"use strict";
var Pulse;
(function (Pulse) {
    var _$ = $, _jQuery = window.jQuery;
    Pulse.jQuery = window.jQuery.noConflict(true);
    $ = _$;
    window.jQuery = _jQuery;
    _$ = _jQuery = undefined;
})(Pulse || (Pulse = {}));
(function (Pulse) {
    var Utils;
    (function (Utils) {
        var JS = (function () {
            function JS() {
            }
            JS.addCSSRule = function (selector, rules, inflectionWidth, rulesForInflection) {
                if (document.styleSheets.length == 0)
                    throw "No stylesheets exist in document, cannot add css rule.";
                var sheet = document.styleSheets[0];
                if (!Pulse.jQuery.isFunction(sheet.insertRule))
                    throw "Browser doesn't support insertRule method, cannot add css rule.";
                var cssRules = sheet.cssRules;
                var index = cssRules.length - 1;
                for (var i = index; i > 0; i--) {
                    var current_style = cssRules[i];
                    if (current_style.selectorText === selector) {
                        sheet.deleteRule(i);
                    }
                }
                if (index < 0)
                    index = 0;
                sheet.insertRule(selector + "{" + rules + "}", index++);
                if (inflectionWidth != null && isNaN(inflectionWidth) == false) {
                    var s = "@media only screen and (max-width :" + inflectionWidth + "px) {" + selector + "{" + rulesForInflection + "}}";
                    sheet.insertRule(s, index++);
                }
            };
            JS.deleteCSSRule = function (selector) {
                if (document.styleSheets.length == 0)
                    throw "No stylesheets exist in document, cannot delete css rule.";
                var sheet = document.styleSheets[0];
                if (!Pulse.jQuery.isFunction(sheet.deleteRule))
                    throw "Browser doesn't support deleteRule method, cannot delete css rule.";
                var cssRules = sheet.cssRules;
                var index = cssRules.length - 1;
                for (var i = index; i > 0; i--) {
                    var current_style = cssRules[i];
                    if (current_style.selectorText === selector) {
                        sheet.deleteRule(i);
                    }
                }
            };
            ;
            JS.isUndefinedOrNull = function (value) {
                return angular.isUndefined(value) || value === null;
            };
            JS.isNullOrWhitespace = function (input) {
                if (typeof input === 'undefined' || input === null)
                    return true;
                return input.replace(/\s/g, '').length < 1;
            };
            JS.isValidDate = function (value) {
                var dateWrapper = new Date(value);
                return !isNaN(dateWrapper.getDate());
            };
            JS.dateTimeStrToDateObj = function (dt) {
                if (typeof dt == "string") {
                    return moment(dt, "YYYY-MM-DDTHH:mm:ss.SSS").toDate();
                }
                return dt;
            };
            JS.DTZeroHourPreviousDayAdjustForDisplay = function (dateValue, miliseconds, undo) {
                if (miliseconds === void 0) { miliseconds = 1; }
                if (undo === void 0) { undo = false; }
                if (!moment.isDate(dateValue))
                    return dateValue;
                if (undo) {
                    return new Date(dateValue.valueOf() + miliseconds);
                }
                return new Date(dateValue.valueOf() - miliseconds);
            };
            JS.toCamelCase = function (str) {
                if (String.isNullOrWhitespace(str))
                    return str;
                return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
                    if (+match === 0)
                        return "";
                    return index == 0 ? match.toLowerCase() : match.toUpperCase();
                });
            };
            JS.toPascalCase = function (str) {
                if (String.isNullOrWhitespace(str))
                    return str;
                return str.replace(/(\w)(\w*)/g, function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
                ;
            };
            JS.combineUrls = function (leftPart, rightPart) {
                var slash = "/";
                leftPart = String.trimRight(leftPart, slash);
                rightPart = String.trimLeft(rightPart, slash);
                var leftPartChunks = leftPart.split(slash);
                var rightPartChunks = rightPart.split(slash);
                if (leftPartChunks[leftPartChunks.length - 1].toLowerCase() == rightPartChunks[0].toLowerCase()) {
                    rightPart = rightPart.substring(rightPart.indexOf(slash) + 1);
                }
                var combinedPath = leftPart + slash + rightPart;
                return combinedPath;
            };
            JS.copyOwnProperties = function (toObj, fromObj, onlyIfUndefinedNullOrEmpty) {
                if (onlyIfUndefinedNullOrEmpty === void 0) { onlyIfUndefinedNullOrEmpty = false; }
                for (var key in fromObj) {
                    if (toObj.hasOwnProperty(key)) {
                        var value = toObj[key];
                        if (onlyIfUndefinedNullOrEmpty && value != null && typeof (value) !== "undefined" && value !== '') {
                            continue;
                        }
                        toObj[key] = fromObj[key];
                    }
                }
            };
            JS.mergeOnUndefined = function (target, source) {
                for (var key in target)
                    if (target.hasOwnProperty(key) && target[key] === undefined && source[key] !== undefined)
                        target[key] = source[key];
            };
            JS.copyAllProperties = function (toObj, fromObj) {
                for (var key in fromObj) {
                    toObj[key] = fromObj[key];
                }
            };
            JS.findObjectsWithPropsMatchFromArray = function (array, filterObject) {
                var filterObjectKeys = Object.keys(filterObject);
                function comparesTwoDateObjects(firstDate, secondDate) {
                    return firstDate.getTime() == secondDate.getTime();
                }
                return array.filter(function (arrayEl) {
                    return filterObjectKeys.every(function (filterObjectKey) {
                        if (arrayEl[filterObjectKey] instanceof Date) {
                            return comparesTwoDateObjects(arrayEl[filterObjectKey], filterObject[filterObjectKey]);
                        }
                        else {
                            return (arrayEl[filterObjectKey] === filterObject[filterObjectKey]);
                        }
                    });
                });
            };
            JS.findByProperties = function (arrObj, filter, caseInsensitive) {
                if (caseInsensitive === void 0) { caseInsensitive = false; }
                var funcStr = "function (a) { return ";
                for (var key in filter) {
                    if (filter[key] != null && typeof filter[key] == "string") {
                        if (caseInsensitive) {
                            funcStr += " (a." + key + " === null ? false : a." + key + ".toUpperCase() == '" + filter[key].toUpperCase() + "') &&";
                        }
                        else {
                            funcStr += " a." + key + " == '" + filter[key] + "' &&";
                        }
                    }
                    else if (filter[key] instanceof Date) {
                        funcStr += " a." + key + ".getTime() == " + filter[key].getTime() + " &&";
                    }
                    else {
                        funcStr += " a." + key + " == " + filter[key] + " &&";
                    }
                }
                funcStr = funcStr.substring(0, funcStr.length - 3);
                funcStr += ";}";
                var result = eval("jQuery.grep(arrObj," + funcStr + ")");
                return result;
            };
            JS.findByPropertiesNotEqual = function (arrObj, filter) {
                var funcStr = "function (a) { return ";
                for (var key in filter) {
                    funcStr += "a." + key + " != " + filter[key] + " ||";
                }
                funcStr = funcStr.substring(0, funcStr.length - 3);
                funcStr += ";}";
                var result = eval("jQuery.grep(arrObj," + funcStr + ")");
                return result;
            };
            JS.htmlEncode = function (text) {
                return Pulse.jQuery('<div />').text(text).html();
            };
            JS.htmlDecode = function (text) {
                return Pulse.jQuery('<div />').html(text).text();
            };
            JS.numberWithCommas = function (n) {
                return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            };
            JS.ordinalSuffixOf = function (i) {
                var j = i % 10, k = i % 100;
                if (j == 1 && k != 11) {
                    return "st";
                }
                if (j == 2 && k != 12) {
                    return "nd";
                }
                if (j == 3 && k != 13) {
                    return "rd";
                }
                return "th";
            };
            JS.compareForSort = function (thing1, thing2, reverseOrProperties) {
                if (thing1 === thing2) {
                    return 0;
                }
                var reverse = false;
                var properties = null;
                var param3Type = Pulse.jQuery.type(reverseOrProperties);
                if (param3Type === 'boolean') {
                    reverse = reverseOrProperties;
                }
                if (param3Type === 'number') {
                    reverse = reverseOrProperties === 0 ? false : true;
                }
                else {
                    properties = reverseOrProperties;
                }
                var result = 0;
                var val1Type = Pulse.jQuery.type(thing1);
                var val2Type = Pulse.jQuery.type(thing2);
                if (val1Type !== val2Type) {
                    throw new Error("Type mismatch for compareForSort function.");
                }
                if (val1Type === "number"
                    || val1Type === "date") {
                    var diff = (thing1 - thing2);
                    if (diff > 0) {
                        result = 1;
                    }
                    else if (diff < 0) {
                        result = -1;
                    }
                    else
                        result = 0;
                }
                else if (val1Type === "string") {
                    result = thing1.localeCompare(thing2);
                }
                else if (val1Type === "object" && properties !== null) {
                    for (var key in properties) {
                        result = Utils.JS.compareForSort(thing1[key], thing2[key], (properties[key]));
                        if (result !== 0) {
                            break;
                        }
                    }
                }
                else {
                    throw new Error(String.format('Type "{0}" not supported for compareForSort function.', val1Type));
                }
                if (reverse) {
                    result = -result;
                }
                return result;
            };
            JS.selectDistinctPropertiesIntoArray = function (arrOfObjs) {
                var propertyNames = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    propertyNames[_i - 1] = arguments[_i];
                }
                if (!arrOfObjs || arrOfObjs.length == 0) {
                    return null;
                }
                var results = new Array();
                for (var i = 0; i < arrOfObjs.length; i++) {
                    if (propertyNames.length == 1) {
                        var value = arrOfObjs[i][propertyNames[0]];
                        if (value && results.indexOf(value) < 0) {
                            results.push(value);
                        }
                    }
                    else {
                        var valueObj = {};
                        for (var j = 0; j < propertyNames.length; j++) {
                            valueObj[propertyNames[j]] = arrOfObjs[i][propertyNames[j]];
                        }
                        var existingMatchs = Utils.JS.findByProperties(results, valueObj);
                        if (!existingMatchs || existingMatchs.length == 0) {
                            results.push(valueObj);
                        }
                    }
                }
                return results;
            };
            JS.parseBool = function (val) { return val === true || val === "true"; };
            JS.zeroPad = function (num, minSize) {
                var s = num + "";
                while (s.length < minSize)
                    s = "0" + s;
                return s;
            };
            JS.removeSpecialCharsFromFileName = function (input) {
                var fileName = null;
                if (typeof (input) !== "undefined" && input != null && input.length > 0) {
                    var pattern = /[^a-zA-Z0-9_\.\,\-]+/g;
                    fileName = input.replace(pattern, "_");
                }
                return fileName;
            };
            JS.uInt8ArrayBufferToString = function (buffer) {
                var bufView = new Uint8Array(buffer);
                var length = bufView.length;
                var result = '';
                var addition = Math.pow(2, 16) - 1;
                for (var i = 0; i < length; i += addition) {
                    if (i + addition > length) {
                        addition = length - i;
                    }
                    result += String.fromCharCode.apply(null, bufView.subarray(i, i + addition));
                }
                return result;
            };
            JS.isElementInViewPort = function (jQuerySelector) {
                try {
                    var element = $(jQuerySelector);
                    var elementTop = element.offset().top;
                    var elementBottom = elementTop + element.height();
                    var JQwindow = $(window);
                    var viewportTop = JQwindow.scrollTop();
                    var viewportBottom = viewportTop + JQwindow.height();
                    return elementBottom > viewportTop && elementTop < viewportBottom;
                }
                catch (e) {
                    return false;
                }
            };
            JS.isElementPartiallyInViewPort = function (jQuerySelector, checkTopLeftOnly) {
                if (checkTopLeftOnly === void 0) { checkTopLeftOnly = false; }
                try {
                    var element = $(jQuerySelector);
                    var elementTop = element.offset().top;
                    var elementBottom = elementTop + element.height();
                    var JQwindow = $(window);
                    var viewportTop = JQwindow.scrollTop();
                    var viewportBottom = viewportTop + JQwindow.height();
                    if (checkTopLeftOnly) {
                        return elementTop > viewportTop && elementTop < elementBottom;
                    }
                    return elementBottom > viewportTop || elementTop > viewportBottom;
                }
                catch (e) {
                    return false;
                }
            };
            JS.isElementVisibleInViewPort = function (jQuerySelector) {
                if (!document.elementFromPoint) {
                    return Utils.JS.isElementInViewPort(jQuerySelector);
                }
                try {
                    var element = $(jQuerySelector);
                    var elementTop = element.offset().top;
                    var elementBottom = elementTop + element.height();
                    var elementLeft = element.offset().left;
                    var elementRight = elementLeft + element.width();
                    if (!Utils.JS.isVisiableAtCoordinate(element, elementLeft - $(window).scrollLeft(), elementTop - $(window).scrollTop())) {
                        return false;
                    }
                    if (!Utils.JS.isVisiableAtCoordinate(element, elementRight - $(window).scrollLeft(), elementTop - $(window).scrollTop())) {
                        return false;
                    }
                    if (!Utils.JS.isVisiableAtCoordinate(element, elementLeft - $(window).scrollLeft(), elementBottom - $(window).scrollTop())) {
                        return false;
                    }
                    if (!Utils.JS.isVisiableAtCoordinate(element, elementRight - $(window).scrollLeft(), elementBottom - $(window).scrollTop())) {
                        return false;
                    }
                }
                catch (e) {
                    return false;
                }
                return true;
            };
            JS.isElementPartiallyVisibleInViewPort = function (jQuerySelector, checkTopLeftOnly) {
                if (checkTopLeftOnly === void 0) { checkTopLeftOnly = false; }
                if (!document.elementFromPoint) {
                    return Utils.JS.isElementPartiallyInViewPort(jQuerySelector, checkTopLeftOnly);
                }
                try {
                    var element = $(jQuerySelector);
                    var elementTop = element.offset().top;
                    var elementBottom = elementTop + element.height();
                    var elementLeft = element.offset().left;
                    var elementRight = elementLeft + element.width();
                    if (Utils.JS.isVisiableAtCoordinate(element, elementLeft - $(window).scrollLeft(), elementTop - $(window).scrollTop())) {
                        return true;
                    }
                    if (checkTopLeftOnly) {
                        return false;
                    }
                    if (Utils.JS.isVisiableAtCoordinate(element, elementRight - $(window).scrollLeft(), elementTop - $(window).scrollTop())) {
                        return true;
                    }
                    if (Utils.JS.isVisiableAtCoordinate(element, elementLeft - $(window).scrollLeft(), elementBottom - $(window).scrollTop())) {
                        return true;
                    }
                    if (Utils.JS.isVisiableAtCoordinate(element, elementRight - $(window).scrollLeft(), elementBottom - $(window).scrollTop())) {
                        return true;
                    }
                }
                catch (e) {
                }
                return false;
            };
            JS.isVisiableAtCoordinate = function (element, atX, atY) {
                var elementAtXY = document.elementFromPoint(atX, atY);
                if (!elementAtXY) {
                    return false;
                }
                var targetHTMLElement = element[0];
                if (targetHTMLElement === elementAtXY || element.find(elementAtXY).length || $(elementAtXY).find(targetHTMLElement).length > 0) {
                    return true;
                }
                return false;
            };
            JS.isValidReturnUrl = function (returnUrl) {
                return angular.isString(returnUrl) &&
                    returnUrl !== Routes.SplashPage &&
                    !String.isNullOrWhitespace(String.trimLeft(returnUrl, '/'));
            };
            JS.extractErrorMessage = function (err) {
                var errorMessage = null;
                if (err.data && err.data.modelState && err.data.modelState.showToUser) {
                    errorMessage = err.data.modelState.showToUser;
                }
                else if (err.data && err.data.innerException) {
                    errorMessage = err.data.innerException.exceptionMessage;
                }
                else if (err.data && err.data.exceptionMessage) {
                    errorMessage = err.data.exceptionMessage;
                }
                else if (err.data && err.data.error && err.data.error.message) {
                    errorMessage = err.data.error.message;
                }
                else if (err.data && err.data.message) {
                    errorMessage = err.data.message;
                }
                return errorMessage;
            };
            JS.isNonEmptyArray = function (object) {
                return !angular.isUndefined(object) && angular.isArray(object) && object.length;
            };
            JS.ExtractPositiveNumberArray = function (object) {
                if (JS.isNonEmptyArray(object) && (typeof object[0] == 'number')) {
                    var positiveNumbers = object.filter(function (n) { return n > 0; });
                    return positiveNumbers;
                }
                else {
                    return [];
                }
            };
            JS.areArraysEqual = function (a1, a2, comparisonFn) {
                if (!comparisonFn || typeof (comparisonFn) !== 'function') {
                    comparisonFn = function (e, arr) { return arr.some(function (e2) { return angular.equals(e, e2); }); };
                }
                return a1.length === a2.length && a1.every(function (e1) { return comparisonFn(e1, a2); });
            };
            JS.deleteProperties = function (objectToClean) {
                for (var x in objectToClean)
                    if (objectToClean.hasOwnProperty(x))
                        delete objectToClean[x];
            };
            JS.getMobileOperatingSystem = function () {
                var userAgent = navigator.userAgent || navigator.vendor;
                if (/windows phone/i.test(userAgent)) {
                    return "Windows Phone";
                }
                if (/android/i.test(userAgent)) {
                    return "Android";
                }
                if (/iPad|iPhone|iPod/.test(userAgent)) {
                    return "iOS";
                }
                return "unknown";
            };
            JS.composeProductThumbNailFullUrl = function (courseVideoThumbnailUrl, imgUrl, largeImage) {
                if (largeImage === void 0) { largeImage = false; }
                var prodThumbImgUrl;
                if (!String.isNullOrWhitespace(imgUrl)) {
                    prodThumbImgUrl = imgUrl.replace('.', largeImage ? '_l.' : '_s.');
                }
                return courseVideoThumbnailUrl + "/" + prodThumbImgUrl;
            };
            JS.isSameDomainHost = function (url1, url2, portCheck) {
                if (portCheck === void 0) { portCheck = false; }
                var val1 = new URL(url1);
                var val2 = new URL(url2);
                if (portCheck) {
                    return val1.host == val2.host;
                }
                return val1.hostname == val2.hostname;
            };
            JS.truncateLastOccuranceOf = function (inputStr, lastOccuranceStr, trimSpaces, isCaseSensitive) {
                if (trimSpaces === void 0) { trimSpaces = true; }
                if (isCaseSensitive === void 0) { isCaseSensitive = true; }
                var idx = isCaseSensitive ? inputStr.lastIndexOf(lastOccuranceStr) : inputStr.toLowerCase().lastIndexOf(lastOccuranceStr.toLowerCase());
                if (idx < 0)
                    return inputStr;
                if (trimSpaces) {
                    return inputStr.substring(0, idx).trim();
                }
                return inputStr.substring(0, idx);
            };
            JS.getDigits = function (textContainingDigits) {
                return textContainingDigits.replace(JS._digitsOnly, "");
            };
            JS.toHashSHA256 = function (input) {
                var hashedValue = CryptoJS.SHA256(input);
                return hashedValue.toString();
            };
            JS.toHashSHA256Base64 = function (input) {
                var hashedValue = CryptoJS.SHA256(input);
                return CryptoJS.enc.Base64.stringify(hashedValue);
            };
            JS.inArray = function (item, array) {
                return (-1 !== array.indexOf(item));
            };
            JS.isArrayEmpty = function (array) {
                return (!angular.isArray(array) || (array.length == 0));
            };
            JS._digitsOnly = new RegExp("[^\d]");
            return JS;
        }());
        Utils.JS = JS;
    })(Utils = Pulse.Utils || (Pulse.Utils = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Collections;
    (function (Collections) {
        var Dictionary = (function () {
            function Dictionary() {
                this._keys = [];
                this._values = [];
                this.undefinedKeyErrorMessage = "Key is either undefined, null or an empty string.";
            }
            Dictionary.prototype.isEitherUndefinedNullOrStringEmpty = function (object) {
                return (typeof object) === "undefined" || object === null || object.toString() === "";
            };
            Dictionary.prototype.checkKeyAndPerformAction = function (action, key, value) {
                if (this.isEitherUndefinedNullOrStringEmpty(key)) {
                    throw new Error(this.undefinedKeyErrorMessage);
                }
                return action(key, value);
            };
            Dictionary.prototype.add = function (key, value) {
                var _this = this;
                var addAction = function (key, value) {
                    if (_this.containsKey(key)) {
                        throw new Error("An element with the same key already exists in the dictionary.");
                    }
                    _this._keys.push(key);
                    _this._values.push(value);
                };
                this.checkKeyAndPerformAction(addAction, key, value);
            };
            Dictionary.prototype.remove = function (key) {
                var _this = this;
                var removeAction = function (key) {
                    if (!_this.containsKey(key)) {
                        return false;
                    }
                    var index = _this._keys.indexOf(key);
                    _this._keys.splice(index, 1);
                    _this._values.splice(index, 1);
                    return true;
                };
                return (this.checkKeyAndPerformAction(removeAction, key));
            };
            Dictionary.prototype.getValue = function (key) {
                var _this = this;
                var getValueAction = function (key) {
                    if (!_this.containsKey(key)) {
                        return null;
                    }
                    var index = _this._keys.indexOf(key);
                    return _this._values[index];
                };
                return this.checkKeyAndPerformAction(getValueAction, key);
            };
            Dictionary.prototype.containsKey = function (key) {
                var _this = this;
                var containsKeyAction = function (key) {
                    if (_this._keys.indexOf(key) === -1) {
                        return false;
                    }
                    return true;
                };
                return this.checkKeyAndPerformAction(containsKeyAction, key);
            };
            Dictionary.prototype.changeValueForKey = function (key, newValue) {
                var _this = this;
                var changeValueForKeyAction = function (key, newValue) {
                    if (!_this.containsKey(key)) {
                        throw new Error("In the dictionary there is no element with the given key.");
                    }
                    var index = _this._keys.indexOf(key);
                    _this._values[index] = newValue;
                };
                this.checkKeyAndPerformAction(changeValueForKeyAction, key, newValue);
            };
            Dictionary.prototype.keys = function () {
                return this._keys;
            };
            Dictionary.prototype.values = function () {
                return this._values;
            };
            Dictionary.prototype.count = function () {
                return this._values.length;
            };
            return Dictionary;
        }());
        Collections.Dictionary = Dictionary;
    })(Collections = Pulse.Collections || (Pulse.Collections = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Utils;
    (function (Utils) {
        var EventUtils = (function () {
            function EventUtils() {
            }
            EventUtils.AddEventListener = function (el, evt, func) {
                if ('addEventListener' in window) {
                    el.addEventListener(evt, func, false);
                }
                else if ('attachEvent' in window) {
                    el.attachEvent('on' + evt, func);
                }
            };
            EventUtils.RemoveEventListener = function (el, evt, func) {
                if ('removeEventListener' in el) {
                    el.removeEventListener(evt, func, false);
                }
                else if ('detachEvent' in el) {
                    el.detachEvent('on' + evt, func);
                }
            };
            return EventUtils;
        }());
        Utils.EventUtils = EventUtils;
        var CrossWinMessenger = (function () {
            function CrossWinMessenger(config) {
                var _this = this;
                this.receiveMessage = function (msgObj) {
                    if (!_this.isAllowedOrigin(msgObj.origin)) {
                        return;
                    }
                    for (var key in _this._targets) {
                        var target = _this._targets[key];
                        if (target.window == msgObj.source && target.msgChannelId == msgObj.data.msgChannelId) {
                            if (target.evtListener) {
                                target.evtListener(msgObj.data.msg);
                            }
                            else {
                                _this._msgQ[key] || (_this._msgQ[key] = new Array());
                                if (_this._msgQ[key].length >= _this._config.maxQueueLength) {
                                    throw new Error("Cross domain window message queue length exceeded maximum(" + _this._config.maxQueueLength + ") allowed.");
                                }
                                _this._msgQ[key].push(msgObj.data.msg);
                            }
                            break;
                        }
                    }
                };
                this._config = config;
                this._config.maxQueueLength || (this._config.maxQueueLength = 1000);
                this._targets = new Array();
                this._msgQ = new Array();
            }
            CrossWinMessenger.prototype.addTarget = function (targetName, targetWindow, targetOrigin, msgChannelId, func) {
                this._targets[targetName] = new CrossWinMessenger.Target(targetWindow, targetOrigin, msgChannelId, func);
                EventUtils.RemoveEventListener(this._config.myWindow, CrossWinMessenger.MSG_EVENT_TYPE, this.receiveMessage);
                EventUtils.AddEventListener(this._config.myWindow, CrossWinMessenger.MSG_EVENT_TYPE, this.receiveMessage);
            };
            CrossWinMessenger.prototype.hasTarget = function (targetName) {
                var target = this.getTarget(targetName);
                if (target)
                    return true;
                return false;
            };
            CrossWinMessenger.prototype.getTarget = function (targetName) {
                var target = this._targets[targetName];
                return target;
            };
            CrossWinMessenger.prototype.removeTarget = function (targetName) {
                var target = this.getTarget(targetName);
                if (target) {
                    this._targets.splice(this._targets.indexOf(target), 1);
                    EventUtils.RemoveEventListener(this._config.myWindow, CrossWinMessenger.MSG_EVENT_TYPE, target.evtListener ? target.evtListener : this.receiveMessage);
                }
            };
            CrossWinMessenger.prototype.removeAllTargets = function () {
                for (var key in this._targets) {
                    var target = this._targets[key];
                    EventUtils.RemoveEventListener(this._config.myWindow, CrossWinMessenger.MSG_EVENT_TYPE, target.evtListener ? target.evtListener : this.receiveMessage);
                    delete this._targets[key];
                }
                this._targets.length = 0;
            };
            CrossWinMessenger.prototype.broadCastMsg = function (msg) {
                for (var key in this._targets) {
                    var target = this._targets[key];
                    this.sendMsgTo(target.window, msg, target.targetOrigin);
                }
            };
            CrossWinMessenger.prototype.sendMsg = function (targetName, msg) {
                var target = this.getTarget(targetName);
                var msgObj = {
                    msgChannelId: target.msgChannelId,
                    msg: msg
                };
                this.sendMsgTo(target.window, msgObj, target.targetOrigin);
            };
            CrossWinMessenger.prototype.sendMsgTo = function (targetWindow, msgObj, targetOrigin) {
                targetWindow.postMessage(msgObj, targetOrigin);
            };
            CrossWinMessenger.prototype.dequeueMessage = function (targetName) {
                if (this._msgQ[targetName]) {
                    return this._msgQ[targetName].shift();
                }
                return null;
            };
            CrossWinMessenger.prototype.isAllowedOrigin = function (origin) {
                var allowed = false;
                for (var key in this._config.allowedOrigins) {
                    var domain = this._config.allowedOrigins[key];
                    if (domain === "*") {
                        allowed = true;
                        break;
                    }
                    else if (domain === origin) {
                        allowed = true;
                        break;
                    }
                }
                return allowed;
            };
            CrossWinMessenger.MSG_EVENT_TYPE = "message";
            return CrossWinMessenger;
        }());
        Utils.CrossWinMessenger = CrossWinMessenger;
        (function (CrossWinMessenger) {
            var Target = (function () {
                function Target(window, targetOrigin, msgChannelId, evtListener) {
                    this.window = window;
                    this.targetOrigin = targetOrigin;
                    this.msgChannelId = msgChannelId;
                    this.evtListener = evtListener;
                }
                return Target;
            }());
            CrossWinMessenger.Target = Target;
        })(CrossWinMessenger = Utils.CrossWinMessenger || (Utils.CrossWinMessenger = {}));
    })(Utils = Pulse.Utils || (Pulse.Utils = {}));
})(Pulse || (Pulse = {}));

"use strict";
angular.uppercase = angular.uppercase || function (text) {
    try {
        return text.toUpperCase();
    }
    catch (e) {
        return text;
    }
};
angular.lowercase = angular.lowercase || function (text) {
    try {
        return text.toLowerCase();
    }
    catch (e) {
        return text;
    }
};
String.format = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var s = args[0];
    for (var i = 0; i < args.length - 1; i++) {
        var reg = new RegExp("\\{" + i + "\\}", "gm");
        s = s.replace(reg, args[i + 1]);
    }
    return s;
};
String.contains = function (target, pattern, ignoreCase) {
    if (ignoreCase === void 0) { ignoreCase = false; }
    var regex;
    if (ignoreCase) {
        regex = new RegExp(pattern, 'i');
    }
    else {
        regex = new RegExp(pattern);
    }
    if (target.search(regex) >= 0) {
        return true;
    }
    return false;
};
String.endsWith = function (target, suffix, ignoreCase) {
    if (ignoreCase === void 0) { ignoreCase = false; }
    if (ignoreCase) {
        var stringLower = target.toLowerCase();
        var suffixLower = suffix.toLowerCase();
        return stringLower.substr(stringLower.length - suffixLower.length) === suffixLower;
    }
    return (target.substr(target.length - suffix.length) === suffix);
};
String.startsWith = function (target, prefix, ignoreCase) {
    if (ignoreCase === void 0) { ignoreCase = false; }
    if (ignoreCase) {
        var stringLower = target.toLowerCase();
        var prefixLower = prefix.toLowerCase();
        return stringLower.substr(0, prefixLower.length) === prefixLower;
    }
    return (target.substr(0, prefix.length) === prefix);
};
String.trimLeft = function (target, charlist) {
    if (charlist === undefined || charlist === null) {
        charlist = " ";
    }
    return target.replace(new RegExp("^[" + charlist + "]+"), "");
};
String.trimRight = function (target, charlist) {
    if (charlist === undefined || charlist === null) {
        charlist = " ";
    }
    return target.replace(new RegExp("[" + charlist + "]+$"), "");
};
String.trim = function (target, charlist) {
    if (charlist === undefined || charlist === null) {
        charlist = " ";
    }
    target = target.replace(new RegExp("^[" + charlist + "]+"), "");
    return target.replace(new RegExp("[" + charlist + "]+$"), "");
};
String.isNullOrWhitespace = function (target) {
    return target == null || target.length == 0 || target.trim().length == 0;
};
Object.defineProperty(Date.prototype, 'toJSON', {
    value: function () {
        return moment(this).format("YYYY-MM-DDTHH:mm:ss.SSS");
    },
    configurable: true,
    writable: true
});
Object.defineProperty(Date.prototype, 'toTZNeutralString', {
    value: function () {
        return moment(this).format("YYYY-MM-DDTHH:mm:ss.SSS");
    },
    configurable: true,
    writable: true
});
if (!('toJSON' in Error.prototype)) {
    Object.defineProperty(Error.prototype, 'toJSON', {
        value: function () {
            var alt = {};
            Object.getOwnPropertyNames(this).forEach(function (key) {
                alt[key] = this[key];
            }, this);
            return alt;
        },
        configurable: true,
        writable: true
    });
}

"use strict";
var Pulse;
(function (Pulse) {
    var Utils;
    (function (Utils) {
        var QueryStringUtils = (function () {
            function QueryStringUtils() {
            }
            QueryStringUtils.GetQueryString = function (url) {
                var startPos = url.indexOf('?');
                return startPos >= 0 ? url.substring(startPos + 1) : '';
            };
            QueryStringUtils.GetParams = function (urlOrQString) {
                var queryStr = QueryStringUtils.GetQueryString(urlOrQString);
                if (!queryStr) {
                    queryStr = '';
                }
                return Pulse.jQuery.deparam(queryStr);
            };
            QueryStringUtils.GetParamByName = function (urlOrQString, paramName) {
                var params = QueryStringUtils.GetParams(urlOrQString);
                if (params) {
                    return params[paramName];
                }
                return null;
            };
            QueryStringUtils.AddOrSetQSParams = function (url, params) {
                var currentParams = QueryStringUtils.GetParams(url);
                var allParams = Pulse.jQuery.extend({}, currentParams, params);
                for (var key in allParams) {
                    if (allParams[key] == undefined || allParams[key] == null || allParams[key] == "") {
                        delete allParams[key];
                    }
                }
                var queryString = Pulse.jQuery.param(allParams, false);
                var absUrlPath = '';
                var endPos = url.indexOf('?');
                if (endPos >= 0) {
                    absUrlPath = url.substring(0, endPos);
                }
                else {
                    absUrlPath = url;
                }
                return absUrlPath + '?' + queryString;
            };
            QueryStringUtils.ContainsQS_HashCode = function (url) {
                var qs_code = QueryStringUtils.GetParamByName(url, QueryStringUtils.QS_HASH_CODE);
                if (angular.isString(qs_code) && qs_code.length > 0) {
                    return true;
                }
                return false;
            };
            QueryStringUtils.RemoveAutoLoginQSfromURL = function (url) {
                var params = {};
                params[QueryStringUtils.GUID] = null;
                return QueryStringUtils.AddOrSetQSParams(url, params);
            };
            QueryStringUtils.ADD_MODE = 'add';
            QueryStringUtils.ADDRESS_LABEL_TYPE_ID = 'addrlbltypeid';
            QueryStringUtils.AGE_GROUP_ID = 'agid';
            QueryStringUtils.AGE_FILTER_SET_ID = 'ageid';
            QueryStringUtils.ATTACHED_CLIENT_LOG_ID = 'attclid';
            QueryStringUtils.ACCOUNT_NUMBER = 'acctnum';
            QueryStringUtils.ACCOUNTING_TRANSACTION_ID = 'AcctgTransID';
            QueryStringUtils.ANSWER_DEFINITION_ID = 'adid';
            QueryStringUtils.AVAYA_COUNTRY_CODE = 'country';
            QueryStringUtils.AVAYA_PHONE_AREA_CODE = 'area';
            QueryStringUtils.AVAYA_PHONE_PREFIX = 'prefix';
            QueryStringUtils.AVAYA_PHONE_NUMBER = 'num';
            QueryStringUtils.AVAYA_EMAIL = 'email';
            QueryStringUtils.AVAYA_ACCOUNT_NUMBER = 'actnum';
            QueryStringUtils.AV_CHART_SECTION_ID = 'avcsid';
            QueryStringUtils.CAMP_AT_HQ = 'campathq';
            QueryStringUtils.CATALOG_BATCH_INCLUDE_USA = 'usa';
            QueryStringUtils.CATALOG_BATCH_INCLUDE_CANADA = 'can';
            QueryStringUtils.CATALOG_BATCH_INCLUDE_INTERNATIONAL = 'intl';
            QueryStringUtils.CELL_PHONE = 'cell';
            QueryStringUtils.CHANGE_ORDER_TYPE = 'cot';
            QueryStringUtils.CHILD_TYPE_CLASS_ID = 'ChildTypeClassID';
            QueryStringUtils.CLIENT_LOG_ACTION_ITEM_ID = 'clactid';
            QueryStringUtils.CLIENT_LOG_ID = 'clid';
            QueryStringUtils.COMPANY_ID = 'cid';
            QueryStringUtils.COMPARISON_OPERATOR_ENUM = 'compenum';
            QueryStringUtils.CORRESPONDENCE_ID = 'correspid';
            QueryStringUtils.COUPON_ID = 'coupid';
            QueryStringUtils.CT = 'CT';
            QueryStringUtils.DATE = 'dt';
            QueryStringUtils.DISCOUNT_ID = 'DiscountID';
            QueryStringUtils.DISCOUNT_DETAIL_ID = 'DiscountDetailID';
            QueryStringUtils.DISCOUNT_BANNER_ID = 'DiscountBannerID';
            QueryStringUtils.DIVISION_ID = 'did';
            QueryStringUtils.DIVISION_JOB_DETAIL_ID = 'DivisionJobDetailID';
            QueryStringUtils.DIVISION_JOB_ID = 'DivisionJobID';
            QueryStringUtils.DOMAIN = 'domain';
            QueryStringUtils.EMAIL_ADDRESS = 'ea';
            QueryStringUtils.EMAIL = 'email';
            QueryStringUtils.END_DATE = 'ed';
            QueryStringUtils.EQUIPMENT_REPORT_ID = 'erid';
            QueryStringUtils.EXPANDER = 'expnd';
            QueryStringUtils.EXPERIENCE_ID = 'exid';
            QueryStringUtils.EFFECTIVE_DATE = 'effdt';
            QueryStringUtils.ERROR_ID = 'errorId';
            QueryStringUtils.ERROR_MESSAGE = 'errormsg';
            QueryStringUtils.FACILITY_ID = 'facid';
            QueryStringUtils.FIRST_NAME = 'fn';
            QueryStringUtils.FILE_ID = 'fid';
            QueryStringUtils.FILE_NAME = 'file';
            QueryStringUtils.FILE_NAME_UPLOADED = 'UploadedFileName';
            QueryStringUtils.FLAG = 'flag';
            QueryStringUtils.FORMSECTION_TYPE_ID = 'FormSectionTypeID';
            QueryStringUtils.FROM_PUBLIC = 'FromPublic';
            QueryStringUtils.GENRE_ID = 'gnrid';
            QueryStringUtils.GUID = 'guid';
            QueryStringUtils.GUID_USER_CHECK = 'guidchk';
            QueryStringUtils.HR_LOG_ID = 'HRLogID';
            QueryStringUtils.INFOREQUEST_ID = 'inforeqid';
            QueryStringUtils.JOB_GENRE_TYPE_ID = 'JobGenTypeID';
            QueryStringUtils.JOB_ID = 'JobID';
            QueryStringUtils.JOB_INTERVIEW_ID = 'JobIntID';
            QueryStringUtils.JOB_OFFER_ID = 'JobOffID';
            QueryStringUtils.LAST_NAME = 'ln';
            QueryStringUtils.LEVEL_ID = 'LevelID';
            QueryStringUtils.LICENSE_ASSIGNMENT_DATE = 'licenseAssignDate';
            QueryStringUtils.LICENSE_ASSIGNMENT_STATUS_TYPE = 'licenseAssignStatusType';
            QueryStringUtils.LICENSE_ITEM_DEF_ID = 'licenseItemDefID';
            QueryStringUtils.LOCATION_ADDRESS_ID = 'LocationAddressID';
            QueryStringUtils.LOCATION_ATTR_CAMP_AT_HQ = 'campathq';
            QueryStringUtils.LOCATION_ID = 'lid';
            QueryStringUtils.LOCATION_PRODUCT_ID = 'LocationProductID';
            QueryStringUtils.LOCATION_SESSION_ID = 'LocationSessionID';
            QueryStringUtils.LOCATION_PAYSTATUS_ID = 'LocationPayStatusID';
            QueryStringUtils.MEASUREGROUP_ID = 'MeasureGroupID';
            QueryStringUtils.MEASUREDEF_ID = 'MeasureDefID';
            QueryStringUtils.CATALOG_DATE_RANGE_ID = 'cdrid';
            QueryStringUtils.MEDIC_APP_MODE = 'mam';
            QueryStringUtils.MEDIC_APP_MEDS_ONLY = 'mamo';
            QueryStringUtils.MEDIC_APP_SMS_CODE = 'masc';
            QueryStringUtils.MIN_DATE = 'mindate';
            QueryStringUtils.MAX_DATE = 'maxdate';
            QueryStringUtils.MOBILE = 'mobile';
            QueryStringUtils.MODE = 'Mode';
            QueryStringUtils.ONLINE_LOCATIONS_ONLY = 'olo';
            QueryStringUtils.OPEN_ID_CONNECT = 'openidconnect';
            QueryStringUtils.OPEN_ID_CONNECT_CLIENT_ID = 'client_id';
            QueryStringUtils.OPEN_ID_CONNECT_CODE = 'code';
            QueryStringUtils.OPEN_ID_CONNECT_STATE = 'state';
            QueryStringUtils.OPL_CLIENT_UI_TAB_IDX = 'oplTabIdx';
            QueryStringUtils.ORDER_ID = 'oid';
            QueryStringUtils.ORDER_DETAIL_ID = 'odid';
            QueryStringUtils.PARENT_ORDER_DETAIL_ID = 'podid';
            QueryStringUtils.ORDER_COMMENT_ID = 'ocid';
            QueryStringUtils.PANEL_ID = 'pnlid';
            QueryStringUtils.PARTICIPANT_ID = 'participantid';
            QueryStringUtils.PARENT_GUARDIAN_ID = 'pgid';
            QueryStringUtils.PARENT_TYPE_CLASS_ID = 'ParentTypeClassID';
            QueryStringUtils.PARENT_TYPE_ID = 'ParentTypeID';
            QueryStringUtils.PAY_WEEK_ID = 'pwid';
            QueryStringUtils.PAYROLL_NUMBER = 'prln';
            QueryStringUtils.PAYMENT_ID = 'payid';
            QueryStringUtils.PRESELECT_ONLINE_LOCATION = 'ol';
            QueryStringUtils.PRODUCT_ID = 'prodid';
            QueryStringUtils.ADDON_PRODUCT_ID = 'addonprodid';
            QueryStringUtils.PRODUCT_DETAIL_ID = 'ProductDetailID';
            QueryStringUtils.PRODUCT_RATIO_ID = 'ProductRatioID';
            QueryStringUtils.PRODUCT_IMPORTANT_DATE_ID = 'ProdImpDateID';
            QueryStringUtils.REGION_ID = 'RegionID';
            QueryStringUtils.REGION_LOCATION_ID = 'RegionLocationID';
            QueryStringUtils.REGION_ROLE_ID = 'RegionRoleID';
            QueryStringUtils.ROLE_CATEGORY = 'RoleCategory';
            QueryStringUtils.ROLE_ID = 'RoleID';
            QueryStringUtils.REFRESH_CUSTOMER_USER = 'RefreshCustUser';
            QueryStringUtils.REG_FLOW_NO_AUTO_DISPATCH = 'rgnad';
            QueryStringUtils.REGIONAL_MANAGER_USER_ID = 'rmuid';
            QueryStringUtils.REPORT_ON_STUDENT_OR_PARENTS_ENUM = 'rosop';
            QueryStringUtils.RESET_CODE = 'ResetCode';
            QueryStringUtils.RETURN_URL = 'ReturnUrl';
            QueryStringUtils.RETURNING_FROM_CLOSE = 'rfc';
            QueryStringUtils.SCHEDULE_TYPE = 'ST';
            QueryStringUtils.SEARCH_DATE = 'SearchDate';
            QueryStringUtils.SECTION_ID = 'SectionID';
            QueryStringUtils.SECTION_NUMBER = 'SectionNbr';
            QueryStringUtils.SESSION_COMBO_ID = 'SessionComboID';
            QueryStringUtils.SESSION_WEEK_ID = 'swkid';
            QueryStringUtils.SHOW = 'show';
            QueryStringUtils.SPA_ROUTE = 'spaRoute';
            QueryStringUtils.STAFF_QA_CRITERION_ID = 'StaffQACriterionID';
            QueryStringUtils.STAFF_TASK_ID = 'stskid';
            QueryStringUtils.START_DATE = 'sd';
            QueryStringUtils.STATEMENT_BATCH_INCLUDE_USA = 'usa';
            QueryStringUtils.STATEMENT_BATCH_INCLUDE_CANADA = 'can';
            QueryStringUtils.STATEMENT_BATCH_INCLUDE_INTERNATIONAL = 'intl';
            QueryStringUtils.SUPPLY_REQUEST_ID = 'supreqid';
            QueryStringUtils.SUPPLY_REQUEST_ITEM_ID = 'sritemid';
            QueryStringUtils.SESSION_ID = 'sid';
            QueryStringUtils.SESSION_PRODUCT_DETAIL_ID = 'spdid';
            QueryStringUtils.SITEPATH_RESET = 'sr';
            QueryStringUtils.SUBSCRIPTION = 'subscription';
            QueryStringUtils.RESCHEDULING = 'rescheduling';
            QueryStringUtils.INSTRUCTOR_USER_ID = 'iuid';
            QueryStringUtils.SHOW_HISTORY = 'showHistory';
            QueryStringUtils.SKILLCAT_ID = 'SkillCategoryID';
            QueryStringUtils.SKILL_ID = 'skid';
            QueryStringUtils.SURVEY_SUBMITTER_TYPE_ENUM = 'sstenum';
            QueryStringUtils.SURVEY_RESPONSE_ID = 'srid';
            QueryStringUtils.MIDTERM_SURVEY_RESPONSE_ID = 'msrid';
            QueryStringUtils.ENDTERM_SURVEY_RESPONSE_ID = 'esrid';
            QueryStringUtils.SMUGMUG_GALLERY_URL = 'smug';
            QueryStringUtils.STUD_ACTIVITY_ID = 'stactid';
            QueryStringUtils.SUBSCRIPTION_TYPE = 'subtyp';
            QueryStringUtils.SURVEY_DEFINITION_ID = 'sdid';
            QueryStringUtils.SURVEY_TYPE_ID = 'stid';
            QueryStringUtils.TARGET_URL = 'TargetUrl';
            QueryStringUtils.TAB = 'tab';
            QueryStringUtils.TAP_ID = 'tapid';
            QueryStringUtils.TEMP_SUBDIRECTORY_NAME = 'tdn';
            QueryStringUtils.TERM_THRESHOLD_ID = 'TermThresholdID';
            QueryStringUtils.TERM_ID = 'tid';
            QueryStringUtils.TERM_GROUP_ID = 'tgid';
            QueryStringUtils.TIME_STAMP = 'ts';
            QueryStringUtils.TYPE_CLASS_ID = 'TypeClassID';
            QueryStringUtils.TYPE_ID = 'TypeID';
            QueryStringUtils.UPLOADED_FORM_TYPE = 'ft';
            QueryStringUtils.URL = 'url';
            QueryStringUtils.USER_ID = 'userid';
            QueryStringUtils.USER_ID_HASH = 'useridhash';
            QueryStringUtils.USER_IMPERSONATE_ID = 'impuid';
            QueryStringUtils.USERFORMDETAIL_ID = 'ufdid';
            QueryStringUtils.USERFORMVERSION_ID = 'ufvid';
            QueryStringUtils.USER_TOKEN = 'usrtkn';
            QueryStringUtils.USERBROWSING_ID = 'ubid';
            QueryStringUtils.USERBROWSING_BROWSE_ID = 'ubbid';
            QueryStringUtils.USERBROWSINGCOMMLOG_ID = 'ubclid';
            QueryStringUtils.USERBROWSINGCOMMLOG_TYPE_ID = 'ubcltid';
            QueryStringUtils.VIP_ONLY = 'viponly';
            QueryStringUtils.WEEK = 'Week';
            QueryStringUtils.WORKFLOW = 'wf';
            QueryStringUtils.ZIP_CODE = 'zc';
            QueryStringUtils.QS_HASH_CODE = 'qshc';
            return QueryStringUtils;
        }());
        Utils.QueryStringUtils = QueryStringUtils;
    })(Utils = Pulse.Utils || (Pulse.Utils = {}));
})(Pulse || (Pulse = {}));
var QueryStringUtils = Pulse.Utils.QueryStringUtils;

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Utils;
    (function (Utils) {
        var TextItemizer = (function () {
            function TextItemizer(text) {
                this.lineBreak = "<br />";
                this.stringBuffer = "";
                this.startTag = "";
                this.endTag = "";
                this.startItemTag = "";
                this.endItemTag = "";
                if (text)
                    this.add(text);
            }
            TextItemizer.prototype.add = function (text) {
                if (this.stringBuffer.length == 0) {
                    this.stringBuffer += this.startTag;
                }
                this.stringBuffer += this.startItemTag + text + this.endItemTag;
            };
            TextItemizer.prototype.toString = function () {
                return this.stringBuffer + this.endTag;
            };
            TextItemizer.prototype.length = function () {
                return this.stringBuffer.length;
            };
            TextItemizer.prototype.clearAll = function () {
                this.stringBuffer = null;
            };
            return TextItemizer;
        }());
        Utils.TextItemizer = TextItemizer;
        var HtmlListItemizer = (function (_super) {
            __extends(HtmlListItemizer, _super);
            function HtmlListItemizer(text, orderedList) {
                if (orderedList === void 0) { orderedList = false; }
                var _this = _super.call(this, text) || this;
                if (orderedList) {
                    _this.startTag = "<ol>";
                    _this.endTag = "</ol>";
                }
                else {
                    _this.startTag = "<ul>";
                    _this.endTag = "</ul>";
                }
                _this.startItemTag = "<li>";
                _this.endItemTag = "</li>";
                return _this;
            }
            return HtmlListItemizer;
        }(TextItemizer));
        Utils.HtmlListItemizer = HtmlListItemizer;
    })(Utils = Pulse.Utils || (Pulse.Utils = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Utils;
    (function (Utils) {
        var Cookies = (function () {
            function Cookies() {
            }
            Object.defineProperty(Cookies, "cookiePrefix", {
                get: function () { return "pulse"; },
                enumerable: false,
                configurable: true
            });
            ;
            Object.defineProperty(Cookies, "cookieExpirationDays", {
                get: function () { return 45; },
                enumerable: false,
                configurable: true
            });
            ;
            Cookies.getCookie = function (cname, usePrefix) {
                if (usePrefix === void 0) { usePrefix = true; }
                var name;
                if (usePrefix) {
                    name = Cookies.prefixCookieName(cname) + "=";
                }
                else {
                    name = cname;
                }
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    var parts = c.split('=');
                    if (parts[0].trim() === name) {
                        return decodeURIComponent(parts[1]);
                    }
                }
                return "";
            };
            Cookies.prefixCookieName = function (cname) {
                return Cookies.cookiePrefix + "." + cname;
            };
            Cookies.setCookie = function (cname, cvalue, usePrefix) {
                if (usePrefix === void 0) { usePrefix = true; }
                var name = usePrefix ? Cookies.prefixCookieName(cname) : cname;
                var d = new Date();
                d.setTime(d.getTime() + (Cookies.cookieExpirationDays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = name + "=" + cvalue + "; " + expires;
            };
            Cookies.eraseCookie = function (cname, usePrefix) {
                if (usePrefix === void 0) { usePrefix = true; }
                var name;
                if (usePrefix) {
                    name = Cookies.prefixCookieName(cname) + "=";
                }
                else {
                    name = cname;
                }
                document.cookie = (name + "=;expires=Fri, 02-Jan-1970 00:00:00 GMT");
            };
            Cookies.FILE_DOWNLOAD_COOKIE_NAME_SUFFIX = "fileDownloadToken";
            return Cookies;
        }());
        Utils.Cookies = Cookies;
    })(Utils = Pulse.Utils || (Pulse.Utils = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Utils;
    (function (Utils) {
        var BrowserCap = (function () {
            function BrowserCap() {
            }
            BrowserCap.checkLocalStorageSupport = function () {
                var mod = 'modernizr';
                var hasLocalStorageSupport = true;
                try {
                    window.localStorage.setItem(mod, mod);
                    window.localStorage.removeItem(mod);
                }
                catch (e) {
                    hasLocalStorageSupport = false;
                }
                return hasLocalStorageSupport;
            };
            BrowserCap.checkSessionStorageSupport = function () {
                var mod = 'modernizr';
                var hasLocalStorageSupport = true;
                try {
                    window.sessionStorage.setItem(mod, mod);
                    window.sessionStorage.removeItem(mod);
                }
                catch (e) {
                    hasLocalStorageSupport = false;
                }
                return hasLocalStorageSupport;
            };
            return BrowserCap;
        }());
        Utils.BrowserCap = BrowserCap;
    })(Utils = Pulse.Utils || (Pulse.Utils = {}));
})(Pulse || (Pulse = {}));

"use strict";
var saveBlobAs;
saveBlobAs = saveBlobAs || (function (view) {
    if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
        return;
    }
    var doc = view.document, get_URL = function () {
        return view.URL || view.webkitURL || view;
    }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function (node) {
        var event = new MouseEvent("click");
        node.dispatchEvent(event);
    }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function (ex) {
        (view.setImmediate || view.setTimeout)(function () {
            throw ex;
        }, 0);
    }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 1000 * 40, revoke = function (file) {
        var revoker = function () {
            if (typeof file === "string") {
                get_URL().revokeObjectURL(file);
            }
            else {
                file.remove();
            }
        };
        setTimeout(revoker, arbitrary_revoke_timeout);
    }, dispatch = function (filesaver, event_types, event) {
        event_types = [].concat(event_types);
        var i = event_types.length;
        while (i--) {
            var listener = filesaver["on" + event_types[i]];
            if (typeof listener === "function") {
                try {
                    listener.call(filesaver, event || filesaver);
                }
                catch (ex) {
                    throw_outside(ex);
                }
            }
        }
    }, auto_bom = function (blob) {
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
            return new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type });
        }
        return blob;
    }, FileSaver = function (blob, name, no_auto_bom) {
        if (!no_auto_bom) {
            blob = auto_bom(blob);
        }
        var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function () {
            dispatch(filesaver, "writestart progress write writeend".split(" "));
        }, fs_error = function () {
            if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
                var reader = new FileReader();
                reader.onloadend = function () {
                    var url = is_chrome_ios ? reader.result.toString() : reader.result.toString().replace(/^data:[^;]*;/, 'data:attachment/file;');
                    var popup = view.open(url, '_blank');
                    if (!popup)
                        view.location.href = url;
                    url = undefined;
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                };
                reader.readAsDataURL(blob);
                filesaver.readyState = filesaver.INIT;
                return;
            }
            if (!object_url) {
                object_url = get_URL().createObjectURL(blob);
            }
            if (force) {
                view.location.href = object_url;
            }
            else {
                var opened = view.open(object_url, "_blank");
                if (!opened) {
                    view.location.href = object_url;
                }
            }
            filesaver.readyState = filesaver.DONE;
            dispatch_all();
            revoke(object_url);
        };
        filesaver.readyState = filesaver.INIT;
        if (can_use_save_link) {
            object_url = get_URL().createObjectURL(blob);
            setTimeout(function () {
                save_link.href = object_url;
                save_link.download = name;
                click(save_link);
                dispatch_all();
                revoke(object_url);
                filesaver.readyState = filesaver.DONE;
            });
            return;
        }
        fs_error();
    }, FS_proto = FileSaver.prototype, saveAs = function (blob, name, no_auto_bom) {
        return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
    };
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
        return function (blob, name, no_auto_bom) {
            name = name || blob.name || "download";
            if (!no_auto_bom) {
                blob = auto_bom(blob);
            }
            return navigator.msSaveOrOpenBlob(blob, name);
        };
    }
    FS_proto.abort = function () { };
    FS_proto.readyState = FS_proto.INIT = 0;
    FS_proto.WRITING = 1;
    FS_proto.DONE = 2;
    FS_proto.error =
        FS_proto.onwritestart =
            FS_proto.onprogress =
                FS_proto.onwrite =
                    FS_proto.onabort =
                        FS_proto.onerror =
                            FS_proto.onwriteend =
                                null;
    return saveAs;
}(typeof self !== "undefined" && self
    || typeof window !== "undefined" && window
    || this.content));
var module = module || undefined;
var define = define || undefined;
if (module && module.exports) {
    module.exports.saveAs = saveBlobAs;
}
else if (define && define.amd !== null) {
    define("FileSaver.js", function () {
        return saveBlobAs;
    });
}

"use strict";
var Pulse;
(function (Pulse) {
    var Utils;
    (function (Utils) {
        var WEBIntegration = (function () {
            function WEBIntegration() {
            }
            Object.defineProperty(WEBIntegration, "headerHeightApproximation", {
                get: function () {
                    return 80;
                },
                enumerable: false,
                configurable: true
            });
            return WEBIntegration;
        }());
        Utils.WEBIntegration = WEBIntegration;
        function scrollToElement(element, topOffset, animationDuration) {
            if (topOffset === void 0) { topOffset = 0; }
            if (animationDuration === void 0) { animationDuration = 500; }
            var $element = angular.element(element);
            if ($element.length) {
                topOffset += WEBIntegration.headerHeightApproximation;
                angular.element('html, body')
                    .animate({ scrollTop: $element.offset().top - topOffset }, animationDuration);
            }
        }
        Utils.scrollToElement = scrollToElement;
    })(Utils = Pulse.Utils || (Pulse.Utils = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Utils;
    (function (Utils) {
        var GoogleAuthUtil = (function () {
            function GoogleAuthUtil() {
            }
            GoogleAuthUtil.GetAuthInstance = function (googleAPI_ClientID) {
                var promise;
                promise = new Promise(function (resolve, reject) {
                    try {
                        if (_.isUndefined(window.gapi)) {
                            setTimeout(function () {
                                GoogleAuthUtil.GetAuthInstance(googleAPI_ClientID)
                                    .then(function (result) {
                                    resolve(result);
                                })
                                    .catch(function (err) {
                                    reject(err);
                                });
                            }, 500);
                            return;
                        }
                        var googleAuthInst_1;
                        if (!gapi.auth2) {
                            gapi.load('auth2', function () {
                                googleAuthInst_1 = gapi.auth2.init({
                                    client_id: googleAPI_ClientID,
                                }).then(function (googleAuthInst) {
                                    resolve(googleAuthInst);
                                });
                            });
                        }
                        else {
                            googleAuthInst_1 = gapi.auth2.getAuthInstance();
                            resolve(googleAuthInst_1);
                        }
                    }
                    catch (e) {
                        reject(e);
                    }
                });
                return promise;
            };
            GoogleAuthUtil.RenderGoogleSigninButton = function (elementID, onsuccess, onfailure) {
                try {
                    gapi.signin2.render(elementID, {
                        'width': 'auto',
                        'height': 48,
                        'longtitle': true,
                        'theme': 'light',
                        'onsuccess': onsuccess,
                        'onfailure': onfailure,
                    });
                }
                catch (e) { }
            };
            return GoogleAuthUtil;
        }());
        Utils.GoogleAuthUtil = GoogleAuthUtil;
    })(Utils = Pulse.Utils || (Pulse.Utils = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Pulse;
(function (Pulse) {
    var Utils;
    (function (Utils) {
        var _analyticsTrack = _analyticsTrack || null;
        var ClickTracking = (function () {
            function ClickTracking() {
            }
            ClickTracking.setTrackingCookie = function (value) {
                var hash = CryptoJS.SHA256(value).toString(CryptoJS.enc.Base64);
                Pulse.Utils.Cookies.setCookie(ClickTracking.TRACKING_COOKIE_NAME, hash, false);
            };
            ClickTracking.getTrackingCookie = function () {
                return Pulse.Utils.Cookies.getCookie(ClickTracking.TRACKING_COOKIE_NAME, false);
            };
            ClickTracking.hookupElementsInContainer = function (container) {
                if (container === void 0) { container = null; }
                return;
                container = container || document.body;
                ClickTracking.hookupButtonsInContainer(container);
                ClickTracking.hookupLinksInContainer(container);
            };
            ClickTracking.hookupButtonsInContainer = function (container) {
                Pulse.jQuery("button", container).on('click', function (e) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    console.log(e.target.textContent.trim() + ": Button Clicked!!!!");
                    ClickTracking.sendElementTrackingData(e.target);
                });
            };
            ClickTracking.hookupLinksInContainer = function (container) {
                Pulse.jQuery("a", container).on('click', function (e) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    console.log(this.textContent.trim() + ": Link Clicked!!!!");
                    ClickTracking.sendElementTrackingData(e.target);
                });
            };
            ClickTracking.sendElementTrackingData = function (el, additionalData) {
                if (additionalData === void 0) { additionalData = {}; }
                var data = __assign({}, additionalData);
                if (el) {
                    data[ClickTracking.ATTR_ACTION_TEXT] = String.trim(el.textContent.replace(/\n/g, ""));
                    data = __assign(__assign({ element: el }, ClickTracking.gatherAllAttributes(el)), data);
                }
                var fromUrl = data[ClickTracking.ATTR_FROM_URL];
                delete data[ClickTracking.ATTR_FROM_URL];
                data[ClickTracking.ATTR_TO_URL] = el.baseURI;
                ClickTracking.analyticsTrack(fromUrl, el.baseURI, data);
            };
            ClickTracking.gatherAllAttributes = function (el) {
                var attributes = el.attributes;
                var result = {};
                for (var i = 0; i < attributes.length; i++) {
                    var attr = attributes.item(i);
                    if (attr.name.match(/^data-id-/i)) {
                        result[attr.name] = attr.value;
                    }
                }
                return result;
            };
            ClickTracking.analyticsTrack = function (fromUrl, toUrl, data) {
                var pageURL = fromUrl;
                var route = fromUrl.split("#")[1] || "";
                if (window._analyticsTrack) {
                    window._analyticsTrack(pageURL, route, data);
                }
                else if (window.isDebugTracking) {
                    console.log({
                        'pageURL': pageURL,
                        'route': route,
                        'data': data
                    });
                }
            };
            ClickTracking.TRACKING_COOKIE_NAME = "iD-trackinghash";
            ClickTracking.ATTR_FROM_URL = "data-id-from-url";
            ClickTracking.ATTR_TO_URL = "data-id-to-url";
            ClickTracking.ATTR_ACTION_TEXT = "data-id-action-text";
            return ClickTracking;
        }());
        Utils.ClickTracking = ClickTracking;
    })(Utils = Pulse.Utils || (Pulse.Utils = {}));
})(Pulse || (Pulse = {}));

"use strict";

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var ServiceTemplates;
        (function (ServiceTemplates) {
            var Decorator = (function () {
                function Decorator() {
                }
                return Decorator;
            }());
            ServiceTemplates.Decorator = Decorator;
        })(ServiceTemplates = Common.ServiceTemplates || (Common.ServiceTemplates = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var ServiceTemplates;
        (function (ServiceTemplates) {
            var Counter = (function () {
                function Counter() {
                    this._counter = 0;
                }
                Counter.prototype.decrement = function (value) {
                    if (value === void 0) { value = 1; }
                    return this._counter -= Math.abs(value);
                };
                Object.defineProperty(Counter.prototype, "counter", {
                    get: function () {
                        return this._counter;
                    },
                    enumerable: false,
                    configurable: true
                });
                Counter.prototype.increment = function (value) {
                    if (value === void 0) { value = 1; }
                    return this._counter += Math.abs(value);
                };
                Counter.prototype.reset = function () {
                    this._counter = 0;
                };
                return Counter;
            }());
            ServiceTemplates.Counter = Counter;
        })(ServiceTemplates = Common.ServiceTemplates || (Common.ServiceTemplates = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var Hacks;
        (function (Hacks) {
            Hacks.hacks = angular.module('hacks', []);
        })(Hacks = Modules.Hacks || (Modules.Hacks = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var Hacks;
        (function (Hacks) {
            var Services;
            (function (Services) {
                var UserAgent = (function () {
                    function UserAgent() {
                        var userAgent = getProducts();
                        this._os = userAgent ? userAgent.os : null;
                        this._browser = userAgent.browser ? userAgent.browser : null;
                        this._device = userAgent.device ? userAgent.device : null;
                        this._engine = userAgent.engine ? userAgent.engine : null;
                        this._ua = userAgent.browser ? userAgent.ua : null;
                        function getProducts() {
                            var clientUserAgent = window.navigator.userAgent;
                            var parser = new window.UAParser();
                            return parser.getResult(clientUserAgent);
                        }
                    }
                    Object.defineProperty(UserAgent.prototype, "os", {
                        get: function () {
                            return this._os;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(UserAgent.prototype, "browser", {
                        get: function () {
                            return this._browser;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(UserAgent.prototype, "device", {
                        get: function () {
                            return this._device;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(UserAgent.prototype, "engine", {
                        get: function () {
                            return this._engine;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(UserAgent.prototype, "ua", {
                        get: function () {
                            return this._ua;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    UserAgent.prototype.isIOS = function () {
                        return this._os.name.toLowerCase() === 'ios' &&
                            this._device.vendor.toLowerCase() === 'apple';
                    };
                    UserAgent.prototype.isSafari = function () {
                        return this._browser.name.toLowerCase()
                            .indexOf('safari') >= 0;
                    };
                    UserAgent.registeredAs = 'UserAgent';
                    return UserAgent;
                }());
                Services.UserAgent = UserAgent;
                Hacks.hacks.service(UserAgent.registeredAs, UserAgent);
            })(Services = Hacks.Services || (Hacks.Services = {}));
        })(Hacks = Modules.Hacks || (Modules.Hacks = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var Hacks;
        (function (Hacks) {
            var Services;
            (function (Services) {
                var Counter = Pulse.Common.ServiceTemplates.Counter;
                var ScrollLockProvider = (function () {
                    function ScrollLockProvider(userAgent) {
                        this.userAgent = userAgent;
                    }
                    ScrollLockProvider.prototype.$get = function () {
                        return this.areConditionsFulfilled
                            ? new ScrollLockService()
                            : new DummyScrollLockService();
                    };
                    Object.defineProperty(ScrollLockProvider.prototype, "areConditionsFulfilled", {
                        get: function () {
                            if (this._conditionsFulfilled === undefined)
                                this._conditionsFulfilled = this.userAgent && this.userAgent.isIOS();
                            return this._conditionsFulfilled;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ScrollLockProvider.prototype.getMajorVersion = function (version) {
                        var versionList = version.split('.');
                        return parseInt(versionList[0], 10);
                    };
                    ScrollLockProvider.prototype.getMinorVersion = function (version) {
                        var versionList = version.split('.');
                        return versionList[1] ? parseInt(versionList[1], 10) : 0;
                    };
                    return ScrollLockProvider;
                }());
                Services.ScrollLockProvider = ScrollLockProvider;
                var DummyScrollLockService = (function (_super) {
                    __extends(DummyScrollLockService, _super);
                    function DummyScrollLockService() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    return DummyScrollLockService;
                }(Counter));
                var ScrollLockService = (function (_super) {
                    __extends(ScrollLockService, _super);
                    function ScrollLockService() {
                        var _this = _super.call(this) || this;
                        _this.fakePositionClass = 'ios-fake-position';
                        _this.wwwSiteHeaderId = 'site-header';
                        _this.docElements = angular.element('html, body');
                        _this.mainContainers = angular.element('body')
                            .children(':not(script, noscript, style)');
                        return _this;
                    }
                    ScrollLockService.prototype.increment = function () {
                        if (this.counter === 0) {
                            this.lockDocumentScroll();
                        }
                        return _super.prototype.increment.call(this, 1);
                    };
                    ScrollLockService.prototype.decrement = function () {
                        if (this.counter === 1) {
                            this.unlockDocumentScroll();
                        }
                        return _super.prototype.decrement.call(this, 1);
                    };
                    ScrollLockService.prototype.reset = function () {
                        if (this.counter > 0)
                            this.unlockDocumentScroll();
                        _super.prototype.reset.call(this);
                    };
                    ScrollLockService.prototype.lockDocumentScroll = function () {
                        if (window.pageYOffset) {
                            this.yOffset = window.pageYOffset;
                            this.createFakePositions();
                        }
                        this.docElements.css({
                            height: '100%',
                            overflow: 'hidden',
                        });
                    };
                    ScrollLockService.prototype.createFakePositions = function () {
                        var _this = this;
                        this.mainContainers
                            .filter(function (i, e) {
                            return ['fixed', 'absolute'].indexOf(angular.element(e)
                                .css('position')) === -1
                                || e.id === _this.wwwSiteHeaderId;
                        })
                            .each(function (i, e) {
                            var jqSelection = angular.element(e);
                            jqSelection.css({ top: -_this.yOffset, position: 'relative' });
                            jqSelection.addClass(_this.fakePositionClass);
                        });
                    };
                    ScrollLockService.prototype.unlockDocumentScroll = function () {
                        this.docElements.css({ height: '', overflow: '' });
                        this.releaseFakePositions();
                        window.scrollTo(0, this.yOffset);
                        this.yOffset = 0;
                    };
                    ScrollLockService.prototype.releaseFakePositions = function () {
                        var _this = this;
                        this.mainContainers.each(function (i, e) {
                            var jqSelection = angular.element(e);
                            if (jqSelection.hasClass(_this.fakePositionClass)) {
                                jqSelection.css({ top: '', position: '' });
                                jqSelection.removeClass(_this.fakePositionClass);
                            }
                        });
                    };
                    ScrollLockService.registeredAs = 'ScrollLockService';
                    return ScrollLockService;
                }(Counter));
                Hacks.hacks.factory(ScrollLockService.registeredAs, [
                    Services.UserAgent.registeredAs,
                    function (ua) { return (new ScrollLockProvider(ua)).$get(); },
                ]);
            })(Services = Hacks.Services || (Hacks.Services = {}));
        })(Hacks = Modules.Hacks || (Modules.Hacks = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var ContainerBoundSticky;
        (function (ContainerBoundSticky) {
            ContainerBoundSticky.containerBoundSticky = angular.module('containerBoundSticky', []);
        })(ContainerBoundSticky = Modules.ContainerBoundSticky || (Modules.ContainerBoundSticky = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var ContainerBoundSticky;
        (function (ContainerBoundSticky) {
            var Definition;
            (function (Definition) {
                var AlignmentEnum;
                (function (AlignmentEnum) {
                    AlignmentEnum[AlignmentEnum["Start"] = 0] = "Start";
                    AlignmentEnum[AlignmentEnum["Center"] = 1] = "Center";
                    AlignmentEnum[AlignmentEnum["End"] = 2] = "End";
                })(AlignmentEnum = Definition.AlignmentEnum || (Definition.AlignmentEnum = {}));
            })(Definition = ContainerBoundSticky.Definition || (ContainerBoundSticky.Definition = {}));
        })(ContainerBoundSticky = Modules.ContainerBoundSticky || (Modules.ContainerBoundSticky = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var ContainerBoundSticky;
        (function (ContainerBoundSticky) {
            var BoxPosition = (function () {
                function BoxPosition(top, right, bottom, left) {
                    if (top === void 0) { top = 0; }
                    if (right === void 0) { right = 0; }
                    if (bottom === void 0) { bottom = 0; }
                    if (left === void 0) { left = 0; }
                    this.top = top;
                    this.right = right;
                    this.bottom = bottom;
                    this.left = left;
                }
                BoxPosition.prototype.add = function (box) {
                    this.top += box.top;
                    this.right += box.right;
                    this.bottom += box.bottom;
                    this.left += box.left;
                    return this;
                };
                BoxPosition.prototype.subtract = function (box) {
                    this.top -= box.top;
                    this.right -= box.right;
                    this.bottom -= box.bottom;
                    this.left -= box.left;
                    return this;
                };
                BoxPosition.prototype.clone = function () {
                    return new BoxPosition(this.top, this.right, this.bottom, this.left);
                };
                BoxPosition.prototype.updateTo = function (boxPosition) {
                    this.top = boxPosition.top;
                    this.right = boxPosition.right;
                    this.bottom = boxPosition.bottom;
                    this.left = boxPosition.left;
                    return this;
                };
                return BoxPosition;
            }());
            ContainerBoundSticky.BoxPosition = BoxPosition;
        })(ContainerBoundSticky = Modules.ContainerBoundSticky || (Modules.ContainerBoundSticky = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var ContainerBoundSticky;
        (function (ContainerBoundSticky) {
            var ClientRectPropEnum;
            (function (ClientRectPropEnum) {
                ClientRectPropEnum["Top"] = "top";
                ClientRectPropEnum["Right"] = "right";
                ClientRectPropEnum["Bottom"] = "bottom";
                ClientRectPropEnum["Left"] = "left";
                ClientRectPropEnum["Height"] = "height";
                ClientRectPropEnum["Width"] = "width";
            })(ClientRectPropEnum = ContainerBoundSticky.ClientRectPropEnum || (ContainerBoundSticky.ClientRectPropEnum = {}));
            var ElemBoundingClientRect = (function () {
                function ElemBoundingClientRect(selector) {
                    this._elemObject = angular.element(selector);
                }
                ElemBoundingClientRect.prototype.refreshBoundingClientRect = function () {
                    this._elemObject = angular.element(this._elemObject);
                    this.clientRect = this._elemObject.length > 0 ? this.element.getBoundingClientRect() : null;
                    return this;
                };
                Object.defineProperty(ElemBoundingClientRect.prototype, "element", {
                    get: function () {
                        return this.$element.get(0);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ElemBoundingClientRect.prototype, "$element", {
                    get: function () {
                        return this._elemObject;
                    },
                    enumerable: false,
                    configurable: true
                });
                ElemBoundingClientRect.prototype.getCRValue = function (property) {
                    var value = 0;
                    if (this.clientRect !== null && angular.isDefined(this.clientRect[property])) {
                        value = this.clientRect[property];
                    }
                    return value;
                };
                Object.defineProperty(ElemBoundingClientRect.prototype, "top", {
                    get: function () {
                        return this.getCRValue(ClientRectPropEnum.Top);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ElemBoundingClientRect.prototype, "right", {
                    get: function () {
                        return this.getCRValue(ClientRectPropEnum.Right);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ElemBoundingClientRect.prototype, "bottom", {
                    get: function () {
                        return this.getCRValue(ClientRectPropEnum.Bottom);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ElemBoundingClientRect.prototype, "left", {
                    get: function () {
                        return this.getCRValue(ClientRectPropEnum.Left);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ElemBoundingClientRect.prototype, "height", {
                    get: function () {
                        return this.getCRValue(ClientRectPropEnum.Bottom) - this.getCRValue(ClientRectPropEnum.Top);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ElemBoundingClientRect.prototype, "width", {
                    get: function () {
                        return this.getCRValue(ClientRectPropEnum.Right) - this.getCRValue(ClientRectPropEnum.Left);
                    },
                    enumerable: false,
                    configurable: true
                });
                return ElemBoundingClientRect;
            }());
            ContainerBoundSticky.ElemBoundingClientRect = ElemBoundingClientRect;
        })(ContainerBoundSticky = Modules.ContainerBoundSticky || (Modules.ContainerBoundSticky = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var ContainerBoundSticky;
        (function (ContainerBoundSticky) {
            var BoxPosition = Pulse.Modules.ContainerBoundSticky.BoxPosition;
            var ElemBoundingClientRect = Pulse.Modules.ContainerBoundSticky.ElemBoundingClientRect;
            var AlignmentEnum = Pulse.Modules.ContainerBoundSticky.Definition.AlignmentEnum;
            var Sticky = (function () {
                function Sticky(selected, mgrBoundingContainer, stickyDef) {
                    this.BCRClonedElement = null;
                    this.optionFlags = {
                        addToAdjustment: false,
                        clone: false
                    };
                    this.position = {
                        horizontal: null,
                        vertical: null
                    };
                    this.styleDefault = {
                        position: 'fixed'
                    };
                    this.inBoundCorrection = new BoxPosition();
                    this.styleCorrection = function () {
                        return {};
                    };
                    this.BCRElement = new ElemBoundingClientRect(selected);
                    this.mgrBoundingContainer = mgrBoundingContainer;
                    if (angular.isDefined(stickyDef.optionFlags))
                        angular.merge(this.optionFlags, stickyDef.optionFlags);
                    if (angular.isDefined(stickyDef.position))
                        angular.merge(this.position, stickyDef.position);
                    if (angular.isDefined(stickyDef.inBoundCorrection))
                        angular.merge(this.inBoundCorrection, stickyDef.inBoundCorrection);
                    if (angular.isDefined(stickyDef.styleCorrection))
                        this.styleCorrection = stickyDef.styleCorrection;
                    if (angular.isDefined(stickyDef.styleDefault))
                        angular.merge(this.styleDefault, stickyDef.styleDefault);
                }
                Sticky.prototype.manageSticky = function (adjustment) {
                    this.refreshClientRect();
                    if (this.exitsBounds(adjustment))
                        if (this.optionFlags.clone) {
                            if (this.BCRClonedElement === null)
                                this.BCRClonedElement = this.cloneSticky(adjustment);
                            else
                                this.refreshStickyProps(adjustment, this.BCRClonedElement);
                        }
                        else {
                            this.BCRElement.$element.show();
                            this.refreshStickyProps(adjustment, this.BCRElement);
                        }
                    else
                        this.hide();
                };
                Sticky.prototype.refreshClientRect = function () {
                    this.BCRElement.refreshBoundingClientRect();
                    if (this.BCRClonedElement)
                        this.BCRClonedElement.refreshBoundingClientRect();
                    return this;
                };
                Sticky.prototype.hide = function () {
                    if (this.optionFlags.clone)
                        this.removeClone();
                    else
                        this.BCRElement.$element.hide();
                };
                Sticky.prototype.exitsBounds = function (adjustment) {
                    var result = true;
                    if (this.position.vertical !== null)
                        result = result && this.existsVerticalBound(adjustment);
                    if (this.position.horizontal !== null)
                        result = result && this.existsHorizontalBound(adjustment);
                    return result;
                };
                Sticky.prototype.existsVerticalBound = function (adjustment) {
                    var result = true;
                    if (this.position.vertical === AlignmentEnum.Start)
                        result = this.existsTopBound(adjustment) && this.canBeDrawnTop(adjustment);
                    else if (this.position.vertical === AlignmentEnum.End)
                        result = this.existsBottomBound(adjustment) && this.canBeDrawnBottom(adjustment);
                    return result;
                };
                Sticky.prototype.existsHorizontalBound = function (adjustment) {
                    var result = true;
                    if (this.position.horizontal === AlignmentEnum.Start)
                        result = this.existsLeftBound(adjustment) && this.canBeDrawnLeft(adjustment);
                    else if (this.position.horizontal === AlignmentEnum.End)
                        result = this.existsRightBound(adjustment) && this.canBeDrawnRight(adjustment);
                    return result;
                };
                Sticky.prototype.existsTopBound = function (adjustment) {
                    return this.BCRElement.top < adjustment.top;
                };
                Sticky.prototype.canBeDrawnTop = function (adjustment) {
                    var elementBottomPosition = adjustment.top + this.BCRElement.height + this.inBoundCorrection.bottom;
                    return this.mgrBoundingContainer.bottom > elementBottomPosition;
                };
                Sticky.prototype.existsBottomBound = function (adjustment) {
                    return this.BCRElement.bottom > window.innerHeight - adjustment.bottom;
                };
                Sticky.prototype.canBeDrawnBottom = function (adjustment) {
                    var elementTopPosition = window.innerHeight - adjustment.bottom
                        - this.BCRElement.height - this.inBoundCorrection.top;
                    return this.mgrBoundingContainer.top < elementTopPosition;
                };
                Sticky.prototype.existsLeftBound = function (adjustment) {
                    return this.BCRElement.left < adjustment.left;
                };
                Sticky.prototype.canBeDrawnLeft = function (adjustment) {
                    return this.mgrBoundingContainer.right > adjustment.left + this.BCRElement.width + this.inBoundCorrection.right;
                };
                Sticky.prototype.existsRightBound = function (adjustment) {
                    return this.BCRElement.right > window.innerWidth - adjustment.right;
                };
                Sticky.prototype.canBeDrawnRight = function (adjustment) {
                    var elementLeftPosition = window.innerWidth - adjustment.top - this.BCRElement.width
                        - this.inBoundCorrection.left;
                    return this.mgrBoundingContainer.left < elementLeftPosition;
                };
                Sticky.prototype.refreshStickyProps = function (adjustment, BCRElement) {
                    var style = angular.merge({}, this.styleDefault);
                    if (this.position.vertical !== null) {
                        angular.merge(style, this.getVerticalStyleProps(adjustment));
                    }
                    if (this.position.horizontal !== null) {
                        angular.merge(style, this.getHorizontalStyleProps(adjustment));
                    }
                    if (this.optionFlags.clone) {
                        style.height = this.BCRElement.height + 'px';
                        style.width = this.BCRElement.width + 'px';
                        style.display = this.BCRElement.$element.css('display');
                    }
                    angular.merge(style, this.styleCorrection(this.BCRElement, this.mgrBoundingContainer, adjustment));
                    BCRElement.$element
                        .removeAttr('style')
                        .css(style);
                    BCRElement.refreshBoundingClientRect();
                    if (this.optionFlags.addToAdjustment)
                        adjustment.add(new BoxPosition(angular.isDefined(style.top) ? BCRElement.height : 0, angular.isDefined(style.right) ? BCRElement.width : 0, angular.isDefined(style.bottom) ? BCRElement.height : 0, angular.isDefined(style.left) ? BCRElement.width : 0));
                };
                Sticky.prototype.getVerticalStyleProps = function (adjustment) {
                    var style = {};
                    if (this.position.vertical === AlignmentEnum.Start)
                        style.top = adjustment.top + 'px';
                    else if (this.position.vertical === AlignmentEnum.End)
                        style.bottom = adjustment.bottom + 'px';
                    else {
                        var maxHeight = Math.min(window.innerHeight - adjustment.top - adjustment.bottom, this.mgrBoundingContainer.height);
                        var top_1 = Math.max(0, (maxHeight - this.BCRElement.height) / 2) + adjustment.top;
                        style['max-height'] = maxHeight + 'px';
                        if (this.mgrBoundingContainer.bottom < ((maxHeight + this.BCRElement.height) / 2 + adjustment.top))
                            style.bottom = window.innerHeight - this.mgrBoundingContainer.bottom + 'px';
                        else
                            style.top = Math.max(top_1, this.mgrBoundingContainer.top) + 'px';
                    }
                    return style;
                };
                Sticky.prototype.getHorizontalStyleProps = function (adjustment) {
                    var style = {};
                    if (this.position.horizontal === AlignmentEnum.Start)
                        style.top = adjustment.left + 'px';
                    else if (this.position.horizontal === AlignmentEnum.End)
                        style.top = adjustment.right + 'px';
                    else {
                        var maxWidth = Math.min(window.innerWidth - adjustment.left - adjustment.right, this.mgrBoundingContainer.width);
                        var left = Math.max(0, (maxWidth - this.BCRElement.height) / 2) + adjustment.left;
                        style['max-width'] = maxWidth + 'px';
                        if (this.mgrBoundingContainer.right < ((maxWidth + this.BCRElement.width) / 2 + adjustment.left))
                            style.right = window.innerWidth - this.mgrBoundingContainer.right + 'px';
                        else
                            style.left = Math.max(left, this.mgrBoundingContainer.left) + 'px';
                    }
                    return style;
                };
                Sticky.prototype.cloneSticky = function (adjustment) {
                    var clone = new ElemBoundingClientRect(this.BCRElement.$element.clone());
                    clone.$element.hide();
                    this.refreshStickyProps(adjustment, clone);
                    this.BCRElement.$element.after(clone.$element);
                    clone.$element.show();
                    return clone;
                };
                Sticky.prototype.removeClone = function () {
                    if (this.BCRClonedElement !== null) {
                        this.BCRClonedElement.$element.remove();
                        this.BCRClonedElement = null;
                    }
                };
                return Sticky;
            }());
            ContainerBoundSticky.Sticky = Sticky;
        })(ContainerBoundSticky = Modules.ContainerBoundSticky || (Modules.ContainerBoundSticky = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var ContainerBoundSticky;
        (function (ContainerBoundSticky) {
            var ElemBoundingClientRect = Pulse.Modules.ContainerBoundSticky.ElemBoundingClientRect;
            var BoxPosition = Pulse.Modules.ContainerBoundSticky.BoxPosition;
            var Sticky = Pulse.Modules.ContainerBoundSticky.Sticky;
            var StickyContainer = (function () {
                function StickyContainer(schema, boundingContainerObject) {
                    var _this = this;
                    if (angular.isUndefined(boundingContainerObject)) {
                        boundingContainerObject = angular.element(schema.boundingContainerSelector);
                    }
                    this.boundingContainer = new ElemBoundingClientRect(boundingContainerObject);
                    this.managedStickies = [];
                    if (angular.isDefined(schema.stickiesDef)) {
                        angular.forEach(schema.stickiesDef, function (stickyDef) {
                            _this.addSticky(stickyDef);
                        });
                    }
                    this.linkedManagers = [];
                    if (angular.isDefined(schema.subManagers)) {
                        angular.forEach(schema.subManagers, function (manager) {
                            _this.addSubManager(manager);
                        });
                    }
                }
                StickyContainer.prototype.setExternalAdjustmentService = function (unmanagedStikies, customUnmanagedStickies) {
                    if (customUnmanagedStickies === void 0) { customUnmanagedStickies = []; }
                    this.unmanagedStickiesService = unmanagedStikies;
                    this.customUnmanagedStickies = customUnmanagedStickies;
                };
                Object.defineProperty(StickyContainer.prototype, "externalBoxPositionAdjustment", {
                    get: function () {
                        return angular.isDefined(this.unmanagedStickiesService) ?
                            this.unmanagedStickiesService.getBoxPositionAdjustment(this.customUnmanagedStickies) :
                            new BoxPosition();
                    },
                    enumerable: false,
                    configurable: true
                });
                StickyContainer.prototype.addSubManager = function (schema) {
                    var _this = this;
                    this.boundingContainer.$element
                        .find(schema.boundingContainerSelector)
                        .each(function (i, element) {
                        _this.linkedManagers.push(new StickyContainer(schema, angular.element(element)));
                    });
                };
                StickyContainer.prototype.addSticky = function (stickyDef) {
                    var _this = this;
                    this.boundingContainer.$element
                        .find(stickyDef.selector)
                        .each(function (i, element) {
                        _this.managedStickies.push(new Sticky(angular.element(element), _this.boundingContainer, stickyDef));
                    });
                };
                StickyContainer.prototype.manageStickies = function (adjustment) {
                    this.boundingContainer.refreshBoundingClientRect();
                    if (angular.isUndefined(adjustment)) {
                        adjustment = this.externalBoxPositionAdjustment;
                    }
                    if (this.isScrollInBounds(adjustment)) {
                        angular.forEach(this.managedStickies, function (sticky) {
                            sticky.manageSticky(adjustment);
                        });
                        angular.forEach(this.linkedManagers, function (manager) {
                            manager.manageStickies(adjustment);
                        });
                    }
                    else {
                        this.hideStickies();
                    }
                };
                StickyContainer.prototype.hideStickies = function () {
                    angular.forEach(this.managedStickies, function (sticky) {
                        sticky.hide();
                    });
                    angular.forEach(this.linkedManagers, function (manager) {
                        manager.hideStickies();
                    });
                };
                StickyContainer.prototype.isScrollInBounds = function (adjustment) {
                    return this.isVerticalInScrollBounds(adjustment)
                        && this.isHorizontalInScrollBounds(adjustment);
                };
                StickyContainer.prototype.isVerticalInScrollBounds = function (adjustment) {
                    return this.boundingContainer.top < window.innerHeight - adjustment.bottom
                        && this.boundingContainer.bottom > adjustment.top;
                };
                StickyContainer.prototype.isHorizontalInScrollBounds = function (adjustment) {
                    return this.boundingContainer.left < window.innerWidth - adjustment.right
                        && this.boundingContainer.right > adjustment.left;
                };
                return StickyContainer;
            }());
            ContainerBoundSticky.StickyContainer = StickyContainer;
        })(ContainerBoundSticky = Modules.ContainerBoundSticky || (Modules.ContainerBoundSticky = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var ContainerBoundSticky;
        (function (ContainerBoundSticky) {
            var StickyToggleMgr = (function () {
                function StickyToggleMgr(stickyContainerMgr) {
                    this._defaultRenderEvents = ['scroll', 'resize'];
                    this._defaultRenderDelay = 0;
                    this._stickyContainerMgr = stickyContainerMgr;
                    this._window = angular.element(window);
                    this.toggleActiveState();
                }
                StickyToggleMgr.prototype.toggleActiveState = function (newState) {
                    this._isActive = newState || !this._isActive;
                };
                StickyToggleMgr.prototype.setPreRenderCallback = function (callback) {
                    this._preRenderCallback = angular.copy(callback);
                };
                StickyToggleMgr.prototype.setPostRenderCallback = function (callback) {
                    this._postRenderCallback = angular.copy(callback);
                };
                StickyToggleMgr.prototype.init = function (renderEvents, renderDelay) {
                    var _this = this;
                    if (renderEvents === void 0) { renderEvents = []; }
                    if (renderDelay === void 0) { renderDelay = this._defaultRenderDelay; }
                    this._renderEvents = this._defaultRenderEvents.concat(renderEvents);
                    this._window.on(this._renderEvents.join(' '), function (event) {
                        _this.render(event, renderDelay);
                    });
                };
                StickyToggleMgr.prototype.onDestroy = function () {
                    this._window.off(this._renderEvents.join(' '), this.render);
                };
                StickyToggleMgr.prototype.triggerOnDemandRender = function (bypassActiveCheck, renderDelay) {
                    if (bypassActiveCheck === void 0) { bypassActiveCheck = false; }
                    if (renderDelay === void 0) { renderDelay = this._defaultRenderDelay; }
                    if (!this._isActive && bypassActiveCheck) {
                        this._isActive = !this._isActive;
                        this.render(null, renderDelay);
                        this._isActive = !this._isActive;
                    }
                    else if (this._isActive) {
                        this.render(null, renderDelay);
                    }
                };
                StickyToggleMgr.prototype.render = function (event, renderDelay) {
                    if (this._isActive) {
                        if (this._preRenderCallback) {
                            this._preRenderCallback(event, this._stickyContainerMgr);
                        }
                        this._stickyContainerMgr.manageStickies();
                        if (this._postRenderCallback) {
                            this._postRenderCallback(event, this._stickyContainerMgr);
                        }
                    }
                };
                return StickyToggleMgr;
            }());
            ContainerBoundSticky.StickyToggleMgr = StickyToggleMgr;
        })(ContainerBoundSticky = Modules.ContainerBoundSticky || (Modules.ContainerBoundSticky = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var ContainerBoundSticky;
        (function (ContainerBoundSticky) {
            var Services;
            (function (Services) {
                var ElemBoundingClientRect = Pulse.Modules.ContainerBoundSticky.ElemBoundingClientRect;
                var BoxPosition = Pulse.Modules.ContainerBoundSticky.BoxPosition;
                var UnmanagedStickiesService = (function () {
                    function UnmanagedStickiesService(unmanagedElemDef) {
                        this.unmanagedElemDef = unmanagedElemDef;
                    }
                    UnmanagedStickiesService.prototype.getBoxPositionAdjustment = function (customUnmanagedElementsBatch) {
                        if (customUnmanagedElementsBatch === void 0) { customUnmanagedElementsBatch = []; }
                        var adjustment = new BoxPosition();
                        var elements = this.getUnmanagedElements(customUnmanagedElementsBatch);
                        angular.forEach(elements, function (sticky) {
                            sticky.refreshBoundingClientRect();
                        });
                        angular.forEach(elements, function (sticky) {
                            adjustment.add(sticky.relevantBoxPosition);
                        });
                        return adjustment;
                    };
                    UnmanagedStickiesService.prototype.getUnmanagedElements = function (customElementsBatch) {
                        var elementsDef = [].concat(this.unmanagedElemDef).concat(customElementsBatch);
                        var elements = [];
                        angular.forEach(elementsDef, function (elDef) {
                            var selected = angular.element(elDef.selector);
                            var takeIntoAccount = angular.isDefined(elDef.takeIntoAccount)
                                ? elDef.takeIntoAccount : function () { return true; };
                            if (takeIntoAccount && selected.length > 0) {
                                elements.push(new UnmanagedStickiesService.UnmanagedElem(selected, elDef.relevantPosition));
                            }
                        });
                        return elements;
                    };
                    UnmanagedStickiesService.registeredAs = 'UnmanagedStickiesService';
                    return UnmanagedStickiesService;
                }());
                Services.UnmanagedStickiesService = UnmanagedStickiesService;
                var UnmanagedStickiesProvider = (function () {
                    function UnmanagedStickiesProvider() {
                    }
                    UnmanagedStickiesProvider.prototype.loadWEBStickiesDefinition = function (existingStickyStack) {
                        this.unmanagedStickies = existingStickyStack;
                    };
                    UnmanagedStickiesProvider.prototype.$get = function () {
                        return new UnmanagedStickiesService(this.unmanagedStickies);
                    };
                    return UnmanagedStickiesProvider;
                }());
                Services.UnmanagedStickiesProvider = UnmanagedStickiesProvider;
                (function (UnmanagedStickiesService) {
                    var UnmanagedElem = (function (_super) {
                        __extends(UnmanagedElem, _super);
                        function UnmanagedElem(element, relevantPositions) {
                            var _this = _super.call(this, element) || this;
                            _this.relevantPositions = relevantPositions;
                            return _this;
                        }
                        Object.defineProperty(UnmanagedElem.prototype, "relevantBoxPosition", {
                            get: function () {
                                var boxPosition;
                                if (this.$element.css('position') !== 'fixed') {
                                    boxPosition = new BoxPosition(0, 0, 0, 0);
                                }
                                else {
                                    boxPosition = new BoxPosition(angular.isDefined(this.relevantPositions.top) ? this.height : 0, angular.isDefined(this.relevantPositions.right) ? this.width : 0, angular.isDefined(this.relevantPositions.bottom) ? this.height : 0, angular.isDefined(this.relevantPositions.left) ? this.width : 0);
                                }
                                return boxPosition;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return UnmanagedElem;
                    }(ElemBoundingClientRect));
                    UnmanagedStickiesService.UnmanagedElem = UnmanagedElem;
                })(UnmanagedStickiesService = Services.UnmanagedStickiesService || (Services.UnmanagedStickiesService = {}));
                ContainerBoundSticky.containerBoundSticky.provider(UnmanagedStickiesService.registeredAs, UnmanagedStickiesProvider);
            })(Services = ContainerBoundSticky.Services || (ContainerBoundSticky.Services = {}));
        })(ContainerBoundSticky = Modules.ContainerBoundSticky || (Modules.ContainerBoundSticky = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Modules;
    (function (Modules) {
        var ContainerBoundSticky;
        (function (ContainerBoundSticky) {
            var Services;
            (function (Services) {
                var StickyMgrFactoryService = (function () {
                    function StickyMgrFactoryService(unmanagedStickiesService) {
                        this.unmanagedStickiesService = unmanagedStickiesService;
                    }
                    StickyMgrFactoryService.prototype.getNewStickyManager = function (managerDef, customUnmanagedStickies) {
                        if (customUnmanagedStickies === void 0) { customUnmanagedStickies = []; }
                        var stickyMgr = new ContainerBoundSticky.StickyContainer(managerDef);
                        stickyMgr.setExternalAdjustmentService(this.unmanagedStickiesService, customUnmanagedStickies);
                        return new ContainerBoundSticky.StickyToggleMgr(stickyMgr);
                    };
                    StickyMgrFactoryService.registeredAs = 'StickyMgrFactoryService';
                    return StickyMgrFactoryService;
                }());
                Services.StickyMgrFactoryService = StickyMgrFactoryService;
                ContainerBoundSticky.containerBoundSticky.service(StickyMgrFactoryService.registeredAs, [
                    Services.UnmanagedStickiesService.registeredAs,
                    StickyMgrFactoryService
                ]);
            })(Services = ContainerBoundSticky.Services || (ContainerBoundSticky.Services = {}));
        })(ContainerBoundSticky = Modules.ContainerBoundSticky || (Modules.ContainerBoundSticky = {}));
    })(Modules = Pulse.Modules || (Pulse.Modules = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    Pulse.app = angular.module('pulseApp', [
        'ngAnimate',
        'ngMessages',
        'ngRoute',
        'ngSanitize',
        'ngAria',
        'breeze.angular',
        'breeze.directives',
        'ui.bootstrap',
        'uiGmapgoogle-maps',
        'dialogs.main',
        'LocalStorageModule',
        'vcRecaptcha',
        'betsol.intlTelInput',
        'ui.grid',
        'ui.grid.edit',
        'ui.grid.rowEdit',
        'ui.grid.selection',
        'ui.grid.pagination',
        'ui.grid.autoResize',
        'ui.grid.resizeColumns',
        'ui.grid.cellNav',
        'ui.grid.pinning',
        'textAngular',
        'templatescache',
        'hacks',
        'rzSlider',
        'containerBoundSticky',
        'ngPapaParse',
    ]);
    Pulse.app.config([
        '$httpProvider',
        '$compileProvider',
        '$logProvider',
        'localStorageServiceProvider',
        'config',
        '$uibModalProvider',
        'uiGmapGoogleMapApiProvider',
        '$locationProvider',
        'intlTelInputOptions',
        '$qProvider',
        function ($httpProvider, $compileProvider, $logProvider, localStorageServiceProvider, config, $uibModalProvider, uiGmapGoogleMapApiProvider, $locationProvider, intlTelInputOptions, $qProvider) {
            $qProvider.errorOnUnhandledRejections(false);
            $httpProvider.interceptors.push(Pulse.Services.AuthInterceptorSvc.serviceId);
            $locationProvider.hashPrefix('');
            $compileProvider.debugInfoEnabled(config.isDebugMode);
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|sms|tel):/);
            if ($logProvider.debugEnabled)
                $logProvider.debugEnabled(config.isDebugMode);
            localStorageServiceProvider
                .setPrefix(Pulse.Utils.Cookies.cookiePrefix)
                .setStorageType('sessionStorage')
                .setStorageCookieDomain('')
                .setStorageCookie(Pulse.Utils.Cookies.cookieExpirationDays, '/');
            $uibModalProvider.options = {
                windowClass: StringConst.CSS_pulseapp,
                windowTopClass: StringConst.CSS_www_pulseapp,
            };
            uiGmapGoogleMapApiProvider.configure({
                key: config.googleBrowserApiKey,
            });
            angular.extend(intlTelInputOptions, {
                initialCountry: 'us',
                nationalMode: false,
                autoFormat: false,
                separateDialCode: true,
                geoIpLookup: function (callback) {
                    $.get('https://freegeoip.net/json/', function () { }, 'jsonp')
                        .always(function (resp) {
                        var countryCode = (resp && resp.country_code) ? resp.country_code : '';
                        callback(countryCode);
                    });
                },
                preferredCountries: ['us', 'ca', 'gb', 'hk', 'sg', 'kr', 'ch']
            });
        },
    ]);
    Pulse.app.config([
        'UnmanagedStickiesServiceProvider',
        function (UnmangedStickiesProvider) {
            UnmangedStickiesProvider.loadWEBStickiesDefinition([
                {
                    relevantPosition: {
                        top: true,
                    },
                    selector: '#site-header',
                },
                {
                    relevantPosition: {
                        top: true,
                    },
                    selector: '#promo-banner',
                },
            ]);
        },
    ]);
    Pulse.app.run([
        '$route', '$location', 'localStorageService', 'common', 'pulseContextService',
        function ($route, $location, localStorageService, common, pulseContextService) {
            common.$rootScope.$on('$routeChangeStart', function (event, next, current) {
                var token = $location.search()[QueryStringUtils.GUID];
                var userId = parseInt($location.search()[QueryStringUtils.USER_ID]);
                if (!String.isNullOrWhitespace(token) && userId > 0) {
                    event.preventDefault();
                    var requestedRoute_1 = QueryStringUtils.RemoveAutoLoginQSfromURL($location.url());
                    pulseContextService.autoAuthenticate(userId, token, requestedRoute_1)
                        .finally(function () {
                        var authData = pulseContextService.authData;
                        if (authData == null || authData.token == null) {
                            common.logTraceToDatabase(userId, null, 'app.ts', 'app.run', Enums.PulseErrorLogSeverityLevel.Errors, Enums.PulseErrorLogSubject.Authentication, 'Invalid UserID/Token - Redirecting to Login page');
                            $location.url(Routes.Login + "?" + QueryStringUtils.RETURN_URL + "=" + encodeURIComponent($location.url()));
                        }
                        else {
                            common.logTraceToDatabase(userId, null, 'app.ts', 'app.run', Enums.PulseErrorLogSeverityLevel.Verbose, Enums.PulseErrorLogSubject.Authentication, ("Querystring UserID and Token are valid. Redirecting to " + requestedRoute_1));
                            $location.url(requestedRoute_1);
                        }
                    });
                    return;
                }
                if (next.name === "unknown") {
                    return;
                }
                var redirectURL = QueryStringUtils.GetParamByName($location.absUrl(), 'redirect');
                if (angular.isString(redirectURL) && $location.path().indexOf(Routes.Redirect) < 0) {
                    document.location.replace(document.location.origin + document.location.pathname + "#" + Routes.Redirect + "/?redirect=" + encodeURIComponent(redirectURL));
                    return;
                }
                if (next && next.$$route && next.$$route.templateUrl) {
                    if (String.contains(next.$$route.templateUrl, "secure", true)) {
                        if (pulseContextService.loggedInUserId <= 0) {
                            common.logTraceToDatabase(pulseContextService.loggedInUserId, null, 'app.ts', 'app.run', Enums.PulseErrorLogSeverityLevel.Errors, Enums.PulseErrorLogSubject.Authentication, ("Token is missing from URL.  pulseContextService.loggedInUserId <= 0. - Redirecting to Login"));
                            event.preventDefault();
                            $location.url(Routes.Login + "?" + QueryStringUtils.RETURN_URL + "=" + encodeURIComponent($location.url()));
                        }
                        else {
                            common.logTraceToDatabase(pulseContextService.loggedInUserId, pulseContextService.actingAsUserId, 'app.ts', $location.url(), Enums.PulseErrorLogSeverityLevel.Trace, Enums.PulseErrorLogSubject.Routing, ("DEAD END: loggedInUserId = " + pulseContextService.loggedInUserId + " and token = '" + token + "' for route = " + $location.url()));
                        }
                    }
                    else {
                        common.logTraceToDatabase(pulseContextService.loggedInUserId, pulseContextService.actingAsUserId, 'app.ts', $location.url(), Enums.PulseErrorLogSeverityLevel.Trace, Enums.PulseErrorLogSubject.Routing, ("Insecure routing loggedInUserId = " + pulseContextService.loggedInUserId + " to " + $location.url()));
                    }
                }
            });
            document.title = common.$rootScope.title = 'My Account';
            common.$rootScope.$on('$routeChangeSuccess', function (event, current, previous) {
                if (angular.isUndefined(current.$$route))
                    return;
                document.title = common.$rootScope.title = (angular.isUndefined(current.$$route.name) ? '' : current.$$route.name);
            });
        },
    ]);
    Pulse.app.run([
        '$anchorScroll', 'config',
        function ($anchorScroll, config) {
            $anchorScroll.yOffset = 100;
        },
    ]);
    Pulse.app.run([
        '$templateCache',
        function ($templateCache) {
            var tpc = $templateCache.get('/dialogs/confirm.html');
            tpc = tpc.replace('btn-default', 'btn-temp');
            tpc = tpc.replace('btn-primary', 'btn-default');
            tpc = tpc.replace('btn-temp', 'btn-primary');
            $templateCache.put('/dialogs/confirm.html', tpc);
        },
    ]);
})(Pulse || (Pulse = {}));
var dataLayer = window.dataLayer;
if (!dataLayer) {
    $(document)
        .ready(function () {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(), event: 'gtm.js',
            });
            var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-F2KF');
    });
}
if (!window.gapi) {
    $(document)
        .ready(function () {
        (function (document) {
            var firstScriptElement = document.getElementsByTagName('script')[0];
            var newScript = document.createElement('script');
            newScript.src = 'https://apis.google.com/js/platform.js';
            firstScriptElement.parentNode.insertBefore(newScript, firstScriptElement);
        })(document);
    });
}
var Offline = Offline || {};
$(document)
    .ready(function () {
    Offline.options = {
        checkOnLoad: true,
        interceptRequests: true,
        reconnect: {
            initialDelay: 3,
        },
        requests: false,
    };
    var checkOfflineStatus = function () {
        Offline.check();
    };
    setInterval(checkOfflineStatus, 10000);
});
angular.merge = function (object) {
    var otherArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherArgs[_i - 1] = arguments[_i];
    }
    return _.merge.apply(_, [object].concat(otherArgs));
};

"use strict";
var Pulse;
(function (Pulse) {
    Pulse.app.filter('unsafe', ['$sce', function ($sce) {
            return $sce.trustAsHtml;
        }]);
    Pulse.app.filter('trusted', ['$sce', function ($sce) {
            return $sce.trustAsResourceUrl;
        }]);
    Pulse.app.filter('lessThanEqualTo', function () {
        return function (items, propertyName, value) {
            if (angular.isDefined(items)) {
                items = items.filter(function (item) {
                    return item[propertyName] <= value;
                });
            }
            return items;
        };
    });
    Pulse.app.filter('courseProductId', function () {
        return function (items, courseProducts) {
            var filtered = [];
            if (angular.isDefined(courseProducts) && courseProducts.length > 0) {
                var courseProductIDs = courseProducts.map(function (a) {
                    return a.productID;
                });
                angular.forEach(items, function (item) {
                    if (item.courseProductID && courseProductIDs.indexOf(item.courseProductID) !== -1) {
                        filtered.push(item);
                    }
                });
            }
            else {
                filtered.push.apply(filtered, items);
            }
            return filtered;
        };
    });
    Pulse.app.filter('formatSessionDates', function () {
        return function (start, end, noBreakSameMonth, noBreakDiffMonth) {
            if (!moment(start).isValid() && !moment(end).isValid())
                return '';
            var startDate = moment(start);
            var endDate = moment(end);
            var differentMonths = startDate.month() != endDate.month();
            var differentYears = startDate.year() != endDate.year();
            var formattedDate;
            if (differentYears) {
                var firstDate = startDate.format('MMM D, YYYY');
                var secondDate = endDate.format('MMM D, YYYY');
                formattedDate = (noBreakDiffMonth) ? firstDate + "-" + secondDate : firstDate + "-<br>" + secondDate;
            }
            else if (differentMonths) {
                var firstDate = startDate.format('MMM D');
                var secondDate = endDate.format('MMM D');
                formattedDate = (noBreakDiffMonth) ? firstDate + "-" + secondDate : firstDate + "-<br>" + secondDate;
            }
            else {
                var monthFormatted = startDate.format('MMM');
                var firstDate = startDate.format('D');
                var secondDate = endDate.format('D');
                formattedDate = (noBreakSameMonth) ? monthFormatted + " " + firstDate + "-" + secondDate : monthFormatted + "<br>" + firstDate + "-" + secondDate;
            }
            return formattedDate;
        };
    });
    Pulse.app.filter('formatSessionFullMonth', function () {
        return function (start, end, noBreakSameMonth, noBreakDiffMonth) {
            if (!moment(start).isValid() && !moment(end).isValid())
                return '';
            var startDate = moment(start);
            var endDate = moment(end);
            var differentMonths = startDate.month() != endDate.month();
            var differentYears = startDate.year() != endDate.year();
            var formattedDate;
            if (differentYears) {
                var firstDate = startDate.format('MMMM D, YYYY');
                var secondDate = endDate.format('MMMM D, YYYY');
                formattedDate = (noBreakDiffMonth) ? firstDate + "-" + secondDate : firstDate + "-<br>" + secondDate;
            }
            else if (differentMonths) {
                var firstDate = startDate.format('MMMM D');
                var secondDate = endDate.format('MMMM D');
                formattedDate = (noBreakDiffMonth) ? firstDate + "-" + secondDate : firstDate + "-<br>" + secondDate;
            }
            else {
                var monthFormatted = startDate.format('MMMM');
                var firstDate = startDate.format('D');
                var secondDate = endDate.format('D');
                formattedDate = (noBreakSameMonth) ? monthFormatted + " " + firstDate + "-" + secondDate : monthFormatted + "<br>" + firstDate + "-" + secondDate;
            }
            return formattedDate;
        };
    });
    Pulse.app.filter('formatVirtualSessionDate', function () {
        return function (start) {
            if (!moment(start).isValid())
                return '';
            var startDate = moment(start);
            var formattedDate;
            var monthFormatted = startDate.format('MMM');
            var firstDate = startDate.format('d');
            formattedDate = monthFormatted + " " + firstDate;
            return formattedDate;
        };
    });
    Pulse.app.filter('getSkillLevelDesc', function () {
        return function (course) {
            if (course.skillLevels && course.skillLevels.length > 0) {
                if (course.skillLevels.length == 1) {
                    return course.skillLevels[0].skill;
                }
                else {
                    return course.skillLevels[0].skill + " - " + course.skillLevels[course.skillLevels.length - 1].skill;
                }
            }
            else {
                return "All Levels";
            }
        };
    });
    Pulse.app.filter('formatCourseSessionAvailabilityStatusType', function () {
        return function (courseSession, sessionAvailabilityStatusTypes) {
            if (courseSession.programStatus === Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.SoldOut])
                return 'Join Waitlist';
            var type = Pulse.Utils.JS.findByProperties(sessionAvailabilityStatusTypes, { 'typeID': courseSession.programStatusTypeID })[0];
            if (angular.isDefined(type))
                return type['typeString'];
            else
                return '';
        };
    });
    Pulse.app.filter('courseHasOvernight', function () {
        return function (session) {
            var html = '';
            if (session.isONpackage == true) {
                html += '<i class="icon-gl-moon"></i>';
            }
            else {
                if (session.spdIDON > 0
                    && session.priceWithON > 0
                    && session.optionStatus !== 'SoldOut'
                    && session.optionRestriction !== 'ParticipantTooYoung') {
                    html += '<i class="icon-gl-sun"></i><i class="icon-gl-moon"></i>';
                }
                else {
                    html += '<i class="icon-gl-sun"></i>';
                }
            }
            if (session.hasPM) {
                html += '<i class="icon-gl-moon"></i>';
            }
            if (session.isPM) {
                html = '<i class="icon-gl-moon"></i>';
            }
            return html;
        };
    });
    Pulse.app.filter('facilityId', function () {
        return function (items, facilities) {
            var filtered = [];
            if (angular.isDefined(facilities) && facilities.length > 0) {
                var courseProductIDs = facilities.map(function (a) {
                    return a.courseProductIDs;
                }).reduce(function (a, b) {
                    return a.concat(b);
                }, []);
                angular.forEach(items, function (item) {
                    if (item.courseProductID && courseProductIDs.indexOf(item.courseProductID) !== -1) {
                        filtered.push(item);
                    }
                });
            }
            else {
                filtered.push.apply(filtered, items);
            }
            return filtered;
        };
    });
    Pulse.app.filter('courseTitleRemoveAges', function () {
        return function (course_title) {
            course_title = course_title.split(' for Ages')[0];
            if (course_title.isArray) {
                return course_title[0];
            }
            return course_title;
        };
    });
    Pulse.app.filter('courseIconFilter', function () {
        return function (course_subCatName) {
            var icon_html = '';
            switch (course_subCatName) {
                case 'Coding':
                    icon_html = '<i class="courses-icon-coding"></i>';
                    break;
                case 'Maker':
                    icon_html = '<i class="courses-icon-maker"></i>';
                    break;
                case 'Robotics':
                    icon_html = '<i class="courses-icon-robotics"></i>';
                    break;
                case 'Game Design':
                    icon_html = '<i class="courses-icon-game-design"></i>';
                    break;
                case 'Engineering':
                    icon_html = '<i class="courses-icon-gears-eng"></i>';
                    break;
                case '3D Modeling, 3D Printing':
                    icon_html = '<i class="courses-icon-d"></i>';
                    break;
                case 'Video Production':
                    icon_html = '<i class="courses-icon-video"></i>';
                    break;
                case 'Photography, Web Design':
                    icon_html = '<i class="courses-icon-webphotog"><i class="path1"></i><i class="path2"></i><i class="path3"></i></i>';
                    break;
                default:
                    icon_html = '';
                    break;
            }
            return icon_html;
        };
    });
    Pulse.app.filter('updateTdClass', function () {
        return function (course_status) {
            if (typeof course_status != 'undefined') {
                if (course_status.indexOf('Space') >= 0) {
                    return 'session-forced-white-background';
                }
                if (course_status != '') {
                    return '';
                }
            }
            return 'session-' + course_status;
        };
    });
    Pulse.app.filter('deleteJoinText', function () {
        return function (data) {
            if (typeof data != 'undefined') {
                data = data.replace('Join', '');
            }
            return data;
        };
    });
    Pulse.app.filter('divisionSchedTypeIdFilter', function () {
        return function (scheduleType) {
            if (scheduleType == 'FullDay') {
                return '';
            }
            else if (scheduleType == 'Afternoon') {
                return 'PM';
            }
            else if (scheduleType == 'Morning') {
                return 'AM';
            }
            return scheduleType;
        };
    });
    Pulse.app.filter('courseTitleRemoveAM', function () {
        return function (course_title, counter) {
            if (counter === void 0) { counter = 0; }
            if (typeof course_title !== 'undefined' || counter === 2) {
                course_title = course_title
                    .replace(' AM:', ':')
                    .replace(' PM:', ':');
            }
            return course_title;
        };
    });
    Pulse.app.filter('scheduleDescriptionFormatter', function () {
        return function (schedule) {
            if (schedule)
                schedule = schedule.split(/ (?=Pick-up:)/)
                    .map(function (s) {
                    return s.trim().replace(/^((Check-in|Pick-up):)(.+)/, "<strong>$1</strong> $3");
                })
                    .join('<br />');
            return schedule;
        };
    });
    Pulse.app.filter('tel', function () {
        return function (tel) {
            if (!tel) {
                return '';
            }
            var value = tel.toString().trim().replace(/^\+/, '').replace('-', '');
            if (value.match(/[^0-9]/)) {
                return tel;
            }
            var country, area, number;
            switch (value.length) {
                case 10:
                    country = 1;
                    area = value.slice(0, 3);
                    number = value.slice(3);
                    break;
                case 11:
                    country = value[0];
                    area = value.slice(1, 4);
                    number = value.slice(4);
                    break;
                default:
                    return tel;
            }
            return country + '-' + area + '-' + number.slice(0, 3) + '-' + number.slice(3);
        };
    });
    Pulse.app.filter('avcSkillLevel', function () {
        function getSkillLevelFullName(skillID) {
            for (var skillName in Pulse.Common.Enums.SkillLevels) {
                if (parseInt(Pulse.Common.Enums.SkillLevels[skillName]) === skillID) {
                    return skillName;
                }
            }
            throw Error('Unknown skill level');
        }
        return function (skillLevels, useFullName) {
            if (useFullName === void 0) { useFullName = false; }
            var representation = 'undefined';
            if (skillLevels) {
                if (skillLevels.length === 1) {
                    representation = getSkillLevelFullName(skillLevels[0].skillID);
                }
                else if (skillLevels.length > 1) {
                    representation = useFullName ? getSkillLevelFullName(skillLevels[0].skillID) : skillLevels[0].skill;
                    representation += '-';
                    representation += useFullName ? getSkillLevelFullName(skillLevels[skillLevels.length - 1].skillID) : skillLevels[skillLevels.length - 1].skill;
                }
            }
            return representation;
        };
    });
    Pulse.app.filter('daysToWeeks', function () {
        return function (days) {
            return Math.ceil(days / 7);
        };
    });
    Pulse.app.filter('utcToLocal', function () {
        return function (utcDateString, format) {
            if (!utcDateString)
                return;
            return moment.utc(utcDateString).local().format(format);
        };
    });
    Pulse.app.filter('htmlToPlaintext', function () {
        return function (text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
    });
    Pulse.app.filter('ageFilter', function () {
        return function (dateOfBirth) {
            return Math.floor(moment(new Date()).diff(moment(dateOfBirth), 'years', true));
        };
    });
    Pulse.app.filter('DTZeroHourPreviousDayAdjustForDisplay', function () {
        return function (dateValue, miliseconds) {
            if (miliseconds === void 0) { miliseconds = 1; }
            return Pulse.Utils.JS.DTZeroHourPreviousDayAdjustForDisplay(dateValue, miliseconds);
        };
    });
    Pulse.app.config(['$provide', function ($provide) {
            $provide.decorator('currencyFilter', ['$delegate', function ($delegate) {
                    var srcFilter = $delegate;
                    var extendsFilter = function (amount, currencySymbolOrTypeID, fractionSize) {
                        var res = "";
                        if (!angular.isNumber(amount))
                            return res;
                        var strUSD = "USD", strINR = "INR";
                        var includeAbbr = true;
                        var isCurrencyTypeID = angular.isNumber(currencySymbolOrTypeID);
                        if (isCurrencyTypeID && currencySymbolOrTypeID < 0) {
                            currencySymbolOrTypeID = Math.abs(currencySymbolOrTypeID);
                            includeAbbr = false;
                        }
                        else if (!isCurrencyTypeID && currencySymbolOrTypeID && currencySymbolOrTypeID.indexOf("-") == 0) {
                            currencySymbolOrTypeID = currencySymbolOrTypeID.substring(1);
                            includeAbbr = false;
                        }
                        if (currencySymbolOrTypeID == Enums.CurrencyType.USD || currencySymbolOrTypeID == strUSD) {
                            if (Number().toLocaleString) {
                                res = amount.toLocaleString('en-US', { style: 'currency', currency: strUSD, maximumFractionDigits: fractionSize });
                            }
                            else {
                                res = "$" + srcFilter.apply(this, [amount, "", fractionSize]);
                            }
                            if (includeAbbr)
                                res += " " + strUSD;
                        }
                        else if (currencySymbolOrTypeID == Enums.CurrencyType.INR || currencySymbolOrTypeID == strINR) {
                            if (Number().toLocaleString) {
                                res = amount.toLocaleString('en-IN', { style: 'currency', currency: strINR, maximumFractionDigits: fractionSize });
                            }
                            else {
                                res = "\u20B9" + srcFilter.apply(this, [amount, "", fractionSize]);
                            }
                            if (includeAbbr)
                                res += " " + strINR;
                        }
                        else {
                            if (isCurrencyTypeID) {
                                currencySymbolOrTypeID = undefined;
                            }
                            res = srcFilter.apply(this, [amount, currencySymbolOrTypeID, fractionSize]);
                        }
                        return res;
                    };
                    return extendsFilter;
                }]);
        }]);
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    "use strict";
    Pulse.config = {
        appName: "Pulse SPA",
        version: "2.1.0",
        isDebugMode: false,
        isIncludeTestCode: true,
        routes: new Array(),
        appErrorPrefix: "[PulsePublic] ",
        companyId: 1,
        docTitle: "PulsePublic: ",
        mqInflectionWidth: 750,
        mqIFrameInflectionWidth: 750,
        appRoot: "https://pulse-res-dev.idtech.com/zigzag_v2/latest/",
        WWW_UrlRoot: "https://wwwdev.idtech.com",
        get WWW_Pulse2x_HomeUrl() {
            return this.WWW_UrlRoot + "/account";
        },
        WWW_PulseappCSS: ".www-pulseapp",
        pulse1x_PublicUrl: "https://ppdev.idtech.com",
        pulse1x_AdminUrl: "https://padev.idtech.com",
        pulse1x_PublicAppRoot: "/PulsePublic",
        pulse1x_AdminAppRoot: "/PulseAdmin",
        get pulse1x_PublicUrlRoot() {
            return this.pulse1x_PublicUrl + this.pulse1x_PublicAppRoot;
        },
        get pulse1x_AdminUrlRoot() {
            return this.pulse1x_AdminUrl + this.pulse1x_AdminAppRoot;
        },
        pulse1x_WelcomeUrlRoot: "https://padev.idtech.com/PulseWelcome",
        pulse1x_WebServicesUrlRoot: "https://DevWebservices.idtech.com",
        webApi_UrlRoot: "https://pwapidev.iDTech.com",
        get webApi_BreezeMetadataUrl() {
            return this.webApi_UrlRoot + "/scripts/metadata.js";
        },
        get webApi_NonBreeze() {
            return this.webApi_UrlRoot + "/pulseWebApi";
        },
        mediaServerUrl: "https://media.idtech.com/pulse-prod",
        get courseVideoThumbnailUrl() {
            return this.mediaServerUrl + "/courseimages";
        },
        get courseVideoPlayerUrl() {
            return this.pulse1x_WebServicesUrlRoot + "/CourseVideoPlayer.aspx";
        },
        get mediaPathGenreUrl() {
            return this.mediaServerUrl + "/path-genre";
        },
        get mediaExperienceUrl() {
            return this.mediaServerUrl + "/experience";
        },
        googleBrowserApiKey: "AIzaSyCQ2SRjMtBA-QCoWRCRKYlZ4t5zNRd7mck",
        googleAPI_ClientID: "243125096424-r99747l1n8m24gsdd592d9190piotuhg.apps.googleusercontent.com",
        facebookAppID: "588628641321042",
        pulseErrorLogEnabled: true,
        pulseErrorLogSeverityLevelFilter: 2,
        skipRegFlow_OPL_Upsell: true,
    };
    var app = angular.module("pulseApp");
    app.constant("config", Pulse.config);
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    function extendExceptionHandler($delegate, $injector, config, logger) {
        var appName = config.appName;
        var appErrorPrefix = config.appErrorPrefix;
        return function (exception, cause) {
            $delegate(exception, cause);
            if (exception == null || (appErrorPrefix && exception.message && exception.message.indexOf(appErrorPrefix) === 0)) {
                return;
            }
            var errorData = { exception: exception, cause: cause, username: "unknown", actingAs: "" };
            var msg = appErrorPrefix + exception.message;
            try {
                var rScope = $injector.get('$rootScope');
                if (rScope) {
                    rScope.$broadcast(Events.SpinnerToggle, { show: false, ignoreCount: true });
                }
            }
            catch (err) { }
            try {
                var pulseContext = $injector.get(Pulse.Services.PulseContextService.serviceId);
                if (pulseContext && pulseContext.isLoggedIn) {
                    errorData.username = pulseContext.loggedInUser.userName;
                    errorData.actingAs = pulseContext.actingAsUser.userName;
                }
            }
            catch (err) { }
            errorData['userAgentData'] = navigator.userAgent;
            errorData['URL'] = window.location.href;
            var localStorage = $injector.get('localStorageService');
            errorData['AVCFilterQuery'] = JSON.stringify(localStorage.get('availabilityChartFilterQuery'));
            var isDupExpMsg = window.sessionStorage.lastSeenError == msg;
            var isExceptionExpired = window.sessionStorage.lastSeenErrorDateTime && moment(window.sessionStorage.lastSeenErrorExpiry).isBefore(moment());
            if (isDupExpMsg && !isExceptionExpired) {
                return;
            }
            else {
                window.sessionStorage.lastSeenError = msg;
                window.sessionStorage.lastSeenErrorExpiry = moment().add(15, 's');
                logger.logError(msg, errorData, appName, true);
            }
        };
    }
    Pulse.app.config(["$provide", function ($provide) {
            $provide.decorator("$exceptionHandler", ["$delegate", "$injector", "config", "logger", extendExceptionHandler]);
        }
    ]);
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var CorsSecurityConfigurator = (function () {
        function CorsSecurityConfigurator($sceDelegateProvider, config) {
            this.config = config;
            $sceDelegateProvider.resourceUrlWhitelist([
                'self',
                this.config.pulse1x_PublicUrl + '/**',
                this.config.pulse1x_AdminUrl + '/**',
                'https://*.idtech.com/**',
                'https://s3*.amazonaws.com/**',
                'about:blank',
                'http://localhost:*/**'
            ]);
        }
        return CorsSecurityConfigurator;
    }());
    Pulse.app.config(["$sceDelegateProvider", "config", function ($sceDelegateProvider, config) {
            return new CorsSecurityConfigurator($sceDelegateProvider, config);
        }
    ]);
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Config;
    (function (Config) {
        Config.commonRouteResolveDef = {
            "initData": ["common", "breezeService", "pulseContextService", function (common, breezeService, pulseContextService) {
                    common.toggleSpinner(true);
                    var promise = breezeService.resolveActivationPromises()
                        .then(function () {
                        return pulseContextService.resolveActivationPromises();
                    }).catch(function (error) {
                        breezeService.clearActivationPromises();
                        pulseContextService.clearActivationPromises();
                        if (angular.isString(error.message)) {
                            common.showError(error.message);
                        }
                        else if (angular.isString(error)) {
                            common.showError(error);
                        }
                        else {
                            common.showError(error);
                        }
                    }).finally(function () {
                        common.toggleSpinner(false, true);
                    });
                    return promise;
                }],
        };
    })(Config = Pulse.Config || (Pulse.Config = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Config;
    (function (Config) {
        var PublicRouteConfigurator = (function () {
            function PublicRouteConfigurator($routeProvider, config) {
                this.config = config;
                this.setupRoutes();
                this.routes.forEach(function (r) {
                    if (angular.isObject(r.config.resolve)) {
                        angular.extend(r.config.resolve, Config.commonRouteResolveDef);
                    }
                    else {
                        r.config.resolve = Config.commonRouteResolveDef;
                    }
                    if (config.isIncludeTestCode || String.isNullOrWhitespace(Routes.Test)
                        || r.url.indexOf(Routes.Test) < 0) {
                        $routeProvider.when(r.url, r.config);
                    }
                });
                $routeProvider.otherwise({
                    name: 'unknown'
                });
                if (!config.isIncludeTestCode) {
                    Routes.Test = '';
                }
            }
            PublicRouteConfigurator.prototype.setupRoutes = function () {
                var _this = this;
                var routes = [
                    {
                        url: Routes.Empty,
                        config: {
                            name: 'iD Tech',
                            redirectTo: function ($routeParams, $locationPath, $locationSearch) {
                                var www_route = $(_this.config.WWW_PulseappCSS).attr('data-page');
                                if (String.isNullOrWhitespace(www_route)) {
                                    return Routes.SplashPage;
                                }
                                return www_route;
                            }
                        }
                    },
                    {
                        url: Routes.PrivacyPolicy,
                        config: {
                            name: 'Privacy Policy',
                            templateUrl: this.config.appRoot + 'app/global/PublicTermsAndConditions.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.PublicTermsAndConditionsCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.Redirect,
                        config: {
                            name: 'iD Tech',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/redirectHandler.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.RedirectHandlerCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.ScholarshipTAP,
                        config: {
                            name: 'iD Tech',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/tuitionAssistanceProgram.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.TuitionAssistanceProgramCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.CreateAccount,
                        config: {
                            name: 'Create Account',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/login-or-create-account/createAccount.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.CreateAccountCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.Login,
                        config: {
                            name: 'Login',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/login-or-create-account/loginOrCreateAccount.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.LoginOrCreateAccountCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.Logout,
                        config: {
                            name: 'Logout',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/logout.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.LogoutCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.ResumeCartWithNoAccount,
                        config: {
                            name: 'iD Tech',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/resumeCartAnonymous.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ResumeCartAnonymousCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.ResumeCart,
                        config: {
                            name: 'iD Tech',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/resumeCart.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ResumeCartCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.SplashPage,
                        config: {
                            name: 'iD Tech',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/splash.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.SplashCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.DispatcherPage,
                        config: {
                            name: 'iD Tech',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/dispatcher.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.DispatcherCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.ChannelPreference,
                        config: {
                            name: 'Channel Preferences',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/channel-preference/channelPreference.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ChannelPreferenceCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.RegFlow_Default,
                        config: {
                            name: 'RegFlow Default',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/regFlowDefault.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.RegFlowDefaultCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.RegFlow_ChooseLocations,
                        config: {
                            name: 'Choose Locations',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/chooseLocation.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ChooseLocationCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.RegFlow_ChoosePath,
                        config: {
                            name: 'Choose Path',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/choosePath.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ChoosePathCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.RegFlow_ChooseExperience,
                        config: {
                            name: 'Choose Experience',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/chooseExperience.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ChooseExperienceCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.RegFlow_AvailChart,
                        config: {
                            name: 'Availability',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/availChart.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.AvailChartCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.RegFlow_AvailChartFilters,
                        config: {
                            name: 'Availability',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/availChartFilters.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.AvailChartFiltersCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            },
                            reloadOnSearch: false
                        }
                    },
                    {
                        url: Routes.RegFlow_ProductAvailability,
                        config: {
                            name: 'Product Availability',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/productAvailability.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ProductAvailabilityCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.RegFlow_ProductIpcDrawer,
                        config: {
                            name: 'Product IPC Availability',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/productIpcDrawer.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ProductIpcDrawerCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.RegFlow_Tutoring,
                        config: {
                            name: 'Tutoring',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/tutoring.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.TutoringCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.RegFlow_Billing,
                        config: {
                            name: 'Billing',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/billing.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.BillingCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.RegFlow_ShoppingCart,
                        config: {
                            name: 'Shopping Cart',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/shoppingCart.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ShoppingCartCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.RegFlow_Upsell,
                        config: {
                            name: 'Online Lessons',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/upsell.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.UpsellCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.RegFlow_OrderSummary,
                        config: {
                            name: 'Order Summary',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/reg-flow/orderSummary.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.OrderSummaryCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.RegFlow_ContactInfo,
                        config: {
                            name: 'Contact Info',
                            templateUrl: this.config.appRoot + String.format('app/pulsepublic/reg-flow/regFlowContactInfo.html'),
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.RegFlowContactInfoCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.RegFlow_OrderConfirmation,
                        config: {
                            name: 'Order Confirmation',
                            templateUrl: this.config.appRoot + String.format('app/pulsepublic/reg-flow/orderConfirmation.html'),
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.OrderConfirmationCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", function (common) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return common.$q.resolve();
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.OldPulseWebSite_GetFileASPX,
                        config: {
                            name: 'Get File ASPX',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/old-pulse-pages/getFileAspx.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.GetFileAspxCtlr.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.MyAccount,
                        config: {
                            name: 'My Account',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/home.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HomeCtrl.controllerId,
                            controllerAs: 'vm',
                            resolve: {
                                "resetPostCampStatus": ["common", "pulseContextService", function (common, pulseContextService) {
                                        Pulse.Common.DataAccess.Managers.ThresholdMgr.ResetPostCampStatus();
                                        return pulseContextService.userMgr.loadRelatedUsersForActingUser(false)
                                            .then(function (relatedUsers) {
                                            for (var _i = 0, relatedUsers_1 = relatedUsers; _i < relatedUsers_1.length; _i++) {
                                                var u = relatedUsers_1[_i];
                                                if (u.userRelationTypeID === Enums.UserRelationshipType.GroupManager) {
                                                    common.$location.url(Routes.MyAccount_RequiredForms);
                                                    return;
                                                }
                                            }
                                        });
                                    }],
                            }
                        }
                    },
                    {
                        url: Routes.MyAccount_RAFLanding,
                        config: {
                            name: 'My Account - Refer a Friend',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/refer-a-friend/rafLanding.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.RafLandingCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_RAFStatus,
                        config: {
                            name: 'My Account - Refer a Friend',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/refer-a-friend/rafStatus.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.RafStatusCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_RAF,
                        config: {
                            name: 'My Account - Refer a Friend',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/refer-a-friend/referAFriend.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ReferAFriendCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Billing,
                        config: {
                            name: 'My Account - Billing',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/billing/billing.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.MyAccountBillingCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Billing_Payment,
                        config: {
                            name: 'My Account - Make Payment',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/billing/payment.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.PaymentCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Billing_Statements,
                        config: {
                            name: 'My Account - Statements',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/billing/statements.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.StatementsCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Billing_Statements_Detailed,
                        config: {
                            name: 'My Account - Statements Detailed',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/billing/statementsDetailed.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.StatementsDetailedCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Billing_Info,
                        config: {
                            name: 'My Account - Billing Information',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/billing/billingInfo.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.BillingInfoCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Billing_ScholarshipTAP,
                        config: {
                            name: 'My Account - iD Tech Scholarship Program',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/billing/tap.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.TAPCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Billing_VIP_EarlyAccess,
                        config: {
                            name: 'VIP Early Access Pass',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/billing/vipEarlyAccess.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.VipEarlyAccessCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Billing_Vouchers,
                        config: {
                            name: 'Vouchers',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/billing/vouchers.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.VouchersCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Welcome_Letter,
                        config: {
                            name: 'iD Tech - Welcome',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/welcome-letter.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.WelcomeLetterCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.Terms_and_Conditions,
                        config: {
                            name: 'iD Tech - Terms and Conditions',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/terms-and-conditions.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.TermsAndConditionsCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_Profile,
                        config: {
                            name: 'My Account - Profile',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/profile.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ProfileCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_ContactInfo,
                        config: {
                            name: 'My Account - Contact Information',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/contactInfo.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ContactInfoCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_SecurityInfo,
                        config: {
                            name: 'My Account - Security Information',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/securityInfo.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.SecurityInfoCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_StudentInfo,
                        config: {
                            name: 'My Account - Student Information',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/studentInfo.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.StudentInfoCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_HistoryInfo,
                        config: {
                            name: 'My Account - History',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/historyInfo.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HistoryInfoCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_ShoppingCart,
                        config: {
                            name: 'My Account - Shopping Cart',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/shoppingCart.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.MyAccountShoppingCartCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_RequiredForms,
                        config: {
                            name: 'My Account - Client Forms',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/clientFormsHome.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ClientFormsHomeCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_CourseTakeHomes,
                        config: {
                            name: 'My Account - Course Take-Homes',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/courseTakeHomes.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.CourseTakeHomesCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_Registration,
                        config: {
                            name: 'My Account - Registration',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/registration/register.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.RegisterCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_ChangeOrder,
                        config: {
                            name: 'My Account - Change Order',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/registration/changeOrder.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ChangeOrderCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_OPLOnlineSessions,
                        config: {
                            name: 'My Account - Online Private lessons',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/online-private-lesson/onlineSessions.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.OnlineSessionsCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_OPLSessionReport,
                        config: {
                            name: 'My Account - OPL Post Session Report',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/online-private-lesson/oplSessionReport.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.OplSessionReportCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_OPLPurchase,
                        config: {
                            name: 'My Account - Online Private Lesson Products',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/online-private-lesson/oplPurchase.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.OPLPurchaseCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_SEMPurchase,
                        config: {
                            name: 'My Account - SEM Products',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/semPurchase.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.SEMPurchaseCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MyAccount_OPLOnlineSessionsClient,
                        config: {
                            name: 'My Account - Online Private lessons',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/online-private-lesson/clientSessions.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ClientSessionsCtrl.controllerId,
                            controllerAs: 'vm',
                            reloadOnSearch: false,
                        }
                    },
                    {
                        url: Routes.MyAccount_OPLOnlineSessionsSchedule,
                        config: {
                            name: 'My Account - Online Private lessons',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/online-private-lesson/schedule.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.ScheduleCtrl.controllerId,
                            controllerAs: 'vm',
                            reloadOnSearch: false,
                        }
                    },
                    {
                        url: Routes.HSF_Welcome,
                        config: {
                            name: 'My Account - Health & Safety Form - Welcome',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/welcome.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFWelcomeCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_NextStudent,
                        config: {
                            name: 'My Account - Health & Safety Form - Next Student',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/nextStudent.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFNextStudentCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_PrimaryEmergencyContact,
                        config: {
                            name: 'My Account - Health & Safety Form - Primary Emergency Contact',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/primaryEmergencyContact.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFPrimaryEmergencyContactCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_SecondaryEmergencyContact,
                        config: {
                            name: 'My Account - Health & Safety Form - Secondary Emergency Contact',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/secondaryEmergencyContact.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFSecondaryEmergencyContactCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_CheckInOut,
                        config: {
                            name: 'My Account - Health & Safety Form - Check In/Out',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/checkInOut.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFCheckInOutCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_AuthPickupContacts,
                        config: {
                            name: 'My Account - Health & Safety Form - Authorized Pickup Contacts',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/authPickupContacts.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFAuthPickupContactsCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_Insurance,
                        config: {
                            name: 'My Account - Health & Safety Form - Health Insurance',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/insurance.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFInsuranceCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_HealthHistory,
                        config: {
                            name: 'My Account - Health & Safety Form - Health History',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/healthHistory.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFHealthHistoryCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_Medications,
                        config: {
                            name: 'My Account - Health & Safety Form - Medications',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/medications.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFMedicationsCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_SpecialNeedsImmunizations,
                        config: {
                            name: 'My Account - Health & Safety Form - Activity Limitations or Participation Restrictions & Immunizations',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/specialNeedsImmunizations.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFSpecialNeedsImmunizationsCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_Schooling,
                        config: {
                            name: 'My Account - Health & Safety Form',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/schooling.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFSchoolingCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_Authorization,
                        config: {
                            name: 'My Account - Health & Safety Form',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/authorization.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFAuthorizationCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.HSF_Thanks,
                        config: {
                            name: 'My Account - Health & Safety Form',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/my-account/profile/client-forms/hsf/thanks.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HSFThanksCtrl.controllerId,
                            controllerAs: 'vm',
                        }
                    },
                    {
                        url: Routes.TermStaff,
                        config: {
                            name: 'Term Staff',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/term-staff/termStaffHome.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.TermStaffHomeCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.TermStaff_RAF,
                        config: {
                            name: 'Term Staff',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/term-staff/termStaffHome.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.TermStaffHomeCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.TermStaff_Employment,
                        config: {
                            name: 'Term Staff',
                            templateUrl: this.config.appRoot + 'app/pulsepublic/secure/term-staff/termStaffHome.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.TermStaffHomeCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MedicSearchMedLog,
                        config: {
                            name: 'Search Medication Log',
                            templateUrl: this.config.appRoot + 'app/medic/secure/search.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.SearchCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MedicSMSSend,
                        config: {
                            name: 'Medic - SMS Send',
                            templateUrl: this.config.appRoot + 'app/medic/secure/sms/smsSend.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.SmsSendCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MedicSMSSent,
                        config: {
                            name: 'Medic - SMS Sent',
                            templateUrl: this.config.appRoot + 'app/medic/secure/sms/smsSent.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.SmsSentCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MedicSMSAuth,
                        config: {
                            name: 'Medic - SMS Auth',
                            templateUrl: this.config.appRoot + 'app/medic/public/sms/smsAuth.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.SmsAuthCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MedicParticipantMedsEdit,
                        config: {
                            name: 'Medic - Add/Edit Student Medications',
                            templateUrl: this.config.appRoot + 'app/medic/secure/edit.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.EditCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MedicParticipantHsfEdit,
                        config: {
                            name: 'Medic - Add/Edit Student Required Form',
                            templateUrl: this.config.appRoot + 'app/medic/secure/hsf.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.HsfCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                    {
                        url: Routes.MedicParticipantMedsComplete,
                        config: {
                            name: 'Medic - Complete',
                            templateUrl: this.config.appRoot + 'app/medic/public/complete.html',
                            caseInsensitiveMatch: true,
                            controller: Pulse.Controllers.CompleteCtrl.controllerId,
                            controllerAs: 'vm'
                        }
                    },
                ];
                this.config.routes = this.config.routes.concat(routes);
            };
            Object.defineProperty(PublicRouteConfigurator.prototype, "routes", {
                get: function () {
                    return this.config.routes;
                },
                enumerable: false,
                configurable: true
            });
            return PublicRouteConfigurator;
        }());
        Pulse.app.config(['$routeProvider', 'config', function ($routeProvider, config) {
                return new PublicRouteConfigurator($routeProvider, config);
            }
        ]);
    })(Config = Pulse.Config || (Pulse.Config = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Bootstrap;
        (function (Bootstrap) {
            Bootstrap.bootstrapDatePickerDefaultConfig = {
                opened: false,
                options: {
                    maxDate: null,
                    minDate: null,
                    showWeeks: false,
                    initDate: null,
                },
                format: 'M!/d!/yyyy',
                altInputFormats: ['yyyy/M!/d!'],
            };
            Pulse.app.value("bootstrapDatePickerDefaultConfig", Bootstrap.bootstrapDatePickerDefaultConfig);
        })(Bootstrap = Common.Bootstrap || (Common.Bootstrap = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Resources;
        (function (Resources) {
            var Events = (function () {
                function Events() {
                }
                Events.TriggerDocCustomEvent = function (eventType, dataObj) {
                    var customEvent = new CustomEvent(eventType, { detail: dataObj });
                    document.dispatchEvent(customEvent);
                };
                Events.LoginSuccess = 'loginSuccess';
                Events.Login3rPartyAccountNotFound = 'Login3rPartyAccountNotFound';
                Events.LoggedOutRefresh = 'LoggedOutRefresh';
                Events.ForcePasswordChange = 'forcePwChange';
                Events.PublicUserAccountCreated = 'publicUserAccountCreated';
                Events.ControllerActivateSuccess = 'ControllerActivateSuccess';
                Events.ProductAddedToCart = 'ProductAddedToCart';
                Events.ShowHelpPopup = 'ShowHelpPopupEvent';
                Events.NgRepeatFinished = 'ngRepeatFinished';
                Events.WEBRemovingPromoBanner = 'WEBRemovingPromoBanner';
                Events.ShowBasicPopup = 'ShowBasicPopup';
                Events.ShowAVCAgePopup = 'ShowAVCAgePopup';
                Events.ShowAVCInfoPopup = 'ShowAVCInfoPopup';
                Events.ShowAvcCourseInfoPopup = 'ShowAvcCourseInfoPopup';
                Events.ShowAvcCourseOverlayPopup = 'ShowAvcCourseOverlayPopup';
                Events.ShowAVCOptionsPopup = 'ShowAVCOptionsPopup';
                Events.ShowAVCPrereqPopup = 'ShowAVCPrereqPopup';
                Events.ShowAVCSelectedPopup = 'ShowAVCSelectedPopup';
                Events.ShowAVCSelectedInliveView = 'ShowAVCSelectedInliveView';
                Events.ShowAVCWaitlistAdd = 'ShowAVCWaitlistAdd';
                Events.ShowLocationMapPopup = 'ShowAVCLocationMapPopup';
                Events.ShowLocationAirportPopup = 'ShowAVCLocationAirportPopup';
                Events.ShowRegFlowAdminOverridePopup = 'ShowRegFlowAdminOverridePopup';
                Events.ShowScheduledPaymentsPopup = 'ShowScheduledPaymentsPopup';
                Events.AdminOverrideAdded = 'AdminOverrideAdded';
                Events.ShowForgotPasswordPopup = 'ShowForgotPasswordPopup';
                Events.ShowResetPasswordPopup = 'ShowResetPasswordPopup';
                Events.ShowGroupWithPopup = 'ShowGroupWithPopup';
                Events.ShowCreditCardPopup = 'ShowCreditCardPopup';
                Events.ShowPrivacyPolicyPopup = 'ShowPrivacyPolicyPopup';
                Events.ShowTermsAndConditionsPopup = 'ShowTermsAndConditionsPopup';
                Events.ShowLoginPopup = 'ShowLoginPopup';
                Events.ShowIFramePopup = 'ShowIFramePopup';
                Events.ShowChangeCampPopup = 'ShowChangeCampPopup';
                Events.ShowRequestVoucherCreditPopup = 'ShowRequestVoucherCreditPopup';
                Events.ShowChangeCampDatePopup = 'ShowChangeCampDatePopup';
                Events.ShowChangeVirtualCampTimePopup = 'ShowChangeVirtualCampTimePopup';
                Events.ShowSubscriptionChangePopup = 'ShowSubscriptionChangePopup';
                Events.ShowSubscriptionPausePopup = 'ShowSubscriptionPausePopup';
                Events.ShowSubscriptionCancelPopup = 'ShowSubscriptionCancelPopup';
                Events.SubscriptionStatusUpdated = 'SubscriptionStatusUpdated';
                Events.CloseAllPopups = 'CloseAllPopups';
                Events.SpinnerInitialized = 'SpinnerInitialized';
                Events.SpinnerToggle = 'SpinnerToggleEvent';
                Events.ShowMedicAppLockedPopup = 'ShowMedicAppLockedPopup';
                Events.ShowMedicCodePopup = 'ShowMedicCodePopup';
                Events.WindowResized = 'WindowResized';
                Events.IFrameLoaded = 'IFrameLoaded';
                Events.GenerateAvailabilityChart = 'generateAvailabilityChart';
                Events.AvChartGenerated = 'avcGenerated';
                Events.MarkNewlyAddedToCartProd = 'markNewlyAddedToCartProd';
                Events.AvChartClearAll = 'availabilityChartClearAll';
                Events.AvChartCloseDrawer = 'removeCourseInline';
                Events.AvChartProcessSessionClickEvent = 'avcProcessSessionClickEvent';
                Events.AvChartAddWaitlist = 'avChartAddWaitlist';
                Events.AvChartTriggerCourseInfo = 'avcTriggerCourseInfo';
                Events.AvChartApplyFilters = 'avChartApplyFilters';
                Events.AvailabilityChartResetFilters = 'AVChartResetFilters';
                Events.AvChartSelectedSession = 'selectedSession';
                Events.DrawerUpdateEmail = 'DrawerUpdateEmail';
                Events.ParticipantFormFocusIn = 'ParticipantFormFocusIn';
                Events.ParticipantFormFocusOut = 'ParticipantFormFocusOut';
                Events.ParticipantFormFocusOnInput = 'ParticipantFormFocusOnInput';
                Events.ShoppingCartAddCourseRequest = 'addCourse';
                Events.ShoppingCartItemOptionSelectedChangeRequest = 'optionIsSelectedChange';
                Events.ShoppingCartRemoveItemRequest = 'removeItem';
                Events.ShoppingCartRemoveNonParticipantItemRequest = 'removeNonParticipantItem';
                Events.ShoppingCartPrimaryOptionChangeRequest = 'primaryOptionChange';
                Events.ShoppingCartRetrieved = 'cartRetrieved';
                Events.ShoppingCartEmpty = 'cartEmpty';
                Events.ShoppingCartChanged = 'cartChange';
                Events.RegFlowCheckOutRequested = 'regFlowCheckOutRequested';
                Events.RegFlowShoppingCartValidated = 'regFlowShoppingCartValidated';
                Events.OrderSummaryChangeRequest = 'orderSummaryChangeRequest';
                Events.StudentGenderChanging = 'studentGenderChanging';
                Events.AllStudentsInfoSaved = 'allStudentsInfoSaved';
                Events.ShowStudentMergePopup = 'showStudentMergePopup';
                Events.StudentsMerged = 'studentsMerged';
                Events.StudentsMerged_RunPostActions = 'studentsMerged_RunPostActions';
                Events.ShowMissingInfoPopup = 'showMissingInfoPopup';
                Events.ShowRafEmailPopup = 'showRafEmailPopup';
                Events.ShowRafEmailSentPopup = 'showRafEmailSentPopup';
                Events.MissingInfoSuccess = 'missingInfoSuccess';
                Events.SendCartInfo_JSEvent = 'idp-cartinfo';
                Events.SendPostCampInfo_JSEvent = 'idp-postcampinfo';
                Events.BackToSelectLocation_JSEvent = "BackToSelectLocation";
                Events.ProductAvailabilityAddedToCart_JSEvent = 'ProductAvailabilityAddedToCart';
                Events.ProductAvailabilityItemClicked_JSEvent = 'ProductAvailabilityItemClicked';
                Events.ProductAvailabilityCancel_JSEvent = 'ProductAvailabilityCancel';
                Events.ProductAvailabilityGroupWithFinished = 'ProductAvailabilityGroupWithFinished';
                Events.ProductAvailabilityStepChange = 'ProductAvailabilityStepChange';
                Events.ClientFormStatusChanging = 'clientFormStatusChanging';
                Events.ClientHistoryFormStatusChanging = 'clientHistoryFormStatusChanging';
                Events.ClientFormSectionStatusChanging = 'clientFormSectionStatusChanging';
                Events.ClientFormStatusChangesSaved = 'clientFormStatusChangesSaved';
                Events.HSFAuthorizationChanged = 'hsfAuthorizationChanged';
                Events.ShowSendEmailToUserPopup = 'showSendEmailToUserPopup';
                Events.SendEmailToUserSuccess = 'sendEmailToUserSuccess';
                Events.ShowFormSectionsPopup = 'showFormSectionsPopup';
                Events.FormCategorySelectionsChanged = 'formCategorySelectionsChanged';
                Events.UploadedFormTypeSelectionsChanged = 'uploadedFormTypeSelectionsChanged';
                Events.DivisionSelectionsChanged = 'divisionSelectionsChanged';
                Events.CountryStateSelectionsChanged = 'countryStateSelectionsChanged';
                Events.LocationSelectionsChanged = 'locationSelectionsChanged';
                Events.SessionSelectionsChanged = 'sessionSelectionsChanged';
                Events.PulseTypeSelectionsChanged = 'pulseTypeSelectionsChanged';
                Events.FacilitySelectionsChanged = 'facilitySelectionsChanged';
                Events.TermSelectionsChanged = 'termSelectionsChanged';
                Events.TermGroupSelectionsChanged = 'termGroupSelectionsChanged';
                Events.AgeRangeSelectionsChanged = 'ageRangeSelectionsChanged';
                Events.AssignToUserFiltersChanged = 'assignToUserFiltersChanged';
                Events.ProductScheduleDefAdded = 'productScheduleDefAdded';
                Events.ProductScheduleDetailsAdded = 'productScheduleDetailsAdded';
                Events.SupplyItemAdded = 'supplyItemAdded';
                Events.SupplyItemRuleAdded = 'supplyItemRuleAdded';
                Events.LicenseItemDefAdded = 'licenseItemDefAdded';
                Events.LicenseItemRuleAdded = 'licenseItemRuleAdded';
                Events.BooleanSelected = 'booleanSelected';
                Events.ShowLicenseItemDefEditPopup = 'showLicenseItemDefEditPopup';
                Events.LicenseItemDefUpdated = 'licenseItemDefUpdated';
                Events.ShowLicenseEditPopup = 'showLicenseEditPopup';
                Events.ShowLicenseItemAssignmentEditPopup = 'showLicenseItemAssignmentEditPopup';
                Events.ShowLicenseUploadPopup = 'showLicenseUploadPopup';
                Events.ShowRafAdminStatusPopup = 'ShowRafAdminStatusPopup';
                Events.RafAdminStatusUpdated = 'RafAdminStatusUpdated';
                Events.ShowOPLSessionNoteEditPopup = 'OPLSessionNoteEditPopup';
                Events.ShowOPLCourseInfoPopup = 'OPLCourseInfoPopup';
                Events.OPLMyAccountStudentChanged = 'OPLMyAccountStudentChanged';
                Events.OPLScheduleLessonsUpdated = 'OPLScheduleLessonsUpdated';
                Events.OPLScheduleCourseSelected = 'OPLScheduleCourseSelected';
                Events.OPLScheduleDateTimeSelected = 'OPLScheduleDateTimeSelected';
                Events.OPLScheduleInstructorSelected = 'OPLScheduleInstructorSelected';
                Events.ShowOplScheduleMultibleTimePopup = 'ShowOplScheduleMultibleTimePopup';
                Events.ShowOplScheduleRecurringDatePopup = 'ShowOplScheduleRecurringDatePopup';
                Events.OPLScheduleTimeZoneSelected = 'OPLScheduleTimeZoneSelected';
                Events.OPLScheduleHardwareFilterApplied = 'OPLScheduleHardwareFilterApplied';
                Events.ShowOPLEmailPreviewPopup = 'OPLEmailPreviewPopup';
                Events.OPLStudentNoteUpdated = 'OPLStudentNoteUpdated';
                Events.OPLStudentNoteDeleted = 'OPLStudentNoteDeleted';
                Events.OPLSessionSummaryUpdated = 'OPLSessionSummaryUpdated';
                Events.OPLHasAvailableSessionsUpdated = 'OPLHasAvailableSessionsUpdated';
                Events.ShowOPLScheduledConfirmationPopup = 'ShowOPLScheduledConfirmationPopup';
                Events.VoucherCreditRequested = 'VoucherCreditRequested';
                Events.CreditCardUpdatedSuccess = 'CreditCardUpdatedSuccess';
                Events.ContactChannelsUpdated = 'ContactChannelsUpdated';
                Events.ShowChannelPrefPopup = 'ShowChannelPrefPopup';
                return Events;
            }());
            Resources.Events = Events;
        })(Resources = Common.Resources || (Common.Resources = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));
var Events = Pulse.Common.Resources.Events;

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Resources;
        (function (Resources) {
            var Paths = (function () {
                function Paths() {
                }
                Paths.SharedDirectives = "app/directives/";
                Paths.PulsePublicDirective = "app/pulsepublic/directives/";
                Paths.PulsePublicRegistryFlow = "app/pulsepublic/registry-flow/";
                Paths.PulseAdminDirective = "app/pulseadmin/directives/";
                Paths.Pulse1x_PublicMyAccountDashboard = "/securepages/dashboard.aspx";
                Paths.Pulse1x_PublicMyAccountSchedule = "/securepages/myschedule.aspx";
                Paths.Pulse1x_PublicGetFile = "/securepages/getfile.aspx";
                Paths.Pulse1x_Admin_ConferenceServiceReportStudent = "/PagesAdmin/ConferenceServiceReport.aspx";
                Paths.Pulse1x_Admin_ConferenceServiceReportStaff = "/PagesAdmin/ConferenceServiceReportStaff.aspx";
                Paths.Pulse1x_Admin_CSImpersonateCustomer = "/PagesAdmin/CSImpersonateCustomer.aspx";
                Paths.Pulse1x_Admin_JobAppSearch = "/PagesAdmin/JobAppSearch.aspx";
                return Paths;
            }());
            Resources.Paths = Paths;
        })(Resources = Common.Resources || (Common.Resources = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));
var Paths = Pulse.Common.Resources.Paths;

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Resources;
        (function (Resources) {
            var PulseErrorTypes = (function () {
                function PulseErrorTypes() {
                }
                PulseErrorTypes.OAuth_Invalid_Grant = "invalid_grant";
                PulseErrorTypes.OAuth_Denied = "auth_denied";
                PulseErrorTypes.Show_To_User = "ShowToUser";
                PulseErrorTypes.Show_To_User_Warning = "ShowToUserWarning";
                PulseErrorTypes.Show_To_User_FriendlyException = "Pulse.Framework.Exceptions.UserFriendlyException";
                return PulseErrorTypes;
            }());
            Resources.PulseErrorTypes = PulseErrorTypes;
        })(Resources = Common.Resources || (Common.Resources = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));
var PulseErrorTypes = Pulse.Common.Resources.PulseErrorTypes;

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Resources;
        (function (Resources) {
            var PulseRegExp = (function () {
                function PulseRegExp() {
                }
                PulseRegExp.Email = /^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
                PulseRegExp.EmailErrorMessage = "Please enter a valid Email address";
                PulseRegExp.Password = /(?=^[!@#$%&:;,.?a-zA-Z0-9]{6,25}$)(?=.*\d)(?![.\n]).*$/;
                PulseRegExp.PasswordErrorMessage = "Invalid password. Must be 6 to 25 characters and contain at least 1 number. The following special characters are also accepted: ! @ # $ % & ; : , . ?";
                PulseRegExp.PasswordMatchMessage = "The passwords must match";
                PulseRegExp.areaCodeUSorCanada = /^[0-9]{3}$/;
                PulseRegExp.areaCodeErrorMessageUSorCanada = "A US/Canadian area code is a 3-digit number.";
                PulseRegExp.areaCodeIntl = /^(\+?[0-9]{1,5}|[0-9]{1,4}[0-9]{1,4})$/;
                PulseRegExp.areaCodeErrorMessageIntl = "The area code is 1 to 5 digits. The digits may be preceded by a plus (+).";
                PulseRegExp.phoneNumberUSorCanada = /^\d{3}-?\d{4}$/;
                PulseRegExp.phoneNumberErrorMessageUSorCanada = "A US/Canadian phone number must be 7 digits.  A dash (-) may appear between the third and fourth digit.";
                PulseRegExp.phoneNumberIntl = /(?=^[-0-9]{1,12}$)(.*\d)/;
                PulseRegExp.phoneNumberErrorMessageIntl = "Invalid international phone number.";
                PulseRegExp.phoneExtension = /^\d*$/;
                PulseRegExp.phoneExtensionErrorMessage = "Only digits are allowed in the Extension.";
                PulseRegExp.phoneNumberUSorCanadaIncludingAreaCode = /^\s*(\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})\s*$/;
                PulseRegExp.phoneNumberErrorMessageUSorCanadaIncludingAreaCode = "A US/Canadian phone number must be 10 digits.  Dashes (-) may appear as in 555-555-5555 or parenthesis as in (555)555-5555.";
                PulseRegExp.currencyAmount = /^(\d{1,3}(\,\d{3})*|(\d+))(\.\d{2})?$/;
                PulseRegExp.currencyAmountErrorMessage = "Must be a decimal number with not more than two decimal places.";
                PulseRegExp.ASCIIOnly = /^[ -~\n]*$/;
                PulseRegExp.ASCIIOnlyErrorMessage = "Please enter English characters only";
                return PulseRegExp;
            }());
            Resources.PulseRegExp = PulseRegExp;
            Pulse.app.run(['$rootScope', function ($rootScope) {
                    $rootScope.PulseRegExp = Pulse.Common.Resources.PulseRegExp;
                }]);
        })(Resources = Common.Resources || (Common.Resources = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));
var PulseRegExp = Pulse.Common.Resources.PulseRegExp;

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Resources;
        (function (Resources) {
            var Routes = (function () {
                function Routes() {
                }
                Routes.Test = '/_test';
                Routes.Empty = '/';
                Routes.Token = '/token';
                Routes.PrivacyPolicy = '/global/privacyPolicy';
                Routes.Redirect = '/redirect';
                Routes.ScholarshipTAP = '/tuitionAssistanceProgram';
                Routes.CreateAccount = '/createAccount';
                Routes.Login = '/login';
                Routes.Logout = '/logout';
                Routes.ResumeCart = '/resumeCart';
                Routes.ResumeCartWithNoAccount = '/resumeCartWithNoAccount';
                Routes.SplashPage = '/splash';
                Routes.DispatcherPage = '/dispatcher';
                Routes.ChannelPreference = '/channel-preference';
                Routes.Billing = '/my-account/billing';
                Routes.Billing_Monthly_Payments = '/my-account/billing/monthly-payments';
                Routes.Billing_Payment = '/my-account/billing/payment';
                Routes.Billing_Statements = '/my-account/billing/statements';
                Routes.Billing_Statements_Detailed = '/my-account/billing/statements-detailed';
                Routes.Billing_Info = '/my-account/billing/billingInfo';
                Routes.Billing_ScholarshipTAP = '/my-account/billing/tap';
                Routes.Billing_Subscription = '/my-account/online-private-lesson/clientSessions';
                Routes.Billing_VIP_EarlyAccess = '/my-account/billing/vip';
                Routes.Billing_Vouchers = '/my-account/billing/vouchers';
                Routes.MyAccount = '/my-account';
                Routes.MyAccount_RAFLanding = '/my-account/refer-a-friend/rafLanding';
                Routes.MyAccount_RAFStatus = '/my-account/refer-a-friend/rafStatus';
                Routes.MyAccount_RAF = '/my-account/refer-a-friend/raf';
                Routes.Welcome_Letter = '/welcome-letter';
                Routes.Terms_and_Conditions = '/terms-and-conditions';
                Routes.MyAccount_Profile = '/my-account/profile';
                Routes.MyAccount_ContactInfo = '/my-account/profile/contactInfo';
                Routes.MyAccount_SecurityInfo = '/my-account/profile/securityInfo';
                Routes.MyAccount_StudentInfo = '/my-account/profile/studentInfo';
                Routes.MyAccount_HistoryInfo = '/my-account/profile/historyInfo';
                Routes.MyAccount_RequiredForms = '/my-account/profile/requiredForms';
                Routes.MyAccount_CourseTakeHomes = '/my-account/profile/courseTakeHomes';
                Routes.MyAccount_Registration = '/my-account/registration';
                Routes.MyAccount_ChangeOrder = '/my-account/registration/changeOrder';
                Routes.MyAccount_ShoppingCart = '/my-account/profile/shopping-cart';
                Routes.MyAccount_OPLOnlineSessions = '/my-account/online-private-lesson/sessions';
                Routes.MyAccount_OPLSessionReport = '/my-account/online-private-lesson/sessionReport';
                Routes.MyAccount_OPLPurchase = '/my-account/online-private-lesson/opl-purchase';
                Routes.MyAccount_SEMPurchase = '/my-account/sem-purchase';
                Routes.MyAccount_OPLOnlineSessionsClient = '/my-account/online-private-lesson/clientSessions';
                Routes.MyAccount_OPLOnlineSessionsSchedule = '/my-account/online-private-lesson/schedule';
                Routes.HSF_Welcome = '/my-account/profile/client-forms/health-safety-form/welcome';
                Routes.HSF_NextStudent = '/my-account/profile/client-forms/health-safety-form/nextStudent';
                Routes.HSF_PrimaryEmergencyContact = '/my-account/profile/client-forms/health-safety-form/primaryContact';
                Routes.HSF_SecondaryEmergencyContact = '/my-account/profile/client-forms/health-safety-form/secondaryContact';
                Routes.HSF_CheckInOut = '/my-account/profile/client-forms/health-safety-form/checkInOut';
                Routes.HSF_AuthPickupContacts = '/my-account/profile/client-forms/health-safety-form/pickupContacts';
                Routes.HSF_Insurance = '/my-account/profile/client-forms/health-safety-form/insurance';
                Routes.HSF_HealthHistory = '/my-account/profile/client-forms/health-safety-form/healthHistory';
                Routes.HSF_Medications = '/my-account/profile/client-forms/health-safety-form/medications';
                Routes.HSF_SpecialNeedsImmunizations = '/my-account/profile/client-forms/health-safety-form/specialNeedsImmunizations';
                Routes.HSF_Schooling = '/my-account/profile/client-forms/health-safety-form/schooling';
                Routes.HSF_Authorization = '/my-account/profile/client-forms/health-safety-form/authorization';
                Routes.HSF_Thanks = '/my-account/profile/client-forms/health-safety-form/thanks';
                Routes.RegFlow_Default = '/reg-flow';
                Routes.RegFlow_ChooseLocations = '/reg-flow/choose-locations';
                Routes.RegFlow_ChoosePath = '/reg-flow/choose-path';
                Routes.RegFlow_ChooseExperience = '/reg-flow/choose-experience';
                Routes.RegFlow_AvailChart = '/reg-flow/avail-charts';
                Routes.RegFlow_AvailChartFilters = '/reg-flow/avail-charts-filters';
                Routes.RegFlow_ProductAvailability = '/reg-flow/product-availability';
                Routes.RegFlow_ProductIpcDrawer = '/reg-flow/product-drawer';
                Routes.RegFlow_Tutoring = '/reg-flow/tutoring';
                Routes.RegFlow_ShoppingCart = '/reg-flow/shopping-cart';
                Routes.RegFlow_OrderSummary = '/reg-flow/order-summary';
                Routes.RegFlow_Login = '/reg-flow/login';
                Routes.RegFlow_ParticipantInfo = '/reg-flow/student-info';
                Routes.RegFlow_Upsell = '/reg-flow/extras';
                Routes.RegFlow_YourInfo = '/reg-flow/your-info';
                Routes.RegFlow_Billing = '/reg-flow/billing';
                Routes.RegFlow_MakePayment = '/reg-flow/make-payment';
                Routes.RegFlow_OrderConfirmation = '/reg-flow/order-confirmation';
                Routes.RegFlow_ContactInfo = '/reg-flow/contact-info';
                Routes.OldPulseWebSite_GetFileASPX = '/secure/old-pulse-pages/get-file-aspx';
                Routes.TermStaff = '/term-staff';
                Routes.TermStaff_RAF = '/term-staff/raf';
                Routes.TermStaff_Employment = '/term-staff/employment';
                Routes.MedicSearchMedLog = '/medic/log';
                Routes.MedicSMSSend = '/medic/sms/send/:participantId/:action';
                Routes.MedicSMSSent = '/medic/sms/sent';
                Routes.MedicSMSAuth = '/iD/:code?';
                Routes.MedicParticipantMedsEdit = '/medic/participant/edit/:userFormDetailId/:userId/:token';
                Routes.MedicParticipantHsfEdit = '/medic/participant/hsf/:userFormDetailId/:userId/:token';
                Routes.MedicParticipantMedsComplete = '/medic/participant/complete';
                Routes.PulseAdmin_SystemCacheCheck = '/pulseadmin/systemCacheCheck';
                Routes.PulseAdmin_StudentCheckouts = '/pulseadmin/studentCheckouts';
                Routes.PulseAdmin_ManageDocumentUploads = '/pulseadmin/manageDocumentUploads';
                Routes.PulseAdmin_DormRoomCreation = '/pulseadmin/dormRoomCreation';
                Routes.PulseAdmin_DormRoomAssignToSessions = '/pulseadmin/dormRoomAssignToSessions';
                Routes.PulseAdmin_DormRoomAdjustSessionAssignments = '/pulseadmin/dormRoomAdjustSessionAssignments';
                Routes.PulseAdmin_DormRoomAssignToUser = '/pulseadmin/dorm-room-assign-to-user';
                Routes.PulseAdmin_ProductScheduleSearch = '/pulseadmin/productScheduleSearch';
                Routes.PulseAdmin_SupplyItemSearch = '/pulseadmin/supplyItemSearch';
                Routes.PulseAdmin_SupplyItemRuleSearch = '/pulseadmin/supplyItemRuleSearch';
                Routes.PulseAdmin_LicenseItemDefSearch = '/pulseadmin/licenseItemDefSearch';
                Routes.PulseAdmin_LicenseItemRuleSearch = '/pulseadmin/licenseItemRuleSearch';
                Routes.PulseAdmin_LicenseSearch = '/pulseadmin/license-management/license-search';
                Routes.PulseAdmin_LicenseAutoAssign = '/pulseadmin/license-management/license-auto-assignment';
                Routes.PulseAdmin_ZoomAttendance = '/pulseadmin/zoomAttendance';
                return Routes;
            }());
            Resources.Routes = Routes;
            Pulse.app.run([
                '$rootScope',
                function ($rootScope) {
                    $rootScope.Routes = Pulse.Common.Resources.Routes;
                },
            ]);
        })(Resources = Common.Resources || (Common.Resources = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));
var Routes = Pulse.Common.Resources.Routes;

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Resources;
        (function (Resources) {
            var StringConsts = (function () {
                function StringConsts() {
                }
                StringConsts.Title_Confirmation = "Confirmation";
                StringConsts.Info_AutoBillEnrolled = "Your account has been enrolled in Auto-bill.";
                StringConsts.Info_AutoBillRemoved = "Your account has been removed from Auto-bill.";
                StringConsts.Info_SaveSucceeded = "Your information has been saved.";
                StringConsts.Info_ResetPassword = "An email regarding your password reset has been sent.";
                StringConsts.Info_WelcomePacketAvailOn = "Your Essential Information will be available on {0}";
                StringConsts.Info_WelcomePacketNotAvail = "Essential Information and Maps & Driving Directions are not currently available";
                StringConsts.Info_WelcomePacketNotAvailMissReqFrms = "Please <a href='{0}'>complete your form(s)</a> to access your Essential Information and see maps, driving directions, your packing list, and more!";
                StringConsts.Info_3rPartyAuth_GoogleAccountNotFound_Msg = 'Email "{0}" is not in our system.';
                StringConsts.Info_3rPartyAuth_GoogleAccountLinkAccount_Msg = 'Log in with the email and password associated with your iD Tech account. We will connect your existing account details to your Google email so you can log in using Google next time.';
                StringConsts.Warn_Cart_MergeNeeded = "Looks like you've accessed your shopping cart from a different device or browser.<br />Click Yes to refresh and review your cart. Click No to empty your cart and start over.";
                StringConsts.Warn_Cart_Removed = "Your shopping cart is empty. Perhaps you were shopping on a different device or browser.<br />Would you like to start a new cart?";
                StringConsts.Warn_Order_ChangeFee = "<strong>Note:</strong> Changing dates and downgrading options may incur a change fee this close to the start of camp.";
                StringConsts.Warn_CreateClientContactStaffLog = "Are you sure you want to create Incoming and Outgoing Client Logs and a Staff Log?";
                StringConsts.Warn_ScreenSizeTooSmallForTask = "You are entering an area that requires a larger screen.<br />Please use a different device or try rotating to landscape mode.";
                StringConsts.Warn_UnsavedChanges = "You have unsaved changes.<br />Abandon unsaved changes and proceed?";
                StringConsts.Warn_UnsavedChanges_RegFlow = "Your registration is incomplete.<br />Are you sure you want to leave this page?";
                StringConsts.Warn_GenericValidationError = "Please check the form for errors";
                StringConsts.Warn_StudentNotMeetAgeRequirement = "Student does not meet age requirements.";
                StringConsts.Warn_CoursePrepOptionNotRemovable = "You have already purchased this service. Please call Client Services at <span style='white-space:nowrap;'>[TollFreeNumber]</span> to cancel";
                StringConsts.Warn_StudentDOBRequired = "Student date of birth is required";
                StringConsts.Warn_Room_Run_AutoRoom = "Are you sure you want to run Auto Rooming, which may change unlocked room assignments?";
                StringConsts.Warn_Room_Unassign_All_From_Unlocked = "Remove all unlocked room assignments from selected building and session?";
                StringConsts.Err_Location_Required = "Please select a Location";
                StringConsts.Err_Path_Genre_Required = "Please select a Path";
                StringConsts.Err_Experience_Required = "Please select an Experience";
                StringConsts.Err_Failure_Friendly_Msg = "We are experiencing some technical difficulties.  Please retry later or contact customer service for assistance. <a href='https://help.idtech.com/'>iD Tech Help Center</a><br /> <a style='white-space:nowrap;' href='tel:+18887098324'>1-888-709-8324</a>";
                StringConsts.Err_Failure_Friendly_Msg_Fragment = "  If you need further assistance please contact customer service. <a href='https://help.idtech.com/'>iD Tech Help Center</a><br /> <a style='white-space:nowrap;' href='tel:+18887098324'>1-888-709-8324</a>";
                StringConsts.Err_Data_Missing = "Data is missing or not loaded correctly.";
                StringConsts.Err_Data_Corrupt = "Data is corrupt or invalid.";
                StringConsts.Err_Not_Implemented = "Code not yet implemented or is unfinished.";
                StringConsts.Err_Not_Supported = "Not supported.";
                StringConsts.Err_User_Migrate_Multi_Emails = "There are multiple accounts with this primary email address. Please try using your old Username to log in and update your primary email address.<br /><br />If you need assistance, please try our <a href='https://help.idtech.com/'>Help Center</a> or feel free to contact one of our Program Advisors at {0} or {1} for international calls.";
                StringConsts.Err_3rdParty_SignInFailure_Msg = "Failed to sign in with {0}. Please try again later or try sign in with your iD Tech account instead.";
                StringConsts.Err_AuthToken_Expired_Or_Unauthorized = "The session may have expired. Please log in again. iD Tech Help Center 1-888-709-8324";
                StringConsts.Partial_URLs_For_Splash = ["splash.aspx",
                    "ShowAnnouncement.aspx",
                    "UserContactInfo.aspx",
                    "TCAgreement.aspx"];
                StringConsts.Partial_URLs_For_Registration = ["ChooseLocationEx.aspx",
                    "AvailabilityChartEx.aspx",
                    "ParticipantInfo.aspx",
                    "AddOptions.aspx",
                    "SubscriptionUpsell.aspx",
                    "YourInformation.aspx",
                    "AddDiscounts.aspx",
                    "OrderSummary2015.aspx",
                    "Billing.aspx",
                    "CustomerInfo2015.aspx",
                    "OrderConfirmation.aspx",
                    "GetFile.aspx",
                    "EmailItinerary.aspx"];
                StringConsts.DateTime_Format = "YYYY-MM-DDTHH:mm:ss";
                StringConsts.CSS_www_pulseapp = "www-pulseapp";
                StringConsts.CSS_pulseapp = "pulseapp";
                StringConsts.CSS_ID_pulse_view_top = "pulseViewTop";
                StringConsts.CSS_ID_pulse_view_btm = "pulseViewBtm";
                return StringConsts;
            }());
            Resources.StringConsts = StringConsts;
            Pulse.app.run(['$rootScope', function ($rootScope) {
                    $rootScope.StringConst = Pulse.Common.Resources.StringConsts;
                }]);
        })(Resources = Common.Resources || (Common.Resources = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));
var StringConst = Pulse.Common.Resources.StringConsts;

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Enums;
        (function (Enums) {
            var TimeInterval;
            (function (TimeInterval) {
                TimeInterval[TimeInterval["All"] = 1] = "All";
                TimeInterval[TimeInterval["Current"] = 2] = "Current";
                TimeInterval[TimeInterval["CurrentTerms"] = 3] = "CurrentTerms";
                TimeInterval[TimeInterval["History"] = 4] = "History";
                TimeInterval[TimeInterval["HistoryTerms"] = 5] = "HistoryTerms";
                TimeInterval[TimeInterval["Future"] = 6] = "Future";
                TimeInterval[TimeInterval["CurrentTermsAndNotYetEnded"] = 7] = "CurrentTermsAndNotYetEnded";
            })(TimeInterval = Enums.TimeInterval || (Enums.TimeInterval = {}));
        })(Enums = Common.Enums || (Common.Enums = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Enums;
        (function (Enums) {
            var TypeClassType;
            (function (TypeClassType) {
                TypeClassType[TypeClassType["RecordState"] = 1] = "RecordState";
                TypeClassType[TypeClassType["UserRole"] = 2] = "UserRole";
                TypeClassType[TypeClassType["Company"] = 3] = "Company";
                TypeClassType[TypeClassType["DivisionDeliveryModel"] = 4] = "DivisionDeliveryModel";
                TypeClassType[TypeClassType["Visibility"] = 5] = "Visibility";
                TypeClassType[TypeClassType["AddressType"] = 6] = "AddressType";
                TypeClassType[TypeClassType["ContactMethod"] = 7] = "ContactMethod";
                TypeClassType[TypeClassType["Country"] = 8] = "Country";
                TypeClassType[TypeClassType["ContractDate"] = 9] = "ContractDate";
                TypeClassType[TypeClassType["ContractItem"] = 10] = "ContractItem";
                TypeClassType[TypeClassType["Contract"] = 11] = "Contract";
                TypeClassType[TypeClassType["Facility"] = 12] = "Facility";
                TypeClassType[TypeClassType["Host"] = 13] = "Host";
                TypeClassType[TypeClassType["Location"] = 14] = "Location";
                TypeClassType[TypeClassType["State"] = 15] = "State";
                TypeClassType[TypeClassType["Course"] = 16] = "Course";
                TypeClassType[TypeClassType["ProductCategory"] = 17] = "ProductCategory";
                TypeClassType[TypeClassType["ProductRelation"] = 18] = "ProductRelation";
                TypeClassType[TypeClassType["Section"] = 19] = "Section";
                TypeClassType[TypeClassType["ReleaseState"] = 20] = "ReleaseState";
                TypeClassType[TypeClassType["ChangeAction"] = 21] = "ChangeAction";
                TypeClassType[TypeClassType["Session"] = 22] = "Session";
                TypeClassType[TypeClassType["Term"] = 23] = "Term";
                TypeClassType[TypeClassType["Language"] = 24] = "Language";
                TypeClassType[TypeClassType["Currency"] = 25] = "Currency";
                TypeClassType[TypeClassType["AgeCheck"] = 28] = "AgeCheck";
                TypeClassType[TypeClassType["Region"] = 29] = "Region";
                TypeClassType[TypeClassType["UserType"] = 30] = "UserType";
                TypeClassType[TypeClassType["RegionRole"] = 31] = "RegionRole";
                TypeClassType[TypeClassType["TimeZone"] = 32] = "TimeZone";
                TypeClassType[TypeClassType["CourseDeposit"] = 33] = "CourseDeposit";
                TypeClassType[TypeClassType["TermThresholdDataCapacity"] = 34] = "TermThresholdDataCapacity";
                TypeClassType[TypeClassType["TermThresholdImportantDate"] = 35] = "TermThresholdImportantDate";
                TypeClassType[TypeClassType["TermThresholdCapacityManagementAlert"] = 36] = "TermThresholdCapacityManagementAlert";
                TypeClassType[TypeClassType["TermThresholdPaymentOption"] = 37] = "TermThresholdPaymentOption";
                TypeClassType[TypeClassType["RelativeRelation"] = 38] = "RelativeRelation";
                TypeClassType[TypeClassType["RelativeToItem"] = 39] = "RelativeToItem";
                TypeClassType[TypeClassType["DateType"] = 40] = "DateType";
                TypeClassType[TypeClassType["ComparisonOperator"] = 41] = "ComparisonOperator";
                TypeClassType[TypeClassType["LimitType"] = 42] = "LimitType";
                TypeClassType[TypeClassType["RoleCategory"] = 43] = "RoleCategory";
                TypeClassType[TypeClassType["PackageType"] = 44] = "PackageType";
                TypeClassType[TypeClassType["CourseSubCategory"] = 45] = "CourseSubCategory";
                TypeClassType[TypeClassType["EmployeeStatus"] = 47] = "EmployeeStatus";
                TypeClassType[TypeClassType["Discount"] = 49] = "Discount";
                TypeClassType[TypeClassType["ScheduleDefType"] = 51] = "ScheduleDefType";
                TypeClassType[TypeClassType["MultipleInstructors"] = 52] = "MultipleInstructors";
                TypeClassType[TypeClassType["ProductRatioType"] = 53] = "ProductRatioType";
                TypeClassType[TypeClassType["CompanyContactMethod"] = 54] = "CompanyContactMethod";
                TypeClassType[TypeClassType["AttributeDefName"] = 55] = "AttributeDefName";
                TypeClassType[TypeClassType["AttributeDataType"] = 56] = "AttributeDataType";
                TypeClassType[TypeClassType["DiscountValueType"] = 57] = "DiscountValueType";
                TypeClassType[TypeClassType["DiscountDateRelativeToItem"] = 58] = "DiscountDateRelativeToItem";
                TypeClassType[TypeClassType["HowHeardAbout"] = 59] = "HowHeardAbout";
                TypeClassType[TypeClassType["HowHeardAboutCategory"] = 60] = "HowHeardAboutCategory";
                TypeClassType[TypeClassType["HowHeardAboutAudience"] = 61] = "HowHeardAboutAudience";
                TypeClassType[TypeClassType["CreatedEvent"] = 62] = "CreatedEvent";
                TypeClassType[TypeClassType["DiscountDivisionRelationship"] = 63] = "DiscountDivisionRelationship";
                TypeClassType[TypeClassType["DiscountLimit"] = 64] = "DiscountLimit";
                TypeClassType[TypeClassType["ProductSubCategory"] = 65] = "ProductSubCategory";
                TypeClassType[TypeClassType["DiscountPaymentReq"] = 66] = "DiscountPaymentReq";
                TypeClassType[TypeClassType["InfoRequest"] = 67] = "InfoRequest";
                TypeClassType[TypeClassType["DiscountScheduleType"] = 68] = "DiscountScheduleType";
                TypeClassType[TypeClassType["FollowUpStatusType"] = 69] = "FollowUpStatusType";
                TypeClassType[TypeClassType["CanadaProvince"] = 70] = "CanadaProvince";
                TypeClassType[TypeClassType["RelatedProductType"] = 71] = "RelatedProductType";
                TypeClassType[TypeClassType["AddressVerificationStatus"] = 72] = "AddressVerificationStatus";
                TypeClassType[TypeClassType["FulfillmentStatusType"] = 73] = "FulfillmentStatusType";
                TypeClassType[TypeClassType["CourseRelatedProductInterest"] = 74] = "CourseRelatedProductInterest";
                TypeClassType[TypeClassType["TermThresholdCategoryType"] = 75] = "TermThresholdCategoryType";
                TypeClassType[TypeClassType["DiscountProductInclusionType"] = 76] = "DiscountProductInclusionType";
                TypeClassType[TypeClassType["DiscountBlanketRestriction"] = 77] = "DiscountBlanketRestriction";
                TypeClassType[TypeClassType["DiscountDiscountTypeRestriction"] = 78] = "DiscountDiscountTypeRestriction";
                TypeClassType[TypeClassType["ScheduleDetailType"] = 79] = "ScheduleDetailType";
                TypeClassType[TypeClassType["DiscountApplicableToward"] = 80] = "DiscountApplicableToward";
                TypeClassType[TypeClassType["OrderType"] = 81] = "OrderType";
                TypeClassType[TypeClassType["AgeRange"] = 82] = "AgeRange";
                TypeClassType[TypeClassType["ShirtSize"] = 84] = "ShirtSize";
                TypeClassType[TypeClassType["Suffix"] = 85] = "Suffix";
                TypeClassType[TypeClassType["AcctgTransactionActivity"] = 86] = "AcctgTransactionActivity";
                TypeClassType[TypeClassType["AcctgTransactionStatus"] = 87] = "AcctgTransactionStatus";
                TypeClassType[TypeClassType["OrderStatus"] = 88] = "OrderStatus";
                TypeClassType[TypeClassType["OrderDetailStatus"] = 89] = "OrderDetailStatus";
                TypeClassType[TypeClassType["OnlyType"] = 90] = "OnlyType";
                TypeClassType[TypeClassType["FeeAmountType"] = 91] = "FeeAmountType";
                TypeClassType[TypeClassType["FeeApplyType"] = 92] = "FeeApplyType";
                TypeClassType[TypeClassType["OrderUserRole"] = 93] = "OrderUserRole";
                TypeClassType[TypeClassType["PaymentType"] = 94] = "PaymentType";
                TypeClassType[TypeClassType["PaymentMethodType"] = 95] = "PaymentMethodType";
                TypeClassType[TypeClassType["CreditCardType"] = 96] = "CreditCardType";
                TypeClassType[TypeClassType["UserRelationship"] = 97] = "UserRelationship";
                TypeClassType[TypeClassType["OrderComment"] = 98] = "OrderComment";
                TypeClassType[TypeClassType["Gender"] = 99] = "Gender";
                TypeClassType[TypeClassType["ExtraActionItemType"] = 100] = "ExtraActionItemType";
                TypeClassType[TypeClassType["OnlyExtraResolutionType"] = 101] = "OnlyExtraResolutionType";
                TypeClassType[TypeClassType["RequestInterest"] = 102] = "RequestInterest";
                TypeClassType[TypeClassType["CourseInterest"] = 103] = "CourseInterest";
                TypeClassType[TypeClassType["AdjustmentCategoryType"] = 105] = "AdjustmentCategoryType";
                TypeClassType[TypeClassType["TermsAndConditionsType"] = 106] = "TermsAndConditionsType";
                TypeClassType[TypeClassType["Buddy"] = 107] = "Buddy";
                TypeClassType[TypeClassType["OrderDetailAdjustmentType"] = 108] = "OrderDetailAdjustmentType";
                TypeClassType[TypeClassType["FileType"] = 109] = "FileType";
                TypeClassType[TypeClassType["FileUsageType"] = 110] = "FileUsageType";
                TypeClassType[TypeClassType["FileFormat"] = 111] = "FileFormat";
                TypeClassType[TypeClassType["FileDirectoryType"] = 112] = "FileDirectoryType";
                TypeClassType[TypeClassType["OrderDetailDiscountStatusType"] = 119] = "OrderDetailDiscountStatusType";
                TypeClassType[TypeClassType["CouponRoleType"] = 122] = "CouponRoleType";
                TypeClassType[TypeClassType["CouponType"] = 126] = "CouponType";
                TypeClassType[TypeClassType["CancellationReason"] = 127] = "CancellationReason";
                TypeClassType[TypeClassType["RewardProgramType"] = 128] = "RewardProgramType";
                TypeClassType[TypeClassType["RewardType"] = 129] = "RewardType";
                TypeClassType[TypeClassType["CouponDetailType"] = 132] = "CouponDetailType";
                TypeClassType[TypeClassType["PaymentStatusType"] = 133] = "PaymentStatusType";
                TypeClassType[TypeClassType["ActionItemPriorityType"] = 134] = "ActionItemPriorityType";
                TypeClassType[TypeClassType["ActionItemCategoryType"] = 135] = "ActionItemCategoryType";
                TypeClassType[TypeClassType["CouponStatus"] = 136] = "CouponStatus";
                TypeClassType[TypeClassType["UserConfirmationType"] = 137] = "UserConfirmationType";
                TypeClassType[TypeClassType["VIPType"] = 138] = "VIPType";
                TypeClassType[TypeClassType["FormRequiredType"] = 139] = "FormRequiredType";
                TypeClassType[TypeClassType["FormCategoryType"] = 140] = "FormCategoryType";
                TypeClassType[TypeClassType["UserAccessRestrictionType"] = 141] = "UserAccessRestrictionType";
                TypeClassType[TypeClassType["RegistrationStatusType"] = 142] = "RegistrationStatusType";
                TypeClassType[TypeClassType["FormStatus"] = 143] = "FormStatus";
                TypeClassType[TypeClassType["SqlAgentTaskType"] = 144] = "SqlAgentTaskType";
                TypeClassType[TypeClassType["UserActivityStatusCode"] = 145] = "UserActivityStatusCode";
                TypeClassType[TypeClassType["ParticipantAgeRange"] = 146] = "ParticipantAgeRange";
                TypeClassType[TypeClassType["UserRoleLevel"] = 147] = "UserRoleLevel";
                TypeClassType[TypeClassType["CountryRegionType"] = 148] = "CountryRegionType";
                TypeClassType[TypeClassType["InfoRequestMethod"] = 149] = "InfoRequestMethod";
                TypeClassType[TypeClassType["AddressLabelType"] = 150] = "AddressLabelType";
                TypeClassType[TypeClassType["CampaignListType"] = 151] = "CampaignListType";
                TypeClassType[TypeClassType["SessionAvailabilityStatusType"] = 152] = "SessionAvailabilityStatusType";
                TypeClassType[TypeClassType["OverrideReasonType"] = 153] = "OverrideReasonType";
                TypeClassType[TypeClassType["CancellationCategoryType"] = 154] = "CancellationCategoryType";
                TypeClassType[TypeClassType["VoucherReasonType"] = 155] = "VoucherReasonType";
                TypeClassType[TypeClassType["CancellationReasonType"] = 127] = "CancellationReasonType";
                TypeClassType[TypeClassType["OverrideType"] = 156] = "OverrideType";
                TypeClassType[TypeClassType["ClientLogEntryType"] = 157] = "ClientLogEntryType";
                TypeClassType[TypeClassType["ClientIssueType"] = 158] = "ClientIssueType";
                TypeClassType[TypeClassType["ClientIssueStatusType"] = 159] = "ClientIssueStatusType";
                TypeClassType[TypeClassType["ClientIssueSeverityType"] = 160] = "ClientIssueSeverityType";
                TypeClassType[TypeClassType["ClientIssueSourceType"] = 161] = "ClientIssueSourceType";
                TypeClassType[TypeClassType["ClientLogTimePeriod"] = 162] = "ClientLogTimePeriod";
                TypeClassType[TypeClassType["ClientLogOwnerType"] = 163] = "ClientLogOwnerType";
                TypeClassType[TypeClassType["ClientIssueCategory"] = 164] = "ClientIssueCategory";
                TypeClassType[TypeClassType["ClientLogReviewStatus"] = 166] = "ClientLogReviewStatus";
                TypeClassType[TypeClassType["ActionItemCompletionStrategy"] = 167] = "ActionItemCompletionStrategy";
                TypeClassType[TypeClassType["ClientIssueResolutionCategory"] = 168] = "ClientIssueResolutionCategory";
                TypeClassType[TypeClassType["CampaignListDisplayFields"] = 169] = "CampaignListDisplayFields";
                TypeClassType[TypeClassType["CampaignListDisplayFieldSubsets"] = 170] = "CampaignListDisplayFieldSubsets";
                TypeClassType[TypeClassType["ClientLogRole"] = 171] = "ClientLogRole";
                TypeClassType[TypeClassType["Note"] = 172] = "Note";
                TypeClassType[TypeClassType["ClientLogAssignment"] = 173] = "ClientLogAssignment";
                TypeClassType[TypeClassType["StatementViewTransactionsType"] = 174] = "StatementViewTransactionsType";
                TypeClassType[TypeClassType["StatementViewTimePeriodType"] = 175] = "StatementViewTimePeriodType";
                TypeClassType[TypeClassType["ActionItemContactMethodType"] = 176] = "ActionItemContactMethodType";
                TypeClassType[TypeClassType["CorrespondenceUserRoleType"] = 177] = "CorrespondenceUserRoleType";
                TypeClassType[TypeClassType["FormSectionType"] = 178] = "FormSectionType";
                TypeClassType[TypeClassType["CouponReceivingOrganizationType"] = 179] = "CouponReceivingOrganizationType";
                TypeClassType[TypeClassType["CorrespondenceDirectionType"] = 180] = "CorrespondenceDirectionType";
                TypeClassType[TypeClassType["CorrespondenceContactType"] = 181] = "CorrespondenceContactType";
                TypeClassType[TypeClassType["CorrespondenceTopicType"] = 182] = "CorrespondenceTopicType";
                TypeClassType[TypeClassType["DiscountCategory"] = 183] = "DiscountCategory";
                TypeClassType[TypeClassType["CouponCategory"] = 185] = "CouponCategory";
                TypeClassType[TypeClassType["SecurityQuestionType"] = 186] = "SecurityQuestionType";
                TypeClassType[TypeClassType["CompanyAlias"] = 187] = "CompanyAlias";
                TypeClassType[TypeClassType["ReferenceContact"] = 188] = "ReferenceContact";
                TypeClassType[TypeClassType["ReferenceOK"] = 189] = "ReferenceOK";
                TypeClassType[TypeClassType["RefundPriority"] = 190] = "RefundPriority";
                TypeClassType[TypeClassType["RefundType"] = 191] = "RefundType";
                TypeClassType[TypeClassType["RefundStatus"] = 192] = "RefundStatus";
                TypeClassType[TypeClassType["InfoRequestMethodCategory"] = 194] = "InfoRequestMethodCategory";
                TypeClassType[TypeClassType["AnnouncementType"] = 195] = "AnnouncementType";
                TypeClassType[TypeClassType["OrderSource"] = 196] = "OrderSource";
                TypeClassType[TypeClassType["AllergyType"] = 197] = "AllergyType";
                TypeClassType[TypeClassType["ImmunizationType"] = 198] = "ImmunizationType";
                TypeClassType[TypeClassType["ImmunizationStatus"] = 199] = "ImmunizationStatus";
                TypeClassType[TypeClassType["InsuranceType"] = 200] = "InsuranceType";
                TypeClassType[TypeClassType["FormPersonRole"] = 201] = "FormPersonRole";
                TypeClassType[TypeClassType["SchoolGrade"] = 202] = "SchoolGrade";
                TypeClassType[TypeClassType["OrderCommentWorkflowStatusType"] = 203] = "OrderCommentWorkflowStatusType";
                TypeClassType[TypeClassType["MedicationTimeTaken"] = 204] = "MedicationTimeTaken";
                TypeClassType[TypeClassType["AttendanceType"] = 205] = "AttendanceType";
                TypeClassType[TypeClassType["TermGroupStatus"] = 206] = "TermGroupStatus";
                TypeClassType[TypeClassType["SurveyType"] = 207] = "SurveyType";
                TypeClassType[TypeClassType["SurveyAnswerFormat"] = 208] = "SurveyAnswerFormat";
                TypeClassType[TypeClassType["SurveyAnswerDataType"] = 209] = "SurveyAnswerDataType";
                TypeClassType[TypeClassType["SurveyAnswerCommentDispType"] = 210] = "SurveyAnswerCommentDispType";
                TypeClassType[TypeClassType["EquipmentReportType"] = 211] = "EquipmentReportType";
                TypeClassType[TypeClassType["EquipmentCategoryType"] = 212] = "EquipmentCategoryType";
                TypeClassType[TypeClassType["SupplyRequestStatus"] = 213] = "SupplyRequestStatus";
                TypeClassType[TypeClassType["SupplyCategoryType"] = 214] = "SupplyCategoryType";
                TypeClassType[TypeClassType["StatisticsAnswerType"] = 215] = "StatisticsAnswerType";
                TypeClassType[TypeClassType["StatisticsQuestionType"] = 216] = "StatisticsQuestionType";
                TypeClassType[TypeClassType["ProductImportantDateType"] = 217] = "ProductImportantDateType";
                TypeClassType[TypeClassType["ProductImportantDateStatusType"] = 218] = "ProductImportantDateStatusType";
                TypeClassType[TypeClassType["ProductImptDateRelativeToType"] = 219] = "ProductImptDateRelativeToType";
                TypeClassType[TypeClassType["ProductSkillType"] = 220] = "ProductSkillType";
                TypeClassType[TypeClassType["JobFLSACompensation"] = 221] = "JobFLSACompensation";
                TypeClassType[TypeClassType["JobClass"] = 222] = "JobClass";
                TypeClassType[TypeClassType["JobVisibility"] = 223] = "JobVisibility";
                TypeClassType[TypeClassType["UserAccountTypeMask"] = 224] = "UserAccountTypeMask";
                TypeClassType[TypeClassType["FormApplicationProcesssingStatus"] = 225] = "FormApplicationProcesssingStatus";
                TypeClassType[TypeClassType["Availability"] = 227] = "Availability";
                TypeClassType[TypeClassType["ProductDisplayConfig"] = 228] = "ProductDisplayConfig";
                TypeClassType[TypeClassType["JobResidencyPreference"] = 229] = "JobResidencyPreference";
                TypeClassType[TypeClassType["DiscountSubcategory"] = 230] = "DiscountSubcategory";
                TypeClassType[TypeClassType["SchoolDegree"] = 231] = "SchoolDegree";
                TypeClassType[TypeClassType["QAMeasurementType"] = 232] = "QAMeasurementType";
                TypeClassType[TypeClassType["FormProcessHistoryType"] = 233] = "FormProcessHistoryType";
                TypeClassType[TypeClassType["SavableSearchType"] = 234] = "SavableSearchType";
                TypeClassType[TypeClassType["SavableSearchCriteriaType"] = 235] = "SavableSearchCriteriaType";
                TypeClassType[TypeClassType["JobInterviewType"] = 236] = "JobInterviewType";
                TypeClassType[TypeClassType["HRLogCategoryType"] = 237] = "HRLogCategoryType";
                TypeClassType[TypeClassType["HRLogActionType"] = 238] = "HRLogActionType";
                TypeClassType[TypeClassType["JobInterviewStatusType"] = 239] = "JobInterviewStatusType";
                TypeClassType[TypeClassType["HRLogReasonType"] = 240] = "HRLogReasonType";
                TypeClassType[TypeClassType["LetterCategoryType"] = 241] = "LetterCategoryType";
                TypeClassType[TypeClassType["LetterType"] = 242] = "LetterType";
                TypeClassType[TypeClassType["ApplicationProcesssingStatusPublic"] = 243] = "ApplicationProcesssingStatusPublic";
                TypeClassType[TypeClassType["ApplicationProcessHistoryAction"] = 244] = "ApplicationProcessHistoryAction";
                TypeClassType[TypeClassType["HRLogEntry"] = 245] = "HRLogEntry";
                TypeClassType[TypeClassType["JobOfferStatus"] = 246] = "JobOfferStatus";
                TypeClassType[TypeClassType["JobOfferType"] = 247] = "JobOfferType";
                TypeClassType[TypeClassType["FormLocationUsageType"] = 248] = "FormLocationUsageType";
                TypeClassType[TypeClassType["DiscretionaryPayReason"] = 249] = "DiscretionaryPayReason";
                TypeClassType[TypeClassType["PayItem"] = 250] = "PayItem";
                TypeClassType[TypeClassType["PayItemDuration"] = 251] = "PayItemDuration";
                TypeClassType[TypeClassType["PayCalculation"] = 252] = "PayCalculation";
                TypeClassType[TypeClassType["FormCategoryGroup"] = 253] = "FormCategoryGroup";
                TypeClassType[TypeClassType["FileDirectoryUsage"] = 254] = "FileDirectoryUsage";
                TypeClassType[TypeClassType["ThresholdType"] = 255] = "ThresholdType";
                TypeClassType[TypeClassType["Acquaintance"] = 256] = "Acquaintance";
                TypeClassType[TypeClassType["AcquaintanceDuration"] = 257] = "AcquaintanceDuration";
                TypeClassType[TypeClassType["PayDisbursementOption"] = 258] = "PayDisbursementOption";
                TypeClassType[TypeClassType["Visa"] = 259] = "Visa";
                TypeClassType[TypeClassType["BankAccount"] = 260] = "BankAccount";
                TypeClassType[TypeClassType["VisaStatus"] = 261] = "VisaStatus";
                TypeClassType[TypeClassType["ProcessingStatusUsage"] = 262] = "ProcessingStatusUsage";
                TypeClassType[TypeClassType["ReferenceRating"] = 263] = "ReferenceRating";
                TypeClassType[TypeClassType["AvailabilityEnteredBy"] = 264] = "AvailabilityEnteredBy";
                TypeClassType[TypeClassType["StaffAssignmentPubStatus"] = 265] = "StaffAssignmentPubStatus";
                TypeClassType[TypeClassType["StaffAssignmentType"] = 266] = "StaffAssignmentType";
                TypeClassType[TypeClassType["GeographicRegion"] = 267] = "GeographicRegion";
                TypeClassType[TypeClassType["JobPurview"] = 268] = "JobPurview";
                TypeClassType[TypeClassType["JobGenre"] = 269] = "JobGenre";
                TypeClassType[TypeClassType["HousingReason"] = 270] = "HousingReason";
                TypeClassType[TypeClassType["UserRoleRequired"] = 271] = "UserRoleRequired";
                TypeClassType[TypeClassType["WorkFlowStatus"] = 272] = "WorkFlowStatus";
                TypeClassType[TypeClassType["FormPersonChange"] = 274] = "FormPersonChange";
                TypeClassType[TypeClassType["PayItemOffset"] = 275] = "PayItemOffset";
                TypeClassType[TypeClassType["DormRoomCapacity"] = 276] = "DormRoomCapacity";
                TypeClassType[TypeClassType["PayrollApprovalStatus"] = 277] = "PayrollApprovalStatus";
                TypeClassType[TypeClassType["PayrollCycle"] = 278] = "PayrollCycle";
                TypeClassType[TypeClassType["RelativeToItemGrouping"] = 280] = "RelativeToItemGrouping";
                TypeClassType[TypeClassType["SkillType"] = 281] = "SkillType";
                TypeClassType[TypeClassType["LocationContactUsage"] = 282] = "LocationContactUsage";
                TypeClassType[TypeClassType["LocationUserRole"] = 283] = "LocationUserRole";
                TypeClassType[TypeClassType["ShippingOption"] = 284] = "ShippingOption";
                TypeClassType[TypeClassType["ApplicationSearchStatusInternal"] = 285] = "ApplicationSearchStatusInternal";
                TypeClassType[TypeClassType["LSISection"] = 286] = "LSISection";
                TypeClassType[TypeClassType["AttendanceAction"] = 289] = "AttendanceAction";
                TypeClassType[TypeClassType["Checkpoint"] = 291] = "Checkpoint";
                TypeClassType[TypeClassType["DivisionText"] = 292] = "DivisionText";
                TypeClassType[TypeClassType["DiscountBannerUsageType"] = 293] = "DiscountBannerUsageType";
                TypeClassType[TypeClassType["ProductURLType"] = 294] = "ProductURLType";
                TypeClassType[TypeClassType["ProductGenre"] = 295] = "ProductGenre";
                TypeClassType[TypeClassType["ShirtSizeGroup"] = 296] = "ShirtSizeGroup";
                TypeClassType[TypeClassType["JobApprovalRequirement"] = 297] = "JobApprovalRequirement";
                TypeClassType[TypeClassType["TuitionAssistanceSalaryRange"] = 299] = "TuitionAssistanceSalaryRange";
                TypeClassType[TypeClassType["TuitionAssistanceStatus"] = 300] = "TuitionAssistanceStatus";
                TypeClassType[TypeClassType["TuitionAssistanceSubStatus"] = 301] = "TuitionAssistanceSubStatus";
                TypeClassType[TypeClassType["TuitionAssistanceLetterType"] = 302] = "TuitionAssistanceLetterType";
                TypeClassType[TypeClassType["StaffTaskCategory"] = 303] = "StaffTaskCategory";
                TypeClassType[TypeClassType["StaffTaskSchedule"] = 304] = "StaffTaskSchedule";
                TypeClassType[TypeClassType["StaffTaskUserStatus"] = 305] = "StaffTaskUserStatus";
                TypeClassType[TypeClassType["StaffTaskDisplayType"] = 306] = "StaffTaskDisplayType";
                TypeClassType[TypeClassType["DivisionProgramType"] = 307] = "DivisionProgramType";
                TypeClassType[TypeClassType["StudentActivityCategory"] = 308] = "StudentActivityCategory";
                TypeClassType[TypeClassType["StudentActivityNumOfPlayers"] = 309] = "StudentActivityNumOfPlayers";
                TypeClassType[TypeClassType["StudentActivityDuration"] = 310] = "StudentActivityDuration";
                TypeClassType[TypeClassType["StudentActivityProps"] = 311] = "StudentActivityProps";
                TypeClassType[TypeClassType["StudentActivityLocation"] = 312] = "StudentActivityLocation";
                TypeClassType[TypeClassType["TokenUsageType"] = 313] = "TokenUsageType";
                TypeClassType[TypeClassType["PhoneCarrier"] = 314] = "PhoneCarrier";
                TypeClassType[TypeClassType["EquipmentUsage"] = 315] = "EquipmentUsage";
                TypeClassType[TypeClassType["ClientIssueCategoryGrouping"] = 316] = "ClientIssueCategoryGrouping";
                TypeClassType[TypeClassType["SurveyTagTypeMask"] = 317] = "SurveyTagTypeMask";
                TypeClassType[TypeClassType["WaitListStatus"] = 318] = "WaitListStatus";
                TypeClassType[TypeClassType["ContactMethodCategory"] = 319] = "ContactMethodCategory";
                TypeClassType[TypeClassType["ProductTextUsage"] = 321] = "ProductTextUsage";
                TypeClassType[TypeClassType["JobScheduleType"] = 322] = "JobScheduleType";
                TypeClassType[TypeClassType["ProductSchedule"] = 323] = "ProductSchedule";
                TypeClassType[TypeClassType["StateSubRegion"] = 324] = "StateSubRegion";
                TypeClassType[TypeClassType["LocationSessionText"] = 325] = "LocationSessionText";
                TypeClassType[TypeClassType["CouponStatusForStaffReferral"] = 327] = "CouponStatusForStaffReferral";
                TypeClassType[TypeClassType["ImmunizationRefusal"] = 329] = "ImmunizationRefusal";
                TypeClassType[TypeClassType["ProductVisibility"] = 330] = "ProductVisibility";
                TypeClassType[TypeClassType["WSQueueActivity"] = 331] = "WSQueueActivity";
                TypeClassType[TypeClassType["WSQueueSyncTarget"] = 332] = "WSQueueSyncTarget";
                TypeClassType[TypeClassType["WSQueueAffectedTable"] = 333] = "WSQueueAffectedTable";
                TypeClassType[TypeClassType["SupplyOrLicenseRatio"] = 334] = "SupplyOrLicenseRatio";
                TypeClassType[TypeClassType["SupplyShipmentBox"] = 335] = "SupplyShipmentBox";
                TypeClassType[TypeClassType["SupplyItemReturn"] = 336] = "SupplyItemReturn";
                TypeClassType[TypeClassType["SupplyRequest"] = 337] = "SupplyRequest";
                TypeClassType[TypeClassType["CorrespondenceCreationType"] = 338] = "CorrespondenceCreationType";
                TypeClassType[TypeClassType["CorrespondenceAccessType"] = 339] = "CorrespondenceAccessType";
                TypeClassType[TypeClassType["MaritalStatus"] = 340] = "MaritalStatus";
                TypeClassType[TypeClassType["RegFlowProgressStep"] = 342] = "RegFlowProgressStep";
                TypeClassType[TypeClassType["SalesCatalog"] = 343] = "SalesCatalog";
                TypeClassType[TypeClassType["ShoppingAbandonmentEmailType"] = 344] = "ShoppingAbandonmentEmailType";
                TypeClassType[TypeClassType["RequestAmount"] = 347] = "RequestAmount";
                TypeClassType[TypeClassType["ShoppingCart"] = 348] = "ShoppingCart";
                TypeClassType[TypeClassType["AllergySeverityType"] = 352] = "AllergySeverityType";
                TypeClassType[TypeClassType["RoomOccupant"] = 354] = "RoomOccupant";
                TypeClassType[TypeClassType["RoomGender"] = 355] = "RoomGender";
                TypeClassType[TypeClassType["ResidencyOption"] = 356] = "ResidencyOption";
                TypeClassType[TypeClassType["UTMCreationTrigger"] = 358] = "UTMCreationTrigger";
                TypeClassType[TypeClassType["OfferOption"] = 359] = "OfferOption";
                TypeClassType[TypeClassType["SupplyRequestCategory"] = 360] = "SupplyRequestCategory";
                TypeClassType[TypeClassType["SupplyItemClass"] = 361] = "SupplyItemClass";
                TypeClassType[TypeClassType["EthnicOrigin"] = 362] = "EthnicOrigin";
                TypeClassType[TypeClassType["Race"] = 363] = "Race";
                TypeClassType[TypeClassType["UTMParamEvent"] = 364] = "UTMParamEvent";
                TypeClassType[TypeClassType["MetroArea"] = 365] = "MetroArea";
                TypeClassType[TypeClassType["CourseOptionGroup"] = 366] = "CourseOptionGroup";
                TypeClassType[TypeClassType["SupplyandLicenseRatioCategory"] = 368] = "SupplyandLicenseRatioCategory";
                TypeClassType[TypeClassType["LicenseItemCategory"] = 369] = "LicenseItemCategory";
                TypeClassType[TypeClassType["LicenseItemAssignmentTarget"] = 370] = "LicenseItemAssignmentTarget";
                TypeClassType[TypeClassType["LicenseItemStatus"] = 371] = "LicenseItemStatus";
                TypeClassType[TypeClassType["LicenseAssignmentRequestType"] = 372] = "LicenseAssignmentRequestType";
                TypeClassType[TypeClassType["OPLStatus"] = 373] = "OPLStatus";
                TypeClassType[TypeClassType["OPLSubject"] = 374] = "OPLSubject";
                TypeClassType[TypeClassType["CatalogType"] = 382] = "CatalogType";
                TypeClassType[TypeClassType["SectionStartStatus"] = 384] = "SectionStartStatus";
                TypeClassType[TypeClassType["UserAvailabilityStatus"] = 385] = "UserAvailabilityStatus";
                TypeClassType[TypeClassType["SkillURLUsageType"] = 386] = "SkillURLUsageType";
                TypeClassType[TypeClassType["SectionWorkFlowStatus"] = 394] = "SectionWorkFlowStatus";
                TypeClassType[TypeClassType["DomainMappingType"] = 396] = "DomainMappingType";
                TypeClassType[TypeClassType["GenderGroup"] = 397] = "GenderGroup";
                TypeClassType[TypeClassType["CovidManufacturerType"] = 402] = "CovidManufacturerType";
                TypeClassType[TypeClassType["BadgeCategoryType"] = 406] = "BadgeCategoryType";
                TypeClassType[TypeClassType["BadgeCalculationType"] = 407] = "BadgeCalculationType";
                TypeClassType[TypeClassType["BadgeImageType"] = 408] = "BadgeImageType";
                TypeClassType[TypeClassType["TipAccount"] = 409] = "TipAccount";
                TypeClassType[TypeClassType["ContactChannel"] = 410] = "ContactChannel";
            })(TypeClassType = Enums.TypeClassType || (Enums.TypeClassType = {}));
            var AcctgTransactionActivityType;
            (function (AcctgTransactionActivityType) {
                AcctgTransactionActivityType[AcctgTransactionActivityType["InitialPurchase"] = 86000] = "InitialPurchase";
                AcctgTransactionActivityType[AcctgTransactionActivityType["BalancePayment"] = 86001] = "BalancePayment";
                AcctgTransactionActivityType[AcctgTransactionActivityType["CreditIssued_Return"] = 86002] = "CreditIssued_Return";
                AcctgTransactionActivityType[AcctgTransactionActivityType["CreditIssued_Discount"] = 86003] = "CreditIssued_Discount";
                AcctgTransactionActivityType[AcctgTransactionActivityType["Refund"] = 86004] = "Refund";
                AcctgTransactionActivityType[AcctgTransactionActivityType["Reward"] = 86005] = "Reward";
                AcctgTransactionActivityType[AcctgTransactionActivityType["ApplyCredit"] = 86006] = "ApplyCredit";
                AcctgTransactionActivityType[AcctgTransactionActivityType["PaymentReversal"] = 86007] = "PaymentReversal";
                AcctgTransactionActivityType[AcctgTransactionActivityType["DiscountReversal"] = 86008] = "DiscountReversal";
                AcctgTransactionActivityType[AcctgTransactionActivityType["RewardReversal"] = 86009] = "RewardReversal";
            })(AcctgTransactionActivityType = Enums.AcctgTransactionActivityType || (Enums.AcctgTransactionActivityType = {}));
            var AcctgTransactionStatus;
            (function (AcctgTransactionStatus) {
                AcctgTransactionStatus[AcctgTransactionStatus["New"] = 87000] = "New";
                AcctgTransactionStatus[AcctgTransactionStatus["InProcess"] = 87001] = "InProcess";
                AcctgTransactionStatus[AcctgTransactionStatus["Success"] = 87002] = "Success";
                AcctgTransactionStatus[AcctgTransactionStatus["ActionRequired"] = 87003] = "ActionRequired";
                AcctgTransactionStatus[AcctgTransactionStatus["Failed"] = 87004] = "Failed";
                AcctgTransactionStatus[AcctgTransactionStatus["ActionTaken"] = 87005] = "ActionTaken";
            })(AcctgTransactionStatus = Enums.AcctgTransactionStatus || (Enums.AcctgTransactionStatus = {}));
            var Acquaintance;
            (function (Acquaintance) {
                Acquaintance[Acquaintance["CoWorker"] = 256000] = "CoWorker";
                Acquaintance[Acquaintance["Professor"] = 256001] = "Professor";
                Acquaintance[Acquaintance["Supervisor"] = 256002] = "Supervisor";
                Acquaintance[Acquaintance["Other"] = 256003] = "Other";
            })(Acquaintance = Enums.Acquaintance || (Enums.Acquaintance = {}));
            var AcquaintanceDuration;
            (function (AcquaintanceDuration) {
                AcquaintanceDuration[AcquaintanceDuration["OneToTwoMonths"] = 257000] = "OneToTwoMonths";
                AcquaintanceDuration[AcquaintanceDuration["ThreeToFiveMonths"] = 257001] = "ThreeToFiveMonths";
                AcquaintanceDuration[AcquaintanceDuration["SixToTwelveMonths"] = 257002] = "SixToTwelveMonths";
                AcquaintanceDuration[AcquaintanceDuration["OneOrMoreYears"] = 257003] = "OneOrMoreYears";
                AcquaintanceDuration[AcquaintanceDuration["FiveOrMoreYears"] = 257004] = "FiveOrMoreYears";
            })(AcquaintanceDuration = Enums.AcquaintanceDuration || (Enums.AcquaintanceDuration = {}));
            var ActionItemCompletionStrategy;
            (function (ActionItemCompletionStrategy) {
                ActionItemCompletionStrategy[ActionItemCompletionStrategy["InternallyWithoutClient"] = 167000] = "InternallyWithoutClient";
                ActionItemCompletionStrategy[ActionItemCompletionStrategy["ThroughCorrespondenceWithClient"] = 167001] = "ThroughCorrespondenceWithClient";
            })(ActionItemCompletionStrategy = Enums.ActionItemCompletionStrategy || (Enums.ActionItemCompletionStrategy = {}));
            var ActionItemCategoryType;
            (function (ActionItemCategoryType) {
                ActionItemCategoryType[ActionItemCategoryType["AdditionalRequiredForms"] = 135000] = "AdditionalRequiredForms";
                ActionItemCategoryType[ActionItemCategoryType["AtSessionChangesFees"] = 135001] = "AtSessionChangesFees";
                ActionItemCategoryType[ActionItemCategoryType["CarpoolChange"] = 135002] = "CarpoolChange";
                ActionItemCategoryType[ActionItemCategoryType["ClientIssue"] = 135003] = "ClientIssue";
                ActionItemCategoryType[ActionItemCategoryType["ClientInfoUpdateChange_Data_Payment"] = 135004] = "ClientInfoUpdateChange_Data_Payment";
                ActionItemCategoryType[ActionItemCategoryType["DiscountCreditsVouchers"] = 135005] = "DiscountCreditsVouchers";
                ActionItemCategoryType[ActionItemCategoryType["DocumentRequest"] = 135006] = "DocumentRequest";
                ActionItemCategoryType[ActionItemCategoryType["EmailBlast"] = 135007] = "EmailBlast";
                ActionItemCategoryType[ActionItemCategoryType["Feedback"] = 135008] = "Feedback";
                ActionItemCategoryType[ActionItemCategoryType["FeesCharges"] = 135009] = "FeesCharges";
                ActionItemCategoryType[ActionItemCategoryType["FridayMailer"] = 135010] = "FridayMailer";
                ActionItemCategoryType[ActionItemCategoryType["InappropriateConduct"] = 135011] = "InappropriateConduct";
                ActionItemCategoryType[ActionItemCategoryType["IncompleteChange"] = 135012] = "IncompleteChange";
                ActionItemCategoryType[ActionItemCategoryType["IncorrectData"] = 135013] = "IncorrectData";
                ActionItemCategoryType[ActionItemCategoryType["InventoryRequest"] = 135014] = "InventoryRequest";
                ActionItemCategoryType[ActionItemCategoryType["LocationFacilityInfo"] = 135015] = "LocationFacilityInfo";
                ActionItemCategoryType[ActionItemCategoryType["OnlyExtraSituation"] = 135016] = "OnlyExtraSituation";
                ActionItemCategoryType[ActionItemCategoryType["PayBalance"] = 135017] = "PayBalance";
                ActionItemCategoryType[ActionItemCategoryType["ProjectRequest"] = 135018] = "ProjectRequest";
                ActionItemCategoryType[ActionItemCategoryType["RequiredForms"] = 135019] = "RequiredForms";
                ActionItemCategoryType[ActionItemCategoryType["SessionSpecialRequest"] = 135020] = "SessionSpecialRequest";
                ActionItemCategoryType[ActionItemCategoryType["SessionLocationProductChange"] = 135021] = "SessionLocationProductChange";
                ActionItemCategoryType[ActionItemCategoryType["SessionMailerPaperwork"] = 135022] = "SessionMailerPaperwork";
                ActionItemCategoryType[ActionItemCategoryType["Statement"] = 135023] = "Statement";
                ActionItemCategoryType[ActionItemCategoryType["SystemAdmin"] = 135024] = "SystemAdmin";
                ActionItemCategoryType[ActionItemCategoryType["WaitingList"] = 135025] = "WaitingList";
                ActionItemCategoryType[ActionItemCategoryType["Other"] = 135026] = "Other";
                ActionItemCategoryType[ActionItemCategoryType["AtSessionIncompletePayment"] = 135027] = "AtSessionIncompletePayment";
            })(ActionItemCategoryType = Enums.ActionItemCategoryType || (Enums.ActionItemCategoryType = {}));
            var ActionItemContactMethodType;
            (function (ActionItemContactMethodType) {
                ActionItemContactMethodType[ActionItemContactMethodType["Phone"] = 176000] = "Phone";
                ActionItemContactMethodType[ActionItemContactMethodType["Email"] = 176001] = "Email";
                ActionItemContactMethodType[ActionItemContactMethodType["Other"] = 176002] = "Other";
            })(ActionItemContactMethodType = Enums.ActionItemContactMethodType || (Enums.ActionItemContactMethodType = {}));
            var ActionItemPriorityType;
            (function (ActionItemPriorityType) {
                ActionItemPriorityType[ActionItemPriorityType["Required"] = 134000] = "Required";
                ActionItemPriorityType[ActionItemPriorityType["Recommended"] = 134001] = "Recommended";
                ActionItemPriorityType[ActionItemPriorityType["ForStatusOnly"] = 134002] = "ForStatusOnly";
            })(ActionItemPriorityType = Enums.ActionItemPriorityType || (Enums.ActionItemPriorityType = {}));
            var AdjustmentCategoryType;
            (function (AdjustmentCategoryType) {
                AdjustmentCategoryType[AdjustmentCategoryType["Cost"] = 105000] = "Cost";
                AdjustmentCategoryType[AdjustmentCategoryType["Payment"] = 105001] = "Payment";
            })(AdjustmentCategoryType = Enums.AdjustmentCategoryType || (Enums.AdjustmentCategoryType = {}));
            var AddressLabelType;
            (function (AddressLabelType) {
                AddressLabelType[AddressLabelType["Avery5960"] = 150000] = "Avery5960";
                AddressLabelType[AddressLabelType["Avery5962"] = 150001] = "Avery5962";
            })(AddressLabelType = Enums.AddressLabelType || (Enums.AddressLabelType = {}));
            var AddressType;
            (function (AddressType) {
                AddressType[AddressType["Home"] = 6000] = "Home";
                AddressType[AddressType["Work"] = 6001] = "Work";
                AddressType[AddressType["Billing"] = 6002] = "Billing";
                AddressType[AddressType["Permanent"] = 6003] = "Permanent";
                AddressType[AddressType["Shipping"] = 6004] = "Shipping";
            })(AddressType = Enums.AddressType || (Enums.AddressType = {}));
            var AddressVerificationStatusType;
            (function (AddressVerificationStatusType) {
                AddressVerificationStatusType[AddressVerificationStatusType["NotVerified"] = 72000] = "NotVerified";
                AddressVerificationStatusType[AddressVerificationStatusType["VerifiedByUser"] = 72001] = "VerifiedByUser";
                AddressVerificationStatusType[AddressVerificationStatusType["VerifiedBySystem"] = 72002] = "VerifiedBySystem";
            })(AddressVerificationStatusType = Enums.AddressVerificationStatusType || (Enums.AddressVerificationStatusType = {}));
            var AgeCheckType;
            (function (AgeCheckType) {
                AgeCheckType[AgeCheckType["StartOfCalendarYear"] = 28000] = "StartOfCalendarYear";
                AgeCheckType[AgeCheckType["StartOfTerm"] = 28001] = "StartOfTerm";
                AgeCheckType[AgeCheckType["StartOfSession"] = 28002] = "StartOfSession";
                AgeCheckType[AgeCheckType["EndOfCalendarYear"] = 28003] = "EndOfCalendarYear";
                AgeCheckType[AgeCheckType["EndOfTerm"] = 28004] = "EndOfTerm";
                AgeCheckType[AgeCheckType["EndOfSession"] = 28005] = "EndOfSession";
                AgeCheckType[AgeCheckType["LastDayOnCampusInTheSession"] = 28006] = "LastDayOnCampusInTheSession";
            })(AgeCheckType = Enums.AgeCheckType || (Enums.AgeCheckType = {}));
            var AgeRangeType;
            (function (AgeRangeType) {
                AgeRangeType[AgeRangeType["CourseRecommender"] = 82000] = "CourseRecommender";
                AgeRangeType[AgeRangeType["CampAgeGroup"] = 82001] = "CampAgeGroup";
                AgeRangeType[AgeRangeType["DivisionSupported"] = 82002] = "DivisionSupported";
                AgeRangeType[AgeRangeType["DormRoom"] = 82003] = "DormRoom";
            })(AgeRangeType = Enums.AgeRangeType || (Enums.AgeRangeType = {}));
            var AllergyType;
            (function (AllergyType) {
                AllergyType[AllergyType["HayFever"] = 197000] = "HayFever";
                AllergyType[AllergyType["Asthma"] = 197001] = "Asthma";
                AllergyType[AllergyType["Eczema"] = 197002] = "Eczema";
                AllergyType[AllergyType["InsectStings"] = 197003] = "InsectStings";
                AllergyType[AllergyType["Peanuts"] = 197004] = "Peanuts";
                AllergyType[AllergyType["Other"] = 197005] = "Other";
                AllergyType[AllergyType["Gluten"] = 197006] = "Gluten";
                AllergyType[AllergyType["Dairy"] = 197007] = "Dairy";
                AllergyType[AllergyType["Eggs"] = 197008] = "Eggs";
                AllergyType[AllergyType["Meat"] = 197009] = "Meat";
                AllergyType[AllergyType["Nuts"] = 197010] = "Nuts";
                AllergyType[AllergyType["Food"] = 197011] = "Food";
            })(AllergyType = Enums.AllergyType || (Enums.AllergyType = {}));
            var AllergySeverityType;
            (function (AllergySeverityType) {
                AllergySeverityType[AllergySeverityType["Mild"] = 352000] = "Mild";
                AllergySeverityType[AllergySeverityType["Moderate"] = 352001] = "Moderate";
                AllergySeverityType[AllergySeverityType["Severe"] = 352002] = "Severe";
            })(AllergySeverityType = Enums.AllergySeverityType || (Enums.AllergySeverityType = {}));
            var AnnouncementType;
            (function (AnnouncementType) {
                AnnouncementType[AnnouncementType["WelcomeMessage"] = 195000] = "WelcomeMessage";
            })(AnnouncementType = Enums.AnnouncementType || (Enums.AnnouncementType = {}));
            var ApplicationProcessHistoryAction;
            (function (ApplicationProcessHistoryAction) {
                ApplicationProcessHistoryAction[ApplicationProcessHistoryAction["Claim"] = 244000] = "Claim";
                ApplicationProcessHistoryAction[ApplicationProcessHistoryAction["Unclaim"] = 244001] = "Unclaim";
                ApplicationProcessHistoryAction[ApplicationProcessHistoryAction["TransferOwnership"] = 244002] = "TransferOwnership";
            })(ApplicationProcessHistoryAction = Enums.ApplicationProcessHistoryAction || (Enums.ApplicationProcessHistoryAction = {}));
            var ApplicationSearchStatusInternal;
            (function (ApplicationSearchStatusInternal) {
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["New"] = 285000] = "New";
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["Claimed"] = 285001] = "Claimed";
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["InterviewPhase"] = 285002] = "InterviewPhase";
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["OfferPhase"] = 285003] = "OfferPhase";
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["PendingEmploymentPaperwork"] = 285004] = "PendingEmploymentPaperwork";
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["EmploymentPaperworkCompleted"] = 285005] = "EmploymentPaperworkCompleted";
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["ClearedForScheduling"] = 285006] = "ClearedForScheduling";
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["Scheduled"] = 285007] = "Scheduled";
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["Rejected"] = 285008] = "Rejected";
                ApplicationSearchStatusInternal[ApplicationSearchStatusInternal["Terminated"] = 285009] = "Terminated";
            })(ApplicationSearchStatusInternal = Enums.ApplicationSearchStatusInternal || (Enums.ApplicationSearchStatusInternal = {}));
            var AttendanceAction;
            (function (AttendanceAction) {
                AttendanceAction[AttendanceAction["CheckIn"] = 289000] = "CheckIn";
                AttendanceAction[AttendanceAction["CheckOut"] = 289001] = "CheckOut";
                AttendanceAction[AttendanceAction["MarkAbsent"] = 289002] = "MarkAbsent";
            })(AttendanceAction = Enums.AttendanceAction || (Enums.AttendanceAction = {}));
            var AttendanceType;
            (function (AttendanceType) {
                AttendanceType[AttendanceType["Absent"] = 205000] = "Absent";
                AttendanceType[AttendanceType["Present"] = 205001] = "Present";
                AttendanceType[AttendanceType["Late"] = 205002] = "Late";
            })(AttendanceType = Enums.AttendanceType || (Enums.AttendanceType = {}));
            var AttributeDataType;
            (function (AttributeDataType) {
                AttributeDataType[AttributeDataType["Integer"] = 56000] = "Integer";
                AttributeDataType[AttributeDataType["String"] = 56001] = "String";
                AttributeDataType[AttributeDataType["Boolean"] = 56002] = "Boolean";
                AttributeDataType[AttributeDataType["DateTime"] = 56003] = "DateTime";
                AttributeDataType[AttributeDataType["Money"] = 56004] = "Money";
            })(AttributeDataType = Enums.AttributeDataType || (Enums.AttributeDataType = {}));
            var AttributeDefNameType;
            (function (AttributeDefNameType) {
                AttributeDefNameType[AttributeDefNameType["DefaultMaxParticipants"] = 55000] = "DefaultMaxParticipants";
                AttributeDefNameType[AttributeDefNameType["DefaultMaxOvernight"] = 55001] = "DefaultMaxOvernight";
                AttributeDefNameType[AttributeDefNameType["DefaultMaxWeekend"] = 55002] = "DefaultMaxWeekend";
                AttributeDefNameType[AttributeDefNameType["DefaultMapsAndDirectionsUrl"] = 55003] = "DefaultMapsAndDirectionsUrl";
                AttributeDefNameType[AttributeDefNameType["DefaultLocationInfoUrl"] = 55004] = "DefaultLocationInfoUrl";
                AttributeDefNameType[AttributeDefNameType["DefaultPhotoURL"] = 55005] = "DefaultPhotoURL";
                AttributeDefNameType[AttributeDefNameType["DefaultMaxWeekendWithin"] = 55006] = "DefaultMaxWeekendWithin";
                AttributeDefNameType[AttributeDefNameType["LocationSessionNewAddEndDate"] = 55007] = "LocationSessionNewAddEndDate";
                AttributeDefNameType[AttributeDefNameType["LocationSessionChgCancelEndDate"] = 55008] = "LocationSessionChgCancelEndDate";
                AttributeDefNameType[AttributeDefNameType["JobLocationMapURL"] = 55009] = "JobLocationMapURL";
                AttributeDefNameType[AttributeDefNameType["AllowsRegistrations"] = 55010] = "AllowsRegistrations";
                AttributeDefNameType[AttributeDefNameType["HasTermStaff"] = 55011] = "HasTermStaff";
                AttributeDefNameType[AttributeDefNameType["FormVariant"] = 55012] = "FormVariant";
                AttributeDefNameType[AttributeDefNameType["FormIdentifier"] = 55013] = "FormIdentifier";
                AttributeDefNameType[AttributeDefNameType["JobGenreCount"] = 55014] = "JobGenreCount";
                AttributeDefNameType[AttributeDefNameType["OrientationStartDate"] = 55015] = "OrientationStartDate";
                AttributeDefNameType[AttributeDefNameType["OrientationLength"] = 55016] = "OrientationLength";
                AttributeDefNameType[AttributeDefNameType["SetUpStartDate"] = 55017] = "SetUpStartDate";
                AttributeDefNameType[AttributeDefNameType["SetUPLength"] = 55018] = "SetUPLength";
                AttributeDefNameType[AttributeDefNameType["EmergencyContactOtherPhone"] = 55019] = "EmergencyContactOtherPhone";
                AttributeDefNameType[AttributeDefNameType["EmergencyContactOtherName"] = 55020] = "EmergencyContactOtherName";
                AttributeDefNameType[AttributeDefNameType["ParkingPasses"] = 55021] = "ParkingPasses";
                AttributeDefNameType[AttributeDefNameType["BestParkingRatesStaff"] = 55022] = "BestParkingRatesStaff";
                AttributeDefNameType[AttributeDefNameType["BestParkingRatesFamilyShowcase"] = 55023] = "BestParkingRatesFamilyShowcase";
                AttributeDefNameType[AttributeDefNameType["BestParkingRatesPressVisits"] = 55024] = "BestParkingRatesPressVisits";
                AttributeDefNameType[AttributeDefNameType["BestParkingLotsLab"] = 55025] = "BestParkingLotsLab";
                AttributeDefNameType[AttributeDefNameType["BestParkingLotsResidenceHall"] = 55026] = "BestParkingLotsResidenceHall";
                AttributeDefNameType[AttributeDefNameType["ParkingConsiderationsCheckInOut"] = 55027] = "ParkingConsiderationsCheckInOut";
                AttributeDefNameType[AttributeDefNameType["PostDirectionalSigns"] = 55028] = "PostDirectionalSigns";
                AttributeDefNameType[AttributeDefNameType["ConstructionThatEffectsParkingOrCheckInOut"] = 55029] = "ConstructionThatEffectsParkingOrCheckInOut";
                AttributeDefNameType[AttributeDefNameType["RecentSecurityIssues"] = 55030] = "RecentSecurityIssues";
                AttributeDefNameType[AttributeDefNameType["SpecialFormsRequired"] = 55031] = "SpecialFormsRequired";
                AttributeDefNameType[AttributeDefNameType["MailroomHours"] = 55032] = "MailroomHours";
                AttributeDefNameType[AttributeDefNameType["VerizonCellPhonesReception"] = 55033] = "VerizonCellPhonesReception";
                AttributeDefNameType[AttributeDefNameType["IndoorspaceForFamilyShowcase"] = 55034] = "IndoorspaceForFamilyShowcase";
                AttributeDefNameType[AttributeDefNameType["Accesstosupplystorage"] = 55035] = "Accesstosupplystorage";
                AttributeDefNameType[AttributeDefNameType["TvDvdPlayerInResidenceHall"] = 55036] = "TvDvdPlayerInResidenceHall";
                AttributeDefNameType[AttributeDefNameType["DistanceFromTheDropoffPickupLocationToLabs"] = 55037] = "DistanceFromTheDropoffPickupLocationToLabs";
                AttributeDefNameType[AttributeDefNameType["DistanceFromLabsToDorms"] = 55038] = "DistanceFromLabsToDorms";
                AttributeDefNameType[AttributeDefNameType["DistanceFromDiningHallToDorms"] = 55039] = "DistanceFromDiningHallToDorms";
                AttributeDefNameType[AttributeDefNameType["DistanceFromDiningHallToLabs"] = 55040] = "DistanceFromDiningHallToLabs";
                AttributeDefNameType[AttributeDefNameType["SportsFieldsOrGrassyAreas"] = 55041] = "SportsFieldsOrGrassyAreas";
                AttributeDefNameType[AttributeDefNameType["IsSportsFieldGrassyAreaOnCampus"] = 55042] = "IsSportsFieldGrassyAreaOnCampus";
                AttributeDefNameType[AttributeDefNameType["BasketballCourt"] = 55043] = "BasketballCourt";
                AttributeDefNameType[AttributeDefNameType["SwimmingPool"] = 55044] = "SwimmingPool";
                AttributeDefNameType[AttributeDefNameType["Volleyball"] = 55045] = "Volleyball";
                AttributeDefNameType[AttributeDefNameType["GymOrRecreationCenter"] = 55046] = "GymOrRecreationCenter";
                AttributeDefNameType[AttributeDefNameType["Bowling"] = 55047] = "Bowling";
                AttributeDefNameType[AttributeDefNameType["Arcade"] = 55048] = "Arcade";
                AttributeDefNameType[AttributeDefNameType["PoolHall"] = 55049] = "PoolHall";
                AttributeDefNameType[AttributeDefNameType["CoffeeShop"] = 55050] = "CoffeeShop";
                AttributeDefNameType[AttributeDefNameType["YogurtOrIceCreamShop"] = 55051] = "YogurtOrIceCreamShop";
                AttributeDefNameType[AttributeDefNameType["Bookstore"] = 55052] = "Bookstore";
                AttributeDefNameType[AttributeDefNameType["Shopping"] = 55053] = "Shopping";
                AttributeDefNameType[AttributeDefNameType["CampusTours"] = 55054] = "CampusTours";
                AttributeDefNameType[AttributeDefNameType["ScienceCenterOrMuseum"] = 55055] = "ScienceCenterOrMuseum";
                AttributeDefNameType[AttributeDefNameType["ImaxTheatre"] = 55056] = "ImaxTheatre";
                AttributeDefNameType[AttributeDefNameType["EarlyStaffArrivalDate"] = 55057] = "EarlyStaffArrivalDate";
                AttributeDefNameType[AttributeDefNameType["MediaAllowed"] = 55058] = "MediaAllowed";
                AttributeDefNameType[AttributeDefNameType["MediaParkingPass"] = 55059] = "MediaParkingPass";
                AttributeDefNameType[AttributeDefNameType["BestParkingForMedia"] = 55060] = "BestParkingForMedia";
                AttributeDefNameType[AttributeDefNameType["OffCampusDayTrips"] = 55061] = "OffCampusDayTrips";
                AttributeDefNameType[AttributeDefNameType["PassesForAccessToGymsPoolsEtc"] = 55062] = "PassesForAccessToGymsPoolsEtc";
                AttributeDefNameType[AttributeDefNameType["HandyStoresNearby"] = 55063] = "HandyStoresNearby";
                AttributeDefNameType[AttributeDefNameType["RestaurantsNearby"] = 55064] = "RestaurantsNearby";
                AttributeDefNameType[AttributeDefNameType["WeekendActivities"] = 55065] = "WeekendActivities";
                AttributeDefNameType[AttributeDefNameType["DoesItRainOftenInSummer"] = 55066] = "DoesItRainOftenInSummer";
                AttributeDefNameType[AttributeDefNameType["EarliestLargeShipmentArrivalDate"] = 55067] = "EarliestLargeShipmentArrivalDate";
                AttributeDefNameType[AttributeDefNameType["CampSupplyStorageLocation"] = 55068] = "CampSupplyStorageLocation";
                AttributeDefNameType[AttributeDefNameType["CampSupplyStorageToLabTransportation"] = 55069] = "CampSupplyStorageToLabTransportation";
                AttributeDefNameType[AttributeDefNameType["HowManySingleRooms"] = 55070] = "HowManySingleRooms";
                AttributeDefNameType[AttributeDefNameType["HowManyDoubleRooms"] = 55071] = "HowManyDoubleRooms";
                AttributeDefNameType[AttributeDefNameType["HowManyTripleRooms"] = 55072] = "HowManyTripleRooms";
                AttributeDefNameType[AttributeDefNameType["HowManyQuadRooms"] = 55073] = "HowManyQuadRooms";
                AttributeDefNameType[AttributeDefNameType["TotalOfBeds"] = 55074] = "TotalOfBeds";
                AttributeDefNameType[AttributeDefNameType["AirConditionedRooms"] = 55075] = "AirConditionedRooms";
                AttributeDefNameType[AttributeDefNameType["BathroomsAreShared"] = 55076] = "BathroomsAreShared";
                AttributeDefNameType[AttributeDefNameType["MattressSize"] = 55077] = "MattressSize";
                AttributeDefNameType[AttributeDefNameType["WheelchairAccessibleRoomsAvailable"] = 55078] = "WheelchairAccessibleRoomsAvailable";
                AttributeDefNameType[AttributeDefNameType["HowOftenAreTheRoomsCleaned"] = 55079] = "HowOftenAreTheRoomsCleaned";
                AttributeDefNameType[AttributeDefNameType["DoorLocks"] = 55080] = "DoorLocks";
                AttributeDefNameType[AttributeDefNameType["ArelinensIncluded"] = 55081] = "ArelinensIncluded";
                AttributeDefNameType[AttributeDefNameType["WhichLinensAreProvided"] = 55082] = "WhichLinensAreProvided";
                AttributeDefNameType[AttributeDefNameType["LimitedLinensPossible"] = 55083] = "LimitedLinensPossible";
                AttributeDefNameType[AttributeDefNameType["SodaSnackMachines"] = 55084] = "SodaSnackMachines";
                AttributeDefNameType[AttributeDefNameType["WasherDryerAccess"] = 55085] = "WasherDryerAccess";
                AttributeDefNameType[AttributeDefNameType["AdditionalNotes"] = 55086] = "AdditionalNotes";
                AttributeDefNameType[AttributeDefNameType["DiningHallBreakfastHours"] = 55087] = "DiningHallBreakfastHours";
                AttributeDefNameType[AttributeDefNameType["DiningHallLunchHours"] = 55088] = "DiningHallLunchHours";
                AttributeDefNameType[AttributeDefNameType["DiningHallDinnerHours"] = 55089] = "DiningHallDinnerHours";
                AttributeDefNameType[AttributeDefNameType["DiningHallOtherhours"] = 55090] = "DiningHallOtherhours";
                AttributeDefNameType[AttributeDefNameType["BuffetAllYouCanEat"] = 55091] = "BuffetAllYouCanEat";
                AttributeDefNameType[AttributeDefNameType["VegetarianOptions"] = 55092] = "VegetarianOptions";
                AttributeDefNameType[AttributeDefNameType["KosherOptions"] = 55093] = "KosherOptions";
                AttributeDefNameType[AttributeDefNameType["GlutenFreeOptions"] = 55094] = "GlutenFreeOptions";
                AttributeDefNameType[AttributeDefNameType["CanDiningHallAccommodateAllergies"] = 55095] = "CanDiningHallAccommodateAllergies";
                AttributeDefNameType[AttributeDefNameType["WillDiningBeOpen4thOfJuly"] = 55096] = "WillDiningBeOpen4thOfJuly";
                AttributeDefNameType[AttributeDefNameType["MealCountSystem"] = 55097] = "MealCountSystem";
                AttributeDefNameType[AttributeDefNameType["OutsideFoodAllowedSundayAndFriday"] = 55098] = "OutsideFoodAllowedSundayAndFriday";
                AttributeDefNameType[AttributeDefNameType["AreBagLunchesAllowedInTheDiningHall"] = 55099] = "AreBagLunchesAllowedInTheDiningHall";
                AttributeDefNameType[AttributeDefNameType["RefrigeratorAccess"] = 55100] = "RefrigeratorAccess";
                AttributeDefNameType[AttributeDefNameType["CanLunchBePurchased"] = 55101] = "CanLunchBePurchased";
                AttributeDefNameType[AttributeDefNameType["Labhoursaccessibletostaff"] = 55102] = "Labhoursaccessibletostaff";
                AttributeDefNameType[AttributeDefNameType["LabHoursAccessibleToComputerSetupTeardown"] = 55103] = "LabHoursAccessibleToComputerSetupTeardown";
                AttributeDefNameType[AttributeDefNameType["WalkingDistanceBetweenLabs"] = 55104] = "WalkingDistanceBetweenLabs";
                AttributeDefNameType[AttributeDefNameType["DateAccessToSpaceIsNeeded"] = 55105] = "DateAccessToSpaceIsNeeded";
                AttributeDefNameType[AttributeDefNameType["WillWeBeIssuedKeyForRooms"] = 55106] = "WillWeBeIssuedKeyForRooms";
                AttributeDefNameType[AttributeDefNameType["WillTablesAndChairsWillBeProvidedByUniversity"] = 55107] = "WillTablesAndChairsWillBeProvidedByUniversity";
                AttributeDefNameType[AttributeDefNameType["WillAnyoneElseHaveAccessToTheRooms"] = 55108] = "WillAnyoneElseHaveAccessToTheRooms";
                AttributeDefNameType[AttributeDefNameType["DimensionsOfTheTables"] = 55109] = "DimensionsOfTheTables";
                AttributeDefNameType[AttributeDefNameType["CandecorationsBePutOnWalls"] = 55110] = "CandecorationsBePutOnWalls";
                AttributeDefNameType[AttributeDefNameType["WillAccessBeLimitedOnJuly4th"] = 55111] = "WillAccessBeLimitedOnJuly4th";
                AttributeDefNameType[AttributeDefNameType["AdditionalLabNotes"] = 55112] = "AdditionalLabNotes";
                AttributeDefNameType[AttributeDefNameType["WillElectricianMeetUsForComputerSetup"] = 55113] = "WillElectricianMeetUsForComputerSetup";
                AttributeDefNameType[AttributeDefNameType["DoYouProvideIPAddressesForOurComputers"] = 55114] = "DoYouProvideIPAddressesForOurComputers";
                AttributeDefNameType[AttributeDefNameType["DHCPorOther"] = 55115] = "DHCPorOther";
                AttributeDefNameType[AttributeDefNameType["AnythingThatWeNeedtoProvide"] = 55116] = "AnythingThatWeNeedtoProvide";
                AttributeDefNameType[AttributeDefNameType["ParkingPassNeeded"] = 55117] = "ParkingPassNeeded";
                AttributeDefNameType[AttributeDefNameType["WhoWillProvideTheParkingPass"] = 55118] = "WhoWillProvideTheParkingPass";
                AttributeDefNameType[AttributeDefNameType["IsThereaLoadingDockAvailable"] = 55119] = "IsThereaLoadingDockAvailable";
                AttributeDefNameType[AttributeDefNameType["WhatParkingLotShouldMTUse"] = 55120] = "WhatParkingLotShouldMTUse";
                AttributeDefNameType[AttributeDefNameType["IsThereSpecificEntranceThatMTShouldUse"] = 55121] = "IsThereSpecificEntranceThatMTShouldUse";
                AttributeDefNameType[AttributeDefNameType["WillThereBeAnElevator"] = 55122] = "WillThereBeAnElevator";
                AttributeDefNameType[AttributeDefNameType["AirConditioned"] = 55123] = "AirConditioned";
                AttributeDefNameType[AttributeDefNameType["IsTheSpaceWheelchairAccessible"] = 55124] = "IsTheSpaceWheelchairAccessible";
                AttributeDefNameType[AttributeDefNameType["DirectorStationBuildingAndRoom"] = 55125] = "DirectorStationBuildingAndRoom";
                AttributeDefNameType[AttributeDefNameType["EthernetWallPortCount"] = 55126] = "EthernetWallPortCount";
                AttributeDefNameType[AttributeDefNameType["CircuitAmps"] = 55127] = "CircuitAmps";
                AttributeDefNameType[AttributeDefNameType["CircuitOutlets"] = 55128] = "CircuitOutlets";
                AttributeDefNameType[AttributeDefNameType["CircuitNotesComments"] = 55129] = "CircuitNotesComments";
                AttributeDefNameType[AttributeDefNameType["ElectricalSchematicwillbeprovided"] = 55130] = "ElectricalSchematicwillbeprovided";
                AttributeDefNameType[AttributeDefNameType["FloorPlanwillbeprovided"] = 55131] = "FloorPlanwillbeprovided";
                AttributeDefNameType[AttributeDefNameType["DefaultAlertTitle"] = 55141] = "DefaultAlertTitle";
                AttributeDefNameType[AttributeDefNameType["DefaultAlertNotes"] = 55142] = "DefaultAlertNotes";
                AttributeDefNameType[AttributeDefNameType["LocationSessionMealAddEndDate"] = 55153] = "LocationSessionMealAddEndDate";
                AttributeDefNameType[AttributeDefNameType["LocationSessionResidencyAddEndDate"] = 55154] = "LocationSessionResidencyAddEndDate";
            })(AttributeDefNameType = Enums.AttributeDefNameType || (Enums.AttributeDefNameType = {}));
            var Availability;
            (function (Availability) {
                Availability[Availability["Available"] = 227000] = "Available";
                Availability[Availability["Unavailable"] = 227001] = "Unavailable";
            })(Availability = Enums.Availability || (Enums.Availability = {}));
            var AvailabilityEnteredBy;
            (function (AvailabilityEnteredBy) {
                AvailabilityEnteredBy[AvailabilityEnteredBy["ApplicantEmployee"] = 264000] = "ApplicantEmployee";
                AvailabilityEnteredBy[AvailabilityEnteredBy["HiringManagerOrAdmin"] = 264001] = "HiringManagerOrAdmin";
            })(AvailabilityEnteredBy = Enums.AvailabilityEnteredBy || (Enums.AvailabilityEnteredBy = {}));
            var BadgeCategoryType;
            (function (BadgeCategoryType) {
                BadgeCategoryType[BadgeCategoryType["OPL"] = 406000] = "OPL";
            })(BadgeCategoryType = Enums.BadgeCategoryType || (Enums.BadgeCategoryType = {}));
            var BadgeCalculationType;
            (function (BadgeCalculationType) {
                BadgeCalculationType[BadgeCalculationType["OPLCompletedLessonCount"] = 407000] = "OPLCompletedLessonCount";
            })(BadgeCalculationType = Enums.BadgeCalculationType || (Enums.BadgeCalculationType = {}));
            var BadgeImageType;
            (function (BadgeImageType) {
                BadgeImageType[BadgeImageType["Awarded"] = 408000] = "Awarded";
                BadgeImageType[BadgeImageType["NotYetEarned"] = 408001] = "NotYetEarned";
            })(BadgeImageType = Enums.BadgeImageType || (Enums.BadgeImageType = {}));
            var BankAccount;
            (function (BankAccount) {
                BankAccount[BankAccount["Checking"] = 260000] = "Checking";
                BankAccount[BankAccount["Savings"] = 260001] = "Savings";
            })(BankAccount = Enums.BankAccount || (Enums.BankAccount = {}));
            var BuddyType;
            (function (BuddyType) {
                BuddyType[BuddyType["GroupWith"] = 107000] = "GroupWith";
                BuddyType[BuddyType["RoomWith"] = 107001] = "RoomWith";
            })(BuddyType = Enums.BuddyType || (Enums.BuddyType = {}));
            var UserBrowsingNoteType;
            (function (UserBrowsingNoteType) {
                UserBrowsingNoteType[UserBrowsingNoteType["GroupWith"] = 383000] = "GroupWith";
            })(UserBrowsingNoteType = Enums.UserBrowsingNoteType || (Enums.UserBrowsingNoteType = {}));
            var CancellationCategoryType;
            (function (CancellationCategoryType) {
                CancellationCategoryType[CancellationCategoryType["Customer"] = 154000] = "Customer";
                CancellationCategoryType[CancellationCategoryType["CustomerService"] = 154001] = "CustomerService";
            })(CancellationCategoryType = Enums.CancellationCategoryType || (Enums.CancellationCategoryType = {}));
            var CancellationReasonType;
            (function (CancellationReasonType) {
                CancellationReasonType[CancellationReasonType["UnpaidBalance"] = 127010] = "UnpaidBalance";
                CancellationReasonType[CancellationReasonType["CSAdjustmentReturn"] = 127014] = "CSAdjustmentReturn";
                CancellationReasonType[CancellationReasonType["Covid19"] = 127015] = "Covid19";
            })(CancellationReasonType = Enums.CancellationReasonType || (Enums.CancellationReasonType = {}));
            var CampaignListDisplayFields;
            (function (CampaignListDisplayFields) {
                CampaignListDisplayFields[CampaignListDisplayFields["ParticipantAccountNumber"] = 169000] = "ParticipantAccountNumber";
                CampaignListDisplayFields[CampaignListDisplayFields["ParticipantFirstName"] = 169001] = "ParticipantFirstName";
                CampaignListDisplayFields[CampaignListDisplayFields["ParticipantLastName"] = 169002] = "ParticipantLastName";
                CampaignListDisplayFields[CampaignListDisplayFields["ParticipantMiddleInitial"] = 169003] = "ParticipantMiddleInitial";
                CampaignListDisplayFields[CampaignListDisplayFields["ParticipantDOB"] = 169004] = "ParticipantDOB";
                CampaignListDisplayFields[CampaignListDisplayFields["ParticipantAgeToday"] = 169005] = "ParticipantAgeToday";
                CampaignListDisplayFields[CampaignListDisplayFields["ParticipantGender"] = 169006] = "ParticipantGender";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultFirstName"] = 169007] = "AdultFirstName";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultLastName"] = 169008] = "AdultLastName";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultAccountNumber"] = 169009] = "AdultAccountNumber";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultUserName"] = 169010] = "AdultUserName";
                CampaignListDisplayFields[CampaignListDisplayFields["Relationship"] = 169011] = "Relationship";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultHomePhone"] = 169012] = "AdultHomePhone";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultWorkPhone"] = 169013] = "AdultWorkPhone";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultCellPhone"] = 169014] = "AdultCellPhone";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultFax"] = 169015] = "AdultFax";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultEmail"] = 169016] = "AdultEmail";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultEmailOK"] = 169017] = "AdultEmailOK";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultAddress"] = 169018] = "AdultAddress";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultAddress2"] = 169019] = "AdultAddress2";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultCity"] = 169020] = "AdultCity";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultStateProvince"] = 169021] = "AdultStateProvince";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultPostalCode"] = 169022] = "AdultPostalCode";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultCountry"] = 169023] = "AdultCountry";
                CampaignListDisplayFields[CampaignListDisplayFields["AdultMailingOK"] = 169024] = "AdultMailingOK";
                CampaignListDisplayFields[CampaignListDisplayFields["AccessRestriction"] = 169025] = "AccessRestriction";
                CampaignListDisplayFields[CampaignListDisplayFields["CatalogRequestDate"] = 169026] = "CatalogRequestDate";
                CampaignListDisplayFields[CampaignListDisplayFields["iDOnsiteRequestDate"] = 169027] = "iDOnsiteRequestDate";
                CampaignListDisplayFields[CampaignListDisplayFields["AccountCreationDate"] = 169028] = "AccountCreationDate";
                CampaignListDisplayFields[CampaignListDisplayFields["HowHeardAbout"] = 169029] = "HowHeardAbout";
                CampaignListDisplayFields[CampaignListDisplayFields["VerificationStatus"] = 169030] = "VerificationStatus";
                CampaignListDisplayFields[CampaignListDisplayFields["LastVerificationDate"] = 169031] = "LastVerificationDate";
            })(CampaignListDisplayFields = Enums.CampaignListDisplayFields || (Enums.CampaignListDisplayFields = {}));
            var CampaignListDisplayFieldSubsets;
            (function (CampaignListDisplayFieldSubsets) {
                CampaignListDisplayFieldSubsets[CampaignListDisplayFieldSubsets["ClientDisplayList"] = 170000] = "ClientDisplayList";
                CampaignListDisplayFieldSubsets[CampaignListDisplayFieldSubsets["ProspectDisplayList"] = 170001] = "ProspectDisplayList";
            })(CampaignListDisplayFieldSubsets = Enums.CampaignListDisplayFieldSubsets || (Enums.CampaignListDisplayFieldSubsets = {}));
            var CampaignListType;
            (function (CampaignListType) {
                CampaignListType[CampaignListType["Mailings"] = 151000] = "Mailings";
                CampaignListType[CampaignListType["EmailBlast"] = 151001] = "EmailBlast";
                CampaignListType[CampaignListType["PressInquiry"] = 151002] = "PressInquiry";
                CampaignListType[CampaignListType["CatalogMailing"] = 151003] = "CatalogMailing";
            })(CampaignListType = Enums.CampaignListType || (Enums.CampaignListType = {}));
            var CanadaProvinceType;
            (function (CanadaProvinceType) {
                CanadaProvinceType[CanadaProvinceType["AB"] = 70009] = "AB";
                CanadaProvinceType[CanadaProvinceType["BC"] = 70006] = "BC";
                CanadaProvinceType[CanadaProvinceType["MB"] = 70005] = "MB";
                CanadaProvinceType[CanadaProvinceType["NB"] = 70004] = "NB";
                CanadaProvinceType[CanadaProvinceType["NL"] = 70010] = "NL";
                CanadaProvinceType[CanadaProvinceType["NS"] = 70003] = "NS";
                CanadaProvinceType[CanadaProvinceType["NT"] = 70011] = "NT";
                CanadaProvinceType[CanadaProvinceType["NU"] = 70013] = "NU";
                CanadaProvinceType[CanadaProvinceType["ON"] = 70000] = "ON";
                CanadaProvinceType[CanadaProvinceType["PE"] = 70007] = "PE";
                CanadaProvinceType[CanadaProvinceType["QC"] = 70001] = "QC";
                CanadaProvinceType[CanadaProvinceType["SK"] = 70008] = "SK";
                CanadaProvinceType[CanadaProvinceType["YT"] = 70012] = "YT";
            })(CanadaProvinceType = Enums.CanadaProvinceType || (Enums.CanadaProvinceType = {}));
            var CancellationReason;
            (function (CancellationReason) {
                CancellationReason[CancellationReason["StudentSick"] = 127000] = "StudentSick";
                CancellationReason[CancellationReason["SchedulingConflict"] = 127001] = "SchedulingConflict";
                CancellationReason[CancellationReason["FamilyEmergency"] = 127002] = "FamilyEmergency";
                CancellationReason[CancellationReason["MedicalCondition"] = 127003] = "MedicalCondition";
                CancellationReason[CancellationReason["FemaleOnly"] = 127004] = "FemaleOnly";
                CancellationReason[CancellationReason["CourseOnly"] = 127005] = "CourseOnly";
                CancellationReason[CancellationReason["TravelingAbroad"] = 127006] = "TravelingAbroad";
                CancellationReason[CancellationReason["FinancialHardship"] = 127007] = "FinancialHardship";
                CancellationReason[CancellationReason["UnhappyWithServiceAtCamp"] = 127008] = "UnhappyWithServiceAtCamp";
                CancellationReason[CancellationReason["DoNotAgreeToTandC"] = 127009] = "DoNotAgreeToTandC";
                CancellationReason[CancellationReason["UnpaidBalance"] = 127010] = "UnpaidBalance";
                CancellationReason[CancellationReason["IncompleteRequiredForms"] = 127011] = "IncompleteRequiredForms";
                CancellationReason[CancellationReason["NoReason"] = 127012] = "NoReason";
            })(CancellationReason = Enums.CancellationReason || (Enums.CancellationReason = {}));
            var ChangePurchasedOrderType;
            (function (ChangePurchasedOrderType) {
                ChangePurchasedOrderType[ChangePurchasedOrderType["ChangeLocation"] = 1] = "ChangeLocation";
                ChangePurchasedOrderType[ChangePurchasedOrderType["ChangeSessionDate"] = 2] = "ChangeSessionDate";
                ChangePurchasedOrderType[ChangePurchasedOrderType["ChangeCourseSession"] = 3] = "ChangeCourseSession";
                ChangePurchasedOrderType[ChangePurchasedOrderType["ChangeOptionsOnly"] = 4] = "ChangeOptionsOnly";
                ChangePurchasedOrderType[ChangePurchasedOrderType["Cancel"] = 5] = "Cancel";
                ChangePurchasedOrderType[ChangePurchasedOrderType["AddNew"] = 6] = "AddNew";
            })(ChangePurchasedOrderType = Enums.ChangePurchasedOrderType || (Enums.ChangePurchasedOrderType = {}));
            var CheckpointType;
            (function (CheckpointType) {
                CheckpointType[CheckpointType["StudentCSR"] = 291000] = "StudentCSR";
                CheckpointType[CheckpointType["StaffCSR"] = 291001] = "StaffCSR";
                CheckpointType[CheckpointType["StaffEarlyArrival"] = 291002] = "StaffEarlyArrival";
                CheckpointType[CheckpointType["StaffRooming"] = 291003] = "StaffRooming";
            })(CheckpointType = Enums.CheckpointType || (Enums.CheckpointType = {}));
            var ClientIssueCategory;
            (function (ClientIssueCategory) {
                ClientIssueCategory[ClientIssueCategory["Instructor"] = 164000] = "Instructor";
                ClientIssueCategory[ClientIssueCategory["Other"] = 164001] = "Other";
            })(ClientIssueCategory = Enums.ClientIssueCategory || (Enums.ClientIssueCategory = {}));
            var ClientIssueCategoryGrouping;
            (function (ClientIssueCategoryGrouping) {
                ClientIssueCategoryGrouping[ClientIssueCategoryGrouping["RM_EvalManagement"] = 316000] = "RM_EvalManagement";
            })(ClientIssueCategoryGrouping = Enums.ClientIssueCategoryGrouping || (Enums.ClientIssueCategoryGrouping = {}));
            var ClientIssueResolutionCategory;
            (function (ClientIssueResolutionCategory) {
                ClientIssueResolutionCategory[ClientIssueResolutionCategory["TalkedToInstructor"] = 168000] = "TalkedToInstructor";
                ClientIssueResolutionCategory[ClientIssueResolutionCategory["TalkedToDirector"] = 168001] = "TalkedToDirector";
                ClientIssueResolutionCategory[ClientIssueResolutionCategory["ChangedToDifferentProduct"] = 168002] = "ChangedToDifferentProduct";
                ClientIssueResolutionCategory[ClientIssueResolutionCategory["Voucher"] = 168003] = "Voucher";
                ClientIssueResolutionCategory[ClientIssueResolutionCategory["Refund"] = 168004] = "Refund";
                ClientIssueResolutionCategory[ClientIssueResolutionCategory["Other"] = 168005] = "Other";
            })(ClientIssueResolutionCategory = Enums.ClientIssueResolutionCategory || (Enums.ClientIssueResolutionCategory = {}));
            var ClientIssueStatusType;
            (function (ClientIssueStatusType) {
                ClientIssueStatusType[ClientIssueStatusType["New"] = 159000] = "New";
                ClientIssueStatusType[ClientIssueStatusType["InProgress"] = 159001] = "InProgress";
                ClientIssueStatusType[ClientIssueStatusType["RequiresCSMgtReview"] = 159002] = "RequiresCSMgtReview";
                ClientIssueStatusType[ClientIssueStatusType["EscalateToManager"] = 159003] = "EscalateToManager";
                ClientIssueStatusType[ClientIssueStatusType["EscalateToRegionalManager"] = 159004] = "EscalateToRegionalManager";
                ClientIssueStatusType[ClientIssueStatusType["ProposedResolutionInProgress"] = 159005] = "ProposedResolutionInProgress";
                ClientIssueStatusType[ClientIssueStatusType["Closed"] = 159006] = "Closed";
            })(ClientIssueStatusType = Enums.ClientIssueStatusType || (Enums.ClientIssueStatusType = {}));
            var ClientIssueSeverityType;
            (function (ClientIssueSeverityType) {
                ClientIssueSeverityType[ClientIssueSeverityType["None"] = 160000] = "None";
                ClientIssueSeverityType[ClientIssueSeverityType["Low"] = 160001] = "Low";
                ClientIssueSeverityType[ClientIssueSeverityType["Standard"] = 160002] = "Standard";
                ClientIssueSeverityType[ClientIssueSeverityType["High"] = 160003] = "High";
                ClientIssueSeverityType[ClientIssueSeverityType["Critical"] = 160004] = "Critical";
            })(ClientIssueSeverityType = Enums.ClientIssueSeverityType || (Enums.ClientIssueSeverityType = {}));
            var ClientIssueSourceType;
            (function (ClientIssueSourceType) {
                ClientIssueSourceType[ClientIssueSourceType["DirectPhoneCall"] = 161000] = "DirectPhoneCall";
                ClientIssueSourceType[ClientIssueSourceType["ParentEvaluation"] = 161009] = "ParentEvaluation";
                ClientIssueSourceType[ClientIssueSourceType["StudentEvaluation"] = 161011] = "StudentEvaluation";
            })(ClientIssueSourceType = Enums.ClientIssueSourceType || (Enums.ClientIssueSourceType = {}));
            var ClientIssueType;
            (function (ClientIssueType) {
                ClientIssueType[ClientIssueType["Concern"] = 158000] = "Concern";
                ClientIssueType[ClientIssueType["Suggestion"] = 158001] = "Suggestion";
            })(ClientIssueType = Enums.ClientIssueType || (Enums.ClientIssueType = {}));
            var ClientLogAssignmentType;
            (function (ClientLogAssignmentType) {
                ClientLogAssignmentType[ClientLogAssignmentType["CSManager"] = 173000] = "CSManager";
                ClientLogAssignmentType[ClientLogAssignmentType["RegionalManager"] = 173001] = "RegionalManager";
                ClientLogAssignmentType[ClientLogAssignmentType["Unassigned"] = 173002] = "Unassigned";
            })(ClientLogAssignmentType = Enums.ClientLogAssignmentType || (Enums.ClientLogAssignmentType = {}));
            var ClientLogEntryType;
            (function (ClientLogEntryType) {
                ClientLogEntryType[ClientLogEntryType["ClientIssue"] = 157000] = "ClientIssue";
                ClientLogEntryType[ClientLogEntryType["ActionIssue"] = 157001] = "ActionIssue";
            })(ClientLogEntryType = Enums.ClientLogEntryType || (Enums.ClientLogEntryType = {}));
            var ClientLogOwnerType;
            (function (ClientLogOwnerType) {
                ClientLogOwnerType[ClientLogOwnerType["Individual"] = 163000] = "Individual";
                ClientLogOwnerType[ClientLogOwnerType["Position"] = 163001] = "Position";
            })(ClientLogOwnerType = Enums.ClientLogOwnerType || (Enums.ClientLogOwnerType = {}));
            var ClientLogRoleType;
            (function (ClientLogRoleType) {
                ClientLogRoleType[ClientLogRoleType["ConcernedClient"] = 171000] = "ConcernedClient";
                ClientLogRoleType[ClientLogRoleType["InvolvedParticipant"] = 171001] = "InvolvedParticipant";
                ClientLogRoleType[ClientLogRoleType["IssueOwner"] = 171002] = "IssueOwner";
                ClientLogRoleType[ClientLogRoleType["ClosedByUser"] = 171003] = "ClosedByUser";
                ClientLogRoleType[ClientLogRoleType["ToBeCompletedBy"] = 171004] = "ToBeCompletedBy";
                ClientLogRoleType[ClientLogRoleType["ActionItemClient"] = 171005] = "ActionItemClient";
                ClientLogRoleType[ClientLogRoleType["ReviewedBy"] = 171006] = "ReviewedBy";
                ClientLogRoleType[ClientLogRoleType["ClientInContext"] = 171007] = "ClientInContext";
            })(ClientLogRoleType = Enums.ClientLogRoleType || (Enums.ClientLogRoleType = {}));
            var ClientLogTimePeriod;
            (function (ClientLogTimePeriod) {
                ClientLogTimePeriod[ClientLogTimePeriod["BeforeSession"] = 162000] = "BeforeSession";
                ClientLogTimePeriod[ClientLogTimePeriod["DuringSession"] = 162001] = "DuringSession";
                ClientLogTimePeriod[ClientLogTimePeriod["AfterSession"] = 162002] = "AfterSession";
            })(ClientLogTimePeriod = Enums.ClientLogTimePeriod || (Enums.ClientLogTimePeriod = {}));
            var ClientLogReviewStatus;
            (function (ClientLogReviewStatus) {
                ClientLogReviewStatus[ClientLogReviewStatus["NotReviewed"] = 166000] = "NotReviewed";
                ClientLogReviewStatus[ClientLogReviewStatus["Reviewed"] = 166001] = "Reviewed";
            })(ClientLogReviewStatus = Enums.ClientLogReviewStatus || (Enums.ClientLogReviewStatus = {}));
            var CompanyAliasType;
            (function (CompanyAliasType) {
                CompanyAliasType[CompanyAliasType["PublicCompanyName"] = 187000] = "PublicCompanyName";
                CompanyAliasType[CompanyAliasType["SubBrand2Singular"] = 187001] = "SubBrand2Singular";
                CompanyAliasType[CompanyAliasType["SubBrand2Plural"] = 187002] = "SubBrand2Plural";
            })(CompanyAliasType = Enums.CompanyAliasType || (Enums.CompanyAliasType = {}));
            var CompanyContactMethodType;
            (function (CompanyContactMethodType) {
                CompanyContactMethodType[CompanyContactMethodType["Email"] = 54000] = "Email";
                CompanyContactMethodType[CompanyContactMethodType["Phone"] = 54001] = "Phone";
                CompanyContactMethodType[CompanyContactMethodType["PhoneInternational"] = 54002] = "PhoneInternational";
                CompanyContactMethodType[CompanyContactMethodType["Fax"] = 54003] = "Fax";
                CompanyContactMethodType[CompanyContactMethodType["PhoneTollFree"] = 54004] = "PhoneTollFree";
                CompanyContactMethodType[CompanyContactMethodType["InternalTechSupportEmail"] = 54005] = "InternalTechSupportEmail";
                CompanyContactMethodType[CompanyContactMethodType["DoNotReplyEmail"] = 54006] = "DoNotReplyEmail";
            })(CompanyContactMethodType = Enums.CompanyContactMethodType || (Enums.CompanyContactMethodType = {}));
            var CompanyType;
            (function (CompanyType) {
                CompanyType[CompanyType["TopLevel"] = 3000] = "TopLevel";
                CompanyType[CompanyType["Subsidiary"] = 3001] = "Subsidiary";
                CompanyType[CompanyType["Partner"] = 3002] = "Partner";
                CompanyType[CompanyType["Licensee"] = 3003] = "Licensee";
                CompanyType[CompanyType["VendorSupplier"] = 3004] = "VendorSupplier";
                CompanyType[CompanyType["Host"] = 3005] = "Host";
                CompanyType[CompanyType["CampAdvisor"] = 3006] = "CampAdvisor";
                CompanyType[CompanyType["ContractElectronicReferralSource"] = 3007] = "ContractElectronicReferralSource";
            })(CompanyType = Enums.CompanyType || (Enums.CompanyType = {}));
            var ComparisonOperator;
            (function (ComparisonOperator) {
                ComparisonOperator[ComparisonOperator["Equals"] = 41000] = "Equals";
                ComparisonOperator[ComparisonOperator["LessThan"] = 41001] = "LessThan";
                ComparisonOperator[ComparisonOperator["GreaterThan"] = 41002] = "GreaterThan";
                ComparisonOperator[ComparisonOperator["LessThanEquals"] = 41003] = "LessThanEquals";
                ComparisonOperator[ComparisonOperator["GreaterThanEquals"] = 41004] = "GreaterThanEquals";
            })(ComparisonOperator = Enums.ComparisonOperator || (Enums.ComparisonOperator = {}));
            var ContactChannel;
            (function (ContactChannel) {
                ContactChannel[ContactChannel["TechEducationInsights_Email"] = 410000] = "TechEducationInsights_Email";
                ContactChannel[ContactChannel["ProgramNewsOffers_Email"] = 410001] = "ProgramNewsOffers_Email";
                ContactChannel[ContactChannel["ProgramNewsOffers_SMS"] = 410002] = "ProgramNewsOffers_SMS";
                ContactChannel[ContactChannel["TransactionalSMS"] = 410003] = "TransactionalSMS";
                ContactChannel[ContactChannel["ProgramNewsOffers_Mail"] = 410004] = "ProgramNewsOffers_Mail";
                ContactChannel[ContactChannel["EventInvitesUpdates_Email"] = 410005] = "EventInvitesUpdates_Email";
                ContactChannel[ContactChannel["ReferralProgressReports_Email"] = 410006] = "ReferralProgressReports_Email";
            })(ContactChannel = Enums.ContactChannel || (Enums.ContactChannel = {}));
            var ContactMethodType;
            (function (ContactMethodType) {
                ContactMethodType[ContactMethodType["HomePhone"] = 7000] = "HomePhone";
                ContactMethodType[ContactMethodType["OfficePhone"] = 7001] = "OfficePhone";
                ContactMethodType[ContactMethodType["CellPhone"] = 7002] = "CellPhone";
                ContactMethodType[ContactMethodType["Fax"] = 7003] = "Fax";
                ContactMethodType[ContactMethodType["Email"] = 7004] = "Email";
                ContactMethodType[ContactMethodType["URL"] = 7005] = "URL";
                ContactMethodType[ContactMethodType["Other"] = 7006] = "Other";
                ContactMethodType[ContactMethodType["EmergencyPhone"] = 7007] = "EmergencyPhone";
            })(ContactMethodType = Enums.ContactMethodType || (Enums.ContactMethodType = {}));
            var ContactMethodCategory;
            (function (ContactMethodCategory) {
                ContactMethodCategory[ContactMethodCategory["PhoneNumbers"] = 319000] = "PhoneNumbers";
            })(ContactMethodCategory = Enums.ContactMethodCategory || (Enums.ContactMethodCategory = {}));
            var CorrespondenceContactType;
            (function (CorrespondenceContactType) {
                CorrespondenceContactType[CorrespondenceContactType["PhoneCall"] = 181000] = "PhoneCall";
                CorrespondenceContactType[CorrespondenceContactType["Voicemail"] = 181001] = "Voicemail";
                CorrespondenceContactType[CorrespondenceContactType["Email"] = 181002] = "Email";
                CorrespondenceContactType[CorrespondenceContactType["Fax"] = 181003] = "Fax";
                CorrespondenceContactType[CorrespondenceContactType["Mail"] = 181004] = "Mail";
                CorrespondenceContactType[CorrespondenceContactType["WalkIn"] = 181005] = "WalkIn";
                CorrespondenceContactType[CorrespondenceContactType["SocialMedia"] = 181006] = "SocialMedia";
            })(CorrespondenceContactType = Enums.CorrespondenceContactType || (Enums.CorrespondenceContactType = {}));
            var CorrespondenceDirectionType;
            (function (CorrespondenceDirectionType) {
                CorrespondenceDirectionType[CorrespondenceDirectionType["Incoming"] = 180000] = "Incoming";
                CorrespondenceDirectionType[CorrespondenceDirectionType["Outgoing"] = 180001] = "Outgoing";
            })(CorrespondenceDirectionType = Enums.CorrespondenceDirectionType || (Enums.CorrespondenceDirectionType = {}));
            var CorrespondenceTopicType;
            (function (CorrespondenceTopicType) {
                CorrespondenceTopicType[CorrespondenceTopicType["AddSession"] = 182000] = "AddSession";
                CorrespondenceTopicType[CorrespondenceTopicType["AddOrRemoveMealPlan"] = 182001] = "AddOrRemoveMealPlan";
                CorrespondenceTopicType[CorrespondenceTopicType["AddOrRemoveResidency"] = 182002] = "AddOrRemoveResidency";
                CorrespondenceTopicType[CorrespondenceTopicType["Cancellation"] = 182003] = "Cancellation";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeBillingInfo"] = 182004] = "ChangeBillingInfo";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeCarpool"] = 182005] = "ChangeCarpool";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeContactInfo"] = 182006] = "ChangeContactInfo";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeCourse"] = 182007] = "ChangeCourse";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeLocation"] = 182008] = "ChangeLocation";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeMealPlan"] = 182009] = "ChangeMealPlan";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeResidency"] = 182010] = "ChangeResidency";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeSession"] = 182011] = "ChangeSession";
                CorrespondenceTopicType[CorrespondenceTopicType["ClientReferenceProgram"] = 182012] = "ClientReferenceProgram";
                CorrespondenceTopicType[CorrespondenceTopicType["ClientIssue"] = 182013] = "ClientIssue";
                CorrespondenceTopicType[CorrespondenceTopicType["WelcomePacket"] = 182014] = "WelcomePacket";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailRequiredForms"] = 182015] = "EmailRequiredForms";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailClientReferenceProgram"] = 182016] = "EmailClientReferenceProgram";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailPromotional"] = 182017] = "EmailPromotional";
                CorrespondenceTopicType[CorrespondenceTopicType["TechRocket"] = 182018] = "TechRocket";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailAnnouncement"] = 182019] = "EmailAnnouncement";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailBalanceDue"] = 182020] = "EmailBalanceDue";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailFeedback"] = 182021] = "EmailFeedback";
                CorrespondenceTopicType[CorrespondenceTopicType["Feedback"] = 182022] = "Feedback";
                CorrespondenceTopicType[CorrespondenceTopicType["FormsRequiredForms"] = 182023] = "FormsRequiredForms";
                CorrespondenceTopicType[CorrespondenceTopicType["FormsAdditionalRequiredForms"] = 182024] = "FormsAdditionalRequiredForms";
                CorrespondenceTopicType[CorrespondenceTopicType["GeneralInfo"] = 182025] = "GeneralInfo";
                CorrespondenceTopicType[CorrespondenceTopicType["InappropriateConduct"] = 182026] = "InappropriateConduct";
                CorrespondenceTopicType[CorrespondenceTopicType["LocationOrFacilityquestions"] = 182027] = "LocationOrFacilityquestions";
                CorrespondenceTopicType[CorrespondenceTopicType["MapsAndDrivingDirections"] = 182028] = "MapsAndDrivingDirections";
                CorrespondenceTopicType[CorrespondenceTopicType["OnlyOrExtraSituation"] = 182029] = "OnlyOrExtraSituation";
                CorrespondenceTopicType[CorrespondenceTopicType["ParticipantProject"] = 182030] = "ParticipantProject";
                CorrespondenceTopicType[CorrespondenceTopicType["PayBalance"] = 182031] = "PayBalance";
                CorrespondenceTopicType[CorrespondenceTopicType["RefundsOrCredits"] = 182032] = "RefundsOrCredits";
                CorrespondenceTopicType[CorrespondenceTopicType["StaffReferralRebate"] = 182033] = "StaffReferralRebate";
                CorrespondenceTopicType[CorrespondenceTopicType["Statement"] = 182034] = "Statement";
                CorrespondenceTopicType[CorrespondenceTopicType["Other"] = 182035] = "Other";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailBalanceOverdue1"] = 182036] = "EmailBalanceOverdue1";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailBalanceOverdue2"] = 182037] = "EmailBalanceOverdue2";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailBalanceOverdue3"] = 182038] = "EmailBalanceOverdue3";
                CorrespondenceTopicType[CorrespondenceTopicType["EmailBalanceOverdue4"] = 182039] = "EmailBalanceOverdue4";
                CorrespondenceTopicType[CorrespondenceTopicType["Unsubscribed"] = 182040] = "Unsubscribed";
                CorrespondenceTopicType[CorrespondenceTopicType["AtSessionAttendance"] = 182041] = "AtSessionAttendance";
                CorrespondenceTopicType[CorrespondenceTopicType["SessionMailer"] = 182042] = "SessionMailer";
                CorrespondenceTopicType[CorrespondenceTopicType["SubscriptionAutoRenewSuccess"] = 182043] = "SubscriptionAutoRenewSuccess";
                CorrespondenceTopicType[CorrespondenceTopicType["SubscriptionAutoRenewFailure"] = 182044] = "SubscriptionAutoRenewFailure";
                CorrespondenceTopicType[CorrespondenceTopicType["SubscriptionAutoRenewReminder2"] = 182045] = "SubscriptionAutoRenewReminder2";
                CorrespondenceTopicType[CorrespondenceTopicType["SubscriptionAutoRenewReminder1"] = 182046] = "SubscriptionAutoRenewReminder1";
                CorrespondenceTopicType[CorrespondenceTopicType["SubscriptionStdExpiryReminder2"] = 182047] = "SubscriptionStdExpiryReminder2";
                CorrespondenceTopicType[CorrespondenceTopicType["SubscriptionStdExpiryReminder1"] = 182048] = "SubscriptionStdExpiryReminder1";
                CorrespondenceTopicType[CorrespondenceTopicType["SubscriptionExpiration"] = 182049] = "SubscriptionExpiration";
                CorrespondenceTopicType[CorrespondenceTopicType["Fee"] = 182050] = "Fee";
                CorrespondenceTopicType[CorrespondenceTopicType["TBD2"] = 182051] = "TBD2";
                CorrespondenceTopicType[CorrespondenceTopicType["AtSessionMedicationScheduleChange"] = 182052] = "AtSessionMedicationScheduleChange";
                CorrespondenceTopicType[CorrespondenceTopicType["AtSessionNotetoParent"] = 182053] = "AtSessionNotetoParent";
                CorrespondenceTopicType[CorrespondenceTopicType["AgeException"] = 182054] = "AgeException";
                CorrespondenceTopicType[CorrespondenceTopicType["BGCForms"] = 182055] = "BGCForms";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeSecurityInformation"] = 182056] = "ChangeSecurityInformation";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeStudentInformation"] = 182057] = "ChangeStudentInformation";
                CorrespondenceTopicType[CorrespondenceTopicType["CheckinCheckout"] = 182058] = "CheckinCheckout";
                CorrespondenceTopicType[CorrespondenceTopicType["CoursePreRequisites"] = 182059] = "CoursePreRequisites";
                CorrespondenceTopicType[CorrespondenceTopicType["Discounts"] = 182060] = "Discounts";
                CorrespondenceTopicType[CorrespondenceTopicType["LoginAssistance"] = 182061] = "LoginAssistance";
                CorrespondenceTopicType[CorrespondenceTopicType["PaymentException"] = 182062] = "PaymentException";
                CorrespondenceTopicType[CorrespondenceTopicType["RoommateRequest"] = 182063] = "RoommateRequest";
                CorrespondenceTopicType[CorrespondenceTopicType["TAPOrScholarships"] = 182064] = "TAPOrScholarships";
                CorrespondenceTopicType[CorrespondenceTopicType["TShirtSize"] = 182065] = "TShirtSize";
                CorrespondenceTopicType[CorrespondenceTopicType["Waitlist"] = 182066] = "Waitlist";
                CorrespondenceTopicType[CorrespondenceTopicType["ClientContactRequest"] = 182067] = "ClientContactRequest";
                CorrespondenceTopicType[CorrespondenceTopicType["AccessedAccount"] = 182068] = "AccessedAccount";
                CorrespondenceTopicType[CorrespondenceTopicType["GroupWithRequest"] = 182069] = "GroupWithRequest";
                CorrespondenceTopicType[CorrespondenceTopicType["ConnectStudent"] = 182070] = "ConnectStudent";
                CorrespondenceTopicType[CorrespondenceTopicType["ChangeStudentRelationship"] = 182071] = "ChangeStudentRelationship";
                CorrespondenceTopicType[CorrespondenceTopicType["ResetUserActivity"] = 182072] = "ResetUserActivity";
                CorrespondenceTopicType[CorrespondenceTopicType["MedicAppTextMessage"] = 182073] = "MedicAppTextMessage";
                CorrespondenceTopicType[CorrespondenceTopicType["MedicAppAddMedication"] = 182074] = "MedicAppAddMedication";
                CorrespondenceTopicType[CorrespondenceTopicType["MedicAppChangeMedication"] = 182075] = "MedicAppChangeMedication";
                CorrespondenceTopicType[CorrespondenceTopicType["MedicAppRemoveMedication"] = 182076] = "MedicAppRemoveMedication";
            })(CorrespondenceTopicType = Enums.CorrespondenceTopicType || (Enums.CorrespondenceTopicType = {}));
            var CorrespondenceUserRoleType;
            (function (CorrespondenceUserRoleType) {
                CorrespondenceUserRoleType[CorrespondenceUserRoleType["Client"] = 177000] = "Client";
                CorrespondenceUserRoleType[CorrespondenceUserRoleType["InvolvedParticipant"] = 177001] = "InvolvedParticipant";
                CorrespondenceUserRoleType[CorrespondenceUserRoleType["OtherInvolvedPerson"] = 177002] = "OtherInvolvedPerson";
                CorrespondenceUserRoleType[CorrespondenceUserRoleType["Admin"] = 177003] = "Admin";
                CorrespondenceUserRoleType[CorrespondenceUserRoleType["Reviewer"] = 177004] = "Reviewer";
                CorrespondenceUserRoleType[CorrespondenceUserRoleType["ClientInContext"] = 177005] = "ClientInContext";
            })(CorrespondenceUserRoleType = Enums.CorrespondenceUserRoleType || (Enums.CorrespondenceUserRoleType = {}));
            var CouponCategory;
            (function (CouponCategory) {
                CouponCategory[CouponCategory["Coupon"] = 185000] = "Coupon";
            })(CouponCategory = Enums.CouponCategory || (Enums.CouponCategory = {}));
            var CouponDetailType;
            (function (CouponDetailType) {
                CouponDetailType[CouponDetailType["StudentName"] = 132000] = "StudentName";
                CouponDetailType[CouponDetailType["ParentName"] = 132001] = "ParentName";
                CouponDetailType[CouponDetailType["ParentEmail"] = 132002] = "ParentEmail";
                CouponDetailType[CouponDetailType["InvalidReason"] = 132003] = "InvalidReason";
                CouponDetailType[CouponDetailType["Note"] = 132004] = "Note";
                CouponDetailType[CouponDetailType["SequenceNumber"] = 132005] = "SequenceNumber";
                CouponDetailType[CouponDetailType["SponsoringOrganization"] = 132006] = "SponsoringOrganization";
                CouponDetailType[CouponDetailType["ReceivingOrganizationOrEvent"] = 132007] = "ReceivingOrganizationOrEvent";
                CouponDetailType[CouponDetailType["Description"] = 132008] = "Description";
                CouponDetailType[CouponDetailType["ApplicantName"] = 132009] = "ApplicantName";
                CouponDetailType[CouponDetailType["ApplicantEmail"] = 132010] = "ApplicantEmail";
                CouponDetailType[CouponDetailType["RewardAmountHistory"] = 132011] = "RewardAmountHistory";
            })(CouponDetailType = Enums.CouponDetailType || (Enums.CouponDetailType = {}));
            var CouponReceivingOrganizationType;
            (function (CouponReceivingOrganizationType) {
                CouponReceivingOrganizationType[CouponReceivingOrganizationType["Auctions"] = 179000] = "Auctions";
                CouponReceivingOrganizationType[CouponReceivingOrganizationType["NonProfits"] = 179001] = "NonProfits";
                CouponReceivingOrganizationType[CouponReceivingOrganizationType["HostLocationContacts"] = 179002] = "HostLocationContacts";
                CouponReceivingOrganizationType[CouponReceivingOrganizationType["ProductCorporatePartners"] = 179003] = "ProductCorporatePartners";
                CouponReceivingOrganizationType[CouponReceivingOrganizationType["Other"] = 179004] = "Other";
            })(CouponReceivingOrganizationType = Enums.CouponReceivingOrganizationType || (Enums.CouponReceivingOrganizationType = {}));
            var CouponStatus;
            (function (CouponStatus) {
                CouponStatus[CouponStatus["NotUsed"] = 136000] = "NotUsed";
                CouponStatus[CouponStatus["WaitingApproval"] = 136001] = "WaitingApproval";
                CouponStatus[CouponStatus["Valid"] = 136002] = "Valid";
                CouponStatus[CouponStatus["Invalid"] = 136003] = "Invalid";
                CouponStatus[CouponStatus["BeingProcessed"] = 136004] = "BeingProcessed";
                CouponStatus[CouponStatus["Canceled"] = 136005] = "Canceled";
                CouponStatus[CouponStatus["Invoiced"] = 136006] = "Invoiced";
            })(CouponStatus = Enums.CouponStatus || (Enums.CouponStatus = {}));
            var CouponStatusForStaffReferral;
            (function (CouponStatusForStaffReferral) {
                CouponStatusForStaffReferral[CouponStatusForStaffReferral["NotUsed"] = 327000] = "NotUsed";
                CouponStatusForStaffReferral[CouponStatusForStaffReferral["Used"] = 327001] = "Used";
                CouponStatusForStaffReferral[CouponStatusForStaffReferral["Qualified"] = 327002] = "Qualified";
                CouponStatusForStaffReferral[CouponStatusForStaffReferral["Reviewed"] = 327003] = "Reviewed";
                CouponStatusForStaffReferral[CouponStatusForStaffReferral["Cancelled"] = 327004] = "Cancelled";
                CouponStatusForStaffReferral[CouponStatusForStaffReferral["Processed"] = 327005] = "Processed";
            })(CouponStatusForStaffReferral = Enums.CouponStatusForStaffReferral || (Enums.CouponStatusForStaffReferral = {}));
            var CountryRegionType;
            (function (CountryRegionType) {
                CountryRegionType[CountryRegionType["USStates"] = 148000] = "USStates";
                CountryRegionType[CountryRegionType["CanadianProvinces"] = 148001] = "CanadianProvinces";
            })(CountryRegionType = Enums.CountryRegionType || (Enums.CountryRegionType = {}));
            var CountryType;
            (function (CountryType) {
                CountryType[CountryType["Andorra"] = 8000] = "Andorra";
                CountryType[CountryType["UnitedArabEmirates"] = 8001] = "UnitedArabEmirates";
                CountryType[CountryType["Afghanistan"] = 8002] = "Afghanistan";
                CountryType[CountryType["AntiguaandBarbuda"] = 8003] = "AntiguaandBarbuda";
                CountryType[CountryType["Anguilla"] = 8004] = "Anguilla";
                CountryType[CountryType["Albania"] = 8005] = "Albania";
                CountryType[CountryType["Armenia"] = 8006] = "Armenia";
                CountryType[CountryType["NetherlandsAntilles"] = 8007] = "NetherlandsAntilles";
                CountryType[CountryType["Angola"] = 8008] = "Angola";
                CountryType[CountryType["Antarctica"] = 8009] = "Antarctica";
                CountryType[CountryType["Argentina"] = 8010] = "Argentina";
                CountryType[CountryType["AmericanSamoa"] = 8011] = "AmericanSamoa";
                CountryType[CountryType["Austria"] = 8012] = "Austria";
                CountryType[CountryType["Australia"] = 8013] = "Australia";
                CountryType[CountryType["Aruba"] = 8014] = "Aruba";
                CountryType[CountryType["\u00C5landIslands"] = 8015] = "\u00C5landIslands";
                CountryType[CountryType["Azerbaijan"] = 8016] = "Azerbaijan";
                CountryType[CountryType["BosniaandHerzegovina"] = 8017] = "BosniaandHerzegovina";
                CountryType[CountryType["Barbados"] = 8018] = "Barbados";
                CountryType[CountryType["Bangladesh"] = 8019] = "Bangladesh";
                CountryType[CountryType["Belgium"] = 8020] = "Belgium";
                CountryType[CountryType["BurkinaFaso"] = 8021] = "BurkinaFaso";
                CountryType[CountryType["Bulgaria"] = 8022] = "Bulgaria";
                CountryType[CountryType["Bahrain"] = 8023] = "Bahrain";
                CountryType[CountryType["Burundi"] = 8024] = "Burundi";
                CountryType[CountryType["Benin"] = 8025] = "Benin";
                CountryType[CountryType["SaintBarthelemy"] = 8026] = "SaintBarthelemy";
                CountryType[CountryType["Bermuda"] = 8027] = "Bermuda";
                CountryType[CountryType["BruneiDarussalam"] = 8028] = "BruneiDarussalam";
                CountryType[CountryType["Bolivia"] = 8029] = "Bolivia";
                CountryType[CountryType["Brazil"] = 8030] = "Brazil";
                CountryType[CountryType["Bahamas"] = 8031] = "Bahamas";
                CountryType[CountryType["Bhutan"] = 8032] = "Bhutan";
                CountryType[CountryType["BouvetIsland"] = 8033] = "BouvetIsland";
                CountryType[CountryType["Botswana"] = 8034] = "Botswana";
                CountryType[CountryType["Belarus"] = 8035] = "Belarus";
                CountryType[CountryType["Belize"] = 8036] = "Belize";
                CountryType[CountryType["Canada"] = 8037] = "Canada";
                CountryType[CountryType["CocosKeelingIslands"] = 8038] = "CocosKeelingIslands";
                CountryType[CountryType["CongoKinshasa"] = 8039] = "CongoKinshasa";
                CountryType[CountryType["CentralAfricanRepublic"] = 8040] = "CentralAfricanRepublic";
                CountryType[CountryType["CongoBrazzaville"] = 8041] = "CongoBrazzaville";
                CountryType[CountryType["Switzerland"] = 8042] = "Switzerland";
                CountryType[CountryType["CotedIvoire"] = 8043] = "CotedIvoire";
                CountryType[CountryType["CookIslands"] = 8044] = "CookIslands";
                CountryType[CountryType["Chile"] = 8045] = "Chile";
                CountryType[CountryType["Cameroon"] = 8046] = "Cameroon";
                CountryType[CountryType["China"] = 8047] = "China";
                CountryType[CountryType["Colombia"] = 8048] = "Colombia";
                CountryType[CountryType["CostaRica"] = 8049] = "CostaRica";
                CountryType[CountryType["Cuba"] = 8050] = "Cuba";
                CountryType[CountryType["CapeVerde"] = 8051] = "CapeVerde";
                CountryType[CountryType["ChristmasIsland"] = 8052] = "ChristmasIsland";
                CountryType[CountryType["Cyprus"] = 8053] = "Cyprus";
                CountryType[CountryType["CzechRepublic"] = 8054] = "CzechRepublic";
                CountryType[CountryType["Germany"] = 8055] = "Germany";
                CountryType[CountryType["Djibouti"] = 8056] = "Djibouti";
                CountryType[CountryType["Denmark"] = 8057] = "Denmark";
                CountryType[CountryType["Dominica"] = 8058] = "Dominica";
                CountryType[CountryType["DominicanRepublic"] = 8059] = "DominicanRepublic";
                CountryType[CountryType["Algeria"] = 8060] = "Algeria";
                CountryType[CountryType["Ecuador"] = 8061] = "Ecuador";
                CountryType[CountryType["Estonia"] = 8062] = "Estonia";
                CountryType[CountryType["Egypt"] = 8063] = "Egypt";
                CountryType[CountryType["WesternSahara"] = 8064] = "WesternSahara";
                CountryType[CountryType["Eritrea"] = 8065] = "Eritrea";
                CountryType[CountryType["Spain"] = 8066] = "Spain";
                CountryType[CountryType["Ethiopia"] = 8067] = "Ethiopia";
                CountryType[CountryType["Finland"] = 8068] = "Finland";
                CountryType[CountryType["Fiji"] = 8069] = "Fiji";
                CountryType[CountryType["FalklandIslands"] = 8070] = "FalklandIslands";
                CountryType[CountryType["Micronesia"] = 8071] = "Micronesia";
                CountryType[CountryType["FaroeIslands"] = 8072] = "FaroeIslands";
                CountryType[CountryType["France"] = 8073] = "France";
                CountryType[CountryType["Gabon"] = 8074] = "Gabon";
                CountryType[CountryType["UnitedKingdom"] = 8075] = "UnitedKingdom";
                CountryType[CountryType["Grenada"] = 8076] = "Grenada";
                CountryType[CountryType["Georgia"] = 8077] = "Georgia";
                CountryType[CountryType["FrenchGuiana"] = 8078] = "FrenchGuiana";
                CountryType[CountryType["Guernsey"] = 8079] = "Guernsey";
                CountryType[CountryType["Ghana"] = 8080] = "Ghana";
                CountryType[CountryType["Gibraltar"] = 8081] = "Gibraltar";
                CountryType[CountryType["Greenland"] = 8082] = "Greenland";
                CountryType[CountryType["Gambia"] = 8083] = "Gambia";
                CountryType[CountryType["Guinea"] = 8084] = "Guinea";
                CountryType[CountryType["Guadeloupe"] = 8085] = "Guadeloupe";
                CountryType[CountryType["EquatorialGuinea"] = 8086] = "EquatorialGuinea";
                CountryType[CountryType["Greece"] = 8087] = "Greece";
                CountryType[CountryType["Guatemala"] = 8088] = "Guatemala";
                CountryType[CountryType["Guam"] = 8089] = "Guam";
                CountryType[CountryType["GuineaBissau"] = 8090] = "GuineaBissau";
                CountryType[CountryType["Guyana"] = 8091] = "Guyana";
                CountryType[CountryType["HongKong"] = 8092] = "HongKong";
                CountryType[CountryType["Honduras"] = 8093] = "Honduras";
                CountryType[CountryType["Croatia"] = 8094] = "Croatia";
                CountryType[CountryType["Haiti"] = 8095] = "Haiti";
                CountryType[CountryType["Hungary"] = 8096] = "Hungary";
                CountryType[CountryType["Indonesia"] = 8097] = "Indonesia";
                CountryType[CountryType["Ireland"] = 8098] = "Ireland";
                CountryType[CountryType["Israel"] = 8099] = "Israel";
                CountryType[CountryType["IsleofMan"] = 8100] = "IsleofMan";
                CountryType[CountryType["India"] = 8101] = "India";
                CountryType[CountryType["Iraq"] = 8102] = "Iraq";
                CountryType[CountryType["Iran"] = 8103] = "Iran";
                CountryType[CountryType["Iceland"] = 8104] = "Iceland";
                CountryType[CountryType["Italy"] = 8105] = "Italy";
                CountryType[CountryType["Jersey"] = 8106] = "Jersey";
                CountryType[CountryType["Jamaica"] = 8107] = "Jamaica";
                CountryType[CountryType["Jordan"] = 8108] = "Jordan";
                CountryType[CountryType["Japan"] = 8109] = "Japan";
                CountryType[CountryType["Kenya"] = 8110] = "Kenya";
                CountryType[CountryType["Kyrgyzstan"] = 8111] = "Kyrgyzstan";
                CountryType[CountryType["Cambodia"] = 8112] = "Cambodia";
                CountryType[CountryType["Kiribati"] = 8113] = "Kiribati";
                CountryType[CountryType["Comoros"] = 8114] = "Comoros";
                CountryType[CountryType["SaintKittsandNevis"] = 8115] = "SaintKittsandNevis";
                CountryType[CountryType["KoreaNorth"] = 8116] = "KoreaNorth";
                CountryType[CountryType["KoreaSouth"] = 8117] = "KoreaSouth";
                CountryType[CountryType["Kuwait"] = 8118] = "Kuwait";
                CountryType[CountryType["CaymanIslands"] = 8119] = "CaymanIslands";
                CountryType[CountryType["Kazakhstan"] = 8120] = "Kazakhstan";
                CountryType[CountryType["Laos"] = 8121] = "Laos";
                CountryType[CountryType["Lebanon"] = 8122] = "Lebanon";
                CountryType[CountryType["SaintLucia"] = 8123] = "SaintLucia";
                CountryType[CountryType["Liechtenstein"] = 8124] = "Liechtenstein";
                CountryType[CountryType["SriLanka"] = 8125] = "SriLanka";
                CountryType[CountryType["Liberia"] = 8126] = "Liberia";
                CountryType[CountryType["Lesotho"] = 8127] = "Lesotho";
                CountryType[CountryType["Lithuania"] = 8128] = "Lithuania";
                CountryType[CountryType["Luxembourg"] = 8129] = "Luxembourg";
                CountryType[CountryType["Latvia"] = 8130] = "Latvia";
                CountryType[CountryType["Libya"] = 8131] = "Libya";
                CountryType[CountryType["Morocco"] = 8132] = "Morocco";
                CountryType[CountryType["Monaco"] = 8133] = "Monaco";
                CountryType[CountryType["Moldova"] = 8134] = "Moldova";
                CountryType[CountryType["Montenegro"] = 8135] = "Montenegro";
                CountryType[CountryType["SaintMartin"] = 8136] = "SaintMartin";
                CountryType[CountryType["Madagascar"] = 8137] = "Madagascar";
                CountryType[CountryType["MarshallIslands"] = 8138] = "MarshallIslands";
                CountryType[CountryType["Macedonia"] = 8139] = "Macedonia";
                CountryType[CountryType["Mali"] = 8140] = "Mali";
                CountryType[CountryType["Myanmar"] = 8141] = "Myanmar";
                CountryType[CountryType["Mongolia"] = 8142] = "Mongolia";
                CountryType[CountryType["Macao"] = 8143] = "Macao";
                CountryType[CountryType["NorthernMarianaIslands"] = 8144] = "NorthernMarianaIslands";
                CountryType[CountryType["Martinique"] = 8145] = "Martinique";
                CountryType[CountryType["Mauritania"] = 8146] = "Mauritania";
                CountryType[CountryType["Montserrat"] = 8147] = "Montserrat";
                CountryType[CountryType["Malta"] = 8148] = "Malta";
                CountryType[CountryType["Mauritius"] = 8149] = "Mauritius";
                CountryType[CountryType["Maldives"] = 8150] = "Maldives";
                CountryType[CountryType["Malawi"] = 8151] = "Malawi";
                CountryType[CountryType["Mexico"] = 8152] = "Mexico";
                CountryType[CountryType["Malaysia"] = 8153] = "Malaysia";
                CountryType[CountryType["Mozambique"] = 8154] = "Mozambique";
                CountryType[CountryType["Namibia"] = 8155] = "Namibia";
                CountryType[CountryType["NewCaledonia"] = 8156] = "NewCaledonia";
                CountryType[CountryType["Niger"] = 8157] = "Niger";
                CountryType[CountryType["NorfolkIsland"] = 8158] = "NorfolkIsland";
                CountryType[CountryType["Nigeria"] = 8159] = "Nigeria";
                CountryType[CountryType["Nicaragua"] = 8160] = "Nicaragua";
                CountryType[CountryType["Netherlands"] = 8161] = "Netherlands";
                CountryType[CountryType["Norway"] = 8162] = "Norway";
                CountryType[CountryType["Nepal"] = 8163] = "Nepal";
                CountryType[CountryType["Nauru"] = 8164] = "Nauru";
                CountryType[CountryType["Niue"] = 8165] = "Niue";
                CountryType[CountryType["NewZealand"] = 8166] = "NewZealand";
                CountryType[CountryType["Oman"] = 8167] = "Oman";
                CountryType[CountryType["Panama"] = 8168] = "Panama";
                CountryType[CountryType["Peru"] = 8169] = "Peru";
                CountryType[CountryType["FrenchPolynesia"] = 8170] = "FrenchPolynesia";
                CountryType[CountryType["PapuaNewGuinea"] = 8171] = "PapuaNewGuinea";
                CountryType[CountryType["Philippines"] = 8172] = "Philippines";
                CountryType[CountryType["Pakistan"] = 8173] = "Pakistan";
                CountryType[CountryType["Poland"] = 8174] = "Poland";
                CountryType[CountryType["SaintPierreandMiquelon"] = 8175] = "SaintPierreandMiquelon";
                CountryType[CountryType["Pitcairn"] = 8176] = "Pitcairn";
                CountryType[CountryType["PuertoRico"] = 8177] = "PuertoRico";
                CountryType[CountryType["PalestinianTerritory"] = 8178] = "PalestinianTerritory";
                CountryType[CountryType["Portugal"] = 8179] = "Portugal";
                CountryType[CountryType["Palau"] = 8180] = "Palau";
                CountryType[CountryType["Paraguay"] = 8181] = "Paraguay";
                CountryType[CountryType["Qatar"] = 8182] = "Qatar";
                CountryType[CountryType["Reunion"] = 8183] = "Reunion";
                CountryType[CountryType["Romania"] = 8184] = "Romania";
                CountryType[CountryType["Serbia"] = 8185] = "Serbia";
                CountryType[CountryType["RussianFederation"] = 8186] = "RussianFederation";
                CountryType[CountryType["Rwanda"] = 8187] = "Rwanda";
                CountryType[CountryType["SaudiArabia"] = 8188] = "SaudiArabia";
                CountryType[CountryType["SolomonIslands"] = 8189] = "SolomonIslands";
                CountryType[CountryType["Seychelles"] = 8190] = "Seychelles";
                CountryType[CountryType["Sudan"] = 8191] = "Sudan";
                CountryType[CountryType["Sweden"] = 8192] = "Sweden";
                CountryType[CountryType["Singapore"] = 8193] = "Singapore";
                CountryType[CountryType["SaintHelena"] = 8194] = "SaintHelena";
                CountryType[CountryType["Slovenia"] = 8195] = "Slovenia";
                CountryType[CountryType["SvalbardandJanMayen"] = 8196] = "SvalbardandJanMayen";
                CountryType[CountryType["Slovakia"] = 8197] = "Slovakia";
                CountryType[CountryType["SierraLeone"] = 8198] = "SierraLeone";
                CountryType[CountryType["SanMarino"] = 8199] = "SanMarino";
                CountryType[CountryType["Senegal"] = 8200] = "Senegal";
                CountryType[CountryType["Somalia"] = 8201] = "Somalia";
                CountryType[CountryType["Suriname"] = 8202] = "Suriname";
                CountryType[CountryType["SaoTomeandPrincipe"] = 8203] = "SaoTomeandPrincipe";
                CountryType[CountryType["ElSalvador"] = 8204] = "ElSalvador";
                CountryType[CountryType["Syria"] = 8205] = "Syria";
                CountryType[CountryType["Swaziland"] = 8206] = "Swaziland";
                CountryType[CountryType["TurksandCaicosIslands"] = 8207] = "TurksandCaicosIslands";
                CountryType[CountryType["Chad"] = 8208] = "Chad";
                CountryType[CountryType["Togo"] = 8209] = "Togo";
                CountryType[CountryType["Thailand"] = 8210] = "Thailand";
                CountryType[CountryType["Tajikistan"] = 8211] = "Tajikistan";
                CountryType[CountryType["Tokelau"] = 8212] = "Tokelau";
                CountryType[CountryType["Timorleste"] = 8213] = "Timorleste";
                CountryType[CountryType["Turkmenistan"] = 8214] = "Turkmenistan";
                CountryType[CountryType["Tunisia"] = 8215] = "Tunisia";
                CountryType[CountryType["Tonga"] = 8216] = "Tonga";
                CountryType[CountryType["Turkey"] = 8217] = "Turkey";
                CountryType[CountryType["TrinidadandTobago"] = 8218] = "TrinidadandTobago";
                CountryType[CountryType["Tuvalu"] = 8219] = "Tuvalu";
                CountryType[CountryType["Taiwan"] = 8220] = "Taiwan";
                CountryType[CountryType["Tanzania"] = 8221] = "Tanzania";
                CountryType[CountryType["Ukraine"] = 8222] = "Ukraine";
                CountryType[CountryType["Uganda"] = 8223] = "Uganda";
                CountryType[CountryType["USA"] = 8224] = "USA";
                CountryType[CountryType["Uruguay"] = 8225] = "Uruguay";
                CountryType[CountryType["Uzbekistan"] = 8226] = "Uzbekistan";
                CountryType[CountryType["VaticanCityHolySee"] = 8227] = "VaticanCityHolySee";
                CountryType[CountryType["SaintVincent"] = 8228] = "SaintVincent";
                CountryType[CountryType["Venezuela"] = 8229] = "Venezuela";
                CountryType[CountryType["VirginIslandsBritish"] = 8230] = "VirginIslandsBritish";
                CountryType[CountryType["VirginIslandsUS"] = 8231] = "VirginIslandsUS";
                CountryType[CountryType["VietNam"] = 8232] = "VietNam";
                CountryType[CountryType["Vanuatu"] = 8233] = "Vanuatu";
                CountryType[CountryType["WallisandFutuna"] = 8234] = "WallisandFutuna";
                CountryType[CountryType["Samoa"] = 8235] = "Samoa";
                CountryType[CountryType["Yemen"] = 8236] = "Yemen";
                CountryType[CountryType["Mayotte"] = 8237] = "Mayotte";
                CountryType[CountryType["SouthAfrica"] = 8238] = "SouthAfrica";
                CountryType[CountryType["Zambia"] = 8239] = "Zambia";
                CountryType[CountryType["Zimbabwe"] = 8240] = "Zimbabwe";
            })(CountryType = Enums.CountryType || (Enums.CountryType = {}));
            var CouponRoleType;
            (function (CouponRoleType) {
                CouponRoleType[CouponRoleType["Creator"] = 122000] = "Creator";
                CouponRoleType[CouponRoleType["Consumer"] = 122001] = "Consumer";
            })(CouponRoleType = Enums.CouponRoleType || (Enums.CouponRoleType = {}));
            var CouponType;
            (function (CouponType) {
                CouponType[CouponType["Standard"] = 126000] = "Standard";
                CouponType[CouponType["Voucher"] = 126001] = "Voucher";
                CouponType[CouponType["ReferFriend"] = 126002] = "ReferFriend";
                CouponType[CouponType["Scholarship"] = 126003] = "Scholarship";
                CouponType[CouponType["TuitionAssistance"] = 126004] = "TuitionAssistance";
                CouponType[CouponType["MarketingCoupon"] = 126005] = "MarketingCoupon";
                CouponType[CouponType["ThirdPartyPayer"] = 126006] = "ThirdPartyPayer";
                CouponType[CouponType["LetterOfIntent"] = 126007] = "LetterOfIntent";
                CouponType[CouponType["ThirdPartyPayerGroup"] = 126008] = "ThirdPartyPayerGroup";
                CouponType[CouponType["TermStaffReferAFriend"] = 126009] = "TermStaffReferAFriend";
                CouponType[CouponType["PurchasedCredit"] = 126010] = "PurchasedCredit";
            })(CouponType = Enums.CouponType || (Enums.CouponType = {}));
            var CourseDeposit;
            (function (CourseDeposit) {
                CourseDeposit[CourseDeposit["FixedAmount"] = 33000] = "FixedAmount";
                CourseDeposit[CourseDeposit["Percent"] = 33001] = "Percent";
            })(CourseDeposit = Enums.CourseDeposit || (Enums.CourseDeposit = {}));
            var CourseOptionGroup;
            (function (CourseOptionGroup) {
                CourseOptionGroup[CourseOptionGroup["PreCampLearningOption"] = 366000] = "PreCampLearningOption";
                CourseOptionGroup[CourseOptionGroup["AtCampOption"] = 366001] = "AtCampOption";
                CourseOptionGroup[CourseOptionGroup["CollegePrepOption"] = 366002] = "CollegePrepOption";
            })(CourseOptionGroup = Enums.CourseOptionGroup || (Enums.CourseOptionGroup = {}));
            var CourseSubCategoryType;
            (function (CourseSubCategoryType) {
                CourseSubCategoryType[CourseSubCategoryType["None"] = 45000] = "None";
            })(CourseSubCategoryType = Enums.CourseSubCategoryType || (Enums.CourseSubCategoryType = {}));
            var CreatedEventType;
            (function (CreatedEventType) {
                CreatedEventType[CreatedEventType["InformationRequest"] = 62000] = "InformationRequest";
                CreatedEventType[CreatedEventType["CreateAccountPublic"] = 62001] = "CreateAccountPublic";
                CreatedEventType[CreatedEventType["CreateAccountStaff"] = 62002] = "CreateAccountStaff";
                CreatedEventType[CreatedEventType["iDOnsiteRequest"] = 62003] = "iDOnsiteRequest";
            })(CreatedEventType = Enums.CreatedEventType || (Enums.CreatedEventType = {}));
            var CreditCardType;
            (function (CreditCardType) {
                CreditCardType[CreditCardType["Visa"] = 96000] = "Visa";
                CreditCardType[CreditCardType["Mastercard"] = 96001] = "Mastercard";
                CreditCardType[CreditCardType["AmericanExpress"] = 96002] = "AmericanExpress";
                CreditCardType[CreditCardType["Discover"] = 96003] = "Discover";
            })(CreditCardType = Enums.CreditCardType || (Enums.CreditCardType = {}));
            var CurrencyType;
            (function (CurrencyType) {
                CurrencyType[CurrencyType["USD"] = 25000] = "USD";
                CurrencyType[CurrencyType["INR"] = 25011] = "INR";
            })(CurrencyType = Enums.CurrencyType || (Enums.CurrencyType = {}));
            var DateType;
            (function (DateType) {
                DateType[DateType["Absolute"] = 40000] = "Absolute";
                DateType[DateType["Relative"] = 40001] = "Relative";
            })(DateType = Enums.DateType || (Enums.DateType = {}));
            var DiscountBannerUsageType;
            (function (DiscountBannerUsageType) {
                DiscountBannerUsageType[DiscountBannerUsageType["Homepage"] = 293000] = "Homepage";
                DiscountBannerUsageType[DiscountBannerUsageType["SecondLevelPage"] = 293001] = "SecondLevelPage";
                DiscountBannerUsageType[DiscountBannerUsageType["Email"] = 293002] = "Email";
            })(DiscountBannerUsageType = Enums.DiscountBannerUsageType || (Enums.DiscountBannerUsageType = {}));
            var DiscountCategory;
            (function (DiscountCategory) {
                DiscountCategory[DiscountCategory["Standard"] = 183000] = "Standard";
                DiscountCategory[DiscountCategory["Coupon"] = 183001] = "Coupon";
                DiscountCategory[DiscountCategory["Voucher"] = 183002] = "Voucher";
                DiscountCategory[DiscountCategory["ReferAFriend"] = 183003] = "ReferAFriend";
                DiscountCategory[DiscountCategory["Promotion"] = 183004] = "Promotion";
            })(DiscountCategory = Enums.DiscountCategory || (Enums.DiscountCategory = {}));
            var DiscountType;
            (function (DiscountType) {
                DiscountType[DiscountType["Special"] = 49000] = "Special";
                DiscountType[DiscountType["Group"] = 49001] = "Group";
                DiscountType[DiscountType["MultiSession"] = 49002] = "MultiSession";
                DiscountType[DiscountType["CorporatePartnerStaff"] = 49003] = "CorporatePartnerStaff";
                DiscountType[DiscountType["LocationStaffFaculty"] = 49004] = "LocationStaffFaculty";
                DiscountType[DiscountType["Sibling"] = 49006] = "Sibling";
                DiscountType[DiscountType["Promotion"] = 49007] = "Promotion";
                DiscountType[DiscountType["ReferAFriend"] = 49008] = "ReferAFriend";
                DiscountType[DiscountType["Voucher"] = 49009] = "Voucher";
                DiscountType[DiscountType["Scholarship"] = 49010] = "Scholarship";
                DiscountType[DiscountType["TuitionAssistance"] = 49011] = "TuitionAssistance";
                DiscountType[DiscountType["ClientServicesDiscretionary"] = 49012] = "ClientServicesDiscretionary";
                DiscountType[DiscountType["Courtesy"] = 49013] = "Courtesy";
                DiscountType[DiscountType["ThirdPartyPayer"] = 49014] = "ThirdPartyPayer";
                DiscountType[DiscountType["ReferAFriendReward"] = 49015] = "ReferAFriendReward";
                DiscountType[DiscountType["VoucherServiceProblem"] = 49016] = "VoucherServiceProblem";
                DiscountType[DiscountType["MarketingCoupon"] = 49017] = "MarketingCoupon";
                DiscountType[DiscountType["WriteOff"] = 49018] = "WriteOff";
                DiscountType[DiscountType["KermitVoucherClientProblem"] = 49019] = "KermitVoucherClientProblem";
                DiscountType[DiscountType["KermitVoucherServiceProblem"] = 49020] = "KermitVoucherServiceProblem";
                DiscountType[DiscountType["Multisession_Sibling"] = 49021] = "Multisession_Sibling";
                DiscountType[DiscountType["CorporatePartnerStaff_LocationStaffFaculty"] = 49022] = "CorporatePartnerStaff_LocationStaffFaculty";
                DiscountType[DiscountType["Scholarship_TuitionAssistance_MarketingCoupon"] = 49023] = "Scholarship_TuitionAssistance_MarketingCoupon";
                DiscountType[DiscountType["PurchasedCredit"] = 49024] = "PurchasedCredit";
            })(DiscountType = Enums.DiscountType || (Enums.DiscountType = {}));
            var DiscountApplicableToward;
            (function (DiscountApplicableToward) {
                DiscountApplicableToward[DiscountApplicableToward["AmountLessDeposit"] = 80000] = "AmountLessDeposit";
                DiscountApplicableToward[DiscountApplicableToward["FullAmount"] = 80001] = "FullAmount";
            })(DiscountApplicableToward = Enums.DiscountApplicableToward || (Enums.DiscountApplicableToward = {}));
            var DiscountBlanketRestriction;
            (function (DiscountBlanketRestriction) {
                DiscountBlanketRestriction[DiscountBlanketRestriction["ExclusivePerOrder"] = 77000] = "ExclusivePerOrder";
                DiscountBlanketRestriction[DiscountBlanketRestriction["ExclusivePerTerm"] = 77001] = "ExclusivePerTerm";
            })(DiscountBlanketRestriction = Enums.DiscountBlanketRestriction || (Enums.DiscountBlanketRestriction = {}));
            var DiscountDateRelativeToItemType;
            (function (DiscountDateRelativeToItemType) {
                DiscountDateRelativeToItemType[DiscountDateRelativeToItemType["FirstDayOfTerm"] = 58000] = "FirstDayOfTerm";
                DiscountDateRelativeToItemType[DiscountDateRelativeToItemType["LastDayOfTerm"] = 58001] = "LastDayOfTerm";
                DiscountDateRelativeToItemType[DiscountDateRelativeToItemType["FirstDayOfLastSession"] = 58002] = "FirstDayOfLastSession";
            })(DiscountDateRelativeToItemType = Enums.DiscountDateRelativeToItemType || (Enums.DiscountDateRelativeToItemType = {}));
            var DiscountDiscountTypeRestriction;
            (function (DiscountDiscountTypeRestriction) {
                DiscountDiscountTypeRestriction[DiscountDiscountTypeRestriction["NotInSameTerm"] = 78000] = "NotInSameTerm";
            })(DiscountDiscountTypeRestriction = Enums.DiscountDiscountTypeRestriction || (Enums.DiscountDiscountTypeRestriction = {}));
            var DiscountDivisionRelationshipType;
            (function (DiscountDivisionRelationshipType) {
                DiscountDivisionRelationshipType[DiscountDivisionRelationshipType["Primary"] = 63000] = "Primary";
                DiscountDivisionRelationshipType[DiscountDivisionRelationshipType["Secondary"] = 63001] = "Secondary";
            })(DiscountDivisionRelationshipType = Enums.DiscountDivisionRelationshipType || (Enums.DiscountDivisionRelationshipType = {}));
            var DiscountLimitType;
            (function (DiscountLimitType) {
                DiscountLimitType[DiscountLimitType["PerTermGroup"] = 64000] = "PerTermGroup";
                DiscountLimitType[DiscountLimitType["PerLocation"] = 64001] = "PerLocation";
                DiscountLimitType[DiscountLimitType["PerCustomer"] = 64002] = "PerCustomer";
                DiscountLimitType[DiscountLimitType["PerParticipant"] = 64003] = "PerParticipant";
                DiscountLimitType[DiscountLimitType["PerOrder"] = 64004] = "PerOrder";
            })(DiscountLimitType = Enums.DiscountLimitType || (Enums.DiscountLimitType = {}));
            var DiscountPaymentReqType;
            (function (DiscountPaymentReqType) {
                DiscountPaymentReqType[DiscountPaymentReqType["NoRequirement"] = 66000] = "NoRequirement";
                DiscountPaymentReqType[DiscountPaymentReqType["PayInFullByPaymentDueDate"] = 66001] = "PayInFullByPaymentDueDate";
                DiscountPaymentReqType[DiscountPaymentReqType["PayInFullImmediately"] = 66002] = "PayInFullImmediately";
            })(DiscountPaymentReqType = Enums.DiscountPaymentReqType || (Enums.DiscountPaymentReqType = {}));
            var DiscountProductInclusionType;
            (function (DiscountProductInclusionType) {
                DiscountProductInclusionType[DiscountProductInclusionType["Include"] = 76000] = "Include";
                DiscountProductInclusionType[DiscountProductInclusionType["Exclude"] = 76001] = "Exclude";
            })(DiscountProductInclusionType = Enums.DiscountProductInclusionType || (Enums.DiscountProductInclusionType = {}));
            var DiscountScheduleType;
            (function (DiscountScheduleType) {
                DiscountScheduleType[DiscountScheduleType["OfferDate"] = 68000] = "OfferDate";
                DiscountScheduleType[DiscountScheduleType["PaymentReqDate"] = 68001] = "PaymentReqDate";
            })(DiscountScheduleType = Enums.DiscountScheduleType || (Enums.DiscountScheduleType = {}));
            var DiscountSubcategoryType;
            (function (DiscountSubcategoryType) {
                DiscountSubcategoryType[DiscountSubcategoryType["CorporatePartnerStaff"] = 230000] = "CorporatePartnerStaff";
                DiscountSubcategoryType[DiscountSubcategoryType["LocationStaffFaculty"] = 230001] = "LocationStaffFaculty";
                DiscountSubcategoryType[DiscountSubcategoryType["Scholarship"] = 230002] = "Scholarship";
                DiscountSubcategoryType[DiscountSubcategoryType["TuitionAssistance"] = 230003] = "TuitionAssistance";
                DiscountSubcategoryType[DiscountSubcategoryType["MarketingCoupon"] = 230004] = "MarketingCoupon";
                DiscountSubcategoryType[DiscountSubcategoryType["LetterOfIntent"] = 230005] = "LetterOfIntent";
                DiscountSubcategoryType[DiscountSubcategoryType["ThirdPartyPayerGroup"] = 230006] = "ThirdPartyPayerGroup";
                DiscountSubcategoryType[DiscountSubcategoryType["CouponamountAddonVouchers"] = 230007] = "CouponamountAddonVouchers";
                DiscountSubcategoryType[DiscountSubcategoryType["CouponamountAddonScholarships"] = 230008] = "CouponamountAddonScholarships";
                DiscountSubcategoryType[DiscountSubcategoryType["CouponamountAddoniDScholarshipProgram"] = 230009] = "CouponamountAddoniDScholarshipProgram";
                DiscountSubcategoryType[DiscountSubcategoryType["CouponamountAddonMarketingCoupons"] = 230010] = "CouponamountAddonMarketingCoupons";
                DiscountSubcategoryType[DiscountSubcategoryType["CouponamountAddonThirdPartyPayers"] = 230011] = "CouponamountAddonThirdPartyPayers";
                DiscountSubcategoryType[DiscountSubcategoryType["PositivelyOutrageousServicePOS"] = 230012] = "PositivelyOutrageousServicePOS";
                DiscountSubcategoryType[DiscountSubcategoryType["ClientIssuedCreditOrRefund"] = 230013] = "ClientIssuedCreditOrRefund";
                DiscountSubcategoryType[DiscountSubcategoryType["SalesCreditsPromotions"] = 230014] = "SalesCreditsPromotions";
                DiscountSubcategoryType[DiscountSubcategoryType["SalesCreditsCorporatePartnerStaff"] = 230015] = "SalesCreditsCorporatePartnerStaff";
                DiscountSubcategoryType[DiscountSubcategoryType["SalesCreditsLocationFacultyAndStaff"] = 230016] = "SalesCreditsLocationFacultyAndStaff";
                DiscountSubcategoryType[DiscountSubcategoryType["EarlyAccess"] = 230017] = "EarlyAccess";
            })(DiscountSubcategoryType = Enums.DiscountSubcategoryType || (Enums.DiscountSubcategoryType = {}));
            var DiscountValueType;
            (function (DiscountValueType) {
                DiscountValueType[DiscountValueType["FixedAmount"] = 57000] = "FixedAmount";
                DiscountValueType[DiscountValueType["Percent"] = 57001] = "Percent";
            })(DiscountValueType = Enums.DiscountValueType || (Enums.DiscountValueType = {}));
            var DiscretionaryPayReason;
            (function (DiscretionaryPayReason) {
                DiscretionaryPayReason[DiscretionaryPayReason["ExceptionalExperience"] = 249000] = "ExceptionalExperience";
                DiscretionaryPayReason[DiscretionaryPayReason["AdjustmentToMeetPreviousPayRate"] = 249001] = "AdjustmentToMeetPreviousPayRate";
                DiscretionaryPayReason[DiscretionaryPayReason["Other"] = 249002] = "Other";
            })(DiscretionaryPayReason = Enums.DiscretionaryPayReason || (Enums.DiscretionaryPayReason = {}));
            var DivisionBehaviorMask;
            (function (DivisionBehaviorMask) {
                DivisionBehaviorMask[DivisionBehaviorMask["None"] = 0] = "None";
                DivisionBehaviorMask[DivisionBehaviorMask["IncludeLocationsFromOtherDivisions"] = 1] = "IncludeLocationsFromOtherDivisions";
                DivisionBehaviorMask[DivisionBehaviorMask["AgeGroupSensitive"] = 2] = "AgeGroupSensitive";
                DivisionBehaviorMask[DivisionBehaviorMask["All"] = 65535] = "All";
            })(DivisionBehaviorMask = Enums.DivisionBehaviorMask || (Enums.DivisionBehaviorMask = {}));
            var DivisionProgramType;
            (function (DivisionProgramType) {
                DivisionProgramType[DivisionProgramType["iDTechCamps"] = 307000] = "iDTechCamps";
                DivisionProgramType[DivisionProgramType["iDTechAcademies"] = 307001] = "iDTechAcademies";
                DivisionProgramType[DivisionProgramType["iDTechMini"] = 307002] = "iDTechMini";
                DivisionProgramType[DivisionProgramType["AlexaCafe"] = 307003] = "AlexaCafe";
                DivisionProgramType[DivisionProgramType["Merchandise"] = 307005] = "Merchandise";
                DivisionProgramType[DivisionProgramType["iDOnLine"] = 307006] = "iDOnLine";
                DivisionProgramType[DivisionProgramType["VirtualCamp"] = 307007] = "VirtualCamp";
            })(DivisionProgramType = Enums.DivisionProgramType || (Enums.DivisionProgramType = {}));
            var DivisionTextType;
            (function (DivisionTextType) {
                DivisionTextType[DivisionTextType["WelcomePacketEmail"] = 292000] = "WelcomePacketEmail";
                DivisionTextType[DivisionTextType["DayProgramDescription"] = 292001] = "DayProgramDescription";
                DivisionTextType[DivisionTextType["OvernightProgramDescription"] = 292002] = "OvernightProgramDescription";
                DivisionTextType[DivisionTextType["IncludedInTuition"] = 292003] = "IncludedInTuition";
                DivisionTextType[DivisionTextType["WelcomePacketWelcomeAndRecapTab"] = 292004] = "WelcomePacketWelcomeAndRecapTab";
                DivisionTextType[DivisionTextType["WelcomePacketMapsAndDirectionsTab"] = 292005] = "WelcomePacketMapsAndDirectionsTab";
                DivisionTextType[DivisionTextType["WelcomePacketPackingListTab"] = 292006] = "WelcomePacketPackingListTab";
                DivisionTextType[DivisionTextType["WelcomePacketMedicationsTab"] = 292007] = "WelcomePacketMedicationsTab";
                DivisionTextType[DivisionTextType["WelcomePacketCodeOfConductTab"] = 292008] = "WelcomePacketCodeOfConductTab";
                DivisionTextType[DivisionTextType["WelcomePacketFAQsTab"] = 292009] = "WelcomePacketFAQsTab";
                DivisionTextType[DivisionTextType["WelcomePacketFamilyShowcaseTab"] = 292010] = "WelcomePacketFamilyShowcaseTab";
                DivisionTextType[DivisionTextType["TechRocketAccountCreationEmail"] = 292011] = "TechRocketAccountCreationEmail";
                DivisionTextType[DivisionTextType["TechRocketPurchaseConfirmationEmail"] = 292012] = "TechRocketPurchaseConfirmationEmail";
                DivisionTextType[DivisionTextType["TechRocketPurchaseConfirmationEmail_UpsaleReg"] = 292013] = "TechRocketPurchaseConfirmationEmail_UpsaleReg";
                DivisionTextType[DivisionTextType["ReferAFriendRewardEmail"] = 292014] = "ReferAFriendRewardEmail";
                DivisionTextType[DivisionTextType["VIPEarlyAccessPass"] = 292015] = "VIPEarlyAccessPass";
            })(DivisionTextType = Enums.DivisionTextType || (Enums.DivisionTextType = {}));
            var DivisionDeliveryModelType;
            (function (DivisionDeliveryModelType) {
                DivisionDeliveryModelType[DivisionDeliveryModelType["YouthEducationalServices"] = 4000] = "YouthEducationalServices";
                DivisionDeliveryModelType[DivisionDeliveryModelType["TermStaffTraining"] = 4001] = "TermStaffTraining";
                DivisionDeliveryModelType[DivisionDeliveryModelType["EducationProgramComponents"] = 4002] = "EducationProgramComponents";
                DivisionDeliveryModelType[DivisionDeliveryModelType["AfterSchoolPrograms"] = 4004] = "AfterSchoolPrograms";
            })(DivisionDeliveryModelType = Enums.DivisionDeliveryModelType || (Enums.DivisionDeliveryModelType = {}));
            var DomainMappingType;
            (function (DomainMappingType) {
                DomainMappingType[DomainMappingType["PublicDomainUrl"] = 396000] = "PublicDomainUrl";
            })(DomainMappingType = Enums.DomainMappingType || (Enums.DomainMappingType = {}));
            var DormRoomCapacity;
            (function (DormRoomCapacity) {
                DormRoomCapacity[DormRoomCapacity["Single"] = 276000] = "Single";
                DormRoomCapacity[DormRoomCapacity["Double"] = 276001] = "Double";
                DormRoomCapacity[DormRoomCapacity["Triple"] = 276002] = "Triple";
                DormRoomCapacity[DormRoomCapacity["Suite"] = 276003] = "Suite";
            })(DormRoomCapacity = Enums.DormRoomCapacity || (Enums.DormRoomCapacity = {}));
            var EmployeeStatusType;
            (function (EmployeeStatusType) {
                EmployeeStatusType[EmployeeStatusType["Applicant"] = 47000] = "Applicant";
                EmployeeStatusType[EmployeeStatusType["CurrentEmployee"] = 47001] = "CurrentEmployee";
                EmployeeStatusType[EmployeeStatusType["Terminated"] = 47002] = "Terminated";
            })(EmployeeStatusType = Enums.EmployeeStatusType || (Enums.EmployeeStatusType = {}));
            var EquipmentCategoryType;
            (function (EquipmentCategoryType) {
                EquipmentCategoryType[EquipmentCategoryType["iMac"] = 212000] = "iMac";
                EquipmentCategoryType[EquipmentCategoryType["StandardPC"] = 212001] = "StandardPC";
                EquipmentCategoryType[EquipmentCategoryType["Monitor"] = 212004] = "Monitor";
                EquipmentCategoryType[EquipmentCategoryType["Printer"] = 212005] = "Printer";
                EquipmentCategoryType[EquipmentCategoryType["MacMini"] = 212006] = "MacMini";
                EquipmentCategoryType[EquipmentCategoryType["MacBookPro"] = 212007] = "MacBookPro";
                EquipmentCategoryType[EquipmentCategoryType["GamingPC"] = 212008] = "GamingPC";
                EquipmentCategoryType[EquipmentCategoryType["AndroidTablet"] = 212009] = "AndroidTablet";
            })(EquipmentCategoryType = Enums.EquipmentCategoryType || (Enums.EquipmentCategoryType = {}));
            var EquipmentReportType;
            (function (EquipmentReportType) {
                EquipmentReportType[EquipmentReportType["SummaryOfIssuesReportedThisWeek"] = 211000] = "SummaryOfIssuesReportedThisWeek";
                EquipmentReportType[EquipmentReportType["NewEquipmentReceived"] = 211001] = "NewEquipmentReceived";
                EquipmentReportType[EquipmentReportType["ReturnedEquipment"] = 211002] = "ReturnedEquipment";
                EquipmentReportType[EquipmentReportType["NoIssuesReportedThisWeek"] = 211003] = "NoIssuesReportedThisWeek";
            })(EquipmentReportType = Enums.EquipmentReportType || (Enums.EquipmentReportType = {}));
            var ExtraActionItemType;
            (function (ExtraActionItemType) {
                ExtraActionItemType[ExtraActionItemType["SectionCapacityZero"] = 100000] = "SectionCapacityZero";
            })(ExtraActionItemType = Enums.ExtraActionItemType || (Enums.ExtraActionItemType = {}));
            var FacilityType;
            (function (FacilityType) {
                FacilityType[FacilityType["ResidenceHall"] = 12000] = "ResidenceHall";
                FacilityType[FacilityType["DiningHall"] = 12001] = "DiningHall";
                FacilityType[FacilityType["LabBuilding"] = 12002] = "LabBuilding";
                FacilityType[FacilityType["LabRoom"] = 12003] = "LabRoom";
            })(FacilityType = Enums.FacilityType || (Enums.FacilityType = {}));
            var FeeAmountType;
            (function (FeeAmountType) {
                FeeAmountType[FeeAmountType["Predefined"] = 91000] = "Predefined";
                FeeAmountType[FeeAmountType["DefinedWhenApplied"] = 91001] = "DefinedWhenApplied";
            })(FeeAmountType = Enums.FeeAmountType || (Enums.FeeAmountType = {}));
            var FeeApplyType;
            (function (FeeApplyType) {
                FeeApplyType[FeeApplyType["Automatic"] = 92000] = "Automatic";
                FeeApplyType[FeeApplyType["Manual"] = 92001] = "Manual";
            })(FeeApplyType = Enums.FeeApplyType || (Enums.FeeApplyType = {}));
            var FileDirectoryType;
            (function (FileDirectoryType) {
                FileDirectoryType[FileDirectoryType["LocalDirectory"] = 112000] = "LocalDirectory";
                FileDirectoryType[FileDirectoryType["VirtualDirectory"] = 112001] = "VirtualDirectory";
            })(FileDirectoryType = Enums.FileDirectoryType || (Enums.FileDirectoryType = {}));
            var FileDirectoryUsage;
            (function (FileDirectoryUsage) {
                FileDirectoryUsage[FileDirectoryUsage["HRLogFiles"] = 254000] = "HRLogFiles";
                FileDirectoryUsage[FileDirectoryUsage["TermStaffFiles"] = 254001] = "TermStaffFiles";
                FileDirectoryUsage[FileDirectoryUsage["EmailTemplates"] = 254002] = "EmailTemplates";
                FileDirectoryUsage[FileDirectoryUsage["TermStaffWelcomeMsgs"] = 254003] = "TermStaffWelcomeMsgs";
                FileDirectoryUsage[FileDirectoryUsage["EmployeeHandbookFiles"] = 254004] = "EmployeeHandbookFiles";
                FileDirectoryUsage[FileDirectoryUsage["RequiredEmploymentPaperwork"] = 254005] = "RequiredEmploymentPaperwork";
                FileDirectoryUsage[FileDirectoryUsage["AttendanceSignatureImages"] = 254006] = "AttendanceSignatureImages";
                FileDirectoryUsage[FileDirectoryUsage["JobApplicantPaperworkUploads"] = 254007] = "JobApplicantPaperworkUploads";
                FileDirectoryUsage[FileDirectoryUsage["TAPDocuments"] = 254008] = "TAPDocuments";
                FileDirectoryUsage[FileDirectoryUsage["OrderConfirmationFiles"] = 254009] = "OrderConfirmationFiles";
                FileDirectoryUsage[FileDirectoryUsage["JobApplicantComplianceUploads"] = 254010] = "JobApplicantComplianceUploads";
                FileDirectoryUsage[FileDirectoryUsage["EmployeeHandbookPdf"] = 254011] = "EmployeeHandbookPdf";
                FileDirectoryUsage[FileDirectoryUsage["RequiredEmploymentPaperworkPdf"] = 254012] = "RequiredEmploymentPaperworkPdf";
                FileDirectoryUsage[FileDirectoryUsage["JobApplicationApplicantPdf"] = 254013] = "JobApplicationApplicantPdf";
                FileDirectoryUsage[FileDirectoryUsage["ClientARF"] = 254014] = "ClientARF";
            })(FileDirectoryUsage = Enums.FileDirectoryUsage || (Enums.FileDirectoryUsage = {}));
            var FileFormat;
            (function (FileFormat) {
                FileFormat[FileFormat["HTML"] = 111000] = "HTML";
                FileFormat[FileFormat["PDF"] = 111001] = "PDF";
                FileFormat[FileFormat["PNG"] = 111002] = "PNG";
                FileFormat[FileFormat["JPG"] = 111003] = "JPG";
                FileFormat[FileFormat["ZIP"] = 111004] = "ZIP";
                FileFormat[FileFormat["DOC"] = 111005] = "DOC";
                FileFormat[FileFormat["DOCX"] = 111006] = "DOCX";
            })(FileFormat = Enums.FileFormat || (Enums.FileFormat = {}));
            var FileType;
            (function (FileType) {
                FileType[FileType["LocalFile"] = 109000] = "LocalFile";
                FileType[FileType["Web"] = 109001] = "Web";
            })(FileType = Enums.FileType || (Enums.FileType = {}));
            var FileUploadReturnCode;
            (function (FileUploadReturnCode) {
                FileUploadReturnCode[FileUploadReturnCode["Success"] = 0] = "Success";
                FileUploadReturnCode[FileUploadReturnCode["Failure"] = 1] = "Failure";
            })(FileUploadReturnCode = Enums.FileUploadReturnCode || (Enums.FileUploadReturnCode = {}));
            var FileUsageType;
            (function (FileUsageType) {
                FileUsageType[FileUsageType["CarpoolTermsAndConditions"] = 110000] = "CarpoolTermsAndConditions";
                FileUsageType[FileUsageType["TermsAndConditions"] = 110001] = "TermsAndConditions";
                FileUsageType[FileUsageType["ReferAFriendTermsAndConditions"] = 110002] = "ReferAFriendTermsAndConditions";
                FileUsageType[FileUsageType["InterviewNotes"] = 110006] = "InterviewNotes";
                FileUsageType[FileUsageType["HRLogRelatedFile"] = 110007] = "HRLogRelatedFile";
                FileUsageType[FileUsageType["TermStaffWorkSchedule"] = 110021] = "TermStaffWorkSchedule";
                FileUsageType[FileUsageType["JobApplicantPaperwork"] = 110024] = "JobApplicantPaperwork";
                FileUsageType[FileUsageType["TaxReturnDocuments"] = 110025] = "TaxReturnDocuments";
                FileUsageType[FileUsageType["Resume"] = 110026] = "Resume";
            })(FileUsageType = Enums.FileUsageType || (Enums.FileUsageType = {}));
            var FollowUpStatusType;
            (function (FollowUpStatusType) {
                FollowUpStatusType[FollowUpStatusType["NeedsFollowUp"] = 69000] = "NeedsFollowUp";
                FollowUpStatusType[FollowUpStatusType["WaitingForReply"] = 69001] = "WaitingForReply";
                FollowUpStatusType[FollowUpStatusType["NoneNeeded"] = 69002] = "NoneNeeded";
            })(FollowUpStatusType = Enums.FollowUpStatusType || (Enums.FollowUpStatusType = {}));
            var FormCategoryGroup;
            (function (FormCategoryGroup) {
                FormCategoryGroup[FormCategoryGroup["ClientForms"] = 253000] = "ClientForms";
                FormCategoryGroup[FormCategoryGroup["JobApplicationForms"] = 253001] = "JobApplicationForms";
                FormCategoryGroup[FormCategoryGroup["TermStaffPaperworkForms"] = 253002] = "TermStaffPaperworkForms";
            })(FormCategoryGroup = Enums.FormCategoryGroup || (Enums.FormCategoryGroup = {}));
            var FormCategoryType;
            (function (FormCategoryType) {
                FormCategoryType[FormCategoryType["Health"] = 140000] = "Health";
                FormCategoryType[FormCategoryType["ClientOther"] = 140001] = "ClientOther";
                FormCategoryType[FormCategoryType["Bring"] = 140002] = "Bring";
                FormCategoryType[FormCategoryType["EmergencyContact"] = 140003] = "EmergencyContact";
                FormCategoryType[FormCategoryType["HealthHistory"] = 140004] = "HealthHistory";
                FormCategoryType[FormCategoryType["StudentAssessment"] = 140005] = "StudentAssessment";
                FormCategoryType[FormCategoryType["TermStaffApplicationForm"] = 140006] = "TermStaffApplicationForm";
                FormCategoryType[FormCategoryType["EmployeeHandbook"] = 140008] = "EmployeeHandbook";
                FormCategoryType[FormCategoryType["RequiredEmploymentPaperwork"] = 140009] = "RequiredEmploymentPaperwork";
                FormCategoryType[FormCategoryType["Certificate"] = 140010] = "Certificate";
                FormCategoryType[FormCategoryType["None"] = 140011] = "None";
                FormCategoryType[FormCategoryType["WeekendHousingAgreement"] = 140012] = "WeekendHousingAgreement";
                FormCategoryType[FormCategoryType["W4"] = 140013] = "W4";
                FormCategoryType[FormCategoryType["Covid19Vax"] = 140015] = "Covid19Vax";
                FormCategoryType[FormCategoryType["Covid19Other"] = 140016] = "Covid19Other";
            })(FormCategoryType = Enums.FormCategoryType || (Enums.FormCategoryType = {}));
            var FormLocationUsageType;
            (function (FormLocationUsageType) {
                FormLocationUsageType[FormLocationUsageType["ApplicantPreference"] = 248000] = "ApplicantPreference";
                FormLocationUsageType[FormLocationUsageType["HomeLocation"] = 248001] = "HomeLocation";
                FormLocationUsageType[FormLocationUsageType["HiringManagerPreference"] = 248002] = "HiringManagerPreference";
                FormLocationUsageType[FormLocationUsageType["AssignedLocation"] = 248003] = "AssignedLocation";
            })(FormLocationUsageType = Enums.FormLocationUsageType || (Enums.FormLocationUsageType = {}));
            var FormPersonChange;
            (function (FormPersonChange) {
                FormPersonChange[FormPersonChange["ReferenceRatingUpdate"] = 274000] = "ReferenceRatingUpdate";
            })(FormPersonChange = Enums.FormPersonChange || (Enums.FormPersonChange = {}));
            var FormPersonRole;
            (function (FormPersonRole) {
                FormPersonRole[FormPersonRole["PrimaryContact"] = 201000] = "PrimaryContact";
                FormPersonRole[FormPersonRole["SecondaryContact"] = 201001] = "SecondaryContact";
                FormPersonRole[FormPersonRole["PickUp"] = 201002] = "PickUp";
                FormPersonRole[FormPersonRole["EmploymentReference"] = 201003] = "EmploymentReference";
            })(FormPersonRole = Enums.FormPersonRole || (Enums.FormPersonRole = {}));
            var FormProcessHistoryType;
            (function (FormProcessHistoryType) {
                FormProcessHistoryType[FormProcessHistoryType["StatusChange"] = 233000] = "StatusChange";
                FormProcessHistoryType[FormProcessHistoryType["OwnershipChange"] = 233001] = "OwnershipChange";
                FormProcessHistoryType[FormProcessHistoryType["LogEntryOnly"] = 233002] = "LogEntryOnly";
            })(FormProcessHistoryType = Enums.FormProcessHistoryType || (Enums.FormProcessHistoryType = {}));
            var FormApplicationProcessingStatus;
            (function (FormApplicationProcessingStatus) {
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["New"] = 225000] = "New";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["Claimed"] = 225001] = "Claimed";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["ContactedForInterview"] = 225002] = "ContactedForInterview";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["NeedAdditionalInterview"] = 225003] = "NeedAdditionalInterview";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["InterviewsCompleted"] = 225004] = "InterviewsCompleted";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["VerbalOfferMade"] = 225005] = "VerbalOfferMade";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["VerbalOfferDeclined"] = 225006] = "VerbalOfferDeclined";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["VerbalOfferAccepted"] = 225007] = "VerbalOfferAccepted";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["WrittenOfferPreparation"] = 225008] = "WrittenOfferPreparation";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["WrittenOfferNeedApproval"] = 225009] = "WrittenOfferNeedApproval";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["WrittenOfferApproved"] = 225010] = "WrittenOfferApproved";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["WrittenOfferPublished"] = 225011] = "WrittenOfferPublished";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["WrittenOfferDeclined"] = 225012] = "WrittenOfferDeclined";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["PendingEmploymentPaperwork"] = 225013] = "PendingEmploymentPaperwork";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["EmploymentPaperworkCompleted"] = 225014] = "EmploymentPaperworkCompleted";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["ClearedForScheduling"] = 225015] = "ClearedForScheduling";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["Scheduled"] = 225016] = "Scheduled";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["Rejected"] = 225017] = "Rejected";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["Withdrawn"] = 225018] = "Withdrawn";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["InterviewCancelled"] = 225019] = "InterviewCancelled";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["WrittenOfferAccepted"] = 225020] = "WrittenOfferAccepted";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["Terminated"] = 225021] = "Terminated";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["WrittenOfferApprovalDenied"] = 225022] = "WrittenOfferApprovalDenied";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["None"] = 225023] = "None";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["Run"] = 225024] = "Run";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["Cleared"] = 225025] = "Cleared";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["DidNotClear"] = 225026] = "DidNotClear";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["UnclaimedAuto"] = 225027] = "UnclaimedAuto";
                FormApplicationProcessingStatus[FormApplicationProcessingStatus["UnclaimedByUser"] = 225028] = "UnclaimedByUser";
            })(FormApplicationProcessingStatus = Enums.FormApplicationProcessingStatus || (Enums.FormApplicationProcessingStatus = {}));
            var FormRequiredType;
            (function (FormRequiredType) {
                FormRequiredType[FormRequiredType["Required"] = 139000] = "Required";
                FormRequiredType[FormRequiredType["Additional"] = 139001] = "Additional";
                FormRequiredType[FormRequiredType["EmployeeRequired"] = 139003] = "EmployeeRequired";
                FormRequiredType[FormRequiredType["EmployeeAdditional"] = 139004] = "EmployeeAdditional";
                FormRequiredType[FormRequiredType["EmployeeLocationSpecific"] = 139005] = "EmployeeLocationSpecific";
                FormRequiredType[FormRequiredType["EmployeeInternalTrackingOnly"] = 139006] = "EmployeeInternalTrackingOnly";
            })(FormRequiredType = Enums.FormRequiredType || (Enums.FormRequiredType = {}));
            var FormSectionType;
            (function (FormSectionType) {
                FormSectionType[FormSectionType["PhysicalExam"] = 178000] = "PhysicalExam";
                FormSectionType[FormSectionType["Immunization"] = 178001] = "Immunization";
                FormSectionType[FormSectionType["Medication"] = 178002] = "Medication";
                FormSectionType[FormSectionType["EmployeeHandbook"] = 178003] = "EmployeeHandbook";
                FormSectionType[FormSectionType["EmployeeConfidentialityAgreement"] = 178004] = "EmployeeConfidentialityAgreement";
                FormSectionType[FormSectionType["ArbitrationAgreement"] = 178005] = "ArbitrationAgreement";
                FormSectionType[FormSectionType["EmergencyContacts"] = 178006] = "EmergencyContacts";
                FormSectionType[FormSectionType["HealthInformation"] = 178007] = "HealthInformation";
                FormSectionType[FormSectionType["BackgroundCheckAuthorization"] = 178008] = "BackgroundCheckAuthorization";
                FormSectionType[FormSectionType["References"] = 178009] = "References";
                FormSectionType[FormSectionType["DirectDepositInformation"] = 178010] = "DirectDepositInformation";
                FormSectionType[FormSectionType["PayDisbursement"] = 178011] = "PayDisbursement";
                FormSectionType[FormSectionType["iPayAuthorization"] = 178012] = "iPayAuthorization";
                FormSectionType[FormSectionType["iDDebitCardAgreement"] = 178013] = "iDDebitCardAgreement";
                FormSectionType[FormSectionType["StaffBioApparel"] = 178014] = "StaffBioApparel";
                FormSectionType[FormSectionType["VoluntaryDisclosure"] = 178015] = "VoluntaryDisclosure";
            })(FormSectionType = Enums.FormSectionType || (Enums.FormSectionType = {}));
            var FormStatus;
            (function (FormStatus) {
                FormStatus[FormStatus["NotReceived"] = 143000] = "NotReceived";
                FormStatus[FormStatus["Received"] = 143001] = "Received";
                FormStatus[FormStatus["Complete"] = 143002] = "Complete";
                FormStatus[FormStatus["Incomplete"] = 143003] = "Incomplete";
                FormStatus[FormStatus["NotApplicable"] = 143004] = "NotApplicable";
                FormStatus[FormStatus["BringToSession"] = 143005] = "BringToSession";
                FormStatus[FormStatus["UpdateRecommended"] = 143006] = "UpdateRecommended";
                FormStatus[FormStatus["MedsOnlyIncomplete"] = 143007] = "MedsOnlyIncomplete";
            })(FormStatus = Enums.FormStatus || (Enums.FormStatus = {}));
            var FulfillmentStatusType;
            (function (FulfillmentStatusType) {
                FulfillmentStatusType[FulfillmentStatusType["Pending"] = 73000] = "Pending";
                FulfillmentStatusType[FulfillmentStatusType["ReferredtoCS"] = 73001] = "ReferredtoCS";
                FulfillmentStatusType[FulfillmentStatusType["Fulfilled"] = 73002] = "Fulfilled";
                FulfillmentStatusType[FulfillmentStatusType["Dismissed"] = 73003] = "Dismissed";
            })(FulfillmentStatusType = Enums.FulfillmentStatusType || (Enums.FulfillmentStatusType = {}));
            var GenderGroup;
            (function (GenderGroup) {
                GenderGroup[GenderGroup["Student"] = 397000] = "Student";
                GenderGroup[GenderGroup["Staff"] = 397001] = "Staff";
            })(GenderGroup = Enums.GenderGroup || (Enums.GenderGroup = {}));
            var GenderType;
            (function (GenderType) {
                GenderType[GenderType["Male"] = 99000] = "Male";
                GenderType[GenderType["Female"] = 99001] = "Female";
                GenderType[GenderType["NonBinary"] = 99002] = "NonBinary";
                GenderType[GenderType["NotListed"] = 99003] = "NotListed";
                GenderType[GenderType["PreferNotToState"] = 99004] = "PreferNotToState";
            })(GenderType = Enums.GenderType || (Enums.GenderType = {}));
            var GeographicRegion;
            (function (GeographicRegion) {
                GeographicRegion[GeographicRegion["East"] = 267000] = "East";
                GeographicRegion[GeographicRegion["Central"] = 267001] = "Central";
                GeographicRegion[GeographicRegion["West"] = 267002] = "West";
            })(GeographicRegion = Enums.GeographicRegion || (Enums.GeographicRegion = {}));
            var HousingReason;
            (function (HousingReason) {
                HousingReason[HousingReason["Orientation"] = 270000] = "Orientation";
                HousingReason[HousingReason["SetUp"] = 270001] = "SetUp";
                HousingReason[HousingReason["ERTransfer"] = 270002] = "ERTransfer";
                HousingReason[HousingReason["EETransfer"] = 270003] = "EETransfer";
                HousingReason[HousingReason["PayrollUseOnly"] = 270004] = "PayrollUseOnly";
            })(HousingReason = Enums.HousingReason || (Enums.HousingReason = {}));
            var HowHeardAboutType;
            (function (HowHeardAboutType) {
                HowHeardAboutType[HowHeardAboutType["ArticleInPublication"] = 59000] = "ArticleInPublication";
                HowHeardAboutType[HowHeardAboutType["AdInMagazine"] = 59001] = "AdInMagazine";
                HowHeardAboutType[HowHeardAboutType["BrochureFromStore"] = 59002] = "BrochureFromStore";
                HowHeardAboutType[HowHeardAboutType["DVDfromiD"] = 59003] = "DVDfromiD";
                HowHeardAboutType[HowHeardAboutType["CampusCareerCenter"] = 59004] = "CampusCareerCenter";
                HowHeardAboutType[HowHeardAboutType["FlyerOnSchoolCampus"] = 59005] = "FlyerOnSchoolCampus";
                HowHeardAboutType[HowHeardAboutType["BannerAdOnWebSite"] = 59006] = "BannerAdOnWebSite";
                HowHeardAboutType[HowHeardAboutType["CampDirectoriesOnWeb"] = 59007] = "CampDirectoriesOnWeb";
                HowHeardAboutType[HowHeardAboutType["CraigsList"] = 59008] = "CraigsList";
                HowHeardAboutType[HowHeardAboutType["ULoop"] = 59009] = "ULoop";
                HowHeardAboutType[HowHeardAboutType["WebSearchGoogle"] = 59010] = "WebSearchGoogle";
                HowHeardAboutType[HowHeardAboutType["WebSearchYahoo"] = 59011] = "WebSearchYahoo";
                HowHeardAboutType[HowHeardAboutType["ReferralFromFriend"] = 59012] = "ReferralFromFriend";
                HowHeardAboutType[HowHeardAboutType["ReturningParticipant"] = 59013] = "ReturningParticipant";
                HowHeardAboutType[HowHeardAboutType["FormerParticipant"] = 59014] = "FormerParticipant";
                HowHeardAboutType[HowHeardAboutType["EmailFrominternalDrive"] = 59015] = "EmailFrominternalDrive";
                HowHeardAboutType[HowHeardAboutType["SchoolNewsletter"] = 59016] = "SchoolNewsletter";
                HowHeardAboutType[HowHeardAboutType["MovieTheatreAd"] = 59017] = "MovieTheatreAd";
                HowHeardAboutType[HowHeardAboutType["CampFair"] = 59018] = "CampFair";
                HowHeardAboutType[HowHeardAboutType["TradeShow"] = 59019] = "TradeShow";
                HowHeardAboutType[HowHeardAboutType["JobFair"] = 59020] = "JobFair";
                HowHeardAboutType[HowHeardAboutType["CampusEvent"] = 59021] = "CampusEvent";
                HowHeardAboutType[HowHeardAboutType["Radio"] = 59022] = "Radio";
                HowHeardAboutType[HowHeardAboutType["TVNews"] = 59023] = "TVNews";
                HowHeardAboutType[HowHeardAboutType["CampAdvisors"] = 59025] = "CampAdvisors";
                HowHeardAboutType[HowHeardAboutType["BrochurefromSchool"] = 59026] = "BrochurefromSchool";
                HowHeardAboutType[HowHeardAboutType["Other"] = 59027] = "Other";
                HowHeardAboutType[HowHeardAboutType["ReferralFromFriendFamily"] = 59028] = "ReferralFromFriendFamily";
                HowHeardAboutType[HowHeardAboutType["CampusProfessorStaff"] = 59029] = "CampusProfessorStaff";
                HowHeardAboutType[HowHeardAboutType["NACElink"] = 59030] = "NACElink";
                HowHeardAboutType[HowHeardAboutType["CampusWebsiteOrCampusJobBoardDuplicate"] = 59031] = "CampusWebsiteOrCampusJobBoardDuplicate";
                HowHeardAboutType[HowHeardAboutType["SummerJobsSearchSite"] = 59032] = "SummerJobsSearchSite";
                HowHeardAboutType[HowHeardAboutType["TrackingCodeReferral"] = 59033] = "TrackingCodeReferral";
            })(HowHeardAboutType = Enums.HowHeardAboutType || (Enums.HowHeardAboutType = {}));
            var HowHeardAboutCategoryType;
            (function (HowHeardAboutCategoryType) {
                HowHeardAboutCategoryType[HowHeardAboutCategoryType["PrintMedia"] = 60000] = "PrintMedia";
                HowHeardAboutCategoryType[HowHeardAboutCategoryType["DirectMail"] = 60001] = "DirectMail";
                HowHeardAboutCategoryType[HowHeardAboutCategoryType["Online"] = 60002] = "Online";
                HowHeardAboutCategoryType[HowHeardAboutCategoryType["WebSearch"] = 60003] = "WebSearch";
                HowHeardAboutCategoryType[HowHeardAboutCategoryType["Referral"] = 60004] = "Referral";
                HowHeardAboutCategoryType[HowHeardAboutCategoryType["Newsletter"] = 60005] = "Newsletter";
                HowHeardAboutCategoryType[HowHeardAboutCategoryType["Event"] = 60006] = "Event";
                HowHeardAboutCategoryType[HowHeardAboutCategoryType["PublicMedia"] = 60007] = "PublicMedia";
            })(HowHeardAboutCategoryType = Enums.HowHeardAboutCategoryType || (Enums.HowHeardAboutCategoryType = {}));
            var HowHeardAboutAudienceType;
            (function (HowHeardAboutAudienceType) {
                HowHeardAboutAudienceType[HowHeardAboutAudienceType["Client"] = 61000] = "Client";
                HowHeardAboutAudienceType[HowHeardAboutAudienceType["Staff"] = 61001] = "Staff";
            })(HowHeardAboutAudienceType = Enums.HowHeardAboutAudienceType || (Enums.HowHeardAboutAudienceType = {}));
            var HRLogActionType;
            (function (HRLogActionType) {
                HRLogActionType[HRLogActionType["ScheduledInterview"] = 238000] = "ScheduledInterview";
                HRLogActionType[HRLogActionType["ActualInterview"] = 238001] = "ActualInterview";
                HRLogActionType[HRLogActionType["RejectApplicant"] = 238002] = "RejectApplicant";
                HRLogActionType[HRLogActionType["RescindOffer"] = 238003] = "RescindOffer";
                HRLogActionType[HRLogActionType["OfferDeclined"] = 238004] = "OfferDeclined";
                HRLogActionType[HRLogActionType["TerminateEmployee"] = 238005] = "TerminateEmployee";
                HRLogActionType[HRLogActionType["Resignation"] = 238006] = "Resignation";
                HRLogActionType[HRLogActionType["SubmitApplication"] = 238007] = "SubmitApplication";
                HRLogActionType[HRLogActionType["ResubmitApplication"] = 238008] = "ResubmitApplication";
                HRLogActionType[HRLogActionType["WithdrawApplication"] = 238009] = "WithdrawApplication";
                HRLogActionType[HRLogActionType["OfferAccepted"] = 238010] = "OfferAccepted";
                HRLogActionType[HRLogActionType["GeneralNote"] = 238011] = "GeneralNote";
                HRLogActionType[HRLogActionType["Promotion"] = 238012] = "Promotion";
                HRLogActionType[HRLogActionType["Demotion"] = 238013] = "Demotion";
                HRLogActionType[HRLogActionType["Change"] = 238014] = "Change";
                HRLogActionType[HRLogActionType["RequestApproval"] = 238016] = "RequestApproval";
                HRLogActionType[HRLogActionType["ApprovalDenied"] = 238017] = "ApprovalDenied";
                HRLogActionType[HRLogActionType["Published"] = 238018] = "Published";
                HRLogActionType[HRLogActionType["Claim"] = 238019] = "Claim";
                HRLogActionType[HRLogActionType["Unclaim"] = 238020] = "Unclaim";
                HRLogActionType[HRLogActionType["TransferOwnership"] = 238021] = "TransferOwnership";
                HRLogActionType[HRLogActionType["BackgroundCheck"] = 238025] = "BackgroundCheck";
                HRLogActionType[HRLogActionType["RequiredPaperwork"] = 238026] = "RequiredPaperwork";
                HRLogActionType[HRLogActionType["EmployeeHandbook"] = 238027] = "EmployeeHandbook";
                HRLogActionType[HRLogActionType["ReferenceCheck"] = 238028] = "ReferenceCheck";
                HRLogActionType[HRLogActionType["Certifications"] = 238029] = "Certifications";
                HRLogActionType[HRLogActionType["OtherPaperwork"] = 238030] = "OtherPaperwork";
                HRLogActionType[HRLogActionType["ApprovalGranted"] = 238044] = "ApprovalGranted";
                HRLogActionType[HRLogActionType["OfferPreparation"] = 238045] = "OfferPreparation";
                HRLogActionType[HRLogActionType["ClearForScheduling"] = 238046] = "ClearForScheduling";
                HRLogActionType[HRLogActionType["RevokeClearanceForScheduling"] = 238047] = "RevokeClearanceForScheduling";
                HRLogActionType[HRLogActionType["FormStatusChange"] = 238048] = "FormStatusChange";
                HRLogActionType[HRLogActionType["ExpirationDateChange"] = 238049] = "ExpirationDateChange";
                HRLogActionType[HRLogActionType["Certification"] = 238029] = "Certification";
                HRLogActionType[HRLogActionType["ARFStatusChange"] = 238050] = "ARFStatusChange";
                HRLogActionType[HRLogActionType["ManualChange"] = 238051] = "ManualChange";
                HRLogActionType[HRLogActionType["AutoChange"] = 238052] = "AutoChange";
                HRLogActionType[HRLogActionType["WeekSchedulerChange"] = 238053] = "WeekSchedulerChange";
                HRLogActionType[HRLogActionType["TabAssignmentsSchedulerChange"] = 238054] = "TabAssignmentsSchedulerChange";
                HRLogActionType[HRLogActionType["ProductControllerChange"] = 238055] = "ProductControllerChange";
                HRLogActionType[HRLogActionType["JobOfferControllerChange"] = 238056] = "JobOfferControllerChange";
                HRLogActionType[HRLogActionType["JobAppReviewControllerChange"] = 238057] = "JobAppReviewControllerChange";
            })(HRLogActionType = Enums.HRLogActionType || (Enums.HRLogActionType = {}));
            var HRLogCategoryType;
            (function (HRLogCategoryType) {
                HRLogCategoryType[HRLogCategoryType["Interview"] = 237000] = "Interview";
                HRLogCategoryType[HRLogCategoryType["Reject_Terminate"] = 237001] = "Reject_Terminate";
                HRLogCategoryType[HRLogCategoryType["Application"] = 237002] = "Application";
                HRLogCategoryType[HRLogCategoryType["WrittenOffer"] = 237003] = "WrittenOffer";
                HRLogCategoryType[HRLogCategoryType["VerbalOffer"] = 237004] = "VerbalOffer";
                HRLogCategoryType[HRLogCategoryType["Preferences"] = 237006] = "Preferences";
                HRLogCategoryType[HRLogCategoryType["Processing"] = 237007] = "Processing";
                HRLogCategoryType[HRLogCategoryType["ContactInfoChange"] = 237015] = "ContactInfoChange";
                HRLogCategoryType[HRLogCategoryType["EmploymentProfileChange"] = 237016] = "EmploymentProfileChange";
                HRLogCategoryType[HRLogCategoryType["StatusChange"] = 237017] = "StatusChange";
                HRLogCategoryType[HRLogCategoryType["Scheduling"] = 237018] = "Scheduling";
            })(HRLogCategoryType = Enums.HRLogCategoryType || (Enums.HRLogCategoryType = {}));
            var HRLogEntryType;
            (function (HRLogEntryType) {
                HRLogEntryType[HRLogEntryType["Auto"] = 245000] = "Auto";
                HRLogEntryType[HRLogEntryType["Manual"] = 245001] = "Manual";
            })(HRLogEntryType = Enums.HRLogEntryType || (Enums.HRLogEntryType = {}));
            var HRLogReasonType;
            (function (HRLogReasonType) {
                HRLogReasonType[HRLogReasonType["Other"] = 240005] = "Other";
                HRLogReasonType[HRLogReasonType["UnsatisfactoryPerformance"] = 240015] = "UnsatisfactoryPerformance";
                HRLogReasonType[HRLogReasonType["ViolationOfCompanyPolicy"] = 240016] = "ViolationOfCompanyPolicy";
                HRLogReasonType[HRLogReasonType["EndOfTerm"] = 240017] = "EndOfTerm";
            })(HRLogReasonType = Enums.HRLogReasonType || (Enums.HRLogReasonType = {}));
            var ImmunizationStatus;
            (function (ImmunizationStatus) {
                ImmunizationStatus[ImmunizationStatus["NeverImmunized"] = 199000] = "NeverImmunized";
                ImmunizationStatus[ImmunizationStatus["ImmunizedNotSureWhen"] = 199001] = "ImmunizedNotSureWhen";
                ImmunizationStatus[ImmunizationStatus["Immunized"] = 199002] = "Immunized";
            })(ImmunizationStatus = Enums.ImmunizationStatus || (Enums.ImmunizationStatus = {}));
            var ImmunizationType;
            (function (ImmunizationType) {
                ImmunizationType[ImmunizationType["Tetanus"] = 198000] = "Tetanus";
                ImmunizationType[ImmunizationType["Diphtheria"] = 198001] = "Diphtheria";
                ImmunizationType[ImmunizationType["Polio"] = 198002] = "Polio";
                ImmunizationType[ImmunizationType["MeaslesMumpsRubella"] = 198003] = "MeaslesMumpsRubella";
                ImmunizationType[ImmunizationType["Measles"] = 198004] = "Measles";
                ImmunizationType[ImmunizationType["Mumps"] = 198005] = "Mumps";
                ImmunizationType[ImmunizationType["Rubella"] = 198006] = "Rubella";
                ImmunizationType[ImmunizationType["HaemophilusInfluenzaTypeB"] = 198007] = "HaemophilusInfluenzaTypeB";
                ImmunizationType[ImmunizationType["HepatitisA"] = 198008] = "HepatitisA";
                ImmunizationType[ImmunizationType["HepatitisB"] = 198009] = "HepatitisB";
                ImmunizationType[ImmunizationType["Varicella"] = 198010] = "Varicella";
                ImmunizationType[ImmunizationType["CovidDose1"] = 198011] = "CovidDose1";
                ImmunizationType[ImmunizationType["CovidDose2"] = 198012] = "CovidDose2";
                ImmunizationType[ImmunizationType["CovidBooster1"] = 198013] = "CovidBooster1";
                ImmunizationType[ImmunizationType["CovidBooster2"] = 198014] = "CovidBooster2";
            })(ImmunizationType = Enums.ImmunizationType || (Enums.ImmunizationType = {}));
            var Covid19ImmunizationType;
            (function (Covid19ImmunizationType) {
                Covid19ImmunizationType[Covid19ImmunizationType["PfizerBioNTech"] = 402000] = "PfizerBioNTech";
                Covid19ImmunizationType[Covid19ImmunizationType["Moderna"] = 402001] = "Moderna";
                Covid19ImmunizationType[Covid19ImmunizationType["JanssenJohnsonJohnson"] = 402002] = "JanssenJohnsonJohnson";
                Covid19ImmunizationType[Covid19ImmunizationType["AstraZeneca"] = 402003] = "AstraZeneca";
                Covid19ImmunizationType[Covid19ImmunizationType["Covaxin"] = 402004] = "Covaxin";
                Covid19ImmunizationType[Covid19ImmunizationType["Covishield"] = 402005] = "Covishield";
                Covid19ImmunizationType[Covid19ImmunizationType["BIBPSinopharm"] = 402006] = "BIBPSinopharm";
                Covid19ImmunizationType[Covid19ImmunizationType["Sinovac"] = 402007] = "Sinovac";
                Covid19ImmunizationType[Covid19ImmunizationType["NovavaxCovovax"] = 402008] = "NovavaxCovovax";
                Covid19ImmunizationType[Covid19ImmunizationType["Other"] = 402009] = "Other";
            })(Covid19ImmunizationType = Enums.Covid19ImmunizationType || (Enums.Covid19ImmunizationType = {}));
            var InsuranceType;
            (function (InsuranceType) {
                InsuranceType[InsuranceType["Health"] = 200000] = "Health";
            })(InsuranceType = Enums.InsuranceType || (Enums.InsuranceType = {}));
            var InfoRequestMethod;
            (function (InfoRequestMethod) {
                InfoRequestMethod[InfoRequestMethod["CSPhone"] = 149000] = "CSPhone";
                InfoRequestMethod[InfoRequestMethod["Client"] = 149001] = "Client";
                InfoRequestMethod[InfoRequestMethod["CSEmail"] = 149002] = "CSEmail";
                InfoRequestMethod[InfoRequestMethod["CSMail"] = 149003] = "CSMail";
                InfoRequestMethod[InfoRequestMethod["CSCampAdvisor"] = 149004] = "CSCampAdvisor";
            })(InfoRequestMethod = Enums.InfoRequestMethod || (Enums.InfoRequestMethod = {}));
            var InfoRequestMethodCategory;
            (function (InfoRequestMethodCategory) {
                InfoRequestMethodCategory[InfoRequestMethodCategory["Client"] = 194000] = "Client";
                InfoRequestMethodCategory[InfoRequestMethodCategory["CustomerService"] = 194001] = "CustomerService";
            })(InfoRequestMethodCategory = Enums.InfoRequestMethodCategory || (Enums.InfoRequestMethodCategory = {}));
            var InfoRequestType;
            (function (InfoRequestType) {
                InfoRequestType[InfoRequestType["Catalog"] = 67000] = "Catalog";
                InfoRequestType[InfoRequestType["iDOnSite"] = 67001] = "iDOnSite";
                InfoRequestType[InfoRequestType["WaitList"] = 67002] = "WaitList";
                InfoRequestType[InfoRequestType["ShoppingSession"] = 67003] = "ShoppingSession";
            })(InfoRequestType = Enums.InfoRequestType || (Enums.InfoRequestType = {}));
            var JobClass;
            (function (JobClass) {
                JobClass[JobClass["CL_Clerical"] = 222000] = "CL_Clerical";
                JobClass[JobClass["MG_Management"] = 222001] = "MG_Management";
                JobClass[JobClass["SM_SeniorManagement"] = 222002] = "SM_SeniorManagement";
                JobClass[JobClass["TC_Technical"] = 222003] = "TC_Technical";
                JobClass[JobClass["SP_SalesPersonnel"] = 222004] = "SP_SalesPersonnel";
            })(JobClass = Enums.JobClass || (Enums.JobClass = {}));
            var JobFLSACompensation;
            (function (JobFLSACompensation) {
                JobFLSACompensation[JobFLSACompensation["Exempt"] = 221000] = "Exempt";
                JobFLSACompensation[JobFLSACompensation["NonExempt"] = 221001] = "NonExempt";
            })(JobFLSACompensation = Enums.JobFLSACompensation || (Enums.JobFLSACompensation = {}));
            var JobGenre;
            (function (JobGenre) {
                JobGenre[JobGenre["Director"] = 269000] = "Director";
                JobGenre[JobGenre["AsstDirector"] = 269001] = "AsstDirector";
                JobGenre[JobGenre["HealthSafety"] = 269002] = "HealthSafety";
                JobGenre[JobGenre["ActivityCoordinator"] = 269003] = "ActivityCoordinator";
                JobGenre[JobGenre["LeadInstructor"] = 269004] = "LeadInstructor";
                JobGenre[JobGenre["Instructor"] = 269005] = "Instructor";
            })(JobGenre = Enums.JobGenre || (Enums.JobGenre = {}));
            var JobInterviewStatusType;
            (function (JobInterviewStatusType) {
                JobInterviewStatusType[JobInterviewStatusType["Cancelled"] = 239000] = "Cancelled";
                JobInterviewStatusType[JobInterviewStatusType["Completed"] = 239001] = "Completed";
                JobInterviewStatusType[JobInterviewStatusType["NeedAdditional"] = 239002] = "NeedAdditional";
            })(JobInterviewStatusType = Enums.JobInterviewStatusType || (Enums.JobInterviewStatusType = {}));
            var JobInterviewType;
            (function (JobInterviewType) {
                JobInterviewType[JobInterviewType["Scheduled"] = 236000] = "Scheduled";
                JobInterviewType[JobInterviewType["Actual"] = 236001] = "Actual";
            })(JobInterviewType = Enums.JobInterviewType || (Enums.JobInterviewType = {}));
            var JobApprovalRequirement;
            (function (JobApprovalRequirement) {
                JobApprovalRequirement[JobApprovalRequirement["DiscretionaryPay"] = 297000] = "DiscretionaryPay";
                JobApprovalRequirement[JobApprovalRequirement["RequireIfNoAssignmentHistory"] = 297001] = "RequireIfNoAssignmentHistory";
                JobApprovalRequirement[JobApprovalRequirement["AlwaysRequire"] = 297002] = "AlwaysRequire";
            })(JobApprovalRequirement = Enums.JobApprovalRequirement || (Enums.JobApprovalRequirement = {}));
            var JobOfferType;
            (function (JobOfferType) {
                JobOfferType[JobOfferType["VerbalOffer"] = 247000] = "VerbalOffer";
                JobOfferType[JobOfferType["WrittenOffer"] = 247001] = "WrittenOffer";
            })(JobOfferType = Enums.JobOfferType || (Enums.JobOfferType = {}));
            var JobOfferStatus;
            (function (JobOfferStatus) {
                JobOfferStatus[JobOfferStatus["Declined"] = 246000] = "Declined";
                JobOfferStatus[JobOfferStatus["Draft"] = 246001] = "Draft";
                JobOfferStatus[JobOfferStatus["NeedApproval"] = 246002] = "NeedApproval";
                JobOfferStatus[JobOfferStatus["Approved"] = 246003] = "Approved";
                JobOfferStatus[JobOfferStatus["Published"] = 246004] = "Published";
                JobOfferStatus[JobOfferStatus["Accepted"] = 246005] = "Accepted";
                JobOfferStatus[JobOfferStatus["ApprovalDenied"] = 246006] = "ApprovalDenied";
                JobOfferStatus[JobOfferStatus["Rescinded"] = 246007] = "Rescinded";
            })(JobOfferStatus = Enums.JobOfferStatus || (Enums.JobOfferStatus = {}));
            var JobPurview;
            (function (JobPurview) {
                JobPurview[JobPurview["CampWide"] = 268000] = "CampWide";
                JobPurview[JobPurview["Instruction"] = 268001] = "Instruction";
            })(JobPurview = Enums.JobPurview || (Enums.JobPurview = {}));
            var JobResidencyPreference;
            (function (JobResidencyPreference) {
                JobResidencyPreference[JobResidencyPreference["ON"] = 229000] = "ON";
                JobResidencyPreference[JobResidencyPreference["ON_Wknd"] = 229001] = "ON_Wknd";
                JobResidencyPreference[JobResidencyPreference["Commute"] = 229002] = "Commute";
                JobResidencyPreference[JobResidencyPreference["Com_Housing"] = 229003] = "Com_Housing";
                JobResidencyPreference[JobResidencyPreference["Com_Housing_Wnd"] = 229004] = "Com_Housing_Wnd";
            })(JobResidencyPreference = Enums.JobResidencyPreference || (Enums.JobResidencyPreference = {}));
            var JobSchedule;
            (function (JobSchedule) {
                JobSchedule[JobSchedule["HalfDay"] = 322000] = "HalfDay";
                JobSchedule[JobSchedule["FullDay"] = 322001] = "FullDay";
            })(JobSchedule = Enums.JobSchedule || (Enums.JobSchedule = {}));
            var JobVisibility;
            (function (JobVisibility) {
                JobVisibility[JobVisibility["TermStaffAppOnly"] = 223000] = "TermStaffAppOnly";
                JobVisibility[JobVisibility["TermStaffAppAndOfferTitle"] = 223001] = "TermStaffAppAndOfferTitle";
                JobVisibility[JobVisibility["JobOfferTitleOnly"] = 223002] = "JobOfferTitleOnly";
                JobVisibility[JobVisibility["SchedulingUnit"] = 223003] = "SchedulingUnit";
            })(JobVisibility = Enums.JobVisibility || (Enums.JobVisibility = {}));
            var LanguageType;
            (function (LanguageType) {
                LanguageType[LanguageType["EnglishUS"] = 24000] = "EnglishUS";
            })(LanguageType = Enums.LanguageType || (Enums.LanguageType = {}));
            var LetterType;
            (function (LetterType) {
                LetterType[LetterType["PostInterviewRejection_NewApplicant"] = 242000] = "PostInterviewRejection_NewApplicant";
                LetterType[LetterType["PostInterviewRejection_ReturningApplicant"] = 242001] = "PostInterviewRejection_ReturningApplicant";
                LetterType[LetterType["RescindOffer_Unresponsive"] = 242002] = "RescindOffer_Unresponsive";
                LetterType[LetterType["RescindOffer_BackgroundReferences"] = 242003] = "RescindOffer_BackgroundReferences";
                LetterType[LetterType["PreInterviewRejection_NewApplicant"] = 242004] = "PreInterviewRejection_NewApplicant";
                LetterType[LetterType["PreInterviewRejection_ReturningApplicant"] = 242005] = "PreInterviewRejection_ReturningApplicant";
                LetterType[LetterType["VerbalOffer_CommitmentToID"] = 242006] = "VerbalOffer_CommitmentToID";
                LetterType[LetterType["WrittenOfferNotification"] = 242007] = "WrittenOfferNotification";
                LetterType[LetterType["WrittenOffer"] = 242008] = "WrittenOffer";
                LetterType[LetterType["WrittenOfferJobDescription"] = 242009] = "WrittenOfferJobDescription";
                LetterType[LetterType["WrittenOfferQualityAssurance"] = 242010] = "WrittenOfferQualityAssurance";
                LetterType[LetterType["WrittenOfferReminder"] = 242011] = "WrittenOfferReminder";
                LetterType[LetterType["ReferenceCheck"] = 242012] = "ReferenceCheck";
                LetterType[LetterType["TermStaffWorkSchedule"] = 242013] = "TermStaffWorkSchedule";
            })(LetterType = Enums.LetterType || (Enums.LetterType = {}));
            var LicenseAssignmentRequestType;
            (function (LicenseAssignmentRequestType) {
                LicenseAssignmentRequestType[LicenseAssignmentRequestType["ActualAssignments"] = 372000] = "ActualAssignments";
                LicenseAssignmentRequestType[LicenseAssignmentRequestType["CheckInventory"] = 372001] = "CheckInventory";
            })(LicenseAssignmentRequestType = Enums.LicenseAssignmentRequestType || (Enums.LicenseAssignmentRequestType = {}));
            var LicenseItemAssignmentTarget;
            (function (LicenseItemAssignmentTarget) {
                LicenseItemAssignmentTarget[LicenseItemAssignmentTarget["Universal"] = 370000] = "Universal";
                LicenseItemAssignmentTarget[LicenseItemAssignmentTarget["DivLocation"] = 370001] = "DivLocation";
                LicenseItemAssignmentTarget[LicenseItemAssignmentTarget["DivLocationCourse"] = 370002] = "DivLocationCourse";
                LicenseItemAssignmentTarget[LicenseItemAssignmentTarget["Student"] = 370003] = "Student";
                LicenseItemAssignmentTarget[LicenseItemAssignmentTarget["Staff"] = 370004] = "Staff";
            })(LicenseItemAssignmentTarget = Enums.LicenseItemAssignmentTarget || (Enums.LicenseItemAssignmentTarget = {}));
            var LicenseItemCategory;
            (function (LicenseItemCategory) {
                LicenseItemCategory[LicenseItemCategory["Account"] = 369000] = "Account";
                LicenseItemCategory[LicenseItemCategory["Key"] = 369001] = "Key";
            })(LicenseItemCategory = Enums.LicenseItemCategory || (Enums.LicenseItemCategory = {}));
            var LicenseItemStatus;
            (function (LicenseItemStatus) {
                LicenseItemStatus[LicenseItemStatus["Unassigned"] = 371000] = "Unassigned";
                LicenseItemStatus[LicenseItemStatus["Assigned"] = 371001] = "Assigned";
            })(LicenseItemStatus = Enums.LicenseItemStatus || (Enums.LicenseItemStatus = {}));
            var LimitType;
            (function (LimitType) {
                LimitType[LimitType["Numeric"] = 42000] = "Numeric";
                LimitType[LimitType["Percent"] = 42001] = "Percent";
            })(LimitType = Enums.LimitType || (Enums.LimitType = {}));
            var LocationType;
            (function (LocationType) {
                LocationType[LocationType["UniversityCollege"] = 14000] = "UniversityCollege";
                LocationType[LocationType["Online"] = 14001] = "Online";
                LocationType[LocationType["VirtualSummerCamp"] = 14002] = "VirtualSummerCamp";
                LocationType[LocationType["VirtualSquads"] = 14003] = "VirtualSquads";
                LocationType[LocationType["BootcampPartnership"] = 14004] = "BootcampPartnership";
            })(LocationType = Enums.LocationType || (Enums.LocationType = {}));
            var LocationAvailabilityTypeAttr;
            (function (LocationAvailabilityTypeAttr) {
                LocationAvailabilityTypeAttr[LocationAvailabilityTypeAttr["None"] = -1] = "None";
                LocationAvailabilityTypeAttr[LocationAvailabilityTypeAttr["Open"] = 1] = "Open";
                LocationAvailabilityTypeAttr[LocationAvailabilityTypeAttr["ComingSoon"] = 2] = "ComingSoon";
                LocationAvailabilityTypeAttr[LocationAvailabilityTypeAttr["In2Years"] = 3] = "In2Years";
            })(LocationAvailabilityTypeAttr = Enums.LocationAvailabilityTypeAttr || (Enums.LocationAvailabilityTypeAttr = {}));
            var LocationContactUsageType;
            (function (LocationContactUsageType) {
                LocationContactUsageType[LocationContactUsageType["VisitorInformation"] = 282000] = "VisitorInformation";
                LocationContactUsageType[LocationContactUsageType["CampDirector"] = 282001] = "CampDirector";
                LocationContactUsageType[LocationContactUsageType["CampAssistantDirector"] = 282002] = "CampAssistantDirector";
            })(LocationContactUsageType = Enums.LocationContactUsageType || (Enums.LocationContactUsageType = {}));
            var LocationSessionTextType;
            (function (LocationSessionTextType) {
                LocationSessionTextType[LocationSessionTextType["AlertNotes"] = 325000] = "AlertNotes";
                LocationSessionTextType[LocationSessionTextType["CSAlertNotes"] = 325001] = "CSAlertNotes";
            })(LocationSessionTextType = Enums.LocationSessionTextType || (Enums.LocationSessionTextType = {}));
            var LocationUserRoleType;
            (function (LocationUserRoleType) {
                LocationUserRoleType[LocationUserRoleType["MainContactLiaison"] = 283000] = "MainContactLiaison";
                LocationUserRoleType[LocationUserRoleType["SummerConferenceAsst"] = 283001] = "SummerConferenceAsst";
                LocationUserRoleType[LocationUserRoleType["PressLiaison"] = 283002] = "PressLiaison";
                LocationUserRoleType[LocationUserRoleType["ParkingContact"] = 283003] = "ParkingContact";
                LocationUserRoleType[LocationUserRoleType["ResidenceHallContact"] = 283004] = "ResidenceHallContact";
                LocationUserRoleType[LocationUserRoleType["DiningServicesContact"] = 283005] = "DiningServicesContact";
                LocationUserRoleType[LocationUserRoleType["LabSpaceContact"] = 283006] = "LabSpaceContact";
                LocationUserRoleType[LocationUserRoleType["LabTechnicalSupportContact"] = 283007] = "LabTechnicalSupportContact";
                LocationUserRoleType[LocationUserRoleType["LabTechnicalSupportContactAlt"] = 283008] = "LabTechnicalSupportContactAlt";
                LocationUserRoleType[LocationUserRoleType["ElectricalAuthorityContact"] = 283009] = "ElectricalAuthorityContact";
                LocationUserRoleType[LocationUserRoleType["ShippingContact"] = 283010] = "ShippingContact";
                LocationUserRoleType[LocationUserRoleType["MailroomContact"] = 283011] = "MailroomContact";
            })(LocationUserRoleType = Enums.LocationUserRoleType || (Enums.LocationUserRoleType = {}));
            var LSISectionType;
            (function (LSISectionType) {
                LSISectionType[LSISectionType["GeneralInfo2"] = 286000] = "GeneralInfo2";
                LSISectionType[LSISectionType["Parking"] = 286001] = "Parking";
                LSISectionType[LSISectionType["MiscellaneousInformation"] = 286002] = "MiscellaneousInformation";
                LSISectionType[LSISectionType["Activities"] = 286003] = "Activities";
                LSISectionType[LSISectionType["ResidenceHallInformation"] = 286004] = "ResidenceHallInformation";
                LSISectionType[LSISectionType["DiningandMeals"] = 286005] = "DiningandMeals";
                LSISectionType[LSISectionType["GeneralLabInfo"] = 286006] = "GeneralLabInfo";
                LSISectionType[LSISectionType["NetworkSetUpInfo"] = 286007] = "NetworkSetUpInfo";
                LSISectionType[LSISectionType["ElectricalRoomDetails"] = 286008] = "ElectricalRoomDetails";
                LSISectionType[LSISectionType["ComputerSetup"] = 286009] = "ComputerSetup";
                LSISectionType[LSISectionType["DeliveriesandShipping"] = 286010] = "DeliveriesandShipping";
                LSISectionType[LSISectionType["AddressN"] = 286011] = "AddressN";
                LSISectionType[LSISectionType["LabBuildingDetails"] = 286012] = "LabBuildingDetails";
                LSISectionType[LSISectionType["GeneralInfo1"] = 286013] = "GeneralInfo1";
                LSISectionType[LSISectionType["AdditionalGeneralNotesGeneralInfo"] = 286014] = "AdditionalGeneralNotesGeneralInfo";
                LSISectionType[LSISectionType["AdditionalGeneralNotesHousing_Meals"] = 286015] = "AdditionalGeneralNotesHousing_Meals";
                LSISectionType[LSISectionType["AdditionalGeneralNotesLabInfo"] = 286016] = "AdditionalGeneralNotesLabInfo";
                LSISectionType[LSISectionType["AdditionalGeneralNotesShipping"] = 286017] = "AdditionalGeneralNotesShipping";
            })(LSISectionType = Enums.LSISectionType || (Enums.LSISectionType = {}));
            var MakePaymentAmountOptionType;
            (function (MakePaymentAmountOptionType) {
                MakePaymentAmountOptionType[MakePaymentAmountOptionType["ApplyToFullBalance"] = 1] = "ApplyToFullBalance";
                MakePaymentAmountOptionType[MakePaymentAmountOptionType["ApplyToFullBalanceAndContractedPaymentCoupons"] = 2] = "ApplyToFullBalanceAndContractedPaymentCoupons";
                MakePaymentAmountOptionType[MakePaymentAmountOptionType["ApplyToEachStudent"] = 3] = "ApplyToEachStudent";
                MakePaymentAmountOptionType[MakePaymentAmountOptionType["ApplyToContractedPaymentCouponsOnly"] = 4] = "ApplyToContractedPaymentCouponsOnly";
            })(MakePaymentAmountOptionType = Enums.MakePaymentAmountOptionType || (Enums.MakePaymentAmountOptionType = {}));
            var MedicationTimeTaken;
            (function (MedicationTimeTaken) {
                MedicationTimeTaken[MedicationTimeTaken["DuringBreakfast"] = 204000] = "DuringBreakfast";
                MedicationTimeTaken[MedicationTimeTaken["DuringLunch"] = 204001] = "DuringLunch";
                MedicationTimeTaken[MedicationTimeTaken["DuringDinner"] = 204002] = "DuringDinner";
                MedicationTimeTaken[MedicationTimeTaken["AtBedTime"] = 204003] = "AtBedTime";
                MedicationTimeTaken[MedicationTimeTaken["Other"] = 204004] = "Other";
                MedicationTimeTaken[MedicationTimeTaken["AsNeeded"] = 204005] = "AsNeeded";
            })(MedicationTimeTaken = Enums.MedicationTimeTaken || (Enums.MedicationTimeTaken = {}));
            var MigrationOutcome;
            (function (MigrationOutcome) {
                MigrationOutcome[MigrationOutcome["NotMigratedUnknownReason"] = 0] = "NotMigratedUnknownReason";
                MigrationOutcome[MigrationOutcome["MigratedAlready"] = 1] = "MigratedAlready";
                MigrationOutcome[MigrationOutcome["MigratedUsernameToPrimaryEmail"] = 2] = "MigratedUsernameToPrimaryEmail";
                MigrationOutcome[MigrationOutcome["MigratedUsernameToProvidedPrimaryEmail"] = 3] = "MigratedUsernameToProvidedPrimaryEmail";
                MigrationOutcome[MigrationOutcome["NotMigratedMultipleAccountsWithProvidedEmail"] = 4] = "NotMigratedMultipleAccountsWithProvidedEmail";
                MigrationOutcome[MigrationOutcome["NotMigratedMultiplePrimaryEmailsWithProvidedUsername"] = 5] = "NotMigratedMultiplePrimaryEmailsWithProvidedUsername";
                MigrationOutcome[MigrationOutcome["NotMigratedPublicUserMissingPrimaryEmail"] = 6] = "NotMigratedPublicUserMissingPrimaryEmail";
                MigrationOutcome[MigrationOutcome["NotMigratedPublicUserNotFound"] = 7] = "NotMigratedPublicUserNotFound";
                MigrationOutcome[MigrationOutcome["NotMigratedAuthenticationFailure"] = 8] = "NotMigratedAuthenticationFailure";
            })(MigrationOutcome = Enums.MigrationOutcome || (Enums.MigrationOutcome = {}));
            var NoteType;
            (function (NoteType) {
                NoteType[NoteType["ClientLogDetail"] = 172000] = "ClientLogDetail";
                NoteType[NoteType["CompletionNote"] = 172001] = "CompletionNote";
                NoteType[NoteType["ProgressNote"] = 172002] = "ProgressNote";
                NoteType[NoteType["AssignmentNote"] = 172003] = "AssignmentNote";
                NoteType[NoteType["ClientLogResolutionDetail"] = 172004] = "ClientLogResolutionDetail";
                NoteType[NoteType["CorrespondenceDetail"] = 172005] = "CorrespondenceDetail";
            })(NoteType = Enums.NoteType || (Enums.NoteType = {}));
            var OnlyExtraResolutionType;
            (function (OnlyExtraResolutionType) {
                OnlyExtraResolutionType[OnlyExtraResolutionType["Unresolved"] = 101000] = "Unresolved";
                OnlyExtraResolutionType[OnlyExtraResolutionType["Closed"] = 101001] = "Closed";
                OnlyExtraResolutionType[OnlyExtraResolutionType["ApprovedAsIs"] = 101002] = "ApprovedAsIs";
                OnlyExtraResolutionType[OnlyExtraResolutionType["ChangedProductOnly"] = 101003] = "ChangedProductOnly";
                OnlyExtraResolutionType[OnlyExtraResolutionType["ChangedSessionOnly"] = 101004] = "ChangedSessionOnly";
                OnlyExtraResolutionType[OnlyExtraResolutionType["ChangedLocationOnly"] = 101005] = "ChangedLocationOnly";
                OnlyExtraResolutionType[OnlyExtraResolutionType["ChangedSessionAndProduct"] = 101006] = "ChangedSessionAndProduct";
                OnlyExtraResolutionType[OnlyExtraResolutionType["ChangedLocationAndProduct"] = 101007] = "ChangedLocationAndProduct";
                OnlyExtraResolutionType[OnlyExtraResolutionType["AutomaticallyResolved"] = 101008] = "AutomaticallyResolved";
                OnlyExtraResolutionType[OnlyExtraResolutionType["SessionStarted"] = 101009] = "SessionStarted";
                OnlyExtraResolutionType[OnlyExtraResolutionType["Cancellation"] = 101010] = "Cancellation";
            })(OnlyExtraResolutionType = Enums.OnlyExtraResolutionType || (Enums.OnlyExtraResolutionType = {}));
            var OnlyType;
            (function (OnlyType) {
                OnlyType[OnlyType["OnlyParticipantInMealPlanForTheSession"] = 90000] = "OnlyParticipantInMealPlanForTheSession";
                OnlyType[OnlyType["OnlyParticipantWithoutMealPlanForTheSession"] = 90001] = "OnlyParticipantWithoutMealPlanForTheSession";
                OnlyType[OnlyType["OnlyParticipantInACourseForTheSession"] = 90002] = "OnlyParticipantInACourseForTheSession";
                OnlyType[OnlyType["OnlyParticipantInOvernightOrWeekendForTheSession"] = 90003] = "OnlyParticipantInOvernightOrWeekendForTheSession";
                OnlyType[OnlyType["OnlyFemaleInASession"] = 90004] = "OnlyFemaleInASession";
                OnlyType[OnlyType["OnlyFemaleInOvernightOrWeekendForTheSession"] = 90005] = "OnlyFemaleInOvernightOrWeekendForTheSession";
                OnlyType[OnlyType["OnlyTeenInASession"] = 90006] = "OnlyTeenInASession";
                OnlyType[OnlyType["OnlyTeenInOvernightOrWeekendForTheSession"] = 90007] = "OnlyTeenInOvernightOrWeekendForTheSession";
                OnlyType[OnlyType["OnlyNonTeenInASession"] = 90008] = "OnlyNonTeenInASession";
                OnlyType[OnlyType["OnlyNonTeenInOvernightOrWeekendForTheSession"] = 90009] = "OnlyNonTeenInOvernightOrWeekendForTheSession";
                OnlyType[OnlyType["OvernightParticipantIsYoungerThanOthersByAtLeast3Years"] = 90010] = "OvernightParticipantIsYoungerThanOthersByAtLeast3Years";
                OnlyType[OnlyType["OvernightParticipantIsOlderThanOthersByAtLeast3Years"] = 90011] = "OvernightParticipantIsOlderThanOthersByAtLeast3Years";
            })(OnlyType = Enums.OnlyType || (Enums.OnlyType = {}));
            var OrderCommentType;
            (function (OrderCommentType) {
                OrderCommentType[OrderCommentType["RoomWith"] = 98000] = "RoomWith";
                OrderCommentType[OrderCommentType["GroupWith"] = 98001] = "GroupWith";
                OrderCommentType[OrderCommentType["General"] = 98002] = "General";
                OrderCommentType[OrderCommentType["FeeDetails"] = 98003] = "FeeDetails";
                OrderCommentType[OrderCommentType["Diploma"] = 98005] = "Diploma";
                OrderCommentType[OrderCommentType["PrivateComment"] = 98007] = "PrivateComment";
                OrderCommentType[OrderCommentType["AutoRenewTurnedOn"] = 98008] = "AutoRenewTurnedOn";
                OrderCommentType[OrderCommentType["AutoRenewTurnedOff"] = 98009] = "AutoRenewTurnedOff";
            })(OrderCommentType = Enums.OrderCommentType || (Enums.OrderCommentType = {}));
            var OrderCommentWorkflowStatusType;
            (function (OrderCommentWorkflowStatusType) {
                OrderCommentWorkflowStatusType[OrderCommentWorkflowStatusType["Draft"] = 203000] = "Draft";
                OrderCommentWorkflowStatusType[OrderCommentWorkflowStatusType["PendingReview"] = 203001] = "PendingReview";
                OrderCommentWorkflowStatusType[OrderCommentWorkflowStatusType["Complete"] = 203002] = "Complete";
            })(OrderCommentWorkflowStatusType = Enums.OrderCommentWorkflowStatusType || (Enums.OrderCommentWorkflowStatusType = {}));
            var OrderDetailAdjustmentType;
            (function (OrderDetailAdjustmentType) {
                OrderDetailAdjustmentType[OrderDetailAdjustmentType["Return"] = 108000] = "Return";
                OrderDetailAdjustmentType[OrderDetailAdjustmentType["DiscountReversal"] = 108001] = "DiscountReversal";
                OrderDetailAdjustmentType[OrderDetailAdjustmentType["Payment"] = 108002] = "Payment";
            })(OrderDetailAdjustmentType = Enums.OrderDetailAdjustmentType || (Enums.OrderDetailAdjustmentType = {}));
            var OrderDetailDiscountStatusType;
            (function (OrderDetailDiscountStatusType) {
                OrderDetailDiscountStatusType[OrderDetailDiscountStatusType["Valid"] = 119000] = "Valid";
                OrderDetailDiscountStatusType[OrderDetailDiscountStatusType["Pending"] = 119001] = "Pending";
                OrderDetailDiscountStatusType[OrderDetailDiscountStatusType["Reversed"] = 119003] = "Reversed";
            })(OrderDetailDiscountStatusType = Enums.OrderDetailDiscountStatusType || (Enums.OrderDetailDiscountStatusType = {}));
            var OrderDetailStatusType;
            (function (OrderDetailStatusType) {
                OrderDetailStatusType[OrderDetailStatusType["SaleComplete"] = 89000] = "SaleComplete";
                OrderDetailStatusType[OrderDetailStatusType["ShoppingCart"] = 89001] = "ShoppingCart";
                OrderDetailStatusType[OrderDetailStatusType["Returned"] = 89002] = "Returned";
                OrderDetailStatusType[OrderDetailStatusType["Cancelled"] = 89003] = "Cancelled";
            })(OrderDetailStatusType = Enums.OrderDetailStatusType || (Enums.OrderDetailStatusType = {}));
            var OrderSourceType;
            (function (OrderSourceType) {
                OrderSourceType[OrderSourceType["Online"] = 196000] = "Online";
                OrderSourceType[OrderSourceType["Phone"] = 196001] = "Phone";
                OrderSourceType[OrderSourceType["Mail"] = 196002] = "Mail";
                OrderSourceType[OrderSourceType["Fax"] = 196003] = "Fax";
            })(OrderSourceType = Enums.OrderSourceType || (Enums.OrderSourceType = {}));
            var OrderStatusType;
            (function (OrderStatusType) {
                OrderStatusType[OrderStatusType["SaleComplete"] = 88000] = "SaleComplete";
                OrderStatusType[OrderStatusType["ShoppingCart"] = 88001] = "ShoppingCart";
                OrderStatusType[OrderStatusType["PaymentProcessing"] = 88002] = "PaymentProcessing";
            })(OrderStatusType = Enums.OrderStatusType || (Enums.OrderStatusType = {}));
            var OrderType;
            (function (OrderType) {
                OrderType[OrderType["Standard"] = 81000] = "Standard";
                OrderType[OrderType["WaitList"] = 81001] = "WaitList";
                OrderType[OrderType["ShoppingCart"] = 81002] = "ShoppingCart";
            })(OrderType = Enums.OrderType || (Enums.OrderType = {}));
            var OrderUserRoleType;
            (function (OrderUserRoleType) {
                OrderUserRoleType[OrderUserRoleType["PrimaryCustomer"] = 93000] = "PrimaryCustomer";
                OrderUserRoleType[OrderUserRoleType["SecondaryCustomer"] = 93001] = "SecondaryCustomer";
                OrderUserRoleType[OrderUserRoleType["ParentGuardian"] = 93002] = "ParentGuardian";
                OrderUserRoleType[OrderUserRoleType["Participant"] = 93003] = "Participant";
                OrderUserRoleType[OrderUserRoleType["PickUpPerson"] = 93004] = "PickUpPerson";
                OrderUserRoleType[OrderUserRoleType["Parent"] = 93005] = "Parent";
                OrderUserRoleType[OrderUserRoleType["Guardian"] = 93006] = "Guardian";
                OrderUserRoleType[OrderUserRoleType["Other"] = 93007] = "Other";
            })(OrderUserRoleType = Enums.OrderUserRoleType || (Enums.OrderUserRoleType = {}));
            var OverrideReasonType;
            (function (OverrideReasonType) {
                OverrideReasonType[OverrideReasonType["FitBetterWithYoungerCourse"] = 153000] = "FitBetterWithYoungerCourse";
                OverrideReasonType[OverrideReasonType["FitBetterWithOlderCourse"] = 153001] = "FitBetterWithOlderCourse";
                OverrideReasonType[OverrideReasonType["MaturityLevelSufficient"] = 153002] = "MaturityLevelSufficient";
                OverrideReasonType[OverrideReasonType["WantJoinFriend"] = 153003] = "WantJoinFriend";
                OverrideReasonType[OverrideReasonType["AtSessionChangeApprovedbyDirector"] = 153004] = "AtSessionChangeApprovedbyDirector";
            })(OverrideReasonType = Enums.OverrideReasonType || (Enums.OverrideReasonType = {}));
            var OverrideType;
            (function (OverrideType) {
                OverrideType[OverrideType["CSRegistrationEndPassed"] = 156000] = "CSRegistrationEndPassed";
                OverrideType[OverrideType["CSAddSessionEndPassed"] = 156001] = "CSAddSessionEndPassed";
                OverrideType[OverrideType["CSChangeSessionEndPassed"] = 156002] = "CSChangeSessionEndPassed";
                OverrideType[OverrideType["ParticipantTooYoung"] = 156003] = "ParticipantTooYoung";
                OverrideType[OverrideType["ParticipantTooOld"] = 156004] = "ParticipantTooOld";
            })(OverrideType = Enums.OverrideType || (Enums.OverrideType = {}));
            var PackageType;
            (function (PackageType) {
                PackageType[PackageType["Standard"] = 44000] = "Standard";
            })(PackageType = Enums.PackageType || (Enums.PackageType = {}));
            var ParticipantAgeRangeType;
            (function (ParticipantAgeRangeType) {
                ParticipantAgeRangeType[ParticipantAgeRangeType["_13"] = 146000] = "_13";
                ParticipantAgeRangeType[ParticipantAgeRangeType["_14"] = 146001] = "_14";
                ParticipantAgeRangeType[ParticipantAgeRangeType["_15"] = 146002] = "_15";
                ParticipantAgeRangeType[ParticipantAgeRangeType["_16"] = 146003] = "_16";
                ParticipantAgeRangeType[ParticipantAgeRangeType["_17"] = 14600] = "_17";
            })(ParticipantAgeRangeType = Enums.ParticipantAgeRangeType || (Enums.ParticipantAgeRangeType = {}));
            var PayCalculation;
            (function (PayCalculation) {
                PayCalculation[PayCalculation["DefinedAmount_Hourly"] = 252000] = "DefinedAmount_Hourly";
                PayCalculation[PayCalculation["DefinedAmount_Exempt"] = 252001] = "DefinedAmount_Exempt";
                PayCalculation[PayCalculation["BaseSalary_Plus_DiscretionaryPay_Minus_Daily"] = 252002] = "BaseSalary_Plus_DiscretionaryPay_Minus_Daily";
            })(PayCalculation = Enums.PayCalculation || (Enums.PayCalculation = {}));
            var PayDisbursementOption;
            (function (PayDisbursementOption) {
                PayDisbursementOption[PayDisbursementOption["DirectDeposit"] = 258000] = "DirectDeposit";
                PayDisbursementOption[PayDisbursementOption["WireTransfer"] = 258001] = "WireTransfer";
                PayDisbursementOption[PayDisbursementOption["LiveCheck"] = 258002] = "LiveCheck";
            })(PayDisbursementOption = Enums.PayDisbursementOption || (Enums.PayDisbursementOption = {}));
            var PayItem;
            (function (PayItem) {
                PayItem[PayItem["Overnight"] = 250000] = "Overnight";
                PayItem[PayItem["Weekend"] = 250001] = "Weekend";
                PayItem[PayItem["LocationSetUp"] = 250002] = "LocationSetUp";
                PayItem[PayItem["Orientation"] = 250003] = "Orientation";
                PayItem[PayItem["NonWorkingWeekendHousing_Charged"] = 250004] = "NonWorkingWeekendHousing_Charged";
                PayItem[PayItem["NonWorkingWeekendHousing_Waived"] = 250005] = "NonWorkingWeekendHousing_Waived";
                PayItem[PayItem["WeeknightHousing"] = 250006] = "WeeknightHousing";
                PayItem[PayItem["NonWorkingWeekendHousing_Included"] = 250007] = "NonWorkingWeekendHousing_Included";
                PayItem[PayItem["ManualPayAdjustment"] = 250008] = "ManualPayAdjustment";
            })(PayItem = Enums.PayItem || (Enums.PayItem = {}));
            var PayItemDuration;
            (function (PayItemDuration) {
                PayItemDuration[PayItemDuration["Hourly"] = 251000] = "Hourly";
                PayItemDuration[PayItemDuration["Daily"] = 251001] = "Daily";
                PayItemDuration[PayItemDuration["Weekly"] = 251002] = "Weekly";
                PayItemDuration[PayItemDuration["Monthly"] = 251003] = "Monthly";
            })(PayItemDuration = Enums.PayItemDuration || (Enums.PayItemDuration = {}));
            var PayItemOffset;
            (function (PayItemOffset) {
                PayItemOffset[PayItemOffset["SessionStart"] = 275000] = "SessionStart";
                PayItemOffset[PayItemOffset["Sunday"] = 275001] = "Sunday";
                PayItemOffset[PayItemOffset["AssignmentStartEndDate"] = 275002] = "AssignmentStartEndDate";
            })(PayItemOffset = Enums.PayItemOffset || (Enums.PayItemOffset = {}));
            var PaymentMethodType;
            (function (PaymentMethodType) {
                PaymentMethodType[PaymentMethodType["Check"] = 95000] = "Check";
                PaymentMethodType[PaymentMethodType["Cash"] = 95001] = "Cash";
                PaymentMethodType[PaymentMethodType["CreditCard"] = 95002] = "CreditCard";
                PaymentMethodType[PaymentMethodType["Voucher"] = 95003] = "Voucher";
                PaymentMethodType[PaymentMethodType["MoneyOrder"] = 95004] = "MoneyOrder";
                PaymentMethodType[PaymentMethodType["Scholarship"] = 95005] = "Scholarship";
                PaymentMethodType[PaymentMethodType["ApplePay"] = 95006] = "ApplePay";
                PaymentMethodType[PaymentMethodType["BankTransfer"] = 95007] = "BankTransfer";
            })(PaymentMethodType = Enums.PaymentMethodType || (Enums.PaymentMethodType = {}));
            var PaymentStatusType;
            (function (PaymentStatusType) {
                PaymentStatusType[PaymentStatusType["Submitted"] = 133000] = "Submitted";
            })(PaymentStatusType = Enums.PaymentStatusType || (Enums.PaymentStatusType = {}));
            var PaymentType;
            (function (PaymentType) {
                PaymentType[PaymentType["Incoming"] = 94000] = "Incoming";
                PaymentType[PaymentType["Outgoing"] = 94001] = "Outgoing";
            })(PaymentType = Enums.PaymentType || (Enums.PaymentType = {}));
            var PayrollApprovalStatus;
            (function (PayrollApprovalStatus) {
                PayrollApprovalStatus[PayrollApprovalStatus["NotStarted"] = 277000] = "NotStarted";
                PayrollApprovalStatus[PayrollApprovalStatus["RMCorrectionsNeeded"] = 277001] = "RMCorrectionsNeeded";
                PayrollApprovalStatus[PayrollApprovalStatus["RMReviewing"] = 277002] = "RMReviewing";
                PayrollApprovalStatus[PayrollApprovalStatus["RMApproved"] = 277003] = "RMApproved";
                PayrollApprovalStatus[PayrollApprovalStatus["COMCorrectionsNeeded"] = 277004] = "COMCorrectionsNeeded";
                PayrollApprovalStatus[PayrollApprovalStatus["COMReviewing"] = 277005] = "COMReviewing";
                PayrollApprovalStatus[PayrollApprovalStatus["COMApproved"] = 277006] = "COMApproved";
                PayrollApprovalStatus[PayrollApprovalStatus["PayrollReviewing"] = 277007] = "PayrollReviewing";
                PayrollApprovalStatus[PayrollApprovalStatus["PayrollApproved"] = 277008] = "PayrollApproved";
                PayrollApprovalStatus[PayrollApprovalStatus["PayrollTransmitted"] = 277009] = "PayrollTransmitted";
                PayrollApprovalStatus[PayrollApprovalStatus["PayrollHold"] = 277010] = "PayrollHold";
            })(PayrollApprovalStatus = Enums.PayrollApprovalStatus || (Enums.PayrollApprovalStatus = {}));
            var PayrollCycle;
            (function (PayrollCycle) {
                PayrollCycle[PayrollCycle["Normal"] = 278000] = "Normal";
                PayrollCycle[PayrollCycle["Early"] = 278001] = "Early";
            })(PayrollCycle = Enums.PayrollCycle || (Enums.PayrollCycle = {}));
            var ProcessingUsageStatus;
            (function (ProcessingUsageStatus) {
                ProcessingUsageStatus[ProcessingUsageStatus["TermStaffApplicationHiringWorkflow"] = 262000] = "TermStaffApplicationHiringWorkflow";
                ProcessingUsageStatus[ProcessingUsageStatus["BackgroundCheck"] = 262001] = "BackgroundCheck";
                ProcessingUsageStatus[ProcessingUsageStatus["ReferenceCheck"] = 262002] = "ReferenceCheck";
            })(ProcessingUsageStatus = Enums.ProcessingUsageStatus || (Enums.ProcessingUsageStatus = {}));
            var ProductCategoryType;
            (function (ProductCategoryType) {
                ProductCategoryType[ProductCategoryType["Course"] = 17000] = "Course";
                ProductCategoryType[ProductCategoryType["Meal"] = 17001] = "Meal";
                ProductCategoryType[ProductCategoryType["Activity"] = 17002] = "Activity";
                ProductCategoryType[ProductCategoryType["Residency"] = 17003] = "Residency";
                ProductCategoryType[ProductCategoryType["Merchandise"] = 17004] = "Merchandise";
                ProductCategoryType[ProductCategoryType["CEU"] = 17005] = "CEU";
                ProductCategoryType[ProductCategoryType["Fee"] = 17006] = "Fee";
                ProductCategoryType[ProductCategoryType["Subscription"] = 17007] = "Subscription";
                ProductCategoryType[ProductCategoryType["Transportation"] = 17008] = "Transportation";
                ProductCategoryType[ProductCategoryType["PurchaseCredit"] = 17009] = "PurchaseCredit";
                ProductCategoryType[ProductCategoryType["Tutor"] = 17010] = "Tutor";
            })(ProductCategoryType = Enums.ProductCategoryType || (Enums.ProductCategoryType = {}));
            var ProductDisplayConfigType;
            (function (ProductDisplayConfigType) {
                ProductDisplayConfigType[ProductDisplayConfigType["Standard"] = 228000] = "Standard";
            })(ProductDisplayConfigType = Enums.ProductDisplayConfigType || (Enums.ProductDisplayConfigType = {}));
            var ProductGenreType;
            (function (ProductGenreType) {
                ProductGenreType[ProductGenreType["Coding"] = 295000] = "Coding";
                ProductGenreType[ProductGenreType["GameDev"] = 295002] = "GameDev";
                ProductGenreType[ProductGenreType["Robotics"] = 295001] = "Robotics";
                ProductGenreType[ProductGenreType["Creative"] = 295003] = "Creative";
            })(ProductGenreType = Enums.ProductGenreType || (Enums.ProductGenreType = {}));
            var ProductImportantDateType;
            (function (ProductImportantDateType) {
                ProductImportantDateType[ProductImportantDateType["AutoRenewReminder2"] = 217000] = "AutoRenewReminder2";
                ProductImportantDateType[ProductImportantDateType["AutoRenewReminder1"] = 217001] = "AutoRenewReminder1";
                ProductImportantDateType[ProductImportantDateType["AutoRenewBillDate"] = 217002] = "AutoRenewBillDate";
                ProductImportantDateType[ProductImportantDateType["StandardSubscriptionExpirationReminder2"] = 217003] = "StandardSubscriptionExpirationReminder2";
                ProductImportantDateType[ProductImportantDateType["StandardSubscriptionExpirationReminder1"] = 217004] = "StandardSubscriptionExpirationReminder1";
            })(ProductImportantDateType = Enums.ProductImportantDateType || (Enums.ProductImportantDateType = {}));
            var ProductImportantDateStatusType;
            (function (ProductImportantDateStatusType) {
                ProductImportantDateStatusType[ProductImportantDateStatusType["Pending"] = 218000] = "Pending";
                ProductImportantDateStatusType[ProductImportantDateStatusType["Sent"] = 218001] = "Sent";
            })(ProductImportantDateStatusType = Enums.ProductImportantDateStatusType || (Enums.ProductImportantDateStatusType = {}));
            var ProductImptDateRelativeToType;
            (function (ProductImptDateRelativeToType) {
                ProductImptDateRelativeToType[ProductImptDateRelativeToType["StartOfSubscription"] = 219000] = "StartOfSubscription";
                ProductImptDateRelativeToType[ProductImptDateRelativeToType["EndOfSubscription"] = 219001] = "EndOfSubscription";
            })(ProductImptDateRelativeToType = Enums.ProductImptDateRelativeToType || (Enums.ProductImptDateRelativeToType = {}));
            var ProductRatioType;
            (function (ProductRatioType) {
                ProductRatioType[ProductRatioType["ParticipantsPerInstructor"] = 53000] = "ParticipantsPerInstructor";
            })(ProductRatioType = Enums.ProductRatioType || (Enums.ProductRatioType = {}));
            var ProductSchedule;
            (function (ProductSchedule) {
                ProductSchedule[ProductSchedule["FullDay"] = 323000] = "FullDay";
                ProductSchedule[ProductSchedule["Morning"] = 323001] = "Morning";
                ProductSchedule[ProductSchedule["Afternoon"] = 323002] = "Afternoon";
            })(ProductSchedule = Enums.ProductSchedule || (Enums.ProductSchedule = {}));
            var ProductSkillType;
            (function (ProductSkillType) {
                ProductSkillType[ProductSkillType["StaffSkill"] = 220000] = "StaffSkill";
                ProductSkillType[ProductSkillType["ParticipantSkill"] = 220001] = "ParticipantSkill";
            })(ProductSkillType = Enums.ProductSkillType || (Enums.ProductSkillType = {}));
            var ProductSubCategoryType;
            (function (ProductSubCategoryType) {
                ProductSubCategoryType[ProductSubCategoryType["Breakfast"] = 65000] = "Breakfast";
                ProductSubCategoryType[ProductSubCategoryType["Lunch"] = 65001] = "Lunch";
                ProductSubCategoryType[ProductSubCategoryType["Dinner"] = 65002] = "Dinner";
                ProductSubCategoryType[ProductSubCategoryType["B_L_D"] = 65024] = "B_L_D";
                ProductSubCategoryType[ProductSubCategoryType["Overnight"] = 65003] = "Overnight";
                ProductSubCategoryType[ProductSubCategoryType["WeekendAfter"] = 65004] = "WeekendAfter";
                ProductSubCategoryType[ProductSubCategoryType["ExtendedDay"] = 65026] = "ExtendedDay";
                ProductSubCategoryType[ProductSubCategoryType["AdministrativeChangeFee"] = 65012] = "AdministrativeChangeFee";
                ProductSubCategoryType[ProductSubCategoryType["ProductChangeAfterSessionStartFee"] = 65029] = "ProductChangeAfterSessionStartFee";
                ProductSubCategoryType[ProductSubCategoryType["BalancePaymentExtensionOverdueFee"] = 65014] = "BalancePaymentExtensionOverdueFee";
                ProductSubCategoryType[ProductSubCategoryType["BalancePaymentOverdueFee"] = 65013] = "BalancePaymentOverdueFee";
                ProductSubCategoryType[ProductSubCategoryType["BackgroundCheckProcessingFeeNotNY"] = 65015] = "BackgroundCheckProcessingFeeNotNY";
                ProductSubCategoryType[ProductSubCategoryType["BackgroundCheckProcessingFeeNY"] = 65027] = "BackgroundCheckProcessingFeeNY";
                ProductSubCategoryType[ProductSubCategoryType["CancellationFee"] = 65025] = "CancellationFee";
                ProductSubCategoryType[ProductSubCategoryType["WeekendBefore"] = 65030] = "WeekendBefore";
                ProductSubCategoryType[ProductSubCategoryType["WeekendWithin"] = 65032] = "WeekendWithin";
                ProductSubCategoryType[ProductSubCategoryType["OvernightAndWeekend"] = 65028] = "OvernightAndWeekend";
                ProductSubCategoryType[ProductSubCategoryType["RecoupWriteOffDiscountFee"] = 65033] = "RecoupWriteOffDiscountFee";
                ProductSubCategoryType[ProductSubCategoryType["LatePickupFee"] = 65022] = "LatePickupFee";
                ProductSubCategoryType[ProductSubCategoryType["LostKeyFee"] = 65017] = "LostKeyFee";
                ProductSubCategoryType[ProductSubCategoryType["MedicationsPurchasedDuringSessionFee"] = 65019] = "MedicationsPurchasedDuringSessionFee";
                ProductSubCategoryType[ProductSubCategoryType["PropertyDamageDuringSessionFee"] = 65016] = "PropertyDamageDuringSessionFee";
                ProductSubCategoryType[ProductSubCategoryType["PurchaseReimbursementDuringSessionFee"] = 65021] = "PurchaseReimbursementDuringSessionFee";
                ProductSubCategoryType[ProductSubCategoryType["ReturnedCheckFee"] = 65023] = "ReturnedCheckFee";
                ProductSubCategoryType[ProductSubCategoryType["TransportationDuringSessionFee"] = 65020] = "TransportationDuringSessionFee";
                ProductSubCategoryType[ProductSubCategoryType["LostMealCardDuringSessionFee"] = 65018] = "LostMealCardDuringSessionFee";
                ProductSubCategoryType[ProductSubCategoryType["GenericFeeForUnusualSituations"] = 65036] = "GenericFeeForUnusualSituations";
                ProductSubCategoryType[ProductSubCategoryType["Subscription_Monthly"] = 65043] = "Subscription_Monthly";
                ProductSubCategoryType[ProductSubCategoryType["ComplianceAndSafetyFee"] = 65044] = "ComplianceAndSafetyFee";
                ProductSubCategoryType[ProductSubCategoryType["CourseChangeFee"] = 65045] = "CourseChangeFee";
                ProductSubCategoryType[ProductSubCategoryType["EarlyAccess"] = 65054] = "EarlyAccess";
                ProductSubCategoryType[ProductSubCategoryType["OneOnOneTutor"] = 65055] = "OneOnOneTutor";
                ProductSubCategoryType[ProductSubCategoryType["CollegePrepAdvising"] = 65056] = "CollegePrepAdvising";
                ProductSubCategoryType[ProductSubCategoryType["CoursePreparation"] = 65057] = "CoursePreparation";
                ProductSubCategoryType[ProductSubCategoryType["CEU"] = 65058] = "CEU";
                ProductSubCategoryType[ProductSubCategoryType["ProductCoupon"] = 65062] = "ProductCoupon";
            })(ProductSubCategoryType = Enums.ProductSubCategoryType || (Enums.ProductSubCategoryType = {}));
            var ProductTextUsage;
            (function (ProductTextUsage) {
                ProductTextUsage[ProductTextUsage["SubscriptionSelectionButtonText"] = 321000] = "SubscriptionSelectionButtonText";
            })(ProductTextUsage = Enums.ProductTextUsage || (Enums.ProductTextUsage = {}));
            var ProductVisibilityType;
            (function (ProductVisibilityType) {
                ProductVisibilityType[ProductVisibilityType["PulseRegUpsell"] = 330000] = "PulseRegUpsell";
                ProductVisibilityType[ProductVisibilityType["TechRocketStandaloneReg"] = 330001] = "TechRocketStandaloneReg";
                ProductVisibilityType[ProductVisibilityType["PulseRegUpsellInternalOnly"] = 330002] = "PulseRegUpsellInternalOnly";
                ProductVisibilityType[ProductVisibilityType["HideOnCoursePageAndUpsellPublic"] = 330003] = "HideOnCoursePageAndUpsellPublic";
                ProductVisibilityType[ProductVisibilityType["HideOnCoursePageDispalyOnUpsell"] = 330004] = "HideOnCoursePageDispalyOnUpsell";
                ProductVisibilityType[ProductVisibilityType["CrossSellUnconditionally"] = 330005] = "CrossSellUnconditionally";
                ProductVisibilityType[ProductVisibilityType["CrossSellOnlyToOtherDivisions"] = 330006] = "CrossSellOnlyToOtherDivisions";
                ProductVisibilityType[ProductVisibilityType["CrossSellToSpecifiedDivisions"] = 330007] = "CrossSellToSpecifiedDivisions";
            })(ProductVisibilityType = Enums.ProductVisibilityType || (Enums.ProductVisibilityType = {}));
            var ProductURLType;
            (function (ProductURLType) {
                ProductURLType[ProductURLType["CourseDetailsURL"] = 294000] = "CourseDetailsURL";
                ProductURLType[ProductURLType["CourseVideoURL"] = 294001] = "CourseVideoURL";
                ProductURLType[ProductURLType["CourseVideoIntroImageURL"] = 294002] = "CourseVideoIntroImageURL";
                ProductURLType[ProductURLType["MerchandiseCatalogPhoto"] = 294003] = "MerchandiseCatalogPhoto";
                ProductURLType[ProductURLType["CourseLmsUrlStudent"] = 294004] = "CourseLmsUrlStudent";
                ProductURLType[ProductURLType["CourseLmsUrlStaff"] = 294005] = "CourseLmsUrlStaff";
                ProductURLType[ProductURLType["PrepInstructionsURL"] = 294007] = "PrepInstructionsURL";
            })(ProductURLType = Enums.ProductURLType || (Enums.ProductURLType = {}));
            var ProjectUploadOptionMask;
            (function (ProjectUploadOptionMask) {
                ProjectUploadOptionMask[ProjectUploadOptionMask["None"] = 0] = "None";
                ProjectUploadOptionMask[ProjectUploadOptionMask["Download"] = 1] = "Download";
                ProjectUploadOptionMask[ProjectUploadOptionMask["Gallery"] = 2] = "Gallery";
                ProjectUploadOptionMask[ProjectUploadOptionMask["YouTube"] = 4] = "YouTube";
                ProjectUploadOptionMask[ProjectUploadOptionMask["FusionSWF"] = 8] = "FusionSWF";
                ProjectUploadOptionMask[ProjectUploadOptionMask["Scratch"] = 16] = "Scratch";
                ProjectUploadOptionMask[ProjectUploadOptionMask["Website"] = 32] = "Website";
                ProjectUploadOptionMask[ProjectUploadOptionMask["Vimeo"] = 64] = "Vimeo";
                ProjectUploadOptionMask[ProjectUploadOptionMask["All"] = 65535] = "All";
            })(ProjectUploadOptionMask = Enums.ProjectUploadOptionMask || (Enums.ProjectUploadOptionMask = {}));
            var PulseErrorLogSeverityLevel;
            (function (PulseErrorLogSeverityLevel) {
                PulseErrorLogSeverityLevel[PulseErrorLogSeverityLevel["Errors"] = 0] = "Errors";
                PulseErrorLogSeverityLevel[PulseErrorLogSeverityLevel["Warnings"] = 1] = "Warnings";
                PulseErrorLogSeverityLevel[PulseErrorLogSeverityLevel["Verbose"] = 2] = "Verbose";
                PulseErrorLogSeverityLevel[PulseErrorLogSeverityLevel["Trace"] = 3] = "Trace";
            })(PulseErrorLogSeverityLevel = Enums.PulseErrorLogSeverityLevel || (Enums.PulseErrorLogSeverityLevel = {}));
            var PulseErrorLogSubject;
            (function (PulseErrorLogSubject) {
                PulseErrorLogSubject[PulseErrorLogSubject["Unknown"] = 0] = "Unknown";
                PulseErrorLogSubject[PulseErrorLogSubject["Authentication"] = 1] = "Authentication";
                PulseErrorLogSubject[PulseErrorLogSubject["Routing"] = 2] = "Routing";
                PulseErrorLogSubject[PulseErrorLogSubject["PulsePublic"] = 3] = "PulsePublic";
                PulseErrorLogSubject[PulseErrorLogSubject["PulseAdmin"] = 4] = "PulseAdmin";
            })(PulseErrorLogSubject = Enums.PulseErrorLogSubject || (Enums.PulseErrorLogSubject = {}));
            var QAMeasurementType;
            (function (QAMeasurementType) {
                QAMeasurementType[QAMeasurementType["TermStaff"] = 232000] = "TermStaff";
            })(QAMeasurementType = Enums.QAMeasurementType || (Enums.QAMeasurementType = {}));
            var RelatedProductType;
            (function (RelatedProductType) {
                RelatedProductType[RelatedProductType["IncludedProduct"] = 71000] = "IncludedProduct";
                RelatedProductType[RelatedProductType["StandardOptionalProduct"] = 71001] = "StandardOptionalProduct";
                RelatedProductType[RelatedProductType["MutuallyExclusiveProduct"] = 71002] = "MutuallyExclusiveProduct";
                RelatedProductType[RelatedProductType["Combo"] = 71004] = "Combo";
                RelatedProductType[RelatedProductType["PrimaryOptionalProduct"] = 71005] = "PrimaryOptionalProduct";
                RelatedProductType[RelatedProductType["ProductVariant"] = 71006] = "ProductVariant";
                RelatedProductType[RelatedProductType["Required"] = 71007] = "Required";
                RelatedProductType[RelatedProductType["VirtualEquivalent"] = 71009] = "VirtualEquivalent";
                RelatedProductType[RelatedProductType["Bundle"] = 71010] = "Bundle";
                RelatedProductType[RelatedProductType["NextInSeries"] = 71011] = "NextInSeries";
            })(RelatedProductType = Enums.RelatedProductType || (Enums.RelatedProductType = {}));
            var RecordStateType;
            (function (RecordStateType) {
                RecordStateType[RecordStateType["Active"] = 1000] = "Active";
                RecordStateType[RecordStateType["Deleted"] = 1001] = "Deleted";
                RecordStateType[RecordStateType["Archived"] = 1002] = "Archived";
            })(RecordStateType = Enums.RecordStateType || (Enums.RecordStateType = {}));
            var ReferenceContactType;
            (function (ReferenceContactType) {
                ReferenceContactType[ReferenceContactType["Yes"] = 188000] = "Yes";
                ReferenceContactType[ReferenceContactType["No"] = 188001] = "No";
                ReferenceContactType[ReferenceContactType["DoNotContact"] = 188002] = "DoNotContact";
            })(ReferenceContactType = Enums.ReferenceContactType || (Enums.ReferenceContactType = {}));
            var ReferenceOKType;
            (function (ReferenceOKType) {
                ReferenceOKType[ReferenceOKType["NotYetAsked"] = 189000] = "NotYetAsked";
                ReferenceOKType[ReferenceOKType["NotYetReplied"] = 189001] = "NotYetReplied";
                ReferenceOKType[ReferenceOKType["Yes"] = 189002] = "Yes";
                ReferenceOKType[ReferenceOKType["No"] = 189003] = "No";
            })(ReferenceOKType = Enums.ReferenceOKType || (Enums.ReferenceOKType = {}));
            var ReferenceRating;
            (function (ReferenceRating) {
                ReferenceRating[ReferenceRating["NA"] = 263001] = "NA";
                ReferenceRating[ReferenceRating["Poor"] = 263002] = "Poor";
                ReferenceRating[ReferenceRating["Fair"] = 263003] = "Fair";
                ReferenceRating[ReferenceRating["Good"] = 263004] = "Good";
                ReferenceRating[ReferenceRating["Excellent"] = 263005] = "Excellent";
                ReferenceRating[ReferenceRating["InvalidReference"] = 263006] = "InvalidReference";
                ReferenceRating[ReferenceRating["UnresponsiveReference"] = 263007] = "UnresponsiveReference";
            })(ReferenceRating = Enums.ReferenceRating || (Enums.ReferenceRating = {}));
            var RefundPriority;
            (function (RefundPriority) {
                RefundPriority[RefundPriority["ASAP"] = 190000] = "ASAP";
                RefundPriority[RefundPriority["Urgent"] = 190001] = "Urgent";
                RefundPriority[RefundPriority["Normal"] = 190002] = "Normal";
            })(RefundPriority = Enums.RefundPriority || (Enums.RefundPriority = {}));
            var RefundStatus;
            (function (RefundStatus) {
                RefundStatus[RefundStatus["Incomplete"] = 192000] = "Incomplete";
                RefundStatus[RefundStatus["AwaitingCheckNumber"] = 192001] = "AwaitingCheckNumber";
                RefundStatus[RefundStatus["Complete"] = 192002] = "Complete";
            })(RefundStatus = Enums.RefundStatus || (Enums.RefundStatus = {}));
            var RefundType;
            (function (RefundType) {
                RefundType[RefundType["SingleCreditCard"] = 191000] = "SingleCreditCard";
                RefundType[RefundType["MultipleCreditCards"] = 191001] = "MultipleCreditCards";
                RefundType[RefundType["Check"] = 191002] = "Check";
                RefundType[RefundType["CheckOverrideForCreditCards"] = 191003] = "CheckOverrideForCreditCards";
            })(RefundType = Enums.RefundType || (Enums.RefundType = {}));
            var RegionRoleType;
            (function (RegionRoleType) {
                RegionRoleType[RegionRoleType["Manager"] = 31000] = "Manager";
            })(RegionRoleType = Enums.RegionRoleType || (Enums.RegionRoleType = {}));
            var RegistrationStatusType;
            (function (RegistrationStatusType) {
                RegistrationStatusType[RegistrationStatusType["Scheduled"] = 142000] = "Scheduled";
                RegistrationStatusType[RegistrationStatusType["Past"] = 142001] = "Past";
                RegistrationStatusType[RegistrationStatusType["NotRegistered"] = 142002] = "NotRegistered";
            })(RegistrationStatusType = Enums.RegistrationStatusType || (Enums.RegistrationStatusType = {}));
            var RegFlowProgressStep;
            (function (RegFlowProgressStep) {
                RegFlowProgressStep[RegFlowProgressStep["AvailChart2017"] = 342005] = "AvailChart2017";
                RegFlowProgressStep[RegFlowProgressStep["ShoppingCart2017"] = 342006] = "ShoppingCart2017";
                RegFlowProgressStep[RegFlowProgressStep["OrderSummary2017"] = 342007] = "OrderSummary2017";
            })(RegFlowProgressStep = Enums.RegFlowProgressStep || (Enums.RegFlowProgressStep = {}));
            var ResidencyOption;
            (function (ResidencyOption) {
                ResidencyOption[ResidencyOption["Day"] = 356000] = "Day";
                ResidencyOption[ResidencyOption["Overnight"] = 356001] = "Overnight";
                ResidencyOption[ResidencyOption["DayAndOvernight"] = 356002] = "DayAndOvernight";
            })(ResidencyOption = Enums.ResidencyOption || (Enums.ResidencyOption = {}));
            var RewardProgramType;
            (function (RewardProgramType) {
                RewardProgramType[RewardProgramType["ReferAFriend"] = 128000] = "ReferAFriend";
                RewardProgramType[RewardProgramType["ReferAFriendForHire"] = 128001] = "ReferAFriendForHire";
            })(RewardProgramType = Enums.RewardProgramType || (Enums.RewardProgramType = {}));
            var RewardType;
            (function (RewardType) {
                RewardType[RewardType["CreditToAccount"] = 129000] = "CreditToAccount";
                RewardType[RewardType["GiftCard"] = 129001] = "GiftCard";
            })(RewardType = Enums.RewardType || (Enums.RewardType = {}));
            var RelativeRelationType;
            (function (RelativeRelationType) {
                RelativeRelationType[RelativeRelationType["Before"] = 38000] = "Before";
                RelativeRelationType[RelativeRelationType["After"] = 38001] = "After";
            })(RelativeRelationType = Enums.RelativeRelationType || (Enums.RelativeRelationType = {}));
            var RelativeToItemType;
            (function (RelativeToItemType) {
                RelativeToItemType[RelativeToItemType["StartOfEachSession"] = 39000] = "StartOfEachSession";
                RelativeToItemType[RelativeToItemType["StartOfTerm"] = 39001] = "StartOfTerm";
                RelativeToItemType[RelativeToItemType["EndOfEachSession"] = 39002] = "EndOfEachSession";
                RelativeToItemType[RelativeToItemType["EndOfTerm"] = 39003] = "EndOfTerm";
                RelativeToItemType[RelativeToItemType["StartOfAssignment"] = 39006] = "StartOfAssignment";
                RelativeToItemType[RelativeToItemType["EndOfAssignment"] = 39007] = "EndOfAssignment";
            })(RelativeToItemType = Enums.RelativeToItemType || (Enums.RelativeToItemType = {}));
            var RelativeToItemGroupingType;
            (function (RelativeToItemGroupingType) {
                RelativeToItemGroupingType[RelativeToItemGroupingType["Term"] = 280000] = "Term";
                RelativeToItemGroupingType[RelativeToItemGroupingType["TermGroup"] = 280001] = "TermGroup";
            })(RelativeToItemGroupingType = Enums.RelativeToItemGroupingType || (Enums.RelativeToItemGroupingType = {}));
            var ReleaseStateType;
            (function (ReleaseStateType) {
                ReleaseStateType[ReleaseStateType["Released"] = 20000] = "Released";
                ReleaseStateType[ReleaseStateType["Pending"] = 20001] = "Pending";
                ReleaseStateType[ReleaseStateType["Obsolete"] = 20002] = "Obsolete";
            })(ReleaseStateType = Enums.ReleaseStateType || (Enums.ReleaseStateType = {}));
            var RoleCategory;
            (function (RoleCategory) {
                RoleCategory[RoleCategory["CompanyRoles"] = 43000] = "CompanyRoles";
                RoleCategory[RoleCategory["DivisionRoles"] = 43001] = "DivisionRoles";
                RoleCategory[RoleCategory["SystemRoles"] = 43002] = "SystemRoles";
            })(RoleCategory = Enums.RoleCategory || (Enums.RoleCategory = {}));
            var RoomGender;
            (function (RoomGender) {
                RoomGender[RoomGender["Male"] = 355000] = "Male";
                RoomGender[RoomGender["Female"] = 355001] = "Female";
                RoomGender[RoomGender["All"] = 355002] = "All";
            })(RoomGender = Enums.RoomGender || (Enums.RoomGender = {}));
            var RoomOccupant;
            (function (RoomOccupant) {
                RoomOccupant[RoomOccupant["Student"] = 354000] = "Student";
                RoomOccupant[RoomOccupant["Staff"] = 354001] = "Staff";
                RoomOccupant[RoomOccupant["All"] = 354002] = "All";
            })(RoomOccupant = Enums.RoomOccupant || (Enums.RoomOccupant = {}));
            var SalesCatalogType;
            (function (SalesCatalogType) {
                SalesCatalogType[SalesCatalogType["StandardCamp"] = 343000] = "StandardCamp";
                SalesCatalogType[SalesCatalogType["AtSchoolMultiWeek"] = 343001] = "AtSchoolMultiWeek";
                SalesCatalogType[SalesCatalogType["AtSchoolOneDay"] = 343002] = "AtSchoolOneDay";
                SalesCatalogType[SalesCatalogType["Merchandise"] = 343003] = "Merchandise";
                SalesCatalogType[SalesCatalogType["OPLGeneric"] = 343004] = "OPLGeneric";
                SalesCatalogType[SalesCatalogType["OPLThemed"] = 343005] = "OPLThemed";
                SalesCatalogType[SalesCatalogType["SquadsConsecutiveDays"] = 343006] = "SquadsConsecutiveDays";
                SalesCatalogType[SalesCatalogType["SquadsMultiWeek"] = 343007] = "SquadsMultiWeek";
                SalesCatalogType[SalesCatalogType["CourseBundle"] = 343008] = "CourseBundle";
            })(SalesCatalogType = Enums.SalesCatalogType || (Enums.SalesCatalogType = {}));
            var SavableSearchType;
            (function (SavableSearchType) {
                SavableSearchType[SavableSearchType["TermStaffApplicationSearch"] = 234000] = "TermStaffApplicationSearch";
            })(SavableSearchType = Enums.SavableSearchType || (Enums.SavableSearchType = {}));
            var SavableSearchCriteriaType;
            (function (SavableSearchCriteriaType) {
                SavableSearchCriteriaType[SavableSearchCriteriaType["TermGroup"] = 235000] = "TermGroup";
                SavableSearchCriteriaType[SavableSearchCriteriaType["Division"] = 235001] = "Division";
                SavableSearchCriteriaType[SavableSearchCriteriaType["ClaimedByRM"] = 235002] = "ClaimedByRM";
                SavableSearchCriteriaType[SavableSearchCriteriaType["Region"] = 235003] = "Region";
                SavableSearchCriteriaType[SavableSearchCriteriaType["Location"] = 235004] = "Location";
                SavableSearchCriteriaType[SavableSearchCriteriaType["JobTitle"] = 235005] = "JobTitle";
                SavableSearchCriteriaType[SavableSearchCriteriaType["ApplicationStatus"] = 235006] = "ApplicationStatus";
                SavableSearchCriteriaType[SavableSearchCriteriaType["FirstName"] = 235007] = "FirstName";
                SavableSearchCriteriaType[SavableSearchCriteriaType["LastName"] = 235008] = "LastName";
                SavableSearchCriteriaType[SavableSearchCriteriaType["PreferredName"] = 235009] = "PreferredName";
                SavableSearchCriteriaType[SavableSearchCriteriaType["Email"] = 235010] = "Email";
                SavableSearchCriteriaType[SavableSearchCriteriaType["AdvancedSearchOption"] = 235011] = "AdvancedSearchOption";
                SavableSearchCriteriaType[SavableSearchCriteriaType["QualifyByJobTitle"] = 235012] = "QualifyByJobTitle";
                SavableSearchCriteriaType[SavableSearchCriteriaType["QualifyByCourse"] = 235013] = "QualifyByCourse";
                SavableSearchCriteriaType[SavableSearchCriteriaType["IsQualifyByAvgScore"] = 235014] = "IsQualifyByAvgScore";
                SavableSearchCriteriaType[SavableSearchCriteriaType["IsQualifyByTotalScore"] = 235015] = "IsQualifyByTotalScore";
                SavableSearchCriteriaType[SavableSearchCriteriaType["QualifyByAvgScore"] = 235016] = "QualifyByAvgScore";
                SavableSearchCriteriaType[SavableSearchCriteriaType["QualifyByTotalScore"] = 235017] = "QualifyByTotalScore";
                SavableSearchCriteriaType[SavableSearchCriteriaType["Skill"] = 235018] = "Skill";
                SavableSearchCriteriaType[SavableSearchCriteriaType["IsQualifyBySkillAvgScore"] = 235019] = "IsQualifyBySkillAvgScore";
                SavableSearchCriteriaType[SavableSearchCriteriaType["IsQualifyBySkillTotalScore"] = 235020] = "IsQualifyBySkillTotalScore";
                SavableSearchCriteriaType[SavableSearchCriteriaType["QualifyBySkillAvgScore"] = 235021] = "QualifyBySkillAvgScore";
                SavableSearchCriteriaType[SavableSearchCriteriaType["QualifyBySkillTotalScore"] = 235022] = "QualifyBySkillTotalScore";
                SavableSearchCriteriaType[SavableSearchCriteriaType["IsShowExcluded"] = 235023] = "IsShowExcluded";
                SavableSearchCriteriaType[SavableSearchCriteriaType["ApplicationStatusForSearch"] = 235024] = "ApplicationStatusForSearch";
                SavableSearchCriteriaType[SavableSearchCriteriaType["CanCommute"] = 235025] = "CanCommute";
                SavableSearchCriteriaType[SavableSearchCriteriaType["CanTravel"] = 235026] = "CanTravel";
                SavableSearchCriteriaType[SavableSearchCriteriaType["ShowAppProcessStatuses"] = 235027] = "ShowAppProcessStatuses";
                SavableSearchCriteriaType[SavableSearchCriteriaType["LocationStateTypeID"] = 235028] = "LocationStateTypeID";
                SavableSearchCriteriaType[SavableSearchCriteriaType["LocationCity"] = 235029] = "LocationCity";
                SavableSearchCriteriaType[SavableSearchCriteriaType["LocationsNearby"] = 235030] = "LocationsNearby";
                SavableSearchCriteriaType[SavableSearchCriteriaType["MinimumDegree"] = 235031] = "MinimumDegree";
                SavableSearchCriteriaType[SavableSearchCriteriaType["IncludeDegreeInProgress"] = 235032] = "IncludeDegreeInProgress";
            })(SavableSearchCriteriaType = Enums.SavableSearchCriteriaType || (Enums.SavableSearchCriteriaType = {}));
            var ScheduleDefType;
            (function (ScheduleDefType) {
                ScheduleDefType[ScheduleDefType["Course"] = 51000] = "Course";
                ScheduleDefType[ScheduleDefType["Meal"] = 51001] = "Meal";
                ScheduleDefType[ScheduleDefType["Residency"] = 51002] = "Residency";
            })(ScheduleDefType = Enums.ScheduleDefType || (Enums.ScheduleDefType = {}));
            var ScheduleDetailType;
            (function (ScheduleDetailType) {
                ScheduleDetailType[ScheduleDetailType["AllDays"] = 79000] = "AllDays";
                ScheduleDetailType[ScheduleDetailType["SingleDay"] = 79001] = "SingleDay";
            })(ScheduleDetailType = Enums.ScheduleDetailType || (Enums.ScheduleDetailType = {}));
            var ScheduledPaymentPlanType;
            (function (ScheduledPaymentPlanType) {
                ScheduledPaymentPlanType[ScheduledPaymentPlanType["InPersonCamps"] = 391000] = "InPersonCamps";
                ScheduledPaymentPlanType[ScheduledPaymentPlanType["Semesters"] = 391001] = "Semesters";
            })(ScheduledPaymentPlanType = Enums.ScheduledPaymentPlanType || (Enums.ScheduledPaymentPlanType = {}));
            var ScheduledPaymentStatusType;
            (function (ScheduledPaymentStatusType) {
                ScheduledPaymentStatusType[ScheduledPaymentStatusType["Unpaid"] = 392000] = "Unpaid";
                ScheduledPaymentStatusType[ScheduledPaymentStatusType["Paid"] = 392001] = "Paid";
                ScheduledPaymentStatusType[ScheduledPaymentStatusType["PaymentFailedNoRetry"] = 392002] = "PaymentFailedNoRetry";
                ScheduledPaymentStatusType[ScheduledPaymentStatusType["PaymentFailedAttempt1"] = 392003] = "PaymentFailedAttempt1";
                ScheduledPaymentStatusType[ScheduledPaymentStatusType["PaymentFailedAttempt2"] = 392004] = "PaymentFailedAttempt2";
            })(ScheduledPaymentStatusType = Enums.ScheduledPaymentStatusType || (Enums.ScheduledPaymentStatusType = {}));
            var SchoolDegreeType;
            (function (SchoolDegreeType) {
                SchoolDegreeType[SchoolDegreeType["HighSchoolDiploma"] = 231000] = "HighSchoolDiploma";
                SchoolDegreeType[SchoolDegreeType["BSBA"] = 231001] = "BSBA";
                SchoolDegreeType[SchoolDegreeType["Masters"] = 231002] = "Masters";
                SchoolDegreeType[SchoolDegreeType["PHD"] = 231003] = "PHD";
                SchoolDegreeType[SchoolDegreeType["Associates"] = 231004] = "Associates";
            })(SchoolDegreeType = Enums.SchoolDegreeType || (Enums.SchoolDegreeType = {}));
            var SectionType;
            (function (SectionType) {
                SectionType[SectionType["Single"] = 19000] = "Single";
                SectionType[SectionType["Combo"] = 19001] = "Combo";
            })(SectionType = Enums.SectionType || (Enums.SectionType = {}));
            var SectionWorkFlowStatus;
            (function (SectionWorkFlowStatus) {
                SectionWorkFlowStatus[SectionWorkFlowStatus["ManagerNotified"] = 394000] = "ManagerNotified";
            })(SectionWorkFlowStatus = Enums.SectionWorkFlowStatus || (Enums.SectionWorkFlowStatus = {}));
            var SecurityQuestionType;
            (function (SecurityQuestionType) {
                SecurityQuestionType[SecurityQuestionType["UserAccount"] = 186000] = "UserAccount";
            })(SecurityQuestionType = Enums.SecurityQuestionType || (Enums.SecurityQuestionType = {}));
            var SessionAvailabilityStatus;
            (function (SessionAvailabilityStatus) {
                SessionAvailabilityStatus[SessionAvailabilityStatus["Open"] = 152000] = "Open";
                SessionAvailabilityStatus[SessionAvailabilityStatus["AlmostFull"] = 152001] = "AlmostFull";
                SessionAvailabilityStatus[SessionAvailabilityStatus["NoSpace"] = 152002] = "NoSpace";
                SessionAvailabilityStatus[SessionAvailabilityStatus["NA"] = 152003] = "NA";
                SessionAvailabilityStatus[SessionAvailabilityStatus["Coming"] = 152004] = "Coming";
                SessionAvailabilityStatus[SessionAvailabilityStatus["Closed"] = 152005] = "Closed";
                SessionAvailabilityStatus[SessionAvailabilityStatus["CallUs"] = 152006] = "CallUs";
                SessionAvailabilityStatus[SessionAvailabilityStatus["SoldOut"] = 152007] = "SoldOut";
                SessionAvailabilityStatus[SessionAvailabilityStatus["Space1"] = 152008] = "Space1";
                SessionAvailabilityStatus[SessionAvailabilityStatus["Space2"] = 152009] = "Space2";
                SessionAvailabilityStatus[SessionAvailabilityStatus["Space3"] = 152010] = "Space3";
                SessionAvailabilityStatus[SessionAvailabilityStatus["NotOffered"] = 152011] = "NotOffered";
                SessionAvailabilityStatus[SessionAvailabilityStatus["SelectAnotherWeek"] = 152012] = "SelectAnotherWeek";
                SessionAvailabilityStatus[SessionAvailabilityStatus["SoldOutDesktop"] = 152013] = "SoldOutDesktop";
                SessionAvailabilityStatus[SessionAvailabilityStatus["Space4"] = 152014] = "Space4";
            })(SessionAvailabilityStatus = Enums.SessionAvailabilityStatus || (Enums.SessionAvailabilityStatus = {}));
            var ShippingOptionType;
            (function (ShippingOptionType) {
                ShippingOptionType[ShippingOptionType["CampinaBoxShipment"] = 284000] = "CampinaBoxShipment";
                ShippingOptionType[ShippingOptionType["FedExDeliveriesforStaffPaychecks"] = 284001] = "FedExDeliveriesforStaffPaychecks";
                ShippingOptionType[ShippingOptionType["ComputersUnloadingLoading"] = 284002] = "ComputersUnloadingLoading";
                ShippingOptionType[ShippingOptionType["FedExDeliveriesforComputers"] = 284003] = "FedExDeliveriesforComputers";
                ShippingOptionType[ShippingOptionType["USPSCarePackagesLettersFromHome"] = 284004] = "USPSCarePackagesLettersFromHome";
            })(ShippingOptionType = Enums.ShippingOptionType || (Enums.ShippingOptionType = {}));
            var ShirtSizeType;
            (function (ShirtSizeType) {
                ShirtSizeType[ShirtSizeType["MenXXS"] = 84000] = "MenXXS";
                ShirtSizeType[ShirtSizeType["MenXS"] = 84001] = "MenXS";
                ShirtSizeType[ShirtSizeType["MenS"] = 84002] = "MenS";
                ShirtSizeType[ShirtSizeType["MenM"] = 84003] = "MenM";
                ShirtSizeType[ShirtSizeType["MenL"] = 84004] = "MenL";
                ShirtSizeType[ShirtSizeType["MenXL"] = 84005] = "MenXL";
                ShirtSizeType[ShirtSizeType["Men2XL"] = 84006] = "Men2XL";
                ShirtSizeType[ShirtSizeType["Men3XL"] = 84007] = "Men3XL";
                ShirtSizeType[ShirtSizeType["WomenXXS"] = 84008] = "WomenXXS";
                ShirtSizeType[ShirtSizeType["WomenXS"] = 84009] = "WomenXS";
                ShirtSizeType[ShirtSizeType["WomenS"] = 84010] = "WomenS";
                ShirtSizeType[ShirtSizeType["WomenM"] = 84011] = "WomenM";
                ShirtSizeType[ShirtSizeType["WomenL"] = 84012] = "WomenL";
                ShirtSizeType[ShirtSizeType["WomenXL"] = 84013] = "WomenXL";
                ShirtSizeType[ShirtSizeType["Women2XL"] = 84014] = "Women2XL";
                ShirtSizeType[ShirtSizeType["AdultXXS"] = 84016] = "AdultXXS";
                ShirtSizeType[ShirtSizeType["YouthS"] = 84017] = "YouthS";
                ShirtSizeType[ShirtSizeType["YouthL"] = 84018] = "YouthL";
                ShirtSizeType[ShirtSizeType["Adult3XL"] = 84019] = "Adult3XL";
                ShirtSizeType[ShirtSizeType["Adult4XL"] = 84020] = "Adult4XL";
            })(ShirtSizeType = Enums.ShirtSizeType || (Enums.ShirtSizeType = {}));
            var ShirtSizeGroupType;
            (function (ShirtSizeGroupType) {
                ShirtSizeGroupType[ShirtSizeGroupType["Student"] = 296000] = "Student";
                ShirtSizeGroupType[ShirtSizeGroupType["Staff"] = 296001] = "Staff";
            })(ShirtSizeGroupType = Enums.ShirtSizeGroupType || (Enums.ShirtSizeGroupType = {}));
            var ShoppingCartType;
            (function (ShoppingCartType) {
                ShoppingCartType[ShoppingCartType["Abandonment"] = 348000] = "Abandonment";
                ShoppingCartType[ShoppingCartType["RegFlow"] = 348001] = "RegFlow";
                ShoppingCartType[ShoppingCartType["ChangeOrder_Location"] = 348002] = "ChangeOrder_Location";
                ShoppingCartType[ShoppingCartType["ChangeOrder_SessionDate"] = 348003] = "ChangeOrder_SessionDate";
                ShoppingCartType[ShoppingCartType["ChangeOrder_Course"] = 348004] = "ChangeOrder_Course";
                ShoppingCartType[ShoppingCartType["ChangeOrder_OptionsOnly"] = 348005] = "ChangeOrder_OptionsOnly";
                ShoppingCartType[ShoppingCartType["ChangeOrder_From"] = 348006] = "ChangeOrder_From";
            })(ShoppingCartType = Enums.ShoppingCartType || (Enums.ShoppingCartType = {}));
            var SkillType;
            (function (SkillType) {
                SkillType[SkillType["Staff"] = 281000] = "Staff";
                SkillType[SkillType["Student"] = 281001] = "Student";
                SkillType[SkillType["StudentLevel"] = 281002] = "StudentLevel";
                SkillType[SkillType["Transcript"] = 281003] = "Transcript";
                SkillType[SkillType["OPLTopic"] = 281004] = "OPLTopic";
            })(SkillType = Enums.SkillType || (Enums.SkillType = {}));
            var SkillURLUsageType;
            (function (SkillURLUsageType) {
                SkillURLUsageType[SkillURLUsageType["LargeImage"] = 386000] = "LargeImage";
                SkillURLUsageType[SkillURLUsageType["SmallImage"] = 386001] = "SmallImage";
                SkillURLUsageType[SkillURLUsageType["TopicSetup"] = 386002] = "TopicSetup";
            })(SkillURLUsageType = Enums.SkillURLUsageType || (Enums.SkillURLUsageType = {}));
            var SqlAgentTaskType;
            (function (SqlAgentTaskType) {
                SqlAgentTaskType[SqlAgentTaskType["PopulateDiscountSessionDataForSession"] = 144000] = "PopulateDiscountSessionDataForSession";
                SqlAgentTaskType[SqlAgentTaskType["PushSessionProductToKermit"] = 144001] = "PushSessionProductToKermit";
                SqlAgentTaskType[SqlAgentTaskType["PopulateDiscountSessionDataForDiscount"] = 144002] = "PopulateDiscountSessionDataForDiscount";
                SqlAgentTaskType[SqlAgentTaskType["UpdateCalculatedMinAndMaxAges"] = 144003] = "UpdateCalculatedMinAndMaxAges";
                SqlAgentTaskType[SqlAgentTaskType["UpdateCalculatedMaxAges"] = 144004] = "UpdateCalculatedMaxAges";
                SqlAgentTaskType[SqlAgentTaskType["UpdateCalculatedMinAges"] = 144005] = "UpdateCalculatedMinAges";
                SqlAgentTaskType[SqlAgentTaskType["UpdateUserFormDueDates"] = 144006] = "UpdateUserFormDueDates";
                SqlAgentTaskType[SqlAgentTaskType["StaffTaskPopulation"] = 144007] = "StaffTaskPopulation";
            })(SqlAgentTaskType = Enums.SqlAgentTaskType || (Enums.SqlAgentTaskType = {}));
            var StaffAssignmentPubStatus;
            (function (StaffAssignmentPubStatus) {
                StaffAssignmentPubStatus[StaffAssignmentPubStatus["Unpublished"] = 265000] = "Unpublished";
                StaffAssignmentPubStatus[StaffAssignmentPubStatus["Published"] = 265001] = "Published";
                StaffAssignmentPubStatus[StaffAssignmentPubStatus["Cancelled"] = 265002] = "Cancelled";
            })(StaffAssignmentPubStatus = Enums.StaffAssignmentPubStatus || (Enums.StaffAssignmentPubStatus = {}));
            var StaffAssignmentType;
            (function (StaffAssignmentType) {
                StaffAssignmentType[StaffAssignmentType["CourseTeachingJob"] = 266000] = "CourseTeachingJob";
                StaffAssignmentType[StaffAssignmentType["CampManagementJob"] = 266001] = "CampManagementJob";
                StaffAssignmentType[StaffAssignmentType["NonJobPayItems"] = 266002] = "NonJobPayItems";
            })(StaffAssignmentType = Enums.StaffAssignmentType || (Enums.StaffAssignmentType = {}));
            var StaffTaskDisplayType;
            (function (StaffTaskDisplayType) {
                StaffTaskDisplayType[StaffTaskDisplayType["BeforeCamp"] = 306000] = "BeforeCamp";
                StaffTaskDisplayType[StaffTaskDisplayType["SampleSetup"] = 306001] = "SampleSetup";
                StaffTaskDisplayType[StaffTaskDisplayType["SampleIDTech"] = 306002] = "SampleIDTech";
                StaffTaskDisplayType[StaffTaskDisplayType["SampleAcademy"] = 306003] = "SampleAcademy";
                StaffTaskDisplayType[StaffTaskDisplayType["SampleOrientation"] = 306004] = "SampleOrientation";
                StaffTaskDisplayType[StaffTaskDisplayType["SampleMini"] = 306005] = "SampleMini";
                StaffTaskDisplayType[StaffTaskDisplayType["SampleAlexaCafe"] = 306006] = "SampleAlexaCafe";
            })(StaffTaskDisplayType = Enums.StaffTaskDisplayType || (Enums.StaffTaskDisplayType = {}));
            var StaffTaskUserStatusType;
            (function (StaffTaskUserStatusType) {
                StaffTaskUserStatusType[StaffTaskUserStatusType["Incomplete"] = 305000] = "Incomplete";
                StaffTaskUserStatusType[StaffTaskUserStatusType["Complete"] = 305001] = "Complete";
            })(StaffTaskUserStatusType = Enums.StaffTaskUserStatusType || (Enums.StaffTaskUserStatusType = {}));
            var StatementViewTimePeriodType;
            (function (StatementViewTimePeriodType) {
                StatementViewTimePeriodType[StatementViewTimePeriodType["ViewByCalendarYear"] = 175000] = "ViewByCalendarYear";
                StatementViewTimePeriodType[StatementViewTimePeriodType["ViewCompleteTransactionHistory"] = 175001] = "ViewCompleteTransactionHistory";
                StatementViewTimePeriodType[StatementViewTimePeriodType["ViewByTransactionDate"] = 175002] = "ViewByTransactionDate";
            })(StatementViewTimePeriodType = Enums.StatementViewTimePeriodType || (Enums.StatementViewTimePeriodType = {}));
            var StatementViewTransactionsType;
            (function (StatementViewTransactionsType) {
                StatementViewTransactionsType[StatementViewTransactionsType["TransactionsForPrimaryCustomer"] = 174000] = "TransactionsForPrimaryCustomer";
                StatementViewTransactionsType[StatementViewTransactionsType["TransactionsForParentAndOrGuardian"] = 174001] = "TransactionsForParentAndOrGuardian";
            })(StatementViewTransactionsType = Enums.StatementViewTransactionsType || (Enums.StatementViewTransactionsType = {}));
            var StateSubRegion;
            (function (StateSubRegion) {
                StateSubRegion[StateSubRegion["Northern"] = 324000] = "Northern";
                StateSubRegion[StateSubRegion["Southern"] = 324001] = "Southern";
            })(StateSubRegion = Enums.StateSubRegion || (Enums.StateSubRegion = {}));
            var SuffixType;
            (function (SuffixType) {
                SuffixType[SuffixType["Jr"] = 85000] = "Jr";
                SuffixType[SuffixType["Sr"] = 85001] = "Sr";
            })(SuffixType = Enums.SuffixType || (Enums.SuffixType = {}));
            var SupplyandLicenseRatioCategory;
            (function (SupplyandLicenseRatioCategory) {
                SupplyandLicenseRatioCategory[SupplyandLicenseRatioCategory["SupplyItemRules"] = 368000] = "SupplyItemRules";
                SupplyandLicenseRatioCategory[SupplyandLicenseRatioCategory["LicenseItemAssignmentRules"] = 368001] = "LicenseItemAssignmentRules";
            })(SupplyandLicenseRatioCategory = Enums.SupplyandLicenseRatioCategory || (Enums.SupplyandLicenseRatioCategory = {}));
            var SupplyItemClass;
            (function (SupplyItemClass) {
                SupplyItemClass[SupplyItemClass["InventoryItem"] = 361000] = "InventoryItem";
                SupplyItemClass[SupplyItemClass["SerializableItem"] = 361001] = "SerializableItem";
                SupplyItemClass[SupplyItemClass["Container"] = 361002] = "Container";
            })(SupplyItemClass = Enums.SupplyItemClass || (Enums.SupplyItemClass = {}));
            var SupplyOrLicenseRatio;
            (function (SupplyOrLicenseRatio) {
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["LabCapacity"] = 334000] = "LabCapacity";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["Registration"] = 334001] = "Registration";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["SpecialOrder"] = 334002] = "SpecialOrder";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["Location"] = 334003] = "Location";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["CampManagementStaffAndLI"] = 334004] = "CampManagementStaffAndLI";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["CampStaff"] = 334005] = "CampStaff";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["Session"] = 334006] = "Session";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["SectionMaxPerSession"] = 334007] = "SectionMaxPerSession";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["OvernightLocationRegistration"] = 334008] = "OvernightLocationRegistration";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["SupplementalList"] = 334009] = "SupplementalList";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["LocationProduct"] = 334010] = "LocationProduct";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["RegistrationProduct"] = 334011] = "RegistrationProduct";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["LabCapacitySessions"] = 334012] = "LabCapacitySessions";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["OvernightCapacity"] = 334013] = "OvernightCapacity";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["SectionTotalPerTermGroup"] = 334014] = "SectionTotalPerTermGroup";
                SupplyOrLicenseRatio[SupplyOrLicenseRatio["LabCapacityProduct"] = 334015] = "LabCapacityProduct";
            })(SupplyOrLicenseRatio = Enums.SupplyOrLicenseRatio || (Enums.SupplyOrLicenseRatio = {}));
            var SurveyAnswerCommentDispType;
            (function (SurveyAnswerCommentDispType) {
                SurveyAnswerCommentDispType[SurveyAnswerCommentDispType["None"] = 210000] = "None";
                SurveyAnswerCommentDispType[SurveyAnswerCommentDispType["AvailableWhenSelected"] = 210001] = "AvailableWhenSelected";
                SurveyAnswerCommentDispType[SurveyAnswerCommentDispType["Always"] = 210002] = "Always";
            })(SurveyAnswerCommentDispType = Enums.SurveyAnswerCommentDispType || (Enums.SurveyAnswerCommentDispType = {}));
            var SurveyAnswerDataType;
            (function (SurveyAnswerDataType) {
                SurveyAnswerDataType[SurveyAnswerDataType["Text"] = 209000] = "Text";
                SurveyAnswerDataType[SurveyAnswerDataType["Date"] = 209001] = "Date";
                SurveyAnswerDataType[SurveyAnswerDataType["Number"] = 209002] = "Number";
            })(SurveyAnswerDataType = Enums.SurveyAnswerDataType || (Enums.SurveyAnswerDataType = {}));
            var SurveyAnswerFormatType;
            (function (SurveyAnswerFormatType) {
                SurveyAnswerFormatType[SurveyAnswerFormatType["RadioButton"] = 208000] = "RadioButton";
                SurveyAnswerFormatType[SurveyAnswerFormatType["CheckBox"] = 208001] = "CheckBox";
                SurveyAnswerFormatType[SurveyAnswerFormatType["TextSingleLine"] = 208002] = "TextSingleLine";
                SurveyAnswerFormatType[SurveyAnswerFormatType["TextMultiline"] = 208003] = "TextMultiline";
                SurveyAnswerFormatType[SurveyAnswerFormatType["Date"] = 208004] = "Date";
                SurveyAnswerFormatType[SurveyAnswerFormatType["SingleSelectDropdown"] = 208005] = "SingleSelectDropdown";
            })(SurveyAnswerFormatType = Enums.SurveyAnswerFormatType || (Enums.SurveyAnswerFormatType = {}));
            var SurveyStatisticsAnswerType;
            (function (SurveyStatisticsAnswerType) {
                SurveyStatisticsAnswerType[SurveyStatisticsAnswerType["Satisfied"] = 215000] = "Satisfied";
                SurveyStatisticsAnswerType[SurveyStatisticsAnswerType["NotSatisfied"] = 215001] = "NotSatisfied";
                SurveyStatisticsAnswerType[SurveyStatisticsAnswerType["NeutralorNotApplicable"] = 215002] = "NeutralorNotApplicable";
                SurveyStatisticsAnswerType[SurveyStatisticsAnswerType["Yes"] = 215003] = "Yes";
                SurveyStatisticsAnswerType[SurveyStatisticsAnswerType["No"] = 215004] = "No";
                SurveyStatisticsAnswerType[SurveyStatisticsAnswerType["NotSure"] = 215005] = "NotSure";
                SurveyStatisticsAnswerType[SurveyStatisticsAnswerType["Positive"] = 215006] = "Positive";
                SurveyStatisticsAnswerType[SurveyStatisticsAnswerType["Negative"] = 215007] = "Negative";
                SurveyStatisticsAnswerType[SurveyStatisticsAnswerType["Neutral"] = 215008] = "Neutral";
            })(SurveyStatisticsAnswerType = Enums.SurveyStatisticsAnswerType || (Enums.SurveyStatisticsAnswerType = {}));
            var SurveyStatisticsQuestionType;
            (function (SurveyStatisticsQuestionType) {
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["Satisfaction"] = 216000] = "Satisfaction";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["WillReturn"] = 216001] = "WillReturn";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["StaffAboveBeyond"] = 216002] = "StaffAboveBeyond";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["StaffReview_QualityOfInstruction"] = 216003] = "StaffReview_QualityOfInstruction";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["StaffReview_SupervisionRapportWithStudents"] = 216004] = "StaffReview_SupervisionRapportWithStudents";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["StaffReview_MaturityFlexibilityTeamRapport"] = 216005] = "StaffReview_MaturityFlexibilityTeamRapport";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["StaffReview_PromotionRehire"] = 216007] = "StaffReview_PromotionRehire";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["DirectorReview_QualityOfOrganization"] = 216008] = "DirectorReview_QualityOfOrganization";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["DirectorReview_MaturityStressMgtTeamRepport"] = 216009] = "DirectorReview_MaturityStressMgtTeamRepport";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["DirectorReview_SupervisionRapportWithStudents"] = 216010] = "DirectorReview_SupervisionRapportWithStudents";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["DirectorReview_Rehire"] = 216011] = "DirectorReview_Rehire";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["Sentiment"] = 216012] = "Sentiment";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["RMReview_QualityOfDuties"] = 216013] = "RMReview_QualityOfDuties";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["RMReview_MaturityFlexibilityTeamRapportStressMgmt"] = 216014] = "RMReview_MaturityFlexibilityTeamRapportStressMgmt";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["RMReview_SupervisionRapportWithStudents"] = 216015] = "RMReview_SupervisionRapportWithStudents";
                SurveyStatisticsQuestionType[SurveyStatisticsQuestionType["RMReview_Rehire"] = 216016] = "RMReview_Rehire";
            })(SurveyStatisticsQuestionType = Enums.SurveyStatisticsQuestionType || (Enums.SurveyStatisticsQuestionType = {}));
            var SurveyTagTypeMask;
            (function (SurveyTagTypeMask) {
                SurveyTagTypeMask[SurveyTagTypeMask["None"] = 0] = "None";
                SurveyTagTypeMask[SurveyTagTypeMask["PositiveQuote"] = 1] = "PositiveQuote";
                SurveyTagTypeMask[SurveyTagTypeMask["All"] = 65535] = "All";
            })(SurveyTagTypeMask = Enums.SurveyTagTypeMask || (Enums.SurveyTagTypeMask = {}));
            var SurveyType;
            (function (SurveyType) {
                SurveyType[SurveyType["ParticipantEvaluation"] = 207000] = "ParticipantEvaluation";
                SurveyType[SurveyType["ParticipantEvaluationMidSession"] = 207001] = "ParticipantEvaluationMidSession";
                SurveyType[SurveyType["FamilyShowcaseEvaluation"] = 207002] = "FamilyShowcaseEvaluation";
                SurveyType[SurveyType["CampSetupEvaluation"] = 207003] = "CampSetupEvaluation";
                SurveyType[SurveyType["PeriodicCampEvaluationNonDirector"] = 207004] = "PeriodicCampEvaluationNonDirector";
                SurveyType[SurveyType["PerformanceReviewMidSeason"] = 207005] = "PerformanceReviewMidSeason";
                SurveyType[SurveyType["ParentEvaluationOfProgram"] = 207006] = "ParentEvaluationOfProgram";
                SurveyType[SurveyType["InstructorEvaluationOfDirectorAsstDirector"] = 207007] = "InstructorEvaluationOfDirectorAsstDirector";
                SurveyType[SurveyType["PerformanceReviewEndSeason"] = 207008] = "PerformanceReviewEndSeason";
                SurveyType[SurveyType["PeriodicCampEvaluationMgmtStaff"] = 207009] = "PeriodicCampEvaluationMgmtStaff";
                SurveyType[SurveyType["CurriculumEvaluation"] = 207010] = "CurriculumEvaluation";
                SurveyType[SurveyType["CompanyEvaluationNonDirector"] = 207011] = "CompanyEvaluationNonDirector";
                SurveyType[SurveyType["CompanyEvaluationDirector"] = 207012] = "CompanyEvaluationDirector";
                SurveyType[SurveyType["TermStaffReferenceQuestionnaire"] = 207013] = "TermStaffReferenceQuestionnaire";
                SurveyType[SurveyType["TermStaffReferenceQuestionnaireSupCoworker"] = 207014] = "TermStaffReferenceQuestionnaireSupCoworker";
                SurveyType[SurveyType["RMEvaluationOfDirectorAsstDirector"] = 207015] = "RMEvaluationOfDirectorAsstDirector";
                SurveyType[SurveyType["RMEvaluationOfInstructor"] = 207016] = "RMEvaluationOfInstructor";
                SurveyType[SurveyType["RMEvaluationOfHealthSafetyCoordinator"] = 207017] = "RMEvaluationOfHealthSafetyCoordinator";
                SurveyType[SurveyType["RMEvaluationOfActivitiesCoordinator"] = 207018] = "RMEvaluationOfActivitiesCoordinator";
                SurveyType[SurveyType["TuitionAssistanceProgram"] = 207019] = "TuitionAssistanceProgram";
            })(SurveyType = Enums.SurveyType || (Enums.SurveyType = {}));
            var SupplyRequestStatusType;
            (function (SupplyRequestStatusType) {
                SupplyRequestStatusType[SupplyRequestStatusType["Draft"] = 213000] = "Draft";
                SupplyRequestStatusType[SupplyRequestStatusType["Submitted"] = 213001] = "Submitted";
                SupplyRequestStatusType[SupplyRequestStatusType["Fulfilled"] = 213002] = "Fulfilled";
            })(SupplyRequestStatusType = Enums.SupplyRequestStatusType || (Enums.SupplyRequestStatusType = {}));
            var SupplyCategoryType;
            (function (SupplyCategoryType) {
                SupplyCategoryType[SupplyCategoryType["GeneralSupplies"] = 214000] = "GeneralSupplies";
                SupplyCategoryType[SupplyCategoryType["ElectronicEquipment"] = 214001] = "ElectronicEquipment";
            })(SupplyCategoryType = Enums.SupplyCategoryType || (Enums.SupplyCategoryType = {}));
            var TermsAndConditionsType;
            (function (TermsAndConditionsType) {
                TermsAndConditionsType[TermsAndConditionsType["CarpoolProgram"] = 106000] = "CarpoolProgram";
                TermsAndConditionsType[TermsAndConditionsType["General"] = 106001] = "General";
                TermsAndConditionsType[TermsAndConditionsType["ReferAFriendProgram"] = 106002] = "ReferAFriendProgram";
            })(TermsAndConditionsType = Enums.TermsAndConditionsType || (Enums.TermsAndConditionsType = {}));
            var TermGroupStatusType;
            (function (TermGroupStatusType) {
                TermGroupStatusType[TermGroupStatusType["Current"] = 206000] = "Current";
                TermGroupStatusType[TermGroupStatusType["Pending"] = 206001] = "Pending";
                TermGroupStatusType[TermGroupStatusType["Closed"] = 206002] = "Closed";
            })(TermGroupStatusType = Enums.TermGroupStatusType || (Enums.TermGroupStatusType = {}));
            var TermThresholdCapacityManagementAlertType;
            (function (TermThresholdCapacityManagementAlertType) {
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["SessionSoldOut"] = 36000] = "SessionSoldOut";
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["CourseNoDemand"] = 36001] = "CourseNoDemand";
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["CourseLowDemand"] = 36002] = "CourseLowDemand";
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["CourseSoldOut"] = 36003] = "CourseSoldOut";
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["SectionNoDemand"] = 36004] = "SectionNoDemand";
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["SectionLowDemand"] = 36005] = "SectionLowDemand";
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["OvernightNoDemand"] = 36006] = "OvernightNoDemand";
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["OvernightLowDemand"] = 36007] = "OvernightLowDemand";
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["WeekendNoDemand"] = 36008] = "WeekendNoDemand";
                TermThresholdCapacityManagementAlertType[TermThresholdCapacityManagementAlertType["WeekendLowDemand"] = 36009] = "WeekendLowDemand";
            })(TermThresholdCapacityManagementAlertType = Enums.TermThresholdCapacityManagementAlertType || (Enums.TermThresholdCapacityManagementAlertType = {}));
            var TermThresholdCategoryType;
            (function (TermThresholdCategoryType) {
                TermThresholdCategoryType[TermThresholdCategoryType["ImportantDate"] = 75000] = "ImportantDate";
                TermThresholdCategoryType[TermThresholdCategoryType["CapacityManagementAlert"] = 75001] = "CapacityManagementAlert";
                TermThresholdCategoryType[TermThresholdCategoryType["PaymentOption"] = 75002] = "PaymentOption";
            })(TermThresholdCategoryType = Enums.TermThresholdCategoryType || (Enums.TermThresholdCategoryType = {}));
            var TermThresholdDataCapacityType;
            (function (TermThresholdDataCapacityType) {
                TermThresholdDataCapacityType[TermThresholdDataCapacityType["DateOnly"] = 34000] = "DateOnly";
                TermThresholdDataCapacityType[TermThresholdDataCapacityType["DateRange"] = 34001] = "DateRange";
                TermThresholdDataCapacityType[TermThresholdDataCapacityType["LimitValueOnly"] = 34002] = "LimitValueOnly";
                TermThresholdDataCapacityType[TermThresholdDataCapacityType["LimitValuePlusDate"] = 34003] = "LimitValuePlusDate";
                TermThresholdDataCapacityType[TermThresholdDataCapacityType["LimitValuePlusDateRange"] = 34004] = "LimitValuePlusDateRange";
            })(TermThresholdDataCapacityType = Enums.TermThresholdDataCapacityType || (Enums.TermThresholdDataCapacityType = {}));
            var TermThresholdImportantDateType;
            (function (TermThresholdImportantDateType) {
                TermThresholdImportantDateType[TermThresholdImportantDateType["PublicRegistrationOpen"] = 35000] = "PublicRegistrationOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["MyAccountAddSessionOpen"] = 35001] = "MyAccountAddSessionOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["MyAccountChangeSessionOpen"] = 35002] = "MyAccountChangeSessionOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CSRegistrationOpen"] = 35003] = "CSRegistrationOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CSAddSessionOpen"] = 35004] = "CSAddSessionOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CSChangeSessionOpen"] = 35005] = "CSChangeSessionOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["RequiredFormsDueDate"] = 35013] = "RequiredFormsDueDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["FormsAvailableDate"] = 35014] = "FormsAvailableDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CEUFormViewable"] = 35021] = "CEUFormViewable";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CEUFormEditable"] = 35022] = "CEUFormEditable";
                TermThresholdImportantDateType[TermThresholdImportantDateType["MapsOpen"] = 35023] = "MapsOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["DirectorCellPhoneAvailable"] = 35024] = "DirectorCellPhoneAvailable";
                TermThresholdImportantDateType[TermThresholdImportantDateType["AdminChangeFeeChargedTimePeriod"] = 35025] = "AdminChangeFeeChargedTimePeriod";
                TermThresholdImportantDateType[TermThresholdImportantDateType["BalanceDueDate"] = 35026] = "BalanceDueDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["LateBalanceDueDate"] = 35027] = "LateBalanceDueDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffApplicationAvailable"] = 35028] = "TermStaffApplicationAvailable";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TuitionAssistancePublicOpen"] = 35029] = "TuitionAssistancePublicOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["AdditionalFormsOpen"] = 35030] = "AdditionalFormsOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["AdditionalFormsDueDate"] = 35031] = "AdditionalFormsDueDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["AdditionalFormsLateDueDate"] = 35032] = "AdditionalFormsLateDueDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["BalanceDueReminderEmailSent"] = 35033] = "BalanceDueReminderEmailSent";
                TermThresholdImportantDateType[TermThresholdImportantDateType["BalanceOverdueEmailSent1"] = 35034] = "BalanceOverdueEmailSent1";
                TermThresholdImportantDateType[TermThresholdImportantDateType["BalanceOverdueEmailSent2"] = 35035] = "BalanceOverdueEmailSent2";
                TermThresholdImportantDateType[TermThresholdImportantDateType["BalanceOverdueEmailSent3"] = 35036] = "BalanceOverdueEmailSent3";
                TermThresholdImportantDateType[TermThresholdImportantDateType["BalanceOverdueEmailSent4"] = 35037] = "BalanceOverdueEmailSent4";
                TermThresholdImportantDateType[TermThresholdImportantDateType["RequiredFormsReminderEmail1Sent"] = 35038] = "RequiredFormsReminderEmail1Sent";
                TermThresholdImportantDateType[TermThresholdImportantDateType["RequiredFormReminderCalls1"] = 35039] = "RequiredFormReminderCalls1";
                TermThresholdImportantDateType[TermThresholdImportantDateType["RequiredFormReminderCalls2"] = 35040] = "RequiredFormReminderCalls2";
                TermThresholdImportantDateType[TermThresholdImportantDateType["PromotionReminderEmail"] = 35041] = "PromotionReminderEmail";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CancellationRefundTuitionLessDeposit"] = 35042] = "CancellationRefundTuitionLessDeposit";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CreditsGivenForDowngrades"] = 35043] = "CreditsGivenForDowngrades";
                TermThresholdImportantDateType[TermThresholdImportantDateType["FindOnlies"] = 35044] = "FindOnlies";
                TermThresholdImportantDateType[TermThresholdImportantDateType["MyAccountCancelSessionOpen"] = 35047] = "MyAccountCancelSessionOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CSCancelSessionOpen"] = 35048] = "CSCancelSessionOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["OverdueBalancesAutomaticallyCharged"] = 35049] = "OverdueBalancesAutomaticallyCharged";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffREPDueDate"] = 35050] = "TermStaffREPDueDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffCertificationsDueDate"] = 35051] = "TermStaffCertificationsDueDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffARFDueDate"] = 35052] = "TermStaffARFDueDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffLateHire"] = 35053] = "TermStaffLateHire";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffARFOpen"] = 35054] = "TermStaffARFOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffPayrollPaperworkDueDate"] = 35055] = "TermStaffPayrollPaperworkDueDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffTrainingOpenDate"] = 35056] = "TermStaffTrainingOpenDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffReferenceCheckEmailOpenDate"] = 35057] = "TermStaffReferenceCheckEmailOpenDate";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffConfidentialDataOpen"] = 35058] = "TermStaffConfidentialDataOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffPublishWorkSchedule"] = 35059] = "TermStaffPublishWorkSchedule";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffTaxStateIDAutoChangeClose"] = 35060] = "TermStaffTaxStateIDAutoChangeClose";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffTerminateButtonAvailable"] = 35061] = "TermStaffTerminateButtonAvailable";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffCornerAvailable"] = 35062] = "TermStaffCornerAvailable";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffViewMyEmailsAvailable"] = 35063] = "TermStaffViewMyEmailsAvailable";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CatalogEmail"] = 35064] = "CatalogEmail";
                TermThresholdImportantDateType[TermThresholdImportantDateType["CatalogMail"] = 35065] = "CatalogMail";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TermStaffEHAndREPAvailable"] = 35066] = "TermStaffEHAndREPAvailable";
                TermThresholdImportantDateType[TermThresholdImportantDateType["TuitionAssistanceCSOpen"] = 35067] = "TuitionAssistanceCSOpen";
                TermThresholdImportantDateType[TermThresholdImportantDateType["VIPEarlyAccessPassOpen"] = 35068] = "VIPEarlyAccessPassOpen";
            })(TermThresholdImportantDateType = Enums.TermThresholdImportantDateType || (Enums.TermThresholdImportantDateType = {}));
            var TermThresholdPaymentOptionType;
            (function (TermThresholdPaymentOptionType) {
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["PublicRegistrationFullPayment"] = 37000] = "PublicRegistrationFullPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["PublicRegistrationDepositPayment"] = 37001] = "PublicRegistrationDepositPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["PublicRegistrationDepositPlusAdditionalPayment"] = 37002] = "PublicRegistrationDepositPlusAdditionalPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["MyAccountAddSessionFullPayment"] = 37003] = "MyAccountAddSessionFullPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["MyAccountAddSessionDepositPayment"] = 37004] = "MyAccountAddSessionDepositPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["MyAccountAddSessionDepositPlusAdditionalPayment"] = 37005] = "MyAccountAddSessionDepositPlusAdditionalPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["CSRegistrationFullPayment"] = 37006] = "CSRegistrationFullPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["CSRegistrationDepositPayment"] = 37007] = "CSRegistrationDepositPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["CSRegistrationDepositPlusAdditionalPayment"] = 37008] = "CSRegistrationDepositPlusAdditionalPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["CSAddSessionFullPayment"] = 37009] = "CSAddSessionFullPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["CSAddSessionDepositPayment"] = 37010] = "CSAddSessionDepositPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["CSAddSessionDepositPlusAdditionalPayment"] = 37011] = "CSAddSessionDepositPlusAdditionalPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["CSChangeSessionFullPayment"] = 37012] = "CSChangeSessionFullPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["CSChangeSessionDepositPlusAdditionalPayment"] = 37013] = "CSChangeSessionDepositPlusAdditionalPayment";
                TermThresholdPaymentOptionType[TermThresholdPaymentOptionType["CSChangeSessionDepositPayment"] = 37014] = "CSChangeSessionDepositPayment";
            })(TermThresholdPaymentOptionType = Enums.TermThresholdPaymentOptionType || (Enums.TermThresholdPaymentOptionType = {}));
            var ThresholdType;
            (function (ThresholdType) {
                ThresholdType[ThresholdType["Term"] = 255000] = "Term";
                ThresholdType[ThresholdType["TermGroup"] = 255001] = "TermGroup";
            })(ThresholdType = Enums.ThresholdType || (Enums.ThresholdType = {}));
            var TimeZoneType;
            (function (TimeZoneType) {
                TimeZoneType[TimeZoneType["Pacific"] = 32000] = "Pacific";
                TimeZoneType[TimeZoneType["Mountain"] = 32001] = "Mountain";
                TimeZoneType[TimeZoneType["Central"] = 32002] = "Central";
                TimeZoneType[TimeZoneType["Eastern"] = 32003] = "Eastern";
            })(TimeZoneType = Enums.TimeZoneType || (Enums.TimeZoneType = {}));
            var TokenUsageType;
            (function (TokenUsageType) {
                TokenUsageType[TokenUsageType["StaffCorner"] = 313000] = "StaffCorner";
                TokenUsageType[TokenUsageType["GamePlan"] = 313001] = "GamePlan";
                TokenUsageType[TokenUsageType["iDTech365"] = 313002] = "iDTech365";
                TokenUsageType[TokenUsageType["PulseSPA"] = 313003] = "PulseSPA";
            })(TokenUsageType = Enums.TokenUsageType || (Enums.TokenUsageType = {}));
            var TuitionAssistanceLetterType;
            (function (TuitionAssistanceLetterType) {
                TuitionAssistanceLetterType[TuitionAssistanceLetterType["Email_SubmissionConfirmationWithFile"] = 302000] = "Email_SubmissionConfirmationWithFile";
                TuitionAssistanceLetterType[TuitionAssistanceLetterType["Email_SubmissionConfirmationWithoutFile"] = 302001] = "Email_SubmissionConfirmationWithoutFile";
                TuitionAssistanceLetterType[TuitionAssistanceLetterType["Email_FinancialsMissing"] = 302002] = "Email_FinancialsMissing";
                TuitionAssistanceLetterType[TuitionAssistanceLetterType["Email_FinancialsInvalid"] = 302003] = "Email_FinancialsInvalid";
                TuitionAssistanceLetterType[TuitionAssistanceLetterType["Email_ApplicationComplete"] = 302004] = "Email_ApplicationComplete";
                TuitionAssistanceLetterType[TuitionAssistanceLetterType["Email_Declined"] = 302005] = "Email_Declined";
                TuitionAssistanceLetterType[TuitionAssistanceLetterType["Email_AppPreOpen"] = 302006] = "Email_AppPreOpen";
                TuitionAssistanceLetterType[TuitionAssistanceLetterType["Email_AppClosed"] = 302007] = "Email_AppClosed";
            })(TuitionAssistanceLetterType = Enums.TuitionAssistanceLetterType || (Enums.TuitionAssistanceLetterType = {}));
            var TuitionAssistanceStatusType;
            (function (TuitionAssistanceStatusType) {
                TuitionAssistanceStatusType[TuitionAssistanceStatusType["InReview"] = 300000] = "InReview";
                TuitionAssistanceStatusType[TuitionAssistanceStatusType["FinancialMissing"] = 300001] = "FinancialMissing";
                TuitionAssistanceStatusType[TuitionAssistanceStatusType["FinancialsInvalid"] = 300002] = "FinancialsInvalid";
                TuitionAssistanceStatusType[TuitionAssistanceStatusType["Complete"] = 300003] = "Complete";
                TuitionAssistanceStatusType[TuitionAssistanceStatusType["Approved"] = 300004] = "Approved";
                TuitionAssistanceStatusType[TuitionAssistanceStatusType["Declined"] = 300005] = "Declined";
                TuitionAssistanceStatusType[TuitionAssistanceStatusType["Invalid"] = 300006] = "Invalid";
            })(TuitionAssistanceStatusType = Enums.TuitionAssistanceStatusType || (Enums.TuitionAssistanceStatusType = {}));
            var TuitionAssistanceSubStatusType;
            (function (TuitionAssistanceSubStatusType) {
                TuitionAssistanceSubStatusType[TuitionAssistanceSubStatusType["FullTuitionMinusDeposit"] = 301000] = "FullTuitionMinusDeposit";
                TuitionAssistanceSubStatusType[TuitionAssistanceSubStatusType["Discounted50Percent"] = 301001] = "Discounted50Percent";
                TuitionAssistanceSubStatusType[TuitionAssistanceSubStatusType["Discounted50Dollars"] = 301002] = "Discounted50Dollars";
                TuitionAssistanceSubStatusType[TuitionAssistanceSubStatusType["AlreadyRegisteredForCurrentSession"] = 301003] = "AlreadyRegisteredForCurrentSession";
                TuitionAssistanceSubStatusType[TuitionAssistanceSubStatusType["LackOfFinancialNeed"] = 301004] = "LackOfFinancialNeed";
                TuitionAssistanceSubStatusType[TuitionAssistanceSubStatusType["LackOfInformationToConsider"] = 301005] = "LackOfInformationToConsider";
                TuitionAssistanceSubStatusType[TuitionAssistanceSubStatusType["ApplicationIncomplete"] = 301006] = "ApplicationIncomplete";
                TuitionAssistanceSubStatusType[TuitionAssistanceSubStatusType["MultipleStudentsToConsider"] = 301007] = "MultipleStudentsToConsider";
                TuitionAssistanceSubStatusType[TuitionAssistanceSubStatusType["LateApplication"] = 301008] = "LateApplication";
            })(TuitionAssistanceSubStatusType = Enums.TuitionAssistanceSubStatusType || (Enums.TuitionAssistanceSubStatusType = {}));
            var UploadedFormTypeFilter;
            (function (UploadedFormTypeFilter) {
                UploadedFormTypeFilter[UploadedFormTypeFilter["StudentARFs"] = 10] = "StudentARFs";
                UploadedFormTypeFilter[UploadedFormTypeFilter["StaffLSRP"] = 20] = "StaffLSRP";
            })(UploadedFormTypeFilter = Enums.UploadedFormTypeFilter || (Enums.UploadedFormTypeFilter = {}));
            var UserAccessRestrictionType;
            (function (UserAccessRestrictionType) {
                UserAccessRestrictionType[UserAccessRestrictionType["None"] = 141000] = "None";
                UserAccessRestrictionType[UserAccessRestrictionType["CodeRed"] = 141001] = "CodeRed";
                UserAccessRestrictionType[UserAccessRestrictionType["Dissatisfied"] = 141002] = "Dissatisfied";
            })(UserAccessRestrictionType = Enums.UserAccessRestrictionType || (Enums.UserAccessRestrictionType = {}));
            var UserAccountActivityType;
            (function (UserAccountActivityType) {
                UserAccountActivityType[UserAccountActivityType["ChangePasswordEnterUserName"] = 48000] = "ChangePasswordEnterUserName";
                UserAccountActivityType[UserAccountActivityType["ChangePasswordAnswerSecurityQuestion"] = 48001] = "ChangePasswordAnswerSecurityQuestion";
                UserAccountActivityType[UserAccountActivityType["UnlockAccount"] = 48002] = "UnlockAccount";
                UserAccountActivityType[UserAccountActivityType["ChangePassword"] = 48003] = "ChangePassword";
                UserAccountActivityType[UserAccountActivityType["LockAccount"] = 48004] = "LockAccount";
                UserAccountActivityType[UserAccountActivityType["RequiredFormsReminderEmail"] = 48005] = "RequiredFormsReminderEmail";
                UserAccountActivityType[UserAccountActivityType["WeekOutEmail"] = 48006] = "WeekOutEmail";
                UserAccountActivityType[UserAccountActivityType["Login"] = 48007] = "Login";
                UserAccountActivityType[UserAccountActivityType["Logout"] = 48008] = "Logout";
                UserAccountActivityType[UserAccountActivityType["ChangeUserName"] = 48009] = "ChangeUserName";
                UserAccountActivityType[UserAccountActivityType["ChangeDisplayName"] = 48010] = "ChangeDisplayName";
                UserAccountActivityType[UserAccountActivityType["REPAvailableEmail"] = 48011] = "REPAvailableEmail";
                UserAccountActivityType[UserAccountActivityType["REPReminderEmail"] = 48012] = "REPReminderEmail";
            })(UserAccountActivityType = Enums.UserAccountActivityType || (Enums.UserAccountActivityType = {}));
            var UserActivityStatusCode;
            (function (UserActivityStatusCode) {
                UserActivityStatusCode[UserActivityStatusCode["Success"] = 145000] = "Success";
                UserActivityStatusCode[UserActivityStatusCode["Failure"] = 145001] = "Failure";
            })(UserActivityStatusCode = Enums.UserActivityStatusCode || (Enums.UserActivityStatusCode = {}));
            var UserConfirmationType;
            (function (UserConfirmationType) {
                UserConfirmationType[UserConfirmationType["OrderConfirmationCode"] = 137000] = "OrderConfirmationCode";
                UserConfirmationType[UserConfirmationType["ParticipantAccessCode"] = 137001] = "ParticipantAccessCode";
            })(UserConfirmationType = Enums.UserConfirmationType || (Enums.UserConfirmationType = {}));
            var UserRelationshipType;
            (function (UserRelationshipType) {
                UserRelationshipType[UserRelationshipType["ResidesWith"] = 97000] = "ResidesWith";
                UserRelationshipType[UserRelationshipType["ParentGuardian"] = 97002] = "ParentGuardian";
                UserRelationshipType[UserRelationshipType["Parent"] = 97005] = "Parent";
                UserRelationshipType[UserRelationshipType["Guardian"] = 97006] = "Guardian";
                UserRelationshipType[UserRelationshipType["Other"] = 97007] = "Other";
                UserRelationshipType[UserRelationshipType["GroupManager"] = 97008] = "GroupManager";
            })(UserRelationshipType = Enums.UserRelationshipType || (Enums.UserRelationshipType = {}));
            var UserRoleType;
            (function (UserRoleType) {
                UserRoleType[UserRoleType["Administrator"] = 2033] = "Administrator";
                UserRoleType[UserRoleType["ClientServices"] = 2034] = "ClientServices";
                UserRoleType[UserRoleType["Public"] = 2035] = "Public";
                UserRoleType[UserRoleType["Corporate"] = 2036] = "Corporate";
                UserRoleType[UserRoleType["Compliance"] = 2037] = "Compliance";
                UserRoleType[UserRoleType["AdministrativeServices"] = 2038] = "AdministrativeServices";
                UserRoleType[UserRoleType["Accounting"] = 2039] = "Accounting";
                UserRoleType[UserRoleType["SalesAndMarketing"] = 2040] = "SalesAndMarketing";
                UserRoleType[UserRoleType["Region"] = 2041] = "Region";
                UserRoleType[UserRoleType["TermStaff"] = 2042] = "TermStaff";
                UserRoleType[UserRoleType["Logistics"] = 2043] = "Logistics";
                UserRoleType[UserRoleType["HR"] = 2044] = "HR";
                UserRoleType[UserRoleType["Payroll"] = 2045] = "Payroll";
                UserRoleType[UserRoleType["IT"] = 2046] = "IT";
                UserRoleType[UserRoleType["CDev"] = 2047] = "CDev";
                UserRoleType[UserRoleType["TechRocket"] = 2048] = "TechRocket";
                UserRoleType[UserRoleType["OPLStaff"] = 2049] = "OPLStaff";
                UserRoleType[UserRoleType["OnlineInstructor"] = 2050] = "OnlineInstructor";
                UserRoleType[UserRoleType["Unknown"] = 2099] = "Unknown";
            })(UserRoleType = Enums.UserRoleType || (Enums.UserRoleType = {}));
            var UserRoleLevelType;
            (function (UserRoleLevelType) {
                UserRoleLevelType[UserRoleLevelType["Default"] = 147000] = "Default";
                UserRoleLevelType[UserRoleLevelType["AdministratorLevel1"] = 147001] = "AdministratorLevel1";
                UserRoleLevelType[UserRoleLevelType["AdministratorLevel2"] = 147002] = "AdministratorLevel2";
                UserRoleLevelType[UserRoleLevelType["AdministratorLevel3"] = 147003] = "AdministratorLevel3";
                UserRoleLevelType[UserRoleLevelType["ClientServicesLevel1"] = 147004] = "ClientServicesLevel1";
                UserRoleLevelType[UserRoleLevelType["ClientServicesLevel2"] = 147005] = "ClientServicesLevel2";
                UserRoleLevelType[UserRoleLevelType["ClientServicesLevel3"] = 147006] = "ClientServicesLevel3";
                UserRoleLevelType[UserRoleLevelType["PublicClientUsersLevel1"] = 147007] = "PublicClientUsersLevel1";
                UserRoleLevelType[UserRoleLevelType["CorporateLevel1"] = 147008] = "CorporateLevel1";
                UserRoleLevelType[UserRoleLevelType["CorporateLevel2"] = 147009] = "CorporateLevel2";
                UserRoleLevelType[UserRoleLevelType["ComplianceLevel1"] = 147010] = "ComplianceLevel1";
                UserRoleLevelType[UserRoleLevelType["AdministrativeServicesLevel1"] = 147011] = "AdministrativeServicesLevel1";
                UserRoleLevelType[UserRoleLevelType["AdministrativeServicesLevel2"] = 147012] = "AdministrativeServicesLevel2";
                UserRoleLevelType[UserRoleLevelType["AccountingLevel1"] = 147013] = "AccountingLevel1";
                UserRoleLevelType[UserRoleLevelType["AccountingLevel2"] = 147014] = "AccountingLevel2";
                UserRoleLevelType[UserRoleLevelType["AccountingLevel3"] = 147015] = "AccountingLevel3";
                UserRoleLevelType[UserRoleLevelType["AccountingLevel4"] = 147016] = "AccountingLevel4";
                UserRoleLevelType[UserRoleLevelType["SalesandMarketingLevel1"] = 147017] = "SalesandMarketingLevel1";
                UserRoleLevelType[UserRoleLevelType["RegionLevel1"] = 147018] = "RegionLevel1";
                UserRoleLevelType[UserRoleLevelType["RegionLevel2"] = 147019] = "RegionLevel2";
                UserRoleLevelType[UserRoleLevelType["TermStaffLevel1"] = 147020] = "TermStaffLevel1";
                UserRoleLevelType[UserRoleLevelType["TermStaffLevel2"] = 147021] = "TermStaffLevel2";
                UserRoleLevelType[UserRoleLevelType["TermStaffLevel3"] = 147022] = "TermStaffLevel3";
                UserRoleLevelType[UserRoleLevelType["TermStaffLevel4"] = 147023] = "TermStaffLevel4";
                UserRoleLevelType[UserRoleLevelType["TermStaffLevel5"] = 147024] = "TermStaffLevel5";
                UserRoleLevelType[UserRoleLevelType["LogisticsLevel1"] = 147025] = "LogisticsLevel1";
                UserRoleLevelType[UserRoleLevelType["LogisticsLevel2"] = 147026] = "LogisticsLevel2";
                UserRoleLevelType[UserRoleLevelType["LogisticsLevel3"] = 147027] = "LogisticsLevel3";
                UserRoleLevelType[UserRoleLevelType["HRLevel1"] = 147028] = "HRLevel1";
                UserRoleLevelType[UserRoleLevelType["HRLevel2"] = 147029] = "HRLevel2";
                UserRoleLevelType[UserRoleLevelType["PayrollLevel1"] = 147030] = "PayrollLevel1";
                UserRoleLevelType[UserRoleLevelType["ITLevel1"] = 147031] = "ITLevel1";
                UserRoleLevelType[UserRoleLevelType["ITLevel2"] = 147032] = "ITLevel2";
                UserRoleLevelType[UserRoleLevelType["CDevLevel1"] = 147040] = "CDevLevel1";
                UserRoleLevelType[UserRoleLevelType["CDevLevel2"] = 147041] = "CDevLevel2";
                UserRoleLevelType[UserRoleLevelType["CDevLevel3"] = 147042] = "CDevLevel3";
                UserRoleLevelType[UserRoleLevelType["OPLStaffLevel1"] = 147043] = "OPLStaffLevel1";
                UserRoleLevelType[UserRoleLevelType["OPLStaffLevel2"] = 147044] = "OPLStaffLevel2";
                UserRoleLevelType[UserRoleLevelType["OPLStaffLevel3"] = 147045] = "OPLStaffLevel3";
                UserRoleLevelType[UserRoleLevelType["OnlineInstructorLevel1"] = 147050] = "OnlineInstructorLevel1";
                UserRoleLevelType[UserRoleLevelType["OnlineInstructorLevel2"] = 147047] = "OnlineInstructorLevel2";
                UserRoleLevelType[UserRoleLevelType["OnlineInstructorLevel3"] = 147048] = "OnlineInstructorLevel3";
            })(UserRoleLevelType = Enums.UserRoleLevelType || (Enums.UserRoleLevelType = {}));
            var UserRoleRequired;
            (function (UserRoleRequired) {
                UserRoleRequired[UserRoleRequired["AlwaysRequired"] = 271000] = "AlwaysRequired";
                UserRoleRequired[UserRoleRequired["RequiredIfNoJobAssignment"] = 271001] = "RequiredIfNoJobAssignment";
                UserRoleRequired[UserRoleRequired["NeverRequired"] = 271002] = "NeverRequired";
            })(UserRoleRequired = Enums.UserRoleRequired || (Enums.UserRoleRequired = {}));
            var UserAccountTypeMask;
            (function (UserAccountTypeMask) {
                UserAccountTypeMask[UserAccountTypeMask["None"] = 0] = "None";
                UserAccountTypeMask[UserAccountTypeMask["CorporateEmployee"] = 1] = "CorporateEmployee";
                UserAccountTypeMask[UserAccountTypeMask["ExternalCorporate"] = 2] = "ExternalCorporate";
                UserAccountTypeMask[UserAccountTypeMask["TermStaff_JobApplicant"] = 4] = "TermStaff_JobApplicant";
                UserAccountTypeMask[UserAccountTypeMask["TermStaff_Employee"] = 8] = "TermStaff_Employee";
                UserAccountTypeMask[UserAccountTypeMask["Public_HasPurchased"] = 16] = "Public_HasPurchased";
                UserAccountTypeMask[UserAccountTypeMask["Public_Participant"] = 32] = "Public_Participant";
                UserAccountTypeMask[UserAccountTypeMask["AlwaysRedirectToJobAccount"] = 64] = "AlwaysRedirectToJobAccount";
                UserAccountTypeMask[UserAccountTypeMask["ParticipantCanManageAccount"] = 128] = "ParticipantCanManageAccount";
                UserAccountTypeMask[UserAccountTypeMask["AccountCreatedByTechRocket"] = 256] = "AccountCreatedByTechRocket";
                UserAccountTypeMask[UserAccountTypeMask["All"] = 65535] = "All";
            })(UserAccountTypeMask = Enums.UserAccountTypeMask || (Enums.UserAccountTypeMask = {}));
            var UserAvailabilityStatus;
            (function (UserAvailabilityStatus) {
                UserAvailabilityStatus[UserAvailabilityStatus["Available"] = 385000] = "Available";
                UserAvailabilityStatus[UserAvailabilityStatus["Scheduled"] = 385001] = "Scheduled";
                UserAvailabilityStatus[UserAvailabilityStatus["Scheduled_NotVisible"] = 385002] = "Scheduled_NotVisible";
            })(UserAvailabilityStatus = Enums.UserAvailabilityStatus || (Enums.UserAvailabilityStatus = {}));
            var USStateType;
            (function (USStateType) {
                USStateType[USStateType["Hawaii"] = 15012] = "Hawaii";
                USStateType[USStateType["Massachusetts"] = 15022] = "Massachusetts";
            })(USStateType = Enums.USStateType || (Enums.USStateType = {}));
            var UTMCreationTriggerType;
            (function (UTMCreationTriggerType) {
                UTMCreationTriggerType[UTMCreationTriggerType["LeadGeneration"] = 358000] = "LeadGeneration";
                UTMCreationTriggerType[UTMCreationTriggerType["CreateAccount"] = 358001] = "CreateAccount";
                UTMCreationTriggerType[UTMCreationTriggerType["Login"] = 358002] = "Login";
                UTMCreationTriggerType[UTMCreationTriggerType["CatalogRequest"] = 358003] = "CatalogRequest";
                UTMCreationTriggerType[UTMCreationTriggerType["AddToCart"] = 358004] = "AddToCart";
                UTMCreationTriggerType[UTMCreationTriggerType["Purchase"] = 358005] = "Purchase";
            })(UTMCreationTriggerType = Enums.UTMCreationTriggerType || (Enums.UTMCreationTriggerType = {}));
            var VIPType;
            (function (VIPType) {
                VIPType[VIPType["CorporatePartnerRelation"] = 138000] = "CorporatePartnerRelation";
                VIPType[VIPType["CelebrityClient"] = 138001] = "CelebrityClient";
                VIPType[VIPType["CelebrityParticipant"] = 138002] = "CelebrityParticipant";
                VIPType[VIPType["PressRelation"] = 138003] = "PressRelation";
                VIPType[VIPType["Other"] = 138004] = "Other";
            })(VIPType = Enums.VIPType || (Enums.VIPType = {}));
            var Visa;
            (function (Visa) {
                Visa[Visa["F1"] = 259000] = "F1";
                Visa[Visa["H1B"] = 259001] = "H1B";
                Visa[Visa["J1"] = 259002] = "J1";
                Visa[Visa["M1"] = 259003] = "M1";
            })(Visa = Enums.Visa || (Enums.Visa = {}));
            var VisaStatus;
            (function (VisaStatus) {
                VisaStatus[VisaStatus["Complete"] = 261000] = "Complete";
                VisaStatus[VisaStatus["Processing"] = 261001] = "Processing";
            })(VisaStatus = Enums.VisaStatus || (Enums.VisaStatus = {}));
            var VisibilityType;
            (function (VisibilityType) {
                VisibilityType[VisibilityType["Public"] = 5000] = "Public";
                VisibilityType[VisibilityType["Internal"] = 5001] = "Internal";
            })(VisibilityType = Enums.VisibilityType || (Enums.VisibilityType = {}));
            var WaitListStatus;
            (function (WaitListStatus) {
                WaitListStatus[WaitListStatus["Waiting"] = 318000] = "Waiting";
                WaitListStatus[WaitListStatus["Disposed"] = 318001] = "Disposed";
            })(WaitListStatus = Enums.WaitListStatus || (Enums.WaitListStatus = {}));
            var WorkFlowStatus;
            (function (WorkFlowStatus) {
                WorkFlowStatus[WorkFlowStatus["Unprocessed"] = 272000] = "Unprocessed";
                WorkFlowStatus[WorkFlowStatus["PayrollTransmitted"] = 272001] = "PayrollTransmitted";
                WorkFlowStatus[WorkFlowStatus["AlteredAfterTransmission"] = 272002] = "AlteredAfterTransmission";
            })(WorkFlowStatus = Enums.WorkFlowStatus || (Enums.WorkFlowStatus = {}));
            var SkillLevels;
            (function (SkillLevels) {
                SkillLevels[SkillLevels["Beginner"] = 51] = "Beginner";
                SkillLevels[SkillLevels["Intermediate"] = 52] = "Intermediate";
                SkillLevels[SkillLevels["Advanced"] = 53] = "Advanced";
            })(SkillLevels = Enums.SkillLevels || (Enums.SkillLevels = {}));
            var OPLStatus;
            (function (OPLStatus) {
                OPLStatus[OPLStatus["Unscheduled"] = 373000] = "Unscheduled";
                OPLStatus[OPLStatus["Scheduled"] = 373001] = "Scheduled";
                OPLStatus[OPLStatus["CompleteDelivered"] = 373002] = "CompleteDelivered";
                OPLStatus[OPLStatus["CompleteEmailSent"] = 373003] = "CompleteEmailSent";
                OPLStatus[OPLStatus["UsedNoShow"] = 373004] = "UsedNoShow";
                OPLStatus[OPLStatus["UsedLateCancellation"] = 373005] = "UsedLateCancellation";
                OPLStatus[OPLStatus["Invalid"] = 373006] = "Invalid";
                OPLStatus[OPLStatus["CompletePresumed"] = 373007] = "CompletePresumed";
                OPLStatus[OPLStatus["AutoExpired"] = 373008] = "AutoExpired";
            })(OPLStatus = Enums.OPLStatus || (Enums.OPLStatus = {}));
            var LineOfBusiness;
            (function (LineOfBusiness) {
                LineOfBusiness[LineOfBusiness["IPC"] = 400000] = "IPC";
                LineOfBusiness[LineOfBusiness["VTC"] = 400001] = "VTC";
                LineOfBusiness[LineOfBusiness["OPL"] = 400002] = "OPL";
                LineOfBusiness[LineOfBusiness["SEM"] = 400003] = "SEM";
                LineOfBusiness[LineOfBusiness["OTA"] = 400004] = "OTA";
                LineOfBusiness[LineOfBusiness["MERCH"] = 400005] = "MERCH";
            })(LineOfBusiness = Enums.LineOfBusiness || (Enums.LineOfBusiness = {}));
            Pulse.app.run([
                '$rootScope',
                function ($rootScope) {
                    $rootScope.Enums = Pulse.Common.Enums;
                },
            ]);
        })(Enums = Common.Enums || (Common.Enums = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));
var Enums = Pulse.Common.Enums;

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Enums;
        (function (Enums) {
            var UI;
            (function (UI) {
                var ProgramStatusLabels;
                (function (ProgramStatusLabels) {
                    ProgramStatusLabels["Green"] = "primary";
                    ProgramStatusLabels["Orange"] = "warning";
                    ProgramStatusLabels["Red"] = "danger";
                    ProgramStatusLabels["Grey"] = "neutral";
                    ProgramStatusLabels["Blue"] = "callus";
                    ProgramStatusLabels["None"] = "";
                })(ProgramStatusLabels = UI.ProgramStatusLabels || (UI.ProgramStatusLabels = {}));
                var LicenseManagementSearchFilterStatusType;
                (function (LicenseManagementSearchFilterStatusType) {
                    LicenseManagementSearchFilterStatusType[LicenseManagementSearchFilterStatusType["AssignAsOfDate"] = 1] = "AssignAsOfDate";
                    LicenseManagementSearchFilterStatusType[LicenseManagementSearchFilterStatusType["NoAssignBetweenDates"] = 2] = "NoAssignBetweenDates";
                    LicenseManagementSearchFilterStatusType[LicenseManagementSearchFilterStatusType["AssignOnDate"] = 3] = "AssignOnDate";
                })(LicenseManagementSearchFilterStatusType = UI.LicenseManagementSearchFilterStatusType || (UI.LicenseManagementSearchFilterStatusType = {}));
                var LicenseManagementMassUpdateAction;
                (function (LicenseManagementMassUpdateAction) {
                    LicenseManagementMassUpdateAction[LicenseManagementMassUpdateAction["Password"] = 1] = "Password";
                    LicenseManagementMassUpdateAction[LicenseManagementMassUpdateAction["Expiration"] = 2] = "Expiration";
                    LicenseManagementMassUpdateAction[LicenseManagementMassUpdateAction["AssignmentStartDate"] = 3] = "AssignmentStartDate";
                    LicenseManagementMassUpdateAction[LicenseManagementMassUpdateAction["AssignmentEndDate"] = 4] = "AssignmentEndDate";
                    LicenseManagementMassUpdateAction[LicenseManagementMassUpdateAction["RecordState"] = 5] = "RecordState";
                })(LicenseManagementMassUpdateAction = UI.LicenseManagementMassUpdateAction || (UI.LicenseManagementMassUpdateAction = {}));
                var LicenseManagementAssignmentStartDate;
                (function (LicenseManagementAssignmentStartDate) {
                    LicenseManagementAssignmentStartDate[LicenseManagementAssignmentStartDate["LocationStartDate"] = 1] = "LocationStartDate";
                    LicenseManagementAssignmentStartDate[LicenseManagementAssignmentStartDate["Custom"] = 2] = "Custom";
                })(LicenseManagementAssignmentStartDate = UI.LicenseManagementAssignmentStartDate || (UI.LicenseManagementAssignmentStartDate = {}));
                var LicenseManagementAssignmentEndDate;
                (function (LicenseManagementAssignmentEndDate) {
                    LicenseManagementAssignmentEndDate[LicenseManagementAssignmentEndDate["LocationEndDate"] = 1] = "LocationEndDate";
                    LicenseManagementAssignmentEndDate[LicenseManagementAssignmentEndDate["Custom"] = 2] = "Custom";
                    LicenseManagementAssignmentEndDate[LicenseManagementAssignmentEndDate["None"] = 3] = "None";
                })(LicenseManagementAssignmentEndDate = UI.LicenseManagementAssignmentEndDate || (UI.LicenseManagementAssignmentEndDate = {}));
                var OPLScheduleRecurringFrequency;
                (function (OPLScheduleRecurringFrequency) {
                    OPLScheduleRecurringFrequency[OPLScheduleRecurringFrequency["NoRepeat"] = 0] = "NoRepeat";
                    OPLScheduleRecurringFrequency[OPLScheduleRecurringFrequency["Weekly"] = 1] = "Weekly";
                    OPLScheduleRecurringFrequency[OPLScheduleRecurringFrequency["Every2Weeks"] = 2] = "Every2Weeks";
                })(OPLScheduleRecurringFrequency = UI.OPLScheduleRecurringFrequency || (UI.OPLScheduleRecurringFrequency = {}));
            })(UI = Enums.UI || (Enums.UI = {}));
        })(Enums = Common.Enums || (Common.Enums = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var Enums;
        (function (Enums) {
            var Keyboard;
            (function (Keyboard) {
                var UI_Keys_Strings;
                (function (UI_Keys_Strings) {
                    UI_Keys_Strings["ESCAPE"] = "Esc";
                    UI_Keys_Strings["ENTER"] = "Enter";
                    UI_Keys_Strings["TAB"] = "Tab";
                    UI_Keys_Strings["ARROW_DOWN"] = "ArrowDown";
                    UI_Keys_Strings["ARROW_UP"] = "ArrowUp";
                    UI_Keys_Strings["ARROW_LEFT"] = "ArrowLeft";
                    UI_Keys_Strings["ARROW_RIGHT"] = "ArrowRight";
                })(UI_Keys_Strings = Keyboard.UI_Keys_Strings || (Keyboard.UI_Keys_Strings = {}));
            })(Keyboard = Enums.Keyboard || (Enums.Keyboard = {}));
        })(Enums = Common.Enums || (Common.Enums = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BaseCommon = (function () {
            function BaseCommon(common, breezeService, pulseContext, loggingId) {
                this.activationPromises = new Array();
                this.common = common;
                this.pulseContext = pulseContext;
                this.breezeService = breezeService;
                this.loggingId = loggingId;
            }
            BaseCommon.prototype.log = function (message, data, showToast) {
                if (showToast === void 0) { showToast = false; }
                this.common.logger.log(message, data, this.loggingId, showToast);
            };
            BaseCommon.prototype.logDebug = function (message, data, showToast) {
                if (showToast === void 0) { showToast = false; }
                if (!this.common.config.isDebugMode)
                    return;
                this.common.logger.logDebug(message, data, this.loggingId, showToast);
            };
            BaseCommon.prototype.logInfo = function (message, data, showToast) {
                if (showToast === void 0) { showToast = false; }
                this.common.logger.logInfo(message, data, this.loggingId, showToast);
            };
            BaseCommon.prototype.logError = function (err, typesOfErrsToShowToUser, options) {
                this.common.logAllErrorTypes(err, this.loggingId, options, typesOfErrsToShowToUser);
            };
            BaseCommon.prototype.logSuccess = function (message, data, showToast) {
                if (showToast === void 0) { showToast = false; }
                this.common.logger.logSuccess(message, data, this.loggingId, showToast);
            };
            BaseCommon.prototype.logWarning = function (message, data, showToast) {
                if (showToast === void 0) { showToast = false; }
                this.common.logger.logWarning(message, data, this.loggingId, showToast);
            };
            return BaseCommon;
        }());
        Common.BaseCommon = BaseCommon;
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BaseCtrl = (function (_super) {
            __extends(BaseCtrl, _super);
            function BaseCtrl($scope, $location, common, breezeService, pulseContext, loggingId) {
                var _this = _super.call(this, common, breezeService, pulseContext, loggingId) || this;
                _this.canSee = true;
                _this.canUpdate = true;
                _this.canCreate = true;
                _this.submitted = false;
                _this.isViewLoaded = false;
                _this.isActivated = false;
                _this._checkUnsavedDataBeforeNav = true;
                _this.checkUnsavedDataBeforeNavOverrideParent = false;
                _this.$scope = $scope;
                _this.$location = $location;
                _this._onViewContentLoadedOff = _this.$scope.$on('$viewContentLoaded', function () {
                    _this.isViewLoaded = true;
                    _this.onViewLoaded();
                });
                _this._onDestroy = _this.$scope.$on('$destroy', function () {
                    _this.onDestroy();
                });
                _this._onUrlChangeStartOff = _this.$scope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
                    _this.onUrlChangeStart(event, newUrl, oldUrl);
                });
                _this.activationPromises.push(_this.setLocalizedTexts());
                _this.securityCheck();
                return _this;
            }
            BaseCtrl.prototype.activateController = function () {
                var _this = this;
                if (this.isActivated)
                    return;
                this.common.toggleSpinner(true);
                return this.common.activateController(this.activationPromises, this.loggingId)
                    .then(function (results) {
                    _this.isActivated = true;
                    _this.onActivated(results);
                    return results;
                })
                    .catch(function (e) {
                    _this.logError(e);
                    return null;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            BaseCtrl.prototype.setLocalizedTexts = function () {
                var deferred = this.common.$q.defer();
                deferred.resolve(null);
                return deferred.promise;
            };
            BaseCtrl.prototype.securityCheck = function () {
            };
            BaseCtrl.prototype.secureAllFeatures = function () { };
            BaseCtrl.prototype.onActivated = function (activationResults) {
            };
            BaseCtrl.prototype.onViewLoaded = function () {
            };
            BaseCtrl.prototype._checkUnsavedDataBeforeNavInParent = function (scope) {
                if (scope && scope.vm && scope.vm.checkUnsavedDataBeforeNav === false) {
                    return false;
                }
                else if (scope && scope.vm) {
                    return this._checkUnsavedDataBeforeNavInParent(scope.$parent);
                }
                return true;
            };
            Object.defineProperty(BaseCtrl.prototype, "checkUnsavedDataBeforeNav", {
                get: function () {
                    return this._checkUnsavedDataBeforeNav && (this.checkUnsavedDataBeforeNavOverrideParent || this._checkUnsavedDataBeforeNavInParent(this.$scope.$parent));
                },
                set: function (value) {
                    this._checkUnsavedDataBeforeNav = value;
                },
                enumerable: false,
                configurable: true
            });
            BaseCtrl.prototype.doFormDirtyCheck = function (event, newUrl, oldUrl, closingResults) {
                var _this = this;
                if (!this.myForm || !this.myForm.$dirty || (this.myForm.$submitted && this.myForm.$valid)
                    || BaseCtrl.checkUnsavedDataCounter > 0) {
                    return;
                }
                if (this.checkUnsavedDataBeforeNav) {
                    if (BaseCtrl.checkUnsavedDataCounter === 0) {
                        BaseCtrl.checkUnsavedDataCounter++;
                        var dlgID = "UnsavedChangesDlg";
                        BaseCtrl.unSavedChangeText = BaseCtrl.unSavedChangeText ? BaseCtrl.unSavedChangeText : StringConst.Warn_UnsavedChanges;
                        this.common.$rootScope.$broadcast(Events.ShowBasicPopup, {
                            size: 'sm',
                            initDataObj: {
                                popupId: dlgID,
                                title: StringConst.Title_Confirmation,
                                html: BaseCtrl.unSavedChangeText,
                                isIncludeHeaderCloseButton: false,
                                button1: {
                                    label: "Yes",
                                    cbFn: function () {
                                        _this.cleanupAndClose(closingResults);
                                        _this._onUrlChangeStartOff();
                                        _this.common.$location.url(_this.common.$location.url(newUrl).hash());
                                        _this.common.$timeout(function () {
                                            BaseCtrl.checkUnsavedDataCounter--;
                                        }, 100);
                                    }
                                },
                                button2: {
                                    label: "No",
                                    cbFn: function () {
                                        BaseCtrl.checkUnsavedDataCounter--;
                                    }
                                },
                                rendered: function () {
                                    if (_this.pulseContext.isImpersonating) {
                                        if (!Pulse.Utils.JS.isElementPartiallyVisibleInViewPort('#' + dlgID)) {
                                            _this.common.scrollToHash(dlgID);
                                        }
                                    }
                                },
                            }
                        });
                    }
                    event.preventDefault();
                }
            };
            BaseCtrl.prototype.onUrlChangeStart = function (event, newUrl, oldUrl) {
                this.doFormDirtyCheck(event, newUrl, oldUrl);
            };
            BaseCtrl.prototype.cleanupAndClose = function (results) {
            };
            BaseCtrl.prototype.onDestroy = function () {
                this._onViewContentLoadedOff();
                this._onUrlChangeStartOff();
                this._onDestroy();
            };
            BaseCtrl.unSavedChangeText = null;
            BaseCtrl.checkUnsavedDataCounter = 0;
            return BaseCtrl;
        }(Common.BaseCommon));
        Common.BaseCtrl = BaseCtrl;
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BaseDirective = (function () {
            function BaseDirective(common) {
                var _this = this;
                this.scope = {};
                this.controller = null;
                this.controllerAs = "vm";
                this.bindToController = true;
                this.compile = function (element, attrs) {
                    var compilationInfoObj = _this.myCompile(element, attrs);
                    return {
                        pre: function (scope, element, attrs, ctrlrs, transcludeFn) {
                            scope.vm.preLink(scope, element, attrs, ctrlrs, transcludeFn, compilationInfoObj);
                        },
                        post: function (scope, element, attrs, ctrlrs, transcludeFn) {
                            scope.vm.postLink(scope, element, attrs, ctrlrs, transcludeFn, compilationInfoObj);
                        }
                    };
                };
                this.scope = angular.extend(this.scope, BaseDirective.scopeDef);
                this.common = common;
            }
            BaseDirective.prototype.myCompile = function (element, attrs) {
                return null;
            };
            BaseDirective.scopeDef = {};
            return BaseDirective;
        }());
        Common.BaseDirective = BaseDirective;
        (function (BaseDirective) {
            var BaseDirectiveCtrl = (function (_super) {
                __extends(BaseDirectiveCtrl, _super);
                function BaseDirectiveCtrl($scope, $location, common, breezeService, pulseContext, loggingId) {
                    return _super.call(this, $scope, $location, common, breezeService, pulseContext, loggingId) || this;
                }
                BaseDirectiveCtrl.prototype.preLink = function (scope, element, attrs, ctrls, transclude, compilationInfoObj) {
                    this.myPreLink(scope, element, attrs, ctrls, transclude, compilationInfoObj);
                };
                BaseDirectiveCtrl.prototype.postLink = function (scope, element, attrs, ctrls, transclude, compilationInfoObj) {
                    Pulse.Utils.ClickTracking.hookupElementsInContainer(element);
                    if (this.canSee) {
                        this.myPostLink(scope, element, attrs, ctrls, transclude, compilationInfoObj);
                        this.secureAllFeatures();
                    }
                };
                BaseDirectiveCtrl.prototype.myPreLink = function (scope, element, attrs, ctrls, transclude, compilationInfoObj) {
                };
                BaseDirectiveCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude, compilationInfoObj) {
                    if (this.formName) {
                        this.myForm = scope[this.formName];
                    }
                };
                BaseDirectiveCtrl.prototype.extractErrorMessage = function (err) {
                    var errorMessage = null;
                    if (err.data && err.data.innerException) {
                        errorMessage = err.data.innerException.exceptionMessage;
                    }
                    else if (err.data && err.data.exceptionMessage) {
                        errorMessage = err.data.exceptionMessage;
                    }
                    else if (err.data && err.data.error && err.data.error.message) {
                        errorMessage = err.data.error.message;
                    }
                    else if (err.data && err.data.message) {
                        errorMessage = err.data.message;
                    }
                    return errorMessage;
                };
                return BaseDirectiveCtrl;
            }(Pulse.Common.BaseCtrl));
            BaseDirective.BaseDirectiveCtrl = BaseDirectiveCtrl;
        })(BaseDirective = Common.BaseDirective || (Common.BaseDirective = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BaseDirectiveWithGrid = (function (_super) {
            __extends(BaseDirectiveWithGrid, _super);
            function BaseDirectiveWithGrid(common) {
                return _super.call(this, common) || this;
            }
            return BaseDirectiveWithGrid;
        }(Common.BaseDirective));
        Common.BaseDirectiveWithGrid = BaseDirectiveWithGrid;
        (function (BaseDirectiveWithGrid) {
            var BaseDirectiveWithGridCtrl = (function (_super) {
                __extends(BaseDirectiveWithGridCtrl, _super);
                function BaseDirectiveWithGridCtrl($scope, $location, common, breezeService, pulseContext, loggingId) {
                    return _super.call(this, $scope, $location, common, breezeService, pulseContext, loggingId) || this;
                }
                BaseDirectiveWithGridCtrl.prototype.showGridHeadingWhenMobile = function (rowIndex) {
                    return this.common.isMobileView || rowIndex == 0;
                };
                return BaseDirectiveWithGridCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            BaseDirectiveWithGrid.BaseDirectiveWithGridCtrl = BaseDirectiveWithGridCtrl;
        })(BaseDirectiveWithGrid = Common.BaseDirectiveWithGrid || (Common.BaseDirectiveWithGrid = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BaseViewCtrl = (function (_super) {
            __extends(BaseViewCtrl, _super);
            function BaseViewCtrl($scope, $location, common, breezeService, pulseContext, loggingId) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, loggingId) || this;
                _this.sPageTitle = "iD Tech";
                _this.scrollToTopOnLoaded = true;
                return _this;
            }
            BaseViewCtrl.prototype.onActivated = function (activationResults) {
                this.secureAllFeatures();
            };
            BaseViewCtrl.prototype.onViewLoaded = function () {
                if (this.formName) {
                    this.myForm = this.$scope[this.formName];
                }
                if (this.scrollToTopOnLoaded) {
                    this.scrollToTop();
                }
            };
            BaseViewCtrl.prototype.scrollToTop = function (offset) {
                if (offset === void 0) { offset = 120; }
                this.common.scrollToHash(StringConst.CSS_ID_pulse_view_top, null, offset);
            };
            return BaseViewCtrl;
        }(Common.BaseCtrl));
        Common.BaseViewCtrl = BaseViewCtrl;
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BaseAdminViewCtrl = (function (_super) {
            __extends(BaseAdminViewCtrl, _super);
            function BaseAdminViewCtrl($scope, $location, common, breezeService, pulseContext, loggingId) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, loggingId) || this;
                angular.element(document).find('html').addClass('pulse-admin-app');
                return _this;
            }
            return BaseAdminViewCtrl;
        }(Common.BaseViewCtrl));
        Common.BaseAdminViewCtrl = BaseAdminViewCtrl;
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BaseCtrlWithiFrame = (function (_super) {
            __extends(BaseCtrlWithiFrame, _super);
            function BaseCtrlWithiFrame($scope, $location, common, breezeService, pulseContext, loggingId) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, loggingId) || this;
                _this.allowedPartialUrls = new Array();
                _this.setAllowedPartialUrls();
                return _this;
            }
            BaseCtrlWithiFrame.prototype.iFrameOnLoad = function (frameId, url) {
                if (this.currentFrameUrl !== url) {
                    this.currentFrameUrl = url;
                    this.actionBasedOnFrameUrl(frameId, url);
                }
                else {
                    this.common.$rootScope.$broadcast(Events.IFrameLoaded, frameId);
                }
            };
            BaseCtrlWithiFrame.prototype.stopAndCleariFrameSrc = function () {
                this.iFrameSrc = "about:blank";
            };
            BaseCtrlWithiFrame.prototype.setAllowedPartialUrls = function () { };
            BaseCtrlWithiFrame.prototype.actionBasedOnFrameUrl = function (frameId, url, autoLogin) {
                var _this = this;
                if (autoLogin === void 0) { autoLogin = true; }
                var _self = this;
                var deferred = this.common.$q.defer();
                var urlLower = url.toLowerCase();
                if (this.pulseContext.isLoggedIn && autoLogin && urlLower.indexOf("login.aspx") > 0) {
                    this.common.toggleSpinner(true, true, 1, 0);
                    this.common.logTraceToDatabase(this.pulseContext.loggedInUserId, this.pulseContext.actingAsUserId, 'baseCtrlWithiFrame.ts', 'actionBasedOnFrameUrl', Common.Enums.PulseErrorLogSeverityLevel.Warnings, Common.Enums.PulseErrorLogSubject.Authentication, 'We should not be on the login page.Request UserToken and retry loading the correct page');
                    var userTokenDAO = new Common.DataAccess.UserTokenDAO(this.common, this.breezeService, this.pulseContext);
                    userTokenDAO.genTokenForUser(this.pulseContext.loggedInUserId, "SPA iFrame Login: " + this.iFrameSrc)
                        .then(function (tokenObj) {
                        if (tokenObj) {
                            var params = {};
                            params[QueryStringUtils.COMPANY_ID] = _this.pulseContext.companyId;
                            params[QueryStringUtils.USER_ID] = _this.pulseContext.loggedInUserId;
                            if (_this.pulseContext.isImpersonating) {
                                params[QueryStringUtils.USER_IMPERSONATE_ID] = _this.pulseContext.actingAsUserId;
                            }
                            params[QueryStringUtils.GUID_USER_CHECK] = 1;
                            params[QueryStringUtils.GUID] = tokenObj.token;
                            if (_this.common.isMobileView) {
                                params[QueryStringUtils.MOBILE] = 1;
                            }
                            _self.common.logTraceToDatabase(_self.pulseContext.loggedInUserId, _self.pulseContext.actingAsUserId, 'baseCtrlWithiFrame.ts', 'actionBasedOnFrameUrl', Common.Enums.PulseErrorLogSeverityLevel.Verbose, Common.Enums.PulseErrorLogSubject.Authentication, 'Got new token = ' + tokenObj.token);
                            _self.iFrameSrc = QueryStringUtils.AddOrSetQSParams(_self.iFrameSrc, params);
                            deferred.resolve(true);
                        }
                        else {
                            _self.common.logTraceToDatabase(_self.pulseContext.loggedInUserId, _self.pulseContext.actingAsUserId, 'baseCtrlWithiFrame.ts', 'actionBasedOnFrameUrl', Common.Enums.PulseErrorLogSeverityLevel.Errors, Common.Enums.PulseErrorLogSubject.Authentication, 'Not able to generate token');
                            throw new Error("Not able to generate token.");
                        }
                    })
                        .catch(function (err) {
                        _this.common.toggleSpinner(false);
                        _this.stopAndCleariFrameSrc();
                        _this.$location.path(Routes.Login);
                        deferred.reject(err);
                    });
                }
                else if (urlLower.indexOf(Paths.Pulse1x_PublicMyAccountDashboard) > 0
                    || urlLower.indexOf(Paths.Pulse1x_PublicMyAccountSchedule) > 0) {
                    this.common.toggleSpinner(true, true, 1, 0);
                    this.stopAndCleariFrameSrc();
                    this.$location.url(Routes.MyAccount);
                    deferred.resolve(true);
                }
                else {
                    this.common.toggleSpinner(false);
                    deferred.resolve(false);
                }
                return deferred.promise;
            };
            return BaseCtrlWithiFrame;
        }(Common.BaseViewCtrl));
        Common.BaseCtrlWithiFrame = BaseCtrlWithiFrame;
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BaseFrame = (function (_super) {
            __extends(BaseFrame, _super);
            function BaseFrame(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = 'E';
                _this.replace = true;
                _this.scope = {
                    frameId: '@frameId',
                    origSrc: '=src',
                    onFrameLoad: '&',
                    showWaitSpinner: '=?showWaitSpinner',
                    api: '=?'
                };
                return _this;
            }
            return BaseFrame;
        }(Common.BaseDirective));
        Common.BaseFrame = BaseFrame;
        (function (BaseFrame) {
            var BaseFrameCtrl = (function (_super) {
                __extends(BaseFrameCtrl, _super);
                function BaseFrameCtrl($scope, $location, common, breezeService, pulseContext, loggingId) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, loggingId) || this;
                    _this.crossWinMessengerListner = function (msgObj) {
                        if (angular.isString(msgObj.currentUrl)) {
                            _this.crossWinMessengerSendMsg({ isHostedInSpa: true });
                            _this.frameElement.style.visibility = 'visible';
                            _this.common.toggleSpinner(false);
                            _this.onFrameLoad({
                                frameId: _this.frameId,
                                url: msgObj.currentUrl
                            });
                        }
                        else if (angular.isString(msgObj.infoMsg)) {
                            _this.common.showInfo(msgObj.infoMsg);
                        }
                        else if (angular.isString(msgObj.errMsg)) {
                            _this.common.showError(msgObj.errMsg);
                        }
                    };
                    return _this;
                }
                BaseFrameCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                    var _this = this;
                    if (this.showWaitSpinner === undefined || this.showWaitSpinner) {
                        this.common.toggleSpinner(true);
                    }
                    scope.$watch(function (scope) {
                        return _this.origSrc;
                    }, function (newVal, oldVal) {
                        _this.onUpdateFrameSrc();
                    }, true);
                    scope.$watch(function (scope) {
                        return _this.api;
                    }, function (newVal, oldVal) {
                        if (angular.isObject(_this.api))
                            return;
                        _this.api = {
                            stopLoad: _this.stopLoad
                        };
                    });
                    this.setupCrossWinMessenger(element);
                };
                Object.defineProperty(BaseFrameCtrl.prototype, "isMobileView", {
                    get: function () {
                        return this.frameElement.clientWidth <= this.common.config.mqIFrameInflectionWidth;
                    },
                    enumerable: false,
                    configurable: true
                });
                BaseFrameCtrl.prototype.stopLoad = function () {
                    try {
                        if (angular.isFunction(this.frameElement.stop))
                            this.frameElement.stop();
                        else
                            this.frameContentWindow.document.execCommand('Stop');
                    }
                    catch (e) { }
                };
                BaseFrameCtrl.prototype.onUpdateFrameSrc = function () {
                    var url = this.origSrc;
                    if (url === '' || url === 'about:blank') {
                        this.stopLoad();
                        this.frameElement.src = '';
                        $(this.frameElement)
                            .empty()
                            .remove();
                        return;
                    }
                    if (!QueryStringUtils.ContainsQS_HashCode(url)) {
                        var params = {};
                        params[QueryStringUtils.USER_ID] = this.pulseContext.loggedInUserId;
                        if (this.pulseContext.isImpersonating) {
                            params[QueryStringUtils.USER_IMPERSONATE_ID] = this.pulseContext.actingAsUserId;
                        }
                        params[QueryStringUtils.GUID_USER_CHECK] = 1;
                        if (this.isMobileView) {
                            params[QueryStringUtils.MOBILE] = 1;
                        }
                        url = QueryStringUtils.AddOrSetQSParams(url, params);
                    }
                    this.frameSrc = url;
                };
                BaseFrameCtrl.prototype.setupCrossWinMessenger = function (element) {
                    var _this = this;
                    this.frameElement = element.find('iframe')[0];
                    this.frameContentWindow = this.frameElement.contentWindow;
                    $(this.frameElement).on('load', function (eventObj) {
                        _this.onFrameWindowLoaded(eventObj);
                    });
                    this.common.crossWinMessenger.addTarget(this.frameId, this.frameContentWindow, '*', 'pulse1x', this.crossWinMessengerListner);
                };
                BaseFrameCtrl.prototype.crossWinMessengerSendMsg = function (msgObj) {
                    this.common.crossWinMessenger.sendMsg(this.frameId, msgObj);
                };
                BaseFrameCtrl.prototype.onFrameWindowLoaded = function (eventObj) {
                    $(document).ready(function () {
                        var heightCalMethod = 'lowestElement';
                        if (window.isIE_LEQT9 == true) {
                            heightCalMethod = 'bodyOffset';
                        }
                        iFrameResize({
                            log: false,
                            checkOrigin: false,
                            heightCalculationMethod: heightCalMethod,
                            scrolling: 'auto'
                        });
                    });
                    try {
                        this.onFrameLoad({
                            frameId: this.frameId,
                            url: this.frameContentWindow.location.href
                        });
                    }
                    catch (e) {
                    }
                    this.common.toggleSpinner(false);
                };
                BaseFrameCtrl.prototype.getFrameWindowPathname = function () {
                    return this.frameContentWindow.location.pathname;
                };
                return BaseFrameCtrl;
            }(Common.BaseDirective.BaseDirectiveCtrl));
            BaseFrame.BaseFrameCtrl = BaseFrameCtrl;
        })(BaseFrame = Common.BaseFrame || (Common.BaseFrame = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BasePopup = (function (_super) {
            __extends(BasePopup, _super);
            function BasePopup(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = 'E';
                _this.template = '<!-- Popup Empty Template -->';
                _this.transclude = true;
                _this.scope = {
                    api: '=?',
                    closeOnOutsideClick: '=',
                    popupId: '@',
                    title: '@',
                };
                return _this;
            }
            return BasePopup;
        }(Pulse.Common.BaseDirective));
        Common.BasePopup = BasePopup;
        (function (BasePopup) {
            var ModalSize = (function () {
                function ModalSize() {
                }
                ModalSize.Small = 'sm';
                ModalSize.Medium = 'md';
                ModalSize.Large = 'lg';
                ModalSize.ExtraLarge = 'xl';
                ModalSize.Full = 'full';
                return ModalSize;
            }());
            BasePopup.ModalSize = ModalSize;
            var EventType = (function () {
                function EventType() {
                }
                EventType.Open = 'PopupOpen';
                EventType.Close = 'PopupClose';
                EventType.Dismissed = 'PopupDismissed';
                return EventType;
            }());
            BasePopup.EventType = EventType;
            var BasePopupCtrl = (function (_super) {
                __extends(BasePopupCtrl, _super);
                function BasePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal, loggingId, scrollLockService) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, loggingId) || this;
                    _this.keyboard = true;
                    _this.windowClass = "";
                    _this.scrollToPopupOnOpen = true;
                    _this.popupTemplateUrl = '';
                    _this.onClick = function (event) {
                        if ($(event.target)
                            .parents('.modal-content').length === 0 && _this.closeOnOutsideClick) {
                            _this.close();
                        }
                    };
                    _this.onKey = function (event) {
                        var keyEvent = event;
                        var key = keyEvent === null || keyEvent === void 0 ? void 0 : keyEvent.key;
                        if (!key)
                            return false;
                        if (key.indexOf(Common.Enums.Keyboard.UI_Keys_Strings.ESCAPE) >= 0) {
                            if (_this.keyboard) {
                                _this.close();
                            }
                        }
                        if (_this._modalTabStops.active) {
                            if (key.indexOf(Common.Enums.Keyboard.UI_Keys_Strings.ARROW_DOWN) >= 0
                                || (key.indexOf(Common.Enums.Keyboard.UI_Keys_Strings.TAB) >= 0 && !keyEvent.shiftKey)) {
                                event.stopPropagation();
                                event.preventDefault();
                                _this.nextTabstop();
                                return false;
                            }
                            if (key.indexOf(Common.Enums.Keyboard.UI_Keys_Strings.ARROW_UP) >= 0
                                || (key.indexOf(Common.Enums.Keyboard.UI_Keys_Strings.TAB) >= 0 && keyEvent.shiftKey)) {
                                event.stopPropagation();
                                event.preventDefault();
                                _this.previousTabstop();
                                return false;
                            }
                        }
                    };
                    _this._modalTabStops = { maxStop: 0, active: false };
                    _this._modalCurrentTabStop = 0;
                    _this.$uibModal = $uibModal;
                    _this.scrollLock = angular.isDefined(scrollLockService)
                        ? scrollLockService : _this.common.$injector.get('ScrollLockService');
                    _this.activateController();
                    return _this;
                }
                BasePopupCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                    var _this = this;
                    scope.$watch(function () {
                        return _this.api;
                    }, function () {
                        if (!angular.isObject(_this.api)) {
                            _this.api = _this;
                        }
                    });
                    scope.$on(this.event_ShowPopup, function (event, data) {
                        _this.open(data.size, data.initDataObj, data.modalSettings);
                    });
                    scope.$on(Events.CloseAllPopups, function (event, data) {
                        _this.close();
                    });
                };
                Object.defineProperty(BasePopupCtrl.prototype, "isOpened", {
                    get: function () {
                        return angular.isObject(this.modalInstance);
                    },
                    enumerable: false,
                    configurable: true
                });
                BasePopupCtrl.prototype.onRendered = function () {
                    if (this.formName) {
                        this.myForm = this.viewScope[this.formName];
                    }
                    $(document)
                        .on('click', this.onClick)
                        .on('keydown', this.onKey);
                };
                BasePopupCtrl.prototype.initTabstops = function (element) {
                    var _this = this;
                    this._modalTabStops = { maxStop: 1, active: false };
                    this._modalCurrentTabStop = 1;
                    var stopAttr = "[" + BasePopupCtrl.TAB_STOP_ATTRIBUTE + "]";
                    var startAttr = "[" + BasePopupCtrl.TAB_STOP_START_ATTRIBUTE + "]";
                    var stops = $(element).find(stopAttr);
                    stops.each(function (idx, elem) {
                        _this._modalTabStops.active = true;
                        var arrIdx = parseInt($(elem).attr(BasePopupCtrl.TAB_STOP_ATTRIBUTE));
                        if (arrIdx == 0) {
                            var nArrIdx = 1;
                            while (_this._modalTabStops[nArrIdx] !== undefined)
                                nArrIdx++;
                            arrIdx = nArrIdx;
                        }
                        var tabIdx = _this.moveToTabstop(arrIdx, elem);
                        _this._modalTabStops.maxStop = Math.max(tabIdx, _this._modalTabStops.maxStop);
                    });
                    var start = $(element).find(startAttr);
                    if (start.length == 1) {
                        this._modalCurrentTabStop = parseInt($(start[0]).attr(BasePopupCtrl.TAB_STOP_START_ATTRIBUTE));
                    }
                    $(this._modalTabStops[this._modalCurrentTabStop]).focus();
                };
                BasePopupCtrl.prototype.moveToTabstop = function (idx, elem) {
                    var nTabstop = idx;
                    if (this._modalTabStops[idx] !== undefined) {
                        var tIdx = this.moveToTabstop(idx + 1, this._modalTabStops[idx]);
                        nTabstop = Math.max(tIdx, nTabstop);
                    }
                    this._modalTabStops[idx] = elem;
                    return nTabstop;
                };
                BasePopupCtrl.prototype.nextTabstop = function () {
                    this._modalCurrentTabStop = (this._modalCurrentTabStop + 1) % this._modalTabStops.maxStop;
                    if (this._modalCurrentTabStop == 0)
                        this._modalCurrentTabStop = this._modalTabStops.maxStop;
                    $(this._modalTabStops[this._modalCurrentTabStop]).focus();
                };
                BasePopupCtrl.prototype.previousTabstop = function () {
                    this._modalCurrentTabStop = ((this._modalTabStops.maxStop + this._modalCurrentTabStop) - 1) % this._modalTabStops.maxStop;
                    if (this._modalCurrentTabStop == 0)
                        this._modalCurrentTabStop = this._modalTabStops.maxStop;
                    $(this._modalTabStops[this._modalCurrentTabStop]).focus();
                };
                BasePopupCtrl.prototype.open = function (size, initDataObj, modalSettings) {
                    var _this = this;
                    if (modalSettings === void 0) { modalSettings = {}; }
                    this.scrollLock.increment();
                    if (this.isOpened) {
                        return;
                    }
                    this.initDataObj = initDataObj;
                    var _self = this;
                    this.modalInstance = this.$uibModal.open(angular.merge({
                        templateUrl: this.popupTemplateUrl,
                        controller: [
                            '$scope',
                            function (scope) {
                                _self.viewScope = scope;
                                if (!_self._onDestroyOff)
                                    _self._onDestroyOff = scope.$on('$destroy', function () {
                                        _self.onDestroy();
                                    });
                                if (!_self._onUrlChangeStartOff)
                                    _self._onUrlChangeStartOff = scope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
                                        _self.onUrlChangeStart(event, newUrl, oldUrl);
                                    });
                                return _self;
                            },
                        ],
                        keyboard: false,
                        controllerAs: 'vm',
                        bindToController: true,
                        scope: this.$scope,
                        size: size,
                        backdrop: 'static',
                        windowClass: this.windowClass,
                        resolve: {
                            data: function () { return _self.activationPromises; },
                        },
                    }, modalSettings));
                    this.modalInstance.rendered.then(function () {
                        var element = Pulse.jQuery("#" + _this.popupId);
                        Pulse.Utils.ClickTracking.hookupElementsInContainer(element);
                        _this.onRendered();
                        _this.initTabstops(element);
                        _self.fireEvent(EventType.Open);
                    });
                    if (this.pulseContext.isImpersonating) {
                        this.common.scrollToHash(StringConst.CSS_ID_pulse_view_top, 0, 0, 1);
                    }
                    else if (this.scrollToPopupOnOpen) {
                        this.common.scrollToHash(this.popupId, 0, 0, 1);
                    }
                    this.modalInstance.result.then(function (result) {
                        _self.fireEvent(EventType.Close, result, _self.initDataObj);
                    }, function (reason) {
                        _self.fireEvent(EventType.Dismissed, reason, _self.initDataObj);
                    });
                };
                BasePopupCtrl.prototype.close = function (results) {
                    var _this = this;
                    if (!this.myForm || !this.myForm.$dirty || (this.myForm.$submitted && this.myForm.$valid)) {
                        this.cleanupAndClose(results);
                        return;
                    }
                    if (this.checkUnsavedDataBeforeNav) {
                        var dlgID = 'UnsavedChangesDlg';
                        this.common.showConfirmation(StringConst.Title_Confirmation, StringConst.Warn_UnsavedChanges, function (confirm) {
                            if (confirm) {
                                _this.cleanupAndClose(results);
                            }
                            else {
                            }
                        }, { dialogId: dlgID });
                    }
                    else {
                        this.cleanupAndClose(results);
                    }
                };
                BasePopupCtrl.prototype.cleanupAndClose = function (results) {
                    var _this = this;
                    this.myForm = null;
                    this.viewScope = null;
                    this.scrollLock.decrement();
                    $(document)
                        .off('click', this.onClick)
                        .off('keydown', this.onKey);
                    if (this.isOpened) {
                        this.modalInstance.close(results);
                        this.modalInstance = null;
                    }
                    if (this.initDataObj && this.initDataObj.returnFocus) {
                        this.common.$timeout(function () {
                            $(_this.initDataObj.returnFocus).focus();
                        }, 10);
                    }
                    _super.prototype.cleanupAndClose.call(this, results);
                };
                BasePopupCtrl.prototype.dismiss = function (reason) {
                    this.myForm = null;
                    this.viewScope = null;
                    this.scrollLock.decrement();
                    if (this.isOpened) {
                        this.modalInstance.dismiss(reason);
                        this.modalInstance = null;
                    }
                };
                BasePopupCtrl.prototype.onEvent = function (name, listener) {
                    return this.$scope.$on(name, listener);
                };
                BasePopupCtrl.prototype.fireEvent = function (name) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    return this.common.$rootScope.$broadcast(name, args);
                };
                BasePopupCtrl.prototype.onDestroy = function () {
                    _super.prototype.onDestroy.call(this);
                    if (this.isOpened) {
                        this.scrollLock.decrement();
                    }
                };
                BasePopupCtrl.TAB_STOP_ATTRIBUTE = 'idp-tab';
                BasePopupCtrl.TAB_STOP_START_ATTRIBUTE = 'idp-tabstart';
                return BasePopupCtrl;
            }(Common.BaseDirective.BaseDirectiveCtrl));
            BasePopup.BasePopupCtrl = BasePopupCtrl;
        })(BasePopup = Common.BasePopup || (Common.BasePopup = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var BasePopover = (function (_super) {
            __extends(BasePopover, _super);
            function BasePopover(common) {
                return _super.call(this, common) || this;
            }
            BasePopover.scopeDef = {
                popoverId: "@",
                showPopover: "=",
                closeOnOutsideClick: "<",
            };
            return BasePopover;
        }(Pulse.Common.BaseDirective));
        Common.BasePopover = BasePopover;
        (function (BasePopover) {
            var BasePopoverCtrl = (function (_super) {
                __extends(BasePopoverCtrl, _super);
                function BasePopoverCtrl($scope, $location, common, breezeService, pulseContext, loggingId) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, loggingId) || this;
                    $scope.$on(Events.CloseAllPopups, function (event, data) {
                        _this.closePopover();
                    });
                    return _this;
                }
                BasePopoverCtrl.prototype.onRendered = function () {
                    var _this = this;
                    $(document).on("click", function (event) {
                        if ($(event.target).parents(".popover-content").length == 0 &&
                            _this.closeOnOutsideClick) {
                            _this.closePopover();
                        }
                    });
                };
                BasePopoverCtrl.prototype.closePopover = function () {
                    var _this = this;
                    if (!this.myForm || !this.myForm.$dirty || (this.myForm.$submitted && this.myForm.$valid)) {
                        this.cleanupAndClose();
                        return;
                    }
                    if (this.checkUnsavedDataBeforeNav) {
                        var dialogClassName = "modal-dialog-over-popover";
                        this.common.$rootScope.$broadcast(Events.ShowBasicPopup, {
                            size: 'sm',
                            initDataObj: {
                                title: StringConst.Title_Confirmation,
                                html: StringConst.Warn_UnsavedChanges,
                                button1: {
                                    label: "Yes",
                                    cbFn: function () {
                                        _this.cleanupAndClose();
                                    }
                                },
                                button2: {
                                    label: "No",
                                    cbFn: function () {
                                    }
                                },
                            },
                            modalSettings: {
                                windowClass: dialogClassName
                            }
                        });
                        if (this.pulseContext.inIframe) {
                            this.common.$timeout(function () {
                                var modalContentElement = angular.element("." + dialogClassName)[0];
                                var popoverElement = angular.element(".popover:last")[0];
                                var popoverOffset = popoverElement.getBoundingClientRect();
                                modalContentElement.style.position = "absolute";
                                modalContentElement.style.top = (popoverOffset.top + (0.3 * popoverOffset.height)) + "px";
                            }, 300);
                        }
                    }
                    else {
                        this.cleanupAndClose();
                    }
                };
                BasePopoverCtrl.prototype.cleanupAndClose = function () {
                    this.showPopover = false;
                };
                return BasePopoverCtrl;
            }(Pulse.Common.BaseDirective
                .BaseDirectiveCtrl));
            BasePopover.BasePopoverCtrl = BasePopoverCtrl;
        })(BasePopover = Common.BasePopover || (Common.BasePopover = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var ComponentOptions = (function () {
            function ComponentOptions() {
                this.controllerAs = '$ctrl';
            }
            return ComponentOptions;
        }());
        Common.ComponentOptions = ComponentOptions;
        var ComponentController = (function () {
            function ComponentController($scope, $element) {
                this.$scope = $scope;
                this.$element = $element;
            }
            ComponentController.prototype.$onInit = function () {
                return;
            };
            ComponentController.prototype.$postLink = function () {
                if (this.$element) {
                    Pulse.Utils.ClickTracking.hookupElementsInContainer(this.$element);
                }
            };
            ComponentController.prototype.checkForNewValue = function (changedValue) {
                return changedValue.isFirstChange() || !angular.equals(changedValue.currentValue, changedValue.previousValue);
            };
            return ComponentController;
        }());
        Common.ComponentController = ComponentController;
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var BaseDAO = (function (_super) {
                __extends(BaseDAO, _super);
                function BaseDAO(common, breezeService, pulseContext, loggingId) {
                    var _this = _super.call(this, common, breezeService, pulseContext, loggingId) || this;
                    _this.entityMgr = breezeService.getEntityManager();
                    return _this;
                }
                BaseDAO.prototype.Create = function (config, entityState, mergeStrategy) {
                    if (!this.entityTypeName) {
                        throw new Error('Create failed. entityTypeName is undefined.');
                    }
                    var entity = this.entityMgr.createEntity(this.entityTypeName, config, entityState, mergeStrategy);
                    if (entity.companyID && !(entity.companyID > 0)) {
                        entity.companyID = this.pulseContext.companyId;
                    }
                    return entity;
                };
                BaseDAO.prototype.getFromSaveResult = function (saveResult) {
                    var _this = this;
                    var entities = new Array();
                    saveResult.entities.forEach(function (entity, index) {
                        if (entity.entityType.shortName === _this.entityTypeName) {
                            entities.push(entity);
                        }
                    });
                    return entities;
                };
                BaseDAO.prototype.getByIdFromBreezeCache = function (keyId) {
                    return this.entityMgr.getEntityByKey(this.entityTypeName, keyId);
                };
                BaseDAO.prototype.clearCache = function () {
                    var _this = this;
                    var cachedItems = this.entityMgr.getEntities(this.entityTypeName);
                    cachedItems.forEach(function (entity) {
                        _this.entityMgr.detachEntity(entity);
                    });
                };
                return BaseDAO;
            }(Common.BaseCommon));
            DataAccess.BaseDAO = BaseDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var AgeRangeDAO = (function (_super) {
                __extends(AgeRangeDAO, _super);
                function AgeRangeDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, AgeRangeDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'AgeRange';
                    return _this;
                }
                AgeRangeDAO.prototype.getActive = function (refreshCache) {
                    if (refreshCache === void 0) { refreshCache = false; }
                    var query = breeze.EntityQuery
                        .from('AgeRange_GetActive')
                        .withParameters({
                        companyID: this.pulseContext.companyId,
                        refreshCache: refreshCache,
                    });
                    var result = this.entityMgr.executeQuery(query)
                        .then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                AgeRangeDAO.prototype.getActiveByType = function (ageRangeTypeID, refreshCache) {
                    if (refreshCache === void 0) { refreshCache = false; }
                    var result = this.getActive(refreshCache)
                        .then(function (data) {
                        return data.filter(function (ar) { return ar.ageRangeTypeID == ageRangeTypeID; });
                    });
                    return result;
                };
                AgeRangeDAO.CLASS_NAME = 'AgeRangeDAO';
                return AgeRangeDAO;
            }(DataAccess.BaseDAO));
            DataAccess.AgeRangeDAO = AgeRangeDAO;
            (function (AgeRangeDAO) {
                var CampAgeGroup;
                (function (CampAgeGroup) {
                    CampAgeGroup[CampAgeGroup["Group1"] = 4] = "Group1";
                    CampAgeGroup[CampAgeGroup["Group2"] = 5] = "Group2";
                    CampAgeGroup[CampAgeGroup["Group3"] = 7] = "Group3";
                })(CampAgeGroup = AgeRangeDAO.CampAgeGroup || (AgeRangeDAO.CampAgeGroup = {}));
                var DormRoomAgeGroup;
                (function (DormRoomAgeGroup) {
                    DormRoomAgeGroup[DormRoomAgeGroup["PreTeen"] = 18] = "PreTeen";
                    DormRoomAgeGroup[DormRoomAgeGroup["Teen"] = 19] = "Teen";
                    DormRoomAgeGroup[DormRoomAgeGroup["All"] = 20] = "All";
                })(DormRoomAgeGroup = AgeRangeDAO.DormRoomAgeGroup || (AgeRangeDAO.DormRoomAgeGroup = {}));
            })(AgeRangeDAO = DataAccess.AgeRangeDAO || (DataAccess.AgeRangeDAO = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var CompanyDAO = (function (_super) {
                __extends(CompanyDAO, _super);
                function CompanyDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, CompanyDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Company';
                    return _this;
                }
                CompanyDAO.prototype.getByID = function (id) {
                    var query = breeze.EntityQuery
                        .from('Companies')
                        .where('companyID', '==', id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                CompanyDAO.CLASS_NAME = 'CompanyDAO';
                return CompanyDAO;
            }(DataAccess.BaseDAO));
            DataAccess.CompanyDAO = CompanyDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var CorrespondenceDAO = (function (_super) {
                __extends(CorrespondenceDAO, _super);
                function CorrespondenceDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, CorrespondenceDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Correspondence';
                    return _this;
                }
                CorrespondenceDAO.CLASS_NAME = 'CorrespondenceDAO';
                return CorrespondenceDAO;
            }(DataAccess.BaseDAO));
            DataAccess.CorrespondenceDAO = CorrespondenceDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var CouponDAO = (function (_super) {
                __extends(CouponDAO, _super);
                function CouponDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, CouponDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Coupon';
                    return _this;
                }
                CouponDAO.prototype.getByUserIDRoleTypeDiscountType = function (userID, roleType, couponType, discountSubType) {
                    var query = breeze.EntityQuery
                        .from('Coupon_GetByUserIDRoleTypeDiscountType')
                        .withParameters({
                        userID: userID,
                        roleTypeID: roleType,
                        couponTypeID: couponType,
                        discountSubTypeID: discountSubType,
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                CouponDAO.prototype.getCurrentRAFCouponForCustomer = function (userID) {
                    var query = breeze.EntityQuery
                        .from('Coupon_GetCurrentRAFCouponForCustomer')
                        .withParameters({
                        userID: userID,
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        if (data.results.length <= 0)
                            return null;
                        return data.results[0];
                    });
                    return result;
                };
                CouponDAO.prototype.getReferrals = function (pageNumber, pageSize, currentTermGroupOnly) {
                    if (pageNumber === void 0) { pageNumber = 0; }
                    if (pageSize === void 0) { pageSize = 0; }
                    if (currentTermGroupOnly === void 0) { currentTermGroupOnly = true; }
                    var query = breeze.EntityQuery
                        .from('Coupon_GetReferrals')
                        .withParameters({
                        userID: this.pulseContext.actingAsUserId,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                        restrictToCurrentTermGroup: currentTermGroupOnly,
                        returnTotal: true,
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return {
                            referralInfos: data.results,
                            totalCountWithoutPaging: data.inlineCount,
                        };
                    });
                    return result;
                };
                CouponDAO.prototype.updateRafConsumerStatus = function (referral, newStatusTypeID) {
                    var url = this.common.config.webApi_NonBreeze + "/Coupon_UpdateRafConsumerStatus";
                    var postData = {
                        couponUserID: referral.couponUsedFor_CouponUserID,
                        newStatusTypeID: newStatusTypeID
                    };
                    return this.common.$http.post(url, postData, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        return response;
                    });
                };
                CouponDAO.CLASS_NAME = 'CouponDAO';
                return CouponDAO;
            }(DataAccess.BaseDAO));
            DataAccess.CouponDAO = CouponDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var DiscountDAO = (function (_super) {
                __extends(DiscountDAO, _super);
                function DiscountDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, DiscountDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Discount';
                    return _this;
                }
                DiscountDAO.prototype.getMaxValueByDiscountTypeID = function (discountType) {
                    var query = breeze.EntityQuery
                        .from('Discount_GetMaxValueByDiscountTypeID')
                        .withParameters({ discountTypeID: discountType })
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        if (data.results && data.results.length > 0) {
                            return data.results[0];
                        }
                        return null;
                    });
                    return result;
                };
                DiscountDAO.prototype.getEarlyAccessDiscountForNextTermGroup = function (subsidiaryCompanyID) {
                    var query = breeze.EntityQuery
                        .from('Discount_GetEarlyAccessDiscountsForNextTermGroup')
                        .withParameters({ 'subsidiaryCompanyID': subsidiaryCompanyID })
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        if (data.results && data.results.length > 0) {
                            return data.results[0];
                        }
                        return null;
                    });
                    return result;
                };
                DiscountDAO.CLASS_NAME = 'DiscountDAO';
                return DiscountDAO;
            }(DataAccess.BaseDAO));
            DataAccess.DiscountDAO = DiscountDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var DivisionDAO = (function (_super) {
                __extends(DivisionDAO, _super);
                function DivisionDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, DivisionDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Division';
                    return _this;
                }
                DivisionDAO.prototype.getActiveForLoggedInUser = function (filters) {
                    var url = this.common.config.webApi_NonBreeze + '/Division_GetActiveForCurrentLoggedInUser';
                    return this.common.$http.post(url, filters, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        var results = response.data;
                        return results;
                    });
                };
                DivisionDAO.prototype.getReleasedAndActive = function (refreshCache) {
                    if (refreshCache === void 0) { refreshCache = false; }
                    var query = breeze.EntityQuery
                        .from('Division_GetReleasedAndActive')
                        .withParameters({
                        'companyID': this.pulseContext.companyId,
                        'refreshCache': refreshCache,
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                DivisionDAO.FilterDivisionsByID = function (divisions, divisionID) {
                    if (divisions) {
                        var results = divisions.filter(function (d) { return d.divisionID == divisionID; });
                        if (results && results.length) {
                            return results[0];
                        }
                    }
                    return null;
                };
                DivisionDAO.CLASS_NAME = 'DivisionDAO';
                return DivisionDAO;
            }(DataAccess.BaseDAO));
            DataAccess.DivisionDAO = DivisionDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var DivisionTextDAO = (function (_super) {
                __extends(DivisionTextDAO, _super);
                function DivisionTextDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, DivisionTextDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'DivisionText';
                    return _this;
                }
                DivisionTextDAO.prototype.getByDivisionAndTextType = function (divisionId, divisionTextTypeId) {
                    var query = breeze.EntityQuery
                        .from('DivisionText_GetByDivisionAndTextType')
                        .withParameters({
                        'divisionID': divisionId,
                        'divisionTextTypeID': divisionTextTypeId,
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                DivisionTextDAO.CLASS_NAME = 'DivisionTextDAO';
                return DivisionTextDAO;
            }(DataAccess.BaseDAO));
            DataAccess.DivisionTextDAO = DivisionTextDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var DomainMapDAO = (function (_super) {
                __extends(DomainMapDAO, _super);
                function DomainMapDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, DomainMapDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'PulseType';
                    return _this;
                }
                DomainMapDAO.prototype.getDomainMapForUrlHost = function (refreshCache) {
                    if (refreshCache === void 0) { refreshCache = false; }
                    var query = breeze.EntityQuery
                        .from('System_GetDomainMapForUrlHost')
                        .withParameters({
                        'refreshCache': refreshCache
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                DomainMapDAO.prototype.getDomainMapByLocID = function (LocationID, refreshCache) {
                    if (refreshCache === void 0) { refreshCache = false; }
                    var query = breeze.EntityQuery
                        .from('System_GetDomainMapByLocID')
                        .withParameters({
                        'locationID': LocationID,
                        'refreshCache': refreshCache
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                DomainMapDAO.CLASS_NAME = 'DomainMapDAO';
                return DomainMapDAO;
            }(DataAccess.BaseDAO));
            DataAccess.DomainMapDAO = DomainMapDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var FacilityDAO = (function (_super) {
                __extends(FacilityDAO, _super);
                function FacilityDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, FacilityDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Facility';
                    return _this;
                }
                FacilityDAO.prototype.getCurrentLabBuildings = function (divisionId, locationId, sessionId) {
                    var query = breeze.EntityQuery
                        .from('Facility_LabBuildings_GetCurrent')
                        .withParameters({
                        divisionId: divisionId,
                        locationId: locationId,
                        sessionId: sessionId
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                FacilityDAO.prototype.getActiveForLoggedInUser = function (filters) {
                    var url = this.common.config.webApi_NonBreeze + '/Facility_GetActiveForCurrentLoggedInUser';
                    return this.common.$http.post(url, filters, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        var results = response.data;
                        return results;
                    });
                };
                FacilityDAO.prototype.getHavingRoomsAssignedByLocationIDSessionID = function (locationID, sessionID) {
                    var query = breeze.EntityQuery
                        .from('Facility_GetHavingRoomsAssignedByLocationIDSessionID')
                        .withParameters({
                        'locationID': locationID,
                        'sessionID': sessionID,
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                FacilityDAO.CLASS_NAME = 'FacilityDAO';
                return FacilityDAO;
            }(DataAccess.BaseDAO));
            DataAccess.FacilityDAO = FacilityDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var FormPersonDAO = (function (_super) {
                __extends(FormPersonDAO, _super);
                function FormPersonDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, FormPersonDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'FormPerson';
                    return _this;
                }
                FormPersonDAO.prototype.getByID = function (id) {
                    var query = breeze.EntityQuery
                        .from('FormPersons')
                        .where('formPersonID', '==', id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                FormPersonDAO.CLASS_NAME = 'FormPersonDAO';
                return FormPersonDAO;
            }(DataAccess.BaseDAO));
            DataAccess.FormPersonDAO = FormPersonDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var FormPersonDetailDAO = (function (_super) {
                __extends(FormPersonDetailDAO, _super);
                function FormPersonDetailDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, FormPersonDetailDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'FormPersonDetail';
                    return _this;
                }
                FormPersonDetailDAO.prototype.getByID = function (id) {
                    var query = breeze.EntityQuery
                        .from('FormPersonDetail')
                        .where('formPersonDetailID', '==', id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                FormPersonDetailDAO.CLASS_NAME = 'FormPersonDetailDAO';
                return FormPersonDetailDAO;
            }(DataAccess.BaseDAO));
            DataAccess.FormPersonDetailDAO = FormPersonDetailDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var FormPersonAddressDAO = (function (_super) {
                __extends(FormPersonAddressDAO, _super);
                function FormPersonAddressDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, FormPersonAddressDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'FormPersonAddress';
                    return _this;
                }
                FormPersonAddressDAO.prototype.getByID = function (id) {
                    var query = breeze.EntityQuery
                        .from('FormPersonAddress')
                        .where('formPersonAddressID', '==', id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                FormPersonAddressDAO.CLASS_NAME = 'FormPersonAddressDAO';
                return FormPersonAddressDAO;
            }(DataAccess.BaseDAO));
            DataAccess.FormPersonAddressDAO = FormPersonAddressDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var FormPersonContactMethodDAO = (function (_super) {
                __extends(FormPersonContactMethodDAO, _super);
                function FormPersonContactMethodDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, FormPersonContactMethodDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'FormPersonContactMethod';
                    return _this;
                }
                FormPersonContactMethodDAO.prototype.getByID = function (id) {
                    var query = breeze.EntityQuery
                        .from('FormPersonContactMethods')
                        .where('formPersonContactMethodID', '==', id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                FormPersonContactMethodDAO.CLASS_NAME = 'FormPersonContactMethodDAO';
                return FormPersonContactMethodDAO;
            }(DataAccess.BaseDAO));
            DataAccess.FormPersonContactMethodDAO = FormPersonContactMethodDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var HowHeardAboutDAO = (function (_super) {
                __extends(HowHeardAboutDAO, _super);
                function HowHeardAboutDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, HowHeardAboutDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'HowHeardAbout';
                    return _this;
                }
                HowHeardAboutDAO.CLASS_NAME = 'HowHeardAboutDAO';
                return HowHeardAboutDAO;
            }(DataAccess.BaseDAO));
            DataAccess.HowHeardAboutDAO = HowHeardAboutDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var InfoRequestDAO = (function (_super) {
                __extends(InfoRequestDAO, _super);
                function InfoRequestDAO(common, breezeService, pulseContext, dateInContext) {
                    if (dateInContext === void 0) { dateInContext = null; }
                    var _this = _super.call(this, common, breezeService, pulseContext, InfoRequestDAO.CLASS_NAME) || this;
                    _this._dateInContext = null;
                    _this.entityTypeName = 'InfoRequest';
                    _this._dateInContext = dateInContext;
                    return _this;
                }
                InfoRequestDAO.prototype.setDateInContext = function (date) {
                    this._dateInContext = date;
                };
                InfoRequestDAO.prototype.getByIdAndHash = function (infoRequestID, idHash) {
                    var query = this.breezeService.breeze.EntityQuery
                        .from('InfoRequest_GetIDAndIDHash')
                        .withParameters({
                        'infoRequestID': infoRequestID,
                        'idHash': idHash,
                    });
                    var results = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return results;
                };
                InfoRequestDAO.CLASS_NAME = 'InfoRequestDAO';
                return InfoRequestDAO;
            }(DataAccess.BaseDAO));
            DataAccess.InfoRequestDAO = InfoRequestDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var LocationDAO = (function (_super) {
                __extends(LocationDAO, _super);
                function LocationDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, LocationDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Location';
                    return _this;
                }
                LocationDAO.prototype.getReleasedAndActiveForDivisions = function (divisionIDs) {
                    return this.common.$http.get(this.common.config.webApi_NonBreeze + '/Location_GetAllReleasedAndActiveForDivisions', {
                        params: {
                            'divisionIDs': divisionIDs
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    })
                        .then(function (response) {
                        return response.data;
                    });
                };
                LocationDAO.prototype.getLocationsForLoggedInUser = function (locationFilters) {
                    var url = this.common.config.webApi_NonBreeze + '/Location_GetActiveForLoggedInUser';
                    return this.common.$http.post(url, locationFilters, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        return response.data;
                    });
                };
                LocationDAO.prototype.getLocatonCampPhotoUrls = function (stateTypeID, refreshCache) {
                    var url = this.common.config.webApi_NonBreeze
                        + '/Location_GetCampPhotoUrl?stateTypeID=' + stateTypeID + '&refreshCache' + refreshCache;
                    return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        return response.data;
                    });
                };
                LocationDAO.CLASS_NAME = 'LocationDAO';
                return LocationDAO;
            }(DataAccess.BaseDAO));
            DataAccess.LocationDAO = LocationDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var OrderDetailBuddyDAO = (function (_super) {
                __extends(OrderDetailBuddyDAO, _super);
                function OrderDetailBuddyDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, OrderDetailBuddyDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'OrderDetailBuddy';
                    return _this;
                }
                OrderDetailBuddyDAO.prototype.getByOrderDetailID = function (userId, orderDetailId) {
                    this.clearCache();
                    var query = breeze.EntityQuery
                        .from('OrderDetailBuddy_Get')
                        .withParameters({
                        userID: userId,
                        orderDetailID: orderDetailId
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                OrderDetailBuddyDAO.prototype.createBuddyList = function (userId, orderDetailId) {
                    return this.breezeService.saveChanges(null, {
                        resourceName: 'OrderDetail_CreateBuddyList',
                        tag: {
                            userId: userId,
                            orderDetailId: orderDetailId
                        }
                    });
                };
                OrderDetailBuddyDAO.CLASS_NAME = 'OrderDetailBuddyDAO';
                return OrderDetailBuddyDAO;
            }(DataAccess.BaseDAO));
            DataAccess.OrderDetailBuddyDAO = OrderDetailBuddyDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var PaymentDAO = (function (_super) {
                __extends(PaymentDAO, _super);
                function PaymentDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, PaymentDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Payment';
                    return _this;
                }
                PaymentDAO.prototype.getRecurringPaymentForUserID = function (userId, currencyTypeID) {
                    var query = breeze.EntityQuery
                        .from('Payment_GetRecurringPaymentForUserID')
                        .withParameters({ userID: this.pulseContext.actingAsUserId, currencyTypeID: currencyTypeID })
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                PaymentDAO.CLASS_NAME = 'PaymentDAO';
                return PaymentDAO;
            }(DataAccess.BaseDAO));
            DataAccess.PaymentDAO = PaymentDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var ProductDAO = (function (_super) {
                __extends(ProductDAO, _super);
                function ProductDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, ProductDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Product';
                    return _this;
                }
                ProductDAO.prototype.getForLocationAndSession = function (locationId, sessionId) {
                    var query = breeze.EntityQuery
                        .from('Product_Courses_GetForLocationAndSession')
                        .withParameters({
                        locationId: locationId,
                        sessionId: sessionId
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                ProductDAO.prototype.getCategoryInfoByProductId = function (productId) {
                    var query = breeze.EntityQuery
                        .from('ProductInfo_GetCategoryInfoByProductId')
                        .withParameters({
                        productId: productId
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                ProductDAO.prototype.getProdInfoByDivisionAndCategory = function (divId, prodCatId, prodSubcatId) {
                    if (divId === void 0) { divId = null; }
                    var query = breeze.EntityQuery
                        .from('ProductInfo_GetByDivisionAndCategory')
                        .withParameters({
                        divisionID: divId,
                        categoryID: prodCatId,
                        subcategoryID: prodSubcatId
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                ProductDAO.prototype.getProdDetailByDivisionAndCategory = function (divId, prodCatId, prodSubcatId) {
                    var query = breeze.EntityQuery
                        .from('ProductDetail_GetByDivisionAndCategory')
                        .withParameters({
                        divisionID: divId,
                        categoryID: prodCatId,
                        subcategoryID: prodSubcatId
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                ProductDAO.CLASS_NAME = 'ProductDAO';
                ProductDAO.ProductVisibilityType_CrossSellTypes = [Common.Enums.ProductVisibilityType.CrossSellUnconditionally,
                    Common.Enums.ProductVisibilityType.CrossSellOnlyToOtherDivisions,
                    Common.Enums.ProductVisibilityType.CrossSellToSpecifiedDivisions];
                return ProductDAO;
            }(DataAccess.BaseDAO));
            DataAccess.ProductDAO = ProductDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var PulseTypeDAO = (function (_super) {
                __extends(PulseTypeDAO, _super);
                function PulseTypeDAO(common, breezeService, pulseContext, dateInContext) {
                    if (dateInContext === void 0) { dateInContext = null; }
                    var _this = _super.call(this, common, breezeService, pulseContext, PulseTypeDAO.CLASS_NAME) || this;
                    _this._dateInContext = null;
                    _this.entityTypeName = 'PulseType';
                    _this._dateInContext = dateInContext;
                    return _this;
                }
                PulseTypeDAO.prototype.setDateInContext = function (date) {
                    this._dateInContext = date;
                };
                PulseTypeDAO.prototype.getActiveByParentTypeId = function (parentTypeId, childTypeClassID, includeExtraLongString, refreshCache) {
                    if (childTypeClassID === void 0) { childTypeClassID = null; }
                    if (includeExtraLongString === void 0) { includeExtraLongString = false; }
                    if (refreshCache === void 0) { refreshCache = false; }
                    var query = this.breezeService.breeze.EntityQuery
                        .from('PulseType_GetActiveByParentTypeID')
                        .withParameters({
                        'parentTypeId': parentTypeId,
                        'childTypeClassID': childTypeClassID,
                        'includeExtraLongString': includeExtraLongString,
                        'dateInContext': this._dateInContext,
                        'refreshCache': refreshCache,
                    });
                    var results = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return results;
                };
                PulseTypeDAO.prototype.getActiveByTypeClassId = function (typeclassId, includeExtraLongString, refreshCache) {
                    if (includeExtraLongString === void 0) { includeExtraLongString = false; }
                    if (refreshCache === void 0) { refreshCache = false; }
                    var query = this.breezeService.breeze.EntityQuery
                        .from('PulseType_GetActiveByTypeClassID')
                        .withParameters({
                        typeClassID: typeclassId,
                        includeExtraLongString: includeExtraLongString,
                        refreshCache: refreshCache,
                    });
                    var results = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return results;
                };
                PulseTypeDAO.prototype.getActiveAndReleasedByTypeClassId = function (typeclassId, includeExtraLongString, refreshCache) {
                    if (includeExtraLongString === void 0) { includeExtraLongString = false; }
                    if (refreshCache === void 0) { refreshCache = false; }
                    var url = this.common.config.webApi_NonBreeze + '/PulseType_GetActiveAndReleasedByTypeClassID';
                    url += "?typeClassID=" + typeclassId + "&includeExtraLongString=" + includeExtraLongString + "&refreshCache=" + refreshCache;
                    return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        var result = response.data;
                        return result;
                    });
                };
                PulseTypeDAO.CLASS_NAME = 'PulseTypeDAO';
                return PulseTypeDAO;
            }(DataAccess.BaseDAO));
            DataAccess.PulseTypeDAO = PulseTypeDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var ReqdFormContentDAO = (function (_super) {
                __extends(ReqdFormContentDAO, _super);
                function ReqdFormContentDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, ReqdFormContentDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'ReqdFormContent';
                    return _this;
                }
                ReqdFormContentDAO.prototype.getByReqdFormContentID = function (id) {
                    var query = breeze.EntityQuery
                        .from('ReqdFormContent')
                        .where('reqdFormContentID', '==', id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                ReqdFormContentDAO.CLASS_NAME = 'ReqdFormContentDAO';
                return ReqdFormContentDAO;
            }(DataAccess.BaseDAO));
            DataAccess.ReqdFormContentDAO = ReqdFormContentDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var RoomSessionDAO = (function (_super) {
                __extends(RoomSessionDAO, _super);
                function RoomSessionDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, RoomSessionDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'RoomSession';
                    return _this;
                }
                RoomSessionDAO.prototype.getByRoomIDSessionID = function (roomID, sessionID) {
                    var query = breeze.EntityQuery
                        .from('RoomSession_GetByRoomIDSessionID')
                        .withParameters({
                        'roomID': roomID,
                        'sessionID': sessionID,
                    })
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                RoomSessionDAO.prototype.update = function (entities) {
                    return this.breezeService.saveChanges(entities, {
                        resourceName: 'RoomSession_Update',
                    });
                };
                RoomSessionDAO.CLASS_NAME = 'RoomSessionDAO';
                return RoomSessionDAO;
            }(DataAccess.BaseDAO));
            DataAccess.RoomSessionDAO = RoomSessionDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var SessionDAO = (function (_super) {
                __extends(SessionDAO, _super);
                function SessionDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, SessionDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Session';
                    return _this;
                }
                SessionDAO.prototype.getSessionsForLoggedInUser = function (sessionFilters) {
                    var url = this.common.config.webApi_NonBreeze + '/Session_GetActiveForLoggedInUser';
                    return this.common.$http.post(url, sessionFilters, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        var results = response.data;
                        return results;
                    });
                };
                SessionDAO.prototype.getBySessionID = function (id) {
                    var query = breeze.EntityQuery
                        .from('Sessions')
                        .where('SessionID', '==', id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                SessionDAO.CLASS_NAME = 'SessionDAO';
                return SessionDAO;
            }(DataAccess.BaseDAO));
            DataAccess.SessionDAO = SessionDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var StaffAssignmentDAO = (function (_super) {
                __extends(StaffAssignmentDAO, _super);
                function StaffAssignmentDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, StaffAssignmentDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'StaffAssignment';
                    return _this;
                }
                StaffAssignmentDAO.prototype.getStaffAssignByOrderDetailID = function (orderDetailId, jobPurviewTypeId) {
                    var query = breeze.EntityQuery
                        .from('TermStaff_GetStaffAssignByOrderDetailID')
                        .orderBy('NickName, FirstName, LastName')
                        .withParameters({ orderDetailID: orderDetailId, jobPurviewTypeID: jobPurviewTypeId });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                StaffAssignmentDAO.CLASS_NAME = 'StaffAssignmentDAO';
                return StaffAssignmentDAO;
            }(DataAccess.BaseDAO));
            DataAccess.StaffAssignmentDAO = StaffAssignmentDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var StateDAO = (function (_super) {
                __extends(StateDAO, _super);
                function StateDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, StateDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'PulseType';
                    return _this;
                }
                StateDAO.prototype.getCountryStates = function (filters) {
                    var url = this.common.config.webApi_NonBreeze + '/GetStates';
                    return this.common.$http.post(url, filters, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        var results = response.data;
                        return results;
                    });
                };
                StateDAO.CLASS_NAME = 'StateDAO';
                return StateDAO;
            }(DataAccess.BaseDAO));
            DataAccess.StateDAO = StateDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var TermGroupDAO = (function (_super) {
                __extends(TermGroupDAO, _super);
                function TermGroupDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, TermGroupDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "TermGroup";
                    return _this;
                }
                TermGroupDAO.prototype.getCurrentTermGroup = function () {
                    var query = breeze.EntityQuery
                        .from("TermGroup_GetCurrent")
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                TermGroupDAO.prototype.getPreviousTermGroup = function () {
                    var query = breeze.EntityQuery
                        .from("TermGroup_GetPrevious")
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                TermGroupDAO.prototype.getActive = function (filters) {
                    var url = this.common.config.webApi_NonBreeze + "/TermGroup_GetActive";
                    filters = filters || {};
                    return this.common.$http.post(url, filters, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        var results = response.data;
                        return results;
                    });
                };
                TermGroupDAO.CLASS_NAME = "TermGroupDAO";
                return TermGroupDAO;
            }(DataAccess.BaseDAO));
            DataAccess.TermGroupDAO = TermGroupDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var TermDAO = (function (_super) {
                __extends(TermDAO, _super);
                function TermDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, TermDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'Term';
                    return _this;
                }
                TermDAO.prototype.getActive = function (filters) {
                    var url = this.common.config.webApi_NonBreeze + '/Term_GetActive';
                    return this.common.$http.post(url, filters, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        var results = response.data;
                        return results;
                    });
                };
                TermDAO.CLASS_NAME = 'TermDAO';
                return TermDAO;
            }(DataAccess.BaseDAO));
            DataAccess.TermDAO = TermDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserBrowsingDAO = (function (_super) {
                __extends(UserBrowsingDAO, _super);
                function UserBrowsingDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserBrowsingDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "UserBrowsing";
                    return _this;
                }
                UserBrowsingDAO.prototype.getByBrowseIdentifierAndCartTypeID = function (browseIdentifier, cartTypeID, isActiveOnly) {
                    if (isActiveOnly === void 0) { isActiveOnly = true; }
                    var query = breeze.EntityQuery
                        .from("UserBrowsing_GetParentByBrowseIdentifierAndCartTypeID")
                        .withParameters({
                        "browseIdentifier": browseIdentifier,
                        "cartTypeID": cartTypeID,
                        "isActiveOnly": isActiveOnly
                    })
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserBrowsingDAO.prototype.getParticipantUserBrowsings = function (browseIdentifier, cartTypeID, refreshCache) {
                    var _this = this;
                    if (refreshCache) {
                        if (this.entityMgr) {
                            var cachedEntities = this.entityMgr.getEntities('UserBrowsing');
                            if (cachedEntities) {
                                cachedEntities.forEach(function (entity) {
                                    if (entity) {
                                        _this.entityMgr.detachEntity(entity);
                                    }
                                });
                            }
                        }
                    }
                    var query = breeze.EntityQuery
                        .from("UserBrowsing_GetParticipantUserBrowsings")
                        .withParameters({
                        "browseIdentifier": browseIdentifier,
                        "cartTypeID": cartTypeID,
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return (data.results);
                    });
                    return result;
                };
                UserBrowsingDAO.prototype.saveChanges = function (userBrowsings) {
                    return this.breezeService.saveChanges(userBrowsings, {
                        resourceName: "UserBrowsing_Save",
                    });
                };
                UserBrowsingDAO.CLASS_NAME = "UserBrowsingDAO";
                return UserBrowsingDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserBrowsingDAO = UserBrowsingDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserBrowsingNoteDAO = (function (_super) {
                __extends(UserBrowsingNoteDAO, _super);
                function UserBrowsingNoteDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserBrowsingNoteDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'UserBrowsingNote';
                    return _this;
                }
                UserBrowsingNoteDAO.prototype.loadBuddyListFromUserBrowsingNotes = function (buddyListArrToPopulate, browseIdentifier, userBrowsingParticipantID) {
                    return this.getByUserBrowsingParticipantID(browseIdentifier, userBrowsingParticipantID, Common.Enums.UserBrowsingNoteType.GroupWith)
                        .then(function (notesBuddyList) {
                        buddyListArrToPopulate.length = 0;
                        for (var i = 0, il = notesBuddyList.length; i < il; ++i) {
                            var o = {};
                            o.userBrowsingNote = notesBuddyList[i];
                            o.userBrowsingNoteID = notesBuddyList[i].userBrowsingNoteID;
                            o.note = notesBuddyList[i].note;
                            buddyListArrToPopulate.push(o);
                            o.firstName = '';
                            o.lastName = '';
                            if (o.note !== null) {
                                o.note = o.note.trim();
                                if (o.note !== '') {
                                    var sa = o.note.split('|');
                                    if (sa.length == 1) {
                                        o.lastName = o.note.split('|')[0];
                                    }
                                    else {
                                        o.firstName = o.note.split('|')[1];
                                        o.lastName = o.note.split('|')[0];
                                    }
                                }
                            }
                            else {
                                o.note = '';
                            }
                        }
                        return notesBuddyList;
                    });
                };
                UserBrowsingNoteDAO.prototype.getByUserBrowsingParticipantID = function (browseIdentifier, userBrowsingParticipantID, userBrowsingNoteTypeID) {
                    this.clearCache();
                    var query = breeze.EntityQuery
                        .from('UserBrowsingNote_Get')
                        .withParameters({
                        browseIdentifier: browseIdentifier,
                        userBrowsingParticipantID: userBrowsingParticipantID,
                        userBrowsingNoteTypeID: userBrowsingNoteTypeID
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                UserBrowsingNoteDAO.prototype.createGroupWithList = function (browseIdentifier, userBrowsingParticipantID) {
                    return this.breezeService.saveChanges(null, {
                        resourceName: 'UserBrowsingNote_CreateGroupWithList',
                        tag: {
                            browseIdentifier: browseIdentifier,
                            userBrowsingParticipantID: userBrowsingParticipantID
                        }
                    });
                };
                UserBrowsingNoteDAO.CLASS_NAME = 'UserBrowsingNoteDAO';
                return UserBrowsingNoteDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserBrowsingNoteDAO = UserBrowsingNoteDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserBrowsingResumeDAO = (function (_super) {
                __extends(UserBrowsingResumeDAO, _super);
                function UserBrowsingResumeDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserBrowsingResumeDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "UserBrowsingResume";
                    return _this;
                }
                UserBrowsingResumeDAO.prototype.getActive = function () {
                    var query = breeze.EntityQuery
                        .from("UserBrowsingResume_GetActive");
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return (data.results);
                    });
                    return result;
                };
                UserBrowsingResumeDAO.CLASS_NAME = "UserBrowsingResumeDAO";
                return UserBrowsingResumeDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserBrowsingResumeDAO = UserBrowsingResumeDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserDAO = (function (_super) {
                __extends(UserDAO, _super);
                function UserDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "User";
                    return _this;
                }
                UserDAO.prototype.getLoggedInUser = function () {
                    var query = breeze.EntityQuery
                        .from("User_GetLoggedInUser")
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserDAO.prototype.getByUserID = function (id) {
                    var query = breeze.EntityQuery
                        .from("User_GetByUserID")
                        .withParameters({
                        "userID": id
                    })
                        .take(1);
                    ;
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserDAO.hasAcctType = function (user, acctTypeMatchMask) {
                    return DataAccess.Managers.UserMgr.hasAcctType(user, acctTypeMatchMask);
                };
                UserDAO.CLASS_NAME = "UserDAO";
                return UserDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserDAO = UserDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserAddressDAO = (function (_super) {
                __extends(UserAddressDAO, _super);
                function UserAddressDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserAddressDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "UserAddress";
                    return _this;
                }
                UserAddressDAO.prototype.getActiveByUserID = function (userId) {
                    var query = breeze.EntityQuery
                        .from("UserAddress")
                        .where("userID", "==", userId)
                        .where("RecordStateID", "==", Common.Enums.RecordStateType.Active)
                        .where("ObsoleteDate", "==", null)
                        .where("EffectiveDate", "<=", new Date());
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                UserAddressDAO.prototype.getActiveByUserIdAndTypeId = function (userId, typeId) {
                    var query = breeze.EntityQuery
                        .from("UserAddress")
                        .where("userID", "==", userId)
                        .where("RecordStateID", "==", Common.Enums.RecordStateType.Active)
                        .where("ObsoleteDate", "==", null)
                        .where("EffectiveDate", "<=", new Date())
                        .where("addressTypeID", "==", typeId);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserAddressDAO.CLASS_NAME = "UserAddressDAO";
                return UserAddressDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserAddressDAO = UserAddressDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserContactMethodDAO = (function (_super) {
                __extends(UserContactMethodDAO, _super);
                function UserContactMethodDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserContactMethodDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "UserContactMethod";
                    return _this;
                }
                UserContactMethodDAO.prototype.getByID = function (id) {
                    var query = breeze.EntityQuery
                        .from("UserContactMethods")
                        .where("userContactMethodID", "==", id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserContactMethodDAO.prototype.getActiveByUserID = function (userId) {
                    var query = breeze.EntityQuery
                        .from("UserContactMethod")
                        .where("UserID", "==", userId)
                        .where("EffectiveDate", "<=", new Date())
                        .where("ObsoleteDate", "==", null)
                        .where("RecordStateID", "==", Common.Enums.RecordStateType.Active)
                        .orderBy("CreatedDate", true);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results;
                    });
                    return result;
                };
                UserContactMethodDAO.prototype.selectContactMethodsByTypeSorted = function (userContactMethods, contactMethodTypeID) {
                    var ucms = this.common.$filter('filter')(userContactMethods, { contactMethodTypeID: contactMethodTypeID });
                    if (ucms && ucms.length) {
                        return this.common.$filter('orderBy')(ucms, ['-isPrimaryNumber', '-lastUpdatedDate']);
                    }
                    else {
                        return new Array();
                    }
                };
                UserContactMethodDAO.CLASS_NAME = "UserContactMethodDAO";
                return UserContactMethodDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserContactMethodDAO = UserContactMethodDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserFormDetailDAO = (function (_super) {
                __extends(UserFormDetailDAO, _super);
                function UserFormDetailDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserFormDetailDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "UserFormDetail";
                    return _this;
                }
                UserFormDetailDAO.prototype.getByUserFormDetailID = function (id) {
                    var query = breeze.EntityQuery
                        .from("UserFormDetail_GetByID")
                        .withParameters({
                        "userFormDetailID": id
                    })
                        .take(1);
                    ;
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserFormDetailDAO.CLASS_NAME = "UserFormDetailDAO";
                return UserFormDetailDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserFormDetailDAO = UserFormDetailDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserFormInsuranceDAO = (function (_super) {
                __extends(UserFormInsuranceDAO, _super);
                function UserFormInsuranceDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserFormInsuranceDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "UserFormInsurance";
                    return _this;
                }
                UserFormInsuranceDAO.prototype.getByUserFormInsuranceID = function (id) {
                    var query = breeze.EntityQuery
                        .from("UserFormInsurances")
                        .where("userFormInsuranceID", "==", id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserFormInsuranceDAO.CLASS_NAME = "UserFormInsuranceDAO";
                return UserFormInsuranceDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserFormInsuranceDAO = UserFormInsuranceDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserTokenDAO = (function (_super) {
                __extends(UserTokenDAO, _super);
                function UserTokenDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserTokenDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "UserToken";
                    return _this;
                }
                UserTokenDAO.prototype.genTokenForUser = function (userId, sourceOrReason) {
                    var query = breeze.EntityQuery
                        .from("UserToken_GenTokenForUser")
                        .take(1)
                        .withParameters({
                        'userID': userId,
                        'sourceOrReason': sourceOrReason
                    });
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserTokenDAO.CLASS_NAME = "UserTokenDAO";
                return UserTokenDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserTokenDAO = UserTokenDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserFormMedicationDAO = (function (_super) {
                __extends(UserFormMedicationDAO, _super);
                function UserFormMedicationDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserFormMedicationDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "UserFormMedication";
                    return _this;
                }
                UserFormMedicationDAO.prototype.getByUserFormInsuranceID = function (id) {
                    var query = breeze.EntityQuery
                        .from("UserFormMedications")
                        .where("userFormMedicationID", "==", id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserFormMedicationDAO.CLASS_NAME = "UserFormMedicationDAO";
                return UserFormMedicationDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserFormMedicationDAO = UserFormMedicationDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var MedScheduleDAO = (function (_super) {
                __extends(MedScheduleDAO, _super);
                function MedScheduleDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, MedScheduleDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'MedSchedule';
                    return _this;
                }
                MedScheduleDAO.prototype.getByUserFormInsuranceID = function (id) {
                    var query = breeze.EntityQuery
                        .from('MedSchedules')
                        .where('MedScheduleID', '==', id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                MedScheduleDAO.CLASS_NAME = 'MedScheduleDAO';
                return MedScheduleDAO;
            }(DataAccess.BaseDAO));
            DataAccess.MedScheduleDAO = MedScheduleDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var UserFormImmunizationDAO = (function (_super) {
                __extends(UserFormImmunizationDAO, _super);
                function UserFormImmunizationDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, UserFormImmunizationDAO.CLASS_NAME) || this;
                    _this.entityTypeName = "UserFormImmunization";
                    return _this;
                }
                UserFormImmunizationDAO.prototype.getByID = function (id) {
                    var query = breeze.EntityQuery
                        .from("UserFormImmunizations")
                        .where("userFormImmunizationID", "==", id)
                        .take(1);
                    var result = this.entityMgr.executeQuery(query).then(function (data) {
                        return data.results[0];
                    });
                    return result;
                };
                UserFormImmunizationDAO.CLASS_NAME = "UserFormImmunizationDAO";
                return UserFormImmunizationDAO;
            }(DataAccess.BaseDAO));
            DataAccess.UserFormImmunizationDAO = UserFormImmunizationDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var WaitlistDAO = (function (_super) {
                __extends(WaitlistDAO, _super);
                function WaitlistDAO(common, breezeService, pulseContext) {
                    return _super.call(this, common, breezeService, pulseContext, WaitlistDAO.CLASS_NAME) || this;
                }
                WaitlistDAO.prototype.getByFilter = function (filter) {
                    var url = this.common.config.webApi_NonBreeze + "/Waitlist_Get";
                    var postData = filter;
                    return this.common.$http.post(url, filter, { headers: { 'Content-Type': 'application/json' } })
                        .then(function (response) {
                        var results = (response.data);
                        results.forEach(function (info) {
                            info.startDate = Pulse.Utils.JS.dateTimeStrToDateObj(info.startDate);
                            info.endDate = Pulse.Utils.JS.dateTimeStrToDateObj(info.endDate);
                            info.createdDate = Pulse.Utils.JS.dateTimeStrToDateObj(info.createdDate);
                        });
                        return results;
                    });
                };
                WaitlistDAO.CLASS_NAME = "WaitlistDAO";
                return WaitlistDAO;
            }(Common.BaseCommon));
            DataAccess.WaitlistDAO = WaitlistDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var ZoomAttendanceDAO = (function (_super) {
                __extends(ZoomAttendanceDAO, _super);
                function ZoomAttendanceDAO(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, ZoomAttendanceDAO.CLASS_NAME) || this;
                    _this.entityTypeName = 'ZoomAttendance';
                    return _this;
                }
                ZoomAttendanceDAO.prototype.getFilterTermList = function (day) {
                    var url = this.common.config.webApi_UrlRoot + "/Zoom/TodayTerms?day=" + day;
                    return this.common.$http.get(url).then(function (response) {
                        return response.data;
                    });
                };
                ZoomAttendanceDAO.prototype.getFilterCourseList = function (filter) {
                    var url = this.common.config.webApi_UrlRoot + "/Zoom/TermCourses";
                    return this.common.$http.post(url, filter).then(function (response) {
                        return response.data;
                    });
                };
                ZoomAttendanceDAO.prototype.getFilterSectionList = function (filter) {
                    var url = this.common.config.webApi_UrlRoot + '/Zoom/CourseSections';
                    return this.common.$http.post(url, filter).then(function (response) {
                        return response.data;
                    });
                };
                ZoomAttendanceDAO.prototype.getZoomAttendance = function (filter) {
                    var url = this.common.config.webApi_UrlRoot + "/Zoom/Attendance";
                    return this.common.$http.post(url, filter).then(function (response) {
                        return response.data;
                    });
                };
                ZoomAttendanceDAO.prototype.setZoomAssigned = function (workFlow) {
                    var url = this.common.config.webApi_UrlRoot + "/Zoom/AttendanceUpdate";
                    return this.common.$http.post(url, workFlow).then(function (response) {
                        return response.data;
                    });
                };
                ZoomAttendanceDAO.CLASS_NAME = 'ZoomAttendanceDAO';
                return ZoomAttendanceDAO;
            }(DataAccess.BaseDAO));
            DataAccess.ZoomAttendanceDAO = ZoomAttendanceDAO;
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Services;
            (function (Services) {
                var Decorator = Pulse.Common.ServiceTemplates.Decorator;
                var SessionAvailabilityStatus = Pulse.Common.Enums.SessionAvailabilityStatus;
                var ProgramStatusLabels = Pulse.Common.Enums.UI.ProgramStatusLabels;
                var ProductStatusTypeDecorator = (function (_super) {
                    __extends(ProductStatusTypeDecorator, _super);
                    function ProductStatusTypeDecorator() {
                        var _this = _super !== null && _super.apply(this, arguments) || this;
                        _this.programStatuses = {
                            AlmostFull: {
                                displayName: 'Near Full',
                                hasUserInteraction: true,
                                htmlClass: ProgramStatusLabels.Orange,
                            },
                            CallUs: {
                                displayName: 'Call Us',
                                hasUserInteraction: true,
                                htmlClass: ProgramStatusLabels.Blue
                            },
                            Closed: {
                                displayName: 'Closed',
                                hasUserInteraction: false,
                                htmlClass: ProgramStatusLabels.Red
                            },
                            Coming: {
                                displayName: 'Coming',
                                hasUserInteraction: false,
                                htmlClass: ProgramStatusLabels.Orange
                            },
                            NA: {
                                displayName: '',
                                hasUserInteraction: false,
                                htmlClass: ProgramStatusLabels.None
                            },
                            NoSpace: {
                                displayName: 'No Space',
                                hasUserInteraction: false,
                                htmlClass: ProgramStatusLabels.Grey
                            },
                            Open: {
                                displayName: 'Open',
                                hasUserInteraction: true,
                                htmlClass: ProgramStatusLabels.Green
                            },
                            SoldOut: {
                                displayName: 'Sold Out',
                                hasUserInteraction: false,
                                htmlClass: ProgramStatusLabels.Grey,
                                id: SessionAvailabilityStatus.SoldOut,
                            },
                            SoldOutDesktop: {
                                displayName: 'Sold Out',
                                hasUserInteraction: false,
                                htmlClass: ProgramStatusLabels.Grey,
                                id: SessionAvailabilityStatus.SoldOutDesktop,
                            },
                            Space1: {
                                displayName: '1 Left',
                                hasUserInteraction: true,
                                htmlClass: ProgramStatusLabels.Orange
                            },
                            Space2: {
                                displayName: '2 Left',
                                hasUserInteraction: true,
                                htmlClass: ProgramStatusLabels.Orange
                            },
                            Space3: {
                                displayName: '3 Left',
                                hasUserInteraction: true,
                                htmlClass: ProgramStatusLabels.Orange
                            },
                            Space4: {
                                displayName: '4 Left',
                                hasUserInteraction: true,
                                htmlClass: ProgramStatusLabels.Orange
                            },
                            Waitlist: {
                                displayName: 'Sold Out',
                                hasUserInteraction: true,
                                htmlClass: ProgramStatusLabels.Red,
                                id: SessionAvailabilityStatus.SoldOut,
                                isWaitlist: true
                            },
                        };
                        return _this;
                    }
                    ProductStatusTypeDecorator.prototype.decorate = function (subject, sessionStartDate) {
                        var partial = this.getExtension(subject, sessionStartDate);
                        return angular.merge({ id: subject, isBuyable: this.isBuyable(partial.hasUserInteraction, subject), isWaitlist: false }, partial);
                    };
                    ProductStatusTypeDecorator.prototype.isBuyable = function (hasUserInteraction, status) {
                        return hasUserInteraction
                            && !(SessionAvailabilityStatus.SoldOut === status || SessionAvailabilityStatus.CallUs === status);
                    };
                    ProductStatusTypeDecorator.prototype.getExtension = function (subject, sessionStartDate) {
                        return (this.hasStatusSoldOut(subject)
                            ? this.getSoldOutType(sessionStartDate)
                            : this.programStatuses[SessionAvailabilityStatus[subject]]);
                    };
                    ProductStatusTypeDecorator.prototype.hasStatusSoldOut = function (subject) {
                        return !this.programStatuses.hasOwnProperty(SessionAvailabilityStatus[subject])
                            || subject === SessionAvailabilityStatus.SoldOut;
                    };
                    ProductStatusTypeDecorator.prototype.getSoldOutType = function (sessionStartDate) {
                        return moment(Date.now()).isBefore(sessionStartDate)
                            ? this.programStatuses['Waitlist']
                            : this.programStatuses['SoldOut'];
                    };
                    ProductStatusTypeDecorator.registeredAs = 'ProductStatusTypeDecorator';
                    return ProductStatusTypeDecorator;
                }(Decorator));
                Services.ProductStatusTypeDecorator = ProductStatusTypeDecorator;
                Pulse.app.service(ProductStatusTypeDecorator.registeredAs, [ProductStatusTypeDecorator]);
            })(Services = DataAccess.Services || (DataAccess.Services = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Services;
            (function (Services) {
                var Decorator = Pulse.Common.ServiceTemplates.Decorator;
                var AvcCourseSessionDecorator = (function (_super) {
                    __extends(AvcCourseSessionDecorator, _super);
                    function AvcCourseSessionDecorator(programStatusTypeDecorator) {
                        var _this = _super.call(this) || this;
                        _this.programStatusDecorator = programStatusTypeDecorator;
                        return _this;
                    }
                    AvcCourseSessionDecorator.prototype.decorate = function (subject) {
                        return angular.merge({}, subject, this.getCourseSessionExtension(subject));
                    };
                    AvcCourseSessionDecorator.prototype.getCourseSessionExtension = function (subject) {
                        return {
                            inCartCount: 0,
                            inWaitlist: false,
                            statusOptions: this.programStatusDecorator.decorate(subject.programStatusTypeID, subject.startDate),
                        };
                    };
                    AvcCourseSessionDecorator.registeredAs = 'CourseSessionDecorator';
                    return AvcCourseSessionDecorator;
                }(Decorator));
                Services.AvcCourseSessionDecorator = AvcCourseSessionDecorator;
                Pulse.app.service(AvcCourseSessionDecorator.registeredAs, [
                    Services.ProductStatusTypeDecorator.registeredAs,
                    AvcCourseSessionDecorator
                ]);
            })(Services = DataAccess.Services || (DataAccess.Services = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Services;
            (function (Services) {
                var Decorator = Pulse.Common.ServiceTemplates.Decorator;
                var AvcCourseDecorator = (function (_super) {
                    __extends(AvcCourseDecorator, _super);
                    function AvcCourseDecorator(sessionDecorator, sessionPriceDiscountService) {
                        var _this = _super.call(this) || this;
                        _this.sessionDecorator = sessionDecorator;
                        _this.sessDiscountService = sessionPriceDiscountService;
                        return _this;
                    }
                    AvcCourseDecorator.prototype.decorate = function (subject, genericGenres) {
                        return angular.merge({ genres: this.getCourseGenres(genericGenres, subject) }, subject, this.getCourseExtensionProperties(subject));
                    };
                    AvcCourseDecorator.prototype.getCourseExtensionProperties = function (subject) {
                        var _this = this;
                        var sessions = [];
                        var startingAt;
                        var buyableStartingAt;
                        var hasBuyableSessions = false;
                        subject.sessions.forEach(function (session) {
                            var extSession = _this.sessionDecorator.decorate(session);
                            sessions.push(extSession);
                            if (extSession.hasCourse) {
                                var sessionPrice = _this.sessDiscountService.getSessionPrice(extSession, subject.locationPrice);
                                startingAt = _this.minOfOrSecond(startingAt, sessionPrice);
                                if (extSession.statusOptions.isBuyable) {
                                    hasBuyableSessions = true;
                                    buyableStartingAt = _this.minOfOrSecond(buyableStartingAt, sessionPrice);
                                }
                            }
                        });
                        startingAt = buyableStartingAt !== undefined ? buyableStartingAt : startingAt;
                        return { hasBuyableSessions: hasBuyableSessions, sessions: sessions, startingAt: startingAt };
                    };
                    AvcCourseDecorator.prototype.getCourseGenres = function (genericGenres, subject) {
                        return genericGenres.filter(function (genre) { return subject.genreIDs.indexOf(genre.iD) !== -1; });
                    };
                    AvcCourseDecorator.prototype.minOfOrSecond = function (a, b) {
                        return a !== undefined ? Math.min(a, b) : b;
                    };
                    AvcCourseDecorator.registeredAs = 'AvcCourseDecorator';
                    return AvcCourseDecorator;
                }(Decorator));
                Services.AvcCourseDecorator = AvcCourseDecorator;
                Pulse.app.service(AvcCourseDecorator.registeredAs, [
                    Services.AvcCourseSessionDecorator.registeredAs,
                    'SessionPriceDiscountService',
                    AvcCourseDecorator
                ]);
            })(Services = DataAccess.Services || (DataAccess.Services = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Services;
            (function (Services) {
                var Decorator = Pulse.Common.ServiceTemplates.Decorator;
                var AvcTermDivisionDecorator = (function (_super) {
                    __extends(AvcTermDivisionDecorator, _super);
                    function AvcTermDivisionDecorator(courseDecorator) {
                        var _this = _super.call(this) || this;
                        _this.courseDecorator = courseDecorator;
                        return _this;
                    }
                    AvcTermDivisionDecorator.prototype.decorate = function (subject, genericDivisions, genericGenres, divisionExperiences, availableCourses) {
                        return angular.merge({}, subject, this.getTermDivisionExtension(subject, genericDivisions, genericGenres, divisionExperiences, availableCourses));
                    };
                    AvcTermDivisionDecorator.prototype.getTermDivisionExtension = function (subject, genericDivisions, genericGenres, divisionExperiences, availableCourses) {
                        return angular.merge(this.getExtensionFromGenericDivision(subject, genericDivisions), { experienceDescription: this.getExperienceDescription(subject, divisionExperiences) }, this.getCoursesAndPropsExtension(availableCourses, genericGenres));
                    };
                    AvcTermDivisionDecorator.prototype.getExperienceDescription = function (division, divisionExperiences) {
                        var expDesc = divisionExperiences
                            .filter(function (exp) { return division.divID === exp.divID; })
                            .map(function (exp) { return exp.desc; })
                            .shift();
                        return expDesc || 'No description!';
                    };
                    AvcTermDivisionDecorator.prototype.getExtensionFromGenericDivision = function (subject, genericDivisions) {
                        var _this = this;
                        var genericDiv = genericDivisions
                            .filter(function (genericDivision) { return subject.divID === genericDivision.iD; })
                            .map(function (genericDivision) { return _this.mapLookupDivision(subject, genericDivision); })
                            .shift();
                        return genericDiv ? genericDiv : {};
                    };
                    AvcTermDivisionDecorator.prototype.mapLookupDivision = function (subject, lookupDivision) {
                        return {
                            daysPerSession: subject.daysPerSession || lookupDivision.daysPerSes,
                            name: lookupDivision.name,
                            studentGenderType: lookupDivision.studGenType
                        };
                    };
                    AvcTermDivisionDecorator.prototype.getCoursesAndPropsExtension = function (rawCourses, genericGenres) {
                        var _this = this;
                        var courses = [];
                        var minCoursePrice;
                        var minBuyableCoursePrice;
                        var currencyTypeID;
                        var skillLevels = [];
                        rawCourses.forEach(function (course) {
                            skillLevels = _this.extendUniqueSkillLevels(skillLevels, course.skillLevels);
                            var extCourse = _this.courseDecorator.decorate(course, genericGenres);
                            courses.push(extCourse);
                            currencyTypeID = _this.minOfOrSecond(minCoursePrice, extCourse.startingAt) != minCoursePrice ? course.currencyTypeID : currencyTypeID;
                            minCoursePrice = _this.minOfOrSecond(minCoursePrice, extCourse.startingAt);
                            if (extCourse.hasBuyableSessions) {
                                minBuyableCoursePrice = _this.minOfOrSecond(minBuyableCoursePrice, extCourse.startingAt);
                            }
                        });
                        minCoursePrice = minBuyableCoursePrice !== undefined ? minBuyableCoursePrice : minCoursePrice;
                        return { courses: courses, minCoursePrice: minCoursePrice, skillLevels: skillLevels, currencyTypeID: currencyTypeID };
                    };
                    AvcTermDivisionDecorator.prototype.minOfOrSecond = function (a, b) {
                        return a !== undefined ? Math.min(a, b) : b;
                    };
                    AvcTermDivisionDecorator.prototype.extendUniqueSkillLevels = function (currentSkillLevels, newSkillLevels) {
                        var skillLevels = angular.copy(currentSkillLevels);
                        var currentSkillsIds = currentSkillLevels
                            .map(function (skill) { return skill.skillID; });
                        newSkillLevels.forEach(function (skill) {
                            if (currentSkillsIds.indexOf(skill.skillID)) {
                                skillLevels.push(skill);
                            }
                        });
                        return skillLevels;
                    };
                    AvcTermDivisionDecorator.registeredAs = 'AvcTermDivisionDecorator';
                    return AvcTermDivisionDecorator;
                }(Decorator));
                Services.AvcTermDivisionDecorator = AvcTermDivisionDecorator;
                Pulse.app.service(AvcTermDivisionDecorator.registeredAs, [
                    Services.AvcCourseDecorator.registeredAs,
                    AvcTermDivisionDecorator
                ]);
            })(Services = DataAccess.Services || (DataAccess.Services = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Services;
            (function (Services) {
                var Decorator = Pulse.Common.ServiceTemplates.Decorator;
                var ProductCategoryType = Pulse.Common.Enums.ProductCategoryType;
                var AvcProductDecorator = (function (_super) {
                    __extends(AvcProductDecorator, _super);
                    function AvcProductDecorator($q, ageMgr) {
                        var _this = _super.call(this) || this;
                        _this.$q = $q;
                        _this.ageMgr = ageMgr;
                        return _this;
                    }
                    AvcProductDecorator.prototype.decorate = function (subject, division, course, session) {
                        var _this = this;
                        var commonProps = this.getCommonProps(division, session, course, subject);
                        var promises = [];
                        promises.push(this.buildMainProduct(subject, commonProps));
                        if (subject.primaryOption && this.isPrimaryOptionAvailable(subject)) {
                            this.adjustPrimaryOptionAgeInterval(subject);
                            promises.push(this.buildOptionProduct(subject, commonProps));
                        }
                        return this.$q.all(promises)
                            .then(function (finalProducts) {
                            var optionAgeDatesQuery = [];
                            finalProducts.forEach(function (p) {
                                if (p.options && angular.isArray(p.options)) {
                                    p.options.forEach(function (o) {
                                        if (o.productCategoryTypeID === ProductCategoryType.Residency) {
                                            optionAgeDatesQuery.push(_this.appendBirthDateValidRange(o, p));
                                        }
                                    });
                                }
                            });
                            return _this.$q.all(optionAgeDatesQuery)
                                .then(function () {
                                return {
                                    mainProduct: finalProducts.shift(),
                                    optionProduct: finalProducts.shift(),
                                };
                            });
                        });
                    };
                    AvcProductDecorator.prototype.getCommonProps = function (division, session, course, subject) {
                        return angular.merge(this.getDivisionMappedProps(division, session), this.getCourseMappedProps(course), this.getSessionMappedProps(session), this.getOtherMappedProps(subject));
                    };
                    AvcProductDecorator.prototype.isPrimaryOptionAvailable = function (products) {
                        return products.primaryOption
                            && !(products.primaryOption.maxAge && products.mainProduct.minAge > products.primaryOption.maxAge
                                || products.primaryOption.minAge && products.mainProduct.maxAge < products.primaryOption.minAge);
                    };
                    AvcProductDecorator.prototype.adjustPrimaryOptionAgeInterval = function (products) {
                        products.primaryOption.minAge = Math.max(products.mainProduct.minAge, products.primaryOption.minAge);
                        products.primaryOption.maxAge = Math.min(products.mainProduct.maxAge, products.primaryOption.maxAge);
                    };
                    AvcProductDecorator.prototype.buildMainProduct = function (program, commonProps) {
                        var product = angular.merge(this.getProductInfoMappedProps(program.mainProduct), commonProps);
                        return this.appendBirthDateValidRange(product, product);
                    };
                    AvcProductDecorator.prototype.buildOptionProduct = function (program, commonProps) {
                        var optionProduct = program.primaryOption;
                        var mainProduct = program.mainProduct;
                        var product = angular.merge(this.getProductInfoMappedProps(optionProduct), commonProps, {
                            locationPrice: commonProps.locationPrice + optionProduct.price,
                            price: mainProduct.price + optionProduct.price,
                        });
                        return this.appendBirthDateValidRange(product, product);
                    };
                    AvcProductDecorator.prototype.getDivisionMappedProps = function (division, session) {
                        var termSession = division.sessions
                            .filter(function (locSession) { return locSession.sessID === session.sessID; })
                            .shift();
                        return {
                            ageRangeID: division.ageRangeID,
                            alerts: termSession ? angular.copy(termSession.alerts) : [],
                            daysPerSession: division.daysPerSession,
                            divisionID: division.divID,
                            locationID: division.locID,
                            termID: division.termID,
                        };
                    };
                    AvcProductDecorator.prototype.getCourseMappedProps = function (course) {
                        return {
                            courseProdID: course.prodID,
                            courseCatalogTypeID: course.catalogTypeID,
                            locationPrice: course.locationPrice,
                            name: course.name,
                            prerequisities: course.prerequisities,
                            skillLevels: course.skillLevels ? angular.copy(course.skillLevels) : [],
                        };
                    };
                    AvcProductDecorator.prototype.getSessionMappedProps = function (session) {
                        return {
                            highlightPriceReductions: session.highlightPriceReductions,
                            locSessID: session.locationSessionID,
                            programStatus: session.programStatus,
                            programStatusTypeID: session.programStatusTypeID,
                            sessionEnd: session.endDate,
                            sessionID: session.sessID,
                            sessionStart: session.startDate,
                            statusOptions: session.statusOptions,
                            alertNote: session.alertNote
                        };
                    };
                    AvcProductDecorator.prototype.getProductInfoMappedProps = function (productInfo) {
                        return {
                            description: productInfo.description,
                            activityDesc: productInfo.activityDesc,
                            takeHomeDesc: productInfo.takeHomeDesc,
                            toolsUsed: productInfo.toolsUsed,
                            endDateTime: productInfo.endDateTime,
                            headline: productInfo.headline,
                            isONPackage: productInfo.isONPackage,
                            maximumAge: productInfo.maxAge,
                            minimumAge: productInfo.minAge,
                            options: this.getOptions(productInfo),
                            price: productInfo.price,
                            currencyTypeID: productInfo.currencyTypeID,
                            productID: productInfo.prodID,
                            scheduleDescriptor: productInfo.schedule,
                            sessionProductDetailID: productInfo.spdID,
                            startDateTime: productInfo.startDateTime,
                        };
                    };
                    AvcProductDecorator.prototype.getOptions = function (productInfo) {
                        var options = [];
                        if (Array.isArray(productInfo.options)) {
                            options = angular.copy(productInfo.options
                                .filter(function (option) {
                                return !option.minAge && !option.maxAge
                                    || !(option.minAge > productInfo.maxAge || option.maxAge < productInfo.minAge);
                            }));
                        }
                        return options;
                    };
                    AvcProductDecorator.prototype.getOtherMappedProps = function (program) {
                        return {
                            catalogTypeID: Common.Enums.SalesCatalogType.StandardCamp,
                            programTypeID: program.programTypeID,
                            currencyTypeID: program.mainProduct.currencyTypeID,
                            scheduleDefID: -1,
                        };
                    };
                    AvcProductDecorator.prototype.appendBirthDateValidRange = function (product, baseProduct) {
                        var prodId = product.productID || product.productID === 0
                            ? product.productID
                            : product.prodID;
                        return this.$q.all([
                            this.getBirthDate(prodId, baseProduct, true),
                            this.getBirthDate(prodId, baseProduct, false),
                        ])
                            .then(function (res) {
                            return angular.merge(product, { minDateForAgeCheck: res.shift(), maxDateForAgeCheck: res.shift() });
                        });
                    };
                    AvcProductDecorator.prototype.getBirthDate = function (productId, baseProduct, isMinDate) {
                        return this.ageMgr.calculateDivCourseMinMaxAgeCheckDate(productId, baseProduct.locationID, baseProduct.sessionID, baseProduct.scheduleDefID, baseProduct.catalogTypeID, isMinDate);
                    };
                    AvcProductDecorator.registeredAs = 'AvcProductDecorator';
                    return AvcProductDecorator;
                }(Decorator));
                Services.AvcProductDecorator = AvcProductDecorator;
                Pulse.app.service(AvcProductDecorator.registeredAs, ['$q', 'AgeMgr', AvcProductDecorator]);
            })(Services = DataAccess.Services || (DataAccess.Services = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Services;
            (function (Services) {
                var SessionPriceDiscountService = (function () {
                    function SessionPriceDiscountService() {
                    }
                    SessionPriceDiscountService.prototype.getSessionPrice = function (session, locationPrice) {
                        return session.price;
                    };
                    SessionPriceDiscountService.prototype.getSessionDiscount = function (session, locationPrice) {
                        return this.hasDiscount(session, locationPrice) ? locationPrice - session.price : 0;
                    };
                    SessionPriceDiscountService.prototype.hasDiscount = function (session, locationPrice) {
                        return this.hasPromoLogicEnabled(session) && this.hasNotBeenFilled(session) && locationPrice > session.price;
                    };
                    SessionPriceDiscountService.prototype.hasNotBeenFilled = function (session) {
                        return session.statusOptions.hasUserInteraction && !session.statusOptions.isWaitlist;
                    };
                    SessionPriceDiscountService.prototype.hasPromoLogicEnabled = function (session) {
                        if (!session)
                            return false;
                        return session.highlightPriceReductions || session.highlightPriceReductions === null;
                    };
                    SessionPriceDiscountService.registeredAs = 'SessionPriceDiscountService';
                    return SessionPriceDiscountService;
                }());
                Pulse.app.service(SessionPriceDiscountService.registeredAs, SessionPriceDiscountService);
            })(Services = DataAccess.Services || (DataAccess.Services = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var BaseMgr = (function (_super) {
                    __extends(BaseMgr, _super);
                    function BaseMgr(common, breezeService, pulseContext, loggingId) {
                        var _this = _super.call(this, common, breezeService, pulseContext, loggingId) || this;
                        _this.entityMgr = breezeService.getEntityManager();
                        return _this;
                    }
                    return BaseMgr;
                }(Pulse.Common.BaseCommon));
                Managers.BaseMgr = BaseMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var LookupInfoMgr = (function (_super) {
                    __extends(LookupInfoMgr, _super);
                    function LookupInfoMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, LookupInfoMgr.CLASS_NAME) || this;
                        _this._dateInContext = null;
                        _this.typeInfos = {};
                        _this.typeInfosReleased = {};
                        _this.divisionTexts = {};
                        _this._dateInContext = dateInContext;
                        return _this;
                    }
                    LookupInfoMgr.prototype.loadReleasedTypeInfo = function (typeClassType, refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var _self = this;
                        var defer = this.common.$q.defer();
                        if (refreshCache || !(_self.typeInfos[typeClassType])) {
                            var pulseTypeDAO = new DataAccess.PulseTypeDAO(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            return pulseTypeDAO.getActiveAndReleasedByTypeClassId(typeClassType, true, refreshCache)
                                .then(function (data) {
                                _self.typeInfosReleased[typeClassType] = data;
                                return data;
                            });
                        }
                        else {
                            defer.resolve(this.typeInfosReleased[typeClassType]);
                        }
                        return defer.promise;
                    };
                    LookupInfoMgr.prototype.loadTypeInfo = function (typeClassType, refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var _self = this;
                        var defer = this.common.$q.defer();
                        if (refreshCache || !(_self.typeInfos[typeClassType])) {
                            var pulseTypeDAO = new DataAccess.PulseTypeDAO(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            return pulseTypeDAO.getActiveByTypeClassId(typeClassType, true, refreshCache)
                                .then(function (data) {
                                _self.typeInfos[typeClassType] = data;
                                return data;
                            });
                        }
                        else {
                            defer.resolve(this.typeInfos[typeClassType]);
                        }
                        return defer.promise;
                    };
                    LookupInfoMgr.prototype.loadChildTypesOfParentTypeId = function (parentTypeId, childTypeClassType, refreshCache) {
                        if (childTypeClassType === void 0) { childTypeClassType = null; }
                        if (refreshCache === void 0) { refreshCache = false; }
                        var _self = this;
                        var defer = this.common.$q.defer();
                        var cacheKey = parentTypeId + '#' + childTypeClassType;
                        if (refreshCache || !(_self.typeInfos[cacheKey])) {
                            var pulseTypeDAO = new DataAccess.PulseTypeDAO(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            return pulseTypeDAO.getActiveByParentTypeId(parentTypeId, childTypeClassType, true, refreshCache)
                                .then(function (data) {
                                _self.typeInfos[cacheKey] = data;
                                return data;
                            });
                        }
                        else {
                            defer.resolve(this.typeInfos[cacheKey]);
                        }
                        return defer.promise;
                    };
                    LookupInfoMgr.prototype.filterTypesByTypeId = function (types, typeId) {
                        if (angular.isUndefined(types) || !angular.isArray(types)) {
                            return undefined;
                        }
                        var filteredTypes = types.filter(function (t) {
                            return t.typeID === typeId;
                        });
                        if (filteredTypes.length > 1) {
                            this.logWarning("More than one matching type found. The first matching type will be returned.");
                        }
                        return filteredTypes[0];
                    };
                    LookupInfoMgr.prototype.loadDivisionInfo = function () {
                        var _self = this;
                        var defer = this.common.$q.defer();
                        if (!(_self.divisionInfos)) {
                            var divDAO = new DataAccess.DivisionDAO(this.common, this.breezeService, this.pulseContext);
                            return divDAO.getReleasedAndActive()
                                .then(function (data) {
                                return _self.divisionInfos = data;
                            });
                        }
                        else {
                            defer.resolve(this.divisionInfos);
                        }
                        return defer.promise;
                    };
                    LookupInfoMgr.prototype.loadDivisionTextByDivisionAndTextType = function (divisionId, divisionTextType, refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var _self = this;
                        var defer = this.common.$q.defer();
                        var cacheKey = divisionId + '#' + divisionTextType;
                        if (refreshCache || !(_self.divisionTexts[cacheKey])) {
                            var divTextDAO = new DataAccess.DivisionTextDAO(this.common, this.breezeService, this.pulseContext);
                            return divTextDAO.getByDivisionAndTextType(divisionId, divisionTextType)
                                .then(function (data) {
                                _self.divisionTexts[cacheKey] = data;
                                return data;
                            });
                        }
                        else {
                            defer.resolve(this.divisionTexts[cacheKey]);
                        }
                        return defer.promise;
                    };
                    LookupInfoMgr.CLASS_NAME = 'LookupInfoMgr';
                    return LookupInfoMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.LookupInfoMgr = LookupInfoMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var ClientFormsMgr = (function (_super) {
                    __extends(ClientFormsMgr, _super);
                    function ClientFormsMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, ClientFormsMgr.CLASS_NAME) || this;
                    }
                    ClientFormsMgr.prototype.getStudentsWithOrders = function () {
                        var url = this.common.config.webApi_NonBreeze + '/ClientForms_GetStudentsWithOrders?userID=' + this.pulseContext.actingAsUserId;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    ClientFormsMgr.prototype.getStudentFormsCurrent = function (studentUserID) {
                        var url = this.common.config.webApi_NonBreeze + '/ClientForms_GetFormsForStudent?customerUserID=' + this.pulseContext.actingAsUserId + '&studentUserID=' + studentUserID;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    ClientFormsMgr.prototype.getPastUploads = function () {
                        var url = this.common.config.webApi_NonBreeze + '/ClientForms_GetPastUploads?customerUserID=' + this.pulseContext.actingAsUserId + '&companyID=' + this.pulseContext.companyId;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    ClientFormsMgr.prototype.getStudentsWithFormsHistory = function () {
                        var url = this.common.config.webApi_NonBreeze + '/ClientForms_GetStudentsWithOrdersHistory?customerUserID=' + this.pulseContext.actingAsUserId + '&companyID=' + this.pulseContext.companyId;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    ClientFormsMgr.prototype.updateUserFormDetailStatus = function () {
                        return this.breezeService.saveChanges(null, {
                            resourceName: 'UserFormDetail_UpdateStatus',
                        });
                    };
                    ClientFormsMgr.prototype.saveClientFormUploadFile = function (fileToUpload, originalFileName, saveFileName, selectedUFDIDForUpload) {
                        var customerUserID = this.pulseContext.actingAsUserId;
                        var formData = new FormData();
                        formData.append(QueryStringUtils.FILE_NAME_UPLOADED, originalFileName);
                        formData.append(QueryStringUtils.USER_ID, JSON.stringify(customerUserID));
                        formData.append(QueryStringUtils.FILE_NAME, saveFileName);
                        formData.append(QueryStringUtils.USERFORMDETAIL_ID, JSON.stringify(selectedUFDIDForUpload));
                        formData.append('pdf', fileToUpload);
                        var webAPIUrl = Pulse.Utils.JS.combineUrls(this.common.config.webApi_NonBreeze, 'Files_SaveClientFormUploadFile');
                        return this.common.$http.post(webAPIUrl, formData, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': undefined }
                        });
                    };
                    ClientFormsMgr.prototype.loadTypeDictionary = function (types, dict) {
                        if (angular.isArray(types)) {
                            for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
                                var type = types_1[_i];
                                dict.add(type.typeID, type);
                            }
                        }
                    };
                    ClientFormsMgr.prototype.isTerminalStatus = function (statusTypeID) {
                        return false;
                    };
                    ClientFormsMgr.CLASS_NAME = 'ClientFormsMgr';
                    ClientFormsMgr.MAX_UPLOAD_FILE_SIZE_IN_BYTES = 4000 * 1024;
                    ClientFormsMgr.MAX_UPLOAD_FILE_SIZE_IN_KILOBYTES = (ClientFormsMgr.MAX_UPLOAD_FILE_SIZE_IN_BYTES / 1024);
                    ClientFormsMgr.MAX_UPLOAD_FILE_SIZE_IN_MEGABYTES = (ClientFormsMgr.MAX_UPLOAD_FILE_SIZE_IN_BYTES / (1000 * 1024));
                    return ClientFormsMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.ClientFormsMgr = ClientFormsMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var CustomerMgr = (function (_super) {
                    __extends(CustomerMgr, _super);
                    function CustomerMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, CustomerMgr.CLASS_NAME) || this;
                    }
                    CustomerMgr.prototype.getStatusAndAlerts = function (userId) {
                        var query = breeze.EntityQuery
                            .from('CustomerInfo_GetStatusAndAlerts')
                            .withParameters({ userID: userId });
                        var result = this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    CustomerMgr.prototype.getCurrentStudents = function (userId) {
                        var query = breeze.EntityQuery
                            .from('CustomerInfo_GetCurrentStudentsWithSessions')
                            .withParameters({ userID: userId });
                        var result = this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    CustomerMgr.prototype.loadStatusAndAlerts = function (refreshCache) {
                        var _this = this;
                        if (refreshCache === void 0) { refreshCache = false; }
                        return this.common.debounceAdd(CustomerMgr._LOAD_STATUS_ALERTS_DEBOUNCE_KEY, function () {
                            var promise;
                            if (_this._statusAndAlerts && !refreshCache) {
                                var deferred = _this.common.$q.defer();
                                deferred.resolve(null);
                                promise = deferred.promise;
                            }
                            else {
                                promise = _this.getStatusAndAlerts(_this.pulseContext.actingAsUserId)
                                    .then(function (data) {
                                    _this._statusMask = data[0].statusMask;
                                    data.splice(0, 1);
                                    _this._statusAndAlerts = data;
                                    angular.forEach(_this._statusAndAlerts, function (item, index) {
                                        item.url = item.url.replace('[WWW_UrlRoot]', _this.common.config.WWW_UrlRoot);
                                        if (item.shortDesc.indexOf('[Date1]') > 0) {
                                            item.shortDesc = item.shortDesc.replace('[Date1]', moment(item.date1)
                                                .format('MMMM D, YYYY'));
                                        }
                                        else if (item.shortDesc.indexOf('[Date1Ordinal]') > 0) {
                                            item.shortDesc = item.shortDesc.replace('[Date1Ordinal]', moment(item.date1)
                                                .format('MMMM Do'));
                                        }
                                        if (item.shortDesc.indexOf('[Value1]') > 0
                                            && (item.statusMask & (CustomerMgr.CustomerStatusTypeMask.HasBalanceDue | CustomerMgr.CustomerStatusTypeMask.HasBalanceOverDue)) > 0) {
                                            item.shortDesc = item.shortDesc.replace('[Value1]', _this.common.$filter('currency')(item.value1, item.currencyTypeID));
                                        }
                                    });
                                })
                                    .catch(function (reason) {
                                    _this.logError(reason);
                                });
                            }
                            return promise;
                        }, 0, true);
                    };
                    CustomerMgr.prototype.loadCurrentStudents = function () {
                        var _this = this;
                        var promise = this.getCurrentStudents(this.pulseContext.actingAsUserId)
                            .then(function (data) {
                            _this._currentStudents = data;
                        })
                            .catch(function (reason) {
                            _this.logError(reason);
                        });
                        return this.common.$q.when(promise);
                    };
                    Object.defineProperty(CustomerMgr.prototype, "currentStudents", {
                        get: function () {
                            return this._currentStudents;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CustomerMgr.prototype, "alerts", {
                        get: function () {
                            return this._statusAndAlerts;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CustomerMgr.prototype.getStudentSessions = function (studentUserID, includeAvailableOptions, timeInterval) {
                        if (includeAvailableOptions === void 0) { includeAvailableOptions = true; }
                        if (timeInterval === void 0) { timeInterval = Common.Enums.TimeInterval.Current; }
                        var query = breeze.EntityQuery
                            .from('CustomerInfo_GetStudentSessions')
                            .withParameters({
                            clientUserID: this.pulseContext.actingAsUserId,
                            studentUserID: studentUserID,
                            includeAvailableOptions: includeAvailableOptions,
                            timeInterval: timeInterval
                        });
                        var result = this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    CustomerMgr.prototype.goChangeOption = function (orderDetailId, spd_id, AVChartSectionId, locationID, destUrl) {
                        var _this = this;
                        if (locationID === void 0) { locationID = null; }
                        if (destUrl === void 0) { destUrl = null; }
                        var addLocationIDtoURL = false;
                        var shoppingCartType;
                        var regFlowStepEnum;
                        this.pulseContext.regFlowMgr.locationFinderMgr.clearAllSelected(true);
                        this.pulseContext.regFlowMgr = null;
                        shoppingCartType = Common.Enums.ShoppingCartType.ChangeOrder_OptionsOnly;
                        regFlowStepEnum = Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart;
                        this.common.toggleSpinner(true, null, null, 0);
                        var isCampAtHQ = false;
                        var shoppingCartMgr = this.pulseContext.regFlowMgr.shoppingCartMgr;
                        var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        this.pulseContext.shoppingCartType = shoppingCartType;
                        return shoppingCartMgr.createOrAddToChangeCart(this.pulseContext.browseIdentifier, shoppingCartType, this.pulseContext.actingAsUserId, orderDetailId, spd_id)
                            .then(function (isOrderDetailCampAtHQ) {
                            isCampAtHQ = isOrderDetailCampAtHQ;
                            userBrowsingMgr.clearUserBrowsingSesesion(userBrowsingMgr.currentUBSession);
                            return userBrowsingMgr.loadInfo(userBrowsingMgr.currentUBSession, false);
                        })
                            .then(function () {
                            if (!String.isNullOrWhitespace(destUrl)) {
                                if (isCampAtHQ) {
                                    var params = {};
                                    params[QueryStringUtils.CAMP_AT_HQ] = true;
                                    destUrl = QueryStringUtils.AddOrSetQSParams(destUrl, params);
                                }
                                _this.common.$location.url(destUrl);
                            }
                            else if (destUrl === null) {
                                _this.pulseContext.regFlowMgr.goToStepByEnum(regFlowStepEnum, true, '', false, isCampAtHQ);
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    CustomerMgr.prototype.goChangeCamp = function (cot, orderDetailId, AVChartSectionId, locationID, destUrl) {
                        var _this = this;
                        if (locationID === void 0) { locationID = null; }
                        if (destUrl === void 0) { destUrl = null; }
                        var addLocationIDtoURL = false;
                        var shoppingCartType;
                        var regFlowStepEnum;
                        this.pulseContext.regFlowMgr.locationFinderMgr.clearAllSelected(true);
                        switch (cot) {
                            case Common.Enums.ChangePurchasedOrderType.ChangeOptionsOnly:
                                this.pulseContext.regFlowMgr = null;
                                shoppingCartType = Common.Enums.ShoppingCartType.ChangeOrder_OptionsOnly;
                                regFlowStepEnum = Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart;
                                break;
                            case Common.Enums.ChangePurchasedOrderType.ChangeLocation:
                                shoppingCartType = Common.Enums.ShoppingCartType.ChangeOrder_Location;
                                regFlowStepEnum = Managers.RegFlowMgr.RegFlowStepEnum.Location;
                                break;
                            case Common.Enums.ChangePurchasedOrderType.ChangeCourseSession:
                                this.pulseContext.regFlowMgr.locationFinderMgr.addOrRemoveFromSelected(locationID, true, true);
                                shoppingCartType = Common.Enums.ShoppingCartType.ChangeOrder_Course;
                                regFlowStepEnum = Managers.RegFlowMgr.RegFlowStepEnum.AVChart;
                                break;
                            case Common.Enums.ChangePurchasedOrderType.ChangeSessionDate:
                                this.pulseContext.regFlowMgr.locationFinderMgr.addOrRemoveFromSelected(locationID, true, false);
                                shoppingCartType = Common.Enums.ShoppingCartType.ChangeOrder_SessionDate;
                                regFlowStepEnum = Managers.RegFlowMgr.RegFlowStepEnum.AVChart;
                                break;
                            case Common.Enums.ChangePurchasedOrderType.Cancel:
                                destUrl = Routes.MyAccount_ChangeOrder;
                                var params = {};
                                params[QueryStringUtils.COMPANY_ID] = this.common.config.companyId;
                                params[QueryStringUtils.ORDER_DETAIL_ID] = orderDetailId;
                                params[QueryStringUtils.CHANGE_ORDER_TYPE] = cot;
                                if (angular.isDefined(AVChartSectionId)) {
                                    params[QueryStringUtils.AV_CHART_SECTION_ID] = AVChartSectionId;
                                }
                                destUrl = QueryStringUtils.AddOrSetQSParams(destUrl, params);
                                this.common.$location.url(destUrl);
                                return;
                            default:
                                throw new Error(StringConst.Err_Not_Implemented);
                        }
                        this.common.toggleSpinner(true, null, null, 0);
                        var isCampAtHQ = false;
                        var shoppingCartMgr = this.pulseContext.regFlowMgr.shoppingCartMgr;
                        var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        this.pulseContext.shoppingCartType = shoppingCartType;
                        return shoppingCartMgr.createOrAddToChangeCart(this.pulseContext.browseIdentifier, shoppingCartType, this.pulseContext.actingAsUserId, orderDetailId)
                            .then(function (isOrderDetailCampAtHQ) {
                            isCampAtHQ = isOrderDetailCampAtHQ;
                            userBrowsingMgr.clearUserBrowsingSesesion(userBrowsingMgr.currentUBSession);
                            return userBrowsingMgr.loadInfo(userBrowsingMgr.currentUBSession, false);
                        })
                            .then(function () {
                            if (!String.isNullOrWhitespace(destUrl)) {
                                if (isCampAtHQ) {
                                    var params_1 = {};
                                    params_1[QueryStringUtils.CAMP_AT_HQ] = true;
                                    destUrl = QueryStringUtils.AddOrSetQSParams(destUrl, params_1);
                                }
                                _this.common.$location.url(destUrl);
                            }
                            else if (destUrl === null) {
                                _this.pulseContext.regFlowMgr.goToStepByEnum(regFlowStepEnum, true, '', false, isCampAtHQ);
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    Object.defineProperty(CustomerMgr.prototype, "hasBalance", {
                        get: function () {
                            return this.isStatus(CustomerMgr.CustomerStatusTypeMask.HasBalanceDue
                                | CustomerMgr.CustomerStatusTypeMask.HasBalanceOverDue);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CustomerMgr.prototype, "hasBalanceOverdue", {
                        get: function () {
                            return this.isStatus(CustomerMgr.CustomerStatusTypeMask.HasBalanceOverDue);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CustomerMgr.prototype, "hasReferAFriend", {
                        get: function () {
                            return this.isStatus(CustomerMgr.CustomerStatusTypeMask.HasReferAFriend);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CustomerMgr.prototype, "hasStudentLicense", {
                        get: function () {
                            return this.isStatus(CustomerMgr.CustomerStatusTypeMask.HasStudentLicense);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CustomerMgr.prototype, "hasOnlyNonUsdPurchases", {
                        get: function () {
                            return this.isStatus(CustomerMgr.CustomerStatusTypeMask.HasOnlyNonUsdPurchases);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CustomerMgr.prototype, "hasOnlyTutorOrCampAtHqProducts", {
                        get: function () {
                            return this.isStatus(CustomerMgr.CustomerStatusTypeMask.HasOnlyTutorOrCampAtHqProducts);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CustomerMgr.prototype, "hasScheduledPayment", {
                        get: function () {
                            return this.isStatus(CustomerMgr.CustomerStatusTypeMask.HasScheduledPayment);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CustomerMgr.prototype.getBalanceInfos = function () {
                        var balanceInfos = [];
                        var hasBalanceMask = (CustomerMgr.CustomerStatusTypeMask.HasBalanceDue |
                            CustomerMgr.CustomerStatusTypeMask.HasBalanceOverDue);
                        for (var key in this._statusAndAlerts) {
                            var item = this._statusAndAlerts[key];
                            if ((item.statusMask & hasBalanceMask) > 0) {
                                var balanceInfo = {
                                    balance: item.value1,
                                    dueDate: item.date1,
                                    currencyTypeID: item.currencyTypeID,
                                };
                                balanceInfos.push(balanceInfo);
                            }
                        }
                        return balanceInfos;
                    };
                    CustomerMgr.prototype.isStatus = function (maskingFlags) {
                        return (this._statusMask & maskingFlags) > 0;
                    };
                    CustomerMgr.prototype.getVouchers = function (userID) {
                        var url = this.common.config.webApi_NonBreeze + '/Coupon_GetVouchersByUserID';
                        var params = { 'userID': userID };
                        url = QueryStringUtils.AddOrSetQSParams(url, params);
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    CustomerMgr.CLASS_NAME = 'CustomerMgr';
                    CustomerMgr._LOAD_STATUS_ALERTS_DEBOUNCE_KEY = "";
                    return CustomerMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.CustomerMgr = CustomerMgr;
                (function (CustomerMgr) {
                    var CustomerStatusTypeMask;
                    (function (CustomerStatusTypeMask) {
                        CustomerStatusTypeMask[CustomerStatusTypeMask["None"] = 0] = "None";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasRegisteredParticipantsForTG"] = 1] = "HasRegisteredParticipantsForTG";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasMadePurchaseBefore"] = 2] = "HasMadePurchaseBefore";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasParticipantsIn_TechRocket"] = 4] = "HasParticipantsIn_TechRocket";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["PubRegHasNotEndedForLastSession"] = 8] = "PubRegHasNotEndedForLastSession";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasBalanceDue"] = 16] = "HasBalanceDue";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasBalanceOverDue"] = 32] = "HasBalanceOverDue";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasTAPApplication"] = 64] = "HasTAPApplication";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasReqFormDue"] = 128] = "HasReqFormDue";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasReferAFriend"] = 256] = "HasReferAFriend";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasAgreedTandC"] = 512] = "HasAgreedTandC";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasStudentLicense"] = 1024] = "HasStudentLicense";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasOnlyTutorOrCampAtHqProducts"] = 2048] = "HasOnlyTutorOrCampAtHqProducts";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasOPLSubscriptions"] = 4096] = "HasOPLSubscriptions";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasScheduledPayment"] = 8192] = "HasScheduledPayment";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasOnlyNonUsdPurchases"] = 16384] = "HasOnlyNonUsdPurchases";
                        CustomerStatusTypeMask[CustomerStatusTypeMask["HasActivePaymentPlan"] = 32768] = "HasActivePaymentPlan";
                    })(CustomerStatusTypeMask = CustomerMgr.CustomerStatusTypeMask || (CustomerMgr.CustomerStatusTypeMask = {}));
                    var DisplayItemType;
                    (function (DisplayItemType) {
                        DisplayItemType[DisplayItemType["Status"] = 1] = "Status";
                        DisplayItemType[DisplayItemType["NextSteps"] = 2] = "NextSteps";
                        DisplayItemType[DisplayItemType["FAQ"] = 3] = "FAQ";
                        DisplayItemType[DisplayItemType["Recommended"] = 4] = "Recommended";
                    })(DisplayItemType = CustomerMgr.DisplayItemType || (CustomerMgr.DisplayItemType = {}));
                    var OptionActionStatausType;
                    (function (OptionActionStatausType) {
                        OptionActionStatausType["Remove"] = "Removed";
                        OptionActionStatausType["Closed"] = "Closed";
                        OptionActionStatausType["SoldOut"] = "Sold Out";
                        OptionActionStatausType["Add"] = "Add to Cart";
                    })(OptionActionStatausType = CustomerMgr.OptionActionStatausType || (CustomerMgr.OptionActionStatausType = {}));
                })(CustomerMgr = Managers.CustomerMgr || (Managers.CustomerMgr = {}));
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var DiscountMgr = (function (_super) {
                    __extends(DiscountMgr, _super);
                    function DiscountMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, DiscountMgr.CLASS_NAME) || this;
                    }
                    DiscountMgr.prototype.loadMaxMultiSessionDiscount = function () {
                        var _this = this;
                        var discountDAO = new DataAccess.DiscountDAO(this.common, this.breezeService, this.pulseContext);
                        var promise = discountDAO.getMaxValueByDiscountTypeID(Common.Enums.DiscountType.Multisession_Sibling)
                            .then(function (data) {
                            if (data) {
                                _this.maxMultiSessionSiblingValue = data.value;
                            }
                            else {
                                _this.maxMultiSessionSiblingValue = 0;
                            }
                        }).catch(function (reason) {
                            _this.logError(reason);
                        });
                        return this.common.$q.when(promise);
                    };
                    DiscountMgr.prototype.hasEarlyAccessDiscountForNextTermGroup = function (subsidiaryCompanyID) {
                        var discountDAO = new DataAccess.DiscountDAO(this.common, this.breezeService, this.pulseContext);
                        return discountDAO.getEarlyAccessDiscountForNextTermGroup(subsidiaryCompanyID)
                            .then(function (data) {
                            if (data && data.discountID) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        });
                    };
                    DiscountMgr.CLASS_NAME = 'DiscountMgr';
                    return DiscountMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.DiscountMgr = DiscountMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var SystemMgr = (function (_super) {
                    __extends(SystemMgr, _super);
                    function SystemMgr(common, breezeService, pulseContext) {
                        var _this = _super.call(this, common, breezeService, pulseContext, SystemMgr.CLASS_NAME) || this;
                        _this._isRunningInPartnerDomain = null;
                        return _this;
                    }
                    SystemMgr.prototype.getServerDateTime = function () {
                        var query = breeze.EntityQuery
                            .from('System_GetDateTime')
                            .take(1);
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var serverDatetime = Pulse.Utils.JS.dateTimeStrToDateObj(data.results[0]);
                            return serverDatetime;
                        });
                        return result;
                    };
                    SystemMgr.prototype.getDateInContextForAvailChart = function (refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var query = breeze.EntityQuery
                            .from('System_GetDateInContextForAvailChart')
                            .withParameters({
                            'refreshCache': refreshCache
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var date = null;
                            if (data.results[0]) {
                                date = Pulse.Utils.JS.dateTimeStrToDateObj(data.results[0]);
                            }
                            return date;
                        });
                        return result;
                    };
                    SystemMgr.prototype.cacheHealthCheck = function (longTermCacheValue, shortTermCacheValue, refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var query = breeze.EntityQuery
                            .from('System_CacheHealthCheck')
                            .withParameters({
                            'longTermCacheValue': longTermCacheValue,
                            'shortTermCacheValue': shortTermCacheValue,
                            'refreshCache': refreshCache
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                            ;
                        });
                        return result;
                    };
                    SystemMgr.prototype.buildCourseVideoUrl = function (productID) {
                        var videoPlayerUrl = this.common.config.courseVideoPlayerUrl;
                        return String.format('{0}?courseID={1}&playerWidth={2}&playerHeight={3}&isMobile={4}&iframe=true&width={5}&height={6}', videoPlayerUrl, productID, SystemMgr.COURSE_VIDEO_PLAYER_WIDTH, SystemMgr.COURSE_VIDEO_PLAYER_HEIGHT, 0, (SystemMgr.COURSE_VIDEO_PLAYER_WIDTH + 30), (SystemMgr.COURSE_VIDEO_PLAYER_HEIGHT + 30));
                    };
                    SystemMgr.prototype.loadSystemInfo = function () {
                        var _this = this;
                        var promises = new Array();
                        promises.push(this.getServerDateTime()
                            .then(function (data) {
                            _this._serverDateTimeOffset = data.valueOf() - Date.now();
                        }));
                        promises.push(this.getDateInContextForAvailChart()
                            .then(function (data) {
                            _this._availChartDateInContext = data;
                        }));
                        var domainMapDAO = new DataAccess.DomainMapDAO(this.common, this.breezeService, this.pulseContext);
                        promises.push(domainMapDAO.getDomainMapForUrlHost()
                            .then(function (data) {
                            _this._domainMap = data;
                            _this.overrideConfigWithDomainMap();
                        }));
                        return this.common.$q.all(promises);
                    };
                    Object.defineProperty(SystemMgr.prototype, "serverDateTime", {
                        get: function () {
                            var serverDT = new Date(this._serverDateTimeOffset + Date.now());
                            return serverDT;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(SystemMgr.prototype, "availChartDateInContext", {
                        get: function () {
                            return this._availChartDateInContext;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(SystemMgr.prototype, "isRunningInPartnerDomain", {
                        get: function () {
                            return this._isRunningInPartnerDomain;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    SystemMgr.prototype.domainMapByTypeID = function (mappingType) {
                        var result = this._domainMap.filter(function (dm) { return dm.mappingTypeID == mappingType; });
                        return result && result.length ? result[0] : null;
                    };
                    SystemMgr.prototype.overrideConfigWithDomainMap = function () {
                        var _a;
                        if (this._isRunningInPartnerDomain === null) {
                            var targetDomain = (_a = this.domainMapByTypeID(Common.Enums.DomainMappingType.PublicDomainUrl)) === null || _a === void 0 ? void 0 : _a.targetDomain;
                            if (!String.isNullOrWhitespace(targetDomain)) {
                                if (targetDomain.toLowerCase().indexOf("http") !== 0) {
                                    targetDomain = "https://" + targetDomain;
                                }
                                this._isRunningInPartnerDomain = !Pulse.Utils.JS.isSameDomainHost(this.common.config.WWW_UrlRoot, targetDomain);
                                this.common.config.WWW_UrlRoot = targetDomain;
                            }
                            else {
                                this._isRunningInPartnerDomain = false;
                            }
                        }
                    };
                    SystemMgr.CLASS_NAME = 'SystemMgr';
                    SystemMgr.COURSE_VIDEO_PLAYER_WIDTH = 480;
                    SystemMgr.COURSE_VIDEO_PLAYER_HEIGHT = 350;
                    return SystemMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.SystemMgr = SystemMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var StatementMgr = (function (_super) {
                    __extends(StatementMgr, _super);
                    function StatementMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, StatementMgr.CLASS_NAME) || this;
                    }
                    StatementMgr.prototype.getSimplifiedStatement = function (userID, entityCompanyID, termGroupYear) {
                        if (!entityCompanyID)
                            entityCompanyID = 0;
                        if (!termGroupYear)
                            termGroupYear = 0;
                        var url = this.common.config.webApi_NonBreeze + '/UserAcct_GetSimplifiedStatement';
                        url += "?userID=" + userID + "&entityCompanyID=" + entityCompanyID + "&termGroupYear=" + termGroupYear;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var result = response.data;
                            return result;
                        });
                    };
                    StatementMgr.prototype.getSimplifiedStatementPdf = function (userID, entityCompanyID, termGroupYear) {
                        if (!entityCompanyID)
                            entityCompanyID = 0;
                        if (!termGroupYear)
                            termGroupYear = 0;
                        var url = this.common.config.webApi_NonBreeze + '/UserAcct_GetSimplifiedStatementPdf';
                        url += "?userID=" + userID + "&entityCompanyID=" + entityCompanyID + "&termGroupYear=" + termGroupYear;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' }, responseType: 'blob', })
                            .then(function (response) {
                            return response;
                        });
                    };
                    StatementMgr.registeredAs = 'StatementMgr';
                    StatementMgr.CLASS_NAME = StatementMgr.registeredAs;
                    return StatementMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.StatementMgr = StatementMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var TermStaffMgr = (function (_super) {
                    __extends(TermStaffMgr, _super);
                    function TermStaffMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, TermStaffMgr.CLASS_NAME) || this;
                    }
                    TermStaffMgr.prototype.searchClearedForSchedulingOrScheduled = function (searchText) {
                        return this.common.$http.get(this.common.config.webApi_NonBreeze + "/TermStaff_SearchClearedForSchedulingOrScheduled", {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                searchText: searchText,
                            }
                        })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    TermStaffMgr.prototype.createClientContactStaffReqLog = function (clientId, studentId, staffAssignmentId, orderDetailId) {
                        var correspondenceDAO = new DataAccess.CorrespondenceDAO(this.common, this.breezeService, this.pulseContext);
                        var dummyRecord = correspondenceDAO.Create();
                        return this.breezeService.saveChanges([dummyRecord], {
                            resourceName: 'TermStaff_CreateClientContactReqLog',
                            tag: {
                                clientId: clientId,
                                studentId: studentId,
                                staffAssignmentId: staffAssignmentId,
                                orderDetailId: orderDetailId
                            }
                        });
                    };
                    TermStaffMgr.CLASS_NAME = 'TermStaffMgr';
                    return TermStaffMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.TermStaffMgr = TermStaffMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var UserMgr = (function (_super) {
                    __extends(UserMgr, _super);
                    function UserMgr(common, breezeService, pulseContext) {
                        var _this = _super.call(this, common, breezeService, pulseContext, UserMgr.CLASS_NAME) || this;
                        _this.isMissingInfoCompleted = false;
                        return _this;
                    }
                    UserMgr.prototype.getLoggedInUserAndRoles = function () {
                        var _this = this;
                        var query = breeze.EntityQuery
                            .from('User_GetLoggedInUserAndRoles')
                            .take(1);
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var results = data.results[0];
                            if (results.user) {
                                var details = (results.user.firstName + ' ' + results.user.lastName + ' roles fetched.');
                                _this.common.logTraceToDatabase(results.user.userID, null, 'UserMgr.ts', 'getLoggedInUserAndRoles', Common.Enums.PulseErrorLogSeverityLevel.Verbose, Common.Enums.PulseErrorLogSubject.Authentication, details);
                            }
                            return results;
                        });
                        return result;
                    };
                    UserMgr.prototype.getRelatedUsersForActingUser = function (legalGuardianOnly) {
                        if (legalGuardianOnly === void 0) { legalGuardianOnly = false; }
                        var query = breeze.EntityQuery
                            .from('User_GetRelatedUsers')
                            .withParameters({
                            'primaryUserID': this.pulseContext.actingAsUserId,
                            'legalGuardianOnly': legalGuardianOnly
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var results = (data.results);
                            for (var i = 0; i < results.length; i++) {
                                var item = results[i];
                                item.dateOfBirth = moment(Pulse.Utils.JS.dateTimeStrToDateObj(item.dateOfBirth)).startOf('day').toDate();
                            }
                            return results;
                        });
                        return result;
                    };
                    UserMgr.prototype.getRelatedUserEntitiesForActingUser = function (relatedUserID, legalGuardianOnly) {
                        if (relatedUserID === void 0) { relatedUserID = null; }
                        if (legalGuardianOnly === void 0) { legalGuardianOnly = false; }
                        var query = breeze.EntityQuery
                            .from('Users_GetRelatedUserEntities')
                            .withParameters({
                            'primaryUserID': this.pulseContext.actingAsUserId,
                            'relatedUserID': relatedUserID,
                            'legalGuardianOnly': legalGuardianOnly
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var results = (data.results);
                            for (var i = 0; i < results.length; i++) {
                                var item = results[i];
                                item.dateOfBirth = moment(Pulse.Utils.JS.dateTimeStrToDateObj(item.dateOfBirth)).startOf('day').toDate();
                            }
                            return results;
                        });
                        return result;
                    };
                    UserMgr.prototype.getContactMethodsForActingAsUser = function () {
                        var ucmDAO = new DataAccess.UserContactMethodDAO(this.common, this.breezeService, this.pulseContext);
                        var self = this;
                        var promise = ucmDAO.getActiveByUserID(this.pulseContext.actingAsUserId);
                        return promise;
                    };
                    UserMgr.prototype.getAddressForActingAsUser = function () {
                        var uaDAO = new DataAccess.UserAddressDAO(this.common, this.breezeService, this.pulseContext);
                        var self = this;
                        var promise = uaDAO.getActiveByUserID(this.pulseContext.actingAsUserId);
                        return promise;
                    };
                    UserMgr.prototype.getRelatedUsersAssignedLicenses = function (termGroupID) {
                        if (termGroupID === void 0) { termGroupID = -1; }
                        var url = this.common.config.webApi_NonBreeze + '/UserLicense_GetRelatedUsersAssignedLicenses';
                        var params = { 'termGroupID': termGroupID };
                        url = QueryStringUtils.AddOrSetQSParams(url, params);
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    UserMgr.prototype.isUsernameTaken = function (username) {
                        var query = breeze.EntityQuery
                            .from('User_IsUsernameTaken')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            username: username
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                    };
                    UserMgr.prototype.isValidUsernameOr3rdPartyAuthEmail = function (usernameOr3rdPartyEmail) {
                        var query = breeze.EntityQuery
                            .from('User_IsValidUsernameOr3rdPartyAuthEmail')
                            .withParameters({
                            usernameOr3rdPartyEmail: usernameOr3rdPartyEmail
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                    };
                    UserMgr.prototype.getParticipantsForPurchasedProductAndLocationSession = function (productID, locationSessionID) {
                        return this.common.$http.get(this.common.config.webApi_NonBreeze + "/User_GetParticipantsForPurchasedProductAndLocationSession", {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                productID: productID,
                                locationSessionID: locationSessionID
                            }
                        })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    UserMgr.prototype.addPhoneNumber = function (userID, countryCode, areaCode, number, extension, contactMethodTypeID, isPrimary) {
                        var info = {};
                        info.areaCode = areaCode;
                        info.contactMethodTypeID = contactMethodTypeID;
                        info.countryCode = countryCode;
                        info.extension = extension;
                        info.isPrimaryNumber = isPrimary;
                        info.number = number;
                        info.userID = userID;
                        var url = this.common.config.webApi_NonBreeze + '/UserAcct_AddPhoneNumber';
                        var postData = info;
                        var jsonString = JSON.stringify(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    UserMgr.prototype.autoLogin = function (userId, actingAsUserId, token) {
                        var postdata = '';
                        var params = {};
                        params[UserMgr.GRANT_TYPE] = UserMgr.OauthGrantType.AutoLoginToken;
                        params[QueryStringUtils.USER_ID] = userId;
                        if (!isNaN(actingAsUserId)) {
                            params[QueryStringUtils.USER_IMPERSONATE_ID] = actingAsUserId;
                        }
                        params[QueryStringUtils.GUID] = token;
                        postdata = Pulse.jQuery.param(params, true);
                        this.common.logTraceToDatabase(userId, (actingAsUserId || null), 'UserMgr.ts', 'autoLogin', Common.Enums.PulseErrorLogSeverityLevel.Verbose, Common.Enums.PulseErrorLogSubject.Authentication, ('Calling /token with: ' + token));
                        return this.common.$http.post(this.common.config.webApi_UrlRoot + Routes.Token, postdata, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
                    };
                    UserMgr.prototype.loginWithGoogleToken = function (id_token, addNewUserIfMissing) {
                        if (addNewUserIfMissing === void 0) { addNewUserIfMissing = false; }
                        var postdata = '';
                        var params = {};
                        params[UserMgr.GRANT_TYPE] = UserMgr.OauthGrantType.Google;
                        params[QueryStringUtils.USER_TOKEN] = id_token;
                        if (addNewUserIfMissing) {
                            params[QueryStringUtils.ADD_MODE] = true;
                        }
                        postdata = Pulse.jQuery.param(params, true);
                        return this.common.$http.post(this.common.config.webApi_UrlRoot + Routes.Token, postdata, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
                    };
                    UserMgr.prototype.createPublicAccount = function (userName) {
                        var _this = this;
                        return this.breezeService.saveChanges(null, {
                            resourceName: 'User_CreatePublicAccount',
                        })
                            .then(function (response) {
                            var userDAO = new DataAccess.UserDAO(_this.common, _this.breezeService, _this.pulseContext);
                            var user = userDAO.getFromSaveResult(response)[0];
                            if (angular.isObject(user) && user.userID > 0) {
                                return _this.pulseContext.regFlowMgr.utmParamsMgr
                                    .recordEventForType(Common.Enums.UTMCreationTriggerType.CreateAccount, userName, user.userID)
                                    .then(function () { return response; });
                            }
                            else {
                                return _this.pulseContext.regFlowMgr.utmParamsMgr
                                    .recordEventForType(Common.Enums.UTMCreationTriggerType.CreateAccount, userName)
                                    .then(function () { return response; });
                            }
                        });
                    };
                    UserMgr.prototype.deleteAllUserInfo = function (userID, emailAddress) {
                        if (emailAddress === void 0) { emailAddress = null; }
                        var url = this.common.config.webApi_NonBreeze + '/UserAcct_DeleteAllUserInfo';
                        var jsonString = JSON.stringify({
                            'userID': userID,
                            'emailAddress': emailAddress
                        });
                        return this.common.$http.post(url, jsonString, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    UserMgr.prototype.forgotPWRetrieval = function (emailOrUsername, captchaResponse) {
                        var url = this.common.config.webApi_NonBreeze + '/User_ForgotPWRetrieval';
                        var postData = {
                            'emailOrUsername': emailOrUsername,
                            'captchaResponse': captchaResponse
                        };
                        return this.common.$http.post(url, JSON.stringify(postData), { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
                            return response.data;
                        });
                    };
                    UserMgr.prototype.forgotPWValidateCode = function (userId, primaryEmail, resetCode) {
                        var url = this.common.config.webApi_NonBreeze + '/User_ForgotPWValidateResetCode';
                        var postData = {
                            'userId': userId,
                            'primaryEmail': primaryEmail,
                            'resetCode': resetCode
                        };
                        return this.common.$http.post(url, JSON.stringify(postData), { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
                            return response.data;
                        });
                    };
                    UserMgr.prototype.forgotPWUpdatePassword = function (userId, resetCode, newPassword, newPasswordConfirm) {
                        var url = this.common.config.webApi_NonBreeze + '/User_ForgotPWChangePassword';
                        var postData = {
                            'userId': userId,
                            'resetCode': resetCode,
                            'newPassword': newPassword,
                            'newPasswordCofirm': newPasswordConfirm
                        };
                        return this.common.$http.post(url, JSON.stringify(postData), { headers: { 'Content-Type': 'application/json' } }).then(function (resposne) {
                            return resposne.data;
                        });
                    };
                    UserMgr.prototype.login = function (username, password) {
                        var _this = this;
                        Routes.PulseAdmin_LicenseItemDefSearch;
                        var hashPW = Pulse.Utils.JS.toHashSHA256Base64(password);
                        var postData = { grant_type: 'password', username: username, password: hashPW };
                        var url = this.common.config.webApi_UrlRoot + Routes.Token;
                        var hasGoogleIdToken = false;
                        var googleEmail = null;
                        if (gapi.auth2) {
                            var authInst = gapi.auth2.getAuthInstance();
                            if (authInst.isSignedIn.get()) {
                                var currentGoogleUser = authInst.currentUser;
                                var basicProfile = currentGoogleUser.get().getBasicProfile();
                                googleEmail = currentGoogleUser.get().getBasicProfile().getEmail();
                                var google_id_token = currentGoogleUser ? currentGoogleUser.get().getAuthResponse().id_token : null;
                                if (!String.isNullOrWhitespace(google_id_token)) {
                                    url = QueryStringUtils.AddOrSetQSParams(url, { 'google_id_token': google_id_token });
                                    hasGoogleIdToken = true;
                                }
                            }
                        }
                        return this.common.$http({
                            method: 'POST',
                            url: url,
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            transformRequest: function (obj) {
                                var str = [];
                                for (var p in obj)
                                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                                return str.join('&');
                            },
                            data: postData
                        })
                            .then(function (response) {
                            if (googleEmail) {
                                _this.common.showSuccess("Email \"" + googleEmail + "\" has been successfully linked to your existing iD Tech account.");
                            }
                            return _this.pulseContext.regFlowMgr.utmParamsMgr
                                .recordEventForType(Common.Enums.UTMCreationTriggerType.Login, username)
                                .then(function () { return response; });
                        });
                    };
                    UserMgr.prototype.migratePublicUser = function (userName, password) {
                        var url = this.common.config.webApi_NonBreeze + "/User_MigratePublicUser";
                        var postData = {
                            'userName': userName,
                            'password': password
                        };
                        var jsonString = JSON.stringify(postData);
                        var result = this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                        return result;
                    };
                    UserMgr.prototype.isUserInformationMissing = function () {
                        if (this.isMissingInfoCompleted || !this.pulseContext.isLoggedIn || this.pulseContext.isLoggedInUserTermStaff || !this.pulseContext.actingAsUser) {
                            return false;
                        }
                        else if (String.isNullOrWhitespace(this.pulseContext.actingAsUser.firstName)
                            || String.isNullOrWhitespace(this.pulseContext.actingAsUser.lastName)
                            || !this.pulseContext.customerMgr.isStatus(DataAccess.Managers.CustomerMgr.CustomerStatusTypeMask.HasRegisteredParticipantsForTG)) {
                            return true;
                        }
                        else {
                            var ucmDAO = new DataAccess.UserContactMethodDAO(this.common, this.breezeService, this.pulseContext);
                            var cellPhones = ucmDAO.selectContactMethodsByTypeSorted(this.contactMethodsForActingAsUser, Common.Enums.ContactMethodType.CellPhone);
                            if (cellPhones.length <= 0)
                                return true;
                            return !cellPhones.some(function (p) { return !p.optOut; });
                        }
                    };
                    UserMgr.prototype.userUpdateMissingInfo = function (missingInfo) {
                        var url = this.common.config.webApi_NonBreeze + '/User_UpdateMissingInformation';
                        var postData = missingInfo;
                        var jsonString = JSON.stringify(missingInfo);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    UserMgr.prototype.getMatchingStudentCandidates = function (student) {
                        var matchingStudentCandidate = [];
                        if (angular.isArray(this.pulseContext.userMgr._relatedUsersAll)) {
                            angular.forEach(this.pulseContext.userMgr._relatedUsersAll, function (relatedStudent) {
                                if (student.genderTypeID == relatedStudent.genderTypeID
                                    && (moment(student.dateOfBirth).diff(relatedStudent.dateOfBirth, 'days') == 0)) {
                                    matchingStudentCandidate.push(relatedStudent);
                                }
                            });
                        }
                        return matchingStudentCandidate;
                    };
                    UserMgr.prototype.sendEmailToClientUser = function (emailInfo) {
                        var url = this.common.config.webApi_NonBreeze + '/Email_SendToClientUser';
                        var jsonString = JSON.stringify(emailInfo);
                        return this.common.$http.post(url, jsonString, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    UserMgr.prototype.sendEmailToTermStaffUser = function (emailInfo) {
                        var userID = this.pulseContext.actingAsUserId;
                        var url = this.common.config.webApi_NonBreeze + '/Email_SendToTermStaffUser';
                        var jsonString = JSON.stringify(emailInfo);
                        return this.common.$http.post(url, jsonString, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    UserMgr.prototype.setNewPassword = function (userID, newPassword) {
                        var url = this.common.config.webApi_NonBreeze + "/UserAcct_SetNewPassword";
                        var postData = {
                            userID: userID,
                            newPassword: newPassword
                        };
                        var jsonString = JSON.stringify(postData);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    UserMgr.prototype.updateRelatedUserForActingUser = function (userInfo) {
                        var url = this.common.config.webApi_NonBreeze + '/User_UpdatedRelatedUser';
                        var jsonString = JSON.stringify(userInfo);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    UserMgr.prototype.loadRelatedUsersForActingUser = function (refreshCache, legalGuardianOnly) {
                        var _this = this;
                        if (refreshCache === void 0) { refreshCache = false; }
                        if (legalGuardianOnly === void 0) { legalGuardianOnly = false; }
                        return this.common.debounceAdd(UserMgr._LOAD_RELATED_USERS_DEBOUNCE_KEY + refreshCache + legalGuardianOnly, function () {
                            var promise = null;
                            if (legalGuardianOnly) {
                                if (!_this._relatedUsersPGOnly || refreshCache) {
                                    var self_1 = _this;
                                    promise = _this.getRelatedUsersForActingUser(legalGuardianOnly)
                                        .then(function (data) {
                                        self_1._relatedUsersPGOnly = data;
                                        return data;
                                    });
                                }
                                else {
                                    var deferred = _this.common.$q.defer();
                                    deferred.resolve(_this._relatedUsersPGOnly);
                                    promise = deferred.promise;
                                }
                            }
                            else {
                                if (!_this._relatedUsersAll || refreshCache) {
                                    var self_2 = _this;
                                    promise = _this.getRelatedUsersForActingUser(legalGuardianOnly)
                                        .then(function (data) {
                                        self_2._relatedUsersAll = data;
                                        return data;
                                    });
                                }
                                else {
                                    var deferred = _this.common.$q.defer();
                                    deferred.resolve(_this._relatedUsersAll);
                                    promise = deferred.promise;
                                }
                            }
                            return promise;
                        }, 0, true).then(function (result) {
                            return result;
                        });
                    };
                    UserMgr.prototype.loadContactMethodsForActingUser = function (refreshCache) {
                        var _this = this;
                        if (refreshCache === void 0) { refreshCache = false; }
                        if (!this.contactMethodsForActingAsUser || refreshCache) {
                            return this.getContactMethodsForActingAsUser()
                                .then(function (data) {
                                _this.contactMethodsForActingAsUser = data;
                                return data;
                            });
                        }
                        else {
                            var deferred = this.common.$q.defer();
                            deferred.resolve(this.contactMethodsForActingAsUser);
                            return deferred.promise;
                        }
                    };
                    UserMgr.prototype.loadAddressesForActingUser = function (refreshCache) {
                        var _this = this;
                        if (refreshCache === void 0) { refreshCache = false; }
                        if (!this.addressesForActingAsUser || refreshCache) {
                            return this.getAddressForActingAsUser()
                                .then(function (uas) {
                                _this.addressesForActingAsUser = uas;
                                return uas;
                            });
                        }
                        else {
                            var deferred = this.common.$q.defer();
                            deferred.resolve(this.addressesForActingAsUser);
                            return deferred.promise;
                        }
                    };
                    UserMgr.hasAcctType = function (user, acctTypeMatchMask) {
                        return (user.acctTypeMask & acctTypeMatchMask) > 0;
                    };
                    UserMgr.prototype.isUserNameUnique = function (userId, userName) {
                        var query = breeze.EntityQuery
                            .from('User_IsUserNameUnique')
                            .withParameters({
                            'userId': userId,
                            'userName': userName
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    UserMgr.prototype.IsContactInfoCompleted = function () {
                        var query = breeze.EntityQuery
                            .from('User_IsContactInfoCompleted');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    UserMgr.prototype.updateSplashPageChoice = function (alwaysToJobAccount) {
                        var query = breeze.EntityQuery
                            .from('User_UpdateSplashPageChoice')
                            .withParameters({
                            'alwaysToJobAccount': alwaysToJobAccount
                        })
                            .take(1);
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    UserMgr.prototype.hasAnyParticipants = function () {
                        var query = breeze.EntityQuery
                            .from('User_HasAnyParticipants');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    UserMgr.registeredAs = 'UserMgr';
                    UserMgr.CLASS_NAME = UserMgr.registeredAs;
                    UserMgr.GRANT_TYPE = 'grant_type';
                    UserMgr.LegalGuardianRelationshipTypes = [
                        Common.Enums.UserRelationshipType.Guardian,
                        Common.Enums.UserRelationshipType.ParentGuardian,
                        Common.Enums.UserRelationshipType.Parent,
                    ];
                    UserMgr.LegalGardianAndManagerRelationshipTypes = __spreadArrays(UserMgr.LegalGuardianRelationshipTypes, [
                        Common.Enums.UserRelationshipType.GroupManager,
                    ]);
                    UserMgr._LOAD_RELATED_USERS_DEBOUNCE_KEY = 'loadRelatedUsersForActingUser';
                    return UserMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.UserMgr = UserMgr;
                (function (UserMgr) {
                    var OauthGrantType;
                    (function (OauthGrantType) {
                        OauthGrantType["AutoLoginToken"] = "token";
                        OauthGrantType["Google"] = "google_id_token";
                    })(OauthGrantType = UserMgr.OauthGrantType || (UserMgr.OauthGrantType = {}));
                })(UserMgr = Managers.UserMgr || (Managers.UserMgr = {}));
                Pulse.app.factory(UserMgr.registeredAs, [
                    'pulseContextService',
                    function (pulseContextService) { return pulseContextService.userMgr; },
                ]);
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var PaymentMgr = (function (_super) {
                    __extends(PaymentMgr, _super);
                    function PaymentMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this_1 = _super.call(this, common, breezeService, pulseContext, PaymentMgr.CLASS_NAME) || this;
                        _this_1._dateInContext = null;
                        _this_1._dateInContext = dateInContext;
                        return _this_1;
                    }
                    Object.defineProperty(PaymentMgr.prototype, "shoppingCartPurchaseResult", {
                        get: function () {
                            if (this._shoppingCartPurchaseResult) {
                                return this._shoppingCartPurchaseResult;
                            }
                            else {
                                this._shoppingCartPurchaseResult = this.common.localStorageService
                                    .get("ShoppingCartPurchaseResult");
                            }
                            return this._shoppingCartPurchaseResult;
                        },
                        set: function (result) {
                            this._shoppingCartPurchaseResult = result;
                            this.common.localStorageService
                                .set("ShoppingCartPurchaseResult", result);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    PaymentMgr.prototype.getBalanceDue = function (customerUserID, includeContractedPayments, removeNewPaymentPlanFees, currencyTypeID) {
                        var o = {
                            customerUserID: customerUserID, includeContractedPayments: includeContractedPayments,
                            removeNewPaymentPlanFees: removeNewPaymentPlanFees,
                            currencyTypeID: currencyTypeID
                        };
                        var jsonString = JSON.stringify(o);
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetBalanceDue";
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return (response.data);
                        });
                    };
                    PaymentMgr.prototype.getCustomerBalanceDueByCurrencyTypes = function (customerUserID) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetCustomerBalanceDueByCurrencyTypes?customerUserID=" + customerUserID;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    PaymentMgr.prototype.getCustomerCurrencyTypesForBillingInfo = function (customerUserID) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetCustomerCurrencyTypesForBillingInfo?customerUserID=" + customerUserID;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    PaymentMgr.prototype.getBillingInformation = function (customerUserID, currencyTypeID) {
                        var o = { customerUserID: customerUserID, currencyTypeID: currencyTypeID };
                        var jsonString = JSON.stringify(o);
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetBillingInformation";
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return (response.data);
                        });
                    };
                    PaymentMgr.prototype.getCyberSecureAcceptanceData = function () {
                        var jsonString = null;
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetCyberSecureAcceptanceData";
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var fields = response.data;
                            fields.is_enabled = fields.is_enabled === 'False' ? false : true;
                            return fields;
                        });
                    };
                    PaymentMgr.prototype.getCyberSecureAcceptanceToken = function (creditCardInfo, fields) {
                        if (fields.is_enabled) {
                            var o = this.validateCreditCardNumber(creditCardInfo.creditCardNumber);
                            if (o.valid) {
                                fields.card_type = o.creditCardType;
                            }
                            else {
                                var err = new Error('The credit card number is invalid.');
                                err.isForUser = true;
                                return Promise.reject(err);
                            }
                            var url_1 = fields.secure_acceptance_token_endpoint;
                            var cardExpirationMonth = creditCardInfo.expMonth.toString();
                            if (creditCardInfo.expMonth < 10) {
                                cardExpirationMonth = '0' + cardExpirationMonth;
                            }
                            var payload = {
                                keyId: fields.key_id,
                                cardInfo: {
                                    cardExpirationMonth: cardExpirationMonth,
                                    cardExpirationYear: creditCardInfo.expYear.toString(),
                                    cardNumber: creditCardInfo.creditCardNumber,
                                    cardType: fields.card_type
                                }
                            };
                            var jsonString_1 = JSON.stringify(payload);
                            var _this_2 = this;
                            return new Promise(function (resolve, reject) {
                                var req = new XMLHttpRequest();
                                req.open('POST', url_1, true);
                                req.onload = onload;
                                req.onerror = onerror;
                                req.responseType = 'json';
                                req.setRequestHeader('Accept', 'application/json');
                                req.setRequestHeader('Content-type', 'application/json');
                                function onload() {
                                    if (this.status >= 200 && this.status < 300) {
                                        var result = this.response;
                                        if (!result.token) {
                                            result = JSON.parse(result);
                                        }
                                        resolve(result);
                                    }
                                    else {
                                        var regEx_CardExpired = /Token not created as the card is expired/g;
                                        if (this.response
                                            && this.response.responseStatus
                                            && this.response.responseStatus.reason === 'VALIDATION_ERROR') {
                                            var err = new Error('The credit card number is invalid.');
                                            err.isForUser = true;
                                            reject(err);
                                        }
                                        else if (this.response
                                            && this.response.responseStatus
                                            && this.response.responseStatus.reason === 'TOKENIZATION_ERROR'
                                            && this.response.responseStatus.message.match(regEx_CardExpired)) {
                                            var err = new Error('The credit card appears to be expired, please double check the expiration date.');
                                            err.isForUser = true;
                                            reject(err);
                                        }
                                        else {
                                            var errMsg = 'Status: ' + (this.status ? this.status : 'N/A')
                                                + ' StatusText: ' + (this.statusText ? this.statusText : 'N/A');
                                            if (this.response
                                                && this.response.responseStatus
                                                && (this.response.responseStatus.reason || this.response.responseStatus.message)) {
                                                errMsg = this.response.responseStatus.reason + ' ' + this.response.responseStatus.message;
                                            }
                                            try {
                                                _this_2.recordPaymentError(creditCardInfo, errMsg);
                                            }
                                            catch (_a) { }
                                            reject(new Error(errMsg));
                                        }
                                    }
                                }
                                function onerror() {
                                    var errMsg = 'Status: ' + (this.status ? this.status : 'N/A')
                                        + ' StatusText: ' + (this.statusText ? this.statusText : 'N/A');
                                    try {
                                        _this_2.recordPaymentError(creditCardInfo, errMsg);
                                    }
                                    catch (_a) { }
                                    reject(new Error(errMsg));
                                }
                                req.send(jsonString_1);
                            });
                        }
                        else {
                            throw new Error('Cybersource secure acceptance is not enabled.');
                        }
                    };
                    PaymentMgr.prototype.getDiscountAmountForMakePayment = function (makePaymentInfo) {
                        this.shoppingCartPurchaseResult = null;
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetDiscountAmountForMakePayment";
                        var jsonString = this.stringifyPayload(makePaymentInfo);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    PaymentMgr.prototype.getMissedScheduledPaymentsInfo = function (customerUserID, currencyTypeID) {
                        var info = { userID: customerUserID, currencyTypeID: currencyTypeID };
                        var jsonString = this.stringifyPayload(info);
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetMissedScheduledPaymentsInfo";
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return (response.data);
                        });
                    };
                    PaymentMgr.prototype.getPaymentsOsBanks = function (currencyTypeID) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetPaymentsOsBanks?currencyTypeID=" + currencyTypeID;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    PaymentMgr.prototype.getPaymentsOsData = function (currencyTypeID) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetPaymentsOsData?currencyTypeID=" + currencyTypeID;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    PaymentMgr.prototype.getScheduledPaymentsInfo = function (customerUserID, currencyTypeID, shoppingCartDTO) {
                        var _this_1 = this;
                        var info = { userID: customerUserID, currencyTypeID: currencyTypeID, shoppingCartDTO: shoppingCartDTO };
                        var jsonString = this.stringifyPayload(info);
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetScheduledPaymentsInfo";
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var info = (response.data);
                            _this_1._processPaymentInfos(info.details);
                            _this_1._processMonthlyTotals(info.monthlyTotals);
                            _this_1._processMonthlyTotals(info.monthlyTotalsUnpaid);
                            return info;
                        });
                    };
                    PaymentMgr.prototype._processMonthlyTotals = function (monthlyTotals) {
                        if (monthlyTotals) {
                            for (var i = 0, il = monthlyTotals.length; i < il; ++i) {
                                var totalInfo = monthlyTotals[i];
                                if (totalInfo.paymentDueDate) {
                                    var s = totalInfo.paymentDueDate;
                                    totalInfo.paymentDueDate = new Date(s);
                                    if (totalInfo.details) {
                                        for (var j = 0, jl = totalInfo.details.length; j < jl; ++j) {
                                            var detailInfo = totalInfo.details[j];
                                            if (detailInfo.paymentDueDate) {
                                                var s2 = detailInfo.paymentDueDate;
                                                detailInfo.paymentDueDate = new Date(s2);
                                                var s3 = detailInfo.sessionStartDate;
                                                detailInfo.sessionStartDate = new Date(s3);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    };
                    PaymentMgr.prototype._processPaymentInfos = function (paymentInfos) {
                        if (paymentInfos) {
                            for (var i = 0, il = paymentInfos.length; i < il; ++i) {
                                var paymentInfo = paymentInfos[i];
                                if (paymentInfo.balanceDueDate) {
                                    var s = paymentInfo.balanceDueDate;
                                    paymentInfo.balanceDueDate = new Date(s);
                                }
                                if (paymentInfo.paymentDueInfos) {
                                    for (var j = 0, jl = paymentInfo.paymentDueInfos.length; j < jl; j++) {
                                        var paymentDueInfo = paymentInfo.paymentDueInfos[j];
                                        var s = paymentDueInfo.paymentDueDate;
                                        paymentDueInfo.paymentDueDate = new Date(s);
                                    }
                                }
                            }
                        }
                    };
                    PaymentMgr.prototype.getPaymentOptionsInfo = function (shoppingCart) {
                        var _this_1 = this;
                        if (shoppingCart.nonParticipantItems) {
                            for (var i = 0, il = shoppingCart.nonParticipantItems.length; i < il; i++) {
                                shoppingCart.nonParticipantItems[i].isSelectedKludge = shoppingCart.nonParticipantItems[i].isSelected;
                            }
                        }
                        var jsonString = this.stringifyPayload(shoppingCart);
                        var url = this.common.config.webApi_NonBreeze + "/Payment_GetPaymentOptionsInfo";
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var paymentOptionsDTO = (response.data);
                            if (paymentOptionsDTO.minBalanceDueDate) {
                                var s = paymentOptionsDTO.minBalanceDueDate;
                                paymentOptionsDTO.minBalanceDueDate = new Date(s);
                            }
                            if (paymentOptionsDTO.minDiscountPayDate) {
                                var s = paymentOptionsDTO.minDiscountPayDate;
                                paymentOptionsDTO.minDiscountPayDate = new Date(s);
                            }
                            _this_1.setParents(paymentOptionsDTO);
                            return paymentOptionsDTO;
                        });
                    };
                    PaymentMgr.prototype.changeBankTransfer = function (bankTransferInfo) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_ChangeBankTransfer";
                        var postData = bankTransferInfo;
                        var promises = new Array();
                        promises.push(this.common.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } }));
                        promises.push(this.pulseContext.refreshUserInfo());
                        return this.common.$q.all(promises);
                    };
                    PaymentMgr.prototype.changeCreditCard = function (creditCardInfo) {
                        var _this_1 = this;
                        return this.getCyberSecureAcceptanceData()
                            .then(function (response) {
                            var fields = response;
                            if (fields.is_enabled) {
                                return _this_1.getCyberSecureAcceptanceToken(creditCardInfo, fields)
                                    .then(function (response) {
                                    creditCardInfo.cofToken = response.token;
                                    creditCardInfo.creditCardNumber = response.maskedPan;
                                    creditCardInfo.creditCardTypeID =
                                        _this_1.convertCyberCreditCardTypeToPulseTypeID(response.cardType);
                                    return _this_1.changeCreditCard_Internal(creditCardInfo);
                                })
                                    .catch(function (err) {
                                    if (!err.isForUser) {
                                        return _this_1.changeCreditCard_Internal(creditCardInfo);
                                    }
                                });
                            }
                            else {
                                return _this_1.changeCreditCard_Internal(creditCardInfo);
                            }
                        });
                    };
                    PaymentMgr.prototype.changeCreditCard_Internal = function (creditCardInfo) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_ChangeCreditCard";
                        var postData = creditCardInfo;
                        var promises = new Array();
                        promises.push(this.common.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } }));
                        promises.push(this.pulseContext.refreshUserInfo());
                        return this.common.$q.all(promises);
                    };
                    PaymentMgr.prototype.makePayment = function (makePaymentInfo) {
                        this.shoppingCartPurchaseResult = null;
                        var url = this.common.config.webApi_NonBreeze + "/Payment_MakePayment";
                        var jsonString = this.stringifyPayload(makePaymentInfo);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    PaymentMgr.prototype.payMissedScheduledPayments = function (userID, currencyTypeID, amount) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_PayMissedScheduledPayments";
                        var jsonString = this.stringifyPayload({ userID: userID, currencyTypeID: currencyTypeID, amount: amount });
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    PaymentMgr.prototype.purchaseShoppingCart = function (purchaseInfo) {
                        var _this_1 = this;
                        this.populateAffiliateTrackingID(purchaseInfo);
                        this.shoppingCartPurchaseResult = null;
                        var url = this.common.config.webApi_NonBreeze + "/Payment_PurchaseShoppingCart";
                        var jsonString = this.stringifyPayload(purchaseInfo);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            _this_1.shoppingCartPurchaseResult = response.data;
                            return _this_1.shoppingCartPurchaseResult;
                        })
                            .then(function (response) {
                            return _this_1.pulseContext.regFlowMgr.utmParamsMgr.recordEventForType(Common.Enums.UTMCreationTriggerType.Purchase).then(function () { return response; });
                        });
                    };
                    PaymentMgr.prototype.recordPaymentError = function (creditCardInfo, errorMsg) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_RecordError";
                        var postData = {
                            creditCardInfo: creditCardInfo,
                            errorMsg: errorMsg
                        };
                        return this.common.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } });
                    };
                    PaymentMgr.prototype.sendRafEmail = function (rafEmailInfo) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_SendRafEmail";
                        var postData = rafEmailInfo;
                        return this.common.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } });
                    };
                    PaymentMgr.prototype.setAutoBill = function (autoBillInfo) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_SetAutoBill";
                        var postData = autoBillInfo;
                        var promises = new Array();
                        promises.push(this.common.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } }));
                        promises.push(this.pulseContext.refreshUserInfo());
                        return this.common.$q.all(promises);
                    };
                    PaymentMgr.prototype.updateScheduledPaymentSettings = function (userID, isEnrolled, autoPayDayOrdinal) {
                        var url = this.common.config.webApi_NonBreeze + "/Payment_UpdateScheduledPaymentSettings";
                        var jsonString = this.stringifyPayload({
                            userID: userID,
                            isEnrolled: isEnrolled,
                            autoPayDayOrdinal: autoPayDayOrdinal
                        });
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } });
                    };
                    PaymentMgr.prototype.validateCreditCardNumber = function (creditCardNumber) {
                        creditCardNumber = creditCardNumber.replace('-', '').replace(' ', '');
                        var regEx = /^3[47][0-9]{13}$/;
                        if (regEx.test(creditCardNumber)) {
                            return { valid: true, creditCardType: '003' };
                        }
                        regEx = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
                        if (regEx.test(creditCardNumber)) {
                            return { valid: true, creditCardType: '004' };
                        }
                        regEx = /^5[1-5][0-9]{14}$/;
                        if (regEx.test(creditCardNumber)) {
                            return { valid: true, creditCardType: '002' };
                        }
                        regEx = /^2[2-7][0-9]{14}$/;
                        if (regEx.test(creditCardNumber)) {
                            return { valid: true, creditCardType: '002' };
                        }
                        regEx = /^4[0-9]{12}(?:[0-9]{3})?$/;
                        if (regEx.test(creditCardNumber)) {
                            return { valid: true, creditCardType: '001' };
                        }
                        return { valid: false };
                    };
                    PaymentMgr.prototype.convertCyberCreditCardTypeToPulseTypeID = function (cyberCreditCardType) {
                        switch (cyberCreditCardType) {
                            case '003':
                                return Common.Enums.CreditCardType.AmericanExpress;
                            case '004':
                                return Common.Enums.CreditCardType.Discover;
                            case '002':
                                return Common.Enums.CreditCardType.Mastercard;
                            case '001':
                                return Common.Enums.CreditCardType.Visa;
                            default:
                                return 0;
                        }
                    };
                    PaymentMgr.prototype.convertPaymentsOsCardTypeToPulseTypeID = function (paymentsOsCardType) {
                        if (paymentsOsCardType) {
                            var chk = paymentsOsCardType.toLowerCase().trim();
                            switch (chk) {
                                case 'americanexpress':
                                    return Common.Enums.CreditCardType.AmericanExpress;
                                case 'discover':
                                    return Common.Enums.CreditCardType.Discover;
                                case 'mastercard':
                                    return Common.Enums.CreditCardType.Mastercard;
                                case 'visa':
                                    return Common.Enums.CreditCardType.Visa;
                                default:
                                    return 0;
                            }
                        }
                        else {
                            return 0;
                        }
                    };
                    PaymentMgr.prototype.setParents = function (paymentOptionsDTO) {
                        if (paymentOptionsDTO.paymentOptions) {
                            for (var i = 0; i < paymentOptionsDTO.paymentOptions.length; i++) {
                                paymentOptionsDTO.paymentOptions[i].parent = paymentOptionsDTO;
                            }
                        }
                    };
                    PaymentMgr.prototype.stringifyPayload = function (payload) {
                        var jsonPayload = JSON.stringify(payload, function (key, value) {
                            if (key == "parent") {
                                return undefined;
                            }
                            else if (key == "myForm") {
                                return undefined;
                            }
                            else if (key == "originalSelectedProducts") {
                                return undefined;
                            }
                            else if (key == "selectedProducts") {
                                return undefined;
                            }
                            else {
                                return value;
                            }
                        });
                        return jsonPayload;
                    };
                    PaymentMgr.prototype.populateAffiliateTrackingID = function (purchaseInfo) {
                        purchaseInfo.affiliateTrackingID = Managers.RakutenMgr.getTrackingID();
                    };
                    PaymentMgr.CLASS_NAME = "PaymentMgr";
                    return PaymentMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.PaymentMgr = PaymentMgr;
                (function (PaymentMgr) {
                    var PaymentOptionType;
                    (function (PaymentOptionType) {
                        PaymentOptionType[PaymentOptionType["PleaseSelect"] = -1] = "PleaseSelect";
                        PaymentOptionType[PaymentOptionType["Deposit"] = 0] = "Deposit";
                        PaymentOptionType[PaymentOptionType["DepositPlusInstallments"] = 1] = "DepositPlusInstallments";
                        PaymentOptionType[PaymentOptionType["Full"] = 2] = "Full";
                        PaymentOptionType[PaymentOptionType["None"] = 3] = "None";
                        PaymentOptionType[PaymentOptionType["Other"] = 4] = "Other";
                        PaymentOptionType[PaymentOptionType["Partial"] = 5] = "Partial";
                    })(PaymentOptionType = PaymentMgr.PaymentOptionType || (PaymentMgr.PaymentOptionType = {}));
                    var PaymentResultType;
                    (function (PaymentResultType) {
                        PaymentResultType[PaymentResultType["Accepted"] = 1] = "Accepted";
                        PaymentResultType[PaymentResultType["Rejected"] = 2] = "Rejected";
                        PaymentResultType[PaymentResultType["Error_CardLimitReached"] = 3] = "Error_CardLimitReached";
                        PaymentResultType[PaymentResultType["Error_Comm"] = 4] = "Error_Comm";
                        PaymentResultType[PaymentResultType["Error_CommFault"] = 5] = "Error_CommFault";
                        PaymentResultType[PaymentResultType["Error_CommTimeout"] = 6] = "Error_CommTimeout";
                        PaymentResultType[PaymentResultType["Error_CouponLimitExceeded"] = 7] = "Error_CouponLimitExceeded";
                        PaymentResultType[PaymentResultType["Error_ExpiredCard"] = 8] = "Error_ExpiredCard";
                        PaymentResultType[PaymentResultType["Error_InvalidCardNumber"] = 9] = "Error_InvalidCardNumber";
                        PaymentResultType[PaymentResultType["Error_InvalidCardType"] = 10] = "Error_InvalidCardType";
                        PaymentResultType[PaymentResultType["Error_InvalidEmailAddress"] = 11] = "Error_InvalidEmailAddress";
                        PaymentResultType[PaymentResultType["Error_InvalidVerificationNumber"] = 12] = "Error_InvalidVerificationNumber";
                        PaymentResultType[PaymentResultType["Error_InsufficientFunds"] = 13] = "Error_InsufficientFunds";
                        PaymentResultType[PaymentResultType["Error_NoOrderDetailItemsExistsForCredit"] = 14] = "Error_NoOrderDetailItemsExistsForCredit";
                        PaymentResultType[PaymentResultType["Error_NoLocationCapacity"] = 15] = "Error_NoLocationCapacity";
                        PaymentResultType[PaymentResultType["Error_NoSectionCapacity"] = 16] = "Error_NoSectionCapacity";
                        PaymentResultType[PaymentResultType["Error_OrderDoesNotExist"] = 17] = "Error_OrderDoesNotExist";
                        PaymentResultType[PaymentResultType["Error_OrderIsInactive"] = 18] = "Error_OrderIsInactive";
                        PaymentResultType[PaymentResultType["Error_PaymentAmountDoesNotMatchApplied"] = 19] = "Error_PaymentAmountDoesNotMatchApplied";
                        PaymentResultType[PaymentResultType["Error_PaymentProcessor"] = 20] = "Error_PaymentProcessor";
                        PaymentResultType[PaymentResultType["Error_RefundQueueDiffers"] = 21] = "Error_RefundQueueDiffers";
                        PaymentResultType[PaymentResultType["Error_UnexpectedError"] = 22] = "Error_UnexpectedError";
                        PaymentResultType[PaymentResultType["Uninitialized"] = 23] = "Uninitialized";
                        PaymentResultType[PaymentResultType["Error_MissingFields"] = 24] = "Error_MissingFields";
                        PaymentResultType[PaymentResultType["Error_GeneralDecline"] = 25] = "Error_GeneralDecline";
                        PaymentResultType[PaymentResultType["SMS_CodeRequired"] = 26] = "SMS_CodeRequired";
                        PaymentResultType[PaymentResultType["SMS_CodeCancelled"] = 27] = "SMS_CodeCancelled";
                        PaymentResultType[PaymentResultType["SMS_CodeResend"] = 28] = "SMS_CodeResend";
                        PaymentResultType[PaymentResultType["SMS_CodeAccepted"] = 29] = "SMS_CodeAccepted";
                        PaymentResultType[PaymentResultType["RedirectRequired"] = 30] = "RedirectRequired";
                        PaymentResultType[PaymentResultType["RedirectSucceeded"] = 31] = "RedirectSucceeded";
                    })(PaymentResultType = PaymentMgr.PaymentResultType || (PaymentMgr.PaymentResultType = {}));
                    var PaymentOption = (function () {
                        function PaymentOption(currencyTypeID, isPaymentPlan, isSelected, paymentAmount, paymentOptionTypeID, parent, $filter) {
                            this.currencyTypeID = currencyTypeID;
                            this.isPaymentPlan = isPaymentPlan;
                            this.isSelected = isSelected;
                            this.paymentAmount = paymentAmount;
                            this.paymentOptionTypeID = paymentOptionTypeID;
                            this.parent = parent;
                            this._$filter = $filter;
                        }
                        Object.defineProperty(PaymentOption.prototype, "isPaymentAmountEditable", {
                            get: function () {
                                switch (this.paymentOptionTypeID) {
                                    case PaymentMgr.PaymentOptionType.Deposit:
                                    case PaymentMgr.PaymentOptionType.DepositPlusInstallments:
                                    case PaymentMgr.PaymentOptionType.Full:
                                    case PaymentMgr.PaymentOptionType.None:
                                        return false;
                                    case PaymentMgr.PaymentOptionType.Other:
                                    case PaymentMgr.PaymentOptionType.Partial:
                                        return true;
                                }
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(PaymentOption.prototype, "name", {
                            get: function () {
                                var s = "";
                                var currency = this._$filter('currency');
                                switch (this.paymentOptionTypeID) {
                                    case PaymentMgr.PaymentOptionType.PleaseSelect:
                                        return "Please select a payment option";
                                    case PaymentMgr.PaymentOptionType.Deposit:
                                        var options = { year: '2-digit', month: 'numeric', day: 'numeric' };
                                        if (this.paymentAmount == 0) {
                                            return "No payment with balance due "
                                                + this.parent.minBalanceDueDate.toLocaleDateString('en-US', options);
                                        }
                                        else {
                                            return currency(this.paymentAmount, this.currencyTypeID, 2) + " deposit with balance due "
                                                + this.parent.minBalanceDueDate.toLocaleDateString('en-US', options);
                                        }
                                    case PaymentMgr.PaymentOptionType.DepositPlusInstallments:
                                        var parent_1 = this.parent;
                                        if (this.paymentAmount == 0 && (!parent_1.scheduledPaymentsInfo || parent_1.scheduledPaymentsInfo.details.length == 0)) {
                                            return "Pay with monthly installments";
                                        }
                                        else if (this.paymentAmount == 0 && parent_1.scheduledPaymentsInfo && parent_1.scheduledPaymentsInfo.details.length > 0) {
                                            return "Add to monthly installments";
                                        }
                                        else {
                                            return currency(this.paymentAmount, this.currencyTypeID, 2) + " due now + monthly installments";
                                        }
                                    case PaymentMgr.PaymentOptionType.Full:
                                        return "Full amount " + currency(this.paymentAmount, this.currencyTypeID, 2);
                                    case PaymentMgr.PaymentOptionType.None:
                                        return "No payment";
                                    case PaymentMgr.PaymentOptionType.Other:
                                        return "Other amount - CS";
                                    case PaymentMgr.PaymentOptionType.Partial:
                                        return "Other amount";
                                }
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(PaymentOption.prototype, "payFullDiscountMsg", {
                            get: function () {
                                if (!this.parent) {
                                    return "";
                                }
                                else {
                                    var currency = this._$filter('currency');
                                    return String.format("Must pay balance by {0} to receive {1}", currency(this.parent.payInFullDiscountTotal, this.currencyTypeID, 0), this.parent.payInFullDiscountNames);
                                }
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(PaymentOption.prototype, "paymentOptionPlaceHolder", {
                            get: function () {
                                var s = "";
                                var currency = this._$filter('currency');
                                switch (this.paymentOptionTypeID) {
                                    case PaymentMgr.PaymentOptionType.Partial:
                                        var hasDeposit = (this.parent.discountAdjustedDepositAmount > 0
                                            && this.parent.discountAdjustedDepositAmount <
                                                this.parent.balanceDue);
                                        var hasMinDueDate = this.parent.minBalanceDueDate;
                                        if (hasDeposit) {
                                            s += currency(this.parent.discountAdjustedDepositAmount, this.currencyTypeID, 0)
                                                + " or more";
                                        }
                                        break;
                                }
                                return s;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(PaymentOption.prototype, "showPayFullDiscountMsg", {
                            get: function () {
                                if (this.parent && this.parent.payInFullDiscountTotal > 0
                                    && (this.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Deposit
                                        || this.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Partial)) {
                                    return true;
                                }
                                else {
                                    return false;
                                }
                            },
                            enumerable: false,
                            configurable: true
                        });
                        PaymentOption.prototype.getPaymentOptionMsg = function (hasAtLeastOneCourse, hasOplOrVirtualCampsOnly) {
                            var s = "";
                            var currency = this._$filter('currency');
                            switch (this.paymentOptionTypeID) {
                                case PaymentMgr.PaymentOptionType.Deposit:
                                    if (this.parent.minBalanceDueDate) {
                                        s += "Balance due by "
                                            + moment(this.parent.minBalanceDueDate).format("M/D/YYYY") + ".";
                                        if (hasOplOrVirtualCampsOnly == false) {
                                            s += " All or portions of this may be non-refundable.";
                                            if (hasAtLeastOneCourse) {
                                                s += " Refer to Cancellations/Refunds below for more details.";
                                            }
                                        }
                                    }
                                    break;
                                case PaymentMgr.PaymentOptionType.Full:
                                    if (hasOplOrVirtualCampsOnly == false) {
                                        s = "*All or portions of this may be non-refundable.";
                                        if (hasAtLeastOneCourse) {
                                            s += " Refer to Cancellations/Refunds below for more details.";
                                        }
                                    }
                                    break;
                                case PaymentMgr.PaymentOptionType.None:
                                    s = "";
                                    break;
                                case PaymentMgr.PaymentOptionType.Other:
                                    s = "";
                                    break;
                                case PaymentMgr.PaymentOptionType.Partial:
                                    var hasDeposit = (this.parent.depositAmount > 0
                                        && this.parent.depositAmount <
                                            this.parent.balanceDue);
                                    var hasMinDueDate = this.parent.minBalanceDueDate;
                                    if (hasMinDueDate) {
                                        s += "Balance due by "
                                            + moment(this.parent.minBalanceDueDate).format("M/D/YYYY") + ".";
                                        if (hasOplOrVirtualCampsOnly == false) {
                                            s += " All or portions of this may be non-refundable.";
                                            if (hasAtLeastOneCourse) {
                                                s += " Refer to Cancellations/Refunds below for more details.";
                                            }
                                        }
                                    }
                                    break;
                                default:
                                    s = "";
                                    break;
                            }
                            if (this.parent && this.paymentOptionTypeID != PaymentMgr.PaymentOptionType.Full) {
                                if (this.parent.payInFullDiscountTotal > 0) {
                                    s += String.format(" *Please note, to receive the discount savings of {0}, you must pay in full", currency(this.parent.payInFullDiscountTotal, this.currencyTypeID, 0), this.parent.payInFullDiscountNames);
                                }
                            }
                            return s;
                        };
                        PaymentOption.prototype.toDTO = function () {
                            var o = {};
                            o.isPaymentPlan = this.isPaymentPlan;
                            o.isSelected = this.isSelected;
                            o.parent = this.parent;
                            o.paymentAmount = this.paymentAmount;
                            o.paymentOptionTypeID = this.paymentOptionTypeID;
                            o.monthlyPaymentDay = this.monthlyPaymentDay;
                            return o;
                        };
                        return PaymentOption;
                    }());
                    PaymentMgr.PaymentOption = PaymentOption;
                })(PaymentMgr = Managers.PaymentMgr || (Managers.PaymentMgr = {}));
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var UploadedFormsMgr = (function (_super) {
                    __extends(UploadedFormsMgr, _super);
                    function UploadedFormsMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, UploadedFormsMgr.CLASS_NAME) || this;
                    }
                    UploadedFormsMgr.prototype.getUserFormsAndUploads = function (uploadFilters) {
                        var url = this.common.config.webApi_NonBreeze + '/Forms_GetUploads';
                        return this.common.$http.post(url, uploadFilters, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            angular.forEach(results, function (upload) {
                                upload.uniqueRowID = upload.userFormDetailID.toString() + '_' + (upload.fileID || 0).toString();
                                upload.uploadedFormType = uploadFilters.uploadedFormType;
                                if (upload.fileName) {
                                    upload.fileNameFormatted = upload.fileName.replace(/\_/g, ' ').replace(/\,/g, ', ');
                                }
                                upload.hasSections = (upload.formSectionCount > 0);
                                if (upload.hasSections) {
                                    upload.sectionsPopupTitle = upload.formName + ' Sections for ' + upload.fullName;
                                }
                                upload.showSections = false;
                            });
                            return results;
                        });
                    };
                    UploadedFormsMgr.prototype.downloadFile = function (fileID) {
                        var url = this.common.config.webApi_NonBreeze + '/Forms_DownloadFile?fileID=' + fileID.toString();
                        return this.common.$http.get(url, { responseType: 'arraybuffer', headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response;
                        });
                    };
                    UploadedFormsMgr.prototype.downloadFilesZipped = function (fileIDs) {
                        var url = this.common.config.webApi_NonBreeze + '/Forms_DownloadFilesZipped';
                        return this.common.$http.get(url, {
                            headers: { 'Content-Type': 'application/json' },
                            params: {
                                'fileIDs[]': fileIDs
                            },
                            responseType: 'arraybuffer',
                            data: ''
                        })
                            .then(function (response) {
                            return response;
                        });
                    };
                    UploadedFormsMgr.prototype.loadUserFormSections = function (userID, formID) {
                        var url = this.common.config.webApi_NonBreeze + '/Forms_GetUserFormSections?userID=' + userID + '&formID=' + formID;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    UploadedFormsMgr.prototype.updateUserFormDetailStatus = function (userFormDetailID, statusTypeID) {
                        var url = this.common.config.webApi_NonBreeze + '/Forms_UpdateUserFormDetailStatus';
                        var params = {
                            userFormDetailID: userFormDetailID,
                            statusTypeID: statusTypeID
                        };
                        return this.common.$http.post(url, params)
                            .then(function (response) {
                            var masterUFDStatusTypeIDShouldBe = response.data;
                            return masterUFDStatusTypeIDShouldBe;
                        });
                    };
                    UploadedFormsMgr.prototype.updateStatusOfRedundantFormsInFASTSearchResults = function (targetUserFormDetailID, newStatusTypeID, newStatusTypeName, userFileIDAlreadyUpdated, userForms) {
                        for (var i = 0; i < userForms.length; i++) {
                            var uf = userForms[i];
                            if (uf.userFormDetailID == targetUserFormDetailID && uf.userFileID != userFileIDAlreadyUpdated) {
                                uf.statusTypeID = newStatusTypeID;
                                uf.status = newStatusTypeName;
                                uf.updatedSinceLastQuery = true;
                            }
                        }
                    };
                    UploadedFormsMgr.prototype.deleteUserFiles = function (userFileIDList) {
                        var url = this.common.config.webApi_NonBreeze + '/Forms_DeleteUserFile';
                        return this.common.$http.post(url, userFileIDList)
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    UploadedFormsMgr.CLASS_NAME = 'UploadedFormsMgr';
                    return UploadedFormsMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.UploadedFormsMgr = UploadedFormsMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var MedicAppMgr = (function (_super) {
                    __extends(MedicAppMgr, _super);
                    function MedicAppMgr(common, breezeService, pulseContext) {
                        var _this = _super.call(this, common, breezeService, pulseContext, MedicAppMgr.CLASS_NAME) || this;
                        _this.searchFormModel = new MedicAppMgr.SearchFormModel();
                        _this.restoreState();
                        return _this;
                    }
                    Object.defineProperty(MedicAppMgr, "storageStashId", {
                        get: function () {
                            return 'medicStashedStorage';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(MedicAppMgr.prototype, "stateBag", {
                        get: function () {
                            if (!angular.isObject(this._medicStateBag)) {
                                var stateObj = this.common.localStorageService.get(MedicAppMgr.MedicStatebag.stateBagId);
                                if (angular.isObject(stateObj)) {
                                    this._medicStateBag = new MedicAppMgr.MedicStatebag(this.common.localStorageService, stateObj);
                                }
                            }
                            if (!angular.isObject(this._medicStateBag)) {
                                this._medicStateBag = new MedicAppMgr.MedicStatebag(this.common.localStorageService);
                            }
                            return this._medicStateBag;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(MedicAppMgr.prototype, "currentLocation", {
                        get: function () {
                            return this._currentLocation;
                        },
                        set: function (location) {
                            this._currentLocation = location;
                            this.stateBag.currentLocationId = location.locationID;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(MedicAppMgr.prototype, "isUILocked", {
                        get: function () {
                            return this._uiLocked;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(MedicAppMgr.prototype, "allowedRoutes", {
                        get: function () {
                            return this.stateBag.allowedRoutes;
                        },
                        set: function (routes) {
                            this.stateBag.allowedRoutes = routes;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    MedicAppMgr.prototype.restoreState = function () {
                        var _this = this;
                        var authData = this.pulseContext.authData;
                        if (authData != null && authData.token != null) {
                            if (!angular.isObject(this._currentLocation) && this.stateBag.currentLocationId > 0) {
                                this.activationPromises.push(this.getLocationByID(this.stateBag.currentLocationId)
                                    .then(function (location) {
                                    _this.currentLocation = location;
                                }));
                            }
                        }
                        this._uiLocked = this.stateBag.uiIsLocked;
                    };
                    MedicAppMgr.prototype.getDivisionsForLoggedInUser = function (includeOnlyCurrentActiveAssignmentsForStaffRole, refreshCache) {
                        if (includeOnlyCurrentActiveAssignmentsForStaffRole === void 0) { includeOnlyCurrentActiveAssignmentsForStaffRole = false; }
                        if (refreshCache === void 0) { refreshCache = false; }
                        var query = breeze.EntityQuery
                            .from('Medic_GetDivisionsForCurrentLoggedInUser')
                            .withParameters({
                            termGroupID: this.pulseContext.currentTermGroup.termGroupID,
                            includeOnlyCurrentActiveAssignmentsForStaffRole: includeOnlyCurrentActiveAssignmentsForStaffRole,
                            refreshCache: refreshCache
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getLocationsForDivision = function (divisionId, currentAssignmentsOnly, useAssignmentDatesNotThresholdDates, refreshCache) {
                        if (useAssignmentDatesNotThresholdDates === void 0) { useAssignmentDatesNotThresholdDates = false; }
                        if (refreshCache === void 0) { refreshCache = false; }
                        var query = breeze.EntityQuery
                            .from('Medic_GetLocationsForDivision')
                            .withParameters({
                            divisionID: divisionId,
                            currentAssignmentsOnly: currentAssignmentsOnly,
                            useAssignmentDatesNotThresholdDates: useAssignmentDatesNotThresholdDates,
                            refreshCache: refreshCache
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getLocationByID = function (locationId) {
                        var query = breeze.EntityQuery
                            .from('Medic_GetLocation')
                            .withParameters({
                            locationID: locationId,
                        }).take(1);
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results[0];
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getSessionsForLocationAndDivision = function (locationId, divisionId, refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var query = breeze.EntityQuery
                            .from('Medic_GetSessionsForLocationAndDivision')
                            .withParameters({
                            termGroupID: this.pulseContext.currentTermGroup.termGroupID,
                            locationID: locationId,
                            divisionID: divisionId,
                            refreshCache: refreshCache
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getCoursesForLocationAndSession = function (locationId, sessionId, refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var query = breeze.EntityQuery
                            .from('Medic_GetProductsForLocationAndSession')
                            .withParameters({
                            locationID: locationId,
                            sessionID: sessionId,
                            refreshCache: refreshCache
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getFacilityLabBuildings = function (divisionId, locationId, sessionId, refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var query = breeze.EntityQuery
                            .from('Medic_GetFacilityLabBuildings')
                            .withParameters({
                            divisionID: divisionId,
                            locationID: locationId,
                            sessionID: sessionId,
                            refreshCache: refreshCache
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getAllParticipantMedicationRecords = function (divisionId, locationId, sessionId) {
                        var query = breeze.EntityQuery
                            .from('Medic_GetAllParticipantMedicationRosterRecords')
                            .withParameters({
                            divisionID: divisionId,
                            locationID: locationId,
                            sessionID: sessionId,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getParticipantMedications = function (participantId, locationId, sessionId) {
                        var query = breeze.EntityQuery
                            .from('Medic_GetParticipantMedications')
                            .withParameters({
                            participantID: participantId,
                            locationID: locationId,
                            sessionID: sessionId,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getNewParticipantMedicationForInsert = function () {
                        var query = breeze.EntityQuery
                            .from('Medic_GetNewParticipantMedicationForInsert')
                            .take(1);
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results[0];
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getParticipantMedicationRosterRecord = function (participantId) {
                        var query = breeze.EntityQuery
                            .from('Medic_GetParticipantMedicationRosterRecord')
                            .withParameters({
                            participantID: participantId,
                            smsCode: this.stateBag.smsAuthToken,
                        }).take(1);
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results[0];
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getMedicationChangesCode = function (participantId, action) {
                        var query = breeze.EntityQuery
                            .from('Medic_GetMedicationChangesCode')
                            .withParameters({
                            participantID: participantId,
                            action: action,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.getAuthTokenFromSMSCode = function (code, participantDob, isTsMode) {
                        var query = breeze.EntityQuery
                            .from('Medic_GetAuthTokenFromSMSCode')
                            .withParameters({
                            code: code,
                            participantDob: participantDob,
                            isTsMode: isTsMode || false,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.validateSMSCode = function (code) {
                        var query = breeze.EntityQuery
                            .from('Medic_ValidateSMSCode')
                            .withParameters({
                            code: code,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.confirmParticipantDateOfBirth = function (participantId, participantDob) {
                        var query = breeze.EntityQuery
                            .from('Medic_ConfirmParticipantDateOfBirth')
                            .withParameters({
                            participantID: participantId,
                            participantDob: participantDob,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.confirmUiUnlockCodeForLocation = function (locationId, passcode) {
                        var _this = this;
                        var query = breeze.EntityQuery
                            .from('Medic_UnlockUi')
                            .withParameters({
                            locationID: locationId,
                            passcode: passcode,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var result = (data.results[0]);
                            if (result.success) {
                                _this._uiLocked = false;
                                _this.stateBag.uiIsLocked = false;
                            }
                            return result;
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.sendMedicationChangesSMS = function (participantId, phoneNumber, action) {
                        var query = breeze.EntityQuery
                            .from('Medic_SendMedicationChangesSMS')
                            .withParameters({
                            participantID: participantId,
                            phoneNumber: phoneNumber,
                            action: action
                        }).take(1);
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    MedicAppMgr.prototype.updateMedicationForParticipant = function (participantId, medInfo) {
                        var url = this.common.config.webApi_UrlRoot
                            + '/pulseWebApi/Medic_UpdateMedicationForParticipant?participantID=' + participantId
                            + '&smsCode=' + this.stateBag.smsAuthToken
                            + '&anonClientName=' + this.stateBag.anonUserFullLegalName;
                        var postData = medInfo;
                        var promises = new Array();
                        promises.push(this.common.$http.post(url, angular.toJson(postData, false), {
                            headers: { 'Content-Type': 'application/json' }
                        }));
                        return this.common.$q.all(promises);
                    };
                    MedicAppMgr.prototype.addMedicationForParticipant = function (participantId, medInfo) {
                        var url = this.common.config.webApi_UrlRoot
                            + '/pulseWebApi/Medic_AddMedicationForParticipant?participantID=' + participantId
                            + '&smsCode=' + this.stateBag.smsAuthToken
                            + '&anonClientName=' + this.stateBag.anonUserFullLegalName;
                        var postData = medInfo;
                        var promises = new Array();
                        promises.push(this.common.$http.post(url, angular.toJson(postData, false), {
                            headers: { 'Content-Type': 'application/json' }
                        }));
                        return this.common.$q.all(promises);
                    };
                    MedicAppMgr.prototype.removeMedicationForParticipant = function (participantId, medInfo) {
                        var url = this.common.config.webApi_UrlRoot
                            + '/pulseWebApi/Medic_RemoveMedicationForParticipant?participantID=' + participantId
                            + '&smsCode=' + this.stateBag.smsAuthToken
                            + '&anonClientName=' + this.stateBag.anonUserFullLegalName;
                        var postData = medInfo;
                        var promises = new Array();
                        promises.push(this.common.$http.post(url, angular.toJson(postData, false), {
                            headers: { 'Content-Type': 'application/json' }
                        }));
                        return this.common.$q.all(promises);
                    };
                    MedicAppMgr.prototype.checkInMedicationForParticipant = function (participantId, userFormMedicationId, locationId, sessionId) {
                        var url = this.common.config.webApi_UrlRoot
                            + '/pulseWebApi/Medic_CheckInMedicationForParticipant?participantID=' + participantId
                            + '&userFormMedicationId=' + userFormMedicationId
                            + '&locationId=' + locationId
                            + '&sessionId=' + sessionId;
                        var promises = new Array();
                        promises.push(this.common.$http.post(url, null));
                        return this.common.$q.all(promises);
                    };
                    MedicAppMgr.prototype.checkOutMedicationForParticipant = function (participantId, userFormMedicationId, locationId, sessionId) {
                        var url = this.common.config.webApi_UrlRoot
                            + '/pulseWebApi/Medic_CheckOutMedicationForParticipant?participantID=' + participantId
                            + '&userFormMedicationId=' + userFormMedicationId
                            + '&locationId=' + locationId
                            + '&sessionId=' + sessionId;
                        var promises = new Array();
                        promises.push(this.common.$http.post(url, null));
                        return this.common.$q.all(promises);
                    };
                    MedicAppMgr.prototype.lockUI = function () {
                        this._uiLocked = true;
                        this.stateBag.uiIsLocked = true;
                    };
                    MedicAppMgr.CLASS_NAME = 'MedicAppMgr';
                    MedicAppMgr.HSF_MEDS_ONLY_ALLOWED_ROUTES = [Routes.HSF_Medications, Routes.MedicParticipantHsfEdit, Routes.HSF_Authorization, Routes.Logout];
                    return MedicAppMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.MedicAppMgr = MedicAppMgr;
                (function (MedicAppMgr) {
                    var SMSCodeAction;
                    (function (SMSCodeAction) {
                        SMSCodeAction[SMSCodeAction["MedsAddEdit"] = 1] = "MedsAddEdit";
                        SMSCodeAction[SMSCodeAction["HsfEdit"] = 2] = "HsfEdit";
                    })(SMSCodeAction = MedicAppMgr.SMSCodeAction || (MedicAppMgr.SMSCodeAction = {}));
                    var SearchFormModel = (function () {
                        function SearchFormModel() {
                            this.formStatusOption = '';
                            this.hasMedicationsOption = '';
                            this.submitted = false;
                        }
                        return SearchFormModel;
                    }());
                    MedicAppMgr.SearchFormModel = SearchFormModel;
                    var MedicStatebag = (function () {
                        function MedicStatebag(localStorageService, stateObj) {
                            if (stateObj === void 0) { stateObj = null; }
                            this._medicStateObject = {
                                _smsAuthToken: null,
                                _isTsMode: null,
                                _currentLocationId: null,
                                _uiIsLocked: false,
                                _anonUserFullLegalName: null,
                                _allowedRoutes: new Array(),
                            };
                            this.localStorageService = localStorageService;
                            if (angular.isObject(stateObj)) {
                                this._medicStateObject = stateObj;
                            }
                        }
                        Object.defineProperty(MedicStatebag.prototype, "smsAuthToken", {
                            get: function () {
                                return this._medicStateObject._smsAuthToken;
                            },
                            set: function (tokenValue) {
                                this._medicStateObject._smsAuthToken = tokenValue;
                                this.localStorageService.set(MedicStatebag.stateBagId, this._medicStateObject);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(MedicStatebag.prototype, "isTsMode", {
                            get: function () {
                                return this._medicStateObject._isTsMode;
                            },
                            set: function (value) {
                                this._medicStateObject._isTsMode = value;
                                this.localStorageService.set(MedicStatebag.stateBagId, this._medicStateObject);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(MedicStatebag.prototype, "currentLocationId", {
                            get: function () {
                                return this._medicStateObject._currentLocationId;
                            },
                            set: function (id) {
                                this._medicStateObject._currentLocationId = id;
                                this.localStorageService.set(MedicStatebag.stateBagId, this._medicStateObject);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(MedicStatebag.prototype, "uiIsLocked", {
                            get: function () {
                                return this._medicStateObject._uiIsLocked;
                            },
                            set: function (value) {
                                this._medicStateObject._uiIsLocked = value;
                                this.localStorageService.set(MedicStatebag.stateBagId, this._medicStateObject);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(MedicStatebag.prototype, "anonUserFullLegalName", {
                            get: function () {
                                return this._medicStateObject._anonUserFullLegalName;
                            },
                            set: function (value) {
                                this._medicStateObject._anonUserFullLegalName = value;
                                this.localStorageService.set(MedicStatebag.stateBagId, this._medicStateObject);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(MedicStatebag.prototype, "allowedRoutes", {
                            get: function () {
                                return this._medicStateObject._allowedRoutes;
                            },
                            set: function (routes) {
                                this._medicStateObject._allowedRoutes = routes;
                                this.localStorageService.set(MedicStatebag.stateBagId, this._medicStateObject);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        MedicStatebag.stateBagId = 'medicStateBagData';
                        return MedicStatebag;
                    }());
                    MedicAppMgr.MedicStatebag = MedicStatebag;
                })(MedicAppMgr = Managers.MedicAppMgr || (Managers.MedicAppMgr = {}));
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var AgeMgr = (function (_super) {
                    __extends(AgeMgr, _super);
                    function AgeMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, AgeMgr.CLASS_NAME) || this;
                    }
                    AgeMgr.prototype.calculateDivCourseMinMaxAgeCheckDate = function (productID, locationID, sessionID, scheduleDefID, salesCatalogType, isMinAgeCheck) {
                        if (isMinAgeCheck === void 0) { isMinAgeCheck = true; }
                        var query = breeze.EntityQuery
                            .from('Age_CalculateDivCourseMinMaxAgeCheckDate')
                            .withParameters({
                            isMinAgeCheck: isMinAgeCheck,
                            locationID: locationID,
                            productID: productID,
                            salesCatalogType: salesCatalogType,
                            scheduleDefID: scheduleDefID,
                            sessionID: sessionID,
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return Pulse.Utils.JS.dateTimeStrToDateObj(data.results[0]);
                        });
                    };
                    AgeMgr.ageAsOfDate = function (dateOfBirth, asOfDate) {
                        var DOB = moment(dateOfBirth)
                            .clone()
                            .startOf('day');
                        var AOD = moment(asOfDate)
                            .clone()
                            .startOf('day');
                        var age = AOD.year() - DOB.year();
                        if (DOB > (AOD.year(AOD.year() - age)))
                            age--;
                        return age;
                    };
                    AgeMgr.dateTurnAge = function (dateOfBirth, turnAge) {
                        var DOB = moment(dateOfBirth)
                            .clone()
                            .startOf('day');
                        DOB.add('years', turnAge);
                        return DOB.toDate();
                    };
                    AgeMgr.isParticipantTeen = function (dateOfBirth, year) {
                        return this.ageAsOfDate(dateOfBirth, new Date(year, 11, 31)) > 12;
                    };
                    AgeMgr.shiftDateByYear = function (target, years) {
                        return moment(target)
                            .add('years', years)
                            .toDate();
                    };
                    AgeMgr.isDOB_WithinAgeRangeByDateInterval = function (DOB, minAge, maxAge, minDate, maxDate) {
                        var isValid = true;
                        if (minAge > 0 && minDate) {
                            isValid = isValid && moment(DOB)
                                .isSameOrBefore(moment(minDate)
                                .subtract(minAge, 'years')
                                .endOf('day'));
                        }
                        if (maxAge > 0 && maxDate) {
                            isValid = isValid && moment(DOB)
                                .isSameOrAfter(moment(maxDate)
                                .subtract(maxAge + 1, 'year')
                                .add(1, 'day')
                                .startOf('day'));
                        }
                        return isValid;
                    };
                    AgeMgr.registerAs = 'AgeMgr';
                    AgeMgr.CLASS_NAME = AgeMgr.registerAs;
                    return AgeMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.AgeMgr = AgeMgr;
                Pulse.app.service(AgeMgr.registerAs, [
                    'common',
                    'breezeService',
                    'pulseContextService',
                    AgeMgr,
                ]);
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var HealthSafetyFormMgr = (function (_super) {
                    __extends(HealthSafetyFormMgr, _super);
                    function HealthSafetyFormMgr(common, breezeService, pulseContext) {
                        var _this = _super.call(this, common, breezeService, pulseContext, HealthSafetyFormMgr.CLASS_NAME) || this;
                        _this.restoreState();
                        return _this;
                    }
                    HealthSafetyFormMgr.prototype.restoreState = function () {
                        if (angular.isDefined(Pulse.Utils.QueryStringUtils.GetParamByName(this.common.$location.absUrl(), Pulse.Utils.QueryStringUtils.MEDIC_APP_MODE))) {
                            this.isMedicAppMode = Boolean(Number(Pulse.Utils.QueryStringUtils.GetParamByName(this.common.$location.absUrl(), Pulse.Utils.QueryStringUtils.MEDIC_APP_MODE)));
                        }
                        else {
                            this.isMedicAppMode = this.stateBag.isMedicAppMode;
                        }
                        if (angular.isDefined(Pulse.Utils.QueryStringUtils.GetParamByName(this.common.$location.absUrl(), Pulse.Utils.QueryStringUtils.MEDIC_APP_MEDS_ONLY))) {
                            this.isMedicAppMedsOnly = Boolean(Number(Pulse.Utils.QueryStringUtils.GetParamByName(this.common.$location.absUrl(), Pulse.Utils.QueryStringUtils.MEDIC_APP_MEDS_ONLY)));
                        }
                        else {
                            this.isMedicAppMedsOnly = this.stateBag.isMedicAppMedsOnly;
                        }
                    };
                    Object.defineProperty(HealthSafetyFormMgr.prototype, "isMedicAppMode", {
                        get: function () {
                            return this._isMedicAppMode;
                        },
                        set: function (value) {
                            this._isMedicAppMode = value;
                            this.stateBag.isMedicAppMode = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(HealthSafetyFormMgr.prototype, "isMedicAppMedsOnly", {
                        get: function () {
                            return this._isMedicAppMedsOnly;
                        },
                        set: function (value) {
                            this._isMedicAppMedsOnly = value;
                            this.stateBag.isMedicAppMedsOnly = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(HealthSafetyFormMgr.prototype, "stateBag", {
                        get: function () {
                            if (!angular.isObject(this._hsfStateBag)) {
                                var stateObj = this.common.localStorageService.get(HealthSafetyFormMgr.HealthSafetyFormStateBag.stateBagId);
                                if (angular.isObject(stateObj)) {
                                    this._hsfStateBag = new HealthSafetyFormMgr.HealthSafetyFormStateBag(this.common.localStorageService, stateObj);
                                }
                            }
                            if (!angular.isObject(this._hsfStateBag)) {
                                this._hsfStateBag = new HealthSafetyFormMgr.HealthSafetyFormStateBag(this.common.localStorageService);
                            }
                            return this._hsfStateBag;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    HealthSafetyFormMgr.prototype.getUserFormDetail = function (ufdId, forceReload) {
                        var _this = this;
                        if (forceReload === void 0) { forceReload = false; }
                        var deferred = this.common.$q.defer();
                        if (angular.isDefined(this._userFormDetail) && (this._userFormDetail.userFormDetailID == ufdId) && !forceReload) {
                            deferred.resolve(this._userFormDetail);
                            return deferred.promise;
                        }
                        else {
                            var query = breeze.EntityQuery
                                .from('HSF_GetUserFormDetail')
                                .withParameters({ ufdID: ufdId });
                            var result = this.entityMgr.executeQuery(query).then(function (data) {
                                _this._userFormDetail = data.results[0];
                                return data.results[0];
                            });
                            return result;
                        }
                    };
                    HealthSafetyFormMgr.prototype.getCurrentUserFormDetailForUser = function (userID) {
                        var deferred = this.common.$q.defer();
                        var query = breeze.EntityQuery
                            .from('HSF_GetCurrentUserFormDetailForUser')
                            .withParameters({ userID: userID });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results[0];
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getUserFormInsuranceForUserFormDetail = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetUserFormInsuranceForUserFormDetail')
                            .withParameters({ ufdID: ufdId });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var r = data.results[0];
                            if (r && !String.isNullOrWhitespace(r.countryCode) && !String.isNullOrWhitespace(r.number)) {
                                r.number = "+" + r.countryCode + r.areaCode + r.number;
                            }
                            return r;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getUserFormInsuranceForPreviousTermGroup = function (participantUserID) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetUserFormInsuranceForPreviousTermGroup')
                            .withParameters({ participantUserID: participantUserID });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var r = data.results[0];
                            if (r && !String.isNullOrWhitespace(r.countryCode) && !String.isNullOrWhitespace(r.number)) {
                                r.number = "+" + r.countryCode + r.areaCode + r.number;
                            }
                            return r;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getParticipant = function (participantId, forceReload) {
                        var _this = this;
                        if (forceReload === void 0) { forceReload = false; }
                        var deferred = this.common.$q.defer();
                        if (angular.isDefined(this._participant) && (this._participant.userID == participantId) && !forceReload) {
                            deferred.resolve(this._participant);
                            return deferred.promise;
                        }
                        else {
                            var query = breeze.EntityQuery
                                .from('HSF_GetParticipant')
                                .withParameters({ participantID: participantId });
                            var result = this.entityMgr.executeQuery(query).then(function (data) {
                                _this._participant = data.results[0];
                                return data.results[0];
                            });
                            return result;
                        }
                    };
                    HealthSafetyFormMgr.prototype.getPrimaryEmergencyContactPersonForUserFormDetail = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetEmergencyContactPerson')
                            .withParameters({
                            ufdID: ufdId,
                            formPersonRoleTypeID: Common.Enums.FormPersonRole.PrimaryContact,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var contactPersons = data.results;
                            contactPersons.forEach(function (p) {
                                if (p.primaryPhone && !String.isNullOrWhitespace(p.primaryPhone.countryCode) && !String.isNullOrWhitespace(p.primaryPhone.number)) {
                                    p.primaryPhone.number = "+" + p.primaryPhone.countryCode + p.primaryPhone.areaCode + p.primaryPhone.number;
                                }
                                if (p.secondaryPhone && !String.isNullOrWhitespace(p.secondaryPhone.countryCode) && !String.isNullOrWhitespace(p.secondaryPhone.number)) {
                                    p.secondaryPhone.number = "+" + p.secondaryPhone.countryCode + p.secondaryPhone.areaCode + p.secondaryPhone.number;
                                }
                            });
                            return contactPersons;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getSecondaryEmergencyContactPersonForUserFormDetail = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetEmergencyContactPerson')
                            .withParameters({
                            ufdID: ufdId,
                            formPersonRoleTypeID: Common.Enums.FormPersonRole.SecondaryContact,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var contactPersons = data.results;
                            contactPersons.forEach(function (p) {
                                if (p.primaryPhone && !String.isNullOrWhitespace(p.primaryPhone.countryCode) && !String.isNullOrWhitespace(p.primaryPhone.number)) {
                                    p.primaryPhone.number = "+" + p.primaryPhone.countryCode + p.primaryPhone.areaCode + p.primaryPhone.number;
                                }
                                if (p.secondaryPhone && !String.isNullOrWhitespace(p.secondaryPhone.countryCode) && !String.isNullOrWhitespace(p.secondaryPhone.number)) {
                                    p.secondaryPhone.number = "+" + p.secondaryPhone.countryCode + p.secondaryPhone.areaCode + p.secondaryPhone.number;
                                }
                            });
                            return contactPersons;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getAuthPickupPersonsForUserFormDetail = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetAuthPickupPersonsForUserFormDetail')
                            .withParameters({ ufdID: ufdId });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var pickupPersons = data.results;
                            if (angular.isArray(pickupPersons)) {
                                pickupPersons.forEach(function (p) {
                                    if (angular.isArray(p.formPersonContactMethods)) {
                                        p.formPersonContactMethods.forEach(function (cm) {
                                            if (!String.isNullOrWhitespace(cm.countryCode) && !String.isNullOrWhitespace(cm.number)) {
                                                cm.number = "+" + cm.countryCode + cm.areaCode + cm.number;
                                            }
                                        });
                                    }
                                });
                            }
                            return pickupPersons;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getReqdFormContentForUserFormDetail = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetReqdFormContentForUserFormDetail')
                            .withParameters({ ufdID: ufdId });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results[0];
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getReqdFormContentForPreviousTermGroup = function (participantId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetReqdFormContentForPreviousTermGroup')
                            .withParameters({ participantUserID: participantId });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            var r = data.results[0];
                            if (r != null) {
                                r.pickupCode = null;
                                r.canSelfSignOut = null;
                                r.approveSelfSignOut = false;
                                r.allergyDietaryRest = null;
                                r.prescriptionReq = null;
                                r.epipen = null;
                                r.isImmunized = null;
                            }
                            return r;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getUserFormAllergyForUserFormDetail = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetUserFormAllergyForUserFormDetail')
                            .withParameters({ ufdID: ufdId });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getUserFormMedicationsForUserFormDetail = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetUserFormMedicationsForUserFormDetail')
                            .withParameters({ ufdID: ufdId });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getIsUserInternational = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetUserIsInternational')
                            .withParameters({ ufdID: ufdId });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results[0];
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getUserFormImmunizationsForUserFormDetail = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetUserFormImmunizationsForUserFormDetail')
                            .withParameters({ ufdID: ufdId });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getUserFormVersionsForUserFormDetail = function (ufdId) {
                        var query = breeze.EntityQuery
                            .from('HSF_GetUserFormVersionDTOsForUserFormDetail')
                            .withParameters({ ufdID: ufdId });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.getIncompleteParticipants = function () {
                        var query = breeze.EntityQuery
                            .from('HSF_GetIncompleteParticipantsForCustomer');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    HealthSafetyFormMgr.prototype.downloadFormAsPDF = function (ufdId, participantId) {
                        var url = this.common.config.webApi_NonBreeze
                            + '/HSF_GetFormAsPDF?'
                            + QueryStringUtils.USERFORMDETAIL_ID + '=' + ufdId + '&'
                            + QueryStringUtils.PARTICIPANT_ID + '=' + participantId;
                        var promises = new Array();
                        promises.push(this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            responseType: 'blob',
                        }).then(function (response) {
                            return response;
                        }));
                        return this.common.$q.all(promises);
                    };
                    HealthSafetyFormMgr.prototype.createReqdFormContent = function (config) {
                        var rfcDAO = new DataAccess.ReqdFormContentDAO(this.common, this.breezeService, this.pulseContext);
                        if (!config || config == null) {
                            return rfcDAO.Create({
                                noHealthInsInfo: null,
                                pickupCode: null,
                                approveSelfSignOut: false,
                                canSelfSignOut: false,
                                prescriptionReq: null,
                                allergyDietaryRest: null,
                                epipen: null,
                            });
                        }
                        else {
                            return rfcDAO.Create({
                                userFormDetailID: config.userFormDetailID,
                                currentGradeTypeID: config.currentGradeTypeID,
                                disbursementTypeID: config.disbursementTypeID,
                                pickupCode: config.pickupCode,
                                isPickupAuthorized: config.isPickupAuthorized,
                                canSelfSignOut: config.canSelfSignOut,
                                approveSelfSignOut: config.approveSelfSignOut,
                                noHealthInsInfo: config.noHealthInsInfo,
                                allergyDietaryRest: config.allergyDietaryRest,
                                epipen: config.epipen,
                                prescriptionReq: config.prescriptionReq,
                                hasSpecialNeeds: config.hasSpecialNeeds,
                                spNeedsComment: config.spNeedsComment,
                                needsAide: config.needsAide,
                                hasHealthHistory: config.hasHealthHist,
                                healthHist: config.healthHist,
                                hasMedConditions: config.hasMedConditions,
                                medConditions: config.medConditions,
                                allergyDesc: config.allergyDesc,
                                epipenComment: config.epipenComment,
                                dietaryComment: config.dietaryComment,
                                assessmentComment: config.assessmentComment,
                                schoolName: config.schoolName,
                                schoolCity: config.schoolCity,
                                schoolState: config.schoolState,
                                schoolDistrict: config.schoolDistrict,
                                takeMedsAtCamp: config.takeMedsAtCamp,
                                respForMedChgs: config.respForMedChgs,
                                noDirectDeposit: config.noDirectDeposit,
                                inventions: config.inventions,
                                dataEncrypted: config.dataEncrypted,
                                isImmunized: config.isImmunized,
                                notImmunizedTypeID: config.notImmunizedTypeID,
                            });
                        }
                    };
                    HealthSafetyFormMgr.prototype.createUserFormInsurance = function (config, onlyInsViewFields) {
                        var ufiDAO = new DataAccess.UserFormInsuranceDAO(this.common, this.breezeService, this.pulseContext);
                        if (config == null) {
                            return ufiDAO.Create({
                                insuranceTypeID: Common.Enums.InsuranceType.Health,
                                countryCode: 1
                            });
                        }
                        else if (onlyInsViewFields) {
                            return ufiDAO.Create({
                                userFormDetailID: config.userFormDetailID,
                                insuranceTypeID: Common.Enums.InsuranceType.Health,
                                carrier: config.carrier,
                                policyNumber: config.policyNumber,
                                policyHolderName: config.policyHolderName,
                                policyHolderDOB: config.policyHolderDOB,
                                countryCode: config.countryCode,
                                areaCode: config.areaCode,
                                number: config.number,
                            });
                        }
                        else {
                            return ufiDAO.Create({
                                userFormDetailID: config.userFormDetailID,
                                insuranceTypeID: config.insuranceTypeID,
                                stateTypeID: config.stateTypeID,
                                countryTypeID: config.countryTypeID,
                                contactMethodTypeID: config.contactMethodTypeID,
                                carrier: config.carrier,
                                policyNumber: config.policyNumber,
                                groupNumber: config.groupNumber,
                                policyHolderName: config.policyHolderName,
                                policyHolderDOB: config.policyHolderDOB,
                                physicianName: config.physicianName,
                                physicianCity: config.physicianCity,
                                physicianState: config.physicianState,
                                countryCode: config.countryCode,
                                areaCode: config.areaCode,
                                number: config.number,
                                extension: config.extension,
                            });
                        }
                    };
                    HealthSafetyFormMgr.prototype.createUserFormMedication = function (config) {
                        var ufmDAO = new DataAccess.UserFormMedicationDAO(this.common, this.breezeService, this.pulseContext);
                        if (!config || config == null) {
                            return ufmDAO.Create({
                                medSchedules: Array(),
                            });
                        }
                        else {
                            return ufmDAO.Create({
                                userFormDetailID: config.userFormDetailID,
                                userFormMedicationID: config.userFormMedicationID,
                                medicationName: config.medicationName,
                                dosage: config.dosage,
                                reason: config.reason,
                                takeWithFood: config.takeWithFood,
                                sideEffects: config.sideEffects,
                                dataEncrypted: config.dataEncrypted,
                                medSchedules: config.medSchedules,
                            });
                        }
                    };
                    HealthSafetyFormMgr.prototype.createMedSchedule = function (config) {
                        var msDAO = new DataAccess.MedScheduleDAO(this.common, this.breezeService, this.pulseContext);
                        if (!config || config == null) {
                            return msDAO.Create({});
                        }
                        else {
                            return msDAO.Create({
                                medScheduleID: config.medScheduleID,
                                userFormMedicationID: config.userFormMedicationID,
                                timeTakenTypeID: config.timeTakenTypeID,
                                timeTaken: config.timeTaken,
                            });
                        }
                    };
                    HealthSafetyFormMgr.prototype.createUserFormImmunization = function (config) {
                        var ufiDAO = new DataAccess.UserFormImmunizationDAO(this.common, this.breezeService, this.pulseContext);
                        if (!config || config == null) {
                            return ufiDAO.Create({});
                        }
                        else {
                            return ufiDAO.Create({
                                userFormDetailID: config.userFormDetailID,
                                immunizationTypeID: config.immunizationTypeID,
                                immuneStatusTypeID: config.immuneStatusTypeID,
                                immunizedYear: config.immunizedYear,
                                immunizedMonth: config.immunizedMonth,
                                immunizationDay: config.immunizationDay,
                                manufacturerTypeID: config.manufacturerTypeID
                            });
                        }
                    };
                    HealthSafetyFormMgr.prototype.getFormsBlackoutInfo = function (studentUserID) {
                        var _this = this;
                        this.pulseContext.clientFormsMgr.getStudentFormsCurrent(studentUserID)
                            .then(function (data) {
                            _this._studentForms = data;
                            for (var _i = 0, _a = _this._studentForms.requiredForms; _i < _a.length; _i++) {
                                var student = _a[_i];
                                student.thresholdAndCourseDates.forEach(function (x) {
                                    if (x.blackOutPeriod)
                                        return true;
                                });
                            }
                        });
                        return false;
                    };
                    HealthSafetyFormMgr.prototype.checkCanEdit = function (userFormDetail) {
                        var _this = this;
                        var defer = this.common.$q.defer();
                        if (this.pulseContext.healthSafetyFormMgr.isMedicAppMode) {
                            defer.resolve(true);
                        }
                        this.pulseContext.customerMgr.getStudentSessions(userFormDetail.userID).then(function (data) {
                            var canEditResult = false;
                            if (data.length > 0) {
                                data.sort(function (a, b) {
                                    return moment(a.sessionStart).unix() - moment(b.sessionStart).unix();
                                });
                                canEditResult = (data[0].formsAvailableDate.startDate.getTime() <= _this.pulseContext.serverDateTime.getTime()
                                    && data[0].formsAvailableDate.endDate.getTime() >= _this.pulseContext.serverDateTime.getTime()) ||
                                    (!_this.getFormsBlackoutInfo(userFormDetail.userID));
                            }
                            if (userFormDetail.termGroupID != _this.pulseContext.currentTermGroup.termGroupID) {
                                canEditResult = false;
                            }
                            if (!canEditResult) {
                                canEditResult = _this.pulseContext.hasAnyRolesAndLevels(Common.Enums.UserRoleType.Administrator, 1, 2, Common.Enums.UserRoleType.ClientServices, 1, 2, 3, Common.Enums.UserRoleType.Compliance, 1);
                            }
                            defer.resolve(canEditResult);
                        }).catch(function (error) {
                            _this.logError(error);
                            defer.reject();
                        });
                        return defer.promise;
                    };
                    HealthSafetyFormMgr.prototype.copyContactInfo = function (studentUserID, copyFromStudentUserFormDetailID, copyPrimaryContact, copySecondaryContact, copyPickupContacts) {
                        var url = this.common.config.webApi_NonBreeze + '/HSF_CopyContactInfo';
                        var params = {
                            studentUserID: studentUserID,
                            copyFromStudentUserFormDetailID: copyFromStudentUserFormDetailID,
                            copyPrimaryContact: copyPrimaryContact,
                            copySecondaryContact: copySecondaryContact,
                            copyPickupContacts: copyPickupContacts,
                        };
                        return this.common.$http.post(url, params)
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    HealthSafetyFormMgr.prototype.clearCache = function () {
                        this._participant = undefined;
                        this._userFormDetail = undefined;
                    };
                    HealthSafetyFormMgr.CLASS_NAME = 'HealthSafetyFormMgr';
                    return HealthSafetyFormMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.HealthSafetyFormMgr = HealthSafetyFormMgr;
                (function (HealthSafetyFormMgr) {
                    var HealthSafetyFormStateBag = (function () {
                        function HealthSafetyFormStateBag(localStorageService, stateObj) {
                            if (stateObj === void 0) { stateObj = null; }
                            this._hsfStateObject = {
                                _isMedicAppMode: false,
                                _isMedicAppMedsOnly: false,
                            };
                            this.localStorageService = localStorageService;
                            if (angular.isObject(stateObj)) {
                                this._hsfStateObject = stateObj;
                            }
                        }
                        Object.defineProperty(HealthSafetyFormStateBag.prototype, "isMedicAppMode", {
                            get: function () {
                                return this._hsfStateObject._isMedicAppMode;
                            },
                            set: function (value) {
                                this._hsfStateObject._isMedicAppMode = value;
                                this.localStorageService.set(HealthSafetyFormStateBag.stateBagId, this._hsfStateObject);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(HealthSafetyFormStateBag.prototype, "isMedicAppMedsOnly", {
                            get: function () {
                                return this._hsfStateObject._isMedicAppMedsOnly;
                            },
                            set: function (value) {
                                this._hsfStateObject._isMedicAppMedsOnly = value;
                                this.localStorageService.set(HealthSafetyFormStateBag.stateBagId, this._hsfStateObject);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        HealthSafetyFormStateBag.stateBagId = 'healthSafetyFormStateBagData';
                        return HealthSafetyFormStateBag;
                    }());
                    HealthSafetyFormMgr.HealthSafetyFormStateBag = HealthSafetyFormStateBag;
                    var ICopyHSFContactInstructions = (function () {
                        function ICopyHSFContactInstructions() {
                        }
                        return ICopyHSFContactInstructions;
                    }());
                    HealthSafetyFormMgr.ICopyHSFContactInstructions = ICopyHSFContactInstructions;
                })(HealthSafetyFormMgr = Managers.HealthSafetyFormMgr || (Managers.HealthSafetyFormMgr = {}));
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var FacilityMgr = (function (_super) {
                    __extends(FacilityMgr, _super);
                    function FacilityMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, FacilityMgr.CLASS_NAME) || this;
                    }
                    FacilityMgr.prototype.getRoomBeds = function (facilityID, refreshCache, skip, take) {
                        var url = this.common.config.webApi_NonBreeze + '/Facility_GetRoomBeds?facilityID=' + facilityID
                            + '&refreshCache=' + refreshCache
                            + '&skip=' + skip
                            + '&take=' + take;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    FacilityMgr.prototype.getRooms = function (facilityID, defaultRoomAgeRangeID, sessionID, refreshCache, skip, take) {
                        var url = this.common.config.webApi_NonBreeze + '/Facility_GetRooms?facilityID=' + facilityID
                            + '&refreshCache=' + refreshCache
                            + '&skip=' + skip
                            + '&take=' + take;
                        if (sessionID && sessionID > 0) {
                            url += '&sessionID=' + sessionID;
                        }
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            angular.forEach(results, function (room) {
                                room.updatedSinceLastQuery = false;
                                room.isAlreadyAssigned = false;
                                if (sessionID && sessionID > 0 && room.occupantTypeID && room.occupantTypeID > 0) {
                                    room.isAlreadyAssigned = true;
                                }
                                if (Pulse.Utils.JS.isUndefinedOrNull(room.occupantTypeID)) {
                                    room.occupantTypeID = Common.Enums.RoomOccupant.All;
                                }
                                if (Pulse.Utils.JS.isUndefinedOrNull(room.genderTypeID)) {
                                    room.genderTypeID = Common.Enums.RoomGender.All;
                                }
                                if (Pulse.Utils.JS.isUndefinedOrNull(room.ageRangeID)) {
                                    room.ageRangeID = defaultRoomAgeRangeID;
                                }
                                if (Pulse.Utils.JS.isUndefinedOrNull(room.isDirectorRoom)) {
                                    room.isDirectorRoom = false;
                                }
                            });
                            return results;
                        });
                    };
                    FacilityMgr.prototype.getRoomSessions = function (facilityID, sessionID, refreshCache, skip, take) {
                        var url = this.common.config.webApi_NonBreeze + '/Facility_GetRoomSessions?facilityID=' + facilityID
                            + '&sessionID=' + sessionID
                            + '&refreshCache=' + refreshCache
                            + '&skip=' + skip
                            + '&take=' + take;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    FacilityMgr.prototype.uploadRoomBeds = function (facilityID, csvFileContent) {
                        var userID = this.pulseContext.actingAsUserId;
                        var webAPIUrl = this.common.config.webApi_NonBreeze + '/Facility_UploadRoomBeds';
                        var formData = {
                            userID: userID,
                            facilityID: facilityID,
                            roomData: csvFileContent,
                        };
                        var jsonString = JSON.stringify(formData);
                        return this.common.$http.post(webAPIUrl, jsonString, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    FacilityMgr.prototype.deleteRoomBeds = function (facilityID, roomIDList, roomBedIDList) {
                        var userID = this.pulseContext.actingAsUserId;
                        var url = this.common.config.webApi_NonBreeze + '/Facility_DeleteRoomBeds';
                        var info = {
                            userID: userID,
                            facilityID: facilityID,
                            roomIDList: roomIDList,
                            roomBedIDList: roomBedIDList,
                        };
                        var jsonString = JSON.stringify(info);
                        return this.common.$http.post(url, jsonString, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    FacilityMgr.prototype.assignRoomsToSessions = function (divisionID, termID, sessionIDList, roomList) {
                        var userID = this.pulseContext.actingAsUserId;
                        var url = this.common.config.webApi_NonBreeze + '/Facility_AssignDormRoomsToSessions';
                        var info = {
                            userID: userID,
                            divisionID: divisionID,
                            termID: termID,
                            sessionIDList: sessionIDList,
                            roomList: roomList,
                        };
                        var jsonString = JSON.stringify(info);
                        return this.common.$http.post(url, jsonString, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    FacilityMgr.prototype.deleteRoomSessions = function (facilityID, sessionID, roomSessionIDList) {
                        var userID = this.pulseContext.actingAsUserId;
                        var url = this.common.config.webApi_NonBreeze + '/Facility_DeleteRoomSessions';
                        var info = {
                            userID: userID,
                            facilityID: facilityID,
                            sessionID: sessionID,
                            roomSessionIDList: roomSessionIDList,
                        };
                        var jsonString = JSON.stringify(info);
                        return this.common.$http.post(url, jsonString, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    FacilityMgr.prototype.updateRoomSessions = function (facilityID, sessionID, roomSessionList) {
                        var userID = this.pulseContext.actingAsUserId;
                        var url = this.common.config.webApi_NonBreeze + '/Facility_UpdateRoomSessions';
                        var updateRoomSessionInfoList = roomSessionList.map(function (rs) {
                            var update = {
                                roomSessionID: rs.roomSessionID,
                                occupantTypeID: rs.occupantTypeID,
                                genderTypeID: rs.genderTypeID,
                                ageRangeID: rs.ageRangeID,
                                isDirectorRoom: rs.isDirectorRoom
                            };
                            return update;
                        });
                        var info = {
                            userID: userID,
                            facilityID: facilityID,
                            sessionID: sessionID,
                            updateRoomSessionInfoList: updateRoomSessionInfoList,
                        };
                        var jsonString = JSON.stringify(info);
                        return this.common.$http.post(url, jsonString, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    FacilityMgr.CLASS_NAME = 'FacilityMgr';
                    return FacilityMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.FacilityMgr = FacilityMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var ThresholdMgr = (function (_super) {
                    __extends(ThresholdMgr, _super);
                    function ThresholdMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, ThresholdMgr.CLASS_NAME) || this;
                        _this._dateInContext = null;
                        _this._dateInContext = dateInContext;
                        return _this;
                    }
                    ThresholdMgr.prototype.getTermGroupThresholds = function (termGroupId, thresholdTypeID, refreshCache) {
                        if (thresholdTypeID === void 0) { thresholdTypeID = null; }
                        if (refreshCache === void 0) { refreshCache = false; }
                        var query = this.breezeService.breeze.EntityQuery
                            .from('Threshold_GetByTermGroup')
                            .withParameters({
                            termGroupID: termGroupId,
                            thresholdTypeID: thresholdTypeID,
                            refreshCache: refreshCache,
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                    };
                    ThresholdMgr.prototype.loadCurrentTermGroupThresholds = function (refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var _self = this;
                        return this.getTermGroupThresholds(this.pulseContext.currentTermGroup.termGroupID, null, refreshCache)
                            .then(function (data) {
                            _self.currentTermGroupThresholds = data;
                            return data;
                        });
                    };
                    ThresholdMgr.prototype.getCurrentTG_ByThresholdTypeFromLocalCache = function (thresholdTypeID) {
                        if (!this.currentTermGroupThresholds) {
                            throw StringConst.Err_Data_Missing;
                        }
                        var results = this.currentTermGroupThresholds.filter(function (th) { return th.thresholdTypeID === thresholdTypeID; });
                        if (results.length > 0) {
                            return results[0];
                        }
                        return null;
                    };
                    ThresholdMgr.prototype.GetDateForPostCampMessageDisplay = function (locationID, refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        var query = this.breezeService.breeze.EntityQuery
                            .from('Threshold_GetDateForPostCampMessageDisplay')
                            .withParameters({
                            locationID: locationID,
                            refreshCache: refreshCache,
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            var result = data.results[0];
                            result.startDate = result.startDate ? moment(result.startDate).toDate() : null;
                            return result;
                        });
                    };
                    ThresholdMgr.prototype.checkPostCampStatus = function (locationID) {
                        var result = new ThresholdMgr.PostCampInfo();
                        var promises = new Array();
                        if (locationID > 0) {
                            promises.push(this.GetDateForPostCampMessageDisplay(locationID)
                                .then(function (data) {
                                result.locationID = locationID;
                                result.locationInfo = data;
                                return result;
                            }));
                        }
                        promises.push(this.GetDateForPostCampMessageDisplay(null)
                            .then(function (data) {
                            result.campWideInfo = data;
                            return result;
                        }));
                        return this.common.$q.all(promises)
                            .then(function () {
                            Events.TriggerDocCustomEvent(Events.SendPostCampInfo_JSEvent, result);
                            return result;
                        });
                    };
                    ThresholdMgr.ResetPostCampStatus = function () {
                        Events.TriggerDocCustomEvent(Events.SendPostCampInfo_JSEvent, null);
                    };
                    ThresholdMgr.CLASS_NAME = 'ThresholdMgr';
                    return ThresholdMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.ThresholdMgr = ThresholdMgr;
                (function (ThresholdMgr) {
                    var PostCampInfo = (function () {
                        function PostCampInfo() {
                        }
                        return PostCampInfo;
                    }());
                    ThresholdMgr.PostCampInfo = PostCampInfo;
                    var PostCampMessageInfo = (function () {
                        function PostCampMessageInfo() {
                        }
                        return PostCampMessageInfo;
                    }());
                    ThresholdMgr.PostCampMessageInfo = PostCampMessageInfo;
                })(ThresholdMgr = Managers.ThresholdMgr || (Managers.ThresholdMgr = {}));
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var UtmParamsMgr = (function (_super) {
                    __extends(UtmParamsMgr, _super);
                    function UtmParamsMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, UtmParamsMgr.CLASS_NAME) || this;
                        _this._dateInContext = null;
                        _this._dateInContext = dateInContext;
                        return _this;
                    }
                    UtmParamsMgr.prototype.recordEvent = function (recordEventInfo) {
                        var url = this.common.config.webApi_UrlRoot + '/UtmParams/RecordEvent';
                        var jsonString = JSON.stringify(recordEventInfo);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } });
                    };
                    UtmParamsMgr.prototype.recordEventForType = function (type, emailAddress, userID) {
                        if (!emailAddress) {
                            emailAddress = this.pulseContext.actingAsUser == null ? null : this.pulseContext.actingAsUser.userName;
                        }
                        if (!userID) {
                            userID = this.pulseContext.actingAsUser == null ? null : this.pulseContext.actingAsUser.userID;
                        }
                        if (emailAddress != null) {
                            var cookie = Pulse.Utils.Cookies.getCookie(UtmParamsMgr.UTM_COOKIE_NAME, false);
                            if (cookie != null && cookie != '') {
                                var recordEventInfo = {};
                                recordEventInfo.emailAddress = emailAddress;
                                recordEventInfo.userID = userID;
                                recordEventInfo.utmCampaign = this.getCookieSubValue(cookie, UtmParamsMgr.UTM_CAMPAIGN);
                                recordEventInfo.utmContent = this.getCookieSubValue(cookie, UtmParamsMgr.UTM_CONTENT);
                                recordEventInfo.utmCreationTriggerTypeID = type;
                                recordEventInfo.utmDestinationUrl = this.getCookieSubValue(cookie, UtmParamsMgr.UTM_DESTINATION_URL);
                                recordEventInfo.utmMedium = this.getCookieSubValue(cookie, UtmParamsMgr.UTM_MEDIUM);
                                recordEventInfo.utmSiteVisitDate = this.getCookieSubValue(cookie, UtmParamsMgr.UTM_SITE_VISIT_DATE);
                                recordEventInfo.utmSource = this.getCookieSubValue(cookie, UtmParamsMgr.UTM_SOURCE);
                                recordEventInfo.utmTerm = this.getCookieSubValue(cookie, UtmParamsMgr.UTM_TERM);
                                recordEventInfo.utmUserAgent = this.getCookieSubValue(cookie, UtmParamsMgr.UTM_USER_AGENT);
                                return this.recordEvent(recordEventInfo)
                                    .then(function (response) {
                                    Pulse.Utils.Cookies.eraseCookie(UtmParamsMgr.UTM_COOKIE_NAME, false);
                                    return response;
                                });
                            }
                            else {
                                var utmCampaign = this.getCookieValue(UtmParamsMgr.UTM_CAMPAIGN);
                                var utmContent = this.getCookieValue(UtmParamsMgr.UTM_CONTENT);
                                var utmDestinationUrl = this.getCookieValue('utmDestinationUrl');
                                var utmMedium = this.getCookieValue(UtmParamsMgr.UTM_MEDIUM);
                                var utmSiteVisitDate = this.getCookieValue('utmSiteVisitDate');
                                var utmSource = this.getCookieValue(UtmParamsMgr.UTM_SOURCE);
                                var utmTerm = this.getCookieValue(UtmParamsMgr.UTM_TERM);
                                var utmUserAgent = this.getCookieValue('utmUserAgent');
                                if (this.nnb(utmCampaign) || this.nnb(utmContent) || this.nnb(utmDestinationUrl) || this.nnb(utmMedium)
                                    || this.nnb(utmSiteVisitDate) || this.nnb(utmSource) || this.nnb(utmTerm) || this.nnb(utmUserAgent)) {
                                    var recordEventInfo = {};
                                    recordEventInfo.emailAddress = emailAddress;
                                    recordEventInfo.userID = userID;
                                    recordEventInfo.utmCampaign = utmCampaign;
                                    recordEventInfo.utmContent = utmContent;
                                    recordEventInfo.utmCreationTriggerTypeID = type;
                                    recordEventInfo.utmDestinationUrl = utmDestinationUrl;
                                    recordEventInfo.utmMedium = utmMedium;
                                    recordEventInfo.utmSiteVisitDate = utmSiteVisitDate;
                                    recordEventInfo.utmSource = utmSource;
                                    recordEventInfo.utmTerm = utmTerm;
                                    recordEventInfo.utmUserAgent = utmUserAgent;
                                    return this.recordEvent(recordEventInfo)
                                        .then(function (response) {
                                        Pulse.Utils.Cookies.eraseCookie(UtmParamsMgr.UTM_CAMPAIGN, false);
                                        Pulse.Utils.Cookies.eraseCookie(UtmParamsMgr.UTM_CONTENT, false);
                                        Pulse.Utils.Cookies.eraseCookie('utmDestinationUrl', false);
                                        Pulse.Utils.Cookies.eraseCookie(UtmParamsMgr.UTM_MEDIUM, false);
                                        Pulse.Utils.Cookies.eraseCookie('utmSiteVisitDate', false);
                                        Pulse.Utils.Cookies.eraseCookie(UtmParamsMgr.UTM_SOURCE, false);
                                        Pulse.Utils.Cookies.eraseCookie(UtmParamsMgr.UTM_TERM, false);
                                        Pulse.Utils.Cookies.eraseCookie('utmUserAgent', false);
                                        return response;
                                    });
                                }
                            }
                        }
                        var deferred = this.common.$q.defer();
                        deferred.resolve(null);
                        return deferred.promise;
                    };
                    UtmParamsMgr.prototype.getCookieSubValue = function (cookieData, subKey) {
                        cookieData = cookieData.replace(/.*?\?/, '');
                        cookieData = cookieData.replace(/_&_/, '_%26_');
                        var vars = cookieData.split('&');
                        for (var i = 0; i < vars.length; i++) {
                            var pair = vars[i].split('=');
                            if (decodeURIComponent(pair[0]) == subKey) {
                                return decodeURIComponent(pair[1]);
                            }
                        }
                    };
                    UtmParamsMgr.prototype.getCookieValue = function (cookieName) {
                        var c = Pulse.Utils.Cookies.getCookie(cookieName, false);
                        if (c == null && c == '') {
                            c = Pulse.Utils.Cookies.getCookie(cookieName.toLowerCase(), false);
                        }
                        if (c == null && c == '') {
                            c = Pulse.Utils.Cookies.getCookie(cookieName.toUppserCase(), false);
                        }
                        if (c == null && c == '') {
                            return null;
                        }
                        else {
                            c = c.replace(/.*?\?/, '');
                            c = c.replace(/_&_/, '_%26_');
                            c = c.trim();
                            if (c == '') {
                                return null;
                            }
                            else {
                                return c;
                            }
                        }
                    };
                    UtmParamsMgr.prototype.nnb = function (s) {
                        return !(s == null) && !(s == '');
                    };
                    UtmParamsMgr.CLASS_NAME = 'UtmParamsMgr';
                    UtmParamsMgr.UTM_COOKIE_NAME = 'UTM';
                    UtmParamsMgr.UTM_SOURCE = 'utm_source';
                    UtmParamsMgr.UTM_MEDIUM = 'utm_medium';
                    UtmParamsMgr.UTM_CAMPAIGN = 'utm_campaign';
                    UtmParamsMgr.UTM_SITE_VISIT_DATE = 'SiteVisitDate';
                    UtmParamsMgr.UTM_TERM = 'utm_term';
                    UtmParamsMgr.UTM_CONTENT = 'utm_content';
                    UtmParamsMgr.UTM_DESTINATION_URL = 'DestinationURL';
                    UtmParamsMgr.UTM_USER_AGENT = 'User_Agent';
                    return UtmParamsMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.UtmParamsMgr = UtmParamsMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var TermsAndConditionsMgr = (function (_super) {
                    __extends(TermsAndConditionsMgr, _super);
                    function TermsAndConditionsMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, TermsAndConditionsMgr.CLASS_NAME) || this;
                    }
                    TermsAndConditionsMgr.prototype.hasUserAgreedToTermsAndConditions = function () {
                        var query = breeze.EntityQuery
                            .from('User_HasAgreedToTermsAndConditions');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    TermsAndConditionsMgr.prototype.saveUserTandCSignature = function () {
                        var query = breeze.EntityQuery
                            .from('User_SaveTandCSignature')
                            .take(1);
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    TermsAndConditionsMgr.prototype.getLatestTermsAndConditionsContent = function () {
                        var query = breeze.EntityQuery
                            .from('User_GetLatestTermsAndConditionsContent');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    TermsAndConditionsMgr.prototype.getPrivacyPolicyContent = function () {
                        var query = breeze.EntityQuery
                            .from('User_GetPrivacyPolicyContent');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    TermsAndConditionsMgr.CLASS_NAME = 'TermsAndConditionsMgr';
                    return TermsAndConditionsMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.TermsAndConditionsMgr = TermsAndConditionsMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var AnnouncementMgr = (function (_super) {
                    __extends(AnnouncementMgr, _super);
                    function AnnouncementMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, AnnouncementMgr.CLASS_NAME) || this;
                    }
                    AnnouncementMgr.prototype.hasSeenCurrentWelcomeMessage = function (companyId, userId) {
                        var query = breeze.EntityQuery
                            .from('User_HasSeenCurrentWelcomeMessage');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    AnnouncementMgr.prototype.saveUserHasSeenWelcomeMessage = function () {
                        var query = breeze.EntityQuery
                            .from('User_SaveHasSeenWelcomeMessage')
                            .take(1);
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    AnnouncementMgr.prototype.getLatestWelcomeMessageContent = function () {
                        var query = breeze.EntityQuery
                            .from('User_GetLatestWelcomeMessageContent');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    AnnouncementMgr.CLASS_NAME = 'AnnouncementMgr';
                    return AnnouncementMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.AnnouncementMgr = AnnouncementMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var OnlinePrivateLessonMgr = (function (_super) {
                    __extends(OnlinePrivateLessonMgr, _super);
                    function OnlinePrivateLessonMgr(common, breezeService, pulseContext) {
                        var _this = _super.call(this, common, breezeService, pulseContext, OnlinePrivateLessonMgr.CLASS_NAME) || this;
                        _this._AllOPLTopicSkillsCache = null;
                        return _this;
                    }
                    OnlinePrivateLessonMgr.prototype.getDiscountValuesForProductIDs = function (discountCode, productIDsAsString) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetDiscountValuesForProductIDs';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                discountCode: discountCode,
                                productIDsAsString: productIDsAsString,
                            }
                        })
                            .then(function (response) {
                            var result = response.data;
                            return result;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getStudentSubscriptions = function (studentID) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetStudentSubscriptions';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                clientUserID: this.pulseContext.actingAsUserId,
                                'studentID': studentID,
                            }
                        })
                            .then(function (response) {
                            var result = response.data;
                            result.forEach(function (r) {
                                var _a;
                                r.fullName = OnlinePrivateLessonMgr.FormatFullName(r);
                                r.prefOrFirstName = r.preferredName ? r.preferredName : r.firstName;
                                r.purchaseDate = r.purchaseDate ? moment(r.purchaseDate).toDate() : null;
                                r.subStartDate = r.subStartDate ? moment(r.subStartDate).toDate() : null;
                                r.expiryDate = r.expiryDate ? moment(r.expiryDate).toDate() : null;
                                r.packSize = r.packSize <= 0 ? 1 : r.packSize;
                                r.isSuspended = OnlinePrivateLessonMgr.IsSubscriptionSuspended(r);
                                (_a = OnlinePrivateLessonMgr.ParseNameAndPacksize(r.productName), r.productNamePart1 = _a.productNamePart1, r.productNamePart2 = _a.productNamePart2);
                                r.pricePerMonth = (r.currentPrice - r.currentDiscAmt);
                                r.pricePerLesson = r.pricePerMonth / r.packSize;
                            });
                            return result;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.pauseSubscription = function (orderDetailID, monthsToPause) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_PauseSubscription';
                        var payload = {
                            orderDetailID: orderDetailID,
                            customerUserID: this.pulseContext.actingAsUser.userID,
                            monthsToPause: monthsToPause
                        };
                        return this.common.$http.post(url, payload)
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.resumeSubscription = function (orderDetailID) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_ResumeSubscription';
                        var payload = {
                            orderDetailID: orderDetailID,
                            customerUserID: this.pulseContext.actingAsUser.userID,
                        };
                        return this.common.$http.post(url, payload)
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.cancelSubscription = function (orderDetailID) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_CancelSubscription';
                        var payload = {
                            orderDetailID: orderDetailID,
                            customerUserID: this.pulseContext.actingAsUser.userID
                        };
                        return this.common.$http.post(url, payload)
                            .then(function (response) {
                            var result = response.data;
                            return result;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.renewNowAndPurchaseSubscription = function (orderDetailID) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_RenewNowAndPurchaseSubscription';
                        var payload = {
                            orderDetailID: orderDetailID,
                            customerUserID: this.pulseContext.actingAsUser.userID,
                        };
                        return this.common.$http.post(url, payload)
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.changeSubscriptionOnNextRenew = function (orderDetailID, changeToProdID, isChangeTopic) {
                        if (isChangeTopic === void 0) { isChangeTopic = false; }
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_ChangeSubscriptionOnNextRenew';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                'orderDetailID': orderDetailID,
                                'changeToProdID': changeToProdID,
                                'isChangeTopic': isChangeTopic
                            },
                            cache: true
                        })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getStudents = function () {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetStudents';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                clientUserID: this.pulseContext.actingAsUserId,
                            }
                        })
                            .then(function (response) {
                            var result = response.data;
                            result.forEach(function (r) {
                                r.fullName = OnlinePrivateLessonMgr.FormatFullName(r);
                                r.prefOrFirstName = r.preferredName ? r.preferredName : r.firstName;
                                r.originalTimeZoneTypeID = r.timeZoneTypeID;
                            });
                            return result;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getStudentsAchievements = function (studentIDs) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetUserAchievements';
                        var postData = {
                            studentIDs: studentIDs,
                            userID: this.pulseContext.actingAsUser.userID,
                            companyID: this.pulseContext.companyId,
                            categoryTypeID: 0,
                            calcTypeID: 0
                        };
                        return this.common.$http.post(url, postData, {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getStudentSessions = function (studentID) {
                        var _this = this;
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetStudentSessions';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                clientUserID: this.pulseContext.actingAsUserId,
                                studentID: studentID !== null && studentID !== void 0 ? studentID : null,
                            }
                        })
                            .then(function (response) {
                            var result = response.data;
                            result.forEach(function (r) {
                                r.fullName = OnlinePrivateLessonMgr.FormatFullName(r);
                                r.prefOrFirstName = r.preferredName ? r.preferredName : r.firstName;
                                r.onlineSessions.forEach(function (s) {
                                    _this.formatSessionSummaryDates(s);
                                });
                            });
                            return result;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getNextSessionsForScheduling = function (studentID, topLevelOrderDetailID) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetNextSessionsForScheduling';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                clientUserID: this.pulseContext.actingAsUserId,
                                studentID: studentID,
                                topLevelOrderDetailID: topLevelOrderDetailID
                            }
                        })
                            .then(function (response) {
                            var result = response.data;
                            result.forEach(function (s) {
                                s.expiryDate = s.expiryDate ? moment(s.expiryDate).toDate() : null;
                            });
                            return result;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getStudentNotes = function (studentUserID) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetStudentNotes?studentUserID=' + studentUserID;
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {}
                        })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.saveStudentNote = function (userNote) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_SaveStudentNote';
                        return this.common.$http.post(url, userNote)
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.deleteStudentNote = function (userNoteID) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_DeleteStudentNote?userNoteID=' + userNoteID;
                        return this.common.$http.post(url, {})
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getSessionSummaries = function (orderDetailID, timezoneStr, lessonOrderDetailID) {
                        var _this = this;
                        if (timezoneStr === void 0) { timezoneStr = ''; }
                        if (lessonOrderDetailID === void 0) { lessonOrderDetailID = null; }
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetSessionSummaries';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                orderDetailID: orderDetailID,
                                timezoneStr: timezoneStr,
                                lessonOrderDetailID: lessonOrderDetailID || '',
                            }
                        })
                            .then(function (response) {
                            var result = response.data;
                            result.forEach(function (d) {
                                _this.formatSessionSummaryDates(d);
                            });
                            return response.data;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.saveSessionSummary = function (sessionSummary) {
                        var _this = this;
                        sessionSummary.productUrls = [];
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_SaveSessionSummary';
                        return this.common.$http.post(url, sessionSummary)
                            .then(function (response) {
                            var result = response.data;
                            return _this.formatSessionSummaryDates(result);
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getOPLInstructors = function () {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetOPLInstructors';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {},
                            cache: false
                        })
                            .then(function (response) {
                            var users = response.data;
                            return users.sort(function (a, b) {
                                return a.firstName > b.firstName ? 1 : -1;
                            });
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getOPLTopicGenres = function (dateInContext, refreshCache) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        if (refreshCache === void 0) { refreshCache = false; }
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetOPLTopicGenres';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                'dateInContext': dateInContext,
                                'refreshCache': refreshCache
                            },
                            cache: true
                        })
                            .then(function (response) {
                            var genres = response.data;
                            return genres;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getOPLTopicSkills = function (productID, studentID, selectedID, dateInContext, refreshCache) {
                        var _this = this;
                        if (productID === void 0) { productID = null; }
                        if (studentID === void 0) { studentID = null; }
                        if (selectedID === void 0) { selectedID = null; }
                        if (dateInContext === void 0) { dateInContext = null; }
                        if (refreshCache === void 0) { refreshCache = false; }
                        if (productID > 0 || studentID > 0 || selectedID > 0 || dateInContext || refreshCache
                            || this._AllOPLTopicSkillsCache == null) {
                            var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetOPLTopicSkills';
                            return this.common.$http.get(url, {
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                params: {
                                    'productID': productID,
                                    'studentID': studentID,
                                    'selectedID': selectedID,
                                    'dateInContext': dateInContext,
                                    'refreshCache': refreshCache
                                },
                                cache: false
                            })
                                .then(function (response) {
                                var results = response.data;
                                if (!(productID > 0 || studentID > 0 || selectedID > 0 || dateInContext)) {
                                    _this._AllOPLTopicSkillsCache = __spreadArrays(results);
                                }
                                return results;
                            });
                        }
                        else {
                            return this.common.$q.resolve(__spreadArrays(this._AllOPLTopicSkillsCache));
                        }
                    };
                    OnlinePrivateLessonMgr.prototype.getOPLTopicSkillsHardware = function (orderDetailID, lessonTopicID) {
                        if (lessonTopicID === void 0) { lessonTopicID = null; }
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetOPLTopicSkillsHardware';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                'orderDetailID': orderDetailID,
                                'lessonTopicID': lessonTopicID,
                            },
                            cache: false
                        })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getOPLProducts = function (topicSkillID, refreshCache) {
                        if (topicSkillID === void 0) { topicSkillID = null; }
                        if (refreshCache === void 0) { refreshCache = false; }
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetOPLProducts';
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                'skillID': topicSkillID,
                                'refreshCache': refreshCache
                            },
                            cache: false
                        })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getAvailableDates = function (skillID, staffUserID, studentUserID, orderDetailID, startDatetime, endDatetime, studentTimeZoneTypeID, ignoreWorkRules, selectedLessons) {
                        if (staffUserID === void 0) { staffUserID = null; }
                        if (studentUserID === void 0) { studentUserID = null; }
                        if (orderDetailID === void 0) { orderDetailID = null; }
                        if (startDatetime === void 0) { startDatetime = null; }
                        if (endDatetime === void 0) { endDatetime = null; }
                        if (ignoreWorkRules === void 0) { ignoreWorkRules = false; }
                        if (selectedLessons === void 0) { selectedLessons = null; }
                        var selectedLessonsCopy = OnlinePrivateLessonMgr.ReduceObjectSizeForAPIcall(selectedLessons);
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetAvailableDates';
                        var payload = {
                            'skillID': skillID,
                            'staffUserID': staffUserID,
                            'studentUserID': studentUserID,
                            'orderDetailID': orderDetailID,
                            'startDatetime': startDatetime ? startDatetime.toTZNeutralString() : '',
                            'endDatetime': endDatetime ? endDatetime.toTZNeutralString() : '',
                            'studentTimeZoneTypeID': studentTimeZoneTypeID,
                            'ignoreWorkRules': ignoreWorkRules ? 1 : 0,
                            'selectedLessons': selectedLessonsCopy,
                        };
                        return this.common.$http.post(url, payload)
                            .then(function (response) {
                            var results = response.data;
                            for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
                                var dateDTO = results_1[_i];
                                dateDTO.date = Pulse.Utils.JS.dateTimeStrToDateObj(dateDTO.date);
                            }
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getAvailableTimeSlots = function (skillID, staffUserID, studentUserID, orderDetailID, startDatetime, endDatetime, studentTimeZoneTypeID, ignoreWorkRules, selectedLessons) {
                        if (staffUserID === void 0) { staffUserID = null; }
                        if (studentUserID === void 0) { studentUserID = null; }
                        if (startDatetime === void 0) { startDatetime = null; }
                        if (endDatetime === void 0) { endDatetime = null; }
                        if (ignoreWorkRules === void 0) { ignoreWorkRules = false; }
                        if (selectedLessons === void 0) { selectedLessons = null; }
                        var selectedLessonsCopy = OnlinePrivateLessonMgr.ReduceObjectSizeForAPIcall(selectedLessons);
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetAvailableTimeSlots';
                        var payload = {
                            'skillID': skillID,
                            'staffUserID': staffUserID,
                            'studentUserID': studentUserID,
                            'orderDetailID': orderDetailID,
                            'startDatetime': startDatetime ? startDatetime.toTZNeutralString() : '',
                            'endDatetime': endDatetime ? endDatetime.toTZNeutralString() : '',
                            'studentTimeZoneTypeID': studentTimeZoneTypeID,
                            'ignoreWorkRules': ignoreWorkRules ? 1 : 0,
                            'selectedLessons': selectedLessonsCopy,
                        };
                        return this.common.$http.post(url, payload)
                            .then(function (response) {
                            var results = response.data;
                            for (var _i = 0, results_2 = results; _i < results_2.length; _i++) {
                                var dateDTO = results_2[_i];
                                dateDTO.startTime = Pulse.Utils.JS.dateTimeStrToDateObj(dateDTO.startTime);
                            }
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getAvailableStaff = function (skillIDs, studentUserID, orderDetailID, startDatetimes, studentTimeZoneTypeID, ignoreWorkRules, selectedLessons) {
                        if (studentUserID === void 0) { studentUserID = null; }
                        if (startDatetimes === void 0) { startDatetimes = null; }
                        if (ignoreWorkRules === void 0) { ignoreWorkRules = false; }
                        if (selectedLessons === void 0) { selectedLessons = null; }
                        var selectedLessonsCopy = OnlinePrivateLessonMgr.ReduceObjectSizeForAPIcall(selectedLessons);
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetAvailableStaffForMulitpleLessons';
                        var payload = {
                            'skillIDs': skillIDs,
                            'studentUserID': studentUserID || '',
                            'orderDetailID': orderDetailID,
                            'startDatetimes': startDatetimes ? startDatetimes.map(function (t) { return t.toTZNeutralString(); }) : '',
                            'studentTimeZoneTypeID': studentTimeZoneTypeID,
                            'ignoreWorkRules': ignoreWorkRules ? 1 : 0,
                            'selectedLessons': selectedLessonsCopy,
                        };
                        return this.common.$http.post(url, payload)
                            .then(function (response) {
                            var results = response.data;
                            for (var _i = 0, results_3 = results; _i < results_3.length; _i++) {
                                var dateDTO = results_3[_i];
                                dateDTO.earliestDate = Pulse.Utils.JS.dateTimeStrToDateObj(dateDTO.earliestDate);
                                if (dateDTO.matchDateTimes && dateDTO.matchDateTimes.length) {
                                    dateDTO.matchDateTimes = dateDTO.matchDateTimes.map(function (datetimeStr, idx) { return Pulse.Utils.JS.dateTimeStrToDateObj(datetimeStr); });
                                }
                            }
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getAvailableSessionsCount = function (orderDetailID) {
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_GetAvailableSessionsCount?orderDetailID=' + orderDetailID;
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {}
                        })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.sendSessionSummaryEmail = function (sessionSummary) {
                        var _this = this;
                        sessionSummary.productUrls = [];
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_SendSessionSummaryEmail';
                        return this.common.$http.post(url, sessionSummary)
                            .then(function (response) {
                            var result = response.data;
                            return _this.formatSessionSummaryDates(result);
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.scheduleLesson = function (skillID, staffUserID, studentUserID, orderDetailID, startDatetime, studentTimeZoneTypeID, ignoreWorkRules, isRescheduling) {
                        if (ignoreWorkRules === void 0) { ignoreWorkRules = false; }
                        if (isRescheduling === void 0) { isRescheduling = false; }
                        var url = this.common.config.webApi_NonBreeze + (isRescheduling ? '/OnlinePrivateLesson_RescheduleLesson' : '/OnlinePrivateLesson_ScheduleLesson');
                        return this.common.$http.get(url, {
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            params: {
                                'skillID': skillID,
                                'staffUserID': staffUserID,
                                'studentUserID': studentUserID,
                                'orderDetailID': orderDetailID,
                                'startDatetime': startDatetime ? startDatetime.toTZNeutralString() : '',
                                'studentTimeZoneTypeID': studentTimeZoneTypeID,
                                'ignoreWorkRules': ignoreWorkRules ? 1 : 0,
                            },
                        })
                            .then(function (response) {
                            return;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.scheduleMultipleLessons = function (studentUserID, studentTimeZoneTypeID, ignoreWorkRules, selectedLessons) {
                        if (studentUserID === void 0) { studentUserID = null; }
                        if (ignoreWorkRules === void 0) { ignoreWorkRules = false; }
                        if (selectedLessons === void 0) { selectedLessons = null; }
                        var selectedLessonsCopy = OnlinePrivateLessonMgr.ReduceObjectSizeForAPIcall(selectedLessons);
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_ScheduleMulitpleLessons';
                        var payload = {
                            'studentUserID': studentUserID,
                            'studentTimeZoneTypeID': studentTimeZoneTypeID,
                            'ignoreWorkRules': ignoreWorkRules ? 1 : 0,
                            'selectedLessons': selectedLessonsCopy,
                        };
                        return this.common.$http.post(url, payload)
                            .then(function (response) {
                            var results = response.data;
                            for (var _i = 0, results_4 = results; _i < results_4.length; _i++) {
                                var dateDTO = results_4[_i];
                                dateDTO.dateTime = Pulse.Utils.JS.dateTimeStrToDateObj(dateDTO.dateTime);
                            }
                            return results;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.cancelLesson = function (orderDetailID) {
                        var cancelLessonPayload = {
                            clientUserID: this.pulseContext.actingAsUser.userID,
                            orderDetailID: orderDetailID,
                            instructorUserID: null
                        };
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_CancelScheduledLesson';
                        return this.common.$http.post(url, cancelLessonPayload)
                            .then(function (response) {
                            var result = response.data;
                            return result;
                        });
                    };
                    OnlinePrivateLessonMgr.FormatFullName = function (student) {
                        return student.firstName + " " + (student.preferredName ? '(' + student.preferredName + ')' : '') + " " + student.lastName;
                    };
                    OnlinePrivateLessonMgr.prototype.formatSessionSummaryDates = function (sessionSummary) {
                        sessionSummary.expiryDate = sessionSummary.expiryDate ? moment(sessionSummary.expiryDate).toDate() : null;
                        sessionSummary.createdDate = sessionSummary.createdDate ? moment(sessionSummary.createdDate).toDate() : null;
                        sessionSummary.lastUpdatedDate = sessionSummary.lastUpdatedDate ? moment(sessionSummary.lastUpdatedDate).toDate() : null;
                        return sessionSummary;
                    };
                    OnlinePrivateLessonMgr.prototype.previewSessionSummaryEmail = function (sessionSummary) {
                        sessionSummary.productUrls = [];
                        var url = this.common.config.webApi_NonBreeze + '/OnlinePrivateLesson_PreviewSessionSummaryEmail';
                        return this.common.$http.post(url, sessionSummary)
                            .then(function (response) {
                            var result = response.data;
                            return result;
                        });
                    };
                    OnlinePrivateLessonMgr.prototype.getSessionStatusStr = function (session) {
                        if (!session || !angular.isNumber(session.statusTypeID))
                            return;
                        if (session.statusTypeID == Common.Enums.OPLStatus.Unscheduled
                            || session.statusTypeID == Common.Enums.OPLStatus.Invalid) {
                            return "<b>" + session.statusStr + "</b>";
                        }
                        var formatStr = 'YYYY-MM-DD';
                        var startDate = null;
                        if (!String.isNullOrWhitespace(session.instrTimeZoneClientStr)) {
                            var sessionStartDate = session.startDateTimeUTC ? moment(session.startDateTimeUTC).toDate() : null;
                            if (!angular.isDate(sessionStartDate))
                                return session.statusStr;
                            var startDateTimeLocal = session.startDateTimeUTC ? Managers.TimeZoneMgr.convertDateTimeFromUTC(session.startDateTimeUTC, session.instrTimeZoneClientStr) : '';
                            startDate = startDateTimeLocal ? moment(startDateTimeLocal).format(formatStr) : '';
                        }
                        var expDate = moment(Pulse.Utils.JS.DTZeroHourPreviousDayAdjustForDisplay(session.expiryDate)).format(formatStr);
                        switch (session.statusTypeID) {
                            case Common.Enums.OPLStatus.Scheduled:
                                if (this.isSessionExpired(session)) {
                                    return "<b>Expired</b> on " + expDate + " Pacific Time";
                                }
                                return "<b>Scheduled</b> for " + startDate;
                            case Common.Enums.OPLStatus.CompleteDelivered:
                            case Common.Enums.OPLStatus.CompleteEmailSent:
                            case Common.Enums.OPLStatus.CompletePresumed:
                                return "<b>" + session.statusStr + "</b> on " + startDate;
                            case Common.Enums.OPLStatus.UsedNoShow:
                            case Common.Enums.OPLStatus.UsedLateCancellation:
                                return "<b>" + session.statusStr + "</b> " + startDate;
                            case Common.Enums.OPLStatus.AutoExpired:
                                return "<b>" + session.statusStr + "</b> on " + expDate + " Pacific Time";
                            default:
                                return "<b>" + session.statusStr + "</b>";
                        }
                    };
                    OnlinePrivateLessonMgr.prototype.getSessionStatusStrClientHtml = function (session, timeZoneStr) {
                        if (!session || !angular.isNumber(session.statusTypeID) || !timeZoneStr)
                            return;
                        var startDateTimeLocal = session.startDateTimeUTC ? Managers.TimeZoneMgr.convertDateTimeFromUTC(session.startDateTimeUTC, timeZoneStr) : '';
                        var startDate = startDateTimeLocal ? moment(startDateTimeLocal).format('dddd MMM D, YYYY') : '';
                        var statusStr = session.statusStrClient;
                        switch (session.statusTypeID) {
                            case Common.Enums.OPLStatus.Unscheduled:
                                return "<span class=\"text-green font-weight-bold\">" + statusStr + "!</span>";
                            case Common.Enums.OPLStatus.Scheduled:
                                return "<span class=\"text-primary font-weight-bold\">" + statusStr + "</span> for " + startDate;
                            case Common.Enums.OPLStatus.CompleteDelivered:
                            case Common.Enums.OPLStatus.CompleteEmailSent:
                            case Common.Enums.OPLStatus.CompletePresumed:
                                return "<span class=\"text-dark font-weight-bold\"><strong>" + statusStr + "</strong></span> on " + startDate;
                            case Common.Enums.OPLStatus.UsedLateCancellation:
                                return "<span class=\"text-danger font-weight-bold\">" + statusStr + "</span> for " + startDate;
                            case Common.Enums.OPLStatus.UsedNoShow:
                                return "<span class=\"text-danger font-weight-bold\">" + statusStr + "</span> for " + startDate;
                            case Common.Enums.OPLStatus.Invalid:
                                return "<span class=\"text-danger font-weight-bold\">" + statusStr + "</span>";
                            default:
                                return statusStr;
                        }
                    };
                    OnlinePrivateLessonMgr.prototype.isSessionAvailable = function (session) {
                        if (!session || !session.statusTypeID)
                            return false;
                        return (session.statusTypeID == Common.Enums.OPLStatus.Unscheduled)
                            && !this.isSessionExpired(session);
                    };
                    OnlinePrivateLessonMgr.prototype.isSessionExpired = function (session) {
                        if (!session || !session.expiryDate)
                            return false;
                        return this.pulseContext.serverDateTime >= session.expiryDate;
                    };
                    OnlinePrivateLessonMgr.prototype.isSessionStartMoreThanXSecondsInFuture = function (session, seconds) {
                        if (seconds === void 0) { seconds = 0; }
                        if (!session || session.statusTypeID != Common.Enums.OPLStatus.Scheduled || !session.startDateTimeUTC)
                            return false;
                        var sessionStartTime = Managers.TimeZoneMgr.convertDateTimeFromUTC(session.startDateTimeUTC, this.pulseContext.serverTimeZoneStr);
                        if (seconds !== 0) {
                            sessionStartTime = moment(sessionStartTime).subtract(seconds, 'seconds').toDate();
                        }
                        return this.pulseContext.serverDateTime < sessionStartTime;
                    };
                    OnlinePrivateLessonMgr.prototype.isSessionExpandable = function (session) {
                        if (!session || !session.statusTypeID)
                            return false;
                        var expired = this.isSessionExpired(session);
                        return (!expired && session.statusTypeID != Common.Enums.OPLStatus.Invalid)
                            || (expired
                                && (session.statusTypeID == Common.Enums.OPLStatus.Scheduled
                                    || session.statusTypeID == Common.Enums.OPLStatus.CompleteDelivered
                                    || session.statusTypeID == Common.Enums.OPLStatus.CompleteEmailSent));
                    };
                    OnlinePrivateLessonMgr.prototype.isScheduledInPulse = function (sessionSummary) {
                        if (!sessionSummary)
                            return false;
                        return !(String.isNullOrWhitespace(sessionSummary.meetingID) && String.isNullOrWhitespace(sessionSummary.meetingURL));
                    };
                    OnlinePrivateLessonMgr.IsSubscriptionSuspended = function (subscription) {
                        return subscription.failedPaymentCount >= 3;
                    };
                    OnlinePrivateLessonMgr.prototype.isOPL3 = function () {
                        return this.pulseContext.isImpersonating && this.pulseContext.hasAnyRolesAndLevels(Common.Enums.UserRoleType.OPLStaff, 3);
                    };
                    OnlinePrivateLessonMgr.prototype.isOPL3_Only = function () {
                        return this.pulseContext.isImpersonating && !this.pulseContext.hasRolesOtherThan(Common.Enums.UserRoleType.Public, Common.Enums.UserRoleType.OPLStaff, 3, Common.Enums.UserRoleType.OnlineInstructor, 3);
                    };
                    OnlinePrivateLessonMgr.ReduceObjectSizeForAPIcall = function (selectedLessons) {
                        return selectedLessons != null ? selectedLessons.map(function (val) {
                            var _a, _b;
                            var newval = __assign({}, val);
                            newval.topicSkillID = (_a = val.topic) === null || _a === void 0 ? void 0 : _a.skillID;
                            newval.instructorUserID = (_b = val.instructor) === null || _b === void 0 ? void 0 : _b.userID;
                            delete newval.topic;
                            delete newval.instructor;
                            return newval;
                        }) : null;
                    };
                    OnlinePrivateLessonMgr.ParseNameAndPacksize = function (productName) {
                        var productNamePart1, productNamePart2;
                        if (productName) {
                            var prodNameParts = productName.split(OnlinePrivateLessonMgr.PRODUCT_NAME_PACKSIZE_DELIMITER);
                            productNamePart1 = Pulse.Utils.JS.truncateLastOccuranceOf(productName, OnlinePrivateLessonMgr.PRODUCT_NAME_PACKSIZE_DELIMITER);
                            productNamePart2 = prodNameParts.length > 1 ? prodNameParts[prodNameParts.length - 1].trim() : "";
                        }
                        return { productNamePart1: productNamePart1, productNamePart2: productNamePart2 };
                    };
                    OnlinePrivateLessonMgr.CLASS_NAME = 'OnlinePrivateLessonMgr';
                    OnlinePrivateLessonMgr.PRODUCT_NAME_PACKSIZE_DELIMITER = '-';
                    return OnlinePrivateLessonMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.OnlinePrivateLessonMgr = OnlinePrivateLessonMgr;
                (function (OnlinePrivateLessonMgr) {
                    ;
                })(OnlinePrivateLessonMgr = Managers.OnlinePrivateLessonMgr || (Managers.OnlinePrivateLessonMgr = {}));
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var OrderMgr = (function (_super) {
                    __extends(OrderMgr, _super);
                    function OrderMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, OrderMgr.CLASS_NAME) || this;
                    }
                    OrderMgr.prototype.cancelOrderDetail = function (orderDetailID, reasonTypeID) {
                        var request = {};
                        request.orderDetailID = orderDetailID;
                        request.reasonTypeID = reasonTypeID;
                        var url = this.common.config.webApi_NonBreeze + "/Order_CancelOrderDetail";
                        var jsonString = JSON.stringify(request);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } });
                    };
                    OrderMgr.registeredAs = 'OrderMgr';
                    OrderMgr.CLASS_NAME = OrderMgr.registeredAs;
                    return OrderMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.OrderMgr = OrderMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var TimeZoneMgr = (function (_super) {
                    __extends(TimeZoneMgr, _super);
                    function TimeZoneMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, TimeZoneMgr.CLASS_NAME) || this;
                        _this._dateInContext = null;
                        _this._timezones = null;
                        _this._ianaTZ = null;
                        _this._dateInContext = dateInContext;
                        return _this;
                    }
                    TimeZoneMgr.prototype.loadTimeZones = function (refreshCache) {
                        var _this = this;
                        if (refreshCache === void 0) { refreshCache = false; }
                        var defer = this.common.$q.defer();
                        if (!refreshCache && this._timezones != null) {
                            defer.resolve(this._timezones);
                        }
                        else {
                            defer.promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Common.Enums.TypeClassType.TimeZone, refreshCache)
                                .then(function (data) {
                                _this._ianaTZ = {};
                                _this._timezones = data;
                                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                                    var t = data_1[_i];
                                    _this._ianaTZ[t.typeExtraString] = t.typeID;
                                    _this._ianaTZ[t.typeID] = t.typeExtraString;
                                }
                                _this.browserTimeZoneTypeID = _this._ianaTZ[TimeZoneMgr.browserTimeZoneStr];
                                return data;
                            });
                        }
                        return defer.promise;
                    };
                    TimeZoneMgr.prototype.getClientTimeZoneType = function (timezoneStr) {
                        var _this = this;
                        if (this._ianaTZ == null) {
                            throw new Error("Must call TimeZoneMgr.loadTimeZones() before hand.");
                        }
                        var defer = this.common.$q.defer();
                        if (this._ianaTZ[timezoneStr] > 0) {
                            defer.resolve(this._ianaTZ[timezoneStr]);
                        }
                        else {
                            var url = this.common.config.webApi_NonBreeze + '/User_GetPulseTimeZoneTypeID?clientTimeZoneStr=' + timezoneStr;
                            defer.promise = this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                                .then(function (response) {
                                var results = response.data;
                                _this._ianaTZ[timezoneStr] = results;
                                _this._ianaTZ[results] = timezoneStr;
                                return results;
                            });
                        }
                        return defer.promise;
                    };
                    TimeZoneMgr.prototype.convertDateTimeFromUTC = function (utcDateTimeStr, tzTypeID) {
                        if (this._ianaTZ == null) {
                            throw new Error("Must call TimeZoneMgr.loadTimeZones() before hand.");
                        }
                        return TimeZoneMgr.convertDateTimeFromUTC(utcDateTimeStr, this._ianaTZ[tzTypeID]);
                    };
                    TimeZoneMgr.prototype.convertDateTimeToUTC = function (dateTime, tzTypeIDorString) {
                        if (this._ianaTZ == null) {
                            throw new Error("Must call TimeZoneMgr.loadTimeZones() before hand.");
                        }
                        tzTypeIDorString = angular.isNumber(tzTypeIDorString) ? this._ianaTZ[tzTypeIDorString] : tzTypeIDorString;
                        return TimeZoneMgr.convertDateTimeToUTC(dateTime, tzTypeIDorString);
                    };
                    TimeZoneMgr.prototype.convertDateTimeFromTZaToTZb = function (dateTime, tzaTypeIDorString, tzbTypeIDorString) {
                        if (this._ianaTZ == null) {
                            throw new Error("Must call TimeZoneMgr.loadTimeZones() before hand.");
                        }
                        if (angular.isDate(dateTime)) {
                            tzaTypeIDorString = angular.isNumber(tzaTypeIDorString) ? this._ianaTZ[tzaTypeIDorString] : tzaTypeIDorString;
                            tzbTypeIDorString = angular.isNumber(tzbTypeIDorString) ? this._ianaTZ[tzbTypeIDorString] : tzbTypeIDorString;
                            if (tzaTypeIDorString == tzbTypeIDorString)
                                return dateTime;
                            var dtStr = moment.tz(dateTime.toTZNeutralString(), tzaTypeIDorString)
                                .tz(tzbTypeIDorString).format('YYYY-MM-DD HH:mm:ss');
                            return moment(dtStr, 'YYYY-MM-DD HH:mm:ss').toDate();
                        }
                    };
                    TimeZoneMgr.convertDateTimeFromUTC = function (utcDateTimeStr, tz) {
                        if (!String.isNullOrWhitespace(utcDateTimeStr) && !String.isNullOrWhitespace(tz)) {
                            var dtStr = moment.utc(utcDateTimeStr).tz(tz).format('YYYY-MM-DD HH:mm:ss');
                            return moment(dtStr, 'YYYY-MM-DD HH:mm:ss').toDate();
                        }
                        return null;
                    };
                    TimeZoneMgr.convertDateTimeToUTC = function (dateTime, tz) {
                        if (angular.isDate(dateTime)) {
                            var localDTStr = moment(dateTime).format("YYYY-MM-DD HH:mm:ss");
                            var dtStr = moment.tz(localDTStr, tz).utc().format('YYYY-MM-DD HH:mm:ss');
                            return moment(dtStr, 'YYYY-MM-DD HH:mm:ss').toDate();
                        }
                    };
                    TimeZoneMgr.CLASS_NAME = 'TimeZoneMgr';
                    TimeZoneMgr.browserTimeZoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    return TimeZoneMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.TimeZoneMgr = TimeZoneMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var ChannelPreferenceMgr = (function (_super) {
                    __extends(ChannelPreferenceMgr, _super);
                    function ChannelPreferenceMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, ChannelPreferenceMgr.CLASS_NAME) || this;
                    }
                    ChannelPreferenceMgr.prototype.getContactChannelsByInfoReqID = function (infoRequestID, idHash) {
                        var url = this.common.config.webApi_NonBreeze + '/PreferenceCenter_GetContactChannelsByInfoReqID?'
                            + 'infoRequestID=' + infoRequestID
                            + '&idHash=' + encodeURIComponent(idHash);
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    ChannelPreferenceMgr.prototype.getContactChannelsByUserIDAndHash = function (userID, idHash) {
                        var url = this.common.config.webApi_NonBreeze + '/PreferenceCenter_GetContactChannelsByUserIDAndHash?'
                            + 'userID=' + userID
                            + '&idHash=' + encodeURIComponent(idHash);
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    ChannelPreferenceMgr.prototype.getContactChannelsByUserID = function (userID) {
                        var url = this.common.config.webApi_NonBreeze + '/PreferenceCenter_GetContactChannelsByUserID?userID=' + userID;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    ChannelPreferenceMgr.prototype.subscribe = function (id, idHash, contactChannelTypeID, contactMethod) {
                        var webAPIUrl = this.common.config.webApi_NonBreeze + '/PreferenceCenter_Subscribe';
                        var formData = {
                            userOrInfoReqID: id,
                            idHash: idHash,
                            contactChannelTypeID: contactChannelTypeID,
                            contactMethod: contactMethod
                        };
                        var jsonString = JSON.stringify(formData);
                        return this.common.$http.post(webAPIUrl, jsonString, {
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    ChannelPreferenceMgr.prototype.unsubscribe = function (id, idHash, contactChannelTypeID, contactMethod) {
                        var webAPIUrl = this.common.config.webApi_NonBreeze + '/PreferenceCenter_Unsubscribe';
                        var formData = {
                            userOrInfoReqID: id,
                            idHash: idHash,
                            contactChannelTypeID: contactChannelTypeID,
                            contactMethod: contactMethod
                        };
                        var jsonString = JSON.stringify(formData);
                        return this.common.$http.post(webAPIUrl, jsonString, {
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    ChannelPreferenceMgr.prototype.subscribeByUserID = function (userID, contactChannelTypeID, contactMethod) {
                        var webAPIUrl = this.common.config.webApi_NonBreeze + '/PreferenceCenter_SubscribeByUserID';
                        var formData = {
                            userID: userID,
                            contactChannelTypeID: contactChannelTypeID,
                            contactMethod: contactMethod
                        };
                        var jsonString = JSON.stringify(formData);
                        return this.common.$http.post(webAPIUrl, jsonString, {
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    ChannelPreferenceMgr.prototype.unsubscribeByUserID = function (userID, contactChannelTypeID, contactMethod) {
                        var webAPIUrl = this.common.config.webApi_NonBreeze + '/PreferenceCenter_UnsubscribeByUserID';
                        var formData = {
                            userID: userID,
                            contactChannelTypeID: contactChannelTypeID,
                            contactMethod: contactMethod
                        };
                        var jsonString = JSON.stringify(formData);
                        return this.common.$http.post(webAPIUrl, jsonString, {
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    ChannelPreferenceMgr.prototype.subscribeToDefaultChannels = function () {
                        var webAPIUrl = this.common.config.webApi_NonBreeze + '/PreferenceCenter_SubscribeToDefaultChannels';
                        return this.common.$http.post(webAPIUrl, null, {
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    ChannelPreferenceMgr.prototype.setOptOutOnContactMethod = function (userOrInfoReqID, idHash, email, contactMethodTypeID, contactMethod, optOut) {
                        var webAPIUrl = this.common.config.webApi_NonBreeze + '/PreferenceCenter_SetOptOutOnContactMethod';
                        var formData = {
                            userOrInfoReqID: userOrInfoReqID,
                            idHash: idHash,
                            emailAddress: email,
                            contactMethodTypeID: contactMethodTypeID,
                            contactMethod: contactMethod,
                            optOut: optOut,
                        };
                        var jsonString = JSON.stringify(formData);
                        return this.common.$http.post(webAPIUrl, jsonString, {
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    ChannelPreferenceMgr.prototype.setOptOutByInfoRequestID = function (infoRequestID, idHash, optOut, requestPromotions) {
                        var webAPIUrl = this.common.config.webApi_NonBreeze + '/PreferenceCenter_SetOptOutByInfoRequestID';
                        var formData = {
                            infoRequestID: infoRequestID,
                            idHash: idHash,
                            optOut: optOut,
                            requestPromotions: requestPromotions,
                        };
                        var jsonString = JSON.stringify(formData);
                        return this.common.$http.post(webAPIUrl, jsonString, {
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    ChannelPreferenceMgr.prototype.setOptOutOnContactMethodByUserID = function (userID, contactMethodTypeID, contactMethod, optOut) {
                        var webAPIUrl = this.common.config.webApi_NonBreeze + '/PreferenceCenter_SetOptOutOnContactMethodByUserID';
                        var formData = {
                            userID: userID,
                            contactMethodTypeID: contactMethodTypeID,
                            contactMethod: contactMethod,
                            optOut: optOut,
                        };
                        var jsonString = JSON.stringify(formData);
                        return this.common.$http.post(webAPIUrl, jsonString, {
                            headers: { 'Content-Type': 'application/json' }
                        });
                    };
                    ChannelPreferenceMgr.CLASS_NAME = 'ChannelPreferenceMgr';
                    return ChannelPreferenceMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.ChannelPreferenceMgr = ChannelPreferenceMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var Cookies = Pulse.Utils.Cookies;
                var RakutenMgr = (function (_super) {
                    __extends(RakutenMgr, _super);
                    function RakutenMgr(common, breezeService, pulseContext) {
                        return _super.call(this, common, breezeService, pulseContext, RakutenMgr.CLASS_NAME) || this;
                    }
                    RakutenMgr.getTrackingID = function () {
                        return Cookies.getCookie(RakutenMgr.RAKUTEN_COOKIE_NAME_SITE_ID, false);
                    };
                    RakutenMgr.transformJSONtoPixelURL = function (orderInfo) {
                        if (!(orderInfo && orderInfo.orderid))
                            return null;
                        var params = {};
                        params['mid'] = RakutenMgr.RAKUTEN_MID;
                        params['ord'] = orderInfo.orderid;
                        params['tr'] = orderInfo.siteid;
                        params['land'] = moment.utc(orderInfo.time_entered).format("YYYYMMDD_HHmm");
                        params['cur'] = orderInfo.currency;
                        var url = QueryStringUtils.AddOrSetQSParams(RakutenMgr.IMAGE_PIXEL_URL_BASE, params);
                        var skulist = '';
                        var qlist = '';
                        var amtlist = '';
                        var namelist = '';
                        for (var _i = 0, _a = orderInfo.items; _i < _a.length; _i++) {
                            var item = _a[_i];
                            var delimiter = orderInfo.items[orderInfo.items.length - 1] !== item ? "|" : "";
                            skulist += encodeURIComponent(item.sku) + delimiter;
                            qlist += item.quantity + delimiter;
                            amtlist += item.amount + delimiter;
                            namelist += encodeURIComponent(item.product_name) + delimiter;
                        }
                        url += "&skulist=" + skulist + "&qlist=" + qlist + "&amtlist=" + amtlist + "&namelist=" + namelist;
                        return url;
                    };
                    RakutenMgr.registerAs = 'RakutenMgr';
                    RakutenMgr.CLASS_NAME = RakutenMgr.registerAs;
                    RakutenMgr.COMPANY_ID = 373;
                    RakutenMgr.RAKUTEN_COOKIE_NAME_SITE_ID = "Rakuten_SiteID";
                    RakutenMgr.RAKUTEN_MID = 50426;
                    RakutenMgr.IMAGE_PIXEL_URL_BASE = "https://track.linksynergy.com/eventnvppixel";
                    return RakutenMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.RakutenMgr = RakutenMgr;
                Pulse.app.service(RakutenMgr.registerAs, [
                    'common',
                    'breezeService',
                    'pulseContextService',
                    RakutenMgr,
                ]);
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var BaseMgr = Pulse.Common.DataAccess.Managers.BaseMgr;
                var RegFlowMgr = (function (_super) {
                    __extends(RegFlowMgr, _super);
                    function RegFlowMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, RegFlowMgr.CLASS_NAME) || this;
                        _this.lookupColors = null;
                        _this.RegFlowStepCollection = {};
                        _this._dateInContext = null;
                        _this._cacheCurrentUpsellProducts = null;
                        _this.userIsComingFromOutside = false;
                        _this._dateInContext = dateInContext;
                        _this._generateRegFlowSteps();
                        return _this;
                    }
                    RegFlowMgr.prototype.setDateInContext = function (date) {
                        this._dateInContext = date;
                    };
                    RegFlowMgr.prototype._generateRegFlowSteps = function () {
                        var i = 0;
                        this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.Default] =
                            new RegFlowMgr.RegFlowStep(this, RegFlowMgr.RegFlowStepEnum.Default, i++, 'Default', 'Default Dispatch', Routes.RegFlow_Default);
                        this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.Location] =
                            new RegFlowMgr.RegFlowStep(this, RegFlowMgr.RegFlowStepEnum.Location, i++, 'Location', 'Choose Location', Routes.RegFlow_ChooseLocations);
                        this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.PathGenre] =
                            new RegFlowMgr.RegFlowStep(this, RegFlowMgr.RegFlowStepEnum.PathGenre, i++, 'Path', 'Dummy', null);
                        this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.AgeFilter] =
                            new RegFlowMgr.RegFlowStep(this, RegFlowMgr.RegFlowStepEnum.AgeFilter, i++, 'Age', 'Dummy', null);
                        this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.AVChart] = new RegFlowMgr.RegFlowStep(this, RegFlowMgr.RegFlowStepEnum.AVChart, i++, 'Courses', 'AV. Chart', Routes.RegFlow_AvailChartFilters);
                        this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.ShoppingCart] = new RegFlowMgr.RegFlowStep(this, RegFlowMgr.RegFlowStepEnum.ShoppingCart, i++, 'Shopping Cart', 'Shopping cart', Routes.RegFlow_ShoppingCart);
                        if (this.common.config.skipRegFlow_OPL_Upsell !== true) {
                            this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.Upsell] = new RegFlowMgr.RegFlowStep(this, RegFlowMgr.RegFlowStepEnum.Upsell, i++, 'Private Lessons', 'Private Lessons', Routes.RegFlow_Upsell);
                        }
                        this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.OrderSummary] = new RegFlowMgr.RegFlowStep(this, RegFlowMgr.RegFlowStepEnum.OrderSummary, i++, 'Order Summary', 'Order Summary', Routes.RegFlow_OrderSummary);
                        this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.Billing] = new RegFlowMgr.RegFlowStep(this, RegFlowMgr.RegFlowStepEnum.Billing, i++, 'Billing Information', 'Billing Information', Routes.RegFlow_Billing);
                        this.stepsOrderedArray = this._getOrderedStepsList();
                        this.filterSteps = [
                            this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.Location],
                            this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.PathGenre],
                            this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.AgeFilter],
                        ];
                    };
                    RegFlowMgr.prototype._getOrderedStepsList = function () {
                        var arr = [];
                        for (var step in this.RegFlowStepCollection) {
                            arr.push(this.RegFlowStepCollection[step]);
                        }
                        arr.sort(function (a, b) {
                            return a.orderNumber - b.orderNumber;
                        });
                        return arr;
                    };
                    Object.defineProperty(RegFlowMgr.prototype, "cartType", {
                        get: function () {
                            return this.pulseContext.shoppingCartType;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "userBrowsingMgr", {
                        get: function () {
                            if (!this._userBrowsingMgr) {
                                this._userBrowsingMgr
                                    = new Managers.UserBrowsingMgr(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            }
                            return this._userBrowsingMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "locationFinderMgr", {
                        get: function () {
                            if (!this._locationFinderMgr) {
                                this._locationFinderMgr = new Managers.LocationFinderMgr(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            }
                            return this._locationFinderMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "genreFinderMgr", {
                        get: function () {
                            if (!(this._genreFinderMgr)) {
                                this._genreFinderMgr = new Managers.GenreFinderMgr(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            }
                            return this._genreFinderMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "experienceFinderMgr", {
                        get: function () {
                            if (!this._experienceFinderMgr) {
                                this._experienceFinderMgr = new Managers.ExperienceFinderMgr(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            }
                            return this._experienceFinderMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "ageFilterMgr", {
                        get: function () {
                            if (!this._ageFilterMgr) {
                                this._ageFilterMgr = this.common.$injector.get(Managers.AgeFilterMgr.registeredAs);
                            }
                            return this._ageFilterMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "availChartMgr", {
                        get: function () {
                            if (!(this._availChartMgr)) {
                                this._availChartMgr = this.common.$injector.get(Managers.AvailChartMgr.registeredAs);
                            }
                            this._availChartMgr.setDateInContext(this._dateInContext);
                            return this._availChartMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "paymentMgr", {
                        get: function () {
                            if (!(this._paymentMgr)) {
                                this._paymentMgr = new Managers.PaymentMgr(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            }
                            return this._paymentMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "onlinePrivateLessonMgr", {
                        get: function () {
                            if (!(this._onlinePrivateLessonMgr))
                                this._onlinePrivateLessonMgr = new Managers.OnlinePrivateLessonMgr(this.common, this.breezeService, this.pulseContext);
                            return this._onlinePrivateLessonMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "shoppingCartMgr", {
                        get: function () {
                            if (!(this._shoppingCartMgr))
                                this._shoppingCartMgr = new Managers.ShoppingCartMgr(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            return this._shoppingCartMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "utmParamsMgr", {
                        get: function () {
                            if (!(this._utmParamsMgr)) {
                                this._utmParamsMgr = new Managers.UtmParamsMgr(this.common, this.breezeService, this.pulseContext, this._dateInContext);
                            }
                            return this._utmParamsMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RegFlowMgr.prototype, "prodAvailabilityMgr", {
                        get: function () {
                            if (!(this._prodAvailabilityMgr)) {
                                this._prodAvailabilityMgr = new Managers.ProdAvailabilityMgr(this.common, this.breezeService, this.pulseContext);
                            }
                            return this._prodAvailabilityMgr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RegFlowMgr.prototype.getCanOverrideRestrictions = function (userID) {
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetCanOverrideRestrictions')
                            .withParameters({
                            userID: userID,
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                    };
                    RegFlowMgr.prototype.getIsLoggedInUserTermStaff = function () {
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetIsContextUserTermStaff');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    RegFlowMgr.prototype.getLookupColors = function () {
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetColors');
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    RegFlowMgr.prototype.getLocationDateRanges = function (locationID) {
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetLocationDateRanges')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            locationID: locationID,
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                    };
                    RegFlowMgr.prototype.getProductQuantitiesByLocationDateRangeID = function (locationCatDateRangeID, catalogTypeID, productID) {
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetProductQuantitiesByLocationDateRangeID')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            locationCatDateRangeID: locationCatDateRangeID,
                            catalogTypeID: catalogTypeID,
                            productID: productID,
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                    };
                    RegFlowMgr.prototype.getProductQuantitiesByLocationIDDivisionID = function (locationID, divisionID, catalogTypeID, subCategoryTypeID, locationCatDateRangeID) {
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetProductQuantitiesByLocationIDDivisionID')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            locationID: locationID,
                            divisionID: divisionID,
                            catalogTypeID: catalogTypeID,
                            subCategoryTypeID: subCategoryTypeID,
                            locationCatDateRangeID: locationCatDateRangeID,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    RegFlowMgr.prototype.getProductQuantity = function (productID) {
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetProductQuantity')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            productID: productID,
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                        return result;
                    };
                    RegFlowMgr.prototype.getProducts = function (locationCatDateRangeID, catalogTypeID) {
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetProducts')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            locationCatDateRangeID: locationCatDateRangeID,
                            catalogTypeID: catalogTypeID,
                            dateInContext: this._dateInContext,
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                    };
                    RegFlowMgr.prototype.getCurrentUpsellProducts = function (productIDs, doNotImpersonate) {
                        if (doNotImpersonate === void 0) { doNotImpersonate = false; }
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetCurrentUpsellProducts')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            productIDs: productIDs,
                            doNotImpersonate: doNotImpersonate,
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return data.results;
                        });
                    };
                    RegFlowMgr.prototype.getCustomUpsellProducts = function (productAndTypeIDs) {
                        var _this = this;
                        var query = breeze.EntityQuery
                            .from('RegFlow_GetCustomUpsellProducts')
                            .withParameters({
                            productAndTypeIDs: productAndTypeIDs,
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            if (_this.shoppingCartMgr && _this.shoppingCartMgr.customTutorProductNames) {
                                for (var i = 0, il = _this.shoppingCartMgr.customTutorProductNames.length; i < il; ++i) {
                                    var o = _this.shoppingCartMgr.customTutorProductNames[i];
                                    for (var j = 0, jl = data.results.length; j < jl; ++j) {
                                        var p = data.results[j];
                                        if (o.productID === p.productID) {
                                            o.productName = p.name;
                                        }
                                    }
                                }
                            }
                            return data.results;
                        });
                    };
                    RegFlowMgr.prototype.loadCurrentUpsellProducts = function (doNotImpersonate, refreshCach) {
                        var _this = this;
                        if (doNotImpersonate === void 0) { doNotImpersonate = false; }
                        if (refreshCach === void 0) { refreshCach = false; }
                        if (!this._cacheCurrentUpsellProducts) {
                            return this.getCurrentUpsellProducts(null, doNotImpersonate)
                                .then(function (data) {
                                _this._cacheCurrentUpsellProducts = data;
                                return data;
                            });
                        }
                        return Promise.resolve(this._cacheCurrentUpsellProducts);
                    };
                    RegFlowMgr.prototype.getRegFlowUserRelationTypes = function () {
                        var filtered = [];
                        var self = this;
                        var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Common.Enums.TypeClassType.UserRelationship)
                            .then(function (data) {
                            angular.forEach(data, function (relationType) {
                                if (RegFlowMgr.regFlowUserRelationTypeIDs.indexOf(relationType.typeID) !== -1) {
                                    filtered.push(relationType);
                                }
                            });
                            return filtered;
                        });
                        return promise;
                    };
                    RegFlowMgr.prototype.getAllUserRelationTypes = function () {
                        var filtered = [];
                        var self = this;
                        var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Common.Enums.TypeClassType.UserRelationship)
                            .then(function (data) {
                            return data;
                        });
                        return promise;
                    };
                    RegFlowMgr.prototype.loadLookupInfo = function () {
                        var promises = new Array();
                        return this.common.$q.all(promises);
                    };
                    RegFlowMgr.prototype.downloadOrderConfirmationPDF = function (orderID) {
                        var url = this.common.config.webApi_NonBreeze
                            + '/RegFlow_DownloadOrderConfirmationPDF?orderID='
                            + orderID.toString();
                        return this.common.$http.get(url, { responseType: 'arraybuffer', headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response;
                        });
                    };
                    RegFlowMgr.prototype.mapStepToManager = function (step) {
                        switch (step) {
                            case RegFlowMgr.RegFlowStepEnum.Location:
                                return this.locationFinderMgr;
                            case RegFlowMgr.RegFlowStepEnum.PathGenre:
                                return this.genreFinderMgr;
                            case RegFlowMgr.RegFlowStepEnum.AgeFilter:
                                return this.ageFilterMgr;
                            case RegFlowMgr.RegFlowStepEnum.AVChart:
                                return this.availChartMgr;
                            case RegFlowMgr.RegFlowStepEnum.ShoppingCart:
                                return this.shoppingCartMgr;
                            case RegFlowMgr.RegFlowStepEnum.Upsell:
                            case RegFlowMgr.RegFlowStepEnum.OrderSummary:
                            case RegFlowMgr.RegFlowStepEnum.Billing:
                            case RegFlowMgr.RegFlowStepEnum.OrderConfirmation:
                            default:
                                throw StringConst.Err_Not_Implemented;
                        }
                    };
                    RegFlowMgr.prototype.restoreFilterState = function (forceRestoreFromStorage) {
                        if (forceRestoreFromStorage === void 0) { forceRestoreFromStorage = false; }
                        for (var _i = 0, _a = this.filterSteps; _i < _a.length; _i++) {
                            var step = _a[_i];
                            step.manager.restoreState(forceRestoreFromStorage);
                        }
                        var promises = new Array();
                        promises.push(this.genreFinderMgr.loadInfo(this.locationFinderMgr.selectedIds, this.experienceFinderMgr.selectedIds));
                        promises.push(this.experienceFinderMgr.loadInfoByLocAndGenre(this.locationFinderMgr.selectedIds, this.genreFinderMgr.selectedIds, true));
                        return this.common.$q.all(promises);
                    };
                    Object.defineProperty(RegFlowMgr.prototype, "noAutoDispatch", {
                        get: function () {
                            var noAutoDispatch = QueryStringUtils.GetParamByName(this.common.$location.url(), QueryStringUtils.REG_FLOW_NO_AUTO_DISPATCH) == 'true';
                            return noAutoDispatch;
                        },
                        set: function (value) {
                            var params = {};
                            params[QueryStringUtils.REG_FLOW_NO_AUTO_DISPATCH] = value;
                            this.common.$location.url(QueryStringUtils.AddOrSetQSParams(this.common.$location.url(), params));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RegFlowMgr.prototype.handleFlow = function (testPathSegment) {
                        var _this = this;
                        if (testPathSegment === void 0) { testPathSegment = ''; }
                        var promises = new Array();
                        this.userIsComingFromOutside = this.isUserComingFromOutside();
                        if (this.userIsComingFromOutside)
                            promises.push(this.restoreFilterState(true)
                                .then(function () {
                                _this.resetAgeFilter();
                            }));
                        else
                            this.resetAgeFilter();
                        if (this.noAutoDispatch) {
                            return;
                        }
                        var currentStep = this.currentStep;
                        var redirectToStep = null;
                        for (var _i = 0, _a = this.filterSteps; _i < _a.length; _i++) {
                            var step = _a[_i];
                            if (!step.manager.hasSelectedItems && step.urlPath !== null) {
                                redirectToStep = step;
                                break;
                            }
                        }
                        var avChartStep = this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.AVChart];
                        if (!redirectToStep && this.lastStepNo != avChartStep.orderNumber) {
                            redirectToStep = avChartStep;
                        }
                        if (redirectToStep) {
                            for (var _b = 0, _c = this.filterSteps; _b < _c.length; _b++) {
                                var step = _c[_b];
                                if (step.orderNumber < redirectToStep.orderNumber) {
                                    step.setToVisited();
                                }
                                else {
                                    break;
                                }
                            }
                        }
                        if (currentStep.id === RegFlowMgr.RegFlowStepEnum.AVChart
                            && !this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.Location].manager.hasSelectedItems) {
                            redirectToStep = this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.Location];
                        }
                        if (redirectToStep && redirectToStep.id !== currentStep.id) {
                            this.goToStep(redirectToStep, false, testPathSegment, true);
                        }
                        else {
                            currentStep.setToVisited();
                        }
                        this.lastStepNo = this.currentStep.orderNumber;
                        return this.common.$q.all(promises);
                    };
                    RegFlowMgr.prototype.resetAgeFilter = function () {
                        if (this.ageFilterMgr.selectedIds.length && this.currentStep.orderNumber < this.RegFlowStepCollection[RegFlowMgr.RegFlowStepEnum.AgeFilter].orderNumber)
                            this.ageFilterMgr.clearAllSelected();
                    };
                    RegFlowMgr.prototype.isUserComingFromOutside = function () {
                        for (var _i = 0, _a = this.filterSteps; _i < _a.length; _i++) {
                            var step = _a[_i];
                            if (step.wasVisited()) {
                                return false;
                            }
                        }
                        return true;
                    };
                    RegFlowMgr.prototype.resetAllSteps = function (clearSelected) {
                        if (clearSelected === void 0) { clearSelected = false; }
                        for (var stepKey in this.RegFlowStepCollection)
                            this.RegFlowStepCollection[stepKey].resetStep(clearSelected);
                    };
                    RegFlowMgr.prototype._resetSteps = function (steps) {
                        if (steps.length)
                            for (var _i = 0, steps_1 = steps; _i < steps_1.length; _i++) {
                                var step = steps_1[_i];
                                step.resetStep(true);
                            }
                    };
                    RegFlowMgr.prototype.nextStep = function (testPathSegment, dummyStep) {
                        if (testPathSegment === void 0) { testPathSegment = ''; }
                        if (dummyStep === void 0) { dummyStep = null; }
                        var currentStep = dummyStep !== null ? dummyStep : this.currentStep;
                        if (currentStep && this.stepsOrderedArray.length > currentStep.orderNumber + 1) {
                            var nextStep = this.stepsOrderedArray[currentStep.orderNumber + 1];
                            if (nextStep.urlPath !== null) {
                                this.goToStep(nextStep, this.noAutoDispatch, testPathSegment);
                            }
                            else {
                                this.nextStep(testPathSegment, nextStep);
                            }
                        }
                        else {
                            throw new Error(StringConst.Err_Not_Supported);
                        }
                    };
                    Object.defineProperty(RegFlowMgr.prototype, "currentStep", {
                        get: function () {
                            var currentRoute = window.location.hash.replace('#/', '/');
                            var qsPosStart = currentRoute.indexOf('?');
                            if (qsPosStart >= 0) {
                                currentRoute = currentRoute.substring(0, qsPosStart);
                            }
                            for (var stepName in this.RegFlowStepCollection) {
                                if (currentRoute == this.RegFlowStepCollection[stepName].urlPath) {
                                    return this.RegFlowStepCollection[stepName];
                                }
                            }
                            throw new Error(StringConst.Err_Not_Supported);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RegFlowMgr.prototype.goToStepByEnum = function (step, noAutoDispatch, testPathSegment, replaceHistory, isCampAtHQ, additionalParams) {
                        if (noAutoDispatch === void 0) { noAutoDispatch = true; }
                        if (testPathSegment === void 0) { testPathSegment = ''; }
                        if (replaceHistory === void 0) { replaceHistory = false; }
                        if (isCampAtHQ === void 0) { isCampAtHQ = false; }
                        this.goToStep(this.RegFlowStepCollection[step], noAutoDispatch, testPathSegment, replaceHistory, isCampAtHQ, additionalParams);
                    };
                    RegFlowMgr.prototype.goToStep = function (step, noAutoDispatch, testPathSegment, replaceHistory, isCampAtHQ, additionalParams) {
                        if (noAutoDispatch === void 0) { noAutoDispatch = true; }
                        if (testPathSegment === void 0) { testPathSegment = ''; }
                        if (replaceHistory === void 0) { replaceHistory = false; }
                        if (isCampAtHQ === void 0) { isCampAtHQ = false; }
                        var urlPath = step.urlPath + testPathSegment
                            + '?' + Pulse.Utils.QueryStringUtils.GetQueryString(this.common.$location.url());
                        var params = {};
                        for (var _i = 0, _a = this.filterSteps; _i < _a.length; _i++) {
                            var step_1 = _a[_i];
                            step_1.manager.addOrSetQSParams(params);
                        }
                        if (noAutoDispatch)
                            params[QueryStringUtils.REG_FLOW_NO_AUTO_DISPATCH] = true;
                        else if (noAutoDispatch === false)
                            params[QueryStringUtils.REG_FLOW_NO_AUTO_DISPATCH] = false;
                        if (isCampAtHQ)
                            params[QueryStringUtils.CAMP_AT_HQ] = true;
                        if (additionalParams) {
                            angular.merge(params, additionalParams);
                        }
                        var $location = this.common.$location.url(QueryStringUtils.AddOrSetQSParams(urlPath, params));
                        if (replaceHistory) {
                            $location.replace();
                        }
                    };
                    RegFlowMgr.registeredAs = 'RegFlowMgr';
                    RegFlowMgr.regFlowUserRelationTypeIDs = [
                        Common.Enums.UserRelationshipType.ParentGuardian,
                        Common.Enums.UserRelationshipType.Other,
                    ];
                    RegFlowMgr.CLASS_NAME = RegFlowMgr.registeredAs;
                    return RegFlowMgr;
                }(BaseMgr));
                Managers.RegFlowMgr = RegFlowMgr;
                (function (RegFlowMgr) {
                    var RegFlowStepEnum;
                    (function (RegFlowStepEnum) {
                        RegFlowStepEnum[RegFlowStepEnum["Default"] = 'Default Dispatch'] = "Default";
                        RegFlowStepEnum[RegFlowStepEnum["Location"] = 'Choose Location'] = "Location";
                        RegFlowStepEnum[RegFlowStepEnum["PathGenre"] = 'Choose Path'] = "PathGenre";
                        RegFlowStepEnum[RegFlowStepEnum["AgeFilter"] = 'Age Filter'] = "AgeFilter";
                        RegFlowStepEnum[RegFlowStepEnum["AVChart"] = 'Availability'] = "AVChart";
                        RegFlowStepEnum[RegFlowStepEnum["ShoppingCart"] = 'Shopping Cart'] = "ShoppingCart";
                        RegFlowStepEnum[RegFlowStepEnum["Upsell"] = 'TechRocket Upsell'] = "Upsell";
                        RegFlowStepEnum[RegFlowStepEnum["OrderSummary"] = 'Order Summary'] = "OrderSummary";
                        RegFlowStepEnum[RegFlowStepEnum["Billing"] = 'Billing Information'] = "Billing";
                        RegFlowStepEnum[RegFlowStepEnum["OrderConfirmation"] = 'Order Confirmation'] = "OrderConfirmation";
                    })(RegFlowStepEnum = RegFlowMgr.RegFlowStepEnum || (RegFlowMgr.RegFlowStepEnum = {}));
                    var RegFlowStep = (function () {
                        function RegFlowStep(regFlowMgr, id, no, displayName, description, urlPath) {
                            this._wasVisited = false;
                            this._manager = null;
                            this._regFlowMgrInstance = regFlowMgr;
                            this.id = id;
                            this.orderNumber = no;
                            this.displayName = displayName;
                            this.description = description;
                            this.urlPath = urlPath;
                        }
                        RegFlowStep.prototype.setToVisited = function () {
                            this._wasVisited = true;
                        };
                        RegFlowStep.prototype.wasVisited = function () {
                            return this._wasVisited;
                        };
                        Object.defineProperty(RegFlowStep.prototype, "manager", {
                            get: function () {
                                return this._regFlowMgrInstance.mapStepToManager(this.id);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        RegFlowStep.prototype.resetStep = function (clearSelected) {
                            if (clearSelected === void 0) { clearSelected = false; }
                            this._wasVisited = false;
                            if (clearSelected)
                                this.manager.clearAllSelected();
                        };
                        return RegFlowStep;
                    }());
                    RegFlowMgr.RegFlowStep = RegFlowStep;
                    var RegFlowStepMgr = (function (_super) {
                        __extends(RegFlowStepMgr, _super);
                        function RegFlowStepMgr(common, breezeService, pulseContext, loggingId, _storageKey) {
                            var _this = _super.call(this, common, breezeService, pulseContext, loggingId) || this;
                            _this._storageKey = _storageKey;
                            _this.selectedIds = [];
                            _this.optionItems = null;
                            return _this;
                        }
                        Object.defineProperty(RegFlowStepMgr.prototype, "selectedItems", {
                            get: function () {
                                var _this = this;
                                if (!this.optionItems)
                                    return null;
                                return this.optionItems.filter(function (item) {
                                    return _this.selectedIds.indexOf(item.iD) !== -1;
                                });
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(RegFlowStepMgr.prototype, "hasSelectedItems", {
                            get: function () {
                                return this.selectedIds && this.selectedIds.length > 0;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        RegFlowStepMgr.prototype.restoreState = function (forceRestoreFromStorage) {
                            if (forceRestoreFromStorage === void 0) { forceRestoreFromStorage = false; }
                            if (forceRestoreFromStorage || !this.selectedIds || this.selectedIds.length === 0) {
                                this.selectedIds = this.savedSelection;
                            }
                            var cdrid = this.common.$location.search()[QueryStringUtils.CATALOG_DATE_RANGE_ID];
                            this.saveState(cdrid);
                        };
                        Object.defineProperty(RegFlowStepMgr.prototype, "savedSelection", {
                            get: function () {
                                var selectedIDs;
                                var expIDs = QueryStringUtils.GetParamByName(this.common.$location.url(), this._storageKey);
                                if (angular.isArray(expIDs))
                                    selectedIDs = expIDs.map(function (lid) { return parseInt(lid, 10); });
                                else if (angular.isString(expIDs))
                                    selectedIDs = [parseInt(expIDs, 10)];
                                else {
                                    selectedIDs = selectedIDs ? selectedIDs : [];
                                }
                                return selectedIDs;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        RegFlowStepMgr.prototype.saveState = function (catalogDateRangID) {
                            if (catalogDateRangID === void 0) { catalogDateRangID = undefined; }
                            var url = this.common.$location.url();
                            var params = {};
                            params[this._storageKey] = this.selectedIds;
                            if (!isNaN(catalogDateRangID) && catalogDateRangID > 0) {
                                params[QueryStringUtils.CATALOG_DATE_RANGE_ID] = catalogDateRangID;
                            }
                            else {
                                params[QueryStringUtils.CATALOG_DATE_RANGE_ID] = null;
                            }
                            url = QueryStringUtils.AddOrSetQSParams(url, params);
                            this.common.$location.url(url).replace();
                        };
                        RegFlowStepMgr.prototype.addOrSetQSParams = function (params) {
                            return params[this._storageKey] = this.selectedIds;
                        };
                        RegFlowStepMgr.prototype.removeSelectionNotInContext = function () {
                            if (this.selectedIds !== null && this.selectedIds.length) {
                                var availableOptionsIs_1 = this.optionItems.map(function (option) { return option.iD; });
                                var availableselectedIDs = this.selectedIds.filter(function (ID) { return availableOptionsIs_1.indexOf(ID) !== -1; });
                                if (this.selectedIds.length !== availableselectedIDs.length)
                                    this.saveState();
                                this.selectedIds = availableselectedIDs;
                            }
                        };
                        RegFlowStepMgr.prototype.addOrRemoveFromSelected = function (locationID, isSelected, saveState, catalogDateRangeID) {
                            if (isSelected === void 0) { isSelected = true; }
                            if (saveState === void 0) { saveState = false; }
                            if (catalogDateRangeID === void 0) { catalogDateRangeID = null; }
                            if (isSelected) {
                                if (this.selectedIds.indexOf(locationID) < 0) {
                                    this.selectedIds.push(locationID);
                                }
                                if (saveState) {
                                    this.saveState(catalogDateRangeID);
                                }
                            }
                            else if (!isSelected) {
                                var index = this.selectedIds.indexOf(locationID);
                                if (index >= 0) {
                                    this.selectedIds.splice(index, 1);
                                }
                                if (saveState)
                                    this.saveState();
                            }
                        };
                        RegFlowStepMgr.prototype.clearAllSelected = function (saveState) {
                            if (saveState === void 0) { saveState = true; }
                            this.selectedIds = [];
                            if (saveState)
                                this.saveState(null);
                        };
                        return RegFlowStepMgr;
                    }(BaseMgr));
                    RegFlowMgr.RegFlowStepMgr = RegFlowStepMgr;
                })(RegFlowMgr = Managers.RegFlowMgr || (Managers.RegFlowMgr = {}));
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var ShoppingCartMgr = (function (_super) {
                    __extends(ShoppingCartMgr, _super);
                    function ShoppingCartMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, ShoppingCartMgr.CLASS_NAME) || this;
                        _this.textMessageAlertsOptIn = false;
                        _this._dateInContext = null;
                        _this.customTutorProductNames = null;
                        _this._currencyTypesInCartCache = null;
                        _this._shoppingCartDTOCache = null;
                        _this._dateInContext = dateInContext;
                        return _this;
                    }
                    ShoppingCartMgr.prototype.setDateInContext = function (date) {
                        this._dateInContext = date;
                    };
                    Object.defineProperty(ShoppingCartMgr.prototype, "selectedItems", {
                        get: function () {
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ShoppingCartMgr.prototype, "optionItems", {
                        get: function () {
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ShoppingCartMgr.prototype, "hasSelectedItems", {
                        get: function () {
                            throw new Error(StringConst.Err_Not_Implemented);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ShoppingCartMgr.prototype.clearAllSelected = function () {
                        throw new Error(StringConst.Err_Not_Implemented);
                    };
                    ShoppingCartMgr.prototype.restoreState = function (forceRestoreFromStorage) {
                        if (forceRestoreFromStorage === void 0) { forceRestoreFromStorage = false; }
                        throw new Error(StringConst.Err_Not_Implemented);
                    };
                    ShoppingCartMgr.prototype.addOrSetQSParams = function (params) {
                        return params;
                    };
                    ShoppingCartMgr.prototype.addCustomerStudentProduct = function (browseIdentifier, customerAccount, studentAccount, sessionProductDetailID) {
                        var _this = this;
                        var info = {};
                        info.browseIdentifier = browseIdentifier;
                        info.customerAccount = customerAccount;
                        info.studentAccount = studentAccount;
                        info.sessionProductDetailID = sessionProductDetailID;
                        var url = this.common.config.webApi_NonBreeze + "/ShoppingCart_AddCustomerStudentProduct";
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            if (response && response.data) {
                                return response.data;
                            }
                            else {
                                return false;
                            }
                        })
                            .then(function (response) {
                            return _this.pulseContext.regFlowMgr.utmParamsMgr.recordEventForType(Common.Enums.UTMCreationTriggerType.AddToCart).then(function () {
                                return response;
                            });
                        });
                    };
                    ShoppingCartMgr.prototype.addDiscountCode = function (shoppingCartDTO, discountOrCouponCode, validationString) {
                        var _this = this;
                        var info = {};
                        info.shoppingCartDTO = shoppingCartDTO;
                        info.discountOrCouponCode = discountOrCouponCode;
                        info.validationString = validationString;
                        var url = this.common.config.webApi_NonBreeze + "/ShoppingCart_AddDiscountCode";
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var dto = response.data;
                            _this.initializeLocalCartStateAfterLoadFromServer(dto);
                            _this._shoppingCartDTOCache = dto;
                            return _this._shoppingCartDTOCache;
                        });
                    };
                    ShoppingCartMgr.prototype.addOptionToParticipant = function (shoppingCartDTO, participantUserBrowsingID, parentUserBrowsingItemID, optionProductID, optionSessionProductDetailID) {
                        var _this = this;
                        var info = {};
                        info.shoppingCartDTO = shoppingCartDTO ? shoppingCartDTO : this._shoppingCartDTOCache;
                        info.participantUserBrowsingID = participantUserBrowsingID;
                        info.parentUserBrowsingItemID = parentUserBrowsingItemID;
                        info.optionProductID = optionProductID;
                        info.optionSessionProductDetailID = optionSessionProductDetailID;
                        var url = this.common.config.webApi_NonBreeze + "/ShoppingCart_AddOptionToParticipant";
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var shoppingCartDTO = response.data;
                            _this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO);
                            _this._shoppingCartDTOCache = shoppingCartDTO;
                            return _this._shoppingCartDTOCache;
                        })
                            .then(function (response) {
                            return _this.pulseContext.regFlowMgr.utmParamsMgr.recordEventForType(Common.Enums.UTMCreationTriggerType.AddToCart).then(function () {
                                return response;
                            });
                        });
                    };
                    ShoppingCartMgr.prototype.addExistingUserAndTutorProductsToCart = function (shoppingCartDTO, participantUserID, productIDs) {
                        var _this = this;
                        var info = {};
                        info.shoppingCartDTO = shoppingCartDTO;
                        info.participantUserID = participantUserID;
                        info.tutorProductIDs = productIDs;
                        var url = this.common.config.webApi_NonBreeze + "/ShoppingCart_AddExistingUserAndTutorProductsToCart";
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var shoppingCartDTO = response.data;
                            var userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                            userBrowsingMgr.sendCartToMailChimp(userBrowsingMgr.currentUBSession);
                            _this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO);
                            _this._shoppingCartDTOCache = shoppingCartDTO;
                            return _this._shoppingCartDTOCache;
                        })
                            .then(function (response) {
                            return _this.pulseContext.regFlowMgr.utmParamsMgr.recordEventForType(Common.Enums.UTMCreationTriggerType.AddToCart).then(function () { return response; });
                        });
                    };
                    ShoppingCartMgr.prototype.addNewUserAndTutorProductsToCart = function (shoppingCartDTO, firstName, lastName, genderTypeID, dateOfBirth, productIDs) {
                        var _this = this;
                        var info = {};
                        info.shoppingCartDTO = shoppingCartDTO;
                        info.firstName = firstName;
                        info.lastName = lastName;
                        info.genderTypeID = genderTypeID;
                        info.dateOfBirth = dateOfBirth;
                        info.tutorProductIDs = productIDs;
                        var url = this.common.config.webApi_NonBreeze + "/ShoppingCart_AddNewUserAndTutorProductsToCart";
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var shoppingCartDTO = response.data;
                            var userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                            userBrowsingMgr.sendCartToMailChimp(userBrowsingMgr.currentUBSession);
                            _this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO);
                            _this._shoppingCartDTOCache = shoppingCartDTO;
                            return _this._shoppingCartDTOCache;
                        })
                            .then(function (response) {
                            return _this.pulseContext.regFlowMgr.utmParamsMgr.recordEventForType(Common.Enums.UTMCreationTriggerType.AddToCart).then(function () { return response; });
                        });
                    };
                    ShoppingCartMgr.prototype.addTutorProductsToParticipant = function (shoppingCartDTO, participantUserBrowsingID, productIDs) {
                        var _this = this;
                        var info = {};
                        info.shoppingCartDTO = shoppingCartDTO;
                        info.participantUserBrowsingID = participantUserBrowsingID;
                        info.tutorProductIDs = productIDs;
                        var url = this.common.config.webApi_NonBreeze + "/ShoppingCart_AddTutorProductsToParticipant";
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var shoppingCartDTO = response.data;
                            var userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                            userBrowsingMgr.sendCartToMailChimp(userBrowsingMgr.currentUBSession);
                            _this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO);
                            _this._shoppingCartDTOCache = shoppingCartDTO;
                            return _this._shoppingCartDTOCache;
                        })
                            .then(function (response) {
                            return _this.pulseContext.regFlowMgr.utmParamsMgr.recordEventForType(Common.Enums.UTMCreationTriggerType.AddToCart).then(function () {
                                return response;
                            });
                        });
                    };
                    ShoppingCartMgr.prototype.createChangeOrderCart = function (browseIdentifier, cartTypeID, userID, predecessorOrderDetailID) {
                        if (predecessorOrderDetailID === void 0) { predecessorOrderDetailID = null; }
                        this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult = null;
                        var info = {
                            browseIdentifier: browseIdentifier,
                            cartTypeID: cartTypeID,
                            predecessorOrderDetailID: predecessorOrderDetailID,
                            userID: userID
                        };
                        var url = this.common.config.webApi_NonBreeze + '/ShoppingCart_CreateChangeOrderCart';
                        var postData = info;
                        return this.common.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var isOrderDetailCampAtHQ = response.data;
                            return isOrderDetailCampAtHQ;
                        });
                    };
                    ShoppingCartMgr.prototype.addItemToChangeFromCart = function (browseIdentifier, cartTypeID, changeFromCart_UBID, userID, predecessorOrderDetailID) {
                        var info = {
                            browseIdentifier: browseIdentifier,
                            cartTypeID: cartTypeID,
                            changeFromCart_UBID: changeFromCart_UBID,
                            predecessorOrderDetailID: predecessorOrderDetailID,
                            userID: userID
                        };
                        var url = this.common.config.webApi_NonBreeze + '/ShoppingCart_AddItemToChangeFromCart';
                        var postData = info;
                        return this.common.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var isOrderDetailCampAtHQ = response.data;
                            return isOrderDetailCampAtHQ;
                        });
                    };
                    ShoppingCartMgr.prototype.createOrAddToChangeCart = function (browseIdentifier, cartTypeID, userID, predecessorOrderDetailID, sPD_ID) {
                        if (predecessorOrderDetailID === void 0) { predecessorOrderDetailID = null; }
                        if (sPD_ID === void 0) { sPD_ID = null; }
                        this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult = null;
                        var info = {
                            browseIdentifier: browseIdentifier,
                            cartTypeID: cartTypeID,
                            predecessorOrderDetailID: predecessorOrderDetailID,
                            userID: userID,
                            sPD_ID: sPD_ID
                        };
                        var url = this.common.config.webApi_NonBreeze + '/ShoppingCart_CreateOrAddToChangeCart';
                        var postData = info;
                        return this.common.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var isOrderDetailCampAtHQ = response.data;
                            return isOrderDetailCampAtHQ;
                        });
                    };
                    ShoppingCartMgr.prototype.doesCodeRequireValidationString = function (code) {
                        var query = breeze.EntityQuery
                            .from('ShoppingCart_DoesCodeRequireValidationString')
                            .withParameters({
                            'code': code
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results[0]);
                        });
                        return result;
                    };
                    ShoppingCartMgr.prototype.getCurrencyTypesInCart = function (browseIdentifier, cartTypeID) {
                        var _this = this;
                        var query = breeze.EntityQuery
                            .from('ShoppingCart_GetCurrencyTypesInCart')
                            .withParameters({
                            'browseIdentifier': browseIdentifier,
                            'cartTypeID': cartTypeID
                        });
                        var result = this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            var types = (data.results);
                            if (_this._currencyTypesInCartCache &&
                                _this._currencyTypesInCartCache.length < types.length) {
                                _this.pulseContext.selectedCurrencyTypeID = null;
                            }
                            _this._currencyTypesInCartCache = types;
                            return types;
                        });
                        return result;
                    };
                    ShoppingCartMgr.prototype.getShoppingCart = function (browseIdentifier, shoppingCartTypeID, filterByCurrencyTypeID, refreshCache) {
                        var _this = this;
                        if (filterByCurrencyTypeID === void 0) { filterByCurrencyTypeID = null; }
                        if (refreshCache === void 0) { refreshCache = true; }
                        if (this._shoppingCartDTOCache && refreshCache == false) {
                            if (this._shoppingCartDTOCache.currencyType) {
                                refreshCache = this._shoppingCartDTOCache.currencyType.typeID != filterByCurrencyTypeID;
                            }
                            else {
                                refreshCache = filterByCurrencyTypeID != null && filterByCurrencyTypeID > 0;
                            }
                        }
                        if (refreshCache
                            || !this._shoppingCartDTOCache
                            || this._shoppingCartDTOCache.browseIdentifier != browseIdentifier
                            || this._shoppingCartDTOCache.cartTypeID != shoppingCartTypeID) {
                            var query = breeze.EntityQuery
                                .from('ShoppingCart_GetShoppingCart')
                                .withParameters({
                                'browseIdentifier': browseIdentifier,
                                'cartTypeID': shoppingCartTypeID,
                                'filterByCurrencyTypeID': filterByCurrencyTypeID
                            });
                            var result = this.entityMgr.executeQuery(query)
                                .then(function (data) {
                                var shoppingCartDTO = (data.results[0]);
                                _this.setCustomTutorProductNames(shoppingCartDTO);
                                _this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO);
                                _this._shoppingCartDTOCache = shoppingCartDTO;
                                return _this._shoppingCartDTOCache;
                            });
                            return result;
                        }
                        else {
                            var deferred = this.common.$q.defer();
                            deferred.resolve(this._shoppingCartDTOCache);
                            return deferred.promise;
                        }
                    };
                    ShoppingCartMgr.HasProductCategoryInCart = function (shoppingCartDTO, prodCat, prodSubCat, isSelected) {
                        var items = ShoppingCartMgr.GetProductsWithFilter(shoppingCartDTO, {
                            productCategoryTypeID: prodCat,
                            productSubCatTypeID: prodSubCat,
                            isSelected: isSelected,
                        });
                        return (items && !!items.length);
                    };
                    ShoppingCartMgr.GetNumOfTopLevelItemsInCart = function (cart) {
                        var count = 0;
                        if (cart.nonParticipantItems) {
                            cart.nonParticipantItems.forEach(function (item) {
                                item.isSelected ? count++ : count;
                            });
                        }
                        if (cart.participants) {
                            cart.participants.forEach(function (p) {
                                p.items.forEach(function (item) {
                                    item.isSelected ? count++ : count;
                                });
                            });
                        }
                        return count;
                    };
                    ShoppingCartMgr.prototype.removeItemFromParticipant = function (shoppingCartDTO, participantUserBrowsingID, userBrowsingItemID) {
                        var _this = this;
                        var info = {};
                        info.shoppingCartDTO = shoppingCartDTO;
                        info.participantUserBrowsingID = participantUserBrowsingID;
                        info.userBrowsingItemID = userBrowsingItemID;
                        var url = this.common.config.webApi_NonBreeze + "/ShoppingCart_RemoveItemFromParticipant";
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var shoppingCartDTO = response.data;
                            var userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                            userBrowsingMgr.sendCartToMailChimp(userBrowsingMgr.currentUBSession);
                            _this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO);
                            _this._shoppingCartDTOCache = shoppingCartDTO;
                            return _this._shoppingCartDTOCache;
                        });
                    };
                    ShoppingCartMgr.prototype.removeNonParticipantItem = function (shoppingCartDTO, userBrowsingItemID) {
                        var _this = this;
                        var info = {};
                        info.shoppingCartDTO = shoppingCartDTO;
                        info.userBrowsingItemID = userBrowsingItemID;
                        var url = this.common.config.webApi_NonBreeze + "/ShoppingCart_RemoveNonParticipantItem";
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var shoppingCartDTO = response.data;
                            var userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                            userBrowsingMgr.sendCartToMailChimp(userBrowsingMgr.currentUBSession);
                            _this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO);
                            _this._shoppingCartDTOCache = shoppingCartDTO;
                            return _this._shoppingCartDTOCache;
                        });
                    };
                    ShoppingCartMgr.prototype.removeOptionFromParticipant = function (shoppingCartDTO, participantUserBrowsingID, parentUserBrowsingItemID, optionUserBrowsingItemID) {
                        var _this = this;
                        var info = {};
                        info.shoppingCartDTO = shoppingCartDTO;
                        info.participantUserBrowsingID = participantUserBrowsingID;
                        info.parentUserBrowsingItemID = parentUserBrowsingItemID;
                        info.optionUserBrowsingItemID = optionUserBrowsingItemID;
                        var url = this.common.config.webApi_NonBreeze + "/ShoppingCart_RemoveOptionFromParticipant";
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var shoppingCartDTO = response.data;
                            var userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                            userBrowsingMgr.sendCartToMailChimp(userBrowsingMgr.currentUBSession);
                            _this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO);
                            _this._shoppingCartDTOCache = shoppingCartDTO;
                            return _this._shoppingCartDTOCache;
                        });
                    };
                    ShoppingCartMgr.prototype.switchPrimaryOption = function (shoppingCartDTO, participantUserBrowsingID, parentUserBrowsingItemID, primaryOptionType) {
                        var _this = this;
                        var info = {};
                        info.shoppingCartDTO = shoppingCartDTO;
                        info.participantUserBrowsingID = participantUserBrowsingID;
                        info.parentUserBrowsingItemID = parentUserBrowsingItemID;
                        var url = null;
                        if (primaryOptionType == ShoppingCartMgr.PrimaryOptionType.Day) {
                            url = this.common.config.webApi_NonBreeze + '/ShoppingCart_SwitchToDayPrimaryOption';
                        }
                        else {
                            url = this.common.config.webApi_NonBreeze + '/ShoppingCart_SwitchToOvernightPrimaryOption';
                        }
                        var jsonString = this.stringifyPayload(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var shoppingCartDTO = response.data;
                            var userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                            userBrowsingMgr.sendCartToMailChimp(userBrowsingMgr.currentUBSession);
                            _this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO);
                            _this._shoppingCartDTOCache = shoppingCartDTO;
                            return _this._shoppingCartDTOCache;
                        })
                            .then(function (response) {
                            return _this.pulseContext.regFlowMgr.utmParamsMgr.recordEventForType(Common.Enums.UTMCreationTriggerType.AddToCart).then(function () {
                                return response;
                            });
                        });
                    };
                    ShoppingCartMgr.prototype.validateShoppingCart = function (shoppingCartDTO, includeWarningsWhenNoErrors) {
                        var _this = this;
                        var url = this.common.config.webApi_NonBreeze + '/ShoppingCart_ValidateShoppingCart';
                        var postData = {
                            shoppingCartDTO: shoppingCartDTO,
                            includeWeekendWarningsWhenNoErrors: includeWarningsWhenNoErrors,
                        };
                        var jsonString = this.stringifyPayload(postData);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            _this.initializeLocalCartStateAfterLoadFromServer(results.updatedCart);
                            return results;
                        });
                    };
                    ShoppingCartMgr.prototype.isOrderDetailCampAtHQ = function (orderDetailID) {
                        var url = this.common.config.webApi_NonBreeze + '/ShoppingCart_IsOrderDetailCampAtHQ?orderDetailID=' + orderDetailID;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var results = response.data;
                            return results;
                        });
                    };
                    ShoppingCartMgr.CalculateDiscountTotal = function (cart) {
                        var d = 0;
                        if (cart.discounts != null) {
                            for (var i = 0; i < cart.discounts.length; i++) {
                                d += cart.discounts[i].amount;
                            }
                        }
                        return d;
                    };
                    ShoppingCartMgr.CalculateParticipantTotal = function (cart, participant) {
                        var d = 0;
                        if (participant) {
                            if (participant.items) {
                                for (var i = 0, len1 = participant.items.length; i < len1; i++) {
                                    var item = participant.items[i];
                                    if (item.isSelected
                                        && (item.isAvailableForRegistration
                                            || cart.cartTypeID == Common.Enums.ShoppingCartType.ChangeOrder_OptionsOnly)) {
                                        if (cart.cartTypeID != Common.Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                            d += item.itemPrice;
                                        }
                                        if (item.options) {
                                            for (var j = 0, len2 = item.options.length; j < len2; j++) {
                                                var option = item.options[j];
                                                if (option.isSelected && (option.isAvailableForRegistration
                                                    || cart.cartTypeID == Common.Enums.ShoppingCartType.ChangeOrder_OptionsOnly)) {
                                                    d += option.itemPrice;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (participant.fees) {
                                for (var i = 0, len = participant.fees.length; i < len; i++) {
                                    var fee = participant.fees[i];
                                    if (fee.parentUserBrowsingItemID == null) {
                                        d += fee.itemPrice;
                                    }
                                    else {
                                        var arr = Pulse.Utils.JS.findByProperties(participant.items, { 'userBrowsingItemID': fee.parentUserBrowsingItemID });
                                        if (arr != null && arr.length == 1) {
                                            var item = arr[0];
                                            if (item.isAvailableForRegistration) {
                                                d += fee.itemPrice;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        return d;
                    };
                    ShoppingCartMgr.CalculateTotal = function (cart) {
                        var d = 0;
                        if (cart.fees != null) {
                            for (var i = 0; i < cart.fees.length; i++) {
                                d += cart.fees[i].itemPrice;
                            }
                        }
                        if (cart.participants != null) {
                            for (var i = 0; i < cart.participants.length; i++) {
                                var participant = cart.participants[i];
                                d += ShoppingCartMgr.CalculateParticipantTotal(cart, participant);
                            }
                        }
                        if (cart.nonParticipantItems != null) {
                            for (var i = 0; i < cart.nonParticipantItems.length; i++) {
                                d += cart.nonParticipantItems[i].itemPrice;
                            }
                        }
                        if (cart.discounts != null) {
                            for (var i = 0; i < cart.discounts.length; i++) {
                                d -= cart.discounts[i].amount;
                            }
                        }
                        var t = d + cart.tax + cart.balanceDueOnOriginalOrdersOtherOrderDetails - cart.availableCredit;
                        if (t < 0)
                            t = 0;
                        return t;
                    };
                    ShoppingCartMgr.CalculateItemsTotalPrice = function (items, isSelectedOnly) {
                        if (isSelectedOnly === void 0) { isSelectedOnly = true; }
                        var d = 0;
                        items.forEach(function (item) {
                            if (!isSelectedOnly || item.isSelected) {
                                d += item.itemPrice;
                            }
                        });
                        return d;
                    };
                    ShoppingCartMgr.prototype.clearCachedCart = function () {
                        this._shoppingCartDTOCache = null;
                    };
                    ShoppingCartMgr.prototype.cancelShoppingCart = function () {
                        this.pulseContext.shoppingCartType = Common.Enums.ShoppingCartType.RegFlow;
                        this.clearCachedCart();
                    };
                    ShoppingCartMgr.CloneDiscount = function (d1) {
                        var d2 = {};
                        d2.amount = d1.amount;
                        d2.discountCategoryTypeID = d1.discountCategoryTypeID;
                        d2.discountDetailID = d1.discountDetailID;
                        d2.discountID = d1.discountID;
                        d2.discountOrCouponCode = d1.discountOrCouponCode;
                        d2.discountPaymentOptionTypeID = d1.discountPaymentOptionTypeID;
                        d2.discountTypeID = d1.discountTypeID;
                        d2.isAutomatic = d1.isAutomatic;
                        d2.name = d1.name;
                        d2.productID = d1.productID;
                        d2.sessionProductDetailID = d1.sessionProductDetailID;
                        d2.userBrowsingID = d1.userBrowsingID;
                        d2.validationString = d1.validationString;
                        return d2;
                    };
                    ShoppingCartMgr.CloneFee = function (f1) {
                        var f2 = {};
                        f2.catalogTypeID = f1.catalogTypeID;
                        f2.dateRange = f1.dateRange;
                        f2.divisionID = f1.divisionID;
                        f2.divisionName = f1.divisionName;
                        f2.isAvailableForRegistration = f1.isAvailableForRegistration;
                        f2.isChangeOrderFee = f1.isChangeOrderFee;
                        f2.isSelected = f1.isSelected;
                        f2.isSoldOut = f1.isSoldOut;
                        f2.itemName = f1.itemName;
                        f2.itemPrice = f1.itemPrice;
                        f2.locationID = f1.locationID;
                        f2.locationName = f1.locationName;
                        f2.maximumAge = f1.maximumAge;
                        f2.minimumAge = f1.minimumAge;
                        f2.parentUserBrowsingItemID = f1.parentUserBrowsingItemID;
                        f2.productCategoryTypeID = f1.productCategoryTypeID;
                        f2.productID = f1.productID;
                        f2.productSubCatTypeID = f1.productSubCatTypeID;
                        f2.quantity = f1.quantity;
                        f2.sessionID = f1.sessionID;
                        f2.sessionProductDetailID = f1.sessionProductDetailID;
                        f2.userBrowsingItemID = f1.userBrowsingItemID;
                        return f2;
                    };
                    ShoppingCartMgr.prototype.stringifyPayload = function (payload) {
                        var jsonPayload = JSON.stringify(payload, function (key, value) {
                            if (key == "parent") {
                                return undefined;
                            }
                            else if (key == "myForm") {
                                return undefined;
                            }
                            else if (key == "originalSelectedProducts") {
                                return undefined;
                            }
                            else if (key == "selectedProducts") {
                                return undefined;
                            }
                            else {
                                return value;
                            }
                        });
                        return jsonPayload;
                    };
                    ShoppingCartMgr.StudentsWithNoItemsSelected = function (cart) {
                        var students = cart.participants;
                        var studentList = [];
                        if (students) {
                            for (var i = 0; i < students.length; i++) {
                                var participant = students[i];
                                if (participant.items) {
                                    var c = 0;
                                    for (var j = 0; j < participant.items.length; j++) {
                                        if (participant.items[j].isSelected
                                            && (participant.items[j].isAvailableForRegistration
                                                || cart.cartTypeID == Common.Enums.ShoppingCartType.ChangeOrder_OptionsOnly)) {
                                            c++;
                                        }
                                    }
                                    if (c == 0) {
                                        studentList.push(participant);
                                    }
                                }
                            }
                        }
                        return studentList;
                    };
                    ShoppingCartMgr.AnonymousStudentsInCart = function (students) {
                        var studentList = [];
                        if (students) {
                            for (var i = 0; i < students.length; i++) {
                                var student = students[i];
                                if (!student.userID) {
                                    studentList.push(student);
                                }
                            }
                        }
                        return studentList;
                    };
                    ShoppingCartMgr.AreAllCartCoursesVirtual = function (shoppingCart) {
                        if (shoppingCart) {
                            if (shoppingCart.participants) {
                                for (var i = 0; i < shoppingCart.participants.length; i++) {
                                    var participant = shoppingCart.participants[i];
                                    var b = ShoppingCartMgr.AreAllParticipantCoursesVirtual(participant);
                                    if (!b)
                                        return false;
                                }
                            }
                        }
                        else {
                            return false;
                        }
                        return true;
                    };
                    ShoppingCartMgr.AreAllParticipantCoursesVirtual = function (participant) {
                        if (participant) {
                            if (participant.items) {
                                for (var j = 0; j < participant.items.length; j++) {
                                    var item = participant.items[j];
                                    if (item.isSelected
                                        && item.productCategoryTypeID == Common.Enums.ProductCategoryType.Course
                                        && item.divisionProgramTypeID != Common.Enums.DivisionProgramType.VirtualCamp) {
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            return false;
                        }
                        return true;
                    };
                    ShoppingCartMgr.RegisteredStudentsInCart = function (students, mustHaveItem) {
                        if (mustHaveItem === void 0) { mustHaveItem = false; }
                        var studentList = [];
                        if (students) {
                            for (var i = 0; i < students.length; i++) {
                                var student = students[i];
                                if (student.userID && student.userID > 0) {
                                    if (mustHaveItem) {
                                        if (student.items && student.items.length > 0) {
                                            studentList.push(student);
                                        }
                                    }
                                    else {
                                        studentList.push(student);
                                    }
                                }
                            }
                        }
                        return studentList;
                    };
                    ShoppingCartMgr.StudentNames = function (students) {
                        var studentList = [];
                        var names = null;
                        if (students) {
                            for (var i = 0; i < students.length; i++) {
                                var student = students[i];
                                studentList.push(student.firstName + ' ' + student.lastName);
                            }
                            names = studentList.join('|');
                            var lastIndex = names.lastIndexOf('|');
                            if (lastIndex > 0) {
                                names = names.substring(0, lastIndex) + ' and ' + names.substring(lastIndex + 1);
                            }
                            names = names.replace(/\|/g, ', ');
                        }
                        return names;
                    };
                    ShoppingCartMgr.prototype.isSubscriptionExpiring = function (subscription, expireInDays) {
                        if (expireInDays === void 0) { expireInDays = 90; }
                        var serverTimeShifted = moment(this.pulseContext.serverDateTime).add('days', expireInDays).toDate();
                        return subscription.endDateTime <= serverTimeShifted;
                    };
                    ShoppingCartMgr.CountStandAloneProducts = function (cart) {
                        var count = 0;
                        if (cart && cart.participants != null) {
                            for (var i = 0, il = cart.participants.length; i < il; i++) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; j++) {
                                    var item = participant.items[j];
                                    if (item.isSelected) {
                                        count++;
                                    }
                                }
                            }
                            for (var i = 0, il = cart.nonParticipantItems.length; i < il; i++) {
                                var item = cart.nonParticipantItems[i];
                                if (item.productCategoryTypeID !== Common.Enums.ProductCategoryType.Fee) {
                                    if (item.isSelected) {
                                        count++;
                                    }
                                }
                            }
                        }
                        return count;
                    };
                    ShoppingCartMgr.CountStandAlonePurchasableProducts = function (cart) {
                        var count = 0;
                        if (cart && cart.participants != null) {
                            for (var i = 0, il = cart.participants.length; i < il; i++) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; j++) {
                                    var item = participant.items[j];
                                    if (item.isSelected && item.isAvailableForRegistration && !item.isSoldOut && !item.isDynamicNameTutor) {
                                        count++;
                                    }
                                }
                            }
                            for (var i = 0, il = cart.nonParticipantItems.length; i < il; i++) {
                                var item = cart.nonParticipantItems[i];
                                if (item.productCategoryTypeID !== Common.Enums.ProductCategoryType.Fee) {
                                    if (item.isSelected && item.isAvailableForRegistration && !item.isSoldOut && !item.isDynamicNameTutor) {
                                        count++;
                                    }
                                }
                            }
                        }
                        return count;
                    };
                    ShoppingCartMgr.CountVipEarlyAccessDiscounts = function (cart) {
                        var count = 0;
                        if (cart && cart.discounts != null) {
                            for (var i = 0; i < cart.discounts.length; i++) {
                                var di = cart.discounts[i];
                                if (di.discountTypeID == Common.Enums.DiscountType.PurchasedCredit
                                    && di.discountSubcategoryTypeID == Common.Enums.DiscountSubcategoryType.EarlyAccess) {
                                    count++;
                                }
                            }
                        }
                        return count;
                    };
                    Object.defineProperty(ShoppingCartMgr.prototype, "currentCachedShoppingCart", {
                        get: function () {
                            return this._shoppingCartDTOCache;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ShoppingCartMgr.DoesCartHaveAtLeastOneCourse = function (cart) {
                        if (cart && cart.participants) {
                            for (var i = 0; i < cart.participants.length; i++) {
                                var hasCourse = false;
                                var participant = cart.participants[i];
                                hasCourse = ShoppingCartMgr.DoesParticipantHaveAtLeastOneCourse(participant);
                                if (hasCourse)
                                    return true;
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.DoesCartHaveAtLeastOneNonTutorProduct = function (cart) {
                        if (cart && cart.participants) {
                            for (var i = 0; i < cart.participants.length; i++) {
                                var hasNonTutor = false;
                                var participant = cart.participants[i];
                                hasNonTutor = ShoppingCartMgr.DoesParticipantHaveAtLeastOneNonTutorProduct(participant);
                                if (hasNonTutor)
                                    return true;
                            }
                            for (var i = 0; i < cart.nonParticipantItems.length; i++) {
                                var item = cart.nonParticipantItems[i];
                                if (item.isSelected && item.productCategoryTypeID !== Common.Enums.ProductCategoryType.Tutor) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.DoesParticipantHaveAtLeastOneCourse = function (participant, mustBeVirtual) {
                        if (mustBeVirtual === void 0) { mustBeVirtual = false; }
                        if (participant) {
                            if (participant.items) {
                                for (var j = 0; j < participant.items.length; j++) {
                                    var item = participant.items[j];
                                    if (mustBeVirtual) {
                                        if (item.isSelected
                                            && item.productCategoryTypeID == Common.Enums.ProductCategoryType.Course
                                            && item.divisionProgramTypeID == Common.Enums.DivisionProgramType.VirtualCamp) {
                                            return true;
                                        }
                                    }
                                    else {
                                        if (item.isSelected
                                            && item.productCategoryTypeID == Common.Enums.ProductCategoryType.Course) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.DoesParticipantHaveAtLeastOneNonTutorProduct = function (participant) {
                        if (participant) {
                            if (participant.items) {
                                for (var j = 0; j < participant.items.length; j++) {
                                    var item = participant.items[j];
                                    if (item.isSelected
                                        && item.productCategoryTypeID != Common.Enums.ProductCategoryType.Tutor) {
                                        return true;
                                    }
                                }
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.GetCampAtHqLocationIds = function (cart) {
                        var ids = [];
                        if (cart) {
                            for (var i = 0, il = cart.participants.length; i < il; ++i) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                    var item = participant.items[j];
                                    if (item.isCampAtHqLocation) {
                                        ids.push(item.locationID);
                                    }
                                }
                            }
                        }
                        return ids;
                    };
                    ShoppingCartMgr.prototype.isCartCached = function (browseIdentifier, shoppingCartTypeID) {
                        if (this._shoppingCartDTOCache == null
                            || this._shoppingCartDTOCache.browseIdentifier != browseIdentifier
                            || this._shoppingCartDTOCache.cartTypeID != shoppingCartTypeID) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    };
                    ShoppingCartMgr.IsCartEmpty = function (cart) {
                        if (cart == null) {
                            return true;
                        }
                        else if (cart.nonParticipantItems != null && cart.nonParticipantItems.length > 0) {
                            return false;
                        }
                        else if (cart.participants == null || cart.participants.length == 0) {
                            return true;
                        }
                        else {
                            var itemsFound = false;
                            for (var i = 0; i < cart.participants.length; i++) {
                                var participant = cart.participants[i];
                                if (participant.items != null && participant.items.length > 0) {
                                    itemsFound = true;
                                    break;
                                }
                            }
                            return !itemsFound;
                        }
                    };
                    ShoppingCartMgr.GroupCartDiscounts = function (cart) {
                        var groupedDiscounts = null;
                        if (cart && cart.discounts != null) {
                            groupedDiscounts = [];
                            var diGroup = null;
                            for (var i = 0; i < cart.discounts.length; i++) {
                                var di = cart.discounts[i];
                                if (diGroup == null
                                    || (diGroup.discountTypeID == Common.Enums.DiscountType.Promotion && diGroup.discountID != di.discountID)
                                    || diGroup.discountTypeID != di.discountTypeID
                                    || diGroup.discountOrCouponCode != di.discountOrCouponCode) {
                                    diGroup = ShoppingCartMgr.CloneDiscount(di);
                                    groupedDiscounts.push(diGroup);
                                }
                                else {
                                    diGroup.amount += di.amount;
                                }
                            }
                        }
                        return groupedDiscounts;
                    };
                    ShoppingCartMgr.GroupCartFees = function (cart) {
                        var groupedFees = null;
                        if (cart && cart.fees != null) {
                            groupedFees = [];
                            var feeGroup = null;
                            for (var i = 0; i < cart.fees.length; i++) {
                                var fee = cart.fees[i];
                                if (feeGroup == null
                                    || feeGroup.productSubCatTypeID != fee.productSubCatTypeID
                                    || feeGroup.itemName != fee.itemName) {
                                    feeGroup = ShoppingCartMgr.CloneFee(fee);
                                    groupedFees.push(feeGroup);
                                }
                                else {
                                    feeGroup.itemPrice += fee.itemPrice;
                                }
                            }
                        }
                        return groupedFees;
                    };
                    ShoppingCartMgr.HasBootcamp = function (cart) {
                        if (cart) {
                            for (var i = 0, il = cart.participants.length; i < il; ++i) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                    var item = participant.items[j];
                                    if (item.isSelected
                                        && (item.divisionAbbr.toLowerCase().substring(0, 4) == 'boot'
                                            || item.locationTypeID == Common.Enums.LocationType.BootcampPartnership)) {
                                        return true;
                                    }
                                }
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.HasCampAtHqLocation = function (cart) {
                        if (cart) {
                            for (var i = 0, il = cart.participants.length; i < il; ++i) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                    var item = participant.items[j];
                                    if (item.isCampAtHqLocation) {
                                        return true;
                                    }
                                }
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.HasNonCampAtHqLocation = function (cart) {
                        if (cart) {
                            for (var i = 0, il = cart.participants.length; i < il; ++i) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                    var item = participant.items[j];
                                    if (item.productCategoryTypeID == Common.Enums.ProductCategoryType.Course
                                        && item.divisionProgramTypeID != Common.Enums.DivisionProgramType.VirtualCamp
                                        && item.isCampAtHqLocation == false) {
                                        return true;
                                    }
                                }
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.HasOnlyOplOrVirtualCamps = function (cart) {
                        var courseCount = 0;
                        var oplCount = 0;
                        if (cart) {
                            for (var i = 0, il = cart.participants.length; i < il; ++i) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                    var item = participant.items[j];
                                    if (item.productCategoryTypeID == Common.Enums.ProductCategoryType.Course) {
                                        courseCount++;
                                    }
                                    else if (item.productCategoryTypeID == Common.Enums.ProductCategoryType.Tutor) {
                                        oplCount++;
                                    }
                                    if (item.productCategoryTypeID != Common.Enums.ProductCategoryType.Tutor
                                        && item.divisionProgramTypeID != Common.Enums.DivisionProgramType.VirtualCamp) {
                                        return false;
                                    }
                                }
                            }
                        }
                        if (courseCount > 0 || oplCount > 0) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    };
                    ShoppingCartMgr.HasOnlyProductCouponProducts = function (cart) {
                        if (cart) {
                            for (var i = 0, il = cart.participants.length; i < il; ++i) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                    var item = participant.items[j];
                                    if (item.isSelected
                                        && (item.productSubCatTypeID !== Common.Enums.ProductSubCategoryType.ProductCoupon
                                            || (item.bundledItems && item.bundledItems.length > 0))) {
                                        return false;
                                    }
                                }
                            }
                            for (var i = 0, il = cart.nonParticipantItems.length; i < il; ++i) {
                                var item = cart.nonParticipantItems[i];
                                if (item.isSelected
                                    && (item.productSubCatTypeID !== Common.Enums.ProductSubCategoryType.ProductCoupon
                                        || (item.bundledItems && item.bundledItems.length > 0))) {
                                    return false;
                                }
                            }
                        }
                        return true;
                    };
                    ShoppingCartMgr.HasSmallGroupSemesters = function (cart) {
                        if (cart) {
                            for (var i = 0, il = cart.participants.length; i < il; ++i) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                    var item = participant.items[j];
                                    if (item.isSelected
                                        && item.divisionProgramTypeID == Common.Enums.DivisionProgramType.VirtualCamp
                                        && item.divisionDeliveryModelTypeID == Common.Enums.DivisionDeliveryModelType.AfterSchoolPrograms
                                        && item.divisionAbbr.toLowerCase().substring(0, 4) != 'boot'
                                        && item.locationTypeID != Common.Enums.LocationType.BootcampPartnership) {
                                        return true;
                                    }
                                }
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.HasVtcOrVta = function (cart) {
                        if (cart) {
                            for (var i = 0, il = cart.participants.length; i < il; ++i) {
                                var participant = cart.participants[i];
                                for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                    var item = participant.items[j];
                                    if (item.isSelected
                                        && item.divisionProgramTypeID == Common.Enums.DivisionProgramType.VirtualCamp
                                        && item.divisionDeliveryModelTypeID == Common.Enums.DivisionDeliveryModelType.YouthEducationalServices
                                        && item.divisionAbbr.toLowerCase().substring(0, 4) != 'boot'
                                        && item.locationTypeID != Common.Enums.LocationType.BootcampPartnership) {
                                        return true;
                                    }
                                }
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.IsStudentAndSpdIdInCart = function (cart, studentAccountNumber, spdID) {
                        if (cart) {
                            for (var i = 0, il = cart.participants.length; i < il; ++i) {
                                var participant = cart.participants[i];
                                if (participant.accountNumber
                                    && studentAccountNumber
                                    && participant.accountNumber.trim().toLowerCase()
                                        == studentAccountNumber.trim().toLowerCase()) {
                                    for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                        var item = participant.items[j];
                                        if (item.sessionProductDetailID == spdID) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                        return false;
                    };
                    ShoppingCartMgr.GetProductsWithFilter = function (cart, searchFilter) {
                        var _a;
                        if (cart) {
                            var participants = searchFilter.participantID > 0 ?
                                cart.participants.filter(function (p) { return p.userID === searchFilter.participantID; })
                                : cart.participants;
                            var items = new Array();
                            items = participants.reduce(function (result, current) {
                                var _a;
                                if ((_a = current === null || current === void 0 ? void 0 : current.items) === null || _a === void 0 ? void 0 : _a.length) {
                                    result = result.concat(current.items);
                                }
                                return result;
                            }, items);
                            if (!(searchFilter.participantID > 0)) {
                                if ((_a = cart.nonParticipantItems) === null || _a === void 0 ? void 0 : _a.length) {
                                    items = items.concat(cart.nonParticipantItems);
                                }
                            }
                            items = items.reduce(function (result, current) {
                                var _a;
                                if ((_a = current.options) === null || _a === void 0 ? void 0 : _a.length) {
                                    result = result.concat(current.options);
                                }
                                return result;
                            }, items);
                            if (searchFilter.divisionID > 0) {
                                items = items.filter(function (item) { return item.divisionID === searchFilter.divisionID; });
                            }
                            if (searchFilter.productCategoryTypeID > 0) {
                                items = items.filter(function (item) { return item.productCategoryTypeID === searchFilter.productCategoryTypeID; });
                            }
                            if (searchFilter.productSubCatTypeID > 0) {
                                items = items.filter(function (item) { return item.productSubCatTypeID === searchFilter.productSubCatTypeID; });
                            }
                            if (searchFilter.isSelected === false || searchFilter.isSelected) {
                                items = items.filter(function (item) { return item.isSelected === searchFilter.isSelected; });
                            }
                            if (searchFilter.isAutoRenew === false || searchFilter.isAutoRenew) {
                                items = items.filter(function (item) { return item.isAutoRenew === searchFilter.isAutoRenew; });
                            }
                            return items;
                        }
                        return null;
                    };
                    ShoppingCartMgr.GetOPLProducts = function (cart, searchFilter) {
                        return ShoppingCartMgr.GetProductsWithFilter(cart, __assign(__assign({}, searchFilter), { productCategoryTypeID: Common.Enums.ProductCategoryType.Tutor }));
                    };
                    ShoppingCartMgr.IsChangeOrderCart = function (cart) {
                        return this.IsChangeOrderCartTypeID(cart.cartTypeID);
                    };
                    ShoppingCartMgr.IsChangeOrderCartTypeID = function (cartTypeID) {
                        return ShoppingCartMgr.ChangeCartTypeList.indexOf(cartTypeID) >= 0;
                    };
                    ShoppingCartMgr.IsChangeOrderCompatibleCartTypeID = function (cartTypeID) {
                        return ShoppingCartMgr.CompatibleChangeCartTypeList.indexOf(cartTypeID) >= 0;
                    };
                    ShoppingCartMgr.prototype.initializeLocalCartStateAfterLoadFromServer = function (shoppingCartDTO) {
                        if (shoppingCartDTO.discounts != null) {
                            for (var i = 0; i < shoppingCartDTO.discounts.length; i++) {
                                shoppingCartDTO.discounts[i].parent = shoppingCartDTO;
                            }
                        }
                        if (shoppingCartDTO.fees != null) {
                            for (var i = 0; i < shoppingCartDTO.fees.length; i++) {
                                shoppingCartDTO.fees[i].parent = shoppingCartDTO;
                            }
                        }
                        if (shoppingCartDTO.nonParticipantItems != null) {
                            for (var i = 0; i < shoppingCartDTO.nonParticipantItems.length; i++) {
                                shoppingCartDTO.nonParticipantItems[i].parent = shoppingCartDTO;
                            }
                        }
                        if (shoppingCartDTO.participants != null) {
                            for (var i = 0; i < shoppingCartDTO.participants.length; i++) {
                                var participant = shoppingCartDTO.participants[i];
                                participant.parent = shoppingCartDTO;
                                if (participant.fees != null) {
                                    for (var j = 0; j < participant.fees.length; j++) {
                                        participant.fees[j].parent = participant;
                                    }
                                }
                                if (participant.items != null) {
                                    for (var j = 0; j < participant.items.length; j++) {
                                        var item = participant.items[j];
                                        item.parent = participant;
                                        if (item.options != null) {
                                            for (var k = 0; k < item.options.length; k++) {
                                                item.options[k].parent = item;
                                            }
                                        }
                                    }
                                }
                                participant.dateOfBirth = moment(Pulse.Utils.JS.dateTimeStrToDateObj(participant.dateOfBirth.toString())).startOf('day').toDate();
                                participant.age = participant.dateOfBirth ? moment(this.pulseContext.systemMgr.serverDateTime).diff(participant.dateOfBirth, 'years') : 0;
                            }
                        }
                        if (shoppingCartDTO.changeFromCart) {
                            this.initializeLocalCartStateAfterLoadFromServer(shoppingCartDTO.changeFromCart);
                        }
                        ShoppingCartMgr._monthlyRenewalDayOrdinal = null;
                    };
                    ShoppingCartMgr.prototype.setCustomProductName = function (item) {
                        if (this.customTutorProductNames) {
                            for (var i = 0, il = this.customTutorProductNames.length; i < il; ++i) {
                                if (this.customTutorProductNames[i].productID == item.productID) {
                                    item.itemName = this.customTutorProductNames[i].productName;
                                }
                            }
                        }
                    };
                    ShoppingCartMgr.prototype.setCustomTutorProductNames = function (shoppingCartDTO) {
                        if (shoppingCartDTO.participants != null) {
                            for (var i = 0; i < shoppingCartDTO.participants.length; i++) {
                                var participant = shoppingCartDTO.participants[i];
                                if (participant.items != null) {
                                    for (var j = 0; j < participant.items.length; j++) {
                                        var item = participant.items[j];
                                        if (item.productCategoryTypeID === Common.Enums.ProductCategoryType.Tutor
                                            && item.productSubCatTypeID === Common.Enums.ProductSubCategoryType.OneOnOneTutor) {
                                            this.setCustomProductName(item);
                                        }
                                        if (item.options != null) {
                                            for (var k = 0; k < item.options.length; k++) {
                                                var option = item.options[k];
                                                if (item.productCategoryTypeID === Common.Enums.ProductCategoryType.Tutor
                                                    && item.productSubCatTypeID === Common.Enums.ProductSubCategoryType.OneOnOneTutor) {
                                                    this.setCustomProductName(option);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    };
                    ShoppingCartMgr.CopyMergeParticipants = function (toList, fromList) {
                        toList = toList || new Array();
                        var newList = new Array();
                        for (var _i = 0, fromList_1 = fromList; _i < fromList_1.length; _i++) {
                            var fromParticipant = fromList_1[_i];
                            var found = false;
                            for (var _a = 0, toList_1 = toList; _a < toList_1.length; _a++) {
                                var toParticipant = toList_1[_a];
                                var matchs = null;
                                if (fromParticipant.userBrowsingID > 0 && toParticipant.userBrowsingID === fromParticipant.userBrowsingID) {
                                    matchs = Pulse.Utils.JS.findByProperties(toList, { userBrowsingID: fromParticipant.userBrowsingID });
                                    toParticipant = ShoppingCartMgr.CopyMergeSingleParticipant(toParticipant, fromParticipant);
                                    found = true;
                                }
                                else if (fromParticipant.userID > 0 && toParticipant.userID === fromParticipant.userID) {
                                    toParticipant = ShoppingCartMgr.CopyMergeSingleParticipant(toParticipant, fromParticipant);
                                    found = true;
                                }
                                else if (toParticipant.firstName === fromParticipant.firstName
                                    && toParticipant.lastName === fromParticipant.lastName
                                    && toParticipant.dateOfBirth.valueOf() === fromParticipant.dateOfBirth.valueOf()) {
                                    toParticipant = ShoppingCartMgr.CopyMergeSingleParticipant(toParticipant, fromParticipant);
                                    found = true;
                                }
                            }
                            if (found) {
                                continue;
                            }
                            newList.push(fromParticipant);
                        }
                        toList.concat(newList);
                        return toList;
                    };
                    ShoppingCartMgr.CopyMergeSingleParticipant = function (to, from) {
                        to.firstName = !String.isNullOrWhitespace(from.firstName) ? from.firstName : to.firstName;
                        to.lastName = !String.isNullOrWhitespace(from.lastName) ? from.lastName : to.lastName;
                        to.nickName = from.nickName;
                        to.genderTypeID = from.genderTypeID > 0 ? from.genderTypeID : to.genderTypeID;
                        to.dateOfBirth = angular.isDate(from.dateOfBirth) ? from.dateOfBirth : to.dateOfBirth;
                        to.age = from.age > 0 ? from.age : to.age;
                        to.userRelationTypeID = from.userRelationTypeID > 0 ? from.userRelationTypeID : to.userRelationTypeID;
                        to.teeShirtSizeTypeID = from.teeShirtSizeTypeID > 0 ? from.teeShirtSizeTypeID : to.teeShirtSizeTypeID;
                        Pulse.Utils.JS.copyOwnProperties(to, from, true);
                        return to;
                    };
                    ShoppingCartMgr.GetChangeFromProduct = function (changeFromCart, searchFilter) {
                        var fromParticipants = searchFilter.participantID > 0 ?
                            changeFromCart.participants.filter(function (p) { return p.userID === searchFilter.participantID; })
                            : changeFromCart.participants;
                        var fromItems = new Array();
                        fromItems = fromParticipants.reduce(function (result, current) { return result.concat(current.items); }, fromItems);
                        var fromItem = fromItems.filter(function (prod) {
                            if (prod.predecessorOrderDetailID === searchFilter.predecessorOrderDetailID) {
                                return true;
                            }
                        })[0];
                        if (fromItem)
                            return fromItem;
                        fromItem = fromItems.filter(function (prod) {
                            if (searchFilter.sessionProductDetailID > 0 && prod.sessionProductDetailID === searchFilter.sessionProductDetailID) {
                                return true;
                            }
                        })[0];
                        if (fromItem)
                            return fromItem;
                        fromItem = fromItems.filter(function (prod) {
                            if (searchFilter.locationID > 0 && prod.locationID === searchFilter.locationID
                                && prod.productID === searchFilter.productID
                                && prod.sessionID === searchFilter.sessionID) {
                                return true;
                            }
                        })[0];
                        if (fromItem)
                            return fromItem;
                        fromItem = fromItems.filter(function (prod) {
                            if (searchFilter.locationID > 0 && prod.locationID === searchFilter.locationID
                                && prod.productID === searchFilter.productID) {
                                return true;
                            }
                        })[0];
                        if (fromItem)
                            return fromItem;
                        fromItem = fromItems.filter(function (prod) {
                            if (searchFilter.productID > 0 && prod.productID === searchFilter.productID) {
                                return true;
                            }
                        })[0];
                        if (fromItem)
                            return fromItem;
                        fromItem = fromItems.filter(function (prod) {
                            if (searchFilter.locationID > 0 && prod.locationID === searchFilter.locationID) {
                                return true;
                            }
                        })[0];
                        if (fromItem)
                            return fromItem;
                        fromItem = fromItems.filter(function (prod) {
                            if (searchFilter.productID > 0 && prod.productID === searchFilter.productID) {
                                return true;
                            }
                        })[0];
                        if (fromItem)
                            return fromItem;
                        fromItem = fromItems[0];
                        return fromItem;
                    };
                    ShoppingCartMgr.GetThumbNailFullUrl = function (config, item, largeImage) {
                        if (largeImage === void 0) { largeImage = false; }
                        var prodThumbImgUrl = '';
                        if (!item.productURLs)
                            return prodThumbImgUrl;
                        var prodUrl = item.productURLs
                            .filter(function (url) {
                            return url.usageTypeID == Common.Enums.ProductURLType.CourseVideoIntroImageURL;
                        })
                            .shift();
                        if (prodUrl && !String.isNullOrWhitespace(prodUrl.url)) {
                            prodThumbImgUrl = Pulse.Utils.JS.composeProductThumbNailFullUrl(config.courseVideoThumbnailUrl, prodUrl.url, largeImage);
                        }
                        return prodThumbImgUrl;
                    };
                    ShoppingCartMgr.GetMonthlyRenewalDayOrdinal = function () {
                        if (ShoppingCartMgr._monthlyRenewalDayOrdinal == null) {
                            var dayOfMonth = (new Date()).getDate();
                            if (dayOfMonth > 28)
                                dayOfMonth = 28;
                            ShoppingCartMgr._monthlyRenewalDayOrdinal = dayOfMonth + Pulse.Utils.JS.ordinalSuffixOf(dayOfMonth);
                        }
                        return ShoppingCartMgr._monthlyRenewalDayOrdinal;
                    };
                    ShoppingCartMgr.registeredAs = 'ShoppingCartMgr';
                    ShoppingCartMgr.CLASS_NAME = ShoppingCartMgr.registeredAs;
                    ShoppingCartMgr.CompatibleChangeCartTypeList = [
                        Common.Enums.ShoppingCartType.ChangeOrder_Location,
                        Common.Enums.ShoppingCartType.ChangeOrder_SessionDate,
                        Common.Enums.ShoppingCartType.ChangeOrder_Course
                    ];
                    ShoppingCartMgr.ChangeCartTypeList = __spreadArrays(ShoppingCartMgr.CompatibleChangeCartTypeList, [Common.Enums.ShoppingCartType.ChangeOrder_OptionsOnly]);
                    ShoppingCartMgr._monthlyRenewalDayOrdinal = null;
                    return ShoppingCartMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.ShoppingCartMgr = ShoppingCartMgr;
                (function (ShoppingCartMgr) {
                    var PrimaryOptionType;
                    (function (PrimaryOptionType) {
                        PrimaryOptionType[PrimaryOptionType["Day"] = 1] = "Day";
                        PrimaryOptionType[PrimaryOptionType["Overnight"] = 2] = "Overnight";
                    })(PrimaryOptionType = ShoppingCartMgr.PrimaryOptionType || (ShoppingCartMgr.PrimaryOptionType = {}));
                    var ShoppingCartUIMode;
                    (function (ShoppingCartUIMode) {
                        ShoppingCartUIMode["MODE_MY_ACCOUNT"] = "my-account";
                        ShoppingCartUIMode["MODE_ORDER_SUMMARY"] = "order-summary";
                        ShoppingCartUIMode["MODE_SHOPPING_CART"] = "shopping-cart";
                        ShoppingCartUIMode["MODE_MAKE_CHANGES"] = "make-changes";
                    })(ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode || (ShoppingCartMgr.ShoppingCartUIMode = {}));
                })(ShoppingCartMgr = Managers.ShoppingCartMgr || (Managers.ShoppingCartMgr = {}));
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var UserBrowsingMgr = (function (_super) {
                    __extends(UserBrowsingMgr, _super);
                    function UserBrowsingMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, UserBrowsingMgr.CLASS_NAME) || this;
                        _this._dateInContext = null;
                        _this.currentUBSession = {
                            userBrowsingID: 0,
                            userBrowsingDTO: null,
                            UB_ChildDTOs: null,
                            UB_RelatedParticipantDTOs: null,
                            UB_ItemDTOs: null,
                            UB_ItemQtyDTOs: null,
                            relatedUB_DTOs: new Array(),
                            _UB_ExtraData: null,
                            userWaitlist: null,
                        };
                        _this._participantIDToMakeChangeFor = null;
                        _this._dateInContext = dateInContext;
                        return _this;
                    }
                    UserBrowsingMgr.prototype.setDateInContext = function (date) {
                        this._dateInContext = date;
                    };
                    UserBrowsingMgr.prototype.getNewBrowseIdentifier = function () {
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_GetNewBrowseIdentifier';
                        return this.common.$http.post(url, null)
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    UserBrowsingMgr.prototype.getUserBrowsingData = function (info) {
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_GetUserBrowsingData';
                        return this.common.$http.post(url, info, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var result = response.data;
                            for (var i = 0; i < result.userBrowsings.length; i++) {
                                var userBrowsing = result.userBrowsings[i];
                                userBrowsing.dateOfBirth = userBrowsing.dateOfBirth ? moment(Pulse.Utils.JS.dateTimeStrToDateObj(userBrowsing.dateOfBirth))
                                    .startOf('day')
                                    .toDate() : userBrowsing.dateOfBirth;
                                userBrowsing.expirationDate = Pulse.Utils.JS.dateTimeStrToDateObj(userBrowsing.expirationDate);
                            }
                            return result;
                        });
                    };
                    UserBrowsingMgr.prototype.getChangeCartUserBrowsingData = function (info) {
                        info.cartTypeID = -1;
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_GetChangeCartUserBrowsingData';
                        return this.common.$http.post(url, info, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var result = response.data;
                            if (result && result.userBrowsings) {
                                for (var i = 0; i < result.userBrowsings.length; i++) {
                                    var userBrowsing = result.userBrowsings[i];
                                    userBrowsing.dateOfBirth = userBrowsing.dateOfBirth ? moment(Pulse.Utils.JS.dateTimeStrToDateObj(userBrowsing.dateOfBirth))
                                        .startOf('day')
                                        .toDate() : userBrowsing.dateOfBirth;
                                    userBrowsing.expirationDate = Pulse.Utils.JS.dateTimeStrToDateObj(userBrowsing.expirationDate);
                                }
                            }
                            return result;
                        });
                    };
                    UserBrowsingMgr.prototype.actionOnUserBrowsingRecordStatus = function (onValidCbfn, onHasBeenMergedCbfn, onNoneExistsCbfn, confirmMergeSilently) {
                        var _this = this;
                        if (confirmMergeSilently === void 0) { confirmMergeSilently = false; }
                        return this.checkUserBrowsingRecordStatus()
                            .then(function (status) {
                            if (status.active) {
                                return onValidCbfn();
                            }
                            var callback;
                            var message;
                            if (!status.exists) {
                                if (confirmMergeSilently || !_this.pulseContext.isLoggedIn) {
                                    return onNoneExistsCbfn(false);
                                }
                                message = StringConst.Warn_Cart_Removed;
                                callback = onNoneExistsCbfn;
                            }
                            else if (status.merged) {
                                if (confirmMergeSilently) {
                                    return onHasBeenMergedCbfn(true);
                                }
                                message = StringConst.Warn_Cart_MergeNeeded;
                                callback = onHasBeenMergedCbfn;
                            }
                            _this.common.toggleSpinner(false);
                            var dlgID = 'UB_InvalidRecord';
                            _this.common.showConfirmation(StringConst.Title_Confirmation, StringConst.Warn_UnsavedChanges, callback, { dialogId: dlgID });
                        });
                    };
                    UserBrowsingMgr.prototype.checkUserBrowsingRecordStatus = function () {
                        var _this = this;
                        var _self = this;
                        var status = {
                            exists: true,
                            active: false,
                            expired: false,
                            merged: false,
                        };
                        var ubDAO = new DataAccess.UserBrowsingDAO(this.common, this.breezeService, this.pulseContext);
                        var promise = ubDAO.getByBrowseIdentifierAndCartTypeID(this.pulseContext.browseIdentifier, this.pulseContext.shoppingCartType, false)
                            .then(function (userBrowsing) {
                            if (!userBrowsing) {
                                status.exists = false;
                            }
                            else {
                                if (userBrowsing.recordStateID === Common.Enums.RecordStateType.Active) {
                                    status.active = true;
                                }
                                if (userBrowsing.expirationDate < _this.pulseContext.serverDateTime) {
                                    status.expired = true;
                                }
                                if (userBrowsing.mergedToUBID > 0) {
                                    status.merged = true;
                                    status.mergedToUBID = userBrowsing.mergedToUBID;
                                    status.mergedToBIdentifyer = userBrowsing.mergedToBIdentifier;
                                }
                            }
                            return status;
                        });
                        return promise;
                    };
                    UserBrowsingMgr.prototype.linkBeneficiaryToItem = function (info) {
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_LinkBeneficiaryToItem';
                        return this.common.$http.post(url, info, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    UserBrowsingMgr.prototype.selectItem = function (info) {
                        var _this = this;
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_SelectItem';
                        return this.common.$http.post(url, info, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data[0];
                        })
                            .then(function (response) {
                            return _this.pulseContext.regFlowMgr.utmParamsMgr.recordEventForType(Common.Enums.UTMCreationTriggerType.AddToCart)
                                .then(function () {
                                return response;
                            });
                        });
                    };
                    UserBrowsingMgr.prototype.selectItemStyle = function (info) {
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_SelectItemStyle';
                        return this.common.$http.post(url, info, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    UserBrowsingMgr.prototype.copyIUserBrowsingToIUpdateUserDataInfo = function (ubSession, ub, isChildUB) {
                        if (isChildUB === void 0) { isChildUB = false; }
                        var info = {};
                        Pulse.Utils.JS.copyAllProperties(info, ub);
                        if (isChildUB) {
                            info.parentUserBrowsingID = ubSession.userBrowsingID;
                            info.persistSettings = false;
                        }
                        info.browseIdentifier = this.pulseContext.browseIdentifier;
                        info.cartTypeID = this.pulseContext.shoppingCartType;
                        info.companyID = this.pulseContext.companyId;
                        info.action = true;
                        info.merge = true;
                        return info;
                    };
                    UserBrowsingMgr.prototype.bundleStudentInfoForSave = function (participant) {
                        var info = {};
                        info.firstName = participant.firstName;
                        info.lastName = participant.lastName;
                        info.nickName = participant.nickName;
                        info.genderTypeID = participant.genderTypeID;
                        info.dateOfBirth = participant.dateOfBirth;
                        info.userRelationTypeID = participant.userRelationTypeID;
                        info.teeShirtSizeTypeID = participant.teeShirtSizeTypeID;
                        info.userBrowsingID = participant.userBrowsingID;
                        info.parentUserBrowsingID = participant.parent.userBrowsingID;
                        info.browseIdentifier = this.pulseContext.browseIdentifier;
                        info.cartTypeID = this.pulseContext.shoppingCartType;
                        info.companyID = this.pulseContext.companyId;
                        info.userID = isNaN(participant.userID) ? null : participant.userID;
                        info.persistSettings = false;
                        info.action = true;
                        info.merge = true;
                        return info;
                    };
                    UserBrowsingMgr.prototype.addOrUpdateUserData = function (ubSession, info) {
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_UpdateUserData';
                        if (ubSession._UB_ExtraData) {
                            info.extraData = JSON.stringify(ubSession._UB_ExtraData);
                        }
                        return this.common.$http.post(url, info, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var userBrowsing = response.data[0];
                            userBrowsing.dateOfBirth = userBrowsing.dateOfBirth ? moment(Pulse.Utils.JS.dateTimeStrToDateObj(userBrowsing.dateOfBirth))
                                .startOf('day')
                                .toDate() : userBrowsing.dateOfBirth;
                            userBrowsing.expirationDate = Pulse.Utils.JS.dateTimeStrToDateObj(userBrowsing.expirationDate);
                            if (!String.isNullOrWhitespace(userBrowsing.extraData)) {
                                ubSession._UB_ExtraData = JSON.parse(userBrowsing.extraData);
                            }
                            return userBrowsing;
                        });
                    };
                    UserBrowsingMgr.prototype.copyUserEnityToUpdateUserDataInfo = function (parentUserBrowsingID, user, cartType) {
                        var info = {};
                        info.companyID = user.companyID;
                        info.browseIdentifier = this.pulseContext.browseIdentifier;
                        info.userID = user.userID;
                        info.parentUserBrowsingID = parentUserBrowsingID;
                        info.genderTypeID = user.genderTypeID;
                        info.teeShirtSizeTypeID = user.teeShirtSizeTypeID;
                        info.firstName = user.firstName;
                        info.lastName = user.lastName;
                        info.nickName = user.nickName;
                        info.dateOfBirth = user.dateOfBirth;
                        info.action = true;
                        info.cartTypeID = cartType;
                        info.persistSettings = false;
                        info.merge = true;
                        return info;
                    };
                    UserBrowsingMgr.prototype.bundleStudentsInfoForSave = function (students) {
                        var studentsBundled = [];
                        angular.forEach(students, function (student) {
                            var userBrowsing = this.bundleStudentInfoForSave(student);
                            studentsBundled.push(userBrowsing);
                        }, this);
                        return studentsBundled;
                    };
                    UserBrowsingMgr.prototype.updateStudents = function (students) {
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_UpdateStudents';
                        return this.common.$http.post(url, students, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var studentResults = response.data;
                            angular.forEach(studentResults, function (student) {
                                student.dateOfBirth = moment(Pulse.Utils.JS.dateTimeStrToDateObj(student.dateOfBirth))
                                    .startOf('day')
                                    .toDate();
                                student.expirationDate = Pulse.Utils.JS.dateTimeStrToDateObj(student.expirationDate);
                            });
                            return studentResults;
                        });
                    };
                    UserBrowsingMgr.prototype.updateMatchedStudent = function (student) {
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_UpdateMatchedStudent';
                        return this.common.$http.post(url, student, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return;
                        });
                    };
                    UserBrowsingMgr.prototype.updateAdminOverride = function (ubSession, adminOverride, saveToDB) {
                        if (saveToDB === void 0) { saveToDB = true; }
                        var deferred = this.common.$q.defer();
                        if (ubSession.userBrowsingID <= 0) {
                            deferred.reject(StringConst.Err_Data_Missing);
                            return deferred.promise;
                        }
                        if (!ubSession._UB_ExtraData) {
                            deferred.resolve(null);
                            return deferred.promise;
                        }
                        var filterObj = {};
                        if (adminOverride.child_UB_ID && adminOverride.child_UB_ID > 0) {
                            filterObj.child_UB_ID = adminOverride.child_UB_ID;
                        }
                        if (adminOverride.sessionProductDetailID && adminOverride.sessionProductDetailID > 0) {
                            filterObj.sessionProductDetailID = adminOverride.sessionProductDetailID;
                        }
                        else {
                            if (adminOverride.productID && adminOverride.productID > 0) {
                                filterObj.productID = adminOverride.productID;
                            }
                            if (adminOverride.locationID && adminOverride.locationID > 0) {
                                filterObj.locationID = adminOverride.locationID;
                            }
                            if (adminOverride.sessionID && adminOverride.sessionID > 0) {
                                filterObj.sessionID = adminOverride.sessionID;
                            }
                        }
                        if (adminOverride.scheduleDefID && adminOverride.scheduleDefID > 0) {
                            filterObj.scheduleDefID = adminOverride.scheduleDefID;
                        }
                        var adminOverrides = this.findAdminOverrides(ubSession, filterObj);
                        if (adminOverrides && adminOverrides.length > 0) {
                            adminOverrides.forEach(function (item) {
                                Pulse.Utils.JS.copyOwnProperties(item, adminOverride);
                            });
                        }
                        else if (filterObj.child_UB_ID && filterObj.child_UB_ID > 0) {
                            filterObj.child_UB_ID = 0;
                            adminOverrides = this.findAdminOverrides(ubSession, filterObj);
                            if (adminOverrides && adminOverrides.length > 0) {
                                adminOverrides.forEach(function (item) {
                                    Pulse.Utils.JS.copyOwnProperties(item, adminOverride);
                                });
                            }
                            else if (!saveToDB) {
                                deferred.resolve(null);
                                return deferred.promise;
                            }
                        }
                        if (saveToDB) {
                            var info = this._newDefaultUpdateUserDataInfo(ubSession);
                            info.extraData = JSON.stringify(ubSession._UB_ExtraData);
                            return this.addOrUpdateUserData(ubSession, info)
                                .then(function (data) {
                                return ubSession._UB_ExtraData;
                            });
                        }
                        deferred.resolve(ubSession._UB_ExtraData);
                        return deferred.promise;
                    };
                    UserBrowsingMgr.prototype.addAdminOverride = function (ubSession, adminOverride, saveToDB) {
                        if (saveToDB === void 0) { saveToDB = true; }
                        var deferred = this.common.$q.defer();
                        if (ubSession.userBrowsingID <= 0) {
                            deferred.reject(StringConst.Err_Data_Missing);
                            return deferred.promise;
                        }
                        if (!ubSession._UB_ExtraData) {
                            ubSession._UB_ExtraData = { overrides: new Array() };
                        }
                        if (!this.hasAdminOverride(ubSession, adminOverride)) {
                            ubSession._UB_ExtraData.overrides.push(adminOverride);
                        }
                        if (saveToDB) {
                            var info = this._newDefaultUpdateUserDataInfo(ubSession);
                            info.extraData = JSON.stringify(ubSession._UB_ExtraData);
                            return this.addOrUpdateUserData(ubSession, info)
                                .then(function (data) {
                                return ubSession._UB_ExtraData;
                            });
                        }
                        deferred.resolve(ubSession._UB_ExtraData);
                        return deferred.promise;
                    };
                    UserBrowsingMgr.prototype.removeAdminOverride = function (ubSession, adminOverride, saveToDB) {
                        if (saveToDB === void 0) { saveToDB = true; }
                        var deferred = this.common.$q.defer();
                        if (ubSession.userBrowsingID <= 0) {
                            deferred.reject(StringConst.Err_Data_Missing);
                            return deferred.promise;
                        }
                        if (adminOverride && ubSession._UB_ExtraData) {
                            var overrides = ubSession._UB_ExtraData.overrides;
                            var adminOverrideMatches = Pulse.Utils.JS.findByProperties(overrides, adminOverride);
                            if (adminOverrideMatches && adminOverrideMatches.length > 0) {
                                for (var i = 0; i < adminOverrideMatches.length; i++) {
                                    var foundIndex = overrides.indexOf(adminOverrideMatches[i]);
                                    overrides.splice(foundIndex, 1);
                                }
                                deferred.resolve(ubSession._UB_ExtraData);
                            }
                            else {
                                deferred.resolve(null);
                            }
                        }
                        else {
                            deferred.resolve(null);
                        }
                        if (saveToDB) {
                            var info = this._newDefaultUpdateUserDataInfo(ubSession);
                            info.extraData = JSON.stringify(ubSession._UB_ExtraData);
                            return this.addOrUpdateUserData(ubSession, info)
                                .then(function (data) {
                                return ubSession._UB_ExtraData;
                            });
                        }
                        return deferred.promise;
                    };
                    UserBrowsingMgr.prototype._newDefaultUpdateUserDataInfo = function (ubSession) {
                        var info = {};
                        info.userBrowsingID = ubSession.userBrowsingID;
                        info.browseIdentifier = this.pulseContext.browseIdentifier;
                        info.cartTypeID = ubSession.userBrowsingDTO.cartTypeID;
                        info.companyID = ubSession.userBrowsingDTO.companyID;
                        info.persistSettings = ubSession.userBrowsingDTO.persistSettings;
                        info.action = true;
                        info.merge = false;
                        return info;
                    };
                    UserBrowsingMgr.prototype.updateCurrentUserBrowsing = function (ubSession) {
                        var isChildUB = false;
                        var info = this.copyIUserBrowsingToIUpdateUserDataInfo(ubSession, ubSession.userBrowsingDTO, isChildUB);
                        return this.addOrUpdateUserData(ubSession, info)
                            .then(function (data) {
                            ubSession.userBrowsingDTO = data;
                            return data;
                        });
                    };
                    UserBrowsingMgr.prototype.deleteRelatedUserBrowsing = function (userID, cartType) {
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_DeleteRelatedUserBrowsingData?'
                            + 'userID=' + this.pulseContext.actingAsUserId + '&'
                            + 'cartType=' + cartType;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return;
                        });
                    };
                    UserBrowsingMgr.prototype.removeUserBrowsingSession = function (ubSession) {
                        var _this = this;
                        var _self = this;
                        var ubDAO = new DataAccess.UserBrowsingDAO(this.common, this.breezeService, this.pulseContext);
                        var promise = ubDAO.getByBrowseIdentifierAndCartTypeID(this.pulseContext.browseIdentifier, ubSession.userBrowsingDTO.cartTypeID)
                            .then(function (userBrowsing) {
                            if (userBrowsing) {
                                return _this.deleteCartFromMailChimp(ubSession)
                                    .then(function () {
                                    return _this.deleteRelatedUserBrowsing(userBrowsing.userID, ubSession.userBrowsingDTO.cartTypeID);
                                });
                            }
                        })
                            .then(function () {
                            _this.clearUserBrowsingSesesion(ubSession);
                            return _this.loadInfo(ubSession, _this.pulseContext.isLoggedIn);
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        });
                        return promise;
                    };
                    UserBrowsingMgr.prototype.addToWaitlist = function (ubSession, wlRecord) {
                        var _this = this;
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_AddToWaitlist';
                        var promises = [];
                        promises.push(this.common.$http.post(url, angular.toJson(wlRecord, false), { headers: { 'Content-Type': 'application/json' } })
                            .then(function () {
                            return _this.loadWaitlist(ubSession, wlRecord.email, true);
                        }));
                        return this.common.$q.all(promises);
                    };
                    UserBrowsingMgr.prototype.loadWaitlist = function (ubSession, emailAddress, refreshCache) {
                        if (refreshCache === void 0) { refreshCache = false; }
                        if (!ubSession.userWaitlist || refreshCache) {
                            var self_1 = this;
                            var wlDAO = new Common.DataAccess.WaitlistDAO(this.common, this.breezeService, this.pulseContext);
                            return wlDAO.getByFilter({ email: emailAddress })
                                .then(function (data) {
                                ubSession.userWaitlist = data;
                                return data;
                            });
                        }
                        else {
                            var deferred = this.common.$q.defer();
                            deferred.resolve(ubSession.userWaitlist);
                            return deferred.promise;
                        }
                    };
                    UserBrowsingMgr.prototype.createNewRegFlowUserBrowsingDTO = function (cartType) {
                        return {
                            userBrowsingID: 0,
                            companyID: this.pulseContext.companyId,
                            browseIdentifier: this.pulseContext.browseIdentifier,
                            acctTypeMask: 0,
                            isShoppingCart: true,
                            persistSettings: false,
                            cartTypeID: cartType,
                        };
                    };
                    UserBrowsingMgr.prototype.clearUserBrowsingSesesion = function (ubSession) {
                        Pulse.Utils.JS.deleteProperties(ubSession);
                        ubSession.userBrowsingID = 0;
                        ubSession.relatedUB_DTOs = new Array();
                    };
                    UserBrowsingMgr.prototype.loadInfo = function (ubSession, merge, triggerCartInfoEvent) {
                        var _this = this;
                        if (triggerCartInfoEvent === void 0) { triggerCartInfoEvent = true; }
                        var _self = this;
                        return this.common.debounceAdd(UserBrowsingMgr._LOAD_INFO_DEBOUNCE_KEY + merge, function () {
                            var promises = new Array();
                            var userID = _this.pulseContext.isLoggedIn ? _this.pulseContext.actingAsUserId : 0;
                            var params = {};
                            params.userBrowsingID = ubSession.userBrowsingID;
                            params.browseIdentifier = _this.pulseContext.browseIdentifier;
                            params.companyID = _this.pulseContext.companyId;
                            params.userID = userID;
                            params.cartTypeID = (ubSession.userBrowsingDTO && ubSession.userBrowsingDTO.cartTypeID > 0)
                                ? ubSession.userBrowsingDTO.cartTypeID
                                : _this.pulseContext.shoppingCartType;
                            params.merge = merge;
                            promises.push(_this.getUserBrowsingData(params)
                                .then(function (data) {
                                _this.populateUBSessionWithData(ubSession, data);
                                _this.pulseContext.shoppingCartType = ubSession.userBrowsingDTO.cartTypeID;
                                return data;
                            })
                                .then(function (data) {
                                if (_self.pulseContext.isLoggedIn) {
                                    promises.push(_self.pulseContext.userMgr.loadRelatedUsersForActingUser(true)
                                        .then(function (relatedUserData) {
                                        _self.mergeRelatedUsers(ubSession, relatedUserData);
                                    })
                                        .then(function () {
                                        if (ubSession.relatedUB_DTOs && ubSession.relatedUB_DTOs.length > 0) {
                                            ubSession.relatedUB_DTOs = ubSession.relatedUB_DTOs.sort(function (o1, o2) { return Pulse.Utils.JS.compareForSort(o1, o2, { 'firstName': 0 }); });
                                        }
                                    }));
                                    promises.push(_self.pulseContext.userMgr.loadContactMethodsForActingUser());
                                }
                            })
                                .then(function () {
                                if (triggerCartInfoEvent) {
                                    _self.triggerCartInfoEvent(ubSession);
                                }
                            }));
                            return _this.common.$q.all(promises);
                        }, 0, true);
                    };
                    UserBrowsingMgr.prototype.getChangeCartSession = function () {
                        var _this = this;
                        var _self = this;
                        var ubSession = {};
                        var promises = new Array();
                        var userID = this.pulseContext.isLoggedIn ? this.pulseContext.actingAsUserId : 0;
                        var params = {};
                        params.browseIdentifier = this.pulseContext.browseIdentifier;
                        params.companyID = this.pulseContext.companyId;
                        params.userID = userID;
                        params.merge = false;
                        return this.getChangeCartUserBrowsingData(params)
                            .then(function (data) {
                            _this.clearUserBrowsingSesesion(ubSession);
                            _this.populateUBSessionWithData(ubSession, data);
                            return ubSession;
                        });
                    };
                    UserBrowsingMgr.prototype.populateUBSessionWithData = function (ubSession, data) {
                        if (data && data.userBrowsings) {
                            var userBrowsings = data.userBrowsings;
                            for (var i = 0; i < userBrowsings.length; i++) {
                                var ub = userBrowsings[i];
                                if (!(ub.parentUserBrowsingID > 0)) {
                                    ubSession.userBrowsingID = ub.userBrowsingID;
                                    ubSession.userBrowsingDTO = ub;
                                    ubSession._UB_ExtraData = JSON.parse(ub.extraData);
                                    userBrowsings.splice(i, 1);
                                    ubSession.UB_ChildDTOs = userBrowsings;
                                    if (ubSession.UB_ChildDTOs.length > 0) {
                                        ubSession.relatedUB_DTOs = userBrowsings;
                                    }
                                    else {
                                        ubSession.relatedUB_DTOs = new Array();
                                        ;
                                    }
                                    break;
                                }
                            }
                            ubSession.UB_RelatedParticipantDTOs = data.userBrowsingParticipants;
                            ubSession.UB_ItemDTOs = data.userBrowsingItems;
                            ubSession.UB_ItemQtyDTOs = data.userBrowsingItemQtys;
                        }
                    };
                    UserBrowsingMgr.prototype.setUserBrowsingResumeStep = function (step) {
                        var _this = this;
                        var _self = this;
                        var ubDAO = new DataAccess.UserBrowsingDAO(this.common, this.breezeService, this.pulseContext);
                        var promise = ubDAO.getByBrowseIdentifierAndCartTypeID(this.pulseContext.browseIdentifier, this.pulseContext.shoppingCartType)
                            .then(function (userBrowsing) {
                            if (userBrowsing) {
                                _self.getUserBrowsingResumeIDByRegFlowStep(step)
                                    .then(function (userBrowsingResumeID) {
                                    userBrowsing.userBrowsingResumeID = userBrowsingResumeID;
                                    return userBrowsing;
                                })
                                    .then(function (userBrowsing) {
                                    return ubDAO.saveChanges([userBrowsing]);
                                });
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        });
                        return promise;
                    };
                    UserBrowsingMgr.prototype.loadAllUserBrowsingResumes = function () {
                        var _this = this;
                        var _self = this;
                        var promise;
                        var deferred = this.common.$q.defer();
                        promise = deferred.promise;
                        if (!this._userBrowsingResumes) {
                            var query = breeze.EntityQuery
                                .from('UserBrowsingResume_GetActive');
                            this.entityMgr.executeQuery(query)
                                .then(function (data) {
                                _self._userBrowsingResumes = data.results;
                                deferred.resolve(_self._userBrowsingResumes);
                                return _self._userBrowsingResumes;
                            })
                                .catch(function (err) {
                                _this.logError(err);
                                deferred.reject(err);
                            });
                        }
                        else {
                            deferred.resolve(_self._userBrowsingResumes);
                        }
                        return promise;
                    };
                    UserBrowsingMgr.prototype.getUserBrowsingResumeIDByRegFlowStep = function (step) {
                        var _this = this;
                        var _self = this;
                        var promise;
                        var deferred = this.common.$q.defer();
                        promise = deferred.promise;
                        this.loadAllUserBrowsingResumes()
                            .then(function () {
                            var ubr = Pulse.Utils.JS.findByProperties(_this._userBrowsingResumes, { stepTypeID: step })[0];
                            deferred.resolve(ubr.userBrowsingResumeID);
                        })
                            .catch(function (err) {
                            _this.logError(err);
                            deferred.reject(err);
                        });
                        return promise;
                    };
                    UserBrowsingMgr.prototype.updateCommLogWithResumeInfo = function (userBrowsingCommLogID, userBrowsingCommLogTypeID, userID) {
                        var info = {
                            'userBrowsingCommLogID': userBrowsingCommLogID,
                            'userBrowsingCommLogTypeID': userBrowsingCommLogTypeID,
                            'userID': userID,
                        };
                        var url = this.common.config.webApi_NonBreeze + '/RegFlow_UpdateCommLogWithResumeInfo';
                        return this.common.$http.post(url, info, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var result = response.data;
                            return result;
                        });
                    };
                    UserBrowsingMgr.prototype.tryResumeAbandonedShoppingCart = function () {
                        var _this = this;
                        var defer = this.common.$q.defer();
                        var promise = defer.promise;
                        var params = QueryStringUtils.GetParams(this.common.$location.url());
                        if (!params) {
                            this.common.$location.path(Routes.RegFlow_Default);
                            defer.resolve();
                            return promise;
                        }
                        var userBrowsingCommLogID = params[QueryStringUtils.USERBROWSINGCOMMLOG_ID];
                        var userBrowsingCommLogTypeID = params[QueryStringUtils.USERBROWSINGCOMMLOG_TYPE_ID];
                        var userID = params[QueryStringUtils.USER_ID];
                        var userBrowsingID = params[QueryStringUtils.USERBROWSING_ID];
                        var browseID = params[QueryStringUtils.USERBROWSING_BROWSE_ID];
                        if (userBrowsingCommLogID > 0) {
                            promise = this.updateCommLogWithResumeInfo(userBrowsingCommLogID, userBrowsingCommLogTypeID, userID);
                            if (userID > 0) {
                                this.common.$location.path(Routes.ResumeCart);
                                return promise;
                            }
                            else {
                                promise = promise.then(function (userBrowsing) {
                                    if (userBrowsing && userBrowsing.browseIdentifier) {
                                        browseID = userBrowsing.browseIdentifier;
                                        userBrowsingID = userBrowsing.userBrowsingID;
                                    }
                                    else {
                                        browseID = null;
                                        userBrowsingID = null;
                                    }
                                    return userBrowsing;
                                });
                            }
                        }
                        else {
                            defer.resolve();
                        }
                        return promise.then(function () {
                            if (isNaN(userBrowsingID) || userBrowsingID <= 0 || String.isNullOrWhitespace(browseID)) {
                                _this.common.$location.url(Routes.RegFlow_Default);
                                return;
                            }
                            _this.currentUBSession.userBrowsingID = userBrowsingID;
                            _this.pulseContext.setBrowseIdentifier(browseID, false);
                            return _this.loadInfo(_this.currentUBSession, false)
                                .then(function () {
                                return _this.redirectToResumeAbandonedShoppingCart(_this.currentUBSession);
                            });
                        });
                    };
                    UserBrowsingMgr.prototype.redirectToResumeAbandonedShoppingCart = function (ubSession) {
                        var _this = this;
                        var defer = this.common.$q.defer();
                        if (ubSession.UB_ItemDTOs && ubSession.UB_ItemDTOs.length > 0) {
                            return this.loadAllUserBrowsingResumes()
                                .then(function () {
                                var ubr = Pulse.Utils.JS.findByProperties(_this._userBrowsingResumes, { userBrowsingResumeID: ubSession.userBrowsingDTO.userBrowsingResumeID })[0];
                                if (ubr) {
                                    var url = ubr.resumeURL;
                                    var params = {};
                                    if (_this.hasCampAtHQItems(ubSession)) {
                                        params[QueryStringUtils.CAMP_AT_HQ] = 'true';
                                    }
                                    var UB_ItemDTO = ubSession.UB_ItemDTOs.filter(function (item) { return item.sessionProductDetailID > 0 || item.locationID > 0; })
                                        .sort(function (a, b) { return b.userBrowsingItemID - a.userBrowsingItemID; })[0];
                                    var locID = UB_ItemDTO ? UB_ItemDTO.locationID : null;
                                    if (locID) {
                                        params[QueryStringUtils.LOCATION_ID] = locID;
                                    }
                                    else {
                                        if (url.indexOf(Routes.RegFlow_AvailChart) >= 0 || url.indexOf(Routes.RegFlow_AvailChartFilters)) {
                                            url = Routes.RegFlow_ShoppingCart;
                                        }
                                    }
                                    params[QueryStringUtils.REG_FLOW_NO_AUTO_DISPATCH] = true;
                                    url = Pulse.Utils.QueryStringUtils.AddOrSetQSParams(url, params);
                                    _this.common.$location.url(url);
                                }
                            })
                                .catch(function (err) {
                                _this.logError(err);
                            });
                        }
                        else {
                            this.common.$location.url(Routes.RegFlow_Default);
                            defer.resolve();
                            return defer.promise;
                        }
                    };
                    Object.defineProperty(UserBrowsingMgr.prototype, "isSendToMailChimpEnabled", {
                        get: function () {
                            return false;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    UserBrowsingMgr.prototype.sendCartToMailChimp = function (ubSession) {
                        var _this = this;
                        if (!this.isSendToMailChimpEnabled)
                            return this.common.$q.resolve();
                        if (!ubSession.userBrowsingDTO) {
                            return this.loadInfo(ubSession, true)
                                .then(function (data) {
                                return _this.sendCartToMailChimp_Internal(ubSession);
                            });
                        }
                        else {
                            return this.sendCartToMailChimp_Internal(ubSession);
                        }
                    };
                    UserBrowsingMgr.prototype.sendCartToMailChimp_Internal = function (ubSession) {
                        if (!this.isSendToMailChimpEnabled)
                            return this.common.$q.resolve();
                        if (ubSession.userBrowsingDTO.cartTypeID !== Common.Enums.ShoppingCartType.RegFlow
                            || String.isNullOrWhitespace(ubSession.userBrowsingDTO.emailAddress)) {
                            var defer = this.common.$q.defer();
                            defer.resolve();
                            return defer.promise;
                        }
                        var url = this.common.config.webApi_NonBreeze + '/ShoppingCart_SendToMailChimp';
                        var postData = {
                            'userBrowsingID': ubSession.userBrowsingID,
                            'resumeCartUrl': this._getResumeCartUrl(ubSession),
                        };
                        return this.common.$http.post(url, JSON.stringify(postData), { headers: { 'Content-Type': 'application/json' } });
                    };
                    UserBrowsingMgr.prototype._getResumeCartUrl = function (ubSession) {
                        if (this.pulseContext.isLoggedIn) {
                            return this.common.config.WWW_Pulse2x_HomeUrl + '#' + Routes.ResumeCart;
                        }
                        else {
                            var urlRoute = this.common.config.WWW_Pulse2x_HomeUrl + '#' + Routes.ResumeCartWithNoAccount;
                            var params = {};
                            params[QueryStringUtils.EMAIL_ADDRESS] = ubSession.userBrowsingDTO.emailAddress;
                            params[QueryStringUtils.USERBROWSING_ID] = ubSession.userBrowsingDTO.userBrowsingID;
                            params[QueryStringUtils.USERBROWSING_BROWSE_ID] = ubSession.userBrowsingDTO.browseIdentifier;
                            urlRoute = QueryStringUtils.AddOrSetQSParams(urlRoute, params);
                            return urlRoute;
                        }
                    };
                    UserBrowsingMgr.prototype.deleteCartFromMailChimp = function (ubSession) {
                        var defer = this.common.$q.defer();
                        if (!this.pulseContext.isLoggedIn || ubSession.userBrowsingDTO.cartTypeID !== Common.Enums.ShoppingCartType.RegFlow) {
                            defer.resolve();
                            return defer.promise;
                        }
                        var url = this.common.config.webApi_NonBreeze + '/ShoppingCart_DeleteFromMailChimp';
                        var postData = { 'userBrowsingID': ubSession.userBrowsingID };
                        return this.common.$http.post(url, JSON.stringify(postData), { headers: { 'Content-Type': 'application/json' } })
                            .catch(function () {
                            defer.resolve();
                            return defer.promise;
                        });
                    };
                    UserBrowsingMgr.prototype.standaloneItemCount = function (ubSession) {
                        var count = 0;
                        if (ubSession.UB_ItemDTOs && ubSession.UB_ItemDTOs.length) {
                            var topLevelItems = ubSession.UB_ItemDTOs.filter(function (item) {
                                return !(item.parentUserBrowsingItemID > 0);
                            });
                            var topLevelItemIDs = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(topLevelItems, 'userBrowsingItemID');
                            topLevelItemIDs.forEach(function (itemID) {
                                var hasParticipant = false;
                                ubSession.UB_RelatedParticipantDTOs.forEach(function (participantItem) {
                                    if (itemID === participantItem.userBrowsingItemID) {
                                        count++;
                                        hasParticipant = true;
                                    }
                                });
                                if (!hasParticipant) {
                                    count++;
                                }
                            });
                        }
                        return count;
                    };
                    UserBrowsingMgr.prototype.triggerCartInfoEvent = function (ubSession) {
                        if (this.pulseContext.shoppingCartType === Common.Enums.ShoppingCartType.RegFlow
                            || Managers.ShoppingCartMgr.IsChangeOrderCompatibleCartTypeID(this.pulseContext.shoppingCartType)) {
                            var dataObj = { first: '', last: '', email: '', count: 0 };
                            if (this.pulseContext.isLoggedIn) {
                                var user = this.pulseContext.actingAsUser;
                                dataObj.first = user.firstName;
                                dataObj.last = user.lastName;
                                dataObj.email = user.userName;
                            }
                            else {
                                dataObj.first = ubSession.userBrowsingDTO.firstName;
                                dataObj.last = ubSession.userBrowsingDTO.lastName;
                                dataObj.email = ubSession.userBrowsingDTO.emailAddress;
                            }
                            dataObj.count = this.standaloneItemCount(ubSession);
                            Events.TriggerDocCustomEvent(Events.SendCartInfo_JSEvent, dataObj);
                        }
                    };
                    UserBrowsingMgr.TriggerCartInfoEvent = function (dataObj) {
                        Events.TriggerDocCustomEvent(Events.SendCartInfo_JSEvent, dataObj);
                    };
                    UserBrowsingMgr.prototype.getParticipantsByProductInfos = function (ubSession, selectedProdInfos) {
                        var participants = new Array();
                        for (var prodIndex = 0; prodIndex < selectedProdInfos.length; prodIndex++) {
                            var prodInfo = selectedProdInfos[prodIndex];
                            var UB_Items = this.getUBItemsByProductInfo(ubSession, prodInfo);
                            if (UB_Items && UB_Items.length > 0) {
                                var userBrowsingItemIDs = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(UB_Items, 'userBrowsingItemID');
                                for (var i = 0; i < ubSession.UB_RelatedParticipantDTOs.length; i++) {
                                    var tempPartItem = ubSession.UB_RelatedParticipantDTOs[i];
                                    if (userBrowsingItemIDs.indexOf(tempPartItem.userBrowsingItemID) >= 0
                                        && Pulse.Utils.JS.findByProperties(participants, { userBrowsingID: tempPartItem.userBrowsingID }).length === 0) {
                                        var tempUBArray = Pulse.Utils.JS.findByProperties(ubSession.UB_ChildDTOs, { userBrowsingID: tempPartItem.userBrowsingID });
                                        participants = participants.concat(tempUBArray);
                                    }
                                }
                            }
                        }
                        return participants;
                    };
                    UserBrowsingMgr.prototype.getUBItemsByProductInfo = function (ubSession, prodInfo) {
                        var UB_Items = new Array();
                        if (prodInfo) {
                            var filterObj = {};
                            if (prodInfo.productID > 0) {
                                filterObj.productID = prodInfo.productID;
                            }
                            if (prodInfo.locationID > 0) {
                                filterObj.locationID = prodInfo.locationID;
                            }
                            if (prodInfo.sessionID > 0) {
                                filterObj.sessionID = prodInfo.sessionID;
                            }
                            if (prodInfo.sessionProductDetailID > 0) {
                                filterObj.sessionProductDetailID = prodInfo.sessionProductDetailID;
                            }
                            if (prodInfo.scheduleDefID > 0) {
                                filterObj.scheduleDefID = prodInfo.scheduleDefID;
                            }
                            UB_Items = Pulse.Utils.JS.findByProperties(ubSession.UB_ItemDTOs, filterObj);
                        }
                        return UB_Items;
                    };
                    UserBrowsingMgr.prototype.getUBParticipantsByPacticipantAndProductInfo = function (ubSession, participant, prodInfo) {
                        var resultUBParts = new Array();
                        if (participant && prodInfo) {
                            var UB_Items = this.getUBItemsByProductInfo(ubSession, prodInfo);
                            var userBrowsingItemIDs = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(UB_Items, 'userBrowsingItemID');
                            var UB_ParticipantItems = Pulse.Utils.JS.findByProperties(ubSession.UB_RelatedParticipantDTOs, { userBrowsingID: participant.userBrowsingID });
                            for (var i = 0; i < UB_ParticipantItems.length; i++) {
                                var UB_PartItem = UB_ParticipantItems[i];
                                if (userBrowsingItemIDs && (userBrowsingItemIDs.indexOf(UB_PartItem.userBrowsingItemID) >= 0)) {
                                    resultUBParts.push(UB_PartItem);
                                }
                            }
                        }
                        return resultUBParts;
                    };
                    UserBrowsingMgr.prototype.findExistingParticipant = function (ubSession, participant) {
                        var matches = Pulse.Utils.JS.findObjectsWithPropsMatchFromArray(ubSession.relatedUB_DTOs, {
                            firstName: participant.firstName,
                            lastName: participant.lastName,
                            dateOfBirth: participant.dateOfBirth,
                        });
                        if (matches.length > 0) {
                            return matches[0];
                        }
                        return null;
                    };
                    UserBrowsingMgr.prototype.hasPredecessorOrderDetailID = function (ubSession, orderDetailID) {
                        if (this.findItemByPredecessorOrderDetailID(ubSession, orderDetailID)) {
                            return true;
                        }
                        return false;
                    };
                    UserBrowsingMgr.prototype.findItemByPredecessorOrderDetailID = function (ubSession, orderDetailID) {
                        if (ubSession && ubSession.UB_ItemDTOs) {
                            var itemsMatch = Pulse.Utils.JS.findByProperties(ubSession.UB_ItemDTOs, { predecessorOrderDetailID: orderDetailID });
                            if (itemsMatch && itemsMatch.length > 0) {
                                return itemsMatch[0];
                            }
                        }
                        return null;
                    };
                    UserBrowsingMgr.prototype.hasParticipantProdInCart = function (ubSession, participant, prodInfo) {
                        if (participant && prodInfo) {
                            var participantCartProds = this.getCartProdInfoByParticipant(ubSession, participant);
                            if (!(participantCartProds === null || participantCartProds === void 0 ? void 0 : participantCartProds.length)) {
                                return false;
                            }
                            var filterObj = {};
                            if (prodInfo.productID > 0) {
                                filterObj.productID = prodInfo.productID;
                            }
                            if (prodInfo.locationID > 0) {
                                filterObj.locationID = prodInfo.locationID;
                            }
                            if (prodInfo.sessionID > 0) {
                                filterObj.sessionID = prodInfo.sessionID;
                            }
                            if (prodInfo.sessionProductDetailID > 0) {
                                filterObj.sessionProductDetailID = prodInfo.sessionProductDetailID;
                            }
                            if (prodInfo.scheduleDefID > 0) {
                                filterObj.scheduleDefID = prodInfo.scheduleDefID;
                            }
                            if (prodInfo.catalogTypeID > 0) {
                                filterObj.catalogTypeID = prodInfo.catalogTypeID;
                            }
                            if (prodInfo.catalogTypeID == Common.Enums.SalesCatalogType.CourseBundle) {
                                return participantCartProds.some(function (p) { return p.productID == prodInfo.productID && p.sessionID == prodInfo.sessionID && p.locationID == prodInfo.locationID; });
                            }
                            else {
                                var itemsMatch = Pulse.Utils.JS.findByProperties(participantCartProds, filterObj);
                                if (itemsMatch && itemsMatch.length > 0) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    };
                    UserBrowsingMgr.prototype.getCartProdInfoByParticipant = function (ubSession, participant) {
                        var selectedProdInfos = new Array();
                        if (participant) {
                            var UB_ParticipantItems = Pulse.Utils.JS.findByProperties(ubSession.UB_RelatedParticipantDTOs, { userBrowsingID: participant.userBrowsingID });
                            if (UB_ParticipantItems && UB_ParticipantItems.length > 0) {
                                var userBrowsingItemIDs = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(UB_ParticipantItems, 'userBrowsingItemID');
                                for (var i = 0; i < ubSession.UB_ItemDTOs.length; i++) {
                                    var tempItem = ubSession.UB_ItemDTOs[i];
                                    if (userBrowsingItemIDs.indexOf(tempItem.userBrowsingItemID) >= 0) {
                                        selectedProdInfos.push({
                                            productID: tempItem.productID,
                                            locationID: tempItem.locationID,
                                            sessionID: tempItem.sessionID,
                                            sessionProductDetailID: tempItem.sessionProductDetailID,
                                            catalogTypeID: tempItem.catalogTypeID,
                                            scheduleDefID: tempItem.scheduleDefID,
                                        });
                                    }
                                }
                            }
                        }
                        return selectedProdInfos;
                    };
                    UserBrowsingMgr.prototype.mergeRelatedUsers = function (ubSession, relatedUsers) {
                        ubSession.relatedUB_DTOs = ubSession.relatedUB_DTOs || new Array();
                        var listToAdd = new Array();
                        var _loop_1 = function (i) {
                            var currentRelatedUser = relatedUsers[i];
                            var matchs = Pulse.Utils.JS.findByProperties(ubSession.relatedUB_DTOs, { userID: currentRelatedUser.userID });
                            if (matchs.length > 0) {
                                matchs.forEach(function (match) {
                                    Pulse.Utils.JS.copyOwnProperties(match, currentRelatedUser, true);
                                });
                                return "continue";
                            }
                            var foundByNameDOB = false;
                            for (var j = 0; j < ubSession.relatedUB_DTOs.length; j++) {
                                cartRelatedUB = ubSession.relatedUB_DTOs[j];
                                if (cartRelatedUB.firstName === currentRelatedUser.firstName
                                    && cartRelatedUB.lastName === currentRelatedUser.lastName
                                    && cartRelatedUB.dateOfBirth.valueOf() === currentRelatedUser.dateOfBirth.valueOf()) {
                                    Pulse.Utils.JS.copyOwnProperties(cartRelatedUB, currentRelatedUser, true);
                                    foundByNameDOB = true;
                                    continue;
                                }
                            }
                            if (foundByNameDOB) {
                                return "continue";
                            }
                            listToAdd.push({
                                userBrowsingID: 0,
                                userID: currentRelatedUser.userID,
                                genderTypeID: currentRelatedUser.genderTypeID,
                                userRelationTypeID: currentRelatedUser.userRelationTypeID,
                                dateOfBirth: currentRelatedUser.dateOfBirth,
                                firstName: currentRelatedUser.firstName,
                                lastName: currentRelatedUser.lastName,
                                nickName: currentRelatedUser.nickName,
                                teeShirtSizeTypeID: currentRelatedUser.teeShirtSizeTypeID,
                                acctTypeMask: currentRelatedUser.acctTypeMask,
                            });
                        };
                        var cartRelatedUB;
                        for (var i = 0; i < relatedUsers.length; i++) {
                            _loop_1(i);
                        }
                        if (listToAdd.length > 0) {
                            ubSession.relatedUB_DTOs = ubSession.relatedUB_DTOs.concat(listToAdd);
                        }
                    };
                    UserBrowsingMgr.prototype.findAdminOverrides = function (ubSession, adminOverride) {
                        var adminOverrideMatches;
                        if (adminOverride && ubSession._UB_ExtraData) {
                            adminOverrideMatches = Pulse.Utils.JS.findByProperties(ubSession._UB_ExtraData.overrides, adminOverride);
                        }
                        return adminOverrideMatches;
                    };
                    UserBrowsingMgr.prototype.hasAdminOverride = function (ubSession, adminOverride) {
                        if (adminOverride && ubSession._UB_ExtraData) {
                            var adminOverrideMatches = this.findAdminOverrides(ubSession, adminOverride);
                            if (adminOverrideMatches && adminOverrideMatches.length > 0) {
                                return true;
                            }
                        }
                        return false;
                    };
                    UserBrowsingMgr.prototype.getParticipantToMakeChangeFor = function (ubSession) {
                        var _this = this;
                        var defer = this.common.$q.defer();
                        if (!this._participantIDToMakeChangeFor) {
                            var url = this.common.config.webApi_NonBreeze + '/RegFlow_GetParticipantToMakeChangeFor';
                            var params = { 'userBrowsingID': ubSession.userBrowsingID };
                            url = QueryStringUtils.AddOrSetQSParams(url, params);
                            this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                                .then(function (response) {
                                _this._participantIDToMakeChangeFor = response.data;
                                var participant = ubSession.UB_ChildDTOs.filter(function (p) { return p.userID === _this._participantIDToMakeChangeFor; })[0];
                                defer.resolve(participant);
                            });
                        }
                        else {
                            var participant = ubSession.UB_ChildDTOs.filter(function (p) { return p.userID === _this._participantIDToMakeChangeFor; })[0];
                            defer.resolve(participant);
                        }
                        return defer.promise;
                    };
                    UserBrowsingMgr.prototype.setParticipantToMakeChangeFor = function (participantID) {
                        this._participantIDToMakeChangeFor = participantID;
                    };
                    UserBrowsingMgr.prototype.getParticipantCurrencyType = function () {
                        var _a;
                        return (_a = this.pulseContext.regflowCurrencyTypeID) !== null && _a !== void 0 ? _a : null;
                    };
                    UserBrowsingMgr.prototype.setParticipantCurrencyType = function (currencyTypeID) {
                        this.pulseContext.regflowCurrencyTypeID = currencyTypeID;
                    };
                    UserBrowsingMgr.prototype.removeParticipantCurrencyType = function () {
                        this.pulseContext.regflowCurrencyTypeID = null;
                    };
                    UserBrowsingMgr.prototype.hasChangeItems = function (ubSession) {
                        if (ubSession
                            && ubSession.userBrowsingDTO && ubSession.UB_ItemDTOs
                            && Managers.ShoppingCartMgr.ChangeCartTypeList.indexOf(ubSession.userBrowsingDTO.cartTypeID)) {
                            for (var _i = 0, _a = ubSession.UB_ItemDTOs; _i < _a.length; _i++) {
                                var item = _a[_i];
                                if (item.predecessorOrderDetailID > 0)
                                    return true;
                            }
                        }
                        return false;
                    };
                    UserBrowsingMgr.prototype.hasCampAtHQItems = function (ubSession) {
                        if (ubSession && ubSession.userBrowsingDTO && ubSession.UB_ItemDTOs) {
                            for (var _i = 0, _a = ubSession.UB_ItemDTOs; _i < _a.length; _i++) {
                                var item = _a[_i];
                                if (item.isCampAtHq)
                                    return true;
                            }
                        }
                        return false;
                    };
                    UserBrowsingMgr.registeredAs = 'UserBrowsingMgr';
                    UserBrowsingMgr.CLASS_NAME = UserBrowsingMgr.registeredAs;
                    UserBrowsingMgr._LOAD_INFO_DEBOUNCE_KEY = 'UserBrowsingMgr_loadInfo';
                    UserBrowsingMgr.REGFLOW_CHANGE_DATA_TOKEN = 'reg-flow-change-data';
                    return UserBrowsingMgr;
                }(DataAccess.Managers.BaseMgr));
                Managers.UserBrowsingMgr = UserBrowsingMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var TermDAO = DataAccess.TermDAO;
                var LocationFinderMgr = (function (_super) {
                    __extends(LocationFinderMgr, _super);
                    function LocationFinderMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, LocationFinderMgr.CLASS_NAME, QueryStringUtils.LOCATION_ID) || this;
                        _this._dateInContext = null;
                        _this._lookupUSStates = null;
                        _this._lookupCountries = null;
                        _this.lookupDivisions = null;
                        _this.lookupStateRelSubReg = null;
                        _this.locDivs = null;
                        _this.locAddrs = null;
                        _this._dateInContext = dateInContext;
                        _this.userBrowsingMgr = pulseContext.regFlowMgr.userBrowsingMgr;
                        return _this;
                    }
                    LocationFinderMgr.prototype.setDateInContext = function (date) {
                        this._dateInContext = date;
                    };
                    Object.defineProperty(LocationFinderMgr.prototype, "allLookupUSStates", {
                        get: function () {
                            return this._lookupUSStates;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(LocationFinderMgr.prototype, "lookupUSStates", {
                        get: function () {
                            var _this = this;
                            if (!this._lookupUSStates || !this.optionItems)
                                return null;
                            var filteredResults = this._lookupUSStates.filter(function (s) {
                                if (angular.isNumber(s.subRegionID)) {
                                    return Pulse.Utils.JS.findByProperties(_this.optionItems, { stateID: s.iD, subRegionID: s.subRegionID }).length > 0;
                                }
                                return Pulse.Utils.JS.findByProperties(_this.optionItems, { stateID: s.iD }).length > 0;
                            });
                            return filteredResults;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(LocationFinderMgr.prototype, "lookupCountries", {
                        get: function () {
                            var _this = this;
                            if (!this._lookupCountries || !this.optionItems)
                                return null;
                            var filteredResults = this._lookupCountries.filter(function (s) {
                                return Pulse.Utils.JS.findByProperties(_this.optionItems, { countryID: s.iD }).length > 0;
                            });
                            return filteredResults;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(LocationFinderMgr.prototype, "virtualLocations", {
                        get: function () {
                            if (!this.optionItems)
                                return null;
                            var filteredResults = this.optionItems.filter(function (loc) {
                                return loc.locTypeID == Common.Enums.LocationType.VirtualSummerCamp;
                            });
                            return filteredResults;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    LocationFinderMgr.prototype.getLocationByType = function (type) {
                        if (!this.optionItems)
                            return null;
                        var filteredResults = this.optionItems.filter(function (loc) { return loc.locTypeID == type; });
                        return filteredResults;
                    };
                    LocationFinderMgr.prototype.getLookupStates = function () {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLookupStates')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                            isImpersonating: this.pulseContext.isImpersonating
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    LocationFinderMgr.prototype.getLookupCountries = function () {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLookupCountries')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                            isImpersonating: this.pulseContext.isImpersonating
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    LocationFinderMgr.prototype.getLookupDivisions = function () {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLookupDivisions')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                            isImpersonating: this.pulseContext.isImpersonating
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return (data.results);
                        });
                    };
                    LocationFinderMgr.prototype.getGenericDivisionsProps = function (refresh) {
                        var _this = this;
                        if (refresh === void 0) { refresh = false; }
                        return this.common.$q(function (resolve) {
                            if (!refresh && _this.lookupDivisions && _this.lookupDivisions.length !== 0) {
                                resolve(_this.lookupDivisions);
                            }
                            else {
                                resolve(_this.getLookupDivisions()
                                    .then(function (result) {
                                    return _this.lookupDivisions = result;
                                }));
                            }
                        });
                    };
                    LocationFinderMgr.prototype.getLookupStateSubRegions = function () {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLookupStateSubRegions')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                            isImpersonating: this.pulseContext.isImpersonating
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    LocationFinderMgr.prototype.getLookupStateRelatedSubRegions = function () {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLookupStateRelatedSubRegions')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                            isImpersonating: this.pulseContext.isImpersonating
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    LocationFinderMgr.prototype.getLocations = function (locationIDs, locationTypeIDs, divisionID, divProgramTypeIDs, stateTypeID, ageGroupID, courseID, genreTypeIDs, experienceTypeIDs) {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLocations')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            locationIDs: locationIDs ? locationIDs : [],
                            locationTypeIDs: locationTypeIDs ? locationTypeIDs : [],
                            divisionID: divisionID,
                            divProgramTypeIDs: divProgramTypeIDs ? divProgramTypeIDs : [],
                            stateTypeID: stateTypeID,
                            ageGroupID: ageGroupID,
                            courseID: courseID,
                            genreTypeIDs: genreTypeIDs ? genreTypeIDs : [],
                            experienceTypeIDs: experienceTypeIDs ? experienceTypeIDs : [],
                            dateInContext: this._dateInContext,
                            isImpersonating: this.pulseContext.isImpersonating
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    LocationFinderMgr.prototype.getLocation = function (locationID) {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLocation')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            locationID: locationID,
                            dateInContext: this._dateInContext,
                            isImpersonating: this.pulseContext.isImpersonating
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results[0];
                        });
                        return result;
                    };
                    LocationFinderMgr.prototype.getLocationDivisions = function () {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLocationDivisions')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                            isImpersonating: this.pulseContext.isImpersonating
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    LocationFinderMgr.prototype.getLocationAddresses = function () {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLocationAddresses')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                            isImpersonating: this.pulseContext.isImpersonating
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    LocationFinderMgr.prototype.getLocationDivisionInfo = function (locationID, divisionID) {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLocationDivisionInfo')
                            .withParameters({
                            locationID: locationID,
                            divisionID: divisionID,
                            dateInContext: this._dateInContext
                        });
                        var result = this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                        return result;
                    };
                    LocationFinderMgr.prototype.getLocAddressInfo = function (locID) {
                        if (this.locAddrs) {
                            var results = Pulse.Utils.JS.findByProperties(this.locAddrs, {
                                'locID': locID
                            });
                            if (results && results.length == 1) {
                                return results[0];
                            }
                            throw new Error(StringConst.Err_Data_Corrupt);
                        }
                        throw new ReferenceError(StringConst.Err_Data_Missing);
                    };
                    LocationFinderMgr.prototype.getDivisionsByLocID = function (locID) {
                        if (this.locDivs) {
                            var results = Pulse.Utils.JS.findByProperties(this.locDivs, {
                                'locID': locID
                            });
                            if (results && results.length == 1) {
                                return results[0];
                            }
                            throw new Error(StringConst.Err_Data_Corrupt);
                        }
                        throw new ReferenceError(StringConst.Err_Data_Missing);
                    };
                    LocationFinderMgr.prototype.getDivisionInfoByDivID = function (divID) {
                        if (this.lookupDivisions) {
                            var results = Pulse.Utils.JS.findByProperties(this.lookupDivisions, {
                                'iD': divID
                            });
                            if (results && results.length == 1) {
                                return results[0];
                            }
                            throw new Error(StringConst.Err_Data_Corrupt);
                        }
                        throw new ReferenceError(StringConst.Err_Data_Missing);
                    };
                    LocationFinderMgr.prototype.getCatalogDateRanges = function (dateInContext) {
                        var url = this.common.config.webApi_NonBreeze
                            + '/RegFlow_GetActiveCatalogDateRanges?dateInContext='
                            + dateInContext;
                        return this.common.$http.get(url, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            return response.data;
                        });
                    };
                    LocationFinderMgr.prototype.getTerms = function () {
                        var termDAO = new TermDAO(this.common, this.breezeService, this.pulseContext);
                        var filters = {
                            divisionIDList: null,
                            termGroupIDList: null,
                            locationIDList: null,
                            refreshCache: false,
                        };
                        return termDAO.getActive(filters)
                            .then(function (data) {
                            return data;
                        });
                    };
                    LocationFinderMgr.prototype.loadInfo = function (genreTypeIDs, experienceTypeIDs, courseIDs, refreshCache) {
                        var _this = this;
                        if (refreshCache === void 0) { refreshCache = false; }
                        return this.common.debounceAdd(LocationFinderMgr._LOAD_INFO_DEBOUNCE_KEY, function () {
                            if (refreshCache || !_this.optionItems) {
                                _this.optionItems = null;
                                _this._lookupUSStates = null;
                                _this.lookupDivisions = null;
                                _this.lookupStateRelSubReg = null;
                                _this.locDivs = null;
                                _this.locAddrs = null;
                                return _this.getLookupStateRelatedSubRegions()
                                    .then(function (data) {
                                    _this.lookupStateRelSubReg = data;
                                    return _this.getLookupStates()
                                        .then(function (stateInfos) {
                                        var tempLookupUSStates = new Array();
                                        var pulseTypeDAO = new DataAccess.PulseTypeDAO(_this.common, _this.breezeService, _this.pulseContext, _this._dateInContext);
                                        var subRegionPromises = new Array();
                                        stateInfos.forEach(function (stateInfo, index) {
                                            var stateSubRegs = Pulse.Utils.JS.findByProperties(_this.lookupStateRelSubReg, { stateID: stateInfo.iD });
                                            if (stateSubRegs && stateSubRegs.length > 0) {
                                                subRegionPromises.push(pulseTypeDAO.getActiveByParentTypeId(stateInfo.iD, Common.Enums.TypeClassType.StateSubRegion)
                                                    .then(function (subRegData) {
                                                    if (subRegData.length > 0) {
                                                        subRegData.forEach(function (subReg, index) {
                                                            tempLookupUSStates.push({
                                                                iD: stateInfo.iD,
                                                                name: stateInfo.name + ' - ' + subReg.typeString,
                                                                order: stateInfo.order,
                                                                subRegionID: subReg.typeID,
                                                                locTypeID: null
                                                            });
                                                        });
                                                    }
                                                }));
                                            }
                                            else {
                                                tempLookupUSStates.push(stateInfo);
                                            }
                                        });
                                        return _this.common.$q.all(subRegionPromises).then(function () {
                                            _this._lookupUSStates = tempLookupUSStates.sort(function (loc1, loc2) { return Pulse.Utils.JS.compareForSort(loc1, loc2, { 'name': 0 }); });
                                            return _this._lookupUSStates;
                                        });
                                    });
                                })
                                    .then(function () {
                                    var promises = new Array();
                                    promises.push(_this.getLookupCountries()
                                        .then(function (data) {
                                        _this._lookupCountries = data;
                                        return data;
                                    }));
                                    promises.push(_this.getLookupDivisions()
                                        .then(function (data) {
                                        _this.lookupDivisions = data;
                                        return data;
                                    }));
                                    var courseID = courseIDs != null && courseIDs.length ? courseIDs[0] : null;
                                    var locTypes = [
                                        Common.Enums.LocationType.UniversityCollege,
                                        Common.Enums.LocationType.VirtualSummerCamp,
                                        Common.Enums.LocationType.VirtualSquads,
                                        Common.Enums.LocationType.BootcampPartnership
                                    ];
                                    promises.push(_this.getLocations(null, locTypes, null, null, null, null, courseID, genreTypeIDs, experienceTypeIDs)
                                        .then(function (data) {
                                        _this.optionItems = data;
                                        return data;
                                    }));
                                    _this.locDivs = [];
                                    promises.push(_this.getLocationAddresses()
                                        .then(function (data) {
                                        _this.locAddrs = data;
                                        return data;
                                    }));
                                    promises.push(_this.getCatalogDateRanges(_this._dateInContext)
                                        .then(function (data) {
                                        _this.catalogDateRanges = _.sortBy(data, 'sortOrder');
                                        return data;
                                    }));
                                    promises.push(_this.getTerms()
                                        .then(function (data) {
                                        _this.terms = _.sortBy(data, 'sortOrder');
                                        return data;
                                    }));
                                    return _this.common.$q.all(promises);
                                });
                            }
                            return;
                        }, 0, true);
                    };
                    Object.defineProperty(LocationFinderMgr.prototype, "selectedLocInfos", {
                        get: function () {
                            var _this = this;
                            this.selectedItems;
                            if (!this.optionItems)
                                return null;
                            var selectedLocs = new Array();
                            this.optionItems.forEach(function (locInfo, index) {
                                if (_this.selectedIds.indexOf(locInfo.iD) >= 0) {
                                    selectedLocs.push(locInfo);
                                }
                            });
                            return selectedLocs;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    LocationFinderMgr.prototype.selectRemoveLoc = function (locID, isSelected) {
                        if (isSelected && this.selectedIds.indexOf(locID) < 0) {
                            this.selectedIds.push(locID);
                        }
                        else if (!isSelected) {
                            var index = this.selectedIds.indexOf(locID);
                            if (index >= 0) {
                                this.selectedIds.splice(index, 1);
                            }
                        }
                    };
                    LocationFinderMgr.prototype.clearLocationsInfo = function () {
                        this.optionItems = null;
                        this.selectedIds = new Array();
                    };
                    LocationFinderMgr.prototype.restoreState = function (forceRestoreFromStorage) {
                        if (forceRestoreFromStorage === void 0) { forceRestoreFromStorage = false; }
                        _super.prototype.restoreState.call(this, forceRestoreFromStorage);
                        var queryParams = {};
                        var url = this.common.$location.url();
                        if (!this.selectedProdIDs || this.selectedProdIDs.length == 0) {
                            var prodIDs = QueryStringUtils.GetParamByName(url, QueryStringUtils.PRODUCT_ID);
                            if (Pulse.jQuery.isArray(prodIDs)) {
                                this.selectedProdIDs = prodIDs.map(function (lid) { return parseInt(lid); });
                            }
                            else if (Pulse.jQuery.isNumeric(prodIDs)) {
                                this.selectedProdIDs = [parseInt(prodIDs)];
                            }
                        }
                        else {
                            queryParams[QueryStringUtils.PRODUCT_ID] = this.selectedProdIDs;
                        }
                        url = QueryStringUtils.AddOrSetQSParams(url, queryParams);
                        this.common.$location.url(url).replace();
                    };
                    LocationFinderMgr.registeredAs = 'LocationFinderMgr';
                    LocationFinderMgr.CLASS_NAME = LocationFinderMgr.registeredAs;
                    LocationFinderMgr._LOAD_INFO_DEBOUNCE_KEY = 'LocationFinderMgr_loadInfo';
                    return LocationFinderMgr;
                }(DataAccess.Managers.RegFlowMgr.RegFlowStepMgr));
                Managers.LocationFinderMgr = LocationFinderMgr;
                Pulse.app.service(LocationFinderMgr.registeredAs, [
                    'common',
                    'breezeService',
                    'pulseContextService',
                    LocationFinderMgr
                ]);
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var GenreFinderMgr = (function (_super) {
                    __extends(GenreFinderMgr, _super);
                    function GenreFinderMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, GenreFinderMgr.CLASS_NAME, QueryStringUtils.GENRE_ID) || this;
                        _this._dateInContext = null;
                        _this._dateInContext = dateInContext;
                        return _this;
                    }
                    GenreFinderMgr.prototype.setDateInContext = function (date) {
                        this._dateInContext = date;
                    };
                    GenreFinderMgr.prototype.getGenres = function (locationIDs, experienceTypeIDs) {
                        var query = breeze.EntityQuery
                            .from('LCF_GetGenres')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                            experienceTypeIDs: experienceTypeIDs ? experienceTypeIDs : [],
                            locationIDs: locationIDs ? locationIDs : [],
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                    };
                    GenreFinderMgr.prototype.loadInfo = function (locationIDs, experienceTypeIDs) {
                        var _this = this;
                        return this.common.debounceAdd(GenreFinderMgr._LOAD_INFO_DEBOUNCE_KEY, function () {
                            var promises = new Array();
                            promises.push(_this.getGenres(locationIDs, experienceTypeIDs)
                                .then(function (data) {
                                _this.optionItems = data;
                                return data;
                            }));
                            return _this.common.$q.all(promises);
                        }, 0, true);
                    };
                    GenreFinderMgr.prototype.getGenericGenres = function () {
                        var _this = this;
                        return this.common.$q(function (resolve) {
                            if (_this.genericGenres !== undefined)
                                resolve(_this.genericGenres);
                            else
                                resolve(_this.getGenres()
                                    .then(function (genres) {
                                    return _this.genericGenres = genres
                                        .sort(function (a, b) { return a.order - b.order; });
                                }));
                        });
                    };
                    GenreFinderMgr.prototype.restoreState = function (forceRestoreFromStorage) {
                        if (forceRestoreFromStorage === void 0) { forceRestoreFromStorage = false; }
                        _super.prototype.restoreState.call(this, forceRestoreFromStorage);
                    };
                    GenreFinderMgr.registeredAs = 'GenreFinderMgr';
                    GenreFinderMgr.CLASS_NAME = GenreFinderMgr.registeredAs;
                    GenreFinderMgr._LOAD_INFO_DEBOUNCE_KEY = 'GenreFinderMgr_loadInfo';
                    return GenreFinderMgr;
                }(DataAccess.Managers.RegFlowMgr.RegFlowStepMgr));
                Managers.GenreFinderMgr = GenreFinderMgr;
                Pulse.app.service(GenreFinderMgr.registeredAs, [
                    'common',
                    'breezeService',
                    'pulseContextService',
                    GenreFinderMgr
                ]);
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var RegFlowStepMgr = Pulse.Common.DataAccess.Managers.RegFlowMgr.RegFlowStepMgr;
                var AgeFilterMgr = (function (_super) {
                    __extends(AgeFilterMgr, _super);
                    function AgeFilterMgr(common, breezeService, pulseContext, ageIntervals) {
                        var _this = _super.call(this, common, breezeService, pulseContext, AgeFilterMgr.CLASS_NAME, QueryStringUtils.AGE_FILTER_SET_ID) || this;
                        _this.optionItems = _this.generateOptions(ageIntervals);
                        return _this;
                    }
                    AgeFilterMgr.prototype.generateOptions = function (ageIntervals) {
                        var options = [];
                        ageIntervals.forEach(function (option, i) {
                            return options.push(new AgeFilterMgr.AgeInterval(i, option));
                        });
                        return options;
                    };
                    AgeFilterMgr.registeredAs = 'AgeFilterMgr';
                    AgeFilterMgr.CLASS_NAME = AgeFilterMgr.registeredAs;
                    return AgeFilterMgr;
                }(RegFlowStepMgr));
                Managers.AgeFilterMgr = AgeFilterMgr;
                (function (AgeFilterMgr) {
                    var AgeInterval = (function () {
                        function AgeInterval(id, interval) {
                            this.iD = id;
                            this.min = interval.min;
                            this.max = interval.max;
                        }
                        Object.defineProperty(AgeInterval.prototype, "name", {
                            get: function () {
                                return this.min + ' - ' + this.max;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return AgeInterval;
                    }());
                    AgeFilterMgr.AgeInterval = AgeInterval;
                })(AgeFilterMgr = Managers.AgeFilterMgr || (Managers.AgeFilterMgr = {}));
                Pulse.app.value('ageIntervals', [
                    { min: 7, max: 9 },
                    { min: 10, max: 12 },
                    { min: 13, max: 19 }
                ]);
                Pulse.app.service(AgeFilterMgr.registeredAs, [
                    'common',
                    'breezeService',
                    'pulseContextService',
                    'ageIntervals',
                    AgeFilterMgr
                ]);
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers_1) {
                var RegFlowStepMgr = Pulse.Common.DataAccess.Managers.RegFlowMgr.RegFlowStepMgr;
                var ExperienceFinderMgr = (function (_super) {
                    __extends(ExperienceFinderMgr, _super);
                    function ExperienceFinderMgr(common, breezeService, pulseContext, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, ExperienceFinderMgr.CLASS_NAME, QueryStringUtils.EXPERIENCE_ID) || this;
                        _this._dateInContext = null;
                        _this.lookupDivExpInfos = null;
                        _this._dateInContext = dateInContext;
                        return _this;
                    }
                    ExperienceFinderMgr.prototype.setDateInContext = function (date) {
                        this._dateInContext = date;
                    };
                    Object.defineProperty(ExperienceFinderMgr.prototype, "selectedDivExpInfos", {
                        get: function () {
                            var _this = this;
                            var divExpInfos = this.lookupDivExpInfos.filter(function (divExpInfo) {
                                return _this.selectedIds.indexOf(divExpInfo.iD) >= 0;
                            });
                            return divExpInfos;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ExperienceFinderMgr.prototype.getExperiences = function (locationIDs, genreTypeIDs) {
                        var query = breeze.EntityQuery
                            .from('LCF_GetExperiences')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                            genreTypeIDs: genreTypeIDs ? genreTypeIDs : [],
                            locationIDs: locationIDs ? locationIDs : [],
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                    };
                    ExperienceFinderMgr.prototype.getLookupDivExperiences = function () {
                        var query = breeze.EntityQuery
                            .from('LCF_GetLookupDivExperiences')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            dateInContext: this._dateInContext,
                        });
                        return this.entityMgr.executeQuery(query).then(function (data) {
                            return data.results;
                        });
                    };
                    ExperienceFinderMgr.prototype.loadInfoByLocAndGenre = function (locationIDs, genreTypeIDs, refreshCache) {
                        var _this = this;
                        if (refreshCache === void 0) { refreshCache = false; }
                        return this.common.debounceAdd(ExperienceFinderMgr._LOAD_INFO_DEBOUNCE_KEY, function () {
                            var promises = new Array();
                            promises.push(_this.getExperiences(locationIDs, genreTypeIDs)
                                .then(function (data) { return _this.optionItems = data; }));
                            promises.push(_this.loadInfo());
                            return _this.common.$q.all(promises);
                        }, 0, true);
                    };
                    ExperienceFinderMgr.prototype.loadInfo = function (refreshCache) {
                        var _this = this;
                        if (refreshCache === void 0) { refreshCache = false; }
                        var promises = [];
                        if (refreshCache || !this.lookupDivExpInfos) {
                            promises.push(this.getLookupDivExperiences()
                                .then(function (data) { return _this.lookupDivExpInfos = data; }));
                        }
                        return this.common.$q.all(promises);
                    };
                    ExperienceFinderMgr.prototype.getDivisionExperiences = function (refresh) {
                        var _this = this;
                        if (refresh === void 0) { refresh = false; }
                        return this.common.$q(function (resolve) {
                            if (!refresh && _this.lookupDivExpInfos && _this.lookupDivExpInfos.length !== 0) {
                                resolve(_this.lookupDivExpInfos);
                            }
                            else {
                                resolve(_this.getLookupDivExperiences()
                                    .then(function (result) {
                                    return _this.lookupDivExpInfos = result;
                                }));
                            }
                        });
                    };
                    ExperienceFinderMgr.registeredAs = 'ExperienceFinderMgr';
                    ExperienceFinderMgr.CLASS_NAME = ExperienceFinderMgr.registeredAs;
                    ExperienceFinderMgr._LOAD_INFO_DEBOUNCE_KEY = 'ExperienceFinderMgr_loadInfo';
                    return ExperienceFinderMgr;
                }(RegFlowStepMgr));
                Managers_1.ExperienceFinderMgr = ExperienceFinderMgr;
                Pulse.app.service(ExperienceFinderMgr.registeredAs, [
                    'common',
                    'breezeService',
                    'pulseContextService',
                    ExperienceFinderMgr
                ]);
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers_1) {
                var BaseMgr = Pulse.Common.DataAccess.Managers.BaseMgr;
                var AvcTermDivisionDecorator = Pulse.Common.DataAccess.Services.AvcTermDivisionDecorator;
                var AvcProductDecorator = Pulse.Common.DataAccess.Services.AvcProductDecorator;
                var AvailChartMgr = (function (_super) {
                    __extends(AvailChartMgr, _super);
                    function AvailChartMgr(common, breezeService, pulseContext, chartFiltersMgr, termDivisionDecorator, productDecorator, dateInContext) {
                        if (dateInContext === void 0) { dateInContext = null; }
                        var _this = _super.call(this, common, breezeService, pulseContext, AvailChartMgr.CLASS_NAME) || this;
                        _this._dateInContext = null;
                        _this._currencyTypeID = null;
                        _this.initRegFlowData();
                        _this.chartFiltersMgr = chartFiltersMgr;
                        _this.termDivisionDecorator = termDivisionDecorator;
                        _this.productDecorator = productDecorator;
                        _this._dateInContext = dateInContext;
                        _this.common.$rootScope.$on(Events.LoggedOutRefresh, function (e, clearAllState) {
                            _this.initRegFlowData();
                        });
                        return _this;
                    }
                    Object.defineProperty(AvailChartMgr.prototype, "currencyTypeID", {
                        get: function () {
                            return this._currencyTypeID;
                        },
                        set: function (currencyTypeID) {
                            this._currencyTypeID = currencyTypeID;
                            if (this.chartData && this._currencyTypeID == null) {
                                this.chartData = null;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AvailChartMgr.prototype.initRegFlowData = function () {
                        this.locationMgr = this.pulseContext.regFlowMgr.locationFinderMgr;
                        this.genreMgr = this.pulseContext.regFlowMgr.genreFinderMgr;
                        this.experienceMgr = this.pulseContext.regFlowMgr.experienceFinderMgr;
                        this.userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                    };
                    AvailChartMgr.prototype.setDateInContext = function (date) {
                        this._dateInContext = date;
                    };
                    Object.defineProperty(AvailChartMgr.prototype, "selectedItems", {
                        get: function () {
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AvailChartMgr.prototype, "optionItems", {
                        get: function () {
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AvailChartMgr.prototype, "hasSelectedItems", {
                        get: function () {
                            return false;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AvailChartMgr.prototype.clearAllSelected = function () {
                        return;
                    };
                    AvailChartMgr.prototype.restoreState = function (forceRestoreFromStorage) {
                        if (forceRestoreFromStorage === void 0) { forceRestoreFromStorage = false; }
                        return;
                    };
                    AvailChartMgr.prototype.addOrSetQSParams = function (params) {
                        return params;
                    };
                    AvailChartMgr.prototype.getAvChartData = function (locationsIds, forcePaint) {
                        var _this = this;
                        if (forcePaint === void 0) { forcePaint = false; }
                        return this.getPaintedTermDivisionCourses(locationsIds, forcePaint)
                            .then(function (termDivs) {
                            termDivs = _this.filterTermDivs(termDivs);
                            termDivs.forEach(function (division) {
                                division.courses = _this.filterCourses(division.courses);
                            });
                            return termDivs;
                        });
                    };
                    AvailChartMgr.prototype.getPaintedTermDivisionCourses = function (locationsIds, force) {
                        var _this = this;
                        if (force === void 0) { force = false; }
                        return this.common.$q.all([
                            this.getRawDecoratedDivisions(locationsIds),
                            this.getWaitlistedSessionProductIds(locationsIds),
                            this.getLocSpecificCartItems(locationsIds)
                        ])
                            .then(function (result) {
                            var termDivs = result[0];
                            var waitlistedSessionsSpdIds = result[1];
                            var cartItems = result[2];
                            var courseFilteredCart;
                            if (!_this.paintedTermDivisionCourses.length || force) {
                                termDivs.forEach(function (division) {
                                    if (cartItems.length || waitlistedSessionsSpdIds.length)
                                        division.courses.forEach(function (course) {
                                            courseFilteredCart = cartItems.filter(function (cartItem) {
                                                return course.prodID === cartItem.productID;
                                            });
                                            course.sessions.forEach(function (session) {
                                                session.inWaitlist = waitlistedSessionsSpdIds.indexOf(session.spdID) !== -1;
                                                session.inCartCount = courseFilteredCart.filter(function (cartItem) {
                                                    return session.spdID === cartItem.sessionProductDetailID;
                                                }).length;
                                            });
                                        });
                                    _this.paintedTermDivisionCourses.push(division.courses);
                                });
                            }
                            else {
                                termDivs.forEach(function (division, index) {
                                    division.courses = _this.paintedTermDivisionCourses[index];
                                });
                            }
                            return termDivs;
                        });
                    };
                    AvailChartMgr.prototype.getCampProducts = function (division, course, session) {
                        var _this = this;
                        return this.getProgramDetails(session.spdID, session.spdIDON)
                            .then(function (program) {
                            return _this.productDecorator.decorate(program, division, course, session);
                        });
                    };
                    AvailChartMgr.prototype.getStandardCampTermDivSessionInfo = function (locationIDs) {
                        var query = breeze.EntityQuery.from('AvailChart_GetStandardCampTermDivSessionInfo')
                            .withParameters({
                            companyID: this.pulseContext.companyId,
                            locationIDs: locationIDs,
                            dateInContext: this._dateInContext,
                            currencyTypeID: this.currencyTypeID,
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return (data.results);
                        });
                    };
                    AvailChartMgr.prototype.getStandardCampAvailability = function (locationID, divisionID, termID, ageRangeID, genreIDs, schedTypeID) {
                        var query = breeze.EntityQuery
                            .from('AvailChart_GetStandardCampAvailability')
                            .withParameters({
                            ageRangeID: ageRangeID,
                            browseIdentifier: this.pulseContext.browseIdentifier,
                            divisionID: divisionID,
                            genreIDs: genreIDs,
                            locationID: locationID,
                            schedTypeID: schedTypeID,
                            termID: termID,
                            dateInContext: this._dateInContext,
                            currencyTypeID: this.currencyTypeID
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return (data.results);
                        });
                    };
                    AvailChartMgr.prototype.getProgramDetails = function (mainSpdID, overnightSpdID) {
                        var query = breeze.EntityQuery.from('AvailChart_GetProgramDetails')
                            .withParameters({
                            mainSpdID: mainSpdID,
                            overnightSpdID: overnightSpdID,
                            dateInContext: this._dateInContext,
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            if (data && data.results && data.results.length > 0)
                                return (data.results[0]);
                            else
                                return null;
                        });
                    };
                    AvailChartMgr.prototype.getCrossSellProducts = function (divisionID) {
                        var query = breeze.EntityQuery.from('AvailChart_GetCrossSellProducts')
                            .withParameters({
                            divisionID: divisionID,
                            dateInContext: this._dateInContext,
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            if (data && data.results && data.results.length > 0)
                                return data.results;
                            else
                                return null;
                        });
                    };
                    AvailChartMgr.prototype.getNearestLocations = function (spdID, maxCount, sameSessionOnly) {
                        var query = breeze.EntityQuery.from('AvailChart_GetNearestLocations')
                            .withParameters({
                            maxCount: maxCount,
                            sameSessionOnly: sameSessionOnly,
                            spdID: spdID,
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return (data.results);
                        });
                    };
                    AvailChartMgr.prototype.getOptionsForLocationTerm = function (isOvernight, locationID, termID) {
                        var query = breeze.EntityQuery.from('AvailChart_GetOptionsForLocationTerm')
                            .withParameters({
                            isOvernight: isOvernight,
                            locationID: locationID,
                            termID: termID,
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return (data.results[0]);
                        });
                    };
                    AvailChartMgr.prototype.isJoinWaitlist = function (session) {
                        return session
                            && session.programStatusTypeID === Common.Enums.SessionAvailabilityStatus.SoldOut
                            || session.programStatusTypeID === Common.Enums.SessionAvailabilityStatus.SoldOutDesktop;
                    };
                    AvailChartMgr.prototype.isCallUs = function (session) {
                        return session.programStatusTypeID === Common.Enums.SessionAvailabilityStatus.CallUs;
                    };
                    AvailChartMgr.prototype.canSessionBeBought = function (session) {
                        return session
                            && !this.doesSessionExists(session)
                            || session.programStatusTypeID === Common.Enums.SessionAvailabilityStatus.NoSpace;
                    };
                    AvailChartMgr.prototype.doesSessionExists = function (session) {
                        return [
                            Common.Enums.SessionAvailabilityStatus.Closed,
                            Common.Enums.SessionAvailabilityStatus.Coming,
                            Common.Enums.SessionAvailabilityStatus.NA,
                            Common.Enums.SessionAvailabilityStatus.NotOffered,
                            Common.Enums.SessionAvailabilityStatus.SelectAnotherWeek,
                        ].indexOf(session.programStatusTypeID) < 0;
                    };
                    AvailChartMgr.prototype.isAvailabilityChartFilterQueryEmpty = function () {
                        var filterQuery = this.common.localStorageService.get('availabilityChartFilterQuery');
                        return !filterQuery || !filterQuery['selectedState'] || !filterQuery['selectedLocation'];
                    };
                    AvailChartMgr.prototype.loadStandardCampTermDivSessionInfo = function (locations) {
                        var _this = this;
                        var promises = [];
                        promises.push(this.getStandardCampTermDivSessionInfo(locations)
                            .then(function (data) {
                            _this.termDivInfos = (data);
                            _this._flattenedSessions = _this.flattenSessions(_this.termDivInfos);
                        }));
                        return this.common.$q.all(promises);
                    };
                    AvailChartMgr.prototype.isSessionClosedForAddingResidency = function (termSession) {
                        var isClosed = true;
                        if (termSession && termSession.residencyAddEndDate !== undefined)
                            isClosed = !(termSession.residencyAddEndDate === null
                                || this.isDateStringAfterServerDate(termSession.residencyAddEndDate + ''));
                        return isClosed;
                    };
                    AvailChartMgr.prototype.isSessionClosedForAddingMeal = function (termSession) {
                        var isClosed = true;
                        if (termSession && termSession.mealAddEndDate)
                            isClosed = !(termSession.residencyAddEndDate === null
                                || this.isDateStringAfterServerDate(termSession.mealAddEndDate + ''));
                        return isClosed;
                    };
                    AvailChartMgr.prototype.isCourseNew = function (course) {
                        return course.isNewExpireDate ? moment(this.pulseContext.serverDateTime).isSameOrBefore(moment(course.isNewExpireDate).endOf('day')) : false;
                    };
                    AvailChartMgr.prototype.checkSessionResidencyOptionAvailability = function (division, locSessID) {
                        var availability = false;
                        if (division && division.sessions && division.sessions.length) {
                            var locSession = division.sessions
                                .filter(function (ls) { return locSessID === ls.lSID; })
                                .shift();
                            if (locSession && locSession.residencyAddEndDate !== undefined)
                                availability = locSession.residencyAddEndDate === null
                                    || this.isDateStringAfterServerDate(locSession.residencyAddEndDate + '');
                        }
                        return availability;
                    };
                    AvailChartMgr.prototype.checkSessionMealOptionAvailability = function (division, locSessID) {
                        var availability = false;
                        if (division && division.sessions && division.sessions.length) {
                            var locSession = division.sessions
                                .filter(function (ls) { return locSessID === ls.lSID; })
                                .shift();
                            if (locSession && locSession.mealAddEndDate !== undefined)
                                availability = locSession.mealAddEndDate === null
                                    || this.isDateStringAfterServerDate(locSession.mealAddEndDate + '');
                        }
                        return availability;
                    };
                    AvailChartMgr.prototype.flattenSessions = function (termDivInfos) {
                        var result = {};
                        for (var _i = 0, _a = this.termDivInfos; _i < _a.length; _i++) {
                            var termDivInfo = _a[_i];
                            for (var _b = 0, _c = termDivInfo.sessions; _b < _c.length; _b++) {
                                var session = _c[_b];
                                result[session.lSID] = session;
                            }
                        }
                        return result;
                    };
                    AvailChartMgr.prototype.getLocSessionInfoByID = function (locSessID) {
                        if (this._flattenedSessions === undefined)
                            this._flattenedSessions = this.flattenSessions(this.termDivInfos);
                        return this._flattenedSessions[locSessID];
                    };
                    AvailChartMgr.prototype.isDateStringAfterServerDate = function (isoDateString) {
                        return moment(Pulse.Utils.JS.dateTimeStrToDateObj(isoDateString))
                            .isAfter(this.pulseContext.serverDateTime);
                    };
                    AvailChartMgr.GetThumbNailFullUrl = function (config, course, largeImage) {
                        if (largeImage === void 0) { largeImage = false; }
                        var prodThumbImgUrl = '';
                        var url;
                        url = course.uRLs
                            .filter(function (u) {
                            return u.usageTypeID === Common.Enums.ProductURLType.CourseVideoIntroImageURL;
                        })
                            .shift();
                        if (url && !String.isNullOrWhitespace(url.uRL)) {
                            prodThumbImgUrl = Pulse.Utils.JS.composeProductThumbNailFullUrl(config.courseVideoThumbnailUrl, url.uRL, largeImage);
                        }
                        return prodThumbImgUrl;
                    };
                    AvailChartMgr.prototype.getRawDecoratedDivisions = function (locationsIds) {
                        var _this = this;
                        return this.common
                            .$q(function (resolve) {
                            if (_this.isCachedChartDataValid(locationsIds))
                                resolve(_this.chartData);
                            else {
                                _this.queriedLocationIds = angular.copy(locationsIds);
                                _this.paintedTermDivisionCourses = [];
                                resolve(_this.retrieveNewChartData(locationsIds));
                            }
                        })
                            .then(function (termDivs) {
                            termDivs.forEach(function (division, i) {
                                return division.courses = angular.copy(_this.rawTermDivisionsCourses[i]);
                            });
                            return termDivs;
                        });
                    };
                    AvailChartMgr.prototype.isCachedChartDataValid = function (locationsIds) {
                        return this.chartData && this.queriedLocationIds
                            && Pulse.Utils.JS.areArraysEqual(this.queriedLocationIds, locationsIds);
                    };
                    AvailChartMgr.prototype.filterTermDivs = function (termDivs) {
                        if (!this.pulseContext.isImpersonating
                            && this.common.$location.absUrl().indexOf(Routes.MyAccount) < 0) {
                            var QS_CAMP_AT_HQ = this.common.$location.search()[QueryStringUtils.LOCATION_ATTR_CAMP_AT_HQ];
                            var hasQS_1 = QS_CAMP_AT_HQ === 'true' || QS_CAMP_AT_HQ === true;
                            termDivs = termDivs.filter(function (td) { return (!td.locHasCampAtHQ || hasQS_1); });
                        }
                        return termDivs;
                    };
                    AvailChartMgr.prototype.filterCourses = function (courses) {
                        var _this = this;
                        return courses.filter(function (course) {
                            return _this.chartFiltersMgr.checkCourseValidity(course);
                        });
                    };
                    AvailChartMgr.prototype.retrieveNewChartData = function (locationIds) {
                        var _this = this;
                        return this.getExtendedTermDivisions(locationIds)
                            .then(function (termDivisions) {
                            _this.chartData = termDivisions.map(function (termDiv) {
                                return _this.trimUnavailableSessions(termDiv);
                            });
                            _this.rawTermDivisionsCourses = _this.chartData.map(function (termDiv) {
                                return angular.copy(termDiv.courses);
                            });
                            return _this.chartData;
                        });
                    };
                    AvailChartMgr.prototype.getExtendedTermDivisions = function (locationIds) {
                        var _this = this;
                        return this.common.$q.all([
                            this.getStandardCampTermDivSessionInfo(locationIds),
                            this.locationMgr.getGenericDivisionsProps(),
                            this.genreMgr.getGenericGenres(),
                            this.experienceMgr.getDivisionExperiences(),
                        ])
                            .then(function (data) {
                            var termDivisions = data[0];
                            var genericDivisions = data[1];
                            var genericGenres = data[2];
                            var divisionExperiences = data[3];
                            return _this.getDivisionsCourses(termDivisions)
                                .then(function (divisionsCourses) {
                                return _this.getDecoratedTermDivisions(termDivisions, genericDivisions, genericGenres, divisionExperiences, divisionsCourses);
                            });
                        });
                    };
                    AvailChartMgr.prototype.getDivisionsCourses = function (termDivisions) {
                        var _this = this;
                        return this.common.$q.all(termDivisions.map(function (division) {
                            return _this.getStandardCampAvailability(division.locID, division.divID, division.termID, division.ageRangeID, [], division.schedTypeID);
                        }));
                    };
                    AvailChartMgr.prototype.getDecoratedTermDivisions = function (termDivisions, genericDivisions, genericGenres, divisionExperiences, divisionsCourses) {
                        var _this = this;
                        return termDivisions.map(function (division, index) {
                            return _this.termDivisionDecorator.decorate(division, genericDivisions, genericGenres, divisionExperiences, divisionsCourses[index]);
                        });
                    };
                    AvailChartMgr.prototype.getWaitlistedSessionProductIds = function (locationIds) {
                        var _this = this;
                        return this.common.$q(function (resolve) {
                            var currentUBSession = _this.userBrowsingMgr.currentUBSession;
                            if (currentUBSession.userBrowsingDTO && currentUBSession.userBrowsingDTO.emailAddress) {
                                resolve(_this.userBrowsingMgr.loadWaitlist(currentUBSession, currentUBSession.userBrowsingDTO.emailAddress));
                            }
                            else {
                                resolve([]);
                            }
                        })
                            .then(function (waitlistedItems) {
                            waitlistedItems = waitlistedItems || [];
                            return waitlistedItems.filter(function (waitlistedItem) {
                                return locationIds.indexOf(waitlistedItem.locationID) !== -1;
                            })
                                .map(function (w) {
                                return w.spdid;
                            });
                        });
                    };
                    AvailChartMgr.prototype.getLocSpecificCartItems = function (locationsIds) {
                        var cartItems = this.userBrowsingMgr.currentUBSession.UB_ItemDTOs || [];
                        return cartItems.filter(function (item) {
                            return locationsIds.indexOf(item.locationID) !== -1 && item.parentUserBrowsingItemID === null;
                        });
                    };
                    AvailChartMgr.prototype.areNumberArraysEqual = function (arr1, arr2) {
                        var areEqual = arr1.length === arr2.length;
                        if (areEqual) {
                            arr1.forEach(function (a) { return areEqual = arr2.indexOf(a) !== -1; });
                        }
                        return areEqual;
                    };
                    AvailChartMgr.prototype.trimUnavailableSessions = function (division) {
                        var termAvailableSessionIds = this.getDivisionAvailableSessionsIds(division);
                        var termSessionsIds = division.sessions.map(function (session) { return session.sessID; });
                        var sessionSliceBegin = this.getAvaialbleSessionsStartIndex(termSessionsIds, termAvailableSessionIds);
                        var sessionSliceEnd = termSessionsIds.length
                            - this.getAvaialbleSessionsStartIndex(termSessionsIds.reverse(), termAvailableSessionIds);
                        if (sessionSliceBegin < sessionSliceEnd) {
                            division.sessions = division.sessions.slice(sessionSliceBegin, sessionSliceEnd);
                            angular.forEach(division.courses, function (course) {
                                course.sessions = course.sessions.slice(sessionSliceBegin, sessionSliceEnd);
                            });
                        }
                        return division;
                    };
                    AvailChartMgr.prototype.getAvaialbleSessionsStartIndex = function (locSessIds, availSessIds) {
                        return locSessIds.reduce(function (v, cv, i) { return availSessIds.indexOf(cv) === -1 && v === i ? i + 1 : v; }, 0);
                    };
                    AvailChartMgr.prototype.getDivisionAvailableSessionsIds = function (division) {
                        var availableIdsPoll = [];
                        angular.forEach(division.courses, function (course) {
                            angular.forEach(course.sessions, function (session) {
                                if (session.hasCourse) {
                                    availableIdsPoll.push(session.sessID);
                                }
                            });
                        });
                        return availableIdsPoll.filter(function (id, index) { return availableIdsPoll.indexOf(id) === index; });
                    };
                    AvailChartMgr.registeredAs = 'AvailChartMgr';
                    AvailChartMgr.CLASS_NAME = AvailChartMgr.registeredAs;
                    return AvailChartMgr;
                }(BaseMgr));
                Managers_1.AvailChartMgr = AvailChartMgr;
                Pulse.app.service(AvailChartMgr.registeredAs, [
                    'common',
                    'breezeService',
                    'pulseContextService',
                    'chartFilterMgr',
                    AvcTermDivisionDecorator.registeredAs,
                    AvcProductDecorator.registeredAs,
                    AvailChartMgr,
                ]);
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var BaseMgr = Pulse.Common.DataAccess.Managers.BaseMgr;
                var ProdAvailabilityMgr = (function (_super) {
                    __extends(ProdAvailabilityMgr, _super);
                    function ProdAvailabilityMgr(common, breezeService, pulseContext) {
                        var _this = _super.call(this, common, breezeService, pulseContext, ProdAvailabilityMgr.CLASS_NAME) || this;
                        _this._locationListCache = {};
                        _this._fetchedProductLocations = [];
                        return _this;
                    }
                    ProdAvailabilityMgr.prototype.getProductAvailability = function (productID, timeZoneTypeID) {
                        var query = breeze.EntityQuery.from('Product_GetAvailability')
                            .withParameters({
                            productID: productID,
                            timeZoneTypeID: timeZoneTypeID,
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return (data.results[0]);
                        });
                    };
                    ProdAvailabilityMgr.prototype.getProductAvailabilityByLocation = function (productID, locationID, emailAddress, dateInContext) {
                        if (emailAddress === void 0) { emailAddress = ''; }
                        if (dateInContext === void 0) { dateInContext = new Date(); }
                        var query = breeze.EntityQuery.from('Product_GetAvailabilityByLocation')
                            .withParameters({
                            productID: productID,
                            locationID: locationID,
                            emailAddress: emailAddress,
                            dateInContext: dateInContext
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return (data.results[0]);
                        });
                    };
                    ProdAvailabilityMgr.prototype.getWwwLocationsByProductId = function (productId) {
                        var _this = this;
                        var url = this.common.config.webApi_UrlRoot + '/Courses/GetById';
                        this._fetchedProductLocations.push(productId);
                        return this.common.$http.get(url, {
                            params: {
                                'companyID': this.common.config.companyId,
                                'courseID': productId
                            },
                            headers: {
                                'Content-Type': 'applications/json'
                            }
                        }).then(function (response) {
                            if (response.data !== null && response.data !== undefined) {
                                var locIds_1 = response.data.locations.map(function (e) {
                                    return {
                                        productID: productId,
                                        locationID: e,
                                        addressArea: '',
                                        locationName: ''
                                    };
                                });
                                var variantIds_1 = response.data.variantIDs;
                                if (variantIds_1.length > 0) {
                                    var promises_1 = new Array();
                                    variantIds_1.forEach(function (prodId) {
                                        if (_this._fetchedProductLocations.indexOf(prodId) == -1) {
                                            promises_1.push(_this.getWwwLocationsByProductId(variantIds_1[0]));
                                        }
                                    });
                                    return _this.common.$q.all(promises_1).then(function (variantLocIds) {
                                        var varList = variantLocIds[0];
                                        if (varList !== undefined) {
                                            varList = varList.filter(function (item) {
                                                return item !== undefined && item !== null;
                                            });
                                        }
                                        return _.concat(locIds_1, varList);
                                    });
                                }
                                else {
                                    return locIds_1;
                                }
                            }
                            else {
                                return [];
                            }
                        });
                    };
                    ProdAvailabilityMgr.prototype.getWwwProductLocationList = function (productId) {
                        var _this = this;
                        var cacheKey = productId.toString();
                        if (Object.keys(this._locationListCache).indexOf(cacheKey) != -1) {
                            var defered = this.common.$q.defer();
                            defered.resolve(this._locationListCache[cacheKey]);
                            return defered.promise;
                        }
                        else {
                            this._fetchedProductLocations = [];
                            return this.getWwwLocationsByProductId(productId).then(function (locList) {
                                var url = _this.common.config.webApi_UrlRoot + "/Locations/GetAll";
                                var locIds = locList.map(function (e) { return e.locationID; });
                                return _this.common.$http.get(url, {
                                    params: {
                                        'companyID': _this.common.config.companyId,
                                        'locationIDs': locIds
                                    },
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                }).then(function (locResp) {
                                    locResp.data.results.forEach(function (loc) {
                                        var idx = locList.map(function (e) { return e.locationID; }).indexOf(loc.id);
                                        locList[idx].addressArea = loc.addressArea;
                                        locList[idx].locationName = loc.name;
                                    });
                                    locList = _.orderBy(locList, ['locationName'], ['asc']);
                                    _this._locationListCache[cacheKey] = locList;
                                    return locList;
                                });
                            });
                        }
                    };
                    ProdAvailabilityMgr.prototype.getProductByID = function (productID, locationID) {
                        var query = breeze.EntityQuery.from('Product_GetProductByProductID')
                            .withParameters({
                            productID: productID,
                            locationID: locationID,
                            asOfDate: new Date()
                        });
                        return this.entityMgr.executeQuery(query)
                            .then(function (data) {
                            return (data.results[0]);
                        });
                    };
                    ProdAvailabilityMgr.prototype.getProductsForVtcTermChange = function (productID, sessionStartDate) {
                        var info = {};
                        info.productID = productID;
                        info.sessionStartDate = sessionStartDate;
                        var url = this.common.config.webApi_NonBreeze + "/Product_GetForVtcTermChange";
                        var jsonString = JSON.stringify(info);
                        return this.common.$http.post(url, jsonString, { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var data = response.data;
                            for (var i = 0, il = data.sessionProductDetails.length; i < il; ++i) {
                                var dto = data.sessionProductDetails[i];
                                dto.startDate = moment(Pulse.Utils.JS.dateTimeStrToDateObj(dto.startDate.toString())).startOf('day').toDate();
                            }
                            return data;
                        });
                    };
                    ProdAvailabilityMgr.prototype.getRelatedBundleCampProducts = function (selectedSPD, sessionProductDetails, products, locationID) {
                        var childrenProducts = products.filter(function (p) { return p.level && p.relatedProductTypeID === Common.Enums.RelatedProductType.Bundle; });
                        var result = [];
                        var course = _.find(products, function (p) { return p.productID == selectedSPD.productID; });
                        var regFlowProd = this.constructCampProdDTO(course, selectedSPD, locationID);
                        result.push(regFlowProd);
                        if (childrenProducts.length > 1) {
                            var _loop_1 = function (i) {
                                var course_1 = _.find(childrenProducts, function (p) { return p.level == i; });
                                var spdID = selectedSPD["l" + i + "SessionProductDetailID"];
                                var levelSPD = _.find(sessionProductDetails, function (spd) { return spd.sessionProductDetailID == spdID; });
                                if (levelSPD) {
                                    result.push(this_1.constructCampProdDTO(course_1, levelSPD, locationID));
                                }
                            };
                            var this_1 = this;
                            for (var i = 2; i <= childrenProducts.length; i++) {
                                _loop_1(i);
                            }
                        }
                        return result;
                    };
                    ProdAvailabilityMgr.prototype.getLastSPDForBundledProducts = function (selectedSPDID, sessionProductDetails) {
                        if (!selectedSPDID || !sessionProductDetails)
                            return null;
                        var selectedSPD = _.find(sessionProductDetails, function (spd) { return spd.sessionProductDetailID == selectedSPDID; });
                        if (selectedSPD.l4SessionProductDetailID) {
                            var spd = _.find(sessionProductDetails, function (s) { return s.sessionProductDetailID == selectedSPD.l4SessionProductDetailID; });
                            if (spd)
                                return spd;
                        }
                        else if (selectedSPD.l3SessionProductDetailID) {
                            var spd = _.find(sessionProductDetails, function (s) { return s.sessionProductDetailID == selectedSPD.l3SessionProductDetailID; });
                            if (spd)
                                return spd;
                        }
                        else if (selectedSPD.l2SessionProductDetailID) {
                            var spd = _.find(sessionProductDetails, function (s) { return s.sessionProductDetailID == selectedSPD.l2SessionProductDetailID; });
                            if (spd)
                                return spd;
                        }
                        else {
                            return selectedSPD;
                        }
                    };
                    ProdAvailabilityMgr.prototype.getRelatedSessionProductDetails = function (selectedSPDID, sessionProductDetails) {
                        var result = [];
                        if (!selectedSPDID || !sessionProductDetails)
                            return [];
                        var selectedSPD = _.find(sessionProductDetails, function (spd) { return spd.sessionProductDetailID == selectedSPDID; });
                        result.push(selectedSPD);
                        if (selectedSPD.l4SessionProductDetailID) {
                            var spd = _.find(sessionProductDetails, function (s) { return s.sessionProductDetailID == selectedSPD.l4SessionProductDetailID; });
                            if (spd)
                                result.push(spd);
                        }
                        else if (selectedSPD.l3SessionProductDetailID) {
                            var spd = _.find(sessionProductDetails, function (s) { return s.sessionProductDetailID == selectedSPD.l3SessionProductDetailID; });
                            if (spd)
                                result.push(spd);
                        }
                        else if (selectedSPD.l2SessionProductDetailID) {
                            var spd = _.find(sessionProductDetails, function (s) { return s.sessionProductDetailID == selectedSPD.l2SessionProductDetailID; });
                            if (spd)
                                result.push(spd);
                        }
                        return result;
                    };
                    ProdAvailabilityMgr.prototype.getRelatedBundleProductForStatus = function (selectedSPDID, sessionProductDetails) {
                        var relatedSPDs = this.getRelatedSessionProductDetails(selectedSPDID, sessionProductDetails);
                        var soldOut = _.find(relatedSPDs, function (spd) { return spd.programStatusTypeID == Common.Enums.SessionAvailabilityStatus.SoldOut || spd.programStatusTypeID == Common.Enums.SessionAvailabilityStatus.SoldOutDesktop; });
                        var noSpace = _.find(relatedSPDs, function (spd) { return spd.programStatusTypeID == Common.Enums.SessionAvailabilityStatus.NoSpace; });
                        var space1 = _.find(relatedSPDs, function (spd) { return spd.programStatusTypeID == Common.Enums.SessionAvailabilityStatus.Space1; });
                        var space2 = _.find(relatedSPDs, function (spd) { return spd.programStatusTypeID == Common.Enums.SessionAvailabilityStatus.Space2; });
                        var space3 = _.find(relatedSPDs, function (spd) { return spd.programStatusTypeID == Common.Enums.SessionAvailabilityStatus.Space3; });
                        var space4 = _.find(relatedSPDs, function (spd) { return spd.programStatusTypeID == Common.Enums.SessionAvailabilityStatus.Space4; });
                        var open = _.find(relatedSPDs, function (spd) { return spd.programStatusTypeID == Common.Enums.SessionAvailabilityStatus.Open; });
                        if (soldOut) {
                            return soldOut;
                        }
                        else if (noSpace) {
                            return noSpace;
                        }
                        else if (space1) {
                            return space1;
                        }
                        else if (space2) {
                            return space2;
                        }
                        else if (space3) {
                            return space3;
                        }
                        else if (space4) {
                            return space4;
                        }
                        else {
                            return open;
                        }
                    };
                    ProdAvailabilityMgr.prototype.constructCampProdDTO = function (course, spd, locationID) {
                        var regFlowProd = {};
                        regFlowProd.divisionID = spd.divisionID;
                        regFlowProd.productID = spd.productID;
                        regFlowProd.name = course.name;
                        regFlowProd.price = course.locationPrice;
                        regFlowProd.catalogTypeID = course.catalogTypeID;
                        regFlowProd.scheduleDefID = spd.scheduleDefID;
                        regFlowProd.sessionID = spd.sessionID;
                        regFlowProd.sessionProductDetailID = spd.sessionProductDetailID;
                        regFlowProd.locationPrice = spd.price;
                        regFlowProd.locationID = locationID;
                        regFlowProd.termID = spd.termID;
                        regFlowProd.programStatus = spd.programStatus;
                        regFlowProd.programStatusTypeID = spd.programStatusTypeID;
                        return regFlowProd;
                    };
                    ProdAvailabilityMgr.registeredAs = 'ProdAvailabilityMgr';
                    ProdAvailabilityMgr.CLASS_NAME = ProdAvailabilityMgr.registeredAs;
                    return ProdAvailabilityMgr;
                }(BaseMgr));
                Managers.ProdAvailabilityMgr = ProdAvailabilityMgr;
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var Managers;
            (function (Managers) {
                var PaymentPlanMgr = (function () {
                    function PaymentPlanMgr(common, breezeService, pulseContext) {
                    }
                    PaymentPlanMgr.prototype.divisionHasPaymentPlan = function (divisionSessionList) {
                        var today = new Date();
                        return moment(divisionSessionList[divisionSessionList.length - 1].displayEnd).diff(today, 'days') > 1;
                    };
                    PaymentPlanMgr.prototype.sessionHasPaymentPlan = function (sessionPaymentOption, price) {
                        var today = new Date();
                        var hasPayment = false;
                        if (angular.isObject(sessionPaymentOption) && angular.isDefined(sessionPaymentOption.balanceDueDate)) {
                            var year = today.getMonth() == 11 ? today.getFullYear() + 1 : today.getFullYear();
                            var month = (today.getMonth() + 2);
                            var nextPaymentDate = new Date(year + "-" + month + "-" + (today.getDate() > 28 ? 28 : today.getDate()));
                            var paymentData = {
                                days: moment(sessionPaymentOption.balanceDueDate).diff(nextPaymentDate, 'days'),
                                paymentOption: this.sessionPaymentValue(sessionPaymentOption, price)
                            };
                            hasPayment = paymentData.days > 0
                                && paymentData.paymentOption > 0
                                && paymentData.paymentOption < price;
                        }
                        if (angular.isObject(sessionPaymentOption)
                            && angular.isDefined(sessionPaymentOption.divDeliveryModelTypeID)
                            && sessionPaymentOption.divDeliveryModelTypeID == Common.Enums.DivisionDeliveryModelType.YouthEducationalServices) {
                            var paymentData = {
                                days: moment(sessionPaymentOption.paymentOptionEndDate).diff(today, 'days'),
                                paymentOption: this.sessionPaymentValue(sessionPaymentOption, price)
                            };
                            hasPayment = paymentData.days > 0
                                && paymentData.paymentOption > 0
                                && paymentData.paymentOption < price;
                        }
                        return hasPayment;
                    };
                    PaymentPlanMgr.prototype.sessionPaymentValue = function (spo, price) {
                        return spo !== undefined ?
                            (spo.depositTypeID == Common.Enums.CourseDeposit.FixedAmount ?
                                spo.depositValue : (spo.depositValue / 100) * price)
                            : 0;
                    };
                    PaymentPlanMgr.registeredAs = 'PaymentPlanMgr';
                    return PaymentPlanMgr;
                }());
                Managers.PaymentPlanMgr = PaymentPlanMgr;
                Pulse.app.service(PaymentPlanMgr.registeredAs, [
                    'common',
                    'breezeService',
                    'pulseContextService',
                    PaymentPlanMgr
                ]);
            })(Managers = DataAccess.Managers || (DataAccess.Managers = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";

"use strict";

"use strict";
var Pulse;
(function (Pulse) {
    var Common;
    (function (Common) {
        var DataAccess;
        (function (DataAccess) {
            var TypeDef;
            (function (TypeDef) {
                var StatusNonQuery = (function () {
                    function StatusNonQuery() {
                        this.data = null;
                    }
                    return StatusNonQuery;
                }());
                TypeDef.StatusNonQuery = StatusNonQuery;
            })(TypeDef = DataAccess.TypeDef || (DataAccess.TypeDef = {}));
        })(DataAccess = Common.DataAccess || (Common.DataAccess = {}));
    })(Common = Pulse.Common || (Pulse.Common = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var ShellCtrl = (function (_super) {
            __extends(ShellCtrl, _super);
            function ShellCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ShellCtrl.controllerId) || this;
                _this.scrollToTopOnLoaded = false;
                _this.activateController();
                return _this;
            }
            ShellCtrl.prototype.onViewLoaded = function () {
                _super.prototype.onViewLoaded.call(this);
                Pulse.Utils.ClickTracking.hookupElementsInContainer();
            };
            ShellCtrl.controllerId = 'shellCtrl';
            return ShellCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ShellCtrl = ShellCtrl;
        Pulse.app.controller(ShellCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            ShellCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var PublicTermsAndConditionsCtrl = (function (_super) {
            __extends(PublicTermsAndConditionsCtrl, _super);
            function PublicTermsAndConditionsCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, PublicTermsAndConditionsCtrl.controllerId) || this;
                _this.iFrameSrc = _this.pulseContext.pulse1x_PublicUrlRoot + "/TermsAndConditions.aspx?" +
                    QueryStringUtils.COMPANY_ID + "=" + _this.pulseContext.companyId;
                _this.common.activateController(null, PublicTermsAndConditionsCtrl.controllerId);
                return _this;
            }
            PublicTermsAndConditionsCtrl.controllerId = "publicTermsAndConditionsCtrl";
            return PublicTermsAndConditionsCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.PublicTermsAndConditionsCtrl = PublicTermsAndConditionsCtrl;
        Pulse.app.controller(PublicTermsAndConditionsCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", PublicTermsAndConditionsCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var RedirectHandlerCtrl = (function (_super) {
            __extends(RedirectHandlerCtrl, _super);
            function RedirectHandlerCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RedirectHandlerCtrl.controllerId) || this;
                var redirectUrl = QueryStringUtils.GetParamByName(_this.$location.url(), "redirect").toString();
                _this.iFrameSrc = redirectUrl;
                _this.activateController();
                return _this;
            }
            RedirectHandlerCtrl.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls.push("PulsePublic");
            };
            RedirectHandlerCtrl.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var _this = this;
                var urlLC = url.toLowerCase();
                return _super.prototype.actionBasedOnFrameUrl.call(this, frameId, urlLC).then(function (stopProcess) {
                    if (stopProcess)
                        return true;
                    for (var i = 0; i < _this.allowedPartialUrls.length; i++) {
                        if (urlLC.indexOf(_this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                            return false;
                        }
                    }
                    _this.iFrameSrc = "about:blank";
                    _this.$location.url(Routes.MyAccount);
                    return true;
                })
                    .catch(function (err) {
                    _this.logError(err);
                    return false;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            RedirectHandlerCtrl.controllerId = "redirectHandlerCtrl";
            return RedirectHandlerCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.RedirectHandlerCtrl = RedirectHandlerCtrl;
        Pulse.app.controller(RedirectHandlerCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", RedirectHandlerCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var ResumeCartAnonymousCtrl = (function (_super) {
            __extends(ResumeCartAnonymousCtrl, _super);
            function ResumeCartAnonymousCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ResumeCartAnonymousCtrl.controllerId) || this;
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.activationPromises.push(_this.userBrowsingMgr.tryResumeAbandonedShoppingCart());
                _this.activateController();
                return _this;
            }
            ResumeCartAnonymousCtrl.controllerId = "resumeCartAnonymousCtrl";
            return ResumeCartAnonymousCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ResumeCartAnonymousCtrl = ResumeCartAnonymousCtrl;
        Pulse.app.controller(ResumeCartAnonymousCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            ResumeCartAnonymousCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var TuitionAssistanceProgramCtrl = (function (_super) {
            __extends(TuitionAssistanceProgramCtrl, _super);
            function TuitionAssistanceProgramCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, TuitionAssistanceProgramCtrl.controllerId) || this;
                _this.iFrameSrc = _this.pulseContext.pulse1x_PublicUrlRoot + "/TuitionAssistanceProgram.aspx?" +
                    QueryStringUtils.COMPANY_ID + "=" + _this.pulseContext.companyId;
                _this.activateController();
                return _this;
            }
            TuitionAssistanceProgramCtrl.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls.push("PulsePublic");
            };
            TuitionAssistanceProgramCtrl.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var _this = this;
                this.common.toggleSpinner(true);
                url = url.toLowerCase();
                return _super.prototype.actionBasedOnFrameUrl.call(this, frameId, url).then(function (stopProcess) {
                    if (stopProcess)
                        return true;
                    for (var i = 0; i < _this.allowedPartialUrls.length; i++) {
                        if (url.indexOf(_this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                            return false;
                        }
                    }
                    _this.iFrameSrc = "about:blank";
                    _this.$location.url(Routes.Billing);
                    return true;
                })
                    .catch(function (err) {
                    _this.common.logAllErrorTypes(err, TuitionAssistanceProgramCtrl.controllerId);
                    return false;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            TuitionAssistanceProgramCtrl.controllerId = "tuitionAssistanceProgramCtrl";
            return TuitionAssistanceProgramCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.TuitionAssistanceProgramCtrl = TuitionAssistanceProgramCtrl;
        Pulse.app.controller(TuitionAssistanceProgramCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", TuitionAssistanceProgramCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var LogoutCtrl = (function (_super) {
            __extends(LogoutCtrl, _super);
            function LogoutCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LogoutCtrl.controllerId) || this;
                _this.iFrameSrc = window.parent === window
                    ? _this.pulseContext.pulse1x_PublicUrlRoot + "/logout.aspx?" + QueryStringUtils.COMPANY_ID + "=" + _this.pulseContext.companyId
                    : "";
                _this.activationPromises.push(_this.pulseContext.logoutGoogle()
                    .then(function () {
                    return _this.pulseContext.logout(true, true);
                }));
                _this.activateController();
                return _this;
            }
            LogoutCtrl.prototype.onActivated = function (activationResults) {
                var _this = this;
                _super.prototype.onActivated.call(this, activationResults);
                this.common.$timeout(function () {
                    _this.$location.url(Routes.Login);
                }, 2000);
            };
            LogoutCtrl.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls.push("logout.aspx");
            };
            LogoutCtrl.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var deferred = this.common.$q.defer();
                url = url.toLowerCase();
                for (var i = 0; i < this.allowedPartialUrls.length; i++) {
                    if (url.indexOf(this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                        deferred.resolve(true);
                        return deferred.promise;
                    }
                }
                this.iFrameSrc = "about:blank";
                this.$scope.$apply();
                this.common.toggleSpinner(false);
                this.$location.url(Routes.Login);
                deferred.resolve(true);
                return deferred.promise;
            };
            LogoutCtrl.controllerId = "logoutCtrl";
            return LogoutCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.LogoutCtrl = LogoutCtrl;
        Pulse.app.controller(LogoutCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", LogoutCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var LoginOrCreateAccountBaseCtrl = (function (_super) {
            __extends(LoginOrCreateAccountBaseCtrl, _super);
            function LoginOrCreateAccountBaseCtrl($scope, $location, common, breezeService, pulseContext, loggingId) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, loggingId) || this;
                _this.$scope.$on(Events.LoginSuccess, function () {
                    _this.onLoginSuccess();
                });
                return _this;
            }
            LoginOrCreateAccountBaseCtrl.prototype.onLoginSuccess = function () {
                var _this = this;
                var returnUrl = this.$location.search()[QueryStringUtils.RETURN_URL];
                if (angular.isString(returnUrl)
                    && returnUrl.indexOf(Routes.ResumeCart) < 0
                    && returnUrl.indexOf(Routes.SplashPage) < 0
                    && !String.isNullOrWhitespace(String.trimLeft(returnUrl, '/'))) {
                    this.$location.url(Routes.SplashPage + "?" + QueryStringUtils.RETURN_URL + "=" + returnUrl);
                }
                else {
                    this.common.toggleSpinner(true);
                    var userBrowsingMgr_1 = this.pulseContext.regFlowMgr.userBrowsingMgr;
                    this.pulseContext.shoppingCartType = Enums.ShoppingCartType.RegFlow;
                    userBrowsingMgr_1.loadInfo(userBrowsingMgr_1.currentUBSession, true)
                        .then(function () {
                        if (userBrowsingMgr_1.currentUBSession.userBrowsingDTO.userBrowsingResumeID > 0) {
                            _this.$location.url(Routes.ResumeCart);
                        }
                        else {
                            _this.$location.url(Routes.SplashPage);
                        }
                    })
                        .catch(function (e) {
                        _this.logError(e);
                        return null;
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                    ;
                }
            };
            return LoginOrCreateAccountBaseCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.LoginOrCreateAccountBaseCtrl = LoginOrCreateAccountBaseCtrl;
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var LoginOrCreateAccountCtrl = (function (_super) {
            __extends(LoginOrCreateAccountCtrl, _super);
            function LoginOrCreateAccountCtrl($scope, $location, common, breezeService, pulseContext, $route) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LoginOrCreateAccountCtrl.controllerId) || this;
                _this.$route = $route;
                _this.showNewPassword = false;
                _this.showLogin = true;
                _this.showCreate = true;
                _this.show3rdPartySignin = true;
                _this.show3rdPartyAccountNotFoundView = false;
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.$scope.$on(Events.ForcePasswordChange, function (evt, user, oldPassword) {
                    _this.onForcePasswordChange(user, oldPassword);
                });
                _this.$scope.$on(Events.Login3rPartyAccountNotFound, function (evt, faileSignInEmail) {
                    if (!_this.signIn3rdPartyAccountNotFoundErr) {
                        _this.signIn3rdPartyAccountNotFoundErr = String.format(StringConst.Info_3rPartyAuth_GoogleAccountNotFound_Msg, faileSignInEmail);
                        _this.show3rdPartyAccountNotFoundView = true;
                    }
                });
                _this.prepopulateLoginName();
                if (_this.pulseContext.isLoggedIn) {
                    _this.pulseContext.logout(true, true);
                }
                _this.activateController();
                return _this;
            }
            LoginOrCreateAccountCtrl.prototype.onViewLoaded = function () {
                var _this = this;
                _super.prototype.onViewLoaded.call(this);
                this.common.$timeout(function () {
                    _this.common.toggleSpinner(false, true);
                }, 1000);
            };
            LoginOrCreateAccountCtrl.prototype.prepopulateLoginName = function () {
                var emailAddress = this.$location.search()[QueryStringUtils.EMAIL_ADDRESS];
                if (!emailAddress) {
                    var returnUrl = this.$location.search()[QueryStringUtils.RETURN_URL];
                    if (!String.isNullOrWhitespace(returnUrl)) {
                        var params = QueryStringUtils.GetParams(returnUrl);
                        var ubclid = params[QueryStringUtils.USERBROWSINGCOMMLOG_ID];
                        if (!ubclid)
                            return;
                        if (typeof (localStorage) !== "undefined") {
                            var userName = localStorage.getItem("login_username");
                            if (userName) {
                                this.emailOrUserName = userName;
                            }
                        }
                    }
                }
                else {
                    if (!String.isNullOrWhitespace(emailAddress)) {
                        this.emailOrUserName = emailAddress;
                    }
                }
            };
            LoginOrCreateAccountCtrl.prototype.setLocalizedTexts = function () {
                return _super.prototype.setLocalizedTexts.call(this);
            };
            LoginOrCreateAccountCtrl.prototype.createAccount = function () {
                var _this = this;
                this.pulseContext.logoutGoogle()
                    .then(function () {
                    _this.$location.url(Routes.CreateAccount);
                });
            };
            LoginOrCreateAccountCtrl.prototype.onForcePasswordChange = function (user, oldPassword) {
                this.oldPassword = oldPassword;
                this.userForPasswordChange = user;
                this.showNewPassword = true;
                this.showLogin = false;
                this.showCreate = false;
            };
            LoginOrCreateAccountCtrl.prototype.showLoginView = function () {
                this.show3rdPartyAccountNotFoundView = false;
            };
            LoginOrCreateAccountCtrl.prototype.closeAccountNotFoundView = function () {
                var _this = this;
                if (this.show3rdPartyAccountNotFoundView) {
                    this.pulseContext.logoutGoogle()
                        .then(function () {
                        _this.signIn3rdPartyAccountNotFoundErr = null;
                        _this.show3rdPartyAccountNotFoundView = false;
                        _this.showLogin = _this.show3rdPartySignin = true;
                    });
                }
            };
            LoginOrCreateAccountCtrl.controllerId = "loginOrCreateAccountCtrl";
            return LoginOrCreateAccountCtrl;
        }(Controllers.LoginOrCreateAccountBaseCtrl));
        Controllers.LoginOrCreateAccountCtrl = LoginOrCreateAccountCtrl;
        Pulse.app.controller(LoginOrCreateAccountCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            LoginOrCreateAccountCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var CreateAccountCtrl = (function (_super) {
            __extends(CreateAccountCtrl, _super);
            function CreateAccountCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CreateAccountCtrl.controllerId) || this;
                _this.formName = "myForm";
                _this.pulseContext.logout(true);
                _this.$scope.$on(Events.PublicUserAccountCreated, function (e, args) {
                    _this.$location.path(Routes.DispatcherPage);
                });
                _this.activateController();
                return _this;
            }
            CreateAccountCtrl.prototype.onLoginClick = function () {
                this.$location.path(Routes.Login);
            };
            CreateAccountCtrl.prototype.setLocalizedTexts = function () {
                this.sPageTitle = "Create Account";
                return _super.prototype.setLocalizedTexts.call(this);
            };
            CreateAccountCtrl.controllerId = "createAccountCtrl";
            return CreateAccountCtrl;
        }(Controllers.LoginOrCreateAccountBaseCtrl));
        Controllers.CreateAccountCtrl = CreateAccountCtrl;
        Pulse.app.controller(CreateAccountCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", CreateAccountCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var ChannelPreferenceCtrl = (function (_super) {
            __extends(ChannelPreferenceCtrl, _super);
            function ChannelPreferenceCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ChannelPreferenceCtrl.controllerId) || this;
                _this.formName = "channelPrefForm";
                _this.channelPreferenceMgr = new DataAccess.Managers.ChannelPreferenceMgr(common, breezeService, pulseContext);
                _this.infoRequestDAO = new DataAccess.InfoRequestDAO(_this.common, _this.breezeService, _this.pulseContext);
                _this.userAddressDAO = new DataAccess.UserAddressDAO(_this.common, _this.breezeService, _this.pulseContext);
                _this.$scope.$on(Events.ContactChannelsUpdated, function () {
                    _this.loadChannelPreferences();
                });
                _this.activationPromises.push(_this.loadChannelPreferences());
                _this.activateController();
                return _this;
            }
            ChannelPreferenceCtrl.prototype.loadChannelPreferences = function () {
                var _this = this;
                try {
                    this.common.toggleSpinner(true);
                    var queryParamDictionary = this.$location.search();
                    var userID = queryParamDictionary[QueryStringUtils.USER_ID];
                    var idHash_1 = queryParamDictionary[QueryStringUtils.USER_ID_HASH];
                    var infoReqID = _.toNumber(queryParamDictionary[QueryStringUtils.INFOREQUEST_ID]);
                    if (userID.indexOf("IR") === 0) {
                        infoReqID = _.toNumber(userID.substring(2));
                    }
                    this.targetUser = null;
                    var promises = [];
                    if (!(String.isNullOrWhitespace(userID) || String.isNullOrWhitespace(idHash_1))) {
                        if (infoReqID > 0) {
                            promises.push(this.infoRequestDAO.getByIdAndHash(infoReqID, idHash_1)
                                .then(function (data) {
                                _this.targetUser = data;
                                _this.targetUser.infoRequestIDHash = idHash_1;
                            }));
                            promises.push(this.channelPreferenceMgr.getContactChannelsByInfoReqID(infoReqID, idHash_1)
                                .then(function (data) {
                                _this.contactChannels = data;
                            }));
                        }
                        else {
                            promises.push(this.channelPreferenceMgr.getContactChannelsByUserIDAndHash(userID, idHash_1)
                                .then(function (data) {
                                _this.targetUser = data.user;
                                _this.targetUser.userIDHash = idHash_1;
                                _this.contactChannels = data.contactChannels;
                            }));
                        }
                    }
                    else if (this.pulseContext.isLoggedIn) {
                        this.targetUser = this.pulseContext.actingAsUser;
                        promises.push(this.channelPreferenceMgr.getContactChannelsByUserID(this.pulseContext.actingAsUserId)
                            .then(function (data) {
                            _this.contactChannels = data;
                        }));
                        promises.push(this.pulseContext.userMgr.loadAddressesForActingUser(true)
                            .then(function (data) {
                            _this.userAddresses = data.filter(function (a) { return a.addressTypeID == Enums.AddressType.Home
                                || a.addressTypeID == Enums.AddressType.Permanent; }).sort(function (a, b) { return a.addressTypeID - b.addressTypeID; });
                        }));
                    }
                    else {
                        this.$location.url(Routes.Login).replace();
                        return this.common.$q.resolve(null);
                    }
                    return this.common.$q.all(promises)
                        .catch(function (e) {
                        _this.logError(e);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                }
                catch (e) {
                    this.logError(e);
                }
            };
            ChannelPreferenceCtrl.controllerId = "ChannelPreferenceCtrl";
            return ChannelPreferenceCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ChannelPreferenceCtrl = ChannelPreferenceCtrl;
        Pulse.app.controller(ChannelPreferenceCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", ChannelPreferenceCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var RegFlowDefaultCtrl = (function (_super) {
            __extends(RegFlowDefaultCtrl, _super);
            function RegFlowDefaultCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RegFlowDefaultCtrl.controllerId) || this;
                _this.formName = "myForm";
                _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                _this.regFlowMgr.restoreFilterState(true);
                _this.regFlowMgr.resetAllSteps();
                _this.regFlowMgr.handleFlow();
                _this.activateController();
                return _this;
            }
            RegFlowDefaultCtrl.prototype.onActivated = function (activationResults) {
            };
            RegFlowDefaultCtrl.controllerId = "regFlowDefaultCtrl";
            return RegFlowDefaultCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.RegFlowDefaultCtrl = RegFlowDefaultCtrl;
        Pulse.app.controller(RegFlowDefaultCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            RegFlowDefaultCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var ChooseLocationCtrl = (function (_super) {
            __extends(ChooseLocationCtrl, _super);
            function ChooseLocationCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ChooseLocationCtrl.controllerId) || this;
                _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                _this.locationFinderMgr = _this.regFlowMgr.locationFinderMgr;
                _this.genreFinderMgr = _this.regFlowMgr.genreFinderMgr;
                _this.experienceFinderMgr = _this.regFlowMgr.experienceFinderMgr;
                _this.formName = 'myForm';
                _this.checkUnsavedDataBeforeNav = false;
                _this.regFlowMgr.handleFlow();
                _this.locationFinderMgr.clearAllSelected();
                _this.regFlowMgr.paymentMgr.shoppingCartPurchaseResult = null;
                _this.activationPromises.push(_this.loadLocationGroups());
                _this.activateController();
                return _this;
            }
            ChooseLocationCtrl.prototype.selectLocation = function (location) {
                if (location && (location.locationAvailabilityStatusAttrID == Enums.LocationAvailabilityTypeAttr.Open
                    || location.locationAvailabilityStatusAttrID == undefined)) {
                    this.locationFinderMgr.addOrRemoveFromSelected(location.iD, true, true, location.catalogDateRangeID);
                    location.selected = true;
                    this.regFlowMgr.nextStep();
                }
            };
            ChooseLocationCtrl.prototype.setLocalizedTexts = function () {
                return _super.prototype.setLocalizedTexts.call(this);
            };
            ChooseLocationCtrl.prototype.loadLocationGroups = function () {
                var _this = this;
                return this.populateLocationCache()
                    .then(function (res) {
                    var virtualLocations = _this.locationFinderMgr.virtualLocations.map(function (l) { l.name = l.desc; return l; });
                    virtualLocations = _this.createVirtualGroupSections(virtualLocations);
                    _this.regionGroups = [];
                    if (_this.locationFinderMgr.lookupCountries.length > 0) {
                        _this.regionGroups.push(_this.getRegionUIExpandable(RegionGroups.Global, RegionDivisionType.Country, _this.locationFinderMgr.lookupCountries));
                    }
                    if (_this.locationFinderMgr.lookupUSStates.length > 0) {
                        _this.regionGroups.push(_this.getRegionUIExpandable(RegionGroups.US, RegionDivisionType.State, _this.locationFinderMgr.lookupUSStates));
                    }
                    if (virtualLocations.length > 0) {
                        _this.regionGroups.push(_this.getRegionUIExpandable(RegionGroups.Virtual, RegionDivisionType.Virtual, virtualLocations));
                    }
                    return res;
                });
            };
            ChooseLocationCtrl.prototype.createVirtualGroupSections = function (locations) {
                if (this.locationFinderMgr.getLocationByType(Enums.LocationType.BootcampPartnership).length > 0) {
                    var bootcamp = {
                        iD: null,
                        name: 'Online Teen Academies',
                        abbr: '',
                        desc: 'Online Teen Academies',
                        addrArea: '',
                        airportInfo: '',
                        countryID: null,
                        stateID: null,
                        subRegionID: null,
                        locTypeID: Enums.LocationType.BootcampPartnership,
                        webUrl: '',
                        selected: false,
                        isOPL: false,
                    };
                    locations.unshift(bootcamp);
                }
                var opl = {
                    iD: null,
                    name: '1-on-1 Private Lessons',
                    abbr: '',
                    desc: '1-on-1 Private Lessons',
                    addrArea: '',
                    airportInfo: '',
                    stateID: null,
                    countryID: null,
                    subRegionID: null,
                    locTypeID: null,
                    selected: false,
                    webUrl: this.common.config.WWW_UrlRoot + '/tutoring',
                    isOPL: true,
                };
                locations.push(opl);
                locations.forEach(function (loc) {
                    if (loc.name.trim().length == 0) {
                        locations.splice(locations.indexOf(loc), 1);
                    }
                });
                return locations;
            };
            ChooseLocationCtrl.prototype.populateLocationCache = function () {
                var loadLocInfoPromise;
                if (this.isAppEntrypoint) {
                    loadLocInfoPromise = this.locationFinderMgr.loadInfo(this.genreFinderMgr.selectedIds, this.experienceFinderMgr.selectedIds, this.locationFinderMgr.selectedProdIDs, true);
                }
                else {
                    loadLocInfoPromise = this.locationFinderMgr.loadInfo(null, null, null, true);
                }
                return loadLocInfoPromise;
            };
            Object.defineProperty(ChooseLocationCtrl.prototype, "isAppEntrypoint", {
                get: function () {
                    return this.pulseContext.regFlowMgr.userIsComingFromOutside;
                },
                enumerable: false,
                configurable: true
            });
            ChooseLocationCtrl.prototype.getRegionUIExpandable = function (name, type, region) {
                var _this = this;
                return new RegionGroupUI(name, region.map(function (e) { return new RegionUIExpandable(_this.locationFinderMgr, type, e); }));
            };
            ChooseLocationCtrl.controllerId = 'chooseLocationCtrl';
            return ChooseLocationCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ChooseLocationCtrl = ChooseLocationCtrl;
        var RegionGroups;
        (function (RegionGroups) {
            RegionGroups["Virtual"] = "Online Programs";
            RegionGroups["Global"] = "Global Locations";
            RegionGroups["US"] = "U.S. Locations";
        })(RegionGroups = Controllers.RegionGroups || (Controllers.RegionGroups = {}));
        var RegionGroupUI = (function () {
            function RegionGroupUI(name, regions) {
                var _this = this;
                this.name = name;
                this.regions = regions;
                this.regions.forEach(function (region) {
                    region.registerExpanderCallback(function (currentExpanded) { return _this.updateExpandableRegionStates(currentExpanded); });
                });
            }
            RegionGroupUI.prototype.updateExpandableRegionStates = function (currentExpanded) {
                if (RegionGroupUI._currentExpanded) {
                    if (RegionGroupUI._currentExpanded.uniqueIndex !== currentExpanded.uniqueIndex) {
                        RegionGroupUI._currentExpanded.inverseExpandedState();
                    }
                    else if (RegionGroupUI._currentExpanded.uniqueIndex === currentExpanded.uniqueIndex) {
                        currentExpanded = null;
                    }
                }
                RegionGroupUI._currentExpanded = currentExpanded;
            };
            return RegionGroupUI;
        }());
        var RegionUIExpandable = (function () {
            function RegionUIExpandable(locMgr, type, ref) {
                this._regionRef = ref;
                this._isExpanded = false;
                this._type = type;
                this._toggleExpanderCallback = function (newExpandedRegion) { return undefined; };
                this.populateLocations(locMgr.optionItems, locMgr.catalogDateRanges, locMgr.lookupDivisions, locMgr.terms);
            }
            RegionUIExpandable.prototype.registerExpanderCallback = function (callback) {
                this._toggleExpanderCallback = callback;
            };
            Object.defineProperty(RegionUIExpandable.prototype, "id", {
                get: function () {
                    return this._regionRef.iD;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "isExpanded", {
                get: function () {
                    return this._isExpanded;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "locations", {
                get: function () {
                    return this._locations;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "name", {
                get: function () {
                    return this._regionRef.name;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "locTypeID", {
                get: function () {
                    return this._regionRef.locTypeID;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "refObject", {
                get: function () {
                    return this._regionRef;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "isState", {
                get: function () {
                    return this._type === RegionDivisionType.State;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "isCountry", {
                get: function () {
                    return this._type === RegionDivisionType.Country;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "isVirtual", {
                get: function () {
                    return this._type === RegionDivisionType.Virtual;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "webUrl", {
                get: function () {
                    return this._regionRef.webUrl;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RegionUIExpandable.prototype, "isOPL", {
                get: function () {
                    return this._regionRef.isOPL;
                },
                enumerable: false,
                configurable: true
            });
            RegionUIExpandable.prototype.toggleExpansion = function () {
                this._toggleExpanderCallback(this);
                this.inverseExpandedState();
            };
            RegionUIExpandable.prototype.inverseExpandedState = function () {
                this._isExpanded = !this._isExpanded;
            };
            Object.defineProperty(RegionUIExpandable.prototype, "uniqueIndex", {
                get: function () {
                    return this.id + this.name;
                },
                enumerable: false,
                configurable: true
            });
            RegionUIExpandable.prototype.populateLocations = function (locationPool, catalogDateRangePool, divisions, terms) {
                if (this.isState) {
                    this._locations = this.filterAsState(locationPool);
                }
                else if (this.isCountry) {
                    this._locations = this.filterAsCountry(locationPool);
                }
                else if (this.isVirtual) {
                    if (this.locTypeID == Enums.LocationType.VirtualSquads) {
                        this._locations = locationPool.filter(function (e) { return e.locTypeID == Enums.LocationType.VirtualSquads; });
                    }
                    else if (this.locTypeID == Enums.LocationType.VirtualSummerCamp) {
                        this._locations = this.filterAsVirtual(locationPool, catalogDateRangePool, divisions, terms);
                    }
                    else if (this.locTypeID == Enums.LocationType.BootcampPartnership) {
                        this._locations = this.filterAsBootcamp(locationPool);
                    }
                    else {
                        this._locations = [];
                    }
                }
                else {
                    this._locations = [];
                }
            };
            RegionUIExpandable.prototype.filterAsState = function (pool) {
                var _this = this;
                return pool.filter(function (e) {
                    var match = (e.stateID === _this.id
                        && e.locTypeID !== Enums.LocationType.VirtualSummerCamp
                        && e.locTypeID !== Enums.LocationType.VirtualSquads
                        && e.locTypeID !== Enums.LocationType.BootcampPartnership);
                    var sId = _this.refObject.subRegionID;
                    match = match && sId
                        ? e.subRegionID && e.subRegionID === sId
                        : match;
                    return match;
                });
            };
            RegionUIExpandable.prototype.filterAsCountry = function (pool) {
                var _this = this;
                return pool.filter(function (e) { return e.countryID === _this.id && e.locTypeID !== Enums.LocationType.VirtualSummerCamp && e.locTypeID !== Enums.LocationType.VirtualSquads; });
            };
            RegionUIExpandable.prototype.filterAsVirtual = function (locations, catalogDateRanges, divisions, terms) {
                var virtualLocations = locations.filter(function (e) { return e.locTypeID === Enums.LocationType.VirtualSummerCamp || e.locTypeID === Enums.LocationType.VirtualSquads; });
                var l = virtualLocations[0];
                var divList = ['iDVC', 'iDVA', 'BOOT'];
                var divIDS = divisions.filter(function (d) { return divList.indexOf(d.abbr) > -1; }).map(function (d) { return d.iD; });
                var filteredCDR = [];
                var _loop_1 = function (i) {
                    var termList = terms.filter(function (t) { return t.catalogDateRangeID == catalogDateRanges[i].catalogDateRangeID && divIDS.indexOf(t.divisionID) >= 0; });
                    if (termList.length > 0) {
                        filteredCDR.push(catalogDateRanges[i]);
                    }
                };
                for (var i = 0; i < catalogDateRanges.length; i++) {
                    _loop_1(i);
                }
                var locationInfos = filteredCDR.map(function (p) {
                    var result = {
                        iD: l.iD,
                        name: p.description,
                        abbr: l.abbr,
                        desc: l.desc,
                        addrArea: l.addrArea,
                        airportInfo: l.airportInfo,
                        stateID: l.stateID,
                        countryID: l.countryID,
                        subRegionID: l.resTypeID,
                        resTypeID: l.resTypeID,
                        locTypeID: l.locTypeID,
                        catalogDateRangeID: p.catalogDateRangeID,
                        selected: false,
                        isOPL: false,
                        webUrl: null
                    };
                    return result;
                });
                return locationInfos;
            };
            RegionUIExpandable.prototype.filterAsBootcamp = function (pool) {
                return pool.filter(function (e) { return e.locTypeID == Enums.LocationType.BootcampPartnership; });
            };
            return RegionUIExpandable;
        }());
        Controllers.RegionUIExpandable = RegionUIExpandable;
        var RegionDivisionType;
        (function (RegionDivisionType) {
            RegionDivisionType[RegionDivisionType["State"] = 0] = "State";
            RegionDivisionType[RegionDivisionType["Country"] = 1] = "Country";
            RegionDivisionType[RegionDivisionType["Virtual"] = 2] = "Virtual";
        })(RegionDivisionType = Controllers.RegionDivisionType || (Controllers.RegionDivisionType = {}));
        Pulse.app.controller(ChooseLocationCtrl.controllerId, [
            '$scope',
            '$location',
            'common',
            'breezeService',
            'pulseContextService',
            ChooseLocationCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var RegFlowMgr = DataAccess.Managers.RegFlowMgr;
        var ChoosePathCtrl = (function (_super) {
            __extends(ChoosePathCtrl, _super);
            function ChoosePathCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ChoosePathCtrl.controllerId) || this;
                _this.formName = 'choosePaths';
                _this.checkUnsavedDataBeforeNav = false;
                _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                _this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart, false, '', true);
                _this.locationFinderMgr = _this.pulseContext.regFlowMgr.locationFinderMgr;
                _this.genreFinderMgr = _this.pulseContext.regFlowMgr.genreFinderMgr;
                _this.mediaServerResourcePath = common.config.mediaServerUrl + '/path-genre/';
                _this.activationPromises.push(_this.locationFinderMgr.loadInfo()
                    .then(function () {
                    _this.selectedLocName = _this.locationFinderMgr.selectedItems.length ? _this.locationFinderMgr.selectedItems[0].name : null;
                }));
                _this.activationPromises.push(_this.genreFinderMgr.loadInfo(_this.regFlowMgr.locationFinderMgr.selectedIds, null)
                    .then(function (genres) {
                    if (!genres || genres[0].length === 0) {
                        _this.$location.path(Routes.RegFlow_ChooseLocations);
                        return;
                    }
                }));
                _this.activateController();
                return _this;
            }
            ChoosePathCtrl.prototype.onActivated = function (activationResults) {
                this.genreFinderMgr.removeSelectionNotInContext();
            };
            ChoosePathCtrl.prototype.toggleSelection = function (genreID) {
                if (this.genreFinderMgr.selectedIds.indexOf(genreID) < 0) {
                    this.genreFinderMgr.addOrRemoveFromSelected(genreID, true);
                }
                else {
                    this.genreFinderMgr.addOrRemoveFromSelected(genreID, false);
                }
            };
            ChoosePathCtrl.prototype.showAllCourses = function () {
                this.genreFinderMgr.clearAllSelected();
                this.regFlowMgr.experienceFinderMgr.clearAllSelected();
                this.goToAVChart();
            };
            ChoosePathCtrl.prototype.goToLocations = function () {
                this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
            };
            ChoosePathCtrl.prototype.goToAVChart = function () {
                this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart);
            };
            ChoosePathCtrl.prototype.setLocalizedTexts = function () {
                return _super.prototype.setLocalizedTexts.call(this);
            };
            ChoosePathCtrl.prototype.submit = function () {
                this.genreFinderMgr.saveState();
                if (this.genreFinderMgr.selectedIds.length == 0) {
                    this.common.showWarning(StringConst.Err_Path_Genre_Required);
                }
                else {
                    this.regFlowMgr.nextStep();
                }
            };
            ChoosePathCtrl.controllerId = 'choosePathCtrl';
            return ChoosePathCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ChoosePathCtrl = ChoosePathCtrl;
        Pulse.app.controller(ChoosePathCtrl.controllerId, [
            '$scope',
            '$location',
            'common',
            'breezeService',
            'pulseContextService',
            ChoosePathCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var RegFlowMgr = DataAccess.Managers.RegFlowMgr;
        var ChooseExperienceCtrl = (function (_super) {
            __extends(ChooseExperienceCtrl, _super);
            function ChooseExperienceCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ChooseExperienceCtrl.controllerId) || this;
                _this.formName = "chooseExperiences";
                _this.checkUnsavedDataBeforeNav = false;
                _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                _this.activationPromises.push(_this.regFlowMgr.handleFlow());
                _this.locationFinderMgr = _this.pulseContext.regFlowMgr.locationFinderMgr;
                _this.expFinderMgr = _this.pulseContext.regFlowMgr.experienceFinderMgr;
                _this.mediaServerResourcePath = common.config.mediaServerUrl + '/experience/';
                _this.activationPromises.push(_this.locationFinderMgr.loadInfo()
                    .then(function () {
                    _this.selectedLocName = _this.locationFinderMgr.selectedItems.length ? _this.locationFinderMgr.selectedItems[0].name : null;
                }));
                _this.activationPromises.push(_this.expFinderMgr.loadInfoByLocAndGenre(_this.regFlowMgr.locationFinderMgr.selectedIds, _this.regFlowMgr.genreFinderMgr.selectedIds));
                _this.activateController();
                return _this;
            }
            ChooseExperienceCtrl.prototype.onActivated = function (activationResults) {
                this.expFinderMgr.removeSelectionNotInContext();
            };
            ChooseExperienceCtrl.prototype.toggleSelection = function (id) {
                if (this.expFinderMgr.selectedIds.indexOf(id) < 0) {
                    this.expFinderMgr.addOrRemoveFromSelected(id, true);
                }
                else {
                    this.expFinderMgr.addOrRemoveFromSelected(id, false);
                }
            };
            ChooseExperienceCtrl.prototype.showAllCourses = function () {
                this.regFlowMgr.genreFinderMgr.clearAllSelected();
                this.expFinderMgr.clearAllSelected();
                this.goToAVChart();
            };
            ChooseExperienceCtrl.prototype.goToLocations = function () {
                this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
            };
            ChooseExperienceCtrl.prototype.goToAVChart = function () {
                this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart);
            };
            ChooseExperienceCtrl.prototype.submit = function () {
                this.expFinderMgr.saveState();
                if (this.expFinderMgr.selectedIds.length == 0) {
                    this.common.showWarning(StringConst.Err_Experience_Required);
                }
                else {
                    this.regFlowMgr.nextStep();
                }
            };
            ChooseExperienceCtrl.prototype.setLocalizedTexts = function () {
                return _super.prototype.setLocalizedTexts.call(this);
            };
            ChooseExperienceCtrl.controllerId = "chooseExperienceCtrl";
            return ChooseExperienceCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ChooseExperienceCtrl = ChooseExperienceCtrl;
        Pulse.app.controller(ChooseExperienceCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            ChooseExperienceCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var RegFlowMgr = DataAccess.Managers.RegFlowMgr;
        var AvailChartCtrl = (function (_super) {
            __extends(AvailChartCtrl, _super);
            function AvailChartCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AvailChartCtrl.controllerId) || this;
                $('.pulseapp')
                    .addClass('old-styling');
                _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                _this.regFlowMgr.handleFlow();
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.locationFinderMgr = _this.pulseContext.regFlowMgr.locationFinderMgr;
                _this.expFinderMgr = _this.pulseContext.regFlowMgr.experienceFinderMgr;
                _this.$scope.$on(Events.LoginSuccess, function () {
                    _this.onLoginSuccess();
                });
                _this.activationPromises.push(_this.locationFinderMgr.loadInfo()
                    .then(function () {
                    _this.regFlowMgr.shoppingCartMgr.clearCachedCart();
                    _this.currentLocation = _this.locationFinderMgr.selectedItems[0];
                    if (!_this.currentLocation)
                        _this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
                }));
                _this.activationPromises.push(_this.expFinderMgr.loadInfo());
                _this.activationPromises.push(_this.regFlowMgr.loadLookupInfo());
                _this.activationPromises.push(_this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                    .then(function () {
                    return _this.userBrowsingMgr.setUserBrowsingResumeStep(Enums.RegFlowProgressStep.AvailChart2017);
                }));
                _this.activateController();
                return _this;
            }
            AvailChartCtrl.prototype.onLoginSuccess = function () {
                var _this = this;
                this.common.toggleSpinner(true, null, null, 0);
                this.userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, true)
                    .then(function (data) {
                    _this.userBrowsingMgr.sendCartToMailChimp(_this.userBrowsingMgr.currentUBSession);
                    return;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            AvailChartCtrl.prototype.onActivated = function (activationResults) {
            };
            AvailChartCtrl.prototype.setLocalizedTexts = function () {
                return _super.prototype.setLocalizedTexts.call(this);
            };
            AvailChartCtrl.prototype.submit = function () {
                if (this.userBrowsingMgr.currentUBSession.UB_ItemDTOs && this.userBrowsingMgr.currentUBSession.UB_ItemDTOs.length > 0) {
                    this.regFlowMgr.nextStep();
                }
                else {
                    this.common.showWarning('Shopping cart is empty.  Please select a course or product.');
                }
            };
            AvailChartCtrl.prototype.goToLocations = function () {
                this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
            };
            AvailChartCtrl.prototype.resetChartFilters = function () {
                this.regFlowMgr.genreFinderMgr.clearAllSelected();
                this.regFlowMgr.experienceFinderMgr.clearAllSelected();
                this.regFlowMgr.noAutoDispatch = true;
                this.$scope.$broadcast(Events.AvailabilityChartResetFilters, true);
            };
            AvailChartCtrl.controllerId = 'AvailChartCtrl';
            return AvailChartCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.AvailChartCtrl = AvailChartCtrl;
        Pulse.app.controller(AvailChartCtrl.controllerId, [
            '$scope', '$location',
            'common',
            'breezeService',
            'pulseContextService',
            AvailChartCtrl,
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var BaseViewCtrl = Pulse.Common.BaseViewCtrl;
        var ProductAvailabilityCtrl = (function (_super) {
            __extends(ProductAvailabilityCtrl, _super);
            function ProductAvailabilityCtrl($scope, $route, config, $location, common, breezeService, pulseContext, pulsePass, drawerToggleService) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ProductAvailabilityCtrl.controllerId) || this;
                _this.showOrderConfirmation = false;
                _this.isSquads = false;
                _this.noTimeInTimeZone = false;
                _this.WEEK_DAYS = [
                    {
                        id: 0,
                        longName: 'Sunday',
                        shortName: 'Sun'
                    }, {
                        id: 1,
                        longName: 'Monday',
                        shortName: 'Mon'
                    }, {
                        id: 2,
                        longName: 'Tuesday',
                        shortName: 'Tue'
                    }, {
                        id: 3,
                        longName: 'Wednesday',
                        shortName: 'Wed'
                    }, {
                        id: 4,
                        longName: 'Thursday',
                        shortName: 'Thu'
                    }, {
                        id: 5,
                        longName: 'Friday',
                        shortName: 'Fri'
                    }, {
                        id: 6,
                        longName: 'Saturday',
                        shortName: 'Sat'
                    }
                ];
                _this.drawerNextStep = {
                    stepID: 0,
                    step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep,
                    stepBackText: 'Back to course page',
                    stepSelectText: 'Select your session date range for:'
                };
                _this.drawerStyle = new DrawerStyle('page2022');
                _this.$scope = $scope;
                _this.common = common;
                _this.config = config;
                _this.pulsePass = pulsePass;
                _this.prodAvailabilityMgr = _this.pulseContext.regFlowMgr.prodAvailabilityMgr;
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.clientTimeZoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone;
                _this.activationPromises.push(_this.pulseContext.timeZoneMgr.loadTimeZones()
                    .then(function () {
                    return _this.loadData();
                }));
                _this.scrollToTopOnLoaded = false;
                _this.$scope.$on(Events.ProductAddedToCart, function (event, mainProduct, participant) {
                    _this.afterProductAddedToCart(mainProduct, participant);
                });
                _this.$scope.$on(Events.ProductAvailabilityGroupWithFinished, function (event, mainProduct) {
                    _this.showConfirmation(mainProduct);
                });
                return _this;
            }
            Object.defineProperty(ProductAvailabilityCtrl.prototype, "showDrawerStep", {
                get: function () {
                    if (this.pulsePass && this.pulsePass.currentStep) {
                        return this.pulsePass.currentStep.step != Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.BuyingCourse;
                    }
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            ProductAvailabilityCtrl.prototype.loadData = function () {
                var promises = new Array();
                promises.push(this.getProductAvailability());
                promises.push(this.loadUserBrowsingInfo());
                return this.common.$q.all(promises);
            };
            ProductAvailabilityCtrl.prototype.getClientTimeZoneType = function (clientTimeZoneStr) {
                var _this = this;
                var result = this.pulseContext.timeZoneMgr.getClientTimeZoneType(clientTimeZoneStr)
                    .then(function (data) {
                    if (angular.isNumber(data) && data > 0) {
                        _this.selectedTimeZoneTypeID = data;
                    }
                    else {
                        _this.selectedTimeZoneTypeID = Enums.TimeZoneType.Pacific;
                    }
                });
                return result;
            };
            ProductAvailabilityCtrl.prototype.getProductAvailability = function (isFirstTime) {
                if (isFirstTime === void 0) { isFirstTime = true; }
                return __awaiter(this, void 0, void 0, function () {
                    var result;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!isFirstTime) return [3, 2];
                                return [4, this.getClientTimeZoneType(this.clientTimeZoneStr)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (isNaN(this.prodId))
                                    return [2, null];
                                return [4, this.prodAvailabilityMgr.getProductAvailability(this.prodId, this.selectedTimeZoneTypeID)
                                        .then(function (data) {
                                        _this.dataset = data;
                                        _this.timeZoneTypes = data.timeZoneTypes;
                                        var mainProd = _this.dataset.products.filter(function (p) { return p.relatedProductTypeID == null; })[0];
                                        if (mainProd) {
                                            _this.isSquads = (data.products &&
                                                (mainProd.catalogTypeID == Enums.SalesCatalogType.SquadsMultiWeek || mainProd.catalogTypeID == Enums.SalesCatalogType.SquadsConsecutiveDays));
                                            _this.isCourseBundle = data.products && mainProd.catalogTypeID == Enums.SalesCatalogType.CourseBundle;
                                            _this.noTimeInTimeZone = false;
                                        }
                                        else {
                                            _this.isSquads = false;
                                            _this.isCourseBundle = false;
                                            _this.noTimeInTimeZone = true;
                                        }
                                        var allStartDays = [];
                                        if (_this.isCourseBundle) {
                                            var level1Prod_1 = _.find(data.products, function (p) { return p.level === 1; });
                                            allStartDays = data.sessionProductDetails.filter(function (spd) { return spd.productID === (level1Prod_1 === null || level1Prod_1 === void 0 ? void 0 : level1Prod_1.productID); }).map(function (s) { return moment(s.startDateTimeLocal).day(); });
                                        }
                                        else {
                                            allStartDays = data.sessionProductDetails.map(function (s) { return moment(s.startDateTimeLocal).day(); });
                                        }
                                        allStartDays = _.uniqBy(allStartDays, function (e) {
                                            return e;
                                        });
                                        _this.availableDays = _this.WEEK_DAYS.filter(function (wd) { return allStartDays.indexOf(wd.id) >= 0; });
                                        var cdrList = [];
                                        for (var _i = 0, _a = _this.dataset.sessionProductDetails; _i < _a.length; _i++) {
                                            var s = _a[_i];
                                            var cdr = {
                                                catalogDateRangeID: s.catalogDateRangeID,
                                                displayName: s.displayName,
                                                description: s.description,
                                                sortOrder: s.sortOrder
                                            };
                                            var find = _.find(cdrList, { 'catalogDateRangeID': cdr.catalogDateRangeID });
                                            if (!find) {
                                                cdrList.push(cdr);
                                            }
                                        }
                                        _this.catalogDateRanges = _.sortBy(cdrList, 'sortOrder');
                                        var newStyle = _this.$location.search().style ? _this.$location.search().style : _this.$location.search().template ? _this.$location.search().template : 'page2022';
                                        if (_this.drawerStyle.drawerTemplate != newStyle)
                                            _this.drawerStyle = new DrawerStyle(newStyle, _this.isSquads, _this.isCourseBundle);
                                        if (_this.drawerStyle.is2022Design) {
                                            _this.drawerStyle.setProductImage(_this.getThumbNailFullUrl());
                                            _this.pulsePass.init({
                                                stepData: _this.drawerNextStep,
                                                stepManagerType: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavStepManagerType.StackSteps
                                            });
                                        }
                                        else {
                                            _this.pulsePass.init({
                                                stepData: _this.pulsePass.accordionStep,
                                                stepManagerType: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavStepManagerType.StaticStep
                                            });
                                        }
                                        return data;
                                    })];
                            case 3:
                                result = _a.sent();
                                return [2, result];
                        }
                    });
                });
            };
            ProductAvailabilityCtrl.prototype.loadUserBrowsingInfo = function () {
                var _this = this;
                return this.userBrowsingMgr
                    .loadInfo(this.userBrowsingMgr.currentUBSession, true)
                    .then(function () {
                    return _this.userBrowsingMgr.setUserBrowsingResumeStep(Enums.RegFlowProgressStep.AvailChart2017);
                })
                    .then(function () {
                    if (_this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress) {
                        return _this.userBrowsingMgr.loadWaitlist(_this.userBrowsingMgr.currentUBSession, _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress, true);
                    }
                });
            };
            Object.defineProperty(ProductAvailabilityCtrl.prototype, "prodId", {
                get: function () {
                    if (this._prodId === undefined) {
                        this._prodId = this.getParamAsNumber(QueryStringUtils.PRODUCT_ID);
                    }
                    return this._prodId;
                },
                enumerable: false,
                configurable: true
            });
            ProductAvailabilityCtrl.prototype.getParamAsNumber = function (qsParamName) {
                var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                if (Array.isArray(param)) {
                    param = param[0];
                }
                return typeof param === 'string' ? parseInt(param, 10) : param;
            };
            ProductAvailabilityCtrl.prototype.updateSelectedTimeZoneTypeID = function () {
                this.dataset = null;
                this.catalogDateRanges = null;
                this.selectedDay = null;
                this.getProductAvailability(false);
            };
            ProductAvailabilityCtrl.prototype.redirectToWWWCourses = function () {
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                }
                else {
                    this.common.$location.url(Routes.RegFlow_Default);
                }
            };
            ProductAvailabilityCtrl.prototype.afterProductAddedToCart = function (mainProduct, participant) {
                if (participant === void 0) { participant = null; }
                var self = this;
                this.pulseContext.regFlowMgr.shoppingCartMgr.clearCachedCart();
                if (this.pulseContext.isRunningInPartnerDomain) {
                    this.redirectToCheckout();
                    return;
                }
                this.showOrderConfirmation = true;
                this.mainProduct = mainProduct;
                Events.TriggerDocCustomEvent(Events.ProductAvailabilityAddedToCart_JSEvent, this.userBrowsingMgr.currentUBSession);
                if (this.pulseContext.isImpersonating) {
                    var count = this.userBrowsingMgr.standaloneItemCount(this.userBrowsingMgr.currentUBSession);
                    this.common.updateCSImpersonationShoppingCartCount(count);
                }
            };
            ProductAvailabilityCtrl.prototype.showConfirmation = function (mainProduct) {
                this.showGroupWith = false;
                this.showOrderConfirmation = true;
            };
            ProductAvailabilityCtrl.prototype.getThumbNailFullUrl = function (largeImage) {
                if (largeImage === void 0) { largeImage = false; }
                var prodThumbImgUrl = 'no-image';
                var url = this.dataset.productURLs
                    .filter(function (u) { return u.usageTypeID === Enums.ProductURLType.CourseVideoIntroImageURL; }).shift();
                if (url && !String.isNullOrWhitespace(url.uRL)) {
                    prodThumbImgUrl = Pulse.Utils.JS.composeProductThumbNailFullUrl(this.config.courseVideoThumbnailUrl, url.uRL, false);
                }
                return prodThumbImgUrl;
            };
            ProductAvailabilityCtrl.prototype.redirectToCheckout = function () {
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/shopping-cart');
                }
                else {
                    this.common.$location.url(Routes.RegFlow_ShoppingCart);
                }
            };
            ProductAvailabilityCtrl.prototype.selectDay = function (day) {
                var _a, _b;
                this.selectedDay = day;
                if (this.drawerStyle.is2022Design) {
                    while (((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) != Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep) {
                        this.pulsePass.stepPrev();
                    }
                }
            };
            ProductAvailabilityCtrl.prototype.isSelectedDay = function (day) {
                return this.selectedDay === day;
            };
            ProductAvailabilityCtrl.prototype.getWeeksCount = function () {
                if (!this.dataset)
                    return;
                if (this.isSquads)
                    return 10;
                if (this.isCourseBundle) {
                    return 10 * (this.dataset.products.length - 1);
                }
                return;
            };
            Object.defineProperty(ProductAvailabilityCtrl.prototype, "showDayOptions", {
                get: function () {
                    var _a, _b;
                    return ((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep;
                },
                enumerable: false,
                configurable: true
            });
            ProductAvailabilityCtrl.controllerId = 'ProductAvailabilityCtrl';
            return ProductAvailabilityCtrl;
        }(BaseViewCtrl));
        Controllers.ProductAvailabilityCtrl = ProductAvailabilityCtrl;
        var DrawerStyle = (function () {
            function DrawerStyle(style, isSquads, isCourseBundle) {
                if (isSquads === void 0) { isSquads = false; }
                if (isCourseBundle === void 0) { isCourseBundle = false; }
                this.drawerTemplate = '';
                this.styles = {
                    drawerHeaderBackground: '',
                    drawerHeaderText: '',
                    drawerBodyBackground: 'bg-lightgray',
                    drawerBodyText: '',
                    drawerSectionBackground: '',
                    drawerSectionText: 'text-black',
                    buttonClose: 'btn-primary',
                    buttonContinue: 'btn-primary',
                    buttonDayGroup: 'btn-group-day',
                    buttonPrimary: 'btn-outline-secondary',
                    buttonTime: 'btn-text',
                    iconCalendarText: 'text-secondary',
                    iconPrimary: 'icon-container',
                    headingAccordion: 'idp-green-text-highlight',
                    headingAddons: 'text-black',
                    headingExtras: 'idp-dark-green-text-highlight',
                    productImage: '',
                    sectionBorder: '',
                };
                this.is2022Design = false;
                this.isSquads = isSquads;
                this.isCourseBundle = isCourseBundle;
                this.SetupDrawerStyle(style);
            }
            Object.defineProperty(DrawerStyle.prototype, "drawerHeaderBackground", {
                get: function () {
                    return this.styles.drawerHeaderBackground;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "drawerHeaderText", {
                get: function () {
                    return this.styles.drawerHeaderText;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "drawerBodyBackground", {
                get: function () {
                    return this.styles.drawerBodyBackground;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "drawerBodyText", {
                get: function () {
                    return this.styles.drawerBodyText;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "drawerSectionBackground", {
                get: function () {
                    return this.styles.drawerSectionBackground;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "drawerSectionText", {
                get: function () {
                    return this.styles.drawerSectionText;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "buttonClose", {
                get: function () {
                    return this.styles.buttonClose;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "buttonContinue", {
                get: function () {
                    return this.styles.buttonContinue;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "buttonDayGroup", {
                get: function () {
                    return this.styles.buttonDayGroup;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "buttonPrimary", {
                get: function () {
                    return this.styles.buttonPrimary;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "buttonTime", {
                get: function () {
                    return this.styles.buttonTime;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "iconCalendarText", {
                get: function () {
                    return this.styles.iconCalendarText;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "iconPrimary", {
                get: function () {
                    return this.styles.iconPrimary;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "headingAccordion", {
                get: function () {
                    return this.styles.headingAccordion;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "headingAddons", {
                get: function () {
                    return this.styles.headingAddons;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "headingExtras", {
                get: function () {
                    return this.styles.headingExtras;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(DrawerStyle.prototype, "sectionBorder", {
                get: function () {
                    return this.styles.sectionBorder;
                },
                enumerable: false,
                configurable: true
            });
            DrawerStyle.prototype.setProductImage = function (img) {
                this.styles.productImage = img;
            };
            Object.defineProperty(DrawerStyle.prototype, "productImage", {
                get: function () {
                    return this.styles.productImage;
                },
                enumerable: false,
                configurable: true
            });
            DrawerStyle.prototype.SetupDrawerStyle = function (style) {
                this.drawerTemplate = style !== null && style !== void 0 ? style : '';
                switch (this.drawerTemplate.toLowerCase()) {
                    case 'professional':
                    case 'pro':
                        this.styles.drawerHeaderText = 'text-white';
                        this.styles.drawerHeaderBackground = 'bg-pro';
                        this.styles.drawerBodyText = 'text-pro';
                        this.styles.buttonContinue = 'btn-primary';
                        this.styles.buttonDayGroup = "btn-group-pro";
                        this.styles.buttonPrimary = 'btn-pro';
                        this.styles.buttonTime = 'time-pro';
                        this.styles.iconCalendarText = 'text-pro';
                        this.styles.iconPrimary = 'icon-container-pro';
                        this.styles.drawerSectionBackground = 'bg-med-grey';
                        this.styles.headingAccordion = 'idp-green-text-highlight';
                        this.styles.headingAddons = 'idp-green-text-highlight';
                        this.styles.headingExtras = 'idp-green-text-highlight';
                        this.styles.sectionBorder = 'border-pro';
                        break;
                    case 'default':
                    case 'page2022':
                        this.styles.drawerHeaderText = '';
                        this.styles.drawerHeaderBackground = '';
                        this.styles.drawerBodyText = '';
                        this.styles.buttonClose = 'btn-close';
                        this.styles.buttonContinue = 'btn-primary';
                        this.styles.buttonDayGroup = '';
                        this.styles.buttonPrimary = 'btn-primary';
                        this.styles.buttonTime = 'btn-text';
                        this.styles.iconCalendarText = '';
                        this.styles.iconPrimary = 'icon-container-2022';
                        this.styles.drawerSectionBackground = '';
                        this.styles.drawerBodyBackground = '';
                        this.styles.headingAccordion = '';
                        this.styles.headingAddons = 'text-black';
                        this.styles.headingExtras = 'text-white';
                        this.styles.sectionBorder = '';
                        this.is2022Design = true;
                        break;
                    default:
                        this.styles.buttonPrimary = 'btn-outline-secondary';
                        if ((this.isSquads || this.isCourseBundle)) {
                            this.styles.buttonContinue = 'btn-success';
                            this.styles.buttonDayGroup = "btn-group-days";
                            this.styles.drawerHeaderBackground = 'bg-darkblue';
                            this.styles.drawerHeaderText = 'text-white';
                            this.styles.drawerBodyBackground = 'bg-purple-gradient';
                            this.styles.drawerBodyText = 'text-white';
                            this.styles.drawerSectionText = "text-black";
                            this.styles.drawerSectionBackground = 'bg-lightgray';
                            this.styles.iconPrimary = 'icon-container';
                            this.styles.buttonTime = 'btn-link squads';
                            this.styles.headingAccordion = 'idp-purple-text-highlight';
                            this.styles.sectionBorder = '';
                        }
                        break;
                }
            };
            return DrawerStyle;
        }());
        Controllers.DrawerStyle = DrawerStyle;
        Pulse.app.controller(ProductAvailabilityCtrl.controllerId, [
            '$scope',
            '$route',
            'config',
            '$location',
            'common',
            'breezeService',
            'pulseContextService',
            'ProductAvailabilityStepService',
            'DrawerToggleService',
            ProductAvailabilityCtrl,
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var BaseViewCtrl = Pulse.Common.BaseViewCtrl;
        var ProductStatusTypeDecorator = Pulse.Common.DataAccess.Services.ProductStatusTypeDecorator;
        var ProductIpcDrawerCtrl = (function (_super) {
            __extends(ProductIpcDrawerCtrl, _super);
            function ProductIpcDrawerCtrl($scope, $route, config, $location, common, breezeService, pulseContext, pulsePass, avcMgr, drawerToggleService) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ProductIpcDrawerCtrl.controllerId) || this;
                _this._regformReady = false;
                _this.location = {};
                _this.locationList = [];
                _this.showOrderConfirmation = false;
                _this.hasSessions = true;
                _this.addToWaitList = false;
                _this.alertList = [];
                _this._selectedSessionProduct = null;
                _this.pulsePass = pulsePass;
                _this.drawerStyle = new Controllers.DrawerStyle('page2022');
                _this.prodAvailabilityMgr = _this.pulseContext.regFlowMgr.prodAvailabilityMgr;
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.drawerToggleService = drawerToggleService;
                _this.availChartMgr = avcMgr;
                _this.productStatusDec = new ProductStatusTypeDecorator();
                _this.activationPromises.push(_this.loadData());
                _this.$scope.$on(Events.ProductAvailabilityStepChange, function (event, newStep) {
                    _this.onStepChanged(newStep);
                });
                _this.$scope.$on(Events.ProductAddedToCart, function (event, mainProduct, participant) {
                    _this.afterProductAddedToCart(mainProduct, participant);
                });
                return _this;
            }
            ProductIpcDrawerCtrl.prototype.onStepChanged = function (newStep) {
                var _this = this;
                this.common.$timeout(function () {
                    switch (newStep.step.step) {
                        case Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep:
                            _this._spdId = null;
                            _this.products = null;
                            _this.selectedProduct = null;
                            _this._regformReady = false;
                            _this.addToWaitList = false;
                            break;
                        case Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.LoadDateStep:
                            if (newStep.stepData.spdId !== undefined) {
                                _this._spdId = newStep.stepData.spdId;
                                _this.initProducts(newStep.stepData);
                            }
                            if (newStep.stepCode == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.StepBack) {
                                _this.pulsePass.stepPrev();
                            }
                            break;
                        case Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectExperienceStep:
                            if (_this.products.optionProduct === undefined || _this.products.optionProduct === null) {
                                if (newStep.stepCode == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.StepForward) {
                                    _this.pulsePass.stepNext(null, _this.mainProduct);
                                }
                                else {
                                    _this.pulsePass.stepPrev();
                                }
                            }
                            break;
                        case Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.BuyingCourse:
                            var prod = newStep.stepData;
                            if (prod.sessionProductDetailID != _this._spdId) {
                                _this._spdId = prod.sessionProductDetailID;
                                _this.selectedProduct = prod;
                            }
                            _this.initForm();
                            break;
                        default:
                            break;
                    }
                });
            };
            ProductIpcDrawerCtrl.prototype.initForm = function () {
                var _this = this;
                var sp = this.sessionProducts.filter(function (spl) { return spl.sessionProductDetailID == _this._spdId; })[0];
                this.sessionPaymentOption = this.sessionList.locationSessionInfo.filter((function (lsi) { return lsi.sessID == sp.sessionID; }))[0].sessionPaymentOption;
                this._regformReady = true;
            };
            ProductIpcDrawerCtrl.prototype.initProducts = function (stepData) {
                var _this = this;
                this.common.toggleSpinner(true, null, null, null, Controllers.AvailChartFiltersCtrl.spinnerMessage);
                var spList = this.sessionProducts;
                var sp = spList.filter(function (p) { return p.relatedProductTypeID == null; })[0];
                var ONsp = spList.filter(function (p) { return p.relatedProductTypeID == Enums.RelatedProductType.PrimaryOptionalProduct; })[0];
                if (ONsp) {
                    sp.sessionProductDetailONID = ONsp.sessionProductDetailID;
                }
                this.initSession(sp, ONsp);
                if (sp.sessionAlertNote !== null && sp.sessionAlertNote !== undefined) {
                    this.alertList = [{
                            title: sp.sessionAlertTitle,
                            note: sp.sessionAlertNote,
                            cssClass: 'warning'
                        }];
                }
                var course = this.initCourse(sp);
                var div = this.initDivision(sp);
                this.drawerToggleService.close();
                this.drawerToggleService.toggleDrawer(div, course, this.selectedSession)
                    .finally(function () {
                    _this.drawerToggleService.setProductCurrencyType(_this.mainProduct.currencyTypeID);
                    _this.products = _this.drawerToggleService.drawerProducts;
                    _this.mainProduct = _this.products.mainProduct;
                    _this.selectedProduct = _this.products.mainProduct;
                    if (_this.productImageUrl !== null && _this.productImageUrl !== undefined) {
                        _this.drawerStyle.setProductImage(_this.productImageUrl);
                    }
                    if (stepData != null && stepData.sessionAvailabilityStatusTypeID == Enums.SessionAvailabilityStatus.SoldOut
                        || stepData.sessionAvailabilityStatusTypeID == Enums.SessionAvailabilityStatus.SoldOutDesktop || _this.forceWaitlist) {
                        _this.addToWaitList = true;
                        _this.location = {
                            name: _this.termDiv.locationName,
                            addressArea: _this.termDiv.addressArea,
                            productImage: _this.productImageUrl
                        };
                    }
                    else {
                        _this.pulsePass.stepNext(null, _this.products);
                    }
                    _this.common.toggleSpinner(false);
                    if (_this.debug) {
                        console.log({
                            products: _this.products,
                            mainProd: _this.mainProduct
                        });
                    }
                });
            };
            ProductIpcDrawerCtrl.prototype.createProductDTO = function (prod, termDiv) {
                if (prod !== undefined && prod !== null) {
                    var prodStatAttr = this.getProductStatusByTypeId(prod.sessionAvailabilityStatusTypeID);
                    return {
                        alertNote: prod.alertNote,
                        divisionID: termDiv.divisionID,
                        productID: prod.productID,
                        sessionProductDetailID: prod.sessionProductDetailID,
                        locationID: termDiv.locationID,
                        locSessID: prod.locationSessionID,
                        sessionID: prod.sessionID,
                        name: prod.productName,
                        price: prod.sessionPrice,
                        locationPrice: prod.locationProductPrice,
                        currencyTypeID: prod.currencyTypeID,
                        maximumAge: prod.maximumAge,
                        minimumAge: prod.minimumAge,
                        scheduleDescriptor: prod.scheduleDescriptor,
                        sessionStart: prod.startDate,
                        sessionEnd: prod.endDate,
                        catalogTypeID: 0,
                        headline: prod.headline,
                        quantity: 1,
                        options: [],
                        description: prod.description,
                        statusOptions: {
                            id: prod.sessionAvailabilityStatusTypeID,
                            displayName: prod.sessionAvailabilityStatus,
                            hasUserInteraction: prodStatAttr.hasUserInteraction,
                            htmlClass: prodStatAttr.htmlClass,
                            isWaitlist: false,
                            isBuyable: true
                        },
                        activityDesc: '',
                        ageRangeID: termDiv.ageRangeID,
                        alerts: [],
                        courseProdId: prod.productID,
                        termID: prod.termID,
                        isONPackage: prod.isONpackage,
                        scheduleTypeID: prod.scheduleTypeID,
                        programTypeID: 0,
                        prerequisities: [],
                        programStatus: prod.sessionAvailabilityStatus,
                        programStatusTypeID: prod.sessionAvailabilityStatusTypeID,
                        spdID: prod.sessionProductDetailID,
                        highlightPriceReductions: prod.highlightPriceReductions,
                        skillLevels: [],
                        daysPerSession: termDiv.daysPerSession,
                        locationCatDateRangeID: 0,
                        productSubCatTypeID: prod.productSubCatTypeID,
                        productCategoryTypeID: 0,
                        shortDescription: '',
                        shippingAndReturnPolicy: '',
                        productBanner: '',
                        isMostPopularBadgeShown: false,
                        percentSaved: 0,
                        takeHomeDesc: prod.takeHomeDesc,
                        startDateTime: prod.startDate,
                        endDateTime: prod.endDate,
                    };
                }
                return null;
            };
            ProductIpcDrawerCtrl.prototype.initCourse = function (sessProd) {
                var course = {
                    activityDesc: sessProd.productActivityDesc,
                    description: sessProd.description,
                    genreIDs: [],
                    hasBuyableSessions: sessProd.hasBuyableSessions,
                    genres: [],
                    isNewExpireDate: sessProd.isNewExpireDate,
                    locationPrice: sessProd.locationProductPrice,
                    maxAge: sessProd.maximumAge,
                    minAge: sessProd.minimumAge,
                    name: sessProd.productName,
                    prerequisities: [],
                    prodID: sessProd.productID,
                    schedule: '',
                    sessions: null,
                    skillLevels: [],
                    startingAt: sessProd.startingAt,
                    subCatID: sessProd.productSubCatTypeID,
                    subCatName: '',
                    takeHomeDesc: sessProd.takeHomeDesc,
                    toolsUsed: sessProd.toolsUsed,
                    uRLs: this.dataset.productURLs,
                    catalogTypeID: 0,
                    headline: sessProd.headline,
                    currencyTypeID: sessProd.currencyTypeID
                };
                return course;
            };
            ProductIpcDrawerCtrl.prototype.initSession = function (sessProd, prodON) {
                var prodStatAttr = this.getProductStatusByTypeId(sessProd.sessionAvailabilityStatusTypeID);
                var selSess = {
                    AMPMOption: sessProd.isONpackage,
                    endDate: sessProd.endDate,
                    hasCourse: sessProd.hasCourse,
                    hasPM: false,
                    inCart: false,
                    inCartCount: 0,
                    inWaitlist: sessProd.inWaitList,
                    isONpackage: sessProd.isONpackage,
                    isONPackage: sessProd.isONpackage,
                    isPM: false,
                    locationSessionID: sessProd.locationSessionID,
                    maxAge: sessProd.maximumAge,
                    maxAgeOverN: 0,
                    minAge: sessProd.minimumAge,
                    minAgeOverN: 0,
                    numOfThisSessProdInCart: 0,
                    optionRestriction: null,
                    optionStatus: null,
                    PMSession: null,
                    price: sessProd.price,
                    progStatusFiltered: null,
                    programStatus: null,
                    programStatusTypeID: null,
                    selectedText: 'Selected',
                    sessID: sessProd.sessionID,
                    spdID: sessProd.sessionProductDetailID,
                    spdIDON: null,
                    statusOptions: {
                        id: sessProd.sessionAvailabilityStatusTypeID,
                        displayName: sessProd.sessionAvailabilityStatus,
                        hasUserInteraction: prodStatAttr.hasUserInteraction,
                        htmlClass: prodStatAttr.htmlClass,
                        isWaitlist: false,
                        isBuyable: true
                    },
                    alertNote: sessProd.alertNote,
                    highlightPriceReductions: sessProd.highlightPriceReductions,
                    priceWithON: 0,
                    products: { mainProduct: null, optionProduct: null },
                    startDate: sessProd.startDate,
                };
                if (prodON !== undefined && prodON !== null) {
                    selSess.spdIDON = prodON.sessionProductDetailID;
                    selSess.programStatus = prodON.sessionAvailabilityStatus;
                    selSess.programStatusTypeID = prodON.sessionAvailabilityStatusTypeID;
                    selSess.priceWithON = sessProd.price + prodON.price;
                    selSess.maxAgeOverN = prodON.maximumAge;
                    selSess.minAgeOverN = prodON.minimumAge;
                }
                this.selectedSession = selSess;
                return selSess;
            };
            ProductIpcDrawerCtrl.prototype.initDivision = function (sessProd) {
                var div = {
                    ageRangeID: 0,
                    catalogDateRange: {},
                    courses: [],
                    currencyTypeID: this.termDiv.currencyTypeID,
                    daysPerSession: this.termDiv.daysPerSession,
                    divID: this.termDiv.divisionID,
                    divProgramTypeID: this.termDiv.programTypeID,
                    experienceDescription: this.termDiv.experienceDescription,
                    hasPM: false,
                    hasWeekend: sessProd.hasWeekend,
                    isDayOnly: sessProd.isDayOnly,
                    isOvernightOnly: sessProd.isOvernightOnly,
                    locHasCampAtHQ: this.termDiv.locHasCampAtHQ,
                    locID: this.termDiv.locationID,
                    minAge: this.termDiv.minAge,
                    minCoursePrice: this.termDiv.minCoursePrice,
                    name: this.termDiv.divisionName,
                    PMDivision: {},
                    sessions: this.sessionList.locationSessionInfo,
                    skillLevels: [],
                    sortOrder: this.termDiv.divisionSortOrder,
                    studentGenderType: this.termDiv.studentGenderType,
                    termDescription: this.termDiv.termDescription,
                    termID: this.termDiv.termID,
                    termName: this.termDiv.termName,
                    termSortOrder: this.termDiv.termSortOrder,
                    divDeliveryModelTypeID: this.termDiv.divDeliveryModelTypeID,
                    divMaxAgeCalcTypeID: this.termDiv.maxAgeCalcTypeID,
                    divMinAgeCalcTypeID: this.termDiv.minAgeCalcTypeID,
                    maxAge: this.termDiv.maxAge,
                    schedTypeID: null,
                    shortTermName: this.termDiv.termName,
                    expName: '',
                    expDesc: this.termDiv.experienceDescription,
                };
                div.ageRangeID = this.termDiv.ageRangeID;
                div.currencyTypeID = this.termDiv.currencyTypeID;
                div.experienceDescription = this.termDiv.experienceDescription;
                return div;
            };
            ProductIpcDrawerCtrl.prototype.initSteps = function () {
                var stepList = [
                    {
                        stepID: 0,
                        step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectLocationStep,
                        stepBackText: 'Back to course page',
                        stepSelectText: 'Locations closest to:'
                    },
                    {
                        stepID: 0,
                        step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep,
                        stepBackText: 'Back to location search',
                        stepSelectText: 'Select your session date range for:'
                    },
                    {
                        stepID: 0,
                        step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.LoadDateStep,
                        stepBackText: 'Back to session date selection',
                        stepSelectText: ''
                    },
                    {
                        stepID: 0,
                        step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectExperienceStep,
                        stepBackText: 'Back to session date selection',
                        stepSelectText: 'Select a camp experience for:'
                    },
                    {
                        stepID: 0,
                        step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.BuyingCourse,
                        stepBackText: 'Back to experience selection',
                        stepSelectText: 'Select a camp experience for:'
                    }
                ];
                if (this.IsSelectLocationStepNeeded) {
                    stepList.splice(1, 0, {
                        stepID: 0,
                        step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectAcadamyStep,
                        stepBackText: 'Back to course page',
                        stepSelectText: 'Academy locations:'
                    });
                }
                this.pulsePass.init({
                    stepManagerType: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavStepManagerType.ListSteps,
                    stepData: stepList
                });
                if (!isNaN(this.locId)) {
                    if (this.IsSelectLocationStepNeeded) {
                        this.pulsePass.stepNext(null, {});
                    }
                }
                this.pulsePass.stepNext(null, {});
            };
            ProductIpcDrawerCtrl.prototype.initWaitlist = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = this;
                                return [4, this.prodAvailabilityMgr.getProductByID(this.prodId, this.locId)];
                            case 1:
                                _a.mainProduct = _b.sent();
                                this.drawerToggleService.waitlistSession = {
                                    inWaitlist: false,
                                    spdID: this.mainProduct.sessionProductDetailID,
                                };
                                this.addToWaitList = true;
                                return [2];
                        }
                    });
                });
            };
            ProductIpcDrawerCtrl.prototype.loadData = function () {
                var promises = new Array();
                if (isNaN(this.locId) && !isNaN(this.prodId)) {
                    promises.push(this.getLocationListAsync());
                }
                else {
                    promises.push(this.getProductAvailabilityAsync());
                    promises.push(this.loadUserBrowsingInfo());
                }
                return this.common.$q.all(promises);
            };
            ProductIpcDrawerCtrl.prototype.getLocationListAsync = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var results;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (isNaN(this.prodId))
                                    return [2, null];
                                this.common.toggleSpinner(true, null, null, null, Controllers.AvailChartFiltersCtrl.spinnerMessage);
                                return [4, this.prodAvailabilityMgr.getWwwProductLocationList(this.prodId)
                                        .then(function (data) {
                                        if (_this.debug) {
                                            console.log(data);
                                        }
                                        _this.locationList = data;
                                    }).finally(function () {
                                        _this.initSteps();
                                        _this.common.toggleSpinner(false);
                                    })];
                            case 1:
                                results = _a.sent();
                                return [2];
                        }
                    });
                });
            };
            ProductIpcDrawerCtrl.prototype.getProductAvailabilityAsync = function (isFirstTime) {
                if (isFirstTime === void 0) { isFirstTime = true; }
                return __awaiter(this, void 0, void 0, function () {
                    var results;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (isNaN(this.prodId) || isNaN(this.locId))
                                    return [2, null];
                                this.common.toggleSpinner(true, null, null, null, Controllers.AvailChartFiltersCtrl.spinnerMessage);
                                return [4, this.prodAvailabilityMgr.getProductAvailabilityByLocation(this.prodId, this.locId)
                                        .then(function (data) {
                                        if (_this.debug) {
                                            console.log(data);
                                        }
                                        _this.dataset = data;
                                        _this.termDiv = _this.dataset.termDivision[0];
                                        _this.mainProduct = _this.createProductDTO(data.productSessions.filter(function (p) { return p.relatedProductTypeID == null; })[0], _this.termDiv);
                                        if (_this.termDiv !== undefined && _this.termDiv !== null) {
                                            _this._locationInfo = {
                                                addressArea: _this.termDiv.addressArea,
                                                locationName: _this.termDiv.locationName,
                                                locationID: _this.termDiv.locationID
                                            };
                                        }
                                        _this.setupLists(data);
                                        return data;
                                    }).finally(function () {
                                        _this.hasSessions = _this.sessionList.locationSessionInfo.length > 0;
                                        if (!_this.hasSessions) {
                                            _this.initWaitlist();
                                        }
                                        _this.common.toggleSpinner(false);
                                    })];
                            case 1:
                                results = _a.sent();
                                this.initSteps();
                                return [2, results];
                        }
                    });
                });
            };
            ProductIpcDrawerCtrl.prototype.loadUserBrowsingInfo = function () {
                var _this = this;
                return this.userBrowsingMgr
                    .loadInfo(this.userBrowsingMgr.currentUBSession, true)
                    .then(function () {
                    return _this.userBrowsingMgr.setUserBrowsingResumeStep(Enums.RegFlowProgressStep.AvailChart2017);
                })
                    .then(function () {
                    if (_this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress) {
                        return _this.userBrowsingMgr.loadWaitlist(_this.userBrowsingMgr.currentUBSession, _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress, true);
                    }
                });
            };
            ProductIpcDrawerCtrl.prototype.setupLists = function (data) {
                this.sessionList = {};
                this.sessionList.courseSessionInfo = [];
                this.sessionList.locationSessionInfo = [];
                this.sessionList.productDates = [];
                var processSessionList = data.productSessions.filter(function (p) { return p.relatedProductTypeID == null; });
                var _loop_1 = function (sess) {
                    var sessStatus = Pulse.PulsePublic.RegistryFlow.AvailabilityStatus.Open;
                    var sessONProd = data.productSessions.filter(function (p) { return p.sessionID == sess.sessionID
                        && p.relatedProductTypeID == Enums.RelatedProductType.PrimaryOptionalProduct; })[0];
                    switch (sess.sessionAvailabilityStatusTypeID) {
                        case Enums.SessionAvailabilityStatus.Space1:
                        case Enums.SessionAvailabilityStatus.Space2:
                        case Enums.SessionAvailabilityStatus.Space3:
                        case Enums.SessionAvailabilityStatus.Space4:
                            sessStatus = sess.sessionAvailabilityStatus.split(' ')[0] + ' spots left';
                            break;
                        default:
                            sessStatus = sess.sessionAvailabilityStatus;
                            break;
                    }
                    this_1.sessionList.productDates.push({
                        start: sess.startDate,
                        end: sess.endDate,
                        prodId: sess.productID,
                        sessId: sess.sessionID,
                        spdId: sess.sessionProductDetailID,
                        sessionStatus: sessStatus,
                        sessionAvailabilityStatusTypeID: sess.sessionAvailabilityStatusTypeID,
                        statusClass: ''
                    });
                    this_1.sessionList.locationSessionInfo.push({
                        alerts: null,
                        end: sess.endDate,
                        locID: this_1.termDiv.locationID,
                        lSID: sess.locationSessionID,
                        ordinal: 1,
                        sessID: sess.sessionID,
                        sessionPaymentOption: {
                            balanceDueDate: sess.balanceDueDate,
                            currencyTypeID: sess.depositTypeID,
                            depositTypeID: sess.depositTypeID,
                            depositValue: sess.depositValue,
                            divDeliveryModelTypeID: this_1.termDiv.deliveryModelTypeID,
                            paymentOptionEndDate: sess.divSignUpEndDate,
                            sessID: sess.sessionID
                        },
                        start: sess.startDate,
                        termID: this_1.termDiv.termID,
                        displayEnd: sess.endDate,
                        mealAddEndDate: sess.endDate,
                        newAddEnd: sess.endDate,
                        residencyAddEndDate: sess.startDate
                    });
                    var csi = {
                        endDate: sess.endDate,
                        hasCourse: sess.hasCourse,
                        isONpackage: sess.isONpackage,
                        locationSessionID: sess.locationSessionID,
                        maxAge: sess.maximumAge,
                        minAge: sess.minimumAge,
                        maxAgeOverN: 0,
                        minAgeOverN: 0,
                        numOfThisSessProdInCart: 0,
                        optionRestriction: null,
                        optionStatus: sess.sessionAvailabilityStatus,
                        price: sess.price,
                        priceWithON: 0,
                        programStatus: sess.sessionAvailabilityStatus,
                        programStatusTypeID: sess.sessionAvailabilityStatusTypeID,
                        scheduleDefID: sess.scheduleDefID,
                        selectedText: null,
                        sessID: sess.sessionID,
                        startDate: sess.startDate,
                        highlightPriceReductions: sess.highlightPriceReductions,
                        spdID: sess.sessionProductDetailID,
                        spdIDON: null
                    };
                    if (sessONProd !== undefined && sessONProd !== null) {
                        csi.spdIDON = sessONProd.sessionProductDetailID;
                        csi.priceWithON = sessONProd.price + sess.price;
                        csi.maxAgeOverN = sessONProd.maximumAge;
                        csi.minAgeOverN = sessONProd.minimumAge;
                    }
                    this_1.sessionList.courseSessionInfo.push(csi);
                };
                var this_1 = this;
                for (var _i = 0, processSessionList_1 = processSessionList; _i < processSessionList_1.length; _i++) {
                    var sess = processSessionList_1[_i];
                    _loop_1(sess);
                }
            };
            ProductIpcDrawerCtrl.prototype.afterProductAddedToCart = function (mainProduct, participant) {
                if (participant === void 0) { participant = null; }
                var self = this;
                this.pulseContext.regFlowMgr.shoppingCartMgr.clearCachedCart();
                if (this.pulseContext.isRunningInPartnerDomain) {
                    this.redirectToCheckout();
                    return;
                }
                this.showOrderConfirmation = true;
                this.mainProduct = mainProduct;
                Events.TriggerDocCustomEvent(Events.ProductAvailabilityAddedToCart_JSEvent, this.userBrowsingMgr.currentUBSession);
                if (this.pulseContext.isImpersonating) {
                    var count = this.userBrowsingMgr.standaloneItemCount(this.userBrowsingMgr.currentUBSession);
                    this.common.updateCSImpersonationShoppingCartCount(count);
                }
                return null;
            };
            ProductIpcDrawerCtrl.prototype.redirectToCheckout = function () {
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/shopping-cart');
                }
                else {
                    this.common.$location.url(Routes.RegFlow_ShoppingCart);
                }
            };
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "crossSellProds", {
                get: function () {
                    return this.drawerToggleService.crossSellProds;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "isDateStep", {
                get: function () {
                    if (this.pulsePass.currentStep !== null && this.pulsePass.currentStep !== undefined)
                        return this.pulsePass.currentStep.step == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep;
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "isExperienceStep", {
                get: function () {
                    if (this.pulsePass.currentStep !== null && this.pulsePass.currentStep !== undefined)
                        return this.pulsePass.currentStep.step == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectExperienceStep;
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "locationInfo", {
                get: function () {
                    return this._locationInfo;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "prodId", {
                get: function () {
                    return this.getParamAsNumber(QueryStringUtils.PRODUCT_ID);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "locId", {
                get: function () {
                    return this.getParamAsNumber(QueryStringUtils.LOCATION_ID);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "locationStep", {
                get: function () {
                    return this.getParamAsBoolean(ProductIpcDrawerCtrl.SELECT_LOCATION_KEY);
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "debug", {
                get: function () {
                    if (this._debug === undefined) {
                        this._debug = this.getParamAsBoolean('debug');
                    }
                    return this._debug;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "forceWaitlist", {
                get: function () {
                    if (this._forceWaitlist === undefined) {
                        this._forceWaitlist = this.getParamAsBoolean('waitlist');
                    }
                    return this._forceWaitlist;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "productImageUrl", {
                get: function () {
                    var _this = this;
                    var prodImages = this.dataset.productURLs.filter(function (p) { return p.productID == _this.mainProduct.productID
                        && p.usageTypeID == Enums.ProductURLType.CourseVideoIntroImageURL; });
                    if (prodImages.length === 0) {
                        return null;
                    }
                    var prodImageUrl = prodImages[0].uRL;
                    prodImageUrl = prodImageUrl.split('.')[0] + '_s.' + prodImageUrl.split('.')[1];
                    return this.common.config.courseVideoThumbnailUrl + '/' + prodImageUrl;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "sessionProducts", {
                get: function () {
                    var _this = this;
                    if (this.selectedSessionProduct != null) {
                        return this.dataset.productSessions.filter(function (p) { return p.sessionID == _this.selectedSessionProduct.sessionID; });
                    }
                    return null;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "selectedSessionProduct", {
                get: function () {
                    var _this = this;
                    if (angular.isNumber(this._spdId) && (this._selectedSessionProduct == null
                        || this._spdId != this._selectedSessionProduct.sessionProductDetailID)) {
                        this._selectedSessionProduct = this.dataset.productSessions.filter(function (f) { return f.sessionProductDetailID == _this._spdId; })[0];
                    }
                    if (!angular.isNumber(this._spdId))
                        this._selectedSessionProduct = null;
                    return this._selectedSessionProduct;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "regFormReady", {
                get: function () {
                    return this._regformReady && this.pulsePass.currentStep.step == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.BuyingCourse;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "showSelectLocation", {
                get: function () {
                    if (this.pulsePass.currentStep !== null && this.pulsePass.currentStep !== undefined)
                        return this.pulsePass.currentStep.step == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectAcadamyStep
                            && (this.locationInfo !== undefined || this.locationInfo !== null);
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "IsSelectLocationStepNeeded", {
                get: function () {
                    return isNaN(this.locId) || this.getParamAsBoolean(ProductIpcDrawerCtrl.SELECT_LOCATION_KEY);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "isSubscription", {
                get: function () {
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "fullAvcLink", {
                get: function () {
                    var fullAvcUrl = this.common.config.WWW_UrlRoot + '/register#/reg-flow/avail-charts-filters?rgnad=true';
                    if (this.dataset !== null && this.dataset !== undefined && this.dataset.termDivision.length > 0) {
                        fullAvcUrl += '&' + QueryStringUtils.LOCATION_ID + '%5B%5D=' + this.dataset.termDivision[0].locationID
                            + '&' + QueryStringUtils.DIVISION_ID + '=' + this.dataset.termDivision[0].divisionID;
                    }
                    return fullAvcUrl;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ProductIpcDrawerCtrl.prototype, "showFullAvcLink", {
                get: function () {
                    var showAvc = false;
                    if (this.dataset !== null && this.dataset !== undefined) {
                        showAvc = _.filter(this.dataset.productSessions, function (ps) {
                            return ps.sessionAvailabilityStatusTypeID === Enums.SessionAvailabilityStatus.SoldOutDesktop || ps.sessionAvailabilityStatusTypeID === Enums.SessionAvailabilityStatus.SoldOut;
                        }).length > 0;
                    }
                    return showAvc && this.isDateStep && this.hasSessions;
                },
                enumerable: false,
                configurable: true
            });
            ProductIpcDrawerCtrl.prototype.getParamAsNumber = function (qsParamName) {
                var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                if (Array.isArray(param)) {
                    param = param[0];
                }
                return typeof param === 'string' ? parseInt(param, 10) : param;
            };
            ProductIpcDrawerCtrl.prototype.getParamAsBoolean = function (qsParamName) {
                var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                if (Array.isArray(param)) {
                    param = param[0];
                }
                return typeof param === 'string' ? parseInt(param) == 1 : param;
            };
            ProductIpcDrawerCtrl.prototype.getProductStatusByTypeId = function (typeId) {
                var statuses = Enums.SessionAvailabilityStatus;
                var propertyName = null;
                for (var name in statuses) {
                    if (statuses[name] === typeId) {
                        propertyName = name;
                    }
                }
                return this.productStatusDec.programStatuses[propertyName];
            };
            ProductIpcDrawerCtrl.controllerId = 'ProductIpcDrawerCtrl';
            ProductIpcDrawerCtrl.SELECT_LOCATION_KEY = 'ls';
            return ProductIpcDrawerCtrl;
        }(BaseViewCtrl));
        Controllers.ProductIpcDrawerCtrl = ProductIpcDrawerCtrl;
        Pulse.app.controller(ProductIpcDrawerCtrl.controllerId, [
            '$scope',
            '$route',
            'config',
            '$location',
            'common',
            'breezeService',
            'pulseContextService',
            'ProductAvailabilityStepService',
            'AvailChartMgr',
            'DrawerToggleService',
            ProductIpcDrawerCtrl,
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var BaseViewCtrl = Pulse.Common.BaseViewCtrl;
        var DrawerStyle = Pulse.Controllers.DrawerStyle;
        var TutoringCtrl = (function (_super) {
            __extends(TutoringCtrl, _super);
            function TutoringCtrl($scope, $route, config, $location, common, breezeService, pulseContext, drawerToggleService) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, TutoringCtrl.controllerId) || this;
                _this.showOrderConfirmation = false;
                _this.addonProducts = [];
                _this.userBrowsingLoaded = false;
                var newStyle = _this.$location.search().style ? _this.$location.search().style : _this.$location.search().template ? _this.$location.search().template : 'page2022';
                _this.drawerStyle = new DrawerStyle(newStyle, false, false);
                _this.$scope = $scope;
                _this.common = common;
                _this.config = config;
                _this.drawerToggleService = drawerToggleService;
                _this.prodAvailabilityMgr = _this.pulseContext.regFlowMgr.prodAvailabilityMgr;
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.scrollToTopOnLoaded = false;
                _this.$scope.$on(Events.ProductAddedToCart, function (event, mainProduct, participant) {
                    _this.afterProductAddedToCart(mainProduct, participant);
                });
                _this.activationPromises.push(_this.loadData());
                return _this;
            }
            TutoringCtrl.prototype.loadData = function () {
                var promises = new Array();
                promises.push(this.getTutoring());
                promises.push(this.loadUserBrowsingInfo());
                return this.common.$q.all(promises);
            };
            TutoringCtrl.prototype.getTutoring = function (isFirstTime) {
                if (isFirstTime === void 0) { isFirstTime = true; }
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        return [2, this.prodAvailabilityMgr.getProductAvailability(this.prodId, Enums.TimeZoneType.Pacific)
                                .then(function (data) {
                                _this.dataset = data;
                                _this.tutorProd = _this.dataset.products.filter(function (p) { return p.relatedProductTypeID == null; })[0];
                                _this.isTutoring = (_this.tutorProd.catalogTypeID == Enums.SalesCatalogType.OPLGeneric || _this.tutorProd.catalogTypeID == Enums.SalesCatalogType.OPLThemed);
                                var addonProds = _this.dataset.products.filter(function (p) { return (p.relatedProductTypeID > 0 && p.relatedProductTypeID !== Enums.RelatedProductType.ProductVariant); });
                                _this.drawerStyle.setProductImage(_this.getThumbNailFullUrl());
                                addonProds.forEach(function (p) {
                                    var addonProd = {
                                        productID: p.productID,
                                        name: p.name,
                                        description: p.description,
                                        isNewExpireDate: p.isNewExpireDate,
                                        minimumAge: p.minimumAge,
                                        maximumAge: p.maximumAge,
                                        locationPrice: p.locationPrice,
                                        currencyTypeID: p.currencyTypeID,
                                        hasBuyableSessions: p.hasBuyableSessions,
                                        startingAt: p.startingAt,
                                        catalogTypeID: p.catalogTypeID,
                                        relatedProductTypeID: p.relatedProductTypeID,
                                        discountValueTypeID: p.discountValueTypeID,
                                        discountValue: p.discountValue,
                                        marketingText: p.marketingText,
                                        prodUrls: _this.dataset.productURLs.filter(function (u) { return u.productID == p.productID; }),
                                        isSelected: _this.addonProdIds.indexOf(p.productID) >= 0
                                    };
                                    _this.addonProducts.push(addonProd);
                                });
                                _this.toggleDrawer();
                                return data;
                            })];
                    });
                });
            };
            TutoringCtrl.prototype.toggleDrawer = function () {
                var product = this.tutorProd;
                var mainProd;
                mainProd = {};
                mainProd.divisionID = 41;
                mainProd.productID = product.productID;
                mainProd.activityDesc = product.productActivityDesc;
                mainProd.name = product.name;
                mainProd.price = this.isSubscription ? this.calculateDiscount(product.locationPrice, product.discountValueTypeID, product.discountValue) : product.locationPrice;
                mainProd.locationPrice = mainProd.price;
                mainProd.currencyTypeID = product.currencyTypeID ? product.currencyTypeID : Enums.CurrencyType.USD;
                mainProd.maximumAge = product.maximumAge;
                mainProd.minimumAge = product.minimumAge;
                mainProd.scheduleDescriptor = product.scheduleDescriptor;
                mainProd.catalogTypeID = product.catalogTypeID;
                mainProd.headline = product.headline;
                mainProd.quantity = product.quantity;
                mainProd.options = [];
                this.addonProducts.forEach(function (ap) {
                    var option;
                    option = {
                        activityDesc: "",
                        description: ap.description,
                        maxAge: ap.maximumAge,
                        minAge: ap.minimumAge,
                        name: ap.name,
                        price: ap.locationPrice,
                        prodID: ap.productID,
                        productCategoryTypeID: ap.catalogTypeID,
                        takeHomeDesc: null,
                        toolsUsed: "",
                    };
                    mainProd.options.push(option);
                });
                mainProd.statusOptions = {
                    displayName: 'Open',
                    hasUserInteraction: true,
                    htmlClass: 'primary',
                    isWaitlist: false
                },
                    mainProd.description = product.description;
                this.products = {
                    mainProduct: mainProd,
                    optionProduct: null
                };
                this.drawerToggleService.setProductCurrencyType(product.currencyTypeID);
                this.drawerToggleService.retrieveCrossSellProducts(mainProd.divisionID);
                this.drawerToggleService.setDrawerProducts(this.products);
            };
            Object.defineProperty(TutoringCtrl.prototype, "drawerProducts", {
                get: function () {
                    return this.drawerToggleService.drawerProducts;
                },
                enumerable: false,
                configurable: true
            });
            TutoringCtrl.prototype.loadUserBrowsingInfo = function () {
                var _this = this;
                this.common.toggleSpinner(true, true, null, 0);
                return this.userBrowsingMgr
                    .loadInfo(this.userBrowsingMgr.currentUBSession, true)
                    .then(function () {
                    _this.userBrowsingLoaded = true;
                })
                    .then(function () {
                    return _this.userBrowsingMgr.setUserBrowsingResumeStep(Enums.RegFlowProgressStep.AvailChart2017);
                })
                    .then(function () {
                    if (_this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress) {
                        return _this.userBrowsingMgr.loadWaitlist(_this.userBrowsingMgr.currentUBSession, _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress, true);
                    }
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false, true);
                });
                ;
            };
            Object.defineProperty(TutoringCtrl.prototype, "prodId", {
                get: function () {
                    if (this._prodId === undefined) {
                        this._prodId = this.getParamAsNumber(QueryStringUtils.PRODUCT_ID);
                    }
                    return this._prodId;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(TutoringCtrl.prototype, "addonProdIds", {
                get: function () {
                    if (this._addonProdIds === undefined) {
                        this._addonProdIds = this.getParamAsNumberArray(QueryStringUtils.ADDON_PRODUCT_ID);
                    }
                    return this._addonProdIds;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(TutoringCtrl.prototype, "isSubscription", {
                get: function () {
                    if (this._isSubscription === undefined) {
                        this._isSubscription = this.getParamAsBoolean(QueryStringUtils.SUBSCRIPTION);
                    }
                    return this._isSubscription;
                },
                enumerable: false,
                configurable: true
            });
            TutoringCtrl.prototype.getParamAsNumber = function (qsParamName) {
                var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                if (Array.isArray(param)) {
                    param = param[0];
                }
                return typeof param === 'string' ? parseInt(param, 10) : param;
            };
            TutoringCtrl.prototype.getParamAsBoolean = function (qsParamName) {
                var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                if (Array.isArray(param)) {
                    param = param[0];
                }
                return !String.isNullOrWhitespace(param) && param.toLowerCase() == "true";
            };
            TutoringCtrl.prototype.getThumbNailFullUrl = function (largeImage) {
                if (largeImage === void 0) { largeImage = false; }
                var prodThumbImgUrl = 'no-image';
                var url = this.dataset.productURLs
                    .filter(function (u) { return u.usageTypeID === Enums.ProductURLType.CourseVideoIntroImageURL; }).shift();
                if (url && !String.isNullOrWhitespace(url.uRL)) {
                    prodThumbImgUrl = Pulse.Utils.JS.composeProductThumbNailFullUrl(this.config.courseVideoThumbnailUrl, url.uRL, false);
                }
                return prodThumbImgUrl;
            };
            TutoringCtrl.prototype.getParamAsNumberArray = function (qsParamName) {
                var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                if (param && Array.isArray(param.split(','))) {
                    return param.split(',').map(function (x) { return parseInt(x); });
                }
                return [];
            };
            TutoringCtrl.prototype.cancel = function () {
                if (this.pulseContext.isImpersonating) {
                    this.common.$location.url(Routes.MyAccount_OPLPurchase);
                }
                else {
                    Events.TriggerDocCustomEvent(Events.ProductAvailabilityCancel_JSEvent, null);
                }
            };
            TutoringCtrl.prototype.afterProductAddedToCart = function (mainProduct, participant) {
                if (participant === void 0) { participant = null; }
                var self = this;
                this.pulseContext.regFlowMgr.shoppingCartMgr.clearCachedCart();
                if (this.pulseContext.isRunningInPartnerDomain) {
                    this.redirectToCheckout();
                    return;
                }
                this.showOrderConfirmation = true;
                this.mainProduct = mainProduct;
                Events.TriggerDocCustomEvent(Events.ProductAvailabilityAddedToCart_JSEvent, this.userBrowsingMgr.currentUBSession);
                if (this.pulseContext.isImpersonating) {
                    var count = this.userBrowsingMgr.standaloneItemCount(this.userBrowsingMgr.currentUBSession);
                    this.common.updateCSImpersonationShoppingCartCount(count);
                }
            };
            TutoringCtrl.prototype.showConfirmation = function (mainProduct) {
                this.showOrderConfirmation = true;
            };
            Object.defineProperty(TutoringCtrl.prototype, "crossSellProds", {
                get: function () {
                    return this.drawerToggleService.crossSellProds;
                },
                enumerable: false,
                configurable: true
            });
            TutoringCtrl.prototype.redirectToCheckout = function () {
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/shopping-cart');
                }
                else {
                    this.common.$location.url(Routes.RegFlow_ShoppingCart);
                }
            };
            TutoringCtrl.prototype.calculateDiscount = function (originalPrice, discountValueType, discountValue) {
                if (discountValueType == Enums.DiscountValueType.FixedAmount) {
                    return originalPrice - discountValue;
                }
                else if (discountValueType == Enums.DiscountValueType.Percent) {
                    return originalPrice * (100 - discountValue) / 100;
                }
                else {
                    return originalPrice;
                }
            };
            TutoringCtrl.prototype.getDivisionAbbr = function () {
                var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, this.products.mainProduct.divisionID);
                return div ? div.abbr : "";
            };
            TutoringCtrl.controllerId = 'TutoringCtrl';
            return TutoringCtrl;
        }(BaseViewCtrl));
        Controllers.TutoringCtrl = TutoringCtrl;
        Pulse.app.controller(TutoringCtrl.controllerId, [
            '$scope',
            '$route',
            'config',
            '$location',
            'common',
            'breezeService',
            'pulseContextService',
            'DrawerToggleService',
            TutoringCtrl,
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var RegFlowMgr = DataAccess.Managers.RegFlowMgr;
        var BaseViewCtrl = Pulse.Common.BaseViewCtrl;
        var ShoppingCartMgr = Pulse.Common.DataAccess.Managers.ShoppingCartMgr;
        var SessionAvailabilityStatus = Pulse.Common.Enums.SessionAvailabilityStatus;
        var scrollToElement = Pulse.Utils.scrollToElement;
        var DrawerStyle = Pulse.Controllers.DrawerStyle;
        var AvailChartFiltersCtrl = (function (_super) {
            __extends(AvailChartFiltersCtrl, _super);
            function AvailChartFiltersCtrl($scope, $route, $location, common, breezeService, pulseContext, chartFiltersMgr, filterPanelToggleService, drawerToggleService, chartExpanderStatuses) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AvailChartFiltersCtrl.controllerId) || this;
                _this.isFirstRender = true;
                _this.isPostCamp = false;
                _this._showCheckoutBar = null;
                _this._addingToCart = false;
                _this.drawerStyle = new DrawerStyle('');
                _this.lookupInfoMgr = _this.pulseContext.lookupInfoMgr;
                _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                _this.chartFiltersMgr = chartFiltersMgr;
                _this.filterPanelToggleService = filterPanelToggleService;
                _this.drawerToggleService = drawerToggleService;
                _this.chartExpanderStatuses = chartExpanderStatuses;
                _this.chartExpanderStatuses.resetAll();
                _this.filterPanelToggleService.resetVisibilityToDefault();
                _this.chartFiltersMgr.resetFiltersSyncState();
                _this.activationPromises.push(_this.regFlowMgr.handleFlow());
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.availChartMgr = _this.regFlowMgr.availChartMgr;
                _this.locationFinderMgr = _this.pulseContext.regFlowMgr.locationFinderMgr;
                _this.common.toggleSpinner(true, null, null, null, AvailChartFiltersCtrl.spinnerMessage);
                _this.locationFinderMgr.restoreState(true);
                _this.activationPromises.push(_this.locationFinderMgr.loadInfo()
                    .then(function (data) {
                    _this.catalogDateRanges = _this.locationFinderMgr.catalogDateRanges;
                    if (_this.locationFinderMgr.selectedItems.length) {
                        _this.currentLocation = _this.locationFinderMgr.selectedItems[0];
                    }
                    else if (_this.locationFinderMgr.selectedIds.length) {
                        return _this.locationFinderMgr.getLocation(_this.locationFinderMgr.selectedIds[0])
                            .then(function (location) {
                            return _this.currentLocation = location;
                        });
                    }
                    else {
                        _this.regFlowMgr.noAutoDispatch = false;
                        _this.locationFinderMgr.clearAllSelected();
                        _this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
                    }
                })
                    .then(function () {
                    if (_this.currentLocation) {
                        return _this.pulseContext.thresholdMgr.checkPostCampStatus(_this.currentLocation.iD)
                            .then(function (postCampInfo) {
                            if ((postCampInfo.campWideInfo
                                && postCampInfo.campWideInfo.startDate
                                && postCampInfo.campWideInfo.startDate <= _this.pulseContext.serverDateTime)
                                ||
                                    (postCampInfo.locationInfo
                                        && postCampInfo.locationInfo.startDate
                                        && postCampInfo.locationInfo.startDate <= _this.pulseContext.serverDateTime)) {
                                _this.isPostCamp = true;
                            }
                            return postCampInfo;
                        });
                    }
                }));
                _this.activationPromises.push(_this.userBrowsingMgr
                    .loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                    .then(function () {
                    return _this.userBrowsingMgr.setUserBrowsingResumeStep(Enums.RegFlowProgressStep.AvailChart2017);
                })
                    .then(function () {
                    if (_this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress) {
                        return _this.userBrowsingMgr.loadWaitlist(_this.userBrowsingMgr.currentUBSession, _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress, true);
                    }
                }));
                _this.availChartMgr.currencyTypeID = _this.userBrowsingMgr.getParticipantCurrencyType();
                _this.$scope.$on(Events.LoginSuccess, function () {
                    _this.common.toggleSpinner(true, null, null, 0);
                    _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                        .then(function () {
                        return _this.userBrowsingMgr
                            .loadWaitlist(_this.userBrowsingMgr.currentUBSession, _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress, true);
                    })
                        .then(function () {
                        return _this.loadChartData(false, true);
                    })
                        .then(function () {
                        _this.userBrowsingMgr.sendCartToMailChimp(_this.userBrowsingMgr.currentUBSession);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                });
                _this.$scope.$on(Events.AvChartApplyFilters, function () { return _this.loadChartData(true); });
                _this.$scope.$on(Events.AvChartAddWaitlist, function () { return _this.loadChartData(false, true); });
                _this.$scope.$on(Events.ProductAddedToCart, function (event, mainProduct) {
                    _this.addProductToCart(mainProduct);
                });
                _this.$scope.$on(Events.AvChartProcessSessionClickEvent, function (event, element, division, course, session) {
                    event.stopPropagation();
                    _this.processSessionClickEvent(element, division, course, session);
                });
                var lastRoute = $route.current;
                var lastLocations = _this.locationFinderMgr.savedSelection;
                var lastCampAtHQVal = _this.getCampAtHQVal();
                _this.$scope.$on('$locationChangeSuccess', function () {
                    if (lastRoute.templateUrl === $route.current.templateUrl
                        && Pulse.Utils.JS.areArraysEqual(lastLocations, _this.locationFinderMgr.savedSelection)
                        && lastCampAtHQVal === _this.getCampAtHQVal()) {
                        $route.current = lastRoute;
                    }
                });
                _this.activateController();
                return _this;
            }
            Object.defineProperty(AvailChartFiltersCtrl.prototype, "currentLocation", {
                get: function () {
                    return this._currentLocation;
                },
                set: function (location) {
                    if (location.locationAvailabilityStatusAttrID != Enums.LocationAvailabilityTypeAttr.Open) {
                        window.location.href = this.common.config.WWW_UrlRoot + '/' + location.uRL;
                    }
                    this._currentLocation = location;
                },
                enumerable: false,
                configurable: true
            });
            AvailChartFiltersCtrl.prototype.onRenderFinish = function () {
                if (this.isFirstRender) {
                    var isVirtualLocation = this.currentLocation && (this.currentLocation.locTypeID === Enums.LocationType.VirtualSummerCamp || this.currentLocation.locTypeID === Enums.LocationType.VirtualSquads);
                    if (!this.isPostCamp && !isVirtualLocation) {
                        var selector = void 0;
                        var scrollOffset = 0;
                        if (this.courseId) {
                            selector = '.term-division-accordion:first-of-type .targeted-course';
                            scrollOffset = 40;
                        }
                        else {
                            selector = '.avc-view-container .page-title';
                        }
                        scrollToElement(angular.element(selector), scrollOffset, 200);
                    }
                    this.isFirstRender = false;
                }
                this.common.toggleSpinner(false, true);
            };
            Object.defineProperty(AvailChartFiltersCtrl.prototype, "showLeftFiltersPanel", {
                get: function () {
                    return this.filterPanelToggleService.isVisible;
                },
                enumerable: false,
                configurable: true
            });
            AvailChartFiltersCtrl.prototype.checkout = function () {
                if (this.userBrowsingMgr.currentUBSession.UB_ItemDTOs && this.userBrowsingMgr.currentUBSession.UB_ItemDTOs.length > 0) {
                    this.regFlowMgr.nextStep();
                }
                else {
                    this.common.showWarning('Shopping cart is empty. Please select a course to proceed.');
                }
            };
            AvailChartFiltersCtrl.prototype.showCheckoutBar = function () {
                if (this._showCheckoutBar === null) {
                    this._showCheckoutBar = this.userBrowsingMgr.standaloneItemCount(this.userBrowsingMgr.currentUBSession) > 0;
                }
                return this._showCheckoutBar;
            };
            AvailChartFiltersCtrl.prototype.getCampAtHQVal = function () {
                var QS_CAMP_AT_HQ = this.common.$location.search()[QueryStringUtils.LOCATION_ATTR_CAMP_AT_HQ];
                return QS_CAMP_AT_HQ === 'true' || QS_CAMP_AT_HQ === true;
            };
            AvailChartFiltersCtrl.prototype.onActivated = function (resultSet) {
                var _this = this;
                this.common.toggleSpinner(true, null, null, 0, AvailChartFiltersCtrl.spinnerMessage);
                _super.prototype.onActivated.call(this, resultSet);
                this.chartFiltersMgr.syncWithStepManagers();
                if (this.currentLocation && this.currentLocation.iD > 0) {
                    this.loadChartData(true, true)
                        .then(function () {
                        _this.common.toggleSpinner(false, true);
                        _this.selectDivisionByQSParam(_this.avcDataSet);
                        if (_this.avcDataSet.length === 1) {
                            _this.chartExpanderStatuses.termDivisionStatus.select(_this.avcDataSet[0]);
                        }
                        else if (!_this.avcDataSet.length) {
                            _this.onRenderFinish();
                        }
                    });
                }
            };
            AvailChartFiltersCtrl.prototype.onDestroy = function () {
                this.filterPanelToggleService.resetVisibilityToDefault();
                this.drawerToggleService.close();
            };
            AvailChartFiltersCtrl.prototype.setLocalizedTexts = function () {
                return _super.prototype.setLocalizedTexts.call(this);
            };
            AvailChartFiltersCtrl.prototype.addProductToCart = function (mainProduct) {
                var _this = this;
                this.common.toggleSpinner(true, true, null, 0);
                this._addingToCart = true;
                return this.userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, true)
                    .then(function () {
                    if (ShoppingCartMgr.IsChangeOrderCartTypeID(_this.pulseContext.shoppingCartType)) {
                        _this.checkout();
                        return;
                    }
                    else {
                        return _this.loadChartData(true, true)
                            .then(function () {
                            return _this.triggerFlowModal(mainProduct);
                        });
                    }
                })
                    .finally(function () {
                    _this._showCheckoutBar = _this.userBrowsingMgr.standaloneItemCount(_this.userBrowsingMgr.currentUBSession) > 0;
                    _this.common.toggleSpinner(false, true);
                });
            };
            AvailChartFiltersCtrl.prototype.triggerFlowModal = function (mainProduct) {
                if (this.pulseContext.isRunningInPartnerDomain) {
                    this.checkout();
                    return;
                }
                var initDataObj = {
                    mainProduct: mainProduct,
                    multiCourseDiscAmount: 100,
                    parentCtlr: this,
                    siblingDiscAmount: 100,
                    shoppingCartHasCampAtHqProduct: this.userBrowsingMgr.hasCampAtHQItems(this.userBrowsingMgr.currentUBSession),
                };
                this.courseAddedPopupAPI.open(Pulse.Common.BasePopup.ModalSize.Medium, initDataObj);
                return this.common.$timeout();
            };
            AvailChartFiltersCtrl.prototype.processSessionClickEvent = function (element, division, course, session) {
                var _this = this;
                if (session.statusOptions.hasUserInteraction) {
                    if (session.statusOptions.id === SessionAvailabilityStatus.CallUs) {
                        this.showCallUsPopup();
                    }
                    else {
                        this.common.toggleSpinner(true, null, null, null, AvailChartFiltersCtrl.spinnerMessage);
                        this.drawerToggleService.toggleDrawer(division, course, session)
                            .then(function () {
                            return _this.common.$timeout(function () {
                                var offset = _this.common.isMobileView ? -20 : 20;
                                scrollToElement(element, offset, 1000);
                            });
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    }
                }
            };
            AvailChartFiltersCtrl.prototype.showCallUsPopup = function () {
                var message = " Call us to check availability. " + this.pulseContext.companyTollFreePhone;
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Call Us', message, null);
            };
            AvailChartFiltersCtrl.prototype.loadChartData = function (closeDrawer, forceRepaint) {
                var _this = this;
                if (closeDrawer === void 0) { closeDrawer = false; }
                if (forceRepaint === void 0) { forceRepaint = false; }
                var msg = this._addingToCart ? '' : AvailChartFiltersCtrl.spinnerMessage;
                this.common.toggleSpinner(true, null, null, 0, msg);
                this._addingToCart = false;
                if (closeDrawer) {
                    this.drawerToggleService.close();
                }
                return this.availChartMgr.getAvChartData([this.currentLocation.iD], forceRepaint)
                    .then(function (chartDataSet) {
                    _this.avcDataSet = chartDataSet;
                    _this.drawerStyle = new DrawerStyle(_this.$location.search().template, false, false);
                    var sessionList = [];
                    chartDataSet.forEach(function (chart) {
                        sessionList = __spreadArrays(sessionList, chart.sessions);
                    });
                    sessionList.sort(function (a, b) { return (a.sessID > b.sessID) ? 1 : -1; });
                    _this.drawerToggleService.sessionPaymentOptionList = sessionList;
                    return _this.avcDataSet;
                })
                    .finally(function () {
                    _this._showCheckoutBar = _this.userBrowsingMgr.standaloneItemCount(_this.userBrowsingMgr.currentUBSession) > 0;
                    _this.common.toggleSpinner(false);
                });
            };
            AvailChartFiltersCtrl.prototype.selectDivisionByQSParam = function (chartDataSet) {
                var termDiv;
                if (chartDataSet.length === 1) {
                    termDiv = chartDataSet[0];
                }
                else if (this.courseId || this.divisionId) {
                    var divIndex = this.getDivisionIndex(chartDataSet);
                    termDiv = chartDataSet[divIndex];
                    if (divIndex > 0)
                        this.unshiftElementByIndex(chartDataSet, divIndex);
                }
                if (termDiv)
                    this.chartExpanderStatuses.termDivisionStatus.select(termDiv);
                return chartDataSet;
            };
            AvailChartFiltersCtrl.prototype.getDivisionIndex = function (chartDataSet) {
                var callback;
                var id;
                if (this.courseId) {
                    callback = function (a, b) {
                        return a.courses.filter(function (course) { return course.prodID === b; }).length === 1;
                    };
                    id = this.courseId;
                }
                else if (this.divisionId) {
                    callback = function (a, b) { return a.divID === b; };
                    id = this.divisionId;
                }
                return this.getPositionInArray(chartDataSet, id, callback);
            };
            AvailChartFiltersCtrl.prototype.unshiftElementByIndex = function (arr, index) {
                var el = arr
                    .splice(index, 1)
                    .shift();
                arr.unshift(el);
                return el;
            };
            AvailChartFiltersCtrl.prototype.getPositionInArray = function (arr, comparedValue, condCallback) {
                var index = -1;
                for (var i = 0; i < arr.length; i++) {
                    if (condCallback(arr[i], comparedValue)) {
                        index = i;
                        break;
                    }
                }
                return index;
            };
            Object.defineProperty(AvailChartFiltersCtrl.prototype, "courseId", {
                get: function () {
                    if (this._courseId === undefined) {
                        this._courseId = this.getParamAsNumber(QueryStringUtils.PRODUCT_ID);
                    }
                    return this._courseId;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(AvailChartFiltersCtrl.prototype, "catalogDateRangeId", {
                get: function () {
                    if (this._catalogDateRangeId === undefined) {
                        this._catalogDateRangeId = this.getParamAsNumber(QueryStringUtils.CATALOG_DATE_RANGE_ID);
                    }
                    return this._catalogDateRangeId;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(AvailChartFiltersCtrl.prototype, "divisionId", {
                get: function () {
                    if (this._divisionId === undefined) {
                        this._divisionId = this.getParamAsNumber(QueryStringUtils.DIVISION_ID);
                    }
                    return this._divisionId;
                },
                enumerable: false,
                configurable: true
            });
            AvailChartFiltersCtrl.prototype.getParamAsNumber = function (qsParamName) {
                var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                if (Array.isArray(param)) {
                    param = param[0];
                }
                return typeof param === 'string' ? parseInt(param, 10) : param;
            };
            AvailChartFiltersCtrl.controllerId = 'AvailChartFiltersCtrl';
            AvailChartFiltersCtrl.spinnerMessage = 'Courses fill fast. Finding current availability...';
            return AvailChartFiltersCtrl;
        }(BaseViewCtrl));
        Controllers.AvailChartFiltersCtrl = AvailChartFiltersCtrl;
        Pulse.app.controller(AvailChartFiltersCtrl.controllerId, [
            '$scope',
            '$route',
            '$location',
            'common',
            'breezeService',
            'pulseContextService',
            'chartFilterMgr',
            'FilterPanelToggleService',
            'DrawerToggleService',
            'AvcExpandersService',
            AvailChartFiltersCtrl,
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var RegFlowMgr = DataAccess.Managers.RegFlowMgr;
        var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
        var ShoppingCartCtrl = (function (_super) {
            __extends(ShoppingCartCtrl, _super);
            function ShoppingCartCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ShoppingCartCtrl.controllerId) || this;
                _this.cart = null;
                _this.isCartEmpty = false;
                _this.isCartRetrieved = false;
                _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                _this._isChangeOrderCart = null;
                _this.formName = "frmShoppingCart";
                _this.checkUnsavedDataBeforeNav = false;
                _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                _this.shoppingCartMgr = _this.regFlowMgr.shoppingCartMgr;
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this._shoppingCartRetrieved = $scope.$on(Events.ShoppingCartRetrieved, function (event, isCartEmpty) {
                    _this.isCartRetrieved = true;
                    _this.isCartEmpty = isCartEmpty;
                });
                $scope.$on('$destroy', function () {
                    _this._shoppingCartRetrieved();
                });
                _this._addCourseHandler = $scope.$on(Events.ShoppingCartAddCourseRequest, function (event, participant) {
                    _this.onAddCourse(participant);
                });
                $scope.$on('$destroy', function () {
                    _this._addCourseHandler();
                });
                _this._shoppingCartValidated = $scope.$on(Events.RegFlowShoppingCartValidated, function (event, checkOutPending, isOrderSummaryNecessary) {
                    _this.onShoppingCartValidated(checkOutPending, isOrderSummaryNecessary);
                });
                $scope.$on('$destroy', function () {
                    _this._shoppingCartValidated();
                });
                _this._allStudentsSaved = $scope.$on(Events.AllStudentsInfoSaved, function (event) {
                    _this.onAllStudentsSaved();
                });
                $scope.$on('$destroy', function () {
                    _this._allStudentsSaved();
                });
                _this.activationPromises.push(_this.userBrowsingMgr.actionOnUserBrowsingRecordStatus(function () {
                    return common.$timeout(1)
                        .then(function () { return _this.loadShoppingCart(); });
                }, function (confirmedMerge) {
                    return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                        .then(function () {
                        return _this.loadShoppingCart();
                    });
                }, function (startNewCart) {
                    return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                        .then(function () {
                        return _this.loadShoppingCart();
                    });
                }, true)
                    .then(function () {
                    return _this.userBrowsingMgr.setUserBrowsingResumeStep(Enums.RegFlowProgressStep.ShoppingCart2017);
                }));
                _this.activateController();
                return _this;
            }
            ShoppingCartCtrl.prototype.loadShoppingCart = function () {
                var _this = this;
                var customerAccount = Pulse.Utils.QueryStringUtils
                    .GetParamByName(window.location.href.toLowerCase(), 'ca');
                var studentAccount = Pulse.Utils.QueryStringUtils
                    .GetParamByName(window.location.href.toLowerCase(), 'sa');
                var spid = Pulse.Utils.QueryStringUtils
                    .GetParamByName(window.location.href.toLowerCase(), 'spid');
                if (customerAccount && studentAccount && Number(spid)
                    && (!this.cart || (this.cart && ShoppingCartMgr.IsStudentAndSpdIdInCart(this.cart, studentAccount, Number(spid)) == false))) {
                    return this.shoppingCartMgr.addCustomerStudentProduct(this.pulseContext.browseIdentifier, customerAccount, studentAccount, Number(spid))
                        .then(function (wasAdded) {
                        return _this.cartCtrlAPI.loadShoppingCart(true);
                    });
                }
                else {
                    return this.cartCtrlAPI.loadShoppingCart(true)
                        .then(function (cart) {
                        return _this.cartCtrlAPI.addProductsFromQueryString()
                            .then(function (wereProductsAdded) {
                            if (wereProductsAdded) {
                                return _this.cartCtrlAPI.loadShoppingCart(true);
                            }
                        });
                    });
                }
            };
            ShoppingCartCtrl.prototype.onViewLoaded = function () {
                _super.prototype.onViewLoaded.call(this);
                var self = this;
                this.common.$timeout(function () {
                    self.myForm.$setPristine();
                }, 3000);
            };
            ShoppingCartCtrl.prototype.securityCheck = function () {
                if (this.pulseContext.isImpersonating) {
                    this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3);
                }
                else {
                    this.canSee = true;
                }
            };
            Object.defineProperty(ShoppingCartCtrl.prototype, "isChangeOrderCart", {
                get: function () {
                    if (this._isChangeOrderCart !== null) {
                        return this._isChangeOrderCart;
                    }
                    if (this.cart) {
                        this._isChangeOrderCart = ShoppingCartMgr.IsChangeOrderCart(this.cart);
                    }
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            ShoppingCartCtrl.prototype.cancelCart = function () {
                var _this = this;
                this.common.toggleSpinner(true);
                this.shoppingCartMgr.cancelShoppingCart();
                this.userBrowsingMgr.removeUserBrowsingSession(this.userBrowsingMgr.currentUBSession)
                    .then(function () {
                    _this.pulseContext.regFlowMgr.userBrowsingMgr.removeParticipantCurrencyType();
                    _this.pulseContext.regFlowMgr = null;
                    _this.$location.url(Routes.MyAccount);
                }).finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            ShoppingCartCtrl.prototype.onShoppingCartValidated = function (checkOutPending, isOrderSummaryNecessary) {
                var self = this;
                this.common.$timeout(function () {
                    self.myForm.$submitted = false;
                    self.myForm.$setPristine();
                }, 0);
                if (!checkOutPending) {
                }
                else if (!this.isChangeOrderCart && this.common.config.skipRegFlow_OPL_Upsell !== true) {
                    this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Upsell);
                    this.scrollToTop();
                }
                else if (isOrderSummaryNecessary) {
                    this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.OrderSummary);
                }
                else {
                    this.$location.url(Routes.RegFlow_Billing);
                }
            };
            ShoppingCartCtrl.prototype.onAddCourse = function (participant) {
                var _this = this;
                if (this.myForm.$dirty) {
                    this.common.toggleSpinner(true, null, null, 0);
                    var students = this.userBrowsingMgr.bundleStudentsInfoForSave(this.cart.participants);
                    var self = this;
                    this.userBrowsingMgr.updateStudents(students)
                        .then(function (students) {
                        self.onAllStudentsSaved();
                        if (_this.pulseContext.inWWW) {
                            window.location.assign(_this.common.config.WWW_UrlRoot + '/courses');
                        }
                        else {
                            if (ShoppingCartMgr.HasCampAtHqLocation(_this.cart)) {
                                var ids = ShoppingCartMgr.GetCampAtHqLocationIds(_this.cart);
                                var additionalParams = {};
                                additionalParams[QueryStringUtils.LOCATION_ID] = ids[0];
                                _this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart, true, undefined, undefined, true, additionalParams);
                            }
                            else {
                                var noAutoDispatch = !!(_this.regFlowMgr.locationFinderMgr.selectedIds && _this.regFlowMgr.locationFinderMgr.selectedIds.length);
                                _this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart, noAutoDispatch);
                            }
                        }
                    })
                        .catch(function (error) {
                        self.logError(error);
                    })
                        .finally(function () {
                        self.common.toggleSpinner(false);
                    });
                }
                else {
                    this.checkUnsavedDataBeforeNav = false;
                    if (this.pulseContext.inWWW) {
                        window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                    }
                    else {
                        if (ShoppingCartMgr.HasCampAtHqLocation(this.cart)) {
                            var ids = ShoppingCartMgr.GetCampAtHqLocationIds(this.cart);
                            var additionalParams = {};
                            additionalParams[QueryStringUtils.LOCATION_ID] = ids[0];
                            this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart, true, undefined, undefined, true, additionalParams);
                        }
                        else {
                            var noAutoDispatch = !!(this.regFlowMgr.locationFinderMgr.selectedIds && this.regFlowMgr.locationFinderMgr.selectedIds.length);
                            this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart, noAutoDispatch);
                        }
                    }
                }
            };
            ShoppingCartCtrl.prototype.onAllStudentsSaved = function () {
                this.myForm.$submitted = false;
                this.myForm.$setPristine();
            };
            ShoppingCartCtrl.prototype.addCourseWhenNoneInCart = function () {
                this.checkUnsavedDataBeforeNav = false;
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                }
                else {
                    this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
                }
            };
            ShoppingCartCtrl.controllerId = "shoppingCartCtrl";
            return ShoppingCartCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ShoppingCartCtrl = ShoppingCartCtrl;
        Pulse.app.controller(ShoppingCartCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            ShoppingCartCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var RegFlowMgr = Pulse.Common.DataAccess.Managers.RegFlowMgr;
        var ShoppingCartMgr = Pulse.Common.DataAccess.Managers.ShoppingCartMgr;
        var ModalSize = Pulse.Common.BasePopup.ModalSize;
        var UpsellCtrl = (function (_super) {
            __extends(UpsellCtrl, _super);
            function UpsellCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this_1 = _super.call(this, $scope, $location, common, breezeService, pulseContext, UpsellCtrl.controllerId) || this;
                _this_1._cart = null;
                _this_1._customTutorProductNames = null;
                _this_1._loggedInOnContinue = false;
                _this_1._upsellProducts = null;
                _this_1._relatedUsers = null;
                _this_1._userAccountWasCreated = false;
                _this_1._tempUserBrowsingID = -1;
                _this_1.areParticipantsBuilt = false;
                _this_1.isCartEmpty = false;
                _this_1.isDiscountUiVisible = false;
                _this_1.frmUpsell = null;
                _this_1.showLoginPopupCloseIcon = false;
                _this_1.participants = null;
                _this_1.priceForOneHour = 0;
                _this_1.continue = _this_1.continue.bind(_this_1);
                _this_1.mergeCartAndRetrieveData = _this_1.mergeCartAndRetrieveData.bind(_this_1);
                _this_1.onLoginSuccess = _this_1.onLoginSuccess.bind(_this_1);
                if (_this_1.isReloadingForDiscountUi) {
                    _this_1.isReloadingForDiscountUi = false;
                    _this_1.isDiscountUiVisible = true;
                }
                _this_1.formName = 'frmUpsell';
                _this_1.checkUnsavedDataBeforeNav = false;
                _this_1.userBrowsingMgr = _this_1.pulseContext.regFlowMgr.userBrowsingMgr;
                _this_1.userMgr = _this_1.pulseContext.userMgr;
                _this_1._onForcePasswordChangeOff = _this_1.$scope.$on(Events.ForcePasswordChange, function (evt, user, oldPassword) {
                    window.location.reload();
                });
                _this_1._addParticipantHandler = $scope.$on('Upsell_AddParticipant', function (event, userBrowsingID) {
                    _this_1.addParticipant();
                });
                $scope.$on('$destroy', function () {
                    _this_1._addParticipantHandler();
                    _this_1._onForcePasswordChangeOff();
                });
                _this_1._removeParticipantHandler = $scope.$on('Upsell_RemoveParticipant', function (event, userBrowsingID) {
                    _this_1.onRemoveParticipant(userBrowsingID);
                });
                $scope.$on('$destroy', function () {
                    _this_1._removeParticipantHandler();
                });
                _this_1._cartChangeHandler = $scope.$on(Events.ShoppingCartChanged, function (event, cart) {
                    _this_1.onCartChange(cart);
                });
                $scope.$on('$destroy', function () {
                    _this_1._cartChangeHandler();
                });
                _this_1._loginSuccessHandler = $scope.$on(Events.LoginSuccess, function (event, participant) {
                    _this_1.onLoginSuccess();
                });
                $scope.$on('$destroy', function () {
                    _this_1._loginSuccessHandler();
                });
                _this_1._createAccountSuccessHandler = $scope.$on(Events.PublicUserAccountCreated, function (e, args) {
                    _this_1._userAccountWasCreated = true;
                    _this_1.common.showSuccess("You account has been created and you have been logged in. Your username is " + args.userName, { preventDuplicates: true });
                });
                $scope.$on('$destroy', function () {
                    _this_1._createAccountSuccessHandler();
                });
                _this_1.activationPromises.push(_this_1.mergeCartAndRetrieveData(true, true));
                _this_1.activateController();
                return _this_1;
            }
            Object.defineProperty(UpsellCtrl.prototype, "areNewStudentsUnique", {
                get: function () {
                    for (var i = 0, j = this.participants.length; i < j; i++) {
                        var p1 = this.participants[i];
                        if (p1.userBrowsingID < 0 && p1.userID === 0) {
                            for (var m = 0, n = this.participants.length; m < n; m++) {
                                var p2 = this.participants[m];
                                if (p1 !== p2
                                    && p1.firstName.trim()
                                        .toUpperCase() === p2.firstName.trim()
                                        .toUpperCase()
                                    && p1.lastName.trim()
                                        .toUpperCase() === p2.lastName.trim()
                                        .toUpperCase()) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(UpsellCtrl.prototype, "canContinue", {
                get: function () {
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(UpsellCtrl.prototype, "cart", {
                get: function () {
                    return this._cart;
                },
                set: function (c) {
                    this._cart = c;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(UpsellCtrl.prototype, "checkmarkUrl", {
                get: function () {
                    return this.common.config.appRoot + 'assets/images/reg-flow/check.svg';
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(UpsellCtrl.prototype, "upsellImageUrl", {
                get: function () {
                    return this.common.config.appRoot + 'assets/images/reg-flow/OPL.jpg';
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(UpsellCtrl.prototype, "doesCartHaveAtLeastOneCourse", {
                get: function () {
                    if (!this.cart) {
                        return false;
                    }
                    else {
                        return ShoppingCartMgr.DoesCartHaveAtLeastOneCourse(this.cart);
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(UpsellCtrl.prototype, "doesCartHaveAtLeastOneNonTutorProduct", {
                get: function () {
                    if (!this.cart) {
                        return false;
                    }
                    else {
                        return ShoppingCartMgr.DoesCartHaveAtLeastOneNonTutorProduct(this.cart);
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(UpsellCtrl.prototype, "hasAtLeastOneExistingParticipant", {
                get: function () {
                    if (!this.cart) {
                        return false;
                    }
                    else {
                        if (!this.cart.participants) {
                            return false;
                        }
                        else {
                            return this.cart.participants.length > 0;
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            UpsellCtrl.prototype.isAnUpsellProductSelected = function () {
                for (var i = 0, il = this.participants.length; i < il; ++i) {
                    var participant = this.participants[i];
                    if (participant.selectedProducts) {
                        var selectedProductIDs = participant.selectedProducts.map(function (f) { return f.productID; });
                        if (selectedProductIDs && selectedProductIDs.length > 0 && !participant.showEditControls) {
                            return true;
                        }
                    }
                }
                return false;
            };
            UpsellCtrl.prototype.isContinueDisabled = function () {
                if (this.isDiscountUiVisible) {
                    return false;
                }
                else {
                    return !this.cart || !this.participants
                        ? true
                        : !this.isAnUpsellProductSelected();
                }
            };
            Object.defineProperty(UpsellCtrl.prototype, "isReloadingForDiscountUi", {
                get: function () {
                    var isTrueSet = (window.sessionStorage.getItem("reloadingForDiscountUi") === 'true');
                    return isTrueSet;
                },
                set: function (b) {
                    sessionStorage.setItem("reloadingForDiscountUi", b + '');
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(UpsellCtrl.prototype, "upsellProducts", {
                get: function () {
                    return this._upsellProducts;
                },
                set: function (products) {
                    this._upsellProducts = products;
                    if (this._upsellProducts) {
                        for (var i = 0, j = this._upsellProducts.length; i < j; i += 1) {
                            var p = this._upsellProducts[i];
                            if (p.quantity == 1) {
                                this.priceForOneHour = p.price;
                                break;
                            }
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            UpsellCtrl.prototype.addDiscountCodeFromUrl = function () {
                var _this_1 = this;
                var dc = this.getDiscountCodeOnUrl();
                if (!dc) {
                    this.gotoNextPage();
                    return null;
                }
                var arr = Pulse.Utils.JS.findByProperties(this.cart.discounts, { 'discountOrCouponCode': dc.trim() }, true);
                if (arr != null && arr.length > 0) {
                    this.gotoNextPage();
                    return null;
                }
                this.common.toggleSpinner(true, null, null, 0);
                var _self = this;
                return this.pulseContext.regFlowMgr.shoppingCartMgr.addDiscountCode(this.cart, dc, '')
                    .then(function (updatedCart) {
                    _self.cart = updatedCart;
                    var arr = Pulse.Utils.JS.findByProperties(_self.cart.discounts, { 'discountOrCouponCode': dc.trim() }, true);
                    if (arr == null || arr.length == 0) {
                        var msg = null;
                        if (dc.trim().toLowerCase().indexOf('discovery') >= 0) {
                            msg = "The savings can not be applied, as a promo code or discount has already been used by one or more students. If you are trying to purchase a Discovery Lesson, you will now see the full price of $75 reflected in your shopping cart.";
                        }
                        else {
                            msg = "A discount code could not be applied, this may be due to one or more students having used the discount code already.";
                        }
                        _this_1.common.showMessagePopup("Please note...", " " + msg, function () { _this_1.gotoNextPage(); });
                    }
                    else {
                        _this_1.gotoNextPage();
                    }
                })
                    .catch(function (err) {
                    if (err && err.data && err.data.modelState && err.data.modelState.showToUserWarning) {
                        var msg = "An unexpected error occurred when applying a discount code.";
                        _this_1.common.showMessagePopup("Please note...", " " + msg, function () { _this_1.gotoNextPage(); });
                    }
                    else {
                        _self.logError(err);
                    }
                })
                    .finally(function () {
                    _self.common.toggleSpinner(false);
                });
            };
            UpsellCtrl.prototype.addParticipant = function () {
                if (this.myForm) {
                    this.myForm.$setPristine();
                }
                var newParticipant = {
                    parent: this.cart,
                    userBrowsingID: this._tempUserBrowsingID--,
                    userID: 0,
                    userRelationTypeID: Enums.UserRelationshipType.ParentGuardian,
                    firstName: null,
                    lastName: null,
                    dateOfBirth: null,
                    showEditControls: true,
                    myForm: this.myForm,
                    items: [],
                };
                this.participants.push(newParticipant);
            };
            UpsellCtrl.prototype.continue = function () {
                var _this_1 = this;
                if (this.isDiscountUiVisible) {
                    this.gotoNextPage();
                }
                else {
                    if (this.myForm.$valid) {
                        this.checkUnsavedDataBeforeNav = false;
                        if (this.isAnUpsellProductSelected()) {
                            if (this.areNewStudentsUnique) {
                                if (!this.pulseContext.isLoggedIn) {
                                    this._loggedInOnContinue = true;
                                    window.setTimeout(function () {
                                        _this_1.userBrowsingMgr.loadInfo(_this_1.userBrowsingMgr.currentUBSession, true, false)
                                            .then(function () {
                                            _this_1.$scope.$broadcast(Events.ShowLoginPopup, {
                                                size: ModalSize.Medium,
                                                initDataObj: {
                                                    isCreateAccountMode: true,
                                                    goBackOnCloseOfDialogByUser: false,
                                                }
                                            });
                                        });
                                    }, 0);
                                    return;
                                }
                                this.common.toggleSpinner(true, null, null, 0);
                                var errorOccured_1 = false;
                                this.pulseContext.regFlowMgr.shoppingCartMgr.customTutorProductNames = this._customTutorProductNames;
                                var userBrowsingMgr_1 = this.pulseContext.regFlowMgr.userBrowsingMgr;
                                return userBrowsingMgr_1.loadInfo(userBrowsingMgr_1.currentUBSession, true, false)
                                    .then(function () { return __awaiter(_this_1, void 0, void 0, function () {
                                    var promises, i, j, promise, participant, k, item, productIDs, k, item;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                promises = [];
                                                i = 0, j = this.participants.length;
                                                _a.label = 1;
                                            case 1:
                                                if (!(i < j)) return [3, 12];
                                                promise = null;
                                                participant = this.participants[i];
                                                if (participant.parent) {
                                                    participant.parent.userBrowsingID = userBrowsingMgr_1.currentUBSession.userBrowsingID;
                                                }
                                                if (!(participant.selectedProducts && participant.selectedProducts.length > 0)) return [3, 9];
                                                if (!this.hasChangedProductSelection(participant)) return [3, 8];
                                                promises = [];
                                                for (k = 0; k < participant.items.length; k++) {
                                                    item = participant.items[k];
                                                    if (item.isSelected
                                                        && item.productCategoryTypeID == Enums.ProductCategoryType.Tutor
                                                        && (item.visibilityTypeID == Enums.ProductVisibilityType.PulseRegUpsell
                                                            || item.visibilityTypeID == Enums.ProductVisibilityType.PulseRegUpsellInternalOnly)
                                                        && this.isItemIncludedInUpsellProducts(item)) {
                                                        promise = this.pulseContext.regFlowMgr.shoppingCartMgr.removeItemFromParticipant(participant.parent, participant.userBrowsingID, item.userBrowsingItemID);
                                                        promises.push(promise);
                                                    }
                                                }
                                                return [4, Promise.all(promises)];
                                            case 2:
                                                _a.sent();
                                                productIDs = participant.selectedProducts.map(function (p) { return p.productID; });
                                                if (!(participant.userBrowsingID < 0 && participant.userID == 0)) return [3, 4];
                                                return [4, this.pulseContext.regFlowMgr.shoppingCartMgr.addNewUserAndTutorProductsToCart(participant.parent, participant.firstName, participant.lastName, participant.genderTypeID, participant.dateOfBirth, productIDs)];
                                            case 3:
                                                _a.sent();
                                                return [3, 8];
                                            case 4:
                                                if (!(participant.userBrowsingID < 0)) return [3, 6];
                                                return [4, this.pulseContext.regFlowMgr.shoppingCartMgr.addExistingUserAndTutorProductsToCart(participant.parent, participant.userID, productIDs)];
                                            case 5:
                                                _a.sent();
                                                return [3, 8];
                                            case 6: return [4, this.pulseContext.regFlowMgr.shoppingCartMgr.addTutorProductsToParticipant(participant.parent, participant.userBrowsingID, productIDs)];
                                            case 7:
                                                _a.sent();
                                                _a.label = 8;
                                            case 8: return [3, 11];
                                            case 9:
                                                promises = [];
                                                for (k = 0; k < participant.items.length; k++) {
                                                    item = participant.items[k];
                                                    if (item.isSelected
                                                        && item.productCategoryTypeID == Enums.ProductCategoryType.Tutor
                                                        && (item.visibilityTypeID == Enums.ProductVisibilityType.PulseRegUpsell
                                                            || item.visibilityTypeID == Enums.ProductVisibilityType.PulseRegUpsellInternalOnly)
                                                        && this.isItemIncludedInUpsellProducts(item)) {
                                                        promise = this.pulseContext.regFlowMgr.shoppingCartMgr.removeItemFromParticipant(participant.parent, participant.userBrowsingID, item.userBrowsingItemID);
                                                        promises.push(promise);
                                                    }
                                                }
                                                return [4, Promise.all(promises)];
                                            case 10:
                                                _a.sent();
                                                _a.label = 11;
                                            case 11:
                                                i++;
                                                return [3, 1];
                                            case 12: return [2, null];
                                        }
                                    });
                                }); })
                                    .catch(function (err) {
                                    errorOccured_1 = true;
                                    _this_1.logError(err);
                                })
                                    .finally(function () {
                                    if (!errorOccured_1) {
                                        _this_1.userBrowsingMgr.loadInfo(_this_1.userBrowsingMgr.currentUBSession, true, false)
                                            .then(function () {
                                            return _this_1.common.$q.resolve(_this_1.pulseContext.regFlowMgr.shoppingCartMgr.getShoppingCart(_this_1.pulseContext.browseIdentifier, _this_1.pulseContext.shoppingCartType, _this_1.pulseContext.selectedCurrencyTypeID, true));
                                        })
                                            .then(function (cart) {
                                            _this_1.cart = cart;
                                            var dc = _this_1.getDiscountCodeOnUrl();
                                            if (dc) {
                                                return _this_1.addDiscountCodeFromUrl();
                                            }
                                            else {
                                                _this_1.isDiscountUiVisible = true;
                                                _this_1.isReloadingForDiscountUi = true;
                                                window.history.pushState({ id: Math.floor(Math.random() * 100000) }, '', window.location.href);
                                            }
                                        })
                                            .finally(function () {
                                            _this_1.common.toggleSpinner(false, true);
                                        });
                                    }
                                    else {
                                        _this_1.mergeCartAndRetrieveData(true, true)
                                            .finally(function () {
                                            _this_1.common.toggleSpinner(false, true);
                                        });
                                    }
                                });
                            }
                            else {
                                this.common.showWarning('One or more of the new students you have added have the same'
                                    + ' first and last name as an existing student, please remove the duplicate student(s).', { timeOut: 8000 });
                            }
                        }
                        else {
                            this.common.showWarning('Please select a lesson for one or more students.');
                        }
                    }
                    else {
                        if (this.myForm.$error) {
                            var err = '';
                            if (this.myForm.$error.idpDateBetweenValidator) {
                                err = 'The following students do not match the age requirement of their lesson. Please deselect their lesson to continue:<br/>';
                                for (var i = 0, il = this.myForm.$error.idpDateBetweenValidator.length; i < il; ++i) {
                                    var p = this.myForm.$error.idpDateBetweenValidator[i];
                                    err += p.firstName.$modelValue + ' ' + p.lastName.$modelValue + '</br>';
                                }
                                this.common.showWarning(err, { timeOut: 12000 });
                            }
                        }
                        var isEditing = (this.participants.filter(function (p) {
                            return p.showEditControls;
                        }).length > 0);
                        if (isEditing) {
                            this.common.showWarning('Before proceeding, please complete adding another student or use the remove link to remove her/him.');
                        }
                    }
                }
            };
            UpsellCtrl.prototype.createParticipantsArray = function (resetExistingParticipants) {
                if (resetExistingParticipants === void 0) { resetExistingParticipants = true; }
                var i, j, m, n, o;
                if (!this.cart) {
                    throw new Error('Shopping cart must be retrieved before createParticipantsArray can be called.');
                }
                if (this.participants) {
                    for (i = 0, j = this.participants.length; i < j; ++i) {
                        if (this.participants[i].showEditControls && this.participants[i].userBrowsingID < 0) {
                            this.participants.splice(i, 1);
                        }
                    }
                }
                if (resetExistingParticipants) {
                    this.participants = [];
                }
                if (this.cart) {
                    for (i = 0, j = this.cart.participants.length; i < j; ++i) {
                        var participant = this.cart.participants[i];
                        participant.showEditControls = false;
                        participant.selectedProducts = [];
                        participant.originalSelectedProductIDs = [];
                        for (o = 0; o < participant.items.length; o++) {
                            var item = participant.items[o];
                            if (item.isSelected
                                && item.productCategoryTypeID == Enums.ProductCategoryType.Tutor
                                && (item.visibilityTypeID == Enums.ProductVisibilityType.PulseRegUpsell
                                    || item.visibilityTypeID == Enums.ProductVisibilityType.PulseRegUpsellInternalOnly)) {
                                participant.originalSelectedProductIDs.push(item.productID);
                            }
                        }
                        this.participants.push(participant);
                    }
                }
                if (this._relatedUsers) {
                    for (i = 0, j = this._relatedUsers.length; i < j; ++i) {
                        var user = this._relatedUsers[i];
                        var found = false;
                        for (m = 0, n = this.participants.length; m < n; ++m) {
                            var participant = this.participants[m];
                            if (participant.userID == user.userID) {
                                found = true;
                            }
                        }
                        if (!found) {
                            var newParticipant = {};
                            newParticipant.parent = this.cart;
                            newParticipant.userBrowsingID = this._tempUserBrowsingID--;
                            newParticipant.userID = user.userID;
                            newParticipant.userRelationTypeID = user.userRelationTypeID;
                            newParticipant.firstName = user.firstName;
                            newParticipant.lastName = user.lastName;
                            newParticipant.dateOfBirth = user.dateOfBirth;
                            newParticipant.genderTypeID = user.genderTypeID;
                            newParticipant.showEditControls = false;
                            newParticipant.myForm = this.myForm;
                            newParticipant.items = [];
                            this.participants.push(newParticipant);
                        }
                    }
                }
                this.participants.sort(function (a, b) {
                    if (!a || !a.lastName || !a.firstName) {
                        return -1;
                    }
                    else if (!b || !b.lastName || !b.firstName) {
                        return 1;
                    }
                    else if (a.lastName.toUpperCase() < b.lastName.toUpperCase()) {
                        return -1;
                    }
                    else if (a.lastName.toUpperCase() == b.lastName.toUpperCase()) {
                        if (a.firstName.toUpperCase() < b.firstName.toUpperCase()) {
                            return -1;
                        }
                        else if (a.firstName.toUpperCase() == b.firstName.toUpperCase()) {
                            return 0;
                        }
                        else {
                            return 1;
                        }
                    }
                    else {
                        return 1;
                    }
                });
                if (this.participants.length == 0) {
                    this.addParticipant();
                }
                this.areParticipantsBuilt = true;
            };
            UpsellCtrl.prototype.getDiscountCodeOnUrl = function () {
                var dc = Pulse.Utils.QueryStringUtils.GetParamByName(window.location.href.toLowerCase(), 'dc');
                if (!dc || dc == '')
                    return null;
                else
                    return dc.trim();
            };
            UpsellCtrl.prototype.getTutorItemForParticipant = function (participant) {
                for (var j = 0; j < participant.items.length; j++) {
                    var item = participant.items[j];
                    if (item.isSelected
                        && item.productCategoryTypeID == Enums.ProductCategoryType.Tutor
                        && (item.visibilityTypeID == Enums.ProductVisibilityType.PulseRegUpsell
                            || item.visibilityTypeID == Enums.ProductVisibilityType.PulseRegUpsellInternalOnly)) {
                        return item;
                    }
                }
                return null;
            };
            UpsellCtrl.prototype.getUpsellProducts = function () {
                var loop = true;
                var idx = 1;
                var productIDs = '';
                var productAndTypeIDs = '';
                this._customTutorProductNames = [];
                this.pulseContext.regFlowMgr.shoppingCartMgr.customTutorProductNames = this._customTutorProductNames;
                while (loop && idx < 10) {
                    var v = Pulse.Utils.QueryStringUtils.GetParamByName(window.location.href.toLowerCase(), 'p' + idx);
                    if (v == undefined) {
                        loop = false;
                    }
                    else {
                        idx++;
                        var ar = v.split(",");
                        if (ar.length == 1) {
                            productIDs += v + ",";
                        }
                        else if (ar.length == 2) {
                            productAndTypeIDs += v + ",";
                            var p = {};
                            p.productID = parseInt(ar[0]);
                            p.productNameTypeID = parseInt(ar[1]);
                            this.pulseContext.regFlowMgr.shoppingCartMgr.customTutorProductNames.push(p);
                        }
                        else {
                            continue;
                        }
                    }
                }
                if (productAndTypeIDs !== '') {
                    this.isThemePack = true;
                    return this.pulseContext.regFlowMgr.getCustomUpsellProducts(productAndTypeIDs);
                }
                else {
                    this.isThemePack = (productIDs !== '');
                    return this.pulseContext.regFlowMgr.getCurrentUpsellProducts(productIDs);
                }
            };
            UpsellCtrl.prototype.gotoNextPage = function () {
                if (!this.pulseContext.selectedCurrencyTypeID) {
                    if (this.cart &&
                        this.cart.participants &&
                        this.cart.participants.length > 0 &&
                        this.cart.participants[0].items &&
                        this.cart.participants[0].items.length > 0) {
                        this.pulseContext.selectedCurrencyTypeID = this.cart.participants[0].items[0].currencyTypeID;
                    }
                }
                this.isDiscountUiVisible = false;
                this.pulseContext.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.OrderSummary);
            };
            UpsellCtrl.prototype.hasChangedProductSelection = function (participant) {
                if (!participant.originalSelectedProductIDs)
                    return true;
                var original = participant.originalSelectedProductIDs;
                var selected = participant.selectedProducts.map(function (f) { return f.productID; });
                return _.isEqual(original.sort(), selected.sort()) == false;
            };
            UpsellCtrl.prototype.isItemIncludedInUpsellProducts = function (item) {
                if (!this.upsellProducts)
                    return false;
                for (var i = 0, il = this.upsellProducts.length; i < il; i++) {
                    var p = this.upsellProducts[i];
                    if (p.productID == item.productID) {
                        return true;
                    }
                }
                return false;
            };
            UpsellCtrl.prototype.mergeCartAndRetrieveData = function (showSpinner, resetExistingParticipants) {
                var _this_1 = this;
                if (showSpinner === void 0) { showSpinner = false; }
                if (resetExistingParticipants === void 0) { resetExistingParticipants = true; }
                if (showSpinner) {
                    this.common.toggleSpinner(true, null, null, 0);
                }
                return this.userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, true, false)
                    .then(function () {
                    return _this_1.common.$q.resolve(_this_1.pulseContext.regFlowMgr.shoppingCartMgr
                        .getShoppingCart(_this_1.pulseContext.browseIdentifier, _this_1.pulseContext.shoppingCartType, _this_1.pulseContext.selectedCurrencyTypeID, true));
                })
                    .then(function (cart) {
                    _this_1.cart = cart;
                    return _this_1.common.$q.resolve(_this_1.getUpsellProducts());
                })
                    .then(function (products) {
                    _this_1.upsellProducts = products;
                    if (_this_1.pulseContext.isLoggedIn) {
                        return _this_1.common.$q.resolve(_this_1.userMgr.loadRelatedUsersForActingUser(false));
                    }
                    else {
                        return _this_1.common.$q.resolve([]);
                    }
                })
                    .then(function (relatedUsers) {
                    _this_1._relatedUsers = relatedUsers;
                    _this_1.createParticipantsArray(resetExistingParticipants);
                })
                    .then(function () {
                    if (_this_1.pulseContext.actingAsUser && _this_1.cart) {
                        var dataObj = { first: '', last: '', email: '', count: 0 };
                        var user = _this_1.pulseContext.actingAsUser;
                        dataObj.first = user.firstName;
                        dataObj.last = user.lastName;
                        dataObj.email = user.userName;
                        dataObj.count = ShoppingCartMgr.CountStandAlonePurchasableProducts(_this_1.cart);
                        Pulse.Common.DataAccess.Managers.UserBrowsingMgr.TriggerCartInfoEvent(dataObj);
                    }
                })
                    .then(function () {
                    var dc = _this_1.getDiscountCodeOnUrl();
                    if (dc) {
                        var productIDsAsString_1 = '';
                        _this_1.upsellProducts.forEach(function (o) {
                            productIDsAsString_1 += o.productID + ',';
                        });
                        if (productIDsAsString_1.length > 0)
                            productIDsAsString_1 = productIDsAsString_1.substring(0, productIDsAsString_1.length - 1);
                        return _this_1.common.$q.resolve(_this_1.pulseContext.regFlowMgr.onlinePrivateLessonMgr.getDiscountValuesForProductIDs(dc, productIDsAsString_1));
                    }
                    else {
                        return _this_1.common.$q.resolve({});
                    }
                })
                    .then(function (discountsResult) {
                    if (discountsResult.discountCodeExists && !discountsResult.discountCodeExpired) {
                        _this_1.upsellProducts.forEach(function (o) {
                            if (discountsResult.discountValues[o.productID + '']) {
                                o.price -= discountsResult.discountValues[o.productID + ''];
                            }
                        });
                    }
                })
                    .catch(function (err) {
                    _this_1.logError(err);
                })
                    .finally(function () {
                    if (showSpinner) {
                        _this_1.common.toggleSpinner(false, true);
                    }
                });
            };
            UpsellCtrl.prototype.onActivated = function (activationResults) {
                _super.prototype.onActivated.call(this, activationResults);
                this.scrollToTop();
            };
            UpsellCtrl.prototype.onCartChange = function (cart) {
                var _this_1 = this;
                this.cart = cart;
                for (var i = 0, j = this.participants.length; i < j; ++i) {
                    this.participants[i].parent = this.cart;
                }
                var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, true, false)
                    .catch(function (error) {
                    _this_1.logError(error);
                });
            };
            UpsellCtrl.prototype.onLoginSuccess = function () {
                var _this = this;
                window.setTimeout(function () {
                    if (!_this._userAccountWasCreated) {
                        _this.common.showSuccess('Login was successful.', { preventDuplicates: true });
                    }
                    if (_this._loggedInOnContinue) {
                        _this.continue();
                    }
                    else {
                        return _this.mergeCartAndRetrieveData(true, false);
                    }
                }, 500);
            };
            UpsellCtrl.prototype.onRemoveParticipant = function (userBrowsingID) {
                for (var i = this.participants.length - 1, j = 0; i >= j; i--) {
                    if (this.participants[i].userBrowsingID === userBrowsingID) {
                        this.participants.splice(i, 1);
                    }
                }
            };
            UpsellCtrl.prototype.onViewLoaded = function () {
                this.myForm = this.$scope[this.formName];
            };
            UpsellCtrl.prototype.removeProductsAndContinue = function () {
                var _this_1 = this;
                this.checkUnsavedDataBeforeNav = false;
                var promises = [];
                for (var i = 0, j = this.cart.participants.length; i < j; i++) {
                    var participant = this.cart.participants[i];
                    for (var k = 0, l = participant.items.length; k < l; k++) {
                        var product = participant.items[k];
                        for (var m = 0, n = this.upsellProducts.length; m < n; m++) {
                            var upProd = this.upsellProducts[m];
                            if (upProd.productID == product.productID) {
                                var promise = this.pulseContext.regFlowMgr.shoppingCartMgr.removeItemFromParticipant(participant.parent, participant.userBrowsingID, product.userBrowsingItemID);
                                promises.push(promise);
                                break;
                            }
                        }
                    }
                }
                if (promises.length > 0) {
                    this.common.toggleSpinner(true, null, null, 0);
                    return this.common.$q.all(promises).then(function () {
                        return _this_1.userBrowsingMgr.loadInfo(_this_1.userBrowsingMgr.currentUBSession, true, false)
                            .then(function () {
                            return _this_1.common.$q.resolve(_this_1.pulseContext.regFlowMgr.shoppingCartMgr.getShoppingCart(_this_1.pulseContext.browseIdentifier, _this_1.pulseContext.shoppingCartType, _this_1.pulseContext.selectedCurrencyTypeID, true));
                        })
                            .then(function (cart) {
                            _this_1.cart = cart;
                            _this_1.gotoNextPage();
                        });
                    })
                        .catch(function (err) {
                        _this_1.logError(err);
                    })
                        .finally(function () {
                        _this_1.common.toggleSpinner(false, true);
                    });
                }
                else {
                    this.gotoNextPage();
                }
            };
            UpsellCtrl.prototype.securityCheck = function () {
                this.canSee = true;
            };
            UpsellCtrl.controllerId = 'UpsellCtrl';
            return UpsellCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.UpsellCtrl = UpsellCtrl;
        Pulse.app.controller(UpsellCtrl.controllerId, [
            "$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            UpsellCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var RegFlowMgr = DataAccess.Managers.RegFlowMgr;
        var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
        var OrderSummaryCtrl = (function (_super) {
            __extends(OrderSummaryCtrl, _super);
            function OrderSummaryCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OrderSummaryCtrl.controllerId) || this;
                _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                _this.isCartEmpty = false;
                _this.isCartRetrieved = false;
                if (!_this.pulseContext.selectedCurrencyTypeID) {
                    _this.$location.url(Routes.RegFlow_ShoppingCart);
                    return _this;
                }
                if (angular.isNumber(_this.pulseContext.regflowCurrencyTypeID)) {
                    _this.pulseContext.regflowCurrencyTypeID = null;
                }
                _this.formName = "frmOrderSummary";
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.checkUnsavedDataBeforeNav = false;
                _this._shoppingCartRetrieved = $scope.$on(Events.ShoppingCartRetrieved, function (event, isCartEmpty) {
                    _this.isCartRetrieved = true;
                    _this.isCartEmpty = isCartEmpty;
                });
                $scope.$on('$destroy', function () {
                    _this._shoppingCartRetrieved();
                });
                _this._addCourseHandler = $scope.$on(Events.ShoppingCartAddCourseRequest, function (event, participant) {
                    _this.onAddCourse(participant);
                });
                $scope.$on('$destroy', function () {
                    _this._addCourseHandler();
                });
                _this._orderSummaryChangeRequest = $scope.$on(Events.OrderSummaryChangeRequest, function (event, item) {
                    _this.checkUnsavedDataBeforeNav = false;
                    if (item && item.productCategoryTypeID == Enums.ProductCategoryType.Tutor) {
                        _this.$location.url(Routes.RegFlow_Upsell);
                    }
                    else {
                        _this.$location.url(Routes.RegFlow_ShoppingCart);
                    }
                });
                $scope.$on('$destroy', function () {
                    _this._shoppingCartRetrieved();
                });
                _this._shoppingCartValidated = $scope.$on(Events.RegFlowShoppingCartValidated, function (event, checkOutPending, isOrderSummaryNecessary) {
                    _this.onShoppingCartValidated();
                });
                $scope.$on('$destroy', function () {
                    _this._shoppingCartValidated();
                });
                _this.activationPromises.push(_this.userBrowsingMgr.actionOnUserBrowsingRecordStatus(function () {
                    return _this.cartCtrlAPI.loadShoppingCart(false)
                        .then(function (cart) {
                        _this.triggerCartInfoEvent(cart);
                    });
                }, function (confirmedMerge) {
                    return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true, false)
                        .then(function () {
                        return _this.cartCtrlAPI.loadShoppingCart(true)
                            .then(function (cart) {
                            _this.triggerCartInfoEvent(cart);
                        });
                    });
                }, function (startNewCart) {
                    return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true, true)
                        .then(function () {
                        return _this.cartCtrlAPI.loadShoppingCart(true);
                    });
                }, true)
                    .then(function () {
                    return _this.pulseContext.regFlowMgr.userBrowsingMgr.setUserBrowsingResumeStep(Enums.RegFlowProgressStep.OrderSummary2017);
                }));
                _this.activateController();
                return _this;
            }
            OrderSummaryCtrl.prototype.securityCheck = function () {
                if (this.pulseContext.isImpersonating) {
                    this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3);
                }
                else {
                    this.canSee = this.pulseContext.isLoggedIn;
                }
            };
            OrderSummaryCtrl.prototype.onAddCourse = function (participant) {
                this.checkUnsavedDataBeforeNav = false;
                var noAutoDispatch = !!(this.pulseContext.regFlowMgr.locationFinderMgr.selectedIds && this.pulseContext.regFlowMgr.locationFinderMgr.selectedIds.length);
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                }
                else {
                    this.pulseContext.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart, noAutoDispatch);
                }
            };
            OrderSummaryCtrl.prototype.onShoppingCartValidated = function () {
                this.$location.url(Routes.RegFlow_Billing);
            };
            OrderSummaryCtrl.prototype.addCourseWhenNoneInCart = function () {
                this.checkUnsavedDataBeforeNav = false;
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                }
                else {
                    this.pulseContext.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
                }
            };
            OrderSummaryCtrl.prototype.triggerCartInfoEvent = function (cart) {
                if (this.pulseContext.actingAsUser && cart) {
                    var dataObj = { first: '', last: '', email: '', count: 0 };
                    var user = this.pulseContext.actingAsUser;
                    dataObj.first = user.firstName;
                    dataObj.last = user.lastName;
                    dataObj.email = user.userName;
                    dataObj.count = ShoppingCartMgr.CountStandAlonePurchasableProducts(cart);
                    Pulse.Common.DataAccess.Managers.UserBrowsingMgr.TriggerCartInfoEvent(dataObj);
                }
            };
            OrderSummaryCtrl.controllerId = "orderSummaryCtrl";
            return OrderSummaryCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.OrderSummaryCtrl = OrderSummaryCtrl;
        Pulse.app.controller(OrderSummaryCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            OrderSummaryCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var PaymentMgr = DataAccess.Managers.PaymentMgr;
        var RegFlowMgr = DataAccess.Managers.RegFlowMgr;
        var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
        var BillingCtrl = (function (_super) {
            __extends(BillingCtrl, _super);
            function BillingCtrl($scope, $location, $templateCache, $filter, common, breezeService, pulseContext, bootstrapDatePickerDefaultConfig) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, BillingCtrl.controllerId) || this;
                _this._cart = null;
                _this._cartContainsVIPEarlyAccess = null;
                _this._cartContainsCourseProduct = null;
                _this._paymentsOsBanks = null;
                _this._paymentsOsBanksForRecurring = null;
                _this._previousPurchaseInfo = null;
                _this._selectedPaymentOption = null;
                _this.agreeToESigAndTandC = true;
                _this.bankTransferInfo = {};
                _this.checkInfo = {};
                _this.creditCardInfo = {};
                _this.hasAtLeastOneCourse = false;
                _this.hasBootcamp = false;
                _this.hasCampAtHqLocation = false;
                _this.hasNonCampAtHqLocation = false;
                _this.hasOnlyOplOrVirtualCamps = false;
                _this.hasOnlyProductCouponProducts = false;
                _this.hasSmallGroupSemesters = false;
                _this.hasVtcOrVta = false;
                _this.isReady = false;
                _this.paymentAmountError = "";
                _this.purchasing = false;
                _this.selectedPaymentMethodTypeID = Enums.PaymentMethodType.CreditCard;
                _this.showBillingAddressFields = false;
                _this.showSmsCode = false;
                _this.signUpForBalloonPayment = false;
                _this.submitted = false;
                _this.submitOrderDisabled = false;
                _this.termStaffHasSeenBalanceDueWarning = false;
                _this._OPLAutoSubscriptions = null;
                if (!_this.pulseContext.selectedCurrencyTypeID) {
                    _this.$location.url(Routes.RegFlow_ShoppingCart);
                    return _this;
                }
                _this.calendarObj_Dated = _.cloneDeep(bootstrapDatePickerDefaultConfig);
                _this.calendarObj_RecDate = _.cloneDeep(bootstrapDatePickerDefaultConfig);
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.$templateCache = $templateCache;
                _this.$filter = $filter;
                _this.appRoot = _this.common.config.appRoot;
                if (_this.isImpersonating) {
                    _this.selectedOrderSourceTypeID = Enums.OrderSourceType.Phone;
                }
                else {
                    _this.selectedOrderSourceTypeID = Enums.OrderSourceType.Online;
                }
                _this.activationPromises.push(_this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, false, false));
                _this.activationPromises.push(_this.getOrderSourceTypes());
                _this.activationPromises.push(_this.getExpirationMonths());
                _this.activationPromises.push(_this.getExpirationYears());
                _this.activationPromises.push(_this.getCountryTypes());
                _this.activationPromises.push(_this.getStateTypes());
                _this.activationPromises.push(_this.getCanadianProvinceTypes());
                _this.activationPromises.push(_this.getCart());
                _this.common.toggleSpinner(true, null, null, 0);
                _this.activateController()
                    .then(function (resultsArr) {
                    _this.userBrowsing = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO;
                    if (resultsArr[2]) {
                        _this.orderSourceTypes = resultsArr[2];
                    }
                    if (resultsArr[3]) {
                        _this.expirationMonths = resultsArr[3];
                    }
                    if (resultsArr[4]) {
                        _this.expirationYears = resultsArr[4];
                    }
                    if (resultsArr[5]) {
                        _this.countryTypes = resultsArr[5];
                    }
                    if (resultsArr[6]) {
                        _this.stateTypes = resultsArr[6];
                    }
                    if (resultsArr[7]) {
                        _this.canadianProvinceTypes = resultsArr[7];
                    }
                    if (resultsArr[8]) {
                        _this.cart = resultsArr[8];
                        return _this.common.$q.resolve(_this.pulseContext.regFlowMgr.paymentMgr.getPaymentOptionsInfo(_this.cart));
                    }
                })
                    .then(function (result) {
                    _this.triggerCartInfoEvent(_this.cart);
                    _this.hasCampAtHqLocation = ShoppingCartMgr.HasCampAtHqLocation(_this.cart);
                    _this.hasBootcamp = ShoppingCartMgr.HasBootcamp(_this.cart);
                    _this.hasNonCampAtHqLocation = ShoppingCartMgr.HasNonCampAtHqLocation(_this.cart);
                    _this.hasAtLeastOneCourse = ShoppingCartMgr.DoesCartHaveAtLeastOneCourse(_this.cart);
                    _this.hasOnlyOplOrVirtualCamps = ShoppingCartMgr.HasOnlyOplOrVirtualCamps(_this.cart);
                    _this.hasOnlyProductCouponProducts = ShoppingCartMgr.HasOnlyProductCouponProducts(_this.cart);
                    _this.hasSmallGroupSemesters = ShoppingCartMgr.HasSmallGroupSemesters(_this.cart);
                    _this.hasVtcOrVta = ShoppingCartMgr.HasVtcOrVta(_this.cart);
                    _this.loadPaymentOptions(result);
                    _this.isReady = true;
                    return _this.checkForPaymentsOsRedirectCompletion();
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false, true);
                    window.setTimeout(function () {
                        _this.scrollToTop();
                    }, 500);
                });
                return _this;
            }
            Object.defineProperty(BillingCtrl.prototype, "balanceDue", {
                get: function () {
                    if (this.paymentOptionsInfo) {
                        if (this.paymentOptionsInfo.payInFullDiscountTotal > 0
                            && this.selectedPaymentOption
                            && this.selectedPaymentOption.paymentOptionTypeID != PaymentMgr.PaymentOptionType.PleaseSelect
                            && this.selectedPaymentOption.paymentOptionTypeID != PaymentMgr.PaymentOptionType.Full) {
                            return this.paymentOptionsInfo.balanceDue + this.paymentOptionsInfo.payInFullDiscountTotal;
                        }
                        else if (this.selectedPaymentOption
                            && this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.DepositPlusInstallments) {
                            return this.paymentOptionsInfo.balanceDue + this.paymentOptionsInfo.paymentPlanFee;
                        }
                        else {
                            if (this.selectedPaymentOption
                                && this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Full) {
                                return this.selectedPaymentOption.paymentAmount;
                            }
                            else {
                                return this.paymentOptionsInfo.balanceDue;
                            }
                        }
                    }
                    else {
                        return 0;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "bootcampVtcVtaLabel", {
                get: function () {
                    var s = '';
                    if (this.hasBootcamp) {
                        s += 'Online Teen Academies';
                        if (this.hasVtcOrVta) {
                            s += ", ";
                        }
                    }
                    if (this.hasVtcOrVta) {
                        s += 'Virtual Tech Camps & Academies';
                    }
                    return s.toUpperCase();
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "cart", {
                get: function () {
                    return this._cart;
                },
                set: function (cart) {
                    this._cart = cart;
                    this.paymentMethodTypes = this.getPaymentMethodTypes();
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "cartContainsVIPEarlyAccessOnly", {
                get: function () {
                    return this.cartContainsVIPEarlyAccess
                        && ShoppingCartMgr.GetNumOfTopLevelItemsInCart(this.cart) == 1;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "cartContainsVIPEarlyAccess", {
                get: function () {
                    if (this._cartContainsVIPEarlyAccess == null && this.cart) {
                        this._cartContainsVIPEarlyAccess = ShoppingCartMgr.HasProductCategoryInCart(this.cart, Enums.ProductCategoryType.PurchaseCredit, Enums.ProductSubCategoryType.EarlyAccess);
                    }
                    return this._cartContainsVIPEarlyAccess;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "cartContainsCourseProduct", {
                get: function () {
                    if (this._cartContainsCourseProduct == null && this.cart) {
                        this._cartContainsCourseProduct = ShoppingCartMgr.HasProductCategoryInCart(this.cart, Enums.ProductCategoryType.Course);
                    }
                    return this._cartContainsCourseProduct;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "cartContainsOPLAutoSubscriptions", {
                get: function () {
                    if (this._OPLAutoSubscriptions == null && this.cart) {
                        this._OPLAutoSubscriptions = ShoppingCartMgr.GetOPLProducts(this.cart, {
                            isSelected: true,
                            isAutoRenew: true,
                        });
                    }
                    return (this._OPLAutoSubscriptions && !!this._OPLAutoSubscriptions.length);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "OPLAutoSubscriptionsTotalPrice", {
                get: function () {
                    if (this._OPLAutoSubscriptions == null && this.cart) {
                        this._OPLAutoSubscriptions = ShoppingCartMgr.GetOPLProducts(this.cart, {
                            isSelected: true,
                            isAutoRenew: true,
                        });
                    }
                    return ShoppingCartMgr.CalculateItemsTotalPrice(this._OPLAutoSubscriptions);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "cityFieldTitle", {
                get: function () {
                    if (this.selectedCountryType != null &&
                        (this.selectedCountryType.typeID == Enums.CountryType.USA
                            || this.selectedCountryType.typeID == Enums.CountryType.Canada)) {
                        return "City";
                    }
                    else {
                        return "City/Territory";
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "currencyTypeID", {
                get: function () {
                    return this.pulseContext.selectedCurrencyTypeID;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "divisionNameForPaymentPlan", {
                get: function () {
                    if (this.cart) {
                        for (var p = 0, pl = this.cart.participants.length; p < pl; ++p) {
                            var participant = this.cart.participants[p];
                            for (var i = 0, il = participant.items.length; i < il; ++i) {
                                var item = participant.items[i];
                                if (item.catalogTypeID == Enums.SalesCatalogType.StandardCamp) {
                                    return item.divisionName;
                                }
                            }
                        }
                        for (var p = 0, pl = this.cart.participants.length; p < pl; ++p) {
                            var participant = this.cart.participants[p];
                            for (var i = 0, il = participant.items.length; i < il; ++i) {
                                var item = participant.items[i];
                                if (item.catalogTypeID == Enums.SalesCatalogType.SquadsMultiWeek) {
                                    return item.divisionName;
                                }
                            }
                        }
                    }
                    return 'N/A';
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "hasNoParticipants", {
                get: function () {
                    return (!this.cart || !this.cart.participants || this.cart.participants.length == 0);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "isImpersonating", {
                get: function () {
                    return this.pulseContext && this.pulseContext.isImpersonating;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "isInChangeProcess", {
                get: function () {
                    return this.pulseContext
                        && this.pulseContext.regFlowMgr
                        && this.pulseContext.regFlowMgr.shoppingCartMgr
                        && this.cart
                        && ShoppingCartMgr.IsChangeOrderCart(this.cart);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "minBalanceDueDateFormatted", {
                get: function () {
                    if (this.paymentOptionsInfo && this.paymentOptionsInfo.minBalanceDueDate) {
                        return moment(this.paymentOptionsInfo.minBalanceDueDate).format("M/D/YYYY");
                    }
                    else {
                        return null;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "minDiscountPayDateFormatted", {
                get: function () {
                    if (this.paymentOptionsInfo && this.paymentOptionsInfo.minDiscountPayDate) {
                        return moment(this.paymentOptionsInfo.minDiscountPayDate).format("M/D/YYYY");
                    }
                    else {
                        return null;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "paymentsOsBanks", {
                get: function () {
                    return this._paymentsOsBanks;
                },
                enumerable: false,
                configurable: true
            });
            ;
            Object.defineProperty(BillingCtrl.prototype, "previousPurchaseInfo", {
                get: function () {
                    if (!this._previousPurchaseInfo) {
                        if (window.sessionStorage["previousPurchaseInfo"]) {
                            this._previousPurchaseInfo = JSON.parse(window.sessionStorage["previousPurchaseInfo"]);
                        }
                    }
                    return this._previousPurchaseInfo;
                },
                set: function (info) {
                    this._previousPurchaseInfo = info;
                    if (info) {
                        var json = this.pulseContext.regFlowMgr.paymentMgr.stringifyPayload(info);
                        window.sessionStorage["previousPurchaseInfo"] = json;
                    }
                    else {
                        window.sessionStorage["previousPurchaseInfo"] = null;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "selectedPaymentOption", {
                get: function () {
                    return this._selectedPaymentOption;
                },
                set: function (paymentOption) {
                    this._selectedPaymentOption = paymentOption;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "showAutoBill", {
                get: function () {
                    if (this.paymentOptionsInfo) {
                        if (this.selectedPaymentOption
                            && this.selectedPaymentOption.paymentOptionTypeID != PaymentMgr.PaymentOptionType.PleaseSelect
                            && this.selectedPaymentOption.paymentOptionTypeID != PaymentMgr.PaymentOptionType.Full
                            && this.selectedPaymentOption.paymentOptionTypeID != PaymentMgr.PaymentOptionType.DepositPlusInstallments
                            && this.selectedPaymentOption.paymentOptionTypeID != PaymentMgr.PaymentOptionType.None
                            && this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.CreditCard) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "showScheduledPayments", {
                get: function () {
                    if (this.paymentOptionsInfo) {
                        if (this.selectedPaymentOption
                            && this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.DepositPlusInstallments
                            && (this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.CreditCard
                                || this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.BankTransfer)
                            && this.scheduledPaymentsInfo) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "showPaymentInputFields", {
                get: function () {
                    if (!this.cart || !this.cart.currencyType) {
                        return false;
                    }
                    else if (!this.selectedPaymentMethodTypeID) {
                        return false;
                    }
                    else if (this.balanceDue > 0
                        && (!this.selectedPaymentOption
                            || this.selectedPaymentOption.paymentOptionTypeID != PaymentMgr.PaymentOptionType.None)) {
                        if (this.selectedPaymentOption
                            && this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Deposit
                            && this.paymentOptionsInfo.discountAdjustedDepositAmount == 0
                            && this.signUpForBalloonPayment == false) {
                            return false;
                        }
                        else if (this.selectedPaymentOption
                            && this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.DepositPlusInstallments
                            && ((this.paymentOptionsInfo.discountAdjustedDepositAmount + this.paymentOptionsInfo.paymentPlanFee) - this.cart.availableCredit) <= 0) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                    else {
                        return false;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "showPaymentAmountInput", {
                get: function () {
                    if (this.paymentOptionsInfo) {
                        if (this.selectedPaymentOption &&
                            (this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Other
                                || this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Partial)) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "showProvinceSelectField", {
                get: function () {
                    if (this.selectedCountryType != null && this.selectedCountryType.typeID == Enums.CountryType.Canada) {
                        return true;
                    }
                    else {
                        return false;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "showStateInputField", {
                get: function () {
                    if (this.selectedCountryType == null || (this.selectedCountryType.typeID != Enums.CountryType.Canada
                        && this.selectedCountryType.typeID != Enums.CountryType.USA)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "showStateSelectField", {
                get: function () {
                    if (this.selectedCountryType != null && this.selectedCountryType.typeID == Enums.CountryType.USA) {
                        return true;
                    }
                    else {
                        return false;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "showTodaysPayment", {
                get: function () {
                    return this.selectedPaymentOption && this.selectedPaymentOption.paymentOptionTypeID != PaymentMgr.PaymentOptionType.PleaseSelect;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "stateFieldTitle", {
                get: function () {
                    if (this.selectedCountryType != null
                        && this.selectedCountryType.typeID == Enums.CountryType.USA) {
                        return "State";
                    }
                    else if (this.selectedCountryType != null
                        && this.selectedCountryType.typeID == Enums.CountryType.Canada) {
                        return "Province";
                    }
                    else {
                        return "State/Province";
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingCtrl.prototype, "zipFieldTitle", {
                get: function () {
                    if (this.selectedCountryType != null
                        && this.selectedCountryType.typeID == Enums.CountryType.USA) {
                        return "Zip Code";
                    }
                    else {
                        return "Postal Code";
                    }
                },
                enumerable: false,
                configurable: true
            });
            BillingCtrl.prototype.addBank = function (arr, code, name, forRecurringPayments) {
                var o = {};
                o.code = code;
                o.name = name;
                o.supportsRecurringPayments = forRecurringPayments;
                arr.push(o);
            };
            BillingCtrl.prototype.checkForPaymentsOsRedirectCompletion = function () {
                if (this.previousPurchaseInfo) {
                    var previousPurchaseInfo = this.previousPurchaseInfo;
                    this.previousPurchaseInfo = null;
                    var paymentsOsPaymentID = Pulse.Utils.QueryStringUtils.GetParamByName(window.location.href.toLowerCase(), "payment_id");
                    var paymentsOsChargeID = Pulse.Utils.QueryStringUtils.GetParamByName(window.location.href.toLowerCase(), "charge_id");
                    var status_1 = Pulse.Utils.QueryStringUtils.GetParamByName(window.location.href.toLowerCase(), "status");
                    if (previousPurchaseInfo.paymentsOsPaymentID &&
                        previousPurchaseInfo.paymentsOsPaymentID.toLowerCase() == paymentsOsPaymentID &&
                        previousPurchaseInfo.paymentsOsChargeID &&
                        previousPurchaseInfo.paymentsOsChargeID.toLowerCase() == paymentsOsChargeID &&
                        status_1) {
                        if (status_1.startsWith("failed")) {
                            this.selectedPaymentMethodTypeID = previousPurchaseInfo.paymentMethodTypeID;
                            this.selectedPaymentOption = this.getPaymentOptionByTypeID(previousPurchaseInfo.paymentOptionDTO.paymentOptionTypeID);
                            if (previousPurchaseInfo.bankTransferDTO) {
                                this.selectedPaymentsOsBank = this.getPaymentsOsBankByBankCode(previousPurchaseInfo.bankTransferDTO.bankCode);
                                this.bankTransferInfo.customerAccountName = previousPurchaseInfo.bankTransferDTO.customerAccountName;
                                this.bankTransferInfo.customerAccountNumber = previousPurchaseInfo.bankTransferDTO.customerAccountNumber;
                                this.bankTransferInfo.customerAccountType = previousPurchaseInfo.bankTransferDTO.customerAccountType;
                            }
                            if (previousPurchaseInfo.creditCardDTO) {
                                this.creditCardInfo.creditCardNumber = "";
                                this.creditCardInfo.address1 = previousPurchaseInfo.creditCardDTO.address1;
                                this.creditCardInfo.address2 = previousPurchaseInfo.creditCardDTO.address2;
                                this.creditCardInfo.city = previousPurchaseInfo.creditCardDTO.city;
                                this.creditCardInfo.state = previousPurchaseInfo.creditCardDTO.state;
                                this.creditCardInfo.postalCode = previousPurchaseInfo.creditCardDTO.postalCode;
                                this.creditCardInfo.creditCardTypeID = previousPurchaseInfo.creditCardDTO.creditCardTypeID;
                                this.selectedExpMonth = this.getExpirationMonthById(previousPurchaseInfo.creditCardDTO.expMonth);
                                this.selectedExpYear = this.getExpirationYearById(previousPurchaseInfo.creditCardDTO.expYear);
                                this.creditCardInfo.creditCardCVV = previousPurchaseInfo.creditCardDTO.creditCardCVV;
                                this.creditCardInfo.nameOnCard = previousPurchaseInfo.creditCardDTO.nameOnCard;
                            }
                            this.common.showError("Payment authorization failed.");
                            return;
                        }
                        else {
                            previousPurchaseInfo.paymentResultTypeID = PaymentMgr.PaymentResultType.RedirectSucceeded;
                            return this.purchase(previousPurchaseInfo);
                        }
                    }
                }
                return;
            };
            BillingCtrl.prototype.getCanadianProvinceTypes = function () {
                return this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.CountryRegionType.CanadianProvinces);
            };
            BillingCtrl.prototype.getCart = function (refresh) {
                if (refresh === void 0) { refresh = false; }
                return this.pulseContext.regFlowMgr.shoppingCartMgr.getShoppingCart(this.pulseContext.browseIdentifier, this.pulseContext.shoppingCartType, this.pulseContext.selectedCurrencyTypeID, refresh);
            };
            BillingCtrl.prototype.getCountryTypes = function () {
                return this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.Country);
            };
            BillingCtrl.prototype.getExpirationMonths = function () {
                var deferred = this.common.$q.defer();
                var expirationMonths = [];
                for (var i = 1; i <= 12; i++) {
                    var s = Pulse.Utils.JS.zeroPad(i, 2);
                    expirationMonths.push({ id: i, name: s });
                }
                deferred.resolve(expirationMonths);
                return deferred.promise;
            };
            BillingCtrl.prototype.getExpirationMonthById = function (id) {
                for (var i = 1; i <= this.expirationMonths.length; i++) {
                    var o = this.expirationMonths[i];
                    if (o.id == id)
                        return o;
                }
                return null;
            };
            BillingCtrl.prototype.getExpirationYears = function () {
                var deferred = this.common.$q.defer();
                var expirationYears = [];
                var d = new Date();
                var startYear = d.getFullYear();
                for (var i = 0; i < 10; i++) {
                    expirationYears.push({ id: (startYear + i), name: (startYear + i) + "" });
                }
                deferred.resolve(expirationYears);
                return deferred.promise;
            };
            BillingCtrl.prototype.getExpirationYearById = function (id) {
                for (var i = 1; i <= this.expirationYears.length; i++) {
                    var o = this.expirationYears[i];
                    if (o.id == id)
                        return o;
                }
                return null;
            };
            BillingCtrl.prototype.getPaymentOptionByTypeID = function (paymentOptionTypeID) {
                for (var i = 0, il = this.paymentOptionsInfo.paymentOptions.length; i < il; i++) {
                    var po = this.paymentOptionsInfo.paymentOptions[i];
                    if (po.paymentOptionTypeID == paymentOptionTypeID) {
                        return po;
                    }
                }
            };
            BillingCtrl.prototype.getPaymentsOsBankByBankCode = function (bankCode) {
                for (var i = 0, il = this.paymentsOsBanks.length; i < il; i++) {
                    var bank = this.paymentsOsBanks[i];
                    if (bank.code == bankCode) {
                        return bank;
                    }
                }
            };
            BillingCtrl.prototype.getScheduledPaymentsInfo = function (shoppingCart) {
                var _this = this;
                if (shoppingCart) {
                    this.common.toggleSpinner(true, null, null, 0);
                    return this.pulseContext.regFlowMgr.paymentMgr.getScheduledPaymentsInfo(shoppingCart.userID, this.pulseContext.selectedCurrencyTypeID, shoppingCart)
                        .then(function (results) {
                        _this.scheduledPaymentsInfo = results;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false, true);
                    });
                }
            };
            BillingCtrl.prototype.getOrderSourceTypes = function () {
                return this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.OrderSource);
            };
            BillingCtrl.prototype.getPaymentMethodTypes = function () {
                var types = [];
                if (this.cart) {
                    if (this.cart.currencyType.typeID == Enums.CurrencyType.USD) {
                        types.push({ typeID: Enums.PaymentMethodType.Check, typeString: "Check" });
                        types.push({ typeID: Enums.PaymentMethodType.CreditCard, typeString: "Credit Card" });
                        types.push({ typeID: Enums.PaymentMethodType.MoneyOrder, typeString: "Money Order" });
                    }
                    else {
                        types.push({ typeID: Enums.PaymentMethodType.CreditCard, typeString: "Credit Card" });
                        types.push({ typeID: Enums.PaymentMethodType.BankTransfer, typeString: "Bank Transfer" });
                    }
                }
                return types;
            };
            BillingCtrl.prototype.getStateTypes = function () {
                return this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.CountryRegionType.USStates);
            };
            BillingCtrl.prototype.loadPaymentOptions = function (result) {
                this.paymentOptionsInfo = result;
                this.scheduledPaymentsInfo = result.scheduledPaymentsInfo;
                if (result.paymentsOsBanks) {
                    this._paymentsOsBanks = [];
                    for (var i_1 = 0, il = result.paymentsOsBanks.length; i_1 < il; i_1++) {
                        var o = result.paymentsOsBanks[i_1];
                        this.addBank(this._paymentsOsBanks, o.bankCode, o.displayName, o.supportsRecurringPayments);
                    }
                }
                if (this.cart == null
                    || ((this.cart.participants == null
                        || this.cart.participants.length == 0)
                        && (this.cart.nonParticipantItems == null
                            || this.cart.nonParticipantItems.length == 0))) {
                    var purchaseResult = this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult;
                    if (purchaseResult) {
                        if (purchaseResult.cartHadCourseProducts || purchaseResult.cartHadTutorProducts) {
                            this.$location.url(Routes.RegFlow_ContactInfo);
                        }
                        else {
                            this.$location.url(Routes.RegFlow_OrderConfirmation);
                        }
                    }
                    else {
                        this.$location.url(Routes.MyAccount);
                    }
                }
                else {
                    if (this.paymentOptionsInfo.paymentOptions.length > 1) {
                        var po = new PaymentMgr.PaymentOption(0, false, true, 0, PaymentMgr.PaymentOptionType.PleaseSelect, null, this.$filter);
                        this.paymentOptionsInfo.paymentOptions.splice(0, 0, po);
                    }
                    for (var i_2 = 0; i_2 < this.paymentOptionsInfo.paymentOptions.length; i_2++) {
                        var o = this.paymentOptionsInfo.paymentOptions[i_2];
                        var po = new PaymentMgr.PaymentOption(o.currencyTypeID, o.isPaymentPlan, o.isSelected, o.paymentAmount, o.paymentOptionTypeID, o.parent, this.$filter);
                        if (po.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Other
                            || po.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Partial) {
                            po.paymentAmount = null;
                        }
                        this.paymentOptionsInfo.paymentOptions[i_2] = po;
                    }
                    var cachedOptionTypeID = null;
                    if (this.selectedPaymentOption) {
                        cachedOptionTypeID = this.selectedPaymentOption.paymentOptionTypeID;
                    }
                    if (!cachedOptionTypeID) {
                        this.selectedPaymentOption = this.paymentOptionsInfo.paymentOptions[0];
                    }
                    else {
                        for (var i = 0; i < this.paymentOptionsInfo.paymentOptions.length; i++) {
                            var o = this.paymentOptionsInfo.paymentOptions[i];
                            if (o.paymentOptionTypeID === cachedOptionTypeID) {
                                this.selectedPaymentOption = o;
                                break;
                            }
                        }
                    }
                }
            };
            BillingCtrl.prototype.onViewLoaded = function () {
                this.frmBankTransfer = this.$scope["frmBankTransfer"];
                this.frmCheck = this.$scope["frmCheck"];
                this.frmCreditCard = this.$scope["frmCreditCard"];
                this.frmMoneyOrder = this.$scope["frmMoneyOrder"];
                this.frmPaymentAmount = this.$scope["frmPaymentAmount"];
                this.frmSignature = this.$scope["frmSignature"];
            };
            BillingCtrl.prototype.purchase = function (purchaseInfo) {
                var _this = this;
                this.common.toggleSpinner(true);
                purchaseInfo.shoppingCartDTO.customTutorProductNames
                    = this.pulseContext.regFlowMgr.shoppingCartMgr.customTutorProductNames;
                return this.pulseContext.regFlowMgr.paymentMgr.purchaseShoppingCart(purchaseInfo)
                    .then(function (response) {
                    _this.purchasing = false;
                    if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.SMS_CodeRequired
                        || response.paymentResultTypeID == PaymentMgr.PaymentResultType.SMS_CodeResend
                        || response.paymentResultTypeID == PaymentMgr.PaymentResultType.RedirectRequired) {
                        _this.common.toggleSpinner(false, true);
                        purchaseInfo.paymentID = response.paymentID;
                        purchaseInfo.paymentResultTypeID = response.paymentResultTypeID;
                        purchaseInfo.paymentsOsPaymentID = response.paymentsOsPaymentID;
                        purchaseInfo.paymentsOsChargeID = response.paymentsOsChargeID;
                        purchaseInfo.paymentsOsSmsCancelUrl = response.paymentsOsSmsCancelUrl;
                        purchaseInfo.paymentsOsSmsPostUrl = response.paymentsOsSmsPostUrl;
                        purchaseInfo.paymentsOsSmsResendUrl = response.paymentsOsSmsResendUrl;
                        _this.previousPurchaseInfo = purchaseInfo;
                        if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.SMS_CodeResend) {
                            _this.common.showInfo("SMS code has been resent.");
                        }
                        else if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.RedirectRequired) {
                            window.location.href = response.paymentsOsRedirectUrl;
                            return;
                        }
                        _this.selectedSmsCode = "";
                        _this.showSmsCode = true;
                        return;
                    }
                    else if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.SMS_CodeCancelled) {
                        _this.common.toggleSpinner(false, true);
                        _this.previousPurchaseInfo = null;
                        _this.showSmsCode = false;
                        return;
                    }
                    else {
                        _this.showSmsCode = false;
                    }
                    _this.purchasing = true;
                    _this.frmBankTransfer.$setPristine();
                    _this.frmCheck.$setPristine();
                    _this.frmCreditCard.$setPristine();
                    _this.frmMoneyOrder.$setPristine();
                    _this.frmPaymentAmount.$setPristine();
                    _this.frmSignature.$setPristine();
                    var purchasedVIPEarlyAccessOnly = _this.cartContainsVIPEarlyAccessOnly;
                    _this.pulseContext.regFlowMgr.shoppingCartMgr.clearCachedCart();
                    if (response.shoppingCartWasEmpty) {
                        _this.common.showWarning("Shopping cart was empty, please start again.");
                        _this.$location.url(Routes.RegFlow_ChooseLocations);
                    }
                    else {
                        if (response.returnedOptionsOnly) {
                            _this.common.showSuccess("Options have been returned.");
                            _this.triggerCartInfoEvent(null);
                            _this.pulseContext.regFlowMgr.shoppingCartMgr.cancelShoppingCart();
                            _this.$location.url(Routes.MyAccount);
                        }
                        else {
                            if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.Accepted) {
                                _this.sendOrderInfoToGoogleGTM(response.orderConfirmationInfo);
                                _this.sendOrderInfoToOptimizely(purchaseInfo.shoppingCartDTO);
                                _this.pulseContext.regFlowMgr.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, false, false)
                                    .then(function () {
                                    var params = {};
                                    params[Pulse.Utils.QueryStringUtils.VIP_ONLY] = purchasedVIPEarlyAccessOnly;
                                    var purchaseResult = _this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult;
                                    if (purchaseResult.cartHadCourseProducts || purchaseResult.cartHadTutorProducts) {
                                        var redirectUrl = Pulse.Utils.QueryStringUtils.AddOrSetQSParams(Routes.RegFlow_ContactInfo, params);
                                        _this.$location.url(redirectUrl);
                                    }
                                    else {
                                        var redirectUrl = Pulse.Utils.QueryStringUtils.AddOrSetQSParams(Routes.RegFlow_OrderConfirmation, params);
                                        _this.$location.url(redirectUrl);
                                    }
                                });
                            }
                            else {
                                if (_this.previousPurchaseInfo) {
                                    _this.previousPurchaseInfo = null;
                                }
                                if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.Rejected
                                    || response.paymentResultTypeID == PaymentMgr.PaymentResultType.Error_PaymentProcessor
                                    || response.paymentResultTypeID == PaymentMgr.PaymentResultType.Error_UnexpectedError
                                    || response.paymentResultTypeID == PaymentMgr.PaymentResultType.Error_GeneralDecline) {
                                    return _this.getCart(true).then(function (latestCart) {
                                        if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.Error_GeneralDecline) {
                                            _this.common.showError(response.error, true, { timeOut: 0 });
                                        }
                                        else {
                                            _this.common.showError(response.error, false, { timeOut: 0 });
                                        }
                                        _this.showBillingAddressFields = true;
                                        _this.cart = latestCart;
                                        return _this.pulseContext.regFlowMgr.paymentMgr.getPaymentOptionsInfo(_this.cart)
                                            .then(function (result) {
                                            _this.loadPaymentOptions(result);
                                        });
                                    });
                                }
                                else {
                                    var errString = response.error + " " + StringConst.Err_Failure_Friendly_Msg_Fragment;
                                    _this.common.showError(errString, true, { timeOut: 0 });
                                }
                            }
                        }
                    }
                })
                    .catch(function (err) {
                    if (_this.purchasing && _this.previousPurchaseInfo) {
                        _this.previousPurchaseInfo = null;
                    }
                    _this.logError(err, null, { timeOut: 0 });
                })
                    .finally(function () {
                    _this.purchasing = false;
                    _this.common.toggleSpinner(false, true);
                });
            };
            BillingCtrl.prototype.securityCheck = function () {
                if (this.pulseContext.isImpersonating) {
                    this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3);
                }
                else {
                    this.canSee = true;
                }
            };
            BillingCtrl.prototype.setFocusOnFirstInvalid = function (formName) {
                var firstInvalid = angular.element("[name='" + formName + "']");
                firstInvalid = angular.element(firstInvalid[0].querySelector('.ng-invalid'))[0];
                if (firstInvalid) {
                    firstInvalid.focus();
                }
            };
            BillingCtrl.prototype.setPaymentOptionNames = function (paymentInfo) {
                for (var i = 0; i < paymentInfo.paymentOptions.length; i++) {
                    var paymentOption = paymentInfo.paymentOptions[i];
                    paymentOption.name = "a";
                }
            };
            BillingCtrl.prototype.showBalanceDueWarningForTermStaff = function () {
                this.termStaffHasSeenBalanceDueWarning = true;
                var template = this.$templateCache.get('termStaffBalanceDueWarning.html');
                var currency = this.$filter('currency');
                template = String.format(template, currency(this.balanceDue - this.selectedPaymentOption.paymentAmount));
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Term Staff Alert", " " + template, null);
            };
            BillingCtrl.prototype.showCreditCardIdHelp = function () {
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Credit Card CVV", Pulse.Directives.HelpPopup.HelpTopic.CreditCardIDNumber, "creditCardIDHelp");
            };
            BillingCtrl.prototype.showTermsAndConditions = function () {
                this.common.$rootScope.$broadcast(Events.ShowIFramePopup, {
                    size: Pulse.Common.BasePopup.ModalSize.Medium,
                    initDataObj: {
                        url: this.pulseContext.pulse1x_PublicUrlRoot + "/TermsAndConditions.aspx?"
                            + QueryStringUtils.COMPANY_ID + "=" + this.pulseContext.companyId,
                        title: "Terms and Conditions",
                    },
                });
            };
            BillingCtrl.prototype.showHelpCenter = function () {
                this.common.$rootScope.$broadcast(Events.ShowIFramePopup, {
                    size: Pulse.Common.BasePopup.ModalSize.ExtraLarge,
                    initDataObj: {
                        url: "https://help.idtech.com/",
                        title: "Help Center",
                    },
                });
            };
            BillingCtrl.prototype.sendOrderInfoToGoogleGTM = function (orderConfirmationInfo) {
                var oGTM = { 'event': 'purchase', 'ecommerce': orderConfirmationInfo.ecommerce };
                dataLayer.push(oGTM);
            };
            BillingCtrl.prototype.sendOrderInfoToOptimizely = function (shoppingCartDTO) {
                if (window['optimizely']) {
                    var total = ShoppingCartMgr.CalculateTotal(shoppingCartDTO);
                    window['optimizely'].push({
                        type: "event",
                        eventName: "optimizely-conversions",
                        tags: {
                            value: total,
                        }
                    });
                    window['optimizely'].push({
                        type: "event",
                        eventName: "trackRevenue",
                        tags: {
                            revenue: Math.round(total * 100),
                        }
                    });
                }
            };
            BillingCtrl.prototype.submitSmsCode = function (override) {
                if (override) {
                    this.previousPurchaseInfo.paymentsOsSmsCode = override;
                }
                else {
                    if (!this.selectedSmsCode || this.selectedSmsCode.trim() == "") {
                        this.common.showWarning("Please enter the SMS code.");
                        return;
                    }
                    else {
                        this.previousPurchaseInfo.paymentsOsSmsCode = this.selectedSmsCode;
                    }
                }
                if (override == "cancel" && !this.previousPurchaseInfo.paymentsOsSmsCancelUrl) {
                    this.previousPurchaseInfo = null;
                    this.showSmsCode = false;
                }
                else {
                    return this.purchase(this.previousPurchaseInfo);
                }
            };
            BillingCtrl.prototype.submitOrder = function () {
                var _this = this;
                var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                var promise;
                if (this.cartContainsOPLAutoSubscriptions ||
                    (this.selectedPaymentOption &&
                        this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.DepositPlusInstallments)) {
                    if (this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.BankTransfer) {
                        var bank = this.getPaymentsOsBankByBankCode(this.selectedPaymentsOsBank.code);
                        if (!bank.supportsRecurringPayments) {
                            if (this.selectedPaymentOption &&
                                this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.DepositPlusInstallments) {
                                this.common.showError("The selected bank cannot be used for payment. To pay using the installments plan you must"
                                    + " select a bank that supports recurring payments.", true, { timeOut: 0 });
                            }
                            else {
                                this.common.showError("The selected bank cannot be used for payment. Your shopping cart contains one or more "
                                    + "'subscription' products and the selected bank does not support recurring payments.", true, { timeOut: 0 });
                            }
                            return;
                        }
                    }
                }
                promise = userBrowsingMgr.actionOnUserBrowsingRecordStatus(function () {
                    return true;
                }, function (confirmedMerge) {
                    return userBrowsingMgr.loadInfo(userBrowsingMgr.currentUBSession, true, false)
                        .then(function () {
                        _this.pulseContext.regFlowMgr.shoppingCartMgr.clearCachedCart();
                        _this.$location.path(Routes.RegFlow_OrderSummary);
                        return null;
                    });
                }, function (startNewCart) {
                    if (startNewCart) {
                        return userBrowsingMgr.loadInfo(userBrowsingMgr.currentUBSession, false, true)
                            .then(function () {
                            _this.pulseContext.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart);
                            return null;
                        });
                    }
                    else {
                        return userBrowsingMgr.loadInfo(userBrowsingMgr.currentUBSession, true, false)
                            .then(function () {
                            _this.pulseContext.regFlowMgr.shoppingCartMgr.clearCachedCart();
                            _this.$location.path(Routes.RegFlow_OrderSummary);
                            return null;
                        });
                    }
                });
                promise.then(function (data) {
                    if (!data) {
                        return;
                    }
                    try {
                        _this.submitOrderDisabled = true;
                        _this.submitted = true;
                        switch (_this.selectedPaymentMethodTypeID) {
                            case Enums.PaymentMethodType.BankTransfer:
                                _this.myForm = _this.frmBankTransfer;
                                break;
                            case Enums.PaymentMethodType.Check:
                                _this.myForm = _this.frmCheck;
                                break;
                            case Enums.PaymentMethodType.CreditCard:
                                _this.myForm = _this.frmCreditCard;
                                break;
                            case Enums.PaymentMethodType.MoneyOrder:
                                _this.myForm = _this.frmMoneyOrder;
                                break;
                        }
                        if (_this.balanceDue > 0 && _this.showPaymentInputFields) {
                            _this.frmPaymentAmount.$setSubmitted();
                            _this.myForm.$setSubmitted();
                            _this.frmSignature.$setSubmitted();
                        }
                        if ((_this.myForm.$valid
                            || _this.balanceDue <= 0
                            || (_this.balanceDue > 0 && _this.showPaymentInputFields == false)
                            || (_this.isImpersonating
                                && _this.selectedPaymentOption
                                && _this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.None))
                            && (_this.agreeToESigAndTandC || _this.isImpersonating || _this.isInChangeProcess)
                            && (_this.frmSignature.$valid || _this.isImpersonating || _this.isInChangeProcess)
                            && _this.getHasError_PaymentAmount() == false) {
                            if (_this.pulseContext.isLoggedInUserTermStaff
                                && _this.selectedPaymentOption
                                && _this.selectedPaymentOption.paymentAmount < _this.balanceDue
                                && _this.termStaffHasSeenBalanceDueWarning == false) {
                                _this.showBalanceDueWarningForTermStaff();
                                return;
                            }
                            if (_this.selectedPaymentOption
                                && _this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.DepositPlusInstallments
                                && _this.scheduledPaymentsInfo) {
                                _this.selectedPaymentOption.monthlyPaymentDay = _this.scheduledPaymentsInfo.monthlyPaymentDay;
                            }
                            _this.common.clearStatus();
                            _this.common.toggleSpinner(true, null, null, 0);
                            var purchaseInfo_1 = {};
                            if (_this.balanceDue > 0
                                && _this.showPaymentInputFields
                                && _this.selectedPaymentOption
                                && _this.selectedPaymentOption.paymentOptionTypeID != PaymentMgr.PaymentOptionType.None) {
                                purchaseInfo_1.customerFirstName = _this.pulseContext.actingAsUser.firstName;
                                purchaseInfo_1.customerLastName = _this.pulseContext.actingAsUser.lastName;
                                purchaseInfo_1.paymentMethodTypeID = _this.selectedPaymentMethodTypeID;
                                switch (_this.selectedPaymentMethodTypeID) {
                                    case Enums.PaymentMethodType.BankTransfer:
                                        purchaseInfo_1.bankTransferDTO = _this.bankTransferInfo;
                                        purchaseInfo_1.bankTransferDTO.bankCode = _this.selectedPaymentsOsBank.code;
                                        break;
                                    case Enums.PaymentMethodType.Check:
                                    case Enums.PaymentMethodType.MoneyOrder:
                                        purchaseInfo_1.checkDTO = _this.checkInfo;
                                        break;
                                    case Enums.PaymentMethodType.CreditCard:
                                        purchaseInfo_1.creditCardDTO = null;
                                        _this.creditCardInfo.userID = _this.pulseContext.actingAsUserId;
                                        _this.creditCardInfo.expMonth = _this.selectedExpMonth.id;
                                        _this.creditCardInfo.expYear = _this.selectedExpYear.id;
                                        if (_this.showBillingAddressFields) {
                                            _this.creditCardInfo.countryTypeID = _this.selectedCountryType.typeID;
                                            if (_this.showProvinceSelectField) {
                                                _this.creditCardInfo.stateTypeID = _this.selectedProvinceType.typeID;
                                            }
                                            if (_this.showStateSelectField) {
                                                _this.creditCardInfo.stateTypeID = _this.selectedStateType.typeID;
                                            }
                                        }
                                        var o = _this.pulseContext.regFlowMgr.paymentMgr.validateCreditCardNumber(_this.creditCardInfo.creditCardNumber);
                                        if (!o.valid) {
                                            _this.common.showError("Credit card number is invalid.", true, { timeOut: 0 });
                                            _this.submitted = false;
                                            _this.common.toggleSpinner(false, true);
                                            return;
                                        }
                                        break;
                                }
                            }
                            if (_this.selectedPaymentOption) {
                                purchaseInfo_1.paymentOptionDTO = _this.selectedPaymentOption.toDTO();
                            }
                            purchaseInfo_1.orderSourceTypeID = _this.selectedOrderSourceTypeID;
                            purchaseInfo_1.shoppingCartDTO = _this.cart;
                            purchaseInfo_1.signUpForBalloonPayment = (_this.selectedPaymentMethodTypeID != Enums.PaymentMethodType.CreditCard
                                || (_this.selectedPaymentOption && _this.selectedPaymentOption.paymentOptionTypeID === PaymentMgr.PaymentOptionType.Full))
                                ? false : _this.signUpForBalloonPayment;
                            purchaseInfo_1.textMessageAlertsOptIn = _this.pulseContext.regFlowMgr.shoppingCartMgr.textMessageAlertsOptIn;
                            if (_this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.CreditCard) {
                                if (_this.showPaymentInputFields === false) {
                                    return _this.purchase(purchaseInfo_1);
                                }
                                else {
                                    if (_this.cart.currencyType.typeID == Enums.CurrencyType.USD) {
                                        return _this.pulseContext.regFlowMgr.paymentMgr.getCyberSecureAcceptanceData()
                                            .then(function (response) {
                                            purchaseInfo_1.creditCardDTO = {};
                                            purchaseInfo_1.creditCardDTO = Object.assign(purchaseInfo_1.creditCardDTO, _this.creditCardInfo);
                                            var fields = response;
                                            if (fields.is_enabled) {
                                                return _this.pulseContext.regFlowMgr.paymentMgr.getCyberSecureAcceptanceToken(purchaseInfo_1.creditCardDTO, fields)
                                                    .then(function (response) {
                                                    purchaseInfo_1.creditCardDTO.cofToken = response.token;
                                                    purchaseInfo_1.creditCardDTO.creditCardNumber = response.maskedPan;
                                                    purchaseInfo_1.creditCardDTO.creditCardTypeID =
                                                        _this.pulseContext.regFlowMgr.paymentMgr.convertCyberCreditCardTypeToPulseTypeID(response.cardType);
                                                    return _this.purchase(purchaseInfo_1);
                                                })
                                                    .catch(function (err) {
                                                    _this.common.toggleSpinner(false, true);
                                                    if (err.isForUser) {
                                                        _this.common.showError(err.message, true, { timeOut: 0 });
                                                    }
                                                    else {
                                                        return _this.purchase(purchaseInfo_1);
                                                    }
                                                });
                                            }
                                            else {
                                                return _this.purchase(purchaseInfo_1);
                                            }
                                        });
                                    }
                                    else {
                                        return _this.pulseContext.regFlowMgr.paymentMgr.getPaymentsOsData(_this.cart.currencyType.typeID)
                                            .then(function (response) {
                                            var POS = window.POS;
                                            var data = response;
                                            POS.setEnvironment(data.environment);
                                            POS.setPublicKey(data.publicKey);
                                            purchaseInfo_1.creditCardDTO = {};
                                            purchaseInfo_1.creditCardDTO = Object.assign(purchaseInfo_1.creditCardDTO, _this.creditCardInfo);
                                            try {
                                                var expMonth = ("0" + _this.creditCardInfo.expMonth).slice(-2);
                                                POS.tokenize({
                                                    "token_type": "credit_card",
                                                    "holder_name": _this.creditCardInfo.nameOnCard,
                                                    "expiration_date": expMonth + "-" + _this.creditCardInfo.expYear,
                                                    "card_number": _this.creditCardInfo.creditCardNumber,
                                                    "credit_card_cvv": _this.creditCardInfo.creditCardCVV,
                                                }, function (result) {
                                                    var tokenData = JSON.parse(result);
                                                    if (tokenData.category && tokenData.category == "api_request_error") {
                                                        if (tokenData.more_info.includes("card_number")) {
                                                            _this.common.showError("Credit card number is invalid.", true, { timeOut: 0 });
                                                        }
                                                        else {
                                                            _this.common.showError("Unexpected tokenization error: " + tokenData.more_info, true, { timeOut: 0 });
                                                        }
                                                        _this.common.$timeout(function () { _this.common.toggleSpinner(false, true); }, 250);
                                                        return;
                                                    }
                                                    purchaseInfo_1.creditCardDTO.cofToken = tokenData.token;
                                                    purchaseInfo_1.creditCardDTO.creditCardNumber = tokenData.last_4_digits;
                                                    purchaseInfo_1.creditCardDTO.creditCardTypeID =
                                                        _this.pulseContext.regFlowMgr.paymentMgr.convertPaymentsOsCardTypeToPulseTypeID(tokenData.vendor);
                                                    return _this.purchase(purchaseInfo_1);
                                                });
                                            }
                                            catch (err) {
                                                _this.common.toggleSpinner(false, true);
                                                _this.common.showError("An unexpected error has occurred during tokenization, please try again.", true, { timeOut: 0 });
                                                return;
                                            }
                                            ;
                                        });
                                    }
                                }
                            }
                            else {
                                return _this.purchase(purchaseInfo_1);
                            }
                        }
                        else {
                            if (_this.getHasError_PaymentAmount()) {
                                var invalidField = angular.element("[name='paymentAmount']");
                                if (invalidField) {
                                    invalidField.focus();
                                }
                            }
                            else if (_this.myForm.$valid == false) {
                                switch (_this.selectedPaymentMethodTypeID) {
                                    case Enums.PaymentMethodType.BankTransfer:
                                        _this.setFocusOnFirstInvalid("frmBankTransfer");
                                        break;
                                    case Enums.PaymentMethodType.Check:
                                        _this.setFocusOnFirstInvalid("frmCheck");
                                        break;
                                    case Enums.PaymentMethodType.CreditCard:
                                        _this.setFocusOnFirstInvalid("frmCreditCard");
                                        break;
                                    case Enums.PaymentMethodType.MoneyOrder:
                                        _this.setFocusOnFirstInvalid("frmMoneyOrder");
                                        break;
                                }
                            }
                            else if (_this.frmSignature.$valid == false) {
                                if (!_this.isImpersonating) {
                                    _this.setFocusOnFirstInvalid("frmSignature");
                                }
                            }
                            _this.common.showWarning("Please review the errors.");
                        }
                    }
                    catch (err) {
                        _this.logError(err, null, { timeOut: 0 });
                    }
                    finally {
                        _this.submitOrderDisabled = false;
                    }
                })
                    .catch(function (err) {
                    _this.logError(err, null, { timeOut: 0 });
                });
            };
            BillingCtrl.prototype.triggerCartInfoEvent = function (cart) {
                if (this.pulseContext.actingAsUser) {
                    var dataObj = { first: '', last: '', email: '', count: 0 };
                    var user = this.pulseContext.actingAsUser;
                    dataObj.first = user.firstName;
                    dataObj.last = user.lastName;
                    dataObj.email = user.userName;
                    if (cart) {
                        dataObj.count = ShoppingCartMgr.CountStandAlonePurchasableProducts(cart);
                    }
                    Pulse.Common.DataAccess.Managers.UserBrowsingMgr.TriggerCartInfoEvent(dataObj);
                }
            };
            BillingCtrl.prototype.getHasError_PaymentAmount = function (formControl) {
                var hasError = false;
                this.paymentAmountError = "";
                if (this.submitted || (!formControl || formControl.$dirty)) {
                    if (this.balanceDue > 0 && (!this.selectedPaymentOption
                        || this.selectedPaymentOption.paymentOptionTypeID === PaymentMgr.PaymentOptionType.PleaseSelect)) {
                        hasError = true;
                        this.paymentAmountError = "Please select a payment option";
                    }
                    else if (this.balanceDue > 0) {
                        if (this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Partial) {
                            if (this.submitted) {
                                if (this.selectedPaymentOption.paymentAmount < this.paymentOptionsInfo.discountAdjustedDepositAmount
                                    || this.selectedPaymentOption.paymentAmount >= this.balanceDue) {
                                    hasError = true;
                                    this.paymentAmountError = "Please enter a partial payment amount that is less than full payment and equal to or more than the required deposit amount";
                                }
                            }
                        }
                        else if (this.selectedPaymentOption.paymentOptionTypeID == PaymentMgr.PaymentOptionType.Other) {
                            if (this.submitted) {
                                if (this.selectedPaymentOption.paymentAmount <= 0
                                    || this.selectedPaymentOption.paymentAmount >= this.balanceDue) {
                                    hasError = true;
                                    this.paymentAmountError = "Please enter an amount greater than zero and less than the full payment";
                                }
                            }
                        }
                    }
                }
                return hasError;
            };
            BillingCtrl.prototype.getMonthlyRenewalDayOrdinal = function () {
                return ShoppingCartMgr.GetMonthlyRenewalDayOrdinal();
            };
            BillingCtrl.controllerId = "billingCtrl";
            BillingCtrl.DATE_FORMAT = "M!/d!/yyyy";
            BillingCtrl.STR_INVALID_DATE = "Please enter a valid date";
            BillingCtrl.STR_REQUIRED_FIELD = "This is a required field";
            return BillingCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.BillingCtrl = BillingCtrl;
        Pulse.app.controller(BillingCtrl.controllerId, ["$scope",
            "$location",
            "$templateCache",
            "$filter",
            "common",
            "breezeService",
            "pulseContextService",
            "bootstrapDatePickerDefaultConfig",
            BillingCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var RegFlowContactInfoCtrl = (function (_super) {
            __extends(RegFlowContactInfoCtrl, _super);
            function RegFlowContactInfoCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RegFlowContactInfoCtrl.controllerId) || this;
                _this.formName = "formContactInfo";
                _this.user = _this.pulseContext.actingAsUser;
                if (_this.breezeService && _this.breezeService.getEntityManager()) {
                    _this.breezeService.getEntityManager().rejectChanges();
                }
                _this.activationPromises.push(_this.getUserMailingAddress());
                _this.activationPromises.push(_this.isUserContactInfoCompleted());
                _this.activateController()
                    .then(function () {
                    var dataObj = { first: '', last: '', email: '', count: 0 };
                    var user = _this.pulseContext.actingAsUser;
                    dataObj.first = user.firstName;
                    dataObj.last = user.lastName;
                    dataObj.email = user.userName;
                    dataObj.count = 0;
                    Pulse.Common.DataAccess.Managers.UserBrowsingMgr.TriggerCartInfoEvent(dataObj);
                });
                return _this;
            }
            RegFlowContactInfoCtrl.prototype.isUserContactInfoCompleted = function () {
                var _this = this;
                this.userMgr = this.pulseContext.userMgr;
                var promise = this.userMgr.IsContactInfoCompleted()
                    .then(function (data) {
                    _this.isContactInfoCompleted = (data[0]);
                }).catch(function (err) {
                    _this.logError(err);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            RegFlowContactInfoCtrl.prototype.getUserMailingAddress = function () {
                var _this = this;
                this.common.toggleSpinner(true);
                var uaDAO = new DataAccess.UserAddressDAO(this.common, this.breezeService, this.pulseContext);
                var promise = uaDAO.getActiveByUserIdAndTypeId(this.pulseContext.actingAsUserId, Pulse.Common.Enums.AddressType.Home)
                    .then(function (data) {
                    if (angular.isUndefined(data)) {
                        var uaDAO = new DataAccess.UserAddressDAO(_this.common, _this.breezeService, _this.pulseContext);
                        _this.mailingAddress = uaDAO.Create({
                            userID: _this.pulseContext.actingAsUserId,
                            addressTypeID: Enums.AddressType.Home
                        });
                    }
                    else {
                        _this.mailingAddress = data;
                        _this.mailingAddress.countryType = { typeID: data.countryTypeID };
                        _this.mailingAddress.stateType = { typeID: data.stateTypeID };
                    }
                    return data;
                })
                    .catch(function (error) {
                    _this.logError(error);
                    return null;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            RegFlowContactInfoCtrl.prototype.submit = function () {
                var _this = this;
                if (!this.myForm.$valid)
                    return;
                if (this.myForm.$dirty || this.breezeService.getEntityManager().hasChanges()) {
                    this.common.toggleSpinner(true);
                    this.breezeService.saveChanges(null, { resourceName: "User_SaveContactInfo" })
                        .then(function (data) {
                        _this.pulseContext.refreshUserInfo();
                        _this.myForm.$setPristine();
                        _this.breezeService.getEntityManager().rejectChanges();
                        _this.$location.url(Routes.RegFlow_OrderConfirmation);
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                        _this.submitted = false;
                    });
                }
                else {
                    this.$location.url(Routes.RegFlow_OrderConfirmation);
                }
            };
            RegFlowContactInfoCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            RegFlowContactInfoCtrl.controllerId = "regFlowContactInfoCtrl";
            return RegFlowContactInfoCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.RegFlowContactInfoCtrl = RegFlowContactInfoCtrl;
        Pulse.app.controller(RegFlowContactInfoCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", RegFlowContactInfoCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var RakutenMgr = DataAccess.Managers.RakutenMgr;
        var OrderConfirmationCtrl = (function (_super) {
            __extends(OrderConfirmationCtrl, _super);
            function OrderConfirmationCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OrderConfirmationCtrl.controllerId) || this;
                _this.downloadingPDF = false;
                _this.showWaitSpinnerInIFrame = false;
                _this.emailAddress = "";
                _this.emailAddressError = "";
                _this.isFormsAvailable = true;
                _this._rakutanImageUrl = null;
                _this._vipOnly = null;
                _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                _this.checkUnsavedDataBeforeNav = false;
                _this.activationPromises.push(_this.getUserContactMethods());
                return _this;
            }
            Object.defineProperty(OrderConfirmationCtrl.prototype, "isOrderConfirmationRetrieved", {
                get: function () {
                    return angular.isObject(this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "orderConfirmationInfo", {
                get: function () {
                    if (!this.isOrderConfirmationRetrieved) {
                        return null;
                    }
                    else {
                        return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.orderConfirmationInfo;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "arborDayFoundationUrl", {
                get: function () {
                    return "https://www.arborday.org/";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "arborDayFoundationLogoUrl", {
                get: function () {
                    return this.common.config.mediaServerUrl + OrderConfirmationCtrl.ORDER_CONFIRMATION_IMAGE_URL + "/ArborDayFoundationLogo.png";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "congratsImageSrc", {
                get: function () {
                    return this.common.config.appRoot + "assets/images/congrats.svg";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "hardware", {
                get: function () {
                    return this.orderConfirmationInfo.hardware;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "hasPurchasedOnlyCampAtHqOrTutorOrSquadOrVirtualCampProducts", {
                get: function () {
                    return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadOnlyCampAtHqOrTutorOrSquadOrVirtualCampProducts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "hasPurchasedOnlyProductCouponProducts", {
                get: function () {
                    return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadOnlyProductCouponProducts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "hasPurchasedOnlyTutorProducts", {
                get: function () {
                    return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadOnlyTutorProducts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "hasPurchasedTutorProducts", {
                get: function () {
                    return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadTutorProducts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "hasPurchasedOnlyTutorOrSquadOrVirtualCampProducts", {
                get: function () {
                    return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadOnlyTutorOrSquadOrVirtualCampProducts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "cartHadOnlySquadProducts", {
                get: function () {
                    return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadOnlySquadProducts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "cartHadOnlyVirtualCampProducts", {
                get: function () {
                    return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadOnlyVirtualCampProducts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "hasCoursesOrVirtualCampsOrSquads", {
                get: function () {
                    return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadCourseProducts
                        || this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadVirtualCampProducts
                        || this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadSquadProducts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "hasCoursesOrTutorOrVirtualCampsOrSquads", {
                get: function () {
                    return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadCourseProducts
                        || this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadVirtualCampProducts
                        || this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadSquadProducts
                        || this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHadTutorProducts;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "scheduleDateWhenHardware", {
                get: function () {
                    return this.orderConfirmationInfo.scheduleDateWhenHardware;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "showRaf", {
                get: function () {
                    return this.hasCoursesOrVirtualCampsOrSquads
                        && this.orderConfirmationInfo && this.orderConfirmationInfo.rafNumber != "N/A";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "divisionNameOfFirstProduct", {
                get: function () {
                    var divisionName = '';
                    var orderedProducts = this.getOrderProducts();
                    if (orderedProducts.length > 0) {
                        divisionName = orderedProducts[0].divisionName;
                    }
                    return divisionName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "videoImageUrl", {
                get: function () {
                    return this.common.config.appRoot + "assets/images/reg-flow/order-conf-congrats-video-02.png";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "videoPlayImageUrl", {
                get: function () {
                    return this.common.config.appRoot + "assets/images/reg-flow/play-button-02.png";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "videoUrl", {
                get: function () {
                    return this.common.config.mediaServerUrl + "/ordconf/registration-celebration.mp4";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(OrderConfirmationCtrl.prototype, "rakutanImageUrl", {
                get: function () {
                    if (this._rakutanImageUrl)
                        return this._rakutanImageUrl;
                    this._rakutanImageUrl = RakutenMgr.transformJSONtoPixelURL(this.orderConfirmationInfo.rakutenSKUOrderInfo);
                    return this._rakutanImageUrl;
                },
                enumerable: false,
                configurable: true
            });
            OrderConfirmationCtrl.prototype.getUserContactMethods = function () {
                var _this = this;
                var promise = this.pulseContext.userMgr.getContactMethodsForActingAsUser()
                    .then(function (data) {
                    var ucm = data.filter(function (ucm) { return ucm.contactMethodTypeID === Enums.ContactMethodType.Email && ucm.isPrimaryNumber; })[0];
                    _this.primaryEmail = ucm ? ucm.contactMethodOther : '';
                    return data;
                })
                    .catch(function (error) {
                    _this.logError(error);
                    return undefined;
                });
                return promise;
            };
            OrderConfirmationCtrl.prototype.getOrderProducts = function () {
                var products = [];
                for (var i = 0; i < this.orderConfirmationInfo.participants.length; i++) {
                    var participant = this.orderConfirmationInfo.participants[i];
                    for (var j = 0; j < participant.courses.length; j++) {
                        products.push(participant.courses[j]);
                    }
                    for (var j = 0; j < participant.products.length; j++) {
                        products.push(participant.products[j]);
                    }
                }
                for (var i = 0; i < this.orderConfirmationInfo.nonParticipantProducts.length; i++) {
                    var course = this.orderConfirmationInfo.nonParticipantProducts[i];
                    products.push(course);
                }
                return products;
            };
            OrderConfirmationCtrl.prototype.getIsFormsAvailable = function () {
                var shoppingCartPurchaseResult = this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult;
                if (!shoppingCartPurchaseResult) {
                    this.isFormsAvailable = false;
                    return;
                }
                var courses = shoppingCartPurchaseResult.orderConfirmationInfo.participants.map(function (p) { return p.courses; });
                var flattenedCourses = [].concat.apply([], courses);
                for (var _i = 0, flattenedCourses_1 = flattenedCourses; _i < flattenedCourses_1.length; _i++) {
                    var c = flattenedCourses_1[_i];
                    if (c && c.isRequiredFormsOpen) {
                        this.isFormsAvailable = true;
                        return;
                    }
                }
                this.isFormsAvailable = false;
            };
            OrderConfirmationCtrl.prototype.onViewLoaded = function () {
                _super.prototype.onViewLoaded.call(this);
                if (!this.isOrderConfirmationRetrieved) {
                    this.$location.url(Routes.MyAccount);
                }
                var userBrowsingMgr = this.regFlowMgr.userBrowsingMgr;
                this.pulseContext.regFlowMgr.shoppingCartMgr.clearCachedCart();
                if (userBrowsingMgr.currentUBSession.userBrowsingID > 0 &&
                    this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.cartHasAdditionalCurrencies == false) {
                    userBrowsingMgr.removeUserBrowsingSession(userBrowsingMgr.currentUBSession);
                    this.pulseContext.shoppingCartType = Enums.ShoppingCartType.RegFlow;
                    this.pulseContext.regFlowMgr = null;
                }
                this.getIsFormsAvailable();
            };
            OrderConfirmationCtrl.prototype.downloadOrderPDF = function () {
                if (!this.pulseContext.isLoggedIn) {
                    this.common.showWarning("Sorry, you can no longer download order details because your login session has expired.  You should receive and email from us with your order details attached.");
                }
                else {
                    var orderID = this.orderConfirmationInfo.orderID;
                    var fileName = "Order " + orderID + ".pdf";
                    var deferred = this.common.$q.defer();
                    var self_1 = this;
                    this.common.toggleSpinner(true);
                    var regFlowMgr = this.pulseContext.regFlowMgr;
                    regFlowMgr.downloadOrderConfirmationPDF(orderID)
                        .then(function (response) {
                        var headers = response.headers();
                        var contentType = headers["content-type"];
                        var linkElement = document.createElement('a');
                        linkElement.setAttribute('style', "display: none");
                        try {
                            var blob = new Blob([response.data], { type: contentType });
                            var userAgent = navigator.userAgent;
                            if (userAgent.match('CriOS')) {
                                var reader = new FileReader();
                                reader.onloadend = function () { window.open(reader.result.toString()); };
                                reader.readAsDataURL(blob);
                            }
                            else {
                                var url = window.URL.createObjectURL(blob);
                                linkElement.setAttribute('download', fileName);
                                linkElement.setAttribute('href', url);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            }
                        }
                        catch (ex) {
                            self_1.logError(ex);
                        }
                    })
                        .catch(function (error) {
                        var jsonString = Pulse.Utils.JS.uInt8ArrayBufferToString(error.data);
                        var jsonError = JSON.parse(jsonString);
                        error.exceptionMessage = jsonError["message"];
                        error.data = null;
                        self_1.logError(error);
                        deferred.reject(error);
                    })
                        .finally(function () {
                        self_1.common.toggleSpinner(false);
                    });
                }
            };
            OrderConfirmationCtrl.prototype.gotoMyAccount = function () {
                this.$location.url(Routes.SplashPage);
            };
            OrderConfirmationCtrl.prototype.closeVideo = function () {
                var img = document.getElementById("congratsVideoImage");
                img.style.display = "block";
                img = document.getElementById("ord-conf-video-gradient");
                img.style.display = "block";
                img = document.getElementById("congratsVideoImagePlay");
                img.style.display = "";
                var vidBackdrop = document.getElementById("congratsVideoBackdrop");
                vidBackdrop.style.display = "none";
                var vid = document.getElementById("congratsVideo");
                vid.pause();
            };
            OrderConfirmationCtrl.prototype.playVideo = function () {
                var _this = this;
                var img = document.getElementById("congratsVideoImage");
                img.style.display = "none";
                img = document.getElementById("congratsVideoImagePlay");
                img.style.display = "none";
                img = document.getElementById("ord-conf-video-gradient");
                img.style.display = "none";
                var vidBackdrop = document.getElementById("congratsVideoBackdrop");
                vidBackdrop.style.display = "block";
                var vid = document.getElementById("congratsVideo");
                if (!vid.onended) {
                    vid.onended = function () {
                        _this.closeVideo();
                    };
                }
                try {
                    vid.currentTime = 0;
                }
                catch (err) {
                    console.log(err);
                }
                vid.play();
            };
            OrderConfirmationCtrl.prototype.pauseVideo = function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                var vid = document.getElementById("congratsVideo");
                if (vid.paused) {
                    vid.play();
                }
                else {
                    vid.pause();
                }
            };
            OrderConfirmationCtrl.prototype.navigateToRequiredForm = function () {
                this.$location.url(Routes.MyAccount_RequiredForms);
            };
            Object.defineProperty(OrderConfirmationCtrl.prototype, "hasPurchasedOnlyVIPEarlyAccess", {
                get: function () {
                    if (this._vipOnly === null) {
                        var value = this.$location.search()[QueryStringUtils.VIP_ONLY];
                        this._vipOnly = value === 'true' || value === true;
                    }
                    return this._vipOnly;
                },
                enumerable: false,
                configurable: true
            });
            OrderConfirmationCtrl.prototype.securityCheck = function () {
                if (!this.pulseContext.isLoggedIn) {
                    this.canSee = false;
                }
                else if (this.pulseContext.isImpersonating) {
                    this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3);
                }
                else {
                    this.canSee = true;
                }
            };
            OrderConfirmationCtrl.prototype.getHasError_EmailAddress = function (formControl) {
                var hasError = false;
                this.emailAddressError = "";
                if (this.submitted) {
                    if (this.emailAddress == null || this.emailAddress.trim() == '') {
                        hasError = true;
                        this.emailAddressError = "Please enter your friend's email address";
                    }
                }
                return hasError;
            };
            OrderConfirmationCtrl.controllerId = "orderConfirmationCtrl";
            OrderConfirmationCtrl.ORDER_CONFIRMATION_IMAGE_URL = "/ordconf";
            return OrderConfirmationCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.OrderConfirmationCtrl = OrderConfirmationCtrl;
        Pulse.app.controller(OrderConfirmationCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            OrderConfirmationCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var ResumeCartCtrl = (function (_super) {
            __extends(ResumeCartCtrl, _super);
            function ResumeCartCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ResumeCartCtrl.controllerId) || this;
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.activateController();
                return _this;
            }
            ResumeCartCtrl.prototype.resumeShoppingCart = function () {
                var _this = this;
                this.common.toggleSpinner(true, null, null, 0);
                this.userBrowsingMgr.redirectToResumeAbandonedShoppingCart(this.userBrowsingMgr.currentUBSession)
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            ResumeCartCtrl.prototype.goToMyAccount = function () {
                this.$location.url(Routes.SplashPage);
            };
            ResumeCartCtrl.prototype.emptyCartAndProceed = function () {
                var _this = this;
                this.common.toggleSpinner(true);
                this.userBrowsingMgr.removeUserBrowsingSession(this.userBrowsingMgr.currentUBSession)
                    .then(function () {
                    _this.$location.url(Routes.SplashPage);
                }).finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            ResumeCartCtrl.controllerId = "resumeCartCtrl";
            return ResumeCartCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ResumeCartCtrl = ResumeCartCtrl;
        Pulse.app.controller(ResumeCartCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            ResumeCartCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var SplashCtrl = (function (_super) {
            __extends(SplashCtrl, _super);
            function SplashCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SplashCtrl.controllerId) || this;
                _this.isAlwaysToJobAccount = false;
                _this.jobAccountImgUrl = _this.pulseContext.pulse1x_PublicUrlRoot + '/Images/MyAccount_SplashPage_myAccount.jpg';
                _this.clientAccountImgUrl = _this.pulseContext.pulse1x_PublicUrlRoot + '/Images/MyAccount_SplashPage_myClientAccount.jpg';
                var user = _this.pulseContext.actingAsUser;
                _this.goToMyClientAccount();
                _this.activateController();
                return _this;
            }
            SplashCtrl.prototype.goToMyJobAccount = function () {
                if (this.isAlwaysToJobAccount) {
                    this.pulseContext.userMgr
                        .updateSplashPageChoice(this.isAlwaysToJobAccount)
                        .then(function () {
                    })
                        .catch(function (err) {
                        console.log(err);
                        return;
                    })
                        .finally(function () {
                    });
                }
                this.$location.url(Routes.TermStaff);
            };
            SplashCtrl.prototype.goToMyClientAccount = function () {
                var returnUrl = this.$location.search()[QueryStringUtils.RETURN_URL];
                if (Pulse.Utils.JS.isValidReturnUrl(returnUrl)) {
                    this.$location.url(Routes.DispatcherPage + '?' + QueryStringUtils.RETURN_URL + '=' + returnUrl);
                }
                else {
                    this.$location.url(Routes.DispatcherPage);
                }
            };
            SplashCtrl.controllerId = 'splashCtrl';
            return SplashCtrl;
        }(Pulse.Common.BaseCtrl));
        Controllers.SplashCtrl = SplashCtrl;
        Pulse.app.controller(SplashCtrl.controllerId, ['$scope', '$location', 'common', 'breezeService', 'pulseContextService', SplashCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var TermsAndConditionsMgr = Pulse.Common.DataAccess.Managers.TermsAndConditionsMgr;
        var AnnouncementMgr = Pulse.Common.DataAccess.Managers.AnnouncementMgr;
        var DispatcherCtrl = (function (_super) {
            __extends(DispatcherCtrl, _super);
            function DispatcherCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, DispatcherCtrl.controllerId) || this;
                _this.url = "";
                var params = QueryStringUtils.GetParams($location.url());
                if (QueryStringUtils.ContainsQS_HashCode($location.url())) {
                    if (!angular.isUndefined(params[QueryStringUtils.USERFORMDETAIL_ID])
                        || !angular.isUndefined(params[QueryStringUtils.USERBROWSINGCOMMLOG_ID])) {
                        var userId = parseInt(params[QueryStringUtils.USER_ID]);
                        if (isNaN(userId) || userId !== _this.pulseContext.actingAsUserId) {
                            _this.pulseContext.logout(true);
                            $location.url(Routes.Login + "?" + QueryStringUtils.RETURN_URL + "=" + encodeURIComponent($location.url()));
                            return _this;
                        }
                    }
                    _this.url += QueryStringUtils.GetQueryString($location.url());
                }
                else {
                    params[QueryStringUtils.COMPANY_ID] = _this.pulseContext.companyId;
                    _this.url = QueryStringUtils.AddOrSetQSParams(_this.url, params);
                }
                _this.activationPromises.push(_this.isUserContactInfoCompleted());
                _this.isPopupOpen = null;
                $scope.$watch("vm.isPopupOpen", function (newValue, oldValue) {
                    if (newValue !== oldValue && newValue === false && oldValue === true) {
                        $location.url(Routes.MyAccount);
                    }
                });
                _this.activateController();
                return _this;
            }
            DispatcherCtrl.prototype.isUserContactInfoCompleted = function () {
                var _this = this;
                this.userMgr = this.pulseContext.userMgr;
                var promise = this.userMgr.IsContactInfoCompleted()
                    .then(function (data) {
                    _this.isContactInfoCompleted = (data[0]);
                    var urlLC = _this.url.toLowerCase();
                    if (urlLC.indexOf("/applicant/") > 0) {
                        _this.$location.url(Routes.TermStaff);
                    }
                    else {
                        if (!_this.pulseContext.isImpersonating && !_this.isContactInfoCompleted) {
                            _this.navigateWithReturnUrl(Routes.MyAccount_ContactInfo);
                            return;
                        }
                        else {
                            _this.hasUserSeenCurrentAnnouncement();
                        }
                    }
                }).catch(function (err) {
                    _this.logError(err);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            DispatcherCtrl.prototype.hasUserSeenCurrentAnnouncement = function () {
                var _this = this;
                var announcementMgr = new AnnouncementMgr(this.common, this.breezeService, this.pulseContext);
                var promise = announcementMgr.hasSeenCurrentWelcomeMessage(this.pulseContext.companyId, this.pulseContext.actingAsUserId)
                    .then(function (data) {
                    _this.hasSeenCurrentAnnouncement = (data[0]);
                    var urlLC = _this.url.toLowerCase();
                    if (urlLC.indexOf("/applicant/") > 0) {
                        _this.$location.url(Routes.TermStaff);
                    }
                    else {
                        _this.hasUserSignedTandC();
                    }
                }).catch(function (err) {
                    _this.logError(err);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            DispatcherCtrl.prototype.hasUserSignedTandC = function () {
                var _this = this;
                var tacMgr = new TermsAndConditionsMgr(this.common, this.breezeService, this.pulseContext);
                var promise = tacMgr.hasUserAgreedToTermsAndConditions()
                    .then(function (data) {
                    _this.hasAgreedtoTandC = (data[0]);
                    if (!_this.pulseContext.isImpersonating && !_this.hasAgreedtoTandC) {
                        _this.showTandC();
                    }
                    else {
                        _this.navigateToReturnUrlOrMyAccount();
                    }
                }).catch(function (err) {
                    _this.logError(err);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            DispatcherCtrl.prototype.showTandC = function () {
                this.navigateWithReturnUrl(Routes.Terms_and_Conditions);
            };
            DispatcherCtrl.prototype.navigateToReturnUrlOrMyAccount = function () {
                var returnUrl = this.$location.search()[QueryStringUtils.RETURN_URL];
                if (Pulse.Utils.JS.isValidReturnUrl(returnUrl)) {
                    this.$location.url(returnUrl);
                }
                else {
                    this.$location.url(Routes.MyAccount);
                }
            };
            DispatcherCtrl.prototype.navigateWithReturnUrl = function (route) {
                var returnUrl = this.$location.search()[QueryStringUtils.RETURN_URL];
                if (Pulse.Utils.JS.isValidReturnUrl(returnUrl)) {
                    this.$location.url(route + "?" + QueryStringUtils.RETURN_URL + "=" + returnUrl);
                }
                else {
                    this.$location.url(route.toString());
                }
            };
            DispatcherCtrl.controllerId = "DispatcherCtrl";
            return DispatcherCtrl;
        }(Pulse.Common.BaseCtrl));
        Controllers.DispatcherCtrl = DispatcherCtrl;
        Pulse.app.controller(DispatcherCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", DispatcherCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var HomeCtrl = (function (_super) {
            __extends(HomeCtrl, _super);
            function HomeCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HomeCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                _this.activationPromises.push(_this.loadData(false));
                $scope.$on(Events.VoucherCreditRequested, function (event, data) {
                    _this.loadData(true);
                    _this.scrollToTop();
                });
                _this.activateController();
                return _this;
            }
            Object.defineProperty(HomeCtrl.prototype, "canSeeReferAFriend", {
                get: function () {
                    return this.studentList && this.studentList.length > 0
                        && !this.pulseContext.customerMgr.hasOnlyTutorOrCampAtHqProducts
                        && !this.pulseContext.customerMgr.hasOnlyNonUsdPurchases;
                },
                enumerable: false,
                configurable: true
            });
            HomeCtrl.prototype.loadData = function (isForceRefresh) {
                var _this = this;
                return this.pulseContext.customerMgr.loadStatusAndAlerts(true)
                    .then(function (result) {
                    _this.alertList = _this.pulseContext.customerMgr.alerts;
                    _this.hasReferAFriend = _this.pulseContext.customerMgr.hasReferAFriend;
                })
                    .then(function () {
                    var userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                    return userBrowsingMgr.getChangeCartSession()
                        .then(function (ubSession) {
                        if (ubSession && ubSession.userBrowsingID > 0) {
                            _this.pulseContext.shoppingCartType = ubSession.userBrowsingDTO.cartTypeID;
                            userBrowsingMgr.currentUBSession = ubSession;
                        }
                        return ubSession;
                    });
                })
                    .then(function () {
                    var customerMgr = _this.pulseContext.customerMgr;
                    if (customerMgr.isStatus(DataAccess.Managers.CustomerMgr.CustomerStatusTypeMask
                        .HasRegisteredParticipantsForTG) || isForceRefresh) {
                        return _this.pulseContext.customerMgr.loadCurrentStudents()
                            .then(function (result) {
                            var stList = _this.pulseContext.customerMgr.currentStudents;
                            _this.studentList = stList;
                        });
                    }
                });
            };
            HomeCtrl.prototype.setLocalizedTexts = function () {
                this.sPageTitle = "My Account";
                return _super.prototype.setLocalizedTexts.call(this);
            };
            HomeCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.HR);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate, Enums.UserRoleType.Compliance, Enums.UserRoleType.OnlineInstructor, Enums.UserRoleType.OPLStaff, Enums.UserRoleType.IT);
            };
            HomeCtrl.controllerId = "homeCtrl";
            return HomeCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HomeCtrl = HomeCtrl;
        Pulse.app.controller(HomeCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HomeCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var AnnouncementMgr = Pulse.Common.DataAccess.Managers.AnnouncementMgr;
        var WelcomeLetterCtrl = (function (_super) {
            __extends(WelcomeLetterCtrl, _super);
            function WelcomeLetterCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, WelcomeLetterCtrl.controllerId) || this;
                _this.user = _this.pulseContext.actingAsUser;
                var announcementMgr = new AnnouncementMgr(_this.common, _this.breezeService, _this.pulseContext);
                announcementMgr.saveUserHasSeenWelcomeMessage().then(function (data) {
                }).catch(function (err) {
                    console.log(err);
                });
                _this.activationPromises.push(_this.getWelcomeLetterContent());
                _this.activateController();
                return _this;
            }
            WelcomeLetterCtrl.prototype.getWelcomeLetterContent = function () {
                var _this = this;
                var announcementMgr = new AnnouncementMgr(this.common, this.breezeService, this.pulseContext);
                var promise = announcementMgr.getLatestWelcomeMessageContent()
                    .then(function (data) {
                    _this.welcomeLetterContent = (data[0])["data"];
                }).catch(function (err) {
                    _this.logError(err);
                })
                    .finally(function () {
                });
                return promise;
            };
            WelcomeLetterCtrl.prototype.proceed = function () {
                this.navigateToDispatcherPageWithReturnUrl();
            };
            WelcomeLetterCtrl.prototype.navigateToDispatcherPageWithReturnUrl = function () {
                var returnUrl = this.$location.search()[QueryStringUtils.RETURN_URL];
                if (Pulse.Utils.JS.isValidReturnUrl(returnUrl)) {
                    this.$location.url(Routes.DispatcherPage + "?" + QueryStringUtils.RETURN_URL + "=" + returnUrl);
                }
                else {
                    this.$location.url(Routes.DispatcherPage);
                }
            };
            WelcomeLetterCtrl.controllerId = "WelcomeLetterCtrl";
            return WelcomeLetterCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.WelcomeLetterCtrl = WelcomeLetterCtrl;
        Pulse.app.controller(WelcomeLetterCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", WelcomeLetterCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var TermsAndConditionsMgr = Pulse.Common.DataAccess.Managers.TermsAndConditionsMgr;
        var TermsAndConditionsCtrl = (function (_super) {
            __extends(TermsAndConditionsCtrl, _super);
            function TermsAndConditionsCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, TermsAndConditionsCtrl.controllerId) || this;
                _this.agreeToESigAndTandC = false;
                _this.submitted = false;
                _this.activationPromises.push(_this.getTermsAndConditionsContent());
                _this.activateController()
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                    window.setTimeout(function () {
                        _this.scrollToTop();
                    }, 500);
                });
                return _this;
            }
            TermsAndConditionsCtrl.prototype.acceptAndClose = function () {
                var _this = this;
                try {
                    this.submitted = true;
                    this.frmSignature.$setSubmitted();
                    if (this.agreeToESigAndTandC && this.frmSignature.$valid) {
                        this.common.clearStatus();
                        this.common.toggleSpinner(true, null, null, 0);
                        if (this.agreeToESigAndTandC) {
                            var tacMgr = new TermsAndConditionsMgr(this.common, this.breezeService, this.pulseContext);
                            tacMgr.saveUserTandCSignature().then(function () {
                                _this.navigateToDispatcherPageWithReturnUrl();
                            }).catch(function (err) {
                                console.log(err);
                                return;
                            });
                        }
                    }
                    else {
                        if (this.frmSignature.$valid == false) {
                            this.setFocusOnFirstInvalid("frmSignature");
                        }
                        this.common.showWarning("Please review the errors.");
                    }
                }
                catch (err) {
                    this.logError(err);
                }
                finally {
                    this.common.toggleSpinner(false);
                }
            };
            TermsAndConditionsCtrl.prototype.getTermsAndConditionsContent = function () {
                var _this = this;
                var tacMgr = new TermsAndConditionsMgr(this.common, this.breezeService, this.pulseContext);
                var promise = tacMgr.getLatestTermsAndConditionsContent()
                    .then(function (data) {
                    _this.termsAndConditionContent = (data[0])["data"];
                }).catch(function (err) {
                    _this.logError(err);
                })
                    .finally(function () {
                });
                return promise;
            };
            TermsAndConditionsCtrl.prototype.navigateToDispatcherPageWithReturnUrl = function () {
                var returnUrl = this.$location.search()[QueryStringUtils.RETURN_URL];
                if (Pulse.Utils.JS.isValidReturnUrl(returnUrl)) {
                    this.$location.url(Routes.DispatcherPage + "?" + QueryStringUtils.RETURN_URL + "=" + returnUrl);
                }
                else {
                    this.$location.url(Routes.DispatcherPage);
                }
            };
            TermsAndConditionsCtrl.prototype.onViewLoaded = function () {
                this.frmSignature = this.$scope["frmSignature"];
            };
            TermsAndConditionsCtrl.prototype.setFocusOnFirstInvalid = function (formName) {
                var firstInvalid = angular.element("[name='" + formName + "']");
                firstInvalid = angular.element(firstInvalid[0].querySelector('.ng-invalid'))[0];
                if (firstInvalid) {
                    firstInvalid.focus();
                }
            };
            TermsAndConditionsCtrl.prototype.scrollToHash = function (region) {
                this.common.scrollToHash(region);
            };
            TermsAndConditionsCtrl.prototype.showTermsAndConditionsOld = function () {
                this.common.$rootScope.$broadcast(Events.ShowIFramePopup, {
                    size: Pulse.Common.BasePopup.ModalSize.Medium,
                    initDataObj: {
                        url: this.pulseContext.pulse1x_PublicUrlRoot + "/TermsAndConditions.aspx?"
                            + QueryStringUtils.COMPANY_ID + "=" + this.pulseContext.companyId,
                        title: "Terms and Conditions",
                    },
                });
            };
            TermsAndConditionsCtrl.prototype.showTermsAndConditions = function () {
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Terms & Conditions", " " + this.termsAndConditionContent, null, null, Pulse.Common.BasePopup.ModalSize.Large);
            };
            TermsAndConditionsCtrl.controllerId = "TermsAndConditionsCtrl";
            return TermsAndConditionsCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.TermsAndConditionsCtrl = TermsAndConditionsCtrl;
        Pulse.app.controller(TermsAndConditionsCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", TermsAndConditionsCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var SEMPurchaseCtrl = (function (_super) {
            __extends(SEMPurchaseCtrl, _super);
            function SEMPurchaseCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SEMPurchaseCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                _this.alertList = [];
                if (!_this.pulseContext.customerMgr.alerts) {
                    _this.activationPromises.push(_this.pulseContext.customerMgr.loadStatusAndAlerts(true));
                }
                _this.activationPromises.push(_this.getSEMProducts());
                _this.activateController();
                return _this;
            }
            SEMPurchaseCtrl.prototype.getSEMProducts = function () {
                var _this = this;
                var prodDAO = new DataAccess.ProductDAO(this.common, this.breezeService, this.pulseContext);
                return prodDAO.getProdInfoByDivisionAndCategory(46, Enums.ProductCategoryType.Course, Enums.ProductSubCategoryType.ProductCoupon)
                    .then(function (prodDetails) {
                    _this.products = _.orderBy(prodDetails, ['name'], ['asc']).filter(function (p) { return p.catalogTypeID == Enums.SalesCatalogType.CourseBundle && p.isMainCatalogEntry; });
                });
            };
            SEMPurchaseCtrl.prototype.navigate = function (prod) {
                if (!prod)
                    return;
                this.common.$location.url(Routes.RegFlow_ProductAvailability + ("?" + QueryStringUtils.PRODUCT_ID + "=" + prod.productID));
            };
            SEMPurchaseCtrl.prototype.onActivated = function (activationResults) {
                this.alertList = this.pulseContext.customerMgr.alerts;
                this.secureAllFeatures();
            };
            SEMPurchaseCtrl.prototype.securityCheck = function () {
                this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.Corporate, 1, 2);
            };
            SEMPurchaseCtrl.controllerId = "semPurchase";
            return SEMPurchaseCtrl;
        }(Pulse.Common.BaseAdminViewCtrl));
        Controllers.SEMPurchaseCtrl = SEMPurchaseCtrl;
        Pulse.app.controller(SEMPurchaseCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            SEMPurchaseCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var RafLandingCtrl = (function (_super) {
            __extends(RafLandingCtrl, _super);
            function RafLandingCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RafLandingCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                _this.activationPromises.push(_this.pulseContext.customerMgr.loadStatusAndAlerts()
                    .then(function (result) {
                    _this.alertList = _this.pulseContext.customerMgr.alerts;
                }));
                _this.activateController();
                return _this;
            }
            RafLandingCtrl.prototype.setLocalizedTexts = function () {
                return _super.prototype.setLocalizedTexts.call(this);
            };
            RafLandingCtrl.controllerId = "rafLandingCtrl";
            return RafLandingCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.RafLandingCtrl = RafLandingCtrl;
        Pulse.app.controller(RafLandingCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            RafLandingCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var RafStatusCtrl = (function (_super) {
            __extends(RafStatusCtrl, _super);
            function RafStatusCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RafStatusCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                _this.iFrameSrc = _this.pulseContext.pulse1x_PublicUrlRoot + "/SecurePages/ViewReferrals.aspx?" +
                    QueryStringUtils.COMPANY_ID + "=" + _this.pulseContext.companyId;
                _this.activateController();
                return _this;
            }
            RafStatusCtrl.prototype.onViewLoaded = function () {
                if (this.common.isMobileView) {
                    this.common.showInfo(StringConst.Warn_ScreenSizeTooSmallForTask, { timeOut: 30000 });
                }
            };
            RafStatusCtrl.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls.push("ViewReferrals.aspx");
            };
            RafStatusCtrl.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var _this = this;
                this.common.toggleSpinner(true);
                url = url.toLowerCase();
                return _super.prototype.actionBasedOnFrameUrl.call(this, frameId, url).then(function (stopProcess) {
                    if (stopProcess)
                        return true;
                    for (var i = 0; i < _this.allowedPartialUrls.length; i++) {
                        if (url.indexOf(_this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                            return false;
                        }
                    }
                    _this.iFrameSrc = "about:blank";
                    _this.$location.url(Routes.MyAccount_RAFLanding);
                    return true;
                })
                    .catch(function (err) {
                    _this.logError(err);
                    return false;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            RafStatusCtrl.controllerId = "rafStatusCtrl";
            return RafStatusCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.RafStatusCtrl = RafStatusCtrl;
        Pulse.app.controller(RafStatusCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", RafStatusCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var ReferAFriendCtrl = (function (_super) {
            __extends(ReferAFriendCtrl, _super);
            function ReferAFriendCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ReferAFriendCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                _this.$scope.$on(Events.RafAdminStatusUpdated, function () {
                    _this.loadReferrals(true);
                });
                _this.activationPromises.push(_this.loadRAFCoupon());
                _this.activationPromises.push(_this.loadReferrals());
                _this.activateController();
                return _this;
            }
            ReferAFriendCtrl.prototype.loadRAFCoupon = function () {
                var _this = this;
                if (!this.rafCoupon) {
                    var couponDAO = new DataAccess.CouponDAO(this.common, this.breezeService, this.pulseContext);
                    return couponDAO.getCurrentRAFCouponForCustomer(this.pulseContext.actingAsUserId)
                        .then(function (rafCoupon) {
                        _this.rafCoupon = rafCoupon;
                    });
                }
                else {
                    return this.common.$q.resolve(this.rafCoupon);
                }
            };
            ReferAFriendCtrl.prototype.hasCode = function () {
                return this.rafCoupon && !String.isNullOrWhitespace(this.rafCoupon.couponCode);
            };
            ReferAFriendCtrl.prototype.getRAF_Code = function () {
                if (this.rafCoupon) {
                    return this.rafCoupon.couponCode;
                }
                return '';
            };
            ReferAFriendCtrl.prototype.loadReferrals = function (refreshCache) {
                var _this = this;
                if (refreshCache === void 0) { refreshCache = false; }
                if (refreshCache || !this.referrals) {
                    var couponDAO = new DataAccess.CouponDAO(this.common, this.breezeService, this.pulseContext);
                    return couponDAO.getReferrals()
                        .then(function (data) {
                        _this.referrals = data.referralInfos;
                        return data;
                    });
                }
                else {
                    return this.common.$q.resolve(this.referrals);
                }
            };
            ReferAFriendCtrl.controllerId = "referAFriendCtrl";
            return ReferAFriendCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ReferAFriendCtrl = ReferAFriendCtrl;
        Pulse.app.controller(ReferAFriendCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", ReferAFriendCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var PaymentMgr = Pulse.Common.DataAccess.Managers.PaymentMgr;
        var MyAccountBillingCtrl = (function (_super) {
            __extends(MyAccountBillingCtrl, _super);
            function MyAccountBillingCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, MyAccountBillingCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Billing;
                _this._paymentMgr = null;
                _this.hasActivePaymentPlan = false;
                _this.hasMadePurchase = false;
                _this.hasBalance = false;
                _this.hasTAPApplication = false;
                _this.hasOPLSubscriptions = false;
                _this._isVIPAvailable = false;
                _this.isOneOnOneUpsellVisible = true;
                _this._balanceMsg = null;
                _this._paymentMgr = new PaymentMgr(_this.common, _this.breezeService, _this.pulseContext);
                _this.checkUnsavedDataBeforeNav = false;
                _this.nextTermGroupYear = _this.pulseContext.currentTermGroup.year + 1;
                var customerMgr = _this.pulseContext.customerMgr;
                var userMgr = _this.pulseContext.userMgr;
                _this.activationPromises.push(customerMgr.loadStatusAndAlerts(true)
                    .then(function (result) {
                    _this._balanceMsg = null;
                    _this.alertList = customerMgr.alerts;
                    _this.hasActivePaymentPlan = customerMgr.isStatus(DataAccess.Managers.CustomerMgr.CustomerStatusTypeMask.HasActivePaymentPlan);
                    _this.hasMadePurchase = customerMgr.isStatus(DataAccess.Managers.CustomerMgr.CustomerStatusTypeMask.HasMadePurchaseBefore);
                    _this.hasTAPApplication = customerMgr.isStatus(DataAccess.Managers.CustomerMgr.CustomerStatusTypeMask.HasTAPApplication);
                    _this.hasOPLSubscriptions = customerMgr.isStatus(DataAccess.Managers.CustomerMgr.CustomerStatusTypeMask.HasOPLSubscriptions);
                    _this.hasBalance = customerMgr.hasBalance;
                    if (_this.hasBalance) {
                        _this.balanceInfos = customerMgr.getBalanceInfos();
                    }
                    return _this.pulseContext.thresholdMgr.loadCurrentTermGroupThresholds()
                        .then(function (result) {
                        var th_VIP_Open = _this.pulseContext.thresholdMgr.getCurrentTG_ByThresholdTypeFromLocalCache(Enums.TermThresholdImportantDateType.VIPEarlyAccessPassOpen);
                        if (th_VIP_Open && angular.isDate(th_VIP_Open.startDate) && th_VIP_Open.startDate <= _this.pulseContext.serverDateTime && _this.pulseContext.serverDateTime < th_VIP_Open.endDate) {
                            var IDTECH = 1;
                            return _this.pulseContext.discountMgr.hasEarlyAccessDiscountForNextTermGroup(IDTECH)
                                .then(function (hasDiscount) {
                                _this._isVIPAvailable = hasDiscount;
                            });
                        }
                    })
                        .then(function () {
                        if (!_this._isVIPAvailable) {
                            var couponDAO = new DataAccess.CouponDAO(_this.common, _this.breezeService, _this.pulseContext);
                            couponDAO.getByUserIDRoleTypeDiscountType(_this.pulseContext.actingAsUserId, Enums.CouponRoleType.Creator, Enums.CouponType.PurchasedCredit, Enums.DiscountSubcategoryType.EarlyAccess)
                                .then(function (coupons) {
                                if (coupons && coupons.length > 0) {
                                    var validCoupons = coupons.filter(function (c) {
                                        return _this.pulseContext.serverDateTime < c.expirationDate;
                                    });
                                    _this._isVIPAvailable = validCoupons && validCoupons.length > 0;
                                }
                            });
                        }
                    });
                }));
                _this.activationPromises.push(customerMgr.getVouchers(_this.pulseContext.actingAsUserId).then(function (vouchers) {
                    _this.vouchers = vouchers.filter(function (v) {
                        return (!v.dateUsed && (!v.expirationDate || moment(v.expirationDate).isAfter(moment(_this.pulseContext.serverDateTime))))
                            || (v.dateUsed && moment(v.dateUsed).add('y', 2).isAfter(moment(_this.pulseContext.serverDateTime)));
                    });
                }));
                _this.activateController();
                return _this;
            }
            Object.defineProperty(MyAccountBillingCtrl.prototype, "showScheduledPayments", {
                get: function () {
                    if (!this.scheduledPaymentsInfo) {
                        return false;
                    }
                    else {
                        return this.scheduledPaymentsInfo.monthlyTotals.length > 0;
                    }
                },
                enumerable: false,
                configurable: true
            });
            MyAccountBillingCtrl.prototype.addTutoring = function () {
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                }
                else {
                    this.$location.url(Routes.RegFlow_Upsell);
                }
            };
            MyAccountBillingCtrl.prototype.manageSubscription = function () {
                this.$location.url(Routes.MyAccount_OPLOnlineSessionsClient);
            };
            Object.defineProperty(MyAccountBillingCtrl.prototype, "isVIPAvailable", {
                get: function () {
                    return this._isVIPAvailable;
                },
                enumerable: false,
                configurable: true
            });
            MyAccountBillingCtrl.prototype.getBalanceMsg = function () {
                if (this._balanceMsg === null) {
                    if (this.hasBalance) {
                        var currencyFn = this.common.$filter('currency');
                        if (this.balanceInfos.length == 1) {
                            this._balanceMsg = "You have a balance of " + currencyFn(this.balanceInfos[0].balance, this.balanceInfos[0].currencyTypeID);
                        }
                        else {
                            var res = "You have balances of ";
                            var count = this.balanceInfos.length;
                            for (var i = 0; i < count; i++) {
                                res += currencyFn(this.balanceInfos[i].balance, this.balanceInfos[i].currencyTypeID) + (i < count - 1 ? " and " : "");
                            }
                            this._balanceMsg = res;
                        }
                    }
                    else {
                        this._balanceMsg = "No balance due at this time";
                    }
                }
                return this._balanceMsg;
            };
            MyAccountBillingCtrl.prototype.setLocalizedTexts = function () {
                return _super.prototype.setLocalizedTexts.call(this);
            };
            MyAccountBillingCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            MyAccountBillingCtrl.prototype.secureAllFeatures = function () {
                _super.prototype.secureAllFeatures.call(this);
                this.isOneOnOneUpsellVisible = true;
            };
            MyAccountBillingCtrl.controllerId = "myAccountBillingCtrl";
            return MyAccountBillingCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.MyAccountBillingCtrl = MyAccountBillingCtrl;
        Pulse.app.controller(MyAccountBillingCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            MyAccountBillingCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var PaymentMgr = DataAccess.Managers.PaymentMgr;
        var PaymentCtrl = (function (_super) {
            __extends(PaymentCtrl, _super);
            function PaymentCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, PaymentCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Billing;
                _this._previousMakePaymentInfo = null;
                _this._selectedCurrencyTypeID = null;
                _this.bankTransferInfo = {};
                _this.creditCardInfo = {};
                _this.checkInfo = {};
                _this.moneyOrderInfo = {};
                _this.voucherScholarshipInfo = {};
                _this.agreeToRecurring = null;
                _this.creditCardNumberCache = null;
                _this.showMakePaymentSection = true;
                _this.hasErrorMsg = false;
                _this.errMsg = "";
                _this.hasBalance = false;
                _this.paymentAmount = null;
                _this.selectedPaymentMethodTypeID = Enums.PaymentMethodType.CreditCard;
                _this.showPaymentAmountFields = true;
                _this.showPaymentSummarySection = false;
                _this.showOtherAmount = false;
                _this.otherAmountPHText = "Payment Amount";
                _this.otherPaymentAmount = null;
                _this.remainingBalance = null;
                _this.remainingContractedBalance = null;
                _this.creditCardDeclined = false;
                _this.showHasScheduledPaymentSection = false;
                _this.selectedSmsCode = "";
                _this.showSmsCode = false;
                _this.formName = "formMakePayment";
                if (_this.breezeService) {
                    _this.breezeService.getEntityManager().rejectChanges();
                }
                _this.paymentMgr = _this.pulseContext.regFlowMgr.paymentMgr;
                _this.activationPromises.push(_this.loadCurrencyTypesWithBalanceDue());
                _this.activationPromises.push(_this.pulseContext.customerMgr.loadStatusAndAlerts()
                    .then(function () {
                    _this.showHasScheduledPaymentSection = _this.pulseContext.customerMgr.hasScheduledPayment;
                }));
                _this.activationPromises.push(_this.checkForPaymentsOsRedirectCompletion());
                _this.activateController();
                return _this;
            }
            Object.defineProperty(PaymentCtrl.prototype, "previousMakePaymentInfo", {
                get: function () {
                    if (!this._previousMakePaymentInfo) {
                        if (window.sessionStorage["previousMakePaymentInfo"]) {
                            this._previousMakePaymentInfo = JSON.parse(window.sessionStorage["previousMakePaymentInfo"]);
                        }
                    }
                    return this._previousMakePaymentInfo;
                },
                set: function (info) {
                    this._previousMakePaymentInfo = info;
                    if (info) {
                        var json = this.pulseContext.regFlowMgr.paymentMgr.stringifyPayload(info);
                        window.sessionStorage["previousMakePaymentInfo"] = json;
                    }
                    else {
                        window.sessionStorage["previousMakePaymentInfo"] = null;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PaymentCtrl.prototype, "selectedCurrencyTypeID", {
                get: function () {
                    return this._selectedCurrencyTypeID;
                },
                set: function (typeID) {
                    this._selectedCurrencyTypeID = typeID;
                    this.bankTransferInfo.currencyTypeID = typeID;
                    this.bankTransferInfo.currencyTypeString = this.getCurrencyTypeString(typeID);
                    this.creditCardInfo.currencyTypeID = typeID;
                    this.creditCardInfo.currencyTypeString = this.getCurrencyTypeString(typeID);
                    if (this._selectedCurrencyTypeID > 0) {
                        this.loadPaymentMethodTypes();
                        this.loadPaymentAmountOptions();
                    }
                },
                enumerable: false,
                configurable: true
            });
            PaymentCtrl.prototype.onViewLoaded = function () {
                _super.prototype.onViewLoaded.call(this);
            };
            PaymentCtrl.prototype.onPaymentAmountSelectChange = function () {
                var _this = this;
                this.showOtherAmount = false;
                this.loadPaymentMethodTypes()
                    .then(function () {
                    if (_this.selectedPaymentOption && _this.selectedPaymentOption.value == -1) {
                        _this.showOtherAmount = true;
                    }
                });
            };
            PaymentCtrl.prototype.onPaymentMethodChange = function () {
                if (this.myForm)
                    this.myForm.$setPristine();
                if (this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.Scholarship
                    || this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.Voucher) {
                    this.showPaymentAmountFields = false;
                }
                else {
                    this.showPaymentAmountFields = true;
                }
            };
            PaymentCtrl.prototype.checkForPaymentsOsRedirectCompletion = function () {
                if (this.previousMakePaymentInfo) {
                    var previousMakePaymentInfo = this.previousMakePaymentInfo;
                    this.previousMakePaymentInfo = null;
                    var paymentsOsPaymentID = Pulse.Utils.QueryStringUtils.GetParamByName(window.location.href.toLowerCase(), "payment_id");
                    var paymentsOsChargeID = Pulse.Utils.QueryStringUtils.GetParamByName(window.location.href.toLowerCase(), "charge_id");
                    var status_1 = Pulse.Utils.QueryStringUtils.GetParamByName(window.location.href.toLowerCase(), "status");
                    if (previousMakePaymentInfo.paymentsOsPaymentID &&
                        previousMakePaymentInfo.paymentsOsPaymentID.toLowerCase() == paymentsOsPaymentID &&
                        previousMakePaymentInfo.paymentsOsChargeID &&
                        previousMakePaymentInfo.paymentsOsChargeID.toLowerCase() == paymentsOsChargeID &&
                        status_1) {
                        if (status_1.startsWith("failed")) {
                            this.selectedPaymentMethodTypeID = previousMakePaymentInfo.paymentMethodTypeID;
                            this.selectedPaymentOption = this.getPaymentAmountOptionByTypeID(previousMakePaymentInfo.paymentAmountOptionTypeID);
                            if (previousMakePaymentInfo.bankTransferDTO) {
                                this.bankTransferInfo.bankCode = previousMakePaymentInfo.bankTransferDTO.bankCode;
                                this.bankTransferInfo.customerAccountName = previousMakePaymentInfo.bankTransferDTO.customerAccountName;
                                this.bankTransferInfo.customerAccountNumber = previousMakePaymentInfo.bankTransferDTO.customerAccountNumber;
                                this.bankTransferInfo.customerAccountType = previousMakePaymentInfo.bankTransferDTO.customerAccountType;
                                this.bankTransferInfo.agreeToRecurring = previousMakePaymentInfo.bankTransferDTO.agreeToRecurring;
                                this.bankTransferInfo.currencyTypeID = previousMakePaymentInfo.bankTransferDTO.currencyTypeID;
                                this.bankTransferInfo.currencyTypeString = previousMakePaymentInfo.bankTransferDTO.currencyTypeString;
                            }
                            if (previousMakePaymentInfo.creditCardDTO) {
                                this.creditCardInfo.creditCardNumber = "";
                                this.creditCardInfo.address1 = previousMakePaymentInfo.creditCardDTO.address1;
                                this.creditCardInfo.address2 = previousMakePaymentInfo.creditCardDTO.address2;
                                this.creditCardInfo.city = previousMakePaymentInfo.creditCardDTO.city;
                                this.creditCardInfo.state = previousMakePaymentInfo.creditCardDTO.state;
                                this.creditCardInfo.postalCode = previousMakePaymentInfo.creditCardDTO.postalCode;
                                this.creditCardInfo.creditCardTypeID = previousMakePaymentInfo.creditCardDTO.creditCardTypeID;
                                this.creditCardInfo.expMonth = previousMakePaymentInfo.creditCardDTO.expMonth;
                                this.creditCardInfo.expYear = previousMakePaymentInfo.creditCardDTO.expYear;
                                this.creditCardInfo.creditCardCVV = previousMakePaymentInfo.creditCardDTO.creditCardCVV;
                                this.creditCardInfo.nameOnCard = previousMakePaymentInfo.creditCardDTO.nameOnCard;
                                this.creditCardInfo.agreeToRecurring = previousMakePaymentInfo.creditCardDTO.agreeToRecurring;
                                this.creditCardInfo.currencyTypeID = previousMakePaymentInfo.creditCardDTO.currencyTypeID;
                                this.creditCardInfo.currencyTypeString = previousMakePaymentInfo.creditCardDTO.currencyTypeString;
                            }
                            this.common.showError("Payment authorization failed.");
                            return;
                        }
                        else {
                            this.showMakePaymentSection = false;
                            previousMakePaymentInfo.paymentResultTypeID = PaymentMgr.PaymentResultType.RedirectSucceeded;
                            return this.completeMakePayment(previousMakePaymentInfo);
                        }
                    }
                }
                return;
            };
            PaymentCtrl.prototype.getCurrencyTypeString = function (typeID) {
                if (this.currencyTypesWithBalanceDue) {
                    for (var i = 0, il = this.currencyTypesWithBalanceDue.length; i < il; i++) {
                        if (this.currencyTypesWithBalanceDue[i].typeID == typeID) {
                            return this.currencyTypesWithBalanceDue[i].typeString;
                        }
                    }
                    return "unknown currency";
                }
                else {
                    return "";
                }
            };
            PaymentCtrl.prototype.getPaymentAmountOptionByTypeID = function (typeID) {
                for (var i = 0, il = this.paymentAmountOptions.length; i < il; i++) {
                    var o = this.paymentAmountOptions[i];
                    if (o.paymentAmountOptionTypeID == typeID) {
                        return o;
                    }
                }
                return null;
            };
            PaymentCtrl.prototype.getPaymentAmount = function () {
                if (this.selectedPaymentOption && this.selectedPaymentOption.value > 0) {
                    return this.selectedPaymentOption.value;
                }
                else {
                    return this.otherPaymentAmount;
                }
            };
            PaymentCtrl.prototype.getMaxOtherAmount = function () {
                if (this.pulseContext.isImpersonating) {
                    return 10000000000;
                }
                else {
                    return this.remainingBalance;
                }
            };
            PaymentCtrl.prototype.loadPaymentAmountOptions = function () {
                var _this = this;
                this.common.toggleSpinner(true, true, null, 0);
                this.paymentAmountOptions = [];
                this.hasBalance = false;
                this.remainingBalance = 0;
                return this.paymentMgr.getBalanceDue(this.pulseContext.actingAsUserId, false, true, this.selectedCurrencyTypeID)
                    .then(function (amount) {
                    var desc;
                    if (amount > 0) {
                        _this.hasBalance = true;
                        _this.remainingBalance = amount;
                        desc = "Full amount " + _this.common.$filter("currency")(amount, _this.selectedCurrencyTypeID, 2);
                        _this.paymentAmountOptions.push({ paymentAmountOptionTypeID: Enums.MakePaymentAmountOptionType.ApplyToFullBalance, value: amount, text: desc });
                    }
                    if (!_this.pulseContext.isImpersonating) {
                        if (amount <= 0) {
                            _this.$location.path(Routes.Billing);
                            return;
                        }
                        return amount;
                    }
                    else {
                        return _this.paymentMgr.getBalanceDue(_this.pulseContext.actingAsUserId, true, true, _this.selectedCurrencyTypeID)
                            .then(function (amountWithContractedPayment) {
                            if (amount != amountWithContractedPayment) {
                                _this.hasBalance = true;
                                desc = "Full amount " + _this.common.$filter("currency")(amountWithContractedPayment, _this.selectedCurrencyTypeID, 2);
                                desc += " including contracted payment coupons";
                                _this.paymentAmountOptions.push({ paymentAmountOptionTypeID: Enums.MakePaymentAmountOptionType.ApplyToFullBalanceAndContractedPaymentCoupons, value: amountWithContractedPayment, text: desc });
                                return amountWithContractedPayment;
                            }
                        });
                    }
                })
                    .finally(function () {
                    _this.selectedPaymentOption = null;
                    var paymentOpt = { paymentAmountOptionTypeID: Enums.MakePaymentAmountOptionType.ApplyToFullBalance, value: -1, text: "Other amount" };
                    _this.paymentAmountOptions.push(paymentOpt);
                    _this.otherAmountPHText = "Payment Amount (Balance is " + _this.common.$filter("currency")(_this.remainingBalance, _this.selectedCurrencyTypeID, 2) + ")";
                    if (!_this.hasBalance) {
                        _this.selectedPaymentOption = paymentOpt;
                        _this.showOtherAmount = true;
                    }
                    if (_this.paymentAmountOptions.length == 1) {
                        _this.selectedPaymentOption = _this.paymentAmountOptions[0];
                    }
                    _this.common.toggleSpinner(false, true);
                });
            };
            PaymentCtrl.prototype.loadCurrencyTypesWithBalanceDue = function () {
                var _this = this;
                this.common.toggleSpinner(true, true, null, 0);
                return this.paymentMgr.getCustomerBalanceDueByCurrencyTypes(this.pulseContext.actingAsUserId)
                    .then(function (data) {
                    var types = [];
                    types.push({ typeID: 0, typeString: "Please select currency type..." });
                    for (var i = 0, il = data.length; i < il; i++) {
                        var o = data[i];
                        types.push({ typeID: o.currencyTypeID, typeString: o.currencyTypeString + " - " + o.currencyTypeDescription });
                    }
                    _this.currencyTypesWithBalanceDue = types;
                    if (types.length == 1) {
                        if (_this.pulseContext.isImpersonating) {
                            _this.selectedCurrencyTypeID = Enums.CurrencyType.USD;
                        }
                        else {
                            throw new Error("No balance is currently due for any currency type.");
                        }
                    }
                    else if (types.length == 2) {
                        _this.selectedCurrencyTypeID = types[1].typeID;
                    }
                    else {
                        _this.selectedCurrencyTypeID = types[0].typeID;
                    }
                    return types;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false, true);
                });
            };
            PaymentCtrl.prototype.loadPaymentMethodTypes = function () {
                var _this = this;
                if (this.selectedCurrencyTypeID == Enums.CurrencyType.USD) {
                    return this.pulseContext.lookupInfoMgr.loadReleasedTypeInfo(Enums.TypeClassType.PaymentMethodType)
                        .then(function (data) {
                        var typesToRemove = [];
                        typesToRemove.push(Enums.PaymentMethodType.Cash);
                        typesToRemove.push(Enums.PaymentMethodType.Voucher);
                        if (_this.selectedPaymentOption &&
                            (_this.selectedPaymentOption.paymentAmountOptionTypeID == Enums.MakePaymentAmountOptionType.ApplyToFullBalanceAndContractedPaymentCoupons
                                || _this.selectedPaymentOption.paymentAmountOptionTypeID == Enums.MakePaymentAmountOptionType.ApplyToContractedPaymentCouponsOnly)) {
                            typesToRemove.push(Enums.PaymentMethodType.Scholarship);
                        }
                        if (!_this.pulseContext.isImpersonating) {
                            typesToRemove.push(Enums.PaymentMethodType.Check, Enums.PaymentMethodType.MoneyOrder);
                        }
                        return _this.paymentMethodTypes = data.filter(function (item) {
                            return typesToRemove.indexOf(item.typeID) < 0;
                        });
                    });
                }
                else {
                    var types = [];
                    types.push({ typeID: Enums.PaymentMethodType.CreditCard, typeString: "Credit Card" });
                    types.push({ typeID: Enums.PaymentMethodType.BankTransfer, typeString: "Bank Transfer" });
                    if (this.selectedPaymentOption &&
                        (this.selectedPaymentOption.paymentAmountOptionTypeID != Enums.MakePaymentAmountOptionType.ApplyToFullBalanceAndContractedPaymentCoupons
                            && this.selectedPaymentOption.paymentAmountOptionTypeID != Enums.MakePaymentAmountOptionType.ApplyToContractedPaymentCouponsOnly)) {
                        types.push({ typeID: Enums.PaymentMethodType.Scholarship, typeString: "Scholarship" });
                    }
                    this.paymentMethodTypes = types;
                    var deferred = this.common.$q.defer();
                    deferred.resolve(types);
                    return deferred.promise;
                }
            };
            PaymentCtrl.prototype.submitSmsCode = function (override) {
                if (override) {
                    this.previousMakePaymentInfo.paymentsOsSmsCode = override;
                }
                else {
                    if (!this.selectedSmsCode || this.selectedSmsCode.trim() == "") {
                        this.common.showWarning("Please enter the SMS code.");
                        return;
                    }
                    else {
                        this.previousMakePaymentInfo.paymentsOsSmsCode = this.selectedSmsCode;
                    }
                }
                if (override == "cancel" && !this.previousMakePaymentInfo.paymentsOsSmsCancelUrl) {
                    this.previousMakePaymentInfo = null;
                    this.showSmsCode = false;
                    if (this.creditCardNumberCache) {
                        this.creditCardInfo.creditCardNumber = this.creditCardNumberCache;
                    }
                }
                else {
                    return this.completeMakePayment(this.previousMakePaymentInfo);
                }
            };
            PaymentCtrl.prototype.beginMakePayment = function () {
                var _this = this;
                if (!this.myForm.$valid) {
                    return;
                }
                try {
                    this.submitted = true;
                    this.hasErrorMsg = false;
                    this.common.clearStatus();
                    this.common.toggleSpinner(true, true, null, 0);
                    var makePaymentInfo_1 = {};
                    makePaymentInfo_1.currencyTypeID = this.selectedCurrencyTypeID;
                    makePaymentInfo_1.customerUserID = this.pulseContext.actingAsUserId;
                    makePaymentInfo_1.paymentAmount = this.getPaymentAmount();
                    makePaymentInfo_1.paymentAmountOptionTypeID = this.selectedPaymentOption ? this.selectedPaymentOption.paymentAmountOptionTypeID : Enums.MakePaymentAmountOptionType.ApplyToFullBalance;
                    makePaymentInfo_1.paymentMethodTypeID = this.selectedPaymentMethodTypeID;
                    switch (this.selectedPaymentMethodTypeID) {
                        case Enums.PaymentMethodType.BankTransfer:
                            makePaymentInfo_1.bankTransferDTO = this.bankTransferInfo;
                            break;
                        case Enums.PaymentMethodType.Check:
                        case Enums.PaymentMethodType.MoneyOrder:
                            makePaymentInfo_1.checkDTO = this.checkInfo;
                            break;
                        case Enums.PaymentMethodType.CreditCard:
                            this.creditCardInfo.userID = makePaymentInfo_1.customerUserID;
                            makePaymentInfo_1.creditCardDTO = null;
                            var o = this.paymentMgr.validateCreditCardNumber(this.creditCardInfo.creditCardNumber);
                            if (!o.valid) {
                                this.formatAndDisplayErrorMsg("Credit card number is invalid.");
                                this.submitted = false;
                                this.common.toggleSpinner(false, true);
                                return;
                            }
                            break;
                        case Enums.PaymentMethodType.Scholarship:
                            makePaymentInfo_1.couponCode = this.voucherScholarshipInfo.couponCode;
                            makePaymentInfo_1.couponValidationString = this.voucherScholarshipInfo.couponValidationString;
                            break;
                    }
                    if (this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.CreditCard) {
                        if (this.selectedCurrencyTypeID == Enums.CurrencyType.USD) {
                            return this.paymentMgr.getCyberSecureAcceptanceData()
                                .then(function (response) {
                                makePaymentInfo_1.creditCardDTO = {};
                                makePaymentInfo_1.creditCardDTO = Object.assign(makePaymentInfo_1.creditCardDTO, _this.creditCardInfo);
                                var fields = response;
                                if (fields.is_enabled) {
                                    return _this.paymentMgr.getCyberSecureAcceptanceToken(makePaymentInfo_1.creditCardDTO, fields)
                                        .then(function (response) {
                                        makePaymentInfo_1.creditCardDTO.cofToken = response.token;
                                        makePaymentInfo_1.creditCardDTO.creditCardNumber = response.maskedPan;
                                        makePaymentInfo_1.creditCardDTO.creditCardTypeID = _this.paymentMgr.convertCyberCreditCardTypeToPulseTypeID(response.cardType);
                                        return _this.completeMakePayment(makePaymentInfo_1);
                                    })
                                        .catch(function (err) {
                                        if (err.isForUser) {
                                            _this.formatAndDisplayErrorMsg(err.message);
                                        }
                                        else {
                                            return _this.completeMakePayment(makePaymentInfo_1);
                                        }
                                    });
                                }
                                else {
                                    return _this.completeMakePayment(makePaymentInfo_1);
                                }
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false, true);
                                _this.submitted = false;
                            });
                        }
                        else {
                            return this.pulseContext.regFlowMgr.paymentMgr.getPaymentsOsData(this.selectedCurrencyTypeID)
                                .then(function (response) {
                                var POS = window.POS;
                                var data = response;
                                POS.setEnvironment(data.environment);
                                POS.setPublicKey(data.publicKey);
                                makePaymentInfo_1.creditCardDTO = {};
                                makePaymentInfo_1.creditCardDTO = Object.assign(makePaymentInfo_1.creditCardDTO, _this.creditCardInfo);
                                try {
                                    var expMonth = ("0" + _this.creditCardInfo.expMonth).slice(-2);
                                    POS.tokenize({
                                        "token_type": "credit_card",
                                        "holder_name": _this.creditCardInfo.nameOnCard,
                                        "expiration_date": expMonth + "-" + _this.creditCardInfo.expYear,
                                        "card_number": _this.creditCardInfo.creditCardNumber,
                                        "credit_card_cvv": _this.creditCardInfo.creditCardCVV,
                                    }, function (result) {
                                        var tokenData = JSON.parse(result);
                                        if (tokenData.category && tokenData.category == "api_request_error") {
                                            if (tokenData.more_info.includes("card_number")) {
                                                _this.formatAndDisplayErrorMsg("Credit card number is invalid.");
                                            }
                                            else {
                                                _this.formatAndDisplayErrorMsg("Unexpected tokenization error: " + tokenData.more_info);
                                            }
                                            _this.submitted = false;
                                            _this.common.$timeout(function () { _this.common.toggleSpinner(false, true); }, 250);
                                            return;
                                        }
                                        _this.creditCardNumberCache = makePaymentInfo_1.creditCardDTO.creditCardNumber;
                                        makePaymentInfo_1.creditCardDTO.cofToken = tokenData.token;
                                        makePaymentInfo_1.creditCardDTO.creditCardNumber = tokenData.last_4_digits;
                                        makePaymentInfo_1.creditCardDTO.creditCardTypeID =
                                            _this.pulseContext.regFlowMgr.paymentMgr.convertPaymentsOsCardTypeToPulseTypeID(tokenData.vendor);
                                        return _this.completeMakePayment(makePaymentInfo_1);
                                    });
                                }
                                catch (err) {
                                    _this.common.toggleSpinner(false, true);
                                    _this.submitted = false;
                                    _this.formatAndDisplayErrorMsg(err);
                                }
                                ;
                            })
                                .catch(function (err) {
                                _this.common.toggleSpinner(false, true);
                                _this.submitted = false;
                                _this.formatAndDisplayErrorMsg(err);
                            });
                        }
                    }
                    else if (this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.Scholarship
                        || this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.Voucher) {
                        if (!makePaymentInfo_1.paymentAmount) {
                            makePaymentInfo_1.paymentAmount = 0;
                        }
                        return this.paymentMgr.getDiscountAmountForMakePayment(makePaymentInfo_1)
                            .then(function (discountAmount) {
                            _this.common.toggleSpinner(false, true);
                            var couponeType = _this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.Scholarship ? "scholarship"
                                : "voucher";
                            var discountAmountStr = _this.common.$filter("currency")(discountAmount, _this.selectedCurrencyTypeID, 2);
                            var confirmMsg = "The " + couponeType + " with the value of " + discountAmountStr + " will be applied to your balance. Do you wish to continue with the payment?";
                            var dlg = _this.common.dialogService.confirm(StringConst.Title_Confirmation, confirmMsg, { dialogId: 'MyDialogId', size: 'sm' });
                            if (_this.pulseContext.isImpersonating) {
                                _this.common.scrollToHash('MyDialogId', 0, 0, 1);
                            }
                            return dlg.result.then(function (btn) {
                                _this.common.toggleSpinner(true, null, null, 0);
                                makePaymentInfo_1.paymentAmount = discountAmount;
                                return _this.completeMakePayment(makePaymentInfo_1)
                                    .finally(function () {
                                    _this.common.toggleSpinner(false, true);
                                    _this.submitted = false;
                                });
                            }, function (btn) {
                            });
                        })
                            .catch(function (err) {
                            _this.formatAndDisplayErrorMsg(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false, true);
                            _this.submitted = false;
                        });
                    }
                    else {
                        return this.completeMakePayment(makePaymentInfo_1)
                            .finally(function () {
                            _this.common.toggleSpinner(false, true);
                            _this.submitted = false;
                        });
                        ;
                    }
                }
                catch (err) {
                    this.common.toggleSpinner(false, true);
                    this.submitted = false;
                    this.formatAndDisplayErrorMsg(err);
                }
            };
            PaymentCtrl.prototype.completeMakePayment = function (makePaymentInfo) {
                var _this = this;
                this.common.toggleSpinner(true, true, null, 0);
                if (this.myForm)
                    this.myForm.$setPristine();
                return this.paymentMgr.makePayment(makePaymentInfo)
                    .then(function (response) {
                    if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.SMS_CodeRequired
                        || response.paymentResultTypeID == PaymentMgr.PaymentResultType.SMS_CodeResend
                        || response.paymentResultTypeID == PaymentMgr.PaymentResultType.RedirectRequired) {
                        _this.common.toggleSpinner(false, true);
                        makePaymentInfo.paymentID = response.paymentID;
                        makePaymentInfo.paymentResultTypeID = response.paymentResultTypeID;
                        makePaymentInfo.paymentsOsPaymentID = response.paymentsOsPaymentID;
                        makePaymentInfo.paymentsOsChargeID = response.paymentsOsChargeID;
                        makePaymentInfo.paymentsOsSmsCancelUrl = response.paymentsOsSmsCancelUrl;
                        makePaymentInfo.paymentsOsSmsPostUrl = response.paymentsOsSmsPostUrl;
                        makePaymentInfo.paymentsOsSmsResendUrl = response.paymentsOsSmsResendUrl;
                        _this.previousMakePaymentInfo = makePaymentInfo;
                        if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.SMS_CodeResend) {
                            _this.common.showInfo("SMS code has been resent.");
                        }
                        else if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.RedirectRequired) {
                            window.location.href = response.paymentsOsRedirectUrl;
                            return;
                        }
                        _this.selectedSmsCode = "";
                        _this.showSmsCode = true;
                        return;
                    }
                    else if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.SMS_CodeCancelled) {
                        _this.common.toggleSpinner(false, true);
                        _this.previousMakePaymentInfo = null;
                        _this.showSmsCode = false;
                        return;
                    }
                    else {
                        _this.showSmsCode = false;
                    }
                    if (response.paymentResultTypeID == PaymentMgr.PaymentResultType.Accepted) {
                        _this.showConfirmation(makePaymentInfo);
                        _this.creditCardDeclined = false;
                        _this.common.showSuccess('make payment was successful!');
                    }
                    else if (_this.selectedPaymentMethodTypeID == Enums.PaymentMethodType.CreditCard
                        && (response.paymentResultTypeID == PaymentMgr.PaymentResultType.Rejected
                            || response.paymentResultTypeID == PaymentMgr.PaymentResultType.Error_PaymentProcessor
                            || response.paymentResultTypeID == PaymentMgr.PaymentResultType.Error_UnexpectedError
                            || response.paymentResultTypeID == PaymentMgr.PaymentResultType.Error_GeneralDecline)) {
                        _this.showMakePaymentSection = true;
                        _this.hasErrorMsg = true;
                        _this.errMsg = response.error;
                        _this.creditCardDeclined = true;
                    }
                    else {
                        _this.showMakePaymentSection = true;
                        _this.common.showError('make payment failed:' + response.paymentResultTypeID);
                    }
                    return response;
                })
                    .catch(function (err) {
                    _this.showMakePaymentSection = true;
                    _this.formatAndDisplayErrorMsg(err);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false, true);
                    _this.submitted = false;
                });
            };
            PaymentCtrl.prototype.showConfirmation = function (makePaymentInfo) {
                var _this = this;
                this.common.toggleSpinner(true, true, null, 0);
                if (this.myForm)
                    this.myForm.$setPristine();
                this.paymentMgr.getBalanceDue(this.pulseContext.actingAsUserId, false, true, makePaymentInfo.currencyTypeID)
                    .then(function (amount) {
                    _this.selectedCurrencyTypeID = makePaymentInfo.currencyTypeID;
                    _this.paymentAmount = makePaymentInfo.paymentAmount;
                    _this.remainingBalance = amount;
                    if (!_this.pulseContext.isImpersonating) {
                        _this.showPaymentSummarySection = true;
                        return;
                    }
                    return _this.paymentMgr.getBalanceDue(_this.pulseContext.actingAsUserId, true, true, makePaymentInfo.currencyTypeID)
                        .then(function (amountWithContractedPayment) {
                        if (amount != amountWithContractedPayment) {
                            _this.remainingContractedBalance = amountWithContractedPayment - amount;
                        }
                        _this.showPaymentSummarySection = true;
                        return;
                    });
                })
                    .finally(function () {
                    _this.showMakePaymentSection = false;
                    _this.common.toggleSpinner(false, true);
                });
            };
            PaymentCtrl.prototype.formatAndDisplayErrorMsg = function (err) {
                if (this.creditCardNumberCache) {
                    this.creditCardInfo.creditCardNumber = this.creditCardNumberCache;
                }
                var errMsg = "";
                if (typeof err === 'string' || err instanceof String) {
                    errMsg += err;
                }
                else if (err.datea && (err.data.message || err.data.exceptionMessage)) {
                    if (err.data.message) {
                        errMsg += "<div>" + err.data.message + "</div>";
                    }
                    if (err.data.exceptionMessage) {
                        errMsg += "<div>" + err.data.exceptionMessage + "</div>";
                    }
                }
                else if (err.data && err.data.modelState && err.data.modelState.showToUserWarning) {
                    var errMsgArr = err.data.modelState.showToUserWarning;
                    errMsgArr.forEach(function (err) {
                        errMsg += "<div>" + err + "</div>";
                    });
                }
                if (errMsg == "")
                    errMsg = "An unexpected error has occurred.";
                this.common.showError(errMsg, true, { timeOut: 0 });
            };
            PaymentCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            PaymentCtrl.controllerId = "paymentCtrl";
            return PaymentCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.PaymentCtrl = PaymentCtrl;
        Pulse.app.controller(PaymentCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", PaymentCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var StatementMgr = DataAccess.Managers.StatementMgr;
        var TermGroupDAO = DataAccess.TermGroupDAO;
        var StatementsCtrl = (function (_super) {
            __extends(StatementsCtrl, _super);
            function StatementsCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, StatementsCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Billing;
                _this.selectedEntityCompany = null;
                _this.selectedTermGroupYear = null;
                _this.logoUrl = _this.common.config.appRoot + 'assets/images/icons/new/logo-25.svg';
                if (_this.breezeService) {
                    _this.breezeService.getEntityManager().rejectChanges();
                }
                _this.statementMgr = new StatementMgr(_this.common, _this.breezeService, _this.pulseContext);
                _this.termGroupDAO = new TermGroupDAO(_this.common, _this.breezeService, _this.pulseContext);
                if (_this.$location.search().termGroupYear) {
                    _this.selectedTermGroupYear = _this.$location.search().termGroupYear;
                }
                _this.activationPromises.push(_this.loadTermGroupYears());
                _this.activationPromises.push(_this.loadSimplifiedStatement());
                _this.activateController();
                return _this;
            }
            Object.defineProperty(StatementsCtrl.prototype, "isIE11OrLess", {
                get: function () {
                    var sAgent = window.navigator.userAgent;
                    var Idx = sAgent.indexOf("MSIE");
                    var version = 0;
                    if (Idx > 0)
                        version = parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
                    else if (!!navigator.userAgent.match(/Trident\/7\./))
                        version = 11;
                    else
                        version = 0;
                    if (version == 0) {
                        return false;
                    }
                    else {
                        return true;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(StatementsCtrl.prototype, "totalCredits", {
                get: function () {
                    var sum = 0;
                    if (this.simplifiedStatementDTO) {
                        if (this.simplifiedStatementDTO.totalDiscountsAmount > 0) {
                            sum += this.simplifiedStatementDTO.totalDiscountsAmount;
                        }
                        sum += this.simplifiedStatementDTO.totalAppliedCredit;
                        if (this.simplifiedStatementDTO.totalRafRewards > 0) {
                            sum += this.simplifiedStatementDTO.totalRafRewards;
                        }
                    }
                    return sum;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(StatementsCtrl.prototype, "totalCreditsColor", {
                get: function () {
                    if (!this.simplifiedStatementDTO) {
                        return '#cccccc';
                    }
                    else {
                        if (this.simplifiedStatementDTO.totalAppliedCredit > 0 && this.simplifiedStatementDTO.totalRafRewards > 0) {
                            return '#cccccc';
                        }
                        else {
                            return 'white';
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(StatementsCtrl.prototype, "totalRafRewardsColor", {
                get: function () {
                    if (!this.simplifiedStatementDTO) {
                        return '#cccccc';
                    }
                    else {
                        if (this.simplifiedStatementDTO.totalDiscountsAmount > 0 && this.simplifiedStatementDTO.totalAppliedCredit > 0) {
                            return 'white';
                        }
                        else {
                            return '#cccccc';
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            StatementsCtrl.prototype.getFileNameFromHttpResponse = function (httpResponse) {
                var contentDispositionHeader = httpResponse.headers('Content-Disposition');
                var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
                return result.replace(/"/g, '');
            };
            StatementsCtrl.prototype.onViewLoaded = function () {
                _super.prototype.onViewLoaded.call(this);
            };
            StatementsCtrl.prototype.loadSimplifiedStatement = function () {
                var _this = this;
                this.common.clearStatus();
                this.common.toggleSpinner(true, true, null, 0);
                var selectedSubsidiary = 0;
                if (this.selectedEntityCompany == null) {
                    this.selectedEntityCompany = { entityCompanyID: 0 };
                }
                else if (this.simplifiedStatementDTO == null) {
                    selectedSubsidiary = this.selectedEntityCompany.entityCompanyID;
                }
                else {
                    selectedSubsidiary = this.simplifiedStatementDTO.selectedSubsidiary;
                }
                if (this.selectedTermGroupYear == null) {
                    this.selectedTermGroupYear = 0;
                }
                return this.statementMgr.getSimplifiedStatement(this.pulseContext.actingAsUserId, selectedSubsidiary, this.selectedTermGroupYear)
                    .then(function (dto) {
                    _this.simplifiedStatementDTO = dto;
                    _this.simplifiedStatementDTO.totalCharges = 0;
                    var bgIndex = 1;
                    var i, il, j, jl, k, kl;
                    for (i = 0, il = _this.simplifiedStatementDTO.participants.length; i < il; ++i) {
                        var participant = _this.simplifiedStatementDTO.participants[i];
                        participant.bgIndex = bgIndex++;
                        participant.total = 0;
                        for (j = 0, jl = participant.items.length; j < jl; ++j) {
                            var item = participant.items[j];
                            participant.total += item.itemPrice;
                            for (k = 0, kl = item.options.length; k < kl; ++k) {
                                var option = item.options[k];
                                participant.total += option.itemPrice;
                            }
                        }
                        _this.simplifiedStatementDTO.totalCharges += participant.total;
                    }
                    _this.simplifiedStatementDTO.otherTotal = 0;
                    if (_this.simplifiedStatementDTO.nonParticipantItems) {
                        _this.simplifiedStatementDTO.nonParticipantItemsBgIndex = bgIndex++;
                        for (i = 0, il = _this.simplifiedStatementDTO.nonParticipantItems.length; i < il; ++i) {
                            var item = _this.simplifiedStatementDTO.nonParticipantItems[i];
                            _this.simplifiedStatementDTO.otherTotal += item.itemPrice;
                        }
                    }
                    _this.simplifiedStatementDTO.totalCharges += _this.simplifiedStatementDTO.otherTotal;
                    bgIndex = 0;
                    if (_this.simplifiedStatementDTO.totalDiscountsAmount > 0) {
                        _this.simplifiedStatementDTO.totalCreditsDiscountsBgIndex = bgIndex++;
                    }
                    if (_this.simplifiedStatementDTO.totalAppliedCredit > 0) {
                        _this.simplifiedStatementDTO.totalCreditsAppliedBgIndex = bgIndex++;
                    }
                    if (_this.simplifiedStatementDTO.totalRafRewards > 0) {
                        _this.simplifiedStatementDTO.totalCreditsRafBgIndex = bgIndex++;
                    }
                    bgIndex = 1;
                    _this.simplifiedStatementDTO.totalPayments = 0;
                    for (i = 0, il = _this.simplifiedStatementDTO.payments.length; i < il; ++i) {
                        _this.simplifiedStatementDTO.payments[i].bgIndex = bgIndex++;
                        _this.simplifiedStatementDTO.totalPayments += _this.simplifiedStatementDTO.payments[i].paymentAmount;
                    }
                    _this.simplifiedStatementDTO.totalPaymentsBgIndex = bgIndex++;
                    _this.selectedEntityCompany = _this.simplifiedStatementDTO.entities[0];
                    if (_this.simplifiedStatementDTO.termGroupYears) {
                        _this.selectedTermGroupYear = _this.simplifiedStatementDTO.termGroupYears[0];
                    }
                    _this.simplifiedStatementDTO.balanceDueForEntity = _this.simplifiedStatementDTO.totalCharges
                        - _this.simplifiedStatementDTO.totalAppliedCredit
                        - _this.simplifiedStatementDTO.totalDiscountsAmount
                        - _this.simplifiedStatementDTO.totalRafRewards
                        - _this.simplifiedStatementDTO.totalPayments
                        + _this.simplifiedStatementDTO.totalRefunds;
                    _this.selectedTermGroupYear = _this.simplifiedStatementDTO.campYear;
                })
                    .catch(function (err) {
                    _this.logError(err);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false, true);
                });
            };
            StatementsCtrl.prototype.loadTermGroupYears = function () {
                var _this = this;
                return this.termGroupDAO.getActive()
                    .then(function (data) {
                    _this.termGroupYears = data;
                });
            };
            StatementsCtrl.prototype.print = function () {
                var _this = this;
                if (this.isIE11OrLess) {
                    this.common.showWarning('Printing statements is not supported for Internet Explorer 11 or less, please use a modern browser to print.');
                    return;
                }
                if (navigator.userAgent.match(/SamsungBrowser/i)) {
                    this.common.showWarning("Printing statements is not supported for Samsung's stock browser, please use the google chrome browser to print.");
                    return;
                }
                this.common.clearStatus();
                this.common.toggleSpinner(true, true, null, 0);
                var objectUrl = null;
                var self = this;
                this.statementMgr.getSimplifiedStatementPdf(this.pulseContext.actingAsUserId, this.selectedEntityCompany.entityCompanyID, this.selectedTermGroupYear)
                    .then(function (response) {
                    var headers = response.headers();
                    var contentType = headers["content-type"];
                    var linkElement = document.createElement('a');
                    linkElement.setAttribute('style', "display: none");
                    try {
                        var blob = new Blob([response.data], { type: "application/pdf" });
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, _this.getFileNameFromHttpResponse(response));
                        }
                        else {
                            objectUrl = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('download', _this.getFileNameFromHttpResponse(response));
                            linkElement.setAttribute('href', objectUrl);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        }
                    }
                    catch (ex) {
                        self.logError(ex);
                    }
                })
                    .catch(function (err) {
                    _this.logError(err);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            StatementsCtrl.prototype.showCreditsInfo = function () {
                var template = "These are credits applied within this specific entity/country. Switch entities or view detailed statement to view all credits.";
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Credits Info", " " + template, null);
            };
            StatementsCtrl.prototype.showDiscountInfo = function () {
                var template = "Includes discounts, promotions, scholarships, multi-session discounts, etc. View itemized discounts in detailed statement.";
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Discount Info", " " + template, null);
            };
            StatementsCtrl.prototype.showEntityInfo = function () {
                var template = "If you have purchased products or services from multiple countries/entities, use this dropdown to view your other statements.<br/><br/>Note: Non-camp products/services (ex: online lessons) will appear under iD Tech";
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Entity Info", " " + template, null);
            };
            StatementsCtrl.prototype.showFeeInfo = function () {
                var template = "Includes all fees, such as Compliance and Safety Fee, balance overdue fees, change fees, cancellation fees, etc. View itemized fees in detailed statement.";
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Fee Info", " " + template, null);
            };
            StatementsCtrl.prototype.showPaymentsInfo = function () {
                var template = "These are payments applied within this specific entity/country. Switch entities or view detailed statement to view all payments.";
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Payments Info", " " + template, null);
            };
            StatementsCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            StatementsCtrl.controllerId = "statementsCtrl";
            return StatementsCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.StatementsCtrl = StatementsCtrl;
        Pulse.app.controller(StatementsCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", StatementsCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var StatementsDetailedCtrl = (function (_super) {
            __extends(StatementsDetailedCtrl, _super);
            function StatementsDetailedCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, StatementsDetailedCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Billing;
                _this.iFrameSrc = _this.pulseContext.pulse1x_PublicUrlRoot + "/SecurePages/Statements.aspx?" +
                    QueryStringUtils.COMPANY_ID + "=" + _this.pulseContext.companyId;
                if (_this.$location.search().termGroupYear) {
                    _this.iFrameSrc += "&termGroupYear=" + _this.$location.search().termGroupYear;
                }
                _this.activateController();
                return _this;
            }
            StatementsDetailedCtrl.prototype.onViewLoaded = function () {
                if (this.common.isMobileView) {
                    this.common.showInfo(StringConst.Warn_ScreenSizeTooSmallForTask, { timeOut: 30000 });
                }
                this.scrollToTop();
            };
            StatementsDetailedCtrl.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls.push("Statements.aspx", "ViewStatement.aspx", "ViewStatementForPrint.aspx");
            };
            StatementsDetailedCtrl.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var _this = this;
                this.common.toggleSpinner(true);
                url = url.toLowerCase();
                return _super.prototype.actionBasedOnFrameUrl.call(this, frameId, url).then(function (stopProcess) {
                    if (stopProcess)
                        return true;
                    for (var i = 0; i < _this.allowedPartialUrls.length; i++) {
                        if (url.indexOf(_this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                            return false;
                        }
                    }
                    _this.iFrameSrc = "about:blank";
                    _this.$location.url(Routes.Billing);
                    return true;
                })
                    .catch(function (err) {
                    _this.logError(err);
                    return false;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            StatementsDetailedCtrl.controllerId = "statementsDetailedCtrl";
            return StatementsDetailedCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.StatementsDetailedCtrl = StatementsDetailedCtrl;
        Pulse.app.controller(StatementsDetailedCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", StatementsDetailedCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var PaymentMgr = Pulse.Common.DataAccess.Managers.PaymentMgr;
        var BillingInfoCtrl = (function (_super) {
            __extends(BillingInfoCtrl, _super);
            function BillingInfoCtrl($scope, $location, $templateCache, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, BillingInfoCtrl.controllerId) || this;
                _this._billingInformation = null;
                _this._paymentMgr = null;
                _this._selectedCurrencyTypeID = null;
                _this.isAutoBillDisabled = false;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Billing;
                _this.$templateCache = $templateCache;
                if (_this.isIE11OrLess && window.sessionStorage.needPageReloadForIe11 === "true") {
                    window.sessionStorage.needPageReloadForIe11 = "false";
                    location.reload();
                }
                _this._paymentMgr = new PaymentMgr(_this.common, _this.breezeService, _this.pulseContext);
                _this.activationPromises.push(_this.loadCurrencyTypes());
                _this.activateController()
                    .catch(function (error) {
                    _this.common.showError(error);
                });
                return _this;
            }
            Object.defineProperty(BillingInfoCtrl.prototype, "billingInformation", {
                get: function () {
                    return this._billingInformation;
                },
                set: function (bi) {
                    this._billingInformation = bi;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingInfoCtrl.prototype, "changeBtnLabel", {
                get: function () {
                    if (this.selectedCurrencyTypeID != Enums.CurrencyType.USD) {
                        return "Change Credit Card or Bank Account";
                    }
                    else if (this.selectedCurrencyTypeID == Enums.CurrencyType.USD) {
                        return "Change Credit Card";
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingInfoCtrl.prototype, "isIE11OrLess", {
                get: function () {
                    var sAgent = window.navigator.userAgent;
                    var Idx = sAgent.indexOf("MSIE");
                    var version = 0;
                    if (Idx > 0)
                        version = parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
                    else if (!!navigator.userAgent.match(/Trident\/7\./))
                        version = 11;
                    else
                        version = 0;
                    if (version == 0) {
                        return false;
                    }
                    else {
                        return true;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingInfoCtrl.prototype, "isOnPaymentPlan", {
                get: function () {
                    if (this.billingInformation && this.billingInformation.monthlyTotals.length > 0) {
                        return true;
                    }
                    else {
                        return false;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingInfoCtrl.prototype, "selectedCurrencyTypeID", {
                get: function () {
                    return this._selectedCurrencyTypeID;
                },
                set: function (typeID) {
                    var _this = this;
                    this._selectedCurrencyTypeID = typeID;
                    if (this._selectedCurrencyTypeID > 0) {
                        this.common.toggleSpinner(true, null, null, 0);
                        var promises = [];
                        if (!this.creditCardTypes) {
                            promises.push(this.getCreditCardTypes());
                        }
                        promises.push(this.getRecurringPayment(this._selectedCurrencyTypeID));
                        promises.push(this.getBillingInformation(this._selectedCurrencyTypeID));
                        promises.push(this.getMissedScheduledPaymentsInfo(this._selectedCurrencyTypeID));
                        this.common.$q.all(promises)
                            .then(function (resultsArr) {
                            var idx = 0;
                            if (!_this.creditCardTypes) {
                                _this.creditCardTypes = resultsArr[idx++];
                            }
                            _this.recurringPayment = resultsArr[idx++];
                            _this.billingInformation = resultsArr[idx++];
                            _this.missedScheduledPaymentsInfo = resultsArr[idx++];
                            _this.updateRecurringDescription();
                            _this.hasCofToken = (_this.pulseContext.actingAsUser.cOFToken != null);
                        })
                            .catch(function (error) {
                            _this.common.showError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false, true);
                        });
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingInfoCtrl.prototype, "showAutoBill", {
                get: function () {
                    return this.recurringPayment
                        && this.billingInformation;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BillingInfoCtrl.prototype, "showCsControls", {
                get: function () {
                    if (!this.isOnPaymentPlan || !this.hasUnpaidScheduledPayments) {
                        return false;
                    }
                    else {
                        return this.pulseContext.isImpersonating;
                    }
                },
                enumerable: false,
                configurable: true
            });
            BillingInfoCtrl.prototype.createAutoPayDayOptions = function () {
                var select = document.getElementById('selectAutoPayDayOrdinal');
                if (select.options.length > 0) {
                    for (var i = select.options.length - 1, j = 0; i >= j; i--) {
                        select.remove(i);
                    }
                }
                for (var i = 1, j = 29; i < j; ++i) {
                    var option = document.createElement('option');
                    option.text = i;
                    option.value = i;
                    select.add(option);
                }
            };
            BillingInfoCtrl.prototype.creditCardPopupClosed = function (closedViaCloseBtn) {
                var _this = this;
                if (closedViaCloseBtn == false) {
                    this.getRecurringPayment(this.selectedCurrencyTypeID).then(function (result) {
                        _this.recurringPayment = result;
                        _this.updateRecurringDescription();
                    });
                }
            };
            BillingInfoCtrl.prototype.getBillingInformation = function (currencyTypeID) {
                var _this = this;
                return this._paymentMgr.getBillingInformation(this.pulseContext.actingAsUserId, currencyTypeID)
                    .then(function (billingInfo) {
                    var hasUnpaid = false;
                    for (var i_1 = 0, il = billingInfo.details.length; i_1 < il; i_1++) {
                        for (var j_1 = 0, jl = billingInfo.details[i_1].paymentDueInfos.length; j_1 < jl; j_1++) {
                            var paymentDueInfo = billingInfo.details[i_1].paymentDueInfos[j_1];
                            if (paymentDueInfo.statusTypeID != Enums.ScheduledPaymentStatusType.Paid) {
                                hasUnpaid = true;
                                break;
                            }
                        }
                        if (hasUnpaid)
                            break;
                    }
                    _this.enrolledInScheduledPayments = hasUnpaid;
                    _this.hasUnpaidScheduledPayments = hasUnpaid;
                    if (_this.enrolledInScheduledPayments) {
                        _this.createAutoPayDayOptions();
                        var select = document.getElementById('selectAutoPayDayOrdinal');
                        for (var i = 0, j = select.options.length; i < j; i++) {
                            var option = select.options[i];
                            if (option.value == billingInfo.monthlyPaymentDay) {
                                option.selected = true;
                                break;
                            }
                        }
                    }
                    return billingInfo;
                })
                    .catch(function (error) {
                    _this.logError(error);
                    return null;
                });
            };
            BillingInfoCtrl.prototype.getRecurringPayment = function (currencyTypeID) {
                var paymentDAO = new DataAccess.PaymentDAO(this.common, this.breezeService, this.pulseContext);
                return paymentDAO.getRecurringPaymentForUserID(this.pulseContext.actingAsUserId, currencyTypeID);
            };
            BillingInfoCtrl.prototype.getCreditCardTypes = function () {
                return this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.CreditCardType);
            };
            BillingInfoCtrl.prototype.getMissedScheduledPaymentsInfo = function (currencyTypeID) {
                return this._paymentMgr.getMissedScheduledPaymentsInfo(this.pulseContext.actingAsUserId, currencyTypeID);
            };
            BillingInfoCtrl.prototype.loadCurrencyTypes = function () {
                var _this = this;
                this.common.toggleSpinner(true, null, null, 0);
                return this._paymentMgr.getCustomerCurrencyTypesForBillingInfo(this.pulseContext.actingAsUserId)
                    .then(function (data) {
                    var types = [];
                    types.push({ typeID: 0, typeString: "Please select a currency type..." });
                    for (var i = 0, il = data.length; i < il; i++) {
                        var o = data[i];
                        types.push({ typeID: o.typeID, typeString: o.typeString + " - " + o.typeDescription });
                    }
                    if (types.length == 1) {
                        throw new Error("The customer has not made any purchases.");
                    }
                    else if (types.length == 2) {
                        _this.selectedCurrencyTypeID = types[1].typeID;
                    }
                    else {
                        _this.selectedCurrencyTypeID = types[0].typeID;
                    }
                    _this.currencyTypes = types;
                    return types;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            BillingInfoCtrl.prototype.makePayment = function () {
                this.$location.url(Routes.Billing_Payment);
            };
            BillingInfoCtrl.prototype.manageSubscription = function () {
                this.$location.url(Routes.MyAccount_OPLOnlineSessionsClient);
            };
            BillingInfoCtrl.prototype.payMissedScheduledPayments = function () {
                var _this = this;
                this.common.toggleSpinner(true, null, null, 0);
                this._paymentMgr.payMissedScheduledPayments(this.pulseContext.actingAsUserId, this.selectedCurrencyTypeID, this.missedScheduledPaymentsInfo.amount)
                    .then(function (response) {
                    return _this.getBillingInformation(_this.selectedCurrencyTypeID)
                        .then(function (data) {
                        _this.billingInformation = data;
                        return _this.getMissedScheduledPaymentsInfo(_this.selectedCurrencyTypeID)
                            .then(function (data) {
                            _this.missedScheduledPaymentsInfo = data;
                            if (response.paymentFailureCount == 0) {
                                var template = _this.$templateCache.get('pay-missed-payments-success.html');
                                _this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Payment Confirmation", " " + template, "autoBillHelp");
                            }
                            else {
                                var template = _this.$templateCache.get('pay-missed-payments-failure.html');
                                _this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Payment Failure", " " + template, "autoBillHelp");
                            }
                        });
                    });
                })
                    .catch(function (err) {
                    _this.logError(err);
                    var template = _this.$templateCache.get('pay-missed-payments-failure.html');
                    _this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Payment Failure", " " + template, "autoBillHelp");
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            BillingInfoCtrl.prototype.saveScheduledPaymentChanges = function () {
                var _this = this;
                var autoPayDayOrdinal = 0;
                var select = document.getElementById('selectAutoPayDayOrdinal');
                autoPayDayOrdinal = select.options[select.selectedIndex].value;
                this.common.toggleSpinner(true, null, null, 0);
                this._paymentMgr.updateScheduledPaymentSettings(this.pulseContext.actingAsUserId, this.enrolledInScheduledPayments, autoPayDayOrdinal)
                    .then(function () {
                    return _this.getBillingInformation(_this.selectedCurrencyTypeID)
                        .then(function (data) {
                        _this.billingInformation = data;
                    });
                })
                    .catch(function (err) {
                    _this.common.toggleSpinner(false, true);
                    if (err.isForUser) {
                        _this.common.showError(err.message, true, { timeOut: 0 });
                    }
                    else {
                        _this.logError(err);
                    }
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            BillingInfoCtrl.prototype.showAutoBillHelp = function ($event) {
                $event.preventDefault();
                var template;
                if (this.selectedCurrencyTypeID == Enums.CurrencyType.USD) {
                    template = this.$templateCache.get('autoBillUSD.html');
                }
                else {
                    template = this.$templateCache.get('autoBillNonUSD.html');
                }
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Auto-bill Help", " " + template, "autoBillHelp");
            };
            BillingInfoCtrl.prototype.showRecurringHelp = function ($event) {
                $event.preventDefault();
                var template;
                if (this.selectedCurrencyTypeID == Enums.CurrencyType.USD) {
                    template = this.$templateCache.get('recurringHelpUSD.html');
                }
                else {
                    template = this.$templateCache.get('recurringHelpNonUSD.html');
                }
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Recurring Payment Help", " " + template, "recurringHelp");
            };
            BillingInfoCtrl.prototype.showCreditCardPopup = function () {
                var _self = this;
                this.creditCardPopupApi.onClose = function (b) { _self.creditCardPopupClosed(b); };
                this.common.$rootScope.$broadcast(Events.ShowCreditCardPopup, {
                    size: '',
                    initDataObj: { currencyTypeID: this.selectedCurrencyTypeID }
                });
            };
            BillingInfoCtrl.prototype.updateRecurringDescription = function () {
                if (this.recurringPayment == null) {
                    this.recurringDescription = "None";
                }
                else {
                    if (this.recurringPayment.paymentMethodTypeID == Enums.PaymentMethodType.CreditCard) {
                        var creditCardType;
                        if (this.creditCardTypes != null) {
                            for (var i = 0, length = this.creditCardTypes.length; i < length; i++) {
                                if (this.creditCardTypes[i].typeID == this.recurringPayment.creditCardTypeID) {
                                    creditCardType = this.creditCardTypes[i].typeString.substring(0, 1).toUpperCase();
                                    break;
                                }
                            }
                        }
                        this.recurringDescription = "Credit card on file: "
                            + creditCardType
                            + "-" + this.recurringPayment.creditCardNumber
                            + ", exp date " + this.recurringPayment.expirationDate;
                    }
                    else {
                        this.recurringDescription = "Bank Account: " + this.recurringPayment.pmtOSBankCode
                            + " - " + this.recurringPayment.pmtOSCustomerAcctName
                            + " - " + this.recurringPayment.pmtOSCustomerAcctNumber
                            + " - " + this.recurringPayment.pmtOSCustomerAcctType;
                    }
                }
            };
            BillingInfoCtrl.prototype.setLocalizedTexts = function () {
                return _super.prototype.setLocalizedTexts.call(this);
            };
            BillingInfoCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            BillingInfoCtrl.controllerId = "billingInfoCtrl";
            return BillingInfoCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.BillingInfoCtrl = BillingInfoCtrl;
        Pulse.app.controller(BillingInfoCtrl.controllerId, ["$scope",
            "$location",
            "$templateCache",
            "common",
            "breezeService",
            "pulseContextService",
            BillingInfoCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var TAPCtrl = (function (_super) {
            __extends(TAPCtrl, _super);
            function TAPCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, TAPCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Billing;
                _this.iFrameSrc = _this.pulseContext.pulse1x_PublicUrlRoot + "/SecurePages/TuitionAssistanceStatus.aspx?" +
                    QueryStringUtils.COMPANY_ID + "=" + _this.pulseContext.companyId;
                _this.activateController();
                return _this;
            }
            TAPCtrl.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls.push("TuitionAssistanceStatus.aspx", "TuitionAssistanceApply.aspx");
            };
            TAPCtrl.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var _this = this;
                this.common.toggleSpinner(true);
                url = url.toLowerCase();
                return _super.prototype.actionBasedOnFrameUrl.call(this, frameId, url).then(function (stopProcess) {
                    if (stopProcess)
                        return true;
                    for (var i = 0; i < _this.allowedPartialUrls.length; i++) {
                        if (url.indexOf(_this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                            return false;
                        }
                    }
                    _this.iFrameSrc = "about:blank";
                    _this.$location.url(Routes.Billing);
                    return true;
                })
                    .catch(function (err) {
                    _this.logError(err);
                    return false;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            TAPCtrl.controllerId = "tapCtrl";
            return TAPCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.TAPCtrl = TAPCtrl;
        Pulse.app.controller(TAPCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", TAPCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var VipEarlyAccessCtrl = (function (_super) {
            __extends(VipEarlyAccessCtrl, _super);
            function VipEarlyAccessCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, VipEarlyAccessCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Billing;
                _this._isAvailable = false;
                _this.hasCoupons = false;
                _this.saveDisabled = false;
                _this.pulseContext.regFlowMgr = null;
                _this.pulseContext.shoppingCartType = Enums.ShoppingCartType.RegFlow;
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this.vip_open_endDate = _this.pulseContext.serverDateTime;
                var defer = _this.common.$q.defer();
                if (!_this.userBrowsingMgr.currentUBSession.userBrowsingDTO) {
                    defer.resolve(_this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true));
                }
                else {
                    defer.resolve();
                }
                _this.activationPromises.push(defer.promise.then(function () {
                    var prodDAO = new DataAccess.ProductDAO(_this.common, _this.breezeService, _this.pulseContext);
                    return prodDAO.getProdInfoByDivisionAndCategory(null, Enums.ProductCategoryType.PurchaseCredit, Enums.ProductSubCategoryType.EarlyAccess)
                        .then(function (prodDetails) {
                        _this.vipProdInfo = prodDetails[0];
                        _this.pulseContext.lookupInfoMgr.loadDivisionTextByDivisionAndTextType(_this.vipProdInfo.divisionID, Enums.DivisionTextType.VIPEarlyAccessPass)
                            .then(function (data) {
                            if (data.length > 0) {
                                _this.vipDivConfigText = data[0].divText;
                            }
                        });
                        return _this.pulseContext.thresholdMgr.loadCurrentTermGroupThresholds()
                            .then(function (result) {
                            _this.th_VIP_Open = _this.pulseContext.thresholdMgr.getCurrentTG_ByThresholdTypeFromLocalCache(Enums.TermThresholdImportantDateType.VIPEarlyAccessPassOpen);
                            if (_this.th_VIP_Open && angular.isDate(_this.th_VIP_Open.startDate)) {
                                if (_this.th_VIP_Open.startDate <= _this.pulseContext.serverDateTime) {
                                    _this.vipTermGroupYear = _this.pulseContext.currentTermGroup.year + 1;
                                }
                                else {
                                    _this.vipTermGroupYear = _this.pulseContext.currentTermGroup.year;
                                }
                                if (_this.th_VIP_Open.startDate <= _this.pulseContext.serverDateTime && _this.pulseContext.serverDateTime < _this.th_VIP_Open.endDate) {
                                    var IDTECH = 1;
                                    _this.activationPromises.push(_this.pulseContext.discountMgr.hasEarlyAccessDiscountForNextTermGroup(IDTECH)
                                        .then(function (hasDiscount) {
                                        _this._isAvailable = hasDiscount;
                                    }));
                                }
                                _this.vip_open_endDate = new Date(_this.th_VIP_Open.endDate.valueOf());
                                _this.vip_open_endDate.setMilliseconds(_this.th_VIP_Open.endDate.getMilliseconds() - 1);
                            }
                            return result;
                        });
                    });
                }));
                _this.loadCoupons();
                _this.activateController();
                return _this;
            }
            VipEarlyAccessCtrl.prototype.loadCoupons = function () {
                var _this = this;
                var couponDAO = new DataAccess.CouponDAO(this.common, this.breezeService, this.pulseContext);
                couponDAO.getByUserIDRoleTypeDiscountType(this.pulseContext.actingAsUserId, Enums.CouponRoleType.Creator, Enums.CouponType.PurchasedCredit, Enums.DiscountSubcategoryType.EarlyAccess)
                    .then(function (coupons) {
                    _this.vipCoupons = coupons.filter(function (c) {
                        return _this.pulseContext.serverDateTime < c.expirationDate;
                    });
                    _this.hasCoupons = _this.vipCoupons && _this.vipCoupons.length > 0 ? true : false;
                    var sortedCoupons = _this.vipCoupons.sort(function (a, b) {
                        return a.expirationDate <= b.expirationDate ? 1 : -1;
                    });
                    _this.termGroupYear = _this.hasCoupons ? sortedCoupons[0].expirationDate.getFullYear() : 0;
                });
            };
            VipEarlyAccessCtrl.prototype.isCouponAvailable = function (coupon) {
                var currentTG = this.pulseContext.currentTermGroup;
                if (coupon.numberCouponUsed > 0 || coupon.startDate > currentTG.lastSessionEnd) {
                    return false;
                }
                else {
                    return true;
                }
            };
            VipEarlyAccessCtrl.prototype.getStatusText = function (coupon) {
                var currentTG = this.pulseContext.currentTermGroup;
                if (coupon.numberCouponUsed > 0) {
                    return 'Used';
                }
                else if (coupon.startDate > currentTG.lastSessionEnd) {
                    return currentTG.year + 1 + " Season";
                }
                else {
                    return 'Available';
                }
            };
            Object.defineProperty(VipEarlyAccessCtrl.prototype, "isAvailable", {
                get: function () {
                    return this._isAvailable;
                },
                enumerable: false,
                configurable: true
            });
            VipEarlyAccessCtrl.prototype.onVIPClicked = function () {
                var _this = this;
                this.common.toggleSpinner(true);
                this.submitted = true;
                this.saveDisabled = true;
                this.pulseContext.shoppingCartType = Enums.ShoppingCartType.RegFlow;
                this.userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, false)
                    .then(function () {
                    return _this.pulseContext.userMgr.loadAddressesForActingUser(false)
                        .then(function (userAddrs) {
                        if (_this.pulseContext.isImpersonating == false) {
                            var filteredAddr = userAddrs.filter(function (ua) { return ua.addressTypeID == Enums.AddressType.Home; });
                            if (!filteredAddr || filteredAddr.length == 0) {
                                _this.common.$location.url(Routes.MyAccount_ContactInfo);
                                return;
                            }
                        }
                        var itemInfo = {};
                        itemInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                        itemInfo.userBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                        itemInfo.productID = _this.vipProdInfo.productID;
                        itemInfo.action = true;
                        return _this.userBrowsingMgr.selectItem(itemInfo)
                            .then(function (data) {
                            return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true);
                        })
                            .then(function () {
                            if (_this.userBrowsingMgr.currentUBSession.UB_ItemDTOs.length > 1) {
                                _this.common.$location.url(Routes.RegFlow_ShoppingCart);
                            }
                            else {
                                _this.common.$location.url(Routes.RegFlow_OrderSummary);
                            }
                        });
                    });
                })
                    .catch(function (err) {
                    _this.logError(err);
                    _this.breezeService.getEntityManager().rejectChanges();
                })
                    .finally(function () {
                    _this.saveDisabled = false;
                    _this.submitted = false;
                    _this.common.toggleSpinner(false);
                });
            };
            VipEarlyAccessCtrl.prototype.setLocalizedTexts = function () {
                this.sPageTitle = 'VIP Pass';
                return _super.prototype.setLocalizedTexts.call(this);
            };
            VipEarlyAccessCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            VipEarlyAccessCtrl.controllerId = 'VipEarlyAccessCtrl';
            return VipEarlyAccessCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.VipEarlyAccessCtrl = VipEarlyAccessCtrl;
        Pulse.app.controller(VipEarlyAccessCtrl.controllerId, ['$scope',
            '$location',
            'common',
            'breezeService',
            'pulseContextService',
            VipEarlyAccessCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var VouchersCtrl = (function (_super) {
            __extends(VouchersCtrl, _super);
            function VouchersCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, VouchersCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Billing;
                _this.loadVouchers();
                _this.activateController();
                return _this;
            }
            VouchersCtrl.prototype.loadVouchers = function () {
                var _this = this;
                this.pulseContext.customerMgr.getVouchers(this.pulseContext.actingAsUserId)
                    .then(function (vouchers) {
                    _this.vouchers = vouchers.filter(function (v) {
                        return (!v.dateUsed && (!v.expirationDate || moment(v.expirationDate).isAfter(moment(_this.pulseContext.serverDateTime))))
                            || (v.dateUsed && moment(v.dateUsed).add('y', 2).isAfter(moment(_this.pulseContext.serverDateTime)));
                    });
                    _this.vouchers = _.orderBy(_this.vouchers, ['consumedByUserID', 'expirationDate'], ['desc', 'asc']);
                });
            };
            VouchersCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canSee = this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Public);
            };
            VouchersCtrl.controllerId = 'VouchersCtrl';
            return VouchersCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.VouchersCtrl = VouchersCtrl;
        Pulse.app.controller(VouchersCtrl.controllerId, ['$scope',
            '$location',
            'common',
            'breezeService',
            'pulseContextService',
            VouchersCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var ProfileCtrl = (function (_super) {
            __extends(ProfileCtrl, _super);
            function ProfileCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ProfileCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Profile;
                _this.clientFormsUrl = Routes.MyAccount_RequiredForms;
                _this.hasMadePurchase = false;
                _this.hasRelatedUsers = false;
                _this.customerMgr = _this.pulseContext.customerMgr;
                _this.isImpersonating = _this.pulseContext.isImpersonating;
                _this.activationPromises.push(_this.pulseContext.customerMgr.loadStatusAndAlerts(true)
                    .then(function (result) {
                    _this.alertList = _this.pulseContext.customerMgr.alerts;
                    _this.hasStudentLicense = _this.customerMgr.hasStudentLicense;
                    _this.hasMadePurchase = _this.customerMgr.isStatus(DataAccess.Managers.CustomerMgr.CustomerStatusTypeMask.HasMadePurchaseBefore);
                }));
                _this.activationPromises.push(_this.pulseContext.userMgr.loadRelatedUsersForActingUser(false)
                    .then(function (relatedUsers) {
                    _this.hasRelatedUsers = relatedUsers ? relatedUsers.length > 0 : false;
                }));
                _this.activateController();
                return _this;
            }
            ProfileCtrl.prototype.setLocalizedTexts = function () {
                this.sPageTitle = "My Account - Profile";
                return _super.prototype.setLocalizedTexts.call(this);
            };
            ProfileCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            ProfileCtrl.controllerId = "profileCtrl";
            return ProfileCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ProfileCtrl = ProfileCtrl;
        Pulse.app.controller(ProfileCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            ProfileCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var locationChangeEvent;
        var ContactInfoCtrl = (function (_super) {
            __extends(ContactInfoCtrl, _super);
            function ContactInfoCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ContactInfoCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Profile;
                _this.formName = "formContactInfo";
                _this.user = _this.pulseContext.actingAsUser;
                locationChangeEvent = _this.$scope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
                    if (_this.breezeService && _this.breezeService.getEntityManager()) {
                        _this.breezeService.getEntityManager().rejectChanges();
                    }
                    locationChangeEvent();
                });
                _this.$scope.$on(Events.ContactChannelsUpdated, function () {
                    _this.breezeService.getEntityManager().clear();
                    return _this.loadContactInfo();
                });
                if (_this.breezeService && _this.breezeService.getEntityManager()) {
                    _this.breezeService.getEntityManager().rejectChanges();
                }
                _this.activationPromises.push(_this.loadContactInfo());
                _this.activateController();
                return _this;
            }
            ContactInfoCtrl.prototype.loadContactInfo = function () {
                var promises = [];
                promises.push(this.getUserMailingAddress());
                promises.push(this.loadUserContactMethods());
                promises.push(this.isUserContactInfoCompleted());
                return this.common.$q.all(promises);
            };
            ContactInfoCtrl.prototype.isUserContactInfoCompleted = function () {
                var _this = this;
                this.userMgr = this.pulseContext.userMgr;
                var promise = this.userMgr.IsContactInfoCompleted()
                    .then(function (data) {
                    _this.isContactInfoCompleted = (data[0]);
                }).catch(function (err) {
                    _this.logError(err);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            ContactInfoCtrl.prototype.getUserMailingAddress = function () {
                var _this = this;
                this.common.toggleSpinner(true);
                var uaDAO = new DataAccess.UserAddressDAO(this.common, this.breezeService, this.pulseContext);
                var promise = uaDAO.getActiveByUserIdAndTypeId(this.pulseContext.actingAsUserId, Pulse.Common.Enums.AddressType.Home)
                    .then(function (data) {
                    if (angular.isUndefined(data)) {
                        var uaDAO = new DataAccess.UserAddressDAO(_this.common, _this.breezeService, _this.pulseContext);
                        _this.mailingAddress = uaDAO.Create({
                            userID: _this.pulseContext.actingAsUserId,
                            addressTypeID: Enums.AddressType.Home
                        });
                    }
                    else {
                        _this.mailingAddress = data;
                        _this.mailingAddress.countryType = { typeID: data.countryTypeID };
                        _this.mailingAddress.stateType = { typeID: data.stateTypeID };
                    }
                    return data;
                })
                    .catch(function (error) {
                    _this.logError(error);
                    return null;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            ContactInfoCtrl.prototype.loadUserContactMethods = function () {
                var _this = this;
                this.common.toggleSpinner(true);
                var promise = this.pulseContext.userMgr.getContactMethodsForActingAsUser()
                    .then(function (data) {
                    data.forEach(function (ucm, index, array) {
                        ucm.contactMethodType = { typeID: ucm.contactMethodTypeID };
                    });
                    var ucmDAO = new DataAccess.UserContactMethodDAO(_this.common, _this.breezeService, _this.pulseContext);
                    _this.emailUserContactMethod =
                        data.filter(function (ucm) { return ucm.contactMethodTypeID === Enums.ContactMethodType.Email &&
                            ucm.isPrimaryNumber; })[0];
                    if (!angular.isDefined(_this.emailUserContactMethod)) {
                        _this.emailUserContactMethod = ucmDAO.Create({
                            userID: _this.pulseContext.actingAsUserId,
                            contactMethodTypeID: Enums.ContactMethodType.Email,
                            recordStateID: Enums.RecordStateType.Active,
                            isPrimaryNumber: true
                        });
                    }
                    if (_this.emailUserContactMethod.optOut == null)
                        _this.emailUserContactMethod.optOut = false;
                    _this.phoneUserContactMethods = data.filter(function (ucm) { return ucm.contactMethodTypeID <= Pulse.Common.Enums.ContactMethodType.CellPhone; });
                    if (data.filter(function (ucm) { return ucm.contactMethodTypeID <= Pulse.Common.Enums.ContactMethodType.CellPhone; }).length < 1) {
                        _this.phoneUserContactMethods.push(ucmDAO.Create({
                            userID: _this.pulseContext.actingAsUserId,
                            contactMethodTypeID: Enums.ContactMethodType.HomePhone,
                            recordStateID: Enums.RecordStateType.Active,
                            isPrimaryNumber: true
                        }));
                    }
                    else {
                        _this.phoneUserContactMethods.forEach(function (pucm) {
                            pucm.fullPhone = "+" + pucm.fullPhone.match(/\d+/)[0];
                        });
                    }
                    return data;
                })
                    .catch(function (error) {
                    _this.logError(error);
                    return undefined;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            ContactInfoCtrl.prototype.submit = function () {
                var _this = this;
                if (!this.myForm.$valid)
                    return;
                var count = 0;
                for (var i = 0; i < this.phoneUserContactMethods.length; i++) {
                    if (this.phoneUserContactMethods[i].isPrimaryNumber)
                        count++;
                }
                if (count > 1) {
                    this.common.showWarning("Please only select one Primary Number");
                    return;
                }
                if (count < 1) {
                    this.common.showWarning("Please select a Primary Number");
                    return;
                }
                if (this.myForm.$dirty || this.breezeService.getEntityManager().hasChanges()) {
                    this.common.toggleSpinner(true);
                    this.breezeService.saveChanges(null, { resourceName: "User_SaveContactInfo" })
                        .then(function (data) {
                        _this.pulseContext.refreshUserInfo();
                        _this.myForm.$setPristine();
                        _this.common.showSuccess("Contact Information Saved");
                        locationChangeEvent();
                        _this.breezeService.getEntityManager().rejectChanges();
                        var channelPreferenceMgr = new DataAccess.Managers.ChannelPreferenceMgr(_this.common, _this.breezeService, _this.pulseContext);
                        channelPreferenceMgr.subscribeToDefaultChannels();
                    })
                        .then(function () {
                        if (_this.isContactInfoCompleted)
                            _this.$location.url(Routes.MyAccount_Profile);
                        else {
                            _this.navigateToDispatcherPageWithReturnUrl();
                        }
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                        _this.submitted = false;
                    });
                }
                else {
                    this.cancel();
                }
            };
            ContactInfoCtrl.prototype.cancel = function () {
                this.$location.url(Routes.MyAccount_Profile);
            };
            ContactInfoCtrl.prototype.navigateToDispatcherPageWithReturnUrl = function () {
                var returnUrl = this.$location.search()[QueryStringUtils.RETURN_URL];
                if (Pulse.Utils.JS.isValidReturnUrl(returnUrl)) {
                    this.$location.url(Routes.DispatcherPage + "?" + QueryStringUtils.RETURN_URL + "=" + returnUrl);
                }
                else {
                    this.$location.url(Routes.DispatcherPage);
                }
            };
            ContactInfoCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            ContactInfoCtrl.controllerId = "contactInfoCtrl";
            return ContactInfoCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ContactInfoCtrl = ContactInfoCtrl;
        Pulse.app.controller(ContactInfoCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", ContactInfoCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var SecurityInfoCtrl = (function (_super) {
            __extends(SecurityInfoCtrl, _super);
            function SecurityInfoCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SecurityInfoCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Profile;
                _this.formName = "formSecurityInfo";
                _this.user = _this.pulseContext.actingAsUser;
                _this.newPassword = "";
                _this.newPasswordConfirm = "";
                _this.checkUnsavedDataBeforeNav = false;
                _this.activateController();
                return _this;
            }
            SecurityInfoCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                this.myForm = scope.myForm;
            };
            SecurityInfoCtrl.prototype.showPrivacyPolicy = function () {
                this.common.$rootScope.$broadcast(Events.ShowPrivacyPolicyPopup, {
                    size: Pulse.Common.BasePopup.ModalSize.Large,
                    initDataObj: {}
                });
            };
            SecurityInfoCtrl.prototype.submit = function () {
                var _this = this;
                if (!this.myForm.$valid)
                    return;
                var common = this.common;
                if (this.myForm.$dirty || this.breezeService.getEntityManager().hasChanges()) {
                    var entityMgr = this.breezeService.getEntityManager();
                    var query = breeze.EntityQuery
                        .from("User_SaveSecurityInfo")
                        .withParameters({
                        'userId': this.user.userID,
                        'newPassword': this.newPassword,
                        'newPasswordConfirm': this.newPasswordConfirm
                    })
                        .take(1);
                    entityMgr.executeQuery(query).then(function (data) {
                        var result = (data.results[0]);
                        if (result.success) {
                            common.showSuccess("Security Information Saved");
                            _this.$location.url(Routes.MyAccount_Profile);
                        }
                        else {
                            common.showWarning(result.message);
                            return;
                        }
                    }).catch(function (error) {
                        common.showError(error);
                        _this.logError(error);
                    }).finally(function () {
                        _this.newPassword = "";
                        _this.newPasswordConfirm = "";
                        _this.myForm.$setPristine();
                        _this.breezeService.getEntityManager().rejectChanges();
                    });
                }
                else {
                    this.cancel();
                }
            };
            SecurityInfoCtrl.prototype.cancel = function () {
                this.breezeService.getEntityManager().rejectChanges();
                this.$location.url(Routes.MyAccount_Profile);
            };
            SecurityInfoCtrl.controllerId = "securityInfoCtrl";
            return SecurityInfoCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.SecurityInfoCtrl = SecurityInfoCtrl;
        Pulse.app.controller(SecurityInfoCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", SecurityInfoCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var locationChangeEvent;
        var StudentInfoCtrl = (function (_super) {
            __extends(StudentInfoCtrl, _super);
            function StudentInfoCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, StudentInfoCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Profile;
                _this.formName = "formStudentInfo";
                if (_this.breezeService && _this.breezeService.getEntityManager()) {
                    _this.breezeService.getEntityManager().rejectChanges();
                }
                _this.activationPromises.push(_this.pulseContext.userMgr.loadRelatedUsersForActingUser(true)
                    .then(function (data) {
                    _this.participantList = data;
                    _this.participantList.forEach(function (s) { return s.isExpanded = false; });
                    for (var _i = 0, _a = _this.participantList; _i < _a.length; _i++) {
                        var u = _a[_i];
                        if (Pulse.Common.DataAccess.Managers.UserMgr.LegalGuardianRelationshipTypes.indexOf(u.userRelationTypeID) < 0) {
                            _this.canUpdate = _this.canUpdate || false;
                        }
                        else {
                            _this.canUpdate = true;
                        }
                    }
                    return data;
                }));
                _this.activateController();
                return _this;
            }
            StudentInfoCtrl.prototype.onExpandToggle = function (participant) {
                if (angular.isUndefined(participant.isExpanded))
                    participant.isExpanded = false;
                participant.isExpanded = !participant.isExpanded;
            };
            StudentInfoCtrl.prototype.submit = function () {
            };
            StudentInfoCtrl.prototype.cancel = function () {
                this.$location.url(Routes.MyAccount_Profile);
            };
            StudentInfoCtrl.prototype.onSubFormsSaveSuccess = function () {
                var hasDirtyForms = this.myForm.$getControls().filter(function (c) { return c.$name.indexOf('siStudentForm') >= 0 && c.$dirty; }).length > 0;
                if (hasDirtyForms) {
                    this.myForm.$setDirty();
                }
                else {
                    this.myForm.$setPristine();
                }
            };
            StudentInfoCtrl.prototype.navigateToDispatcherPageWithReturnUrl = function () {
                var returnUrl = this.$location.search()[QueryStringUtils.RETURN_URL];
                if (Pulse.Utils.JS.isValidReturnUrl(returnUrl)) {
                    this.$location.url(Routes.DispatcherPage + "?" + QueryStringUtils.RETURN_URL + "=" + returnUrl);
                }
                else {
                    this.$location.url(Routes.DispatcherPage);
                }
            };
            StudentInfoCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            StudentInfoCtrl.controllerId = "StudentInfoCtrl";
            return StudentInfoCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.StudentInfoCtrl = StudentInfoCtrl;
        Pulse.app.controller(StudentInfoCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", StudentInfoCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var RegFlowMgr = DataAccess.Managers.RegFlowMgr;
        var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
        var MyAccountShoppingCartCtrl = (function (_super) {
            __extends(MyAccountShoppingCartCtrl, _super);
            function MyAccountShoppingCartCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, MyAccountShoppingCartCtrl.controllerId) || this;
                _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                _this.isCartEmpty = false;
                _this.isCartRetrieved = false;
                _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                _this.shoppingCartMgr = _this.regFlowMgr.shoppingCartMgr;
                _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                _this._shoppingCartRetrieved = $scope.$on(Events.ShoppingCartRetrieved, function (event, isCartEmpty) {
                    _this.isCartRetrieved = true;
                    _this.isCartEmpty = isCartEmpty;
                });
                $scope.$on('$destroy', function () {
                    _this._shoppingCartRetrieved();
                });
                _this._addCourseHandler = $scope.$on(Events.ShoppingCartAddCourseRequest, function (event, participant) {
                    _this.onAddCourse(participant);
                });
                $scope.$on('$destroy', function () {
                    _this._addCourseHandler();
                });
                _this.activationPromises.push(_this.userBrowsingMgr.actionOnUserBrowsingRecordStatus(function () {
                    return common.$timeout(1)
                        .then(function () { return _this.cartCtrlAPI.loadShoppingCart(true); })
                        .then(function (cart) {
                        if (_this.pulseContext.actingAsUser && cart) {
                            var dataObj = { first: '', last: '', email: '', count: 0 };
                            var user = _this.pulseContext.actingAsUser;
                            dataObj.first = user.firstName;
                            dataObj.last = user.lastName;
                            dataObj.email = user.userName;
                            dataObj.count = ShoppingCartMgr.CountStandAloneProducts(cart);
                            Pulse.Common.DataAccess.Managers.UserBrowsingMgr.TriggerCartInfoEvent(dataObj);
                        }
                    });
                }, function (confirmedMerge) {
                    return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                        .then(function () {
                        return _this.cartCtrlAPI.loadShoppingCart(true);
                    });
                }, function (startNewCart) {
                    return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                        .then(function () {
                        return _this.cartCtrlAPI.loadShoppingCart(true);
                    });
                }, true));
                _this.activateController();
                return _this;
            }
            MyAccountShoppingCartCtrl.prototype.onViewLoaded = function () {
                _super.prototype.onViewLoaded.call(this);
            };
            MyAccountShoppingCartCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices);
                this.canSee = this.canUpdate;
            };
            MyAccountShoppingCartCtrl.prototype.onAddCourse = function (participant) {
                this.checkUnsavedDataBeforeNav = false;
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                }
                else {
                    this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
                }
            };
            MyAccountShoppingCartCtrl.prototype.addCourseWhenNoneInCart = function () {
                this.checkUnsavedDataBeforeNav = false;
                if (this.pulseContext.inWWW) {
                    window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                }
                else {
                    this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
                }
            };
            MyAccountShoppingCartCtrl.controllerId = "myAccountShoppingCartCtrl";
            return MyAccountShoppingCartCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.MyAccountShoppingCartCtrl = MyAccountShoppingCartCtrl;
        Pulse.app.controller(MyAccountShoppingCartCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            MyAccountShoppingCartCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var Managers = Pulse.Common.DataAccess.Managers;
        var ClientFormsMgr = Managers.ClientFormsMgr;
        var ClientFormsHomeCtrl = (function (_super) {
            __extends(ClientFormsHomeCtrl, _super);
            function ClientFormsHomeCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ClientFormsHomeCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Forms;
                _this.formStatusDict = new Pulse.Collections.Dictionary();
                _this.formSectionDict = new Pulse.Collections.Dictionary();
                _this.currentFormsInfo = null;
                _this.studentList = null;
                _this.studentListWithForms = null;
                _this.userFormInfoDict = new Pulse.Collections.Dictionary();
                _this.anyStudents = false;
                _this.anythingToSave = false;
                _this.previouslyUploadedFormsList = null;
                _this.userFormDetailsToUpload = null;
                _this.selectedUFDIDForUpload = null;
                _this.inputFiles = [];
                _this.hasInputFile = false;
                _this.inputFilePath = null;
                _this.uploadErrorMsg = null;
                _this.showARFUploader = false;
                _this.anyAdditionalFormsToUpload = false;
                _this.showPastUploads = false;
                _this.showFormsHistory = false;
                _this.submitted = false;
                _this.anyAdditionalForms = false;
                _this.formDict = new Pulse.Collections.Dictionary();
                _this.formLocationAbbrevDict = new Pulse.Collections.Dictionary();
                _this.formLocationNameDict = new Pulse.Collections.Dictionary();
                _this.isImpersonating = false;
                _this.sPageTitle = "Forms";
                _this.formName = "frmClientFormsLanding";
                _this.activationPromises.push(_this.getFormStatusTypes());
                _this.activationPromises.push(_this.getFormSectionTypes());
                _this.companyTollFreePhone = _this.pulseContext.companyTollFreePhone;
                _this.companyInternationalPhone = _this.pulseContext.companyInternationalPhone;
                _this.isImpersonating = _this.pulseContext.isImpersonating;
                _this._clientFormStatusChangingHandler = $scope.$on(Events.ClientFormStatusChanging, function (event, userFormDetailID, statusTypeID) {
                    _this.updateUserFormDetailStatus(userFormDetailID, statusTypeID);
                });
                $scope.$on('$destroy', function () {
                    _this._clientFormStatusChangingHandler();
                });
                _this._clientHistoryFormStatusChangingHandler = $scope.$on(Events.ClientHistoryFormStatusChanging, function (event, userFormDetailID, statusTypeID) {
                    _this.updateUserFormDetailStatus(userFormDetailID, statusTypeID);
                });
                $scope.$on('$destroy', function () {
                    _this._clientHistoryFormStatusChangingHandler();
                });
                _this._clientFormStatusChangesSavedHandler = $scope.$on(Events.ClientFormStatusChangesSaved, function (event) {
                    _this.getStudentsWithForms();
                });
                $scope.$on('$destroy', function () {
                    _this._clientFormStatusChangesSavedHandler();
                });
                _this.activateController();
                return _this;
            }
            Object.defineProperty(ClientFormsHomeCtrl.prototype, "atLeastOneFormToUpload", {
                get: function () {
                    return this.userFormDetailsToUpload && angular.isArray(this.userFormDetailsToUpload) && (this.userFormDetailsToUpload.length > 0);
                },
                enumerable: false,
                configurable: true
            });
            ClientFormsHomeCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canAdministerForms = this.pulseContext.isImpersonating
                    && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canAdministerForms || !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices);
                this.canChangeSectionStatus = this.canUpdate || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate, Enums.UserRoleType.Region);
                this.canSee = this.canUpdate || this.canChangeSectionStatus;
            };
            ClientFormsHomeCtrl.prototype.onActivated = function (activationResults) {
                this.getStudentsWithForms();
                this.pulseContext.healthSafetyFormMgr.clearCache();
            };
            ClientFormsHomeCtrl.prototype.setLocalizedTexts = function () {
                this.sPageTitle = "Required Forms";
                return _super.prototype.setLocalizedTexts.call(this);
            };
            ClientFormsHomeCtrl.prototype.getFormStatusTypes = function () {
                var self = this;
                this.common.toggleSpinner(true);
                var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.FormStatus)
                    .then(function (data) {
                    if (data) {
                        self.pulseContext.clientFormsMgr.loadTypeDictionary(data, self.formStatusDict);
                        self.formStatusTypes = data.filter(function (statusType) { return statusType.typeID != Enums.FormStatus.BringToSession && statusType.typeID != Enums.FormStatus.MedsOnlyIncomplete; });
                    }
                })
                    .catch(function (error) {
                    self.logError(error);
                })
                    .finally(function () {
                    self.common.toggleSpinner(false);
                });
                return promise;
            };
            ClientFormsHomeCtrl.prototype.getFormSectionTypes = function () {
                var self = this;
                this.common.toggleSpinner(true);
                var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.FormSectionType)
                    .then(function (data) {
                    self.formSectionTypes = data;
                    self.pulseContext.clientFormsMgr.loadTypeDictionary(self.formSectionTypes, self.formSectionDict);
                })
                    .catch(function (error) {
                    self.logError(error, ['System.ArgumentException']);
                })
                    .finally(function () {
                    self.common.toggleSpinner(false);
                });
                return promise;
            };
            ClientFormsHomeCtrl.prototype.getStudentsWithForms = function () {
                var self = this;
                this.common.toggleSpinner(true);
                var clientFormsMgr = this.pulseContext.clientFormsMgr;
                var promise = clientFormsMgr.getStudentsWithOrders()
                    .then(function (data) {
                    self.currentFormsInfo = data;
                    self.deriveFormInfo(self.currentFormsInfo, self.formStatusDict, self.formSectionDict);
                })
                    .catch(function (error) {
                    self.logError(error);
                })
                    .finally(function () {
                    self.common.toggleSpinner(false);
                });
                return promise;
            };
            ClientFormsHomeCtrl.prototype.deriveFormInfo = function (currentFormsInfo, formStatusDict, formSectionDict) {
                this.studentList = (this.currentFormsInfo == null) ? null : this.currentFormsInfo.studentsWithForms;
                this.studentListWithForms = (this.studentList == null) ? null
                    : this.studentList.filter(function (student) { return (student.requiredForms && student.requiredForms.length > 0)
                        || (student.additionalForms && student.additionalForms.length > 0); });
                this.anyStudents = angular.isArray(this.studentList) && (this.studentList.length > 0);
                var now = new Date();
                this.userFormInfoDict = new Pulse.Collections.Dictionary();
                if (this.anyStudents) {
                    if (this.studentList.length == 1) {
                        this.studentList[0].isExpanded = true;
                    }
                    for (var _i = 0, _a = this.studentList; _i < _a.length; _i++) {
                        var student = _a[_i];
                        if (angular.isArray(student.additionalForms) && student.additionalForms.length > 0) {
                            this.anyAdditionalFormsToUpload = true;
                        }
                        student.anyIncompleteFormsBeforeCamp = (student.areRequiredFormsComplete != null && !student.areRequiredFormsComplete)
                            || (student.areAdditionalRequiredFormsNotBringComplete != null && !student.areAdditionalRequiredFormsNotBringComplete);
                        student.completeOverdueRequiredFormAtCamp = false;
                        if (angular.isArray(student.requiredForms)) {
                            for (var _b = 0, _c = student.requiredForms; _b < _c.length; _b++) {
                                var req = _c[_b];
                                this.userFormInfoDict.add(req.formInfo.userFormDetailID, req.formInfo);
                                req.formInfo.parentUserFormInfo = req;
                                req.isAdditional = false;
                                req.formInfo.dueDate = Pulse.Utils.JS.dateTimeStrToDateObj(req.formInfo.dueDate);
                                req.earliestTermEndDateWhereFormRequired = Pulse.Utils.JS.dateTimeStrToDateObj(req.earliestTermEndDateWhereFormRequired);
                                req.formOpenEndDate = Pulse.Utils.JS.dateTimeStrToDateObj(req.formOpenEndDate);
                                req.formOpenStartDate = Pulse.Utils.JS.dateTimeStrToDateObj(req.formOpenStartDate);
                                req.formInfo.status = formStatusDict.getValue(req.formInfo.statusTypeID).typeString;
                                req.isStatusReadOnly = true;
                                if (!req.isStatusReadOnly) {
                                    this.anythingToSave = true;
                                }
                                req.completeFormAtCamp = this.completeFormAtCamp(req);
                                if (req.completeFormAtCamp) {
                                    student.completeOverdueRequiredFormAtCamp = true;
                                }
                                this.setRequiredFormButtonProperties(req);
                                req.hasSections = angular.isArray(req.sections) && (req.sections.length > 0);
                                if (req.hasSections) {
                                    for (var _d = 0, _e = req.sections; _d < _e.length; _d++) {
                                        var section = _e[_d];
                                        section.parentUserFormInfoID = req.formInfo.userFormDetailID;
                                        section.parentUserFormInfo = req;
                                        this.userFormInfoDict.add(section.userFormDetailID, section);
                                        section.status = formStatusDict.getValue(section.statusTypeID).typeString;
                                        section.formSectionName = formSectionDict.getValue(section.formSectionTypeID).typeString;
                                        section.isStatusReadOnly = this.sectionStatusIsReadOnly(req.formOpenEndDate, section);
                                        if (!section.isStatusReadOnly) {
                                            this.anythingToSave = true;
                                        }
                                        section.dueDate = Pulse.Utils.JS.dateTimeStrToDateObj(section.dueDate);
                                    }
                                }
                                req.canShowSections = req.hasSections && this.pulseContext.isImpersonating;
                            }
                        }
                        if (angular.isArray(student.additionalForms)) {
                            for (var _f = 0, _g = student.additionalForms; _f < _g.length; _f++) {
                                var arf = _g[_f];
                                this.userFormInfoDict.add(arf.formInfo.userFormDetailID, arf.formInfo);
                                arf.formInfo.parentUserFormInfo = arf;
                                this.anyAdditionalForms = true;
                                arf.isAdditional = true;
                                arf.formInfo.dueDate = Pulse.Utils.JS.dateTimeStrToDateObj(arf.formInfo.dueDate);
                                arf.earliestTermEndDateWhereFormRequired = Pulse.Utils.JS.dateTimeStrToDateObj(arf.earliestTermEndDateWhereFormRequired);
                                arf.formOpenEndDate = Pulse.Utils.JS.dateTimeStrToDateObj(arf.formOpenEndDate);
                                arf.formOpenStartDate = Pulse.Utils.JS.dateTimeStrToDateObj(arf.formOpenStartDate);
                                arf.formInfo.status = formStatusDict.getValue(arf.formInfo.statusTypeID).typeString;
                                if (!this.pulseContext.isImpersonating) {
                                    arf.isStatusReadOnly = true;
                                }
                                else {
                                    arf.isStatusReadOnly = this.formStatusIsReadOnly(arf);
                                    if (!arf.isStatusReadOnly) {
                                        this.anythingToSave = true;
                                    }
                                }
                                arf.completeFormAtCamp = false;
                                this.setAdditionalFormButtonProperties(arf);
                                arf.hasSections = angular.isArray(arf.sections) && (arf.sections.length > 0);
                                if (arf.hasSections) {
                                    for (var _h = 0, _j = arf.sections; _h < _j.length; _h++) {
                                        var section = _j[_h];
                                        section.parentUserFormInfoID = arf.formInfo.userFormDetailID;
                                        section.parentUserFormInfo = arf;
                                        this.userFormInfoDict.add(section.userFormDetailID, section);
                                        section.status = formStatusDict.getValue(section.statusTypeID).typeString;
                                        section.formSectionName = formSectionDict.getValue(section.formSectionTypeID).typeString;
                                        section.isStatusReadOnly = this.sectionStatusIsReadOnly(arf.formOpenEndDate, section);
                                        if (!section.isStatusReadOnly) {
                                            this.anythingToSave = true;
                                        }
                                        section.dueDate = Pulse.Utils.JS.dateTimeStrToDateObj(section.dueDate);
                                    }
                                }
                                arf.canShowSections = arf.hasSections && this.pulseContext.isImpersonating;
                            }
                        }
                    }
                    this.loadFormDictionaries(this.currentFormsInfo.formsToUpload);
                    this.defineUploadOptions();
                }
            };
            ClientFormsHomeCtrl.prototype.setRequiredFormButtonProperties = function (form) {
                var now = this.pulseContext.serverDateTime;
                var buttonText = "View/Edit";
                var isFormButtonDisabled = false;
                var isFormButtonVisible = true;
                var noFormButtonText = "";
                var isFormClosedToClient = (now > form.formOpenEndDate);
                var formButtonUrl = form.isAdditional ? null : String.format("{0}?{1}={2}", Routes.HSF_Welcome, QueryStringUtils.USERFORMDETAIL_ID, form.formInfo.userFormDetailID);
                if (this.pulseContext.isImpersonating) {
                    if (now < form.formOpenStartDate) {
                        isFormButtonVisible = false;
                        noFormButtonText = ("Available " + moment(form.formOpenStartDate).format('MM/DD/YYYY'));
                    }
                    else if (now > form.formOpenEndDate) {
                        buttonText = "View/Edit (closed to client)";
                    }
                    else if (form.formInfo.statusTypeID == Enums.FormStatus.Incomplete) {
                        buttonText = "View/Edit";
                    }
                    else {
                        isFormButtonVisible = false;
                    }
                }
                else {
                    var localForm_1;
                    var currentForm = form.thresholdAndCourseDates.filter(function (item, index) {
                        if (item.sessionID === form.earliestSessionIDWhereFormRequired)
                            localForm_1 = form.thresholdAndCourseDates[index];
                    });
                    if (now < form.formOpenStartDate) {
                        isFormButtonVisible = false;
                        noFormButtonText = ("Available " + moment(form.formOpenStartDate).format('MM/DD/YYYY'));
                    }
                    else if (now > form.formOpenEndDate) {
                        buttonText = "View";
                        isFormButtonDisabled = (form.formInfo.statusTypeID != Enums.FormStatus.Complete);
                    }
                    else {
                        if (form.lobTypeID == Enums.LineOfBusiness.IPC) {
                            isFormButtonVisible = !localForm_1.blackOutPeriod;
                            if (!localForm_1.blackOutPeriod) {
                                buttonText = "View/Edit";
                            }
                        }
                        else {
                            buttonText = "View/Edit";
                        }
                    }
                    if (form.formInfo.statusTypeID == Enums.FormStatus.Complete) {
                        isFormButtonVisible = false;
                        isFormButtonDisabled = true;
                    }
                }
                form.formButtonUrl = formButtonUrl;
                form.formButtonText = buttonText;
                form.isFormButtonDisabled = isFormButtonDisabled;
                form.isFormButtonVisible = isFormButtonVisible;
                form.noFormButtonText = noFormButtonText;
            };
            ClientFormsHomeCtrl.prototype.setAdditionalFormButtonProperties = function (form) {
                var now = new Date();
                var buttonText = "Download";
                var isFormButtonDisabled = false;
                var isFormButtonVisible = true;
                var noFormButtonText = "";
                var isFormClosedToClient = (now > form.formOpenEndDate);
                var formButtonUrl = form.isAdditional ? null : String.format("{0}?{1}={2}", Routes.HSF_Welcome, QueryStringUtils.USERFORMDETAIL_ID, form.formInfo.userFormDetailID);
                if (this.pulseContext.isImpersonating) {
                    if (now < form.formOpenStartDate) {
                        isFormButtonVisible = false;
                        noFormButtonText = ("Available " + moment(form.formOpenStartDate).format('MM/DD/YYYY'));
                    }
                    else {
                        buttonText = isFormClosedToClient ? "Download (closed to client)" : "Download";
                    }
                }
                else {
                    if (now < form.formOpenStartDate) {
                        isFormButtonVisible = false;
                        noFormButtonText = ("Available " + moment(form.formOpenStartDate).format('MM/DD/YYYY'));
                    }
                    else if (form.formOpenEndDate < now) {
                        isFormButtonVisible = false;
                        noFormButtonText = "Not Accessible";
                    }
                    else {
                        buttonText = "Download";
                    }
                }
                form.formButtonUrl = formButtonUrl;
                form.formButtonText = buttonText;
                form.isFormButtonDisabled = isFormButtonDisabled;
                form.isFormButtonVisible = isFormButtonVisible;
                form.noFormButtonText = noFormButtonText;
            };
            ClientFormsHomeCtrl.prototype.formStatusIsReadOnly = function (form) {
                var hasSections = angular.isArray(form.sections) && (form.sections.length > 0);
                var isTerminalStatus = this.pulseContext.clientFormsMgr.isTerminalStatus(form.formInfo.statusTypeID);
                var now = new Date();
                var dueDateHasPast = (now > form.formInfo.dueDate);
                var isBringToSessionForm = (form.formInfo.statusTypeID == Enums.FormStatus.BringToSession);
                var isHealthAndSafetyForm = (form.formInfo.categoryTypeID == Enums.FormCategoryType.Health);
                return (isHealthAndSafetyForm || !this.canUpdate || hasSections || isTerminalStatus || isBringToSessionForm);
            };
            ClientFormsHomeCtrl.prototype.sectionStatusIsReadOnly = function (parentFormOpenEndDate, section) {
                var isTerminalStatus = this.pulseContext.clientFormsMgr.isTerminalStatus(section.statusTypeID);
                var isBringToSessionForm = section.statusTypeID == Enums.FormStatus.BringToSession;
                var isHealthAndSafetyForm = (section.categoryTypeID == Enums.FormCategoryType.Health);
                return (isHealthAndSafetyForm || !this.canChangeSectionStatus || isTerminalStatus || isBringToSessionForm);
            };
            ClientFormsHomeCtrl.prototype.completeFormAtCamp = function (formWithSections) {
                var statusTypeID = formWithSections.formInfo.statusTypeID;
                var isStatusIncomplete = (statusTypeID == Enums.FormStatus.Incomplete);
                var now = new Date();
                var formsEditableEndDateHasPast = (now > formWithSections.formOpenEndDate);
                return !formWithSections.isAdditional && isStatusIncomplete && formsEditableEndDateHasPast;
            };
            ClientFormsHomeCtrl.prototype.loadFormDictionaries = function (additionalRequiredFormList) {
                this.formLocationAbbrevDict = new Pulse.Collections.Dictionary();
                this.formLocationNameDict = new Pulse.Collections.Dictionary();
                for (var i = 0; i < additionalRequiredFormList.length; i++) {
                    var arf = additionalRequiredFormList[i];
                    var ufdID = arf.userFormDetailID;
                    if (!this.formDict.containsKey(ufdID)) {
                        this.formDict.add(ufdID, arf);
                    }
                    if (this.formLocationAbbrevDict.containsKey(ufdID)) {
                        var abbrevs = this.formLocationAbbrevDict[ufdID];
                        if (abbrevs.indexOf(arf.locationAbbreviation) < 0) {
                            abbrevs.push(arf.locationAbbreviation);
                        }
                    }
                    else {
                        this.formLocationAbbrevDict.add(ufdID, [arf.locationAbbreviation]);
                    }
                    if (this.formLocationNameDict.containsKey(ufdID)) {
                        var names = this.formLocationNameDict[ufdID];
                        if (names.indexOf(arf.locationName) < 0) {
                            names.push(arf.locationName);
                        }
                    }
                    else {
                        this.formLocationNameDict.add(ufdID, [arf.locationName]);
                    }
                }
            };
            ClientFormsHomeCtrl.prototype.defineUploadOptions = function () {
                this.userFormDetailsToUpload = new Array();
                var userFormDetailIDList = this.formLocationNameDict.keys();
                for (var _i = 0, userFormDetailIDList_1 = userFormDetailIDList; _i < userFormDetailIDList_1.length; _i++) {
                    var ufdID = userFormDetailIDList_1[_i];
                    var form = this.formDict.getValue(ufdID);
                    if (form.formCategoryTypeID != Enums.FormCategoryType.Bring) {
                        var studentFullName = form.userFullName;
                        var formName = form.formName;
                        var locationsApplicable = this.formLocationNameDict.getValue(ufdID).join();
                        var description = String.format("{0} - {1} - {2}", studentFullName, formName, locationsApplicable);
                        var item = new uploadOption(Number(ufdID), description);
                        this.userFormDetailsToUpload.push(item);
                    }
                }
                if (this.userFormDetailsToUpload.length > 0) {
                    var pleaseSelectOption = new uploadOption(0, "Please select...");
                    this.userFormDetailsToUpload.splice(0, 0, pleaseSelectOption);
                    this.selectedUFDIDForUpload = 0;
                }
                else {
                }
            };
            ClientFormsHomeCtrl.prototype.toggleARFUploader = function () {
                this.showARFUploader = !this.showARFUploader;
            };
            ClientFormsHomeCtrl.prototype.uploadFile = function (selectedUFDIDForUpload, hasInputFile, inputFilePath, filesToUpload) {
                this.uploadErrorMsg = null;
                if (selectedUFDIDForUpload <= 0) {
                    this.uploadErrorMsg = "Please select the form that you are uploading";
                }
                else if (!hasInputFile || typeof (filesToUpload) === "undefined" || filesToUpload == null || filesToUpload.length == 0) {
                    this.uploadErrorMsg = "Please select a file to upload";
                }
                else {
                    var fileToUpload = filesToUpload[0];
                    var size = fileToUpload.size;
                    if (size > ClientFormsMgr.MAX_UPLOAD_FILE_SIZE_IN_BYTES) {
                        this.uploadErrorMsg = String.format("Your file exceeds our maximum file size of {0} MB.", ClientFormsMgr.MAX_UPLOAD_FILE_SIZE_IN_MEGABYTES);
                    }
                    else {
                        var inputFileName = Pulse.Utils.JS.removeSpecialCharsFromFileName(fileToUpload.name);
                        var form = this.formDict.getValue(selectedUFDIDForUpload);
                        var locationAbbrevs = this.formLocationAbbrevDict.getValue(selectedUFDIDForUpload);
                        var saveFileName = this.formatUploadedARFFilename(locationAbbrevs, form.userFirstName, form.userLastName, form.formAbbreviation, inputFileName);
                        this.common.clearStatus();
                        this.common.toggleSpinner(true);
                        var self_1 = this;
                        this.pulseContext.clientFormsMgr.saveClientFormUploadFile(fileToUpload, fileToUpload.name, saveFileName, selectedUFDIDForUpload)
                            .then(function (saveResult) {
                            self_1.common.showSuccess("Your form was uploaded.");
                            self_1.getStudentsWithForms();
                        })
                            .catch(function (err) {
                            self_1.logError(err, ['System.ArgumentException']);
                            self_1.breezeService.getEntityManager().rejectChanges();
                        })
                            .finally(function () {
                            self_1.common.toggleSpinner(false);
                        });
                    }
                }
            };
            ClientFormsHomeCtrl.prototype.formatUploadedARFFilename = function (formLocationAbbreviations, firstName, lastName, formAbbreviation, uploadedFileName) {
                firstName = Pulse.Utils.JS.removeSpecialCharsFromFileName(firstName);
                lastName = Pulse.Utils.JS.removeSpecialCharsFromFileName(lastName);
                formAbbreviation = Pulse.Utils.JS.removeSpecialCharsFromFileName(formAbbreviation);
                var extension = String.endsWith(uploadedFileName, ".jpg", true) || String.endsWith(uploadedFileName, ".jpeg", true) || String.endsWith(uploadedFileName, ".jpe", true) ? ".jpg"
                    : String.endsWith(uploadedFileName, ".pdf", true) ? ".pdf"
                        : uploadedFileName.substring(uploadedFileName.lastIndexOf("."));
                var now = new Date();
                var date = this.common.$filter("date")(now, "yyyyMMdd");
                var scrubbedFileName = String.format("{0}_{1},{2}_{3}_{4}{5}", formLocationAbbreviations, lastName, firstName, formAbbreviation, date, extension);
                return scrubbedFileName;
            };
            ClientFormsHomeCtrl.prototype.updateFormStatusDisplayed = function (ufdIdUploaded) {
                var _self = this;
                var ufdDAO = new DataAccess.UserFormDetailDAO(this.common, this.breezeService, this.pulseContext);
                return ufdDAO.getByUserFormDetailID(ufdIdUploaded)
                    .then(function (ufd) {
                    _self.updateDisplayedUserFormInfoStatus(ufd.userFormDetailID, ufd.statusTypeID);
                    _self.isPastUploadsCurrent = false;
                    return ufd;
                })
                    .catch(function (err) {
                    _self.logError(err);
                    return null;
                });
            };
            ClientFormsHomeCtrl.prototype.updateDisplayedUserFormInfoStatus = function (searchUFDID, newStatusTypeID) {
                for (var _i = 0, _a = this.studentList; _i < _a.length; _i++) {
                    var student = _a[_i];
                    for (var _b = 0, _c = student.requiredForms; _b < _c.length; _b++) {
                        var req = _c[_b];
                        if (req.formInfo.userFormDetailID == searchUFDID) {
                            req.formInfo.statusTypeID = newStatusTypeID;
                            req.formInfo.status = this.formStatusDict.getValue(newStatusTypeID).typeString;
                        }
                        for (var _d = 0, _e = req.sections; _d < _e.length; _d++) {
                            var section = _e[_d];
                            if (section.userFormDetailID == searchUFDID) {
                                section.statusTypeID = newStatusTypeID;
                                section.status = this.formStatusDict.getValue(newStatusTypeID).typeString;
                            }
                        }
                    }
                    for (var _f = 0, _g = student.additionalForms; _f < _g.length; _f++) {
                        var arf = _g[_f];
                        if (arf.formInfo.userFormDetailID == searchUFDID) {
                            arf.formInfo.statusTypeID = newStatusTypeID;
                            arf.formInfo.status = this.formStatusDict.getValue(newStatusTypeID).typeString;
                        }
                        for (var _h = 0, _j = arf.sections; _h < _j.length; _h++) {
                            var section = _j[_h];
                            if (section.userFormDetailID == searchUFDID) {
                                section.statusTypeID = newStatusTypeID;
                                section.status = this.formStatusDict.getValue(newStatusTypeID).typeString;
                            }
                        }
                    }
                }
            };
            ClientFormsHomeCtrl.prototype.togglePastUploads = function () {
                this.showPastUploads = !this.showPastUploads;
            };
            ClientFormsHomeCtrl.prototype.toggleFormsHistory = function () {
                this.showFormsHistory = !this.showFormsHistory;
            };
            ClientFormsHomeCtrl.prototype.updateUserFormDetailStatus = function (userFormDetailID, statusTypeID) {
                var _self = this;
                var ufdDAO = new DataAccess.UserFormDetailDAO(this.common, this.breezeService, this.pulseContext);
                var updateStatusPromise = ufdDAO.getByUserFormDetailID(userFormDetailID)
                    .then(function (ufd) {
                    ufd.statusTypeID = statusTypeID;
                })
                    .catch(function (err) {
                    _self.logError(err);
                });
            };
            ClientFormsHomeCtrl.controllerId = "clientFormsHomeCtrl";
            return ClientFormsHomeCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ClientFormsHomeCtrl = ClientFormsHomeCtrl;
        var uploadOption = (function () {
            function uploadOption(userFormDetailID, description) {
                this.userFormDetailID = userFormDetailID;
                this.description = description;
            }
            return uploadOption;
        }());
        Pulse.app.controller(ClientFormsHomeCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", ClientFormsHomeCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var TermGroupDAO = Pulse.Common.DataAccess.TermGroupDAO;
        var TermGroupStatusType = Pulse.Common.Enums.TermGroupStatusType;
        var CourseTakeHomesCtrl = (function (_super) {
            __extends(CourseTakeHomesCtrl, _super);
            function CourseTakeHomesCtrl($scope, $route, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CourseTakeHomesCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Profile;
                _this.formName = 'formCourseTakeHomes';
                _this.checkUnsavedDataBeforeNav = false;
                if (_this.breezeService && _this.breezeService.getEntityManager()) {
                    _this.breezeService.getEntityManager().rejectChanges();
                }
                _this.activationPromises.push(_this.retrieveTermGroupLicenses());
                _this.activateController();
                var lastRoute = $route.current;
                _this.$scope.$on('$locationChangeSuccess', function (event) {
                    if (lastRoute.templateUrl === $route.current.templateUrl) {
                        $route.current = lastRoute;
                        event.preventDefault();
                    }
                });
                return _this;
            }
            CourseTakeHomesCtrl.prototype.onTermGroupChanged = function () {
                var _this = this;
                if (this.isValidTermGroupId(this.selectedTermGroupID)) {
                    this.updateTermGroupIdQS(this.selectedTermGroupID);
                    this.common.toggleSpinner(true, false, null, 0);
                    this.retrieveUsersTakeHomes(this.selectedTermGroupID)
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                }
            };
            CourseTakeHomesCtrl.prototype.getFullName = function (user) {
                return user.firstName + ' ' + user.lastName;
            };
            CourseTakeHomesCtrl.prototype.showNotePopup = function (license) {
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, license.itemName, license.noteHtml + ' ', null);
            };
            CourseTakeHomesCtrl.prototype.retrieveTermGroupLicenses = function () {
                var _this = this;
                return this.retrieveFirstFiveValidTermGroups()
                    .then(function (validTG) {
                    var utQuery;
                    _this.termGroups = validTG;
                    _this.selectedTermGroupID = _this.getTermGroupIdFromQS();
                    if (_this.selectedTermGroupID) {
                        _this.updateTermGroupIdQS(_this.selectedTermGroupID);
                        utQuery = _this.retrieveUsersTakeHomes(_this.selectedTermGroupID);
                    }
                    else {
                        utQuery = _this.searchBackwardsFirstTermGroupWithValues(_this.getCurrentTermGroupIndex(), _this.termGroups);
                    }
                    return utQuery;
                });
            };
            CourseTakeHomesCtrl.prototype.getCurrentTermGroupIndex = function () {
                var _this = this;
                return this.termGroups.reduce(function (currentIndex, tg, index) {
                    return currentIndex === -1 && _this.pulseContext.currentTermGroup.termGroupID === tg.termGroupID
                        ? index
                        : currentIndex;
                }, -1);
            };
            CourseTakeHomesCtrl.prototype.searchBackwardsFirstTermGroupWithValues = function (termGroupIndex, termGroupsList) {
                var _this = this;
                return this.retrieveUsersTakeHomes(termGroupsList[termGroupIndex].termGroupID)
                    .then(function (aggData) {
                    var result;
                    if (!aggData.length && termGroupIndex > 0) {
                        result = _this.searchBackwardsFirstTermGroupWithValues(termGroupIndex - 1, termGroupsList);
                    }
                    else {
                        if (!aggData.length && termGroupIndex === -1) {
                            _this.selectedTermGroupID = _this.pulseContext.currentTermGroup.termGroupID;
                        }
                        else {
                            _this.selectedTermGroupID = termGroupsList[termGroupIndex].termGroupID;
                        }
                        _this.updateTermGroupIdQS(_this.selectedTermGroupID);
                        result = _this.common.$q.resolve(aggData);
                    }
                    return result;
                });
            };
            CourseTakeHomesCtrl.prototype.getTermGroupIdFromQS = function () {
                var termGroupIdParam = parseInt(QueryStringUtils.GetParamByName(this.$location.url().replace(/%3[Ff]/, '?'), QueryStringUtils.TERM_GROUP_ID), 10);
                return termGroupIdParam && this.isValidTermGroupId(termGroupIdParam)
                    ? termGroupIdParam
                    : null;
            };
            CourseTakeHomesCtrl.prototype.updateTermGroupIdQS = function (termGroupId) {
                var params = {};
                params[QueryStringUtils.TERM_GROUP_ID] = termGroupId;
                this.$location.url(QueryStringUtils.AddOrSetQSParams(this.$location.url().replace(/%3[Ff]/, '?'), params));
            };
            CourseTakeHomesCtrl.prototype.isValidTermGroupId = function (val) {
                return this.termGroups.some(function (tg) { return val === tg.termGroupID; });
            };
            CourseTakeHomesCtrl.prototype.retrieveFirstFiveValidTermGroups = function () {
                var tgDAO = new TermGroupDAO(this.common, this.breezeService, this.pulseContext);
                return tgDAO.getActive()
                    .then(function (data) {
                    var validTGs = data.filter(function (tg) {
                        return tg.statusTypeID !== TermGroupStatusType.Pending;
                    });
                    return validTGs.length > 5 ? validTGs.slice(validTGs.length - 5) : validTGs;
                });
            };
            CourseTakeHomesCtrl.prototype.retrieveUsersTakeHomes = function (termGroupID) {
                var _this = this;
                return this.pulseContext.userMgr.getRelatedUsersAssignedLicenses(termGroupID)
                    .then(function (data) {
                    _this.userLicenseInfoList = _this.aggregateOnStudent(data);
                    return _this.userLicenseInfoList;
                });
            };
            CourseTakeHomesCtrl.prototype.aggregateOnStudent = function (data) {
                var aggregation = [];
                var _loop_1 = function (ul) {
                    if (ul.licenseItems.length) {
                        var lWithSameUser = aggregation.filter(function (e) { return e.user.userID === ul.user.userID; }).shift();
                        if (lWithSameUser) {
                            lWithSameUser.licenseItems = lWithSameUser.licenseItems.concat(ul.licenseItems);
                        }
                        else {
                            aggregation.push(ul);
                        }
                    }
                };
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var ul = data_1[_i];
                    _loop_1(ul);
                }
                return aggregation;
            };
            CourseTakeHomesCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            CourseTakeHomesCtrl.controllerId = 'CourseTakeHomesCtrl';
            return CourseTakeHomesCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.CourseTakeHomesCtrl = CourseTakeHomesCtrl;
        Pulse.app.controller(CourseTakeHomesCtrl.controllerId, [
            '$scope',
            '$route',
            '$location',
            'common',
            'breezeService',
            'pulseContextService',
            CourseTakeHomesCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var locationChangeEvent;
        var HistoryInfoCtrl = (function (_super) {
            __extends(HistoryInfoCtrl, _super);
            function HistoryInfoCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HistoryInfoCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Profile;
                _this.showNoHistoryMsg = false;
                if (_this.breezeService && _this.breezeService.getEntityManager()) {
                    _this.breezeService.getEntityManager().rejectChanges();
                }
                _this.activationPromises.push(_this.pulseContext.userMgr.loadRelatedUsersForActingUser(false)
                    .then(function (data) {
                    _this.initParticipants(data);
                    return data;
                }));
                _this.activateController();
                return _this;
            }
            HistoryInfoCtrl.prototype.initParticipants = function (participantList) {
                var _this = this;
                this.participantList = new Array();
                var promises = new Array();
                var _loop_1 = function (u) {
                    promises.push(this_1.loadStudentSessions(u)
                        .then(function () {
                        if (u.sessionList && u.sessionList.length) {
                            _this.participantList.push(u);
                        }
                    }));
                };
                var this_1 = this;
                for (var _i = 0, participantList_1 = participantList; _i < participantList_1.length; _i++) {
                    var u = participantList_1[_i];
                    _loop_1(u);
                }
                this.common.$q.all(promises)
                    .then(function () {
                    _this.showNoHistoryMsg = !_this.participantList.length;
                    _this.participantList.sort(function (o1, o2) { return Pulse.Utils.JS.compareForSort(o1, o2, { 'lastName': 0, 'firstName': 0 }); });
                });
            };
            HistoryInfoCtrl.prototype.loadStudentSessions = function (student) {
                var _this = this;
                var userID = student.userID;
                if (student.sessionList) {
                    return this.common.$q.resolve(student.sessionList);
                }
                this.common.toggleSpinner(true);
                return this.pulseContext.customerMgr.getStudentSessions(userID, false, Enums.TimeInterval.History).then(function (data) {
                    if (data != null) {
                        for (var i = 0; i < data.length; i++) {
                            var optList = Array();
                            var sessionData = data[i];
                            if (sessionData.primaryCustomerUserID != _this.pulseContext.actingAsUserId) {
                                sessionData.isEnabled = false;
                            }
                            var isDivAcademy = sessionData.programTypeID == Enums.DivisionProgramType.iDTechAcademies;
                            var priceSuffix = isDivAcademy ? '/session' : '/week';
                            if (sessionData.options != null) {
                                for (var iOpt = 0; iOpt < sessionData.options.length; iOpt++) {
                                    var optionItem = sessionData.options[iOpt];
                                    if (optionItem.productCategory == Enums.ProductCategoryType.CEU) {
                                        optionItem.price += priceSuffix;
                                        optionItem.cssClass = 'ceus';
                                    }
                                    else if (optionItem.productCategory == Enums.ProductCategoryType.Meal) {
                                        optionItem.price += priceSuffix;
                                        optionItem.cssClass = 'lunch';
                                    }
                                    else if (optionItem.productCategory == Enums.ProductCategoryType.Residency) {
                                        switch (optionItem.productSubCategory) {
                                            case Enums.ProductSubCategoryType.OvernightAndWeekend:
                                            case Enums.ProductSubCategoryType.Overnight:
                                                optionItem.price += priceSuffix;
                                                optionItem.cssClass = 'overnight';
                                                break;
                                            case Enums.ProductSubCategoryType.WeekendBefore:
                                            case Enums.ProductSubCategoryType.WeekendWithin:
                                                optionItem.description = String.format("The weekend of <span style='white-space:nowrap;'>{0} - {1}</span> for {2}", _this.common.$filter('date')(optionItem.startDateTime, 'MMM d'), _this.common.$filter('date')(optionItem.endDateTime, 'MMM d'), optionItem.price);
                                                optionItem.price = null;
                                                optionItem.cssClass = 'weekend';
                                                break;
                                            case Enums.ProductSubCategoryType.WeekendAfter:
                                                if (isDivAcademy) {
                                                    optionItem.description = String.format("The weekend of <span style='white-space:nowrap;'>{0} - {1}</span> for {2}", _this.common.$filter('date')(optionItem.startDateTime, 'MMM d'), _this.common.$filter('date')(optionItem.endDateTime, 'MMM d'), optionItem.price);
                                                    optionItem.price = null;
                                                    optionItem.cssClass = 'weekend';
                                                }
                                                else {
                                                    optionItem.description = String.format("The weekend of <span style='white-space:nowrap;'>{0} - {1}</span> for {2}", _this.common.$filter('date')(optionItem.startDateTime, 'MMM d'), _this.common.$filter('date')(optionItem.endDateTime, 'MMM d'), optionItem.price);
                                                    optionItem.price = null;
                                                    optionItem.cssClass = 'gaming';
                                                }
                                                break;
                                            default:
                                                optionItem.price += priceSuffix;
                                                optionItem.cssClass = 'overnight';
                                                break;
                                        }
                                    }
                                    optList.push(optionItem);
                                }
                            }
                            sessionData.options = optList;
                        }
                    }
                    student.sessionList = data;
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            HistoryInfoCtrl.prototype.print = function () {
                throw new Error(StringConst.Err_Not_Implemented);
                var printFrame = document.getElementById("printFrame");
                printFrame.src = "#/my-account/profile/historyInfo";
                printFrame.focus();
                printFrame.contentWindow.document.write(window.document.documentElement.innerHTML);
                if (printFrame.contentWindow.printPage) {
                    printFrame.contentWindow.printPage();
                }
                else {
                    printFrame.contentWindow.print();
                }
            };
            HistoryInfoCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = this.canUpdate && !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices);
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
            };
            HistoryInfoCtrl.controllerId = "HistoryInfoCtrl";
            return HistoryInfoCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HistoryInfoCtrl = HistoryInfoCtrl;
        Pulse.app.controller(HistoryInfoCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", HistoryInfoCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFWelcomeCtrl = (function (_super) {
            __extends(HSFWelcomeCtrl, _super);
            function HSFWelcomeCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFWelcomeCtrl.controllerId) || this;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId, true)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID, true)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.companyTollFreePhone = _this.pulseContext.companyTollFreePhone;
                _this.companyInternationalPhone = _this.pulseContext.companyInternationalPhone;
                _this.activateController();
                return _this;
            }
            HSFWelcomeCtrl.prototype.continue = function () {
                this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_PrimaryEmergencyContact, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
            };
            HSFWelcomeCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFWelcomeCtrl.controllerId = "HSFWelcomeCtrl";
            return HSFWelcomeCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFWelcomeCtrl = HSFWelcomeCtrl;
        Pulse.app.controller(HSFWelcomeCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFWelcomeCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFPrimaryEmergencyContactCtrl = (function (_super) {
            __extends(HSFPrimaryEmergencyContactCtrl, _super);
            function HSFPrimaryEmergencyContactCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFPrimaryEmergencyContactCtrl.controllerId) || this;
                _this.formPersonRole = Pulse.Common.Enums.FormPersonRole.PrimaryContact;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getPrimaryEmergencyContactPersonForUserFormDetail(_this.userFormDetail.userFormDetailID)
                        .then(function (data) {
                        var primaryEmergencyContacts = data.filter(function (p) {
                            return p.formRoleTypeID === Pulse.Common.Enums.FormPersonRole.PrimaryContact;
                        });
                        _this.emergencyContact = primaryEmergencyContacts[0];
                        _this.formPersonRole = Pulse.Common.Enums.FormPersonRole.PrimaryContact;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            HSFPrimaryEmergencyContactCtrl.prototype.formSaveSuccess = function () {
                this.breezeService.getEntityManager().rejectChanges();
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.common.showSuccess(StringConst.Info_SaveSucceeded);
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_SecondaryEmergencyContact, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFPrimaryEmergencyContactCtrl.prototype.backClick = function () {
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Welcome, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFPrimaryEmergencyContactCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFPrimaryEmergencyContactCtrl.controllerId = "HSFPrimaryEmergencyContactCtrl";
            return HSFPrimaryEmergencyContactCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFPrimaryEmergencyContactCtrl = HSFPrimaryEmergencyContactCtrl;
        Pulse.app.controller(HSFPrimaryEmergencyContactCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFPrimaryEmergencyContactCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFSecondaryEmergencyContactCtrl = (function (_super) {
            __extends(HSFSecondaryEmergencyContactCtrl, _super);
            function HSFSecondaryEmergencyContactCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFSecondaryEmergencyContactCtrl.controllerId) || this;
                _this.formPersonRole = Pulse.Common.Enums.FormPersonRole.SecondaryContact;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getSecondaryEmergencyContactPersonForUserFormDetail(_this.userFormDetail.userFormDetailID)
                        .then(function (data) {
                        var secondaryEmergencyContacts = data.filter(function (p) {
                            return p.formRoleTypeID === Pulse.Common.Enums.FormPersonRole.SecondaryContact;
                        });
                        _this.emergencyContact = secondaryEmergencyContacts.length > 0 ? secondaryEmergencyContacts[0] : null;
                        _this.formPersonRole = Pulse.Common.Enums.FormPersonRole.SecondaryContact;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            HSFSecondaryEmergencyContactCtrl.prototype.formSaveSuccess = function () {
                this.breezeService.getEntityManager().rejectChanges();
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.common.showSuccess(StringConst.Info_SaveSucceeded);
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_CheckInOut, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFSecondaryEmergencyContactCtrl.prototype.backClick = function () {
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_PrimaryEmergencyContact, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFSecondaryEmergencyContactCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFSecondaryEmergencyContactCtrl.controllerId = "HSFSecondaryEmergencyContactCtrl";
            return HSFSecondaryEmergencyContactCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFSecondaryEmergencyContactCtrl = HSFSecondaryEmergencyContactCtrl;
        Pulse.app.controller(HSFSecondaryEmergencyContactCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFSecondaryEmergencyContactCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFCheckInOutCtrl = (function (_super) {
            __extends(HSFCheckInOutCtrl, _super);
            function HSFCheckInOutCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFCheckInOutCtrl.controllerId) || this;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getReqdFormContentForUserFormDetail(data.userFormDetailID)
                        .then(function (data) {
                        if (angular.isObject(data)) {
                            _this.reqdFormContent = data;
                        }
                        else {
                            _this.pulseContext.healthSafetyFormMgr.getReqdFormContentForPreviousTermGroup(_this.userFormDetail.userID)
                                .then(function (data) {
                                if (angular.isObject(data)) {
                                    _this.reqdFormContent = data;
                                }
                                else {
                                    _this.reqdFormContent = _this.pulseContext.healthSafetyFormMgr.createReqdFormContent(null);
                                    _this.reqdFormContent.userFormDetailID = _this.userFormDetail.userFormDetailID;
                                }
                            })
                                .catch(function (error) {
                                _this.logError(error);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            HSFCheckInOutCtrl.prototype.formSaveSuccess = function () {
                this.breezeService.getEntityManager().rejectChanges();
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.common.showSuccess(StringConst.Info_SaveSucceeded);
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    if (this.reqdFormContent.canSelfSignOut) {
                        this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Insurance, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                    }
                    else {
                        this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_AuthPickupContacts, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                    }
                }
            };
            HSFCheckInOutCtrl.prototype.backClick = function () {
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_SecondaryEmergencyContact, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFCheckInOutCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFCheckInOutCtrl.controllerId = "HSFCheckInOutCtrl";
            return HSFCheckInOutCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFCheckInOutCtrl = HSFCheckInOutCtrl;
        Pulse.app.controller(HSFCheckInOutCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFCheckInOutCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFAuthPickupContactsCtrl = (function (_super) {
            __extends(HSFAuthPickupContactsCtrl, _super);
            function HSFAuthPickupContactsCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFAuthPickupContactsCtrl.controllerId) || this;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getAuthPickupPersonsForUserFormDetail(data.userFormDetailID)
                        .then(function (data) {
                        _this.authPickupContacts = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            HSFAuthPickupContactsCtrl.prototype.formSaveSuccess = function () {
                this.checkUnsavedDataBeforeNav = false;
                this.breezeService.getEntityManager().rejectChanges();
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.common.showSuccess(StringConst.Info_SaveSucceeded);
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Insurance, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFAuthPickupContactsCtrl.prototype.backClick = function () {
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_CheckInOut, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFAuthPickupContactsCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFAuthPickupContactsCtrl.controllerId = "HSFAuthPickupContactsCtrl";
            return HSFAuthPickupContactsCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFAuthPickupContactsCtrl = HSFAuthPickupContactsCtrl;
        Pulse.app.controller(HSFAuthPickupContactsCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFAuthPickupContactsCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFInsuranceCtrl = (function (_super) {
            __extends(HSFInsuranceCtrl, _super);
            function HSFInsuranceCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFInsuranceCtrl.controllerId) || this;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.getUserFormInsurance();
                    _this.getReqdFormContent();
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            HSFInsuranceCtrl.prototype.getReqdFormContent = function () {
                var _this = this;
                this.common.toggleSpinner(true, null, null, 0);
                var promise = this.pulseContext.healthSafetyFormMgr.getReqdFormContentForUserFormDetail(this.userFormDetail.userFormDetailID)
                    .then(function (data) {
                    _this.reqdFormContent = data;
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            HSFInsuranceCtrl.prototype.getUserFormInsurance = function () {
                var _this = this;
                this.common.toggleSpinner(true, null, null, 0);
                var promise = this.pulseContext.healthSafetyFormMgr.getUserFormInsuranceForUserFormDetail(this.userFormDetail.userFormDetailID)
                    .then(function (data) {
                    _this.userFormInsurance = data;
                    if (_this.userFormInsurance == null) {
                        return _this.pulseContext.healthSafetyFormMgr.getUserFormInsuranceForPreviousTermGroup(_this.userFormDetail.userID)
                            .then(function (data) {
                            _this.userFormInsurance = data;
                            if (_this.userFormInsurance == null) {
                                _this.userFormInsurance = _this.pulseContext.healthSafetyFormMgr.createUserFormInsurance(null, false);
                                _this.userFormInsurance.userFormDetailID = _this.userFormDetail.userFormDetailID;
                            }
                        });
                    }
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            HSFInsuranceCtrl.prototype.formSaveSuccess = function () {
                this.breezeService.getEntityManager().rejectChanges();
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.common.showSuccess(StringConst.Info_SaveSucceeded);
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_HealthHistory, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFInsuranceCtrl.prototype.backClick = function () {
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    if (this.reqdFormContent.canSelfSignOut) {
                        this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_CheckInOut, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                    }
                    else {
                        this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_AuthPickupContacts, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                    }
                }
            };
            HSFInsuranceCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFInsuranceCtrl.controllerId = "HSFInsuranceCtrl";
            return HSFInsuranceCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFInsuranceCtrl = HSFInsuranceCtrl;
        Pulse.app.controller(HSFInsuranceCtrl.controllerId, [
            "$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFInsuranceCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFHealthHistoryCtrl = (function (_super) {
            __extends(HSFHealthHistoryCtrl, _super);
            function HSFHealthHistoryCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFHealthHistoryCtrl.controllerId) || this;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getReqdFormContentForUserFormDetail(_this.userFormDetail.userFormDetailID)
                        .then(function (data) {
                        _this.reqdFormContent = data;
                        if (_this.reqdFormContent.allergyDietaryRest != null && _this.reqdFormContent.allergyDietaryRest) {
                            _this.pulseContext.healthSafetyFormMgr.getUserFormAllergyForUserFormDetail(_this.userFormDetail.userFormDetailID)
                                .then(function (data) {
                                _this.userFormAllergies = data;
                            })
                                .catch(function (error) {
                                _this.logError(error);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                        else {
                            _this.userFormAllergies = Array();
                        }
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activationPromises.push();
                _this.activateController();
                return _this;
            }
            HSFHealthHistoryCtrl.prototype.formSaveSuccess = function () {
                this.breezeService.getEntityManager().rejectChanges();
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.common.showSuccess(StringConst.Info_SaveSucceeded);
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Medications, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFHealthHistoryCtrl.prototype.backClick = function () {
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Insurance, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFHealthHistoryCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFHealthHistoryCtrl.controllerId = "HSFHealthHistoryCtrl";
            return HSFHealthHistoryCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFHealthHistoryCtrl = HSFHealthHistoryCtrl;
        Pulse.app.controller(HSFHealthHistoryCtrl.controllerId, [
            "$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFHealthHistoryCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFMedicationsCtrl = (function (_super) {
            __extends(HSFMedicationsCtrl, _super);
            function HSFMedicationsCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFMedicationsCtrl.controllerId) || this;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                if (_this.breezeService && _this.breezeService.getEntityManager()) {
                    _this.breezeService.getEntityManager().rejectChanges();
                }
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getReqdFormContentForUserFormDetail(_this.userFormDetail.userFormDetailID)
                        .then(function (data) {
                        if (angular.isObject(data)) {
                            _this.reqdFormContent = data;
                        }
                        else {
                            _this.pulseContext.healthSafetyFormMgr.getReqdFormContentForPreviousTermGroup(_this.userFormDetail.userID)
                                .then(function (data) {
                                if (angular.isObject(data)) {
                                    _this.reqdFormContent = data;
                                }
                                else {
                                    _this.reqdFormContent = _this.pulseContext.healthSafetyFormMgr.createReqdFormContent(null);
                                }
                                _this.reqdFormContent.userFormDetailID = _this.userFormDetail.userFormDetailID;
                            })
                                .catch(function (error) {
                                _this.logError(error);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            HSFMedicationsCtrl.prototype.formSaveSuccess = function () {
                this.breezeService.getEntityManager().clear();
                this.pulseContext.healthSafetyFormMgr.clearCache();
                if (this.pulseContext.healthSafetyFormMgr.isMedicAppMedsOnly) {
                    if (window != window.top) {
                        window.top.location.assign("#" + Routes.MedicParticipantMedsComplete);
                    }
                    else {
                        this.$location.url(Routes.MedicParticipantMedsComplete);
                    }
                    return;
                }
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.common.showSuccess(StringConst.Info_SaveSucceeded);
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_SpecialNeedsImmunizations, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFMedicationsCtrl.prototype.backClick = function () {
                if (this.pulseContext.healthSafetyFormMgr.isMedicAppMedsOnly) {
                    if (window != window.top) {
                        window.top.location.assign("#" + Routes.MedicParticipantMedsComplete);
                    }
                    else {
                        this.$location.url(Routes.MedicParticipantMedsComplete);
                    }
                    return;
                }
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_HealthHistory, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFMedicationsCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFMedicationsCtrl.controllerId = "HSFMedicationsCtrl";
            return HSFMedicationsCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFMedicationsCtrl = HSFMedicationsCtrl;
        Pulse.app.controller(HSFMedicationsCtrl.controllerId, [
            "$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFMedicationsCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFNextStudentCtrl = (function (_super) {
            __extends(HSFNextStudentCtrl, _super);
            function HSFNextStudentCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFNextStudentCtrl.controllerId) || this;
                _this.copyPrimaryContact = null;
                _this.copySecondaryContact = null;
                _this.copyPickupContacts = null;
                _this.formName = "HSFNextStudentForm";
                var nextStudentUserID = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USER_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getParticipant(nextStudentUserID, true)
                    .then(function (data) {
                    _this.nextStudent = data;
                    _this.pulseContext.healthSafetyFormMgr.getCurrentUserFormDetailForUser(nextStudentUserID)
                        .then(function (data) {
                        _this.nextStudentUserFormDetail = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                var previousStudentUserFormDetailID = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(previousStudentUserFormDetailID, true)
                    .then(function (data) {
                    _this.previousStudentUserFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.previousStudentUserFormDetail.userID, true)
                        .then(function (data) {
                        _this.previousStudent = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activationPromises.push(_this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.StatisticsAnswerType)
                    .then(function (data) {
                    _this.yesNoTypes = data.filter(function (t) {
                        return t.typeID >= Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes && t.typeID <= Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            Object.defineProperty(HSFNextStudentCtrl.prototype, "isContinueDisable", {
                get: function () {
                    return this.submitted || Pulse.Utils.JS.isUndefinedOrNull(this.copyPrimaryContact) || Pulse.Utils.JS.isUndefinedOrNull(this.copySecondaryContact) || Pulse.Utils.JS.isUndefinedOrNull(this.copyPickupContacts);
                },
                enumerable: false,
                configurable: true
            });
            HSFNextStudentCtrl.prototype.copyPrimaryContactYesNoClick = function () {
                this.myForm.$setDirty();
                this.copyPrimaryContact = Pulse.Utils.JS.findByProperties(this.selectedPrimaryContactTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
            };
            HSFNextStudentCtrl.prototype.copySecondaryContactYesNoClick = function () {
                this.myForm.$setDirty();
                this.copySecondaryContact = Pulse.Utils.JS.findByProperties(this.selectedSecondaryContactTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
            };
            HSFNextStudentCtrl.prototype.copyPickupContactsYesNoClick = function () {
                this.myForm.$setDirty();
                this.copyPickupContacts = Pulse.Utils.JS.findByProperties(this.selectedPickupContactTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
            };
            HSFNextStudentCtrl.prototype.submit = function () {
                var _this = this;
                if (!this.copyPrimaryContact && !this.copySecondaryContact && !this.copyPickupContacts) {
                    this.goToPrimaryContactView();
                }
                else {
                    this.submitted = true;
                    this.pulseContext.healthSafetyFormMgr.copyContactInfo(this.nextStudent.userID, this.previousStudentUserFormDetail.userFormDetailID, this.copyPrimaryContact, this.copySecondaryContact, this.copyPickupContacts)
                        .then(function (dummy) {
                        _this.goToPrimaryContactView();
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.submitted = false;
                        _this.common.toggleSpinner(false);
                    });
                }
            };
            HSFNextStudentCtrl.prototype.goToPrimaryContactView = function () {
                this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_PrimaryEmergencyContact, QueryStringUtils.USERFORMDETAIL_ID, this.nextStudentUserFormDetail.userFormDetailID));
            };
            HSFNextStudentCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFNextStudentCtrl.controllerId = "HSFNextStudentCtrl";
            return HSFNextStudentCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFNextStudentCtrl = HSFNextStudentCtrl;
        Pulse.app.controller(HSFNextStudentCtrl.controllerId, ["$scope", "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFNextStudentCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFSpecialNeedsImmunizationsCtrl = (function (_super) {
            __extends(HSFSpecialNeedsImmunizationsCtrl, _super);
            function HSFSpecialNeedsImmunizationsCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFSpecialNeedsImmunizationsCtrl.controllerId) || this;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getReqdFormContentForUserFormDetail(_this.userFormDetail.userFormDetailID)
                        .then(function (data) {
                        _this.reqdFormContent = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            HSFSpecialNeedsImmunizationsCtrl.prototype.formSaveSuccess = function () {
                this.breezeService.getEntityManager().rejectChanges();
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.common.showSuccess(StringConst.Info_SaveSucceeded);
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Schooling, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFSpecialNeedsImmunizationsCtrl.prototype.backClick = function () {
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Medications, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFSpecialNeedsImmunizationsCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFSpecialNeedsImmunizationsCtrl.controllerId = "HSFSpecialNeedsImmunizationsCtrl";
            return HSFSpecialNeedsImmunizationsCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFSpecialNeedsImmunizationsCtrl = HSFSpecialNeedsImmunizationsCtrl;
        Pulse.app.controller(HSFSpecialNeedsImmunizationsCtrl.controllerId, [
            "$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFSpecialNeedsImmunizationsCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFSchoolingCtrl = (function (_super) {
            __extends(HSFSchoolingCtrl, _super);
            function HSFSchoolingCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFSchoolingCtrl.controllerId) || this;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.getReqdFormContent();
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            HSFSchoolingCtrl.prototype.getReqdFormContent = function () {
                var _this = this;
                this.common.toggleSpinner(true, null, null, 0);
                var promise = this.pulseContext.healthSafetyFormMgr.getReqdFormContentForUserFormDetail(this.userFormDetail.userFormDetailID)
                    .then(function (data) {
                    _this.reqdFormContent = data;
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
                return promise;
            };
            HSFSchoolingCtrl.prototype.formSaveSuccess = function () {
                this.breezeService.getEntityManager().rejectChanges();
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.common.showSuccess(StringConst.Info_SaveSucceeded);
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Authorization, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFSchoolingCtrl.prototype.backClick = function () {
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_SpecialNeedsImmunizations, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFSchoolingCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFSchoolingCtrl.controllerId = "HSFSchoolingCtrl";
            return HSFSchoolingCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFSchoolingCtrl = HSFSchoolingCtrl;
        Pulse.app.controller(HSFSchoolingCtrl.controllerId, [
            "$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFSchoolingCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var HSFAuthorizationCtrl = (function (_super) {
            __extends(HSFAuthorizationCtrl, _super);
            function HSFAuthorizationCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFAuthorizationCtrl.controllerId) || this;
                _this.isHSFAuthorized = false;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.formName = "HSFAuthPageForm";
                _this._hsfAuthorizationChangedHandler = $scope.$on(Events.HSFAuthorizationChanged, function (event, iUnderstand, iCertify, iAuthMedical, iCovidExposure, iFinResponsible, iStudentPickup) {
                    _this.isHSFAuthorized = (iUnderstand && iCertify && iAuthMedical && iCovidExposure && iFinResponsible && iStudentPickup);
                });
                $scope.$on('$destroy', function () {
                    _this._hsfAuthorizationChangedHandler();
                });
                _this.activateController();
                return _this;
            }
            HSFAuthorizationCtrl.prototype.submit = function () {
                var _this = this;
                if (this.myForm.$valid) {
                    this.submitted = true;
                    this.common.toggleSpinner(true, null, null, 0);
                    this.userFormDetail.entityAspect.setModified();
                    var self_1 = this;
                    this.breezeService.saveChanges(null, {
                        resourceName: "HSF_SaveAuthorization",
                        tag: this.pulseContext.healthSafetyFormMgr.isMedicAppMode,
                    })
                        .then(function (data) {
                        self_1.pulseContext.healthSafetyFormMgr.clearCache();
                        if (self_1.pulseContext.isImpersonating) {
                            self_1.common.updateCSImpersonationHeader(self_1.pulseContext.actingAsUser.userID);
                        }
                        if (self_1.pulseContext.healthSafetyFormMgr.isMedicAppMode) {
                            self_1.common.localStorageService.set(DataAccess.Managers.HealthSafetyFormMgr.HealthSafetyFormStateBag.stateBagId, null);
                            if (window != window.top) {
                                window.top.location.assign("#" + Routes.MedicParticipantMedsComplete);
                            }
                            else {
                                self_1.$location.url(Routes.MedicParticipantMedsComplete);
                            }
                        }
                        else {
                            self_1.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Thanks, QueryStringUtils.USERFORMDETAIL_ID, self_1.userFormDetail.userFormDetailID));
                        }
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                        _this.submitted = false;
                    });
                }
            };
            HSFAuthorizationCtrl.prototype.backClick = function () {
                if (this.userFormDetail.statusTypeID == Enums.FormStatus.Complete) {
                    this.pulseContext.healthSafetyFormMgr.clearCache();
                    this.$location.url(Routes.MyAccount_RequiredForms);
                }
                else {
                    this.$location.url(String.format("{0}?{1}={2}", Routes.HSF_Schooling, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID));
                }
            };
            HSFAuthorizationCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFAuthorizationCtrl.controllerId = "HSFAuthorizationCtrl";
            return HSFAuthorizationCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFAuthorizationCtrl = HSFAuthorizationCtrl;
        Pulse.app.controller(HSFAuthorizationCtrl.controllerId, [
            "$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFAuthorizationCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HSFThanksCtrl = (function (_super) {
            __extends(HSFThanksCtrl, _super);
            function HSFThanksCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFThanksCtrl.controllerId) || this;
                var ufdId = Number(Pulse.Utils.QueryStringUtils.GetParamByName($location.absUrl(), Pulse.Utils.QueryStringUtils.USERFORMDETAIL_ID));
                _this.activationPromises.push(_this.pulseContext.healthSafetyFormMgr.getUserFormDetail(ufdId)
                    .then(function (data) {
                    _this.userFormDetail = data;
                    _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                        .then(function (data) {
                        _this.participant = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                })
                    .catch(function (error) {
                    _this.logError(error);
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                }));
                _this.activateController();
                return _this;
            }
            HSFThanksCtrl.prototype.backClick = function () {
                this.pulseContext.healthSafetyFormMgr.clearCache();
                this.$location.url(Routes.MyAccount_RequiredForms);
            };
            HSFThanksCtrl.prototype.securityCheck = function () {
                _super.prototype.securityCheck.call(this);
                this.canUpdate = !this.pulseContext.isImpersonating
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance);
                this.canUpdate = this.canUpdate
                    || (!this.pulseContext.isImpersonating
                        && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region, Enums.UserRoleType.TermStaff, 1, 2));
                this.canSee = this.canUpdate
                    || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Region);
            };
            HSFThanksCtrl.controllerId = "HSFThanksCtrl";
            return HSFThanksCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HSFThanksCtrl = HSFThanksCtrl;
        Pulse.app.controller(HSFThanksCtrl.controllerId, [
            "$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            HSFThanksCtrl
        ]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var RegisterCtrl = (function (_super) {
            __extends(RegisterCtrl, _super);
            function RegisterCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RegisterCtrl.controllerId) || this;
                var params = {};
                params[QueryStringUtils.CHANGE_ORDER_TYPE] = Enums.ChangePurchasedOrderType.AddNew;
                _this.iFrameSrc = QueryStringUtils.AddOrSetQSParams(_this.pulseContext.pulse1x_PublicUrlRoot + "/ChooseLocationEx.aspx", params);
                _this.activateController();
                return _this;
            }
            RegisterCtrl.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls = this.allowedPartialUrls.concat(StringConst.Partial_URLs_For_Registration);
            };
            RegisterCtrl.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var _this = this;
                this.common.toggleSpinner(true);
                var urlLC = url.toLowerCase();
                return _super.prototype.actionBasedOnFrameUrl.call(this, frameId, urlLC).then(function (stopProcess) {
                    if (stopProcess)
                        return true;
                    for (var i = 0; i < _this.allowedPartialUrls.length; i++) {
                        if (urlLC.indexOf(_this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                            return false;
                        }
                    }
                    _this.iFrameSrc = "about:blank";
                    _this.$location.url(Routes.MyAccount);
                    return true;
                })
                    .catch(function (err) {
                    _this.logError(err);
                    return false;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            RegisterCtrl.controllerId = "registerCtrl";
            return RegisterCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.RegisterCtrl = RegisterCtrl;
        Pulse.app.controller(RegisterCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", RegisterCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var ChangeOrderCtrl = (function (_super) {
            __extends(ChangeOrderCtrl, _super);
            function ChangeOrderCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ChangeOrderCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                var destUrl = _this.pulseContext.pulse1x_PublicUrlRoot + "/SecurePages/SPA_ChangeOrder.aspx?" + QueryStringUtils.GetQueryString($location.url());
                _this.iFrameSrc = destUrl;
                _this.activateController();
                return _this;
            }
            ChangeOrderCtrl.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls.push("SPA_ChangeOrder.aspx", "ChooseLocationEx.aspx", "AvailabilityChartEx.aspx", "ParticipantInfo.aspx", "AddOptions.aspx", "SubscriptionUpsell.aspx", "YourInformation.aspx", "AddDiscounts.aspx", "OrderSummary2015.aspx", "Billing.aspx", "CustomerInfo2015.aspx", "OrderConfirmation.aspx", "GetFile.aspx", "EmailItinerary.aspx", "ChangeSessionDatesAndCourses", "CancelCourseSession.aspx", "CancelCourseSessionConfirmation.aspx", "SPA_ReturnOptConfirm.aspx", "Statements.aspx", "ViewStatement.aspx");
            };
            ChangeOrderCtrl.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var _this = this;
                this.common.toggleSpinner(true);
                url = url.toLowerCase();
                return _super.prototype.actionBasedOnFrameUrl.call(this, frameId, url).then(function (stopProcess) {
                    if (stopProcess)
                        return true;
                    for (var i = 0; i < _this.allowedPartialUrls.length; i++) {
                        if (url.indexOf(_this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                            return false;
                        }
                    }
                    _this.iFrameSrc = "about:blank";
                    _this.$location.url(Routes.MyAccount);
                    return true;
                })
                    .catch(function (err) {
                    _this.logError(err);
                    return false;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            ChangeOrderCtrl.controllerId = "changeOrderCtrl";
            return ChangeOrderCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.ChangeOrderCtrl = ChangeOrderCtrl;
        Pulse.app.controller(ChangeOrderCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", ChangeOrderCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var OnlineSessionsCtrl = (function (_super) {
            __extends(OnlineSessionsCtrl, _super);
            function OnlineSessionsCtrl($scope, $location, $routeParams, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OnlineSessionsCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                _this.serverDateTime = _this.pulseContext.serverDateTime;
                _this.studentID = Number($routeParams[QueryStringUtils.PARTICIPANT_ID]);
                _this.preSelectedParentOrderDetailId = Number($routeParams[QueryStringUtils.PARENT_ORDER_DETAIL_ID]);
                _this.preSelectedOrderDetailId = Number($routeParams[QueryStringUtils.ORDER_DETAIL_ID]);
                $scope.$on(Events.OPLSessionSummaryUpdated, function (event, sessionSummary) {
                    if (sessionSummary) {
                        _this.studentSessions.forEach(function (ss) {
                            var hasLessons = false;
                            ss.onlineSessions.forEach(function (s) {
                                if (s.orderDetailID == sessionSummary.orderDetailID) {
                                    s.instructorName = sessionSummary.instructorName;
                                    s.statusTypeID = sessionSummary.statusTypeID;
                                    s.statusStr = sessionSummary.statusStr;
                                    s.instructorName = sessionSummary.instructorName;
                                    s.expiryDate = sessionSummary.expiryDate;
                                }
                                if (_this.pulseContext.onlinePrivateLessonMgr.isSessionAvailable(s)) {
                                    hasLessons = true;
                                }
                            });
                            if (hasLessons != ss.hasLessonsAvailable) {
                                ss.hasLessonsAvailable = hasLessons;
                                _this.$scope.$broadcast(Events.OPLHasAvailableSessionsUpdated, ss);
                            }
                        });
                    }
                });
                if (!_this.pulseContext.customerMgr.alerts) {
                    _this.activationPromises.push(_this.pulseContext.customerMgr.loadStatusAndAlerts(true));
                }
                _this.activationPromises.push(_this.pulseContext.onlinePrivateLessonMgr.getStudentSessions()
                    .then(function (studentSessions) {
                    studentSessions.forEach(function (sl) {
                        var hasLessons = false;
                        sl.onlineSessions.forEach(function (s) {
                            if (_this.pulseContext.onlinePrivateLessonMgr.isSessionAvailable(s)) {
                                hasLessons = true;
                            }
                        });
                        sl.hasLessonsAvailable = hasLessons;
                    });
                    _this.sortStudentSessions(studentSessions);
                }));
                _this.activateController();
                return _this;
            }
            OnlineSessionsCtrl.prototype.sortStudentSessions = function (studentSessions) {
                this.studentSessions = studentSessions.sort(function (a, b) {
                    if (a.hasLessonsAvailable && !b.hasLessonsAvailable) {
                        return -1;
                    }
                    else if (!a.hasLessonsAvailable && b.hasLessonsAvailable) {
                        return 1;
                    }
                    else {
                        if (a.onlineSessions.length > 0 && b.onlineSessions.length <= 0) {
                            return -1;
                        }
                        else if (a.onlineSessions.length <= 0 && b.onlineSessions.length > 0) {
                            return 1;
                        }
                        else {
                            return a.firstName > b.firstName ? 1 : -1;
                        }
                    }
                });
            };
            OnlineSessionsCtrl.prototype.onActivated = function (activationResults) {
                this.alertList = this.pulseContext.customerMgr.alerts;
                this.secureAllFeatures();
            };
            OnlineSessionsCtrl.prototype.onOnlineLessonsClientRedirectClick = function () {
                this.common.$location.url(Routes.MyAccount_OPLOnlineSessionsClient);
            };
            OnlineSessionsCtrl.prototype.securityCheck = function () {
                this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.Corporate, 1, 2, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2, 3);
            };
            OnlineSessionsCtrl.controllerId = "onlineSessions";
            return OnlineSessionsCtrl;
        }(Pulse.Common.BaseAdminViewCtrl));
        Controllers.OnlineSessionsCtrl = OnlineSessionsCtrl;
        Pulse.app.controller(OnlineSessionsCtrl.controllerId, ["$scope",
            "$location",
            "$routeParams",
            "common",
            "breezeService",
            "pulseContextService",
            "uiGridConstants",
            "Papa",
            OnlineSessionsCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var OPLPurchaseCtrl = (function (_super) {
            __extends(OPLPurchaseCtrl, _super);
            function OPLPurchaseCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OPLPurchaseCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                _this.alertList = [];
                _this.genericOPL = {
                    skillID: -1,
                    displayName: 'No topic associated',
                    description: 'No topic associated',
                    name: 'No topic associated',
                    sort: 9999,
                    skillURLs: [],
                    isSelected: false,
                    genreIDs: []
                };
                if (!_this.pulseContext.customerMgr.alerts) {
                    _this.activationPromises.push(_this.pulseContext.customerMgr.loadStatusAndAlerts(true));
                }
                _this.activationPromises.push(_this.getOPLTopics());
                _this.activateController();
                return _this;
            }
            OPLPurchaseCtrl.prototype.getOPLTopics = function () {
                var _this = this;
                return this.pulseContext.onlinePrivateLessonMgr.getOPLTopicSkills()
                    .then(function (skills) {
                    _this.skills = skills;
                    _this.skills.push(_this.genericOPL);
                }).catch(function (error) {
                    _this.logError(error);
                });
            };
            OPLPurchaseCtrl.prototype.updateSelectedSkill = function () {
                var _this = this;
                if (!this.selectedSkillID)
                    return;
                return this.pulseContext.onlinePrivateLessonMgr.getOPLProducts(this.selectedSkillID, false)
                    .then(function (products) {
                    _this.products = _.map(products, function (p) { return _.extend({ isSubscriptionSelected: false }, p); });
                }).catch(function (error) {
                    _this.logError(error);
                });
            };
            OPLPurchaseCtrl.prototype.navigate = function (prod) {
                if (!prod)
                    return;
                this.common.$location.url(Routes.RegFlow_Tutoring + ("?" + QueryStringUtils.PRODUCT_ID + "=" + prod.prodID) + ("" + (prod.isSubscriptionSelected ? '&subscription=true' : '')));
            };
            OPLPurchaseCtrl.prototype.calculatePrice = function (prod) {
                if (prod.isSubscriptionSelected) {
                    return this.calculateDiscount(prod.price, prod.subDiscValueTypeID, prod.subDiscountValue);
                }
                else {
                    return prod.price;
                }
            };
            OPLPurchaseCtrl.prototype.calculateDiscount = function (originalPrice, discountValueType, discountValue) {
                if (discountValueType == Enums.DiscountValueType.FixedAmount) {
                    return originalPrice - discountValue;
                }
                else if (discountValueType == Enums.DiscountValueType.Percent) {
                    return originalPrice * (100 - discountValue) / 100;
                }
                else {
                    return originalPrice;
                }
            };
            OPLPurchaseCtrl.prototype.onActivated = function (activationResults) {
                this.alertList = this.pulseContext.customerMgr.alerts;
                this.secureAllFeatures();
            };
            OPLPurchaseCtrl.prototype.securityCheck = function () {
                this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.Corporate, 1, 2);
            };
            OPLPurchaseCtrl.controllerId = "oplPurchase";
            return OPLPurchaseCtrl;
        }(Pulse.Common.BaseAdminViewCtrl));
        Controllers.OPLPurchaseCtrl = OPLPurchaseCtrl;
        Pulse.app.controller(OPLPurchaseCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            OPLPurchaseCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var Enums = Pulse.Common.Enums;
        var ClientSessionsCtrl = (function (_super) {
            __extends(ClientSessionsCtrl, _super);
            function ClientSessionsCtrl($scope, $location, common, breezeService, pulseContext, $routeParams) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ClientSessionsCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                _this.serverDateTime = _this.pulseContext.serverDateTime;
                _this.showDropupMenu = false;
                _this.hasOPLSubscriptions = false;
                _this._showBadges = false;
                _this.handleStudentNotesChanged = function (event, studentUserID) {
                    _this.common.toggleSpinner(true, null, null, 0);
                    _this.pulseContext.onlinePrivateLessonMgr.getStudentNotes(studentUserID)
                        .then(function (data) {
                        _this.selectedStudent.studentNotes = data;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                };
                $scope.$on(Events.OPLStudentNoteUpdated, _this.handleStudentNotesChanged);
                $scope.$on(Events.OPLStudentNoteDeleted, _this.handleStudentNotesChanged);
                _this.$scope.$on(Events.OPLScheduleLessonsUpdated, function (event, payload) {
                    _this.common.toggleSpinner(true, null, null, 0);
                    _this.pulseContext.onlinePrivateLessonMgr.getStudentSessions(_this.selectedStudentID)
                        .then(function (data) {
                        _this.selectedStudentSession = data && data.length ? data[0] : null;
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                });
                _this.$scope.$on(Events.SubscriptionStatusUpdated, function (event, payload) {
                    _this.common.toggleSpinner(true, null, null, 0);
                    _this.getStudentSubscriptions()
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                });
                _this.activationPromises.push(_this.pulseContext.customerMgr.loadStatusAndAlerts(true)
                    .then(function () {
                    _this.hasOPLSubscriptions = _this.pulseContext.customerMgr.isStatus(DataAccess.Managers.CustomerMgr.CustomerStatusTypeMask.HasOPLSubscriptions);
                    if (_this.hasOPLSubscriptions) {
                        return _this.getStudentSubscriptions();
                    }
                }));
                _this.preSelelectedStudentID = Number($routeParams[QueryStringUtils.PARTICIPANT_ID]);
                _this.parentOrderDetailId = Number($routeParams[QueryStringUtils.PARENT_ORDER_DETAIL_ID]);
                _this.activationPromises.push(_this.getTimeZones()
                    .then(function () {
                    return _this.getStudents();
                }));
                _this.activateController();
                return _this;
            }
            ClientSessionsCtrl.prototype.onActivated = function (activationResults) {
                this.log('onActivated');
                this.alertList = this.pulseContext.customerMgr.alerts;
                this.secureAllFeatures();
                this.setSelectedStudent();
            };
            ClientSessionsCtrl.prototype.securityCheck = function () {
                this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Public);
            };
            ClientSessionsCtrl.prototype.updateSelectedTimeZoneTypeID = function () {
                var self = this;
                var tz = _.find(this.timeZoneTypes, { 'typeID': self.selectedStudent.timeZoneTypeID });
                if (tz) {
                    this.selectedTimeZoneType = tz;
                    this.common.showInfo("Your scheduled time is displayed in " + tz.typeDescription);
                }
            };
            Object.defineProperty(ClientSessionsCtrl.prototype, "selectedTimeZoneTypeStr", {
                get: function () {
                    var self = this;
                    if (!this.timeZoneTypes || !self.selectedStudent.timeZoneTypeID)
                        return;
                    var tz = _.find(this.timeZoneTypes, { 'typeID': self.selectedStudent.timeZoneTypeID });
                    if (tz) {
                        return tz.typeDescription;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ClientSessionsCtrl.prototype, "isOpl3", {
                get: function () {
                    return this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.OPLStaff, 3);
                },
                enumerable: false,
                configurable: true
            });
            ClientSessionsCtrl.prototype.getTimeZones = function () {
                var _this = this;
                return this.pulseContext.timeZoneMgr.loadTimeZones()
                    .then(function (data) {
                    _this.timeZoneTypes = data.sort(function (a, b) { return a.typeOrder < b.typeOrder ? -1 : a.typeOrder > b.typeOrder ? 1 : 0; });
                });
            };
            ClientSessionsCtrl.prototype.getStudents = function () {
                var _this = this;
                var self = this;
                var promise = self.pulseContext.onlinePrivateLessonMgr.getStudents()
                    .then(function (students) {
                    var studentIds = students.map(function (s) { return s.studentUserID; });
                    _this.log("getStudents - getStudentsAchievements");
                    _this.students = students;
                    return self.pulseContext.onlinePrivateLessonMgr.getStudentsAchievements(studentIds).then(function (resData) {
                        var badgeData = _this.setupBadgeData(resData);
                        resData.earnedBadges = _this.common.$filter('orderBy')(resData.earnedBadges, 'seqNum');
                        resData.availableBadges = _this.common.$filter('orderBy')(resData.availableBadges, 'seqNum');
                        _this.log(resData);
                        _this.availableBadges = badgeData.availableBadges;
                        students.forEach(function (ss) {
                            ss.originalTimeZoneTypeID = ss.timeZoneTypeID;
                            ss.earnedAchievements = [];
                            if (badgeData.earnedBadges != null && badgeData.earnedBadges.length > 0) {
                                ss.earnedAchievements = badgeData.earnedBadges.filter(function (f) { return f.userID == ss.studentUserID; });
                            }
                            var nextBadge = _this.getNextBadgeForStudent(ss.earnedAchievements, badgeData.availableBadges, ss.studentUserID);
                            ss.earnedAchievements.push(nextBadge);
                        });
                        _this._showBadges = true;
                    });
                }).catch(function (error) {
                    _this.logError(error);
                });
                return promise;
            };
            ClientSessionsCtrl.prototype.setupBadgeData = function (resData) {
                if (resData.earnedBadges !== undefined && resData.earnedBadges.length > 0) {
                    resData.earnedBadges.forEach(function (badge) {
                        badge.badgeImageTypeID = Enums.BadgeImageType.Awarded;
                    });
                }
                return resData;
            };
            ClientSessionsCtrl.prototype.getNextBadgeForStudent = function (earnedBadges, availableBadges, studentId) {
                var nextBadge = {};
                if (earnedBadges !== undefined && availableBadges !== undefined) {
                    var earnedIdx = Math.max(0, earnedBadges.length - 1);
                    var lastIdx = -1;
                    if (earnedIdx >= 0 && earnedBadges.length > 0) {
                        var lastEarned_1 = earnedBadges[earnedIdx];
                        lastIdx = _.findIndex(availableBadges, function (badge) {
                            return badge.badgeDefID == lastEarned_1.badgeDefID;
                        });
                    }
                    var nextBadgeIdx = earnedBadges.length > 0 ? lastIdx + 1 : 0;
                    var nextAvailable = availableBadges[nextBadgeIdx];
                    nextBadge = {
                        badgeDefID: nextAvailable.badgeDefID,
                        badgeDescription: nextAvailable.description,
                        badgeImageTypeID: Enums.BadgeImageType.NotYetEarned,
                        badgeName: nextAvailable.badgeName,
                        dateEarned: null,
                        userBadgeID: null,
                        userID: studentId
                    };
                }
                return nextBadge;
            };
            ClientSessionsCtrl.prototype.getStudentSubscriptions = function () {
                var _this = this;
                var self = this;
                var promise = self.pulseContext.onlinePrivateLessonMgr.getStudentSubscriptions()
                    .then(function (studentSubscriptions) {
                    _this.allStudentSubscriptions = studentSubscriptions.filter(function (s) { return s.isAutoRenew; }).sort(function (a, b) {
                        if (a.isSuspended)
                            return -1;
                        return (a.expiryDate ? a.expiryDate.valueOf() : 0) - (b.expiryDate ? b.expiryDate.valueOf() : 0);
                    });
                    if (_this.selectedStudentID > 0) {
                        _this.selectedStudentSubscriptions = _this.allStudentSubscriptions.filter(function (ss) { return ss.studentUserID == _this.selectedStudentID; });
                    }
                }).catch(function (error) {
                    _this.logError(error);
                });
                return promise;
            };
            ClientSessionsCtrl.prototype.hasSelectedStudentSubscriptions = function () {
                return this.selectedStudentSubscriptions && this.selectedStudentSubscriptions.length > 0;
            };
            ClientSessionsCtrl.prototype.selectedStudentChanged = function (studentUserID) {
                var _this = this;
                this.log('selectedStudentChanged');
                if (angular.isNumber(studentUserID)) {
                    this.selectedStudentID = studentUserID;
                }
                this.selectedStudent = this.students.filter(function (ss) { return ss.studentUserID == _this.selectedStudentID; })[0];
                if (!(this.selectedStudent))
                    return;
                var params = {};
                params[QueryStringUtils.PARTICIPANT_ID] = this.selectedStudentID;
                if (this.debug) {
                    params['debug'] = 1;
                }
                var url = QueryStringUtils.AddOrSetQSParams(window.location.href.split('?')[0], params);
                window.location.href = url;
                var promises = new Array();
                promises.push(this.pulseContext.onlinePrivateLessonMgr.getStudentSessions(this.selectedStudentID)
                    .then(function (data) {
                    _this.selectedStudentSession = data && data.length ? data[0] : null;
                }));
                if (this.pulseContext.isImpersonating) {
                    promises.push(this.pulseContext.onlinePrivateLessonMgr.getStudentNotes(this.selectedStudentID)
                        .then(function (data) {
                        _this.selectedStudent.studentNotes = data;
                    }));
                }
                if (!angular.isNumber(this.selectedStudent.timeZoneTypeID)) {
                    promises.push(this.pulseContext.timeZoneMgr.getClientTimeZoneType(DataAccess.Managers.TimeZoneMgr.browserTimeZoneStr)
                        .then(function (studTZ) {
                        _this.common.$timeout(function () {
                            _this.selectedStudent.timeZoneTypeID = studTZ;
                        }, 0);
                        var tz = _.find(_this.timeZoneTypes, { 'typeID': studTZ });
                        if (tz) {
                            _this.selectedTimeZoneType = tz;
                        }
                    }));
                }
                else {
                    var tz = _.find(this.timeZoneTypes, { 'typeID': this.selectedStudent.timeZoneTypeID });
                    if (tz) {
                        this.selectedTimeZoneType = tz;
                    }
                }
                if (this.hasOPLSubscriptions) {
                    this.selectedStudentSubscriptions = this.allStudentSubscriptions.filter(function (ss) { return ss.studentUserID == _this.selectedStudentID; });
                }
                this.sendChangeNotification();
                this.common.toggleSpinner(true, null, null, 0);
                return this.common.$q.all(promises)
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                    if (_this.common.isMobileView) {
                        _this.common.scrollToHash('opl-client');
                    }
                });
            };
            ClientSessionsCtrl.prototype.sendChangeNotification = function () {
                var _this = this;
                if (!this._showBadges || !this.selectedStudent) {
                    this.log('re-sendChangeNotification');
                    this.common.$timeout(function () {
                        _this.sendChangeNotification();
                    }, 50);
                }
                else {
                    this.log('sending ChangeNotification');
                    this.common.$timeout(function () {
                        _this.common.$rootScope.$broadcast(Events.OPLMyAccountStudentChanged, _this.selectedStudent);
                    }, 1000);
                }
            };
            ClientSessionsCtrl.prototype.setSelectedStudent = function () {
                if (this.preSelelectedStudentID) {
                    this.selectedStudentID = this.preSelelectedStudentID;
                }
                else if (this.students && this.students[0]) {
                    this.selectedStudentID = this.students[0].studentUserID;
                }
                this.selectedStudentChanged();
            };
            ClientSessionsCtrl.prototype.buyLessonsClick = function () {
                this.pulseContext.regFlowMgr = null;
                this.pulseContext.shoppingCartType = Enums.ShoppingCartType.RegFlow;
                this.common.$location.url(Routes.RegFlow_Upsell);
            };
            ClientSessionsCtrl.prototype.onOnlineLessonsAdminRedirectClick = function () {
                this.common.$location.url(Routes.MyAccount_OPLOnlineSessions);
            };
            ClientSessionsCtrl.prototype.onModifySubscriptionClick = function () {
                var params = {};
                params[QueryStringUtils.PARTICIPANT_ID] = this.selectedStudentID;
                this.common.$location.url(QueryStringUtils.AddOrSetQSParams(Routes.MyAccount_OPLOnlineSessionsClient, params));
            };
            ClientSessionsCtrl.prototype.showRenewalDateHelp = function ($event) {
                $event.preventDefault();
                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Renewal Date", Pulse.Directives.HelpPopup.HelpTopic.RenewalDateHelp, "renewalDateHelp");
            };
            Object.defineProperty(ClientSessionsCtrl.prototype, "showAchievements", {
                get: function () {
                    return this._showBadges
                        && this.selectedStudent !== undefined
                        && this.selectedStudent.earnedAchievements !== undefined
                        && this.selectedStudent.earnedAchievements.length > 0;
                },
                enumerable: false,
                configurable: true
            });
            ClientSessionsCtrl.prototype.onAchivementsClicked = function () {
                Pulse.Utils.scrollToElement(angular.element('#studentAchievements'), 0, 200);
            };
            ClientSessionsCtrl.prototype.log = function (log) {
                if (this.debug) {
                    console.log(log);
                }
            };
            Object.defineProperty(ClientSessionsCtrl.prototype, "debug", {
                get: function () {
                    return this.getParamAsBoolean('debug', false);
                },
                enumerable: false,
                configurable: true
            });
            ClientSessionsCtrl.prototype.getParamAsBoolean = function (qsParamName, defaultValue) {
                if (defaultValue === void 0) { defaultValue = false; }
                var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                if (Array.isArray(param)) {
                    param = param[0];
                }
                return typeof param === 'string' ? parseInt(param) == 1 : defaultValue;
            };
            ClientSessionsCtrl.controllerId = "clientSessions";
            return ClientSessionsCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ClientSessionsCtrl = ClientSessionsCtrl;
        Pulse.app.controller(ClientSessionsCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            "$routeParams",
            ClientSessionsCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var TimeZoneMgr = DataAccess.Managers.TimeZoneMgr;
        var ScheduleCtrl = (function (_super) {
            __extends(ScheduleCtrl, _super);
            function ScheduleCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ScheduleCtrl.controllerId) || this;
                _this.imgSrcCheckmark = _this.common.config.appRoot + "assets/images/icons/checkmark.svg";
                _this.selectedLesson = {};
                _this.isThemedOPL = false;
                _this.studentTimeZoneTypeStr = '';
                _this.isViolateOvertimeRules = false;
                _this.canViolateOvertimeRules = false;
                _this.hardwareSkills = null;
                _this.selectedSkillIDs = [];
                _this.isSchedulingRecurringDates = false;
                _this._allSelectedDateTimeString = null;
                _this._allSelectedInstructorsString = null;
                _this._availLessonsCache = null;
                _this._BackToMyAccountURL = null;
                _this.$scope.$on(Events.OPLScheduleCourseSelected, function (event, payload) {
                    _this.selectedTopic = payload;
                    _this.isShowScheduleTopics = false;
                    if (_this.common.isMobileView) {
                        _this.common.scrollToHash("opl-schedule-date-instructor", 250, 80);
                        return;
                    }
                });
                _this.$scope.$on(Events.OPLScheduleDateTimeSelected, function (event, payload) { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (this.selectedTopic) {
                                    this.selectedDateTime = payload.startTime;
                                    this.isShowScheduleDates = false;
                                }
                                this.isSchedulingRecurringDates = false;
                                this._allSelectedDateTimeString = null;
                                _a = payload.fromDirectiveID !== Pulse.Directives.PulsePublic.OplScheduleRecurringDatePopup.directiveId;
                                if (!_a) return [3, 2];
                                return [4, this.checkAndShowScheduleRecurringDates()];
                            case 1:
                                _a = (_b.sent());
                                _b.label = 2;
                            case 2:
                                if (_a)
                                    return [2];
                                if (this.selectedTopic && !this.selectedInstructor && this.selectedDateTime) {
                                    this.scheduleByInstructor();
                                    return [2];
                                }
                                if (this.selectedTopic && this.selectedDateTime
                                    && (this.isSchedulingRecurringDates || (!this.isSchedulingRecurringDates && this.selectedInstructor))) {
                                    this.scrollToTop(-15);
                                    this.checkAndShowConfirmMultipleLessons();
                                }
                                return [2];
                        }
                    });
                }); });
                _this.$scope.$on(Events.OPLScheduleInstructorSelected, function (event, instructors) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (this.selectedTopic) {
                                    this._allSelectedInstructorsString = null;
                                    this.assignInstructorsToSelectedLessons(instructors);
                                    this.isShowScheduleInstructors = false;
                                }
                                this.isShowScheduleDates = !this.selectedDateTime && (angular.isDefined(this.selectedInstructor) && this.selectedInstructor != null);
                                if (!!this.selectedDateTime) return [3, 3];
                                return [4, this.getAvailableDates(this.selectedInstructor.userID)];
                            case 1:
                                _a.sent();
                                if (!this.calendarFocusedDate) return [3, 3];
                                return [4, this.selectedDateUpdated(this.calendarFocusedDate)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                if (this.selectedTopic && !this.selectedDateTime) {
                                    this.common.scrollToHash("opl-schedule-date-time", 250, 80);
                                    return [2];
                                }
                                if (this.selectedTopic && this.selectedDateTime
                                    && (this.isSchedulingRecurringDates || (!this.isSchedulingRecurringDates && this.selectedInstructor))) {
                                    this.scrollToTop(-15);
                                    this.checkAndShowConfirmMultipleLessons();
                                }
                                return [2];
                        }
                    });
                }); });
                _this.$scope.$on(Events.OPLScheduleTimeZoneSelected, function (event, payload) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.adjustForTimezoneChange(this.studentTimeZoneTypeID, payload);
                                this.studentTimeZoneTypeID = payload;
                                this.studentTimeZoneTypeStr = _.find(this.timeZoneTypes, function (t) { return t.typeID === payload; }).typeDescription;
                                if (!(this.selectedInstructor && !this.selectedDateTime)) return [3, 4];
                                return [4, this.getAvailableDates(this.selectedInstructor ? this.selectedInstructor.userID : null)];
                            case 1:
                                _a.sent();
                                if (!this.calendarFocusedDate) return [3, 3];
                                return [4, this.selectedDateUpdated(this.calendarFocusedDate)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [3, 7];
                            case 4:
                                this.selectedInstructor = null;
                                this.selectedDateTime = null;
                                this.getAvailableStaffs(!!this.calendarFocusedDate);
                                return [4, this.getAvailableDates(this.selectedInstructor ? this.selectedInstructor.userID : null)];
                            case 5:
                                _a.sent();
                                if (!this.calendarFocusedDate) return [3, 7];
                                return [4, this.selectedDateUpdated(this.calendarFocusedDate)];
                            case 6:
                                _a.sent();
                                _a.label = 7;
                            case 7: return [2];
                        }
                    });
                }); });
                _this.$scope.$on(Events.OPLScheduleHardwareFilterApplied, function (event, payload) {
                    _this.selectedSkillIDs = payload;
                    _this.getAvailableStaffs(!!_this.selectedDateTime);
                });
                _this.getParametersFromUrl();
                _this.isShowScheduleTopics = true;
                _this.canViolateOvertimeRules = _this.pulseContext.isImpersonating &&
                    _this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.OPLStaff, 1);
                _this.activationPromises.push(_this.getTimeZones()
                    .then(function () {
                    return _this.getStudentUser();
                }));
                _this.activateController();
                return _this;
            }
            ScheduleCtrl.prototype.onActivated = function (activationResults) {
                this.secureAllFeatures();
                var self = this;
                var selectedTZ = _.find(this.timeZoneTypes, function (t) { return t.typeID === self.studentTimeZoneTypeID; });
                this.studentTimeZoneTypeStr = selectedTZ ? selectedTZ.typeDescription : '';
                this.originalTZTypeStr = selectedTZ === null || selectedTZ === void 0 ? void 0 : selectedTZ.typeDescription;
                this.originalTZTypeID = selectedTZ === null || selectedTZ === void 0 ? void 0 : selectedTZ.typeID;
            };
            ScheduleCtrl.prototype.securityCheck = function () {
                if (this.pulseContext.isImpersonating) {
                    this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.Corporate, 1, 2, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2, 3);
                }
                else {
                    this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Public);
                }
            };
            ScheduleCtrl.prototype.getParametersFromUrl = function () {
                var params = QueryStringUtils.GetParams(window.location.href);
                this.studentID = Number(params[QueryStringUtils.PARTICIPANT_ID]);
                this.orderDetailID = Number(params[QueryStringUtils.ORDER_DETAIL_ID]);
                this.parentOrderDetailID = Number(params[QueryStringUtils.PARENT_ORDER_DETAIL_ID]);
                this.productID = Number(params[QueryStringUtils.PRODUCT_ID]);
                this.isRescheduling = Boolean(params[QueryStringUtils.RESCHEDULING]);
                this.selectedTopicIDFromUrl = Number(params[QueryStringUtils.SKILL_ID]);
                this.selectedInstructorIDFromUrl = Number(params[QueryStringUtils.INSTRUCTOR_USER_ID]);
            };
            Object.defineProperty(ScheduleCtrl.prototype, "selectedTopic", {
                get: function () {
                    return this.selectedLesson.topic;
                },
                set: function (val) {
                    this.selectedLesson.topic = val;
                    this.selectedLesson.topicSkillID = val === null || val === void 0 ? void 0 : val.skillID;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ScheduleCtrl.prototype, "selectedDateTime", {
                get: function () {
                    return this.selectedLesson.dateTime;
                },
                set: function (val) {
                    this.selectedLesson.dateTime = val;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ScheduleCtrl.prototype, "selectedInstructor", {
                get: function () {
                    return this.selectedLesson.instructor;
                },
                set: function (val) {
                    this.selectedLesson.instructor = val;
                    this.selectedLesson.instructorUserID = val === null || val === void 0 ? void 0 : val.userID;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ScheduleCtrl.prototype, "allSelectedDateTimeString", {
                get: function () {
                    if (this.isSchedulingRecurringDates) {
                        if (!this._allSelectedDateTimeString) {
                            var monthStr = void 0, timeStr = void 0;
                            var result = "";
                            var days = [];
                            var month = -1;
                            for (var _i = 0, _a = this.selectedLessonsWithNoInstructors; _i < _a.length; _i++) {
                                var lesson = _a[_i];
                                var lessonMonth = lesson.dateTime.getMonth();
                                if (month != lessonMonth) {
                                    if (!monthStr) {
                                        monthStr = this.common.$filter("date")(lesson.dateTime, "EEEE, MMMM ");
                                        timeStr = this.common.$filter("date")(lesson.dateTime, " '@' h:mm a");
                                    }
                                    else {
                                        result += monthStr + days.join(", ") + timeStr + "<br>";
                                        monthStr = this.common.$filter("date")(lesson.dateTime, "EEEE, MMMM ");
                                        days.length = 0;
                                    }
                                    month = lessonMonth;
                                }
                                days.push(lesson.dateTime.getDate());
                            }
                            result += monthStr + days.join(", ") + timeStr + "<br>";
                            this._allSelectedDateTimeString = result;
                        }
                        return this._allSelectedDateTimeString;
                    }
                    else {
                        return this.common.$filter("date")(this.selectedDateTime, ScheduleCtrl.FORMAT_DATETIME_STR);
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ScheduleCtrl.prototype, "allSelectedInstructorString", {
                get: function () {
                    if (this.isSchedulingRecurringDates) {
                        if (!this._allSelectedInstructorsString) {
                            var result = "";
                            var instructors = this.selectedLessons.map(function (lesson) { return lesson.instructor; });
                            instructors = _.uniqBy(instructors, 'userID');
                            for (var _i = 0, instructors_1 = instructors; _i < instructors_1.length; _i++) {
                                var instructor = instructors_1[_i];
                                if (instructor) {
                                    result += instructor.firstName + " " + instructor.lastName + "<br>";
                                }
                            }
                            this._allSelectedInstructorsString = result;
                        }
                        return this._allSelectedInstructorsString;
                    }
                    else {
                        return this.selectedInstructor ?
                            this.selectedInstructor.firstName + " " + this.selectedInstructor.lastName
                            : "";
                    }
                },
                enumerable: false,
                configurable: true
            });
            ScheduleCtrl.prototype.addSelectedLesson = function (lesson) {
                if (!this.selectedLessons) {
                    this.selectedLessons = [lesson];
                    return;
                }
                var existingLesson = this.findInSelectedLessons(lesson);
                if (existingLesson == null) {
                    this.selectedLessons.push(lesson);
                }
                else {
                    existingLesson = __assign(__assign({}, existingLesson), lesson);
                }
                this.selectedLessons.sort(function (a, b) { return Pulse.Utils.JS.compareForSort(a, b, { 'dateTime': 0 }); });
            };
            ScheduleCtrl.prototype.removeLesson = function (lesson) {
                var _a;
                var index = this.selectedLessons.indexOf(lesson);
                if (index >= 0) {
                    this.selectedLessons.splice(index, 1);
                    if (this.selectedLessons.length == 0) {
                        this.isShowScheduleDates = true;
                        this.isShowScheduleInstructors = false;
                    }
                    if (this.isShowScheduleInstructors) {
                        this.scheduleByInstructor();
                    }
                    else if (this.isShowScheduleDates) {
                        this.scheduleByDate((_a = this.selectedInstructor) === null || _a === void 0 ? void 0 : _a.userID);
                    }
                }
            };
            ScheduleCtrl.prototype.removeLessonsWithoutDateTime = function () {
                var _a;
                if (this.selectedLessons && this.selectedLessons.length) {
                    var lessonsWithDateTime = this.selectedLessons.filter(function (lesson) { return !!lesson.dateTime; });
                    this.selectedLessons.length = 0;
                    (_a = this.selectedLessons).push.apply(_a, lessonsWithDateTime);
                }
            };
            ScheduleCtrl.prototype.removeLessonsWithoutInstructor = function () {
                var _a;
                if (this.selectedLessons && this.selectedLessons.length) {
                    var lessonsWithInstructor = this.selectedLessons.filter(function (lesson) { return !!lesson.instructor; });
                    this.selectedLessons.length = 0;
                    (_a = this.selectedLessons).push.apply(_a, lessonsWithInstructor);
                }
            };
            ScheduleCtrl.prototype.findInSelectedLessons = function (lesson) {
                var found = this.selectedLessons.filter(function (less) { return less.orderDetailID === lesson.orderDetailID; });
                if (found.length)
                    return found[0];
                return null;
            };
            Object.defineProperty(ScheduleCtrl.prototype, "selectedLessonsWithNoInstructors", {
                get: function () {
                    if (this.selectedLessons && this.selectedLessons.length) {
                        return this.selectedLessons.filter(function (lesson) { return !lesson.instructor; });
                    }
                    return null;
                },
                enumerable: false,
                configurable: true
            });
            ScheduleCtrl.prototype.assignInstructorsToSelectedLessons = function (instructors) {
                if (!instructors || !instructors.length)
                    return;
                if (!this.isSchedulingRecurringDates) {
                    this.selectedInstructor = instructors[0];
                }
                else {
                    this._assignInstrsToLessions(instructors);
                    var lessons = this.selectedLessonsWithNoInstructors;
                    if (!lessons.length)
                        return;
                    var instructorsNotPreferred = this.availableInstructors.filter(function (instr) { return instructors.indexOf(instr) < 0; });
                    this._assignInstrsToLessions(instructorsNotPreferred);
                }
            };
            ScheduleCtrl.prototype._assignInstrsToLessions = function (instructors) {
                for (var _i = 0, instructors_2 = instructors; _i < instructors_2.length; _i++) {
                    var instr = instructors_2[_i];
                    var lessons = this.selectedLessonsWithNoInstructors;
                    if (!lessons.length)
                        break;
                    for (var _a = 0, lessons_1 = lessons; _a < lessons_1.length; _a++) {
                        var lesson = lessons_1[_a];
                        for (var _b = 0, _c = instr.matchDateTimes; _b < _c.length; _b++) {
                            var matchDateTime = _c[_b];
                            if (matchDateTime.valueOf() == lesson.dateTime.valueOf()) {
                                lesson.instructor = instr;
                                lesson.instructorUserID = instr.userID;
                                break;
                            }
                        }
                    }
                }
            };
            ScheduleCtrl.prototype.getAvailLessons = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!(this._availLessonsCache == null)) return [3, 2];
                                _a = this;
                                return [4, this.pulseContext.onlinePrivateLessonMgr.getNextSessionsForScheduling(this.studentID, this.parentOrderDetailID)];
                            case 1:
                                _a._availLessonsCache = _b.sent();
                                _b.label = 2;
                            case 2:
                                this._availLessonsCache = this.sortAvailableLessons(this._availLessonsCache);
                                return [2, this._availLessonsCache];
                        }
                    });
                });
            };
            ScheduleCtrl.prototype.checkAndShowConfirmMultipleLessons = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var availLessons;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(!this.isRescheduling && this.selectedTopic && this.selectedDateTime
                                    && (this.isSchedulingRecurringDates || (!this.isSchedulingRecurringDates && this.selectedInstructor)))) return [3, 2];
                                this.selectedLesson.productID = this.productID;
                                this.selectedLesson.orderDetailID = this.orderDetailID;
                                this.selectedLesson.parentOrderDetailID = this.parentOrderDetailID;
                                this.addSelectedLesson(this.selectedLesson);
                                return [4, this.getAvailLessons()];
                            case 1:
                                availLessons = _a.sent();
                                this.$scope.$broadcast(Events.ShowOplScheduleMultibleTimePopup, {
                                    size: Pulse.Common.BasePopup.ModalSize.Large,
                                    initDataObj: {
                                        availableLessons: availLessons,
                                        studentUser: this.studentUser,
                                        selectedLessons: this.selectedLessons,
                                        selectedLesson: this.selectedLesson,
                                        studentTimeZoneTypeStr: this.studentTimeZoneTypeStr,
                                        isSchedulingRecurringDates: this.isSchedulingRecurringDates,
                                        addMoreLessons: function (isSameInstructor) {
                                            if (isSameInstructor === void 0) { isSameInstructor = true; }
                                            _this.addMoreLessons(isSameInstructor);
                                        },
                                        removeLesson: function (lesson) { _this.removeLesson(lesson); },
                                        scheduleLessons: function () { _this.scheduleLessons(); },
                                        goBack: function () { _this.backFromShowConfirmMultipleLessons(); }
                                    }
                                });
                                return [2, true];
                            case 2: return [2, false];
                        }
                    });
                });
            };
            ScheduleCtrl.prototype.checkAndShowScheduleRecurringDates = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var availLessons, allTimeSlots;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(!this.isRescheduling && this.selectedTopic && this.selectedDateTime && !this.selectedInstructor)) return [3, 3];
                                this.removeLessonsWithoutInstructor();
                                this.removeLessonsWithoutDateTime();
                                return [4, this.getAvailLessons()];
                            case 1:
                                availLessons = _a.sent();
                                if (!(!this.selectedLessons || (availLessons.length - this.selectedLessons.length) > 1)) return [3, 3];
                                this.selectedLesson.productID = this.productID;
                                this.selectedLesson.orderDetailID = this.orderDetailID;
                                this.selectedLesson.parentOrderDetailID = this.parentOrderDetailID;
                                this.addSelectedLesson(this.selectedLesson);
                                return [4, this.getAllAvailableDateTimes()];
                            case 2:
                                allTimeSlots = _a.sent();
                                this.$scope.$broadcast(Events.ShowOplScheduleRecurringDatePopup, {
                                    size: Pulse.Common.BasePopup.ModalSize.Medium,
                                    initDataObj: {
                                        availableLessons: availLessons,
                                        studentUser: this.studentUser,
                                        selectedLessons: this.selectedLessons,
                                        selectedLesson: this.selectedLesson,
                                        studentTimeZoneTypeStr: this.studentTimeZoneTypeStr,
                                        allAvailableTimeSlots: allTimeSlots,
                                        isThemedOPL: this.isThemedOPL,
                                        addSelectedLesson: function (lesson) { _this.addSelectedLesson(lesson); },
                                        chooseMultipleInstructors: function () { _this.chooseMultipleInstructors(); },
                                        showDateTimeList: function () { _this.showDateTimeList(); },
                                    }
                                });
                                return [2, true];
                            case 3: return [2, false];
                        }
                    });
                });
            };
            ScheduleCtrl.prototype.sortAvailableLessons = function (lessons) {
                var _this = this;
                var sortedLessons = lessons.filter(function (lesson) {
                    return lesson.orderDetailID == _this.selectedLesson.orderDetailID;
                });
                sortedLessons.push.apply(sortedLessons, lessons.filter(function (lesson) {
                    return lesson.orderDetailID != _this.selectedLesson.orderDetailID
                        && lesson.parentOrderDetailID == _this.selectedLesson.parentOrderDetailID;
                }));
                sortedLessons.push.apply(sortedLessons, lessons.filter(function (lesson) {
                    return lesson.orderDetailID != _this.selectedLesson.orderDetailID
                        && lesson.parentOrderDetailID != _this.selectedLesson.parentOrderDetailID
                        && lesson.parentProductID == _this.selectedLesson.productID;
                }));
                sortedLessons.push.apply(sortedLessons, lessons.filter(function (lesson) {
                    return lesson.orderDetailID != _this.selectedLesson.orderDetailID
                        && lesson.parentOrderDetailID != _this.selectedLesson.parentOrderDetailID
                        && lesson.parentProductID != _this.selectedLesson.productID;
                }));
                return sortedLessons;
            };
            ScheduleCtrl.prototype.adjustForTimezoneChange = function (fromTzID, toTzID) {
                if (this.selectedLessons && this.selectedLessons.length) {
                    for (var _i = 0, _a = this.selectedLessons; _i < _a.length; _i++) {
                        var lesson = _a[_i];
                        if (lesson && lesson.dateTime) {
                            lesson.dateTime = this.pulseContext.timeZoneMgr.convertDateTimeFromTZaToTZb(lesson.dateTime, fromTzID, toTzID);
                        }
                    }
                }
            };
            ScheduleCtrl.prototype.hasSchedulableSelectedLessons = function () {
                if (this.selectedLessons) {
                    for (var _i = 0, _a = this.selectedLessons; _i < _a.length; _i++) {
                        var lesson = _a[_i];
                        if (lesson && lesson.topic && lesson.instructor && lesson.dateTime) {
                            return true;
                        }
                    }
                }
                return false;
            };
            ScheduleCtrl.prototype.getBackToMyAccountURL = function () {
                if (!this._BackToMyAccountURL && this.studentID && this.parentOrderDetailID) {
                    var params = {};
                    params[QueryStringUtils.PARTICIPANT_ID] = this.studentID;
                    params[QueryStringUtils.PARENT_ORDER_DETAIL_ID] = this.parentOrderDetailID;
                    if (this.isRescheduling) {
                        params[QueryStringUtils.OPL_CLIENT_UI_TAB_IDX] = Pulse.Directives.OplStudentLessonsDir.TabIndex.Scheduled;
                    }
                    else {
                        params[QueryStringUtils.OPL_CLIENT_UI_TAB_IDX] = Pulse.Directives.OplStudentLessonsDir.TabIndex.Available;
                    }
                    this._BackToMyAccountURL = '#' + QueryStringUtils.AddOrSetQSParams(Routes.MyAccount_OPLOnlineSessionsClient, params);
                }
                return this._BackToMyAccountURL;
            };
            ScheduleCtrl.prototype.getTimeZones = function () {
                var _this = this;
                return this.pulseContext.timeZoneMgr.loadTimeZones()
                    .then(function (data) {
                    _this.timeZoneTypes = data.sort(function (a, b) { return a.typeOrder < b.typeOrder ? -1 : a.typeOrder > b.typeOrder ? 1 : 0; });
                });
            };
            ScheduleCtrl.prototype.getStudentUser = function () {
                var _this = this;
                return this.pulseContext.userMgr.getRelatedUserEntitiesForActingUser(this.studentID)
                    .then(function (userResult) {
                    if (userResult.length == 1) {
                        _this.studentUser = userResult[0];
                        _this.studentTimeZoneTypeID = userResult[0].timeZoneTypeID;
                        if (_this.isRescheduling) {
                            _this.activationPromises.push(_this.getSessionSummary(_this.orderDetailID, TimeZoneMgr.browserTimeZoneStr));
                        }
                        else {
                            _this.getOPLSkills();
                        }
                    }
                }).then(function () {
                    if (!angular.isNumber(_this.studentTimeZoneTypeID)) {
                        _this.pulseContext.timeZoneMgr.getClientTimeZoneType(TimeZoneMgr.browserTimeZoneStr)
                            .then(function (result) {
                            if (angular.isNumber(result) && result > 0) {
                                _this.studentTimeZoneTypeID = result;
                                _this.studentTimeZoneTypeStr = _.find(_this.timeZoneTypes, function (t) { return t.typeID === result; }).typeDescription;
                            }
                            else {
                                _this.studentTimeZoneTypeID = null;
                            }
                        });
                    }
                });
            };
            ScheduleCtrl.prototype.getSessionSummary = function (odid, tzStr) {
                var _this = this;
                return this.pulseContext.onlinePrivateLessonMgr.getSessionSummaries(-1, tzStr, odid)
                    .then(function (data) {
                    var _a;
                    _this.sessionSummary = data[0];
                    _this.selectedTopic = {
                        skillID: _this.sessionSummary.skillID,
                        displayName: _this.sessionSummary.skillStr,
                        name: _this.sessionSummary.skillStr,
                        description: _this.sessionSummary.skillStr,
                        genreIDs: [],
                        isSelected: false,
                        skillURLs: []
                    };
                    _this.selectedDateTime = _this.convertDateTimeFromUTC((_a = _this.sessionSummary) === null || _a === void 0 ? void 0 : _a.startDateTimeUTC);
                    _this.selectedInstructor = {
                        userID: _this.sessionSummary.instructorUserID,
                        firstName: _this.sessionSummary.instructorName,
                        lastName: '',
                    };
                })
                    .then(function () {
                    var _a;
                    return _this.getOPLSkills((_a = _this.sessionSummary) === null || _a === void 0 ? void 0 : _a.skillID);
                })
                    .then(function () {
                    var _a;
                    return _this.getOPLTopicSkillsHardware((_a = _this.sessionSummary) === null || _a === void 0 ? void 0 : _a.skillID);
                })
                    .then(function () {
                    _this.addSelectedLesson(_this.selectedLesson);
                })
                    .catch(function (err) {
                    _this.common.logAllErrorTypes(err, _this.loggingId);
                });
            };
            ScheduleCtrl.prototype.getOPLSkills = function (selectedSkillID) {
                var _this = this;
                if (selectedSkillID === void 0) { selectedSkillID = null; }
                this.isShowScheduleTopics = false;
                return this.pulseContext.onlinePrivateLessonMgr.getOPLTopicGenres()
                    .then(function (data) {
                    _this.oplGenreTypes = data;
                    return _this.pulseContext.onlinePrivateLessonMgr.getOPLTopicSkills(_this.productID, _this.studentID, selectedSkillID)
                        .then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.clientTopicSkills = data;
                                    if (!this.pulseContext.isImpersonating) {
                                        this.groupSkillsByGenre(data);
                                    }
                                    if (data.length == 1) {
                                        this.selectedTopic = data[0];
                                        this.isShowScheduleTopics = false;
                                        this.isThemedOPL = true;
                                    }
                                    else {
                                        this.isThemedOPL = false;
                                        if (this.isRescheduling) {
                                            this.isShowScheduleTopics = false;
                                        }
                                        else {
                                            if (!selectedSkillID)
                                                this.selectedTopic = null;
                                            this.isShowScheduleTopics = true;
                                        }
                                    }
                                    if (!this.pulseContext.isImpersonating) return [3, 2];
                                    return [4, this.pulseContext.onlinePrivateLessonMgr.getOPLTopicSkills(null, this.studentID)
                                            .then(function (data) {
                                            _this.groupSkillsByGenre(data);
                                            if (data.length == 1) {
                                                _this.selectedTopic = data[0];
                                                _this.isShowScheduleTopics = false;
                                                _this.isThemedOPL = true;
                                            }
                                            else {
                                                _this.isThemedOPL = false;
                                                if (_this.isRescheduling) {
                                                    _this.isShowScheduleTopics = false;
                                                }
                                                else {
                                                    if (!selectedSkillID)
                                                        _this.selectedTopic = null;
                                                    _this.isShowScheduleTopics = true;
                                                }
                                            }
                                        })];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [2, null];
                            }
                        });
                    }); }).then(function () {
                        if ((!_this.selectedTopic && _this.selectedTopicIDFromUrl > 0)
                            || (_this.selectedTopicIDFromUrl && _this.selectedTopic.skillTypeID != _this.selectedTopicIDFromUrl)) {
                            var topicFromUrl = _this.oplTopicSkills.filter(function (s) { return s.skillID == _this.selectedTopicIDFromUrl; })[0];
                            if (topicFromUrl) {
                                _this.selectedTopic = topicFromUrl;
                                _this.isShowScheduleTopics = false;
                            }
                        }
                    }).then(function () {
                        if ((!_this.selectedInstructor && _this.selectedInstructorIDFromUrl > 0)
                            || (_this.selectedInstructorIDFromUrl && _this.selectedInstructor.userID != _this.selectedInstructorIDFromUrl)) {
                            return _this.getAvailableStaffs().then(function () {
                                var instructorFromUrl = _this.availableInstructors.filter(function (i) { return i.userID == _this.selectedInstructorIDFromUrl; })[0];
                                if (instructorFromUrl) {
                                    _this.selectedInstructor = instructorFromUrl;
                                }
                            }).then(function () {
                                if (!_this.selectedDateTime) {
                                    return _this.getAvailableDates(_this.selectedInstructor.userID)
                                        .then(function () {
                                        if (_this.calendarFocusedDate)
                                            _this.selectedDateUpdated(_this.calendarFocusedDate);
                                        _this.showDateTimeList();
                                    });
                                }
                            });
                        }
                    });
                });
            };
            ScheduleCtrl.prototype.groupSkillsByGenre = function (data) {
                var _this = this;
                this.oplTopicSkills = data;
                this.oplTopicSkills.forEach(function (s) {
                    var existsInClientSkills = _this.clientTopicSkills.some(function (cts) { return cts.skillID == s.skillID; });
                    s.isAdminOverride = !existsInClientSkills;
                });
                var list = [];
                this.oplGenreTypes.forEach(function (genre) {
                    var item = {
                        genreType: genre,
                        skills: _this.oplTopicSkills.filter(function (s) { return s.genreIDs.indexOf(genre.typeID) >= 0; })
                    };
                    list.push(item);
                });
                this.genreTopicsList = list;
            };
            ScheduleCtrl.prototype.showInstructorList = function () {
                this.isShowScheduleDates = false;
                this.isShowScheduleInstructors = true;
                this.isShowScheduleTopics = false;
            };
            ScheduleCtrl.prototype.showDateTimeList = function () {
                this.isShowScheduleDates = true;
                this.isShowScheduleInstructors = false;
                this.isShowScheduleTopics = false;
            };
            ScheduleCtrl.prototype.scheduleByDate = function (staffUserID) {
                var _this = this;
                if (staffUserID === void 0) { staffUserID = null; }
                if (!this.selectedTopic) {
                    this.common.showWarning("Please select a Topic first.");
                    return;
                }
                this.availableDateTimes = null;
                this.getAvailableDates(staffUserID).then(function () {
                    _this.calendarFocusedDate = !_this.calendarFocusedDate ? _this.selectedDateTime : _this.calendarFocusedDate;
                    _this.selectedDateUpdated(_this.calendarFocusedDate);
                    _this.showDateTimeList();
                });
            };
            ScheduleCtrl.prototype.scheduleByInstructor = function () {
                var _this = this;
                if (!this.selectedTopic) {
                    this.common.showWarning("Please select a Topic first.");
                    return;
                }
                return this.getOPLTopicSkillsHardware(this.selectedTopic.skillID)
                    .then(function () {
                    return _this.getAvailableStaffs(true).then(function () {
                        _this.showInstructorList();
                        _this.common.scrollToHash("opl-schedule-instructor", 250, 80);
                    });
                });
            };
            ScheduleCtrl.prototype.scheduleLessons = function () {
                var _this = this;
                if (this.scheduleBtnDisabled)
                    return;
                this.scheduleBtnDisabled = true;
                this.common.toggleSpinner(true);
                var promise;
                if (this.isRescheduling) {
                    promise = this.pulseContext.onlinePrivateLessonMgr.scheduleLesson(this.selectedTopic.skillID, this.selectedInstructor.userID, this.studentID, this.orderDetailID, this.selectedDateTime, this.studentTimeZoneTypeID, this.pulseContext.isImpersonating && this.isViolateOvertimeRules, this.isRescheduling);
                }
                else {
                    promise = this.pulseContext.onlinePrivateLessonMgr.scheduleMultipleLessons(this.studentID, this.studentTimeZoneTypeID, this.pulseContext.isImpersonating && this.isViolateOvertimeRules, this.selectedLessons)
                        .then(function (resultLessons) {
                        for (var _i = 0, resultLessons_1 = resultLessons; _i < resultLessons_1.length; _i++) {
                            var less = resultLessons_1[_i];
                            var found = _this.findInSelectedLessons(less);
                            if (found) {
                                found.regErrMsg = less.regErrMsg;
                            }
                        }
                        _this.selectedLessons.sort(function (v1, v2) { return Pulse.Utils.JS.compareForSort(v1, v2, { 'dateTime': 0 }); });
                    });
                }
                promise.then(function (res) {
                    _this.showScheduleConfirmation();
                })
                    .catch(function (err) {
                    _this.common.logAllErrorTypes(err, _this.loggingId);
                })
                    .finally(function () {
                    _this.scheduleBtnDisabled = false;
                    _this.common.toggleSpinner(false);
                });
            };
            ScheduleCtrl.prototype.showScheduleConfirmation = function () {
                var _this = this;
                this.pulseContext.onlinePrivateLessonMgr.getNextSessionsForScheduling(this.studentID, this.parentOrderDetailID)
                    .then(function (res) {
                    var _a, _b;
                    _this.common.$rootScope.$broadcast(Events.ShowOPLScheduledConfirmationPopup, {
                        size: Pulse.Common.BasePopup.ModalSize.Large,
                        initDataObj: {
                            availableLessons: res,
                            studentUser: _this.studentUser,
                            parentOrderDetailID: _this.parentOrderDetailID,
                            productID: _this.productID,
                            selectedTopicID: (_a = _this.selectedTopic) === null || _a === void 0 ? void 0 : _a.skillID,
                            selectedInstructorID: (_b = _this.selectedInstructor) === null || _b === void 0 ? void 0 : _b.userID,
                            selectedLessons: _this.selectedLessons,
                            studentTimeZoneTypeStr: _this.studentTimeZoneTypeStr,
                            isRescheduling: _this.isRescheduling
                        }
                    });
                });
            };
            ScheduleCtrl.prototype.changeTopic = function () {
                var _this = this;
                if (!this.canChangeSkill()) {
                    this.common.showWarning("The topic cannot be changed for this kind of lesson.");
                    return;
                }
                if ((this.selectedInstructor || this.selectedInstructor) && !this.isRescheduling) {
                    this.common.showConfirmation("Please confirm", "Changing Topics at this point during scheduling may result in losing your selected date/time and instructor.", function (confirm) {
                        if (confirm) {
                            _this.selectedTopic = null;
                            _this.selectedDateTime = null;
                            _this.selectedInstructor = null;
                            _this.isShowScheduleTopics = true;
                            _this.isShowScheduleDates = false;
                            _this.isShowScheduleInstructors = false;
                        }
                    }, { size: 'md' }, 'Change Topic', 'Cancel', false);
                }
                else {
                    this.selectedDateTime = null;
                    this.selectedInstructor = null;
                    this.isShowScheduleTopics = true;
                    this.isShowScheduleDates = false;
                    this.isShowScheduleInstructors = false;
                }
            };
            ScheduleCtrl.prototype.changeDateTime = function () {
                var _this = this;
                var confirmationMsg = '';
                var button1 = null;
                var button2 = null;
                var button3 = null;
                var popupSize = Pulse.Common.BasePopup.ModalSize.Medium;
                button1 = {
                    label: 'Change Date & Time',
                    isVisible: true,
                    isCloseAfterClick: true,
                    cbFn: function () {
                        _this.getAvailableDates(_this.selectedInstructor ? _this.selectedInstructor.userID : null)
                            .then(function () {
                            _this.isSchedulingRecurringDates = false;
                            _this.removeLessonsWithoutDateTime();
                            _this.selectedDateTime = null;
                            _this.calendarFocusedDate = !_this.calendarFocusedDate ? _this.selectedDateTime : _this.calendarFocusedDate;
                            _this.selectedDateUpdated(_this.calendarFocusedDate);
                            _this.showDateTimeList();
                        });
                    },
                };
                if (this.selectedInstructor) {
                    confirmationMsg = 'Do you wish to change the date/time only or change instructor and date/time. This will remove your current selection.';
                    button2 = {
                        label: 'Change Instructor and Date & Time ',
                        isVisible: true,
                        isCloseAfterClick: true,
                        cssClass: 'px-3 btn btn-primary',
                        cbFn: function () {
                            _this.getAvailableDates(null)
                                .then(function () {
                                _this.isSchedulingRecurringDates = false;
                                _this.removeLessonsWithoutDateTime();
                                _this.selectedDateTime = null;
                                _this.selectedInstructor = null;
                                _this.calendarFocusedDate = !_this.calendarFocusedDate ? _this.selectedDateTime : _this.calendarFocusedDate;
                                _this.selectedDateUpdated(_this.calendarFocusedDate);
                            });
                        },
                    };
                    button3 = {
                        label: 'Cancel',
                        isVisible: true,
                        isCloseAfterClick: true,
                        cssClass: 'px-3 btn btn-outline-secondary',
                    };
                    popupSize = Pulse.Common.BasePopup.ModalSize.Large;
                }
                else {
                    confirmationMsg = 'Change date/time? This will remove your current selection.';
                    button2 = {
                        label: 'Cancel',
                        isVisible: true,
                        isCloseAfterClick: true,
                        cssClass: 'px-3 btn btn-outline-secondary',
                        cbFn: function () {
                        }
                    };
                }
                var popupInitDataObj = {
                    popupId: 'popup_changeTime',
                    title: 'Please confirm',
                    html: confirmationMsg,
                    button1: button1,
                    button2: button2,
                    button3: button3,
                };
                this.common.$rootScope.$broadcast(Events.ShowBasicPopup, {
                    size: popupSize,
                    initDataObj: popupInitDataObj,
                });
            };
            ScheduleCtrl.prototype.changeInstructor = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var confirmationMsg, button1, button2, button3, popupSize, popupInitDataObj;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this.isRescheduling) return [3, 2];
                                this.selectedDateTime = null;
                                this.selectedInstructor = null;
                                this.isShowScheduleDates = false;
                                this.isShowScheduleInstructors = true;
                                return [4, this.getOPLTopicSkillsHardware(this.selectedTopic.skillID)];
                            case 1:
                                _a.sent();
                                this.getAvailableStaffs();
                                return [2];
                            case 2:
                                confirmationMsg = '';
                                button1 = null;
                                button2 = null;
                                button3 = null;
                                popupSize = Pulse.Common.BasePopup.ModalSize.Medium;
                                button1 = {
                                    label: 'Change Instructor',
                                    isVisible: true,
                                    isCloseAfterClick: true,
                                    cbFn: function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    this.selectedInstructor = null;
                                                    this.isShowScheduleDates = false;
                                                    this.isShowScheduleInstructors = true;
                                                    return [4, this.getOPLTopicSkillsHardware(this.selectedTopic.skillID)];
                                                case 1:
                                                    _a.sent();
                                                    this.getAvailableStaffs(!!this.selectedDateTime);
                                                    return [2];
                                            }
                                        });
                                    }); },
                                };
                                confirmationMsg = 'Do you wish to change the instructor only or change instructor and date/time. This will remove your current selection.';
                                button2 = {
                                    label: 'Change Instructor and Date & Time ',
                                    isVisible: true,
                                    isCloseAfterClick: true,
                                    cssClass: 'px-3 btn btn-primary',
                                    cbFn: function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    this.isSchedulingRecurringDates = false;
                                                    this.removeLessonsWithoutDateTime();
                                                    this.selectedDateTime = null;
                                                    this.selectedInstructor = null;
                                                    this.isShowScheduleDates = false;
                                                    this.isShowScheduleInstructors = false;
                                                    return [4, this.getOPLTopicSkillsHardware(this.selectedTopic.skillID)];
                                                case 1:
                                                    _a.sent();
                                                    this.getAvailableStaffs();
                                                    return [2];
                                            }
                                        });
                                    }); },
                                };
                                button3 = {
                                    label: 'Cancel',
                                    isVisible: true,
                                    isCloseAfterClick: true,
                                    cssClass: 'px-3 btn btn-outline-secondary',
                                };
                                popupSize = Pulse.Common.BasePopup.ModalSize.Large;
                                popupInitDataObj = {
                                    popupId: 'popup_changeTime',
                                    title: 'Please confirm',
                                    html: confirmationMsg,
                                    button1: button1,
                                    button2: button2,
                                    button3: button3,
                                };
                                this.common.$rootScope.$broadcast(Events.ShowBasicPopup, {
                                    size: popupSize,
                                    initDataObj: popupInitDataObj,
                                });
                                return [2];
                        }
                    });
                });
            };
            ScheduleCtrl.prototype.onTopicClosed = function () {
                this.isShowScheduleTopics = false;
            };
            ScheduleCtrl.prototype.onDateTimeClosed = function () {
                this.isShowScheduleDates = false;
                this.isShowScheduleInstructors = !this.selectedInstructor && angular.isDate(this.selectedDateTime);
            };
            ScheduleCtrl.prototype.onInstructorClosed = function () {
                this.isShowScheduleInstructors = false;
                this.isShowScheduleDates = !this.selectedDateTime && (angular.isDefined(this.selectedInstructor) && this.selectedInstructor != null);
            };
            ScheduleCtrl.prototype.canChangeSkill = function () {
                return this.pulseContext.isImpersonating || !this.isThemedOPL;
            };
            ScheduleCtrl.prototype.violateOvertimeRules = function () {
                if (!this.isViolateOvertimeRules) {
                    this.selectedInstructor = null;
                    this.selectedDateTime = null;
                }
                if (this.selectedTopic) {
                    this.getAvailableStaffs(!!this.selectedDateTime);
                    this.getAvailableDates(this.selectedInstructor ? this.selectedInstructor.userID : null);
                }
            };
            ScheduleCtrl.prototype.selectedDateUpdated = function (selectedDate) {
                if (angular.isDate(selectedDate)) {
                    return this.getAvailableDateTimes(selectedDate, this.selectedInstructor ? this.selectedInstructor.userID : null);
                }
                return null;
            };
            ScheduleCtrl.prototype.getOPLTopicSkillsHardware = function (selectedSkillID) {
                var _this = this;
                this.common.toggleSpinner(true);
                return this.pulseContext.onlinePrivateLessonMgr.getOPLTopicSkillsHardware(this.orderDetailID, selectedSkillID)
                    .then(function (result) {
                    if (result.filter(function (hs) { return hs.skillID === selectedSkillID; }).length > 0) {
                        _this.hardwareSkills = [];
                    }
                    else {
                        _this.hardwareSkills = result;
                    }
                    _this.hardwareSkills = result.filter(function (hs) { return hs.skillID !== selectedSkillID; });
                    _this.selectedSkillIDs = _this.hardwareSkills.filter(function (hs) { return hs.isSelected; }).map(function (hs) { return hs.skillID; });
                }).catch(function (error) {
                    _this.logError(error);
                }).finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            ScheduleCtrl.prototype.getAvailableStaffs = function (bySpecificDates) {
                var _this = this;
                if (bySpecificDates === void 0) { bySpecificDates = false; }
                this.common.toggleSpinner(true);
                var skillIDs = __spreadArrays(this.selectedSkillIDs, [this.selectedTopic.skillID]);
                var selectedDateTimes;
                if (bySpecificDates) {
                    if (this.isSchedulingRecurringDates) {
                        selectedDateTimes = this.selectedLessonsWithNoInstructors.map(function (lesson) { return lesson.dateTime; });
                    }
                    else {
                        selectedDateTimes = this.selectedDateTime ? [this.selectedDateTime] : [];
                    }
                }
                return this.pulseContext.onlinePrivateLessonMgr.getAvailableStaff(skillIDs, this.studentID, this.orderDetailID, selectedDateTimes, this.studentTimeZoneTypeID, this.isViolateOvertimeRules, this.selectedLessons)
                    .then(function (result) {
                    _this.availableInstructors = result;
                }).catch(function (error) {
                    _this.logError(error);
                }).finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            ScheduleCtrl.prototype.getAvailableDates = function (staffUserID) {
                var _this = this;
                if (staffUserID === void 0) { staffUserID = null; }
                this.common.toggleSpinner(true);
                if (this.isOPL3_Only) {
                    staffUserID = this.pulseContext.loggedInUserId;
                }
                return this.pulseContext.onlinePrivateLessonMgr.getAvailableDates(this.selectedTopic.skillID, staffUserID, this.studentID, this.orderDetailID, null, null, this.studentTimeZoneTypeID, this.isViolateOvertimeRules, this.selectedLessons)
                    .then(function (result) {
                    _this.availableDates = result;
                    _this.availableDateTimes = null;
                }).catch(function (error) {
                    _this.logError(error);
                }).finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            ScheduleCtrl.prototype.getAvailableDateTimes = function (selectedDate, staffUserID) {
                var _this = this;
                if (staffUserID === void 0) { staffUserID = null; }
                this.common.toggleSpinner(true);
                if (this.isOPL3_Only) {
                    staffUserID = this.pulseContext.loggedInUserId;
                }
                var startDateTime = moment(selectedDate).isSame(moment(), 'day')
                    ? this.pulseContext.timeZoneMgr.convertDateTimeFromTZaToTZb(new Date(), TimeZoneMgr.browserTimeZoneStr, this.studentTimeZoneTypeID)
                    : moment(selectedDate).startOf('day').toDate();
                return this.pulseContext.onlinePrivateLessonMgr.getAvailableTimeSlots(this.selectedTopic.skillID, staffUserID, this.studentID, this.orderDetailID, startDateTime, moment(startDateTime).endOf('day').toDate(), this.studentTimeZoneTypeID, this.isViolateOvertimeRules, this.selectedLessons)
                    .then(function (result) {
                    _this.availableDateTimes = result;
                }).catch(function (error) {
                    _this.logError(error);
                }).finally(function () {
                    _this.common.toggleSpinner(false);
                });
            };
            ScheduleCtrl.prototype.getAllAvailableDateTimes = function (staffUserID) {
                if (staffUserID === void 0) { staffUserID = null; }
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.common.toggleSpinner(true);
                                if (this.isOPL3_Only) {
                                    staffUserID = this.pulseContext.loggedInUserId;
                                }
                                return [4, this.pulseContext.onlinePrivateLessonMgr.getAvailableTimeSlots(this.selectedTopic.skillID, staffUserID, this.studentID, this.orderDetailID, null, null, this.studentTimeZoneTypeID, this.isViolateOvertimeRules, this.selectedLessons)
                                        .finally(function () {
                                        _this.common.toggleSpinner(false);
                                    })];
                            case 1: return [2, _a.sent()];
                        }
                    });
                });
            };
            Object.defineProperty(ScheduleCtrl.prototype, "isOPL3_Only", {
                get: function () {
                    return this.pulseContext.onlinePrivateLessonMgr.isOPL3_Only();
                },
                enumerable: false,
                configurable: true
            });
            ScheduleCtrl.prototype.hasChanges = function () {
                var _a, _b, _c, _d, _e;
                if (!this.hasSchedulableSelectedLessons())
                    return false;
                var isTheSame = ((_a = this.sessionSummary) === null || _a === void 0 ? void 0 : _a.skillID) == ((_b = this.selectedTopic) === null || _b === void 0 ? void 0 : _b.skillID) &&
                    moment(this.convertDateTimeFromUTC((_c = this.sessionSummary) === null || _c === void 0 ? void 0 : _c.startDateTimeUTC)).isSame(moment(this.selectedDateTime)) &&
                    ((_d = this.sessionSummary) === null || _d === void 0 ? void 0 : _d.instructorUserID) == ((_e = this.selectedInstructor) === null || _e === void 0 ? void 0 : _e.userID) &&
                    this.originalTZTypeID == this.studentTimeZoneTypeID;
                return !isTheSame;
            };
            ScheduleCtrl.prototype.convertDateTimeFromUTC = function (utcDateTimeStr) {
                if (String.isNullOrWhitespace(utcDateTimeStr) || !this.originalTZTypeID)
                    return;
                var self = this;
                var tzStr = _.find(this.timeZoneTypes, function (t) { return t.typeID === self.originalTZTypeID; }).typeExtraString;
                return this.sessionSummary.startDateTimeUTC ? TimeZoneMgr.convertDateTimeFromUTC(utcDateTimeStr, tzStr) : null;
            };
            ScheduleCtrl.prototype.addMoreLessons = function (isSameInstructor) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.getParametersFromUrl();
                                this.removeLessonsWithoutInstructor();
                                this.removeLessonsWithoutDateTime();
                                this.selectedLesson = __assign({}, this.selectedLesson);
                                this.selectedTopic = null;
                                return [4, this.getOPLSkills(this.selectedLesson.topicSkillID)];
                            case 1:
                                _a.sent();
                                if (!isSameInstructor || this.isSchedulingRecurringDates) {
                                    this.isSchedulingRecurringDates = false;
                                    this.selectedInstructor = null;
                                    this.selectedDateTime = null;
                                }
                                else if (this.selectedTopic && this.selectedInstructor) {
                                    this.selectedDateTime = null;
                                    this.scheduleByDate(this.selectedInstructor.userID);
                                }
                                return [2];
                        }
                    });
                });
            };
            ScheduleCtrl.prototype.chooseMultipleInstructors = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        this.isSchedulingRecurringDates = true;
                        this._allSelectedInstructorsString = null;
                        this.scheduleByInstructor();
                        return [2];
                    });
                });
            };
            ScheduleCtrl.prototype.onResetToNonRecurringLesson = function () {
                this.isSchedulingRecurringDates = false;
                this._allSelectedDateTimeString = null;
                this._allSelectedInstructorsString = null;
                this.removeLessonsWithoutInstructor();
                this.selectedDateTime = null;
                this.scheduleByInstructor();
            };
            ScheduleCtrl.prototype.backFromShowConfirmMultipleLessons = function () {
                if (this.isSchedulingRecurringDates) {
                    this.selectedInstructor = null;
                    this.selectedDateTime = null;
                    this.selectedLessons.length = 0;
                    this.isSchedulingRecurringDates = false;
                }
                else {
                    this.removeLessonsWithoutInstructor();
                }
                this._allSelectedDateTimeString = null;
                this._allSelectedInstructorsString = null;
            };
            ScheduleCtrl.controllerId = "ScheduleCtrl";
            ScheduleCtrl.FORMAT_DATETIME_STR = "EEEE, MMMM d '@' h:mm a";
            return ScheduleCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.ScheduleCtrl = ScheduleCtrl;
        Pulse.app.controller(ScheduleCtrl.controllerId, ["$scope",
            "$location",
            "common",
            "breezeService",
            "pulseContextService",
            ScheduleCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var Managers = DataAccess.Managers;
        var OplSessionReportCtrl = (function (_super) {
            __extends(OplSessionReportCtrl, _super);
            function OplSessionReportCtrl($scope, $location, $routeParams, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplSessionReportCtrl.controllerId) || this;
                _this.topNavMenuSelected = Pulse.Directives.PulsePublic.TopNavDir.TopNavItemType.Home;
                _this.serverDateTime = _this.pulseContext.serverDateTime;
                _this.onCloseClicked = function () {
                    var returnUrl = QueryStringUtils.GetParamByName(_this.common.$location.url(), QueryStringUtils.RETURN_URL.toLowerCase());
                    if (String.isNullOrWhitespace(returnUrl)) {
                        returnUrl = QueryStringUtils.GetParamByName(_this.common.$location.url(), QueryStringUtils.RETURN_URL);
                    }
                    if (window.parent && !String.isNullOrWhitespace(returnUrl)) {
                        window.parent.location.href = returnUrl;
                    }
                    else {
                        _this.onOnlineLessonsClientRedirectClick();
                    }
                };
                _this.studentID = Number($routeParams[QueryStringUtils.PARTICIPANT_ID]);
                _this.parentOrderDetailId = Number($routeParams[QueryStringUtils.PARENT_ORDER_DETAIL_ID]);
                _this.orderDetailId = Number($routeParams[QueryStringUtils.ORDER_DETAIL_ID]);
                $scope.$on(Events.OPLSessionSummaryUpdated, function (event, sessionSummary) {
                    if (sessionSummary) {
                    }
                });
                if (!_this.pulseContext.customerMgr.alerts) {
                    _this.activationPromises.push(_this.pulseContext.customerMgr.loadStatusAndAlerts());
                }
                _this.activationPromises.push(_this.pulseContext.onlinePrivateLessonMgr.getSessionSummaries(-1, Managers.TimeZoneMgr.browserTimeZoneStr, _this.orderDetailId)
                    .then(function (data) {
                    _this.sessionSummary = data[0];
                }));
                _this.activateController();
                return _this;
            }
            OplSessionReportCtrl.prototype.onActivated = function (activationResults) {
                this.secureAllFeatures();
            };
            OplSessionReportCtrl.prototype.securityCheck = function () {
                this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, Enums.UserRoleType.Corporate, 1, 2, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2, 3);
                this.canUpdate = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2, 3);
            };
            OplSessionReportCtrl.prototype.onOnlineLessonsAdminRedirectClick = function () {
                var params = {};
                params[QueryStringUtils.PARTICIPANT_ID] = this.studentID;
                params[QueryStringUtils.PARENT_ORDER_DETAIL_ID] = this.parentOrderDetailId;
                params[QueryStringUtils.ORDER_DETAIL_ID] = this.orderDetailId;
                this.common.$location.url(QueryStringUtils.AddOrSetQSParams(Routes.MyAccount_OPLOnlineSessions, params));
            };
            OplSessionReportCtrl.prototype.onOnlineLessonsClientRedirectClick = function () {
                var url = this.common.$location.url();
                var paramTabIndex = QueryStringUtils.GetParamByName(url, QueryStringUtils.OPL_CLIENT_UI_TAB_IDX);
                url = Routes.MyAccount_OPLOnlineSessionsClient;
                var params = {};
                params[QueryStringUtils.ORDER_DETAIL_ID] = this.sessionSummary.orderDetailID;
                if (paramTabIndex) {
                    params[QueryStringUtils.OPL_CLIENT_UI_TAB_IDX] = parseInt(paramTabIndex);
                }
                url = QueryStringUtils.AddOrSetQSParams(url, params);
                this.common.$location.url(url);
            };
            OplSessionReportCtrl.controllerId = "OplSessionReport";
            return OplSessionReportCtrl;
        }(Pulse.Common.BaseAdminViewCtrl));
        Controllers.OplSessionReportCtrl = OplSessionReportCtrl;
        Pulse.app.controller(OplSessionReportCtrl.controllerId, ["$scope",
            "$location",
            "$routeParams",
            "common",
            "breezeService",
            "pulseContextService",
            "uiGridConstants",
            "Papa",
            OplSessionReportCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var TermStaffHomeCtrl = (function (_super) {
            __extends(TermStaffHomeCtrl, _super);
            function TermStaffHomeCtrl($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, TermStaffHomeCtrl.controllerId) || this;
                _this.autoLogin = true;
                _this.iFrameSrc = _this.pulseContext.pulse1x_PublicUrlRoot + _this.getClassicPulseTermStaffURL() + "?"
                    + QueryStringUtils.COMPANY_ID + "=" + _this.pulseContext.companyId;
                $scope.$on(Events.IFrameLoaded, function (event) {
                    _this.scrollToTop();
                });
                _this.activateController();
                return _this;
            }
            TermStaffHomeCtrl.prototype.getClassicPulseTermStaffURL = function () {
                var url = "/Applicant/Dashboard.aspx";
                if (this.$location.url().toLowerCase().indexOf(Routes.TermStaff_RAF) >= 0) {
                    url = "/Applicant/ReferAFriendForHire.aspx";
                }
                else if (this.$location.url().toLowerCase().indexOf(Routes.TermStaff_Employment) >= 0) {
                    url = "/Applicant/JobApplication.aspx";
                }
                return url;
            };
            TermStaffHomeCtrl.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls.push("/Applicant/", "/JobApplication/");
            };
            TermStaffHomeCtrl.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var _this = this;
                this.common.toggleSpinner(true);
                var urlLC = url.toLowerCase();
                return _super.prototype.actionBasedOnFrameUrl.call(this, frameId, urlLC, this.autoLogin).then(function (stopProcess) {
                    _this.autoLogin = false;
                    if (stopProcess)
                        return true;
                    for (var i = 0; i < _this.allowedPartialUrls.length; i++) {
                        if (urlLC.indexOf(_this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                            return false;
                        }
                    }
                    _this.iFrameSrc = "about:blank";
                    if (urlLC.indexOf(Paths.Pulse1x_PublicMyAccountDashboard) > 0) {
                        _this.$location.url(Routes.MyAccount);
                    }
                    else {
                        _this.$location.url(Routes.Login);
                    }
                    return true;
                })
                    .catch(function (err) {
                    _this.logError(err);
                    return false;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false);
                    _this.scrollToTop();
                });
            };
            TermStaffHomeCtrl.controllerId = "termStaffHomeCtrl";
            return TermStaffHomeCtrl;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.TermStaffHomeCtrl = TermStaffHomeCtrl;
        Pulse.app.controller(TermStaffHomeCtrl.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", TermStaffHomeCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var GetFileAspxCtlr = (function (_super) {
            __extends(GetFileAspxCtlr, _super);
            function GetFileAspxCtlr($scope, $location, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, GetFileAspxCtlr.controllerId) || this;
                _this.showWaitSpinner = false;
                var queryString = QueryStringUtils.GetQueryString($location.absUrl());
                var companyID = $location.search()[QueryStringUtils.COMPANY_ID];
                if (String.isNullOrWhitespace(companyID)) {
                    queryString += "&" + QueryStringUtils.COMPANY_ID + "=" + _this.pulseContext.companyId;
                }
                _this.iFrameSrc = _this.pulseContext.pulse1x_PublicUrlRoot + Paths.Pulse1x_PublicGetFile + "?" + queryString;
                _this.activateController();
                _this.showWaitSpinner = false;
                return _this;
            }
            GetFileAspxCtlr.prototype.onViewLoaded = function () {
            };
            GetFileAspxCtlr.prototype.setAllowedPartialUrls = function () {
                this.allowedPartialUrls.push("GetFile.aspx");
            };
            GetFileAspxCtlr.prototype.actionBasedOnFrameUrl = function (frameId, url) {
                var _this = this;
                var urlLC = url.toLowerCase();
                return _super.prototype.actionBasedOnFrameUrl.call(this, frameId, urlLC).then(function (stopProcess) {
                    if (stopProcess)
                        return true;
                    for (var i = 0; i < _this.allowedPartialUrls.length; i++) {
                        if (urlLC.indexOf(_this.allowedPartialUrls[i].toLowerCase()) >= 0) {
                            return false;
                        }
                    }
                    _this.iFrameSrc = "about:blank";
                    _this.$location.url(Routes.MyAccount);
                    return true;
                })
                    .catch(function (err) {
                    _this.logError(err);
                    return false;
                })
                    .finally(function () {
                    _this.common.toggleSpinner(false, true, undefined, 20);
                });
            };
            GetFileAspxCtlr.controllerId = "getFileAspxCtlr";
            return GetFileAspxCtlr;
        }(Pulse.Common.BaseCtrlWithiFrame));
        Controllers.GetFileAspxCtlr = GetFileAspxCtlr;
        Pulse.app.controller(GetFileAspxCtlr.controllerId, ["$scope", "$location", "common", "breezeService", "pulseContextService", GetFileAspxCtlr]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var SearchCtrl = (function (_super) {
            __extends(SearchCtrl, _super);
            function SearchCtrl($scope, $location, $routeParams, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SearchCtrl.controllerId) || this;
                _this.divisionId = $routeParams[QueryStringUtils.DIVISION_ID] || null;
                _this.locationId = $routeParams[QueryStringUtils.LOCATION_ID] || null;
                _this.sessionId = $routeParams[QueryStringUtils.SESSION_ID] || null;
                _this.imgSrcLogoSmall = _this.common.config.appRoot + "assets/images/id-logo-small.png";
                _this.activateController();
                return _this;
            }
            SearchCtrl.controllerId = "searchCtrl";
            return SearchCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.SearchCtrl = SearchCtrl;
        Pulse.app.controller(SearchCtrl.controllerId, ["$scope", "$location", "$routeParams",
            "common",
            "breezeService",
            "pulseContextService",
            SearchCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var SmsSendCtrl = (function (_super) {
            __extends(SmsSendCtrl, _super);
            function SmsSendCtrl($scope, $location, $routeParams, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SmsSendCtrl.controllerId) || this;
                _this.participantId = $routeParams.participantId;
                _this.action = $routeParams.action;
                _this.imgSrcLogoSmall = _this.common.config.appRoot + "assets/images/id-logo-small.png";
                _this.activateController();
                return _this;
            }
            SmsSendCtrl.controllerId = "SmsSendCtrl";
            return SmsSendCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.SmsSendCtrl = SmsSendCtrl;
        Pulse.app.controller(SmsSendCtrl.controllerId, ["$scope", "$location", "$routeParams",
            "common",
            "breezeService",
            "pulseContextService",
            SmsSendCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var SmsSentCtrl = (function (_super) {
            __extends(SmsSentCtrl, _super);
            function SmsSentCtrl($scope, $location, $routeParams, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SmsSentCtrl.controllerId) || this;
                if (angular.isObject(_this.pulseContext.medicAppMgr.currentLocation)) {
                    _this.locationId = _this.pulseContext.medicAppMgr.currentLocation.locationID;
                }
                _this.imgSrcLogo = _this.common.config.appRoot + "assets/images/id-logo.png";
                _this.activateController();
                return _this;
            }
            SmsSentCtrl.controllerId = "SmsSentCtrl";
            return SmsSentCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.SmsSentCtrl = SmsSentCtrl;
        Pulse.app.controller(SmsSentCtrl.controllerId, ["$scope", "$location", "$routeParams",
            "common",
            "breezeService",
            "pulseContextService",
            SmsSentCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var SmsAuthCtrl = (function (_super) {
            __extends(SmsAuthCtrl, _super);
            function SmsAuthCtrl($scope, $location, $routeParams, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SmsAuthCtrl.controllerId) || this;
                _this.code = $routeParams.code;
                _this.imgSrcLogo = _this.common.config.appRoot + "assets/images/id-logo.png";
                _this.activateController();
                return _this;
            }
            SmsAuthCtrl.controllerId = "SmsAuthCtrl";
            return SmsAuthCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.SmsAuthCtrl = SmsAuthCtrl;
        Pulse.app.controller(SmsAuthCtrl.controllerId, ["$scope", "$location", "$routeParams",
            "common",
            "breezeService",
            "pulseContextService",
            SmsAuthCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var DataAccess = Pulse.Common.DataAccess;
        var CompleteCtrl = (function (_super) {
            __extends(CompleteCtrl, _super);
            function CompleteCtrl($scope, $location, $routeParams, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CompleteCtrl.controllerId) || this;
                _this.isInTsMode = false;
                _this.imgSrcLogo = _this.common.config.appRoot + "assets/images/id-logo.png";
                _this.activateController();
                if (_this.pulseContext.medicAppMgr.stateBag.isTsMode) {
                    _this.isInTsMode = true;
                    if (angular.isArray(_this.common.localStorageService.get(DataAccess.Managers.MedicAppMgr.storageStashId))) {
                        var stash = _this.common.localStorageService.get(DataAccess.Managers.MedicAppMgr.storageStashId);
                        for (var i = 0; i <= stash.length - 1; i++) {
                            if (stash[i]["key"] !== (null || "undefined")) {
                                _this.common.localStorageService.set(stash[i]["key"], stash[i]["value"]);
                            }
                        }
                        _this.common.localStorageService.remove(DataAccess.Managers.MedicAppMgr.storageStashId);
                    }
                }
                else {
                    _this.common.localStorageService.set(Pulse.Services.PulseContextService.authDataId, null);
                    _this.common.localStorageService.clearAll();
                }
                return _this;
            }
            CompleteCtrl.controllerId = "CompleteCtrl";
            return CompleteCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.CompleteCtrl = CompleteCtrl;
        Pulse.app.controller(CompleteCtrl.controllerId, ["$scope", "$location", "$routeParams",
            "common",
            "breezeService",
            "pulseContextService",
            CompleteCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var EditCtrl = (function (_super) {
            __extends(EditCtrl, _super);
            function EditCtrl($scope, $location, $routeParams, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, EditCtrl.controllerId) || this;
                _this.userFormDetailId = $routeParams.userFormDetailId;
                _this.userId = $routeParams.userId;
                _this.token = $routeParams.token;
                _this.frameSrc = window.location.href.split('#')[0] + "#" + Routes.HSF_Medications
                    + "?" + QueryStringUtils.USERFORMDETAIL_ID + "=" + _this.userFormDetailId
                    + "&" + QueryStringUtils.MEDIC_APP_MEDS_ONLY + "=" + "1"
                    + "&" + QueryStringUtils.MEDIC_APP_MODE + "=" + "1"
                    + "&" + QueryStringUtils.MEDIC_APP_SMS_CODE + "=" + _this.pulseContext.medicAppMgr.stateBag.smsAuthToken
                    + "&" + QueryStringUtils.USER_ID + "=" + _this.userId
                    + "&" + QueryStringUtils.GUID + "=" + _this.token;
                _this.activateController();
                return _this;
            }
            EditCtrl.prototype.cancel = function () {
                this.common.$location.url(Routes.MedicParticipantMedsComplete);
            };
            EditCtrl.controllerId = "EditCtrl";
            return EditCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.EditCtrl = EditCtrl;
        Pulse.app.controller(EditCtrl.controllerId, ["$scope", "$location", "$routeParams",
            "common",
            "breezeService",
            "pulseContextService",
            EditCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Controllers;
    (function (Controllers) {
        var HsfCtrl = (function (_super) {
            __extends(HsfCtrl, _super);
            function HsfCtrl($scope, $location, $routeParams, common, breezeService, pulseContext) {
                var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HsfCtrl.controllerId) || this;
                _this.userFormDetailId = $routeParams.userFormDetailId;
                _this.userId = $routeParams.userId;
                _this.token = $routeParams.token;
                _this.frameSrc = window.location.href.split('#')[0] + "#" + Routes.HSF_Welcome
                    + "?" + QueryStringUtils.USERFORMDETAIL_ID + "=" + _this.userFormDetailId
                    + "&" + QueryStringUtils.MEDIC_APP_MEDS_ONLY + "=" + "0"
                    + "&" + QueryStringUtils.MEDIC_APP_MODE + "=" + "1"
                    + "&" + QueryStringUtils.MEDIC_APP_SMS_CODE + "=" + _this.pulseContext.medicAppMgr.stateBag.smsAuthToken
                    + "&" + QueryStringUtils.USER_ID + "=" + _this.userId
                    + "&" + QueryStringUtils.GUID + "=" + _this.token;
                _this.activateController();
                return _this;
            }
            HsfCtrl.prototype.cancel = function () {
                this.common.$location.url(Routes.MedicParticipantMedsComplete);
            };
            HsfCtrl.controllerId = "HsfCtrl";
            return HsfCtrl;
        }(Pulse.Common.BaseViewCtrl));
        Controllers.HsfCtrl = HsfCtrl;
        Pulse.app.controller(HsfCtrl.controllerId, ["$scope", "$location", "$routeParams",
            "common",
            "breezeService",
            "pulseContextService",
            HsfCtrl]);
    })(Controllers = Pulse.Controllers || (Pulse.Controllers = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var FormFocusOnErr = (function () {
            function FormFocusOnErr() {
                var _this = this;
                this.restrict = 'A';
                this.link = function (scope, elem, attr) {
                    elem.on('submit', function () {
                        var firstInvalid = angular
                            .element(elem.get(0).querySelector('.ng-invalid'))
                            .get(0);
                        if (firstInvalid) {
                            firstInvalid.focus();
                            if (_this.hasNgFormContext(firstInvalid)) {
                                var firstInvalidFormElment = angular
                                    .element(_this.getNgInvalidQuerySelector(firstInvalid))
                                    .filter(':visible')
                                    .get(0);
                                if (firstInvalidFormElment)
                                    firstInvalidFormElment.focus();
                            }
                        }
                    });
                };
            }
            FormFocusOnErr.prototype.getNgInvalidQuerySelector = function (firstInvalid) {
                return firstInvalid.querySelector('input.ng-invalid,select.ng-invalid,textarea.ng-invalid');
            };
            FormFocusOnErr.prototype.hasNgFormContext = function (firstInvalid) {
                return firstInvalid.tagName.toLowerCase() === 'ng-form'
                    || firstInvalid.hasAttribute('ng-form')
                    || firstInvalid.hasAttribute('data-ng-form');
            };
            FormFocusOnErr.directiveId = 'idpFormFocusOnErr';
            return FormFocusOnErr;
        }());
        Pulse.app.directive(FormFocusOnErr.directiveId, function () { return new FormFocusOnErr(); });
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var Match = (function () {
            function Match($parse) {
                this.restrict = "A";
                this.require = '?ngModel';
                this.scope = {
                    otherModelValue: "=idpMatch"
                };
                this.link = function (scope, elem, attrs, ctrl) {
                    if (!ctrl)
                        return;
                    if (!attrs[Match.directiveId])
                        return;
                    ctrl.$validators.idpMatch = function (modelValue) {
                        return modelValue == scope.otherModelValue;
                    };
                    scope.$watch("otherModelValue", function () {
                        ctrl.$validate();
                    });
                };
                this.$parse = $parse;
            }
            Match.directiveId = 'idpMatch';
            return Match;
        }());
        Pulse.app.directive(Match.directiveId, ['$parse', function (p) { return new Match(p); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var Visible = (function () {
            function Visible() {
                this.restrict = "A";
                this.link = function (scope, element, attributes, ctrl) {
                    scope.$watch(attributes.visible, function (value) {
                        element.css('visibility', value ? 'visible' : 'hidden');
                    });
                };
            }
            Visible.directiveId = 'visible';
            return Visible;
        }());
        Pulse.app.directive(Visible.directiveId, [function () { return new Visible(); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulseTypeListHelpDir = (function (_super) {
            __extends(PulseTypeListHelpDir, _super);
            function PulseTypeListHelpDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.SharedDirectives + "idp-pulse-type-list-help.html";
                _this.scope = {
                    types: "<",
                    showPopover: "=",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    PulseTypeListHelpDir.PulseTypeListHelpDirCtrl];
                return _this;
            }
            PulseTypeListHelpDir.directiveId = "idpPulseTypeListHelp";
            return PulseTypeListHelpDir;
        }(Pulse.Common.BasePopover));
        Directives.PulseTypeListHelpDir = PulseTypeListHelpDir;
        (function (PulseTypeListHelpDir) {
            var PulseTypeListHelpDirCtrl = (function (_super) {
                __extends(PulseTypeListHelpDirCtrl, _super);
                function PulseTypeListHelpDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, PulseTypeListHelpDirCtrl.controllerId) || this;
                    _this.formName = "myForm";
                    _this.checkUnsavedDataBeforeNav = false;
                    return _this;
                }
                PulseTypeListHelpDirCtrl.prototype.$onInit = function () {
                    this.activateController();
                };
                PulseTypeListHelpDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                    this.myForm = scope.myForm;
                };
                PulseTypeListHelpDirCtrl.prototype.onDestroy = function () {
                };
                PulseTypeListHelpDirCtrl.prototype.secureAllFeatures = function () {
                    this.canSee = true;
                };
                PulseTypeListHelpDirCtrl.prototype.close = function () {
                    _super.prototype.closePopover.call(this);
                };
                PulseTypeListHelpDirCtrl.controllerId = "PulseTypeListHelpDirCtrl";
                return PulseTypeListHelpDirCtrl;
            }(Pulse.Common.BasePopover.BasePopoverCtrl));
            PulseTypeListHelpDir.PulseTypeListHelpDirCtrl = PulseTypeListHelpDirCtrl;
        })(PulseTypeListHelpDir = Directives.PulseTypeListHelpDir || (Directives.PulseTypeListHelpDir = {}));
        Pulse.app.directive(PulseTypeListHelpDir.directiveId, ["common", function (c) { return new PulseTypeListHelpDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var NumbersOnly = (function () {
            function NumbersOnly() {
                this.restrict = "A";
                this.require = "ngModel";
                this.link = function (scope, elem, attrs, ctrl) {
                    function fromUser(text) {
                        if (text) {
                            var transformedInput = text.replace(/[^0-9.]/g, '');
                            var pos = transformedInput.indexOf('.');
                            if (pos !== -1) {
                                var sub = transformedInput.substring(pos + 1);
                                sub = sub.replace(/\./g, '');
                                if (sub.length > 2) {
                                    sub = sub.substring(0, 2);
                                }
                                transformedInput = transformedInput.substring(0, pos + 1) + sub;
                            }
                            if (transformedInput !== text) {
                                ctrl.$setViewValue(transformedInput);
                                ctrl.$render();
                            }
                            return transformedInput;
                        }
                        return undefined;
                    }
                    ctrl.$parsers.push(fromUser);
                };
            }
            NumbersOnly.directiveId = 'idpNumbersOnly';
            return NumbersOnly;
        }());
        Pulse.app.directive(NumbersOnly.directiveId, [function () { return new NumbersOnly(); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        Pulse.app.directive('onRepeatFinish', [
            '$timeout',
            '$parse',
            '$rootScope',
            function ($timeout, $parse, $rootScope) {
                return {
                    link: function (scope, element, attr) {
                        if (scope.$last === true) {
                            $timeout(function () {
                                $rootScope.$broadcast(Events.NgRepeatFinished);
                                if (!!attr.onRepeatFinish) {
                                    $parse(attr.onRepeatFinish)(scope);
                                }
                            });
                        }
                    },
                    restrict: 'A'
                };
            }
        ]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        Pulse.app.directive('idpFocusOn', [
            '$timeout',
            '$parse',
            function ($timeout, $parse) {
                return {
                    link: function (scope, element, attr) {
                        $timeout(function () {
                            if (!!attr.idpFocusOn && $parse(attr.idpFocusOn)(scope))
                                angular.element(element).focus();
                        });
                    },
                    restrict: 'A'
                };
            }
        ]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var InputFiles = (function () {
            function InputFiles() {
                this.restrict = "A";
                this.scope = {
                    files: '=idpFiles',
                    hasFiles: '=idpHasFile',
                    filePath: '=idpFilePath'
                };
                this.link = function (scope, element, attrs, ctrl) {
                    element.bind('change', function () {
                        scope.$apply(function () {
                            if (element[0].files) {
                                scope.files = element[0].files;
                                scope.filePath = element[0].value;
                                scope.type = element[0].type;
                                scope.hasFiles = element[0].files.length > 0;
                            }
                        });
                    });
                    if (element[0].form) {
                        angular.element(element[0].form)
                            .bind('reset', function () {
                            scope.$apply(function () {
                                scope.files = element[0].files;
                                scope.filePath = element[0].value;
                                scope.type = element[0].type;
                                scope.hasFiles = false;
                            });
                        });
                    }
                };
            }
            InputFiles.directiveId = 'idpInputFiles';
            return InputFiles;
        }());
        Pulse.app.directive(InputFiles.directiveId, [function () { return new InputFiles(); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        "use strict";
        var BooleanSelectorDir = (function (_super) {
            __extends(BooleanSelectorDir, _super);
            function BooleanSelectorDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.SharedDirectives + "idp-boolean-selector.html";
                _this.require = "^" + BooleanSelectorDir.directiveId;
                _this.scope = {
                    selectedBoolean: "=",
                    isEditMode: "=",
                    isReadOnly: "=",
                    onChangeReturnKey: "<",
                    isRequired: "<",
                    verticalLayout: "<",
                    yesButtonText: "<",
                    noButtonText: "<",
                    tooltip: "@",
                    requiredMessage: "@",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    BooleanSelectorDir.BooleanSelectorDirCtrl];
                return _this;
            }
            BooleanSelectorDir.directiveId = "idpBooleanSelector";
            return BooleanSelectorDir;
        }(Pulse.Common.BaseDirective));
        Directives.BooleanSelectorDir = BooleanSelectorDir;
        (function (BooleanSelectorDir) {
            var BooleanSelectorDirCtrl = (function (_super) {
                __extends(BooleanSelectorDirCtrl, _super);
                function BooleanSelectorDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, BooleanSelectorDirCtrl.controllerId) || this;
                    _this.isRequired = false;
                    _this.verticalLayout = false;
                    _this.yesButtonText = "Yes";
                    _this.noButtonText = "No";
                    _this.requiredMessage = "Required";
                    _this.id = BooleanSelectorDirCtrl._instanceCount++;
                    _this.formName = "booleanSelector" + _this.id;
                    _this.checkUnsavedDataBeforeNav = false;
                    _this.activateController();
                    return _this;
                }
                BooleanSelectorDirCtrl.prototype.setSelectedBoolean = function (yesOrNo) {
                    if (!this.isReadOnly) {
                        this.selectedBoolean = yesOrNo;
                        this.myForm.hiddenSelect.$setTouched();
                        this.$scope.$emit(Events.BooleanSelected, this.onChangeReturnKey, this.selectedBoolean);
                    }
                };
                BooleanSelectorDirCtrl.prototype.validate = function () {
                    if (this.myForm == null || this.myForm.hiddenSelect == null)
                        return;
                    if (this.isRequired) {
                        this.myForm.hiddenSelect.$setValidity("required", (!angular.isUndefined(this.selectedBoolean) && this.selectedBoolean != null));
                    }
                    ;
                };
                BooleanSelectorDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                    var _this = this;
                    this.myForm = scope[this.formName];
                    var parentCtrl = (scope.$parent).vm;
                    if (parentCtrl && !angular.isUndefined(parentCtrl.myForm) && (parentCtrl.myForm != null)) {
                        scope.$watch(function (scope) {
                            return parentCtrl.myForm.$submitted;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                _this.validate();
                            }
                        });
                    }
                    scope.$watchCollection(function (scope) {
                        return _this.selectedBoolean;
                    }, function (newVal, oldVal) {
                        if (_this.myForm.hiddenSelect.$touched) {
                            _this.validate();
                        }
                    });
                };
                BooleanSelectorDirCtrl.controllerId = "BooleanSelectorDirCtrl";
                BooleanSelectorDirCtrl._instanceCount = 0;
                return BooleanSelectorDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            BooleanSelectorDir.BooleanSelectorDirCtrl = BooleanSelectorDirCtrl;
        })(BooleanSelectorDir = Directives.BooleanSelectorDir || (Directives.BooleanSelectorDir = {}));
        Pulse.app.directive(BooleanSelectorDir.directiveId, ["common", function (c) { return new BooleanSelectorDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var Draggable = (function () {
            function Draggable($document) {
                var _this = this;
                this.restrict = "A";
                this.scope = {
                    idpDraggable: "@",
                };
                this.link = function (scope, elem, attrs, ctrl) {
                    _this.scope = scope;
                    var $document = _this.$document;
                    scope.$watch('idpDraggable', function (newVal) {
                        var startX = 0, startY = 0, x = 0, y = 0;
                        var idpDraggableElem = elem;
                        if (angular.isString(newVal)) {
                            idpDraggableElem = $("#" + newVal);
                            if (idpDraggableElem.length == 0) {
                                idpDraggableElem = $("." + newVal);
                            }
                            if (idpDraggableElem.length == 0) {
                                idpDraggableElem = $(newVal);
                            }
                            if (idpDraggableElem.length == 0) {
                                idpDraggableElem = elem;
                            }
                        }
                        idpDraggableElem.css({
                            cursor: 'move'
                        });
                        idpDraggableElem.on('mousedown', function (event) {
                            var width = elem.width();
                            var height = elem.height();
                            elem.css({
                                position: 'fixed',
                            });
                            elem.width(width);
                            elem.height(height);
                            x = elem.context.offsetLeft;
                            y = elem.context.offsetTop;
                            event.preventDefault();
                            startX = event.screenX - x;
                            startY = event.screenY - y;
                            $document.on('mousemove', mousemove);
                            $document.on('mouseup', mouseup);
                        });
                        function mousemove(event) {
                            y = event.screenY - startY;
                            x = event.screenX - startX;
                            elem.css({
                                top: y + 'px',
                                left: x + 'px'
                            });
                        }
                        function mouseup() {
                            $document.unbind('mousemove', mousemove);
                            $document.unbind('mouseup', mouseup);
                        }
                    });
                };
                this.$document = $document;
            }
            Draggable.directiveId = 'idpDraggable';
            return Draggable;
        }());
        Pulse.app.directive(Draggable.directiveId, ['$document', function (d) { return new Draggable(d); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var CompileSourceDirective = (function () {
            function CompileSourceDirective() {
                this.restrict = 'A';
                this.controller = ['$compile', CompileSourceCtrl];
                this.controllerAs = '$ctrl';
                this.scope = {};
                this.scope[CompileSourceDirective.registeredAs] = '<';
            }
            CompileSourceDirective.prototype.link = function (scope, instanceElement, instanceAttributes, controller, transclude) {
                var source = scope[CompileSourceDirective.registeredAs];
                controller
                    .$compile(source)(scope.$parent, function (e, s) {
                    instanceElement.append(e);
                });
            };
            CompileSourceDirective.registeredAs = 'idpCompileSource';
            return CompileSourceDirective;
        }());
        var CompileSourceCtrl = (function () {
            function CompileSourceCtrl($compile) {
                this._compileService = $compile;
            }
            Object.defineProperty(CompileSourceCtrl.prototype, "$compile", {
                get: function () {
                    return this._compileService;
                },
                enumerable: false,
                configurable: true
            });
            return CompileSourceCtrl;
        }());
        Pulse.app.directive(CompileSourceDirective.registeredAs, function () { return new CompileSourceDirective(); });
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var TextDatePickerDir = (function (_super) {
            __extends(TextDatePickerDir, _super);
            function TextDatePickerDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.SharedDirectives + "idp-text-date-picker.html";
                _this.require = "^" + TextDatePickerDir.directiveId;
                _this.scope = {
                    placeholder: "@",
                    inputCssClass: "@",
                    date: "=",
                    minDate: "<",
                    maxDate: "<",
                    isEditMode: "<",
                    isRequired: "<",
                    isDisabled: "<",
                    isUseZeroHourOfNextDay: "<",
                    format: "@",
                    requiredMessage: "@",
                    invalidMessage: "@",
                    tooltip: "@",
                    width: "@",
                    firstTabIndex: "<",
                    onChange: "&",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    "bootstrapDatePickerDefaultConfig",
                    TextDatePickerDir.TextDatePickerDirCtrl];
                return _this;
            }
            TextDatePickerDir.directiveId = "idpTextDatePicker";
            return TextDatePickerDir;
        }(Pulse.Common.BaseDirective));
        Directives.TextDatePickerDir = TextDatePickerDir;
        (function (TextDatePickerDir) {
            var TextDatePickerDirCtrl = (function (_super) {
                __extends(TextDatePickerDirCtrl, _super);
                function TextDatePickerDirCtrl($scope, $location, common, breezeService, pulseContext, bootstrapDatePickerDefaultConfig) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, TextDatePickerDirCtrl.controllerId) || this;
                    _this.isUseZeroHourOfNextDay = false;
                    _this.id = TextDatePickerDirCtrl._instanceCount++;
                    _this.formName = "frmTextDatePicker" + _this.id;
                    _this.checkUnsavedDataBeforeNav = false;
                    _this.calendarObj = _.cloneDeep(bootstrapDatePickerDefaultConfig);
                    _this.activateController();
                    return _this;
                }
                Object.defineProperty(TextDatePickerDirCtrl.prototype, "minInputAttrib", {
                    get: function () {
                        return this.isDisabled ? null : this.common.$filter('date')(this.minDate, "yyyy-MM-dd") + " 00:00:00";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(TextDatePickerDirCtrl.prototype, "maxInputAttrib", {
                    get: function () {
                        return this.isDisabled ? null : this.common.$filter('date')(this.maxDate, "yyyy-MM-dd") + " 23:59:59";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(TextDatePickerDirCtrl.prototype, "minMessage", {
                    get: function () {
                        return this.isDisabled ? null : "min is " + this.common.$filter('date')(this.minDate, "MM-dd-yyyy");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(TextDatePickerDirCtrl.prototype, "maxMessage", {
                    get: function () {
                        return this.isDisabled ? null : "max is " + this.common.$filter('date')(this.maxDate, "MM-dd-yyyy");
                    },
                    enumerable: false,
                    configurable: true
                });
                TextDatePickerDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                    var _this = this;
                    this.myForm = scope[this.formName];
                    if (angular.isUndefined(this.minDate))
                        this.minDate = new Date("1/1/1990");
                    if (angular.isUndefined(this.maxDate))
                        this.maxDate = moment().add(10, "years").toDate();
                    if (angular.isDate(this.date)) {
                        this.internalDateValue = this.isUseZeroHourOfNextDay ? Pulse.Utils.JS.DTZeroHourPreviousDayAdjustForDisplay(this.date) : new Date(this.date.valueOf());
                        this.calendarObj.options.initDate = this.internalDateValue;
                    }
                    if (this.format) {
                        this.calendarObj.format = this.format;
                    }
                    this.calendarObj.options.minDate = moment(this.minDate).startOf('day').toDate();
                    this.calendarObj.options.maxDate = moment(this.maxDate).endOf('day').toDate();
                    scope.$watch(function (scope) {
                        return _this.date;
                    }, function (newValue, oldValue) {
                        if (newValue != oldValue && !newValue) {
                            _this.internalDateValue = newValue;
                            return;
                        }
                        if (angular.isDate(newValue)) {
                            var dateToCompare = !!_this.isUseZeroHourOfNextDay ? Pulse.Utils.JS.DTZeroHourPreviousDayAdjustForDisplay(newValue, 1) : new Date(newValue.valueOf());
                            if (angular.isDate(_this.internalDateValue)
                                && dateToCompare.valueOf() != _this.internalDateValue.valueOf()) {
                                _this.internalDateValue = dateToCompare;
                                _this.calendarObj.options.initDate = _this.internalDateValue;
                            }
                            else {
                                _this.internalDateValue = dateToCompare;
                            }
                        }
                        else {
                            _this.internalDateValue = null;
                        }
                    });
                    scope.$watch(function (scope) {
                        return _this.internalDateValue;
                    }, function (newValue, oldValue) {
                        if (!!newValue && angular.isDate(newValue)) {
                            var dateToCompare = !!_this.isUseZeroHourOfNextDay ? Pulse.Utils.JS.DTZeroHourPreviousDayAdjustForDisplay(newValue, 1, true) : new Date(newValue.valueOf());
                            if (!_this.date || dateToCompare.valueOf() != _this.date.valueOf()) {
                                _this.date = dateToCompare;
                                _this.onValueChange();
                                _this.onChange();
                            }
                        }
                    });
                    scope.$watch(function (scope) {
                        return _this.minDate;
                    }, function (newValue, oldValue) {
                        _this.calendarObj.options.minDate = moment(_this.minDate).startOf('day').toDate();
                    });
                    scope.$watch(function (scope) {
                        return _this.maxDate;
                    }, function (newValue, oldValue) {
                        _this.calendarObj.options.maxDate = moment(_this.maxDate).endOf('day').toDate();
                    });
                    var parentCtrl = (scope.$parent).vm;
                    if (parentCtrl && parentCtrl.myForm) {
                        scope.$watch(function (scope) {
                            return parentCtrl.myForm.$submitted;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                _this.myForm.$setSubmitted();
                            }
                        });
                    }
                };
                TextDatePickerDirCtrl.prototype.onValueChange = function () {
                    if (!this.myForm)
                        return;
                    if (this.isEditMode && !(this.isDisabled || false) && angular.isDefined(this.internalDateValue) && this.internalDateValue && !this.myForm.date.$error.date) {
                        this.myForm.date.$setValidity("min", moment(this.internalDateValue).isSameOrAfter(this.minDate));
                        this.myForm.date.$setValidity("max", moment(this.internalDateValue).isSameOrBefore(this.maxDate));
                    }
                    else {
                        this.myForm.date.$setValidity("min", true);
                        this.myForm.date.$setValidity("max", true);
                    }
                };
                TextDatePickerDirCtrl.controllerId = "TextDatePickerDirCtrl";
                TextDatePickerDirCtrl._instanceCount = 0;
                return TextDatePickerDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            TextDatePickerDir.TextDatePickerDirCtrl = TextDatePickerDirCtrl;
        })(TextDatePickerDir = Directives.TextDatePickerDir || (Directives.TextDatePickerDir = {}));
        Pulse.app.directive(TextDatePickerDir.directiveId, ["common", function (c) { return new TextDatePickerDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var BackImg = (function () {
            function BackImg() {
                this.restrict = "A";
                this.link = function (scope, element, attributes, ctrl) {
                    var url = attributes.backImg;
                    element.css({
                        'background-image': 'url(' + url + ')',
                        'background-size': 'cover'
                    });
                };
            }
            BackImg.directiveId = 'backImg';
            return BackImg;
        }());
        Pulse.app.directive(BackImg.directiveId, [function () { return new BackImg(); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        Pulse.app.directive('idpClickTracking', [
            function ($timeout, $parse) {
                return {
                    link: function (scope, element, attrs) {
                        element.attr(Pulse.Utils.ClickTracking.ATTR_FROM_URL, window.location.toString());
                        element.on("click", function (e) {
                            var args = [];
                            for (var _i = 1; _i < arguments.length; _i++) {
                                args[_i - 1] = arguments[_i];
                            }
                            Pulse.Utils.ClickTracking.sendElementTrackingData(element[0]);
                        });
                    },
                    restrict: 'A'
                };
            }
        ]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var ExportWrapperDir = (function (_super) {
            __extends(ExportWrapperDir, _super);
            function ExportWrapperDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + "app/directives/export/idp-export-wrapper.html";
                _this.transclude = true;
                _this.scope = {
                    api: "=?",
                    showButton: "<",
                    buttonText: "@?",
                    watchData: "<",
                    showContent: "<",
                    exportType: "@?",
                    fileName: "@?",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    ExportWrapperDir.ExportWrapperDirCtrl];
                return _this;
            }
            ExportWrapperDir.directiveId = "idpExportWrapper";
            return ExportWrapperDir;
        }(Pulse.Common.BaseDirective));
        Directives.ExportWrapperDir = ExportWrapperDir;
        (function (ExportWrapperDir) {
            var CompilationInfo = (function () {
                function CompilationInfo() {
                }
                return CompilationInfo;
            }());
            ExportWrapperDir.CompilationInfo = CompilationInfo;
            var ExportWrapperDirCtrl = (function (_super) {
                __extends(ExportWrapperDirCtrl, _super);
                function ExportWrapperDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ExportWrapperDirCtrl.controllerId) || this;
                    _this.buttonText = "Export";
                    _this.showContent = false;
                    _this.exportType = "excel";
                    _this._MIME = ExportWrapperDirCtrl.EXCEL_MIME;
                    _this.activateController();
                    return _this;
                }
                ExportWrapperDirCtrl.prototype.onActivated = function (activationResults) {
                    _super.prototype.onActivated.call(this, activationResults);
                    if (this.exportType === 'word') {
                        this.fileName = this.fileName || "Report.doc";
                        this._MIME = ExportWrapperDirCtrl.WORD_MIME;
                    }
                    else {
                        this.fileName = this.fileName || "Report.xls";
                    }
                };
                ExportWrapperDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl, transclude, compilationInfoObj) {
                    var _this = this;
                    _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl, transclude, compilationInfoObj);
                    var templateElement = element.find(".exportTemplate").first();
                    this.templateId = "exportId" + Date.now();
                    templateElement.attr("id", this.templateId);
                    templateElement.children().removeAttr("ng-non-bindable");
                    this.templateHtml = templateElement.html();
                    templateElement.html("");
                    scope.$watch(function (scope) {
                        return _this.api;
                    }, function (newVal, oldVal) {
                        if (angular.isObject(_this.api))
                            return;
                        _this.api = _this;
                    });
                    scope.$watch(function (scope) {
                        return _this.watchData;
                    }, function (newValue, oldValue) {
                        _this.clearHtmlFromDOM();
                    });
                };
                ExportWrapperDirCtrl.prototype.generateHtml = function () {
                    if (!this._isGenerated) {
                        var div = this.clearHtmlFromDOM();
                        var linkFn = this.common.$compile(this.templateHtml);
                        var content = linkFn(this.$scope.$parent);
                        content.appendTo(div);
                        this._isGenerated = true;
                    }
                };
                ExportWrapperDirCtrl.prototype.clearHtmlFromDOM = function () {
                    this._isGenerated = false;
                    var div = Pulse.jQuery("#" + this.templateId);
                    div.html("");
                    return div;
                };
                ExportWrapperDirCtrl.prototype.export = function () {
                    var _this = this;
                    this.generateHtml();
                    this.common.$timeout(function () {
                        var div = Pulse.jQuery("#" + _this.templateId);
                        var blob = new Blob([div.html()], {
                            type: _this._MIME
                        });
                        saveBlobAs(blob, _this.fileName);
                    }, 0);
                };
                ExportWrapperDirCtrl.prototype.$onChanges = function (changes) {
                };
                ExportWrapperDirCtrl.controllerId = "ExportWrapperDirCtrl";
                ExportWrapperDirCtrl.WORD_MIME = "application/msword";
                ExportWrapperDirCtrl.EXCEL_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
                return ExportWrapperDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            ExportWrapperDir.ExportWrapperDirCtrl = ExportWrapperDirCtrl;
        })(ExportWrapperDir = Directives.ExportWrapperDir || (Directives.ExportWrapperDir = {}));
        Pulse.app.directive(ExportWrapperDir.directiveId, ["common", function (c) { return new ExportWrapperDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var HelpPopup = (function (_super) {
            __extends(HelpPopup, _super);
            function HelpPopup(common) {
                var _this = _super.call(this, common) || this;
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    "$uibModal",
                    "ScrollLockService",
                    HelpPopup.HelpPopupCtrl];
                return _this;
            }
            HelpPopup.directiveId = "idpHelpPopup";
            return HelpPopup;
        }(Pulse.Common.BasePopup));
        Directives.HelpPopup = HelpPopup;
        (function (HelpPopup) {
            var HelpPopupCtrl = (function (_super) {
                __extends(HelpPopupCtrl, _super);
                function HelpPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, HelpPopupCtrl.controllerId) || this;
                    _this.isVisible = false;
                    _this.event_ShowPopup = Events.ShowHelpPopup;
                    _this.popupTemplateUrl = _this.common.config.appRoot + "app/directives/help-popup/idp-help-popup.html";
                    _this.isIncludeHeaderCloseButton = true;
                    _this.title = "Loading...";
                    _this.helpHtml = "Loading...";
                    _this.activateController();
                    return _this;
                }
                HelpPopupCtrl.prototype.open = function (size, initDataObj) {
                    this.isVisible = false;
                    this.initDataObj = initDataObj;
                    this.popupId = initDataObj.popupId;
                    this.title = initDataObj.helpTitle;
                    this.helpHtml = "Loading...";
                    this.windowClass = initDataObj.windowClass;
                    HelpPopupCtrl.helpTopicId++;
                    this.activationPromises.push(this.loadData());
                    this.activateController();
                    _super.prototype.open.call(this, size, initDataObj);
                };
                HelpPopupCtrl.prototype.close = function (results) {
                    if (this.pulseContext.inIframe && angular.isString(this.initDataObj.parentId)) {
                        var element = document.getElementById(this.initDataObj.parentId);
                        if (element) {
                            element.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
                        }
                    }
                    _super.prototype.close.call(this, results);
                };
                HelpPopupCtrl.prototype.loadData = function () {
                    var promises = new Array();
                    promises.push(this.getHelpHtml(this.initDataObj));
                    return this.common.$q.all(promises);
                };
                HelpPopupCtrl.prototype.getHelpHtml = function (params) {
                    if (params.helpTopicName == null) {
                        this.helpHtml = params.helpHtml;
                        this.isVisible = true;
                    }
                    else {
                        var url = this.common.config.pulse1x_PublicUrl + "/api/pulsespa/GetHelpTopic";
                        var postData = {
                            helpContentType: params.helpContentType,
                            companyID: this.pulseContext.companyId,
                            topicName: params.helpTopicName
                        };
                        var self = this;
                        this.common.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } })
                            .then(function (response) {
                            var data = response.data;
                            var htmlStr = "";
                            if (params.helpContentType === HelpPopup.HelpContentType.CourseInfo) {
                                htmlStr += angular.isString(data.ages) ? "<p>" + data.ages + "</p>" : "";
                                htmlStr += angular.isString(data.minAgeText) ? "<p>" + data.minAgeText + "</p>" : "";
                                htmlStr += angular.isString(data.prereq) ? "<p>" + data.prereq + "</p>" : "";
                                htmlStr += angular.isString(data.skillLevel) ? "<p>" + data.skillLevel + "</p>" : "";
                                htmlStr += "<p>" + data.description + "</p>";
                                self.helpHtml = htmlStr;
                            }
                            else if (params.helpContentType === HelpPopup.HelpContentType.OptionInfo) {
                                htmlStr += angular.isString(data.ages) ? "<p>" + data.ages + "</p>" : "";
                                htmlStr += "<p>" + data.description + "</p>";
                                self.helpHtml = htmlStr;
                            }
                            else if (params.helpContentType === HelpPopup.HelpContentType.ProductInfo) {
                                htmlStr += "<p>" + data.description + "</p>";
                                self.helpHtml = htmlStr;
                            }
                            else if (params.helpContentType === HelpPopup.HelpContentType.DiscountInfo) {
                                data = JSON.parse(data);
                                htmlStr += "<p>" + data.Description + "</p>";
                                self.helpHtml = htmlStr;
                            }
                            else {
                                var replacement = ("src=\"" + self.common.config.pulse1x_PublicUrl + self.common.config.pulse1x_PublicAppRoot);
                                htmlStr = data.html ? data.html.toString() : "";
                                htmlStr = htmlStr.replace(/src="\/PulsePublic/g, replacement);
                                self.helpHtml = htmlStr;
                            }
                        })
                            .catch(function () {
                            self.helpHtml = ("<div>An unknown error occurred attempting to retrieve topicName: '" + params.helpTopicName + "'");
                        })
                            .finally(function () {
                            self.isVisible = true;
                        });
                    }
                };
                Object.defineProperty(HelpPopupCtrl.prototype, "HelpTitleID", {
                    get: function () {
                        return "IdpHelpTitle_" + HelpPopupCtrl.helpTopicId;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(HelpPopupCtrl.prototype, "HelpContentID", {
                    get: function () {
                        return "IdpHelpContent_" + HelpPopupCtrl.helpTopicId;
                    },
                    enumerable: false,
                    configurable: true
                });
                HelpPopupCtrl.controllerId = "HelpPopupCtrl";
                HelpPopupCtrl.helpTopicId = 0;
                return HelpPopupCtrl;
            }(Pulse.Common.BasePopup.BasePopupCtrl));
            HelpPopup.HelpPopupCtrl = HelpPopupCtrl;
            var HelpContentType;
            (function (HelpContentType) {
                HelpContentType[HelpContentType["HelpTopic"] = 1] = "HelpTopic";
                HelpContentType[HelpContentType["CourseInfo"] = 2] = "CourseInfo";
                HelpContentType[HelpContentType["OptionInfo"] = 3] = "OptionInfo";
                HelpContentType[HelpContentType["ProductInfo"] = 4] = "ProductInfo";
                HelpContentType[HelpContentType["DiscountInfo"] = 5] = "DiscountInfo";
            })(HelpContentType = HelpPopup.HelpContentType || (HelpPopup.HelpContentType = {}));
            var HelpTopic;
            (function (HelpTopic) {
                HelpTopic["AllowAnotherUserToConnectParticipant"] = "AllowAnotherUserToConnectParticipant";
                HelpTopic["ConnectParticipant"] = "ConnectParticipant";
                HelpTopic["CreateAccountInfo"] = "CreateAccountInfo";
                HelpTopic["CreateTermStaffApplicantAccountInfo"] = "CreateTermStaffApplicantAccountInfo";
                HelpTopic["CreditCardIDNumber"] = "CreditCardIDNumber";
                HelpTopic["Nickname"] = "Nickname";
                HelpTopic["GenderHelp"] = "GenderHelp";
                HelpTopic["PrivacyPolicy"] = "PrivacyPolicy";
                HelpTopic["AdjustParticipantsInSections"] = "AdjustParticipantsInSections";
                HelpTopic["CheckInCheckOutRoster"] = "CheckInCheckOutRoster";
                HelpTopic["DailyAttendanceRoster"] = "DailyAttendanceRoster";
                HelpTopic["Dashboard"] = "Dashboard";
                HelpTopic["DiplomaReviewPrint"] = "DiplomaReviewPrint";
                HelpTopic["EvalDetailsReport"] = "EvalDetailsReport";
                HelpTopic["EvalSummaryReport"] = "EvalSummaryReport";
                HelpTopic["InstructorSectionAssignment"] = "InstructorSectionAssignment";
                HelpTopic["Roster"] = "Roster";
                HelpTopic["StaffBios"] = "StaffBios";
                HelpTopic["StaffRoster"] = "StaffRoster";
                HelpTopic["StaffWeekendRoster"] = "StaffWeekendRoster";
                HelpTopic["StudentDiplomaEntry"] = "StudentDiplomaEntry";
                HelpTopic["StudentWeekendRoster"] = "StudentWeekendRoster";
                HelpTopic["AdjustNumberOfCourseSections"] = "AdjustNumberOfCourseSections";
                HelpTopic["MiniCourseRoster"] = "MiniCourseRoster";
                HelpTopic["SupplyRequestSearch"] = "SupplyRequestSearch";
                HelpTopic["HardwareSearch"] = "HardwareSearch";
                HelpTopic["DiscountLimits"] = "DiscountLimits";
                HelpTopic["TShirtSize"] = "TShirtSize";
                HelpTopic["W4Domestic"] = "W4Domestic";
                HelpTopic["W4International"] = "W4International";
                HelpTopic["WeekendHousingForm"] = "WeekendHousingForm";
                HelpTopic["DailyMedsSchedule"] = "DailyMedsSchedule";
                HelpTopic["TAPApplicationStatus"] = "TAPApplicationStatus";
                HelpTopic["TermsAndConditions"] = "TermsAndConditions";
                HelpTopic["UserNameHelp"] = "UserNameHelp";
                HelpTopic["PasswordHelp"] = "PasswordHelp";
                HelpTopic["AddStudentMobileHelp"] = "AddStudentMobileHelp";
                HelpTopic["PendingDiscount"] = "PendingDiscount";
                HelpTopic["CreatePasswordHelp"] = "CreatePasswordHelp";
                HelpTopic["TermsAndConditionsRAF"] = "TermsAndConditionsRAF";
                HelpTopic["DiscountAcceptedCodes"] = "DiscountAcceptedCodes";
                HelpTopic["BuildingSectionAssignment"] = "BuildingSectionAssignment";
                HelpTopic["OPLAvailableLessonsHelp"] = "OPLAvailableLessonsHelp";
                HelpTopic["RenewalDateHelp"] = "RenewalDateHelp";
                HelpTopic["GroupWithBeginnersHelp"] = "GroupWithBeginnersHelp";
            })(HelpTopic = HelpPopup.HelpTopic || (HelpPopup.HelpTopic = {}));
            Pulse.app.directive(HelpPopup.directiveId, ["common", function (c) { return new HelpPopup(c); }]);
        })(HelpPopup = Directives.HelpPopup || (Directives.HelpPopup = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var IFrameDir = (function (_super) {
            __extends(IFrameDir, _super);
            function IFrameDir(common) {
                var _this = _super.call(this, common) || this;
                _this.templateUrl = _this.common.config.appRoot + "app/directives/iframe/idp-iframe.html";
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    IFrameDir.IFrameCtrl];
                window.sessionStorage.needPageReloadForIe11 = "true";
                return _this;
            }
            IFrameDir.directiveId = "idpIframe";
            return IFrameDir;
        }(Pulse.Common.BaseFrame));
        Directives.IFrameDir = IFrameDir;
        (function (IFrameDir) {
            var IFrameCtrl = (function (_super) {
                __extends(IFrameCtrl, _super);
                function IFrameCtrl() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                IFrameCtrl.controllerId = "IFrameDirCtrl";
                return IFrameCtrl;
            }(Pulse.Common.BaseFrame.BaseFrameCtrl));
            IFrameDir.IFrameCtrl = IFrameCtrl;
        })(IFrameDir = Directives.IFrameDir || (Directives.IFrameDir = {}));
        Pulse.app.directive(IFrameDir.directiveId, ["common", function (c) { return new IFrameDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var IFramePopup = (function (_super) {
                __extends(IFramePopup, _super);
                function IFramePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        IFramePopup.IFramePopupCtrl];
                    return _this;
                }
                IFramePopup.directiveId = "idpIframePopup";
                return IFramePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.IFramePopup = IFramePopup;
            (function (IFramePopup) {
                var IFramePopupCtrl = (function (_super) {
                    __extends(IFramePopupCtrl, _super);
                    function IFramePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, IFramePopupCtrl.controllerId) || this;
                        _this.initDataObj = {
                            url: "",
                            title: "",
                        };
                        _this.title = "";
                        _this.url = "";
                        _this.event_ShowPopup = Events.ShowIFramePopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + "app/directives/iframe/idp-iframe-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    IFramePopupCtrl.prototype.close = function () {
                        _super.prototype.close.call(this);
                    };
                    IFramePopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        if (initDataObj) {
                            if (initDataObj.url)
                                this.url = initDataObj.url;
                            if (initDataObj.title)
                                this.title = initDataObj.title;
                        }
                    };
                    IFramePopupCtrl.controllerId = "IFramePopupCtrl";
                    return IFramePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                IFramePopup.IFramePopupCtrl = IFramePopupCtrl;
            })(IFramePopup = PulsePublic.IFramePopup || (PulsePublic.IFramePopup = {}));
            Pulse.app.directive(IFramePopup.directiveId, ["common", function (c) { return new IFramePopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var BasicPopup = (function (_super) {
            __extends(BasicPopup, _super);
            function BasicPopup(common) {
                var _this = _super.call(this, common) || this;
                _this.transclude = false;
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    "$uibModal",
                    "ScrollLockService",
                    BasicPopup.BasicPopupCtrl];
                return _this;
            }
            BasicPopup.directiveId = "idpPopup";
            return BasicPopup;
        }(Pulse.Common.BasePopup));
        Directives.BasicPopup = BasicPopup;
        (function (BasicPopup) {
            var BasicPopupCtrl = (function (_super) {
                __extends(BasicPopupCtrl, _super);
                function BasicPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, BasicPopupCtrl.controllerId) || this;
                    _this.isIncludeHeaderCloseButton = true;
                    _this.footerCss = "justify-content-right";
                    _this.checkUnsavedDataBeforeNav = false;
                    _this.event_ShowPopup = Events.ShowBasicPopup;
                    _this.popupTemplateUrl = _this.common.config.appRoot + Paths.SharedDirectives + "popup/idp-popup.html";
                    _this.activateController();
                    return _this;
                }
                BasicPopupCtrl.prototype.resetDefaultButtonSettings = function () {
                    var _this = this;
                    this.isIncludeHeaderCloseButton = true;
                    this.button1 = {
                        label: "Yes",
                        cssClass: "px-3 btn btn-primary",
                        isVisible: true,
                        isCloseAfterClick: true,
                        onClick: function () {
                            if (_this.button1.cbFn)
                                _this.button1.cbFn();
                            if (_this.button1.isCloseAfterClick) {
                                _this.close();
                            }
                        },
                    };
                    this.button2 = {
                        label: "No",
                        cssClass: "px-3 btn btn-outline-secondary",
                        isVisible: true,
                        isCloseAfterClick: true,
                        onClick: function () {
                            if (_this.button2.cbFn)
                                _this.button2.cbFn();
                            if (_this.button2.isCloseAfterClick) {
                                _this.close();
                            }
                        },
                    };
                    this.button3 = {
                        label: "Cancel",
                        cssClass: "btn btn-link",
                        isVisible: false,
                        isCloseAfterClick: true,
                        onClick: function () {
                            if (_this.button3.cbFn)
                                _this.button3.cbFn();
                            if (_this.button3.isCloseAfterClick) {
                                _this.close();
                            }
                        },
                    };
                    this.button4 = {
                        label: "...",
                        isVisible: false,
                        isCloseAfterClick: true,
                        onClick: function () {
                            if (_this.button4.cbFn)
                                _this.button4.cbFn();
                            if (_this.button4.isCloseAfterClick) {
                                _this.close();
                            }
                        },
                    };
                };
                BasicPopupCtrl.prototype.open = function (size, initDataObj, modalSettings) {
                    if (modalSettings === void 0) { modalSettings = {}; }
                    this.resetDefaultButtonSettings();
                    this.initDataObj = initDataObj;
                    if (initDataObj) {
                        this.initDataObj.popupInstance = this;
                        this.popupId = initDataObj.popupId || this.popupId;
                        this.scrollToPopupOnOpen = initDataObj.scrollToPopupOnOpen;
                        this.title = !angular.isUndefined(initDataObj.title) ? initDataObj.title : this.title;
                        this.isIncludeHeaderCloseButton = !angular.isUndefined(initDataObj.isIncludeHeaderCloseButton) ? initDataObj.isIncludeHeaderCloseButton : this.isIncludeHeaderCloseButton;
                        this.footerCss = !angular.isUndefined(initDataObj.footerCss) ? initDataObj.footerCss : this.footerCss;
                        this.button1 = initDataObj.button1 ? __assign(__assign({}, this.button1), initDataObj.button1) : this.button1;
                        this.button2 = initDataObj.button2 ? __assign(__assign({}, this.button2), initDataObj.button2) : this.button2;
                        this.button3 = initDataObj.button3 ? __assign(__assign({}, this.button3), initDataObj.button3) : this.button3;
                        this.button4 = initDataObj.button4 ? __assign(__assign({}, this.button4), initDataObj.button4) : this.button4;
                    }
                    this.activateController();
                    _super.prototype.open.call(this, size, initDataObj, modalSettings);
                };
                BasicPopupCtrl.prototype.close = function (results) {
                    if (this.pulseContext.inIframe && angular.isString(this.initDataObj.parentId)) {
                        this.common.scrollToHash(this.initDataObj.parentId);
                    }
                    _super.prototype.close.call(this, results);
                };
                BasicPopupCtrl.prototype.onRendered = function () {
                    _super.prototype.onRendered.call(this);
                    if (this.initDataObj.rendered) {
                        this.initDataObj.rendered();
                    }
                };
                BasicPopupCtrl.controllerId = 'BasicPopupCtrl';
                return BasicPopupCtrl;
            }(Pulse.Common.BasePopup.BasePopupCtrl));
            BasicPopup.BasicPopupCtrl = BasicPopupCtrl;
        })(BasicPopup = Directives.BasicPopup || (Directives.BasicPopup = {}));
        Pulse.app.directive(BasicPopup.directiveId, ["common", function (c) { return new BasicPopup(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var SpinnerDir = (function (_super) {
            __extends(SpinnerDir, _super);
            function SpinnerDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.SharedDirectives + "spinner/idp-spinner.html";
                _this.scope = {
                    isActive: "@",
                    isVisible: "@",
                    message: "@",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    SpinnerDir.SpinnerDirCtrl];
                return _this;
            }
            SpinnerDir.directiveId = "idpSpinner";
            return SpinnerDir;
        }(Pulse.Common.BaseDirective));
        Directives.SpinnerDir = SpinnerDir;
        (function (SpinnerDir) {
            var SpinnerDirCtrl = (function (_super) {
                __extends(SpinnerDirCtrl, _super);
                function SpinnerDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SpinnerDirCtrl.controllerId) || this;
                    _this.shellContainer = "shell-container";
                    _this.isMessageLarge = false;
                    _this.showRequests = 0;
                    _this.checkUnsavedDataBeforeNav = false;
                    _this.unbind_SpinnerToggle = _this.common.$rootScope.$on(Events.SpinnerToggle, function (event, data) {
                        _this.toggleSpinner(data);
                    });
                    _this.isActive = true;
                    _this.isVisible = true;
                    _this.showRequests = 0;
                    _this.style = "";
                    _this.common.$rootScope.$broadcast(Events.SpinnerInitialized, null);
                    return _this;
                }
                Object.defineProperty(SpinnerDirCtrl.prototype, "spinnerMessage", {
                    get: function () {
                        var _a;
                        var msg = (_a = this.message) !== null && _a !== void 0 ? _a : SpinnerDirCtrl.defaultSpinnerMessage;
                        return msg;
                    },
                    enumerable: false,
                    configurable: true
                });
                SpinnerDirCtrl.prototype.onDestroy = function () {
                    this.unbind_SpinnerToggle();
                };
                SpinnerDirCtrl.prototype.toggleSpinner = function (data) {
                    var _this = this;
                    if (data.show) {
                        this.showRequests++;
                        if (data.message !== SpinnerDirCtrl.defaultSpinnerMessage) {
                            this.message = data.message.trim();
                        }
                        if (angular.isObject(data.style)) {
                            this.style = data.style;
                        }
                        this.isActive = true;
                        this.isMessageLarge = this.message !== undefined ? this.message.trim().length > SpinnerDirCtrl.defaultSpinnerMessage.length : false;
                        var miliSecondDelay = 500;
                        if (angular.isNumber(data.delay)) {
                            miliSecondDelay = data.delay;
                        }
                        this.common.$timeout(function () {
                            if (_this.showRequests > 0) {
                                _this.blurBackground();
                                _this.isVisible = true;
                            }
                            else {
                                _this.unBlurBackground();
                                _this.isVisible = false;
                                _this.isActive = false;
                                _this.message = SpinnerDirCtrl.defaultSpinnerMessage;
                            }
                        }, miliSecondDelay, true);
                    }
                    else {
                        this.showRequests--;
                        if (this.showRequests <= 0 || data.ignoreCount) {
                            this.showRequests = 0;
                            this.isVisible = false;
                            this.isActive = false;
                            this.blurBackground();
                            this.unBlurBackground();
                            this.message = SpinnerDirCtrl.defaultSpinnerMessage;
                            var el = document.getElementById("global_spinner");
                            el.classList.remove("visible");
                            el.classList.remove("active");
                        }
                    }
                };
                SpinnerDirCtrl.prototype.blurBackground = function () {
                    angular.element("." + this.shellContainer).addClass('blur');
                };
                SpinnerDirCtrl.prototype.unBlurBackground = function () {
                    angular.element("." + this.shellContainer).removeClass('blur');
                };
                SpinnerDirCtrl.controllerId = "spinnerDirCtrl";
                SpinnerDirCtrl.defaultSpinnerMessage = 'Loading...';
                return SpinnerDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            SpinnerDir.SpinnerDirCtrl = SpinnerDirCtrl;
        })(SpinnerDir = Directives.SpinnerDir || (Directives.SpinnerDir = {}));
        Pulse.app.directive(SpinnerDir.directiveId, ["common", function (c) { return new SpinnerDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var FacebookShareDir = (function (_super) {
                __extends(FacebookShareDir, _super);
                function FacebookShareDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.SharedDirectives + "social-media/idp-facebook-share.html";
                    _this.scope = {
                        name: "<",
                        description: "<",
                        url: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        FacebookShareDir.FacebookShareDirCtrl];
                    var facebookAppID = _this.common.config.facebookAppID;
                    window.fbAsyncInit = function () {
                        window.FB.init({
                            appId: facebookAppID,
                            autoLogAppEvents: true,
                            xfbml: true,
                            version: 'v2.10'
                        });
                        window.FB.AppEvents.logPageView();
                    };
                    (function (d, s, id) {
                        var js, fjs = d.getElementsByTagName(s)[0];
                        if (d.getElementById(id)) {
                            return;
                        }
                        js = d.createElement(s);
                        js.id = id;
                        js.src = "https://connect.facebook.net/en_US/sdk.js";
                        fjs.parentNode.insertBefore(js, fjs);
                    }(document, 'script', 'facebook-jssdk'));
                    return _this;
                }
                FacebookShareDir.directiveId = "idpFacebookShare";
                return FacebookShareDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.FacebookShareDir = FacebookShareDir;
            (function (FacebookShareDir) {
                var FacebookShareDirCtrl = (function (_super) {
                    __extends(FacebookShareDirCtrl, _super);
                    function FacebookShareDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        return _super.call(this, $scope, $location, common, breezeService, pulseContext, FacebookShareDirCtrl.controllerId) || this;
                    }
                    Object.defineProperty(FacebookShareDirCtrl.prototype, "facebookLogoUrl", {
                        get: function () {
                            return this.common.config.appRoot + "assets/images/reg-flow/facebook-f2.png";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    FacebookShareDirCtrl.prototype.share = function (event) {
                        event.preventDefault();
                        var shareName = this.name || 'iD Tech summer camp!';
                        var shareDescription = this.description || 'Share iD Tech with Friends on FB';
                        var shareUrl = this.url || this.common.config.WWW_UrlRoot;
                        var fbParams = {
                            method: 'share',
                            display: 'popup',
                            href: shareUrl,
                            quote: shareDescription,
                            mobile_iframe: true,
                        };
                        FB.ui(fbParams, function (response) { });
                    };
                    FacebookShareDirCtrl.controllerId = "idpFacebookShareCtrl";
                    return FacebookShareDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                FacebookShareDir.FacebookShareDirCtrl = FacebookShareDirCtrl;
            })(FacebookShareDir = PulsePublic.FacebookShareDir || (PulsePublic.FacebookShareDir = {}));
            Pulse.app.directive(FacebookShareDir.directiveId, ["common", function (c) { return new FacebookShareDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var idpTwitterShareDir = (function (_super) {
                __extends(idpTwitterShareDir, _super);
                function idpTwitterShareDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.SharedDirectives + "social-media/idp-twitter-share.html";
                    _this.scope = {
                        text: "<",
                        url: "<",
                        width: "<",
                        height: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        idpTwitterShareDir.idpTwitterShareDirCtrl];
                    return _this;
                }
                idpTwitterShareDir.directiveId = "idpTwitterShare";
                return idpTwitterShareDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.idpTwitterShareDir = idpTwitterShareDir;
            (function (idpTwitterShareDir) {
                var idpTwitterShareDirCtrl = (function (_super) {
                    __extends(idpTwitterShareDirCtrl, _super);
                    function idpTwitterShareDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, idpTwitterShareDirCtrl.controllerId) || this;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(idpTwitterShareDirCtrl.prototype, "twitterLogoUrl", {
                        get: function () {
                            return this.common.config.appRoot + "assets/images/reg-flow/twitter-bird2.png";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    idpTwitterShareDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls);
                    };
                    idpTwitterShareDirCtrl.prototype.share = function (event) {
                        event.preventDefault();
                        var shareText = this.text || "We've enrolled at iD Tech!";
                        var shareUrl = this.url || "www.iDTech.com";
                        var url = String.format("https://twitter.com/share?text={0}&url={1}", encodeURIComponent(shareText), encodeURIComponent(shareUrl));
                        var windowWidth = this.common.$window.innerWidth ? this.common.$window.innerWidth : this.common.$window.document.documentElement.clientWidth;
                        var windowHeight = this.common.$window.innerHeight ? this.common.$window.innerHeight : this.common.$window.document.documentElement.clientHeight;
                        var popupWidth = Math.min(windowWidth, (this.width || 575));
                        var popupHeight = Math.min(windowHeight, (this.height || 400));
                        var left = (popupWidth / 2) - (this.width / 2);
                        var top = (popupHeight / 2) - (this.height / 2);
                        var features = String.format("width={0},height={1},top={2},left={3}", popupWidth, popupHeight, top, left);
                        this.common.$window.open(url, "_blank", features);
                    };
                    idpTwitterShareDirCtrl.controllerId = "idpTwitterShareDirCtrl";
                    idpTwitterShareDirCtrl._instanceCount = 0;
                    return idpTwitterShareDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                idpTwitterShareDir.idpTwitterShareDirCtrl = idpTwitterShareDirCtrl;
            })(idpTwitterShareDir = PulsePublic.idpTwitterShareDir || (PulsePublic.idpTwitterShareDir = {}));
            Pulse.app.directive(idpTwitterShareDir.directiveId, ["common", function (c) { return new idpTwitterShareDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var idpEmailShareDir = (function (_super) {
                __extends(idpEmailShareDir, _super);
                function idpEmailShareDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.SharedDirectives + "social-media/idp-email-share.html";
                    _this.scope = {
                        rafCode: "<",
                        width: "<",
                        height: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        idpEmailShareDir.idpEmailShareDirCtrl];
                    return _this;
                }
                idpEmailShareDir.directiveId = "idpEmailShare";
                return idpEmailShareDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.idpEmailShareDir = idpEmailShareDir;
            (function (idpEmailShareDir) {
                var idpEmailShareDirCtrl = (function (_super) {
                    __extends(idpEmailShareDirCtrl, _super);
                    function idpEmailShareDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, idpEmailShareDirCtrl.controllerId) || this;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(idpEmailShareDirCtrl.prototype, "emailLogoUrl", {
                        get: function () {
                            return this.common.config.appRoot + "assets/images/reg-flow/share-email.png";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    idpEmailShareDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls);
                    };
                    idpEmailShareDirCtrl.prototype.share = function (event) {
                        event.preventDefault();
                        var url = "mailto:?subject=Save $25 on iD Tech Summer Programs"
                            + "&body=We've signed up for an iD Tech summer camp!"
                            + " Check out their awesome camps and save $25 when you use my referral"
                            + " code to register: " + this.rafCode + " (New customers only)";
                        var windowWidth = this.common.$window.innerWidth ? this.common.$window.innerWidth : this.common.$window.document.documentElement.clientWidth;
                        var windowHeight = this.common.$window.innerHeight ? this.common.$window.innerHeight : this.common.$window.document.documentElement.clientHeight;
                        var popupWidth = Math.min(windowWidth, (this.width || 575));
                        var popupHeight = Math.min(windowHeight, (this.height || 400));
                        var left = (popupWidth / 2) - (this.width / 2);
                        var top = (popupHeight / 2) - (this.height / 2);
                        var features = String.format("width={0},height={1},top={2},left={3}", popupWidth, popupHeight, top, left);
                        this.common.$window.open(url, "_blank", features);
                    };
                    idpEmailShareDirCtrl.controllerId = "idpEmailShareDirCtrl";
                    idpEmailShareDirCtrl._instanceCount = 0;
                    return idpEmailShareDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                idpEmailShareDir.idpEmailShareDirCtrl = idpEmailShareDirCtrl;
            })(idpEmailShareDir = PulsePublic.idpEmailShareDir || (PulsePublic.idpEmailShareDir = {}));
            Pulse.app.directive(idpEmailShareDir.directiveId, ["common", function (c) { return new idpEmailShareDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var animationTimes = {
                get collapse() {
                    return 200;
                },
                get scroll() {
                    return 200;
                },
                get expand() {
                    return 500;
                },
                get offsetFinishInsurance() {
                    return 100;
                },
            };
            var scrollToElement = Pulse.Utils.scrollToElement;
            Pulse.app.directive('idpLocationsExpander', ['$timeout', function ($timeout) {
                    var maxHeight;
                    function getMaxScrollHeight($element) {
                        return $element.get(0).scrollHeight;
                    }
                    function expand($element) {
                        maxHeight = getMaxScrollHeight($element);
                        $element.css({
                            'max-height': maxHeight + "px",
                            'transition': "max-height " + animationTimes.expand + "ms ease"
                        });
                    }
                    function collapse($element) {
                        maxHeight = 0;
                        $element.css({
                            'max-height': "" + maxHeight,
                            'transition': "max-height " + animationTimes.collapse + "ms ease"
                        });
                    }
                    function isVisible($element) {
                        return $element.parents('.region').css('display') !== 'none'
                            && $element.parents('.region-column').css('display') !== 'none';
                    }
                    function resize($element) {
                        if (maxHeight !== getMaxScrollHeight($element)) {
                            maxHeight = getMaxScrollHeight($element);
                            $element.css('max-height', maxHeight);
                        }
                    }
                    return {
                        link: function (scope, $element, attr) {
                            var $window = angular.element(window);
                            var promise;
                            scope.$watch(function () {
                                return parseInt($element.css('height'), 10) - $element.get(0).scrollHeight;
                            }, function (newVal, oldVal) {
                                if (scope.expanderFlag && newVal !== oldVal) {
                                    resize($element);
                                }
                            });
                            scope.$watch('expanderFlag', function (newState) {
                                if (newState) {
                                    $timeout(function () {
                                        if (isVisible($element)) {
                                            scrollToElement($element, 40, animationTimes.scroll);
                                        }
                                        $timeout(function () {
                                            expand($element);
                                            bindResizeListener();
                                        }, animationTimes.scroll + animationTimes.offsetFinishInsurance);
                                    }, animationTimes.collapse + animationTimes.offsetFinishInsurance);
                                }
                                else {
                                    collapse($element);
                                    unbindResizeListener();
                                }
                            });
                            scope.$on('$destroy', function () {
                                unbindResizeListener();
                            });
                            function bindResizeListener() {
                                $window.bind('resize', triggerDigest);
                            }
                            function unbindResizeListener() {
                                $window.unbind('resize', triggerDigest);
                            }
                            function triggerDigest() {
                                if (promise) {
                                    $timeout.cancel(promise);
                                }
                                promise = $timeout(function () {
                                    promise = undefined;
                                    scope.$digest();
                                }, 100, false);
                            }
                        },
                        restrict: 'A',
                        scope: {
                            expanderFlag: '=',
                        }
                    };
                }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var GenderDir = (function (_super) {
                __extends(GenderDir, _super);
                function GenderDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "common/idp-gender.html";
                    _this.require = "^" + GenderDir.directiveId;
                    _this.scope = {
                        genderTypeId: "=",
                        isEditMode: "<",
                        isRequired: "<",
                        labelFontSize: "<?",
                        labelClass: "<?",
                        radioFormat: "<?",
                        textWhenReadOnly: "<?",
                        onChange: "&?",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        GenderDir.GenderDirCtrl];
                    return _this;
                }
                GenderDir.directiveId = "idpGender";
                return GenderDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.GenderDir = GenderDir;
            (function (GenderDir) {
                var GenderDirCtrl = (function (_super) {
                    __extends(GenderDirCtrl, _super);
                    function GenderDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, GenderDirCtrl.controllerId) || this;
                        _this.radioFormat = false;
                        _this.labelFontSize = "auto";
                        _this.labelClass = "";
                        _this.textWhenReadOnly = false;
                        _this.genderButtonWidthWhenUndefined = { width: '40%' };
                        _this.genderButtonWidthWhenDefined = { width: '49%' };
                        _this.genderButtonStyle = _this.genderButtonWidthWhenDefined;
                        _this.formName = "frmGender";
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.id = GenderDirCtrl._instanceCount++;
                        _this.activationPromises.push(_this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.GenderGroup.Student, Enums.TypeClassType.Gender)
                            .then(function (genderTypes) {
                            _this.genderTypes = genderTypes;
                        }));
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(GenderDirCtrl.prototype, "isGenderDefined", {
                        get: function () {
                            return angular.isNumber(this.genderTypeId);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    GenderDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        this.myForm = scope[this.formName];
                    };
                    GenderDirCtrl.prototype.changeGender = function (genderTypeId) {
                        this.genderTypeId = genderTypeId;
                        this.myForm.$setDirty();
                        this.$scope.$emit(Events.StudentGenderChanging);
                        if (this.onChange) {
                            this.onChange();
                        }
                    };
                    GenderDirCtrl.prototype.showGenderHelp = function ($e) {
                        $e.preventDefault();
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Gender', Directives.HelpPopup.HelpTopic.GenderHelp, "GenderHelp" + this.id.toString());
                    };
                    Object.defineProperty(GenderDirCtrl.prototype, "infoIconSize", {
                        get: function () {
                            var iconSize = 'text-em-0-75';
                            if (this.labelFontSize == 'auto' || this.labelFontSize == '16px') {
                                iconSize = 'text-em-1-0';
                            }
                            return iconSize;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(GenderDirCtrl.prototype, "genderHelpHtml", {
                        get: function () {
                            return '<span role="tooltip">In an effort to be inclusive of all students, we use this info as a means of data collection to help inform our diversity, equity, and inclusion initiatives and better support our students. We recognize that these options do not include all experiences. Please select the category that most closely aligns with your child’s gender identity.</span>';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    GenderDirCtrl.prototype.onGenderSelected = function (e, genderType) {
                        if (!this.isEditMode)
                            return;
                        if (this.genderTypeId === genderType.typeID) {
                            e.preventDefault();
                        }
                        else {
                            this.genderTypeId = genderType.typeID;
                        }
                        if (this.onChange) {
                            this.onChange();
                        }
                    };
                    GenderDirCtrl.controllerId = "GenderDirCtrl";
                    GenderDirCtrl._instanceCount = 0;
                    return GenderDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                GenderDir.GenderDirCtrl = GenderDirCtrl;
            })(GenderDir = PulsePublic.GenderDir || (PulsePublic.GenderDir = {}));
            Pulse.app.directive(GenderDir.directiveId, ["common", function (c) { return new GenderDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var IntlTelInputDir = (function (_super) {
                __extends(IntlTelInputDir, _super);
                function IntlTelInputDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "common/idp-intl-tel-input.html";
                    _this.require = "^" + IntlTelInputDir.directiveId;
                    _this.scope = {
                        countryCode: "=",
                        phoneNumber: "=",
                        phoneNumberPlaceHolder: "@?",
                        isEditMode: "<",
                        isReadonly: "<",
                        isRequired: "<",
                        firstTabIndex: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        IntlTelInputDir.IntlTelInputDirCtrl];
                    return _this;
                }
                IntlTelInputDir.directiveId = "idpIntlTelInput";
                return IntlTelInputDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.IntlTelInputDir = IntlTelInputDir;
            (function (IntlTelInputDir) {
                var IntlTelInputDirCtrl = (function (_super) {
                    __extends(IntlTelInputDirCtrl, _super);
                    function IntlTelInputDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, IntlTelInputDirCtrl.controllerId) || this;
                        _this.countryCode = '1';
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.id = IntlTelInputDirCtrl._instanceCount++;
                        _this.formName = "frmIntlTelInput" + _this.id;
                        return _this;
                    }
                    Object.defineProperty(IntlTelInputDirCtrl.prototype, "phoneNumberFormatted", {
                        get: function () {
                            return this.phoneNumber;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    IntlTelInputDirCtrl.prototype.$onInit = function () {
                        this.activateController();
                    };
                    IntlTelInputDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.myForm = scope[this.formName];
                        scope.$watch(function (scope) {
                            return _this.phoneNumberCtrl.getSelectedCountryData();
                        }, function (newValue, oldValue) {
                            if (newValue && newValue.dialCode) {
                                _this.countryCode = newValue.dialCode;
                            }
                            else {
                                _this.countryCode = "1";
                            }
                        });
                    };
                    IntlTelInputDirCtrl.prototype.phoneNumberWithDashes = function (countryCode, phoneNumber) {
                        var phone = "";
                        if (String.isNullOrWhitespace(phoneNumber)) {
                            return "";
                        }
                        else {
                            var insertDash = false;
                            if (!(countryCode)) {
                                insertDash = true;
                            }
                            else if (countryCode == 1) {
                                insertDash = true;
                            }
                            if (insertDash) {
                                if ((phoneNumber.length > 3) && (phoneNumber.indexOf('-') < 0)) {
                                    phone.concat([phoneNumber.slice(0, 3), "-", phoneNumber.slice(3)].join(''));
                                }
                                else {
                                    phone.concat(phoneNumber);
                                }
                            }
                            else {
                                phone.concat(phoneNumber);
                            }
                            return phone;
                        }
                    };
                    IntlTelInputDirCtrl.controllerId = "IntlTelInputDirCtrl";
                    IntlTelInputDirCtrl._instanceCount = 0;
                    return IntlTelInputDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                IntlTelInputDir.IntlTelInputDirCtrl = IntlTelInputDirCtrl;
            })(IntlTelInputDir = PulsePublic.IntlTelInputDir || (PulsePublic.IntlTelInputDir = {}));
            Pulse.app.directive(IntlTelInputDir.directiveId, ["common", function (c) { return new IntlTelInputDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DatePickerDir = (function (_super) {
                __extends(DatePickerDir, _super);
                function DatePickerDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot
                        + Paths.PulsePublicDirective + 'common/idp-date-picker.html';
                    _this.require = '^' + DatePickerDir.directiveId;
                    _this.scope = {
                        date: '=',
                        dayLabel: '<',
                        disableDateRangeValidation: '=?',
                        firstTabIndex: '<',
                        invalidDateMsg: '<?',
                        isDisabled: '&?',
                        isEditMode: '<',
                        isRequired: '<',
                        maxDate: '<',
                        minDate: '<',
                        monthLabel: '<',
                        requiredMessage: '<',
                        showDay: '<',
                        showMonth: '<',
                        showYear: '<',
                        sortYearsDescending: '<',
                        validMaxDate: '<?',
                        validMinDate: '<?',
                        yearLabel: '<'
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        DatePickerDir.DatePickerDirCtrl,
                    ];
                    return _this;
                }
                DatePickerDir.directiveId = 'idpDatePicker';
                return DatePickerDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.DatePickerDir = DatePickerDir;
            (function (DatePickerDir) {
                var DatePickerDirCtrl = (function (_super) {
                    __extends(DatePickerDirCtrl, _super);
                    function DatePickerDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, DatePickerDirCtrl.controllerId) || this;
                        _this.months = new Array();
                        _this.days = new Array();
                        _this.years = new Array();
                        _this.isUpdated = false;
                        _this.id = DatePickerDirCtrl._instanceCount++;
                        _this.formName = 'frmDatePicker';
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.isDisabled = function () { return false; };
                        return _this;
                    }
                    DatePickerDirCtrl.prototype.$onInit = function () {
                        this.minDate = moment.isDate(this.minDate) ? this.minDate : new Date();
                        this.maxDate = moment.isDate(this.maxDate) ? this.maxDate : new Date(1920, 1, 1);
                        this.validMinDate = this.validMinDate ? this.validMinDate : this.minDate;
                        this.validMaxDate = this.validMaxDate ? this.validMaxDate : this.maxDate;
                        if (angular.isUndefined(this.showMonth))
                            this.showMonth = true;
                        if (angular.isUndefined(this.showDay))
                            this.showDay = true;
                        if (angular.isUndefined(this.showYear))
                            this.showYear = true;
                        if (angular.isUndefined(this.sortYearsDescending))
                            this.sortYearsDescending = false;
                        this.populateMonths();
                        this.populateDays(31);
                        this.populateYears();
                        this.isUpdated = false;
                        this.activateController();
                    };
                    DatePickerDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.myForm = scope[this.formName];
                        scope.$watch(function () {
                            return _this.date;
                        }, function (newValue, oldValue) {
                            if (angular.isDefined(newValue) && moment(newValue)
                                .isValid()) {
                                _this.selectedMonth = Pulse.Utils.JS.findByProperties(_this.months, { id: newValue.getMonth() })[0].id;
                                _this.selectedDay = Pulse.Utils.JS.findByProperties(_this.days, { id: newValue.getDate() })[0];
                                _this.selectedYear = Pulse.Utils.JS.findByProperties(_this.years, { id: newValue.getFullYear() })[0];
                            }
                            else {
                                _this.selectedMonth = undefined;
                                _this.selectedDay = undefined;
                                _this.selectedYear = undefined;
                            }
                        });
                        scope.$watch(function () {
                            return _this.minDate;
                        }, function (newValue) {
                            if (angular.isDefined(newValue))
                                _this.populateYears();
                        });
                        scope.$watch(function () {
                            return _this.maxDate;
                        }, function (newValue) {
                            if (angular.isDefined(newValue))
                                _this.populateYears();
                        });
                    };
                    DatePickerDirCtrl.prototype.onValueChange = function () {
                        if (!this.showMonth)
                            this.selectedMonth = this.months[0].id;
                        if (!this.showDay)
                            this.selectedDay = this.days[0];
                        if (!this.showYear)
                            this.selectedYear = this.years[0];
                        if (this.isDate()) {
                            var d = moment().startOf('day');
                            d.year(this.selectedYear.id);
                            d.month(this.selectedMonth);
                            d.date(this.selectedDay.id);
                            var daysInMonth = d.daysInMonth();
                            this.populateDays(daysInMonth);
                            if (d.isValid())
                                this.date = d.toDate();
                            else
                                this.date = undefined;
                        }
                        this.isUpdated = true;
                    };
                    DatePickerDirCtrl.prototype.isDate = function () {
                        return angular.isDefined(this.selectedMonth)
                            && angular.isDefined(this.selectedDay)
                            && angular.isDefined(this.selectedYear);
                    };
                    DatePickerDirCtrl.prototype.populateMonths = function () {
                        this.months = new Array();
                        var monthNames = moment.monthsShort();
                        var monthFullNames = moment.months();
                        for (var i = 0; i < monthNames.length; i++)
                            this.months.push({
                                id: i,
                                label: monthNames[i],
                                fullMonthLabel: monthFullNames[i],
                            });
                    };
                    DatePickerDirCtrl.prototype.populateDays = function (daysInMonth) {
                        this.days = new Array();
                        for (var i = 1; i <= daysInMonth; i++)
                            this.days.push({
                                id: i,
                                label: i.toString(),
                            });
                    };
                    DatePickerDirCtrl.prototype.populateYears = function () {
                        this.years = new Array();
                        var minYear = moment(this.maxDate)
                            .year();
                        var maxYear = moment(this.minDate)
                            .year();
                        for (var i = minYear; i <= maxYear; i++)
                            this.years.push({
                                id: i,
                                label: i.toString(),
                            });
                        if (this.sortYearsDescending)
                            this.years.reverse();
                    };
                    DatePickerDirCtrl.controllerId = 'DatePickerDirCtrl';
                    DatePickerDirCtrl._instanceCount = 0;
                    return DatePickerDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                DatePickerDir.DatePickerDirCtrl = DatePickerDirCtrl;
            })(DatePickerDir = PulsePublic.DatePickerDir || (PulsePublic.DatePickerDir = {}));
            Pulse.app.directive(DatePickerDir.directiveId, [
                'common',
                function (c) { return new DatePickerDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var TypeSelectorDir = (function (_super) {
                __extends(TypeSelectorDir, _super);
                function TypeSelectorDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "common/idp-type-selector.html";
                    _this.require = "^" + TypeSelectorDir.directiveId;
                    _this.scope = {
                        types: "=",
                        selectedTypes: "=",
                        max: "@",
                        min: "@",
                        isEditMode: "=",
                        isReadOnly: "=",
                        isRequired: "<",
                        verticalLayout: "<",
                        tooltip: "@",
                        requiredMessage: "@",
                        maxMessage: "@",
                        minMessage: "@"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        TypeSelectorDir.TypeSelectorDirCtrl];
                    return _this;
                }
                TypeSelectorDir.directiveId = "idpTypeSelector";
                return TypeSelectorDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.TypeSelectorDir = TypeSelectorDir;
            (function (TypeSelectorDir) {
                var TypeSelectorDirCtrl = (function (_super) {
                    __extends(TypeSelectorDirCtrl, _super);
                    function TypeSelectorDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, TypeSelectorDirCtrl.controllerId) || this;
                        _this.id = TypeSelectorDirCtrl._instanceCount++;
                        _this.formName = "formTypeSelect" + _this.id;
                        _this.checkUnsavedDataBeforeNav = false;
                        return _this;
                    }
                    TypeSelectorDirCtrl.prototype.$onInit = function () {
                        if (!angular.isArray(this.selectedTypes) || angular.isUndefined(this.selectedTypes)) {
                            this.selectedTypes = new Array();
                        }
                        this.activateController();
                    };
                    TypeSelectorDirCtrl.prototype.toggleSelected = function (type) {
                        if (!this.isReadOnly) {
                            if (Pulse.Utils.JS.findByProperties(this.selectedTypes, { typeID: type.typeID }).length > 0) {
                                this.selectedTypes.splice(this.selectedTypes.indexOf(type), 1);
                            }
                            else if (angular.isDefined(this.max)) {
                                if (this.selectedTypes.length < this.max) {
                                    this.selectedTypes.push(type);
                                }
                                else if (this.max == 1) {
                                    this.selectedTypes = [];
                                    this.selectedTypes.push(type);
                                }
                            }
                            else {
                                this.selectedTypes.push(type);
                            }
                            this.myForm.backingSelect.$setTouched();
                        }
                    };
                    TypeSelectorDirCtrl.prototype.isSelected = function (type) {
                        return this.selectedTypes.indexOf(type) > -1;
                    };
                    TypeSelectorDirCtrl.prototype.validate = function () {
                        if (this.myForm == null || this.myForm.backingSelect == null)
                            return;
                        if (this.isRequired) {
                            this.myForm.backingSelect.$setValidity("required", this.selectedTypes.length > 0);
                        }
                        ;
                        if (angular.isDefined(this.max)) {
                            this.myForm.backingSelect.$setValidity("maxlength", this.selectedTypes.length <= this.max);
                        }
                        if (angular.isDefined(this.min)) {
                            this.myForm.backingSelect.$setValidity("minlength", this.selectedTypes.length >= this.min);
                        }
                    };
                    TypeSelectorDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.myForm = scope[this.formName];
                        var parentCtrl = (scope.$parent).vm;
                        scope.$watch(function (scope) {
                            return parentCtrl.myForm.$submitted;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                _this.validate();
                            }
                        });
                        scope.$watchCollection(function (scope) {
                            return _this.selectedTypes;
                        }, function (newVal, oldVal) {
                            if (angular.isArray(newVal) && _this.myForm.backingSelect.$touched) {
                                _this.validate();
                            }
                        });
                    };
                    TypeSelectorDirCtrl.controllerId = "TypeSelectorDirCtrl";
                    TypeSelectorDirCtrl._instanceCount = 0;
                    return TypeSelectorDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                TypeSelectorDir.TypeSelectorDirCtrl = TypeSelectorDirCtrl;
            })(TypeSelectorDir = PulsePublic.TypeSelectorDir || (PulsePublic.TypeSelectorDir = {}));
            Pulse.app.directive(TypeSelectorDir.directiveId, ["common", function (c) { return new TypeSelectorDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var PasswordDir = (function (_super) {
                __extends(PasswordDir, _super);
                function PasswordDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "common/idp-password.html";
                    _this.scope = {
                        newPassword: "=",
                        newPasswordConfirm: "=",
                        firstTabIndex: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        PasswordDir.PasswordDirCtrl];
                    return _this;
                }
                PasswordDir.directiveId = "idpPassword";
                return PasswordDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.PasswordDir = PasswordDir;
            (function (PasswordDir) {
                var PasswordDirCtrl = (function (_super) {
                    __extends(PasswordDirCtrl, _super);
                    function PasswordDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, PasswordDirCtrl.controllerId) || this;
                        _this.passwordRegExp = PulseRegExp.Password;
                        _this.passwordRegExpErrorMsg = PulseRegExp.PasswordErrorMessage;
                        _this.passwordRegExpMatchMsg = PulseRegExp.PasswordMatchMessage;
                        _this.id = PasswordDirCtrl._instanceCount++;
                        _this.formName = "idpPasswordForm" + _this.id;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.activateController();
                        return _this;
                    }
                    PasswordDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        this.myForm = scope[this.formName];
                        var parentCtrl = (scope.$parent).vm;
                    };
                    PasswordDirCtrl.controllerId = "idpPasswordCtrl";
                    PasswordDirCtrl._instanceCount = 0;
                    return PasswordDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                PasswordDir.PasswordDirCtrl = PasswordDirCtrl;
            })(PasswordDir = PulsePublic.PasswordDir || (PulsePublic.PasswordDir = {}));
            Pulse.app.directive(PasswordDir.directiveId, ["common", function (c) { return new PasswordDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            "use strict";
            var ScheduledPaymentsDir = (function (_super) {
                __extends(ScheduledPaymentsDir, _super);
                function ScheduledPaymentsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "common/idp-scheduled-payments.html";
                    _this.scope = {
                        currencyTypeId: "<",
                        divisionNameForPaymentPlan: "=",
                        scheduledPaymentsInfo: "=",
                        selectedPaymentOption: "=",
                        isForMyAccount: "@"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "$templateCache",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        ScheduledPaymentsDir.ScheduledPaymentsDirCtrl];
                    return _this;
                }
                ScheduledPaymentsDir.directiveId = "idpScheduledPayments";
                return ScheduledPaymentsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.ScheduledPaymentsDir = ScheduledPaymentsDir;
            (function (ScheduledPaymentsDir) {
                var ScheduledPaymentsDirCtrl = (function (_super) {
                    __extends(ScheduledPaymentsDirCtrl, _super);
                    function ScheduledPaymentsDirCtrl($scope, $location, $templateCache, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ScheduledPaymentsDirCtrl.controllerId) || this;
                        _this._divisionNameForPaymentPlan = '';
                        _this._isForMyAccount = null;
                        _this.currencyTypeId = null;
                        _this.$templateCache = $templateCache;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(ScheduledPaymentsDirCtrl.prototype, "divisionNameForPaymentPlan", {
                        get: function () {
                            return this._divisionNameForPaymentPlan;
                        },
                        set: function (divisionName) {
                            this._divisionNameForPaymentPlan = divisionName;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ScheduledPaymentsDirCtrl.prototype, "isForMyAccount", {
                        get: function () {
                            if (this._isForMyAccount == null) {
                                return false;
                            }
                            else {
                                return this._isForMyAccount;
                            }
                        },
                        set: function (b) {
                            if (typeof b == 'string') {
                                this._isForMyAccount = this.stringToBoolean(b);
                            }
                            else {
                                this._isForMyAccount = b;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ScheduledPaymentsDirCtrl.prototype, "scheduledPaymentsInfo", {
                        get: function () {
                            return this._scheduledPaymentsInfo;
                        },
                        set: function (info) {
                            this._scheduledPaymentsInfo = info;
                            if (info) {
                                if (info.monthlyTotals) {
                                    for (var i = 0, il = info.monthlyTotals.length; i < il; ++i) {
                                        var totalInfo = info.monthlyTotals[i];
                                        totalInfo.statusTypeAsString = this.getStringForStatusTypeID(totalInfo.statusTypeID);
                                        for (var j = 0, jl = totalInfo.details.length; j < jl; ++j) {
                                            var detailInfo = totalInfo.details[j];
                                            detailInfo.statusTypeAsString = this.getStringForStatusTypeID(detailInfo.statusTypeID);
                                        }
                                    }
                                }
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ScheduledPaymentsDirCtrl.prototype.getStringForStatusTypeID = function (statusTypeID) {
                        switch (statusTypeID) {
                            case -1:
                                return 'see details';
                            case Enums.ScheduledPaymentStatusType.Paid:
                                return 'Paid';
                            case Enums.ScheduledPaymentStatusType.Unpaid:
                                return 'Unpaid';
                            default:
                                return 'Payment Failed';
                        }
                    };
                    ScheduledPaymentsDirCtrl.prototype.setIsMonthlyTotalDetailVisible = function (idx, isVisible) {
                        this.scheduledPaymentsInfo.monthlyTotals[idx].isDetailVisible = isVisible;
                    };
                    ScheduledPaymentsDirCtrl.prototype.showMoreInfo = function () {
                        var initDataObj = {};
                        initDataObj.scheduledPaymentsInfo = null;
                        initDataObj.showSchedule = false;
                        this.common.$rootScope.$broadcast(Events.ShowScheduledPaymentsPopup, {
                            size: '',
                            initDataObj: initDataObj,
                        });
                    };
                    ScheduledPaymentsDirCtrl.prototype.showPaymentSchedule = function () {
                        var initDataObj = {};
                        initDataObj.scheduledPaymentsInfo = this.scheduledPaymentsInfo;
                        initDataObj.showSchedule = true;
                        this.common.$rootScope.$broadcast(Events.ShowScheduledPaymentsPopup, {
                            size: '',
                            initDataObj: initDataObj,
                        });
                    };
                    ScheduledPaymentsDirCtrl.prototype.stringToBoolean = function (s) {
                        switch (s.toLowerCase().trim()) {
                            case "true":
                            case "yes":
                            case "1": return true;
                            case "false":
                            case "no":
                            case "0":
                            case null: return false;
                            default: return Boolean(s);
                        }
                    };
                    ScheduledPaymentsDirCtrl.controllerId = "ScheduledPaymentsDirCtrl";
                    return ScheduledPaymentsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                ScheduledPaymentsDir.ScheduledPaymentsDirCtrl = ScheduledPaymentsDirCtrl;
            })(ScheduledPaymentsDir = PulsePublic.ScheduledPaymentsDir || (PulsePublic.ScheduledPaymentsDir = {}));
            Pulse.app.directive(ScheduledPaymentsDir.directiveId, ["common", function (c) { return new ScheduledPaymentsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var ScheduledPaymentsPopup = (function (_super) {
                __extends(ScheduledPaymentsPopup, _super);
                function ScheduledPaymentsPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "ScrollLockService",
                        ScheduledPaymentsPopup.ScheduledPaymentsPopupCtrl];
                    return _this;
                }
                ScheduledPaymentsPopup.directiveId = "idpScheduledPaymentsPopup";
                return ScheduledPaymentsPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.ScheduledPaymentsPopup = ScheduledPaymentsPopup;
            (function (ScheduledPaymentsPopup) {
                var ScheduledPaymentsPopupCtrl = (function (_super) {
                    __extends(ScheduledPaymentsPopupCtrl, _super);
                    function ScheduledPaymentsPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, ScheduledPaymentsPopupCtrl.controllerId) || this;
                        _this.initDataObj = { scheduledPaymentsInfo: null, showSchedule: true, };
                        _this.formName = "frmScheduledPayments";
                        _this.event_ShowPopup = Events.ShowScheduledPaymentsPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot
                            + Paths.PulsePublicDirective
                            + "common/idp-scheduled-payments-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(ScheduledPaymentsPopupCtrl.prototype, "currencyTypeID", {
                        get: function () {
                            return this.pulseContext.selectedCurrencyTypeID;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ScheduledPaymentsPopupCtrl.prototype.close = function () {
                        _super.prototype.close.call(this);
                    };
                    ScheduledPaymentsPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        if (initDataObj) {
                            this.initDataObj = initDataObj;
                        }
                        this.showSchedule = initDataObj.showSchedule;
                        if (this.showSchedule) {
                            this.title = "Payment Schedule";
                        }
                        else {
                            this.title = "More Info";
                        }
                        this.setLocalizedTexts();
                    };
                    ScheduledPaymentsPopupCtrl.controllerId = "ScheduledPaymentsPopupCtrl";
                    return ScheduledPaymentsPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                ScheduledPaymentsPopup.ScheduledPaymentsPopupCtrl = ScheduledPaymentsPopupCtrl;
            })(ScheduledPaymentsPopup = PulsePublic.ScheduledPaymentsPopup || (PulsePublic.ScheduledPaymentsPopup = {}));
            Pulse.app.directive(ScheduledPaymentsPopup.directiveId, ["common", function (c) { return new ScheduledPaymentsPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var BankTransferInfoDir = (function (_super) {
                __extends(BankTransferInfoDir, _super);
                function BankTransferInfoDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-bank-transfer-info.html";
                    _this.scope = {
                        bankTransferInfo: "=",
                        amountToCharge: "<",
                        isReadOnly: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        BankTransferInfoDir.BankTransferInfoDirCtrl];
                    return _this;
                }
                BankTransferInfoDir.directiveId = "idpBankTransferInfo";
                return BankTransferInfoDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.BankTransferInfoDir = BankTransferInfoDir;
            (function (BankTransferInfoDir) {
                var BankTransferInfoDirCtrl = (function (_super) {
                    __extends(BankTransferInfoDirCtrl, _super);
                    function BankTransferInfoDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, BankTransferInfoDirCtrl.controllerId) || this;
                        _this.formName = "frmBankTransferInfo";
                        return _this;
                    }
                    Object.defineProperty(BankTransferInfoDirCtrl.prototype, "selectedPaymentsOsBank", {
                        get: function () {
                            if (this.bankTransferInfo.bankCode && this.paymentsOsBanks) {
                                for (var i = 0, il = this.paymentsOsBanks.length; i < il; i++) {
                                    var o = this.paymentsOsBanks[i];
                                    if (o.bankCode == this.bankTransferInfo.bankCode) {
                                        return o;
                                    }
                                }
                            }
                            else {
                                return null;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    BankTransferInfoDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.loadPaymentsOsBanks());
                        this.activateController();
                    };
                    BankTransferInfoDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls, transclude);
                        scope.$watch(function (scope) {
                            return _this.myForm.$submitted;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                _this.validate();
                            }
                        });
                    };
                    BankTransferInfoDirCtrl.prototype.loadPaymentsOsBanks = function () {
                        var _this = this;
                        if (!this.paymentsOsBanks) {
                            this.common.toggleSpinner(true, null, null, 0);
                            return this.pulseContext.regFlowMgr.paymentMgr.getPaymentsOsBanks(this.bankTransferInfo.currencyTypeID)
                                .then(function (data) {
                                _this.paymentsOsBanks = data;
                                return data;
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false, true);
                            });
                        }
                        else {
                            var deferred = this.common.$q.defer();
                            deferred.resolve(this.paymentsOsBanks);
                            return deferred.promise;
                        }
                    };
                    BankTransferInfoDirCtrl.prototype.validate = function () {
                    };
                    BankTransferInfoDirCtrl.controllerId = "BankTransferInfoDirCtrl";
                    return BankTransferInfoDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                BankTransferInfoDir.BankTransferInfoDirCtrl = BankTransferInfoDirCtrl;
            })(BankTransferInfoDir = PulsePublic.BankTransferInfoDir || (PulsePublic.BankTransferInfoDir = {}));
            Pulse.app.directive(BankTransferInfoDir.directiveId, ["common", function (c) { return new BankTransferInfoDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CreditCardInfoDir = (function (_super) {
                __extends(CreditCardInfoDir, _super);
                function CreditCardInfoDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-credit-card-info.html";
                    _this.scope = {
                        creditCardInfo: "=",
                        amountToCharge: "<",
                        showBillingAddress: "<",
                        isReadOnly: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CreditCardInfoDir.CreditCardInfoDirCtrl];
                    return _this;
                }
                CreditCardInfoDir.directiveId = "idpCreditCardInfo";
                return CreditCardInfoDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CreditCardInfoDir = CreditCardInfoDir;
            (function (CreditCardInfoDir) {
                var CreditCardInfoDirCtrl = (function (_super) {
                    __extends(CreditCardInfoDirCtrl, _super);
                    function CreditCardInfoDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CreditCardInfoDirCtrl.controllerId) || this;
                        _this.formName = "formCreditCardInfo";
                        return _this;
                    }
                    CreditCardInfoDirCtrl.prototype.$onInit = function () {
                        this.loadExpirationMonths();
                        this.loadExpirationYears();
                        this.activationPromises.push(this.loadCountryTypes());
                        this.activationPromises.push(this.loadStateTypes());
                        this.activationPromises.push(this.loadCanadianProvinceTypes());
                        this.activateController();
                    };
                    CreditCardInfoDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls, transclude);
                        scope.$watch(function (scope) {
                            return _this.myForm.$submitted;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                _this.validate();
                            }
                        });
                    };
                    CreditCardInfoDirCtrl.prototype.loadExpirationMonths = function () {
                        if (!this.expirationMonths) {
                            var expirationMonths = new Array();
                            for (var i = 1; i <= 12; i++) {
                                var s = Pulse.Utils.JS.zeroPad(i, 2);
                                expirationMonths.push({ id: i, name: s });
                            }
                            this.expirationMonths = expirationMonths;
                        }
                    };
                    CreditCardInfoDirCtrl.prototype.loadExpirationYears = function () {
                        if (!this.expirationYears) {
                            var expirationYears = new Array();
                            var d = new Date();
                            var startYear = d.getFullYear();
                            for (var i = 0; i < 10; i++) {
                                expirationYears.push({ id: (startYear + i), name: (startYear + i) + "" });
                            }
                            this.expirationYears = expirationYears;
                        }
                    };
                    CreditCardInfoDirCtrl.prototype.loadCountryTypes = function () {
                        var _this = this;
                        return this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.Country)
                            .then(function (data) {
                            return _this.countryTypes = data;
                        });
                    };
                    CreditCardInfoDirCtrl.prototype.loadStateTypes = function () {
                        var _this = this;
                        return this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.CountryRegionType.USStates)
                            .then(function (data) {
                            return _this.stateTypes = data;
                        });
                    };
                    CreditCardInfoDirCtrl.prototype.loadCanadianProvinceTypes = function () {
                        var _this = this;
                        return this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.CountryRegionType.CanadianProvinces)
                            .then(function (data) {
                            return _this.canadianProvinceTypes = data;
                        });
                    };
                    Object.defineProperty(CreditCardInfoDirCtrl.prototype, "isUSA", {
                        get: function () {
                            if (this.creditCardInfo.countryTypeID == Enums.CountryType.USA) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CreditCardInfoDirCtrl.prototype, "isCanada", {
                        get: function () {
                            if (this.creditCardInfo.countryTypeID == Enums.CountryType.Canada) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CreditCardInfoDirCtrl.prototype, "cityFieldTitle", {
                        get: function () {
                            if (this.isUSA || this.isCanada) {
                                return "City";
                            }
                            else {
                                return "City/Territory";
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CreditCardInfoDirCtrl.prototype, "stateFieldTitle", {
                        get: function () {
                            if (this.isUSA) {
                                return "State";
                            }
                            else if (this.isCanada) {
                                return "Province";
                            }
                            else {
                                return "State/Province";
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CreditCardInfoDirCtrl.prototype, "zipFieldTitle", {
                        get: function () {
                            if (this.isUSA) {
                                return "Zip Code";
                            }
                            else {
                                return "Postal Code";
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CreditCardInfoDirCtrl.prototype.onCountryChange = function () {
                        this.creditCardInfo.stateTypeID = undefined;
                    };
                    CreditCardInfoDirCtrl.prototype.showCreditCardIdHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Credit Card CVV", Pulse.Directives.HelpPopup.HelpTopic.CreditCardIDNumber, "creditCardIDHelp");
                    };
                    CreditCardInfoDirCtrl.prototype.validate = function () {
                    };
                    CreditCardInfoDirCtrl.controllerId = "CreditCardInfoDirCtrl";
                    return CreditCardInfoDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CreditCardInfoDir.CreditCardInfoDirCtrl = CreditCardInfoDirCtrl;
            })(CreditCardInfoDir = PulsePublic.CreditCardInfoDir || (PulsePublic.CreditCardInfoDir = {}));
            Pulse.app.directive(CreditCardInfoDir.directiveId, ["common", function (c) { return new CreditCardInfoDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CheckInfoDir = (function (_super) {
                __extends(CheckInfoDir, _super);
                function CheckInfoDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-check-info.html";
                    _this.scope = {
                        checkInfo: "=",
                        isReadOnly: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "bootstrapDatePickerDefaultConfig",
                        CheckInfoDir.CheckInfoDirCtrl];
                    return _this;
                }
                CheckInfoDir.directiveId = "idpCheckInfo";
                return CheckInfoDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CheckInfoDir = CheckInfoDir;
            (function (CheckInfoDir) {
                var CheckInfoDirCtrl = (function (_super) {
                    __extends(CheckInfoDirCtrl, _super);
                    function CheckInfoDirCtrl($scope, $location, common, breezeService, pulseContext, bootstrapDatePickerDefaultConfig) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CheckInfoDirCtrl.controllerId) || this;
                        _this.formName = "formCheckInfo";
                        _this.calendarObj_Dated = _.cloneDeep(bootstrapDatePickerDefaultConfig);
                        _this.calendarObj_RecDate = _.cloneDeep(bootstrapDatePickerDefaultConfig);
                        return _this;
                    }
                    CheckInfoDirCtrl.prototype.$onInit = function () {
                        this.activateController();
                    };
                    CheckInfoDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls, transclude);
                        scope.$watch(function (scope) {
                            return _this.myForm.$submitted;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                _this.validate();
                            }
                        });
                    };
                    CheckInfoDirCtrl.prototype.validate = function () {
                    };
                    CheckInfoDirCtrl.controllerId = "CheckInfoDirCtrl";
                    return CheckInfoDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CheckInfoDir.CheckInfoDirCtrl = CheckInfoDirCtrl;
            })(CheckInfoDir = PulsePublic.CheckInfoDir || (PulsePublic.CheckInfoDir = {}));
            Pulse.app.directive(CheckInfoDir.directiveId, ["common", function (c) { return new CheckInfoDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var MoneyOrderInfoDir = (function (_super) {
                __extends(MoneyOrderInfoDir, _super);
                function MoneyOrderInfoDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-money-order-info.html";
                    _this.scope = {
                        moneyOrderInfo: "=",
                        isReadOnly: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "bootstrapDatePickerDefaultConfig",
                        MoneyOrderInfoDir.MoneyOrderInfoDirCtrl];
                    return _this;
                }
                MoneyOrderInfoDir.directiveId = "idpMoneyOrderInfo";
                return MoneyOrderInfoDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.MoneyOrderInfoDir = MoneyOrderInfoDir;
            (function (MoneyOrderInfoDir) {
                var MoneyOrderInfoDirCtrl = (function (_super) {
                    __extends(MoneyOrderInfoDirCtrl, _super);
                    function MoneyOrderInfoDirCtrl($scope, $location, common, breezeService, pulseContext, bootstrapDatePickerDefaultConfig) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, MoneyOrderInfoDirCtrl.controllerId) || this;
                        _this.formName = "formMoneyOrderInfo";
                        _this.calendarObj_Dated = _.cloneDeep(bootstrapDatePickerDefaultConfig);
                        _this.calendarObj_RecDate = _.cloneDeep(bootstrapDatePickerDefaultConfig);
                        return _this;
                    }
                    MoneyOrderInfoDirCtrl.prototype.$onInit = function () {
                        this.activateController();
                    };
                    MoneyOrderInfoDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls, transclude);
                        scope.$watch(function (scope) {
                            return _this.myForm.$submitted;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                _this.validate();
                            }
                        });
                    };
                    MoneyOrderInfoDirCtrl.prototype.validate = function () {
                    };
                    MoneyOrderInfoDirCtrl.controllerId = "MoneyOrderInfoDirCtrl";
                    return MoneyOrderInfoDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                MoneyOrderInfoDir.MoneyOrderInfoDirCtrl = MoneyOrderInfoDirCtrl;
            })(MoneyOrderInfoDir = PulsePublic.MoneyOrderInfoDir || (PulsePublic.MoneyOrderInfoDir = {}));
            Pulse.app.directive(MoneyOrderInfoDir.directiveId, ["common", function (c) { return new MoneyOrderInfoDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var VoucherScholarshipInfoDir = (function (_super) {
                __extends(VoucherScholarshipInfoDir, _super);
                function VoucherScholarshipInfoDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-voucher-scholarship-info.html";
                    _this.scope = {
                        voucherScholarshipInfo: "=",
                        isReadOnly: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        VoucherScholarshipInfoDir.VoucherScholarshipInfoDirCtrl];
                    return _this;
                }
                VoucherScholarshipInfoDir.directiveId = "idpVoucherScholarshipInfo";
                return VoucherScholarshipInfoDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.VoucherScholarshipInfoDir = VoucherScholarshipInfoDir;
            (function (VoucherScholarshipInfoDir) {
                var VoucherScholarshipInfoDirCtrl = (function (_super) {
                    __extends(VoucherScholarshipInfoDirCtrl, _super);
                    function VoucherScholarshipInfoDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, VoucherScholarshipInfoDirCtrl.controllerId) || this;
                        _this.formName = "formVoucherScholarshipInfo";
                        return _this;
                    }
                    VoucherScholarshipInfoDirCtrl.prototype.$onInit = function () {
                        this.activateController();
                    };
                    VoucherScholarshipInfoDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls, transclude);
                        scope.$watch(function (scope) {
                            return _this.myForm.$submitted;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                _this.validate();
                            }
                        });
                    };
                    VoucherScholarshipInfoDirCtrl.prototype.validate = function () {
                    };
                    VoucherScholarshipInfoDirCtrl.controllerId = "VoucherScholarshipInfoDirCtrl";
                    return VoucherScholarshipInfoDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                VoucherScholarshipInfoDir.VoucherScholarshipInfoDirCtrl = VoucherScholarshipInfoDirCtrl;
            })(VoucherScholarshipInfoDir = PulsePublic.VoucherScholarshipInfoDir || (PulsePublic.VoucherScholarshipInfoDir = {}));
            Pulse.app.directive(VoucherScholarshipInfoDir.directiveId, ["common", function (c) { return new VoucherScholarshipInfoDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var VoucherDir = (function (_super) {
                __extends(VoucherDir, _super);
                function VoucherDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-voucher.html";
                    _this.scope = {
                        coupon: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        VoucherDir.VoucherDirCtrl];
                    return _this;
                }
                VoucherDir.directiveId = "idpVoucher";
                return VoucherDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.VoucherDir = VoucherDir;
            (function (VoucherDir) {
                var VoucherDirCtrl = (function (_super) {
                    __extends(VoucherDirCtrl, _super);
                    function VoucherDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        return _super.call(this, $scope, $location, common, breezeService, pulseContext, VoucherDirCtrl.controllerId) || this;
                    }
                    VoucherDirCtrl.controllerId = "VoucherDirCtrl";
                    return VoucherDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                VoucherDir.VoucherDirCtrl = VoucherDirCtrl;
            })(VoucherDir = PulsePublic.VoucherDir || (PulsePublic.VoucherDir = {}));
            Pulse.app.directive(VoucherDir.directiveId, ["common", function (c) { return new VoucherDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var LoginDir = (function (_super) {
                __extends(LoginDir, _super);
                function LoginDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'login/idp-login.html';
                    _this.scope = {
                        emailOrUserName: '=?',
                        firstTabIndex: '=',
                        hideRequiredAsterix: '@?',
                        lockEmailAddress: '=',
                        showCancelBtn: '=',
                        showLabels: '@?',
                        show3rdPartySignin: '=?',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        LoginDir.LoginDirCtrl,
                    ];
                    return _this;
                }
                LoginDir.directiveId = 'idpLogin';
                return LoginDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.LoginDir = LoginDir;
            (function (LoginDir) {
                var LoginDirCtrl = (function (_super) {
                    __extends(LoginDirCtrl, _super);
                    function LoginDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LoginDirCtrl.controllerId) || this;
                        _this.show3rdPartySignin = true;
                        _this.showReplaceEmailWith3rdPartyAuthEmail = false;
                        _this.isReplaceWith3rdPartyAuthEmail = true;
                        _this.googleSigninSuccess = function (user) {
                            _this.common.toggleSpinner(true, null, null, 0);
                            var id_token = user.getAuthResponse().id_token;
                            _this.pulseContext.googleAuthenticate(id_token)
                                .then(function (result) {
                            })
                                .catch(function (reason) {
                                _this.show3rdPartySignin = false;
                                _this.showReplaceEmailWith3rdPartyAuthEmail = true;
                                _this.thirdPartyAuthEmail = user.getBasicProfile().getEmail();
                                _this.common.$rootScope.$broadcast(Events.Login3rPartyAccountNotFound, _this.thirdPartyAuthEmail);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false, true);
                            });
                        };
                        _this.googleSigninFail = function (err) {
                            if (err && err.error == "popup_closed_by_user") {
                                return;
                            }
                            _this.common.showError(String.format(StringConst.Err_3rdParty_SignInFailure_Msg, "Google"));
                        };
                        _this.formName = 'loginForm';
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.password = '';
                        _this.submitted = false;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(LoginDirCtrl.prototype, "emailFormat", {
                        get: function () {
                            return PulseRegExp.Email;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(LoginDirCtrl.prototype, "iconStyle", {
                        get: function () {
                            if (this.showLabels) {
                                return { 'top': '52px' };
                            }
                            else {
                                return {};
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    LoginDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl, transclude) {
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl, transclude);
                        if (ctrl.$location.search()[Pulse.Utils.QueryStringUtils.MODE] == 'reset') {
                            this.common.$rootScope.$broadcast(Events.ShowResetPasswordPopup, {
                                size: '',
                                initDataObj: {
                                    'resetCode': ctrl.$location.search()[Pulse.Utils.QueryStringUtils.RESET_CODE],
                                    'userId': ctrl.$location.search()[Pulse.Utils.QueryStringUtils.USER_ID],
                                },
                            });
                        }
                    };
                    LoginDirCtrl.prototype.loadUserContactEmail = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var promise = this.pulseContext.userMgr.getContactMethodsForActingAsUser()
                            .then(function (data) {
                            data.forEach(function (ucm, index, array) {
                                ucm.contactMethodType = { typeID: ucm.contactMethodTypeID };
                            });
                            var ucmDAO = new DataAccess.UserContactMethodDAO(_this.common, _this.breezeService, _this.pulseContext);
                            _this.primaryEmail =
                                data.filter(function (ucm) { return ucm.contactMethodTypeID === Enums.ContactMethodType.Email &&
                                    ucm.isPrimaryNumber; })[0];
                            if (angular.isUndefined(_this.primaryEmail)) {
                                throw new Error(StringConst.Err_Data_Missing);
                            }
                            return data;
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    LoginDirCtrl.prototype.showEmailAddressHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Email/Username Information', Directives.HelpPopup.HelpTopic.UserNameHelp, 'emailAddressHelp');
                    };
                    LoginDirCtrl.prototype.showPasswordHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Password Information', Directives.HelpPopup.HelpTopic.PasswordHelp, 'passwordHelp');
                    };
                    LoginDirCtrl.prototype.showForgotPassword = function () {
                        this.$scope.$broadcast(Events.ShowForgotPasswordPopup, {
                            size: '',
                            initDataObj: {},
                        });
                    };
                    LoginDirCtrl.prototype.submit = function () {
                        var _this = this;
                        this.btnLoginDisabled = true;
                        var deferTask = this.common.$q.defer();
                        if (this.myForm.$valid) {
                            this.common.clearStatus();
                            this.common.toggleSpinner(true, null, null, 0);
                            var ubMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                            var emailAddress = ubMgr.currentUBSession.userBrowsingDTO && ubMgr.currentUBSession.userBrowsingDTO.emailAddress
                                ? ubMgr.currentUBSession.userBrowsingDTO.emailAddress.trim()
                                : '';
                            if (this.emailOrUserName != emailAddress) {
                                var resetBrowseIdentifier = !String.isNullOrWhitespace(emailAddress);
                                deferTask.promise = this.pulseContext.logout(true, resetBrowseIdentifier);
                            }
                            else {
                                deferTask.resolve();
                            }
                            var self = this;
                            deferTask.promise
                                .then(function () {
                                return _this.pulseContext.login(_this.emailOrUserName, _this.password, true)
                                    .then(function (userAndRoles) {
                                    if (userAndRoles.user
                                        && _this.showReplaceEmailWith3rdPartyAuthEmail
                                        && _this.isReplaceWith3rdPartyAuthEmail) {
                                        return _this.loadUserContactEmail()
                                            .then(function (data) {
                                            _this.primaryEmail.contactMethodOther = _this.thirdPartyAuthEmail;
                                            if (_this.breezeService.getEntityManager().hasChanges()) {
                                                return _this.breezeService.saveChanges(null, { resourceName: "User_SaveContactInfo" })
                                                    .then(function (data) {
                                                    _this.pulseContext.refreshUserInfo();
                                                    _this.breezeService.getEntityManager().rejectChanges();
                                                });
                                            }
                                            return;
                                        })
                                            .then(function () {
                                            return userAndRoles;
                                        });
                                    }
                                    return userAndRoles;
                                })
                                    .then(function (userAndRoles) {
                                    if (typeof (localStorage) !== "undefined") {
                                        localStorage.setItem("login_username", _this.emailOrUserName);
                                    }
                                    self.btnLoginDisabled = false;
                                    self.myForm.$setPristine();
                                    _this.pulseContext.setBrowseIdentifier(_this.pulseContext.browseIdentifier, _this.showRememberMe && _this.rememberMe);
                                    if (userAndRoles.user.forcePWChange) {
                                        _this.common.$rootScope.$broadcast(Events.ForcePasswordChange, userAndRoles.user, _this.password);
                                    }
                                    else {
                                        _this.common.$rootScope.$broadcast(Events.LoginSuccess);
                                    }
                                });
                            })
                                .catch(function (err) {
                                self.logError(err);
                                self.password = '';
                            })
                                .finally(function () {
                                self.btnLoginDisabled = false;
                                _this.common.toggleSpinner(false);
                            });
                        }
                        else {
                            this.btnLoginDisabled = false;
                        }
                    };
                    LoginDirCtrl.controllerId = 'LoginDirCtrl';
                    return LoginDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                LoginDir.LoginDirCtrl = LoginDirCtrl;
            })(LoginDir = PulsePublic.LoginDir || (PulsePublic.LoginDir = {}));
            Pulse.app.directive(LoginDir.directiveId, [
                'common',
                function (c) { return new LoginDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LoginPopup = (function (_super) {
                __extends(LoginPopup, _super);
                function LoginPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        '$uibModal',
                        'ScrollLockService',
                        LoginPopup.LoginPopupCtrl,
                    ];
                    return _this;
                }
                LoginPopup.directiveId = 'idpLoginPopup';
                return LoginPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.LoginPopup = LoginPopup;
            (function (LoginPopup) {
                var LoginPopupCtrl = (function (_super) {
                    __extends(LoginPopupCtrl, _super);
                    function LoginPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, LoginPopupCtrl.controllerId) || this;
                        _this.is3rdPartyAccountNotFoundView = false;
                        _this._initDataObjDefault = {
                            disableCreateAccount: false,
                            emailAddress: '',
                            firstTabIndex: 100,
                            goBackOnCloseOfDialogByUser: false,
                            hideRequiredAsterix: false,
                            isCreateAccountMode: false,
                            isNewPasswordMode: false,
                            lockEmailAddress: false,
                            showLabels: false,
                            showRemember: true,
                            showRememberMe: false,
                            title: 'My Account Login',
                            subTitle: '',
                        };
                        _this.event_ShowPopup = Events.ShowLoginPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'login/idp-login-popup.html';
                        _this.keyboard = false;
                        _this.windowClass = "spa-login-popup";
                        _this._onLoginSuccessOff = function () { return; };
                        _this._onForcePasswordChangeOff = function () { return; };
                        _this._onPublicUserAccountCreatedOff = function () { return; };
                        _this.activateController();
                        return _this;
                    }
                    LoginPopupCtrl.prototype.close = function (isCloseProgramatic) {
                        this._onLoginSuccessOff();
                        this._onForcePasswordChangeOff();
                        this._onPublicUserAccountCreatedOff();
                        this._onLogin3rPartyAccountNotFoundOff();
                        this.initDataObj.isCreateAccountMode = false;
                        if (this.signIn3rdPartyAccountNotFoundErr) {
                            this.pulseContext.logoutGoogle();
                            this.is3rdPartyAccountNotFoundView = false;
                        }
                        _super.prototype.close.call(this);
                        if (!isCloseProgramatic && this.shouldNavigateBackOnClose) {
                            window.history.back();
                        }
                    };
                    LoginPopupCtrl.prototype.goBack = function () {
                        this.close();
                        window.history.back();
                    };
                    LoginPopupCtrl.prototype.open = function (size, initDataObj) {
                        var _this = this;
                        this.signIn3rdPartyAccountNotFoundErr = null;
                        initDataObj = initDataObj || {};
                        initDataObj = __assign(__assign({}, this._initDataObjDefault), initDataObj);
                        _super.prototype.open.call(this, size, initDataObj);
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        this.setLocalizedTexts();
                        this._onLoginSuccessOff = this.$scope.$on(Events.LoginSuccess, function () {
                            _this.close(true);
                        });
                        this._onForcePasswordChangeOff = this.$scope.$on(Events.ForcePasswordChange, function (evt, user, oldPassword) {
                            _this.onForcePasswordChange(user, oldPassword);
                        });
                        this._onLogin3rPartyAccountNotFoundOff = this.$scope.$on(Events.Login3rPartyAccountNotFound, function (evt, faileSignInEmail) {
                            if (!_this.signIn3rdPartyAccountNotFoundErr) {
                                _this.signIn3rdPartyAccountNotFoundErr = String.format(StringConst.Info_3rPartyAuth_GoogleAccountNotFound_Msg, faileSignInEmail);
                                if (!_this.hasCreateAccountDisabled) {
                                    _this.is3rdPartyAccountNotFoundView = true;
                                }
                            }
                        });
                    };
                    Object.defineProperty(LoginPopupCtrl.prototype, "shouldNavigateBackOnClose", {
                        get: function () {
                            return this.initDataObj.goBackOnCloseOfDialogByUser;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(LoginPopupCtrl.prototype, "isCreateAccountMode", {
                        get: function () {
                            return (this.initDataObj && this.initDataObj.isCreateAccountMode) && !this.hasCreateAccountDisabled;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(LoginPopupCtrl.prototype, "isLoginMode", {
                        get: function () {
                            return !this.isCreateAccountMode;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(LoginPopupCtrl.prototype, "isNewPasswordMode", {
                        get: function () {
                            return this.initDataObj.isNewPasswordMode;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(LoginPopupCtrl.prototype, "hasCreateAccountDisabled", {
                        get: function () {
                            return this.initDataObj.disableCreateAccount;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(LoginPopupCtrl.prototype, "title", {
                        get: function () {
                            if (this.is3rdPartyAccountNotFoundView || this.signIn3rdPartyAccountNotFoundErr) {
                                return "Account not found";
                            }
                            else if (this.isCreateAccountMode) {
                                return "Create an Account";
                            }
                            else {
                                return this.initDataObj ? this.initDataObj.title : this._title;
                            }
                        },
                        set: function (value) {
                            this._title = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    LoginPopupCtrl.prototype.onForcePasswordChange = function (userForPasswordChange, oldPassword) {
                        this.oldPassword = oldPassword;
                        this.userForPasswordChange = userForPasswordChange;
                        this.initDataObj.isCreateAccountMode = false;
                        this.initDataObj.isNewPasswordMode = true;
                    };
                    LoginPopupCtrl.prototype.toggleCreateAccount = function () {
                        this.initDataObj.isCreateAccountMode = !this.hasCreateAccountDisabled && !this.isCreateAccountMode;
                        this.is3rdPartyAccountNotFoundView = false;
                    };
                    LoginPopupCtrl.prototype.showLoginView = function () {
                        this.is3rdPartyAccountNotFoundView = false;
                        this.initDataObj.isCreateAccountMode = false;
                        this.initDataObj.disableCreateAccount = true;
                    };
                    LoginPopupCtrl.controllerId = 'LoginPopupCtrl';
                    return LoginPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                LoginPopup.LoginPopupCtrl = LoginPopupCtrl;
            })(LoginPopup = PulsePublic.LoginPopup || (PulsePublic.LoginPopup = {}));
            Pulse.app.directive(LoginPopup.directiveId, ['common', function (c) { return new LoginPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LoginPanelDir = (function (_super) {
                __extends(LoginPanelDir, _super);
                function LoginPanelDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'login/idp-login-panel.html';
                    _this.scope = {
                        isCreateAccountVisible: '=',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        LoginPanelDir.LoginPanelDirCtrl,
                    ];
                    return _this;
                }
                LoginPanelDir.directiveId = 'idpLoginPanel';
                return LoginPanelDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.LoginPanelDir = LoginPanelDir;
            (function (LoginPanelDir) {
                var ModalSize = Pulse.Common.BasePopup.ModalSize;
                var LoginPanelDirCtrl = (function (_super) {
                    __extends(LoginPanelDirCtrl, _super);
                    function LoginPanelDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LoginPanelDirCtrl.controllerId) || this;
                        _this.$scope.$on(Events.PublicUserAccountCreated, function (e, args) {
                            _this.common.showSuccess("You account has been created and you have been logged in. Your username is " + args.userName, { preventDuplicates: true });
                        });
                        _this.activateController();
                        return _this;
                    }
                    LoginPanelDirCtrl.prototype.openLoginModal = function () {
                        this.$scope.$broadcast(Events.ShowLoginPopup, {
                            initDataObj: this.getInitDataObj(),
                            size: ModalSize.Medium,
                        });
                    };
                    LoginPanelDirCtrl.prototype.openCreateAccountModal = function () {
                        this.$scope.$broadcast(Events.ShowLoginPopup, {
                            initDataObj: this.getInitDataObj(true),
                            size: ModalSize.Medium,
                        });
                    };
                    LoginPanelDirCtrl.prototype.getInitDataObj = function (createAcc) {
                        if (createAcc === void 0) { createAcc = false; }
                        var ubMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        var emailAddress = ubMgr.currentUBSession.userBrowsingDTO && ubMgr.currentUBSession.userBrowsingDTO.emailAddress
                            ? ubMgr.currentUBSession.userBrowsingDTO.emailAddress.trim()
                            : '';
                        return {
                            subTitle: "",
                            emailAddress: emailAddress,
                            isCreateAccountMode: createAcc,
                        };
                    };
                    LoginPanelDirCtrl.controllerId = 'LoginPanelDirCtrl';
                    LoginPanelDirCtrl._authChangeStateTimeout = 500;
                    return LoginPanelDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                LoginPanelDir.LoginPanelDirCtrl = LoginPanelDirCtrl;
                var ModalEnumActiveProp;
                (function (ModalEnumActiveProp) {
                    ModalEnumActiveProp["LOGIN"] = "loginModalIsActive";
                    ModalEnumActiveProp["CREATE_ACCOUNT"] = "createAccountModalIsActive";
                })(ModalEnumActiveProp = LoginPanelDir.ModalEnumActiveProp || (LoginPanelDir.ModalEnumActiveProp = {}));
            })(LoginPanelDir = PulsePublic.LoginPanelDir || (PulsePublic.LoginPanelDir = {}));
            Pulse.app.directive(LoginPanelDir.directiveId, [
                'common',
                function (c) { return new LoginPanelDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var ForgotPasswordPopup = (function (_super) {
                __extends(ForgotPasswordPopup, _super);
                function ForgotPasswordPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "ScrollLockService",
                        ForgotPasswordPopup.ForgotPasswordPopupCtrl];
                    return _this;
                }
                ForgotPasswordPopup.directiveId = "idpForgotPasswordPopup";
                return ForgotPasswordPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.ForgotPasswordPopup = ForgotPasswordPopup;
            (function (ForgotPasswordPopup) {
                var ForgotPasswordPopupCtrl = (function (_super) {
                    __extends(ForgotPasswordPopupCtrl, _super);
                    function ForgotPasswordPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, ForgotPasswordPopupCtrl.controllerId) || this;
                        _this.emailRegExpErrorMsg = PulseRegExp.EmailErrorMessage;
                        _this.captchaValidated = false;
                        _this.submitted = false;
                        _this.saveDisabled = false;
                        _this.formName = "frmForgotPassword";
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.event_ShowPopup = Events.ShowForgotPasswordPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "login/idp-forgot-password-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    ForgotPasswordPopupCtrl.prototype.getCaptChaResponse = function (res) {
                        this.captchaResponse = res + '_pulse';
                        this.captchaValidated = res.length > 0;
                    };
                    ForgotPasswordPopupCtrl.prototype.close = function (results) {
                        this.captchaValidated = false;
                        this.captchaResponse = null;
                        _super.prototype.close.call(this, results);
                    };
                    ForgotPasswordPopupCtrl.prototype.submit = function () {
                        var _this = this;
                        this.submitted = true;
                        this.saveDisabled = true;
                        if (this.myForm.$valid && this.captchaValidated) {
                            this.common.clearStatus();
                            this.common.toggleSpinner(true);
                            this.pulseContext.userMgr.forgotPWRetrieval(this.emailOrUserName, this.captchaResponse)
                                .then(function (result) {
                                if (result.success) {
                                    _this.common.$rootScope.$broadcast(Events.ShowResetPasswordPopup, {
                                        size: '',
                                        initDataObj: {
                                            'primaryEmail': result.message != null ? result.message.toString() : "",
                                            'userId': result.data != null ? result.data.toString() : ""
                                        }
                                    });
                                    _this.close();
                                }
                                else {
                                    _this.common.showWarning(result.message, { "timeOut": 0 });
                                }
                            })
                                .catch(function (err) {
                                _this.logError(err);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                                _this.saveDisabled = false;
                                _this.submitted = false;
                            });
                        }
                        else {
                            if (this.myForm.emailAddress.$valid && !this.captchaValidated) {
                                this.common.showWarning("Please validate that you are not a robot.");
                            }
                            this.saveDisabled = false;
                            this.submitted = false;
                        }
                    };
                    ForgotPasswordPopupCtrl.controllerId = 'ForgotPasswordPopupCtrl';
                    return ForgotPasswordPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                ForgotPasswordPopup.ForgotPasswordPopupCtrl = ForgotPasswordPopupCtrl;
            })(ForgotPasswordPopup = PulsePublic.ForgotPasswordPopup || (PulsePublic.ForgotPasswordPopup = {}));
            Pulse.app.directive(ForgotPasswordPopup.directiveId, ["common", function (c) { return new ForgotPasswordPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var ResetPasswordPopup = (function (_super) {
                __extends(ResetPasswordPopup, _super);
                function ResetPasswordPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "ScrollLockService",
                        ResetPasswordPopup.ResetPasswordPopupCtrl];
                    return _this;
                }
                ResetPasswordPopup.directiveId = "idpResetPasswordPopup";
                return ResetPasswordPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.ResetPasswordPopup = ResetPasswordPopup;
            (function (ResetPasswordPopup) {
                var ResetPasswordPopupCtrl = (function (_super) {
                    __extends(ResetPasswordPopupCtrl, _super);
                    function ResetPasswordPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, ResetPasswordPopupCtrl.controllerId) || this;
                        _this.passwordRegExp = PulseRegExp.Password;
                        _this.submitted = false;
                        _this.saveDisabled = false;
                        _this.formName = "frmResetPassword";
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.event_ShowPopup = Events.ShowResetPasswordPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "login/idp-reset-password-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    ResetPasswordPopupCtrl.prototype.onRendered = function () {
                        _super.prototype.onRendered.call(this);
                        this.stepNumber = 1;
                        if (this.initDataObj) {
                            this.resetCode = this.initDataObj.resetCode;
                            this.primaryEmail = this.initDataObj.primaryEmail;
                            this.userId = this.initDataObj.userId;
                            if (angular.isString(this.resetCode)) {
                                this.stepNumber = 2;
                            }
                        }
                        else {
                            this.common.$rootScope.$broadcast(Events.ShowForgotPasswordPopup, {
                                size: '',
                                initDataObj: {}
                            });
                            this.close();
                        }
                    };
                    ResetPasswordPopupCtrl.prototype.submit = function () {
                        var _this = this;
                        this.common.clearStatus();
                        this.submitted = true;
                        this.saveDisabled = true;
                        this.common.toggleSpinner(true);
                        if (this.stepNumber == 1) {
                            if (this.myForm.resetCode.$valid) {
                                this.pulseContext.userMgr.forgotPWValidateCode(this.userId, this.primaryEmail, this.resetCode)
                                    .then(function (result) {
                                    if (result.success) {
                                        _this.userId = result.data != null ? result.data.toString() : "0";
                                        _this.stepNumber = 2;
                                        _this.common.toggleSpinner(false);
                                    }
                                    else {
                                        _this.common.showWarning(result.message);
                                        _this.common.toggleSpinner(false);
                                    }
                                })
                                    .catch(function (err) {
                                    _this.logError(err);
                                    _this.common.toggleSpinner(false);
                                });
                            }
                            else {
                                var msgBuilder = new Pulse.Utils.HtmlListItemizer();
                                if (this.myForm.resetCode.$error.required) {
                                    msgBuilder.add("Reset code is required.");
                                }
                                if (this.myForm.resetCode.$error.minlength || this.myForm.resetCode.$error.maxlength) {
                                    msgBuilder.add("Reset code should be six digits.");
                                }
                                this.common.showWarning(msgBuilder.toString());
                                this.common.toggleSpinner(false);
                            }
                            this.saveDisabled = false;
                            this.submitted = false;
                            return;
                        }
                        if (this.stepNumber == 2) {
                            if (this.myForm.newPassword.$valid && this.myForm.newPasswordConfirm.$valid) {
                                this.pulseContext.userMgr.forgotPWUpdatePassword(this.userId, this.resetCode, this.newPassword, this.newPasswordConfirm)
                                    .then(function (result) {
                                    if (result.success) {
                                        _this.common.showSuccess("Your password was successfully changed. <br />You are now being logged in...");
                                        _this.close();
                                        _this.pulseContext.login(result.data != null ? result.data.toString() : _this.primaryEmail, _this.newPassword)
                                            .then(function (response) {
                                            _this.common.toggleSpinner(false);
                                        });
                                    }
                                    else {
                                        _this.common.showWarning(result.message);
                                        _this.common.toggleSpinner(false);
                                    }
                                })
                                    .catch(function (err) {
                                    _this.logError(err);
                                    _this.common.toggleSpinner(false);
                                });
                            }
                            else {
                                var msgBuilder = new Pulse.Utils.HtmlListItemizer();
                                if (this.myForm.newPassword.$error.required || this.myForm.newPasswordConfirm.$error.required) {
                                    msgBuilder.add("The password is required.");
                                }
                                if (this.myForm.newPassword.$error.pattern) {
                                    msgBuilder.add("The password is not valid.");
                                }
                                if (this.myForm.newPassword.$valid && this.myForm.newPasswordConfirm.$error.idpMatch) {
                                    msgBuilder.add("The passwords must match.");
                                }
                                this.common.showWarning(msgBuilder.toString());
                                this.common.toggleSpinner(false);
                            }
                            this.saveDisabled = false;
                            this.submitted = false;
                        }
                    };
                    ResetPasswordPopupCtrl.controllerId = "ResetPasswordPopupCtrl";
                    return ResetPasswordPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                ResetPasswordPopup.ResetPasswordPopupCtrl = ResetPasswordPopupCtrl;
            })(ResetPasswordPopup = PulsePublic.ResetPasswordPopup || (PulsePublic.ResetPasswordPopup = {}));
            Pulse.app.directive(ResetPasswordPopup.directiveId, ["common", function (c) { return new ResetPasswordPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var CreateAccountDir = (function (_super) {
                __extends(CreateAccountDir, _super);
                function CreateAccountDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot
                        + Paths.PulsePublicDirective
                        + 'login/idp-create-account.html';
                    _this.scope = {
                        emailAddress: '=?',
                        firstTabIndex: '=',
                        successCallback: '&',
                        show3rdPartySignin: '@?',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        CreateAccountDir.CreateAccountDirCtrl,
                    ];
                    return _this;
                }
                CreateAccountDir.directiveId = 'idpCreateAccount';
                return CreateAccountDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CreateAccountDir = CreateAccountDir;
            (function (CreateAccountDir) {
                var PulseTypeDAO = Pulse.Common.DataAccess.PulseTypeDAO;
                var CreateAccountDirCtrl = (function (_super) {
                    __extends(CreateAccountDirCtrl, _super);
                    function CreateAccountDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CreateAccountDirCtrl.controllerId) || this;
                        _this.show3rdPartySignin = true;
                        _this.emailRegExpErrorMsg = PulseRegExp.EmailErrorMessage;
                        _this.passwordRegExp = PulseRegExp.Password;
                        _this.passwordRegExpErrorMsg = PulseRegExp.PasswordErrorMessage;
                        _this.howHeardAboutTypes = null;
                        _this.howHeardAboutInput = '';
                        _this.selectedHowHeardAboutType = null;
                        _this.checkBoxStates = [];
                        _this.googleSigninSuccess = function (user) {
                            _this.common.toggleSpinner(true, null, null, 0);
                            var id_token = user.getAuthResponse().id_token;
                            _this.pulseContext.googleAuthenticate(id_token, true)
                                .then(function (result) {
                            })
                                .catch(function (reason) {
                                _this.show3rdPartySignin = false;
                                _this.common.$rootScope.$broadcast(Events.Login3rPartyAccountNotFound, user.getBasicProfile().getEmail());
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false, true);
                            });
                        };
                        _this.googleSigninFail = function (err) {
                            if (err && err.error && err.error == "popup_closed_by_user") {
                                return;
                            }
                            _this.common.showError(String.format(StringConst.Err_3rdParty_SignInFailure_Msg, "Google"));
                        };
                        _this.formName = 'createAccountForm';
                        return _this;
                    }
                    CreateAccountDirCtrl.prototype.$onInit = function () {
                        var _this = this;
                        var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        if (!this.emailAddress && userBrowsingMgr.currentUBSession.userBrowsingDTO && !String.isNullOrWhitespace(userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress)) {
                            this.emailAddress = userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress;
                        }
                        this.channelPreferenceMgr = new DataAccess.Managers.ChannelPreferenceMgr(this.common, this.breezeService, this.pulseContext);
                        this.activationPromises.push(this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.ContactMethodType.CellPhone, Enums.TypeClassType.ContactChannel)
                            .then(function (data) {
                            _this.phoneChannelTypes = data.sort(function (a, b) { return a.typeOrder < b.typeOrder ? -1 : a.typeOrder > b.typeOrder ? 1 : 0; });
                            _this.checkBoxStates = [];
                            _this.initCheckBoxStateByChannelTypes(_this.phoneChannelTypes);
                        }));
                        this.activationPromises.push(this.getHowHeardAboutUsTypes());
                        this.activateController();
                    };
                    CreateAccountDirCtrl.prototype.initCheckBoxStateByChannelTypes = function (channelTypes) {
                        for (var _i = 0, channelTypes_1 = channelTypes; _i < channelTypes_1.length; _i++) {
                            var ccType = channelTypes_1[_i];
                            this.checkBoxStates.push({
                                contactChannelType: ccType,
                                optOut: true,
                                newOptOut: true,
                            });
                        }
                    };
                    CreateAccountDirCtrl.prototype.showCreatePasswordHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Create Password', Directives.HelpPopup.HelpTopic.CreatePasswordHelp, 'createPasswordHelp');
                    };
                    CreateAccountDirCtrl.prototype.showPrivacyPolicy = function () {
                        this.common.$rootScope.$broadcast(Events.ShowPrivacyPolicyPopup, {
                            initDataObj: {},
                            size: Pulse.Common.BasePopup.ModalSize.Large,
                        });
                    };
                    CreateAccountDirCtrl.prototype.getHowHeardAboutUsTypes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var pulseTypeDAO = new PulseTypeDAO(this.common, this.breezeService, this.pulseContext);
                        return pulseTypeDAO.getActiveByParentTypeId(Enums.HowHeardAboutAudienceType.Client, null, true)
                            .then(function (data) {
                            _this.howHeardAboutTypes = data;
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    CreateAccountDirCtrl.prototype.combineFullPhone = function () {
                        return Pulse.Utils.JS.getDigits(this.phoneNumber);
                    };
                    CreateAccountDirCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.myForm.$valid) {
                            var smsTextMessageAlertsOptIn = false;
                            for (var _i = 0, _a = this.checkBoxStates; _i < _a.length; _i++) {
                                var chkBox = _a[_i];
                                if (!chkBox.newOptOut) {
                                    smsTextMessageAlertsOptIn = true;
                                    break;
                                }
                            }
                            this.breezeService.getEntityManager()
                                .rejectChanges();
                            this.common.clearStatus();
                            this.common.toggleSpinner(true);
                            var userDAO = new DataAccess.UserDAO(this.common, this.breezeService, this.pulseContext);
                            var newUser = userDAO.Create({
                                firstName: this.firstName,
                                lastName: this.lastName,
                                userName: this.emailAddress,
                                password: Pulse.Utils.JS.toHashSHA256Base64(this.password),
                            });
                            var ucmDAO = new DataAccess.UserContactMethodDAO(this.common, this.breezeService, this.pulseContext);
                            var newPrimaryPhone = ucmDAO.Create({
                                contactMethodTypeID: Enums.ContactMethodType.CellPhone,
                                countryCode: this.countryCode,
                                areaCode: this.areaCode,
                                number: this.phoneNumber,
                                optOut: !smsTextMessageAlertsOptIn,
                                isPrimaryNumber: true,
                            });
                            newPrimaryPhone.user = newUser;
                            if (this.selectedHowHeardAboutType != null) {
                                var hhaDAO = new DataAccess.HowHeardAboutDAO(this.common, this.breezeService, this.pulseContext);
                                var hha = hhaDAO.Create({
                                    selectionTypeID: this.selectedHowHeardAboutType.typeID,
                                    answerDetail: this.howHeardAboutInput || '',
                                });
                                hha.user = newUser;
                            }
                            this.pulseContext.userMgr.createPublicAccount(this.emailAddress)
                                .then(function (saveResult) {
                                var user = userDAO.getFromSaveResult(saveResult)[0];
                                if (angular.isObject(user) && user.userID > 0) {
                                    return _this.pulseContext.login(user.userName, _this.password);
                                }
                            })
                                .then(function () {
                                var channelPrefMgr = new DataAccess.Managers.ChannelPreferenceMgr(_this.common, _this.breezeService, _this.pulseContext);
                                var promises = [];
                                for (var _i = 0, _a = _this.checkBoxStates; _i < _a.length; _i++) {
                                    var chkbox = _a[_i];
                                    if (chkbox.newOptOut) {
                                        promises.push(channelPrefMgr.unsubscribeByUserID(_this.pulseContext.actingAsUserId, chkbox.contactChannelType.typeID, _this.combineFullPhone()));
                                    }
                                    else {
                                        promises.push(channelPrefMgr.subscribeByUserID(_this.pulseContext.actingAsUserId, chkbox.contactChannelType.typeID, _this.combineFullPhone()));
                                    }
                                }
                                return Promise.all(promises);
                            })
                                .then(function () {
                                _this.pulseContext.userMgr.isMissingInfoCompleted = true;
                                _this.common.$rootScope.$broadcast(Events.PublicUserAccountCreated, { userName: _this.emailAddress });
                            })
                                .catch(function (err) {
                                _this.logError(err);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                                _this.breezeService.getEntityManager()
                                    .rejectChanges();
                            });
                        }
                    };
                    CreateAccountDirCtrl.controllerId = 'CreateAccountDirCtrl';
                    return CreateAccountDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CreateAccountDir.CreateAccountDirCtrl = CreateAccountDirCtrl;
            })(CreateAccountDir = PulsePublic.CreateAccountDir || (PulsePublic.CreateAccountDir = {}));
            Pulse.app.directive(CreateAccountDir.directiveId, [
                'common',
                function (c) { return new CreateAccountDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var MissingInfoPopup = (function (_super) {
                __extends(MissingInfoPopup, _super);
                function MissingInfoPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "ScrollLockService",
                        MissingInfoPopup.MissingInfoPopupCtrl];
                    return _this;
                }
                MissingInfoPopup.directiveId = "idpMissingInfoPopup";
                return MissingInfoPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.MissingInfoPopup = MissingInfoPopup;
            (function (MissingInfoPopup) {
                var MissingInfoPopupCtrl = (function (_super) {
                    __extends(MissingInfoPopupCtrl, _super);
                    function MissingInfoPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, MissingInfoPopupCtrl.controllerId) || this;
                        _this.initDataObj = {
                            firstTabIndex: 100,
                        };
                        _this.firstTabIndex = _this.initDataObj.firstTabIndex;
                        _this.isEmailReadOnly = false;
                        _this.emailRegExpErrorMsg = PulseRegExp.EmailErrorMessage;
                        _this.checkBoxStates = [];
                        _this.setPopupProperties();
                        _this.channelPreferenceMgr = new DataAccess.Managers.ChannelPreferenceMgr(common, breezeService, pulseContext);
                        _this.activationPromises.push(_this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.ContactMethodType.CellPhone, Enums.TypeClassType.ContactChannel)
                            .then(function (data) {
                            _this.phoneChannelTypes = data.sort(function (a, b) { return a.typeOrder < b.typeOrder ? -1 : a.typeOrder > b.typeOrder ? 1 : 0; });
                        }));
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(MissingInfoPopupCtrl.prototype, "missingAcknowledgementErrorName", {
                        get: function () {
                            return "missingAck";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    MissingInfoPopupCtrl.prototype.setPopupProperties = function () {
                        this.formName = "frmMissingInfo";
                        this.title = "Add or Update Information";
                        this.event_ShowPopup = Events.ShowMissingInfoPopup;
                        this.popupTemplateUrl = this.common.config.appRoot + Paths.PulsePublicDirective + "login/idp-missing-info-popup.html";
                    };
                    MissingInfoPopupCtrl.prototype.close = function () {
                        _super.prototype.close.call(this);
                    };
                    MissingInfoPopupCtrl.prototype.open = function (size, initDataObj) {
                        return __awaiter(this, void 0, void 0, function () {
                            var promises, user, self_1;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.setPopupProperties();
                                        _super.prototype.open.call(this, size, initDataObj);
                                        this.initDataObj = initDataObj;
                                        if (initDataObj) {
                                            if (initDataObj.firstTabIndex)
                                                this.initDataObj.firstTabIndex = initDataObj.firstTabIndex;
                                        }
                                        this.breezeService.getEntityManager().rejectChanges();
                                        if (this.myForm) {
                                            this.myForm.$setPristine();
                                        }
                                        this.setLocalizedTexts();
                                        promises = [];
                                        user = this.pulseContext.actingAsUser;
                                        if (user) {
                                            this.firstName = user.firstName;
                                            this.lastName = user.lastName;
                                            if (!this.pulseContext.userMgr.contactMethodsForActingAsUser) {
                                                this.common.toggleSpinner(true);
                                                self_1 = this;
                                                promises.push(this.pulseContext.userMgr.loadContactMethodsForActingUser(true)
                                                    .then(function (ucms) {
                                                    self_1.getContactMethods(_this.pulseContext.actingAsUserId);
                                                })
                                                    .catch(function (err) {
                                                    self_1.logError(err);
                                                })
                                                    .finally(function () {
                                                    self_1.common.toggleSpinner(false);
                                                }));
                                            }
                                            else {
                                                this.getContactMethods(this.pulseContext.actingAsUserId);
                                            }
                                        }
                                        else {
                                            this.logError("this.pulseContext.actingAsUser is not defined.");
                                        }
                                        return [4, Promise.all(promises)];
                                    case 1:
                                        _a.sent();
                                        return [4, this.channelPreferenceMgr.getContactChannelsByUserID(this.pulseContext.actingAsUserId)
                                                .then(function (data) {
                                                _this.contactChannels = data;
                                                _this.checkBoxStates = [];
                                                _this.initCheckBoxStateByMethodsAndChannels(_this.primaryPhone.fullPhone, _this.phoneChannelTypes);
                                            })];
                                    case 2:
                                        _a.sent();
                                        return [2];
                                }
                            });
                        });
                    };
                    MissingInfoPopupCtrl.prototype.getContactMethods = function (userID) {
                        var ucmDAO = new DataAccess.UserContactMethodDAO(this.common, this.breezeService, this.pulseContext);
                        var userContactMethods = this.pulseContext.userMgr.contactMethodsForActingAsUser;
                        var emails = ucmDAO.selectContactMethodsByTypeSorted(userContactMethods, Enums.ContactMethodType.Email);
                        if (emails && emails.length) {
                            this.emailAddress = emails[0].contactMethodOther;
                        }
                        else {
                            this.emailAddress = null;
                        }
                        this.isEmailReadOnly = String.isNullOrWhitespace(this.emailAddress) ? false : (this.emailAddress.toLowerCase() == this.pulseContext.actingAsUser.userName.toLowerCase());
                        var cellPhones = ucmDAO.selectContactMethodsByTypeSorted(userContactMethods, Enums.ContactMethodType.CellPhone);
                        if (cellPhones && cellPhones.length) {
                            this.primaryPhone = cellPhones[0];
                            var currentCountryCode = this.primaryPhone.countryCode;
                            this.countryCode = currentCountryCode ? currentCountryCode : null;
                            this.phoneNumber = "+" + this.primaryPhone.fullPhone.match(/\d+/)[0];
                        }
                        else {
                            this.countryCode = "1";
                            this.phoneNumber = null;
                        }
                    };
                    MissingInfoPopupCtrl.prototype.initCheckBoxStateByMethodsAndChannels = function (phoneContactMethod, channelTypes) {
                        var _loop_1 = function (ccType) {
                            var ccArr = this_1.contactChannels
                                ? this_1.contactChannels.filter(function (cc) { return cc.contactChannelTypeID == ccType.typeID
                                    && cc.contactMethodTypeID != Enums.ContactMethodType.Other
                                    && cc.contactMethod == phoneContactMethod; })
                                : null;
                            if (ccArr === null || ccArr === void 0 ? void 0 : ccArr.length) {
                                for (var _i = 0, ccArr_1 = ccArr; _i < ccArr_1.length; _i++) {
                                    var channel = ccArr_1[_i];
                                    this_1.checkBoxStates.push(__assign(__assign({}, channel), { contactChannelType: ccType, newOptOut: channel.optOut }));
                                }
                            }
                        };
                        var this_1 = this;
                        for (var _i = 0, channelTypes_1 = channelTypes; _i < channelTypes_1.length; _i++) {
                            var ccType = channelTypes_1[_i];
                            _loop_1(ccType);
                        }
                    };
                    MissingInfoPopupCtrl.prototype.saveAndContinue = function () {
                        var _this = this;
                        if (this.myForm.$valid) {
                            var smsTextMessageAlertsOptIn = false;
                            for (var _i = 0, _a = this.checkBoxStates; _i < _a.length; _i++) {
                                var chkBox = _a[_i];
                                if (!chkBox.newOptOut) {
                                    smsTextMessageAlertsOptIn = true;
                                    break;
                                }
                            }
                            var missingInfo = {
                                userID: this.pulseContext.actingAsUser.userID,
                                firstName: this.firstName,
                                lastName: this.lastName,
                                emailAddress: this.emailAddress,
                                countryCode: parseInt(this.countryCode),
                                areaCode: null,
                                phoneNumber: this.phoneNumber,
                                hasOptedInForSMSTextMessageAlerts: smsTextMessageAlertsOptIn,
                            };
                            this.common.toggleSpinner(true);
                            var self = this;
                            this.pulseContext.userMgr.userUpdateMissingInfo(missingInfo)
                                .then(function (actingAsUser) {
                                self.myForm.$setPristine();
                                return self.pulseContext.refreshUserInfo();
                            })
                                .then(function (data) {
                                return self.pulseContext.userMgr.loadContactMethodsForActingUser(true);
                            })
                                .then(function () {
                                _this.getContactMethods(_this.pulseContext.actingAsUserId);
                                var channelPrefMgr = new DataAccess.Managers.ChannelPreferenceMgr(_this.common, _this.breezeService, _this.pulseContext);
                                var promises = [];
                                for (var _i = 0, _a = _this.checkBoxStates; _i < _a.length; _i++) {
                                    var chkbox = _a[_i];
                                    if (chkbox.optOut != chkbox.newOptOut) {
                                        if (chkbox.contactMethodTypeID != Enums.ContactMethodType.Other) {
                                            if (chkbox.newOptOut) {
                                                promises.push(channelPrefMgr.unsubscribeByUserID(_this.pulseContext.actingAsUserId, chkbox.contactChannelTypeID, _this.primaryPhone.fullPhone));
                                            }
                                            else {
                                                promises.push(channelPrefMgr.subscribeByUserID(_this.pulseContext.actingAsUserId, chkbox.contactChannelTypeID, _this.primaryPhone.fullPhone));
                                            }
                                        }
                                    }
                                }
                                return Promise.all(promises);
                            })
                                .then(function (data) {
                                self.pulseContext.userMgr.isMissingInfoCompleted = true;
                                self.common.$rootScope.$broadcast(Events.MissingInfoSuccess);
                                self.close();
                            })
                                .catch(function (err) {
                                self.logError(err, ["System.ArgumentException"]);
                            })
                                .finally(function () {
                                self.common.toggleSpinner(false);
                            });
                        }
                    };
                    MissingInfoPopupCtrl.controllerId = "MissingInfoPopupCtrl";
                    return MissingInfoPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                MissingInfoPopup.MissingInfoPopupCtrl = MissingInfoPopupCtrl;
            })(MissingInfoPopup = PulsePublic.MissingInfoPopup || (PulsePublic.MissingInfoPopup = {}));
            Pulse.app.directive(MissingInfoPopup.directiveId, ["common", function (c) { return new MissingInfoPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            "use strict";
            var NewPasswordDir = (function (_super) {
                __extends(NewPasswordDir, _super);
                function NewPasswordDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "login/idp-new-password.html";
                    _this.scope = {
                        isActive: "@",
                        oldPassword: "=",
                        user: "="
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        NewPasswordDir.NewPasswordDirCtrl];
                    return _this;
                }
                NewPasswordDir.directiveId = "idpNewPassword";
                return NewPasswordDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.NewPasswordDir = NewPasswordDir;
            (function (NewPasswordDir) {
                var NewPasswordDirCtrl = (function (_super) {
                    __extends(NewPasswordDirCtrl, _super);
                    function NewPasswordDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, NewPasswordDirCtrl.controllerId) || this;
                        _this._isActive = false;
                        _this._oldPassword = null;
                        _this.isSubmitButtonDisabled = false;
                        _this.passwordRegExp = PulseRegExp.Password;
                        _this.passwordRegExpErrorMsg = PulseRegExp.PasswordErrorMessage;
                        _this.formName = "newPasswordForm";
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.newPassword = "";
                        _this.submitted = false;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(NewPasswordDirCtrl.prototype, "isActive", {
                        set: function (b) {
                            this._isActive = b;
                            window.setTimeout(function () {
                                var o = document.getElementById('newPassword');
                                if (o) {
                                    o.focus();
                                }
                            }, 500);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(NewPasswordDirCtrl.prototype, "oldPassword", {
                        get: function () {
                            return this._oldPassword;
                        },
                        set: function (s) {
                            this._oldPassword = s;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    NewPasswordDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl, transclude) {
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl, transclude);
                    };
                    NewPasswordDirCtrl.prototype.showCreatePasswordHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Create Password", Directives.HelpPopup.HelpTopic.CreatePasswordHelp, "createPasswordHelp");
                    };
                    NewPasswordDirCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.newPassword === this.oldPassword) {
                            this.common.showError("Your new password cannot be the same as your old password.", true);
                            return;
                        }
                        this.isSubmitButtonDisabled = true;
                        if (this.myForm.$valid) {
                            this.common.clearStatus();
                            this.common.toggleSpinner(true, null, null, 0);
                            var self = this;
                            this.pulseContext.userMgr.setNewPassword(self.user.userID, self.newPassword)
                                .then(function (response) {
                                self.myForm.$setPristine();
                                return self.pulseContext.login(self.user.userName, self.newPassword, false);
                            })
                                .catch(function (err) {
                                self.logError(err);
                                self.isSubmitButtonDisabled = false;
                                self.newPassword = "";
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                        else {
                            this.isSubmitButtonDisabled = false;
                        }
                    };
                    NewPasswordDirCtrl.controllerId = "NewPasswordDirCtrl";
                    return NewPasswordDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                NewPasswordDir.NewPasswordDirCtrl = NewPasswordDirCtrl;
            })(NewPasswordDir = PulsePublic.NewPasswordDir || (PulsePublic.NewPasswordDir = {}));
            Pulse.app.directive(NewPasswordDir.directiveId, ["common", function (c) { return new NewPasswordDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AuthAccountNotFoundDir = (function (_super) {
                __extends(AuthAccountNotFoundDir, _super);
                function AuthAccountNotFoundDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot
                        + Paths.PulsePublicDirective
                        + 'login/idp-auth-account-not-found.html';
                    _this.scope = {
                        firstTabIndex: '=',
                        showLoginView: '&',
                        isVisible: '=',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        AuthAccountNotFoundDir.AuthAccountNotFoundDirCtrl,
                    ];
                    return _this;
                }
                AuthAccountNotFoundDir.directiveId = 'idpAuthAccountNotFound';
                return AuthAccountNotFoundDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AuthAccountNotFoundDir = AuthAccountNotFoundDir;
            (function (AuthAccountNotFoundDir) {
                var AuthAccountNotFoundDirCtrl = (function (_super) {
                    __extends(AuthAccountNotFoundDirCtrl, _super);
                    function AuthAccountNotFoundDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        return _super.call(this, $scope, $location, common, breezeService, pulseContext, AuthAccountNotFoundDirCtrl.controllerId) || this;
                    }
                    AuthAccountNotFoundDirCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.isVisible;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                Pulse.Utils.GoogleAuthUtil.GetAuthInstance(_this.common.config.googleAPI_ClientID)
                                    .then(function (googleAuthInst) {
                                    if (googleAuthInst.isSignedIn.get()) {
                                        var googleUser = googleAuthInst.currentUser.get();
                                        if (googleUser) {
                                            var profile = googleUser.getBasicProfile();
                                            _this.fullName = profile.getName();
                                            _this.email = profile.getEmail();
                                        }
                                    }
                                }).catch(function (e) {
                                    return;
                                });
                            }
                        });
                    };
                    AuthAccountNotFoundDirCtrl.prototype.onGoToLoginClick = function () {
                        this.showLoginView();
                    };
                    AuthAccountNotFoundDirCtrl.prototype.onCreateAccountClick = function () {
                        var _this = this;
                        this.common.toggleSpinner(true, true, null, 0);
                        Pulse.Utils.GoogleAuthUtil.GetAuthInstance(this.common.config.googleAPI_ClientID)
                            .then(function (googleAuthInst) {
                            var id_token = googleAuthInst.currentUser.get().getAuthResponse().id_token;
                            return _this.pulseContext.googleAuthenticate(id_token, true);
                        })
                            .catch(function (e) {
                            return;
                        })
                            .then(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    AuthAccountNotFoundDirCtrl.controllerId = 'AuthAccountNotFoundDirCtrl';
                    return AuthAccountNotFoundDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AuthAccountNotFoundDir.AuthAccountNotFoundDirCtrl = AuthAccountNotFoundDirCtrl;
            })(AuthAccountNotFoundDir = PulsePublic.AuthAccountNotFoundDir || (PulsePublic.AuthAccountNotFoundDir = {}));
            Pulse.app.directive(AuthAccountNotFoundDir.directiveId, [
                'common',
                function (c) { return new AuthAccountNotFoundDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AuthWithThirdPartyDir = (function (_super) {
                __extends(AuthWithThirdPartyDir, _super);
                function AuthWithThirdPartyDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'login/idp-auth-with-third-party.html';
                    _this.scope = {
                        googleButtonText: '@?',
                        googleSigninSuccessFn: '=',
                        googleSigninFailFn: '=',
                        show3rdPartySignin: '=?'
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        AuthWithThirdPartyDir.AuthWithThirdPartyDirCtrl,
                    ];
                    return _this;
                }
                AuthWithThirdPartyDir.directiveId = 'idpAuthWithThirdParty';
                return AuthWithThirdPartyDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AuthWithThirdPartyDir = AuthWithThirdPartyDir;
            (function (AuthWithThirdPartyDir) {
                var AuthWithThirdPartyDirCtrl = (function (_super) {
                    __extends(AuthWithThirdPartyDirCtrl, _super);
                    function AuthWithThirdPartyDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AuthWithThirdPartyDirCtrl.controllerId) || this;
                        _this.googleButtonText = "Sign in with Google";
                        _this.show3rdPartySignin = true;
                        _this.activateController();
                        return _this;
                    }
                    AuthWithThirdPartyDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl, transclude);
                        this.init3rdPartySignIn();
                        scope.$watch(function (scope) {
                            return _this.show3rdPartySignin;
                        }, function (newVal, oldVal) {
                            if (newVal !== oldVal && newVal) {
                                _this.init3rdPartySignIn();
                            }
                        }, true);
                    };
                    AuthWithThirdPartyDirCtrl.prototype.init3rdPartySignIn = function () {
                        var _this = this;
                        if (!this.show3rdPartySignin) {
                            return;
                        }
                        Pulse.Utils.GoogleAuthUtil.GetAuthInstance(this.common.config.googleAPI_ClientID)
                            .then(function (googleAuthInst) {
                            if (!_this.pulseContext.isLoggedIn || !googleAuthInst.isSignedIn.get()) {
                                var element = document.getElementById('google-signin-button');
                                googleAuthInst.attachClickHandler(element, {}, function (user) { return _this.googleSigninSuccessFn(user); }, function (err) { return _this.googleSigninFailFn(err); });
                            }
                            else {
                                _this.show3rdPartySignin = false;
                            }
                        }).catch(function (e) {
                            _this.show3rdPartySignin = false;
                        });
                    };
                    Object.defineProperty(AuthWithThirdPartyDirCtrl.prototype, "googleLogoUrl", {
                        get: function () {
                            return this.common.config.appRoot + 'assets/images/icons/google/google-sign-in.svg';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AuthWithThirdPartyDirCtrl.controllerId = 'AuthWithThirdPartyDirCtrl';
                    return AuthWithThirdPartyDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AuthWithThirdPartyDir.AuthWithThirdPartyDirCtrl = AuthWithThirdPartyDirCtrl;
            })(AuthWithThirdPartyDir = PulsePublic.AuthWithThirdPartyDir || (PulsePublic.AuthWithThirdPartyDir = {}));
            Pulse.app.directive(AuthWithThirdPartyDir.directiveId, [
                'common',
                function (c) { return new AuthWithThirdPartyDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var PageHeaderDir = (function (_super) {
                __extends(PageHeaderDir, _super);
                function PageHeaderDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "page-header/idp-page-header.html";
                    _this.restrict = "E";
                    _this.scope = {
                        showBackBtn: "=",
                        pageTitle: "@",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        PageHeaderDir.PageHeaderDirCtrl];
                    return _this;
                }
                PageHeaderDir.directiveId = "idpPageHeader";
                return PageHeaderDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.PageHeaderDir = PageHeaderDir;
            (function (PageHeaderDir) {
                var PageHeaderDirCtrl = (function (_super) {
                    __extends(PageHeaderDirCtrl, _super);
                    function PageHeaderDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        return _super.call(this, $scope, $location, common, breezeService, pulseContext, PageHeaderDirCtrl.controllerId) || this;
                    }
                    PageHeaderDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls, transclude);
                    };
                    PageHeaderDirCtrl.controllerId = "idpPageHeaderCtrl";
                    return PageHeaderDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                PageHeaderDir.PageHeaderDirCtrl = PageHeaderDirCtrl;
            })(PageHeaderDir = PulsePublic.PageHeaderDir || (PulsePublic.PageHeaderDir = {}));
            Pulse.app.directive(PageHeaderDir.directiveId, ["common", function (c) { return new PageHeaderDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var TopNavDir = (function (_super) {
                __extends(TopNavDir, _super);
                function TopNavDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "top-nav/idp-top-nav.html";
                    _this.scope = {
                        selected: "=itemSelected"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        TopNavDir.TopNavDirCtrl];
                    return _this;
                }
                TopNavDir.directiveId = "idpTopNav";
                return TopNavDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.TopNavDir = TopNavDir;
            (function (TopNavDir) {
                var TopNavItemType;
                (function (TopNavItemType) {
                    TopNavItemType[TopNavItemType["Home"] = 1] = "Home";
                    TopNavItemType[TopNavItemType["Profile"] = 2] = "Profile";
                    TopNavItemType[TopNavItemType["Billing"] = 3] = "Billing";
                    TopNavItemType[TopNavItemType["Forms"] = 4] = "Forms";
                })(TopNavItemType = TopNavDir.TopNavItemType || (TopNavDir.TopNavItemType = {}));
                var TopNavDirCtrl = (function (_super) {
                    __extends(TopNavDirCtrl, _super);
                    function TopNavDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, TopNavDirCtrl.controllerId) || this;
                        _this.showHome = true;
                        _this.showForms = true;
                        _this.showBilling = true;
                        _this.showProfile = true;
                        _this.TopNavItemType = TopNavDir.TopNavItemType;
                        return _this;
                    }
                    TopNavDirCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.activationPromises.push(this.pulseContext.userMgr.loadRelatedUsersForActingUser(false)
                            .then(function (relatedUsers) {
                            for (var _i = 0, relatedUsers_1 = relatedUsers; _i < relatedUsers_1.length; _i++) {
                                var u = relatedUsers_1[_i];
                                if (u.userRelationTypeID === Enums.UserRelationshipType.GroupManager) {
                                    _this.showHome =
                                        _this.showBilling =
                                            _this.showProfile = false;
                                    return;
                                }
                            }
                        }));
                        this.activateController();
                    };
                    TopNavDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls);
                        var actingAsUser = this.pulseContext.actingAsUser;
                        if (actingAsUser) {
                            if (angular.isDefined(actingAsUser.firstName)
                                && actingAsUser.firstName.length > 0) {
                                this.firstOrUserName = actingAsUser.firstName;
                            }
                            else {
                                this.firstOrUserName = actingAsUser.userName;
                            }
                        }
                    };
                    TopNavDirCtrl.prototype.onLogoutClick = function () {
                        this.common.$location.url(Routes.Logout);
                    };
                    TopNavDirCtrl.prototype.securityCheck = function () {
                        this.canSee = true;
                    };
                    TopNavDirCtrl.prototype.secureAllFeatures = function () {
                    };
                    TopNavDirCtrl.controllerId = "idpTopNavCtrl";
                    return TopNavDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                TopNavDir.TopNavDirCtrl = TopNavDirCtrl;
            })(TopNavDir = PulsePublic.TopNavDir || (PulsePublic.TopNavDir = {}));
            Pulse.app.directive(TopNavDir.directiveId, ["common", function (c) { return new TopNavDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AlertsDir = (function (_super) {
                __extends(AlertsDir, _super);
                function AlertsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "alerts/idp-alerts.html";
                    _this.scope = {
                        alertList: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        AlertsDir.AlertDirCtrl];
                    return _this;
                }
                AlertsDir.directiveId = "idpAlerts";
                return AlertsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AlertsDir = AlertsDir;
            (function (AlertsDir) {
                var AlertDirCtrl = (function (_super) {
                    __extends(AlertDirCtrl, _super);
                    function AlertDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        return _super.call(this, $scope, $location, common, breezeService, pulseContext, AlertDirCtrl.controllerId) || this;
                    }
                    ;
                    AlertDirCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.activationPromises.push(this.pulseContext.userMgr.loadRelatedUsersForActingUser(false)
                            .then(function (relatedUsers) {
                            for (var _i = 0, relatedUsers_1 = relatedUsers; _i < relatedUsers_1.length; _i++) {
                                var u = relatedUsers_1[_i];
                                if (u.userRelationTypeID === Enums.UserRelationshipType.GroupManager) {
                                    _this.canSee = false;
                                    return;
                                }
                            }
                        }));
                        this.activateController();
                    };
                    AlertDirCtrl.prototype.securityCheck = function () {
                        this.canUpdate = !this.pulseContext.isImpersonating
                            || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance, Enums.UserRoleType.HR, Enums.UserRoleType.IT, Enums.UserRoleType.OnlineInstructor, Enums.UserRoleType.OPLStaff);
                        this.canSee = this.canUpdate
                            || this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate);
                    };
                    AlertDirCtrl.controllerId = "alertDirCtrl";
                    return AlertDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AlertsDir.AlertDirCtrl = AlertDirCtrl;
            })(AlertsDir = PulsePublic.AlertsDir || (PulsePublic.AlertsDir = {}));
            Pulse.app.directive(AlertsDir.directiveId, ["common", function (c) { return new AlertsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var FooterDir = (function (_super) {
                __extends(FooterDir, _super);
                function FooterDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "footer/idp-footer.html";
                    _this.scope = {
                        canSeeReferAFriend: "<",
                        canUpdate: "<",
                        hasReferAFriend: "<",
                        showSimple: "<?",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        FooterDir.FooterDirCtrl];
                    return _this;
                }
                FooterDir.directiveId = "idpFooter";
                return FooterDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.FooterDir = FooterDir;
            (function (FooterDir) {
                var FooterDirCtrl = (function (_super) {
                    __extends(FooterDirCtrl, _super);
                    function FooterDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, FooterDirCtrl.controllerId) || this;
                        _this.hasMadePurchaseBefore = false;
                        _this.hasRelatedUsers = false;
                        _this.customerMgr = _this.pulseContext.customerMgr;
                        return _this;
                    }
                    FooterDirCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.activationPromises.push(this.customerMgr.loadStatusAndAlerts(false)
                            .then(function () {
                            _this.hasMadePurchaseBefore = _this.customerMgr.isStatus(DataAccess.Managers.CustomerMgr.CustomerStatusTypeMask.HasMadePurchaseBefore);
                        }));
                        this.activationPromises.push(this.pulseContext.userMgr.loadRelatedUsersForActingUser(false)
                            .then(function (relatedUsers) {
                            _this.hasRelatedUsers = relatedUsers ? relatedUsers.length > 0 : false;
                        }));
                        this.activateController();
                    };
                    FooterDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls);
                        var company = this.pulseContext.company;
                        this.companyName = company.companyName;
                        this.companyTaxId = company.taxID;
                        this.currentTermGroup = this.pulseContext.currentTermGroup;
                        this.imgSrcAddWeek = this.common.config.appRoot + "assets/images/addweek.png";
                        this.imgSrcRefer = this.common.config.appRoot + "assets/images/raf.png";
                        this.imgSrcTechRocket = this.common.config.appRoot + "assets/images/techrocket.png";
                        this.imgSrcTechRocketWord = this.common.config.appRoot + "assets/images/techrocketword.png";
                        this.imgSrcTax = this.common.config.appRoot + "assets/images/tax.png";
                        this.rafUrl = "#/my-account/refer-a-friend/raf";
                    };
                    FooterDirCtrl.prototype.onOnlineLessonsAdminRedirectClick = function () {
                        this.common.$location.url(Routes.MyAccount_OPLOnlineSessions);
                    };
                    FooterDirCtrl.prototype.onOplAdminPurchaseClick = function () {
                        this.common.$location.url(Routes.MyAccount_OPLPurchase);
                    };
                    FooterDirCtrl.prototype.onSemAdminPurchaseClick = function () {
                        this.common.$location.url(Routes.MyAccount_SEMPurchase);
                    };
                    FooterDirCtrl.prototype.onOnlineLessonsRedirectClick = function () {
                        this.common.$location.url(Routes.MyAccount_OPLOnlineSessionsClient);
                    };
                    FooterDirCtrl.prototype.onOnlineLessonsClick = function () {
                        this.pulseContext.regFlowMgr = null;
                        this.pulseContext.shoppingCartType = Enums.ShoppingCartType.RegFlow;
                        this.common.$location.url(Routes.RegFlow_Upsell);
                    };
                    FooterDirCtrl.prototype.onRegisterClick = function () {
                        var _this = this;
                        var ubMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        if (ubMgr.hasChangeItems(ubMgr.currentUBSession)) {
                            this.common.showConfirmation("Pending Changes", "You have other pending changes.<br>\n                        <br>Click Yes to complete the pending changes in Shopping Cart.\n                        <br>Click No to start new Shopping Cart.", function (confirm) {
                                if (confirm) {
                                    _this.pulseContext.regFlowMgr.goToStepByEnum(DataAccess.Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                                }
                                else {
                                    _this.goRegister();
                                }
                            }, { size: 'md' });
                        }
                        else {
                            this.goRegister();
                        }
                    };
                    FooterDirCtrl.prototype.goRegister = function () {
                        this.pulseContext.regFlowMgr = null;
                        if (!this.pulseContext.inWWW) {
                            this.pulseContext.shoppingCartType = Enums.ShoppingCartType.RegFlow;
                            this.common.$location.url(Routes.RegFlow_Default);
                        }
                        else {
                            window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                        }
                    };
                    FooterDirCtrl.prototype.securityCheck = function () {
                        this.canSee = true;
                    };
                    FooterDirCtrl.prototype.secureAllFeatures = function () {
                        this.canSeeOPLSessions = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.Corporate, 1, 2, Enums.UserRoleType.OnlineInstructor, Enums.UserRoleType.OPLStaff, Enums.UserRoleType.Public);
                    };
                    FooterDirCtrl.controllerId = "idpFooterCtrl";
                    return FooterDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                FooterDir.FooterDirCtrl = FooterDirCtrl;
            })(FooterDir = PulsePublic.FooterDir || (PulsePublic.FooterDir = {}));
            Pulse.app.directive(FooterDir.directiveId, ["common", function (c) { return new FooterDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var PersonalInfoDir = (function (_super) {
                __extends(PersonalInfoDir, _super);
                function PersonalInfoDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "contact-info/idp-personal-info.html";
                    _this.scope = {
                        user: "=",
                        firstTabIndex: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        PersonalInfoDir.PersonalInfoDirCtrl];
                    return _this;
                }
                PersonalInfoDir.directiveId = "idpPersonalInfo";
                return PersonalInfoDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.PersonalInfoDir = PersonalInfoDir;
            (function (PersonalInfoDir) {
                var PersonalInfoDirCtrl = (function (_super) {
                    __extends(PersonalInfoDirCtrl, _super);
                    function PersonalInfoDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, PersonalInfoDirCtrl.controllerId) || this;
                        _this.id = PersonalInfoDirCtrl._instanceCount++;
                        _this.formName = "idpPersonInfoForm" + _this.id;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.activateController();
                        return _this;
                    }
                    PersonalInfoDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        this.myForm = scope[this.formName];
                        var parentCtrl = (scope.$parent).vm;
                    };
                    PersonalInfoDirCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.user;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                if (newVal.userID != _this.pulseContext.actingAsUserId) {
                                    _this.canCreate = false;
                                    _this.canUpdate = false;
                                }
                            }
                        });
                    };
                    PersonalInfoDirCtrl.controllerId = "idpPersonalInfoCtrl";
                    PersonalInfoDirCtrl._instanceCount = 0;
                    return PersonalInfoDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                PersonalInfoDir.PersonalInfoDirCtrl = PersonalInfoDirCtrl;
            })(PersonalInfoDir = PulsePublic.PersonalInfoDir || (PulsePublic.PersonalInfoDir = {}));
            Pulse.app.directive(PersonalInfoDir.directiveId, ["common", function (c) { return new PersonalInfoDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var MailingAddressDir = (function (_super) {
                __extends(MailingAddressDir, _super);
                function MailingAddressDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "contact-info/idp-mailing-address.html";
                    _this.scope = {
                        address: "=",
                        firstTabIndex: "<",
                        showPromotionsAndNewsCheckbox: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        MailingAddressDir.MailingAddressDirCtrl];
                    return _this;
                }
                MailingAddressDir.directiveId = "idpMailingAddress";
                return MailingAddressDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.MailingAddressDir = MailingAddressDir;
            (function (MailingAddressDir) {
                var MailingAddressDirCtrl = (function (_super) {
                    __extends(MailingAddressDirCtrl, _super);
                    function MailingAddressDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, MailingAddressDirCtrl.controllerId) || this;
                        _this.countryTypes = null;
                        _this.stateTypes = null;
                        _this.id = MailingAddressDirCtrl._instanceCount++;
                        _this.formName = "idpMailingAddressForm" + _this.id;
                        _this.checkUnsavedDataBeforeNav = false;
                        return _this;
                    }
                    MailingAddressDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.getCountryTypes());
                        this.activationPromises.push(this.getStateTypes());
                        this.activateController();
                    };
                    MailingAddressDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        this.myForm = scope[this.formName];
                        var parentCtrl = (scope.$parent).vm;
                    };
                    MailingAddressDirCtrl.prototype.countryTypeChanged = function () {
                        this.address.countryTypeID = this.address.countryType.typeID;
                    };
                    MailingAddressDirCtrl.prototype.stateTypeChanged = function () {
                        this.address.stateTypeID = this.address.stateType.typeID;
                    };
                    MailingAddressDirCtrl.prototype.onNotificationSettingClicked = function () {
                        this.common.$rootScope.$broadcast(Events.ShowChannelPrefPopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Large,
                            initDataObj: {},
                        });
                    };
                    MailingAddressDirCtrl.prototype.getCountryTypes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.Country)
                            .then(function (data) {
                            _this.countryTypes = data;
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    MailingAddressDirCtrl.prototype.getStateTypes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var promise = this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Pulse.Common.Enums.CountryRegionType.USStates, Enums.TypeClassType.State)
                            .then(function (data) {
                            _this.stateTypes = data;
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    MailingAddressDirCtrl.controllerId = "idpMailingAddressCtrl";
                    MailingAddressDirCtrl._instanceCount = 0;
                    return MailingAddressDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                MailingAddressDir.MailingAddressDirCtrl = MailingAddressDirCtrl;
            })(MailingAddressDir = PulsePublic.MailingAddressDir || (PulsePublic.MailingAddressDir = {}));
            Pulse.app.directive(MailingAddressDir.directiveId, ["common", function (c) { return new MailingAddressDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var EmailAddressDir = (function (_super) {
                __extends(EmailAddressDir, _super);
                function EmailAddressDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "contact-info/idp-email-address.html";
                    _this.scope = {
                        emailUserContactMethod: "=",
                        firstTabIndex: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        EmailAddressDir.EmailAddressDirCtrl];
                    return _this;
                }
                EmailAddressDir.directiveId = "idpEmailAddress";
                return EmailAddressDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.EmailAddressDir = EmailAddressDir;
            (function (EmailAddressDir) {
                var EmailAddressDirCtrl = (function (_super) {
                    __extends(EmailAddressDirCtrl, _super);
                    function EmailAddressDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, EmailAddressDirCtrl.controllerId) || this;
                        _this.emailRegExpErrorMsg = PulseRegExp.EmailErrorMessage;
                        _this.userMgr = _this.pulseContext.userMgr;
                        _this.id = EmailAddressDirCtrl._instanceCount++;
                        _this.formName = "idpEmailAddressForm" + _this.id;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.activateController();
                        return _this;
                    }
                    EmailAddressDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        this.myForm = scope[this.formName];
                        var parentCtrl = (scope.$parent).vm;
                    };
                    EmailAddressDirCtrl.prototype.checkEmailUniqueness = function (e) {
                        var _this = this;
                        var userName = e.target.value;
                        if (String.isNullOrWhitespace(userName))
                            return;
                        return new Promise(function (resolve, reject) {
                            _this.userMgr.isUserNameUnique(_this.emailUserContactMethod.userID, userName).then(function (isUnique) {
                                if (_this.myForm == null || _this.myForm["email"] == null)
                                    return;
                                var valid = isUnique;
                                if (valid) {
                                    _this.myForm["email"].$setValidity("unique", true);
                                }
                                else {
                                    _this.myForm["email"].$setValidity("unique", false);
                                }
                                resolve();
                            });
                        });
                    };
                    EmailAddressDirCtrl.prototype.openNewsLetterPopup = function ($event) {
                        $event.preventDefault();
                        var helpContentHtml = "<p>To keep our clients up-to-date, you can choose to have our free email newsletters mailed to your inbox. What a cool way to stay informed!</p>\n                     <p>Some benefits of our newsletters:</p>\n                     <ol>\n                        <li>Savings opportunities!</li>\n                        <li>New Locations and Dates!</li>\n                        <li>Exciting New Courses and Programs!</li>\n                     </ol>\n                     <p>Our newsletters are sent to you periodically throughout the year in HTML format.We do not share email addresses or any other personal information with third parties.You can unsubscribe at any time.</p>";
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "iD Tech Newsletters", " " + helpContentHtml, "newsletterHelpPopup");
                    };
                    EmailAddressDirCtrl.prototype.onNotificationSettingClicked = function () {
                        this.common.$rootScope.$broadcast(Events.ShowChannelPrefPopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Large,
                            initDataObj: {},
                        });
                    };
                    EmailAddressDirCtrl.controllerId = "idpMailingAddressCtrl";
                    EmailAddressDirCtrl._instanceCount = 0;
                    return EmailAddressDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                EmailAddressDir.EmailAddressDirCtrl = EmailAddressDirCtrl;
            })(EmailAddressDir = PulsePublic.EmailAddressDir || (PulsePublic.EmailAddressDir = {}));
            Pulse.app.directive(EmailAddressDir.directiveId, ["common", function (c) { return new EmailAddressDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var PhoneNumbersDir = (function (_super) {
                __extends(PhoneNumbersDir, _super);
                function PhoneNumbersDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'contact-info/idp-phone-numbers.html';
                    _this.scope = {
                        phoneUserContactMethods: '=',
                        firstTabIndex: '<'
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        PhoneNumbersDir.PhoneNumbersDirCtrl
                    ];
                    return _this;
                }
                PhoneNumbersDir.directiveId = 'idpPhoneNumbers';
                return PhoneNumbersDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.PhoneNumbersDir = PhoneNumbersDir;
            (function (PhoneNumbersDir) {
                var PhoneNumbersDirCtrl = (function (_super) {
                    __extends(PhoneNumbersDirCtrl, _super);
                    function PhoneNumbersDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, PhoneNumbersDirCtrl.controllerId) || this;
                        _this.id = PhoneNumbersDirCtrl._instanceCount++;
                        _this.formName = 'idpPhoneNumbersForm' + _this.id;
                        _this.userContactMethodDAO = new DataAccess.UserContactMethodDAO(_this.common, _this.breezeService, _this.pulseContext);
                        _this.checkUnsavedDataBeforeNav = false;
                        return _this;
                    }
                    PhoneNumbersDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.getPhoneContactMethodTypes());
                        this.activateController();
                    };
                    PhoneNumbersDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        this.myForm = scope[this.formName];
                        var parentCtrl = scope.$parent.vm;
                    };
                    PhoneNumbersDirCtrl.prototype.contactMethodTypeChanged = function (contactMethod) {
                        contactMethod.contactMethodTypeID = contactMethod.contactMethodType.typeID;
                        contactMethod.optOut = true;
                    };
                    PhoneNumbersDirCtrl.prototype.addPhone = function () {
                        if (angular.isDefined(this.phoneUserContactMethods) && angular.isArray(this.phoneUserContactMethods)) {
                            var newUCM = this.userContactMethodDAO.Create();
                            newUCM.userID = this.pulseContext.actingAsUserId;
                            newUCM.recordStateID = Enums.RecordStateType.Active;
                            newUCM.isPrimaryNumber = false;
                            newUCM.optOut = true;
                            this.phoneUserContactMethods.push(newUCM);
                            this.myForm.$setDirty();
                        }
                    };
                    PhoneNumbersDirCtrl.prototype.removePhone = function (contactMethod) {
                        this.myForm.$setDirty();
                        if (contactMethod.userContactMethodID > 0) {
                            contactMethod.entityAspect.rejectChanges();
                            contactMethod.recordStateID = Enums.RecordStateType.Archived;
                        }
                        else {
                            contactMethod.entityAspect.rejectChanges();
                            contactMethod.entityAspect.setDetached();
                        }
                        if (this.phoneUserContactMethods.indexOf(contactMethod) > 0)
                            this.phoneUserContactMethods.splice(this.phoneUserContactMethods.indexOf(contactMethod), 1);
                    };
                    PhoneNumbersDirCtrl.prototype.updateIsPrimaryNumber = function (position, contactMethod) {
                        if (this.phoneUserContactMethods.length === 1) {
                            this.phoneUserContactMethods[0].isPrimaryNumber = true;
                            return;
                        }
                        angular.forEach(this.phoneUserContactMethods, function (phone, index) {
                            if (position !== index && phone.isPrimaryNumber)
                                phone.isPrimaryNumber = false;
                        });
                    };
                    PhoneNumbersDirCtrl.prototype.getPhoneContactMethodTypes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var promise = this.pulseContext.lookupInfoMgr
                            .loadTypeInfo(Enums.TypeClassType.ContactMethod)
                            .then(function (data) {
                            _this.phoneContactMethodTypes = data.filter(function (t) { return t.typeID <= Pulse.Common.Enums.ContactMethodType.CellPhone; });
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    PhoneNumbersDirCtrl.prototype.onNotificationSettingClicked = function () {
                        this.common.$rootScope.$broadcast(Events.ShowChannelPrefPopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Large,
                            initDataObj: {},
                        });
                    };
                    PhoneNumbersDirCtrl.controllerId = 'idpPhoneNumbersCtrl';
                    PhoneNumbersDirCtrl._instanceCount = 0;
                    return PhoneNumbersDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                PhoneNumbersDir.PhoneNumbersDirCtrl = PhoneNumbersDirCtrl;
            })(PhoneNumbersDir = PulsePublic.PhoneNumbersDir || (PulsePublic.PhoneNumbersDir = {}));
            Pulse.app.directive(PhoneNumbersDir.directiveId, ['common', function (c) { return new PhoneNumbersDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var TermsAndConditionsMgr = Pulse.Common.DataAccess.Managers.TermsAndConditionsMgr;
            var TacPopupDir = (function (_super) {
                __extends(TacPopupDir, _super);
                function TacPopupDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        TacPopupDir.TacPopupDirCtrl];
                    _this.scope = {
                        isPopupOpen: "="
                    };
                    return _this;
                }
                TacPopupDir.directiveId = "idpTacPopup";
                return TacPopupDir;
            }(Pulse.Common.BasePopup));
            PulsePublic.TacPopupDir = TacPopupDir;
            (function (TacPopupDir) {
                var TacPopupDirCtrl = (function (_super) {
                    __extends(TacPopupDirCtrl, _super);
                    function TacPopupDirCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, TacPopupDirCtrl.controllerId) || this;
                        _this.agreedToTermsAndConditions = false;
                        _this.formName = "tacPopupForm";
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "terms-and-conditions/idp-tac-popup.html";
                        _this.keyboard = false;
                        _this.event_ShowPopup = Events.ShowTermsAndConditionsPopup;
                        _this.activationPromises.push(_this.getTermsAndConditionsContent());
                        _this.activateController();
                        return _this;
                    }
                    TacPopupDirCtrl.prototype.getTermsAndConditionsContent = function () {
                        var _this = this;
                        var tacMgr = new TermsAndConditionsMgr(this.common, this.breezeService, this.pulseContext);
                        var promise = tacMgr.getLatestTermsAndConditionsContent()
                            .then(function (data) {
                            _this.termsAndConditionContent = (data[0])["data"];
                        }).catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                        });
                        return promise;
                    };
                    TacPopupDirCtrl.prototype.acceptAndClose = function () {
                        if (this.agreedToTermsAndConditions)
                            var tacMgr = new TermsAndConditionsMgr(this.common, this.breezeService, this.pulseContext);
                        tacMgr.saveUserTandCSignature().then(function (data) {
                        }).catch(function (err) {
                            console.log(err);
                            return;
                        });
                        if (angular.isObject(this.api)) {
                            if (angular.isDefined(this.api.onClose)) {
                                this.api.onClose();
                            }
                        }
                        this.isPopupOpen = false;
                        _super.prototype.close.call(this);
                    };
                    TacPopupDirCtrl.prototype.onRendered = function () {
                        $('.modal .modal-full .modal-body').css('height', $(window).height() * 0.80);
                        _super.prototype.onRendered.call(this);
                    };
                    TacPopupDirCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        this.submitted = false;
                        this.isPopupOpen = true;
                        this.breezeService.getEntityManager().rejectChanges();
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        this.setLocalizedTexts();
                    };
                    TacPopupDirCtrl.prototype.scrollToHash = function (region) {
                        this.common.scrollToHash(region);
                    };
                    TacPopupDirCtrl.controllerId = "TacDirCtrl";
                    return TacPopupDirCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                TacPopupDir.TacPopupDirCtrl = TacPopupDirCtrl;
            })(TacPopupDir = PulsePublic.TacPopupDir || (PulsePublic.TacPopupDir = {}));
            Pulse.app.directive(TacPopupDir.directiveId, ["common", function (c) { return new TacPopupDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var Managers = Pulse.Common.DataAccess.Managers;
            var MyStudentsWithFormsDir = (function (_super) {
                __extends(MyStudentsWithFormsDir, _super);
                function MyStudentsWithFormsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/idp-my-students-with-forms.html";
                    _this.scope = {
                        canAdministerForms: "<",
                        canUpdate: "<",
                        studentList: "<",
                        formStatusTypes: "<",
                        formStatusDict: "<",
                        formSectionTypes: "<",
                        formSectionDict: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        MyStudentsWithFormsDir.MyStudentsWithFormsDirCtrl];
                    return _this;
                }
                MyStudentsWithFormsDir.directiveId = "idpMyStudentsWithForms";
                return MyStudentsWithFormsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.MyStudentsWithFormsDir = MyStudentsWithFormsDir;
            (function (MyStudentsWithFormsDir) {
                var MyStudentsWithFormsDirCtrl = (function (_super) {
                    __extends(MyStudentsWithFormsDirCtrl, _super);
                    function MyStudentsWithFormsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, MyStudentsWithFormsDirCtrl.controllerId) || this;
                        _this.canAdministerForms = false;
                        _this.anythingChanged = false;
                        _this.formName = "frmStudentsWithCurrentForms";
                        _this._clientFormSectionStatusChangingHandler = $scope.$on(Events.ClientFormSectionStatusChanging, function (event, userFormDetailID, statusTypeID) {
                            _this.anythingChanged = true;
                            _this.$scope.$emit(Events.ClientFormStatusChanging, userFormDetailID, statusTypeID);
                        });
                        $scope.$on('$destroy', function () {
                            _this._clientFormSectionStatusChangingHandler();
                        });
                        return _this;
                    }
                    MyStudentsWithFormsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _this = this;
                        this.myForm = scope[this.formName];
                        scope.$watch(function (scope) {
                            return _this.formStatusTypes;
                        }, function (newValue, oldValue) {
                        });
                        scope.$watch(function (scope) {
                            return _this.formSectionTypes;
                        }, function (newValue, oldValue) {
                        });
                        scope.$watch(function (scope) {
                            return _this.studentList;
                        }, function (newValue, oldValue) {
                        });
                    };
                    MyStudentsWithFormsDirCtrl.prototype.showDueDate = function (formWithSections) {
                        var statusTypeID = formWithSections.formInfo.statusTypeID;
                        return (statusTypeID != Enums.FormStatus.Complete && statusTypeID != Enums.FormStatus.NotApplicable);
                    };
                    MyStudentsWithFormsDirCtrl.prototype.onViewFormClick = function (form) {
                        if (form.isAdditional) {
                            if (form.formInfo.fileUrl == null) {
                                this.logError("Additional required form '" + form.formInfo.formName + "' is missing its download file URL.");
                            }
                            else if (form.formInfo.fileUrl.toLowerCase().lastIndexOf("http") == 0) {
                                var downloadPath = form.formInfo.fileUrl;
                                window.open(downloadPath, '_blank', '');
                            }
                            else {
                                var downloadPath = Pulse.Utils.JS.combineUrls(this.common.config.pulse1x_PublicUrlRoot, form.formInfo.fileUrl);
                                window.open(downloadPath, '_blank', '');
                            }
                        }
                        else if (form.formButtonUrl != null) {
                            this.$location.url(form.formButtonUrl);
                        }
                        return false;
                    };
                    MyStudentsWithFormsDirCtrl.prototype.ufdStatusChanged = function (form) {
                        this.anythingChanged = true;
                        var ufdID = form.formInfo.userFormDetailID;
                        var newStatusTypeID = form.formInfo.statusTypeID;
                        this.$scope.$emit(Events.ClientFormStatusChanging, ufdID, newStatusTypeID);
                    };
                    MyStudentsWithFormsDirCtrl.prototype.studentIsTeen = function (student, form) {
                        this.pulseContext.healthSafetyFormMgr.getReqdFormContentForUserFormDetail(form.formInfo.userFormDetailID)
                            .then(function (data) {
                            if (angular.isDefined(data)) {
                                student.isTeen = data.canSelfSignOut;
                                if (!data.canSelfSignOut) {
                                    student.isTeen = Managers.AgeMgr.isParticipantTeen(student.dateOfBirth, moment(form.earliestTermEndDateWhereFormRequired).year());
                                }
                            }
                        });
                    };
                    MyStudentsWithFormsDirCtrl.prototype.studentIsUSLocationOnly = function (userFormDetailID, student) {
                        this.pulseContext.healthSafetyFormMgr.getIsUserInternational(userFormDetailID)
                            .then(function (data) {
                            if (angular.isDefined(data) && student) {
                                student.isUsLocationOnly = !data;
                            }
                        });
                    };
                    MyStudentsWithFormsDirCtrl.prototype.onSaveStatusUpdatesClick = function () {
                        var _this = this;
                        this.common.clearStatus();
                        this.common.toggleSpinner(true);
                        var ufdDAO = new DataAccess.UserFormDetailDAO(this.common, this.breezeService, this.pulseContext);
                        var self = this;
                        this.pulseContext.clientFormsMgr.updateUserFormDetailStatus()
                            .then(function (saveResult) {
                            self.anythingChanged = false;
                            self.myForm.$setPristine();
                            self.common.showSuccess("Form status update(s) saved.");
                            self.$scope.$emit(Events.ClientFormStatusChangesSaved);
                            if (_this.pulseContext.isImpersonating) {
                                self.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUser.userID);
                            }
                        })
                            .catch(function (err) {
                            self.logError(err);
                            self.breezeService.getEntityManager().rejectChanges();
                        })
                            .finally(function () {
                            self.common.toggleSpinner(false);
                        });
                    };
                    MyStudentsWithFormsDirCtrl.prototype.onExpandToggle = function (student) {
                        if (angular.isUndefined(student.isExpanded))
                            student.isExpanded = false;
                        student.isExpanded = !student.isExpanded;
                    };
                    MyStudentsWithFormsDirCtrl.prototype.onCloseClick = function (student) {
                        student.isExpanded = false;
                    };
                    MyStudentsWithFormsDirCtrl.prototype.securityCheck = function () {
                        _super.prototype.securityCheck.call(this);
                    };
                    MyStudentsWithFormsDirCtrl.prototype.secureAllFeatures = function () {
                        _super.prototype.secureAllFeatures.call(this);
                        this.canUpdate = this.canUpdate ||
                            this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Corporate, Enums.UserRoleType.Region);
                    };
                    MyStudentsWithFormsDirCtrl.controllerId = "idpMyStudentsWithForms";
                    return MyStudentsWithFormsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                MyStudentsWithFormsDir.MyStudentsWithFormsDirCtrl = MyStudentsWithFormsDirCtrl;
            })(MyStudentsWithFormsDir = PulsePublic.MyStudentsWithFormsDir || (PulsePublic.MyStudentsWithFormsDir = {}));
            Pulse.app.directive(MyStudentsWithFormsDir.directiveId, ["common", function (c) { return new MyStudentsWithFormsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var MyStudentFormSectionsDir = (function (_super) {
                __extends(MyStudentFormSectionsDir, _super);
                function MyStudentFormSectionsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/idp-my-student-form-sections.html";
                    _this.scope = {
                        show: "=",
                        masterForm: "<",
                        formSections: "<",
                        formStatusTypes: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        MyStudentFormSectionsDir.MyStudentFormSectionsDirCtrl];
                    return _this;
                }
                MyStudentFormSectionsDir.directiveId = "idpMyStudentFormSections";
                return MyStudentFormSectionsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.MyStudentFormSectionsDir = MyStudentFormSectionsDir;
            (function (MyStudentFormSectionsDir) {
                var MyStudentFormSectionsDirCtrl = (function (_super) {
                    __extends(MyStudentFormSectionsDirCtrl, _super);
                    function MyStudentFormSectionsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        return _super.call(this, $scope, $location, common, breezeService, pulseContext, MyStudentFormSectionsDirCtrl.controllerId) || this;
                    }
                    MyStudentFormSectionsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _this = this;
                        var self = this;
                        scope.$watch(function (scope) {
                            return _this.show;
                        }, function (newValue, oldValue) {
                            if (newValue) {
                            }
                        });
                    };
                    MyStudentFormSectionsDirCtrl.prototype.ufdStatusChanged = function (section) {
                        this.$scope.$emit(Events.ClientFormSectionStatusChanging, section.userFormDetailID, section.statusTypeID);
                    };
                    MyStudentFormSectionsDirCtrl.prototype.securityCheck = function () {
                    };
                    MyStudentFormSectionsDirCtrl.prototype.secureAllFeatures = function () {
                    };
                    MyStudentFormSectionsDirCtrl.controllerId = "idpMyStudentFormSections";
                    return MyStudentFormSectionsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                MyStudentFormSectionsDir.MyStudentFormSectionsDirCtrl = MyStudentFormSectionsDirCtrl;
            })(MyStudentFormSectionsDir = PulsePublic.MyStudentFormSectionsDir || (PulsePublic.MyStudentFormSectionsDir = {}));
            Pulse.app.directive(MyStudentFormSectionsDir.directiveId, ["common", function (c) { return new MyStudentFormSectionsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var MyStudentHsfSectionLinksDir = (function (_super) {
                __extends(MyStudentHsfSectionLinksDir, _super);
                function MyStudentHsfSectionLinksDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'forms/idp-my-student-hsf-section-links.html';
                    _this.scope = {
                        userFormDetailId: '<',
                        termGroupId: '<',
                        statusTypeId: '<',
                        formCategoryTypeId: '<',
                        isTeen: '<',
                        isUsOnly: '<',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        MyStudentHsfSectionLinksDir.MyStudentHsfSectionLinksDirCtrl,
                    ];
                    return _this;
                }
                MyStudentHsfSectionLinksDir.directiveId = 'idpMyStudentHsfSectionLinks';
                return MyStudentHsfSectionLinksDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.MyStudentHsfSectionLinksDir = MyStudentHsfSectionLinksDir;
            (function (MyStudentHsfSectionLinksDir) {
                var MyStudentHsfSectionLinksDirCtrl = (function (_super) {
                    __extends(MyStudentHsfSectionLinksDirCtrl, _super);
                    function MyStudentHsfSectionLinksDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        return _super.call(this, $scope, $location, common, breezeService, pulseContext, MyStudentHsfSectionLinksDirCtrl.controllerId) || this;
                    }
                    MyStudentHsfSectionLinksDirCtrl.prototype.$onInit = function () {
                        this.show = this.formCategoryTypeId == Enums.FormCategoryType.EmergencyContact
                            && this.statusTypeId == Enums.FormStatus.Complete;
                    };
                    MyStudentHsfSectionLinksDirCtrl.prototype.securityCheck = function () {
                    };
                    MyStudentHsfSectionLinksDirCtrl.prototype.secureAllFeatures = function () {
                    };
                    MyStudentHsfSectionLinksDirCtrl.controllerId = 'idpMyStudentHsfSectionLinks';
                    return MyStudentHsfSectionLinksDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                MyStudentHsfSectionLinksDir.MyStudentHsfSectionLinksDirCtrl = MyStudentHsfSectionLinksDirCtrl;
            })(MyStudentHsfSectionLinksDir = PulsePublic.MyStudentHsfSectionLinksDir || (PulsePublic.MyStudentHsfSectionLinksDir = {}));
            Pulse.app.directive(MyStudentHsfSectionLinksDir.directiveId, [
                'common',
                function (c) { return new MyStudentHsfSectionLinksDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var MyStudentsWithFormsHistoryDir = (function (_super) {
                __extends(MyStudentsWithFormsHistoryDir, _super);
                function MyStudentsWithFormsHistoryDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/idp-my-students-with-forms-history.html";
                    _this.scope = {
                        show: "=",
                        formStatusTypes: "<",
                        formStatusDict: "<",
                        formSectionTypes: "<",
                        formSectionDict: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        MyStudentsWithFormsHistoryDir.MyStudentsWithFormsHistoryDirCtrl];
                    return _this;
                }
                MyStudentsWithFormsHistoryDir.directiveId = "idpMyStudentsWithFormsHistory";
                return MyStudentsWithFormsHistoryDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.MyStudentsWithFormsHistoryDir = MyStudentsWithFormsHistoryDir;
            (function (MyStudentsWithFormsHistoryDir) {
                var MyStudentsWithFormsHistoryDirCtrl = (function (_super) {
                    __extends(MyStudentsWithFormsHistoryDirCtrl, _super);
                    function MyStudentsWithFormsHistoryDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, MyStudentsWithFormsHistoryDirCtrl.controllerId) || this;
                        _this.studentList = null;
                        _this.anythingChanged = false;
                        _this.formName = "frmStudentsWithCurrentFormsHistory";
                        _this._clientFormSectionStatusChangingHandler = $scope.$on(Events.ClientFormSectionStatusChanging, function (event, userFormDetailID, statusTypeID) {
                            _this.anythingChanged = true;
                            _this.$scope.$emit(Events.ClientHistoryFormStatusChanging, userFormDetailID, statusTypeID);
                        });
                        $scope.$on('$destroy', function () {
                            _this._clientFormSectionStatusChangingHandler();
                        });
                        return _this;
                    }
                    MyStudentsWithFormsHistoryDirCtrl.prototype.anyStudents = function () { return (angular.isArray(this.studentList) && (this.studentList.length > 0)); };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.securityCheck = function () {
                        this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Public, 1, Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance, 1, Enums.UserRoleType.ClientServices, 1, 2, 3);
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.secureAllFeatures = function () {
                        this.canUpdate = this.pulseContext.isImpersonating
                            && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.Compliance, 1);
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.myForm = scope[this.formName];
                        var self = this;
                        scope.$watch(function (scope) {
                            return _this.show;
                        }, function (newValue, oldValue) {
                            if (newValue && !angular.isArray(_this.studentList)) {
                                self.getStudentsWithFormsHistory();
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.studentList;
                        }, function (newValue, oldValue) {
                            if (angular.isArray(newValue) && newValue.length > 0) {
                                self.deriveStudentInfo(self.formStatusDict, self.formSectionDict);
                            }
                        });
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.getStudentsWithFormsHistory = function () {
                        var self = this;
                        this.common.toggleSpinner(true);
                        var clientFormsMgr = this.pulseContext.clientFormsMgr;
                        clientFormsMgr.getStudentsWithFormsHistory()
                            .then(function (data) {
                            self.studentList = data;
                        })
                            .catch(function (error) {
                            self.logError(error);
                        })
                            .finally(function () {
                            self.common.toggleSpinner(false);
                        });
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.deriveStudentInfo = function (formStatusDict, formSectionDict) {
                        var now = new Date();
                        for (var _i = 0, _a = this.studentList; _i < _a.length; _i++) {
                            var student = _a[_i];
                            if (angular.isArray(student.requiredForms)) {
                                for (var _b = 0, _c = student.requiredForms; _b < _c.length; _b++) {
                                    var req = _c[_b];
                                    req.isAdditional = false;
                                    req.formInfo.dueDate = Pulse.Utils.JS.dateTimeStrToDateObj(req.formInfo.dueDate);
                                    req.formInfo.status = formStatusDict.getValue(req.formInfo.statusTypeID).typeString;
                                    req.isStatusReadOnly = this.formStatusIsReadOnly(req);
                                    this.setRequiredFormButtonProperties(req);
                                    req.hasSections = angular.isArray(req.sections) && (req.sections.length > 0);
                                    if (req.hasSections) {
                                        for (var _d = 0, _e = req.sections; _d < _e.length; _d++) {
                                            var section = _e[_d];
                                            section.status = formStatusDict.getValue(section.statusTypeID).typeString;
                                            section.formSectionName = formSectionDict.getValue(section.formSectionTypeID).typeString;
                                            section.isStatusReadOnly = this.sectionStatusIsReadOnly(section);
                                            section.dueDate = Pulse.Utils.JS.dateTimeStrToDateObj(section.dueDate);
                                        }
                                    }
                                    req.canShowSections = req.hasSections && this.pulseContext.isImpersonating;
                                }
                            }
                            if (angular.isArray(student.additionalForms)) {
                                for (var _f = 0, _g = student.additionalForms; _f < _g.length; _f++) {
                                    var arf = _g[_f];
                                    arf.isAdditional = true;
                                    arf.formInfo.dueDate = Pulse.Utils.JS.dateTimeStrToDateObj(arf.formInfo.dueDate);
                                    arf.formInfo.status = formStatusDict.getValue(arf.formInfo.statusTypeID).typeString;
                                    arf.isStatusReadOnly = this.formStatusIsReadOnly(arf);
                                    this.setAdditionalFormButtonProperties(arf);
                                    arf.hasSections = angular.isArray(arf.sections) && (arf.sections.length > 0);
                                    if (arf.hasSections) {
                                        for (var _h = 0, _j = arf.sections; _h < _j.length; _h++) {
                                            var section = _j[_h];
                                            section.status = formStatusDict.getValue(section.statusTypeID).typeString;
                                            section.formSectionName = formSectionDict.getValue(section.formSectionTypeID).typeString;
                                            section.isStatusReadOnly = this.sectionStatusIsReadOnly(section);
                                            section.dueDate = Pulse.Utils.JS.dateTimeStrToDateObj(section.dueDate);
                                        }
                                    }
                                    arf.canShowSections = arf.hasSections && this.pulseContext.isImpersonating;
                                }
                            }
                        }
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.formStatusIsReadOnly = function (form) {
                        var hasSections = angular.isArray(form.sections) && (form.sections.length > 0);
                        var isCurrentTermGroup = (form.formInfo.termGroupID == this.pulseContext.currentTermGroup.termGroupID);
                        var isHealthAndSafetyForm = (form.formInfo.categoryTypeID == Enums.FormCategoryType.EmergencyContact);
                        var isBringToFirstDayOfSessionForm = (form.formInfo.categoryTypeID == Enums.FormCategoryType.Bring);
                        return (isHealthAndSafetyForm || isBringToFirstDayOfSessionForm || !this.canUpdate || hasSections || !isCurrentTermGroup);
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.sectionStatusIsReadOnly = function (section) {
                        var isCurrentTermGroup = (section.termGroupID == this.pulseContext.currentTermGroup.termGroupID);
                        var isHealthSafetyStatusForm = (section.categoryTypeID == Enums.FormCategoryType.EmergencyContact);
                        return (isHealthSafetyStatusForm || !this.canUpdate || !isCurrentTermGroup);
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.setRequiredFormButtonProperties = function (form) {
                        var now = new Date();
                        var buttonText = "View";
                        var isFormButtonDisabled = false;
                        var isFormButtonVisible = true;
                        var noFormButtonText = "";
                        var formButtonUrl = form.isAdditional ? null : String.format("{0}?{1}={2}", Routes.HSF_Welcome, QueryStringUtils.USERFORMDETAIL_ID, form.formInfo.userFormDetailID);
                        if (this.pulseContext.isImpersonating && form.formInfo.statusTypeID != Enums.FormStatus.Complete) {
                            if (form.formInfo.termGroupID == this.pulseContext.currentTermGroup.termGroupID) {
                                buttonText = "View/Edit (closed to client)";
                            }
                        }
                        else {
                            buttonText = "View";
                        }
                        if (this.isPrivilegedUser() && moment(form.formInfo.privilegedUserEditableUntil).isAfter()) {
                            isFormButtonVisible = true;
                        }
                        else {
                            isFormButtonVisible = form.formInfo.termGroupYear > 2016;
                        }
                        form.formButtonText = buttonText;
                        form.isFormButtonVisible = isFormButtonVisible;
                        form.isFormButtonDisabled = isFormButtonDisabled;
                        form.noFormButtonText = noFormButtonText;
                        form.formButtonUrl = formButtonUrl;
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.setAdditionalFormButtonProperties = function (form) {
                        var now = new Date();
                        var buttonText = "Download";
                        var isFormButtonDisabled = false;
                        var isFormButtonVisible = false;
                        var noFormButtonText = "Not Available";
                        form.formButtonText = buttonText;
                        form.isFormButtonDisabled = isFormButtonDisabled;
                        form.isFormButtonVisible = isFormButtonVisible;
                        form.noFormButtonText = noFormButtonText;
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.toggleSections = function (formWithSections) {
                        formWithSections.showSections = !formWithSections.showSections;
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.showDueDate = function (formWithSections) {
                        var statusTypeID = formWithSections.formInfo.statusTypeID;
                        return (statusTypeID != Enums.FormStatus.Complete && statusTypeID != Enums.FormStatus.NotApplicable);
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.ufdStatusChanged = function (form) {
                        this.anythingChanged = true;
                        var ufdID = form.formInfo.userFormDetailID;
                        var newStatusTypeID = form.formInfo.statusTypeID;
                        this.$scope.$emit(Events.ClientHistoryFormStatusChanging, ufdID, newStatusTypeID);
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.onSaveStatusUpdatesClick = function () {
                        var _this = this;
                        this.common.clearStatus();
                        this.common.toggleSpinner(true);
                        var ufdDAO = new DataAccess.UserFormDetailDAO(this.common, this.breezeService, this.pulseContext);
                        var self = this;
                        this.pulseContext.clientFormsMgr.updateUserFormDetailStatus()
                            .then(function (saveResult) {
                            self.anythingChanged = false;
                            self.myForm.$setPristine();
                            self.common.showSuccess("Form history status update(s) saved.");
                            self.getStudentsWithFormsHistory();
                            if (_this.pulseContext.isImpersonating) {
                                self.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUser.userID);
                            }
                        })
                            .catch(function (err) {
                            self.logError(err);
                            self.breezeService.getEntityManager().rejectChanges();
                        })
                            .finally(function () {
                            self.common.toggleSpinner(false);
                        });
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.onViewFormClick = function (form, participantId) {
                        if (form.isAdditional) {
                            var downloadPath = Pulse.Utils.JS.combineUrls(this.common.config.pulse1x_PublicUrlRoot, form.formInfo.fileUrl);
                            window.open(downloadPath, '_blank', '');
                        }
                        else if (form.formInfo.categoryTypeID == Enums.FormCategoryType.EmergencyContact) {
                            if (this.isPrivilegedUser()) {
                                if (moment(form.formInfo.privilegedUserEditableUntil).isAfter() && form.formInfo.statusTypeID != Enums.FormStatus.Complete) {
                                    this.$location.url(form.formButtonUrl);
                                }
                                else {
                                    this.downloadFormAsPDF(form.formInfo.userFormDetailID, participantId);
                                }
                            }
                            else {
                                this.downloadFormAsPDF(form.formInfo.userFormDetailID, participantId);
                            }
                        }
                        else if (form.formButtonUrl != null) {
                            this.$location.url(form.formButtonUrl);
                        }
                        return false;
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.onToggleClick = function (index) {
                        var student = this.studentList[index];
                        if (angular.isUndefined(student.isExpanded))
                            student.isExpanded = false;
                        student.isExpanded = !student.isExpanded;
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.onCloseClick = function (index) {
                        var student = this.studentList[index];
                        student.isExpanded = false;
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.downloadFormAsPDF = function (ufdId, participantId) {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var objectUrl = null;
                        var self = this;
                        this.pulseContext.healthSafetyFormMgr.downloadFormAsPDF(ufdId, participantId)
                            .then(function (response) {
                            if (angular.isArray(response)) {
                                var headers = response[0].headers();
                                var contentType = headers["content-type"];
                                var linkElement = document.createElement('a');
                                linkElement.setAttribute('style', "display: none");
                                try {
                                    var blob = new Blob([response[0].data], { type: contentType });
                                    var url = window.URL.createObjectURL(blob);
                                    linkElement.setAttribute('download', _this.getFileNameFromHttpResponse(response[0]));
                                    linkElement.setAttribute('href', url);
                                    var clickEvent = new MouseEvent("click", {
                                        "view": window,
                                        "bubbles": true,
                                        "cancelable": false
                                    });
                                    linkElement.dispatchEvent(clickEvent);
                                }
                                catch (ex) {
                                    self.logError(ex);
                                }
                            }
                            else {
                                _this.logError("PDF download request response was not an array.");
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                            URL.revokeObjectURL(objectUrl);
                        });
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.getFileNameFromHttpResponse = function (httpResponse) {
                        var contentDispositionHeader = httpResponse.headers('Content-Disposition');
                        var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
                        return result.replace(/"/g, '');
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.logError = function (err, typesOfErrsToShowToUser, options) {
                        this.common.logAllErrorTypes(err, this.loggingId, options, typesOfErrsToShowToUser);
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.isPrivilegedUser = function () {
                        return this.pulseContext.isImpersonating && this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Compliance, 1, Enums.UserRoleType.Administrator, 1, 2);
                    };
                    MyStudentsWithFormsHistoryDirCtrl.prototype.isPrivilegedUserEndDateAfterToday = function (date) {
                        return moment(date).isAfter();
                    };
                    MyStudentsWithFormsHistoryDirCtrl.controllerId = "idpMyStudentsWithFormsHistory";
                    return MyStudentsWithFormsHistoryDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                MyStudentsWithFormsHistoryDir.MyStudentsWithFormsHistoryDirCtrl = MyStudentsWithFormsHistoryDirCtrl;
            })(MyStudentsWithFormsHistoryDir = PulsePublic.MyStudentsWithFormsHistoryDir || (PulsePublic.MyStudentsWithFormsHistoryDir = {}));
            Pulse.app.directive(MyStudentsWithFormsHistoryDir.directiveId, ["common", function (c) { return new MyStudentsWithFormsHistoryDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var MyStudentsPastFormUploadsDir = (function (_super) {
                __extends(MyStudentsPastFormUploadsDir, _super);
                function MyStudentsPastFormUploadsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/idp-my-students-past-form-uploads.html";
                    _this.scope = {
                        show: "=",
                        isCurrent: "="
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        MyStudentsPastFormUploadsDir.MyStudentsPastFormUploadsDirCtrl];
                    return _this;
                }
                MyStudentsPastFormUploadsDir.directiveId = "idpMyStudentsPastFormUploads";
                return MyStudentsPastFormUploadsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.MyStudentsPastFormUploadsDir = MyStudentsPastFormUploadsDir;
            (function (MyStudentsPastFormUploadsDir) {
                var MyStudentsPastFormUploadsDirCtrl = (function (_super) {
                    __extends(MyStudentsPastFormUploadsDirCtrl, _super);
                    function MyStudentsPastFormUploadsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, MyStudentsPastFormUploadsDirCtrl.controllerId) || this;
                        _this.isCurrent = true;
                        _this.formsList = null;
                        _this.anyPastUploads = true;
                        return _this;
                    }
                    MyStudentsPastFormUploadsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _this = this;
                        var self = this;
                        scope.$watch(function (scope) {
                            return _this.show;
                        }, function (newValue, oldValue) {
                            if (newValue && !angular.isArray(_this.formsList)) {
                                self.getPastUploads();
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.isCurrent;
                        }, function (newValue, oldValue) {
                            if (!newValue) {
                                self.getPastUploads();
                            }
                        });
                    };
                    MyStudentsPastFormUploadsDirCtrl.prototype.getPastUploads = function () {
                        var _this = this;
                        var self = this;
                        this.common.toggleSpinner(true);
                        var clientFormsMgr = this.pulseContext.clientFormsMgr;
                        clientFormsMgr.getPastUploads()
                            .then(function (data) {
                            self.formsList = data;
                            self.isCurrent = true;
                            self.anyPastUploads = (angular.isArray(_this.formsList) && (_this.formsList.length > 0));
                        })
                            .catch(function (error) {
                            self.logError(error);
                        })
                            .finally(function () {
                            self.common.toggleSpinner(false);
                        });
                    };
                    MyStudentsPastFormUploadsDirCtrl.prototype.securityCheck = function () {
                    };
                    MyStudentsPastFormUploadsDirCtrl.prototype.secureAllFeatures = function () {
                    };
                    MyStudentsPastFormUploadsDirCtrl.controllerId = "idpMyStudentsPastFormUploads";
                    return MyStudentsPastFormUploadsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                MyStudentsPastFormUploadsDir.MyStudentsPastFormUploadsDirCtrl = MyStudentsPastFormUploadsDirCtrl;
            })(MyStudentsPastFormUploadsDir = PulsePublic.MyStudentsPastFormUploadsDir || (PulsePublic.MyStudentsPastFormUploadsDir = {}));
            Pulse.app.directive(MyStudentsPastFormUploadsDir.directiveId, ["common", function (c) { return new MyStudentsPastFormUploadsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HSFPageHeaderDir = (function (_super) {
                __extends(HSFPageHeaderDir, _super);
                function HSFPageHeaderDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/hsf/idp-hsf-page-header.html";
                    _this.scope = {
                        participant: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        HSFPageHeaderDir.HSFPageHeaderDirCtrl];
                    return _this;
                }
                HSFPageHeaderDir.directiveId = "idpHsfPageHeader";
                return HSFPageHeaderDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFPageHeaderDir = HSFPageHeaderDir;
            (function (HSFPageHeaderDir) {
                var HSFPageHeaderDirCtrl = (function (_super) {
                    __extends(HSFPageHeaderDirCtrl, _super);
                    function HSFPageHeaderDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFPageHeaderDirCtrl.controllerId) || this;
                        _this.activateController();
                        return _this;
                    }
                    HSFPageHeaderDirCtrl.controllerId = "idpHsfEmergencyContactsCtrl";
                    return HSFPageHeaderDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFPageHeaderDir.HSFPageHeaderDirCtrl = HSFPageHeaderDirCtrl;
            })(HSFPageHeaderDir = PulsePublic.HSFPageHeaderDir || (PulsePublic.HSFPageHeaderDir = {}));
            Pulse.app.directive(HSFPageHeaderDir.directiveId, ["common", function (c) { return new HSFPageHeaderDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var HSFEmergencyContactsDir = (function (_super) {
                __extends(HSFEmergencyContactsDir, _super);
                function HSFEmergencyContactsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'forms/hsf/idp-hsf-emergency-contacts.html';
                    _this.scope = {
                        userFormDetail: '=',
                        formPersonRole: '=',
                        emergencyContact: '=',
                        onFormSaveSuccess: '&',
                        firstTabIndex: '=',
                        onBackClick: '&',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        HSFEmergencyContactsDir.HSFEmergencyContactsDirCtrl,
                    ];
                    return _this;
                }
                HSFEmergencyContactsDir.directiveId = 'idpHsfEmergencyContacts';
                return HSFEmergencyContactsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFEmergencyContactsDir = HSFEmergencyContactsDir;
            (function (HSFEmergencyContactsDir) {
                var HSFEmergencyContactsDirCtrl = (function (_super) {
                    __extends(HSFEmergencyContactsDirCtrl, _super);
                    function HSFEmergencyContactsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFEmergencyContactsDirCtrl.controllerId) || this;
                        _this.primaryContactEnumValue = Pulse.Common.Enums.FormPersonRole.PrimaryContact;
                        _this.secondaryContactEnumValue = Pulse.Common.Enums.FormPersonRole.SecondaryContact;
                        _this.officePhoneEnumValue = Pulse.Common.Enums.ContactMethodType.OfficePhone;
                        _this.userRelationTypes = null;
                        _this.countryTypes = null;
                        _this.stateTypes = null;
                        _this.phoneContactMethodTypes = null;
                        return _this;
                    }
                    HSFEmergencyContactsDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.getCountryTypes());
                        this.activationPromises.push(this.getStateTypes());
                        this.activationPromises.push(this.getPhoneContactMethodTypes());
                        this.activateController();
                    };
                    HSFEmergencyContactsDirCtrl.prototype.getCountryTypes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.Country)
                            .then(function (data) {
                            _this.countryTypes = data;
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    HSFEmergencyContactsDirCtrl.prototype.getStateTypes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var promise = this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Pulse.Common.Enums.CountryRegionType.USStates, Enums.TypeClassType.State)
                            .then(function (data) {
                            _this.stateTypes = data;
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    HSFEmergencyContactsDirCtrl.prototype.getPhoneContactMethodTypes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.ContactMethod)
                            .then(function (data) {
                            _this.phoneContactMethodTypes = data.filter(function (t) {
                                return t.typeID <= Pulse.Common.Enums.ContactMethodType.CellPhone;
                            });
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    HSFEmergencyContactsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        this.myForm = scope.myForm;
                        this.breezeService.getEntityManager()
                            .rejectChanges();
                    };
                    HSFEmergencyContactsDirCtrl.prototype.submit = function () {
                        var _this = this;
                        if (!this.myForm.$valid)
                            return;
                        if (this.emergencyContact.dataWasPrepopulated) {
                            this.myForm.$setDirty();
                        }
                        if (this.myForm.$dirty) {
                            this.submitted = true;
                            this.common.toggleSpinner(true);
                            if (this.formPersonRole === Pulse.Common.Enums.FormPersonRole.PrimaryContact && this.emergencyContact.address.countryType.typeID == Enums.CountryType.USA) {
                                this.emergencyContact.address.state = this.emergencyContact.address.stateType.typeString;
                            }
                            var fpDAO = new DataAccess.FormPersonDAO(this.common, this.breezeService, this.pulseContext);
                            var newFormPerson = fpDAO.Create({
                                formPersonID: this.emergencyContact.formPersonID,
                                name: this.emergencyContact.name,
                                relationshipToUser: this.emergencyContact.relationshipToUser,
                                userFormDetailID: this.userFormDetail.userFormDetailID,
                                formRoleTypeID: this.formPersonRole,
                            });
                            var fpdDAO = new DataAccess.FormPersonDetailDAO(this.common, this.breezeService, this.pulseContext);
                            var newFormPersonDetail = fpdDAO.Create({
                                name: this.emergencyContact.name,
                                relationshipToUser: this.emergencyContact.relationshipToUser,
                            });
                            newFormPersonDetail.formPerson = newFormPerson;
                            var fpcmDAO = new DataAccess.FormPersonContactMethodDAO(this.common, this.breezeService, this.pulseContext);
                            var newEmail = fpcmDAO.Create({
                                contactMethodTypeID: Pulse.Common.Enums.ContactMethodType.Email,
                                contactMethodOther: this.emergencyContact.emailAddress,
                                isPrimaryNumber: true,
                            });
                            newEmail.formPerson = newFormPerson;
                            var newPrimaryPhone = fpcmDAO.Create({
                                contactMethodTypeID: this.emergencyContact.primaryPhone.contactMethodType.typeID,
                                countryCode: this.emergencyContact.primaryPhone.countryCode ? this.emergencyContact.primaryPhone.countryCode : 1,
                                number: this.emergencyContact.primaryPhone.number,
                                isPrimaryNumber: true,
                            });
                            newPrimaryPhone.formPerson = newFormPerson;
                            var newSecondaryPhone = fpcmDAO.Create({
                                contactMethodTypeID: this.emergencyContact.secondaryPhone.contactMethodType.typeID,
                                countryCode: this.emergencyContact.secondaryPhone.countryCode ? this.emergencyContact.secondaryPhone.countryCode : 1,
                                number: this.emergencyContact.secondaryPhone.number,
                                isPrimaryNumber: false,
                            });
                            newSecondaryPhone.formPerson = newFormPerson;
                            if (this.formPersonRole === Pulse.Common.Enums.FormPersonRole.PrimaryContact) {
                                var fpaDAO = new DataAccess.FormPersonAddressDAO(this.common, this.breezeService, this.pulseContext);
                                var newFormPersonAddress = fpaDAO.Create({
                                    addressTypeID: Pulse.Common.Enums.AddressType.Home,
                                    countryTypeID: this.emergencyContact.address.countryType.typeID,
                                    stateTypeID: this.emergencyContact.address.stateType != null ? this.emergencyContact.address.stateType.typeID : null,
                                    address1: this.emergencyContact.address.address1,
                                    address2: this.emergencyContact.address.address2,
                                    city: this.emergencyContact.address.city,
                                    state: this.emergencyContact.address.state,
                                    country: this.emergencyContact.address.countryType.typeString,
                                    postalCode: this.emergencyContact.address.postalCode,
                                });
                                newFormPersonAddress.formPerson = newFormPerson;
                            }
                            this.breezeService.saveChanges(null, { resourceName: 'HSF_SaveEmergencyContact' })
                                .then(function (data) {
                                _this.myForm.$setPristine();
                                if (_this.pulseContext.isImpersonating) {
                                    _this.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUserId);
                                }
                                _this.onFormSaveSuccess();
                            })
                                .catch(function (error) {
                                _this.logError(error);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                                _this.submitted = false;
                            });
                        }
                        else {
                            this.myForm.$setPristine();
                            this.onFormSaveSuccess();
                        }
                    };
                    HSFEmergencyContactsDirCtrl.prototype.securityCheck = function () {
                    };
                    HSFEmergencyContactsDirCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.common.toggleSpinner(true);
                                _this.pulseContext.healthSafetyFormMgr.checkCanEdit(newVal)
                                    .then(function (result) {
                                    _this.canCreate = result;
                                    _this.canUpdate = result;
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                    };
                    HSFEmergencyContactsDirCtrl.controllerId = 'idpHsfEmergencyContactsCtrl';
                    return HSFEmergencyContactsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFEmergencyContactsDir.HSFEmergencyContactsDirCtrl = HSFEmergencyContactsDirCtrl;
            })(HSFEmergencyContactsDir = PulsePublic.HSFEmergencyContactsDir || (PulsePublic.HSFEmergencyContactsDir = {}));
            Pulse.app.directive(HSFEmergencyContactsDir.directiveId, [
                'common',
                function (c) { return new HSFEmergencyContactsDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var Managers = Pulse.Common.DataAccess.Managers;
            var HSFCheckOutDir = (function (_super) {
                __extends(HSFCheckOutDir, _super);
                function HSFCheckOutDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/hsf/idp-hsf-check-out.html";
                    _this.scope = {
                        userFormDetail: "=",
                        reqdFormContent: "=",
                        onFormSaveSuccess: "&",
                        onBackClick: "&",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        HSFCheckOutDir.HSFCheckOutDirCtrl];
                    return _this;
                }
                HSFCheckOutDir.directiveId = "idpHsfCheckOut";
                return HSFCheckOutDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFCheckOutDir = HSFCheckOutDir;
            (function (HSFCheckOutDir) {
                var HSFCheckOutDirCtrl = (function (_super) {
                    __extends(HSFCheckOutDirCtrl, _super);
                    function HSFCheckOutDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFCheckOutDirCtrl.controllerId) || this;
                        _this.participantIsTeen = false;
                        return _this;
                    }
                    HSFCheckOutDirCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.activationPromises.push(this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.StatisticsAnswerType)
                            .then(function (data) {
                            _this.yesNoTypes = data.filter(function (t) {
                                return t.typeID >= Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes && t.typeID <= Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                            });
                        }));
                        this.activateController();
                    };
                    HSFCheckOutDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _self = this;
                        this.myForm = scope.myForm;
                        this.onActivated = function (activationResults) {
                            var _this = this;
                            this.breezeService.getEntityManager().rejectChanges();
                            scope.$watch(function (scope) {
                                return _this.reqdFormContent;
                            }, function (newVal, oldVal) {
                                if (angular.isDefined(newVal) && angular.isDefined(_this.yesNoTypes) && newVal.canSelfSignOut != null) {
                                    if (newVal.canSelfSignOut) {
                                        _this.selectedYesNoTypes = _this.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                        });
                                    }
                                    else {
                                        _this.selectedYesNoTypes = _this.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                        });
                                    }
                                }
                            });
                            scope.$watch(function (scope) {
                                return _this.userFormDetail;
                            }, function (newVal, oldVal) {
                                if (angular.isDefined(newVal)) {
                                    _this.common.toggleSpinner(true);
                                    var termGroupDAO = new DataAccess.TermGroupDAO(_this.common, _this.breezeService, _this.pulseContext);
                                    termGroupDAO.getCurrentTermGroup()
                                        .then(function (data) {
                                        _this.pulseContext.healthSafetyFormMgr.getParticipant(_this.userFormDetail.userID)
                                            .then(function (participant) {
                                            _this.participantIsTeen = Managers.AgeMgr.isParticipantTeen(participant.dateOfBirth, data.year);
                                        })
                                            .catch(function (error) {
                                            _this.logError(error);
                                        })
                                            .finally(function () {
                                            _this.common.toggleSpinner(false);
                                        });
                                    })
                                        .catch(function (error) {
                                        _this.logError(error);
                                    })
                                        .finally(function () {
                                        _this.common.toggleSpinner(false);
                                    });
                                }
                            });
                        };
                    };
                    HSFCheckOutDirCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.myForm.$valid) {
                            if (this.myForm.$dirty || (this.participantIsTeen && (this.reqdFormContent.canSelfSignOut == null || !this.reqdFormContent.canSelfSignOut))) {
                                this.submitted = true;
                                this.common.toggleSpinner(true);
                                if (this.participantIsTeen && !this.reqdFormContent.canSelfSignOut) {
                                    this.reqdFormContent.canSelfSignOut = true;
                                }
                                var newReqFormContent = this.pulseContext.healthSafetyFormMgr.createReqdFormContent(this.reqdFormContent);
                                newReqFormContent.userFormDetailID = this.userFormDetail.userFormDetailID;
                                this.reqdFormContent.entityAspect.rejectChanges();
                                this.reqdFormContent = newReqFormContent;
                                this.breezeService.saveChanges(null, { resourceName: "HSF_SaveCheckInOut" })
                                    .then(function (data) {
                                    if (_this.pulseContext.isImpersonating) {
                                        _this.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUserId);
                                    }
                                    _this.myForm.$setPristine();
                                    _this.onFormSaveSuccess();
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                    _this.submitted = false;
                                });
                            }
                            else {
                                this.onFormSaveSuccess();
                            }
                        }
                    };
                    HSFCheckOutDirCtrl.prototype.yesNoClick = function () {
                        this.myForm.$setDirty();
                        this.reqdFormContent.canSelfSignOut = Pulse.Utils.JS.findByProperties(this.selectedYesNoTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
                        if (this.reqdFormContent.canSelfSignOut) {
                            this.reqdFormContent.isPickupAuthorized = true;
                            this.reqdFormContent.pickupCode = "";
                        }
                        else {
                            this.reqdFormContent.isPickupAuthorized = false;
                            this.reqdFormContent.approveSelfSignOut = false;
                        }
                    };
                    HSFCheckOutDirCtrl.prototype.securityCheck = function () {
                    };
                    HSFCheckOutDirCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.common.toggleSpinner(true);
                                _this.pulseContext.healthSafetyFormMgr.checkCanEdit(newVal)
                                    .then(function (result) {
                                    _this.canCreate = result;
                                    _this.canUpdate = result;
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                    };
                    HSFCheckOutDirCtrl.controllerId = "idpHsfCheckOutCtrl";
                    return HSFCheckOutDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFCheckOutDir.HSFCheckOutDirCtrl = HSFCheckOutDirCtrl;
            })(HSFCheckOutDir = PulsePublic.HSFCheckOutDir || (PulsePublic.HSFCheckOutDir = {}));
            Pulse.app.directive(HSFCheckOutDir.directiveId, ["common", function (c) { return new HSFCheckOutDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var HSFAuthContactsDir = (function (_super) {
                __extends(HSFAuthContactsDir, _super);
                function HSFAuthContactsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'forms/hsf/idp-hsf-auth-contacts.html';
                    _this.scope = {
                        userFormDetail: '=',
                        authPickupContacts: '=',
                        onFormSaveSuccess: '&',
                        firstTabIndex: '=',
                        onBackClick: '&',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        HSFAuthContactsDir.HSFAuthContactsDirCtrl,
                    ];
                    return _this;
                }
                HSFAuthContactsDir.directiveId = 'idpHsfAuthContacts';
                return HSFAuthContactsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFAuthContactsDir = HSFAuthContactsDir;
            (function (HSFAuthContactsDir) {
                var HSFAuthContactsDirCtrl = (function (_super) {
                    __extends(HSFAuthContactsDirCtrl, _super);
                    function HSFAuthContactsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFAuthContactsDirCtrl.controllerId) || this;
                        _this.phoneContactMethodTypes = null;
                        _this.breezeService.getEntityManager()
                            .rejectChanges();
                        return _this;
                    }
                    HSFAuthContactsDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.getPhoneContactMethodTypes());
                        this.activateController();
                    };
                    HSFAuthContactsDirCtrl.prototype.addAuthContact = function () {
                        var _this = this;
                        if (this.canCreate) {
                            this.myForm.$setDirty();
                            if (!angular.isArray(this.authPickupContacts)) {
                                this.authPickupContacts = new Array();
                            }
                            var fpDAO = new DataAccess.FormPersonDAO(this.common, this.breezeService, this.pulseContext);
                            var newFormPerson = fpDAO.Create({
                                userFormDetailID: this.userFormDetail.userFormDetailID,
                                formRoleTypeID: Enums.FormPersonRole.PickUp,
                                recordStateID: Enums.RecordStateType.Active,
                            });
                            var fpdDAO = new DataAccess.FormPersonDetailDAO(this.common, this.breezeService, this.pulseContext);
                            var newFormPersonDetail = fpdDAO.Create({
                                formPersonID: newFormPerson.formPersonID,
                            });
                            newFormPerson.formPersonDetails.push(newFormPersonDetail);
                            var fpcmDAO = new DataAccess.FormPersonContactMethodDAO(this.common, this.breezeService, this.pulseContext);
                            var newPrimaryPhone = fpcmDAO.Create({
                                formPersonID: newFormPerson.formPersonID,
                                contactMethodTypeID: null,
                                isPrimaryNumber: true,
                            });
                            newFormPerson.formPersonContactMethods.push(newPrimaryPhone);
                            this.authPickupContacts.push(newFormPerson);
                            this.common.$timeout(function () {
                                _this.common.scrollToHash('contact' + (_this.authPickupContacts.length - 1));
                            }, 100);
                        }
                    };
                    HSFAuthContactsDirCtrl.prototype.removeAuthContact = function (contact) {
                        var index = this.authPickupContacts.indexOf(contact);
                        if (index > -1) {
                            this.myForm.$setDirty();
                            contact.formPersonContactMethods[0].entityAspect.rejectChanges();
                            contact.formPersonDetails[0].entityAspect.rejectChanges();
                            contact.entityAspect.rejectChanges();
                            if (contact.formPersonID > 0) {
                                contact.recordStateID = Enums.RecordStateType.Archived;
                                contact.formPersonDetails[0].recordStateID = Enums.RecordStateType.Archived;
                                contact.formPersonContactMethods[0].recordStateID = Enums.RecordStateType.Archived;
                            }
                            else {
                                this.authPickupContacts.splice(index, 1);
                            }
                        }
                    };
                    HSFAuthContactsDirCtrl.prototype.getPhoneContactMethodTypes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.ContactMethod)
                            .then(function (data) {
                            _this.phoneContactMethodTypes = data.filter(function (t) {
                                return t.typeID <= Pulse.Common.Enums.ContactMethodType.CellPhone;
                            });
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    HSFAuthContactsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        this.myForm = scope.myForm;
                        var _self = this;
                        this.onActivated = function () {
                            this.breezeService.getEntityManager()
                                .rejectChanges();
                        };
                    };
                    HSFAuthContactsDirCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.myForm.$valid) {
                            if (this.myForm.$dirty && this.authPickupContacts.length > 0) {
                                this.submitted = true;
                                this.common.toggleSpinner(true);
                                this.authPickupContacts.forEach(function (contact) {
                                    contact.formPersonContactMethods.forEach(function (c) {
                                        c.areaCode = c.number;
                                    });
                                });
                                this.breezeService.saveChanges(null, { resourceName: 'HSF_SaveAuthPickupContacts' })
                                    .then(function (data) {
                                    if (_this.pulseContext.isImpersonating) {
                                        _this.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUserId);
                                    }
                                    _this.onFormSaveSuccess();
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                    _this.submitted = false;
                                });
                            }
                            else {
                                this.onFormSaveSuccess();
                            }
                        }
                    };
                    HSFAuthContactsDirCtrl.prototype.securityCheck = function () {
                    };
                    HSFAuthContactsDirCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.common.toggleSpinner(true);
                                _this.pulseContext.healthSafetyFormMgr.checkCanEdit(newVal)
                                    .then(function (result) {
                                    _this.canCreate = result;
                                    _this.canUpdate = result;
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                    };
                    HSFAuthContactsDirCtrl.controllerId = 'idpHsfAuthContactsCtrl';
                    return HSFAuthContactsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFAuthContactsDir.HSFAuthContactsDirCtrl = HSFAuthContactsDirCtrl;
            })(HSFAuthContactsDir = PulsePublic.HSFAuthContactsDir || (PulsePublic.HSFAuthContactsDir = {}));
            Pulse.app.directive(HSFAuthContactsDir.directiveId, [
                'common',
                function (c) { return new HSFAuthContactsDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HSFInsuranceDir = (function (_super) {
                __extends(HSFInsuranceDir, _super);
                function HSFInsuranceDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/hsf/idp-hsf-insurance.html";
                    _this.scope = {
                        userFormDetail: "=",
                        reqdFormContent: "=",
                        userFormInsurance: "=",
                        onFormSaveSuccess: "&",
                        onBackClick: "&",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        HSFInsuranceDir.HSFInsuranceDirCtrl];
                    return _this;
                }
                HSFInsuranceDir.directiveId = "idpHsfInsurance";
                return HSFInsuranceDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFInsuranceDir = HSFInsuranceDir;
            (function (HSFInsuranceDir) {
                var HSFInsuranceDirCtrl = (function (_super) {
                    __extends(HSFInsuranceDirCtrl, _super);
                    function HSFInsuranceDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFInsuranceDirCtrl.controllerId) || this;
                        _this.maxDOBDate = new Date();
                        _this.minDOBDate = new Date("01/01/1920");
                        _this.breezeService.getEntityManager().rejectChanges();
                        return _this;
                    }
                    HSFInsuranceDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.getYesNoTypes());
                        this.activateController();
                    };
                    HSFInsuranceDirCtrl.prototype.getYesNoTypes = function () {
                        var _this = this;
                        var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.StatisticsAnswerType)
                            .then(function (data) {
                            _this.yesNoTypes = data.filter(function (t) {
                                return t.typeID >= Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes && t.typeID <= Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                            });
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    HSFInsuranceDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _this = this;
                        this.myForm = scope.myForm;
                        this.$scope.$watch(function (scope) {
                            return _this.reqdFormContent;
                        }, function (rfc, oldVal) {
                            if (angular.isDefined(rfc)) {
                                if (rfc.noHealthInsInfo != null) {
                                    if (rfc.noHealthInsInfo) {
                                        _this.selectedYesNoTypes = _this.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                        });
                                    }
                                    else {
                                        _this.selectedYesNoTypes = _this.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                        });
                                    }
                                }
                            }
                        });
                    };
                    HSFInsuranceDirCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.myForm.$valid) {
                            if (this.myForm.$dirty) {
                                this.submitted = true;
                                this.common.toggleSpinner(true);
                                var newReqFormContent = this.pulseContext.healthSafetyFormMgr.createReqdFormContent(this.reqdFormContent);
                                newReqFormContent.userFormDetailID = this.userFormDetail.userFormDetailID;
                                this.reqdFormContent.entityAspect.rejectChanges();
                                this.reqdFormContent = newReqFormContent;
                                if (newReqFormContent.noHealthInsInfo) {
                                    this.userFormInsurance.entityAspect.rejectChanges();
                                    this.userFormInsurance.recordStateID = Enums.RecordStateType.Archived;
                                }
                                else {
                                    var newUserFormInsurance = this.pulseContext.healthSafetyFormMgr.createUserFormInsurance(this.userFormInsurance, true);
                                    newUserFormInsurance.userFormDetailID = this.userFormDetail.userFormDetailID;
                                    this.userFormInsurance.entityAspect.rejectChanges();
                                    this.userFormInsurance = newUserFormInsurance;
                                }
                                this.breezeService.saveChanges(null, { resourceName: "HSF_SaveInsurance" })
                                    .then(function (data) {
                                    if (_this.pulseContext.isImpersonating) {
                                        _this.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUserId);
                                    }
                                    _this.myForm.$setPristine();
                                    _this.onFormSaveSuccess();
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                    _this.submitted = false;
                                });
                            }
                            else {
                                this.onFormSaveSuccess();
                            }
                        }
                    };
                    HSFInsuranceDirCtrl.prototype.yesNoClick = function () {
                        this.myForm.$setDirty();
                        this.reqdFormContent.noHealthInsInfo = Pulse.Utils.JS.findByProperties(this.selectedYesNoTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.No }).length > 0;
                    };
                    HSFInsuranceDirCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.common.toggleSpinner(true);
                                _this.pulseContext.healthSafetyFormMgr.checkCanEdit(newVal)
                                    .then(function (result) {
                                    _this.canCreate = result;
                                    _this.canUpdate = result;
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                    };
                    HSFInsuranceDirCtrl.controllerId = "idpHsfInsuranceCtrl";
                    return HSFInsuranceDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFInsuranceDir.HSFInsuranceDirCtrl = HSFInsuranceDirCtrl;
            })(HSFInsuranceDir = PulsePublic.HSFInsuranceDir || (PulsePublic.HSFInsuranceDir = {}));
            Pulse.app.directive(HSFInsuranceDir.directiveId, ["common", function (c) { return new HSFInsuranceDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HSFHealthHistory = (function (_super) {
                __extends(HSFHealthHistory, _super);
                function HSFHealthHistory(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'forms/hsf/idp-hsf-health-history.html';
                    _this.scope = {
                        userFormDetail: '=',
                        reqdFormContent: '=',
                        userFormAllergies: '=',
                        onFormSaveSuccess: '&',
                        onBackClick: '&',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        HSFHealthHistory.HSFHealthHistoryCtrl,
                    ];
                    return _this;
                }
                HSFHealthHistory.directiveId = 'idpHsfHealthHistory';
                return HSFHealthHistory;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFHealthHistory = HSFHealthHistory;
            (function (HSFHealthHistory) {
                var HSFHealthHistoryCtrl = (function (_super) {
                    __extends(HSFHealthHistoryCtrl, _super);
                    function HSFHealthHistoryCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFHealthHistoryCtrl.controllerId) || this;
                        _this.participantIsTeen = false;
                        _this.asciiOnlyRegExp = PulseRegExp.ASCIIOnly;
                        _this.asciiOnlyRegExpErrorMsg = PulseRegExp.ASCIIOnlyErrorMessage;
                        return _this;
                    }
                    HSFHealthHistoryCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.activationPromises.push(this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.StatisticsAnswerType)
                            .then(function (data) {
                            _this.yesNoTypes = data.filter(function (t) {
                                return t.typeID >= Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes && t.typeID <= Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                            });
                        }));
                        this.activationPromises.push(this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.AllergyType)
                            .then(function (data) {
                            _this.allergyTypes = data.filter(function (t) {
                                return t.typeID == Pulse.Common.Enums.AllergyType.HayFever
                                    || t.typeID == Pulse.Common.Enums.AllergyType.InsectStings
                                    || t.typeID == Pulse.Common.Enums.AllergyType.Food
                                    || t.typeID == Pulse.Common.Enums.AllergyType.Other;
                            });
                        }));
                        this.activationPromises.push(this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.AllergySeverityType)
                            .then(function (data) {
                            _this.allergySeverityTypes = data;
                            _this.allergySeverityTypeLabels = _this.allergySeverityTypes.map(function (a) { return a.typeString; });
                            _this.allergySeverityTypeIds = _this.allergySeverityTypes.map(function (a) { return a.typeID; });
                        }));
                        this.activateController();
                    };
                    HSFHealthHistoryCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _self = this;
                        this.myForm = scope.myForm;
                        this.onActivated = function (activationResults) {
                            var _this = this;
                            this.breezeService.getEntityManager()
                                .rejectChanges();
                            this.sliderOptions = {
                                showTicks: true,
                                showTicksValues: false,
                                hideLimitLabels: true,
                                stepsArray: this.allergySeverityTypes.map(function (a) {
                                    return {
                                        value: a.typeID,
                                        legend: a.typeString,
                                    };
                                }),
                            };
                            scope.$watch(function (scope) {
                                return _this.reqdFormContent;
                            }, function (rfc, oldVal) {
                                if (angular.isDefined(rfc)) {
                                    if (rfc.hasMedConditions) {
                                        _self.selectedHasMedConditionsTypes = _this.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                        });
                                    }
                                    else {
                                        _self.selectedHasMedConditionsTypes = _this.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                        });
                                    }
                                    if (rfc.allergyDietaryRest != null) {
                                        if (rfc.allergyDietaryRest) {
                                            _self.selectedAllergyDietaryRestTypes = _this.yesNoTypes.filter(function (t) {
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                            });
                                        }
                                        else {
                                            _self.selectedAllergyDietaryRestTypes = _this.yesNoTypes.filter(function (t) {
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                            });
                                        }
                                    }
                                }
                            });
                        };
                    };
                    HSFHealthHistoryCtrl.prototype.setFormDirty = function () {
                        this.myForm.$setDirty();
                    };
                    HSFHealthHistoryCtrl.prototype.getAllergyForType = function (type) {
                        var allergy = Pulse.Utils.JS.findByProperties(this.userFormAllergies, { allergyTypeID: type.typeID })[0];
                        return allergy;
                    };
                    HSFHealthHistoryCtrl.prototype.toggleAllergySelected = function (type) {
                        this.myForm.$setDirty();
                        if (Pulse.Utils.JS.findByProperties(this.userFormAllergies, { allergyTypeID: type.typeID }).length > 0) {
                            var ufa = this.getAllergyForType(type);
                            ufa.entityAspect.rejectChanges();
                            if (ufa.entityAspect.entityState === breeze.EntityState.Unchanged) {
                                ufa.recordStateID = Enums.RecordStateType.Archived;
                            }
                            this.userFormAllergies.splice(this.userFormAllergies.indexOf(ufa), 1);
                        }
                        else {
                            var newUfa = this.breezeService.getEntityManager()
                                .createEntity('UserFormAllergy', {
                                userFormDetailID: this.userFormDetail.userFormDetailID,
                                allergyTypeID: type.typeID,
                                allergyName: type.typeString,
                                severityTypeID: Enums.AllergySeverityType.Mild,
                            });
                            this.userFormAllergies.push(newUfa);
                        }
                    };
                    HSFHealthHistoryCtrl.prototype.isAllergySelected = function (type) {
                        if (angular.isArray(this.userFormAllergies)) {
                            return this.userFormAllergies.indexOf(this.getAllergyForType(type)) > -1;
                        }
                        else {
                            return false;
                        }
                    };
                    HSFHealthHistoryCtrl.prototype.getPlaceholderTextForAllergyType = function (type) {
                        var placeholder = '';
                        switch (type.typeID) {
                            case Enums.AllergyType.Food:
                                placeholder = 'Please describe what food allergies and reactions (airborne, contact allergy, etc.)';
                                break;
                            case Enums.AllergyType.Other:
                                placeholder = 'Describe other allergies (such as medications, latex, etc.), include severity and reactions';
                                break;
                            default:
                                placeholder = 'Please describe severity/reaction';
                        }
                        return placeholder + ' (1000 Characters Maximum)';
                    };
                    HSFHealthHistoryCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.myForm.$valid) {
                            if (this.reqdFormContent.allergyDietaryRest && this.userFormAllergies.length < 1 && String.isNullOrWhitespace(this.reqdFormContent.dietaryComment)) {
                                this.common.showWarning('Please select at least one known allergy and/or provide details of any dietary restrictions');
                                return;
                            }
                            if (this.myForm.$dirty) {
                                this.submitted = true;
                                this.common.toggleSpinner(true);
                                if (!this.reqdFormContent.hasMedConditions) {
                                    this.reqdFormContent.medConditions = null;
                                }
                                if (!this.reqdFormContent.allergyDietaryRest) {
                                    this.reqdFormContent.dietaryComment = null;
                                    for (var i = this.userFormAllergies.length - 1; i >= 0; i--) {
                                        var allergy = this.userFormAllergies[i];
                                        allergy.entityAspect.rejectChanges();
                                        if (allergy.entityAspect.entityState === breeze.EntityState.Detached) {
                                            this.userFormAllergies.splice(this.userFormAllergies.indexOf(allergy), 1);
                                        }
                                        if (allergy.entityAspect.entityState === breeze.EntityState.Unchanged) {
                                            allergy.recordStateID = Enums.RecordStateType.Archived;
                                        }
                                    }
                                }
                                var newReqFormContent = this.pulseContext.healthSafetyFormMgr.createReqdFormContent(this.reqdFormContent);
                                newReqFormContent.userFormDetailID = this.userFormDetail.userFormDetailID;
                                if (this.reqdFormContent.entityAspect.entityState === breeze.EntityState.Modified) {
                                    this.reqdFormContent.entityAspect.rejectChanges();
                                }
                                this.reqdFormContent = newReqFormContent;
                                this.breezeService.saveChanges(null, { resourceName: 'HSF_HealthHistory' })
                                    .then(function (data) {
                                    if (_this.pulseContext.isImpersonating) {
                                        _this.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUserId);
                                    }
                                    _this.onFormSaveSuccess();
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                    _this.submitted = false;
                                });
                            }
                            else {
                                this.onFormSaveSuccess();
                            }
                        }
                    };
                    HSFHealthHistoryCtrl.prototype.hasMedConditionsYesNoClick = function () {
                        this.myForm.$setDirty();
                        this.reqdFormContent.hasMedConditions = Pulse.Utils.JS.findByProperties(this.selectedHasMedConditionsTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
                    };
                    HSFHealthHistoryCtrl.prototype.allergyDietaryRestYesNoClick = function () {
                        this.myForm.$setDirty();
                        this.reqdFormContent.allergyDietaryRest = Pulse.Utils.JS.findByProperties(this.selectedAllergyDietaryRestTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
                    };
                    HSFHealthHistoryCtrl.prototype.securityCheck = function () {
                    };
                    HSFHealthHistoryCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.common.toggleSpinner(true);
                                _this.pulseContext.healthSafetyFormMgr.checkCanEdit(newVal)
                                    .then(function (result) {
                                    _this.canCreate = result;
                                    _this.canUpdate = result;
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                    };
                    HSFHealthHistoryCtrl.controllerId = 'idpHsfHealthHistoryCtrl';
                    return HSFHealthHistoryCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFHealthHistory.HSFHealthHistoryCtrl = HSFHealthHistoryCtrl;
            })(HSFHealthHistory = PulsePublic.HSFHealthHistory || (PulsePublic.HSFHealthHistory = {}));
            Pulse.app.directive(HSFHealthHistory.directiveId, [
                'common',
                function (c) { return new HSFHealthHistory(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HSFMedications = (function (_super) {
                __extends(HSFMedications, _super);
                function HSFMedications(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/hsf/idp-hsf-medications.html";
                    _this.scope = {
                        userFormDetail: "=",
                        reqdFormContent: "=",
                        onFormSaveSuccess: "&",
                        onBackClick: "&",
                        isMedicAppMode: "=",
                        isMedicAppMedsOnly: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        HSFMedications.HSFMedicationsCtrl];
                    return _this;
                }
                HSFMedications.directiveId = "idpHsfMedications";
                return HSFMedications;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFMedications = HSFMedications;
            (function (HSFMedications) {
                var HSFMedicationsCtrl = (function (_super) {
                    __extends(HSFMedicationsCtrl, _super);
                    function HSFMedicationsCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFMedicationsCtrl.controllerId) || this;
                        _this.userFormMedications = Array();
                        _this.asciiOnlyRegExp = PulseRegExp.ASCIIOnly;
                        _this.asciiOnlyRegExpErrorMsg = PulseRegExp.ASCIIOnlyErrorMessage;
                        return _this;
                    }
                    HSFMedicationsCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.activationPromises.push(this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.StatisticsAnswerType)
                            .then(function (data) {
                            _this.yesNoTypes = data.filter(function (t) {
                                return t.typeID >= Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes && t.typeID <= Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                            });
                        }));
                        this.activationPromises.push(this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.MedicationTimeTaken)
                            .then(function (data) {
                            _this.medTimeTakenTypes = data;
                        }));
                        this.activateController();
                    };
                    HSFMedicationsCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        this.myForm = scope.myForm;
                    };
                    HSFMedicationsCtrl.prototype.onActivated = function (activationResults) {
                        var _this = this;
                        if (angular.isDefined(this.userFormDetail)) {
                            this.pulseContext.healthSafetyFormMgr.getUserFormMedicationsForUserFormDetail(this.userFormDetail.userFormDetailID)
                                .then(function (data) {
                                _this.userFormMedications = data;
                                if (_this.userFormMedications.length < 1) {
                                    _this.addMedication(false);
                                }
                                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                                    var med = data_1[_i];
                                    med.selectedMedTimeTakenTypes = Array();
                                    if (med.medSchedules.length > 0) {
                                        med.selectedMedTimeTakenTypes = _this.medTimeTakenTypes.filter(function (t) {
                                            return Pulse.Utils.JS.findByProperties(med.medSchedules, { timeTakenTypeID: t.typeID }).length > 0;
                                        });
                                    }
                                }
                            })
                                .catch(function (error) {
                                _this.logError(error);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                        if (angular.isDefined(this.reqdFormContent)) {
                            if (this.reqdFormContent.prescriptionReq != null && this.yesNoTypes) {
                                if (this.reqdFormContent.prescriptionReq) {
                                    this.selectedPrescriptionReqTypes = this.yesNoTypes.filter(function (t) {
                                        return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                    });
                                }
                                else {
                                    this.selectedPrescriptionReqTypes = this.yesNoTypes.filter(function (t) {
                                        return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                    });
                                }
                            }
                            if (this.reqdFormContent.epipen != null && this.yesNoTypes) {
                                if (this.reqdFormContent.epipen) {
                                    this.selectedEpipenTypes = this.yesNoTypes.filter(function (t) {
                                        return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                    });
                                }
                                else {
                                    this.selectedEpipenTypes = this.yesNoTypes.filter(function (t) {
                                        return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                    });
                                }
                            }
                        }
                    };
                    HSFMedicationsCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.myForm.$valid) {
                            if (this.myForm.$dirty) {
                                this.submitted = true;
                                this.common.toggleSpinner(true);
                                if (!this.reqdFormContent.prescriptionReq) {
                                    for (var i = this.userFormMedications.length - 1; i >= 0; i--) {
                                        this.deleteMedication(this.userFormMedications[i]);
                                    }
                                }
                                if (this.reqdFormContent.entityAspect.entityState === breeze.EntityState.Modified) {
                                    this.reqdFormContent.entityAspect.setAdded();
                                }
                                if (angular.isUndefined(this.reqdFormContent.canSelfSignOut) || this.reqdFormContent.canSelfSignOut == null) {
                                    this.reqdFormContent.canSelfSignOut = false;
                                }
                                this.userFormMedications.forEach(function (med) {
                                    med.medSchedules.forEach(function (schedule) {
                                        schedule.recordStateID = Pulse.Common.Enums.RecordStateType.Archived;
                                    });
                                    med.selectedMedTimeTakenTypes.forEach(function (type) {
                                        med.medSchedules.push(_this.pulseContext.healthSafetyFormMgr.createMedSchedule({
                                            userFormMedicationID: med.userFormMedicationID,
                                            timeTakenTypeID: type.typeID,
                                            timeTaken: type.typeString,
                                            recordStateID: Pulse.Common.Enums.RecordStateType.Active,
                                        }));
                                    });
                                });
                                this.breezeService.saveChanges(null, {
                                    resourceName: "HSF_HealthAndWellness",
                                    tag: this.pulseContext.healthSafetyFormMgr.isMedicAppMedsOnly
                                })
                                    .then(function (data) {
                                    if (_this.pulseContext.isImpersonating) {
                                        _this.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUserId);
                                    }
                                    _this.onFormSaveSuccess();
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                    _this.submitted = false;
                                });
                            }
                            else {
                                this.onFormSaveSuccess();
                            }
                        }
                    };
                    HSFMedicationsCtrl.prototype.addMedication = function (scroll) {
                        var _this = this;
                        if (scroll === void 0) { scroll = true; }
                        if (this.canCreate) {
                            var newMed = this.pulseContext.healthSafetyFormMgr.createUserFormMedication(null);
                            newMed.userFormDetailID = this.userFormDetail.userFormDetailID;
                            newMed.recordStateID = 1000;
                            this.userFormMedications.push(newMed);
                            if (scroll) {
                                this.common.$timeout(function () {
                                    _this.common.scrollToHash("med" + (_this.userFormMedications.length - 1));
                                }, 100);
                            }
                        }
                    };
                    HSFMedicationsCtrl.prototype.deleteMedication = function (med) {
                        this.myForm.$setDirty();
                        if (med.entityAspect.entityState !== breeze.EntityState.Detached) {
                            for (var i = med.medSchedules.length - 1; i >= 0; i--) {
                                var s = med.medSchedules[i];
                                s.entityAspect.rejectChanges();
                                if (s.entityAspect.entityState === breeze.EntityState.Unchanged) {
                                    s.recordStateID = Pulse.Common.Enums.RecordStateType.Archived;
                                }
                                else {
                                    med.medSchedules.splice(i, 1);
                                }
                            }
                            med.entityAspect.rejectChanges();
                            if (med.entityAspect.entityState === breeze.EntityState.Unchanged) {
                                med.recordStateID = Pulse.Common.Enums.RecordStateType.Archived;
                            }
                            else {
                                this.userFormMedications.splice(this.userFormMedications.indexOf(med), 1);
                            }
                        }
                    };
                    HSFMedicationsCtrl.prototype.prescriptionReqYesNoClick = function () {
                        this.myForm.$setDirty();
                        this.reqdFormContent.prescriptionReq = Pulse.Utils.JS.findByProperties(this.selectedPrescriptionReqTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
                        if (this.reqdFormContent.prescriptionReq) {
                            var msg = angular.element('#medsAdminPolicyModalContent').html();
                            this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Medication Dispensing Policy", " " + msg, null);
                        }
                        else {
                            this.selectedEpipenTypes = this.yesNoTypes.filter(function (t) {
                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                            });
                            this.epipenYesNoClick();
                        }
                    };
                    HSFMedicationsCtrl.prototype.epipenYesNoClick = function () {
                        this.myForm.$setDirty();
                        this.reqdFormContent.epipen = Pulse.Utils.JS.findByProperties(this.selectedEpipenTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
                        if (this.reqdFormContent.epipen) {
                            if (!this.reqdFormContent.prescriptionReq) {
                                this.selectedPrescriptionReqTypes = this.yesNoTypes.filter(function (t) {
                                    return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                });
                                this.prescriptionReqYesNoClick();
                            }
                        }
                    };
                    HSFMedicationsCtrl.prototype.securityCheck = function () {
                    };
                    HSFMedicationsCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.common.toggleSpinner(true);
                                _this.pulseContext.healthSafetyFormMgr.checkCanEdit(newVal)
                                    .then(function (result) {
                                    _this.canCreate = result;
                                    _this.canUpdate = result;
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                    };
                    HSFMedicationsCtrl.controllerId = "idpHsfMedicationsCtrl";
                    return HSFMedicationsCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFMedications.HSFMedicationsCtrl = HSFMedicationsCtrl;
            })(HSFMedications = PulsePublic.HSFMedications || (PulsePublic.HSFMedications = {}));
            Pulse.app.directive(HSFMedications.directiveId, ["common", function (c) { return new HSFMedications(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HSFSpecialNeedsImmunizations = (function (_super) {
                __extends(HSFSpecialNeedsImmunizations, _super);
                function HSFSpecialNeedsImmunizations(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'forms/hsf/idp-hsf-special-needs-immunizations.html';
                    _this.scope = {
                        userFormDetail: '=',
                        participant: '=',
                        reqdFormContent: '=',
                        onFormSaveSuccess: '&',
                        onBackClick: '&',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        HSFSpecialNeedsImmunizations.HSFSpecialNeedsImmunizationsCtrl,
                    ];
                    return _this;
                }
                HSFSpecialNeedsImmunizations.directiveId = 'idpHsfSpecialNeedsImmunizations';
                return HSFSpecialNeedsImmunizations;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFSpecialNeedsImmunizations = HSFSpecialNeedsImmunizations;
            (function (HSFSpecialNeedsImmunizations) {
                var HSFSpecialNeedsImmunizationsCtrl = (function (_super) {
                    __extends(HSFSpecialNeedsImmunizationsCtrl, _super);
                    function HSFSpecialNeedsImmunizationsCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFSpecialNeedsImmunizationsCtrl.controllerId) || this;
                        _this.covidImmunizationsManufDose1 = new Array();
                        _this.covidImmunizationsManufDose2 = new Array();
                        _this.covidImmunizationsManufBooster1 = new Array();
                        _this.covidImmunizationsManufBooster2 = new Array();
                        _this.dose1Required = false;
                        _this.breezeService.getEntityManager()
                            .rejectChanges();
                        return _this;
                    }
                    HSFSpecialNeedsImmunizationsCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.activationPromises.push(this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.StatisticsAnswerType)
                            .then(function (data) {
                            _this.yesNoTypes = data.filter(function (t) {
                                return t.typeID >= Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes && t.typeID <= Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                            });
                        }));
                        this.activationPromises.push(this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.ImmunizationRefusal)
                            .then(function (data) {
                            _this.immunizationRefusalTypes = data;
                        }));
                        this.companyTollFreePhone = this.pulseContext.companyTollFreePhone;
                        this.companyInternationalPhone = this.pulseContext.companyInternationalPhone;
                        this.maxCovidImmunizationDate = moment().toDate();
                        this.activateController();
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _this = this;
                        var _self = this;
                        this.myForm = scope.myForm;
                        scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.ImmunizationType)
                                    .then(function (data) {
                                    var _self = _this;
                                    _this.finalSubmitted = _this.userFormDetail.submittedDate != null;
                                    _this.covidImmunizationTypes = data.filter(function (x) { return x.typeString.indexOf('Covid') !== -1; });
                                    _this.immunizationTypes = data.filter(function (t) {
                                        return t.typeID == Pulse.Common.Enums.ImmunizationType.Tetanus
                                            || t.typeID == Pulse.Common.Enums.ImmunizationType.MeaslesMumpsRubella;
                                    });
                                    _this.pulseContext.healthSafetyFormMgr.getIsUserInternational(_this.userFormDetail.userFormDetailID).then(function (data) {
                                        if (data != null) {
                                            _this.isUSLocationOnly = !data;
                                        }
                                    });
                                    _this.pulseContext.healthSafetyFormMgr.getUserFormImmunizationsForUserFormDetail(_this.userFormDetail.userFormDetailID)
                                        .then(function (data) {
                                        _self.userFormImmunizations = data.filter(function (t) {
                                            return _self.getTypeForImmunization(t);
                                        });
                                        for (var _i = 0, _a = _this.userFormImmunizations; _i < _a.length; _i++) {
                                            var i = _a[_i];
                                            if (angular.isDefined(i.immunizedMonth) && angular.isDefined(i.immunizedYear)) {
                                                var date = moment();
                                                date.date(1);
                                                date.month(i.immunizedMonth - 1);
                                                date.year(i.immunizedYear);
                                                i.immunizedDate = date.toDate();
                                            }
                                        }
                                        for (var _b = 0, _c = _this.immunizationTypes; _b < _c.length; _b++) {
                                            var type = _c[_b];
                                            if (data.filter(function (ufi) { return ufi.immunizationTypeID == type.typeID; }).length == 0) {
                                                _this.userFormImmunizations.push(_this.pulseContext.healthSafetyFormMgr.createUserFormImmunization({
                                                    userFormDetailID: _this.userFormDetail.userFormDetailID,
                                                    immunizationTypeID: type.typeID,
                                                    immuneStatusTypeID: Pulse.Common.Enums.ImmunizationStatus.Immunized,
                                                }));
                                            }
                                        }
                                    })
                                        .catch(function (error) {
                                        _this.logError(error);
                                    })
                                        .finally(function () {
                                        _this.common.toggleSpinner(false);
                                    });
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                                _this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.CovidManufacturerType)
                                    .then(function (data) {
                                    var _self = _this;
                                    data.forEach(function (x) {
                                        var t = {};
                                        t.typeClassID = x.typeClassID;
                                        t.typeDescription = x.typeDescription;
                                        t.typeExtraLongString = x.typeExtraLongString;
                                        t.typeString = x.typeString;
                                        t.typeID = x.typeID;
                                        _this.covidImmunizationsManufDose1.push(t);
                                        _this.covidImmunizationsManufDose2.push(t);
                                        _this.covidImmunizationsManufBooster1.push(t);
                                        _this.covidImmunizationsManufBooster2.push(t);
                                    });
                                    _this.pulseContext.healthSafetyFormMgr.getIsUserInternational(_this.userFormDetail.userFormDetailID).then(function (data) {
                                        if (data != null) {
                                            _this.isUSLocationOnly = !data;
                                        }
                                    });
                                    _this.pulseContext.healthSafetyFormMgr.getUserFormImmunizationsForUserFormDetail(_this.userFormDetail.userFormDetailID)
                                        .then(function (data) {
                                        _self.userFormCovidImmunizations = data.filter(function (t) {
                                            return _self.getTypeForCovidImmunization(t);
                                        });
                                        if (_self.userFormCovidImmunizations != null && _self.userFormCovidImmunizations.length > 0) {
                                            _self.selectedIsCovidImmunizedTypes = _self.yesNoTypes.filter(function (t) {
                                                _self.reqdFormContent.isCovidImmunized = true;
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                            });
                                        }
                                        for (var _i = 0, _a = _this.userFormCovidImmunizations; _i < _a.length; _i++) {
                                            var i = _a[_i];
                                            if (angular.isDefined(i.immunizedMonth) && angular.isDefined(i.immunizedYear)) {
                                                var date = moment();
                                                date.date(i.immunizationDay);
                                                date.month(i.immunizedMonth - 1);
                                                date.year(i.immunizedYear);
                                                i.immunizedDate = date.toDate();
                                            }
                                        }
                                        _this.userFormCovidImmunizations.filter(function (o1) {
                                            _self.covidImmunizationsManufDose1.some(function (o2) {
                                                if (o1.manufacturerTypeID === o2.typeID && o1.immunizationTypeID == Enums.ImmunizationType.CovidDose1) {
                                                    var t = {};
                                                    t.typeID = o1.manufacturerTypeID;
                                                    t.typeString = o2.typeString;
                                                    _self.selectedDose1 = t;
                                                    _self.selectedDose1EffectiveDate = o1.immunizedDate;
                                                }
                                            });
                                            _self.covidImmunizationsManufDose2.some(function (o2) {
                                                if (o1.manufacturerTypeID === o2.typeID && o1.immunizationTypeID == Enums.ImmunizationType.CovidDose2) {
                                                    var t = {};
                                                    t.typeID = o1.manufacturerTypeID;
                                                    t.typeString = o2.typeString;
                                                    _self.selectedDose2 = t;
                                                    _self.selectedDose2EffectiveDate = o1.immunizedDate;
                                                }
                                            });
                                            _self.covidImmunizationsManufBooster1.some(function (o2) {
                                                if (o1.manufacturerTypeID === o2.typeID && o1.immunizationTypeID == Enums.ImmunizationType.CovidBooster1) {
                                                    var t = {};
                                                    t.typeID = o1.manufacturerTypeID;
                                                    t.typeString = o2.typeString;
                                                    _self.selectedBooster1 = t;
                                                    _self.selectedBooster1EffectiveDate = o1.immunizedDate;
                                                }
                                            });
                                            _self.covidImmunizationsManufBooster2.some(function (o2) {
                                                if (o1.manufacturerTypeID === o2.typeID && o1.immunizationTypeID == Enums.ImmunizationType.CovidBooster2) {
                                                    var t = {};
                                                    t.typeID = o1.manufacturerTypeID;
                                                    t.typeString = o2.typeString;
                                                    _self.selectedBooster2 = t;
                                                    _self.selectedBooster2EffectiveDate = o1.immunizedDate;
                                                }
                                            });
                                        });
                                        for (var _b = 0, _c = _this.covidImmunizationTypes; _b < _c.length; _b++) {
                                            var type = _c[_b];
                                            _this.userFormCovidImmunizations.push(_this.pulseContext.healthSafetyFormMgr.createUserFormImmunization({
                                                userFormDetailID: _this.userFormDetail.userFormDetailID,
                                                immunizationTypeID: type.typeID,
                                                immuneStatusTypeID: Pulse.Common.Enums.ImmunizationStatus.Immunized,
                                            }));
                                        }
                                    })
                                        .catch(function (error) {
                                        _this.logError(error);
                                    })
                                        .finally(function () {
                                        _this.common.toggleSpinner(false);
                                    });
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.participant;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.minImmunizationDate = _this.pulseContext.serverDateTime || new Date();
                                _this.maxImmunizationDate = _this.participant.dateOfBirth || moment()
                                    .subtract(19, 'year')
                                    .toDate();
                            }
                        });
                        this.onActivated = function (activationResults) {
                            var _this = this;
                            scope.$watch(function (scope) {
                                return _this.reqdFormContent;
                            }, function (rfc, oldVal) {
                                if (angular.isDefined(rfc)) {
                                    if (rfc.hasSpecialNeeds) {
                                        _self.selectedHasSpecialNeedsTypes = _self.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                        });
                                    }
                                    else {
                                        _self.selectedHasSpecialNeedsTypes = _self.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                        });
                                    }
                                    if (rfc.needsAide) {
                                        _self.selectedNeedsAideTypes = _self.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                        });
                                    }
                                    else {
                                        _self.selectedNeedsAideTypes = _self.yesNoTypes.filter(function (t) {
                                            return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                        });
                                    }
                                    if (rfc.isImmunized != null) {
                                        if (rfc.isImmunized) {
                                            _self.selectedIsImmunizedTypes = _self.yesNoTypes.filter(function (t) {
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                            });
                                        }
                                        else {
                                            _self.selectedIsImmunizedTypes = _self.yesNoTypes.filter(function (t) {
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                            });
                                            _self.selectedImmunizationRefusalTypes = _self.immunizationRefusalTypes.filter(function (t) {
                                                return t.typeID == rfc.notImmunizedTypeID;
                                            });
                                        }
                                    }
                                    rfc.isCovidImmunized = JSON.parse(localStorage.getItem('_covidImmunized'));
                                    if (rfc.isCovidImmunized != null) {
                                        if (!rfc.isCovidImmunized) {
                                            _this.userFormCovidImmunizations = [];
                                            _self.selectedIsCovidImmunizedTypes = _self.yesNoTypes.filter(function (t) {
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                            });
                                        }
                                        if (_this.userFormCovidImmunizations == null || _this.userFormCovidImmunizations.length == 0) {
                                            rfc.isCovidImmunized = false;
                                            _self.selectedIsCovidImmunizedTypes = _self.yesNoTypes.filter(function (t) {
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                            });
                                        }
                                        if (rfc.isCovidImmunized && _this.userFormCovidImmunizations != null && _this.userFormCovidImmunizations.length > 0) {
                                            _self.selectedIsCovidImmunizedTypes = _self.yesNoTypes.filter(function (t) {
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                            });
                                        }
                                        else if ((_this.submitted || _this.finalSubmitted) && _this.userFormCovidImmunizations.length == 0) {
                                            rfc.isCovidImmunized = false;
                                            _self.selectedIsCovidImmunizedTypes = _self.yesNoTypes.filter(function (t) {
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                                            });
                                        }
                                    }
                                    else if (rfc.isCovidImmunized == null) {
                                        if (_this.userFormCovidImmunizations != null && _this.userFormCovidImmunizations.length > 0) {
                                            rfc.isCovidImmunized = true;
                                            _self.selectedIsCovidImmunizedTypes = _self.yesNoTypes.filter(function (t) {
                                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes;
                                            });
                                        }
                                        else {
                                            rfc.isCovidImmunized = false;
                                            _self.selectedIsCovidImmunizedTypes = _self.yesNoTypes.filter(function (t) {
                                                return t.typeID == 0;
                                            });
                                        }
                                    }
                                }
                            });
                        };
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.reqdFormContent.isCovidImmunized) {
                            this.dose1Required = true;
                            if (this.selectedDose1 == null || this.selectedDose1EffectiveDate == null) {
                                this.myForm.$valid = false;
                            }
                            else {
                                this.myForm.$valid = true;
                            }
                        }
                        if (this.myForm.$valid) {
                            if (this.myForm.$dirty || !this.reqdFormContent.isCovidImmunized) {
                                this.submitted = true;
                                this.common.toggleSpinner(true);
                                var entitiesToSave = [];
                                for (var _i = 0, _a = this.userFormImmunizations; _i < _a.length; _i++) {
                                    var immunization = _a[_i];
                                    if (angular.isDate(immunization.immunizedDate)) {
                                        immunization.immunizedMonth = immunization.immunizedDate.getMonth() + 1;
                                        immunization.immunizedYear = immunization.immunizedDate.getFullYear();
                                    }
                                    if (!this.reqdFormContent.isImmunized) {
                                        immunization.entityAspect.rejectChanges();
                                        if (immunization.entityAspect.entityState !== breeze.EntityState.Detached) {
                                            immunization.recordStateID = Enums.RecordStateType.Archived;
                                            entitiesToSave.push(immunization);
                                        }
                                    }
                                    else {
                                        this.reqdFormContent.notImmunizedTypeID = null;
                                        if (immunization.entityAspect.entityState === breeze.EntityState.Modified) {
                                            var newImmunization = this.pulseContext.healthSafetyFormMgr.createUserFormImmunization(immunization);
                                            immunization.entityAspect.rejectChanges();
                                            immunization.recordStateID = Enums.RecordStateType.Archived;
                                            entitiesToSave.push(newImmunization);
                                        }
                                        entitiesToSave.push(immunization);
                                    }
                                }
                                for (var _b = 0, _c = this.userFormCovidImmunizations; _b < _c.length; _b++) {
                                    var immunization = _c[_b];
                                    if (immunization.immunizationTypeID != null) {
                                        if (this.reqdFormContent != null && this.reqdFormContent.isCovidImmunized == false) {
                                            this.myForm.$setPristine();
                                            immunization.entityAspect.rejectChanges();
                                            if (immunization.entityAspect.entityState !== breeze.EntityState.Detached) {
                                                immunization.recordStateID = Enums.RecordStateType.Archived;
                                                entitiesToSave.push(immunization);
                                            }
                                        }
                                        else {
                                            var newCovidImmunization = null;
                                            if (this.selectedDose1 != null && immunization.immunizationTypeID == Enums.ImmunizationType.CovidDose1) {
                                                newCovidImmunization = this.breezeService.getEntityManager().createEntity('UserFormImmunization', {
                                                    immunizationTypeID: Enums.ImmunizationType.CovidDose1,
                                                    manufacturerTypeID: this.selectedDose1.typeID,
                                                    immuneStatusTypeID: Enums.ImmunizationStatus.Immunized,
                                                    userFormDetailID: this.userFormDetail.userFormDetailID,
                                                    immunizationDay: this.selectedDose1EffectiveDate.getDate(),
                                                    immunizedMonth: this.selectedDose1EffectiveDate.getMonth() + 1,
                                                    immunizedYear: this.selectedDose1EffectiveDate.getFullYear(),
                                                });
                                            }
                                            if (this.selectedDose2 != null && immunization.immunizationTypeID == Enums.ImmunizationType.CovidDose2) {
                                                newCovidImmunization = this.breezeService.getEntityManager().createEntity('UserFormImmunization', {
                                                    immunizationTypeID: Enums.ImmunizationType.CovidDose2,
                                                    manufacturerTypeID: this.selectedDose2.typeID,
                                                    immuneStatusTypeID: Enums.ImmunizationStatus.Immunized,
                                                    userFormDetailID: this.userFormDetail.userFormDetailID,
                                                    immunizationDay: this.selectedDose2EffectiveDate.getDate(),
                                                    immunizedMonth: this.selectedDose2EffectiveDate.getMonth() + 1,
                                                    immunizedYear: this.selectedDose2EffectiveDate.getFullYear(),
                                                });
                                            }
                                            if (this.selectedBooster1 != null && immunization.immunizationTypeID == Enums.ImmunizationType.CovidBooster1) {
                                                newCovidImmunization = this.breezeService.getEntityManager().createEntity('UserFormImmunization', {
                                                    immunizationTypeID: Enums.ImmunizationType.CovidBooster1,
                                                    manufacturerTypeID: this.selectedBooster1.typeID,
                                                    immuneStatusTypeID: Enums.ImmunizationStatus.Immunized,
                                                    userFormDetailID: this.userFormDetail.userFormDetailID,
                                                    immunizationDay: this.selectedBooster1EffectiveDate.getDate(),
                                                    immunizedMonth: this.selectedBooster1EffectiveDate.getMonth() + 1,
                                                    immunizedYear: this.selectedBooster1EffectiveDate.getFullYear(),
                                                });
                                            }
                                            if (this.selectedBooster2 != null && immunization.immunizationTypeID == Enums.ImmunizationType.CovidBooster2) {
                                                newCovidImmunization = this.breezeService.getEntityManager().createEntity('UserFormImmunization', {
                                                    immunizationTypeID: Enums.ImmunizationType.CovidBooster2,
                                                    manufacturerTypeID: this.selectedBooster2.typeID,
                                                    immuneStatusTypeID: Enums.ImmunizationStatus.Immunized,
                                                    userFormDetailID: this.userFormDetail.userFormDetailID,
                                                    immunizationDay: this.selectedBooster2EffectiveDate.getDate(),
                                                    immunizedMonth: this.selectedBooster2EffectiveDate.getMonth() + 1,
                                                    immunizedYear: this.selectedBooster2EffectiveDate.getFullYear(),
                                                });
                                            }
                                            if (immunization.entityAspect.entityState === breeze.EntityState.Added) {
                                                if (newCovidImmunization != null)
                                                    entitiesToSave.push(newCovidImmunization);
                                            }
                                            else {
                                                immunization.entityAspect.rejectChanges();
                                                immunization.recordStateID = Enums.RecordStateType.Archived;
                                            }
                                            if (immunization.manufacturerTypeID != null)
                                                entitiesToSave.push(immunization);
                                        }
                                    }
                                }
                                if (!this.reqdFormContent.hasSpecialNeeds) {
                                    this.reqdFormContent.needsAide = false;
                                    this.reqdFormContent.spNeedsComment = '';
                                }
                                var newReqFormContent = this.pulseContext.healthSafetyFormMgr.createReqdFormContent(this.reqdFormContent);
                                newReqFormContent.userFormDetailID = this.userFormDetail.userFormDetailID;
                                if (this.reqdFormContent.entityAspect.entityState === breeze.EntityState.Modified) {
                                    this.reqdFormContent.entityAspect.rejectChanges();
                                }
                                this.reqdFormContent = newReqFormContent;
                                entitiesToSave.push(newReqFormContent);
                                if (this.userFormDetail.entityAspect.entityState == breeze.EntityState.Modified) {
                                    entitiesToSave.push(this.userFormDetail);
                                }
                                this.breezeService.saveChanges(entitiesToSave, { resourceName: 'HSF_SpecialNeedsImmunizations' })
                                    .then(function (data) {
                                    if (_this.pulseContext.isImpersonating) {
                                        _this.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUserId);
                                    }
                                    _this.onFormSaveSuccess();
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                    _this.submitted = false;
                                });
                            }
                            else {
                                this.onFormSaveSuccess();
                            }
                        }
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.hasSpecialNeedsYesNoClick = function () {
                        this.myForm.$setDirty();
                        this.reqdFormContent.hasSpecialNeeds = Pulse.Utils.JS.findByProperties(this.selectedHasSpecialNeedsTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
                        if (!this.reqdFormContent.hasSpecialNeeds) {
                            this.selectedNeedsAideTypes = this.yesNoTypes.filter(function (t) {
                                return t.typeID == Pulse.Common.Enums.SurveyStatisticsAnswerType.No;
                            });
                            this.needsAideYesNoClick();
                        }
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.needsAideYesNoClick = function () {
                        this.myForm.$setDirty();
                        this.reqdFormContent.needsAide = Pulse.Utils.JS.findByProperties(this.selectedNeedsAideTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
                        if (this.reqdFormContent.needsAide) {
                            var msg = angular.element('#needsAidePolicyModalContent')
                                .html();
                            this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Student Aide Information', ' ' + msg, null);
                        }
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.isImmunizedYesNoClick = function () {
                        this.myForm.$setDirty();
                        this.reqdFormContent.isImmunized = Pulse.Utils.JS.findByProperties(this.selectedIsImmunizedTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.isCovidImmunizedYesNoClick = function () {
                        this.reqdFormContent.isCovidImmunized = Pulse.Utils.JS.findByProperties(this.selectedIsCovidImmunizedTypes, { typeID: Pulse.Common.Enums.SurveyStatisticsAnswerType.Yes }).length > 0;
                        localStorage.setItem('_covidImmunized', this.reqdFormContent.isCovidImmunized.toString());
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.immunizationRefusalClick = function () {
                        this.myForm.$setDirty();
                        if (this.selectedImmunizationRefusalTypes.length > 0) {
                            this.reqdFormContent.notImmunizedTypeID = this.selectedImmunizationRefusalTypes[0].typeID;
                        }
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.getTypeForImmunization = function (ufi) {
                        return Pulse.Utils.JS.findByProperties(this.immunizationTypes, { typeID: ufi.immunizationTypeID })[0];
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.getTypeForCovidImmunization = function (ufi) {
                        return Pulse.Utils.JS.findByProperties(this.covidImmunizationTypes, { typeID: ufi.immunizationTypeID })[0];
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.securityCheck = function () {
                    };
                    HSFSpecialNeedsImmunizationsCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.common.toggleSpinner(true);
                                _this.pulseContext.healthSafetyFormMgr.checkCanEdit(newVal)
                                    .then(function (result) {
                                    _this.canCreate = result;
                                    _this.canUpdate = result;
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                    };
                    HSFSpecialNeedsImmunizationsCtrl.controllerId = 'idpHsfSpecialNeedsImmunizationsCtrl';
                    return HSFSpecialNeedsImmunizationsCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFSpecialNeedsImmunizations.HSFSpecialNeedsImmunizationsCtrl = HSFSpecialNeedsImmunizationsCtrl;
            })(HSFSpecialNeedsImmunizations = PulsePublic.HSFSpecialNeedsImmunizations || (PulsePublic.HSFSpecialNeedsImmunizations = {}));
            Pulse.app.directive(HSFSpecialNeedsImmunizations.directiveId, [
                'common',
                function (c) { return new HSFSpecialNeedsImmunizations(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HSFSchoolingDir = (function (_super) {
                __extends(HSFSchoolingDir, _super);
                function HSFSchoolingDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/hsf/idp-hsf-schooling.html";
                    _this.scope = {
                        userFormDetail: "=",
                        reqdFormContent: "=",
                        onFormSaveSuccess: "&",
                        onBackClick: "&",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        HSFSchoolingDir.HSFSchoolingDirCtrl];
                    return _this;
                }
                HSFSchoolingDir.directiveId = "idpHsfSchooling";
                return HSFSchoolingDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFSchoolingDir = HSFSchoolingDir;
            (function (HSFSchoolingDir) {
                var HSFSchoolingDirCtrl = (function (_super) {
                    __extends(HSFSchoolingDirCtrl, _super);
                    function HSFSchoolingDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFSchoolingDirCtrl.controllerId) || this;
                        _this.breezeService.getEntityManager().rejectChanges();
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(HSFSchoolingDirCtrl.prototype, "reqdFormContent", {
                        get: function () {
                            return this._reqdFormContent;
                        },
                        set: function (rfc) {
                            this._reqdFormContent = rfc;
                            if (this.breezeService) {
                                if (this.reqdFormContentNew) {
                                    this.reqdFormContentNew.entityAspect.setDeleted();
                                }
                                this.reqdFormContentNew = this.pulseContext.healthSafetyFormMgr.createReqdFormContent(this.reqdFormContent);
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(HSFSchoolingDirCtrl.prototype, "isReqdFormContentChanged", {
                        get: function () {
                            if (this.reqdFormContentNew) {
                                return this.reqdFormContent == null
                                    || this.reqdFormContent.assessmentComment != this.reqdFormContentNew.assessmentComment
                                    || this.reqdFormContent.schoolCity != this.reqdFormContentNew.schoolCity
                                    || this.reqdFormContent.schoolName != this.reqdFormContentNew.schoolName
                                    || this.reqdFormContent.schoolState != this.reqdFormContentNew.schoolState;
                            }
                            return false;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    HSFSchoolingDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        this.myForm = scope.myForm;
                    };
                    HSFSchoolingDirCtrl.prototype.onActivated = function (activationResults) {
                        if (!this.reqdFormContentNew) {
                            this.reqdFormContentNew = this.pulseContext.healthSafetyFormMgr.createReqdFormContent(this.reqdFormContent);
                        }
                        this.myForm.$setPristine();
                    };
                    HSFSchoolingDirCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.myForm.$dirty == false && this.myForm.$valid) {
                            this.myForm.$setPristine();
                            this.onFormSaveSuccess();
                        }
                        else {
                            if (this.myForm.$valid) {
                                if (this.isReqdFormContentChanged) {
                                    this.submitted = true;
                                    this.common.toggleSpinner(true, null, null, 0);
                                    this.breezeService.saveChanges(null, { resourceName: "HSF_SaveSchooling" })
                                        .then(function (data) {
                                        _this.myForm.$setPristine();
                                        if (_this.pulseContext.isImpersonating) {
                                            _this.common.updateCSImpersonationHeader(_this.pulseContext.actingAsUserId);
                                        }
                                        _this.onFormSaveSuccess();
                                    })
                                        .catch(function (error) {
                                        _this.logError(error);
                                    })
                                        .finally(function () {
                                        _this.common.toggleSpinner(false);
                                        _this.submitted = false;
                                    });
                                }
                                else {
                                    this.myForm.$setPristine();
                                    this.onFormSaveSuccess();
                                }
                            }
                        }
                    };
                    HSFSchoolingDirCtrl.prototype.securityCheck = function () {
                    };
                    HSFSchoolingDirCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.common.toggleSpinner(true);
                                _this.pulseContext.healthSafetyFormMgr.checkCanEdit(newVal)
                                    .then(function (result) {
                                    _this.canCreate = result;
                                    _this.canUpdate = result;
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                    };
                    HSFSchoolingDirCtrl.controllerId = "idpHsfSchoolingCtrl";
                    return HSFSchoolingDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFSchoolingDir.HSFSchoolingDirCtrl = HSFSchoolingDirCtrl;
            })(HSFSchoolingDir = PulsePublic.HSFSchoolingDir || (PulsePublic.HSFSchoolingDir = {}));
            Pulse.app.directive(HSFSchoolingDir.directiveId, ["common", function (c) { return new HSFSchoolingDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HSFAuthorizationDir = (function (_super) {
                __extends(HSFAuthorizationDir, _super);
                function HSFAuthorizationDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "forms/hsf/idp-hsf-authorization.html";
                    _this.scope = {
                        userFormDetail: "=",
                        showSubmissionHistory: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        HSFAuthorizationDir.HSFAuthorizationDirCtrl];
                    return _this;
                }
                HSFAuthorizationDir.directiveId = "idpHsfAuthorization";
                return HSFAuthorizationDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFAuthorizationDir = HSFAuthorizationDir;
            (function (HSFAuthorizationDir) {
                var HSFAuthorizationDirCtrl = (function (_super) {
                    __extends(HSFAuthorizationDirCtrl, _super);
                    function HSFAuthorizationDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFAuthorizationDirCtrl.controllerId) || this;
                        _this.iUnderstand = null;
                        _this.submissionHistoryLoaded = false;
                        _this.id = HSFAuthorizationDirCtrl._instanceCount++;
                        _this.formName = "hsfAuthSaveForm" + _this.id;
                        _this.activateController();
                        return _this;
                    }
                    HSFAuthorizationDirCtrl.prototype.getSubmissionHistory = function () {
                        var _this = this;
                        this.common.toggleSpinner(true, null, null, 0);
                        if (this.userFormDetail) {
                            var promise = this.pulseContext.healthSafetyFormMgr.getUserFormVersionsForUserFormDetail(this.userFormDetail.userFormDetailID)
                                .then(function (data) {
                                _this.submissionHistory = data;
                                return data;
                            })
                                .catch(function (error) {
                                _this.logError(error);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                            return promise;
                        }
                        else {
                            var deferred = this.common.$q.defer();
                            deferred.resolve(null);
                            return deferred.promise;
                        }
                    };
                    HSFAuthorizationDirCtrl.prototype.submissionHistoryClick = function () {
                        var _this = this;
                        if (angular.isArray(this.submissionHistory)) {
                            this.submissionHistoryLoaded = true;
                        }
                        else {
                            this.getSubmissionHistory().then(function (data) {
                                _this.submissionHistoryLoaded = true;
                            });
                        }
                    };
                    HSFAuthorizationDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.myForm = scope[this.formName];
                        var parentCtrl = (scope.$parent).vm;
                        scope.$watch(function (scope) {
                            return parentCtrl.myForm.$submitted;
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                _this.myForm.$setSubmitted();
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.isFormComplete = newVal.statusTypeID == Enums.FormStatus.Complete;
                                newVal.signature = "";
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.iCovidExposure;
                        }, function (newVal, oldVal) {
                            if (newVal != oldVal) {
                                _this.userFormDetail.entityAspect.setModified();
                                _this.myForm.$setDirty();
                                scope.$emit(Events.HSFAuthorizationChanged, _this.iUnderstand, _this.iCertify, _this.iCovidExposure, _this.iAuthMedical, _this.iFinResponsible, _this.iPickupStudent);
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.iAuthMedical;
                        }, function (newVal, oldVal) {
                            if (newVal != oldVal) {
                                _this.userFormDetail.entityAspect.setModified();
                                _this.myForm.$setDirty();
                                scope.$emit(Events.HSFAuthorizationChanged, _this.iUnderstand, _this.iCertify, _this.iCovidExposure, _this.iAuthMedical, _this.iFinResponsible, _this.iPickupStudent);
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.iPickupStudent;
                        }, function (newVal, oldVal) {
                            if (newVal != oldVal) {
                                _this.userFormDetail.entityAspect.setModified();
                                _this.myForm.$setDirty();
                                scope.$emit(Events.HSFAuthorizationChanged, _this.iUnderstand, _this.iCertify, _this.iCovidExposure, _this.iAuthMedical, _this.iFinResponsible, _this.iPickupStudent);
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.iFinResponsible;
                        }, function (newVal, oldVal) {
                            if (newVal != oldVal) {
                                _this.userFormDetail.entityAspect.setModified();
                                _this.myForm.$setDirty();
                                scope.$emit(Events.HSFAuthorizationChanged, _this.iUnderstand, _this.iCertify, _this.iCovidExposure, _this.iAuthMedical, _this.iFinResponsible, _this.iPickupStudent);
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.iUnderstand;
                        }, function (newVal, oldVal) {
                            if (newVal != oldVal) {
                                _this.userFormDetail.entityAspect.setModified();
                                _this.myForm.$setDirty();
                                scope.$emit(Events.HSFAuthorizationChanged, _this.iUnderstand, _this.iCertify, _this.iCovidExposure, _this.iAuthMedical, _this.iFinResponsible, _this.iPickupStudent);
                            }
                        });
                        scope.$watch(function (scope) {
                            return _this.iCertify;
                        }, function (newVal, oldVal) {
                            if (newVal != oldVal) {
                                _this.userFormDetail.entityAspect.setModified();
                                _this.myForm.$setDirty();
                                scope.$emit(Events.HSFAuthorizationChanged, _this.iUnderstand, _this.iCertify, _this.iCovidExposure, _this.iAuthMedical, _this.iFinResponsible, _this.iPickupStudent);
                            }
                        });
                    };
                    HSFAuthorizationDirCtrl.prototype.securityCheck = function () {
                    };
                    HSFAuthorizationDirCtrl.prototype.secureAllFeatures = function () {
                        var _this = this;
                        this.$scope.$watch(function (scope) {
                            return _this.userFormDetail;
                        }, function (newVal, oldVal) {
                            if (angular.isDefined(newVal)) {
                                _this.common.toggleSpinner(true);
                                _this.pulseContext.healthSafetyFormMgr.checkCanEdit(newVal)
                                    .then(function (result) {
                                    _this.canCreate = result;
                                    _this.canUpdate = result;
                                })
                                    .catch(function (error) {
                                    _this.logError(error);
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        });
                    };
                    HSFAuthorizationDirCtrl.controllerId = "idpHsfAuthorizationCtrl";
                    HSFAuthorizationDirCtrl._instanceCount = 0;
                    return HSFAuthorizationDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFAuthorizationDir.HSFAuthorizationDirCtrl = HSFAuthorizationDirCtrl;
            })(HSFAuthorizationDir = PulsePublic.HSFAuthorizationDir || (PulsePublic.HSFAuthorizationDir = {}));
            Pulse.app.directive(HSFAuthorizationDir.directiveId, ["common", function (c) { return new HSFAuthorizationDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HSFThanksDir = (function (_super) {
                __extends(HSFThanksDir, _super);
                function HSFThanksDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'forms/hsf/idp-hsf-thanks.html';
                    _this.scope = {
                        participant: '=',
                        userFormDetail: '=',
                        onContinueClick: '&',
                        onBackClick: '&',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        HSFThanksDir.HSFThanksDirCtrl,
                    ];
                    return _this;
                }
                HSFThanksDir.directiveId = 'idpHsfThanks';
                return HSFThanksDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFThanksDir = HSFThanksDir;
            (function (HSFThanksDir) {
                var HSFThanksDirCtrl = (function (_super) {
                    __extends(HSFThanksDirCtrl, _super);
                    function HSFThanksDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFThanksDirCtrl.controllerId) || this;
                        _this.incompleteParticipants = [];
                        _this.isReady = false;
                        _this.breezeService.getEntityManager()
                            .rejectChanges();
                        return _this;
                    }
                    Object.defineProperty(HSFThanksDirCtrl.prototype, "userFormDetail", {
                        get: function () {
                            return this._userFormDetail;
                        },
                        set: function (ufd) {
                            this._userFormDetail = ufd;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    HSFThanksDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.getIncompleteParticipants());
                        this.activationPromises.push(this.setIsReady());
                        this.activateController();
                    };
                    HSFThanksDirCtrl.prototype.getIncompleteParticipants = function () {
                        var _this = this;
                        this.common.toggleSpinner(true, null, null, 0);
                        var promise = this.pulseContext.healthSafetyFormMgr.getIncompleteParticipants()
                            .then(function (data) {
                            if (data == null) {
                                _this.incompleteParticipants = [];
                            }
                            else {
                                _this.incompleteParticipants = data;
                            }
                            return data;
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    HSFThanksDirCtrl.prototype.completeNextStudentForm = function (studentUserID) {
                        var url = String.format('{0}?{1}={2}&{3}={4}', Routes.HSF_NextStudent, QueryStringUtils.USER_ID, studentUserID, QueryStringUtils.USERFORMDETAIL_ID, this.userFormDetail.userFormDetailID);
                        this.$location.url(url);
                    };
                    HSFThanksDirCtrl.prototype.setIsReady = function () {
                        this.isReady = true;
                        var deferred = this.common.$q.defer();
                        deferred.resolve(null);
                        return deferred.promise;
                    };
                    HSFThanksDirCtrl.prototype.securityCheck = function () {
                    };
                    HSFThanksDirCtrl.prototype.secureAllFeatures = function () {
                    };
                    HSFThanksDirCtrl.controllerId = 'idpHsfThanksCtrl';
                    return HSFThanksDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFThanksDir.HSFThanksDirCtrl = HSFThanksDirCtrl;
            })(HSFThanksDir = PulsePublic.HSFThanksDir || (PulsePublic.HSFThanksDir = {}));
            Pulse.app.directive(HSFThanksDir.directiveId, ['common', function (c) { return new HSFThanksDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HSFCovidDir = (function (_super) {
                __extends(HSFCovidDir, _super);
                function HSFCovidDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'forms/hsf/idp-hsf-covid.html';
                    _this.scope = {
                        hideDetails: "=",
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        HSFCovidDir.HSFCovidDirCtrl,
                    ];
                    return _this;
                }
                HSFCovidDir.directiveId = 'idpHsfCovid';
                return HSFCovidDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HSFCovidDir = HSFCovidDir;
            (function (HSFCovidDir) {
                var HSFCovidDirCtrl = (function (_super) {
                    __extends(HSFCovidDirCtrl, _super);
                    function HSFCovidDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        return _super.call(this, $scope, $location, common, breezeService, pulseContext, HSFCovidDirCtrl.controllerId) || this;
                    }
                    HSFCovidDirCtrl.prototype.$onInit = function () {
                        this.activateController();
                    };
                    HSFCovidDirCtrl.controllerId = 'idpHsfCovidCtrl';
                    return HSFCovidDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HSFCovidDir.HSFCovidDirCtrl = HSFCovidDirCtrl;
            })(HSFCovidDir = PulsePublic.HSFCovidDir || (PulsePublic.HSFCovidDir = {}));
            Pulse.app.directive(HSFCovidDir.directiveId, ['common', function (c) { return new HSFCovidDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var RafEmailAddressListDir = (function (_super) {
                __extends(RafEmailAddressListDir, _super);
                function RafEmailAddressListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "refer-a-friend/idp-raf-email-address-list.html";
                    _this.scope = {
                        emailAddresses: "=",
                        myForm: "=",
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        RafEmailAddressListDir.RafEmailAddressListDirCtrl
                    ];
                    return _this;
                }
                RafEmailAddressListDir.directiveId = "idpRafEmailAddressList";
                return RafEmailAddressListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.RafEmailAddressListDir = RafEmailAddressListDir;
            (function (RafEmailAddressListDir) {
                var RafEmailAddressListDirCtrl = (function (_super) {
                    __extends(RafEmailAddressListDirCtrl, _super);
                    function RafEmailAddressListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RafEmailAddressListDirCtrl.controllerId) || this;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(RafEmailAddressListDirCtrl.prototype, "emailAddresses", {
                        get: function () {
                            return this._emailAddresses;
                        },
                        set: function (emailAddresses) {
                            this._emailAddresses = emailAddresses;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailAddressListDirCtrl.prototype, "myForm", {
                        get: function () {
                            return this._myForm;
                        },
                        set: function (form) {
                            this._myForm = form;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RafEmailAddressListDirCtrl.controllerId = "RafEmailAddressListDirCtrl";
                    return RafEmailAddressListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                RafEmailAddressListDir.RafEmailAddressListDirCtrl = RafEmailAddressListDirCtrl;
            })(RafEmailAddressListDir = PulsePublic.RafEmailAddressListDir || (PulsePublic.RafEmailAddressListDir = {}));
            Pulse.app.directive(RafEmailAddressListDir.directiveId, ["common", function (c) { return new RafEmailAddressListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var RafEmailAddressDir = (function (_super) {
                __extends(RafEmailAddressDir, _super);
                function RafEmailAddressDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "refer-a-friend/idp-raf-email-address.html";
                    _this.require = "^" + PulsePublic.RafEmailAddressListDir.directiveId;
                    _this.scope = {
                        emailAddress: "=",
                        index: '@',
                        myForm: "="
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        RafEmailAddressDir.RafEmailAddressDirCtrl];
                    return _this;
                }
                RafEmailAddressDir.directiveId = "idpRafEmailAddress";
                return RafEmailAddressDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.RafEmailAddressDir = RafEmailAddressDir;
            (function (RafEmailAddressDir) {
                var RafEmailAddressDirCtrl = (function (_super) {
                    __extends(RafEmailAddressDirCtrl, _super);
                    function RafEmailAddressDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RafEmailAddressDirCtrl.controllerId) || this;
                        _this.emailRegExpErrorMsg = PulseRegExp.EmailErrorMessage;
                        _this.id = RafEmailAddressDirCtrl._instanceCount++;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(RafEmailAddressDirCtrl.prototype, "id", {
                        get: function () {
                            return this._id;
                        },
                        set: function (n) {
                            this._id = n;
                            this.connectFormControl();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailAddressDirCtrl.prototype, "isRequired", {
                        get: function () {
                            if (this.index == 0) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailAddressDirCtrl.prototype, "myForm", {
                        get: function () {
                            return this._myForm;
                        },
                        set: function (form) {
                            this._myForm = form;
                            this.connectFormControl();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailAddressDirCtrl.prototype, "placeHolder", {
                        get: function () {
                            var n = Number(this.index);
                            if (n == 0) {
                                return "1st Friend's email";
                            }
                            else if (n == 1) {
                                return "2nd Friend's email";
                            }
                            else if (n == 2) {
                                return "3rd Friend's email";
                            }
                            else {
                                return (n + 1) + "th Friend's email";
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailAddressDirCtrl.prototype, "toolTip", {
                        get: function () {
                            if (this.emailAddressFormControl) {
                                if (this.emailAddressFormControl.$valid) {
                                    return "Email Address";
                                }
                                else {
                                    if (this.emailAddressFormControl.$error.required) {
                                        return "First email address is required";
                                    }
                                    else if (this.emailAddressFormControl.$error.email) {
                                        return "Email address is not valid";
                                    }
                                    else if (this.emailAddressFormControl.$error.maxlength) {
                                        return "The email address must be less than 200 characters.";
                                    }
                                }
                            }
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RafEmailAddressDirCtrl.prototype.connectFormControl = function () {
                        var _this = this;
                        if (this.common) {
                            this.common.$timeout(function () {
                                if (_this._myForm && isNaN(_this.id) == false && _this.id >= 0) {
                                    _this.emailAddressFormControl = _this._myForm['emailAddress' + _this.id];
                                }
                            }, 500);
                        }
                    };
                    RafEmailAddressDirCtrl.controllerId = "RafEmailAddressDirCtrl";
                    RafEmailAddressDirCtrl._instanceCount = 0;
                    return RafEmailAddressDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                RafEmailAddressDir.RafEmailAddressDirCtrl = RafEmailAddressDirCtrl;
            })(RafEmailAddressDir = PulsePublic.RafEmailAddressDir || (PulsePublic.RafEmailAddressDir = {}));
            Pulse.app.directive(RafEmailAddressDir.directiveId, ["common", function (c) { return new RafEmailAddressDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var RafEmailPopup = (function (_super) {
                __extends(RafEmailPopup, _super);
                function RafEmailPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "ScrollLockService",
                        RafEmailPopup.RafEmailPopupCtrl];
                    return _this;
                }
                RafEmailPopup.directiveId = "idpRafEmailPopup";
                return RafEmailPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.RafEmailPopup = RafEmailPopup;
            (function (RafEmailPopup) {
                var RafEmailPopupCtrl = (function (_super) {
                    __extends(RafEmailPopupCtrl, _super);
                    function RafEmailPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, RafEmailPopupCtrl.controllerId) || this;
                        _this.initDataObj = { rafCode: "", emailAddresses: [] };
                        _this.formName = "frmRafEmail";
                        _this.event_ShowPopup = Events.ShowRafEmailPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot
                            + Paths.PulsePublicDirective
                            + "refer-a-friend/idp-raf-email-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(RafEmailPopupCtrl.prototype, "emailClosing", {
                        get: function () {
                            return '<p>Thank you, <br/>' + this.pulseContext.actingAsUser.firstName + '</p>';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailPopupCtrl.prototype, "emailBody", {
                        get: function () {
                            var html = "";
                            var varText = "";
                            if (this.orderConfirmationInfo) {
                                for (var i = 0, j = this.orderConfirmationInfo.participants.length; i < j; i++) {
                                    var p = this.orderConfirmationInfo.participants[i];
                                    if (p.courses.length > 0) {
                                        var c = p.courses[0];
                                        html += "<p>" + p.firstName + " is going to iD Tech this summer. "
                                            + (p.genderTypeID == Enums.GenderType.Male ? "He" : "She")
                                            + " just enrolled in " + c.courseName + " at "
                                            + c.divisionName + " starting on " + c.startDateFormatted + ".</p>";
                                        if (p.courses.length > 1) {
                                            for (var k = 1, l = p.courses.length; k < l; k++) {
                                                c = p.courses[k];
                                                html += "<p>" + (p.genderTypeID == Enums.GenderType.Male ? "He" : "She")
                                                    + " is also attending " + c.courseName + " at "
                                                    + c.divisionName + " starting on " + c.startDateFormatted + ".</p>";
                                            }
                                        }
                                    }
                                }
                                varText = "When you signup";
                            }
                            else {
                                varText = "When you signup";
                            }
                            html += "<p>" + varText + ", you will <strong>save $25</strong> by using my refer-a-friend code\n          <strong>" + this.initDataObj.rafCode + "</strong>. My code can be combined with any other discount, and I know your child will love iD Tech.</p>\n          <p>Go to <a target='_blank' href='" + this.common.config.WWW_UrlRoot + "'>www.iDTech.com</a> to enroll.</p>";
                            return html;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailPopupCtrl.prototype, "emailSubject", {
                        get: function () {
                            return this.pulseContext.actingAsUser.firstName
                                + ' ' + this.pulseContext.actingAsUser.lastName
                                + ' Invites You to iD Tech Camps';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailPopupCtrl.prototype, "isOrderConfirmationRetrieved", {
                        get: function () {
                            return angular.isObject(this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailPopupCtrl.prototype, "plusImageUrl", {
                        get: function () {
                            return this.common.config.appRoot + "assets/images/reg-flow/plus.png";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafEmailPopupCtrl.prototype, "orderConfirmationInfo", {
                        get: function () {
                            if (!this.isOrderConfirmationRetrieved) {
                                return null;
                            }
                            else {
                                return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.orderConfirmationInfo;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RafEmailPopupCtrl.prototype.close = function () {
                        this.checkUnsavedDataBeforeNav = false;
                        _super.prototype.close.call(this);
                    };
                    RafEmailPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.breezeService.getEntityManager().rejectChanges();
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        this.title = "Share via Email";
                        if (initDataObj) {
                            this.initDataObj = initDataObj;
                        }
                        this.emailAddresses = this.initDataObj.emailAddresses;
                        if (!this.emailAddresses || !this.emailAddresses.length) {
                            this.emailAddresses = [];
                            this.emailAddresses[0] = { id: 0, email: null };
                            this.emailAddresses[1] = { id: 1, email: null };
                            this.emailAddresses[2] = { id: 2, email: null };
                        }
                        this.setLocalizedTexts();
                    };
                    RafEmailPopupCtrl.prototype.addEmailAddress = function () {
                        if (this.emailAddresses.length < 10) {
                            this.emailAddresses.push({ id: this.emailAddresses.length, email: null });
                        }
                        else {
                            this.common.showInfo("Your unique Refer-a-Friend code can be used by up to 10 friends.");
                        }
                    };
                    RafEmailPopupCtrl.prototype.sendEmail = function () {
                        var _this = this;
                        if (this.myForm.$valid) {
                            var emailAddresses = [];
                            for (var i = 0, j = this.emailAddresses.length; i < j; i++) {
                                var o = this.emailAddresses[i];
                                if (!String.isNullOrWhitespace(o.email)
                                    && emailAddresses.indexOf(o.email) == -1) {
                                    emailAddresses.push(o.email);
                                }
                            }
                            var personalizedMessage = this.personalizedMessage ?
                                '<p>' + this.personalizedMessage.replace(/(<([^>]+)>)/ig, "") + '</p>' : '';
                            var rafEmail = {
                                customerUserID: this.pulseContext.actingAsUser.userID,
                                emailAddresses: emailAddresses,
                                emailBody: personalizedMessage + this.emailBody + this.emailClosing,
                                emailSubject: this.emailSubject
                            };
                            this.common.toggleSpinner(true, null, null, 0);
                            this.pulseContext.regFlowMgr.paymentMgr.sendRafEmail(rafEmail)
                                .then(function () {
                                _this.close();
                                _this.common.$rootScope.$broadcast(Events.ShowRafEmailSentPopup, {
                                    size: '',
                                    initDataObj: _this.initDataObj,
                                });
                            })
                                .catch(function (err) {
                                _this.logError(err);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                    };
                    RafEmailPopupCtrl.controllerId = "RafEmailPopupCtrl";
                    return RafEmailPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                RafEmailPopup.RafEmailPopupCtrl = RafEmailPopupCtrl;
            })(RafEmailPopup = PulsePublic.RafEmailPopup || (PulsePublic.RafEmailPopup = {}));
            Pulse.app.directive(RafEmailPopup.directiveId, ["common", function (c) { return new RafEmailPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var RafEmailSentPopup = (function (_super) {
                __extends(RafEmailSentPopup, _super);
                function RafEmailSentPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "ScrollLockService",
                        RafEmailSentPopup.RafEmailSentPopupCtrl];
                    return _this;
                }
                RafEmailSentPopup.directiveId = "idpRafEmailSentPopup";
                return RafEmailSentPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.RafEmailSentPopup = RafEmailSentPopup;
            (function (RafEmailSentPopup) {
                var RafEmailSentPopupCtrl = (function (_super) {
                    __extends(RafEmailSentPopupCtrl, _super);
                    function RafEmailSentPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal, scrollLockService) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, RafEmailSentPopupCtrl.controllerId, scrollLockService) || this;
                        _this.initDataObj = { rafCode: "", emailAddresses: [] };
                        _this.formName = "frmRafSentEmail";
                        _this.event_ShowPopup = Events.ShowRafEmailSentPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "refer-a-friend/idp-raf-email-sent-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(RafEmailSentPopupCtrl.prototype, "orderConfirmationInfo", {
                        get: function () {
                            return this.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.orderConfirmationInfo;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RafEmailSentPopupCtrl.prototype.close = function () {
                        this.checkUnsavedDataBeforeNav = false;
                        _super.prototype.close.call(this);
                    };
                    RafEmailSentPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.breezeService.getEntityManager().rejectChanges();
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        this.title = "Email sent!";
                        if (initDataObj) {
                            this.initDataObj = initDataObj;
                        }
                        this.emailAddresses = this.initDataObj.emailAddresses;
                        if (!this.emailAddresses) {
                            this.emailAddresses = [];
                        }
                        this.setLocalizedTexts();
                    };
                    RafEmailSentPopupCtrl.prototype.addMoreFriends = function () {
                        this.close();
                        this.initDataObj.emailAddresses.length = 0;
                        this.common.$rootScope.$broadcast(Events.ShowRafEmailPopup, {
                            size: '',
                            initDataObj: this.initDataObj,
                        });
                    };
                    RafEmailSentPopupCtrl.controllerId = "RafEmailSentPopupCtrl";
                    return RafEmailSentPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                RafEmailSentPopup.RafEmailSentPopupCtrl = RafEmailSentPopupCtrl;
            })(RafEmailSentPopup = PulsePublic.RafEmailSentPopup || (PulsePublic.RafEmailSentPopup = {}));
            Pulse.app.directive(RafEmailSentPopup.directiveId, ["common", function (c) { return new RafEmailSentPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var RafShareDir = (function (_super) {
                __extends(RafShareDir, _super);
                function RafShareDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'refer-a-friend/idp-raf-share.html';
                    _this.scope = {
                        rafCode: '<',
                        showImage: '<?',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        RafShareDir.RafShareDirCtrl,
                    ];
                    return _this;
                }
                RafShareDir.directiveId = 'idpRafShare';
                return RafShareDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.RafShareDir = RafShareDir;
            (function (RafShareDir) {
                var RafShareDirCtrl = (function (_super) {
                    __extends(RafShareDirCtrl, _super);
                    function RafShareDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RafShareDirCtrl.controllerId) || this;
                        _this.showImage = true;
                        _this.emailAddress = "";
                        _this.emailAddressError = "";
                        _this.formName = 'rafShareForm';
                        _this.checkUnsavedDataBeforeNav = false;
                        try {
                            var win = window;
                            var clipboard = new win.ClipboardJS('#btnCopyCode');
                            if (clipboard) {
                                clipboard.on('success', function (e) {
                                    e.trigger.innerHTML = 'Copied';
                                    common.$timeout(function () {
                                        e.trigger.innerHTML = 'Copy Code';
                                    }, 5000);
                                });
                            }
                        }
                        catch (err) {
                            console.log(err);
                        }
                        return _this;
                    }
                    RafShareDirCtrl.prototype.$onInit = function () {
                        this.activateController();
                    };
                    Object.defineProperty(RafShareDirCtrl.prototype, "rafImageUrl", {
                        get: function () {
                            return this.common.config.appRoot + "assets/images/raf.png";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafShareDirCtrl.prototype, "letterImageUrl", {
                        get: function () {
                            return this.common.config.appRoot + "assets/images/reg-flow/letter.png";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafShareDirCtrl.prototype, "facebookShareUrl", {
                        get: function () {
                            return this.common.config.WWW_UrlRoot;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafShareDirCtrl.prototype, "facebookShareName", {
                        get: function () {
                            return "iD Tech summer camp!";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafShareDirCtrl.prototype, "facebookReferAFriendText", {
                        get: function () {
                            return String.format("We've enrolled at iD Tech Camps! Join us & save $25 when you use my unique referral code to register: {0}", this.rafCode);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafShareDirCtrl.prototype, "twitterShareUrl", {
                        get: function () {
                            return "www.iDTech.com";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(RafShareDirCtrl.prototype, "twitterReferAFriendText", {
                        get: function () {
                            return String.format("We've enrolled at @iDTechCamps! Join us & save $25 when you use my unique referral code to register: {0}", this.rafCode);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RafShareDirCtrl.prototype.showRafEmailPopup = function () {
                        var grp = document.getElementById("enterEmail");
                        var inputEmail = document.getElementById("inputEmail");
                        var btnSend = document.getElementById("btnSend");
                        var err = document.getElementById("emailAddressError");
                        grp.classList.remove('has-error');
                        err.style.display = 'none';
                        if (inputEmail.value.trim() == '') {
                            grp.classList.add('has-error');
                            err.style.display = 'block';
                            window.setTimeout(function () {
                                inputEmail.focus();
                                window.setTimeout(function () {
                                    inputEmail.blur();
                                    window.setTimeout(function () {
                                        inputEmail.focus();
                                    }, 250);
                                }, 250);
                            }, 0);
                            return;
                        }
                        else {
                            btnSend.blur();
                        }
                        var initDataObj = null;
                        if (this.emailAddress && this.emailAddress.trim() != '') {
                            initDataObj = {};
                            initDataObj.rafCode = this.rafCode;
                            initDataObj.emailAddresses = [];
                            initDataObj.emailAddresses[0] = { id: 0, email: this.emailAddress };
                            initDataObj.emailAddresses[1] = { id: 1, email: null };
                            initDataObj.emailAddresses[2] = { id: 2, email: null };
                        }
                        this.emailAddress = '';
                        this.common.$rootScope.$broadcast(Events.ShowRafEmailPopup, {
                            size: '',
                            initDataObj: initDataObj,
                        });
                    };
                    RafShareDirCtrl.prototype.showTandC = function () {
                        this.common.showHelpPopup(Directives.HelpPopup.HelpContentType.HelpTopic, 'Terms and Conditions', Directives.HelpPopup.HelpTopic.TermsAndConditionsRAF, 'rafTandCHelp');
                    };
                    RafShareDirCtrl.controllerId = 'RafShareDirCtrl';
                    return RafShareDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                RafShareDir.RafShareDirCtrl = RafShareDirCtrl;
            })(RafShareDir = PulsePublic.RafShareDir || (PulsePublic.RafShareDir = {}));
            Pulse.app.directive(RafShareDir.directiveId, [
                'common',
                function (c) { return new RafShareDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var RafStatusDir = (function (_super) {
                __extends(RafStatusDir, _super);
                function RafStatusDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'refer-a-friend/idp-raf-status.html';
                    _this.scope = {
                        referrals: '=',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        RafStatusDir.RafStatusDirCtrl,
                    ];
                    return _this;
                }
                RafStatusDir.directiveId = 'idpRafStatus';
                return RafStatusDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.RafStatusDir = RafStatusDir;
            (function (RafStatusDir) {
                var RafStatusDirCtrl = (function (_super) {
                    __extends(RafStatusDirCtrl, _super);
                    function RafStatusDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, RafStatusDirCtrl.controllerId) || this;
                        _this.hasReferrals = false;
                        var d = new Date();
                        _this.year = d.getFullYear();
                        return _this;
                    }
                    RafStatusDirCtrl.prototype.$onInit = function () {
                        this.activateController();
                    };
                    RafStatusDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl, transclude);
                        scope.$watch(function (scope) {
                            return _this.referrals;
                        }, function (newValue, oldValue) {
                            _this.hasReferrals = !!(_this.referrals && _this.referrals.length);
                        });
                    };
                    RafStatusDirCtrl.prototype.onChangeStatus = function (referral) {
                        this.common.$rootScope.$broadcast(Events.ShowRafAdminStatusPopup, {
                            size: '',
                            initDataObj: { referral: referral }
                        });
                    };
                    RafStatusDirCtrl.prototype.onSwitchAccount = function (referral) {
                        this.common.toggleSpinner(true);
                        var url = this.common.config.pulse1x_AdminAppRoot + Paths.Pulse1x_Admin_CSImpersonateCustomer;
                        var params = {};
                        params[QueryStringUtils.USER_IMPERSONATE_ID] = referral.couponUsedFor_UserID;
                        params[QueryStringUtils.TARGET_URL] = referral.couponUsedFor_UserID;
                        url = Pulse.Utils.QueryStringUtils.AddOrSetQSParams(url, params);
                        this.common.redirectParentWindow(url);
                    };
                    RafStatusDirCtrl.controllerId = 'RafStatusDirCtrl';
                    return RafStatusDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                RafStatusDir.RafStatusDirCtrl = RafStatusDirCtrl;
            })(RafStatusDir = PulsePublic.RafStatusDir || (PulsePublic.RafStatusDir = {}));
            Pulse.app.directive(RafStatusDir.directiveId, [
                'common',
                function (c) { return new RafStatusDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var OnlineLessonStudentsDir = (function (_super) {
            __extends(OnlineLessonStudentsDir, _super);
            function OnlineLessonStudentsDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/idp-online-lesson-students.html";
                _this.scope = {
                    studentSessions: "<",
                    selectedStudentId: "<?",
                    selectedParentOrderDetailId: "<?",
                    selectedOrderDetailId: "<?"
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OnlineLessonStudentsDir.OnlineLessonStudentsDirCtrl];
                return _this;
            }
            OnlineLessonStudentsDir.directiveId = "idpOnlineLessonStudents";
            return OnlineLessonStudentsDir;
        }(Pulse.Common.BaseDirective));
        Directives.OnlineLessonStudentsDir = OnlineLessonStudentsDir;
        (function (OnlineLessonStudentsDir) {
            var OnlineLessonStudentsDirCtrl = (function (_super) {
                __extends(OnlineLessonStudentsDirCtrl, _super);
                function OnlineLessonStudentsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OnlineLessonStudentsDirCtrl.controllerId) || this;
                    _this.handleStudentNotesChanged = function (event, studentUserID) {
                        var student = _this.studentSessionsCopy.filter(function (s) { return s.studentUserID == studentUserID; });
                        if (student && student.length == 1) {
                            _this.pulseContext.onlinePrivateLessonMgr.getStudentNotes(studentUserID).then(function (data) {
                                if (data != null) {
                                    student[0].studentNotes = data;
                                }
                            })
                                .catch(function (error) {
                                _this.logError(error);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                    };
                    $scope.$on(Events.OPLStudentNoteUpdated, _this.handleStudentNotesChanged);
                    $scope.$on(Events.OPLStudentNoteDeleted, _this.handleStudentNotesChanged);
                    $scope.$on(Events.OPLHasAvailableSessionsUpdated, function (event, studentSession) {
                        if (angular.isDefined(studentSession)) {
                            _this.studentSessionsCopy.forEach(function (ss) {
                                if (ss.studentUserID == studentSession.studentUserID) {
                                    ss.hasLessonsAvailable = studentSession.hasLessonsAvailable;
                                }
                            });
                        }
                    });
                    return _this;
                }
                OnlineLessonStudentsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                    var _this = this;
                    _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl);
                    scope.$watch(function (scope) {
                        return _this.studentSessions;
                    }, function (newVal, oldVal) {
                        _this.studentSessionsCopy = angular.copy(_this.studentSessions);
                        _this.studentSessionsCopy.forEach(function (ss) {
                            ss.onlineSessions = ss.onlineSessions.filter(function (s) { return s.isPartOfPackage === false; });
                            ss.onlineSessions.sort(function (a, b) {
                                if (a.purchaseDate > b.purchaseDate)
                                    return 1;
                                if (a.purchaseDate < b.purchaseDate)
                                    return -1;
                                return 0;
                            });
                        });
                        angular.forEach(_this.studentSessionsCopy, function (student) {
                            student.isActive == false;
                        });
                        if (angular.isArray(_this.studentSessionsCopy) && _this.studentSessionsCopy.length > 0 && !_this.studentSessionsCopy[0].isActive) {
                            if (_this.selectedStudentId) {
                                var studentSession = _this.studentSessionsCopy.filter(function (ss) { return ss.studentUserID == _this.selectedStudentId; })[0];
                                if (studentSession) {
                                    var index = _this.studentSessionsCopy.indexOf(studentSession);
                                    _this.getStudentNotes(index);
                                }
                            }
                        }
                    }, false);
                };
                OnlineLessonStudentsDirCtrl.prototype.getStudentNotes = function (index) {
                    var _this = this;
                    this.common.toggleSpinner(true);
                    var student = this.studentSessionsCopy[index];
                    if (student.isReadyToShow) {
                        student.isActive = !student.isActive;
                        this.common.toggleSpinner(false);
                        return;
                    }
                    var userID = student.studentUserID;
                    student.isActive = true;
                    return this.pulseContext.onlinePrivateLessonMgr.getStudentNotes(userID).then(function (data) {
                        if (data != null) {
                            student.studentNotes = data;
                        }
                        student.isReadyToShow = true;
                        student.isActive = true;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                };
                OnlineLessonStudentsDirCtrl.prototype.onCloseClick = function (student) {
                    student.isActive = false;
                    this.common.scrollToHash('heading' + student.studentUserID);
                };
                OnlineLessonStudentsDirCtrl.controllerId = "OnlineLessonStudentsDirCtrl";
                return OnlineLessonStudentsDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OnlineLessonStudentsDir.OnlineLessonStudentsDirCtrl = OnlineLessonStudentsDirCtrl;
        })(OnlineLessonStudentsDir = Directives.OnlineLessonStudentsDir || (Directives.OnlineLessonStudentsDir = {}));
        Pulse.app.directive(OnlineLessonStudentsDir.directiveId, ["common", function (c) { return new OnlineLessonStudentsDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var DataAccess = Pulse.Common.DataAccess;
        var TimeZoneMgr = DataAccess.Managers.TimeZoneMgr;
        var OnlineLessonProductsDir = (function (_super) {
            __extends(OnlineLessonProductsDir, _super);
            function OnlineLessonProductsDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/idp-online-lesson-products.html";
                _this.scope = {
                    sessions: "<?",
                    student: "<?",
                    parentProdID: "<?",
                    selectedParentOrderDetailId: "<?",
                    selectedOrderDetailId: "<?",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OnlineLessonProductsDir.OnlineLessonProductsDirCtrl];
                return _this;
            }
            OnlineLessonProductsDir.directiveId = "idpOnlineLessonProducts";
            return OnlineLessonProductsDir;
        }(Pulse.Common.BaseDirective));
        Directives.OnlineLessonProductsDir = OnlineLessonProductsDir;
        (function (OnlineLessonProductsDir) {
            var OnlineLessonProductsDirCtrl = (function (_super) {
                __extends(OnlineLessonProductsDirCtrl, _super);
                function OnlineLessonProductsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OnlineLessonProductsDirCtrl.controllerId) || this;
                    _this.serverDateTime = moment(_this.pulseContext.serverDateTime).startOf('day').toDate();
                    $scope.$on(Events.OPLSessionSummaryUpdated, function (event, sessionSummaryDTO) {
                        if (sessionSummaryDTO) {
                            _this.sessions.forEach(function (s) {
                                if (s.orderDetailID == sessionSummaryDTO.orderDetailID) {
                                    s.statusTypeID = sessionSummaryDTO.statusTypeID;
                                    s.statusStr = sessionSummaryDTO.statusStr;
                                    s.instructorName = sessionSummaryDTO.instructorName;
                                    s.subjectStr = sessionSummaryDTO.subjectStr;
                                    s.subjectTypeID = sessionSummaryDTO.subjectTypeID;
                                    s.skillID = sessionSummaryDTO.skillID;
                                    s.skillStr = sessionSummaryDTO.skillStr;
                                    s.startDateTimeUTC = sessionSummaryDTO.startDateTimeUTC;
                                    s.endDateTimeUTC = sessionSummaryDTO.endDateTimeUTC;
                                    s.expiryDate = sessionSummaryDTO.expiryDate;
                                }
                                if (angular.isDefined(sessionSummaryDTO.parentOrderDetailID) && s.orderDetailID == sessionSummaryDTO.parentOrderDetailID) {
                                    _this.pulseContext.onlinePrivateLessonMgr.getAvailableSessionsCount(sessionSummaryDTO.parentOrderDetailID).then(function (data) {
                                        if (angular.isNumber(data)) {
                                            s.availableSessionsCount = data;
                                        }
                                        else {
                                            s.availableSessionsCount = 0;
                                        }
                                    })
                                        .catch(function (error) {
                                        _this.logError(error);
                                    })
                                        .finally(function () {
                                        _this.common.toggleSpinner(false);
                                    });
                                }
                            });
                        }
                    });
                    return _this;
                }
                OnlineLessonProductsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                    var _this = this;
                    var self = this;
                    if (this.selectedParentOrderDetailId) {
                        var selectedSession = this.sessions.filter(function (s) { return s.orderDetailID == _this.selectedParentOrderDetailId; })[0];
                        if (selectedSession) {
                            var index = this.sessions.indexOf(selectedSession);
                            this.loadSessionSummary(index)
                                .then(function () {
                                _this.common.scrollToHash('SummaryID_' + self.selectedOrderDetailId, 100);
                            });
                        }
                    }
                };
                OnlineLessonProductsDirCtrl.prototype.getSessionStatusStr = function (session) {
                    return this.pulseContext.onlinePrivateLessonMgr.getSessionStatusStr(session);
                };
                OnlineLessonProductsDirCtrl.prototype.loadSessionSummary = function (index) {
                    var _this = this;
                    this.common.toggleSpinner(true);
                    var session = this.sessions[index];
                    if (session.isReadyToShow) {
                        session.isActive = !session.isActive;
                        this.common.toggleSpinner(false);
                        return;
                    }
                    var orderDetailID = session.orderDetailID;
                    var timezoneStr = TimeZoneMgr.browserTimeZoneStr;
                    session.isActive = true;
                    return this.pulseContext.onlinePrivateLessonMgr.getSessionSummaries(orderDetailID, timezoneStr).then(function (data) {
                        if (data != null) {
                            session.sessionSummaries = data;
                            if (_this.selectedOrderDetailId) {
                                var selectedSummary = session.sessionSummaries.filter(function (s) { return s.orderDetailID === _this.selectedOrderDetailId; })[0];
                                selectedSummary.isReadyToShow = selectedSummary.isActive = true;
                            }
                        }
                        session.isReadyToShow = true;
                        session.isActive = true;
                    })
                        .catch(function (error) {
                        _this.logError(error);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                };
                OnlineLessonProductsDirCtrl.prototype.showExpiredLabel = function (session) {
                    var isExpired = this.pulseContext.onlinePrivateLessonMgr.isSessionExpired(session);
                    return isExpired && (session.statusTypeID == Enums.OPLStatus.AutoExpired || session.statusTypeID == Enums.OPLStatus.Unscheduled || session.statusTypeID == Enums.OPLStatus.Scheduled);
                };
                OnlineLessonProductsDirCtrl.prototype.isSessionAvailable = function (session) {
                    return this.pulseContext.onlinePrivateLessonMgr.isSessionAvailable(session);
                };
                OnlineLessonProductsDirCtrl.controllerId = "OnlineLessonProductsDirCtrl";
                return OnlineLessonProductsDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OnlineLessonProductsDir.OnlineLessonProductsDirCtrl = OnlineLessonProductsDirCtrl;
        })(OnlineLessonProductsDir = Directives.OnlineLessonProductsDir || (Directives.OnlineLessonProductsDir = {}));
        Pulse.app.directive(OnlineLessonProductsDir.directiveId, ["common", function (c) { return new OnlineLessonProductsDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var OnlineLessonSessionsDir = (function (_super) {
            __extends(OnlineLessonSessionsDir, _super);
            function OnlineLessonSessionsDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/idp-online-lesson-sessions.html";
                _this.scope = {
                    sessionSummaries: "<?",
                    parentProdId: "<?",
                    studentUserId: "<?"
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OnlineLessonSessionsDir.OnlineLessonSessionsDirCtrl];
                return _this;
            }
            OnlineLessonSessionsDir.directiveId = "idpOnlineLessonSessions";
            return OnlineLessonSessionsDir;
        }(Pulse.Common.BaseDirective));
        Directives.OnlineLessonSessionsDir = OnlineLessonSessionsDir;
        (function (OnlineLessonSessionsDir) {
            var OnlineLessonSessionsDirCtrl = (function (_super) {
                __extends(OnlineLessonSessionsDirCtrl, _super);
                function OnlineLessonSessionsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OnlineLessonSessionsDirCtrl.controllerId) || this;
                    _this.serverDateTime = moment(_this.pulseContext.serverDateTime).startOf('day').toDate();
                    _this.activationPromises.push(_this.pulseContext.onlinePrivateLessonMgr.getOPLInstructors()
                        .then(function (data) {
                        _this.instructors = data;
                    }));
                    _this.activateController();
                    return _this;
                }
                OnlineLessonSessionsDirCtrl.prototype.getSessionStatusStr = function (session) {
                    return this.pulseContext.onlinePrivateLessonMgr.getSessionStatusStr(session);
                };
                OnlineLessonSessionsDirCtrl.prototype.showExpiredLabel = function (session) {
                    var isExpired = this.pulseContext.onlinePrivateLessonMgr.isSessionExpired(session);
                    return isExpired && (session.statusTypeID == Enums.OPLStatus.AutoExpired || session.statusTypeID == Enums.OPLStatus.Unscheduled || session.statusTypeID == Enums.OPLStatus.Scheduled);
                };
                OnlineLessonSessionsDirCtrl.prototype.isSessionAvailable = function (session) {
                    return this.pulseContext.onlinePrivateLessonMgr.isSessionAvailable(session);
                };
                OnlineLessonSessionsDirCtrl.prototype.loadSessionSummary = function (index) {
                    this.common.toggleSpinner(true);
                    var product = this.sessionSummaries[index];
                    if (product.isReadyToShow) {
                        product.isActive = !product.isActive;
                        this.common.toggleSpinner(false);
                        return;
                    }
                    product.isActive = true;
                    product.isReadyToShow = true;
                    this.common.toggleSpinner(false);
                };
                OnlineLessonSessionsDirCtrl.controllerId = "OnlineLessonSessionsDirCtrl";
                return OnlineLessonSessionsDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OnlineLessonSessionsDir.OnlineLessonSessionsDirCtrl = OnlineLessonSessionsDirCtrl;
        })(OnlineLessonSessionsDir = Directives.OnlineLessonSessionsDir || (Directives.OnlineLessonSessionsDir = {}));
        Pulse.app.directive(OnlineLessonSessionsDir.directiveId, ["common", function (c) { return new OnlineLessonSessionsDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var OnlineLessonSessionSummaryDir = (function (_super) {
            __extends(OnlineLessonSessionSummaryDir, _super);
            function OnlineLessonSessionSummaryDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/idp-online-lesson-session-summary.html";
                _this.scope = {
                    sessionSummary: "<?",
                    instructors: "<?",
                    parentProdId: "<?",
                    studentUserId: "<?",
                    isEditMode: "<?",
                    onCloseClicked: "=",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OnlineLessonSessionSummaryDir.OnlineLessonSessionSummaryDirCtrl];
                return _this;
            }
            OnlineLessonSessionSummaryDir.directiveId = "idpOnlineLessonSessionSummary";
            return OnlineLessonSessionSummaryDir;
        }(Pulse.Common.BaseDirective));
        Directives.OnlineLessonSessionSummaryDir = OnlineLessonSessionSummaryDir;
        (function (OnlineLessonSessionSummaryDir) {
            var OnlineLessonSessionSummaryDirCtrl = (function (_super) {
                __extends(OnlineLessonSessionSummaryDirCtrl, _super);
                function OnlineLessonSessionSummaryDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OnlineLessonSessionSummaryDirCtrl.controllerId) || this;
                    _this.taToolbar = [['h2', 'h3', 'h4', 'h5', 'p'], ['bold', 'italics', 'underline', 'strikeThrough'], ['ul', 'ol'], ['clear'], ['justifyLeft', 'justifyCenter', 'justifyRight'], ['insertLink']];
                    _this.isEditMode = false;
                    _this.isExpired = false;
                    _this.isScheduledMoreThan1DayInFuture = false;
                    _this.today = moment().startOf('day').toDate();
                    _this.serverDateTime = moment(_this.pulseContext.serverDateTime).startOf('day').toDate();
                    _this.canUpdateInternalNotes = false;
                    _this.canSave = false;
                    _this.isOPLAdmin = false;
                    _this.id = OnlineLessonSessionSummaryDirCtrl._instanceCount++;
                    _this.formName = "myForm" + _this.id;
                    _this.checkUnsavedDataBeforeNav = false;
                    $scope.$on(Events.OPLSessionSummaryUpdated, function (event, sessionSummaryDTO) {
                        if (sessionSummaryDTO && _this.sessionSummary.orderDetailID == sessionSummaryDTO.orderDetailID) {
                            if (!_this.sessionSummaryOrig) {
                                _this.sessionSummaryOrig = sessionSummaryDTO;
                            }
                            else {
                                Pulse.Utils.JS.copyOwnProperties(_this.sessionSummaryOrig, sessionSummaryDTO);
                            }
                            _this.sessionSummary = angular.copy(sessionSummaryDTO);
                            _this.populateLocalState(_this.sessionSummary);
                            _this.filterInstructors();
                            if (sessionSummaryDTO.statusTypeID == Enums.OPLStatus.CompleteEmailSent) {
                                _this.isEditMode = false;
                            }
                        }
                    });
                    _this.activationPromises.push(_this.getTimeZoneTypes());
                    _this.sessionSummaryOrig = _this.sessionSummary;
                    if (_this.sessionSummary) {
                        _this.sessionSummary = angular.copy(_this.sessionSummary);
                    }
                    _this.activateController();
                    return _this;
                }
                OnlineLessonSessionSummaryDirCtrl.prototype.getTimeZoneTypes = function () {
                    var _this = this;
                    return this.pulseContext.timeZoneMgr.loadTimeZones()
                        .then(function (data) {
                        return _this.timeZoneTypes = data.sort(function (a, b) { return a.typeOrder < b.typeOrder ? -1 : a.typeOrder > b.typeOrder ? 1 : 0; });
                    });
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.securityCheck = function () {
                    this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.Corporate, 1, 2, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff);
                    this.canUpdate = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff);
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                    var _this = this;
                    _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls);
                    var self = this;
                    scope.$watch(function (scope) {
                        return _this.sessionSummary;
                    }, function (newVal, oldVal) { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(this.sessionSummary && this.sessionSummary.orderDetailID)) return [3, 2];
                                    return [4, this.getTimeZoneTypes()];
                                case 1:
                                    _a.sent();
                                    this.sessionSummaryOrig = angular.copy(this.sessionSummary);
                                    if (!angular.isArray(this.sessionSummarySkills)) {
                                        this.pulseContext.onlinePrivateLessonMgr.getOPLTopicSkills()
                                            .then(function (data) {
                                            _this.sessionSummarySkills = data;
                                            if (!_this.sessionSummary.skillID && _this.parentProdId > 0) {
                                                return _this.pulseContext.onlinePrivateLessonMgr.getOPLTopicSkills(_this.parentProdId, _this.studentUserId, _this.sessionSummary.skillID)
                                                    .then(function (data) {
                                                    if (data.length == 1) {
                                                        self.sessionSummary.skillID = data[0].skillID;
                                                    }
                                                });
                                            }
                                        });
                                    }
                                    if (angular.isArray(this.sessionSummaryStatusTypesOrig)) {
                                        this.populateLocalState(this.sessionSummary);
                                    }
                                    else {
                                        this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.OPLStatus)
                                            .then(function (data) {
                                            _this.sessionSummaryStatusTypesOrig = data;
                                            _this.populateLocalState(_this.sessionSummary);
                                        });
                                    }
                                    _a.label = 2;
                                case 2: return [2];
                            }
                        });
                    }); }, false);
                    scope.$watch(function (scope) {
                        return _this.instructors;
                    }, function (newVal, oldVal) { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(newVal !== oldVal)) return [3, 2];
                                    return [4, this.getTimeZoneTypes()];
                                case 1:
                                    _a.sent();
                                    if (angular.isArray(this.instructors)) {
                                        this.oplInstructorsOrig = this.instructors;
                                        this.filterInstructors();
                                    }
                                    else {
                                        this.pulseContext.onlinePrivateLessonMgr.getOPLInstructors()
                                            .then(function (data) {
                                            _this.oplInstructorsOrig = data;
                                            _this.filterInstructors();
                                        });
                                    }
                                    _a.label = 2;
                                case 2: return [2];
                            }
                        });
                    }); }, false);
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.secureAllFeatures = function () {
                    this.isOPL2 = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.OPLStaff, 2);
                    this.isOPL3 = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.OPLStaff, 3);
                    this.isCS = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices);
                    this.isOPLAdmin = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2);
                    this.canUpdateInternalNotes = this.isCS || this.canUpdate;
                    this.canSave = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2, 3);
                    var hasOPLRoles = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.OPLStaff, 1, 2, 3);
                    this.isEditMode = this.isEditMode || hasOPLRoles;
                    this.checkEditForOPL3();
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.onActivated = function (activationResults) {
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.populateLocalState = function (sessionSummary) {
                    var oplMgr = this.pulseContext.onlinePrivateLessonMgr;
                    this.clientStartDateTime = this.convertToLocalDateTime(this.sessionSummary.startDateTimeUTC);
                    this.clientEndDateTime = this.convertToLocalDateTime(this.sessionSummary.endDateTimeUTC);
                    this.isExpired = oplMgr.isSessionExpired(this.sessionSummary) || this.sessionSummary.statusTypeID == Enums.OPLStatus.AutoExpired;
                    this.isScheduledMoreThan1DayInFuture = oplMgr.isSessionStartMoreThanXSecondsInFuture(this.sessionSummary, 86400);
                    if (this.isEditMode) {
                        this.filterOPLStatus();
                    }
                    this.checkEditForOPL3();
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.checkEditForOPL3 = function () {
                    if (!this.isOPLAdmin && this.isOPL3 && !this.isCS && this.sessionSummary) {
                        if (angular.isNumber(this.sessionSummary.instructorUserID) && this.sessionSummary.instructorUserID !== this.pulseContext.loggedInUserId) {
                            this.isNotAssignedToLoggedInUser = true;
                            this.isEditMode = false;
                            this.canUpdate = false;
                            this.canSave = false;
                            this.canUpdateInternalNotes = false;
                        }
                    }
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.filterOPLStatus = function () {
                    var _this = this;
                    if (!this.sessionSummary)
                        return;
                    if (this.sessionSummary.statusTypeID === Enums.OPLStatus.AutoExpired) {
                        this.sessionSummaryStatusTypes = this.sessionSummaryStatusTypesOrig.filter(function (d) { return d.typeID === Enums.OPLStatus.AutoExpired; });
                    }
                    else {
                        this.sessionSummaryStatusTypes = this.sessionSummaryStatusTypesOrig.filter(function (d) { return d.typeID !== Enums.OPLStatus.AutoExpired; });
                    }
                    if (this.isScheduledMoreThan1DayInFuture) {
                        this.sessionSummaryStatusTypes = this.sessionSummaryStatusTypes.filter(function (d) { return d.typeID !== Enums.OPLStatus.CompleteDelivered
                            && d.typeID !== Enums.OPLStatus.CompletePresumed
                            && d.typeID !== Enums.OPLStatus.UsedNoShow; });
                    }
                    if (this.sessionSummary.statusTypeID === Enums.OPLStatus.CompleteEmailSent) {
                        this.sessionSummaryStatusTypes = this.sessionSummaryStatusTypesOrig.filter(function (d) { return d.typeID !== Enums.OPLStatus.AutoExpired; });
                    }
                    else {
                        this.sessionSummaryStatusTypes = this.sessionSummaryStatusTypes.filter(function (d) { return d.typeID !== Enums.OPLStatus.CompleteEmailSent; });
                    }
                    if (this.isOPLAdmin) {
                        return;
                    }
                    if (this.isOPL3 && this.sessionSummary.statusTypeID !== Enums.OPLStatus.Invalid) {
                        this.sessionSummaryStatusTypes = this.sessionSummaryStatusTypes.filter(function (d) { return d.typeID !== Enums.OPLStatus.Invalid; });
                    }
                    if (this.isOPL3 && this.sessionSummary.statusTypeID !== Enums.OPLStatus.Scheduled) {
                        this.sessionSummaryStatusTypes = this.sessionSummaryStatusTypes.filter(function (d) { return d.typeID !== Enums.OPLStatus.Scheduled; });
                    }
                    if (this.isCS && !this.isOPL3) {
                        this.sessionSummaryStatusTypes = this.sessionSummaryStatusTypes.filter(function (d) { return d.typeID == Enums.OPLStatus.Invalid || d.typeID == _this.sessionSummary.statusTypeID; });
                    }
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.filterInstructors = function () {
                    var _this = this;
                    if (!this.sessionSummary || !this.oplInstructorsOrig)
                        return;
                    if (!this.isOPLAdmin && this.isOPL3) {
                        this.oplInstructors = this.oplInstructorsOrig.filter(function (u) { return u.userID == _this.pulseContext.loggedInUserId; });
                    }
                    else {
                        this.oplInstructors = this.oplInstructorsOrig;
                    }
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.onEditClicked = function () {
                    this.filterOPLStatus();
                    this.isEditMode = !this.isEditMode;
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.isStatusDisabled = function () {
                    if (!this.sessionSummaryOrig)
                        return true;
                    var isDeliveredOrEmailSent = this.sessionSummaryOrig.statusTypeID == Enums.OPLStatus.CompleteDelivered || this.sessionSummaryOrig.statusTypeID == Enums.OPLStatus.CompleteEmailSent;
                    var isUsedOrInvalid = this.sessionSummaryOrig.statusTypeID == Enums.OPLStatus.UsedLateCancellation ||
                        this.sessionSummaryOrig.statusTypeID == Enums.OPLStatus.UsedNoShow ||
                        this.sessionSummaryOrig.statusTypeID == Enums.OPLStatus.Invalid;
                    return (this.isExpired && this.sessionSummaryOrig.statusTypeID !== Enums.OPLStatus.Scheduled)
                        || (this.isOPL2 && isDeliveredOrEmailSent)
                        || (this.isOPL3 && (isUsedOrInvalid || isDeliveredOrEmailSent));
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.onSessionStartDateChanged = function () {
                    if (angular.isDefined(this.clientStartDateTime) && angular.isDate(this.clientStartDateTime)
                        && !angular.isDate(this.clientEndDateTime)) {
                        this.clientEndDateTime = moment(this.clientStartDateTime).add(1, 'hours').toDate();
                    }
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.onStatusTypeChanged = function (newStatusTypeID, oldStatusTypeID) {
                    if (this.isScheduledInPulse() && oldStatusTypeID == Enums.OPLStatus.Scheduled && newStatusTypeID == Enums.OPLStatus.Unscheduled) {
                        this.common.showMessagePopup("Warning", "This lesson is scheduled in Pulse, you can cancel the lesson from the client-side or instructor schedule page.");
                        this.sessionSummary.statusTypeID = Enums.OPLStatus.Scheduled;
                        return;
                    }
                    if (this.isOPL3 && newStatusTypeID == Enums.OPLStatus.Scheduled && newStatusTypeID != oldStatusTypeID) {
                        this.common.showMessagePopup("Warning", "You cannot change the status to Scheduled.");
                        this.sessionSummary.statusTypeID = +oldStatusTypeID;
                        return;
                    }
                    if (!this.isScheduledInPulse() && oldStatusTypeID == Enums.OPLStatus.Scheduled && newStatusTypeID == Enums.OPLStatus.Unscheduled) {
                        this.sessionSummary.instructorUserID = null;
                        this.sessionSummary.subjectTypeID = null;
                        this.sessionSummary.skillID = null;
                        this.sessionSummary.startDateTimeUTC = null;
                        this.sessionSummary.endDateTimeUTC = null;
                        this.clientStartDateTime = null;
                        this.clientEndDateTime = null;
                    }
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.isScheduledInPulse = function () {
                    return this.pulseContext.onlinePrivateLessonMgr.isScheduledInPulse(this.sessionSummary);
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.isValid = function () {
                    var errorMessages = [];
                    if (!angular.isDate(this.sessionSummary.expiryDate) || !this.sessionSummary.statusTypeID) {
                        errorMessages.push("Please enter expiry date and status.");
                    }
                    if (this.clientStartDateTime && this.clientEndDateTime
                        && this.clientStartDateTime >= this.clientEndDateTime) {
                        errorMessages.push("start date time cannot be earlier than end date time.");
                    }
                    if (this.sessionSummary.statusTypeID == Enums.OPLStatus.Scheduled ||
                        this.sessionSummary.statusTypeID == Enums.OPLStatus.CompleteDelivered ||
                        this.sessionSummary.statusTypeID == Enums.OPLStatus.CompleteEmailSent ||
                        this.sessionSummary.statusTypeID == Enums.OPLStatus.UsedNoShow ||
                        this.sessionSummary.statusTypeID == Enums.OPLStatus.UsedLateCancellation) {
                        if (!this.clientStartDateTime || !this.clientEndDateTime) {
                            errorMessages.push("Date and time details are required.");
                        }
                    }
                    if (this.myForm.$error.maxlength) {
                        errorMessages.push("the comments can only have max. 4000 characters including markups");
                    }
                    if (this.sessionSummary.statusTypeID == Enums.OPLStatus.CompleteDelivered &&
                        !this.sessionSummary.skillID) {
                        errorMessages.push("Topic is required when status is Complete - Delivered.");
                    }
                    if (this.sessionSummary.statusTypeID == Enums.OPLStatus.CompleteDelivered &&
                        !this.sessionSummary.instructorUserID) {
                        errorMessages.push("Instructor is required when status is Complete - Delivered.");
                    }
                    var isOPL3 = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.OPLStaff, 3);
                    if (isOPL3 && this.sessionSummaryOrig.statusTypeID !== Enums.OPLStatus.Invalid && this.sessionSummary.statusTypeID == Enums.OPLStatus.Invalid) {
                        errorMessages.push("You don't have permission to set status to Invalid.");
                    }
                    if (this.sessionSummary.statusTypeID == Enums.OPLStatus.CompleteEmailSent &&
                        this.myForm.$error.required) {
                        errorMessages.push("Please filled in all required fields when status is Complete - Delivered.");
                    }
                    if (this.sessionSummaryOrig.statusTypeID == Enums.OPLStatus.Scheduled &&
                        this.sessionSummary.statusTypeID == Enums.OPLStatus.Unscheduled &&
                        this.isScheduledInPulse()) {
                        errorMessages.push("Lesson scheduled in Pulse cannot be changed back to 'Unschedule', cancel the lesson from the client-side or instructor schedule page.");
                    }
                    if (errorMessages.length > 0) {
                        errorMessages = errorMessages.map(function (m) { return "<li>" + m + "</li>"; });
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.OptionInfo, 'Validation Errors', "<ul>" + errorMessages.join('') + "</ul>", null);
                        return false;
                    }
                    var startDateTimeUTC = this.convertToUTC(this.clientStartDateTime);
                    var endDateTimeUTC = this.convertToUTC(this.clientEndDateTime);
                    if (!this.sessionSummary.startDateTimeUTC || (new Date(this.sessionSummary.startDateTimeUTC)).valueOf() !== startDateTimeUTC.valueOf()) {
                        this.sessionSummary.startDateTimeUTC = startDateTimeUTC === null || startDateTimeUTC === void 0 ? void 0 : startDateTimeUTC.toTZNeutralString();
                    }
                    if (!this.sessionSummary.endDateTimeUTC || (new Date(this.sessionSummary.endDateTimeUTC)).valueOf() !== endDateTimeUTC.valueOf()) {
                        this.sessionSummary.endDateTimeUTC = endDateTimeUTC === null || endDateTimeUTC === void 0 ? void 0 : endDateTimeUTC.toTZNeutralString();
                    }
                    return true;
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.save = function () {
                    var _this = this;
                    var deferred = this.common.$q.defer();
                    var self = this;
                    this.common.toggleSpinner(true);
                    this.pulseContext.onlinePrivateLessonMgr.saveSessionSummary(this.sessionSummary)
                        .then(function (data) {
                        if (_this.sessionSummary.statusTypeID == Enums.OPLStatus.CompleteEmailSent) {
                            self.common.showMessagePopup("Saved", "Saved changes are visible to the client. Resend email if needed.");
                        }
                        else {
                            self.common.showMessagePopup("Saved", "Session summary saved.");
                        }
                        self.sessionSummary = data;
                        Pulse.Utils.JS.copyOwnProperties(self.sessionSummaryOrig, data);
                        self.common.$rootScope.$broadcast(Events.OPLSessionSummaryUpdated, data);
                        deferred.resolve(data);
                    })
                        .catch(function (error) {
                        deferred.reject(error);
                        var errorMessage = Pulse.Utils.JS.extractErrorMessage(error);
                        self.logError(errorMessage, ['OPLSessionSummary_Save', 'OPLSessionSummary_Save', 'ApplicationException']);
                    })
                        .finally(function () {
                        self.common.toggleSpinner(false);
                        self.submitted = false;
                        if (self.myForm) {
                            self.myForm.$setPristine();
                        }
                    });
                    return deferred.promise;
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.onSaveClicked = function () {
                    if (!this.isValid())
                        return;
                    this.save();
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.onEmailPreviewClicked = function () {
                    this.submitted = true;
                    this.myForm.$setSubmitted();
                    if (!this.isValid() || !this.myForm.$valid) {
                        this.submitted = false;
                        return;
                    }
                    this.common.$rootScope.$broadcast(Events.ShowOPLEmailPreviewPopup, {
                        size: Pulse.Common.BasePopup.ModalSize.Large,
                        initDataObj: this.sessionSummary,
                    });
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.onCancelClicked = function () {
                    this.isEditMode = false;
                    this.sessionSummary = angular.copy(this.sessionSummaryOrig);
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.onTimeZoneClicked = function () {
                    if (!this.isEditMode)
                        return;
                    this.common.showInfo("This can be updated on the instructor’s Public Profile page by a manager.");
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.convertToLocalDateTime = function (dateUTCstr) {
                    if (String.isNullOrWhitespace(dateUTCstr) || !this.sessionSummary || !this.timeZoneTypes || !this.sessionSummary.instrTimeZoneTypeID)
                        return null;
                    var result = this.pulseContext.timeZoneMgr.convertDateTimeFromUTC(dateUTCstr, this.sessionSummary.instrTimeZoneTypeID);
                    if (angular.isDate(result)) {
                        return result;
                    }
                    return null;
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.convertToUTC = function (date) {
                    if (!date || !this.sessionSummary || !this.timeZoneTypes || !this.sessionSummary.instrTimeZoneTypeID)
                        return null;
                    var result = this.pulseContext.timeZoneMgr.convertDateTimeToUTC(date, this.sessionSummary.instrTimeZoneTypeID);
                    if (angular.isDate(result)) {
                        return result;
                    }
                    return null;
                };
                OnlineLessonSessionSummaryDirCtrl.prototype.formatDateTime = function (date) {
                    if (angular.isDate(date)) {
                        return moment(date).format('M/D/YY h:mm a');
                    }
                    return '';
                };
                OnlineLessonSessionSummaryDirCtrl.controllerId = "OnlineLessonSessionSummaryDirCtrl";
                OnlineLessonSessionSummaryDirCtrl._instanceCount = 0;
                return OnlineLessonSessionSummaryDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OnlineLessonSessionSummaryDir.OnlineLessonSessionSummaryDirCtrl = OnlineLessonSessionSummaryDirCtrl;
            Pulse.app.directive(OnlineLessonSessionSummaryDir.directiveId, ["common", function (c) { return new OnlineLessonSessionSummaryDir(c); }]);
        })(OnlineLessonSessionSummaryDir = Directives.OnlineLessonSessionSummaryDir || (Directives.OnlineLessonSessionSummaryDir = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var OnlineLessonStudentNotesDir = (function (_super) {
            __extends(OnlineLessonStudentNotesDir, _super);
            function OnlineLessonStudentNotesDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/idp-online-lesson-student-notes.html";
                _this.scope = {
                    studentNotes: "<?",
                    studentUserId: "<",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OnlineLessonStudentNotesDir.OnlineLessonStudentNotesDirCtrl];
                return _this;
            }
            OnlineLessonStudentNotesDir.directiveId = "idpOnlineLessonStudentNotes";
            return OnlineLessonStudentNotesDir;
        }(Pulse.Common.BaseDirective));
        Directives.OnlineLessonStudentNotesDir = OnlineLessonStudentNotesDir;
        (function (OnlineLessonStudentNotesDir) {
            var OnlineLessonStudentNotesDirCtrl = (function (_super) {
                __extends(OnlineLessonStudentNotesDirCtrl, _super);
                function OnlineLessonStudentNotesDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    return _super.call(this, $scope, $location, common, breezeService, pulseContext, OnlineLessonStudentNotesDirCtrl.controllerId) || this;
                }
                OnlineLessonStudentNotesDirCtrl.prototype.securityCheck = function () {
                    this.canAddNote = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, 3, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2, 3);
                    this.canEditNote = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2);
                    this.canDeleteNote = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1);
                };
                OnlineLessonStudentNotesDirCtrl.prototype.onEditNoteClick = function (note) {
                    this.$scope.$broadcast(Events.ShowOPLSessionNoteEditPopup, {
                        size: Pulse.Common.BasePopup.ModalSize.Large,
                        initDataObj: {
                            studentNote: angular.copy(note),
                            studentUserID: this.studentUserId
                        }
                    });
                };
                OnlineLessonStudentNotesDirCtrl.prototype.onDeleteNoteClick = function (note) {
                    var _this = this;
                    var dlg = this.common.dialogService.confirm('Please confirm...', ('Are you sure you want to delete the note?'), { dialogId: 'MyDialogId', size: 'sm' });
                    dlg.result.then(function (resolve) {
                        _this.pulseContext.onlinePrivateLessonMgr.deleteStudentNote(note.userNoteID)
                            .then(function (data) {
                            _this.$scope.$emit(Events.OPLStudentNoteDeleted, _this.studentUserId);
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    });
                };
                OnlineLessonStudentNotesDirCtrl.controllerId = "OnlineLessonStudentNotesDirCtrl";
                return OnlineLessonStudentNotesDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OnlineLessonStudentNotesDir.OnlineLessonStudentNotesDirCtrl = OnlineLessonStudentNotesDirCtrl;
        })(OnlineLessonStudentNotesDir = Directives.OnlineLessonStudentNotesDir || (Directives.OnlineLessonStudentNotesDir = {}));
        Pulse.app.directive(OnlineLessonStudentNotesDir.directiveId, ["common", function (c) { return new OnlineLessonStudentNotesDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var OnlineLessonNoteEditPopup = (function (_super) {
                __extends(OnlineLessonNoteEditPopup, _super);
                function OnlineLessonNoteEditPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        OnlineLessonNoteEditPopup.OnlineLessonNoteEditPopupCtrl];
                    return _this;
                }
                OnlineLessonNoteEditPopup.directiveId = "idpOnlineLessonNoteEditPopup";
                return OnlineLessonNoteEditPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.OnlineLessonNoteEditPopup = OnlineLessonNoteEditPopup;
            (function (OnlineLessonNoteEditPopup) {
                var OnlineLessonNoteEditPopupCtrl = (function (_super) {
                    __extends(OnlineLessonNoteEditPopupCtrl, _super);
                    function OnlineLessonNoteEditPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, OnlineLessonNoteEditPopupCtrl.controllerId) || this;
                        _this.isNew = false;
                        _this.event_ShowPopup = Events.ShowOPLSessionNoteEditPopup;
                        _this.keyboard = false;
                        _this.checkUnsavedDataBeforeNav = true;
                        _this.formName = "myForm";
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/idp-online-lesson-note-edit-popup.html";
                        _this.submitted = false;
                        _this.activateController();
                        return _this;
                    }
                    OnlineLessonNoteEditPopupCtrl.prototype.close = function () {
                        _super.prototype.close.call(this);
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                    };
                    OnlineLessonNoteEditPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        if (this.initDataObj) {
                            this.note = initDataObj.studentNote;
                        }
                        this.isNew = !(this.note && this.note.userNoteID);
                        this.submitted = false;
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                    };
                    OnlineLessonNoteEditPopupCtrl.prototype.saveNote = function () {
                        var _this = this;
                        var deferred = this.common.$q.defer();
                        if (this.myForm.$valid) {
                            this.submitted = true;
                            this.common.toggleSpinner(true);
                            var self = this;
                            var isNew = (!this.note.userNoteID || this.note.userNoteID <= 0);
                            this.note.studentUserID = this.initDataObj.studentUserID;
                            this.pulseContext.onlinePrivateLessonMgr.saveStudentNote(this.note)
                                .then(function (data) {
                                self.common.showSuccess("User note " + (isNew ? "Saved" : "Updated"));
                                self.close();
                                self.$scope.$emit(Events.OPLStudentNoteUpdated, _this.note.studentUserID);
                            })
                                .catch(function (error) {
                                deferred.reject(error);
                                var errorMessage = Pulse.Utils.JS.extractErrorMessage(error);
                                self.logError(errorMessage, ['OPLStudentNote_Save', 'OPLStudentNote', 'ApplicationException']);
                            })
                                .finally(function () {
                                self.common.toggleSpinner(false);
                                self.submitted = false;
                                if (self.myForm) {
                                    self.myForm.$setPristine();
                                }
                            });
                        }
                        deferred.resolve();
                        return deferred.promise;
                    };
                    OnlineLessonNoteEditPopupCtrl.controllerId = "OnlineLessonNoteEditPopupCtrl";
                    return OnlineLessonNoteEditPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                OnlineLessonNoteEditPopup.OnlineLessonNoteEditPopupCtrl = OnlineLessonNoteEditPopupCtrl;
                Pulse.app.directive(OnlineLessonNoteEditPopup.directiveId, ["common", function (c) { return new OnlineLessonNoteEditPopup(c); }]);
            })(OnlineLessonNoteEditPopup = PulsePublic.OnlineLessonNoteEditPopup || (PulsePublic.OnlineLessonNoteEditPopup = {}));
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var OnlineLessonEmailPreviewPopup = (function (_super) {
                __extends(OnlineLessonEmailPreviewPopup, _super);
                function OnlineLessonEmailPreviewPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        OnlineLessonEmailPreviewPopup.OnlineLessonEmailPreviewPopupCtrl];
                    return _this;
                }
                OnlineLessonEmailPreviewPopup.directiveId = "idpOnlineLessonEmailPreviewPopup";
                return OnlineLessonEmailPreviewPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.OnlineLessonEmailPreviewPopup = OnlineLessonEmailPreviewPopup;
            (function (OnlineLessonEmailPreviewPopup) {
                var OnlineLessonEmailPreviewPopupCtrl = (function (_super) {
                    __extends(OnlineLessonEmailPreviewPopupCtrl, _super);
                    function OnlineLessonEmailPreviewPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, OnlineLessonEmailPreviewPopupCtrl.controllerId) || this;
                        _this.emailRegExpErrorMsg = PulseRegExp.EmailErrorMessage;
                        _this.event_ShowPopup = Events.ShowOPLEmailPreviewPopup;
                        _this.keyboard = false;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.formName = "myForm";
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/idp-online-lesson-email-preview-popup.html";
                        _this.submitted = false;
                        _this.activateController();
                        return _this;
                    }
                    OnlineLessonEmailPreviewPopupCtrl.prototype.close = function () {
                        _super.prototype.close.call(this);
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        this.emailPreview = null;
                    };
                    OnlineLessonEmailPreviewPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        if (this.initDataObj) {
                            this.sessionSummary = initDataObj;
                        }
                        else {
                            throw new Error("initDataObj can not be null when opening ShowOPLEmailPreviewPopup");
                        }
                        this.submitted = false;
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        this.setLocalizedTexts();
                        this.initPreview();
                    };
                    OnlineLessonEmailPreviewPopupCtrl.prototype.initPreview = function () {
                        var _this = this;
                        this.sessionSummary.ccEmailAddress = null;
                        this.common.toggleSpinner(true);
                        this.pulseContext.onlinePrivateLessonMgr.previewSessionSummaryEmail(this.sessionSummary)
                            .then(function (data) {
                            _this.emailPreview = data;
                        })
                            .catch(function (error) {
                            _this.logError(error, ['OnlinePrivateLesson_PreviewSessionSummaryEmail', 'OnlinePrivateLesson_PreviewSessionSummaryEmail', 'ApplicationException']);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    OnlineLessonEmailPreviewPopupCtrl.prototype.sendEmail = function () {
                        var _this = this;
                        if (!this.myForm.$valid)
                            return;
                        this.common.toggleSpinner(true);
                        this.sessionSummary.statusTypeID = Enums.OPLStatus.CompleteEmailSent;
                        this.pulseContext.onlinePrivateLessonMgr.sendSessionSummaryEmail(this.sessionSummary)
                            .then(function (result) {
                            var successMessage = "Session summary sent <br />to: " + result.customerInfo.email;
                            if (_this.sessionSummary.ccEmailAddress) {
                                successMessage += "<br/>cc: " + _this.sessionSummary.ccEmailAddress;
                            }
                            _this.common.showMessagePopup("Saved and Sent", successMessage);
                            _this.close();
                            _this.common.$rootScope.$broadcast(Events.OPLSessionSummaryUpdated, result);
                        })
                            .catch(function (error) {
                            _this.logError(error, ['OnlinePrivateLesson_SendSessionSummaryEmail', 'OnlinePrivateLesson_SendSessionSummaryEmail', 'ApplicationException']);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    OnlineLessonEmailPreviewPopupCtrl.controllerId = "OnlineLessonEmailPreviewPopupCtrl";
                    return OnlineLessonEmailPreviewPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                OnlineLessonEmailPreviewPopup.OnlineLessonEmailPreviewPopupCtrl = OnlineLessonEmailPreviewPopupCtrl;
                Pulse.app.directive(OnlineLessonEmailPreviewPopup.directiveId, ["common", function (c) { return new OnlineLessonEmailPreviewPopup(c); }]);
            })(OnlineLessonEmailPreviewPopup = PulsePublic.OnlineLessonEmailPreviewPopup || (PulsePublic.OnlineLessonEmailPreviewPopup = {}));
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var OplStudentAchievements = (function (_super) {
            __extends(OplStudentAchievements, _super);
            function OplStudentAchievements(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/idp-opl-student-achievements.html";
                _this.scope = {
                    availableAchievements: "<",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OplStudentAchievementsDir.OplStudentAchievementsCtrl];
                return _this;
            }
            OplStudentAchievements.directiveId = "idpOplStudentAchievements";
            return OplStudentAchievements;
        }(Pulse.Common.BaseDirective));
        Directives.OplStudentAchievements = OplStudentAchievements;
        var OplStudentAchievementsDir;
        (function (OplStudentAchievementsDir) {
            var OplStudentAchievementsCtrl = (function (_super) {
                __extends(OplStudentAchievementsCtrl, _super);
                function OplStudentAchievementsCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplStudentAchievementsCtrl.controllerId) || this;
                    _this._rowExtraCells = [];
                    _this.$scope.$on(Events.OPLMyAccountStudentChanged, function (event, student) {
                        _this.initLastRow(student.earnedAchievements);
                    });
                    _this.studentAchievements = [];
                    return _this;
                }
                OplStudentAchievementsCtrl.prototype.initLastRow = function (achivementList) {
                    this._rowExtraCells = [];
                    this.studentAchievements = achivementList;
                    var remainderRowsNeeded = OplStudentAchievementsCtrl.numberOfColumns - ((achivementList.length) % OplStudentAchievementsCtrl.numberOfColumns);
                    if (remainderRowsNeeded != OplStudentAchievementsCtrl.numberOfColumns) {
                        for (var i = 0; i < remainderRowsNeeded; ++i) {
                            this._rowExtraCells.push(i.toString());
                        }
                    }
                    if (this.debug) {
                        console.log("initLastRow");
                        console.log(this.studentAchievements);
                    }
                };
                OplStudentAchievementsCtrl.prototype.getBadgeImage = function (badge) {
                    var srcBadge = _.filter(this.availableAchievements, function (f) { return f.badgeDefID == badge.badgeDefID; })[0];
                    var srcUrl = _.filter(srcBadge.imageUrls, function (f) { return f.imageTypeID == badge.badgeImageTypeID; })[0];
                    return srcUrl.url;
                };
                OplStudentAchievementsCtrl.prototype.nextRow = function (index) {
                    var adjustedId = index + 1;
                    return adjustedId % OplStudentAchievementsCtrl.numberOfColumns == 0;
                };
                Object.defineProperty(OplStudentAchievementsCtrl.prototype, "showLastRow", {
                    get: function () {
                        return this._rowExtraCells.length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                OplStudentAchievementsCtrl.prototype.cellsNeededForRow = function () {
                    return this._rowExtraCells;
                };
                Object.defineProperty(OplStudentAchievementsCtrl.prototype, "StudentAchivementCount", {
                    get: function () {
                        var count = Math.max(0, this.studentAchievements.length - 1).toString();
                        return count;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(OplStudentAchievementsCtrl.prototype, "debug", {
                    get: function () {
                        return this.getParamAsBoolean('debug', false);
                    },
                    enumerable: false,
                    configurable: true
                });
                OplStudentAchievementsCtrl.prototype.getParamAsBoolean = function (qsParamName, defaultValue) {
                    if (defaultValue === void 0) { defaultValue = false; }
                    var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                    if (Array.isArray(param)) {
                        param = param[0];
                    }
                    return typeof param === 'string' ? parseInt(param) == 1 : defaultValue;
                };
                OplStudentAchievementsCtrl.controllerId = "OplStudentAchievementsDirCtrl";
                OplStudentAchievementsCtrl.numberOfColumns = 5;
                return OplStudentAchievementsCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OplStudentAchievementsDir.OplStudentAchievementsCtrl = OplStudentAchievementsCtrl;
        })(OplStudentAchievementsDir = Directives.OplStudentAchievementsDir || (Directives.OplStudentAchievementsDir = {}));
        Pulse.app.directive(OplStudentAchievements.directiveId, ["common", function (c) { return new OplStudentAchievements(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var OplStudentLessonsDir = (function (_super) {
            __extends(OplStudentLessonsDir, _super);
            function OplStudentLessonsDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-student-lessons.html";
                _this.scope = {
                    studentInfo: "<",
                    studentSession: "<",
                    selectedTimeZoneType: "<?",
                    selectedParentOrderDetailId: "<?",
                    buyLessonsClick: "<",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OplStudentLessonsDir.OplStudentLessonsDirCtrl];
                return _this;
            }
            OplStudentLessonsDir.directiveId = "idpOplStudentLessons";
            return OplStudentLessonsDir;
        }(Pulse.Common.BaseDirective));
        Directives.OplStudentLessonsDir = OplStudentLessonsDir;
        (function (OplStudentLessonsDir) {
            var TabIndex;
            (function (TabIndex) {
                TabIndex[TabIndex["Scheduled"] = 0] = "Scheduled";
                TabIndex[TabIndex["Available"] = 1] = "Available";
                TabIndex[TabIndex["Completed"] = 2] = "Completed";
                TabIndex[TabIndex["BuyLessons"] = 3] = "BuyLessons";
            })(TabIndex = OplStudentLessonsDir.TabIndex || (OplStudentLessonsDir.TabIndex = {}));
            var OplStudentLessonsDirCtrl = (function (_super) {
                __extends(OplStudentLessonsDirCtrl, _super);
                function OplStudentLessonsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplStudentLessonsDirCtrl.controllerId) || this;
                    _this._activeTabIdx = TabIndex.Available;
                    _this.isTabRenderedStateBag = {};
                    return _this;
                }
                OplStudentLessonsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                    var _this = this;
                    _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl);
                    scope.$watch(function (scope) {
                        return _this.studentSession;
                    }, function (newVal, oldVal) {
                        if (!newVal)
                            return;
                        _this.scheduledSessions = _this.studentSession.onlineSessions.filter(function (s) { return s.statusTypeID == Enums.OPLStatus.Scheduled; });
                        _this.scheduledSessions.sort(function (a, b) {
                            var aVal = Pulse.Utils.JS.dateTimeStrToDateObj(a.startDateTimeUTC).valueOf();
                            var bVal = Pulse.Utils.JS.dateTimeStrToDateObj(b.startDateTimeUTC).valueOf();
                            return aVal - bVal;
                        });
                        _this.availableSessions = _this.studentSession.onlineSessions.filter(function (s) { return _this.pulseContext.onlinePrivateLessonMgr.isSessionAvailable(s); });
                        _this.availableSessions.sort(function (a, b) {
                            var aVal = a.expiryDate.valueOf();
                            var bVal = b.expiryDate.valueOf();
                            return aVal - bVal;
                        });
                        _this.allOtherSessions = _this.studentSession.onlineSessions.filter(function (s) { return s.statusTypeID > 0
                            && _this.scheduledSessions.indexOf(s) < 0
                            && _this.availableSessions.indexOf(s) < 0; });
                        _this.allOtherSessions.sort(function (a, b) {
                            var aVal, bVal;
                            aVal = a.statusTypeID === Enums.OPLStatus.Invalid ? a.lastUpdatedDate.valueOf() : 0;
                            bVal = b.statusTypeID === Enums.OPLStatus.Invalid ? b.lastUpdatedDate.valueOf() : 0;
                            if (a.endDateTimeUTC && b.endDateTimeUTC) {
                                aVal = Pulse.Utils.JS.dateTimeStrToDateObj(a.endDateTimeUTC).valueOf();
                                bVal = Pulse.Utils.JS.dateTimeStrToDateObj(b.endDateTimeUTC).valueOf();
                            }
                            else if (!a.endDateTimeUTC && b.endDateTimeUTC) {
                                aVal = aVal ? aVal : a.expiryDate.valueOf();
                                bVal = Pulse.Utils.JS.dateTimeStrToDateObj(b.endDateTimeUTC).valueOf();
                            }
                            else if (a.endDateTimeUTC && !b.endDateTimeUTC) {
                                aVal = Pulse.Utils.JS.dateTimeStrToDateObj(a.endDateTimeUTC).valueOf();
                                bVal = bVal ? bVal : b.expiryDate.valueOf();
                            }
                            else {
                                aVal = aVal ? aVal : a.expiryDate.valueOf();
                                bVal = bVal ? bVal : b.expiryDate.valueOf();
                            }
                            return bVal - aVal;
                        });
                        _this.onlineSessionsTopLevel = _this.studentSession.onlineSessions.filter(function (s) { return s.isPartOfPackage === false; });
                        _this.studentSession.isActive = false;
                        _this.calculateTabIndex();
                        _this.isTabRenderedStateBag = {};
                    }, false);
                };
                Object.defineProperty(OplStudentLessonsDirCtrl.prototype, "activeTabIdx", {
                    get: function () {
                        return this._activeTabIdx;
                    },
                    set: function (idx) {
                        this._activeTabIdx = idx;
                        this.isTabRenderedStateBag["" + idx] = true;
                    },
                    enumerable: false,
                    configurable: true
                });
                OplStudentLessonsDirCtrl.prototype.isTabIdxRendered = function (idx) {
                    return this.isTabRenderedStateBag["" + idx] === true;
                };
                OplStudentLessonsDirCtrl.prototype.calculateTabIndex = function () {
                    var url = this.common.$location.url();
                    var paramTabIndex = QueryStringUtils.GetParamByName(url, QueryStringUtils.OPL_CLIENT_UI_TAB_IDX);
                    if (paramTabIndex) {
                        this.common.$location.search(QueryStringUtils.OPL_CLIENT_UI_TAB_IDX, null);
                        this.activeTabIdx = parseInt(paramTabIndex);
                        this.activeTabIdx = this.activeTabIdx == TabIndex.Available && !(this.availableSessions.length) ? TabIndex.Scheduled : this.activeTabIdx;
                        return;
                    }
                    var orderDetailIDStr = QueryStringUtils.GetParamByName(url, QueryStringUtils.ORDER_DETAIL_ID);
                    if (orderDetailIDStr) {
                        this.common.$location.search(QueryStringUtils.ORDER_DETAIL_ID, null);
                        var orderDetailID_1 = parseInt(orderDetailIDStr);
                        var foundSess = this.scheduledSessions.filter(function (s) { return s.orderDetailID == orderDetailID_1; });
                        if (foundSess.length) {
                            this.activeTabIdx = TabIndex.Scheduled;
                            return;
                        }
                        foundSess = this.availableSessions.filter(function (s) { return s.orderDetailID == orderDetailID_1; });
                        if (foundSess.length) {
                            this.activeTabIdx = TabIndex.Available;
                            return;
                        }
                        this.activeTabIdx = TabIndex.Completed;
                        return;
                    }
                    this.activeTabIdx = this.scheduledSessions.length ? TabIndex.Scheduled : TabIndex.Available;
                };
                OplStudentLessonsDirCtrl.prototype.getTopLevelSession = function (session) {
                    var topLevelSessions = this.onlineSessionsTopLevel.filter(function (s) { return s.orderDetailID === session.parentOrderDetailID; });
                    return topLevelSessions.length ? topLevelSessions[0] : session;
                };
                OplStudentLessonsDirCtrl.prototype.showAvailableLessonsHelp = function () {
                    this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Available lesson', Directives.HelpPopup.HelpTopic.OPLAvailableLessonsHelp, 'createPasswordHelp');
                };
                OplStudentLessonsDirCtrl.prototype.showExpiredLabel = function (session) {
                    var isExpired = this.pulseContext.onlinePrivateLessonMgr.isSessionExpired(session);
                    return isExpired && (session.statusTypeID == Enums.OPLStatus.Unscheduled || session.statusTypeID == Enums.OPLStatus.Scheduled);
                };
                OplStudentLessonsDirCtrl.prototype.getSessionStatusStr = function (session) {
                    if (this.selectedTimeZoneType && this.selectedTimeZoneType.typeExtraString) {
                        return this.pulseContext.onlinePrivateLessonMgr.getSessionStatusStrClientHtml(session, this.selectedTimeZoneType.typeExtraString);
                    }
                };
                OplStudentLessonsDirCtrl.prototype.isSessionAvailable = function (session) {
                    return this.pulseContext.onlinePrivateLessonMgr.isSessionAvailable(session);
                };
                OplStudentLessonsDirCtrl.prototype.isSessionExpandable = function (session) {
                    if (session.productSubCatTypeID == Enums.ProductSubCategoryType.OneOnOneTutor)
                        return true;
                    return this.pulseContext.onlinePrivateLessonMgr.isSessionExpandable(session);
                };
                OplStudentLessonsDirCtrl.prototype.onCloseClick = function (student) {
                    student.isActive = false;
                    this.common.scrollToHash('heading' + student.studentUserID);
                };
                OplStudentLessonsDirCtrl.prototype.hasScheduledLessons = function (session) {
                    if (!this.studentSession.onlineSessions || !session)
                        return;
                    var sessions = this.studentSession.onlineSessions.filter(function (s) { return s.isPartOfPackage === true && s.parentOrderDetailID == session.orderDetailID; });
                    var scheduledSession = _.find(sessions, function (s) {
                        return s.statusTypeID == Enums.OPLStatus.Scheduled;
                    });
                    return angular.isDefined(scheduledSession);
                };
                OplStudentLessonsDirCtrl.controllerId = "OplStudentLessonsDirCtrl";
                return OplStudentLessonsDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OplStudentLessonsDir.OplStudentLessonsDirCtrl = OplStudentLessonsDirCtrl;
        })(OplStudentLessonsDir = Directives.OplStudentLessonsDir || (Directives.OplStudentLessonsDir = {}));
        Pulse.app.directive(OplStudentLessonsDir.directiveId, ["common", function (c) { return new OplStudentLessonsDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var DataAccess = Pulse.Common.DataAccess;
        var TimeZoneMgr = DataAccess.Managers.TimeZoneMgr;
        var OplSessionDir = (function (_super) {
            __extends(OplSessionDir, _super);
            function OplSessionDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-session.html";
                _this.scope = {
                    session: "<",
                    topLevelSession: "<",
                    purchaseDate: "<?",
                    campStartDate: "<?",
                    studentUserId: "<?",
                    studentOriginalTimeZoneTypeId: "<?",
                    selectedTimeZoneType: "<?",
                    inTabIdx: "<?"
                };
                _this.controller = ["$scope",
                    "$location",
                    "$route",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OplSessionDir.OplSessionDirCtrl];
                return _this;
            }
            OplSessionDir.directiveId = "idpOplSession";
            return OplSessionDir;
        }(Pulse.Common.BaseDirective));
        Directives.OplSessionDir = OplSessionDir;
        (function (OplSessionDir) {
            var OplSessionDirCtrl = (function (_super) {
                __extends(OplSessionDirCtrl, _super);
                function OplSessionDirCtrl($scope, $location, $route, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplSessionDirCtrl.controllerId) || this;
                    _this.today = moment().startOf('day').toDate();
                    _this.serverDateTime = moment(_this.pulseContext.serverDateTime).startOf('day').toDate();
                    _this._canSchedule = null;
                    _this._canReschedule = null;
                    _this._canCancel = null;
                    _this._OPLSchedulingURL = null;
                    _this.hasLessonDetails = false;
                    _this.isShowDetails = null;
                    _this.id = OplSessionDirCtrl._instanceCount++;
                    _this.$route = $route;
                    return _this;
                }
                OplSessionDirCtrl.prototype.$onInit = function () {
                    var _this = this;
                    this.activationPromises.push(this.pulseContext.timeZoneMgr.loadTimeZones()
                        .then(function (data) {
                        _this.timeZoneTypes = data.sort(function (a, b) { return a.typeOrder < b.typeOrder ? -1 : a.typeOrder > b.typeOrder ? 1 : 0; });
                    }));
                    this.session = angular.copy(this.session);
                    this.activateController();
                };
                OplSessionDirCtrl.prototype.securityCheck = function () {
                    this.canSee = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Public);
                    this.canUpdate = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2, 3);
                };
                OplSessionDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                    _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls);
                };
                OplSessionDirCtrl.prototype.secureAllFeatures = function () {
                };
                OplSessionDirCtrl.prototype.onActivated = function (activationResults) {
                };
                OplSessionDirCtrl.prototype.getSessionStatusStr = function (session) {
                    if (this.selectedTimeZoneType && this.selectedTimeZoneType.typeExtraString) {
                        return this.pulseContext.onlinePrivateLessonMgr.getSessionStatusStrClientHtml(session, this.selectedTimeZoneType.typeExtraString);
                    }
                };
                OplSessionDirCtrl.prototype.showExpiredLabel = function (session) {
                    var isExpired = this.pulseContext.onlinePrivateLessonMgr.isSessionExpired(session);
                    return session.statusTypeID == Enums.OPLStatus.AutoExpired || (isExpired && session.statusTypeID == Enums.OPLStatus.Unscheduled);
                };
                OplSessionDirCtrl.prototype.isSessionAvailable = function (session) {
                    return this.pulseContext.onlinePrivateLessonMgr.isSessionAvailable(session);
                };
                OplSessionDirCtrl.prototype.isSessionCompleted = function (session) {
                    return session.statusTypeID != Enums.OPLStatus.Scheduled
                        && !this.pulseContext.onlinePrivateLessonMgr.isSessionAvailable(session);
                };
                OplSessionDirCtrl.prototype.isScheduledInPulse = function (session) {
                    return this.pulseContext.onlinePrivateLessonMgr.isScheduledInPulse(session);
                };
                OplSessionDirCtrl.prototype.isShowLessonInfo = function () {
                    return !(this.session.statusTypeID == Enums.OPLStatus.Unscheduled
                        || this.session.statusTypeID == Enums.OPLStatus.Invalid)
                        || this.pulseContext.onlinePrivateLessonMgr.isSessionExpired(this.session);
                };
                OplSessionDirCtrl.prototype.canSchedule = function () {
                    if (this._canSchedule === null) {
                        if (!this.session)
                            this._canSchedule = false;
                        var hasPermission = false;
                        if (this.pulseContext.isImpersonating) {
                            hasPermission = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2, 3);
                            if (this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.OPLStaff, 3)) {
                                if (!angular.isNumber(this.studentOriginalTimeZoneTypeId)) {
                                    return this._canSchedule = false;
                                }
                            }
                        }
                        else {
                            hasPermission = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Public);
                        }
                        this._canSchedule = this.session.statusTypeID == Enums.OPLStatus.Unscheduled
                            && hasPermission
                            && this.session.expiryDate
                            && !this.pulseContext.onlinePrivateLessonMgr.isSessionExpired(this.session);
                    }
                    return this._canSchedule;
                };
                OplSessionDirCtrl.prototype.canReschedule = function () {
                    if (this._canReschedule === null) {
                        if (!this.session || !this.session.startDateTimeUTC || this.session.statusTypeID !== Enums.OPLStatus.Scheduled) {
                            return this._canReschedule = false;
                        }
                        if (!this.pulseContext.isImpersonating && this.isStartDateWithin24Hrs()) {
                            return this._canReschedule = false;
                        }
                        if (this.pulseContext.isImpersonating && !(this.canCancel && this.canSchedule)) {
                            return this._canReschedule = false;
                        }
                        this._canReschedule = true;
                    }
                    return this._canReschedule;
                };
                OplSessionDirCtrl.prototype.isStartDateWithin24Hrs = function () {
                    var startDatetime = this.pulseContext.timeZoneMgr.convertDateTimeFromUTC(this.session.startDateTimeUTC, Enums.TimeZoneType.Pacific);
                    startDatetime.setDate(startDatetime.getDate() - 1);
                    return this.pulseContext.serverDateTime >= startDatetime;
                };
                OplSessionDirCtrl.prototype.cancelLesson = function () {
                    var _this = this;
                    var message = "You are about to cancel this scheduled lesson. You can reschedule this lesson before " + moment(this.session.expiryDate).format('M/D/YYYY');
                    if (this.isStartDateWithin24Hrs()) {
                        message = "You are about to cancel this scheduled lesson within 24 hours of its start time. If canceled, this lesson will no longer be valid and cannot be rescheduled or refunded.";
                    }
                    this.common.showConfirmation("Please confirm", message, function (confirm) {
                        if (confirm) {
                            _this.common.toggleSpinner(true, null, null, 0);
                            _this.pulseContext.onlinePrivateLessonMgr.cancelLesson(_this.session.orderDetailID)
                                .then(function (res) {
                                _this.common.$timeout(function () {
                                    _this.common.showSuccess('Your lesson is cancelled successfully.');
                                }, 1000);
                                _this.$scope.$emit(Events.OPLScheduleLessonsUpdated, _this.studentUserId);
                            })
                                .catch(function (error) {
                                _this.logError(error);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                    }, { size: 'md' }, 'Continue', 'Don\'t Cancel', false);
                };
                OplSessionDirCtrl.prototype.canCancel = function () {
                    if (this._canCancel === null) {
                        if (!this.session)
                            return this._canCancel = false;
                        var hasPermission = false;
                        if (this.pulseContext.isImpersonating) {
                            hasPermission = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2, 3, Enums.UserRoleType.OnlineInstructor, 1, 2, Enums.UserRoleType.OPLStaff, 1, 2);
                        }
                        else {
                            hasPermission = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Public);
                        }
                        if (!hasPermission) {
                            return this._canCancel = false;
                        }
                        this._canCancel = (this.session.statusTypeID == Enums.OPLStatus.Scheduled && this.pulseContext.onlinePrivateLessonMgr.isScheduledInPulse(this.session));
                    }
                    return this._canCancel;
                };
                OplSessionDirCtrl.prototype.getClientDateTimeFromUTC = function (dateUTCstr) {
                    if (!dateUTCstr || !this.selectedTimeZoneType)
                        return;
                    return TimeZoneMgr.convertDateTimeFromUTC(dateUTCstr, this.selectedTimeZoneType.typeExtraString);
                };
                OplSessionDirCtrl.prototype.getOPLSchedulingURL = function () {
                    if (!this._OPLSchedulingURL) {
                        var odid = this.session.orderDetailID;
                        var pid = this.topLevelSession.productID;
                        if (angular.isNumber(odid) && angular.isNumber(pid) && angular.isNumber(this.studentUserId)) {
                            this._OPLSchedulingURL = '#' + Routes.MyAccount_OPLOnlineSessionsSchedule + "?" + QueryStringUtils.PRODUCT_ID + "=" + pid
                                + '&' + QueryStringUtils.ORDER_DETAIL_ID + "=" + odid
                                + '&' + QueryStringUtils.PARTICIPANT_ID + "=" + this.studentUserId
                                + '&' + QueryStringUtils.PARENT_ORDER_DETAIL_ID + "=" + this.session.parentOrderDetailID
                                + (this.session.statusTypeID == Enums.OPLStatus.Scheduled ? "&" + QueryStringUtils.RESCHEDULING + "=true" : '');
                        }
                    }
                    return this._OPLSchedulingURL;
                };
                OplSessionDirCtrl.prototype.showHideDetails = function () {
                    var _this = this;
                    if (this.isShowDetails === null) {
                        this.common.toggleSpinner(true, null, null, 0);
                        this.pulseContext.onlinePrivateLessonMgr.getSessionSummaries(-1, TimeZoneMgr.browserTimeZoneStr, this.session.orderDetailID)
                            .then(function (data) {
                            Pulse.Utils.JS.copyAllProperties(_this.session, data[0]);
                            _this.hasLessonDetails = !!_this.session.conceptsCovered
                                || !!_this.session.instructorNotes
                                || (_this.pulseContext.isImpersonating && !!_this.session.internalNotes);
                            _this.isShowDetails = true;
                        })
                            .catch(function (err) {
                            _this.common.logAllErrorTypes(err, _this.loggingId);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    }
                    else {
                        this.isShowDetails = !this.isShowDetails;
                    }
                };
                OplSessionDirCtrl.prototype.onEditClicked = function () {
                    var params = {};
                    params[QueryStringUtils.PARTICIPANT_ID] = this.studentUserId;
                    params[QueryStringUtils.PARENT_ORDER_DETAIL_ID] = this.session.parentOrderDetailID;
                    params[QueryStringUtils.ORDER_DETAIL_ID] = this.session.orderDetailID;
                    params[QueryStringUtils.OPL_CLIENT_UI_TAB_IDX] = this.inTabIdx;
                    this.common.$location.url(QueryStringUtils.AddOrSetQSParams(Routes.MyAccount_OPLSessionReport, params));
                };
                OplSessionDirCtrl.controllerId = "OplSessionDirCtrl";
                OplSessionDirCtrl._instanceCount = 0;
                return OplSessionDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OplSessionDir.OplSessionDirCtrl = OplSessionDirCtrl;
            Pulse.app.directive(OplSessionDir.directiveId, ["common", function (c) { return new OplSessionDir(c); }]);
        })(OplSessionDir = Directives.OplSessionDir || (Directives.OplSessionDir = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        "use strict";
        var OplScheduleTopicDir = (function (_super) {
            __extends(OplScheduleTopicDir, _super);
            function OplScheduleTopicDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-schedule-topic.html";
                _this.scope = {
                    genreTopicsList: "<",
                    selectedTopic: "<?",
                    closedCallback: "&"
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OplScheduleTopicDir.OplScheduleTopicDirCtrl];
                return _this;
            }
            OplScheduleTopicDir.directiveId = "idpOplScheduleTopic";
            return OplScheduleTopicDir;
        }(Pulse.Common.BaseDirective));
        Directives.OplScheduleTopicDir = OplScheduleTopicDir;
        (function (OplScheduleTopicDir) {
            var OplScheduleTopicDirCtrl = (function (_super) {
                __extends(OplScheduleTopicDirCtrl, _super);
                function OplScheduleTopicDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplScheduleTopicDirCtrl.controllerId) || this;
                    _this._hasAnySkills = null;
                    _this.id = OplScheduleTopicDirCtrl._instanceCount++;
                    _this.checkUnsavedDataBeforeNav = false;
                    _this.activateController();
                    return _this;
                }
                OplScheduleTopicDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                };
                OplScheduleTopicDirCtrl.prototype.moveLeft = function (e) {
                    angular.element('div.scrolling-wrapper-flexbox')
                        .animate({ scrollLeft: '-=40' }, 200);
                };
                OplScheduleTopicDirCtrl.prototype.moveRight = function (e) {
                    angular.element('div.scrolling-wrapper-flexbox')
                        .animate({ scrollLeft: '+=40' }, 200);
                };
                OplScheduleTopicDirCtrl.prototype.hasAnySkills = function () {
                    if (this._hasAnySkills == null) {
                        if (this.genreTopicsList) {
                            this._hasAnySkills = false;
                            for (var _i = 0, _a = this.genreTopicsList; _i < _a.length; _i++) {
                                var genre = _a[_i];
                                this._hasAnySkills = genre.skills && !!genre.skills.length;
                                if (this._hasAnySkills)
                                    break;
                            }
                        }
                        return true;
                    }
                    return this._hasAnySkills;
                };
                OplScheduleTopicDirCtrl.prototype.close = function () {
                    this.closedCallback();
                };
                OplScheduleTopicDirCtrl.controllerId = "OplScheduleTopicDirCtrl";
                OplScheduleTopicDirCtrl._instanceCount = 0;
                return OplScheduleTopicDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OplScheduleTopicDir.OplScheduleTopicDirCtrl = OplScheduleTopicDirCtrl;
        })(OplScheduleTopicDir = Directives.OplScheduleTopicDir || (Directives.OplScheduleTopicDir = {}));
        Pulse.app.directive(OplScheduleTopicDir.directiveId, ["common", function (c) { return new OplScheduleTopicDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        "use strict";
        var OplScheduleInstructorDir = (function (_super) {
            __extends(OplScheduleInstructorDir, _super);
            function OplScheduleInstructorDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-schedule-instructor.html";
                _this.scope = {
                    availableInstructors: "<",
                    timeZoneTypes: "<",
                    studentTimeZoneTypeId: "<?",
                    selectedDateTime: '<',
                    selectedInstructor: '<',
                    hardwareSkills: '<?',
                    closedCallback: "&",
                    resetToNonRecurringCallback: "&",
                    isSchedulingRecurringDates: "<",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OplScheduleInstructorDir.OplScheduleInstructorDirCtrl];
                return _this;
            }
            OplScheduleInstructorDir.directiveId = "idpOplScheduleInstructor";
            return OplScheduleInstructorDir;
        }(Pulse.Common.BaseDirective));
        Directives.OplScheduleInstructorDir = OplScheduleInstructorDir;
        (function (OplScheduleInstructorDir) {
            var OplScheduleInstructorDirCtrl = (function (_super) {
                __extends(OplScheduleInstructorDirCtrl, _super);
                function OplScheduleInstructorDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplScheduleInstructorDirCtrl.controllerId) || this;
                    _this.clientTimeZoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    _this.isSelectMultiple = false;
                    _this.itemsPerPage = 10;
                    _this.currentPage = 1;
                    return _this;
                }
                OplScheduleInstructorDirCtrl.prototype.$onInit = function () {
                    this.activateController();
                };
                OplScheduleInstructorDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                };
                OplScheduleInstructorDirCtrl.prototype.$onChanges = function (changesObj) {
                    if (changesObj.studentTimeZoneTypeId && angular.isNumber(changesObj.studentTimeZoneTypeId.currentValue) && changesObj.studentTimeZoneTypeId.currentValue > 0) {
                        this.selectedTimeZoneTypeID = changesObj.studentTimeZoneTypeId.currentValue;
                    }
                    this.preferredInstructors = [];
                    this.preferredPlaceholders = [];
                    if (changesObj.availableInstructors && angular.isArray(changesObj.availableInstructors.currentValue)) {
                        this.availableInstructorsOrig = __spreadArrays(this.availableInstructors);
                        this.currentPage = 1;
                        this.searchTerm = '';
                        this.isSelectMultiple = this.isSchedulingRecurringDates && this.availableInstructorsOrig.length > 1;
                        if (this.isSelectMultiple) {
                            this.numOfRequiredInstructors = this.availableInstructorsOrig.length >= OplScheduleInstructorDirCtrl.MaxNumOfPrefInstrs
                                ? OplScheduleInstructorDirCtrl.MaxNumOfPrefInstrs : this.availableInstructorsOrig.length;
                            this.preferredPlaceholders = Array.from({ length: this.numOfRequiredInstructors }, function (v, i) { return i; });
                        }
                        this.title = this.isSelectMultiple ? "Select Instructors" : "Select an Instructor";
                    }
                    if (changesObj.hardwareSkills && angular.isArray(changesObj.hardwareSkills.currentValue)) {
                        this.selectedHWSkillIDs = this.hardwareSkills.filter(function (hs) { return hs.isSelected; }).map(function (hs) { return hs.skillID; });
                    }
                };
                OplScheduleInstructorDirCtrl.prototype.topChoicesInfoClick = function () {
                    var _this = this;
                    var template = this.common.$templateCache.get('oplScheduleRecurringInfo.html');
                    this.common.showConfirmation("Your Top Instructors", template, function (confirm) {
                        if (confirm) {
                            _this.resetToNonRecurringCallback();
                        }
                    }, {
                        size: 'md',
                        button1: { cssClass: 'btn btn-link' },
                    }, 'Schedule by Instructor', 'Ok, got it!', true);
                };
                OplScheduleInstructorDirCtrl.prototype.removePrefInstructor = function (instructor) {
                    instructor.isSelected = false;
                    this.preferredInstructors.splice(this.preferredInstructors.indexOf(instructor), 1);
                    this.preferredPlaceholders.push(instructor.userID);
                };
                OplScheduleInstructorDirCtrl.prototype.filterBySearchTerm = function () {
                    if (this.searchTerm && this.searchTerm != '') {
                        var stLower_1 = this.searchTerm.toLowerCase();
                        this.availableInstructors = this.availableInstructorsOrig.filter(function (i) {
                            var fullName = i.nickName ? i.nickName : i.firstName + ' ' + i.lastName;
                            return (i.firstName && i.firstName.toLowerCase().indexOf(stLower_1) == 0)
                                || (i.nickName && i.nickName.toLowerCase().indexOf(stLower_1) == 0)
                                || (i.lastName && i.lastName.toLowerCase().indexOf(stLower_1) == 0)
                                || (fullName.toLowerCase().indexOf(stLower_1) == 0);
                        });
                    }
                    else {
                        this.availableInstructors = this.availableInstructorsOrig;
                    }
                };
                OplScheduleInstructorDirCtrl.prototype.filterInstructors = function () {
                    this.selectedHWSkillIDs = this.hardwareSkills ?
                        this.hardwareSkills
                            .filter(function (f) { return f.isSelected; }).map(function (f) { return f.skillID; })
                        : [];
                };
                OplScheduleInstructorDirCtrl.prototype.applyFilters = function () {
                    this.searchTerm = '';
                    this.$scope.$emit(Events.OPLScheduleHardwareFilterApplied, this.selectedHWSkillIDs);
                };
                OplScheduleInstructorDirCtrl.prototype.isDateTimeSelected = function () {
                    return angular.isDate(this.selectedDateTime);
                };
                OplScheduleInstructorDirCtrl.prototype.updateSelectedTimeZoneTypeID = function () {
                    this.selectedInstructor = null;
                    this.$scope.$emit(Events.OPLScheduleTimeZoneSelected, this.selectedTimeZoneTypeID);
                };
                OplScheduleInstructorDirCtrl.prototype.onSelectInstructor = function (instructor) {
                    if (this.isSelectMultiple) {
                        if (instructor.isSelected) {
                            instructor.isSelected = false;
                            this.removePrefInstructor(instructor);
                        }
                        else {
                            instructor.isSelected = true;
                            if (!this.preferredInstructors) {
                                this.preferredInstructors = [];
                            }
                            if (this.preferredInstructors.indexOf(instructor) < 0) {
                                if (this.preferredInstructors.length >= OplScheduleInstructorDirCtrl.MaxNumOfPrefInstrs) {
                                    this.preferredInstructors.shift().isSelected = false;
                                }
                                this.preferredPlaceholders.pop();
                                this.preferredInstructors.push(instructor);
                            }
                        }
                    }
                    else {
                        this.$scope.$emit(Events.OPLScheduleInstructorSelected, [instructor]);
                    }
                };
                OplScheduleInstructorDirCtrl.prototype.confirmInstructors = function () {
                    this.$scope.$emit(Events.OPLScheduleInstructorSelected, this.preferredInstructors);
                };
                Object.defineProperty(OplScheduleInstructorDirCtrl.prototype, "hasEnoughPreferredInstr", {
                    get: function () {
                        if (this.isSelectMultiple) {
                            return this.numOfRequiredInstructors <= this.preferredInstructors.length;
                        }
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                OplScheduleInstructorDirCtrl.prototype.pageChanged = function () {
                    this.common.scrollToHash("opl-schedule-instructor", 250, 80);
                };
                Object.defineProperty(OplScheduleInstructorDirCtrl.prototype, "isOPL3_Only", {
                    get: function () {
                        return this.pulseContext.onlinePrivateLessonMgr.isOPL3_Only();
                    },
                    enumerable: false,
                    configurable: true
                });
                OplScheduleInstructorDirCtrl.prototype.close = function () {
                    this.closedCallback();
                };
                OplScheduleInstructorDirCtrl.controllerId = "OplScheduleInstructorDirCtrl";
                OplScheduleInstructorDirCtrl.MaxNumOfPrefInstrs = 3;
                return OplScheduleInstructorDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OplScheduleInstructorDir.OplScheduleInstructorDirCtrl = OplScheduleInstructorDirCtrl;
        })(OplScheduleInstructorDir = Directives.OplScheduleInstructorDir || (Directives.OplScheduleInstructorDir = {}));
        Pulse.app.directive(OplScheduleInstructorDir.directiveId, ["common", function (c) { return new OplScheduleInstructorDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        "use strict";
        var OplScheduleDateTimeDir = (function (_super) {
            __extends(OplScheduleDateTimeDir, _super);
            function OplScheduleDateTimeDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-schedule-date-time.html";
                _this.scope = {
                    availableDates: "<",
                    availableDateTimes: "<",
                    timeZoneTypes: "<",
                    studentTimeZoneTypeId: "<?",
                    selectedDateTime: '<',
                    selectedInstructor: '<',
                    selectedLessons: '<',
                    selectedLessonsCount: '<',
                    closedCallback: "&",
                    focusedDate: "=",
                    selectedDateUpdated: "&"
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    "bootstrapDatePickerDefaultConfig",
                    OplScheduleDateTimeDir.OplScheduleDateTimeDirCtrl];
                return _this;
            }
            OplScheduleDateTimeDir.directiveId = "idpOplScheduleDateTime";
            return OplScheduleDateTimeDir;
        }(Pulse.Common.BaseDirective));
        Directives.OplScheduleDateTimeDir = OplScheduleDateTimeDir;
        (function (OplScheduleDateTimeDir) {
            var OplScheduleDateTimeDirCtrl = (function (_super) {
                __extends(OplScheduleDateTimeDirCtrl, _super);
                function OplScheduleDateTimeDirCtrl($scope, $location, common, breezeService, pulseContext, bootstrapDatePickerDefaultConfig) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplScheduleDateTimeDirCtrl.controllerId) || this;
                    _this.clientTimeZoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    _this.maxDate = moment().add(35, 'days').endOf('day').toDate();
                    _this.minDate = moment().startOf('day').toDate();
                    _this.calendarOptions = {
                        minDate: _this.minDate,
                        maxDate: _this.maxDate,
                        showWeeks: false,
                        maxMode: 'day',
                        formatDay: 'd',
                        datepickerMode: 'day',
                        customClass: function (data) { return _this.getDayClassForDatePicker(data); },
                        dateDisabled: function (data) { return _this.getDatesDisabledForDatePicker(data); },
                    };
                    return _this;
                }
                OplScheduleDateTimeDirCtrl.prototype.$onInit = function () {
                    this.activateController();
                };
                OplScheduleDateTimeDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                };
                OplScheduleDateTimeDirCtrl.prototype.$onChanges = function (changesObj) {
                    if (changesObj.studentTimeZoneTypeId && angular.isNumber(changesObj.studentTimeZoneTypeId.currentValue) && changesObj.studentTimeZoneTypeId.currentValue > 0) {
                        this.selectedTimeZoneTypeID = changesObj.studentTimeZoneTypeId.currentValue;
                    }
                    if (changesObj.availableDates && angular.isArray(changesObj.availableDates.currentValue)) {
                        this.reRenderCalendar();
                    }
                    else if (changesObj.selectedInstructor && angular.isObject(changesObj.selectedInstructor.currentValue)) {
                        this.reRenderCalendar();
                    }
                    else if (changesObj.selectedLessonsCount && changesObj.selectedLessonsCount.currentValue != changesObj.selectedLessonsCount.previousValue) {
                        this.reRenderCalendar();
                    }
                };
                OplScheduleDateTimeDirCtrl.prototype.reRenderCalendar = function () {
                    var self = this;
                    this.calendarOptions.minDate = null;
                    this.common.$timeout(function () {
                        self.calendarOptions.minDate = self.minDate;
                    }, 1);
                };
                OplScheduleDateTimeDirCtrl.prototype.getDayClassForDatePicker = function (data) {
                    if (!this.availableDates)
                        return '';
                    var date = data.date, mode = data.mode;
                    var cssStr = '';
                    if (mode === 'day') {
                        if (this.selectedLessons) {
                            for (var _i = 0, _a = this.selectedLessons; _i < _a.length; _i++) {
                                var lesson = _a[_i];
                                if (lesson.instructor && lesson.dateTime) {
                                    if (moment(lesson.dateTime).isSame(moment(date), 'day')) {
                                        cssStr += 'has-selected ';
                                        break;
                                    }
                                }
                            }
                        }
                        var day = _.find(this.availableDates, function (d) {
                            return moment(d.date).isSame(moment(date), 'day');
                        });
                        if (!day)
                            return cssStr;
                        if (this.pulseContext.isImpersonating && (day.minEquipViolatedDateTime || day.minViolatedDateTime)) {
                            cssStr += 'admin-override ';
                        }
                    }
                    return cssStr;
                };
                OplScheduleDateTimeDirCtrl.prototype.getDatesDisabledForDatePicker = function (data) {
                    if (!this.availableDates)
                        return false;
                    var date = data.date, mode = data.mode;
                    var availableDateList = this.availableDates.map(function (a) { return a.date; });
                    var isAvalable = _.find(availableDateList, function (d) {
                        return moment(d).isSame(moment(date), 'day');
                    });
                    return !isAvalable;
                };
                OplScheduleDateTimeDirCtrl.prototype.selectDateTime = function (t) {
                    var _this = this;
                    var selectedTimeZoneTypeID = this.selectedTimeZoneTypeID;
                    var selectedTZ = _.find(this.timeZoneTypes, function (t) { return t.typeID === selectedTimeZoneTypeID; });
                    var msg = '';
                    if (this.pulseContext.isImpersonating) {
                        if (t.minViolatedDateTime) {
                            msg += "<p>You're scheduling a lesson earlier than " + moment(t.minViolatedDateTime).format('l') + ". Message from Katie: Please tell me you confirmed with the instructor. Proceed?</p>";
                        }
                        else if (t.minEquipViolatedDateTime) {
                            msg += "<p>Reno is fast but this lesson is faster. You're scheduling a lesson earlier than " + moment(t.minEquipViolatedDateTime).format('l') + " and hardware is involved. Are you sure the client will have the required hardware in time?</p>";
                        }
                    }
                    this.common.showConfirmation("Please confirm", msg + ("<p>Select " + moment(t.startTime).format('llll') + " " + selectedTZ.typeDescription + "?</p>"), function (confirm) {
                        if (confirm) {
                            _this.common.$timeout(function () {
                                _this.$scope.$emit(Events.OPLScheduleDateTimeSelected, { fromDirectiveID: OplScheduleDateTimeDir.directiveId, startTime: t.startTime });
                            }, 500);
                        }
                    }, { size: 'md' }, 'Yes', 'Cancel', false);
                };
                OplScheduleDateTimeDirCtrl.prototype.updateSelectedDate = function () {
                    var _this = this;
                    this.selectedDateUpdated({ selectedDate: this.focusedDate })
                        .then(function () {
                        if (_this.common.isMobileView) {
                            _this.common.scrollToHash('opl-schedule-time-container', 300);
                        }
                    });
                };
                OplScheduleDateTimeDirCtrl.prototype.close = function () {
                    if (this.selectedInstructor && this.focusedDate) {
                        this.focusedDate = null;
                    }
                    else {
                        this.closedCallback();
                    }
                };
                OplScheduleDateTimeDirCtrl.prototype.updateSelectedTimeZoneTypeID = function () {
                    this.focusedDate = null;
                    this.selectedDateTime = null;
                    this.$scope.$emit(Events.OPLScheduleTimeZoneSelected, this.selectedTimeZoneTypeID);
                };
                Object.defineProperty(OplScheduleDateTimeDirCtrl.prototype, "isOPL3_Only", {
                    get: function () {
                        return this.pulseContext.onlinePrivateLessonMgr.isOPL3_Only();
                    },
                    enumerable: false,
                    configurable: true
                });
                OplScheduleDateTimeDirCtrl.controllerId = "OplScheduleDateTimeDirCtrl";
                return OplScheduleDateTimeDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OplScheduleDateTimeDir.OplScheduleDateTimeDirCtrl = OplScheduleDateTimeDirCtrl;
        })(OplScheduleDateTimeDir = Directives.OplScheduleDateTimeDir || (Directives.OplScheduleDateTimeDir = {}));
        Pulse.app.directive(OplScheduleDateTimeDir.directiveId, ["common", function (c) { return new OplScheduleDateTimeDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        "use strict";
        var OplCourseListDir = (function (_super) {
            __extends(OplCourseListDir, _super);
            function OplCourseListDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-course-list.html";
                _this.scope = {
                    genreTopics: "<",
                    selectedTopic: "<"
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OplCourseListDir.OplCourseListDirCtrl];
                return _this;
            }
            OplCourseListDir.directiveId = "idpOplCourseList";
            return OplCourseListDir;
        }(Pulse.Common.BaseDirective));
        Directives.OplCourseListDir = OplCourseListDir;
        (function (OplCourseListDir) {
            var OplCourseListDirCtrl = (function (_super) {
                __extends(OplCourseListDirCtrl, _super);
                function OplCourseListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplCourseListDirCtrl.controllerId) || this;
                    _this.id = OplCourseListDirCtrl._instanceCount++;
                    _this.formName = "booleanSelector" + _this.id;
                    _this.checkUnsavedDataBeforeNav = false;
                    _this.activateController();
                    return _this;
                }
                OplCourseListDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                };
                OplCourseListDirCtrl.prototype.moveLeft = function (e) {
                    var target = $(e.target);
                    var p = target.parent();
                    var closest = p.find('div.scrolling-wrapper-flexbox');
                    if (closest.length > 0) {
                        if (this.common.isMobileView) {
                            angular.element(closest[0]).animate({ scrollLeft: '-=150' }, 200);
                        }
                        else {
                            angular.element(closest[0]).animate({ scrollLeft: '-=200' }, 200);
                        }
                    }
                };
                OplCourseListDirCtrl.prototype.moveRight = function (e) {
                    var target = $(e.target);
                    var p = target.parent();
                    var closest = p.find('div.scrolling-wrapper-flexbox');
                    if (closest.length > 0) {
                        if (this.common.isMobileView) {
                            angular.element(closest[0]).animate({ scrollLeft: '+=150' }, 200);
                        }
                        else {
                            angular.element(closest[0]).animate({ scrollLeft: '+=200' }, 200);
                        }
                    }
                };
                OplCourseListDirCtrl.prototype.isSelectedTopic = function (course) {
                    return angular.isDefined(this.selectedTopic) && this.selectedTopic != null && this.selectedTopic.skillID == course.skillID;
                };
                OplCourseListDirCtrl.prototype.openCourseInfoPopup = function (skill) {
                    var _this = this;
                    if (this.pulseContext.isImpersonating) {
                        var msg = '';
                        if (skill.isAdminOverride) {
                            msg += "<p>A client cannot select this topic but you can. With great power comes great responsibility.  Continue with this topic that does not match the purchased product?</p>";
                        }
                        if (skill.isAgeViolated) {
                            msg += "<p>It seems you've found a gifted student! The age range for this topic is " + skill.minAge + " to " + skill.maxAge + ". Proceed with this exception?</p>";
                        }
                        if (msg != "") {
                            this.common.showConfirmation("Please confirm", msg, function (confirm) {
                                if (confirm) {
                                    _this.openPopup(skill);
                                }
                            }, { size: 'md' }, 'Ok', 'Cancel', false);
                        }
                        else {
                            this.openPopup(skill);
                        }
                    }
                    else {
                        this.openPopup(skill);
                    }
                };
                OplCourseListDirCtrl.prototype.openPopup = function (skill) {
                    this.common.$rootScope.$broadcast(Events.ShowOPLCourseInfoPopup, {
                        size: Pulse.Common.BasePopup.ModalSize.Large,
                        initDataObj: {
                            skill: skill,
                            genreType: this.genreTopics.genreType
                        }
                    });
                };
                OplCourseListDirCtrl.prototype.getThumbImage = function (s) {
                    var u = _.find(s.skillURLs, function (url) {
                        return url.usageTypeID == Enums.SkillURLUsageType.SmallImage;
                    });
                    if (u)
                        return u.url;
                    return '';
                };
                OplCourseListDirCtrl.controllerId = "OplCourseListDirCtrl";
                OplCourseListDirCtrl._instanceCount = 0;
                return OplCourseListDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OplCourseListDir.OplCourseListDirCtrl = OplCourseListDirCtrl;
        })(OplCourseListDir = Directives.OplCourseListDir || (Directives.OplCourseListDir = {}));
        Pulse.app.directive(OplCourseListDir.directiveId, ["common", function (c) { return new OplCourseListDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var OplCourseInfoPopup = (function (_super) {
                __extends(OplCourseInfoPopup, _super);
                function OplCourseInfoPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        OplCourseInfoPopup.OplCourseInfoPopupCtrl];
                    return _this;
                }
                OplCourseInfoPopup.directiveId = "idpOplCourseInfoPopup";
                return OplCourseInfoPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.OplCourseInfoPopup = OplCourseInfoPopup;
            (function (OplCourseInfoPopup) {
                var OplCourseInfoPopupCtrl = (function (_super) {
                    __extends(OplCourseInfoPopupCtrl, _super);
                    function OplCourseInfoPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, OplCourseInfoPopupCtrl.controllerId) || this;
                        _this.event_ShowPopup = Events.ShowOPLCourseInfoPopup;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-course-info-popup.html";
                        _this.submitted = false;
                        _this.keyboard = false;
                        _this.activateController();
                        return _this;
                    }
                    OplCourseInfoPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        if (this.initDataObj) {
                            this.skill = this.initDataObj.skill;
                            this.genreType = this.initDataObj.genreType;
                            this.heroImg = this.getHeroImgUrl(this.initDataObj.skill);
                        }
                        this.submitted = false;
                    };
                    OplCourseInfoPopupCtrl.prototype.getHeroImgUrl = function (skill) {
                        var u = _.find(skill.skillURLs, function (url) {
                            return url.usageTypeID == Enums.SkillURLUsageType.LargeImage;
                        });
                        if (u)
                            return u.url.toString();
                        return '';
                    };
                    OplCourseInfoPopupCtrl.prototype.selectTopic = function () {
                        this.$scope.$emit(Events.OPLScheduleCourseSelected, this.skill);
                        this.close();
                    };
                    OplCourseInfoPopupCtrl.controllerId = "oplCourseInfoPopupCtrl";
                    return OplCourseInfoPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                OplCourseInfoPopup.OplCourseInfoPopupCtrl = OplCourseInfoPopupCtrl;
                Pulse.app.directive(OplCourseInfoPopup.directiveId, ["common", function (c) { return new OplCourseInfoPopup(c); }]);
            })(OplCourseInfoPopup = PulsePublic.OplCourseInfoPopup || (PulsePublic.OplCourseInfoPopup = {}));
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var OplScheduleConfirmationPopup = (function (_super) {
                __extends(OplScheduleConfirmationPopup, _super);
                function OplScheduleConfirmationPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        OplScheduleConfirmationPopup.OplScheduleConfirmationPopupCtrl];
                    return _this;
                }
                OplScheduleConfirmationPopup.directiveId = "idpOplScheduleConfirmationPopup";
                return OplScheduleConfirmationPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.OplScheduleConfirmationPopup = OplScheduleConfirmationPopup;
            (function (OplScheduleConfirmationPopup) {
                var OplScheduleConfirmationPopupCtrl = (function (_super) {
                    __extends(OplScheduleConfirmationPopupCtrl, _super);
                    function OplScheduleConfirmationPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, OplScheduleConfirmationPopupCtrl.controllerId) || this;
                        _this.successfulLessons = null;
                        _this.failedLessons = null;
                        _this.event_ShowPopup = Events.ShowOPLScheduledConfirmationPopup;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-schedule-confirmation-popup.html";
                        _this.submitted = false;
                        _this.keyboard = false;
                        _this.activateController();
                        return _this;
                    }
                    OplScheduleConfirmationPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        if (this.initDataObj) {
                            this.availableLessons = this.initDataObj.availableLessons;
                            this.studentUser = this.initDataObj.studentUser;
                            this.parentOrderDetailID = this.initDataObj.parentOrderDetailID;
                            this.productID = this.initDataObj.productID;
                            this.selectedTopicID = this.initDataObj.selectedTopicID;
                            this.selectedInstructorID = this.initDataObj.selectedInstructorID;
                            this.selectedLessons = this.initDataObj.selectedLessons;
                            this.sortLessons();
                            this.studentTimeZoneTypeStr = this.initDataObj.studentTimeZoneTypeStr;
                            this.isRescheduling = this.initDataObj.isRescheduling;
                        }
                        this.isTheSameInstructor = true;
                        this.submitted = false;
                    };
                    OplScheduleConfirmationPopupCtrl.prototype.sortLessons = function () {
                        this.successfulLessons = this.selectedLessons.filter(function (lesson) {
                            return String.isNullOrWhitespace(lesson.regErrMsg);
                        });
                        this.failedLessons = this.selectedLessons.filter(function (lesson) {
                            return !String.isNullOrWhitespace(lesson.regErrMsg);
                        });
                    };
                    OplScheduleConfirmationPopupCtrl.prototype.scheduleNextLesson = function () {
                        var nextLesson = this.availableLessons[0];
                        var params = {};
                        params[QueryStringUtils.PRODUCT_ID] = nextLesson.parentProductID;
                        params[QueryStringUtils.ORDER_DETAIL_ID] = nextLesson.orderDetailID;
                        params[QueryStringUtils.PARTICIPANT_ID] = this.studentUser.userID;
                        params[QueryStringUtils.PARENT_ORDER_DETAIL_ID] = nextLesson.parentOrderDetailID;
                        if (nextLesson.parentProductID == this.productID) {
                            params[QueryStringUtils.SKILL_ID] = this.selectedTopicID;
                            if (this.isTheSameInstructor) {
                                params[QueryStringUtils.INSTRUCTOR_USER_ID] = this.selectedInstructorID;
                            }
                        }
                        var url = QueryStringUtils.AddOrSetQSParams(window.location.href.split('?')[0], params);
                        window.location.href = url;
                        window.location.reload(true);
                    };
                    OplScheduleConfirmationPopupCtrl.prototype.navigateToMyAccount = function () {
                        var params = {};
                        if (this.studentUser && this.parentOrderDetailID) {
                            params[QueryStringUtils.PARTICIPANT_ID] = this.studentUser.userID;
                            params[QueryStringUtils.PARENT_ORDER_DETAIL_ID] = this.parentOrderDetailID;
                        }
                        if (this.isRescheduling) {
                            params[QueryStringUtils.OPL_CLIENT_UI_TAB_IDX] = Directives.OplStudentLessonsDir.TabIndex.Scheduled;
                        }
                        else {
                            params[QueryStringUtils.OPL_CLIENT_UI_TAB_IDX] = Directives.OplStudentLessonsDir.TabIndex.Available;
                        }
                        this.common.$location.url(QueryStringUtils.AddOrSetQSParams(Routes.MyAccount_OPLOnlineSessionsClient, params));
                    };
                    OplScheduleConfirmationPopupCtrl.controllerId = "OplScheduleConfirmationPopupCtrl";
                    return OplScheduleConfirmationPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                OplScheduleConfirmationPopup.OplScheduleConfirmationPopupCtrl = OplScheduleConfirmationPopupCtrl;
                Pulse.app.directive(OplScheduleConfirmationPopup.directiveId, ["common", function (c) { return new OplScheduleConfirmationPopup(c); }]);
            })(OplScheduleConfirmationPopup = PulsePublic.OplScheduleConfirmationPopup || (PulsePublic.OplScheduleConfirmationPopup = {}));
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        "use strict";
        var OplInstructorDir = (function (_super) {
            __extends(OplInstructorDir, _super);
            function OplInstructorDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-instructor.html";
                _this.scope = {
                    instructor: "<",
                    selectedDateTime: '<',
                    selectInstructorCallback: '&',
                    isSelectMultiple: '<',
                    isDisableSelect: '<'
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OplInstructorDir.OplInstructorDirCtrl];
                return _this;
            }
            OplInstructorDir.directiveId = "idpOplInstructor";
            return OplInstructorDir;
        }(Pulse.Common.BaseDirective));
        Directives.OplInstructorDir = OplInstructorDir;
        (function (OplInstructorDir) {
            var OplInstructorDirCtrl = (function (_super) {
                __extends(OplInstructorDirCtrl, _super);
                function OplInstructorDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplInstructorDirCtrl.controllerId) || this;
                    _this.id = OplInstructorDirCtrl._instanceCount++;
                    _this.checkUnsavedDataBeforeNav = false;
                    _this.showMore = false;
                    _this.activateController();
                    return _this;
                }
                OplInstructorDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                };
                OplInstructorDirCtrl.prototype.selectInstructor = function () {
                    this.selectInstructorCallback({ instructor: this.instructor });
                };
                OplInstructorDirCtrl.controllerId = "OplInstructorDirCtrl";
                OplInstructorDirCtrl._instanceCount = 0;
                return OplInstructorDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OplInstructorDir.OplInstructorDirCtrl = OplInstructorDirCtrl;
        })(OplInstructorDir = Directives.OplInstructorDir || (Directives.OplInstructorDir = {}));
        Pulse.app.directive(OplInstructorDir.directiveId, ["common", function (c) { return new OplInstructorDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var OplScheduleMultibleTimePopup = (function (_super) {
                __extends(OplScheduleMultibleTimePopup, _super);
                function OplScheduleMultibleTimePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        OplScheduleMultibleTimePopup.OplScheduleMultibleTimePopupCtrl];
                    return _this;
                }
                OplScheduleMultibleTimePopup.directiveId = "idpOplScheduleMultibleTimePopup";
                return OplScheduleMultibleTimePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.OplScheduleMultibleTimePopup = OplScheduleMultibleTimePopup;
            (function (OplScheduleMultibleTimePopup) {
                var OplScheduleMultibleTimePopupCtrl = (function (_super) {
                    __extends(OplScheduleMultibleTimePopupCtrl, _super);
                    function OplScheduleMultibleTimePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, OplScheduleMultibleTimePopupCtrl.controllerId) || this;
                        _this.successfulLessons = null;
                        _this.failedLessons = null;
                        _this.event_ShowPopup = Events.ShowOplScheduleMultibleTimePopup;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-schedule-multible-time-popup.html";
                        _this.submitted = false;
                        _this.activateController();
                        return _this;
                    }
                    OplScheduleMultibleTimePopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.selectedLessons = initDataObj.selectedLessons;
                        this.selectedLesson = initDataObj.selectedLesson;
                        this.sortLessons();
                        this.availableLessons = initDataObj.availableLessons;
                        this.studentUser = this.initDataObj.studentUser;
                        this.studentTimeZoneTypeStr = initDataObj.studentTimeZoneTypeStr;
                        this.isSchedulingRecurringDates = initDataObj.isSchedulingRecurringDates;
                        this.addMoreLessonsCbFn = initDataObj.addMoreLessons;
                        this.removeLessonCbFn = initDataObj.removeLesson;
                        this.scheduleLessonsCbFn = initDataObj.scheduleLessons;
                        this.goBackCbFn = initDataObj.goBack;
                        this.isUseSameInstructor = true;
                        this._nextAvailableLesson = undefined;
                        this.submitted = false;
                    };
                    OplScheduleMultibleTimePopupCtrl.prototype.sortLessons = function () {
                        this.successfulLessons = this.selectedLessons.filter(function (lesson) {
                            return !!lesson.instructor;
                        });
                        this.failedLessons = this.selectedLessons.filter(function (lesson) {
                            return !lesson.instructor;
                        });
                    };
                    Object.defineProperty(OplScheduleMultibleTimePopupCtrl.prototype, "lessonsLeft", {
                        get: function () {
                            return this.availableLessons ? this.availableLessons.length - this.successfulLessons.length : 0;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(OplScheduleMultibleTimePopupCtrl.prototype, "nextAvailableLesson", {
                        get: function () {
                            var _this = this;
                            if (this._nextAvailableLesson === undefined
                                || (this._nextAvailableLesson === null && this.selectedLessons.length < this.availableLessons.length)) {
                                var remainLessons = this.availableLessons.filter(function (availLesson) {
                                    var foundIndex = _.findIndex(_this.selectedLessons, function (selected) { return selected.orderDetailID === availLesson.orderDetailID; });
                                    return foundIndex < 0;
                                });
                                this._nextAvailableLesson = remainLessons.length ? remainLessons[0] : null;
                            }
                            return this._nextAvailableLesson;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    OplScheduleMultibleTimePopupCtrl.prototype.addMoreLessons = function (isSameInstructor) {
                        var params = {};
                        params[QueryStringUtils.PRODUCT_ID] = this.nextAvailableLesson.parentProductID;
                        params[QueryStringUtils.ORDER_DETAIL_ID] = this.nextAvailableLesson.orderDetailID;
                        params[QueryStringUtils.PARTICIPANT_ID] = this.nextAvailableLesson.studentUserID;
                        params[QueryStringUtils.PARENT_ORDER_DETAIL_ID] = this.nextAvailableLesson.parentOrderDetailID;
                        if (this.nextAvailableLesson.parentProductID == this.selectedLesson.productID
                            || this.nextAvailableLesson.skillIDs.indexOf(this.selectedLesson.topicSkillID) >= 0) {
                            params[QueryStringUtils.SKILL_ID] = this.selectedLesson.topicSkillID;
                            if (this.isUseSameInstructor && this.selectedLessons.length == 1) {
                                params[QueryStringUtils.INSTRUCTOR_USER_ID] = this.selectedLesson.instructor.userID;
                            }
                        }
                        var url = QueryStringUtils.AddOrSetQSParams(window.location.href.split('?')[0], params);
                        window.location.href = url;
                        this._nextAvailableLesson = undefined;
                        this.addMoreLessonsCbFn(isSameInstructor);
                        this.close();
                    };
                    OplScheduleMultibleTimePopupCtrl.prototype.removeLesson = function (lesson) {
                        this.successfulLessons.splice(this.successfulLessons.indexOf(lesson), 1);
                        this.removeLessonCbFn(lesson);
                        if (!this.selectedLessons.length)
                            this.close();
                    };
                    OplScheduleMultibleTimePopupCtrl.prototype.scheduleLessons = function () {
                        this.scheduleLessonsCbFn();
                        this.close();
                    };
                    OplScheduleMultibleTimePopupCtrl.prototype.goBack = function () {
                        this.goBackCbFn();
                        this.close();
                    };
                    OplScheduleMultibleTimePopupCtrl.prototype.navigateToMyAccount = function () {
                    };
                    OplScheduleMultibleTimePopupCtrl.controllerId = "OplScheduleMultibleTimePopupCtrl";
                    return OplScheduleMultibleTimePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                OplScheduleMultibleTimePopup.OplScheduleMultibleTimePopupCtrl = OplScheduleMultibleTimePopupCtrl;
                Pulse.app.directive(OplScheduleMultibleTimePopup.directiveId, ["common", function (c) { return new OplScheduleMultibleTimePopup(c); }]);
            })(OplScheduleMultibleTimePopup = PulsePublic.OplScheduleMultibleTimePopup || (PulsePublic.OplScheduleMultibleTimePopup = {}));
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var OplScheduleRecurringDatePopup = (function (_super) {
                __extends(OplScheduleRecurringDatePopup, _super);
                function OplScheduleRecurringDatePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        OplScheduleRecurringDatePopup.OplScheduleRecurringDatePopupCtrl];
                    return _this;
                }
                OplScheduleRecurringDatePopup.directiveId = "idpOplScheduleRecurringDatePopup";
                return OplScheduleRecurringDatePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.OplScheduleRecurringDatePopup = OplScheduleRecurringDatePopup;
            (function (OplScheduleRecurringDatePopup) {
                var OplScheduleRecurringDatePopupCtrl = (function (_super) {
                    __extends(OplScheduleRecurringDatePopupCtrl, _super);
                    function OplScheduleRecurringDatePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, OplScheduleRecurringDatePopupCtrl.controllerId) || this;
                        _this.event_ShowPopup = Events.ShowOplScheduleRecurringDatePopup;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-schedule-recurring-date-popup.html";
                        _this.submitted = false;
                        _this.activateController();
                        return _this;
                    }
                    OplScheduleRecurringDatePopupCtrl.prototype.open = function (size, initDataObj) {
                        var _this = this;
                        this.frequency = Enums.UI.OPLScheduleRecurringFrequency.NoRepeat;
                        this.selectedLessons = initDataObj.selectedLessons;
                        this.selectedLesson = initDataObj.selectedLesson;
                        this.allAvailableLessons = initDataObj.availableLessons;
                        this.qualifyingAvailableLessons = this.composeQualifyingAvailableLessons(this.allAvailableLessons);
                        this.studentUser = initDataObj.studentUser;
                        this.studentTimeZoneTypeStr = initDataObj.studentTimeZoneTypeStr;
                        this.allAvailableTimeSlots = initDataObj.allAvailableTimeSlots;
                        this.isThemedOPL = initDataObj.isThemedOPL;
                        this.addSelectedLessonCbFn = initDataObj.addSelectedLesson;
                        this.chooseMultipleInstructorsCbFn = initDataObj.chooseMultipleInstructors;
                        this.showDateTimeListCbFn = initDataObj.showDateTimeList;
                        this.init();
                        if (!(this.availableEveryWeeks.length || this.availableEvery2Weeks.length)) {
                            this.common.$timeout(function () {
                                _this.$scope.$emit(Events.OPLScheduleDateTimeSelected, { fromDirectiveID: OplScheduleRecurringDatePopup.directiveId, startTime: _this.selectedLesson.dateTime });
                            }, 0);
                            return;
                        }
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    OplScheduleRecurringDatePopupCtrl.prototype.composeQualifyingAvailableLessons = function (availableLessons) {
                        var qualifyingAvailableLessons = [];
                        for (var _i = 0, availableLessons_1 = availableLessons; _i < availableLessons_1.length; _i++) {
                            var lesson = availableLessons_1[_i];
                            if (lesson.parentProductID == this.selectedLesson.productID
                                || lesson.skillIDs.indexOf(this.selectedLesson.topicSkillID) >= 0) {
                                qualifyingAvailableLessons.push(lesson);
                            }
                        }
                        return qualifyingAvailableLessons;
                    };
                    Object.defineProperty(OplScheduleRecurringDatePopupCtrl.prototype, "lessonsLeft", {
                        get: function () {
                            return this.qualifyingAvailableLessons ? (this.qualifyingAvailableLessons.length - this.numOfLessonsWithInstructorAndDatetime) : 0;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    OplScheduleRecurringDatePopupCtrl.prototype.init = function () {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.submitted = false;
                                this.numOfLessonsWithInstructorAndDatetime = this.selectedLessons.filter(function (l) { return !!l.instructor && !!l.dateTime; }).length;
                                this.availableEveryWeeks = this.composeAvailableWeeksList(Enums.UI.OPLScheduleRecurringFrequency.Weekly);
                                this.availableEvery2Weeks = this.composeAvailableWeeksList(Enums.UI.OPLScheduleRecurringFrequency.Every2Weeks);
                                this.numOfLessonsToSchedule = null;
                                this.weekToSkip = null;
                                this.isSkipWeek = false;
                                return [2];
                            });
                        });
                    };
                    OplScheduleRecurringDatePopupCtrl.prototype.composeAvailableWeeksList = function (frequency) {
                        var availableWeeks = [];
                        var maxStartTime = moment(_.max(this.allAvailableTimeSlots.map(function (ats) { return ats.startTime; })));
                        var nextWeekTime = moment(this.selectedLesson.dateTime).add(frequency, "weeks");
                        var count = 2;
                        while (nextWeekTime <= maxStartTime && count <= this.lessonsLeft) {
                            if (_.find(this.allAvailableTimeSlots, function (ats) { return ats.startTime.valueOf() == nextWeekTime.valueOf(); })) {
                                var shortDesc = nextWeekTime.format('MMMM D, YYYY');
                                var weekDesc = shortDesc + " (" + count + " Lessons)";
                                availableWeeks.push({ dateTime: nextWeekTime.toDate(), numOfLessons: count, desc: weekDesc, shortDesc: shortDesc });
                                count++;
                            }
                            nextWeekTime = nextWeekTime.add(frequency, "weeks");
                        }
                        return availableWeeks;
                    };
                    OplScheduleRecurringDatePopupCtrl.prototype.onFrequencyChanged = function () {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (this.frequency) {
                                    case Enums.UI.OPLScheduleRecurringFrequency.Weekly:
                                        this.availableWeeks = this.availableEveryWeeks;
                                        break;
                                    case Enums.UI.OPLScheduleRecurringFrequency.Every2Weeks:
                                        this.availableWeeks = this.availableEvery2Weeks;
                                        break;
                                    default:
                                        this.availableWeeks = [];
                                        this.numOfLessonsToSchedule = null;
                                        break;
                                }
                                this.numOfLessonsToSchedule = this.availableWeeks.length ? this.availableWeeks[this.availableWeeks.length - 1].numOfLessons : null;
                                this.onEndsOnWeekChange();
                                return [2];
                            });
                        });
                    };
                    OplScheduleRecurringDatePopupCtrl.prototype.onEndsOnWeekChange = function () {
                        this.onSkipWeekChanged();
                    };
                    OplScheduleRecurringDatePopupCtrl.prototype.onSkipWeekChanged = function () {
                        this.weekToSkip = null;
                        if (this.numOfLessonsToSchedule >= 3 && this.isSkipWeek) {
                            this.skippableWeeks = [];
                            for (var _i = 0, _a = this.availableWeeks; _i < _a.length; _i++) {
                                var aw = _a[_i];
                                if (aw.numOfLessons >= this.numOfLessonsToSchedule)
                                    break;
                                this.skippableWeeks.push(aw);
                            }
                        }
                        else {
                            this.skippableWeeks = [];
                        }
                        this.weekToSkip = this.skippableWeeks.length ? this.skippableWeeks[0].dateTime : null;
                    };
                    OplScheduleRecurringDatePopupCtrl.prototype.getNextAvailableLesson = function () {
                        var _this = this;
                        var remainLessons = this.qualifyingAvailableLessons.filter(function (availLesson) {
                            var foundIndex = _.findIndex(_this.selectedLessons, function (selected) { return selected.orderDetailID === availLesson.orderDetailID; });
                            return foundIndex < 0;
                        });
                        return remainLessons.length ? remainLessons[0] : null;
                    };
                    OplScheduleRecurringDatePopupCtrl.prototype.nextStep = function () {
                        var _this = this;
                        if (this.frequency == Enums.UI.OPLScheduleRecurringFrequency.NoRepeat) {
                            this.common.$timeout(function () {
                                _this.$scope.$emit(Events.OPLScheduleDateTimeSelected, { fromDirectiveID: OplScheduleRecurringDatePopup.directiveId, startTime: _this.selectedLesson.dateTime });
                            }, 0);
                            this.close();
                            return;
                        }
                        for (var _i = 0, _a = this.availableWeeks; _i < _a.length; _i++) {
                            var aw = _a[_i];
                            if (this.frequency > 0 && this.numOfLessonsToSchedule >= 3 && this.isSkipWeek && aw.dateTime == this.weekToSkip)
                                continue;
                            if (aw.numOfLessons > this.numOfLessonsToSchedule)
                                break;
                            var nextLesson = this.getNextAvailableLesson();
                            if (nextLesson) {
                                this.addSelectedLessonCbFn({
                                    parentOrderDetailID: nextLesson.parentOrderDetailID,
                                    orderDetailID: nextLesson.orderDetailID,
                                    productID: nextLesson.parentProductID,
                                    topic: this.selectedLesson.topic,
                                    topicSkillID: this.selectedLesson.topicSkillID,
                                    dateTime: aw.dateTime,
                                });
                            }
                            else {
                                break;
                            }
                        }
                        this.chooseMultipleInstructorsCbFn();
                        this.close();
                    };
                    OplScheduleRecurringDatePopupCtrl.prototype.cancel = function () {
                        this.showDateTimeListCbFn();
                        this.close();
                    };
                    OplScheduleRecurringDatePopupCtrl.controllerId = "OplScheduleRecurringDatePopupCtrl";
                    return OplScheduleRecurringDatePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                OplScheduleRecurringDatePopup.OplScheduleRecurringDatePopupCtrl = OplScheduleRecurringDatePopupCtrl;
                Pulse.app.directive(OplScheduleRecurringDatePopup.directiveId, ["common", function (c) { return new OplScheduleRecurringDatePopup(c); }]);
            })(OplScheduleRecurringDatePopup = PulsePublic.OplScheduleRecurringDatePopup || (PulsePublic.OplScheduleRecurringDatePopup = {}));
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var DataAccess = Pulse.Common.DataAccess;
        var OnlinePrivateLessonMgr = DataAccess.Managers.OnlinePrivateLessonMgr;
        var ProdAvailabilityMgr = DataAccess.Managers.ProdAvailabilityMgr;
        var OplStudentSubscriptionsDir = (function (_super) {
            __extends(OplStudentSubscriptionsDir, _super);
            function OplStudentSubscriptionsDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "online-private-lesson/public/idp-opl-student-subscriptions.html";
                _this.scope = {
                    studentInfo: "<",
                    studentSubscriptions: "=",
                    selectedTimeZoneType: "<?",
                    selectedParentOrderDetailId: "<?",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OplStudentSubscriptionsDir.OplStudentSubscriptionsDirCtrl];
                return _this;
            }
            OplStudentSubscriptionsDir.directiveId = "idpOplStudentSubscriptions";
            return OplStudentSubscriptionsDir;
        }(Pulse.Common.BaseDirective));
        Directives.OplStudentSubscriptionsDir = OplStudentSubscriptionsDir;
        (function (OplStudentSubscriptionsDir) {
            var OplStudentSubscriptionsDirCtrl = (function (_super) {
                __extends(OplStudentSubscriptionsDirCtrl, _super);
                function OplStudentSubscriptionsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, OplStudentSubscriptionsDirCtrl.controllerId) || this;
                    _this.prodAvailabilityMgr = new ProdAvailabilityMgr(common, breezeService, pulseContext);
                    _this.$scope.$on(Events.CreditCardUpdatedSuccess, function (event, orderDetailID) { return __awaiter(_this, void 0, void 0, function () {
                        var subscription;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    subscription = this.studentSubscriptions.filter(function (item) { return item.orderDetailID === orderDetailID; })[0];
                                    return [4, this.getRecurringPaymentInfo(subscription.currencyTypeID, true)];
                                case 1:
                                    _a.sent();
                                    if (this.creditCardPopupCbFn) {
                                        this.creditCardPopupCbFn();
                                        return [2];
                                    }
                                    if (this.changeType == Directives.PulsePublic.SubscriptionChangePopup.ChangeType.ChangeTopic) {
                                        this.onChangeTopicClick(subscription);
                                    }
                                    else if (this.changeType == Directives.PulsePublic.SubscriptionChangePopup.ChangeType.ChangePlanStep1) {
                                        this.onChangePlanClick(subscription);
                                    }
                                    else if (this.changeType == Directives.PulsePublic.SubscriptionChangePopup.ChangeType.RenewSub) {
                                        this.onClickAction(subscription, this.changeType);
                                    }
                                    else if (this.changeType == Directives.PulsePublic.SubscriptionChangePopup.ChangeType.ReactivateSub) {
                                        this.onClickAction(subscription, this.changeType);
                                    }
                                    return [2];
                            }
                        });
                    }); });
                    return _this;
                }
                OplStudentSubscriptionsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                    _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl);
                };
                OplStudentSubscriptionsDirCtrl.prototype.showRenewalDateHelp = function ($event) {
                    $event.stopPropagation();
                    $event.preventDefault();
                    this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Renewal Date", Pulse.Directives.HelpPopup.HelpTopic.RenewalDateHelp, "renewalDateHelp");
                };
                OplStudentSubscriptionsDirCtrl.prototype.showSuspendedHelp = function ($event, subscription) {
                    $event.stopPropagation();
                    $event.preventDefault();
                    this.onClickAction(subscription, Directives.PulsePublic.SubscriptionChangePopup.ChangeType.SuspendedInfoPopup, Pulse.Common.BasePopup.ModalSize.Large);
                };
                OplStudentSubscriptionsDirCtrl.prototype.onExpandToggle = function (subscription) {
                    if (angular.isUndefined(subscription.isExpanded))
                        subscription.isExpanded = false;
                    subscription.isExpanded = !subscription.isExpanded;
                };
                OplStudentSubscriptionsDirCtrl.prototype.onClickAction = function (subscription, changeType, popupSize) {
                    if (popupSize === void 0) { popupSize = Pulse.Common.BasePopup.ModalSize.ExtraLarge; }
                    return __awaiter(this, void 0, void 0, function () {
                        var promises, err_1;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, 3, 4]);
                                    this.common.toggleSpinner(true, null, null, 0);
                                    promises = [];
                                    if (!subscription.productInfo) {
                                        promises.push(this.prodAvailabilityMgr.getProductAvailability(subscription.productID, this.selectedTimeZoneType.typeID)
                                            .then(function (data) {
                                            subscription.productInfo = data;
                                            return data;
                                        }));
                                    }
                                    return [4, Promise.all(promises)
                                            .then(function () {
                                            _this.common.$rootScope.$broadcast(Events.ShowSubscriptionChangePopup, {
                                                size: popupSize,
                                                initDataObj: {
                                                    parentCtrl: _this,
                                                    subscription: subscription,
                                                    changeType: changeType,
                                                }
                                            });
                                        })];
                                case 1:
                                    _a.sent();
                                    return [3, 4];
                                case 2:
                                    err_1 = _a.sent();
                                    this.logError(err_1);
                                    return [3, 4];
                                case 3:
                                    this.common.toggleSpinner(false);
                                    return [7];
                                case 4: return [2];
                            }
                        });
                    });
                };
                OplStudentSubscriptionsDirCtrl.prototype.onChangeTopicClick = function (subscription) {
                    return __awaiter(this, void 0, void 0, function () {
                        var promises, err_2;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.changeType = Directives.PulsePublic.SubscriptionChangePopup.ChangeType.ChangeTopic;
                                    return [4, this.isCreditCardExpiringBeforeRenewalDate(subscription)];
                                case 1:
                                    if (!((_a.sent()) === false)) return [3, 7];
                                    _a.label = 2;
                                case 2:
                                    _a.trys.push([2, 4, 5, 6]);
                                    this.common.toggleSpinner(true, null, null, 0);
                                    promises = [];
                                    if (!subscription.productInfo) {
                                        promises.push(this.prodAvailabilityMgr.getProductAvailability(subscription.productID, this.selectedTimeZoneType.typeID)
                                            .then(function (data) {
                                            subscription.productInfo = data;
                                            return data;
                                        }));
                                    }
                                    promises.push(this.getProductsForChange(subscription.currencyTypeID, subscription.packSize)
                                        .then(function (prodsForChange) {
                                        if (!prodsForChange || !prodsForChange.length) {
                                            _this.common.showWarning("Oops!  Looks like there are no matching topics for this change.");
                                            return;
                                        }
                                        return _this.prodAvailabilityMgr.getProductAvailability(prodsForChange[0].productID, _this.selectedTimeZoneType.typeID)
                                            .then(function (data) {
                                            subscription.changeToProdInfo = data;
                                            for (var _i = 0, _a = subscription.changeToProdInfo.products; _i < _a.length; _i++) {
                                                var prod = _a[_i];
                                                (prod.name = OnlinePrivateLessonMgr.ParseNameAndPacksize(prod.name).productNamePart1);
                                            }
                                            return subscription.changeToProdInfo;
                                        });
                                    }));
                                    return [4, Promise.all(promises)
                                            .then(function () {
                                            subscription.productImg = _this.getThumbNailFullUrl(subscription.productInfo);
                                            subscription.changeToProdImg = _this.getThumbNailFullUrl(subscription.changeToProdInfo);
                                            _this.common.$rootScope.$broadcast(Events.ShowSubscriptionChangePopup, {
                                                size: 'xl',
                                                initDataObj: {
                                                    parentCtrl: _this,
                                                    subscription: subscription,
                                                    changeType: _this.changeType,
                                                }
                                            });
                                        })];
                                case 3:
                                    _a.sent();
                                    return [3, 6];
                                case 4:
                                    err_2 = _a.sent();
                                    this.logError(err_2);
                                    return [3, 6];
                                case 5:
                                    this.common.toggleSpinner(false);
                                    return [7];
                                case 6: return [3, 8];
                                case 7:
                                    this.showCreditCardPopup(subscription);
                                    _a.label = 8;
                                case 8: return [2];
                            }
                        });
                    });
                };
                OplStudentSubscriptionsDirCtrl.prototype.onChangePlanClick = function (subscription) {
                    return __awaiter(this, void 0, void 0, function () {
                        var promises, err_3;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.changeType = Directives.PulsePublic.SubscriptionChangePopup.ChangeType.ChangePlanStep1;
                                    return [4, this.isCreditCardExpiringBeforeRenewalDate(subscription)];
                                case 1:
                                    if (!((_a.sent()) === false)) return [3, 7];
                                    _a.label = 2;
                                case 2:
                                    _a.trys.push([2, 4, 5, 6]);
                                    this.common.toggleSpinner(true, null, null, 0);
                                    promises = [];
                                    if (!subscription.productInfo) {
                                        promises.push(this.prodAvailabilityMgr.getProductAvailability(subscription.productID, this.selectedTimeZoneType.typeID)
                                            .then(function (data) {
                                            subscription.productInfo = data;
                                            return data;
                                        }));
                                    }
                                    return [4, Promise.all(promises)
                                            .then(function () {
                                            subscription.changeToProdInfo = subscription.productInfo;
                                            subscription.changeToProdInfo.products = subscription.changeToProdInfo.products.filter(function (p) { return p.visibilityTypeID !== Enums.ProductVisibilityType.HideOnCoursePageAndUpsellPublic; });
                                            subscription.changeToProdInfo.products = subscription.changeToProdInfo.products
                                                .filter(function (p) { return (!p.relatedProductTypeID || p.relatedProductTypeID === Enums.RelatedProductType.ProductVariant)
                                                && p.visibilityTypeID !== Enums.ProductVisibilityType.HideOnCoursePageAndUpsellPublic; })
                                                .sort(function (a, b) { return b.quantity - a.quantity; });
                                            for (var _i = 0, _a = subscription.changeToProdInfo.products; _i < _a.length; _i++) {
                                                var prod = _a[_i];
                                                (prod.name = OnlinePrivateLessonMgr.ParseNameAndPacksize(prod.name).productNamePart1);
                                            }
                                            _this.common.$rootScope.$broadcast(Events.ShowSubscriptionChangePopup, {
                                                size: 'xl',
                                                initDataObj: {
                                                    parentCtrl: _this,
                                                    subscription: subscription,
                                                    changeType: _this.changeType,
                                                }
                                            });
                                        })];
                                case 3:
                                    _a.sent();
                                    return [3, 6];
                                case 4:
                                    err_3 = _a.sent();
                                    this.logError(err_3);
                                    return [3, 6];
                                case 5:
                                    this.common.toggleSpinner(false);
                                    return [7];
                                case 6: return [3, 8];
                                case 7:
                                    this.showCreditCardPopup(subscription);
                                    _a.label = 8;
                                case 8: return [2];
                            }
                        });
                    });
                };
                OplStudentSubscriptionsDirCtrl.prototype.onPauseSubClick = function (subscription) {
                    this.onClickAction(subscription, Directives.PulsePublic.SubscriptionChangePopup.ChangeType.Pause);
                };
                OplStudentSubscriptionsDirCtrl.prototype.onCancelSubClick = function (subscription) {
                    this.changeType = Directives.PulsePublic.SubscriptionChangePopup.ChangeType.CancelActive;
                    ;
                    if (subscription.isSuspended) {
                        this.changeType = Directives.PulsePublic.SubscriptionChangePopup.ChangeType.CancelSuspended;
                    }
                    else if (subscription.isRenewPaused) {
                        this.changeType = Directives.PulsePublic.SubscriptionChangePopup.ChangeType.CancelPaused;
                    }
                    this.onClickAction(subscription, this.changeType);
                };
                OplStudentSubscriptionsDirCtrl.prototype.onRenewSubClick = function (subscription) {
                    return __awaiter(this, void 0, void 0, function () {
                        var now;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.changeType = Directives.PulsePublic.SubscriptionChangePopup.ChangeType.RenewSub;
                                    now = new Date();
                                    return [4, this.isCreditCardExpiringBeforeRenewalDate(subscription, now)];
                                case 1:
                                    if ((_a.sent()) === false) {
                                        this.onClickAction(subscription, this.changeType);
                                    }
                                    else {
                                        this.showCreditCardPopup(subscription);
                                    }
                                    return [2];
                            }
                        });
                    });
                };
                OplStudentSubscriptionsDirCtrl.prototype.onManageSubClick = function (subscription) {
                    this.changeType = Directives.PulsePublic.SubscriptionChangePopup.ChangeType.ManageSub;
                    this.onClickAction(subscription, this.changeType);
                };
                OplStudentSubscriptionsDirCtrl.prototype.onReactivateSubClick = function (subscription) {
                    return __awaiter(this, void 0, void 0, function () {
                        var now;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.changeType = Directives.PulsePublic.SubscriptionChangePopup.ChangeType.ReactivateSub;
                                    now = new Date();
                                    return [4, this.isCreditCardExpiringBeforeRenewalDate(subscription, now)];
                                case 1:
                                    if ((_a.sent()) === false) {
                                        this.onClickAction(subscription, this.changeType);
                                    }
                                    else {
                                        this.showCreditCardPopup(subscription);
                                    }
                                    return [2];
                            }
                        });
                    });
                };
                OplStudentSubscriptionsDirCtrl.prototype.getThumbNailFullUrl = function (prodInfo, largeImage) {
                    if (largeImage === void 0) { largeImage = false; }
                    var prodThumbImgUrl = 'no-image';
                    if (prodInfo && prodInfo.productURLs) {
                        var url = prodInfo.productURLs
                            .filter(function (u) { return u.productID === prodInfo.products[0].productID && u.usageTypeID === Enums.ProductURLType.CourseVideoIntroImageURL; })[0];
                        if (url && !String.isNullOrWhitespace(url.uRL)) {
                            prodThumbImgUrl = Pulse.Utils.JS.composeProductThumbNailFullUrl(this.common.config.courseVideoThumbnailUrl, url.uRL, largeImage);
                        }
                    }
                    return prodThumbImgUrl;
                };
                OplStudentSubscriptionsDirCtrl.prototype.getProductsForChange = function (currencyTypeID, packSize) {
                    if (packSize === void 0) { packSize = null; }
                    return __awaiter(this, void 0, void 0, function () {
                        var availableUpsellProds, prods;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4, this.pulseContext.regFlowMgr.loadCurrentUpsellProducts(true)];
                                case 1:
                                    availableUpsellProds = _a.sent();
                                    prods = availableUpsellProds.filter(function (p) {
                                        return p.catalogTypeID === Enums.SalesCatalogType.OPLGeneric
                                            && p.productSubCatTypeID === Enums.ProductSubCategoryType.OneOnOneTutor
                                            && p.currencyTypeID === currencyTypeID
                                            && (packSize === null || p.quantity === packSize);
                                    });
                                    return [2, prods];
                            }
                        });
                    });
                };
                OplStudentSubscriptionsDirCtrl.prototype.getRecurringPaymentInfo = function (currencyTypeID, refreshCache) {
                    if (refreshCache === void 0) { refreshCache = false; }
                    return __awaiter(this, void 0, void 0, function () {
                        var paymentDAO, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    paymentDAO = new DataAccess.PaymentDAO(this.common, this.breezeService, this.pulseContext);
                                    if (!refreshCache && this.cardOnFile && this.cardOnFile.currencyTypeID === currencyTypeID)
                                        return [2, this.cardOnFile];
                                    _a = this;
                                    return [4, paymentDAO.getRecurringPaymentForUserID(this.pulseContext.actingAsUserId, currencyTypeID)];
                                case 1:
                                    _a.cardOnFile = _b.sent();
                                    return [2, this.cardOnFile];
                            }
                        });
                    });
                };
                OplStudentSubscriptionsDirCtrl.prototype.isCreditCardExpiringBeforeRenewalDate = function (subscription, renewalDate) {
                    if (renewalDate === void 0) { renewalDate = null; }
                    return __awaiter(this, void 0, void 0, function () {
                        var self, today, nextMonth;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    self = this;
                                    renewalDate = renewalDate !== null && renewalDate !== void 0 ? renewalDate : subscription.expiryDate;
                                    today = moment();
                                    nextMonth = today.add(1, 'month').toDate();
                                    renewalDate = renewalDate.valueOf() < nextMonth.valueOf() ? nextMonth : renewalDate;
                                    return [4, this.getRecurringPaymentInfo(subscription.currencyTypeID)];
                                case 1:
                                    _a.sent();
                                    return [2, !this.cardOnFile || moment(this.cardOnFile.expirationDate, 'M/YYYY').isSameOrBefore(renewalDate)];
                            }
                        });
                    });
                };
                OplStudentSubscriptionsDirCtrl.prototype.showCreditCardPopup = function (subscription, callbackFn) {
                    this.creditCardPopupCbFn = callbackFn;
                    this.common.$rootScope.$broadcast(Events.ShowCreditCardPopup, {
                        size: '',
                        initDataObj: {
                            selectedOrderDetailId: subscription.orderDetailID,
                            message: 'We noticed that your card on file may be expiring or invalid. You\'ll need to update your payment information so your student can continue to unlock their brilliance with personalized 1-on-1 tutoring.',
                            currencyTypeID: subscription.currencyTypeID,
                        }
                    });
                };
                OplStudentSubscriptionsDirCtrl.controllerId = "OplStudentSubscriptionsDirCtrl";
                return OplStudentSubscriptionsDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OplStudentSubscriptionsDir.OplStudentSubscriptionsDirCtrl = OplStudentSubscriptionsDirCtrl;
        })(OplStudentSubscriptionsDir = Directives.OplStudentSubscriptionsDir || (Directives.OplStudentSubscriptionsDir = {}));
        Pulse.app.directive(OplStudentSubscriptionsDir.directiveId, ["common", function (c) { return new OplStudentSubscriptionsDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var DataAccess = Pulse.Common.DataAccess;
        var ContactChannelsDir = (function (_super) {
            __extends(ContactChannelsDir, _super);
            function ContactChannelsDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "channel-preference/idp-contact-channels.html";
                _this.scope = {
                    contactChannels: "<",
                    userAddresses: "<",
                    targetUser: "<",
                    cancelCallback: "&?",
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    ContactChannelsDir.ContactChannelsDirCtrl];
                return _this;
            }
            ContactChannelsDir.directiveId = "idpContactChannels";
            return ContactChannelsDir;
        }(Pulse.Common.BaseDirective));
        Directives.ContactChannelsDir = ContactChannelsDir;
        (function (ContactChannelsDir) {
            var ContactChannelsDirCtrl = (function (_super) {
                __extends(ContactChannelsDirCtrl, _super);
                function ContactChannelsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ContactChannelsDirCtrl.controllerId) || this;
                    _this.cancelCallback = null;
                    _this.canDelete = false;
                    _this.checkBoxStates = [];
                    _this.optOutAllEmail = false;
                    _this.optOutAllText = false;
                    _this.optOutAllMail = false;
                    _this.optOutAll = false;
                    _this.formName = 'idpContactChannelsForm';
                    _this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.ContactMethod);
                    _this.activationPromises.push(_this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.ContactMethodType.Email, Enums.TypeClassType.ContactChannel)
                        .then(function (data) {
                        _this.emailChannelTypes = data.sort(function (a, b) { return a.typeOrder < b.typeOrder ? -1 : a.typeOrder > b.typeOrder ? 1 : 0; });
                    }));
                    _this.activationPromises.push(_this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.ContactMethodType.CellPhone, Enums.TypeClassType.ContactChannel)
                        .then(function (data) {
                        _this.phoneChannelTypes = data.sort(function (a, b) { return a.typeOrder < b.typeOrder ? -1 : a.typeOrder > b.typeOrder ? 1 : 0; });
                    }));
                    _this.activationPromises.push(_this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.ContactChannel)
                        .then(function (data) {
                        data = data.filter(function (v) { return v.typeID == Enums.ContactChannel.ProgramNewsOffers_Mail; });
                        _this.mailChannelTypes = data.sort(function (a, b) { return a.typeOrder < b.typeOrder ? -1 : a.typeOrder > b.typeOrder ? 1 : 0; });
                    }));
                    _this.checkBoxStates = [];
                    return _this;
                }
                ContactChannelsDirCtrl.prototype.secureAllFeatures = function () {
                    _super.prototype.secureAllFeatures.call(this);
                    this.canDelete = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.Administrator, 1, 2, Enums.UserRoleType.ClientServices, 1, 2);
                };
                ContactChannelsDirCtrl.prototype.$onChanges = function (changesObj) {
                    var _this = this;
                    if (changesObj.contactChannels && changesObj.userAddresses)
                        return;
                    this.common.$q.resolve(this.activateController())
                        .then(function () {
                        if (changesObj.contactChannels && changesObj.contactChannels.currentValue) {
                            var ccArr = _this.contactChannels.filter(function (cc) { return cc.contactMethodTypeID == Enums.ContactMethodType.Email; });
                            _this.emailMethods = [];
                            var _loop_1 = function (cc) {
                                var foundMatces = _this.emailMethods.filter(function (email) { return email.contactMethod == cc.contactMethod; });
                                if (!foundMatces || foundMatces.length == 0) {
                                    _this.emailMethods.push({
                                        contactMethod: cc.contactMethod,
                                        contactMethodTypeID: cc.contactMethodTypeID,
                                    });
                                }
                            };
                            for (var _i = 0, ccArr_1 = ccArr; _i < ccArr_1.length; _i++) {
                                var cc = ccArr_1[_i];
                                _loop_1(cc);
                            }
                            ccArr = _this.contactChannels.filter(function (cc) { return cc.contactMethodTypeID != Enums.ContactMethodType.Email; });
                            _this.phoneMethods = [];
                            var _loop_2 = function (cc) {
                                var foundMatces = _this.phoneMethods.filter(function (phone) { return phone.contactMethod == cc.contactMethod; });
                                if (!foundMatces || foundMatces.length == 0) {
                                    _this.phoneMethods.push({
                                        contactMethod: cc.contactMethod,
                                        contactMethodTypeID: cc.contactMethodTypeID,
                                    });
                                }
                            };
                            for (var _a = 0, ccArr_2 = ccArr; _a < ccArr_2.length; _a++) {
                                var cc = ccArr_2[_a];
                                _loop_2(cc);
                            }
                            _this.initCheckBoxState();
                        }
                        if (changesObj.userAddresses && changesObj.userAddresses.currentValue) {
                            _this.mailMethods = [];
                            var _loop_3 = function (addr) {
                                var foundMatces = _this.mailMethods.filter(function (method) { return method.contactMethod == addr.address1; });
                                if (!foundMatces || foundMatces.length == 0) {
                                    _this.mailMethods.push({
                                        contactMethod: addr.address1,
                                        contactMethodTypeID: Enums.ContactMethodType.Other,
                                        optOut: addr.optOut,
                                    });
                                }
                            };
                            for (var _b = 0, _c = _this.userAddresses; _b < _c.length; _b++) {
                                var addr = _c[_b];
                                _loop_3(addr);
                            }
                            _this.initCheckBoxStateByMethodsAndChannels(_this.mailMethods, _this.mailChannelTypes);
                        }
                        if (changesObj.targetUser && changesObj.targetUser.currentValue) {
                            var infoRequest = (isNaN(changesObj.targetUser.currentValue.infoRequestID) ? null : changesObj.targetUser.currentValue);
                            if (infoRequest && infoRequest.address1) {
                                _this.mailMethods = [];
                                _this.mailMethods.push({
                                    contactMethod: infoRequest.address1,
                                    contactMethodTypeID: Enums.ContactMethodType.Other,
                                    optOut: !infoRequest.requestPromotions,
                                });
                            }
                            _this.initCheckBoxStateByMethodsAndChannels(_this.mailMethods, _this.mailChannelTypes);
                        }
                    });
                };
                ContactChannelsDirCtrl.prototype.initCheckBoxState = function () {
                    this.initCheckBoxStateByMethodsAndChannels(this.emailMethods, this.emailChannelTypes);
                    this.initCheckBoxStateByMethodsAndChannels(this.phoneMethods, this.phoneChannelTypes);
                };
                ContactChannelsDirCtrl.prototype.initCheckBoxStateByMethodsAndChannels = function (methods, channelTypes) {
                    if (!methods || !channelTypes)
                        return;
                    var _loop_4 = function (cm) {
                        var _loop_5 = function (ccType) {
                            if (cm.contactMethodTypeID != Enums.ContactMethodType.Other) {
                                var ccArr = this_1.contactChannels
                                    ? this_1.contactChannels.filter(function (cc) { return cc.contactChannelTypeID == ccType.typeID
                                        && cc.contactMethodTypeID == cm.contactMethodTypeID
                                        && cc.contactMethod == cm.contactMethod; })
                                    : null;
                                if (ccArr === null || ccArr === void 0 ? void 0 : ccArr.length) {
                                    var _loop_6 = function (channel) {
                                        var existingMatch = this_1.checkBoxStates.filter(function (cb) { return cb.contactMethod == channel.contactMethod && cb.contactChannelType == ccType; });
                                        if (!existingMatch || !existingMatch.length) {
                                            this_1.checkBoxStates.push(__assign(__assign({}, channel), { contactChannelType: ccType, newOptOut: channel.optOut }));
                                        }
                                    };
                                    for (var _i = 0, ccArr_3 = ccArr; _i < ccArr_3.length; _i++) {
                                        var channel = ccArr_3[_i];
                                        _loop_6(channel);
                                    }
                                }
                                else {
                                    this_1.checkBoxStates.push({
                                        contactMethod: cm.contactMethod,
                                        contactMethodTypeID: cm.contactMethodTypeID,
                                        contactChannelTypeID: ccType.typeID,
                                        contactChannelType: ccType,
                                        optOut: true,
                                        newOptOut: false,
                                    });
                                }
                            }
                            else {
                                this_1.checkBoxStates.push({
                                    contactMethod: cm.contactMethod,
                                    contactMethodTypeID: cm.contactMethodTypeID,
                                    contactChannelTypeID: ccType.typeID,
                                    contactChannelType: ccType,
                                    optOut: cm.optOut,
                                    newOptOut: cm.optOut,
                                });
                            }
                        };
                        for (var _i = 0, channelTypes_1 = channelTypes; _i < channelTypes_1.length; _i++) {
                            var ccType = channelTypes_1[_i];
                            _loop_5(ccType);
                        }
                    };
                    var this_1 = this;
                    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
                        var cm = methods_1[_i];
                        _loop_4(cm);
                    }
                };
                ContactChannelsDirCtrl.prototype.optOutAllEmailCicked = function () {
                    var channelOptOuts = this.checkBoxStates.filter(function (cc) { return cc.contactMethodTypeID == Enums.ContactMethodType.Email; });
                    for (var _i = 0, channelOptOuts_1 = channelOptOuts; _i < channelOptOuts_1.length; _i++) {
                        var chOptOut = channelOptOuts_1[_i];
                        chOptOut.newOptOut = this.optOutAllEmail;
                    }
                };
                ContactChannelsDirCtrl.prototype.optOutAllTextCicked = function () {
                    var channelOptOuts = this.checkBoxStates.filter(function (cc) { return cc.contactMethodTypeID == Enums.ContactMethodType.CellPhone
                        || cc.contactMethodTypeID == Enums.ContactMethodType.HomePhone; });
                    for (var _i = 0, channelOptOuts_2 = channelOptOuts; _i < channelOptOuts_2.length; _i++) {
                        var chOptOut = channelOptOuts_2[_i];
                        chOptOut.newOptOut = this.optOutAllText;
                    }
                };
                ContactChannelsDirCtrl.prototype.optOutAllMailCicked = function () {
                    var channelOptOuts = this.checkBoxStates.filter(function (cc) { return cc.contactMethodTypeID == Enums.ContactMethodType.Other; });
                    for (var _i = 0, channelOptOuts_3 = channelOptOuts; _i < channelOptOuts_3.length; _i++) {
                        var chOptOut = channelOptOuts_3[_i];
                        chOptOut.newOptOut = this.optOutAllMail;
                    }
                };
                ContactChannelsDirCtrl.prototype.optOutAllCicked = function () {
                    this.optOutAllEmail = this.optOutAllText = this.optOutAllMail = this.optOutAll;
                    for (var _i = 0, _a = this.checkBoxStates; _i < _a.length; _i++) {
                        var chOptOut = _a[_i];
                        chOptOut.newOptOut = this.optOutAll;
                    }
                };
                ContactChannelsDirCtrl.prototype.cancel = function () {
                    if (this.cancelCallback) {
                        this.cancelCallback();
                        return;
                    }
                    this.optOutAllEmail = this.optOutAllText = this.optOutAllMail = this.optOutAll = false;
                    for (var _i = 0, _a = this.checkBoxStates; _i < _a.length; _i++) {
                        var chOptOut = _a[_i];
                        chOptOut.newOptOut = chOptOut.optOut;
                    }
                };
                ContactChannelsDirCtrl.prototype.delete = function () {
                    var _this = this;
                    if (!this.canDelete)
                        return;
                    this.common.showConfirmation("Delete User", "This user's account information and all associated data will be deleted from the system.\n                     <div class='text-danger'>Please be aware that this cannot be undone after deleting.</div>\n                    ", function (confirm) {
                        if (!confirm)
                            return;
                        _this.common.toggleSpinner(true);
                        var promise;
                        var user = _this.targetUser && _this.targetUser.userID ?
                            _this.targetUser : null;
                        if (user) {
                            promise = _this.pulseContext.userMgr.deleteAllUserInfo(user.userID, _this.emailMethods.length ? _this.emailMethods[0].contactMethod : user.userName);
                        }
                        else {
                            var infoRequest = _this.targetUser && _this.targetUser.infoRequestID ?
                                _this.targetUser : null;
                            promise = _this.pulseContext.userMgr.deleteAllUserInfo(null, infoRequest.emailAddress);
                        }
                        promise
                            .then(function () {
                            _this.$location.url(Routes.Logout);
                            _this.common.showMessagePopup("User Deleted", "User account and associated information has been deleted.");
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    }, null, "Delete!", "Cancel");
                };
                ContactChannelsDirCtrl.prototype.submit = function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var channelPrefMgr, user, infoRequest, promises, needToUpdateAddr, needToUpdateInfoRequest, _loop_7, this_2, _i, _a, chkbox, combinedCMs, _loop_8, this_3, matchChecked, isOptOut, _b, combinedCMs_1, cm, err_1;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    if (!this.myForm.$dirty) return [3, 6];
                                    this.submitted = true;
                                    this.common.toggleSpinner(true, null, null, 0);
                                    _c.label = 1;
                                case 1:
                                    _c.trys.push([1, 4, 5, 6]);
                                    channelPrefMgr = new DataAccess.Managers.ChannelPreferenceMgr(this.common, this.breezeService, this.pulseContext);
                                    user = this.targetUser && this.targetUser.userID ?
                                        this.targetUser : null;
                                    infoRequest = this.targetUser && this.targetUser.infoRequestID ?
                                        this.targetUser : null;
                                    promises = [];
                                    needToUpdateAddr = false;
                                    needToUpdateInfoRequest = false;
                                    _loop_7 = function (chkbox) {
                                        if (chkbox.optOut != chkbox.newOptOut) {
                                            if (chkbox.contactMethodTypeID != Enums.ContactMethodType.Other) {
                                                if (chkbox.newOptOut) {
                                                    if (user) {
                                                        if (this_2.pulseContext.isLoggedIn) {
                                                            promises.push(channelPrefMgr.unsubscribeByUserID(user.userID, chkbox.contactChannelTypeID, chkbox.contactMethod));
                                                        }
                                                        else if (!String.isNullOrWhitespace(user.userIDHash)) {
                                                            promises.push(channelPrefMgr.unsubscribe(user.userID.toString(), user.userIDHash, chkbox.contactChannelTypeID, chkbox.contactMethod));
                                                        }
                                                    }
                                                    else if (infoRequest) {
                                                        promises.push(channelPrefMgr.unsubscribe("IR" + infoRequest.infoRequestID, infoRequest.infoRequestIDHash, chkbox.contactChannelTypeID, chkbox.contactMethod));
                                                    }
                                                }
                                                else {
                                                    if (user) {
                                                        if (this_2.pulseContext.isLoggedIn) {
                                                            promises.push(channelPrefMgr.subscribeByUserID(user.userID, chkbox.contactChannelTypeID, chkbox.contactMethod));
                                                        }
                                                        else if (!String.isNullOrWhitespace(user.userIDHash)) {
                                                            promises.push(channelPrefMgr.subscribe(user.userID.toString(), user.userIDHash, chkbox.contactChannelTypeID, chkbox.contactMethod));
                                                        }
                                                    }
                                                    else if (infoRequest) {
                                                        promises.push(channelPrefMgr.subscribe("IR" + infoRequest.infoRequestID, infoRequest.infoRequestIDHash, chkbox.contactChannelTypeID, chkbox.contactMethod));
                                                    }
                                                }
                                            }
                                            else {
                                                if (user && this_2.pulseContext.isLoggedIn) {
                                                    needToUpdateAddr = true;
                                                    var addr = this_2.userAddresses.filter(function (addr) { return addr.address1 === chkbox.contactMethod; })[0];
                                                    addr.optOut = chkbox.newOptOut;
                                                }
                                                else if (infoRequest) {
                                                    needToUpdateInfoRequest = true;
                                                    infoRequest.requestPromotions = !chkbox.newOptOut;
                                                }
                                            }
                                        }
                                    };
                                    this_2 = this;
                                    for (_i = 0, _a = this.checkBoxStates; _i < _a.length; _i++) {
                                        chkbox = _a[_i];
                                        _loop_7(chkbox);
                                    }
                                    if (needToUpdateAddr) {
                                        promises.push(this.breezeService.saveChanges(null, { resourceName: "User_SaveContactInfo" })
                                            .then(function (data) {
                                        }));
                                    }
                                    return [4, Promise.all(promises)];
                                case 2:
                                    _c.sent();
                                    promises = [];
                                    combinedCMs = __spreadArrays(this.emailMethods, this.phoneMethods);
                                    _loop_8 = function (cm) {
                                        matchChecked = this_3.checkBoxStates.filter(function (cb) { return cb.contactMethod == cm.contactMethod
                                            && cb.contactMethodTypeID == cm.contactMethodTypeID
                                            && !cb.newOptOut; });
                                        isOptOut = !(matchChecked && matchChecked.length);
                                        if (user) {
                                            if (this_3.pulseContext.isLoggedIn) {
                                                promises.push(channelPrefMgr.setOptOutOnContactMethodByUserID(user.userID, cm.contactMethodTypeID, cm.contactMethod, isOptOut));
                                            }
                                            else if (!String.isNullOrWhitespace(user.userIDHash)) {
                                                promises.push(channelPrefMgr.setOptOutOnContactMethod(user.userID.toString(), user.userIDHash, user.userName, cm.contactMethodTypeID, cm.contactMethod, isOptOut));
                                            }
                                        }
                                        else if (infoRequest) {
                                            needToUpdateInfoRequest = true;
                                            infoRequest.optOut = isOptOut;
                                        }
                                        else {
                                        }
                                    };
                                    this_3 = this;
                                    for (_b = 0, combinedCMs_1 = combinedCMs; _b < combinedCMs_1.length; _b++) {
                                        cm = combinedCMs_1[_b];
                                        _loop_8(cm);
                                    }
                                    if (needToUpdateInfoRequest) {
                                        promises.push(channelPrefMgr.setOptOutByInfoRequestID(infoRequest.infoRequestID, infoRequest.infoRequestIDHash, infoRequest.optOut, infoRequest.requestPromotions));
                                    }
                                    return [4, Promise.all(promises)];
                                case 3:
                                    _c.sent();
                                    ;
                                    this.common.showSuccess("Subscription Preferences Updated");
                                    this.checkBoxStates = [];
                                    this.common.$rootScope.$broadcast(Events.ContactChannelsUpdated, {
                                        contactChannels: this.contactChannels,
                                        userAddresses: this.userAddresses,
                                    });
                                    return [3, 6];
                                case 4:
                                    err_1 = _c.sent();
                                    this.logError(err_1);
                                    return [3, 6];
                                case 5:
                                    this.myForm.$setSubmitted();
                                    this.myForm.$setPristine();
                                    this.submitted = false;
                                    this.common.toggleSpinner(false);
                                    return [7];
                                case 6: return [2];
                            }
                        });
                    });
                };
                ContactChannelsDirCtrl.controllerId = "ContactChannelsDirCtrl";
                return ContactChannelsDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            ContactChannelsDir.ContactChannelsDirCtrl = ContactChannelsDirCtrl;
        })(ContactChannelsDir = Directives.ContactChannelsDir || (Directives.ContactChannelsDir = {}));
        Pulse.app.directive(ContactChannelsDir.directiveId, ["common", function (c) { return new ContactChannelsDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ChannelPrefPopup = (function (_super) {
                __extends(ChannelPrefPopup, _super);
                function ChannelPrefPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "ScrollLockService",
                        ChannelPrefPopup.ChannelPrefPopupCtrl];
                    return _this;
                }
                ChannelPrefPopup.directiveId = "idpChannelPrefPopup";
                return ChannelPrefPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.ChannelPrefPopup = ChannelPrefPopup;
            (function (ChannelPrefPopup) {
                var ChannelPrefPopupCtrl = (function (_super) {
                    __extends(ChannelPrefPopupCtrl, _super);
                    function ChannelPrefPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, ChannelPrefPopupCtrl.controllerId) || this;
                        _this.formName = "frmChannelPref";
                        _this.checkUnsavedDataBeforeNav = true;
                        _this.event_ShowPopup = Events.ShowChannelPrefPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "channel-preference/idp-channel-pref-popup.html";
                        _this.channelPreferenceMgr = new DataAccess.Managers.ChannelPreferenceMgr(common, breezeService, pulseContext);
                        _this.userAddressDAO = new DataAccess.UserAddressDAO(_this.common, _this.breezeService, _this.pulseContext);
                        _this.$scope.$on(Events.ContactChannelsUpdated, function () {
                            _this.checkUnsavedDataBeforeNav = false;
                            _this.close();
                        });
                        return _this;
                    }
                    ChannelPrefPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.checkUnsavedDataBeforeNav = true;
                        this.targetUser = this.pulseContext.actingAsUser;
                        this.activationPromises.push(this.loadChannelPreferences());
                        this.activateController();
                        this.submitted = false;
                    };
                    ChannelPrefPopupCtrl.prototype.loadChannelPreferences = function () {
                        var _this = this;
                        try {
                            this.common.toggleSpinner(true);
                            var promises = [];
                            promises.push(this.channelPreferenceMgr.getContactChannelsByUserID(this.pulseContext.actingAsUserId)
                                .then(function (data) {
                                _this.contactChannels = data;
                            }));
                            promises.push(this.pulseContext.userMgr.loadAddressesForActingUser(true)
                                .then(function (data) {
                                _this.userAddresses = data.filter(function (a) { return a.addressTypeID == Enums.AddressType.Home
                                    || a.addressTypeID == Enums.AddressType.Permanent; }).sort(function (a, b) { return a.addressTypeID - b.addressTypeID; });
                            }));
                            return this.common.$q.all(promises)
                                .catch(function (e) {
                                _this.logError(e);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                            ;
                        }
                        catch (e) {
                            this.logError(e);
                        }
                    };
                    ChannelPrefPopupCtrl.prototype.close = function (results) {
                        _super.prototype.close.call(this, results);
                    };
                    ChannelPrefPopupCtrl.controllerId = 'ChannelPrefPopupCtrl';
                    return ChannelPrefPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                ChannelPrefPopup.ChannelPrefPopupCtrl = ChannelPrefPopupCtrl;
            })(ChannelPrefPopup = PulsePublic.ChannelPrefPopup || (PulsePublic.ChannelPrefPopup = {}));
            Pulse.app.directive(ChannelPrefPopup.directiveId, ["common", function (c) { return new ChannelPrefPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var OrderConfirmationProductDir = (function (_super) {
            __extends(OrderConfirmationProductDir, _super);
            function OrderConfirmationProductDir(common) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "order-confirmation/idp-order-confirmation-product.html";
                _this.scope = {
                    product: "<?",
                    participant: "<?",
                    rafCode: "<?"
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    OrderConfirmationProductDir.OrderConfirmationProductDirCtrl];
                return _this;
            }
            OrderConfirmationProductDir.directiveId = "idpOrderConfirmationProduct";
            return OrderConfirmationProductDir;
        }(Pulse.Common.BaseDirective));
        Directives.OrderConfirmationProductDir = OrderConfirmationProductDir;
        (function (OrderConfirmationProductDir) {
            var OrderConfirmationProductDirCtrl = (function (_super) {
                __extends(OrderConfirmationProductDirCtrl, _super);
                function OrderConfirmationProductDirCtrl($scope, $location, common, breezeService, pulseContext) {
                    return _super.call(this, $scope, $location, common, breezeService, pulseContext, OrderConfirmationProductDirCtrl.controllerId) || this;
                }
                Object.defineProperty(OrderConfirmationProductDirCtrl.prototype, "isProductTutor", {
                    get: function () {
                        if (this.product) {
                            return this.product.productCategoryTypeID == Enums.ProductCategoryType.Tutor;
                        }
                        else {
                            return false;
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(OrderConfirmationProductDirCtrl.prototype, "manageLessonsUrl", {
                    get: function () {
                        return "#" + Routes.MyAccount_OPLOnlineSessionsClient;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(OrderConfirmationProductDirCtrl.prototype, "scheduleUrl", {
                    get: function () {
                        return "#" + Routes.MyAccount_OPLOnlineSessionsSchedule + "?prodid="
                            + this.product.productID
                            + "&odid=" + this.product.oplFirstPackagedChildOrderDetailID
                            + "&participantid=" + this.participant.userID
                            + "&podid=" + this.product.orderDetailID;
                    },
                    enumerable: false,
                    configurable: true
                });
                OrderConfirmationProductDirCtrl.controllerId = "OrderConfirmationProductDirCtrl";
                return OrderConfirmationProductDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            OrderConfirmationProductDir.OrderConfirmationProductDirCtrl = OrderConfirmationProductDirCtrl;
        })(OrderConfirmationProductDir = Directives.OrderConfirmationProductDir || (Directives.OrderConfirmationProductDir = {}));
        Pulse.app.directive(OrderConfirmationProductDir.directiveId, ["common", function (c) { return new OrderConfirmationProductDir(c); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var UserAgent = Pulse.Modules.Hacks.Services.UserAgent;
        var ProductShareDir = (function (_super) {
            __extends(ProductShareDir, _super);
            function ProductShareDir(common, userAgent) {
                var _this = _super.call(this, common) || this;
                _this.restrict = "E";
                _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "order-confirmation/idp-product-share.html";
                _this.scope = {
                    product: "<?",
                    participant: "<?",
                    rafCode: "<?"
                };
                _this.controller = ["$scope",
                    "$location",
                    "common",
                    "breezeService",
                    "pulseContextService",
                    ProductShareDir.ProductShareDirCtrl];
                _this.userAgent = userAgent;
                return _this;
            }
            ProductShareDir.directiveId = "idpProductShare";
            return ProductShareDir;
        }(Pulse.Common.BaseDirective));
        Directives.ProductShareDir = ProductShareDir;
        (function (ProductShareDir) {
            var ProductShareDirCtrl = (function (_super) {
                __extends(ProductShareDirCtrl, _super);
                function ProductShareDirCtrl($scope, $location, common, breezeService, pulseContext, userAgent) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, ProductShareDirCtrl.controllerId) || this;
                    var facebookAppID = _this.common.config.facebookAppID;
                    window.fbAsyncInit = function () {
                        window.FB.init({
                            appId: facebookAppID,
                            autoLogAppEvents: true,
                            xfbml: true,
                            version: 'v2.10'
                        });
                        window.FB.AppEvents.logPageView();
                    };
                    (function (d, s, id) {
                        var js, fjs = d.getElementsByTagName(s)[0];
                        if (d.getElementById(id)) {
                            return;
                        }
                        js = d.createElement(s);
                        js.id = id;
                        js.src = "https://connect.facebook.net/en_US/sdk.js";
                        fjs.parentNode.insertBefore(js, fjs);
                    }(document, 'script', 'facebook-jssdk'));
                    try {
                        var win = window;
                        var clipboard = new win.ClipboardJS('#btnCopyCode');
                        if (clipboard) {
                            clipboard.on('success', function (e) {
                                var text = e.trigger.innerHTML;
                                e.trigger.innerHTML = 'Link copied';
                                common.$timeout(function () {
                                    e.trigger.innerHTML = text;
                                }, 3000);
                            });
                        }
                    }
                    catch (err) {
                        common.showWarning("Copy function doesn't work on your browser");
                        console.log(err);
                    }
                    return _this;
                }
                ProductShareDirCtrl.prototype.getEmail = function () {
                    return "mailto:?subject=" + encodeURIComponent(this.getEmailSubject()) + "&body=" + encodeURIComponent(this.getEmailBody("\r\n"));
                };
                ProductShareDirCtrl.prototype.getSmsBody = function () {
                    if (Pulse.Utils.JS.getMobileOperatingSystem() == 'iOS') {
                        return "sms:&body=" + encodeURIComponent(this.getEmailBody());
                    }
                    return "sms:?body=" + encodeURIComponent(this.getEmailBody());
                };
                ProductShareDirCtrl.prototype.getMessengerBody = function () {
                    return "http://www.facebook.com/dialog/send?app_id=" + this.common.config.facebookAppID + "&link=" + this.getCourseShareUrl() + "&redirect_uri=" + this.getCourseShareUrl();
                };
                ProductShareDirCtrl.prototype.shareOnFB = function (event) {
                    event.preventDefault();
                    var shareName = this.getEmailSubject() || 'iD Tech summer camp!';
                    var shareDescription = this.getEmailBody("\n") || 'Share iD Tech with Friends on FB';
                    var shareUrl = this.getCourseShareUrl() || this.common.config.WWW_UrlRoot;
                    var fbParams = {
                        method: 'share',
                        display: 'popup',
                        href: shareUrl,
                        quote: shareDescription,
                        hashtag: '',
                        mobile_iframe: true,
                    };
                    FB.ui(fbParams, function (response) { });
                };
                ProductShareDirCtrl.prototype.getEmailSubject = function () {
                    if (!this.participant || !this.rafCode || !this.product)
                        return;
                    return "Join " + (this.participant.preferredName ? this.participant.preferredName : this.participant.firstName) + " " + this.participant.lastName + " in " + this.product.courseName;
                };
                ProductShareDirCtrl.prototype.getEmailBody = function (lineBreak) {
                    var _this = this;
                    if (lineBreak === void 0) { lineBreak = "\n"; }
                    if (!this.participant || !this.rafCode || !this.product)
                        return;
                    var showShortTermName = this.product.catalogTypeID == Enums.SalesCatalogType.CourseBundle || this.product.catalogTypeID == Enums.SalesCatalogType.SquadsMultiWeek;
                    var termName = showShortTermName ? this.product.shortTermName : this.product.termName;
                    var location = (this.product.divisionProgramTypeID == Enums.DivisionProgramType.VirtualCamp || this.product.divisionProgramTypeID == Enums.DivisionProgramType.iDOnLine) ? "" : " at " + this.product.locationName;
                    var rafLine = ProductShareDirCtrl.INVALID_RAF_CODES.filter(function (raf) { return raf == _this.rafCode; }).length == 0 ? lineBreak + "Save $25 if you\u2019re new to iD with code: " + this.rafCode : '';
                    var emailBody = "Join " + (this.participant.preferredName ? this.participant.preferredName : this.participant.firstName) + " in " + this.product.courseName + " - " + this.product.divisionName + location + "! " + this.product.dayOfWeekRange + ", " + this.product.dateRange + ", " + (this.product.catalogTypeID === Enums.SalesCatalogType.CourseBundle ? this.common.$filter('date')(this.product.startDate, "EEE") : '') + " " + termName + "\n                    " + rafLine + "\n                    " + lineBreak + this.product.courseName + ": " + this.getCourseShareUrl();
                    return emailBody;
                };
                ProductShareDirCtrl.prototype.getCourseShareUrl = function () {
                    if (this.product.divisionID == 46) {
                        return this.common.config.WWW_UrlRoot + "/" + this.product.courseDetailsURL + "#" + Routes.RegFlow_ProductAvailability + "?" + QueryStringUtils.PRODUCT_ID + "=" + this.product.productID;
                    }
                    return this.common.config.WWW_UrlRoot + "/" + this.product.courseDetailsURL;
                };
                ProductShareDirCtrl.controllerId = "ProductShareDirCtrl";
                ProductShareDirCtrl.INVALID_RAF_CODES = ['N/A', ''];
                return ProductShareDirCtrl;
            }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
            ProductShareDir.ProductShareDirCtrl = ProductShareDirCtrl;
        })(ProductShareDir = Directives.ProductShareDir || (Directives.ProductShareDir = {}));
        Pulse.app.directive(ProductShareDir.directiveId, ["common",
            UserAgent.registeredAs, function (c, userAgent) { return new ProductShareDir(c, userAgent); }]);
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var Managers = Pulse.Common.DataAccess.Managers;
            var RegFlowAdminOverridePopup = (function (_super) {
                __extends(RegFlowAdminOverridePopup, _super);
                function RegFlowAdminOverridePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        RegFlowAdminOverridePopup.RegFlowAdminOverridePopupCtrl];
                    return _this;
                }
                RegFlowAdminOverridePopup.directiveId = "idpRegFlowAdminOverridePopup";
                return RegFlowAdminOverridePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.RegFlowAdminOverridePopup = RegFlowAdminOverridePopup;
            (function (RegFlowAdminOverridePopup) {
                var RegFlowAdminOverridePopupCtrl = (function (_super) {
                    __extends(RegFlowAdminOverridePopupCtrl, _super);
                    function RegFlowAdminOverridePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, RegFlowAdminOverridePopupCtrl.controllerId) || this;
                        _this.submitted = false;
                        _this.saveDisabled = false;
                        _this.overrideReasonTypes = null;
                        _this.selectedOverrideReason = null;
                        _this.isApproved = false;
                        _this.formName = "frmAdminOverride";
                        _this.title = "Admin Override";
                        _this.event_ShowPopup = Events.ShowRegFlowAdminOverridePopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/idp-reg-flow-admin-override-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    RegFlowAdminOverridePopupCtrl.prototype.open = function (size, initDataObj) {
                        this.userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        this.ageMgr = new Managers.AgeMgr(this.common, this.breezeService, this.pulseContext);
                        this.initDataObj = initDataObj;
                        this.isApproved = false;
                        this.activationPromises.push(this.loadOverrideReasonTypes());
                        this.activationPromises.push(this.loadData());
                        this.activateController();
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    Object.defineProperty(RegFlowAdminOverridePopupCtrl.prototype, "restrictionMsg", {
                        get: function () {
                            var msgStr = "";
                            for (var _i = 0, _a = this.initDataObj.overrideReqs; _i < _a.length; _i++) {
                                var overrideReq = _a[_i];
                                msgStr += "<div>";
                                switch (overrideReq.overrideType) {
                                    case OverrideUIType.AgeOverride:
                                        var minAge = overrideReq.minAge;
                                        var maxAge = overrideReq.maxAge;
                                        var DOB = overrideReq.DOB;
                                        msgStr += String.format("{0} ages {1}-{2}. ", overrideReq.productName, minAge, maxAge);
                                        var age = Managers.AgeMgr.ageAsOfDate(DOB, this.pulseContext.serverDateTime);
                                        msgStr += String.format("Student is {0}", age);
                                        if (age < minAge) {
                                            msgStr += String.format(", turns {0} on {1}", minAge, this.common.$filter('date')(Managers.AgeMgr.dateTurnAge(DOB, minAge), 'MM/dd/yyyy'));
                                        }
                                        else {
                                            msgStr += String.format(", turned {0} on {1}", maxAge, this.common.$filter('date')(Managers.AgeMgr.dateTurnAge(DOB, maxAge), 'MM/dd/yyyy'));
                                        }
                                        break;
                                    default:
                                        throw new Error(StringConst.Err_Not_Implemented);
                                }
                                msgStr += "</div>";
                            }
                            return msgStr;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RegFlowAdminOverridePopupCtrl.prototype.loadOverrideReasonTypes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var promise = this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.OverrideReasonType)
                            .then(function (data) {
                            _this.overrideReasonTypes = data;
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    RegFlowAdminOverridePopupCtrl.prototype.loadData = function () {
                        var promises = new Array();
                        return this.common.$q.all(promises);
                    };
                    RegFlowAdminOverridePopupCtrl.prototype.submit = function () {
                        var _this = this;
                        this.submitted = true;
                        this.saveDisabled = true;
                        if (this.myForm.$valid) {
                            this.common.clearStatus();
                            this.common.toggleSpinner(true);
                            try {
                                var promises_1 = [];
                                this.initDataObj.overrideReqs.forEach(function (overrideReq) {
                                    var minAge = overrideReq.minAge;
                                    var maxAge = overrideReq.maxAge;
                                    var DOB = overrideReq.DOB;
                                    var age = Managers.AgeMgr.ageAsOfDate(DOB, _this.pulseContext.serverDateTime);
                                    var ageOverride = {
                                        child_UB_ID: overrideReq.child_UB_ID,
                                        locationID: overrideReq.locationID,
                                        productID: overrideReq.productID,
                                        sessionID: overrideReq.sessionID,
                                        sessionProductDetailID: overrideReq.sessionProductDetailID,
                                        scheduleDefID: overrideReq.scheduleDefID,
                                        overrideTypeID: Enums.OverrideType.ParticipantTooYoung,
                                        reasonTypeID: _this.selectedOverrideReason.typeID
                                    };
                                    if (overrideReq.overrideType === OverrideUIType.AgeOverride) {
                                        ageOverride.overrideTypeID = (age < minAge) ? Enums.OverrideType.ParticipantTooYoung : Enums.OverrideType.ParticipantTooOld;
                                    }
                                    promises_1.push(_this.userBrowsingMgr.addAdminOverride(_this.userBrowsingMgr.currentUBSession, ageOverride));
                                });
                                var callbackID_1 = this.initDataObj.callbackID;
                                this.common.$q.all(promises_1)
                                    .then(function (data) {
                                    _this.common.$rootScope.$broadcast(Events.AdminOverrideAdded, { data: data, callbackID: callbackID_1 });
                                    _this.close({ data: data, callbackID: callbackID_1 });
                                })
                                    .catch(function (err) {
                                    _this.logError(err);
                                    _this.breezeService.getEntityManager().rejectChanges();
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                    _this.saveDisabled = false;
                                });
                            }
                            catch (err) {
                                this.logError(err);
                            }
                        }
                        else {
                            var msgBuilder = new Pulse.Utils.HtmlListItemizer();
                            if (this.myForm.selOverrideReason.$error.required) {
                                msgBuilder.add("Override Reason is required.");
                            }
                            if (this.myForm.chkApproved.$error.required) {
                                msgBuilder.add("CS Manager/Lead Approval is required.");
                            }
                            this.common.showWarning(msgBuilder.toString());
                            this.saveDisabled = false;
                        }
                    };
                    RegFlowAdminOverridePopupCtrl.controllerId = "RegFlowAdminOverridePopupCtrl";
                    return RegFlowAdminOverridePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                RegFlowAdminOverridePopup.RegFlowAdminOverridePopupCtrl = RegFlowAdminOverridePopupCtrl;
                var OverrideUIType;
                (function (OverrideUIType) {
                    OverrideUIType[OverrideUIType["AgeOverride"] = 0] = "AgeOverride";
                })(OverrideUIType = RegFlowAdminOverridePopup.OverrideUIType || (RegFlowAdminOverridePopup.OverrideUIType = {}));
            })(RegFlowAdminOverridePopup = PulsePublic.RegFlowAdminOverridePopup || (PulsePublic.RegFlowAdminOverridePopup = {}));
            Pulse.app.directive(RegFlowAdminOverridePopup.directiveId, ["common", function (c) { return new RegFlowAdminOverridePopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LocationListGlobalDir = (function (_super) {
                __extends(LocationListGlobalDir, _super);
                function LocationListGlobalDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/loc-finder/idp-location-list-global.html";
                    _this.scope = {
                        lookupCountries: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        LocationListGlobalDir.LocationListGlobalDirCtrl];
                    return _this;
                }
                LocationListGlobalDir.directiveId = "idpLocationListGlobal";
                return LocationListGlobalDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.LocationListGlobalDir = LocationListGlobalDir;
            (function (LocationListGlobalDir) {
                var LocationListGlobalDirCtrl = (function (_super) {
                    __extends(LocationListGlobalDirCtrl, _super);
                    function LocationListGlobalDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LocationListGlobalDirCtrl.controllerId) || this;
                        _this.activateController();
                        return _this;
                    }
                    LocationListGlobalDirCtrl.controllerId = "LocationListGlobalDirCtrl";
                    return LocationListGlobalDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                LocationListGlobalDir.LocationListGlobalDirCtrl = LocationListGlobalDirCtrl;
            })(LocationListGlobalDir = PulsePublic.LocationListGlobalDir || (PulsePublic.LocationListGlobalDir = {}));
            Pulse.app.directive(LocationListGlobalDir.directiveId, ["common", function (c) { return new LocationListGlobalDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LocationCountryDir = (function (_super) {
                __extends(LocationCountryDir, _super);
                function LocationCountryDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/loc-finder/idp-location-country.html";
                    _this.require = "^" + PulsePublic.LocationListGlobalDir.directiveId;
                    _this.scope = {
                        countryInfo: "=",
                        expandedCountryID: "=expandedCountryId",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        LocationCountryDir.LocationCountryDirCtrl];
                    return _this;
                }
                LocationCountryDir.directiveId = "idpLocationCountry";
                return LocationCountryDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.LocationCountryDir = LocationCountryDir;
            (function (LocationCountryDir) {
                var LocationCountryDirCtrl = (function (_super) {
                    __extends(LocationCountryDirCtrl, _super);
                    function LocationCountryDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LocationCountryDirCtrl.controllerId) || this;
                        _this.locations = null;
                        _this.locationFinderMgr = _this.pulseContext.regFlowMgr.locationFinderMgr;
                        _this.activateController();
                        return _this;
                    }
                    LocationCountryDirCtrl.prototype.onHeaderClick = function () {
                        if (!this.isExpanded()) {
                            this.expandedCountryID = this.countryInfo.iD;
                            this.loadLocations();
                            return;
                        }
                        this.expandedCountryID = null;
                    };
                    LocationCountryDirCtrl.prototype.isExpanded = function () {
                        return this.expandedCountryID === this.countryInfo.iD;
                    };
                    LocationCountryDirCtrl.prototype.loadLocations = function () {
                        if (this.locations == null) {
                            this.locations = Pulse.Utils.JS.findByProperties(this.locationFinderMgr.optionItems, {
                                countryID: this.countryInfo.iD
                            });
                        }
                    };
                    LocationCountryDirCtrl.controllerId = "LocationCountryDirCtrl";
                    return LocationCountryDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                LocationCountryDir.LocationCountryDirCtrl = LocationCountryDirCtrl;
            })(LocationCountryDir = PulsePublic.LocationCountryDir || (PulsePublic.LocationCountryDir = {}));
            Pulse.app.directive(LocationCountryDir.directiveId, ["common", function (c) { return new LocationCountryDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LocationListUSDir = (function (_super) {
                __extends(LocationListUSDir, _super);
                function LocationListUSDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/loc-finder/idp-location-list-us.html";
                    _this.scope = {
                        lookupUSStates: "=lookupUsStates",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        LocationListUSDir.LocationListUSDirCtrl];
                    return _this;
                }
                LocationListUSDir.directiveId = "idpLocationListUs";
                return LocationListUSDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.LocationListUSDir = LocationListUSDir;
            (function (LocationListUSDir) {
                var LocationListUSDirCtrl = (function (_super) {
                    __extends(LocationListUSDirCtrl, _super);
                    function LocationListUSDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LocationListUSDirCtrl.controllerId) || this;
                        _this.expandedStateID = null;
                        _this.activateController();
                        return _this;
                    }
                    LocationListUSDirCtrl.controllerId = "LocationListUSDirCtrl";
                    return LocationListUSDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                LocationListUSDir.LocationListUSDirCtrl = LocationListUSDirCtrl;
            })(LocationListUSDir = PulsePublic.LocationListUSDir || (PulsePublic.LocationListUSDir = {}));
            Pulse.app.directive(LocationListUSDir.directiveId, ["common", function (c) { return new LocationListUSDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LocationStateDir = (function (_super) {
                __extends(LocationStateDir, _super);
                function LocationStateDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/loc-finder/idp-location-state.html";
                    _this.require = "^" + PulsePublic.LocationListUSDir.directiveId;
                    _this.scope = {
                        stateInfo: "=",
                        expandedStateID: "=expandedStateId",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        LocationStateDir.LocationStateDirCtrl];
                    return _this;
                }
                LocationStateDir.directiveId = "idpLocationState";
                return LocationStateDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.LocationStateDir = LocationStateDir;
            (function (LocationStateDir) {
                var LocationStateDirCtrl = (function (_super) {
                    __extends(LocationStateDirCtrl, _super);
                    function LocationStateDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LocationStateDirCtrl.controllerId) || this;
                        _this.locations = null;
                        _this.locationFinderMgr = _this.pulseContext.regFlowMgr.locationFinderMgr;
                        _this.activateController();
                        return _this;
                    }
                    LocationStateDirCtrl.prototype.onHeaderClick = function () {
                        if (!this.isExpanded()) {
                            this.expandedStateID = this.stateInfo.hasOwnProperty('subRegionID') ?
                                this.stateInfo.subRegionID
                                : this.stateInfo.iD;
                            this.loadLocations();
                            return;
                        }
                        this.expandedStateID = null;
                    };
                    LocationStateDirCtrl.prototype.isExpanded = function () {
                        if (this.stateInfo.hasOwnProperty('subRegionID')) {
                            return this.expandedStateID === this.stateInfo.subRegionID;
                        }
                        return this.expandedStateID === this.stateInfo.iD;
                    };
                    LocationStateDirCtrl.prototype.loadLocations = function () {
                        if (this.locations == null) {
                            this.locations = Pulse.Utils.JS.findByProperties(this.locationFinderMgr.optionItems, {
                                stateID: this.stateInfo.iD
                            });
                            if (this.stateInfo.subRegionID > 0) {
                                this.locations = Pulse.Utils.JS.findByProperties(this.locations, {
                                    subRegionID: this.stateInfo.subRegionID
                                });
                            }
                        }
                    };
                    LocationStateDirCtrl.controllerId = "LocationStateDirCtrl";
                    return LocationStateDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                LocationStateDir.LocationStateDirCtrl = LocationStateDirCtrl;
            })(LocationStateDir = PulsePublic.LocationStateDir || (PulsePublic.LocationStateDir = {}));
            Pulse.app.directive(LocationStateDir.directiveId, ["common", function (c) { return new LocationStateDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LocationPhysicalDir = (function (_super) {
                __extends(LocationPhysicalDir, _super);
                function LocationPhysicalDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/loc-finder/idp-location-physical.html";
                    _this.scope = {
                        locInfo: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        LocationPhysicalDir.LocationPhysicalDirCtrl];
                    return _this;
                }
                LocationPhysicalDir.directiveId = "idpLocationPhysical";
                return LocationPhysicalDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.LocationPhysicalDir = LocationPhysicalDir;
            (function (LocationPhysicalDir) {
                var ResidencyOption = Pulse.Common.Enums.ResidencyOption;
                var LocationPhysicalDirCtrl = (function (_super) {
                    __extends(LocationPhysicalDirCtrl, _super);
                    function LocationPhysicalDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LocationPhysicalDirCtrl.controllerId) || this;
                        _this.locationFinderMgr = _this.pulseContext.regFlowMgr.locationFinderMgr;
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.activateController();
                        return _this;
                    }
                    LocationPhysicalDirCtrl.prototype.hasDayClasses = function () {
                        return this.locInfo.resTypeID === ResidencyOption.Day
                            || this.locInfo.resTypeID === ResidencyOption.DayAndOvernight;
                    };
                    LocationPhysicalDirCtrl.prototype.hasNightClasses = function () {
                        return this.locInfo.resTypeID === ResidencyOption.DayAndOvernight
                            || this.locInfo.resTypeID === ResidencyOption.Overnight;
                    };
                    LocationPhysicalDirCtrl.prototype.selectLocation = function () {
                        this.locationFinderMgr.addOrRemoveFromSelected(this.locInfo.iD, true, true);
                        this.locInfo.selected = true;
                        this.regFlowMgr.nextStep();
                    };
                    LocationPhysicalDirCtrl.controllerId = "LocationPhysicalDirCtrl";
                    return LocationPhysicalDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                LocationPhysicalDir.LocationPhysicalDirCtrl = LocationPhysicalDirCtrl;
            })(LocationPhysicalDir = PulsePublic.LocationPhysicalDir || (PulsePublic.LocationPhysicalDir = {}));
            Pulse.app.directive(LocationPhysicalDir.directiveId, ["common", function (c) { return new LocationPhysicalDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LocationDivisionDir = (function (_super) {
                __extends(LocationDivisionDir, _super);
                function LocationDivisionDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/loc-finder/idp-location-division.html";
                    _this.scope = {
                        locId: "@",
                        divId: "@"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        LocationDivisionDir.LocationDivisionDirCtrl];
                    return _this;
                }
                LocationDivisionDir.directiveId = "idpLocationDivision";
                return LocationDivisionDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.LocationDivisionDir = LocationDivisionDir;
            (function (LocationDivisionDir) {
                var LocationDivisionDirCtrl = (function (_super) {
                    __extends(LocationDivisionDirCtrl, _super);
                    function LocationDivisionDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, LocationDivisionDirCtrl.controllerId) || this;
                        _this.count = 0;
                        _this.locationFinderMgr = _this.pulseContext.regFlowMgr.locationFinderMgr;
                        _this.divInfo = _this.locationFinderMgr.getDivisionInfoByDivID(_this.divId);
                        return _this;
                    }
                    LocationDivisionDirCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.activationPromises.push(this.locationFinderMgr.getLocationDivisionInfo(this.locId, this.divId)
                            .then(function (data) {
                            if (data && data.length > 0) {
                                _this.locDivInfo = data[0];
                            }
                        }));
                        this.activateController();
                    };
                    LocationDivisionDirCtrl.prototype.onDestroy = function () {
                        this.common.debounceRemove("scrolling");
                        var w = angular.element(this.common.$window);
                        w.unbind("scroll");
                        _super.prototype.onDestroy.call(this);
                    };
                    LocationDivisionDirCtrl.controllerId = "LocationDivisionDirCtrl";
                    return LocationDivisionDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                LocationDivisionDir.LocationDivisionDirCtrl = LocationDivisionDirCtrl;
            })(LocationDivisionDir = PulsePublic.LocationDivisionDir || (PulsePublic.LocationDivisionDir = {}));
            Pulse.app.directive(LocationDivisionDir.directiveId, ["common", function (c) { return new LocationDivisionDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LocationMapPopup = (function (_super) {
                __extends(LocationMapPopup, _super);
                function LocationMapPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "uiGmapIsReady",
                        LocationMapPopup.LocationMapPopupCtrl];
                    return _this;
                }
                LocationMapPopup.directiveId = "idpLocationMapPopup";
                return LocationMapPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.LocationMapPopup = LocationMapPopup;
            (function (LocationMapPopup) {
                var LocationMapPopupCtrl = (function (_super) {
                    __extends(LocationMapPopupCtrl, _super);
                    function LocationMapPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal, uiGmapIsReady) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, LocationMapPopupCtrl.controllerId) || this;
                        _this.title = "Location Map";
                        _this.event_ShowPopup = Events.ShowLocationMapPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/loc-finder/idp-location-map-popup.html";
                        _this.map = uiGmapIsReady;
                        _this.activateController();
                        return _this;
                    }
                    LocationMapPopupCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        this.mapCenter = {
                            latitude: initDataObj.locationAddress.lat,
                            longitude: initDataObj.locationAddress.lng,
                        };
                        this.markerPosition = angular.copy(this.mapCenter);
                        var _self = this;
                        this.common.$timeout(function () {
                            if (angular.isDefined(_self.map) && angular.isDefined(_self.map.refresh)) {
                                _self.map.refresh(_self.mapCenter);
                            }
                        });
                        this.activateController();
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    LocationMapPopupCtrl.controllerId = "LocationMapPopupCtrl";
                    return LocationMapPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                LocationMapPopup.LocationMapPopupCtrl = LocationMapPopupCtrl;
            })(LocationMapPopup = PulsePublic.LocationMapPopup || (PulsePublic.LocationMapPopup = {}));
            Pulse.app.directive(LocationMapPopup.directiveId, ["common", function (c) { return new LocationMapPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var LocationAirportPopup = (function (_super) {
                __extends(LocationAirportPopup, _super);
                function LocationAirportPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "uiGmapIsReady",
                        LocationAirportPopup.LocationAirportPopupCtrl];
                    return _this;
                }
                LocationAirportPopup.directiveId = "idpLocationAirportPopup";
                return LocationAirportPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.LocationAirportPopup = LocationAirportPopup;
            (function (LocationAirportPopup) {
                var LocationAirportPopupCtrl = (function (_super) {
                    __extends(LocationAirportPopupCtrl, _super);
                    function LocationAirportPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal, uiGmapIsReady) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, LocationAirportPopupCtrl.controllerId) || this;
                        _this.title = "Nearby Airports";
                        _this.event_ShowPopup = Events.ShowLocationAirportPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/loc-finder/idp-location-airport-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    LocationAirportPopupCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        this.activateController();
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    LocationAirportPopupCtrl.controllerId = "LocationAirportPopupCtrl";
                    return LocationAirportPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                LocationAirportPopup.LocationAirportPopupCtrl = LocationAirportPopupCtrl;
            })(LocationAirportPopup = PulsePublic.LocationAirportPopup || (PulsePublic.LocationAirportPopup = {}));
            Pulse.app.directive(LocationAirportPopup.directiveId, ["common", function (c) { return new LocationAirportPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var LocationList = (function (_super) {
                __extends(LocationList, _super);
                function LocationList() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        locationList: '<',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'location/components/idp-ipc-location-list.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        "$location",
                        '$element',
                        'pulseContextService',
                        'ProductAvailabilityStepService',
                        '$timeout',
                        function ($scope, $location, $element, pulseContext, pulsePass, $t) { return new LocationListCtrl($scope, $location, $element, pulseContext, pulsePass, $t); }
                    ];
                    return _this;
                }
                LocationList.registeredAs = 'idpIpcLocationList';
                return LocationList;
            }(ComponentOptions));
            var LocationListCtrl = (function (_super) {
                __extends(LocationListCtrl, _super);
                function LocationListCtrl($scope, $location, $element, PulseContext, pulsePass, $timeout) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.pulsePass = pulsePass;
                    _this.$location = $location;
                    return _this;
                }
                LocationListCtrl.prototype.onLocationClicked = function (loc) {
                    this.$location.search(QueryStringUtils.PRODUCT_ID, null);
                    this.$location.url(this.$location.url() + ("&" + QueryStringUtils.PRODUCT_ID + "=" + loc.productID + "&lid=" + loc.locationID + "&ls=1"));
                };
                return LocationListCtrl;
            }(ComponentController));
            Pulse.app.component(LocationList.registeredAs, new LocationList());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var LocationRegionGroup = (function (_super) {
                __extends(LocationRegionGroup, _super);
                function LocationRegionGroup() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        locationClickHandler: '&?',
                        regionGroup: '<',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'location/components/idp-location-region-group.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        function ($scope, $element, pc) { return new LocationRegionGroupCtrl($scope, $element, pc); }
                    ];
                    return _this;
                }
                LocationRegionGroup.registeredAs = 'idpLocationRegionGroup';
                return LocationRegionGroup;
            }(ComponentOptions));
            var LocationRegionGroupCtrl = (function (_super) {
                __extends(LocationRegionGroupCtrl, _super);
                function LocationRegionGroupCtrl($scope, $element, pulseC) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this._locMgr = pulseC.regFlowMgr.locationFinderMgr;
                    _this.locationClickHandler = function (l) { return undefined; };
                    return _this;
                }
                LocationRegionGroupCtrl.prototype.selectLocation = function (location) {
                    this.locationClickHandler({ location: location });
                };
                LocationRegionGroupCtrl.prototype.isVirtual = function (regionGroup) {
                    return regionGroup && angular.isArray(regionGroup.regions) && regionGroup.regions[0].isVirtual;
                };
                LocationRegionGroupCtrl.prototype.isIndexInColumn = function (index, columnIndex, columnCount) {
                    return index >= this.getColumnStartIndex(columnCount, columnIndex)
                        && index < this.getColumnStartIndex(columnCount, columnIndex + 1);
                };
                LocationRegionGroupCtrl.prototype.isIndexOutsideColumn = function (index, columnIndex, columnCount) {
                    return !this.isIndexInColumn(index, columnIndex, columnCount);
                };
                LocationRegionGroupCtrl.prototype.getColumnStartIndex = function (columnsCount, columnIndex) {
                    return Math.floor(this.regionsLength / columnsCount) * columnIndex
                        + Math.min(this.regionsLength % columnsCount, columnIndex);
                };
                Object.defineProperty(LocationRegionGroupCtrl.prototype, "regionsLength", {
                    get: function () {
                        return this.regionGroup.regions.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                return LocationRegionGroupCtrl;
            }(ComponentController));
            Pulse.app.component(LocationRegionGroup.registeredAs, new LocationRegionGroup());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var ResidencyOption = Pulse.Common.Enums.ResidencyOption;
            var LocationRegion = (function (_super) {
                __extends(LocationRegion, _super);
                function LocationRegion() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        locationClickHandler: '&?',
                        region: '<',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'location/components/idp-location-region.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        '$timeout',
                        function ($scope, $element, pulseContext, $t) { return new LocationRegionCtrl($scope, $element, pulseContext, $t); }
                    ];
                    return _this;
                }
                LocationRegion.registeredAs = 'idpLocationRegion';
                return LocationRegion;
            }(ComponentOptions));
            var LocationRegionCtrl = (function (_super) {
                __extends(LocationRegionCtrl, _super);
                function LocationRegionCtrl($scope, $element, PulseContext, $timeout) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.$timeout = $timeout;
                    _this.locationClickHandler = function (l) { return undefined; };
                    _this.pulseContext = PulseContext;
                    return _this;
                }
                LocationRegionCtrl.prototype.onRegionNameClick = function (event, region) {
                    if (region.locations && region.locTypeID == Enums.LocationType.VirtualSquads) {
                        this.selectLocation(region.locations[0]);
                        return;
                    }
                    else if (region.isOPL && !String.isNullOrWhitespace(region.webUrl)) {
                        window.location.assign(region.webUrl);
                    }
                    else {
                        this.toggleExpander(event, region);
                    }
                };
                LocationRegionCtrl.prototype.toggleExpander = function (event, region) {
                    if (!LocationRegionCtrl.animationInProgress) {
                        LocationRegionCtrl.animationInProgress = true;
                        region.toggleExpansion();
                        this.$timeout(function () { LocationRegionCtrl.animationInProgress = false; }, LocationRegionCtrl.defferDuration);
                    }
                };
                LocationRegionCtrl.prototype.selectLocation = function (location) {
                    this.locationClickHandler({ location: location });
                };
                LocationRegionCtrl.prototype.hasDayClasses = function (location) {
                    return location.locTypeID === Enums.LocationType.UniversityCollege
                        && (location.resTypeID === ResidencyOption.Day
                            || location.resTypeID === ResidencyOption.DayAndOvernight);
                };
                LocationRegionCtrl.prototype.hasNightClasses = function (location) {
                    return location.locTypeID === Enums.LocationType.UniversityCollege
                        && (location.resTypeID === ResidencyOption.DayAndOvernight
                            || location.resTypeID === ResidencyOption.Overnight);
                };
                LocationRegionCtrl.prototype.showLocation = function (loc) {
                    var show = true;
                    if (loc.campAtHQ !== undefined) {
                        show = loc.campAtHQ.indexOf("False") > -1 || this.pulseContext.isImpersonating;
                    }
                    return show;
                };
                LocationRegionCtrl.animationInProgress = false;
                LocationRegionCtrl.defferDuration = 600;
                return LocationRegionCtrl;
            }(ComponentController));
            Pulse.app.component(LocationRegion.registeredAs, new LocationRegion());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var Abstracts;
            (function (Abstracts) {
                var ParallelListSelection = (function () {
                    function ParallelListSelection() {
                        this.resetSelection();
                    }
                    ParallelListSelection.prototype.isSelected = function (target) {
                        return this.getIndexOf(target) !== -1;
                    };
                    ParallelListSelection.prototype.toggleStatusChange = function (target) {
                        var index = this.getIndexOf(target);
                        if (index !== -1)
                            this.selection.splice(index, 1);
                        else
                            this.selection.push(this.createElementIdentifier(target));
                    };
                    ParallelListSelection.prototype.select = function (target) {
                        var index = this.getIndexOf(target);
                        if (index === -1)
                            this.selection.push(this.createElementIdentifier(target));
                    };
                    ParallelListSelection.prototype.unselect = function (target) {
                        var index = this.getIndexOf(target);
                        if (index !== -1)
                            this.selection.splice(index, 1);
                    };
                    ParallelListSelection.prototype.retrieveSelected = function (list) {
                        var _this = this;
                        return list.filter(function (e) { return _this.getIndexOf(e) !== -1; });
                    };
                    ParallelListSelection.prototype.resetSelection = function () {
                        this.selection = [];
                    };
                    ParallelListSelection.prototype.updateContext = function (list) {
                        var _this = this;
                        var index;
                        var newList = [];
                        list.forEach(function (e) {
                            index = _this.getIndexOf(e);
                            if (index !== -1)
                                newList.push(_this.selection[index]);
                        });
                        this.selection = newList;
                    };
                    ParallelListSelection.prototype.getIndexOf = function (target) {
                        var expandedTermDivIndex = -1;
                        for (var i = 0; i < this.selection.length; i++)
                            if (this.compareValues(target, this.selection[i])) {
                                expandedTermDivIndex = i;
                                break;
                            }
                        return expandedTermDivIndex;
                    };
                    return ParallelListSelection;
                }());
                Abstracts.ParallelListSelection = ParallelListSelection;
            })(Abstracts = RegistryFlow.Abstracts || (RegistryFlow.Abstracts = {}));
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var Views;
            (function (Views) {
                var AvChart;
                (function (AvChart) {
                    var Config;
                    (function (Config) {
                        var AlignmentEnum = Pulse.Modules.ContainerBoundSticky.Definition.AlignmentEnum;
                        Pulse.app.constant('avcStickiesConfig', {
                            boundingContainerSelector: '.avc-availability-chart',
                            stickiesDef: [
                                {
                                    position: {
                                        vertical: AlignmentEnum.Center
                                    },
                                    selector: 'idp-avc-left-filters-panel .left-filters-panel',
                                    styleCorrection: function (BCRElement, mgrBoundingContainer, adjustment) {
                                        var style = {};
                                        style.left = window.innerWidth >= 1200 ? mgrBoundingContainer.left + 'px' : '0';
                                        style.position = window.innerWidth < 768 ? 'static' : 'fixed';
                                        return style;
                                    },
                                    styleDefault: {
                                        'z-index': '90'
                                    }
                                }
                            ],
                            subManagers: [
                                {
                                    boundingContainerSelector: '.av-chart',
                                    stickiesDef: [
                                        {
                                            inBoundCorrection: {
                                                bottom: 50
                                            },
                                            optionFlags: {
                                                clone: true
                                            },
                                            position: {
                                                vertical: AlignmentEnum.Start
                                            },
                                            selector: '.av-sessions-header',
                                            styleDefault: {
                                                'z-index': '80'
                                            }
                                        }
                                    ]
                                }
                            ]
                        });
                        Pulse.app.constant('avcUnmanagedStickies', [
                            {
                                relevantPosition: {
                                    bottom: true
                                },
                                selector: '.avc-cart-checkout'
                            },
                            {
                                relevantPosition: {
                                    top: true
                                },
                                selector: '#site-header nav.navbar'
                            }
                        ]);
                    })(Config = AvChart.Config || (AvChart.Config = {}));
                })(AvChart = Views.AvChart || (Views.AvChart = {}));
            })(Views = RegistryFlow.Views || (RegistryFlow.Views = {}));
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ChartFilter = (function () {
                function ChartFilter(name, options, stepManager) {
                    if (stepManager === void 0) { stepManager = null; }
                    this._id = name.replace(' ', '_').toLowerCase();
                    this._name = name;
                    this._stepMgr = stepManager;
                    this._options = options;
                    this._allSelectedOption = new SelectAllFilterOption();
                }
                Object.defineProperty(ChartFilter.prototype, "id", {
                    get: function () {
                        return this._id;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChartFilter.prototype, "name", {
                    get: function () {
                        return this._name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChartFilter.prototype, "options", {
                    get: function () {
                        return this._options;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChartFilter.prototype, "allSelectedOption", {
                    get: function () {
                        return this._allSelectedOption;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChartFilter.prototype, "selection", {
                    get: function () {
                        var _this = this;
                        return this.options.filter(function (option) {
                            return _this._allSelectedOption.state && !option.state
                                || !_this._allSelectedOption.state && option.state;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                ChartFilter.prototype.switchOptionState = function (option) {
                    this.updateFilterState();
                    this.syncStepMgr();
                };
                ChartFilter.prototype.selectAll = function () {
                    this.resetSelected();
                    this.syncStepMgr();
                };
                ChartFilter.prototype.validateCourse = function (course) {
                    return this._allSelectedOption.validateCourseVsOption(course)
                        || matchAnyOption(course, this.options);
                    function matchAnyOption(subject, options) {
                        return options.some(function (o) { return o.validateCourseVsOption(subject); });
                    }
                };
                ChartFilter.prototype.syncToStepMgr = function () {
                    var _this = this;
                    if (this._stepMgr !== null
                        && !arraysAreEqual(getSelectedOptionsIds(this.options), this._stepMgr.selectedIds)) {
                        this.options.forEach(function (option) {
                            return option.state = _this._stepMgr.selectedIds.indexOf(option.id) !== -1;
                        });
                        this.updateFilterState();
                    }
                    function getSelectedOptionsIds(options) {
                        var ids = [];
                        options.forEach(function (option) {
                            if (option.state)
                                ids.push(option.id);
                        });
                        return ids;
                    }
                    function arraysAreEqual(a, b) {
                        return a.length === b.length && a.every(function (el) { return b.indexOf(el) !== -1; });
                    }
                };
                ChartFilter.prototype.syncStepMgr = function () {
                    var _this = this;
                    if (this._stepMgr !== null)
                        if (this.allSelectedOption.state)
                            this._stepMgr.clearAllSelected();
                        else {
                            this.options.forEach(function (option) {
                                return _this._stepMgr.addOrRemoveFromSelected(option.id, option.state, false);
                            });
                            this._stepMgr.saveState();
                        }
                };
                ChartFilter.prototype.updateFilterState = function () {
                    if (hasNoneSelected(this.options) && !this._allSelectedOption.state || this._allSelectedOption.state)
                        this.allSelectedOption.switchState();
                    function hasAllSelected(options) {
                        return options.every(function (option) { return option.state; });
                    }
                    function hasNoneSelected(options) {
                        return !options.some(function (option) { return option.state; });
                    }
                };
                ChartFilter.prototype.resetSelected = function () {
                    this.allSelectedOption.resetToDefault();
                    this.options.forEach(function (option) { return option.resetToDefault(); });
                };
                return ChartFilter;
            }());
            RegistryFlow.ChartFilter = ChartFilter;
            var FilterOption = (function () {
                function FilterOption(id, displayedText, defaultState) {
                    if (defaultState === void 0) { defaultState = false; }
                    this._id = id;
                    this._displayedText = displayedText;
                    this._defaultState = defaultState;
                    this.resetToDefault();
                }
                Object.defineProperty(FilterOption.prototype, "id", {
                    get: function () {
                        return this._id;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(FilterOption.prototype, "displayedText", {
                    get: function () {
                        return this._displayedText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(FilterOption.prototype, "state", {
                    get: function () {
                        return this._state;
                    },
                    set: function (state) {
                        this._state = state;
                    },
                    enumerable: false,
                    configurable: true
                });
                FilterOption.prototype.switchState = function () {
                    this._state = !this._state;
                };
                FilterOption.prototype.resetToDefault = function () {
                    this._state = this._defaultState;
                };
                return FilterOption;
            }());
            RegistryFlow.FilterOption = FilterOption;
            var SelectAllFilterOption = (function (_super) {
                __extends(SelectAllFilterOption, _super);
                function SelectAllFilterOption(displayedText, defaultState) {
                    if (displayedText === void 0) { displayedText = 'All'; }
                    if (defaultState === void 0) { defaultState = true; }
                    return _super.call(this, -1, displayedText, defaultState) || this;
                }
                SelectAllFilterOption.prototype.validateCourseVsOption = function (course) {
                    return this.state;
                };
                return SelectAllFilterOption;
            }(FilterOption));
            RegistryFlow.SelectAllFilterOption = SelectAllFilterOption;
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ProductGenreType = Pulse.Common.Enums.ProductGenreType;
            var PathFilterService = (function (_super) {
                __extends(PathFilterService, _super);
                function PathFilterService() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                PathFilterService.registeredAs = 'PathFilterService';
                return PathFilterService;
            }(RegistryFlow.ChartFilter));
            RegistryFlow.PathFilterService = PathFilterService;
            var PathOption = (function (_super) {
                __extends(PathOption, _super);
                function PathOption() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                PathOption.prototype.validateCourseVsOption = function (course) {
                    return this.state && course.genreIDs.indexOf(this.id) !== -1;
                };
                return PathOption;
            }(RegistryFlow.FilterOption));
            RegistryFlow.PathOption = PathOption;
            Pulse.app.factory(PathFilterService.registeredAs, [
                'pulseContextService',
                function (pulseContext) {
                    var options = [];
                    var id;
                    var displayedText;
                    for (var path in ProductGenreType) {
                        id = parseInt(ProductGenreType[path], 10);
                        if (!isNaN(id)) {
                            displayedText = path.replace(/([A-Z])/g, ' $1').trim();
                            options.push(new PathOption(id, displayedText));
                        }
                    }
                    return new PathFilterService('Path', options, pulseContext.regFlowMgr.genreFinderMgr);
                },
            ]);
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var AgeSetFilterService = (function (_super) {
                __extends(AgeSetFilterService, _super);
                function AgeSetFilterService(name, options, stepManger) {
                    return _super.call(this, name, AgeSetFilterService.createOptionsFromAgeRangeArray(options), stepManger) || this;
                }
                AgeSetFilterService.createOptionsFromAgeRangeArray = function (optionsDefinition) {
                    var options = [];
                    optionsDefinition.forEach(function (option, i) {
                        return options.push(new AgeFilterOption(i, option.min, option.max));
                    });
                    return options;
                };
                AgeSetFilterService.registeredAs = 'AgeSetFilterService';
                return AgeSetFilterService;
            }(RegistryFlow.ChartFilter));
            RegistryFlow.AgeSetFilterService = AgeSetFilterService;
            var AgeFilterOption = (function (_super) {
                __extends(AgeFilterOption, _super);
                function AgeFilterOption(id, minAge, maxAge) {
                    var _this = _super.call(this, id, minAge + ' - ' + maxAge) || this;
                    _this.minAge = minAge;
                    _this.maxAge = maxAge;
                    return _this;
                }
                AgeFilterOption.prototype.validateCourseVsOption = function (course) {
                    return this.state && this.courseAgeRangeInOptionRange(course);
                };
                AgeFilterOption.prototype.courseAgeRangeInOptionRange = function (course) {
                    var isValid = true;
                    if (course.minAge < this.minAge)
                        isValid = this.minAge <= course.maxAge;
                    else if (course.minAge > this.minAge)
                        isValid = this.maxAge >= course.minAge;
                    return isValid;
                };
                return AgeFilterOption;
            }(RegistryFlow.FilterOption));
            RegistryFlow.AgeFilterOption = AgeFilterOption;
            Pulse.app.factory(AgeSetFilterService.registeredAs, [
                'pulseContextService',
                'ageIntervals',
                function (pulseContext, ai) {
                    return new AgeSetFilterService('Ages', ai, pulseContext.regFlowMgr.ageFilterMgr);
                },
            ]);
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var AgeSetFilter = Pulse.PulsePublic.RegistryFlow.AgeSetFilterService;
            var PathFilter = Pulse.PulsePublic.RegistryFlow.PathFilterService;
            var ChartFiltersMgr = (function () {
                function ChartFiltersMgr() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    this._registeredFilters = args;
                }
                Object.defineProperty(ChartFiltersMgr.prototype, "filters", {
                    get: function () {
                        return this._registeredFilters;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChartFiltersMgr.prototype, "areFiltersSynced", {
                    get: function () {
                        return this._areFiltersSynced;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChartFiltersMgr.prototype, "countSelectedOptions", {
                    get: function () {
                        var count = 0;
                        this.filters.forEach(function (chartFilter) {
                            count += chartFilter.allSelectedOption.state ? 0 : chartFilter.selection.length;
                        });
                        return count;
                    },
                    enumerable: false,
                    configurable: true
                });
                ChartFiltersMgr.prototype.checkCourseValidity = function (course) {
                    return this.filters.every(function (chartFilter) {
                        return chartFilter.validateCourse(course);
                    });
                };
                ChartFiltersMgr.prototype.resetAllFilters = function () {
                    this._registeredFilters.forEach(function (chartFilter) { return chartFilter.selectAll(); });
                };
                ChartFiltersMgr.prototype.syncWithStepManagers = function () {
                    this.filters.forEach(function (chartFilter) { return chartFilter.syncToStepMgr(); });
                    this._areFiltersSynced = true;
                };
                ChartFiltersMgr.prototype.resetFiltersSyncState = function () {
                    this._areFiltersSynced = false;
                };
                ChartFiltersMgr.registeredAs = 'chartFilterMgr';
                return ChartFiltersMgr;
            }());
            RegistryFlow.ChartFiltersMgr = ChartFiltersMgr;
            Pulse.app.factory(ChartFiltersMgr.registeredAs, [
                PathFilter.registeredAs,
                AgeSetFilter.registeredAs,
                function (p, a) {
                    return new ChartFiltersMgr(p, a);
                }
            ]);
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var WalkthroughListSelectablesDir = (function (_super) {
                __extends(WalkthroughListSelectablesDir, _super);
                function WalkthroughListSelectablesDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/walkthrough-filter/idp-walkthrough-list-selectables.html";
                    _this.scope = {
                        selectables: '<',
                        selectedIds: '=',
                        mediaServerResourcePath: '<',
                        toggleSelection: "&"
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        WalkthroughListSelectablesDir.WalkthroughListSelectablesDirCtrl
                    ];
                    return _this;
                }
                WalkthroughListSelectablesDir.directiveId = 'idpWalkthroughListSelectables';
                return WalkthroughListSelectablesDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.WalkthroughListSelectablesDir = WalkthroughListSelectablesDir;
            (function (WalkthroughListSelectablesDir) {
                var WalkthroughListSelectablesDirCtrl = (function (_super) {
                    __extends(WalkthroughListSelectablesDirCtrl, _super);
                    function WalkthroughListSelectablesDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, WalkthroughListSelectablesDirCtrl.controllerId) || this;
                        _this.webHost = common.config.WWW_UrlRoot;
                        _this.activateController();
                        return _this;
                    }
                    WalkthroughListSelectablesDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude, compilationInfoObj) {
                        var self = this;
                        scope.$watchCollection(function () {
                            return self.selectables;
                        }, function () {
                            self.checkboxes = [];
                            if (Pulse.jQuery.isArray(self.selectables)) {
                                for (var _i = 0, _a = self.selectables; _i < _a.length; _i++) {
                                    var selectable = _a[_i];
                                    self.checkboxes.push(self.selectedIds.indexOf(selectable.iD) !== -1);
                                }
                            }
                        });
                    };
                    WalkthroughListSelectablesDirCtrl.prototype.toggleCheckbox = function (index) {
                        this.checkboxes[index] = !this.checkboxes[index];
                        this.toggleSelection({ genreID: this.selectables[index].iD });
                    };
                    WalkthroughListSelectablesDirCtrl.controllerId = "WalkthroughListSelectablesDirCtrl";
                    return WalkthroughListSelectablesDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                WalkthroughListSelectablesDir.WalkthroughListSelectablesDirCtrl = WalkthroughListSelectablesDirCtrl;
            })(WalkthroughListSelectablesDir = PulsePublic.WalkthroughListSelectablesDir || (PulsePublic.WalkthroughListSelectablesDir = {}));
            Pulse.app.directive(WalkthroughListSelectablesDir.directiveId, [
                "common",
                function (c) { return new WalkthroughListSelectablesDir(c); }
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var RegFlowMgr = Pulse.Common.DataAccess.Managers.RegFlowMgr;
            var AvcCurrentLocation = (function (_super) {
                __extends(AvcCurrentLocation, _super);
                function AvcCurrentLocation() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        disableChangeLocation: '&?',
                        navigateToLocations: '&',
                        selectedLocation: '<',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/header-panel/idp-avc-current-location.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'config',
                        'pulseContextService',
                        function ($scope, $element, config, pulseContextService) {
                            return new AvcCurrentLocationCtrl($scope, $element, config, pulseContextService);
                        },
                    ];
                    return _this;
                }
                AvcCurrentLocation.registeredAs = 'idpAvcCurrentLocation';
                return AvcCurrentLocation;
            }(ComponentOptions));
            RegistryFlow.AvcCurrentLocation = AvcCurrentLocation;
            var AvcCurrentLocationCtrl = (function (_super) {
                __extends(AvcCurrentLocationCtrl, _super);
                function AvcCurrentLocationCtrl($scope, $element, config, pulseContextService) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.logo = 'ic-university.svg';
                    _this.disableChangeLocation = function () { return false; };
                    _this.config = config;
                    _this.regFlowMgr = pulseContextService.regFlowMgr;
                    return _this;
                }
                Object.defineProperty(AvcCurrentLocationCtrl.prototype, "logoPath", {
                    get: function () {
                        return this.config.mediaServerUrl + ("/" + this.logo);
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcCurrentLocationCtrl.prototype.goToChooseLocationsView = function () {
                    this.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.Location);
                };
                return AvcCurrentLocationCtrl;
            }(ComponentController));
            RegistryFlow.AvcCurrentLocationCtrl = AvcCurrentLocationCtrl;
            Pulse.app.component(AvcCurrentLocation.registeredAs, new AvcCurrentLocation());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var ChartFiltersMgr = Pulse.PulsePublic.RegistryFlow.ChartFiltersMgr;
            var AvcActiveFilters = (function (_super) {
                __extends(AvcActiveFilters, _super);
                function AvcActiveFilters() {
                    var _this = _super.call(this) || this;
                    _this.templateUrl = [
                        'config',
                        function (config) { return config.appRoot
                            + Paths.PulsePublicRegistryFlow
                            + 'av-chart/components/header-panel/idp-avc-active-filters.html'; }
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'config',
                        '$rootScope',
                        ChartFiltersMgr.registeredAs,
                        'FilterPanelToggleService',
                        function ($scope, $element, config, $rootScope, cfm, filterPanelToggleService) {
                            return new AvcActiveFiltersCtrl($scope, $element, config, $rootScope, cfm, filterPanelToggleService);
                        }
                    ];
                    return _this;
                }
                AvcActiveFilters.registeredAs = 'idpAvcActiveFilters';
                return AvcActiveFilters;
            }(ComponentOptions));
            RegistryFlow.AvcActiveFilters = AvcActiveFilters;
            var AvcActiveFiltersCtrl = (function (_super) {
                __extends(AvcActiveFiltersCtrl, _super);
                function AvcActiveFiltersCtrl($scope, $element, config, $rootScope, chartFilterMgr, filterPanelToggleService) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.logo = 'ic-monitor.svg';
                    _this.config = config;
                    _this.$rootScope = $rootScope;
                    _this.chartFiltersMgr = chartFilterMgr;
                    _this.filterPanelToggleService = filterPanelToggleService;
                    return _this;
                }
                Object.defineProperty(AvcActiveFiltersCtrl.prototype, "countSelectedOptions", {
                    get: function () {
                        return this.chartFiltersMgr.countSelectedOptions;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcActiveFiltersCtrl.prototype.displayLeftFiltersPanel = function () {
                    if (this.isButtonEnabled)
                        this.filterPanelToggleService.toggleVisibility();
                };
                Object.defineProperty(AvcActiveFiltersCtrl.prototype, "logoPath", {
                    get: function () {
                        return this.config.mediaServerUrl + ("/" + this.logo);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcActiveFiltersCtrl.prototype, "areFiltersSynced", {
                    get: function () {
                        return this.chartFiltersMgr.areFiltersSynced;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcActiveFiltersCtrl.prototype, "isButtonEnabled", {
                    get: function () {
                        return this.areFiltersSynced && !this.filterPanelToggleService.isVisible;
                    },
                    enumerable: false,
                    configurable: true
                });
                return AvcActiveFiltersCtrl;
            }(ComponentController));
            RegistryFlow.AvcActiveFiltersCtrl = AvcActiveFiltersCtrl;
            Pulse.app.component(AvcActiveFilters.registeredAs, new AvcActiveFilters());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcHeaderPanel = (function (_super) {
                __extends(AvcHeaderPanel, _super);
                function AvcHeaderPanel() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        disableChangeLocation: '&?',
                        location: '<',
                        showFiltersPanel: '<',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/idp-avc-header-panel.html';
                        }
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        function ($scope, $element) { return new AvcHeaderPanelCtrl($scope, $element); }
                    ];
                    return _this;
                }
                AvcHeaderPanel.registeredAs = 'idpAvcHeaderPanel';
                return AvcHeaderPanel;
            }(ComponentOptions));
            RegistryFlow.AvcHeaderPanel = AvcHeaderPanel;
            var AvcHeaderPanelCtrl = (function (_super) {
                __extends(AvcHeaderPanelCtrl, _super);
                function AvcHeaderPanelCtrl($scope, $element) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.disableChangeLocation = function () { return false; };
                    return _this;
                }
                AvcHeaderPanelCtrl.controllerId = 'AvcHeaderPanelCtrl';
                return AvcHeaderPanelCtrl;
            }(ComponentController));
            RegistryFlow.AvcHeaderPanelCtrl = AvcHeaderPanelCtrl;
            Pulse.app.component(AvcHeaderPanel.registeredAs, new AvcHeaderPanel());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var WalkthroughSkipToStepDir = (function (_super) {
                __extends(WalkthroughSkipToStepDir, _super);
                function WalkthroughSkipToStepDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/walkthrough-filter/idp-walkthrough-skip-to-step.html";
                    _this.scope = {
                        buttonText: '<',
                        buttonAction: '&'
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        WalkthroughSkipToStepDir.WalkthroughSkipToStepDirCtrl
                    ];
                    return _this;
                }
                WalkthroughSkipToStepDir.directiveId = 'idpWalkthroughSkipToStep';
                return WalkthroughSkipToStepDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.WalkthroughSkipToStepDir = WalkthroughSkipToStepDir;
            (function (WalkthroughSkipToStepDir) {
                var WalkthroughSkipToStepDirCtrl = (function (_super) {
                    __extends(WalkthroughSkipToStepDirCtrl, _super);
                    function WalkthroughSkipToStepDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, WalkthroughSkipToStepDirCtrl.controllerId) || this;
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.activateController();
                        return _this;
                    }
                    WalkthroughSkipToStepDirCtrl.controllerId = "WalkthroughSkipToStepDirCtrl";
                    return WalkthroughSkipToStepDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                WalkthroughSkipToStepDir.WalkthroughSkipToStepDirCtrl = WalkthroughSkipToStepDirCtrl;
            })(WalkthroughSkipToStepDir = PulsePublic.WalkthroughSkipToStepDir || (PulsePublic.WalkthroughSkipToStepDir = {}));
            Pulse.app.directive(WalkthroughSkipToStepDir.directiveId, [
                "common",
                function (c) { return new WalkthroughSkipToStepDir(c); }
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var WalkthroughFormSubmitButtonDir = (function (_super) {
                __extends(WalkthroughFormSubmitButtonDir, _super);
                function WalkthroughFormSubmitButtonDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/walkthrough-filter/idp-walkthrough-form-submit-button.html";
                    _this.scope = {
                        message: '<',
                        buttonText: '<'
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        WalkthroughFormSubmitButtonDir.WalkthroughFormSubmitButtonDirCtrl
                    ];
                    return _this;
                }
                WalkthroughFormSubmitButtonDir.directiveId = 'idpWalkthroughFormSubmitButton';
                return WalkthroughFormSubmitButtonDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.WalkthroughFormSubmitButtonDir = WalkthroughFormSubmitButtonDir;
            (function (WalkthroughFormSubmitButtonDir) {
                var WalkthroughFormSubmitButtonDirCtrl = (function (_super) {
                    __extends(WalkthroughFormSubmitButtonDirCtrl, _super);
                    function WalkthroughFormSubmitButtonDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, WalkthroughFormSubmitButtonDirCtrl.controllerId) || this;
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.activateController();
                        return _this;
                    }
                    WalkthroughFormSubmitButtonDirCtrl.prototype.hasMessage = function () {
                        return this.message.length > 0;
                    };
                    WalkthroughFormSubmitButtonDirCtrl.controllerId = "WalkthroughFormSubmitButtonDirCtrl";
                    return WalkthroughFormSubmitButtonDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                WalkthroughFormSubmitButtonDir.WalkthroughFormSubmitButtonDirCtrl = WalkthroughFormSubmitButtonDirCtrl;
            })(WalkthroughFormSubmitButtonDir = PulsePublic.WalkthroughFormSubmitButtonDir || (PulsePublic.WalkthroughFormSubmitButtonDir = {}));
            Pulse.app.directive(WalkthroughFormSubmitButtonDir.directiveId, [
                "common",
                function (c) { return new WalkthroughFormSubmitButtonDir(c); }
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var FilterPanelToggleService = (function () {
                function FilterPanelToggleService() {
                }
                Object.defineProperty(FilterPanelToggleService.prototype, "isVisible", {
                    get: function () {
                        return this._isVisible;
                    },
                    enumerable: false,
                    configurable: true
                });
                FilterPanelToggleService.prototype.resetVisibilityToDefault = function () {
                    this.hidePanel();
                };
                FilterPanelToggleService.prototype.toggleVisibility = function () {
                    if (this._isVisible)
                        this.hidePanel();
                    else
                        this.showPanel();
                };
                FilterPanelToggleService.prototype.showPanel = function () {
                    this._isVisible = true;
                    this.managedElements = this.spaContainerSiblings.addClass('hidden-mobile');
                };
                FilterPanelToggleService.prototype.hidePanel = function () {
                    this._isVisible = false;
                    if (this.managedElements && this.managedElements.length) {
                        this.managedElements.removeClass('hidden-mobile');
                        this.managedElements = undefined;
                    }
                };
                Object.defineProperty(FilterPanelToggleService.prototype, "spaContainerSiblings", {
                    get: function () {
                        return angular.element(FilterPanelToggleService.bodyNonScriptChildrenSelector);
                    },
                    enumerable: false,
                    configurable: true
                });
                FilterPanelToggleService.registeredAs = 'FilterPanelToggleService';
                FilterPanelToggleService.bodyNonScriptChildrenSelector = 'body > *:not(script):not(noscript):not(.main):not(.pulseapp):not(hidden-mobile)';
                return FilterPanelToggleService;
            }());
            Pulse.app.factory(FilterPanelToggleService.registeredAs, function () { return new FilterPanelToggleService(); });
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var DrawerToggleService = (function () {
                function DrawerToggleService($timeout, common, avcMgr) {
                    this.$timeout = $timeout;
                    this.common = common;
                    this.avcMgr = avcMgr;
                    this._productCurrencyTypeID = undefined;
                }
                Object.defineProperty(DrawerToggleService.prototype, "division", {
                    get: function () {
                        return this._division;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DrawerToggleService.prototype, "course", {
                    get: function () {
                        return this._course;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DrawerToggleService.prototype, "session", {
                    get: function () {
                        return this._session;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DrawerToggleService.prototype, "waitlistSession", {
                    set: function (sess) {
                        this._session = sess;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DrawerToggleService.prototype, "sessionPaymentOptionList", {
                    get: function () {
                        return this._sessionPaymentOptionList;
                    },
                    set: function (list) {
                        this._sessionPaymentOptionList = list;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DrawerToggleService.prototype, "sessionPaymentOption", {
                    get: function () {
                        var _this = this;
                        if (this.sessionPaymentOptionList != undefined && this.sessionPaymentOptionList.length > 0) {
                            var paymentOptions = this.sessionPaymentOptionList.filter(function (spo) { return spo.sessID == _this.session.sessID; });
                            if (paymentOptions.length > 0)
                                return paymentOptions[0].sessionPaymentOption;
                        }
                        else {
                            console.error("Session Payment Option List is undefined or blank.");
                        }
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                DrawerToggleService.prototype.close = function () {
                    this._division = undefined;
                    this._course = undefined;
                    this._session = undefined;
                    this._locationSessionInfo = undefined;
                    this._products = undefined;
                    this._crossSellProds = undefined;
                    this._productCurrencyTypeID = undefined;
                };
                DrawerToggleService.prototype.toggleDrawer = function (division, course, session) {
                    var _this = this;
                    var closeCurrent = this.isSelected(division, course, session);
                    return this.$timeout(function () {
                        if (!closeCurrent) {
                            _this.close();
                            var promises = new Array();
                            promises.push(_this.avcMgr.getCampProducts(division, course, session)
                                .then(function (products) {
                                _this._products = products;
                                _this._division = division;
                                _this._course = course;
                                _this._session = session;
                                if (course.catalogTypeID == Enums.SalesCatalogType.CourseBundle) {
                                    var mainProd = void 0;
                                    mainProd = _this._products.mainProduct;
                                    mainProd.divisionID = division.divID;
                                    mainProd.productID = course.prodID;
                                    mainProd.activityDesc = course.activityDesc;
                                    mainProd.name = course.name;
                                    mainProd.price = course.locationPrice;
                                    mainProd.locationPrice = mainProd.price;
                                    mainProd.currencyTypeID = mainProd.currencyTypeID;
                                    mainProd.maximumAge = course.maxAge;
                                    mainProd.minimumAge = course.minAge;
                                    mainProd.description = course.description;
                                    mainProd.catalogTypeID = course.catalogTypeID;
                                    mainProd.headline = course.headline;
                                    mainProd.scheduleDescriptor = course.schedule;
                                    mainProd.quantity = 1;
                                    mainProd.options = [];
                                    mainProd.statusOptions = {
                                        displayName: 'Open',
                                        hasUserInteraction: true,
                                        htmlClass: 'primary',
                                        isWaitlist: false
                                    };
                                    _this._products.mainProduct = mainProd;
                                }
                            }));
                            promises.push(_this.retrieveCrossSellProducts(division.divID));
                            return _this.common.$q.all(promises);
                        }
                        else {
                            var defered = _this.common.$q.defer();
                            defered.resolve({});
                            return defered.promise;
                        }
                    });
                };
                DrawerToggleService.prototype.retrieveCrossSellProducts = function (divisionID) {
                    var _this = this;
                    return this.avcMgr.getCrossSellProducts(divisionID)
                        .then(function (prods) {
                        _this._crossSellProds = prods;
                    });
                };
                Object.defineProperty(DrawerToggleService.prototype, "drawerProducts", {
                    get: function () {
                        return this._products;
                    },
                    enumerable: false,
                    configurable: true
                });
                DrawerToggleService.prototype.setDrawerProducts = function (p) {
                    this._products = p;
                };
                DrawerToggleService.prototype.setProductCurrencyType = function (currencyTypeID) {
                    this._productCurrencyTypeID = currencyTypeID;
                    return this;
                };
                Object.defineProperty(DrawerToggleService.prototype, "crossSellProds", {
                    get: function () {
                        return this._crossSellProds;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DrawerToggleService.prototype, "productCurrencyTypeID", {
                    get: function () {
                        return this._productCurrencyTypeID;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DrawerToggleService.prototype, "isOpened", {
                    get: function () {
                        return !!(this._division && this._course && this._session);
                    },
                    enumerable: false,
                    configurable: true
                });
                DrawerToggleService.prototype.isSelected = function (division, course, session) {
                    return this.isOpened
                        && this.isDivisionSelected(division)
                        && this.isCourseSelected(course)
                        && this.isSessionSelected(session);
                };
                Object.defineProperty(DrawerToggleService.prototype, "locationSessionInfo", {
                    get: function () {
                        var _this = this;
                        if (!this._locationSessionInfo && this.division && this.drawerProducts)
                            this._locationSessionInfo = this.division.sessions
                                .filter(function (locSess) {
                                return locSess.lSID === _this.drawerProducts.mainProduct.locSessID;
                            }).shift();
                        return this._locationSessionInfo;
                    },
                    enumerable: false,
                    configurable: true
                });
                DrawerToggleService.prototype.isSessionSelected = function (session) {
                    return session && session.sessID === this._session.sessID;
                };
                DrawerToggleService.prototype.isCourseSelected = function (course) {
                    return course && course.prodID === this._course.prodID;
                };
                DrawerToggleService.prototype.isDivisionSelected = function (division) {
                    return division && division.divID === this._division.divID && division.termID === this._division.termID;
                };
                DrawerToggleService.registeredAs = 'DrawerToggleService';
                return DrawerToggleService;
            }());
            RegistryFlow.DrawerToggleService = DrawerToggleService;
            Pulse.app.service(DrawerToggleService.registeredAs, ['$timeout', 'common', 'AvailChartMgr', DrawerToggleService]);
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ParallelListSelection = Pulse.PulsePublic.RegistryFlow.Abstracts.ParallelListSelection;
            var AvcTermDivisionExpander = (function (_super) {
                __extends(AvcTermDivisionExpander, _super);
                function AvcTermDivisionExpander() {
                    return _super.call(this) || this;
                }
                AvcTermDivisionExpander.prototype.compareValues = function (target, elementIdentifier) {
                    return elementIdentifier.match(target);
                };
                AvcTermDivisionExpander.prototype.createElementIdentifier = function (target) {
                    return new TermDivisionId(target);
                };
                return AvcTermDivisionExpander;
            }(ParallelListSelection));
            RegistryFlow.AvcTermDivisionExpander = AvcTermDivisionExpander;
            var TermDivisionId = (function () {
                function TermDivisionId(termDiv) {
                    this.divisionId = termDiv.divID;
                    this.termId = termDiv.termID;
                }
                TermDivisionId.prototype.match = function (termDiv) {
                    return termDiv.divID === this.divisionId && termDiv.termID === this.termId;
                };
                return TermDivisionId;
            }());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ParallelListSelection = Pulse.PulsePublic.RegistryFlow.Abstracts.ParallelListSelection;
            var AvcCourseExpander = (function (_super) {
                __extends(AvcCourseExpander, _super);
                function AvcCourseExpander() {
                    return _super.call(this) || this;
                }
                AvcCourseExpander.prototype.compareValues = function (target, elementIdentifier) {
                    return target.prodID === elementIdentifier;
                };
                AvcCourseExpander.prototype.createElementIdentifier = function (target) {
                    return target.prodID;
                };
                return AvcCourseExpander;
            }(ParallelListSelection));
            RegistryFlow.AvcCourseExpander = AvcCourseExpander;
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var AvcExpandersService = (function () {
                function AvcExpandersService() {
                    this._courseMobileExpanderStatus = new RegistryFlow.AvcCourseExpander();
                    this._termDivisionExpanderStatus = new RegistryFlow.AvcTermDivisionExpander();
                }
                Object.defineProperty(AvcExpandersService.prototype, "courseMobileStatus", {
                    get: function () {
                        return this._courseMobileExpanderStatus;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcExpandersService.prototype.resetAll = function () {
                    this.courseMobileStatus.resetSelection();
                    this.termDivisionStatus.resetSelection();
                };
                Object.defineProperty(AvcExpandersService.prototype, "termDivisionStatus", {
                    get: function () {
                        return this._termDivisionExpanderStatus;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcExpandersService.registeredAs = 'AvcExpandersService';
                return AvcExpandersService;
            }());
            Pulse.app.service(AvcExpandersService.registeredAs, AvcExpandersService);
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var WaitlistFormService = (function () {
                function WaitlistFormService(common, $q, pulseContextService) {
                    var _this = this;
                    this.common = common;
                    this.$q = $q;
                    this.pulseContext = pulseContextService;
                    this.initRegFlowData();
                    this.common.$rootScope.$on(Events.LoggedOutRefresh, function (e, clearAllState) {
                        _this.initRegFlowData();
                    });
                }
                WaitlistFormService.prototype.initRegFlowData = function () {
                    this.userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                };
                WaitlistFormService.prototype.submitForm = function (form, formModel, product) {
                    var _this = this;
                    var submitPromise;
                    form.$setSubmitted();
                    if (form.$valid)
                        submitPromise = this.common
                            .$timeout(function () { _this.common.toggleSpinner(true); }, 0)
                            .then(function () { return _this.getSubmitPromise(formModel, product); });
                    else
                        submitPromise = this.$q.reject();
                    return submitPromise;
                };
                WaitlistFormService.prototype.getSubmitPromise = function (formModel, product) {
                    var _this = this;
                    return this.userBrowsingMgr
                        .addToWaitlist(this.userBrowsingMgr.currentUBSession, this.getWaitlistRecord(formModel, product))
                        .catch(function (err) {
                        _this.common.logAllErrorTypes(err, WaitlistFormService.registerAs);
                    })
                        .finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                };
                WaitlistFormService.prototype.getWaitlistRecord = function (fromModel, product) {
                    return {
                        email: fromModel.emailAddress,
                        spdID: product.sessionProductDetailID,
                    };
                };
                WaitlistFormService.registerAs = 'WaitlistFormService';
                return WaitlistFormService;
            }());
            RegistryFlow.WaitlistFormService = WaitlistFormService;
            Pulse.app.service(WaitlistFormService.registerAs, ['common', '$q', 'pulseContextService', WaitlistFormService]);
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var Managers = Pulse.Common.DataAccess.Managers;
            var ShoppingCartMgr = Managers.ShoppingCartMgr;
            var AgeMgr = Managers.AgeMgr;
            var RegisterFormService = (function () {
                function RegisterFormService(common, breeze, pcService) {
                    this.BEGINNER_SKILL_ID = 51;
                    this.common = common;
                    this.$q = this.common.$q;
                    this.pulseContext = pcService;
                    this.breezeService = breeze;
                    this.csImpersonatingMinDate = moment().subtract(5, "year").toDate();
                    this.csImpersonatingMaxDate = moment().subtract(20, "year").toDate();
                }
                Object.defineProperty(RegisterFormService.prototype, "ubMgr", {
                    get: function () { return this.pulseContext.regFlowMgr.userBrowsingMgr; },
                    enumerable: false,
                    configurable: true
                });
                ;
                RegisterFormService.prototype.submitForm = function (product, formModel, mainProduct, isAutoRenew, bundledProds) {
                    var _this = this;
                    if (isAutoRenew === void 0) { isAutoRenew = false; }
                    if (bundledProds === void 0) { bundledProds = null; }
                    this.common.toggleSpinner(true, null, null, 0);
                    var skillID = formModel.groupWithBeginners ? this.BEGINNER_SKILL_ID : null;
                    return this.$q.resolve(this.addToCart(product, formModel, mainProduct, skillID, isAutoRenew, bundledProds))
                        .finally(function () {
                        _this.pulseContext.regFlowMgr.shoppingCartMgr.clearCachedCart();
                        _this.common.toggleSpinner(false);
                    });
                };
                RegisterFormService.prototype.isChangeOrderCart = function () {
                    return ShoppingCartMgr.IsChangeOrderCartTypeID(this.pulseContext.shoppingCartType);
                };
                RegisterFormService.prototype.getMinDateOfBirth = function (product) {
                    return RegisterFormService.GetMinDateOfBirth(product);
                };
                RegisterFormService.GetMinDateOfBirth = function (product) {
                    var date = moment(product.minDateForAgeCheck)
                        .subtract(product.minimumAge, 'year')
                        .endOf('day');
                    if (product.catalogTypeID == Enums.SalesCatalogType.OPLGeneric || product.catalogTypeID == Enums.SalesCatalogType.OPLThemed) {
                        date = date.endOf('year');
                    }
                    return date === null || date === void 0 ? void 0 : date.toDate();
                };
                RegisterFormService.prototype.getMaxDateOfBirth = function (product) {
                    return RegisterFormService.GetMaxDateOfBirth(product);
                };
                RegisterFormService.GetMaxDateOfBirth = function (product) {
                    return moment(product.maxDateForAgeCheck)
                        .subtract(product.maximumAge + 1, 'year')
                        .add(1, 'day')
                        .startOf('day')
                        .toDate();
                };
                RegisterFormService.prototype.getMinDisplayDateForDOB = function (product) {
                    return this.pulseContext.isImpersonating ? this.csImpersonatingMinDate : this.getMinDateOfBirth(product);
                };
                RegisterFormService.prototype.getMaxDisplayDateForDOB = function (product) {
                    return this.pulseContext.isImpersonating ? this.csImpersonatingMaxDate : this.getMaxDateOfBirth(product);
                };
                RegisterFormService.prototype.getProductAdminOverrideReqs = function (participant, products) {
                    var _this = this;
                    var overrideReqs = new Array();
                    products.forEach(function (product) {
                        var validAge = moment(participant.dateOfBirth).isSameOrAfter(_this.getMaxDateOfBirth(product))
                            && moment(participant.dateOfBirth).isSameOrBefore(_this.getMinDateOfBirth(product));
                        if (!validAge) {
                            var ageOverride = {
                                child_UB_ID: participant.userBrowsingID,
                                locationID: product.locationID,
                                productID: product.productID,
                                sessionID: product.sessionID,
                                sessionProductDetailID: product.sessionProductDetailID,
                                scheduleDefID: product.scheduleDefID
                            };
                            var overrideExists = _this.ubMgr.hasAdminOverride(_this.ubMgr.currentUBSession, ageOverride);
                            if (!overrideExists) {
                                var overrideReq = __assign(__assign({}, ageOverride), { productName: product.name + " (" + product.headline + ")", minAge: product.minimumAge, maxAge: product.maximumAge, overrideType: Pulse.Directives.PulsePublic.RegFlowAdminOverridePopup.OverrideUIType.AgeOverride, DOB: participant.dateOfBirth });
                                var existingMatches = Pulse.Utils.JS.findByProperties(overrideReqs, overrideReq);
                                if (!existingMatches || existingMatches.length === 0) {
                                    overrideReqs = overrideReqs.concat(overrideReq);
                                }
                            }
                        }
                    });
                    return overrideReqs;
                };
                RegisterFormService.prototype.getOptionAdminOverrideReqs = function (participant, selectedProduct, options) {
                    var _this = this;
                    var overrideReqs = new Array();
                    options.forEach(function (option) {
                        if (option.minAge <= 0 && option.maxAge <= 0)
                            return;
                        var validAge = AgeMgr.isDOB_WithinAgeRangeByDateInterval(participant.dateOfBirth, option.minAge, option.maxAge, option.minDateForAgeCheck ? option.minDateForAgeCheck : selectedProduct.minDateForAgeCheck, option.maxDateForAgeCheck ? option.maxDateForAgeCheck : selectedProduct.maxDateForAgeCheck);
                        if (!validAge && _this.pulseContext.isImpersonating) {
                            var ageOverride = {
                                child_UB_ID: participant.userBrowsingID,
                                locationID: selectedProduct.locationID,
                                productID: option.prodID,
                                sessionID: selectedProduct.sessionID,
                                sessionProductDetailID: option.spdID,
                                scheduleDefID: selectedProduct.scheduleDefID
                            };
                            var overrideExists = _this.ubMgr.hasAdminOverride(_this.ubMgr.currentUBSession, ageOverride);
                            if (!overrideExists) {
                                var overrideReq = __assign(__assign({}, ageOverride), { productName: option.name, minAge: option.minAge, maxAge: option.maxAge, overrideType: Pulse.Directives.PulsePublic.RegFlowAdminOverridePopup.OverrideUIType.AgeOverride, DOB: participant.dateOfBirth });
                                overrideReqs = overrideReqs.concat(overrideReq);
                            }
                        }
                    });
                    return overrideReqs;
                };
                RegisterFormService.prototype.updateParticipantDataAndProductSelection = function (participant, selectedProduct, mainProduct, options, skillID, isAutoRenew, bundledProds, crossSellProds) {
                    var _this = this;
                    if (isAutoRenew === void 0) { isAutoRenew = false; }
                    if (bundledProds === void 0) { bundledProds = null; }
                    var info = this.ubMgr.copyIUserBrowsingToIUpdateUserDataInfo(this.ubMgr.currentUBSession, participant, true);
                    return this.ubMgr.addOrUpdateUserData(this.ubMgr.currentUBSession, info)
                        .then(function (newBrowsingUser) {
                        angular.copy(newBrowsingUser, participant);
                        return _this.ubMgr.selectItem(_this.composeSelectedItemInfo(mainProduct));
                    })
                        .then(function (ubItemDTO) {
                        _this.updateAdminOverrides(participant, selectedProduct, mainProduct, options);
                        return _this.ubMgr.linkBeneficiaryToItem(_this.composeLinkedBeneficiaryInfo(participant, ubItemDTO, null, skillID, isAutoRenew))
                            .then(function () {
                            var parentUserBrowsingItemID = ubItemDTO.userBrowsingItemID;
                            if (selectedProduct.productID !== mainProduct.productID) {
                                return _this.ubMgr.selectItem(_this.composeSelectedItemInfo(selectedProduct, parentUserBrowsingItemID))
                                    .then(function (optionProdItemDTO) {
                                    _this.ubMgr.currentUBSession.UB_ItemDTOs.push(optionProdItemDTO);
                                    return _this.ubMgr.linkBeneficiaryToItem(_this.composeLinkedBeneficiaryInfo(participant, optionProdItemDTO, parentUserBrowsingItemID));
                                });
                            }
                            var promises = [];
                            if (bundledProds && bundledProds.length) {
                                var promises_1 = [];
                                for (var _i = 0, bundledProds_1 = bundledProds; _i < bundledProds_1.length; _i++) {
                                    var bundledProd = bundledProds_1[_i];
                                    promises_1.push(_this.ubMgr.selectItem(_this.composeSelectedItemInfo(bundledProd, parentUserBrowsingItemID))
                                        .then(function (optionProdItemDTO) {
                                        _this.ubMgr.currentUBSession.UB_ItemDTOs.push(optionProdItemDTO);
                                        return _this.ubMgr.linkBeneficiaryToItem(_this.composeLinkedBeneficiaryInfo(participant, optionProdItemDTO, parentUserBrowsingItemID));
                                    }));
                                }
                            }
                            if (options && options.length) {
                                promises.push(_this.addOptionsToCart(ubItemDTO, participant, options));
                            }
                            return _this.$q.all(promises);
                        });
                    })
                        .then(function () {
                        if (crossSellProds && crossSellProds.length) {
                            return _this.addCrossSellProdsToCart(participant, crossSellProds);
                        }
                    });
                };
                RegisterFormService.prototype.addToCart = function (selectedProduct, formModel, mainProduct, skillID, isAutoRenew, bundledProds) {
                    var _this = this;
                    if (skillID === void 0) { skillID = null; }
                    if (isAutoRenew === void 0) { isAutoRenew = false; }
                    if (bundledProds === void 0) { bundledProds = null; }
                    var participant = angular.copy(formModel.participant);
                    var options = angular.copy(formModel.options);
                    var backupFormModel = angular.copy(formModel);
                    return this.ubMgr.loadInfo(this.ubMgr.currentUBSession, true)
                        .then(function () {
                        participant = _this.linkParticipantToBrowsingUser(participant);
                        angular.merge(formModel, backupFormModel);
                        return _this.updateParticipantDataAndProductSelection(participant, selectedProduct, mainProduct, options, skillID, isAutoRenew, bundledProds, formModel.selectedCrossSellProds);
                    })
                        .then(function () {
                        return _this.ubMgr.loadInfo(_this.ubMgr.currentUBSession, false);
                    })
                        .then(function () {
                        return _this.ubMgr.sendCartToMailChimp(_this.ubMgr.currentUBSession);
                    })
                        .catch(function (err) {
                        _this.common.logAllErrorTypes(err, RegisterFormService.registeredAs);
                        _this.breezeService.getEntityManager()
                            .rejectChanges();
                    });
                };
                RegisterFormService.prototype.updateAdminOverrides = function (participant, product, mainProduct, options) {
                    var _this = this;
                    var updateOverrideObj;
                    options.forEach(function (option) {
                        updateOverrideObj = {
                            child_UB_ID: participant.userBrowsingID,
                            locationID: product.locationID,
                            productID: option.prodID,
                            scheduleDefID: product.scheduleDefID,
                            sessionID: product.sessionID,
                            sessionProductDetailID: option.spdID,
                        };
                        _this.ubMgr.updateAdminOverride(_this.ubMgr.currentUBSession, updateOverrideObj, false);
                    });
                    if (product.spdID !== mainProduct.spdID) {
                        updateOverrideObj = this.getOverrideObjUpdate(participant, mainProduct);
                        this.ubMgr.updateAdminOverride(this.ubMgr.currentUBSession, updateOverrideObj, false);
                    }
                    updateOverrideObj = this.getOverrideObjUpdate(participant, product);
                    this.ubMgr.updateAdminOverride(this.ubMgr.currentUBSession, updateOverrideObj);
                };
                RegisterFormService.prototype.getOverrideObjUpdate = function (participant, product) {
                    return {
                        child_UB_ID: participant.userBrowsingID,
                        locationID: product.locationID,
                        productID: product.productID,
                        scheduleDefID: product.scheduleDefID,
                        sessionID: product.sessionID,
                        sessionProductDetailID: product.sessionProductDetailID,
                    };
                };
                RegisterFormService.prototype.composeLinkedBeneficiaryInfo = function (participant, data, parentUserBrowsingItemID, skillID, isAutoRenew) {
                    if (isAutoRenew === void 0) { isAutoRenew = false; }
                    var linkBeneficiaryInfo = {
                        action: true,
                        beneficiaryUserBrowsingID: participant.userBrowsingID,
                        browseIdentifier: this.pulseContext.browseIdentifier,
                        customerUserBrowsingID: this.ubMgr.currentUBSession.userBrowsingDTO.userBrowsingID,
                        userBrowsingItemID: data.userBrowsingItemID,
                        autoRenew: isAutoRenew,
                        skillID: skillID
                    };
                    if (parentUserBrowsingItemID)
                        linkBeneficiaryInfo.parentUserBrowsingItemID = parentUserBrowsingItemID;
                    return linkBeneficiaryInfo;
                };
                RegisterFormService.prototype.composeSelectedItemInfo = function (campProduct, parentUserBrowsingItemID) {
                    var itemInfo = {
                        action: true,
                        browseIdentifier: this.pulseContext.browseIdentifier,
                        catalogTypeID: campProduct.catalogTypeID,
                        locationID: campProduct.locationID,
                        parentUserBrowsingItemID: parentUserBrowsingItemID,
                        productID: campProduct.productID,
                        scheduleDefID: campProduct.scheduleDefID,
                        sessionID: campProduct.sessionID,
                        sessionProductDetailID: campProduct.sessionProductDetailID,
                        userBrowsingID: this.ubMgr.currentUBSession.userBrowsingDTO.userBrowsingID
                    };
                    if (parentUserBrowsingItemID)
                        itemInfo.parentUserBrowsingItemID = parentUserBrowsingItemID;
                    return itemInfo;
                };
                RegisterFormService.prototype.composeSelectedItemInfoFromOption = function (campProductOption, ubParentItemDTO) {
                    var itemInfo = {
                        action: true,
                        browseIdentifier: this.pulseContext.browseIdentifier,
                        catalogTypeID: ubParentItemDTO.catalogTypeID,
                        locationID: ubParentItemDTO.locationID,
                        parentUserBrowsingItemID: ubParentItemDTO.userBrowsingItemID,
                        productID: campProductOption.prodID,
                        sessionID: ubParentItemDTO.sessionID,
                        sessionProductDetailID: campProductOption.spdID,
                        userBrowsingID: this.ubMgr.currentUBSession.userBrowsingDTO.userBrowsingID
                    };
                    return itemInfo;
                };
                RegisterFormService.prototype.composeSelectedItemInfoFromCrossSellProd = function (prod, parentUserBrowsingItemID) {
                    var itemInfo = {
                        action: true,
                        browseIdentifier: this.pulseContext.browseIdentifier,
                        catalogTypeID: prod.catalogTypeID,
                        parentUserBrowsingItemID: parentUserBrowsingItemID,
                        productID: prod.prodID,
                        userBrowsingID: this.ubMgr.currentUBSession.userBrowsingDTO.userBrowsingID
                    };
                    if (parentUserBrowsingItemID)
                        itemInfo.parentUserBrowsingItemID = parentUserBrowsingItemID;
                    return itemInfo;
                };
                RegisterFormService.prototype.linkParticipantToBrowsingUser = function (participant) {
                    if (!participant.userBrowsingID || participant.userBrowsingID === 0) {
                        var linkParticipant = this.ubMgr.findExistingParticipant(this.ubMgr.currentUBSession, participant);
                        if (linkParticipant)
                            angular.merge(participant, linkParticipant);
                    }
                    return participant;
                };
                RegisterFormService.prototype.addOptionsToCart = function (ubParentItemDTO, participant, options) {
                    var _this = this;
                    if (options && options.length) {
                        var promises = [];
                        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                            var optionProd = options_1[_i];
                            promises.push(this.ubMgr.selectItem(this.composeSelectedItemInfoFromOption(optionProd, ubParentItemDTO))
                                .then(function (optionProdItemDTO) {
                                _this.ubMgr.currentUBSession.UB_ItemDTOs.push(optionProdItemDTO);
                                return _this.ubMgr.linkBeneficiaryToItem(_this.composeLinkedBeneficiaryInfo(participant, optionProdItemDTO, ubParentItemDTO.userBrowsingItemID));
                            }));
                        }
                        return this.$q.all(promises);
                    }
                };
                RegisterFormService.prototype.addCrossSellProdsToCart = function (participant, crossSellProds) {
                    var _this = this;
                    var promises = [];
                    for (var _i = 0, crossSellProds_1 = crossSellProds; _i < crossSellProds_1.length; _i++) {
                        var prod = crossSellProds_1[_i];
                        if (this.ubMgr.hasParticipantProdInCart(this.ubMgr.currentUBSession, participant, {
                            productID: prod.prodID,
                            catalogTypeID: prod.catalogTypeID,
                        }))
                            continue;
                        promises.push(this.ubMgr.selectItem(this.composeSelectedItemInfoFromCrossSellProd(prod))
                            .then(function (optionProdItemDTO) {
                            _this.ubMgr.currentUBSession.UB_ItemDTOs.push(optionProdItemDTO);
                            return _this.ubMgr.linkBeneficiaryToItem(_this.composeLinkedBeneficiaryInfo(participant, optionProdItemDTO));
                        }));
                    }
                    return this.$q.all(promises);
                };
                RegisterFormService.registeredAs = 'RegisterFormService';
                return RegisterFormService;
            }());
            RegistryFlow.RegisterFormService = RegisterFormService;
            Pulse.app.service(RegisterFormService.registeredAs, [
                'common',
                'breezeService',
                'pulseContextService',
                RegisterFormService,
            ]);
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var Managers = Pulse.Common.DataAccess.Managers;
            var AVCSelectProdDir = (function (_super) {
                __extends(AVCSelectProdDir, _super);
                function AVCSelectProdDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot
                        + Paths.PulsePublicDirective
                        + 'reg-flow/avail-chart/idp-avc-select-prod.html';
                    _this.scope = {
                        course: '<',
                        division: '<',
                        formName: '@?',
                        formSuffix: '@?',
                        isAlreadyInCart: '=',
                        location: '<',
                        maxDate: '=',
                        minDate: '=',
                        prodInfos: '=',
                        urls: '<',
                    };
                    _this.controller = ['$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        AVCSelectProdDir.AVCSelectProdDirCtrl];
                    return _this;
                }
                AVCSelectProdDir.directiveId = 'idpAvcSelectProd';
                return AVCSelectProdDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCSelectProdDir = AVCSelectProdDir;
            (function (AVCSelectProdDir) {
                var ProductSubCategoryType = Pulse.Common.Enums.ProductSubCategoryType;
                var ProductCategoryType = Pulse.Common.Enums.ProductCategoryType;
                var AVCSelectProdDirCtrl = (function (_super) {
                    __extends(AVCSelectProdDirCtrl, _super);
                    function AVCSelectProdDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCSelectProdDirCtrl.controllerId) || this;
                        _this.selectedProdInfos = [];
                        _this.selectedProdIndexes = {};
                        _this.sessionAvailabilityStatusTypes = [];
                        _this.selectedOptions = [];
                        _this.participantsWithThisProduct = [];
                        _this.waitlist = { 'spdID': null, 'date': null };
                        _this.isJoinWaitlist = false;
                        _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.activateController();
                        return _this;
                    }
                    AVCSelectProdDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        this.parentCtrl = (scope.$parent).vm;
                        if (this.parentCtrl.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                            if (this.prodInfos && this.prodInfos.length > 0) {
                                this.campMainProd = this.prodInfos[0];
                            }
                            if (this.prodInfos && this.prodInfos.length > 1) {
                                this.campOptionProd = this.prodInfos[1];
                            }
                        }
                        this.myForm = this.$scope[this.formName];
                        $(document).on('click', '.display_popover', function () {
                            var mobileWidthDevices = 768;
                            if (window.innerWidth > mobileWidthDevices) {
                                return;
                            }
                            var intervalPopover;
                            intervalPopover = setInterval(function () {
                                if ($('.popover').length) {
                                    $('.popover').width('100%');
                                    $('.popover').css('left', 0);
                                    clearInterval(intervalPopover);
                                }
                            }, 50);
                        });
                    };
                    AVCSelectProdDirCtrl.prototype.$onInit = function () {
                        this.isAddStudentMode = false;
                        this.addParticipant();
                        this.ageMgr = new Managers.AgeMgr(this.common, this.breezeService, this.pulseContext);
                        this.availChartMgr = this.pulseContext.regFlowMgr.availChartMgr;
                        this.addedToWaitlist = false;
                        if (this.prodInfos.length == 1) {
                            this.selectProduct(this.prodInfos[0]);
                        }
                        else {
                            for (var i = 0; i < this.prodInfos.length; i++) {
                                var prodInfo = this.prodInfos[i];
                                if (!prodInfo.isONPackage) {
                                    this.maxAge = this.prodInfos[i].maximumAge;
                                }
                            }
                        }
                        if (this.selectedProdInfos.length) {
                            this.isJoinWaitlist = this.availChartMgr.isJoinWaitlist(this.selectedProdInfos[0]);
                        }
                    };
                    AVCSelectProdDirCtrl.prototype.recountAgeRequirements = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        this.minDate = null;
                        this.maxDate = null;
                        var promises = new Array();
                        var minAge = this.selectedProdInfos[0].minimumAge;
                        if (this.selectedProdInfos[0].isONPackage && this.prodInfos[0].minimumAge > this.selectedProdInfos[0].minimumAge) {
                            minAge = this.prodInfos[0].minimumAge;
                        }
                        var maxAge = this.prodInfos[0].maximumAge;
                        if (this.selectedProdInfos[0].catalogTypeID === Enums.SalesCatalogType.StandardCamp) {
                            promises.push(this.ageMgr.calculateDivCourseMinMaxAgeCheckDate(this.selectedProdInfos[0].productID, this.selectedProdInfos[0].locationID, this.selectedProdInfos[0].sessionID, -1, this.selectedProdInfos[0].catalogTypeID, true)
                                .then(function (minAgeCheckDate) {
                                var min = moment(minAgeCheckDate);
                                min.subtract(minAge, 'year');
                                _this.minDate = min.endOf('day').toDate();
                            }));
                            promises.push(this.ageMgr.calculateDivCourseMinMaxAgeCheckDate(this.prodInfos[0].productID, this.prodInfos[0].locationID, this.prodInfos[0].sessionID, -1, this.prodInfos[0].catalogTypeID, false)
                                .then(function (maxAgeCheckDate) {
                                var max = moment(maxAgeCheckDate);
                                max.subtract(maxAge + 1, 'year');
                                max.add(1, 'day');
                                _this.maxDate = max.startOf('day').toDate();
                            }));
                        }
                        return this.common.$q.all(promises);
                    };
                    AVCSelectProdDirCtrl.prototype.isAgeValid = function (date) {
                        return moment(date).isSameOrAfter(this.maxDate) && moment(date).isSameOrBefore(this.minDate);
                    };
                    AVCSelectProdDirCtrl.prototype.joinWaitlist = function () {
                        var _this = this;
                        this.waitlist.spdID = this.selectedProdInfos[0].sessionProductDetailID;
                        var isEmailValid = this.myForm.waitListContactForm.emailAddress.$valid;
                        this.myForm.$setSubmitted();
                        if (isEmailValid) {
                            this.common.toggleSpinner(true);
                            var wlRec = {
                                email: this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress,
                                spdID: this.waitlist.spdID
                            };
                            this.userBrowsingMgr.addToWaitlist(this.userBrowsingMgr.currentUBSession, wlRec)
                                .then(function (response) {
                                _this.addedToWaitlist = true;
                                _this.common.$rootScope
                                    .$broadcast(Events.AvChartAddWaitlist, _this.division.divID, _this.selectedProdInfos[0].courseProdID, _this.selectedProdInfos[0].sessionProductDetailID);
                            })
                                .catch(function (err) {
                                _this.logError(err);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                        else {
                            this.common.showWarning(Pulse.Common.Resources.StringConsts.Warn_GenericValidationError);
                        }
                    };
                    AVCSelectProdDirCtrl.prototype.manipulateOption = function (product, clickedOption) {
                        var _this = this;
                        if (this.isOptionAvailable(product, clickedOption)) {
                            var isOptionAlreadySelected_1 = false;
                            this.selectedOptions.forEach(function (option, index) {
                                if (option.price === clickedOption.price && option.name === clickedOption.name) {
                                    _this.selectedOptions.splice(index, 1);
                                    isOptionAlreadySelected_1 = true;
                                    clickedOption.isChecked = false;
                                }
                            });
                            if (!isOptionAlreadySelected_1) {
                                this.selectedOptions.push(clickedOption);
                                clickedOption.isChecked = true;
                            }
                        }
                    };
                    AVCSelectProdDirCtrl.prototype.addParticipant = function () {
                        var newUB = this.userBrowsingMgr.createNewRegFlowUserBrowsingDTO(Enums.ShoppingCartType.RegFlow);
                        this.participant = newUB;
                    };
                    AVCSelectProdDirCtrl.prototype.addAnotherStudent = function () {
                        this.isAddStudentMode = true;
                    };
                    AVCSelectProdDirCtrl.prototype.addProductToCart = function () {
                        var _this = this;
                        if (!this.myForm.$valid) {
                            this.common.showWarning(Pulse.Common.Resources.StringConsts.Warn_GenericValidationError);
                            return;
                        }
                        if (!this.pulseContext.isLoggedIn) {
                            this.userBrowsingMgr.updateCurrentUserBrowsing(this.userBrowsingMgr.currentUBSession)
                                .then(function (data) {
                                _this._addProductToCart();
                            });
                        }
                        else {
                            this._addProductToCart();
                        }
                    };
                    AVCSelectProdDirCtrl.prototype._addProductToCart = function () {
                        this.participant.selectedProdInfos = this.selectedProdInfos;
                        this.parentCtrl.addToCart(this.formSuffix, this.formName, this.participant, this.selectedOptions);
                    };
                    AVCSelectProdDirCtrl.prototype.hasSelectedOverNightOption = function (item) {
                        for (var i = 0; i < item.options.length; i++) {
                            var option = item.options[i];
                            if (option.productCategoryTypeID == Enums.ProductCategoryType.Residency
                                && (option.productSubCatTypeID == Enums.ProductSubCategoryType.Overnight
                                    || option.productSubCatTypeID == Enums.ProductSubCategoryType.OvernightAndWeekend)) {
                                if (option.hasOptionSelected)
                                    return true;
                            }
                        }
                        return false;
                    };
                    AVCSelectProdDirCtrl.prototype.selectProduct = function (prodInfo) {
                        var _this = this;
                        this.selectedProdInfos.push(prodInfo);
                        this.isJoinWaitlist = this.availChartMgr.isJoinWaitlist(this.selectedProdInfos[0]);
                        if (prodInfo.programStatusTypeID == Enums.SessionAvailabilityStatus.CallUs) {
                            var msg = "Call us to check availability. " + this.pulseContext.companyTollFreePhone;
                            this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Call Us', ' ' + msg, null);
                            this.removeCourseInline();
                            return;
                        }
                        this.recountAgeRequirements().then(function () {
                            _this.common.toggleSpinner(false);
                        });
                        var maxAge;
                        if (this.selectedProdInfos[0].isONPackage) {
                            maxAge = this.maxAge;
                        }
                        else {
                            maxAge = this.selectedProdInfos[0].maximumAge;
                        }
                        if (this.selectedProdInfos[0].options) {
                            for (var i = 0; i < this.selectedProdInfos[0].options.length; i++) {
                                var option = this.selectedProdInfos[0].options[i];
                                if (maxAge <= option.minAge) {
                                    this.selectedProdInfos[0].options.splice(i, 1);
                                }
                            }
                        }
                        if (this.selectedProdInfos[0].programTypeID === Enums.DivisionProgramType.AlexaCafe) {
                            if (this.selectedProdInfos[0].options) {
                                for (var i = 0; i < this.selectedProdInfos[0].options.length; i++) {
                                    var option = this.selectedProdInfos[0].options[i];
                                    if (option.name.toLowerCase().indexOf('continuing education units') !== -1) {
                                        option.message = 'Please Note: Continuing Education Units is only for ages 13+';
                                    }
                                }
                            }
                        }
                        if (this.selectedProdInfos[0].programTypeID === Enums.DivisionProgramType.iDTechAcademies) {
                            this.selectedProdInfos[0].sessionPerWeek = 'per session';
                        }
                        else {
                            this.selectedProdInfos[0].sessionPerWeek = 'per week';
                        }
                        if (this.pulseContext.regFlowMgr.shoppingCartMgr.currentCachedShoppingCart.participants) {
                            this.pulseContext.regFlowMgr.shoppingCartMgr.currentCachedShoppingCart.participants.forEach(function (student, index, array) {
                                var filterObject = {
                                    'locationID': _this.selectedProdInfos[0].locationID,
                                    'sessionID': _this.selectedProdInfos[0].sessionID,
                                };
                                if (prodInfo['isONPackage']) {
                                    filterObject['productID'] = _this.selectedProdInfos[0].courseProdID;
                                }
                                else {
                                    filterObject['productID'] = _this.selectedProdInfos[0].productID;
                                    filterObject['scheduleDescriptor'] = _this.selectedProdInfos[0].scheduleDescriptor;
                                }
                                var itemThatMayMatch = Pulse.Utils.JS.findByProperties(student.items, filterObject);
                                if (itemThatMayMatch.length && !prodInfo['isONPackage'] && !_this.hasSelectedOverNightOption(itemThatMayMatch[0])) {
                                    _this.participantsWithThisProduct.push(student);
                                }
                                else if (itemThatMayMatch.length && prodInfo['isONPackage'] && _this.hasSelectedOverNightOption(itemThatMayMatch[0])) {
                                    _this.participantsWithThisProduct.push(student);
                                }
                            });
                        }
                        if (this.participantsWithThisProduct.length) {
                            this.isAddStudentMode = false;
                        }
                        else {
                            this.isAddStudentMode = true;
                        }
                    };
                    AVCSelectProdDirCtrl.prototype.removeProduct = function (prodInfo) {
                        var tempIndex = this.selectedProdInfos.indexOf(prodInfo);
                        if (tempIndex >= 0) {
                            this.selectedProdInfos.splice(tempIndex, 1);
                        }
                    };
                    AVCSelectProdDirCtrl.prototype.removeCourseInline = function () {
                        var scrollToCellAfterClose = true;
                        this.$scope.$emit(Events.AvChartCloseDrawer, scrollToCellAfterClose);
                    };
                    AVCSelectProdDirCtrl.prototype.campMainProductPrice = function () {
                        if (!this.campMainProd) {
                            return '';
                        }
                        if (this.campMainProd.programTypeID == 307001) {
                            return '2-Week Program for $' + this.campMainProd.price;
                        }
                        else if (this.campMainProd.programTypeID == 307000 || this.campMainProd.programTypeID == 307003) {
                            return '$' + this.campMainProd.price + ' per week';
                        }
                        else if (this.campMainProd.programTypeID == 307002) {
                            return '$' + this.campMainProd.price;
                        }
                        else {
                            return '';
                        }
                    };
                    AVCSelectProdDirCtrl.prototype.campOptionPrice = function () {
                        if (!this.campOptionProd) {
                            return '';
                        }
                        if (this.campOptionProd.programTypeID == 307001) {
                            return '2-Week Program for $' + this.campOptionProd.price;
                        }
                        else {
                            return '$' + this.campOptionProd.price + ' per week';
                        }
                    };
                    AVCSelectProdDirCtrl.prototype.checkIsAlreadyInCart = function (participant) {
                        return this.parentCtrl.isAlreadyInCart(participant);
                    };
                    AVCSelectProdDirCtrl.prototype.isOptionAvailable = function (product, option) {
                        var isAvailable = true;
                        if (option.productCategoryTypeID === ProductCategoryType.Meal) {
                            isAvailable = this.availChartMgr.checkSessionMealOptionAvailability(this.division, product.locSessID);
                        }
                        else if (option.productCategoryTypeID === ProductCategoryType.Residency) {
                            isAvailable = this.availChartMgr.checkSessionResidencyOptionAvailability(this.division, product.locSessID);
                        }
                        return isAvailable;
                    };
                    AVCSelectProdDirCtrl.prototype.showOptionUnavailableDetailPopup = function (option) {
                        this.common.showWarning(this.getOptionUnavailableMessage(option), { toastClass: 'reg-flow', timeOut: 20000 });
                    };
                    AVCSelectProdDirCtrl.prototype.getOptionUnavailableMessage = function (option) {
                        var a = option.productSubCatTypeID === ProductSubCategoryType.Lunch ? 'lunch' : 'meals';
                        return "We apologize but the \u201C" + option.name + "\u201D add-on is no longer available for purchase this session. "
                            + ("<srtong>Students must bring a " + a + " from home.</srtong>");
                    };
                    AVCSelectProdDirCtrl.prototype.campOptionDisabled = function () {
                        if (this.isAlreadyInCart) {
                            return true;
                        }
                        return !this.isOvernightAllowedByAge();
                    };
                    AVCSelectProdDirCtrl.prototype.isOvernightAllowedByAge = function () {
                        if (!this.campOptionProd) {
                            return false;
                        }
                        var hasOverlap = this.campMainProd.minimumAge <= this.campOptionProd.maximumAge
                            && this.campMainProd.maximumAge >= this.campOptionProd.minimumAge;
                        return hasOverlap;
                    };
                    AVCSelectProdDirCtrl.prototype.getLocationPrice = function (product) {
                        return this.course.locationPrice + (product.isONPackage && this.prodInfos.length > 1
                            ? Math.abs(this.prodInfos[0].price - this.prodInfos[1].price)
                            : 0);
                    };
                    AVCSelectProdDirCtrl.controllerId = 'AVCSelectProdDirCtrl';
                    return AVCSelectProdDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCSelectProdDir.AVCSelectProdDirCtrl = AVCSelectProdDirCtrl;
            })(AVCSelectProdDir = PulsePublic.AVCSelectProdDir || (PulsePublic.AVCSelectProdDir = {}));
            Pulse.app.directive(AVCSelectProdDir.directiveId, ['common', function (c) { return new AVCSelectProdDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var Managers = Pulse.Common.DataAccess.Managers;
            var AVCSelectedInline = (function (_super) {
                __extends(AVCSelectedInline, _super);
                function AVCSelectedInline(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'reg-flow/avail-chart/idp-avc-selected-inline.html';
                    _this.scope = {
                        'initDataObj': '=',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        AVCSelectedInline.AVCSelectedInlineCtrl,
                    ];
                    return _this;
                }
                AVCSelectedInline.directiveId = 'idpAvcSelectedInline';
                return AVCSelectedInline;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCSelectedInline = AVCSelectedInline;
            (function (AVCSelectedInline) {
                var AVCSelectedInlineCtrl = (function (_super) {
                    __extends(AVCSelectedInlineCtrl, _super);
                    function AVCSelectedInlineCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCSelectedInlineCtrl.controllerId) || this;
                        _this.isLoginCollapsed = true;
                        _this.isHalfDayPurchasedList = [];
                        _this.isChangeOrder = false;
                        _this.saveDisabled = false;
                        _this.formName = 'frmAVCSelectProd';
                        _this.myForm = $scope[_this.formName];
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                        _this.ageMgr = new Managers.AgeMgr(_this.common, _this.breezeService, _this.pulseContext);
                        _this.checkUnsavedDataBeforeNav = false;
                        return _this;
                    }
                    AVCSelectedInlineCtrl.prototype.$onInit = function () {
                        this.title = this.initDataObj.location.name;
                        this.submitted = false;
                        if (this.initDataObj && this.initDataObj.prodInfos && this.initDataObj.prodInfos.length > 0) {
                            this.prodDTO = this.initDataObj.prodInfos[0];
                        }
                        this.breezeService.getEntityManager().rejectChanges();
                        this.activateController();
                    };
                    AVCSelectedInlineCtrl.prototype.removeCourseInline = function () {
                        this.$scope.$emit(Events.AvChartCloseDrawer);
                    };
                    AVCSelectedInlineCtrl.prototype.onLoginExpandClicked = function () {
                        this.isLoginCollapsed = !this.isLoginCollapsed;
                    };
                    AVCSelectedInlineCtrl.prototype.canSelectedAddonsBeBought = function (participant, selectedAddons) {
                        if (!moment.isDate(participant.dateOfBirth)) {
                            return false;
                        }
                        var startDateTime = angular.isString(this.prodDTO.startDateTime) ? (new Date((this.prodDTO.startDateTime))) : this.prodDTO.startDateTime;
                        var yearWhenCourseStarts = startDateTime.getFullYear();
                        var participantBirthYear = participant.dateOfBirth.getFullYear();
                        var participantsAgeWhenCourseStarts = yearWhenCourseStarts - participantBirthYear;
                        var addonsThatCantBeBought = selectedAddons.filter(function (addon) {
                            return addon.maxAge !== 0 && addon.minAge !== 0
                                && addon.minAge > participantsAgeWhenCourseStarts
                                && participantsAgeWhenCourseStarts <= addon.maxAge;
                        });
                        if (addonsThatCantBeBought.length) {
                            return addonsThatCantBeBought;
                        }
                        return true;
                    };
                    AVCSelectedInlineCtrl.prototype.isAlreadyInCart = function (participant) {
                        if (participant) {
                            for (var i = 0; i < this.initDataObj.prodInfos.length; i++) {
                                var checkProd = this.initDataObj.prodInfos[i];
                                if (this.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp && i > 0) {
                                    return false;
                                }
                                if (this.userBrowsingMgr.hasParticipantProdInCart(this.userBrowsingMgr.currentUBSession, participant, checkProd)) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    };
                    AVCSelectedInlineCtrl.prototype.addParticipant = function () {
                        var newUB = this.userBrowsingMgr.createNewRegFlowUserBrowsingDTO(Enums.ShoppingCartType.RegFlow);
                        this.participants.push(newUB);
                    };
                    AVCSelectedInlineCtrl.prototype.removeParticipant = function (participant) {
                        var _this = this;
                        var promises = new Array();
                        for (var i = 0; i < this.initDataObj.prodInfos.length; i++) {
                            var prodInfo = this.initDataObj.prodInfos[i];
                            var UBParts = this.userBrowsingMgr.getUBParticipantsByPacticipantAndProductInfo(this.userBrowsingMgr.currentUBSession, participant, prodInfo);
                            for (var j = 0; j < UBParts.length; j++) {
                                var UBParticipant = UBParts[j];
                                var linkInfo = {};
                                linkInfo.browseIdentifier = this.pulseContext.browseIdentifier;
                                linkInfo.userBrowsingParticipantID = UBParticipant.userBrowsingParticipantID;
                                linkInfo.customerUserBrowsingID = this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                linkInfo.beneficiaryUserBrowsingID = UBParticipant.userBrowsingID;
                                linkInfo.userBrowsingItemID = UBParticipant.userBrowsingItemID;
                                linkInfo.parentUserBrowsingItemID = UBParticipant.parentUserBrowsingItemID;
                                linkInfo.action = false;
                                promises.push(this.userBrowsingMgr.linkBeneficiaryToItem(linkInfo));
                            }
                        }
                        this.common.$q.all(promises)
                            .then(function (data) {
                            _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true);
                        })
                            .catch(function (err) {
                            _this.logError(err);
                            _this.breezeService.getEntityManager().rejectChanges();
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    AVCSelectedInlineCtrl.prototype.isAgeValid = function (participant) {
                        var valid = moment(participant.dateOfBirth).isSameOrAfter(this.maxDateOfBirth)
                            && moment(participant.dateOfBirth).isSameOrBefore(this.minDateOfBirth);
                        if (!valid && this.pulseContext.isImpersonating) {
                            var ageOverride = {
                                child_UB_ID: participant.userBrowsingID,
                                locationID: this.prodDTO.locationID,
                                productID: this.prodDTO.productID,
                                sessionID: this.prodDTO.sessionID,
                                sessionProductDetailID: this.prodDTO.sessionProductDetailID,
                                scheduleDefID: this.prodDTO.scheduleDefID,
                            };
                            valid = this.userBrowsingMgr.hasAdminOverride(this.userBrowsingMgr.currentUBSession, ageOverride);
                        }
                        return valid;
                    };
                    AVCSelectedInlineCtrl.prototype._validNameString = function (name) {
                        return !String.isNullOrWhitespace(name);
                    };
                    AVCSelectedInlineCtrl.prototype.addToCart = function (formSuffix, formName, participant, selectedOptions) {
                        var _this = this;
                        this.common.clearStatus();
                        this.common.toggleSpinner(true, true, undefined, 0);
                        this.submitted = true;
                        this.saveDisabled = true;
                        var isGenderValid = false;
                        if (participant.genderTypeID &&
                            (participant.genderTypeID == Enums.GenderType.Male ||
                                participant.genderTypeID == Enums.GenderType.Female)) {
                            isGenderValid = true;
                        }
                        var canAddonsBeBought = this.canSelectedAddonsBeBought(participant, selectedOptions);
                        var isAgeValid = this.isAgeValid(participant);
                        var isLastNameValid = this._validNameString(participant.lastName);
                        var isFirstNameValid = this._validNameString(participant.firstName);
                        if (isAgeValid && isGenderValid && isLastNameValid && isFirstNameValid && canAddonsBeBought === true) {
                            var promise_1;
                            this.common.$timeout(function () {
                                promise_1 = _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                                    .then(function () {
                                    if (!participant.userBrowsingID || participant.userBrowsingID === 0) {
                                        var existingParticipant = _this.userBrowsingMgr.findExistingParticipant(_this.userBrowsingMgr.currentUBSession, participant);
                                        if (existingParticipant) {
                                            Pulse.Utils.JS.copyAllProperties(participant, existingParticipant);
                                        }
                                    }
                                    var info = _this.userBrowsingMgr.copyIUserBrowsingToIUpdateUserDataInfo(_this.userBrowsingMgr.currentUBSession, participant, true);
                                    return _this.userBrowsingMgr.addOrUpdateUserData(_this.userBrowsingMgr.currentUBSession, info)
                                        .then(function (data) {
                                        var promises = new Array();
                                        Pulse.Utils.JS.copyOwnProperties(participant, data);
                                        if (participant.selectedProdInfos && participant.selectedProdInfos.length > 0) {
                                            var primOptUserBrowsingItemID = 0;
                                            var hasSelectedStandardCampPrimOpt_1 = false;
                                            if (_this.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                                                var primOptProd = _this.initDataObj.prodInfos.length > 1 ? _this.initDataObj.prodInfos[1] : null;
                                                if (primOptProd && Pulse.Utils.JS.findByProperties(participant.selectedProdInfos, { productID: primOptProd.productID }).length > 0) {
                                                    hasSelectedStandardCampPrimOpt_1 = true;
                                                    participant.selectedProdInfos.unshift(_this.initDataObj.prodInfos[0]);
                                                }
                                                var purchasedProds_1 = [];
                                                var selectedProdInfo_1 = participant.selectedProdInfos[0];
                                                var itemInfo = {};
                                                itemInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                itemInfo.userBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                itemInfo.productID = selectedProdInfo_1.productID;
                                                itemInfo.locationID = selectedProdInfo_1.locationID;
                                                itemInfo.sessionID = selectedProdInfo_1.sessionID;
                                                itemInfo.catalogTypeID = selectedProdInfo_1.catalogTypeID;
                                                itemInfo.sessionProductDetailID = selectedProdInfo_1.sessionProductDetailID;
                                                itemInfo.scheduleDefID = selectedProdInfo_1.scheduleDefID;
                                                itemInfo.action = true;
                                                promises.push(_this.userBrowsingMgr.selectItem(itemInfo)
                                                    .then(function (data) {
                                                    var updateOverrideObj = {
                                                        child_UB_ID: participant.userBrowsingID,
                                                        locationID: selectedProdInfo_1.locationID,
                                                        productID: selectedProdInfo_1.productID,
                                                        sessionID: selectedProdInfo_1.sessionID,
                                                        sessionProductDetailID: selectedProdInfo_1.sessionProductDetailID,
                                                        scheduleDefID: selectedProdInfo_1.scheduleDefID
                                                    };
                                                    _this.userBrowsingMgr.updateAdminOverride(_this.userBrowsingMgr.currentUBSession, updateOverrideObj);
                                                    var linkInfo = {};
                                                    linkInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                    linkInfo.customerUserBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                    linkInfo.beneficiaryUserBrowsingID = participant.userBrowsingID;
                                                    linkInfo.userBrowsingItemID = data.userBrowsingItemID;
                                                    linkInfo.action = true;
                                                    return _this.userBrowsingMgr.linkBeneficiaryToItem(linkInfo)
                                                        .then(function () {
                                                        purchasedProds_1[0] = selectedProdInfo_1;
                                                        if (hasSelectedStandardCampPrimOpt_1) {
                                                            var primOptUserBrowsingItemID_1 = data.userBrowsingItemID;
                                                            var selectedProdInfo_2 = participant.selectedProdInfos[1];
                                                            var itemInfo_1 = {};
                                                            itemInfo_1.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                            itemInfo_1.parentUserBrowsingItemID = primOptUserBrowsingItemID_1;
                                                            itemInfo_1.userBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                            itemInfo_1.productID = selectedProdInfo_2.productID;
                                                            itemInfo_1.locationID = selectedProdInfo_2.locationID;
                                                            itemInfo_1.sessionID = selectedProdInfo_2.sessionID;
                                                            itemInfo_1.catalogTypeID = selectedProdInfo_2.catalogTypeID;
                                                            itemInfo_1.sessionProductDetailID = selectedProdInfo_2.sessionProductDetailID;
                                                            itemInfo_1.scheduleDefID = selectedProdInfo_2.scheduleDefID;
                                                            itemInfo_1.action = true;
                                                            return _this.userBrowsingMgr.selectItem(itemInfo_1)
                                                                .then(function (data) {
                                                                _this.userBrowsingMgr.currentUBSession.UB_ItemDTOs.push(data);
                                                                purchasedProds_1[1] = selectedProdInfo_2;
                                                                var linkInfo = {};
                                                                linkInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                                linkInfo.customerUserBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                                linkInfo.beneficiaryUserBrowsingID = participant.userBrowsingID;
                                                                linkInfo.userBrowsingItemID = data.userBrowsingItemID;
                                                                linkInfo.parentUserBrowsingItemID = primOptUserBrowsingItemID_1;
                                                                linkInfo.action = true;
                                                                _this.common.$rootScope.$broadcast(Events.ProductAddedToCart, purchasedProds_1, participant, selectedOptions);
                                                                return _this.userBrowsingMgr.linkBeneficiaryToItem(linkInfo);
                                                            });
                                                        }
                                                        else {
                                                            _this.common.$rootScope.$broadcast(Events.ProductAddedToCart, purchasedProds_1, participant, selectedOptions);
                                                        }
                                                    });
                                                }));
                                            }
                                            else {
                                                for (var i = 0; i < participant.selectedProdInfos.length; i++) {
                                                    var selectedProdInfo = participant.selectedProdInfos[i];
                                                    var itemInfo = {};
                                                    itemInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                    itemInfo.userBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                    itemInfo.productID = selectedProdInfo.productID;
                                                    itemInfo.locationID = selectedProdInfo.locationID;
                                                    itemInfo.sessionID = selectedProdInfo.sessionID;
                                                    itemInfo.catalogTypeID = selectedProdInfo.catalogTypeID;
                                                    itemInfo.sessionProductDetailID = selectedProdInfo.sessionProductDetailID;
                                                    itemInfo.scheduleDefID = selectedProdInfo.scheduleDefID;
                                                    itemInfo.action = true;
                                                    var seletItemPromise = _this.userBrowsingMgr.selectItem(itemInfo)
                                                        .then(function (data) {
                                                        var linkInfo = {};
                                                        linkInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                        linkInfo.customerUserBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                        linkInfo.beneficiaryUserBrowsingID = participant.userBrowsingID;
                                                        linkInfo.userBrowsingItemID = data.userBrowsingItemID;
                                                        linkInfo.action = true;
                                                        return _this.userBrowsingMgr.linkBeneficiaryToItem(linkInfo);
                                                    });
                                                    promises.push(seletItemPromise);
                                                }
                                            }
                                            return _this.common.$q.all(promises);
                                        }
                                    });
                                })
                                    .then(function (data) {
                                    return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true);
                                })
                                    .then(function (data) {
                                    _this.userBrowsingMgr.sendCartToMailChimp(_this.userBrowsingMgr.currentUBSession);
                                    var scrollToCellAfterClose = true;
                                    _this.$scope.$emit(Events.AvChartCloseDrawer, scrollToCellAfterClose);
                                    return;
                                })
                                    .catch(function (err) {
                                    _this.logError(err);
                                    _this.breezeService.getEntityManager().rejectChanges();
                                })
                                    .finally(function () {
                                    _this.saveDisabled = false;
                                    _this.submitted = false;
                                    _this.common.toggleSpinner(false);
                                });
                            }, 5);
                            return promise_1;
                        }
                        else {
                            this.common.toggleSpinner(false, true);
                            var msgBuilder = new Pulse.Utils.HtmlListItemizer();
                            if (!isLastNameValid) {
                                msgBuilder.add('Please provide valid last name');
                            }
                            if (!isFirstNameValid) {
                                msgBuilder.add('Please provide valid first name');
                            }
                            if (!isGenderValid) {
                                msgBuilder.add('Please select gender');
                            }
                            if (canAddonsBeBought !== true && canAddonsBeBought.length > 0) {
                                canAddonsBeBought.forEach(function (addon) {
                                    msgBuilder.add("Addon " + addon.name + " is for students who are at least " + addon.minAge + ", and not older then " + addon.maxAge + " by the end of the calendar year.");
                                });
                            }
                            if (!isAgeValid) {
                                if (this.pulseContext.isImpersonating) {
                                    this.common.$rootScope.$broadcast(Events.ShowRegFlowAdminOverridePopup, {
                                        size: Pulse.Common.BasePopup.ModalSize.Medium,
                                        initDataObj: {
                                            overrideReqs: [{
                                                    overrideType: PulsePublic.RegFlowAdminOverridePopup.OverrideUIType.AgeOverride,
                                                    productName: this.prodDTO.name,
                                                    minAge: this.prodDTO.minimumAge,
                                                    maxAge: this.prodDTO.maximumAge,
                                                    productID: this.prodDTO.productID,
                                                    sessionID: this.prodDTO.sessionID,
                                                    locationID: this.prodDTO.locationID,
                                                    sessionProductDetailID: this.prodDTO.sessionProductDetailID,
                                                    scheduleDefID: this.prodDTO.scheduleDefID,
                                                    DOB: participant.dateOfBirth,
                                                    child_UB_ID: participant.userBrowsingID,
                                                }]
                                        }
                                    });
                                    this.saveDisabled = false;
                                    this.submitted = false;
                                    return;
                                }
                                else {
                                    if (angular.isDate(participant.dateOfBirth)) {
                                        msgBuilder.add(StringConst.Warn_StudentNotMeetAgeRequirement);
                                    }
                                    else {
                                        msgBuilder.add(StringConst.Warn_StudentDOBRequired);
                                    }
                                }
                            }
                            if (this.initDataObj.salesCatalogType === Enums.SalesCatalogType.AtSchoolOneDay
                                || this.initDataObj.salesCatalogType === Enums.SalesCatalogType.AtSchoolMultiWeek) {
                                if (this.myForm['prodForm_' + formSuffix][formName].chkedProds.$error.required) {
                                    msgBuilder.add('Please select a session.');
                                }
                            }
                            else if (this.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                                if (!angular.isArray(participant.selectedProdInfos) || participant.selectedProdInfos.length < 1) {
                                    msgBuilder.add('Please select day or overnight camp.');
                                }
                            }
                            if (msgBuilder.length() > 0) {
                                this.common.showWarning(msgBuilder.toString());
                            }
                            this.submitted = false;
                            this.saveDisabled = false;
                        }
                        var defer = this.common.$q.defer();
                        defer.resolve();
                        return defer.promise;
                    };
                    AVCSelectedInlineCtrl.prototype.checkout = function () {
                        if (this.userBrowsingMgr.currentUBSession.UB_ItemDTOs && this.userBrowsingMgr.currentUBSession.UB_ItemDTOs.length > 0) {
                            this.regFlowMgr.nextStep();
                        }
                        else {
                            this.common.showWarning('Shopping cart is empty. Please select a course to proceed.');
                        }
                    };
                    AVCSelectedInlineCtrl.prototype.isHalfDayPurchased = function (studentIndex) {
                        return this.isHalfDayPurchasedList[studentIndex];
                    };
                    AVCSelectedInlineCtrl.controllerId = 'AVCSelectedInlineCtrl';
                    return AVCSelectedInlineCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCSelectedInline.AVCSelectedInlineCtrl = AVCSelectedInlineCtrl;
            })(AVCSelectedInline = PulsePublic.AVCSelectedInline || (PulsePublic.AVCSelectedInline = {}));
            Pulse.app.directive(AVCSelectedInline.directiveId, ["common", function (c) { return new AVCSelectedInline(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var AVCCourseAddedPopup = (function (_super) {
                __extends(AVCCourseAddedPopup, _super);
                function AVCCourseAddedPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        AVCCourseAddedPopup.AVCCourseAddedPopupCtrl];
                    return _this;
                }
                AVCCourseAddedPopup.directiveId = "idpAvcCourseAddedPopup";
                return AVCCourseAddedPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.AVCCourseAddedPopup = AVCCourseAddedPopup;
            (function (AVCCourseAddedPopup) {
                var AVCCourseAddedPopupCtrl = (function (_super) {
                    __extends(AVCCourseAddedPopupCtrl, _super);
                    function AVCCourseAddedPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, AVCCourseAddedPopupCtrl.controllerId) || this;
                        _this.internationalDiscountCodes = [{ amount: 50, currencyTypeID: Enums.CurrencyType.USD }];
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/avail-chart/idp-avc-course-added-popup.html";
                        _this.activationPromises.push(_this.pulseContext.lookupInfoMgr.loadDivisionInfo());
                        _this.activateController();
                        return _this;
                    }
                    AVCCourseAddedPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        console.log(initDataObj);
                    };
                    AVCCourseAddedPopupCtrl.prototype.getDivisionAbbr = function () {
                        return DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, this.initDataObj.mainProduct.divisionID).abbr;
                    };
                    Object.defineProperty(AVCCourseAddedPopupCtrl.prototype, "Discount", {
                        get: function () {
                            var _this = this;
                            var discount = this.internationalDiscountCodes.filter(function (w) { return w.currencyTypeID == _this.initDataObj.mainProduct.currencyTypeID; });
                            if (discount.length > 0) {
                                return discount[0];
                            }
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AVCCourseAddedPopupCtrl.controllerId = "AVCCourseAddedPopupCtrl";
                    return AVCCourseAddedPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                AVCCourseAddedPopup.AVCCourseAddedPopupCtrl = AVCCourseAddedPopupCtrl;
            })(AVCCourseAddedPopup = PulsePublic.AVCCourseAddedPopup || (PulsePublic.AVCCourseAddedPopup = {}));
            Pulse.app.directive(AVCCourseAddedPopup.directiveId, ["common", function (c) { return new AVCCourseAddedPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCContactInfoDir = (function (_super) {
                __extends(AVCContactInfoDir, _super);
                function AVCContactInfoDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot
                        + Paths.PulsePublicDirective
                        + 'reg-flow/avail-chart/idp-avc-contact-info.html';
                    _this.scope = {
                        formName: '@?',
                        label: '@?',
                        parentInfo: '=',
                        placeholder: '<?',
                        title: '@?',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        AVCContactInfoDir.AVCContactInfoDirCtrl,
                    ];
                    return _this;
                }
                AVCContactInfoDir.directiveId = 'idpAvcContactInfo';
                return AVCContactInfoDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCContactInfoDir = AVCContactInfoDir;
            (function (AVCContactInfoDir) {
                var AVCContactInfoDirCtrl = (function (_super) {
                    __extends(AVCContactInfoDirCtrl, _super);
                    function AVCContactInfoDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCContactInfoDirCtrl.controllerId) || this;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(AVCContactInfoDirCtrl.prototype, "isDisabled", {
                        get: function () {
                            return false;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCContactInfoDirCtrl.prototype, "hasLabel", {
                        get: function () {
                            if (this._hasLabel === undefined)
                                this._hasLabel = !!this.title || !!this.label;
                            return this._hasLabel;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCContactInfoDirCtrl.prototype, "labelContent", {
                        get: function () {
                            if (this._label === undefined && this.hasLabel)
                                this._label = this.label || this.title;
                            return this._label;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCContactInfoDirCtrl.prototype, "fieldPlaceholder", {
                        get: function () {
                            if (this._placeholder === undefined)
                                this._placeholder = this.placeholder || 'Email Address';
                            return this._placeholder;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AVCContactInfoDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude, compilationInfoObj) {
                        if (this.formName)
                            this.myForm = scope[this.formName];
                    };
                    AVCContactInfoDirCtrl.controllerId = 'AVCContactInfoDirCtrl';
                    return AVCContactInfoDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCContactInfoDir.AVCContactInfoDirCtrl = AVCContactInfoDirCtrl;
            })(AVCContactInfoDir = PulsePublic.AVCContactInfoDir || (PulsePublic.AVCContactInfoDir = {}));
            Pulse.app.directive(AVCContactInfoDir.directiveId, [
                'common',
                function (c) { return new AVCContactInfoDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var StickyMgrFactory = Pulse.Modules.ContainerBoundSticky.Services.StickyMgrFactoryService;
            var AvailabilityChart = (function (_super) {
                __extends(AvailabilityChart, _super);
                function AvailabilityChart() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        avcDataSet: '<',
                        location: '<',
                        onRenderFinish: '&?',
                        targetedCourseId: '<?',
                        drawerStyle: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/idp-avc-availability-chart.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        'common',
                        '$element',
                        'pulseContextService',
                        'config',
                        '$timeout',
                        StickyMgrFactory.registeredAs,
                        'avcStickiesConfig',
                        'avcUnmanagedStickies',
                        'FilterPanelToggleService',
                        'DrawerToggleService',
                        'AvcExpandersService',
                        function ($scope, common, $element, pulseContext, config, $timeout, stickyMgrFactory, avcStickiesConfig, avcUnmanagedStickies, filterPanelToggleService, drawerToggleService, chartExpanderStatuses) {
                            return new AvailabilityChartCtrl($scope, common, $element, pulseContext, config, $timeout, stickyMgrFactory, avcStickiesConfig, avcUnmanagedStickies, filterPanelToggleService, drawerToggleService, chartExpanderStatuses);
                        },
                    ];
                    return _this;
                }
                AvailabilityChart.registeredAs = 'idpAvcAvailabilityChart';
                return AvailabilityChart;
            }(ComponentOptions));
            RegistryFlow.AvailabilityChart = AvailabilityChart;
            var AvailabilityChartCtrl = (function (_super) {
                __extends(AvailabilityChartCtrl, _super);
                function AvailabilityChartCtrl($scope, common, $element, pulseContext, config, $timeout, stickyMgrFactory, avcStickiesConfig, avcUnmanagedStickies, filterPanelToggleService, drawerToggleService, chartExpanderStatuses) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.pulseContext = pulseContext;
                    _this.viewLoaded = false;
                    _this._isChangeRegFlow = false;
                    _this.common = common;
                    _this.$timeout = $timeout;
                    _this.config = config;
                    _this.stickyMgrFactory = stickyMgrFactory;
                    _this.stickiesDef = avcStickiesConfig;
                    _this.unmanagedStickies = avcUnmanagedStickies;
                    _this.filterPanelToggleService = filterPanelToggleService;
                    _this.drawerToggleService = drawerToggleService;
                    _this.chartExpanderStatuses = chartExpanderStatuses;
                    _this.onRenderFinish = function () { return; };
                    _this.$scope.$on(Events.NgRepeatFinished, function () { return $timeout(function () { return _this.triggerRenderFinish(); }, 1); });
                    _this.pulseContext.lookupInfoMgr.loadDivisionInfo();
                    _this._isChangeRegFlow = angular.isNumber(_this.pulseContext.regFlowMgr.userBrowsingMgr.getParticipantCurrencyType());
                    return _this;
                }
                Object.defineProperty(AvailabilityChartCtrl.prototype, "vcLogoImageSrc", {
                    get: function () {
                        return this.config.appRoot + "assets/images/icons/new/logo-42.svg";
                    },
                    enumerable: false,
                    configurable: true
                });
                AvailabilityChartCtrl.prototype.$onDestroy = function () {
                    if (this.stickyMgr) {
                        this.stickyMgr.onDestroy();
                    }
                };
                AvailabilityChartCtrl.prototype.toggleTermDivisionAccordion = function (termDivision) {
                    this.chartExpanderStatuses.termDivisionStatus.toggleStatusChange(termDivision);
                };
                AvailabilityChartCtrl.prototype.hasAccordionPanelExpanded = function (termDivision) {
                    return this.chartExpanderStatuses.termDivisionStatus.isSelected(termDivision);
                };
                AvailabilityChartCtrl.prototype.triggerRenderFinish = function () {
                    this.viewLoaded = true;
                    this.initViewStickiesManager();
                    this.onRenderFinish();
                };
                AvailabilityChartCtrl.prototype.refreshStickiesOnNextDigest = function () {
                    var _this = this;
                    this.$timeout.cancel(this.scheduledStickyRefresh);
                    if (this.stickyMgr) {
                        this.scheduledStickyRefresh = this.$timeout(function () {
                            _this.stickyMgr.triggerOnDemandRender();
                        });
                    }
                };
                AvailabilityChartCtrl.prototype.showLeftFiltersPanel = function () {
                    return this.filterPanelToggleService.isVisible;
                };
                AvailabilityChartCtrl.prototype.hasCourses = function (division) {
                    return division && division.courses && division.courses.length > 0;
                };
                AvailabilityChartCtrl.prototype.toggleMobileSessionsVisibility = function (course) {
                    this.chartExpanderStatuses.courseMobileStatus.toggleStatusChange(course);
                };
                AvailabilityChartCtrl.prototype.areSessionsMobileVisible = function (course) {
                    return this.chartExpanderStatuses.courseMobileStatus.isSelected(course);
                };
                AvailabilityChartCtrl.prototype.isSessionMobileVisible = function (course, session) {
                    return session.statusOptions.id !== Enums.SessionAvailabilityStatus.NA
                        && this.areSessionsMobileVisible(course);
                };
                Object.defineProperty(AvailabilityChartCtrl.prototype, "isChangeRegFlow", {
                    get: function () {
                        return this._isChangeRegFlow;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvailabilityChartCtrl.prototype.getThumbNailFullUrl = function (course, largeImage) {
                    if (largeImage === void 0) { largeImage = false; }
                    return Pulse.Common.DataAccess.Managers.AvailChartMgr.GetThumbNailFullUrl(this.config, course, largeImage);
                };
                AvailabilityChartCtrl.prototype.toggleSessionAction = function ($event, division, course, session) {
                    this.showCourseSessionMobileCells(course);
                    this.$scope.$emit(Events.AvChartProcessSessionClickEvent, $event.currentTarget, division, course, session);
                    this.drawerToggleService.setProductCurrencyType(Enums.CurrencyType.USD);
                };
                AvailabilityChartCtrl.prototype.checkDrawerForSession = function (division, course, session) {
                    return this.drawerToggleService.isSelected(division, course, session);
                };
                Object.defineProperty(AvailabilityChartCtrl.prototype, "drawerProducts", {
                    get: function () {
                        return this.drawerToggleService.drawerProducts;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvailabilityChartCtrl.prototype, "crossSellProds", {
                    get: function () {
                        return this.drawerToggleService.setProductCurrencyType(this.drawerProducts.mainProduct.currencyTypeID).crossSellProds;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvailabilityChartCtrl.prototype, "showVTC", {
                    get: function () {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvailabilityChartCtrl.prototype, "VtcPrice", {
                    get: function () {
                        return '$399';
                    },
                    enumerable: false,
                    configurable: true
                });
                AvailabilityChartCtrl.prototype.initViewStickiesManager = function () {
                    this.stickyMgr = this.viewsStickyMgr;
                    this.stickyMgr.init([Events.WEBRemovingPromoBanner]);
                };
                AvailabilityChartCtrl.prototype.showCourseSessionMobileCells = function (course) {
                    this.chartExpanderStatuses.courseMobileStatus.select(course);
                };
                Object.defineProperty(AvailabilityChartCtrl.prototype, "viewsStickyMgr", {
                    get: function () {
                        return this.stickyMgrFactory.getNewStickyManager(this.stickiesDef, this.unmanagedStickies);
                    },
                    enumerable: false,
                    configurable: true
                });
                AvailabilityChartCtrl.prototype.redirectToVirtualCamps = function () {
                    var url = this.config.WWW_UrlRoot + '/virtual';
                    window.location.assign(url);
                };
                AvailabilityChartCtrl.prototype.getDivisionAbbr = function (divID) {
                    var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, divID);
                    return div ? div.abbr : "";
                };
                AvailabilityChartCtrl.prototype.onCancelExchange = function () {
                    var _this = this;
                    this._isChangeRegFlow = false;
                    this.common.toggleSpinner(true);
                    this.pulseContext.regFlowMgr.shoppingCartMgr.cancelShoppingCart();
                    this.pulseContext.regFlowMgr.userBrowsingMgr.removeUserBrowsingSession(this.pulseContext.regFlowMgr.userBrowsingMgr.currentUBSession)
                        .then(function () {
                        _this.pulseContext.regFlowMgr.userBrowsingMgr.removeParticipantCurrencyType();
                        _this.pulseContext.regFlowMgr = null;
                        _this.common.$location.url(Routes.MyAccount);
                    }).finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                };
                return AvailabilityChartCtrl;
            }(ComponentController));
            RegistryFlow.AvailabilityChartCtrl = AvailabilityChartCtrl;
            Pulse.app.component(AvailabilityChart.registeredAs, new AvailabilityChart());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var StickyMgrFactory = Pulse.Modules.ContainerBoundSticky.Services.StickyMgrFactoryService;
            var AvailabilityChartVirtual = (function (_super) {
                __extends(AvailabilityChartVirtual, _super);
                function AvailabilityChartVirtual() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        avcDataSet: '<',
                        location: '<',
                        onRenderFinish: '&?',
                        targetedCourseId: '<?',
                        catalogDateRangeId: '<?',
                        catalogDateRanges: '<?',
                        drawerStyle: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/idp-avc-availability-chart-virtual.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'config',
                        'common',
                        '$timeout',
                        StickyMgrFactory.registeredAs,
                        'avcStickiesConfig',
                        'avcUnmanagedStickies',
                        'FilterPanelToggleService',
                        'DrawerToggleService',
                        'AvcExpandersService',
                        function ($scope, $element, pulseContext, config, common, $timeout, stickyMgrFactory, avcStickiesConfig, avcUnmanagedStickies, filterPanelToggleService, drawerToggleService, chartExpanderStatuses) {
                            return new AvailabilityChartVirtualCtrl($scope, $element, pulseContext, config, common, $timeout, stickyMgrFactory, avcStickiesConfig, avcUnmanagedStickies, filterPanelToggleService, drawerToggleService, chartExpanderStatuses);
                        },
                    ];
                    return _this;
                }
                AvailabilityChartVirtual.registeredAs = 'idpAvcAvailabilityChartVirtual';
                return AvailabilityChartVirtual;
            }(ComponentOptions));
            RegistryFlow.AvailabilityChartVirtual = AvailabilityChartVirtual;
            var AvailabilityChartVirtualCtrl = (function (_super) {
                __extends(AvailabilityChartVirtualCtrl, _super);
                function AvailabilityChartVirtualCtrl($scope, $element, pulseContext, config, common, $timeout, stickyMgrFactory, avcStickiesConfig, avcUnmanagedStickies, filterPanelToggleService, drawerToggleService, chartExpanderStatuses) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.pulseContext = pulseContext;
                    _this.viewLoaded = false;
                    _this.avcDataSetGrouped = [];
                    _this._isChangeRegFlow = false;
                    _this.$timeout = $timeout;
                    _this.config = config;
                    _this.stickyMgrFactory = stickyMgrFactory;
                    _this.stickiesDef = avcStickiesConfig;
                    _this.unmanagedStickies = avcUnmanagedStickies;
                    _this.filterPanelToggleService = filterPanelToggleService;
                    _this.drawerToggleService = drawerToggleService;
                    _this.chartExpanderStatuses = chartExpanderStatuses;
                    _this.common = common;
                    _this.onRenderFinish = function () { return; };
                    _this.$scope.$on(Events.NgRepeatFinished, function () { return $timeout(function () { return _this.triggerRenderFinish(); }, 1); });
                    _this._isChangeRegFlow = angular.isNumber(_this.pulseContext.regFlowMgr.userBrowsingMgr.getParticipantCurrencyType());
                    return _this;
                }
                AvailabilityChartVirtualCtrl.prototype.$onChanges = function (changes) {
                    if (changes.avcDataSet && changes.avcDataSet.isFirstChange()) {
                        this.avcDataSetGrouped = [];
                        var _loop_1 = function (cdr) {
                            var terms = this_1.avcDataSet.filter(function (s) { return s.catalogDateRange && s.catalogDateRange.catalogDateRangeID == cdr.catalogDateRangeID; });
                            if (terms.length > 0) {
                                this_1.avcDataSetGrouped.push({
                                    catalogDateRangeID: cdr.catalogDateRangeID,
                                    catalogDateRange: terms[0].catalogDateRange,
                                    terms: cdr.catalogDateRangeID === this_1.catalogDateRangeId ? _.sortBy(terms, 'termSortOrder') : [],
                                    isActive: false
                                });
                            }
                        };
                        var this_1 = this;
                        for (var _i = 0, _a = this.catalogDateRanges; _i < _a.length; _i++) {
                            var cdr = _a[_i];
                            _loop_1(cdr);
                        }
                        var self = this;
                        this.$timeout(function () {
                            var _loop_2 = function (g) {
                                if (g.terms.length == 0) {
                                    terms = self.avcDataSet.filter(function (d) { return d.catalogDateRange && d.catalogDateRange.catalogDateRangeID === g.catalogDateRangeID; });
                                    g.terms = _.sortBy(terms, 'termSortOrder');
                                }
                            };
                            var terms;
                            for (var _i = 0, _a = self.avcDataSetGrouped; _i < _a.length; _i++) {
                                var g = _a[_i];
                                _loop_2(g);
                            }
                        }, 1500);
                        this.expandSelection(this.catalogDateRangeId);
                    }
                };
                AvailabilityChartVirtualCtrl.prototype.expandSelection = function (catalogDateRangeId) {
                    if (this.catalogDateRangeId) {
                        for (var _i = 0, _a = this.avcDataSetGrouped; _i < _a.length; _i++) {
                            var e = _a[_i];
                            if (Number(e.catalogDateRangeID) == catalogDateRangeId) {
                                e.isActive = true;
                                this.common.scrollToHash('cdr-heading-' + e.catalogDateRangeID, 500);
                                return;
                            }
                        }
                        if (this.avcDataSetGrouped.length > 0) {
                            this.avcDataSetGrouped[0].isActive = true;
                        }
                    }
                    else {
                        if (this.avcDataSetGrouped.length > 0) {
                            this.avcDataSetGrouped[0].isActive = true;
                        }
                        return;
                    }
                };
                AvailabilityChartVirtualCtrl.prototype.$onDestroy = function () {
                    if (this.stickyMgr) {
                        this.stickyMgr.onDestroy();
                    }
                };
                AvailabilityChartVirtualCtrl.prototype.toggleTermDivisionAccordion = function (termDivision) {
                    this.chartExpanderStatuses.termDivisionStatus.toggleStatusChange(termDivision);
                };
                AvailabilityChartVirtualCtrl.prototype.hasAccordionPanelExpanded = function (termDivision) {
                    return this.chartExpanderStatuses.termDivisionStatus.isSelected(termDivision);
                };
                AvailabilityChartVirtualCtrl.prototype.triggerRenderFinish = function () {
                    this.viewLoaded = true;
                    this.initViewStickiesManager();
                    this.onRenderFinish();
                };
                AvailabilityChartVirtualCtrl.prototype.refreshStickiesOnNextDigest = function () {
                    var _this = this;
                    this.$timeout.cancel(this.scheduledStickyRefresh);
                    if (this.stickyMgr) {
                        this.scheduledStickyRefresh = this.$timeout(function () {
                            _this.stickyMgr.triggerOnDemandRender();
                        });
                    }
                };
                AvailabilityChartVirtualCtrl.prototype.showLeftFiltersPanel = function () {
                    return this.filterPanelToggleService.isVisible;
                };
                AvailabilityChartVirtualCtrl.prototype.hasCourses = function (division) {
                    return division && division.courses && division.courses.length > 0;
                };
                AvailabilityChartVirtualCtrl.prototype.toggleMobileSessionsVisibility = function (course) {
                    this.chartExpanderStatuses.courseMobileStatus.toggleStatusChange(course);
                };
                AvailabilityChartVirtualCtrl.prototype.areSessionsMobileVisible = function (course) {
                    return this.chartExpanderStatuses.courseMobileStatus.isSelected(course);
                };
                AvailabilityChartVirtualCtrl.prototype.isSessionMobileVisible = function (course, session) {
                    return session.statusOptions.id !== Enums.SessionAvailabilityStatus.NA
                        && this.areSessionsMobileVisible(course);
                };
                AvailabilityChartVirtualCtrl.prototype.getThumbNailFullUrl = function (course, largeImage) {
                    if (largeImage === void 0) { largeImage = false; }
                    return Pulse.Common.DataAccess.Managers.AvailChartMgr.GetThumbNailFullUrl(this.config, course, largeImage);
                };
                AvailabilityChartVirtualCtrl.prototype.isChangeRegFlow = function () {
                    return this._isChangeRegFlow;
                };
                AvailabilityChartVirtualCtrl.prototype.toggleSessionAction = function ($event, division, course, session) {
                    this.showCourseSessionMobileCells(course);
                    this.$scope.$emit(Events.AvChartProcessSessionClickEvent, $event.currentTarget, division, course, session);
                    this.drawerToggleService.setProductCurrencyType(course.currencyTypeID);
                };
                AvailabilityChartVirtualCtrl.prototype.checkDrawerForSession = function (division, course, session) {
                    return this.drawerToggleService.isSelected(division, course, session);
                };
                Object.defineProperty(AvailabilityChartVirtualCtrl.prototype, "drawerProducts", {
                    get: function () {
                        return this.drawerToggleService.drawerProducts;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvailabilityChartVirtualCtrl.prototype, "crossSellProds", {
                    get: function () {
                        return this.drawerToggleService.crossSellProds;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvailabilityChartVirtualCtrl.prototype.initViewStickiesManager = function () {
                    this.stickyMgr = this.viewsStickyMgr;
                    this.stickyMgr.init([Events.WEBRemovingPromoBanner]);
                };
                AvailabilityChartVirtualCtrl.prototype.showCourseSessionMobileCells = function (course) {
                    this.chartExpanderStatuses.courseMobileStatus.select(course);
                };
                Object.defineProperty(AvailabilityChartVirtualCtrl.prototype, "viewsStickyMgr", {
                    get: function () {
                        return this.stickyMgrFactory.getNewStickyManager(this.stickiesDef, this.unmanagedStickies);
                    },
                    enumerable: false,
                    configurable: true
                });
                AvailabilityChartVirtualCtrl.prototype.loadSessions = function (index) {
                    var group = this.avcDataSetGrouped[index];
                    if (group) {
                        group.isActive = !group.isActive;
                    }
                };
                AvailabilityChartVirtualCtrl.prototype.getDivisionAbbr = function (divID) {
                    var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, divID);
                    return div ? div.abbr : "";
                };
                AvailabilityChartVirtualCtrl.prototype.onCancelExchange = function () {
                    var _this = this;
                    this._isChangeRegFlow = false;
                    this.common.toggleSpinner(true);
                    this.pulseContext.regFlowMgr.shoppingCartMgr.cancelShoppingCart();
                    this.pulseContext.regFlowMgr.userBrowsingMgr.removeUserBrowsingSession(this.pulseContext.regFlowMgr.userBrowsingMgr.currentUBSession)
                        .then(function () {
                        _this.pulseContext.regFlowMgr.userBrowsingMgr.removeParticipantCurrencyType();
                        _this.pulseContext.regFlowMgr = null;
                        _this.common.$location.url(Routes.MyAccount);
                    }).finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                };
                return AvailabilityChartVirtualCtrl;
            }(ComponentController));
            RegistryFlow.AvailabilityChartVirtualCtrl = AvailabilityChartVirtualCtrl;
            Pulse.app.component(AvailabilityChartVirtual.registeredAs, new AvailabilityChartVirtual());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var DivisionInfoBlock = (function (_super) {
                __extends(DivisionInfoBlock, _super);
                function DivisionInfoBlock() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        accordionOpened: '&?',
                        termDivision: '<'
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/chart/idp-avc-division-info-block.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'PaymentPlanMgr',
                        'config',
                        function ($scope, $element, ppm, config) { return new DivisionInfoBlockCtrl($scope, $element, ppm, config); },
                    ];
                    return _this;
                }
                DivisionInfoBlock.registeredAs = 'idpAvcDivisionInfoBlock';
                return DivisionInfoBlock;
            }(ComponentOptions));
            RegistryFlow.DivisionInfoBlock = DivisionInfoBlock;
            var DivisionInfoBlockCtrl = (function (_super) {
                __extends(DivisionInfoBlockCtrl, _super);
                function DivisionInfoBlockCtrl($scope, $element, ppm, config) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.config = config;
                    _this.paymentPlanMgr = ppm;
                    _this.accordionOpened = function () { return false; };
                    return _this;
                }
                Object.defineProperty(DivisionInfoBlockCtrl.prototype, "logoImageSrc", {
                    get: function () {
                        return this.config.appRoot + "assets/images/icons/new/logo-" + this.termDivision.divID + ".svg";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DivisionInfoBlockCtrl.prototype, "termDivisionName", {
                    get: function () {
                        return this.termDivision.divProgramTypeID == Enums.DivisionProgramType.VirtualCamp ? this.termDivision.termName : this.termDivision.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DivisionInfoBlockCtrl.prototype, "hasValidPaymentOptions", {
                    get: function () {
                        if (this._hasValidPaymentOptions === undefined) {
                            this._hasValidPaymentOptions = this.paymentPlanMgr.divisionHasPaymentPlan(this.termDivision.sessions);
                        }
                        return this._hasValidPaymentOptions;
                    },
                    enumerable: false,
                    configurable: true
                });
                return DivisionInfoBlockCtrl;
            }(ComponentController));
            RegistryFlow.DivisionInfoBlockCtrl = DivisionInfoBlockCtrl;
            Pulse.app.component(DivisionInfoBlock.registeredAs, new DivisionInfoBlock());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcCourseCell = (function (_super) {
                __extends(AvcCourseCell, _super);
                function AvcCourseCell() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        areSessionsMobileVisible: '&',
                        course: '<',
                        courseImg: '&',
                        division: '<',
                        toggleMobileSessionVisibility: '&',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/chart/idp-avc-course-cell.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        '$rootScope',
                        'config',
                        'PaymentPlanMgr',
                        'pulseContextService',
                        function ($scope, $element, $rootScope, config, ppm, pulseContext) {
                            return new AvcCourseCellCtrl($scope, $element, $rootScope, config, ppm, pulseContext);
                        },
                    ];
                    return _this;
                }
                AvcCourseCell.registeredAs = 'idpAvcCourseCell';
                return AvcCourseCell;
            }(ComponentOptions));
            RegistryFlow.AvcCourseCell = AvcCourseCell;
            var AvcCourseCellCtrl = (function (_super) {
                __extends(AvcCourseCellCtrl, _super);
                function AvcCourseCellCtrl($scope, $element, $rootScope, config, ppm, pulseContext) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.pulseContext = pulseContext;
                    _this._isNew = null;
                    _this.$rootScope = $rootScope;
                    _this.config = config;
                    _this.availChartMgr = pulseContext.regFlowMgr.availChartMgr;
                    _this.isImpersonating = _this.pulseContext.isImpersonating;
                    _this.paymentPlanMgr = ppm;
                    return _this;
                }
                AvcCourseCellCtrl.prototype.triggerCourseInfoPopup = function () {
                    this.$rootScope.$broadcast(Events.ShowAvcCourseOverlayPopup, this.division, this.course);
                };
                AvcCourseCellCtrl.prototype.isNew = function () {
                    if (this._isNew === null) {
                        this._isNew = this.availChartMgr.isCourseNew(this.course);
                    }
                    return this._isNew;
                };
                AvcCourseCellCtrl.prototype.getDivisionAbbr = function (divID) {
                    var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, divID);
                    return div ? div.abbr : "";
                };
                Object.defineProperty(AvcCourseCellCtrl.prototype, "hasValidPaymentPlan", {
                    get: function () {
                        return this.paymentPlanMgr.divisionHasPaymentPlan(this.division.sessions);
                    },
                    enumerable: false,
                    configurable: true
                });
                return AvcCourseCellCtrl;
            }(ComponentController));
            RegistryFlow.AvcCourseCellCtrl = AvcCourseCellCtrl;
            Pulse.app.component(AvcCourseCell.registeredAs, new AvcCourseCell());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcSessionCell = (function (_super) {
                __extends(AvcSessionCell, _super);
                function AvcSessionCell() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        locationPrice: '<',
                        currencyTypeId: '<?',
                        session: '<',
                        termSession: '<'
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/chart/idp-avc-session-cell.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'FilterPanelToggleService',
                        function ($scope, $element, pcs, filterPanelToggleService) { return new AvcSessionCellCtrl($scope, $element, pcs, filterPanelToggleService); },
                    ];
                    return _this;
                }
                AvcSessionCell.registeredAs = 'idpAvcSessionCell';
                return AvcSessionCell;
            }(ComponentOptions));
            RegistryFlow.AvcSessionCell = AvcSessionCell;
            var AvcSessionCellCtrl = (function (_super) {
                __extends(AvcSessionCellCtrl, _super);
                function AvcSessionCellCtrl($scope, $element, pulseContext, filterPanelToggleService) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.pulseContext = pulseContext;
                    _this.availChartMgr = pulseContext.regFlowMgr.availChartMgr;
                    _this.filterPanelToggleService = filterPanelToggleService;
                    return _this;
                }
                AvcSessionCellCtrl.prototype.$onInit = function () {
                    _super.prototype.$onInit.call(this);
                    if (this.currencyTypeId == undefined)
                        this.currencyTypeId = Enums.CurrencyType.USD;
                };
                Object.defineProperty(AvcSessionCellCtrl.prototype, "hasNAStatus", {
                    get: function () {
                        return this.session.statusOptions.id === Enums.SessionAvailabilityStatus.NA;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcSessionCellCtrl.prototype, "showLeftFiltersPanel", {
                    get: function () {
                        return this.filterPanelToggleService.isVisible;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcSessionCellCtrl.prototype, "showDayIcon", {
                    get: function () {
                        return this.session.isONpackage !== true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcSessionCellCtrl.prototype, "showNightIcon", {
                    get: function () {
                        var displayNightIcon = false;
                        if (this.session.isONpackage === true) {
                            displayNightIcon = true;
                        }
                        else {
                            displayNightIcon = this.session.spdIDON > 0
                                && this.session.priceWithON > 0
                                && this.session.optionRestriction !== Enums.OverrideType[Enums.OverrideType.ParticipantTooYoung]
                                && this.session.optionStatus !== Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.SoldOut]
                                && (!this.availChartMgr.isSessionClosedForAddingResidency(this.termSession) || this.pulseContext.isImpersonating);
                        }
                        return displayNightIcon;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcSessionCellCtrl.prototype, "highlightOnHover", {
                    get: function () {
                        return this.session.statusOptions.hasUserInteraction;
                    },
                    enumerable: false,
                    configurable: true
                });
                return AvcSessionCellCtrl;
            }(ComponentController));
            RegistryFlow.AvcSessionCellCtrl = AvcSessionCellCtrl;
            Pulse.app.component(AvcSessionCell.registeredAs, new AvcSessionCell());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ChartFiltersMgr = Pulse.PulsePublic.RegistryFlow.ChartFiltersMgr;
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcLeftFiltersPanel = (function (_super) {
                __extends(AvcLeftFiltersPanel, _super);
                function AvcLeftFiltersPanel() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        onDemandStickyRender: '&',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) { return config.appRoot
                            + Paths.PulsePublicRegistryFlow
                            + 'av-chart/components/chart/idp-avc-left-filters-panel.html'; },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'common',
                        '$timeout',
                        '$interval',
                        ChartFiltersMgr.registeredAs,
                        'FilterPanelToggleService',
                        function ($scope, $element, common, $timeout, $interval, cfm, filterPanelToggleService) {
                            return new AvcLeftFiltersPanelCtrl($scope, $element, common, $timeout, $interval, cfm, filterPanelToggleService);
                        },
                    ];
                    return _this;
                }
                AvcLeftFiltersPanel.registeredAs = 'idpAvcLeftFiltersPanel';
                return AvcLeftFiltersPanel;
            }(ComponentOptions));
            RegistryFlow.AvcLeftFiltersPanel = AvcLeftFiltersPanel;
            var AvcLeftFiltersPanelCtrl = (function (_super) {
                __extends(AvcLeftFiltersPanelCtrl, _super);
                function AvcLeftFiltersPanelCtrl($scope, $element, common, $timeout, $interval, chartFiltersMgr, filterPanelToggleService) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.title = 'Left Filters Panel';
                    _this.common = common;
                    _this.filterMgr = chartFiltersMgr;
                    _this.filterPanelToggleService = filterPanelToggleService;
                    var $component = function () {
                        return angular.element('idp-avc-left-filters-panel');
                    };
                    var $filterPanel = function () {
                        return angular.element('.left-filter-panel');
                    };
                    var panelMinHeight = function () {
                        return Math.min(500, window.innerHeight);
                    };
                    var deferredPanelPositionReset;
                    $scope.$watch(function () { return _this.filterPanelToggleService.isVisible; }, function (newVal, oldValue) {
                        var timeout = function () {
                            $timeout(function () {
                                $filterPanel()
                                    .removeAttr('style');
                                if (_this.onDemandStickyRender)
                                    _this.onDemandStickyRender();
                            });
                        };
                        if (newVal && newVal !== oldValue) {
                            $interval.cancel(deferredPanelPositionReset);
                            deferredPanelPositionReset = $interval(function () {
                                if ($component().height() >= panelMinHeight()) {
                                    timeout();
                                    $interval.cancel(deferredPanelPositionReset);
                                }
                            }, 100);
                        }
                    });
                    return _this;
                }
                Object.defineProperty(AvcLeftFiltersPanelCtrl.prototype, "filters", {
                    get: function () {
                        return this.filterMgr.filters;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcLeftFiltersPanelCtrl.prototype.closePanel = function () {
                    this.filterPanelToggleService.toggleVisibility();
                };
                AvcLeftFiltersPanelCtrl.prototype.resetAllFilters = function () {
                    this.filterMgr.resetAllFilters();
                    this.$scope.$emit(Events.AvChartApplyFilters);
                };
                AvcLeftFiltersPanelCtrl.prototype.resetFilter = function (filter) {
                    filter.selectAll();
                    this.$scope.$emit(Events.AvChartApplyFilters);
                };
                AvcLeftFiltersPanelCtrl.prototype.switchFilterOptionState = function (filter, option) {
                    var _this = this;
                    filter.switchOptionState(option);
                    this.common.debounceAdd('switchAVCFilterOptionState', function () {
                        _this.$scope.$emit(Events.AvChartApplyFilters);
                    }, 800);
                };
                return AvcLeftFiltersPanelCtrl;
            }(ComponentController));
            RegistryFlow.AvcLeftFiltersPanelCtrl = AvcLeftFiltersPanelCtrl;
            Pulse.app.component(AvcLeftFiltersPanel.registeredAs, new AvcLeftFiltersPanel());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcSessionDrawer = (function (_super) {
                __extends(AvcSessionDrawer, _super);
                function AvcSessionDrawer() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        course: '<',
                        courseImgThumbnailUrl: '@',
                        courseImgUrl: '@',
                        location: '<',
                        products: '<',
                        crossSellProds: '<',
                        drawerStyle: "<?",
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/drawer/idp-avc-session-drawer.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        '$timeout',
                        'pulseContextService',
                        'DrawerToggleService',
                        function ($scope, $element, $timeout, pulseContext, drawerToggleService) {
                            return new AvcSessionDrawerCtrl($scope, $element, $timeout, pulseContext, drawerToggleService);
                        },
                    ];
                    return _this;
                }
                AvcSessionDrawer.registeredAs = 'idpAvcSessionDrawer';
                return AvcSessionDrawer;
            }(ComponentOptions));
            RegistryFlow.AvcSessionDrawer = AvcSessionDrawer;
            var AvcSessionDrawerCtrl = (function (_super) {
                __extends(AvcSessionDrawerCtrl, _super);
                function AvcSessionDrawerCtrl($scope, $element, $timeout, pulseContext, drawerToggleService) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this._isNew = null;
                    _this.$timeout = $timeout;
                    _this.pulseContext = pulseContext;
                    _this.availChartMgr = pulseContext.regFlowMgr.availChartMgr;
                    _this.drawerToggleService = drawerToggleService;
                    _this.userMgr = pulseContext.userMgr;
                    _this.ubMgr = pulseContext.regFlowMgr.userBrowsingMgr;
                    _this._alertTypes = [];
                    _this.registrationDisabled = false;
                    _this.knownEmailCheckCount = 0;
                    $scope.$on(Events.DrawerUpdateEmail, function (event, email) {
                        _this.checkEmailExistence(event, email);
                    });
                    $scope.$on(Events.LoginSuccess, function () {
                        _this.unknownUser = false;
                    });
                    return _this;
                }
                AvcSessionDrawerCtrl.prototype.$onChanges = function (changesObj) {
                    if (changesObj.products && changesObj.products.isFirstChange()) {
                        var products = changesObj.products.currentValue;
                        if (!this.hasDisabledPrimaryOption(products) || this.hasWaitlistStatus) {
                            this.selectProduct(products.mainProduct);
                        }
                    }
                };
                AvcSessionDrawerCtrl.prototype.closeDrawer = function () {
                    this.drawerToggleService.close();
                };
                Object.defineProperty(AvcSessionDrawerCtrl.prototype, "alertTypes", {
                    get: function () {
                        return this._alertTypes;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcSessionDrawerCtrl.prototype, "selectedProduct", {
                    get: function () {
                        return this._selectedProduct;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcSessionDrawerCtrl.prototype.selectProduct = function (product) {
                    this._selectedProduct = product;
                };
                Object.defineProperty(AvcSessionDrawerCtrl.prototype, "hasSelectedProduct", {
                    get: function () {
                        return !!this._selectedProduct;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcSessionDrawerCtrl.prototype.showProductSelection = function () {
                    return this.products.optionProduct && !(this.hasSelectedProduct || this.hasWaitlistStatus);
                };
                Object.defineProperty(AvcSessionDrawerCtrl.prototype, "hasWaitlistStatus", {
                    get: function () {
                        return this.session.statusOptions.isWaitlist;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcSessionDrawerCtrl.prototype, "session", {
                    get: function () {
                        return this.drawerToggleService.session;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcSessionDrawerCtrl.prototype, "sessionPaymentOption", {
                    get: function () {
                        return this.drawerToggleService.sessionPaymentOption;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcSessionDrawerCtrl.prototype.closeLoginAlert = function () {
                    this.showLoginAlert = false;
                };
                AvcSessionDrawerCtrl.prototype.showLogin = function () {
                    this.pulseContext.regFlowMgr.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress = this.checkedEmail;
                    this.$scope.$broadcast(Events.ShowLoginPopup, {
                        initDataObj: {
                            disableCreateAccount: true,
                            emailAddress: this.checkedEmail,
                            hideRequiredAsterix: true,
                            lockEmailAddress: true,
                            showCancel: true,
                            showLabels: true,
                            showRemember: true,
                        },
                        size: '',
                    });
                };
                AvcSessionDrawerCtrl.prototype.checkEmailExistence = function (event, email) {
                    var _this = this;
                    if (email && !this.pulseContext.isLoggedIn && this.knownEmailCheckCount < 3) {
                        this.$timeout.cancel(this.checkEmailPromise);
                        this.registrationDisabled = true;
                        this.checkEmailPromise = this.$timeout(function () {
                            _this.checkEmailIsKnown(email)
                                .finally(function () {
                                _this.registrationDisabled = false;
                            });
                        }, 500);
                    }
                    else if (this.knownEmailCheckCount >= 3) {
                        this.closeLoginAlert();
                    }
                };
                AvcSessionDrawerCtrl.prototype.checkEmailIsKnown = function (email) {
                    var _this = this;
                    return this.userMgr.isValidUsernameOr3rdPartyAuthEmail(email)
                        .then(function (result) {
                        result = typeof result === 'object' && Array.isArray(result)
                            ? !!result.shift()
                            : false;
                        _this.showLoginAlert = result;
                        _this.checkedEmail = result ? email : '';
                        _this.unknownUser = true;
                        if (result) {
                            _this.knownEmailCheckCount++;
                        }
                    })
                        .catch(function (err) {
                        console.error(err);
                    });
                };
                AvcSessionDrawerCtrl.prototype.hasDisabledPrimaryOption = function (products) {
                    return products.optionProduct && products.mainProduct.isONPackage !== true
                        && this.session.optionStatus !== Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.SoldOut]
                        && this.session.optionRestriction !== Enums.OverrideType[Enums.OverrideType.ParticipantTooYoung]
                        && (!this.availChartMgr.isSessionClosedForAddingResidency(this.drawerToggleService.locationSessionInfo)
                            || this.pulseContext.isImpersonating);
                };
                AvcSessionDrawerCtrl.prototype.isNew = function () {
                    if (this._isNew === null) {
                        this._isNew = this.availChartMgr.isCourseNew(this.course);
                    }
                    return this._isNew;
                };
                return AvcSessionDrawerCtrl;
            }(ComponentController));
            Pulse.app.component(AvcSessionDrawer.registeredAs, new AvcSessionDrawer());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var Paths = Pulse.Common.Resources.Paths;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcProductDescription = (function (_super) {
                __extends(AvcProductDescription, _super);
                function AvcProductDescription() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        courseImgUrl: '@',
                        product: '<',
                        originalProduct: '<?',
                        mainProduct: '<',
                        isShowDetailInfo: '@',
                        isSubscription: '<?',
                        sessionPaymentOption: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/drawer/idp-avc-product-description.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'common',
                        'DrawerToggleService',
                        'PaymentPlanMgr',
                        function ($scope, $element, common, dts, ppm) { return new AvcProductDescriptionCtrl($scope, $element, common, dts, ppm); }
                    ];
                    return _this;
                }
                AvcProductDescription.registeredAs = 'idpAvcProductDescription';
                return AvcProductDescription;
            }(ComponentOptions));
            RegistryFlow.AvcProductDescription = AvcProductDescription;
            var AvcProductDescriptionCtrl = (function (_super) {
                __extends(AvcProductDescriptionCtrl, _super);
                function AvcProductDescriptionCtrl($scope, $element, common, drawerService, paymentPlanMgr) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.common = common;
                    _this.isDetailExpanded = false;
                    _this.partialDetails = null;
                    _this.criticalDetails = null;
                    _this.completeDetails = "";
                    _this.sessionClone = angular.copy(drawerService.session);
                    _this.paymentPlanMgr = paymentPlanMgr;
                    return _this;
                }
                AvcProductDescriptionCtrl.prototype.$onInit = function () {
                    var _this = this;
                    _super.prototype.$onInit.call(this);
                    this.processInfo(this.mainProduct, this.common.isMobileView);
                    this.common.$rootScope.$on(Events.WindowResized, function (event, data) {
                        _this.processInfo(_this.mainProduct, _this.common.isMobileView);
                    });
                };
                AvcProductDescriptionCtrl.prototype.isWaitlist = function () {
                    return this.product.statusOptions.isWaitlist;
                };
                AvcProductDescriptionCtrl.prototype.isVirtual = function () {
                    return this.product.programTypeID == Enums.DivisionProgramType.VirtualCamp;
                };
                AvcProductDescriptionCtrl.prototype.isTutoring = function () {
                    return this.product.catalogTypeID == Enums.SalesCatalogType.OPLGeneric || this.product.catalogTypeID == Enums.SalesCatalogType.OPLThemed;
                };
                AvcProductDescriptionCtrl.prototype.isCourseBundle = function () {
                    return this.product.catalogTypeID == Enums.SalesCatalogType.CourseBundle;
                };
                Object.defineProperty(AvcProductDescriptionCtrl.prototype, "session", {
                    get: function () {
                        if (!this.sessionClone)
                            return null;
                        if (this.product.price !== this.sessionClone.price) {
                            this.sessionClone.price = this.product.price;
                        }
                        return this.sessionClone;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcProductDescriptionCtrl.prototype, "sessionPaymentValue", {
                    get: function () {
                        return this.paymentPlanMgr.sessionPaymentValue(this.sessionPaymentOption, this.product.price);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcProductDescriptionCtrl.prototype, "sessionPaymentCurrencyTypeID", {
                    get: function () {
                        if (this.hasValidPaymentOption) {
                            return this.sessionPaymentOption.currencyTypeID;
                        }
                        return Enums.CurrencyType.USD;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcProductDescriptionCtrl.prototype, "hasValidPaymentOption", {
                    get: function () {
                        return this.paymentPlanMgr.sessionHasPaymentPlan(this.sessionPaymentOption, this.product.price);
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcProductDescriptionCtrl.prototype.truncateAsNeeded = function (text) {
                    var trucateLen = 175;
                    if (text.length > trucateLen) {
                        text = _.truncate(text, { length: trucateLen, separator: /\W/ });
                    }
                    return text;
                };
                AvcProductDescriptionCtrl.prototype.processInfo = function (product, isMobile) {
                    if (isMobile === void 0) { isMobile = false; }
                    var sectionHeader, tempStr = "";
                    var isTruncated = false;
                    this.completeDetails = "";
                    this.criticalDetails = "";
                    if (!String.isNullOrWhitespace(product.description)) {
                        sectionHeader = "<p><strong>Course description:</strong>";
                        tempStr = this.truncateAsNeeded(product.description);
                        if (tempStr !== product.description) {
                            isTruncated = true;
                            this.partialDetails = sectionHeader + " " + tempStr + "</p>";
                        }
                        this.completeDetails += sectionHeader + " " + product.description + "</p>";
                    }
                    if (!String.isNullOrWhitespace(product.activityDesc)) {
                        sectionHeader = "<p><strong>In this course, you will:</strong>";
                        if (!isTruncated && isMobile) {
                            tempStr = this.truncateAsNeeded(product.activityDesc);
                            if (tempStr !== product.activityDesc) {
                                isTruncated = true;
                                this.partialDetails = sectionHeader + " " + tempStr + "</p>";
                            }
                        }
                        this.criticalDetails += sectionHeader + " " + product.activityDesc + "</p>";
                    }
                    if (!String.isNullOrWhitespace(product.takeHomeDesc)) {
                        sectionHeader = "<p><strong>Your tuition includes:</strong>";
                        if (!isTruncated && isMobile) {
                            tempStr = this.truncateAsNeeded(product.takeHomeDesc);
                            if (tempStr !== product.takeHomeDesc) {
                                isTruncated = true;
                                this.partialDetails = sectionHeader + " " + tempStr + "</p>";
                            }
                        }
                        this.criticalDetails += sectionHeader + " " + product.takeHomeDesc + "</p>";
                    }
                    if (isMobile) {
                        this.completeDetails += this.criticalDetails;
                    }
                };
                AvcProductDescriptionCtrl.prototype.triggerDetailInfo = function () {
                    this.isDetailExpanded = !this.isDetailExpanded;
                };
                return AvcProductDescriptionCtrl;
            }(ComponentController));
            Pulse.app.component(AvcProductDescription.registeredAs, new AvcProductDescription());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var Paths = Pulse.Common.Resources.Paths;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcProductDescriptionHeader = (function (_super) {
                __extends(AvcProductDescriptionHeader, _super);
                function AvcProductDescriptionHeader() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        courseImgUrl: '@',
                        product: '<',
                        mainProduct: '<',
                        isShowDetailInfo: '@',
                        isSubscription: '<?',
                        sessionPaymentOption: '<?',
                        withHeadline: '<?',
                        withDesc: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/drawer/idp-avc-product-description-header.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'common',
                        'DrawerToggleService',
                        function ($scope, $element, common, dts) { return new AvcProductDescriptionHeaderCtrl($scope, $element, common, dts); }
                    ];
                    return _this;
                }
                AvcProductDescriptionHeader.registeredAs = 'idpAvcProductDescriptionHeader';
                return AvcProductDescriptionHeader;
            }(ComponentOptions));
            RegistryFlow.AvcProductDescriptionHeader = AvcProductDescriptionHeader;
            var AvcProductDescriptionHeaderCtrl = (function (_super) {
                __extends(AvcProductDescriptionHeaderCtrl, _super);
                function AvcProductDescriptionHeaderCtrl($scope, $element, common, drawerService) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.common = common;
                    _this.isDetailExpanded = false;
                    _this.partialDetails = null;
                    _this.criticalDetails = null;
                    _this.completeDetails = "";
                    _this.withHeadline = false;
                    _this.withDesc = true;
                    _this.sessionClone = angular.copy(drawerService.session);
                    return _this;
                }
                AvcProductDescriptionHeaderCtrl.prototype.$onInit = function () {
                    var _this = this;
                    _super.prototype.$onInit.call(this);
                    this.processInfo(this.mainProduct, this.common.isMobileView);
                    this.common.$rootScope.$on(Events.WindowResized, function (event, data) {
                        _this.processInfo(_this.mainProduct, _this.common.isMobileView);
                    });
                };
                AvcProductDescriptionHeaderCtrl.prototype.isWaitlist = function () {
                    return this.product.statusOptions.isWaitlist;
                };
                AvcProductDescriptionHeaderCtrl.prototype.isVirtual = function () {
                    return this.product.programTypeID == Enums.DivisionProgramType.VirtualCamp;
                };
                AvcProductDescriptionHeaderCtrl.prototype.isTutoring = function () {
                    return this.product.catalogTypeID == Enums.SalesCatalogType.OPLGeneric || this.product.catalogTypeID == Enums.SalesCatalogType.OPLThemed;
                };
                AvcProductDescriptionHeaderCtrl.prototype.isCourseBundle = function () {
                    return this.product.catalogTypeID == Enums.SalesCatalogType.CourseBundle;
                };
                Object.defineProperty(AvcProductDescriptionHeaderCtrl.prototype, "session", {
                    get: function () {
                        if (!this.sessionClone)
                            return null;
                        if (this.product.price !== this.sessionClone.price) {
                            this.sessionClone.price = this.product.price;
                        }
                        return this.sessionClone;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcProductDescriptionHeaderCtrl.prototype.truncateAsNeeded = function (text) {
                    var trucateLen = 175;
                    if (text.length > trucateLen) {
                        text = _.truncate(text, { length: trucateLen, separator: /\W/ });
                    }
                    return text;
                };
                AvcProductDescriptionHeaderCtrl.prototype.processInfo = function (product, isMobile) {
                    if (isMobile === void 0) { isMobile = false; }
                    var sectionHeader, tempStr = "";
                    var isTruncated = false;
                    this.completeDetails = "";
                    this.criticalDetails = "";
                    if (!String.isNullOrWhitespace(product.description)) {
                        sectionHeader = "<p><strong>Course description:</strong>";
                        tempStr = this.truncateAsNeeded(product.description);
                        if (tempStr !== product.description) {
                            isTruncated = true;
                            this.partialDetails = sectionHeader + " " + tempStr + "</p>";
                        }
                        this.completeDetails += sectionHeader + " " + product.description + "</p>";
                    }
                    if (!String.isNullOrWhitespace(product.activityDesc)) {
                        sectionHeader = "<p><strong>In this course, you will:</strong>";
                        if (!isTruncated && isMobile) {
                            tempStr = this.truncateAsNeeded(product.activityDesc);
                            if (tempStr !== product.activityDesc) {
                                isTruncated = true;
                                this.partialDetails = sectionHeader + " " + tempStr + "</p>";
                            }
                        }
                        this.criticalDetails += sectionHeader + " " + product.activityDesc + "</p>";
                    }
                    if (!String.isNullOrWhitespace(product.takeHomeDesc)) {
                        sectionHeader = "<p><strong>Your tuition includes:</strong>";
                        if (!isTruncated && isMobile) {
                            tempStr = this.truncateAsNeeded(product.takeHomeDesc);
                            if (tempStr !== product.takeHomeDesc) {
                                isTruncated = true;
                                this.partialDetails = sectionHeader + " " + tempStr + "</p>";
                            }
                        }
                        this.criticalDetails += sectionHeader + " " + product.takeHomeDesc + "</p>";
                    }
                    if (isMobile) {
                        this.completeDetails += this.criticalDetails;
                    }
                };
                Object.defineProperty(AvcProductDescriptionHeaderCtrl.prototype, "sessionPaymentValue", {
                    get: function () {
                        return this.sessionPaymentOption !== undefined ?
                            (this.sessionPaymentOption.depositTypeID == Enums.CourseDeposit.FixedAmount ?
                                this.sessionPaymentOption.depositValue : (this.sessionPaymentOption.depositValue / 100) * this.product.price)
                            : 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcProductDescriptionHeaderCtrl.prototype, "sessionPaymentCurrencyTypeID", {
                    get: function () {
                        if (this.hasValidPaymentOption) {
                            return this.sessionPaymentOption.currencyTypeID;
                        }
                        return Enums.CurrencyType.USD;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcProductDescriptionHeaderCtrl.prototype, "hasValidPaymentOption", {
                    get: function () {
                        var today = new Date();
                        var hasValidPayment = false;
                        if (angular.isObject(this.sessionPaymentOption) && angular.isDefined(this.sessionPaymentOption.balanceDueDate)) {
                            var year = today.getMonth() == 11 ? today.getFullYear() + 1 : today.getFullYear();
                            var month = (today.getMonth() + 2);
                            var nextPaymentDate = new Date(year + "-" + month + "-" + (today.getDate() > 28 ? 28 : today.getDate()));
                            hasValidPayment = moment(this.sessionPaymentOption.balanceDueDate).diff(nextPaymentDate, 'days') > 0
                                && this.sessionPaymentValue > 0
                                && this.sessionPaymentValue < this.product.price;
                        }
                        if (angular.isObject(this.sessionPaymentOption)
                            && angular.isDefined(this.sessionPaymentOption.divDeliveryModelTypeID)
                            && this.sessionPaymentOption.divDeliveryModelTypeID == Enums.DivisionDeliveryModelType.YouthEducationalServices) {
                            hasValidPayment = moment(this.sessionPaymentOption.paymentOptionEndDate).diff(today, 'days') > 0
                                && this.sessionPaymentValue > 0
                                && this.sessionPaymentValue < this.product.price;
                        }
                        return hasValidPayment;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcProductDescriptionHeaderCtrl.prototype.triggerDetailInfo = function () {
                    this.isDetailExpanded = !this.isDetailExpanded;
                };
                return AvcProductDescriptionHeaderCtrl;
            }(ComponentController));
            Pulse.app.component(AvcProductDescriptionHeader.registeredAs, new AvcProductDescriptionHeader());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var Views;
            (function (Views) {
                var AvChart;
                (function (AvChart) {
                    var Components;
                    (function (Components) {
                        var ComponentController = Pulse.Common.ComponentController;
                        var ComponentOptions = Pulse.Common.ComponentOptions;
                        var LocationSessionTextType = Pulse.Common.Enums.LocationSessionTextType;
                        var DrawerAlerts = (function (_super) {
                            __extends(DrawerAlerts, _super);
                            function DrawerAlerts() {
                                var _this = _super.call(this) || this;
                                _this.bindings = {
                                    alerts: '<',
                                    bootstrapAlertType: '@',
                                    filterByAlertTypes: '<?',
                                };
                                _this.templateUrl = [
                                    'config',
                                    function (config) { return config.appRoot
                                        + Paths.PulsePublicRegistryFlow
                                        + 'av-chart/components/drawer/idp-avc-drawer-alerts.html'; },
                                ];
                                _this.controller = [
                                    '$scope',
                                    '$element',
                                    function ($scope, $element) { return new DrawerAlertsCtrl($scope, $element); },
                                ];
                                return _this;
                            }
                            DrawerAlerts.registeredAs = 'idpAvcDrawerAlerts';
                            return DrawerAlerts;
                        }(ComponentOptions));
                        Components.DrawerAlerts = DrawerAlerts;
                        var DrawerAlertsCtrl = (function (_super) {
                            __extends(DrawerAlertsCtrl, _super);
                            function DrawerAlertsCtrl($scope, $element) {
                                var _this = _super.call(this, $scope, $element) || this;
                                _this.defaultAlertType = 'info';
                                return _this;
                            }
                            DrawerAlertsCtrl.prototype.getAlertTypeCSS = function (alert) {
                                var alertType;
                                if (alert.typeID == LocationSessionTextType.CSAlertNotes) {
                                    alertType = "alert-danger";
                                }
                                else {
                                    alertType = "alert-" + (this.bootstrapAlertType || this.defaultAlertType);
                                }
                                return alertType;
                            };
                            Object.defineProperty(DrawerAlertsCtrl.prototype, "filteredAlerts", {
                                get: function () {
                                    return this._filteredAlerts;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            DrawerAlertsCtrl.prototype.$onChanges = function (changes) {
                                if (changes.filterByAlertTypes && !changes.filterByAlertTypes.currentValue) {
                                    this.filterByAlertTypes = [];
                                }
                                if (changes.alerts && changes.alerts.currentValue && this.checkForNewValue(changes.alerts)) {
                                    this._filteredAlerts = this.filterAlertsByType(changes.alerts.currentValue, this.filterByAlertTypes);
                                }
                            };
                            DrawerAlertsCtrl.prototype.filterAlertsByType = function (alerts, types) {
                                if (types && types.length > 0) {
                                    return alerts.filter(function (alert) {
                                        return types.some(function (type) {
                                            return alert.typeID === type;
                                        });
                                    });
                                }
                                return alerts;
                            };
                            return DrawerAlertsCtrl;
                        }(ComponentController));
                        Components.DrawerAlertsCtrl = DrawerAlertsCtrl;
                        Pulse.app.component(DrawerAlerts.registeredAs, new DrawerAlerts());
                    })(Components = AvChart.Components || (AvChart.Components = {}));
                })(AvChart = Views.AvChart || (Views.AvChart = {}));
            })(Views = RegistryFlow.Views || (RegistryFlow.Views = {}));
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var Views;
            (function (Views) {
                var AvChart;
                (function (AvChart) {
                    var Components;
                    (function (Components) {
                        var ComponentOptions = Pulse.Common.ComponentOptions;
                        var ComponentController = Pulse.Common.ComponentController;
                        var AvcCourseAlternativeLocations = (function (_super) {
                            __extends(AvcCourseAlternativeLocations, _super);
                            function AvcCourseAlternativeLocations() {
                                var _this = _super.call(this) || this;
                                _this.bindings = {
                                    maxCount: '<',
                                    sameSession: '<?',
                                    spdId: '<',
                                };
                                _this.controller = [
                                    '$scope',
                                    '$element',
                                    '$route',
                                    'pulseContextService',
                                    function ($scope, $element, $route, pulseContext) {
                                        return new AvcCourseAlternativeLocationsCtrl($scope, $element, $route, pulseContext);
                                    },
                                ];
                                _this.templateUrl = [
                                    'config',
                                    function (config) { return config.appRoot
                                        + Paths.PulsePublicRegistryFlow
                                        + 'av-chart/components/drawer/idp-avc-course-alternative-locations.html'; },
                                ];
                                return _this;
                            }
                            AvcCourseAlternativeLocations.registeredAs = 'idpAvcCourseAlternativeLocations';
                            return AvcCourseAlternativeLocations;
                        }(ComponentOptions));
                        Components.AvcCourseAlternativeLocations = AvcCourseAlternativeLocations;
                        var AvcCourseAlternativeLocationsCtrl = (function (_super) {
                            __extends(AvcCourseAlternativeLocationsCtrl, _super);
                            function AvcCourseAlternativeLocationsCtrl($scope, $element, $route, pulseContext) {
                                var _this = _super.call(this, $scope, $element) || this;
                                _this.$route = $route;
                                _this.regFlowMgr = pulseContext.regFlowMgr;
                                _this.avMgr = pulseContext.regFlowMgr.availChartMgr;
                                _this.locationMgr = pulseContext.regFlowMgr.locationFinderMgr;
                                _this.alternatives = [];
                                return _this;
                            }
                            Object.defineProperty(AvcCourseAlternativeLocationsCtrl.prototype, "spdID", {
                                get: function () {
                                    return this.spdId;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            AvcCourseAlternativeLocationsCtrl.prototype.$onInit = function () {
                                var _this = this;
                                this.$scope.$watch(function () { return _this.spdID; }, function () {
                                    _this.alternatives = undefined;
                                    _this.avMgr
                                        .getNearestLocations(_this.spdID, _this.maxCount, _this.sameSessionOnly)
                                        .then(function (data) {
                                        return _this.alternatives = data;
                                    }, function () { return _this.alternatives = []; });
                                });
                            };
                            Object.defineProperty(AvcCourseAlternativeLocationsCtrl.prototype, "hasNearLocations", {
                                get: function () {
                                    return this.alternatives === undefined || this.alternatives.length > 0;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            Object.defineProperty(AvcCourseAlternativeLocationsCtrl.prototype, "sameSessionOnly", {
                                get: function () {
                                    return !!(this.sameSession === undefined || this.sameSession);
                                },
                                enumerable: false,
                                configurable: true
                            });
                            AvcCourseAlternativeLocationsCtrl.prototype.navigateToAvChart = function (locationID) {
                                this.locationMgr.clearAllSelected(false);
                                this.locationMgr.addOrRemoveFromSelected(locationID, true, true);
                            };
                            return AvcCourseAlternativeLocationsCtrl;
                        }(ComponentController));
                        Components.AvcCourseAlternativeLocationsCtrl = AvcCourseAlternativeLocationsCtrl;
                        Pulse.app.component(AvcCourseAlternativeLocations.registeredAs, new AvcCourseAlternativeLocations());
                    })(Components = AvChart.Components || (AvChart.Components = {}));
                })(AvChart = Views.AvChart || (Views.AvChart = {}));
            })(Views = RegistryFlow.Views || (RegistryFlow.Views = {}));
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcWaitlistForm = (function (_super) {
                __extends(AvcWaitlistForm, _super);
                function AvcWaitlistForm() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        location: '<',
                        product: '<',
                    };
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'common',
                        'WaitlistFormService',
                        'DrawerToggleService',
                        function ($scope, $element, pulseContext, common, wfs, dts) {
                            return new AvcWaitlistFormCtrl($scope, $element, pulseContext, common, wfs, dts);
                        },
                    ];
                    _this.templateUrl = [
                        'config',
                        function (config) { return config.appRoot
                            + Paths.PulsePublicRegistryFlow
                            + 'av-chart/components/drawer/forms/idp-avc-waitlist-form.html'; },
                    ];
                    return _this;
                }
                AvcWaitlistForm.registeredAs = 'idpAvcWaitlistForm';
                return AvcWaitlistForm;
            }(ComponentOptions));
            RegistryFlow.AvcWaitlistForm = AvcWaitlistForm;
            var AvcWaitlistFormCtrl = (function (_super) {
                __extends(AvcWaitlistFormCtrl, _super);
                function AvcWaitlistFormCtrl($scope, $element, pulseContext, common, wfs, dts) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.formName = 'waitlistForm';
                    _this.common = common;
                    _this.waitlistFormService = wfs;
                    _this.drawerToggleService = dts;
                    _this.userBrowsingMgr = pulseContext.regFlowMgr.userBrowsingMgr;
                    _this.displayConfirmation = _this.drawerToggleService.session.inWaitlist;
                    _this.pulseContext = pulseContext;
                    return _this;
                }
                AvcWaitlistFormCtrl.prototype.$postLink = function () {
                    _super.prototype.$postLink.call(this);
                    this.initFormModel();
                };
                AvcWaitlistFormCtrl.prototype.submitForm = function () {
                    var _this = this;
                    this.updateUserEmailAddress(this.formModel.emailAddress)
                        .then(function () {
                        _this.waitlistFormService.submitForm(_this.waitlistForm, _this.formModel, _this.product)
                            .then(function () {
                            _this.drawerToggleService.session.inWaitlist = true;
                            _this.displayConfirmation = true;
                            _this.$scope.$emit(Events.AvChartAddWaitlist);
                        });
                    });
                };
                AvcWaitlistFormCtrl.prototype.isUserLoggedIn = function () {
                    return this.pulseContext.isLoggedIn;
                };
                AvcWaitlistFormCtrl.prototype.updateUserEmailAddress = function (newEmail) {
                    Pulse.Utils.ClickTracking.setTrackingCookie(newEmail);
                    var promise;
                    if (this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress !== newEmail) {
                        this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress = newEmail;
                        promise = this.userBrowsingMgr.updateCurrentUserBrowsing(this.userBrowsingMgr.currentUBSession);
                    }
                    else
                        promise = this.common.$q.resolve(this.userBrowsingMgr.currentUBSession.userBrowsingDTO);
                    return promise;
                };
                AvcWaitlistFormCtrl.prototype.isValidImage = function (imagePath) {
                    return imagePath !== null && imagePath !== undefined && imagePath.trim().length > 0;
                };
                AvcWaitlistFormCtrl.prototype.initFormModel = function () {
                    this.formModel = {};
                    var email = this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress;
                    this.formModel.emailAddress = email ? email : '';
                };
                return AvcWaitlistFormCtrl;
            }(ComponentController));
            RegistryFlow.AvcWaitlistFormCtrl = AvcWaitlistFormCtrl;
            Pulse.app.component(AvcWaitlistForm.registeredAs, new AvcWaitlistForm());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var Views;
            (function (Views) {
                var AvChart;
                (function (AvChart) {
                    var Components;
                    (function (Components) {
                        var ComponentOptions = Pulse.Common.ComponentOptions;
                        var ComponentController = Pulse.Common.ComponentController;
                        var AvcRegistrationForm = (function (_super) {
                            __extends(AvcRegistrationForm, _super);
                            function AvcRegistrationForm() {
                                var _this = _super.call(this) || this;
                                _this.bindings = {
                                    formDisabled: '<',
                                    mainProduct: '<',
                                    selectedProduct: '<',
                                    isSquads: '<?',
                                    addonProducts: '<?',
                                    isSubscription: '<?',
                                    isCourseBundle: '<?',
                                    bundleProducts: '<?',
                                    groupWithBeginners: '<?',
                                    crossSellProds: '<',
                                    drawerStyle: '<?',
                                    resetStep: '<?',
                                };
                                _this.templateUrl = [
                                    'config',
                                    function (config) { return config.appRoot
                                        + Paths.PulsePublicRegistryFlow
                                        + 'av-chart/components/drawer/forms/idp-avc-registration-form.html'; },
                                ];
                                _this.controller = [
                                    '$scope',
                                    '$element',
                                    'pulseContextService',
                                    'common',
                                    'DrawerToggleService',
                                    'ProductAvailabilityStepService',
                                    'RegisterFormService',
                                    function ($scope, $element, pulseContext, common, drawerToggleService, pulsePass, regFormService) {
                                        return new AvcRegistrationFormCtrl($scope, $element, pulseContext, common, drawerToggleService, pulsePass, regFormService);
                                    },
                                ];
                                return _this;
                            }
                            AvcRegistrationForm.registerAs = 'idpAvcRegistrationForm';
                            return AvcRegistrationForm;
                        }(ComponentOptions));
                        Components.AvcRegistrationForm = AvcRegistrationForm;
                        var AvcRegistrationFormCtrl = (function (_super) {
                            __extends(AvcRegistrationFormCtrl, _super);
                            function AvcRegistrationFormCtrl($scope, $element, pulseContext, common, drawerToggleService, pulsePass, regFormService) {
                                var _this = _super.call(this, $scope, $element) || this;
                                _this.formName = 'registrationForm';
                                _this.isSquads = false;
                                _this.isSubscription = false;
                                _this.isCourseBundle = false;
                                _this.groupWithBeginners = false;
                                _this.resetStep = true;
                                _this.isShowAvailStatus = false;
                                _this.pulseContext = pulseContext;
                                _this._ubMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                                _this.drawerToggleService = drawerToggleService;
                                _this.common = common;
                                _this.regFormService = regFormService;
                                _this.pulsePass = pulsePass;
                                _this.formDisabled = false;
                                $scope.$watch(function () { var _a; return (_a = _this.formModel) === null || _a === void 0 ? void 0 : _a.participant; }, function () {
                                    $scope.$applyAsync();
                                }, true);
                                $scope.$on(Pulse.Common.BasePopup.EventType.Close, function (event, data) {
                                    _this.adminOverridePopupClosed(event, data);
                                });
                                $scope.$on(Events.LoginSuccess, function (event, data) {
                                    _this.ubMgr.loadInfo(_this.ubMgr.currentUBSession, true)
                                        .then(function () {
                                        _this.initFormModel();
                                    });
                                });
                                return _this;
                            }
                            AvcRegistrationFormCtrl.prototype.processEmailChange = function (emailAddress, isValid) {
                                if (isValid) {
                                    this.$scope.$emit(Events.DrawerUpdateEmail, emailAddress);
                                }
                            };
                            Object.defineProperty(AvcRegistrationFormCtrl.prototype, "form", {
                                get: function () {
                                    return this.$scope[this.formName];
                                },
                                enumerable: false,
                                configurable: true
                            });
                            Object.defineProperty(AvcRegistrationFormCtrl.prototype, "productOptions", {
                                get: function () {
                                    return this.selectedProduct.options;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            Object.defineProperty(AvcRegistrationFormCtrl.prototype, "ubMgr", {
                                get: function () {
                                    return this._ubMgr;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            Object.defineProperty(AvcRegistrationFormCtrl.prototype, "isTutoring", {
                                get: function () {
                                    return this.selectedProduct.catalogTypeID == Enums.SalesCatalogType.OPLGeneric || this.selectedProduct.catalogTypeID == Enums.SalesCatalogType.OPLThemed;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            Object.defineProperty(AvcRegistrationFormCtrl.prototype, "startedClass", {
                                get: function () {
                                    var spanClass = this.drawerStyle.headingAccordion;
                                    if (this.isTutoring && this.drawerStyle.drawerTemplate == '') {
                                        spanClass = 'idp-dark-green-text-highlight';
                                    }
                                    return spanClass;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            Object.defineProperty(AvcRegistrationFormCtrl.prototype, "buttonContinueClass", {
                                get: function () {
                                    var btnClass = this.drawerStyle.buttonContinue;
                                    return btnClass;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            AvcRegistrationFormCtrl.prototype.$onInit = function () {
                                this.initFormModel();
                                this.initAvailabilityStatus();
                            };
                            AvcRegistrationFormCtrl.prototype.submitForm = function () {
                                var _this = this;
                                if (!this.isAllowedSubmit())
                                    return;
                                var participant = this.formModel.participant;
                                var participantAlreadyInCart = this.isAlreadyInCart(this.formModel.participant);
                                if (!(this.formDisabled || participantAlreadyInCart || this.requireAdminOverride(true))) {
                                    if (this.isFormValid) {
                                        this.updateUserEmailAddress(this.formModel.emailAddress)
                                            .then(function () { return _this.regFormService.submitForm(_this.selectedProduct, _this.formModel, _this.mainProduct, _this.isSubscription, _this.bundleProducts); })
                                            .then(function () {
                                            if (_this.drawerToggleService.session) {
                                                _this.drawerToggleService.session.inCartCount++;
                                            }
                                            _this.$scope.$emit(Events.ProductAddedToCart, _this.mainProduct, participant);
                                        });
                                    }
                                }
                                else if (this.requireAdminOverride()) {
                                    this._ageOverrideCallbackID = this.ubMgr.currentUBSession.userBrowsingID
                                        + '_' + this.formModel.participant.userID
                                        + '_' + this.selectedProduct.sessionProductDetailID;
                                    this.common.$rootScope.$broadcast(Events.ShowRegFlowAdminOverridePopup, {
                                        initDataObj: {
                                            callbackID: this._ageOverrideCallbackID,
                                            overrideReqs: this.getAdminOverrideReqs(false),
                                        },
                                        size: Pulse.Common.BasePopup.ModalSize.Medium,
                                    });
                                }
                                else if (participantAlreadyInCart) {
                                    this.common.showWarning('Already in Cart.  Please select a different student.');
                                }
                                if (this.resetStep) {
                                    this.pulsePass.reset();
                                }
                            };
                            Object.defineProperty(AvcRegistrationFormCtrl.prototype, "isFormValid", {
                                get: function () {
                                    return this.form.$valid;
                                },
                                enumerable: false,
                                configurable: true
                            });
                            AvcRegistrationFormCtrl.prototype.getParentsEmailLabel = function () {
                                return this.drawerStyle.is2022Design ? '' : "PARENT'S EMAIL";
                            };
                            AvcRegistrationFormCtrl.prototype.getStudentsLabel = function () {
                                return this.drawerStyle.is2022Design ? '' : "STUDENT'S INFO";
                            };
                            AvcRegistrationFormCtrl.prototype.isEmailFieldsetEditable = function () {
                                return !this.formDisabled;
                            };
                            AvcRegistrationFormCtrl.prototype.areNonEmailFieldsetsEditable = function () {
                                return !(!(this.form.contactEmail && this.form.contactEmail.$valid) || this.formDisabled);
                            };
                            AvcRegistrationFormCtrl.prototype.isParticipantInfoEditable = function () {
                                return this.areNonEmailFieldsetsEditable() && !this.isChangeOrder;
                            };
                            AvcRegistrationFormCtrl.prototype.newParticipantTemplate = function () {
                                return this.ubMgr.createNewRegFlowUserBrowsingDTO(this.pulseContext.shoppingCartType);
                            };
                            AvcRegistrationFormCtrl.prototype.isUserLoggedIn = function () {
                                return this.pulseContext.isLoggedIn;
                            };
                            AvcRegistrationFormCtrl.prototype.isAlreadyInCart = function (participant) {
                                var isOpl = this.drawerToggleService.drawerProducts.mainProduct.catalogTypeID == Enums.SalesCatalogType.OPLThemed || this.drawerToggleService.drawerProducts.mainProduct.catalogTypeID == Enums.SalesCatalogType.OPLGeneric;
                                if (isOpl)
                                    return false;
                                return participant
                                    && this.ubMgr.hasParticipantProdInCart(this.ubMgr.currentUBSession, participant, this.drawerToggleService.drawerProducts.mainProduct);
                            };
                            AvcRegistrationFormCtrl.prototype.isAllowedSubmit = function () {
                                return this.form.$valid || this.pulseContext.isImpersonating;
                            };
                            AvcRegistrationFormCtrl.prototype.adminOverridePopupClosed = function (event, data) {
                                var _this = this;
                                if (data && data[0] && data[0].callbackID && data[0].callbackID == this._ageOverrideCallbackID) {
                                    this.form.$setDirty();
                                    var immediateID_1 = this.common.$window.setImmediate(function () {
                                        _this.submitForm();
                                        _this.common.$window.clearImmediate(immediateID_1);
                                    });
                                }
                            };
                            AvcRegistrationFormCtrl.prototype.requireAdminOverride = function (refreshCache) {
                                if (refreshCache === void 0) { refreshCache = false; }
                                var isRequired = false;
                                if (this.pulseContext.canOverrideRegFlowRestrictions) {
                                    var overrideReqs = this.getAdminOverrideReqs(refreshCache);
                                    if (overrideReqs && overrideReqs.length)
                                        isRequired = true;
                                }
                                return isRequired;
                            };
                            AvcRegistrationFormCtrl.prototype.getAdminOverrideReqs = function (refreshCache) {
                                if (refreshCache === void 0) { refreshCache = false; }
                                if (refreshCache) {
                                    this._overrideReqs = [];
                                    this._overrideReqs = this._overrideReqs.concat(this.regFormService.getProductAdminOverrideReqs(this.formModel.participant, [this.selectedProduct]));
                                    this._overrideReqs = this._overrideReqs.concat(this.regFormService.getOptionAdminOverrideReqs(this.formModel.participant, this.selectedProduct, this.formModel.options));
                                }
                                return this._overrideReqs;
                            };
                            AvcRegistrationFormCtrl.prototype.updateUserEmailAddress = function (newEmail) {
                                Pulse.Utils.ClickTracking.setTrackingCookie(newEmail);
                                var promise;
                                if (this.ubMgr.currentUBSession.userBrowsingDTO.emailAddress !== newEmail) {
                                    this.ubMgr.currentUBSession.userBrowsingDTO.emailAddress = newEmail;
                                    promise = this.ubMgr.updateCurrentUserBrowsing(this.ubMgr.currentUBSession);
                                }
                                else
                                    promise = this.common.$q.resolve(this.ubMgr.currentUBSession.userBrowsingDTO);
                                return promise;
                            };
                            AvcRegistrationFormCtrl.prototype.initFormModel = function () {
                                var _this = this;
                                var email = this.ubMgr.currentUBSession.userBrowsingDTO.emailAddress || "";
                                this.formModel = {
                                    emailAddress: email ? email : '',
                                    options: [],
                                    participant: null,
                                    groupWithBeginners: this.groupWithBeginners,
                                    selectedCrossSellProds: [],
                                };
                                if (String.isNullOrWhitespace(this.formModel.emailAddress)) {
                                    this.populateEmailFrom3rdPartyAuth();
                                }
                                this.isChangeOrder = this.regFormService.isChangeOrderCart();
                                if (this.isChangeOrder) {
                                    this.ubMgr.getParticipantToMakeChangeFor(this.ubMgr.currentUBSession)
                                        .then(function (p) {
                                        _this.formModel.participant = p;
                                    });
                                }
                                else {
                                    this.formModel.participant = {};
                                }
                            };
                            AvcRegistrationFormCtrl.prototype.populateEmailFrom3rdPartyAuth = function (defaultValue) {
                                var _this = this;
                                if (defaultValue === void 0) { defaultValue = ""; }
                                Pulse.Utils.GoogleAuthUtil.GetAuthInstance(this.common.config.googleAPI_ClientID)
                                    .then(function (googleAuthInst) {
                                    if (googleAuthInst.isSignedIn.get()) {
                                        _this.formModel.emailAddress = googleAuthInst.currentUser.get().getBasicProfile().getEmail();
                                    }
                                    else {
                                        _this.formModel.emailAddress = defaultValue;
                                    }
                                    if (!String.isNullOrWhitespace(_this.formModel.emailAddress)) {
                                        _this.processEmailChange(_this.formModel.emailAddress, true);
                                    }
                                }).catch(function (e) {
                                    _this.formModel.emailAddress = defaultValue;
                                });
                            };
                            AvcRegistrationFormCtrl.prototype.initAvailabilityStatus = function () {
                                var showStatuses = [
                                    Enums.SessionAvailabilityStatus.Space1,
                                    Enums.SessionAvailabilityStatus.Space2,
                                    Enums.SessionAvailabilityStatus.Space3,
                                    Enums.SessionAvailabilityStatus.Space4,
                                ];
                                this.isShowAvailStatus = showStatuses.indexOf(this.selectedProduct.statusOptions.id) >= 0;
                            };
                            AvcRegistrationFormCtrl.prototype.getAvailStatus = function () {
                                return "Only " + this.selectedProduct.statusOptions.displayName;
                            };
                            Object.defineProperty(AvcRegistrationFormCtrl.prototype, "divisionAbbr", {
                                get: function () {
                                    var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, this.mainProduct.divisionID);
                                    return div ? div.abbr : "";
                                },
                                enumerable: false,
                                configurable: true
                            });
                            return AvcRegistrationFormCtrl;
                        }(ComponentController));
                        Components.AvcRegistrationFormCtrl = AvcRegistrationFormCtrl;
                        Pulse.app.component(AvcRegistrationForm.registerAs, new AvcRegistrationForm());
                    })(Components = AvChart.Components || (AvChart.Components = {}));
                })(AvChart = Views.AvChart || (Views.AvChart = {}));
            })(Views = RegistryFlow.Views || (RegistryFlow.Views = {}));
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var DrawerStyle = Pulse.Controllers.DrawerStyle;
            var AvcParticipantForm = (function (_super) {
                __extends(AvcParticipantForm, _super);
                function AvcParticipantForm() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        editEnabled: '&?',
                        formName: '@',
                        fieldSetName: '@?',
                        mainProduct: '<',
                        newParticipantTemplate: '&?',
                        participant: '=',
                        participantInCart: '&?',
                        product: '<',
                        userLinkedParticipants: '<',
                        groupWithBeginners: '=?',
                        drawerStyle: '<?'
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'av-chart/components/drawer/forms/fieldsets/idp-avc-participant-form.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'common',
                        'RegisterFormService',
                        function ($scope, $element, pulseContext, common, regFormService) {
                            return new AvcParticipantFormCtrl($scope, $element, pulseContext, common, regFormService);
                        }
                    ];
                    return _this;
                }
                AvcParticipantForm.registeredAs = 'idpAvcParticipantForm';
                return AvcParticipantForm;
            }(ComponentOptions));
            RegistryFlow.AvcParticipantForm = AvcParticipantForm;
            var AvcParticipantFormCtrl = (function (_super) {
                __extends(AvcParticipantFormCtrl, _super);
                function AvcParticipantFormCtrl($scope, $element, pulseContext, common, regFormService) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.canEditParticipant = false;
                    _this.hasAgeAdminOverride = false;
                    _this.groupWithBeginners = false;
                    _this.common = common;
                    _this.pulseContext = pulseContext;
                    _this.regFormService = regFormService;
                    _this.editEnabled = function () { return true; };
                    _this.participantInCart = function (obj) { return false; };
                    _this.$scope.$on(Events.AdminOverrideAdded, function (e, data) {
                        _this.checkHasAgeAdminOverride();
                    });
                    var unbindParticipantWatcher = _this.$scope.$watch(function (scope) {
                        return _this.participant;
                    }, function (newVal, oldVal) {
                        if (!!newVal) {
                            unbindParticipantWatcher();
                            if (!_this.participant.userBrowsingID) {
                                _this.participant = _this.newParticipantTemplate();
                                _this.canEditParticipant = true;
                            }
                            else {
                                _this.selectedParticipant = _this.participant;
                                _this.canEditParticipant = false;
                            }
                            _this.checkHasAgeAdminOverride();
                        }
                    });
                    return _this;
                }
                Object.defineProperty(AvcParticipantFormCtrl.prototype, "form", {
                    get: function () {
                        return this.$scope[this.formName];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcParticipantFormCtrl.prototype, "minDisplayDate", {
                    get: function () {
                        return this._minDisplayDate
                            || (this._minDisplayDate = this.regFormService.getMinDisplayDateForDOB(this.product));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcParticipantFormCtrl.prototype, "maxDisplayDate", {
                    get: function () {
                        return this._maxDisplayDate
                            || (this._maxDisplayDate = this.regFormService.getMaxDisplayDateForDOB(this.product));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcParticipantFormCtrl.prototype, "minValidBirthDate", {
                    get: function () {
                        return this._minValidBirthDate
                            || (this._minValidBirthDate = this.regFormService.getMinDateOfBirth(this.product));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcParticipantFormCtrl.prototype, "maxValidBirthDate", {
                    get: function () {
                        return this._maxValidBirthDate
                            || (this._maxValidBirthDate = this.regFormService.getMaxDateOfBirth(this.product));
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcParticipantFormCtrl.prototype.$onInit = function () {
                    if (this.drawerStyle === undefined)
                        this.drawerStyle = new DrawerStyle('');
                };
                AvcParticipantFormCtrl.prototype.checkHasAgeAdminOverride = function () {
                    if (this.pulseContext.canOverrideRegFlowRestrictions && this.participant) {
                        var ageOverride = {
                            child_UB_ID: this.participant.userBrowsingID,
                            locationID: this.product.locationID,
                            productID: this.product.productID,
                            scheduleDefID: this.product.scheduleDefID,
                            sessionID: this.product.sessionID,
                            sessionProductDetailID: this.product.sessionProductDetailID
                        };
                        var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        this.hasAgeAdminOverride = userBrowsingMgr.hasAdminOverride(userBrowsingMgr.currentUBSession, ageOverride);
                    }
                    else {
                        this.hasAgeAdminOverride = false;
                    }
                };
                AvcParticipantFormCtrl.prototype.getFullName = function (participant) {
                    return participant.firstName + " " + participant.lastName;
                };
                Object.defineProperty(AvcParticipantFormCtrl.prototype, "nameColumnClass", {
                    get: function () {
                        return this.drawerStyle.is2022Design ? 'col-sm-12' : 'col-sm-6';
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcParticipantFormCtrl.prototype.selectParticipant = function () {
                    if (!this.selectedParticipant) {
                        this.participant = this.newParticipantTemplate();
                        this.canEditParticipant = true;
                    }
                    else if (this.participant !== this.selectedParticipant) {
                        this.participant = this.selectedParticipant;
                        this.canEditParticipant = false;
                    }
                    this.checkHasAgeAdminOverride();
                    this.onGenderChanged();
                };
                AvcParticipantFormCtrl.prototype.openGroupWithBeginnersPopup = function ($event) {
                    $event.preventDefault();
                    this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Group With Beginners", Pulse.Directives.HelpPopup.HelpTopic.GroupWithBeginnersHelp, "groupWithBeginnersPopup", null, Pulse.Common.BasePopup.ModalSize.Medium, 'spa-help-popup');
                };
                AvcParticipantFormCtrl.prototype.isOPL = function () {
                    var _a, _b;
                    return ((_a = this.product) === null || _a === void 0 ? void 0 : _a.catalogTypeID) == Enums.SalesCatalogType.OPLGeneric || ((_b = this.product) === null || _b === void 0 ? void 0 : _b.catalogTypeID) == Enums.SalesCatalogType.OPLThemed;
                };
                AvcParticipantFormCtrl.prototype.onGenderChanged = function () {
                    var _this = this;
                    var changeTimer = this.common.$timeout(function () {
                        _this.common.$timeout.cancel(changeTimer);
                        if (_this.product.programTypeID == Enums.DivisionProgramType.AlexaCafe
                            && _this.participant.genderTypeID == Enums.GenderType.Male) {
                            _this.common.showMessagePopup("A note about Alexa Café", "<strong>Note:</strong> With a focus on female leadership and social impact, Alexa Café is specially designed to spark girls’ love of tech and bridge the gender gap in STEM. The program fosters friendship and collaboration in a fresh, inviting setting. All genders are welcome to attend.");
                        }
                    }, 5);
                };
                return AvcParticipantFormCtrl;
            }(ComponentController));
            RegistryFlow.AvcParticipantFormCtrl = AvcParticipantFormCtrl;
            Pulse.app.component(AvcParticipantForm.registeredAs, new AvcParticipantForm());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistrationFlow;
        (function (RegistrationFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var DrawerStyle = Pulse.Controllers.DrawerStyle;
            var AvcContactEmail = (function (_super) {
                __extends(AvcContactEmail, _super);
                function AvcContactEmail() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        editEnabled: '&?',
                        emailAddress: '=',
                        formName: '@',
                        fieldSetName: '@?',
                        onChange: '&?',
                        placeholder: '@?',
                        readonly: '&?',
                        drawerStyle: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) { return config.appRoot
                            + Paths.PulsePublicRegistryFlow
                            + 'av-chart/components/drawer/forms/fieldsets/idp-avc-contact-email.html'; },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'common',
                        function ($scope, $element, common) { return new AvcContactEmailCtrl($scope, $element, common); },
                    ];
                    return _this;
                }
                AvcContactEmail.registeredAs = 'idpAvcContactEmail';
                return AvcContactEmail;
            }(ComponentOptions));
            RegistrationFlow.AvcContactEmail = AvcContactEmail;
            var AvcContactEmailCtrl = (function (_super) {
                __extends(AvcContactEmailCtrl, _super);
                function AvcContactEmailCtrl($scope, $element, common) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.common = common;
                    _this.editEnabled = function () { return true; };
                    _this.onChange = function (obj) { return; };
                    return _this;
                }
                AvcContactEmailCtrl.prototype.$onInit = function () {
                    _super.prototype.$onInit.call(this);
                    if (this.drawerStyle === undefined)
                        this.drawerStyle = new DrawerStyle('');
                };
                AvcContactEmailCtrl.prototype.$postLink = function () {
                    _super.prototype.$postLink.call(this);
                    if (this.emailAddress) {
                        this.processChange();
                    }
                };
                Object.defineProperty(AvcContactEmailCtrl.prototype, "form", {
                    get: function () {
                        return this.$scope[this.formName];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcContactEmailCtrl.prototype, "focusOnEmail", {
                    get: function () {
                        return !this.common.isMobileView && (!this.emailAddress || this.emailAddress.trim() === '');
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcContactEmailCtrl.prototype.processChange = function () {
                    if (this.onChange) {
                        this.onChange({
                            emailAddress: this.emailAddress,
                            isValid: this.isEmailAddressValid,
                        });
                    }
                };
                Object.defineProperty(AvcContactEmailCtrl.prototype, "isEmailAddressValid", {
                    get: function () {
                        return this.form.emailAddress && this.form.emailAddress.$valid;
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcContactEmailCtrl.controllerId = 'AVCContactInfoDirCtrl';
                return AvcContactEmailCtrl;
            }(ComponentController));
            RegistrationFlow.AvcContactEmailCtrl = AvcContactEmailCtrl;
            Pulse.app.component(AvcContactEmail.registeredAs, new AvcContactEmail());
        })(RegistrationFlow = PulsePublic.RegistrationFlow || (PulsePublic.RegistrationFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var ProductCategoryType = Pulse.Common.Enums.ProductCategoryType;
            var RelatedProductType = Pulse.Common.Enums.RelatedProductType;
            var ProductSubCategoryType = Pulse.Common.Enums.ProductSubCategoryType;
            var AgeMgr = Pulse.Common.DataAccess.Managers.AgeMgr;
            var AvcProductOptionsForm = (function (_super) {
                __extends(AvcProductOptionsForm, _super);
                function AvcProductOptionsForm() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        editEnabled: '&?',
                        formName: '@',
                        legend: '@?',
                        mainProduct: '<',
                        participant: '<?',
                        product: '<',
                        selectedOptions: '=',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) { return config.appRoot
                            + Paths.PulsePublicRegistryFlow
                            + 'av-chart/components/drawer/forms/fieldsets/idp-avc-product-options-form.html'; },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'common',
                        'pulseContextService',
                        'AvailChartMgr',
                        'DrawerToggleService',
                        function ($scope, $element, common, pulseContextService, avcMgr, drawerMgr) {
                            return new AvcProductOptionsFormCtrl($scope, $element, common, pulseContextService, avcMgr, drawerMgr);
                        },
                    ];
                    return _this;
                }
                AvcProductOptionsForm.registerAs = 'idpAvcProductOptionsForm';
                return AvcProductOptionsForm;
            }(ComponentOptions));
            RegistryFlow.AvcProductOptionsForm = AvcProductOptionsForm;
            var AvcProductOptionsFormCtrl = (function (_super) {
                __extends(AvcProductOptionsFormCtrl, _super);
                function AvcProductOptionsFormCtrl($scope, $element, common, pulseContextService, avcMgr, drawerMgr) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.OptionDisabledCauses = OptionDisabledCauses;
                    _this.common = common;
                    _this.pulseContext = pulseContextService;
                    _this.avcMgr = avcMgr;
                    _this.drwMgr = drawerMgr;
                    _this.editEnabled = function () { return true; };
                    _this.groupedProdOptions = [];
                    _this.selectedOptions = [];
                    $scope.$watch(function () { return _this.participant; }, function (newP, prevP) {
                        _this.groupedProdOptions.forEach(function (g) {
                            g.options.forEach(function (o) {
                                o.disabledCauses = _this.getOptionDisabledCauses(o.props, newP);
                                o.state = (o.state || o.required) && !o.disabledCauses.length;
                            });
                        });
                        _this.updateSelectedOptions();
                    }, true);
                    return _this;
                }
                AvcProductOptionsFormCtrl.prototype.$onInit = function () {
                    var _this = this;
                    this.pulseContext.lookupInfoMgr
                        .loadTypeInfo(Enums.TypeClassType.CourseOptionGroup)
                        .then(function (data) {
                        _this.optionGroups = data;
                        if (_this.product.options) {
                            _this.groupedProdOptions = _this.getGroupedProductOptionUI(_this.product.options, _this.optionGroups);
                            _this.updatePreselectedOptionsUIState();
                            _this.updateSelectedOptions();
                        }
                    });
                };
                Object.defineProperty(AvcProductOptionsFormCtrl.prototype, "form", {
                    get: function () {
                        return this.$scope[this.formName];
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcProductOptionsFormCtrl.prototype.toggleOptionInfoPopup = function (option, parentID) {
                    this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.OptionInfo, option.props.name, option.props.description, parentID);
                };
                AvcProductOptionsFormCtrl.prototype.getOptionName = function (option) {
                    return option.productSubCatTypeID === Enums.ProductSubCategoryType.CoursePreparation
                        ? option.name + ': ' + this.product.name
                        : option.name;
                };
                AvcProductOptionsFormCtrl.prototype.getCurrencyType = function (option) {
                    return option.currencyTypeID != undefined ? option.currencyTypeID : Enums.CurrencyType.USD;
                };
                AvcProductOptionsFormCtrl.prototype.isOptionDisabled = function (uiOption) {
                    return uiOption.required
                        || !this.editEnabled()
                        || (uiOption.disabledCauses.length && !this.pulseContext.canOverrideRegFlowRestrictions);
                };
                AvcProductOptionsFormCtrl.prototype.hasDisabledCause = function (uiOption, cause) {
                    return uiOption.disabledCauses.indexOf(OptionDisabledCauses[cause]) !== -1;
                };
                AvcProductOptionsFormCtrl.prototype.showOptionUnavailableDetailPopup = function (option, cause) {
                    this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.OptionInfo, '', this.getOptionUnavailableMessage(option.props, OptionDisabledCauses[cause]), '');
                };
                AvcProductOptionsFormCtrl.prototype.getOptionUnavailableMessage = function (option, cause) {
                    var message = '';
                    message = "We apologize but the \"" + option.name + "\" add-on is no longer available for purchase this session. ";
                    if (cause === OptionDisabledCauses.MealAddDateClosed) {
                        var a = option.productSubCatTypeID === ProductSubCategoryType.Lunch ? 'lunch' : 'meals';
                        message += "<strong>Students must bring a " + a + " from home.</strong>";
                    }
                    return message;
                };
                AvcProductOptionsFormCtrl.prototype.updateSelectedOptions = function () {
                    var _this = this;
                    this.selectedOptions = this.groupedProdOptions
                        .reduce(function (options, g) { return options.concat(g.options); }, [])
                        .filter(function (p) {
                        return p.state && (!p.disabledCauses.length || _this.pulseContext.canOverrideRegFlowRestrictions);
                    })
                        .map(function (p) {
                        return p.props;
                    });
                };
                AvcProductOptionsFormCtrl.prototype.updatePreselectedOptionsUIState = function () {
                    var _this = this;
                    if (this.selectedOptions && this.selectedOptions.length)
                        this.groupedProdOptions.forEach(function (g) {
                            g.options.forEach(function (o) {
                                o.state = _this.selectedOptions
                                    .reduce(function (state, option) { return (state || o.props.name === option.name); }, false);
                            });
                        });
                };
                AvcProductOptionsFormCtrl.prototype.getGroupedProductOptionUI = function (options, optionGroups) {
                    var _this = this;
                    var ageValidOptions = options.filter(function (o) {
                        return !(o.minAge && o.minAge > _this.mainProduct.maximumAge
                            || o.maxAge && o.maxAge < _this.mainProduct.minimumAge);
                    });
                    var groupedOptions = [];
                    var groupedOptionsIds = optionGroups.map(function (og) { return og.typeID; });
                    var ungroupedOptions = ageValidOptions
                        .filter(function (option) {
                        return !option.productSubCatGroupID || groupedOptionsIds.indexOf(option.productSubCatGroupID) === -1;
                    });
                    if (ungroupedOptions.length)
                        groupedOptions.push(this.getGroupedProductOptionsUI({ typeString: this.legend ? this.legend : '' }, ungroupedOptions));
                    optionGroups.forEach(function (optionGroup) {
                        var groupFilteredOptions = ageValidOptions
                            .filter(function (option) { return option.productSubCatGroupID === optionGroup.typeID; });
                        if (groupFilteredOptions.length)
                            groupedOptions.push(_this.getGroupedProductOptionsUI(optionGroup, groupFilteredOptions));
                    });
                    return groupedOptions;
                };
                AvcProductOptionsFormCtrl.prototype.getGroupedProductOptionsUI = function (optionGroup, options) {
                    var _this = this;
                    return {
                        optionGroup: optionGroup,
                        options: options.map(function (option) { return _this.buildUIOption(option); }),
                    };
                };
                AvcProductOptionsFormCtrl.prototype.buildUIOption = function (option, participant) {
                    if (participant === void 0) { participant = null; }
                    var disabledCauses = this.getOptionDisabledCauses(option, participant);
                    var required = option.relatedProductTypeID === RelatedProductType.Required;
                    return {
                        disabledCauses: disabledCauses,
                        props: option,
                        required: required,
                        state: required && !disabledCauses.length
                    };
                };
                AvcProductOptionsFormCtrl.prototype.getOptionDisabledCauses = function (option, participant) {
                    var disabledCauses = [];
                    if (option.productCategoryTypeID === ProductCategoryType.Meal) {
                        if (this.avcMgr.isSessionClosedForAddingMeal(this.drwMgr.locationSessionInfo)) {
                            disabledCauses.push(OptionDisabledCauses.MealAddDateClosed);
                        }
                    }
                    else if (option.productCategoryTypeID === ProductCategoryType.Residency) {
                        if (this.avcMgr.isSessionClosedForAddingResidency(this.drwMgr.locationSessionInfo)) {
                            disabledCauses.push(OptionDisabledCauses.ResidencyAddDateClosed);
                        }
                    }
                    if (participant && participant.dateOfBirth && !this.isAgeCheckValid(option, participant.dateOfBirth)) {
                        disabledCauses.push(OptionDisabledCauses.AgeRequirementNotMeet);
                    }
                    return disabledCauses;
                };
                AvcProductOptionsFormCtrl.prototype.isAgeCheckValid = function (option, dateOfBirth) {
                    return AgeMgr.isDOB_WithinAgeRangeByDateInterval(dateOfBirth, option.minAge, option.maxAge, option.minDateForAgeCheck ? option.minDateForAgeCheck : this.product.minDateForAgeCheck, option.maxDateForAgeCheck ? option.maxDateForAgeCheck : this.product.maxDateForAgeCheck);
                };
                return AvcProductOptionsFormCtrl;
            }(ComponentController));
            RegistryFlow.AvcProductOptionsFormCtrl = AvcProductOptionsFormCtrl;
            var OptionDisabledCauses;
            (function (OptionDisabledCauses) {
                OptionDisabledCauses["MealAddDateClosed"] = "MealAddDateClosed";
                OptionDisabledCauses["ResidencyAddDateClosed"] = "ResidencyAddDateClosed";
                OptionDisabledCauses["AgeRequirementNotMeet"] = "AgeRequirementNotMeet";
            })(OptionDisabledCauses = RegistryFlow.OptionDisabledCauses || (RegistryFlow.OptionDisabledCauses = {}));
            Pulse.app.component(AvcProductOptionsForm.registerAs, new AvcProductOptionsForm());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var ProductAddonsForm = (function (_super) {
                __extends(ProductAddonsForm, _super);
                function ProductAddonsForm() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        editEnabled: '&?',
                        formName: '@',
                        legend: '@?',
                        mainProduct: '<',
                        participant: '<?',
                        product: '<',
                        addonProducts: '<',
                        selectedOptions: '=',
                        drawerStyle: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) { return config.appRoot
                            + Paths.PulsePublicRegistryFlow
                            + 'av-chart/components/drawer/forms/fieldsets/idp-product-addons-form.html'; },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'common',
                        'pulseContextService',
                        'AvailChartMgr',
                        'DrawerToggleService',
                        function ($scope, $element, common, pulseContextService, avcMgr, drawerMgr) {
                            return new ProductAddonsFormCtrl($scope, $element, common, pulseContextService, avcMgr, drawerMgr);
                        },
                    ];
                    return _this;
                }
                ProductAddonsForm.registerAs = 'idpProductAddonsForm';
                return ProductAddonsForm;
            }(ComponentOptions));
            RegistryFlow.ProductAddonsForm = ProductAddonsForm;
            var ProductAddonsFormCtrl = (function (_super) {
                __extends(ProductAddonsFormCtrl, _super);
                function ProductAddonsFormCtrl($scope, $element, common, pulseContextService, avcMgr, drawerMgr) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.OptionDisabledCauses = RegistryFlow.OptionDisabledCauses;
                    _this.common = common;
                    _this.pulseContext = pulseContextService;
                    _this.editEnabled = function () { return true; };
                    _this.groupedProdOptions = [];
                    _this.selectedOptions = [];
                    $scope.$watch(function (scope) {
                        return _this.addonProducts;
                    }, function (newVal, oldVal) {
                        if (!newVal)
                            return;
                        _this.requiredAddonProducts = _this.addonProducts.filter(function (p) { return p.relatedProductTypeID == Enums.RelatedProductType.Required
                            && p.currencyTypeID == _this.product.currencyTypeID; });
                        _this.standardAddonProducts = _this.addonProducts.filter(function (p) { return p.relatedProductTypeID == Enums.RelatedProductType.StandardOptionalProduct
                            && p.currencyTypeID == _this.product.currencyTypeID; });
                        _this.updateSelectedOptions();
                    }, true);
                    return _this;
                }
                ProductAddonsFormCtrl.prototype.$onInit = function () {
                };
                Object.defineProperty(ProductAddonsFormCtrl.prototype, "form", {
                    get: function () {
                        return this.$scope[this.formName];
                    },
                    enumerable: false,
                    configurable: true
                });
                ProductAddonsFormCtrl.prototype.getProdThumbUrl = function (prod) {
                    var url = prod.prodUrls.filter(function (u) { return u.usageTypeID == Enums.ProductURLType.CourseVideoIntroImageURL; });
                    if (url.length > 0) {
                        return this.thumbnailFullUrl(url[0].uRL);
                    }
                    return "";
                };
                ProductAddonsFormCtrl.prototype.thumbnailFullUrl = function (imgUrl) {
                    if (!imgUrl)
                        return "";
                    var result = this.common.config.courseVideoThumbnailUrl + "/";
                    var thumbnailSegments = imgUrl.split(".");
                    result += thumbnailSegments[0] + "_s." + thumbnailSegments[1];
                    return result;
                };
                ProductAddonsFormCtrl.prototype.updateSelectedOptions = function () {
                    this.addonProducts.forEach(function (p) {
                        if (p.relatedProductTypeID == Enums.RelatedProductType.Required) {
                            p.isSelected = true;
                        }
                    });
                    this.selectedOptions = this.addonProducts ?
                        this.addonProducts
                            .filter(function (p) { return p.isSelected; })
                            .map(function (key, index) {
                            var opt = {
                                activityDesc: '',
                                description: key.description,
                                maxAge: key.maximumAge,
                                minAge: key.minimumAge,
                                name: key.name,
                                price: key.locationPrice,
                                prodID: key.productID,
                                productCategoryTypeID: key.catalogTypeID,
                                takeHomeDesc: '',
                                toolsUsed: ''
                            };
                            return opt;
                        })
                        : null;
                };
                ProductAddonsFormCtrl.prototype.isOptionDisabled = function (uiOption) {
                    return !this.editEnabled();
                };
                return ProductAddonsFormCtrl;
            }(ComponentController));
            RegistryFlow.ProductAddonsFormCtrl = ProductAddonsFormCtrl;
            Pulse.app.component(ProductAddonsForm.registerAs, new ProductAddonsForm());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcCrossSellProdForm = (function (_super) {
                __extends(AvcCrossSellProdForm, _super);
                function AvcCrossSellProdForm() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        editEnabled: '&?',
                        formName: '@',
                        legend: '@?',
                        participant: '<?',
                        mainProduct: '<?',
                        crossSellProds: '<',
                        selectedProducts: '=',
                        drawerStyle: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) { return config.appRoot
                            + Paths.PulsePublicRegistryFlow
                            + 'av-chart/components/drawer/forms/fieldsets/idp-avc-cross-sell-prod-form.html'; },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'common',
                        'pulseContextService',
                        'AvailChartMgr',
                        'DrawerToggleService',
                        function ($scope, $element, common, pulseContextService, avcMgr, drawerMgr) {
                            return new AvcCrossSellProdFormCtrl($scope, $element, common, pulseContextService, avcMgr, drawerMgr);
                        },
                    ];
                    return _this;
                }
                AvcCrossSellProdForm.registerAs = 'idpAvcCrossSellProdForm';
                return AvcCrossSellProdForm;
            }(ComponentOptions));
            RegistryFlow.AvcCrossSellProdForm = AvcCrossSellProdForm;
            var AvcCrossSellProdFormCtrl = (function (_super) {
                __extends(AvcCrossSellProdFormCtrl, _super);
                function AvcCrossSellProdFormCtrl($scope, $element, common, pulseContextService, avcMgr, drawerMgr) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.OptionDisabledCauses = RegistryFlow.OptionDisabledCauses;
                    _this.common = common;
                    _this.pulseContext = pulseContextService;
                    _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                    _this.editEnabled = function () { return true; };
                    _this.selectedProducts = [];
                    _this.isShowMoreDesc = false;
                    _this.drawerMgr = drawerMgr;
                    $scope.$watch(function (scope) {
                        return _this.crossSellProds;
                    }, function (newVal, oldVal) {
                        if (!newVal)
                            return;
                        _this.updateCrossSellProds();
                    }, true);
                    $scope.$watch(function (scope) {
                        return _this.participant;
                    }, function (newVal, oldVal) {
                        if (!newVal || _this.crossSellProds == null)
                            return;
                        _this.updateCrossSellProds();
                    }, true);
                    return _this;
                }
                AvcCrossSellProdFormCtrl.prototype.updateCrossSellProds = function () {
                    var _this = this;
                    if (this.crossSellProds == null)
                        return;
                    this.common.$timeout(function () {
                        _this.crossSellTutorProds = _this.crossSellProds.filter(function (p) { return p.productCategoryTypeID == Enums.ProductCategoryType.Tutor && _this.isShowProd(p); });
                        _this.crossSellOtherProds = _this.crossSellProds.filter(function (p) { return p.productCategoryTypeID != Enums.ProductCategoryType.Tutor && _this.isShowProd(p); });
                    });
                    this.updateSelectedOptions();
                };
                AvcCrossSellProdFormCtrl.prototype.$onInit = function () {
                    _super.prototype.$onInit.call(this);
                };
                Object.defineProperty(AvcCrossSellProdFormCtrl.prototype, "form", {
                    get: function () {
                        return this.$scope[this.formName];
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcCrossSellProdFormCtrl.prototype.getProdThumbUrl = function (prod, isLarge) {
                    if (isLarge === void 0) { isLarge = false; }
                    var url = prod.uRLs.filter(function (u) { return u.usageTypeID == Enums.ProductURLType.CourseVideoIntroImageURL; });
                    if (url.length > 0 && url[0].uRL) {
                        return Pulse.Utils.JS.composeProductThumbNailFullUrl(this.common.config.courseVideoThumbnailUrl, url[0].uRL, isLarge);
                    }
                    return "";
                };
                AvcCrossSellProdFormCtrl.prototype.updateSelectedOptions = function (prod) {
                    var _this = this;
                    if (prod === void 0) { prod = null; }
                    this.common.$timeout(function () {
                        if (prod) {
                            _this.crossSellProds.forEach(function (p) {
                                if ((p !== prod) && (p.prodID == prod.prodID))
                                    p.isSelected = prod.isSelected;
                            });
                        }
                        _this.selectedProducts = _this.crossSellProds ?
                            _this.crossSellProds
                                .filter(function (p) { return p.isSelected; })
                            : null;
                    }, 0);
                };
                AvcCrossSellProdFormCtrl.prototype.isTutoringProduct = function (prod) {
                    return prod.name.indexOf('Jump Start') > 0;
                };
                AvcCrossSellProdFormCtrl.prototype.isOptionDisabled = function (prod) {
                    return !this.editEnabled();
                };
                AvcCrossSellProdFormCtrl.prototype.isShow = function () {
                    if (!this.crossSellProds || !this.crossSellProds.length)
                        return false;
                    for (var _i = 0, _a = this.crossSellProds; _i < _a.length; _i++) {
                        var prod = _a[_i];
                        if (this.isShowProd(prod))
                            return true;
                    }
                    return false;
                };
                AvcCrossSellProdFormCtrl.prototype.isShowProd = function (prod) {
                    return !this.userBrowsingMgr.hasParticipantProdInCart(this.userBrowsingMgr.currentUBSession, this.participant, {
                        productID: prod.prodID,
                        catalogTypeID: prod.catalogTypeID,
                    }) && prod.currencyTypeID == this.drawerMgr.productCurrencyTypeID;
                };
                AvcCrossSellProdFormCtrl.prototype.isProdOpl = function (prod) {
                    return prod.catalogTypeID == Enums.SalesCatalogType.OPLGeneric || prod.catalogTypeID == Enums.SalesCatalogType.OPLGeneric;
                };
                AvcCrossSellProdFormCtrl.prototype.getHtmlPopover = function (prod) {
                    var image = this.isProdOpl(prod) ? '' : "<img src=\"" + this.getProdThumbUrl(prod, true) + "\" style=\"width:200px; max-width:200px;\" />";
                    return image + "<div>" + prod.description + "</div>";
                };
                AvcCrossSellProdFormCtrl.prototype.hasAtLeastOneProd = function (products) {
                    var _this = this;
                    return products.some(function (p) { return _this.isShowProd(p) === true; });
                };
                return AvcCrossSellProdFormCtrl;
            }(ComponentController));
            RegistryFlow.AvcCrossSellProdFormCtrl = AvcCrossSellProdFormCtrl;
            Pulse.app.component(AvcCrossSellProdForm.registerAs, new AvcCrossSellProdForm());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var Views;
            (function (Views) {
                var AvChart;
                (function (AvChart) {
                    var Components;
                    (function (Components) {
                        var ComponentOptions = Pulse.Common.ComponentOptions;
                        var ComponentController = Pulse.Common.ComponentController;
                        var CheckoutBar = (function (_super) {
                            __extends(CheckoutBar, _super);
                            function CheckoutBar() {
                                var _this = _super.call(this) || this;
                                _this.bindings = {
                                    goToCheckoutFn: '&',
                                };
                                _this.templateUrl = [
                                    'config',
                                    function (config) { return config.appRoot
                                        + Paths.PulsePublicRegistryFlow
                                        + 'av-chart/components/idp-avc-checkout-bar.html'; },
                                ];
                                _this.controller = [
                                    '$scope',
                                    '$element',
                                    function ($scope, $element) { return new CheckoutBarCtrl($scope, $element); },
                                ];
                                return _this;
                            }
                            CheckoutBar.registeredAs = 'idpAvcCheckoutBar';
                            return CheckoutBar;
                        }(ComponentOptions));
                        Components.CheckoutBar = CheckoutBar;
                        var CheckoutBarCtrl = (function (_super) {
                            __extends(CheckoutBarCtrl, _super);
                            function CheckoutBarCtrl($scope, $element) {
                                return _super.call(this, $scope, $element) || this;
                            }
                            return CheckoutBarCtrl;
                        }(ComponentController));
                        Components.CheckoutBarCtrl = CheckoutBarCtrl;
                        Pulse.app.component(CheckoutBar.registeredAs, new CheckoutBar());
                    })(Components = AvChart.Components || (AvChart.Components = {}));
                })(AvChart = Views.AvChart || (Views.AvChart = {}));
            })(Views = RegistryFlow.Views || (RegistryFlow.Views = {}));
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var BasePopupCtrl = Pulse.Common.BasePopup.BasePopupCtrl;
            var ModalSize = Pulse.Common.BasePopup.ModalSize;
            var StringConsts = Pulse.Common.Resources.StringConsts;
            var AvcCourseOverlayPopup = (function (_super) {
                __extends(AvcCourseOverlayPopup, _super);
                function AvcCourseOverlayPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        '$uibModal',
                        'AvailChartMgr',
                        AvcCourseOverlayPopupCtrl,
                    ];
                    return _this;
                }
                AvcCourseOverlayPopup.registeredAs = 'idpAvcCourseOverlayPopup';
                return AvcCourseOverlayPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.AvcCourseOverlayPopup = AvcCourseOverlayPopup;
            var AvcCourseOverlayPopupCtrl = (function (_super) {
                __extends(AvcCourseOverlayPopupCtrl, _super);
                function AvcCourseOverlayPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal, availabilityChartMgr) {
                    var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, AvcCourseOverlayPopupCtrl.controllerId) || this;
                    _this.overlay = '';
                    _this.showAgeCheckDate = false;
                    _this.event_ShowPopup = Events.ShowAvcCourseOverlayPopup;
                    _this.acMgr = availabilityChartMgr;
                    _this.popupTemplateUrl = _this.common.config.appRoot
                        + Paths.PulsePublicRegistryFlow
                        + 'av-chart/components/idp-avc-course-overlay-popup.html';
                    return _this;
                }
                AvcCourseOverlayPopupCtrl.prototype.close = function (results) {
                    $('html')
                        .removeClass('no-scroll');
                    _super.prototype.close.call(this);
                };
                AvcCourseOverlayPopupCtrl.prototype.onEvent = function (name, listener) {
                    return undefined;
                };
                AvcCourseOverlayPopupCtrl.prototype.open = function (size, initDataObj) {
                    _super.prototype.open.call(this, size, initDataObj, { windowClass: 'main' });
                };
                AvcCourseOverlayPopupCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                    var _this = this;
                    scope.$on(Events.CloseAllPopups, function () {
                        _this.close();
                    });
                    scope.$on(this.event_ShowPopup, function (e, division, course) {
                        _this.triggerModalCallback(division, course);
                    });
                };
                AvcCourseOverlayPopupCtrl.prototype.triggerModalCallback = function (division, course) {
                    var _this = this;
                    this.division = division;
                    this.course = course;
                    var validAgeCheckTypes = [Enums.AgeCheckType.StartOfCalendarYear, Enums.AgeCheckType.EndOfCalendarYear,
                        Enums.AgeCheckType.StartOfTerm, Enums.AgeCheckType.EndOfTerm,
                        Enums.AgeCheckType.StartOfSession, Enums.AgeCheckType.EndOfSession];
                    this.showAgeCheckDate = validAgeCheckTypes.indexOf(this.division.divMinAgeCalcTypeID) >= 0;
                    if (this.showAgeCheckDate) {
                        this.common.toggleSpinner(true);
                        this.common.$q.all([
                            this.acMgr.getCampProducts(division, course, this.getGenericSessionWithProducts(course)),
                        ])
                            .then(function (result) {
                            _this.open(ModalSize.Full, { products: result[0], overlay: "" });
                        }, function () {
                            _this.common.showError(StringConsts.Err_Failure_Friendly_Msg);
                        })
                            .finally(function () {
                            return _this.common.toggleSpinner(false);
                        });
                    }
                    else {
                        this.open(ModalSize.Full, { products: null, overlay: "" });
                    }
                };
                AvcCourseOverlayPopupCtrl.prototype.getMinAgeCheckDateStr = function (product) {
                    var _a;
                    if (this.division.divMinAgeCalcTypeID == Enums.AgeCheckType.StartOfSession) {
                        return 'start of first class';
                    }
                    return ((_a = this.initDataObj.products.mainProduct) === null || _a === void 0 ? void 0 : _a.minDateForAgeCheck) ? moment(this.initDataObj.products.mainProduct.minDateForAgeCheck).format('l') : '';
                };
                AvcCourseOverlayPopupCtrl.prototype.getThumbNailFullUrl = function (course, largeImage) {
                    if (largeImage === void 0) { largeImage = false; }
                    return Pulse.Common.DataAccess.Managers.AvailChartMgr.GetThumbNailFullUrl(this.common.config, course, largeImage);
                };
                AvcCourseOverlayPopupCtrl.prototype.getGenericSessionWithProducts = function (course) {
                    var validSessions = course.sessions
                        .filter(function (s) { return s.hasCourse; });
                    return validSessions.shift() || null;
                };
                AvcCourseOverlayPopupCtrl.prototype.getCourseOverlayTemplate = function (courseFullUrl) {
                    var _this = this;
                    return this.common.$http.get(courseFullUrl, { params: { minimal: 1 } })
                        .then(function (result) {
                        return _this.common.$q(function (resolve, reject) {
                            if (result.data) {
                                resolve(_this.sanitizeHtml(result.data));
                            }
                            else {
                                reject({ message: 'Not found!' });
                            }
                        });
                    });
                };
                AvcCourseOverlayPopupCtrl.prototype.sanitizeHtml = function (html) {
                    var parser = new OverlayParser(this.common.config.appRoot + Paths.PulsePublicRegistryFlow);
                    return parser.parseOverlay(html);
                };
                AvcCourseOverlayPopupCtrl.prototype.getProductDetailFullUrl = function (course) {
                    var partialUrl = course.uRLs
                        .filter(function (url) {
                        return url.usageTypeID === Enums.ProductURLType.CourseDetailsURL;
                    })
                        .map(function (url) { return url.uRL; })
                        .shift();
                    return this.common.config.WWW_UrlRoot + '/' + (partialUrl ? partialUrl : '');
                };
                AvcCourseOverlayPopupCtrl.controllerId = 'AvcCourseOverlayPopupCtrl';
                return AvcCourseOverlayPopupCtrl;
            }(BasePopupCtrl));
            var OverlayParser = (function () {
                function OverlayParser(registryFlowPath) {
                    this.domParser = new DOMParser();
                    this.registryFlowPath = registryFlowPath;
                }
                OverlayParser.prototype.parseOverlay = function (htmlString) {
                    var overlay = angular.element(this.getDocument(htmlString))
                        .find('body > div.main');
                    this.copyCarousel(overlay);
                    return this.replaceAnchorsWithStatic(this.deleteButtons(overlay))
                        .get(0).outerHTML;
                };
                OverlayParser.prototype.deleteButtons = function (target) {
                    target.find('a.btn:not(.btn-link), a.button')
                        .remove();
                    return target;
                };
                OverlayParser.prototype.copyCarousel = function (target) {
                    var _this = this;
                    var carousel = target.find('.block.photo-carousel .carousel');
                    if (carousel.length) {
                        carousel.find('.carousel-indicators, .carousel-control-next, .carousel-control-prev')
                            .remove();
                        carousel.each(function (i, e) {
                            e.setAttribute('uib-carousel', '');
                            e.setAttribute('interval', '2000');
                            e.setAttribute('template-url', _this.registryFlowPath + 'av-chart/components/carousel-template.html');
                        });
                        carousel.find('.carousel-item')
                            .each(function (i, e) {
                            e.setAttribute('uib-slide', '');
                            e.setAttribute('index', i.toString());
                            angular.element(e)
                                .find('img')
                                .each(function (j, img) {
                                if (img.hasAttribute('data-src')) {
                                    img.setAttribute('src', img.getAttribute('data-src'));
                                    img.removeAttribute('data-src');
                                }
                            });
                        });
                    }
                    return target;
                };
                OverlayParser.prototype.replaceAnchorsWithStatic = function (target) {
                    var list = target.find('a:not(.carousel-control-next, .carousel-control-prev)')
                        .after(function (i, innerHtml) { return "<span>" + innerHtml + "</span>"; });
                    list.remove();
                    return target;
                };
                OverlayParser.prototype.getDocument = function (htmlString) {
                    return this.domParser.parseFromString(htmlString, 'text/html');
                };
                return OverlayParser;
            }());
            Pulse.app.directive(AvcCourseOverlayPopup.registeredAs, [
                'common',
                function (common) { return new AvcCourseOverlayPopup(common); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var AvcPriceSlash = (function (_super) {
                __extends(AvcPriceSlash, _super);
                function AvcPriceSlash() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        locationPrice: '<',
                        session: '<',
                        showDiscountOnMobile: '<?',
                        showFromText: '<?',
                        currencyTypeId: '<?',
                        textWrap: '<?',
                    };
                    _this.transclude = true;
                    _this.templateUrl = [
                        'config',
                        function (config) { return config.appRoot
                            + Paths.PulsePublicRegistryFlow
                            + 'av-chart/components/idp-avc-price-slash.html'; },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'SessionPriceDiscountService',
                        function ($scope, $element, s) { return new AvcPriceSlashCtrl($scope, $element, s); },
                    ];
                    return _this;
                }
                AvcPriceSlash.registeredAs = 'idpAvcPriceSlash';
                return AvcPriceSlash;
            }(ComponentOptions));
            RegistryFlow.AvcPriceSlash = AvcPriceSlash;
            var AvcPriceSlashCtrl = (function (_super) {
                __extends(AvcPriceSlashCtrl, _super);
                function AvcPriceSlashCtrl($scope, $element, spds) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.showDiscountOnMobile = false;
                    _this.showFromText = true;
                    _this.textWrap = false;
                    _this.discountService = spds;
                    return _this;
                }
                AvcPriceSlashCtrl.prototype.$onInit = function () {
                    if (this.currencyTypeId == undefined)
                        this.currencyTypeId = "" + Enums.CurrencyType.USD;
                    _super.prototype.$onInit.call(this);
                };
                AvcPriceSlashCtrl.prototype.hasDiscount = function () {
                    return this.discountService.hasDiscount(this.session, this.locationPrice);
                };
                Object.defineProperty(AvcPriceSlashCtrl.prototype, "sessionDiscount", {
                    get: function () {
                        return this.discountService.getSessionDiscount(this.session, this.locationPrice);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AvcPriceSlashCtrl.prototype, "sessionPrice", {
                    get: function () {
                        if (!this.session)
                            return this.locationPrice;
                        return this.discountService.getSessionPrice(this.session, this.locationPrice);
                    },
                    enumerable: false,
                    configurable: true
                });
                AvcPriceSlashCtrl.registeredAs = 'idpRfAvcPriceSlashCtrl';
                return AvcPriceSlashCtrl;
            }(ComponentController));
            Pulse.app.component(AvcPriceSlash.registeredAs, new AvcPriceSlash());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var GenderType = Pulse.Common.Enums.GenderType;
            Pulse.app.directive('idpParticipantGenderValidator', function () {
                return {
                    require: 'ngModel',
                    restrict: 'A',
                    link: function (scope, element, attrs, ctrl) {
                        ctrl.$validators.idpProgramTypeGenderValidator = function (mValue, vValue) {
                            var gender = parseInt(mValue, 10);
                            return gender === GenderType.Female || gender === GenderType.Male;
                        };
                    },
                };
            });
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            Pulse.app.directive('idpDateBetweenValidator', function () {
                return {
                    require: 'ngModel',
                    restrict: 'A',
                    scope: {
                        disableDateBetweenValidator: '=',
                        maxDate: '<',
                        minDate: '<',
                        ngModel: '=',
                    },
                    link: function (scope, element, attrs, ctrl) {
                        scope.$watch('ngModel', function (newValue, oldValue) {
                            if (newValue !== undefined && newValue !== oldValue && !ctrl.$pristine) {
                                ctrl.$setTouched();
                                ctrl.$setDirty();
                            }
                        });
                        scope.$watch('disableDateBetweenValidator', function (newValue, oldValue) {
                            if (newValue) {
                                ctrl.$setValidity('idpDateBetweenValidator', true);
                            }
                            else if (newValue !== undefined && newValue !== oldValue) {
                                if (!scope.xCachedVal) {
                                    ctrl.$setValidity('idpDateBetweenValidator', newValue);
                                }
                                else {
                                    var val = scope.xCachedVal;
                                    var validity = moment.isDate(val) && moment.isDate(scope.minDate) && moment.isDate(scope.maxDate)
                                        ? moment(val).isSameOrAfter(scope.maxDate, 'day') && moment(val).isSameOrBefore(scope.minDate, 'day')
                                        : true;
                                    ctrl.$setValidity('idpDateBetweenValidator', validity);
                                }
                            }
                        });
                        ctrl.$validators.idpDateBetweenValidator = function (val) {
                            scope.xCachedVal = val;
                            return !scope.disableDateBetweenValidator && moment.isDate(val) && moment.isDate(scope.minDate) && moment.isDate(scope.maxDate)
                                ? moment(val).isSameOrAfter(scope.maxDate, 'day') && moment(val).isSameOrBefore(scope.minDate, 'day')
                                : true;
                        };
                    },
                };
            });
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCLocationDir = (function (_super) {
                __extends(AVCLocationDir, _super);
                function AVCLocationDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-location.html";
                    _this.scope = {
                        location: "=",
                        singleLocMode: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        AVCLocationDir.AVCLocationDirCtrl];
                    return _this;
                }
                AVCLocationDir.directiveId = "idpAvcLocation";
                return AVCLocationDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCLocationDir = AVCLocationDir;
            (function (AVCLocationDir) {
                var AVCLocationDirCtrl = (function (_super) {
                    __extends(AVCLocationDirCtrl, _super);
                    function AVCLocationDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCLocationDirCtrl.controllerId) || this;
                        _this.isExpanded = false;
                        _this.hasOneDay = false;
                        _this.hasMultiWeek = false;
                        _this.hasCamp = false;
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.availChartMgr = _this.regFlowMgr.availChartMgr;
                        _this.activateController();
                        return _this;
                    }
                    AVCLocationDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        scope.$watch(function (scope) {
                            return _this.singleLocMode;
                        }, function (newValue, oldValue) {
                            _this.isExpanded = newValue;
                            if (_this.isExpanded) {
                                _this.loadLocationInfo();
                            }
                        });
                    };
                    AVCLocationDirCtrl.prototype.onHeaderClick = function () {
                        var isOpen = !this.isExpanded;
                        if (isOpen) {
                            this.loadLocationInfo();
                        }
                    };
                    AVCLocationDirCtrl.prototype.loadLocationInfo = function () {
                        var _this = this;
                        var _self = this;
                        if (!this.termDivInfos) {
                            this.common.toggleSpinner(true);
                            this.availChartMgr.loadStandardCampTermDivSessionInfo(this.pulseContext.regFlowMgr.locationFinderMgr.selectedIds)
                                .then(function () {
                                var promises = new Array();
                                var lookupInfoMgr = _self.pulseContext.lookupInfoMgr;
                                if (!lookupInfoMgr.divisionInfos) {
                                    promises.push(lookupInfoMgr.loadDivisionInfo());
                                }
                                if (!lookupInfoMgr.typeInfos || !lookupInfoMgr.typeInfos[Enums.TypeClassType.DivisionProgramType]) {
                                    promises.push(lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.DivisionProgramType));
                                }
                                if (!lookupInfoMgr.typeInfos || !lookupInfoMgr.typeInfos[Enums.TypeClassType.ProductSchedule]) {
                                    promises.push(lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.ProductSchedule));
                                }
                                return _self.common.$q.all(promises);
                            })
                                .then(function () {
                                _self.termDivInfos = Pulse.Utils.JS.findByProperties(_self.availChartMgr.termDivInfos, { locID: _self.location.iD });
                                if (_self.termDivInfos && _self.termDivInfos.length > 0) {
                                    _self.termDivInfos = _self.termDivInfos.sort(function (t1, t2) { return Pulse.Utils.JS.compareForSort(t1, t2, { 'sortOrder': 0, 'termStart': 0 }); });
                                    _self.hasCamp = true;
                                }
                            })
                                .catch(function (err) {
                                _this.logError(err);
                                return null;
                            })
                                .finally(function () {
                                _self.common.toggleSpinner(false);
                            });
                        }
                        if (!this.locOneDayDateRanges
                            && !this.locMultiWeekDateRanges) {
                            this.common.toggleSpinner(true);
                            this.regFlowMgr.getLocationDateRanges(this.location.iD)
                                .then(function (data) {
                                if (data) {
                                    _self.locOneDayDateRanges = Pulse.Utils.JS.findByProperties(data, { catalogTypeID: Enums.SalesCatalogType.AtSchoolOneDay });
                                    _self.locMultiWeekDateRanges = Pulse.Utils.JS.findByProperties(data, { catalogTypeID: Enums.SalesCatalogType.AtSchoolMultiWeek });
                                }
                                _self.hasOneDay = _self.locOneDayDateRanges && _self.locOneDayDateRanges.length > 0;
                                _self.hasMultiWeek = _self.locMultiWeekDateRanges && _self.locMultiWeekDateRanges.length > 0;
                            })
                                .finally(function () {
                                _self.common.toggleSpinner(false);
                            });
                        }
                        return null;
                    };
                    AVCLocationDirCtrl.controllerId = "AVCLocationDirCtrl";
                    return AVCLocationDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCLocationDir.AVCLocationDirCtrl = AVCLocationDirCtrl;
            })(AVCLocationDir = PulsePublic.AVCLocationDir || (PulsePublic.AVCLocationDir = {}));
            Pulse.app.directive(AVCLocationDir.directiveId, ["common", function (c) { return new AVCLocationDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCCampDir = (function (_super) {
                __extends(AVCCampDir, _super);
                function AVCCampDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-camp.html";
                    _this.scope = {
                        location: "=",
                        termDivInfos: "=",
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        AVCCampDir.AVCCampDirCtrl
                    ];
                    return _this;
                }
                AVCCampDir.directiveId = "idpAvcCamp";
                return AVCCampDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCCampDir = AVCCampDir;
            (function (AVCCampDir) {
                var AVCCampDirCtrl = (function (_super) {
                    __extends(AVCCampDirCtrl, _super);
                    function AVCCampDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCCampDirCtrl.controllerId) || this;
                        _this.selectedDivExpInfos = _this.pulseContext.regFlowMgr.experienceFinderMgr.selectedDivExpInfos;
                        _this.availChartMgr = _this.pulseContext.regFlowMgr.availChartMgr;
                        return _this;
                    }
                    AVCCampDirCtrl.prototype.$onInit = function () {
                        this.filterTermDivInfos();
                        this.activateController();
                    };
                    AVCCampDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                    };
                    AVCCampDirCtrl.prototype.filterTermDivInfos = function () {
                        var _this = this;
                        if (this.selectedDivExpInfos && this.selectedDivExpInfos.length) {
                            this.selectedTermDivInfos = this.termDivInfos.filter(function (termDivInfo) {
                                var matches = Pulse.Utils.JS.findByProperties(_this.selectedDivExpInfos, {
                                    divID: termDivInfo.divID,
                                    ageRangeID: termDivInfo.ageRangeID
                                });
                                return matches.length > 0;
                            });
                            this.otherTermDivInfos = this.termDivInfos.filter(function (termDivInfo) {
                                var matches = Pulse.Utils.JS.findByProperties(_this.selectedDivExpInfos, {
                                    divID: termDivInfo.divID,
                                    ageRangeID: termDivInfo.ageRangeID
                                });
                                return matches.length === 0;
                            });
                        }
                        else {
                            this.selectedTermDivInfos = this.termDivInfos;
                            this.otherTermDivInfos = null;
                        }
                    };
                    AVCCampDirCtrl.prototype.onSelect = function () {
                        this.isCollapsed = !this.isCollapsed;
                    };
                    AVCCampDirCtrl.controllerId = "AVCCampDirCtrl";
                    return AVCCampDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCCampDir.AVCCampDirCtrl = AVCCampDirCtrl;
            })(AVCCampDir = PulsePublic.AVCCampDir || (PulsePublic.AVCCampDir = {}));
            Pulse.app.directive(AVCCampDir.directiveId, [
                "common",
                function (c) { return new AVCCampDir(c); }
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCCampTermDir = (function (_super) {
                __extends(AVCCampTermDir, _super);
                function AVCCampTermDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'reg-flow/old-avail-chart/idp-avc-camp-term.html';
                    _this.scope = {
                        location: '=',
                        termDivInfo: '=',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        AVCCampTermDir.AVCCampTermDirCtrl,
                    ];
                    return _this;
                }
                AVCCampTermDir.directiveId = 'idpAvcCampTerm';
                return AVCCampTermDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCCampTermDir = AVCCampTermDir;
            (function (AVCCampTermDir) {
                var AVCCampTermDirCtrl = (function (_super) {
                    __extends(AVCCampTermDirCtrl, _super);
                    function AVCCampTermDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCCampTermDirCtrl.controllerId) || this;
                        _this.isCollapsed = true;
                        _this.isCollapsedMobile = true;
                        _this.hasCourses = false;
                        _this.sessions = [];
                        _this.courses = [];
                        _this.sessionAvailabilityStatusTypes = [];
                        _this.showButtonStatuses = [
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.AlmostFull],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.CallUs],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Open],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Space1],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Space2],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Space3],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Space4],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.SoldOut],
                        ];
                        _this.lookupInfoMgr = _this.pulseContext.lookupInfoMgr;
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.availChartMgr = _this.pulseContext.regFlowMgr.availChartMgr;
                        _this.id = AVCCampTermDirCtrl._instanceCount++;
                        _this.$scope.$on(Events.ProductAddedToCart, _this.onProductAddedToCart);
                        return _this;
                    }
                    AVCCampTermDirCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.activationPromises.push(this.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.SessionAvailabilityStatusType)
                            .then(function (data) {
                            _this.sessionAvailabilityStatusTypes = data;
                        }));
                        this.activateController();
                    };
                    AVCCampTermDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.parentCtrl = ctrls;
                        scope.$watch(function (scope) {
                            return _this.termDivInfo;
                        }, function (newValue, oldValue) {
                            _this.loadTermInfo();
                        });
                    };
                    AVCCampTermDirCtrl.prototype.onProductAddedToCart = function (event, addedProds) {
                        if (!addedProds || addedProds.length == 0) {
                            return;
                        }
                        var mProd = addedProds[0];
                        var wrongControl = event.currentScope.vm.termDivInfo.locID != mProd.locationID ||
                            event.currentScope.vm.termDivInfo.divID != mProd.divisionID ||
                            event.currentScope.vm.termDivInfo.termID != mProd.termID ||
                            event.currentScope.vm.termDivInfo.ageRangeID != mProd.ageRangeID;
                        if (wrongControl) {
                            return;
                        }
                        var c = Pulse.Utils.JS.findByProperties(event.currentScope.vm.courses, { prodID: mProd.productID })[0];
                        if (angular.isDefined(c)) {
                            var s = Pulse.Utils.JS.findByProperties(c.sessions, { sessID: mProd.sessionID })[0];
                            if (mProd.programTypeID == Enums.DivisionProgramType.iDTechMini) {
                                if (mProd.scheduleTypeID == Enums.ProductSchedule.Morning) {
                                    s.selectedText = 'AM';
                                }
                                else if (mProd.scheduleTypeID == Enums.ProductSchedule.Afternoon) {
                                    s.selectedText = 'PM';
                                }
                            }
                            else {
                                if (mProd.isONPackage) {
                                    s.selectedText = 'Overnight';
                                }
                                else {
                                    if (addedProds.length > 1) {
                                        s.selectedText = 'Overnight';
                                    }
                                    else {
                                        s.selectedText = 'Day';
                                    }
                                }
                            }
                        }
                    };
                    AVCCampTermDirCtrl.prototype.onSelect = function () {
                        var _this = this;
                        if (this.isCollapsed) {
                            this.sessions = this.termDivInfo.sessions;
                            this.loadAvailability()
                                .then(function () {
                                _this.isCollapsed = !_this.isCollapsed;
                                _this.common.scrollToHash('collapse' + _this.id);
                            });
                        }
                        else {
                            this.isCollapsed = !this.isCollapsed;
                        }
                    };
                    AVCCampTermDirCtrl.prototype.onSelectMobile = function (course) {
                        var _this = this;
                        if (this.isCollapsedMobile) {
                            this.common.$timeout(function () {
                                _this.common.scrollToHash('collapseMobile' + _this.id + course.prodID);
                            }, 200);
                        }
                        this.isCollapsedMobile = !this.isCollapsedMobile;
                    };
                    AVCCampTermDirCtrl.prototype.productVideoFullUrl = function (course) {
                        return this.pulseContext.systemMgr.buildCourseVideoUrl(course.prodID);
                    };
                    AVCCampTermDirCtrl.prototype.productDetailFullUrl = function (course) {
                        var result = this.common.config.WWW_UrlRoot + '/';
                        var prodDetailUrl;
                        if (course.uRLs) {
                            var url = Pulse.Utils.JS.findByProperties(course.uRLs, {
                                usageTypeID: Enums.ProductURLType.CourseDetailsURL,
                            });
                            if (url && url.length > 0) {
                                prodDetailUrl = url[0].uRL;
                            }
                        }
                        result += prodDetailUrl;
                        return result;
                    };
                    AVCCampTermDirCtrl.prototype.thumbNailFullUrl = function (course) {
                        var result = this.common.config.courseVideoThumbnailUrl + '/';
                        var prodThumbImgUrl;
                        if (course.uRLs) {
                            var url = Pulse.Utils.JS.findByProperties(course.uRLs, {
                                usageTypeID: Enums.ProductURLType.CourseVideoIntroImageURL,
                            });
                            if (url && url.length > 0) {
                                prodThumbImgUrl = url[0].uRL;
                            }
                        }
                        if (!String.isNullOrWhitespace(prodThumbImgUrl)) {
                            var thumbNailSegments = prodThumbImgUrl.split('.');
                            result += thumbNailSegments[0] + '_s.' + thumbNailSegments[1];
                        }
                        return result;
                    };
                    AVCCampTermDirCtrl.prototype.loadAvailability = function () {
                        var _this = this;
                        var _self = this;
                        var promises = new Array();
                        if (this.courses == null || this.courses.length == 0) {
                            this.common.toggleSpinner(true);
                            promises.push(this.availChartMgr.getStandardCampAvailability(this.termDivInfo.locID, this.termDivInfo.divID, this.termDivInfo.termID, this.termDivInfo.ageRangeID, this.regFlowMgr.genreFinderMgr.selectedIds, this.termDivInfo.schedTypeID)
                                .then(function (data) {
                                for (var i = 0; i < data.length; i++) {
                                    for (var j = 0; j < data[i].sessions.length; j++) {
                                        data[i].sessions[j].selectedText = null;
                                    }
                                }
                                _this.courses = data;
                                _this.hasCourses = _this.courses && _this.courses.length > 0;
                                _this.removeEmptySessions();
                            })
                                .catch(function (reason) {
                                _this.logError(reason);
                            })
                                .finally(function () {
                                _self.common.toggleSpinner(false);
                            }));
                        }
                        return this.common.$q.all(promises);
                    };
                    AVCCampTermDirCtrl.prototype.removeEmptySessions = function () {
                        var emptyIndex = [];
                        for (var sesIdx = 0; sesIdx < this.sessions.length; sesIdx++) {
                            var hasProduct = false;
                            for (var j = 0; j < this.courses.length; j++) {
                                if (this.courses[j].sessions[sesIdx].hasCourse) {
                                    hasProduct = true;
                                    break;
                                }
                            }
                            if (hasProduct) {
                                break;
                            }
                            else {
                                emptyIndex.push(sesIdx);
                            }
                        }
                        for (var sesIdx = this.sessions.length - 1; sesIdx >= 0; sesIdx--) {
                            var hasProduct = false;
                            for (var j = 0; j < this.courses.length; j++) {
                                if (this.courses[j].sessions[sesIdx].hasCourse) {
                                    hasProduct = true;
                                    break;
                                }
                            }
                            if (hasProduct) {
                                break;
                            }
                            else {
                                emptyIndex.push(sesIdx);
                            }
                        }
                        if (emptyIndex.length > 0) {
                            var sortedIndex = emptyIndex.sort(function (n1, n2) { return n2 - n1; });
                            for (var i = 0; i < sortedIndex.length; i++) {
                                for (var j = 0; j < this.courses.length; j++) {
                                    this.courses[j].sessions.splice(sortedIndex[i], 1);
                                }
                                this.sessions.splice(sortedIndex[i], 1);
                            }
                        }
                    };
                    AVCCampTermDirCtrl.prototype.getProgramDetails = function (course, courseSession) {
                        var _this = this;
                        var _self = this;
                        var progInfo;
                        var mainSpdID = courseSession.spdID;
                        var overnightSpdID = courseSession.spdIDON;
                        var promise = this.availChartMgr.getProgramDetails(mainSpdID, overnightSpdID)
                            .then(function (data) {
                            progInfo = data;
                            var mainProd;
                            mainProd = {};
                            mainProd.divisionID = _this.termDivInfo.divID;
                            mainProd.ageRangeID = _this.termDivInfo.ageRangeID;
                            mainProd.termID = _this.termDivInfo.termID;
                            mainProd.productID = progInfo.mainProduct.prodID;
                            mainProd.headline = progInfo.mainProduct.headline;
                            mainProd.name = course.name;
                            mainProd.price = progInfo.mainProduct.price;
                            mainProd.sessionID = courseSession.sessID;
                            mainProd.maximumAge = progInfo.mainProduct.maxAge;
                            mainProd.minimumAge = progInfo.mainProduct.minAge;
                            mainProd.scheduleDescriptor = progInfo.mainProduct.schedule;
                            mainProd.options = progInfo.mainProduct.options;
                            mainProd.sessionProductDetailID = progInfo.mainProduct.spdID;
                            mainProd.isONPackage = progInfo.mainProduct.isONPackage;
                            mainProd.programTypeID = progInfo.programTypeID;
                            mainProd.catalogTypeID = Enums.SalesCatalogType.StandardCamp;
                            mainProd.locationID = _this.termDivInfo.locID;
                            mainProd.prerequisities = course.prerequisities;
                            mainProd.description = progInfo.mainProduct.description;
                            mainProd.sessionStart = courseSession.startDate;
                            mainProd.sessionEnd = courseSession.endDate;
                            mainProd.startDateTime = progInfo.mainProduct.startDateTime;
                            mainProd.endDateTime = progInfo.mainProduct.endDateTime;
                            mainProd.locSessID = courseSession.locationSessionID;
                            var selectedSess = Pulse.Utils.JS.findByProperties(_this.sessions, {
                                sessID: courseSession.sessID,
                            })[0];
                            mainProd.alerts = selectedSess.alerts;
                            var optProd;
                            if (progInfo.primaryOption !== null && _this.showOption(courseSession)) {
                                optProd = {};
                                optProd.productID = progInfo.primaryOption.prodID;
                                optProd.headline = progInfo.primaryOption.headline;
                                optProd.price = progInfo.mainProduct.price + progInfo.primaryOption.price;
                                optProd.sessionID = courseSession.sessID;
                                optProd.maximumAge = progInfo.primaryOption.maxAge;
                                optProd.minimumAge = progInfo.primaryOption.minAge;
                                optProd.scheduleDescriptor = progInfo.primaryOption.schedule;
                                optProd.scheduleTypeID = progInfo.primaryOption.scheduleTypeID;
                                optProd.sessionProductDetailID = progInfo.primaryOption.spdID;
                                optProd.isONPackage = progInfo.primaryOption.isONPackage;
                                optProd.options = progInfo.primaryOption.options;
                                optProd.programTypeID = progInfo.programTypeID;
                                optProd.catalogTypeID = Enums.SalesCatalogType.StandardCamp;
                                optProd.locationID = _this.termDivInfo.locID;
                                optProd.locSessID = courseSession.locationSessionID;
                            }
                            return [mainProd, optProd];
                        });
                        return promise;
                    };
                    AVCCampTermDirCtrl.prototype.loadTermInfo = function () {
                        var _this = this;
                        this.loadAvailability()
                            .then(function () {
                            var divLookupInfo = Pulse.Utils.JS.findByProperties(_this.lookupInfoMgr.divisionInfos, { divisionID: _this.termDivInfo.divID })[0];
                            _this.divName = divLookupInfo.divisionName;
                            _this.ageRange = String.format('{0}-{1}', _this.termDivInfo.minAge, _this.termDivInfo.maxAge);
                            _this.duration = _this.termDivInfo.daysPerSession > 7 ? '2 weeks' : 'Weeklong';
                            var divProgTypes = _this.lookupInfoMgr.typeInfos[Enums.TypeClassType.DivisionProgramType];
                            _this.programType = Pulse.Utils.JS.findByProperties(divProgTypes, { 'typeID': _this.termDivInfo.divProgramTypeID })[0]['typeExtraString'];
                            if (_this.termDivInfo.divProgramTypeID == Enums.DivisionProgramType.iDTechMini) {
                                var schedTypes = _this.lookupInfoMgr.typeInfos[Enums.TypeClassType.ProductSchedule];
                                _this.scheduleType = ' - ' + Pulse.Utils.JS.findByProperties(schedTypes, { 'typeID': _this.termDivInfo.schedTypeID })[0]['typeExtraString'];
                                _this.options = 'Half Day & Full Day';
                            }
                            else if (_this.termDivInfo.isOvernightOnly) {
                                _this.options = 'Overnight';
                            }
                            else if (_this.termDivInfo.isDayOnly) {
                                _this.options = 'Day';
                            }
                            else {
                                _this.options = 'Day & Overnight';
                            }
                        });
                    };
                    AVCCampTermDirCtrl.prototype.showOptionsForTerm = function (course) {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var isOvernight = false;
                        for (var i = 0; i < course.sessions.length; i++) {
                            if (course.sessions[i].hasCourse) {
                                var validStatus = this.showButtonStatuses.indexOf(course.sessions[i].programStatus) > -1;
                                if (validStatus && course.sessions[i].isONpackage) {
                                    isOvernight = true;
                                    break;
                                }
                            }
                        }
                        this.getOptionsForTerm(isOvernight)
                            .then(function (result) {
                            var a = result;
                            _this.common.$rootScope.$broadcast(Events.ShowAVCOptionsPopup, {
                                size: Pulse.Common.BasePopup.ModalSize.Medium,
                                initDataObj: result,
                            });
                        })
                            .catch(function (reason) {
                            _this.logError(reason);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    AVCCampTermDirCtrl.prototype.getOptionsForTerm = function (isOvernight) {
                        var promise = this.availChartMgr.getOptionsForLocationTerm(isOvernight, this.termDivInfo.locID, this.termDivInfo.termID);
                        return promise;
                    };
                    AVCCampTermDirCtrl.prototype.formatSessionDates = function (start, end) {
                        if (moment(start)
                            .isValid() && moment(end)
                            .isValid()) {
                            var startDate = moment(start);
                            var endDate = moment(end);
                            var differentMonths = startDate.month() != endDate.month();
                            var formattedDate = void 0;
                            if (differentMonths) {
                                var firstDate = startDate.format('MMM D');
                                var secondDate = endDate.format('MMM D');
                                formattedDate = firstDate + "-" + secondDate;
                            }
                            else {
                                var monthFormatted = startDate.format('MMM');
                                var firstDate = startDate.format('D');
                                var secondDate = endDate.format('D');
                                formattedDate = monthFormatted + " " + firstDate + "-" + secondDate;
                            }
                            return formattedDate;
                        }
                        else {
                            return '';
                        }
                    };
                    AVCCampTermDirCtrl.prototype.showMainPrice = function (courseSession) {
                        var isAvailable = false;
                        if (this.showButtonStatuses.indexOf(courseSession.programStatus) > -1) {
                            isAvailable = true;
                        }
                        return isAvailable;
                    };
                    AVCCampTermDirCtrl.prototype.showOption = function (courseSession) {
                        var isAvailable = false;
                        if (this.showButtonStatuses.indexOf(courseSession.optionStatus) > -1) {
                            if (!courseSession.optionRestriction) {
                                isAvailable = true;
                            }
                        }
                        return isAvailable;
                    };
                    AVCCampTermDirCtrl.prototype.showButton = function (programStatus) {
                        return (this.showButtonStatuses.indexOf(programStatus) > -1);
                    };
                    AVCCampTermDirCtrl.prototype.showWLButton = function (programStatus) {
                        return programStatus == Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.SoldOut];
                    };
                    AVCCampTermDirCtrl.prototype.formatCourseSessionAvailabilityStatusType = function (courseSession) {
                        if (courseSession.programStatus === Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.SoldOut]) {
                            return 'Join Waitlist';
                        }
                        var type = Pulse.Utils.JS.findByProperties(this.sessionAvailabilityStatusTypes, { 'typeID': courseSession.programStatusTypeID })[0];
                        if (angular.isDefined(type)) {
                            return type.typeString;
                        }
                        else {
                            return '';
                        }
                    };
                    AVCCampTermDirCtrl.prototype.waitlistPopup = function (course, courseSession) {
                        this.common.toggleSpinner(true);
                        this._clickedSession = {
                            prodID: course.prodID,
                            sessID: courseSession.sessID,
                        };
                        var selectedSess = Pulse.Utils.JS.findByProperties(this.sessions, {
                            sessID: courseSession.sessID,
                        })[0];
                        this.common.$rootScope.$broadcast(Events.ShowAVCWaitlistAdd, {
                            size: Pulse.Common.BasePopup.ModalSize.Medium,
                            initDataObj: {
                                locationName: this.parentCtrl.location.name,
                                divisionName: this.divName,
                                spdID: courseSession.spdID,
                                courseName: course.name,
                                sessionStart: selectedSess.start,
                                sessionEnd: selectedSess.displayEnd,
                            },
                        });
                        this.common.toggleSpinner(false);
                    };
                    AVCCampTermDirCtrl.prototype.selectProdPopup = function (course, courseSession) {
                        var _this = this;
                        if (courseSession.programStatusTypeID == Enums.SessionAvailabilityStatus.CallUs) {
                            var msg = 'Call us to check availability. 1-888-709-8324, option 1.';
                            this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Call Us', ' ' + msg, null);
                        }
                        else if (this.showWLButton(courseSession.programStatus)) {
                            this.waitlistPopup(course, courseSession);
                        }
                        else if (this.showButton(courseSession.programStatus)) {
                            this.common.toggleSpinner(true);
                            this._clickedSession = {
                                prodID: course.prodID,
                                sessID: courseSession.sessID,
                            };
                            this.getProgramDetails(course, courseSession)
                                .then(function (prods) {
                                _this.common.$rootScope.$broadcast(Events.ShowAVCSelectedPopup, {
                                    size: Pulse.Common.BasePopup.ModalSize.Medium,
                                    initDataObj: {
                                        location: _this.parentCtrl.location,
                                        courseSession: courseSession,
                                        salesCatalogType: Enums.SalesCatalogType.StandardCamp,
                                        urls: {
                                            thumbNailFullUrl: _this.thumbNailFullUrl(course),
                                            prodDetailFullUrl: _this.productDetailFullUrl(course),
                                            prodVideoFullUrl: _this.productVideoFullUrl(course),
                                        },
                                        prodInfos: prods,
                                    },
                                });
                            })
                                .catch(function (reason) {
                                _this.logError(reason);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                    };
                    AVCCampTermDirCtrl.prototype.getSkillLevelDesc = function (course) {
                        var firstSkill, lastSkill;
                        if (course.skillLevels && course.skillLevels.length > 0) {
                            if (course.skillLevels.length == 1) {
                                return course.skillLevels[0].skill;
                            }
                            else {
                                return course.skillLevels[0].skill + ' - ' + course.skillLevels[course.skillLevels.length - 1].skill;
                            }
                        }
                        else {
                            return 'All Levels';
                        }
                    };
                    AVCCampTermDirCtrl.prototype.showAgePolicy = function (course) {
                        var validSession;
                        for (var i = 0; i < course.sessions.length; i++) {
                            if (course.sessions[i].hasCourse) {
                                validSession = course.sessions[i];
                                break;
                            }
                        }
                        this.common.$rootScope.$broadcast(Events.ShowAVCAgePopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Medium,
                            initDataObj: {
                                productID: course.prodID,
                                locationID: this.parentCtrl.location.iD,
                                sessionID: validSession.sessID,
                                scheduleDefID: -1,
                                salesCatalogType: Enums.SalesCatalogType.StandardCamp,
                                minAge: course.minAge,
                                maxAge: course.maxAge,
                            },
                        });
                    };
                    AVCCampTermDirCtrl.prototype.hasPrerequisites = function (course) {
                        return course.prerequisities && course.prerequisities.length > 0;
                    };
                    AVCCampTermDirCtrl.prototype.showPrereq = function (course) {
                        var prereqs = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(course.prerequisities, 'skill');
                        this.common.$rootScope.$broadcast(Events.ShowAVCPrereqPopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Medium,
                            initDataObj: {
                                prodName: course.name,
                                prereqList: prereqs,
                            },
                        });
                    };
                    AVCCampTermDirCtrl.prototype.showCourseInfo = function (course) {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var courseSession = Pulse.Utils.JS.findByProperties(course.sessions, {
                            hasCourse: true,
                        })[0];
                        this.getProgramDetails(course, courseSession)
                            .then(function (prods) {
                            _this.common.$rootScope.$broadcast(Events.ShowAVCInfoPopup, {
                                size: Pulse.Common.BasePopup.ModalSize.Medium,
                                initDataObj: {
                                    prodDetailFullUrl: _this.productDetailFullUrl(course),
                                    prodInfos: prods,
                                    prereqList: Pulse.Utils.JS.selectDistinctPropertiesIntoArray(course.prerequisities, 'skill'),
                                    skillLevelDesc: _this.getSkillLevelDesc(course),
                                },
                            });
                        })
                            .catch(function (reason) {
                            _this.logError(reason);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    AVCCampTermDirCtrl.controllerId = 'AVCCampTermDirCtrl';
                    AVCCampTermDirCtrl._instanceCount = 0;
                    return AVCCampTermDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCCampTermDir.AVCCampTermDirCtrl = AVCCampTermDirCtrl;
            })(AVCCampTermDir = PulsePublic.AVCCampTermDir || (PulsePublic.AVCCampTermDir = {}));
            Pulse.app.directive(AVCCampTermDir.directiveId, [
                'common',
                function (c) { return new AVCCampTermDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCMultiDayDir = (function (_super) {
                __extends(AVCMultiDayDir, _super);
                function AVCMultiDayDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-multi-day.html";
                    _this.scope = {
                        location: "=",
                        dateRanges: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        AVCMultiDayDir.AVCMultiDayDirCtrl];
                    return _this;
                }
                AVCMultiDayDir.directiveId = "idpAvcMultiDay";
                return AVCMultiDayDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCMultiDayDir = AVCMultiDayDir;
            (function (AVCMultiDayDir) {
                var AVCMultiDayDirCtrl = (function (_super) {
                    __extends(AVCMultiDayDirCtrl, _super);
                    function AVCMultiDayDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCMultiDayDirCtrl.controllerId) || this;
                        _this.selectedProdPopupAPI = null;
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.activateController();
                        return _this;
                    }
                    AVCMultiDayDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        scope.$watch(function (scope) {
                            return _this.dateRanges;
                        }, function (newValue, oldValue) {
                            _this.selectCurrentDateRange(newValue);
                        });
                        scope.$watch(function (scope) {
                            return _this.selectedDateRangeIndex;
                        }, function (newValue, oldValue) {
                            _this.loadProductInfo(_this.selectedDateRange);
                        });
                    };
                    AVCMultiDayDirCtrl.prototype.loadProductInfo = function (selectedDateRange) {
                        var _this = this;
                        var _self = this;
                        this.common.toggleSpinner(true);
                        this.regFlowMgr.getProducts(selectedDateRange.locationCatDateRangeID, selectedDateRange.catalogTypeID)
                            .then(function (data) {
                            _self.productDTOs = Pulse.Utils.JS.findByProperties(data.products, { isMainCatalogEntry: 1 });
                            _self.prodGenresDTOs = data.productGenres;
                            _self.prodDateDTOs = data.productDates;
                            _self.prodStyleMtxDTOs = data.productStyleMatrixes;
                            _self.prodStyleDivDTOs = data.productStyleDivisions;
                            _self.prodSkillDTOs = data.productSkills;
                            _self.prodUrlDTOs = data.productURLs;
                            _self.relatedProdDTOs = data.relatedProducts;
                            _self.uniqueProducts = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(_self.productDTOs, "productID", "name", "minimumAge", "maximumAge", "numClasses");
                            if (_self.productDTOs.length > 0) {
                                var prodDTO = _self.productDTOs[0];
                                _this.regFlowMgr.getProductQuantitiesByLocationIDDivisionID(prodDTO.locationID, prodDTO.divisionID, prodDTO.catalogTypeID, 0, _self.selectedDateRange.locationCatDateRangeID)
                                    .then(function (data) {
                                    _self.prodQtyDTOs = data;
                                });
                            }
                            else {
                                _self.prodQtyDTOs = null;
                            }
                        })
                            .finally(function () {
                            _self.common.toggleSpinner(false);
                        });
                    };
                    AVCMultiDayDirCtrl.prototype.onSelect = function () {
                        this.isCollapsed = !this.isCollapsed;
                    };
                    AVCMultiDayDirCtrl.prototype.selectCurrentDateRange = function (dateRanges) {
                        if (!dateRanges)
                            return;
                        var currentDate = this.pulseContext.serverDateTime;
                        for (var i = 0; i < dateRanges.length; i++) {
                            var dateRange = dateRanges[i];
                            if (dateRange.startDate <= currentDate && currentDate <= dateRange.endDate) {
                                this.selectedDateRangeIndex = i;
                                break;
                            }
                            else if (currentDate < dateRange.startDate) {
                                this.selectedDateRangeIndex = i;
                                break;
                            }
                        }
                        if (this.selectedDateRangeIndex == 0 && dateRanges[dateRanges.length - 1].endDate < currentDate) {
                            this.selectedDateRangeIndex = dateRanges.length - 1;
                        }
                    };
                    AVCMultiDayDirCtrl.prototype.prevDateRange = function () {
                        if (this.selectedDateRangeIndex > 0) {
                            this.selectedDateRangeIndex--;
                        }
                    };
                    AVCMultiDayDirCtrl.prototype.nextDateRange = function () {
                        if (this.selectedDateRangeIndex < this.dateRanges.length - 1) {
                            this.selectedDateRangeIndex++;
                        }
                    };
                    Object.defineProperty(AVCMultiDayDirCtrl.prototype, "selectedDateRange", {
                        get: function () {
                            return this.dateRanges[this.selectedDateRangeIndex];
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCMultiDayDirCtrl.prototype, "displayDateRange", {
                        get: function () {
                            var dateRange = this.selectedDateRange;
                            var result;
                            if (dateRange) {
                                result = String.format("({0} - {1})", this.common.$filter('date')(dateRange.startDate, 'MMM d'), this.common.$filter('date')(dateRange.endDate, 'MMM d'));
                            }
                            return result;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AVCMultiDayDirCtrl.controllerId = "AVCMultiDayDirCtrl";
                    return AVCMultiDayDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCMultiDayDir.AVCMultiDayDirCtrl = AVCMultiDayDirCtrl;
            })(AVCMultiDayDir = PulsePublic.AVCMultiDayDir || (PulsePublic.AVCMultiDayDir = {}));
            Pulse.app.directive(AVCMultiDayDir.directiveId, ["common", function (c) { return new AVCMultiDayDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCMultiDayProdDir = (function (_super) {
                __extends(AVCMultiDayProdDir, _super);
                function AVCMultiDayProdDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-multi-day-prod.html";
                    _this.require = "^" + PulsePublic.AVCMultiDayDir.directiveId;
                    _this.scope = {
                        productInfo: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        AVCMultiDayProdDir.AVCMultiDayProdDirCtrl];
                    return _this;
                }
                AVCMultiDayProdDir.directiveId = "idpAvcMultiDayProd";
                return AVCMultiDayProdDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCMultiDayProdDir = AVCMultiDayProdDir;
            (function (AVCMultiDayProdDir) {
                var AVCMultiDayProdDirCtrl = (function (_super) {
                    __extends(AVCMultiDayProdDirCtrl, _super);
                    function AVCMultiDayProdDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCMultiDayProdDirCtrl.controllerId) || this;
                        _this._prodQtyDTO = null;
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.activateController();
                        return _this;
                    }
                    AVCMultiDayProdDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.parentCtrl = ctrls;
                        this._prodQtyDTO = null;
                        scope.$watch(function (scope) {
                            return _this.productInfo;
                        }, function (newValue, oldValue) {
                            _this.loadProductInfo();
                        });
                    };
                    AVCMultiDayProdDirCtrl.prototype.loadProductInfo = function () {
                        this._prodQtyDTO = null;
                        var urls = Pulse.Utils.JS.findByProperties(this.parentCtrl.prodUrlDTOs, { productID: this.productInfo.productID });
                        for (var i = 0; i < urls.length; i++) {
                            var urlInfo = urls[i];
                            this.prodDetailUrl = this.prodDetailUrl || (urlInfo.usageTypeID == Enums.ProductURLType.CourseDetailsURL ? urlInfo.uRL : this.prodDetailUrl);
                            this.prodVideoUrl = this.prodVideoUrl || (urlInfo.usageTypeID == Enums.ProductURLType.CourseVideoURL ? urlInfo.uRL : this.prodVideoUrl);
                            this.prodThumbImgUrl = this.prodThumbImgUrl || (urlInfo.usageTypeID == Enums.ProductURLType.CourseVideoIntroImageURL ? urlInfo.uRL : this.prodThumbImgUrl);
                        }
                        if (this.parentCtrl.prodSkillDTOs && this.parentCtrl.prodSkillDTOs.length > 0) {
                            this.prodPrereqs = Pulse.Utils.JS.findByProperties(this.parentCtrl.prodSkillDTOs, { skillTypeID: Enums.SkillType.Student });
                            this.prodSkillLvls = Pulse.Utils.JS.findByProperties(this.parentCtrl.prodSkillDTOs, { skillTypeID: Enums.SkillType.StudentLevel });
                        }
                        this.productDTOs = Pulse.Utils.JS.findByProperties(this.parentCtrl.productDTOs, {
                            productID: this.productInfo.productID,
                            numClasses: this.productInfo.numClasses,
                        });
                    };
                    Object.defineProperty(AVCMultiDayProdDirCtrl.prototype, "thumbNailFullUrl", {
                        get: function () {
                            if (!this.prodThumbImgUrl)
                                return undefined;
                            var result = this.common.config.courseVideoThumbnailUrl + "/";
                            var thumbNailSegments = this.prodThumbImgUrl.split(".");
                            if (this.common.isMobileView) {
                                result += thumbNailSegments[0] + "_s." + thumbNailSegments[1];
                            }
                            else {
                                result += thumbNailSegments[0] + "_l." + thumbNailSegments[1];
                            }
                            return result;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCMultiDayProdDirCtrl.prototype, "productDetailFullUrl", {
                        get: function () {
                            var result = this.common.config.WWW_UrlRoot + "/";
                            result += this.prodDetailUrl;
                            return result;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCMultiDayProdDirCtrl.prototype, "productVideoFullUrl", {
                        get: function () {
                            return this.pulseContext.systemMgr.buildCourseVideoUrl(this.productInfo.productID);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCMultiDayProdDirCtrl.prototype, "hasPrerequisites", {
                        get: function () {
                            return this.prodPrereqs && this.prodPrereqs.length > 0;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCMultiDayProdDirCtrl.prototype, "prodQtyDTO", {
                        get: function () {
                            if (!this._prodQtyDTO && this.productDTOs && this.parentCtrl.prodQtyDTOs) {
                                var matches = Pulse.Utils.JS.findByProperties(this.parentCtrl.prodQtyDTOs, {
                                    productID: this.productInfo.productID,
                                });
                                var schedDefIDs = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(this.productDTOs, "scheduleDefID");
                                for (var i = matches.length - 1; i >= 0; i--) {
                                    var prodQty = matches[i];
                                    if (schedDefIDs.indexOf(prodQty.scheduleDefID) < 0) {
                                        matches.splice(i, 1);
                                    }
                                }
                                matches = matches.sort(function (obj1, obj2) { return Pulse.Utils.JS.compareForSort(obj1, obj2, { "qtyAvailable": 1 }); });
                                if (matches.length > 0) {
                                    this._prodQtyDTO = matches[0];
                                }
                                else {
                                    this._prodQtyDTO = null;
                                }
                            }
                            return this._prodQtyDTO;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AVCMultiDayProdDirCtrl.prototype.getQtyAvailable = function () {
                        if (this.prodQtyDTO) {
                            return this.prodQtyDTO.qtyAvailable;
                        }
                        return 0;
                    };
                    AVCMultiDayProdDirCtrl.prototype.getAvailabilityString = function () {
                        if (this.prodQtyDTO) {
                            return this.prodQtyDTO.qtyString;
                        }
                        return "Not Available";
                    };
                    AVCMultiDayProdDirCtrl.prototype.selectProdPopup = function () {
                        this.common.$rootScope.$broadcast(Events.ShowAVCSelectedPopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Medium,
                            initDataObj: {
                                location: this.parentCtrl.location,
                                salesCatalogType: Enums.SalesCatalogType.AtSchoolMultiWeek,
                                urls: {
                                    thumbNailFullUrl: this.thumbNailFullUrl,
                                    prodDetailFullUrl: this.productDetailFullUrl,
                                    prodVideoFullUrl: this.productVideoFullUrl
                                },
                                prodInfos: this.productDTOs,
                            }
                        });
                    };
                    AVCMultiDayProdDirCtrl.prototype.showPrereq = function () {
                        var prereqs = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(this.prodPrereqs, "skill");
                        this.common.$rootScope.$broadcast(Events.ShowAVCPrereqPopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Medium,
                            initDataObj: {
                                prodName: this.productInfo.name,
                                prereqList: prereqs,
                            }
                        });
                    };
                    AVCMultiDayProdDirCtrl.prototype.showAgePolicy = function () {
                        this.common.$rootScope.$broadcast(Events.ShowAVCAgePopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Medium,
                            initDataObj: {
                                productID: this.productInfo.productID,
                                locationID: this.parentCtrl.location.iD,
                                sessionID: this.productDTOs[0].sessionID,
                                scheduleDefID: this.productDTOs[0].scheduleDefID,
                                salesCatalogType: Enums.SalesCatalogType.AtSchoolMultiWeek,
                                minAge: this.productInfo.minimumAge,
                                maxAge: this.productInfo.maximumAge,
                            }
                        });
                    };
                    AVCMultiDayProdDirCtrl.prototype.showMoreInfo = function () {
                        var prereqs = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(this.prodPrereqs, "skill");
                        this.common.$rootScope.$broadcast(Events.ShowAVCInfoPopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Medium,
                            initDataObj: {
                                prodDetailFullUrl: this.productDetailFullUrl,
                                prodInfos: this.productDTOs,
                                prereqList: prereqs,
                                skillLevelDesc: this.getSkillLevelDesc(),
                            }
                        });
                    };
                    AVCMultiDayProdDirCtrl.prototype.getSkillLevelDesc = function () {
                        var firstSkill, lastSkill;
                        if (this.prodSkillLvls && this.prodSkillLvls.length > 0) {
                            if (this.prodSkillLvls.length == 1) {
                                return this.prodSkillLvls[0].skill;
                            }
                            else {
                                return this.prodSkillLvls[0].skill + " - " + this.prodSkillLvls[this.prodSkillLvls.length - 1].skill;
                            }
                        }
                        else {
                            return "All Levels";
                        }
                    };
                    AVCMultiDayProdDirCtrl.controllerId = "AVCMultiDayProdDirCtrl";
                    return AVCMultiDayProdDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCMultiDayProdDir.AVCMultiDayProdDirCtrl = AVCMultiDayProdDirCtrl;
            })(AVCMultiDayProdDir = PulsePublic.AVCMultiDayProdDir || (PulsePublic.AVCMultiDayProdDir = {}));
            Pulse.app.directive(AVCMultiDayProdDir.directiveId, ["common", function (c) { return new AVCMultiDayProdDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCSingleDayDir = (function (_super) {
                __extends(AVCSingleDayDir, _super);
                function AVCSingleDayDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-single-day.html";
                    _this.scope = {
                        location: "=",
                        dateRanges: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        AVCSingleDayDir.AVCSingleDayDirCtrl];
                    return _this;
                }
                AVCSingleDayDir.directiveId = "idpAvcSingleDay";
                return AVCSingleDayDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCSingleDayDir = AVCSingleDayDir;
            (function (AVCSingleDayDir) {
                var AVCSingleDayDirCtrl = (function (_super) {
                    __extends(AVCSingleDayDirCtrl, _super);
                    function AVCSingleDayDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCSingleDayDirCtrl.controllerId) || this;
                        _this.selectedProdPopupAPI = null;
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.activateController();
                        return _this;
                    }
                    AVCSingleDayDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        scope.$watch(function (scope) {
                            return _this.dateRanges;
                        }, function (newValue, oldValue) {
                            _this.selectCurrentDateRange(newValue);
                        });
                        scope.$watch(function (scope) {
                            return _this.selectedDateRangeIndex;
                        }, function (newValue, oldValue) {
                            _this.loadProductInfo(_this.selectedDateRange);
                        });
                    };
                    AVCSingleDayDirCtrl.prototype.loadProductInfo = function (selectedDateRange) {
                        var _this = this;
                        var _self = this;
                        this.common.toggleSpinner(true);
                        this.regFlowMgr.getProducts(selectedDateRange.locationCatDateRangeID, selectedDateRange.catalogTypeID)
                            .then(function (data) {
                            _self.productDTOs = Pulse.Utils.JS.findByProperties(data.products, { isMainCatalogEntry: 1 });
                            _self.prodGenresDTOs = data.productGenres;
                            _self.prodDateDTOs = data.productDates;
                            _self.prodStyleMtxDTOs = data.productStyleMatrixes;
                            _self.prodStyleDivDTOs = data.productStyleDivisions;
                            _self.prodSkillDTOs = data.productSkills;
                            _self.prodUrlDTOs = data.productURLs;
                            _self.relatedProdDTOs = data.relatedProducts;
                            _self.uniqueProducts = Pulse.Utils.JS.selectDistinctPropertiesIntoArray(_self.productDTOs, "productID", "name", "minimumAge", "maximumAge");
                            if (_self.productDTOs.length > 0) {
                                var prodDTO = _self.productDTOs[0];
                                _this.regFlowMgr.getProductQuantitiesByLocationIDDivisionID(prodDTO.locationID, prodDTO.divisionID, prodDTO.catalogTypeID, 0, _self.selectedDateRange.locationCatDateRangeID)
                                    .then(function (data) {
                                    _self.prodQtyDTOs = data;
                                });
                            }
                            else {
                                _self.prodQtyDTOs = null;
                            }
                        })
                            .finally(function () {
                            _self.common.toggleSpinner(false);
                        });
                    };
                    AVCSingleDayDirCtrl.prototype.onSelect = function () {
                        this.isCollapsed = !this.isCollapsed;
                    };
                    AVCSingleDayDirCtrl.prototype.selectCurrentDateRange = function (dateRanges) {
                        if (!dateRanges)
                            return;
                        var currentDate = this.pulseContext.serverDateTime;
                        for (var i = 0; i < dateRanges.length; i++) {
                            var dateRange = dateRanges[i];
                            if (dateRange.startDate <= currentDate && currentDate <= dateRange.endDate) {
                                this.selectedDateRangeIndex = i;
                                break;
                            }
                            else if (currentDate < dateRange.startDate) {
                                this.selectedDateRangeIndex = i;
                                break;
                            }
                        }
                        if (this.selectedDateRangeIndex == 0 && dateRanges[dateRanges.length - 1].endDate < currentDate) {
                            this.selectedDateRangeIndex = dateRanges.length - 1;
                        }
                    };
                    AVCSingleDayDirCtrl.prototype.prevDateRange = function () {
                        if (this.selectedDateRangeIndex > 0) {
                            this.selectedDateRangeIndex--;
                        }
                    };
                    AVCSingleDayDirCtrl.prototype.nextDateRange = function () {
                        if (this.selectedDateRangeIndex < this.dateRanges.length - 1) {
                            this.selectedDateRangeIndex++;
                        }
                    };
                    Object.defineProperty(AVCSingleDayDirCtrl.prototype, "selectedDateRange", {
                        get: function () {
                            return this.dateRanges[this.selectedDateRangeIndex];
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCSingleDayDirCtrl.prototype, "displayDateRange", {
                        get: function () {
                            var dateRange = this.selectedDateRange;
                            var result;
                            if (dateRange) {
                                result = String.format("({0} - {1})", this.common.$filter('date')(dateRange.startDate, 'MMM d'), this.common.$filter('date')(dateRange.endDate, 'MMM d'));
                            }
                            return result;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AVCSingleDayDirCtrl.controllerId = "AVCSingleDayDirCtrl";
                    return AVCSingleDayDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCSingleDayDir.AVCSingleDayDirCtrl = AVCSingleDayDirCtrl;
            })(AVCSingleDayDir = PulsePublic.AVCSingleDayDir || (PulsePublic.AVCSingleDayDir = {}));
            Pulse.app.directive(AVCSingleDayDir.directiveId, ["common", function (c) { return new AVCSingleDayDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCSingleDayProdDir = (function (_super) {
                __extends(AVCSingleDayProdDir, _super);
                function AVCSingleDayProdDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-single-day-prod.html";
                    _this.require = "^" + PulsePublic.AVCSingleDayDir.directiveId;
                    _this.scope = {
                        productInfo: "=",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        AVCSingleDayProdDir.AVCSingleDayProdDirCtrl];
                    return _this;
                }
                AVCSingleDayProdDir.directiveId = "idpAvcSingleDayProd";
                return AVCSingleDayProdDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCSingleDayProdDir = AVCSingleDayProdDir;
            (function (AVCSingleDayProdDir) {
                var AVCSingleDayProdDirCtrl = (function (_super) {
                    __extends(AVCSingleDayProdDirCtrl, _super);
                    function AVCSingleDayProdDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCSingleDayProdDirCtrl.controllerId) || this;
                        _this.isCollapsed = true;
                        _this.selectedMonthIndex = 0;
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.availChartMgr = _this.regFlowMgr.availChartMgr;
                        _this.activateController();
                        return _this;
                    }
                    AVCSingleDayProdDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.parentCtrl = ctrls;
                        scope.$watch(function (scope) {
                            return _this.productInfo;
                        }, function (newValue, oldValue) {
                            _this.loadProductInfo();
                        });
                    };
                    AVCSingleDayProdDirCtrl.prototype.onSelect = function () {
                        this.isCollapsed = !this.isCollapsed;
                        if (!this.isCollapsed) {
                            this.loadDateInfo();
                        }
                    };
                    AVCSingleDayProdDirCtrl.prototype.loadProductInfo = function () {
                        var urls = Pulse.Utils.JS.findByProperties(this.parentCtrl.prodUrlDTOs, { productID: this.productInfo.productID });
                        for (var i = 0; i < urls.length; i++) {
                            var urlInfo = urls[i];
                            this.prodDetailUrl = this.prodDetailUrl || (urlInfo.usageTypeID == Enums.ProductURLType.CourseDetailsURL ? urlInfo.uRL : this.prodDetailUrl);
                            this.prodVideoUrl = this.prodVideoUrl || (urlInfo.usageTypeID == Enums.ProductURLType.CourseVideoURL ? urlInfo.uRL : this.prodVideoUrl);
                            this.prodThumbImgUrl = this.prodThumbImgUrl || (urlInfo.usageTypeID == Enums.ProductURLType.CourseVideoIntroImageURL ? urlInfo.uRL : this.prodThumbImgUrl);
                        }
                        this.productDTOs = Pulse.Utils.JS.findByProperties(this.parentCtrl.productDTOs, { productID: this.productInfo.productID });
                    };
                    AVCSingleDayProdDirCtrl.prototype.loadDateInfo = function () {
                        this.prodDates = Pulse.Utils.JS.findByProperties(this.parentCtrl.prodDateDTOs, { productID: this.productInfo.productID });
                        if (this.prodDates) {
                            this.months = this.months || new Array();
                            for (var i = 0; i < this.prodDates.length; i++) {
                                var startTime = this.prodDates[i].startTime;
                                var foundMonth = Pulse.Utils.JS.findByProperties(this.months, { value: startTime.getMonth() });
                                if (!foundMonth || foundMonth.length == 0) {
                                    var monthStr = this.common.$filter('date')(startTime, 'MMMM');
                                    this.months.push({ value: startTime.getMonth(), name: monthStr });
                                }
                                startTime.toTimeString();
                            }
                        }
                        this.loadMonthlyProdDates();
                    };
                    AVCSingleDayProdDirCtrl.prototype.loadMonthlyProdDates = function () {
                        this.selectedMonthProdDates = new Array();
                        var month = this.months[this.selectedMonthIndex].value;
                        for (var i = 0; i < this.prodDates.length; i++) {
                            if (this.prodDates[i].startTime.getMonth() == month) {
                                this.selectedMonthProdDates.push(this.prodDates[i]);
                            }
                        }
                        this.selectedMonthProdDates = this.selectedMonthProdDates.sort(function (v1, v2) { return Pulse.Utils.JS.compareForSort(v1, v2, { 'startTime': 0 }); });
                    };
                    Object.defineProperty(AVCSingleDayProdDirCtrl.prototype, "thumbNailFullUrl", {
                        get: function () {
                            if (!this.prodThumbImgUrl)
                                return undefined;
                            var result = this.common.config.courseVideoThumbnailUrl + "/";
                            var thumbNailSegments = this.prodThumbImgUrl.split(".");
                            if (this.common.isMobileView) {
                                result += thumbNailSegments[0] + "_s." + thumbNailSegments[1];
                            }
                            else {
                                result += thumbNailSegments[0] + "_l." + thumbNailSegments[1];
                            }
                            return result;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCSingleDayProdDirCtrl.prototype, "productDetailFullUrl", {
                        get: function () {
                            var result = this.common.config.WWW_UrlRoot + "/";
                            result += this.prodDetailUrl;
                            return result;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AVCSingleDayProdDirCtrl.prototype, "productVideoFullUrl", {
                        get: function () {
                            return this.pulseContext.systemMgr.buildCourseVideoUrl(this.productInfo.productID);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AVCSingleDayProdDirCtrl.prototype.prevMonth = function () {
                        if (this.selectedMonthIndex > 0) {
                            this.selectedMonthIndex--;
                            this.loadMonthlyProdDates();
                        }
                    };
                    AVCSingleDayProdDirCtrl.prototype.nextMonth = function () {
                        if (this.selectedMonthIndex < this.months.length - 1) {
                            this.selectedMonthIndex++;
                            this.loadMonthlyProdDates();
                        }
                    };
                    Object.defineProperty(AVCSingleDayProdDirCtrl.prototype, "displayMonth", {
                        get: function () {
                            var result = undefined;
                            if (this.months) {
                                result = this.months[this.selectedMonthIndex].name;
                            }
                            return result;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AVCSingleDayProdDirCtrl.prototype.getProductPrice = function (prodDate) {
                        var matches = Pulse.Utils.JS.findByProperties(this.productDTOs, {
                            productID: this.productInfo.productID,
                            scheduleDefID: prodDate.scheduleDefID,
                            sessionID: prodDate.sessionID
                        });
                        return matches[0].price;
                    };
                    AVCSingleDayProdDirCtrl.prototype.getQtyAvailable = function (prodDate) {
                        var matches = Pulse.Utils.JS.findByProperties(this.parentCtrl.prodQtyDTOs, {
                            productID: this.productInfo.productID,
                            scheduleDefID: prodDate.scheduleDefID,
                            sessionID: prodDate.sessionID
                        });
                        if (matches.length == 0)
                            return 0;
                        return matches[0].qtyAvailable;
                    };
                    AVCSingleDayProdDirCtrl.prototype.getAvailabilityString = function (prodDate) {
                        var matches = Pulse.Utils.JS.findByProperties(this.parentCtrl.prodQtyDTOs, {
                            productID: this.productInfo.productID,
                            scheduleDefID: prodDate.scheduleDefID,
                            sessionID: prodDate.sessionID
                        });
                        if (matches.length == 0)
                            return "Not Available";
                        return matches[0].qtyString;
                    };
                    AVCSingleDayProdDirCtrl.prototype.selectProdPopup = function (prodDate) {
                        var productDTOs = Pulse.Utils.JS.findByProperties(this.productDTOs, {
                            productID: this.productInfo.productID,
                            scheduleDefID: prodDate.scheduleDefID,
                            sessionID: prodDate.sessionID
                        });
                        if (!productDTOs || productDTOs.length == 0) {
                            throw new Error(StringConst.Err_Data_Missing);
                        }
                        this.common.$rootScope.$broadcast(Events.ShowAVCSelectedPopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Medium,
                            initDataObj: {
                                location: this.parentCtrl.location,
                                salesCatalogType: Enums.SalesCatalogType.AtSchoolOneDay,
                                urls: {
                                    thumbNailFullUrl: this.thumbNailFullUrl,
                                    prodDetailFullUrl: this.productDetailFullUrl,
                                    prodVideoFullUrl: this.productVideoFullUrl
                                },
                                prodInfos: productDTOs
                            }
                        });
                    };
                    AVCSingleDayProdDirCtrl.controllerId = "AVCSingleDayProdDirCtrl";
                    return AVCSingleDayProdDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCSingleDayProdDir.AVCSingleDayProdDirCtrl = AVCSingleDayProdDirCtrl;
            })(AVCSingleDayProdDir = PulsePublic.AVCSingleDayProdDir || (PulsePublic.AVCSingleDayProdDir = {}));
            Pulse.app.directive(AVCSingleDayProdDir.directiveId, ["common", function (c) { return new AVCSingleDayProdDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var Managers = Pulse.Common.DataAccess.Managers;
            var AVCSelectedPopup = (function (_super) {
                __extends(AVCSelectedPopup, _super);
                function AVCSelectedPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        AVCSelectedPopup.AVCSelectedPopupCtrl];
                    return _this;
                }
                AVCSelectedPopup.directiveId = "idpAvcSelectedPopup";
                return AVCSelectedPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.AVCSelectedPopup = AVCSelectedPopup;
            (function (AVCSelectedPopup) {
                var AVCSelectedPopupCtrl = (function (_super) {
                    __extends(AVCSelectedPopupCtrl, _super);
                    function AVCSelectedPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, AVCSelectedPopupCtrl.controllerId) || this;
                        _this.isLoginCollapsed = true;
                        _this.isHalfDayPurchasedList = [];
                        _this.isChangeOrder = false;
                        _this.submitted = false;
                        _this.saveDisabled = false;
                        _this.formName = "frmAVCSelectProd";
                        _this.event_ShowPopup = Events.ShowAVCSelectedPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-selected-popup.html";
                        _this.breezeService.getEntityManager().rejectChanges();
                        _this.regFlowMgr = _this.pulseContext.regFlowMgr;
                        _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                        _this.ageMgr = new Managers.AgeMgr(_this.common, _this.breezeService, _this.pulseContext);
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.activateController();
                        return _this;
                    }
                    AVCSelectedPopupCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        this.title = this.initDataObj.location.name;
                        this.submitted = false;
                        this.participants = null;
                        if (this.initDataObj && this.initDataObj.prodInfos && this.initDataObj.prodInfos.length > 0) {
                            this.prodDTO = this.initDataObj.prodInfos[0];
                        }
                        if (Managers.ShoppingCartMgr.IsChangeOrderCartTypeID(this.pulseContext.shoppingCartType)) {
                            this.isChangeOrder = true;
                        }
                        this.breezeService.getEntityManager().rejectChanges();
                        this.activationPromises.push(this.loadData());
                        this.activateController();
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    AVCSelectedPopupCtrl.prototype.onRendered = function () {
                        _super.prototype.onRendered.call(this);
                    };
                    AVCSelectedPopupCtrl.prototype.loadData = function () {
                        var _this = this;
                        this.participants = null;
                        var promises = new Array();
                        promises.push(this.userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, true)
                            .then(function () {
                            if (_this.isChangeOrder) {
                                _this.participants = _this.userBrowsingMgr.currentUBSession.UB_ChildDTOs;
                            }
                            else {
                                if (_this.initDataObj.salesCatalogType === Enums.SalesCatalogType.AtSchoolOneDay) {
                                    _this.participants = (_this.userBrowsingMgr.getParticipantsByProductInfos(_this.userBrowsingMgr.currentUBSession, _this.initDataObj.prodInfos));
                                }
                                else if (_this.initDataObj.salesCatalogType === Enums.SalesCatalogType.AtSchoolMultiWeek) {
                                    _this.participants = (_this.userBrowsingMgr.getParticipantsByProductInfos(_this.userBrowsingMgr.currentUBSession, _this.initDataObj.prodInfos));
                                }
                                else if (_this.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                                    _this.participants = (_this.userBrowsingMgr.getParticipantsByProductInfos(_this.userBrowsingMgr.currentUBSession, _this.initDataObj.prodInfos.slice(0, 1)));
                                }
                                else {
                                    throw new Error(StringConst.Err_Data_Corrupt);
                                }
                                if (_this.participants.length == 0) {
                                    _this.addParticipant();
                                }
                            }
                        })
                            .then(function () {
                            var minAge = _this.prodDTO.minimumAge;
                            var maxAge = _this.prodDTO.maximumAge;
                            if (_this.initDataObj.salesCatalogType === Enums.SalesCatalogType.AtSchoolOneDay
                                || _this.initDataObj.salesCatalogType === Enums.SalesCatalogType.AtSchoolMultiWeek) {
                                promises.push(_this.ageMgr.calculateDivCourseMinMaxAgeCheckDate(_this.prodDTO.productID, _this.initDataObj.location.iD, _this.prodDTO.sessionID, _this.prodDTO.scheduleDefID, _this.initDataObj.salesCatalogType, true)
                                    .then(function (minAgeCheckDate) {
                                    var min = moment(minAgeCheckDate);
                                    min.subtract(minAge, "year");
                                    _this.maxDateOfBirth = min.startOf('day').toDate();
                                }));
                                promises.push(_this.ageMgr.calculateDivCourseMinMaxAgeCheckDate(_this.prodDTO.productID, _this.initDataObj.location.iD, _this.prodDTO.sessionID, _this.prodDTO.scheduleDefID, _this.initDataObj.salesCatalogType, false)
                                    .then(function (maxAgeCheckDate) {
                                    var max = moment(maxAgeCheckDate);
                                    max.subtract(maxAge, "year");
                                    max.add(1, "day");
                                    _this.minDateOfBirth = max.startOf('day').toDate();
                                }));
                            }
                            else if (_this.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                                promises.push(_this.ageMgr.calculateDivCourseMinMaxAgeCheckDate(_this.prodDTO.productID, _this.initDataObj.location.iD, _this.prodDTO.sessionID, -1, _this.initDataObj.salesCatalogType, true)
                                    .then(function (minAgeCheckDate) {
                                    var min = moment(minAgeCheckDate);
                                    min.subtract(minAge, "year");
                                    _this.minDateOfBirth = min.endOf('day').toDate();
                                }));
                                promises.push(_this.ageMgr.calculateDivCourseMinMaxAgeCheckDate(_this.prodDTO.productID, _this.initDataObj.location.iD, _this.prodDTO.sessionID, -1, _this.initDataObj.salesCatalogType, false)
                                    .then(function (maxAgeCheckDate) {
                                    var max = moment(maxAgeCheckDate);
                                    max.subtract(maxAge + 1, "year");
                                    max.add(1, "day");
                                    _this.maxDateOfBirth = max.startOf('day').toDate();
                                }));
                            }
                        }));
                        return this.common.$q.all(promises);
                    };
                    AVCSelectedPopupCtrl.prototype.onLoginExpandClicked = function () {
                        this.isLoginCollapsed = !this.isLoginCollapsed;
                    };
                    AVCSelectedPopupCtrl.prototype.isAlreadyInCart = function (participant) {
                        if (participant) {
                            for (var i = 0; i < this.initDataObj.prodInfos.length; i++) {
                                var checkProd = this.initDataObj.prodInfos[i];
                                if (this.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp && i > 0) {
                                    return false;
                                }
                                if (this.userBrowsingMgr.hasParticipantProdInCart(this.userBrowsingMgr.currentUBSession, participant, checkProd)) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    };
                    AVCSelectedPopupCtrl.prototype.addParticipant = function () {
                        var newUB = this.userBrowsingMgr.createNewRegFlowUserBrowsingDTO(Enums.ShoppingCartType.RegFlow);
                        this.participants.push(newUB);
                    };
                    AVCSelectedPopupCtrl.prototype.removeParticipant = function (participant) {
                        var _this = this;
                        var promises = new Array();
                        for (var i = 0; i < this.initDataObj.prodInfos.length; i++) {
                            var prodInfo = this.initDataObj.prodInfos[i];
                            var UBParts = this.userBrowsingMgr.getUBParticipantsByPacticipantAndProductInfo(this.userBrowsingMgr.currentUBSession, participant, prodInfo);
                            for (var j = 0; j < UBParts.length; j++) {
                                var UBParticipant = UBParts[j];
                                var linkInfo = {};
                                linkInfo.browseIdentifier = this.pulseContext.browseIdentifier;
                                linkInfo.userBrowsingParticipantID = UBParticipant.userBrowsingParticipantID;
                                linkInfo.customerUserBrowsingID = this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                linkInfo.beneficiaryUserBrowsingID = UBParticipant.userBrowsingID;
                                linkInfo.userBrowsingItemID = UBParticipant.userBrowsingItemID;
                                linkInfo.parentUserBrowsingItemID = UBParticipant.parentUserBrowsingItemID;
                                linkInfo.action = false;
                                promises.push(this.userBrowsingMgr.linkBeneficiaryToItem(linkInfo));
                            }
                        }
                        this.common.$q.all(promises)
                            .then(function (data) {
                            _this.loadData();
                        })
                            .catch(function (err) {
                            _this.logError(err);
                            _this.breezeService.getEntityManager().rejectChanges();
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    AVCSelectedPopupCtrl.prototype.hasAgeAdminOverride = function (participant, overrideTypeID) {
                        var ageOverride = {
                            child_UB_ID: participant.userBrowsingID,
                            locationID: this.prodDTO.locationID,
                            productID: this.prodDTO.productID,
                            sessionID: this.prodDTO.sessionID,
                            sessionProductDetailID: this.prodDTO.sessionProductDetailID,
                            overrideTypeID: overrideTypeID,
                            reasonTypeID: Enums.OverrideReasonType.FitBetterWithYoungerCourse
                        };
                        return false;
                    };
                    AVCSelectedPopupCtrl.prototype.isAgeValid = function (participant) {
                        var valid = moment(participant.dateOfBirth).isSameOrAfter(this.maxDateOfBirth)
                            && moment(participant.dateOfBirth).isSameOrBefore(this.minDateOfBirth);
                        if (!valid && this.pulseContext.isImpersonating) {
                            var ageOverride = {
                                child_UB_ID: participant.userBrowsingID,
                                locationID: this.prodDTO.locationID,
                                productID: this.prodDTO.productID,
                                sessionID: this.prodDTO.sessionID,
                                sessionProductDetailID: this.prodDTO.sessionProductDetailID,
                                scheduleDefID: this.prodDTO.scheduleDefID
                            };
                            valid = this.userBrowsingMgr.hasAdminOverride(this.userBrowsingMgr.currentUBSession, ageOverride);
                        }
                        return valid;
                    };
                    AVCSelectedPopupCtrl.prototype.addToCart = function (formSuffix, formName, participant) {
                        var _this = this;
                        this.common.clearStatus();
                        this.common.toggleSpinner(true, true, undefined, 0);
                        this.submitted = true;
                        this.saveDisabled = true;
                        var isAgeValid = this.isAgeValid(participant);
                        if (this.myForm.$valid && isAgeValid) {
                            this.userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, true)
                                .then(function () {
                                if (!participant.userBrowsingID || participant.userBrowsingID === 0) {
                                    var existingParticipant = _this.userBrowsingMgr.findExistingParticipant(_this.userBrowsingMgr.currentUBSession, participant);
                                    if (existingParticipant) {
                                        Pulse.Utils.JS.copyAllProperties(participant, existingParticipant);
                                    }
                                }
                                var info = _this.userBrowsingMgr.copyIUserBrowsingToIUpdateUserDataInfo(_this.userBrowsingMgr.currentUBSession, participant, true);
                                return _this.userBrowsingMgr.addOrUpdateUserData(_this.userBrowsingMgr.currentUBSession, info)
                                    .then(function (data) {
                                    var promises = new Array();
                                    Pulse.Utils.JS.copyOwnProperties(participant, data);
                                    if (participant.selectedProdInfos && participant.selectedProdInfos.length > 0) {
                                        var primOptUserBrowsingItemID = 0;
                                        var hasSelectedStandardCampPrimOpt_1 = false;
                                        if (_this.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                                            var primOptProd = _this.initDataObj.prodInfos.length > 1 ? _this.initDataObj.prodInfos[1] : null;
                                            if (primOptProd && Pulse.Utils.JS.findByProperties(participant.selectedProdInfos, { productID: primOptProd.productID }).length > 0) {
                                                hasSelectedStandardCampPrimOpt_1 = true;
                                                participant.selectedProdInfos.unshift(_this.initDataObj.prodInfos[0]);
                                            }
                                            var purchasedProds_1 = [];
                                            var selectedProdInfo_1 = participant.selectedProdInfos[0];
                                            var itemInfo = {};
                                            itemInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                            itemInfo.userBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                            itemInfo.productID = selectedProdInfo_1.productID;
                                            itemInfo.locationID = selectedProdInfo_1.locationID;
                                            itemInfo.sessionID = selectedProdInfo_1.sessionID;
                                            itemInfo.catalogTypeID = selectedProdInfo_1.catalogTypeID;
                                            itemInfo.sessionProductDetailID = selectedProdInfo_1.sessionProductDetailID;
                                            itemInfo.scheduleDefID = selectedProdInfo_1.scheduleDefID;
                                            itemInfo.action = true;
                                            promises.push(_this.userBrowsingMgr.selectItem(itemInfo)
                                                .then(function (data) {
                                                var updateOverrideObj = {
                                                    child_UB_ID: participant.userBrowsingID,
                                                    locationID: selectedProdInfo_1.locationID,
                                                    productID: selectedProdInfo_1.productID,
                                                    sessionID: selectedProdInfo_1.sessionID,
                                                    sessionProductDetailID: selectedProdInfo_1.sessionProductDetailID,
                                                    scheduleDefID: selectedProdInfo_1.scheduleDefID
                                                };
                                                _this.userBrowsingMgr.updateAdminOverride(_this.userBrowsingMgr.currentUBSession, updateOverrideObj);
                                                var linkInfo = {};
                                                linkInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                linkInfo.customerUserBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                linkInfo.beneficiaryUserBrowsingID = participant.userBrowsingID;
                                                linkInfo.userBrowsingItemID = data.userBrowsingItemID;
                                                linkInfo.action = true;
                                                return _this.userBrowsingMgr.linkBeneficiaryToItem(linkInfo)
                                                    .then(function () {
                                                    purchasedProds_1[0] = selectedProdInfo_1;
                                                    if (hasSelectedStandardCampPrimOpt_1) {
                                                        var primOptUserBrowsingItemID_1 = data.userBrowsingItemID;
                                                        var selectedProdInfo_2 = participant.selectedProdInfos[1];
                                                        var itemInfo_1 = {};
                                                        itemInfo_1.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                        itemInfo_1.parentUserBrowsingItemID = primOptUserBrowsingItemID_1;
                                                        itemInfo_1.userBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                        itemInfo_1.productID = selectedProdInfo_2.productID;
                                                        itemInfo_1.locationID = selectedProdInfo_2.locationID;
                                                        itemInfo_1.sessionID = selectedProdInfo_2.sessionID;
                                                        itemInfo_1.catalogTypeID = selectedProdInfo_2.catalogTypeID;
                                                        itemInfo_1.sessionProductDetailID = selectedProdInfo_2.sessionProductDetailID;
                                                        itemInfo_1.scheduleDefID = selectedProdInfo_2.scheduleDefID;
                                                        itemInfo_1.action = true;
                                                        return _this.userBrowsingMgr.selectItem(itemInfo_1)
                                                            .then(function (data) {
                                                            purchasedProds_1[1] = selectedProdInfo_2;
                                                            var linkInfo = {};
                                                            linkInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                            linkInfo.customerUserBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                            linkInfo.beneficiaryUserBrowsingID = participant.userBrowsingID;
                                                            linkInfo.userBrowsingItemID = data.userBrowsingItemID;
                                                            linkInfo.parentUserBrowsingItemID = primOptUserBrowsingItemID_1;
                                                            linkInfo.action = true;
                                                            _this.common.$rootScope.$broadcast(Events.ProductAddedToCart, purchasedProds_1);
                                                            return _this.userBrowsingMgr.linkBeneficiaryToItem(linkInfo);
                                                        });
                                                    }
                                                    else {
                                                        _this.common.$rootScope.$broadcast(Events.ProductAddedToCart, purchasedProds_1);
                                                    }
                                                });
                                            }));
                                        }
                                        else {
                                            for (var i = 0; i < participant.selectedProdInfos.length; i++) {
                                                var selectedProdInfo = participant.selectedProdInfos[i];
                                                var itemInfo = {};
                                                itemInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                itemInfo.userBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                itemInfo.productID = selectedProdInfo.productID;
                                                itemInfo.locationID = selectedProdInfo.locationID;
                                                itemInfo.sessionID = selectedProdInfo.sessionID;
                                                itemInfo.catalogTypeID = selectedProdInfo.catalogTypeID;
                                                itemInfo.sessionProductDetailID = selectedProdInfo.sessionProductDetailID;
                                                itemInfo.scheduleDefID = selectedProdInfo.scheduleDefID;
                                                itemInfo.action = true;
                                                var seletItemPromise = _this.userBrowsingMgr.selectItem(itemInfo)
                                                    .then(function (data) {
                                                    var linkInfo = {};
                                                    linkInfo.browseIdentifier = _this.pulseContext.browseIdentifier;
                                                    linkInfo.customerUserBrowsingID = _this.userBrowsingMgr.currentUBSession.userBrowsingDTO.userBrowsingID;
                                                    linkInfo.beneficiaryUserBrowsingID = participant.userBrowsingID;
                                                    linkInfo.userBrowsingItemID = data.userBrowsingItemID;
                                                    linkInfo.action = true;
                                                    return _this.userBrowsingMgr.linkBeneficiaryToItem(linkInfo);
                                                });
                                                promises.push(seletItemPromise);
                                            }
                                        }
                                        return _this.common.$q.all(promises);
                                    }
                                });
                            })
                                .then(function (data) {
                                _this.myForm.$setPristine();
                                return _this.loadData();
                            })
                                .then(function (data) {
                                _this.userBrowsingMgr.sendCartToMailChimp(_this.userBrowsingMgr.currentUBSession);
                                return;
                            })
                                .catch(function (err) {
                                _this.logError(err);
                                _this.breezeService.getEntityManager().rejectChanges();
                            })
                                .finally(function () {
                                _this.saveDisabled = false;
                                _this.submitted = false;
                                _this.common.toggleSpinner(false);
                            });
                        }
                        else {
                            this.common.toggleSpinner(false, true);
                            var msgBuilder = new Pulse.Utils.HtmlListItemizer();
                            if (this.myForm["prodForm_" + formSuffix][formName].$error.dateDisabled || !isAgeValid) {
                                if (this.pulseContext.isImpersonating) {
                                    this.common.$rootScope.$broadcast(Events.ShowRegFlowAdminOverridePopup, {
                                        size: Pulse.Common.BasePopup.ModalSize.Medium,
                                        initDataObj: {
                                            overrideReqs: [{
                                                    overrideType: PulsePublic.RegFlowAdminOverridePopup.OverrideUIType.AgeOverride,
                                                    productName: this.prodDTO.name,
                                                    minAge: this.prodDTO.minimumAge,
                                                    maxAge: this.prodDTO.maximumAge,
                                                    productID: this.prodDTO.productID,
                                                    sessionID: this.prodDTO.sessionID,
                                                    locationID: this.prodDTO.locationID,
                                                    sessionProductDetailID: this.prodDTO.sessionProductDetailID,
                                                    scheduleDefID: this.prodDTO.scheduleDefID,
                                                    DOB: participant.dateOfBirth,
                                                    child_UB_ID: participant.userBrowsingID,
                                                }]
                                        }
                                    });
                                    this.saveDisabled = false;
                                    this.submitted = false;
                                    return;
                                }
                                else {
                                    if (angular.isDate(participant.dateOfBirth)) {
                                        msgBuilder.add(StringConst.Warn_StudentNotMeetAgeRequirement);
                                    }
                                    else {
                                        msgBuilder.add(StringConst.Warn_StudentDOBRequired);
                                    }
                                }
                            }
                            if (this.initDataObj.salesCatalogType === Enums.SalesCatalogType.AtSchoolOneDay
                                || this.initDataObj.salesCatalogType === Enums.SalesCatalogType.AtSchoolMultiWeek) {
                                if (this.myForm["prodForm_" + formSuffix][formName].chkedProds.$error.required) {
                                    msgBuilder.add("Please select a session.");
                                }
                            }
                            else if (this.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                                if (!angular.isArray(participant.selectedProdInfos) || participant.selectedProdInfos.length < 1) {
                                    msgBuilder.add("Please select day or overnight camp.");
                                }
                            }
                            if (msgBuilder.length() > 0) {
                                this.common.showWarning(msgBuilder.toString());
                            }
                            this.submitted = false;
                            this.saveDisabled = false;
                        }
                    };
                    AVCSelectedPopupCtrl.prototype.checkout = function () {
                        if (this.userBrowsingMgr.currentUBSession.UB_ItemDTOs && this.userBrowsingMgr.currentUBSession.UB_ItemDTOs.length > 0) {
                            this.regFlowMgr.nextStep();
                        }
                        else {
                            this.common.showWarning("Shopping cart is empty. Please select a course to proceed.");
                        }
                    };
                    AVCSelectedPopupCtrl.prototype.isHalfDayPurchased = function (studentIndex) {
                        return this.isHalfDayPurchasedList[studentIndex];
                    };
                    AVCSelectedPopupCtrl.controllerId = "AVCSelectedPopupCtrl";
                    return AVCSelectedPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                AVCSelectedPopup.AVCSelectedPopupCtrl = AVCSelectedPopupCtrl;
            })(AVCSelectedPopup = PulsePublic.AVCSelectedPopup || (PulsePublic.AVCSelectedPopup = {}));
            Pulse.app.directive(AVCSelectedPopup.directiveId, ["common", function (c) { return new AVCSelectedPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCWaitlistAdd = (function (_super) {
                __extends(AVCWaitlistAdd, _super);
                function AVCWaitlistAdd(common) {
                    var _this = _super.call(this, common) || this;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        AVCWaitlistAdd.AVCWaitlistAddCtrl];
                    return _this;
                }
                AVCWaitlistAdd.directiveId = "idpAvcWaitlistAdd";
                return AVCWaitlistAdd;
            }(Pulse.Common.BasePopup));
            PulsePublic.AVCWaitlistAdd = AVCWaitlistAdd;
            (function (AVCWaitlistAdd) {
                var AVCWaitlistAddCtrl = (function (_super) {
                    __extends(AVCWaitlistAddCtrl, _super);
                    function AVCWaitlistAddCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, AVCWaitlistAddCtrl.controllerId) || this;
                        _this.isLoginCollapsed = true;
                        _this.hasNearestLocations = true;
                        _this.addedToWailist = false;
                        _this.btnJoinDisabled = false;
                        _this.formName = "frmAVCWaitlistAdd";
                        _this.event_ShowPopup = Events.ShowAVCWaitlistAdd;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-waitlist-add.html";
                        _this.breezeService.getEntityManager().rejectChanges();
                        _this.avMgr = _this.pulseContext.regFlowMgr.availChartMgr;
                        _this.activateController();
                        return _this;
                    }
                    AVCWaitlistAddCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        this.hasNearestLocations = true;
                        this.nearestLocations = [];
                        this.addedToWailist = false;
                        this.activationPromises.push(this.loadNearestLocations(this.initDataObj.spdID));
                        this.activateController();
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    AVCWaitlistAddCtrl.prototype.loadNearestLocations = function (spdId) {
                        var _this = this;
                        this.nearestLocations = null;
                        var promises = new Array();
                        promises.push(this.avMgr.getNearestLocations(spdId, 3, false)
                            .then(function (data) {
                            if (data && data.length > 0) {
                                _this.nearestLocations = data;
                                _this.hasNearestLocations = true;
                            }
                            else {
                                _this.hasNearestLocations = false;
                            }
                        }));
                        return this.common.$q.all(promises);
                    };
                    AVCWaitlistAddCtrl.prototype.submit = function () {
                        var _this = this;
                        if (this.myForm.$valid) {
                            this.common.toggleSpinner(true);
                            var wlRec = {
                                email: this.emailAddress,
                                spdID: this.initDataObj.spdID
                            };
                            var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                            userBrowsingMgr.addToWaitlist(userBrowsingMgr.currentUBSession, wlRec)
                                .then(function (response) {
                                _this.addedToWailist = true;
                            })
                                .catch(function (err) {
                                _this.logError(err);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                        else {
                            this.common.showWarning(Pulse.Common.Resources.StringConsts.Warn_GenericValidationError);
                        }
                    };
                    AVCWaitlistAddCtrl.prototype.back = function () {
                        this.close();
                    };
                    AVCWaitlistAddCtrl.prototype.showPrivacyPolicy = function () {
                        this.common.$rootScope.$broadcast(Events.ShowIFramePopup, {
                            size: Pulse.Common.BasePopup.ModalSize.Medium,
                            initDataObj: {
                                url: this.pulseContext.pulse1x_PublicUrlRoot + "/TermsAndConditions.aspx?" + QueryStringUtils.COMPANY_ID + "=" + this.pulseContext.companyId + "#privacy",
                                title: "Privacy Policy",
                            },
                        });
                    };
                    AVCWaitlistAddCtrl.controllerId = "AVCWaitlistAddCtrl";
                    return AVCWaitlistAddCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                AVCWaitlistAdd.AVCWaitlistAddCtrl = AVCWaitlistAddCtrl;
            })(AVCWaitlistAdd = PulsePublic.AVCWaitlistAdd || (PulsePublic.AVCWaitlistAdd = {}));
            Pulse.app.directive(AVCWaitlistAdd.directiveId, ["common", function (c) { return new AVCWaitlistAdd(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCSelectProdDirOld = (function (_super) {
                __extends(AVCSelectProdDirOld, _super);
                function AVCSelectProdDirOld(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot
                        + Paths.PulsePublicDirective + 'reg-flow/old-avail-chart/idp-avc-select-prod.html';
                    _this.scope = {
                        formName: '@?',
                        formSuffix: '@?',
                        isAlreadyInCart: '=',
                        maxDate: '=',
                        minDate: '=',
                        participant: '=',
                        prodInfos: '=',
                    };
                    _this.controller = ['$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        AVCSelectProdDirOld.AVCSelectProdDirOldCtrl];
                    return _this;
                }
                AVCSelectProdDirOld.directiveId = 'idpAvcSelectProdOld';
                return AVCSelectProdDirOld;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AVCSelectProdDirOld = AVCSelectProdDirOld;
            (function (AVCSelectProdDirOld) {
                var AVCSelectProdDirOldCtrl = (function (_super) {
                    __extends(AVCSelectProdDirOldCtrl, _super);
                    function AVCSelectProdDirOldCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AVCSelectProdDirOldCtrl.controllerId) || this;
                        _this.selectedProdIndexes = {};
                        _this.userBrowsingMgr = pulseContext.regFlowMgr.userBrowsingMgr;
                        _this.avcMgr = pulseContext.regFlowMgr.availChartMgr;
                        _this.locMgr = pulseContext.regFlowMgr.locationFinderMgr;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.activationPromises.push(_this.locMgr.loadInfo()
                            .then(function () {
                            return _this.avcMgr.loadStandardCampTermDivSessionInfo(_this.locMgr.selectedIds);
                        }));
                        _this.activateController();
                        return _this;
                    }
                    AVCSelectProdDirOldCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.parentCtrl = (scope.$parent).vm;
                        if (this.parentCtrl.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                            this.courseSession = this.parentCtrl.initDataObj.courseSession;
                            if (this.prodInfos && this.prodInfos.length > 0)
                                this.campMainProd = this.prodInfos[0];
                            if (this.prodInfos && this.prodInfos.length > 1)
                                this.campOptionProd = this.prodInfos[1];
                        }
                        scope.$watch(function (s) {
                            return _this.participant;
                        }, function (newValue, oldValue) {
                            if (_this.participant) {
                                _this.setupSelectedProds();
                            }
                        });
                    };
                    AVCSelectProdDirOldCtrl.prototype.selectProd = function (index, prodInfo) {
                        if (this.selectedProdIndexes[index]) {
                            if (this.parentCtrl.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                                this.selectedProdInfos.splice(0, this.selectedProdInfos.length);
                                for (var indexKey in this.selectedProdIndexes) {
                                    if (this.selectedProdIndexes.hasOwnProperty(indexKey) && indexKey !== index.toString()) {
                                        this.selectedProdIndexes[indexKey] = false;
                                    }
                                }
                            }
                            if (this.selectedProdInfos.indexOf(prodInfo) < 0) {
                                this.selectedProdInfos.push(prodInfo);
                            }
                        }
                        else {
                            var tempIndex = this.selectedProdInfos.indexOf(prodInfo);
                            if (tempIndex >= 0) {
                                this.selectedProdInfos.splice(tempIndex, 1);
                            }
                        }
                    };
                    AVCSelectProdDirOldCtrl.prototype.selectProduct = function (prodInfo) {
                        if (this.parentCtrl.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp) {
                            this.selectedProdInfos.splice(0, this.selectedProdInfos.length);
                        }
                        if (this.selectedProdInfos.indexOf(prodInfo) < 0) {
                            this.selectedProdInfos.push(prodInfo);
                        }
                    };
                    AVCSelectProdDirOldCtrl.prototype.removeProduct = function (prodInfo) {
                        var tempIndex = this.selectedProdInfos.indexOf(prodInfo);
                        if (tempIndex >= 0) {
                            this.selectedProdInfos.splice(tempIndex, 1);
                        }
                    };
                    AVCSelectProdDirOldCtrl.prototype.setupSelectedProds = function () {
                        this.participant.selectedProdInfos = this.participant.selectedProdInfos
                            || this.userBrowsingMgr.getCartProdInfoByParticipant(this.userBrowsingMgr.currentUBSession, this.participant);
                        this.selectedProdInfos = this.participant.selectedProdInfos;
                        if (this.selectedProdInfos.length > 0) {
                            for (var i = 0; i < this.prodInfos.length; i++) {
                                var prodInfo = this.prodInfos[i];
                                if (!prodInfo) {
                                    continue;
                                }
                                var filterObj = {};
                                if (prodInfo.productID > 0) {
                                    filterObj.productID = prodInfo.productID;
                                }
                                if (prodInfo.locationID > 0) {
                                    filterObj.locationID = prodInfo.locationID;
                                }
                                if (prodInfo.sessionID > 0) {
                                    filterObj.sessionID = prodInfo.sessionID;
                                }
                                if (prodInfo.sessionProductDetailID > 0) {
                                    filterObj.sessionProductDetailID = prodInfo.sessionProductDetailID;
                                }
                                if (prodInfo.scheduleDefID > 0) {
                                    filterObj.scheduleDefID = prodInfo.scheduleDefID;
                                }
                                var matches = Pulse.Utils.JS.findByProperties(this.selectedProdInfos, filterObj);
                                if (matches && matches.length > 0) {
                                    this.selectedProdIndexes[i + ''] = true;
                                    if (this.parentCtrl.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp
                                        && i > 0) {
                                        this.selectedProdIndexes[0] = false;
                                    }
                                }
                                else if (this.parentCtrl.initDataObj.salesCatalogType === Enums.SalesCatalogType.StandardCamp
                                    && i === 0) {
                                    break;
                                }
                            }
                        }
                    };
                    AVCSelectProdDirOldCtrl.prototype.hasSelectedProd = function () {
                        var isSelected = false;
                        for (var i = 0; i < this.prodInfos.length; i++) {
                            if (this.selectedProdIndexes[i + '']) {
                                isSelected = true;
                                continue;
                            }
                        }
                        return isSelected;
                    };
                    AVCSelectProdDirOldCtrl.prototype.campMainProductPrice = function () {
                        if (!this.campMainProd) {
                            return '';
                        }
                        if (this.campMainProd.programTypeID === 307001) {
                            return '2-Week Program for $' + this.campMainProd.price;
                        }
                        else if (this.campMainProd.programTypeID === 307000 || this.campMainProd.programTypeID === 307003) {
                            return '$' + this.campMainProd.price + ' per week';
                        }
                        else if (this.campMainProd.programTypeID === 307002) {
                            return '$' + this.campMainProd.price;
                        }
                        else {
                            return '';
                        }
                    };
                    AVCSelectProdDirOldCtrl.prototype.campOptionPrice = function () {
                        if (!this.campOptionProd) {
                            return '';
                        }
                        if (this.campOptionProd.programTypeID === 307001) {
                            return '2-Week Program for $' + this.campOptionProd.price;
                        }
                        else {
                            return '$' + this.campOptionProd.price + ' per week';
                        }
                    };
                    AVCSelectProdDirOldCtrl.prototype.checkIsAlreadyInCart = function (participant) {
                        return this.parentCtrl.isAlreadyInCart(participant);
                    };
                    AVCSelectProdDirOldCtrl.prototype.hasOvernightOptionAvailable = function () {
                        var isAvailable = !!this.isAlreadyInCart;
                        if (!isAvailable) {
                            isAvailable = this.isOvernightAvailable()
                                && this.isOvernightAllowedByAge()
                                && (!this.avcMgr.isSessionClosedForAddingResidency({})
                                    || this.pulseContext.isImpersonating);
                        }
                        return isAvailable;
                    };
                    AVCSelectProdDirOldCtrl.prototype.isOvernightAvailable = function () {
                        var isAvailable = false;
                        var availableStatuses = [
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.AlmostFull],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Open],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Space1],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Space2],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Space3],
                            Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.Space4],
                        ];
                        if (availableStatuses.indexOf(this.courseSession.optionStatus) > -1) {
                            isAvailable = true;
                        }
                        return isAvailable;
                    };
                    AVCSelectProdDirOldCtrl.prototype.isOvernightAllowedByAge = function () {
                        if (!this.campOptionProd) {
                            return false;
                        }
                        var hasOverlap = this.campMainProd.minimumAge <= this.campOptionProd.maximumAge
                            && this.campMainProd.maximumAge >= this.campOptionProd.minimumAge;
                        return hasOverlap;
                    };
                    AVCSelectProdDirOldCtrl.controllerId = 'AVCSelectProdDirOldCtrl';
                    return AVCSelectProdDirOldCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AVCSelectProdDirOld.AVCSelectProdDirOldCtrl = AVCSelectProdDirOldCtrl;
            })(AVCSelectProdDirOld = PulsePublic.AVCSelectProdDirOld || (PulsePublic.AVCSelectProdDirOld = {}));
            Pulse.app.directive(AVCSelectProdDirOld.directiveId, [
                'common',
                function (c) { return new AVCSelectProdDirOld(c); }
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCPrereqPopup = (function (_super) {
                __extends(AVCPrereqPopup, _super);
                function AVCPrereqPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        AVCPrereqPopup.AVCPrereqPopupCtrl];
                    return _this;
                }
                AVCPrereqPopup.directiveId = "idpAvcPrereqPopup";
                return AVCPrereqPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.AVCPrereqPopup = AVCPrereqPopup;
            (function (AVCPrereqPopup) {
                var AVCPrereqPopupCtrl = (function (_super) {
                    __extends(AVCPrereqPopupCtrl, _super);
                    function AVCPrereqPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, AVCPrereqPopupCtrl.controllerId) || this;
                        _this.title = "Prerequisite Information";
                        _this.event_ShowPopup = Events.ShowAVCPrereqPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-prereq-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    AVCPrereqPopupCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    AVCPrereqPopupCtrl.controllerId = "AVCPrereqPopupCtrl";
                    return AVCPrereqPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                AVCPrereqPopup.AVCPrereqPopupCtrl = AVCPrereqPopupCtrl;
            })(AVCPrereqPopup = PulsePublic.AVCPrereqPopup || (PulsePublic.AVCPrereqPopup = {}));
            Pulse.app.directive(AVCPrereqPopup.directiveId, ["common", function (c) { return new AVCPrereqPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var Managers = Pulse.Common.DataAccess.Managers;
            var AVCAgePopup = (function (_super) {
                __extends(AVCAgePopup, _super);
                function AVCAgePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        AVCAgePopup.AVCAgePopupCtrl];
                    return _this;
                }
                AVCAgePopup.directiveId = "idpAvcAgePopup";
                return AVCAgePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.AVCAgePopup = AVCAgePopup;
            (function (AVCAgePopup) {
                var AVCAgePopupCtrl = (function (_super) {
                    __extends(AVCAgePopupCtrl, _super);
                    function AVCAgePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, AVCAgePopupCtrl.controllerId) || this;
                        _this.title = "Age Policy";
                        _this.event_ShowPopup = Events.ShowAVCAgePopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/_test/idp-avc-age-popup.html";
                        _this.ageMgr = new Managers.AgeMgr(_this.common, _this.breezeService, _this.pulseContext);
                        _this.activateController();
                        return _this;
                    }
                    AVCAgePopupCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        this.minAgeCheckDate = undefined;
                        this.activationPromises.push(this.loadData());
                        this.activateController();
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    AVCAgePopupCtrl.prototype.loadData = function () {
                        var _this = this;
                        var promises = new Array();
                        promises.push(this.ageMgr.calculateDivCourseMinMaxAgeCheckDate(this.initDataObj.productID, this.initDataObj.locationID, this.initDataObj.sessionID, this.initDataObj.scheduleDefID, this.initDataObj.salesCatalogType, true)
                            .then(function (minAgeCheckDate) {
                            _this.minAgeCheckDate = minAgeCheckDate;
                        }));
                        return this.common.$q.all(promises);
                    };
                    AVCAgePopupCtrl.controllerId = "AVCAgePopupCtrl";
                    return AVCAgePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                AVCAgePopup.AVCAgePopupCtrl = AVCAgePopupCtrl;
            })(AVCAgePopup = PulsePublic.AVCAgePopup || (PulsePublic.AVCAgePopup = {}));
            Pulse.app.directive(AVCAgePopup.directiveId, ["common", function (c) { return new AVCAgePopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var Managers = Pulse.Common.DataAccess.Managers;
            var AVCInfoPopupOld = (function (_super) {
                __extends(AVCInfoPopupOld, _super);
                function AVCInfoPopupOld(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        AVCInfoPopupOld.AVCInfoPopupOldCtrl];
                    return _this;
                }
                AVCInfoPopupOld.directiveId = "idpAvcInfoPopupOld";
                return AVCInfoPopupOld;
            }(Pulse.Common.BasePopup));
            PulsePublic.AVCInfoPopupOld = AVCInfoPopupOld;
            (function (AVCInfoPopupOld) {
                var AVCInfoPopupOldCtrl = (function (_super) {
                    __extends(AVCInfoPopupOldCtrl, _super);
                    function AVCInfoPopupOldCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, AVCInfoPopupOldCtrl.controllerId) || this;
                        _this.title = "Course Information";
                        _this.event_ShowPopup = Events.ShowAVCInfoPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-info-popup.html";
                        _this.ageMgr = new Managers.AgeMgr(_this.common, _this.breezeService, _this.pulseContext);
                        _this.activateController();
                        return _this;
                    }
                    AVCInfoPopupOldCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        this.minAgeCheckDate = undefined;
                        if (this.initDataObj && this.initDataObj.prodInfos && this.initDataObj.prodInfos.length > 0) {
                            this.prodDTO = this.initDataObj.prodInfos[0];
                        }
                        this.activateController();
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    AVCInfoPopupOldCtrl.prototype.loadData = function () {
                        var promises = new Array();
                        return this.common.$q.all(promises);
                    };
                    AVCInfoPopupOldCtrl.controllerId = "AVCInfoPopupOldCtrl";
                    return AVCInfoPopupOldCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                AVCInfoPopupOld.AVCInfoPopupOldCtrl = AVCInfoPopupOldCtrl;
            })(AVCInfoPopupOld = PulsePublic.AVCInfoPopupOld || (PulsePublic.AVCInfoPopupOld = {}));
            Pulse.app.directive(AVCInfoPopupOld.directiveId, ["common", function (c) { return new AVCInfoPopupOld(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var AVCOptionsPopup = (function (_super) {
                __extends(AVCOptionsPopup, _super);
                function AVCOptionsPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        AVCOptionsPopup.AVCOptionsPopupCtrl];
                    return _this;
                }
                AVCOptionsPopup.directiveId = "idpAvcOptionsPopup";
                return AVCOptionsPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.AVCOptionsPopup = AVCOptionsPopup;
            (function (AVCOptionsPopup) {
                var AVCOptionsPopupCtrl = (function (_super) {
                    __extends(AVCOptionsPopupCtrl, _super);
                    function AVCOptionsPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, AVCOptionsPopupCtrl.controllerId) || this;
                        _this.event_ShowPopup = Events.ShowAVCOptionsPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/old-avail-chart/idp-avc-options-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    AVCOptionsPopupCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    AVCOptionsPopupCtrl.controllerId = "AVCOptionsPopupCtrl";
                    return AVCOptionsPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                AVCOptionsPopup.AVCOptionsPopupCtrl = AVCOptionsPopupCtrl;
            })(AVCOptionsPopup = PulsePublic.AVCOptionsPopup || (PulsePublic.AVCOptionsPopup = {}));
            Pulse.app.directive(AVCOptionsPopup.directiveId, ["common", function (c) { return new AVCOptionsPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var ShoppingCartMgr = Pulse.Common.DataAccess.Managers.ShoppingCartMgr;
            var StudentMergePopup = (function (_super) {
                __extends(StudentMergePopup, _super);
                function StudentMergePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        StudentMergePopup.StudentMergePopupCtrl];
                    return _this;
                }
                StudentMergePopup.directiveId = "idpStudentMergePopup";
                return StudentMergePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.StudentMergePopup = StudentMergePopup;
            (function (StudentMergePopup) {
                var StudentMergePopupCtrl = (function (_super) {
                    __extends(StudentMergePopupCtrl, _super);
                    function StudentMergePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, StudentMergePopupCtrl.controllerId) || this;
                        _this.initDataObj = {
                            participant: null,
                            firstTabIndex: 100,
                        };
                        _this.matchingStudentCandidates = [];
                        _this.selectedUserID = 0;
                        _this.event_ShowPopup = Events.ShowStudentMergePopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/order-summary/idp-student-merge-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    StudentMergePopupCtrl.prototype.close = function () {
                        _super.prototype.close.call(this);
                    };
                    StudentMergePopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.relatedUsers = [];
                        this.matchingStudentCandidates = [];
                        this.selectedUserID = 0;
                        this.initDataObj = initDataObj;
                        if (initDataObj) {
                            if (initDataObj.participant) {
                                this.participant = initDataObj.participant;
                                this.participant.firstName = this.participant.firstName.trim();
                                this.participant.lastName = this.participant.lastName.trim();
                                this.allOtherCartParticipants = this.common.$filter('filter')(this.participant.parent.participants, { userBrowsingID: "!" + this.participant.userBrowsingID.toString() });
                            }
                        }
                        this.breezeService.getEntityManager().rejectChanges();
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        this.setLocalizedTexts();
                        this.getRelatedStudents(this.pulseContext.actingAsUserId, this.participant.firstName, this.participant.lastName, this.participant.genderTypeID, this.participant.dateOfBirth);
                    };
                    StudentMergePopupCtrl.prototype.getRelatedStudents = function (actingAsUserID, studentFirstName, studentLastName, studentGenderTypeID, studentDateOfBirth) {
                        var self = this;
                        var alreadyMatchedCartStudents = (this.allOtherCartParticipants && this.allOtherCartParticipants.length > 0) ? ShoppingCartMgr.RegisteredStudentsInCart(this.allOtherCartParticipants, true)
                            : [];
                        this.common.toggleSpinner(true);
                        this.pulseContext.userMgr.loadRelatedUsersForActingUser(true, false)
                            .then(function (data) {
                            self.relatedUsers = data;
                            var matchingUserCandidates = self.pulseContext.userMgr.getMatchingStudentCandidates(self.participant);
                            angular.forEach(matchingUserCandidates, function (student) {
                                var alreadyMatched = self.common.$filter('filter')(alreadyMatchedCartStudents, { userID: student.userID });
                                if (!alreadyMatched || alreadyMatched.length <= 0) {
                                    student.matchScore = 0;
                                    if (moment(student.dateOfBirth).diff(studentDateOfBirth, 'days') == 0)
                                        student.matchScore += 4;
                                    if (student.firstName.toLowerCase() == studentFirstName.toLowerCase())
                                        student.matchScore += 2;
                                    if (student.lastName.toLowerCase() == studentLastName.toLowerCase())
                                        student.matchScore += 2;
                                    if (student.genderTypeID == studentGenderTypeID)
                                        student.matchScore += 1;
                                    self.matchingStudentCandidates.push(student);
                                }
                            });
                        })
                            .catch(function (error) {
                            self.logError(error);
                        })
                            .finally(function () {
                            self.common.toggleSpinner(false);
                        });
                    };
                    StudentMergePopupCtrl.prototype.onStudentSelected = function (e, userID) {
                        if (this.selectedUserID === userID) {
                            e.preventDefault();
                        }
                        else {
                            this.selectedUserID = userID;
                        }
                    };
                    StudentMergePopupCtrl.prototype.saveAndContinue = function () {
                        var _this = this;
                        if (this.selectedUserID != (this.participant.userID | 0)) {
                            this.participant.userID = (this.selectedUserID == 0) ? null : this.selectedUserID;
                            var student = this.pulseContext.regFlowMgr.userBrowsingMgr.bundleStudentInfoForSave(this.participant);
                            this.common.toggleSpinner(true);
                            var self = this;
                            var userBrowsingMgr_1 = this.pulseContext.regFlowMgr.userBrowsingMgr;
                            userBrowsingMgr_1.updateMatchedStudent(student)
                                .then(function (data) {
                                userBrowsingMgr_1.loadInfo(userBrowsingMgr_1.currentUBSession, false)
                                    .then(function () {
                                    _this.common.$rootScope.$broadcast(Events.StudentsMerged);
                                    self.close();
                                    _this.common.$rootScope.$broadcast(Events.StudentsMerged_RunPostActions);
                                });
                            })
                                .catch(function (error) {
                                self.logError(error);
                            })
                                .finally(function () {
                                self.common.toggleSpinner(false);
                            });
                        }
                        else {
                            this.close();
                        }
                    };
                    StudentMergePopupCtrl.controllerId = "studentMergePopupCtrl";
                    return StudentMergePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                StudentMergePopup.StudentMergePopupCtrl = StudentMergePopupCtrl;
            })(StudentMergePopup = PulsePublic.StudentMergePopup || (PulsePublic.StudentMergePopup = {}));
            Pulse.app.directive(StudentMergePopup.directiveId, ["common", function (c) { return new StudentMergePopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var RegFlowMgr = DataAccess.Managers.RegFlowMgr;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartDir = (function (_super) {
                __extends(CartDir, _super);
                function CartDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'reg-flow/shopping-cart/idp-cart.html';
                    _this.scope = {
                        cart: '=',
                        reminders: '=',
                        mode: '<',
                        api: '=?',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        CartDir.CartDirCtrl,
                    ];
                    return _this;
                }
                CartDir.directiveId = 'idpCart';
                return CartDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartDir = CartDir;
            (function (CartDir) {
                var CartDirCtrl = (function (_super) {
                    __extends(CartDirCtrl, _super);
                    function CartDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartDirCtrl.controllerId) || this;
                        _this._currencyTypesInCart = null;
                        _this._currencyTypesForUi = null;
                        _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                        _this.isCartRetrieved = false;
                        _this.checkOutPending = false;
                        _this.continueButtonText = 'Continue';
                        _this.formName = 'cartForm';
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                        _this._cartChangeHandler = $scope.$on(Events.ShoppingCartChanged, function (event, cart) {
                            _this.onCartChange(cart);
                        });
                        $scope.$on('$destroy', function () {
                            _this._cartChangeHandler();
                        });
                        _this.isLoggedIn = _this.pulseContext.isLoggedIn;
                        _this.isLoggedInUserTermStaff = _this.pulseContext.isLoggedInUserTermStaff;
                        _this.isImpersonating = _this.pulseContext.isImpersonating;
                        _this._loginSuccessHandler = $scope.$on(Events.LoginSuccess, function (event, participant) {
                            _this.onLoginSuccess();
                        });
                        $scope.$on('$destroy', function () {
                            _this._loginSuccessHandler();
                        });
                        _this._missingInfoSavedHandler = $scope.$on(Events.MissingInfoSuccess, function (event) {
                            _this.onMissingInfoSaved();
                        });
                        $scope.$on('$destroy', function () {
                            _this._missingInfoSavedHandler();
                        });
                        _this._removeNonParticipantItemHandler = $scope.$on(Events.ShoppingCartRemoveNonParticipantItemRequest, function (event, item) {
                            _this.onRemoveNonParticipantItem(item);
                        });
                        $scope.$on('$destroy', function () {
                            _this._removeNonParticipantItemHandler();
                        });
                        _this._removeStudentsMerged_RunPostActionsHandler = _this.$scope.$on(Events.StudentsMerged_RunPostActions, function (e, data) {
                            var discountsAmount = 0;
                            _this._cart.discounts.forEach(function (d) { discountsAmount += d.amount; });
                            sessionStorage.setItem('chkCart_DiscountsAmount', discountsAmount + '');
                            _this.common.$window.location.reload();
                        });
                        $scope.$on('$destroy', function () {
                            _this._removeStudentsMerged_RunPostActionsHandler();
                        });
                        return _this;
                    }
                    Object.defineProperty(CartDirCtrl.prototype, "cart", {
                        get: function () {
                            return this._cart;
                        },
                        set: function (cart) {
                            var isNewCart = this._cart == null
                                || (this._cart.browseIdentifier != cart.browseIdentifier
                                    || this._cart.cartTypeID != cart.cartTypeID);
                            this._cart = cart;
                            if (this._cart && this._cart.participants) {
                                if (this._cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                    for (var i = 0, j = this._cart.participants.length; i < j; i++) {
                                        var participant = this._cart.participants[i];
                                        var oldFees = participant.fees;
                                        if (oldFees) {
                                            var newFees = [];
                                            for (var m = 0, n = oldFees.length; m < n; m++) {
                                                var oldFee = oldFees[m];
                                                if (oldFee.productSubCatTypeID != Enums.ProductSubCategoryType.ComplianceAndSafetyFee) {
                                                    newFees.push(oldFee);
                                                }
                                            }
                                            participant.fees = newFees;
                                        }
                                    }
                                }
                                this.groupedDiscounts = ShoppingCartMgr.GroupCartDiscounts(this._cart);
                                this.groupedFees = ShoppingCartMgr.GroupCartFees(this._cart);
                                this.hasCampAtHqLocation = ShoppingCartMgr.HasCampAtHqLocation(this._cart);
                                this.participants = this._cart.participants;
                                this.nonParticipantItems = this._cart.nonParticipantItems;
                                this.total = ShoppingCartMgr.CalculateTotal(this._cart);
                                if (isNewCart) {
                                    this._remindersDisplayed = false;
                                }
                                if (this['reminders']) {
                                    this.displayReminders(this._cart);
                                }
                                this.isChangingPurchasedOrder = this._cart.cartTypeID != Enums.ShoppingCartType.RegFlow
                                    && this._cart.cartTypeID != Enums.ShoppingCartType.Abandonment;
                                var discountsAmountPrev = Number(sessionStorage.getItem('chkCart_DiscountsAmount'));
                                if (!isNaN(discountsAmountPrev) && discountsAmountPrev > 0) {
                                    var discountsAmountCurr_1 = 0;
                                    this.cart.discounts.forEach(function (d) { discountsAmountCurr_1 += d.amount; });
                                    if (discountsAmountPrev !== discountsAmountCurr_1) {
                                        sessionStorage.setItem('chkCart_DiscountsAmount', '0');
                                        var options = { timeOut: 0 };
                                        this.common.showWarning('Please note that one or more of your discounts has been disqualifed due to discount limits.', options);
                                    }
                                }
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartDirCtrl.prototype, "currencyTypesInCart", {
                        get: function () {
                            if (!this._currencyTypesForUi && this._currencyTypesInCart) {
                                var types = [];
                                var type = {};
                                type.typeID = null;
                                type.typeDescription = "Currency Type";
                                types.push(type);
                                for (var i = 0, il = this._currencyTypesInCart.length; i < il; i++) {
                                    types.push(this._currencyTypesInCart[i]);
                                }
                                this._currencyTypesForUi = types;
                            }
                            return this._currencyTypesForUi;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartDirCtrl.prototype, "doesCartHaveAtLeastOneCourse", {
                        get: function () {
                            return ShoppingCartMgr.DoesCartHaveAtLeastOneCourse(this.cart);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartDirCtrl.prototype, "isCartEmpty", {
                        get: function () {
                            return ShoppingCartMgr.IsCartEmpty(this.cart);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartDirCtrl.prototype, "hasParticipantWithNoItemsSelected", {
                        get: function () {
                            return (ShoppingCartMgr.StudentsWithNoItemsSelected(this.cart).length > 0);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartDirCtrl.prototype, "selectedCurrencyTypeID", {
                        get: function () {
                            return this.pulseContext.selectedCurrencyTypeID;
                        },
                        set: function (typeID) {
                            this.pulseContext.selectedCurrencyTypeID = typeID;
                            if (!this.pulseContext.selectedCurrencyTypeID) {
                                this.loadShoppingCart(true, true);
                            }
                            else {
                                this.common.$window.location.reload();
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartDirCtrl.prototype.$onInit = function () {
                        if (this.pulseContext.isLoggedIn) {
                            this.activationPromises.push(this.pulseContext.customerMgr.loadStatusAndAlerts());
                        }
                        if (this.mode === ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY) {
                            this.continueButtonText = 'Proceed to Checkout';
                        }
                        this.activateController();
                        if (angular.isNumber(this.pulseContext.regflowCurrencyTypeID)
                            && !angular.isNumber(this.selectedCurrencyTypeID)) {
                            this.selectedCurrencyTypeID = this.pulseContext.regflowCurrencyTypeID;
                        }
                    };
                    CartDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl);
                        var self = this;
                        this.common.$timeout(function () {
                            self.myForm.$setPristine();
                        }, 0);
                        scope.$watch(function (scope) {
                            return _this.api;
                        }, function (newVal, oldVal) {
                            if (angular.isObject(_this.api))
                                return;
                            _this.api = _this;
                        });
                    };
                    CartDirCtrl.prototype.addProductsFromQueryString = function () {
                        var _this = this;
                        if (this.mode !== ShoppingCartMgr.ShoppingCartUIMode.MODE_SHOPPING_CART) {
                            return this.common.$q.resolve(false);
                        }
                        else {
                            var promise = new Promise(function (resolve, reject) {
                                var loop = true;
                                var idx = 1;
                                var productsWereAdded = false;
                                var promises = [];
                                var _loop_1 = function () {
                                    var v = Pulse.Utils.QueryStringUtils.GetParamByName(window.location.href.toLowerCase(), 'p' + idx);
                                    if (v == undefined) {
                                        loop = false;
                                    }
                                    else {
                                        idx++;
                                        var productID_1 = parseInt(v);
                                        var items = _this.cart.nonParticipantItems.filter(function (o) { return o.productID == productID_1; });
                                        if (items.length == 0) {
                                            var itemInfo_1 = {};
                                            itemInfo_1.browseIdentifier = _this.pulseContext.browseIdentifier;
                                            itemInfo_1.userBrowsingID = _this.cart.userBrowsingID;
                                            itemInfo_1.productID = productID_1;
                                            itemInfo_1.action = true;
                                            var productDAO = new DataAccess.ProductDAO(_this.common, _this.breezeService, _this.pulseContext);
                                            var p = productDAO.getCategoryInfoByProductId(productID_1)
                                                .then(function (productInfo) {
                                                if (productInfo.productCategoryTypeID == Enums.ProductCategoryType.Course
                                                    && productInfo.subCategoryTypeID == Enums.ProductSubCategoryType.ProductCoupon) {
                                                    return _this.userBrowsingMgr.selectItem(itemInfo_1)
                                                        .then(function (data) {
                                                        productsWereAdded = true;
                                                        return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true);
                                                    });
                                                }
                                            });
                                            promises.push(p);
                                        }
                                    }
                                };
                                while (loop && idx < 10) {
                                    _loop_1();
                                }
                                Promise.all(promises)
                                    .then(function () {
                                    resolve(productsWereAdded);
                                });
                            });
                            return promise;
                        }
                    };
                    CartDirCtrl.prototype.loadCurrencyTypesInCart = function (forceReload) {
                        var _this = this;
                        return this.pulseContext.regFlowMgr.shoppingCartMgr.getCurrencyTypesInCart(this.pulseContext.browseIdentifier, this.cart ? this.cart.cartTypeID : this.pulseContext.shoppingCartType).then(function (types) {
                            if (types && types.length > 0) {
                                for (var i = 0, il = types.length; i < il; i++) {
                                    types[i].typeDescription = types[i].typeString + " - " + types[i].typeDescription;
                                }
                                if (types.length == 1) {
                                    _this.pulseContext.selectedCurrencyTypeID = types[0].typeID;
                                }
                                _this._currencyTypesInCart = types;
                                _this._currencyTypesForUi = null;
                                return !!_this.pulseContext.selectedCurrencyTypeID || forceReload;
                            }
                            else {
                                _this._currencyTypesInCart = null;
                                _this._currencyTypesForUi = null;
                                _this.$scope.$emit(Events.ShoppingCartRetrieved, true);
                                return false;
                            }
                        });
                    };
                    CartDirCtrl.prototype.loadShoppingCart = function (refreshCache, forceReload) {
                        var _this = this;
                        if (refreshCache === void 0) { refreshCache = true; }
                        if (forceReload === void 0) { forceReload = false; }
                        return this.loadCurrencyTypesInCart(forceReload)
                            .then(function (isOkToLoadCart) {
                            if (isOkToLoadCart) {
                                var _self_1 = _this;
                                if (_this.canSee) {
                                    _this.common.toggleSpinner(true, null, null, 0);
                                    return _this.pulseContext.regFlowMgr.shoppingCartMgr.getShoppingCart(_this.pulseContext.browseIdentifier, _this.pulseContext.shoppingCartType, _this.pulseContext.selectedCurrencyTypeID, refreshCache)
                                        .then(function (shoppingCartDTO) {
                                        if (_self_1.cart) {
                                            shoppingCartDTO.participants = ShoppingCartMgr.CopyMergeParticipants(shoppingCartDTO.participants, _self_1.cart.participants);
                                        }
                                        _self_1.cart = shoppingCartDTO;
                                        _self_1.cart.userID = _this.pulseContext.actingAsUserId;
                                        _self_1.isCartRetrieved = true;
                                        _self_1.$scope.$emit(Events.ShoppingCartRetrieved, _self_1.isCartEmpty);
                                        if (_this.pulseContext.actingAsUser && _self_1.cart) {
                                            var dataObj = { first: '', last: '', email: '', count: 0 };
                                            var user = _this.pulseContext.actingAsUser;
                                            dataObj.first = user.firstName;
                                            dataObj.last = user.lastName;
                                            dataObj.email = user.userName;
                                            dataObj.count = ShoppingCartMgr.CountStandAloneProducts(_self_1.cart);
                                            Pulse.Common.DataAccess.Managers.UserBrowsingMgr.TriggerCartInfoEvent(dataObj);
                                        }
                                        else if (_self_1.cart) {
                                            var dataObj = { first: '', last: '', email: '', count: 0 };
                                            dataObj.count = ShoppingCartMgr.CountStandAloneProducts(_self_1.cart);
                                            Pulse.Common.DataAccess.Managers.UserBrowsingMgr.TriggerCartInfoEvent(dataObj);
                                        }
                                        return shoppingCartDTO;
                                    })
                                        .catch(function (error) {
                                        _self_1.logError(error);
                                    })
                                        .finally(function () {
                                        _this.common.toggleSpinner(false);
                                    });
                                }
                            }
                        });
                    };
                    CartDirCtrl.prototype.continueToCheckout = function () {
                        var _this = this;
                        if (this.myForm.$invalid) {
                            return;
                        }
                        var hasDupes = false;
                        if (this.cart && this.cart.participants) {
                            for (var i = 0, il = this.cart.participants.length; i < il; i++) {
                                var student1 = this.cart.participants[i];
                                for (var j = 0, jl = this.cart.participants.length; j < jl; j++) {
                                    var student2 = this.cart.participants[j];
                                    if (student1.userBrowsingID != student2.userBrowsingID &&
                                        student1.firstName.toLowerCase().trim() == student2.firstName.toLowerCase().trim() &&
                                        student1.lastName.toLowerCase().trim() == student2.lastName.toLowerCase().trim() &&
                                        student1.dateOfBirth == student2.dateOfBirth) {
                                        if (!student1.userID && !student2.userID) {
                                            hasDupes = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        if (hasDupes) {
                            var error = "There exists one or more students with the same first name, last name, and birth date."
                                + " Please correct the values or remove the duplicates to continue.";
                            this.common.showWarning(error, { timeOut: -1 });
                            return;
                        }
                        this.common.toggleSpinner(true, null, null, 0);
                        var confirmMergeSilently = this.pulseContext.isImpersonating;
                        var promise;
                        if (this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY) {
                            promise = this.userBrowsingMgr.actionOnUserBrowsingRecordStatus(function () {
                                return true;
                            }, function (confirmedMerge) {
                                return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                                    .then(function () {
                                    if (confirmMergeSilently) {
                                        return _this.loadShoppingCart();
                                    }
                                    _this.common.$window.location.reload();
                                    return null;
                                });
                            }, function (startNewCart) {
                                if (startNewCart) {
                                    return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, false)
                                        .then(function () {
                                        _this.pulseContext.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.AVChart);
                                        return null;
                                    });
                                }
                                else {
                                    return _this.userBrowsingMgr.loadInfo(_this.userBrowsingMgr.currentUBSession, true)
                                        .then(function () {
                                        _this.common.$window.location.reload();
                                        return null;
                                    });
                                }
                            }, confirmMergeSilently);
                        }
                        else {
                            promise = this.userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, true)
                                .then(function () {
                                return _this.loadShoppingCart();
                            });
                        }
                        promise.then(function (data) {
                            if (!data) {
                                return;
                            }
                            _this.common.toggleSpinner(true, null, null, 0);
                            if (!_this.cart || !_this.cart.participants) {
                                _this.common.showWarning('The shopping cart is empty, cannot continue to checkout.');
                            }
                            else {
                                _this.common.$rootScope.$broadcast(Events.RegFlowCheckOutRequested, true);
                                _this.myForm.$submitted = true;
                                var self = _this;
                                _this.common.$timeout(function () {
                                    self.common.$rootScope.$broadcast('runCustomValidations');
                                    self.common.$timeout(function () {
                                        if (self.myForm.$invalid) {
                                            if (self.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY && self.doesCartHaveAtLeastOneCourse) {
                                                self.common.showWarning('Student information is missing.  Please press \'Continue\' to see which fields are required.');
                                                self.pulseContext.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                                            }
                                        }
                                        else if (self.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_SHOPPING_CART && self.hasParticipantWithNoItemsSelected) {
                                            var studentsWithNoSessions = ShoppingCartMgr.StudentsWithNoItemsSelected(self.cart);
                                            var studentNamesStr = ShoppingCartMgr.StudentNames(studentsWithNoSessions);
                                            var dlg = self.common.dialogService.confirm('Please confirm...', (studentNamesStr + (studentsWithNoSessions.length == 1 ? ' has' : ' have') + ' no sessions selected. Do you want to add a course for ' + studentNamesStr + '?'), { dialogId: 'MyDialogId', size: 'sm' });
                                            dlg.result.then(function (resolve) {
                                                self.$scope.$emit(Events.ShoppingCartAddCourseRequest, studentsWithNoSessions[0]);
                                            }, function (reject) {
                                                self.validateCart(true, true);
                                            });
                                        }
                                        else {
                                            if (self.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY) {
                                                self.validateCart(true, false);
                                            }
                                            else {
                                                self.validateCart(true, true);
                                            }
                                        }
                                    }, 0);
                                }, 0);
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false, true);
                        });
                    };
                    CartDirCtrl.prototype.continueShopping = function () {
                        this.checkUnsavedDataBeforeNav = false;
                        this.pulseContext.shoppingCartType = Enums.ShoppingCartType.RegFlow;
                        this.pulseContext.regFlowMgr.goToStepByEnum(RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                    };
                    CartDirCtrl.prototype.displayInvalidProductsReminder = function () {
                        var msg = '<ul>';
                        for (var i = 0, j = this._cart.participants.length; i < j; i++) {
                            var participant = this._cart.participants[i];
                            for (var m = 0, n = participant.items.length; m < n; m++) {
                                var item = participant.items[m];
                                if (item.isSelected
                                    && (item.isAvailableForRegistration == false || item.isSoldOut)) {
                                    msg += 'To continue, please change the products that are no longer available.';
                                    break;
                                }
                                for (var o = 0, p = item.options.length; o < p; o++) {
                                    var option = item.options[o];
                                    if (option.productCategoryTypeID == Enums.ProductCategoryType.Residency
                                        && (option.productSubCatTypeID == Enums.ProductSubCategoryType.Overnight
                                            || option.productSubCatTypeID == Enums.ProductSubCategoryType.OvernightAndWeekend)) {
                                        if (option.isSelected && (option.isAvailableForRegistration == false || option.isSoldOut)) {
                                            msg += 'To continue, please change the products that are no longer available.';
                                        }
                                    }
                                }
                            }
                        }
                        if (msg !== '<ul>') {
                            msg += '</ul>';
                            this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Reminders', ' ' + msg, null);
                            return true;
                        }
                        return false;
                    };
                    CartDirCtrl.prototype.displayReminders = function (cart) {
                        if (cart != null && this.pulseContext != null && this._remindersDisplayed == false) {
                            var msg = '<ul>';
                            if ((cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_Course
                                || cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_Location
                                || cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_SessionDate)
                                && ShoppingCartMgr.AreAllCartCoursesVirtual(cart) == false) {
                                msg += '<li>IMPORTANT: Please verify your preferred options are selected.</li>';
                            }
                            if (this.cart.changeOrder_HasAdditionalRequiredForms) {
                                msg += '<li>Please confirm that the parent/guardian will be able to fill out the necessary additional forms for the location.</li>';
                            }
                            var vipEarlyAccessDiscountCount = ShoppingCartMgr.CountVipEarlyAccessDiscounts(cart);
                            if (vipEarlyAccessDiscountCount > 0) {
                                if (vipEarlyAccessDiscountCount == 1) {
                                    msg += '<li>Please note that ' + vipEarlyAccessDiscountCount + ' VIP Early Access discount was automatically applied to this order.</li>';
                                }
                                else {
                                    msg += '<li>Please note that ' + vipEarlyAccessDiscountCount + ' VIP Early Access discounts were automatically applied to this order.</li>';
                                }
                            }
                            if (this.cart.customerAlerts != null) {
                                for (var i = 0; i < this.cart.customerAlerts.length; i++) {
                                    msg += '<li>' + this.cart.customerAlerts[i] + '</li>';
                                }
                            }
                            if (this.cart.csAlerts != null) {
                                for (var i = 0; i < this.cart.csAlerts.length; i++) {
                                    msg += '<li>' + this.cart.csAlerts[i] + '</li>';
                                }
                            }
                            if (msg !== '<ul>') {
                                msg += '</ul>';
                                this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Reminders', ' ' + msg, null);
                            }
                            this._remindersDisplayed = true;
                        }
                    };
                    CartDirCtrl.prototype.onCartChange = function (cart) {
                        return __awaiter(this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.cart = cart;
                                        this.userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, true)
                                            .catch(function (error) {
                                            _this.logError(error);
                                        });
                                        if (!this.cart) return [3, 2];
                                        return [4, this.pulseContext.regFlowMgr.shoppingCartMgr.getCurrencyTypesInCart(this.pulseContext.browseIdentifier, this.cart ? this.cart.cartTypeID : this.pulseContext.shoppingCartType)
                                                .then(function (types) {
                                                if ((!_this._currencyTypesInCart && types)
                                                    || _this._currencyTypesInCart.length != types.length) {
                                                    _this.isCartRetrieved = false;
                                                    _this.common.$window.location.reload();
                                                }
                                                else {
                                                    _this.$scope.$emit(Events.ShoppingCartRetrieved, _this.isCartEmpty);
                                                }
                                            })];
                                    case 1: return [2, _a.sent()];
                                    case 2: return [2];
                                }
                            });
                        });
                    };
                    CartDirCtrl.prototype.onLoginSuccess = function () {
                        var _this = this;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        var doUserBrowsingMerge = true;
                        this.userBrowsingMgr.loadInfo(this.userBrowsingMgr.currentUBSession, doUserBrowsingMerge)
                            .then(function (data) {
                            var promises = new Array();
                            promises.push(self.loadShoppingCart(true));
                            promises.push(self.pulseContext.customerMgr.loadStatusAndAlerts());
                            return self.common.$q.all(promises)
                                .then(function () {
                                return self.addProductsFromQueryString()
                                    .then(function (wereProductsAdded) {
                                    if (wereProductsAdded) {
                                        return self.loadShoppingCart(true);
                                    }
                                });
                            });
                        })
                            .then(function (data) {
                            self.validateCart(self.checkOutPending, true);
                        })
                            .then(function (data) {
                            _this.userBrowsingMgr.sendCartToMailChimp(_this.userBrowsingMgr.currentUBSession);
                            return;
                        })
                            .catch(function (error) {
                            self.logError(error);
                        })
                            .finally(function () {
                            self.common.toggleSpinner(false);
                        });
                    };
                    CartDirCtrl.prototype.onMissingInfoSaved = function () {
                        this.validateCart(this.checkOutPending, true);
                        if (this.checkOutPending == false) {
                            if (this.cart != null && this.pulseContext != null) {
                                var msg = '<ul>';
                                var vipEarlyAccessDiscountCount = ShoppingCartMgr.CountVipEarlyAccessDiscounts(this.cart);
                                if (vipEarlyAccessDiscountCount > 0) {
                                    if (vipEarlyAccessDiscountCount == 1) {
                                        msg += '<li>Please note that ' + vipEarlyAccessDiscountCount + ' VIP Early Access discount was automatically applied to this order.</li>';
                                    }
                                    else {
                                        msg += '<li>Please note that ' + vipEarlyAccessDiscountCount + ' VIP Early Access discounts were automatically applied to this order.</li>';
                                    }
                                }
                                if (msg !== '<ul>') {
                                    msg += '</ul>';
                                    this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'Reminders', ' ' + msg, null);
                                }
                            }
                        }
                    };
                    CartDirCtrl.prototype.onRemoveNonParticipantItem = function (item) {
                        var _this = this;
                        this.common.toggleSpinner(true, null, null, 0);
                        this.pulseContext.regFlowMgr.shoppingCartMgr.removeNonParticipantItem(this.cart, item.userBrowsingItemID)
                            .then(function (cartDTO) {
                            _this.$scope.$emit(Events.ShoppingCartChanged, cartDTO);
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    CartDirCtrl.prototype.saveStudentsInfoAndAddCourse = function () {
                        this.$scope.$emit(Events.ShoppingCartAddCourseRequest, null);
                    };
                    CartDirCtrl.prototype.showTaxHelp = function () {
                        var template = this.common.$templateCache.get('taxHelp.html');
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, 'VAT', ' ' + template, null);
                    };
                    CartDirCtrl.prototype.validateCart = function (checkOutPending, displayWarnings) {
                        var _this = this;
                        this.checkOutPending = checkOutPending;
                        if (!this.pulseContext.isLoggedIn) {
                            this.totalBeforeLogin = this.total;
                            this.common.$rootScope.$broadcast(Events.ShowLoginPopup, {
                                size: '',
                                initDataObj: {
                                    emailAddress: this.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress,
                                    lockEmailAddress: false,
                                    showCancel: true,
                                    showLabels: true,
                                    showRemember: true,
                                    hideRequiredAsterix: true,
                                },
                            });
                        }
                        else {
                            this.pulseContext.refreshUserInfo()
                                .then(function () {
                                if (_this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_SHOPPING_CART && _this.pulseContext.userMgr.isUserInformationMissing()) {
                                    _this.common.$rootScope.$broadcast(Events.ShowMissingInfoPopup, {
                                        size: '',
                                        initDataObj: {
                                            firstTabIndex: 1000,
                                        },
                                    });
                                }
                                else {
                                    if (!_this.isCartEmpty) {
                                        _this.common.toggleSpinner(true, null, null, 0);
                                        var self = _this;
                                        _this.pulseContext.regFlowMgr.shoppingCartMgr.validateShoppingCart(_this.cart, displayWarnings)
                                            .then(function (valResults) {
                                            if (!valResults || !valResults.updatedCart) {
                                                self.common.showError('Invalid result returned from validateShoppingCart');
                                            }
                                            else {
                                                self.cart = valResults.updatedCart;
                                                if (valResults.errors && valResults.errors.length == 1) {
                                                    self.common.showError(valResults.errors[0], true);
                                                }
                                                else if (valResults.errors && valResults.errors.length > 1) {
                                                    var errHtml = '<ul>';
                                                    for (var i = 0; i < valResults.errors.length; i++) {
                                                        errHtml += '<li>' + valResults.errors[i] + '</li>';
                                                    }
                                                    errHtml += '</ul>';
                                                    self.common.showError(errHtml, true);
                                                }
                                                else {
                                                    if (valResults.weekendWarnings
                                                        && valResults.weekendWarnings.length > 0
                                                        && displayWarnings) {
                                                        var warningHtml = '<ul>';
                                                        if (valResults.weekendWarnings
                                                            && valResults.weekendWarnings.length > 0) {
                                                            for (var i = 0; i < valResults.weekendWarnings.length; i++) {
                                                                warningHtml += '<li>' + valResults.weekendWarnings[i] + '</li>';
                                                            }
                                                        }
                                                        warningHtml += '</ul>';
                                                        var dlg = self.common.dialogService.confirm('Please note...', warningHtml, { dialogId: 'MyDialogId', size: 'md' });
                                                        dlg.result.then(function (resolve) {
                                                            self.myForm.$setPristine();
                                                            var anonymousStudents = ShoppingCartMgr.AnonymousStudentsInCart(self.cart.participants);
                                                            var isOrderSummaryNecessary = self.checkOutPending || (anonymousStudents.length > 0);
                                                            self.$scope.$emit(Events.RegFlowShoppingCartValidated, self.checkOutPending, isOrderSummaryNecessary);
                                                            self.checkOutPending = false;
                                                        }, function (reject) {
                                                        });
                                                    }
                                                    else {
                                                        self.myForm.$setPristine();
                                                        var anonymousStudents = ShoppingCartMgr.AnonymousStudentsInCart(self.cart.participants);
                                                        var isOrderSummaryNecessary = self.checkOutPending || (anonymousStudents.length > 0);
                                                        self.$scope.$emit(Events.RegFlowShoppingCartValidated, self.checkOutPending, isOrderSummaryNecessary);
                                                        self.checkOutPending = false;
                                                    }
                                                }
                                            }
                                        })
                                            .catch(function (error) {
                                            self.logError(error, ['ShoppingCartMgr.ShoppingCartException']);
                                        })
                                            .finally(function () {
                                            self.common.toggleSpinner(false);
                                        });
                                    }
                                }
                            });
                        }
                    };
                    CartDirCtrl.controllerId = 'CartDirCtrl';
                    return CartDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartDir.CartDirCtrl = CartDirCtrl;
            })(CartDir = PulsePublic.CartDir || (PulsePublic.CartDir = {}));
            Pulse.app.directive(CartDir.directiveId, [
                'common',
                function (c) { return new CartDir(c); },
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CartDiscountDir = (function (_super) {
                __extends(CartDiscountDir, _super);
                function CartDiscountDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-discount.html";
                    _this.require = "^" + PulsePublic.CartDiscountListDir.directiveId;
                    _this.scope = {
                        cartHasTax: "<",
                        discount: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartDiscountDir.CartDiscountDirCtrl];
                    return _this;
                }
                CartDiscountDir.directiveId = "idpCartDiscount";
                return CartDiscountDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartDiscountDir = CartDiscountDir;
            (function (CartDiscountDir) {
                var CartDiscountDirCtrl = (function (_super) {
                    __extends(CartDiscountDirCtrl, _super);
                    function CartDiscountDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartDiscountDirCtrl.controllerId) || this;
                        _this.id = CartDiscountDirCtrl._instanceCount++;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CartDiscountDirCtrl.prototype, "currencyTypeID", {
                        get: function () {
                            return this.pulseContext.selectedCurrencyTypeID;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartDiscountDirCtrl.prototype.showDiscountHelp = function () {
                        var discountHelpParam;
                        if (this.discount.discountCategoryTypeID == Enums.DiscountCategory.Standard
                            && this.discount.isAutomatic) {
                            discountHelpParam = this.pulseContext.companyId + ";"
                                + this.discount.discountCategoryTypeID + ";"
                                + this.discount.discountTypeID + ";"
                                + this.discount.discountID;
                        }
                        else {
                            discountHelpParam = this.pulseContext.companyId + ";"
                                + this.discount.discountCategoryTypeID + ";"
                                + this.discount.discountTypeID + ";"
                                + "0";
                        }
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.DiscountInfo, this.discount.name, discountHelpParam, "discountHelp" + this.discount.discountID);
                    };
                    CartDiscountDirCtrl.controllerId = "CartDiscountDirCtrl";
                    CartDiscountDirCtrl._instanceCount = 0;
                    return CartDiscountDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartDiscountDir.CartDiscountDirCtrl = CartDiscountDirCtrl;
            })(CartDiscountDir = PulsePublic.CartDiscountDir || (PulsePublic.CartDiscountDir = {}));
            Pulse.app.directive(CartDiscountDir.directiveId, ["common", function (c) { return new CartDiscountDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CartDiscountApplyDir = (function (_super) {
                __extends(CartDiscountApplyDir, _super);
                function CartDiscountApplyDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-discount-apply.html";
                    _this.scope = {
                        cart: "=",
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartDiscountApplyDir.CartDiscountApplyDirCtrl
                    ];
                    return _this;
                }
                CartDiscountApplyDir.directiveId = "idpCartDiscountApply";
                return CartDiscountApplyDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartDiscountApplyDir = CartDiscountApplyDir;
            (function (CartDiscountApplyDir) {
                var CartDiscountApplyDirCtrl = (function (_super) {
                    __extends(CartDiscountApplyDirCtrl, _super);
                    function CartDiscountApplyDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartDiscountApplyDirCtrl.controllerId) || this;
                        _this.promoCode = null;
                        _this.validationString = null;
                        _this.formName = "frmApplyDiscount";
                        _this.checkUnsavedDataBeforeNav = false;
                        _this._checkOutRequestHandler = $scope.$on(Events.RegFlowCheckOutRequested, function (event, isCheckingOut) {
                            _this.onCheckOutRequested(isCheckingOut);
                        });
                        $scope.$on('$destroy', function () {
                            _this._checkOutRequestHandler();
                        });
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CartDiscountApplyDirCtrl.prototype, "missingErrorKey", {
                        get: function () {
                            return "missing";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartDiscountApplyDirCtrl.prototype, "acceptedErrorKey", {
                        get: function () {
                            return "accepted";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartDiscountApplyDirCtrl.prototype, "duplicateErrorKey", {
                        get: function () {
                            return "duplicate";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartDiscountApplyDirCtrl.prototype, "supercededErrorKey", {
                        get: function () {
                            return "superceded";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartDiscountApplyDirCtrl.prototype, "serverWarningErrorKey", {
                        get: function () {
                            return "serverWarning";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartDiscountApplyDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        this.myForm = scope[this.formName];
                        this.resetPromoCodeErrorFlags();
                    };
                    CartDiscountApplyDirCtrl.prototype.resetPromoCodeErrorFlags = function () {
                        this.resetPromoCodeErrorValidity();
                        this.promoCodeSuccessMessage = null;
                        this.promoCodeServerWarning = null;
                        this.promoCodeRequiresValidationString = null;
                        this.isValidationStringRequiredVisible = false;
                        this.validationString = null;
                        this.myForm.$setPristine();
                    };
                    CartDiscountApplyDirCtrl.prototype.resetPromoCodeErrorValidity = function () {
                        this.myForm.promoCode.$setValidity(this.missingErrorKey, true);
                        this.myForm.promoCode.$setValidity(this.acceptedErrorKey, (this.promoCode));
                        this.myForm.promoCode.$setValidity(this.duplicateErrorKey, true);
                        this.myForm.promoCode.$setValidity(this.supercededErrorKey, true);
                        this.myForm.promoCode.$setValidity(this.serverWarningErrorKey, true);
                        this.myForm.validationString.$setValidity(this.acceptedErrorKey, true);
                    };
                    CartDiscountApplyDirCtrl.prototype.verifyPromoCode = function () {
                        if (this.cart != null) {
                            if (String.isNullOrWhitespace(this.promoCode)) {
                                this.myForm.promoCode.$setValidity(this.missingErrorKey, false);
                            }
                            else {
                                if (this.cart.participants != null) {
                                    var hasAtLeastOneCourse = false;
                                    for (var i = 0; i < this.cart.participants.length; i++) {
                                        var participant = this.cart.participants[i];
                                        if (participant.items != null && participant.items.length > 0) {
                                            hasAtLeastOneCourse = true;
                                            break;
                                        }
                                    }
                                    if (hasAtLeastOneCourse) {
                                        if (this.promoCodeRequiresValidationString == null) {
                                            this.common.toggleSpinner(true);
                                            var _self = this;
                                            this.pulseContext.regFlowMgr.shoppingCartMgr.doesCodeRequireValidationString(this.promoCode)
                                                .then(function (requires) {
                                                _self.promoCodeRequiresValidationString = requires;
                                                if (requires) {
                                                }
                                                else {
                                                    _self.validationString = "";
                                                    _self.addDiscountCode();
                                                }
                                            })
                                                .catch(function (err) {
                                                _self.logError(err);
                                            })
                                                .finally(function () {
                                                _self.common.toggleSpinner(false);
                                            });
                                        }
                                        else if (this.promoCodeRequiresValidationString && String.isNullOrWhitespace(this.validationString)) {
                                            this.isValidationStringRequiredVisible = true;
                                        }
                                        else {
                                            this.addDiscountCode();
                                        }
                                    }
                                    else {
                                        this.common.showWarning("Please select one or more courses first.");
                                    }
                                }
                            }
                        }
                    };
                    CartDiscountApplyDirCtrl.prototype.addDiscountCode = function () {
                        var _this = this;
                        this.resetPromoCodeErrorValidity();
                        this.common.toggleSpinner(true, null, null, 0);
                        var _self = this;
                        this.pulseContext.regFlowMgr.shoppingCartMgr.addDiscountCode(this.cart, this.promoCode, this.validationString)
                            .then(function (updatedCart) {
                            var arr = null;
                            if (_self.validationString == null || _self.validationString.trim() == "") {
                                arr = Pulse.Utils.JS.findByProperties(_self.cart.discounts, { 'discountOrCouponCode': _self.promoCode.trim() }, true);
                            }
                            else {
                                var couponCode = _self.promoCode.trim().replace("-", "");
                                arr = Pulse.Utils.JS.findByProperties(_self.cart.discounts, { 'discountOrCouponCode': couponCode, 'validationString': _self.validationString.trim() }, true);
                            }
                            if (arr != null && arr.length > 0) {
                                _self.myForm.promoCode.$setValidity(_this.duplicateErrorKey, false);
                            }
                            else {
                                _self.myForm.promoCode.$setValidity(_this.duplicateErrorKey, true);
                                if (_self.validationString == null || _self.validationString.trim() == "") {
                                    arr = Pulse.Utils.JS.findByProperties(updatedCart.discounts, { 'discountOrCouponCode': _self.promoCode.trim() }, true);
                                }
                                else {
                                    var couponCode = _self.promoCode.trim().replace("-", "");
                                    arr = Pulse.Utils.JS.findByProperties(updatedCart.discounts, { 'discountOrCouponCode': couponCode, 'validationString': _self.validationString.trim() }, true);
                                }
                                if (arr == null || arr.length == 0) {
                                    _self.myForm.promoCode.$setValidity(_this.acceptedErrorKey, false);
                                }
                                else {
                                    var dialogDisplayed_1 = false;
                                    arr.forEach(function (discount) {
                                        if (dialogDisplayed_1 == false
                                            && discount.discountPaymentOptionTypeID == Enums.DiscountPaymentReqType.PayInFullImmediately
                                            && !_this.cart.requiresFullPayment) {
                                            dialogDisplayed_1 = true;
                                            var msg = "This discount requires that you pay in full at the time of registration in"
                                                + " order to receive it. Please remember to select 'Pay in Full' on the checkout page.";
                                            _this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Please note...", " " + msg, null);
                                        }
                                    });
                                }
                            }
                            if (_self.myForm.$valid) {
                                _self.resetPromoCodeErrorFlags();
                                _self.promoCodeSuccessMessage = "A promo code has been applied";
                                _self.promoCode = null;
                                _this.$scope.$emit(Events.ShoppingCartChanged, updatedCart);
                            }
                            _self.cart = updatedCart;
                        })
                            .catch(function (err) {
                            if (err && err.data && err.data.modelState && err.data.modelState.showToUserWarning) {
                                _self.promoCodeServerWarning = err.data.modelState.showToUserWarning.join("  ");
                                _self.myForm.promoCode.$setValidity(_this.serverWarningErrorKey, false);
                            }
                            else {
                                _self.logError(err);
                                if (_self.promoCodeRequiresValidationString) {
                                    _self.myForm.validationString.$setValidity(_this.acceptedErrorKey, false);
                                }
                                else {
                                    _self.myForm.promoCode.$setValidity(_this.acceptedErrorKey, false);
                                }
                            }
                        })
                            .finally(function () {
                            _self.common.toggleSpinner(false);
                        });
                    };
                    CartDiscountApplyDirCtrl.prototype.onCheckOutRequested = function (isCheckingOut) {
                        this.promoCode = null;
                        this.validationString = null;
                        this.myForm.$setPristine();
                        this.resetPromoCodeErrorFlags();
                    };
                    CartDiscountApplyDirCtrl.controllerId = "CartDiscountApplyDirCtrl";
                    return CartDiscountApplyDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartDiscountApplyDir.CartDiscountApplyDirCtrl = CartDiscountApplyDirCtrl;
            })(CartDiscountApplyDir = PulsePublic.CartDiscountApplyDir || (PulsePublic.CartDiscountApplyDir = {}));
            Pulse.app.directive(CartDiscountApplyDir.directiveId, ["common", function (c) { return new CartDiscountApplyDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CartDiscountListDir = (function (_super) {
                __extends(CartDiscountListDir, _super);
                function CartDiscountListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-discount-list.html";
                    _this.scope = {
                        cartHasTax: "<",
                        discounts: "<"
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartDiscountListDir.CartDiscountListDirCtrl
                    ];
                    return _this;
                }
                CartDiscountListDir.directiveId = "idpCartDiscountList";
                return CartDiscountListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartDiscountListDir = CartDiscountListDir;
            (function (CartDiscountListDir) {
                var CartDiscountListDirCtrl = (function (_super) {
                    __extends(CartDiscountListDirCtrl, _super);
                    function CartDiscountListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartDiscountListDirCtrl.controllerId) || this;
                        _this.activateController();
                        return _this;
                    }
                    CartDiscountListDirCtrl.controllerId = "CartDiscountListDirCtrl";
                    return CartDiscountListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartDiscountListDir.CartDiscountListDirCtrl = CartDiscountListDirCtrl;
            })(CartDiscountListDir = PulsePublic.CartDiscountListDir || (PulsePublic.CartDiscountListDir = {}));
            Pulse.app.directive(CartDiscountListDir.directiveId, ["common", function (c) { return new CartDiscountListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CartFeeDir = (function (_super) {
                __extends(CartFeeDir, _super);
                function CartFeeDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-fee.html";
                    _this.require = "^" + PulsePublic.CartFeeListDir.directiveId;
                    _this.scope = {
                        fee: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartFeeDir.CartFeeDirCtrl];
                    return _this;
                }
                CartFeeDir.directiveId = "idpCartFee";
                return CartFeeDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartFeeDir = CartFeeDir;
            (function (CartFeeDir) {
                var CartFeeDirCtrl = (function (_super) {
                    __extends(CartFeeDirCtrl, _super);
                    function CartFeeDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartFeeDirCtrl.controllerId) || this;
                        _this.id = CartFeeDirCtrl._instanceCount++;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CartFeeDirCtrl.prototype, "isHealthAndSafetyFee", {
                        get: function () {
                            return (this.fee.productSubCatTypeID == Enums.ProductSubCategoryType.ComplianceAndSafetyFee);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartFeeDirCtrl.prototype.showFeeHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.ProductInfo, this.fee.itemName, "p_" + this.fee.productID, "feeHelp-" + this.id);
                    };
                    CartFeeDirCtrl.controllerId = "CartFeeDirCtrl";
                    CartFeeDirCtrl._instanceCount = 0;
                    return CartFeeDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartFeeDir.CartFeeDirCtrl = CartFeeDirCtrl;
            })(CartFeeDir = PulsePublic.CartFeeDir || (PulsePublic.CartFeeDir = {}));
            Pulse.app.directive(CartFeeDir.directiveId, ["common", function (c) { return new CartFeeDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CartFeeListDir = (function (_super) {
                __extends(CartFeeListDir, _super);
                function CartFeeListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-fee-list.html";
                    _this.scope = {
                        fees: "<",
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartFeeListDir.CartFeeListDirCtrl
                    ];
                    return _this;
                }
                CartFeeListDir.directiveId = "idpCartFeeList";
                return CartFeeListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartFeeListDir = CartFeeListDir;
            (function (CartFeeListDir) {
                var CartFeeListDirCtrl = (function (_super) {
                    __extends(CartFeeListDirCtrl, _super);
                    function CartFeeListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartFeeListDirCtrl.controllerId) || this;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CartFeeListDirCtrl.prototype, "fees", {
                        get: function () {
                            return this._fees;
                        },
                        set: function (fees) {
                            if (fees) {
                                this._fees = [];
                                for (var i = 0, j = fees.length; i < j; i++) {
                                    var fee1 = fees[i];
                                    var found = false;
                                    for (var k = 0, l = this._fees.length; k < l; k++) {
                                        var fee2 = this._fees[k];
                                        if (fee1.productSubCatTypeID == fee2.productSubCatTypeID) {
                                            fee2.itemPrice += fee1.itemPrice;
                                            found = true;
                                        }
                                    }
                                    if (!found) {
                                        var feeNew = {};
                                        feeNew.itemName = fee1.itemName;
                                        feeNew.itemPrice = fee1.itemPrice;
                                        feeNew.productCategoryTypeID = fee1.productCategoryTypeID;
                                        feeNew.productID = fee1.productID;
                                        feeNew.productSubCatTypeID = fee1.productSubCatTypeID;
                                        feeNew.quantity = fee1.quantity;
                                        feeNew.currencyTypeID = fee1.currencyTypeID;
                                        this._fees.push(feeNew);
                                    }
                                }
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartFeeListDirCtrl.controllerId = "CartFeeListDirCtrl";
                    return CartFeeListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartFeeListDir.CartFeeListDirCtrl = CartFeeListDirCtrl;
            })(CartFeeListDir = PulsePublic.CartFeeListDir || (PulsePublic.CartFeeListDir = {}));
            Pulse.app.directive(CartFeeListDir.directiveId, ["common", function (c) { return new CartFeeListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartItemDir = (function (_super) {
                __extends(CartItemDir, _super);
                function CartItemDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-item.html";
                    _this.require = "^" + PulsePublic.CartItemListDir.directiveId;
                    _this.scope = {
                        item: "<",
                        mode: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartItemDir.CartItemDirCtrl];
                    return _this;
                }
                CartItemDir.directiveId = "idpCartItem";
                return CartItemDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartItemDir = CartItemDir;
            (function (CartItemDir) {
                var CartItemDirCtrl = (function (_super) {
                    __extends(CartItemDirCtrl, _super);
                    function CartItemDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartItemDirCtrl.controllerId) || this;
                        _this._areAllCartCoursesVirtual = null;
                        _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                        _this._hasAdminOverride = null;
                        _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                        _this.shoppingCartMgr = _this.pulseContext.regFlowMgr.shoppingCartMgr;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CartItemDirCtrl.prototype, "areAllCartCoursesVirtual", {
                        get: function () {
                            if (this._cart) {
                                if (this._areAllCartCoursesVirtual === null) {
                                    this._areAllCartCoursesVirtual = ShoppingCartMgr.AreAllCartCoursesVirtual(this._cart);
                                }
                                return this._areAllCartCoursesVirtual;
                            }
                            else {
                                return false;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "canItemBeRemoved", {
                        get: function () {
                            if (this._canItemBeRemoved == null || typeof this._canItemBeRemoved == 'undefined') {
                                if (this.item == null) {
                                    this._canItemBeRemoved = false;
                                }
                                else {
                                    var participant = this.item.parent;
                                    if (participant.parent.cartTypeID != Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                        this._canItemBeRemoved = true;
                                    }
                                    else {
                                        this._canItemBeRemoved = false;
                                    }
                                }
                            }
                            return this._canItemBeRemoved;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "canSwitchPrimaryOption", {
                        get: function () {
                            if (this._canSwitchPrimaryOption == null || typeof this._canSwitchPrimaryOption == 'undefined') {
                                if (this.hasSelectedOvernightOption) {
                                    this._canSwitchPrimaryOption = this.item.isPrimaryOptionSwitchable;
                                }
                                else if (this._itemOption_Overnight && this.participant
                                    && (this._itemOption_Overnight.isValidForParticipantsAge || this.pulseContext.canOverrideRegFlowRestrictions)) {
                                    this._canSwitchPrimaryOption = this.item.isPrimaryOptionSwitchable;
                                }
                                else {
                                    this._canSwitchPrimaryOption = false;
                                }
                            }
                            return this._canSwitchPrimaryOption;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemDirCtrl.prototype.isItemAfterSchool = function (item) {
                        if (item.catalogTypeID == Enums.SalesCatalogType.AtSchoolMultiWeek
                            || item.catalogTypeID == Enums.SalesCatalogType.AtSchoolOneDay) {
                            return true;
                        }
                        else if (this.item.catalogTypeID == Enums.SalesCatalogType.StandardCamp) {
                            return false;
                        }
                    };
                    Object.defineProperty(CartItemDirCtrl.prototype, "isAfterSchool", {
                        get: function () {
                            if (this._isAfterSchool == null || typeof this._isAfterSchool == 'undefined') {
                                if (this.item == null) {
                                    this._isAfterSchool = false;
                                }
                                else {
                                    this._isAfterSchool = this.isItemAfterSchool(this.item);
                                }
                            }
                            return this._isAfterSchool;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "isItemSquads", {
                        get: function () {
                            if (this.item == null) {
                                return false;
                            }
                            else {
                                return this.item.catalogTypeID == Enums.SalesCatalogType.SquadsConsecutiveDays || this.item.catalogTypeID == Enums.SalesCatalogType.SquadsMultiWeek;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "isChangeOptionsOnlyCart", {
                        get: function () {
                            if (this._isChangeOptionsOnlyCart == null || typeof this._isChangeOptionsOnlyCart == 'undefined') {
                                if (this._cart != null
                                    && this._cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                    this._isChangeOptionsOnlyCart = true;
                                }
                                else {
                                    this._isChangeOptionsOnlyCart = false;
                                }
                            }
                            return this._isChangeOptionsOnlyCart;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "isChangeCourseSessionCart", {
                        get: function () {
                            if (this._cart) {
                                return ShoppingCartMgr.IsChangeOrderCart(this._cart) && this._cart.cartTypeID !== Enums.ShoppingCartType.ChangeOrder_OptionsOnly;
                            }
                            return false;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "isDisabled", {
                        get: function () {
                            if (this._isDisabled == null || typeof this._isDisabled == 'undefined') {
                                if (this.item == null) {
                                    this._isDisabled = true;
                                }
                                else {
                                    this._isDisabled = (this.item.isAvailableForRegistration == false
                                        || (this.hasSelectedOvernightOption
                                            && this._itemOption_Overnight.isAvailableForRegistration == false));
                                }
                            }
                            return this._isDisabled;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "isDisabledReason", {
                        get: function () {
                            if (this._isDisabledReason == null || typeof this._isDisabledReason == 'undefined') {
                                if (this.isDisabled) {
                                    if (this.item == null) {
                                        this._isDisabledReason = "";
                                    }
                                    else if (this.item.isSoldOut) {
                                        this._isDisabledReason = "There is no space available for this course.";
                                    }
                                    else if (this.hasSelectedOvernightOption
                                        && !this.isOptionSelectedInChangeFromCart(this.changeFromItem, this.itemOption_Overnight.sessionProductDetailID)
                                        && (this._itemOption_Overnight.isSoldOut
                                            || this._itemOption_Overnight.isAvailableForRegistration == false)) {
                                        this._isDisabledReason = "Overnight is unavailable.";
                                    }
                                    else if (this.item.isAvailableForRegistration == false) {
                                        this._isDisabledReason = "Registration is now closed for this course.";
                                    }
                                    else {
                                        this._isDisabledReason = "";
                                    }
                                }
                                else {
                                    this._isDisabledReason = "";
                                }
                            }
                            return this._isDisabledReason;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "isItemACourse", {
                        get: function () {
                            if (this.item) {
                                return this.item.productCategoryTypeID == Enums.ProductCategoryType.Course;
                            }
                            else {
                                return false;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "isSemesterBundle", {
                        get: function () {
                            return this.item.catalogTypeID == Enums.SalesCatalogType.CourseBundle;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "isStandardCamp", {
                        get: function () {
                            if (this._isStandardCamp == null || typeof this._isStandardCamp == 'undefined') {
                                if (this.item == null) {
                                    this._isStandardCamp = false;
                                }
                                else {
                                    this._isStandardCamp = this.getIsStandardCamp(this.item);
                                }
                            }
                            return this._isStandardCamp;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemDirCtrl.prototype.getIsStandardCamp = function (item) {
                        if (item.catalogTypeID == Enums.SalesCatalogType.StandardCamp) {
                            return true;
                        }
                        return false;
                    };
                    CartItemDirCtrl.prototype.getOvernightOption = function (options) {
                        if (options != null) {
                            for (var i = 0; i < options.length; i++) {
                                var option = options[i];
                                if (option.productCategoryTypeID == Enums.ProductCategoryType.Residency
                                    && (option.productSubCatTypeID == Enums.ProductSubCategoryType.Overnight
                                        || option.productSubCatTypeID == Enums.ProductSubCategoryType.OvernightAndWeekend)) {
                                    return option;
                                }
                            }
                        }
                        return null;
                    };
                    Object.defineProperty(CartItemDirCtrl.prototype, "cart", {
                        get: function () {
                            return this._cart;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "participant", {
                        get: function () {
                            return this._participant;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "item", {
                        get: function () {
                            return this._item;
                        },
                        set: function (item) {
                            this.clearCriticalCachedFlags();
                            this._item = item;
                            this._participant = this._item.parent;
                            this._cart = this._participant.parent;
                            this._itemOption_Overnight = null;
                            this.hasSelectedOvernightOption = false;
                            this.calculatedPrice = this._item.itemPrice;
                            this._itemOption_Overnight = this.getOvernightOption(this._item.options);
                            if (!this._itemOption_Overnight && this.item.mutExOptions != null) {
                                this._itemOption_Overnight = this.getOvernightOption(this._item.mutExOptions);
                            }
                            this.hasSelectedOvernightOption = this._itemOption_Overnight ? this._itemOption_Overnight.isSelected : false;
                            if (this._itemOption_Overnight != null) {
                                if (this.hasSelectedOvernightOption
                                    && this._cart.cartTypeID != Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                    this.calculatedPrice += this._itemOption_Overnight.itemPrice;
                                }
                            }
                            if (this.item == null
                                || this.item.options == null
                                || this.isDisabled) {
                                this.options = null;
                            }
                            else {
                                if (this._cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                    this.options = this.item.options;
                                }
                                else {
                                    this.options = Pulse.Utils.JS.findByPropertiesNotEqual(this.item.options, { relatedProductTypeID: Enums.RelatedProductType.PrimaryOptionalProduct });
                                }
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "itemOption_Overnight", {
                        get: function () {
                            return this._itemOption_Overnight;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "isPriceVisible", {
                        get: function () {
                            if (this._isPriceVisible == null || typeof this._isPriceVisible == 'undefined') {
                                if (this.item == null) {
                                    this._isPriceVisible = false;
                                }
                                else {
                                    var participant = this.item.parent;
                                    if (participant.parent.cartTypeID == Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                        this._isPriceVisible = false;
                                    }
                                    else {
                                        this._isPriceVisible = true;
                                    }
                                }
                            }
                            return this._isPriceVisible;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl);
                        scope.$on(Pulse.Common.BasePopup.EventType.Close, function (event, data) {
                            _this.childPopupClosed(event, data);
                        });
                    };
                    CartItemDirCtrl.prototype.isItemVirtualCamp = function (item) {
                        return item.divisionProgramTypeID === Enums.DivisionProgramType.VirtualCamp;
                    };
                    Object.defineProperty(CartItemDirCtrl.prototype, "itemName", {
                        get: function () {
                            if (typeof this._itemName == 'undefined') {
                                if (this.item == null) {
                                    this._itemName = "";
                                }
                                else {
                                    this._itemName = this.getItemName(this.item);
                                }
                            }
                            return this._itemName;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemDirCtrl.prototype.getItemName = function (item) {
                        var s = "";
                        if (item) {
                            s = item.itemName;
                            if (item.catalogTypeID == Enums.SalesCatalogType.CourseBundle
                                || item.catalogTypeID == Enums.SalesCatalogType.SquadsMultiWeek) {
                                var cartItem = void 0;
                                if (item.bundledItems && item.bundledItems.length) {
                                    cartItem = item.bundledItems[0];
                                }
                                else {
                                    cartItem = item;
                                }
                                s += " - " + moment(cartItem.spd_StartDateTime).format('ddd')
                                    + (cartItem.termShortName ? " " + cartItem.termShortName : "");
                                return s;
                            }
                            else if (this.isItemVirtualCamp(this.item)) {
                                s += item.termName ? " - " + item.termName : "";
                                return s;
                            }
                            if (item.locationName) {
                                s += " - " + item.locationName;
                            }
                            if (this.item.divisionName) {
                                s += " - " + item.divisionName;
                            }
                            if (this.isItemATutorProduct
                                && item.isAutoRenew) {
                                s += " / monthly subscription";
                            }
                        }
                        return s;
                    };
                    Object.defineProperty(CartItemDirCtrl.prototype, "isItemATutorProduct", {
                        get: function () {
                            if (this.item) {
                                return (this.item.productCategoryTypeID == Enums.ProductCategoryType.Tutor);
                            }
                            else {
                                return false;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemDirCtrl.prototype.childPopupClosed = function (event, data) {
                        if (data && data[0] && data[0].callbackID && data[0].callbackID == this._ageOverrideCallbackID) {
                            this.switchPrimaryOption();
                        }
                    };
                    CartItemDirCtrl.prototype.clearCriticalCachedFlags = function () {
                        this._areAllCartCoursesVirtual = null;
                        this._canItemBeRemoved = null;
                        this._canSwitchPrimaryOption = null;
                        this._hasAdminOverride = null;
                        this._isAfterSchool = null;
                        this._isDisabled = null;
                        this._isDisabledReason = null;
                        this._isPriceVisible = null;
                    };
                    Object.defineProperty(CartItemDirCtrl.prototype, "changeFromItem", {
                        get: function () {
                            if (!this._changeFromItem) {
                                if (ShoppingCartMgr.IsChangeOrderCompatibleCartTypeID(this.cart.cartTypeID)) {
                                    this._changeFromItem = ShoppingCartMgr.GetChangeFromProduct(this.cart.changeFromCart, __assign(__assign({}, this.item), { participantID: this.participant.userID }));
                                }
                            }
                            return this._changeFromItem;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemDirCtrl.prototype.removeItem = function () {
                        var _this = this;
                        if (this.item) {
                            var msg = null;
                            if (this.item.productCategoryTypeID == Enums.ProductCategoryType.Subscription) {
                                msg = "You are about to remove a subscription. Do you want to continue?";
                            }
                            else {
                                msg = "You are about to remove a course. Do you want to continue?";
                            }
                            var dlg = this.common.dialogService.confirm("Please confirm...", msg, { dialogId: 'MyDialogId', size: 'sm' });
                            dlg.result.then(function (resolve) {
                                _this.removeAdminOverridesFromCurrentItem();
                                _this.$scope.$emit(Events.ShoppingCartRemoveItemRequest, _this.item);
                            }, function (reject) { });
                        }
                    };
                    Object.defineProperty(CartItemDirCtrl.prototype, "hasAdminOverride", {
                        get: function () {
                            if (this._hasAdminOverride != null)
                                return this._hasAdminOverride;
                            this._hasAdminOverride = false;
                            this._hasAdminOverride = this.hasItemAdminOverride(this.item);
                            if (!this._hasAdminOverride && this.hasSelectedOvernightOption) {
                                this._hasAdminOverride = this.hasItemAdminOverride(this._itemOption_Overnight);
                            }
                            return this._hasAdminOverride;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemDirCtrl.prototype.hasItemAdminOverride = function (item) {
                        return this.userBrowsingMgr.hasAdminOverride(this.userBrowsingMgr.currentUBSession, {
                            child_UB_ID: this.participant.userBrowsingID,
                            locationID: item.locationID > 0 ? item.locationID : item.parent.locationID,
                            productID: item.productID,
                            sessionID: item.sessionID,
                            sessionProductDetailID: item.sessionProductDetailID,
                        });
                    };
                    CartItemDirCtrl.prototype.isOptionSelectedInChangeFromCart = function (changeFromItem, SPD_ID) {
                        if (changeFromItem && changeFromItem.options) {
                            return changeFromItem.options.filter(function (opt) { return opt.sessionProductDetailID == SPD_ID && opt.isSelected; }).length > 0;
                        }
                        return false;
                    };
                    Object.defineProperty(CartItemDirCtrl.prototype, "showSwitchToOvernightCamp", {
                        get: function () {
                            return this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_SHOPPING_CART && this.isStandardCamp && this.canSwitchPrimaryOption
                                && !this.hasSelectedOvernightOption
                                && (this.isOptionSelectedInChangeFromCart(this.changeFromItem, this.itemOption_Overnight.sessionProductDetailID)
                                    ||
                                        (this.itemOption_Overnight.isAvailableForRegistration == true
                                            && this.itemOption_Overnight.isSoldOut == false));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "showSwitchToDayCamp", {
                        get: function () {
                            return this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_SHOPPING_CART && this.isStandardCamp && this.canSwitchPrimaryOption && this.hasSelectedOvernightOption;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemDirCtrl.prototype, "showEdit", {
                        get: function () {
                            return false;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemDirCtrl.prototype.removeAdminOverridesFromItem = function (item, saveToDB) {
                        var adminOverride = {
                            child_UB_ID: this.participant.userBrowsingID,
                            productID: item.productID,
                            locationID: item.locationID,
                            sessionID: item.sessionID,
                            sessionProductDetailID: item.sessionProductDetailID,
                        };
                        this.userBrowsingMgr.removeAdminOverride(this.userBrowsingMgr.currentUBSession, adminOverride, saveToDB);
                    };
                    CartItemDirCtrl.prototype.removeAdminOverridesFromCurrentItem = function () {
                        var item;
                        var adminOverride = {};
                        if (this.hasSelectedOvernightOption) {
                            this.removeAdminOverridesFromItem(this._itemOption_Overnight, false);
                        }
                        item = this.item;
                        this.removeAdminOverridesFromItem(this.item, true);
                    };
                    CartItemDirCtrl.prototype.switchPrimaryOption = function () {
                        if (this.hasSelectedOvernightOption) {
                            this.removeAdminOverridesFromItem(this._itemOption_Overnight, true);
                            this.clearCriticalCachedFlags();
                            this.$scope.$emit(Events.ShoppingCartPrimaryOptionChangeRequest, { userBrowsingItemID: this.item.userBrowsingItemID, primaryOptionType: ShoppingCartMgr.PrimaryOptionType.Day, });
                        }
                        else {
                            if (!this._itemOption_Overnight.isValidForParticipantsAge && !this.hasItemAdminOverride(this._itemOption_Overnight)) {
                                this._ageOverrideCallbackID = this.participant.userBrowsingID + "_" + this.item.sessionProductDetailID + "_" + this._itemOption_Overnight.sessionProductDetailID;
                                this.common.$rootScope.$broadcast(Events.ShowRegFlowAdminOverridePopup, {
                                    size: Pulse.Common.BasePopup.ModalSize.Medium,
                                    initDataObj: {
                                        callbackID: this._ageOverrideCallbackID,
                                        overrideReqs: [{
                                                overrideType: PulsePublic.RegFlowAdminOverridePopup.OverrideUIType.AgeOverride,
                                                productName: this._itemOption_Overnight.itemName,
                                                minAge: this._itemOption_Overnight.minimumAge,
                                                maxAge: this._itemOption_Overnight.maximumAge,
                                                productID: this._itemOption_Overnight.productID,
                                                sessionID: this._itemOption_Overnight.sessionID,
                                                locationID: this._itemOption_Overnight.locationID,
                                                sessionProductDetailID: this._itemOption_Overnight.sessionProductDetailID,
                                                DOB: this.participant.dateOfBirth,
                                                child_UB_ID: this.participant.userBrowsingID,
                                            }]
                                    }
                                });
                                return;
                            }
                            else {
                                this.clearCriticalCachedFlags();
                                this.$scope.$emit(Events.ShoppingCartPrimaryOptionChangeRequest, { userBrowsingItemID: this.item.userBrowsingItemID, primaryOptionType: ShoppingCartMgr.PrimaryOptionType.Overnight, });
                            }
                        }
                    };
                    CartItemDirCtrl.prototype.toggleEditMode = function () {
                        if (this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY) {
                            this.$scope.$emit(Events.OrderSummaryChangeRequest, this.item);
                        }
                    };
                    CartItemDirCtrl.prototype.isDayCamp = function (item) {
                        if (item.divisionProgramTypeID === Enums.DivisionProgramType.VirtualCamp)
                            return false;
                        var overnightOption = this.getOvernightOption(item.options);
                        return this.getIsStandardCamp(item) && !((overnightOption && overnightOption.isSelected) || item.isOvernightBundled);
                    };
                    CartItemDirCtrl.prototype.isOvernightCamp = function (item) {
                        if (item.divisionProgramTypeID === Enums.DivisionProgramType.VirtualCamp)
                            return false;
                        var overnightOption = this.getOvernightOption(item.options);
                        return this.getIsStandardCamp(item) && ((overnightOption && overnightOption.isSelected) || item.isOvernightBundled);
                    };
                    CartItemDirCtrl.prototype.getMonthlyRenewalDayOrdinal = function () {
                        return ShoppingCartMgr.GetMonthlyRenewalDayOrdinal();
                    };
                    CartItemDirCtrl.prototype.getDivisionAbbr = function (divID) {
                        var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, divID);
                        return div ? div.abbr : "";
                    };
                    CartItemDirCtrl.controllerId = "CartItemDirCtrl";
                    return CartItemDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartItemDir.CartItemDirCtrl = CartItemDirCtrl;
            })(CartItemDir = PulsePublic.CartItemDir || (PulsePublic.CartItemDir = {}));
            Pulse.app.directive(CartItemDir.directiveId, ["common", function (c) { return new CartItemDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartCrossSellItemDir = (function (_super) {
                __extends(CartCrossSellItemDir, _super);
                function CartCrossSellItemDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-cross-sell-item.html";
                    _this.require = "^" + PulsePublic.CartItemListDir.directiveId;
                    _this.scope = {
                        item: "<",
                        mode: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartCrossSellItemDir.CartCrossSellItemDirCtrl];
                    return _this;
                }
                CartCrossSellItemDir.directiveId = "idpCartCrossSellItem";
                return CartCrossSellItemDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartCrossSellItemDir = CartCrossSellItemDir;
            (function (CartCrossSellItemDir) {
                var CartCrossSellItemDirCtrl = (function (_super) {
                    __extends(CartCrossSellItemDirCtrl, _super);
                    function CartCrossSellItemDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartCrossSellItemDirCtrl.controllerId) || this;
                        _this._areAllCartCoursesVirtual = null;
                        _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                        _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                        _this.shoppingCartMgr = _this.pulseContext.regFlowMgr.shoppingCartMgr;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "areAllCartCoursesVirtual", {
                        get: function () {
                            if (this._cart) {
                                if (this._areAllCartCoursesVirtual === null) {
                                    this._areAllCartCoursesVirtual = ShoppingCartMgr.AreAllCartCoursesVirtual(this._cart);
                                }
                                return this._areAllCartCoursesVirtual;
                            }
                            else {
                                return false;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "canItemBeRemoved", {
                        get: function () {
                            if (this._canItemBeRemoved == null || typeof this._canItemBeRemoved == 'undefined') {
                                if (this.item == null) {
                                    this._canItemBeRemoved = false;
                                }
                                else {
                                    var participant = this.item.parent;
                                    if (participant.parent.cartTypeID != Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                        this._canItemBeRemoved = true;
                                    }
                                    else {
                                        this._canItemBeRemoved = false;
                                    }
                                }
                            }
                            return this._canItemBeRemoved;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "isChangeOptionsOnlyCart", {
                        get: function () {
                            if (this._isChangeOptionsOnlyCart == null || typeof this._isChangeOptionsOnlyCart == 'undefined') {
                                if (this._cart != null
                                    && this._cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                    this._isChangeOptionsOnlyCart = true;
                                }
                                else {
                                    this._isChangeOptionsOnlyCart = false;
                                }
                            }
                            return this._isChangeOptionsOnlyCart;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "isChangeCourseSessionCart", {
                        get: function () {
                            if (this._cart) {
                                return ShoppingCartMgr.IsChangeOrderCart(this._cart) && this._cart.cartTypeID !== Enums.ShoppingCartType.ChangeOrder_OptionsOnly;
                            }
                            return false;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "isDisabled", {
                        get: function () {
                            if (this._isDisabled == null || typeof this._isDisabled == 'undefined') {
                                if (this.item == null) {
                                    this._isDisabled = true;
                                }
                                else {
                                    this._isDisabled = (this.item.isAvailableForRegistration == false
                                        || (this.hasSelectedOvernightOption
                                            && this._itemOption_Overnight.isAvailableForRegistration == false));
                                }
                            }
                            return this._isDisabled;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "cart", {
                        get: function () {
                            return this._cart;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "participant", {
                        get: function () {
                            return this._participant;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "item", {
                        get: function () {
                            return this._item;
                        },
                        set: function (item) {
                            this.clearCriticalCachedFlags();
                            this._item = item;
                            this._participant = this._item.parent;
                            this._cart = this._participant.parent;
                            this._itemOption_Overnight = null;
                            this.hasSelectedOvernightOption = false;
                            this.calculatedPrice = this._item.itemPrice;
                            this.hasSelectedOvernightOption = this._itemOption_Overnight ? this._itemOption_Overnight.isSelected : false;
                            if (this._itemOption_Overnight != null) {
                                if (this.hasSelectedOvernightOption
                                    && this._cart.cartTypeID != Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                    this.calculatedPrice += this._itemOption_Overnight.itemPrice;
                                }
                            }
                            if (this.item == null
                                || this.item.options == null
                                || this.isDisabled) {
                                this.options = null;
                            }
                            else {
                                if (this._cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                    this.options = this.item.options;
                                }
                                else {
                                    this.options = Pulse.Utils.JS.findByPropertiesNotEqual(this.item.options, { relatedProductTypeID: Enums.RelatedProductType.PrimaryOptionalProduct });
                                }
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "itemOption_Overnight", {
                        get: function () {
                            return this._itemOption_Overnight;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "isPriceVisible", {
                        get: function () {
                            if (this._isPriceVisible == null || typeof this._isPriceVisible == 'undefined') {
                                if (this.item == null) {
                                    this._isPriceVisible = false;
                                }
                                else {
                                    var participant = this.item.parent;
                                    if (participant.parent.cartTypeID == Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                        this._isPriceVisible = false;
                                    }
                                    else {
                                        this._isPriceVisible = true;
                                    }
                                }
                            }
                            return this._isPriceVisible;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "isItemVirtualCamp", {
                        get: function () {
                            return this.item.divisionProgramTypeID === Enums.DivisionProgramType.VirtualCamp;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartCrossSellItemDirCtrl.prototype, "itemName", {
                        get: function () {
                            if (typeof this._itemName == 'undefined') {
                                if (this.item == null) {
                                    this._itemName = "";
                                }
                                else {
                                    this._itemName = this.getItemName(this.item);
                                }
                            }
                            return this._itemName;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartCrossSellItemDirCtrl.prototype.getItemName = function (item) {
                        return item.itemName;
                    };
                    CartCrossSellItemDirCtrl.prototype.clearCriticalCachedFlags = function () {
                        this._areAllCartCoursesVirtual = null;
                        this._canItemBeRemoved = null;
                        this._canSwitchPrimaryOption = null;
                        this._isAfterSchool = null;
                        this._isDisabled = null;
                        this._isDisabledReason = null;
                        this._isPriceVisible = null;
                    };
                    CartCrossSellItemDirCtrl.prototype.removeItem = function () {
                        var _this = this;
                        if (this.item) {
                            var msg = "You are about to remove an item from your cart. Do you want to continue?";
                            var dlg = this.common.dialogService.confirm("Please confirm...", msg, { dialogId: 'MyDialogId', size: 'sm' });
                            dlg.result.then(function (resolve) {
                                _this.$scope.$emit(Events.ShoppingCartRemoveItemRequest, _this.item);
                            }, function (reject) { });
                        }
                    };
                    CartCrossSellItemDirCtrl.prototype.isOptionSelectedInChangeFromCart = function (changeFromItem, SPD_ID) {
                        if (changeFromItem && changeFromItem.options) {
                            return changeFromItem.options.filter(function (opt) { return opt.sessionProductDetailID == SPD_ID && opt.isSelected; }).length > 0;
                        }
                        return false;
                    };
                    CartCrossSellItemDirCtrl.prototype.getDivisionAbbr = function (divID) {
                        var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, divID);
                        return div ? div.abbr : "";
                    };
                    CartCrossSellItemDirCtrl.prototype.showItemHelp = function () {
                        var isOpl = this.item.productCategoryTypeID == Enums.ProductCategoryType.Tutor;
                        var image = isOpl ? '' : "<img src=\"" + this.getProdThumbUrl(true) + "\" style=\"width:200px; max-width:200px;display:block;margin:auto;margin-bottom:10px;\" />";
                        var desc = image + "<div>" + this.item.prodDescription + "</div>";
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.ProductInfo, this.item.itemName, desc, null);
                    };
                    CartCrossSellItemDirCtrl.prototype.getProdThumbUrl = function (isLarge) {
                        if (isLarge === void 0) { isLarge = false; }
                        var url = this.item.productURLs.filter(function (u) { return u.usageTypeID == Enums.ProductURLType.CourseVideoIntroImageURL; });
                        if (url.length > 0 && url[0].url) {
                            return Pulse.Utils.JS.composeProductThumbNailFullUrl(this.common.config.courseVideoThumbnailUrl, url[0].url, isLarge);
                        }
                        return "";
                    };
                    CartCrossSellItemDirCtrl.controllerId = "CartCrossSellItemDirCtrl";
                    return CartCrossSellItemDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartCrossSellItemDir.CartCrossSellItemDirCtrl = CartCrossSellItemDirCtrl;
            })(CartCrossSellItemDir = PulsePublic.CartCrossSellItemDir || (PulsePublic.CartCrossSellItemDir = {}));
            Pulse.app.directive(CartCrossSellItemDir.directiveId, ["common", function (c) { return new CartCrossSellItemDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartItemListDir = (function (_super) {
                __extends(CartItemListDir, _super);
                function CartItemListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-item-list.html";
                    _this.scope = {
                        items: "<",
                        isCrossSellItems: "<",
                        participant: "<",
                        mode: "<"
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartItemListDir.CartItemListDirCtrl
                    ];
                    return _this;
                }
                CartItemListDir.directiveId = "idpCartItemList";
                return CartItemListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartItemListDir = CartItemListDir;
            (function (CartItemListDir) {
                var CartItemListDirCtrl = (function (_super) {
                    __extends(CartItemListDirCtrl, _super);
                    function CartItemListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartItemListDirCtrl.controllerId) || this;
                        _this.isCrossSellItems = false;
                        _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                        _this.activateController();
                        return _this;
                    }
                    CartItemListDirCtrl.controllerId = "CartItemListDirCtrl";
                    return CartItemListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartItemListDir.CartItemListDirCtrl = CartItemListDirCtrl;
            })(CartItemListDir = PulsePublic.CartItemListDir || (PulsePublic.CartItemListDir = {}));
            Pulse.app.directive(CartItemListDir.directiveId, ["common", function (c) { return new CartItemListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartItemOptionDir = (function (_super) {
                __extends(CartItemOptionDir, _super);
                function CartItemOptionDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-item-option.html";
                    _this.require = "^" + PulsePublic.CartItemOptionListDir.directiveId;
                    _this.scope = {
                        option: "<",
                        mode: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartItemOptionDir.CartItemOptionDirCtrl];
                    return _this;
                }
                CartItemOptionDir.directiveId = "idpCartItemOption";
                return CartItemOptionDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartItemOptionDir = CartItemOptionDir;
            (function (CartItemOptionDir) {
                var CartItemOptionDirCtrl = (function (_super) {
                    __extends(CartItemOptionDirCtrl, _super);
                    function CartItemOptionDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartItemOptionDirCtrl.controllerId) || this;
                        _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                        _this._hasAdminOverride = null;
                        _this.isMeals = false;
                        _this.isCEU = false;
                        _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                        _this.id = CartItemOptionDirCtrl._instanceCount++;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "option", {
                        get: function () {
                            return this._option;
                        },
                        set: function (option) {
                            this._option = option;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "hasOverrideableAgeRestriction", {
                        get: function () {
                            if (typeof this._hasOverrideableAgeRestriction == "undefined") {
                                if (this.option == null) {
                                    this._hasOverrideableAgeRestriction = false;
                                }
                                else if (this.option.isValidForParticipantsAge) {
                                    this._hasOverrideableAgeRestriction = false;
                                }
                                else {
                                    this._hasOverrideableAgeRestriction = this.pulseContext.canOverrideRegFlowRestrictions;
                                }
                            }
                            return this._hasOverrideableAgeRestriction;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "hasAdminOverride", {
                        get: function () {
                            if (this._hasAdminOverride)
                                return this._hasAdminOverride;
                            this._hasAdminOverride = false;
                            this._hasAdminOverride = this.hasItemAdminOverride(this.option);
                            return this._hasAdminOverride;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "isVisible", {
                        get: function () {
                            if (this._isVisible == null || typeof this._isVisible == "undefined") {
                                if (this.option.productCategoryTypeID == Enums.ProductCategoryType.Residency
                                    && (this.option.productSubCatTypeID == Enums.ProductSubCategoryType.Overnight
                                        || this.option.productSubCatTypeID == Enums.ProductSubCategoryType.OvernightAndWeekend)) {
                                    this._isVisible = false;
                                }
                                else {
                                    this._isVisible = true;
                                }
                            }
                            return this._isVisible;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "isDisabled", {
                        get: function () {
                            if (this._isDisabled == null || typeof this._isDisabled == "undefined") {
                                if ((this.option == null
                                    || this.option.isSoldOut
                                    || this.option.isAvailableForRegistration == false
                                    || !(this.option.isValidForParticipantsAge || this.pulseContext.canOverrideRegFlowRestrictions)
                                    || this.option.relatedProductTypeID == Enums.RelatedProductType.Required)
                                    && this.option.wasOriginalSelectionInOptionOnlyChangeCart == false) {
                                    this._isDisabled = true;
                                }
                                else if (this.option && this.option.isNotAllowedCancel) {
                                    this._isDisabled = true;
                                }
                                else {
                                    this._isDisabled = false;
                                }
                            }
                            return this._isDisabled;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemOptionDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        this.isMeals = (this.option.productCategoryTypeID == Enums.ProductCategoryType.Meal);
                        this.isCEU = (this.option.productCategoryTypeID == Enums.ProductCategoryType.CEU);
                        scope.$on(Pulse.Common.BasePopup.EventType.Close, function (event, data) {
                            _this.childPopupClosed(event, data);
                        });
                    };
                    CartItemOptionDirCtrl.prototype.childPopupClosed = function (event, data) {
                        if (data && data[0] && data[0].callbackID && data[0].callbackID == this._ageOverrideCallbackID) {
                            this.option.isSelected = true;
                            this.handleCheckboxClick();
                        }
                    };
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "participant", {
                        get: function () {
                            return this.option.parent.parent;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemOptionDirCtrl.prototype.getOptionName = function (option) {
                        if (option.productSubCatTypeID == Enums.ProductSubCategoryType.CoursePreparation) {
                            return option.itemName + ": " + option.parent.itemName;
                        }
                        return option.itemName;
                    };
                    CartItemOptionDirCtrl.prototype.hasItemAdminOverride = function (item) {
                        var participantUserBrowsingID = item.parent.parent.userBrowsingID;
                        return this.userBrowsingMgr.hasAdminOverride(this.userBrowsingMgr.currentUBSession, {
                            child_UB_ID: this.participant.userBrowsingID,
                            locationID: item.parent.locationID,
                            productID: item.productID,
                            sessionID: item.sessionID,
                            sessionProductDetailID: item.sessionProductDetailID,
                        });
                    };
                    CartItemOptionDirCtrl.prototype.removeAdminOverridesFromItem = function (item, saveToDB) {
                        var adminOverride = {
                            child_UB_ID: this.participant.userBrowsingID,
                            productID: item.productID,
                            locationID: item.parent.locationID,
                            sessionID: item.sessionID,
                            sessionProductDetailID: item.sessionProductDetailID,
                        };
                        this.pulseContext.regFlowMgr.userBrowsingMgr.removeAdminOverride(this.userBrowsingMgr.currentUBSession, adminOverride, saveToDB);
                    };
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "hasRequiredStatus", {
                        get: function () {
                            return this.option.relatedProductTypeID === Enums.RelatedProductType.Required;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "hideCheckbox", {
                        get: function () {
                            return this.option.productCategoryTypeID === Enums.ProductCategoryType.Merchandise
                                && this.option.relatedProductTypeID === Enums.RelatedProductType.Required;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemOptionDirCtrl.prototype.handleCheckboxClick = function () {
                        if (!this.hasRequiredStatus && !this.isDisabled) {
                            if (this.option.isSelected
                                && !this.option.isValidForParticipantsAge
                                && !this.hasItemAdminOverride(this.option)) {
                                this._ageOverrideCallbackID = this.participant.userBrowsingID + "_" + this.option.parent.sessionProductDetailID + "_" + this.option.sessionProductDetailID;
                                this.common.$rootScope.$broadcast(Events.ShowRegFlowAdminOverridePopup, {
                                    size: Pulse.Common.BasePopup.ModalSize.Medium,
                                    initDataObj: {
                                        callbackID: this._ageOverrideCallbackID,
                                        overrideReqs: [{
                                                overrideType: PulsePublic.RegFlowAdminOverridePopup.OverrideUIType.AgeOverride,
                                                productName: this.option.itemName,
                                                minAge: this.option.minimumAge,
                                                maxAge: this.option.maximumAge,
                                                productID: this.option.productID,
                                                sessionID: this.option.sessionID,
                                                locationID: this.option.parent.locationID,
                                                sessionProductDetailID: this.option.sessionProductDetailID,
                                                DOB: this.participant.dateOfBirth,
                                                child_UB_ID: this.participant.userBrowsingID,
                                            }]
                                    }
                                });
                                this.option.isSelected = false;
                                return;
                            }
                            else if (!this.option.isSelected) {
                                if (this.hasItemAdminOverride(this.option)) {
                                    this.removeAdminOverridesFromItem(this.option, true);
                                }
                            }
                            this.$scope.$emit(Events.ShoppingCartItemOptionSelectedChangeRequest, this.option);
                        }
                    };
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "isCoursePrepOption", {
                        get: function () {
                            return this.option.productSubCatTypeID === Enums.ProductSubCategoryType.CoursePreparation;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "isVisibleCoursePrepOptionMessage", {
                        get: function () {
                            return this.isCoursePrepOption && this.option.isNotAllowedCancel && this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_SHOPPING_CART;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "hasMessage", {
                        get: function () {
                            return this.hasOverrideableAgeRestriction || this.isVisibleCoursePrepOptionMessage;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemOptionDirCtrl.prototype.getMessage = function () {
                        if (this.hasOverrideableAgeRestriction) {
                            return this.getOverrideMessage();
                        }
                        else if (this.isVisibleCoursePrepOptionMessage) {
                            return StringConst.Warn_CoursePrepOptionNotRemovable.replace("[TollFreeNumber]", this.pulseContext.companyTollFreePhone);
                        }
                        return "";
                    };
                    CartItemOptionDirCtrl.prototype.getOverrideMessage = function () {
                        if (this.hasAdminOverride) {
                            return "Overridden";
                        }
                        else if (this.hasOverrideableAgeRestriction)
                            return StringConst.Warn_StudentNotMeetAgeRequirement;
                    };
                    CartItemOptionDirCtrl.prototype.showOptionHelp = function ($event) {
                        $event.preventDefault();
                        var paramStr = "";
                        if (this.option.sessionProductDetailID > 0) {
                            paramStr = "spd_" + this.option.sessionProductDetailID;
                        }
                        else {
                            paramStr = "p_" + this.option.productID;
                        }
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.OptionInfo, this.option.itemName, paramStr, "itemOptionHelp" + this.id);
                    };
                    CartItemOptionDirCtrl.prototype.showUnavailableDetails = function () {
                        var msg = 'We apologize but the "' + this.option.itemName + '" add-on is no longer available'
                            + ' for purchase this session.';
                        switch (this.option.productCategoryTypeID) {
                            case Enums.ProductCategoryType.Meal:
                                if (this.option.productSubCatTypeID == Enums.ProductSubCategoryType.Lunch) {
                                    msg += ' Students must bring a lunch from home.';
                                }
                                else {
                                    msg += ' Students must bring meals from home.';
                                }
                                break;
                        }
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Details", " " + msg, null);
                    };
                    Object.defineProperty(CartItemOptionDirCtrl.prototype, "productImage", {
                        get: function () {
                            if (this._prodImg === undefined) {
                                this._prodImg = ShoppingCartMgr.GetThumbNailFullUrl(this.common.config, this.option);
                                this._prodImg = String.isNullOrWhitespace(this._prodImg) ? null : this._prodImg;
                            }
                            return this._prodImg;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemOptionDirCtrl.controllerId = "CartItemOptionDirCtrl";
                    CartItemOptionDirCtrl._instanceCount = 0;
                    return CartItemOptionDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartItemOptionDir.CartItemOptionDirCtrl = CartItemOptionDirCtrl;
            })(CartItemOptionDir = PulsePublic.CartItemOptionDir || (PulsePublic.CartItemOptionDir = {}));
            Pulse.app.directive(CartItemOptionDir.directiveId, ["common", function (c) { return new CartItemOptionDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartItemOptionListDir = (function (_super) {
                __extends(CartItemOptionListDir, _super);
                function CartItemOptionListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-item-option-list.html";
                    _this.scope = {
                        options: "<",
                        mode: "<"
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartItemOptionListDir.CartItemOptionListDirCtrl
                    ];
                    return _this;
                }
                CartItemOptionListDir.directiveId = "idpCartItemOptionList";
                return CartItemOptionListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartItemOptionListDir = CartItemOptionListDir;
            (function (CartItemOptionListDir) {
                var CartItemOptionListDirCtrl = (function (_super) {
                    __extends(CartItemOptionListDirCtrl, _super);
                    function CartItemOptionListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartItemOptionListDirCtrl.controllerId) || this;
                        _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                        _this._optionsWithoutOptionGroup = null;
                        _this._addOnMerchOptionsWithoutOptionGroup = null;
                        _this._requiredMerchWithoutOptionGroup = null;
                        _this.activateController();
                        return _this;
                    }
                    CartItemOptionListDirCtrl.prototype.$onInit = function () {
                        return;
                    };
                    CartItemOptionListDirCtrl.prototype.$onChanges = function (changes) {
                        var _this = this;
                        this._optionsWithoutOptionGroup = null;
                        this._requiredMerchWithoutOptionGroup = null;
                        this._addOnMerchOptionsWithoutOptionGroup = null;
                        this.options = changes.options.currentValue;
                        if (this.options) {
                            this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.CourseOptionGroup)
                                .then(function (data) {
                                _this.optionGroups = data.filter(function (og) {
                                    var opts = _this.options
                                        .filter(function (opt) { return opt.productSubCatGroupID === og.typeID
                                        && (opt.isSelected ||
                                            (_this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_SHOPPING_CART
                                                && (opt.isValidForParticipantsAge || _this.pulseContext.isImpersonating))); });
                                    return opts && opts.length > 0;
                                });
                            });
                        }
                        else {
                            this.optionGroups = null;
                        }
                    };
                    CartItemOptionListDirCtrl.prototype.getOptionsWithoutOptionGroup = function () {
                        if (this._optionsWithoutOptionGroup == null && this.options && this.options.length) {
                            this._optionsWithoutOptionGroup = this.options.filter(function (opt) { return opt.sessionProductDetailID && !opt.productSubCatGroupID; });
                        }
                        return this._optionsWithoutOptionGroup;
                    };
                    CartItemOptionListDirCtrl.prototype.getOptionsByOptionGroupID = function (optGroupID) {
                        if (this.options && this.options.length) {
                            return this.options.filter(function (opt) { return opt.productSubCatGroupID === optGroupID; });
                        }
                        return null;
                    };
                    CartItemOptionListDirCtrl.prototype.getAddOnMerchOptionsWithoutOptionGroup = function () {
                        if (this._addOnMerchOptionsWithoutOptionGroup == null && this.options && this.options.length) {
                            this._addOnMerchOptionsWithoutOptionGroup =
                                this.options.filter(function (opt) { return opt.relatedProductTypeID !== Enums.RelatedProductType.Required
                                    && !opt.sessionProductDetailID && !opt.productSubCatGroupID; });
                        }
                        return this._addOnMerchOptionsWithoutOptionGroup;
                    };
                    CartItemOptionListDirCtrl.prototype.hasSelectedAddOnMerchOptionsWithoutOptionGroup = function () {
                        var options = this.getAddOnMerchOptionsWithoutOptionGroup();
                        if (options && options.filter(function (opt) { return opt.isSelected; }).length) {
                            return true;
                        }
                        return false;
                    };
                    CartItemOptionListDirCtrl.prototype.getRequiredMerchWithoutOptionGroup = function () {
                        if (this._requiredMerchWithoutOptionGroup == null && this.options && this.options.length) {
                            this._requiredMerchWithoutOptionGroup =
                                this.options.filter(function (opt) { return opt.relatedProductTypeID === Enums.RelatedProductType.Required
                                    && !opt.sessionProductDetailID && !opt.productSubCatGroupID; });
                        }
                        return this._requiredMerchWithoutOptionGroup;
                    };
                    CartItemOptionListDirCtrl.controllerId = "CartItemOptionListDirCtrl";
                    return CartItemOptionListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartItemOptionListDir.CartItemOptionListDirCtrl = CartItemOptionListDirCtrl;
            })(CartItemOptionListDir = PulsePublic.CartItemOptionListDir || (PulsePublic.CartItemOptionListDir = {}));
            Pulse.app.directive(CartItemOptionListDir.directiveId, ["common", function (c) { return new CartItemOptionListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartNonParticipantItemDir = (function (_super) {
                __extends(CartNonParticipantItemDir, _super);
                function CartNonParticipantItemDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-non-participant-item.html";
                    _this.require = "^" + PulsePublic.CartNonParticipantItemListDir.directiveId;
                    _this.scope = {
                        item: "<",
                        mode: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartNonParticipantItemDir.CartNonParticipantItemDirCtrl];
                    return _this;
                }
                CartNonParticipantItemDir.directiveId = "idpCartNonParticipantItem";
                return CartNonParticipantItemDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartNonParticipantItemDir = CartNonParticipantItemDir;
            (function (CartNonParticipantItemDir) {
                var CartNonParticipantItemDirCtrl = (function (_super) {
                    __extends(CartNonParticipantItemDirCtrl, _super);
                    function CartNonParticipantItemDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartNonParticipantItemDirCtrl.controllerId) || this;
                        _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                        _this.userBrowsingMgr = _this.pulseContext.regFlowMgr.userBrowsingMgr;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CartNonParticipantItemDirCtrl.prototype, "canItemBeRemoved", {
                        get: function () {
                            if (this._canItemBeRemoved == null || typeof this._canItemBeRemoved == 'undefined') {
                                if (this.item == null) {
                                    this._canItemBeRemoved = false;
                                }
                                else {
                                    if (this._cart != null && this._cart.cartTypeID == Enums.ShoppingCartType.RegFlow) {
                                        this._canItemBeRemoved = true;
                                    }
                                    else {
                                        this._canItemBeRemoved = false;
                                    }
                                }
                            }
                            return this._canItemBeRemoved;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartNonParticipantItemDirCtrl.prototype, "isChangeOptionsOnlyCart", {
                        get: function () {
                            if (this._isChangeOptionsOnlyCart == null || typeof this._isChangeOptionsOnlyCart == 'undefined') {
                                if (this._cart != null
                                    && this._cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                    this._isChangeOptionsOnlyCart = true;
                                }
                                else {
                                    this._isChangeOptionsOnlyCart = false;
                                }
                            }
                            return this._isChangeOptionsOnlyCart;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartNonParticipantItemDirCtrl.prototype, "isDisabled", {
                        get: function () {
                            if (this._isDisabled == null || typeof this._isDisabled == 'undefined') {
                                if (this.item == null) {
                                    this._isDisabled = true;
                                }
                                else {
                                    this._isDisabled = this.item.isAvailableForRegistration == false;
                                }
                            }
                            return this._isDisabled;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartNonParticipantItemDirCtrl.prototype, "isDisabledReason", {
                        get: function () {
                            if (this._isDisabledReason == null || typeof this._isDisabledReason == 'undefined') {
                                if (this.isDisabled) {
                                    if (this.item == null) {
                                        this._isDisabledReason = "";
                                    }
                                    else if (this.item.isSoldOut) {
                                        this._isDisabledReason = "Sold Out";
                                    }
                                    else if (this.item.isAvailableForRegistration == false) {
                                        this._isDisabledReason = "Not available for purchase at this time.";
                                    }
                                    else {
                                        this._isDisabledReason = "";
                                    }
                                }
                                else {
                                    this._isDisabledReason = "";
                                }
                            }
                            return this._isDisabledReason;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartNonParticipantItemDirCtrl.prototype, "cart", {
                        get: function () {
                            return this._cart;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartNonParticipantItemDirCtrl.prototype, "item", {
                        get: function () {
                            return this._item;
                        },
                        set: function (item) {
                            this.clearCriticalCachedFlags();
                            this._item = item;
                            this._cart = this._item.parent;
                            this.calculatedPrice = this._item.itemPrice;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartNonParticipantItemDirCtrl.prototype, "isPriceVisible", {
                        get: function () {
                            if (this._isPriceVisible == null || typeof this._isPriceVisible == 'undefined') {
                                if (this.item == null) {
                                    this._isPriceVisible = false;
                                }
                                else {
                                    if (this._cart != null && this._cart.cartTypeID == Enums.ShoppingCartType.ChangeOrder_OptionsOnly) {
                                        this._isPriceVisible = false;
                                    }
                                    else {
                                        this._isPriceVisible = true;
                                    }
                                }
                            }
                            return this._isPriceVisible;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartNonParticipantItemDirCtrl.prototype, "itemName", {
                        get: function () {
                            if (typeof this._itemName == 'undefined') {
                                if (this.item == null) {
                                    this._itemName = "";
                                }
                                else {
                                    var s = this.item.itemName;
                                    if (this.item.productSubCatTypeID == Enums.ProductSubCategoryType.ProductCoupon) {
                                        this._itemName = s;
                                    }
                                    else {
                                        if (this.item.locationName) {
                                            s += " - " + this.item.locationName;
                                        }
                                        if (this.item.productCategoryTypeID != Enums.ProductCategoryType.PurchaseCredit
                                            && this.item.divisionName) {
                                            s += " - " + this.item.divisionName;
                                        }
                                        this._itemName = s;
                                    }
                                }
                            }
                            return this._itemName;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartNonParticipantItemDirCtrl.prototype.clearCriticalCachedFlags = function () {
                        this._canItemBeRemoved = null;
                        this._isDisabled = null;
                        this._isDisabledReason = null;
                        this._isPriceVisible = null;
                    };
                    CartNonParticipantItemDirCtrl.prototype.removeItem = function () {
                        var _this = this;
                        if (this.item) {
                            var msg = null;
                            msg = "You are about to remove a product. Do you want to continue?";
                            var dlg = this.common.dialogService.confirm("Please confirm...", msg, { dialogId: 'MyDialogId', size: 'sm' });
                            dlg.result.then(function (resolve) {
                                _this.$scope.$emit(Events.ShoppingCartRemoveNonParticipantItemRequest, _this.item);
                            }, function (reject) { });
                        }
                    };
                    CartNonParticipantItemDirCtrl.prototype.toggleEditMode = function () {
                        if (this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY) {
                            this.$scope.$emit(Events.OrderSummaryChangeRequest);
                        }
                    };
                    CartNonParticipantItemDirCtrl.controllerId = "CartNonParticipantItemDirCtrl";
                    return CartNonParticipantItemDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartNonParticipantItemDir.CartNonParticipantItemDirCtrl = CartNonParticipantItemDirCtrl;
            })(CartNonParticipantItemDir = PulsePublic.CartNonParticipantItemDir || (PulsePublic.CartNonParticipantItemDir = {}));
            Pulse.app.directive(CartNonParticipantItemDir.directiveId, ["common", function (c) { return new CartNonParticipantItemDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartNonParticipantItemListDir = (function (_super) {
                __extends(CartNonParticipantItemListDir, _super);
                function CartNonParticipantItemListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-non-participant-item-list.html";
                    _this.scope = {
                        items: "<",
                        mode: "<"
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartNonParticipantItemListDir.CartNonParticipantItemListDirCtrl
                    ];
                    return _this;
                }
                CartNonParticipantItemListDir.directiveId = "idpCartNonParticipantItemList";
                return CartNonParticipantItemListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartNonParticipantItemListDir = CartNonParticipantItemListDir;
            (function (CartNonParticipantItemListDir) {
                var CartNonParticipantItemListDirCtrl = (function (_super) {
                    __extends(CartNonParticipantItemListDirCtrl, _super);
                    function CartNonParticipantItemListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartNonParticipantItemListDirCtrl.controllerId) || this;
                        _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                        _this.activateController();
                        return _this;
                    }
                    CartNonParticipantItemListDirCtrl.controllerId = "CartNonParticipantItemListDirCtrl";
                    return CartNonParticipantItemListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartNonParticipantItemListDir.CartNonParticipantItemListDirCtrl = CartNonParticipantItemListDirCtrl;
            })(CartNonParticipantItemListDir = PulsePublic.CartNonParticipantItemListDir || (PulsePublic.CartNonParticipantItemListDir = {}));
            Pulse.app.directive(CartNonParticipantItemListDir.directiveId, ["common", function (c) { return new CartNonParticipantItemListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartParticipantDir = (function (_super) {
                __extends(CartParticipantDir, _super);
                function CartParticipantDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-participant.html";
                    _this.require = "^" + PulsePublic.CartParticipantListDir.directiveId;
                    _this.scope = {
                        teeShirtSizeTypes: "<",
                        teeShirtSizeDict: "<",
                        userRelationTypes: "<",
                        userRelationDict: "<",
                        mode: "<",
                        firstTabIndex: "<",
                        participant: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartParticipantDir.CartParticipantDirCtrl];
                    return _this;
                }
                CartParticipantDir.directiveId = "idpCartParticipant";
                return CartParticipantDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartParticipantDir = CartParticipantDir;
            (function (CartParticipantDir) {
                var CartParticipantDirCtrl = (function (_super) {
                    __extends(CartParticipantDirCtrl, _super);
                    function CartParticipantDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartParticipantDirCtrl.controllerId) || this;
                        _this._areAllCoursesVirtual = null;
                        _this._doesParticipantHaveAtLeastOneCourse = null;
                        _this._doesParticipantHaveAtLeastOneVirtualCourse = null;
                        _this._participantItems = null;
                        _this._participantCrossSellItems = null;
                        _this.ShoppingCartUIMode = ShoppingCartMgr.ShoppingCartUIMode;
                        _this.editMode = false;
                        _this.minDateOfBirth = moment().subtract(19, 'years').format('YYYY-MM-DD');
                        _this.maxDateOfBirth = moment().subtract(6, 'years').format('YYYY-MM-DD');
                        _this.matchingStudentCandidates = [];
                        _this.formName = "studentForm";
                        _this.checkUnsavedDataBeforeNav = false;
                        _this._optionIsSelectedChangeHandler = $scope.$on(Events.ShoppingCartItemOptionSelectedChangeRequest, function (event, option) {
                            _this.onOptionIsSelectedChange(option);
                        });
                        _this._removeItemHandler = $scope.$on(Events.ShoppingCartRemoveItemRequest, function (event, item) {
                            _this.onRemoveItem(item);
                        });
                        _this._switchPrimaryOptionHandler = $scope.$on(Events.ShoppingCartPrimaryOptionChangeRequest, function (event, change) {
                            _this.onPrimaryOptionChange(change);
                        });
                        _this._checkOutRequestHandler = $scope.$on(Events.RegFlowCheckOutRequested, function (event, isCheckingOut) {
                            _this.onCheckOutRequested(isCheckingOut);
                        });
                        $scope.$on('$destroy', function () {
                            _this._optionIsSelectedChangeHandler();
                            _this._removeItemHandler();
                            _this._switchPrimaryOptionHandler();
                            _this._checkOutRequestHandler();
                            _this.pulseContext.pulseAriaService.ClearState();
                        });
                        _this.$scope.$on(Events.StudentsMerged, function (e, data) {
                            _this.getMatchingStudents();
                        });
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "currencyTypeID", {
                        get: function () {
                            return this.pulseContext.selectedCurrencyTypeID;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "participant", {
                        get: function () {
                            return this._participant;
                        },
                        set: function (participant) {
                            if (participant) {
                                this._participant = participant;
                                this._participantItems = null;
                                this._participantCrossSellItems = null;
                                this.fees = this._participant.fees;
                                if (this.pulseContext) {
                                    this.total = ShoppingCartMgr.CalculateParticipantTotal(this._participant.parent, this._participant);
                                }
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "participantItems", {
                        get: function () {
                            if (this.participant) {
                                if (!this._participantItems) {
                                    var items = void 0;
                                    if (this.mode === ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY && !this.pulseContext.isImpersonating) {
                                        items = this.participant.itemsFiltered;
                                    }
                                    else {
                                        items = this.participant.items;
                                    }
                                    this._participantItems = items.filter(function (item) { return DataAccess.ProductDAO.ProductVisibilityType_CrossSellTypes.indexOf(item.visibilityTypeID) < 0; });
                                }
                                return this._participantItems;
                            }
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "participantCrossSellItems", {
                        get: function () {
                            if (this.participant) {
                                if (!this._participantCrossSellItems) {
                                    var items = void 0;
                                    if (this.mode === ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY && !this.pulseContext.isImpersonating) {
                                        items = this.participant.itemsFiltered;
                                    }
                                    else {
                                        items = this.participant.items;
                                    }
                                    this._participantCrossSellItems = items.filter(function (item) { return DataAccess.ProductDAO.ProductVisibilityType_CrossSellTypes.indexOf(item.visibilityTypeID) >= 0; });
                                }
                                return this._participantCrossSellItems;
                            }
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "dateOfBirth", {
                        get: function () {
                            return this.participant.dateOfBirth;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "areAllCoursesVirtual", {
                        get: function () {
                            if (this.participant) {
                                if (this._areAllCoursesVirtual === null) {
                                    this._areAllCoursesVirtual = ShoppingCartMgr
                                        .AreAllParticipantCoursesVirtual(this.participant);
                                }
                                return this._areAllCoursesVirtual;
                            }
                            else {
                                return false;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "doesParticipantHaveAtLeastOneCourse", {
                        get: function () {
                            if (this.participant) {
                                if (this._doesParticipantHaveAtLeastOneCourse === null) {
                                    this._doesParticipantHaveAtLeastOneCourse = ShoppingCartMgr
                                        .DoesParticipantHaveAtLeastOneCourse(this.participant);
                                }
                                return this._doesParticipantHaveAtLeastOneCourse;
                            }
                            else {
                                return true;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "doesParticipantHaveAtLeastOneVirtualCourse", {
                        get: function () {
                            if (this.participant) {
                                if (this._doesParticipantHaveAtLeastOneVirtualCourse === null) {
                                    this._doesParticipantHaveAtLeastOneVirtualCourse = ShoppingCartMgr
                                        .DoesParticipantHaveAtLeastOneCourse(this.participant, true);
                                }
                                return this._doesParticipantHaveAtLeastOneVirtualCourse;
                            }
                            else {
                                return true;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "genderTypeID", {
                        get: function () {
                            return this.participant.genderTypeID;
                        },
                        set: function (typeID) {
                            this.participant.genderTypeID = typeID;
                            this.myForm.$setDirty();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "userRelationTypeID", {
                        get: function () {
                            return this.participant.userRelationTypeID;
                        },
                        set: function (typeID) {
                            var _this = this;
                            this.participant.userRelationTypeID = typeID;
                            if (typeID == Enums.UserRelationshipType.Other && !this.areAllCoursesVirtual) {
                                document.getElementById("relationshipToStudent" + this.participant.userBrowsingID).blur();
                                this.common.$timeout(function () {
                                    var warningHtml = "You have selected '<b>Other</b>' as your relationship to this student."
                                        + " <br/><br/><b>IMPORTANT</b>: Only the student's parent/guardian can complete the student health and safety form."
                                        + " This form is required to attend camp. <br/><br/><b>After you register here, please call Client Services"
                                        + " (888-709-8324)</b> to learn how to establish an iD Tech account for the parent/guardian and"
                                        + " give them permission to access and complete the student's forms.";
                                    _this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Please note...", " " + warningHtml, "relationshipToStudent" + _this.participant.userBrowsingID);
                                }, 250);
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantDirCtrl.prototype, "isMatchStudentPromptVisible", {
                        get: function () {
                            return (this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY
                                && !this.participant.userID
                                && (this.matchingStudentCandidates.length > 0));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartParticipantDirCtrl.prototype.$onInit = function () {
                        var _this = this;
                        this.pulseContext.pulseAriaService.AddPlaceholderToField('studentFirstName' + this.participant.userBrowsingID, "First Name");
                        this.pulseContext.pulseAriaService.AddPlaceholderToField('studentLastName' + this.participant.userBrowsingID, "Last Name");
                        this.pulseContext.pulseAriaService.AddPlaceholderToField('studentNickName' + this.participant.userBrowsingID, "Student's preferred name");
                        this.common.$timeout(function () {
                            _this.pulseContext.pulseAriaService.InitAria();
                        }, 5);
                    };
                    CartParticipantDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, transclude);
                        this.total = ShoppingCartMgr.CalculateParticipantTotal(this.participant.parent, this.participant);
                        this.getMatchingStudents();
                        var self = this;
                        this.common.$timeout(function () {
                            self.myForm.$setPristine();
                        }, 0);
                        scope.$on(Pulse.Common.BasePopup.EventType.Close, function (event, data) {
                            _this.warningPopupClosed(event, data);
                        });
                        scope.$on(Pulse.Common.BasePopup.EventType.Dismissed, function (event, data) {
                            _this.warningPopupClosed(event, data);
                        });
                    };
                    CartParticipantDirCtrl.prototype.getMatchingStudents = function () {
                        var _this = this;
                        if (this.pulseContext.isLoggedIn) {
                            this.common.toggleSpinner(true);
                            this.pulseContext.userMgr.loadRelatedUsersForActingUser(true, false)
                                .then(function (data) {
                                var relatedUsers = data;
                                _this.matchingStudentCandidates = _this.pulseContext.userMgr.getMatchingStudentCandidates(_this.participant);
                                var cart = _this.participant.parent;
                                for (var m = _this.matchingStudentCandidates.length - 1, n = 0; m >= n; m--) {
                                    var candidate = _this.matchingStudentCandidates[m];
                                    for (var i = 0, j = cart.participants.length; i < j; i++) {
                                        var cartParticipant = cart.participants[i];
                                        if (cartParticipant.items && cartParticipant.items.length > 0
                                            && candidate.userID === cartParticipant.userID) {
                                            _this.matchingStudentCandidates.splice(m, 1);
                                            break;
                                        }
                                    }
                                }
                            })
                                .catch(function (error) {
                                _this.logError(error);
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                    };
                    CartParticipantDirCtrl.prototype.warningPopupClosed = function (event, data) {
                        if (data && data[1] && data[1].parentId && data[1].parentId.startsWith("relationshipToStudent")) {
                            document.getElementById(data[1].parentId).focus();
                        }
                    };
                    CartParticipantDirCtrl.prototype.saveThenAddCourse = function () {
                        var _this = this;
                        this.myForm.$submitted = false;
                        if (this.myForm.$dirty) {
                            this.common.toggleSpinner(true);
                            var userBrowsingMgr_1 = this.pulseContext.regFlowMgr.userBrowsingMgr;
                            var info_1 = userBrowsingMgr_1.bundleStudentInfoForSave(this.participant);
                            var self_1 = this;
                            userBrowsingMgr_1.loadInfo(userBrowsingMgr_1.currentUBSession, true)
                                .then(function () {
                                return userBrowsingMgr_1.addOrUpdateUserData(userBrowsingMgr_1.currentUBSession, info_1);
                            })
                                .then(function (data) {
                                self_1.addCourse();
                            })
                                .catch(function (err) {
                                _this.logError(err);
                                _this.breezeService.getEntityManager().rejectChanges();
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                        else {
                            this.addCourse();
                        }
                    };
                    CartParticipantDirCtrl.prototype.addCourse = function () {
                        this.$scope.$emit(Events.ShoppingCartAddCourseRequest, this.participant);
                    };
                    CartParticipantDirCtrl.prototype.getCourses = function () {
                        var courses = [];
                        if (this.participant.items) {
                            for (var i = 0; i < this.participant.items.length; i++) {
                                var item = this.participant.items[i];
                                if (item.productCategoryTypeID == Enums.ProductCategoryType.Course) {
                                    courses.push(item);
                                }
                            }
                        }
                        return courses;
                    };
                    CartParticipantDirCtrl.prototype.onOptionIsSelectedChange = function (option) {
                        var _this = this;
                        this.submitted;
                        this.common.toggleSpinner(true, null, null, 0);
                        var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        userBrowsingMgr.loadInfo(userBrowsingMgr.currentUBSession, true)
                            .then(function () {
                            _this.participant.parent.userBrowsingID = userBrowsingMgr.currentUBSession.userBrowsingID;
                            if (option.isSelected) {
                                return _this.pulseContext.regFlowMgr.shoppingCartMgr.addOptionToParticipant(_this.participant.parent, _this.participant.userBrowsingID, option.parent.userBrowsingItemID, option.productID, option.sessionProductDetailID)
                                    .then(function (cartDTO) {
                                    _this.$scope.$emit(Events.ShoppingCartChanged, cartDTO);
                                });
                            }
                            else {
                                return _this.pulseContext.regFlowMgr.shoppingCartMgr.removeOptionFromParticipant(_this.participant.parent, _this.participant.userBrowsingID, option.parent.userBrowsingItemID, option.userBrowsingItemID)
                                    .then(function (cartDTO) {
                                    _this.$scope.$emit(Events.ShoppingCartChanged, cartDTO);
                                });
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    CartParticipantDirCtrl.prototype.onPrimaryOptionChange = function (change) {
                        var _this = this;
                        this.submitted;
                        this.common.toggleSpinner(true, null, null, 0);
                        var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        userBrowsingMgr.loadInfo(userBrowsingMgr.currentUBSession, true)
                            .then(function () {
                            _this.participant.parent.userBrowsingID = userBrowsingMgr.currentUBSession.userBrowsingID;
                            return _this.pulseContext.regFlowMgr.shoppingCartMgr.switchPrimaryOption(_this.participant.parent, _this.participant.userBrowsingID, change.userBrowsingItemID, change.primaryOptionType)
                                .then(function (cartDTO) {
                                _this.$scope.$emit(Events.ShoppingCartChanged, cartDTO);
                            });
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    CartParticipantDirCtrl.prototype.onCheckOutRequested = function (isCheckingOut) {
                        this.editMode = true;
                    };
                    CartParticipantDirCtrl.prototype.onRemoveItem = function (item) {
                        var _this = this;
                        if ((this.participant.items.length == 1) && this.myForm.$dirty) {
                            this.common.toggleSpinner(true, null, null, 0);
                            var userBrowsingMgr_2 = this.pulseContext.regFlowMgr.userBrowsingMgr;
                            var info_2 = userBrowsingMgr_2.bundleStudentInfoForSave(this.participant);
                            var self_2 = this;
                            userBrowsingMgr_2.loadInfo(userBrowsingMgr_2.currentUBSession, true)
                                .then(function () {
                                return userBrowsingMgr_2.addOrUpdateUserData(userBrowsingMgr_2.currentUBSession, info_2);
                            })
                                .then(function (data) {
                                self_2.removeItem(item);
                            })
                                .catch(function (err) {
                                _this.logError(err);
                                _this.breezeService.getEntityManager().rejectChanges();
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                            });
                        }
                        else {
                            this.removeItem(item);
                        }
                    };
                    CartParticipantDirCtrl.prototype.removeItem = function (item) {
                        var _this = this;
                        this.common.toggleSpinner(true, null, null, 0);
                        console.log("removing item");
                        this.pulseContext.regFlowMgr.shoppingCartMgr.removeItemFromParticipant(this.participant.parent, this.participant.userBrowsingID, item.userBrowsingItemID)
                            .then(function (cartDTO) {
                            _this.$scope.$emit(Events.ShoppingCartChanged, cartDTO);
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.clearCacheState();
                            _this.common.toggleSpinner(false);
                            console.log("finished");
                        });
                    };
                    CartParticipantDirCtrl.prototype.clearCacheState = function () {
                        this._areAllCoursesVirtual = null;
                        this._doesParticipantHaveAtLeastOneCourse = null;
                    };
                    CartParticipantDirCtrl.prototype.getTypeString = function (typeID, dict) {
                        var value = null;
                        if (typeID && dict.containsKey(typeID)) {
                            value = dict.getValue(typeID).typeString;
                        }
                        return value;
                    };
                    CartParticipantDirCtrl.prototype.toggleEditMode = function () {
                        if (this.mode == ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY) {
                            this.$scope.$emit(Events.OrderSummaryChangeRequest);
                        }
                        else {
                            this.editMode = !this.editMode;
                            if (this.editMode) {
                            }
                        }
                    };
                    CartParticipantDirCtrl.prototype.showNickNameHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Preferred Name", Directives.HelpPopup.HelpTopic.Nickname, "nickNameHelp" + this.participant.userBrowsingID.toString());
                    };
                    CartParticipantDirCtrl.prototype.showTeeShirtHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Tee Shirt Size", Directives.HelpPopup.HelpTopic.TShirtSize, "teeShirtSizeHelp" + this.participant.userBrowsingID.toString());
                    };
                    CartParticipantDirCtrl.prototype.matchStudent = function () {
                        this.common.$rootScope.$broadcast(Events.ShowStudentMergePopup, {
                            size: '',
                            initDataObj: {
                                participant: this.participant,
                                tabIndex: 100
                            }
                        });
                    };
                    CartParticipantDirCtrl.controllerId = "CartParticipantDirCtrl";
                    return CartParticipantDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartParticipantDir.CartParticipantDirCtrl = CartParticipantDirCtrl;
            })(CartParticipantDir = PulsePublic.CartParticipantDir || (PulsePublic.CartParticipantDir = {}));
            Pulse.app.directive(CartParticipantDir.directiveId, ["common", function (c) { return new CartParticipantDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = DataAccess.Managers.ShoppingCartMgr;
            var CartParticipantListDir = (function (_super) {
                __extends(CartParticipantListDir, _super);
                function CartParticipantListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'reg-flow/shopping-cart/idp-cart-participant-list.html';
                    _this.scope = {
                        participants: '<',
                        mode: '<',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        CartParticipantListDir.CartParticipantListDirCtrl,
                    ];
                    return _this;
                }
                CartParticipantListDir.directiveId = 'idpCartParticipantList';
                return CartParticipantListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartParticipantListDir = CartParticipantListDir;
            (function (CartParticipantListDir) {
                var CartParticipantListDirCtrl = (function (_super) {
                    __extends(CartParticipantListDirCtrl, _super);
                    function CartParticipantListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartParticipantListDirCtrl.controllerId) || this;
                        _this.MODE_MY_ACCOUNT = 'my-account';
                        _this.MODE_ORDER_SUMMARY = 'order-summary';
                        _this.MODE_SHOPPING_CART = 'shopping-cart';
                        _this.teeShirtSizeTypes = null;
                        _this.teeShirtSizeDict = new Pulse.Collections.Dictionary();
                        _this.userRelationTypes = null;
                        _this.userRelationDict = new Pulse.Collections.Dictionary();
                        _this._cartChangeHandler = _this.common.$rootScope.$on(Events.ShoppingCartChanged, function (event, cart) {
                            _this._participants = null;
                        });
                        $scope.$on('$destroy', function () {
                            _this._cartChangeHandler();
                        });
                        return _this;
                    }
                    Object.defineProperty(CartParticipantListDirCtrl.prototype, "mode", {
                        get: function () {
                            return this._mode;
                        },
                        set: function (mode) {
                            this._mode = mode;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantListDirCtrl.prototype, "participants", {
                        get: function () {
                            return this._participants;
                        },
                        set: function (participants) {
                            if (!participants)
                                return;
                            if (this._participants)
                                return;
                            if (this.mode === ShoppingCartMgr.ShoppingCartUIMode.MODE_ORDER_SUMMARY && !this.pulseContext.isImpersonating) {
                                this._participants = [];
                                for (var i = 0, il = participants.length; i < il; ++i) {
                                    var participant = participants[i];
                                    participant.itemsFiltered = [];
                                    for (var j = 0, jl = participant.items.length; j < jl; ++j) {
                                        var item = participant.items[j];
                                        if (item.isAvailableForRegistration && item.isSoldOut == false) {
                                            if (item.options) {
                                                var atLeastOneOptionSelected = item.options.filter(function (o) { return o.isSelected; }).length > 0;
                                                if (atLeastOneOptionSelected) {
                                                    for (var k = 0, kl = item.options.length; k < kl; ++k) {
                                                        var option = item.options[k];
                                                        if (option.isSelected) {
                                                            if (option.productCategoryTypeID == Enums.ProductCategoryType.Residency
                                                                && (option.productSubCatTypeID == Enums.ProductSubCategoryType.Overnight
                                                                    || option.productSubCatTypeID == Enums.ProductSubCategoryType.OvernightAndWeekend)
                                                                && option.isAvailableForRegistration
                                                                && option.isSoldOut) {
                                                                if (participant.itemsFiltered.indexOf(item) === -1) {
                                                                    participant.itemsFiltered.push(item);
                                                                }
                                                            }
                                                            else {
                                                                if (participant.itemsFiltered.indexOf(item) === -1) {
                                                                    participant.itemsFiltered.push(item);
                                                                }
                                                                if (!option.isAvailableForRegistration || option.isSoldOut) {
                                                                    option.isSelected = false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    participant.itemsFiltered.push(item);
                                                }
                                            }
                                            else {
                                                participant.itemsFiltered.push(item);
                                            }
                                        }
                                    }
                                    if (participant.itemsFiltered.length > 0) {
                                        this._participants.push(participant);
                                    }
                                }
                            }
                            else {
                                this._participants = participants;
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartParticipantListDirCtrl.prototype, "participantsHavingAtLeastOneCourse", {
                        get: function () {
                            var keepers = [];
                            angular.forEach(this.participants, function (student) {
                                if (student.items && student.items.length) {
                                    keepers.push(student);
                                }
                            });
                            return keepers;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartParticipantListDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.getTeeShirtSizeTypes());
                        this.activationPromises.push(this.getUserRelationTypes());
                        if (this.mode == this.MODE_ORDER_SUMMARY && this.pulseContext.isLoggedIn) {
                            this.activationPromises.push(this.pulseContext.userMgr.loadRelatedUsersForActingUser(false));
                        }
                        this.activateController();
                    };
                    CartParticipantListDirCtrl.prototype.getTeeShirtSizeTypes = function () {
                        var self = this;
                        this.common.toggleSpinner(true);
                        var pulseTypeDAO = new DataAccess.PulseTypeDAO(this.common, this.breezeService, this.pulseContext);
                        var promise = this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.ShirtSizeGroupType.Student, Enums.TypeClassType.ShirtSize)
                            .then(function (data) {
                            self.teeShirtSizeTypes = data;
                            self.pulseContext.clientFormsMgr.loadTypeDictionary(self.teeShirtSizeTypes, self.teeShirtSizeDict);
                        })
                            .catch(function (error) {
                            self.logError(error);
                        })
                            .finally(function () {
                            self.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    CartParticipantListDirCtrl.prototype.getUserRelationTypes = function () {
                        var self = this;
                        this.common.toggleSpinner(true);
                        var pulseTypeDAO = new DataAccess.PulseTypeDAO(this.common, this.breezeService, this.pulseContext);
                        var promise = this.pulseContext.regFlowMgr.getRegFlowUserRelationTypes()
                            .then(function (data) {
                            self.userRelationTypes = data;
                            self.userRelationDict = new Pulse.Collections.Dictionary();
                            self.pulseContext.clientFormsMgr.loadTypeDictionary(self.userRelationTypes, self.userRelationDict);
                        })
                            .catch(function (error) {
                            self.logError(error);
                        })
                            .finally(function () {
                            self.common.toggleSpinner(false);
                        });
                        return promise;
                    };
                    CartParticipantListDirCtrl.controllerId = 'CartParticipantListDirCtrl';
                    return CartParticipantListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartParticipantListDir.CartParticipantListDirCtrl = CartParticipantListDirCtrl;
            })(CartParticipantListDir = PulsePublic.CartParticipantListDir || (PulsePublic.CartParticipantListDir = {}));
            Pulse.app.directive(CartParticipantListDir.directiveId, ['common', function (c) { return new CartParticipantListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CartItemGroupWithDir = (function (_super) {
                __extends(CartItemGroupWithDir, _super);
                function CartItemGroupWithDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/shopping-cart/idp-cart-item-group-with.html";
                    _this.require = "^" + PulsePublic.CartItemDir.directiveId;
                    _this.scope = {
                        item: "<",
                        mode: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CartItemGroupWithDir.CartItemGroupWithDirCtrl];
                    return _this;
                }
                CartItemGroupWithDir.directiveId = "idpCartItemGroupWith";
                return CartItemGroupWithDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CartItemGroupWithDir = CartItemGroupWithDir;
            (function (CartItemGroupWithDir) {
                var CartItemGroupWithDirCtrl = (function (_super) {
                    __extends(CartItemGroupWithDirCtrl, _super);
                    function CartItemGroupWithDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CartItemGroupWithDirCtrl.controllerId) || this;
                        _this.groupWithList = [];
                        return _this;
                    }
                    CartItemGroupWithDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.getBuddyListAsUserBrowsingNotes());
                        this.activateController();
                    };
                    CartItemGroupWithDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl);
                        scope.$watch(function (scope) {
                            return _this.item;
                        }, function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                _this.getBuddyListAsUserBrowsingNotes();
                            }
                        });
                    };
                    Object.defineProperty(CartItemGroupWithDirCtrl.prototype, "isItemVirtualCamp", {
                        get: function () {
                            return this.item.divisionProgramTypeID === Enums.DivisionProgramType.VirtualCamp;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(CartItemGroupWithDirCtrl.prototype, "isItemSquads", {
                        get: function () {
                            return this.item.catalogTypeID == Enums.SalesCatalogType.SquadsConsecutiveDays || this.item.catalogTypeID == Enums.SalesCatalogType.SquadsMultiWeek;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CartItemGroupWithDirCtrl.prototype.getBuddyListAsUserBrowsingNotes = function () {
                        var _this = this;
                        if (!this.item)
                            return null;
                        this.common.toggleSpinner(true);
                        var ubnDAO = new Pulse.Common.DataAccess.UserBrowsingNoteDAO(this.common, this.breezeService, this.pulseContext);
                        return ubnDAO.loadBuddyListFromUserBrowsingNotes(this.groupWithList, this.pulseContext.browseIdentifier, this.item.userBrowsingParticipantID)
                            .then(function (buddyList) {
                        }).catch(function (err) {
                            _this.logError(err);
                            return null;
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    CartItemGroupWithDirCtrl.prototype.onBuddyListUpdated = function (groupWithList) {
                        this.groupWithList = groupWithList;
                    };
                    CartItemGroupWithDirCtrl.prototype.groupWith = function () {
                        var _this = this;
                        this.common.$rootScope.$broadcast(Events.ShowGroupWithPopup, {
                            size: '',
                            initDataObj: {
                                isVTC: this.isItemVirtualCamp,
                                browseIdentifier: this.pulseContext.browseIdentifier,
                                userBrowsingParticipantID: this.item.userBrowsingParticipantID,
                                afterSaveCallback: function (groupWithList) { _this.onBuddyListUpdated(groupWithList); },
                                maxFriendNumber: this.isItemSquads ? 9 : null,
                                returnFocus: '#groupWithAddButtonId'
                            }
                        });
                    };
                    CartItemGroupWithDirCtrl.controllerId = "CartItemGroupWithDirCtrl";
                    return CartItemGroupWithDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CartItemGroupWithDir.CartItemGroupWithDirCtrl = CartItemGroupWithDirCtrl;
            })(CartItemGroupWithDir = PulsePublic.CartItemGroupWithDir || (PulsePublic.CartItemGroupWithDir = {}));
            Pulse.app.directive(CartItemGroupWithDir.directiveId, ["common", function (c) { return new CartItemGroupWithDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var UpsellItemDir = (function (_super) {
                __extends(UpsellItemDir, _super);
                function UpsellItemDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'reg-flow/upsell/idp-upsell-item.html';
                    _this.require = '^' + UpsellItemDir.directiveId;
                    _this.scope = {
                        participant: '=',
                        product: '<',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        UpsellItemDir.UpsellItemDirCtrl,
                    ];
                    return _this;
                }
                UpsellItemDir.directiveId = 'idpUpsellItem';
                return UpsellItemDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.UpsellItemDir = UpsellItemDir;
            (function (UpsellItemDir) {
                var UpsellItemDirCtrl = (function (_super) {
                    __extends(UpsellItemDirCtrl, _super);
                    function UpsellItemDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, UpsellItemDirCtrl.controllerId) || this;
                        _this.id = UpsellItemDirCtrl._instanceCount++;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(UpsellItemDirCtrl.prototype, "isSelected", {
                        get: function () {
                            if (this.participant && this.participant.items) {
                                var p = this.participant;
                                if (p.selectedProduct) {
                                    this._isSelected = p.selectedProduct === this.product;
                                }
                                if (typeof this._isSelected == 'undefined') {
                                    for (var j = 0; j < this.participant.items.length; j++) {
                                        var item = this.participant.items[j];
                                        if (item.isSelected
                                            && item.productCategoryTypeID == Enums.ProductCategoryType.Tutor
                                            && item.productID == this.product.productID) {
                                            this._isSelected = true;
                                            var p_1 = this.participant;
                                            p_1.selectedProduct = this.product;
                                            p_1.originalSelectedProduct = this.product;
                                            break;
                                        }
                                    }
                                    if (typeof this._isSelected == 'undefined') {
                                        this._isSelected = false;
                                    }
                                }
                                return this._isSelected;
                            }
                            else {
                                return false;
                            }
                        },
                        set: function (isSelected) {
                            if (this.participant) {
                                if (isSelected != this._isSelected) {
                                    this._isSelected = isSelected;
                                    var p = this.participant;
                                    if (this._isSelected) {
                                        p.selectedProduct = this.product;
                                    }
                                    else {
                                        p.selectedProduct = null;
                                    }
                                }
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    UpsellItemDirCtrl.prototype.handleRadioClick = function () {
                        this.isSelected = !this.isSelected;
                    };
                    UpsellItemDirCtrl.controllerId = 'UpsellItemDirCtrl';
                    UpsellItemDirCtrl._instanceCount = 0;
                    return UpsellItemDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                UpsellItemDir.UpsellItemDirCtrl = UpsellItemDirCtrl;
            })(UpsellItemDir = PulsePublic.UpsellItemDir || (PulsePublic.UpsellItemDir = {}));
            Pulse.app.directive(UpsellItemDir.directiveId, ['common', function (c) { return new UpsellItemDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var UpsellItemPromoDir = (function (_super) {
                __extends(UpsellItemPromoDir, _super);
                function UpsellItemPromoDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'reg-flow/upsell/idp-upsell-item-promo.html';
                    _this.require = '^' + UpsellItemPromoDir.directiveId;
                    _this.scope = {
                        product: '<',
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        UpsellItemPromoDir.UpsellItemPromoDirCtrl,
                    ];
                    return _this;
                }
                UpsellItemPromoDir.directiveId = 'idpUpsellItemPromo';
                return UpsellItemPromoDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.UpsellItemPromoDir = UpsellItemPromoDir;
            (function (UpsellItemPromoDir) {
                var UpsellItemPromoDirCtrl = (function (_super) {
                    __extends(UpsellItemPromoDirCtrl, _super);
                    function UpsellItemPromoDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, UpsellItemPromoDirCtrl.controllerId) || this;
                        _this.id = UpsellItemPromoDirCtrl._instanceCount++;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(UpsellItemPromoDirCtrl.prototype, "mostPopularImageUrl", {
                        get: function () {
                            return this.common.config.mediaServerUrl + "/most-popular-badge.png";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    UpsellItemPromoDirCtrl.controllerId = 'UpsellItemPromoDirCtrl';
                    UpsellItemPromoDirCtrl._instanceCount = 0;
                    return UpsellItemPromoDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                UpsellItemPromoDir.UpsellItemPromoDirCtrl = UpsellItemPromoDirCtrl;
            })(UpsellItemPromoDir = PulsePublic.UpsellItemPromoDir || (PulsePublic.UpsellItemPromoDir = {}));
            Pulse.app.directive(UpsellItemPromoDir.directiveId, ['common', function (c) { return new UpsellItemPromoDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var UpsellItemListDir = (function (_super) {
                __extends(UpsellItemListDir, _super);
                function UpsellItemListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/upsell/idp-upsell-item-list.html";
                    _this.scope = {
                        participant: "=",
                        products: "<",
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        UpsellItemListDir.UpsellItemListDirCtrl
                    ];
                    return _this;
                }
                UpsellItemListDir.directiveId = "idpUpsellItemList";
                return UpsellItemListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.UpsellItemListDir = UpsellItemListDir;
            (function (UpsellItemListDir) {
                var UpsellItemListDirCtrl = (function (_super) {
                    __extends(UpsellItemListDirCtrl, _super);
                    function UpsellItemListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, UpsellItemListDirCtrl.controllerId) || this;
                        _this.activateController();
                        return _this;
                    }
                    UpsellItemListDirCtrl.controllerId = "UpsellItemListDirCtrl";
                    return UpsellItemListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                UpsellItemListDir.UpsellItemListDirCtrl = UpsellItemListDirCtrl;
            })(UpsellItemListDir = PulsePublic.UpsellItemListDir || (PulsePublic.UpsellItemListDir = {}));
            Pulse.app.directive(UpsellItemListDir.directiveId, ["common", function (c) { return new UpsellItemListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var RegFlow;
        (function (RegFlow) {
            var Upsell;
            (function (Upsell) {
                var ComponentOptions = Pulse.Common.ComponentOptions;
                var ComponentController = Pulse.Common.ComponentController;
                var ParticipantOptions = (function (_super) {
                    __extends(ParticipantOptions, _super);
                    function ParticipantOptions() {
                        var _this = _super.call(this) || this;
                        _this.bindings = {
                            participant: '<',
                            products: '<',
                        };
                        _this.templateUrl = [
                            'config',
                            function (c) { return c.appRoot
                                + Paths.PulsePublicDirective
                                + 'reg-flow/upsell/idp-upsell-participant-options.html'; },
                        ];
                        _this.controller = [
                            '$scope',
                            '$element',
                            function ($scope, $element) { return new ParticipantOptionsCtrl($scope, $element); },
                        ];
                        return _this;
                    }
                    ParticipantOptions.registeredAs = 'idpUpsellParticipantOptions';
                    return ParticipantOptions;
                }(ComponentOptions));
                var ParticipantOptionsCtrl = (function (_super) {
                    __extends(ParticipantOptionsCtrl, _super);
                    function ParticipantOptionsCtrl($scope, $element) {
                        return _super.call(this, $scope, $element) || this;
                    }
                    ParticipantOptionsCtrl.prototype.$onChanges = function (changesObj) {
                        if (changesObj.participant && this.checkForNewValue(changesObj.participant)
                            && changesObj.products && this.checkForNewValue(changesObj.products)) {
                            if (!this.participant.selectedProducts) {
                                this.participant.selectedProducts = [];
                            }
                            this.applyBoughtOptions(changesObj.participant.currentValue, changesObj.products.currentValue);
                        }
                    };
                    ParticipantOptionsCtrl.prototype.getOptionId = function (product) {
                        return this.participant.userBrowsingID + '' + product.productID;
                    };
                    ParticipantOptionsCtrl.prototype.manageSelect = function (e, product) {
                        this.participant.selectedProducts = [];
                        if (this.selectedProductId === product.productID) {
                            this.selectedProductId = undefined;
                            e.preventDefault();
                        }
                        else {
                            this.participant.selectedProducts.push(product);
                        }
                        if (this.participant.selectedProducts.length > 1) {
                            this.participant.selectedProducts = this.participant.selectedProducts.slice(-1);
                        }
                    };
                    ParticipantOptionsCtrl.prototype.applyBoughtOptions = function (participant, products) {
                        var _this = this;
                        if (participant.items)
                            participant.items.forEach(function (item) {
                                if (item.isSelected && item.productCategoryTypeID === Enums.ProductCategoryType.Tutor)
                                    products.forEach(function (product) {
                                        if (item.productID === product.productID) {
                                            participant.selectedProducts.push(product);
                                            _this.selectedProductId = product.productID;
                                        }
                                    });
                            });
                    };
                    return ParticipantOptionsCtrl;
                }(ComponentController));
                Pulse.app.component(ParticipantOptions.registeredAs, new ParticipantOptions());
            })(Upsell = RegFlow.Upsell || (RegFlow.Upsell = {}));
        })(RegFlow = Directives.RegFlow || (Directives.RegFlow = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var RegFlow;
        (function (RegFlow) {
            var Upsell;
            (function (Upsell) {
                var ComponentOptions = Pulse.Common.ComponentOptions;
                var ComponentController = Pulse.Common.ComponentController;
                var ParticipantOptionsMulti = (function (_super) {
                    __extends(ParticipantOptionsMulti, _super);
                    function ParticipantOptionsMulti() {
                        var _this = _super.call(this) || this;
                        _this.bindings = {
                            participant: '<',
                            products: '<',
                        };
                        _this.templateUrl = [
                            'config',
                            function (c) { return c.appRoot
                                + Paths.PulsePublicDirective
                                + 'reg-flow/upsell/idp-upsell-participant-options-multi.html'; },
                        ];
                        _this.controller = [
                            '$scope',
                            '$element',
                            function ($scope, $element) { return new ParticipantOptionsMultiCtrl($scope, $element); },
                        ];
                        return _this;
                    }
                    ParticipantOptionsMulti.registeredAs = 'idpUpsellParticipantOptionsMulti';
                    return ParticipantOptionsMulti;
                }(ComponentOptions));
                var ParticipantOptionsMultiCtrl = (function (_super) {
                    __extends(ParticipantOptionsMultiCtrl, _super);
                    function ParticipantOptionsMultiCtrl($scope, $element) {
                        var _this = _super.call(this, $scope, $element) || this;
                        _this.selectedProductIDs = [];
                        return _this;
                    }
                    ParticipantOptionsMultiCtrl.prototype.$onChanges = function (changesObj) {
                        if (changesObj.participant && this.checkForNewValue(changesObj.participant)
                            && changesObj.products && this.checkForNewValue(changesObj.products)) {
                            if (!this.participant.selectedProducts) {
                                this.participant.selectedProducts = [];
                            }
                            this.applyBoughtOptions(changesObj.participant.currentValue, changesObj.products.currentValue);
                        }
                    };
                    ParticipantOptionsMultiCtrl.prototype.getOptionId = function (product) {
                        return this.participant.userBrowsingID + '' + product.productID;
                    };
                    ParticipantOptionsMultiCtrl.prototype.manageSelect = function (product) {
                        var prodId = product.productID;
                        var idx = this.selectedProductIDs.indexOf(prodId);
                        if (idx > -1) {
                            this.selectedProductIDs.splice(idx, 1);
                        }
                        else {
                            this.selectedProductIDs.push(prodId);
                        }
                        var prod = this.participant.selectedProducts.indexOf(product);
                        if (prod > -1) {
                            this.participant.selectedProducts.splice(prod, 1);
                        }
                        else {
                            this.participant.selectedProducts.push(product);
                        }
                    };
                    ParticipantOptionsMultiCtrl.prototype.applyBoughtOptions = function (participant, products) {
                        var _this = this;
                        if (participant.items)
                            participant.items.forEach(function (item) {
                                if (item.isSelected && item.productCategoryTypeID === Enums.ProductCategoryType.Tutor)
                                    products.forEach(function (product) {
                                        if (item.productID === product.productID) {
                                            _this.selectedProductIDs.push(product.productID);
                                            participant.selectedProducts.push(product);
                                        }
                                    });
                            });
                    };
                    return ParticipantOptionsMultiCtrl;
                }(ComponentController));
                Pulse.app.component(ParticipantOptionsMulti.registeredAs, new ParticipantOptionsMulti());
            })(Upsell = RegFlow.Upsell || (RegFlow.Upsell = {}));
        })(RegFlow = Directives.RegFlow || (Directives.RegFlow = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var UpsellParticipantDir = (function (_super) {
                __extends(UpsellParticipantDir, _super);
                function UpsellParticipantDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/upsell/idp-upsell-participant.html";
                    _this.require = "^" + PulsePublic.UpsellParticipantListDir.directiveId;
                    _this.scope = {
                        displayNumber: "<",
                        participant: "<",
                        products: "<",
                        isThemePack: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        UpsellParticipantDir.UpsellParticipantDirCtrl];
                    return _this;
                }
                UpsellParticipantDir.directiveId = "idpUpsellParticipant";
                return UpsellParticipantDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.UpsellParticipantDir = UpsellParticipantDir;
            (function (UpsellParticipantDir) {
                var UpsellParticipantDirCtrl = (function (_super) {
                    __extends(UpsellParticipantDirCtrl, _super);
                    function UpsellParticipantDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, UpsellParticipantDirCtrl.controllerId) || this;
                        _this.canEdit = true;
                        _this.genderTypeID = 99001;
                        _this.formName = "frmParticipant";
                        _this.csImpersonatingMinDate = moment().subtract(5, 'year').toDate();
                        _this.csImpersonatingMaxDate = moment().subtract(20, 'year').toDate();
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(UpsellParticipantDirCtrl.prototype, "products", {
                        get: function () {
                            return this._products;
                        },
                        set: function (prods) {
                            this._products = prods;
                            if (prods) {
                                this.minDate = moment().subtract(prods[0].minimumAge, 'year').toDate();
                                this.maxDate = moment().subtract((prods[0].maximumAge + 1), 'year').toDate();
                                var dtNow = new Date();
                                var dtEOC = new Date(dtNow.getFullYear(), 11, 31);
                                var millisecondsOffset = dtEOC.getTime() - dtNow.getTime();
                                var newMoment = moment(this.minDate);
                                newMoment.milliseconds((newMoment.milliseconds() + millisecondsOffset));
                                this.minDate = newMoment.toDate();
                            }
                        },
                        enumerable: false,
                        configurable: true
                    });
                    UpsellParticipantDirCtrl.prototype.addParticipant = function () {
                        if (this.myForm.$valid
                            || (this.myForm.$error.idpDateBetweenValidator
                                && this.myForm.frmDatePicker.$valid)) {
                            this.participant.showEditControls = false;
                        }
                    };
                    UpsellParticipantDirCtrl.prototype.removeParticipant = function () {
                        this.$scope.$emit("Upsell_RemoveParticipant", this.participant.userBrowsingID);
                    };
                    UpsellParticipantDirCtrl.controllerId = "UpsellParticipantDirCtrl";
                    return UpsellParticipantDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                UpsellParticipantDir.UpsellParticipantDirCtrl = UpsellParticipantDirCtrl;
            })(UpsellParticipantDir = PulsePublic.UpsellParticipantDir || (PulsePublic.UpsellParticipantDir = {}));
            Pulse.app.directive(UpsellParticipantDir.directiveId, ["common", function (c) { return new UpsellParticipantDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var UpsellParticipantListDir = (function (_super) {
                __extends(UpsellParticipantListDir, _super);
                function UpsellParticipantListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "reg-flow/upsell/idp-upsell-participant-list.html";
                    _this.scope = {
                        participants: "=",
                        products: "<",
                        isThemePack: "<",
                    };
                    _this.controller = [
                        "$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        UpsellParticipantListDir.UpsellParticipantListDirCtrl
                    ];
                    return _this;
                }
                UpsellParticipantListDir.directiveId = "idpUpsellParticipantList";
                return UpsellParticipantListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.UpsellParticipantListDir = UpsellParticipantListDir;
            (function (UpsellParticipantListDir) {
                var UpsellParticipantListDirCtrl = (function (_super) {
                    __extends(UpsellParticipantListDirCtrl, _super);
                    function UpsellParticipantListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, UpsellParticipantListDirCtrl.controllerId) || this;
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(UpsellParticipantListDirCtrl.prototype, "addParticipantImageUrl", {
                        get: function () {
                            return this.common.config.appRoot + 'assets/images/reg-flow/opl-plus.svg';
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(UpsellParticipantListDirCtrl.prototype, "showAddParticipantCard", {
                        get: function () {
                            if (this.participants) {
                                for (var i = 0, il = this.participants.length; i < il; ++i) {
                                    var participant = this.participants[i];
                                    if (participant.showEditControls) {
                                        return false;
                                    }
                                }
                            }
                            return true;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    UpsellParticipantListDirCtrl.prototype.addParticipant = function () {
                        this.$scope.$emit("Upsell_AddParticipant");
                    };
                    UpsellParticipantListDirCtrl.controllerId = "UpsellParticipantListDirCtrl";
                    return UpsellParticipantListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                UpsellParticipantListDir.UpsellParticipantListDirCtrl = UpsellParticipantListDirCtrl;
            })(UpsellParticipantListDir = PulsePublic.UpsellParticipantListDir || (PulsePublic.UpsellParticipantListDir = {}));
            Pulse.app.directive(UpsellParticipantListDir.directiveId, ["common", function (c) { return new UpsellParticipantListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var PavCatalogDateRangesCell = (function (_super) {
                __extends(PavCatalogDateRangesCell, _super);
                function PavCatalogDateRangesCell() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        dataset: '<',
                        catalogDateRanges: '<',
                        prodId: '<',
                        selectedDay: '<?',
                        drawerStyle: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/idp-pav-catalog-date-ranges.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'ProductAvailabilityStepService',
                        function ($scope, $element, pcs, pulsePass) { return new PavCatalogDateRangesCellCtrl($scope, $element, pcs, pulsePass); }
                    ];
                    return _this;
                }
                PavCatalogDateRangesCell.registeredAs = 'idpPavCatalogDateRanges';
                return PavCatalogDateRangesCell;
            }(ComponentOptions));
            RegistryFlow.PavCatalogDateRangesCell = PavCatalogDateRangesCell;
            var PavCatalogDateRangesCellCtrl = (function (_super) {
                __extends(PavCatalogDateRangesCellCtrl, _super);
                function PavCatalogDateRangesCellCtrl($scope, $element, pulseContext, pulsePass) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.catalogDateRangeUIs = [];
                    _this.isShowMore = false;
                    _this.itemsLimit = 7;
                    _this.drawerNextStep = {
                        stepID: 0,
                        step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep,
                        stepBackText: 'Back to course page',
                        stepSelectText: 'Select your date range for:'
                    };
                    _this.myDrawerStep = Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep;
                    _this.pulseContext = pulseContext;
                    _this.pulsePass = pulsePass;
                    _this.$scope.$on(Events.ProductAvailabilityStepChange, function (event, newStep) {
                        _this.onStepChanged(newStep);
                    });
                    return _this;
                }
                PavCatalogDateRangesCellCtrl.prototype.$onChanges = function (changesObj) {
                    var _this = this;
                    if (changesObj.catalogDateRanges && changesObj.catalogDateRanges.currentValue && changesObj.catalogDateRanges.currentValue.length > 0) {
                        changesObj.catalogDateRanges.currentValue.forEach(function (e) {
                            var cdrItem = {
                                catalogDateRangeID: e.catalogDateRangeID,
                                catalogDateRange: e,
                                isActive: false,
                                sessionGroups: _this.getSessionGroups(e.catalogDateRangeID, null)
                            };
                            if (cdrItem.sessionGroups.length > 0) {
                                _this.catalogDateRangeUIs.push(cdrItem);
                            }
                        });
                        this.catalogDateRangeUIs[0].isActive = this.catalogDateRangeUIs.length == 1;
                    }
                    if (changesObj.selectedDay && changesObj.selectedDay.currentValue) {
                        this.catalogDateRangeUIs.forEach(function (cdr) {
                            cdr.sessionGroups = _this.getSessionGroups(cdr.catalogDateRangeID, _this.selectedDay);
                        });
                    }
                };
                PavCatalogDateRangesCellCtrl.prototype.onStepChanged = function (newStep) {
                    if (newStep.stepCode == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.StepBack
                        && newStep.step.step == this.myDrawerStep
                        && newStep.step.step != Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.AccordionDrawer) {
                        if (this.catalogDateRangeUIs.length > 1) {
                            this.catalogDateRangeUIs.forEach(function (ui) {
                                ui.isActive = false;
                            });
                        }
                    }
                    if (newStep.stepCode == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.StepForward
                        && newStep.step.step == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectTimeStep) {
                        var cdrList = this.catalogDateRangeUIs.filter(function (ui) { return ui.catalogDateRangeID != newStep.stepData.seasonIndex; });
                        cdrList.forEach(function (cdr) {
                            cdr.isActive = false;
                        });
                    }
                };
                PavCatalogDateRangesCellCtrl.prototype.dateRangeContent = function (content) {
                    if (this.drawerStyle.drawerTemplate.toLowerCase() == 'pro' || this.drawerStyle.is2022Design) {
                        return content.replace(/<[^>]+>/g, '');
                    }
                    return content;
                };
                Object.defineProperty(PavCatalogDateRangesCellCtrl.prototype, "showDrawerStep", {
                    get: function () {
                        var _a, _b;
                        return this.drawerStyle.is2022Design && ((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavCatalogDateRangesCellCtrl.prototype.loadSessions = function (index) {
                    var cdr = this.catalogDateRangeUIs[index];
                    if (cdr) {
                        cdr.isActive = !cdr.isActive;
                    }
                };
                PavCatalogDateRangesCellCtrl.prototype.toggleHeaders = function () {
                    var cdrIds = this.catalogDateRangeUIs.map(function (cdr) { return '#cdr-heading-' + cdr.catalogDateRangeID; });
                    cdrIds.forEach(function (cdr) { return $(cdr).toggle(); });
                };
                Object.defineProperty(PavCatalogDateRangesCellCtrl.prototype, "showSeasonSelector", {
                    get: function () {
                        var _a, _b, _c, _d, _e, _f;
                        return this.catalogDateRangeUIs.length > 1
                            && (((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.AccordionDrawer
                                || ((_d = (_c = this.pulsePass) === null || _c === void 0 ? void 0 : _c.currentStep) === null || _d === void 0 ? void 0 : _d.step) == this.myDrawerStep
                                || ((_f = (_e = this.pulsePass) === null || _e === void 0 ? void 0 : _e.currentStep) === null || _f === void 0 ? void 0 : _f.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PavCatalogDateRangesCellCtrl.prototype, "getProduct", {
                    get: function () {
                        return this.dataset.products[0].name;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavCatalogDateRangesCellCtrl.prototype.isLastSession = function (sessionID) {
                    var cat = this.catalogDateRangeUIs[this.catalogDateRangeUIs.length - 1];
                    return cat.sessionGroups[cat.sessionGroups.length - 1].sessionID == sessionID
                        && this.showDrawerStep;
                };
                PavCatalogDateRangesCellCtrl.prototype.getSessionGroups = function (catalogDateRangeID, selectedDay) {
                    var _this = this;
                    var sessionGroups = [];
                    var sessionProductDetails = [];
                    var mainProd = _.find(this.dataset.products, function (p) { return p.relatedProductTypeID == null; });
                    var isCourseBundle = this.dataset.products && mainProd.catalogTypeID == Enums.SalesCatalogType.CourseBundle;
                    if (isCourseBundle) {
                        var level1Prod_1 = _.find(this.dataset.products, function (p) { return p.level === 1; });
                        sessionProductDetails = this.dataset.sessionProductDetails.filter(function (spd) { return spd.productID == level1Prod_1.productID; });
                        sessionProductDetails.forEach(function (spd) {
                            var lastSessionSPD = _this.pulseContext.regFlowMgr.prodAvailabilityMgr.getLastSPDForBundledProducts(spd.sessionProductDetailID, _this.dataset.sessionProductDetails);
                            if (lastSessionSPD) {
                                spd.endDateTimeLocal = lastSessionSPD.endDateTimeLocal;
                                spd.endDate = lastSessionSPD.endDate;
                                var relatedSPDForStatus = _this.pulseContext.regFlowMgr.prodAvailabilityMgr.getRelatedBundleProductForStatus(spd.sessionProductDetailID, _this.dataset.sessionProductDetails);
                                if (relatedSPDForStatus) {
                                    spd.programStatus = relatedSPDForStatus.programStatus;
                                    spd.programStatusTypeID = relatedSPDForStatus.programStatusTypeID;
                                }
                            }
                        });
                    }
                    else {
                        sessionProductDetails = this.dataset.sessionProductDetails;
                    }
                    var _loop_1 = function (d) {
                        if (d.catalogDateRangeID != catalogDateRangeID)
                            return "continue";
                        if (selectedDay && moment(d.startDateTimeLocal).day() !== selectedDay.id)
                            return "continue";
                        sessionGroup = _.find(sessionGroups, function (s) {
                            return moment(s.startDate).isSame(moment(d.startDateTimeLocal), 'd') && moment(s.endDate).isSame(moment(d.endDateTimeLocal), 'd');
                        });
                        if (sessionGroup) {
                            sessionGroup.sessionProductDetails.push(d);
                        }
                        else {
                            sessionGroups.push({
                                sessionID: d.sessionID,
                                startDate: d.startDateTimeLocal,
                                endDate: d.endDateTimeLocal,
                                sessionProductDetails: [d],
                            });
                        }
                    };
                    var sessionGroup;
                    for (var _i = 0, sessionProductDetails_1 = sessionProductDetails; _i < sessionProductDetails_1.length; _i++) {
                        var d = sessionProductDetails_1[_i];
                        _loop_1(d);
                    }
                    return sessionGroups;
                };
                return PavCatalogDateRangesCellCtrl;
            }(ComponentController));
            RegistryFlow.PavCatalogDateRangesCellCtrl = PavCatalogDateRangesCellCtrl;
            Pulse.app.component(PavCatalogDateRangesCell.registeredAs, new PavCatalogDateRangesCell());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var SessionAvailabilityStatus = Pulse.Common.Enums.SessionAvailabilityStatus;
            var PavSessionCell = (function (_super) {
                __extends(PavSessionCell, _super);
                function PavSessionCell() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        sessionGroup: '<',
                        dataset: '<',
                        prodId: '<',
                        drawerStyle: '<?',
                        seasonIndex: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/idp-pav-session-cell.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'common',
                        'pulseContextService',
                        'DrawerToggleService',
                        'ProductAvailabilityStepService',
                        function ($scope, $element, common, pcs, drawerToggleService, pulsePass) {
                            return new PavSessionCellCtrl($scope, $element, common, pcs, drawerToggleService, pulsePass);
                        }
                    ];
                    return _this;
                }
                PavSessionCell.registeredAs = 'idpPavSessionCell';
                return PavSessionCell;
            }(ComponentOptions));
            RegistryFlow.PavSessionCell = PavSessionCell;
            var PavSessionCellCtrl = (function (_super) {
                __extends(PavSessionCellCtrl, _super);
                function PavSessionCellCtrl($scope, $element, common, pulseContext, drawerToggleService, pulsePass) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.showExtra = false;
                    _this.myDrawerStep = Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep;
                    _this.drawerNextStep = {
                        stepID: 0,
                        step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectTimeStep,
                        stepBackText: 'Back to date range availability',
                        stepSelectText: 'Select your time for:'
                    };
                    _this.pulseContext = pulseContext;
                    _this.drawerToggleService = drawerToggleService;
                    _this.pulsePass = pulsePass;
                    _this.common = common;
                    _this.$scope.$on(Events.ProductAvailabilityStepChange, function (event, newStep) {
                        _this.onStepChanged(newStep);
                    });
                    return _this;
                }
                PavSessionCellCtrl.prototype.onStepChanged = function (newStep) {
                    if (newStep.stepCode == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.StepBack
                        && newStep.step.step == this.myDrawerStep) {
                        this.showExtra = false;
                        angular.element('.cdr-session-button').attr('style', '');
                    }
                };
                PavSessionCellCtrl.prototype.getSessionStatus = function (sessionItems) {
                    var spds = sessionItems;
                    var openCount = spds.filter(function (i) { return i.programStatusTypeID === SessionAvailabilityStatus.Open; }).length;
                    var soldOutCount = spds.filter(function (i) { return i.programStatusTypeID === SessionAvailabilityStatus.SoldOut || i.programStatusTypeID === SessionAvailabilityStatus.SoldOutDesktop || i.programStatusTypeID === SessionAvailabilityStatus.SelectAnotherWeek; }).length;
                    if (openCount == spds.length) {
                        this.sessionStatus = AvailabilityStatus.Open;
                    }
                    else if (soldOutCount == spds.length) {
                        this.sessionStatus = AvailabilityStatus.SoldOut;
                    }
                    else {
                        this.sessionStatus = AvailabilityStatus.NearlyFull;
                    }
                };
                Object.defineProperty(PavSessionCellCtrl.prototype, "sessionStatusText", {
                    get: function () {
                        if (this.drawerStyle.is2022Design) {
                            if (this.sessionStatus == AvailabilityStatus.SoldOut) {
                                return "Add to waitlist";
                            }
                            else {
                                return "Select date";
                            }
                        }
                        return this.sessionStatus;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PavSessionCellCtrl.prototype, "showSessionButton", {
                    get: function () {
                        return this.sessionStatus != AvailabilityStatus.SoldOut;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavSessionCellCtrl.prototype.getSessionStatusClass = function () {
                    if (this.sessionStatus == AvailabilityStatus.SoldOut) {
                        if (this.drawerStyle.is2022Design) {
                            this.sessionStatusClass = 'badge-waitlist';
                        }
                        else {
                            this.sessionStatusClass = 'badge-danger';
                        }
                    }
                    else if (this.sessionStatus == AvailabilityStatus.NearlyFull && !this.drawerStyle.is2022Design) {
                        this.sessionStatusClass = 'badge-warning';
                    }
                    else {
                        this.sessionStatusClass = 'badge-primary';
                    }
                };
                Object.defineProperty(PavSessionCellCtrl.prototype, "sessionStatusIconClass", {
                    get: function () {
                        if (this.sessionStatus == AvailabilityStatus.SoldOut) {
                            return 'fa-exclamation-circle';
                        }
                        else if (this.sessionStatus == AvailabilityStatus.NearlyFull) {
                            return 'fa-exclamation-triangle session-warning';
                        }
                        else {
                            return 'fa-circle';
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PavSessionCellCtrl.prototype, "showAccordion", {
                    get: function () {
                        var _a, _b;
                        return ((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.AccordionDrawer;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PavSessionCellCtrl.prototype, "showAccordionButtons", {
                    get: function () {
                        var _a, _b, _c, _d;
                        return ((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.AccordionDrawer
                            || ((_d = (_c = this.pulsePass) === null || _c === void 0 ? void 0 : _c.currentStep) === null || _d === void 0 ? void 0 : _d.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PavSessionCellCtrl.prototype, "showAccordionBar", {
                    get: function () {
                        var _a, _b;
                        return this.drawerStyle.is2022Design && ((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectTimeStep;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavSessionCellCtrl.prototype.$onChanges = function (changesObj) {
                    if (changesObj.sessionGroup && changesObj.sessionGroup.isFirstChange()) {
                        this.sessionGroup.sessionProductDetails = _.sortBy(this.sessionGroup.sessionProductDetails, 'startDateTimeLocal');
                    }
                    if (changesObj.dataset && changesObj.dataset.currentValue) {
                        this.mainProd = _.find(this.dataset.products, function (p) { return p.relatedProductTypeID == null; });
                        this.isSquads = this.mainProd.catalogTypeID == Enums.SalesCatalogType.SquadsConsecutiveDays || this.mainProd.catalogTypeID == Enums.SalesCatalogType.SquadsMultiWeek;
                    }
                    this.getSessionStatus(this.sessionGroup.sessionProductDetails);
                    this.getSessionStatusClass();
                };
                PavSessionCellCtrl.prototype.loadTerms = function (index) {
                    var _a, _b;
                    if (this.sessionStatus != AvailabilityStatus.SoldOut) {
                        this.showExtra = !this.showExtra;
                        if (((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) != Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.AccordionDrawer) {
                            angular.element('.cdr-session-button').attr('style', 'display: none !important');
                            this.pulsePass.stepNext(this.drawerNextStep, { seasonIndex: this.seasonIndex });
                            this.common.scrollToHash('idpDrawerTopBtn', 0, 0, 1);
                        }
                    }
                };
                Object.defineProperty(PavSessionCellCtrl.prototype, "drawerProducts", {
                    get: function () {
                        return this.drawerToggleService.drawerProducts;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavSessionCellCtrl.prototype.isDrawerOpen = function (sessionTime) {
                    var products = this.drawerToggleService.drawerProducts;
                    if (!products || !this.sessionGroup)
                        return;
                    var spdiDs = this.sessionGroup.sessionProductDetails.map(function (i) { return i.sessionProductDetailID; });
                    var drawerSpdID = products.mainProduct.sessionProductDetailID;
                    var result = _.includes(spdiDs, drawerSpdID);
                    return result;
                };
                PavSessionCellCtrl.prototype.isFirstSession = function (sessionProductDetailID) {
                    return this.sessionGroup.sessionProductDetails[0].sessionProductDetailID == sessionProductDetailID;
                };
                PavSessionCellCtrl.prototype.getDivisionAbbr = function () {
                    var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, this.dataset.termDivisions[0].divisionID);
                    return div ? div.abbr : "";
                };
                PavSessionCellCtrl.prototype.getEndDate = function () {
                    return this.sessionGroup.endDate;
                };
                return PavSessionCellCtrl;
            }(ComponentController));
            RegistryFlow.PavSessionCellCtrl = PavSessionCellCtrl;
            Pulse.app.component(PavSessionCell.registeredAs, new PavSessionCell());
            var AvailabilityStatus;
            (function (AvailabilityStatus) {
                AvailabilityStatus["Open"] = "Open";
                AvailabilityStatus["NearlyFull"] = "Nearly Full";
                AvailabilityStatus["SoldOut"] = "Sold Out";
                AvailabilityStatus["NoSpace"] = "No Space";
            })(AvailabilityStatus = RegistryFlow.AvailabilityStatus || (RegistryFlow.AvailabilityStatus = {}));
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var SessionAvailabilityStatus = Pulse.Common.Enums.SessionAvailabilityStatus;
            var PavSessionTimeCell = (function (_super) {
                __extends(PavSessionTimeCell, _super);
                function PavSessionTimeCell() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        sessionProductDetail: '<',
                        termDivisions: '<',
                        product: '<',
                        sessionProductDetails: '<',
                        datasetProducts: '<',
                        drawerStyle: '<'
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/idp-pav-session-time-cell.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'common',
                        'DrawerToggleService',
                        'ProductStatusTypeDecorator',
                        'ProductAvailabilityStepService',
                        function ($scope, $element, pulseContext, common, drawerToggleService, productStatusTypeDecorator, pulsePass) {
                            return new PavSessionTimeCellCtrl($scope, $element, pulseContext, common, drawerToggleService, productStatusTypeDecorator, pulsePass);
                        },
                    ];
                    return _this;
                }
                PavSessionTimeCell.registeredAs = 'idpPavSessionTimeCell';
                return PavSessionTimeCell;
            }(ComponentOptions));
            RegistryFlow.PavSessionTimeCell = PavSessionTimeCell;
            var PavSessionTimeCellCtrl = (function (_super) {
                __extends(PavSessionTimeCellCtrl, _super);
                function PavSessionTimeCellCtrl($scope, $element, pulseContext, common, drawerToggleService, productStatusTypeDecorator, pulsePass) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.isExpanded = false;
                    _this.drawerNextStep = {
                        stepID: 0,
                        step: Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.BuyingCourse,
                        stepBackText: 'Back to time availability',
                        stepSelectText: ''
                    };
                    _this.pulseContext = pulseContext;
                    _this.common = common;
                    _this.drawerToggleService = drawerToggleService;
                    _this.productStatusTypeDecorator = productStatusTypeDecorator;
                    _this.pulsePass = pulsePass;
                    _this.$scope.$on(Events.ProductAvailabilityStepChange, function (event, newStep) {
                        _this.onStepChanged(newStep);
                    });
                    return _this;
                }
                PavSessionTimeCellCtrl.prototype.onStepChanged = function (newStep) {
                    if (newStep.stepCode == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.StepBack
                        && newStep.previousStep.step == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.BuyingCourse) {
                        this.drawerToggleService.close();
                    }
                };
                PavSessionTimeCellCtrl.prototype.$onChanges = function (changesObj) {
                    if (changesObj.sessionProductDetail && changesObj.sessionProductDetail.isFirstChange()) {
                        this.session = {
                            endDate: this.sessionProductDetail.endDateTimeLocal,
                            hasCourse: this.sessionProductDetail.hasCourse,
                            isONPackage: this.sessionProductDetail.isONpackage,
                            highlightPriceReductions: this.sessionProductDetail.highlightPriceReductions,
                            locationSessionID: this.sessionProductDetail.locationSessionID,
                            maxAge: this.sessionProductDetail.maximumAge,
                            maxAgeOverN: this.sessionProductDetail.maxAgeOverN,
                            minAge: this.sessionProductDetail.minimumAge,
                            minAgeOverN: this.sessionProductDetail.minAgeOverN,
                            optionRestriction: this.sessionProductDetail.optionRestriction,
                            optionStatus: this.sessionProductDetail.optionStatus,
                            price: this.sessionProductDetail.price,
                            priceWithON: this.sessionProductDetail.priceWithON,
                            programStatusTypeID: this.sessionProductDetail.programStatusTypeID,
                            programStatus: this.sessionProductDetail.programStatus,
                            scheduleDefID: this.sessionProductDetail.scheduleDefID,
                            sessID: this.sessionProductDetail.sessionID,
                            spdID: this.sessionProductDetail.sessionProductDetailID,
                            spdIDON: this.sessionProductDetail.spdIDON,
                            selectedText: '',
                            startDate: this.sessionProductDetail.startDateTimeLocal,
                            products: { mainProduct: null, optionProduct: null },
                            AMPMOption: false,
                            PMSession: null,
                            hasPM: false,
                            inCart: false,
                            inCartCount: this.sessionProductDetail.inCartCount,
                            inWaitlist: this.sessionProductDetail.inWaitlist,
                            isPM: false,
                            isONpackage: this.sessionProductDetail.isONpackage,
                            numOfThisSessProdInCart: 0,
                            progStatusFiltered: '',
                            statusOptions: this.productStatusTypeDecorator.decorate(this.sessionProductDetail.programStatusTypeID),
                            alertNote: this.sessionProductDetail.alertNote
                        };
                    }
                    if (changesObj.product && changesObj.product.currentValue) {
                        this.isSquads = this.product.catalogTypeID == Enums.SalesCatalogType.SquadsConsecutiveDays || this.product.catalogTypeID == Enums.SalesCatalogType.SquadsMultiWeek;
                        this.isCourseBundle = this.product.catalogTypeID == Enums.SalesCatalogType.CourseBundle;
                    }
                };
                PavSessionTimeCellCtrl.prototype.showTimeButtons = function () {
                    var _a, _b, _c, _d;
                    return ((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.AccordionDrawer
                        || ((_d = (_c = this.pulsePass) === null || _c === void 0 ? void 0 : _c.currentStep) === null || _d === void 0 ? void 0 : _d.step) == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectTimeStep;
                };
                PavSessionTimeCellCtrl.prototype.toggleSessionAction = function ($event) {
                    var _this = this;
                    var _a, _b;
                    this.isExpanded = !this.isExpanded;
                    var termDivision = this.termDivisions.filter(function (td) { return td.termID == _this.sessionProductDetail.termID; })[0];
                    this.division = {
                        PMDivision: null,
                        ageRangeID: termDivision.ageRangeID,
                        catalogDateRange: null,
                        courses: null,
                        divID: termDivision.divisionID,
                        daysPerSession: termDivision.daysPerSession,
                        divProgramTypeID: termDivision.programTypeID,
                        expDesc: termDivision.experienceDescription,
                        expName: '',
                        experienceDescription: termDivision.experienceDescription,
                        hasPM: false,
                        hasWeekend: termDivision.hasWeekend,
                        isDayOnly: termDivision.isDayOnly,
                        isOvernightOnly: termDivision.isOvernightOnly,
                        locHasCampAtHQ: termDivision.locHasCampAtHQ,
                        locID: termDivision.locationID,
                        minAge: termDivision.minAge,
                        maxAge: termDivision.maxAge,
                        minCoursePrice: termDivision.minCoursePrice,
                        currencyTypeID: this.product.currencyTypeID,
                        name: termDivision.termName,
                        sessions: [],
                        sortOrder: termDivision.termSortOrder,
                        studentGenderType: termDivision.studentGenderType,
                        termID: termDivision.termID,
                        termName: termDivision.termName,
                        termDescription: termDivision.termDescription,
                        termSortOrder: termDivision.termSortOrder,
                        divMaxAgeCalcTypeID: termDivision.maxAgeCalcTypeID,
                        divMinAgeCalcTypeID: termDivision.minAgeCalcTypeID,
                        schedTypeID: termDivision.scheduleTypeID,
                        skillLevels: []
                    };
                    this.course = {
                        activityDesc: this.product.productActivityDesc,
                        catalogTypeID: this.product.catalogTypeID,
                        description: this.product.description,
                        genreIDs: [],
                        genres: [],
                        hasBuyableSessions: this.product.hasBuyableSessions,
                        isNewExpireDate: this.product.isNewExpireDate,
                        locationPrice: this.product.locationPrice,
                        currencyTypeID: this.product.currencyTypeID,
                        maxAge: this.product.maximumAge,
                        minAge: this.product.minimumAge,
                        name: this.product.name,
                        prerequisities: [],
                        prodID: this.product.productID,
                        schedule: this.product.scheduleDescriptor,
                        sessions: [],
                        skillLevels: [],
                        startingAt: this.product.startingAt,
                        subCatID: this.product.productSubCatTypeID,
                        subCatName: '',
                        takeHomeDesc: this.product.takeHomeDesc,
                        toolsUsed: this.product.toolsUsed,
                        uRLs: [],
                        headline: this.product.headline
                    };
                    if (this.hasUserInteraction && this.product) {
                        this.drawerToggleService.toggleDrawer(this.division, this.course, this.session)
                            .then(function () {
                            return _this.common.$timeout(function () {
                                Events.TriggerDocCustomEvent(Events.ProductAvailabilityItemClicked_JSEvent, $event.target);
                            });
                        });
                        if (((_b = (_a = this.pulsePass) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.step) != Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.AccordionDrawer) {
                            this.pulsePass.stepNext(this.drawerNextStep, {});
                            this.common.scrollToHash('idpDrawerTopBtn', 0, 0, 1);
                        }
                    }
                };
                Object.defineProperty(PavSessionTimeCellCtrl.prototype, "drawerProducts", {
                    get: function () {
                        return this.drawerToggleService.drawerProducts;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PavSessionTimeCellCtrl.prototype, "hasUserInteraction", {
                    get: function () {
                        if (this.session.programStatusTypeID == SessionAvailabilityStatus.SoldOut || this.session.programStatusTypeID == SessionAvailabilityStatus.SoldOutDesktop)
                            return false;
                        return this.session && this.session.statusOptions && this.session.statusOptions.hasUserInteraction;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavSessionTimeCellCtrl.prototype.handleDrawerClose = function () {
                    this.drawerToggleService.toggleDrawer(this.division, this.course, this.session);
                };
                PavSessionTimeCellCtrl.prototype.getStatusTypeID = function () {
                    var _a;
                    return (_a = this.sessionProductDetail) === null || _a === void 0 ? void 0 : _a.programStatusTypeID;
                };
                PavSessionTimeCellCtrl.prototype.getStatusString = function () {
                    var statusOptions = this.productStatusTypeDecorator.decorate(this.getStatusTypeID());
                    if (!statusOptions)
                        return;
                    var statusString = statusOptions.displayName;
                    if (this.drawerStyle.is2022Design) {
                        statusString = statusString == 'Open' ? 'Available' : statusString;
                    }
                    return statusString;
                };
                Object.defineProperty(PavSessionTimeCellCtrl.prototype, "showTimeButton", {
                    get: function () {
                        var statusOptions = this.productStatusTypeDecorator.decorate(this.getStatusTypeID());
                        return statusOptions.displayName != RegistryFlow.AvailabilityStatus.SoldOut;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavSessionTimeCellCtrl.prototype.getStatusStringClass = function () {
                    var statusOptions = this.productStatusTypeDecorator.decorate(this.getStatusTypeID());
                    if (!statusOptions)
                        return;
                    var statusClass = '';
                    switch (statusOptions.id) {
                        case SessionAvailabilityStatus.SoldOut:
                        case SessionAvailabilityStatus.SoldOutDesktop:
                        case SessionAvailabilityStatus.NoSpace:
                            statusClass = 'session-danger';
                            break;
                        case SessionAvailabilityStatus.Space1:
                        case SessionAvailabilityStatus.Space2:
                        case SessionAvailabilityStatus.Space3:
                        case SessionAvailabilityStatus.Space4:
                            statusClass = 'session-warning';
                            break;
                        default:
                            statusClass = 'session-open';
                            break;
                    }
                    return statusClass;
                };
                PavSessionTimeCellCtrl.prototype.getStatusButtonClass = function () {
                    var statusOptions = this.productStatusTypeDecorator.decorate(this.getStatusTypeID());
                    if (!statusOptions)
                        return;
                    var badgeColor = 'text-white';
                    var badgeClass = "" + statusOptions.htmlClass;
                    if (statusOptions.id == SessionAvailabilityStatus.SoldOut || statusOptions.id == SessionAvailabilityStatus.SoldOutDesktop) {
                        badgeClass = 'danger';
                    }
                    else if (this.drawerStyle.is2022Design && statusOptions.id == SessionAvailabilityStatus.NoSpace) {
                        badgeClass = 'waitlist';
                        badgeColor = 'text-muted';
                    }
                    else if (this.drawerStyle.is2022Design) {
                        badgeClass = 'primary';
                    }
                    return "badge-" + badgeClass + " " + badgeColor;
                };
                PavSessionTimeCellCtrl.prototype.getDivisionAbbr = function () {
                    var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, this.sessionProductDetail.divisionID);
                    return div ? div.abbr : "";
                };
                PavSessionTimeCellCtrl.prototype.checkDrawerForSession = function () {
                    return this.drawerToggleService.isSelected(this.division, this.course, this.session);
                };
                Object.defineProperty(PavSessionTimeCellCtrl.prototype, "crossSellProds", {
                    get: function () {
                        return this.drawerToggleService.setProductCurrencyType(this.product.currencyTypeID).crossSellProds;
                    },
                    enumerable: false,
                    configurable: true
                });
                return PavSessionTimeCellCtrl;
            }(ComponentController));
            RegistryFlow.PavSessionTimeCellCtrl = PavSessionTimeCellCtrl;
            Pulse.app.component(PavSessionTimeCell.registeredAs, new PavSessionTimeCell());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var PavSessionTimeDrawer = (function (_super) {
                __extends(PavSessionTimeDrawer, _super);
                function PavSessionTimeDrawer() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        division: '<?',
                        product: '<',
                        products: '<?',
                        addonProducts: '<?',
                        isSubscription: '<?',
                        selectedSessionProductDetail: "<?",
                        sessionProductDetails: '<?',
                        datasetProducts: '<',
                        crossSellProds: '<',
                        resetStep: '<?',
                        drawerStyle: '<?'
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/idp-pav-session-time-drawer.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        '$timeout',
                        'pulseContextService',
                        'DrawerToggleService',
                        function ($scope, $element, $timeout, pulseContext, drawerToggleService) {
                            return new PavSessionTimeDrawerCtrl($scope, $element, $timeout, pulseContext, drawerToggleService);
                        },
                    ];
                    return _this;
                }
                PavSessionTimeDrawer.registeredAs = 'idpPavSessionTimeDrawer';
                return PavSessionTimeDrawer;
            }(ComponentOptions));
            RegistryFlow.PavSessionTimeDrawer = PavSessionTimeDrawer;
            var PavSessionTimeDrawerCtrl = (function (_super) {
                __extends(PavSessionTimeDrawerCtrl, _super);
                function PavSessionTimeDrawerCtrl($scope, $element, $timeout, pulseContext, drawerToggleService) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.isSubscription = false;
                    _this.resetStep = true;
                    _this.isSquads = false;
                    _this.$timeout = $timeout;
                    _this.pulseContext = pulseContext;
                    _this.availChartMgr = pulseContext.regFlowMgr.availChartMgr;
                    _this.userMgr = pulseContext.userMgr;
                    _this.ubMgr = pulseContext.regFlowMgr.userBrowsingMgr;
                    _this.drawerToggleService = drawerToggleService;
                    _this.registrationDisabled = false;
                    _this.knownEmailCheckCount = 0;
                    $scope.$on(Events.DrawerUpdateEmail, function (event, email) {
                        _this.checkEmailExistence(event, email);
                    });
                    $scope.$on(Events.LoginSuccess, function () {
                        _this.unknownUser = false;
                    });
                    return _this;
                }
                PavSessionTimeDrawerCtrl.prototype.$onChanges = function (changesObj) {
                    var _a, _b, _c, _d, _e, _f;
                    if (changesObj.products && changesObj.products.currentValue) {
                        var products = changesObj.products.currentValue;
                        this.selectProduct(products.mainProduct);
                    }
                    if (changesObj.product && changesObj.product.currentValue) {
                        this.isSquads = changesObj.product.currentValue.catalogTypeID == Enums.SalesCatalogType.SquadsConsecutiveDays || changesObj.product.currentValue.catalogTypeID == Enums.SalesCatalogType.SquadsMultiWeek;
                        this.isCourseBundle = changesObj.product.currentValue.catalogTypeID == Enums.SalesCatalogType.CourseBundle;
                    }
                    if (((_a = changesObj.selectedSessionProductDetail) === null || _a === void 0 ? void 0 : _a.currentValue) && ((_b = changesObj.sessionProductDetails) === null || _b === void 0 ? void 0 : _b.currentValue) && ((_c = changesObj.datasetProducts) === null || _c === void 0 ? void 0 : _c.currentValue)) {
                        if (this.isCourseBundle) {
                            this.products.mainProduct.sessionStart = (_d = changesObj.selectedSessionProductDetail) === null || _d === void 0 ? void 0 : _d.currentValue.startDateTimeLocal;
                            this.bundleProducts = this.pulseContext.regFlowMgr.prodAvailabilityMgr.getRelatedBundleCampProducts(changesObj.selectedSessionProductDetail.currentValue, changesObj.sessionProductDetails.currentValue, (_e = changesObj.datasetProducts) === null || _e === void 0 ? void 0 : _e.currentValue, (_f = this.division) === null || _f === void 0 ? void 0 : _f.locID);
                            var lastSPD = this.pulseContext.regFlowMgr.prodAvailabilityMgr.getLastSPDForBundledProducts(this.selectedSessionProductDetail.sessionProductDetailID, changesObj.sessionProductDetails.currentValue);
                            if (lastSPD) {
                                this.products.mainProduct.sessionEnd = lastSPD.endDateTimeLocal;
                            }
                        }
                    }
                };
                PavSessionTimeDrawerCtrl.prototype.closeDrawer = function () {
                    this.drawerToggleService.close();
                };
                PavSessionTimeDrawerCtrl.prototype.closeLoginAlert = function () {
                    this.showLoginAlert = false;
                };
                Object.defineProperty(PavSessionTimeDrawerCtrl.prototype, "selectedProduct", {
                    get: function () {
                        return this._selectedProduct;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavSessionTimeDrawerCtrl.prototype.selectProduct = function (product) {
                    this._selectedProduct = product;
                };
                PavSessionTimeDrawerCtrl.prototype.showLogin = function () {
                    this.pulseContext.regFlowMgr.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress = this.checkedEmail;
                    this.$scope.$broadcast(Events.ShowLoginPopup, {
                        initDataObj: {
                            disableCreateAccount: true,
                            emailAddress: this.checkedEmail,
                            hideRequiredAsterix: true,
                            lockEmailAddress: true,
                            showCancel: true,
                            showLabels: true,
                            showRemember: true,
                        },
                        size: '',
                    });
                };
                Object.defineProperty(PavSessionTimeDrawerCtrl.prototype, "showDescription", {
                    get: function () {
                        return !this.drawerStyle.is2022Design && this.products.mainProduct;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PavSessionTimeDrawerCtrl.prototype, "sessionPaymentOption", {
                    get: function () {
                        if ((this._sessionPaymentOption === undefined
                            && this.selectedSessionProductDetail !== undefined)
                            || (this._sessionPaymentOption !== undefined && this._sessionPaymentOption.sessID != this.selectedSessionProductDetail.sessionID)) {
                            this._sessionPaymentOption = {
                                sessID: this.selectedSessionProductDetail.sessionID,
                                currencyTypeID: this.selectedSessionProductDetail.depositCurrencyTypeID,
                                depositTypeID: this.selectedSessionProductDetail.depositTypeID,
                                depositValue: this.selectedSessionProductDetail.depositValue,
                                balanceDueDate: this.selectedSessionProductDetail.balanceDueDate,
                                divDeliveryModelTypeID: this.selectedSessionProductDetail.divDeliveryModelTypeID,
                                paymentOptionEndDate: this.selectedSessionProductDetail.divSignupEndDate
                            };
                        }
                        return this._sessionPaymentOption;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavSessionTimeDrawerCtrl.prototype.checkEmailExistence = function (event, email) {
                    var _this = this;
                    if (email && !this.pulseContext.isLoggedIn && this.knownEmailCheckCount < 3) {
                        this.$timeout.cancel(this.checkEmailPromise);
                        this.registrationDisabled = true;
                        this.checkEmailPromise = this.$timeout(function () {
                            _this.checkEmailIsKnown(email)
                                .finally(function () {
                                _this.registrationDisabled = false;
                            });
                        }, 500);
                    }
                    else if (this.knownEmailCheckCount >= 3) {
                        this.closeLoginAlert();
                    }
                };
                PavSessionTimeDrawerCtrl.prototype.checkEmailIsKnown = function (email) {
                    var _this = this;
                    return this.userMgr.isValidUsernameOr3rdPartyAuthEmail(email)
                        .then(function (result) {
                        result = typeof result === 'object' && Array.isArray(result)
                            ? !!result.shift()
                            : false;
                        _this.showLoginAlert = result;
                        _this.checkedEmail = result ? email : '';
                        _this.unknownUser = true;
                        if (result) {
                            _this.knownEmailCheckCount++;
                        }
                    })
                        .catch(function (err) {
                        console.error(err);
                    });
                };
                return PavSessionTimeDrawerCtrl;
            }(ComponentController));
            Pulse.app.component(PavSessionTimeDrawer.registeredAs, new PavSessionTimeDrawer());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var PavOrderConfirmation = (function (_super) {
                __extends(PavOrderConfirmation, _super);
                function PavOrderConfirmation() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        product: '<?',
                        isSquads: '<?',
                        isCourseBundle: '<?',
                        isTutoring: '<?'
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/idp-pav-order-confirmation.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'common',
                        function ($scope, $element, pulseContext, common) {
                            return new PavOrderConfirmationCtrl($scope, $element, pulseContext, common);
                        }
                    ];
                    return _this;
                }
                PavOrderConfirmation.registeredAs = 'idpPavOrderConfirmation';
                return PavOrderConfirmation;
            }(ComponentOptions));
            RegistryFlow.PavOrderConfirmation = PavOrderConfirmation;
            var PavOrderConfirmationCtrl = (function (_super) {
                __extends(PavOrderConfirmationCtrl, _super);
                function PavOrderConfirmationCtrl($scope, $element, pulseContext, common) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.isSquads = false;
                    _this.isCourseBundle = false;
                    _this.isTutoring = false;
                    _this.internationalDiscountCodes = [{ amount: 50, currencyTypeID: Enums.CurrencyType.USD }];
                    _this.pulseContext = pulseContext;
                    _this.common = common;
                    return _this;
                }
                PavOrderConfirmationCtrl.prototype.addAnotherCourse = function () {
                    var _a;
                    if (this.pulseContext.isImpersonating) {
                        if (((_a = this.product) === null || _a === void 0 ? void 0 : _a.catalogTypeID) == Enums.SalesCatalogType.CourseBundle) {
                            this.common.$location.url(Routes.MyAccount_SEMPurchase);
                        }
                        else {
                            this.common.$location.url(Routes.MyAccount_OPLPurchase);
                        }
                    }
                    else {
                        window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                    }
                };
                PavOrderConfirmationCtrl.prototype.redirectToCheckout = function () {
                    if (this.pulseContext.inWWW) {
                        var url = this.common.config.WWW_UrlRoot + '/shopping-cart';
                        window.location.assign(url);
                    }
                    else {
                        this.common.$location.url(Routes.RegFlow_ShoppingCart);
                    }
                };
                Object.defineProperty(PavOrderConfirmationCtrl.prototype, "Discount", {
                    get: function () {
                        var _this = this;
                        var discount = this.internationalDiscountCodes.filter(function (w) { return w.currencyTypeID == _this.product.currencyTypeID; });
                        if (discount.length > 0) {
                            return discount[0];
                        }
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavOrderConfirmationCtrl.prototype.getDivisionAbbr = function () {
                    var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, this.product.divisionID);
                    return div ? div.abbr : "";
                };
                return PavOrderConfirmationCtrl;
            }(ComponentController));
            RegistryFlow.PavOrderConfirmationCtrl = PavOrderConfirmationCtrl;
            Pulse.app.component(PavOrderConfirmation.registeredAs, new PavOrderConfirmation());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var ProductIpcDrawerCtrl = Pulse.Controllers.ProductIpcDrawerCtrl;
            var PavDrawerStep = (function (_super) {
                __extends(PavDrawerStep, _super);
                function PavDrawerStep() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        currentStep: '<',
                        drawerStyle: '<',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/idp-pav-drawer-step.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$location',
                        '$element',
                        'common',
                        'ProductAvailabilityStepService',
                        function ($scope, $location, $element, common, pulsePass) {
                            return new PavDrawerStepCtrl($scope, $location, $element, common, pulsePass);
                        },
                    ];
                    return _this;
                }
                PavDrawerStep.registeredAs = 'idpPavDrawerStep';
                return PavDrawerStep;
            }(ComponentOptions));
            RegistryFlow.PavDrawerStep = PavDrawerStep;
            var PavDrawerStepCtrl = (function (_super) {
                __extends(PavDrawerStepCtrl, _super);
                function PavDrawerStepCtrl($scope, $location, $element, common, pulsePass) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.common = common;
                    _this.pulsePass = pulsePass;
                    _this.$location = $location;
                    return _this;
                }
                PavDrawerStepCtrl.prototype.previousStepClick = function () {
                    if (this.pulsePass.viewPreviousStep.step === Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectAcadamyStep) {
                        this.$location.search(QueryStringUtils.LOCATION_ID, null);
                        this.$location.search(ProductIpcDrawerCtrl.SELECT_LOCATION_KEY, null);
                    }
                    else {
                        this.pulsePass.stepPrev();
                    }
                };
                PavDrawerStepCtrl.prototype.backToSelectLocationClicked = function (e) {
                    Events.TriggerDocCustomEvent(Pulse.Common.Resources.Events.BackToSelectLocation_JSEvent, { backToSelectLocation: true });
                    return false;
                };
                Object.defineProperty(PavDrawerStepCtrl.prototype, "backToCourse", {
                    get: function () {
                        return this.pulsePass.stepCount == 1
                            || (this.pulsePass.currentStep !== undefined
                                && this.pulsePass.currentStep !== null
                                && this.pulsePass.currentStep.step == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectAcadamyStep);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PavDrawerStepCtrl.prototype, "backToPrevious", {
                    get: function () {
                        return this.pulsePass.stepCount > 1 && !this.backToSelectLocation
                            && this.pulsePass.currentStep !== undefined
                            && this.pulsePass.currentStep !== null
                            && this.pulsePass.currentStep.step != Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectAcadamyStep;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PavDrawerStepCtrl.prototype, "backToSelectLocation", {
                    get: function () {
                        return (this.pulsePass.viewPreviousStep !== undefined && this.pulsePass.viewPreviousStep !== null)
                            && this.pulsePass.viewPreviousStep.step == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectLocationStep
                            && this.pulsePass.currentStep.step != Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectAcadamyStep;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavDrawerStepCtrl.prototype.getParamAsBoolean = function (qsParamName) {
                    var param = QueryStringUtils.GetParamByName(this.$location.url(), qsParamName);
                    if (param !== undefined && param !== null) {
                        return typeof param === 'string' ? parseInt(param) == 1 : param;
                    }
                    return false;
                };
                return PavDrawerStepCtrl;
            }(ComponentController));
            RegistryFlow.PavDrawerStepCtrl = PavDrawerStepCtrl;
            Pulse.app.component(PavDrawerStep.registeredAs, new PavDrawerStep());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var PavAlert = (function (_super) {
                __extends(PavAlert, _super);
                function PavAlert() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        alertTitle: '<',
                        alertNote: '<',
                        alertClass: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/camp-drawer/idp-pav-alert.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'common',
                        'pulseContextService',
                        function ($scope, common, $element, pcs) { return new PavAlertCtrl($scope, common, $element, pcs); }
                    ];
                    return _this;
                }
                PavAlert.registeredAs = 'idpPavAlert';
                return PavAlert;
            }(ComponentOptions));
            RegistryFlow.PavAlert = PavAlert;
            var PavAlertCtrl = (function (_super) {
                __extends(PavAlertCtrl, _super);
                function PavAlertCtrl($scope, common, $element, pulseContext) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this._showAlert = true;
                    _this.pulseContext = pulseContext;
                    _this.common = common;
                    return _this;
                }
                PavAlertCtrl.prototype.onCloseClicked = function () {
                    this._showAlert = false;
                };
                Object.defineProperty(PavAlertCtrl.prototype, "showAlert", {
                    get: function () {
                        return this._showAlert;
                    },
                    enumerable: false,
                    configurable: true
                });
                return PavAlertCtrl;
            }(ComponentController));
            RegistryFlow.PavAlertCtrl = PavAlertCtrl;
            Pulse.app.component(PavAlert.registeredAs, new PavAlert());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var PavExperience = (function (_super) {
                __extends(PavExperience, _super);
                function PavExperience() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        products: '<',
                        locationInfo: '<',
                        drawerStyle: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/camp-drawer/idp-pav-experience.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'ProductAvailabilityStepService',
                        function ($scope, $element, pcs, pulsePass) { return new PavExperienceCtrl($scope, $element, pcs, pulsePass); }
                    ];
                    return _this;
                }
                PavExperience.registeredAs = 'idpPavExperience';
                return PavExperience;
            }(ComponentOptions));
            RegistryFlow.PavExperience = PavExperience;
            var PavExperienceCtrl = (function (_super) {
                __extends(PavExperienceCtrl, _super);
                function PavExperienceCtrl($scope, $element, pulseContext, pulsePass) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.pulseContext = pulseContext;
                    _this.pulsePass = pulsePass;
                    _this.$scope.$on(Events.ProductAvailabilityStepChange, function (event, newStep) {
                        _this.onStepChanged(newStep);
                    });
                    return _this;
                }
                Object.defineProperty(PavExperienceCtrl.prototype, "mainProduct", {
                    get: function () {
                        return this.products.mainProduct;
                    },
                    enumerable: false,
                    configurable: true
                });
                PavExperienceCtrl.prototype.onStepChanged = function (newStep) {
                };
                PavExperienceCtrl.prototype.onSelectExperience = function (product) {
                    this.pulsePass.stepNext(null, product);
                };
                return PavExperienceCtrl;
            }(ComponentController));
            RegistryFlow.PavExperienceCtrl = PavExperienceCtrl;
            Pulse.app.component(PavExperience.registeredAs, new PavExperience());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var PavRegisterForm = (function (_super) {
                __extends(PavRegisterForm, _super);
                function PavRegisterForm() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        products: '<',
                        selectedProduct: '<',
                        selectedSession: '<',
                        termDiv: '<',
                        sessionPaymentOption: '<',
                        alertList: '<?',
                        drawerStyle: '<?',
                        crossSellProds: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/camp-drawer/idp-pav-register-form.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        '$timeout',
                        'pulseContextService',
                        'ProductAvailabilityStepService',
                        function ($scope, $element, $timeout, pcs, pulsePass) { return new PavRegisterFormCtrl($scope, $element, $timeout, pcs, pulsePass); }
                    ];
                    return _this;
                }
                PavRegisterForm.registeredAs = 'idpPavRegisterForm';
                return PavRegisterForm;
            }(ComponentOptions));
            RegistryFlow.PavRegisterForm = PavRegisterForm;
            var PavRegisterFormCtrl = (function (_super) {
                __extends(PavRegisterFormCtrl, _super);
                function PavRegisterFormCtrl($scope, $element, $timeout, pulseContext, pulsePass) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.knownEmailCheckCount = 0;
                    _this.checkEmailPromise = null;
                    _this.registrationDisabled = false;
                    _this.showLoginAlert = false;
                    _this.unknownUser = false;
                    _this.pulseContext = pulseContext;
                    _this.$timeout = $timeout;
                    _this.userMgr = pulseContext.userMgr;
                    $scope.$on(Events.DrawerUpdateEmail, function (event, email) {
                        _this.checkEmailExistence(event, email);
                    });
                    $scope.$on(Events.LoginSuccess, function () {
                        _this.unknownUser = false;
                    });
                    return _this;
                }
                ;
                PavRegisterFormCtrl.prototype.checkEmailExistence = function (event, email) {
                    var _this = this;
                    if (email && !this.pulseContext.isLoggedIn && this.knownEmailCheckCount < 3) {
                        this.$timeout.cancel(this.checkEmailPromise);
                        this.registrationDisabled = true;
                        this.checkEmailPromise = this.$timeout(function () {
                            _this.checkEmailIsKnown(email)
                                .finally(function () {
                                _this.registrationDisabled = false;
                            });
                        }, 500);
                    }
                    else if (this.knownEmailCheckCount >= 3) {
                        this.closeLoginAlert();
                    }
                };
                PavRegisterFormCtrl.prototype.checkEmailIsKnown = function (email) {
                    var _this = this;
                    return this.userMgr.isValidUsernameOr3rdPartyAuthEmail(email)
                        .then(function (result) {
                        result = typeof result === 'object' && Array.isArray(result)
                            ? !!result.shift()
                            : false;
                        _this.showLoginAlert = result;
                        _this.checkedEmail = result ? email : '';
                        _this.unknownUser = true;
                        if (result) {
                            _this.knownEmailCheckCount++;
                        }
                    })
                        .catch(function (err) {
                        console.error(err);
                    });
                };
                PavRegisterFormCtrl.prototype.closeLoginAlert = function () {
                    this.showLoginAlert = false;
                };
                PavRegisterFormCtrl.prototype.showLogin = function () {
                    this.pulseContext.regFlowMgr.userBrowsingMgr.currentUBSession.userBrowsingDTO.emailAddress = this.checkedEmail;
                    this.$scope.$broadcast(Events.ShowLoginPopup, {
                        initDataObj: {
                            disableCreateAccount: true,
                            emailAddress: this.checkedEmail,
                            hideRequiredAsterix: true,
                            lockEmailAddress: true,
                            showCancel: true,
                            showLabels: true,
                            showRemember: true,
                        },
                        size: '',
                    });
                };
                PavRegisterFormCtrl.prototype.IsValidImageUrl = function (imgUrl) {
                    return imgUrl !== null && imgUrl !== undefined && imgUrl.trim().length > 0;
                };
                Object.defineProperty(PavRegisterFormCtrl.prototype, "hasWaitlistStatus", {
                    get: function () {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                return PavRegisterFormCtrl;
            }(ComponentController));
            RegistryFlow.PavRegisterFormCtrl = PavRegisterFormCtrl;
            Pulse.app.component(PavRegisterForm.registeredAs, new PavRegisterForm());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var ComponentController = Pulse.Common.ComponentController;
            var AvailabilityStatus = Pulse.PulsePublic.RegistryFlow.AvailabilityStatus;
            var PavSessionDates = (function (_super) {
                __extends(PavSessionDates, _super);
                function PavSessionDates() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        dataset: '<',
                        catalogDateRanges: '<',
                        productDates: '<',
                        drawerStyle: '<?',
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'prod-availability/components/camp-drawer/idp-pav-session-dates.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'ProductAvailabilityStepService',
                        function ($scope, $element, pcs, pulsePass) { return new PavSessionDatesCtrl($scope, $element, pcs, pulsePass); }
                    ];
                    return _this;
                }
                PavSessionDates.registeredAs = 'idpPavSessionDates';
                return PavSessionDates;
            }(ComponentOptions));
            RegistryFlow.PavSessionDates = PavSessionDates;
            var PavSessionDatesCtrl = (function (_super) {
                __extends(PavSessionDatesCtrl, _super);
                function PavSessionDatesCtrl($scope, $element, pulseContext, pulsePass) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.showMoreProductDates = true;
                    _this.pulseContext = pulseContext;
                    _this.pulsePass = pulsePass;
                    _this.$scope.$on(Events.ProductAvailabilityStepChange, function (event, newStep) {
                        _this.onStepChanged(newStep);
                    });
                    return _this;
                }
                PavSessionDatesCtrl.prototype.onStepChanged = function (stepChange) {
                    if (stepChange.step.step == Pulse.PulsePublic.RegistryFlow.ProductAvailability.PavDrawerSteps.SelectDateStep) {
                        this.setupFilteredList();
                    }
                };
                PavSessionDatesCtrl.prototype.$onInit = function () {
                    this.setupFilteredList();
                };
                PavSessionDatesCtrl.prototype.setupFilteredList = function (filterList) {
                    if (filterList === void 0) { filterList = true; }
                    if (this.productDates.length > 7 && filterList) {
                        this.showMoreProductDates = true;
                        this.productFilterDates = this.productDates.slice(0, 7);
                    }
                    else {
                        this.productFilterDates = this.productDates;
                        this.showMoreProductDates = false;
                    }
                };
                PavSessionDatesCtrl.prototype.sessionBadgeClass = function (status) {
                    if (status == Enums.SessionAvailabilityStatus.SoldOut || status == Enums.SessionAvailabilityStatus.SoldOutDesktop)
                        return 'badge-waitlist';
                    return 'badge-primary';
                };
                PavSessionDatesCtrl.prototype.sessionStatusText = function (status) {
                    var ssText = "Select date";
                    if (status == AvailabilityStatus.SoldOut)
                        ssText = "Add to Waitlist";
                    return ssText;
                };
                PavSessionDatesCtrl.prototype.sessionStatusIconClass = function (status) {
                    if (status == Enums.SessionAvailabilityStatus.SoldOut) {
                        return 'fa-exclamation-circle';
                    }
                    else if (status == Enums.SessionAvailabilityStatus.Open) {
                        return 'fa-circle';
                    }
                    else {
                        return 'fa-exclamation-triangle session-warning';
                    }
                };
                PavSessionDatesCtrl.prototype.sessionTextClass = function (status) {
                    var textClass = 'session-warning';
                    switch (status) {
                        case Enums.SessionAvailabilityStatus.Open:
                            textClass = 'session-open';
                            break;
                        case Enums.SessionAvailabilityStatus.NoSpace:
                        case Enums.SessionAvailabilityStatus.SoldOut:
                            textClass = 'session-danger';
                            break;
                        default:
                            break;
                    }
                    return textClass;
                };
                PavSessionDatesCtrl.prototype.onSelectDate = function (date) {
                    this.pulsePass.stepNext(null, date);
                };
                PavSessionDatesCtrl.prototype.showMore = function () {
                    this.setupFilteredList(false);
                };
                return PavSessionDatesCtrl;
            }(ComponentController));
            RegistryFlow.PavSessionDatesCtrl = PavSessionDatesCtrl;
            Pulse.app.component(PavSessionDates.registeredAs, new PavSessionDates());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ComponentOptions = Pulse.Common.ComponentOptions;
            var DataAccess = Pulse.Common.DataAccess;
            var ComponentController = Pulse.Common.ComponentController;
            var GroupWith = (function (_super) {
                __extends(GroupWith, _super);
                function GroupWith() {
                    var _this = _super.call(this) || this;
                    _this.bindings = {
                        product: '<?',
                        userBrowsingParticipantId: '<',
                        browseIdentifier: '<'
                    };
                    _this.templateUrl = [
                        'config',
                        function (config) {
                            return config.appRoot
                                + Paths.PulsePublicRegistryFlow
                                + 'idp-group-with.html';
                        },
                    ];
                    _this.controller = [
                        '$scope',
                        '$element',
                        'pulseContextService',
                        'common',
                        'breezeService',
                        function ($scope, $element, pulseContext, common, breezeService) {
                            return new GroupWithCtrl($scope, $element, pulseContext, common, breezeService);
                        }
                    ];
                    return _this;
                }
                GroupWith.registeredAs = 'idpGroupWith';
                return GroupWith;
            }(ComponentOptions));
            RegistryFlow.GroupWith = GroupWith;
            var GroupWithCtrl = (function (_super) {
                __extends(GroupWithCtrl, _super);
                function GroupWithCtrl($scope, $element, pulseContext, common, breezeService) {
                    var _this = _super.call(this, $scope, $element) || this;
                    _this.friends = [];
                    _this.buddyListAsUserBrowsingNotes = [];
                    _this.formName = "myForm";
                    _this.pulseContext = pulseContext;
                    _this.common = common;
                    _this.breezeService = breezeService;
                    _this.imgSrc = _this.common.config.appRoot + 'assets/images/group-with-friends.png';
                    return _this;
                }
                GroupWithCtrl.prototype.$onInit = function () {
                    this.getFriends();
                };
                GroupWithCtrl.prototype.getFriends = function () {
                    var _this = this;
                    this.common.toggleSpinner(true);
                    this.breezeService.getEntityManager().rejectChanges();
                    var ubnDAO = new Pulse.Common.DataAccess.UserBrowsingNoteDAO(this.common, this.breezeService, this.pulseContext);
                    return ubnDAO.loadBuddyListFromUserBrowsingNotes(this.friends, this.browseIdentifier, this.userBrowsingParticipantId)
                        .then(function (buddyList) {
                        _this.buddyListAsUserBrowsingNotes = buddyList;
                        if (_this.friends.length == 0) {
                            _this.addFriend();
                        }
                    }).catch(function (err) {
                        return null;
                    }).finally(function () {
                        _this.common.toggleSpinner(false);
                    });
                };
                GroupWithCtrl.prototype.addFriend = function () {
                    if (this.userBrowsingParticipantId) {
                        var ubnDAO = new DataAccess.UserBrowsingNoteDAO(this.common, this.breezeService, this.pulseContext);
                        var userBrowsingNote = ubnDAO.Create({
                            userBrowsingNoteTypeID: Enums.UserBrowsingNoteType.GroupWith,
                            userBrowsingParticipantID: this.userBrowsingParticipantId,
                            note: ''
                        });
                        var newBuddy = Object.assign({}, userBrowsingNote);
                        newBuddy.userBrowsingNote = userBrowsingNote;
                        newBuddy.firstName = '';
                        newBuddy.lastName = '';
                        this.friends.push(newBuddy);
                    }
                };
                Object.defineProperty(GroupWithCtrl.prototype, "form", {
                    get: function () {
                        return this.$scope[this.formName];
                    },
                    enumerable: false,
                    configurable: true
                });
                GroupWithCtrl.prototype.submit = function () {
                    var _this = this;
                    if (this.form.$valid) {
                        this.saveDisabled = true;
                        this.common.clearStatus();
                        this.common.toggleSpinner(true);
                        for (var i = 0, il = this.friends.length; i < il; ++i) {
                            var o = this.friends[i];
                            if (String.isNullOrWhitespace(o.lastName) && String.isNullOrWhitespace(o.firstName)) {
                                o.entityAspect.rejectChanges();
                            }
                            if (o.userBrowsingNote) {
                                o.userBrowsingNote.note = o.lastName + '|' + o.firstName;
                            }
                            else {
                                for (var j = 0, jl = this.buddyListAsUserBrowsingNotes.length; j < jl; ++j) {
                                    var ubn = this.buddyListAsUserBrowsingNotes[j];
                                    if (ubn.userBrowsingNoteID == o.userBrowsingNoteID) {
                                        ubn.note = o.lastName + '|' + o.firstName;
                                    }
                                }
                            }
                        }
                        var ubnDAO_1 = new DataAccess.UserBrowsingNoteDAO(this.common, this.breezeService, this.pulseContext);
                        ubnDAO_1.createGroupWithList(this.browseIdentifier, this.userBrowsingParticipantId)
                            .then(function (saveResult) {
                            _this.buddyListAsUserBrowsingNotes = ubnDAO_1.getFromSaveResult(saveResult);
                            _this.common.$rootScope.$broadcast(Events.ProductAvailabilityGroupWithFinished, _this.product);
                        })
                            .catch(function (err) {
                            _this.breezeService.getEntityManager().rejectChanges();
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                            _this.saveDisabled = false;
                        });
                    }
                };
                GroupWithCtrl.prototype.skip = function () {
                    this.common.$rootScope.$broadcast(Events.ProductAvailabilityGroupWithFinished, this.product);
                };
                GroupWithCtrl.prototype.isSaveDisabled = function () {
                    var found = _.find(this.friends, function (f) {
                        return !String.isNullOrWhitespace(f.firstName) || !String.isNullOrWhitespace(f.firstName);
                    });
                    return !found;
                };
                GroupWithCtrl.prototype.getDivisionAbbr = function () {
                    var div = Pulse.Common.DataAccess.DivisionDAO.FilterDivisionsByID(this.pulseContext.lookupInfoMgr.divisionInfos, this.product.divisionID);
                    return div ? div.abbr : "";
                };
                return GroupWithCtrl;
            }(ComponentController));
            RegistryFlow.GroupWithCtrl = GroupWithCtrl;
            Pulse.app.component(GroupWith.registeredAs, new GroupWith());
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var PulsePublic;
    (function (PulsePublic) {
        var RegistryFlow;
        (function (RegistryFlow) {
            var ProductAvailability;
            (function (ProductAvailability) {
                var ProductAvailabilityStepService = (function () {
                    function ProductAvailabilityStepService(common) {
                        this.common = common;
                        this.reset();
                    }
                    ProductAvailabilityStepService.prototype.init = function (cfg) {
                        this._stepManagerType = cfg.stepManagerType;
                        switch (this._stepManagerType) {
                            case PavStepManagerType.StackSteps:
                                {
                                    this._stepService = new StackStepService(this.common);
                                    this._stepService.stepNext(cfg.stepData, {});
                                }
                                break;
                            case PavStepManagerType.ListSteps:
                                {
                                    this._stepService = new ListStepService(this.common);
                                    var stepList = cfg.stepData;
                                    for (var _i = 0, stepList_1 = stepList; _i < stepList_1.length; _i++) {
                                        var step = stepList_1[_i];
                                        this._stepService.addStep(step);
                                    }
                                }
                                break;
                            default:
                                {
                                    this._stepService = new AccordionStepService();
                                }
                                break;
                        }
                        return this;
                    };
                    ProductAvailabilityStepService.prototype.reset = function () {
                        this.init({
                            stepManagerType: PavStepManagerType.StackSteps,
                            stepData: this.accordionStep
                        });
                        return this;
                    };
                    ProductAvailabilityStepService.prototype.addStep = function (step) {
                        this._stepService.addStep(step);
                        return this;
                    };
                    Object.defineProperty(ProductAvailabilityStepService.prototype, "stepCount", {
                        get: function () {
                            return this._stepService.stepCount;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ProductAvailabilityStepService.prototype, "accordionStep", {
                        get: function () {
                            if (this._stepManagerType == PavStepManagerType.StaticStep) {
                                return this._stepService.currentStep;
                            }
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ProductAvailabilityStepService.prototype.stepNext = function (nStep, stepData) {
                        this._stepService.stepNext(nStep, stepData);
                        return this;
                    };
                    ProductAvailabilityStepService.prototype.stepPrev = function () {
                        this._stepService.stepPrev();
                        return this;
                    };
                    Object.defineProperty(ProductAvailabilityStepService.prototype, "viewPreviousStep", {
                        get: function () {
                            return this._stepService.viewPreviousStep;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ProductAvailabilityStepService.prototype, "currentStep", {
                        get: function () {
                            return this._stepService.currentStep;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ProductAvailabilityStepService.registerAs = 'ProductAvailabilityStepService';
                    return ProductAvailabilityStepService;
                }());
                ProductAvailability.ProductAvailabilityStepService = ProductAvailabilityStepService;
                var BaseStepService = (function () {
                    function BaseStepService() {
                        this._nextStepID = 0;
                    }
                    Object.defineProperty(BaseStepService.prototype, "nextStepID", {
                        get: function () {
                            this._nextStepID = (this._nextStepID + 1) % 10000000;
                            return this._nextStepID;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return BaseStepService;
                }());
                var AccordionStepService = (function (_super) {
                    __extends(AccordionStepService, _super);
                    function AccordionStepService() {
                        return _super.call(this) || this;
                    }
                    Object.defineProperty(AccordionStepService.prototype, "currentStep", {
                        get: function () {
                            return this.accordionStep;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(AccordionStepService.prototype, "viewPreviousStep", {
                        get: function () {
                            return this.accordionStep;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AccordionStepService.prototype.addStep = function (step) {
                    };
                    Object.defineProperty(AccordionStepService.prototype, "stepCount", {
                        get: function () {
                            return 1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AccordionStepService.prototype.stepNext = function (nStep, stepData) { };
                    AccordionStepService.prototype.stepPrev = function () { };
                    Object.defineProperty(AccordionStepService.prototype, "accordionStep", {
                        get: function () {
                            return {
                                stepID: this.nextStepID,
                                step: PavDrawerSteps.AccordionDrawer,
                                stepBackText: 'Back to course page',
                                stepSelectText: ''
                            };
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return AccordionStepService;
                }(BaseStepService));
                var ListStepService = (function (_super) {
                    __extends(ListStepService, _super);
                    function ListStepService(common) {
                        var _this = _super.call(this) || this;
                        _this._stepList = [];
                        _this._currentStepIdx = 0;
                        _this.common = common;
                        return _this;
                    }
                    Object.defineProperty(ListStepService.prototype, "currentStep", {
                        get: function () {
                            return this._stepList[this._currentStepIdx];
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(ListStepService.prototype, "viewPreviousStep", {
                        get: function () {
                            if (this._currentStepIdx - 1 >= 0) {
                                return this._stepList[this._currentStepIdx - 1];
                            }
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ListStepService.prototype.addStep = function (step) {
                        step.stepID = this.nextStepID;
                        this._stepList.push(step);
                    };
                    Object.defineProperty(ListStepService.prototype, "stepCount", {
                        get: function () {
                            return this._stepList.length;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ListStepService.prototype.stepNext = function (nStep, stepData) {
                        var nIdx = Math.min(this._currentStepIdx + 1, this._stepList.length - 1);
                        var stepEvent = {
                            previousStep: this.currentStep,
                            step: this._stepList[nIdx],
                            stepCode: PavDrawerSteps.StepForward,
                            stepData: stepData
                        };
                        this._currentStepIdx = nIdx;
                        this.common.$rootScope.$broadcast(Events.ProductAvailabilityStepChange, stepEvent);
                    };
                    ListStepService.prototype.stepPrev = function () {
                        var pIdx = Math.max(this._currentStepIdx - 1, 0);
                        var stepEvent = {
                            previousStep: this.currentStep,
                            step: this._stepList[pIdx],
                            stepCode: PavDrawerSteps.StepBack,
                            stepData: {}
                        };
                        this._currentStepIdx = pIdx;
                        this.common.$rootScope.$broadcast(Events.ProductAvailabilityStepChange, stepEvent);
                    };
                    return ListStepService;
                }(BaseStepService));
                var StackStepService = (function (_super) {
                    __extends(StackStepService, _super);
                    function StackStepService(common) {
                        var _this = _super.call(this) || this;
                        _this._stepStack = [];
                        _this._currentStepID = 0;
                        _this.common = common;
                        return _this;
                    }
                    Object.defineProperty(StackStepService.prototype, "currentStep", {
                        get: function () {
                            var _this = this;
                            return this._stepStack.filter(function (step) { return step.stepID == _this._currentStepID; })[0];
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(StackStepService.prototype, "viewPreviousStep", {
                        get: function () {
                            if (this._stepStack.length > 1) {
                                return this._stepStack[this._stepStack.length - 2];
                            }
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    StackStepService.prototype.addStep = function (step) {
                    };
                    Object.defineProperty(StackStepService.prototype, "stepCount", {
                        get: function () {
                            return this._stepStack.length;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    StackStepService.prototype.stepNext = function (nStep, stepData) {
                        if (nStep == null || nStep == undefined)
                            return;
                        nStep.stepID = this.nextStepID;
                        var stepEvent = {
                            previousStep: this.currentStep,
                            step: nStep,
                            stepCode: PavDrawerSteps.StepForward,
                            stepData: stepData
                        };
                        this._currentStepID = nStep.stepID;
                        this._stepStack.push(nStep);
                        this.common.$rootScope.$broadcast(Events.ProductAvailabilityStepChange, stepEvent);
                    };
                    StackStepService.prototype.stepPrev = function () {
                        var stepEvent = {
                            previousStep: this._stepStack.pop(),
                            step: this._stepStack[this._stepStack.length - 1],
                            stepCode: PavDrawerSteps.StepBack,
                            stepData: {}
                        };
                        this._currentStepID = stepEvent.step.stepID;
                        this.common.$rootScope.$broadcast(Events.ProductAvailabilityStepChange, stepEvent);
                    };
                    return StackStepService;
                }(BaseStepService));
                var PavDrawerSteps;
                (function (PavDrawerSteps) {
                    PavDrawerSteps[PavDrawerSteps["AccordionDrawer"] = 9999] = "AccordionDrawer";
                    PavDrawerSteps[PavDrawerSteps["SelectLocationStep"] = 10] = "SelectLocationStep";
                    PavDrawerSteps[PavDrawerSteps["SelectAcadamyStep"] = 15] = "SelectAcadamyStep";
                    PavDrawerSteps[PavDrawerSteps["SelectDateStep"] = 20] = "SelectDateStep";
                    PavDrawerSteps[PavDrawerSteps["SelectTimeStep"] = 30] = "SelectTimeStep";
                    PavDrawerSteps[PavDrawerSteps["SelectExperienceStep"] = 40] = "SelectExperienceStep";
                    PavDrawerSteps[PavDrawerSteps["BuyingCourse"] = 60] = "BuyingCourse";
                    PavDrawerSteps[PavDrawerSteps["LoadDateStep"] = 100] = "LoadDateStep";
                    PavDrawerSteps[PavDrawerSteps["StepForward"] = 1] = "StepForward";
                    PavDrawerSteps[PavDrawerSteps["StepBack"] = -1] = "StepBack";
                })(PavDrawerSteps = ProductAvailability.PavDrawerSteps || (ProductAvailability.PavDrawerSteps = {}));
                var PavStepManagerType;
                (function (PavStepManagerType) {
                    PavStepManagerType[PavStepManagerType["StackSteps"] = 0] = "StackSteps";
                    PavStepManagerType[PavStepManagerType["ListSteps"] = 1] = "ListSteps";
                    PavStepManagerType[PavStepManagerType["StaticStep"] = 2] = "StaticStep";
                })(PavStepManagerType = ProductAvailability.PavStepManagerType || (ProductAvailability.PavStepManagerType = {}));
                Pulse.app.service(ProductAvailabilityStepService.registerAs, [
                    'common',
                    ProductAvailabilityStepService
                ]);
            })(ProductAvailability = RegistryFlow.ProductAvailability || (RegistryFlow.ProductAvailability = {}));
        })(RegistryFlow = PulsePublic.RegistryFlow || (PulsePublic.RegistryFlow = {}));
    })(PulsePublic = Pulse.PulsePublic || (Pulse.PulsePublic = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var MyStudentsDir = (function (_super) {
                __extends(MyStudentsDir, _super);
                function MyStudentsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "schedule/idp-my-students.html";
                    _this.scope = {
                        studentList: "=",
                        canUpdate: "<"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        MyStudentsDir.MyStudentsDirCtrl];
                    return _this;
                }
                MyStudentsDir.directiveId = "idpMyStudents";
                return MyStudentsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.MyStudentsDir = MyStudentsDir;
            (function (MyStudentsDir) {
                var MyStudentsDirCtrl = (function (_super) {
                    __extends(MyStudentsDirCtrl, _super);
                    function MyStudentsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, MyStudentsDirCtrl.controllerId) || this;
                        _this.groupWithPopupAPI = null;
                        _this.requestVoucherCreditPopupApi = null;
                        return _this;
                    }
                    MyStudentsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrl);
                        scope.$watch(function (scope) {
                            return angular.isArray(_this.studentList) ? _this.studentList.length : 0;
                        }, function (newVal, oldVal) {
                            angular.forEach(_this.studentList, function (student) {
                                student.isActive == false;
                            });
                            if (!_this.pulseContext.isImpersonating) {
                                if (angular.isArray(_this.studentList) && _this.studentList.length == 1 && !_this.studentList[0].isActive) {
                                    _this.loadStudentSessions(0);
                                }
                            }
                        }, false);
                    };
                    MyStudentsDirCtrl.prototype.loadStudentSessions = function (index) {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        var student = this.studentList[index];
                        if (student.isReadyToShow) {
                            student.isActive = !student.isActive;
                            this.common.toggleSpinner(false);
                            return;
                        }
                        var userID = student.userID;
                        student.isActive = true;
                        return this.pulseContext.customerMgr.getStudentSessions(userID).then(function (data) {
                            if (data != null) {
                                for (var i = 0; i < data.length; i++) {
                                    var optList = Array();
                                    var sessionData = data[i];
                                    if (sessionData.primaryCustomerUserID != _this.pulseContext.actingAsUserId) {
                                        sessionData.isEnabled = false;
                                    }
                                    sessionData.isVirtualCamp = sessionData.programTypeID == Enums.DivisionProgramType.VirtualCamp;
                                    sessionData.isSquads = sessionData.productCatalog == Enums.SalesCatalogType.SquadsConsecutiveDays || sessionData.productCatalog == Enums.SalesCatalogType.SquadsMultiWeek;
                                    sessionData.isAfterSchoolDelivery = sessionData.divDeliveryModelTypeID == Enums.DivisionDeliveryModelType.AfterSchoolPrograms;
                                    var isDivAcademy = sessionData.programTypeID == Enums.DivisionProgramType.iDTechAcademies;
                                    var priceSuffix = isDivAcademy ? '/session' : '/week';
                                    if (sessionData.options != null) {
                                        for (var iOpt = 0; iOpt < sessionData.options.length; iOpt++) {
                                            var optionItem = sessionData.options[iOpt];
                                            if (optionItem.productCategory == Enums.ProductCategoryType.CEU) {
                                                optionItem.price += priceSuffix;
                                                optionItem.priceSuffix = priceSuffix;
                                                optionItem.cssClass = 'ceus';
                                            }
                                            else if (optionItem.productCategory == Enums.ProductCategoryType.Meal) {
                                                optionItem.price += priceSuffix;
                                                optionItem.priceSuffix = priceSuffix;
                                                optionItem.cssClass = 'lunch';
                                            }
                                            else if (optionItem.productCategory == Enums.ProductCategoryType.Residency) {
                                                switch (optionItem.productSubCategory) {
                                                    case Enums.ProductSubCategoryType.OvernightAndWeekend:
                                                    case Enums.ProductSubCategoryType.Overnight:
                                                        optionItem.price += priceSuffix;
                                                        optionItem.priceSuffix = priceSuffix;
                                                        optionItem.cssClass = 'overnight';
                                                        break;
                                                    case Enums.ProductSubCategoryType.WeekendBefore:
                                                    case Enums.ProductSubCategoryType.WeekendWithin:
                                                        optionItem.description = String.format("The weekend of <span style='white-space:nowrap;'>{0} - {1}</span> for {2}", _this.common.$filter('date')(optionItem.startDateTime, 'MMM d'), _this.common.$filter('date')(optionItem.endDateTime, 'MMM d'), optionItem.price);
                                                        optionItem.price = null;
                                                        optionItem.cssClass = 'weekend';
                                                        break;
                                                    case Enums.ProductSubCategoryType.WeekendAfter:
                                                        if (isDivAcademy) {
                                                            optionItem.description = String.format("The weekend of <span style='white-space:nowrap;'>{0} - {1}</span> for {2}", _this.common.$filter('date')(optionItem.startDateTime, 'MMM d'), _this.common.$filter('date')(optionItem.endDateTime, 'MMM d'), optionItem.price);
                                                            optionItem.price = null;
                                                            optionItem.cssClass = 'weekend';
                                                        }
                                                        else {
                                                            optionItem.description = String.format("The weekend of <span style='white-space:nowrap;'>{0} - {1}</span> for {2}", _this.common.$filter('date')(optionItem.startDateTime, 'MMM d'), _this.common.$filter('date')(optionItem.endDateTime, 'MMM d'), optionItem.price);
                                                            optionItem.price = null;
                                                            optionItem.cssClass = 'gaming';
                                                        }
                                                        break;
                                                    default:
                                                        optionItem.price += priceSuffix;
                                                        optionItem.priceSuffix = priceSuffix;
                                                        optionItem.cssClass = 'overnight';
                                                        break;
                                                }
                                            }
                                            optList.push(optionItem);
                                        }
                                    }
                                    if (sessionData.oppositeAvChartSection != null) {
                                        optList.push({
                                            name: 'Make it a full day at iD Tech Mini',
                                            description: 'Upgrade your current iD Tech Mini Session.',
                                            isPurchased: false,
                                            cssClass: 'full',
                                            isEnabled: !sessionData.hasSessionEnded,
                                        });
                                    }
                                    sessionData.options = optList;
                                }
                            }
                            student.sessionList = data;
                            student.isReadyToShow = true;
                            student.isActive = true;
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    MyStudentsDirCtrl.prototype.onOnlineLessonsClick = function () {
                        this.pulseContext.regFlowMgr = null;
                        if (!this.pulseContext.inWWW) {
                            this.pulseContext.shoppingCartType = Enums.ShoppingCartType.RegFlow;
                            this.common.$location.url(Routes.RegFlow_Upsell);
                        }
                        else {
                            window.location.assign(this.common.config.WWW_UrlRoot + '/courses');
                        }
                    };
                    MyStudentsDirCtrl.prototype.onCloseClick = function (student) {
                        student.isReadyToShow = false;
                        student.isActive = false;
                        this.common.scrollToHash('heading' + student.userID);
                    };
                    MyStudentsDirCtrl.controllerId = "MyStudentsDirCtrl";
                    return MyStudentsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                MyStudentsDir.MyStudentsDirCtrl = MyStudentsDirCtrl;
            })(MyStudentsDir = PulsePublic.MyStudentsDir || (PulsePublic.MyStudentsDir = {}));
            Pulse.app.directive(MyStudentsDir.directiveId, ["common", function (c) { return new MyStudentsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ShoppingCartMgr = Pulse.Common.DataAccess.Managers.ShoppingCartMgr;
            var SessionsDir = (function (_super) {
                __extends(SessionsDir, _super);
                function SessionsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'schedule/idp-sessions.html';
                    _this.scope = {
                        student: '=',
                        sessionList: '='
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        SessionsDir.SessionsDirCtrl
                    ];
                    return _this;
                }
                SessionsDir.directiveId = 'idpSessions';
                return SessionsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.SessionsDir = SessionsDir;
            (function (SessionsDir) {
                var SessionsDirCtrl = (function (_super) {
                    __extends(SessionsDirCtrl, _super);
                    function SessionsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SessionsDirCtrl.controllerId) || this;
                        _this.isPnlStaffEnabled = false;
                        _this.isPnlStaffOpen = false;
                        _this._showChangeFeeWarning = null;
                        return _this;
                    }
                    SessionsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls);
                        scope.$watch(function (scope) {
                            return _this.sessionList;
                        }, function (newValue, oldValue) {
                            if (newValue) {
                                _this.sessionList.forEach(function (sess) {
                                    sess.hasPendingChanges = _this.hasChangeForSession(sess);
                                    sess.showMakeChange = sess.showMakeChange || sess.hasPendingChanges;
                                });
                            }
                        });
                    };
                    SessionsDirCtrl.prototype.hasChangeForSession = function (session) {
                        var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        var currentUBSession = userBrowsingMgr.currentUBSession;
                        if (currentUBSession && currentUBSession.userBrowsingDTO
                            && ShoppingCartMgr.CompatibleChangeCartTypeList.indexOf(currentUBSession.userBrowsingDTO.cartTypeID) >= 0) {
                            return userBrowsingMgr.hasPredecessorOrderDetailID(userBrowsingMgr.currentUBSession, session.orderDetailID);
                        }
                        return false;
                    };
                    SessionsDirCtrl.prototype.onMakeChangeClick = function (session) {
                        if (angular.isUndefined(session.showMakeChange)) {
                            session.showMakeChange = false;
                        }
                        session.showMakeChange = !session.showMakeChange;
                    };
                    SessionsDirCtrl.prototype.onChangeCampClick = function (session) {
                        this.common.$rootScope.$broadcast(Events.ShowChangeCampPopup, {
                            size: '',
                            initDataObj: {
                                student: this.student,
                                session: session,
                                showChangeFeeWarning: this.showChangeFeeWarning(session),
                            }
                        });
                    };
                    SessionsDirCtrl.prototype.onRequestVoucherCredit = function (session) {
                        this.common.$rootScope.$broadcast(Events.ShowRequestVoucherCreditPopup, {
                            size: '',
                            initDataObj: {
                                student: this.student,
                                session: session,
                            }
                        });
                    };
                    SessionsDirCtrl.prototype.onCancelCampClick = function (session) {
                        this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.Cancel, session.orderDetailID);
                    };
                    SessionsDirCtrl.prototype.onGoToCampClick = function (session) {
                        this.common.$window.open(this.common.config.pulse1x_WelcomeUrlRoot + '/Welcome.aspx?' + session.welcomeQS, 'Welcome Packet');
                    };
                    SessionsDirCtrl.prototype.onGroupWithClick = function (session) {
                        this.common.$rootScope.$broadcast(Events.ShowGroupWithPopup, {
                            size: '',
                            initDataObj: {
                                hasOvernight: session.hasOvernight,
                                orderDetailId: session.orderDetailID,
                                isVTC: session.isVirtualCamp,
                                maxFriendNumber: session.isSquads ? 9 : null,
                            }
                        });
                    };
                    SessionsDirCtrl.prototype.onGoShoppingCartClick = function () {
                        this.pulseContext.regFlowMgr.goToStepByEnum(DataAccess.Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                    };
                    SessionsDirCtrl.prototype.onRemovePendingChangeClick = function (session) {
                        var _this = this;
                        var userBrowsingMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        var shoppingCartMgr = this.pulseContext.regFlowMgr.shoppingCartMgr;
                        var currentUBSession = userBrowsingMgr.currentUBSession;
                        if (currentUBSession && currentUBSession.userBrowsingDTO
                            && ShoppingCartMgr.CompatibleChangeCartTypeList.indexOf(currentUBSession.userBrowsingDTO.cartTypeID) >= 0) {
                            this.common.toggleSpinner(true, true, null, 0);
                            var UB_Item = userBrowsingMgr.findItemByPredecessorOrderDetailID(currentUBSession, session.orderDetailID);
                            if (UB_Item) {
                                var itemInfo = {};
                                itemInfo.browseIdentifier = this.pulseContext.browseIdentifier;
                                itemInfo.userBrowsingItemID = UB_Item.userBrowsingItemID;
                                itemInfo.userBrowsingID = UB_Item.userBrowsingID;
                                itemInfo.productID = UB_Item.productID;
                                itemInfo.action = false;
                                userBrowsingMgr.selectItem(itemInfo)
                                    .then(function () {
                                    shoppingCartMgr.clearCachedCart();
                                    return userBrowsingMgr.loadInfo(userBrowsingMgr.currentUBSession, false)
                                        .then(function () {
                                        if (!userBrowsingMgr.hasChangeItems(userBrowsingMgr.currentUBSession)) {
                                            shoppingCartMgr.cancelShoppingCart();
                                            return userBrowsingMgr.removeUserBrowsingSession(userBrowsingMgr.currentUBSession)
                                                .then(function () {
                                                _this.pulseContext.regFlowMgr = null;
                                            });
                                        }
                                    });
                                })
                                    .then(function () {
                                    session.hasPendingChanges = false;
                                    userBrowsingMgr.removeParticipantCurrencyType();
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                            }
                        }
                    };
                    SessionsDirCtrl.prototype.getDateListFromSession = function (session) {
                        var dateList = [];
                        var currMonth;
                        var currYear;
                        for (var _i = 0, _a = session.sessionDateList; _i < _a.length; _i++) {
                            var date = _a[_i];
                            var fmtDate_1 = this.common.$filter('date')(date.startDateTime, 'MM/dd/yy');
                            if (date.sessionProductDetailID !== session.sessionDateList[session.sessionDateList.length - 1].sessionProductDetailID) {
                                dateList.push(fmtDate_1);
                            }
                        }
                        var fmtDate = this.common.$filter('date')(session.sessionDateList[session.sessionDateList.length - 1].startDateTime, 'MM/dd/yy');
                        return dateList.join(', ') + ', & ' + fmtDate;
                    };
                    SessionsDirCtrl.prototype.getDateListFromSessionV2 = function (session) {
                        var dateList = [];
                        var currMonth = '';
                        var currYear = '';
                        var fmtList = '';
                        var firstDate = session.sessionDateList[0].startDateTime;
                        var lastDate = session.sessionDateList[session.sessionDateList.length - 1].startDateTime;
                        var now = moment(new Date());
                        var nowMonth = this.common.$filter('date')(now.toDate(), 'MM');
                        var hasMarkedNextDate = false;
                        var markingOutDates = false;
                        var hasNotStarted = this.common.$filter('date')(firstDate, 'MM') > nowMonth
                            && this.common.$filter('date')(firstDate, 'yyyy') >= this.common.$filter('date')(now.toDate(), 'yyyy');
                        for (var _i = 0, _a = session.sessionDateList; _i < _a.length; _i++) {
                            var sessDate = _a[_i];
                            var month = this.common.$filter('date')(sessDate.startDateTime, 'MM');
                            var day = this.common.$filter('date')(sessDate.startDateTime, 'dd');
                            var year = this.common.$filter('date')(sessDate.startDateTime, 'yyyy');
                            var date = moment(sessDate.startDateTime);
                            if (date.isBefore(now) && !markingOutDates) {
                                markingOutDates = true;
                                fmtList += '<span class="past-scheduled-date">';
                                markingOutDates = true;
                            }
                            if (markingOutDates && (date.isAfter(now) || parseInt(month) == parseInt(nowMonth))) {
                                markingOutDates = false;
                                fmtList += '</span>';
                            }
                            if (year != currYear) {
                                fmtList += ' ' + currYear + (currYear != '' ? ', ' : '');
                                currYear = year;
                            }
                            if (month != currMonth) {
                                currMonth = month;
                                var monthPrefix = '';
                                var monthSuffix = '';
                                if (parseInt(month) == parseInt(nowMonth) || hasNotStarted) {
                                    monthPrefix = '<span class="next-scheduled-date">';
                                    monthSuffix = '</span>';
                                    hasNotStarted = false;
                                }
                                fmtList += monthPrefix + this.common.$filter('date')(sessDate.startDateTime, 'MMM') + ': ' + monthSuffix;
                            }
                            var prefixTag = '';
                            var suffixTag = '';
                            if (date.isAfter(now) && !hasMarkedNextDate) {
                                hasMarkedNextDate = true;
                                prefixTag = '<span class="next-scheduled-date">';
                                suffixTag = '</span>';
                            }
                            if (date.isBefore(now) && !markingOutDates) {
                                prefixTag = '<span class="past-scheduled-date">';
                                suffixTag = '</span>';
                            }
                            day = "<span title=\"" + this.common.$filter('date')(sessDate.startDateTime, 'EEEE, MMMM dd yyyy') + "\">" + day + "</span>";
                            fmtList += (sessDate.startDateTime != lastDate ? '' : ' & ') + prefixTag + day + suffixTag + (sessDate.startDateTime != lastDate ? ', ' : '');
                        }
                        fmtList += ' ' + currYear;
                        return fmtList;
                    };
                    SessionsDirCtrl.prototype.getChangeStatusText = function (session) {
                        if (!session.canBeChanged && !session.canBeCanceled) {
                            return 'changes and cancellations';
                        }
                        else if (!session.canBeChanged) {
                            return 'changes';
                        }
                        else if (!session.canBeCanceled) {
                            return 'cancellations';
                        }
                        return '';
                    };
                    SessionsDirCtrl.prototype.isWelcomePacketAvailable = function (session) {
                        var now = this.pulseContext.serverDateTime;
                        var isOpen = session.welcomeMapsOpen.startDate < now && now <= session.welcomeMapsOpen.endDate;
                        var hasReqFrmAvailEnded = session.formsAvailableDate.endDate < now;
                        return isOpen;
                    };
                    SessionsDirCtrl.prototype.getWelcomePacketNotAvailMsg = function (session) {
                        var now = this.pulseContext.serverDateTime;
                        var hasReqFrmAvailEnded = session.formsAvailableDate.endDate < now;
                        if (now < session.welcomeMapsOpen.startDate) {
                            return String.format(StringConst.Info_WelcomePacketAvailOn, this.common.$filter('date')(session.welcomeMapsOpen.startDate, 'mediumDate'));
                        }
                        else {
                            return StringConst.Info_WelcomePacketNotAvail;
                        }
                    };
                    SessionsDirCtrl.prototype.isInAdminChangeFeeChargedTimePeriod = function (session) {
                        if (!session.adminChangeFeeChargePeriod)
                            return false;
                        var now = this.pulseContext.serverDateTime;
                        return session.adminChangeFeeChargePeriod.startDate < now && now <= session.adminChangeFeeChargePeriod.endDate;
                    };
                    SessionsDirCtrl.prototype.showChangeFeeWarning = function (session) {
                        if (this._showChangeFeeWarning === null) {
                            this._showChangeFeeWarning = this.isInAdminChangeFeeChargedTimePeriod(session) && session.isPrimaryCustomer && session.canBeChanged;
                        }
                        return this._showChangeFeeWarning;
                    };
                    Object.defineProperty(SessionsDirCtrl.prototype, "licenceViewLink", {
                        get: function () {
                            var params = {};
                            params[QueryStringUtils.TERM_GROUP_ID] = this.pulseContext.currentTermGroup.termGroupID;
                            params[QueryStringUtils.PARTICIPANT_ID] = this.student.userID;
                            return QueryStringUtils.AddOrSetQSParams(Routes.MyAccount_CourseTakeHomes, params);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    SessionsDirCtrl.prototype.isReqFrmsCompleted = function (session) {
                        return ((session.reqdFormsComplete == null || session.reqdFormsComplete) &&
                            (session.addReqdFormsComplete == null || session.addReqdFormsComplete));
                    };
                    SessionsDirCtrl.prototype.getPrepInstructionUrl = function (session) {
                        var matches = session.urls.filter(function (url) { return url.usageTypeID == Enums.ProductURLType.PrepInstructionsURL; });
                        if (matches.length) {
                            return matches[0].url || matches[0].uRL;
                        }
                        return null;
                    };
                    SessionsDirCtrl.prototype.hasSessionEnded = function (session) {
                        return moment(this.pulseContext.serverDateTime).isAfter(moment(session.sessionEnd).endOf('day'));
                    };
                    SessionsDirCtrl.controllerId = 'SessionsDirCtrl';
                    return SessionsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                SessionsDir.SessionsDirCtrl = SessionsDirCtrl;
            })(SessionsDir = PulsePublic.SessionsDir || (PulsePublic.SessionsDir = {}));
            Pulse.app.directive(SessionsDir.directiveId, ['common', function (c) { return new SessionsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CourseSummeryDir = (function (_super) {
                __extends(CourseSummeryDir, _super);
                function CourseSummeryDir(common, breezeService, pulseContext) {
                    var _this = _super.call(this, common, breezeService, pulseContext, CourseSummeryDir.directiveId) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "schedule/idp-course-summary.html";
                    _this.scope = {
                        alertList: "="
                    };
                    _this.link = function (scope, element, attrs, ctrl) {
                        _this.scope = scope;
                        scope.onMakeChangeClick = function () {
                            _this.onMakeChangeClick();
                        };
                    };
                    return _this;
                }
                CourseSummeryDir.prototype.onMakeChangeClick = function () {
                    this.scope.showMakeChange = !this.scope.showMakeChange;
                };
                CourseSummeryDir.directiveId = "idpCourseSummary";
                return CourseSummeryDir;
            }(Pulse.Common.BaseCommon));
            PulsePublic.CourseSummeryDir = CourseSummeryDir;
            Pulse.app.directive(CourseSummeryDir.directiveId, ["common",
                "breezeService",
                "pulseContextService", function (c, b, p) { return new CourseSummeryDir(c, b, p); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var CourseOptionsDir = (function (_super) {
                __extends(CourseOptionsDir, _super);
                function CourseOptionsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "schedule/idp-course-options.html";
                    _this.scope = {
                        session: "<",
                        optionList: "<",
                        orderDetailId: "<",
                        hasOvernight: "<",
                        oppositeAvChartSection: "<",
                        heading: "@",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CourseOptionsDir.CourseOptionsDirCtrl];
                    return _this;
                }
                CourseOptionsDir.directiveId = "idpCourseOptions";
                return CourseOptionsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CourseOptionsDir = CourseOptionsDir;
            (function (CourseOptionsDir) {
                var CourseOptionsDirCtrl = (function (_super) {
                    __extends(CourseOptionsDirCtrl, _super);
                    function CourseOptionsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CourseOptionsDirCtrl.controllerId) || this;
                        _this.isPnlStaffEnabled = false;
                        _this.isPnlStaffOpen = false;
                        $scope.$watch(function (scope) {
                            return _this.optionList;
                        }, function (newVal, oldValue) {
                            _this.filteredOptionList = _this.filterOptions(_this.optionList, false);
                        });
                        return _this;
                    }
                    CourseOptionsDirCtrl.prototype.filterOptions = function (options, isPurchased) {
                        if (isPurchased === void 0) { isPurchased = true; }
                        var results = [];
                        results = results.concat(options.filter(function (o) {
                            return o.isPurchased === isPurchased;
                        }));
                        return results;
                    };
                    CourseOptionsDirCtrl.prototype.getBtnText = function (opt) {
                        var text = "Add";
                        if (!opt.actionStatus) {
                            return DataAccess.Managers.CustomerMgr.OptionActionStatausType.Add;
                        }
                        return DataAccess.Managers.CustomerMgr.OptionActionStatausType[opt.actionStatus];
                    };
                    CourseOptionsDirCtrl.prototype.onOptionClick = function (index, opt) {
                        var _this = this;
                        var ubMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        if (this.filteredOptionList[index].cssClass == "friends") {
                            this.common.$rootScope.$broadcast(Events.ShowGroupWithPopup, {
                                size: '',
                                initDataObj: {
                                    hasOvernight: this.hasOvernight,
                                    orderDetailId: this.orderDetailId,
                                    isVTC: this.session.isVirtualCamp,
                                    maxFriendNumber: this.session.isSquads ? 9 : null,
                                }
                            });
                        }
                        else if (this.filteredOptionList[index].cssClass == "full") {
                            if (ubMgr.hasChangeItems(ubMgr.currentUBSession)) {
                                this.common.showConfirmation("Pending Changes", "You have other pending changes.<br>\n                <br>Click Yes to complete the pending changes in Shopping Cart.\n                <br>Click No to start new Shopping Cart.", function (confirm) {
                                    if (confirm) {
                                        _this.pulseContext.regFlowMgr.goToStepByEnum(DataAccess.Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                                    }
                                    else {
                                        _this.pulseContext.regFlowMgr = null;
                                        _this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.AddNew, _this.orderDetailId, _this.oppositeAvChartSection);
                                    }
                                }, { size: 'md' });
                            }
                            else {
                                this.pulseContext.regFlowMgr = null;
                                this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.AddNew, this.orderDetailId, this.oppositeAvChartSection);
                            }
                        }
                        else {
                            if (ubMgr.hasChangeItems(ubMgr.currentUBSession)) {
                                this.common.showConfirmation("Pending Changes", "You have other pending changes.<br>\n                <br>Click Yes to complete the pending changes in Shopping Cart.\n                <br>Click No to continue with new change.", function (confirm) {
                                    if (confirm) {
                                        _this.pulseContext.regFlowMgr.goToStepByEnum(DataAccess.Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                                    }
                                    else {
                                        _this.common.toggleSpinner(true, null, null, 0);
                                        ubMgr.removeUserBrowsingSession(ubMgr.currentUBSession)
                                            .then(function () {
                                            _this.pulseContext.regFlowMgr = null;
                                            _this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.ChangeOptionsOnly, _this.orderDetailId);
                                        })
                                            .finally(function () {
                                            _this.common.toggleSpinner(false);
                                        });
                                    }
                                }, { size: 'md' });
                            }
                            else {
                                this.pulseContext.regFlowMgr = null;
                                this.pulseContext.customerMgr.goChangeOption(this.orderDetailId, opt.sPD_ID);
                            }
                        }
                    };
                    CourseOptionsDirCtrl.prototype.showOptionInfo = function (index) {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.OptionInfo, this.filteredOptionList[index].name, "spd_" + this.filteredOptionList[index].sPD_ID.toString(), this.orderDetailId + "_" + this.filteredOptionList[index].sPD_ID.toString());
                    };
                    CourseOptionsDirCtrl.controllerId = "CourseOptionsDirCtrl";
                    return CourseOptionsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CourseOptionsDir.CourseOptionsDirCtrl = CourseOptionsDirCtrl;
            })(CourseOptionsDir = PulsePublic.CourseOptionsDir || (PulsePublic.CourseOptionsDir = {}));
            Pulse.app.directive(CourseOptionsDir.directiveId, ["common", function (c) { return new CourseOptionsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var CourseOptionsListDir = (function (_super) {
                __extends(CourseOptionsListDir, _super);
                function CourseOptionsListDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "schedule/idp-course-options-list.html";
                    _this.scope = {
                        session: "<",
                        optionList: "<",
                        orderDetailId: "<",
                        hasOvernight: "<",
                        oppositeAvChartSection: "<",
                        heading: "@",
                        isReadOnly: "<",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        CourseOptionsListDir.CourseOptionsListDirCtrl];
                    return _this;
                }
                CourseOptionsListDir.directiveId = "idpCourseOptionsList";
                return CourseOptionsListDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.CourseOptionsListDir = CourseOptionsListDir;
            (function (CourseOptionsListDir) {
                var CourseOptionsListDirCtrl = (function (_super) {
                    __extends(CourseOptionsListDirCtrl, _super);
                    function CourseOptionsListDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, CourseOptionsListDirCtrl.controllerId) || this;
                        _this.isReadOnly = false;
                        _this.isPnlStaffEnabled = false;
                        _this.isPnlStaffOpen = false;
                        $scope.$watch(function (scope) {
                            return _this.optionList;
                        }, function (newVal, oldValue) {
                            _this.filteredOptionList = _this.filterOptions(_this.optionList, true);
                        });
                        return _this;
                    }
                    CourseOptionsListDirCtrl.prototype.filterOptions = function (options, isPurchased) {
                        if (isPurchased === void 0) { isPurchased = true; }
                        var results = [];
                        results = results.concat(options.filter(function (o) {
                            return o.isPurchased === isPurchased;
                        }));
                        return results;
                    };
                    CourseOptionsListDirCtrl.prototype.getBtnText = function (opt) {
                        var text = "Add";
                        if (!opt.actionStatus) {
                            return DataAccess.Managers.CustomerMgr.OptionActionStatausType[DataAccess.Managers.CustomerMgr.OptionActionStatausType.Add];
                        }
                        switch (opt.actionStatus) {
                            case DataAccess.Managers.CustomerMgr.OptionActionStatausType.SoldOut:
                                return "Sold Out";
                            default:
                                return (opt.actionStatus);
                        }
                    };
                    CourseOptionsListDirCtrl.prototype.onOptionClick = function (index) {
                        var _this = this;
                        var ubMgr = this.pulseContext.regFlowMgr.userBrowsingMgr;
                        if (this.filteredOptionList[index].cssClass == "friends") {
                            this.common.$rootScope.$broadcast(Events.ShowGroupWithPopup, {
                                size: '',
                                initDataObj: {
                                    hasOvernight: this.hasOvernight,
                                    orderDetailId: this.orderDetailId,
                                    isVTC: this.session.isVirtualCamp,
                                    maxFriendNumber: this.session.isSquads ? 9 : null,
                                }
                            });
                        }
                        else if (this.filteredOptionList[index].cssClass == "full") {
                            if (ubMgr.hasChangeItems(ubMgr.currentUBSession)) {
                                this.common.showConfirmation("Pending Changes", "You have other pending changes.<br>\n                <br>Click Yes to complete the pending changes in Shopping Cart.\n                <br>Click No to start new shopping cart.", function (confirm) {
                                    if (confirm) {
                                        _this.pulseContext.regFlowMgr.goToStepByEnum(DataAccess.Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                                    }
                                    else {
                                        _this.pulseContext.regFlowMgr = null;
                                        _this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.AddNew, _this.orderDetailId, _this.oppositeAvChartSection);
                                    }
                                }, { size: 'md' });
                            }
                            else {
                                this.pulseContext.regFlowMgr = null;
                                this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.AddNew, this.orderDetailId, this.oppositeAvChartSection);
                            }
                        }
                        else {
                            if (ubMgr.hasChangeItems(ubMgr.currentUBSession)) {
                                this.common.showConfirmation("Pending Changes", "You have other pending changes.<br>\n                <br>Click Yes to complete the pending changes in Shopping Cart.\n                <br>Click No to start new changes.", function (confirm) {
                                    if (confirm) {
                                        _this.pulseContext.regFlowMgr.goToStepByEnum(DataAccess.Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                                    }
                                    else {
                                        _this.pulseContext.regFlowMgr = null;
                                        _this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.ChangeOptionsOnly, _this.orderDetailId);
                                    }
                                }, { size: 'md' });
                            }
                            else {
                                this.pulseContext.regFlowMgr = null;
                                this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.ChangeOptionsOnly, this.orderDetailId);
                            }
                        }
                    };
                    CourseOptionsListDirCtrl.prototype.showOptionInfo = function (index) {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.OptionInfo, this.filteredOptionList[index].name, "spd_" + this.filteredOptionList[index].sPD_ID.toString(), this.orderDetailId + "_" + this.filteredOptionList[index].sPD_ID.toString());
                    };
                    CourseOptionsListDirCtrl.controllerId = "CourseOptionsListDirCtrl";
                    return CourseOptionsListDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                CourseOptionsListDir.CourseOptionsListDirCtrl = CourseOptionsListDirCtrl;
            })(CourseOptionsListDir = PulsePublic.CourseOptionsListDir || (PulsePublic.CourseOptionsListDir = {}));
            Pulse.app.directive(CourseOptionsListDir.directiveId, ["common", function (c) { return new CourseOptionsListDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var GroupWithPopup = (function (_super) {
                __extends(GroupWithPopup, _super);
                function GroupWithPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        GroupWithPopup.GroupWithPopupCtrl];
                    return _this;
                }
                GroupWithPopup.directiveId = "idpGroupWithPopup";
                return GroupWithPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.GroupWithPopup = GroupWithPopup;
            (function (GroupWithPopup) {
                var EventType = (function (_super) {
                    __extends(EventType, _super);
                    function EventType() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    EventType.AddedRoomWith = "AddedRoomWith";
                    EventType.AddedGroupWith = "AddedGroupWith";
                    return EventType;
                }(Pulse.Common.BasePopup.EventType));
                GroupWithPopup.EventType = EventType;
                var GroupWithPopupCtrl = (function (_super) {
                    __extends(GroupWithPopupCtrl, _super);
                    function GroupWithPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, GroupWithPopupCtrl.controllerId) || this;
                        _this.groupWithList = [];
                        _this.roomWithList = [];
                        _this.submitted = false;
                        _this.addedAdditional = false;
                        _this.saveDisabled = false;
                        _this.formName = "frmGroupWith";
                        _this.checkUnsavedDataBeforeNav = true;
                        _this.checkUnsavedDataBeforeNavOverrideParent = true;
                        _this.event_ShowPopup = Events.ShowGroupWithPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "schedule/idp-group-with-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(GroupWithPopupCtrl.prototype, "browseIdentifier", {
                        get: function () {
                            if (this.initDataObj) {
                                return this.initDataObj.browseIdentifier;
                            }
                            return null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(GroupWithPopupCtrl.prototype, "hasOvernight", {
                        get: function () {
                            if (this.initDataObj) {
                                return this.initDataObj.hasOvernight;
                            }
                            return false;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(GroupWithPopupCtrl.prototype, "orderDetailID", {
                        get: function () {
                            if (this.initDataObj && this.initDataObj.orderDetailId) {
                                return this.initDataObj.orderDetailId;
                            }
                            return -1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(GroupWithPopupCtrl.prototype, "userBrowsingParticipantID", {
                        get: function () {
                            if (this.initDataObj) {
                                return this.initDataObj.userBrowsingParticipantID;
                            }
                            return -1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    GroupWithPopupCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        this.breezeService.getEntityManager().rejectChanges();
                        if (this.initDataObj.userBrowsingParticipantID) {
                            this.activationPromises.push(this.getBuddyListAsUserBrowsingNotes());
                        }
                        else {
                            this.activationPromises.push(this.getBuddyList());
                        }
                        this.isVTC = this.initDataObj.isVTC;
                        this.addedAdditional = false;
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    GroupWithPopupCtrl.prototype.getBuddyList = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        this.breezeService.getEntityManager().rejectChanges();
                        var odbDAO = new DataAccess.OrderDetailBuddyDAO(this.common, this.breezeService, this.pulseContext);
                        this.groupWithList = [];
                        return odbDAO.getByOrderDetailID(this.pulseContext.actingAsUserId, this.orderDetailID)
                            .then(function (buddyList) {
                            _this.buddyList = buddyList;
                            _this.groupWithList = _this.buddyList.filter(function (buddy, index, arr) {
                                return buddy.buddyTypeID == Enums.BuddyType.GroupWith;
                            });
                            if (_this.groupWithList.length == 0) {
                                _this.addGroupWith();
                            }
                            _this.roomWithList = _this.buddyList.filter(function (buddy, index, arr) {
                                return buddy.buddyTypeID == Enums.BuddyType.RoomWith;
                            });
                            if (_this.roomWithList.length == 0) {
                                _this.addRoomWith();
                            }
                        }).catch(function (err) {
                            _this.logError(err);
                            return null;
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    GroupWithPopupCtrl.prototype.getBuddyListAsUserBrowsingNotes = function () {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        this.breezeService.getEntityManager().rejectChanges();
                        var ubnDAO = new Pulse.Common.DataAccess.UserBrowsingNoteDAO(this.common, this.breezeService, this.pulseContext);
                        this.groupWithList = [];
                        return ubnDAO.loadBuddyListFromUserBrowsingNotes(this.groupWithList, this.initDataObj.browseIdentifier, this.initDataObj.userBrowsingParticipantID)
                            .then(function (buddyList) {
                            _this.buddyListAsUserBrowsingNotes = buddyList;
                            if (_this.groupWithList.length == 0) {
                                _this.addGroupWith_UserBrowsingNote();
                            }
                        }).catch(function (err) {
                            _this.logError(err);
                            return null;
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    GroupWithPopupCtrl.prototype.addGroupWith = function ($event) {
                        if ($event === void 0) { $event = null; }
                        if ($event !== null) {
                            $event.preventDefault();
                        }
                        this.addedAdditional = true;
                        if (!this.initDataObj.userBrowsingParticipantID) {
                            var odbDAO = new DataAccess.OrderDetailBuddyDAO(this.common, this.breezeService, this.pulseContext);
                            var newBuddy = odbDAO.Create({
                                buddyTypeID: Enums.BuddyType.GroupWith,
                                orderDetailID: this.orderDetailID,
                            });
                            this.groupWithList.push(newBuddy);
                            this.fireEvent(GroupWithPopup.EventType.AddedGroupWith, newBuddy);
                        }
                        else {
                            this.addGroupWith_UserBrowsingNote();
                        }
                    };
                    GroupWithPopupCtrl.prototype.groupWithFocus = function (idx) {
                        return (this.groupWithList.length - 1) == idx && this.addedAdditional ? "true" : "false";
                    };
                    GroupWithPopupCtrl.prototype.addGroupWith_UserBrowsingNote = function () {
                        var ubnDAO = new DataAccess.UserBrowsingNoteDAO(this.common, this.breezeService, this.pulseContext);
                        var o = ubnDAO.Create({
                            userBrowsingNoteTypeID: Enums.UserBrowsingNoteType.GroupWith,
                            userBrowsingParticipantID: this.initDataObj.userBrowsingParticipantID,
                            note: ''
                        });
                        var newBuddy = Object.assign({}, o);
                        newBuddy.userBrowsingNote = o;
                        newBuddy.firstName = '';
                        newBuddy.lastName = '';
                        this.groupWithList.push(newBuddy);
                        this.fireEvent(GroupWithPopup.EventType.AddedGroupWith, newBuddy);
                    };
                    GroupWithPopupCtrl.prototype.addRoomWith = function () {
                        this.addedAdditional = true;
                        var odbDAO = new DataAccess.OrderDetailBuddyDAO(this.common, this.breezeService, this.pulseContext);
                        var newBuddy = odbDAO.Create({
                            buddyTypeID: Enums.BuddyType.RoomWith,
                            orderDetailID: this.orderDetailID,
                        });
                        this.roomWithList.push(newBuddy);
                        this.fireEvent(GroupWithPopup.EventType.AddedRoomWith, newBuddy);
                    };
                    GroupWithPopupCtrl.prototype.submit = function () {
                        var _this = this;
                        this.submitted = true;
                        this.saveDisabled = true;
                        if (this.myForm.$valid) {
                            this.common.clearStatus();
                            this.common.toggleSpinner(true);
                            if (!this.initDataObj.userBrowsingParticipantID) {
                                var odbDAO_1 = new DataAccess.OrderDetailBuddyDAO(this.common, this.breezeService, this.pulseContext);
                                odbDAO_1.createBuddyList(this.pulseContext.actingAsUserId, this.orderDetailID)
                                    .then(function (saveResult) {
                                    _this.buddyList = odbDAO_1.getFromSaveResult(saveResult);
                                    _this.common.showSuccess(StringConst.Info_SaveSucceeded);
                                    if (_this.initDataObj.afterSaveCallback) {
                                        _this.groupWithList = _this.groupWithList
                                            .filter(function (item) { return !String.isNullOrWhitespace(item.firstName) || !String.isNullOrWhitespace(item.lastName); });
                                        _this.initDataObj.afterSaveCallback(_this.groupWithList);
                                    }
                                    _this.close({});
                                })
                                    .catch(function (err) {
                                    _this.logError(err);
                                    _this.breezeService.getEntityManager().rejectChanges();
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                    _this.saveDisabled = false;
                                });
                            }
                            else {
                                for (var i = 0, il = this.groupWithList.length; i < il; ++i) {
                                    var o = this.groupWithList[i];
                                    if (o.userBrowsingNote) {
                                        o.userBrowsingNote.note = o.lastName + '|' + o.firstName;
                                    }
                                    else {
                                        for (var j = 0, jl = this.buddyListAsUserBrowsingNotes.length; j < jl; ++j) {
                                            var ubn = this.buddyListAsUserBrowsingNotes[j];
                                            if (ubn.userBrowsingNoteID == o.userBrowsingNoteID) {
                                                ubn.note = o.lastName + '|' + o.firstName;
                                            }
                                        }
                                    }
                                }
                                var ubnDAO_1 = new DataAccess.UserBrowsingNoteDAO(this.common, this.breezeService, this.pulseContext);
                                ubnDAO_1.createGroupWithList(this.initDataObj.browseIdentifier, this.initDataObj.userBrowsingParticipantID)
                                    .then(function (saveResult) {
                                    _this.buddyListAsUserBrowsingNotes = ubnDAO_1.getFromSaveResult(saveResult);
                                    _this.common.showSuccess(StringConst.Info_SaveSucceeded);
                                    if (_this.initDataObj.afterSaveCallback) {
                                        _this.groupWithList = _this.groupWithList
                                            .filter(function (item) { return !String.isNullOrWhitespace(item.firstName) || !String.isNullOrWhitespace(item.lastName); });
                                        _this.initDataObj.afterSaveCallback(_this.groupWithList);
                                    }
                                    _this.close({});
                                })
                                    .catch(function (err) {
                                    _this.logError(err);
                                    _this.breezeService.getEntityManager().rejectChanges();
                                })
                                    .finally(function () {
                                    _this.common.toggleSpinner(false);
                                    _this.saveDisabled = false;
                                });
                            }
                        }
                        else {
                        }
                    };
                    GroupWithPopupCtrl.controllerId = "GroupWithPopupCtrl";
                    return GroupWithPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                GroupWithPopup.GroupWithPopupCtrl = GroupWithPopupCtrl;
            })(GroupWithPopup = PulsePublic.GroupWithPopup || (PulsePublic.GroupWithPopup = {}));
            Pulse.app.directive(GroupWithPopup.directiveId, ["common", function (c) { return new GroupWithPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var ChangeCampPopup = (function (_super) {
                __extends(ChangeCampPopup, _super);
                function ChangeCampPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        ChangeCampPopup.ChangeCampPopupCtrl];
                    return _this;
                }
                ChangeCampPopup.directiveId = "idpChangeCampPopup";
                return ChangeCampPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.ChangeCampPopup = ChangeCampPopup;
            (function (ChangeCampPopup) {
                var EventType = (function (_super) {
                    __extends(EventType, _super);
                    function EventType() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    return EventType;
                }(Pulse.Common.BasePopup.EventType));
                ChangeCampPopup.EventType = EventType;
                var ChangeCampPopupCtrl = (function (_super) {
                    __extends(ChangeCampPopupCtrl, _super);
                    function ChangeCampPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, ChangeCampPopupCtrl.controllerId) || this;
                        _this.changeOptions = [ChangeType.Course, ChangeType.Date, ChangeType.Location];
                        _this.saveDisabled = false;
                        _this.continueText = "Continue";
                        _this.formName = "frmChangeCamp";
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.event_ShowPopup = Events.ShowChangeCampPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "schedule/idp-change-camp-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(ChangeCampPopupCtrl.prototype, "orderDetailID", {
                        get: function () {
                            if (this.initDataObj) {
                                return this.initDataObj.session.orderDetailID;
                            }
                            return -1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ChangeCampPopupCtrl.prototype.open = function (size, initDataObj) {
                        var _this = this;
                        this.initDataObj = initDataObj;
                        this.session = initDataObj.session;
                        this.breezeService.getEntityManager().rejectChanges();
                        if (this.session && this.session.orderDetailID) {
                            var self_1 = this;
                            this.activationPromises.push(this.getIfCampAtHQ(this.session.orderDetailID)
                                .then(function () {
                                if (self_1.session.isVirtualCamp) {
                                    if (!_this.pulseContext.isImpersonating) {
                                        _this.changeOptions = _this.changeOptions.filter(function (x) { return x != ChangeType.Location; });
                                    }
                                }
                            }));
                        }
                        else {
                            this.selectedChangeType = this.changeOptions[0];
                        }
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    ChangeCampPopupCtrl.prototype.getIfCampAtHQ = function (orderDetailID) {
                        var _this = this;
                        return this.pulseContext.regFlowMgr.shoppingCartMgr.isOrderDetailCampAtHQ(orderDetailID).then(function (isCampAtHQ) {
                            if (isCampAtHQ && !_this.pulseContext.isImpersonating) {
                                _this.changeOptions = [ChangeType.Course, ChangeType.Date];
                            }
                            else {
                                _this.changeOptions = [ChangeType.Course, ChangeType.Date, ChangeType.Location];
                            }
                        }).finally(function () {
                            _this.selectedChangeType = _this.changeOptions[0];
                        });
                    };
                    ChangeCampPopupCtrl.prototype.selectedChangeTypeChanged = function () {
                        if (this.selectedChangeType == ChangeType.Time) {
                            this.continueText = "See more times";
                        }
                        else {
                            this.continueText = "Continue";
                        }
                    };
                    ChangeCampPopupCtrl.prototype.submit = function () {
                        var _this = this;
                        try {
                            this.submitted = true;
                            this.saveDisabled = true;
                            if (this.myForm.$valid) {
                                this.common.clearStatus();
                                this.pulseContext.regFlowMgr.userBrowsingMgr.setParticipantToMakeChangeFor(this.initDataObj.student.userID);
                                this.pulseContext.regFlowMgr.userBrowsingMgr.setParticipantCurrencyType(this.session.currencyTypeID);
                                if (this.selectedChangeType == ChangeType.Course) {
                                    this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.ChangeCourseSession, this.session.orderDetailID, null, this.session.locationID);
                                }
                                else if (this.selectedChangeType == ChangeType.Location) {
                                    this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.ChangeLocation, this.session.orderDetailID, null, this.session.locationID);
                                }
                                else if (this.selectedChangeType == ChangeType.Date) {
                                    this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.ChangeSessionDate, this.session.orderDetailID, null, this.session.locationID, "")
                                        .then(function () {
                                        _this.common.$rootScope.$broadcast(Events.ShowChangeCampDatePopup, {
                                            initDataObj: {
                                                student: _this.initDataObj.student,
                                                session: _this.session,
                                            }
                                        });
                                        _this.close();
                                    });
                                }
                                else if (this.selectedChangeType == ChangeType.Time) {
                                    this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.ChangeSessionDate, this.session.orderDetailID, null, this.session.locationID, "")
                                        .then(function () {
                                        _this.common.$rootScope.$broadcast(Events.ShowChangeVirtualCampTimePopup, {
                                            initDataObj: {
                                                student: _this.initDataObj.student,
                                                session: _this.session,
                                            }
                                        });
                                        _this.close();
                                    });
                                }
                                else {
                                    throw new Error(StringConst.Err_Not_Supported);
                                }
                            }
                            else {
                            }
                        }
                        finally {
                            this.submitted = false;
                            this.saveDisabled = false;
                        }
                    };
                    ChangeCampPopupCtrl.controllerId = "ChangeCampPopupCtrl";
                    return ChangeCampPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                ChangeCampPopup.ChangeCampPopupCtrl = ChangeCampPopupCtrl;
                var ChangeType;
                (function (ChangeType) {
                    ChangeType["Course"] = "Course";
                    ChangeType["Date"] = "Date/Time";
                    ChangeType["Location"] = "Location";
                    ChangeType["Time"] = "Time";
                })(ChangeType = ChangeCampPopup.ChangeType || (ChangeCampPopup.ChangeType = {}));
            })(ChangeCampPopup = PulsePublic.ChangeCampPopup || (PulsePublic.ChangeCampPopup = {}));
            Pulse.app.directive(ChangeCampPopup.directiveId, ["common", function (c) { return new ChangeCampPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var Managers = Pulse.Common.DataAccess.Managers;
            var OrderMgr = Managers.OrderMgr;
            var RequestVoucherCreditPopup = (function (_super) {
                __extends(RequestVoucherCreditPopup, _super);
                function RequestVoucherCreditPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        RequestVoucherCreditPopup.RequestVoucherCreditPopupCtrl];
                    return _this;
                }
                RequestVoucherCreditPopup.directiveId = "idpRequestVoucherCreditPopup";
                return RequestVoucherCreditPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.RequestVoucherCreditPopup = RequestVoucherCreditPopup;
            (function (RequestVoucherCreditPopup) {
                var RequestVoucherCreditPopupCtrl = (function (_super) {
                    __extends(RequestVoucherCreditPopupCtrl, _super);
                    function RequestVoucherCreditPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, RequestVoucherCreditPopupCtrl.controllerId) || this;
                        _this.saveDisabled = false;
                        _this.formName = "frmRequestVoucherCredit";
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.event_ShowPopup = Events.ShowRequestVoucherCreditPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "schedule/idp-request-voucher-credit-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(RequestVoucherCreditPopupCtrl.prototype, "orderDetailID", {
                        get: function () {
                            if (this.initDataObj) {
                                return this.initDataObj.session.orderDetailID;
                            }
                            return -1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    RequestVoucherCreditPopupCtrl.prototype.open = function (size, initDataObj) {
                        this.initDataObj = initDataObj;
                        this.session = initDataObj.session;
                        this.isResultSuccess = false;
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    RequestVoucherCreditPopupCtrl.prototype.submit = function () {
                        var _this = this;
                        if (!this.initDataObj.session)
                            return;
                        this.common.toggleSpinner(true, null, null, 0);
                        this.submitted = true;
                        this.saveDisabled = true;
                        try {
                            if (this.myForm.$valid) {
                                this.common.clearStatus();
                                var orderMgr = new OrderMgr(this.common, this.breezeService, this.pulseContext);
                                orderMgr.cancelOrderDetail(this.initDataObj.session.orderDetailID, Enums.CancellationReasonType.Covid19)
                                    .then(function (result) {
                                    _this.isResultSuccess = true;
                                    _this.$scope.$emit(Events.VoucherCreditRequested, {
                                        size: '',
                                        initDataObj: {
                                            student: _this.initDataObj.student
                                        }
                                    });
                                }).catch(function (error) {
                                    _this.logError(error);
                                }).finally(function () {
                                    _this.common.toggleSpinner(false);
                                });
                                ;
                            }
                        }
                        finally {
                            this.submitted = false;
                            this.saveDisabled = false;
                        }
                    };
                    RequestVoucherCreditPopupCtrl.prototype.navigateToStatement = function () {
                        _super.prototype.close.call(this);
                        this.$location.url(Routes.Billing_Statements);
                    };
                    RequestVoucherCreditPopupCtrl.controllerId = "RequestVoucherCreditPopupCtrl";
                    return RequestVoucherCreditPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                RequestVoucherCreditPopup.RequestVoucherCreditPopupCtrl = RequestVoucherCreditPopupCtrl;
            })(RequestVoucherCreditPopup = PulsePublic.RequestVoucherCreditPopup || (PulsePublic.RequestVoucherCreditPopup = {}));
            Pulse.app.directive(RequestVoucherCreditPopup.directiveId, ["common", function (c) { return new RequestVoucherCreditPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ChangeCampDatePopup = (function (_super) {
                __extends(ChangeCampDatePopup, _super);
                function ChangeCampDatePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "RegisterFormService",
                        ChangeCampDatePopup.ChangeCampDatePopupCtrl];
                    return _this;
                }
                ChangeCampDatePopup.directiveId = "idpChangeCampDatePopup";
                return ChangeCampDatePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.ChangeCampDatePopup = ChangeCampDatePopup;
            (function (ChangeCampDatePopup) {
                var EventType = (function (_super) {
                    __extends(EventType, _super);
                    function EventType() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    return EventType;
                }(Pulse.Common.BasePopup.EventType));
                ChangeCampDatePopup.EventType = EventType;
                var ChangeCampDatePopupCtrl = (function (_super) {
                    __extends(ChangeCampDatePopupCtrl, _super);
                    function ChangeCampDatePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal, regFormService) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, ChangeCampDatePopupCtrl.controllerId) || this;
                        _this.regFormService = regFormService;
                        _this.allAvailableSessions = [];
                        _this.showConfirmationView = false;
                        _this.WEEK_DAYS = [
                            {
                                id: 0,
                                longName: 'Sunday',
                                shortName: 'Sun'
                            }, {
                                id: 1,
                                longName: 'Monday',
                                shortName: 'Mon'
                            }, {
                                id: 2,
                                longName: 'Tuesday',
                                shortName: 'Tue'
                            }, {
                                id: 3,
                                longName: 'Wednesday',
                                shortName: 'Wed'
                            }, {
                                id: 4,
                                longName: 'Thursday',
                                shortName: 'Thu'
                            }, {
                                id: 5,
                                longName: 'Friday',
                                shortName: 'Fri'
                            }, {
                                id: 6,
                                longName: 'Saturday',
                                shortName: 'Sat'
                            }
                        ];
                        _this.ageIsValid = true;
                        _this.saveDisabled = false;
                        _this.formName = "frmChangeCampDate";
                        _this.event_ShowPopup = Events.ShowChangeCampDatePopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "schedule/idp-change-camp-date-popup.html";
                        $scope.$on(Pulse.Common.BasePopup.EventType.Close, function (event, data) {
                            _this.adminOverridePopupClosed(event, data);
                        });
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(ChangeCampDatePopupCtrl.prototype, "availChartMgr", {
                        get: function () { return this.pulseContext.regFlowMgr.availChartMgr; },
                        enumerable: false,
                        configurable: true
                    });
                    ;
                    Object.defineProperty(ChangeCampDatePopupCtrl.prototype, "userBrowsingMgr", {
                        get: function () { return this.pulseContext.regFlowMgr.userBrowsingMgr; },
                        enumerable: false,
                        configurable: true
                    });
                    ;
                    Object.defineProperty(ChangeCampDatePopupCtrl.prototype, "orderDetailID", {
                        get: function () {
                            if (this.initDataObj) {
                                return this.initDataObj.session.orderDetailID;
                            }
                            return -1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ChangeCampDatePopupCtrl.prototype.open = function (size, initDataObj) {
                        this.showConfirmationView = false;
                        this.initDataObj = initDataObj;
                        this.sessionToChange = initDataObj.session;
                        this.student = initDataObj.student;
                        this.ageIsValid = true;
                        this.title = "" + this.sessionToChange.courseName;
                        this.breezeService.getEntityManager().rejectChanges();
                        this.termDivision = null;
                        this.selectedDay = null;
                        this.allAvailableSessions = [];
                        this.sessions = [];
                        this.activationPromises.push(this.loadChartData());
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    ChangeCampDatePopupCtrl.prototype.close = function (results) {
                        this.initDataObj =
                            this.sessionToChange =
                                this.selectedSession =
                                    this.course =
                                        this.sessions =
                                            this.student = null;
                        this.showConfirmationView = false;
                        _super.prototype.close.call(this, results);
                    };
                    ChangeCampDatePopupCtrl.prototype.loadChartData = function () {
                        var _this = this;
                        this.common.toggleSpinner(true, true, null, 0);
                        return this.availChartMgr.getAvChartData([this.sessionToChange.locationID], true)
                            .then(function (chartDataSet) {
                            _this.termDivision = chartDataSet.filter(function (item) { return item.sessions.some(function (s) { return s.locID === _this.sessionToChange.locationID && s.sessID === _this.sessionToChange.sessionID; }); })[0];
                            _this.termSession = _this.termDivision.sessions.filter(function (s) { return s.locID === _this.sessionToChange.locationID && s.sessID === _this.sessionToChange.sessionID; })[0];
                            _this.course = _this.termDivision.courses.filter(function (item) { return item.sessions.some(function (s) { return s.spdID === _this.sessionToChange.sPD_ID; }); })[0];
                            _this.isVTC = _this.termDivision.divProgramTypeID == Enums.DivisionProgramType.VirtualCamp && _this.termDivision.divDeliveryModelTypeID == Enums.DivisionDeliveryModelType.YouthEducationalServices;
                            _this.isSquads = _this.termDivision.divProgramTypeID == Enums.DivisionProgramType.VirtualCamp && _this.termDivision.divDeliveryModelTypeID == Enums.DivisionDeliveryModelType.AfterSchoolPrograms;
                            _this.sessions = _this.isSquads || _this.isVTC ? [] : _this.course.sessions;
                            _this.getAllAvailableSessions(chartDataSet, _this.course.prodID);
                            return chartDataSet;
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    ChangeCampDatePopupCtrl.prototype.getAllAvailableSessions = function (chartDataSet, prodID) {
                        var _this = this;
                        chartDataSet.forEach(function (data) {
                            data.courses.forEach(function (c) {
                                if (c.prodID == _this.course.prodID) {
                                    c.sessions.forEach(function (s) {
                                        var session = s;
                                        session.termName = String.isNullOrWhitespace(data.shortTermName) ? data.termName : data.shortTermName;
                                        _this.allAvailableSessions.push(session);
                                    });
                                }
                            });
                        });
                        this.allAvailableSessions = _.uniqBy(this.allAvailableSessions, function (s) {
                            return s.locationSessionID;
                        });
                        this.allAvailableSessions = _.sortBy(this.allAvailableSessions, [function (o) { return o.startDate; }]);
                        if (this.isVTC) {
                            this.sessions = angular.copy(this.allAvailableSessions);
                        }
                        var allStartDays = _.uniqBy(this.allAvailableSessions.map(function (s) { return moment(s.startDate).day(); }), function (e) {
                            return e;
                        });
                        this.availableDays = this.WEEK_DAYS.filter(function (wd) { return allStartDays.indexOf(wd.id) >= 0; });
                    };
                    Object.defineProperty(ChangeCampDatePopupCtrl.prototype, "selectedParticipant", {
                        get: function () {
                            var _this = this;
                            return this.userBrowsingMgr.currentUBSession.relatedUB_DTOs.filter(function (p) { return p.userID === _this.student.userID; })[0];
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ChangeCampDatePopupCtrl.prototype.showSession = function (session) {
                        return !(session.statusOptions.id === Enums.SessionAvailabilityStatus.NA
                            || ((session.statusOptions.id === Enums.SessionAvailabilityStatus.Closed
                                || moment(session.startDate).valueOf() < moment(this.pulseContext.serverDateTime).valueOf())
                                && !this.pulseContext.isImpersonating));
                        moment();
                    };
                    ChangeCampDatePopupCtrl.prototype.isSelectable = function (session) {
                        return (this.pulseContext.isImpersonating || session.statusOptions.id !== Enums.SessionAvailabilityStatus.SoldOut)
                            && session.statusOptions.hasUserInteraction
                            && !this.isCurrentlyPurchased(session);
                    };
                    ChangeCampDatePopupCtrl.prototype.showDayIcon = function (session) {
                        return session.isONpackage !== true;
                    };
                    ChangeCampDatePopupCtrl.prototype.showNightIcon = function (session) {
                        var displayNightIcon = false;
                        if (session.isONpackage === true) {
                            displayNightIcon = true;
                        }
                        else {
                            displayNightIcon = session.spdIDON > 0
                                && session.priceWithON > 0
                                && session.optionRestriction !== Enums.OverrideType[Enums.OverrideType.ParticipantTooYoung]
                                && session.optionStatus !== Enums.SessionAvailabilityStatus[Enums.SessionAvailabilityStatus.SoldOut]
                                && (!this.availChartMgr.isSessionClosedForAddingResidency(this.termSession) || this.pulseContext.isImpersonating);
                        }
                        return displayNightIcon;
                    };
                    ChangeCampDatePopupCtrl.prototype.isCurrentlyPurchased = function (session) {
                        return this.sessionToChange.sessionID === session.sessID;
                    };
                    ChangeCampDatePopupCtrl.prototype.isSessionSelected = function (session) {
                        return this.selectedSession === session;
                    };
                    ChangeCampDatePopupCtrl.prototype.onSessionSelect = function (session) {
                        if (this.isSelectable(session)) {
                            this.selectedSession = session;
                            this.myForm.$setPristine();
                        }
                    };
                    ChangeCampDatePopupCtrl.prototype.onChangeCourse = function () {
                        this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.ChangeCourseSession, this.sessionToChange.orderDetailID, null, this.sessionToChange.locationID);
                    };
                    ChangeCampDatePopupCtrl.prototype.getConfirmationMsg = function () {
                        var msg = '';
                        if (this.selectedSession) {
                            msg = this.sessionToChange.courseName + " for ";
                            msg += this.common.$filter('formatSessionDates')(this.selectedSession.startDate, this.selectedSession.endDate, true, true);
                            msg += (this.isVTC || this.isSquads) ? " " + this.selectedSession.termName : '';
                            msg += " has been added to your cart.";
                        }
                        return msg;
                    };
                    ChangeCampDatePopupCtrl.prototype.adminOverridePopupClosed = function (event, data) {
                        var _this = this;
                        if (data && data[0] && data[0].callbackID && data[0].callbackID == this._ageOverrideCallbackID) {
                            this.myForm.$setDirty();
                            var immediateID_1 = this.common.$window.setImmediate(function () {
                                _this.submit();
                                _this.common.$window.clearImmediate(immediateID_1);
                            });
                        }
                    };
                    ChangeCampDatePopupCtrl.prototype.isValid = function () {
                        var _this = this;
                        var defer = this.common.$q.defer();
                        if (!this.selectedSession) {
                            defer.resolve(false);
                            return defer.promise;
                        }
                        this.availChartMgr.getCampProducts(this.termDivision, this.course, this.selectedSession)
                            .then(function (campSessionProducts) {
                            _this.selectedSession.products = campSessionProducts;
                            var products = [campSessionProducts.mainProduct];
                            if (_this.showNightIcon(_this.selectedSession)
                                && _this.sessionToChange.hasOvernight
                                && campSessionProducts.optionProduct) {
                                products = [campSessionProducts.optionProduct];
                            }
                            var overrideReqs = _this.regFormService.getProductAdminOverrideReqs(_this.selectedParticipant, products);
                            if (overrideReqs && overrideReqs.length) {
                                if (_this.pulseContext.canOverrideRegFlowRestrictions) {
                                    _this._ageOverrideCallbackID = _this.userBrowsingMgr.currentUBSession.userBrowsingID
                                        + '_' + _this.selectedParticipant.userID
                                        + '_' + _this.selectedSession.spdID;
                                    _this.common.$rootScope.$broadcast(Events.ShowRegFlowAdminOverridePopup, {
                                        initDataObj: {
                                            callbackID: _this._ageOverrideCallbackID,
                                            overrideReqs: overrideReqs,
                                        },
                                        size: Pulse.Common.BasePopup.ModalSize.Medium,
                                    });
                                }
                                else {
                                    _this.ageIsValid = false;
                                }
                                defer.resolve(false);
                            }
                            else {
                                _this.ageIsValid = true;
                                defer.resolve(true);
                            }
                        });
                        return defer.promise;
                    };
                    ChangeCampDatePopupCtrl.prototype.submit = function () {
                        var _this = this;
                        this.submitted = true;
                        this.saveDisabled = true;
                        this.common.toggleSpinner(true, true, null, 0);
                        if (this.myForm.$valid) {
                            this.isValid()
                                .then(function (isValid) {
                                if (isValid) {
                                    if (!_this.selectedSession.products) {
                                        throw new Error(StringConst.Err_Data_Missing);
                                    }
                                    var mainProduct = _this.selectedSession.products.mainProduct;
                                    var overnightProduct = _this.selectedSession.products.optionProduct;
                                    var productToPurchase = mainProduct;
                                    if (_this.showNightIcon(_this.selectedSession)
                                        && _this.sessionToChange.hasOvernight
                                        && overnightProduct) {
                                        productToPurchase = overnightProduct;
                                    }
                                    var formModel = {
                                        emailAddress: _this.pulseContext.actingAsUser.userName,
                                        options: _this.getPurchasedOptions(_this.sessionToChange, productToPurchase),
                                        participant: _this.selectedParticipant,
                                    };
                                    return _this.regFormService.submitForm(productToPurchase, formModel, mainProduct)
                                        .then(function () {
                                        _this.sessionToChange.hasPendingChanges = true;
                                        _this.showConfirmationView = true;
                                        _this.title = "Change Pending";
                                    });
                                }
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false, true);
                                _this.submitted = false;
                                _this.saveDisabled = false;
                            });
                        }
                        else {
                            this.common.toggleSpinner(false, true);
                            this.submitted = false;
                            this.saveDisabled = false;
                        }
                    };
                    ChangeCampDatePopupCtrl.prototype.onGoCheckout = function () {
                        this.close();
                        this.pulseContext.regFlowMgr.goToStepByEnum(DataAccess.Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                    };
                    ChangeCampDatePopupCtrl.prototype.getPurchasedOptions = function (sessionToChange, productToPurchase) {
                        var purchasedOptions = new Array();
                        productToPurchase.options.forEach(function (opt) {
                            sessionToChange.options.forEach(function (existingOpt) {
                                if (existingOpt.isPurchased) {
                                    var selectOpt = null;
                                    if (existingOpt.productID === opt.prodID
                                        || (existingOpt.productCategory === opt.productCategoryTypeID
                                            && !existingOpt.productSubCategory)
                                        || (existingOpt.productCategory === opt.productCategoryTypeID
                                            && existingOpt.productSubCategory === opt.productSubCatTypeID)) {
                                        purchasedOptions.push(opt);
                                    }
                                }
                            });
                        });
                        return purchasedOptions;
                    };
                    ChangeCampDatePopupCtrl.prototype.selectDay = function (day) {
                        this.selectedDay = day;
                        this.sessions = _.sortBy(this.allAvailableSessions.filter(function (d) { return moment(d.startDate).day() == day.id; }), 'startDate');
                    };
                    ChangeCampDatePopupCtrl.prototype.isSelectedDay = function (day) {
                        return this.selectedDay === day;
                    };
                    ChangeCampDatePopupCtrl.controllerId = "ChangeCampDatePopupCtrl";
                    return ChangeCampDatePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                ChangeCampDatePopup.ChangeCampDatePopupCtrl = ChangeCampDatePopupCtrl;
            })(ChangeCampDatePopup = PulsePublic.ChangeCampDatePopup || (PulsePublic.ChangeCampDatePopup = {}));
            Pulse.app.directive(ChangeCampDatePopup.directiveId, ["common", function (c) { return new ChangeCampDatePopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var ChangeVirtualCampTimePopup = (function (_super) {
                __extends(ChangeVirtualCampTimePopup, _super);
                function ChangeVirtualCampTimePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        "RegisterFormService",
                        "ProductStatusTypeDecorator",
                        ChangeVirtualCampTimePopup.ChangeVirtualCampTimePopupCtrl];
                    return _this;
                }
                ChangeVirtualCampTimePopup.directiveId = "idpChangeVirtualCampTimePopup";
                return ChangeVirtualCampTimePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.ChangeVirtualCampTimePopup = ChangeVirtualCampTimePopup;
            (function (ChangeVirtualCampTimePopup) {
                var EventType = (function (_super) {
                    __extends(EventType, _super);
                    function EventType() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    return EventType;
                }(Pulse.Common.BasePopup.EventType));
                ChangeVirtualCampTimePopup.EventType = EventType;
                var ChangeVirtualCampTimePopupCtrl = (function (_super) {
                    __extends(ChangeVirtualCampTimePopupCtrl, _super);
                    function ChangeVirtualCampTimePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal, regFormService, productStatusTypeDecorator) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, ChangeVirtualCampTimePopupCtrl.controllerId) || this;
                        _this.regFormService = regFormService;
                        _this.productStatusTypeDecorator = productStatusTypeDecorator;
                        _this.sessionProductDetails = [];
                        _this.showConfirmationView = false;
                        _this.saveDisabled = false;
                        _this.formName = "frmChangeCampTime";
                        _this.event_ShowPopup = Events.ShowChangeVirtualCampTimePopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "schedule/idp-change-virtual-camp-time-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(ChangeVirtualCampTimePopupCtrl.prototype, "prodAvailabilityMgr", {
                        get: function () { return this.pulseContext.regFlowMgr.prodAvailabilityMgr; },
                        enumerable: false,
                        configurable: true
                    });
                    ;
                    Object.defineProperty(ChangeVirtualCampTimePopupCtrl.prototype, "userBrowsingMgr", {
                        get: function () { return this.pulseContext.regFlowMgr.userBrowsingMgr; },
                        enumerable: false,
                        configurable: true
                    });
                    ;
                    Object.defineProperty(ChangeVirtualCampTimePopupCtrl.prototype, "orderDetailID", {
                        get: function () {
                            if (this.initDataObj) {
                                return this.initDataObj.session.orderDetailID;
                            }
                            return -1;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ChangeVirtualCampTimePopupCtrl.prototype.open = function (size, initDataObj) {
                        this.showConfirmationView = false;
                        this.initDataObj = initDataObj;
                        this.sessionToChange = initDataObj.session;
                        this.student = initDataObj.student;
                        this.title = "" + this.sessionToChange.courseName;
                        this.breezeService.getEntityManager().rejectChanges();
                        this.activationPromises.push(this.loadProductData());
                        _super.prototype.open.call(this, size, initDataObj);
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.close = function (results) {
                        this.sessionToChange.sessionStart;
                        this.initDataObj =
                            this.sessionToChange =
                                this.selectedSessionProductDetail =
                                    this.sessionProductDetails =
                                        this.student =
                                            this.terms = null;
                        this.showConfirmationView = false;
                        _super.prototype.close.call(this, results);
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.loadProductData = function () {
                        var _this = this;
                        this.common.toggleSpinner(true, true, null, 0);
                        return this.prodAvailabilityMgr.getProductsForVtcTermChange(this.sessionToChange.productID, this.sessionToChange.sessionStart)
                            .then(function (data) {
                            _this.terms = data.terms;
                            _this.sessionProductDetails = data.sessionProductDetails;
                            _this.sessionProductDetails.sort(function (a, b) {
                                return _this.getTerm(a).termSortOrder - _this.getTerm(b).termSortOrder;
                            });
                            return data;
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    Object.defineProperty(ChangeVirtualCampTimePopupCtrl.prototype, "selectedParticipant", {
                        get: function () {
                            var _this = this;
                            return this.userBrowsingMgr.currentUBSession.relatedUB_DTOs.filter(function (p) { return p.userID === _this.student.userID; })[0];
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ChangeVirtualCampTimePopupCtrl.prototype.showSessionProductDetail = function (spd) {
                        return !(spd.programStatusTypeID === Enums.SessionAvailabilityStatus.NA
                            || ((spd.programStatusTypeID === Enums.SessionAvailabilityStatus.Closed
                                || moment(spd.startDate).valueOf() < moment(this.pulseContext.serverDateTime).valueOf())
                                && !this.pulseContext.isImpersonating));
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.isSelectable = function (spd) {
                        return (this.pulseContext.isImpersonating || spd.programStatusTypeID !== Enums.SessionAvailabilityStatus.SoldOut)
                            && this.getStatusOptions(spd).hasUserInteraction
                            && !this.isCurrentlyPurchased(spd);
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.isCurrentlyPurchased = function (spd) {
                        return this.sessionToChange.sPD_ID === spd.sessionProductDetailID;
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.isSelected = function (spd) {
                        return this.selectedSessionProductDetail === spd;
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.onSessionProductDetailSelect = function (spd) {
                        if (this.isSelectable(spd)) {
                            this.selectedSessionProductDetail = spd;
                            this.myForm.$setPristine();
                        }
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.onChangeCourse = function () {
                        this.pulseContext.customerMgr.goChangeCamp(Enums.ChangePurchasedOrderType.ChangeCourseSession, this.sessionToChange.orderDetailID, null, this.sessionToChange.locationID);
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.getConfirmationMsg = function () {
                        var msg = '';
                        if (this.selectedSessionProductDetail) {
                            msg = this.sessionToChange.courseName + " for ";
                            msg += this.getTermName(this.selectedSessionProductDetail);
                            msg += " has been added to your cart.";
                        }
                        return msg;
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.getTerm = function (spd) {
                        return this.terms.filter(function (o) { return o.termID == spd.termID; })[0];
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.getTermName = function (spd) {
                        return this.terms.filter(function (o) { return o.termID == spd.termID; })[0].termName;
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.getStatusOptions = function (spd) {
                        var programStatusTypeID = spd.programStatusTypeID;
                        if (spd.programStatusTypeID === Enums.SessionAvailabilityStatus.SoldOutDesktop
                            || spd.programStatusTypeID === Enums.SessionAvailabilityStatus.SoldOut) {
                            programStatusTypeID = Enums.SessionAvailabilityStatus.SoldOut;
                        }
                        var statuses = Enums.SessionAvailabilityStatus;
                        var propertyName = null;
                        for (var name in statuses) {
                            if (statuses[name] === programStatusTypeID) {
                                propertyName = name;
                            }
                        }
                        var statusOptions = this.productStatusTypeDecorator.programStatuses[propertyName];
                        if (programStatusTypeID == Enums.SessionAvailabilityStatus.SoldOut) {
                            statusOptions = Object.assign({}, statusOptions);
                            statusOptions.htmlClass = Enums.UI.ProgramStatusLabels.Red;
                        }
                        return statusOptions;
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.submit = function () {
                        var _this = this;
                        this.submitted = true;
                        this.saveDisabled = true;
                        this.common.toggleSpinner(true, true, null, 0);
                        if (this.myForm.$valid) {
                            var mainProduct = {};
                            mainProduct.sessionProductDetailID = this.selectedSessionProductDetail.sessionProductDetailID;
                            mainProduct.productID = this.selectedSessionProductDetail.productID;
                            mainProduct.locationID = this.sessionToChange.locationID;
                            mainProduct.sessionID = this.selectedSessionProductDetail.sessionID;
                            var productToPurchase = mainProduct;
                            var formModel = {
                                emailAddress: this.pulseContext.actingAsUser.userName,
                                options: [],
                                participant: this.selectedParticipant,
                            };
                            this.regFormService.submitForm(productToPurchase, formModel, mainProduct)
                                .then(function () {
                                _this.sessionToChange.hasPendingChanges = true;
                                _this.showConfirmationView = true;
                                _this.title = "Change Pending";
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false, true);
                                _this.submitted = false;
                                _this.saveDisabled = false;
                            });
                        }
                        else {
                            this.common.toggleSpinner(false, true);
                            this.submitted = false;
                            this.saveDisabled = false;
                        }
                    };
                    ChangeVirtualCampTimePopupCtrl.prototype.onGoCheckout = function () {
                        this.close();
                        this.pulseContext.regFlowMgr.goToStepByEnum(DataAccess.Managers.RegFlowMgr.RegFlowStepEnum.ShoppingCart);
                    };
                    ChangeVirtualCampTimePopupCtrl.controllerId = "ChangeVirtualCampTimePopupCtrl";
                    return ChangeVirtualCampTimePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                ChangeVirtualCampTimePopup.ChangeVirtualCampTimePopupCtrl = ChangeVirtualCampTimePopupCtrl;
            })(ChangeVirtualCampTimePopup = PulsePublic.ChangeVirtualCampTimePopup || (PulsePublic.ChangeVirtualCampTimePopup = {}));
            Pulse.app.directive(ChangeVirtualCampTimePopup.directiveId, ["common", function (c) { return new ChangeVirtualCampTimePopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var HistorySessionsDir = (function (_super) {
                __extends(HistorySessionsDir, _super);
                function HistorySessionsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = 'E';
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + 'schedule/history/idp-history-sessions.html';
                    _this.scope = {
                        student: '=',
                        sessionList: '='
                    };
                    _this.controller = [
                        '$scope',
                        '$location',
                        'common',
                        'breezeService',
                        'pulseContextService',
                        HistorySessionsDir.HistorySessionsDirCtrl
                    ];
                    return _this;
                }
                HistorySessionsDir.directiveId = 'idpHistorySessions';
                return HistorySessionsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.HistorySessionsDir = HistorySessionsDir;
            (function (HistorySessionsDir) {
                var HistorySessionsDirCtrl = (function (_super) {
                    __extends(HistorySessionsDirCtrl, _super);
                    function HistorySessionsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, HistorySessionsDirCtrl.controllerId) || this;
                        _this.isPnlStaffEnabled = false;
                        _this.isPnlStaffOpen = false;
                        return _this;
                    }
                    HistorySessionsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrls, transclude) {
                        var _this = this;
                        _super.prototype.myPostLink.call(this, scope, element, attrs, ctrls);
                        scope.$watch(function (scope) {
                            return angular.isArray(_this.sessionList) ? _this.sessionList.length : 0;
                        }, function (newVal, oldVal) {
                            angular.forEach(_this.sessionList, function (session) {
                                session.isActive = false;
                            });
                        }, true);
                    };
                    HistorySessionsDirCtrl.prototype.onHeadingClick = function (session) {
                        session.isActive = !session.isActive;
                    };
                    HistorySessionsDirCtrl.prototype.onCloseClick = function (session) {
                        session.isActive = false;
                        this.common.scrollToHash('heading' + session.sessionID);
                    };
                    HistorySessionsDirCtrl.controllerId = 'HistorySessionsDirCtrl';
                    return HistorySessionsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                HistorySessionsDir.HistorySessionsDirCtrl = HistorySessionsDirCtrl;
            })(HistorySessionsDir = PulsePublic.HistorySessionsDir || (PulsePublic.HistorySessionsDir = {}));
            Pulse.app.directive(HistorySessionsDir.directiveId, ['common', function (c) { return new HistorySessionsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var StudentDir = (function (_super) {
                __extends(StudentDir, _super);
                function StudentDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "student-info/idp-si-student.html";
                    _this.scope = {
                        participant: "<",
                        onFormSaveSuccess: "&"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        StudentDir.StudentDirCtrl];
                    return _this;
                }
                StudentDir.directiveId = "idpSiStudent";
                return StudentDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.StudentDir = StudentDir;
            (function (StudentDir) {
                var StudentDirCtrl = (function (_super) {
                    __extends(StudentDirCtrl, _super);
                    function StudentDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, StudentDirCtrl.controllerId) || this;
                        _this.checkUnsavedDataBeforeNav = true;
                        _this.activationPromises.push(_this.pulseContext.lookupInfoMgr.loadChildTypesOfParentTypeId(Enums.ShirtSizeGroupType.Student, Enums.TypeClassType.ShirtSize)
                            .then(function (data) {
                            _this.teeShirtSizeTypes = data;
                        }));
                        _this.activationPromises.push(_this.pulseContext.lookupInfoMgr.loadTypeInfo(Enums.TypeClassType.VIPType)
                            .then(function (data) {
                            _this.VIPTypes = data;
                        }));
                        return _this;
                    }
                    StudentDirCtrl.prototype.$onInit = function () {
                        this.formName = "siStudentForm" + this.participant.userID;
                        this.isTShirtSizeRequired = this.participant.teeShirtSizeTypeID > 0;
                    };
                    StudentDirCtrl.prototype.showNickNameHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Preferred Name", Directives.HelpPopup.HelpTopic.Nickname, "nickNameHelp" + this.participant.userID.toString());
                    };
                    StudentDirCtrl.prototype.showTeeShirtHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Tee Shirt Size", Directives.HelpPopup.HelpTopic.TShirtSize, "teeShirtSizeHelp" + this.participant.userID.toString());
                    };
                    StudentDirCtrl.prototype.save = function () {
                        var _this = this;
                        this.submitted = true;
                        this.common.toggleSpinner(true);
                        this.pulseContext.userMgr.updateRelatedUserForActingUser(this.participant)
                            .then(function (data) {
                            _this.myForm.$setPristine();
                            _this.onFormSaveSuccess();
                            _this.common.showSuccess(StringConst.Info_SaveSucceeded);
                            _this.isTShirtSizeRequired = data.teeShirtSizeTypeID > 0;
                        })
                            .finally(function () {
                            _this.submitted = false;
                            _this.common.toggleSpinner(false);
                        });
                    };
                    StudentDirCtrl.prototype.secureAllFeatures = function () {
                        _super.prototype.secureAllFeatures.call(this);
                        if (this.pulseContext.isImpersonating) {
                            this.canUpdate = this.pulseContext.hasAnyRolesAndLevels(Enums.UserRoleType.ClientServices, Enums.UserRoleType.Administrator, 1, 2);
                        }
                        else {
                            this.canUpdate = Pulse.Common.DataAccess.Managers.UserMgr.LegalGuardianRelationshipTypes.indexOf(this.participant.userRelationTypeID) >= 0;
                        }
                        this.checkUnsavedDataBeforeNav = this.canUpdate;
                    };
                    StudentDirCtrl.controllerId = "StudentDirCtrl";
                    return StudentDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                StudentDir.StudentDirCtrl = StudentDirCtrl;
            })(StudentDir = PulsePublic.StudentDir || (PulsePublic.StudentDir = {}));
            Pulse.app.directive(StudentDir.directiveId, ["common", function (c) { return new StudentDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var PaymentMgr = Pulse.Common.DataAccess.Managers.PaymentMgr;
            var CreditCardPopup = (function (_super) {
                __extends(CreditCardPopup, _super);
                function CreditCardPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        CreditCardPopup.CreditCardPopupCtrl];
                    return _this;
                }
                CreditCardPopup.directiveId = "idpCreditCardPopup";
                return CreditCardPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.CreditCardPopup = CreditCardPopup;
            (function (CreditCardPopup) {
                var CreditCardPopupCtrl = (function (_super) {
                    __extends(CreditCardPopupCtrl, _super);
                    function CreditCardPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, CreditCardPopupCtrl.controllerId) || this;
                        _this._paymentMethodTypes = null;
                        _this._selectedPaymentMethodTypeID = null;
                        _this.submitted = false;
                        _this.saveDisabled = false;
                        _this.formName = "frmCreditCard";
                        _this.event_ShowPopup = Events.ShowCreditCardPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-credit-card-popup.html";
                        _this.imgSrcCreditCards = _this.common.config.appRoot + 'assets/images/credit-cards-icons-new.png';
                        _this.activateController();
                        return _this;
                    }
                    Object.defineProperty(CreditCardPopupCtrl.prototype, "selectedPaymentMethodTypeID", {
                        get: function () {
                            return this._selectedPaymentMethodTypeID;
                        },
                        set: function (typeID) {
                            this._selectedPaymentMethodTypeID = typeID;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    CreditCardPopupCtrl.prototype.close = function () {
                        if (angular.isObject(this.api)) {
                            if (angular.isDefined(this.api.onClose)) {
                                this.api.onClose(this.closedViaCloseBtn);
                            }
                        }
                        _super.prototype.close.call(this);
                    };
                    CreditCardPopupCtrl.prototype.getExpirationMonths = function () {
                        var deferred = this.common.$q.defer();
                        this.expirationMonths = [];
                        this.expirationMonths.push({ id: -1, name: "Exp. Month" });
                        for (var i = 1; i <= 12; i++) {
                            var s = Pulse.Utils.JS.zeroPad(i, 2);
                            this.expirationMonths.push({ id: i, name: s });
                        }
                        if (this.selectedExpMonth == null) {
                            this.selectedExpMonth = this.expirationMonths[0];
                        }
                        deferred.resolve(this.expirationMonths);
                        return deferred.promise;
                    };
                    CreditCardPopupCtrl.prototype.getExpirationYears = function () {
                        var deferred = this.common.$q.defer();
                        this.expirationYears = [];
                        this.expirationYears.push({ id: -1, name: "Exp. Year" });
                        var d = new Date();
                        var startYear = d.getFullYear();
                        for (var i = 0; i < 10; i++) {
                            this.expirationYears.push({ id: (startYear + i), name: (startYear + i) + "" });
                        }
                        if (this.selectedExpYear == null) {
                            this.selectedExpYear = this.expirationYears[0];
                        }
                        deferred.resolve(this.expirationYears);
                        return deferred.promise;
                    };
                    CreditCardPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this._paymentMethodTypes = null;
                        if (initDataObj) {
                            this.initDataObj = initDataObj;
                            if (this.initDataObj.creditCardInfo) {
                                this.creditCardInfo = this.initDataObj.creditCardInfo;
                            }
                            else {
                                this.creditCardInfo = {};
                                this.creditCardInfo.expMonth = -1;
                                this.creditCardInfo.expYear = -1;
                            }
                        }
                        this.closedViaCloseBtn = true;
                        this.selectedExpMonth = null;
                        this.selectedExpYear = null;
                        this.submitted = false;
                        this.breezeService.getEntityManager().rejectChanges();
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        this.getExpirationMonths();
                        this.getExpirationYears();
                        this.setLocalizedTexts();
                    };
                    CreditCardPopupCtrl.prototype.showCreditCardIdHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Credit Card ID", Directives.HelpPopup.HelpTopic.CreditCardIDNumber, "creditCardIDHelp");
                    };
                    CreditCardPopupCtrl.prototype.submit = function () {
                        var _this = this;
                        this.creditCardInfo.expMonth = this.selectedExpMonth.id;
                        this.creditCardInfo.expYear = this.selectedExpYear.id;
                        var currentMonth = new Date().getMonth() + 1;
                        var currentYear = new Date().getFullYear();
                        if (this.creditCardInfo.expYear < currentYear || (this.creditCardInfo.expYear == currentYear && this.creditCardInfo.expMonth < currentMonth)) {
                            this.common.showError("The credit card appears to be expired, please double check the expiration date.", true);
                            return;
                        }
                        this.submitted = true;
                        this.saveDisabled = true;
                        if (this.myForm.$valid) {
                            this.common.clearStatus();
                            this.common.toggleSpinner(true);
                            this.creditCardInfo.userID = this.pulseContext.actingAsUserId;
                            this.creditCardInfo.currencyTypeID = this.initDataObj.currencyTypeID;
                            var paymentMgr = new PaymentMgr(this.common, this.breezeService, this.pulseContext);
                            paymentMgr.changeCreditCard(this.creditCardInfo)
                                .then(function (response) {
                                var self = _this;
                                _this.common.showSuccess("Your credit card information has been saved.");
                                _this.common.$timeout(function () {
                                    var _a;
                                    self.common.$rootScope.$broadcast(Events.CreditCardUpdatedSuccess, (_a = self.initDataObj) === null || _a === void 0 ? void 0 : _a.selectedOrderDetailId);
                                }, 1);
                                _this.closedViaCloseBtn = false;
                                _this.close();
                            })
                                .catch(function (err) {
                                if (err && err.message) {
                                    if (err.isForUser) {
                                        _this.common.showError(err.message, true, { timeOut: 0 });
                                    }
                                    else {
                                        _this.logError(err);
                                    }
                                }
                                else {
                                    _this.logError(err);
                                }
                            })
                                .finally(function () {
                                _this.common.toggleSpinner(false);
                                _this.saveDisabled = false;
                            });
                        }
                        else {
                            var msgBuilder = new Pulse.Utils.HtmlListItemizer();
                            if (this.myForm.creditCardNumber.$error.required) {
                                msgBuilder.add("Credit card number is required.");
                            }
                            if (this.myForm.expMonth.$error.required || this.myForm.expMonth.$viewValue.id == -1) {
                                msgBuilder.add("Expiration month is required.");
                            }
                            if (this.myForm.expYear.$error.required || this.myForm.expYear.$viewValue.id == -1) {
                                msgBuilder.add("Expiration year is required.");
                            }
                            if (this.myForm.creditCardCVV.$error.required) {
                                msgBuilder.add("Credit card Id is required.");
                            }
                            if (this.myForm.postalCode.$error.required) {
                                msgBuilder.add("Zip / postal code is required.");
                            }
                            if (this.myForm.nameOnCard.$error.required) {
                                msgBuilder.add("Name on Card is required.");
                            }
                            this.common.showWarning(msgBuilder.toString());
                            this.saveDisabled = false;
                        }
                    };
                    CreditCardPopupCtrl.controllerId = "CreditCardPopupCtrl";
                    return CreditCardPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                CreditCardPopup.CreditCardPopupCtrl = CreditCardPopupCtrl;
            })(CreditCardPopup = PulsePublic.CreditCardPopup || (PulsePublic.CreditCardPopup = {}));
            Pulse.app.directive(CreditCardPopup.directiveId, ["common", function (c) { return new CreditCardPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var SubscriptionChangePopup = (function (_super) {
                __extends(SubscriptionChangePopup, _super);
                function SubscriptionChangePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        SubscriptionChangePopup.SubscriptionChangePopupCtrl];
                    return _this;
                }
                SubscriptionChangePopup.directiveId = "idpSubscriptionChangePopup";
                return SubscriptionChangePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.SubscriptionChangePopup = SubscriptionChangePopup;
            (function (SubscriptionChangePopup) {
                var SubscriptionChangePopupCtrl = (function (_super) {
                    __extends(SubscriptionChangePopupCtrl, _super);
                    function SubscriptionChangePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, SubscriptionChangePopupCtrl.controllerId) || this;
                        _this.ChangeTypeEnum = ChangeType;
                        _this.pauseDurations = [1, 2, 3];
                        _this.ManagePauseOptionEnum = ManagePauseOption;
                        _this.formName = "frmSubscriptionChange";
                        _this.event_ShowPopup = Events.ShowSubscriptionChangePopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-subscription-change-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    SubscriptionChangePopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        this.parentCtrl = initDataObj.parentCtrl;
                        this.changeType = initDataObj.changeType;
                        this.subscription = initDataObj.subscription;
                        if (this.changeType === SubscriptionChangePopup.ChangeType.ChangePlanStep1) {
                            for (var _i = 0, _a = this.subscription.changeToProdInfo.products; _i < _a.length; _i++) {
                                var prod = _a[_i];
                                if (prod.productID === this.subscription.productID) {
                                    this.currentSub = prod;
                                    break;
                                }
                            }
                        }
                        else if (this.changeType === SubscriptionChangePopup.ChangeType.Pause) {
                            this.selectedDuration = this.pauseDurations[0];
                        }
                        else if (this.changeType === SubscriptionChangePopup.ChangeType.ManageSub) {
                            this.selectedManageOption = ManagePauseOption.ResumeNow;
                        }
                        this.submitted = false;
                    };
                    SubscriptionChangePopupCtrl.prototype.changeTopic = function () {
                        var _this = this;
                        this.isSubmitting = true;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        this.pulseContext.onlinePrivateLessonMgr.changeSubscriptionOnNextRenew(this.subscription.orderDetailID, this.subscription.changeToProdInfo.products[0].productID, true)
                            .then(function (res) {
                            var template = _this.common.$templateCache.get('oplConfirmTopicChanged.html');
                            var formatedExpDate = _this.common.$filter('date')(_this.subscription.expiryDate, 'MMMM d, yyyy');
                            var line1 = _this.subscription.expiryDate ? "As a reminder, on " + formatedExpDate + " your subscription will change to " + _this.subscription.changeToProdInfo.products[0].name + "."
                                : "As a reminder, upon renewal your subscription will change to All Topic Access.";
                            var line2 = _this.subscription.expiryDate ? "You will select a topic when scheduling your lessons."
                                : "You may renew by selecting \"Renew now\" under the subscription details.";
                            template = template.replace("[line1]", line1)
                                .replace("[line2]", line2);
                            _this.common.showMessagePopup("", template, function () {
                            }, {
                                size: 'lg',
                                footerCss: 'justify-content-center',
                            }, 'OK, got it!', 'btn btn-outline-secondary px-8');
                            _this.$scope.$emit(Events.SubscriptionStatusUpdated);
                            _this.close();
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            self.isSubmitting = false;
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SubscriptionChangePopupCtrl.prototype.changeSubscription = function () {
                        var _this = this;
                        this.isSubmitting = true;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        this.pulseContext.onlinePrivateLessonMgr.changeSubscriptionOnNextRenew(this.subscription.orderDetailID, this.selectedNewSub.productID)
                            .then(function (res) {
                            var template = _this.common.$templateCache.get('oplConfirmSubChanged.html');
                            var formatedExpDate = _this.common.$filter('date')(_this.subscription.expiryDate, 'MMMM d, yyyy');
                            var line1 = "Your subscription has been changed from " + _this.currentSub.quantity + " lesson" + (_this.currentSub.quantity > 1 ? 's' : '') + " a month to " + _this.selectedNewSub.quantity + " lesson" + (_this.selectedNewSub.quantity > 1 ? 's' : '') + " a month.";
                            var line2 = _this.subscription.expiryDate ? "Starting on " + formatedExpDate + ", you will be charged " + _this.getPriceLessonsPerMonthStr(_this.selectedNewSub) + "."
                                : "Upon renewal, you will be charged " + _this.getPriceLessonsPerMonthStr(_this.selectedNewSub) + ".";
                            template = template.replace("[line1]", line1)
                                .replace("[line2]", line2);
                            _this.common.showMessagePopup("", template, function () {
                            }, {
                                size: 'lg',
                                footerCss: 'justify-content-center',
                            }, 'OK, got it!', 'btn btn-outline-secondary px-8');
                            _this.$scope.$emit(Events.SubscriptionStatusUpdated);
                            _this.close();
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            self.isSubmitting = false;
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SubscriptionChangePopupCtrl.prototype.pauseSubscription = function () {
                        var _this = this;
                        this.isSubmitting = true;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        this.pulseContext.onlinePrivateLessonMgr.pauseSubscription(this.subscription.orderDetailID, this.selectedDuration)
                            .then(function (nextRenewalDate) {
                            _this.subscription.expiryDate = nextRenewalDate ? moment(nextRenewalDate).toDate() : null;
                            var template = _this.common.$templateCache.get('oplConfirmPause.html');
                            var title = 'Your subscription has been paused.';
                            var formatedDate = _this.common.$filter('date')(nextRenewalDate, 'MMMM d, yyyy');
                            var line1 = "Your subscription will resume on " + formatedDate + ", and your next payment will be processed automatically on that day.";
                            var line2 = "Any unused lessons are saved in \"My Account\" and can be scheduled until their expiration date.<br><br>See you soon!";
                            template = template.replace("[title]", title);
                            template = template.replace("[line1]", line1);
                            template = template.replace("[line2]", line2);
                            _this.common.showMessagePopup("", template, function () {
                            }, {
                                size: 'lg',
                                footerCss: 'justify-content-center',
                            }, 'OK, got it!', 'btn btn-outline-secondary px-8');
                            _this.$scope.$emit(Events.SubscriptionStatusUpdated);
                            _this.close();
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            self.isSubmitting = false;
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SubscriptionChangePopupCtrl.prototype.pauseSubIndefinitely = function () {
                        var _this = this;
                        this.isSubmitting = true;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        this.pulseContext.onlinePrivateLessonMgr.pauseSubscription(this.subscription.orderDetailID, -1)
                            .then(function (nextRenewalDate) {
                            _this.subscription.expiryDate = nextRenewalDate ? moment(nextRenewalDate).toDate() : null;
                            var template = _this.common.$templateCache.get('oplConfirmPause.html');
                            var title = 'The subscription has been paused indefinitely.';
                            var line1 = "The subscription has been paused by the Admin and will remain paused until the customer selects to reactivate.";
                            var line2 = "Any unused lessons are saved in \"My Account\" and can be scheduled until their expiration date.";
                            template = template.replace("[title]", title)
                                .replace("[line1]", line1)
                                .replace("[line2]", line2);
                            _this.common.showMessagePopup("", template, function () {
                            }, {
                                size: 'lg',
                                footerCss: 'justify-content-center',
                            }, 'OK, got it!', 'btn btn-outline-secondary px-8');
                            _this.$scope.$emit(Events.SubscriptionStatusUpdated);
                            _this.close();
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            self.isSubmitting = false;
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SubscriptionChangePopupCtrl.prototype.extendPausedSubscription = function () {
                        var _this = this;
                        this.isSubmitting = true;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        this.pulseContext.onlinePrivateLessonMgr.pauseSubscription(this.subscription.orderDetailID, 1)
                            .then(function (nextRenewalDate) {
                            _this.subscription.expiryDate = nextRenewalDate ? moment(nextRenewalDate).toDate() : null;
                            var template = _this.common.$templateCache.get('oplConfirmPause.html');
                            var title = 'The pause on your subscription has been extended by one month.';
                            var formatedDate = _this.common.$filter('date')(nextRenewalDate, 'MMMM d, yyyy');
                            var line1 = "Your subscription will resume on " + formatedDate + ".";
                            var line2 = "We will process your payment automatically on this date.";
                            template = template.replace("[title]", title);
                            template = template.replace("[line1]", line1);
                            template = template.replace("[line2]", line2);
                            _this.common.showMessagePopup("", template, function () {
                            }, {
                                size: 'lg',
                                footerCss: 'justify-content-center',
                            }, 'OK, got it!', 'btn btn-outline-secondary px-8');
                            _this.$scope.$emit(Events.SubscriptionStatusUpdated);
                            _this.close();
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            self.isSubmitting = false;
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SubscriptionChangePopupCtrl.prototype.cancelSubscription = function () {
                        var _this = this;
                        this.isSubmitting = true;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        this.pulseContext.onlinePrivateLessonMgr.cancelSubscription(this.subscription.orderDetailID)
                            .then(function (res) {
                            var template = _this.common.$templateCache.get('oplConfirmCancel.html');
                            var title = "Your subscription has been canceled.";
                            var line1 = "As a reminder, your monthly subscription for " + _this.subscription.productName + " has been canceled.";
                            var line2 = "Any unused lessons are saved in My Account and can be scheduled until their expiration date.\n                            We hope you will sign up for one of our other topics found in\n                            <a href=\"" + (_this.common.config.WWW_UrlRoot + '/tutoring') + "\" target=\"_blank\" alt='Our Courses' ng-click=\"vm.close()\">Our Courses</a>.";
                            template = template.replace("[title]", title)
                                .replace("[line1]", line1)
                                .replace("[line2]", line2);
                            _this.common.showMessagePopup("", template, function () {
                            }, {
                                size: 'lg',
                                footerCss: 'justify-content-center',
                            }, 'OK, got it!', 'btn btn-outline-secondary px-8');
                            _this.$scope.$emit(Events.SubscriptionStatusUpdated);
                            _this.close();
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            self.isSubmitting = false;
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SubscriptionChangePopupCtrl.prototype.managePausedSub = function () {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (this.selectedManageOption === ManagePauseOption.PauseAnotherMonth) {
                                    this.extendPausedSubscription();
                                    return [2];
                                }
                                this.onRenewSubscriptionNowClick();
                                return [2];
                            });
                        });
                    };
                    SubscriptionChangePopupCtrl.prototype.onRenewSubscriptionNowClick = function () {
                        return __awaiter(this, void 0, void 0, function () {
                            var now;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        now = new Date();
                                        return [4, this.parentCtrl.isCreditCardExpiringBeforeRenewalDate(this.subscription, now)];
                                    case 1:
                                        if (_a.sent()) {
                                            this.parentCtrl.showCreditCardPopup(this.subscription, function () { _this.renewSubscriptionNow(); });
                                        }
                                        else {
                                            this.renewSubscriptionNow();
                                        }
                                        return [2];
                                }
                            });
                        });
                    };
                    SubscriptionChangePopupCtrl.prototype.renewSubscriptionNow = function () {
                        var _this = this;
                        this.isSubmitting = true;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        this.pulseContext.onlinePrivateLessonMgr.renewNowAndPurchaseSubscription(this.subscription.orderDetailID)
                            .then(function (res) {
                            var template = _this.common.$templateCache.get('oplConfirmRenew.html');
                            var formatedDate = _this.common.$filter('date')(_this.getNowDate(), 'MMMM d, yyyy');
                            var title = _this.changeType === ChangeType.ReactivateSub ?
                                "Your subscription has been reactivated."
                                : "Your subscription has been renewed.";
                            var line1 = _this.changeType === ChangeType.ReactivateSub ?
                                "Your subscription will renew today, " + formatedDate + "."
                                : "Your subscription has renewed today, " + formatedDate + ".";
                            var line2 = "Your payment has been processed.";
                            template = template.replace("[title]", title)
                                .replace("[line1]", line1)
                                .replace("[line2]", line2);
                            _this.common.showMessagePopup("", template, function () {
                            }, {
                                size: 'lg',
                                footerCss: 'justify-content-center',
                            }, 'OK, got it!', 'btn btn-outline-secondary px-8');
                            _this.$scope.$emit(Events.SubscriptionStatusUpdated);
                            _this.$scope.$emit(Events.OPLScheduleLessonsUpdated);
                            _this.close();
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            self.isSubmitting = false;
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SubscriptionChangePopupCtrl.prototype.goChangePlan = function () {
                        var _this = this;
                        this.common.$window.setTimeout(function () { _this.parentCtrl.onChangePlanClick(_this.subscription); }, 1);
                        this.close();
                    };
                    SubscriptionChangePopupCtrl.prototype.goChangeTopic = function () {
                        var _this = this;
                        this.common.$window.setTimeout(function () { _this.parentCtrl.onChangeTopicClick(_this.subscription); }, 1);
                        this.close();
                    };
                    SubscriptionChangePopupCtrl.prototype.goPauseSub = function () {
                        var _this = this;
                        this.common.$window.setTimeout(function () { _this.parentCtrl.onPauseSubClick(_this.subscription); }, 1);
                        this.close();
                    };
                    SubscriptionChangePopupCtrl.prototype.goReactivateSub = function () {
                        var _this = this;
                        this.common.$window.setTimeout(function () { _this.parentCtrl.onReactivateSubClick(_this.subscription); }, 1);
                        this.close();
                    };
                    SubscriptionChangePopupCtrl.prototype.goMakePayment = function () {
                        this.$location.url(Routes.Billing_Info);
                        this.close();
                    };
                    SubscriptionChangePopupCtrl.prototype.getTitle = function () {
                        switch (this.changeType) {
                            case ChangeType.ChangeTopic:
                                return "Change your topic";
                            case ChangeType.ChangePlanStep1:
                            case ChangeType.ChangePlanStep2:
                                return "Change your subscription";
                            case ChangeType.Pause:
                                return "Pause your subscription";
                            case ChangeType.CancelActive:
                            case ChangeType.CancelPaused:
                            case ChangeType.CancelSuspended:
                                return "Cancel your subscription";
                            case ChangeType.ManageSub:
                                return "Manage your subscripiton";
                            case ChangeType.RenewSub:
                                return "Renew your subscripiton";
                            case ChangeType.ReactivateSub:
                                return "Reactivate your subscripiton";
                            default:
                                return "";
                        }
                    };
                    SubscriptionChangePopupCtrl.prototype.getCompanyContactInfo = function () {
                        if (!this._contactInfo) {
                            var telFn = this.common.$filter('tel');
                            this._contactInfo = "If you have any questions, call us at " + telFn(this.pulseContext.companyTollFreePhone) + " or " + telFn(this.pulseContext.companyInternationalPhone) + " (international).";
                        }
                        return this._contactInfo;
                    };
                    SubscriptionChangePopupCtrl.prototype.getNowDate = function () {
                        return new Date();
                    };
                    SubscriptionChangePopupCtrl.prototype.getProduct = function () {
                        this.subscription.changeToProdInfo.products[0].locationPrice;
                        return this.subscription.productInfo.products.filter(function (p) { return p.relatedProductTypeID === null; })[0];
                    };
                    SubscriptionChangePopupCtrl.prototype.getPricePerLesson = function (product) {
                        var _a;
                        return (product.locationPrice - ((_a = product.discountValue) !== null && _a !== void 0 ? _a : 0)) / product.quantity;
                    };
                    SubscriptionChangePopupCtrl.prototype.getPricePerMonth = function (product) {
                        var _a;
                        return (product.locationPrice - ((_a = product.discountValue) !== null && _a !== void 0 ? _a : 0));
                    };
                    SubscriptionChangePopupCtrl.prototype.getPercentOff = function (product, allVariantProducts) {
                        var copyVariants = __spreadArrays(allVariantProducts);
                        var highestPriceProdWithoutDisc = copyVariants.sort(function (a, b) {
                            var _a, _b;
                            return ((_a = b.locationPrice / b.quantity) !== null && _a !== void 0 ? _a : 0) - ((_b = a.locationPrice / a.quantity) !== null && _b !== void 0 ? _b : 0);
                        })[0];
                        var highestPrice = highestPriceProdWithoutDisc.locationPrice / highestPriceProdWithoutDisc.quantity;
                        var pricePerLesson = this.getPricePerLesson(product);
                        return Math.floor(100 * ((highestPrice - pricePerLesson) / highestPrice));
                    };
                    SubscriptionChangePopupCtrl.prototype.getPriceLessonsPerMonthStr = function (product) {
                        var amount = this.common.$filter("currency")(this.getPricePerMonth(product), -this.subscription.currencyTypeID, 0);
                        return amount + "/mo for " + product.quantity + " lesson" + (product.quantity > 1 ? 's' : '');
                    };
                    SubscriptionChangePopupCtrl.prototype.isCurrentSub = function (product) {
                        return this.currentSub === product;
                    };
                    SubscriptionChangePopupCtrl.prototype.selectNewSubscription = function (product) {
                        this.selectedNewSub = product;
                        this.changeType = ChangeType.ChangePlanStep2;
                    };
                    SubscriptionChangePopupCtrl.prototype.goToChangeSubStep1 = function () {
                        this.selectedNewSub = null;
                        this.changeType = ChangeType.ChangePlanStep1;
                    };
                    SubscriptionChangePopupCtrl.prototype.getPausedExpectedRenewalDate = function (duration, addMonth) {
                        if (!this.subscription.expiryDate)
                            return null;
                        var renewDate = this.subscription.expiryDate;
                        var month = renewDate.getMonth() + (addMonth ? addMonth : 0);
                        return new Date(renewDate.getFullYear(), month + duration, renewDate.getDate());
                    };
                    SubscriptionChangePopupCtrl.prototype.showSubscriptionPausePopup = function (session) {
                        this.common.$rootScope.$broadcast(Events.ShowSubscriptionPausePopup, {
                            size: 'lg',
                            initDataObj: {
                                studentName: this.subscription.prefOrFirstName,
                                orderDetailId: this.subscription.orderDetailID,
                                courseName: this.subscription.productName,
                                isAutoRenew: this.subscription.isAutoRenew,
                                expiryDate: this.subscription.expiryDate
                            }
                        });
                        this.close();
                    };
                    SubscriptionChangePopupCtrl.controllerId = "SubscriptionChangePopupCtrl";
                    return SubscriptionChangePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                SubscriptionChangePopup.SubscriptionChangePopupCtrl = SubscriptionChangePopupCtrl;
                var ChangeType;
                (function (ChangeType) {
                    ChangeType[ChangeType["ChangeTopic"] = 1] = "ChangeTopic";
                    ChangeType[ChangeType["ChangePlanStep1"] = 2] = "ChangePlanStep1";
                    ChangeType[ChangeType["ChangePlanStep2"] = 3] = "ChangePlanStep2";
                    ChangeType[ChangeType["Pause"] = 4] = "Pause";
                    ChangeType[ChangeType["CancelActive"] = 5] = "CancelActive";
                    ChangeType[ChangeType["CancelPaused"] = 6] = "CancelPaused";
                    ChangeType[ChangeType["CancelSuspended"] = 7] = "CancelSuspended";
                    ChangeType[ChangeType["ManageSub"] = 8] = "ManageSub";
                    ChangeType[ChangeType["RenewSub"] = 9] = "RenewSub";
                    ChangeType[ChangeType["ReactivateSub"] = 10] = "ReactivateSub";
                    ChangeType[ChangeType["SuspendedInfoPopup"] = 11] = "SuspendedInfoPopup";
                })(ChangeType = SubscriptionChangePopup.ChangeType || (SubscriptionChangePopup.ChangeType = {}));
                var ManagePauseOption;
                (function (ManagePauseOption) {
                    ManagePauseOption[ManagePauseOption["ResumeNow"] = 0] = "ResumeNow";
                    ManagePauseOption[ManagePauseOption["PauseAnotherMonth"] = 1] = "PauseAnotherMonth";
                })(ManagePauseOption || (ManagePauseOption = {}));
            })(SubscriptionChangePopup = PulsePublic.SubscriptionChangePopup || (PulsePublic.SubscriptionChangePopup = {}));
            Pulse.app.directive(SubscriptionChangePopup.directiveId, ["common", function (c) { return new SubscriptionChangePopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var SubscriptionPausePopup = (function (_super) {
                __extends(SubscriptionPausePopup, _super);
                function SubscriptionPausePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        SubscriptionPausePopup.SubscriptionPausePopupCtrl];
                    return _this;
                }
                SubscriptionPausePopup.directiveId = "idpSubscriptionPausePopup";
                return SubscriptionPausePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.SubscriptionPausePopup = SubscriptionPausePopup;
            (function (SubscriptionPausePopup) {
                var SubscriptionPausePopupCtrl = (function (_super) {
                    __extends(SubscriptionPausePopupCtrl, _super);
                    function SubscriptionPausePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, SubscriptionPausePopupCtrl.controllerId) || this;
                        _this.formName = "frmSubscriptionPause";
                        _this.event_ShowPopup = Events.ShowSubscriptionPausePopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-subscription-pause-popup.html";
                        _this.pauseDurations = [{ id: 1, length: 1 }, { id: 2, length: 2 }, { id: 3, length: 3 }];
                        _this.activateController();
                        return _this;
                    }
                    SubscriptionPausePopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        this.submitted = false;
                        this.resumeDate = null;
                        this.showConfirmation = false;
                        this.selectedDuration = this.pauseDurations[0];
                    };
                    SubscriptionPausePopupCtrl.prototype.submit = function () {
                        var _this = this;
                        this.isSubmitting = true;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        this.pulseContext.onlinePrivateLessonMgr.pauseSubscription(this.initDataObj.orderDetailId, this.selectedDuration.id)
                            .then(function (res) {
                            self.isSubmitting = false;
                            self.showConfirmation = true;
                            self.resumeDate = res;
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SubscriptionPausePopupCtrl.prototype.isSelectedDuration = function (d) {
                        var _a;
                        return d && d.id == ((_a = this.selectedDuration) === null || _a === void 0 ? void 0 : _a.id);
                    };
                    SubscriptionPausePopupCtrl.prototype.closeAnyNotify = function () {
                        this.$scope.$emit(Events.SubscriptionStatusUpdated);
                        this.close();
                    };
                    SubscriptionPausePopupCtrl.controllerId = "SubscriptionPausePopupCtrl";
                    return SubscriptionPausePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                SubscriptionPausePopup.SubscriptionPausePopupCtrl = SubscriptionPausePopupCtrl;
            })(SubscriptionPausePopup = PulsePublic.SubscriptionPausePopup || (PulsePublic.SubscriptionPausePopup = {}));
            Pulse.app.directive(SubscriptionPausePopup.directiveId, ["common", function (c) { return new SubscriptionPausePopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var SubscriptionCancelPopup = (function (_super) {
                __extends(SubscriptionCancelPopup, _super);
                function SubscriptionCancelPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        SubscriptionCancelPopup.SubscriptionCancelPopupCtrl];
                    return _this;
                }
                SubscriptionCancelPopup.directiveId = "idpSubscriptionCancelPopup";
                return SubscriptionCancelPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.SubscriptionCancelPopup = SubscriptionCancelPopup;
            (function (SubscriptionCancelPopup) {
                var SubscriptionCancelPopupCtrl = (function (_super) {
                    __extends(SubscriptionCancelPopupCtrl, _super);
                    function SubscriptionCancelPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, SubscriptionCancelPopupCtrl.controllerId) || this;
                        _this.formName = "frmSubscriptionCancel";
                        _this.event_ShowPopup = Events.ShowSubscriptionCancelPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "billing/idp-subscription-cancel-popup.html";
                        _this.activateController();
                        return _this;
                    }
                    SubscriptionCancelPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        this.submitted = false;
                    };
                    SubscriptionCancelPopupCtrl.prototype.submit = function () {
                        var _this = this;
                        this.isSubmitting = true;
                        this.common.toggleSpinner(true, null, null, 0);
                        var self = this;
                        this.pulseContext.onlinePrivateLessonMgr.cancelSubscription(this.initDataObj.orderDetailId)
                            .then(function (res) {
                            self.isSubmitting = false;
                            self.close();
                            _this.$scope.$emit(Events.SubscriptionStatusUpdated);
                            self.common.showSuccess("Your subscription has been cancelled.");
                        })
                            .catch(function (error) {
                            _this.logError(error);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SubscriptionCancelPopupCtrl.prototype.showSubscriptionPausePopup = function (session) {
                        this.common.$rootScope.$broadcast(Events.ShowSubscriptionPausePopup, {
                            size: 'lg',
                            initDataObj: {
                                studentName: this.initDataObj.studentName,
                                orderDetailId: this.initDataObj.orderDetailId,
                                courseName: this.initDataObj.courseName,
                                isAutoRenew: this.initDataObj.isAutoRenew,
                                expiryDate: this.initDataObj.expiryDate
                            }
                        });
                        this.close();
                    };
                    SubscriptionCancelPopupCtrl.controllerId = "SubscriptionCancelPopupCtrl";
                    return SubscriptionCancelPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                SubscriptionCancelPopup.SubscriptionCancelPopupCtrl = SubscriptionCancelPopupCtrl;
            })(SubscriptionCancelPopup = PulsePublic.SubscriptionCancelPopup || (PulsePublic.SubscriptionCancelPopup = {}));
            Pulse.app.directive(SubscriptionCancelPopup.directiveId, ["common", function (c) { return new SubscriptionCancelPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var TermsAndConditionsMgr = Pulse.Common.DataAccess.Managers.TermsAndConditionsMgr;
            var PrivacyPolicyPopup = (function (_super) {
                __extends(PrivacyPolicyPopup, _super);
                function PrivacyPolicyPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        PrivacyPolicyPopup.PrivacyPolicyPopupCtrl];
                    return _this;
                }
                PrivacyPolicyPopup.directiveId = "idpPrivacyPolicyPopup";
                return PrivacyPolicyPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.PrivacyPolicyPopup = PrivacyPolicyPopup;
            (function (PrivacyPolicyPopup) {
                var PrivacyPolicyPopupCtrl = (function (_super) {
                    __extends(PrivacyPolicyPopupCtrl, _super);
                    function PrivacyPolicyPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, PrivacyPolicyPopupCtrl.controllerId) || this;
                        _this.event_ShowPopup = Events.ShowPrivacyPolicyPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + Paths.PulsePublicDirective + "privacy-policy/idp-privacy-policy-popup.html";
                        _this.keyboard = false;
                        _this.activationPromises.push(_this.getPrivacyPolicyContent());
                        _this.activateController();
                        return _this;
                    }
                    PrivacyPolicyPopupCtrl.prototype.getPrivacyPolicyContent = function () {
                        var _this = this;
                        var tacMgr = new TermsAndConditionsMgr(this.common, this.breezeService, this.pulseContext);
                        var promise = tacMgr.getPrivacyPolicyContent()
                            .then(function (data) {
                            _this.privacyPolicyContent = (data[0])["data"];
                        }).catch(function (err) {
                            _this.logError(err);
                        })
                            .finally(function () {
                        });
                        return promise;
                    };
                    PrivacyPolicyPopupCtrl.prototype.close = function () {
                        if (angular.isObject(this.api)) {
                            if (angular.isDefined(this.api.onClose)) {
                                this.api.onClose(this.closedViaCloseBtn);
                            }
                        }
                        _super.prototype.close.call(this);
                    };
                    PrivacyPolicyPopupCtrl.prototype.onRendered = function () {
                        _super.prototype.onRendered.call(this);
                    };
                    PrivacyPolicyPopupCtrl.prototype.open = function (size, initDataObj) {
                        _super.prototype.open.call(this, size, initDataObj);
                        this.initDataObj = initDataObj;
                        this.closedViaCloseBtn = true;
                        this.submitted = false;
                        this.breezeService.getEntityManager().rejectChanges();
                        if (this.myForm) {
                            this.myForm.$setPristine();
                        }
                        this.setLocalizedTexts();
                    };
                    PrivacyPolicyPopupCtrl.prototype.scrollToHash = function (region) {
                        this.common.scrollToHash(region);
                    };
                    PrivacyPolicyPopupCtrl.controllerId = "PrivacyPolicyPopupCtrl";
                    return PrivacyPolicyPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                PrivacyPolicyPopup.PrivacyPolicyPopupCtrl = PrivacyPolicyPopupCtrl;
            })(PrivacyPolicyPopup = PulsePublic.PrivacyPolicyPopup || (PulsePublic.PrivacyPolicyPopup = {}));
            Pulse.app.directive(PrivacyPolicyPopup.directiveId, ["common", function (c) { return new PrivacyPolicyPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var SearchMedLogDir = (function (_super) {
                __extends(SearchMedLogDir, _super);
                function SearchMedLogDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + "app/medic/directives/med-log/idm-search-med-log.html";
                    _this.scope = {
                        firstTabIndex: "=",
                        divisionId: "@?",
                        locationId: "@?",
                        sessionId: "@?"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        SearchMedLogDir.SearchMedLogDirCtrl];
                    return _this;
                }
                SearchMedLogDir.directiveId = "idmSearchMedLog";
                return SearchMedLogDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.SearchMedLogDir = SearchMedLogDir;
            (function (SearchMedLogDir) {
                var SearchMedLogDirCtrl = (function (_super) {
                    __extends(SearchMedLogDirCtrl, _super);
                    function SearchMedLogDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SearchMedLogDirCtrl.controllerId) || this;
                        _this.divisions = _this.pulseContext.medicAppMgr.searchFormModel.divisions;
                        _this.selectedDivision = _this.pulseContext.medicAppMgr.searchFormModel.selectedDivision;
                        _this.locations = _this.pulseContext.medicAppMgr.searchFormModel.locations;
                        _this.selectedLocation = _this.pulseContext.medicAppMgr.searchFormModel.selectedLocation;
                        _this.sessions = _this.pulseContext.medicAppMgr.searchFormModel.sessions;
                        _this.selectedSession = _this.pulseContext.medicAppMgr.searchFormModel.selectedSession;
                        _this.courses = _this.pulseContext.medicAppMgr.searchFormModel.courses;
                        _this.selectedCourses = _this.pulseContext.medicAppMgr.searchFormModel.selectedCourses;
                        _this.buildings = _this.pulseContext.medicAppMgr.searchFormModel.buildings;
                        _this.selectedBuildings = _this.pulseContext.medicAppMgr.searchFormModel.selectedBuildings;
                        _this.formStatusOption = _this.pulseContext.medicAppMgr.searchFormModel.formStatusOption;
                        _this.hasMedicationsOption = _this.pulseContext.medicAppMgr.searchFormModel.hasMedicationsOption;
                        _this.participantName = _this.pulseContext.medicAppMgr.searchFormModel.participantName;
                        _this.participants = _this.pulseContext.medicAppMgr.searchFormModel.participants;
                        _this.refreshCache = true;
                        _this.smsCodeActionMedsAddEdit = DataAccess.Managers.MedicAppMgr.SMSCodeAction.MedsAddEdit;
                        _this.smsCodeActionHsfEdit = DataAccess.Managers.MedicAppMgr.SMSCodeAction.HsfEdit;
                        _this.submitted = _this.pulseContext.medicAppMgr.searchFormModel.submitted || false;
                        if (_this.pulseContext.medicAppMgr.isUILocked) {
                            _this.common.$rootScope.$broadcast(Events.ShowMedicAppLockedPopup, {
                                size: '',
                                initDataObj: {}
                            });
                            console.log("UI is locked");
                        }
                        return _this;
                    }
                    SearchMedLogDirCtrl.prototype.$onInit = function () {
                        this.activationPromises.push(this.loadDivisions());
                        this.activateController();
                    };
                    SearchMedLogDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        this.myForm = scope.myForm;
                        if (angular.isObject(this.selectedDivision) && angular.isObject(this.selectedLocation) && angular.isObject(this.selectedSession)) {
                            this.loadParticipants();
                        }
                    };
                    SearchMedLogDirCtrl.prototype.onDestroy = function () {
                        this.pulseContext.medicAppMgr.searchFormModel.divisions = this.divisions;
                        this.pulseContext.medicAppMgr.searchFormModel.selectedDivision = this.selectedDivision;
                        this.pulseContext.medicAppMgr.searchFormModel.locations = this.locations;
                        this.pulseContext.medicAppMgr.searchFormModel.selectedLocation = this.selectedLocation;
                        this.pulseContext.medicAppMgr.searchFormModel.sessions = this.sessions;
                        this.pulseContext.medicAppMgr.searchFormModel.selectedSession = this.selectedSession;
                        this.pulseContext.medicAppMgr.searchFormModel.courses = this.courses;
                        this.pulseContext.medicAppMgr.searchFormModel.selectedCourses = this.selectedCourses;
                        this.pulseContext.medicAppMgr.searchFormModel.buildings = this.buildings;
                        this.pulseContext.medicAppMgr.searchFormModel.selectedBuildings = this.selectedBuildings;
                        this.pulseContext.medicAppMgr.searchFormModel.formStatusOption = this.formStatusOption;
                        this.pulseContext.medicAppMgr.searchFormModel.hasMedicationsOption = this.hasMedicationsOption;
                        this.pulseContext.medicAppMgr.searchFormModel.participantName = this.participantName;
                        this.pulseContext.medicAppMgr.searchFormModel.participants = this.participants;
                        this.pulseContext.medicAppMgr.searchFormModel.submitted = this.submitted;
                    };
                    SearchMedLogDirCtrl.prototype.loadDivisions = function () {
                        var _this = this;
                        var deferred = this.common.$q.defer();
                        this.common.toggleSpinner(true);
                        this.divisions = [];
                        this.pulseContext.medicAppMgr.getDivisionsForLoggedInUser(false, this.refreshCache)
                            .then(function (data) {
                            _this.divisions = data;
                        })
                            .catch(function (err) {
                            deferred.reject(err);
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                            if (+_this.divisionId > 0 && !angular.isObject(_this.selectedDivision)) {
                                _this.selectedDivision = _this.divisions.filter(function (d) { return d.divisionID == _this.divisionId; })[0];
                                if (angular.isObject(_this.selectedDivision))
                                    _this.loadLocations();
                            }
                        });
                        deferred.resolve(this.divisions);
                        return deferred.promise;
                    };
                    SearchMedLogDirCtrl.prototype.loadLocations = function () {
                        var _this = this;
                        var deferred = this.common.$q.defer();
                        this.common.toggleSpinner(true);
                        this.locations = [];
                        this.pulseContext.medicAppMgr.getLocationsForDivision(this.selectedDivision.divisionID, false, this.refreshCache)
                            .then(function (data) {
                            _this.locations = data;
                        })
                            .catch(function (err) {
                            deferred.reject(err);
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                            if (+_this.locationId > 0 && !angular.isObject(_this.selectedLocation)) {
                                _this.selectedLocation = _this.locations.filter(function (d) { return d.locationID == _this.locationId; })[0];
                                if (angular.isObject(_this.selectedLocation))
                                    _this.loadSessions();
                            }
                        });
                        deferred.resolve(this.locations);
                        return deferred.promise;
                    };
                    SearchMedLogDirCtrl.prototype.loadSessions = function () {
                        var _this = this;
                        if (!this.selectedLocation || !this.selectedDivision) {
                            return;
                        }
                        var deferred = this.common.$q.defer();
                        this.common.toggleSpinner(true);
                        this.sessions = [];
                        this.pulseContext.medicAppMgr.getSessionsForLocationAndDivision(this.selectedLocation.locationID, this.selectedDivision.divisionID, this.refreshCache)
                            .then(function (data) {
                            _this.sessions = data;
                            _this.participants = [];
                        })
                            .catch(function (err) {
                            deferred.reject(err);
                            _this.logError(err);
                        })
                            .finally(function () {
                            _this.common.toggleSpinner(false);
                            if (+_this.sessionId > 0 && !angular.isObject(_this.selectedSession)) {
                                _this.selectedSession = _this.sessions.filter(function (d) { return d.sessionID == _this.sessionId; })[0];
                                if (angular.isObject(_this.selectedSession)) {
                                    _this.loadCourses();
                                    _this.loadBuildings();
                                }
                            }
                        });
                        deferred.resolve(this.sessions);
                        return deferred.promise;
                    };
                    SearchMedLogDirCtrl.prototype.loadCourses = function () {
                        var _this = this;
                        var deferred = this.common.$q.defer();
                        this.courses = [];
                        if (!angular.isObject(this.selectedLocation)
                            || !angular.isObject(this.selectedSession)) {
                            deferred.reject();
                            return;
                        }
                        this.common.toggleSpinner(true);
                        this.pulseContext.medicAppMgr.getCoursesForLocationAndSession(this.selectedLocation.locationID, this.selectedSession.sessionID, this.refreshCache)
                            .then(function (data) {
                            _this.courses = data;
                            _this.participants = [];
                        })
                            .catch(function (err) {
                            deferred.reject(err);
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        deferred.resolve(this.courses);
                        return deferred.promise;
                    };
                    SearchMedLogDirCtrl.prototype.loadBuildings = function () {
                        var _this = this;
                        var deferred = this.common.$q.defer();
                        this.buildings = [];
                        if (!angular.isObject(this.selectedDivision)
                            || !angular.isObject(this.selectedLocation)
                            || !angular.isObject(this.selectedSession)) {
                            deferred.reject();
                            return;
                        }
                        this.common.toggleSpinner(true);
                        this.pulseContext.medicAppMgr.getFacilityLabBuildings(this.selectedDivision.divisionID, this.selectedLocation.locationID, this.selectedSession.sessionID, this.refreshCache)
                            .then(function (data) {
                            _this.buildings = data;
                        })
                            .catch(function (err) {
                            deferred.reject(err);
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        deferred.resolve(this.buildings);
                        return deferred.promise;
                    };
                    SearchMedLogDirCtrl.prototype.loadParticipants = function () {
                        var _this = this;
                        if (this.myForm.$invalid) {
                            this.common.showWarning("Please select a Division, Location, and Session.");
                            return;
                        }
                        this.participants = [];
                        this.common.toggleSpinner(true);
                        this.pulseContext.medicAppMgr.currentLocation = this.selectedLocation;
                        this.pulseContext.medicAppMgr.getAllParticipantMedicationRecords(this.selectedDivision.divisionID, this.selectedLocation.locationID, this.selectedSession.sessionID)
                            .then(function (data) {
                            _this.participants = data;
                            _this.submitted = true;
                            _this.refreshCache = false;
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SearchMedLogDirCtrl.prototype.loadMedicationsForParticipant = function (participant) {
                        var _this = this;
                        var deferred = this.common.$q.defer();
                        this.common.toggleSpinner(true);
                        this.pulseContext.medicAppMgr.getParticipantMedications(participant.participantInfo.participantUserID, this.selectedLocation.locationID, this.selectedSession.sessionID)
                            .then(function (data) {
                            participant.medications = data;
                            participant.hasMedications = data.length > 0;
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                        deferred.resolve(participant.medications);
                        return deferred.promise;
                    };
                    SearchMedLogDirCtrl.prototype.makeMedicationChanges = function (participant) {
                        var _this = this;
                        this.pulseContext.medicAppMgr.getMedicationChangesCode(participant.participantInfo.participantUserID, DataAccess.Managers.MedicAppMgr.SMSCodeAction.MedsAddEdit)
                            .then(function (result) {
                            if (result.success) {
                                _this.pulseContext.medicAppMgr.stateBag.isTsMode = true;
                                _this.common.$location.url("/iD/" + result.data[0]);
                            }
                            else {
                                _this.common.showWarning("There was a problem retrieving the information. Please try again.");
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SearchMedLogDirCtrl.prototype.completeCRF = function (participant) {
                        var _this = this;
                        this.pulseContext.medicAppMgr.getMedicationChangesCode(participant.participantInfo.participantUserID, DataAccess.Managers.MedicAppMgr.SMSCodeAction.HsfEdit)
                            .then(function (result) {
                            if (result.success) {
                                _this.pulseContext.medicAppMgr.stateBag.isTsMode = true;
                                _this.common.$location.url("/iD/" + result.data[0]);
                            }
                            else {
                                _this.common.showWarning("There was a problem retrieving the information. Please try again.");
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SearchMedLogDirCtrl.prototype.checkIn = function (participant, med) {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        this.submitted = true;
                        this.pulseContext.medicAppMgr.checkInMedicationForParticipant(participant.participantInfo.participantUserID, med.userFormMedicationID, this.selectedLocation.locationID, this.selectedSession.sessionID)
                            .then(function (result) {
                            if (result[0].status == 200) {
                                _this.common.showSuccess("The medication was checked in.");
                                med.isCheckedIn = true;
                                participant.allMedicationsCheckedIn = _this.participants[_this.participants.indexOf(participant)].medications.every(function (value, index, array) {
                                    return value.isCheckedIn;
                                });
                            }
                            else {
                                _this.common.showWarning("There was a problem checking in the medication. Please try again.");
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                            _this.submitted = false;
                        });
                    };
                    SearchMedLogDirCtrl.prototype.checkOut = function (participant, med) {
                        var _this = this;
                        this.common.toggleSpinner(true);
                        this.pulseContext.medicAppMgr.checkOutMedicationForParticipant(participant.participantInfo.participantUserID, med.userFormMedicationID, this.selectedLocation.locationID, this.selectedSession.sessionID)
                            .then(function (result) {
                            if (result[0].status == 200) {
                                _this.common.showSuccess("The medication was checked out.");
                                med.isCheckedIn = false;
                                participant.allMedicationsCheckedIn = _this.participants[_this.participants.indexOf(participant)].medications.every(function (value, index, array) {
                                    return value.isCheckedIn;
                                });
                            }
                            else {
                                _this.common.showWarning("There was a problem checking out the medication. Please try again.");
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SearchMedLogDirCtrl.prototype.showLinkAndCode = function (participant, action) {
                        var _this = this;
                        this.pulseContext.medicAppMgr.getMedicationChangesCode(participant.participantInfo.participantUserID, action)
                            .then(function (result) {
                            if (result.success) {
                                _this.common.$rootScope.$broadcast(Events.ShowMedicCodePopup, {
                                    size: '',
                                    initDataObj: {
                                        participant: participant,
                                        code: result.data[0],
                                        ttl: result.data[1],
                                        url: result.message,
                                    }
                                });
                            }
                            else {
                                _this.common.showWarning("There was a problem retrieving the information. Please try again.");
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                        });
                    };
                    SearchMedLogDirCtrl.prototype.formatMealOption = function (options) {
                        var best = Math.max.apply(Math, options);
                        if (best == Enums.ProductSubCategoryType.B_L_D
                            || best == Enums.ProductSubCategoryType.Dinner) {
                            return "All Meals Included";
                        }
                        else if (best == Enums.ProductSubCategoryType.Lunch) {
                            return "Lunch Included";
                        }
                        else {
                            return "Bringing Lunch";
                        }
                    };
                    ;
                    SearchMedLogDirCtrl.prototype.showPasswordHelp = function () {
                        this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Password Information", Directives.HelpPopup.HelpTopic.PasswordHelp, "passwordHelp");
                    };
                    SearchMedLogDirCtrl.controllerId = "SearchMedLogDirCtrl";
                    return SearchMedLogDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                SearchMedLogDir.SearchMedLogDirCtrl = SearchMedLogDirCtrl;
            })(SearchMedLogDir = PulsePublic.SearchMedLogDir || (PulsePublic.SearchMedLogDir = {}));
            Pulse.app.directive(SearchMedLogDir.directiveId, ["common", function (c) { return new SearchMedLogDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var SendSmsDir = (function (_super) {
                __extends(SendSmsDir, _super);
                function SendSmsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + "app/medic/directives/sms/idm-send-sms.html";
                    _this.scope = {
                        firstTabIndex: "=",
                        participantId: "@?",
                        action: "@?",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        SendSmsDir.SendSmsDirCtrl];
                    return _this;
                }
                SendSmsDir.directiveId = "idmSendSms";
                return SendSmsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.SendSmsDir = SendSmsDir;
            (function (SendSmsDir) {
                var SendSmsDirCtrl = (function (_super) {
                    __extends(SendSmsDirCtrl, _super);
                    function SendSmsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, SendSmsDirCtrl.controllerId) || this;
                        _this.medsAddEditAction = DataAccess.Managers.MedicAppMgr.SMSCodeAction.MedsAddEdit;
                        _this.hsfEditAction = DataAccess.Managers.MedicAppMgr.SMSCodeAction.HsfEdit;
                        _this.submitted = false;
                        _this.checkUnsavedDataBeforeNav = false;
                        _this.pulseContext.medicAppMgr.lockUI();
                        _this.activateController();
                        return _this;
                    }
                    SendSmsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        this.myForm = scope.myForm;
                    };
                    SendSmsDirCtrl.prototype.submit = function () {
                        var _this = this;
                        if (!angular.isDefined(this.participantId)
                            || !angular.isDefined(this.phoneNumber)
                            || this.myForm.$invalid) {
                            this.common.showWarning("Phone number is not valid.");
                            return;
                        }
                        this.common.toggleSpinner(true);
                        this.submitted = true;
                        this.pulseContext.medicAppMgr.sendMedicationChangesSMS(this.participantId, "+" + this.phoneNumber, this.action)
                            .then(function (result) {
                            if (result.success) {
                                _this.common.$location.url(Routes.MedicSMSSent);
                            }
                            else {
                                _this.common.showWarning("Unable to send text message. Please check the number and try again.");
                            }
                        })
                            .catch(function (err) {
                            _this.logError(err);
                        }).finally(function () {
                            _this.common.toggleSpinner(false);
                            _this.submitted = false;
                        });
                    };
                    SendSmsDirCtrl.controllerId = "SendSmsDirCtrl";
                    return SendSmsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                SendSmsDir.SendSmsDirCtrl = SendSmsDirCtrl;
            })(SendSmsDir = PulsePublic.SendSmsDir || (PulsePublic.SendSmsDir = {}));
            Pulse.app.directive(SendSmsDir.directiveId, ["common", function (c) { return new SendSmsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var DataAccess = Pulse.Common.DataAccess;
            var AuthSmsDir = (function (_super) {
                __extends(AuthSmsDir, _super);
                function AuthSmsDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + "app/medic/directives/sms/idm-auth-sms.html";
                    _this.scope = {
                        firstTabIndex: "=",
                        code: "@?"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        AuthSmsDir.AuthSmsDirCtrl];
                    return _this;
                }
                AuthSmsDir.directiveId = "idmAuthSms";
                return AuthSmsDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.AuthSmsDir = AuthSmsDir;
            (function (AuthSmsDir) {
                var AuthSmsDirCtrl = (function (_super) {
                    __extends(AuthSmsDirCtrl, _super);
                    function AuthSmsDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, AuthSmsDirCtrl.controllerId) || this;
                        _this.submitted = false;
                        _this.pulseContext.medicAppMgr.lockUI();
                        _this.dobMin = moment().endOf('year').subtract(6, 'years').toDate();
                        _this.dobMax = moment().startOf('year').subtract(19, 'years').toDate();
                        if (!_this.pulseContext.medicAppMgr.stateBag.isTsMode) {
                            _this.pulseContext.clearState();
                        }
                        _this.activateController();
                        return _this;
                    }
                    AuthSmsDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        this.myForm = scope.myForm;
                    };
                    AuthSmsDirCtrl.prototype.submit = function () {
                        var _this = this;
                        this.submitted = true;
                        if (this.myForm.$valid && angular.isDefined(this.participantDob) && angular.isDate(this.participantDob)) {
                            this.common.toggleSpinner(true);
                            var parsedDate = moment(this.participantDob).format("MM/DD/YYYY");
                            if (!this.code) {
                                this.code = this.tmpCode;
                            }
                            this.pulseContext.medicAppMgr.getAuthTokenFromSMSCode(this.code, parsedDate, this.pulseContext.medicAppMgr.stateBag.isTsMode || false)
                                .then(function (result) {
                                if (result.success) {
                                    _this.pulseContext.medicAppMgr.stateBag.smsAuthToken = _this.code || _this.tmpCode;
                                    if (_this.pulseContext.medicAppMgr.stateBag.isTsMode) {
                                        var stash = [];
                                        var storageService = _this.common.localStorageService;
                                        var keys = _this.common.localStorageService.keys();
                                        for (var i = 0; i <= keys.length - 1; i++) {
                                            stash.push({ key: keys[i], value: _this.common.localStorageService.get(keys[i]) });
                                        }
                                        _this.common.localStorageService.set(DataAccess.Managers.MedicAppMgr.storageStashId, stash);
                                        if (result.data["action"] == DataAccess.Managers.MedicAppMgr.SMSCodeAction.MedsAddEdit) {
                                            _this.common.$location.url("/medic/participant/edit"
                                                + "/" + result.data["ufdId"]
                                                + "/" + result.data["userId"]
                                                + "/" + result.data["token"]);
                                        }
                                        else if (result.data["action"] == DataAccess.Managers.MedicAppMgr.SMSCodeAction.HsfEdit) {
                                            _this.common.$location.url("/medic/participant/hsf"
                                                + "/" + result.data["ufdId"]
                                                + "/" + result.data["userId"]
                                                + "/" + result.data["token"]);
                                        }
                                        else {
                                            _this.common.showWarning("Server response incorrect. Please retry request. The response message was: " + result.message);
                                        }
                                    }
                                    else {
                                        var _self = _this;
                                        var validationInterval = _this.common.$interval(function () {
                                            _self.pulseContext.medicAppMgr.validateSMSCode(_self.pulseContext.medicAppMgr.stateBag.smsAuthToken)
                                                .then(function (result) {
                                                if (!result.success) {
                                                    _self.common.$interval.cancel(validationInterval);
                                                    _self.common.showWarning("Your session has expired and you have been logged out.");
                                                    _self.common.$location.url(Routes.Logout);
                                                }
                                            })
                                                .catch(function (err) {
                                                _self.logError(err);
                                            }).finally(function () {
                                                _self.common.toggleSpinner(false);
                                            });
                                        }, 60000);
                                        if (result.data["action"] == DataAccess.Managers.MedicAppMgr.SMSCodeAction.MedsAddEdit) {
                                            _this.common.$location.url(Routes.HSF_Medications
                                                + "/?" + QueryStringUtils.USERFORMDETAIL_ID + "=" + result.data["ufdId"]
                                                + "&" + QueryStringUtils.MEDIC_APP_MEDS_ONLY + "=" + "1"
                                                + "&" + QueryStringUtils.MEDIC_APP_MODE + "=" + "1"
                                                + "&" + QueryStringUtils.MEDIC_APP_SMS_CODE + "=" + _this.pulseContext.medicAppMgr.stateBag.smsAuthToken
                                                + "&" + QueryStringUtils.USER_ID + "=" + result.data["userId"]
                                                + "&" + QueryStringUtils.GUID + "=" + result.data["token"]);
                                        }
                                        else if (result.data["action"] == DataAccess.Managers.MedicAppMgr.SMSCodeAction.HsfEdit) {
                                            _this.common.$location.url(Routes.HSF_Welcome
                                                + "/?" + QueryStringUtils.USERFORMDETAIL_ID + "=" + result.data["ufdId"]
                                                + "&" + QueryStringUtils.MEDIC_APP_MEDS_ONLY + "=" + "0"
                                                + "&" + QueryStringUtils.MEDIC_APP_MODE + "=" + "1"
                                                + "&" + QueryStringUtils.MEDIC_APP_SMS_CODE + "=" + _this.pulseContext.medicAppMgr.stateBag.smsAuthToken
                                                + "&" + QueryStringUtils.USER_ID + "=" + result.data["userId"]
                                                + "&" + QueryStringUtils.GUID + "=" + result.data["token"]);
                                        }
                                        else {
                                            _this.common.showWarning("Server response incorrect. Please retry request. The response message was: " + result.message);
                                        }
                                    }
                                }
                                else {
                                    _this.common.showWarning("The information you entered could not be verified.");
                                    if (angular.isDefined(_this.tmpCode) && _this.tmpCode.length > 0) {
                                        _this.code = undefined;
                                    }
                                }
                            })
                                .catch(function (err) {
                                _this.logError(err);
                            }).finally(function () {
                                _this.common.toggleSpinner(false);
                                _this.submitted = false;
                            });
                        }
                        else {
                            var msgBuilder = new Pulse.Utils.HtmlListItemizer();
                            if (this.myForm.code && this.myForm.code.$error.required) {
                                msgBuilder.add("Temporary Code is required.");
                            }
                            if (!angular.isDefined(this.participantDob) || !angular.isDate(this.participantDob)) {
                                msgBuilder.add("Student Birthdate is required.");
                            }
                            if (msgBuilder.length() > 0) {
                                this.common.showWarning(msgBuilder.toString());
                            }
                            this.submitted = false;
                        }
                    };
                    AuthSmsDirCtrl.controllerId = "AuthSmsDirCtrl";
                    return AuthSmsDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                AuthSmsDir.AuthSmsDirCtrl = AuthSmsDirCtrl;
            })(AuthSmsDir = PulsePublic.AuthSmsDir || (PulsePublic.AuthSmsDir = {}));
            Pulse.app.directive(AuthSmsDir.directiveId, ["common", function (c) { return new AuthSmsDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var UiLockedDir = (function (_super) {
                __extends(UiLockedDir, _super);
                function UiLockedDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot + "app/medic/directives/med-ui-lock/idm-ui-unlock.html";
                    _this.scope = {
                        firstTabIndex: "=",
                        locationId: "@?",
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        UiLockedDir.UiLockedDirCtrl];
                    return _this;
                }
                UiLockedDir.directiveId = "idmUiUnlock";
                return UiLockedDir;
            }(Pulse.Common.BaseDirective));
            PulsePublic.UiLockedDir = UiLockedDir;
            (function (UiLockedDir) {
                var UiLockedDirCtrl = (function (_super) {
                    __extends(UiLockedDirCtrl, _super);
                    function UiLockedDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, UiLockedDirCtrl.controllerId) || this;
                        _this.submitted = false;
                        _this.checkUnsavedDataBeforeNav = false;
                        return _this;
                    }
                    UiLockedDirCtrl.prototype.$onInit = function () {
                        this.activateController();
                    };
                    UiLockedDirCtrl.prototype.myPostLink = function (scope, element, attrs, ctrl) {
                        this.myForm = scope.myForm;
                    };
                    UiLockedDirCtrl.prototype.submit = function () {
                        var _this = this;
                        this.submitted = true;
                        this.common.toggleSpinner(true);
                        if (isFinite(+this.passcode)) {
                            this.pulseContext.medicAppMgr.confirmUiUnlockCodeForLocation(this.locationId, +this.passcode)
                                .then(function (result) {
                                if (result.success) {
                                    _this.$location.url(Routes.MedicSearchMedLog);
                                    _this.common.$rootScope.$broadcast(Events.CloseAllPopups);
                                    _this.pulseContext.medicAppMgr.stateBag.isTsMode = false;
                                }
                                else {
                                    _this.common.showWarning("The passcode you entered could not be verified. Please try again.");
                                }
                            })
                                .catch(function (err) {
                                _this.logError(err);
                            }).finally(function () {
                                _this.common.toggleSpinner(false);
                                _this.submitted = false;
                            });
                        }
                        else {
                            this.common.showWarning("The passcode you entered could not be verified. Please try again.");
                            this.common.toggleSpinner(false);
                            this.submitted = false;
                        }
                    };
                    UiLockedDirCtrl.controllerId = "UiLockedDirCtrl";
                    return UiLockedDirCtrl;
                }(Pulse.Common.BaseDirective.BaseDirectiveCtrl));
                UiLockedDir.UiLockedDirCtrl = UiLockedDirCtrl;
            })(UiLockedDir = PulsePublic.UiLockedDir || (PulsePublic.UiLockedDir = {}));
            Pulse.app.directive(UiLockedDir.directiveId, ["common", function (c) { return new UiLockedDir(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var UiLockedPopup = (function (_super) {
                __extends(UiLockedPopup, _super);
                function UiLockedPopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        UiLockedPopup.UiLockedPopupCtrl];
                    return _this;
                }
                UiLockedPopup.directiveId = "idmUiLockedPopup";
                return UiLockedPopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.UiLockedPopup = UiLockedPopup;
            (function (UiLockedPopup) {
                var UiLockedPopupCtrl = (function (_super) {
                    __extends(UiLockedPopupCtrl, _super);
                    function UiLockedPopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, UiLockedPopupCtrl.controllerId) || this;
                        _this.formName = "fromMedicAppLocked";
                        _this.event_ShowPopup = Events.ShowMedicAppLockedPopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + "app/medic/directives/med-ui-lock/idm-ui-locked-popup.html";
                        _this.imgSrcLogo = _this.common.config.appRoot + "assets/images/id-logo.png";
                        _this.keyboard = false;
                        _this.breezeService.getEntityManager().rejectChanges();
                        _this.activateController();
                        return _this;
                    }
                    UiLockedPopupCtrl.controllerId = "UiLockedPopupCtrl";
                    return UiLockedPopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                UiLockedPopup.UiLockedPopupCtrl = UiLockedPopupCtrl;
            })(UiLockedPopup = PulsePublic.UiLockedPopup || (PulsePublic.UiLockedPopup = {}));
            Pulse.app.directive(UiLockedPopup.directiveId, ["common", function (c) { return new UiLockedPopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var CodePopup = (function (_super) {
                __extends(CodePopup, _super);
                function CodePopup(common) {
                    var _this = _super.call(this, common) || this;
                    _this.transclude = false;
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        "$uibModal",
                        CodePopup.CodePopupCtrl];
                    return _this;
                }
                CodePopup.directiveId = "idmCodePopup";
                return CodePopup;
            }(Pulse.Common.BasePopup));
            PulsePublic.CodePopup = CodePopup;
            (function (CodePopup) {
                var CodePopupCtrl = (function (_super) {
                    __extends(CodePopupCtrl, _super);
                    function CodePopupCtrl($scope, $location, common, breezeService, pulseContext, $uibModal) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, $uibModal, CodePopupCtrl.controllerId) || this;
                        _this.formName = "formMedicCode";
                        _this.event_ShowPopup = Events.ShowMedicCodePopup;
                        _this.popupTemplateUrl = _this.common.config.appRoot + "app/medic/directives/sms/idm-code-popup.html";
                        _this.keyboard = false;
                        _this.activateController();
                        return _this;
                    }
                    CodePopupCtrl.controllerId = "CodePopupCtrl";
                    return CodePopupCtrl;
                }(Pulse.Common.BasePopup.BasePopupCtrl));
                CodePopup.CodePopupCtrl = CodePopupCtrl;
            })(CodePopup = PulsePublic.CodePopup || (PulsePublic.CodePopup = {}));
            Pulse.app.directive(CodePopup.directiveId, ["common", function (c) { return new CodePopup(c); }]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Services;
    (function (Services) {
        var AuthInterceptorSvc = (function () {
            function AuthInterceptorSvc($q, $location, localStorageService) {
                var _this = this;
                this.request = function (config) {
                    config.headers = config.headers || {};
                    if (config.url && (Services.BreezeService.isUrlForBreeze(config.url) || config.url.indexOf("/pulseWebApi/") > 0)) {
                        var authData = _this.localStorageService.get(Services.PulseContextService.authDataId);
                        if (authData) {
                            config.headers['Authorization'] = 'Bearer ' + authData.token;
                        }
                    }
                    config.withCredentials = true;
                    return config;
                };
                this.responseError = function (rejection) {
                    if (rejection.status === 401) {
                        _this.localStorageService.set(Services.PulseContextService.authDataId, undefined);
                        _this.$location.path(Routes.Logout);
                    }
                    return _this.$q.reject(rejection);
                };
                this.$q = $q;
                this.$location = $location;
                this.localStorageService = localStorageService;
            }
            AuthInterceptorSvc.serviceId = "authInterceptorSvc";
            return AuthInterceptorSvc;
        }());
        Services.AuthInterceptorSvc = AuthInterceptorSvc;
        Pulse.app.factory(AuthInterceptorSvc.serviceId, ['$q', '$location', 'localStorageService', function (q, l, ls) { return new AuthInterceptorSvc(q, l, ls); }]);
    })(Services = Pulse.Services || (Pulse.Services = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Pulse;
(function (Pulse) {
    var Services;
    (function (Services) {
        var Common = (function () {
            function Common($http, $compile, $q, $rootScope, $window, $location, $timeout, $interval, $filter, $injector, $anchorScroll, localStorageService, config, logger, dialogService, $templateCache) {
                var _this = this;
                this.crossWinMsgrParentTarget = 'ParentPulse1.x';
                this.crossWinMessengerFromParentListener = function (msgObj) {
                    if (angular.isString(msgObj.eventName)) {
                        _this.$rootScope.$broadcast(msgObj.eventName, msgObj);
                    }
                };
                this.$http = $http;
                this.$compile = $compile;
                this.$q = $q;
                this.$rootScope = $rootScope;
                this.$window = $window;
                this.$location = $location;
                this.$timeout = $timeout;
                this.$interval = $interval;
                this.$filter = $filter;
                this.$injector = $injector;
                this.$anchorScroll = $anchorScroll;
                this.localStorageService = localStorageService;
                this.config = config;
                this.logger = logger;
                this.mqInflectionWidth = config.mqInflectionWidth;
                this.dialogService = dialogService;
                this.$templateCache = $templateCache;
                this.debunceDictionary = {};
                this.setDefaultToasterOptions();
                this.determineIsMobileView();
                var w = angular.element($window);
                w.bind('resize', function (e) {
                    _this.debounceAdd('win_resize', function () {
                        _this.determineIsMobileView();
                        _this.$rootScope.$emit(Events.WindowResized, { isMobileView: _this.isMobileView });
                    }, 200);
                });
                this.crossWinMessenger = new Pulse.Utils.CrossWinMessenger({
                    myWindow: window,
                    allowedOrigins: ['*']
                });
                if (window.parent !== window) {
                    this.crossWinMessenger.addTarget(this.crossWinMsgrParentTarget, window.parent, '*', 'pulse1x', this.crossWinMessengerFromParentListener);
                }
            }
            Common.prototype.activateController = function (promises, controllerId) {
                var _this = this;
                return this.$q.all(promises).then(function (resultsArr) {
                    _this.broadcastControllerActivateSuccessEvent(controllerId);
                    _this.logger.logDebug('Activated', null, controllerId, false);
                    return resultsArr;
                });
            };
            Common.prototype.combinePromises = function (promises, loggingId) {
                var _this = this;
                return this.$q.all(promises).then(function (ressultsArr) {
                    _this.logger.logDebug('Resolved promises', null, loggingId, false);
                    return ressultsArr;
                });
            };
            Common.prototype.broadcastControllerActivateSuccessEvent = function (controllerId) {
                this.$rootScope.$broadcast(Events.ControllerActivateSuccess, { controllerId: controllerId });
            };
            Common.prototype.redirectParentWindow = function (url) {
                if (!window.parent || window.parent === window) {
                    this.$window.location.assign(url);
                }
                else {
                    this.triggerEventInParentWindow('fromSPA_redirect', url);
                }
            };
            Common.prototype.updateCSImpersonationHeader = function (actingAsUserID) {
                this.triggerEventInParentWindow('fromSPA_UpdateCSImpersonationHeader', actingAsUserID);
            };
            Common.prototype.updateCSImpersonationShoppingCartCount = function (shoppingCartCount) {
                this.triggerEventInParentWindow('fromSPA_UpdateCSImpersonationShoppingCartCount', shoppingCartCount);
            };
            Common.prototype.triggerEventInParentWindow = function (eventName, arg) {
                if (this.crossWinMessenger.hasTarget(this.crossWinMsgrParentTarget)) {
                    this.crossWinMessenger.sendMsg(this.crossWinMsgrParentTarget, {
                        eventName: eventName,
                        eventArg: arg
                    });
                }
            };
            Common.prototype.clearStatus = function () {
                toastr.clear();
            };
            Common.prototype.createSearchThrottle = function (viewmodel, list, filteredList, filter, delay) {
                var _this = this;
                delay = +delay || 300;
                if (!filteredList) {
                    filteredList = 'filtered' + list[0].toUpperCase() + list.substr(1).toLowerCase();
                    filter = list + 'Filter';
                }
                var filterFn = function () {
                    viewmodel[filteredList] = viewmodel[list].filter(function (item) { return viewmodel[filter](item); });
                };
                return (function () {
                    var filterInputTimeout;
                    return function (searchNow) {
                        if (filterInputTimeout) {
                            _this.$timeout.cancel(filterInputTimeout);
                            filterInputTimeout = null;
                        }
                        if (searchNow || !delay) {
                            filterFn();
                        }
                        else {
                            filterInputTimeout = _this.$timeout(filterFn, delay);
                        }
                    };
                })();
            };
            Common.prototype.debounceAdd = function (key, callback, delay, immediate) {
                var _this = this;
                if (immediate === void 0) { immediate = false; }
                var defaultDelay = 500;
                delay = delay || defaultDelay;
                if (immediate && !this.debunceDictionary[key]) {
                    var promise = this.$timeout(callback, 0);
                    this.debunceDictionary[key] = promise;
                    return promise.then(function (value) {
                        _this.debounceRemove(key);
                        return value;
                    });
                }
                else if (immediate && this.debunceDictionary[key]) {
                    return this.debunceDictionary[key];
                }
                else {
                    this.debounceRemove(key);
                    return this.debunceDictionary[key] = this.$timeout(callback, delay);
                }
            };
            Common.prototype.debounceRemove = function (key) {
                if (this.debunceDictionary[key]) {
                    this.$timeout.cancel(this.debunceDictionary[key]);
                    this.debunceDictionary[key] = undefined;
                }
            };
            Common.prototype.determineIsMobileView = function () {
                if (this.$window.innerWidth <= this.mqInflectionWidth) {
                    this.isMobileView = true;
                }
                else {
                    this.isMobileView = false;
                }
            };
            Common.prototype.isServiceErrorInList = function (err, errorListToCheck) {
                var hasErrorInList = false;
                if (err.hasOwnProperty('error')) {
                    if (errorListToCheck && errorListToCheck.length > 0) {
                        hasErrorInList = errorListToCheck.indexOf(err.error) >= 0;
                        if (hasErrorInList)
                            return true;
                    }
                }
                else if (err.entityErrors) {
                    var errs = err.entityErrors;
                    errs.forEach(function (entityError, i) {
                        if (errorListToCheck && errorListToCheck.length > 0) {
                            hasErrorInList = errorListToCheck.indexOf(entityError.errorName) >= 0;
                            if (hasErrorInList)
                                return true;
                        }
                    });
                }
                return hasErrorInList;
            };
            Common.prototype.logAllErrorTypes = function (err, logId, options, typesOfErrsToShowToUser) {
                var origErr = err;
                var errString = '';
                var forceShowDetails = false;
                var showAsWarning = false;
                if (!typesOfErrsToShowToUser || typesOfErrsToShowToUser.length == 0) {
                    typesOfErrsToShowToUser = typesOfErrsToShowToUser || Array();
                    typesOfErrsToShowToUser.push(PulseErrorTypes.Show_To_User, PulseErrorTypes.OAuth_Invalid_Grant);
                }
                var typesOfWarningsToShowToUser = Array();
                typesOfWarningsToShowToUser.push(PulseErrorTypes.Show_To_User_Warning, PulseErrorTypes.Show_To_User_FriendlyException, PulseErrorTypes.OAuth_Denied);
                if (err == null) {
                    errString = StringConst.Err_Failure_Friendly_Msg;
                    err == new Error('Unknown Error');
                }
                else {
                    err = err.data || err;
                    if (err.hasOwnProperty('exceptionMessage')) {
                        forceShowDetails = typesOfErrsToShowToUser.indexOf(err.exceptionType) >= 0;
                        showAsWarning = typesOfWarningsToShowToUser.indexOf(err.exceptionType) >= 0;
                        errString = err.exceptionMessage;
                    }
                    else if (err.hasOwnProperty('error')) {
                        forceShowDetails = typesOfErrsToShowToUser.indexOf(err.error) >= 0;
                        showAsWarning = typesOfWarningsToShowToUser.indexOf(err.error) >= 0;
                        errString = err.error_description || err.description || err.message;
                    }
                    else if (err.hasOwnProperty('name')) {
                        forceShowDetails = typesOfErrsToShowToUser.indexOf(err.name) >= 0;
                        showAsWarning = typesOfWarningsToShowToUser.indexOf(err.name) >= 0;
                        errString = err.message || err.description;
                    }
                    else if (err.entityErrors) {
                        var errs = err.entityErrors;
                        var msgBuilder_1 = new Pulse.Utils.HtmlListItemizer();
                        errs.forEach(function (entityError, i) {
                            forceShowDetails = typesOfErrsToShowToUser.indexOf(entityError.errorName) >= 0;
                            showAsWarning = typesOfWarningsToShowToUser.indexOf(entityError.errorName) >= 0;
                            msgBuilder_1.add(entityError.errorMessage);
                        });
                        errString = msgBuilder_1.toString();
                    }
                    else if (err.modelState) {
                        var apiErrs_1 = err.modelState;
                        var msgBuilder_2 = new Pulse.Utils.HtmlListItemizer();
                        var arr = Object.keys(apiErrs_1);
                        if (arr.length == 1) {
                            var name_1 = arr[0];
                            if (name_1 == PulseErrorTypes.Show_To_User
                                || name_1 == Pulse.Utils.JS.toCamelCase(PulseErrorTypes.Show_To_User)) {
                                forceShowDetails = true;
                                errString = apiErrs_1[name_1];
                            }
                            else if (name_1 == PulseErrorTypes.Show_To_User_Warning
                                || name_1 == Pulse.Utils.JS.toCamelCase(PulseErrorTypes.Show_To_User_Warning)) {
                                showAsWarning = true;
                                errString = apiErrs_1[name_1];
                            }
                            else {
                                errString = name_1 + ' : ' + apiErrs_1[name_1];
                            }
                        }
                        else {
                            arr.forEach(function (name) {
                                if (name == PulseErrorTypes.Show_To_User
                                    || name == Pulse.Utils.JS.toCamelCase(PulseErrorTypes.Show_To_User)) {
                                    forceShowDetails = true;
                                    msgBuilder_2.add(apiErrs_1[name]);
                                }
                                else if (name == PulseErrorTypes.Show_To_User_Warning
                                    || name == Pulse.Utils.JS.toCamelCase(PulseErrorTypes.Show_To_User_Warning)) {
                                    showAsWarning = true;
                                    msgBuilder_2.add(apiErrs_1[name]);
                                }
                                else {
                                    msgBuilder_2.add(name + ' : ' + apiErrs_1[name]);
                                }
                            });
                            errString = msgBuilder_2.toString();
                        }
                    }
                    else if (err.httpResponse && err.httpResponse.data) {
                        if (err.httpResponse.status == 401) {
                            err = err.httpResponse.data;
                            showAsWarning = true;
                            errString = StringConst.Err_AuthToken_Expired_Or_Unauthorized;
                        }
                        else {
                            errString = err.httpResponse.data.ExceptionMessage || err.message;
                            err = err.httpResponse.data;
                        }
                    }
                    else if (err.hasOwnProperty('message')) {
                        errString = err.message;
                    }
                    else if (err.hasOwnProperty('keys')) {
                        var keys = Object.keys(err);
                        var msgBuilder_3 = new Pulse.Utils.HtmlListItemizer();
                        keys.forEach(function (errorMessage, i) {
                            msgBuilder_3.add(errorMessage);
                        });
                        errString = msgBuilder_3.toString();
                    }
                    else {
                        errString = err;
                        try {
                            throw new Error(errString);
                        }
                        catch (e) {
                            err = e;
                        }
                    }
                }
                if (showAsWarning) {
                    this.showWarning(errString, options);
                }
                else {
                    this.showError(errString, forceShowDetails, options);
                }
                if (!showAsWarning && !forceShowDetails) {
                    this.logger.logError(errString, origErr, logId, false);
                }
            };
            Common.prototype.logTraceToDatabase = function (loggedInUserID, actingAsUserID, moduleName, methodName, severity, subject, details) {
                if (this.config.pulseErrorLogEnabled && (this.config.pulseErrorLogSeverityLevelFilter || 0) >= severity) {
                    var logEntry = {
                        pulseErrorLogID: null,
                        loggedInUserID: loggedInUserID,
                        impersonatedUserID: actingAsUserID,
                        tableTypeID: null,
                        tableKeyID: null,
                        serverName: null,
                        sourceApp: this.config.appName,
                        moduleName: moduleName,
                        methodName: methodName,
                        listenerType: Enums.PulseErrorLogSeverityLevel[severity],
                        subject: Enums.PulseErrorLogSubject[subject],
                        exception: null,
                        stackTrace: details,
                        eventDateTime: new Date(),
                        referrerURL: document.referrer,
                        requestedURL: this.$location.url(),
                        userAgent: navigator.userAgent,
                    };
                    return this.logger.logEntryToDatabase(logEntry);
                }
            };
            Common.prototype.logToDatabase = function (loggedInUserID, actingAsUserID, moduleName, methodName, severity, subject, exception, stackTrace, tableTypeID, tableKeyID) {
                if (this.config.pulseErrorLogEnabled && (this.config.pulseErrorLogSeverityLevelFilter || 0) >= severity) {
                    var logEntry = {
                        pulseErrorLogID: null,
                        loggedInUserID: loggedInUserID,
                        impersonatedUserID: actingAsUserID,
                        tableTypeID: tableTypeID,
                        tableKeyID: tableKeyID,
                        serverName: null,
                        sourceApp: this.config.appName,
                        moduleName: moduleName,
                        methodName: methodName,
                        listenerType: Enums.PulseErrorLogSeverityLevel[severity],
                        subject: Enums.PulseErrorLogSubject[subject],
                        exception: exception,
                        stackTrace: stackTrace,
                        eventDateTime: new Date(),
                        referrerURL: document.referrer,
                        requestedURL: this.$location.url(),
                        userAgent: navigator.userAgent,
                    };
                    return this.logger.logEntryToDatabase(logEntry);
                }
            };
            Common.prototype.scrollToHash = function (hashValue, delay, yOffset, scrollAttemps) {
                var _this = this;
                if (delay === void 0) { delay = 0; }
                if (scrollAttemps === void 0) { scrollAttemps = 5; }
                setTimeout(function () {
                    _this.scrollToHashNoDelay(hashValue, yOffset);
                }, delay);
                if (scrollAttemps > 0) {
                    setTimeout(function () {
                        if (!Pulse.Utils.JS.isElementPartiallyVisibleInViewPort('#' + hashValue, true)) {
                            _this.scrollToHash(hashValue, delay, yOffset, --scrollAttemps);
                        }
                    }, (1000 / scrollAttemps));
                }
            };
            Common.prototype.scrollToHashNoDelay = function (hashValue, yOffset) {
                var oldHash = this.$location.hash();
                if (this.$location.hash() !== hashValue) {
                    this.$location.hash(hashValue);
                }
                if (angular.isNumber(yOffset)) {
                    this.$anchorScroll.yOffset = yOffset;
                }
                this.$anchorScroll();
                this.$location.hash(oldHash);
            };
            Common.prototype.setDefaultToasterOptions = function (options) {
                var defaultOptions = toastr.options;
                defaultOptions.closeButton = true;
                defaultOptions.debug = false;
                defaultOptions.positionClass = 'toast-top-center mt-4';
                defaultOptions.onclick = null;
                defaultOptions.showDuration = 100;
                defaultOptions.hideDuration = 10000;
                defaultOptions.timeOut = 10000;
                defaultOptions.extendedTimeOut = 0;
                defaultOptions.showEasing = 'swing';
                defaultOptions.hideEasing = 'linear';
                defaultOptions.showMethod = 'fadeIn';
                defaultOptions.hideMethod = 'fadeOut';
                defaultOptions.tapToDismiss = true;
                defaultOptions.preventDuplicates = false;
                defaultOptions.progressBar = true;
            };
            Common.prototype.setToasterOptions = function (options) {
                if (options) {
                    angular.extend(toastr.options, options);
                }
                else {
                    this.setDefaultToasterOptions();
                }
            };
            Common.prototype.showError = function (text, forceShowDetails, options) {
                if (forceShowDetails === void 0) { forceShowDetails = false; }
                options = options || { preventDuplicates: true };
                if (angular.isUndefined(options['timeOut']))
                    options['timeOut'] = 15000;
                this.toggleSpinner(false);
                this.setToasterOptions(options);
                if (forceShowDetails || this.config.isDebugMode)
                    toastr.error(text);
                else
                    toastr.error(StringConst.Err_Failure_Friendly_Msg);
            };
            Common.prototype.showConfirmation = function (title, htmlText, callback, opts, confirmBtnText, cancelBtnText, scrollToPopup) {
                if (confirmBtnText === void 0) { confirmBtnText = 'Yes'; }
                if (cancelBtnText === void 0) { cancelBtnText = 'No'; }
                if (scrollToPopup === void 0) { scrollToPopup = true; }
                this.toggleSpinner(false, true);
                if (!opts) {
                    opts = {
                        dialogId: 'popup_confirmation',
                        size: Pulse.Common.BasePopup.ModalSize.Small,
                    };
                }
                this.$rootScope.$broadcast(Events.ShowBasicPopup, {
                    size: opts.size,
                    initDataObj: {
                        popupId: opts.dialogId,
                        scrollToPopupOnOpen: scrollToPopup,
                        title: title,
                        html: htmlText,
                        button1: __assign({ label: confirmBtnText, cbFn: function () { if (callback)
                                callback(true); } }, opts.button1),
                        button2: __assign({ label: cancelBtnText, cbFn: function () { if (callback)
                                callback(false); } }, opts.button2),
                        footerCss: opts.footerCss,
                    },
                });
            };
            Common.prototype.showMessagePopup = function (title, htmlText, callback, opts, btnText, btnClass, scrollToHash, size) {
                if (callback === void 0) { callback = null; }
                if (btnText === void 0) { btnText = 'Ok, got it!'; }
                if (btnClass === void 0) { btnClass = "btn btn-link"; }
                if (scrollToHash === void 0) { scrollToHash = true; }
                if (size === void 0) { size = 'md'; }
                this.toggleSpinner(false, true);
                if (!opts) {
                    opts = {
                        dialogId: 'popup_message',
                        size: size,
                    };
                }
                this.$rootScope.$broadcast(Events.ShowBasicPopup, {
                    size: opts.size,
                    initDataObj: {
                        popupId: opts.dialogId,
                        scrollToPopupOnOpen: scrollToHash,
                        title: title,
                        html: htmlText,
                        button1: {
                            label: btnText,
                            cssClass: btnClass,
                            cbFn: function () { if (callback)
                                callback(); }
                        },
                        button2: {
                            isVisible: false,
                        },
                        footerCss: opts.footerCss,
                    },
                });
            };
            Common.prototype.showHelpPopup = function (helpContentType, helpTitle, helpTopicNameOrHtml, popupParentId, offsetY, size, windowClass) {
                var helpHtml = null;
                var topicName = null;
                if (helpTopicNameOrHtml.match(/\s/g) != null) {
                    helpHtml = helpTopicNameOrHtml;
                }
                else {
                    topicName = helpTopicNameOrHtml;
                    helpHtml = "Loading...";
                }
                var helpParams = {
                    helpContentType: helpContentType,
                    helpHtml: helpHtml,
                    helpTitle: helpTitle,
                    parentId: popupParentId,
                    popupId: 'shellHelpPopup',
                    helpTopicName: topicName,
                    offsetY: offsetY,
                    windowClass: windowClass
                };
                this.$rootScope.$broadcast(Events.ShowHelpPopup, {
                    size: size ? size : Pulse.Common.BasePopup.ModalSize.Medium,
                    initDataObj: helpParams
                });
            };
            Common.prototype.showInfo = function (text, options) {
                this.setToasterOptions(options);
                toastr.info(text);
            };
            Common.prototype.showSuccess = function (text, options) {
                this.setToasterOptions(options);
                toastr.success(text);
            };
            Common.prototype.showWarning = function (text, options) {
                options = options || { preventDuplicates: true };
                this.setToasterOptions(options);
                toastr.warning(text);
            };
            Common.prototype.toggleSpinner = function (show, ignoreCount, opacity, delay, message) {
                if (ignoreCount === void 0) { ignoreCount = false; }
                if (opacity === void 0) { opacity = 0.2; }
                if (delay === void 0) { delay = null; }
                if (message === void 0) { message = 'Loading...'; }
                var bgColor = String.format('rgba(100,100,100, {0})', opacity);
                this.$rootScope.$emit(Events.SpinnerToggle, { show: show, ignoreCount: ignoreCount, style: { 'background-color': bgColor }, delay: delay, message: message });
            };
            Common.serviceId = 'common';
            return Common;
        }());
        Services.Common = Common;
        Pulse.app.factory(Common.serviceId, [
            '$http', '$compile', '$q', '$rootScope', '$window', '$location', '$timeout', '$interval', '$filter', '$injector',
            '$anchorScroll', 'localStorageService', 'config', 'logger', 'dialogs', '$templateCache',
            function ($http, $compile, $q, $rS, $w, $l, $to, $i, $f, $inj, $as, lss, c, l, d, tc) {
                return new Common($http, $compile, $q, $rS, $w, $l, $to, $i, $f, $inj, $as, lss, c, l, d, tc);
            }
        ]);
    })(Services = Pulse.Services || (Pulse.Services = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Services;
    (function (Services) {
        var Logger = (function () {
            function Logger($injector, $log, config) {
                this.$http = null;
                this.service = {
                    getLogFn: this.getLogFn,
                    debug: this.logDebug,
                    log: this.log,
                    logSuccess: this.logSuccess,
                    logInfo: this.logInfo,
                    logWarning: this.logWarning,
                    logError: this.logError,
                };
                this.$injector = $injector;
                this.$log = $log;
                this.config = config;
            }
            Logger.prototype.getLogFn = function (loggingId, logFunctionName) {
                var _this = this;
                logFunctionName = logFunctionName || "log";
                switch (logFunctionName.toLowerCase()) {
                    case "debug":
                        logFunctionName = "logDebug";
                        break;
                    case "info":
                        logFunctionName = "logInfo";
                        break;
                    case "success":
                        logFunctionName = "logSuccess";
                        break;
                    case "error":
                        logFunctionName = "logError";
                        break;
                    case "warn":
                        logFunctionName = "logWarning";
                        break;
                    case "warning":
                        logFunctionName = "logWarning";
                        break;
                    default:
                        logFunctionName = "log";
                        break;
                }
                return function (msg, data, showToast) {
                    _this.logFn = _this.service[logFunctionName] || _this.service.log;
                    _this.logFn(msg, data, loggingId, (showToast === undefined) ? false : showToast);
                };
            };
            Logger.prototype.log = function (message, data, source, showToast) {
                this.logIt(message, data, source, showToast, Logger.LogType.log);
            };
            Logger.prototype.logDebug = function (message, data, source, showToast) {
                if (this.config.isDebugMode) {
                    this.logIt(message, data, source, showToast, Logger.LogType.debug);
                }
            };
            Logger.prototype.logInfo = function (message, data, source, showToast) {
                this.logIt(message, data, source, showToast, Logger.LogType.info);
            };
            Logger.prototype.logWarning = function (message, data, source, showToast) {
                this.logIt(message, data, source, showToast, Logger.LogType.warn);
            };
            Logger.prototype.logSuccess = function (message, data, source, showToast) {
                this.logIt(message, data, source, showToast, Logger.LogType.success);
            };
            Logger.prototype.logError = function (message, data, source, showToast) {
                try {
                    this.logErrorToServer(message, data, source);
                }
                catch (e) {
                    console.error(e);
                    if (this.config.isDebugMode)
                        alert(e);
                }
                try {
                    if (this.config.isDebugMode) {
                        this.logIt(message, data, source, showToast, Logger.LogType.error);
                    }
                    else {
                        this.logIt(StringConst.Err_Failure_Friendly_Msg, null, source, showToast, Logger.LogType.error);
                    }
                }
                catch (e) {
                    console.error(e);
                    if (this.config.isDebugMode)
                        alert(e);
                }
            };
            Logger.prototype.logIt = function (message, data, source, showToast, logType) {
                var write;
                var toasterDisplayFunc = null;
                switch (logType) {
                    case Logger.LogType.debug:
                        write = this.$log.debug;
                        break;
                    case Logger.LogType.info:
                        write = this.$log.info;
                        toasterDisplayFunc = toastr.info;
                        break;
                    case Logger.LogType.success:
                        write = this.$log.info;
                        toasterDisplayFunc = toastr.success;
                        break;
                    case Logger.LogType.warn:
                        write = this.$log.warn;
                        toasterDisplayFunc = toastr.warning;
                        break;
                    case Logger.LogType.error:
                        write = this.$log.error;
                        toasterDisplayFunc = toastr.error;
                        break;
                    default:
                        write = this.$log.log;
                        toasterDisplayFunc = toastr.info;
                }
                source = source ? "[" + source + "] " : "";
                if (data) {
                    write(source, message, data);
                }
                else {
                    write(source, message);
                }
                if (showToast) {
                    toasterDisplayFunc(message);
                }
            };
            Logger.prototype.logErrorToServer = function (message, data, source) {
                if (!this.$http) {
                    this.$http = this.$injector.get("$http");
                }
                var info = {};
                info.browseIdentifier = Services.PulseContextService.browseIdentifier;
                info.errorSource = source;
                info.errorMessage = message;
                info.data = data;
                var url = this.config.webApi_NonBreeze + "/Log_Error";
                var postData = info;
                return this.$http.post(url, angular.toJson(postData, false), { headers: { 'Content-Type': 'application/json' } })
                    .then(function (response) {
                    return null;
                });
            };
            Logger.prototype.logEntryToDatabase = function (logEntry) {
                if (!this.$http) {
                    this.$http = this.$injector.get("$http");
                }
                var url = this.config.webApi_NonBreeze + "/PulseErrorLog_Insert";
                return this.$http.post(url, logEntry, { headers: { 'Content-Type': 'application/json' } })
                    .then(function (response) {
                    return null;
                });
            };
            Logger.serviceId = "logger";
            return Logger;
        }());
        Services.Logger = Logger;
        (function (Logger) {
            var LogType;
            (function (LogType) {
                LogType[LogType["debug"] = 0] = "debug";
                LogType[LogType["log"] = 1] = "log";
                LogType[LogType["success"] = 2] = "success";
                LogType[LogType["info"] = 3] = "info";
                LogType[LogType["warn"] = 4] = "warn";
                LogType[LogType["error"] = 5] = "error";
            })(LogType = Logger.LogType || (Logger.LogType = {}));
        })(Logger = Services.Logger || (Services.Logger = {}));
        Pulse.app.factory(Logger.serviceId, ["$injector", "$log", "config", function ($injector, $log, config) { return new Logger($injector, $log, config); }]);
    })(Services = Pulse.Services || (Pulse.Services = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Services;
    (function (Services) {
        var DCContextType;
        (function (DCContextType) {
            DCContextType[DCContextType["Pulse"] = 0] = "Pulse";
        })(DCContextType = Services.DCContextType || (Services.DCContextType = {}));
        var BreezeService = (function () {
            function BreezeService(breeze, common) {
                var _this = this;
                this.activationPromises = new Array();
                this.resolveActivationPromises = function () {
                    return _this.common.combinePromises(_this.activationPromises, BreezeService.serviceId);
                };
                this.clearActivationPromises = function () {
                    return _this.activationPromises.length = 0;
                };
                this.breeze = breeze;
                this.common = common;
                this.breeze.NamingConvention.camelCase.setAsDefault();
                this.breeze.DataType.parseDateFromServer = function (source) {
                    return moment(source).toDate();
                };
                var o = new this.breeze.ValidationOptions({ validateOnAttach: false }).setAsDefault();
                this.setDCContextType(DCContextType.Pulse);
            }
            BreezeService.isUrlForBreeze = function (url) {
                if (url && url.indexOf(BreezeService.DCPulseServicePath) > 0)
                    return true;
            };
            BreezeService.prototype.getDCContextType = function () {
                return this.dcContextType;
            };
            BreezeService.prototype.getDCPulseManager = function () {
                if (this.DCPulseManager == null) {
                    var dataService = new this.breeze.DataService({
                        serviceName: this.common.config.webApi_UrlRoot + BreezeService.DCPulseServicePath,
                        hasServerMetadata: false
                    });
                    this.DCPulseMetadataStore = new this.breeze.MetadataStore();
                    this.DCPulseMetadataStore.importMetadata(window.Pulse.metadata);
                    this.DCPulseManager = new this.breeze.EntityManager({
                        dataService: dataService,
                        metadataStore: this.DCPulseMetadataStore
                    });
                }
                return this.DCPulseManager;
            };
            BreezeService.prototype.getEntityManager = function () {
                switch (this.getDCContextType()) {
                    case DCContextType.Pulse:
                        return this.getDCPulseManager();
                    default:
                        alert("dcContextType is invalid");
                        return null;
                }
            };
            BreezeService.prototype.setDCContextType = function (dcContextType) {
                this.dcContextType = dcContextType;
                this.DCPulseManager = null;
                this.DCPulseMetadataStore = null;
                this.initDCContext();
            };
            BreezeService.prototype.initDCContext = function () {
            };
            BreezeService.prototype.saveChanges = function (entities, config, callback, errorCallback) {
                var entityMgr = this.getEntityManager();
                if (config) {
                    entityMgr.saveOptions.using(config);
                }
                return entityMgr.saveChanges(entities, null, callback, errorCallback);
            };
            BreezeService.serviceId = 'breezeService';
            BreezeService.DCPulseServicePath = "/breeze/DCPulseBreeze";
            return BreezeService;
        }());
        Services.BreezeService = BreezeService;
        Pulse.app.factory(BreezeService.serviceId, ["breeze",
            "common", function (b, c) { return new BreezeService(b, c); }]);
    })(Services = Pulse.Services || (Pulse.Services = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Services;
    (function (Services) {
        var DataAccess = Pulse.Common.DataAccess;
        var Utils = Pulse.Utils;
        var Managers = Pulse.Common.DataAccess.Managers;
        var PulseContextStatebag = (function () {
            function PulseContextStatebag(localStorageService, stateObj) {
                if (stateObj === void 0) { stateObj = null; }
                this._stateObj = {
                    _actingAsUserId: -1,
                    _canOverrideRegFlowRestrictions: false,
                    _companyId: -1,
                    _inRegFlow: false,
                    _isLoggedInUserTermStaff: false,
                    _loggedInUserId: -1,
                    _loggedInUserRoles: new Array(),
                    _selectedCurrencyTypeID: null,
                    _regflowCurrencyTypeID: null,
                    _shoppingCartType: Enums.ShoppingCartType.RegFlow,
                    _termGroupId: -1,
                };
                this.localStorageService = localStorageService;
                if (angular.isObject(stateObj)) {
                    this._stateObj = stateObj;
                }
            }
            Object.defineProperty(PulseContextStatebag, "browseId", {
                get: function () { return 'browseId'; },
                enumerable: false,
                configurable: true
            });
            ;
            Object.defineProperty(PulseContextStatebag, "stateBagId", {
                get: function () { return 'pulseContextStateBagData'; },
                enumerable: false,
                configurable: true
            });
            ;
            Object.defineProperty(PulseContextStatebag.prototype, "canOverrideRegFlowRestrictions", {
                get: function () {
                    return this._stateObj._canOverrideRegFlowRestrictions;
                },
                set: function (canOverride) {
                    this._stateObj._canOverrideRegFlowRestrictions = canOverride;
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag.prototype, "companyId", {
                get: function () {
                    return this._stateObj._companyId;
                },
                set: function (companyId) {
                    this._stateObj._companyId = companyId;
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag.prototype, "selectedCurrencyTypeID", {
                get: function () {
                    return this._stateObj._selectedCurrencyTypeID;
                },
                set: function (currencyTypeID) {
                    this._stateObj._selectedCurrencyTypeID = currencyTypeID;
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag.prototype, "regflowCurrencyTypeID", {
                get: function () {
                    return this._stateObj._regflowCurrencyTypeID;
                },
                set: function (value) {
                    this._stateObj._regflowCurrencyTypeID = value;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag.prototype, "termGroupId", {
                get: function () {
                    return this._stateObj._termGroupId;
                },
                set: function (termGroupId) {
                    this._stateObj._termGroupId = termGroupId;
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag, "browseIdentifier", {
                get: function () {
                    var browseID = null;
                    var browseIDCookieName = Utils.Cookies.prefixCookieName(PulseContextStatebag.browseId);
                    if (Utils.BrowserCap.checkLocalStorageSupport() && Utils.BrowserCap.checkSessionStorageSupport()) {
                        if (window.sessionStorage.getItem(browseIDCookieName) == null
                            && window.localStorage.getItem(browseIDCookieName) == null) {
                            browseID = null;
                        }
                        else if (window.sessionStorage.getItem(browseIDCookieName) == null
                            && window.localStorage.getItem(browseIDCookieName) != null) {
                            browseID = window.localStorage.getItem(browseIDCookieName);
                            window.sessionStorage.setItem(browseIDCookieName, browseID);
                        }
                        else {
                            browseID = window.sessionStorage.getItem(browseIDCookieName);
                        }
                    }
                    else {
                        browseID = Utils.Cookies.getCookie(PulseContextStatebag.browseId);
                    }
                    return browseID ? browseID : null;
                },
                enumerable: false,
                configurable: true
            });
            PulseContextStatebag.prototype.setBrowseIdentifier = function (browseIdentifier, storeInLongTermStorage) {
                if (Utils.BrowserCap.checkLocalStorageSupport() && Utils.BrowserCap.checkSessionStorageSupport()) {
                    var browseIDCookieName = Utils.Cookies.prefixCookieName(PulseContextStatebag.browseId);
                    if (!String.isNullOrWhitespace(browseIdentifier)) {
                        if (storeInLongTermStorage) {
                            window.localStorage.setItem(browseIDCookieName, browseIdentifier);
                        }
                        else {
                            window.localStorage.removeItem(browseIDCookieName);
                        }
                        window.sessionStorage.setItem(browseIDCookieName, browseIdentifier);
                    }
                    else {
                        window.localStorage.removeItem(browseIDCookieName);
                        window.sessionStorage.removeItem(browseIDCookieName);
                    }
                }
                else {
                    if (!String.isNullOrWhitespace(browseIdentifier)) {
                        Utils.Cookies.setCookie(PulseContextStatebag.browseId, browseIdentifier);
                    }
                    else {
                        Utils.Cookies.eraseCookie(PulseContextStatebag.browseId);
                    }
                }
            };
            Object.defineProperty(PulseContextStatebag.prototype, "isLoggedInUserTermStaff", {
                get: function () {
                    return this._stateObj._isLoggedInUserTermStaff;
                },
                set: function (isTermStaff) {
                    this._stateObj._isLoggedInUserTermStaff = isTermStaff;
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag.prototype, "loggedInUserId", {
                get: function () {
                    return this._stateObj._loggedInUserId;
                },
                set: function (id) {
                    this._stateObj._loggedInUserId = id;
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag.prototype, "loggedInUserRoles", {
                get: function () {
                    return this._stateObj._loggedInUserRoles;
                },
                set: function (roles) {
                    this._stateObj._loggedInUserRoles = angular.copy(roles);
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag.prototype, "actingAsUserId", {
                get: function () {
                    return this._stateObj._actingAsUserId;
                },
                set: function (id) {
                    this._stateObj._actingAsUserId = id;
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag.prototype, "inRegFlow", {
                get: function () {
                    return this._stateObj._inRegFlow;
                },
                set: function (inRegflow) {
                    this._stateObj._inRegFlow = inRegflow;
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextStatebag.prototype, "shoppingCartType", {
                get: function () {
                    return this._stateObj._shoppingCartType;
                },
                set: function (type) {
                    this._stateObj._shoppingCartType = type;
                    this.localStorageService.set(PulseContextStatebag.stateBagId, this._stateObj);
                },
                enumerable: false,
                configurable: true
            });
            return PulseContextStatebag;
        }());
        var PulseContextService = (function () {
            function PulseContextService(common, breezeService) {
                var _this = this;
                this.activationPromises = new Array();
                this.resolveActivationPromises = function () {
                    return _this.common.combinePromises(_this.activationPromises, PulseContextService.serviceId);
                };
                this.clearActivationPromises = function () {
                    return _this.activationPromises.length = 0;
                };
                this.common = common;
                this.breezeService = breezeService;
                this.restoreState();
            }
            Object.defineProperty(PulseContextService.prototype, "systemMgr", {
                get: function () {
                    return this._systemMgr || (this._systemMgr = new DataAccess.Managers.SystemMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._systemMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "lookupInfoMgr", {
                get: function () {
                    return this._lookupInfoMgr || (this._lookupInfoMgr = new DataAccess.Managers.LookupInfoMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._lookupInfoMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "timeZoneMgr", {
                get: function () {
                    return this._timeZoneMgr || (this._timeZoneMgr = new DataAccess.Managers.TimeZoneMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._timeZoneMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "thresholdMgr", {
                get: function () {
                    return this._thresholdMgr
                        || (this._thresholdMgr = new DataAccess.Managers.ThresholdMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._thresholdMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "userMgr", {
                get: function () {
                    return this._userMgr || (this._userMgr = new DataAccess.Managers.UserMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._userMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "pulseAriaService", {
                get: function () {
                    if (this._pulseAriaService == null)
                        this._pulseAriaService = new Services.PulseAriaService();
                    return this._pulseAriaService;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "customerMgr", {
                get: function () {
                    return this._customerMgr || (this._customerMgr = new DataAccess.Managers.CustomerMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._customerMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "discountMgr", {
                get: function () {
                    return this._discountMgr || (this._discountMgr = new DataAccess.Managers.DiscountMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._discountMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "regFlowMgr", {
                get: function () {
                    return this._regFlowMgr
                        ||
                            (this._regFlowMgr = new DataAccess.Managers.RegFlowMgr(this.common, this.breezeService, this, this.systemMgr.availChartDateInContext));
                },
                set: function (newMgr) {
                    this._regFlowMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "medicAppMgr", {
                get: function () {
                    return this._medicAppMgr || (this._medicAppMgr = new DataAccess.Managers.MedicAppMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._medicAppMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "clientFormsMgr", {
                get: function () {
                    return this._clientFormsMgr || (this._clientFormsMgr = new DataAccess.Managers.ClientFormsMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._clientFormsMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "healthSafetyFormMgr", {
                get: function () {
                    return this._healthSafetyFormMgr || (this._healthSafetyFormMgr = new DataAccess.Managers.HealthSafetyFormMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._healthSafetyFormMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "termStaffMgr", {
                get: function () {
                    return this._termStaffMgr || (this._termStaffMgr = new DataAccess.Managers.TermStaffMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._termStaffMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "onlinePrivateLessonMgr", {
                get: function () {
                    return this._onlinePrivateLessonMgr || (this._onlinePrivateLessonMgr = new DataAccess.Managers.OnlinePrivateLessonMgr(this.common, this.breezeService, this));
                },
                set: function (newMgr) {
                    this._onlinePrivateLessonMgr = newMgr;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "isRunningInPartnerDomain", {
                get: function () {
                    return this.systemMgr.isRunningInPartnerDomain;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "pulse1x_PublicUrlRoot", {
                get: function () {
                    var urlRoot = '';
                    if (this.isImpersonating) {
                        urlRoot = this.common.config.pulse1x_AdminUrl + this.common.config.pulse1x_PublicAppRoot;
                    }
                    else {
                        urlRoot = this.common.config.pulse1x_PublicUrl + this.common.config.pulse1x_PublicAppRoot;
                    }
                    return urlRoot;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "authData", {
                get: function () {
                    return this.common.localStorageService.get(Pulse.Services.PulseContextService.authDataId);
                },
                set: function (data) {
                    data ? this.common.localStorageService.set(Pulse.Services.PulseContextService.authDataId, data)
                        : this.common.localStorageService.remove(Pulse.Services.PulseContextService.authDataId);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "stateBag", {
                get: function () {
                    if (!angular.isObject(this._stateBag)) {
                        var stateObj = this.common.localStorageService.get(PulseContextStatebag.stateBagId);
                        if (angular.isObject(stateObj)) {
                            this._stateBag = new PulseContextStatebag(this.common.localStorageService, stateObj);
                        }
                    }
                    if (!angular.isObject(this._stateBag)) {
                        this._stateBag = new PulseContextStatebag(this.common.localStorageService);
                    }
                    return this._stateBag;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "serverDateTime", {
                get: function () {
                    return this.systemMgr.serverDateTime;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "serverTimeZoneStr", {
                get: function () {
                    return "America/Los_Angeles";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "canOverrideRegFlowRestrictions", {
                get: function () {
                    return this.stateBag.canOverrideRegFlowRestrictions;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "companyId", {
                get: function () {
                    return this.stateBag.companyId;
                },
                set: function (id) {
                    var _this = this;
                    if (id > 0 && (!angular.isObject(this._company) || this._company.companyID != id)) {
                        var companyDAO = new DataAccess.CompanyDAO(this.common, this.breezeService, this);
                        this.activationPromises.push(companyDAO.getByID(id)
                            .then(function (company) {
                            _this._company = company;
                            _this.stateBag.companyId = id;
                        }));
                    }
                    else if (id <= 0) {
                        this.stateBag.companyId = -1;
                        this._company = null;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "company", {
                get: function () {
                    return this._company;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "companyTollFreePhone", {
                get: function () {
                    var tel = '';
                    for (var _i = 0, _a = this.company.companyContactMethods; _i < _a.length; _i++) {
                        var cm = _a[_i];
                        if (cm.contactMethod.contactMethodTypeID == Enums.CompanyContactMethodType.PhoneTollFree) {
                            tel = cm.contactMethod.countryCode + "-" + cm.contactMethod.areaCode + "-" + cm.contactMethod.number;
                            break;
                        }
                    }
                    return tel;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "companyInternationalPhone", {
                get: function () {
                    var tel = '';
                    for (var _i = 0, _a = this.company.companyContactMethods; _i < _a.length; _i++) {
                        var cm = _a[_i];
                        if (cm.contactMethod.contactMethodTypeID == Enums.CompanyContactMethodType.PhoneInternational) {
                            tel = cm.contactMethod.countryCode + "-" + cm.contactMethod.areaCode + "-" + cm.contactMethod.number;
                            break;
                        }
                    }
                    return tel;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "isLoggedInUserTermStaff", {
                get: function () {
                    return this.stateBag.isLoggedInUserTermStaff;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "currentTermGroup", {
                get: function () {
                    return this._termGroup;
                },
                set: function (termGroup) {
                    this._termGroup = termGroup;
                    this.stateBag.termGroupId = termGroup.termGroupID;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "loggedInUserId", {
                get: function () {
                    return this.stateBag.loggedInUserId;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "loggedInUser", {
                get: function () {
                    return this._loggedInUser;
                },
                set: function (user) {
                    if (user) {
                        this._loggedInUser = user;
                        this.stateBag.loggedInUserId = user.userID;
                    }
                    else {
                        this._loggedInUser = null;
                        this.stateBag.loggedInUserId = -1;
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "loggedInUserRoles", {
                get: function () {
                    return this.stateBag.loggedInUserRoles;
                },
                set: function (roles) {
                    this.stateBag.loggedInUserRoles = roles;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "actingAsUserId", {
                get: function () {
                    if (this.stateBag.actingAsUserId <= 0) {
                        return this.loggedInUserId;
                    }
                    else {
                        return this.stateBag.actingAsUserId;
                    }
                },
                set: function (userID) {
                    var _this = this;
                    if (this.isLoggedIn) {
                        this.stateBag.actingAsUserId = userID;
                        if (userID > 0) {
                            var userDAO = new DataAccess.UserDAO(this.common, this.breezeService, this);
                            this.activationPromises.push(userDAO.getByUserID(userID).then(function (user) {
                                _this._actingAsUser = user;
                            }));
                        }
                        else {
                            this._actingAsUser = null;
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "actingAsUser", {
                get: function () {
                    if (this.stateBag.actingAsUserId <= 0) {
                        return this.loggedInUser;
                    }
                    else if (!angular.isObject(this._actingAsUser) && this.stateBag.actingAsUserId > 0) {
                        var userDAO = new DataAccess.UserDAO(this.common, this.breezeService, this);
                        var self_1 = this;
                        userDAO.getByUserID(this.stateBag.actingAsUserId)
                            .then(function (user) {
                            self_1._actingAsUser = user;
                        });
                    }
                    return this._actingAsUser;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "isLoggedIn", {
                get: function () {
                    if (this.stateBag.loggedInUserId > 0 && angular.isObject(this.loggedInUser)) {
                        return true;
                    }
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "isImpersonating", {
                get: function () {
                    if (this.stateBag.loggedInUserId > 0 && this.stateBag.actingAsUserId > 0
                        && this.stateBag.loggedInUserId != this.stateBag.actingAsUserId) {
                        return true;
                    }
                    return false;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "inRegFlow", {
                get: function () {
                    return this.stateBag.inRegFlow;
                },
                set: function (value) {
                    this.stateBag.inRegFlow = value;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "inIframe", {
                get: function () {
                    return (window.parent !== window);
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "inWWW", {
                get: function () {
                    return location.href.indexOf(this.common.config.WWW_UrlRoot) == 0;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "selectedCurrencyTypeID", {
                get: function () {
                    return this.stateBag.selectedCurrencyTypeID;
                },
                set: function (value) {
                    this.stateBag.selectedCurrencyTypeID = value;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "regflowCurrencyTypeID", {
                get: function () {
                    return this.stateBag.regflowCurrencyTypeID;
                },
                set: function (value) {
                    this.stateBag.regflowCurrencyTypeID = value;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService, "browseIdentifier", {
                get: function () {
                    return PulseContextStatebag.browseIdentifier;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PulseContextService.prototype, "browseIdentifier", {
                get: function () {
                    return PulseContextStatebag.browseIdentifier;
                },
                enumerable: false,
                configurable: true
            });
            PulseContextService.prototype.setBrowseIdentifier = function (browseIdentifier, storeInLongTermStorage) {
                this.stateBag.setBrowseIdentifier(browseIdentifier, storeInLongTermStorage);
            };
            Object.defineProperty(PulseContextService.prototype, "shoppingCartType", {
                get: function () {
                    return this.stateBag.shoppingCartType;
                },
                set: function (type) {
                    this.stateBag.shoppingCartType = type;
                },
                enumerable: false,
                configurable: true
            });
            PulseContextService.prototype.clearState = function () {
                this.common.localStorageService.remove(PulseContextStatebag.stateBagId);
                this.authData = null;
                if (this._pulseAriaService !== null && this._pulseAriaService !== undefined) {
                    this._pulseAriaService.ClearState();
                }
                this.stateBag.setBrowseIdentifier(null, false);
                this.stateBag.setBrowseIdentifier(null, true);
                this._stateBag = null;
                this._company = null;
                this._termGroup = null;
                this._loggedInUser = null;
                this._actingAsUser = null;
                this._pulseAriaService = null;
                this._systemMgr = null;
                this._lookupInfoMgr = null;
                this._timeZoneMgr = null;
                this._userMgr = null;
                this._customerMgr = null;
                this._discountMgr = null;
                this._regFlowMgr = null;
                this._medicAppMgr = null;
                this._clientFormsMgr = null;
                this._healthSafetyFormMgr = null;
                this._termStaffMgr = null;
                this._onlinePrivateLessonMgr = null;
            };
            PulseContextService.prototype.restoreState = function () {
                var _this = this;
                this.stateBag.companyId = this.common.config.companyId;
                this.companyId = this.common.config.companyId;
                this.activationPromises.push(this.systemMgr.loadSystemInfo());
                var userDAO = new DataAccess.UserDAO(this.common, this.breezeService, this);
                var userContactMethodDAO = new DataAccess.UserContactMethodDAO(this.common, this.breezeService, this);
                var regFlowMgr = new DataAccess.Managers.RegFlowMgr(this.common, this.breezeService, this);
                if (this.stateBag.loggedInUserId > 0 && !angular.isObject(this._loggedInUser)) {
                    this.common.logTraceToDatabase(this.stateBag.loggedInUserId, this.actingAsUserId, 'PulseContextService', 'restoreState', Enums.PulseErrorLogSeverityLevel.Verbose, Enums.PulseErrorLogSubject.Authentication, ('Getting user while restoring context for stateBag.loggedInUserId ' + this.stateBag.loggedInUserId));
                    this.activationPromises.push(userDAO.getLoggedInUser()
                        .then(function (user) {
                        _this.loggedInUser = user;
                    }));
                }
                if (!angular.isObject(this._termGroup)) {
                    var termGroupDAO = new DataAccess.TermGroupDAO(this.common, this.breezeService, this);
                    this.activationPromises.push(termGroupDAO.getCurrentTermGroup()
                        .then(function (tg) {
                        _this.currentTermGroup = tg;
                    }));
                }
                if (!this.lookupInfoMgr.divisionInfos) {
                    this.activationPromises.push(this.lookupInfoMgr.loadDivisionInfo());
                }
                if (this.stateBag.actingAsUserId > 0 && !angular.isObject(this._actingAsUser)) {
                    this.activationPromises.push(userDAO.getByUserID(this.stateBag.actingAsUserId)
                        .then(function (user) {
                        _this._actingAsUser = user;
                    }));
                    this.activationPromises.push(regFlowMgr.getCanOverrideRestrictions(this.stateBag.loggedInUserId)
                        .then(function (flag) {
                        _this.stateBag.canOverrideRegFlowRestrictions = flag;
                    }));
                    this.activationPromises.push(regFlowMgr.getIsLoggedInUserTermStaff()
                        .then(function (flag) {
                        _this.stateBag.isLoggedInUserTermStaff = flag;
                    }));
                }
                if (PulseContextStatebag.browseIdentifier == null) {
                    this.activationPromises.push(regFlowMgr.userBrowsingMgr.getNewBrowseIdentifier().then(function (browseId) {
                        _this.stateBag.setBrowseIdentifier(browseId, false);
                        return browseId;
                    }));
                }
                this.inRegFlow = this.stateBag.inRegFlow;
                return this.resolveActivationPromises();
            };
            PulseContextService.prototype.recordUserAndRoles = function (userAndRoles) {
                this.loggedInUser = userAndRoles.user;
                this.loggedInUserRoles = userAndRoles.roles;
                var authData = this.authData;
                if (!authData) {
                    authData = {};
                }
                authData.userId = userAndRoles.user.userID;
                authData.userName = userAndRoles.user.userName;
                this.authData = authData;
            };
            PulseContextService.prototype.login = function (userName, password, enforcePasswordChange) {
                var _this = this;
                var deferred = this.common.$q.defer();
                var loginPromise = null;
                this.userMgr.migratePublicUser(userName, password)
                    .then(function (result) {
                    if (result.outcome == Enums.MigrationOutcome.MigratedAlready
                        || result.outcome == Enums.MigrationOutcome.MigratedUsernameToProvidedPrimaryEmail) {
                        var newUsername = result.newUsername || result.oldUsername;
                        loginPromise = _this.userMgr.login(newUsername, password);
                        return loginPromise;
                    }
                    else if (result.outcome == Enums.MigrationOutcome.MigratedUsernameToPrimaryEmail
                        || result.outcome == Enums.MigrationOutcome.NotMigratedMultiplePrimaryEmailsWithProvidedUsername
                        || result.outcome === Enums.MigrationOutcome.NotMigratedPublicUserMissingPrimaryEmail) {
                        userName = result.newUsername || result.oldUsername;
                        _this.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.HelpTopic, "Username Information", " " + result.message, null);
                        loginPromise = _this.userMgr.login(userName, password);
                        return loginPromise;
                    }
                    else if (result.outcome == Enums.MigrationOutcome.NotMigratedMultipleAccountsWithProvidedEmail) {
                        deferred.reject({
                            name: PulseErrorTypes.Show_To_User,
                            message: result.message
                        });
                        return deferred.promise;
                    }
                    else {
                        loginPromise = _this.userMgr.login(userName, password);
                        return loginPromise;
                    }
                })
                    .then(function (result) {
                    loginPromise
                        .then(function (response) {
                        var data = response.data;
                        var userAndRolesCache = null;
                        _this.authData = { token: data.access_token, userName: userName };
                        _this.userMgr.getLoggedInUserAndRoles()
                            .then(function (userAndRoles) {
                            userAndRolesCache = userAndRoles;
                            _this.recordUserAndRoles(userAndRolesCache);
                            Utils.ClickTracking.setTrackingCookie(_this.actingAsUser.userName);
                        })
                            .then(function () {
                            var channelPrefMgr = new Managers.ChannelPreferenceMgr(_this.common, _this.breezeService, _this);
                            return channelPrefMgr.subscribeToDefaultChannels();
                        })
                            .then(function () {
                            if (_this._regFlowMgr) {
                                _this.regFlowMgr.locationFinderMgr.clearLocationsInfo();
                            }
                        })
                            .catch(function (reason) {
                            deferred.reject(reason);
                        }).finally(function () {
                            if (!enforcePasswordChange) {
                                deferred.resolve(data);
                                _this.common.$rootScope.$broadcast(Events.LoginSuccess);
                            }
                            else
                                deferred.resolve(userAndRolesCache);
                        });
                    })
                        .catch(function (err) {
                        _this.logout();
                        deferred.reject(err);
                    });
                })
                    .catch(function (reason) {
                    _this.logout();
                    deferred.reject(reason);
                });
                return deferred.promise;
            };
            PulseContextService.prototype.autoAuthenticate = function (userId, token, requestedRoute) {
                var _this = this;
                var deferred = this.common.$q.defer();
                if (angular.isUndefined(token) || isNaN(userId)) {
                    deferred.resolve();
                    return deferred.promise;
                }
                var actingAsUserId = parseInt(this.common.$location.search()[QueryStringUtils.USER_IMPERSONATE_ID]);
                var authData = this.authData;
                if (angular.isObject(authData) && this.isLoggedIn && this.loggedInUserId == userId) {
                    if (!isNaN(actingAsUserId) && this.actingAsUserId != actingAsUserId) {
                        this.actingAsUserId = actingAsUserId;
                        this.customerMgr = null;
                        this.regFlowMgr = null;
                    }
                    this.common.logTraceToDatabase(userId, (this.actingAsUserId || null), 'pulseContextService.ts', 'autoAuthenticate', Enums.PulseErrorLogSeverityLevel.Verbose, Enums.PulseErrorLogSubject.Authentication, ('UserID ' + userId + ' is already logged in via token = ' + token));
                    deferred.resolve();
                    return deferred.promise;
                }
                else {
                    this.common.logTraceToDatabase(userId, (this.actingAsUserId || null), 'pulseContextService.ts', 'autoAuthenticate', Enums.PulseErrorLogSeverityLevel.Verbose, Enums.PulseErrorLogSubject.Authentication, ('localStorageService did not have authData for userID ' + userId + ' via key ' + PulseContextService.authDataId));
                    this.userMgr = null;
                    this.customerMgr = null;
                    this.regFlowMgr = null;
                    this.userMgr.autoLogin(userId, actingAsUserId, token)
                        .then(function (response) {
                        var data = response.data;
                        _this.authData = { token: data.access_token, userId: userId, requestedRoute: requestedRoute };
                        _this.common.logTraceToDatabase(userId, (_this.actingAsUserId || null), 'pulseContextService.ts', 'autoAuthenticate', Enums.PulseErrorLogSeverityLevel.Verbose, Enums.PulseErrorLogSubject.Authentication, ('autoLogin succeeded.  localStorageService stuffed with access_token: ' + data.access_token));
                        return _this.userMgr.getLoggedInUserAndRoles()
                            .then(function (userAndRoles) {
                            _this.recordUserAndRoles(userAndRoles);
                            if (!isNaN(actingAsUserId) && _this.actingAsUserId != actingAsUserId) {
                                _this.actingAsUserId = actingAsUserId;
                                _this.common.logTraceToDatabase(userId, (_this.actingAsUserId || null), 'pulseContextService.ts', 'autoAuthenticate', Enums.PulseErrorLogSeverityLevel.Verbose, Enums.PulseErrorLogSubject.Authentication, ('Impersonating UserID: ' + actingAsUserId));
                            }
                            else if ((isNaN(actingAsUserId) || actingAsUserId <= 0) && _this.actingAsUserId > 0) {
                                _this.actingAsUserId = -1;
                                _this.common.logTraceToDatabase(userId, (_this.actingAsUserId || null), 'pulseContextService.ts', 'autoAuthenticate', Enums.PulseErrorLogSeverityLevel.Verbose, Enums.PulseErrorLogSubject.Authentication, ('NOT impersonating any user'));
                            }
                            return _this.restoreState()
                                .then(function () {
                                Utils.ClickTracking.setTrackingCookie(_this.actingAsUser.userName);
                            });
                        })
                            .then(function () {
                            var promises = [];
                            var channelPrefMgr = new Managers.ChannelPreferenceMgr(_this.common, _this.breezeService, _this);
                            promises.push(channelPrefMgr.subscribeToDefaultChannels());
                            promises.push(_this.regFlowMgr.userBrowsingMgr.getNewBrowseIdentifier().then(function (browseId) {
                                _this.stateBag.setBrowseIdentifier(browseId, false);
                            }));
                            return _this.common.$q.all(promises);
                        })
                            .then(function () {
                            _this.common.$rootScope.$broadcast(Events.LoginSuccess);
                            deferred.resolve();
                        })
                            .catch(function (reason) {
                            _this.common.logTraceToDatabase(userId, (_this.actingAsUserId || null), 'pulseContextService.ts', 'autoAuthenticate', Enums.PulseErrorLogSeverityLevel.Errors, Enums.PulseErrorLogSubject.Authentication, ('getLoggedInUserAndRoles failed: ' + reason));
                            _this.logout(true, true);
                            deferred.reject(reason);
                        });
                    })
                        .catch(function (reason) {
                        _this.logout(true, true);
                        deferred.reject("Auto Authentication Error!");
                    })
                        .finally(function () {
                    });
                    return deferred.promise;
                }
            };
            PulseContextService.prototype.googleAuthenticate = function (id_token, addNewUserIfMissing) {
                var _this = this;
                if (addNewUserIfMissing === void 0) { addNewUserIfMissing = false; }
                var deferred = this.common.$q.defer();
                this.userMgr.loginWithGoogleToken(id_token, addNewUserIfMissing)
                    .then(function (response) {
                    var data = response.data;
                    _this.authData = { token: data.access_token };
                    _this.userMgr.getLoggedInUserAndRoles()
                        .then(function (userAndRoles) {
                        _this.recordUserAndRoles(userAndRoles);
                    })
                        .then(function () {
                        var channelPrefMgr = new Managers.ChannelPreferenceMgr(_this.common, _this.breezeService, _this);
                        return channelPrefMgr.subscribeToDefaultChannels();
                    })
                        .then(function () {
                        if (_this._regFlowMgr) {
                            _this.regFlowMgr.locationFinderMgr.clearLocationsInfo();
                        }
                    })
                        .catch(function (reason) {
                        deferred.reject(reason);
                    }).finally(function () {
                        Utils.ClickTracking.setTrackingCookie(_this.actingAsUser.userName);
                        deferred.resolve(data);
                        _this.common.$rootScope.$broadcast(Events.LoginSuccess);
                    });
                })
                    .catch(function (err) {
                    _this.logout();
                    deferred.reject(err);
                });
                return deferred.promise;
            };
            PulseContextService.prototype.refreshUserInfo = function () {
                var _this = this;
                var self = this;
                this.userMgr.addressesForActingAsUser = null;
                var promise = this.userMgr.getLoggedInUserAndRoles()
                    .then(function (userAndRoles) {
                    _this.recordUserAndRoles(userAndRoles);
                    if (self.isImpersonating) {
                        var userDAO = new DataAccess.UserDAO(self.common, self.breezeService, self);
                        return userDAO.getByUserID(self.actingAsUserId).then(function (user) {
                            self._actingAsUser = user;
                        });
                    }
                    else {
                        Utils.ClickTracking.setTrackingCookie(_this.actingAsUser.userName);
                        return userAndRoles.user;
                    }
                });
                return promise;
            };
            PulseContextService.prototype.logout = function (clearAllState, resetBroweIdentifier) {
                var _this = this;
                if (clearAllState === void 0) { clearAllState = false; }
                if (resetBroweIdentifier === void 0) { resetBroweIdentifier = false; }
                var browseId = this.browseIdentifier;
                if (clearAllState) {
                    this.clearState();
                }
                else {
                    this._stateBag = null;
                    this.common.localStorageService.remove(PulseContextStatebag.stateBagId);
                    this.authData = null;
                }
                if (!resetBroweIdentifier) {
                    this.stateBag.setBrowseIdentifier(browseId, false);
                }
                else {
                    Events.TriggerDocCustomEvent(Events.SendCartInfo_JSEvent, { first: '', last: '', email: '', count: 0 });
                }
                this.stateBag.companyId = this.common.config.companyId;
                return this.restoreState()
                    .then(function (result) {
                    _this.common.$rootScope.$broadcast(Events.LoggedOutRefresh, clearAllState);
                    return result;
                });
                ;
            };
            PulseContextService.prototype.logoutGoogle = function () {
                var _discAndSignOutFn = function (googleAuthInst, deferred) {
                    googleAuthInst.disconnect();
                    if (googleAuthInst.isSignedIn.get()) {
                        deferred.resolve(googleAuthInst.signOut());
                    }
                    else {
                        deferred.resolve();
                    }
                };
                var deferred = this.common.$q.defer();
                try {
                    Utils.GoogleAuthUtil.GetAuthInstance(this.common.config.googleAPI_ClientID)
                        .then(function (googleAuthInst) {
                        _discAndSignOutFn(googleAuthInst, deferred);
                    })
                        .catch(function (e) {
                        deferred.resolve();
                    });
                }
                catch (e) {
                    deferred.resolve();
                }
                return deferred.promise;
            };
            PulseContextService.prototype.hasAnyRolesAndLevels = function () {
                var roleAndLevels = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    roleAndLevels[_i] = arguments[_i];
                }
                var role = null;
                var level = -1;
                var foundRole = false;
                var foundRoleLevel = false;
                var hasRoleLevelSpecified = false;
                for (var i = 0; i < roleAndLevels.length; i++) {
                    var param = roleAndLevels[i];
                    if (angular.isNumber(param)) {
                        if (param >= 2000) {
                            if (role != null && role != param && (foundRole && !hasRoleLevelSpecified)) {
                                return true;
                            }
                            role = param;
                            foundRole = false;
                            foundRoleLevel = false;
                            hasRoleLevelSpecified = false;
                            level = -1;
                        }
                        else {
                            level = param;
                            foundRoleLevel = false;
                            hasRoleLevelSpecified = true;
                        }
                    }
                    else if (angular.isString(param)) {
                        var newRole = Enums.UserRoleType[param];
                        if (newRole != role && (foundRole && !hasRoleLevelSpecified)) {
                            return true;
                        }
                        role = newRole;
                        foundRole = false;
                        foundRoleLevel = false;
                        level = -1;
                    }
                    else {
                        throw new Error('Role type or Role Level type is invalid.');
                    }
                    this.loggedInUserRoles.forEach(function (userRole, index) {
                        if (userRole.roleTypeID == role) {
                            foundRole = true;
                            if (level > 0 && userRole.roleLevel == level) {
                                foundRoleLevel = true;
                                return;
                            }
                        }
                    });
                    if (foundRole && foundRoleLevel)
                        return true;
                }
                return (foundRole && !hasRoleLevelSpecified);
            };
            PulseContextService.prototype.hasRolesOtherThan = function () {
                var roleAndLevels = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    roleAndLevels[_i] = arguments[_i];
                }
                var roleLevelArr = new Array();
                var role = null;
                var level = -1;
                for (var i = 0; i < roleAndLevels.length; i++) {
                    var param = roleAndLevels[i];
                    if (angular.isNumber(param)) {
                        if (param >= 2000) {
                            role = param;
                            level = -1;
                        }
                        else {
                            level = param;
                        }
                    }
                    else if (angular.isString(param)) {
                        var newRole = Enums.UserRoleType[param];
                        role = newRole;
                        level = -1;
                    }
                    else {
                        throw new Error('Role type or Role Level type is invalid.');
                    }
                    if (level >= 0) {
                        if (roleLevelArr[roleLevelArr.length - 1].level === -1) {
                            roleLevelArr.pop();
                        }
                    }
                    roleLevelArr.push({ role: role, level: level });
                }
                for (var _a = 0, _b = this.loggedInUserRoles; _a < _b.length; _a++) {
                    var userRole = _b[_a];
                    var matches = Utils.JS.findByProperties(roleLevelArr, { role: userRole.roleTypeID, level: userRole.roleLevel });
                    if (matches && matches.length > 0) {
                        continue;
                    }
                    matches = Utils.JS.findByProperties(roleLevelArr, { role: userRole.roleTypeID, level: -1 });
                    if (matches && matches.length > 0) {
                        continue;
                    }
                    return true;
                }
                return false;
            };
            PulseContextService.serviceId = 'pulseContextService';
            PulseContextService.authDataId = 'authorizationData';
            return PulseContextService;
        }());
        Services.PulseContextService = PulseContextService;
        Pulse.app.factory(PulseContextService.serviceId, [
            'common',
            'breezeService',
            function (common, breezeService) { return new PulseContextService(common, breezeService); },
        ]);
    })(Services = Pulse.Services || (Pulse.Services = {}));
})(Pulse || (Pulse = {}));

"use strict";
var Pulse;
(function (Pulse) {
    var Services;
    (function (Services) {
        var PulseAriaService = (function () {
            function PulseAriaService() {
                this._placeholderList = [];
                this._isReady = false;
            }
            PulseAriaService.prototype.InitAria = function () {
                if (this._placeholderList !== undefined && this._placeholderList.length > 0 && !this._isReady) {
                    var _loop_1 = function (ph) {
                        var fieldId = this_1.GetFieldId(ph);
                        var tag = angular.element(document.querySelector(fieldId));
                        tag.attr('placeholder', ph.placeholder);
                        tag.on('focus', function (e) {
                            tag.removeAttr('placeholder');
                        }).on('blur', function (e) {
                            tag.attr('placeholder', ph.placeholder);
                        });
                    };
                    var this_1 = this;
                    for (var _i = 0, _a = this._placeholderList; _i < _a.length; _i++) {
                        var ph = _a[_i];
                        _loop_1(ph);
                    }
                    this._isReady = true;
                }
            };
            PulseAriaService.prototype.AddPlaceholderToField = function (fieldId, placeholder) {
                if (this._placeholderList.filter(function (ph) { return ph.fieldId == fieldId; }).length == 0) {
                    this._placeholderList.push({ fieldId: fieldId, placeholder: placeholder });
                }
            };
            PulseAriaService.prototype.ClearState = function () {
                if (this._placeholderList !== undefined && this._placeholderList.length > 0 && this._isReady) {
                    for (var _i = 0, _a = this._placeholderList; _i < _a.length; _i++) {
                        var ph = _a[_i];
                        var fieldId = this.GetFieldId(ph);
                        var tag = angular.element(document.querySelector(fieldId));
                        if (tag !== undefined) {
                            tag.off('focus');
                            tag.off('blur');
                        }
                    }
                    this._placeholderList = [];
                    this._isReady = false;
                }
            };
            PulseAriaService.prototype.GetFieldId = function (field) {
                var fieldId = field.fieldId;
                if (fieldId[0] !== '#')
                    fieldId = '#' + fieldId;
                return fieldId;
            };
            return PulseAriaService;
        }());
        Services.PulseAriaService = PulseAriaService;
    })(Services = Pulse.Services || (Pulse.Services = {}));
})(Pulse || (Pulse = {}));

"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Pulse;
(function (Pulse) {
    var Directives;
    (function (Directives) {
        var PulsePublic;
        (function (PulsePublic) {
            var BaseDirective = Pulse.Common.BaseDirective;
            var DebugDisplayDataDir = (function (_super) {
                __extends(DebugDisplayDataDir, _super);
                function DebugDisplayDataDir(common) {
                    var _this = _super.call(this, common) || this;
                    _this.restrict = "E";
                    _this.templateUrl = _this.common.config.appRoot
                        + Paths.PulsePublicDirective
                        + '_debug/debug-display-data.html';
                    _this.scope = {
                        debugData: "<",
                        title: "<?"
                    };
                    _this.controller = ["$scope",
                        "$location",
                        "common",
                        "breezeService",
                        "pulseContextService",
                        DebugDisplayDataDir.DebugDisplayDataDirCtrl
                    ];
                    return _this;
                }
                DebugDisplayDataDir.directiveId = 'debugDisplayData';
                return DebugDisplayDataDir;
            }(BaseDirective));
            PulsePublic.DebugDisplayDataDir = DebugDisplayDataDir;
            (function (DebugDisplayDataDir) {
                var BaseDirectiveCtrl = Pulse.Common.BaseDirective.BaseDirectiveCtrl;
                var DebugDisplayDataDirCtrl = (function (_super) {
                    __extends(DebugDisplayDataDirCtrl, _super);
                    function DebugDisplayDataDirCtrl($scope, $location, common, breezeService, pulseContext) {
                        var _this = _super.call(this, $scope, $location, common, breezeService, pulseContext, DebugDisplayDataDirCtrl.controllerId) || this;
                        _this.debug = false;
                        _this.isDebugEnabled = common.config.isDebugMode || false;
                        return _this;
                    }
                    DebugDisplayDataDirCtrl.prototype.isObject = function () {
                        return typeof this.debugData === 'object';
                    };
                    DebugDisplayDataDirCtrl.controllerId = "DebugDisplayDataDirCtrl";
                    return DebugDisplayDataDirCtrl;
                }(BaseDirectiveCtrl));
                DebugDisplayDataDir.DebugDisplayDataDirCtrl = DebugDisplayDataDirCtrl;
            })(DebugDisplayDataDir = PulsePublic.DebugDisplayDataDir || (PulsePublic.DebugDisplayDataDir = {}));
            Pulse.app.directive(DebugDisplayDataDir.directiveId, [
                'common',
                function (c) { return new DebugDisplayDataDir(c); }
            ]);
        })(PulsePublic = Directives.PulsePublic || (Directives.PulsePublic = {}));
    })(Directives = Pulse.Directives || (Pulse.Directives = {}));
})(Pulse || (Pulse = {}));

//# sourceMappingURL=pulseapp.js.map

angular.module('templatescache', []).run(['$templateCache', function($templateCache) {$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/logout.html','<div class="my-account" style="margin: 0px 1.0em 0px 0.5em;"><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/redirectHandler.html','<div class="my-account" style="margin: 0px 0.5em 0px 0.5em;"><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/resumeCartAnonymous.html','<div class="container"></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/tuitionAssistanceProgram.html','<div class="my-account" style="margin: 0px 0.5em 0px 0.5em;"><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/channel-preference/channelPreference.html','<div class="container py-5"><h3 class="my-5">Notification Settings</h3><hr><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err><fieldset ng-disabled="!vm.canUpdate"><idp-contact-channels contact-channels="vm.contactChannels" user-addresses="vm.userAddresses" target-user="vm.targetUser"></idp-contact-channels></fieldset></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/availChart.html','<div class="reg-flow" data-ng-show="vm.canSee"><div id="content" class="reg-flow-main-container"><div class="content-container"><h1 class="page-title"><span class="hidden-xs">Select a program below to view courses, dates and tuition. </span><span class="visible-xs-block">Programs, courses and dates.</span></h1><idp-avc-header-panel show-filters-panel="false" location="vm.currentLocation"></idp-avc-header-panel><idp-login-panel></idp-login-panel><form id="myForm" name="myForm" role="form" novalidate idp-form-focus ng-submit="vm.submit()"><debug-display-data debug-data="vm.genreFinderMgr.selectedIDs"></debug-display-data><div class="row" ng-repeat="location in vm.regFlowMgr.locationFinderMgr.selectedItems"><idp-avc-location location="location" single-loc-mode="vm.regFlowMgr.locationFinderMgr.selectedItems.length === 1"></idp-avc-location></div><idp-walkthrough-form-submit-button message="\'Select one or more courses and click continue.\'" button-text="\'Continue\'"></idp-walkthrough-form-submit-button></form></div></div><idp-avc-selected-popup popup-id="selectedProdPopup"></idp-avc-selected-popup><idp-avc-prereq-popup popup-id="prereqPopup"></idp-avc-prereq-popup><idp-avc-age-popup popup-id="agePolicyPopup"></idp-avc-age-popup><idp-avc-info-popup-old popup-id="moreInfoPopup"></idp-avc-info-popup-old><idp-avc-waitlist-add popup-id="waitlistPopup"></idp-avc-waitlist-add><idp-avc-options-popup popup-id="optPopup"></idp-avc-options-popup><idp-reg-flow-admin-override-popup popup-id="adminOverridePopup"></idp-reg-flow-admin-override-popup></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/availChartFilters.html','<div class="avc-view-container pt-4" data-ng-show="vm.canSee"><h2 class="page-title mb-5" ng-class="{\'d-none d-md-block\': vm.showLeftFiltersPanel}"><span class="d-none d-md-inline">Select a program below to view courses, dates and tuition. </span><span class="d-inline d-md-none d-lg-none">Programs, courses and dates.</span></h2><idp-avc-header-panel class="mb-4" show-filters-panel="true" disable-change-location="vm.getCampAtHQVal()" location="vm.currentLocation" ng-class="{\'d-none d-md-block\': vm.showLeftFiltersPanel}"></idp-avc-header-panel><idp-avc-availability-chart class="mb-9" avc-data-set="vm.avcDataSet" targeted-course-id="vm.courseId" on-render-finish="vm.onRenderFinish()" location="vm.currentLocation" drawer-style="vm.drawerStyle" ng-if="vm.currentLocation && vm.currentLocation.locTypeID !== $root.Enums.LocationType.VirtualSummerCamp && vm.currentLocation.locTypeID !== $root.Enums.LocationType.VirtualSquads"></idp-avc-availability-chart><idp-avc-availability-chart-virtual class="mb-9" avc-data-set="vm.avcDataSet" targeted-course-id="vm.courseId" on-render-finish="vm.onRenderFinish()" location="vm.currentLocation" catalog-date-ranges="vm.catalogDateRanges" catalog-date-range-id="vm.catalogDateRangeId" drawer-style="vm.drawerStyle" ng-if="vm.currentLocation && (vm.currentLocation.locTypeID == $root.Enums.LocationType.VirtualSummerCamp || vm.currentLocation.locTypeID == $root.Enums.LocationType.VirtualSquads) && vm.avcDataSet"></idp-avc-availability-chart-virtual><idp-avc-checkout-bar ng-show="vm.showCheckoutBar()" ng-class="{\'d-none d-md-block\': vm.showLeftFiltersPanel}" go-to-checkout-fn="vm.checkout()"></idp-avc-checkout-bar><idp-avc-course-added-popup popup-id="courseAddedPopup" api="vm.courseAddedPopupAPI"></idp-avc-course-added-popup><idp-avc-course-info-popup close-on-outside-click="true" popup-id="courseInfoPopup"></idp-avc-course-info-popup><idp-avc-course-overlay-popup close-on-outside-click="false" popup-id="courseOverlayPopup"></idp-avc-course-overlay-popup><idp-reg-flow-admin-override-popup popup-id="adminOverridePopup"></idp-reg-flow-admin-override-popup></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/billing.html','<div class="container justify-content-center" style="max-width:700px;"><div id="content" ng-show="vm.isReady && vm.canSee"><div ng-show="vm.showSmsCode"><h3 class="text-center">Please Enter the SMS Code</h3><div class="row"><div class="col-md-12"><div class="form-group mb-0"><label class="sr-only" for="otpCode">SMS Code</label> <input name="smsCode" class="form-control" placeholder="SMS Code" ng-model="vm.selectedSmsCode" required maxlength="20" autocomplete="off" idp-numbers-only></div></div></div><div class="row justify-content-end" style="margin-top:10px;margin-bottom:15px;"><div class="col-12 col-md-4 mb-3"><button type="button" class="btn btn-primary btn-block" ng-class="{disabled: vm.submitOrderDisabled}" ng-disabled="vm.submitOrderDisabled" ng-click="vm.submitSmsCode()">SUBMIT</button></div><div class="col-12 col-md-4 mb-3"><button type="button" class="btn btn-primary btn-block" ng-class="{disabled: vm.submitOrderDisabled}" ng-disabled="vm.submitOrderDisabled" ng-click="vm.submitSmsCode(\'resend\')">RE-SEND CODE</button></div><div class="col-12 col-md-4"><button type="button" class="btn btn-primary btn-block" ng-class="{disabled: vm.submitOrderDisabled}" ng-disabled="vm.submitOrderDisabled" ng-click="vm.submitSmsCode(\'cancel\')">CANCEL</button></div></div></div><div ng-hide="vm.showSmsCode"><div class="mt-5"><h3 class="text-center">Payment Information</h3><div class="mt-3" ng-show="vm.isImpersonating"><h4>ORDER ORIGINATION</h4>Origination:&nbsp;<select ng-model="vm.selectedOrderSourceTypeID" ng-options="o.typeID as o.typeString for o in vm.orderSourceTypes"></select></div></div><div class="mt-3"><h4 ng-show="vm.balanceDue > 0">How do you want to pay?</h4><form name="frmPaymentAmount" role="form" novalidate ng-show="vm.balanceDue > 0"><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="paymentOption">Payment Option</label> <select name="paymentOption" class="form-control" ng-class="{\'ng-invalid\': vm.getHasError_PaymentAmount(vm.frmPaymentAmount.paymentAmount)}" ng-model="vm.selectedPaymentOption" ng-options="o as o.name for o in vm.paymentOptionsInfo.paymentOptions"></select> <span class="text-danger" ng-show="vm.submitted && !vm.showPaymentAmountInput">{{vm.paymentAmountError}}</span></div></div></div><div class="row" ng-show="vm.showPaymentAmountInput"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="paymentAmountInput">Payment Amount Input</label> <input name="paymentAmountInput" class="form-control" ng-class="{\'ng-invalid\': vm.getHasError_PaymentAmount(vm.frmPaymentAmount.paymentAmount)}" placeholder="{{vm.selectedPaymentOption.paymentOptionPlaceHolder}}" ng-model="vm.selectedPaymentOption.paymentAmount" required maxlength="50" autocomplete="off" idp-numbers-only> <span class="text-danger">{{vm.paymentAmountError}}</span></div></div></div><div class="row" ng-show="vm.isImpersonating || vm.cart.currencyType.typeID != 25000"><div class="col-md-12"><div class="form-group" uib-tooltip="Payment Method" tooltip-trigger="\'focus\'"><label for="payment_method" style="font-weight:bold;color:#000;">Payment Method</label> <select name="payment_method" class="form-control" ng-model="vm.selectedPaymentMethodTypeID" ng-options="o.typeID as o.typeString for o in vm.paymentMethodTypes"><option value="">Payment Method</option></select></div></div></div><div class="row" ng-show="vm.selectedPaymentOption.getPaymentOptionMsg(vm.hasAtLeastOneCourse, vm.hasOnlyOplOrVirtualCamps)"><div class="col-md-12"><div class="form-group"><span class="text-muted">{{vm.selectedPaymentOption.getPaymentOptionMsg(vm.hasAtLeastOneCourse, vm.hasOnlyOplOrVirtualCamps)}}</span></div></div></div><div ng-show="vm.cart.currencyType.typeID == 25000 || (vm.cart.currencyType.typeID != 25000 && vm.selectedPaymentMethodTypeID)"><div ng-show="vm.showScheduledPayments" class="mb-7"><idp-scheduled-payments currency-type-id="vm.pulseContext.selectedCurrencyTypeID" scheduled-payments-info="vm.scheduledPaymentsInfo" selected-payment-option="vm.selectedPaymentOption" is-for-my-account="false"></idp-scheduled-payments></div><div ng-show="vm.showAutoBill"><div class="form-check"><input id="autoBill" name="autoBill" type="checkbox" ng-model="vm.signUpForBalloonPayment" class="form-check-input"> <label for="autoBill" class="form-check-label">Yes, please automatically bill any remaining balance on my account to this credit card <span ng-show="vm.paymentOptionsInfo.minBalanceDueDate">on {{vm.minBalanceDueDateFormatted}}, </span>in order to keep my account current and avoid late charges. (The credit card below will be used instead of any card I may have previously stated to be used for automatic payment.) <span ng-show="vm.paymentOptionsInfo.minDiscountPayDate">(NOTE: If you want to receive the {{vm.paymentOptionsInfo.payInFullDiscountNames}}, you must pay in full by {{vm.minDiscountPayDateFormatted}}.)"</span></label></div></div></div></form></div><div ng-show="vm.cart.currencyType.typeID == 25000 || (vm.cart.currencyType.typeID != 25000 && vm.selectedPaymentMethodTypeID)"><div><div ng-show="!vm.showPaymentInputFields" class="mb-3">No additional payment information is required.</div><div ng-show="vm.showPaymentInputFields"><form ng-show="vm.selectedPaymentMethodTypeID == Enums.PaymentMethodType.BankTransfer" name="frmBankTransfer" role="form" novalidate><div class="row"><div class="col-md-12"><div class="form-group"><label for="payments_os_bankcode" style="font-weight:bold;">Bank</label> <select name="payments_os_bankcode" class="form-control" ng-model="vm.selectedPaymentsOsBank" ng-required="true" ng-options="o as o.name for o in vm.paymentsOsBanks"><option value="">Please select a bank</option></select><div ng-messages="vm.frmBankTransfer.payments_os_bankcode.$error" class="text-danger"><div ng-message="required">A bank is required</div></div></div></div></div><div ng-show="vm.selectedPaymentOption && vm.selectedPaymentOption.paymentOptionTypeID == 1\n                || vm.cartContainsOPLAutoSubscriptions\n                || (vm.selectedPaymentsOsBank && vm.selectedPaymentsOsBank.supportsRecurringPayments)"><div>The following additional fields are required for recurring Bank Transfer payments.</div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="customerAccountName">Customer name on bank account</label> <input name="customerAccountName" type="text" class="form-control" placeholder="Customer Name On Bank Account" ng-model="vm.bankTransferInfo.customerAccountName" ng-required="vm.selectedPaymentOption && vm.selectedPaymentOption.paymentOptionTypeID == 1" maxlength="50" autocomplete="off" uib-tooltip="Customer Name On Bank Account" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmBankTransfer.customerAccountName.$error" class="text-danger"><div ng-message="required">Customer name on bank account is required</div><div ng-message="maxlength">The customer name on bank account must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="customerAccountNumber">Bank Account Number</label> <input name="customerAccountNumber" type="text" class="form-control" placeholder="Bank Account Number" ng-model="vm.bankTransferInfo.customerAccountNumber" ng-required="vm.selectedPaymentOption && vm.selectedPaymentOption.paymentOptionTypeID == 1" maxlength="50" autocomplete="off" uib-tooltip="Bank account number" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmBankTransfer.customerAccountNumber.$error" class="text-danger"><div ng-message="required">Bank account number is required</div><div ng-message="maxlength">The bank account number must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="customerAccountType">Account Type</label> <select name="customerAccountType" class="form-control" ng-model="vm.bankTransferInfo.customerAccountType" ng-required="vm.selectedPaymentOption && vm.selectedPaymentOption.paymentOptionTypeID == 1"><option value="">Account Type</option><option value="SAVINGS">Savings</option><option value="CURRENT">Current</option></select><div ng-messages="vm.frmBankTransfer.customerAccountType.$error" class="text-danger"><div ng-message="required">Account type is required</div></div></div></div></div></div></form><form ng-show="vm.selectedPaymentMethodTypeID == Enums.PaymentMethodType.Check" name="frmCheck" role="form" novalidate><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="checkNumber">Check Number</label> <input name="checkNumber" type="text" class="form-control" placeholder="Check Number" ng-model="vm.checkInfo.checkNumber" ng-required="true" maxlength="50" autocomplete="off" uib-tooltip="Check Number" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmCheck.checkNumber.$error" class="text-danger"><div ng-message="required">Check number is required</div><div ng-message="maxlength">The check number must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="receivedDate">Received Date</label> <input name="receivedDate" type="text" class="form-control" uib-datepicker-popup="{{vm.calendarObj_RecDate.format}}" ng-model="vm.checkInfo.receivedDate" ng-required="true" is-open="vm.calendarObj_RecDate.opened" placeholder="Received Date (mm/dd/yyyy)" datepicker-options="vm.calendarObj_RecDate.options" close-text="Close" alt-input-formats="vm.calendarObj_RecDate.altInputFormats" uib-tooltip="Received Date (mm/dd/yyyy)" tooltip-trigger="\'focus\'"> <i class="icon icon-calendar feedback-icon" ng-click="vm.calendarObj_RecDate.opened = true"></i><div ng-messages="vm.frmCheck.receivedDate.$error" class="text-danger"><div ng-message="required">Received date is required</div><div ng-message="date">Please enter a valid date</div></div></div></div><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="dated">Dated</label> <input name="dated" type="text" class="form-control" uib-datepicker-popup="{{vm.calendarObj_Dated.format}}" ng-model="vm.checkInfo.checkDated" ng-required="true" is-open="vm.calendarObj_Dated.opened" placeholder="Dated (mm/dd/yyyy)" datepicker-options="vm.calendarObj_Dated.options" close-text="Close" alt-input-formats="vm.calendarObj_Dated.altInputFormats" uib-tooltip="Dated (mm/dd/yyyy)" tooltip-trigger="\'focus\'" style="padding-right:0px; margin:0px; width:100%"> <i class="icon icon-calendar feedback-icon" ng-click="vm.calendarObj_Dated.opened = true"></i><div ng-messages="vm.frmCheck.dated.$error" class="text-danger"><div ng-message="required">Dated is required</div><div ng-message="date">Please enter a valid date</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="sr-only" for="issuerOne">Issuer One</label> <input name="issuerOne" type="text" class="form-control" placeholder="First Issuer" ng-model="vm.checkInfo.issuerOne" ng-required="true" maxlength="100" autocomplete="off" uib-tooltip="First Issuer" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmCheck.issuerOne.$error" class="text-danger"><div ng-message="required">First Issuer is required</div><div ng-message="maxlength">The first issuer must be 100 characters or less</div></div></div></div><div class="col-md-6"><div class="form-group"><label class="sr-only" for="IssuerTwo">Issuer Two</label> <input name="issuerTwo" type="text" class="form-control" placeholder="Second Issuer" ng-model="vm.checkInfo.issuerTwo" ng-required="true" maxlength="100" autocomplete="off" uib-tooltip="Second Issuer" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmCheck.issuerTwo.$error" class="text-danger"><div ng-message="required">Second Issuer is required</div><div ng-message="maxlength">The second issuer must be 100 characters or less</div></div></div></div></div></form><form ng-show="vm.selectedPaymentMethodTypeID == Enums.PaymentMethodType.CreditCard" name="frmCreditCard" role="form" novalidate><div class="row"><div class="col-md-12"><div><div style="max-width:367px;margin: 0 auto 10px;"><img style="max-width: 100%;height: auto;width: auto\\9;" src="{{vm.appRoot}}assets/images/credit-cards-icons-lg.png"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="nameOnCard">Name on Card</label> <input name="nameOnCard" class="form-control" placeholder="Name On Card" ng-model="vm.creditCardInfo.nameOnCard" ng-required="true" maxlength="50" autocomplete="cc-name" uib-tooltip="Name On Card" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmCreditCard.nameOnCard.$error" class="text-danger"><div ng-message="required">Name On Card is required</div><div ng-message="maxlength">The name on card must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="creditCardNumber">Credit Card Number</label> <input name="creditCardNumber" class="form-control" placeholder="Card Number" ng-model="vm.creditCardInfo.creditCardNumber" ng-required="true" maxlength="50" autocomplete="cc-number" uib-tooltip="Card Number" tooltip-trigger="\'focus\'" idp-numbers-only><div ng-messages="vm.frmCreditCard.creditCardNumber.$error" class="text-danger"><div ng-message="required">Credit Card Number is required</div><div ng-message="maxlength">The credit card number must be 50 digits or less</div></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group" uib-tooltip="Expiration Month" tooltip-trigger="\'focus\'"><label class="sr-only" for="expMonth">Expiration Month</label> <select name="expMonth" class="form-control" ng-model="vm.selectedExpMonth" autocomplete="cc-exp-month" convert-to-number ng-required="true" ng-options="month.name for month in vm.expirationMonths"><option value="">Expiration Month</option></select><div ng-messages="vm.frmCreditCard.expMonth.$error" class="text-danger"><div ng-message="required">Expiration Month is required</div></div></div></div><div class="col-sm-6"><div class="form-group" uib-tooltip="Expiration Year" tooltip-trigger="\'focus\'"><label class="sr-only" for="expYear">Expiration Year</label> <select name="expYear" class="form-control" ng-model="vm.selectedExpYear" autocomplete="cc-exp-year" convert-to-number ng-required="true" ng-options="year.name for year in vm.expirationYears"><option value="">Expiration Year</option></select><div ng-messages="vm.frmCreditCard.expYear.$error" class="text-danger"><div ng-message="required">Expiration Year is required</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="creditCardCVV">Credit Card CVV</label> <input name="creditCardCVV" class="form-control" maxlength="4" placeholder="CVV" ng-model="vm.creditCardInfo.creditCardCVV" ng-required="true" autocomplete="cc-csc" uib-tooltip="CVV" tooltip-trigger="\'focus\'" idp-numbers-only> <i id="creditCardIDHelp" class="icon icon-info feedback-icon" ng-click="vm.showCreditCardIdHelp()"></i><div ng-messages="vm.frmCreditCard.creditCardCVV.$error" class="text-danger"><div ng-message="required">CVV is required</div><div ng-message="maxlength">The CVV must be 4 digits or less</div></div></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.getHasError(vm.frmCreditCard.postalCode)}"><label class="sr-only" for="postalCode">Postal Code</label> <input name="postalCode" class="form-control" maxlength="20" placeholder="Zip Code" ng-model="vm.creditCardInfo.postalCode" autocomplete="billing postal-code" uib-tooltip="Zip Code" tooltip-trigger="\'focus\'"><div style="margin-top:3px;">(00000 for international)</div></div></div></div><div class="row" ng-show="vm.showBillingAddressFields"><div class="col-md-12"><div class="form-group" uib-tooltip="Country" tooltip-trigger="\'focus\'"><label class="sr-only" for="countryType">Country</label> <select name="countryType" class="form-control" ng-model="vm.selectedCountryType" autocomplete="billing country" ng-required="vm.showBillingAddressFields" ng-options="countryType.typeString for countryType in vm.countryTypes"><option value="">Country</option></select><div ng-messages="vm.frmCreditCard.countryType.$error" class="text-danger"><div ng-message="required">Country is required</div></div></div></div></div><div class="row" ng-show="vm.showBillingAddressFields"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="address1">Billing Address Line 1</label> <input name="address1" class="form-control" placeholder="Billing Address Line 1" ng-model="vm.creditCardInfo.address1" ng-required="vm.showBillingAddressFields" maxlength="100" autocomplete="billing address-line1" uib-tooltip="Address Line 1" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmCreditCard.address1.$error" class="text-danger"><div ng-message="required">Billing address line 1 is required</div><div ng-message="maxlength">The billing address line 1 must be 100 characters or less</div></div></div></div></div><div class="row" ng-show="vm.showBillingAddressFields"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="address2">Billing Address Line 2</label> <input name="address2" class="form-control" placeholder="Billing Address Line 2" ng-model="vm.creditCardInfo.address2" maxlength="100" autocomplete="billing address-line2" uib-tooltip="Address Line 2" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmCreditCard.address2.$error" class="text-danger"><div ng-message="maxlength">The billing address line 2 must be 100 characters or less</div></div></div></div></div><div class="row" ng-show="vm.showBillingAddressFields"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="city">{{vm.cityFieldTitle}}</label> <input name="city" class="form-control" placeholder="{{vm.cityFieldTitle}}" ng-model="vm.creditCardInfo.city" ng-required="vm.showBillingAddressFields" maxlength="50" autocomplete="billing address-level2" uib-tooltip="{{vm.cityFieldTitle}}" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmCreditCard.city.$error" class="text-danger"><div ng-message="required">{{vm.cityFieldTitle}} is required</div><div ng-message="maxlength">{{vm.cityFieldTitle}} must be 50 characters or less</div></div></div></div></div><div class="row" ng-show="vm.showBillingAddressFields"><div class="col-md-12"><div class="form-group" ng-show="vm.showStateInputField"><label class="sr-only" for="state">{{vm.stateFieldTitle}}</label> <input name="state" class="form-control" placeholder="{{vm.stateFieldTitle}}" ng-model="vm.creditCardInfo.state" ng-required="vm.showBillingAddressFields && vm.showStateInputField" maxlength="50" autocomplete="billing address-level1" uib-tooltip="{{vm.stateFieldTitle}}" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmCreditCard.state.$error" class="text-danger"><div ng-message="required">{{vm.stateFieldTitle}} is required</div><div ng-message="maxlength">{{vm.stateFieldTitle}} must be 50 characters or less</div></div></div><div class="form-group" uib-tooltip="{{vm.stateFieldTitle}}" tooltip-trigger="\'focus\'" ng-show="vm.showProvinceSelectField"><label class="sr-only" for="provinceType">{{vm.stateFieldTitle}}</label> <select name="provinceType" class="form-control" ng-model="vm.selectedProvinceType" autocomplete="billing address-level1" ng-required="vm.showBillingAddressFields && vm.showProvinceSelectField" ng-options="provinceType.typeString for provinceType in vm.canadianProvinceTypes"><option value="">Select Province</option></select><div ng-messages="vm.frmCreditCard.provinceType.$error" class="text-danger"><div ng-message="required">{{vm.stateFieldTitle}} is required</div></div></div><div class="form-group" uib-tooltip="{{vm.stateFieldTitle}}" tooltip-trigger="\'focus\'" ng-show="vm.showStateSelectField"><label class="sr-only" for="stateType">{{vm.stateFieldTitle}}</label> <select name="stateType" class="form-control" ng-model="vm.selectedStateType" autocomplete="billing address-level1" ng-required="vm.showBillingAddressFields && vm.showStateSelectField" ng-options="stateType.typeString for stateType in vm.stateTypes"><option value="">Select State</option></select><div ng-messages="vm.frmCreditCard.stateType.$error" class="text-danger"><div ng-message="required">{{vm.stateFieldTitle}} is required</div></div></div></div></div><div class="row" ng-show="vm.showBillingAddressFields"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.getHasError(vm.frmCreditCard.postalCode)}"><label class="sr-only" for="zipOrPostalCode">{{vm.zipFieldTitle}}</label> <input name="zipOrPostalCode" class="form-control" maxlength="20" placeholder="{{vm.zipFieldTitle}} (00000 for international)" ng-model="vm.creditCardInfo.postalCode" ng-required="vm.showBillingAddressFields" autocomplete="billing postal-code" uib-tooltip=">{{vm.zipFieldTitle}} (00000 for international)" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmCreditCard.zipOrPostalCode.$error" class="text-danger"><div ng-message="required">{{vm.zipFieldTitle}} is required</div><div ng-message="maxlength">{{vm.zipFieldTitle}} must be 20 characters or less</div></div></div></div></div></form><form ng-show="vm.selectedPaymentMethodTypeID == Enums.PaymentMethodType.MoneyOrder" name="frmMoneyOrder" role="form" novalidate><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="serialNumber">Serial Number</label> <input name="serialNumber" type="text" class="form-control" placeholder="Serial Number" ng-model="vm.checkInfo.checkNumber" ng-required="true" maxlength="50" autocomplete="off" uib-tooltip="Serial Number" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmMoneyOrder.serialNumber.$error" class="text-danger"><div ng-message="required">Serial Number is required</div><div ng-message="maxlength">The serial number must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="receivedDate">Received Date</label> <input name="receivedDate" type="text" class="form-control" uib-datepicker-popup="{{vm.calendarObj_RecDate.format}}" ng-model="vm.checkInfo.receivedDate" is-open="vm.calendarObj_RecDate.opened" placeholder="Received Date (mm/dd/yyyy)" datepicker-options="vm.calendarObj_RecDate.options" required close-text="Close" alt-input-formats="vm.calendarObj_RecDate.altInputFormats" uib-tooltip="Received Date (mm/dd/yyyy)" tooltip-trigger="\'focus\'" style="padding-right:0px; margin:0px; width:100%"> <i class="icon icon-calendar feedback-icon" ng-click="vm.calendarObj_RecDate.opened = true"></i><div ng-messages="vm.frmMoneyOrder.receivedDate.$error" class="text-danger"><div ng-message="required">Received date is required</div><div ng-message="date">Please enter a valid date</div></div></div></div><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="dated">Dated</label> <input name="dated" type="text" class="form-control" uib-datepicker-popup="{{vm.calendarObj_Dated.format}}" ng-model="vm.checkInfo.checkDated" is-open="vm.calendarObj_Dated.opened" placeholder="Dated (mm/dd/yyyy)" datepicker-options="vm.calendarObj_Dated.options" required close-text="Close" alt-input-formats="vm.calendarObj_Dated.altInputFormats" uib-tooltip="Dated (mm/dd/yyyy)" tooltip-trigger="\'focus\'" style="padding-right:0px; margin:0px; width:100%"> <i class="icon icon-calendar feedback-icon" ng-click="vm.calendarObj_Dated.opened = true"></i><div ng-messages="vm.frmMoneyOrder.dated.$error" class="text-danger"><div ng-message="required">Dated is required</div><div ng-message="date">Please enter a valid date</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="from">From</label> <input name="from" type="text" class="form-control" placeholder="From" data-ng-model="vm.checkInfo.issuerOne" ng-required="true" maxlength="100" autocomplete="off" uib-tooltip="From" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmMoneyOrder.from.$error" class="text-danger"><div ng-message="required">From is required</div><div ng-message="maxlength">The from field must be 100 characters or less</div></div></div></div></div></form></div></div><div ng-if="vm.cartContainsCourseProduct || vm.cartContainsOPLAutoSubscriptions"><div ng-if="vm.hasNonCampAtHqLocation || vm.cartContainsVIPEarlyAccess"><div class="mt-1"><h4>ON-CAMPUS PROGRAMS</h4></div><div class="my-3">Unlimited changes/easy cancellation. You can make unlimited changes\u2014<i>with no fees</i>\u2014up to 14 days before the start of your session. If you need to cancel, you will receive a refund of the amount paid, less the payment plan fee (if any) and the deposit of $250 per week. No refunds are provided for cancellations made within 14 days of the start of your session.</div></div><div ng-if="vm.cartContainsOPLAutoSubscriptions"><div class="mt-1"><h4>ONLINE PRIVATE LESSONS</h4></div><div class="my-3">Scheduling freedom. Lessons are available 24/7 to fit your student\'s busy schedule. No risk\u2014you can cancel your subscription at any time from My Account.</div></div><div ng-if="vm.hasSmallGroupSemesters"><div class="mt-1"><h4>ONLINE SMALL GROUP COURSES</h4></div><div class="my-3">Ultimate flexibility. You can make unlimited changes\u2014with no fees\u2014up to 48 hours before your session.</div></div><div ng-if="vm.hasBootcamp || vm.hasVtcOrVta"><div id="divFlexibility" class="mt-1"><h4>{{vm.bootcampVtcVtaLabel}}</h4></div><div class="my-3">Ultimate flexibility. You can make unlimited changes\u2014with no fees\u2014up to 48 hours before your session.</div></div><div ng-if="vm.hasCampAtHqLocation"><div class="mt-1"><h4>AS TO YOUR EMPLOYER-SPONSORED PROGRAM</h4><span style="text-decoration: underline;">Deposits</span>: Upon registration, you will be required to pay a minimum nonrefundable deposit amount for each course.</div><div class="my-3"><span style="text-decoration: underline;">Changes</span>: You have the flexibility to modify your course as many times as you like\u2014without any fees\u2014up until 21 days before your camp start date. Up until 21 days before your camp start date you may also change to one of our regular camps and any funds directly paid by you will be applied to your new registration. No changes are allowed within 21 days of your camp start date.</div><div class="my-3"><span style="text-decoration: underline;">Cancellations</span>: If you cancel more than 21 days from your camp start date, you will receive a refund of the amounts directly paid by you, minus the nonrefundable deposit amount for each course canceled. Refunds will not be issued for courses canceled within 21 days of your camp start date and you will be responsible for the entire registration cost.</div></div></div><div ng-if="vm.hasOnlyProductCouponProducts"><div class="my-3"><h4>SEASON PASSES</h4>Virtual Tech Camps Season Passes are non-refundable, and all courses must be taken in the term for which they are purchased. You have the flexibility to transfer any Virtual Tech Camps Season Pass courses to family members or friends.</div></div><div ng-if="vm.cartContainsVIPEarlyAccess"><div class="my-3"><h4>VIP PASS</h4>$250 purchase price is non-refundable and will be automatically applied as a credit towards any purchase made on or after November 1st, 2023. Credit can be transferred to a friend or family member in the event you no longer wish to enroll. Credit and promo code can be used for Summer 2024 course at iD Tech Camps, iD Tech Academies, Virtual Tech Camps, and Online Academies. Promo code expires 11:59 pm PT on November 14, 2023. Promo code cannot be combined with other offers.</div></div></div><div ng-show="(vm.cart.currencyType.typeID && (vm.cart.currencyType.typeID == 25000 || (vm.cart.currencyType.typeID != 25000 && vm.selectedPaymentMethodTypeID)))\n        && vm.isReady && vm.canSee" style="background-color: #f7f7f7;"><div class="container py-3"><div class="row"><div class="col-xs-12" style="font-weight:bold;text-align:left;font-size:24px;">Your total: {{vm.balanceDue | currency:vm.currencyTypeID:2}}</div></div><div ng-show="vm.showTodaysPayment" class="row" style="margin-top:10px;"><div class="col-xs-12" style="font-weight:bold;text-align:left;">Due today: {{vm.selectedPaymentOption.paymentAmount | currency:vm.currencyTypeID:2}}</div></div><form ng-show="!vm.isImpersonating && !vm.isInChangeProcess" name="frmSignature" role="form" novalidate><div class="row my-3"><div class="col-12">By clicking submit below you agree to the iD Tech <a ng-click="vm.showTermsAndConditions()" href="">Terms & Conditions</a> and authorize payment for the amount listed above and any future payments.</div></div></form><div class="row justify-content-end" style="margin-top:5px;margin-bottom:15px;"><div class="col-12 col-md-6"><button ng-show="vm.balanceDue > 0" class="btn btn-primary btn-block" style="width:100%;" ng-class="{disabled: vm.submitOrderDisabled}" ng-disabled="vm.submitOrderDisabled" ng-click="vm.submitOrder()" idp-click-tracking>Submit secure payment</button> <button ng-show="vm.balanceDue <= 0" class="btn btn-primary btn-block" style="width:100%;" ng-class="{disabled: vm.submitOrderDisabled}" ng-disabled="vm.submitOrderDisabled" ng-click="vm.submitOrder()" idp-click-tracking>SUBMIT</button></div></div></div></div></div><div id="content" ng-show="vm.isReady && vm.canSee == false" style="text-align:center;"><span style="color:#f00;">You do not have permission for this view.</span></div></div></div><script type="text/ng-template" id="termStaffBalanceDueWarning.html"><p>\n    <span style=\'color:#ff0000;\'>\n      Our records indicate that this transaction leaves a\n      {0} balance. Please contact Client Services for the breakdown of charges.\n      Payment must be collected within 24 hours of this transaction.\n      Please re-submit the payment to finish processing this transaction.\n    </span>\n  </p></script>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/chooseExperience.html','<div class="reg-flow" data-ng-show="vm.canSee"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="reg-flow-main-container"><div class="content-container"><idp-walkthrough-selected-location location-name="vm.selectedLocName" on-click="vm.goToLocations()"></idp-walkthrough-selected-location><idp-walkthrough-nav steps="vm.navSteps" current-step="vm.currentStep" change-step-fn="vm.regFlowMgr.goToStep(step)"></idp-walkthrough-nav><h3 class="view-title">Next, choose an Experience they&#39;ll never forget.</h3><p class="view-instructions">Select one or multiple</p><debug-display-data debug-data="vm.expFinderMgr.selectedIDs"></debug-display-data><idp-walkthrough-list-selectables selectables="vm.expFinderMgr.optionItems" selected-ids="vm.expFinderMgr.selectedIDs" media-server-resource-path="vm.mediaServerResourcePath" toggle-selection="vm.toggleSelection(genreID)"></idp-walkthrough-list-selectables><idp-walkthrough-skip-to-step button-text="\'SHOW ME ALL COURSES\'" button-action="vm.showAllCourses()"></idp-walkthrough-skip-to-step></div></div><idp-walkthrough-form-submit-button message="\'\'" button-text="\'Next step\'"></idp-walkthrough-form-submit-button></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/chooseLocation.html','<div class="container"><div class="text-md-center my-4 my-md-8"><h2>Explore our programs</h2><p class="mt-3">To view our courses, choose a program below!</p></div><idp-location-region-group class="d-block mb-6" ng-repeat="regionGroup in vm.regionGroups" location-click-handler="vm.selectLocation(location)" region-group="regionGroup"></idp-location-region-group></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/choosePath.html','<div class="reg-flow" data-ng-show="vm.canSee"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="reg-flow-main-container"><div class="content-container"><h1 class="page-title"><span class="hidden-xs">Narrow down your course options by selecting one or multiple Paths. </span><span class="visible-xs-block">Select one or multiple paths below.</span></h1><idp-rf-step-filters-panel></idp-rf-step-filters-panel><debug-display-data debug-data="vm.genreFinderMgr.selectedIDs"></debug-display-data><idp-walkthrough-list-selectables selectables="vm.genreFinderMgr.optionItems" selected-ids="vm.genreFinderMgr.selectedIDs" media-server-resource-path="vm.mediaServerResourcePath" toggle-selection="vm.toggleSelection(genreID)"></idp-walkthrough-list-selectables><idp-walkthrough-skip-to-step button-text="\'SHOW ME ALL COURSES\'" button-action="vm.showAllCourses()"></idp-walkthrough-skip-to-step></div></div><idp-walkthrough-form-submit-button message="\'\'" button-text="\'Next step\'"></idp-walkthrough-form-submit-button></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/orderConfirmation.html','<div id="content" class="order-confirmation"><div ng-show="vm.isOrderConfirmationRetrieved && vm.canSee" class="container-fluid px-0"><div class="order-confirmation-header"><div class="row pb-4 mx-0"><div class="col-12 col-lg-7 col-xl-8 my-autopl-3 px-lg-7"><div class="font-weight-bold d-flex justify-content-center justify-content-lg-start"><img class="mr-3" ng-src="{{ ::vm.congratsImageSrc }}" alt="Congrats" title="Congrats"><div><div class="header-text idp-text-gradient">{{vm.hasPurchasedOnlyProductCouponProducts ? \'Success!\' : \'Congratulations!\'}}</div><div class="text-black">Here\'s your registration confirmation:</div><span><span class="text-black">Order</span> <a ng-click="vm.downloadOrderPDF()" role="button" href="">#{{::vm.orderConfirmationInfo.orderNumber}}</a></span></div></div></div><div class="col-12 col-lg-5 col-xl-4 col-xl-3 mt-3 px-5 px-lg-0" ng-show="vm.showRaf"><div class="text-white p-4 mr-lg-6 mr-xl-10 font-weight-bold rounded text-center text-small bg-green-gradient">Get a $25 credit for each friend who registers using your referral code below. Your friends will save, too! (Valid only for students who are new to iD Tech.)<br>Use code: {{vm.orderConfirmationInfo.rafNumber}}</div></div></div></div><div class="pb-10 bg-white"><div class="row pb-5 justify-content-center mx-0"><div class="order-xs-12 order-lg-1 col-lg-7 col-xl-8 mt-5 mt-lg-0 px-0" ng-hide="vm.hasPurchasedOnlyProductCouponProducts || !vm.hasCoursesOrTutorOrVirtualCampsOrSquads"><div class="h2-responsive pt-3 pt-lg-7 font-weight-bold rounded mt-lg-0 px-lg-7 px-5 text-black">Share the excitement and invite your friends!</div><section class="student-products pl-5 pl-lg-7 py-6" ng-show="participant.courses && participant.courses.length > 0" ng-repeat="participant in vm.pulseContext.regFlowMgr.paymentMgr.shoppingCartPurchaseResult.orderConfirmationInfo.participants"><div class="text-black font-weight-bold text-em-1-25">{{participant.preferredName ? participant.preferredName:participant.firstName}} {{participant.lastName}}</div><div class="d-flex flex-wrap student-product"><div class="mt-3" ng-repeat="course in participant.courses"><div class="rounded mr-3 mr-md-6"><idp-order-confirmation-product product="course" participant="participant" raf-code="vm.orderConfirmationInfo.rafNumber"></idp-order-confirmation-product></div></div></div></section></div><div class="order-xs-1 order-lg-12 col-lg-5 col-xl-4 text-black px-5 px-8 py-7 mr-0" ng-class="{\'bg-lightgray\': vm.hasCoursesOrVirtualCampsOrSquads,\r\n             \'col-lg-5 col-xl-4\': !vm.hasPurchasedOnlyVIPEarlyAccess,\r\n             \'col-lg-10 col-xl-8\': vm.hasPurchasedOnlyVIPEarlyAccess}"><section class="pb-3"><div class="h3-responsive d-inline-block idp-green-text-highlight">What\'s next?</div><div ng-if="vm.hasPurchasedTutorProducts"><a href="#/my-account/online-private-lesson/clientSessions" title="Schedule your lessons" class="font-weight-bold">Schedule your lessons</a> <span style="color:#4c4c4c;">using the Online Lessons page in My Account.</span> <span ng-if="vm.hardware" style="color:#4c4c4c;">Your purchase includes the following hardware: {{::vm.hardware}}. To allow time for shipping, please schedule your first lesson for after {{::vm.scheduleDateWhenHardware}}. The hardware will be sent to the mailing address you provided.</span><div class="mt-3">We have sent a confirmation email to:<div class="font-weight-bold">{{vm.primaryEmail}}</div></div></div><div ng-hide="vm.hasPurchasedOnlyVIPEarlyAccess || vm.hasPurchasedTutorProducts">We\'ll notify you of your next steps via email at:<div class="font-weight-bold">{{vm.primaryEmail}}</div></div><div class="mt-3" ng-show="vm.hasPurchasedOnlyProductCouponProducts">You can expect to receive a purchase confirmation email followed by an email containing the unique codes you\'ll redeem to secure your preferred {{vm.divisionNameOfFirstProduct}} sessions.</div><div class="mt-3" ng-show="vm.hasPurchasedOnlyVIPEarlyAccess"><ol><li>This fall, your VIP pass will arrive! We\u2019ll email you your exclusive promo code for $200 off camps & virtual academies and $400 off in-person academies.</li><li>Starting November 1, 2023, your early access to register for next summer begins (five days before we announce to the general public).</li><li>Once you add the perfect courses to your cart, remember to enter your exclusive promo code. Your $250 credit will automatically be applied to your purchase during checkout.</li></ol><div>To review the details of your VIP Pass purchase, visit the VIP page in the billing section of My Account.</div><h3 class="h3-responsive d-inline-block idp-green-text-highlight mt-3">Questions about your VIP Pass?</h3><div>Call our Camp Specialists at 1-888-709-8324 or email <a href="mailto:VIP@idtech.com">VIP@idtech.com</a>.</div></div></section><section class="py-3" ng-show="vm.hasPurchasedOnlyTutorOrSquadOrVirtualCampProducts && !vm.hasPurchasedOnlyVIPEarlyAccess"><div class="h3-responsive d-inline-block idp-green-text-highlight">Don\'t see your confirmation email?</div><div style="color:#4c4c4c;">Be sure to check your spam folder. All communications are sent from <nobr>do-not-reply@idtechnotifications.com</nobr>. You can also log into <a href="#/my-account" title="My Account" class="font-weight-bold">My Account</a> at any time to view your order details.</div></section><section class="py-3" ng-if="!vm.hasPurchasedOnlyVIPEarlyAccess"><div class="h3-responsive d-inline-block idp-green-text-highlight">Questions about your purchase?</div><div><span style="color:#4c4c4c;">Jump to our</span> <a target="_blank" href="https://help.idtech.com" title="My Account" class="font-weight-bold">Help Center</a>.</div></section><section class="py-3" ng-show="vm.isFormsAvailable"><div class="h3-responsive d-inline-block idp-green-text-highlight">Health & Safety form</div><div style="color:#4c4c4c;">While you\'re at it\u2026 complete your required<br>Health & Safety form.</div><div class="mt-3" style="color:#4c4c4c;">This only takes about 10 minutes to complete!</div><div class="mt-3 row"><div class="col-xl-10 col-12"><button class="btn btn-block btn-outline-secondary" ng-click="vm.navigateToRequiredForm()">Complete your form</button></div></div></section></div></div></div></div><img ng-if="vm.isOrderConfirmationRetrieved && vm.rakutanImageUrl" ng-src="{{ ::vm.rakutanImageUrl }}" width="1" height="1" border="0"></div><div ng-show="vm.isOrderConfirmationRetrieved && vm.canSee == false"><span class="text-danger">You do not have permission for this view.</span></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/orderSummary.html','<div class="reg-flow container"><div class="row justify-content-center"><idp-student-merge-popup popup-id="studentMergePopup"></idp-student-merge-popup><form id="{{::vm.formName}}" name="{{::vm.formName}}" class="col-12 col-md-10 col-lg-8" role="form" novalidate idp-form-focus-on-err><h3 class="text-strong">Order Summary</h3><div data-ng-cloak ng-show="vm.canSee && vm.isCartRetrieved"><div class="well-lg" ng-show="vm.isCartEmpty"><p>Your shopping cart is empty</p><button ng-if="!vm.pulseContext.isRunningInPartnerDomain" class="btn btn-primary" type="button" ng-click="vm.addCourseWhenNoneInCart()">Add Course</button></div><idp-cart reminders="false" cart="vm.cart" ng-hide="vm.isCartEmpty" mode="vm.ShoppingCartUIMode.MODE_ORDER_SUMMARY" api="vm.cartCtrlAPI"></idp-cart></div><div data-ng-cloak ng-show="vm.canSee == false"><span class="text-danger">You do not have permission for this view.</span></div></form></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/productAvailability.html','<div class="product-availability"><idp-pav-drawer-step current-step="vm.pulsePass.currentStep" drawer-style="vm.drawerStyle"></idp-pav-drawer-step><div ng-if="!vm.showOrderConfirmation && !vm.showGroupWith"><header class="p-2 p-sm-3 {{vm.drawerStyle.drawerHeaderBackground}}" ng-show="vm.showDrawerStep"><h3 class="mb-0 idp-drawer-focus {{vm.drawerStyle.drawerHeaderText}}" ng-if="!vm.drawerStyle.is2022Design" tabindex="-1">Prices and Dates</h3><div><div class="d-flex align-items-center my-2"><span class="icon icon-globe mr-2 text-lg-right text-em-1-5 {{vm.drawerStyle.drawerHeaderText}}" ng-if="!vm.drawerStyle.is2022Design" aria-hidden="true"></span> <label for="timezone" class="font-weight-bold {{vm.drawerStyle.drawerHeaderText}}">Your Time Zone</label></div><div class="row"><div class="col-12"><select ng-options="type.typeID as type.typeExtraLongString for type in vm.timeZoneTypes" ng-change="vm.updateSelectedTimeZoneTypeID()" class="form-control" name="timezone" id="timezone" ng-model="vm.selectedTimeZoneTypeID"></select></div></div></div></header><div ng-if="vm.noTimeInTimeZone" class="pl-3 pt-4 {{vm.drawerStyle.drawerBodyBackground}}">No times found for current selected time zone.</div><div class="{{vm.drawerStyle.drawerBodyBackground}} p-3" style="min-height: 80vh;" ng-if="vm.dataset"><div ng-show="(vm.isSquads || vm.isCourseBundle) && vm.showDayOptions" class="my-3"><div class="{{vm.drawerStyle.drawerBodyText}} font-weight-bold">This course meets 1 lesson per week for {{vm.getWeeksCount()}} weeks</div><div class="{{vm.drawerStyle.drawerBodyText}} mt-2">What day do you want to start?</div><div class="{{vm.drawerStyle.buttonDayGroup}}"><button ng-repeat="d in vm.availableDays" class="btn {{vm.drawerStyle.buttonPrimary}} mt-3 ml-2 font-weight-bold" type="button" ng-class="vm.isSelectedDay(d) ? \'selected\':\'\'" ng-click="vm.selectDay(d)">{{d.shortName}}</button></div><div class="{{vm.drawerStyle.drawerBodyText}} my-3" ng-show="vm.selectedDay"><strong>Your course will meet weekly every {{vm.selectedDay.longName}}</strong>.</div></div><idp-pav-catalog-date-ranges dataset="vm.dataset" catalog-date-ranges="vm.catalogDateRanges" prod-id="vm.prodId" selected-day="vm.selectedDay" drawer-style="vm.drawerStyle" ng-show="(vm.isSquads && vm.selectedDay) || (vm.isCourseBundle && vm.selectedDay) || (!vm.isSquads && !vm.isCourseBundle)"></idp-pav-catalog-date-ranges><div class="d-flex justify-content-center py-3" ng-if="!vm.pulseContext.isRunningInPartnerDomain && !vm.drawerStyle.is2022Design" ng-hide="vm.isSquads || vm.isCourseBundle"><button class="btn btn-link" ng-click="vm.redirectToWWWCourses()">View all Virtual Tech Courses</button></div><div class="d-flex justify-content-center py-3" ng-if="!vm.pulseContext.isRunningInPartnerDomainW && !vm.drawerStyle.is2022Design" ng-hide="vm.isSquads || vm.isCourseBundle"><button class="btn btn-link" ng-click="vm.redirectToWWWCourses()">Close</button></div></div></div><idp-pav-order-confirmation product="vm.mainProduct" is-squads="vm.isSquads" is-course-bundle="vm.isCourseBundle" ng-if="vm.mainProduct && vm.showOrderConfirmation"></idp-pav-order-confirmation><idp-group-with ng-if="vm.showGroupWith && vm.userBrowsingParticipantID" product="vm.mainProduct" browse-identifier="vm.browseIdentifier" user-browsing-participant-id="vm.userBrowsingParticipantID"></idp-group-with></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/productIpcDrawer.html','<div class="product-availability px-5"><div class="drawer-steps" ng-if="!vm.showOrderConfirmation"><idp-pav-drawer-step current-step="vm.pulsePass.currentStep" drawer-style="vm.drawerStyle"></idp-pav-drawer-step><div ng-if="vm.showSelectLocation"><idp-ipc-location-list location-list="vm.locationList"></idp-ipc-location-list></div><div ng-if="vm.isDateStep && vm.hasSessions"><idp-pav-session-dates dataset="vm.dataset" product-dates="vm.sessionList.productDates" drawer-style="vm.drawerStyle"></idp-pav-session-dates></div><div ng-if="vm.isExperienceStep"><idp-pav-experience session-product="vm.sessionProduct" products="vm.products"></idp-pav-experience></div><div ng-if="vm.regFormReady"><idp-pav-register-form main-product="vm.mainProduct" products="vm.products" selected-product="vm.selectedProduct" selected-session="vm.selectedSession" term-div="vm.termDiv" cross-sell-prods="vm.crossSellProds" session-payment-option="vm.sessionPaymentOption" alert-list="vm.alertList" drawer-style="vm.drawerStyle"></idp-pav-register-form></div></div><div ng-if="!vm.hasSessions" class="mb-4">Sorry no sessions are available for selected location.</div><div ng-show="vm.showFullAvcLink" class="text-center"><a href="{{ vm.fullAvcLink }}" class="btn btn-outline-dark btn-pill">View all courses at this location</a></div><div ng-if="vm.addToWaitList"><idp-avc-waitlist-form location="vm.location" product="vm.mainProduct"></idp-avc-waitlist-form></div><div class="drawer-confirmation" ng-if="vm.showOrderConfirmation"><idp-pav-order-confirmation product="vm.mainProduct" is-squads="vm.isSquads" is-course-bundle="vm.isCourseBundle" ng-if="vm.mainProduct && vm.showOrderConfirmation"></idp-pav-order-confirmation><idp-group-with ng-if="vm.showGroupWith && vm.userBrowsingParticipantID" product="vm.mainProduct" browse-identifier="vm.browseIdentifier" user-browsing-participant-id="vm.userBrowsingParticipantID"></idp-group-with></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/regFlowContactInfo.html','<div class="container"><div class="row"><div class="col-xs-12"><h3>One last step. Let\'s complete your profile.</h3><p>Please provide or verify your contact information below, then continue on to view your official order confirmation.</p></div></div><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><fieldset ng-disabled="!vm.canUpdate"><div class="row my-3"><div class="col-xs-12"><h4>Mailing Address</h4><idp-mailing-address address="vm.mailingAddress" first-tab-index="1" show-promotions-and-news-checkbox="false"></idp-mailing-address></div></div></fieldset><hr class="py-1"><div class="row mb-10 justify-content-end"><div class="col-md-4 mt-md-0 mt-3"><button type="submit" class="btn btn-primary btn-block" ng-disabled="!vm.canUpdate">View order confirmation</button></div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/regFlowDefault.html','');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/shoppingCart.html','<div class="spa-shopping-cart reg-flow container"><div class="row"><idp-login-popup popup-id="loginPopup"></idp-login-popup></div><div class="row"><idp-missing-info-popup></idp-missing-info-popup><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" class="col-12 offset-md-1 col-md-10 offset-lg-2 col-lg-8" novalidate idp-form-focus-on-err><div><h3 class="mb-1">Shopping Cart</h3><div><button type="button" class="btn btn-link bg-white pl-0" ng-if="vm.isChangeOrderCart" ng-click="vm.cancelCart()">Cancel Change Request</button><div data-ng-cloak ng-show="vm.canSee"><div class="card bg-light border" ng-show="vm.isCartEmpty"><div class="card-body"><p>Your shopping cart is empty</p><button ng-if="!vm.pulseContext.isRunningInPartnerDomain" class="btn btn-primary pr-6 pl-6" type="button" ng-click="vm.addCourseWhenNoneInCart()">Add Course</button></div></div><idp-cart reminders="true" cart="vm.cart" ng-hide="vm.isCartEmpty" mode="vm.ShoppingCartUIMode.MODE_SHOPPING_CART" api="vm.cartCtrlAPI"></idp-cart></div></div></div><div data-ng-cloak ng-show="vm.canSee == false"><span class="text-danger">You do not have permission for this view.</span></div></form></div><idp-reg-flow-admin-override-popup popup-id="adminOverridePopup"></idp-reg-flow-admin-override-popup></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/techRocket.html','<div class="reg-flow spa-upsell col-xs-12"><div class="row"><div class="col-xs-12"><div class="spa-icon-upsell-contianer"><div class="spa-icon-upsell-logo"></div></div></div><div class="col-xs-12"><br class="hide-mobile"><br class="hide-mobile"></div><div class="col-sm-6 col-sm-push-6 col-xs-12"><p class="head-start">Give your child a head start on camp with year-round online tech courses!</p><p class="register">Yes, I\u2019d like to add the following students:</p><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err><div id="content" style="margin: 0px 0.5em 0px 0.5em;"><div data-ng-cloak ng-show="vm.canSee && vm.isCartRetrieved"><idp-upsell-participant-list participants="vm.cart.participants"></idp-upsell-participant-list></div><div data-ng-cloak ng-show="vm.canSee == false" style="text-align:center;"><span style="color:#f00;">You do not have permission for this view.</span></div></div></form><div class="row"><div class="row my-3"><div class="col-sm-6 col-sm-push-3 col-xs-8 col-xs-push-2"><p><button class="btn btn-primary btn-block green-button" ng-click="vm.continue()" ng-dblclick="false">Review Order</button></p></div></div></div><hr class="show-mobile"><br class="show-mobile"></div><div class="col-sm-6 col-sm-pull-6 col-xs-12"><p class="upsell">Just a few of the exciting courses offered:</p><div class="spa-icon-upsell-courses"></div><div class="show-mobile"><hr><div class="spa-upsell-mobile-live-support"></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/tutoring.html','<div class="product-availability"><div ng-if="!vm.showOrderConfirmation"><div class="py-3 px-3 px-sm-6" style="min-height: 60vh;" ng-if="vm.dataset && vm.userBrowsingLoaded"><a href="#" ng-if="vm.drawerStyle.is2022Design" class="btn btn-text close {{vm.drawerStyle.buttonClose}}" data-dismiss="drawer"><span class="icon icon-left" aria-hidden="true"></span> Back to course page</a><idp-pav-session-time-drawer ng-show="vm.dataset.products" product="vm.tutorProd" products="vm.products" addon-products="vm.addonProducts" is-subscription="vm.isSubscription" drawer-style="vm.drawerStyle" reset-step="false" cross-sell-prods="vm.crossSellProds"></idp-pav-session-time-drawer><div class="d-flex flex-column align-items-center justify-content-center py-3"><div class="small mb-3" ng-show="vm.isSubscription">No risk, cancel anytime.</div><div ng-if="false"><button class="btn btn-link" ng-click="vm.cancel()" idp-click-tracking data-id-div-abbr="{{::vm.getDivisionAbbr()}}" data-id-product-id="{{::vm.mainProduct.productID}}">Cancel</button></div></div></div></div><idp-pav-order-confirmation product="vm.mainProduct" is-squads="vm.isSquads" is-tutoring="vm.isTutoring" ng-if="vm.mainProduct && vm.showOrderConfirmation"></idp-pav-order-confirmation></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/reg-flow/upsell.html','<div class="reg-flow spa-upsell"><div class="mx-auto"><div class="container" ng-if="!vm.pulseContext.isLoggedIn"><div class="row row-padded"><div class="col-xs-12"><div class="panel-gray-padded"><idp-login-panel class="no-border-shadow-transparent-bg" is-create-account-visible="false"></idp-login-panel></div></div></div></div><div class="container"><div class="row"><div class="col-12 py-md-2 text-center"><div class="h2-responsive text-black">Start learning today with Online Private Lessons</div></div></div></div><div class="mt-5" ng-hide="vm.isDiscountUiVisible"><div class="container"><div ng-show="vm.canSee && vm.areParticipantsBuilt"><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err><idp-upsell-participant-list participants="vm.participants" products="vm.upsellProducts" is-theme-pack="vm.isThemePack"></idp-upsell-participant-list></form></div></div></div><div class="container mt-3" ng-show="vm.isDiscountUiVisible"><div class="bg-light p-4"><idp-cart-discount-apply stye="display: block;" class="row container" cart="vm.cart"></idp-cart-discount-apply></div></div><div class="container mt-3"><div class="mt-5 mt-md-7" ng-show="vm.canSee && vm.areParticipantsBuilt"><div class="row justify-content-center"><div class="col-12 col-sm-6 col-md-5"><button type="submit" class="btn btn-primary btn-block" ng-dblclick="false" ng-click="vm.continue()" ng-disabled="vm.isContinueDisabled()" idp-click-tracking>Proceed to checkout</button></div></div><div class="row justify-content-center mt-3" ng-show="vm.doesCartHaveAtLeastOneNonTutorProduct"><div class="col-12 col-sm-6 col-md-5"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.removeProductsAndContinue()" ng-dblclick="false" idp-click-tracking>No thanks, Skip this</button></div></div><div class="pt-8">&nbsp;</div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/login-or-create-account/createAccount.html','<div class="container"><div class="row justify-content-center"><div class="col-12 col-md-8 col-lg-6"><h3>Create an Account</h3><idp-create-account></idp-create-account></div></div><div class="row justify-content-center align-items-center mt-3 mb-5"><div class="col-12 col-md-8 col-lg-6"><p class="text-center">Already have an account? <a class="font-weight-bold" data-ng-click="vm.onLoginClick()" href="">Log in</a></p></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/login-or-create-account/loginOrCreateAccount.html','<div ng-cloak class="container"><div class="row justify-content-center" ng-hide="vm.show3rdPartyAccountNotFoundView"><div ng-show="vm.showLogin" class="col-md-6 col-lg-5"><div class="row mb-2"><div class="col"><h3>Already Have an Account?</h3></div></div><div class="row"><div class="col-lg-10"><div class="alert alert-danger" ng-show="vm.signIn3rdPartyAccountNotFoundErr">{{vm.signIn3rdPartyAccountNotFoundErr}}</div><div class="my-3" ng-show="vm.signIn3rdPartyAccountNotFoundErr">{{::$root.StringConst.Info_3rPartyAuth_GoogleAccountLinkAccount_Msg}}</div><idp-login email-or-user-name="vm.emailOrUserName" first-tab-index="100" show-3rd-party-signin="vm.show3rdPartySignin"></div></div></div><div ng-show="vm.showCreate" class="col-md-6 col-lg-5 mt-md-0 mt-2"><div class="row text-center mb-2 mt-3 mt-md-0"><div class="col"><h3 class="font-weight-normal">New to iD Tech?</h3></div></div><div class="row"><div class="col col-md-8 offset-md-2"><button type="button" class="btn btn-outline-secondary btn-block" tabindex="200" data-ng-click="vm.createAccount()">Create Account</button></div></div></div><div ng-show="vm.showNewPassword" class="col-md-6 col-lg-4 mt-5"><idp-new-password is-active="vm.isNewPasswordVisible" user="vm.userForPasswordChange" old-password="vm.oldPassword"></div></div><div class="row justify-content-center" ng-show="vm.show3rdPartyAccountNotFoundView"><div ng-show="vm.showLogin" class="col col-sm-10 col-md-6 col-lg-5"><div class="row mb-2"><div class="col"><h3>Account not found</h3></div></div><div class="row justify-content-center"><div class="col-12"><div class="alert alert-danger" ng-show="vm.signIn3rdPartyAccountNotFoundErr">{{vm.signIn3rdPartyAccountNotFoundErr}}</div><idp-auth-account-not-found show-login-view="vm.showLoginView()" is-visible="vm.show3rdPartyAccountNotFoundView"></idp-auth-account-not-found><button class="btn btn-outline-secondary btn-block" ng-dblclick="false" ng-click="vm.closeAccountNotFoundView()">Cancel</button></div></div></div></div><div ng-show="!vm.showNewPassword" class="row justify-content-center"><div class="col-xs-12 col-md-9 text-center mt-6"><p>We collect information about you in your account. Click here to see our <a ng-href="{{vm.common.config.WWW_UrlRoot +\'/privacy-policy\'}}">Privacy Policy</a> to learn more about what we may collect and how we may use it.</p></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/idp-group-with.html','<div class="d-flex header px-3 py-5"><div class="image-container d-flex align-items-center"><img ng-src="{{$ctrl.imgSrc}}"></div><div class="d-flex flex-column ml-3"><div class="text-white header-text font-weight-bold">Request to group with friends!</div><hr class="divider w-100"><div class="text-white font-weight-bold text-small">Get a $25 credit each time a friend joins Squads using your referral code (provided after checkout). Referral code valid for new students only.</div></div></div><div class="p-3"><p class="mt-1">Whether you want to make new friends or invite your own, learning is even more fun together! You can add names below or skip this step.</p><form name="{{::$ctrl.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="$ctrl.submit()"><fieldset><div ng-repeat="f in $ctrl.friends track by $index" class="mt-2"><span class="font-weight-bold">Friend {{$index + 1}}</span> (optional)<div class="row"><div class="col-6 pr-1"><div class="form-group"><input class="form-control" maxlength="100" placeholder="Friend first name" ng-model="f.firstName"></div></div><div class="col-6 pl-1"><div class="form-group"><input class="form-control" maxlength="100" placeholder="Friend last name" ng-model="f.lastName"></div></div></div></div></fieldset><div class="d-flex align-items-center text-secondary c-pointer" ng-if="$ctrl.friends && $ctrl.friends.length < 9" ng-click="$ctrl.addFriend()"><i class="icon icon-plus-circle1 text-em-2-0 mr-2"></i> <a href="">Add more friends</a></div><div class="row justify-content-center mt-5"><div class="col-12 col-md-8"><button class="btn btn-success btn-text-sm btn-block" type="submit" ng-disabled="$ctrl.isSaveDisabled() || $ctrl.saveDisabled" idp-click-tracking data-id-action-text="Group With - Save and continue" data-id-div-abbr="{{::$ctrl.getDivisionAbbr()}}" data-id-product-id="{{::$ctrl.product.productID}}">Save and continue</button> <button class="btn btn-link btn-text-sm btn-block mt-3" type="button" ng-click="$ctrl.skip();" idp-click-tracking data-id-action-text="Group With - Skip this step" data-id-div-abbr="{{::$ctrl.getDivisionAbbr()}}" data-id-product-id="{{::$ctrl.product.productID}}">Skip this step</button></div></div><div class="text-muted text-small mt-3">* We do our best to accommodate requests to group with friends, however, we cannot make guarantees.</div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/dispatcher.html','<div class="dispatcher"><idp-tac-popup popup-id="idpTacPopup" is-popup-open="vm.isPopupOpen"></idp-tac-popup></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/resumeCart.html','<div class="container"><div class="d-flex justify-content-center"><div class="flex-basis-auto flex-grow-0 flex-shrink-1 text-center"><h3>You have an active registration in progress.</h3><h3>Please choose one of the options below.</h3><div class="m-5 d-flex flex-column align-items-stretch"><button class="btn btn-primary mb-5" ng-click="vm.resumeShoppingCart()">Continue Registration</button> <button class="btn btn-primary" ng-click="vm.goToMyAccount()">Go to My Account</button></div><a href="" ng-click="vm.emptyCartAndProceed()">Empty Shopping Cart and Continue to My Account</a></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/splash.html','<div class="container" ng-cloak><div class="row"><div class="col-sm-12 text-center"><h2>Would you like to:</h2></div></div><div class="row"><div class="col-sm-12 text-center"><img name="imgJobApp" id="imgJobApp" alt="Job Account" ng-src="{{vm.jobAccountImgUrl}}" ng-click="vm.goToMyJobAccount()"> <img name="imgucClient" id="imgClient" alt="Client Account" ng-src="{{vm.clientAccountImgUrl}}" ng-click="vm.goToMyClientAccount()"></div></div><div class="row justify-content-center mt-5"><div class="form-check"><input class="form-check-input" name="isAlwaysJobAcct" id="isAlwaysJobAcct" type="checkbox" ng-model="vm.isAlwaysToJobAccount"> <label class="form-check-label" for="isAlwaysJobAcct">Always take me straight to My Job Account</label></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/admin/idp-session-admin-staff.html','<form novalidate class="css-form"><div class="row filters"><div class="col-md-4"><label>Job Purview</label><div class="form-group"><select ng-model="vm.selectedJobPurviewType" class="form-control id-standard" ng-options="type.typeString for type in vm.jobPurViewTypes"><option value="">All</option></select></div></div><div class="col-md-4"></div></div><table class="table table-bordered"><thead><tr><th>Name</th><th>Preferred name</th><th>Job Genre</th><th data-ng-if="vm.canUpdate">Rehire?</th><th>Email</th><th class="center" data-ng-if="vm.canUpdate">Client Contact Request</th></tr></thead><tbody><tr ng-repeat="staff in vm.staffInfoList" id="{{::staff.staffAssignmentID}}"><td>{{::staff.fullName}}</td><td>{{::staff.nickName}}</td><td>{{::staff.genre}}</td><td data-ng-if="vm.canUpdate">{{::staff.rehireStatus}}</td><td><a ng-href="mailto:{{::staff.email}}">{{::staff.email}}</a></td><td class="center" data-ng-if="vm.canUpdate"><a ng-click="vm.onCreateLogClicked(staff)" class="btn btn-small btn-primary">Create Contact Request</a></td></tr></tbody></table></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/admin/idp-session-admin.html','<div class="row admin-session" ng-show="vm.canSee"><uib-accordion ng-if="vm.canSeePnlStaff" close-others="oneAtATime" class="w-100"><div uib-accordion-group is-open="vm.isPnlStaffOpen"><uib-accordion-heading><div data-ng-click="vm.onPnlStaffClick();">Staff <i class="ml-2 icon" ng-class="{\'icon-chevron-down\': vm.isPnlStaffOpen, \'icon-chevron-right\': !vm.isPnlStaffOpen}"></i></div></uib-accordion-heading><idp-session-admin-staff order-detail-id="vm.orderDetailId" student-user-id="vm.studentUserId" is-display="vm.isPnlStaffOpen"></idp-session-admin-staff></div></uib-accordion></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/alerts/idp-alerts.html','<fieldset ng-if="vm.canSee" ng-disabled="!vm.canUpdate"><div class="alert alert-info" role="alert" data-ng-repeat="alertItem in ::vm.alertList track by $index" data-ng-class="{\'info\': alertItem.itemPriorityType == $root.Enums.ActionItemPriorityType.Recommended }"><div class="row vertical-align vertical-align-not-xs"><div class="col-12 col-md-8 my-auto"><span data-ng-bind-html="alertItem.shortDesc | unsafe"></span><div class="id-alert-subtitle" data-ng-show="alertItem.subText" data-ng-bind="alertItem.subText">Please Note: Forms can take 4-7 business days for us to process</div></div><div class="col-10 col-md-4 mt-2 mt-md-0 mx-auto"><a class="btn btn-primary btn-block mt-3 mt-xs-0" target="{{alertItem.linkTarget}}" ng-class="{disabled: !vm.canUpdate}" data-ng-show="alertItem.linkName" href="{{::alertItem.url}}">{{::alertItem.linkName}}</a></div></div></div></fieldset>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/_debug/debug-display-data.html','<div ng-if="vm.isDebugEnabled"><p ng-click="vm.debug = !vm.debug" class="text-danger" style="width: 150px; cursor: pointer; font-size: 12px"><span ng-hide="vm.debug">[ + ] Show {{ vm.title || \'data\' }}!</span> <span ng-show="vm.debug">[ - ] Hide {{ vm.title || \'data\' }}!</span></p><pre ng-if="vm.isObject()" ng-show="vm.debug" style="width: 100%; max-height: 600px; overflow: scroll; font-size: 1rem;">{{ vm.debugData | json}}</pre><pre ng-if="!vm.isObject()" ng-show="vm.debug" ng-bind="vm.debugData" style="width: 100%; max-height: 600px; overflow: scroll; font-size: 1rem;">\n    </pre></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/channel-preference/idp-channel-pref-popup.html','<div id="{{::vm.popupId}}"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err><div class="modal-header"><h3 class="modal-title">{{::vm.title}}</h3><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.close()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><fieldset ng-disabled="!vm.canUpdate"><idp-contact-channels contact-channels="vm.contactChannels" user-addresses="vm.userAddresses" target-user="vm.targetUser" cancel-callback="vm.close()"></idp-contact-channels></fieldset></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/channel-preference/idp-contact-channels.html','<div ng-form="{{vm.formName}}" novalidate><b>Which types of messages would {{::vm.targetUser && vm.targetUser.userid && vm.targetUser.userid != vm.pulseContext.actingAsUser.userid ? vm.targetUser.firstName + \' \' + vm.targetUser.lastName : \'you\'}} like to receive?</b><div class="my-5" data-ng-show="vm.emailMethods && vm.emailMethods.length"><div ng-repeat="cm in vm.emailMethods track by $index"><div class="align-items-center my-2 d-flex"><i class="bi bi-envelope mr-2 text-lg-right text-em-2-0"></i> <span class="font-weight-bold text-black mr-1">Email:</span><b>{{::cm.contactMethod}}</b></div><div ng-repeat="channel in vm.checkBoxStates | filter:{contactMethod: cm.contactMethod} track by $index"><div class="row"><div class="col ml-2"><div class="form-check"><input class="form-check-input ng-pristine ng-untouched ng-valid ng-valid-required ng-not-empty" name="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}" id="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}" type="checkbox" ng-true-value="false" ng-false-value="true" ng-model="channel.newOptOut" ng-required="false" aria-invalid="false"> <label class="form-check-label" for="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}">{{::channel.contactChannelType.typeDescription}}</label></div></div></div></div></div></div><div class="my-5" data-ng-show="vm.phoneMethods && vm.phoneMethods.length"><div ng-repeat="cm in vm.phoneMethods track by $index"><div class="align-items-center my-2 d-flex"><i class="bi bi-phone-vibrate mr-2 text-lg-right text-em-2-0"></i> <span class="font-weight-bold text-black mr-1">Text(SMS):</span><b>{{::cm.contactMethod}}</b></div><div ng-repeat="channel in vm.checkBoxStates | filter:{contactMethod: cm.contactMethod} track by $index"><div class="row"><div class="col ml-2"><div class="form-check"><input class="form-check-input ng-pristine ng-untouched ng-valid ng-valid-required ng-not-empty" name="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}" id="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}" type="checkbox" ng-true-value="false" ng-false-value="true" ng-model="channel.newOptOut" ng-required="false" aria-invalid="false"> <label class="form-check-label" for="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}">{{::channel.contactChannelType.typeDescription}}</label></div></div></div></div></div></div><div class="my-5" data-ng-show="vm.mailMethods && vm.mailMethods.length"><div ng-repeat="cm in vm.mailMethods track by $index"><div class="align-items-center my-2 d-flex"><i class="bi bi-mailbox mr-2 text-lg-right text-em-2-0"></i> <span class="font-weight-bold text-black mr-1">Mail:</span><b>{{::cm.contactMethod}}</b></div><div ng-repeat="channel in vm.checkBoxStates | filter:{contactMethod: cm.contactMethod} track by $index"><div class="row"><div class="col ml-2"><div class="form-check"><input class="form-check-input ng-pristine ng-untouched ng-valid ng-valid-required ng-not-empty" name="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}" id="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}" type="checkbox" ng-true-value="false" ng-false-value="true" ng-model="channel.newOptOut" ng-required="false" aria-invalid="false"> <label class="form-check-label" for="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}">{{::channel.contactChannelType.typeDescription}}</label></div></div></div></div></div></div><div class="py-5"><div class="form-check" ng-show="vm.emailMethods && vm.emailMethods.length"><input class="form-check-input ng-pristine ng-untouched ng-valid ng-valid-required ng-not-empty" name="optOutAllEmail" id="optOutAllEmail" type="checkbox" ng-model="vm.optOutAllEmail" ng-change="vm.optOutAllEmailCicked()" ng-required="false" aria-invalid="false"> <label class="form-check-label" for="optOutAllEmail">Unsubscribe from all emails</label></div><div class="form-check" ng-show="vm.phoneMethods && vm.phoneMethods.length"><input class="form-check-input ng-pristine ng-untouched ng-valid ng-valid-required ng-not-empty" name="optOutAllText" id="optOutAllText" type="checkbox" ng-model="vm.optOutAllText" ng-change="vm.optOutAllTextCicked()" ng-required="false" aria-invalid="false"> <label class="form-check-label" for="optOutAllText">Unsubscribe from all text(SMS)</label></div><div class="form-check" ng-show="vm.mailMethods && vm.mailMethods.length"><input class="form-check-input ng-pristine ng-untouched ng-valid ng-valid-required ng-not-empty" name="optOutAllMail" id="optOutAllMail" type="checkbox" ng-model="vm.optOutAllMail" ng-change="vm.optOutAllMailCicked()" ng-required="false" aria-invalid="false"> <label class="form-check-label" for="optOutAllMail">Unsubscribe from all mail</label></div><div class="form-check"><input class="form-check-input ng-pristine ng-untouched ng-valid ng-valid-required ng-not-empty" name="optOutAll" id="optOutAll" type="checkbox" ng-model="vm.optOutAll" ng-change="vm.optOutAllCicked()" ng-required="false" aria-invalid="false"> <label class="form-check-label" for="optOutAll">Unsubscribe from all messages</label></div></div><div class="my-5" ng-if="vm.canDelete"><div class="align-items-center my-2 d-flex"><i class="bi bi-person-x mr-2 text-lg-right text-em-2-0"></i> <span class="font-weight-bold text-black mr-1">Delete User Account</span></div><div class="row"><div class="col-sm-6 col-md-2"><button type="button" class="btn btn-danger btn-block" ng-click="vm.delete()">Delete</button></div></div></div><hr><div class="row justify-content-end flex-column-reverse flex-lg-row"><div class="col-lg-2"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.cancel()">Cancel</button></div><div class="col-lg-4 my-3 my-lg-0"><button type="button" class="btn btn-primary btn-block" ng-dblclick="false" ng-disabled="vm.submitted" ng-click="vm.submit()">Save Preferences</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-bank-transfer-info.html','<div data-ng-form="{{::vm.formName}}"><fieldset ng-disabled="vm.isReadOnly"><div class="row"><div class="col-md-12"><div class="form-group"><label for="payments_os_bankcode" style="font-weight:bold;">Bank</label> <select name="payments_os_bankcode" class="form-control" ng-model="vm.bankTransferInfo.bankCode" ng-required="true" ng-options="o.bankCode as o.displayName for o in vm.paymentsOsBanks"><option value="">Please select a bank</option></select><div ng-messages="vm.myForm.payments_os_bankcode.$error" class="text-danger"><div ng-message="required">A bank is required</div></div></div></div></div><div ng-show="vm.selectedPaymentsOsBank && vm.selectedPaymentsOsBank.supportsRecurringPayments"><div>The following additional fields are required for the bank selected above.</div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="customerAccountName">Customer name on bank account</label> <input name="customerAccountName" type="text" class="form-control" placeholder="Customer Name On Bank Account" ng-model="vm.bankTransferInfo.customerAccountName" ng-required="vm.selectedPaymentsOsBank && vm.selectedPaymentsOsBank.supportsRecurringPayments" maxlength="50" autocomplete="off" uib-tooltip="Customer Name On Bank Account" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.customerAccountName.$error" class="text-danger"><div ng-message="required">Customer name on bank account is required</div><div ng-message="maxlength">The customer name on bank account must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="customerAccountNumber">Bank Account Number</label> <input name="customerAccountNumber" type="text" class="form-control" placeholder="Bank Account Number" ng-model="vm.bankTransferInfo.customerAccountNumber" ng-required="vm.selectedPaymentsOsBank && vm.selectedPaymentsOsBank.supportsRecurringPayments" maxlength="50" autocomplete="off" uib-tooltip="Bank account number" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.customerAccountNumber.$error" class="text-danger"><div ng-message="required">Bank account number is required</div><div ng-message="maxlength">The bank account number must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="customerAccountType">Account Type</label> <select name="customerAccountType" class="form-control" ng-model="vm.bankTransferInfo.customerAccountType" ng-required="vm.selectedPaymentsOsBank && vm.selectedPaymentsOsBank.supportsRecurringPayments"><option value="">Account Type</option><option value="SAVINGS">Savings</option><option value="CURRENT">Current</option></select><div ng-messages="vm.myForm.customerAccountType.$error" class="text-danger"><div ng-message="required">Account type is required</div></div></div></div></div></div><section ng-show="vm.amountToCharge && vm.amountToCharge > 0"><div class="row"><div class="col-md-12" style="font-weight:bold;text-align:left;font-size:24px;">Total: {{vm.amountToCharge | currency:vm.bankTransferInfo.currencyTypeID:2}}</div></div></section><div class="row" ng-if="vm.selectedPaymentsOsBank.supportsRecurringPayments"><div class="col-md-12"><div>Please note that this payment method will also be used for any recurring \'{{vm.bankTransferInfo.currencyTypeString}}\' payments you may have.</div></div></div></fieldset></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-check-info.html','<div data-ng-form="{{::vm.formName}}"><fieldset ng-disabled="vm.isReadOnly"><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="checkNumber">Check Number</label> <input name="checkNumber" type="text" class="form-control" placeholder="Check Number" ng-model="vm.checkInfo.checkNumber" ng-required="true" maxlength="50" autocomplete="off" uib-tooltip="Check Number" tooltip-trigger="focus"><div ng-messages="vm.myForm.checkNumber.$error" class="text-danger"><div ng-message="required">Check number is required</div><div ng-message="maxlength">Must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="receivedDate">Received Date</label> <input name="receivedDate" type="text" class="form-control" uib-datepicker-popup="{{vm.calendarObj_RecDate.format}}" ng-model="vm.checkInfo.receivedDate" ng-required="true" is-open="vm.calendarObj_RecDate.opened" placeholder="Received Date (mm/dd/yyyy)" datepicker-options="vm.calendarObj_RecDate.options" close-text="Close" alt-input-formats="vm.calendarObj_RecDate.altInputFormats" uib-tooltip="Received Date (mm/dd/yyyy)" tooltip-trigger="focus"> <i class="icon icon-calendar feedback-icon" ng-click="vm.calendarObj_RecDate.opened = true"></i><div ng-messages="vm.myForm.receivedDate.$error" class="text-danger"><div ng-message="required">Received date is required</div><div ng-message="date">Please enter a valid date</div></div></div></div><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="dated">Dated</label> <input name="dated" type="text" class="form-control" uib-datepicker-popup="{{vm.calendarObj_Dated.format}}" ng-model="vm.checkInfo.checkDated" ng-required="true" is-open="vm.calendarObj_Dated.opened" placeholder="Dated (mm/dd/yyyy)" datepicker-options="vm.calendarObj_Dated.options" close-text="Close" alt-input-formats="vm.calendarObj_Dated.altInputFormats" uib-tooltip="Dated (mm/dd/yyyy)" tooltip-trigger="focus" style="padding-right:0px; margin:0px; width:100%"> <i class="icon icon-calendar feedback-icon" ng-click="vm.calendarObj_Dated.opened = true"></i><div ng-messages="vm.myForm.dated.$error" class="text-danger"><div ng-message="required">Dated is required</div><div ng-message="date">Please enter a valid date</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="sr-only" for="issuerOne">Issuer One</label> <input name="issuerOne" type="text" class="form-control" placeholder="First Issuer" ng-model="vm.checkInfo.issuerOne" ng-required="true" maxlength="100" autocomplete="off" uib-tooltip="First Issuer" tooltip-trigger="focus"><div ng-messages="vm.myForm.issuerOne.$error" class="text-danger"><div ng-message="required">First Issuer is required</div><div ng-message="maxlength">The first issuer must be 100 characters or less</div></div></div></div><div class="col-md-6"><div class="form-group"><label class="sr-only" for="IssuerTwo">Issuer Two</label> <input name="issuerTwo" type="text" class="form-control" placeholder="Second Issuer" ng-model="vm.checkInfo.issuerTwo" maxlength="100" autocomplete="off" uib-tooltip="Second Issuer" tooltip-trigger="focus"><div ng-messages="vm.myForm.issuerTwo.$error" class="text-danger"><div ng-message="maxlength">The second issuer must be 100 characters or less</div></div></div></div></div></fieldset></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-credit-card-info.html','<div data-ng-form="{{::vm.formName}}"><fieldset ng-disabled="vm.isReadOnly"><div class="row"><div class="col-md-12"><div><div style="max-width:367px;margin: 0 auto 10px;"><img style="max-width: 100%;height: auto;width: auto;" src="{{vm.common.config.appRoot}}assets/images/credit-cards-icons-lg.png"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="nameOnCard">Name on Card</label> <input name="nameOnCard" class="form-control" placeholder="Name On Card" ng-model="vm.creditCardInfo.nameOnCard" ng-required="true" maxlength="50" autocomplete="cc-name" uib-tooltip="Name On Card" tooltip-trigger="focus"><div ng-messages="vm.myForm.nameOnCard.$error" class="text-danger"><div ng-message="required">Name On Card is required</div><div ng-message="maxlength">The name on card must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="creditCardNumber">Credit Card Number</label> <input name="creditCardNumber" class="form-control" placeholder="Card Number" ng-model="vm.creditCardInfo.creditCardNumber" ng-required="true" maxlength="50" autocomplete="cc-number" uib-tooltip="Card Number" tooltip-trigger="focus" idp-numbers-only><div ng-messages="vm.myForm.creditCardNumber.$error" class="text-danger"><div ng-message="required">Credit Card Number is required</div><div ng-message="maxlength">The credit card number must be 50 digits or less</div></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group" uib-tooltip="Expiration Month" tooltip-trigger="focus"><label class="sr-only" for="expMonth">Expiration Month</label> <select name="expMonth" class="form-control" ng-model="vm.creditCardInfo.expMonth" ng-required="true" autocomplete="cc-exp-month" convert-to-number ng-options="month.id as month.name for month in vm.expirationMonths"><option value="">Expiration Month</option></select><div ng-messages="vm.myForm.expMonth.$error" class="text-danger"><div ng-message="required">Expiration Month is required</div></div></div></div><div class="col-sm-6"><div class="form-group" uib-tooltip="Expiration Year" tooltip-trigger="focus"><label class="sr-only" for="expYear">Expiration Year</label> <select name="expYear" class="form-control" ng-model="vm.creditCardInfo.expYear" ng-required="true" autocomplete="cc-exp-year" convert-to-number ng-options="year.id as year.name for year in vm.expirationYears"><option value="">Expiration Year</option></select><div ng-messages="vm.myForm.expYear.$error" class="text-danger"><div ng-message="required">Expiration Year is required</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="creditCardCVV">Credit Card CVV</label> <input name="creditCardCVV" class="form-control" maxlength="4" placeholder="CVV" ng-model="vm.creditCardInfo.creditCardCVV" ng-required="true" autocomplete="cc-csc" uib-tooltip="CVV" tooltip-trigger="focus" idp-numbers-only> <i id="creditCardIDHelp" class="icon icon-info feedback-icon" ng-click="vm.showCreditCardIdHelp()"></i><div ng-messages="vm.myForm.creditCardCVV.$error" class="text-danger"><div ng-message="required">CVV is required</div><div ng-message="maxlength">The CVV must be 4 digits or less</div></div></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.getHasError(vm.myForm.postalCode)}"><label class="sr-only" for="postalCode">Postal Code</label> <input name="postalCode" class="form-control" maxlength="20" placeholder="Zip Code" ng-model="vm.creditCardInfo.postalCode" autocomplete="billing postal-code" uib-tooltip="Zip Code" tooltip-trigger="focus"><div style="margin-top:3px;">(00000 for international)</div></div></div></div><section ng-if="vm.showBillingAddress"><div class="row"><div class="col-md-12"><div class="form-group" uib-tooltip="Country" tooltip-trigger="focus"><label class="sr-only" for="countryType">Country</label> <select name="countryType" class="form-control" ng-model="vm.creditCardInfo.countryTypeID" autocomplete="billing country" ng-required="true" ng-change="vm.onCountryChange()" ng-options="countryType.typeID as countryType.typeString for countryType in vm.countryTypes track by countryType.typeID"><option value="">Country</option></select><div ng-messages="vm.myForm.countryType.$error" class="text-danger"><div ng-message="required">Country is required</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="address1">Billing Address Line 1</label> <input name="address1" class="form-control" placeholder="Billing Address Line 1" ng-model="vm.creditCardInfo.address1" ng-required="true" maxlength="100" autocomplete="billing address-line1" uib-tooltip="Address Line 1" tooltip-trigger="focus"><div ng-messages="vm.myForm.address1.$error" class="text-danger"><div ng-message="required">Billing address line 1 is required</div><div ng-message="maxlength">The billing address line 1 must be 100 characters or less</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="address2">Billing Address Line 2</label> <input name="address2" class="form-control" placeholder="Billing Address Line 2" ng-model="vm.creditCardInfo.address2" maxlength="100" autocomplete="billing address-line2" uib-tooltip="Address Line 2" tooltip-trigger="focus"><div ng-messages="vm.myForm.address2.$error" class="text-danger"><div ng-message="maxlength">The billing address line 2 must be 100 characters or less</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="city">{{vm.cityFieldTitle}}</label> <input name="city" class="form-control" placeholder="{{vm.cityFieldTitle}}" ng-model="vm.creditCardInfo.city" ng-required="true" maxlength="50" autocomplete="billing address-level2" uib-tooltip="{{vm.cityFieldTitle}}" tooltip-trigger="focus"><div ng-messages="vm.myForm.city.$error" class="text-danger"><div ng-message="required">{{vm.cityFieldTitle}} is required</div><div ng-message="maxlength">{{vm.cityFieldTitle}} must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" ng-show="!(vm.isUSA || vm.isCanada)"><label class="sr-only" for="state">{{vm.stateFieldTitle}}</label> <input name="state" class="form-control" placeholder="{{vm.stateFieldTitle}}" ng-model="vm.creditCardInfo.state" ng-required="!(vm.isUSA || vm.isCanada)" maxlength="50" autocomplete="billing address-level1" uib-tooltip="{{vm.stateFieldTitle}}" tooltip-trigger="focus"><div ng-messages="vm.myForm.state.$error" class="text-danger"><div ng-message="required">{{vm.stateFieldTitle}} is required</div><div ng-message="maxlength">{{vm.stateFieldTitle}} must be 50 characters or less</div></div></div><div class="form-group" uib-tooltip="{{vm.stateFieldTitle}}" tooltip-trigger="focus" ng-show="vm.isCanada"><label class="sr-only" for="provinceType">{{vm.stateFieldTitle}}</label> <select name="provinceType" class="form-control" ng-model="vm.creditCardInfo.stateTypeID" autocomplete="billing address-level1" ng-required="vm.isCanada" ng-options="provinceType.typeID as provinceType.typeString for provinceType in vm.canadianProvinceTypes track by provinceType.typeID"><option value="">Select Province</option></select><div ng-messages="vm.myForm.provinceType.$error" class="text-danger"><div ng-message="required">{{vm.stateFieldTitle}} is required</div></div></div><div class="form-group" uib-tooltip="{{vm.stateFieldTitle}}" tooltip-trigger="focus" ng-show="vm.isUSA"><label class="sr-only" for="stateType">{{vm.stateFieldTitle}}</label> <select name="stateType" class="form-control" ng-model="vm.creditCardInfo.stateTypeID" autocomplete="billing address-level1" ng-required="vm.isUSA" ng-options="stateType.typeID as stateType.typeString for stateType in vm.stateTypes track by stateType.typeID"><option value="">Select State</option></select><div ng-messages="vm.myForm.stateType.$error" class="text-danger"><div ng-message="required">{{vm.stateFieldTitle}} is required</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group" ng-class="{\'has-error\': vm.getHasError(vm.myForm.postalCode)}"><label class="sr-only" for="zipOrPostalCode">{{vm.zipFieldTitle}}</label> <input name="zipOrPostalCode" class="form-control" maxlength="20" placeholder="{{vm.zipFieldTitle}} (00000 for international)" ng-model="vm.creditCardInfo.postalCode" ng-required="true" autocomplete="billing postal-code" uib-tooltip=">{{vm.zipFieldTitle}} (00000 for international)" tooltip-trigger="focus"><div ng-messages="vm.myForm.zipOrPostalCode.$error" class="text-danger"><div ng-message="required">{{vm.zipFieldTitle}} is required</div><div ng-message="maxlength">{{vm.zipFieldTitle}} must be 20 characters or less</div></div></div></div></div></section><section ng-show="vm.amountToCharge && vm.amountToCharge > 0"><div class="row"><div class="col-md-12" style="font-weight:bold;text-align:left;font-size:24px;">Total: {{vm.amountToCharge | currency:vm.creditCardInfo.currencyTypeID:2}}</div></div></section><div class="row" ng-if="vm.creditCardInfo.currencyTypeID != $root.Enums.CurrencyType.USD"><div class="col-md-12"><div class="form-check"><input id="agreeToRecurring" name="agreeToRecurring" type="checkbox" ng-model="vm.creditCardInfo.agreeToRecurring" class="form-check-input"> <label for="agreeToRecurring" class="form-check-label">Also use this card for any recurring \'{{vm.creditCardInfo.currencyTypeString}}\' payments I may have.</label></div></div></div></fieldset></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-credit-card-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="modal-header"><h3>{{vm.initDataObj.title ? vm.initDataObj.title : \'Please enter your credit card information\'}}</h3><button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div id="content" class="container-fluid w-100"><div ng-show="vm.initDataObj.message" class="pb-3">{{vm.initDataObj.message}}</div><fieldset><div class="row"><div class="col-md-6"><div class="has-feedback id-required" ng-class="{\'has-error\': (vm.submitted || vm.myForm.creditCardNumber.$dirty) && vm.myForm.creditCardNumber.$invalid}"><input name="creditCardNumber" class="form-control" placeholder="Credit Card #" data-ng-model="vm.creditCardInfo.creditCardNumber" required autocomplete="cc-number" uib-tooltip="Credit Card Number" tooltip-trigger="\'focus\'" idp-numbers-only></div></div><div class="col-md-6"><div class="w-85 mt-0 mr-auto mb-4"><div class="mw-80"><img class="mw-100 h-auto w-auto" ng-src="{{vm.imgSrcCreditCards}}"></div></div></div></div><div class="row mt-sm-3"><div class="col-md-6"><div class="form-group id-required" ng-class="{\'has-error\': ((vm.submitted || vm.myForm.expMonth.$dirty) && vm.myForm.expMonth.$invalid)\n                                  || (vm.submitted && vm.myForm.expMonth.$viewValue.id == -1)}" uib-tooltip="Expiration Month" tooltip-trigger="\'focus\'"><select name="expMonth" class="form-control" data-ng-model="vm.selectedExpMonth" autocomplete="cc-exp-month" convert-to-number ng-options="month.name for month in vm.expirationMonths track by month.id"></select></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': ((vm.submitted || vm.myForm.expYear.$dirty) && vm.myForm.expYear.$invalid)\n                                  || (vm.submitted && vm.myForm.expYear.$viewValue.id == -1)}" uib-tooltip="Expiration Year" tooltip-trigger="\'focus\'"><select name="expYear" class="form-control" data-ng-model="vm.selectedExpYear" autocomplete="cc-exp-year" convert-to-number ng-options="year.name for year in vm.expirationYears track by year.id"></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback id-required" ng-class="{\'has-error\': (vm.submitted || vm.myForm.creditCardCVV.$dirty) && vm.myForm.creditCardCVV.$invalid}"><input name="creditCardCVV" class="form-control" maxlength="4" placeholder="Card ID #" data-ng-model="vm.creditCardInfo.creditCardCVV" data-ng-model-options="{ \'updateOn\' : \'blur\' }" required autocomplete="cc-csc" uib-tooltip="Credit Card ID Number" tooltip-trigger="\'focus\'" idp-numbers-only> <span id="creditCardIDHelp" class="icon icon-info feedback-icon" ng-click="vm.showCreditCardIdHelp()"></span></div></div><div class="col-md-6"><div class="form-group id-required" ng-class="{\'has-error\': (vm.submitted || vm.myForm.postalCode.$dirty) && vm.myForm.postalCode.$invalid}"><input name="postalCode" class="form-control" maxlength="20" placeholder="Zip / Postal Code" data-ng-model="vm.creditCardInfo.postalCode" data-ng-model-options="{ \'updateOn\' : \'blur\' }" autocomplete="billing postal-code" uib-tooltip="Zip / Postal Code" tooltip-trigger="\'focus\'"></div></div></div><div class="row"><div class="pb-none col-md-6"><p><strong>Name on Card:</strong></p></div></div><div class="row"><div class="col-md-12"><div class="has-feedback id-required" ng-class="{\'has-error\': (vm.submitted || vm.myForm.nameOnCard.$dirty) && vm.myForm.nameOnCard.$invalid}"><input name="nameOnCard" class="form-control" maxlength="50" placeholder="Name on Card" data-ng-model="vm.creditCardInfo.nameOnCard" data-ng-model-options="{ \'updateOn\' : \'blur\' }" required autocomplete="cc-name" uib-tooltip="Name on Card" tooltip-trigger="\'focus\'"></div></div></div></fieldset></div></div><div class="modal-footer"><button class="btn btn-primary px-5" type="submit" data-ng-class="{disabled: vm.saveDisabled}" data-ng-disabled="vm.saveDisabled" data-ng-dblclick="false">Save changes</button> <button class="btn btn-outline-secondary px-5 ml-3" type="button" data-ng-click="vm.close()">Close</button></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-money-order-info.html','<div data-ng-form="{{::vm.formName}}"><fieldset ng-disabled="vm.isReadOnly"><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="serialNumber">Serial Number</label> <input name="serialNumber" type="text" class="form-control" placeholder="Serial Number" ng-model="vm.moneyOrderInfo.checkNumber" ng-required="true" maxlength="50" autocomplete="off" uib-tooltip="Serial Number" tooltip-trigger="focus"><div ng-messages="vm.myForm.serialNumber.$error" class="text-danger"><div ng-message="required">Serial Number is required</div><div ng-message="maxlength">The serial number must be 50 characters or less</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="receivedDate">Received Date</label> <input name="receivedDate" type="text" class="form-control" uib-datepicker-popup="{{vm.calendarObj_RecDate.format}}" ng-model="vm.moneyOrderInfo.receivedDate" is-open="vm.calendarObj_RecDate.opened" placeholder="Received Date (mm/dd/yyyy)" datepicker-options="vm.calendarObj_RecDate.options" required close-text="Close" alt-input-formats="vm.calendarObj_RecDate.altInputFormats" uib-tooltip="Received Date (mm/dd/yyyy)" tooltip-trigger="focus" style="padding-right:0px; margin:0px; width:100%"> <i class="icon icon-calendar feedback-icon" ng-click="vm.calendarObj_RecDate.opened = true"></i><div ng-messages="vm.myForm.receivedDate.$error" class="text-danger"><div ng-message="required">Received date is required</div><div ng-message="date">Please enter a valid date</div></div></div></div><div class="col-md-6"><div class="form-group has-feedback"><label class="sr-only" for="dated">Dated</label> <input name="dated" type="text" class="form-control" uib-datepicker-popup="{{vm.calendarObj_Dated.format}}" ng-model="vm.moneyOrderInfo.checkDated" is-open="vm.calendarObj_Dated.opened" placeholder="Dated (mm/dd/yyyy)" datepicker-options="vm.calendarObj_Dated.options" required close-text="Close" alt-input-formats="vm.calendarObj_Dated.altInputFormats" uib-tooltip="Dated (mm/dd/yyyy)" tooltip-trigger="focus" style="padding-right:0px; margin:0px; width:100%"> <i class="icon icon-calendar feedback-icon" ng-click="vm.calendarObj_Dated.opened = true"></i><div ng-messages="vm.myForm.dated.$error" class="text-danger"><div ng-message="required">Dated is required</div><div ng-message="date">Please enter a valid date</div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="sr-only" for="from">From</label> <input name="from" type="text" class="form-control" placeholder="From" data-ng-model="vm.moneyOrderInfo.issuerOne" ng-required="true" maxlength="100" autocomplete="off" uib-tooltip="From" tooltip-trigger="focus"><div ng-messages="vm.myForm.from.$error" class="text-danger"><div ng-message="required">From is required</div><div ng-message="maxlength">The from field must be 100 characters or less</div></div></div></div></div></fieldset></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-subscription-cancel-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header border-0 pb-0"><button type="button" class="close text-em-2-5" data-dismiss="modal" aria-hidden="true" data-ng-click="vm.close()">&#xD7;</button></div><div class="modal-body px-3 px-lg-8 py-0"><h3>Cancel your subscription</h3><section ng-hide="vm.initDataObj.isRenewPaused || vm.initDataObj.isSuspended"><div class="mt-3 text-black">{{vm.initDataObj.studentName}}\'s learning journey doesn\u2019t have to end here! <strong>Would you like to pause your subscription instead?</strong></div><div class="aqua-bg mt-3 px-2 py-3 p-md-3 p-lg-5"><div class="d-flex align-items-center pl-1 pl-md-3 text-black py-2"><i class="icon icon-star-check text-em-2-25 mr-2"></i> <strong>Benefits of pausing your subscription</strong></div><div class="my-3 pl-1 pl-md-3">Need to take a break or not using your lessons as quickly as you planned? No problem! Pause today with peace of mind, and come back whenever you\u2019re ready.</div><ul class="pl-5 pl-md-7"><li>All remaining lessons will be saved, and available, for future use.</li><li>All remaining lessons are available for one year from purchase, even when your subscription is on pause.</li><li>You can pause for 1, 2, or 3 months.</li><li>No fees of any kind!</li></ul><div class="d-flex justify-content-center"><button class="btn btn-outline-secondary px-8" type="button" data-ng-click="vm.showSubscriptionPausePopup()" data-ng-dblclick="false">Pause subscription</button></div></div><p class="pt-3">You also have the option to change your topic or number of lessons per month instead. To modify your subscription, call us at 1-888-709-8324.</p><p>As a reminder, your monthly subscription for {{vm.initDataObj.courseName}} is paid until {{vm.initDataObj.expiryDate | DTZeroHourPreviousDayAdjustForDisplay | date:\'MMM d, yyyy\'}}.</p></section><section ng-show="vm.initDataObj.isRenewPaused || vm.initDataObj.isSuspended" class="my-3"><p ng-hide="vm.initDataObj.isSuspended">Your monthly subscription for {{vm.initDataObj.courseName}} is currently paused until {{vm.initDataObj.expiryDate | date:\'MMM d, yyyy\'}}. To continue with your cancellation, click the green button below.</p><p ng-show="vm.initDataObj.isSuspended">Your monthly subscription for {{vm.initDataObj.courseName}} is suspended. To continue with your cancellation, click the green button below.</p><p class="font-weight-bold">Would you like to change your topic or number of lessons per month instead?</p><p class="font-weight-bold">No problem! Call us at 1-888-709-8324 to modify your subscription.</p></section></div><div class="modal-footer justify-content-center flex-column border-0" ng-show="!vm.showConfirmation"><button class="btn btn-primary px-8" type="submit" ng-disabled="vm.isSubmitting" data-ng-click="vm.submit()" data-ng-dblclick="false">Cancel subscription</button> <button class="btn btn-link mt-2 px-8" type="button" data-ng-click="vm.close()">Close</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-subscription-change-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header border-0 pb-0"><h3>{{::vm.getTitle()}}</h3><button type="button" class="close text-em-2-5" data-dismiss="modal" aria-hidden="true" data-ng-click="vm.close()">&#xD7;</button></div><div class="modal-body px-3 px-lg-8 py-0"><section ng-if="vm.changeType === vm.ChangeTypeEnum.ChangeTopic"><div class="p-1 d-flex justify-content-around align-items-stretch align-content-between flex-wrap"><div class="card p-0 col-lg"><div class="card-body h-100" style="font-size: 0.88rem;"><img class="rounded float-left mt-1 mr-3" ng-src="{{::vm.subscription.productImg}}" alt="Topic"><div class="h4">{{::vm.subscription.productNamePart1}}</div><ng-bind-html ng-bind-html="::vm.getProduct().description | unsafe"></ng-bind-html></div></div><div class="col-lg-auto p-0 m-auto d-flex justify-content-center"><i class="bi-arrow-right-circle-fill display-4 d-none d-lg-inline" style="color: rgba(0, 0, 0, 0.2);"></i> <i class="bi-arrow-down-circle-fill display-4 d-lg-none" style="color: rgba(0, 0, 0, 0.2);"></i></div><div class="card p-0 col-lg"><div class="card-body h-100" style="font-size: 0.88rem;"><img class="rounded float-left mt-1 mr-3" ng-src="{{::vm.subscription.changeToProdImg}}" alt="Topic"><div class="h4">{{::vm.subscription.changeToProdInfo.products[0].name}}</div><div>Whether you want to learn to program, make games, or even create art and edit videos for platforms like YouTube, we\u2019ll guide you from total beginner to college-bound pro. You\u2019ll have fun and advance fast with consistent coaching!</div></div></div></div><div class="my-5"><h4>What happens next?</h4><ul class="my-2" ng-if="::vm.subscription.expiryDate"><li>Your new plan starts on your renewal date: <b>{{::vm.subscription.expiryDate | date:\'MMMM d, yyyy\'}}</b>.</li><li>Starting on <b>{{::vm.subscription.expiryDate | date:\'MMMM d, yyyy\'}}</b>, you will be able to schedule lessons for 50+ topics.</li><li>You will select your topic at the time of scheduling your lessons.</li></ul><ul class="my-2" ng-if="::!vm.subscription.expiryDate"><li>Your new plan will start when you renew your subscription. You may renew by selecting "Renew now" under the subscription details.</li><li>Upon renewal, you will be able to schedule lessons for 50+ topics.</li><li>You will select your topic at the time of scheduling your lessons.</li></ul><p>{{::vm.getCompanyContactInfo()}}</p></div><div class="modal-footer px-4"><button type="button" class="btn btn-outline-secondary col-lg-2 col-md-3 col-12 px-3 ng-scope" ng-click="vm.close()">Cancel</button> <button type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-2" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.changeTopic()">Change Topic</button></div></section><section class="mt-2" ng-if="vm.changeType === vm.ChangeTypeEnum.ChangePlanStep1">Need to change the number of lessons your student has a month? You have the option to select from one of the options below.<div class="mb-6 p-1 d-flex justify-content-center align-items-stretch align-content-between flex-wrap"><div class="card mt-3 mx-1 p-0 col-lg d-flex flex-column" ng-class=":: vm.isCurrentSub(newSubscription) ? \'border-blue backdrop-shadow\' : \'backdrop-shadow-with-hover\'" style="max-width:15rem;" ng-repeat="newSubscription in vm.subscription.changeToProdInfo.products track by newSubscription.productID"><div class="card-body h-100 d-flex flex-column text-center"><span class="ml-auto py-1 px-3 bg-light-cyan-pastel rounded-pill text-em-0-65 font-weight-bold">SAVE {{::vm.getPercentOff(newSubscription, vm.subscription.changeToProdInfo.products)}}%</span><div class="mt-5 mx-auto idp-icon-md-circle-bg bg-lightgray font-weight-bold">{{::newSubscription.quantity}}</div><div class="mt-1 font-weight-bold">Lesson{{::newSubscription.quantity > 1 ? \'s\' : \'\'}} / Month</div><span ng-class="{\'invisible\': !(newSubscription.isMostPopular)}" class="my-1 mx-auto py-1 px-3 bg-light-purple-blue rounded-pill text-em-0-65 font-weight-bold">MOST POPULAR</span><div>{{::vm.getPricePerLesson(newSubscription) | currency:-vm.subscription.currencyTypeID:0}}<span class="text-muted"> / Lesson</span></div><div ng-if="newSubscription.quantity > 1" class="text-muted">{{::vm.getPricePerMonth(newSubscription) | currency:-vm.subscription.currencyTypeID:0}} / mo</div><div ng-if="newSubscription.quantity == 1" class="text-muted">once a month</div><button type="button" class="btn btn-sm btn-primary m-3" ng-disabled="vm.isCurrentSub(newSubscription) || vm.isSubmitting" ng-dblclick="false" ng-click="vm.selectNewSubscription(newSubscription)">{{::vm.isCurrentSub(newSubscription) ? \'Current Plan\' : \'Select Plan\'}}</button></div></div></div><div class="modal-footer px-4"><button type="button" class="btn btn-outline-secondary col-lg-2 col-md-3 col-12 px-3 ng-scope" ng-click="vm.close()">Cancel</button></div></section><section class="mt-2" ng-if="vm.changeType === vm.ChangeTypeEnum.ChangePlanStep2"><div class="mb-6 p-1 d-flex justify-content-center align-items-stretch align-content-between flex-wrap"><div class="card mt-3 p-0 col-sm d-flex flex-column backdrop-shadow" style="max-width:15rem;"><div class="card-body h-100 d-flex flex-column text-center"><div class="d-flex justify-content-between middle"><h4 class="my-auto">Current Plan</h4><span class="py-1 px-3 bg-light-cyan-pastel rounded-pill text-em-0-65 font-weight-bold">SAVE {{::vm.getPercentOff(vm.currentSub, vm.subscription.changeToProdInfo.products)}}%</span></div><div class="mt-5 mx-auto idp-icon-md-circle-bg bg-lightgray font-weight-bold">{{::vm.currentSub.quantity}}</div><div class="mt-1 font-weight-bold">Lesson{{::vm.currentSub.quantity > 1 ? \'s\' : \'\'}} / Month</div><span ng-class="{\'invisible\': !(vm.currentSub.isMostPopular)}" class="my-1 mx-auto py-1 px-3 bg-light-<h4>What happens next?</h4>purple-blue rounded-pill text-em-0-65 font-weight-bold">MOST POPULAR</span><div>{{::vm.getPricePerLesson(vm.currentSub) | currency:-vm.subscription.currencyTypeID:0}}<span class="text-muted"> / Lesson</span></div><div ng-if="vm.currentSub.quantity > 1" class="text-muted">{{::vm.getPricePerMonth(vm.currentSub) | currency:-vm.subscription.currencyTypeID:0}} / mo</div><div ng-if="vm.currentSub.quantity == 1" class="text-muted">once a month</div></div></div><div class="col-sm-auto p-0 my-auto d-flex justify-content-center"><i class="bi-arrow-right-circle-fill display-4 d-none d-sm-inline" style="color: rgba(0, 0, 0, 0.2);"></i> <i class="bi-arrow-down-circle-fill display-4 d-sm-none" style="color: rgba(0, 0, 0, 0.2);"></i></div><div class="card mt-sm-3 mt-0 p-0 col-sm d-flex flex-column backdrop-shadow" style="max-width:15rem;"><div class="card-body h-100 d-flex flex-column text-center"><div class="d-flex justify-content-between middle"><h4 class="my-auto">New Plan</h4><span class="py-1 px-3 bg-light-cyan-pastel rounded-pill text-em-0-65 font-weight-bold">SAVE {{::vm.getPercentOff(vm.selectedNewSub, vm.subscription.changeToProdInfo.products)}}%</span></div><div class="mt-5 mx-auto idp-icon-md-circle-bg bg-lightgray font-weight-bold">{{::vm.selectedNewSub.quantity}}</div><div class="mt-1 font-weight-bold">Lesson{{::vm.selectedNewSub.quantity > 1 ? \'s\' : \'\'}} / Month</div><span ng-class="{\'invisible\': !(vm.selectedNewSub.isMostPopular)}" class="my-1 mx-auto py-1 px-3 bg-light-purple-blue rounded-pill small font-weight-bold">MOST POPULAR</span><div>{{::vm.getPricePerLesson(vm.selectedNewSub) | currency:-vm.subscription.currencyTypeID:0}}<span class="text-muted"> / Lesson</span></div><div ng-if="vm.selectedNewSub.quantity > 1" class="text-muted">{{::vm.getPricePerMonth(vm.selectedNewSub) | currency:-vm.subscription.currencyTypeID:0}} / mo</div><div ng-if="vm.selectedNewSub.quantity == 1" class="text-muted">once a month</div></div></div></div><div class="my-5"><h4>What happens next?</h4><ul class="my-2" ng-if="::vm.subscription.expiryDate"><li>Your new plan starts on your renewal date: <b>{{::vm.subscription.expiryDate | date:\'MMMM d, yyyy\'}}</b>.</li><li>Starting on <b>{{::vm.subscription.expiryDate | date:\'MMMM d, yyyy\'}}</b>, you will be charged {{::vm.getPriceLessonsPerMonthStr(vm.selectedNewSub)}}.</li><li>Your existing lessons will remain available until their expiration date.</li></ul><ul class="my-2" ng-if="::!vm.subscription.expiryDate"><li>Your new plan will start when you renew your plan. You may renew by selecting "Renew now" under the subscription details.</li><li>Upon renewal, you will be charged {{::vm.getPriceLessonsPerMonthStr(vm.selectedNewSub)}}.</li><li>Your existing lessons will remain available until their expiration date.</li></ul><p>{{::vm.getCompanyContactInfo()}}</p></div><div class="modal-footer px-4"><button class="btn btn-link col-md-2 col-12 mr-md-auto" ng-click="vm.goToChangeSubStep1()">Back</button> <button type="button" class="btn btn-outline-secondary col-lg-2 col-md-3 col-12 px-3 ng-scope" ng-click="vm.close()">Cancel</button> <button type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-2" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.changeSubscription()">Change Subscription</button></div></section><section class="mt-2" ng-if="vm.changeType === vm.ChangeTypeEnum.Pause">Need to take a break? You have the flexibility to pause your subscription and resume your lessons when the time is right.<div class="mt-3 text-black"><b>You\u2019re pausing your subscription for the following topic:</b><br>{{::vm.subscription.productName}}</div><div class="mt-8 mb-3">How long do you want to pause?</div><div class="mb-6 p-1 d-flex justify-content-center align-items-stretch align-content-between flex-wrap"><div class="card mt-3 mx-1 p-0 col-lg d-flex flex-column" ng-class="vm.selectedDuration === durration ? \'text-blue border-blue backdrop-shadow font-weight-bold\' : \'backdrop-shadow-with-hover\'" style="max-width:15rem;" ng-repeat="durration in vm.pauseDurations track by durration" ng-click="vm.selectedDuration = durration"><div class="card-body h-100 d-flex flex-column align-items-center"><div class="d-flex align-items-center"><i class="icon mr-2 text-em-2-5" ng-class="\'icon-cal-{{durration}}-month\'"></i><span class="pt-2 text-em-1-5 ng-binding">Month{{durration == 1 ? \'\':\'s\'}}</span></div><div class="mt-3 small">(until {{::vm.getPausedExpectedRenewalDate(durration) | date:\'MMMM d, yyyy\'}})</div><button type="button" class="btn btn-sm rounded-pill m-3 w-75" ng-class="vm.selectedDuration === durration ? \'btn-secondary\' : \'btn-outline-secondary\'" ng-dblclick="false">{{vm.selectedDuration === durration ? \'Selected\' : \'Select\'}}</button></div></div></div><div class="my-5"><h4>What happens next?</h4><ul class="my-2"><li>Your plan will resume on <b>{{vm.getPausedExpectedRenewalDate(vm.selectedDuration) | date:\'MMMM d, yyyy\'}}</b>.</li><li>Starting on <b>{{vm.getPausedExpectedRenewalDate(vm.selectedDuration) | date:\'MMMM d, yyyy\'}}</b>, your payments will automatically begin processing again.</li><li>Your existing lessons will remain available in "My Account" until their expiration date.</li></ul><p>{{::vm.getCompanyContactInfo()}}</p></div><div class="modal-footer px-4"><button ng-if="::vm.pulseContext.isImpersonating && !vm.pulseContext.isLoggedInUserTermStaff" class="btn btn-link col-md-3 col-12 px-0 mr-md-auto" ng-click="vm.pauseSubIndefinitely()">Pause Indefinitely (Admin)</button> <button type="button" class="btn btn-outline-secondary col-lg-2 col-md-3 col-12 px-3 ng-scope" ng-click="vm.close()">Cancel</button> <button type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-2" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.pauseSubscription()">Pause Subscription</button></div></section><section class="mt-2" ng-if="vm.changeType === vm.ChangeTypeEnum.CancelActive">{{::vm.subscription.prefOrFirstName}}\'s learning journey doesn\'t have to end here! <b class="text-black">Would you like to pause your subscription instead?</b><div class="card mt-6"><div class="p-1 d-flex justify-content-around align-items-stretch align-content-between flex-wrap"><div class="p-0 mt-lg-8 col-lg-3" style="text-align: center; height: 12rem;"><div class="mt-4 pb-0" style="color: rgba(20, 10, 119, 0.8);"><i class="bi-calendar4-week d-lg-inline" style="font-size: 8rem;top: -2rem;left: 2rem;position: relative;"></i><div class="idp-icon-md-circle-bg bg-light-purple text-purple text-em-2-25" style="width:3.6rem; position: relative;left: -1.5rem;top: 5rem;border: solid;border-color: rgba(20, 10, 119, 0.8);"><i class="bi-pause-fill" style="position: relative; top: 2px;"></i></div></div></div><div class="p-0 col-lg"><div class="card-body pt-0 pt-md-3 h-100"><h4>Benefits of pausing your subscription:</h4><div class="mt-2">Need to take a break, have a vacation planned, or not using your lessons as quickly as you planned? No problem! Pause today with peace of mind, and come back whenever you\u2019re ready.<ul class="mt-2"><li>All remaining lessons will be saved, and available, for future use.</li><li>All remaining lessons are available for one year from purchase, even when your subscription is on pause.</li><li>You can pause for 1, 2, or 3 months.</li><li>No fees of any kind!</li></ul></div></div></div></div></div><div class="my-5"><h4>You also have the option to:</h4><ul class="my-4"><li>Change your number of lessons per month by clicking <button type="button" class="btn btn-link p-0" ng-dblclick="false" ng-click="vm.goChangePlan()">here</button>.</li><li ng-if="::vm.subscription.catalogTypeID !== $root.Enums.SalesCatalogType.OPLGeneric">Change your topic by clicking <button type="button" class="btn btn-link p-0" ng-dblclick="false" ng-click="vm.goChangeTopic()">here</button>.</li></ul><p>{{::vm.getCompanyContactInfo()}}</p></div><div class="modal-footer px-4"><button class="btn btn-link col-md-3 col-12 px-0 mr-md-auto" ng-click="vm.close()">Close</button> <button type="button" class="btn btn-outline-secondary col-lg-3 col-12 px-3" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.cancelSubscription()">Cancel Subscription</button> <button type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-2" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.goPauseSub()">Pause Subscription</button></div></section><section class="mt-2" ng-if="vm.changeType === vm.ChangeTypeEnum.CancelPaused">Your monthly subscription for {{::vm.subscription.productName}} is currently paused<span ng-if="::vm.subscription.expiryDate"> until {{::vm.subscription.expiryDate | date:\'MMMM d, yyyy\'}}</span>.<br><b class="text-black">Would you like to change your number of lessons per month instead?</b><div class="card mt-6"><div class="p-1 d-flex justify-content-around align-items-stretch align-content-between flex-wrap"><div class="p-0 mt-lg-3 col-lg-3" style="text-align: center; height: 12rem;"><div class="mt-4 pb-0"><div class="idp-icon-xl-circle-bg bg-light-cyan-pastel"><i class="bi-arrows-angle-expand"></i></div></div></div><div class="p-0 col-lg"><div class="card-body pt-0 pt-md-3 h-100"><h4>Changing your plan size is easy!</h4><div class="mt-2">If your child isn\u2019t using as many lessons as you expected or their schedule has gotten busier, it\u2019s easy to change your number of lessons. We offer monthly subscriptions of all different sizes.</div></div></div></div></div><div class="my-5"><div ng-if="::vm.subscription.catalogTypeID !== $root.Enums.SalesCatalogType.OPLGeneric"><h4>You also have the option to:</h4><ul class="my-4"><li>Change your topic by clicking <button type="button" class="btn btn-link p-0" ng-dblclick="false" ng-click="vm.goChangeTopic()">here</button>.</li></ul></div><p>{{::vm.getCompanyContactInfo()}}</p></div><div class="modal-footer px-4"><button class="btn btn-link col-md-3 col-12 px-0 mr-md-auto" ng-click="vm.close()">Close</button> <button type="button" class="btn btn-outline-secondary col-lg-3 col-12 px-3" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.cancelSubscription()">Cancel Subscription</button> <button type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-2" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.goChangePlan()">Change Plan</button></div></section><section class="mt-2" ng-if="vm.changeType === vm.ChangeTypeEnum.CancelSuspended">You are about to cancel your subscription for {{::vm.subscription.productName}}. <b class="text-black">Would you like to reactivate your subscription instead?</b><div class="card mt-6"><div class="p-1 d-flex justify-content-around align-items-stretch align-content-between flex-wrap"><div class="p-0 mt-lg-4 col-lg-3" style="text-align: center; height: 12rem;"><div class="mt-4 pb-0"><div class="idp-icon-xl-circle-bg bg-light-green text-light-green"><i class="bi-arrow-repeat fa fa-rotate-90"></i></div></div></div><div class="p-0 col-lg"><div class="card-body py-0 pt-md-3 h-100"><b>Benefits of Reactivating Your Subscription</b><div class="mt-2">Your child will be able to:<ul class="mt-2"><li>Pick up learning in their favorite topic or dive into something brand new</li><li>Continue working toward their previous academic goals or partner with their instructor to set new milestones</li><li>Get customized homework help and boost their grades</li><li>Have a fun, creative educational outlet to look forward to each week</li></ul></div></div></div></div></div><div class="my-5"><b>What happens if you reactivate?</b><ul class="my-4"><li>Your plan will renew today, <b>{{::vm.getNowDate() | date:\'MMMM d, yyyy\'}}</b>.</li><li>You will be charged {{::vm.subscription.pricePerMonth |currency:-vm.subscription.currencyTypeID}} today.</li><li>You will have {{::vm.subscription.packSize}} lesson{{::vm.subscription.packSize > 1 ? \'s\': \'\'}} available today.</li></ul><p>{{::vm.getCompanyContactInfo()}}</p></div><div class="modal-footer px-4"><button class="btn btn-link col-md-3 col-12 px-0 mr-md-auto" ng-click="vm.close()">Close</button> <button type="button" class="btn btn-outline-secondary col-lg-3 col-12 px-3" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.cancelSubscription()">Cancel Subscription</button> <button type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-2" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.onRenewSubscriptionNowClick()">Reactivate Subscription</button></div></section><section class="mt-2" ng-if="vm.changeType === vm.ChangeTypeEnum.ManageSub"><b class="text-black">Your monthly subscription for {{::vm.subscription.productName}} is paused until {{::vm.subscription.expiryDate | date:\'MMMM d, yyyy\'}}.</b><br>You have the flexibility to resume your lessons now or pause for another month.<div class="mt-8 mb-3">How would you like to manage your subscription?</div><div class="mb-6 p-1 d-flex justify-content-center align-items-stretch align-content-between flex-wrap"><div class="card mt-3 mx-md-3 p-0 col-lg d-flex flex-column" ng-class="vm.selectedManageOption === vm.ManagePauseOptionEnum.ResumeNow ? \'text-blue border-blue backdrop-shadow font-weight-bold\' : \'backdrop-shadow-with-hover\'" style="max-width:23rem;" ng-click="vm.selectedManageOption =  vm.ManagePauseOptionEnum.ResumeNow"><div class="card-body py-7 h-100 d-flex flex-column align-items-center"><div class="d-flex align-items-center"><span class="pt-2 text-em-1-5">Resume now</span></div><div class="mt-2 small">({{::vm.getNowDate() | date:\'MMMM d, yyyy\'}})</div><button type="button" class="btn btn-sm rounded-pill mt-3 w-50" ng-class="vm.selectedManageOption === vm.ManagePauseOptionEnum.ResumeNow ? \'btn-secondary\' : \'btn-outline-secondary\'" ng-dblclick="false">{{vm.selectedManageOption === vm.ManagePauseOptionEnum.ResumeNow ? \'Selected\' : \'Select\'}}</button></div></div><div class="card mt-3 mx-md-3 p-0 col-lg d-flex flex-column" ng-class="vm.selectedManageOption === vm.ManagePauseOptionEnum.PauseAnotherMonth ? \'text-blue border-blue backdrop-shadow font-weight-bold\' : \'backdrop-shadow-with-hover\'" style="max-width:23rem;" ng-click="vm.selectedManageOption = vm.ManagePauseOptionEnum.PauseAnotherMonth"><div class="card-body py-7 h-100 d-flex flex-column align-items-center"><div class="d-flex align-items-center"><i class="icon mr-2 text-em-2-5" ng-class="\'icon-cal-{{durration}}-month\'"></i><span class="pt-2 text-em-1-5">Pause for another month</span></div><div class="mt-2 small">(Resumes {{::vm.getPausedExpectedRenewalDate(1) | date:\'MMMM d, yyyy\'}})</div><button type="button" class="btn btn-sm rounded-pill mt-3 w-50" ng-class="vm.selectedManageOption === vm.ManagePauseOptionEnum.PauseAnotherMonth ? \'btn-secondary\' : \'btn-outline-secondary\'" ng-dblclick="false">{{vm.selectedManageOption === vm.ManagePauseOptionEnum.PauseAnotherMonth ? \'Selected\' : \'Select\'}}</button></div></div></div><div class="my-5"><h4>What happens next?</h4><ul class="my-4" ng-if="vm.selectedManageOption === vm.ManagePauseOptionEnum.ResumeNow"><li>Your plan will renew today, <b>{{::vm.getNowDate() | date:\'MMMM d, yyyy\'}}</b> instead of {{::vm.subscription.expiryDate | date:\'MMMM d, yyyy\'}}.</li><li>You will be charged {{::vm.subscription.pricePerMonth |currency:-vm.subscription.currencyTypeID}} today.</li><li>You will have {{::vm.subscription.packSize}} lesson{{::vm.subscription.packSize > 1 ? \'s\': \'\'}} available today.</li></ul><ul class="my-4" ng-if="vm.selectedManageOption === vm.ManagePauseOptionEnum.PauseAnotherMonth"><li>Your plan will resume on <b>{{::vm.getPausedExpectedRenewalDate(1) | date:\'MMMM d, yyyy\'}}</b> instead of {{::vm.subscription.expiryDate | date:\'MMMM d, yyyy\'}}.</li><li>Starting on <b>{{::vm.getPausedExpectedRenewalDate(1) | date:\'MMMM d, yyyy\'}}</b>, your payments will automatically begin processing again.</li><li>Your lessons will become available on <b>{{::vm.getPausedExpectedRenewalDate(1) | date:\'MMMM d, yyyy\'}}</b>.</li></ul><p>{{::vm.getCompanyContactInfo()}}</p></div><div class="modal-footer px-4"><button type="button" class="btn btn-outline-secondary col-lg-2 col-md-3 col-12 px-3 ng-scope" ng-click="vm.close()">Cancel</button> <button type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-2" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.managePausedSub()">{{vm.selectedManageOption === vm.ManagePauseOptionEnum.ResumeNow ? \'Resume Now\': \'Extend Pause\'}}</button></div></section><section class="mt-2" ng-if="vm.changeType === vm.ChangeTypeEnum.RenewSub"><b class="text-black">You\u2019re renewing your subscription for the following topic:</b><br>{{::vm.subscription.productName}}<div class="m-6 p-1 d-flex justify-content-center align-items-stretch align-content-between flex-wrap"><div ng-if="::vm.subscription.expiryDate" class="card p-0 col-sm d-flex flex-column backdrop-shadow" style="max-width:15rem;"><div class="card-body h-100 d-flex flex-column text-center"><h4 class="align-self-start">Current Renewal Date</h4><div class="mt-5 font-weight-bold">{{::vm.subscription.expiryDate | date:\'MMMM\'}}</div><div class="mt-1 mx-auto idp-icon-md-circle-bg bg-lightgray font-weight-bold">{{::vm.subscription.expiryDate | date:\'d\'}}</div><div class="py-2 text-muted">{{::vm.subscription.expiryDate | date:\'yyyy\'}}</div></div></div><div ng-if="::vm.subscription.expiryDate" class="col-sm-auto p-0 my-auto d-flex justify-content-center"><i class="bi-arrow-right-circle-fill display-4 d-none d-sm-inline" style="color: rgba(0, 0, 0, 0.2);"></i> <i class="bi-arrow-down-circle-fill display-4 d-sm-none" style="color: rgba(0, 0, 0, 0.2);"></i></div><div class="card p-0 col-sm d-flex flex-column backdrop-shadow" style="max-width:15rem;"><div class="card-body h-100 d-flex flex-column text-center"><h4 class="align-self-start">New Renewal Date</h4><div class="mt-5 font-weight-bold">{{::vm.getNowDate() | date:\'MMMM\'}}</div><div class="mt-1 mx-auto idp-icon-md-circle-bg bg-lightgray font-weight-bold">{{::vm.getNowDate() | date:\'d\'}}</div><div class="py-2 text-muted">{{::vm.getNowDate() | date:\'yyyy\'}}<br>(Today)</div></div></div></div><div class="my-5"><h4>What happens next?</h4><ul class="my-4"><li>Your plan will renew today, <b>{{::vm.getNowDate() | date:\'MMMM d, yyyy\'}}</b><span ng-if="::vm.subscription.expiryDate"> instead of {{::vm.subscription.expiryDate | date:\'MMMM d, yyyy\'}}</span>.</li><li>You will be charged {{::vm.subscription.pricePerMonth |currency:-vm.subscription.currencyTypeID}} today.</li><li>You will have {{::vm.subscription.packSize}} lesson{{::vm.subscription.packSize > 1 ? \'s\': \'\'}} available today.</li></ul><p>{{::vm.getCompanyContactInfo()}}</p></div><div class="modal-footer px-4"><button type="button" class="btn btn-outline-secondary col-lg-2 col-md-3 col-12 px-3 ng-scope" ng-click="vm.close()">Cancel</button> <button type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-2" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.onRenewSubscriptionNowClick()">Confirm Renewal</button></div></section><section class="mt-2" ng-if="vm.changeType === vm.ChangeTypeEnum.ReactivateSub"><b class="text-black">You\u2019re reactivating your subscription for the following topic:</b><br>{{::vm.subscription.productName}}<div class="m-6 p-1 d-flex justify-content-center align-items-stretch align-content-between flex-wrap"><div class="card p-0 col-sm d-flex flex-column backdrop-shadow" style="max-width:15rem;"><div class="card-body h-100 d-flex flex-column text-center"><h4 class="align-self-start">Reactivation Date</h4><div class="mt-5 font-weight-bold">{{::vm.getNowDate() | date:\'MMMM\'}}</div><div class="mt-1 mx-auto idp-icon-md-circle-bg bg-lightgray font-weight-bold">{{::vm.getNowDate() | date:\'d\'}}</div><div class="py-2 text-muted">{{::vm.getNowDate() | date:\'yyyy\'}}<br>(Today)</div></div></div></div><div class="my-5"><h4>What happens next?</h4><ul class="my-4"><li>Your plan will renew today, <b>{{::vm.getNowDate() | date:\'MMMM d, yyyy\'}}</b>.</li><li>You will be charged {{::vm.subscription.pricePerMonth |currency:-vm.subscription.currencyTypeID}} today.</li><li>You will have {{::vm.subscription.packSize}} lesson{{::vm.subscription.packSize > 1 ? \'s\': \'\'}} available today.</li></ul><p>{{::vm.getCompanyContactInfo()}}</p></div><div class="modal-footer px-4"><button type="button" class="btn btn-outline-secondary col-lg-2 col-md-3 col-12 px-3 ng-scope" ng-click="vm.close()">Cancel</button> <button type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-2" ng-disabled="vm.isSubmitting" ng-dblclick="false" ng-click="vm.onRenewSubscriptionNowClick()">Confirm Reactivation</button></div></section><section class="m-2" ng-if="vm.changeType === vm.ChangeTypeEnum.SuspendedInfoPopup"><div class="mb-8 text-center"><h3 class="my-3">Suspended Subscription</h3><div class="my-4"><b>Why does a subscription become suspended?</b><br>An account will become suspended when a payment cannot be processed.</div><div class="my-4"><b>How can I reactivate my suspended subscription?</b><br>If your subscription is suspended, you may reactivate it by<br><button class="btn btn-link p-0" ng-click="vm.goMakePayment()">Making a Payment</button>.</div><div class="mb-8">{{::vm.getCompanyContactInfo()}}</div><button type="button" class="btn btn-outline-secondary col-lg-3 col-md-4 col-12 px-2" ng-dblclick="false" ng-click="vm.close()">Okay, got it!</button></div></section></div><script type="text/ng-template" id="oplConfirmTopicChanged.html"><div class="text-center my-6">\n      <div class="idp-icon-lg-circle-bg bg-light-purple-blue"><i class="bi-arrow-left-right" style="color:#0916cc;"></i></div>\n      <h3 class="my-3">Your subscription topic has been changed.</h3>\n      <div class="my-4">\n        <b>[line1]</b>\n        <br />[line2]\n      </div>\n\n    </div></script><script type="text/ng-template" id="oplConfirmSubChanged.html"><div class="text-center my-6">\n      <div class="idp-icon-lg-circle-bg bg-light-green text-light-green" style="font-size:3.2rem;"><i class="bi-check-lg"></i></div>\n      <h3 class="my-3">Your subscription has been updated.</h3>\n      <div class="my-4">\n        <b>[line1]</b>\n        <br />[line2]\n      </div>\n    </div></script><script type="text/ng-template" id="oplConfirmPause.html"><div class="text-center my-6">\n      <div class="idp-icon-lg-circle-bg bg-light-purple text-purple" style="font-size:3.2rem;"><i class="bi-pause-fill"></i></div>\n      <h3 class="my-3">[title]</h3>\n      <div class="my-4">\n        <b>[line1]</b> [line2]\n      </div>\n    </div></script><script type="text/ng-template" id="oplConfirmCancel.html"><div class="text-center my-6">\n      <div class="idp-icon-lg-circle-bg bg-light-red text-danger">\n        <i class="bi-trash3" style="position: relative;top: .2rem;"></i>\n      </div>\n      <h3 class="my-3">[title]</h3>\n      <div class="my-4">\n        <b>[line1]</b> [line2]\n      </div>\n    </div></script><script type="text/ng-template" id="oplConfirmRenew.html"><div class="text-center my-6">\n      <div class="idp-icon-lg-circle-bg bg-light-green text-light-green" style="font-size:3.2rem;"><i class="bi-check-lg"></i></div>\n      <h3 class="my-3">[title]</h3>\n      <div class="my-4">\n        <b>[line1]</b>\n        [line2]\n      </div>\n    </div></script></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-subscription-pause-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header border-0 pb-0"><button type="button" class="close text-em-2-5" ng-show="!vm.showConfirmation" data-dismiss="modal" aria-hidden="true" data-ng-click="vm.close()">&#xD7;</button></div><div class="modal-body px-3 px-lg-8 pt-0"><section ng-show="!vm.showConfirmation"><h3>Pause your subscription</h3><div class="text-black">Need to take a break? You have the flexibility to pause your subscription and resume your lessons when the time is right.</div><div class="text-black mt-3"><b>You\u2019re pausing your subscription for the following topic:</b></div><span class="text-black">{{vm.initDataObj.courseName}} <span ng-show="vm.initDataObj.isAutoRenew">(Monthly subscription)</span></span><div class="mt-3 text-black">Select a duration</div><div class="d-flex mt-2"><div ng-repeat="d in vm.pauseDurations" class="card px-2 px-md-4 px-lg-6 py-3 mr-2 mr-sm-6 c-pointer shadow border-4 align-self-center duration-list" ng-class="{\'selected\': vm.isSelectedDuration(d)}" ng-click="vm.selectedDuration = d;"><div class="d-flex align-items-center"><i class="icon mr-2" ng-class="\'icon-cal-{{d.length}}-month\'"></i><span>Month{{d.length == 1 ? \'\':\'s\'}}</span></div></div></div></section><section ng-show="vm.showConfirmation"><div class="text-black text-em-1-25 font-weight-bold mt-3">Your subscription has been paused.</div><div class="text-black font-weight-bold mt-4">Your subscription will resume on {{vm.resumeDate | date:\'M/d/yy\'}}, and your next payment will be processed automatically on that day.</div><div class="mt-3">Any unused lessons are saved in <a href="#/my-account/online-private-lesson/clientSessions">My Account</a> and can be scheduled any time. See you soon!</div></section></div><div class="modal-footer justify-content-center flex-column border-0" ng-show="!vm.showConfirmation"><button class="btn btn-primary px-8" type="submit" ng-click="vm.submit();" ng-disabled="!vm.selectedDuration || vm.isSubmitting" data-ng-dblclick="false">Pause subscription</button> <button class="btn btn-link mt-2 px-8" type="button" data-ng-click="vm.close()">Close</button></div><div class="modal-footer border-0" ng-show="vm.showConfirmation"><button class="btn btn-link mt-2 px-8" type="button" data-ng-click="vm.closeAnyNotify()">Ok, got it!</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-voucher-scholarship-info.html','<div data-ng-form="{{::vm.formName}}"><fieldset ng-disabled="vm.isReadOnly"><div class="row"><div class="col-md-6"><div class="form-group"><label class="sr-only" for="issuerOne">Code</label> <input name="couponCode" type="text" class="form-control" placeholder="Code" ng-model="vm.voucherScholarshipInfo.couponCode" ng-required="true" maxlength="100" autocomplete="off" uib-tooltip="code" tooltip-trigger="focus"><div ng-messages="vm.myForm.couponCode.$error" class="text-danger"><div ng-message="required">Code is required</div><div ng-message="maxlength">The code must be 100 characters or less</div></div></div></div><div class="col-md-6"><div class="form-group"><label class="sr-only" for="IssuerTwo">Validation Text</label> <input name="couponValidationString" type="text" class="form-control" placeholder="Validation Text" ng-model="vm.voucherScholarshipInfo.couponValidationString" ng-required="true" maxlength="100" autocomplete="off" uib-tooltip="Validation Text" tooltip-trigger="focus"><div ng-messages="vm.myForm.couponValidationString.$error" class="text-danger"><div ng-message="required">Validation Text is required</div><div ng-message="maxlength">The Validation Text must be 100 characters or less</div></div></div></div></div></fieldset></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/billing/idp-voucher.html','<div><strong>Date created:</strong> {{vm.coupon.createdDate | date:\'M/d/yyyy\'}}</div><div><strong>Status:</strong> {{vm.coupon.dateUsed ? \'used\': \'unused\'}} <span ng-show="vm.coupon.dateUsed">on {{vm.coupon.dateUsed | date:\'M/d/yyyy\'}}</span></div><div ng-hide="vm.coupon.consumedByUserID && vm.coupon.dateUsed"><strong>Expires:</strong> {{vm.coupon.expirationDate | date:\'M/d/yyyy\'}}</div><div ng-hide="vm.coupon.consumedByUserID && vm.coupon.dateUsed"><strong>Max Value:</strong> {{vm.coupon.amount | currency:"$":0}}</div><div ng-hide="vm.coupon.consumedByUserID && vm.coupon.dateUsed"><strong>Code:</strong> {{vm.coupon.couponCode }}</div><div ng-hide="vm.coupon.consumedByUserID && vm.coupon.dateUsed"><strong>Validation:</strong> {{vm.coupon.validationString}}</div><div ng-show="vm.coupon.consumedByUserID && vm.coupon.consumedByUserName"><strong>Used by:</strong> {{vm.coupon.consumedByUserName}}</div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/common/idp-date-picker.html','<div ng-form="{{::vm.formName}}"><div ng-show="vm.isEditMode" class="d-block d-md-flex flex-md-row"><div class="month-section mb-3 mb-md-0 mr-md-3" style="flex-grow: 1;" ng-show="vm.showMonth"><label for="idp_dob_selectMonth" class="sr-only">Month of birth</label> <select name="selectedMonth" class="form-control" data-ng-disabled="!vm.isEditMode || vm.isDisabled()" ng-model="vm.selectedMonth" ng-change="vm.onValueChange()" id="idp_dob_selectMonth" tabindex="{{::vm.firstTabIndex}}"><option value="" disabled="disabled" hidden>{{vm.monthLabel || \'Month\'}}</option><option ng-repeat="month in vm.months track by month.id" aria-label="{{month.fullMonthLabel}}" ng-value="{{month.id}}">{{month.label}}</option></select></div><div class="day-section mb-3 mb-md-0 mr-md-3" style="flex-grow: 1;" ng-show="vm.showDay"><label for="idp_dob_selectDay" class="sr-only">Day of birth</label> <select name="selectedDay" class="form-control" ng-disabled="!vm.isEditMode || vm.isDisabled()" ng-model="vm.selectedDay" ng-change="vm.onValueChange()" ng-options="option.label for option in vm.days track by option.id" id="idp_dob_selectDay" tabindex="{{::vm.firstTabIndex}}"><option value="" disabled="disabled" hidden>{{vm.dayLabel || \'Day\'}}</option></select></div><div class="year-section mb-md-0" style="flex-grow: 1;" ng-show="vm.showYear"><label for="idp_dob_selectYear" class="sr-only">Year of birth</label> <select name="selectedYear" class="form-control" ng-disabled="!vm.isEditMode || vm.isDisabled()" ng-model="vm.selectedYear" ng-change="vm.onValueChange()" ng-options="option.label for option in vm.years track by option.id" id="idp_dob_selectYear" tabindex="{{::vm.firstTabIndex}}"><option value="" disabled="disabled" hidden>{{vm.yearLabel || \'Year\'}}</option></select></div></div><div ng-show="vm.isEditMode"><input name="date" type="text" class="d-none" ng-model="vm.date" idp-date-between-validator min-date="vm.validMinDate" max-date="vm.validMaxDate" disable-date-between-validator="vm.disableDateRangeValidation" ng-required="vm.isRequired" readonly="readonly"><div ng-messages="vm.myForm.date.$error" role="alert" class="text-danger"><div ng-message="required">{{vm.requiredMessage || \'Student date of birth is required\'}}</div><div ng-message="idpDateBetweenValidator">{{ vm.invalidDateMsg || \'Student does not meet age requirements.\' }}</div></div></div><div ng-hide="vm.isEditMode" class="form-group"><input name="view_only_date" class="form-control" type="text" ng-class="{\'ng-invalid\': vm.myForm.date.$invalid}" ng-disabled="vm.isDisabled()" ng-value="vm.date | date:longDate" readonly="readonly"><div ng-show="vm.myForm.date.$invalid" class="text-danger small">{{ vm.invalidDateMsg || \'Student does not meet age requirements.\'}}</div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/common/idp-gender.html','<div data-ng-form="{{::vm.formName}}" class="" ng-disabled="!vm.isEditMode"><div ng-if="vm.radioFormat && (vm.isEditMode || !vm.textWhenReadOnly)" class="row"><div class="col-12"><legend style="font-size: {{vm.labelFontSize}};" class="{{vm.labelClass}}" ng-id="$ctrl.legend">Gender: <button type="button" class="btn btn-link text-dark display_popover d-inline icon icon-info ml-1 {{vm.infoIconSize}} p-0" style="vertical-align: baseline;" popover-trigger="\'outsideClick\'" uib-popover-html="vm.genderHelpHtml" popover-placement="bottom-left" id="genderHelpID"><span class="sr-only">More information about gender</span></button></legend></div><span ng-repeat="gender in vm.genderTypes" class="idp-gender-option"><span class="form-check flex-grow-0 flex-shrink-0"><input id="genderTypeID{{vm.id}}_{{gender.typeID}}" class="form-check-input" name="genderTypeID{{ vm.id }}" ng-model="vm.genderTypeId" ng-readonly="!vm.isEditMode" ng-disabled="!vm.isEditMode" type="radio" ng-value="gender.typeID" ng-change="vm.onGenderSelected($event, gender)" ng-required="vm.isRequired"> <label for="genderTypeID{{vm.id}}_{{gender.typeID}}" ng-click="vm.onGenderSelected($event, gender)" class="form-check-label">{{ gender.typeString }}</label></span></span></div><div ng-if="!vm.radioFormat && (vm.isEditMode || !vm.textWhenReadOnly)" class="row"><div class="col-12 label {{vm.labelClass}}">Gender:<button type="button" class="icon icon-info feedback-icon text-decoration-none btn btn-text" style="vertical-align: baseline;" ng-click="vm.showGenderHelp($event)"><span class="sr-only">More information about gender</span></button></div><div class="col-12 form-group"><div class="justify-content-start" role="group" aria-label="gender"><button ng-repeat="gen in vm.genderTypes" id="genderType{{gen.typeID}}" type="button" class="btn btn-outline-secondary col-md-4" name="studentGenderTypeID" ng-class="{ \'active fonrt-weight-bold\': (vm.genderTypeId == gen.typeID),\n            \'d-none\': (!vm.isEditMode && vm.genderTypeId != gen.typeID)}" ng-click="vm.changeGender(gen.typeID)" ng-disabled="!vm.isEditMode"><span class="text=text-capitalize">{{::gen.typeExtraString}}</span></button></div></div></div><div class="row idp-readonly-gender"><div class="col-12" data-ng-hide="vm.isEditMode || !vm.textWhenReadOnly"><span ng-repeat="gen in vm.genderTypes" ng-show="gen.typeID == vm.genderTypeId">{{:: gen.typeExtraString}}</span></div></div><input name="studentGenderTypeID" type="text" ng-model="vm.genderTypeId" class="d-none" ng-required="vm.isEditMode && vm.isRequired"><div class="text-danger" ng-messages="vm.myForm.studentGenderTypeID.$error"><div ng-message="required" role="alert">Student gender is required</div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/common/idp-intl-tel-input.html','<div ng-cloak ng-show="vm.isEditMode" ng-form="{{::vm.formName}}"><input class="form-control" type="tel" name="phoneNumber" ng-model="vm.phoneNumber" intl-tel-input intl-tel-input-controller="vm.phoneNumberCtrl" ng-model-options="{ debounce: 300, allowInvalid: true }" uib-tooltip="{{vm.phoneNumberPlaceHolder}}" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex}}" ng-required="vm.isRequired" autocomplete="tel"><div class="text-danger small" ng-show="(vm.myForm.phoneNumber.$dirty || vm.myForm.phoneNumber.$touched || vm.myForm.$submitted) && (vm.myForm.phoneNumber.$error.phoneNumber || vm.myForm.phoneNumber.$error.required)">Please enter a valid phone number</div></div><div class="row" ng-hide="vm.isEditMode"><div class="col-xs-12">{{vm.phoneNumberFormatted}}</div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/common/idp-password.html','\uFEFF<div ng-form="{{::vm.formName}}"><div style="opacity:.01;width:1px;height:1px;"><input id="dpac_1" type="password"></div><div class="row"><div class="col-sm-4"><div class="form-group id-required" ng-class="{\'has-error\': (vm.submitted || vm.myForm.newPassword.$dirty) && vm.myForm.newPassword.$invalid}"><input type="password" class="form-control" name="newPassword" placeholder="New Password" required tabindex="{{::vm.firstTabIndex}}" ng-model="vm.newPassword" ng-model-options="{ \'updateOn\' : \'blur\' }" ng-pattern="vm.passwordRegExp" uib-tooltip="New Password (case sensitive)" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.newPassword.$error" class="text-danger"><div ng-message="required">Password is required</div><div ng-message="pattern">{{vm.passwordRegExpErrorMsg}}</div></div></div></div></div><div class="row"><div class="col-sm-4"><div class="form-group" ng-class="{\'has-error\': (vm.submitted || vm.myForm.newPasswordConfirm.$dirty) && vm.myForm.newPasswordConfirm.$invalid}"><input type="password" class="form-control" name="newPasswordConfirm" placeholder="Confirm New Password" ng-model="vm.newPasswordConfirm" ng-model-options="{ \'updateOn\' : \'blur\' }" ng-required="true" tabindex="{{::vm.firstTabIndex+1}}" data-idp-match="vm.newPassword" uib-tooltip="Confirm New Password" tooltip-trigger="\'focus\'" required><div ng-messages="vm.myForm.newPasswordConfirm.$error" class="text-danger"><div ng-message="required">Confirmation password is required</div><div ng-message="idpMatch">{{vm.passwordRegExpMatchMsg}}</div></div></div></div></div><div>Passwords are CASE sensitive, must be 6 to 25 characters, and must contain at least 1 number. The following special characters are also accepted: ! @ # $ % & ; : , . ?</div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/common/idp-scheduled-payments-popup.html','<form id="{{::vm.formName}}" name="{{::vm.formName}}" class="pulseapp" ng-cloak role="form" novalidate autocomplete="something-new" idp-form-focus-on-err><div><div class="modal-header idp-popup-title">{{vm.title}} <button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div class="row mt-4" ng-show="vm.showSchedule"><div class="col-xs-12"><table style="width:100%"><tr><td class="p-2 border border-top-0 border-left-0 border-bottom-0" style="width:33.3%;" align="center">Payment Date</td><td class="p-2 border border-top-0 border-left-0 border-right-0 border-bottom-0" style="width:33.3%;" align="center">Amount Due</td></tr><tbody ng-repeat="monthlyTotalInfo in vm.initDataObj.scheduledPaymentsInfo.monthlyTotalsUnpaid"><tr class="mt-3"><td class="p-2 border border-left-0 border-bottom-0" style="width:33.3%;" align="center"><span class="font-weight-bold">{{::monthlyTotalInfo.paymentDueDateAsString}}</span><br></td><td class="p-2 border border-left-0 border-bottom-0 border-right-0 font-weight-bold" style="width:33.3%;" align="center">{{::monthlyTotalInfo.amountDue | currency:vm.currencyTypeID:2}}</td></tr></tbody></table><p class="mt-5">Note: These payments do not include any online lesson subscriptions.</p></div></div><div class="row mt-1" ng-show="!vm.showSchedule"><div class="col-xs-12"><p>Your payment today covers the first installment for any program purchased via a payment plan and includes a non-refundable 3% payment plan fee and the full amount of any other services purchased. (Note: If you are purchasing an on-campus program, the amount you are paying today also includes a $250 per week per program non-refundable deposit.) The credit card used today will be auto-billed for remaining installments. By selecting this payment option, you are authorizing iD Tech to charge your card on file for the amounts due per the detailed payment schedule provided in My Account.</p><p>If you have any questions, please contact our Program Specialists at 1-888-709-8324.</p></div></div></div><div class="modal-footer"><div class="col-xs-12" style="text-align:center;"><button class="btn btn-primary done-button" style="margin:auto;" ng-click="vm.close()">Close</button></div></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/common/idp-scheduled-payments.html','<idp-scheduled-payments-popup></idp-scheduled-payments-popup><div class="row" ng-show="vm.isForMyAccount == false || vm.hasAdditionalBalanceDue"><div class="col-xs-12 text-left"><div ng-show="vm.isForMyAccount == false"><span ng-show="vm.selectedPaymentOption.paymentAmount > 0">The amount above is due now and includes a 3% payment plan fee. </span>The remaining balance is divided into monthly installments on this <a href="" ng-click="vm.showPaymentSchedule()">payment schedule</a>. <span class="icon icon-info" ng-click="vm.showMoreInfo()" role="button" tabindex="0"></span></div></div><div class="col-xs-12 mt-5 border border-top-0 border-left-0 border-right-0"></div></div><div class="row mt-4" ng-show="vm.isForMyAccount"><div class="col-xs-12"><table style="width:100%"><tr><td class="p-2 border border-top-0 border-left-0 border-bottom-0" style="width:33.3%;" align="center">Payment Date</td><td class="p-2 border border-top-0 border-left-0 border-bottom-0" style="width:33.3%;" align="center">Amount Due</td><td class="p-2" style="width:33.3%;" align="center">Status</td></tr><tbody ng-repeat="monthlyTotalInfo in vm.scheduledPaymentsInfo.monthlyTotals"><tr class="mt-3"><td class="p-2 border border-left-0 border-bottom-0" style="width:33.3%;" align="center"><span class="font-weight-bold">{{::monthlyTotalInfo.paymentDueDateAsString}}</span><br><a class="link" href="" ng-hide="monthlyTotalInfo.isDetailVisible" ng-click="vm.setIsMonthlyTotalDetailVisible($index,true)">show student details</a> <a class="link" href="" ng-show="monthlyTotalInfo.isDetailVisible" ng-click="vm.setIsMonthlyTotalDetailVisible($index,false)">hide student details</a></td><td class="p-2 border border-left-0 border-bottom-0 font-weight-bold" style="width:33.3%;" align="center">{{::monthlyTotalInfo.amountDue | currency:vm.currencyTypeId:2}}</td><td class="p-2 border border-left-0 border-bottom-0 border-right-0 font-weight-bold" style="width:33.3%;" align="center">{{::monthlyTotalInfo.statusTypeAsString}}</td></tr><tr class="mt-3" ng-show="monthlyTotalInfo.isDetailVisible" ng-repeat="detailInfo in monthlyTotalInfo.details"><td class="p-2 border border-left-0 border-bottom-0" style="width:33.3%;" align="center"><div>{{::detailInfo.divisionName}}</div><div>starts {{::detailInfo.sessionStartDateAsString}}</div><div>{{::detailInfo.participantFirstName}} {{::detailInfo.participantLastName}}</div></td><td class="p-2 border border-left-0 border-bottom-0" style="width:33.3%;" align="center">{{::detailInfo.amountDue | currency:vm.currencyTypeId:2}}</td><td class="p-2 border border-left-0 border-bottom-0 border-right-0" style="width:33.3%;" align="center">{{::detailInfo.statusTypeAsString}}</td></tr></tbody></table></div></div><script type="text/ng-template" id="customerPaymentPlanInfo.html"><p>\n    Automatic payments will be auto-billed to your credit card on the dates listed.\n    <!--All payments must be made by May 2.--> There are no additional fees or interest.\n  </p>\n  <p>\n    If you have any questions, please contact Client Services at 1-888-709-8324.\n  </p></script>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/common/idp-type-selector.html','<div data-ng-form="{{::vm.formName}}" class="d-inline-block"><div class="btn-group border rounded" role="group" ng-class="vm.verticalLayout ? \'btn-group-vertical\' : \'btn-group-justified\'" uib-tooltip="{{vm.tooltip}}"><div class="btn-group" role="group" ng-repeat="t in vm.types track by t.typeID"><button type="button" class="btn btn-primary" ng-disabled="vm.isReadOnly" ng-class="vm.isSelected(t) ? \'btn-primary\' : \'btn-light\'" ng-click="vm.toggleSelected(t)"><span class="text-capitalize">{{t.typeString}}</span></button></div></div><select name="backingSelect" id="backingSelect" class="d-none" multiple="multiple" ng-model="vm.selectedTypes" ng-disabled="vm.isReadOnly" ng-options="t.typeID for t in vm.types track by t.typeID"></select><div ng-messages="vm.myForm.backingSelect.$error" class="text-danger"><div ng-message="required">{{vm.requiredMessage}}</div><div ng-message="maxlength">{{vm.maxMessage}}</div><div ng-message="minlength">{{vm.minMessage}}</div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/contact-info/idp-email-address.html','<div ng-form="{{::vm.formName}}"><div class="row"><div class="col-xs-12 col-md-4"><div class="form-group"><label class="sr-only" for="email">Email Address</label> <input name="email" class="form-control" type="email" placeholder="Email Address" uib-tooltip="Email Address" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+1}}" ng-maxlength="200" ng-model-options="{ updateOn : \'blur\', debounce: 300, allowInvalid: true }" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emailUserContactMethod.contactMethodOther" ng-blur="vm.checkEmailUniqueness($event)" autocomplete="email"><div ng-messages="vm.myForm.email.$error" class="text-danger"><div ng-message="required">Email is required</div><div ng-message="maxlength">Your email address cannot be more than 200 characters</div><div ng-message="unique">This email address already exists, please try another</div><div ng-message="email">{{vm.emailRegExpErrorMsg}}</div></div></div></div></div><div class="row"><div class=""><div class="form-check"><a href="" ng-click="vm.onNotificationSettingClicked()">Update Notification Settings</a> <span id="newsletterHelpPopup" class="ml-1 icon icon-info c-pointer" ng-click="vm.openNewsLetterPopup($event)"></span></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/contact-info/idp-mailing-address.html','<div ng-form="{{::vm.formName}}"><div class="row"><div class="col-sm-4"><div class="form-group"><label class="sr-only" for="country">Country</label> <select class="form-control" name="country" placeholder="Country" uib-tooltip="Country" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+21}}" ng-required="true" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.address.countryType" ng-options="t.typeString for t in vm.countryTypes track by t.typeID" ng-change="vm.countryTypeChanged()" autocomplete="country"><option value="" disabled="disabled" selected="selected">Country</option></select><div ng-messages="vm.myForm.country.$error" class="text-danger"><div ng-message="required">Country is required</div></div></div></div><div class="col-sm-4"><div class="form-group"><label class="sr-only" for="address1">Address Line 1</label> <input type="text" class="form-control" name="address1" placeholder="Address Line 1" uib-tooltip="Address Line 1" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+22}}" ng-required="true" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.address.address1" autocomplete="address-line1"><div ng-messages="vm.myForm.address1.$error" class="text-danger"><div ng-message="required">Address Line 1 is required</div></div></div></div><div class="col-sm-4"><div class="form-group"><label class="sr-only" for="address2">Address Line 2</label> <input type="text" class="form-control" name="address2" placeholder="Address Line 2" uib-tooltip="Address Line 2" tooltip-trigger="\'focus\'" ng-required="false" tabindex="{{::vm.firstTabIndex+23}}" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.address.address2" autocomplete="address-line2"></div></div></div><div class="row"><div class="col-sm-4"><div class="form-group"><label class="sr-only" for="city">City</label> <input type="text" class="form-control" name="city" placeholder="City" uib-tooltip="City" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+24}}" ng-required="true" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.address.city" autocomplete="shipping address-level2"><div ng-messages="vm.myForm.city.$error" class="text-danger"><div ng-message="required">City is required</div></div></div></div><div class="col-sm-4"><div class="form-group" ng-if="vm.address.countryType.typeID != $root.Enums.CountryType.USA"><label class="sr-only" for="stateprovince">State/Province</label> <input type="text" class="form-control" name="stateprovince" placeholder="State/Province" uib-tooltip="State/Province" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+25}}" ng-required="false" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.address.state" autocomplete="shipping address-level1"><div ng-messages="vm.myForm.stateprovince.$error" class="text-danger"><div ng-message="required">State/Province is required</div></div></div><div class="form-group" ng-if="vm.address.countryType.typeID == $root.Enums.CountryType.USA"><label class="sr-only" for="state">State</label> <select class="form-control" name="state" placeholder="State" uib-tooltip="State" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+26}}" ng-required="vm.address.countryType.typeID == $root.Enums.CountryType.USA" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.address.stateType" ng-options="t.typeString for t in vm.stateTypes track by t.typeID" ng-change="vm.stateTypeChanged()" ng-init="vm.address.stateType = vm.address.stateType || options[0].value" autocomplete="shipping address-level1"><option value="" disabled="disabled" selected="selected">State</option></select><div ng-messages="vm.myForm.state.$error" class="text-danger"><div ng-message="required">State is required</div></div></div></div><div class="col-sm-4"><div class="form-group"><label class="sr-only" for="postalCode">{{vm.address.countryType.typeID == $root.Enums.CountryType.USA ? \'Zip\' : \'Postal\'}} Code</label> <input type="text" class="form-control" name="postalCode" placeholder="{{vm.address.countryType.typeID == $root.Enums.CountryType.USA ? \'Zip\' : \'Postal\'}} Code" uib-tooltip="{{vm.address.countryType.typeID == $root.Enums.CountryType.USA ? \'Zip\' : \'Postal\'}} Code" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+27}}" ng-required="true" maxlength="20" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.address.postalCode" autocomplete="shipping postal-code"><div ng-messages="vm.myForm.postalCode.$error" class="text-danger"><div ng-message="required">{{vm.address.countryType.typeID == $root.Enums.CountryType.USA ? \'Zip\' : \'Postal\'}} Code is required</div></div></div></div></div><div class="row" ng-if="vm.showPromotionsAndNewsCheckbox === undefined || vm.showPromotionsAndNewsCheckbox === true"><div class="col-sm-10"><a href="" ng-click="vm.onNotificationSettingClicked()">Update Notification Settings</a></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/contact-info/idp-personal-info.html','<div ng-form="{{::vm.formName}}" class="row"><div class="col-sm-4"><div class="form-group"><label class="sr-only" for="firstName">First Name</label> <input name="firstName" class="form-control" placeholder="First Name" uib-tooltip="First Name" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex}}" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.user.firstName" autocomplete="given-name"><div ng-messages="vm.myForm.firstName.$error" class="text-danger"><div ng-message="required">First Name is required</div></div></div></div><div class="col-sm-4"><div class="form-group"><label class="sr-only" for="lastName">Last Name</label> <input name="lastName" class="form-control" placeholder="Last Name" uib-tooltip="Last Name" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+1}}" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.user.lastName" autocomplete="family-name"><div ng-messages="vm.myForm.lastName.$error" class="text-danger"><div ng-message="required">Last Name is required</div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/contact-info/idp-phone-numbers.html','<div ng-form="{{vm.formName}}" novalidate><div class="row" ng-repeat="phone in filtered = (vm.phoneUserContactMethods | filter:{recordStateID:$root.Enums.RecordStateType.Active})"><div class="col-md-12"><div class="row"><div class="col-xs-12"><span><em>Phone {{$index + 1}}</em><a href="" class="ml-3" ng-if="$index > 0" ng-click="vm.removePhone(phone)">Remove</a></span></div></div><div class="row"><div class="col-md-3 col-lg-3"><div class="form-group"><select name="phonetype_{{$index}}" class="form-control" placeholder="Phone Type" uib-tooltip="Phone Type" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+3}}" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="phone.contactMethodType" ng-options="t.typeString for t in vm.phoneContactMethodTypes track by t.typeID" ng-change="vm.contactMethodTypeChanged(phone)"><option value="" disabled="disabled" selected="selected">Phone Type</option></select><div ng-messages="vm.myForm[\'phonetype_\' + $index].$error" class="text-danger"><div ng-message="required">Phone type is required</div></div></div></div><div class="col-md-7 col-lg-4"><idp-intl-tel-input country-code="phone.countryCode" phone-number="phone.fullPhone" is-required="true" is-readonly="!vm.canCreate || !vm.canUpdate" is-edit-mode="true" first-tab-index="vm.firstTabIndex+4" phone-number-place-holder="Phone Number {{$index+1}}"></div><div class="col-md-2 col-lg-2 pt-2"><div class="form-check"><input class="form-check-input" type="radio" id="isPrimaryNumber_{{$index}}" name="primaryNumber" ng-model="phone.isPrimaryNumber" ng-value="true" ng-change="vm.updateIsPrimaryNumber($index, phone)" ng-disabled="!vm.canCreate || !vm.canUpdate"> <label class="form-check-label" for="isPrimaryNumber_{{$index}}">Primary</label> <input type="hidden" name="isPrimaryNumber_{{$index}}" ng-model="phone.isPrimaryNumber"></div></div><div class="col-md-12 mb-3 col-lg-3 pt-2"><a href="" ng-show="phone.isPrimaryNumber" ng-click="vm.onNotificationSettingClicked()">Update Notification Settings</a></div></div></div></div><div class="row my-3"><div class="col-sm-4 col-lg-3"><a href="" ng-click="vm.addPhone()">Add Phone Number</a></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/idp-my-student-form-sections.html','<div ng-show="vm.show"><div id="formSectionID{{section.formSectionID}}" data-ng-repeat="section in vm.formSections track by section.formSectionID"><strong>{{section.formSectionName}}</strong><br><span ng-show="section.isStatusReadOnly">{{section.status}}</span> <select ng-show="!section.isStatusReadOnly" ng-options="item.typeID as item.typeString for item in vm.formStatusTypes" ng-change="vm.ufdStatusChanged(section)" ng-model="section.statusTypeID"></select></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/idp-my-student-hsf-section-links.html','<ul class="list-unstyled" ng-if="vm.show"><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_PrimaryEmergencyContact + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Primary Emergency Contact</button></li><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_SecondaryEmergencyContact + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Secondary Emergency Contact</button></li><li ng-hide="vm.isTeen"><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_CheckInOut + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Code Word</button></li><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_CheckInOut + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Self Sign Out</button></li><li ng-hide="vm.isTeen"><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_AuthPickupContacts + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Authorized Pick-Up Contacts</button></li><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_Insurance + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Health Insurance</button></li><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_HealthHistory + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Medical Condition</button></li><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_HealthHistory + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Allergies</button></li><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_HealthHistory + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Dietary Restrictions</button></li><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_Medications + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Medication(s)</button></li><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_SpecialNeedsImmunizations + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Activity Limitations or Participation Restrictions</button></li><li ng-show="vm.isUsOnly"><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_SpecialNeedsImmunizations + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Immunizations</button></li><li><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_Schooling + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Learning Style</button></li><li ng-if="vm.pulseContext.isImpersonating"><button type="button" class="btn btn-link py-0" ng-click="vm.$location.url($root.Routes.HSF_Authorization + \'?ufdid\' + \'=\' + vm.userFormDetailId)">Submission History</button></li></ul>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/idp-my-students-past-form-uploads.html','<div id="idp-my-students-past-form-uploads" ng-show="vm.show"><div ng-show="vm.anyPastUploads"><div id="file{{file.iD}}" class="row border-bottom border-light py-1" ng-class-odd="bg-light" data-ng-repeat="file in vm.formsList track by file.userFileID"><div class="col-md-3"><strong ng-show="vm.showGridHeadingWhenMobile($index)">Form Type</strong><div>{{file.fileUsageType}}</div></div><div class="col-md-6"><strong ng-show="vm.showGridHeadingWhenMobile($index)">File</strong><div>{{file.description || file.fileName }}</div></div><div class="col-md-3"><strong ng-show="vm.showGridHeadingWhenMobile($index)">Date Uploaded</strong><div>{{file.createdDate | date:\'MM/dd/yyyy\' }}</div></div></div></div><div ng-show="!vm.anyPastUploads"><div>No forms have been uploaded for the students currently enrolled.</div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/idp-my-students-with-forms-history.html','<div ng-form="{{::vm.formName}}" id="idp-my-students-with-forms-history" ng-show="vm.show"><div ng-show="!vm.anyStudents()">You have no associated students with historic data for whom you are the parent/guardian.</div><p ng-show="vm.anyStudents()"><strong>Choose a student to see their Required Forms History:</strong></p><div class="id-panel-group" id="historyStudents" ng-show="vm.anyStudents()"><div class="card id-collapsible-card mt-3" ng-repeat="student in vm.studentList track by student.userID"><div class="card-heading" id="historyHeading{{::student.userID}}" ng-click="vm.onToggleClick($index)" ng-class="{\'collapsed\': !student.isExpanded}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{\'d-none\': student.isExpanded}"></span> <span class="icon icon-minus-1" ng-class="{\'d-none\': !student.isExpanded}"></span></div><div class="content font-weight-bold"><span>{{student.firstName}} {{student.lastName}}</span></div></div></div><div id="historyCollapse{{::student.userID}}" class="panel-collapse padded-content" uib-collapse="!student.isExpanded"><div class="card-body px-md-6"><table class="table table-striped d-none d-md-table"><thead><tr><th scope="col" class="border-top-0">Required Form</th><th scope="col" class="border-top-0">Season</th><th scope="col" class="border-top-0">Location</th><th scope="col" class="border-top-0">Status</th><th scope="col" class="border-top-0">Due Date</th><th scope="col" class="border-top-0"></th></tr></thead><tbody><tr ng-repeat="req in student.requiredForms | orderBy:\'formInfo.dueDate\':true track by req.formInfo.userFormDetailID" ng-init="reqSections = req.sections"><td><div>{{req.formInfo.formName}}</div><idp-my-student-hsf-section-links user-form-detail-id="req.formInfo.userFormDetailID" term-group-id="req.formInfo.termGroupID" status-type-id="req.formInfo.statusTypeID" form-category-type-id="req.formInfo.categoryTypeID" is-teen="student.isTeen" ng-if="vm.isPrivilegedUser() && vm.isPrivilegedUserEndDateAfterToday(req.formInfo.privilegedUserEditableUntil)"></idp-my-student-hsf-section-links></td><td>{{req.formInfo.termGroupName}}<div><small class="text-muted">Editable until {{req.formInfo.privilegedUserEditableUntil | date:\'MM/dd/yyyy\'}}</small></div></td><td>{{req.formInfo.locationName}}</td><td><span ng-show="req.isStatusReadOnly">{{vm.formStatusDict.getValue(req.formInfo.statusTypeID).typeString}}</span><br><select ng-show="!req.isStatusReadOnly" ng-options="item.typeID as item.typeString for item in vm.formStatusTypes" ng-model="req.formInfo.statusTypeID" ng-change="vm.ufdStatusChanged(req)"></select><idp-my-student-form-sections show="vm.pulseContext.isImpersonating" master-form="req.formInfo" form-sections="reqSections" form-status-types="vm.formStatusTypes"></idp-my-student-form-sections></td><td><div ng-show="vm.showDueDate(req)">{{req.formInfo.dueDate | date:\'MM/dd/yyyy\' }}</div></td><td class="text-center"><button type="button" class="btn btn-primary btn-sm btn-block" ng-show="req.isFormButtonVisible" ng-disabled="req.isFormButtonDisabled" ng-click="vm.onViewFormClick(req, student.userID);" formnovalidate>{{req.formButtonText}}</button> <span ng-show="!req.isFormButtonVisible">{{req.noFormButtonText}}</span></td></tr></tbody></table><div class="border border-light bg-light mb-3 p-3 d-md-none" ng-repeat="req in student.requiredForms | orderBy:\'formInfo.dueDate\':true track by req.formInfo.userFormDetailID" ng-init="reqSections = req.sections"><dl><dt>Required Form</dt><dd>{{req.formInfo.formName}}</dd><dt>Season</dt><dd>{{req.formInfo.termGroupName}} <small class="text-muted">Editable until {{req.formInfo.privilegedUserEditableUntil | date:\'MM/dd/yyyy\'}}</small></dd><dt>Location</dt><dd>{{req.formInfo.locationName}}</dd><dt>Status</dt><dd><span ng-show="req.isStatusReadOnly">{{vm.formStatusDict.getValue(req.formInfo.statusTypeID).typeString}}</span> <select ng-show="!req.isStatusReadOnly" ng-options="item.typeID as item.typeString for item in vm.formStatusTypes" ng-model="req.formInfo.statusTypeID" ng-change="vm.ufdStatusChanged(req)"></select><idp-my-student-form-sections show="vm.pulseContext.isImpersonating" master-form="req.formInfo" form-sections="reqSections" form-status-types="vm.formStatusTypes"></idp-my-student-form-sections></dd><dt>Due Date</dt><dd><div ng-show="vm.showDueDate(req)">{{req.formInfo.dueDate | date:\'MM/dd/yyyy\' }}</div></dd></dl><button type="button" class="btn btn-primary btn-sm btn-block" ng-show="req.isFormButtonVisible" ng-disabled="req.isFormButtonDisabled" ng-click="vm.onViewFormClick(req, student.userID);" formnovalidate>{{req.formButtonText}}</button> <span ng-show="!req.isFormButtonVisible">{{req.noFormButtonText}}</span></div></div><div class="card-body px-md-6"><p ng-show="(student.additionalForms.length == 0)">No additional forms are required</p><table class="table table-striped d-none d-md-table" ng-show="(student.additionalForms.length > 0)"><thead><tr><th scope="col" class="border-top-0">Additional Required Form</th><th scope="col" class="border-top-0">Season</th><th scope="col" class="border-top-0">Location</th><th scope="col" class="border-top-0">Status</th><th scope="col" class="border-top-0">Due Date</th><th scope="col" class="border-top-0"></th></tr></thead><tbody><tr ng-repeat="arf in student.additionalForms track by arf.formInfo.userFormDetailID" ng-init="arfSections = arf.sections"><td>{{arf.formInfo.formName}}</td><td>{{arf.formInfo.termGroupName}}</td><td>{{arf.formInfo.locationName}}</td><td><span ng-show="arf.isStatusReadOnly">{{vm.formStatusDict.getValue(arf.formInfo.statusTypeID).typeString}}</span> <select ng-show="!arf.isStatusReadOnly" ng-options="item.typeID as item.typeString for item in vm.formStatusTypes" ng-model="arf.formInfo.statusTypeID" ng-change="vm.ufdStatusChanged(arf)"></select><idp-my-student-form-sections show="vm.pulseContext.isImpersonating" master-form="arf.formInfo" form-sections="arfSections" form-status-types="vm.formStatusTypes"></idp-my-student-form-sections></td><td><div ng-show="vm.showDueDate(arf)">{{arf.formInfo.dueDate | date:\'MM/dd/yyyy\' }}</div></td><td class="text-center"><button type="button" class="btn btn-primary btn-sm btn-block" ng-show="arf.isFormButtonVisible" ng-disabled="arf.isFormButtonDisabled" ng-click="vm.onViewFormClick(arf, student.userID);" formnovalidate>{{arf.formButtonText}}</button> <span ng-show="!arf.isFormButtonVisible">{{arf.noFormButtonText}}</span></td></tr></tbody></table><div class="border border-light bg-light mb-3 p-3 d-md-none" ng-repeat="arf in student.additionalForms track by arf.formInfo.userFormDetailID" ng-init="arfSections = arf.sections"><dl><dt>Additional Required Form</dt><dd>{{arf.formInfo.formName}}</dd><dt>Season</dt><dd>{{arf.formInfo.termGroupName}}</dd><dt>Location</dt><dd>{{arf.formInfo.locationName}}</dd><dt>Status</dt><dd><span ng-show="arf.isStatusReadOnly">{{vm.formStatusDict.getValue(arf.formInfo.statusTypeID).typeString}}</span> <select ng-show="!arf.isStatusReadOnly" ng-options="item.typeID as item.typeString for item in vm.formStatusTypes" ng-model="arf.formInfo.statusTypeID" ng-change="vm.ufdStatusChanged(arf)"></select><idp-my-student-form-sections show="vm.pulseContext.isImpersonating" master-form="arf.formInfo" form-sections="arfSections" form-status-types="vm.formStatusTypes"></idp-my-student-form-sections></dd><dt>Due Date</dt><dd><div ng-show="vm.showDueDate(arf)">{{arf.formInfo.dueDate | date:\'MM/dd/yyyy\' }}</div></dd></dl><button type="button" class="btn btn-primary btn-sm btn-block" ng-show="arf.isFormButtonVisible" ng-disabled="arf.isFormButtonDisabled" ng-click="vm.onViewFormClick(arf, student.userID);" formnovalidate>{{arf.formButtonText}}</button> <span ng-show="!arf.isFormButtonVisible">{{arf.noFormButtonText}}</span></div></div></div></div></div><div class="row my-3" ng-show="vm.anythingChanged"><div class="col-sm-4 offset-8"><button type="button" class="button" ng-disabled="!vm.canUpdate" ng-click="vm.onSaveStatusUpdatesClick()">Save</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/idp-my-students-with-forms.html','<div ng-form="{{::vm.formName}}" id="idp-my-students-with-forms"><div class="id-panel-group" id="studentsAccordion"><div class="card id-collapsible-card mt-3" ng-repeat="student in vm.studentList track by student.userID"><div class="card-heading" id="heading{{::student.userID}}" ng-click="vm.onExpandToggle(student)" ng-class="{\'collapsed\': !student.isExpanded}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{\'d-none\': student.isExpanded}"></span> <span class="icon icon-minus-1" ng-class="{\'d-none\': !student.isExpanded}"></span></div><div class="content"><h4 class="text-nowrap mb-0">{{student.firstName}} {{student.lastName}}</h4><small ng-show="!vm.pulseContext.isImpersonating && false"><span class="text-success" ng-show="!student.anyIncompleteFormsBeforeCamp && !student.anyFormsToBringToCamp">All Forms Complete </span><span class="text-warning" ng-show="student.anyIncompleteFormsBeforeCamp">Forms Incomplete </span><span class="text-warning" ng-show="student.anyFormsToBringToCamp">Don\'t forget to bring your forms to camp! </span></small><small ng-show="vm.pulseContext.isImpersonating"><span ng-show="student.areRequiredFormsComplete"><span class="icon icon-checkmark text-success"></span> Required Forms Complete</span> <span ng-hide="student.areRequiredFormsComplete"><span class="icon icon-warning text-warning"></span> Required Forms Incomplete</span><span ng-show="student.areAdditionalRequiredFormsNotBringComplete != null"><span ng-show="student.areAdditionalRequiredFormsNotBringComplete"><span class="icon icon-checkmark text-success"></span> Additional Forms Complete</span> <span ng-hide="student.areAdditionalRequiredFormsNotBringComplete"><span class="icon icon-warning text-warning"></span> Additional Forms Incomplete</span> </span><span ng-show="student.anyFormsToBringToCamp != null"><span ng-show="student.anyFormsToBringToCamp"><span class="icon icon-warning text-warning"></span> Has Forms to Bring to Camp</span></span></small></div></div></div><div id="collapse{{::student.userID}}" class="panel-collapse padded-content" uib-collapse="!student.isExpanded"><div class="card-body" ng-show="student.completeOverdueRequiredFormAtCamp"><strong class="text-danger">The Health & Safety Form is now closed. Please arrive early to camp to complete it at check-in.</strong></div><div class="card-body"><table class="table table-striped d-none d-md-table"><thead><tr><th scope="col" class="border-top-0">Required Form</th><th scope="col" class="border-top-0">Location</th><th scope="col" class="border-top-0">Status</th><th scope="col" class="border-top-0">Due Date</th><th scope="col" class="border-top-0"></th></tr></thead><tbody><tr ng-repeat="req in student.requiredForms track by req.formInfo.userFormDetailID" ng-init="reqSections = req.sections; vm.studentIsTeen(student, req); vm.studentIsUSLocationOnly(req.formInfo.userFormDetailID,student)"><td>{{req.formInfo.formName}}<idp-my-student-hsf-section-links user-form-detail-id="req.formInfo.userFormDetailID" term-group-id="req.formInfo.termGroupID" status-type-id="req.formInfo.statusTypeID" form-category-type-id="req.formInfo.categoryTypeID" is-teen="student.isTeen" is-us-only="student.isUsLocationOnly" ng-show="vm.canUpdate"></td><td>{{req.formInfo.locationName}}</td><td><span ng-show="req.isStatusReadOnly">{{vm.formStatusDict.getValue(req.formInfo.statusTypeID).typeString}}</span> <select ng-show="!req.isStatusReadOnly" ng-options="item.typeID as item.typeString for item in vm.formStatusTypes" ng-model="req.formInfo.statusTypeID" ng-change="vm.ufdStatusChanged(req)"></select><idp-my-student-form-sections show="vm.pulseContext.isImpersonating" master-form="req.formInfo" form-sections="reqSections" form-status-types="vm.formStatusTypes"></idp-my-student-form-sections></td><td><div ng-show="vm.showDueDate(req)">{{req.formInfo.dueDate | date:\'MM/dd/yyyy\' }}</div></td><td class="text-center"><button type="button" class="btn btn-primary btn-sm btn-block" ng-show="req.isFormButtonVisible" ng-disabled="req.isFormButtonDisabled || !vm.canUpdate" ng-click="vm.onViewFormClick(req);" formnovalidate>{{req.formButtonText}}</button> <span ng-show="!req.isFormButtonVisible">{{req.noFormButtonText}}</span></td></tr></tbody></table><div class="d-md-none pt-3 pt-md-0" ng-repeat="req in student.requiredForms track by req.formInfo.userFormDetailID" ng-init="reqSections = req.sections; vm.studentIsUSLocationOnly(req.formInfo.userFormDetailID,student)"><dl><dt>Required Form</dt><dd>{{req.formInfo.formName}}</dd><dt>Location</dt><dd>{{req.formInfo.locationName}}</dd><dt>Status</dt><dd><span ng-show="req.isStatusReadOnly">{{vm.formStatusDict.getValue(req.formInfo.statusTypeID).typeString}}</span> <select ng-show="!req.isStatusReadOnly" ng-options="item.typeID as item.typeString for item in vm.formStatusTypes" ng-model="req.formInfo.statusTypeID" ng-change="vm.ufdStatusChanged(req)"></select><idp-my-student-form-sections show="vm.pulseContext.isImpersonating" master-form="req.formInfo" form-sections="reqSections" form-status-types="vm.formStatusTypes"></idp-my-student-form-sections></dd><dt>Due Date</dt><dd><div ng-show="vm.showDueDate(req)">{{req.formInfo.dueDate | date:\'MM/dd/yyyy\' }}</div></dd></dl><button type="button" class="btn btn-primary btn-sm btn-block" ng-show="req.isFormButtonVisible" ng-disabled="req.isFormButtonDisabled" ng-click="vm.onViewFormClick(req);" formnovalidate>{{req.formButtonText}}</button> <span ng-show="!req.isFormButtonVisible">{{req.noFormButtonText}}</span><idp-my-student-hsf-section-links user-form-detail-id="req.formInfo.userFormDetailID" term-group-id="req.formInfo.termGroupID" status-type-id="req.formInfo.statusTypeID" form-category-type-id="req.formInfo.categoryTypeID" is-teen="student.isTeen" is-us-only="student.isUsLocationOnly"></div></div><div class="card-body"><p ng-show="(student.additionalForms.length == 0)">No additional forms are required</p><table class="table table-striped d-none d-md-table" ng-show="(student.additionalForms.length > 0)"><thead><tr><th scope="col" class="border-top-0">Additional Required Form</th><th scope="col" class="border-top-0">Location</th><th scope="col" class="border-top-0">Status</th><th scope="col" class="border-top-0">Due Date</th><th scope="col" class="border-top-0"></th></tr></thead><tbody><tr ng-repeat="arf in student.additionalForms track by arf.formInfo.userFormDetailID"><td>{{arf.formInfo.formName}}</td><td>{{arf.formInfo.locationName}}</td><td><span ng-show="arf.isStatusReadOnly">{{vm.formStatusDict.getValue(arf.formInfo.statusTypeID).typeString}}</span> <select ng-show="!arf.isStatusReadOnly" ng-options="item.typeID as item.typeString for item in vm.formStatusTypes" ng-model="arf.formInfo.statusTypeID" ng-change="vm.ufdStatusChanged(arf)"></select><idp-my-student-form-sections show="vm.pulseContext.isImpersonating" master-form="arf.formInfo" form-sections="arf.sections" form-status-types="vm.formStatusTypes"></idp-my-student-form-sections></td><td><div ng-show="vm.showDueDate(arf)">{{arf.formInfo.dueDate | date:\'MM/dd/yyyy\' }}</div></td><td class="text-center"><button type="button" class="btn btn-primary btn-sm btn-block" ng-show="arf.isFormButtonVisible" ng-disabled="arf.isFormButtonDisabled" ng-click="vm.onViewFormClick(arf);" formnovalidate>{{arf.formButtonText}}</button> <span ng-show="!arf.isFormButtonVisible">{{arf.noFormButtonText}}</span></td></tr></tbody></table><div class="d-md-none pt-3 pt-md-0" ng-repeat="arf in student.additionalForms track by arf.formInfo.userFormDetailID" ng-init="arfSections = arf.sections"><dl><dt>Additional Required Form</dt><dd>{{arf.formInfo.formName}}</dd><dt>Location</dt><dd>{{arf.formInfo.locationName}}</dd><dt>Status</dt><dd><span ng-show="arf.isStatusReadOnly">{{vm.formStatusDict.getValue(arf.formInfo.statusTypeID).typeString}}</span> <select ng-show="!arf.isStatusReadOnly" ng-options="item.typeID as item.typeString for item in vm.formStatusTypes" ng-model="arf.formInfo.statusTypeID" ng-change="vm.ufdStatusChanged(arf)"></select><idp-my-student-form-sections show="vm.pulseContext.isImpersonating" master-form="arf.formInfo" form-sections="arfSections" form-status-types="vm.formStatusTypes"></idp-my-student-form-sections></dd><dt>Due Date</dt><dd><div ng-show="vm.showDueDate(arf)">{{arf.formInfo.dueDate | date:\'MM/dd/yyyy\' }}</div></dd></dl><button type="button" class="btn btn-primary btn-sm btn-block" ng-show="arf.isFormButtonVisible" ng-disabled="arf.isFormButtonDisabled" ng-click="vm.onViewFormClick(arf);" formnovalidate>{{arf.formButtonText}}</button> <span ng-show="!arf.isFormButtonVisible">{{arf.noFormButtonText}}</span></div></div></div></div></div><div class="row my-3" ng-show="vm.anythingChanged"><div class="col-sm-4 offset-8"><button type="button" class="btn btn-primary btn-block" ng-show="vm.pulseContext.isImpersonating" ng-disabled="!vm.canAdministerForms" ng-click="vm.onSaveStatusUpdatesClick()">Save</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/footer/idp-footer.html','<div id="upsells" class="mb-3"><fieldset ng-disabled="!vm.canUpdate"><div class="row mt-3" ng-if="!vm.showSimple && vm.canSeeReferAFriend"><div class="col-12"><div class="d-flex flex-wrap-reverse justify-content-between"><div class="flex-grow-1 align-self-start mr-auto mr-auto"><h3 class="raf-heading mt-lg-6">Refer-a-Friend</h3><p><strong>Share the love and save $25 when you refer a friend to {{::vm.companyName}}.</strong></p><p>Your friend will save, too!</p><a class="btn btn-primary btn-md" ng-class="{disabled: !vm.canUpdate}" ng-href="{{vm.rafUrl}}">Go now</a></div><div class="mx-auto pr-6"><img class="raf-img" ng-src="{{::vm.imgSrcRefer}}"></div></div></div></div><div class="row mt-7" ng-if="!vm.showSimple"><div class="col-12"><h3>Add a Course. Or two!</h3><p><strong>Register for camp or add another small-group course.</strong></p><p>Enroll for our current season, or add an additional session to dive deeper into new concepts and projects. You&apos;ll automatically save $50 for each additional course. (Amount varies based on the currency of your purchase.)</p><button class="btn btn-primary btn-md" ng-click="vm.onRegisterClick();">Go now</button></div></div></fieldset><div class="row mt-7" ng-if="!vm.showSimple && vm.canSeeOPLSessions"><div class="col-12"><h3>Online Private Lessons</h3><p><strong>Buy or schedule lessons.</strong></p><p>Learn year-round on your own schedule with a certified iD Tech instructor. Dive into a new subject, or continue working on the project you started at camp! For ages 7-19.</p><button class="btn btn-primary btn-md" ng-click="vm.onOnlineLessonsRedirectClick();">Go now</button> <button ng-if="vm.pulseContext.isImpersonating" class="btn btn-link" ng-click="vm.onOnlineLessonsAdminRedirectClick();">Admin view</button> <button ng-if="vm.pulseContext.isImpersonating" class="btn btn-link" ng-click="vm.onOplAdminPurchaseClick();">Admin - Purchase OPL</button></div></div><div class="row mt-7" ng-if="!vm.showSimple && vm.hasRelatedUsers"><div class="col-12"><h3>Camp Course History</h3><p><strong>View camp courses from a previous season.</strong></p><a class="btn btn-primary btn-md" ng-href="#{{::$root.Routes.MyAccount_HistoryInfo}}">Go now</a></div></div><div class="row mt-7"><div class="col-12"><h3>Our Tax ID:</h3><p><strong style="white-space:nowrap">{{::vm.companyTaxId}}</strong></p></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-auth-account-not-found.html','<div><div class="alert alert-danger" ng-show="vm.signIn3rdPartyErr">{{vm.signIn3rdPartyErr}}</div><h4>Have you been to iD Tech before?</h4><div>Click the button below to log in with the email and password associated with your iD Tech account. We will connect your existing account details to your Google email so you can log in using Google next time.</div><button class="btn btn-block btn-primary my-4" type="submit" ng-dblclick="false" ng-click="vm.onGoToLoginClick()">Log in with your iD Tech account</button><h4 class="mt-4">Or, create a new iD Tech account with your Google information:</h4><div><div>Name: {{vm.fullName}}</div><div>Email: {{vm.email}}</div></div><button class="btn btn-block btn-primary my-4" type="submit" ng-dblclick="false" ng-click="vm.onCreateAccountClick()">Create new account using Google</button></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-auth-with-third-party.html','<div id="login3rdParty" ng-show="vm.show3rdPartySignin"><div id="google-signin-button" class="btn btn-outline-secondary btn-block"><span style="width:18px;height:18px;" class="abcRioButtonSvgImageWithFallback abcRioButtonIconImage abcRioButtonIconImage18"><img class="pr-2 pb-1" ng-src="{{::vm.googleLogoUrl}}"> </span>{{::vm.googleButtonText}}</div><div class="row my-1 text-center text-muted"><div class="col-5 pr-0"><hr></div><div class="col align-self-center">or</div><div class="col-5 pl-0"><hr></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-create-account.html','<div><idp-auth-with-third-party show-3rd-party-signin="vm.show3rdPartySignin" google-button-text="Sign up with Google" google-signin-success-fn="vm.googleSigninSuccess" google-signin-fail-fn="vm.googleSigninFail"></idp-auth-with-third-party><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="form-group"><input name="firstName" type="text" class="form-control" placeholder="First Name*" ng-model="vm.firstName" ng-required="true" ng-maxlength="100" autocomplete="off" uib-tooltip="First Name" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.firstName.$error" class="text-danger"><div ng-message="required">Your first name is required</div><div ng-message="maxlength">First name cannot be more than 100 characters</div></div></div><div class="form-group"><input name="lastName" placeholder="Last Name*" type="text" class="form-control" ng-model="vm.lastName" ng-maxlength="100" ng-required="true" uib-tooltip="Last Name" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.lastName.$error" class="text-danger"><div ng-message="required">Your last name is required</div><div ng-message="maxlength">Last name cannot be more than 100 characters</div></div></div><div class="form-group"><input type="email" name="emailAddress" class="form-control emailAddress" placeholder="Email*" autocomplete="off" ng-model="vm.emailAddress" ng-model-options="{ updateOn : \'blur\', debounce: 300 }" ng-required="true" ng-maxlength="200" uib-tooltip="Email" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.emailAddress.$error" class="text-danger"><div ng-message="required">Your email address is required</div><div ng-message="email">{{vm.emailRegExpErrorMsg}}</div><div ng-message="maxlength">Your email address cannot be more than 200 characters</div></div></div><div class="form-group has-feedback"><input class="form-control" name="password" type="password" placeholder="Password (Case Sensitive)*" ng-model="vm.password" ng-required="true" ng-maxlength="25" ng-minlength="6" autocomplete="off" ng-model-options="{ updateOn : \'blur\', debounce: 300 }" uib-tooltip="Password" tooltip-trigger="\'focus\'" aria-describedby="passwordHelpBlock" ng-pattern="vm.passwordRegExp"> <i class="icon icon-info feedback-icon" ng-click="vm.showCreatePasswordHelp()"></i><div ng-messages="vm.myForm.password.$error" class="text-danger"><div ng-message="required">Password is required</div><div ng-message="pattern">{{vm.passwordRegExpErrorMsg}}</div><div ng-message="maxlength">Your password cannot be more than 25 characters</div><div ng-message="minlength">Your password cannot be less than 6 characters</div></div></div><idp-intl-tel-input country-code="vm.countryCode" phone-number="vm.phoneNumber" phone-number-place-holder="Cell Phone Number" is-required="true" is-edit-mode="true"></idp-intl-tel-input><div ng-repeat="channel in vm.checkBoxStates track by $index"><div class="align-top form-check mt-3"><input class="form-check-input form-control" name="optIn_{{channel.contactChannelType.typeID}}" id="optIn_{{channel.contactChannelType.typeID}}" type="checkbox" tabindex="{{::vm.firstTabIndex+10 + $index}}" ng-true-value="false" ng-false-value="true" ng-model="channel.newOptOut"> <label class="form-check-label" for="optIn_{{channel.contactChannelType.typeID}}">I agree to receive automated {{::channel.contactChannelType.typeDescription}} text messages.</label></div></div><button class="btn btn-block btn-primary" type="submit" ng-dblclick="false" idp-click-tracking>Create Account</button><p class="mt-3 mb-0 text-center"><a href="" ng-click="vm.showPrivacyPolicy()">Privacy Policy</a></p></form></div><idp-privacy-policy-popup popup-id="idpPrivacyPolicyPopup"></idp-privacy-policy-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-forgot-password-popup.html','<div id="{{::vm.popupId}}"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err><div class="modal-header"><h3 class="modal-title">Forgot Password?</h3><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.close()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div class="form-group" data-ng-class="{\'has-error\': (vm.submitted || vm.myForm.emailAddress.$dirty) && vm.myForm.emailAddress.$invalid}"><label for="emailAddress">Please enter your email address</label> <input type="email" class="form-control" name="emailAddress" placeholder="Email" ng-model="vm.emailOrUserName" ng-model-options="{ \'updateOn\' : \'blur\' }" maxlength="200" autofocus="" required uib-tooltip="Login email address" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.emailAddress.$error" class="text-danger"><div ng-message="required">Email is required</div><div ng-message="email">{{vm.emailRegExpErrorMsg}}</div></div></div><div class="d-flex justify-content-center py-3"><div class="d-inline-block" vc-recaptcha key="\'6LdteDEUAAAAAEvwhARiWG7POjZJlXJx9xyVrhYw\'" on-success="vm.getCaptChaResponse(response)"></div></div></div><div class="modal-footer justify-content-center"><button type="submit" class="btn btn-primary btn-block" data-ng-class="{disabled: vm.saveDisabled}" data-ng-disabled="vm.saveDisabled" data-ng-dblclick="false" ng-click="vm.submit()">Submit</button></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-login-panel.html','<div class="card border-0 rounded-0 mt-4 mb-4" ng-if="!vm.pulseContext.isLoggedIn"><div class="card-body bg-light"><div class="row justify-content-center align-items-center"><div class="col-xs-12 col-md-5 col-lg-6 col-sm-offset-1 text-center text-md-left">Already have an account?<br class="d-xl-none"><span class="ml-xl-1">Log in for the best experience.</span></div><div class="col-xs-12 col-md-3 col-lg-2 mt-md-0 mt-2"><button class="btn btn-block btn-outline-secondary" type="button" ng-click="vm.openLoginModal()">Login</button></div><div ng-if="vm.isCreateAccountVisible !== false" class="col-xs-12 col-sm-4 col-md-3 text-center text-md-left"><a class="btn text-secondary pl-0" ng-click="vm.openCreateAccountModal()">Create account</a></div></div></div></div><idp-login-popup popup-id="authenticationModal" close-on-outside-click="false"></idp-login-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-login-popup.html','<div id="{{::vm.popupId}}"><div class="modal-header border-bottom-0"><h3 class="modal-title"><span>{{vm.title}}</span></h3><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.close()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" ng-hide="vm.is3rdPartyAccountNotFoundView"><div ng-if="vm.isLoginMode && !vm.isNewPasswordMode"><p ng-if="vm.initDataObj.subTitle">{{::vm.initDataObj.subTitle}}</p><div class="alert alert-danger" ng-show="vm.signIn3rdPartyAccountNotFoundErr">{{vm.signIn3rdPartyAccountNotFoundErr}}</div><div class="my-3" ng-show="vm.signIn3rdPartyAccountNotFoundErr">{{::$root.StringConst.Info_3rPartyAuth_GoogleAccountLinkAccount_Msg}}</div><idp-login email-or-user-name="vm.initDataObj.emailAddress" lock-email-address="vm.initDataObj.lockEmailAddress" show-labels="vm.initDataObj.showLabels" hide-required-asterix="vm.initDataObj.hideRequiredAsterix" first-tab-index="vm.initDataObj.firstTabIndex"></idp-login></div><div ng-if="vm.isCreateAccountMode"><idp-create-account email-address="vm.initDataObj.emailAddress" show-3rd-party-signin="true"></idp-create-account></div><div ng-show="vm.isNewPasswordMode"><idp-new-password is-active="vm.isNewPasswordMode" user="vm.userForPasswordChange" old-password="vm.oldPassword"></div></div><div class="modal-body" ng-show="vm.is3rdPartyAccountNotFoundView"><div class="alert alert-danger" ng-show="vm.signIn3rdPartyAccountNotFoundErr">{{vm.signIn3rdPartyAccountNotFoundErr}}</div><idp-auth-account-not-found show-login-view="vm.showLoginView()" is-visible="vm.is3rdPartyAccountNotFoundView"></idp-auth-account-not-found></div><div class="modal-footer justify-content-center" ng-hide="vm.is3rdPartyAccountNotFoundView"><div ng-hide="vm.hasCreateAccountDisabled"><div class="d-flex flex-column justify-content-center align-items-center pt-6 pb-6" ng-show="vm.isLoginMode && !vm.isNewPasswordMode"><h4 class="text-center"><strong>Don\u2019t have an Account?</strong></h4><div><button type="button" class="btn btn-block btn-outline-secondary" ng-click="vm.toggleCreateAccount()">Create Account</button></div></div></div><div ng-show="vm.isCreateAccountMode" class="text-center"><span class="text-neutral">Already have an account?</span><button type="button" class="btn btn-link pl-1 pr-1" ng-click="vm.toggleCreateAccount()">Log in</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-login.html','<div><idp-auth-with-third-party show-3rd-party-signin="vm.show3rdPartySignin" google-signin-success-fn="vm.googleSigninSuccess" google-signin-fail-fn="vm.googleSigninFail"></idp-auth-with-third-party><form name="{{::vm.formName}}" role="form" class="needs-validation" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="form-group"><input type="text" class="form-control" name="emailAddress" placeholder="Email" ng-disabled="vm.lockEmailAddress" ng-model="vm.emailOrUserName" ng-required="true" ng-maxlength="200" autocomplete="off" tabindex="{{::vm.firstTabIndex + 1}}" uib-tooltip="Login email address" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.emailAddress.$error" class="text-danger"><div ng-message="required">Your email address is required</div><div ng-message="maxlength">Your email address must be less than 200 characters</div></div></div><div class="form-group has-feedback"><input class="form-control" type="password" name="password" placeholder="Password (Case Sensitive)" ng-model="vm.password" ng-required="true" ng-maxlength="25" autocomplete="off" tabindex="{{::vm.firstTabIndex + 2}}" uib-tooltip="Password" tooltip-trigger="\'focus\'" aria-describedby="forgotPasswordLink"> <span id="passwordHelp" tabindex="-1" class="icon icon-info feedback-icon" ng-click="vm.showPasswordHelp()"></span><div ng-messages="vm.myForm.password.$error" class="text-danger"><div ng-message="required">Your password is required</div><div ng-message="maxlength">Your password must be less than 25 characters</div></div></div><div class="form-group" ng-show="vm.showReplaceEmailWith3rdPartyAuthEmail"><div class="form-check"><input class="form-check-input" type="checkbox" name="replaceEmail" id="replaceEmail" ng-model="vm.isReplaceWith3rdPartyAuthEmail"> <label class="form-check-label mb-0" for="replaceEmail">Receive iD Tech emails at {{vm.thirdPartyAuthEmail}} going forward.</label></div></div><button class="btn btn-primary btn-block my-4" id="btnlogin" type="submit" tabindex="{{::vm.firstTabIndex + 4}}" ng-dblclick="false" ng-disabled="vm.btnLoginDisabled" idp-click-tracking>Log in</button><div class="mt-3 text-center"><a href="" ng-click="vm.showForgotPassword()" tabindex="{{::vm.firstTabIndex + 5}}">Forgot Password?</a></div></form></div><idp-forgot-password-popup popup-id="forgotPWPopup" title="Forgot Password" api="forgotPWPopup"></idp-forgot-password-popup><idp-reset-password-popup popup-id="resetPWPopup" title="Reset Password" api="resetPWPopup"></idp-reset-password-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-missing-info-popup.html','<form id="{{::vm.formName}}" name="{{::vm.formName}}" ng-cloak role="form" novalidate idp-form-focus-on-err><div class="modal-header"><h3 class="modal-title">{{::vm.title}}</h3><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.close()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body" ng-if="vm.myForm"><div class="row form-group"><div class="col-12"><input id="firstName" name="firstName" type="text" class="form-control" placeholder="First Name" data-ng-model="vm.firstName" data-ng-required="true" maxlength="100" autocomplete="off" tabindex="{{::vm.firstTabIndex}}" uib-tooltip-html="vm.myForm.firstName.$valid ? \'First Name\' : vm.myForm.firstName.$error.required ? \'First Name is required\' : \'First Name is not valid\'" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.firstName.$error" class="text-danger"><div ng-message="required">Student first name is required</div></div></div></div><div class="row form-group"><div class="col-12"><input id="lastName" name="lastName" placeholder="Last Name" uib-tooltip-html="vm.myForm.lastName.$valid ? \'Last Name\' : vm.myForm.lastName.$error.required ? \'Last Name is required\' : \'Last Name is not valid\'" tooltip-trigger="\'focus\'" type="text" class="form-control" data-ng-model="vm.lastName" maxlength="100" data-ng-required="true" tabindex="{{::vm.firstTabIndex+1}}"><div ng-messages="vm.myForm.lastName.$error" class="text-danger"><div ng-message="required">Your last name is required</div></div></div></div><div ng-if="!vm.isEmailReadOnly" class="row form-group"><div class="col-12"><input name="email" type="email" class="form-control" placeholder="Email" autocomplete="off" data-ng-model="vm.emailAddress" data-ng-model-options="{ updateOn : \'blur\', debounce: 300 }" data-ng-required="true" data-ng-maxlength="200" uib-tooltip-html="vm.myForm.email.$valid ? \'Email\' : vm.myForm.email.$error.required ? \'Email is required\' : \'Email is not valid\'" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+2}}"><div ng-messages="vm.myForm.email.$error" class="text-danger"><div ng-message="required">Your email address is required</div><div ng-message="email">{{vm.emailRegExpErrorMsg}}</div><div ng-message="maxlength">Your email address must be less than 200 characters</div></div></div></div><p ng-show="vm.isEmailReadOnly">Email: {{::vm.emailAddress}}</p><idp-intl-tel-input country-code="vm.countryCode" phone-number="vm.phoneNumber" first-tab-index="vm.firstTabIndex+3" is-required="true" is-edit-mode="true" phone-number-place-holder="Cell Phone Number"></idp-intl-tel-input><div ng-repeat="channel in vm.checkBoxStates track by $index"><div class="align-top form-check mt-3"><input class="form-check-input form-control" name="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}" id="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}" type="checkbox" tabindex="{{::vm.firstTabIndex+10 + $index}}" ng-true-value="false" ng-false-value="true" ng-model="channel.newOptOut"> <label class="form-check-label" for="optIn_{{cm.contactMethod}}_{{channel.contactChannelTypeID}}">I agree to receive automated {{::channel.contactChannelType.typeDescription}} text messages.</label></div></div></div><div class="modal-footer"><div class="col-12" style="text-align:center;"><button class="btn btn-primary done-button" type="submit" style="margin:auto;" tabindex="{{::vm.firstTabIndex+4}}" ng-click="vm.saveAndContinue()">Done</button></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-new-password.html','<form id="frmNewPassword" name="{{::vm.formName}}" class="reg-flow" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="form-group has-feedback"><div>Please enter a new password:</div><input id="newPassword" type="password" name="newPassword" class="form-control" placeholder="New Password* (case sensitive)" autocomplete="off" ng-model="vm.newPassword" ng-model-options="{ updateOn : \'blur\' }" ng-required="true" ng-maxlength="25" ng-minlength="6" ng-pattern="vm.passwordRegExp"> <span id="createPasswordHelp" tabindex="-1" class="spa-help-icon-right-inside-control form-control-feedback" ng-click="vm.showCreatePasswordHelp();" style="top:15px;"></span><div ng-messages="vm.myForm.newPassword.$error" class="text-danger"><div ng-message="required">Password is required</div><div ng-message="pattern">{{vm.passwordRegExpErrorMsg}}</div><div ng-message="maxlength">Your password cannot be more than 25 characters</div><div ng-message="minlength">Your password cannot be less than 6 characters</div></div></div><div class="row"><div class="col-xs-12"><button class="btn btn-primary btn-block" id="btnSubmit" type="submit" tabindex="" ng-dblclick="false" ng-disabled="vm.isSubmitButtonDisabled">Submit</button></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/login/idp-reset-password-popup.html','<div id="{{::vm.popupId}}"><div class="modal-header"><h3 class="modal-title">Forgot Password</h3><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.close()"><span aria-hidden="true">&times;</span></button></div><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="modal-body" ng-show="(vm.stepNumber === 1)"><p>A reset code has been emailed to {{::vm.primaryEmail}}</p><div class="form-group" ng-class="{\'has-error\': (vm.submitted || vm.myForm.resetCode.$dirty) && vm.myForm.resetCode.$invalid}"><label for="resetCode">Please check your email, and enter the reset code below:</label> <input type="text" class="form-control" name="resetCode" placeholder="Reset Code" ng-model="vm.resetCode" ng-model-options="{ \'updateOn\' : \'blur\' }" maxlength="6" ng-minlength="6" autofocus="" required uib-tooltip="Reset Code" tooltip-trigger="\'focus\'"></div></div><div class="modal-body" ng-show="(vm.stepNumber === 2)"><div class="form-group" ng-class="{\'has-error\': (vm.submitted || vm.myForm.newPassword.$dirty) && vm.myForm.newPassword.$invalid}"><input id="dpac_1" type="password" class="d-none"> <label for="newPassword">Please enter your new password</label> <input type="password" class="form-control" name="newPassword" placeholder="New Password" ng-model="vm.newPassword" ng-model-options="{ \'updateOn\' : \'blur\' }" ng-pattern="vm.passwordRegExp" maxlength="25" uib-tooltip="New Password" tooltip-trigger="\'focus\'" required></div><div class="form-group" ng-class="{\'has-error\': (vm.submitted || vm.myForm.newPasswordConfirm.$dirty) && vm.myForm.newPasswordConfirm.$invalid}"><input type="password" class="form-control" name="newPasswordConfirm" placeholder="Confirm New Password" ng-model="vm.newPasswordConfirm" ng-model-options="{ \'updateOn\' : \'blur\' }" data-idp-match="vm.newPassword" maxlength="25" uib-tooltip="Confirm New Password" tooltip-trigger="\'focus\'" required></div><div class="alert alert-info" role="alert">Passwords are CASE sensitive, must be 6 to 25 characters, and must contain at least 1 number. The following special characters are also accepted: ! @ # $ % & ; : , . ?</div></div></form><div class="modal-footer justify-content-center"><button class="btn btn-primary btn-block" type="submit" ng-class="{disabled: vm.saveDisabled}" ng-disabled="vm.saveDisabled" ng-dblclick="false" ng-click="vm.submit()">Submit</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/idp-online-lesson-email-preview-popup.html','<div id="{{::vm.idp-online-lesson-email-preview-popup}}" class="pulseapp"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.sendEmail()"><div class="modal-header"><h4>Email Preview</h4><button type="button" class="close" dismiss="modal" aria-hidden="true" ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div id="content" class="container-fluid"><div class="row"><div class="col"><div ng-if="!vm.emailPreview" class="py-5">Loading preview...</div><div ng-if="vm.emailPreview"><div>From:&nbsp;{{vm.emailPreview.fromEmail}}</div><div>To:&nbsp;{{vm.emailPreview.toEmail}}</div><div><label for="ccEmail">Cc:&nbsp;</label> <input name="ccEmail" class="form-control d-inline-block w-25" type="email" placeholder="Cc Email Address" uib-tooltip="Cc Email Address" tooltip-trigger="\'focus\'" ng-maxlength="200" ng-model="vm.sessionSummary.ccEmailAddress"><div ng-messages="vm.myForm.ccEmail.$error" class="text-danger"><div ng-message="maxlength">Your email address cannot be more than 200 characters</div><div ng-message="email">{{vm.emailRegExpErrorMsg}}</div></div></div><div>Subject: {{vm.emailPreview.subject}}</div><div ng-bind-html="vm.emailPreview.body | unsafe"></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-if="vm.canUpdate" class="btn btn-primary px-5" ng-class="{disabled: vm.submitted}" ng-disabled="vm.submitted" ng-dblclick="false">Publish and Send</button> <button class="btn btn-outline-secondary px-5 ml-3" type="button" ng-click="vm.close()">Close</button></div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/idp-online-lesson-note-edit-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.saveNote()"><div class="modal-header"><h3>{{vm.isNew ? "New":"Edit"}} note</h3><button type="button" class="close" dismiss="modal" aria-hidden="true" ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div id="content" class="container-fluid"><div class="row form-group required"><div class="col"><textarea id="note" name="note" class="form-control h-100" ng-model="vm.note.noteText" rows="3" maxlength="200" required></textarea><div ng-messages="vm.myForm.note.$error" class="text-danger"><div ng-message="required">note is required</div></div></div></div></div></div><div class="modal-footer"><div class="d-inline-block text-right pr-5"><span ng-if="vm.successMessage" class="text-success text-em-1-2 font-weight-bold" ng-bind-html="vm.successMessage"></span> <span ng-if="vm.errorMessage" class="text-danger font-weight-bold" ng-bind-html="vm.errorMessage"></span></div><button type="submit" ng-if="vm.canUpdate" class="btn btn-primary px-5" ng-class="{disabled: vm.submitted}" ng-disabled="vm.submitted" ng-dblclick="false">Save</button> <button class="btn btn-outline-secondary px-5 ml-3" type="button" ng-click="vm.close()">Cancel</button></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/idp-online-lesson-products.html','<div ng-repeat="session in vm.sessions"><div class="card id-collapsible-card mt-3"><div class="card-heading" id="heading{{::session.userID}}" ng-click="vm.loadSessionSummary($index)" ng-class="{\'collapsed\': !session.isActive}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{ \'d-none\': session.isActive}"></span> <span class="icon icon-minus-1" ng-class="{ \'d-none\': !session.isActive }"></span></div><div class="content container-fluid"><div class="d-flex flex-column flex-md-row"><div class="flex-grow-1 flex-shrink-1"><h4 class="mb-0 d-inline-block">{{session.purchaseDate | date:\'yyyy-MM-dd\'}} <span class="ml-4">{{session.courseName}}</span> <span class="ml-3" ng-show="session.productSubCatTypeID==$root.Enums.ProductSubCategoryType.CoursePreparation">(Camp date : {{session.campStartDate | date:\'yyyy-MM-dd\'}})</span></h4><span class="ml-md-4 text-danger" ng-if="vm.showExpiredLabel(session)">Expired on {{session.expiryDate | DTZeroHourPreviousDayAdjustForDisplay | date:\'yyyy-MM-dd\'}} </span><span class="ml-md-4 text-primary" ng-if="vm.isSessionAvailable(session)">1 available</span> <span class="ml-md-4 text-primary" ng-if="!vm.showExpiredLabel(session)\n                && session.productSubCatTypeID == $root.Enums.ProductSubCategoryType.OneOnOneTutor\n                && session.availableSessionsCount > 0">{{session.availableSessionsCount}} available</span><div class="mt-1" ng-if="!vm.showExpiredLabel(session)"><span>{{vm.getSessionStatusStr(session)}}</span> <span class="ml-4 mb-0 d-inline-block" ng-if="session.skillStr">{{session.skillStr}}</span> <span class="ml-4 mb-0 d-inline-block" ng-if="session.instructorName">instr: {{session.instructorName}}</span></div></div></div></div></div></div><div id="collapse{{::session.id}}" class="card-collapse" uib-collapse="!session.isActive"><div class="card-body"><div ng-if="!session.sessionSummaries" class="py-3">Loading...</div><div ng-if="session.sessionSummaries && session.sessionSummaries.length"><idp-online-lesson-session-summary ng-if="!session.sessionSummaries[0].isPartOfPackage" session-summary="session.sessionSummaries[0]" student-user-id="vm.student.studentUserID" parent-prod-id="session.productID"></idp-online-lesson-session-summary><div ng-if="session.sessionSummaries[0].isPartOfPackage"><idp-online-lesson-sessions session-summaries="session.sessionSummaries" student-user-id="vm.student.studentUserID" parent-prod-id="session.productID"></idp-online-lesson-sessions></div></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/idp-online-lesson-session-summary.html','<div class="w-100" data-ng-cloak ng-show="vm.canSee && vm.sessionSummary"><div ng-if="vm.isOPL3 && vm.isNotAssignedToLoggedInUser" class="alert alert-warning mt-3" role="alert">You cannot edit a lesson that is assigned to another instructor.</div><div ng-if="vm.isScheduledMoreThan1DayInFuture" class="alert alert-warning mt-3">This is a lesson in the future.</div><button type="button" ng-if="!vm.isEditMode && (vm.canUpdate || vm.canUpdateInternalNotes)" class="btn btn-sm px-6 btn-outline-secondary float-right" ng-dblclick="false" ng-click="vm.onEditClicked()">Edit</button><form id="{{::vm.formName}}" name="{{::vm.formName}}" class="w-100 pt-2" role="form" ng-submit="vm.onEmailPreviewClicked()" novalidate idp-form-focus-on-err><div class="row"><div class="col-3 text-right"><label>Customer:</label></div><div class="col-6"><span>{{vm.sessionSummary.customerInfo.name}}</span> <span class="ml-2">({{vm.sessionSummary.customerInfo.email}})</span><br><span ng-if="vm.sessionSummary.customerInfo.city">{{vm.sessionSummary.customerInfo.city}},</span> <span ng-if="vm.sessionSummary.customerInfo.state" class="ml-2">{{vm.sessionSummary.customerInfo.state}},</span> <span class="ml-2">{{vm.sessionSummary.customerInfo.country}}</span></div></div><div class="row mt-2"><div class="col-3 text-right"><label for="expiryDate">Exp date:</label></div><div class="col-9 col-md-6 col-lg-4"><span ng-if="!(vm.isEditMode && vm.canUpdate && vm.isOPLAdmin && !this.isExpired)">{{vm.sessionSummary.expiryDate | DTZeroHourPreviousDayAdjustForDisplay | date:\'yyyy-MM-dd\'}} Pacific Time</span><idp-text-date-picker name="expiryDate" placeholder="yyyy-mm-dd" format="yyyy-MM-dd" date="vm.sessionSummary.expiryDate" is-edit-mode="true" is-required="true" is-use-zero-hour-of-next-day="true" width="100%" ng-if="vm.isEditMode && vm.canUpdate && vm.isOPLAdmin && !this.isExpired" first-tab-index="100" required-message="The field is required"></idp-text-date-picker></div></div><div class="row mt-2"><div class="col-3 text-right"><label>Status:</label></div><div class="col-9 col-md-6 col-lg-4"><span ng-if="!vm.isEditMode">{{vm.sessionSummary.statusStr}}</span> <select ng-options="type.typeID as type.typeString for type in vm.sessionSummaryStatusTypes" class="form-control" name="status" ng-model="vm.sessionSummary.statusTypeID" ng-if="vm.isEditMode" required ng-disabled="vm.isStatusDisabled();" ng-change="vm.onStatusTypeChanged(vm.sessionSummary.statusTypeID, \'{{vm.sessionSummary.statusTypeID}}\')"></select><div ng-messages="vm.myForm.status.$error" class="text-danger"><div ng-message="required">This field is required</div></div></div></div><div class="row mt-2"><div class="col-3 text-right"><label>Instructor:</label></div><div class="col-9 col-md-6 col-lg-4"><span ng-if="!vm.isEditMode || !vm.canUpdate || this.isExpired || vm.isScheduledInPulse()">{{vm.sessionSummary.instructorName}}</span> <select ng-options="user.userID as user.fullName for user in vm.oplInstructors" class="form-control" name="instructorUserID" ng-model="vm.sessionSummary.instructorUserID" ng-if="vm.isEditMode && vm.canUpdate && !this.isExpired && vm.isScheduledInPulse() == false" ng-required="vm.sessionSummary.statusTypeID && vm.sessionSummary.statusTypeID != $root.Enums.OPLStatus.Unscheduled"></select><div ng-messages="vm.myForm.instructorUserID.$error" class="text-danger"><div ng-message="required">This field is required</div></div></div></div><div class="row mt-2"><div class="col-3 text-right"><label>Topic:</label></div><div class="col-9 col-md-6 col-lg-4"><span ng-if="!vm.isEditMode || !vm.canUpdate || this.isExpired">{{vm.sessionSummary.skillStr}}</span> <select ng-options="type.skillID as type.displayName for type in vm.sessionSummarySkills" class="form-control" name="skill" ng-model="vm.sessionSummary.skillID" ng-if="vm.isEditMode && vm.canUpdate && !this.isExpired" ng-required="vm.sessionSummary.statusTypeID && vm.sessionSummary.statusTypeID != $root.Enums.OPLStatus.Unscheduled"></select><div ng-messages="vm.myForm.skill.$error" class="text-danger"><div ng-message="required">This field is required</div></div></div></div><div class="row mt-2"><div class="col-3 text-right"><label>Lesson date/time:</label></div><div class="col-9" ng-if="!vm.isEditMode || !vm.canUpdate || this.isExpired || vm.isScheduledInPulse()"><div class="row"><div class="col-6 col-lg-4"><span class="mr-2">Start:</span> <span>{{vm.convertToLocalDateTime(vm.sessionSummary.startDateTimeUTC) | date:\'yyyy-MM-dd h:mm a\'}}</span></div><div class="col-6 col-lg-4"><span class="mr-2">End:</span> <span>{{vm.convertToLocalDateTime(vm.sessionSummary.endDateTimeUTC) | date:\'yyyy-MM-dd h:mm a\'}}</span></div></div></div><div class="col-9" ng-if="vm.isEditMode && vm.canUpdate && !this.isExpired && !vm.isScheduledInPulse()"><div class="row align-items-center"><span class="col-12 col-xl-1 pr-0">Start:</span><idp-text-date-picker name="startDateTimeUTC" placeholder="yyyy-mm-dd" format="yyyy-MM-dd" class="col-12 col-lg-4" date="vm.clientStartDateTime" is-edit-mode="true" is-required="vm.sessionSummary.statusTypeID && vm.sessionSummary.statusTypeID != $root.Enums.OPLStatus.Unscheduled" width="100%" on-change="vm.onSessionStartDateChanged()" first-tab-index=" 100" max-date="vm.sessionSummary.expiryDate"></idp-text-date-picker><div uib-timepicker ng-model="vm.clientStartDateTime" class="col-12 col-lg-4"></div><div ng-messages="vm.myForm.startDateTimeUTC.$error" class="text-danger"><div ng-message="required">This field is required</div></div></div><div class="row align-items-center"><span class="col-12 col-xl-1 pr-0">End:</span><idp-text-date-picker name="endDateTimeUTC" placeholder="yyyy-mm-dd" format="yyyy-MM-dd" class="col-12 col-lg-4" date="vm.clientEndDateTime" is-edit-mode="true" is-required="vm.sessionSummary.statusTypeID && vm.sessionSummary.statusTypeID != $root.Enums.OPLStatus.Unscheduled" width="100%" first-tab-index="110" max-date="vm.sessionSummary.expiryDate"></idp-text-date-picker><div uib-timepicker ng-model="vm.clientEndDateTime" class="col-12 col-lg-4"></div><div ng-messages="vm.myForm.endDateTimeUTC.$error" class="text-danger"><div ng-message="required">This field is required</div></div></div></div></div><div class="row mt-2"><div class="col-3 text-right"><label>Instructor time zone:</label></div><div class="col-9 col-md-6 col-lg-4"><span ng-click="vm.onTimeZoneClicked();">{{vm.sessionSummary.instrTimeZoneStr}}</span></div></div><div class="row mt-2"><div class="col-3 text-right"><label>Internal notes:</label></div><div class="col-9"><div ng-if="!vm.isEditMode || !vm.canUpdateInternalNotes" ng-bind-html="vm.sessionSummary.internalNotes | unsafe"></div><div type="text" text-angular ng-model="vm.sessionSummary.internalNotes" ta-toolbar="vm.taToolbar" class="opl-richtext-editor" ng-minlength="0" ng-maxlength="4000" name="internalNotes{{vm.id}}" ng-required="false" ng-if="vm.isEditMode && vm.canUpdateInternalNotes" tabindex="{{::vm.firstTabIndex+10}}"></div><div class="text-danger small" ng-if="vm.myForm[\'internalNotes\'+ vm.id].$error.maxlength">The field can only have max. 4000 characters including markups</div></div></div><div class="row mt-2"><div class="col-3 text-right"><label>Concepts covered:</label><div ng-show="vm.isEditMode">(Minimum 3 bulleted skills)</div></div><div class="col-9"><div ng-if="!vm.canSave || !vm.isEditMode" ng-bind-html="vm.sessionSummary.conceptsCovered | unsafe"></div><div text-angular ng-model="vm.sessionSummary.conceptsCovered" ta-toolbar="vm.taToolbar" class="opl-richtext-editor" name="conceptsCovered{{vm.id}}" ng-minlength="0" ng-maxlength="4000" ng-required="true" ng-if="vm.canSave && vm.isEditMode" ta-disabled="vm.isScheduledMoreThan1DayInFuture" tabindex="{{::vm.firstTabIndex+10}}"></div><div class="text-danger small" ng-if="vm.myForm[\'conceptsCovered\'+ vm.id].$error && vm.myForm.$submitted"><div ng-if="vm.myForm[\'conceptsCovered\'+ vm.id].$error.required">The field is required.</div></div><div class="text-danger small" ng-if="vm.myForm[\'conceptsCovered\'+ vm.id].$error.maxlength">The field can only have max. 4000 characters including markups</div></div></div><div class="row mt-2"><div class="col-3 text-right"><label>Student highlights:</label><div ng-show="vm.isEditMode">(How did student do during the lesson? How did they progress on their project?)</div></div><div class="col-9"><div ng-if="!vm.canSave || !vm.isEditMode" ng-bind-html="vm.sessionSummary.instructorNotes | unsafe"></div><div text-angular ng-model="vm.sessionSummary.instructorNotes" ta-toolbar="vm.taToolbar" class="opl-richtext-editor" name="instructorNotes{{vm.id}}" ng-minlength="0" ng-maxlength="4000" ng-required="true" ng-if="vm.canSave && vm.isEditMode" ta-disabled="vm.isScheduledMoreThan1DayInFuture" tabindex="{{::vm.firstTabIndex+10}}"></div><div class="text-danger small" ng-if="vm.myForm[\'instructorNotes\'+ vm.id].$error && vm.myForm.$submitted"><div ng-if="vm.myForm[\'instructorNotes\'+ vm.id].$error.required">The field is required.</div></div><div class="text-danger small" ng-if="vm.myForm[\'instructorNotes\'+ vm.id].$error.maxlength">The field can only have max. 4000 characters including markups</div></div></div><div class="row mt-3"><div class="col text-right"><button class="btn btn-outline-secondary ml-4" type="button" ng-if="!vm.isEditMode && vm.onCloseClicked" ng-click="vm.onCloseClicked()">Close</button> <button type="button" ng-if="vm.canSave && vm.isEditMode" class="btn btn-primary" ng-disabled="vm.myForm.$pristine" ng-click="vm.onSaveClicked()">Save</button> <button class="btn btn-primary ml-2" type="submit" ng-if="vm.canUpdate && vm.isEditMode && vm.sessionSummary.statusTypeID == $root.Enums.OPLStatus.CompleteDelivered">Preview Email and Save</button> <button class="btn btn-primary ml-2" type="button" ng-if="(vm.canUpdate || vm.canUpdateInternalNotes || (!vm.isOPLAdmin && !vm.isCS && vm.isOPL3)) && (vm.sessionSummary.statusTypeID == $root.Enums.OPLStatus.CompleteEmailSent) && vm.myForm.$valid" ng-click="vm.onEmailPreviewClicked();">Resend email to client</button> <button class="btn btn-outline-secondary ml-4" type="button" ng-if="vm.canSave && vm.isEditMode" ng-click="vm.onCancelClicked()">Cancel</button></div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/idp-online-lesson-sessions.html','<div ng-repeat="sessionSummary in vm.sessionSummaries"><div id="SummaryID_{{sessionSummary.orderDetailID}}" class="card id-collapsible-card mt-3"><div class="card-heading" id="heading{{::sessionSummary.userID}}" ng-click="vm.loadSessionSummary($index)" ng-class="{\'collapsed\': !sessionSummary.isActive}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{ \'d-none\': sessionSummary.isActive}"></span> <span class="icon icon-minus-1" ng-class="{ \'d-none\': !sessionSummary.isActive }"></span></div><div class="content container-fluid"><div class="d-flex flex-column flex-md-row"><div class="flex-grow-1 flex-shrink-1"><h4 class="mb-0 d-inline-block">Lesson {{$index+1}}</h4><span class="d-inline-block" ng-bind-html="vm.getSessionStatusStr(sessionSummary) | unsafe"></span> <span class="ml-md-4 text-primary" ng-if="vm.isSessionAvailable(sessionSummary)">1 available</span><div class="mt-1"><span class="ml-4 mb-0 d-inline-block" ng-if="sessionSummary.skillStr">{{sessionSummary.skillStr}}</span> <span class="ml-4 mb-0 d-inline-block" ng-if="sessionSummary.instructorName">instr: {{sessionSummary.instructorName}}</span></div></div></div></div></div></div><div id="collapse{{::sessionSummary.id}}" class="card-collapse" uib-collapse="!sessionSummary.isActive"><div class="card-body"><idp-online-lesson-session-summary session-summary="sessionSummary" instructors="vm.instructors" student-user-id="vm.studentUserId" parent-prod-id="vm.parentProdId"></idp-online-lesson-session-summary></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/idp-online-lesson-student-notes.html','<idp-online-lesson-note-edit-popup></idp-online-lesson-note-edit-popup><div class="card overflow-auto p-2" style="max-height: 12rem;" ng-show="vm.studentNotes && vm.studentNotes.length > 0"><span ng-repeat="note in vm.studentNotes"><span>{{note.createdDateUTC | utcToLocal:\'YYYY-MM-DD h:mm A\'}}</span> <span class="font-weight-bold ml-2">{{note.createdUserName}}</span> <span class="ml-2">{{note.noteText}}</span> <button class="btn btn-link px-1 py-0" type="button" ng-if="vm.canEditNote" ng-click="vm.onEditNoteClick(note)">Edit</button> <button class="btn btn-link px-1 py-0" type="button" ng-if="vm.canDeleteNote" ng-click="vm.onDeleteNoteClick(note)">Delete</button></span></div><div class="row mt-2"><div class="col text-right"><button type="button" ng-if="vm.canAddNote" class="btn btn-outline-secondary btn-sm" ng-click="vm.onEditNoteClick(null)">Add New Note</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/idp-online-lesson-students.html','<div data-ng-show="vm.studentSessionsCopy && vm.studentSessionsCopy.length > 0"><div class="id-panel-group" id="studentsAccordion"><div ng-repeat="student in vm.studentSessionsCopy"><div class="card id-collapsible-card mt-3"><div class="card-heading" id="heading{{::student.studentUserID}}" ng-click="vm.getStudentNotes($index)" ng-class="{\'collapsed\': !student.isActive}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{ \'d-none\': student.isActive}"></span> <span class="icon icon-minus-1" ng-class="{ \'d-none\': !student.isActive }"></span></div><div class="content container-fluid"><div class="d-flex flex-column flex-md-row"><div class="flex-grow-1 flex-shrink-1"><h3 class="mb-0 d-inline-block"><span>{{student.fullName}}</span></h3><span class="ml-3">{{student.dateOfBirth | ageFilter}} years old</span> <span class="ml-3 text-primary" ng-if="student.hasLessonsAvailable">lessons available</span></div></div></div></div></div><div id="collapse{{::student.studentUserID}}" class="card-collapse" uib-collapse="!student.isActive"><div class="card-body"><div class="my-3"><idp-online-lesson-student-notes student-notes="student.studentNotes" student-user-id="student.studentUserID"></idp-online-lesson-student-notes><idp-online-lesson-products ng-if="student.onlineSessions" sessions="student.onlineSessions" student="student" selected-parent-order-detail-id="vm.selectedParentOrderDetailId" selected-order-detail-id="vm.selectedOrderDetailId"></idp-online-lesson-products></div></div><hr><div class="row mt-3 justify-content-center"><div class="col"><button class="btn btn-link btn-block no-text-transform" type="button" ng-click="vm.onCloseClick(student)"><span class="icon icon-chevron-up mr-2"></span>Close <span class="d-none d-sm-inline-block">drawer</span></button></div></div></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/idp-opl-student-achievements.html','<h3>My Achievements ({{ vm.StudentAchivementCount }})</h3><div class="badge-container"><div class="row"><badges ng-repeat-start="badge in vm.studentAchievements track by $index"></badges><div class="col badge-col py-2"><img src="{{ vm.getBadgeImage(badge) }}" alt="{{ badge.badgeName }}"></div><div class="badge-break" ng-if="vm.nextRow($index)"></div><badgesend ng-repeat-end></badgesend><div class="col badge-col py-2" ng-if="vm.showLastRow" ng-repeat="cell in vm.cellsNeededForRow()"></div><div class="w-100" ng-if="vm.showLastRow"></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/order-confirmation/idp-order-confirmation-product.html','<div class="shadow rounded fixed-width"><div class="header rounded-top" ng-class="\'header-{{::vm.product.divisionID }}\'"></div><div class="p-3 bg-white rounded"><div class="d-flex flex-row"><div ng-if="!vm.pulseContext.isRunningInPartnerDomain" class="mr-3 mr-lg-5"><img class="logo" ng-src="{{vm.common.config.appRoot }}assets/images/icons/new/logo-{{vm.product.divisionID}}.svg" alt="{{ ::division.name }}" title="{{ ::division.name }}"></div><div class="flex-grow-1"><div class="font-weight-bold" style="color:#000;">{{::vm.product.courseName}}</div><div class="text-small"><div>{{::vm.product.divisionName}} <span ng-if="vm.product.isSubscription">(Subscription)</span></div><div ng-if="!vm.isProductTutor">{{::vm.product.dayOfWeekRange}}, {{::vm.product.dateRange}}</div><div ng-if="!vm.isProductTutor"><span class="mr-1" ng-show="vm.product.catalogTypeID === $root.Enums.SalesCatalogType.SquadsMultiWeek || vm.product.catalogTypeID === $root.Enums.SalesCatalogType.CourseBundle">{{::vm.product.startDate | date:\'EEE\'}}</span><span>{{::vm.product.shortTermName}}</span></div><div ng-if="vm.isProductTutor"><span>{{::vm.product.numberOfPackagedChildren}}</span> <span ng-if="vm.product.numberOfPackagedChildren <= 1">lesson</span> <span ng-if="vm.product.numberOfPackagedChildren >= 2">lessons</span> <span ng-if="vm.product.isSubscription">per month</span></div></div></div></div><hr><div ng-if="!vm.isProductTutor"><idp-product-share product="vm.product" participant="vm.participant" raf-code="vm.rafCode"></idp-product-share></div><div class="text-black" ng-if="vm.isProductTutor"><div class="font-weight-bold">Start learning</div><div class="d-block d-md-none row"><div class="col mt-3"><a ng-href="{{vm.scheduleUrl}}" title="Schedule now" class="btn btn-block btn-primary">Schedule now</a></div></div><div class="d-block d-md-none row"><div class="col mt-3"><a ng-href="{{vm.manageLessonsUrl}}" title="Manage lessons" class="btn btn-block btn-outline-secondary">Manage lessons</a></div></div><div class="d-md-block d-none row"><div class="col mt-3"><a ng-href="{{vm.scheduleUrl}}" title="Schedule now" class="btn btn-primary" style="width: 172px;">Schedule now</a> <a ng-href="{{vm.manageLessonsUrl}}" title="Manage lessons" class="btn btn-outline-secondary ml-3" style="width: 172px;">Manage lessons</a></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/order-confirmation/idp-product-share.html','<div class="text-black"><div class="font-weight-bold">Invite your friends!</div><div class="row"><div class="col d-flex align-items-center text-black c-pointer mt-3"><i class="icon icon-email1 text-em-1-5 mr-2"></i> <a class="text-black" ng-href="{{vm.getEmail()}}">Email</a></div><div class="col d-flex align-items-center text-black c-pointer mt-3"><i class="icon icon-sms-oval text-em-1-5 mr-2"></i> <a class="text-black" ng-href="{{vm.getSmsBody()}}">SMS</a></div><div class="col d-flex align-items-center text-black c-pointer mt-3"><i class="icon icon-link text-em-1-5 mr-2"></i> <a id="btnCopyCode" class="text-black text-nowrap" data-clipboard-text="{{vm.getCourseShareUrl()}}" ng-href="">Copy link</a></div><div class="col d-flex align-items-center text-black c-pointer mt-3" ng-click="vm.shareOnFB($event)"><i class="icon icon-facebook-circle text-em-1-5 mr-2"></i> <a class="text-black" target="_new" ng-href="">Facebook</a></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/page-header/idp-page-header.html','<div class="pp-page-header"><div class="pp-page-content-centered"><table style="height:140px;"><tr><td valign="middle" data-ng-show="showBackBtn"><div class="pp-btn-back-header mq-display-none-to-inlineblock" data-ng-click="vm.submit()"></div></td><td valign="middle" class="pp-page-title">{{pageTitle}}</td></tr></table></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/privacy-policy/idp-privacy-policy-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><h4>iD Tech Privacy Policy</h4><button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div ng-bind-html="vm.privacyPolicyContent | unsafe"></div></div></div><div class="modal-footer"><div class="pull-right"><button class="btn btn-outline-secondary" type="button" data-ng-click="vm.close()">Close</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/refer-a-friend/idp-raf-email-address-list.html','<idp-raf-email-address index="{{$index}}" email-address="emailAddress" my-form="vm.myForm" ng-repeat="emailAddress in vm.emailAddresses track by emailAddress.id"></idp-raf-email-address>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/refer-a-friend/idp-raf-email-address.html','<div class="row form-group"><div class="col-xs-12"><label class="sr-only" for="emailAddress{{::vm.id}}">Email Address</label> <label for="" style="display: none;">hidden label to mislead chrome autocomplete</label> <input id="emailAddress{{::vm.id}}" name="emailAddress{{::vm.id}}" type="email" class="form-control" placeholder="{{::vm.placeHolder}}" ng-model="vm.emailAddress.email" ng-required="vm.isRequired" ng-maxlength="200" autocomplete="something-new" uib-tooltip-html="vm.toolTip" tooltip-trigger="\'focus\'"><div ng-messages="vm.emailAddressFormControl.$error" class="text-danger"><div ng-message="required">1st email address is required</div><div ng-message="email">{{vm.emailRegExpErrorMsg}}</div><div ng-message="maxlength">The email address must be less than 200 characters</div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/refer-a-friend/idp-raf-email-popup.html','<form id="{{::vm.formName}}" name="{{::vm.formName}}" class="pulseapp" ng-cloak role="form" novalidate autocomplete="something-new" idp-form-focus-on-err><div><div class="modal-header idp-popup-title">{{vm.title}} <button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div class="row"><div class="col-xs-1"><strong>To:</strong></div><div class="col-xs-11"><idp-raf-email-address-list email-addresses="vm.emailAddresses" my-form="vm.myForm"></idp-raf-email-address-list><div class="form-group"><img class="" ng-src="{{::vm.plusImageUrl}}" title="Add more friends" alt="Add more friends" ng-click="vm.addEmailAddress()" style="cursor:pointer;"> <a class="ord-conf ord-conf-add-email" ng-click="vm.addEmailAddress()" style="text-decoration:none;">Add more friends</a></div></div></div><div class="row"><div class="col-xs-12"><strong>Subject:</strong> {{::vm.emailSubject}}</div></div><div class="row" style="margin-top:15px;margin-bottom:10px;"><div class="col-xs-12"><textarea style="width:100%;height:100px;" placeholder="Enter a personalized message here..." ng-model="vm.personalizedMessage" maxlength="5000"></textarea></div></div><div class="row"><div class="col-xs-12" ng-bind-html="vm.emailBody"></div></div><div class="row"><div class="col-xs-12" ng-bind-html="vm.emailClosing"></div></div></div><div class="modal-footer"><div class="col-xs-12" style="text-align:center;"><button class="btn btn-primary done-button" type="submit" style="margin:auto;" ng-click="vm.sendEmail()">Send email</button></div></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/refer-a-friend/idp-raf-email-sent-popup.html','<form id="{{::vm.formName}}" name="{{::vm.formName}}" class="pulseapp" ng-cloak role="form" novalidate idp-form-focus-on-err><div><div class="modal-header idp-popup-title">{{::vm.title}} <button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div class="row" style="margin-bottom:10px;"><div class="col-xs-1"></div><div class="col-xs-10"><strong>Congratulations, your email was successfully sent to the following friends:</strong></div><div class="col-xs-1"></div></div><div class="row" ng-repeat="emailAddress in vm.emailAddresses"><div class="col-xs-1"></div><div class="col-xs-10">{{emailAddress.email}}</div><div class="col-xs-1"></div></div></div><div class="modal-footer" style="justify-content: center;"><div class="d-flex flex-column flex-sm-row"><div class="mr-sm-2"><button class="btn btn-primary" type="submit" style="width:200px;" ng-click="vm.addMoreFriends()">Add more friends</button></div><div class="mt-2 mt-sm-0"><button class="btn btn-outline-secondary" type="submit" style="width:200px;" ng-click="vm.close()">Close</button></div></div></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/refer-a-friend/idp-raf-share.html','<idp-raf-email-popup></idp-raf-email-popup><idp-raf-email-sent-popup></idp-raf-email-sent-popup><div class="row d-flex flex-wrap-reverse" style="background-color: #eee;"><div class="col-lg-6 mt-md-9" ng-show="vm.showImage"><img class="img-fluid" ng-src="{{::vm.rafImageUrl}}" title="Congrats!" alt="Congrats!"></div><div class="col"><div class="idp-raf-container"><div class="d-inline-block text-center"><h3 class="mt-2 idp-green-text-highlight d-none d-lg-inline-block">Refer a friend in 13 seconds!</h3><h4 class="mt-2 idp-green-text-highlight d-xs-inline-block d-lg-none">Refer a friend in 13 seconds!</h4><h1 class="mt-3 d-none d-xl-block">Give $25, get $25</h1><h2 class="mt-3 d-xs-block d-xl-none">Give $25, get $25</h2></div><div class="mt-3"><div>Share your code <span class="text-black font-weight-bold">{{vm.rafCode}}</span> with friends and family. You save $25 and your friend does too. (Applies only toward purchases in US dollars.)</div></div><div class="mt-3"><img ng-src="{{::vm.letterImageUrl}}"> <span class="text-black font-weight-bold">Enter friend\'s email</span></div><div id="enterEmail" class="mt-2"><form class="row"><div class="col-12 col-lg-8"><label class="sr-only" for="emailAddress">Email Address</label> <input id="inputEmail" type="text" name="emailAddress" class="form-control" placeholder="Email*" ng-required="true" ng-model="vm.emailAddress" maxlength="200" autocomplete="off"><div id="emailAddressError" class="mt-1" style="display:none;"><div class="text-danger text-small">Email address is required.</div></div></div><div class="col-12 col-lg-4 mt-3 mt-lg-0"><button id="btnSend" class="btn btn-outline-secondary btn-block" style="height: 3rem;" type="button" ng-click="vm.showRafEmailPopup()">Send</button></div></form></div><div class="mt-3 text-center"><div class="idp-raf-line-gray"></div><div class="ord-conf-or-text">&nbsp;Or&nbsp;</div><div class="idp-raf-line-gray"></div></div><div class="mt-4"><form><div class="form-group"><idp-facebook-share name="vm.facebookShareName" url="vm.facebookShareUrl" description="vm.facebookReferAFriendText"></idp-facebook-share></div><div class="form-group"><idp-twitter-share text="vm.twitterReferAFriendText" url="vm.twitterShareUrl" width="575" height="400"></idp-twitter-share></div></form></div><div class="mt-3 text-center">Share the code via instant messenger</div><div class="mt-2"><form class="d-flex flex-column flex-lg-row justify-content-center align-items-center row"><div class="col-12 col-lg-8"><label class="sr-only" for="rafCode">RAF Code</label><div id="divCode" name="rafCode" class="form-control"><div style="position:relative;top:4px;">Code: <span class="text-black font-weight-bold">{{vm.rafCode}}</span></div></div></div><div class="col-12 col-lg-4 mt-3 mt-lg-0"><button id="btnCopyCode" class="btn btn-outline-secondary btn-block" style="height: 3rem;" type="button" data-clipboard-text="{{vm.rafCode}}">Copy Code</button></div></form></div><div class="mt-lg-8 mt-4 small text-left">*Your unique Refer-a-Friend code can be used by up to 10 friends. Referred friends must be new to iD Tech and must use your Refer-a-Friend code at the time of registration. The Refer-a-Friend program does not apply to siblings or Private Online Lessons. Refer-a-Friend codes may be applied only toward purchases in US dollars. For a complete list of rules, please review our <a href="" id="rafTandCHelp" ng-click="vm.showTandC()" title="Terms & Conditions">Terms & Conditions</a>.</div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/refer-a-friend/idp-raf-status.html','<div class="my-3"><h4>View Your Rewards</h4><div ng-hide="vm.hasReferrals">Your unique code for {{::vm.year}} hasn\'t been used yet. Keep sharing to save!</div><div ng-show="vm.hasReferrals" class="px-3"><div class="row d-none d-md-flex raf-header"><div class="col-md-2">Referral Status</div><div class="col-md-4">Reason if Invalid</div><div class="col-md-2">Used On</div><div class="col-md-2">Used By</div><div class="col-md-2">Amount</div></div><div ng-repeat="referral in vm.referrals track by referral.couponUsedFor_CouponUserID"><div class="row raf-item"><div class="d-md-none col-3 raf-header">Status</div><div class="col-md-2 col-9">{{referral.statusTypeString}}<div ng-if="vm.pulseContext.isImpersonating && referral.statusTypeID != $root.Enums.CouponStatus.Canceled"><a href="" ng-click="vm.onChangeStatus(referral)" title="Change status">Change</a></div></div><div class="d-md-none col-3 raf-header">Reason if Invalid</div><div class="col-md-4 col-9">{{referral.invalidReason}}</div><div class="d-md-none col-3 raf-header">Used On</div><div class="col-md-2 col-9">{{referral.couponUsedDate | date:\'yyyy-MM-dd\'}}</div><div class="d-md-none col-3 raf-header">Used By</div><div class="col-md-2 col-9"><a href="" ng-if="vm.pulseContext.isImpersonating" ng-click="vm.onSwitchAccount(referral)" title="Switch To {{::referral.couponUsedFor}} account.">{{::referral.couponUsedFor}} </a><span ng-if="!vm.pulseContext.isImpersonating">{{::referral.couponUsedFor}}</span></div><div class="d-md-none col-3 raf-header">Amount</div><div class="col-md-2 col-9">{{::referral.rewardAmount | currency:"$" }}</div></div><div class="row d-md-none" style="height:1em;"></div></div></div><idp-raf-admin-status-popup popup-id="rafAdminStatusPopup"></idp-raf-admin-status-popup></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/idp-reg-flow-admin-override-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4><strong>{{::vm.title}}</strong></h4></div><div class="modal-body"><div class="alert alert-danger" role="alert"><strong>Restrictions:</strong><br><span ng-bind-html="::vm.restrictionMsg | unsafe"></span></div><div class="form-group"><select name="selOverrideReason" ng-model="vm.selectedOverrideReason" class="form-control id-standard" ng-required="true" required uib-tooltip="Override Reason" tooltip-trigger="\'focus\'" ng-options="type.typeString for type in vm.overrideReasonTypes"><option value="">Select Override Reason</option></select></div><div class="row vertical-align well"><div class="col-1"><div class="form-check float-left"><input type="checkbox" id="chkApproved" name="chkApproved" ng-model="vm.isApproved" ng-required="true" class="form-check-input"> <label for="chkApproved" class="form-check-label"></label></div></div><div class="col-11">Approved by CS Manager/Lead?</div></div></div><div class="modal-footer"><div class="col-xs-6 col-md-4"><button class="btn btn-outline-secondary btn-block" type="button" ng-click="vm.close()">Close</button></div><div class="col-xs-6 col-md-4"><button class="btn btn-primary btn-block" type="submit" ng-class="{disabled: vm.saveDisabled}" ng-disabled="vm.saveDisabled" ng-dblclick="false">Override</button></div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-change-camp-date-popup.html','<div id="{{::vm.popupId}}" role="dialog" class="pulseapp idp-change-camp-date-popup"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="modal-header"><h4 class="modal-title">{{vm.title}}</h4><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div ng-show="vm.isSquads && !vm.showConfirmationView"><div>What day do you want to start?</div><div class="btn-group-days mx-0"><button ng-repeat="d in vm.availableDays" class="btn btn-outline-secondary mt-3 ml-2 font-weight-bold" type="button" ng-class="vm.isSelectedDay(d) ? \'selected\':\'\'" ng-click="vm.selectDay(d)">{{d.shortName}}</button></div></div><section class="mt-2" ng-if="!vm.showConfirmationView && vm.sessions.length > 0"><p>Select a new date below:</p><div class="container"><div ng-repeat="session in vm.sessions" class="row cell-container" ng-class="{\'border-last-row\': $last,\n                        \'selected\': vm.isSessionSelected(session),\n                        \'highlight-on-hover\': vm.isSelectable(session),\n                        \'in-cart\':  vm.isCurrentlyPurchased(session)}" ng-show="vm.showSession(session)" ng-click="vm.onSessionSelect(session)"><div class="col px-1"><div class="font-weight-bold" ng-bind-html="session.startDate | formatSessionDates:session.endDate:1:1"></div><span ng-show="vm.isSquads || vm.isVTC">{{session.termName}}</span></div><div class="col-1 col-xs-2 px-1"><span class="text-black icon icon-day" ng-show="vm.showDayIcon(session)"></span> <span class="text-black icon icon-night" ng-show="vm.showNightIcon(session)"></span></div><div class="col-5 col-xs-4 col-sm-3 justify-content-center text-center mx-1" ng-if="vm.isCurrentlyPurchased(session)">Already Purchased</div><div class="col-5 col-xs-4 col-sm-3 justify-content-center mx-1 py-2 badge badge-{{ ::session.statusOptions.htmlClass }}" ng-if="!vm.isCurrentlyPurchased(session)">{{::session.statusOptions.displayName | uppercase }}</div></div></div><div ng-show="vm.myForm.$submitted && !vm.selectedSession" class="text-danger mt-3">Please select a new date.</div><div ng-show="vm.myForm.$submitted && !vm.ageIsValid" class="text-danger mt-3" ng-bind-html="$root.StringConst.Warn_StudentNotMeetAgeRequirement | unsafe"></div></section><section ng-if="vm.showConfirmationView">{{::vm.getConfirmationMsg()}}</section></div><section ng-if="!vm.showConfirmationView"><div class="modal-footer align-items-stretch flex-column flex-md-row"><div class="m-0 mr-md-4"><button class="btn btn-outline-secondary btn-block" type="button" data-ng-click="vm.close()">Cancel</button></div><div class="m-0 mt-2 mt-md-0"><button class="btn btn-primary btn-block px-md-5" type="submit" data-ng-class="{disabled: vm.saveDisabled}" data-ng-disabled="!vm.selectedSession || vm.saveDisabled" data-ng-dblclick="false">Select</button></div></div></section><section ng-if="vm.showConfirmationView"><div class="modal-footer align-items-stretch flex-column flex-md-row"><div class="m-0 mr-md-4"><button class="btn btn-outline-secondary btn-block" type="button" data-ng-click="vm.close()">Keep Making Changes</button></div><div class="m-0 mt-2 mt-md-0"><button class="btn btn-primary btn-block px-md-5" ng-click="vm.onGoCheckout()" data-ng-class="{disabled: vm.saveDisabled}" data-ng-disabled="!vm.selectedSession || vm.saveDisabled" data-ng-dblclick="false">Checkout Now</button></div></div></section><div ng-if="!vm.showConfirmationView" class="row mx-2 mb-3"><div class="col">None of these dates work? <a href="" ng-click="vm.onChangeCourse()">View all courses here</a> or call us at <span style="white-space:nowrap;">{{::vm.pulseContext.companyTollFreePhone}}</span> for assistance.</div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-change-camp-popup.html','<div id="{{::vm.popupId}}" role="dialog" class="pulseapp"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="modal-header"><h4 class="modal-title">{{::vm.title}}</h4><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><fieldset><p>Please select the type of change you would like to make.</p><div class="row"><div class="col-md-6"><div class="form-group" uib-tooltip="Type of Change" tooltip-trigger="focus"><select name="changeType" class="form-control" ng-change="vm.selectedChangeTypeChanged()" ng-model="vm.selectedChangeType" autocomplete="off" ng-required="true" ng-options="opt for opt in vm.changeOptions"></select></div></div></div></fieldset><div class="alert alert-warning" ng-show="vm.initDataObj.showChangeFeeWarning" ng-bind-html="$root.StringConst.Warn_Order_ChangeFee | unsafe"></div></div><div class="modal-footer align-items-stretch flex-column flex-md-row"><div class="m-0 mr-md-4"><button class="btn btn-outline-secondary btn-block" type="button" data-ng-click="vm.close()">Cancel</button></div><div class="m-0 mt-2 mt-md-0"><button class="btn btn-primary btn-block px-md-5" type="submit" data-ng-class="{disabled: vm.saveDisabled}" data-ng-disabled="vm.saveDisabled" data-ng-dblclick="false">{{vm.continueText}}</button></div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-change-virtual-camp-time-popup.html','<div id="{{::vm.popupId}}" role="dialog" class="pulseapp idp-change-camp-date-popup"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="modal-header"><h4 class="modal-title">{{vm.title}}</h4><bheutton type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></bheutton></div><div class="modal-body"><section ng-if="!vm.showConfirmationView"><p>Course Date: <span style="font-weight:bold">{{:: vm.sessionToChange.sessionStart | formatVirtualSessionDate}}</span></p><p>Select a new time below:</p><div class="container"><div ng-repeat="spd in vm.sessionProductDetails" class="row cell-container" ng-class="{\'border-last-row\': $last,\n                        \'selected\': vm.isSelected(spd),\n                        \'highlight-on-hover\': vm.isSelectable(spd),\n                        \'in-cart\':  vm.isCurrentlyPurchased(spd)}" ng-show="vm.showSessionProductDetail(spd)" ng-click="vm.onSessionProductDetailSelect(spd)"><div class="col font-weight-bold px-1" ng-bind-html="vm.getTermName(spd)"></div><div class="col-5 col-xs-4 col-sm-3 justify-content-center text-center mx-1" ng-if="vm.isCurrentlyPurchased(spd)">Already Purchased</div><div class="col-5 col-xs-4 col-sm-3 justify-content-center mx-1 py-2 badge badge-{{ ::vm.getStatusOptions(spd).htmlClass }}" ng-if="!vm.isCurrentlyPurchased(spd)">{{::vm.getStatusOptions(spd).displayName | uppercase }}</div></div></div><div ng-show="vm.myForm.$submitted && !vm.selectedSessionProductDetail" class="text-danger mt-3">Please select a new time.</div></section><section ng-if="vm.showConfirmationView">{{::vm.getConfirmationMsg()}}</section></div><section ng-if="!vm.showConfirmationView"><div class="modal-footer align-items-stretch flex-column flex-md-row"><div class="col-12 col-offset-0 col-md-4 col-md-offset-4 mr-0"><button class="m-0 mr-md-4" type="button" data-ng-click="vm.close()">Cancel</button></div><div class="m-0 mt-2 mt-md-0"><button class="btn btn-primary btn-block px-md-5" type="submit" data-ng-class="{disabled: vm.saveDisabled}" data-ng-disabled="!vm.selectedSessionProductDetail || vm.saveDisabled" data-ng-dblclick="false">Select</button></div></div></section><section ng-if="vm.showConfirmationView"><div class="modal-footer align-items-stretch flex-column flex-md-row"><div class="m-0 mr-md-4"><button class="btn btn-outline-secondary btn-block" type="button" data-ng-click="vm.close()">Keep Making Changes</button></div><div class="m-0 mt-2 mt-md-0"><button class="btn btn-primary btn-block px-md-5" ng-click="vm.onGoCheckout()" data-ng-class="{disabled: vm.saveDisabled}" data-ng-disabled="!vm.selectedSessionProductDetail || vm.saveDisabled" data-ng-dblclick="false">Checkout Now</button></div></div></section><div ng-if="!vm.showConfirmationView" class="row mx-2 mb-3"><div class="col">None of these times work? <a href="" ng-click="vm.onChangeCourse()">View all courses here</a> or call us at <span style="white-space:nowrap;">{{::vm.pulseContext.companyTollFreePhone}}</span> for assistance.</div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-course-options-list.html','<span>{{::vm.heading}}</span><div class="{{opt.cssClass}} my-2" data-ng-repeat="opt in vm.filteredOptionList"><div><strong>{{opt.name}}</strong> <span id="{{vm.orderDetailId + \'_\' + opt.sPD_ID}}" class="icon icon-info feedback-icon" ng-click="vm.showOptionInfo($index)" ng-show="opt.sPD_ID != null"></span></div><div ng-hide="vm.isReadOnly" class="d-flex flex-wrap align-items-center"><div class="mr-2"><button type="button" class="btn btn-link p-0" ng-disabled="!opt.isEnabled" ng-class="{\'alt-color\': opt.isPurchased && opt.isEnabled, \'disabled\': !opt.isEnabled}" ng-click="vm.onOptionClick($index)">{{ vm.getBtnText(opt) }}</button></div><div class="flex-grow-1 text-warning" g-if="opt.message != null" ng-bind-html="opt.message | unsafe"></div></div></div><div ng-if="!vm.filteredOptionList || vm.filteredOptionList.length == 0" class="{{opt.cssClass}} my-2"><strong>None</strong></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-course-options.html','<div ng-if="vm.filteredOptionList.length" class="py-3"><h4 class="mb-0">{{::vm.heading}}</h4><div class="row"><div class="col-md-4 {{opt.cssClass}} mt-3" data-ng-repeat="opt in vm.filteredOptionList"><div class="card p-3 h-100"><p class="my-sm-3"><strong>{{::opt.name}}</strong> <span id="{{vm.orderDetailId + \'_\' + opt.sPD_ID}}" class="icon icon-info feedback-icon" ng-click="vm.showOptionInfo($index)" ng-show="opt.sPD_ID != null"></span></p><div ng-if="opt.price != null" class="mb-1 mt-auto">{{ opt.locationPrice | currency:opt.currencyTypeID:0 }}{{ opt.priceSuffix }}</div><div ng-if="opt.price == null" class="mb-1 mt-auto" ng-bind-html="opt.description | unsafe"></div><small class="text-info my-auto" ng-if="opt.message != null" ng-bind-html="opt.message | unsafe"></small> <button class="mt-3 btn btn-outline-secondary mr-auto no-text-transform" ng-disabled="!opt.isEnabled" ng-class="{\'alt-color\': opt.isPurchased && opt.isEnabled, \'disabled\': !opt.isEnabled}" ng-click="vm.onOptionClick($index, opt)">{{::vm.getBtnText(opt) }}</button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-course-summary.html','<div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-group-with-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="modal-header"><h4 class="modal-title" ng-hide="vm.isVTC" idp-focus-on="true" tabindex="0">Group or room with a friend</h4><h4 class="modal-title" ng-show="vm.isVTC" idp-focus-on="true" tabindex="0">Group with a friend</h4><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><fieldset><h5 ng-hide="vm.isVTC">Request to be in the same Course Group</h5><p>Your friend must register for the same course</p><div class="can-clone"><div class="row" data-ng-repeat="buddy in vm.groupWithList track by $index"><div class="col-md-6"><div class="form-group"><input class="form-control" maxlength="200" placeholder="Friend first name" data-ng-model="buddy.firstName" data-ng-model-options="{ \'updateOn\' : \'blur\' }" idp-focus-on="{{vm.groupWithFocus($index)}}"></div></div><div class="col-md-6"><div class="form-group"><input class="form-control" maxlength="200" aria-label="Friend last name" placeholder="Friend last name" data-ng-model="buddy.lastName" data-ng-model-options="{ \'updateOn\' : \'blur\' }"></div></div></div><p><a href="#" data-ng-if="vm.groupWithList && vm.groupWithList.length < (vm.initDataObj.maxFriendNumber || 3)" data-ng-click="vm.addGroupWith($event)">Add Another<span class="sr-only"> friend</span></a></p></div></fieldset><fieldset ng-if="vm.hasOvernight"><h5>Request to be Roommates</h5><p>Note that most locations have 2 students per room</p><div class="can-clone"><div class="row" data-ng-repeat="buddy in vm.roomWithList track by $index"><div class="col-md-6"><div class="form-group"><input class="form-control" maxlength="200" placeholder="Friend First Name" data-ng-model="buddy.firstName" data-ng-model-options="{ \'updateOn\' : \'blur\' }" idp-focus-on="{{vm.groupWithFocus($index)}}"></div></div><div class="col-md-6"><div class="form-group"><input class="form-control" maxlength="200" placeholder="Friend Last Name" data-ng-model="buddy.lastName" data-ng-model-options="{ \'updateOn\' : \'blur\' }"></div></div></div><p><a href="" data-ng-if="vm.roomWithList && vm.roomWithList.length < (vm.initDataObj.maxFriendNumber || 3)" data-ng-click="vm.addRoomWith()">Add Another<span class="sr-only"> roommate</span></a></p></div></fieldset><div class="text-info text-small">*We do our best to accommodate requests to group with friends, however, we cannot make guarantees.</div></div><div class="modal-footer align-items-stretch flex-column flex-md-row"><div class="m-0 mr-md-4"><button class="btn btn-outline-secondary btn-block" type="button" data-ng-click="vm.close()">Cancel</button></div><div class="m-0 mt-2 mt-md-0"><button class="btn btn-primary btn-block px-md-5" type="submit" data-ng-class="{disabled: vm.saveDisabled}" data-ng-disabled="vm.saveDisabled" data-ng-dblclick="false" idp-click-tracking data-id-action-text="Group With - Save changes">Save changes</button></div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-my-students.html','<div data-ng-show="vm.studentList && vm.studentList.length > 0"><h3>My Students</h3><div class="id-panel-group" id="studentsAccordion"><div ng-repeat="student in vm.studentList"><div class="card id-collapsible-card mt-3"><div class="card-heading" id="heading{{::student.userID}}" ng-click="vm.loadStudentSessions($index)" ng-class="{\'collapsed\': !student.isActive}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-hide="student.isActive"></span> <span class="icon icon-minus-1" ng-show="student.isActive"></span></div><div class="content container-fluid"><div class="d-flex flex-column flex-md-row"><div class="flex-grow-1 flex-shrink-1"><h3 class="">{{student.firstName}} {{student.lastName}}</h3><div><small ng-show="student.codeWord != null && student.codeWord != \'\'">Code word for pick-up: <strong class="text-danger">{{student.codeWord}}</strong><p class="mb-0">Pick-up person MUST provide this Code Word in order for iD Staff to release your preteen student.</p></small></div></div><div class="flex-grow-0 flex-shrink-0" ng-hide="student.isActive"><button type="button" class="btn btn-primary btn-sm">Camp details</button></div></div></div></div></div><div id="collapse{{::student.userID}}" class="card-collapse" uib-collapse="!student.isActive"><div class="card-body" ng-show="student.isReadyToShow"><fieldset ng-disabled="!vm.canUpdate"><idp-sessions student="student" session-list="student.sessionList"></idp-sessions><hr><div class="my-3"><h3>Online Private Lessons</h3><div class="my-3"><strong class="d-block">Learn year-round on your own schedule with a certified iD Tech instructor!</strong> Our private online lessons are the perfect way to prep for a summer course, continue learning afterwards, or dive into a new topic anytime. With one-on-one remote instruction, your student will build in-demand coding, game dev, and design skills from the comfort of home. Get started today!</div><button class="btn btn-outline-secondary no-text-transform" data-ng-click="vm.onOnlineLessonsClick()">Purchase Online Private Lessons</button></div></fieldset><hr><div class="row mt-3 justify-content-center"><div class="col"><button class="btn btn-link btn-block no-text-transform" type="button" ng-click="vm.onCloseClick(student)"><span class="icon icon-chevron-up mr-2"></span>Close <span class="d-none d-sm-inline-block">drawer</span></button></div></div></div></div></div></div></div><idp-group-with-popup popup-id="groupWithPopup" title="Friends" api="vm.groupWithPopupAPI"></idp-group-with-popup><idp-change-camp-popup popup-id="changeCampPopup" title="Change Camp"></idp-change-camp-popup><idp-change-camp-date-popup popup-id="changeCampDatePopup"></idp-change-camp-date-popup><idp-change-virtual-camp-time-popup popup-id="changeCampTimePopup"></idp-change-virtual-camp-time-popup><idp-reg-flow-admin-override-popup popup-id="adminOverridePopup"></idp-reg-flow-admin-override-popup><idp-request-voucher-credit-popup popup-id="requestVoucherCreditPopup" title="Request voucher credit" api="vm.requestVoucherCreditPopupApi"></idp-request-voucher-credit-popup></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-request-voucher-credit-popup.html','<div id="{{::vm.popupId}}" role="dialog" class="pulseapp"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="modal-header"><h4 class="modal-title">{{::vm.title}}</h4><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><p ng-hide="vm.isResultSuccess">Thank you for requesting a voucher credit.<br>Pressing confirm below will issue you a voucher credit for this course.</p><p ng-show="vm.isResultSuccess">Your request has been processed, details can be found on your <button type="button" class="btn btn-link p-0" ng-click="vm.navigateToStatement();">statement</button>.</p></div><div class="modal-footer row mx-0"><div class="col-12 col-offset-0 col-md-4 col-md-offset-4 mr-0"><button class="btn btn-outline-secondary btn-block" type="button" data-ng-click="vm.close()">Close</button></div><div class="col-12 col-md-5 mt-2 mt-md-0 ml-0" ng-hide="vm.isResultSuccess"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.saveDisabled}" data-ng-disabled="vm.saveDisabled" data-ng-dblclick="false">Confirm</button></div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/idp-sessions.html','<div data-ng-repeat="session in vm.sessionList" class="option padded-content" data-ng-class="{\'make-changes-open\': session.showMakeChange}"><div class="row justify-content-center"><div class="col-12 px-2 px-sm-5"><div ng-if="!session.isVirtualCamp" class="alert alert-info" data-ng-hide="vm.isWelcomePacketAvailable(session)" ng-bind-html="vm.getWelcomePacketNotAvailMsg(session) | unsafe"></div><div class="d-flex flex-wrap-reverse justify-content-between"><div class="flex-grow-1 page-header py-1 mr-auto pulse-session-width"><h3><div class="font-weight-light mb-2">{{::session.courseName}}</div><div class="font-weight-light mb-2 text-em-1-0" ng-show="session.isVirtualCamp"><p ng-hide="session.isCourseBundle">{{::session.termName}}</p><p ng-show="session.isCourseBundle">{{::session.sessionStart | date:\'EEE\'}} {{::session.shortTermName}}</p></div><div class="text-em-1-25">{{::session.divisionName}} - {{::session.locationName}}<br><span ng-show="session.isSquads && session.productCatalog == $root.Enums.SalesCatalogType.SquadsMultiWeek && !session.isAfterSchoolDelivery">Meets every {{::session.sessionStart | date:\'EEEE\'}} from {{::session.sessionDates}}</span> <span ng-hide="session.isSquads && session.productCatalog == $root.Enums.SalesCatalogType.SquadsMultiWeek">{{::session.sessionDates}}</span> <span ng-if="session.isAfterSchoolDelivery">Meets <span ng-bind-html="vm.getDateListFromSessionV2(session) | unsafe" class="schedule-dates"></span></span></div></h3><div ng-if="session.isVirtualCamp && !vm.hasSessionEnded(session)" class="my-3"><div ng-if="!(vm.getPrepInstructionUrl(session) == null || vm.getPrepInstructionUrl(session) == \'\')"><strong>Pre-Session Installation: </strong><a ng-href="{{ vm.getPrepInstructionUrl(session) }}" target="coursePrep">Go now</a></div><div><strong>Virtual Program Link: </strong><span ng-if="!session.releasedForRosters || (session.virtualMeetingUrl == null || session.virtualMeetingUrl == \'\')">Check back after 3pm ET / 12pm PT the day before your session.</span> <a ng-if="session.releasedForRosters && !(session.virtualMeetingUrl == null || session.virtualMeetingUrl == \'\')" ng-href="{{session.virtualMeetingUrl}}" target="vMeeting">{{session.virtualMeetingUrl}}</a></div></div><a ng-href="#{{ ::vm.licenceViewLink }}" class="btn-link" ng-if="session.hasAssignedLicense">View Course Take-Homes</a></div><div ng-if="!session.isVirtualCamp" class="mx-auto mx-lg-0 mb-2"><button class="btn btn-primary btn-md btn-block no-text-transform px-2" data-ng-class="{\'disabled\': !vm.isWelcomePacketAvailable(session)}" data-ng-disabled="!vm.isWelcomePacketAvailable(session)" data-ng-click="vm.onGoToCampClick(session)">Essential Information<span class="text-nowrap d-none d-sm-inline-block">: Get to Camp</span></button></div></div><div class="row"><div class="col-xs-12"><idp-course-options-list session="session" option-list="session.options" order-detail-id="session.orderDetailID" heading="Purchased Course Options" has-overnight="session.hasOvernight" opposite-av-chart-section="session.oppositeAvChartSection"></idp-course-options-list><hr class="short-hr"><div><strong ng-show="session.isVirtualCamp">Group with a friend</strong> <strong ng-hide="session.isVirtualCamp">Group or room with a friend</strong><div><button class="btn btn-outline-secondary no-text-transform mt-2 mb-3 px-2" data-ng-click="vm.onGroupWithClick(session)">Request / Edit</button></div></div></div><div ng-if="!session.isVirtualCamp" class="col-xs-12 bg-light"><idp-course-options session="session" option-list="session.options" order-detail-id="session.orderDetailID" heading="Available Course Options" has-overnight="session.hasOvernight" opposite-av-chart-section="session.oppositeAvChartSection"></idp-course-options></div></div><div class="row mt-3"><div class="col-12"><button class="btn btn-outline-secondary no-text-transform" data-ng-click="vm.onMakeChangeClick(session)" data-ng-show="session.isPrimaryCustomer" data-ng-disabled="session.hasPendingChanges" data-ng-class="{\'disabled\': session.hasPendingChanges}"><span class="icon" data-ng-class="{ \'icon-plus font-weight-bold\': !session.showMakeChange, \'icon-close\': session.showMakeChange}"></span> &nbsp; {{ session.showMakeChange ? \'Close\' : \'Make\'}} changes</button></div></div><div class="row my-3" data-ng-show="!session.isPrimaryCustomer"><div class="col-xs-12"><p class="text-info">Only the customer who purchased this session is able to make changes or add/remove options. Please contact Client Services for questions.</p></div></div><div ng-show="session.showMakeChange"><div class="row my-3"><div class="col-md-4 col-xl-3"><button class="btn btn-primary btn-block" data-ng-click="vm.onChangeCampClick(session)" data-ng-disabled="!session.canBeChanged || session.hasPendingChanges" data-ng-class="{\'disabled\': !session.canBeChanged || session.hasPendingChanges}">Change Camp</button></div><div class="col-md-8 col-xl-9 d-flex align-items-center mt-xs-3 mt-md-0"><span class="text-small text-muted" ng-if="!vm.pulseContext.isImpersonating">If you have questions about your camp session, please contact us at <a class="text-muted" href="tel:408-871-2227">408-871-2227</a> or email <a href="mailto: hello@iDtech.com">hello@iDtech.com</a>. </span><button class="btn btn-link text-nowrap" ng-if="vm.pulseContext.isImpersonating" data-ng-click="vm.onCancelCampClick(session)" data-ng-disabled="!session.canBeCanceled || session.hasPendingChanges" data-ng-class="{\'disabled\': !session.canBeCanceled} || session.hasPendingChanges">Cancel Camp</button></div></div><div class="row my-3 pl-md-2"><div class="col-lg-6 px-3"><div class="row"><div class="col-xs-12" ng-show="!session.hasPendingChanges"><div class="alert alert-warning" data-ng-show="vm.showChangeFeeWarning(session)" ng-bind-html="$root.StringConst.Warn_Order_ChangeFee | unsafe"></div><div class="alert alert-danger" data-ng-show="!session.canBeChanged">Online {{::vm.getChangeStatusText(session) }} for this session are no longer permitted at this date. Please contact Client Services for questions.</div></div><div class="col-xs-12" ng-show="session.hasPendingChanges"><div class="alert alert-warning">Note: You have a pending change. Go to your Shopping Cart to view and complete this change. <button class="btn btn-primary btn-block col-12 col-md-6" data-ng-click="vm.onGoShoppingCartClick()">Shopping Cart</button></div><a href="" ng-click="vm.onRemovePendingChangeClick(session)" class="btn-link">Remove pending change</a></div></div></div></div></div><div class="row mt-3"><div class="col-12"><button class="btn btn-outline-secondary no-text-transform" data-ng-show="vm.pulseContext.isImpersonating" data-ng-click="vm.onRequestVoucherCredit(session)" data-ng-if="session.isPrimaryCustomer && session.isVirtualCamp && session.canBeCanceled" data-ng-disabled="session.hasPendingChanges" data-ng-class="{\'disabled\': session.hasPendingChanges}">Request voucher credit</button></div></div></div></div><div class="row my-3"><div class="col-xs-12"><idp-session-admin order-detail-id="session.orderDetailID" student-user-id="vm.student.userID"></idp-session-admin></div></div><hr style="margin-left: -1rem; margin-right: -1rem;" data-ng-show="!$last"></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/student-info/idp-si-student.html','<div data-ng-cloak data-ng-form="{{::vm.formName}}"><fieldset ng-disabled="!vm.canUpdate"><div class="row"><div class="col-md-6"><div class="form-group"><input id="studentFirstName{{::vm.participant.userID}}" name="studentFirstName" type="text" class="form-control" placeholder="First Name" ng-model="vm.participant.firstName" ng-required="true" maxlength="100" autocomplete="off" tabindex="vm.firstTabIndex" uib-tooltip-html="vm.myForm.studentFirstName.$valid ? \'First Name\' : vm.myForm.studentFirstName.$error.required ? \'First Name is required\' : \'First Name is not valid\'" tooltip-trigger="\'focus\'" ng-disabled="!vm.pulseContext.isImpersonating"><div ng-messages="vm.myForm.studentFirstName.$error" class="text-danger"><div ng-message="required">Student first name is required</div></div></div></div><div class="col-md-6"><div class="form-group"><input id="studentLastName{{::vm.participant.userBrowsingID}}" name="studentLastName" placeholder="Last Name" autocomplete="off" uib-tooltip-html="vm.myForm.studentLastName.$valid ? \'Last Name\' : vm.myForm.studentLastName.$error.required ? \'Last Name is required\' : \'Last Name is not valid\'" tooltip-trigger="\'focus\'" type="text" class="form-control" ng-model="vm.participant.lastName" maxlength="100" ng-required="true" ng-disabled="!vm.pulseContext.isImpersonating" tabindex="vm.firstTabIndex+2"><div ng-messages="vm.myForm.studentLastName.$error" class="text-danger"><div ng-message="required">Student last name is required</div></div></div></div></div><div class="row"><div class="col-md-6" uib-tooltip="Date of Birth" tooltip-trigger="\'focus\'"><div class="row"><div class="col-12"><span class="mr-2">Date of birth:</span><div class="form-group id-required"><idp-date-picker date="vm.participant.dateOfBirth" is-edit-mode="true" is-required="true"></idp-date-picker></div></div></div><div class="row"><div class="col-12"><idp-gender gender-type-id="vm.participant.genderTypeID" is-required="true" is-edit-mode="true"></idp-gender></div></div><div class="row"><div class="col-12"><div class="form-group has-feedback"><input id="studentNickName{{::vm.participant.userID}}" name="nickName" class="form-control" type="text" placeholder="Student\'s Preferred Name" uib-tooltip="Student\'s Preferred Name" tooltip-trigger="\'focus\'" maxlength="13" data-ng-model="vm.participant.nickName" tabindex="vm.firstTabIndex+4"> <i class="icon icon-info feedback-icon" ng-click="vm.showNickNameHelp()"></i></div></div></div><div class="row"><div class="col-12"><span id="tshirtHelpText" class="form-text text-muted">Note: T-shirts are unisex and listed in U.S. sizes.</span><div class="form-group has-feedback"><select id="teeShirtSize{{vm.participant.userID}}" name="teeShirtSizeTypeID" class="form-control rounded-right-0" data-ng-model="vm.participant.teeShirtSizeTypeID" data-ng-options="item.typeID as item.typeString for item in vm.teeShirtSizeTypes" uib-tooltip-html="vm.myForm.teeShirtSizeTypeID.$valid ? \'T-Shirt Size\' : vm.myForm.teeShirtSizeTypeID.$error.required ? \'T-Shirt Size is required\' : \'T-Shirt Size is not valid\'" tooltip-trigger="\'focus\'" ng-required="vm.isTShirtSizeRequired" aria-describedby="tshirtHelpText" tabindex="vm.firstTabIndex+6"><option value="" selected="selected">T-Shirt Size</option></select> <i class="icon icon-info feedback-icon mr-6" ng-click="vm.showTeeShirtHelp()"></i><div ng-messages="vm.myForm.teeShirtSizeTypeID.$error" class="text-danger"><div ng-message="required">T-Shirt Size is required</div></div></div></div></div><div class="row" ng-if="vm.pulseContext.isImpersonating"><div class="col-md-6"><span class="mr-2">VIP or related to VIP?</span><div class="form-group has-feedback"><select id="vIPTypeID{{vm.participant.userID}}" name="vIPTypeID" class="form-control rounded-right-0" data-ng-model="vm.participant.vIPTypeID" data-ng-options="item.typeID as item.typeString for item in vm.VIPTypes" uib-tooltip="VIP or related to VIP?" tooltip-trigger="\'focus\'" tabindex="vm.firstTabIndex+7"><option value="" selected="selected"></option></select></div></div></div></div><div class="col-md-6" ng-if="vm.pulseContext.isImpersonating"><div class="row"><div class="col-12">Current Level: {{::(vm.participant.userXPLevelTypeString ? vm.participant.userXPLevelTypeString : \'N/A\')}}</div></div><div class="row"><div class="col-12">Accumulated Points: {{::(vm.participant.userXPTotalCredits ? vm.participant.userXPTotalCredits : \'N/A\')}}</div></div><div class="row"><div class="col-12">Points till next Level: {{::(vm.participant.userXPCreditsNeededForNextLevel ? vm.participant.userXPCreditsNeededForNextLevel : \'N/A\')}}</div></div></div></div><div class="row"><div class="col-md-8 col-sm-2"></div><div class="col-md-3 col-sm-8"><button type="button" class="btn btn-primary btn-block" ng-disabled="!vm.myForm.$dirty || !vm.canUpdate || vm.myForm.$invalid || vm.submitted" ng-click="vm.save()">Save</button></div></div></fieldset></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/terms-and-conditions/idp-tac-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><h4>iD Tech Camps Terms & Conditions</h4></div><div class="modal-body"><div ng-bind-html="vm.termsAndConditionContent | unsafe"></div><div class="container"><div class="center-block" style="max-width:600px;"><div class="checkbox"><input name="agreedToTermsAndConditions" id="agreedToTermsAndConditions" type="checkbox" ng-model="vm.agreedToTermsAndConditions"> <label for="agreedToTermsAndConditions"><span class="spa-check"></span> <span class="spa-box"></span></label> <span class="modal-content-padded">By checking this box, I <b>agree</b> to iD Tech Camps\' Terms & Conditions.</span></div></div></div><div class="row"><div class="col-sm-12 col-md-2 col-md-push-5"><button ng-disabled="!vm.agreedToTermsAndConditions" class="btn btn-change btn-block" type="button" data-ng-click="vm.acceptAndClose()">Accept and Close</button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/www-top-nav/idp-www-top-nav.html','<h2>Name {{vm.firstName}}</h2>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/top-nav/idp-top-nav.html','<div id="welcome"><div class="row"><div class="col-md-8 pt-5"><h3 class="font-weight-normal mb-0">Welcome, {{vm.firstOrUserName}}!</h3><a class="logout" href="" ng-click="vm.onLogoutClick()" data-ng-if="!vm.pulseContext.isImpersonating">Logout</a></div><div class="col-md-4"><div class="row my-3"><a class="col-3 d-flex align-items-center flex-column spa-cursor-pointer" ng-class="vm.selected === vm.TopNavItemType.Home ? \'text-primary\': \'text-secondary\'" ng-if="vm.showHome" href="#/my-account"><span class="icon icon-home icon-large"></span> <span class="mt-1">Home</span> </a><a class="col-3 d-flex align-items-center flex-column spa-cursor-pointer" ng-class="vm.selected === vm.TopNavItemType.Forms ? \'text-primary\': \'text-secondary\'" ng-if="vm.showForms" href="#/my-account/profile/requiredForms"><span class="icon icon-file-text2 icon-large"></span> <span class="mt-1">Forms</span> </a><a class="col-3 d-flex align-items-center flex-column spa-cursor-pointer" ng-class="vm.selected === vm.TopNavItemType.Billing ? \'text-primary\': \'text-secondary\'" ng-if="vm.showBilling" href="#/my-account/billing"><span class="icon icon-tuition icon-large"></span> <span class="mt-1">Billing</span> </a><a class="col-3 d-flex align-items-center flex-column spa-cursor-pointer" ng-class="vm.selected === vm.TopNavItemType.Profile ? \'text-primary\': \'text-secondary\'" ng-if="vm.showProfile" href="#/my-account/profile"><span class="icon icon-badge icon-large"></span> <span class="mt-1">Profile</span></a></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/home.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts ng-show="vm.alertList && vm.alertList.length > 0" alert-list="vm.alertList"></idp-alerts></div><div ng-show="vm.canSee" class="home"><div class="container"><idp-my-students student-list="vm.studentList" can-update="vm.canUpdate"></idp-my-students><idp-footer can-see-refer-a-friend="vm.canSeeReferAFriend" has-refer-a-friend="vm.hasReferAFriend" can-update="vm.canUpdate"></idp-footer></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/semPurchase.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts></div><div class="container" style="min-height: 350px;" ng-if="vm.canSee"><h3 class="pt-6">SEM Products</h3><div ng-repeat="p in vm.products" class="alternative-row"><div class="py-3 px-md-3 px-2"><div class="card-heading" id="heading{{::p.userID}}"><div class="d-flex flex-column flex-lg-row justify-content-between vertical-align mb-0"><div><h4 class="d-inline-block"><span class="course-name">{{::p.name}}</span></h4><span class="ml-1">({{::p.shortName}})</span> <span class="ml-1">Ages: {{::p.minimumAge}} - {{::p.maximumAge}}</span> <span class="ml-2 font-weight-bold">{{p.price| currency:\'$\':0}}</span></div><div class="d-flex align-items-center"><button class="btn btn-primary btn-sm text-nowrap" ng-click="vm.navigate(p);">Select</button></div></div></div></div></div><div class="py-3" ng-show="vm.products && vm.products.length == 0">No products found</div></div><div class="container mb-10" ng-if="!vm.canSee"><h4 class="text-danger">You don\'t have permission to view the page.</h4></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/terms-and-conditions.html','<div class="container"><h2>iD Tech Terms & Conditions</h2><hr><form name="frmSignature" role="form" novalidate><div class="row"><div class="col-12"><div class="form-check"><input id="agreeToESigAndTandC" name="agreeToESigAndTandC" type="checkbox" ng-model="vm.agreeToESigAndTandC" class="form-check-input"> <label for="agreeToESigAndTandC" class="form-check-label">I agree to the\xA0<a ng-click="vm.showTermsAndConditions()" href="">Terms & Conditions</a>\xA0for iD Tech. I agree to use electronic signatures and agree that my electronic signature has the same legal effect as a written signature.</label></div></div></div><div class="row" ng-show="vm.submitted && !vm.agreeToESigAndTandC"><div class="col-md-12"><span class="text-danger">Agreeing by checking the checkbox is required to continue.</span></div></div><div class="container justify-content-center" style="max-width:700px;"><div class="row" ng-show="vm.agreeToESigAndTandC" style="margin-top:10px;"><div class="col-md-6"><div class="form-group"><label class="sr-only" for="firstName">First Name</label> <input name="firstName" type="text" class="form-control" placeholder="First Name" ng-model="vm.esigFirstName" ng-required="true" maxlength="200" autocomplete="given-name" uib-tooltip="First Name" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmSignature.firstName.$error" class="text-danger"><div ng-message="required">First Name is required</div><div ng-message="maxlength">The first name field must be 200 characters or less</div></div></div></div><div class="col-md-6"><div class="form-group"><label class="sr-only" for="lastName">Last Name</label> <label class="sr-only" for="middleInit">Middle Initial</label> <input name="middleInit" type="text" class="form-control" placeholder="Middle Initial" ng-model="vm.esigMiddleInit" maxlength="50" autocomplete="additional-name" uib-tooltip="Middle Initial" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmSignature.middleInit.$error" class="text-danger"><div ng-message="maxlength">The middle initial field must be 50 characters or less</div></div></div></div></div><div class="row" ng-show="vm.agreeToESigAndTandC"><div class="col-md-6"><div class="form-group"><input name="lastName" type="text" class="form-control" placeholder="Last Name" ng-model="vm.esigLastName" ng-required="true" maxlength="200" autocomplete="family-name" uib-tooltip="Last Name" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmSignature.lastName.$error" class="text-danger"><div ng-message="required">Last Name is required</div><div ng-message="maxlength">The last name field must be 200 characters or less</div></div></div></div><div class="col-md-6"><div class="form-group"><label class="sr-only" for="lastName">Suffix</label> <input name="suffix" type="text" class="form-control" placeholder="Suffix" ng-model="vm.esigSuffix" maxlength="50" autocomplete="off" uib-tooltip="Suffix" tooltip-trigger="\'focus\'"><div ng-messages="vm.frmSignature.suffix.$error" class="text-danger"><div ng-message="maxlength">The suffix field must be 50 characters or less</div></div></div></div></div><div class="row" style="margin-top:5px;margin-bottom:15px;"><div class="d-none d-md-block col-md-6">&nbsp;</div><div class="col-12 col-md-6"><button class="btn btn-primary btn-block" ng-click="vm.acceptAndClose()">Accept and Close</button></div></div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/welcome-letter.html','<div class="container"><div class="row"><div class="col-12" ng-bind-html="vm.welcomeLetterContent | unsafe"></div></div><div class="row my-6 justify-content-center"><div class="col-12 col-md-4"><button ng-click="vm.proceed();" class="btn btn-primary btn-block">Continue</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/old-pulse-pages/getFileAspx.html','<div class="my-account home" style="margin-bottom:3em;"><div class="container"><idp-iframe style="visibility:hidden;" frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)" show-wait-spinner="vm.showWaitSpinner" api="vm.iFrameAPI"></idp-iframe></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/term-staff/termStaffHome.html','<div class="my-account" style="margin: 0px 1.0em 0px 0.5em;"><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-auth-contacts.html','<h3>Authorized Pick-up/Contacts</h3><hr><form id="myForm" name="myForm" role="form" ng-submit="vm.submit()" novalidate><div class="row"><div class="col-12"><p><strong>Besides the emergency contacts, who else is authorized to pick up your student from camp?</strong></p></div></div><div class="row my-3" ng-repeat="contact in filtered = (vm.authPickupContacts | filter:{recordStateID:$root.Enums.RecordStateType.Active})" ng-form="contact{{$index}}" id="contact{{$index}}" ng-init="vm.firstTabIndex = vm.firstTabIndex + 10"><div class="col-md-9"><div><div class="d-flex justify-content-between"><strong class="mt-1">{{contact.name || \'Authorized Contact\'}}</strong> <button ng-if="vm.canCreate || vm.canUpdate" type="button" class="btn btn-link text-danger pt-0 pr-0" ng-click="vm.removeAuthContact(contact)">Delete Contact</button></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="sr-only" for="contactName">Authorized Pick-Up Name</label> <input type="text" class="form-control" name="contactName" placeholder="Authorized Pick-Up Name" uib-tooltip="Authorized Pick-Up Name" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+$index}}" maxlength="200" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="contact.name"><div ng-messages="vm.myForm[\'contact\' + $index].contactName.$error" class="text-danger"><div ng-message="required">Authorized Pick-Up Name is required</div></div></div></div><div class="col-md-6"><div class="form-group"><label class="sr-only" for="relationshipToUser">Your relationship to student</label> <input type="text" class="form-control" name="relationshipToUser" placeholder="Your relationship to student" uib-tooltip="Your relationship to the student" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+$index+1}}" maxlength="200" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="contact.relationshipToUser"><div ng-messages="vm.myForm[\'contact\' + $index].relationshipToUser.$error" class="text-danger"><div ng-message="required">Your relationship to the student is required</div></div></div></div></div><div class="row" ng-repeat="phone in contact.formPersonContactMethods"><div class="col-md-5 col-lg-4 col-xl-3"><div class="form-group"><label class="sr-only" for="phoneType">Phone Type</label> <select name="phoneType" class="form-control" placeholder="Primary Phone Type" uib-tooltip="Primary Phone Type" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+$index+2}}" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="phone.contactMethodTypeID" ng-options="t.typeID as t.typeString for t in vm.phoneContactMethodTypes"><option value="" disabled="disabled">Phone Type</option></select><div ng-messages="vm.myForm[\'contact\' + $parent.$index].phoneType.$error" class="text-danger"><div ng-message="required">Phone type is required</div></div></div></div><div class="col-md-6 col-lg-5"><div class="form-group"><idp-intl-tel-input country-code="phone.countryCode" phone-number="phone.number" is-required="true" is-readonly="vm.canCreate || !vm.canUpdate" is-edit-mode="true" first-tab-index="vm.firstTabIndex+$index+3" phone-number-place-holder="Phone Number {{$index+1}}"></div></div></div></div></div></div><div class="row my-3" ng-show="vm.authPickupContacts.length > 0"><div class="col-12"><h3>Additional Authorized Pick-up/Contacts</h3><hr></div></div><div class="row my-3"><div class="col-md-5 col-lg-4"><button type="button" class="btn btn-primary btn-block no-text-transform" ng-click="vm.addAuthContact()" ng-disabled="!vm.canCreate || !vm.canUpdate"><span class="icon icon-plus mr-2 font-weight-bold"></span>Add authorized contact</button></div></div><idp-hsf-authorization user-form-detail="vm.userFormDetail" ng-if="vm.myForm.$dirty && vm.userFormDetail.statusTypeID == $root.Enums.FormStatus.Complete"></idp-hsf-authorization><div class="row my-3"><div class="col-md-3 offset-md-6"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.onBackClick()">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Back\' : \'Cancel\'}}</button></div><div class="col-md-3 pt-3 pt-md-0"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.submitted}" data-ng-disabled="vm.submitted" data-ng-dblclick="false">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Save &amp; Continue\' : \'Submit\'}}</button></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-authorization.html','<div ng-form="{{::vm.formName}}" class="row my-3"><div class="col-12"><div class="row"><div class="col-12"><h3>Authorization</h3><hr></div></div><div class="row"><div class="col-sm-11"><div class="form-check" ng-click="vm.iCovidExposure = !vm.iCovidExposure"><input type="checkbox" class="form-check-input form-control" name="chkCovidExposure" ng-model="vm.iCovidExposure" ng-required="true"> <label class="form-check-label ml-5" for="chkCovidExposure">I understand there remains a risk of injury and/or illness including exposure to COVID-19 regardless of any precautions taken.</label></div></div></div><div class="row"><div class="col-sm-11"><div class="form-check" ng-click="vm.iAuthMedical = !vm.iAuthMedical"><input type="checkbox" class="form-check-input form-control" name="chkAuthMedical" ng-model="vm.iAuthMedical" ng-required="true"> <label class="form-check-label ml-5" for="chkAuthMedical">I authorize iD Tech Staff to attend to any medical issues my student may incur while participating in an iD Tech program, including providing basic first aid, administering authorized medications, and seeking emergency medical care.</label></div></div></div><div class="row"><div class="col-sm-11"><div class="form-check" ng-click="vm.iPickupStudent = !vm.iPickupStudent"><input type="checkbox" class="form-check-input form-control" name="chkPickupStudent" ng-model="vm.iPickupStudent" ng-required="true"> <label class="form-check-label ml-5" for="chkPickupStudent">I agree to have the ability to have my student picked up within four hours of notification should my student need to leave camp for any reason.</label></div></div></div><div class="row"><div class="col-sm-11"><div class="form-check" ng-click="vm.iFinResponsible = !vm.iFinResponsible"><input type="checkbox" class="form-check-input form-control" name="chkFinResponsible" ng-model="vm.iFinResponsible" ng-required="true"> <label class="form-check-label ml-5" for="chkFinResponsible">I agree to be financially responsible for all medical treatment needed by my student during the program.</label></div></div></div><div class="row"><div class="col-sm-11"><div class="form-check" ng-click="vm.iUnderstand = !vm.iUnderstand"><input type="checkbox" class="form-check-input form-control" name="chkIUnderstand" ng-model="vm.iUnderstand" ng-required="true"> <label class="form-check-label ml-5" for="chkIUnderstand">I understand that it is my responsibility to update the Health and Wellness priorities section of this form if my child begins taking medications or if there are changes to current medications.</label></div></div></div><div class="row"><div class="col-sm-11"><div class="form-check" ng-click="vm.iCertify = !vm.iCertify"><input type="checkbox" class="form-check-input form-control" name="chkICertify" ng-model="vm.iCertify" ng-required="true"> <label class="form-check-label ml-5" for="chkICertify">By signing this form, it certifies that I, the Parent/Guardian (whose name is displayed on page 1), ensure that all information is up-to-date and accurate.</label></div></div></div><div class="row"><div class="col-md-4 mt-3"><div class="form-group"><label class="sr-only" for="parentGuardianName">Parent/Guardian Name</label> <input type="text" class="form-control" name="parentGuardianName" placeholder="Parent/Guardian Name" uib-tooltip="Parent/Guardian Name" tooltip-trigger="\'focus\'" maxlength="200" ng-required="true" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.userFormDetail.signature"><div ng-messages="vm.myForm.parentGuardianName.$error" class="text-danger" ng-show="vm.myForm.$submitted"><div ng-message="required">Parent/Guardian name is required</div></div></div></div></div><div class="row" ng-show="vm.userFormDetail.submittedDate && vm.showSubmissionHistory"><div class="col-12 mt-2">Last submitted on: {{ vm.userFormDetail.submittedDate | date : \'MMM d, y h:mm:ss a\' }}</div></div><div class="row my-3" ng-show="vm.showSubmissionHistory && vm.isFormComplete" ng-click="vm.submissionHistoryClick()"><div class="col-12 id-panel-group" id="historyAccordion"><div class="card"><div class="card-header" id="historyHeading" ng-click="isHistoryCollapsed = !isHistoryCollapsed" ng-class="{\'collapsed\': !isHistoryCollapsed}"><div class="card-title row vertical-align"><div class="icon-container"><span class="icon icon-plus" ng-show="isHistoryCollapsed"></span> <span class="icon icon-minus" ng-hide="isHistoryCollapsed"></span></div><div class="content"><h4>Health & Safety Form Submission History</h4></div></div></div><div id="historyBody" class="panel-collapse" uib-collapse="!isHistoryCollapsed" ng-show="vm.submissionHistory && vm.submissionHistory.length > 0 && vm.submissionHistoryLoaded"><div class="card-body"><table class="table table-sm d-sm-none"><thead><tr><th class="col-md-3">Updated By</th><th class="col-md-3">Date/Time</th><th class="col-md-2">Signature</th></tr></thead><tbody><tr ng-repeat="submission in vm.submissionHistory track by submission.userFormVersionID"><td>{{submission.updatedByFullName}}</td><td>{{submission.submissionDate | date : \'MMM d, y h:mm:ss a\'}}</td><td>{{submission.signature}}</td></tr></tbody></table><div class="pt-3 pt-md-0" ng-repeat="submission in vm.submissionHistory track by submission.userFormVersionID"><dl><dt>Updated By</dt><dd>{{submission.updatedByFullName}}</dd><dt>Date</dt><dd>{{submission.submissionDate | date : \'MMM d, y h:mm:ss a\'}}</dd><dt>Parent/Guardian Name</dt><dd>{{submission.signature}}</dd></dl></div></div></div></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-check-out.html','<h3>Checkout Policy</h3><hr><form id="myForm" name="myForm" role="form" ng-submit="vm.submit()" idp-form-focus-on-err novalidate><div class="row" ng-if="vm.participantIsTeen"><div class="col-12"><p><strong>Teen Sign-Out Policy - No Code Word Needed:</strong> Commuting teens will sign out with our staff at the end of each day. Overnight students may only sign themselves out at the end of each program week. If a student needs to be checked out at times other than the standard pickup times, then a parent/guardian must contact the Camp Director to make arrangements. Once a student signs out they are no longer in our care. Students, if requested, can be escorted by our staff to the designated camp pick-up location.</p></div></div><div class="row" ng-if="!vm.participantIsTeen"><div class="col-12"><p><strong>Selecting \'Yes\' authorizes your preteen to sign him/herself out of camp.</strong></p><div class="row"><div class="col-md-4"><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedYesNoTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="!vm.participantIsTeen" required-message="Please select Yes or No" vertical-layout="false" tooltip="Self-signout Authorization" max="1" ng-click="vm.yesNoClick();"></div></div><div class="row my-3" ng-if="!vm.reqdFormContent.canSelfSignOut  && vm.selectedYesNoTypes.length > 0"><div class="col-12"><strong>Code Word</strong><p>Pick-up person MUST provide this Code Word in order for iD Staff to release your preteen student.</p><div class="row"><div class="col-md-4"><div class="form-group"><label class="sr-only" for="codeWord">Code Word</label> <input type="text" class="form-control" name="codeWord" placeholder="Code Word" uib-tooltip="Code Word" tooltip-trigger="\'focus\'" ng-required="!vm.participantIsTeen && !vm.reqdFormContent.canSelfSignOut" maxlength="10" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.reqdFormContent.pickupCode"><div ng-messages="vm.myForm.codeWord.$error" class="text-danger"><div ng-message="required">Code Word is required</div></div><span class="form-text">(10 characters or less)</span></div></div></div></div></div><div class="row my-3 vertical-align" ng-if="vm.reqdFormContent.canSelfSignOut"><div class="col-12"><div class="form-check"><input type="checkbox" id="selfSignOutAuth" name="selfSignOutAuth" class="form-check-input" ng-model="vm.reqdFormContent.approveSelfSignOut" ng-required="!vm.participantIsTeen && vm.reqdFormContent.canSelfSignOut" ng-disabled="!vm.canCreate || !vm.canUpdate"> <label for="selfSignOutAuth" class="form-check-label"><div>I agree that my preteen student (turns 13 years of age by December 31st of the year) can sign himself/herself out of camp and I understand the following applies. He/she can sign himself/herself out with staff after 5 PM Monday through Thursday and after 3 PM on Friday, unless attending an overnight program. Once my student signs out, they will no longer be in the care of iD Tech. Students signed up for an Overnight program may only sign themselves out at 3 PM Friday. If my student needs to be checked out at times other than the standard pickup times, then I must contact the Camp Director to make arrangements.</div></label></div></div></div><div class="row"><div class="col-12"><div ng-messages="vm.myForm.selfSignOutAuth.$error" class="text-danger" ng-show="vm.myForm.$submitted"><div ng-message="required">You must agree to the self-signout policy</div></div></div></div></div></div><idp-hsf-authorization user-form-detail="vm.userFormDetail" ng-if="vm.myForm.$dirty && vm.userFormDetail.statusTypeID == $root.Enums.FormStatus.Complete"></idp-hsf-authorization><div class="row my-3"><div class="col-md-3 offset-md-6"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.onBackClick()">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Back\' : \'Cancel\'}}</button></div><div class="col-md-3 pt-3 pt-md-0"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.submitted}" data-ng-disabled="vm.submitted" data-ng-dblclick="false">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Save &amp; Continue\' : \'Submit\'}}</button></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-covid.html','<strong>COVID-19 vaccination status question(s) is included.</strong> <em>Note</em>: This information is collected in the event that a location provider requires it be collected to be on their campus, and/or a regulatory agency requests it as a requirement to operate in their jurisdiction.<ul ng-hide="vm.hideDetails"><li class="text-danger mt-3">iD Tech highly recommends that students be vaccinated against COVID-19 for their own and other participants\' sake prior to arrival at camp.</li><li class="text-danger mt-3">There are locations where all students will be required to be vaccinated by the location provider and/or a regulatory agency to attend. If this applies to you, you will be notified via email and in your My Account of the requirements and next steps.</li></ul>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-emergency-contacts.html','<h3>Emergency Contact Information</h3><p class="text-danger mt-3">If for any reason (including illness) your student needs to leave camp, you will be called and you MUST have the ability to have your student picked up within four (4) hours of receiving the call.</p><p class="text-danger mt-3">Two DIFFERENT phone numbers are HIGHLY RECOMMENDED per emergency contact.</p><p ng-show="vm.formPersonRole == vm.primaryContactEnumValue">In case of an emergency, please ensure that this contact is reachable 24 hours a day at the phone numbers provided. Calls from iD Tech will have a "408" or "669" area code. International parents will see these numbers after the country code of "001".</p><hr><form id="myForm" name="myForm" role="form" ng-submit="vm.submit()" idp-form-focus-on-err novalidate><div class="row my-3"><div class="col-12"><strong><span ng-show="vm.formPersonRole == vm.primaryContactEnumValue">Primary Contact (Parent/Guardian)</span> <span ng-show="vm.formPersonRole == vm.secondaryContactEnumValue">Secondary Contact</span></strong><div ng-show="vm.formPersonRole == vm.secondaryContactEnumValue" class="mt-2">In case we cannot reach the primary contact, please provide a second emergency contact below (example: other parent, a grandparent, a friend).</div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label class="sr-only" for="contactName">Contact Name</label> <input name="contactName" class="form-control" placeholder="Contact Name" uib-tooltip="Contact Name" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex}}" maxlength="300" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.name"><div ng-messages="vm.myForm.contactName.$error" class="text-danger"><div ng-message="required">Contact name is required</div></div></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="relationshipToStudent">Your relationship to student</label> <input type="text" class="form-control" name="relationshipToStudent" placeholder="Your relationship to student" uib-tooltip="Your relationship to the student" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+1}}" maxlength="200" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.relationshipToUser"><div ng-messages="vm.myForm.relationshipToStudent.$error" class="text-danger"><div ng-message="required">Your relationship to the student is required</div></div></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="email">Email Address</label> <input name="email" class="form-control" type="email" placeholder="Email Address" uib-tooltip="Email Address" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+2}}" maxlength="200" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.emailAddress"><div ng-messages="vm.myForm.email.$error" class="text-danger"><div ng-message="required">Email is required</div><div ng-message="email">Please enter a valid Email address</div></div></div></div></div><div class="row my-3"><div class="col-12"><strong>Primary Phone Number</strong></div></div><div class="row"><div class="col-md-4 col-lg-3 col-xl-2"><div class="form-group"><select name="primaryPhoneType" class="form-control" placeholder="Primary Phone Type" uib-tooltip="Primary Phone Type" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+3}}" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.primaryPhone.contactMethodType" ng-options="t.typeString for t in vm.phoneContactMethodTypes track by t.typeID"><option value="" disabled="disabled" selected="selected">Phone Type</option></select><div ng-messages="vm.myForm.primaryPhoneType.$error" class="text-danger"><div ng-message="required">Phone type is required</div></div></div></div><div class="col-md-5 col-lg-4"><div class="form-group"><idp-intl-tel-input country-code="vm.emergencyContact.primaryPhone.countryCode" phone-number="vm.emergencyContact.primaryPhone.number" is-required="true" is-readonly="!vm.canCreate || !vm.canUpdate" is-edit-mode="true" first-tab-index="vm.firstTabIndex+4" phone-number-place-holder="{{vm.emergencyContact.primaryPhone.contactMethodType.typeString}} Number"></div></div></div><div class="row my-3"><div class="col-12"><strong>Secondary Phone Number</strong><div class="info">Alternate number from primary number is best. If you only have one phone number, you can use primary number again.</div></div></div><div class="row"><div class="col-md-4 col-lg-3 col-xl-2"><div class="form-group"><select name="secondaryPhoneType" class="form-control" placeholder="Secondary Phone Type" uib-tooltip="Secondary Phone Type" tooltip-trigger="\'focus\'" ng-required="true" tabindex="{{::vm.firstTabIndex+11}}" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.secondaryPhone.contactMethodType" ng-options="t.typeString for t in vm.phoneContactMethodTypes track by t.typeID"><option value="" disabled="disabled" selected="selected">Phone Type</option></select><div ng-messages="vm.myForm.secondaryPhoneType.$error" class="text-danger"><div ng-message="required">Phone type is required</div></div></div></div><div class="col-md-5 col-lg-4"><div class="form-group"><idp-intl-tel-input country-code="vm.emergencyContact.secondaryPhone.countryCode" phone-number="vm.emergencyContact.secondaryPhone.number" is-required="true" is-readonly="!vm.canCreate || !vm.canUpdate" is-edit-mode="true" first-tab-index="vm.firstTabIndex+12" hone-number-place-holder="{{vm.emergencyContact.secondaryPhone.contactMethodType.typeString}} Number"></div></div></div><div ng-show="vm.emergencyContact.formRoleTypeID == vm.primaryContactEnumValue"><div class="row my-3"><div class="col-12"><strong>Address</strong></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label class="sr-only" for="country">Country</label> <select class="form-control" name="country" placeholder="Country" uib-tooltip="Country" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+21}}" ng-required="vm.emergencyContact.formRoleTypeID == vm.primaryContactEnumValue" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.address.countryType" ng-options="t.typeString for t in vm.countryTypes track by t.typeID"><option value="" disabled="disabled" selected="selected">Country</option></select><div ng-messages="vm.myForm.country.$error" class="text-danger"><div ng-message="required">Country is required</div></div></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="address1">Address Line 1</label> <input type="text" class="form-control" name="address1" placeholder="Address Line 1" uib-tooltip="Address Line 1" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+22}}" ng-required="vm.emergencyContact.formRoleTypeID == vm.primaryContactEnumValue" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.address.address1"><div ng-messages="vm.myForm.address1.$error" class="text-danger"><div ng-message="required">Address Line 1 is required</div></div></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="address2">Address Line 2</label> <input type="text" class="form-control" name="address2" placeholder="Address Line 2" uib-tooltip="Address Line 2" tooltip-trigger="\'focus\'" ng-required="false" tabindex="{{::vm.firstTabIndex+23}}" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.address.address2"></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label class="sr-only" for="city">City</label> <input type="text" class="form-control" name="city" placeholder="City" uib-tooltip="City" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+24}}" ng-required="vm.emergencyContact.formRoleTypeID == vm.primaryContactEnumValue" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.address.city"><div ng-messages="vm.myForm.city.$error" class="text-danger"><div ng-message="required">City is required</div></div></div></div><div class="col-md-4"><div class="form-group" ng-if="vm.emergencyContact.address.countryType.typeID != $root.Enums.CountryType.USA"><label class="sr-only" for="stateprovince">State/Province</label> <input type="text" class="form-control" name="stateprovince" placeholder="State/Province" uib-tooltip="State/Province" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+25}}" ng-required="(vm.emergencyContact.formRoleTypeID == vm.primaryContactEnumValue) && (vm.emergencyContact.address.countryType.typeID != $root.Enums.CountryType.USA)" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.address.state"><div ng-messages="vm.myForm.stateprovince.$error" class="text-danger"><div ng-message="required">State/Province is required</div></div></div><div class="form-group" ng-if="vm.emergencyContact.address.countryType.typeID == $root.Enums.CountryType.USA"><label class="sr-only" for="state">State</label> <select class="form-control" name="state" placeholder="State" uib-tooltip="State" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+26}}" ng-required="(vm.emergencyContact.formRoleTypeID == vm.primaryContactEnumValue) && (vm.emergencyContact.address.countryType.typeID == $root.Enums.CountryType.USA)" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.address.stateType" ng-options="t.typeString for t in vm.stateTypes track by t.typeID"><option value="" disabled="disabled" selected="selected">State</option></select><div ng-messages="vm.myForm.state.$error" class="text-danger"><div ng-message="required">State is required</div></div></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="postalCode">Zip/Postal Code</label> <input type="text" class="form-control" name="postalCode" placeholder="Zip/Postal Code" uib-tooltip="Zip/Postal Code" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex+27}}" ng-required="vm.emergencyContact.formRoleTypeID == vm.primaryContactEnumValue" maxlength="20" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.emergencyContact.address.postalCode"><div ng-messages="vm.myForm.postalCode.$error" class="text-danger"><div ng-message="required">Zip/Postal Code is required is required</div></div></div></div></div></div><idp-hsf-authorization user-form-detail="vm.userFormDetail" ng-if="vm.myForm.$dirty && vm.userFormDetail.statusTypeID == $root.Enums.FormStatus.Complete"></idp-hsf-authorization><div class="row my-3"><div class="col-md-3 offset-md-6"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.onBackClick()">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Back\' : \'Cancel\'}}</button></div><div class="col-md-3 pt-3 pt-md-0"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.submitted}" data-ng-disabled="vm.submitted" data-ng-dblclick="false">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Save &amp; Continue\' : \'Submit\'}}</button></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-health-history.html','<h3>Health History</h3><hr><form id="myForm" name="myForm" role="form" ng-submit="vm.submit()" idp-form-focus-on-err novalidate><div class="row"><div class="col-12"><div class="row"><div class="col-12 col-md-6"><p><strong>Does your student have any past/current medical condition that would require special attention or should restrict any activity?</strong></p><div class="info">(Chronic illness, recent infectious disease, recent injury, asthma, diabetes, seizures, behavioral or emotional health issues, etc.)</div><p></p><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedHasMedConditionsTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="true" required-message="Please select Yes or No" vertical-layout="false" max="1" ng-click="vm.hasMedConditionsYesNoClick()"></div></div><div class="row my-3" ng-if="vm.reqdFormContent.hasMedConditions"><div class="col-12 col-md-6"><p>Please explain:</p><div class="form-group"><textarea class="form-control" name="medConditions" ng-placeholder="Explanation of Medical Condition" uib-tooltip="Explanation of Medical Condition" tooltip-trigger="\'focus\'" ng-required="true" maxlength="1500" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.reqdFormContent.medConditions"></textarea><div ng-messages="vm.myForm.medConditions.$error" class="text-danger"><div ng-message="required">Explanation of Medical Condition is required</div></div></div></div></div></div></div><div class="row my-3"><div class="col-12"><div class="row my-3"><div class="col-12 col-md-6"><p><strong>My student has allergies and/or other dietary restrictions</strong></p><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedAllergyDietaryRestTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="true" required-message="Please select Yes or No" vertical-layout="false" max="1" ng-click="vm.allergyDietaryRestYesNoClick()"></div></div><div class="row my-3" ng-if="vm.reqdFormContent.allergyDietaryRest"><div class="col-12 col-md-6"><div><p><strong>Please select all known allergies:</strong></p><div ng-repeat="a in vm.allergyTypes" ng-if="vm.userFormAllergies" ng-form="allergy{{$index}}"><div class="row my-3"><div class="col-12 col-md-5"><button type="button" class="btn btn-primary btn-block" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-class="vm.isAllergySelected(a) ? \'btn-primary\' : \'btn-light\'" ng-click="vm.toggleAllergySelected(a)"><span class="text-capitalize">{{a.typeString}}</span></button></div><div class="col-10 offset-md-1 col-md-6 py-3" ng-if="vm.isAllergySelected(a)"><rzslider class="mt-0" rz-slider-model="vm.getAllergyForType(a).severityTypeID" rz-slider-options="vm.sliderOptions" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-click="vm.setFormDirty();"></rzslider></div></div><div class="row my-3" ng-if="vm.isAllergySelected(a)"><div class="col-12"><div class="form-group"><textarea class="form-control" name="allergyDescription" ng-placeholder="{{vm.getPlaceholderTextForAllergyType(a)}}" uib-tooltip="{{a.typeString}}: Severity/Reaction" tooltip-trigger="\'focus\'" ng-required="vm.isAllergySelected(a)" maxlength="1000" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model-options="{ getterSetter: true, allowInvalid: \'true\' }" ng-model="vm.getAllergyForType(a).allergyDescription" ng-pattern="vm.asciiOnlyRegExp"></textarea><div ng-messages="vm.myForm[\'allergy\' + $index].allergyDescription.$error" class="text-danger"><div ng-message="required">Description of severity/reaction is required</div><div ng-message="pattern">{{vm.asciiOnlyRegExpErrorMsg}}</div></div></div></div></div></div></div></div></div><div class="row" ng-if="vm.reqdFormContent.allergyDietaryRest"><div class="col-md-6"><div><p><strong>Please provide details of any dietary restrictions:</strong></p><div class="form-group"><textarea class="form-control" name="dietaryComment" ng-placeholder="Please describe (Vegan, Vegetarian, Fruitarian, Plant-based, Gluten Free, etc.) (1000 Characters Maximum)" uib-tooltip="Dietary Restrictions" tooltip-trigger="\'focus\'" maxlength="1000" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.reqdFormContent.dietaryComment" ng-model-options="{ allowInvalid: \'true\' }" ng-pattern="vm.asciiOnlyRegExp"></textarea><div ng-messages="vm.myForm.dietaryComment.$error" class="text-danger"><div ng-message="pattern">{{vm.asciiOnlyRegExpErrorMsg}}</div></div></div></div></div></div></div></div><idp-hsf-authorization user-form-detail="vm.userFormDetail" ng-if="vm.myForm.$dirty && vm.userFormDetail.statusTypeID == $root.Enums.FormStatus.Complete"></idp-hsf-authorization><div class="row my-3"><div class="col-md-3 offset-md-6"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.onBackClick()">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Back\' : \'Cancel\'}}</button></div><div class="col-md-3 pt-3 pt-md-0"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.submitted}" data-ng-disabled="vm.submitted" data-ng-dblclick="false">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Save &amp; Continue\' : \'Submit\'}}</button></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-insurance.html','<h3>Health Insurance</h3><p>All guardians, regardless of health insurance status, are financially responsible for their students. You hereby release iD Tech from any such financial responsibility.</p><hr><form id="myForm" name="myForm" role="form" ng-submit="vm.submit()" idp-form-focus-on-err novalidate><p><strong>Is your student covered under a health plan?</strong> Please select No if your student is NOT covered under a health plan, you do not wish to enter your information or your home country provides national health services.</p><div class="row"><div class="col-md-5"><div class="form-group"><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedYesNoTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="true" required-message="Please select Yes or No" vertical-layout="false" tooltip="" max="1" ng-click="vm.yesNoClick()"></div></div></div><div ng-if="vm.reqdFormContent && vm.reqdFormContent.noHealthInsInfo != null && !vm.reqdFormContent.noHealthInsInfo"><div class="row my-3"><div class="col-12"><strong>Insurance Provider Information</strong></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label class="sr-only" for="medicalInsuranceProvider">Medical Insurance Provider</label> <input name="medicalInsuranceProvider" class="form-control" placeholder="Medical Insurance Provider" uib-tooltip="Medical Insurance Provider" tooltip-trigger="\'focus\'" maxlength="100" ng-required="true" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.userFormInsurance.carrier" tabindex="1"><div ng-messages="vm.myForm.medicalInsuranceProvider.$error" class="text-danger"><div ng-message="required">Medical Insurance Provider is required</div></div></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="policyNumber">Policy Number</label> <input type="text" class="form-control" name="policyNumber" placeholder="Policy Number" uib-tooltip="Policy Number" tooltip-trigger="\'focus\'" maxlength="100" ng-required="true" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.userFormInsurance.policyNumber" tabindex="2"><div ng-messages="vm.myForm.policyNumber.$error" class="text-danger"><div ng-message="required">Policy Number is required</div></div></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="policyHolderName">Policy Holder Name</label> <input type="text" class="form-control" name="policyHolderName" placeholder="Policy Holder Name" uib-tooltip="Policy Holder Name" tooltip-trigger="\'focus\'" maxlength="100" ng-required="true" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.userFormInsurance.policyHolderName" tabindex="3"><div ng-messages="vm.myForm.policyHolderName.$error" class="text-danger"><div ng-message="required">Policy Holder Name is required</div></div></div></div></div><div class="row my-3"><div class="col-12"><strong>Insurance Provider Phone Number</strong></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label class="sr-only" for="policyNumber">Insurance Provider Phone Number</label><idp-intl-tel-input country-code="vm.userFormInsurance.countryCode" phone-number="vm.userFormInsurance.number" is-required="true" is-readonly="!vm.canCreate || !vm.canUpdate" is-edit-mode="true" first-tab-index="4" phone-number-place-holder="Insurance Provider Phone Number"></div></div></div><div class="row my-3"><div class="col-12"><strong>Policy Holder\'s Date of Birth: <small>(Optional)</small></strong></div></div><div class="row"><div class="col-md-8"><div class="form-group"><label class="sr-only" for="policyNumber">Policy Holder\'s Date of Birth</label><idp-date-picker date="vm.userFormInsurance.policyHolderDOB" min-date="vm.maxDOBDate" max-date="vm.minDOBDate" is-edit-mode="vm.canCreate || vm.canUpdate" is-required="false" first-tab-index="7" invalid-date-msg="\'Please select a valid date\'"></idp-date-picker></div></div></div></div><idp-hsf-authorization user-form-detail="vm.userFormDetail" ng-if="vm.myForm.$dirty && vm.userFormDetail.statusTypeID == $root.Enums.FormStatus.Complete"></idp-hsf-authorization><div class="row my-3"><div class="col-md-3 offset-md-6"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.onBackClick()">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Back\' : \'Cancel\'}}</button></div><div class="col-md-3 pt-3 pt-md-0"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.submitted}" data-ng-disabled="vm.submitted" data-ng-dblclick="false">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Save &amp; Continue\' : \'Submit\'}}</button></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-medications.html','<h3>iD\'s Health &amp; Wellness Priorities</h3><hr><form id="myForm" name="myForm" role="form" ng-submit="vm.submit()" idp-form-focus-on-err novalidate><div class="row my-3"><div class="col-md-7"><p><strong>Will this student be <span class="text-danger">bringing</span> prescribed and/or over-the-counter medications <span class="text-danger">to camp</span>?</strong></p><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedPrescriptionReqTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="true" required-message="Please select Yes or No" vertical-layout="false" max="1" ng-click="vm.prescriptionReqYesNoClick()"></div></div><div class="row my-3"><div class="col-md-7"><p><strong>Will this student be <span class="text-danger">bringing</span> a diabetic testing kit, inhaler, epinephrine auto-injector/EpiPen, or injections/syringes <span class="text-danger">to camp</span>?</strong></p><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedEpipenTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="true" required-message="Please select Yes or No" vertical-layout="false" max="1" ng-click="vm.epipenYesNoClick()"></div></div><div class="row my-3" ng-if="vm.reqdFormContent.prescriptionReq"><div class="col-12"><div class="row my-3"><div class="col-12"><h3>Medications</h3><hr></div></div><div class="row" ng-repeat="med in filtered = (vm.userFormMedications | filter:{recordStateID:$root.Enums.RecordStateType.Active}) track by $index"><div class="col-md-9"><div id="med{{$index}}" ng-form="med{{$index}}"><div class="row vertical-align"><div class="col-8"><h4><strong>Medication {{$index+1}}</strong></h4></div><div class="col-4 text-right" ng-if="(vm.canCreate || vm.canUpdate) && vm.userFormMedications.length > 1"><small><a ng-click="vm.deleteMedication(med)">Delete Medication</a></small></div></div><div class="row"><div class="col-md-8"><div class="form-group"><label class="sr-only" for="medicationName">Medication Name</label> <input type="text" class="form-control" name="medicationName" placeholder="Medication Name (incl. kits, inhalers, EpiPens, injections)" uib-tooltip="Medication Name" tooltip-trigger="\'focus\'" ng-required="vm.reqdFormContent.prescriptionReq" maxlength="200" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="med.medicationName" ng-model-options="{ allowInvalid: \'true\' }" ng-pattern="vm.asciiOnlyRegExp"><div ng-messages="vm.myForm[\'med\' + $index].medicationName.$error" class="text-danger"><div ng-message="required">Medication Name is required</div><div ng-message="pattern">{{vm.asciiOnlyRegExpErrorMsg}}</div></div></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="medicationDosage">Dosage</label> <input type="text" class="form-control" name="medicationDosage" placeholder="Dosage" uib-tooltip="Dosage" tooltip-trigger="\'focus\'" ng-required="vm.reqdFormContent.prescriptionReq" maxlength="200" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="med.dosage" ng-model-options="{ allowInvalid: \'true\' }" ng-pattern="vm.asciiOnlyRegExp"><div ng-messages="vm.myForm[\'med\' + $index].medicationDosage.$error" class="text-danger"><div ng-message="required">Dosage is required</div><div ng-message="pattern">{{vm.asciiOnlyRegExpErrorMsg}}</div></div></div></div></div><div class="row"><div class="col-12"><div class="form-group"><label class="sr-only" for="medicationReason">Reason</label> <input type="text" class="form-control" name="medicationReason" placeholder="Reason" uib-tooltip="Reason" tooltip-trigger="\'focus\'" ng-required="vm.reqdFormContent.prescriptionReq" maxlength="200" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="med.reason" ng-model-options="{ allowInvalid: \'true\' }" ng-pattern="vm.asciiOnlyRegExp"><div ng-messages="vm.myForm[\'med\' + $index].medicationReason.$error" class="text-danger"><div ng-message="required">Reason is required</div><div ng-message="pattern">{{vm.asciiOnlyRegExpErrorMsg}}</div></div></div></div></div><div class="row my-3"><div class="col-12 col-md-4"><p><strong>Times Taken</strong></p><idp-type-selector types="vm.medTimeTakenTypes" selected-types="med.selectedMedTimeTakenTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="vm.reqdFormContent.prescriptionReq" required-message="Time Taken is required" vertical-layout="true" min="1" ng-click="vm.myForm.$setDirty()"></div><div class="col-md-8"><p>&nbsp;</p><div class="form-group"><textarea class="form-control" name="specialInstructions" placeholder="Special Instructions / Side Effects (600 Characters Maximum)" uib-tooltip="Special Instructions / Side Effects" tooltip-trigger="\'focus\'" maxlength="600" rows="6" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="med.sideEffects" ng-model-options="{ allowInvalid: \'true\' }" ng-pattern="vm.asciiOnlyRegExp"></textarea><div ng-messages="vm.myForm[\'med\' + $index].specialInstructions.$error" class="text-danger"><div ng-message="pattern">{{vm.asciiOnlyRegExpErrorMsg}}</div></div></div></div></div></div></div></div><div class="row my-3"><div class="col-md-5 col-md-4"><button type="button" class="btn btn-primary btn-block vertical-align no-text-transform" ng-click="vm.addMedication()" ng-disabled="!vm.canCreate || !vm.canUpdate"><span class="icon icon-plus font-weight-bold mr-2"></span>Add medication</button></div></div></div></div><idp-hsf-authorization user-form-detail="vm.userFormDetail" ng-if="(vm.myForm.$dirty && vm.userFormDetail.statusTypeID == $root.Enums.FormStatus.Complete) || vm.pulseContext.healthSafetyFormMgr.isMedicAppMedsOnly"></idp-hsf-authorization><div class="row my-3"><div class="col-md-3 offset-md-6"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.onBackClick()">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Back\' : \'Cancel\'}}</button></div><div class="col-md-3 pt-3 pt-md-0"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.submitted}" data-ng-disabled="vm.submitted" data-ng-dblclick="false">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Save &amp; Continue\' : \'Submit\'}}</button></div></div></form><div id="medsAdminPolicyModalContent" class="d-none"><div class="text-default"><p class="text-danger"><strong>For the safety of our students, please note that students cannot be admitted to camp if these procedures are not followed:</strong></p><p></p><ul class="list-unstyled text-default"><li><strong class="text-danger">All medications must be brought to camp in their original containers on your student\'s first day.</strong> The original container must identify (in English) the prescribing physician (if a prescription drug), the name of the medication, the dosage and the frequency of administration.<br><br><strong class="text-danger">Please do not bring medications in any other containers.</strong><br><br><strong class="text-danger">If your student will be bringing an epinephrine auto-injector (e.g. EpiPen, Auvi-Q), you will need to bring two non-expired devices the first day of their program. One will be held by staff. The other will be held by the student.</strong><br><br>All medication brought to camp must match what is listed in this form. Any discrepancies may result in delays at check-in.<br><br><strong class="text-danger">Our staff will only dispense the dosage as listed on the original container. Please provide a physician\'s note if your student\'s dosage differs from what is listed on the original container.</strong></li></ul><p></p></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-page-header.html','<div class="row"><div class="col-12"><h1 class="text-left">Health &amp; Safety Form for {{vm.participant.firstName}}</h1></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-schooling.html','<h3>Student Assessment and Learning Style</h3><p><strong>Please provide us with insights and tips to help us engage with your student to optimize their camp experience.</strong></p><hr><form id="myForm" name="myForm" role="form" ng-submit="vm.submit()" idp-form-focus-on-err novalidate><p><strong>Sample of some insight and tips:</strong> Matthew is going into 5th grade. He\'s very curious and intelligent. As a result, he gets distracted if not engaged. He likes to participate in discussions and answer questions. Please challenge him early on to start things off on the right foot. He may also need some help making friends as he\'s shy at first, so please pair him up from time to time. He does very well in math and is a voracious reader. He has done some Scratch programming with Code.org at school. Matthew loves it best when he can use creativity and storytelling in his projects. He\'s really into Harry Potter and Roblox right now. Matthew also loves outdoor activities and playing soccer. He has been on a soccer team for 3 years.</p><div class="row"><div class="col-md-8"><div class="form-group"><label class="sr-only" for="assessment">Assessment</label> <textarea name="assessment" class="form-control" uib-tooltip="Assessment" tooltip-trigger="\'focus\'" maxlength="1000" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.reqdFormContentNew.assessmentComment" rows="4" placeholder="Maximum 1000 characters"></textarea></div></div></div><p><strong>School</strong></p><div class="row"><div class="col-md-4"><div class="form-group"><label class="sr-only" for="schoolName">School Name</label> <input type="text" class="form-control" name="schoolName" placeholder="School Name" uib-tooltip="School Name" tooltip-trigger="\'focus\'" maxlength="200" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.reqdFormContentNew.schoolName"></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="schoolCity">School City</label> <input type="text" class="form-control" name="schoolCity" placeholder="School City" uib-tooltip="School City" tooltip-trigger="\'focus\'" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.reqdFormContentNew.schoolCity"></div></div><div class="col-md-4"><div class="form-group"><label class="sr-only" for="schoolState">School State</label> <input type="text" class="form-control" name="schoolState" placeholder="School State" uib-tooltip="School State" tooltip-trigger="\'focus\'" maxlength="100" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.reqdFormContentNew.schoolState"></div></div></div><idp-hsf-authorization user-form-detail="vm.userFormDetail" ng-if="vm.myForm.$dirty && vm.userFormDetail.statusTypeID == $root.Enums.FormStatus.Complete"></idp-hsf-authorization><div class="row my-3"><div class="col-md-3 offset-md-6"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.onBackClick()">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Back\' : \'Cancel\'}}</button></div><div class="col-md-3 pt-3 pt-md-0"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.submitted}" data-ng-disabled="vm.submitted" data-ng-dblclick="false">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Save &amp; Continue\' : \'Submit\'}}</button></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-special-needs-immunizations.html','<h3>Activity Limitations or Participation Restrictions</h3><hr><form id="myForm" name="myForm" role="form" ng-submit="vm.submit()" idp-form-focus-on-err novalidate><div class="row my-3"><div class="col-md-6"><p><strong>Does your student have limitations or restrictions that are physical, developmental, behavioral or emotional we need to know to properly support the student while attending camp? (i.e., physical disability, low vision, limited hearing, on autism spectrum, learning disability, developmental delays)</strong></p><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedHasSpecialNeedsTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="true" required-message="Please select Yes or No" vertical-layout="false" max="1" ng-click="vm.hasSpecialNeedsYesNoClick()"></div></div><div class="row" ng-if="vm.reqdFormContent.hasSpecialNeeds"><div class="col-md-6"><p class="mb-1"><strong>Please explain:</strong></p><div class="form-group"><textarea class="form-control" name="spNeedsComment" ng-placeholder="1000 Characters Maximum" uib-tooltip="Activity Limitations or Participation Restrictions comment" tooltip-trigger="\'focus\'" maxlength="1000" rows="5" ng-disabled="!vm.canCreate || !vm.canUpdate" ng-model="vm.reqdFormContent.spNeedsComment" ng-required="true"></textarea><div ng-messages="vm.myForm.spNeedsComment.$error" class="text-danger"><div ng-message="required">Comment is required</div></div></div></div></div><div class="row my-3" ng-if="vm.reqdFormContent.hasSpecialNeeds"><div class="col-md-6"><p><strong>Does your Student require an aide to come to camp with them to assist in their participation?</strong></p><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedNeedsAideTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="true" required-message="Please select Yes or No" vertical-layout="false" max="1" ng-click="vm.needsAideYesNoClick()"></div></div><div ng-if="vm.isUSLocationOnly"><div class="row my-3"><div class="col-12"><h3>Immunizations</h3><hr></div></div><div class="row"><div class="col-md-6"><p><strong>Is your student up-to-date on all immunizations required to attend school?</strong></p><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedIsImmunizedTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="true" required-message="Please select Yes or No" vertical-layout="false" max="1" ng-click="vm.isImmunizedYesNoClick()"></div></div><div class="row my-3" ng-if="!vm.reqdFormContent.isImmunized && vm.reqdFormContent.isImmunized != null"><div class="col-12"><div class="row"><div class="col-md-6"><p><strong>Select reason why student is not fully immunized:</strong></p><p><em>Note:</em> The state in which your child is attending iD Tech may not allow one or more of these immunization exemptions. Philosophical and religious exemptions are not valid in many states. Click <a href="https://www.nvic.org/vaccine-laws/state-vaccine-requirements.aspx" target="_blank">here</a> to see what exemptions are allowed by the state where your child is attending iD Tech.</p></div></div><div class="row"><div class="col-md-3"><idp-type-selector types="vm.immunizationRefusalTypes" selected-types="vm.selectedImmunizationRefusalTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="!vm.reqdFormContent.isImmunized" required-message="Please select a reason" vertical-layout="true" max="1" ng-click="vm.immunizationRefusalClick()"></div></div></div></div><div class="row my-3" ng-if="vm.reqdFormContent.isImmunized"><div class="col-12"><div class="row"><div class="col-md-6"><p><strong>We need to know the most recent year your student was immunized for the following:</strong></p><p>If you are unable to determine the exact date, make a selection based on your best recollection.</p></div></div><div class="row"><div class="col-md-6"><div ng-repeat="ufi in vm.userFormImmunizations"><strong>Vaccine - {{vm.getTypeForImmunization(ufi).typeString}} ({{vm.getTypeForImmunization(ufi).typeExtraString}}):</strong><p>Most recent immunization</p><div class="row"><div class="col-md-12"><idp-date-picker date="ufi.immunizedDate" min-date="vm.minImmunizationDate" max-date="vm.maxImmunizationDate" show-day="false" show-month="true" show-year="true" month-label="\'Month\'" year-label="\'Year\'" required-message="\'Month and Year required\'" is-edit-mode="true" is-required="vm.reqdFormContent.isImmunized" invalid-date-msg="\'Please select a valid date\'" sort-years-descending="true" first-tab-index="7"></idp-date-picker></div></div></div></div></div></div></div><hr><div class="row"><div class="col-12"><div class="row"><div class="col-md-6"><p>&nbsp;</p><idp-hsf-covid hide-details="true"></idp-hsf-covid></div></div></div></div><div class="row"><div class="col-12"><div class="col-md-6"><p><strong>Is your student vaccinated against COVID-19?</strong></p><idp-type-selector name="isCovidImmunized" id="isCovidImmunized" types="vm.yesNoTypes" selected-types="vm.selectedIsCovidImmunizedTypes" is-edit-mode="true" is-read-only="!vm.canCreate || !vm.canUpdate" is-required="true" required-message="Please select Yes or No" vertical-layout="false" max="1" ng-click="vm.isCovidImmunizedYesNoClick()"></div></div></div><div class="row" ng-if="vm.reqdFormContent.isCovidImmunized && vm.reqdFormContent.isCovidImmunized != null"><div class="col-12"><div class="col-md-6"><div class="row"><p>&nbsp;</p><p><strong>Please enter the COVID-19 vaccinations details for your student below. If your student receives a COVID-19 vaccination(s) in the future before camp starts, please come back and update this document.</strong></p></div></div></div><div class="col-md-6"><div class="row"><div class="col-sm-3" style="float:left;padding: 10px;">Dose #1</div><div class="col-sm-5" style="float:left;padding: 5px;"><select id="dose1" name="dose1" class="form-control" ng-required="vm.reqdFormContent.isCovidImmunized == true" ng-model="vm.selectedDose1" ng-options="manuf.typeString for manuf in vm.covidImmunizationsManufDose1 track by manuf.typeID"><option value="">Please Select</option></select></div><div class="col-sm-3" style="float:left;padding: 5px;"><idp-text-date-picker name="dose1EffectiveDate" ng-change="alert($event)" ng-model="vm.selectedDose1EffectiveDate" placeholder="Date" date="vm.selectedDose1EffectiveDate" is-edit-mode="true" is-required="vm.reqdFormContent.isCovidImmunized == true" is-disabled="false" max-date="vm.maxCovidImmunizationDate" tooltip="Date (mm/dd/yyyy)" first-tab-index="1100"></idp-text-date-picker></div></div><div class="row"><div class="col-sm-3" style="float:left;padding: 10px;">Dose #2</div><div class="col-sm-5" style="float:left;padding: 5px;"><select id="dose2" name="dose2" class="form-control" ng-required="vm.selectedDose2EffectiveDate != null" ng-model="vm.selectedDose2" ng-options="manuf.typeString for manuf in vm.covidImmunizationsManufDose2 track by manuf.typeID"><option value="">Please Select</option></select></div><div class="col-sm-3" style="float:left;padding: 5px;"><idp-text-date-picker name="dose2EffectiveDate" ng-model="vm.selectedDose2EffectiveDate" placeholder="Date" date="vm.selectedDose2EffectiveDate" is-edit-mode="true" is-required="vm.selectedDose2 != null || vm.selectedDose2EffectiveDate != null" is-disabled="false" max-date="vm.maxCovidImmunizationDate" tooltip="Date (mm/dd/yyyy)" first-tab-index="1100"></idp-text-date-picker></div></div><div class="row"><div class="col-sm-3" style="float:left;padding: 10px;">Booster #1</div><div class="col-sm-5" style="float:left;padding: 5px;"><select id="booster1" name="booster1" class="form-control" ng-required="vm.selectedBooster1EffectiveDate != null" ng-model="vm.selectedBooster1" ng-options="manuf.typeString for manuf in vm.covidImmunizationsManufBooster1 track by manuf.typeID"><option value="">Please Select</option></select></div><div class="col-sm-3" style="float:left;padding: 5px;"><idp-text-date-picker name="booster1EffectiveDate" ng-model="vm.selectedBooster1EffectiveDate" placeholder="Date" date="vm.selectedBooster1EffectiveDate" is-edit-mode="true" is-required="vm.selectedBooster1 != null || vm.selectedBooster1EffectiveDate != null" is-disabled="false" max-date="vm.maxCovidImmunizationDate" tooltip="Date (mm/dd/yyyy)" first-tab-index="1100"></idp-text-date-picker></div></div><div class="row"><div class="col-sm-3" style="float:left;padding: 10px;">Booster #2</div><div class="col-sm-5" style="float:left;padding: 5px;"><select id="booster2" name="booster2" class="form-control" ng-required="vm.selectedBooster2EffectiveDate != null" ng-model="vm.selectedBooster2" ng-options="manuf.typeString for manuf in vm.covidImmunizationsManufBooster2 track by manuf.typeID"><option value="">Please Select</option></select></div><div class="col-sm-3" style="float:left;padding: 5px;"><idp-text-date-picker name="booster2EffectiveDate" ng-model="vm.selectedBooster2EffectiveDate" placeholder="Date" date="vm.selectedBooster2EffectiveDate" is-edit-mode="true" is-required="vm.selectedBooster2 != null || vm.selectedBooster2EffectiveDate != null" is-disabled="false" max-date="vm.maxCovidImmunizationDate" tooltip="Date (mm/dd/yyyy)" first-tab-index="1100"></idp-text-date-picker></div></div></div></div></div><idp-hsf-authorization user-form-detail="vm.userFormDetail" ng-if="vm.myForm.$dirty && vm.userFormDetail.statusTypeID == $root.Enums.FormStatus.Complete"></idp-hsf-authorization><div class="row my-3"><div class="col-md-3 offset-md-6"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.onBackClick()">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Back\' : \'Cancel\'}}</button></div><div class="col-md-3 pt-3 pt-md-0"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.submitted}" data-ng-disabled="vm.submitted" data-ng-dblclick="false">{{vm.userFormDetail.statusTypeID != $root.Enums.FormStatus.Complete ? \'Save &amp; Continue\' : \'Submit\'}}</button></div></div></form><div id="needsAidePolicyModalContent" class="d-none"><p class="text-default"><strong>Student Aide Information:</strong> If your student requires an aide to come with them to camp to assist them.</p><ul class="list-unstyled text-default"><li><strong>Please phone {{vm.companyTollFreePhone | tel}} or {{vm.companyInternationalPhone | tel}} (international).</strong> Please note, you must contact the iD Tech office at least twenty (20) business days prior to the start of the session so that there is sufficient time to accommodate your needs and run a background check on your student\u2019s aide. The aide will not be admitted to camp without a favorable background check.</li><li>&nbsp;</li><li>You understand that if your student requires an aide at school then he/she will need to be accompanied by an aide at camp and that you will need to provide an aide for the duration of the camp session. You further understand that you will be responsible for charges for room and board for the aide (if applicable). According to iD Tech policy, the aide must be over age 18, may not be the student\u2019s parent or guardian, may not be a sibling, and must receive a favorable result on a criminal background check prior to attending our program.</li></ul><p></p></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/forms/hsf/idp-hsf-thanks.html','<div ng-show="vm.isReady"><h3>Thank you!</h3><hr><div><div class="row my-3"><div class="col-12 text-em-1-2">Your Health and Safety Form for {{vm.participant.firstName}} is complete.</div></div><div class="row my-3"><div class="col-12">You can review or edit your submission now by clicking Back to My Account or at any time by going to the Required Forms page under Profile in your My Account.</div></div><div class="row my-3" ng-show="vm.incompleteParticipants.length > 0"><div class="col-12 text-em-1-2">Would you like to continue to <a class="font-weight-bold" ng-click="vm.completeNextStudentForm(vm.incompleteParticipants[0].userID)">fill out {{vm.incompleteParticipants[0].firstName}}\'s form?</a></div></div><div class="row my-3" ng-show="vm.incompleteParticipants.length > 0"><div class="col-md-5 offset-2"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.onBackClick()">Back to My Account</button></div><div class="col-md-5 pt-3 pt-md-0" ng-show="vm.incompleteParticipants.length > 0"><button type="button" class="btn btn-primary btn-block" ng-click="vm.completeNextStudentForm(vm.incompleteParticipants[0].userID)">Continue to next form</button></div></div><div class="row my-3" ng-show="vm.incompleteParticipants.length == 0"><div class="col-md-3 offset-md-9"><button type="button" class="btn btn-primary btn-block" ng-click="vm.onBackClick()">Back to My Account</button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-course-info-popup.html','<div id="{{::vm.popupId}}" class="pulseapp opl-course-info-popup"><div class="modal-header d-flex flex-column align-items-center justify-content-center text-center" back-img="{{vm.heroImg}}"><div class="text-white header-text"><strong>{{::vm.skill.name}}</strong></div><button type="button" class="close" dismiss="modal" aria-hidden="true" ng-click="vm.close()">&#xD7;</button></div><div class="modal-body p-2 p-lg-5"><div ng-bind-html="vm.skill.description | unsafe"></div></div><div class="modal-footer justify-content-center border-top-0"><button type="button" class="btn btn-success px-8" ng-click="vm.selectTopic()" data-dismiss="modal">Select this topic</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-course-list.html','<div ng-show="vm.genreTopics.skills.length > 0"><p class="ml-6 text-black mb-3"><strong>{{vm.genreTopics.genreType.typeString}}</strong></p><div class="d-flex"><button class="px-1 btn btn-outline-secondary text-black border-0 text-em-2-75" ng-click="vm.moveLeft($event)">&lt;</button><div class="scrolling-wrapper-flexbox"><div class="card btn d-flex align-items-center justify-content-center text-center p-0" ng-repeat="s in vm.genreTopics.skills" ng-click="vm.openCourseInfoPopup(s)" ng-class="{selected: vm.isSelectedTopic(s)}"><img ng-src="{{vm.getThumbImage(s)}}" class="thumbnail" ng-class="{ \'admin-override\': vm.pulseContext.isImpersonating && (s.isAdminOverride || s.isAgeViolated)}" alt="thumbnail" border="0"><div class="text-white font-weight-bold course-name px-3">{{s.name.toString()}}</div><div class="bg-white px-3 view-detail text-black">View Details</div></div></div><button class="ml-2 px-1 btn btn-outline-secondary text-black border-0 text-em-2-75" ng-click="vm.moveRight($event)">&gt;</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-instructor.html','<div class="card border-0 shadow-lg p-lg-5 p-2 mt-2"><div class="d-flex flex-row"><div class="instructor-avatar mr-2 mr-lg-5"><img ng-src="{{::vm.instructor.imageUrl}}" ng-show="vm.instructor.imageUrl" title="Instructor avatar" alt="Instructor avatar"></div><div class="flex-grow-1"><div class="row"><div class="col-12 col-lg-3 text-black font-weight-bold">{{vm.instructor.firstName}} {{vm.instructor.lastName}}</div><div class="col-lg-6 d-none d-lg-inline"><span class="bg-primary px-lg-3 py-1 rounded" ng-hide="vm.selectedDateTime"><span class="font-weight-bold">Next Available Lesson &middot;</span><wbr> <span>{{vm.instructor.earliestDate | date:\'EEEE, MMMM d, y\'}}</span></span></div><div class="col-12 col-lg-3 text-lg-right mt-5 mt-lg-0"><button class="btn" ng-disabled="vm.isDisableSelect && !vm.instructor.isSelected " ng-class="{\'btn-outline-secondary\': vm.isSelectMultiple && !vm.instructor.isSelected,\n                            \'btn-secondary\': vm.isSelectMultiple && vm.instructor.isSelected,\n                            \'btn-success\': !vm.isSelectMultiple}" ng-click="vm.selectInstructor();">{{vm.instructor.isSelected ? "Remove Instructor" :"Select this Instructor"}}</button></div></div></div></div><div class="row d-lg-none"><div class="col-12 mt-3"><span class="bg-primary px-lg-3 px-3 py-1 rounded instructor-available-text"><span class="font-weight-bold">Next Available Lesson &middot;</span> <span>{{vm.instructor.earliestDate | date:\'EEEE, MMMM d, y\'}}</span></span></div></div><div class="row mt-2"><div class="col-12"><span ng-show="!vm.showMore"><span ng-bind-html="vm.instructor.bio | limitTo: 300 | unsafe"></span> <span ng-show="vm.instructor.bio.length > 300">...&nbsp; <a href="" ng-click="vm.showMore = !vm.showMore" class="font-weight-bold">Read more</a> </span></span><span ng-show="vm.showMore"><span ng-bind-html="vm.instructor.bio | unsafe"></span> <a href="" ng-click="vm.showMore = !vm.showMore" class="font-weight-bold">Read less</a></span></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-schedule-confirmation-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><h3>{{:: vm.successfulLessons && vm.successfulLessons.length ? \'Congrats\': \'Sorry\'}}</h3></div><div class="modal-body p-2 p-lg-5"><div ng-show="vm.successfulLessons && vm.successfulLessons.length"><p>The following lesson(s) have been scheduled:</p><div><span>Time Zone: {{vm.studentTimeZoneTypeStr}}</span></div><ul><li ng-repeat="lession in vm.successfulLessons track by $index"><b>{{lession.topic.name}}</b> with {{lession.instructor.firstName}} {{lession.instructor.lastName}} on <b>{{lession.dateTime | date:"EEEE, MMMM d \'@\' h:mm a"}}</b></li></ul></div><div ng-show="vm.failedLessons && vm.failedLessons.length"><p>The timeslots below are unavailable. Please schedule another date and time for the following lessons:</p><div><span>Time Zone: {{vm.studentTimeZoneTypeStr}}</span></div><ul><li ng-repeat="lession in vm.failedLessons track by $index"><b>{{lession.topic.name}}</b> with {{lession.instructor.firstName}} {{lession.instructor.lastName}} on <b>{{lession.dateTime | date:"EEEE, MMMM d \'@\' h:mm a"}}</b></li></ul></div><p ng-hide="vm.availableLessons && vm.availableLessons.length > 0 && !vm.isRescheduling">To schedule another lesson, go to My Account!</p><p ng-show="vm.availableLessons && vm.availableLessons.length > 0 && !vm.isRescheduling">{{vm.studentUser.firstName}} has {{vm.availableLessons.length}} available {{vm.availableLessons.length == 1 ? \'lesson\' : \'lessons\'}} left.</p><div><div class="form-check" ng-show="vm.showSameInstructorCheckbox"><input class="form-check-input" name="sameInstructor" id="sameInstructor" type="checkbox" ng-model="vm.isTheSameInstructor" ng-required="false"> <label class="form-check-label" for="sameInstructor">Look for the same instructor</label></div></div></div><div class="modal-footer"><span class="btn btn-link col-md-5 col-12" style="text-align:left"></span> <button type="button" class="btn btn-primary col-md-3 col-12 px-3" ng-click="vm.navigateToMyAccount()" data-dismiss="modal">Back to My Account</button> <button ng-if="vm.availableLessons && vm.availableLessons.length > 0 && !vm.isRescheduling" type="button" class="btn btn-outline-secondary col-md-3 col-12 px-3" ng-click="vm.scheduleNextLesson()" data-dismiss="modal">Schedule more</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-schedule-date-time.html','<div class="d-flex justify-content-between align-items-center py-lg-5 pl-lg-5 pr-lg-3 p-2"><div class="d-flex align-items-center schedule-header-text"><i class="icon icon-new-cal text-green"></i> <span class="text-black ml-5"><strong>Select a Date & Time</strong></span></div><button type="button" class="close collapse-btn" ng-click="vm.close()" ng-hide="vm.selectedInstructor">&#xD7;</button></div><div class="p-1 p-lg-5"><div class="d-flex align-items-center my-2"><span class="icon icon-globe mr-2 text-lg-right text-em-1-5"></span> <span class="font-weight-bold text-black">Student Time Zone</span></div><div class="row"><div class="col-12 col-md-8 col-xl-6"><select ng-options="type.typeID as type.typeExtraLongString for type in vm.timeZoneTypes" ng-change="vm.updateSelectedTimeZoneTypeID()" class="form-control" name="timezone" ng-model="vm.selectedTimeZoneTypeID" ng-disabled="vm.isOPL3_Only"></select></div></div><div class="mt-5" ng-show="vm.availableDates && vm.availableDates.length == 0">There are currently no dates available for this topic and/or instructor. Check back soon as availability changes regularly.</div><div ng-show="vm.availableDates && vm.availableDates.length > 0"><p ng-show="vm.selectedInstructor" class="mt-5 text-small">{{vm.selectedInstructor.firstName}} {{vm.selectedInstructor.lastName}}\'s soonest availability is <span>{{vm.selectedInstructor.earliestDate | date:\'EEEE MMM d\'}}</span>.<br>Please click on any days that follow to see available times.</p><div class="row text-center d-flex justify-content-center my-5"><div class="col-12 col-md-6 px-lg-5"><div uib-datepicker ng-model="vm.focusedDate" ng-change="vm.updateSelectedDate()" datepicker-options="vm.calendarOptions"></div><div><span class="unavailable-day mr-2"></span>Unavailable days <span ng-if="vm.selectedLessons.length"><span class="has-selected-day mr-2"></span>Selected</span></div></div><div class="col-12 col-md-6 px-lg-5 m-5 m-lg-0" ng-if="vm.focusedDate && vm.selectedTimeZoneTypeID > 0"><div class="shadow d-inline-block" id="opl-schedule-time-container"><div class="time-header-text text-left font-weight-bold p-3">Select an available time</div><div class="opl-time-container p-3"><div ng-repeat="t in vm.availableDateTimes"><div class="btn time-text mb-2 bt btn-block" ng-class="{\'border border-danger\': vm.pulseContext.isImpersonating && (t.minViolatedDateTime || t.minEquipViolatedDateTime)}" ng-click="vm.selectDateTime(t);">{{t.startTime | date: \'h:mm a\'}}</div></div></div></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-schedule-instructor.html','<div class="p-lg-5 p-2"><div class="row align-items-center"><div class="col-12 col-lg-5 schedule-header-text mb-1"><div class="d-flex align-items-center"><i class="icon icon-instructor text-green"></i> <span class="text-black ml-5"><strong>{{vm.title}}</strong></span></div></div><div class="col-12 col-lg-7 px-lg-0"><div ng-if="vm.isSelectMultiple" class="d-flex align-items-center text-warning"><span><i style="line-height: 24px; vertical-align: text-bottom;" class="icon icon-clock pr-1"></i><strong>Recurring lessons</strong> Please choose your top choices for your instructor.<i style="line-height: 24px; vertical-align: text-bottom;" class="icon icon-info pl-1" ng-click="vm.topChoicesInfoClick()"></i></span></div></div></div><div ng-if="vm.isSelectMultiple" class="d-flex flex-row flex-wrap justify-content-center justify-content-md-start my-3 align-items-center pb-3 ng-scope" style="border-bottom: lightgray solid;"><div ng-repeat="prefInstr in vm.preferredInstructors track by prefInstr.userID" class="instructor-avatar-circle mr-2 mr-lg-5" ng-click="vm.removePrefInstructor(prefInstr)"><img ng-src="{{prefInstr.imageUrl}}" ng-attr-title="{{prefInstr.firstName + \' \' + prefInstr.lastName}}" ng-attr-alt="{{prefInstr.nickName ? prefInstr.nickName: prefInstr.firstName + \' \' + prefInstr.lastName}}"> <span class="xtext">x</span></div><div ng-repeat="empty in vm.preferredPlaceholders track by $index" class="instructor-avatar-circle mr-2 mr-lg-5"><img title="Pick an Instructor" alt="Empty Instructor avatar" src="data:image/svg+xml;charset=utf8,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\'%3E%3C/svg%3E"> <span class="numtext">{{vm.preferredInstructors.length + $index + 1}}</span></div><div class="d-flex flex-row flex-grow-1 justify-content-center justify-content-md-end pt-md-0 pt-3"><button class="btn btn-success" ng-click="vm.confirmInstructors();" ng-disabled="!vm.hasEnoughPreferredInstr">Confirm your Instructors</button></div></div><div class="row align-items-center mt-3"><div class="col-12"><div class="form-group row"><label for="instructorSearch" class="col-12 col-md-3 col-xl-2 pr-md-0 col-form-label">Instructor Search</label><div class="col-12 col-md-6 col-lg-4 col-xl-3 p-md-0"><i class="icon icon-search text-muted" style="position:absolute; padding: 1rem;"></i> <input type="search" class="form-control pl-7 py-5" id="instructorSearch" placeholder="Name" ng-model="vm.searchTerm" ng-model-options="{ debounce: 1000 }" ng-change="vm.filterBySearchTerm();"></div><button type="button" class="close collapse-btn" ng-click="vm.close()" ng-show="vm.selectedInstructor">&#xD7;</button></div></div></div><div ng-hide="vm.isDateTimeSelected();"><div class="d-flex align-items-center my-2"><span class="icon icon-globe mr-2 text-lg-right text-em-1-5"></span> <span class="font-weight-bold text-black">Student Time Zone</span></div><div class="row"><div class="col-12 col-md-8 col-xl-6"><select ng-options="type.typeID as type.typeExtraLongString for type in vm.timeZoneTypes" ng-change="vm.updateSelectedTimeZoneTypeID()" class="form-control" name="timezone" ng-model="vm.selectedTimeZoneTypeID" ng-disabled="vm.isOPL3_Only"></select></div></div></div><section ng-show="vm.hardwareSkills && vm.hardwareSkills.length > 0"><div class="my-2 font-weight-bold text-black">Filter by hardware</div><div class="row mb-3"><div class="col-12 col-md-8"><div ng-repeat="hs in vm.hardwareSkills" class="form-check flex-grow-0 flex-shrink-0"><input id="filter-{{ hs.id\n        }}-{{ $index }}" class="form-check-input" type="checkbox" ng-change="vm.filterInstructors()" ng-model="hs.isSelected"> <label class="form-check-label" for="filter-{{ hs.id }}-{{ $index }}">Only show instructors that teach with {{hs.displayName}}</label></div></div><div class="col-12 col-md-4"><button type="button" class="btn btn-primary px-6" ng-click="vm.applyFilters()">Apply filter</button></div></div></section><idp-opl-instructor instructor="instructor" selected-date-time="vm.selectedDateTime" select-instructor-callback="vm.onSelectInstructor(instructor)" is-select-multiple="vm.isSelectMultiple" is-disable-select="vm.hasEnoughPreferredInstr" ng-repeat="instructor in vm.availableInstructors.slice(((vm.currentPage-1)*vm.itemsPerPage), ((vm.currentPage)*vm.itemsPerPage))" class="mt-3" ng-show="vm.availableInstructors.length > 0"></idp-opl-instructor><div uib-pagination total-items="vm.availableInstructors.length" items-per-page="vm.itemsPerPage" ng-model="vm.currentPage" ng-change="vm.pageChanged();" class="pagination justify-content-center mt-3" boundary-links="false" max-size="3" force-ellipses="true" ng-show="vm.availableInstructors.length > vm.itemsPerPage"></div><div ng-if="vm.isSelectMultiple" class="d-flex flex-row flex-wrap justify-content-center justify-content-md-start my-3 align-items-center pb-3 ng-scope" style="border-bottom: lightgray solid;"><div ng-repeat="prefInstr in vm.preferredInstructors track by prefInstr.userID" class="instructor-avatar-circle mr-2 mr-lg-5" ng-click="vm.removePrefInstructor(prefInstr)"><img ng-src="{{prefInstr.imageUrl}}" ng-attr-title="{{prefInstr.firstName + \' \' + prefInstr.lastName}}" ng-attr-alt="{{prefInstr.nickName ? prefInstr.nickName: prefInstr.firstName + \' \' + prefInstr.lastName}}"> <span class="xtext">x</span></div><div ng-repeat="empty in vm.preferredPlaceholders track by $index" class="instructor-avatar-circle mr-2 mr-lg-5"><img title="Pick an Instructor" alt="Empty Instructor avatar" src="data:image/svg+xml;charset=utf8,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\'%3E%3C/svg%3E"> <span class="numtext">{{vm.preferredInstructors.length + $index + 1}}</span></div><div class="d-flex flex-row flex-grow-1 justify-content-center justify-content-md-end pt-md-0 pt-3"><button class="btn btn-success" ng-click="vm.confirmInstructors();" ng-disabled="!vm.hasEnoughPreferredInstr">Confirm your Instructors</button></div></div><div ng-hide="vm.availableInstructors.length > 0 || vm.availableInstructorsOrig.length == 0" class="py-5">There is no instructor with that name that is available for the topic and/or time.</div><div ng-hide="vm.availableInstructorsOrig.length > 0" class="py-5">There are currently no instructors available for this topic and/or date. Check back soon as availability changes regularly.</div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-schedule-multible-time-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><h3>Confirm your next steps</h3></div><div class="modal-body p-2 p-lg-5"><div><p>You\u2019ve selected the following private lesson(s):</p><div><span>Time Zone: {{vm.studentTimeZoneTypeStr}}</span></div><ul><li ng-repeat="lession in vm.successfulLessons track by $index"><b>{{lession.topic.name}}</b> with {{lession.instructor.firstName}} {{lession.instructor.lastName}} on <b>{{lession.dateTime | date:"EEEE, MMMM d \'@\' h:mm a"}}</b> <a class="text-danger" ng-click="vm.removeLesson(lession)">Remove</a></li></ul></div><div ng-show="vm.failedLessons && vm.failedLessons.length"><p>Instructors are unavailable for the timeslots below.<br>Please schedule another date and time for the following lessons:</p><ul><li ng-repeat="lession in vm.failedLessons track by $index"><b>{{lession.topic.name}}</b> on <b>{{lession.dateTime | date:"EEEE, MMMM d \'@\' h:mm a"}}</b></li></ul></div><p ng-show="vm.lessonsLeft > 0">{{vm.studentUser.firstName}} has {{vm.lessonsLeft}} available {{vm.lessonsLeft == 1 ? \'lesson\' : \'lessons\'}} left.</p></div><div class="modal-footer"><a class="btn btn-link col-md-2 col-12 mr-md-auto" ng-click="vm.goBack()">{{vm.isSchedulingRecurringDates ? \'Start over\' : \'Back\'}} </a><button ng-if="vm.lessonsLeft > 0" type="button" class="btn btn-primary col-lg-3 col-md-4 col-12 px-3" ng-dblclick="false" ng-click="vm.addMoreLessons(vm.isUseSameInstructor)" data-dismiss="modal">Schedule more</button> <button type="button" class="btn btn-outline-secondary col-lg-3 col-md-4 col-12 px-2" ng-dblclick="false" ng-click="vm.scheduleLessons()" data-dismiss="modal">Schedule</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-schedule-recurring-date-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-body p-2 p-lg-5"><div class="aqua-bg my-3 py-2 text-center" ng-show="vm.lessonsLeft > 0">{{vm.lessonsLeft}} {{vm.lessonsLeft == 1 ? \'lesson\' : \'lessons\'}} remaining</div><div><b>{{vm.selectedLesson.dateTime | date:"EEEE, MMMM d, yyyy \'@\' h:mm a"}}</b><div class="pb-3">{{vm.studentTimeZoneTypeStr}}</div><div class="form-check flex-grow-0 flex-shrink-0"><input id="freqOpt1" class="form-check-input" name="frequency" ng-model="vm.frequency" type="radio" ng-value="$root.Enums.UI.OPLScheduleRecurringFrequency.NoRepeat" ng-change="vm.frequencyChanged()"> <label for="freqOpt1" class="form-check-label">Does not repeat</label></div><div ng-if="vm.availableEveryWeeks && vm.availableEveryWeeks.length" class="form-check flex-grow-0 flex-shrink-0"><input id="freqOpt2" class="form-check-input" name="frequency" ng-model="vm.frequency" type="radio" ng-value="$root.Enums.UI.OPLScheduleRecurringFrequency.Weekly" ng-change="vm.onFrequencyChanged()"> <label for="freqOpt2" class="form-check-label">Weekly</label></div><div ng-if="vm.availableEvery2Weeks && vm.availableEvery2Weeks.length" class="form-check flex-grow-0 flex-shrink-0"><input id="freqOpt3" class="form-check-input" name="frequency" ng-model="vm.frequency" type="radio" ng-value="$root.Enums.UI.OPLScheduleRecurringFrequency.Every2Weeks" ng-change="vm.onFrequencyChanged()"> <label for="freqOpt3" class="form-check-label">Every 2 weeks</label></div><div ng-if="vm.frequency !== $root.Enums.UI.OPLScheduleRecurringFrequency.NoRepeat" class="pt-2"><label>Ends On</label> <select id="endsOnWeek" name="endsOnWeek" class="form-control" ng-model="vm.numOfLessonsToSchedule" ng-options="aw.numOfLessons as aw.shortDesc for aw in vm.availableWeeks" ng-required="true" ng-change="vm.onEndsOnWeekChange()" uib-tooltip="Please select the date of your final lesson" tooltip-trigger="\'focus\'"></select></div><div ng-if="vm.frequency > 0 && vm.numOfLessonsToSchedule >= 3" class="pt-3"><label>Have a vacation or need to skip a week?</label><div class="form-check flex-grow-0 flex-shrink-0"><input id="chkSkipWeek" class="form-check-input" name="chkSkipWeek" ng-model="vm.isSkipWeek" type="checkbox" ng-change="vm.onSkipWeekChanged()"> <label for="chkSkipWeek" class="form-check-label">Yes</label></div><select ng-if="vm.isSkipWeek" id="ddlSkipWeek" name="ddlSkipWeek" class="form-control" ng-model="vm.weekToSkip" ng-options="aw.dateTime as aw.shortDesc for aw in vm.skippableWeeks" ng-required="true" uib-tooltip="Please select the date to skip" tooltip-trigger="\'focus\'"></select></div><span ng-if="vm.frequency !== $root.Enums.UI.OPLScheduleRecurringFrequency.NoRepeat" class="font-italic font-weight-bold">Scheduling {{ (vm.frequency > 0 && vm.numOfLessonsToSchedule >= 3 && vm.isSkipWeek) ? vm.numOfLessonsToSchedule - 1 : vm.numOfLessonsToSchedule}} lessons</span></div></div><div class="modal-footer"><a class="btn btn-link col-md-3 col-4" ng-click="vm.cancel()">Cancel </a><button type="button" class="btn btn-primary col-md-3 col-4 px-3" ng-click="vm.nextStep()" data-dismiss="modal">Continue</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-schedule-topic.html','<div><p class="text-black schedule-header-text d-inline-block">Start here! <strong>Select a Topic</strong></p><button type="button" class="close collapse-btn" ng-click="vm.close()" ng-show="vm.selectedTopic">&#xD7;</button><hr><div class="mt-6" ng-repeat="genreTopics in vm.genreTopicsList"><idp-opl-course-list genre-topics="genreTopics" selected-topic="vm.selectedTopic"></idp-opl-course-list></div><div ng-if="!vm.selectedTopic && !vm.hasAnySkills()" class="font-weight-bold">Please contact Customer Service to schedule your lesson(s) at {{vm.pulseContext.companyTollFreePhone | tel}} or {{vm.pulseContext.companyInternationalPhone | tel}} (international). Thank you!</div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-session.html','<div class="card w-100 my-2 backdrop-shadow" data-ng-cloak ng-show="vm.canSee"><div class="card-body container"><div class="text-right"><button ng-if="vm.canUpdate" type="button" class="btn btn-sm px-6 btn-outline-secondary ng-scope" ng-dblclick="false" ng-click="vm.onEditClicked()">Edit</button></div><div class="row vertical-align vertical-align-not-xs"><div class="col-12 col-md-8 my-auto"><h4><span ng-if="vm.canSchedule()">{{::vm.topLevelSession.courseName}}</span> <span ng-if="vm.session.skillStr && vm.isShowLessonInfo()">{{vm.session.skillStr}}</span></h4><h5><span ng-if="!vm.canSchedule()">{{::vm.topLevelSession.courseName}}</span></h5><div class="d-flex flex-column flex-md-row"><div class="flex-grow-1 flex-shrink-1"><div><span class="text-danger" ng-if="vm.showExpiredLabel(vm.session)">Expired on {{vm.session.expiryDate | DTZeroHourPreviousDayAdjustForDisplay | date:\'MMM d, yyyy\'}}</span><div class="mt-1" ng-if="!vm.showExpiredLabel(vm.session)"><span class="mb-0" ng-if="vm.session.statusTypeID" ng-bind-html="vm.getSessionStatusStr(vm.session) | unsafe"></span> <span class="mx-4 text-warning" ng-if="vm.isSessionAvailable(vm.session)"><span class="font-weight-bold">\xB7</span> Expires: {{vm.session.expiryDate | DTZeroHourPreviousDayAdjustForDisplay | date:\'MMM d, yyyy\'}}</span></div></div><div ng-if="vm.pulseContext.isImpersonating\n                && vm.isShowLessonInfo()"><label class="mb-0 font-weight-bold">Internal status</label> {{::vm.session.statusStr}}</div><div ng-if="vm.session.startDateTimeUTC\n                && vm.isShowLessonInfo()"><label class="mb-0 font-weight-bold">Time</label> {{vm.getClientDateTimeFromUTC(vm.session.startDateTimeUTC) | date : \'h:mm a\'}} - {{vm.getClientDateTimeFromUTC(vm.session.endDateTimeUTC) | date : \'h:mm a\'}} {{vm.selectedTimeZoneType.typeDescription}}</div><div ng-if="vm.session.instructorName\n                && vm.isShowLessonInfo()"><label class="mb-0 font-weight-bold">Instructor</label> {{vm.session.instructorName}}</div><div ng-if="vm.pulseContext.isImpersonating\n                 && vm.session.instrTimeZoneStr\n                && vm.isShowLessonInfo()"><label class="mb-0 font-weight-bold">Instructor time zone</label> {{vm.session.instrTimeZoneStr}}</div><div ng-if="(vm.session.statusTypeID!=$root.Enums.OPLStatus.Unscheduled) && vm.session.meetingURL"><label class="mb-0 font-weight-bold">Meeting link</label> <a target="_blank" ng-href="{{vm.session.meetingURL}}">{{vm.session.meetingURL}}</a></div><div class="my-4 text-info" ng-if="vm.isShowDetails && !vm.hasLessonDetails\n                  && vm.isShowLessonInfo()">No additional lesson details.</div><div ng-if="vm.isShowDetails && vm.hasLessonDetails\n                && vm.isShowLessonInfo()"><div class="pt-2" ng-show="vm.session.conceptsCovered"><label class="mb-0 font-weight-bold">Concepts covered:</label><div ng-bind-html="vm.session.conceptsCovered | unsafe"></div></div><div class="pt-2" ng-show="vm.session.instructorNotes"><label class="mb-0 font-weight-bold">Student highlights:</label><div ng-bind-html="vm.session.instructorNotes | unsafe"></div></div><div class="pt-2" ng-show="vm.pulseContext.isImpersonating && vm.session.internalNotes"><label class="mb-0 font-weight-bold">Internal notes:</label><div ng-bind-html="vm.session.internalNotes | unsafe"></div></div></div></div></div></div><div class="col-10 col-md-4 col-lg-3 mt-2 my-md-auto mx-auto"><a class="btn btn-primary btn-block mt-3 mt-xs-1 ng-binding" ng-if="vm.getOPLSchedulingURL() && vm.canSchedule()" ng-href="{{vm.getOPLSchedulingURL()}}">Schedule now!</a> <span ng-if="vm.getOPLSchedulingURL() == null && vm.canSchedule()">Link unavailable. Please call <a ng-href="{{vm.common.config.WWW_UrlRoot+\'/contact\'}}" target="_blank">Client Services</a> to schedule. </span><a class="btn btn-primary btn-block mt-3 mt-xs-1 ng-binding" ng-if="vm.canReschedule()" ng-href="{{vm.getOPLSchedulingURL()}}">Reschedule lesson </a><button class="btn btn-outline-secondary btn-block mt-3 mt-xs-1 ng-binding" ng-if="vm.canCancel()" ng-click="vm.cancelLesson();">Cancel lesson</button> <button class="btn btn-outline-secondary btn-block mt-3 mt-xs-1 ng-binding" ng-if="vm.isSessionCompleted(vm.session)" ng-click="vm.showHideDetails();"><span ng-if="!vm.isShowDetails">Lesson details</span> <span ng-if="vm.isShowDetails">Hide details</span></button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-student-lessons.html','<h4 style="font-size: 1.25rem;">My Lessons</h4><uib-tabset active="vm.activeTabIdx" class="idp-tabset" style="min-height: 20em;"><uib-tab index="0"><uib-tab-heading>Scheduled<span class="d-none d-md-inline"> Lessons</span> ({{vm.studentSession.scheduledSessionsCount}})</uib-tab-heading><div class="mt-3"><div class="m-2 text-info text-center" ng-if="!vm.scheduledSessions.length">No lessons have been scheduled.</div><div ng-repeat="session in vm.scheduledSessions" ng-if="(vm.isTabIdxRendered(0) || vm.activeTabIdx == 0) && vm.scheduledSessions.length"><idp-opl-session session="session" top-level-session="vm.getTopLevelSession(session)" purchase-date="session.purchaseDate" camp-start-date="session.campStartDate" student-user-id="vm.studentInfo.studentUserID" student-original-time-zone-type-id="vm.studentInfo.originalTimeZoneTypeID" selected-time-zone-type="vm.selectedTimeZoneType" in-tab-idx="0"></idp-opl-session></div></div></uib-tab><uib-tab index="1"><uib-tab-heading>Available<span class="d-none d-md-inline"> Lessons</span> ({{vm.studentSession.availableSessionsCount}})</uib-tab-heading><div class="mt-3"><div class="m-2 text-info text-center" ng-if="!vm.availableSessions.length">No available lessons to schedule.</div><div ng-repeat="session in vm.availableSessions" ng-if="(vm.isTabIdxRendered(1) || vm.activeTabIdx == 1) && vm.availableSessions.length"><idp-opl-session session="session" top-level-session="vm.getTopLevelSession(session)" purchase-date="session.purchaseDate" camp-start-date="session.campStartDate" student-user-id="vm.studentInfo.studentUserID" student-original-time-zone-type-id="vm.studentInfo.originalTimeZoneTypeID" selected-time-zone-type="vm.selectedTimeZoneType" in-tab-idx="1"></idp-opl-session></div></div></uib-tab><uib-tab index="2"><uib-tab-heading>Past<span class="d-none d-md-inline"> Lessons</span> ({{vm.studentSession.totalSessionsCount - (vm.studentSession.scheduledSessionsCount + vm.studentSession.availableSessionsCount)}})</uib-tab-heading><div class="mt-3"><div class="m-2 text-info text-center" ng-if="!vm.allOtherSessions || !vm.allOtherSessions.length">No past lessons.</div><div ng-repeat="session in vm.allOtherSessions" ng-if="(vm.isTabIdxRendered(2) || vm.activeTabIdx == 2) && vm.allOtherSessions.length"><idp-opl-session session="session" top-level-session="vm.getTopLevelSession(session)" purchase-date="session.purchaseDate" camp-start-date="session.campStartDate" student-user-id="vm.studentInfo.studentUserID" student-original-time-zone-type-id="vm.studentInfo.originalTimeZoneTypeID" selected-time-zone-type="vm.selectedTimeZoneType" in-tab-idx="2"></idp-opl-session></div></div></uib-tab><uib-tab classes="d-none d-md-inline-block py-0" select="vm.buyLessonsClick()"><uib-tab-heading><button class="btn btn-primary btn-sm px-4">Buy lessons</button></uib-tab-heading></uib-tab></uib-tabset>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/online-private-lesson/public/idp-opl-student-subscriptions.html','<h4 style="font-size: 1.25rem;">My Subscriptions ({{vm.studentSubscriptions.length}})</h4><div class="id-panel-group" id="subscriptionAccordion"><div class="card id-collapsible-card mt-3" ng-repeat="subscription in vm.studentSubscriptions track by subscription.orderDetailID"><div class="card-heading" id="heading{{::subscription.orderDetailID}}" ng-click="vm.onExpandToggle(subscription)" ng-class="{\'collapsed\': !subscription.isExpanded}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{\'d-none\': subscription.isExpanded}"></span> <span class="icon icon-minus-1" ng-class="{\'d-none\': !subscription.isExpanded}"></span></div><div class="content container-fluid"><div class="d-flex flex-column flex-md-row"><div class="flex-grow-1 flex-shrink-1"><strong class="d-inline-block"><h4 class="course-name">{{subscription.productName}}</h4></strong><div ng-if="!subscription.isSuspended"><div ng-if="!subscription.isRenewPaused"><div class="idp-icon-circle-bg bg-light-green mr-1"><i class="bi-check-lg text-light-green"></i></div>Renewal Date <span class="icon icon-info mr-1 c-pointer" id="renewalDateHelp" ng-click="vm.showRenewalDateHelp($event)"></span>: {{subscription.expiryDate | date:\'MMMM d, yyyy\'}}</div><div class="font-weight-bold text-purple" ng-if="subscription.isRenewPaused"><div class="idp-icon-circle-bg bg-light-purple mr-1"><i class="bi-pause-fill"></i></div>Paused {{ subscription.expiryDate ? \'until \' + (subscription.expiryDate | date:\'MMMM d, yyyy\') : \'indefinitely\'}}</div></div><div ng-if="subscription.isSuspended"><div class="font-weight-bold text-danger"><div class="idp-icon-circle-bg bg-light-red mr-1"><i class="icon icon-cancel" style="font-size:.9rem"></i></div>Suspended <span class="icon icon-info mr-1 c-pointer" id="suspendedHelp" ng-click="vm.showSuspendedHelp($event, subscription)"></span></div></div></div><div class="mt-3 m-md-auto" ng-hide="subscription.isExpanded"><button type="button" class="btn btn-outline-secondary btn-sm">View Details</button></div></div></div></div></div><div id="collapse{{::subscription.orderDetailID}}" class="panel-collapse padded-content" uib-collapse="!subscription.isExpanded"><div class="card-body p-1 bg-lightgray d-flex justify-content-around align-items-stretch align-content-between flex-wrap"><div class="card col-lg-5 m-2 m-lg-3"><div class="h-100 my-3"><div class="font-size-larger mb-2">Topic & Plan</div><div class="h4 m-0">{{subscription.productNamePart1}}</div>{{subscription.productNamePart2}}<div>{{subscription.pricePerLesson | currency:-subscription.currencyTypeID:0}}&nbsp;/lesson&nbsp;&nbsp;|&nbsp;&nbsp;{{subscription.pricePerMonth | currency:-subscription.currencyTypeID:0}}&nbsp;/month</div></div><div class="px-0 card-footer d-flex justify-content-around align-items-stretch align-content-between flex-wrap"><button class="btn btn-outline-secondary px-6" ng-disabled="subscription.isSuspended || subscription.catalogTypeID === $root.Enums.SalesCatalogType.OPLGeneric" ng-click="vm.onChangeTopicClick(subscription)">Change Topic</button> <button class="btn btn-link px-7" type="button" ng-disabled="subscription.isSuspended" ng-click="vm.onChangePlanClick(subscription)">Change Plan</button></div></div><div class="card col-lg-5 m-2 m-lg-3"><div class="h-100 my-3"><div class="font-size-larger mb-2">Pause & Cancel</div><div class="h4 m-0"><div ng-if="!subscription.isSuspended"><div ng-if="!subscription.isRenewPaused">Renewal Date: {{subscription.expiryDate | date:\'MMMM d, yyyy\'}}</div><div class="text-purple" ng-if="subscription.isRenewPaused">Paused {{ subscription.expiryDate ? \'until \' + (subscription.expiryDate | date:\'MMMM d, yyyy\') : \'indefinitely\'}}</div><a class="btn-link" ng-click="vm.onRenewSubClick(subscription)">Renew now</a></div><div ng-if="subscription.isSuspended"><div class="text-danger">Suspended <span class="icon icon-info mr-1 c-pointer" id="suspendedHelp" ng-click="vm.showSuspendedHelp($event, subscription)"></span></div></div></div></div><div class="px-0 card-footer d-flex justify-content-around align-items-stretch align-content-between flex-wrap"><button ng-if="!subscription.isSuspended && !subscription.isRenewPaused" class="btn btn-outline-secondary" ng-click="vm.onPauseSubClick(subscription)">Pause Subscription</button> <button ng-if="!subscription.isSuspended && subscription.isRenewPaused" ng-disabled="!subscription.expiryDate" class="btn btn-outline-secondary" ng-click="vm.onManageSubClick(subscription)">Manage Subscription</button> <button ng-if="subscription.isSuspended" class="btn btn-outline-secondary" ng-click="vm.onReactivateSubClick(subscription)">Reactivate Subscription</button> <button class="btn btn-link" type="button" ng-click="vm.onCancelSubClick(subscription)">Cancel Subscription</button></div></div></div><div class="card-footer"><div><button class="btn btn-link btn-block no-text-transform" type="button" ng-click="vm.onExpandToggle(subscription)"><span class="icon icon-chevron-up mr-2"></span>Close <span class="d-none d-sm-inline-block">drawer</span></button></div></div></div></div></div><idp-subscription-change-popup popup-id="subscriptionChangePopup"></idp-subscription-change-popup><idp-subscription-pause-popup popup-id="subscriptionPausePopup"></idp-subscription-pause-popup><idp-subscription-cancel-popup popup-id="subscriptionCancelPopup"></idp-subscription-cancel-popup><idp-credit-card-popup popup-id="changeCreditCardPopup" api="vm.creditCardPopupApi"></idp-credit-card-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/refer-a-friend/admin/idp-raf-admin-status-popup.html','<div id="{{::vm.popupId}}" role="dialog" class="pulseapp"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="modal-header"><h4 class="modal-title">Change Referral Status</h4><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><h5>You are about to change the status of the referral:</h5><div class="container-fluid"><div class="row my-2"><div class="col-4"><strong>Used By:</strong></div><div class="col">{{vm.referral.couponUsedFor}}</div></div><div class="row my-2"><div class="col-4"><strong>Status:</strong></div><div class="col">{{vm.referral.statusTypeString}}</div></div><div class="row my-2"><div class="d-none d-xs-block col-4"></div><div class="col form-group"><select id="newStatusID" name="newStatusID" class="form-control id-standard" ng-model="vm.newStatusID" ng-options="+(status.typeID) as status.typeString for status in vm.filteredStatusTypes" ng-required="true"><option value="">Select new status</option></select><div ng-messages="vm.myForm.newStatusID.$error" class="text-danger"><div ng-message="required">required</div></div></div></div></div></div><div class="modal-footer row mx-0"><div class="col-12 col-offset-0 col-md-5 col-md-offset-4 mr-0"><button class="btn btn-primary btn-block" type="submit" ng-class="{disabled: vm.saveDisabled}" ng-disabled="vm.saveDisabled" ng-dblclick="false">Save changes</button></div><div class="col-12 col-md-4 mt-2 mt-md-0 ml-0"><button class="btn btn-outline-secondary btn-block" type="button" ng-click="vm.close()">Cancel</button></div></div></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/avail-chart/idp-avc-contact-info.html','<ng-form name="{{::vm.formName}}" novalidate idp-form-focus-on-err><fieldset ng-disabled="vm.isDisabled"><label ng-if="vm.hasLabel">{{ ::vm.labelContent }}</label><div class="form-group id-required"><input name="emailAddress" type="email" class="form-control id-standard" ng-model="vm.parentInfo.emailAddress" placeholder="{{ ::vm.fieldPlaceholder }}" ng-required="true" ng-maxlength="200" uib-tooltip="Your Email Address" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.emailAddress.$error" class="text-danger" ng-hide="vm.myForm.emailAddress.$pristine && !vm.myForm.$submitted"><div ng-message="required">Your email address is required</div><div ng-message="email">Invalid email address</div><div ng-message="maxlength">Your email address cannot exceed 200 characters</div></div></div></fieldset></ng-form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/avail-chart/idp-avc-course-added-popup.html','<div id="{{::vm.popupId}}" role="dialog" class="pulseapp p-3"><div class="modal-header"><div class="modal-title"><span class="h4">{{::vm.initDataObj.mainProduct.name}}</span> <span class="font-weight-normal">has been added to your cart!</span></div></div><div class="modal-body text-center" ng-show="!vm.initDataObj.shoppingCartHasCampAtHqProduct"><h3 class="text-strong pb-3">Add another course or student and save<span ng-if="vm.Discount != null"> {{ vm.Discount.amount | currency : -vm.Discount.currencyTypeID : 0 }}</span>!</h3><p class="mb-1">Practice makes perfect! Students who attend multiple sessions gain accelerated mastery, giving them a head start on their long-term skill development pathways.</p></div><div class="modal-footer border-top-0"><div class="row flex-grow-1 justify-content-center"><div class="col-12 col-md-9 form-group"><button class="btn btn-primary btn-block" ng-dblclick="false" ng-click="vm.close()" idp-click-tracking data-id-div-abbr="{{::vm.getDivisionAbbr()}}" data-id-product-id="{{::vm.initDataObj.mainProduct.productID}}" data-id-location-id="{{::vm.initDataObj.mainProduct.locationID}}">Add another course or student</button></div><div class="col-12 col-md-9 form-group"><button class="btn btn-outline-secondary btn-block" type="button" ng-click="vm.initDataObj.parentCtlr.checkout()" idp-click-tracking data-id-div-abbr="{{::vm.getDivisionAbbr()}}" data-id-product-id="{{::vm.initDataObj.mainProduct.productID}}" data-id-location-id="{{::vm.initDataObj.mainProduct.locationID}}">Checkout</button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/avail-chart/idp-avc-info-popup.html','<div ng-cloak class="modal-content-padded"><div class="modal-header"><h3><strong>{{::vm.prodDTO.name}}</strong></h3></div><div class="modal-body"><p><span ng-bind-html="::vm.prodDTO.description | unsafe"></span></p><ul class="list-unstyled"><li><strong>Ages:</strong> {{::vm.prodDTO.minimumAge}}-{{::vm.prodDTO.maximumAge}}<span ng-if="vm.prodDTO.programTypeID == vm.AlexaDivisionProgramTypeID">, All-Girls</span></li><li><strong>Level:</strong> {{ vm.initDataObj.course | getSkillLevelDesc}}</li><li><strong>Hours:</strong><div ng-repeat="prod_Info in vm.initDataObj.prodInfos" class="modal-content-padded"><strong>{{ prod_Info.headline }}</strong><div ng-bind-html="::prod_Info.scheduleDescriptor | unsafe"></div></div></li></ul><div ng-if="vm.initDataObj.prereqList.length > 0"><strong>Prerequisites</strong><br><p ng-repeat="prereq in vm.initDataObj.prereqList track by $index">{{::prereq}}</p></div><strong>Need more details?</strong><p><a target="_blank" href="{{ vm.initDataObj.prodDetailFullUrl }}">View Course Page</a></p></div><div class="modal-footer"><a class="hidden-xs" ng-click="vm.close()" data-dismiss="modal">Ok, Got it!</a> <button class="btn btn-block btn-secondary visible-xs" ng-click="vm.close()" data-dismiss="modal">Ok, Got it!</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/avail-chart/idp-avc-select-prod.html','<ng-form name="{{::vm.formName}}" novalidate idp-form-focus-on-err><div ng-if="vm.parentCtrl.initDataObj.salesCatalogType === $root.Enums.SalesCatalogType.StandardCamp"><div class="one-course" ng-if="vm.selectedProdInfos.length == 1"><div ng-if="vm.isJoinWaitlist" class="many-students-on-product"><idp-rf-avc-drawer-waitlist browsing-user="vm.userBrowsingMgr.currentUBSession.userBrowsingDTO" division="vm.division" form-name="vm.formName" location="vm.location" location-price="vm.getLocationPrice(vm.selectedProdInfos[0])" on-waitlist="vm.addedToWaitlist" product="vm.selectedProdInfos[0]" submit-fn="vm.joinWaitlist()" urls="vm.urls"></idp-rf-avc-drawer-waitlist></div><div ng-if="vm.isAddStudentMode == false && !vm.isJoinWaitlist" class="many-students-on-product"><header class="hidden-xs"><img ng-src="{{ vm.urls.thumbNailFullUrl }}"><h3 class="course-title">{{ vm.selectedProdInfos[0].name|courseTitleRemoveAM }}</h3><div ng-click="vm.removeCourseInline()" class="close close-inline-course">&#xD7;</div></header><ul class="list-of-students"><li ng-repeat="student in vm.participantsWithThisProduct"><span class="student-info">{{ student.firstName }} {{ student.lastName }} has already been added to this course.</span> <a class="hidden-xs" ng-href="#{{ vm.common.$rootScope.Routes.RegFlow_ShoppingCart }}">View Details</a></li></ul><button class="btn btn-primary btn-text-sm hidden-xs" type="button" ng-click="vm.addAnotherStudent()">ADD ANOTHER STUDENT</button> <button class="btn btn-primary btn-text-sm btn-block hidden-lg hidden-md hidden-sm" type="button" ng-click="vm.addAnotherStudent()">ADD ANOTHER STUDENT</button></div><div ng-if="vm.isAddStudentMode == true  && !vm.isJoinWaitlist"><header><div class="text-right hidden-xs"><div ng-click="vm.removeCourseInline()" class="close close-inline-course hidden-xs">&#xD7;</div></div><h3 class="course-title pull-left">{{ vm.prodInfos[0].name|courseTitleRemoveAM:vm.prodInfos.length }}</h3><idp-rf-avc-drawer-alerts ng-if="vm.selectedProdInfos[0].alerts.length > 0" alerts="vm.selectedProdInfos[0].alerts" filter-by-object="{typeID:$root.Enums.LocationSessionTextType.AlertNotes}" bootstrap-alert-type="\'warning\'"></idp-rf-avc-drawer-alerts><idp-rf-avc-drawer-alerts ng-if="vm.selectedProdInfos[0].alerts.length > 0" alerts="vm.selectedProdInfos[0].alerts" filter-by-object="{typeID:$root.Enums.LocationSessionTextType.CSAlertNotes}" bootstrap-alert-type="\'warning\'"></idp-rf-avc-drawer-alerts></header><div class="row"><div class="col-sm-5 left-content"><div class="flex-row-xs x-space-between-xs y-start-xs"><div class="section-headline-date flex-0-1-xs"><h4 ng-class="(vm.selectedProdInfos[0].isONPackage || vm.selectedProdInfos[0].isPMPackage) ? \'product-headline-night\' : \'product-headline-day\'">{{ vm.selectedProdInfos[0].headline }} <i ng-class="(vm.selectedProdInfos[0].isONPackage || vm.selectedProdInfos[0].isPMPackage) ? \'icon-gl-moon\' : \'icon-gl-sun\'"></i></h4><h4 class="product-date hidden-xs">{{ vm.prodInfos[0].sessionStart | date:\'MMM d\'}}-{{ vm.prodInfos[0].sessionEnd | date:\'d\'}}</h4></div><div class="product-price flex-0-0-xs"><idp-rf-avc-price-slash highlight-price-reductions="vm.selectedProdInfos[0].highlightPriceReductions" reference-price="vm.selectedProdInfos[0].price" location-price="vm.getLocationPrice(vm.selectedProdInfos[0])" program-status-type-id="vm.selectedProdInfos[0].programStatusTypeID"></idp-rf-avc-price-slash><ng-pluralize count="vm.division.daysPerSession | daysToWeeks" when="{ \'1\': \'1 Week\', \'other\': \'{{vm.division.daysPerSession | daysToWeeks}} Weeks\'}"></ng-pluralize></div></div><div class="clearfix"></div><img class="course-img hidden-xs" ng-src="{{ vm.urls.thumbNailFullUrl }}"><div class="product-description"><div ng-bind-html="vm.selectedProdInfos[0].scheduleDescriptor | unsafe"></div></div></div><div class="col-sm-7 right-content"><idp-avc-contact-info ng-if="!vm.pulseContext.isLoggedIn" title="Parent Email" form-name="contactForm" parent-info="vm.userBrowsingMgr.currentUBSession.userBrowsingDTO"></idp-avc-contact-info><br><label>student info</label><idp-avc-participant form-name="campMainProd_partForm_{{::vm.formName}}" participant="vm.participant" is-already-in-cart="vm.isAlreadyInCart" min-date="vm.minDate" max-date="vm.maxDate"></idp-avc-participant><label class="addons-label"><span ng-show="vm.selectedProdInfos[0].options.length">Add-ons</span></label><ul ng-show="vm.selectedProdInfos[0].options.length"><li class="addon" ng-repeat="option in vm.selectedProdInfos[0].options"><div class="flex-row-xs x-start-xs y-start-xs align-start-xs"><div class="flex-0-0-xs" ng-click="vm.manipulateOption(vm.selectedProdInfos[0], option)"><div class="default-checkbox" ng-class="{\'disabled\': !vm.isOptionAvailable(vm.selectedProdInfos[0], option)}"><input id="addon-option_{{$index}}" name="addon-option_{{$index}}" type="checkbox" ng-model="option.isChecked" disabled="disabled"> <label for="addon-option_{{$index}}"></label></div></div><div class="flex-1-1-xs"><div><label class="option-description" for="addon-option_{{$index}}" ng-click="vm.manipulateOption(vm.selectedProdInfos[0], option)">{{ option.name }}</label> <img class="display_popover hidden-xs" ng-src="{{::vm.common.config.appRoot}}assets/images/icons/rounded-info-button.svg" uib-popover-template="\'addon-popover-template.html\'" popover-title="{{ option.name }}" popover-trigger="outsideClick" popover-placement="auto bottom"> <img id="option-popup-info-icon{{$index}}" class="display_popover hidden-sm hidden-md hidden-lg" ng-src="{{::vm.common.config.appRoot}}assets/images/icons/rounded-info-button.svg" ng-click="vm.common.showHelpPopup(Pulse.Directives.HelpPopup.HelpContentType.OptionInfo, option.name, option.description, \'option-popup-info-icon\'+$index)"></div><p class="option-unavailable" ng-hide="vm.isOptionAvailable(vm.selectedProdInfos[0], option)"></p></div><div class="price flex-0-0-xs"><strong>{{ option.price | currency:\'$\':2 }}</strong></div></div><div class="col-sm-offset-1 option-message" ng-show="option.message">{{option.message}}</div></li></ul><button class="btn btn-block btn-primary btn-text-sm hidden-xs" ng-click="vm.addProductToCart()">ADD STUDENT</button> <button class="btn btn-block btn-primary btn-text-sm hidden-lg hidden-md hidden-sm" ng-click="vm.addProductToCart()">DONE</button><h5 class="hidden-lg hidden-md hidden-sm text-center cancel-course-inline" ng-click="vm.removeCourseInline()">CANCEL</h5></div></div></div></div><div class="two-courses" ng-if="vm.selectedProdInfos.length != 1"><header class="hidden-xs"><div ng-click="vm.removeCourseInline()" class="close close-inline-course hidden-xs">&#xD7;</div><div><img class="course-img" ng-src="{{ vm.urls.thumbNailFullUrl }}"><h3 class="course-title">{{ vm.prodInfos[0].name|courseTitleRemoveAM }}</h3></div></header><div class="section-choose-product row"><div class="col-xs-12 col-sm-6 m-day-left"><h4 class="spa-avc-type-152-{{ vm.prodInfos[0].programStatusTypeID }} program-status">{{vm.prodInfos[0].progStatusFiltered}}</h4><div class="flex-row-xs x-space-between-xs y-start-xs"><div class="section-headline-date flex-0-1-xs"><h4 class="product-headline-day">{{ vm.prodInfos[0].headline }} <i class="icon-gl-sun"></i></h4><h4 class="product-date hidden-xs">{{ vm.prodInfos[0].sessionStart | date:\'MMM d\'}}-{{ vm.prodInfos[0].sessionEnd | date:\'d\'}}</h4></div><div class="product-price flex-0-0-xs"><idp-rf-avc-price-slash highlight-price-reductions="vm.prodInfos[0].highlightPriceReductions" reference-price="vm.prodInfos[0].price" location-price="vm.getLocationPrice(vm.prodInfos[0])" program-status-type-id="vm.prodInfos[0].programStatusTypeID"></idp-rf-avc-price-slash><ng-pluralize count="vm.division.daysPerSession | daysToWeeks" when="{ \'1\': \'1 Week\', \'other\': \'{{vm.division.daysPerSession | daysToWeeks}} Weeks\'}"></ng-pluralize></div></div><div class="clearfix"></div><div class="product-description"><div ng-bind-html="vm.prodInfos[0].scheduleDescriptor | unsafe"></div></div><button ng-if="!vm.availChartMgr.isJoinWaitlist(vm.prodInfos[0])" class="btn btn-block btn-primary btn-text-sm btn-block" type="button" ng-click="vm.selectProduct(vm.prodInfos[0])" ng-disabled="!vm.availChartMgr.canSessionBeBought(vm.prodInfos[0])">ADD {{ vm.prodInfos[0].headline }}</button> <button ng-if="vm.availChartMgr.isJoinWaitlist(vm.prodInfos[0])" class="btn btn-block btn-primary btn-text-sm btn-block" type="button" ng-click="vm.selectProduct(vm.prodInfos[0])" ng-disabled="!vm.availChartMgr.canSessionBeBought(vm.prodInfos[0])">JOIN WAITLIST</button><div class="m-line-wr hidden-xs"><div class="m-line">or</div></div></div><div class="col-xs-12 hidden-sm hidden-md hidden-lg"><div class="product-divider"></div></div><div class="col-xs-12 col-sm-6 m-day-right"><h4 class="spa-avc-type-152-{{ vm.prodInfos[1].programStatusTypeID }} program-status">{{vm.prodInfos[1].progStatusFiltered}}</h4><div class="flex-row-xs x-space-between-xs y-start-xs"><div class="section-headline-date flex-0-1-xs"><h4 class="product-headline-night">{{ vm.prodInfos[1].headline }} <i class="icon-gl-moon"></i></h4><h4 class="product-date hidden-xs">{{ vm.prodInfos[0].sessionStart | date:\'MMM d\'}}-{{ vm.prodInfos[0].sessionEnd | date:\'d\'}}</h4></div><div class="product-price flex-0-0-xs"><idp-rf-avc-price-slash highlight-price-reductions="vm.prodInfos[1].highlightPriceReductions" reference-price="vm.prodInfos[1].price" location-price="vm.getLocationPrice(vm.prodInfos[1])" program-status-type-id="vm.prodInfos[1].programStatusTypeID"></idp-rf-avc-price-slash><ng-pluralize count="vm.division.daysPerSession | daysToWeeks" when="{ \'1\': \'1 Week\', \'other\': \'{{vm.division.daysPerSession | daysToWeeks}} Weeks\'}"></ng-pluralize></div></div><div class="clearfix"></div><div class="product-description"><div ng-bind-html="vm.prodInfos[1].scheduleDescriptor | unsafe"></div></div><button ng-if="!vm.availChartMgr.isJoinWaitlist(vm.prodInfos[1])" class="btn btn-block btn-primary btn-text-sm btn-block" type="button" ng-click="vm.selectProduct(vm.prodInfos[1])" ng-disabled="!vm.availChartMgr.canSessionBeBought(vm.prodInfos[1])">ADD {{ vm.prodInfos[1].headline }}</button> <button ng-if="vm.availChartMgr.isJoinWaitlist(vm.prodInfos[1])" class="btn btn-block btn-primary btn-text-sm btn-block" type="button" ng-click="vm.selectProduct(vm.prodInfos[1])" ng-disabled="!vm.availChartMgr.canSessionBeBought(vm.prodInfos[1])">JOIN WAITLIST</button></div></div></div></div></ng-form><script type="text/ng-template" id="addon-popover-template.html"><div>\n    <p ng-bind-html="option.description | unsafe "></p>\n  </div></script>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/avail-chart/idp-avc-selected-inline.html','<form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="false"><idp-avc-select-prod course="vm.initDataObj.course" division="vm.initDataObj.division" form-name="prodForm_{{::vm.formName}}" form-suffix="{{$index}}" location="vm.initDataObj.location" min-date="vm.minDateOfBirth" max-date="vm.maxDateOfBirth" prod-infos="vm.initDataObj.prodInfos" urls="vm.initDataObj.urls"></idp-avc-select-prod></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/loc-finder/idp-location-airport-popup.html','<div id="{{::vm.popupId}}" role="dialog" class="pulseapp"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">{{::vm.initDataObj.locationInfo.name}}</h4></div><div class="modal-body"><h4>Nearby Airports</h4><div ng-bind-html="vm.initDataObj.locationInfo.airportInfo | unsafe"></div><br><div class="well"><strong>Important Note:</strong><p>We do <strong>not</strong> provide airport pick-ups or drop offs.</p></div><hr></div><div class="modal-footer"><button type="button" class="btn btn-primary btn-block" data-dismiss="modal" ng-click="vm.close()" ng-dblclick="false">Close</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/loc-finder/idp-location-country.html','<li><div class="clickable" ng-click="vm.onHeaderClick()"><div class="d-inline-block icon" ng-class="{\'icon-chevron-right\': !vm.isExpanded(), \'icon-chevron-down\': vm.isExpanded() }"></div><h4 class="state-name d-inline-block">{{ ::vm.countryInfo.name }}</h4></div><ul class="poi-list" ng-show="vm.isExpanded()"><idp-location-physical loc-info="POI" ng-repeat="POI in vm.locations"></idp-location-physical></ul></li>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/loc-finder/idp-location-division.html','<span ng-class="vm.divId == 39 ? \'spa-alexa-logo-icon\' : \'spa-id-logo-icon\'" class="text-division-{{::vm.divId}}" title="{{::vm.divInfo.name}}"></span> &nbsp;');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/loc-finder/idp-location-list-global.html','<div class="container-fluid my-3"><div class="row px-8"><div class="col-sm-6 col-12 p-0" ng-repeat="chunk in vm.lookupCountries| genChunks:4 | genChunks:2 track by $index"><div class="row"><ul class="col-12 col-xl-6 country-list" ng-repeat="countries in chunk"><idp-location-country country-info="country" expanded-country-id="vm.expandedCountryID" ng-repeat="country in countries"></idp-location-country></ul></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/loc-finder/idp-location-list-us.html','<div class="container-fluid my-3"><div class="row px-8"><div class="col-sm-6 col-12 p-0" ng-repeat="chunk in vm.lookupUSStates| genChunks:4 | genChunks:2 track by $index"><div class="row"><ul class="col-12 col-xl-6 state-list" ng-repeat="states in chunk"><idp-location-state state-info="state" expanded-state-id="vm.expandedStateID" ng-repeat="state in states"></idp-location-state></ul></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/loc-finder/idp-location-map-popup.html','<div id="{{::vm.popupId}}" role="dialog" class="pulseapp"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">{{::vm.initDataObj.locationAddress.locName}}</h4></div><div class="modal-body"><div class="row"><div class="col-md-4"><p></p><address><strong>{{::vm.initDataObj.locationAddress.locName}}</strong><br><span ng-show="vm.initDataObj.locationAddress.addr1">{{::vm.initDataObj.locationAddress.addr1}}<br></span><span ng-show="vm.initDataObj.locationAddress.addr2">{{::vm.initDataObj.locationAddress.addr2}}<br></span><span ng-show="vm.initDataObj.locationAddress.addr3">{{::vm.initDataObj.locationAddress.addr3}}<br></span><span ng-show="vm.initDataObj.locationAddress.city">{{::vm.initDataObj.locationAddress.city}}<br></span><span ng-show="vm.initDataObj.locationAddress.zip">{{::vm.initDataObj.locationAddress.zip}}<br></span></address><p></p></div><div class="col-md-8"><ui-gmap-google-map center="vm.mapCenter" zoom="13" refresh="true" control="vm.map"><ui-gmap-marker idkey="vm.initDataObj.locationAddress.iD" coords="vm.markerPosition"></ui-gmap-marker></ui-gmap-google-map></div></div><hr></div><div class="modal-footer row"><div class="col-md-6"><p><a ng-href="http://www.google.com/maps/dir//{{::vm.initDataObj.locationAddress.lat}},{{::vm.initDataObj.locationAddress.lng}}" role="button" target="_blank" class="btn btn-primary btn-block">Get Directions</a></p></div><div class="col-md-6"><p><button type="button" class="btn btn-primary btn-block" data-dismiss="modal" ng-click="vm.close()" ng-dblclick="false">Close</button></p></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/loc-finder/idp-location-physical.html','<li ng-click="vm.selectLocation()"><h4 class="poi-name my-1">{{::vm.locInfo.name}} <i ng-show="vm.hasDayClasses()" class="icon icon-day pl-1 pr-0"></i> <i ng-show="vm.hasNightClasses()" class="icon icon-night pl-1 pr-0"></i></h4><h4 class="poi-address text-muted mt-1 mb-3">{{::vm.locInfo.addrArea}}</h4></li>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/loc-finder/idp-location-state.html','<li><div class="clickable" ng-click="vm.onHeaderClick()"><div class="d-inline-block icon" ng-class="{\'icon-chevron-right\': !vm.isExpanded(), \'icon-chevron-down\': vm.isExpanded() }"></div><h4 class="state-name d-inline-block">{{ ::vm.stateInfo.name }}</h4></div><ul class="poi-list" ng-show="vm.isExpanded()"><idp-location-physical loc-info="POI" ng-repeat="POI in vm.locations"></idp-location-physical></ul></li>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/order-summary/idp-student-merge-popup.html','<div id="{{::vm.popupId}}" ng-form="{{::vm.formName}}" ng-cloak><div><div class="modal-header"><h3 class="modal-title">Student Information</h3><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.close()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div class="panel-prompt text-em-1-2">It looks like this student is already in our system:</div><p class="pl-3">{{::vm.participant.firstName}} {{::vm.participant.lastName}}<br>{{::((vm.participant.genderTypeID == $root.Enums.GenderType.Female) ? "Female" : "Male")}}<br>Date of birth:&nbsp;<span data-ng-bind="vm.participant.dateOfBirth | date:\'MM.dd.yyyy\'"></span></p><div class="panel-prompt text-em-1-2 mb-3">Update information for the previously registered student below?</div><div class="form-check" data-ng-repeat="student in vm.matchingStudentCandidates | orderBy:[\'-matchScore\', \'firstName\'] track by student.userID"><input class="form-check-input form-control" type="radio" name="matchingStudentUserID" data-ng-value="student.userID" data-ng-model="vm.selectedUserID"> <label for="{{ matchingStudentUserID }}" ng-click="vm.onStudentSelected($event, student.userID)" class="form-check-label">{{::student.firstName}} {{::student.lastName}}, {{::((student.genderTypeID == $root.Enums.GenderType.Female) ? "Female" : "Male")}} <span data-ng-bind="student.dateOfBirth | date:\'MM.dd.yyyy\'"></span></label></div><div class="form-check"><input class="form-check-input" type="radio" name="matchingStudentUserID" ng-value="0" data-ng-model="vm.selectedUserID"> <label for="matchingStudentUserID" class="form-check-label" ng-click="vm.onStudentSelected($event, 0)">No. This is a new student</label></div></div><div class="modal-footer"><button class="btn btn-primary" type="button" ng-click="vm.saveAndContinue()">Save and continue</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-age-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div id="content" class="container-fluid" style="width:100%"><fieldset><legend>{{::vm.title}}</legend><p>To enroll, student must turn the age of {{::vm.initDataObj.minAge}} by {{::vm.minAgeCheckDate | date:\'longDate\'}}.</p></fieldset></div></div><div class="modal-footer row"><div class="col-sm-4 col-sm-offset-4"><div class="form-group"><button class="button no-icon" ng-click="vm.close()" ng-dblclick="false">Close</button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-camp-term.html','<div class="panel panel-default panel-division-{{::vm.termDivInfo.divID}}" ng-if="vm.hasCourses"><div class="panel-heading" ng-click="vm.onSelect(); isCollapsed = !isCollapsed" ng-class="{\'collapsed\': !isCollapsed}"><div class="panel-title row vertical-align"><div class="col-xs-11"><strong>{{::vm.divName}}<span ng-if="vm.scheduleType">{{::vm.scheduleType}}</span></strong><br><small>Ages {{::vm.ageRange}}, {{::vm.programType}}</small></div><div class="col-xs-1"><span class="pull-right spa-arrow-right-icon"></span></div></div></div><div id="collapse{{::vm.id}}" class="panel-collapse" uib-collapse="!isCollapsed"><div class="panel-body" ng-show="vm.courses.length > 0"><table class="table table-bordered table-responsive spa-table-avc visible-lg hidden-md hidden-sm hidden-xs visible-print"><tr><th class="col-lg-2 text-uppercase">Course</th><th class="text-uppercase text-center col-lg-1" ng-repeat="session in vm.sessions"><strong>{{vm.formatSessionDates(session.start, session.displayEnd)}}</strong></th></tr><tr ng-repeat="course in vm.courses"><td><img class="img-responsive" ng-src="{{::vm.getThumbNailFullUrl(course)}}"><h5><strong>{{::course.name}}</strong></h5><ul class="list-unstyled text-muted"><li>Duration: {{vm.duration}}</li><li>Ages: {{::course.minAge}} - {{::course.maxAge}}</li><li>Level: <span>{{vm.getSkillLevelDesc(course)}}</span></li><li><a ng-click="vm.showCourseInfo(course)">Course Info</a></li></ul></td><td style="vertical-align:middle" class="text-uppercase text-center" ng-class="vm.showButtonStatuses.indexOf(product.programStatus) > -1 ? \'spa-cursor-pointer\' : \'\'" ng-repeat="courseSession in course.sessions" ng-click="vm.selectProdPopup(course, courseSession)"><strong><span style="padding-left:5px; padding-right:5px;" class="session-status-{{::courseSession.programStatusTypeID}}">{{vm.formatCourseSessionAvailabilityStatusType(courseSession)}}</span><br><span ng-if="vm.showMainPrice(courseSession)">From ${{courseSession.price}}</span></strong></td></tr></table><div ng-repeat="course in vm.courses" class="hidden-lg visible-md visible-sm visible-xs hidden-print" id="courseDetailAccordion"><div class="panel panel-default"><div class="panel-body"><div class="row my-3" role="button"><div class="col-xs-4"><img class="img-responsive" ng-src="{{::vm.getThumbNailFullUrl(course)}}"></div><div class="col-xs-8"><h4><strong>{{::course.name}}</strong></h4><ul class="list-unstyled text-muted"><li>Duration: {{vm.duration}}</li><li>Ages: {{::course.minAge}} - {{::course.maxAge}}</li><li>Level: <span>{{vm.getSkillLevelDesc(course)}}</span></li></ul></div></div><div class="row my-3"><div class="col-sm-7"><div ng-click="vm.onSelectMobile(course); isOpenMobile = !isOpenMobile" ng-class="{\'collapsed\': !isOpenMobile}"><span ng-hide="isOpenMobile"><span class="btn btn-primary btn-block">View Availability</span> </span><span ng-hide="!isOpenMobile"><span class="btn btn-invert btn-block">Hide Availability</span></span></div></div><div class="col-sm-5"><div class="hidden-lg hidden-md hidden-sm">&nbsp;</div><button class="btn btn-change btn-block" ng-click="vm.showCourseInfo(course)">Course Info</button></div></div></div></div><div class="panel panel-default" id="collapseMobile{{::vm.id}}{{::course.prodID}}" uib-collapse="!isOpenMobile"><div class="panel-body panel-body-bordered" ng-repeat="courseSession in course.sessions"><div class="row my-3" ng-class="vm.showButtonStatuses.indexOf(courseSession.programStatus) > -1 ? \'spa-cursor-pointer\' : \'\'" ng-click="vm.selectProdPopup(course, courseSession)"><div class="col-xs-8 text-uppercase"><strong>{{vm.formatSessionDates(courseSession.startDate, courseSession.endDate)}}</strong></div><div class="col-xs-4 text-right text-uppercase"><strong><span style="padding-left:5px; padding-right:5px;" class="session-status-{{::courseSession.programStatusTypeID}}">{{vm.formatCourseSessionAvailabilityStatusType(courseSession)}}</span></strong></div></div></div></div><hr></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-camp.html','<div class="panel-group"><idp-avc-camp-term term-div-info="termDivInfo" location="vm.location" ng-repeat="termDivInfo in vm.selectedTermDivInfos"></idp-avc-camp-term></div><div ng-if="vm.otherTermDivInfos"><div class="row my-3"><div class="col-xs-12 text-center"><h3>Other Programs</h3></div></div><div class="clearfix"></div><div class="panel-group"><idp-avc-camp-term term-div-info="termDivInfo" location="vm.location" ng-repeat="termDivInfo in vm.otherTermDivInfos"></idp-avc-camp-term></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-info-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4><strong>{{::vm.prodDTO.name}}</strong></h4></div><div class="modal-body"><p class="text-justify"><span ng-bind-html="::vm.prodDTO.description | unsafe"></span></p><div class="list-group"><div class="list-group-item"><h4 class="list-group-item-heading">Ages</h4><p class="list-group-item-text">{{::vm.prodDTO.minimumAge}}-{{::vm.prodDTO.maximumAge}}</p></div><div class="list-group-item" ng-if="vm.initDataObj.prereqList.length > 0"><h4 class="list-group-item-heading">Prerequisites</h4><p class="list-group-item-text" ng-repeat="prereq in vm.initDataObj.prereqList track by $index">{{::prereq}}</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary btn-block" ng-click="vm.close()" data-dismiss="modal">Close</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-location.html','<div ng-if="!vm.singleLocMode"><div class="panel-group" id="locationAccordion"><div class="panel panel-nested-parent panel-default"><div class="panel-heading collapsed" role="tab" ng-click="vm.onHeaderClick();" data-toggle="collapse" href="#collapse{{::vm.location.iD}}"><div class="panel-title row my-3 vertical-align" role="button"><div class="col-xs-11">{{::vm.location.name}}</div><div class="col-xs-1"><span class="pull-right spa-arrow-right-icon"></span></div></div></div><div id="collapse{{::vm.location.iD}}" class="panel-collapse collapse" role="tabpanel"><div class="panel-body"><idp-avc-single-day ng-if="vm.hasOneDay" location="vm.location" date-ranges="vm.locOneDayDateRanges"></idp-avc-single-day><idp-avc-multi-day ng-if="vm.hasMultiWeek" location="vm.location" date-ranges="vm.locMultiWeekDateRanges"></idp-avc-multi-day><idp-avc-camp ng-if="vm.hasCamp" location="vm.location" term-div-infos="vm.termDivInfos"></idp-avc-camp></div></div></div></div></div><div ng-if="vm.singleLocMode"><h3>{{::vm.location.name}}</h3><idp-avc-single-day ng-if="vm.hasOneDay" location="vm.location" date-ranges="vm.locOneDayDateRanges"></idp-avc-single-day><idp-avc-multi-day ng-if="vm.hasMultiWeek" location="vm.location" date-ranges="vm.locMultiWeekDateRanges"></idp-avc-multi-day><idp-avc-camp ng-if="vm.hasCamp" location="vm.location" term-div-infos="vm.termDivInfos"></idp-avc-camp></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-multi-day-prod.html','<div style="border: 1px solid; margin: 1em; padding:1em;"><div class="row"><div class="col-md-2"><a ng-href="{{vm.productVideoFullUrl}}" ng-click="$event.stopPropagation();"><img ng-src="{{::vm.getThumbNailFullUrl}}"></a></div><div class="col-md-7"><b>{{::vm.productInfo.name}}</b><br>{{::vm.productInfo.numClasses}} Classes<br><a ng-click="vm.showAgePolicy(); $event.stopPropagation();">Ages {{::vm.productInfo.minimumAge}} - {{::vm.productInfo.maximumAge}}</a><div ng-show="vm.hasPrerequisites"><a ng-click="vm.showPrereq(); $event.stopPropagation();">Prerequisites</a></div></div><div class="col-md-2"><button style="width:10em;" ng-disabled="vm.getQtyAvailable() == 0" ng-click="vm.selectProdPopup()">{{vm.getAvailabilityString()}}</button> <button style="width:10em;" type="button" ng-click="vm.showMoreInfo()">More Info</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-multi-day.html','<div style="border: 1px solid; padding: 5px;"><h4 style="cursor:pointer;" ng-click="vm.onSelect()">{{ vm.isCollapsed ? \'+\' : \'-\' }} {{vm.location.name}} - Multi Day Courses</h4><div uib-collapse="vm.isCollapsed"><hr><center><table><tr><td><button ng-click="vm.prevDateRange()">&lt;</button></td><td><center>{{vm.selectedDateRange.displayName}}<br>{{vm.displayDateRange}}</center></td><td><button ng-click="vm.nextDateRange()">&gt;</button></td></tr></table></center><div class="row" style="padding-left:.5em; padding-right:.5em;" ng-repeat="productInfo in vm.uniqueProducts"><idp-avc-multi-day-prod product-info="productInfo"></idp-avc-multi-day-prod></div></div></div><br>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-options-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div id="content" class="container-fluid" style="width:100%"><h3>{{::vm.initDataObj.title}}</h3><dl><dt ng-bind-html="vm.initDataObj.programTitle | unsafe"></dt><dd ng-bind-html="vm.initDataObj.programDescription | unsafe"></dd><dt ng-repeat-start="i in vm.initDataObj.options">{{i.name}}</dt><dd ng-repeat-end>{{i.description}}</dd></dl></div></div><div class="modal-footer row"><div class="col-sm-4 col-sm-offset-4"><div class="form-group"><button class="button no-icon" ng-click="vm.close()" ng-dblclick="false">Close</button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-participant.html','<ng-form name="{{::vm.formName}}" novalidate idp-form-focus-on-err><fieldset ng-disabled="vm.isAlreadyInCart"><div class="row" ng-show="vm.isShowSelectParticipant"><div class="col-md-12"><div class="form-group"><select ng-model="vm.selectedUB" class="form-control id-standard" ng-options="vm.getFullName(UB) for UB in vm.userBrowsingMgr.currentUBSession.relatedUB_DTOs" ng-change="vm.onSelectParticipant()"><option value="">Select or enter new student</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group id-required"><input name="firstName" class="form-control id-standard" ng-disabled="!vm.canEdit" ng-model="vm.selectedUB.firstName" placeholder="Student First name" ng-required="true" uib-tooltip="Student First name" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.firstName.$error" class="text-danger"><div ng-message="required">Student first name is required</div></div></div></div><div class="col-md-6"><div class="form-group id-required"><input name="lastName" class="form-control id-standard" ng-disabled="!vm.canEdit" ng-model="vm.selectedUB.lastName" placeholder="Student Last name" ng-required="true" uib-tooltip="Student Last name" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.lastName.$error" class="text-danger"><div ng-message="required">Student last name is required</div></div></div></div></div><div class="row"><div class="col-md-12" uib-tooltip="Date of Birth" tooltip-trigger="\'focus\'"><div class="form-group id-required"><idp-date-picker date="vm.selectedUB.dateOfBirth" min-date="vm.pulseContext.isImpersonating ? vm.csImpersonatingMinDate : vm.minDate" max-date="vm.pulseContext.isImpersonating ? vm.csImpersonatingMaxDate : vm.maxDate" is-edit-mode="vm.canEdit" is-required="true"></idp-date-picker></div></div></div><div class="row"><div class="col-md-12"><div class="form-group id-required"><idp-gender gender-type-id="vm.selectedUB.genderTypeID" is-required="true" is-edit-mode="vm.canEdit"></idp-gender></div></div></div></fieldset></ng-form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-prereq-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><div id="content" class="container-fluid" style="width:100%"><fieldset><legend>{{::vm.title}}</legend><b>{{::vm.initDataObj.prodName}}</b><br><p>For the best experience, this course requires the following skills prior to enrolling:</p><p></p><ul><li ng-repeat="prereq in vm.initDataObj.prereqList track by $index">{{::prereq}}</li></ul><p></p></fieldset></div></div><div class="modal-footer row"><div class="col-sm-4 col-sm-offset-4"><div class="form-group"><button class="button no-icon" ng-click="vm.close()" ng-dblclick="false">Close</button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-select-prod.html','<ng-form name="{{::vm.formName}}" novalidate idp-form-focus-on-err><div ng-if="vm.parentCtrl.initDataObj.salesCatalogType === $root.Enums.SalesCatalogType.StandardCamp"><div class="row"><div class="col-xs-12"><div class="panel panel-default" ng-class="{\'panel-selected\' : vm.selectedProdInfos.indexOf(vm.campMainProd) != -1}"><div class="panel-heading"><div class="row vertical-align"><div class="col-xs-1"><span ng-class="vm.campMainProd.isONPackage ? \'spa-moon-icon\' : \'spa-sun-icon\'"></span></div><div class="col-xs-11"><strong>{{vm.campMainProd.headline}}</strong></div></div></div><div class="panel-body padded-content"><div class="row"><div class="col-xs-7"><div ng-bind-html="vm.campMainProd.scheduleDescriptor | unsafe"></div><p ng-if="vm.campMainProd.options && vm.campMainProd.options.length > 0"></p><ul><li ng-repeat="opt in vm.campMainProd.options"><strong>{{opt.name}}:</strong> Add ${{opt.price}}</li></ul><p></p></div><div class="col-xs-5 text-right"><p class="lead"><strong>{{vm.campMainProductPrice()}}</strong></p></div></div></div><div class="panel-footer"><span ng-hide="vm.selectedProdInfos.indexOf(vm.campMainProd) != -1"><button class="btn btn-block btn-primary" type="button" ng-click="vm.selectProduct(vm.campMainProd)">Add Student</button> </span><span ng-show="vm.selectedProdInfos.indexOf(vm.campMainProd) != -1"><idp-avc-participant-old form-name="campMainProd_partForm_{{::vm.formName}}" participant="vm.participant" is-already-in-cart="vm.isAlreadyInCart" min-date="vm.minDate" max-date="vm.maxDate"></idp-avc-participant-old><button class="btn btn-block btn-primary" ng-click="vm.parentCtrl.addToCart(vm.formSuffix, \'campMainProd_partForm_\' + vm.formName, vm.participant)">Add to Cart</button> <button class="btn btn-block btn-cancel" ng-click="vm.removeProduct(vm.campMainProd)">Cancel</button></span></div></div></div><div class="col-xs-12" ng-if="vm.campOptionProd && vm.hasOvernightOptionAvailable()"><div class="panel panel-default" ng-class="{\'panel-selected\' : vm.selectedProdInfos.indexOf(vm.campOptionProd) != -1}"><div class="panel-heading"><div class="row vertical-align"><div class="col-xs-1"><span ng-class="vm.campOptionProd.isONPackage ? \'spa-moon-icon\' : \'spa-sun-icon\'"></span></div><div class="col-xs-11"><strong>{{vm.campOptionProd.headline}}</strong></div></div></div><div class="panel-body padded-content"><div class="row"><div class="col-xs-7"><div ng-bind-html="vm.campOptionProd.scheduleDescriptor | unsafe"></div><p ng-class="{\'text-warning\' : !vm.isOvernightAllowedByAge()}">Ages {{vm.campOptionProd.minimumAge}}+</p><p ng-if="vm.campOptionProd.options && vm.campOptionProd.options.length > 0"></p><ul><li ng-repeat="opt in vm.campOptionProd.options"><strong>{{opt.name}}:</strong> Add ${{opt.price}}</li></ul><p></p></div><div class="col-xs-5 text-right"><p class="lead"><strong>{{vm.campOptionPrice()}}</strong></p></div></div></div><div class="panel-footer"><span ng-hide="vm.selectedProdInfos.indexOf(vm.campOptionProd) != -1"><button class="btn btn-block btn-primary" type="button" ng-click="vm.selectProduct(vm.campOptionProd)">Add Student</button> </span><span ng-show="vm.selectedProdInfos.indexOf(vm.campOptionProd) != -1"><idp-avc-participant-old form-name="campOptionProd_partForm_{{::vm.formName}}" participant="vm.participant" is-already-in-cart="vm.isAlreadyInCart" min-date="vm.minDate" max-date="vm.maxDate"></idp-avc-participant-old><button class="btn btn-block btn-primary" ng-click="vm.parentCtrl.addToCart(vm.formSuffix, \'campOptionProd_partForm_\' + vm.formName, vm.participant)">Add to Cart</button> <button class="btn btn-block btn-cancel" ng-click="vm.removeProduct(vm.campOptionProd)">Cancel</button></span></div></div></div></div><div class="row" ng-if="vm.campMainProd.alerts.length > 0"><div class="col-xs-12"><div class="alert alert-danger" ng-repeat="a in filtered = (vm.campMainProd.alerts | filter:{typeID:$root.Enums.LocationSessionTextType.CSAlertNotes})"><strong>{{a.title}}</strong><p>{{a.text}}</p></div><div class="alert alert-warning" ng-repeat="a in filtered = (vm.campMainProd.alerts | filter:{typeID:$root.Enums.LocationSessionTextType.AlertNotes})"><strong>{{a.title}}</strong><p>{{a.text}}</p></div></div></div><div class="row" ng-if="vm.campMainProd.prerequisities.length > 0"><div class="col-xs-12"><div class="alert alert-info"><strong>Prerequisites</strong><p>For the best experience, this course requires the following skills prior to enrolling:</p><ul><li ng-repeat="p in vm.campMainProd.prerequisities">{{p.skill}}</li></ul></div></div></div></div></ng-form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-selected-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4><strong>{{::vm.prodDTO.name}}</strong></h4></div><div class="modal-body"><h4>{{::vm.title}}</h4><div>{{::vm.prodDTO.sessionStart | date:\'longDate\'}} - {{::vm.prodDTO.sessionEnd | date:\'longDate\'}}</div><div class="row my-3"><div class="col-xs-12"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="false"><fieldset><div ng-repeat="participant in vm.participants track by $index"><div class="row" ng-show="vm.isAlreadyInCart(participant)"><div class="col-xs-12"><div class="panel panel-default"><div class="panel-body row vertical-align"><div class="col-xs-1"><span class="spa-checkmark-icon text-primary"></span></div><div class="col-xs-8"><span class="text-capitalize">{{participant.firstName}} {{participant.lastName}}</span> is in your cart for this course</div><div class="col-xs-3"><a class="pull-right" ng-click="vm.removeParticipant(participant)">Remove</a></div></div></div></div></div><div class="row" ng-hide="vm.isAlreadyInCart(participant)"><div class="col-xs-12"><idp-avc-select-prod-old form-name="prodForm_{{$index}}" participant="participant" is-already-in-cart="vm.isAlreadyInCart(participant)" prod-infos="vm.initDataObj.prodInfos" form-suffix="{{$index}}" min-date="vm.minDateOfBirth" max-date="vm.maxDateOfBirth"></idp-avc-select-prod-old></div></div></div></fieldset></form></div></div><div class="row" ng-show="(vm.participants.length == 0 || vm.isAlreadyInCart(vm.participants[vm.participants.length -1])) && !vm.isChangeOrder"><div class="col-xs-12"><button class="btn btn-block btn-primary" ng-click="vm.addParticipant()">Add Another Student</button></div></div></div><hr><div class="modal-footer row justify-content-center"><div ng-class="{ \'col-sm-6\': !vm.isChangeOrder, \'col-sm-3\': vm.isChangeOrder }"><button class="btn btn-cancel btn-block" ng-click="vm.close()" ng-dblclick="false" ng-if="!vm.isChangeOrder">Keep Shopping</button></div><div class="col-sm-6"><div class="visible-xs">&nbsp;</div><button class="btn btn-primary btn-block" ng-click="vm.checkout()" ng-dblclick="false">Checkout</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-single-day-prod.html','<div style="border: 1px solid; margin: 1em; padding:1em;"><div class="row" style="cursor:pointer;" ng-click="vm.onSelect()"><div class="col-md-2">{{ vm.isCollapsed ? \'+\' : \'-\' }} <a ng-href="{{vm.productVideoFullUrl}}" ng-click="$event.stopPropagation();"><img ng-src="{{::vm.getThumbNailFullUrl}}"></a></div><div class="col-md-10"><b>{{::vm.productInfo.name}}</b><br>Ages {{::vm.productInfo.minimumAge}} - {{::vm.productInfo.maximumAge}}<br><a ng-href="{{vm.productDetailFullUrl}}" ng-click="$event.stopPropagation();">Course Details</a></div></div><div uib-collapse="vm.isCollapsed"><hr><center><table><tr><td><button ng-click="vm.prevMonth()">&lt;&lt;</button></td><td><center>{{vm.displayMonth}}</center></td><td><button ng-click="vm.nextMonth()">&gt;&gt;</button></td></tr></table></center><div ng-repeat="prodDate in vm.selectedMonthProdDates"><table width="80%"><tr><td style="text-align:right">Price: &nbsp;</td><td>${{vm.getProductPrice(prodDate)}}</td><td style="text-align:right">Start: &nbsp;</td><td>{{prodDate.startTime | date:\'MM/dd/yyyy h:mm a\' }}</td><td style="text-align:right">End: &nbsp;</td><td>{{prodDate.endTime | date:\'MM/dd/yyyy h:mm a\' }}</td><td style="text-align:right">Availability: &nbsp;</td><td>{{vm.getAvailabilityString(prodDate)}} {{vm.getQtyAvailable(prodDate)}} left</td><td><button ng-show="vm.getQtyAvailable(prodDate)" ng-click="vm.selectProdPopup(prodDate)">Open</button></td></tr></table></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-single-day.html','<div style="border: 1px solid; padding: 5px;"><h4 style="cursor:pointer;" ng-click="vm.onSelect()">{{ vm.isCollapsed ? \'+\' : \'-\' }} iD Labs: {{vm.location.name}}</h4><div uib-collapse="vm.isCollapsed"><hr><center><table><tr><td><button ng-click="vm.prevDateRange()">&lt;</button></td><td><center>{{vm.selectedDateRange.displayName}}<br>{{vm.displayDateRange}}</center></td><td><button ng-click="vm.nextDateRange()">&gt;</button></td></tr></table></center><div class="row" style="padding-left:.5em; padding-right:.5em;" ng-repeat="productInfo in vm.uniqueProducts"><idp-avc-single-day-prod product-info="productInfo"></idp-avc-single-day-prod></div></div></div><br>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/old-avail-chart/idp-avc-waitlist-add.html','<div id="{{::vm.popupId}}" class="pulseapp"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.close()" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4><strong>{{vm.initDataObj.overlay}}</strong></h4><p>{{::vm.initDataObj.locationName}}</p></div><div class="modal-body"><p>You are joining the following waitlist:</p><dl class="dl-horizontal"><dt>Course</dt><dd>{{vm.initDataObj.overlay}}</dd><dt>Location</dt><dd>{{::vm.initDataObj.locationName}}</dd><dt>Date</dt><dd>{{::vm.initDataObj.sessionStart | date:\'longDate\'}} - {{::vm.initDataObj.sessionEnd | date:\'longDate\'}}</dd></dl>Should a space open up, you will be notified by email.<p></p><div class="well"><form name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div ng-if="!vm.addedToWailist"><div class="form-group"><input type="email" class="form-control" name="emailAddress" placeholder="Email address" ng-model="vm.emailAddress" ng-required="true" ng-maxlength="200" autocomplete="off" tabindex="100" uib-tooltip="Email address" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.emailAddress.$error" class="text-danger" ng-hide="vm.myForm.emailAddress.$pristine && !vm.myForm.$submitted"><div ng-message="required">Your email address is required</div><div ng-message="email">Invalid email address</div><div ng-message="maxlength">Your email address cannot exceed 200 characters</div></div></div><div class="form-group"><input type="email" class="form-control" name="confirmEmail" placeholder="Confirm email address" ng-model="vm.confirmEmail" ng-required="true" data-idp-match="vm.emailAddress" autocomplete="off" tabindex="101" uib-tooltip="Confirm email address" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.confirmEmail.$error" class="text-danger" ng-hide="vm.myForm.confirmEmail.$pristine && !vm.myForm.$submitted"><div ng-message="required">Please confirm your email address</div><div ng-message="email">Invalid email address</div><div ng-message="idpMatch">The email addresses must match</div></div></div><div class="form-group"><button class="btn btn-primary btn-block" id="btnJoin" type="submit" tabindex="102" ng-dblclick="false" ng-disabled="vm.btnJoinDisabled">Join Waitlist</button></div><a class="text-muted" ng-click="vm.showPrivacyPolicy()">Privacy Policy</a></div></form><div ng-if="vm.addedToWailist"><p>Thank you! You have been added to the waitlist.</p><button type="button" class="btn btn-primary btn-block" ng-click="vm.close()" data-dismiss="modal">Done</button></div></div><div class="list-group"><div class="list-group-item" ng-if="vm.hasNearestLocations"><h4 class="list-group-item-heading">Consider These Alternative Locations</h4><p class="list-group-item-text">These are the nearest locations that also offer this course and might have an open space:</p><ul><li ng-repeat="nLoc in vm.nearestLocations"><a ng-href="{{vm.common.config.WWW_UrlRoot+\'/\'+nLoc.url}}" target="_blank">{{nLoc.name}} - {{nLoc.distance}} mi</a></li></ul><p></p></div><div class="list-group-item" ng-if="!vm.hasNearestLocations"><h4 class="list-group-item-heading">Let us make a suggestion:</h4><p class="list-group-item-text">Please consider an alternate date or a different course.</p></div><div class="list-group-item"><h4 class="list-group-item-heading">Recommendations &amp; Terms of Use:</h4><p class="list-group-item-text"></p><ul><li>Have flexibility to enroll in an alternate course, week or location? We encourage you to enroll today - limited waitlist spaces tend to open up.</li><li>If a space opens up, all those on the waitlist will be notified by email. First come, first served.</li><li>As a courtesy, once you join the waitlist, you will receive monthly newsletters to keep you up to date with iD news, including new space added.</li><li>You must be 13 or older to submit this form.</li></ul><p></p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary btn-block" ng-click="vm.close()" data-dismiss="modal">Close</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-cross-sell-item.html','<div ng-show="vm.canSee" class="mb-5" ng-class="{\'cart-item disabled\': vm.isDisabled}"><div class="d-flex align-content-stretch"><div class="h3 e-width-6 flex-grow-0 flex-shrink-0"></div><div class="flex-grow-1 flex-shrink-1 flex-basis-0 mr-1"><div class="text-black"><img ng-src="{{::vm.getProdThumbUrl()}}" ng-show="vm.getProdThumbUrl()" class="mr-3" style="max-width: 2rem;" title="Product Thumbnail" alt="Product Thumbnail">{{::vm.itemName}} <span id="itemHelp-{{vm.participant.userID}}-{{vm.item.productID}}" class="icon icon-info c-pointer" ng-click="vm.showItemHelp()"><span class="sr-only">Additional Information</span></span></div><div ng-show="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART && vm.canItemBeRemoved"><button type="button" class="btn btn-link bg-white pl-0" style="cursor:pointer; pointer-events:all;" ng-click="vm.removeItem()" idp-click-tracking data-id-div-abbr="{{::vm.getDivisionAbbr(vm.item.divisionID)}}" data-id-product-id="{{::vm.item.productID}}" data-id-location-id="{{::vm.item.locationID}}">Remove</button></div></div><div class="flex-grow-0 flex-shrink-0 text-right text-black"><span ng-show="vm.isPriceVisible" style="white-space:nowrap;">{{vm.calculatedPrice | currency:vm.item.currencyTypeID:0}}</span></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-discount-apply.html','<div class="pb-4"><span class="icon icon-promo" aria-hidden="true">&nbsp;</span>Have a promo code, referral code or a voucher?</div><div class="form-group w-100" data-ng-form="{{::vm.formName}}"><div class="row"><div class="col-12 mb-2 col-md-8" ng-show="vm.promoCodeRequiresValidationString"><input id="validationString" name="validationString" type="text" ng-class="vm.myForm.promoCode.$valid ? \'\' : \'is-invalid\'" class="form-control" maxlength="100" placeholder="Enter validation string" uib-tooltip-html="vm.myForm.validationString.$valid ? \'Validation String\' : vm.myForm.validationString.$error.required ? \'Validation String is required\' : \'Validation String is not valid\'" tooltip-trigger="\'focus\'" data-ng-required="vm.promoCodeRequiresValidationString && vm.isValidationStringRequiredVisible" data-ng-model="vm.validationString" data-ng-change="vm.myForm.validationString.$setValidity(vm.acceptedErrorKey, true)" ng-keypress="$event.keyCode == 13 && ($event.preventDefault() || vm.verifyPromoCode())"><div ng-show="vm.myForm.validationString.$error" class="text-danger" role="alert"><div ng-show="vm.myForm.validationString.$error.required">Validation string is required</div></div></div><div class="d-none col-md-4">&nbsp;</div></div><div class="row"><div class="col-12 col-md-8"><input id="promoCode" name="promoCode" class="form-control" type="text" maxlength="100" placeholder="Enter promo code" aria-label="Enter promo code" uib-tooltip-html="vm.myForm.promoCode.$valid ? \'Promo Code\' : vm.myForm.promoCode.$error.required ? \'Promo Code is required\' : \'Promo Code is not valid\'" tooltip-trigger="\'focus\'" data-ng-model="vm.promoCode" data-ng-change="vm.resetPromoCodeErrorFlags()" ng-keypress="$event.keyCode == 13 && ($event.preventDefault() || vm.verifyPromoCode())"><div ng-show="vm.myForm.promoCode.$error" class="text-danger"><div ng-show="vm.myForm.promoCode.$error.missing">A promo code is required</div><div ng-show="vm.myForm.promoCode.$error.accepted && vm.cart.discounts.length == 0">The code could not be applied, it has failed one or more validation rules or has already been used</div><div ng-show="vm.myForm.promoCode.$error.accepted && vm.cart.discounts.length > 0">The code could not be applied, most likely due to the other discounts that have already been applied</div><div ng-show="vm.myForm.promoCode.$error.duplicate">You have already received this discount</div><div ng-show="vm.myForm.promoCode.$error.superceded">You can only have one promo discount, so we gave you the bigger one!</div><div ng-show="vm.myForm.promoCode.$error.serverWarning">{{vm.promoCodeServerWarning}}</div></div></div><div class="col-12 mt-2 col-md-4 mt-md-0"><button type="button" class="btn btn-outline-dark btn-block" ng-disabled="!vm.promoCode || (vm.promoCodeRequiresValidationString && !vm.validationString)" ng-click="vm.verifyPromoCode()">Apply</button></div></div><div class="row-fluid text-success">{{vm.promoCodeSuccessMessage}}</div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-discount-list.html','<idp-cart-discount cart-has-tax="vm.cartHasTax" discount="discount" data-ng-repeat="discount in vm.discounts"></idp-cart-discount>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-discount.html','<div class="row my-3"><div class="col-8 col-sm-9 text-md-right">{{::vm.discount.name}} <span id="discountHelp{{vm.discount.discountID}}" class="icon icon-info" ng-click="vm.showDiscountHelp()"><span class="sr-only">More about discount</span></span></div><div class="col-4 col-sm-3 text-right">-{{::vm.discount.amount | currency:vm.currencyTypeID:2}}</div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-fee-list.html','<idp-cart-fee fee="fee" ng-repeat="fee in vm.fees"></idp-cart-fee>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-fee.html','<div class="row"><div class="col-7 col-sm-8 text-md-right">{{::vm.fee.itemName}} <span id="feeHelp-{{vm.id}}" class="icon icon-info" ng-click="vm.showFeeHelp()"><span class="sr-only">Additional fee information</span></span></div><div class="col-5 col-sm-4 text-right">{{::vm.fee.itemPrice | currency:vm.fee.currencyTypeID:0}}</div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-item-group-with.html','<div class="row pt-1"><div class="col-12 mb-0 font-weight-bold"><i class="icon icon-students-icon text-em-1-2 mr-1" aria-hidden="true"></i> Group with a friend</div><div class="col-12" ng-show="vm.groupWithList && vm.groupWithList.length > 0">You have requested to group with the following friends:</div></div><div class="row"><div class="col my-1 ml-2"><div ng-repeat="buddy in vm.groupWithList track by $index">Friend {{$index + 1}}: <span class="font-weight-bold">{{buddy.firstName}} {{buddy.lastName}}</span></div></div></div><div class="row mb-1"><div class="col-12 col-md-7 col-lg-6 col-xl-5"><button type="button" class="d-flex align-items-center text-secondary c-pointer btn btn-link" id="groupWithAddButtonId" ng-click="vm.groupWith()"><i class="icon icon-plus-circle1 text-em-2-0 mr-2" aria-hidden="true"></i> Add friends</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-item-list.html','<div ng-if="!vm.isCrossSellItems"><idp-cart-item class="d-block" ng-class="{\'nologo-adjust\': vm.pulseContext.isRunningInPartnerDomain}" item="item" mode="vm.mode" ng-repeat="item in vm.items track by item.userBrowsingItemID"></idp-cart-item></div><div ng-if="vm.isCrossSellItems && vm.items && vm.items.length"><div class="text-black font-weight-bold py-3">Additional add-ons for {{vm.participant.firstName}}</div><idp-cart-cross-sell-item class="d-block" ng-class="{\'nologo-adjust\': vm.pulseContext.isRunningInPartnerDomain}" item="item" mode="vm.mode" ng-repeat="item in vm.items track by item.userBrowsingItemID"></idp-cart-cross-sell-item></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-item-option-list.html','<idp-cart-item-option class="d-block" option="option" mode="vm.mode" ng-repeat="option in vm.getOptionsWithoutOptionGroup()"></idp-cart-item-option><div class="my-3" ng-repeat="optionGroup in vm.optionGroups"><label class="text-uppercase font-weight-bold" ng-if="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART">{{ optionGroup.typeString }}</label><idp-cart-item-option class="d-block" option="option" mode="vm.mode" ng-repeat="option in vm.getOptionsByOptionGroupID(optionGroup.typeID)"></idp-cart-item-option></div><div style="margin-left:-2.2rem;" ng-class="{ \'p-2 p-md-4 bg-light\': vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART, \'p-0\': vm.mode == vm.ShoppingCartUIMode.MODE_ORDER_SUMMARY }" ng-if="vm.getAddOnMerchOptionsWithoutOptionGroup().length && (vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART || vm.hasSelectedAddOnMerchOptionsWithoutOptionGroup())"><div class="mb-3" ng-if="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART"><span class="font-weight-bold text-black mr-2">Add-ons</span>One-time price</div><idp-cart-item-option class="d-block" option="option" mode="vm.mode" ng-repeat="option in vm.getAddOnMerchOptionsWithoutOptionGroup()"></idp-cart-item-option></div><div style="margin-left:-2.2rem;" ng-class="{ \'p-2 p-md-4 bg-light\': vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART, \'p-0\': vm.mode == vm.ShoppingCartUIMode.MODE_ORDER_SUMMARY }" ng-if="vm.getRequiredMerchWithoutOptionGroup().length"><div class="mb-3" ng-if="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART"><span class="font-weight-bold text-black mr-2">Premium home delivery kit</span>one-time fee</div><idp-cart-item-option class="d-block" option="option" mode="vm.mode" ng-repeat="option in vm.getRequiredMerchWithoutOptionGroup()"></idp-cart-item-option></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-item-option.html','<div class="my-1" ng-show="vm.isVisible"><div class="d-flex justify-content-between" data-ng-if="vm.option.isSelected && vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART"><div class="form-check flex-grow-1 flex-shrink-1 flex-basis-0 mt-1" ng-class="{\'disabled\':vm.isDisabled}"><input id="itemOption-{{vm.id}}" name="itemOption-{{vm.id}}" type="checkbox" class="form-check-input" ng-if="!vm.hideCheckbox" ng-change="vm.handleCheckboxClick()" ng-model="vm.option.isSelected" ng-disabled="vm.hasRequiredStatus || vm.isDisabled" ng-readonly="vm.hasRequiredStatus && !vm.isDisabled"> <label class="form-check-label" style="margin-top:-0.5rem;" for="itemOption-{{vm.id}}"><div class="d-flex align-items-center"><img class="course-thumbnail e-width-7 rounded" ng-src="{{vm.productImage}}" ng-if="vm.productImage"><div class="flex-grow-1 flex-shrink-1 mx-2"><span ng-class="{\'cart-item disabled\':vm.isDisabled}"><span>{{::vm.getOptionName(vm.option)}}</span> <b ng-hide="vm.option.isSelected" style="white-space:nowrap;">: +{{::vm.option.itemPrice | currency:vm.option.currencyTypeID:0}}</b> </span><span id="itemOptionHelp{{vm.id}}" name="itemOptionHelp{{vm.id}}" class="icon icon-info" ng-click="vm.showOptionHelp($event)"><span class="sr-only">Additional Information</span></span><div ng-show="vm.hasMessage" class="text-danger" ng-bind-html="vm.getMessage() | unsafe"></div></div></div></label></div><div class="flex-grow-0 flex-shrink-0 text-right text-black" style="white-space:nowrap;">{{::vm.option.itemPrice | currency:vm.option.currencyTypeID:0}}</div></div><div class="d-flex justify-content-between align-items-center" data-ng-if="vm.option.isSelected && vm.mode != vm.ShoppingCartUIMode.MODE_SHOPPING_CART"><div class="d-flex align-items-center"><span ng-if="!vm.productImage" data-ng-class="{ \'icon icon-knife-fork\': vm.isMeals,\n                              \'icon icon-ceu\': vm.isCEU,\n                              \'icon icon-id-logo\': !(vm.isMeals || vm.isCEU) && !vm.pulseContext.isRunningInPartnerDomain\n                              }"></span> <img class="course-thumbnail e-width-7 rounded" ng-src="{{vm.productImage}}" ng-if="vm.productImage"><div class="text-black px-2"><div><span ng-class="{\'cart-item disabled\':vm.isDisabled}">{{::vm.getOptionName(vm.option)}}<span ng-hide="vm.option.isSelected" style="white-space:nowrap;">: {{::vm.option.itemPrice | currency:vm.option.currencyTypeID:0}}</span></span> <span id="itemOptionHelp{{vm.id}}" name="itemOptionHelp{{vm.id}}" class="icon icon-info" ng-click="vm.showOptionHelp($event)"><span class="sr-only">Additional Information</span></span></div><div ng-show="vm.hasMessage" class="text-danger" ng-bind-html="vm.getMessage() | unsafe"></div></div></div><div class="text-right pl-xs-1 text-black" style="white-space:nowrap;" ng-if="vm.mode != vm.ShoppingCartUIMode.MODE_MAKE_CHANGES">{{::vm.option.itemPrice | currency:vm.option.currencyTypeID:0}}</div></div><div class="d-flex" data-ng-if="!vm.option.isSelected && vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART && (vm.option.isValidForParticipantsAge || vm.pulseContext.isImpersonating)"><div class="form-check flex-grow-1 flex-shrink-1 flex-basis-0 mt-1" ng-class="{\'disabled\':vm.isDisabled}"><input id="itemOption-{{vm.id}}" name="itemOption-{{vm.id}}" type="checkbox" class="form-check-input" ng-if="!vm.hideCheckbox" ng-change="vm.handleCheckboxClick()" ng-model="vm.option.isSelected" ng-disabled="vm.hasRequiredStatus || vm.isDisabled" ng-readonly="vm.hasRequiredStatus && !vm.isDisabled"> <label for="itemOption-{{vm.id}}" class="form-check-label" style="margin-top:-0.5rem;"><div class="d-flex align-items-center"><img class="course-thumbnail e-width-7 rounded" ng-src="{{vm.productImage}}" ng-if="vm.productImage"><div class="flex-grow-1 flex-shrink-1 text-left mx-2"><div ng-class="{\'cart-item disabled\':vm.isDisabled}" class="text-black"><span data-ng-hide="vm.mode != vm.ShoppingCartUIMode.MODE_SHOPPING_CART"></span> <span>{{::vm.getOptionName(vm.option)}}</span> <span ng-hide="vm.option.isSelected" style="white-space:nowrap;">: +{{::vm.option.itemPrice | currency:vm.option.currencyTypeID:0}}</span> <span id="itemOptionHelp{{vm.id}}" name="itemOptionHelp{{vm.id}}" class="icon icon-info" ng-click="vm.showOptionHelp($event)"><span class="sr-only">Additional Information</span></span></div><div ng-show="vm.hasMessage" class="text-danger" ng-bind-html="vm.getMessage() | unsafe"></div></div><div class="flex-grow-0 flex-shrink-0 e-width-6">&nbsp;</div></div></label></div></div><div class="row" ng-if="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART && !vm.option.isAvailableForRegistration"><div class="col-1">&nbsp;</div><div class="col-11"><span class="text-danger">Currently unavailable.</span> <a ng-click="vm.showUnavailableDetails()">Details</a></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-item.html','<div ng-show="vm.canSee" class="mb-5" ng-class="{\'cart-item disabled\': vm.isDisabled}"><section ng-if="vm.isChangeCourseSessionCart"><h5 class="alert alert-dark p-1">Original Course</h5><div class="d-flex align-content-stretch"><div class="h3 e-width-6 flex-grow-0 flex-shrink-0"><span aria-hidden="true" class="text-primary" data-ng-class="{ \'icon icon-id-logo\' : !vm.pulseContext.isRunningInPartnerDomain }"></span></div><div class="flex-grow-1 flex-shrink-1 flex-basis-0 mr-1">{{::vm.getItemName(vm.changeFromItem)}}</div></div><div class="d-flex align-content-stretch" ng-if="vm.changeFromItem.spd_StartDateTime || vm.changeFromItem.options.length"><div class="e-width-6 flex-grow-0 flex-shrink-0"><span aria-hidden="true" data-ng-class="{ \'icon icon-id-logo\' : vm.isAfterSchool && !vm.pulseContext.isRunningInPartnerDomain,\n              \'icon icon-night\' : vm.isOvernightCamp(vm.changeFromItem),\n              \'icon icon-day\' : vm.isDayCamp(vm.changeFromItem) }">&nbsp;</span></div><div class="flex-grow-1 flex-shrink-1"><span ng-show="vm.isDayCamp(vm.changeFromItem)">Day Camp: {{::vm.changeFromItem.dateRange}}</span> <span ng-show="vm.isOvernightCamp(vm.changeFromItem)">Overnight Camp: {{::vm.changeFromItem.dateRange}}</span> <span ng-show="vm.isItemAfterSchool(vm.changeFromItem)">After School Program: {{::vm.changeFromItem.dateRange}}</span><idp-cart-item-option-list class="d-block" options="vm.changeFromItem.options" mode="vm.ShoppingCartUIMode.MODE_MAKE_CHANGES"></idp-cart-item-option-list></div></div><h5 class="alert alert-warning p-1">Replace with Course</h5></section><div class="d-flex align-content-stretch"><div class="h3 e-width-6 flex-grow-0 flex-shrink-0"><span aria-hidden="true" class="text-primary" data-ng-class="{ \'icon icon-id-logo\' : !vm.pulseContext.isRunningInPartnerDomain }"></span></div><div class="flex-grow-1 flex-shrink-1 flex-basis-0 mr-2"><div class="text-black">{{::vm.itemName}}</div><div class="text-small pt-2" ng-if="vm.isItemATutorProduct && vm.item.isAutoRenew">Price auto-renews every month on the {{vm.getMonthlyRenewalDayOrdinal()}}</div></div><div class="flex-grow-0 flex-shrink-0 text-right text-black"><span ng-show="vm.isPriceVisible" style="white-space:nowrap;">{{vm.calculatedPrice | currency:vm.item.currencyTypeID:0}}</span></div></div><div class="d-flex align-content-stretch" ng-if="vm.item.spd_StartDateTime || vm.options.length"><div class="e-width-6 flex-grow-0 flex-shrink-0"><span aria-hidden="true" data-ng-class="{ \'icon icon-id-logo\' : vm.isAfterSchool && !vm.pulseContext.isRunningInPartnerDomain,\n                            \'icon icon-night\' : vm.isOvernightCamp(vm.item),\n                            \'icon icon-day\' : vm.isDayCamp(vm.item) }">&nbsp;</span></div><div class="flex-grow-1 flex-shrink-1"><div ng-if="vm.item.dateRange && !vm.isItemATutorProduct"><div tabindex="0"><span><span ng-show="vm.isDayCamp(vm.item)">Day Camp: </span><span ng-show="vm.isOvernightCamp(vm.item)">Overnight Camp: </span><span ng-show="vm.isItemVirtualCamp(vm.item)">Online Program: </span><span ng-show="vm.isAfterSchool">After School Program: </span><span>{{::vm.item.dateRange}}</span></span></div><span ng-show="vm.pulseContext.canOverrideRegFlowRestrictions && vm.hasAdminOverride" class="text-danger">Overridden</span><div ng-show="vm.showSwitchToOvernightCamp"><button type="button" class="btn btn-link bg-white pl-0" style="cursor:pointer;" ng-click="vm.switchPrimaryOption()">Switch to Overnight Camp: +{{:: vm.itemOption_Overnight.itemPrice | currency:vm.itemOption_Overnight.currencyTypeID:0}}</button></div><div ng-show="vm.showSwitchToDayCamp"><button type="button" class="btn btn-link bg-white pl-0" style="cursor:pointer; pointer-events:all;" ng-click="vm.switchPrimaryOption()">Switch to Day Camp</button></div></div><div ng-show="vm.isDisabled" class="text-danger">{{::vm.isDisabledReason}}</div><idp-cart-item-option-list class="d-block" options="vm.options" mode="vm.mode"></idp-cart-item-option-list></div></div><div class="d-flex align-content-stretch"><div class="e-width-6 flex-grow-0 flex-shrink-0"></div><div class="flex-grow-1 flex-shrink-1"><div class="pt-2" ng-if="(vm.isItemSquads || vm.isItemVirtualCamp(vm.item)) && vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART"><idp-cart-item-group-with item="vm.item" mode="vm.mode"></idp-cart-item-group-with></div><div ng-show="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART && vm.canItemBeRemoved"><button type="button" class="btn btn-link bg-white pl-0" style="cursor:pointer; pointer-events:all;" ng-click="vm.removeItem()" idp-click-tracking data-id-div-abbr="{{::vm.getDivisionAbbr(vm.item.divisionID)}}" data-id-product-id="{{::vm.item.productID}}" data-id-location-id="{{::vm.item.locationID}}">Remove Course<span class="sr-only"> {{ :: vm.itemName }}</span></button></div></div></div></div><div class="row my-3 border-bottom border-dark" ng-if="vm.showEdit"><div class="col-12 mb-1"><button type="button" class="btn btn-link bg-white pl-0 pb-1" data-ng-click="vm.toggleEditMode()">Edit</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-non-participant-item-list.html','<idp-cart-non-participant-item item="item" mode="vm.mode" ng-repeat="item in vm.items track by item.userBrowsingItemID"></idp-cart-non-participant-item>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-non-participant-item.html','<div class="mb-3" ng-class="{\'cart-item disabled\': vm.isDisabled}"><div class="d-flex"><div class="h3 e-width-6 flex-grow-0 flex-shrink-0 mb-0 mr-1"><span aria-hidden="true" class="text-primary h3" data-ng-class="{ \'icon icon-id-logo\' : !vm.pulseContext.isRunningInPartnerDomain }"></span></div><div class="flex-grow-1 flex-shrink-1"><div class="d-flex"><div class="flex-grow-1 flex-shrink-1">{{::vm.itemName}}</div><div class="flex-grow-0 flex-shrink-0 e-width-8 text-right"><span ng-show="vm.isPriceVisible">{{vm.calculatedPrice | currency:vm.item.currencyTypeID:0}}</span></div></div><div><button class="btn btn-link px-0 py-1" ng-show="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART && vm.canItemBeRemoved" ng-click="vm.removeItem()">Remove</button></div><div class="text-danger" ng-show="vm.isDisabled">{{::vm.isDisabledReason}}</div></div></div><div class="row" ng-show="vm.mode == vm.ShoppingCartUIMode.MODE_ORDER_SUMMARY"><div class="col-12"><button type="button" class="btn btn-link bg-white pl-0" data-ng-click="vm.toggleEditMode()">Edit</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-participant-list.html','<div class="border-bottom mb-3" ng-repeat="participant in vm.participantsHavingAtLeastOneCourse track by participant.userBrowsingID"><div class="text-uppercase text-black font-weight-bold mb-1">STUDENT {{$index+1}}</div><idp-cart-participant class="d-block" participant="participant" first-tab-index="$index*10" tee-shirt-size-types="vm.teeShirtSizeTypes" tee-shirt-size-dict="vm.teeShirtSizeDict" user-relation-types="vm.userRelationTypes" user-relation-dict="vm.userRelationDict" mode="vm.mode"></idp-cart-participant></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart-participant.html','<div data-ng-cloak data-ng-form="{{::vm.formName}}"><div class="alert alert-warning" role="alert" data-ng-show="vm.isMatchStudentPromptVisible">This student may already be in our system.<br><a href="javascript:void(0)" data-ng-click="vm.matchStudent()">View and confirm</a></div><div class="row text-black" ng-hide="vm.editMode"><div class="col-12">{{vm.participant.firstName | limitTo: 25 }}{{vm.participant.firstName.length > 25 ? \'...\' : \'\'}} {{vm.participant.lastName | limitTo: 25 }}{{vm.participant.lastName.length > 25 ? \'...\' : \'\'}}</div></div><div class="row" ng-show="vm.editMode"><div class="col-md-6"><div class="form-group"><input id="studentFirstName{{::vm.participant.userBrowsingID}}" name="studentFirstName" type="text" class="form-control" ng-model="vm.participant.firstName" ng-required="vm.editMode" maxlength="100" autocomplete="off" tabindex="vm.firstTabIndex" uib-tooltip-html="vm.myForm.studentFirstName.$valid ? \'First Name\' : vm.myForm.studentFirstName.$error.required ? \'First Name is required\' : \'First Name is not valid\'" aria-required="true" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.studentFirstName.$error" class="text-danger" role="alert"><div ng-message="required">Student first name is required</div></div></div></div><div class="col-md-6"><div class="form-group"><input id="studentLastName{{::vm.participant.userBrowsingID}}" name="studentLastName" uib-tooltip-html="vm.myForm.studentLastName.$valid ? \'Last Name\' : vm.myForm.studentLastName.$error.required ? \'Last Name is required\' : \'Last Name is not valid\'" tooltip-trigger="\'focus\'" type="text" class="form-control" data-ng-model="vm.participant.lastName" aria-required="true" maxlength="100" data-ng-required="vm.editMode" tabindex="vm.firstTabIndex+2"><div ng-messages="vm.myForm.studentLastName.$error" class="text-danger" role="alert"><div ng-message="required">Student last name is required</div></div></div></div></div><div class="row text-black"><div class="col-12"><span class="mr-2">Date of birth:</span><span data-ng-bind="vm.dateOfBirth | date:\'MM.dd.yyyy\'"></span><div ng-if="vm.editMode">&nbsp;</div></div></div><div class="row"><div class="col-12 mb-3 text-black"><idp-gender label-class="\'text-uppercase text-black font-weight-bold mb-1\'" label-font-size="\'16px\'" gender-type-id="vm.genderTypeID" radio-format="true" text-when-read-only="true" is-required="vm.editMode" is-edit-mode="vm.editMode"></idp-gender><div ng-hide="vm.editMode || vm.mode != vm.ShoppingCartUIMode.MODE_SHOPPING_CART"><button type="button" class="btn btn-link bg-white pl-0 pt-0" ng-click="vm.toggleEditMode()">Edit<span class="sr-only"> {{::vm.participant.firstName}} {{::vm.participant.lastName}}</span></button></div></div></div><div class="row" ng-show="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART"><div class="col-md-6 pb-3"><div class="form-group has-feedback"><input id="studentNickName{{::vm.participant.userBrowsingID}}" name="nickName" class="form-control" type="text" uib-tooltip="Student\'s preferred name" aria-label="Student\'s preferred name" tooltip-trigger="\'focus\'" maxlength="13" data-ng-model="vm.participant.nickName" tabindex="vm.firstTabIndex+4"> <button type="button" class="icon icon-info icon-btn feedback-icon btn-text" ng-click="vm.showNickNameHelp()"><span class="sr-only">More information about preferred name</span></button></div></div><div class="col-md-6"><div class="form-group"><select id="relationshipToStudent{{::vm.participant.userBrowsingID}}" name="relationshipToStudent" class="form-control" data-ng-model="vm.userRelationTypeID" data-ng-options="item.typeID as item.typeString for item in vm.userRelationTypes" ng-required="vm.doesParticipantHaveAtLeastOneCourse" aria-required="true" aria-label="Your relationship to student" uib-tooltip-html="vm.myForm.relationshipToStudent.$valid ? \'Your relationship to the student\' : vm.myForm.relationshipToStudent.$error.required ? \'Your relationship to the student is required\' : \'Your relationship to the student is not valid\'" tooltip-trigger="\'focus\'" tabindex="vm.firstTabIndex+5"><option value="">Your relationship to student</option></select><div ng-messages="vm.myForm.relationshipToStudent.$error" class="text-danger" role="alert"><div ng-message="required">Your relationship to the student is required</div></div></div></div></div><div class="row" ng-hide="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART || vm.doesParticipantHaveAtLeastOneCourse == false"><div class="col-12">Your relationship to the student: {{vm.getTypeString(vm.participant.userRelationTypeID, vm.userRelationDict)}}</div></div><div class="row" ng-hide="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART\n  || vm.doesParticipantHaveAtLeastOneCourse == false\n  || vm.participant.nickName == null\n  || vm.participant.nickName.length == 0"><div class="col-12">Preferred Name: {{vm.participant.nickName}}</div></div><div class="row" ng-if="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART && vm.areAllCoursesVirtual == false"><div class="col-md-6"><div class="form-group has-feedback"><select id="teeShirtSize{{vm.participant.userBrowsingID}}" name="teeShirtSizeTypeID" class="form-control rounded-right-0" data-ng-model="vm.participant.teeShirtSizeTypeID" data-ng-options="item.typeID as item.typeString for item in vm.teeShirtSizeTypes" uib-tooltip-html="vm.myForm.teeShirtSizeTypeID.$valid ? \'T-Shirt Size\' : vm.myForm.teeShirtSizeTypeID.$error.required ? \'T-Shirt Size is required\' : \'T-Shirt Size is not valid\'" tooltip-trigger="\'focus\'" ng-required="vm.doesParticipantHaveAtLeastOneCourse" aria-describedby="tshirtHelpText" aria-required="true" tabindex="vm.firstTabIndex+6"><option value="" selected="selected">T-Shirt Size</option></select> <button type="button" class="icon icon-info icon-btn feedback-icon mr-6 btn-text" ng-click="vm.showTeeShirtHelp()"><span class="sr-only">More information about T-Shirt sizes</span></button><div ng-messages="vm.myForm.teeShirtSizeTypeID.$error" class="text-danger" role="alert"><div ng-message="required">T-Shirt Size is required</div></div></div></div><div class="col-12"><span id="tshirtHelpText" class="form-text text-muted">Note: T-shirts are unisex and listed in U.S. sizes.</span></div></div><div class="row" ng-hide="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART || vm.areAllCoursesVirtual == true || vm.doesParticipantHaveAtLeastOneCourse == false"><div class="col-12">T-shirt size: {{vm.getTypeString(vm.participant.teeShirtSizeTypeID, vm.teeShirtSizeDict)}}</div><div class="col-12 pb-2 pt-1" ng-show="vm.mode == vm.ShoppingCartUIMode.MODE_ORDER_SUMMARY && vm.doesParticipantHaveAtLeastOneCourse"><button type="button" class="btn btn-link bg-white pl-0" ng-click="vm.toggleEditMode()">Edit</button></div></div><div class="row my-3"><div class="col-12"><strong class="text-uppercase text-black font-weight-bold" tabindex="0">Course Info</strong></div></div><idp-cart-item-list class="d-block" items="vm.participantItems" participant="vm.participant" mode="vm.mode"></idp-cart-item-list><idp-cart-item-list class="d-block" items="vm.participantCrossSellItems" is-cross-sell-items="true" participant="vm.participant" mode="vm.mode"></idp-cart-item-list><idp-cart-fee-list fees="vm.participant.fees"></idp-cart-fee-list><div class="row my-3 text-black"><div class="col-7 col-sm-8 text-md-right">{{vm.participant.firstName | limitTo: 15 }}\'s Total:</div><div class="col-5 col-sm-4 text-right"><strong>{{vm.total | currency:vm.currencyTypeID:0}}</strong></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/shopping-cart/idp-cart.html','<div data-ng-form="{{::vm.formName}}"><div ng-show="vm.mode === vm.ShoppingCartUIMode.MODE_SHOPPING_CART && vm.currencyTypesInCart && vm.currencyTypesInCart.length > 2"><h4 class="mb-3" style="font-weight:normal;" ng-show="!vm.pulseContext.selectedCurrencyTypeID">Your shopping cart contains products for more than one currency, but we can only process one currency at a time. Please select the currency you would like to process:</h4><div class="mb-3"><div class="form-group" uib-tooltip="Currency Type" tooltip-trigger="\'focus\'"><label for="currency_type" style="font-weight:bold;color:black;">Currency Type</label> <select name="currency_type" class="form-control" ng-model="vm.selectedCurrencyTypeID" ng-options="o.typeID as o.typeDescription for o in vm.currencyTypesInCart"></select></div></div></div><div ng-show="vm.pulseContext.selectedCurrencyTypeID || (vm.currencyTypesInCart && vm.currencyTypesInCart.length == 0)"><div class="pb-3 text-muted">Prices shown in {{vm.cart.currencyType.typeString}}</div><idp-cart-participant-list participants="vm.participants" mode="vm.mode"></idp-cart-participant-list><idp-cart-non-participant-item-list items="vm.nonParticipantItems" mode="vm.mode"></idp-cart-non-participant-item-list><div ng-show="vm.isCartRetrieved"><div class="bg-light p-4" ng-hide="vm.mode != vm.ShoppingCartUIMode.MODE_SHOPPING_CART || vm.isLoggedInUserTermStaff "><idp-cart-discount-apply stye="display: block;" class="row container" cart="vm.cart"></idp-cart-discount-apply></div><div class="row"><div class="col-12"><idp-cart-discount-list cart-has-tax="(vm.cart.tax > 0)" discounts="vm.groupedDiscounts"></idp-cart-discount-list></div></div><idp-cart-fee-list fees="vm.groupedFees"></idp-cart-fee-list><div class="row my-3 text-black" ng-show="vm.cart.balanceDueOnOriginalOrdersOtherOrderDetails > 0"><div class="col-7 col-sm-8 text-md-right">Previous Balance Due:</div><div class="col-5 col-sm-4 text-right">{{vm.cart.balanceDueOnOriginalOrdersOtherOrderDetails | currency:vm.selectedCurrencyTypeID:2}}</div></div><div class="row my-3 text-black" ng-show="vm.cart.availableCredit > 0"><div class="col-7 col-sm-8 text-md-right">Available Credit:</div><div class="col-5 col-sm-4 text-right">{{vm.cart.availableCredit | currency:vm.selectedCurrencyTypeID:2}}</div></div><div class="row my-3 text-black" ng-show="vm.cart.tax > 0"><div class="col-7 col-sm-8 text-md-right">VAT <span class="icon icon-info" ng-click="vm.showTaxHelp()"></span></div><div class="col-5 col-sm-4 text-right">{{vm.cart.tax | currency:vm.selectedCurrencyTypeID:2}}</div></div><div class="row my-3 text-black"><div class="col-6 col-sm-8 text-md-right" tabindex="0">Your Total:<br></div><div class="col-6 col-sm-4 text-right" tabindex="0"><strong>{{vm.total | currency:vm.selectedCurrencyTypeID:2}}</strong></div></div><div class="row my-3 text-black" ng-hide="vm.isLoggedIn" ng-show="vm.mode == vm.ShoppingCartUIMode.MODE_SHOPPING_CART && (vm.groupedDiscounts && vm.groupedDiscounts.length > 0)"><div class="col-6 col-sm-8 text-md-right"><span class="text-muted text-small">includes pending discounts</span></div></div><div class="row justify-content-end my-3"><div class="col-12 col-lg-6 col-md-7"><button class="btn btn-primary btn-block" type="submit" ng-hide="vm.isCartEmpty || vm.mode == vm.ShoppingCartUIMode.MODE_MY_ACCOUNT" ng-click="vm.continueToCheckout()" idp-click-tracking>{{vm.continueButtonText}}</button> <button class="btn btn-primary btn-block" type="submit" ng-show="vm.isCartEmpty == false && vm.mode == vm.ShoppingCartUIMode.MODE_MY_ACCOUNT" ng-click="vm.continueShopping()">Continue Shopping</button></div></div><div class="row justify-content-end my-3" ng-if="!vm.pulseContext.isRunningInPartnerDomain" ng-show="vm.mode != vm.ShoppingCartUIMode.MODE_ORDER_SUMMARY && vm.doesCartHaveAtLeastOneCourse"><div class="col-12 col-lg-6 col-md-7"><button class="btn btn-outline-secondary btn-text-sm btn-block" type="button" ng-hide="vm.isChangingPurchasedOrder || vm.mode == vm.ShoppingCartUIMode.MODE_MY_ACCOUNT || vm.hasCampAtHqLocation" ng-click="vm.saveStudentsInfoAndAddCourse()" idp-click-tracking>Add a course and save</button> <button class="btn btn-outline-secondary btn-text-sm btn-block" type="button" ng-hide="vm.isChangingPurchasedOrder || vm.mode == vm.ShoppingCartUIMode.MODE_MY_ACCOUNT || !vm.hasCampAtHqLocation" ng-click="vm.saveStudentsInfoAndAddCourse()" idp-click-tracking>Add another course</button></div></div></div></div></div><script type="text/ng-template" id="taxHelp.html"><p>\n        A portion of your order is subject to value-added tax (VAT).\n    </p></script><idp-group-with-popup popup-id="groupWithPopup" title="Friends"></idp-group-with-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/upsell/idp-upsell-item-list.html','<div ng-repeat="product in vm.products" class="mb-2"><idp-upsell-item participant="vm.participant" product="product"></idp-upsell-item></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/upsell/idp-upsell-item-promo.html','<div class="upsell-item-desc"><strong ng-if="vm.product.percentSaved > 0">Save {{vm.product.percentSaved}}%</strong> <img ng-if="vm.product.isMostPopularBadgeShown" ng-src="{{vm.mostPopularImageUrl}}" alt="Most Popular!"></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/upsell/idp-upsell-item.html','<table><tr><td valign="top"><div class="form-radio"><input name="chkProduct-{{vm.participant.userBrowsingID}}" type="radio" ng-checked="vm.isSelected"> <label for="chkProduct-{{vm.participant.userBrowsingID}}" ng-click="vm.handleRadioClick()"></label></div></td><td valign="top"><div class="upsell-item-title">{{::vm.product.name}} {{::vm.product.price | currency:"$":0}}</div><idp-upsell-item-promo product="vm.product"></idp-upsell-item-promo></td></tr></table>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/upsell/idp-upsell-participant-list.html','<div class="d-flex flex-row flex-wrap justify-content-center align-content-start align-items-stretch"><div class="card shadow mt-2 mb-2 mr-0 ml-0 mr-sm-2 ml-sm-2 p-3" style="width:330px;" ng-repeat="participant in vm.participants"><idp-upsell-participant participant="participant" display-number="$index + 1" products="vm.products" is-theme-pack="vm.isThemePack"></idp-upsell-participant></div><div class="card shadow mt-2 mb-2 mr-0 ml-0 mr-sm-2 ml-sm-2 p-3" style="width:330px;" ng-show="vm.showAddParticipantCard"><div class="text-center m-auto" style="min-height: 265px;"><div class="mt-9"><b>Add a student</b></div><div class="mt-5"><img style="width:48px;height:48px;cursor:pointer;" ng-src="{{::vm.addParticipantImageUrl}}" ng-click="vm.addParticipant()"></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/upsell/idp-upsell-participant-options-multi.html','<div data-ng-form="{{::vm.formName}}"><div class="d-flex mb-3" ng-repeat="product in $ctrl.products"><div class="form-check flex-grow-0 flex-shrink-0"><input type="checkbox" name="product{{ $ctrl.participant.userBrowsingID }}" id="product{{ $ctrl.getOptionId(product) }}" class="form-check-input" ng-checked="$ctrl.selectedProductIDs.indexOf(product.productID) > -1" ng-click="$ctrl.manageSelect(product)"> <label for="{{ $ctrl.getOptionId(product) }}" ng-click="$ctrl.manageSelect(product)" class="form-check-label"></label></div><div><label class="upsell-item-title d-block mb-0" for="product{{ $ctrl.getOptionId(product) }}">{{ product.name }} {{ product.price | currency:product.currencyTypeID:0 }}</label><idp-upsell-item-promo product="product"></idp-upsell-item-promo></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/upsell/idp-upsell-participant-options.html','<div data-ng-form="{{::vm.formName}}"><div class="d-flex mb-3" ng-repeat="product in $ctrl.products"><div class="form-check flex-grow-0 flex-shrink-0"><input id="{{ $ctrl.getOptionId(product) }}" class="form-check-input" name="{{ $ctrl.participant.userBrowsingID }}" ng-model="$ctrl.selectedProductId" type="radio" data-ng-value="product.productID"> <label for="{{ $ctrl.getOptionId(product) }}" ng-click="$ctrl.manageSelect($event, product)" class="form-check-label"></label></div><div><label class="upsell-item-title d-block mb-0" ng-click="$ctrl.manageSelect($event, product)" for="{{ $ctrl.getOptionId(product) }}">{{ product.name }} {{ product.price | currency:product.currencyTypeID}}</label><idp-upsell-item-promo product="product"></idp-upsell-item-promo></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/upsell/idp-upsell-participant.html','<div data-ng-form="{{::vm.formName}}"><div class="row ng-hide" ng-show="!vm.participant.showEditControls && vm.participant.userBrowsingID < 0 && vm.participant.userID == 0"><div class="col-12 text-left"><span class="font-weight-bold">Student {{vm.displayNumber}}:</span>&nbsp;&nbsp;<span class="text-black"> {{vm.participant.firstName}} {{vm.participant.lastName}}</span></div><div class="col-12 text-left mb-2"><a href="" ng-click="vm.removeParticipant()" ng-show="vm.participant.userBrowsingID < 0 && vm.participant.userID == 0">Remove</a></div></div><div class="row ng-hide" ng-show="!vm.participant.showEditControls && (vm.participant.userBrowsingID >= 0 || vm.participant.userID != 0)"><div class="col-12 text-left mb-2"><span class="font-weight-bold">Student {{vm.displayNumber}}:</span>&nbsp;&nbsp;<span class="text-black"> {{vm.participant.firstName}} {{vm.participant.lastName}}</span></div></div><div class="mt-3 mb-4 text-center" ng-show="vm.participant.showEditControls"><b>Add a student</b></div><table class="w-100 ml-0 ng-hide" style="display:none;"><tr><td></td></tr><tr><td class="text-right ng-hide" ng-show="vm.participant.userBrowsingID < 0 && vm.participant.userID == 0 && vm.displayNumber > 1"><a href="" ng-click="vm.removeParticipant()">REMOVE</a></td></tr></table><div class="mb-1" ng-show="vm.participant.showEditControls"><div class="row"><div class="col-12 form-group id-required"><input id="participant_{{vm.participant.userBrowsingID}}" type="text" name="firstName" class="form-control id-standard" ng-disabled="!vm.canEdit" ng-model="vm.participant.firstName" placeholder="Student\'s first name" ng-required="vm.participant.userBrowsingID < 0 && vm.participant.userID == 0" uib-tooltip="Student\'s first name" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.firstName.$error" class="text-danger"><div ng-message="required">Student\'s first name is required</div></div></div></div><div class="row"><div class="col-12 form-group id-required"><input type="text" name="lastName" class="form-control id-standard" ng-disabled="!vm.canEdit" ng-model="vm.participant.lastName" placeholder="Student\'s last name" ng-required="vm.participant.userBrowsingID < 0 && vm.participant.userID == 0" uib-tooltip="Student\'s last name" tooltip-trigger="\'focus\'"><div ng-messages="vm.myForm.lastName.$error" class="text-danger"><div ng-message="required">Student\'s last name is required</div></div></div></div><div class="row"><div class="col-sm-12"><idp-gender gender-type-id="vm.participant.genderTypeID" radio-format="true" is-edit-mode="vm.canEdit" is-required="true" label-font-size="\'16px\'"></idp-gender></div></div><div class="row date-picker"><div class="col-sm-12"><label>Student\'s Date of Birth</label></div></div><div class="row"><div class="col-xs-12"><div uib-tooltip="Date of Birth" tooltip-trigger="\'focus\'"><div class="form-group id-required"><idp-date-picker date="vm.participant.dateOfBirth" min-date="vm.pulseContext.isImpersonating ? vm.csImpersonatingMinDate : vm.minDate" max-date="vm.pulseContext.isImpersonating ? vm.csImpersonatingMaxDate : vm.maxDate" is-edit-mode="vm.canEdit" is-required="vm.participant.userBrowsingID < 0 && vm.participant.userID == 0" disable-date-range-validation="vm.participant.selectedProducts.length == 0"></idp-date-picker></div></div></div></div></div><idp-upsell-participant-options participant="vm.participant" products="vm.products" ng-if="vm.isThemePack"></idp-upsell-participant-options><idp-upsell-participant-options-multi participant="vm.participant" products="vm.products" ng-if="!vm.isThemePack"></idp-upsell-participant-options-multi><div class="mt-1 ng-hide" ng-show="vm.participant.showEditControls"><div class="row"><div class="col-12"><button type="submit" class="btn btn-primary btn-block" ng-dblclick="false" ng-click="vm.addParticipant()">Add</button></div></div><div class="row mt-2"><div class="col-12 text-center"><a href="" ng-click="vm.removeParticipant()"><b>Remove</b></a></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/schedule/history/idp-history-sessions.html','<div class="id-panel-group" id="sessionAccordion"><div data-ng-repeat="session in vm.sessionList" class="option padded-content"><div class="card id-collapsible-card mt-3"><div class="card-heading" id="heading{{::session.sessionID}}" ng-click="vm.onHeadingClick(session)" ng-class="{\'collapsed\': !session.isActive}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-hide="session.isActive"></span> <span class="icon icon-minus-1" ng-show="session.isActive"></span></div><div class="content container-fluid py-2"><div class="d-flex flex-column flex-md-row"><div class="flex-grow-1 flex-shrink-1"><div class="mb-1 font-weight-light"><h3><small>{{::session.courseName}}</small></h3></div><div class="font-weight-bold">{{::session.divisionName}} - {{::session.locationName}}, {{::session.sessionDates}}</div></div></div></div></div></div><div id="collapse{{::session.sessionID}}" class="card-collapse" uib-collapse="!session.isActive"><div class="card-body"><div class="ml-7"><idp-course-options-list session="session" option-list="session.options" order-detail-id="session.orderDetailID" heading="Course Options" has-overnight="session.hasOvernight" is-read-only="true"></idp-course-options-list></div></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/walkthrough-filter/idp-walkthrough-form-submit-button.html','<div class="navbar navbar-default navbar-fixed-bottom"><div class="container-fluid"><div class="row my-3"><div class="col-xs-12 col-sm-6 message-container"><p ng-show="vm.hasMessage()">{{ vm.message }}</p></div><div class="col-xs-12 col-sm-6 submit-button-container"><button class="btn btn-primary btn-text-sm btn-w-200 form-submit" type="submit" data-ng-dblclick="false">{{ vm.buttonText }}</button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/walkthrough-filter/idp-walkthrough-list-selectables.html','<div class="row" ng-cloak><div id="selectable{{ selectable.iD }}" class="selectable col-xs-12 col-sm-6" ng-repeat="selectable in vm.selectables track by selectable.iD" ng-class="{\'selected\': vm.checkboxes[$index]}"><div class="selectable-container"><div class="descriptor-img-container" ng-click="vm.toggleCheckbox($index)" ng-style="{background: \'linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(\' + vm.mediaServerResourcePath + selectable.iD +\'.jpg)\'}"><div class="img-overlay"></div><div class="selectable-checkbox"><input id="checkbox{{ selectable.iD }}" name="select{{ selectable.iD }}" type="checkbox" ng-model="vm.checkboxes[$index]" disabled="disabled" value="true"> <label for="checkbox{{ selectable.iD }}"></label></div><h2><span>{{selectable.name}}</span><br><small>Ages {{selectable.minAge}} - {{selectable.maxAge}}</small></h2></div><p class="selectable-description">{{selectable.desc}}</p><a ng-if="selectable.uRL" class="selectable-link" ng-href="{{vm.webHost + selectable.uRL}}">Learn More</a></div></div><debug-display-data debug-data="vm.selectables"></debug-display-data></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/walkthrough-filter/idp-walkthrough-skip-to-step.html','<div class="break-with-text"><div class="break-line"></div><div class="break-text">or</div><div class="break-line"></div></div><div class="text-center"><button id="skipToStep" class="btn btn-secondary btn-text-sm" type="button" ng-click="vm.buttonAction()" style="min-width: 234px">{{vm.buttonText}}</button></div><div class="help-container text-center"><h3>Need help choosing the perfect course?</h3><p>Our Program Specialists provide personalized recommendations based on your child\u2019s interests.<br>Call <strong class="text-color-black">{{vm.pulseContext.companyTollFreePhone | tel}}</strong></p></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/carousel-template.html','<div class="carousel-inner" ng-transclude></div><a role="button" href class="carousel-control-prev" ng-click="prev()" ng-class="{ disabled: isPrevDisabled() }" ng-show="slides.length > 1"><span class="icon-chevron-left" aria-hidden="true"></span> <span class="sr-only">Previous</span> </a><a role="button" href class="carousel-control-next" ng-click="next()" ng-class="{ disabled: isNextDisabled() }" ng-show="slides.length > 1"><span class="icon-chevron-right" aria-hidden="true"></span> <span class="sr-only">Next</span></a><ol class="carousel-indicators" ng-show="slides.length > 1"><li class="rounded-circle my-0 mx-2" ng-repeat="slide in slides | orderBy:indexOfSlide track by $index" ng-class="{ active: isActive(slide) }" ng-click="select(slide)"><span class="sr-only">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if="isActive(slide)">, currently active</span></span></li></ol>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/idp-avc-availability-chart-virtual.html','<div class="d-flex align-content-stretch avc-availability-chart"><idp-avc-left-filters-panel ng-show="$ctrl.showLeftFiltersPanel()" visible="$ctrl.viewLoaded" on-demand-sticky-render="$ctrl.refreshStickiesOnNextDigest()" class="left-filter-container"></idp-avc-left-filters-panel><div class="chart" ng-cloak ng-class="{\'d-none d-md-block\': $ctrl.showLeftFiltersPanel()}"><div ng-repeat="g in $ctrl.avcDataSetGrouped"><div class="id-collapsible-card-virtual-camp mt-5 pb-5 border-bottom"><div class="card-heading" id="cdr-heading-{{::g.catalogDateRangeID}}" ng-click="$ctrl.loadSessions($index)" ng-class="{\'collapsed\': !g.isActive}"><div class="card-title d-flex vertical-align mb-0 align-items-center"><div class="icon-container d-flex align-items-center justify-content-center border rounded"><span class="icon icon-plus-1" ng-if="!g.isActive"></span> <span class="icon icon-minus-1" ng-if="g.isActive"></span></div><div class="title-text font-weight-bold mb-0 ml-3" data-ng-bind-html="g.catalogDateRange.description | unsafe"></div></div></div></div><div id="collapse{{::g.catalogDateRangeID}}" class="card-collapse" uib-collapse="!g.isActive"><div class="my-3" ng-if="g.terms.length > 0"><div class="term-division-accordion mb-3 backdrop-shadow rounded" ng-cloak ng-repeat="termDivision in g.terms" on-repeat-finish><idp-avc-division-info-block class="term-division-info backdrop-shadow-with-hover" ng-click="$ctrl.toggleTermDivisionAccordion(termDivision)" accordion-opened="$ctrl.hasAccordionPanelExpanded(termDivision)" term-division="termDivision"></idp-avc-division-info-block><div class="border-left border-right rounded-bottom bg-white" ng-show="$ctrl.viewLoaded && $ctrl.hasAccordionPanelExpanded(termDivision)"><div ng-hide="$ctrl.hasCourses(termDivision)" class="empty-division text-center border-bottom rounded-bottom"><div class="text-info" ng-if="!$ctrl.isChangeRegFlow">No results at {{ ::termDivision.name }} match your criteria. Please modify filter.</div><div class="text-info pt-3 pb-3" ng-if="$ctrl.isChangeRegFlow"><div>There\u2019s nothing available in the currency you\u2019re trying to exchange</div><div class="pt-2"><button type="button" class="btn btn-link" ng-click="$ctrl.onCancelExchange()">Cancel course exchange</button></div></div></div><div ng-show="$ctrl.hasCourses(termDivision)" class="av-chart rounded"><div class="av-sessions-header d-none d-md-flex align-items-stretch" ng-class="{\'small\': $ctrl.showLeftFiltersPanel()}"><div class="course-column d-flex justify-content-center align-items-center"><div class="text-center">Courses</div></div><div class="division-session-term d-flex justify-content-center align-items-center border-left" ng-repeat="session in termDivision.sessions"><div class="text-center" ng-bind-html="session.start | formatSessionDates:session.displayEnd"></div></div></div><div class="course-row d-block d-md-flex flex-md-row flex-md-wrap align-items-stretch" ng-class="{\n                \'targeted-course\': $ctrl.targetedCourseId === course.prodID,\n                \'course-mobile-selected\': $ctrl.areSessionsMobileVisible(course)\n               }" ng-repeat="course in termDivision.courses" on-repeat-finish="$ctrl.refreshStickiesOnNextDigest()"><idp-avc-course-cell class="course-cell d-block order-1" ng-class="{\'sessions-hidden\': !$ctrl.areSessionsMobileVisible(course)}" course="course" course-img="$ctrl.getThumbNailFullUrl(course)" division="termDivision" toggle-mobile-session-visibility="$ctrl.toggleMobileSessionsVisibility(course)" are-sessions-mobile-visible="$ctrl.areSessionsMobileVisible(course)"></idp-avc-course-cell><idp-avc-session-cell id="spdID_{{::session.spdID}}" class="session-cell order-1" ng-repeat-start="session in course.sessions" ng-class="{\'marked-session\': session.inCartCount || session.inWaitlist && session.statusOptions.isWaitlist,\n                         \'d-none d-md-flex\': !$ctrl.isSessionMobileVisible(course, session),\n                         \'session-is-selected\': $ctrl.checkDrawerForSession(termDivision, course, session)\n                        }" ng-click="$ctrl.toggleSessionAction($event, termDivision, course, session)" session="session" location-price="course.locationPrice" currency-type-id="course.currencyTypeID" term-session="termDivision.sessions[$index]" idp-click-tracking data-id-div-abbr="{{::$ctrl.getDivisionAbbr(termDivision.divID)}}" data-id-product-id="{{::course.prodID}}" data-id-location-id="{{::$ctrl.location.iD}}"></idp-avc-session-cell><idp-avc-session-drawer class="drawer d-flex order-md-12 order-1 order-md-3" ng-class="{ \'d-none d-md-block\': !$ctrl.isSessionMobileVisible(course, session) }" ng-if="$ctrl.checkDrawerForSession(termDivision, course, session)" course-img-thumbnail-url="{{ :: $ctrl.getThumbNailFullUrl(course) }}" course-img-url="{{ :: $ctrl.getThumbNailFullUrl(course, true) }}" course="course" location="$ctrl.location" products="$ctrl.drawerProducts" drawer-style="$ctrl.drawerStyle" cross-sell-prods="$ctrl.crossSellProds" ng-repeat-end=""></idp-avc-session-drawer></div></div></div></div></div><div ng-if="g.terms.length ==0">Loading...</div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/idp-avc-availability-chart.html','<div class="d-flex align-content-stretch avc-availability-chart"><idp-avc-left-filters-panel ng-show="$ctrl.showLeftFiltersPanel()" on-demand-sticky-render="$ctrl.refreshStickiesOnNextDigest()" class="left-filter-container"></idp-avc-left-filters-panel><div class="chart" ng-cloak ng-class="{\'d-none d-md-block\': $ctrl.showLeftFiltersPanel()}"><div class="term-division-accordion mb-3 backdrop-shadow rounded" ng-cloak ng-repeat="termDivision in $ctrl.avcDataSet" on-repeat-finish><idp-avc-division-info-block class="term-division-info backdrop-shadow-with-hover" ng-click="$ctrl.toggleTermDivisionAccordion(termDivision)" accordion-opened="$ctrl.hasAccordionPanelExpanded(termDivision)" term-division="termDivision"></idp-avc-division-info-block><div class="border-left border-right rounded-bottom bg-white" ng-show="$ctrl.viewLoaded && $ctrl.hasAccordionPanelExpanded(termDivision)"><div ng-hide="$ctrl.hasCourses(termDivision)" class="empty-division text-center border-bottom rounded-bottom"><span class="text-info" ng-if="!$ctrl.isChangeRegFlow">No results at {{ ::termDivision.name }} match your criteria. Please modify filter.</span><div class="text-info pt-3 pb-3" ng-if="$ctrl.isChangeRegFlow"><div>There\u2019s nothing available in the currency you\u2019re trying to exchange</div><div class="pt-2"><button type="button" class="btn btn-link" ng-click="$ctrl.onCancelExchange()">Cancel course exchange</button></div></div></div><div ng-show="$ctrl.hasCourses(termDivision)" class="av-chart rounded"><div class="av-sessions-header d-none d-md-flex align-items-stretch" ng-class="{\'small\': $ctrl.showLeftFiltersPanel()}"><div class="course-column d-flex justify-content-center align-items-center"><div class="text-center">Courses</div></div><div class="division-session-term d-flex justify-content-center align-items-center border-left" ng-repeat="session in termDivision.sessions"><div class="text-center" ng-bind-html="session.start | formatSessionDates:session.displayEnd"></div></div></div><div class="course-row d-block d-md-flex flex-md-row flex-md-wrap align-items-stretch" ng-class="{\n                \'targeted-course\': $ctrl.targetedCourseId === course.prodID,\n                \'course-mobile-selected\': $ctrl.areSessionsMobileVisible(course)\n               }" ng-repeat="course in termDivision.courses" on-repeat-finish="$ctrl.refreshStickiesOnNextDigest()"><idp-avc-course-cell class="course-cell d-block order-1" ng-class="{\'sessions-hidden\': !$ctrl.areSessionsMobileVisible(course)}" course="course" course-img="$ctrl.getThumbNailFullUrl(course)" division="termDivision" toggle-mobile-session-visibility="$ctrl.toggleMobileSessionsVisibility(course)" are-sessions-mobile-visible="$ctrl.areSessionsMobileVisible(course)"></idp-avc-course-cell><idp-avc-session-cell id="spdID_{{::session.spdID}}" class="session-cell order-1" ng-repeat-start="session in course.sessions" ng-class="{\n                                     \'marked-session\': session.inCartCount || session.inWaitlist && session.statusOptions.isWaitlist,\n                                     \'d-none d-md-flex\': !$ctrl.isSessionMobileVisible(course, session),\n                                     \'session-is-selected\': $ctrl.checkDrawerForSession(termDivision, course, session)\n                                   }" ng-click="$ctrl.toggleSessionAction($event, termDivision, course, session)" session="session" location-price="course.locationPrice" currency-type-id="course.currencyTypeID" term-session="termDivision.sessions[$index]" idp-click-tracking data-id-div-abbr="{{::$ctrl.getDivisionAbbr(termDivision.divID)}}" data-id-product-id="{{::course.prodID}}" data-id-location-id="{{::$ctrl.location.iD}}"></idp-avc-session-cell><idp-avc-session-drawer class="drawer d-flex order-md-12 order-1 order-md-3" ng-class="{ \'d-none d-md-block\': !$ctrl.isSessionMobileVisible(course, session) }" ng-if="$ctrl.checkDrawerForSession(termDivision, course, session)" course-img-thumbnail-url="{{ :: $ctrl.getThumbNailFullUrl(course) }}" course-img-url="{{ :: $ctrl.getThumbNailFullUrl(course, true) }}" course="course" location="$ctrl.location" products="$ctrl.drawerProducts" drawer-style="$ctrl.drawerStyle" cross-sell-prods="$ctrl.crossSellProds" ng-repeat-end=""></idp-avc-session-drawer></div></div></div></div><div ng-if="$ctrl.viewLoaded && $ctrl.showVTC" class="virtual-camp" ng-click="$ctrl.redirectToVirtualCamps()"><div class="d-flex flex-column flex-md-row align-content-md-stretch border rounded-top rounded-bottom"><div class="division media p-3 order-1 w-100 align-items-center rounded-bottom"><img class="division-logo d-none d-md-block e-width-9 flex-grow-0 flex-shrink-0" ng-src="{{ ::$ctrl.vcLogoImageSrc }}" alt="Virtual Tech Camp" title="Virtual Tech Camp"><div class="media-body pl-md-3 flex-grow-1 flex-shrink-1"><div class="media pb-1 pb-md-0 w-100 flex-grow-1 flex-shrink-1 align-items-center"><img class="division-logo d-md-none e-width-6 flex-grow-0 flex-shrink-0" ng-src="{{ ::$ctrl.vcLogoImageSrc }}" alt="Virtual Tech Camp" title="Virtual Tech Camp"><div class="media-body pl-3 pl-md-0"><h3 class="d-none d-md-block mb-0">Virtual Tech Camp</h3><h5 class="d-md-none align-self-center mb-0">Virtual Tech Camp</h5></div></div><ul class="division-properties list-inline bullet-between mb-0"><li class="list-inline-item">Ages: 7-19</li><li class="list-inline-item">Beg-Adv</li><li class="list-inline-item">1 week</li><li class="list-inline-item d-none d-sm-inline">From {{ $ctrl.VtcPrice }} USD</li></ul><p class="experience-description text-muted m-0">Experience the magic of camp online from the comfort of home! Build in-demand skills, learn from tech rockstars, and engage with friends remotely. <strong>Note: By selecting this option, you\u2019ll leave this page.</strong></p></div></div><div class="accordion-status-highlighters d-block d-md-none p-1 border-top text-center order-2"><span class="pr-2">Courses from {{ $ctrl.VtcPrice }} <span class="icon icon-pop-out pl-2"></span></span></div><div class="accordion-status-highlighters d-none d-md-flex justify-content-center align-items-center order-0 e-width-6 border-right"><span class="icon icon-pop-out"></span></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/idp-avc-checkout-bar.html','<div class="container-fluid bg-white fixed-bottom w-100 p-1 p-md-2 border-top delimiter-shadow-top"><div class="d-flex flex-column flex-md-row justify-content-center align-items-center"><button class="btn btn-primary pr-5 pl-5" ng-click="$ctrl.goToCheckoutFn()" idp-click-tracking>Checkout</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/idp-avc-course-overlay-popup.html','<div class="course-overlay"><div class="d-flex bg-light py-3 px-4 py-md-4 px-md-5"><div class="course-title flex-shrink-1 flex-grow-1 m-0 font-weight-bold">{{::vm.course.name}}</div><div class="flex-shrink-0 flex-grow-0 ml-3"><button class="close" ng-click="vm.close()" type="button"><span aria-hidden="true" class="icon icon-close"></span></button></div></div><div class="container-fluid p-0"><div class="d-flex flex-column flex-md-row py-3"><div class="d-flex flex-column mx-3 mx-md-auto my-md-3 my-0"><div class="my-2"><strong class="text-black">AGES:</strong> {{::vm.course.minAge}}-{{::vm.course.maxAge}} <span ng-if="::vm.showAgeCheckDate">(Must turn {{::vm.course.minAge}} by {{vm.getMinAgeCheckDateStr()}})</span> <span ng-if="::vm.initDataObj.products.mainProduct.programTypeID == $root.Enums.DivisionProgramType.AlexaCafe">, All-Girls</span></div><div class="my-2"><strong class="text-black">SKILL LEVEL:</strong> {{:: vm.course.skillLevels | avcSkillLevel:true}}</div><div class="my-2"><strong class="text-black">PATH:</strong> <span ng-repeat="genre in vm.course.genres">{{ genre.name }}{{ $last ? "" : ", " }}</span></div></div><div class="d-flex flex-column mx-3 mx-md-auto my-md-3 my-0"><div class="my-2"><strong class="text-black">PROGRAM:</strong> {{:: vm.division.name + " | "}}<ng-pluralize count="vm.division.daysPerSession | daysToWeeks" when="{ \'1\': vm.division.divDeliveryModelTypeID == 4004 ? \'10 Weekly Lessons\' : \'1 Week\',\n                        \'other\': vm.division.divDeliveryModelTypeID == 4004 ? \'10 Weekly Lessons\' : \'{{ :: vm.division.daysPerSession | daysToWeeks}} Weeks\'}"></ng-pluralize></div><div class="my-2"><strong class="text-black">PREREQUISITE:</strong> {{:: vm.course.prerequisities && vm.course.prerequisities.length ? "See course description" : "None"}}</div><div class="my-2"><strong class="text-black">TOOLS:</strong> {{::vm.course.toolsUsed | unsafe}}</div></div></div><div class="row no-gutters"><div class="col-md-6 bg-light"><img class="w-100" ng-src="{{::vm.getThumbNailFullUrl(vm.course, true) }}"></div><div class="col-md-6 bg-light"><div class="px-4 px-md-6 pl-lg-8 pr-md-6 pt-8 pt-md-1"><h2 class="mb-3">{{::vm.course.name}}</h2><strong>Course Description:</strong><p ng-bind-html="::vm.course.description | unsafe"></p><div ng-if="vm.course.prerequisities && vm.course.prerequisities.length"><strong>Prerequisite:</strong> <span ng-repeat="prereq in vm.course.prerequisities track by $index">{{::prereq.skill}}<br></span></div></div></div></div><div class="row pt-4 pt-md-8"><div class="col-md-6 col-12" ng-if="vm.course.activityDesc"><div class="mx-5"><h4>In this course, you will:</h4><p ng-bind-html="::vm.course.activityDesc | unsafe"></p></div></div><div class="col-md-6 col-12" ng-if="::vm.course.takeHomeDesc"><div class="mx-5"><h4>Your tuition includes:</h4><p ng-bind-html="::vm.course.takeHomeDesc | unsafe"></p></div></div></div></div><div class="container-fluid py-4 pb-md-8"><button type="button" class="btn btn-outline-secondary btn-block btn-width-300" ng-click="vm.close()" data-dismiss="modal">Close</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/idp-avc-header-panel.html','<div class="container-fluid bg-light border" ng-if="$ctrl.location"><div class="row"><idp-avc-current-location class="filter col-12 col-md-6 p-3" disable-change-location="$ctrl.disableChangeLocation()" selected-location="$ctrl.location"></idp-avc-current-location><idp-avc-active-filters ng-if="$ctrl.showFiltersPanel" class="filter col-12 col-md-6 p-3"></idp-avc-active-filters></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/idp-avc-price-slash.html','<div ng-if="$ctrl.hasDiscount()" class="location-price lineh-none"><div class="session-price-label d-none d-xl-inline-block small" ng-if="$ctrl.showFromText">from&nbsp;</div><s ng-class="{\n    \'d-none d-md-block\': $ctrl.showDiscountOnMobile, \'text-nowrap\': $ctrl.textWrap}" ng-bind-html="$ctrl.locationPrice | currency:$ctrl.currencyTypeId:0"></s><div class="reference-price d-lineh-none text-danger" ng-if="!$ctrl.isSoldOut" ng-class="{\n    \'d-none d-md-block\': $ctrl.showDiscountOnMobile}"><span ng-bind-html="$ctrl.sessionPrice | currency:$ctrl.currencyTypeId:0" ng-class="{\'text-nowrap\': $ctrl.textWrap}"></span><ng-transclude></ng-transclude></div><div ng-if="$ctrl.showDiscountOnMobile" class="d-block d-md-none text-danger"><strong>Save <span ng-bind-html="$ctrl.sessionDiscount | currency:$ctrl.currencyTypeId:0"></span></strong></div></div><div ng-if="!$ctrl.hasDiscount()" ng-class="{\n  \'d-none d-md-block\': $ctrl.showDiscountOnMobile}"><div class="session-price-label small" ng-if="$ctrl.showFromText">from</div><div class="reference-price lineh-none"><span ng-bind-html="$ctrl.sessionPrice | currency:$ctrl.currencyTypeId:0" ng-class="{\'text-nowrap\': $ctrl.textWrap}"></span><ng-transclude></ng-transclude></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/idp-pav-catalog-date-ranges.html','<div ng-repeat="cdr in $ctrl.catalogDateRangeUIs track by cdr.catalogDateRangeID"><div class="id-collapsible-card-virtual-camp {{$ctrl.drawerStyle.drawerSectionBackground}} px-2" ng-class="{\'border-bottom\': !$ctrl.drawerStyle.is2022Design, \'py-3\': !cdr.isActive}" ng-if="cdr.sessionGroups.length > 0"><button type="button" class="card-heading btn btn-link p-0 m-0" ng-if="$ctrl.showSeasonSelector" id="cdr-heading-{{::cdr.catalogDateRangeID}}" aria-expanded="{{cdr.isActive}}" ng-click="$ctrl.loadSessions($index)" ng-class="{\'collapsed\': !cdr.isActive}"><div class="card-title d-flex vertical-align mb-0 align-items-center"><div class="{{$ctrl.drawerStyle.iconPrimary}} d-flex align-items-center justify-content-center border rounded"><span class="icon icon-plus-1" aria-hidden="true" ng-if="!cdr.isActive"></span> <span class="icon icon-minus-1" aria-hidden="true" ng-if="cdr.isActive"></span></div><div class="date-range-title-text align-left font-weight-bold mb-0 ml-3 {{$ctrl.drawerStyle.drawerSectionText}}" data-ng-bind-html="$ctrl.dateRangeContent(cdr.catalogDateRange.description) | unsafe"></div></div></button><div ng-show="$ctrl.drawerStyle.is2022Design && cdr.isActive && $ctrl.pulsePass.currentStep.stepSelectText.length > 0" class="pt-3"><div class="h4">{{ $ctrl.pulsePass.currentStep.stepSelectText }}</div><div class="">{{ $ctrl.getProduct }}</div></div><div id="collapse{{::cdr.catalogDateRangeID}}" class="card-collapse" ng-class="{\'pt-3\': !$ctrl.drawerStyle.is2022Design}" uib-collapse="!cdr.isActive"><div class="highlight" ng-if="cdr.isActive" ng-repeat="sessionGroup in $ctrl.catalogDateRangeUIs[$index].sessionGroups | limitTo: $ctrl.isShowMore ? null : 7 track by sessionGroup.sessionID"><hr ng-if="$ctrl.showDrawerStep"><idp-pav-session-cell id="spdID_{{::sessionGroup.sessionID}}" class="session-cell order-1" session-group="sessionGroup" prod-id="$ctrl.prodId" drawer-style="$ctrl.drawerStyle" season-index="cdr.catalogDateRangeID" dataset="$ctrl.dataset"></idp-pav-session-cell><hr ng-if="$ctrl.isLastSession(sessionGroup.sessionID)"></div><button type="button" class="text-secondary text-center font-weight-bold c-pointer btn btn-link btn-block" ng-show="$ctrl.catalogDateRangeUIs[$index].sessionGroups.length > 7 && $ctrl.showDrawerStep" ng-click="$ctrl.isShowMore = !$ctrl.isShowMore">{{$ctrl.isShowMore ? \'Load less dates\': \'Load more dates\'}}</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/idp-pav-drawer-step.html','<div ng-if="$ctrl.drawerStyle.is2022Design"><div ng-if="$ctrl.backToCourse"><a href="#" id="idpDrawerTop" class="btn btn-text close {{$ctrl.drawerStyle.buttonClose}}" data-dismiss="drawer"><span class="icon icon-left" aria-hidden="true"></span> {{ $ctrl.currentStep.stepBackText }}</a></div><div ng-if="$ctrl.backToSelectLocation"><a href="#" id="idpDrawerTop" class="btn btn-text {{$ctrl.drawerStyle.buttonClose}}" ng-click="$ctrl.backToSelectLocationClicked()"><span class="icon icon-left" aria-hidden="true"></span> {{ $ctrl.currentStep.stepBackText }}</a></div><div ng-if="$ctrl.backToPrevious"><button type="button" id="idpDrawerTopBtn" class="btn btn-text {{$ctrl.drawerStyle.buttonClose}}" ng-click="$ctrl.previousStepClick()"><span class="icon icon-left" aria-hidden="true"></span> {{ $ctrl.currentStep.stepBackText }}</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/idp-pav-order-confirmation.html','<div class="p-3 pt-8"><h4 class="header-text px-3 text-lg-center"><strong>{{$ctrl.product.name}}</strong> <span class="font-weight-normal ml-1">has been added to your cart</span></h4><hr><div class="px-sm-6 py-3"><div class="d-flex flex-column align-items-center"><h3 class="text-center" ng-hide="$ctrl.isTutoring || $ctrl.isCourseBundle">Add another course or student and save<span ng-if="$ctrl.Discount != null"> {{ $ctrl.Discount.amount | currency : -$ctrl.Discount.currencyTypeID : 0 }}</span>!</h3><h3 class="text-center" ng-show="$ctrl.isTutoring">Add another course or student and save!</h3><div ng-hide="$ctrl.isTutoring" class="text-center px-2" ng-class="{\'text-em-1-25 mt-0 text-black\' : $ctrl.isCourseBundle,\n                      \'text-small mt-3\': !$ctrl.isCourseBundle}">Practice makes perfect! Students who attend multiple sessions gain accelerated mastery, giving them a head start on their long-term skill development pathways.</div><div ng-show="$ctrl.isTutoring" class="text-small mt-3 text-center px-2">Your child can bring a sibling (or friend) to their sessions for free. It\u2019s like saving 50%.</div><div class="row justify-content-center w-100 mt-6"><div class="col-12 col-md-8"><button class="btn btn-text-sm btn-block" ng-class="{ \'btn-success\' : $ctrl.isSquads || $ctrl.isCourseBundle,\n                            \'btn-tutoring\': $ctrl.isTutoring,\n                            \'btn-primary\': !$ctrl.isSquads && !$ctrl.isTutoring &&  !$ctrl.isCourseBundle}" type="button" ng-click="$ctrl.addAnotherCourse()" idp-click-tracking data-id-div-abbr="{{::$ctrl.getDivisionAbbr()}}" data-id-product-id="{{::$ctrl.product.productID}}">Add another course or student</button> <button class="btn btn-outline-secondary btn-text-sm btn-block mt-3" type="button" ng-click="$ctrl.redirectToCheckout()" idp-click-tracking data-id-div-abbr="{{::$ctrl.getDivisionAbbr()}}" data-id-product-id="{{::$ctrl.product.productID}}">Checkout</button></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/idp-pav-session-cell.html','<div class="mb-3 {{$ctrl.drawerStyle.sectionBorder}}" ng-class="{\'active\': $ctrl.showExtra && !$ctrl.drawerStyle.is2022Design}"><button type="button" class="d-flex justify-content-between btn btn-link btn-block cdr-session-button" ng-class="{\'cell-container\': !$ctrl.drawerStyle.is2022Design}" ng-click="$ctrl.loadTerms()" ng-if="$ctrl.showAccordionButtons" idp-click-tracking aria-expanded="{{$ctrl.showExtra}}" data-id-div-abbr="{{::$ctrl.getDivisionAbbr()}}" data-id-product-id="{{::$ctrl.prodId}}"><div class="d-flex align-items-center"><span class="icon icon-calendar1 mr-2 {{$ctrl.drawerStyle.iconCalendarText}} text-em-1-5" ng-if="!$ctrl.drawerStyle.is2022Design" aria-hidden="true"></span><span ng-if="!$ctrl.drawerStyle.is2022Design" class="text-black text-nowrap session-term" ng-bind-html="$ctrl.sessionGroup.startDate | formatSessionDates:$ctrl.getEndDate():1:1"></span><div class="d-flex flex-column" ng-if="$ctrl.drawerStyle.is2022Design"><div class="text-black align-left line-height-sm session-term date-cell-normal" ng-bind-html="$ctrl.sessionGroup.startDate | formatSessionFullMonth:$ctrl.getEndDate():1:1"></div><div class="text-black align-left line-height-sm session-term date-cell-mobile" ng-bind-html="$ctrl.sessionGroup.startDate | formatSessionFullMonth:$ctrl.getEndDate():1:0"></div><div class="text-nowrap text-left" ng-class="{\n            \'session-open\': $ctrl.sessionStatus == \'Open\',\n            \'session-warning\': $ctrl.sessionStatus == \'Nearly Full\',\n            \'session-danger\': $ctrl.sessionStatus == \'Sold Out\'\n          }"><span class="fas fa-xs {{$ctrl.sessionStatusIconClass}}"></span> {{$ctrl.sessionStatus}}</div></div></div><div class="availability-status badge {{$ctrl.sessionStatusClass}}" ng-if="$ctrl.showSessionButton" ng-class="{\'btn-pill btn-pill-lg mt-2\': $ctrl.drawerStyle.is2022Design\n          , \'d-none\': $ctrl.showExtra && !ctrl.drawerStyle.is2022Design\n          , \'text-white\': !$ctrl.drawerStyle.is2022Design}"><span>{{ $ctrl.sessionStatusText }}</span></div></button><div ng-if="$ctrl.showExtra" class="bg-white"><div ng-class="{\'py-2 mx-2 mx-sm-3\': !$ctrl.drawerStyle.is2022Design}"><div ng-repeat="spd in $ctrl.sessionGroup.sessionProductDetails track by spd.sessionProductDetailID"><hr ng-show="$ctrl.showAccordionBar && $ctrl.isFirstSession(spd.sessionProductDetailID)"><idp-pav-session-time-cell session-product-detail="spd" term-divisions="$ctrl.dataset.termDivisions" session-product-details="$ctrl.dataset.sessionProductDetails" dataset-products="$ctrl.dataset.products" drawer-style="$ctrl.drawerStyle" product="$ctrl.mainProd"></idp-pav-session-time-cell><hr ng-show="$ctrl.showAccordionBar"></div><div class="d-flex justify-content-center mt-3" ng-show="!$ctrl.isDrawerOpen(spd)"><button class="btn btn-link font-weight-bold" ng-if="$ctrl.showAccordion" ng-click="$ctrl.showExtra = !$ctrl.showExtra">Close</button></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/idp-pav-session-time-cell.html','<button type="button" class="d-flex justify-content-between mb-2 btn {{$ctrl.drawerStyle.buttonTime}} btn-block" ng-click="$ctrl.toggleSessionAction($event)" ng-class="{\'inactive\': !$ctrl.hasUserInteraction, \'cell-container\': !$ctrl.drawerStyle.is2022Design}" ng-if="$ctrl.showTimeButtons()" idp-click-tracking aria-expanded="{{$ctrl.isExpanded}}" data-id-div-abbr="{{::$ctrl.getDivisionAbbr()}}" data-id-product-id="{{::$ctrl.product.productID}}"><div class="text-title d-flex align-items-center" ng-if-start="!$ctrl.drawerStyle.is2022Design" ng-class="{\'inactive\': !$ctrl.hasUserInteraction}"><span class="text-nowrap font-weight-bold">{{$ctrl.sessionProductDetail.startDateTimeLocal | date:\'h:mm a\' }}</span></div><div class="availability-status badge text-white text-uppercase" ng-if-end ng-class="$ctrl.getStatusButtonClass()"><span>{{$ctrl.getStatusString()}}</span></div><div class="text-title align-items-center" ng-if-start="$ctrl.drawerStyle.is2022Design" ng-class="{\'inactive\': !$ctrl.hasUserInteraction}"><div class="text-nowrap font-weight-bold">{{$ctrl.sessionProductDetail.startDateTimeLocal | date:\'h:mm a\' }}</div><div class="time-availability ml-1 {{$ctrl.getStatusStringClass()}}"><span class="fas fa-circle fa-xs"></span> {{$ctrl.getStatusString()}}</div></div><div class="availability-status badge btn-pill btn-pill-lg" ng-if-end ng-if="$ctrl.showTimeButton" ng-class="$ctrl.getStatusButtonClass()"><span>Select time</span></div></button><div ng-if="$ctrl.checkDrawerForSession()"><div ng-class="{\'py-2\': !$ctrl.drawerStyle.is2022Design}"><idp-pav-session-time-drawer ng-show="$ctrl.product" division="$ctrl.division" product="$ctrl.product" products="$ctrl.drawerProducts" dataset-products="$ctrl.datasetProducts" selected-session-product-detail="$ctrl.sessionProductDetail" session-product-details="$ctrl.sessionProductDetails" drawer-style="$ctrl.drawerStyle" cross-sell-prods="$ctrl.crossSellProds"></idp-pav-session-time-drawer><div class="d-flex justify-content-center"><button class="btn btn-link" ng-click="$ctrl.handleDrawerClose();" ng-if="$ctrl.showTimeButtons()" idp-click-tracking data-id-div-abbr="{{::$ctrl.getDivisionAbbr()}}" data-id-product-id="{{::$ctrl.product.productID}}">Cancel</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/idp-pav-session-time-drawer.html','<div><header ng-class="{\'pb-2\': $ctrl.drawerStyle.is2022Design}"><div ng-if="$ctrl.drawerStyle.is2022Design" class="d-flex flex-row"><div class="product-image"><img src="{{$ctrl.drawerStyle.productImage}}" alt="" aria-hidden="true" class="product-thumbnail"></div><div class="product-info"><h2 class="d-none d-sm-block h4">{{::$ctrl.product.name }}</h2><h3 class="d-sm-none h5">{{::$ctrl.product.name }} {{$ctrl.product.startDateTime}}</h3><idp-avc-product-description-header class="flex-grow-1 flex-shrink-1 mb-4" product="$ctrl.products.mainProduct" main-product="$ctrl.products.mainProduct" session-payment-option="$ctrl.sessionPaymentOption" is-subscription="$ctrl.isSubscription"></idp-avc-product-description-header></div></div><div ng-if="!$ctrl.drawerStyle.is2022Design"><h2 class="d-none d-sm-block">{{::$ctrl.product.name }}</h2><h3 class="d-sm-none h4">{{::$ctrl.product.name }} {{$ctrl.product.startDateTime}}</h3></div></header><div ng-hide="$ctrl.selectedProduct && $ctrl.products.mainProduct" class="my-3">Loading...</div><idp-avc-product-description ng-if="$ctrl.showDescription" class="flex-grow-1 flex-shrink-1 mb-4" original-product="$ctrl.product" product="$ctrl.products.mainProduct" main-product="$ctrl.products.mainProduct" session-payment-option="$ctrl.sessionPaymentOption" is-subscription="$ctrl.isSubscription"></idp-avc-product-description><div class="selected-product"><div class="login-alert alert alert-warning flex-grow-1 flex-shrink-1 order-0" ng-show="$ctrl.showLoginAlert"><button type="button" class="close" ng-click="$ctrl.closeLoginAlert()">&#xD7;</button><p class="text-center mb-0" ng-show="$ctrl.unknownUser"><span class="text-bold">You already have an account.</span><br><span>Please <a class="login-btn" href="" ng-click="$ctrl.showLogin()">login </a>for the best experience.</span></p><p class="text-center mb-0" ng-hide="$ctrl.unknownUser"><span class="text-bold">You are now logged in. </span>Select or enter a new student below.</p></div><div ng-if="$ctrl.selectedProduct && $ctrl.products.mainProduct"><idp-avc-registration-form form-disabled="false" main-product="$ctrl.products.mainProduct" selected-product="$ctrl.selectedProduct" is-squads="$ctrl.isSquads" addon-products="$ctrl.addonProducts" is-subscription="$ctrl.isSubscription" is-course-bundle="$ctrl.isCourseBundle" drawer-style="$ctrl.drawerStyle" reset-step="$ctrl.resetStep" bundle-products="$ctrl.bundleProducts" cross-sell-prods="$ctrl.crossSellProds"></idp-avc-registration-form></div></div></div><idp-login-popup popup-id="authenticationModal" close-on-outside-click="false"></idp-login-popup><idp-reg-flow-admin-override-popup popup-id="adminOverridePopup"></idp-reg-flow-admin-override-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/location/components/idp-ipc-location-list.html','<div class="container-fluid"><div class="row"><div class="col-12 location-academy">Academy locations:</div></div><div class="location-list" ng-repeat="loc in $ctrl.locationList"><button type="button" class="d-flex justify-content-between align-middle btn btn-link btn-block cdr-session-button location-item" ng-click="$ctrl.onLocationClicked(loc);"><div class="d-flex align-items-center my-auto"><div class="align-left text-black date-cell-normal"><div class="location-name">{{loc.locationName}}</div><div class="location-address-area">{{loc.addressArea}}</div></div></div><div class="d-flex align-items-right my-auto"><div class="badge badge-primary btn-pill btn-pill-lg mt-2">Select location</div></div></button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/location/components/idp-location-region-group.html','<h3 class="letter-spacing-03 mt-6 mb-4">{{ $ctrl.regionGroup.name}}</h3><div class="row"><ul class="region-column list-unstyled col-12 col-sm-6 col-md-4 col-xl-3 mb-0" ng-repeat="col in [0,1,2,3] track by $index" ng-class="{\n        \'d-none d-xl-block\': col === 3,\n        \'d-none d-md-block\': col === 2,\n        \'d-none d-sm-block\': col === 1\n      }"><li class="region mb-2 d-block" ng-repeat="region in $ctrl.regionGroup.regions track by $index" ng-class="{\n          \'d-xl-block\': $ctrl.isIndexInColumn($index, col, 4),\n          \'d-xl-none\': $ctrl.isIndexOutsideColumn($index, col, 4),\n          \'d-md-block\': $ctrl.isIndexInColumn($index, col, 3),\n          \'d-md-none\': $ctrl.isIndexOutsideColumn($index, col, 3),\n          \'d-sm-none\': $ctrl.isIndexOutsideColumn($index, col, 2)\n        }"><idp-location-region class="d-block" region="region" location-click-handler="$ctrl.selectLocation(location)"></idp-location-region></li></ul></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/location/components/idp-location-region.html','<div class="d-flex align-content-center c-pointer" ng-click="$ctrl.onRegionNameClick($event, $ctrl.region)"><div class="expander-indicator text-secondary e-width-5 flex-grow-0 flex-shrink-0"><span class="icon icon-chevron-down" ng-class="{ \'rotate-90-counter\': !$ctrl.region.isExpanded }"></span></div><h4 class="flex-grow-1 flex-shrink-1 letter-spacing-05 font-weight-normal lineh-base">{{ $ctrl.region.name }}</h4></div><ul class="location-list list-unstyled mb-0 pl-5" idp-locations-expander expander-flag="$ctrl.region.isExpanded"><li class="py-2 c-pointer" ng-repeat="location in $ctrl.region.locations track by location.iD + location.name" ng-show="$ctrl.showLocation(location)" ng-click="$ctrl.selectLocation(location)"><h4 class="text-secondary m-0 letter-spacing-03 font-weight-normal">{{ location.name }} <span class="d-inline-block pl-1"><span class="text-black icon icon-day" ng-show="$ctrl.hasDayClasses(location)"></span> <span class="text-black icon icon-night" ng-show="$ctrl.hasNightClasses(location)"></span></span><div ng-if="location.addrArea.trim().length > 0"><span class="location-address text-muted">{{ location.addrArea }}</span><div class="location-status" ng-class="{\'location-status-open\': location.locationAvailabilityStatusAttrID == 1, \'location-status-coming\': location.locationAvailabilityStatusAttrID == 2, \'location-status-in2years\': location.locationAvailabilityStatusAttrID == 3}"><span ng-if="location.locationAvailabilityStatusAttrID == 1" class="fas fa-circle fa-xs" aria-hidden="true"></span> {{ location.locationAvailabilityStatusAttr }}</div></div></h4></li></ul>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/billing.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts><div id="billing" ng-show="vm.canSee"><div class="row" data-ng-show="vm.hasMadePurchase"><div class="col-md-6 mt-3"><h3>Make a Payment</h3><p>{{vm.getBalanceMsg()}}</p><p><a class="btn btn-primary no-text-transform px-5" ng-disabled="!vm.canUpdate" ng-class="{disabled: !vm.canUpdate || (!vm.pulseContext.isImpersonating && !vm.hasBalance)}" href="#/my-account/billing/payment">Go Now</a></p></div><div class="col-md-6 mt-3"><h3>Print Statement</h3><p>View or print your current billing statement</p><p><a class="btn btn-primary no-text-transform px-5" href="#/my-account/billing/statements">Go Now</a></p></div></div><div class="row"><div class="col-md-6 mt-3"><h3>Billing Information</h3><p ng-if="vm.hasActivePaymentPlan || vm.hasOPLSubscriptions">View or edit your current billing information</p><p ng-if="!vm.hasActivePaymentPlan && !vm.hasOPLSubscriptions">You have no upcoming recurring payments</p><p><a class="btn btn-primary no-text-transform px-5" ng-class="{disabled: !vm.hasActivePaymentPlan && !vm.hasOPLSubscriptions}" href="#/my-account/billing/billingInfo">Go Now</a></p></div><div class="col-md-6 mt-3" ng-show="vm.hasTAPApplication"><h3>iD Tech Scholarship Program</h3><p>Check your current status</p><p><a class="btn btn-primary no-text-transform px-5" href="#/my-account/billing/tap">Go Now</a></p></div><div class="col-md-6 mt-3" ng-show="vm.isVIPAvailable"><h3>VIP Pass</h3><p>Purchase or review your 2024 early access pass.</p><p><a class="btn btn-primary no-text-transform px-5" href="#/my-account/billing/vip">Go Now</a></p></div><div class="col-md-6 mt-3" ng-show="vm.isOneOnOneUpsellVisible"><h3>Online Private Lessons</h3><p>Purchase additional online sessions</p><p><button class="btn btn-primary no-text-transform px-5" ng-disabled="!vm.canUpdate" ng-click="vm.addTutoring()">Go Now</button> <button class="btn btn-link no-text-transform ml-lg-3" ng-show="vm.hasOPLSubscriptions" ng-click="vm.manageSubscription()">Manage your subscriptions</button></p></div><div class="col-md-6 mt-3" ng-show="vm.vouchers && vm.vouchers.length > 0"><h3>Vouchers</h3><p>View your issued vouchers</p><p><a class="btn btn-primary no-text-transform px-5" href="#/my-account/billing/vouchers">Go Now</a></p></div></div><hr></div><idp-footer show-simple="true"></idp-footer></div><script type="text/ng-template" id="taxHelp.html"><p>\r\n        TODO: tax help text goes here....\r\n    </p></script>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/billingInfo.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts></div><div id="billing-info" ng-show="vm.canSee"><idp-credit-card-popup popup-id="changeCreditCardPopup" api="vm.creditCardPopupApi"></idp-credit-card-popup><div id="content" class="grid"><div class="container"><h3>Billing Information</h3><section ng-if="vm.currencyTypes.length > 2"><div class="row mb-3 pt-2"><div class="col-md-6"><h4>Currency Type</h4><div><select name="currency_type" class="form-control" ng-model="vm.selectedCurrencyTypeID" ng-options="o.typeID as o.typeString for o in vm.currencyTypes"></select></div></div></div></section><fieldset ng-if="vm.selectedCurrencyTypeID" ng-disabled="!vm.canUpdate"><div ng-if="vm.isOnPaymentPlan || vm.billingInformation.hasOplSubscriptions"><div class="row"><div class="col-md-6 pt-2"><h4>Recurring Payment Method</h4><div class="pt-2" ng-show="vm.recurringPayment">{{vm.recurringDescription}} <span id="recurringHelp" class="ml-1 icon icon-info c-pointer" ng-click="vm.showRecurringHelp($event);"></span></div></div></div><div class="row mt-2"><div class="col-12" ng-if="vm.selectedCurrencyTypeID == $root.Enums.CurrencyType.USD"><button class="btn btn-primary" data-ng-click="vm.showCreditCardPopup()">{{vm.changeBtnLabel}}</button></div><div class="col-md-6" ng-if="vm.selectedCurrencyTypeID == $root.Enums.CurrencyType.INR">If you would like to change the credit card or bank account that is being used for your recurring payments please use the <a ng-click="vm.makePayment()" href="javscript:void(0)">Make Payment</a> page.</div></div></div><div class="mt-7" ng-show="vm.isOnPaymentPlan"><h3 class="row col-xs-12">Payment Plans</h3><div><div class="row col-xs-12">See below for your current payment schedule.</div><idp-scheduled-payments currency-type-id="vm.selectedCurrencyTypeID" scheduled-payments-info="vm.billingInformation" is-for-my-account="true"></idp-scheduled-payments></div><div class="row"><div class="col-md-6" ng-show="vm.showCsControls"><p><table><tr ng-if="vm.currencyTypes.length > 2"><td style="color:red;font-weight:bold;" colspan="2">Please note that changing the \'Monthly Payment Day\' or \'Un-enrolling\' the customer from automatic payments will affect ALL of the customer\'s currencies.</td></tr><tr><td valign="top"><div class="form-check"><input id="chkEnrolledInScheduledPayments" class="form-check-input" type="checkbox" ng-model="vm.enrolledInScheduledPayments"> <label class="form-check-label" for="chkEnrolledInScheduledPayments"></label></div></td><td style="padding-left:15px;">Uncheck and click \'Save\' button below to un-enroll customer from automatic payments.</td></tr></table></p><p><select id="selectAutoPayDayOrdinal"></select> Monthly Payment Day</p><p><button class="btn btn-primary no-text-transform" ng-click="vm.saveScheduledPaymentChanges()">Save</button></p></div></div></div><div class="row mt-7" ng-show="vm.missedScheduledPaymentsInfo.amount > 0"><div class="col-xs-12"><h3>Missed payments</h3><div>Pay {{vm.missedScheduledPaymentsInfo.amount | currency:vm.selectedCurrencyTypeID:2 }} for past due automatic payment(s).</div></div></div><div class="row mt-2" ng-show="vm.missedScheduledPaymentsInfo.amount > 0"><div class="col-xs-12"><button class="btn btn-primary" ng-click="vm.payMissedScheduledPayments()">Process missed payments</button></div></div><div class="row mt-7" ng-show="vm.billingInformation.hasOplSubscriptions"><div class="col-xs-12"><h3>Online Private Lesson - Subscriptions</h3><button class="btn btn-link no-text-transform ml-lg-3" ng-click="vm.manageSubscription()">Manage your subscriptions</button></div></div></fieldset></div></div></div><script type="text/ng-template" id="autoBillUSD.html"><p><b>Camps and Academies</b></p>\n  <p>\n    Enroll in Auto-Bill to avoid late fees! If this is checked,\n    we will automatically use your recurring payment credit card to pay your Balance\n    Due on the due date.\n  </p></script><script type="text/ng-template" id="autoBillNonUSD.html"><p><b>Camps and Academies</b></p>\n  <p>\n    Enroll in Auto-Bill to avoid late fees! If this is checked,\n    we will automatically use your recurring payment credit card or bank account to pay your Balance\n    Due on the due date.\n  </p></script><script type="text/ng-template" id="recurringHelpUSD.html"><p>\n    By using this credit card to register with a payment plan or to purchase an Online Private Lessons subscription,\n    it will become your default credit card. All future recurring payments will be made using this\n    credit card, unless otherwise updated in My Account.\n  </p></script><script type="text/ng-template" id="recurringHelpNonUSD.html"><p>\n    By using this credit card or bank account to register with a payment plan or to purchase an Online Private Lessons subscription,\n    it will become your default credit card or bank account. All future recurring payments will be made using this\n    credit card or bank account, unless otherwise updated in My Account.\n  </p></script><script type="text/ng-template" id="pay-missed-payments-success.html"><p>\n    Thank you for your payment(s), you will receive one or more email confirmations to the email address on your account.\n  </p></script><script type="text/ng-template" id="pay-missed-payments-failure.html"><p>\n    Unfortunately we were unable to process your missed payment(s). Please update your recurring payment method above or contact Customer Service at 1-888-709-8324 for assistance.\n  </p></script>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/billingScheduledPayments.html','');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/payment.html','<div class="container" ng-show="vm.canSee"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err><fieldset ng-disabled="!vm.canUpdate"><div ng-if="vm.showSmsCode"><h3 class="text-center">Please Enter the SMS Code</h3><div class="row"><div class="col-md-12"><div class="form-group mb-0"><label class="sr-only" for="otpCode">SMS Code</label> <input name="smsCode" class="form-control" placeholder="SMS Code" ng-model="vm.selectedSmsCode" required maxlength="20" autocomplete="off" idp-numbers-only></div></div></div><div class="row justify-content-end" style="margin-top:10px;margin-bottom:15px;"><div class="col-12 col-md-4 mb-3"><button type="button" class="btn btn-primary btn-block" ng-click="vm.submitSmsCode()">SUBMIT</button></div><div class="col-12 col-md-4 mb-3"><button type="button" class="btn btn-primary btn-block" ng-click="vm.submitSmsCode(\'resend\')">RE-SEND CODE</button></div><div class="col-12 col-md-4"><button type="button" class="btn btn-primary btn-block" ng-click="vm.submitSmsCode(\'cancel\')">CANCEL</button></div></div></div><section ng-if="vm.showMakePaymentSection && !vm.showSmsCode"><div class="row"><div class="col-xs-12"><h3>Make a Payment</h3>Please select an option below to make a balance payment.<hr></div></div><div class="row" ng-if="vm.showHasScheduledPaymentSection"><div class="col-xs-12">Go to the <a ng-href="#{{ vm.common.$rootScope.Routes.Billing_Info }}">Billing Information Page</a> to view your automatic Payment Plans and pay any past due balance(s).</div></div><div class="my-3"><section ng-if="vm.currencyTypesWithBalanceDue.length > 2"><h4 class="mb-3">Please select the currency you would like to make a payment for:</h4><div class="row mb-3"><div class="col-lg-8 form-group" uib-tooltip="Currency Type" tooltip-trigger="\'focus\'"><label for="currency_type" style="font-weight:bold;color:black;">Currency Type</label> <select name="currency_type" class="form-control" ng-model="vm.selectedCurrencyTypeID" ng-options="o.typeID as o.typeString for o in vm.currencyTypesWithBalanceDue"></select></div></div></section><section ng-if="vm.selectedCurrencyTypeID"><section ng-if="vm.showPaymentAmountFields"><h4>Payment Amount</h4><div class="row"><div class="col-lg-8 form-group"><label class="sr-only" for="paymentAmount">Paymount Amount Options</label> <select name="paymentAmount" class="form-control" ng-model="vm.selectedPaymentOption" autocomplete="off" ng-required="true" uib-tooltip="Payment Amount Option" tooltip-trigger="focus" ng-change="vm.onPaymentAmountSelectChange()" ng-options="opt as opt.text for opt in vm.paymentAmountOptions"><option value="">Please select</option></select><div ng-messages="vm.myForm.paymentAmount.$error" class="text-danger"><div ng-message="required">Please select payment amount</div></div></div></div><div class="row" ng-if="vm.showOtherAmount"><div class="col-lg-8 form-group"><label class="sr-only" for="otherAmount">Other Paymount Amount</label> <input name="otherAmount" type="number" class="form-control" placeholder="{{vm.otherAmountPHText}}" ng-model="vm.otherPaymentAmount" ng-required="vm.showOtherAmount" maxlength="50" min="1" max="{{vm.getMaxOtherAmount()}}" autocomplete="off" uib-tooltip="Payment Amount" tooltip-trigger="focus"><div ng-messages="vm.myForm.otherAmount.$error" class="text-danger"><div ng-message="required">Payment amount is required</div><div ng-message="maxlength">The payment amount must be 50 characters or less</div><div ng-message="min">Payment amount must be more than 0</div><div ng-message="max">Payment amount exceeded balance due</div></div></div></div></section><h4>Payment Method</h4><div class="row my-3"><div class="col-lg-8 form-group"><select name="paymentMethod" class="form-control" ng-model="vm.selectedPaymentMethodTypeID" autocomplete="off" uib-tooltip="Payment Method" tooltip-trigger="focus" ng-change="vm.onPaymentMethodChange()" ng-options="o.typeID as o.typeString for o in vm.paymentMethodTypes"></select></div></div><div class="row"><div class="col-lg-8 form-group"><idp-bank-transfer-info ng-if="vm.selectedPaymentMethodTypeID == $root.Enums.PaymentMethodType.BankTransfer" bank-transfer-info="vm.bankTransferInfo" amount-to-charge="vm.getPaymentAmount()"></idp-bank-transfer-info><idp-credit-card-info ng-if="vm.selectedPaymentMethodTypeID == $root.Enums.PaymentMethodType.CreditCard" credit-card-info="vm.creditCardInfo" amount-to-charge="vm.getPaymentAmount()" show-billing-address="vm.creditCardDeclined"></idp-credit-card-info><idp-check-info ng-if="vm.selectedPaymentMethodTypeID == $root.Enums.PaymentMethodType.Check" check-info="vm.checkInfo" amount-to-charge="vm.getPaymentAmount()"></idp-check-info><idp-money-order-info ng-if="vm.selectedPaymentMethodTypeID == $root.Enums.PaymentMethodType.MoneyOrder" money-order-info="vm.checkInfo" amount-to-charge="vm.getPaymentAmount()"></idp-money-order-info><idp-voucher-scholarship-info ng-if="vm.selectedPaymentMethodTypeID == $root.Enums.PaymentMethodType.Voucher\n                                          || vm.selectedPaymentMethodTypeID == $root.Enums.PaymentMethodType.Scholarship" voucher-scholarship-info="vm.voucherScholarshipInfo"></idp-voucher-scholarship-info></div></div><div class="row" ng-show="vm.hasErrorMsg"><div class="col-lg-8 text-danger" ng-bind-html="vm.errMsg"></div></div><div class="row"><div class="col-lg-5 col-sm-2"></div><div class="col-lg-3 col-sm-8"><button type="button" class="btn btn-primary btn-block" ng-disabled="vm.submitted" ng-dblclick="false" ng-click="vm.beginMakePayment()">Continue</button></div></div></section></div></section><section ng-if="!vm.showMakePaymentSection"><div class="row"><div class="col-xs-12"><h3>Payment Confirmation</h3>Thank you for your payment! You will receive an email confirmation to the email address on your account.<hr></div></div><section ng-if="vm.showPaymentSummarySection"><h4>Payment Summary</h4><div class="row"><div class="col-lg-8">Total paid on the balance: {{vm.paymentAmount | currency:vm.selectedCurrencyTypeID:2}}</div></div><div class="row" ng-show="vm.remainingBalance && vm.remainingBalance > 0"><div class="col-lg-8">Remaining balance: {{vm.remainingBalance | currency:vm.selectedCurrencyTypeID:2}}</div></div><div class="row" ng-show="vm.remainingContractedBalance && vm.remainingContractedBalance > 0"><div class="col-lg-8">Contracted Payment balance: {{vm.remainingContractedBalance | currency:vm.selectedCurrencyTypeID:2}}</div></div><div class="row my-3"><div class="col-lg-3 col-sm-8"><div class="d-none d-lg-inline-block"><a class="btn btn-outline-secondary btn-block" ng-href="#{{ vm.common.$rootScope.Routes.Billing_Statements_Detailed }}"><nobr>View Detailed Statement >></nobr></a></div><div class="d-lg-none">Detailed statement available for screen widths greater than 991 pixels.</div></div></div></section><section ng-if="!vm.showPaymentSummarySection">Loading summary...</section></section></fieldset></form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/paymentiFrame.html','<div class="my-account home" style="margin-bottom:3em;"><div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/statements.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><div ng-show="vm.canSee"><div class="row"><div class="col-xs-12"><h3>Customer Statement</h3></div></div><div class="d-none d-md-block"><div class="row"><div class="col-md-6"><div><img ng-src="{{vm.logoUrl}}" alt="iD Tech Camps" title="iD Tech Camps" style="height:66px;width:66px;"></div></div><div class="col-md-6"><div style="float:right;"><table><tr><td><button type="button" class="btn btn-primary btn-block" ng-dblclick="false" ng-click="vm.print()" style="width:125px;float:right;">Print</button></td></tr><tr><td><div class="d-none d-lg-inline-block" style="margin-top: 5px;"><a ng-href="#{{ vm.common.$rootScope.Routes.Billing_Statements_Detailed }}?termGroupYear={{vm.selectedTermGroupYear}}">View detailed statement</a></div><div class="d-none d-md-inline-block d-lg-none" style="margin-top: 5px;text-align: right;">Detailed statement available for screen widths greater than 991 pixels.</div></td></tr></table></div></div></div></div><div class="d-none d-sm-block d-md-none"><div class="row"><div class="col-xs-6"><div><img ng-src="{{vm.logoUrl}}" alt="iD Tech Camps" title="iD Tech Camps" style="height:66px;width:66px;"></div></div><div class="col-xs-6"><button type="button" class="btn btn-primary btn-block" ng-dblclick="false" ng-click="vm.print()" style="max-width:125px;float:right;">Print</button><div class="d-inline-block" style="margin-top: 5px;text-align:right;">Detailed statement available for screen widths greater than 991 pixels.</div></div></div></div><div class="d-block d-sm-none"><div class="row"><div class="col-xs-12"><div><img ng-src="{{vm.logoUrl}}" alt="iD Tech Camps" title="iD Tech Camps" style="height:66px;width:66px;"></div><div style="margin-top:15px;">{{vm.simplifiedStatementDTO.entities[0].entityName}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityAddressLine1">{{vm.simplifiedStatementDTO.entities[0].entityAddressLine1}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityAddressLine2">{{vm.simplifiedStatementDTO.entities[0].entityAddressLine2}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityAddressLine3">{{vm.simplifiedStatementDTO.entities[0].entityAddressLine3}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityCity">{{vm.simplifiedStatementDTO.entities[0].entityCity}}, {{vm.simplifiedStatementDTO.entities[0].entityState}} {{vm.simplifiedStatementDTO.entities[0].entityPostalCode}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityCountry">{{vm.simplifiedStatementDTO.entities[0].entityCountry}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityPhoneNumber">Phone: {{vm.simplifiedStatementDTO.entities[0].entityPhoneNumber}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityTaxID">Tax ID: {{vm.simplifiedStatementDTO.entities[0].entityTaxID}}</div></div><div class="col-xs-12 mt-3"><button type="button" class="btn btn-primary btn-block" ng-dblclick="false" ng-click="vm.print()">Print</button><div style="text-align:center;margin-top: 5px;">Detailed statement available for screen widths greater than 991 pixels.</div></div></div></div><div ng-if="vm.simplifiedStatementDTO"><div class="row mt-2"><div class="col-md-6 d-none d-sm-block"><div>{{vm.simplifiedStatementDTO.entities[0].entityName}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityAddressLine1">{{vm.simplifiedStatementDTO.entities[0].entityAddressLine1}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityAddressLine2">{{vm.simplifiedStatementDTO.entities[0].entityAddressLine2}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityAddressLine3">{{vm.simplifiedStatementDTO.entities[0].entityAddressLine3}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityCity">{{vm.simplifiedStatementDTO.entities[0].entityCity}}, {{vm.simplifiedStatementDTO.entities[0].entityState}} {{vm.simplifiedStatementDTO.entities[0].entityPostalCode}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityCountry">{{vm.simplifiedStatementDTO.entities[0].entityCountry}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityPhoneNumber">Phone: {{vm.simplifiedStatementDTO.entities[0].entityPhoneNumber}}</div><div ng-if="vm.simplifiedStatementDTO.entities[0].entityTaxID">Tax ID: {{vm.simplifiedStatementDTO.entities[0].entityTaxID}}</div></div><div class="col-md-6 text-md-right mt-md-0 text-left mt-3" style="text-align: right;"><div><b>Name:</b> {{vm.simplifiedStatementDTO.customerName}}</div><div><b>Account Number:</b> {{vm.simplifiedStatementDTO.customerAccountNumber}}</div><div ng-if="vm.simplifiedStatementDTO.customerAddressLine1">{{vm.simplifiedStatementDTO.customerAddressLine1}}</div><div ng-if="vm.simplifiedStatementDTO.customerAddressLine2">{{vm.simplifiedStatementDTO.customerAddressLine2}}</div><div ng-if="vm.simplifiedStatementDTO.customerAddressLine3">{{vm.simplifiedStatementDTO.customerAddressLine3}}</div><div ng-if="vm.simplifiedStatementDTO.customerCity">{{vm.simplifiedStatementDTO.customerCity}}, {{vm.simplifiedStatementDTO.customerState}} {{vm.simplifiedStatementDTO.customerPostalCode}}</div><div ng-if="vm.simplifiedStatementDTO.customerCountry">{{vm.simplifiedStatementDTO.customerCountry}}</div></div></div><div class="row mt-2"><div class="col-xs-12"><div ng-if="vm.simplifiedStatementDTO.entities.length > 1"><b>Entity / Country:</b> <nobr><select name="entityCompany" class="ml-1" ng-change="vm.loadSimplifiedStatement()" ng-model="vm.selectedEntityCompany" ng-options="o as o.entityName for o in vm.simplifiedStatementDTO.entities"></select> <span class="icon icon-info ml-1" style="cursor: pointer;" ng-click="vm.showEntityInfo()"></span></nobr></div></div></div><div class="row mt-3" ng-if="vm.simplifiedStatementDTO.subsidiaries.length > 1"><div class="col-xs-12"><div><b>Subsidiary:</b> <select name="subsidiaries" class="ml-1" ng-change="vm.loadSimplifiedStatement()" ng-model="vm.simplifiedStatementDTO.selectedSubsidiary" ng-options="o.companyID as o.companyName for o in vm.simplifiedStatementDTO.subsidiaries"></select></div></div></div><div class="row mt-3"><div class="col-xs-12"><div><b>Camp Year:</b> <select name="termGroupYears" class="ml-1" ng-change="vm.loadSimplifiedStatement()" ng-model="vm.selectedTermGroupYear" ng-options="o as o for o in vm.simplifiedStatementDTO.termGroupYears"></select></div></div></div><div class="row"><div class="col-xs-12"><div><b>Statement Period:</b> {{vm.simplifiedStatementDTO.statementPeriod}}</div><div><b>Statement Date:</b> {{vm.simplifiedStatementDTO.statementDate}}</div></div></div><div class="row mt-3" ng-if="vm.simplifiedStatementDTO.participants.length == 0 \n        && vm.simplifiedStatementDTO.nonParticipantItems.length == 0\n        && vm.simplifiedStatementDTO.totalRefunds == 0"><div class="col-xs-12">There are no transactions to display for the selected camp year.</div></div><div ng-if="vm.simplifiedStatementDTO.participants.length > 0 \n        || vm.simplifiedStatementDTO.nonParticipantItems.length > 0\n        || vm.simplifiedStatementDTO.totalCharges > 0"><div class="row mt-3"><div class="col-xs-12"><b>Charges</b></div></div><div ng-repeat="participant in vm.simplifiedStatementDTO.participants track by participant.userID"><div ng-style="{\'background-color\': (participant.bgIndex % 2 !== 0) ? \'white\' : \'#f4f4f4\'}"><div class="row" ng-class="$index > 0 ? \'mt-2\' : \'\'"><div class="col-xs-12" style="padding-left: 30px;"><b>{{participant.fullName}}</b></div></div><div ng-repeat="item in participant.items track by item.orderDetailID"><div class="row mt-2"><table style="width:100%;"><tr><td align="left" style="padding-left: 50px;padding-right: 15px;">{{item.startDate}} {{item.locationName}}<br ng-if="item.startDate && item.startDate != \'\'">{{item.itemName}}</td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;">{{item.itemPrice | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div><div ng-repeat="option in item.options track by option.orderDetailID"><div class="row mt-2"><table style="width:100%;"><tr><td align="left" style="padding-left: 70px;padding-right: 15px;">{{option.itemName}}</td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;">{{option.itemPrice | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div></div></div><div class="row mt-2"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;">Total</td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;">{{participant.total | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div></div></div><div ng-if="vm.simplifiedStatementDTO.nonParticipantItems && vm.simplifiedStatementDTO.nonParticipantItems.length > 0" ng-style="{\'background-color\': (vm.simplifiedStatementDTO.nonParticipantItemsBgIndex % 2 !== 0) ? \'white\' : \'#f4f4f4\'}"><div class="row mt-2"><div class="col-xs-12" style="padding-left: 30px;"><b>Other</b></div></div><div ng-repeat="item in vm.simplifiedStatementDTO.nonParticipantItems track by item.orderDetailID"><div class="row mt-2"><table style="width:100%;"><tr><td align="left" style="padding-left: 50px;padding-right: 15px;">{{item.itemName}} <span ng-if="item.productCategoryTypeID == Enums.ProductCategoryType.Fee" class="icon icon-info" style="cursor: pointer;" ng-click="vm.showFeeInfo()"></span></td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;">{{item.itemPrice | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div></div><div class="row mt-2"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;">Total</td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;">{{vm.simplifiedStatementDTO.otherTotal | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div></div><div class="row mt-2"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;"><b>Total Charges</b></td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;"><b>{{vm.simplifiedStatementDTO.totalCharges | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</b></td></tr></table></div></div><div ng-if="vm.simplifiedStatementDTO.totalDiscountsAmount > 0\n        || vm.simplifiedStatementDTO.totalAppliedCredit > 0\n        || (vm.simplifiedStatementDTO.totalRafRewards > 0\n        && vm.selectedEntityCompany\n        && vm.selectedEntityCompany.entityCompanyID == 1)"><div class="row mt-3"><div class="col-xs-12"><b>Credits</b> <span ng-if="vm.simplifiedStatementDTO.entities.length > 1" class="icon icon-info" style="cursor: pointer;" ng-click="vm.showCreditsInfo()"></span></div></div><div class="row mt-2 bg-white" ng-if="vm.simplifiedStatementDTO.totalDiscountsAmount > 0"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;">Discounts <span class="icon icon-info" style="cursor: pointer;" ng-click="vm.showDiscountInfo()"></span></td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;white-space: nowrap;">-{{vm.simplifiedStatementDTO.totalDiscountsAmount | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div><div class="row mt-2" ng-if="vm.simplifiedStatementDTO.totalAppliedCredit > 0"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;">Purchase Exchange Credit</td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;white-space: nowrap;">-{{vm.simplifiedStatementDTO.totalAppliedCredit | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div><div class="row mt-2" ng-if="vm.simplifiedStatementDTO.totalAppliedCredit < 0"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;">Credit Removal</td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;white-space: nowrap;">{{-vm.simplifiedStatementDTO.totalAppliedCredit | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div><div class="row mt-2" ng-if="vm.simplifiedStatementDTO.totalRafRewards > 0"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;">RAF Rewards</td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;white-space: nowrap;">-{{vm.simplifiedStatementDTO.totalRafRewards | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div><div class="row mt-2"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;"><b>Total Credits</b></td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;white-space: nowrap;" ng-if="vm.totalCredits > 0"><b>-{{vm.totalCredits | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</b></td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;white-space: nowrap;" ng-if="vm.totalCredits < 0"><b>{{-vm.totalCredits | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</b></td></tr></table></div></div><div ng-if="vm.simplifiedStatementDTO.payments.length > 0"><div class="row mt-3"><div class="col-xs-12"><b>Payments</b> <span ng-if="vm.simplifiedStatementDTO.entities.length > 1" class="icon icon-info" style="cursor: pointer;" ng-click="vm.showPaymentsInfo()"></span></div></div><div ng-repeat="payment in vm.simplifiedStatementDTO.payments track by payment.paymentID"><div class="row mt-2"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;">{{payment.description}}</td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;white-space: nowrap;">-{{payment.paymentAmount | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</td></tr></table></div></div><div class="row mt-2"><table style="width:100%;"><tr><td align="left" style="padding-left: 30px;padding-right: 15px;"><b>Total Payments</b></td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;white-space: nowrap;"><b>-{{vm.simplifiedStatementDTO.totalPayments | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</b></td></tr></table></div></div><div class="row mt-2" ng-if="vm.simplifiedStatementDTO.totalRefunds > 0"><table style="width:100%;"><tr><td align="left" style="padding-left: 15px;padding-right: 15px;"><b>Total Refunds</b></td><td align="right" valign="bottom" class="text-right" style="padding-right: 30px;"><b>{{vm.simplifiedStatementDTO.totalRefunds | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</b></td></tr></table></div><div class="row mt-3"><div class="col-xs-12"><b>Balance due for statement period {{vm.simplifiedStatementDTO.statementPeriod}}:</b> <span ng-if="vm.simplifiedStatementDTO.entities.length == 1">{{vm.simplifiedStatementDTO.balanceDueTotal | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</span></div></div><div ng-if="vm.simplifiedStatementDTO.entities.length > 1"><div class="row mt-2"><div class="col-xs-12" style="padding-left: 30px;"><b>This entity:</b> {{vm.simplifiedStatementDTO.balanceDueForEntity | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</div></div><div class="row mt-2"><div class="col-xs-12" style="padding-left: 30px;"><b>Across all entities:</b> {{vm.simplifiedStatementDTO.balanceDueTotal | currency:vm.simplifiedStatementDTO.currencyTypeID:2}}</div></div></div><div class="row mt-3"><div class="col-xs-12"><div><b>Camp Year:</b> <select name="termGroupYears" class="ml-1" ng-change="vm.loadSimplifiedStatement()" ng-model="vm.selectedTermGroupYear" ng-options="o as o for o in vm.simplifiedStatementDTO.termGroupYears"></select></div></div></div><div class="row mt-3 d-none d-lg-block"><div class="col-xs-12"><div ng-if="vm.simplifiedStatementDTO.entities.length > 1">Don\u2019t see all your purchases, credits, or payments? Select another entity/country or <a ng-href="#{{ vm.common.$rootScope.Routes.Billing_Statements_Detailed }}?termGroupYear={{vm.selectedTermGroupYear}}">View detailed statement</a>.</div><div ng-if="vm.simplifiedStatementDTO.entities.length == 1">Don\u2019t see all your purchases, credits, or payments? <a ng-href="#{{ vm.common.$rootScope.Routes.Billing_Statements_Detailed }}?termGroupYear={{vm.selectedTermGroupYear}}">View detailed statement</a>.</div></div></div><div class="row mt-3 d-lg-none"><div class="col-xs-12"><div ng-if="vm.simplifiedStatementDTO.entities.length > 1">Don\u2019t see all your purchases, credits, or payments? Detailed statement available for screen widths greater than 991 pixels.</div><div ng-if="vm.simplifiedStatementDTO.entities.length == 1">Don\u2019t see all your purchases, credits, or payments? Detailed statement available for screen widths greater than 991 pixels.</div></div></div><div class="row mt-3" ng-if="vm.simplifiedStatementDTO.entities.length > 1"><div class="col-xs-12"><b>Entity / Country:</b> <nobr><select name="entityCompany" class="ml-1" ng-change="vm.loadSimplifiedStatement()" ng-model="vm.selectedEntityCompany" ng-options="o as o.entityName for o in vm.simplifiedStatementDTO.entities"></select> <span class="icon icon-info ml-1" style="cursor: pointer;" ng-click="vm.showEntityInfo()"></span></nobr></div></div><div class="row mt-3"><div class="col-xs-12">To pay your balance by check, make your check payable to and mail to iD Tech. <b>Please include your account number on your check.</b></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/statementsDetailed.html','<div class="my-account home" style="margin-bottom:3em;"><div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/subscription.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts></div><div class="container mt-5" ng-show="vm.canSee"><div class="font-weight-bold text-em-1-5 text-black">Online Private Lesson - Subscriptions</div><div class="row"><div class="col-12 col-lg-8 text-black">Going on vacation or just need to take a break? You can pause your subscription(s) at any time, and jump back in when you\'re ready!</div></div><div class="my-5" ng-if="vm.studentSubscriptions"><div class="d-flex text-black mb-2"><i class="icon icon-students-icon text-em-1-5 mr-2"></i><span class="font-weight-bold">Your Students</span></div><div class="row col-md-6 col-xl-4"><select ng-model="vm.selectedStudentId" class="form-control" ng-change="vm.selectedStudentChanged()" ng-init="vm.setSelectedStudent()" ng-options="ss.studentUserID as ss.fullName for ss in vm.studentSubscriptions"></select></div></div><div ng-if="vm.hasSubscriptions()"><div class="text-em-1-25 text-black">Active subscription{{vm.selectedStudentSubscriptions.length == 1 ? \'\':\'s\'}} ({{vm.selectedStudentSubscriptions.length}})</div><hr class="mb-0"><div ng-repeat="subscription in vm.selectedStudentSubscriptions" class="alternative-row"><div class="py-3 px-md-3 px-2"><div class="card-heading" id="heading{{::subscription.userID}}"><div class="d-flex flex-column flex-lg-row justify-content-between vertical-align mb-0"><div class="d-flex flex-column"><h4 class="d-inline-block"><span class="course-name">{{subscription.productName}}<span ng-show="subscription.isAutoRenew">&nbsp;(Monthly subscription)</span></span></h4><div ng-hide="subscription.failedPaymentCount >= 3"><span ng-hide="subscription.isRenewPaused">Renewal date <span class="icon icon-info mr-1 c-pointer" id="renewalDateHelp" ng-click="vm.showRenewalDateHelp($event)"></span>: {{subscription.expiryDate | date:\'MMM d, yyyy\'}} </span><span class="font-weight-bold text-purple" ng-show="subscription.isRenewPaused">Paused until {{subscription.expiryDate | date:\'MMM d, yyyy\'}}</span></div><div ng-show="subscription.failedPaymentCount >= 3"><span class="font-weight-bold text-danger">Suspended</span></div></div><div class="d-flex flex-row h-75 pl-lg-3 mt-2"><button class="btn btn-outline-secondary btn-sm text-nowrap" ng-if="!subscription.isRenewPaused" ng-hide="subscription.failedPaymentCount >= 3" ng-disabled="!vm.canUpdate" ng-click="vm.showSubscriptionPausePopup(subscription)">Pause subscription</button> <button class="btn btn-outline-secondary btn-sm text-nowrap" ng-if="subscription.isRenewPaused" ng-hide="subscription.failedPaymentCount >= 3" ng-disabled="!vm.canUpdate || vm.isSubmitting" ng-click="vm.onResumeSubscriptionClicked(subscription)">Resume subscription</button> <button class="btn btn-link btn-sm text-nowrap" ng-disabled="!vm.canUpdate" ng-click="vm.showSubscriptionCancelPopup(subscription)">Cancel subscription</button></div></div></div></div></div></div><div ng-if="!vm.hasSubscriptions()">This student does not have any active subscriptions.</div></div><div class="container my-5" ng-if="!vm.canSee"><h4 class="text-danger">You don\'t have permission to view the page.</h4></div><idp-subscription-pause-popup popup-id="subscriptionPausePopup"></idp-subscription-pause-popup><idp-subscription-cancel-popup popup-id="subscriptionCancelPopup"></idp-subscription-cancel-popup><idp-credit-card-popup popup-id="changeCreditCardPopup" api="vm.creditCardPopupApi"></idp-credit-card-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/tap.html','<div class="my-account home" style="margin-bottom:3em;"><div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/vipEarlyAccess.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><div class="billing" ng-show="vm.canSee"><fieldset ng-disabled="!vm.canUpdate"><div ng-if="vm.isAvailable"><h3>VIP Pass</h3><div><button class="btn" ng-class="{\'btn-primary\': !vm.hasCoupons, \'btn-light\': vm.hasCoupons}" ng-disabled="!vm.canUpdate" ng-dblclick="false" ng-click="vm.onVIPClicked()">Purchase</button></div></div><div class="py-3" ng-bind-html="vm.vipDivConfigText | unsafe" ng-if="!vm.hasCoupons"></div><div ng-if="vm.hasCoupons"><div class="mt-3"><h3>What\u2019s next?</h3><ol><li>This fall, your VIP pass will arrive! We\u2019ll email you your exclusive promo code for $200 off camps & virtual academies and $400 off in-person academies.</li><li>At that time, your $250 credit will be available in your account.</li><li>Starting November 1, 2023, your early access to register for next summer begins (five days before we announce to the general public).</li><li>Once you add the perfect courses to your cart, remember to enter your exclusive promo code. Your $250 credit will automatically be applied to your purchase during checkout.</li></ol><div>See you at camp!</div></div><div class="font-weight-bold my-3">VIP Pass Purchase Summary</div><p>Below is the information for your $250 credit to be used toward summer {{::vm.termGroupYear}} tuition. This credit will be automatically applied at the time of your camp purchase. (If you no longer wish to enroll, you may transfer the credit to a friend or relative.) Your exclusive VIP promo code will be emailed to you prior to your early registration period.</p><table class="table table-bordered table-sm table-striped"><thead><tr class="gridheader"><th>Purchase Date</th><th>Code</th><th>Validation Text</th><th>Status</th></tr></thead><tbody><tr ng-repeat="coupon in vm.vipCoupons track by coupon.couponID" ng-class="{\'grayout\': !vm.isCouponAvailable(coupon)}"><td>{{::coupon.createdDate | date : \'yyyy-MM-dd\' }}</td><td>{{::coupon.couponCode}}</td><td>{{::coupon.validationString}}</td><td>{{::vm.getStatusText(coupon)}}</td></tr></tbody></table><div class="text-legal">Here\u2019s the legal stuff: $250 purchase price is non-refundable and will be automatically applied as a credit towards any purchase made on or after November 1st, 2023. Credit can be transferred to a friend or family member in the event you no longer wish to enroll. Credit and promo code can be used for Summer 2024 course at iD Tech Camps, iD Tech Academies, Virtual Tech Camps, and Online Academies. Promo code expires 11:59 pm PT on November 14, 2023. Promo code cannot be combined with other offers.</div></div></fieldset></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/billing/vouchers.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><div class="billing" ng-show="vm.canSee"><h3>Vouchers</h3><div ng-if="vm.vouchers"><p class="my-3">If you have credit on your account, it will be reflected by a negative balance at the bottom of your <a href="#/my-account/billing/statements">statement</a>.</p><div class="mt-5" ng-repeat="coupon in vm.vouchers track by coupon.couponID"><idp-voucher coupon="coupon"></idp-voucher></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/online-private-lesson/clientSessions.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts></div><div class="container" id="opl-client"><div class="row"><div class="col-8"><h3 class="mb-0 d-inline-block">Online Lessons</h3></div><div class="col-4 text-right" ng-if="vm.pulseContext.isImpersonating"><button class="btn btn-link" ng-click="vm.onOnlineLessonsAdminRedirectClick()">Admin view</button></div></div></div><div class="pb-10"><div class="container pt-3" ng-show="vm.canSee" class="online-lessons-client"><div ng-if="vm.students && vm.students.length === 0"><div class="alert alert-primary mt-3" role="alert">You have no students associated with your account.</div><button class="btn btn-primary btn-sm px-4 my-2 d-none d-md-block" ng-click="vm.buyLessonsClick()">Buy lessons</button></div><div ng-if="vm.students && vm.students.length > 0"><div class="row"><div class="col-12 col-md-6"><h3 class="mb-0 d-xs-inline-block d-md-none font-weight-normal"><span>{{vm.selectedStudent.fullName}}</span></h3><div class="align-items-center my-2 d-none d-md-flex"><span class="icon icon-students-icon mr-2 text-lg-right text-em-1-5"></span> <span class="font-weight-bold text-black">My Student(s)</span></div><div><select ng-model="vm.selectedStudentID" class="form-control d-none d-md-block" ng-change="vm.selectedStudentChanged()" ng-options="ss.studentUserID as ss.fullName for ss in vm.students"></select></div></div><div class="col-12 col-md-6"><div class="d-flex align-items-center my-2"><span class="icon icon-globe mr-2 text-lg-right text-em-1-5"></span> <span class="font-weight-bold text-black">Student Time Zone</span></div><div><select ng-options="type.typeID as type.typeExtraLongString for type in vm.timeZoneTypes" ng-change="vm.updateSelectedTimeZoneTypeID()" class="form-control" name="timezone" ng-disabled="vm.isOpl3" ng-model="vm.selectedStudent.timeZoneTypeID"></select></div></div><div class="col-12 col-md-6 pt-4" ng-if="vm.showAchievements"><button type="button" ng-click="vm.onAchivementsClicked()" class="btn btn-outline-secondary">My Achievements <span class="badge badge-pill badge-secondary py-1">{{ vm.selectedStudent.earnedAchievements.length-1 }}</span></button></div></div><div ng-if="vm.hasSelectedStudentSubscriptions()" class="my-7 px-0"><idp-opl-student-subscriptions student-info="vm.selectedStudent" student-subscriptions="vm.selectedStudentSubscriptions" selected-time-zone-type="vm.selectedTimeZoneType"></idp-opl-student-subscriptions></div></div><div class="mt-1 px-0" ng-if="::vm.pulseContext.isImpersonating"><div class="d-flex align-items-center mt-3"><span class="icon icon-pencil mr-2 text-lg-right text-em-1-5"></span> <span class="font-weight-bold text-black">Notes for {{vm.selectedStudent.fullName}}</span></div><idp-online-lesson-student-notes student-notes="vm.selectedStudent.studentNotes" student-user-id="vm.selectedStudent.studentUserID"></idp-online-lesson-student-notes></div><div class="mt-7"><idp-opl-student-lessons student-info="vm.selectedStudent" student-session="vm.selectedStudentSession" selected-time-zone-type="vm.selectedTimeZoneType" selected-parent-order-detail-id="vm.parentOrderDetailId" buy-lessons-click="vm.buyLessonsClick"></idp-opl-student-lessons></div></div></div><div class="container mb-2" ng-if="vm.canSee === false" class="online-lessons"><h4 class="text-danger">You don\'t have permission to view the page.</h4></div><div class="opl-student-selector-bottom container-fluid d-flex justify-content-between align-items-center d-md-none"><button class="btn btn-primary btn-sm px-4" ng-click="vm.buyLessonsClick()">Buy lessons</button><div class="btn text-secondary d-flex align-items-center" ng-click="vm.showDropupMenu = !vm.showDropupMenu" ng-show="vm.students && vm.students.length > 1"><span class="mr-2">{{vm.showDropupMenu? \'Close\' : \'My Students\'}}</span> <span class="icon icon-plus-circle1" ng-class="{ \'d-none\': vm.showDropupMenu }"></span> <span class="icon icon-x-circle" ng-class="{ \'d-none\': !vm.showDropupMenu }"></span></div><div class="opl-dropup-content w-100 py-3 px-5" ng-show="vm.showDropupMenu"><p>Please select a student to view lessons</p><div class="student-list row mx-0" ng-click="vm.selectedStudentChanged(stud.studentUserID); vm.showDropupMenu = !vm.showDropupMenu" ng-repeat="stud in vm.students"><div class="col-4">{{stud.firstName}}</div><div class="col-7 text-right" ng-class="stud.availableSessionsCount > 0 ? \'text-green\':\'text-danger\'">{{stud.availableSessionsCount}} available {{stud.availableSessionsCount == 1? \'lesson\' : \'lessons\'}}</div></div></div></div><div class="container mb-10" id="studentAchievements" ng-if="vm.showAchievements"><idp-opl-student-achievements available-achievements="vm.availableBadges"></idp-opl-student-achievements></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/online-private-lesson/onlineSessions.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts></div><div class="container mb-10" ng-show="vm.canSee" class="online-lessons"><div class="row"><div class="col-8"><h3 class="mb-0 d-inline-block">Online Lessons</h3></div><div class="col-4 text-right" ng-if="vm.pulseContext.isImpersonating"><button class="btn btn-link" ng-click="vm.onOnlineLessonsClientRedirectClick()">Client view</button></div></div><div ng-if="vm.studentSessions && vm.studentSessions.length === 0" class="alert alert-primary mt-3" role="alert">You have no students associated with your account.</div><idp-online-lesson-students ng-if="vm.studentSessions && vm.studentSessions.length > 0" student-sessions="vm.studentSessions" selected-student-id="vm.studentID" selected-parent-order-detail-id="vm.preSelectedParentOrderDetailId" selected-order-detail-id="vm.preSelectedOrderDetailId"></idp-online-lesson-students></div><div class="container mb-10" ng-if="vm.canSee === false" class="online-lessons"><h4 class="text-danger">You don\'t have permission to view the page.</h4></div><idp-online-lesson-email-preview-popup></idp-online-lesson-email-preview-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/online-private-lesson/oplPurchase.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts></div><div class="container" style="min-height: 350px;" ng-if="vm.canSee"><h3 class="pt-6">Online Private Lesson Products</h3><div class="py-1">Select a topic</div><select ng-options="s.skillID as s.displayName for s in vm.skills" ng-change="vm.updateSelectedSkill()" class="form-control w-50" name="skill" ng-model="vm.selectedSkillID"><option value="" disabled="disabled" selected="selected">Select a topic...</option></select><h4 class="mt-5" ng-show="vm.products && vm.products.length > 0">Products</h4><div ng-repeat="p in vm.products" class="alternative-row"><div class="py-3 px-md-3 px-2"><div class="card-heading" id="heading{{::p.userID}}"><div class="d-flex flex-column flex-lg-row justify-content-between vertical-align mb-0"><div><h4 class="d-inline-block"><span class="course-name">{{::p.name}}</span> <span class="ml-1" ng-show="p.isSubscriptionSelected">(Monthly subscription)</span></h4><span class="ml-1">({{::p.shortName}})</span> <span class="ml-1">Ages: {{::p.minAge}} - {{::p.maxAge}}</span> <span class="ml-2 font-weight-bold">{{vm.calculatePrice(p)| currency:\'$\':0}}</span><div class="form-check" ng-show="p.isSubscribable"><input id="subscriptionChk_{{$index}}" name="subscriptionChk_{{$index}}" type="checkbox" ng-model="p.isSubscriptionSelected" class="form-check-input"> <label for="subscriptionChk_{{$index}}" class="form-check-label">Monthly subscription</label></div></div><div class="d-flex align-items-center"><button class="btn btn-primary btn-sm text-nowrap" ng-click="vm.navigate(p);">Select</button></div></div></div></div></div><div class="py-3" ng-show="vm.products && vm.products.length == 0">No products found</div></div><div class="container mb-10" ng-if="!vm.canSee"><h4 class="text-danger">You don\'t have permission to view the page.</h4></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/online-private-lesson/oplSessionReport.html','<div class="container" ng-cloak><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav></div><div class="container mb-10" ng-show="vm.canSee" class="online-lessons"><div class="row"><div class="col-8"><h3 class="mb-0 d-inline-block">Lesson Details</h3></div><div class="col-4 text-right"><button class="btn btn-link" ng-click="vm.onOnlineLessonsClientRedirectClick()">Client view</button> <button class="btn btn-link" ng-click="vm.onOnlineLessonsAdminRedirectClick()">Admin view</button></div></div><div><idp-online-lesson-session-summary session-summary="vm.sessionSummary" student-user-id="vm.studentID" parent-prod-id="this.sessionSummary.productID" is-edit-mode="true" on-close-clicked="vm.onCloseClicked"></idp-online-lesson-session-summary></div></div><div class="container mb-10" ng-if="vm.canSee === false" class="online-lessons"><h4 class="text-danger">You don\'t have permission to view this page.</h4></div><idp-online-lesson-email-preview-popup></idp-online-lesson-email-preview-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/online-private-lesson/schedule.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts></div><div class="container opl-client-schedule"><a class="btn btn-outline-primary btn-sm" ng-href="{{::vm.getBackToMyAccountURL()}}" role="button" style="width:auto;">Back to My Account</a><div class="py-3 font-weight-bold text-black">Schedule lesson for {{vm.studentUser.firstName}}&nbsp;{{vm.studentUser.lastName}}</div><div class="form-check d-inline-block mt-3" ng-if="vm.canViolateOvertimeRules"><input class="form-check-input" name="violateOvertimeRules" id="violateOvertimeRules" type="checkbox" ng-model="vm.isViolateOvertimeRules" ng-change="vm.violateOvertimeRules();"> <label class="form-check-label" for="violateOvertimeRules">Violate overtime rules</label></div></div><div class="pb-10 opl-client-schedule" ng-show="vm.canSee"><div class="container pt-6" class="online-lessons-client"><div ng-if="vm.hasSchedulableSelectedLessons() || vm.isRescheduling"><div class="row mb-0 mb-lg-3"><div class="col-12 col-lg-6 text-center text-lg-left"><h2>Lesson Details</h2></div><div class="col-12 col-lg-6 text-lg-right d-none d-lg-block" ng-show="(vm.isRescheduling && vm.hasChanges()) || (!vm.isRescheduling && vm.hasSchedulableSelectedLessons())"><button class="btn btn-success mx-auto px-10 py-2 font-weight-bold" ng-click="vm.scheduleLessons()" ng-disabled="vm.scheduleBtnDisabled">{{::vm.isRescheduling ? \'Schedule it!\' : \'Schedule\' }}</button></div></div><div class="row"><div class="col-12 mt-3 mt-lg-0 text-black" ng-if="!vm.isRescheduling && vm.hasSchedulableSelectedLessons()"><div><span>Time Zone: </span><span class="font-weight-bold">{{vm.studentTimeZoneTypeStr}}</span></div><ul><li ng-repeat="lession in vm.selectedLessons track by $index" ng-if="lession.topic && lession.instructor && lession.dateTime"><b>{{lession.topic.name}}</b> with {{lession.instructor.firstName}} {{lession.instructor.lastName}} on <b>{{lession.dateTime | date:"EEEE, MMMM d \'@\' h:mm a"}}</b> <a class="text-danger" ng-click="vm.removeLesson(lession)">Remove</a></li></ul></div><div class="col-12 col-lg-6 mt-3 mt-lg-0 text-black" ng-if="vm.sessionSummary"><div class="font-weight-bold text-em-1-25">Currently Scheduled Lesson</div><div><span>Topic: </span><span class="font-weight-bold">{{::vm.sessionSummary.skillStr}}</span></div><div><span>Instructor: </span><span class="font-weight-bold">{{::vm.sessionSummary.instructorName}}</span></div><div><span>Date & Time: </span><span class="font-weight-bold">{{vm.convertDateTimeFromUTC(vm.sessionSummary.startDateTimeUTC) | date:"EEEE, MMMM d, yyyy \'@\' h:mm a"}}</span></div><div><span>Time Zone: </span><span class="font-weight-bold">{{vm.originalTZTypeStr}}</span></div></div><div class="col-12 col-lg-6 mt-3 mt-lg-0 text-black" ng-if="vm.isRescheduling"><div class="font-weight-bold text-em-1-25">Replacement Lesson</div><div><span>Topic: </span><span class="font-weight-bold">{{vm.selectedTopic.name}}</span></div><div><span>Instructor: </span><span class="font-weight-bold">{{vm.selectedInstructor.firstName }} {{vm.selectedInstructor.lastName}}</span></div><div><span>Date & Time: </span><span class="font-weight-bold">{{vm.selectedDateTime | date:"EEEE, MMMM d, yyyy \'at\' h:mm a"}}</span></div><div><span>Time Zone: </span><span class="font-weight-bold">{{vm.studentTimeZoneTypeStr}}</span></div></div></div><div class="col mt-3 text-center d-block d-lg-none" ng-show="(vm.isRescheduling && vm.hasChanges()) || (!vm.isRescheduling && vm.hasSchedulableSelectedLessons())"><button class="btn btn-success mx-auto px-10 py-2 font-weight-bold" ng-click="vm.scheduleLessons()" ng-disabled="vm.scheduleBtnDisabled">{{::vm.isRescheduling ? \'Schedule it!\' : \'Schedule\' }}</button></div></div><div class="text-em-1-25 my-3 text-black" ng-show="vm.isRescheduling">Expand any section below to change your selection.</div><div class="opl-schedule-container shadow-lg p-lg-5 p-2" ng-show="vm.isShowScheduleTopics"><idp-opl-schedule-topic closed-callback="vm.onTopicClosed()" genre-topics-list="vm.genreTopicsList" selected-topic="vm.selectedTopic"></idp-opl-schedule-topic></div><div class="mt-3" ng-show="vm.selectedTopic && !vm.isShowScheduleTopics" ng-click="vm.changeTopic();"><div class="btn card border-0 shadow d-flex flex-row justify-content-between align-items-center pr-3 pl-lg-2 pl-0"><div class="d-flex flex-row align-items-center"><img ng-src="{{vm.imgSrcCheckmark}}" class="checkmark-img"> <span class="opl-header-text text-black ml-1 text-left">Topic:</span> <span class="opl-header-text text-black font-weight-bold ml-2">{{vm.selectedTopic.name}}</span></div><i class="icon icon-plus-circle opl-header-icon text-primary" ng-show="vm.canChangeSkill();"></i></div></div><div class="mt-3" ng-show="vm.selectedInstructor && !vm.isShowScheduleInstructors" ng-click="vm.changeInstructor();"><div class="btn card shadow d-flex flex-row justify-content-between align-items-center pr-3 pl-lg-2 pl-0"><div class="border-0 d-flex flex-row align-items-center"><img ng-src="{{vm.imgSrcCheckmark}}" class="checkmark-img"> <span class="opl-header-text text-black ml-1 text-left">Instructor:</span> <span class="opl-header-text text-black font-weight-bold ml-2 text-left" ng-bind-html="vm.allSelectedInstructorString | unsafe"></span></div><i class="icon icon-plus-circle opl-header-icon text-primary"></i></div></div><div class="mt-3" ng-show="vm.selectedDateTime && !vm.isShowScheduleDates" ng-click="vm.changeDateTime();"><div class="btn card shadow d-flex flex-row justify-content-between align-items-center pr-3 pl-lg-2 pl-0"><div class="border-0 d-flex flex-row align-items-center"><img ng-src="{{vm.imgSrcCheckmark}}" class="checkmark-img"> <span class="opl-header-text text-black ml-1 text-left">Date & time:</span> <span class="opl-header-text text-black font-weight-bold ml-2 text-left" ng-bind-html="vm.allSelectedDateTimeString | unsafe"></span></div><i class="icon icon-plus-circle opl-header-icon text-primary"></i></div></div><div class="opl-schedule-container shadow-lg mt-3" ng-show="vm.isShowScheduleDates" id="opl-schedule-date-time" ng-if="vm.availableDates"><div class="row"><div class="col-12"><idp-opl-schedule-date-time closed-callback="vm.onDateTimeClosed()" selected-date-updated="vm.selectedDateUpdated(selectedDate)" student-time-zone-type-id="vm.studentTimeZoneTypeID" available-dates="vm.availableDates" available-date-times="vm.availableDateTimes" selected-date-time="vm.selectedDateTime" selected-instructor="vm.selectedInstructor" selected-lessons="vm.selectedLessons" selected-lessons-count="vm.selectedLessons.length" time-zone-types="vm.timeZoneTypes" focused-date="vm.calendarFocusedDate"></idp-opl-schedule-date-time></div></div></div><div class="opl-schedule-container shadow-lg mt-3" id="opl-schedule-instructor" ng-show="vm.isShowScheduleInstructors"><div class="row"><div class="col-12"><idp-opl-schedule-instructor closed-callback="vm.onInstructorClosed()" reset-to-non-recurring-callback="vm.onResetToNonRecurringLesson()" student-time-zone-type-id="vm.studentTimeZoneTypeID" available-instructors="vm.availableInstructors" selected-date-time="vm.selectedDateTime" selected-instructor="vm.selectedInstructor" is-scheduling-recurring-dates="vm.isSchedulingRecurringDates" time-zone-types="vm.timeZoneTypes" hardware-skills="vm.hardwareSkills"></idp-opl-schedule-instructor></div></div></div><div class="row mt-5" id="opl-schedule-date-instructor" ng-hide="vm.selectedDateTime || vm.selectedInstructor"><div class="col-12 col-md" ng-click="vm.scheduleByDate()" ng-hide="vm.isShowScheduleDates"><div class="btn card text-left px-3 py-2 py-lg-6 border-0 shadow d-flex flex-row justify-content-between align-items-center opl-header-text"><div class="border-0 d-flex flex-row align-items-center"><i class="icon icon-new-cal text-green"></i><div class="ml-3"><div class="text-black font-weight-bold opl-header-text">Schedule by Date</div><div class="opl-subheader-text">Select specific dates for lessons</div></div></div><span class="icon icon-plus-circle text-color-primary opl-header-icon text-primary"></span></div></div><div class="col-4 col-md-2 my-auto px-3 py-3 py-md-0 mx-auto" ng-hide="vm.isShowScheduleDates || vm.isShowScheduleInstructors"><hr class="opl-schedule-hr font-weight-bold font-italic text-em-1-5"></div><div class="col-12 col-md" ng-click="vm.scheduleByInstructor()" ng-hide="vm.isShowScheduleInstructors"><div class="btn card text-left px-3 py-2 py-lg-6 border-0 shadow d-flex flex-row justify-content-between align-items-center opl-header-text"><div class="border-0 d-flex flex-row align-items-center"><i class="icon icon-instructor text-green"></i><div class="ml-3"><div class="text-black font-weight-bold opl-header-text">Schedule by Instructor</div><div class="opl-subheader-text">Select specific instructor for lessons</div></div></div><span class="icon icon-plus-circle text-color-primary opl-header-icon text-primary"></span></div></div></div></div></div><div class="container mb-10" ng-if="vm.canSee === false" class="online-lessons"><h4 class="text-danger">You don\'t have permission to view the page.</h4></div><idp-opl-course-info-popup popup-id="oplCourseInfoPopup"></idp-opl-course-info-popup><idp-opl-schedule-confirmation-popup popup-id="oplCourseInfoPopup"></idp-opl-schedule-confirmation-popup><idp-opl-schedule-multible-time-popup popup-id="oplMultipleTimeslotPopup"></idp-opl-schedule-multible-time-popup><idp-opl-schedule-recurring-date-popup popup-id="oplRecurringDatePopup"></idp-opl-schedule-recurring-date-popup><script type="text/ng-template" id="oplScheduleRecurringInfo.html"><div>\n    <h4>Why are we asking?</h4>\n    <p>\n      Because we know that there\'s no replacement for a teacher that brings out the best in your child -\xA0and you know your child best! If your instructor is ever unavailable, one of your other preferred instructors will be there.\n    </p>\n\n  </div></script>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/contactInfo.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected" ng-if="vm.isContactInfoCompleted"></idp-top-nav><div id="welcome" ng-if="!vm.isContactInfoCompleted"><div class="row mb-2"><div class="col-md-8"><h3 class="font-weight-normal mb-0">Welcome, {{vm.user.firstName}}!</h3></div></div></div><idp-alerts alert-list="vm.alertList"></idp-alerts><div class="row"><div class="col-xs-12"><h3>Contact Information</h3><p>This is your personal user account information.</p><div ng-if="!vm.isContactInfoCompleted" class="alert alert-info" role="alert">Let\'s set up your account! Please provide your contact information below and save in order to access your account home page. (Please ensure all fields are filled out.)</div></div></div><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><fieldset ng-disabled="!vm.canUpdate"><div class="row my-3"><div class="col-xs-12"><h4>Personal Information</h4><idp-personal-info user="vm.user" first-tab-index="10"></idp-personal-info></div></div><div class="row my-3"><div class="col-xs-12"><h4>Mailing Address</h4><idp-mailing-address address="vm.mailingAddress" first-tab-index="20"></idp-mailing-address></div></div><div class="row my-3"><div class="col-xs-12"><h4>Contact Methods</h4><p>Your email address is also used for logging into your account. Any changes made will be reflected on your next login attempt.</p><div class="row"><div class="col-xs-12"><p><strong>Email</strong>&nbsp;&nbsp;<small> This email address will receive all account notifications and <strong>will be used for login</strong>.</small></p><idp-email-address email-user-contact-method="vm.emailUserContactMethod"></idp-email-address></div></div><div class="row my-3"><div class="col-xs-12"><p><strong>Phone</strong>&nbsp;&nbsp;<small>At least one phone number is required.</small></p><idp-phone-numbers phone-user-contact-methods="vm.phoneUserContactMethods"></idp-phone-numbers></div></div></div></div></fieldset><hr class="py-1"><div class="row justify-content-between mb-10"><div class="col-md-2"><div ng-if="vm.isContactInfoCompleted"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.cancel()">Cancel</button></div></div><div class="col-md-4 mt-md-0 mt-3"><button type="submit" class="btn btn-primary btn-block" ng-disabled="!vm.canUpdate">Save Changes</button></div></div></form></div><idp-channel-pref-popup popup-id="channelPrefPopup" title="Notification Settings" api="channelPrefPopup"></idp-channel-pref-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/courseTakeHomes.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><div ng-show="vm.canSee"><h3>Course Take-Homes</h3><small>Note: For courses that have take-homes, codes will appear below on the Friday near the end of the camp session.</small><form id="{{ ::vm.formName }}" class="form-inline pt-3" name="{{ ::vm.formName }}" role="form" novalidate idp-form-focus-on-err ng-submit="null"><div class="form-group"><label for="termGroup" class="pr-4 text-black font-weight-bold">Select a camp year:</label> <select id="termGroup" name="termGroup" ng-model="vm.selectedTermGroupID" ng-change="vm.onTermGroupChanged()" class="form-control flex-grow-1" ng-options="termGroup.termGroupID as termGroup.year for termGroup in vm.termGroups" style=""></select></div></form><hr><ul class="list-unstyled letter-spacing-02"><li class="participant py-6" ng-repeat="userLicenseSet in vm.userLicenseInfoList" ng-class="{ \'bg-light\' : $index % 2 === 1}"><div class="container"><h3>{{ vm.getFullName(userLicenseSet.user) }}</h3><ul class="list-unstyled ml-6 letter-spacing-04"><li class="py-4 text-black letter-spacing-03" ng-repeat="license in userLicenseSet.licenseItems"><h4 style="font-size: 1.25rem;">{{ license.itemName }}</h4><div ng-if="license.identifier"><strong class="pr-2">Code:</strong>{{ license.identifier }}</div><div ng-if="license.username"><strong class="pr-2">Username:</strong>{{ license.username }}</div><div ng-if="license.password"><strong class="pr-2">Password:</strong>{{ license.password }}</div><div ng-if="license.expDate"><strong class="pr-2">ExpDate:</strong>{{ license.expDate | date:"MM/dd/yyyy" }}</div><div ng-if="license.noteHtml"><a class="btn btn-link py-0 pl-0" href="" ng-click="vm.showNotePopup(license)">note</a></div></li></ul></div></li><li ng-hide="vm.userLicenseInfoList.length"><div class="container">There are no take-homes for the selected camp year.</div></li></ul></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/historyInfo.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><div ng-show="vm.canSee"><div class="row"><div class="col-12"><h3>Camp Course History</h3><hr></div><div class="col-md-1" ng-if="false"><button value="Print" ng-click="vm.print()"></button></div></div><div><div class="id-panel-group" id="participantsAccordion"><div class="" ng-repeat="participant in vm.participantList track by participant.userID"><h3 class="text-nowrap mt-4">{{participant.firstName}} {{participant.lastName}}</h3><idp-history-sessions student="participant" session-list="participant.sessionList"></idp-history-sessions></div></div><h4 ng-show="vm.showNoHistoryMsg">There are no camp courses from prior seasons.</h4></div><iframe id="printFrame" name="printFrame" style="visibility: hidden; width:0px; height:0px;"></iframe></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/profile.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts><div ng-show="vm.canSee"><div class="row"><div class="col-md-6"><h3>Contact Information</h3><p>Update contact information including name, address and email</p><p><a class="btn btn-primary no-text-transform" href="#{{::$root.Routes.MyAccount_ContactInfo}}">Go Now</a></p></div><div class="col-md-6"><h3>User Account and Password</h3><p>Update your security information</p><p><a class="btn btn-primary no-text-transform" ng-disabled="!vm.canUpdate" ng-class="{disabled: !vm.canUpdate}" href="#{{::$root.Routes.MyAccount_SecurityInfo}}">Go Now</a></p></div><div class="col-md-6 mt-3"><h3>Required Forms</h3><p>Complete required forms to attend camp</p><p><a class="btn btn-primary no-text-transform" href="#{{::$root.Routes.MyAccount_RequiredForms}}">Go Now</a></p></div><div class="col-md-6 mt-3"><h3>Student Information</h3><p>Update student information including Preferred name, T-Shirt size and Date of Birth</p><p><a class="btn btn-primary no-text-transform" href="#{{::$root.Routes.MyAccount_StudentInfo}}">Go Now</a></p></div><div class="col-md-6 mt-3" ng-show="vm.isImpersonating"><h3>Shopping Cart</h3><p>Customer\'s Shopping Cart</p><p><a class="btn btn-primary no-text-transform" href="#{{::$root.Routes.MyAccount_ShoppingCart}}">Go Now</a></p></div><div class="col-md-6 mt-3" ng-show="vm.hasStudentLicense"><h3>Course Take-Homes</h3><p>View redemption information at the end of camp</p><p><a class="btn btn-primary no-text-transform" href="#{{::$root.Routes.MyAccount_CourseTakeHomes}}">Go Now</a></p></div><div class="col-md-6 mt-3" ng-show="vm.hasRelatedUsers"><h3>Camp Course History</h3><p>View camp courses from a previous season</p><p><a class="btn btn-primary no-text-transform" href="#{{::$root.Routes.MyAccount_HistoryInfo}}">Go Now</a></p></div></div><hr></div><idp-footer show-simple="true"></idp-footer></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/securityInfo.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts><div class="row my-3"><div class="col-12"><h3>Security Information</h3><p>Update your security information.</p><hr></div></div><div class="row"><div class="col-12"><h3>Login Details</h3><div><strong>Login Email Address: </strong><span>{{vm.user.userName}}</span></div><div style="margin-top: 5px">Use your primary email address to log in.</div></div></div><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="row my-3"><div class="col-12"><h3>Password</h3><idp-password user="vm.user" new-password="vm.newPassword" new-password-confirm="vm.newPasswordConfirm" first-tab-index="10"></idp-password></div></div><hr><div class="row justify-content-between"><div class="col-md-2"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.cancel()">Cancel</button></div><div class="col-md-4 mt-md-0 mt-3"><button type="submit" class="btn btn-primary btn-block">Save Changes</button></div></div></form><div class="row mt-3"><div class="col-md-12"><p>{{::vm.pulseContext.company.companyName}} does not sell or share personal information about you with other parties. <a href="" class="btn-link" ng-click="vm.showPrivacyPolicy()">Privacy Policy</a></p></div></div></div><idp-privacy-policy-popup popup-id="idpPrivacyPolicyPopup_SecurityInfo"></idp-privacy-policy-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/shoppingCart.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts></div><div class="spa-shopping-cart"><div class="container"><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err><h3 class="text-strong">Shopping Cart</h3><div data-ng-cloak ng-show="vm.canSee && vm.isCartRetrieved"><div class="well well-lg" ng-show="vm.isCartEmpty"><p>Your shopping cart is empty</p><button ng-if="!vm.pulseContext.isRunningInPartnerDomain" class="btn btn-primary" type="button" ng-click="vm.addCourseWhenNoneInCart()">Add Course</button></div><idp-cart reminders="true" cart="vm.cart" ng-hide="vm.isCartEmpty" mode="vm.ShoppingCartUIMode.MODE_MY_ACCOUNT" api="vm.cartCtrlAPI"></idp-cart></div><div data-ng-cloak ng-show="vm.canSee == false"><span class="text-danger">You do not have permission for this view.</span></div></form></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/studentInfo.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><div ng-show="vm.canSee"><div class="row"><div class="col-xs-12"><h3>Student Information</h3><hr></div></div><div class="my-3"><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err><div class="id-panel-group" id="participantsAccordion"><div class="card id-collapsible-card mt-3" ng-repeat="participant in vm.participantList track by participant.userID"><div class="card-heading" id="heading{{::participant.userID}}" ng-click="vm.onExpandToggle(participant)" ng-class="{\'collapsed\': !participant.isExpanded}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{\'d-none\': participant.isExpanded}"></span> <span class="icon icon-minus-1" ng-class="{\'d-none\': !participant.isExpanded}"></span></div><div class="content"><h4 class="text-nowrap mb-0">{{participant.firstName}} {{participant.lastName}}</h4></div></div></div><div id="collapse{{::participant.userID}}" class="panel-collapse padded-content" uib-collapse="!participant.isExpanded"><div class="card-body"><idp-si-student participant="participant" on-form-save-success="vm.onSubFormsSaveSuccess()"></idp-si-student></div></div></div></div></form></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/refer-a-friend/rafLanding.html','<div class="my-account home"><div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-alerts alert-list="vm.alertList"></idp-alerts></div><div id="content" class="grid"><div class="container"><div class="row"><div class="col-md-6"><h3>Refer-a-Friend Status</h3><p>Check status of your referrals</p><a class="btn btn-primary no-text-transform" href="#/my-account/refer-a-friend/rafStatus">Go Now</a></div><div class="col-md-6"><h3>Refer-a-Friend</h3><p>Refer more friends. Save more!</p><a class="btn btn-primary no-text-transform" href="#/my-account/refer-a-friend/raf">Go Now</a></div></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/refer-a-friend/rafStatus.html','<div class="my-account home mb-9"><div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/refer-a-friend/referAFriend.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><div ng-if="vm.hasCode()"><div class="row"><div class="col-12"><h3>Refer a Friend</h3><p>There is truly no bigger compliment than when you share iD Tech with your friends and family. As a thank you, we offer customers a credit for each new student they refer to iD Tech.</p><p>Earn credit by sharing your Refer-a-Friend code with family, friends, or the parents of your child\'s soccer team\u2014the possibilities are endless. Each time someone new registers using your code, they\'ll save $25 and you\'ll get $25 credit. It\'s pretty much a win-win.</p></div></div><idp-raf-share raf-code="vm.getRAF_Code()"></idp-raf-share><idp-raf-status referrals="vm.referrals"></idp-raf-status></div><div ng-if="!vm.hasCode()"><div class="row"><div class="col-12"><h3>Refer a Friend</h3><p>Clients must be registered for the current camp session to refer a friend and receive credit</p><a ng-href="#{{$root.Routes.RegFlow_ChooseLocations}}">Find a course for your child &gt;&gt;</a></div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/refer-a-friend/referAFriendOld.html','<div class="my-account home mb-9"><div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/registration/changeOrder.html','<div class="my-account home mb-9"><div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/registration/register.html','<div class="my-account" style="margin: 0px 0.5em 0px 0.5em;"><idp-iframe frame-id="pulse1xFrame" src="vm.iFrameSrc" on-frame-load="vm.iFrameOnLoad(frameId, url)"></idp-iframe></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/directives/reg-flow/walkthrough-filter/decomissioned/idp-walkthrough-nav.html','<div class="step" ng-repeat="step in vm.steps track by $index" ng-class="{\'current-step\': vm.isCurrentStep(step.orderNumber), \'step-completed\': vm.stepIsComplete(step), \'step-skipped\': vm.stepIsSkipped(step)}" ng-style="{width: ($index > 0 ? vm.lineWidth + \'%\': \'0\'), \'z-index\': (500 - $index) }"><div class="line"></div><div class="step-details" ng-click="vm.goToStep(step)"><div class="disk-index"><span class="step-num">{{ ::($index + 1) }}</span> <span class="spa-icon-checkmark"></span></div><p class="step-name">{{ ::step.displayName}}</p></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/idp-avc-course-alternative-locations.html','<div class="course-alternative-locations"><h4 class="component-title mb-2">Let us make a suggestion:</h4><div ng-repeat="location in $ctrl.alternatives" class="alternative-location mb-3"><a class="location-url" ng-click="$ctrl.navigateToAvChart(location.locationID)" href="">{{ location.name }}</a><div class="distance lineh-none"><span ng-show="location.distance">{{ location.distance | number:0 }}</span> <span ng-hide="location.distance">&lt; 1</span> mi away</div></div><p ng-hide="$ctrl.hasNearLocations">Please consider an alternate date or a different course.</p></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/idp-avc-drawer-alerts.html','<div class="row"><div class="col-xs-12"><div class="alert {{ $ctrl.getAlertTypeCSS(a) }}" ng-repeat="a in $ctrl.filteredAlerts "><strong>{{a.title}}</strong><p>{{a.text}}</p></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/idp-avc-product-description-header.html','<div class="mb-2"><div class="status-row d-flex flex-column flex-lg-row"><div class="d-md-block mb-4 col-lg-6 pl-0 pr-0 pr-lg-3" ng-if="$ctrl.courseImgUrl"><img class="w-100" ng-src="{{ $ctrl.courseImgUrl }}"></div><div class="col flex-column pr-md-0 pl-0 pr-0"><div class="d-flex justify-content-between flex-column"><div class="product-tagline" ng-if="$ctrl.isTutoring()">1-on-1 Private Tutoring</div><div class="product-tagline" ng-if="$ctrl.isVirtual()">Online &bull; <span class="text-nowrap" ng-bind-html="$ctrl.product.sessionStart | formatSessionDates:$ctrl.product.sessionEnd :1:1"></span></div><div class="product-subscription" ng-if="$ctrl.isTutoring()"><span ng-if="$ctrl.isSubscription">Monthly Subscription</span> <span ng-if="!$ctrl.isSubscription">Lesson Package</span></div><div ng-if="$ctrl.withHeadline"><ul class="division-properties list-inline bullet-between mb-0"><li class="list-inline-item">{{ $ctrl.product.headline }}</li><li class="list-inline-item"><span ng-bind-html="$ctrl.product.sessionStart | formatSessionDates:$ctrl.product.sessionEnd :1:1"></span></li></ul></div><div class="product-price my-2"><idp-avc-price-slash class="text-em-0-5 text-black" location-price="$ctrl.product.locationPrice" currency-type-id="$ctrl.product.currencyTypeID" text-wrap="true" session="$ctrl.session" show-from-text="false"><span class="price-description text-muted text-capitalize" ng-show="$ctrl.product.courseCatalogTypeID == $root.Enums.SalesCatalogType.SquadsMultiWeek">/10 weekly lessons </span><span class="price-description text-black" ng-show="$ctrl.isTutoring()"><span><span ng-bind-html="\' for \'"></span>{{$ctrl.product.quantity}}</span><ng-pluralize count="$ctrl.product.quantity" when="{\'one\': \' Lesson\', \'other\': \' Lessons\'}"></span><ng-pluralize ng-hide="$ctrl.product.courseCatalogTypeID == $root.Enums.SalesCatalogType.SquadsMultiWeek || $ctrl.product.courseCatalogTypeID == $root.Enums.SalesCatalogType.CourseBundle" class="price-description text-muted text-capitalize text-nowrap" count="$ctrl.product.daysPerSession | daysToWeeks" when="{\n                    \'1\': \'/ 1 Week\',\n                    \'other\': \'/ {{$ctrl.product.daysPerSession | daysToWeeks}} Weeks\'\n                  }"></ng-pluralize></idp-avc-price-slash><div class="pt-2" ng-if="$ctrl.hasValidPaymentOption">or <strong>{{ $ctrl.sessionPaymentValue | currency:$ctrl.sessionPaymentCurrencyTypeID:0 }} now + payments</strong></div></div></div><div class="section-headline-date flex-grow-0 flex-shrink-1 my-2" ng-hide="$ctrl.isTutoring() || $ctrl.isVirtual() || $ctrl.withHeadline"><h4 class="product-date hidden-xs" ng-bind-html="$ctrl.product.sessionStart | formatSessionDates:$ctrl.product.sessionEnd :1:1"></h4></div><div class="product-schedule-description" ng-hide="$ctrl.isTutoring() || $ctrl.isVirtual()" ng-if="!$ctrl.isWaitlist() && $ctrl.withDesc" ng-bind-html="$ctrl.product.scheduleDescriptor | unsafe"></div><div class="text-warning font-weight-bold" ng-show="$ctrl.product.alertNote">Note: {{$ctrl.product.alertNote}}</div></div></div></div><div class="product-detail mt-2" ng-if="$ctrl.isShowDetailInfo"><div ng-bind-html="($ctrl.partialDetails && !$ctrl.isDetailExpanded) ? $ctrl.partialDetails : $ctrl.completeDetails | unsafe"></div><div ng-show="$ctrl.partialDetails !== null" class="text-center"><button type="button" class="btn btn-link btn-sm mx-auto py-0 my-0 font-weight-bold" ng-click=" $ctrl.triggerDetailInfo()">{{ $ctrl.isDetailExpanded ? "Read less" : "Read more" }}</button></div><div ng-hide="$ctrl.common.isMobileView" ng-bind-html="$ctrl.criticalDetails | unsafe"></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/idp-avc-product-description.html','<div class="mb-2"><div class="status-row d-flex flex-column flex-lg-row"><div class="d-md-block mb-4 col-lg-6 pl-0 pr-0 pr-lg-3" ng-if="$ctrl.courseImgUrl"><img class="w-100" ng-src="{{ $ctrl.courseImgUrl }}"></div><div class="col flex-column pr-md-0 pl-0 pr-0"><div class="d-flex justify-content-between flex-column"><div><h5 class="rounded d-inline text-white pt-1 pr-2 pb-1 pl-2 font-weight-normal" ng-class="{\n          \'product-headline-virtual\': ($ctrl.isVirtual() || $ctrl.isCourseBundle()) && !$ctrl.isWaitlist(),\n          \'product-headline-tutoring\': $ctrl.isTutoring() && !$ctrl.isWaitlist(),\n          \'product-headline-day\': !$ctrl.product.isONPackage && !$ctrl.isWaitlist() && !$ctrl.isVirtual() && !$ctrl.isCourseBundle(),\n          \'product-headline-night\': $ctrl.product.isONPackage && !$ctrl.isWaitlist() && !$ctrl.isVirtual() && !$ctrl.isCourseBundle(),\n          \'badge-danger\': $ctrl.isWaitlist()\n        }"><span>{{ $ctrl.isWaitlist()? \'Sold Out\' : $ctrl.product.headline }}</span> <span class="icon" aria-hidden="true" ng-hide="$ctrl.isWaitlist() || $ctrl.isVirtual() || $ctrl.isTutoring() || $ctrl.isCourseBundle()" ng-class="{\n                            \'icon-day\': !$ctrl.product.isONPackage,\n                            \'icon-night\': $ctrl.product.isONPackage\n                            }"></span></h5></div><div class="product-price my-2"><idp-avc-price-slash class="text-em-1-5 text-black" location-price="$ctrl.product.locationPrice" currency-type-id="$ctrl.product.currencyTypeID" session="$ctrl.session" show-from-text="false"><span class="price-description text-muted text-capitalize" ng-show="$ctrl.product.courseCatalogTypeID == $root.Enums.SalesCatalogType.SquadsMultiWeek">/10 weekly lessons </span><span class="price-description text-black" ng-show="$ctrl.isTutoring()">/{{$ctrl.product.quantity}} Online Private Lesson{{$ctrl.product.quantity > 1 ? \'s\':\'\'}}{{$ctrl.isSubscription ? \',\':\'\'}}<div class="mt-2" ng-show="$ctrl.isSubscription">monthly subscription</div></span><ng-pluralize ng-hide="$ctrl.product.courseCatalogTypeID == $root.Enums.SalesCatalogType.SquadsMultiWeek || $ctrl.product.courseCatalogTypeID == $root.Enums.SalesCatalogType.CourseBundle" class="price-description text-muted text-capitalize" count="$ctrl.product.daysPerSession | daysToWeeks" when="{\n                    \'1\': \'/ 1 Week\',\n                    \'other\': \'/ {{$ctrl.product.daysPerSession | daysToWeeks}} Weeks\'\n                  }"></ng-pluralize></idp-avc-price-slash><div class="pt-2" ng-if="$ctrl.hasValidPaymentOption">or <strong>{{ $ctrl.sessionPaymentValue | currency:$ctrl.sessionPaymentCurrencyTypeID:0 }} now + payments</strong></div></div></div><div class="section-headline-date flex-grow-0 flex-shrink-1 my-2" ng-hide="$ctrl.isTutoring()"><h4 class="product-date hidden-xs" ng-bind-html="$ctrl.product.sessionStart | formatSessionDates:$ctrl.product.sessionEnd :1:1"></h4></div><div class="product-schedule-description" ng-hide="$ctrl.isTutoring()" ng-if="!$ctrl.isWaitlist()" ng-bind-html="$ctrl.product.scheduleDescriptor | unsafe"></div><div class="text-warning font-weight-bold" ng-show="$ctrl.product.alertNote">Note: {{$ctrl.product.alertNote}}</div></div></div></div><div class="product-detail mt-2" ng-if="$ctrl.isShowDetailInfo"><div ng-bind-html="($ctrl.partialDetails && !$ctrl.isDetailExpanded) ? $ctrl.partialDetails : $ctrl.completeDetails | unsafe"></div><div ng-show="$ctrl.partialDetails !== null" class="text-center"><button type="button" class="btn btn-link btn-sm mx-auto py-0 my-0 font-weight-bold" ng-click=" $ctrl.triggerDetailInfo()">{{ $ctrl.isDetailExpanded ? "Read less" : "Read more" }}</button></div><div ng-hide="$ctrl.common.isMobileView" ng-bind-html="$ctrl.criticalDetails | unsafe"></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/idp-avc-session-drawer.html','<div class="in-drawer-container pt-5 pb-4 pb-md-7" ng-cloak><header class="media mt-2 mb-4"><span class="font-weight-bold" ng-class="{\'label-new\': $ctrl.isNew() , \'label-updated\': !$ctrl.isNew()}">{{::$ctrl.isNew() ? \'NEW\' : \'UPDATED\'}}</span><h3 class="course-title media-body ml-2 d-none d-sm-block">{{ $ctrl.products.mainProduct.name }}</h3><h4 class="course-title media-body ml-2 d-sm-none">{{ $ctrl.products.mainProduct.name }}</h4><button class="close float-right hidden-xs" ng-click="$ctrl.closeDrawer()"><span aria-hidden="true">&times;</span></button></header><idp-avc-drawer-alerts ng-if="$ctrl.hasSelectedProduct" class="d-block" alerts="$ctrl.selectedProduct.alerts" bootstrap-alert-type="warning" filter-by-alert-types="$ctrl.alertTypes"></idp-avc-drawer-alerts><div class="product-multi-choice d-md-flex align-content-stretch" ng-if="$ctrl.showProductSelection()"><div class="product-description-selector d-flex flex-column flex-grow-1 flex-md-grow-0 flex-shrink-1 align-items-stretch justify-content-between mb-6 mb-md-0"><idp-avc-product-description class="flex-grow-1 flex-shrink-1 mb-3" product="$ctrl.products.mainProduct" main-product="$ctrl.products.mainProduct" session-payment-option="$ctrl.sessionPaymentOption"></idp-avc-product-description><div class="flex-grow-0 flex-shrink-1"><button class="btn btn-primary btn-block" ng-click="$ctrl.selectProduct($ctrl.products.mainProduct)">Add day Camp</button></div></div><div class="product-divider d-flex flex-column align-items-center flex-grow-1 flex-shrink-1"><div class="product-divider-line border flex-grow-1 flex-shrink-1"></div></div><div class="product-description-selector d-flex flex-column flex-grow-1 flex-md-grow-0 flex-shrink-1 align-items-stretch justify-content-between"><idp-avc-product-description class="flex-grow-1 flex-shrink-1 mb-3" product="$ctrl.products.optionProduct" main-product="$ctrl.products.mainProduct" session-payment-option="$ctrl.sessionPaymentOption"></idp-avc-product-description><div class="flex-grow-0 flex-shrink-1"><button class="btn btn-primary btn-block" ng-click="$ctrl.selectProduct($ctrl.products.optionProduct)">Add overnight Camp</button></div></div></div><div class="selected-product d-md-flex align-items-stretch flex-md-wrap" ng-if="$ctrl.hasSelectedProduct || $ctrl.hasWaitlistStatus"><div class="product-description flex-grow-1 flex-grow-0 order-1"><idp-avc-product-description course-img-url="{{ ::$ctrl.courseImgUrl }}" product="$ctrl.selectedProduct" main-product="$ctrl.products.mainProduct" is-show-detail-info="true" session-payment-option="$ctrl.sessionPaymentOption"></idp-avc-product-description></div><div class="login-alert alert alert-warning flex-grow-1 flex-shrink-1 order-0" ng-show="$ctrl.showLoginAlert"><button type="button" class="close" ng-click="$ctrl.closeLoginAlert()">&#xD7;</button><p class="text-center mb-0" ng-show="$ctrl.unknownUser"><span class="text-bold">You already have an account.</span><br><span>Please <a class="login-btn" href="" ng-click="$ctrl.showLogin()">login </a>for the best experience.</span></p><p class="text-center mb-0" ng-hide="$ctrl.unknownUser"><span class="text-bold">You are now logged in. </span>Select or enter a new student below.</p></div><div class="product-form bg-light flex-grow-0 flex-shrink-1 order-3 px-1 py-3 p-xs-3 p-md-5"><idp-avc-registration-form ng-if="!$ctrl.hasWaitlistStatus" form-disabled="$ctrl.registrationDisabled" main-product="$ctrl.products.mainProduct" selected-product="$ctrl.selectedProduct" drawer-style="$ctrl.drawerStyle" cross-sell-prods="$ctrl.crossSellProds"></idp-avc-registration-form><idp-avc-waitlist-form ng-if="$ctrl.hasWaitlistStatus" location="$ctrl.location" product="$ctrl.selectedProduct"></idp-avc-waitlist-form></div></div></div><idp-login-popup popup-id="authenticationModal" close-on-outside-click="false"></idp-login-popup>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/chart/idp-avc-course-cell.html','<div class="media align-content-stretch p-2 p-md-0"><div class="d-block pt-1"><div class="img-container d-block d-md-none d-lg-block" ng-click=" $ctrl.triggerCourseInfoPopup($ctrl.course, $ctrl.division)" idp-click-tracking data-id-action-text="Course Info" data-id-div-abbr="{{::$ctrl.getDivisionAbbr($ctrl.division.divID)}}" data-id-product-id="{{::$ctrl.course.prodID}}" data-id-location-id="{{::$ctrl.division.locID}}"><img class="course-thumbnail e-sm-width-10 e-width-9" ng-src="{{::$ctrl.courseImg(course)}}" ng-if="$ctrl.isImpersonating || $ctrl.config.isDebugMode"> <img class="lazyload course-thumbnail e-sm-width-10 e-width-9" ng-if="!$ctrl.isImpersonating && !$ctrl.config.isDebugMode" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" id-data-src="{{ ::$ctrl.courseImg(course) }}"></div></div><div class="media-body d-flex align-items-stretch"><div class="course-info pt-2 pr-1 pl-2"><h5 class="course-name mb-md-1">{{ ::$ctrl.course.name }}</h5><ul class="course-info list-inline bullet-between small mb-0"><li class="list-inline-item">Ages: {{ ::$ctrl.course.minAge }}-{{ ::$ctrl.course.maxAge }}</li><li class="list-inline-item">{{ ::$ctrl.course.skillLevels | avcSkillLevel}}</li><li class="list-inline-item d-md-none"><ng-pluralize count="$ctrl.division.daysPerSession | daysToWeeks" when="{ \'1\': $ctrl.division.divDeliveryModelTypeID == 4004 ? \'10 Weekly Lessons\' : \'1 Week\',\n                        \'other\': $ctrl.division.divDeliveryModelTypeID == 4004 ? \'10 Weekly Lessons\' : \'{{ ::$ctrl.division.daysPerSession | daysToWeeks}} Weeks\'}"></ng-pluralize></li></ul><div class="course-starting-price d-block d-md-none media-body pt-2"><div class="small">from <span class="lineh-none font-weight-bold">{{ ::$ctrl.course.startingAt | currency:$ctrl.course.currencyTypeID:0 }}</span></div><div class="small" ng-if="$ctrl.hasValidPaymentPlan">(Payment plans available)</div></div><button type="button" class="btn btn-outline-secondary btn-sm pl-1 pr-1 p-0 d-none d-md-block mb-md-1" ng-click=" $ctrl.triggerCourseInfoPopup($ctrl.course, $ctrl.division)" idp-click-tracking data-id-action-text="Course Info" data-id-div-abbr="{{::$ctrl.getDivisionAbbr($ctrl.division.divID)}}" data-id-product-id="{{::$ctrl.course.prodID}}" data-id-location-id="{{::$ctrl.division.locID}}">Course info</button></div><div class="genres d-none d-xl-flex border-left flex-column justify-content-center align-items-center"><span class="d-block small text-black font-weight-bold" ng-repeat="genre in $ctrl.course.genres">{{ genre.name}}</span></div></div></div><div class="mobile-view-buttons d-flex d-md-none justify-content-between pt-2 pr-3 pb-4 pl-3"><button class="btn btn-outline-secondary col-7 text-center px-0" ng-click="$ctrl.toggleMobileSessionVisibility()"><span class="sessions-are-hidden" ng-hide="$ctrl.areSessionsMobileVisible()">View </span><span class="sessions-are-visible" ng-show="$ctrl.areSessionsMobileVisible()">Close </span><span class="d-none d-xs-inline">Dates</span></button> <button class="btn btn-link col-5 text-center px-0" ng-click="$ctrl.triggerCourseInfoPopup($ctrl.course, $ctrl.division)" idp-click-tracking data-id-action-text="Course Info" data-id-div-abbr="{{::$ctrl.getDivisionAbbr($ctrl.division.divID)}}" data-id-product-id="{{::$ctrl.course.prodID}}" data-id-location-id="{{::$ctrl.division.locID}}"><span class="d-none d-xs-inline">Course </span>Info</button></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/chart/idp-avc-division-info-block.html','<div class="d-flex flex-column flex-md-row align-content-md-stretch border rounded-top" ng-class="{\'rounded-bottom\': !$ctrl.accordionOpened()}"><div class="division media p-3 order-1 w-100 align-items-center" ng-class="{\'rounded-bottom\': !$ctrl.accordionOpened()}"><img class="division-logo d-none d-md-block e-width-9 flex-grow-0 flex-shrink-0" ng-src="{{ ::$ctrl.logoImageSrc }}" alt="{{ :: $ctrl.termDivisionName }}" title="{{ :: $ctrl.termDivisionName }}"><div class="media-body pl-md-3 flex-grow-1 flex-shrink-1"><div class="media pb-1 pb-md-0 w-100 flex-grow-1 flex-shrink-1 align-items-center"><img class="division-logo d-md-none e-width-6 flex-grow-0 flex-shrink-0" ng-src="{{ ::$ctrl.logoImageSrc }}" alt="{{ :: $ctrl.termDivisionName }}" title="{{ :: $ctrl.termDivisionName }}"><div class="media-body pl-3 pl-md-0"><h3 class="d-none d-md-block mb-0">{{ :: $ctrl.termDivisionName }}</h3><h5 class="d-md-none align-self-center mb-0">{{ :: $ctrl.termDivisionName }}</h5></div></div><ul class="division-properties list-inline bullet-between mb-0"><li class="list-inline-item">Ages: {{ :: $ctrl.termDivision.minAge }}-{{ :: $ctrl.termDivision.maxAge }}</li><li class="list-inline-item">{{ :: $ctrl.termDivision.skillLevels | avcSkillLevel}}</li><li class="list-inline-item"><ng-pluralize count="$ctrl.termDivision.daysPerSession | daysToWeeks" when="{ \'1\': $ctrl.termDivision.divDeliveryModelTypeID == 4004 ? \'10 Weekly Lessons\' : \'1 Week\',\n                        \'other\': $ctrl.termDivision.divDeliveryModelTypeID == 4004 ? \'10 Weekly Lessons\' : \'{{ :: $ctrl.termDivision.daysPerSession | daysToWeeks}} Weeks\'}"></ng-pluralize></li><li class="list-inline-item d-none d-sm-inline">From {{ :: $ctrl.termDivision.minCoursePrice | currency:$ctrl.termDivision.currencyTypeID:0}} <span ng-if="$ctrl.hasValidPaymentOptions">(Payment plans available)</span></li></ul><p class="experience-description text-muted m-0">{{ :: $ctrl.termDivision.termDescription ? $ctrl.termDivision.termDescription : \'&nbsp;\'}}</p></div></div><div class="accordion-status-highlighters d-block d-md-none p-1 border-top text-center order-2" ng-class="{ \'accordion-opened\': $ctrl.accordionOpened() }"><span class="pr-2" ng-hide="$ctrl.accordionOpened()">Courses from {{ :: $ctrl.termDivision.minCoursePrice| currency:$ctrl.termDivision.currencyTypeID:0 }} <span class="icon icon-chevron-down pl-2"></span> </span><span class="accordion-status-opened" ng-show="$ctrl.accordionOpened()">Close Courses <span class="icon icon-chevron-up pl-2"></span></span></div><div class="accordion-status-highlighters d-none d-md-flex justify-content-center align-items-center order-0 e-width-6 border-right" ng-class="{ \'accordion-opened\': $ctrl.accordionOpened() }"><span class="icon icon-plus-1 text-em-1-5" ng-hide="$ctrl.accordionOpened()"></span> <span class="icon icon-minus-1 text-em-1-5" ng-show="$ctrl.accordionOpened()"></span></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/chart/idp-avc-left-filters-panel.html','<aside class="left-filters-panel card box-shadow-none delimiter-shadow-md-right backdrop-shadow-xl"><div class="card-body card-body px-2 py-2"><button type="button" class="close" ng-click="$ctrl.closePanel()"><span aria-hidden="true">&times;</span></button><h3 class="card-title mt-6 mb-0">Filter courses</h3><div class="card-subtitle"><button type="button" class="btn btn-link pl-0 h-" ng-click="$ctrl.resetAllFilters()">Reset filters</button></div><h4 class="filter-name" ng-repeat-start="filter in $ctrl.filters track by $index">{{ ::filter.name }}</h4><div class="filter-options mb-4" ng-repeat-end=""><div class="form-check"><input id="{{ ::filter.id}}_all" class="form-check-input" name="{{ ::filter.id}}_all" ng-model="filter.allSelectedOption.state" ng-change="$ctrl.resetFilter(filter)" type="checkbox"> <label class="form-check-label" for="{{ ::filter.id}}_all">{{filter.allSelectedOption.displayedText}}</label></div><div class="form-check" ng-repeat="option in filter.options track by option.id"><input id="{{ ::filter.id}}_{{ ::option.id }}" class="form-check-input" name="{{ ::filter.id}}_{{ ::option.id }}" ng-model="option.state" ng-change="$ctrl.switchFilterOptionState(filter, option)" type="checkbox"> <label class="form-check-label" for="{{ ::filter.id}}_{{ ::option.id }}">{{ ::option.displayedText }}</label></div></div><button class="btn btn-primary d-block d-md-none m-auto w-75" ng-click="$ctrl.closePanel()" type="button">Apply filters</button></div></aside>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/chart/idp-avc-session-cell.html','<div class="cell-container" ng-class="{\n        \'highlight-on-hover\': $ctrl.highlightOnHover,\n        \'in-cart\': $ctrl.session.inCartCount || $ctrl.session.inWaitlist,\n        \'empty\': $ctrl.hasNAStatus,\n     }" ng-if="!$ctrl.hasNAStatus"><div class="session-term d-block d-md-none font-weight-bold px-1 text-nowrap" ng-bind-html="$ctrl.session.startDate | formatSessionDates:$ctrl.session.endDate:1:1"></div><div class="session-status d-flex"><div ng-if="!$ctrl.session.inCartCount && !($ctrl.session.inWaitlist && $ctrl.session.statusOptions.isWaitlist)" class="order-1 order-md-0 d-flex align-items-center justify-content-center letter-spacing-05 py-2 mr-3 mr-md-0"><span class="icon icon-day" ng-show="$ctrl.showDayIcon"></span> <span class="icon icon-night" ng-show="$ctrl.showNightIcon"></span></div><div class="availability-status badge badge-{{ ::$ctrl.session.statusOptions.htmlClass }} order-1 d-flex align-items-center justify-content-center" ng-if="!$ctrl.session.inCartCount && !$ctrl.session.inWaitlist"><span>{{ ::$ctrl.session.statusOptions.displayName | uppercase }}<span></span></span></div><div class="order-0 order-md-3 flex-grow-1 flex-shrink-1 align-items-center justify-content-center d-md-flex text-center" ng-if="!$ctrl.session.inCartCount && !$ctrl.session.inWaitlist"><idp-avc-price-slash class="session-price d-block" location-price="$ctrl.locationPrice" currency-type-id="-$ctrl.currencyTypeId" show-discount-on-mobile="true" session="$ctrl.session" ng-if="!$ctrl.session.inCartCount\n                  && !$ctrl.session.inWaitlist\n                  && !$ctrl.session.statusOptions.isWaitlist" show-from-text="true"></idp-avc-price-slash><div class="lineh-heading waitlist-text" ng-if="$ctrl.session.statusOptions.isWaitlist && !$ctrl.session.inWaitlist">Join<br>Waitlist</div></div><div ng-if="$ctrl.session.inCartCount" class="bought-message flex-grow-1 flex-shrink-1 d-flex flex-column order-1 mb-0"><div class="bought-count d-inline-block d-md-block">{{ $ctrl.session.inCartCount > 1 ? "(" + $ctrl.session.inCartCount + ")" : " "}}</div><div class="d-inline-block">Selected</div></div><div ng-if="$ctrl.session.inWaitlist && $ctrl.session.statusOptions.isWaitlist" class="bought-message flex-grow-1 flex-shrink-1 d-flex flex-column order-1 mb-0"><div>Added to<br>waitlist</div></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/header-panel/idp-avc-active-filters.html','<div class="media"><img class="filter-logo" ng-src="{{::$ctrl.logoPath}}" alt="Filter"><div class="pl-3 pl-md-4 media-body"><h4 class="d-none d-md-block mb-0 font-weight-bold">Filter course results</h4><p class="d-inline d-md-block mb-0 mr-3 mr-md-0"><ng-pluralize class="d-inline" ng-show="$ctrl.areFiltersSynced" count="$ctrl.countSelectedOptions" when="{   \'0\': \'No filters applied\',\n                                \'1\': \'1 filter applied\',\n                            \'other\': \'{} filters applied\'\n                      }"></ng-pluralize><span class="text-info" ng-hide="$ctrl.areFiltersSynced">Loading filters ...</span></p><button class="btn btn-link d-inline-block pl-0 pt-0 pb-0 pt-md-1 pb-md-1 align-baseline" type="button" ng-class="{\'editDisabled\': !$ctrl.isButtonEnabled}" ng-click="$ctrl.displayLeftFiltersPanel()">Filter <span class="d-none d-sm-inline">courses</span></button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/header-panel/idp-avc-current-location.html','<div class="media"><img class="filter-logo" ng-src="{{ ::$ctrl.logoPath}}" alt="Location filter image"><div class="media-body pl-3 pl-md-4 pt-2 pt-md-0"><h4 class="d-inline d-md-block pt-2 mb-0 mr-3 mr-md-0 pt-md-0 font-weight-bold">{{ ::$ctrl.selectedLocation.name}}</h4><p class="d-none d-md-block mb-0">{{ ::$ctrl.selectedLocation.addrArea }}</p><button type="button" class="btn btn-link d-inline-block pl-0 pt-0 pb-0 pt-md-1 pb-md-1 align-baseline" ng-hide="$ctrl.disableChangeLocation()" ng-click="$ctrl.goToChooseLocationsView()">Change location</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/camp-drawer/idp-pav-alert.html','<div class="alert alert-{{$ctrl.alertClass}}"><div class="alert-header d-flex"><div class="flex-grow-1 align-left"><strong>{{ $ctrl.alertTitle }}</strong></div></div><div class="align-left">{{ $ctrl.alertNote }}</div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/camp-drawer/idp-pav-experience.html','<div class="experience-button d-flex mb-3"><button type="button" class="btn btn-text cdr-session-button" ng-click="$ctrl.onSelectExperience($ctrl.products.mainProduct)" idp-click-tracking><div class="d-flex"><div class="text-bold"><span class="icon icon-day" aria-hidden="true"></span> {{ $ctrl.products.mainProduct.headline }}</div><div class="ml-auto"><idp-avc-price-slash class="text-em-1-0 text-black text-bold" location-price="$ctrl.products.mainProduct.price" currency-type-id="$ctrl.products.mainProduct.currencyTypeID" text-wrap="true" session="$ctrl.session" show-from-text="false"></idp-avc-price-slash></div></div><div class="d-flex"><div class="text-left" ng-bind-html="$ctrl.mainProduct.scheduleDescriptor"></div><div class="availability-status badge badge-primary btn-pill btn-pill-lg align-self-center ml-4">Select</div></div></button></div><div ng-if="$ctrl.products.optionProduct != null" class="experience-button mb-3"><button class="btn btn-text cdr-session-button" ng-click="$ctrl.onSelectExperience($ctrl.products.optionProduct)" idp-click-tracking><div class="d-flex"><div class="text-bold"><span class="icon icon-night" aria-hidden="true"></span> {{ $ctrl.products.optionProduct.headline }}</div><div class="ml-auto"><idp-avc-price-slash class="text-em-1-0 text-black text-bold" location-price="$ctrl.products.optionProduct.price" currency-type-id="$ctrl.products.optionProduct.currencyTypeID" text-wrap="true" session="$ctrl.session" show-from-text="false"></idp-avc-price-slash></div></div><div class="d-flex"><div class="text-left" ng-bind-html="$ctrl.products.optionProduct.scheduleDescriptor"></div><div class="availability-status badge badge-primary btn-pill btn-pill-lg align-self-center ml-4">Select</div></div></button></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/camp-drawer/idp-pav-register-form.html','<div class="login-popup"><idp-login-popup popup-id="authenticationModal" close-on-outside-click="false"></idp-login-popup></div><div class="register"><div ng-if="$ctrl.alertList.length > 0"><div class="alert-container" ng-repeat="alert in $ctrl.alertList"><idp-pav-alert alert-title="alert.title" alert-note="alert.note" alert-class="alert.cssClass"></idp-pav-alert></div></div><div class="login-alert alert alert-warning flex-grow-1 flex-shrink-1 order-0" ng-show="$ctrl.showLoginAlert"><button type="button" class="close" ng-click="$ctrl.closeLoginAlert()">&#xD7;</button><p class="text-center mb-0" ng-show="$ctrl.unknownUser"><span class="text-bold">You already have an account.</span><br><span>Please <a class="login-btn" href="" ng-click="$ctrl.showLogin()">login </a>for the best experience.</span></p><p class="text-center mb-0" ng-hide="$ctrl.unknownUser"><span class="text-bold">You are now logged in. </span>Select or enter a new student below.</p></div><header ng-class="{\'pb-2\': $ctrl.drawerStyle.is2022Design}"><div class="d-flex flex-row"><div class="product-image" ng-if="$ctrl.IsValidImageUrl($ctrl.drawerStyle.productImage)"><img src="{{$ctrl.drawerStyle.productImage}}" alt="" aria-hidden="true" class="product-thumbnail"></div><div class="product-info"><h2 class="d-none d-sm-block h4">{{ $ctrl.mainProduct.name }}</h2><h3 class="d-sm-none h5">{{ $ctrl.mainProduct.name }} {{ $ctrl.mainProduct.startDateTime }}</h3><div>{{ $ctrl.termDiv.locationName }}</div><div>{{ $ctrl.termDiv.addressArea }}</div><idp-avc-product-description-header class="flex-grow-1 flex-shrink-1 mb-4" product="$ctrl.selectedProduct" main-product="$ctrl.products.mainProduct" session-payment-option="$ctrl.sessionPaymentOption" with-headline="true" with-desc="false" is-subscription="false"></idp-avc-product-description-header></div></div></header><idp-avc-registration-form ng-if="!$ctrl.hasWaitlistStatus" form-disabled="$ctrl.registrationDisabled" main-product="$ctrl.products.mainProduct" selected-product="$ctrl.selectedProduct" drawer-style="$ctrl.drawerStyle" reset-step="false" cross-sell-prods="$ctrl.crossSellProds"></idp-avc-registration-form></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/prod-availability/components/camp-drawer/idp-pav-session-dates.html','<div ng-if="$ctrl.productFilterDates.length > 0"><div ng-repeat="pDate in $ctrl.productFilterDates"><hr><button type="button" class="d-flex justify-content-between btn btn-link btn-block cdr-session-button" ng-click="$ctrl.onSelectDate(pDate)" idp-click-tracking><div class="d-flex align-items-center"><div class="align-left text-black date-cell-normal"><div ng-bind-html="pDate.start | formatSessionFullMonth:pDate.end:1:1"></div><div class="text-nowrap text-left {{ $ctrl.sessionTextClass(pDate.sessionAvailabilityStatusTypeID) }}"><span class="fas fa-xs {{ $ctrl.sessionStatusIconClass(pDate.sessionAvailabilityStatusTypeID) }}" aria-hidden="true"></span> {{ pDate.sessionStatus }}</div></div></div><div class="availability-status badge {{ $ctrl.sessionBadgeClass(pDate.sessionAvailabilityStatusTypeID) }} btn-pill btn-pill-lg mt-2">{{ $ctrl.sessionStatusText(pDate.sessionStatus) }}</div></button></div><hr><div ng-if="$ctrl.showMoreProductDates"><button type="button" class="text-secondary text-center font-weight-bold c-pointer btn btn-link btn-block" ng-click="$ctrl.showMore()">Load more dates</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/clientFormsHome.html','<div class="container"><idp-top-nav item-selected="vm.topNavMenuSelected"></idp-top-nav></div><div class="container" ng-show="vm.canSee"><div class="row"><div class="col-12"><h3>Required Forms</h3></div><div class="col-12"><p>To save time, please be sure you have the following information handy before you begin:</p><ul class="mb-md-6"><li>Names, phone numbers, and email addresses for your emergency contacts and authorized pick up people</li><li>Health insurance information (company, policy number, etc.) for those attending iD Tech programs in the U.S. only</li><li>Medications your student will bring (name, dosage, frequency, etc.)</li><li>Last immunization full dates for Tetanus and Measles/Mumps/Rubella for those attending iD Tech programs in the U.S. only</li><li><idp-hsf-covid></idp-hsf-covid></li></ul><p><strong>Select a student below to see their forms, then click on the "View/Edit" or "Download" buttons to complete or update all required information.</strong></p></div></div><form id="{{::vm.formName}}" name="{{::vm.formName}}" role="form" novalidate idp-form-focus-on-err ng-submit="vm.submit()"><div class="row my-3"><div class="col-12"><div ng-show="!vm.anyStudents && vm.isActivated" class="text-warning">You have no associated students for whom you are the parent/guardian.</div><div ng-show="(!vm.studentListWithForms || vm.studentListWithForms.length == 0) && vm.isActivated" class="text-warning">No students currently have required forms.</div><idp-my-students-with-forms ng-show="vm.anyStudents" can-administer-forms="vm.canAdministerForms" can-update="vm.canUpdate" form-status-types="vm.formStatusTypes" form-status-dict="vm.formStatusDict" form-section-types="vm.formSectionTypes" form-section-dict="vm.formSectionDict" student-list="vm.studentListWithForms"></idp-my-students-with-forms></div></div><div class="row my-3"><div class="col-12" id="historyAccordion"><div class="card id-collapsible-card" ng-show="vm.anyAdditionalFormsToUpload"><div class="card-heading" id="arfUploaderHeading" ng-click="isARFCollapsed = !isARFCollapsed" ng-class="{\'collapsed\': !isARFCollapsed}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{\'d-none\': isARFCollapsed}"></span> <span class="icon icon-minus-1" ng-class="{\'d-none\': !isARFCollapsed}"></span></div><div class="content"><h4>Additional Required Forms Upload Tool</h4></div></div></div><div id="arfUploaderBody" class="card-collapse" uib-collapse="!isARFCollapsed"><div class="card-body" ng-show="!vm.atLeastOneFormToUpload"><p class="text-justify">No forms to upload at this time.</p></div><div class="card-body padded-content" ng-show="vm.atLeastOneFormToUpload"><p class="text-justify">You can use this uploader to submit your <strong>Required Forms</strong> and <strong>Additional Required Forms </strong>(if any). Please scan and upload your paperwork in PDF format. Please do not submit a picture of your document, as pictures may be difficult to read and process.</p><p>Email <a href="mailto:Info@iDTech.com">Info@iDTech.com</a> if you have any questions.</p><p><strong>Choose a form from the drop down list then choose a file to upload. File size limit is 4MB.</strong></p><div class="row my-3"><div class="col-12 col-md-6"><div class="form-group"><select id="arfUploader" class="form-control" ng-model="vm.selectedUFDIDForUpload" ng-options="item.userFormDetailID as item.description for item in vm.userFormDetailsToUpload"></select></div></div></div><div class="row"><div class="col-12 col-md-6"><input id="arfUploadFile" name="arfUploadFile" class="w-100" idp-input-files type="file" ng-model="vm.uploadFilePath" idp-files="vm.inputFiles" idp-has-file="vm.hasInputFile" idp-file-path="vm.inputFilePath" accept=".pdf,.jpg,.jpeg,.jpe,.png" value="Choose File..."></div></div><div class="col-12 col-md-3 pt-2 pt-md-1"><button id="btnUploadFile" type="button" class="btn btn-primary btn-block" ng-click="vm.uploadFile(vm.selectedUFDIDForUpload, vm.hasInputFile, vm.inputFilePath, vm.inputFiles)" ng-disabled="!(vm.selectedUFDIDForUpload != 0 && vm.hasInputFile)">Upload</button><div class="text-danger">{{vm.uploadErrorMsg}}</div></div></div></div></div></div><div class="col-12"><div class="card id-collapsible-card mt-5"><div class="card-heading" id="pastUploadsHeading" ng-click="isPastUploadsCollapsed = !isPastUploadsCollapsed" ng-class="{\'collapsed\': !isPastUploadsCollapsed}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{\'d-none\': isPastUploadsCollapsed}"></span> <span class="icon icon-minus-1" ng-class="{\'d-none\': !isPastUploadsCollapsed}"></span></div><div class="content"><h4 class="m-0">Past Uploads</h4></div></div></div><div id="pastUploadsBody" class="card-collapse padded-content" uib-collapse="!isPastUploadsCollapsed"><div class="card-body"><idp-my-students-past-form-uploads show="true" is-current="vm.isPastUploadsCurrent"></idp-my-students-past-form-uploads></div></div></div></div><div class="col-12"><div class="card id-collapsible-card mt-5"><div class="card-heading" id="requiredHistoryHeading" ng-click="isHistoryCollapsed = !isHistoryCollapsed" ng-class="{\'collapsed\': !isHistoryCollapsed}"><div class="card-title d-flex vertical-align mb-0"><div class="icon-container justify-content-center"><span class="icon icon-plus-1" ng-class="{\'d-none\': isHistoryCollapsed}"></span> <span class="icon icon-minus-1" ng-class="{\'d-none\': !isHistoryCollapsed}"></span></div><div class="content"><h4 class="m-0">Required Forms History</h4></div></div></div><div id="requiredHistoryBody" class="card-collapse padded-content" uib-collapse="!isHistoryCollapsed"><div class="card-body"><idp-my-students-with-forms-history show="true" form-status-types="vm.formStatusTypes" form-status-dict="vm.formStatusDict" form-section-types="vm.formSectionTypes" form-section-dict="vm.formSectionDict"></idp-my-students-with-forms-history></div></div></div></div></div></form><idp-footer show-simple="true"></idp-footer></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/forms/idp-avc-registration-form.html','<form name="{{$ctrl.formName}}" novalidate idp-form-focus-on-err><h3 ng-hide="{{$ctrl.drawerStyle.is2022Design}}"><span class="{{$ctrl.startedClass}}">Let\'s get started!</span></h3><idp-avc-contact-email class="d-block mt-3" ng-class="{\'mb-2\': $ctrl.drawerStyle.is2022Design, \'mb-3\': !$ctrl.drawerStyle.is2022Design}" email-address="$ctrl.formModel.emailAddress" edit-enabled="$ctrl.isEmailFieldsetEditable()" form-name="contactEmail" field-set-name="{{$ctrl.getParentsEmailLabel()}}" on-change="$ctrl.processEmailChange(emailAddress, isValid)" placeholder="Email address" drawer-style="$ctrl.drawerStyle" readonly="$ctrl.isUserLoggedIn()"></idp-avc-contact-email><idp-avc-participant-form class="d-block mb-3" edit-enabled="$ctrl.isParticipantInfoEditable()" form-name="participantFieldset" field-set-name="{{$ctrl.getStudentsLabel()}}" user-linked-participants="$ctrl.ubMgr.currentUBSession.relatedUB_DTOs" participant="$ctrl.formModel.participant" new-participant-template="$ctrl.newParticipantTemplate()" group-with-beginners="$ctrl.formModel.groupWithBeginners" product="$ctrl.selectedProduct" main-product="$ctrl.mainProduct" drawer-style="$ctrl.drawerStyle" participant-in-cart="$ctrl.isAlreadyInCart(participant)"></idp-avc-participant-form><idp-avc-product-options-form ng-if="!$ctrl.isTutoring" class="d-block mb-3" edit-enabled="$ctrl.areNonEmailFieldsetsEditable()" form-name="optionsFieldset" legend="Add-ons" participant="$ctrl.formModel.participant" product="$ctrl.selectedProduct" main-product="$ctrl.mainProduct" selected-options="$ctrl.formModel.options"></idp-avc-product-options-form><idp-product-addons-form ng-show="$ctrl.isTutoring" edit-enabled="$ctrl.areNonEmailFieldsetsEditable()" form-name="addonsFieldset" legend="Add-ons" participant="$ctrl.formModel.participant" product="$ctrl.selectedProduct" main-product="$ctrl.mainProduct" addon-products="$ctrl.addonProducts" drawer-style="$ctrl.drawerStyle" selected-options="$ctrl.formModel.options"></idp-product-addons-form><idp-avc-cross-sell-prod-form class="d-block mb-3" edit-enabled="$ctrl.areNonEmailFieldsetsEditable()" form-name="crossSellFieldset" legend="Other Products" participant="$ctrl.formModel.participant" cross-sell-prods="$ctrl.crossSellProds" main-product="$ctrl.mainProduct" drawer-style="$ctrl.drawerStyle" selected-products="$ctrl.formModel.selectedCrossSellProds"></idp-avc-cross-sell-prod-form><div class="text-badge-orange text-center font-weight-bold my-1" ng-if="$ctrl.isShowAvailStatus">{{$ctrl.getAvailStatus()}}</div><div class="w-100 text-center"><button type="submit" ng-class="{\'btn btn-block no-text-transform\': !$ctrl.drawerStyle.is2022Design,\n                        \'btn btn-pill no-text-transform\': $ctrl.drawerStyle.is2022Design}" class="{{$ctrl.buttonContinueClass}}" ng-click="$ctrl.submitForm()" idp-click-tracking data-id-div-abbr="{{::$ctrl.divisionAbbr}}" data-id-product-id="{{::$ctrl.mainProduct.productID}}" data-id-location-id="{{::$ctrl.mainProduct.locationID}}">{{$ctrl.drawerStyle.is2022Design ? \'Continue to checkout\' : \'Continue\'}}</button></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/forms/idp-avc-waitlist-form.html','<form name="$ctrl.waitlistForm" class="waitlist-form mb-5" ng-if="!$ctrl.displayConfirmation" ng-submit="false" novalidate idp-form-focus-on-err=""><h3><span>Add to waitlist!</span></h3><div class="pb-4">Receive an email when this date becomes available.</div><div class="container m-0 p-0"><div class="row"><div class="col-md-8"><idp-avc-contact-email email-address="$ctrl.formModel.emailAddress" readonly="$ctrl.isUserLoggedIn()" form-name="contactEmail" placeholder="Parent email address"></idp-avc-contact-email></div><div class="col-md-3"><button class="btn btn-primary btn-pill font-weight-bold" type="button" ng-click="$ctrl.submitForm()">Submit</button></div></div></div></form><div ng-if="$ctrl.displayConfirmation" class="waitlist-confirmation mb-5"><h3 class="form-title">Thank you!</h3><p class="confirmation-info">We\'ll send an email to <strong>{{ $ctrl.formModel.emailAddress }}</strong> if a space becomes available. First come, first served.</p><h4>You have been waitlisted for:</h4><div class="container pb-4"><div class="row"><div class="col-3" ng-if="$ctrl.isValidImage($ctrl.location.productImage)"><img src="{{ $ctrl.location.productImage }}" class="product-thumbnail" aria-hidden="true" alt="{{ $ctrl.product.name }}"></div><div class="col-9"><div class="waitlist-details"><div><strong class="text-black">{{ $ctrl.product.name }}</strong></div><div>{{ $ctrl.location.name }}</div><div>{{ $ctrl.location.addressArea }}</div><div><ul class="list-inline bullet-between mb-0"><li class="list-inline-item d-none d-sm-inline">{{ $ctrl.product.headline }}</li><li class="list-inline-item" ng-bind-html="$ctrl.product.sessionStart | formatSessionFullMonth:$ctrl.product.sessionEnd:1:1"></li></ul></div><div>{{ $ctrl.product.locationPrice | currency:$ctrl.product.currencyTypeId:0 }}<ng-pluralize ng-hide="$ctrl.product.courseCatalogTypeID == $root.Enums.SalesCatalogType.SquadsMultiWeek || $ctrl.product.courseCatalogTypeID == $root.Enums.SalesCatalogType.CourseBundle" class="price-description text-muted text-capitalize" count="$ctrl.product.daysPerSession | daysToWeeks" when="{\n                    \'1\': \'/ 1 Week\',\n                    \'other\': \'/ {{$ctrl.product.daysPerSession | daysToWeeks}} Weeks\'\n                  }"></ng-pluralize></div></div></div></div></div><idp-avc-course-alternative-locations class="border-top pt-5" same-session="false" spd-id="$ctrl.product.sessionProductDetailID" max-count="3" same-session="0"></idp-avc-course-alternative-locations></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/authPickupContacts.html','<div class="container mb-10" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate"><idp-hsf-auth-contacts on-form-save-success="vm.formSaveSuccess()" user-form-detail="vm.userFormDetail" auth-pickup-contacts="vm.authPickupContacts" first-tab-index="1000" on-back-click="vm.backClick()"></idp-hsf-auth-contacts></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/authorization.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate"><form id="HSFAuthPageForm" name="HSFAuthPageForm" role="form" ng-submit="vm.submit()" idp-form-focus-on-err novalidate><idp-hsf-authorization user-form-detail="vm.userFormDetail" show-submission-history="true"></idp-hsf-authorization><div class="row my-3"><div class="col-md-3 offset-md-6"><button type="button" class="btn btn-outline-secondary btn-block" ng-click="vm.backClick()">Back</button></div><div class="col-md-3 pt-3 pt-md-0"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.submitted || !vm.isHSFAuthorized}" data-ng-disabled="vm.submitted || !vm.isHSFAuthorized" data-ng-dblclick="false">Submit</button></div></div></form></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/checkInOut.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate"><idp-hsf-check-out on-form-save-success="vm.formSaveSuccess()" user-form-detail="vm.userFormDetail" reqd-form-content="vm.reqdFormContent" on-back-click="vm.backClick()"></idp-hsf-check-out></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/healthHistory.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate"><idp-hsf-health-history on-form-save-success="vm.formSaveSuccess()" user-form-detail="vm.userFormDetail" reqd-form-content="vm.reqdFormContent" user-form-allergies="vm.userFormAllergies" on-back-click="vm.backClick()"></idp-hsf-health-history></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/insurance.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate"><idp-hsf-insurance on-form-save-success="vm.formSaveSuccess()" user-form-detail="vm.userFormDetail" reqd-form-content="vm.reqdFormContent" user-form-insurance="vm.userFormInsurance" user-form-insurance-previous="vm.userFormInsurancePrevious" on-back-click="vm.backClick()"></idp-hsf-insurance></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/medications.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate" ng-if="vm.reqdFormContent"><idp-hsf-medications on-form-save-success="vm.formSaveSuccess()" user-form-detail="vm.userFormDetail" reqd-form-content="vm.reqdFormContent" on-back-click="vm.backClick()"></idp-hsf-medications></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/nextStudent.html','<div class="container" ng-show="vm.canSee"><fieldset ng-disabled="!vm.canUpdate"><idp-hsf-page-header participant="vm.nextStudent"></idp-hsf-page-header><form id="HSFNextStudentForm" name="HSFNextStudentForm" role="form" ng-submit="vm.submit()" idp-form-focus-on-err novalidate><h4>Before we take you to {{vm.nextStudent.firstName}}\'s Health &amp; Safety Form:</h4><p>Would you like to copy some information from {{vm.previousStudent.firstName}}\'s form to {{vm.nextStudent.firstName}}\'s form?</p><div class="row my-3"><div class="col-md-12">Primary Contact Information:</div></div><div class="row my-3"><div class="col-md-6"><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedPrimaryContactTypes" is-edit-mode="true" is-read-only="false" is-required="true" required-message="Please select Yes or No" vertical-layout="false" tooltip="Copy Primary Contact Information" max="1" ng-click="vm.copyPrimaryContactYesNoClick();"></div></div><div class="row my-3"><div class="col-md-12">Secondary Contact Information:</div></div><div class="row my-3"><div class="col-md-6"><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedSecondaryContactTypes" is-edit-mode="true" is-read-only="false" is-required="true" required-message="Please select Yes or No" vertical-layout="false" tooltip="Copy Secondary Contact Information" max="1" ng-click="vm.copySecondaryContactYesNoClick();"></div></div><div class="row my-3"><div class="col-md-12">Authorized Pick Up Contacts: (Only applies to pre-teens)</div></div><div class="row my-3"><div class="col-md-6"><idp-type-selector types="vm.yesNoTypes" selected-types="vm.selectedPickupContactTypes" is-edit-mode="true" is-read-only="false" is-required="true" required-message="Please select Yes or No" vertical-layout="false" tooltip="Copy Authorized Pick Up Contacts" max="1" ng-click="vm.copyPickupContactsYesNoClick();"></div></div><div class="row my-3"><div class="col-md-6 offset-md-6"><button class="btn btn-primary btn-block" type="submit" data-ng-class="{disabled: vm.isContinueDisable}" data-ng-disabled="vm.isContinueDisable" data-ng-dblclick="false">Save &amp; Continue to Form</button></div></div></form></fieldset></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/primaryEmergencyContact.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate"><idp-hsf-emergency-contacts on-form-save-success="vm.formSaveSuccess()" form-person-role="vm.formPersonRole" user-form-detail="vm.userFormDetail" emergency-contact="vm.emergencyContact" first-tab-index="1000" on-back-click="vm.backClick()"></idp-hsf-emergency-contacts></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/schooling.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate"><idp-hsf-schooling on-form-save-success="vm.formSaveSuccess()" user-form-detail="vm.userFormDetail" reqd-form-content="vm.reqdFormContent" on-back-click="vm.backClick()"></idp-hsf-schooling></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/secondaryEmergencyContact.html','<div class="container mb-10" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate"><idp-hsf-emergency-contacts on-form-save-success="vm.formSaveSuccess()" form-person-role="vm.formPersonRole" participant="vm.participant" user-form-detail="vm.userFormDetail" emergency-contact="vm.emergencyContact" first-tab-index="1000" on-back-click="vm.backClick()"></idp-hsf-emergency-contacts></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/specialNeedsImmunizations.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-12"><fieldset ng-disabled="!vm.canUpdate"><idp-hsf-special-needs-immunizations on-form-save-success="vm.formSaveSuccess()" user-form-detail="vm.userFormDetail" participant="vm.participant" reqd-form-content="vm.reqdFormContent" on-back-click="vm.backClick()"></idp-hsf-special-needs-immunizations></fieldset></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/thanks.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row"><div class="col-xs-12"><idp-hsf-thanks on-continue-click="vm.continueClick()" participant="vm.participant" user-form-detail="vm.userFormDetail" on-back-click="vm.backClick()"></idp-hsf-thanks></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/secure/my-account/profile/client-forms/hsf/welcome.html','<div class="container" ng-show="vm.canSee"><idp-hsf-page-header participant="vm.participant"></idp-hsf-page-header><div class="row my-3"><div class="col-xs-12"><h4>Welcome, {{vm.pulseContext.loggedInUser.firstName}}</h4><hr><p>Within this form you will be asked to provide information about: <strong>{{vm.participant.firstName}} <span ng-show="vm.participant.middleInit">{{vm.participant.middleInit}}</span> {{vm.participant.lastName}}</strong></p><p>You will be asked to supply information that will help us care for your student(s). The form will take about 10 minutes to complete. This form saves after each step.</p><p><strong>IMPORTANT:</strong> The Health & Safety Form will only accept responses written in English.</p><p>Within this form you will need to provide information about:</p><ul><li>Names, phone numbers, and email addresses for your emergency contacts and authorized pick up people</li><li>Health insurance information (company, policy number, etc.) for those attending iD Tech programs in the U.S. only</li><li>Medications your student will bring (name, dosage, frequency, etc.)</li><li>Last immunization full dates for Tetanus and Measles/Mumps/Rubella for those attending iD Tech programs in the U.S. only</li><li><idp-hsf-covid></idp-hsf-covid></li></ul><p><strong>Returning from last season?</strong> Most fields should be pre-filled for you. If not, please call us as you may have a duplicate account.</p><p>Questions? See our phone numbers and hours for worldwide program support <a href="https://www.idtech.com/contact" target="_blank">here</a>.</p></div></div><div class="row my-3"><div class="col-md-3 col-md-offset-9"><button type="button" class="btn btn-primary btn-block" ng-disabled="!vm.canSee" ng-click="vm.continue()">Continue</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/forms/fieldsets/idp-avc-contact-email.html','<ng-form name="{{$ctrl.formName}}" novalidate idp-form-focus-on-err><fieldset ng-disabled="!$ctrl.editEnabled"><legend ng-if="$ctrl.fieldSetName">{{ ::$ctrl.fieldSetName }}</legend><div class="id-required" ng-class="{\'form-group\': !$ctrl.drawerStyle.is2022Design}"><input name="emailAddress" type="email" class="form-control id-standard" ng-change="$ctrl.processChange()" ng-maxlength="200" ng-model="$ctrl.emailAddress" ng-required="true" placeholder="{{ ::$ctrl.placeholder }}" uib-tooltip="Your Email Address" tooltip-trigger="\'focus\'" ng-readonly="$ctrl.readonly()" idp-focus-on="$ctrl.focusOnEmail"><div ng-messages="$ctrl.form.emailAddress.$error" class="text-danger" ng-hide="$ctrl.form.emailAddress.$pristine && !$ctrl.form.$submitted"><div ng-message="required">Your email address is required</div><div ng-message="email">Invalid email address</div><div ng-message="maxlength">Your email address cannot exceed 200 characters</div></div></div></fieldset></ng-form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/forms/fieldsets/idp-avc-cross-sell-prod-form.html','<ng-form name="{{ $ctrl.formName }}" ng-if="$ctrl.isShow()" novalidate idp-form-focus-on-err=""><section ng-show="$ctrl.crossSellTutorProds && $ctrl.crossSellTutorProds.length && $ctrl.hasAtLeastOneProd($ctrl.crossSellTutorProds)" ng-class="{\'product-options\': $ctrl.drawerStyle.is2022Design}"><h3><span class="{{$ctrl.drawerStyle.headingExtras}}">Prepare with pre-camp learning!</span></h3><fieldset class="option-fieldset my-6" ng-repeat="prod in $ctrl.crossSellTutorProds"><div ng-if="::$ctrl.isShowProd(prod)" class="d-flex"><div class="d-flex flex-column w-100"><div class="form-check w-100"><input id="option-{{ prod.prodID }}-{{ $index }}" class="form-check-input" type="checkbox" ng-change="$ctrl.updateSelectedOptions(prod)" ng-model="prod.isSelected" ng-disabled="$ctrl.isOptionDisabled(p)"> <label class="form-check-label mb-0 d-flex" for="option-{{ prod.prodID }}-{{ $index }}"><div class="d-flex w-100" ng-class="{\'addonLabel\': $ctrl.drawerStyle.is2022Design}"><div><img ng-src="{{::$ctrl.getProdThumbUrl(prod)}}" ng-show="$ctrl.getProdThumbUrl(prod)" class="mr-3 productAddons" title="Addon Product Thumbnail" alt="Addon Product Thumbnail"><div class="text-em-1-5 d-sm-none">{{prod.locationPrice | currency:prod.currencyTypeID:0 }}</div></div><div class="w-75"><span class="font-weight-bold" ng-class="{\'text-black\': !$ctrl.drawerStyle.is2022Design, \'text-white\': $ctrl.drawerStyle.is2022Design}">{{ prod.name }}</span> <span ng-if="$ctrl.isTutoringProduct(prod)" ng-class="{\'text-black\': !$ctrl.drawerStyle.is2022Design, \'text-white\': $ctrl.drawerStyle.is2022Design}">for <span class="font-weight-bold">{{ $ctrl.mainProduct.name }}</span></span> <span ng-class="{\'text-black\': !$ctrl.drawerStyle.is2022Design, \'text-white\': $ctrl.drawerStyle.is2022Design}">{{::prod.shortDesc}}</span> <a class="btn btn-link display_popover d-inline icon icon-info ml-1 text-em-1-25 p-0 c-pointer" ng-class="{\'text-dark\': !$ctrl.drawerStyle.is2022Design, \'text-white\': $ctrl.drawerStyle.is2022Design}" href="" ng-click="$event.stopPropagation()" uib-popover-html="$ctrl.getHtmlPopover(prod)" popover-trigger="\'outsideClick\'"></a><div class="text-dark-green mt-2 font-italic" ng-bind-html="::prod.marketingText | unsafe"></div></div><div class="w-25 text-md-nowrap text-right"><span class="text-small slash" ng-show="prod.marketingPrice">{{::prod.marketingPrice}}</span> <span class="text-em-1-25" ng-class="{\'text-black\': !$ctrl.drawerStyle.is2022Design, \'text-white\': $ctrl.drawerStyle.is2022Design}">{{::prod.price | currency:prod.currencyTypeID:0}}</span></div></div></label></div></div></div></fieldset></section><section ng-show="$ctrl.crossSellOtherProds && $ctrl.crossSellOtherProds.length && $ctrl.hasAtLeastOneProd($ctrl.crossSellOtherProds)"><h3 ng-hide="$ctrl.participant.firstName"><span class="{{$ctrl.drawerStyle.headingExtras}}">Additional add-ons</span></h3><h3 ng-show="$ctrl.participant.firstName"><span class="{{$ctrl.drawerStyle.headingExtras}}">Additional add-ons for {{$ctrl.participant.firstName}}</span></h3><fieldset class="option-fieldset my-6" ng-repeat="prod in $ctrl.crossSellOtherProds"><div ng-if="::$ctrl.isShowProd(prod)" class="d-flex"><div class="d-flex flex-column w-100"><div class="form-check w-100"><input id="option-{{ prod.prodID }}-{{ $index }}" class="form-check-input" type="checkbox" ng-change="$ctrl.updateSelectedOptions(prod)" ng-model="prod.isSelected" ng-disabled="$ctrl.isOptionDisabled(p)"> <label class="form-check-label mb-0 d-flex" for="option-{{ prod.prodID }}-{{ $index }}"><div class="d-flex w-100"><div><img ng-src="{{::$ctrl.getProdThumbUrl(prod)}}" ng-show="$ctrl.getProdThumbUrl(prod)" class="mr-3" style="max-width: 4rem;" title="Addon Product Thumbnail" alt="Addon Product Thumbnail"><div class="text-em-1-5 d-sm-none">{{prod.locationPrice | currency:prod.currencyTypeID:0 }}</div></div><div class="w-75"><div class="text-black font-weight-bold">{{::prod.name}}</div><div class="text-black">{{::prod.shortDesc}} <a class="btn btn-link text-dark display_popover d-inline icon icon-info ml-1 text-em-1-25 p-0 c-pointer" href="" ng-click="$event.stopPropagation()" uib-popover-html="$ctrl.getHtmlPopover(prod)" popover-trigger="\'outsideClick\'"></a></div><div class="text-dark-green mt-2 font-italic" ng-bind-html="::prod.marketingText | unsafe"></div></div><div class="w-25 text-md-nowrap text-right"><span class="text-small slash" ng-show="prod.marketingPrice">{{::prod.marketingPrice}}</span> <span class="text-black text-em-1-25">{{::prod.price | currency:prod.currencyTypeID:0}}</span></div></div></label></div></div></div></fieldset></section></ng-form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/forms/fieldsets/idp-avc-participant-form.html','<ng-form name="{{::$ctrl.formName}}" novalidate idp-form-focus-on-err><fieldset class="" ng-disabled="!$ctrl.editEnabled()"><legend ng-id="$ctrl.fieldSetName">{{::$ctrl.fieldSetName}}</legend><div class="row select-student-dropdown"><div class="col-sm-12"><div class="form-group"><select ng-model="$ctrl.selectedParticipant" class="form-control id-standard" ng-options="$ctrl.getFullName(participant)\n                              disable when $ctrl.participantInCart({participant})\n                              for participant in $ctrl.userLinkedParticipants" ng-change="$ctrl.selectParticipant()" ng-disabled="!$ctrl.editEnabled()"><option value="">Select or enter new student</option></select></div></div></div><div class="row"><div class="{{$ctrl.nameColumnClass}} padding-right-4px-md margin-bottom-8px-sm"><div class="form-group id-required"><input name="firstName" class="form-control id-standard" ng-readonly="!$ctrl.canEditParticipant" ng-model="$ctrl.participant.firstName" placeholder="Student First name" ng-required="true" uib-tooltip="Student First name" tooltip-trigger="\'focus\'" ng-disabled="!$ctrl.editEnabled()"><div ng-messages="$ctrl.form.firstName.$error" class="text-danger"><div ng-message="required">Student first name is required</div></div></div></div><div class="{{$ctrl.nameColumnClass}} padding-left-4px-md"><div class="form-group id-required"><input name="lastName" class="form-control id-standard" ng-readonly="!$ctrl.canEditParticipant" ng-model="$ctrl.participant.lastName" placeholder="Student Last name" ng-required="true" uib-tooltip="Student Last name" tooltip-trigger="\'focus\'" ng-disabled="!$ctrl.editEnabled()"><div ng-messages="$ctrl.form.lastName.$error" class="text-danger"><div ng-message="required">Student last name is required</div></div></div></div></div></fieldset><fieldset class="mb-2" ng-disabled="!$ctrl.editEnabled()"><div class="w-100"><idp-gender gender-type-id="$ctrl.participant.genderTypeID" is-required="true" radio-format="true" on-change="$ctrl.onGenderChanged()" is-full-help="true" is-edit-mode="$ctrl.canEditParticipant && $ctrl.editEnabled()"></idp-gender></div></fieldset><fieldset class="" ng-disabled="!$ctrl.editEnabled()"><legend ng-id="$ctrl.legend">Student\'s date of birth</legend><div class="row"><div class="col-xs-12"><div uib-tooltip="Date of Birth" tooltip-trigger="\'focus\'"><div class="form-group id-required"><idp-date-picker date="$ctrl.participant.dateOfBirth" min-date="$ctrl.minDisplayDate" max-date="$ctrl.maxDisplayDate" valid-min-date="$ctrl.minValidBirthDate" valid-max-date="$ctrl.maxValidBirthDate" is-edit-mode="$ctrl.canEditParticipant" is-required="true" disable-date-range-validation="$ctrl.hasAgeAdminOverride" is-disabled="!$ctrl.editEnabled()"></idp-date-picker></div></div></div></div></fieldset><fieldset class="mt-2 mb-5" ng-disabled="!$ctrl.editEnabled()" ng-if="!$ctrl.isOPL()"><div class="d-flex"><div class="form-check"><input class="form-check-input" type="checkbox" name="groupWithBeginners" id="groupWithBeginners" ng-model="$ctrl.groupWithBeginners"> <label class="form-check-label mb-0" for="groupWithBeginners">Please try to group my student with beginners.</label></div><a class="btn btn-link text-dark display_popover d-inline icon icon-info ml-1 text-em-1-25 p-0" href="" ng-click="$event.stopPropagation()" popover-trigger="\'outsideClick\'" uib-popover="While we cannot guarantee this accommodation, we do our best to group beginners together for an optimal learning experience."></a></div></fieldset></ng-form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/forms/fieldsets/idp-avc-product-options-form.html','<ng-form name="{{ $ctrl.formName }}" novalidate idp-form-focus-on-err=""><fieldset class="option-fieldset mb-3" ng-repeat="group in $ctrl.groupedProdOptions"><legend ng-if="group.optionGroup.typeString">{{ group.optionGroup.typeString }}</legend><div class="option d-flex flex-row mb-2" ng-repeat="option in group.options"><div class="form-check flex-grow-0 flex-shrink-0"><input id="option-{{ group.optionGroup.typeID }}-{{ $index }}" class="form-check-input" type="checkbox" ng-change="$ctrl.updateSelectedOptions()" ng-model="option.state" ng-disabled="$ctrl.isOptionDisabled(option)" ng-readonly="$ctrl.isOptionDisabled(option)"> <label class="form-check-label" for="option-{{ group.optionGroup.typeID }}-{{ $index }}"></label></div><div class="d-flex flex-column flex-grow-1 flex-shrink-1 flex-basis-0"><div class="d-flex flex-row flex-grow-1 flex-shrink-0"><div class="option-name flex-grow-1 flex-shrink-1" ng-class="$ctrl.isOptionDisabled(option)? \'disabled\':\'\'"><label class="d-inline" for="option-{{ group.optionGroup.typeID }}-{{ $index }}">{{ $ctrl.getOptionName(option.props) }}</label> <a href="" id="option-popup-{{ group.optionGroup.typeID }}-{{ $index }}" class="btn btn-link text-dark display_popover d-inline icon icon-info ml-1 text-em-1-25 p-0" ng-click="$ctrl.toggleOptionInfoPopup(option, \'option-popup-\' + group.optionGroup.typeID + \'-\' + $index)"></a></div><label class="option-price flex-grow-1 flex-shrink-0 e-width-8 text-right" ng-class="$ctrl.isOptionDisabled(option)? \'disabled\':\'\'" for="option-{{ group.optionGroup.typeID }}-{{ $index }}">{{ option.props.price | currency:$ctrl.getCurrencyType(option.props):0 }}</label></div><div class="option-unavailable flex-grow-1 flex-shrink-0" ng-show="option.disabledCauses.length"><div class="cause lineh-header small text-danger" ng-show="$ctrl.hasDisabledCause( option, $ctrl.OptionDisabledCauses.MealAddDateClosed)"><span class="text-highlight">Currently Unavailable.</span> <strong><a href="" ng-click="$ctrl.showOptionUnavailableDetailPopup(option, $ctrl.OptionDisabledCauses.MealAddDateClosed)">Details</a></strong></div><div class="cause lineh-header small text-danger" ng-show="option.props && option.props.productCategoryTypeID != $root.Enums.ProductCategoryType.CEU && $ctrl.hasDisabledCause( option, $ctrl.OptionDisabledCauses.AgeRequirementNotMeet)"><span class="text-highlight">Age requirements not met.</span></div></div></div></div></fieldset></ng-form><script type="text/ng-template" id="addon-popover-template.html"><div>\n    <p ng-bind-html="option.props.description | unsafe "></p>\n  </div></script>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/pulsepublic/registry-flow/av-chart/components/drawer/forms/fieldsets/idp-product-addons-form.html','<ng-form name="{{ $ctrl.formName }}" novalidate idp-form-focus-on-err=""><section><h3 ng-show="$ctrl.requiredAddonProducts && $ctrl.requiredAddonProducts.length"><span class="{{$ctrl.drawerStyle.headingExtras}}"><span class="font-weight-bold">Premium home delivery kit</span> <span class="font-weight-normal">(one-time fee)</span></span></h3><fieldset class="option-fieldset my-6" ng-repeat="prod in $ctrl.requiredAddonProducts"><div class="card shadow border-0 p-5"><div class="flex-grow-0 flex-shrink-0"><div class="d-flex flex-column flex-sm-row"><div class="d-flex align-items-xs-center align-items-sm-start justify-content-between"><img ng-src="{{::$ctrl.getProdThumbUrl(prod)}}" ng-show="$ctrl.getProdThumbUrl(prod)" class="mr-3" style="max-width: 4rem;" title="Addon Product Thumbnail" alt="Addon Product Thumbnail"><div class="text-black text-em-1-5 d-sm-none">{{prod.locationPrice | currency:prod.currencyTypeID:0 }}</div></div><div class="flex-grow-1"><div class="text-black"><div class="d-flex align-items-center justify-content-between"><div class="font-weight-bold">{{prod.name}}</div><div class="text-em-1-5 d-none d-sm-block">{{prod.locationPrice | currency:prod.currencyTypeID:0 }}</div></div><div class="text-small mt-3" ng-bind-html="::prod.description | unsafe"></div></div></div></div></div></div></fieldset></section><section><div ng-class="{\'p-3 my-4 product-addons product-card\': $ctrl.drawerStyle.is2022Design}" ng-if="$ctrl.standardAddonProducts && $ctrl.standardAddonProducts.length"><h3 ng-show="$ctrl.standardAddonProducts && $ctrl.standardAddonProducts.length"><span class="{{$ctrl.drawerStyle.headingAddons}}">Complement this course with these Add-ons</span></h3><fieldset class="option-fieldset" ng-class="{\'my-1\': $ctrl.drawerStyle.is2022Design, \'my-6\': !$ctrl.drawerStyle.is2022Design}" ng-repeat="prod in $ctrl.standardAddonProducts"><div ng-class="{\'card shadow p-5\': !$ctrl.drawerStyle.is2022Design, \'px-5\': $ctrl.drawerStyle.is2022Design}" class="border-0"><div class="form-check flex-grow-0 flex-shrink-0"><input id="option-{{ prod.productID }}-{{ $index }}" class="form-check-input" type="checkbox" ng-change="$ctrl.updateSelectedOptions()" ng-model="prod.isSelected" ng-disabled="$ctrl.isOptionDisabled(p)"> <label class="form-check-label" for="option-{{ prod.productID }}-{{ $index }}"><div class="d-flex flex-column flex-sm-row"><div class="d-flex align-items-xs-center align-items-sm-start justify-content-between"><img ng-src="{{::$ctrl.getProdThumbUrl(prod)}}" ng-show="$ctrl.getProdThumbUrl(prod)" class="mr-3" style="max-width: 4rem;" title="Addon Product Thumbnail" alt="Addon Product Thumbnail"><div class="text-black text-em-1-5 d-sm-none">{{prod.locationPrice | currency:prod.currencyTypeID:0 }}</div></div><div class="flex-grow-1"><div class="text-black"><div class="d-flex align-items-center justify-content-between"><div class="font-weight-bold">{{prod.name}}</div><div class="text-em-1-5 d-none d-sm-block">{{prod.locationPrice | currency:prod.currencyTypeID:0 }}</div></div><div class="text-small mt-3" ng-bind-html="::prod.description | unsafe"></div></div></div></div><div class="text-dark-green mt-2 font-italic" ng-bind-html="::prod.marketingText | unsafe"></div></label></div></div></fieldset></div></section></ng-form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/idp-boolean-selector.html','<div data-ng-form="{{::vm.formName}}"><div class="btn-group" role="group" ng-class="vm.verticalLayout ? \'btn-group-vertical\' : \'btn-group-toolbar\'" uib-tooltip="{{vm.tooltip}}"><button type="button" class="btn btn-light" ng-disabled="vm.isReadOnly" ng-class="(vm.selectedBoolean === true) ? \'btn-primary\' : \'btn-light\'" ng-click="vm.setSelectedBoolean(true)"><span class="text-capitalize">{{vm.yesButtonText}}</span></button> <button type="button" class="btn btn-light" ng-disabled="vm.isReadOnly" ng-class="(vm.selectedBoolean === false) ? \'btn-primary\' : \'btn-light\'" ng-click="vm.setSelectedBoolean(false)"><span class="text-capitalize">{{vm.noButtonText}}</span></button></div><input name="hiddenSelect" id="hiddenSelect" class="hidden" ng-model="vm.selectedBoolean" ng-disabled="vm.isReadOnly"><div ng-messages="vm.myForm.hiddenSelect.$error" class="text-danger"><div ng-message="required">{{vm.requiredMessage}}</div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/idp-pulse-type-list-help.html','<form id="myForm" name="myForm" role="form" idp-form-focus-on-err novalidate class="form-horizontal" style="width:500px;" data-iframe-height ng-dblclick="$event.stopPropagation();"><dl><dt class="font-weight-bold d-block" ng-repeat-start="type in vm.types | orderBy:\'typeOrder\' track by type.typeID">{{type.typeString}}</dt><dd class="pl-5 pb-3" ng-repeat-end>{{type.typeDescription}}</dd></dl><div class="row"><div class="col-12 text-right"><button class="btn m-auto" type="button" ng-click="vm.close()">Close</button></div></div></form>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/idp-text-date-picker.html','<div ng-form="{{::vm.formName}}" ng-show="vm.isEditMode" ng-style="{ \'width\': vm.width || \'10rem\' }"><div class="input-group"><input name="date" type="text" class="form-control pr-0 m-0 {vm.inputCssClass}" uib-datepicker-popup="{{vm.calendarObj.format}}" ng-model="vm.internalDateValue" ng-required="vm.isRequired" ng-disabled="vm.isDisabled" is-open="vm.calendarObj.opened" placeholder="{{::vm.placeholder}}" ng-min="vm.minInputAttrib" ng-max="vm.maxInputAttrib" datepicker-options="vm.calendarObj.options" close-text="Close" alt-input-formats="vm.calendarObj.altInputFormats" uib-tooltip="{{::vm.tooltip}}" tooltip-trigger="\'focus\'" tabindex="{{::vm.firstTabIndex}}"><div ng-show="vm.isEditMode" class="input-group-append ml-0" ng-click="vm.calendarObj.opened = true"><span class="icon icon-calendar input-group-text"></span></div></div><div ng-if="(vm.myForm.date.$error && vm.myForm.date.$dirty) || (vm.myForm.date.$error && vm.myForm.$submitted)" class="text-danger small"><div ng-show="vm.myForm.date.$error.required">{{vm.requiredMessage || \'please enter a date\'}}</div><div ng-show="vm.myForm.date.$error.date && !vm.myForm.date.$error.required">{{vm.invalidMessage || \'please enter a valid date\'}}</div><div ng-show="vm.myForm.date.$error.min && !vm.myForm.date.$error.required">{{vm.minMessage}}</div><div ng-show="vm.myForm.date.$error.max && !vm.myForm.date.$error.required">{{vm.maxMessage}}</div></div><div ng-hide="vm.isEditMode" ng-bind="vm.internalDateValue | date:longDate"></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/export/idp-export-wrapper.html','<div><button ng-show="vm.showButton" type="button" style="width:auto;" class="btn btn-primary btn-block" ng-click="vm.export()">{{vm.buttonText}}</button><div class="exportTemplate" ng-show="vm.showContent" ng-transclude></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/iframe/idp-iframe-popup.html','<div id="{{::vm.popupId}}" class="pulseapp"><div><div class="modal-header"><h4>{{vm.title}}</h4><button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="vm.close()">&#xD7;</button></div><div class="modal-body"><iframe id="{{vm.popupId}}_iframe" ng-src="{{vm.url | trusted}}" width="100%" style="height:400px; border:0px;">Your browser does not support IFrames. Please upgrade your browser or enable IFrames.</iframe></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.close()" ng-dblclick="false">Close</button></div></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/iframe/idp-iframe.html','<div><iframe width="100%" id="{{vm.frameId}}" ng-src="{{vm.frameSrc | trusted}}" scrolling="auto" style="height:400px; border:0px; visibility:hidden;">Your browser does not support IFrames. Please upgrade your browser or enable IFrames.</iframe></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/help-popup/idp-help-popup.html','<div id="{{::vm.popupId}}" data-ng-cloak role="dialog" aria-labelledby="{{::vm.HelpTitleID}}" aria-describedby="{{::vm.HelpContentID}}"><div class="modal-header"><h3 class="modal-title" id="{{::vm.HelpTitleID}}" tabindex="0" idp-tab="1" idp-tabstart="2" ng-bind-html="vm.title"></h3><button type="button" tabindex="-1" class="close" data-dismiss="modal" aria-label="Close" ng-if="vm.isIncludeHeaderCloseButton" ng-click="vm.close()" aria-hidden="true"><span aria-hidden="true">&times;</span> <span class="sr-only">Close</span></button></div><div class="modal-body" id="{{::vm.HelpContentID}}"><div ng-bind-html="vm.helpHtml | unsafe" tabindex="0" idp-tab="2"></div></div><div class="modal-footer"><a href="" class="btn btn-link" tabindex="0" idp-tab="3" data-dismiss="modal" ng-click="vm.close()">Ok, got it!</a></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/popup/idp-popup.html','<div id="{{vm.popupId}}" class="pulseapp"><div class="modal-header"><h3 class="modal-title" ng-bind-html="vm.title"></h3><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-if="vm.isIncludeHeaderCloseButton" ng-click="vm.close()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div ng-bind-html="vm.initDataObj.html | unsafe"></div></div><div class="modal-footer {{vm.footerCss}}"><button class="{{vm.button1.cssClass ? vm.button1.cssClass : \'px-3 btn btn-primary\'}}" style="{{vm.button1.cssStyle}}" ng-click="vm.button1.onClick()" ng-show="vm.button1.isVisible">{{vm.button1.label}}</button> <button class="{{vm.button2.cssClass ? vm.button2.cssClass : \'px-3 btn btn-primary\'}}" style="{{vm.button2.cssStyle}}" ng-click="vm.button2.onClick()" ng-show="vm.button2.isVisible">{{vm.button2.label}}</button> <button class="{{vm.button3.cssClass ? vm.button3.cssClass : \'px-3 btn btn-primary\'}}" style="{{vm.button3.cssStyle}}" ng-click="vm.button3.onClick()" ng-show="vm.button3.isVisible">{{vm.button3.label}}</button> <button class="{{vm.button4.cssClass ? vm.button4.cssClass : \'px-3 btn btn-primary\'}}" style="{{vm.button4.cssStyle}}" ng-click="vm.button4.onClick()" ng-show="vm.button4.isVisible">{{vm.button4.label}}</button></div></div>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/social-media/idp-email-share.html','<a id="ucShareEmail" title="Email" ng-click="vm.share($event)" class="spa-email-share" style="padding-right:0;padding-left:0;"><img ng-src="{{::vm.emailLogoUrl}}" title="Email" alt="Email"></a>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/social-media/idp-facebook-share.html','<a id="ucShareFacebook" class="btn btn-outline-secondary bg-light w-100" ng-click="vm.share($event)" href=""><img ng-src="{{::vm.facebookLogoUrl}}" title="Facebook" alt="Facebook"> Share via Facebook</a>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/social-media/idp-twitter-share.html','<a id="ucShareTwitter" class="btn btn-outline-secondary bg-light w-100" ng-click="vm.share($event)" href=""><img ng-src="{{::vm.twitterLogoUrl}}" title="Twitter" alt="Twitter"> Share via Twitter</a>');
$templateCache.put('https://pulse-res-dev.idtech.com/zigzag_v2/latest/app/directives/spinner/idp-spinner.html','<div id="global_spinner" class="idp-page-modal" ng-class="{\'active\': vm.isActive, \'visible\': vm.isVisible}" ng-style="vm.style"><div id="spinner-message" class="idp-page-modal-message idp-modal-message-subtle" ng-class="{\'idp-modal-message-lg\': vm.isMessageLarge}"><div class="spa-spinner"></div><div class="spa-spinner-text">{{vm.spinnerMessage}}</div></div></div>');}]);